
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6577"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6577"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("cxvHN", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $9211291b9e8b03fc$export$ffb0004e005737fa; }, function (v) { return $9211291b9e8b03fc$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $9211291b9e8b03fc$export$34b9dba7ce09269b; }, function (v) { return $9211291b9e8b03fc$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $9211291b9e8b03fc$export$25062201e9e25d76; }, function (v) { return $9211291b9e8b03fc$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9211291b9e8b03fc$export$ffb0004e005737fa;
var $9211291b9e8b03fc$export$34b9dba7ce09269b;
var $9211291b9e8b03fc$export$25062201e9e25d76;
"use strict";
var $9211291b9e8b03fc$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $9211291b9e8b03fc$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $9211291b9e8b03fc$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $9211291b9e8b03fc$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$9211291b9e8b03fc$export$ffb0004e005737fa = $9211291b9e8b03fc$var$REACT_FRAGMENT_TYPE;
$9211291b9e8b03fc$export$34b9dba7ce09269b = $9211291b9e8b03fc$var$jsxProd;
$9211291b9e8b03fc$export$25062201e9e25d76 = $9211291b9e8b03fc$var$jsxProd;

});

parcelRegister("7XjM8", function(module, exports) {

$parcel$export(module.exports, "Activity", function () { return $5cad620f523f0269$export$9c16c1426311996d; }, function (v) { return $5cad620f523f0269$export$9c16c1426311996d = v; });
$parcel$export(module.exports, "Children", function () { return $5cad620f523f0269$export$dca3b0875bd9a954; }, function (v) { return $5cad620f523f0269$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $5cad620f523f0269$export$16fa2f45be04daa8; }, function (v) { return $5cad620f523f0269$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $5cad620f523f0269$export$ffb0004e005737fa; }, function (v) { return $5cad620f523f0269$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $5cad620f523f0269$export$e2c29f18771995cb; }, function (v) { return $5cad620f523f0269$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $5cad620f523f0269$export$221d75b3f55bb0bd; }, function (v) { return $5cad620f523f0269$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $5cad620f523f0269$export$5f8d39834fd61797; }, function (v) { return $5cad620f523f0269$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $5cad620f523f0269$export$74bf444e3cd11ea5; }, function (v) { return $5cad620f523f0269$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $5cad620f523f0269$export$1ced07cd6b1985ce; }, function (v) { return $5cad620f523f0269$export$1ced07cd6b1985ce = v; });
$parcel$export(module.exports, "__COMPILER_RUNTIME", function () { return $5cad620f523f0269$export$abd8e32b826d7ea7; }, function (v) { return $5cad620f523f0269$export$abd8e32b826d7ea7 = v; });
$parcel$export(module.exports, "cache", function () { return $5cad620f523f0269$export$69a3209f1a06c04d; }, function (v) { return $5cad620f523f0269$export$69a3209f1a06c04d = v; });
$parcel$export(module.exports, "cacheSignal", function () { return $5cad620f523f0269$export$8c538325882c7eec; }, function (v) { return $5cad620f523f0269$export$8c538325882c7eec = v; });
$parcel$export(module.exports, "cloneElement", function () { return $5cad620f523f0269$export$e530037191fcd5d7; }, function (v) { return $5cad620f523f0269$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $5cad620f523f0269$export$fd42f52fd3ae1109; }, function (v) { return $5cad620f523f0269$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $5cad620f523f0269$export$c8a8987d4410bf2d; }, function (v) { return $5cad620f523f0269$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createRef", function () { return $5cad620f523f0269$export$7d1e3a5e95ceca43; }, function (v) { return $5cad620f523f0269$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $5cad620f523f0269$export$257a8862b851cb5b; }, function (v) { return $5cad620f523f0269$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $5cad620f523f0269$export$a8257692ac88316c; }, function (v) { return $5cad620f523f0269$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $5cad620f523f0269$export$488013bae63b21da; }, function (v) { return $5cad620f523f0269$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $5cad620f523f0269$export$7c73462e0d25e514; }, function (v) { return $5cad620f523f0269$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $5cad620f523f0269$export$7568632d0d33d16d; }, function (v) { return $5cad620f523f0269$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_useCacheRefresh", function () { return $5cad620f523f0269$export$f93f40ac0ca7e3a8; }, function (v) { return $5cad620f523f0269$export$f93f40ac0ca7e3a8 = v; });
$parcel$export(module.exports, "use", function () { return $5cad620f523f0269$export$1f96ae73734a86cc; }, function (v) { return $5cad620f523f0269$export$1f96ae73734a86cc = v; });
$parcel$export(module.exports, "useActionState", function () { return $5cad620f523f0269$export$9a47ced3238df325; }, function (v) { return $5cad620f523f0269$export$9a47ced3238df325 = v; });
$parcel$export(module.exports, "useCallback", function () { return $5cad620f523f0269$export$35808ee640e87ca7; }, function (v) { return $5cad620f523f0269$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $5cad620f523f0269$export$fae74005e78b1a27; }, function (v) { return $5cad620f523f0269$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $5cad620f523f0269$export$dc8fbce3eb94dc1e; }, function (v) { return $5cad620f523f0269$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $5cad620f523f0269$export$6a7bc4e911dc01cf; }, function (v) { return $5cad620f523f0269$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $5cad620f523f0269$export$6d9c69b0de29b591; }, function (v) { return $5cad620f523f0269$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useEffectEvent", function () { return $5cad620f523f0269$export$7f54fc3180508a52; }, function (v) { return $5cad620f523f0269$export$7f54fc3180508a52 = v; });
$parcel$export(module.exports, "useId", function () { return $5cad620f523f0269$export$f680877a34711e37; }, function (v) { return $5cad620f523f0269$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $5cad620f523f0269$export$d5a552a76deda3c2; }, function (v) { return $5cad620f523f0269$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $5cad620f523f0269$export$aaabe4eda9ed9969; }, function (v) { return $5cad620f523f0269$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $5cad620f523f0269$export$e5c5a5f917a5871c; }, function (v) { return $5cad620f523f0269$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $5cad620f523f0269$export$1538c33de8887b59; }, function (v) { return $5cad620f523f0269$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useOptimistic", function () { return $5cad620f523f0269$export$fca7f784ae7a249a; }, function (v) { return $5cad620f523f0269$export$fca7f784ae7a249a = v; });
$parcel$export(module.exports, "useReducer", function () { return $5cad620f523f0269$export$13e3392192263954; }, function (v) { return $5cad620f523f0269$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $5cad620f523f0269$export$b8f5890fc79d6aca; }, function (v) { return $5cad620f523f0269$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $5cad620f523f0269$export$60241385465d0a34; }, function (v) { return $5cad620f523f0269$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $5cad620f523f0269$export$306c0aa65ff9ec16; }, function (v) { return $5cad620f523f0269$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $5cad620f523f0269$export$7b286972b8d8ccbf; }, function (v) { return $5cad620f523f0269$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $5cad620f523f0269$export$83d89fbfd8236492; }, function (v) { return $5cad620f523f0269$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5cad620f523f0269$export$9c16c1426311996d;
var $5cad620f523f0269$export$dca3b0875bd9a954;
var $5cad620f523f0269$export$16fa2f45be04daa8;
var $5cad620f523f0269$export$ffb0004e005737fa;
var $5cad620f523f0269$export$e2c29f18771995cb;
var $5cad620f523f0269$export$221d75b3f55bb0bd;
var $5cad620f523f0269$export$5f8d39834fd61797;
var $5cad620f523f0269$export$74bf444e3cd11ea5;
var $5cad620f523f0269$export$1ced07cd6b1985ce;
var $5cad620f523f0269$export$abd8e32b826d7ea7;
var $5cad620f523f0269$export$69a3209f1a06c04d;
var $5cad620f523f0269$export$8c538325882c7eec;
var $5cad620f523f0269$export$e530037191fcd5d7;
var $5cad620f523f0269$export$fd42f52fd3ae1109;
var $5cad620f523f0269$export$c8a8987d4410bf2d;
var $5cad620f523f0269$export$7d1e3a5e95ceca43;
var $5cad620f523f0269$export$257a8862b851cb5b;
var $5cad620f523f0269$export$a8257692ac88316c;
var $5cad620f523f0269$export$488013bae63b21da;
var $5cad620f523f0269$export$7c73462e0d25e514;
var $5cad620f523f0269$export$7568632d0d33d16d;
var $5cad620f523f0269$export$f93f40ac0ca7e3a8;
var $5cad620f523f0269$export$1f96ae73734a86cc;
var $5cad620f523f0269$export$9a47ced3238df325;
var $5cad620f523f0269$export$35808ee640e87ca7;
var $5cad620f523f0269$export$fae74005e78b1a27;
var $5cad620f523f0269$export$dc8fbce3eb94dc1e;
var $5cad620f523f0269$export$6a7bc4e911dc01cf;
var $5cad620f523f0269$export$6d9c69b0de29b591;
var $5cad620f523f0269$export$7f54fc3180508a52;
var $5cad620f523f0269$export$f680877a34711e37;
var $5cad620f523f0269$export$d5a552a76deda3c2;
var $5cad620f523f0269$export$aaabe4eda9ed9969;
var $5cad620f523f0269$export$e5c5a5f917a5871c;
var $5cad620f523f0269$export$1538c33de8887b59;
var $5cad620f523f0269$export$fca7f784ae7a249a;
var $5cad620f523f0269$export$13e3392192263954;
var $5cad620f523f0269$export$b8f5890fc79d6aca;
var $5cad620f523f0269$export$60241385465d0a34;
var $5cad620f523f0269$export$306c0aa65ff9ec16;
var $5cad620f523f0269$export$7b286972b8d8ccbf;
var $5cad620f523f0269$export$83d89fbfd8236492;
"use strict";
var $5cad620f523f0269$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $5cad620f523f0269$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $5cad620f523f0269$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $5cad620f523f0269$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $5cad620f523f0269$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $5cad620f523f0269$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $5cad620f523f0269$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $5cad620f523f0269$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $5cad620f523f0269$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $5cad620f523f0269$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $5cad620f523f0269$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $5cad620f523f0269$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $5cad620f523f0269$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $5cad620f523f0269$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $5cad620f523f0269$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$5cad620f523f0269$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $5cad620f523f0269$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $5cad620f523f0269$var$assign = Object.assign, $5cad620f523f0269$var$emptyObject = {};
function $5cad620f523f0269$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $5cad620f523f0269$var$emptyObject;
    this.updater = updater || $5cad620f523f0269$var$ReactNoopUpdateQueue;
}
$5cad620f523f0269$var$Component.prototype.isReactComponent = {};
$5cad620f523f0269$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$5cad620f523f0269$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $5cad620f523f0269$var$ComponentDummy() {}
$5cad620f523f0269$var$ComponentDummy.prototype = $5cad620f523f0269$var$Component.prototype;
function $5cad620f523f0269$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $5cad620f523f0269$var$emptyObject;
    this.updater = updater || $5cad620f523f0269$var$ReactNoopUpdateQueue;
}
var $5cad620f523f0269$var$pureComponentPrototype = $5cad620f523f0269$var$PureComponent.prototype = new $5cad620f523f0269$var$ComponentDummy();
$5cad620f523f0269$var$pureComponentPrototype.constructor = $5cad620f523f0269$var$PureComponent;
$5cad620f523f0269$var$assign($5cad620f523f0269$var$pureComponentPrototype, $5cad620f523f0269$var$Component.prototype);
$5cad620f523f0269$var$pureComponentPrototype.isPureReactComponent = !0;
var $5cad620f523f0269$var$isArrayImpl = Array.isArray;
function $5cad620f523f0269$var$noop() {}
var $5cad620f523f0269$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $5cad620f523f0269$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $5cad620f523f0269$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $5cad620f523f0269$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $5cad620f523f0269$var$cloneAndReplaceKey(oldElement, newKey) {
    return $5cad620f523f0269$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $5cad620f523f0269$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $5cad620f523f0269$var$REACT_ELEMENT_TYPE;
}
function $5cad620f523f0269$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $5cad620f523f0269$var$userProvidedKeyEscapeRegex = /\/+/g;
function $5cad620f523f0269$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $5cad620f523f0269$var$escape("" + element.key) : index.toString(36);
}
function $5cad620f523f0269$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($5cad620f523f0269$var$noop, $5cad620f523f0269$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $5cad620f523f0269$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $5cad620f523f0269$var$REACT_ELEMENT_TYPE:
                case $5cad620f523f0269$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $5cad620f523f0269$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $5cad620f523f0269$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $5cad620f523f0269$var$getElementKey(children, 0) : nameSoFar, $5cad620f523f0269$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($5cad620f523f0269$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $5cad620f523f0269$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($5cad620f523f0269$var$isValidElement(callback) && (callback = $5cad620f523f0269$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($5cad620f523f0269$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($5cad620f523f0269$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $5cad620f523f0269$var$getElementKey(nameSoFar, i), invokeCallback += $5cad620f523f0269$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $5cad620f523f0269$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $5cad620f523f0269$var$getElementKey(nameSoFar, i++), invokeCallback += $5cad620f523f0269$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $5cad620f523f0269$var$mapIntoArray($5cad620f523f0269$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $5cad620f523f0269$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $5cad620f523f0269$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $5cad620f523f0269$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $5cad620f523f0269$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $5cad620f523f0269$var$Children = {
    map: $5cad620f523f0269$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $5cad620f523f0269$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $5cad620f523f0269$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $5cad620f523f0269$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$5cad620f523f0269$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$5cad620f523f0269$export$9c16c1426311996d = $5cad620f523f0269$var$REACT_ACTIVITY_TYPE;
$5cad620f523f0269$export$dca3b0875bd9a954 = $5cad620f523f0269$var$Children;
$5cad620f523f0269$export$16fa2f45be04daa8 = $5cad620f523f0269$var$Component;
$5cad620f523f0269$export$ffb0004e005737fa = $5cad620f523f0269$var$REACT_FRAGMENT_TYPE;
$5cad620f523f0269$export$e2c29f18771995cb = $5cad620f523f0269$var$REACT_PROFILER_TYPE;
$5cad620f523f0269$export$221d75b3f55bb0bd = $5cad620f523f0269$var$PureComponent;
$5cad620f523f0269$export$5f8d39834fd61797 = $5cad620f523f0269$var$REACT_STRICT_MODE_TYPE;
$5cad620f523f0269$export$74bf444e3cd11ea5 = $5cad620f523f0269$var$REACT_SUSPENSE_TYPE;
$5cad620f523f0269$export$1ced07cd6b1985ce = $5cad620f523f0269$var$ReactSharedInternals;
$5cad620f523f0269$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $5cad620f523f0269$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$5cad620f523f0269$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$5cad620f523f0269$export$8c538325882c7eec = function() {
    return null;
};
$5cad620f523f0269$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $5cad620f523f0269$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$5cad620f523f0269$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $5cad620f523f0269$var$ReactElement(element.type, key, props);
};
$5cad620f523f0269$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $5cad620f523f0269$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $5cad620f523f0269$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$5cad620f523f0269$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$5cad620f523f0269$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $5cad620f523f0269$var$ReactElement(type, key, props);
};
$5cad620f523f0269$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$5cad620f523f0269$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $5cad620f523f0269$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$5cad620f523f0269$export$a8257692ac88316c = $5cad620f523f0269$var$isValidElement;
$5cad620f523f0269$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $5cad620f523f0269$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $5cad620f523f0269$var$lazyInitializer
    };
};
$5cad620f523f0269$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $5cad620f523f0269$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$5cad620f523f0269$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $5cad620f523f0269$var$ReactSharedInternals.T, currentTransition = {};
    $5cad620f523f0269$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $5cad620f523f0269$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($5cad620f523f0269$var$noop, $5cad620f523f0269$var$reportGlobalError);
    } catch (error) {
        $5cad620f523f0269$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $5cad620f523f0269$var$ReactSharedInternals.T = prevTransition;
    }
};
$5cad620f523f0269$export$f93f40ac0ca7e3a8 = function() {
    return $5cad620f523f0269$var$ReactSharedInternals.H.useCacheRefresh();
};
$5cad620f523f0269$export$1f96ae73734a86cc = function(usable) {
    return $5cad620f523f0269$var$ReactSharedInternals.H.use(usable);
};
$5cad620f523f0269$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $5cad620f523f0269$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$5cad620f523f0269$export$35808ee640e87ca7 = function(callback, deps) {
    return $5cad620f523f0269$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$5cad620f523f0269$export$fae74005e78b1a27 = function(Context) {
    return $5cad620f523f0269$var$ReactSharedInternals.H.useContext(Context);
};
$5cad620f523f0269$export$dc8fbce3eb94dc1e = function() {};
$5cad620f523f0269$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $5cad620f523f0269$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$5cad620f523f0269$export$6d9c69b0de29b591 = function(create, deps) {
    return $5cad620f523f0269$var$ReactSharedInternals.H.useEffect(create, deps);
};
$5cad620f523f0269$export$7f54fc3180508a52 = function(callback) {
    return $5cad620f523f0269$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$5cad620f523f0269$export$f680877a34711e37 = function() {
    return $5cad620f523f0269$var$ReactSharedInternals.H.useId();
};
$5cad620f523f0269$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $5cad620f523f0269$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$5cad620f523f0269$export$aaabe4eda9ed9969 = function(create, deps) {
    return $5cad620f523f0269$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$5cad620f523f0269$export$e5c5a5f917a5871c = function(create, deps) {
    return $5cad620f523f0269$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$5cad620f523f0269$export$1538c33de8887b59 = function(create, deps) {
    return $5cad620f523f0269$var$ReactSharedInternals.H.useMemo(create, deps);
};
$5cad620f523f0269$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $5cad620f523f0269$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$5cad620f523f0269$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $5cad620f523f0269$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$5cad620f523f0269$export$b8f5890fc79d6aca = function(initialValue) {
    return $5cad620f523f0269$var$ReactSharedInternals.H.useRef(initialValue);
};
$5cad620f523f0269$export$60241385465d0a34 = function(initialState) {
    return $5cad620f523f0269$var$ReactSharedInternals.H.useState(initialState);
};
$5cad620f523f0269$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $5cad620f523f0269$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$5cad620f523f0269$export$7b286972b8d8ccbf = function() {
    return $5cad620f523f0269$var$ReactSharedInternals.H.useTransition();
};
$5cad620f523f0269$export$83d89fbfd8236492 = "19.2.6";

});

parcelRegister("lyXGN", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $fb2b12fdc6fd9506$export$882461b6382ed46c; }, function (v) { return $fb2b12fdc6fd9506$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $fb2b12fdc6fd9506$export$757ceba2d55c277e; }, function (v) { return $fb2b12fdc6fd9506$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "version", function () { return $fb2b12fdc6fd9506$export$83d89fbfd8236492; }, function (v) { return $fb2b12fdc6fd9506$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $fb2b12fdc6fd9506$export$882461b6382ed46c;
var $fb2b12fdc6fd9506$export$757ceba2d55c277e;
var $fb2b12fdc6fd9506$export$83d89fbfd8236492;
"use strict";

var $8PV0D = parcelRequire("8PV0D");

var $8v0nu = parcelRequire("8v0nu");

var $k2dbP = parcelRequire("k2dbP");
function $fb2b12fdc6fd9506$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $fb2b12fdc6fd9506$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $fb2b12fdc6fd9506$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $fb2b12fdc6fd9506$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $fb2b12fdc6fd9506$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $fb2b12fdc6fd9506$var$assertIsMounted(fiber) {
    if ($fb2b12fdc6fd9506$var$getNearestMountedFiber(fiber) !== fiber) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(188));
}
function $fb2b12fdc6fd9506$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $fb2b12fdc6fd9506$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $fb2b12fdc6fd9506$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $fb2b12fdc6fd9506$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $fb2b12fdc6fd9506$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $fb2b12fdc6fd9506$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $fb2b12fdc6fd9506$var$assign = Object.assign, $fb2b12fdc6fd9506$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $fb2b12fdc6fd9506$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $fb2b12fdc6fd9506$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $fb2b12fdc6fd9506$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $fb2b12fdc6fd9506$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $fb2b12fdc6fd9506$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $fb2b12fdc6fd9506$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $fb2b12fdc6fd9506$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $fb2b12fdc6fd9506$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $fb2b12fdc6fd9506$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $fb2b12fdc6fd9506$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $fb2b12fdc6fd9506$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $fb2b12fdc6fd9506$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $fb2b12fdc6fd9506$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $fb2b12fdc6fd9506$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $fb2b12fdc6fd9506$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $fb2b12fdc6fd9506$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $fb2b12fdc6fd9506$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$fb2b12fdc6fd9506$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $fb2b12fdc6fd9506$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $fb2b12fdc6fd9506$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $fb2b12fdc6fd9506$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $fb2b12fdc6fd9506$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $fb2b12fdc6fd9506$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $fb2b12fdc6fd9506$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $fb2b12fdc6fd9506$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $fb2b12fdc6fd9506$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $fb2b12fdc6fd9506$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $fb2b12fdc6fd9506$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $fb2b12fdc6fd9506$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $fb2b12fdc6fd9506$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $fb2b12fdc6fd9506$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $fb2b12fdc6fd9506$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $fb2b12fdc6fd9506$var$getComponentNameFromType(type.type) || "Memo";
        case $fb2b12fdc6fd9506$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $fb2b12fdc6fd9506$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $fb2b12fdc6fd9506$var$isArrayImpl = Array.isArray, $fb2b12fdc6fd9506$var$ReactSharedInternals = $8v0nu.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $fb2b12fdc6fd9506$var$ReactDOMSharedInternals = $k2dbP.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $fb2b12fdc6fd9506$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $fb2b12fdc6fd9506$var$valueStack = [], $fb2b12fdc6fd9506$var$index = -1;
function $fb2b12fdc6fd9506$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $fb2b12fdc6fd9506$var$pop(cursor) {
    0 > $fb2b12fdc6fd9506$var$index || (cursor.current = $fb2b12fdc6fd9506$var$valueStack[$fb2b12fdc6fd9506$var$index], $fb2b12fdc6fd9506$var$valueStack[$fb2b12fdc6fd9506$var$index] = null, $fb2b12fdc6fd9506$var$index--);
}
function $fb2b12fdc6fd9506$var$push(cursor, value) {
    $fb2b12fdc6fd9506$var$index++;
    $fb2b12fdc6fd9506$var$valueStack[$fb2b12fdc6fd9506$var$index] = cursor.current;
    cursor.current = value;
}
var $fb2b12fdc6fd9506$var$contextStackCursor = $fb2b12fdc6fd9506$var$createCursor(null), $fb2b12fdc6fd9506$var$contextFiberStackCursor = $fb2b12fdc6fd9506$var$createCursor(null), $fb2b12fdc6fd9506$var$rootInstanceStackCursor = $fb2b12fdc6fd9506$var$createCursor(null), $fb2b12fdc6fd9506$var$hostTransitionProviderCursor = $fb2b12fdc6fd9506$var$createCursor(null);
function $fb2b12fdc6fd9506$var$pushHostContainer(fiber, nextRootInstance) {
    $fb2b12fdc6fd9506$var$push($fb2b12fdc6fd9506$var$rootInstanceStackCursor, nextRootInstance);
    $fb2b12fdc6fd9506$var$push($fb2b12fdc6fd9506$var$contextFiberStackCursor, fiber);
    $fb2b12fdc6fd9506$var$push($fb2b12fdc6fd9506$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $fb2b12fdc6fd9506$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $fb2b12fdc6fd9506$var$getOwnHostContext(nextRootInstance), fiber = $fb2b12fdc6fd9506$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $fb2b12fdc6fd9506$var$pop($fb2b12fdc6fd9506$var$contextStackCursor);
    $fb2b12fdc6fd9506$var$push($fb2b12fdc6fd9506$var$contextStackCursor, fiber);
}
function $fb2b12fdc6fd9506$var$popHostContainer() {
    $fb2b12fdc6fd9506$var$pop($fb2b12fdc6fd9506$var$contextStackCursor);
    $fb2b12fdc6fd9506$var$pop($fb2b12fdc6fd9506$var$contextFiberStackCursor);
    $fb2b12fdc6fd9506$var$pop($fb2b12fdc6fd9506$var$rootInstanceStackCursor);
}
function $fb2b12fdc6fd9506$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $fb2b12fdc6fd9506$var$push($fb2b12fdc6fd9506$var$hostTransitionProviderCursor, fiber);
    var context = $fb2b12fdc6fd9506$var$contextStackCursor.current;
    var JSCompiler_inline_result = $fb2b12fdc6fd9506$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($fb2b12fdc6fd9506$var$push($fb2b12fdc6fd9506$var$contextFiberStackCursor, fiber), $fb2b12fdc6fd9506$var$push($fb2b12fdc6fd9506$var$contextStackCursor, JSCompiler_inline_result));
}
function $fb2b12fdc6fd9506$var$popHostContext(fiber) {
    $fb2b12fdc6fd9506$var$contextFiberStackCursor.current === fiber && ($fb2b12fdc6fd9506$var$pop($fb2b12fdc6fd9506$var$contextStackCursor), $fb2b12fdc6fd9506$var$pop($fb2b12fdc6fd9506$var$contextFiberStackCursor));
    $fb2b12fdc6fd9506$var$hostTransitionProviderCursor.current === fiber && ($fb2b12fdc6fd9506$var$pop($fb2b12fdc6fd9506$var$hostTransitionProviderCursor), $fb2b12fdc6fd9506$var$HostTransitionContext._currentValue = $fb2b12fdc6fd9506$var$sharedNotPendingObject);
}
var $fb2b12fdc6fd9506$var$prefix, $fb2b12fdc6fd9506$var$suffix;
function $fb2b12fdc6fd9506$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $fb2b12fdc6fd9506$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $fb2b12fdc6fd9506$var$prefix = match && match[1] || "";
        $fb2b12fdc6fd9506$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $fb2b12fdc6fd9506$var$prefix + name + $fb2b12fdc6fd9506$var$suffix;
}
var $fb2b12fdc6fd9506$var$reentry = !1;
function $fb2b12fdc6fd9506$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $fb2b12fdc6fd9506$var$reentry) return "";
    $fb2b12fdc6fd9506$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $fb2b12fdc6fd9506$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $fb2b12fdc6fd9506$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $fb2b12fdc6fd9506$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $fb2b12fdc6fd9506$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $fb2b12fdc6fd9506$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $fb2b12fdc6fd9506$var$describeBuiltInComponentFrame("Suspense Fallback") : $fb2b12fdc6fd9506$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $fb2b12fdc6fd9506$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $fb2b12fdc6fd9506$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $fb2b12fdc6fd9506$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $fb2b12fdc6fd9506$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $fb2b12fdc6fd9506$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $fb2b12fdc6fd9506$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $fb2b12fdc6fd9506$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $fb2b12fdc6fd9506$var$hasOwnProperty = Object.prototype.hasOwnProperty, $fb2b12fdc6fd9506$var$scheduleCallback$3 = $8PV0D.unstable_scheduleCallback, $fb2b12fdc6fd9506$var$cancelCallback$1 = $8PV0D.unstable_cancelCallback, $fb2b12fdc6fd9506$var$shouldYield = $8PV0D.unstable_shouldYield, $fb2b12fdc6fd9506$var$requestPaint = $8PV0D.unstable_requestPaint, $fb2b12fdc6fd9506$var$now = $8PV0D.unstable_now, $fb2b12fdc6fd9506$var$getCurrentPriorityLevel = $8PV0D.unstable_getCurrentPriorityLevel, $fb2b12fdc6fd9506$var$ImmediatePriority = $8PV0D.unstable_ImmediatePriority, $fb2b12fdc6fd9506$var$UserBlockingPriority = $8PV0D.unstable_UserBlockingPriority, $fb2b12fdc6fd9506$var$NormalPriority$1 = $8PV0D.unstable_NormalPriority, $fb2b12fdc6fd9506$var$LowPriority = $8PV0D.unstable_LowPriority, $fb2b12fdc6fd9506$var$IdlePriority = $8PV0D.unstable_IdlePriority, $fb2b12fdc6fd9506$var$log$1 = $8PV0D.log, $fb2b12fdc6fd9506$var$unstable_setDisableYieldValue = $8PV0D.unstable_setDisableYieldValue, $fb2b12fdc6fd9506$var$rendererID = null, $fb2b12fdc6fd9506$var$injectedHook = null;
function $fb2b12fdc6fd9506$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $fb2b12fdc6fd9506$var$log$1 && $fb2b12fdc6fd9506$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($fb2b12fdc6fd9506$var$injectedHook && "function" === typeof $fb2b12fdc6fd9506$var$injectedHook.setStrictMode) try {
        $fb2b12fdc6fd9506$var$injectedHook.setStrictMode($fb2b12fdc6fd9506$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $fb2b12fdc6fd9506$var$clz32 = Math.clz32 ? Math.clz32 : $fb2b12fdc6fd9506$var$clz32Fallback, $fb2b12fdc6fd9506$var$log = Math.log, $fb2b12fdc6fd9506$var$LN2 = Math.LN2;
function $fb2b12fdc6fd9506$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($fb2b12fdc6fd9506$var$log(x) / $fb2b12fdc6fd9506$var$LN2 | 0) | 0;
}
var $fb2b12fdc6fd9506$var$nextTransitionUpdateLane = 256, $fb2b12fdc6fd9506$var$nextTransitionDeferredLane = 262144, $fb2b12fdc6fd9506$var$nextRetryLane = 4194304;
function $fb2b12fdc6fd9506$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $fb2b12fdc6fd9506$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $fb2b12fdc6fd9506$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $fb2b12fdc6fd9506$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $fb2b12fdc6fd9506$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $fb2b12fdc6fd9506$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $fb2b12fdc6fd9506$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $fb2b12fdc6fd9506$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $fb2b12fdc6fd9506$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $fb2b12fdc6fd9506$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $fb2b12fdc6fd9506$var$claimNextRetryLane() {
    var lane = $fb2b12fdc6fd9506$var$nextRetryLane;
    $fb2b12fdc6fd9506$var$nextRetryLane <<= 1;
    0 === ($fb2b12fdc6fd9506$var$nextRetryLane & 62914560) && ($fb2b12fdc6fd9506$var$nextRetryLane = 4194304);
    return lane;
}
function $fb2b12fdc6fd9506$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $fb2b12fdc6fd9506$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $fb2b12fdc6fd9506$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $fb2b12fdc6fd9506$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $fb2b12fdc6fd9506$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $fb2b12fdc6fd9506$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $fb2b12fdc6fd9506$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $fb2b12fdc6fd9506$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $fb2b12fdc6fd9506$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $fb2b12fdc6fd9506$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $fb2b12fdc6fd9506$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $fb2b12fdc6fd9506$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $fb2b12fdc6fd9506$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $fb2b12fdc6fd9506$var$resolveUpdatePriority() {
    var updatePriority = $fb2b12fdc6fd9506$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $fb2b12fdc6fd9506$var$getEventPriority(updatePriority.type);
}
function $fb2b12fdc6fd9506$var$runWithPriority(priority, fn) {
    var previousPriority = $fb2b12fdc6fd9506$var$ReactDOMSharedInternals.p;
    try {
        return $fb2b12fdc6fd9506$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $fb2b12fdc6fd9506$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $fb2b12fdc6fd9506$var$randomKey = Math.random().toString(36).slice(2), $fb2b12fdc6fd9506$var$internalInstanceKey = "__reactFiber$" + $fb2b12fdc6fd9506$var$randomKey, $fb2b12fdc6fd9506$var$internalPropsKey = "__reactProps$" + $fb2b12fdc6fd9506$var$randomKey, $fb2b12fdc6fd9506$var$internalContainerInstanceKey = "__reactContainer$" + $fb2b12fdc6fd9506$var$randomKey, $fb2b12fdc6fd9506$var$internalEventHandlersKey = "__reactEvents$" + $fb2b12fdc6fd9506$var$randomKey, $fb2b12fdc6fd9506$var$internalEventHandlerListenersKey = "__reactListeners$" + $fb2b12fdc6fd9506$var$randomKey, $fb2b12fdc6fd9506$var$internalEventHandlesSetKey = "__reactHandles$" + $fb2b12fdc6fd9506$var$randomKey, $fb2b12fdc6fd9506$var$internalRootNodeResourcesKey = "__reactResources$" + $fb2b12fdc6fd9506$var$randomKey, $fb2b12fdc6fd9506$var$internalHoistableMarker = "__reactMarker$" + $fb2b12fdc6fd9506$var$randomKey;
function $fb2b12fdc6fd9506$var$detachDeletedInstance(node) {
    delete node[$fb2b12fdc6fd9506$var$internalInstanceKey];
    delete node[$fb2b12fdc6fd9506$var$internalPropsKey];
    delete node[$fb2b12fdc6fd9506$var$internalEventHandlersKey];
    delete node[$fb2b12fdc6fd9506$var$internalEventHandlerListenersKey];
    delete node[$fb2b12fdc6fd9506$var$internalEventHandlesSetKey];
}
function $fb2b12fdc6fd9506$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$fb2b12fdc6fd9506$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$fb2b12fdc6fd9506$var$internalContainerInstanceKey] || parentNode[$fb2b12fdc6fd9506$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $fb2b12fdc6fd9506$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$fb2b12fdc6fd9506$var$internalInstanceKey]) return parentNode;
                targetNode = $fb2b12fdc6fd9506$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $fb2b12fdc6fd9506$var$getInstanceFromNode(node) {
    if (node = node[$fb2b12fdc6fd9506$var$internalInstanceKey] || node[$fb2b12fdc6fd9506$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $fb2b12fdc6fd9506$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(33));
}
function $fb2b12fdc6fd9506$var$getResourcesFromRoot(root) {
    var resources = root[$fb2b12fdc6fd9506$var$internalRootNodeResourcesKey];
    resources || (resources = root[$fb2b12fdc6fd9506$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $fb2b12fdc6fd9506$var$markNodeAsHoistable(node) {
    node[$fb2b12fdc6fd9506$var$internalHoistableMarker] = !0;
}
var $fb2b12fdc6fd9506$var$allNativeEvents = new Set(), $fb2b12fdc6fd9506$var$registrationNameDependencies = {};
function $fb2b12fdc6fd9506$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $fb2b12fdc6fd9506$var$registerDirectEvent(registrationName, dependencies);
    $fb2b12fdc6fd9506$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $fb2b12fdc6fd9506$var$registerDirectEvent(registrationName, dependencies) {
    $fb2b12fdc6fd9506$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$fb2b12fdc6fd9506$var$allNativeEvents.add(dependencies[registrationName]);
}
var $fb2b12fdc6fd9506$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $fb2b12fdc6fd9506$var$illegalAttributeNameCache = {}, $fb2b12fdc6fd9506$var$validatedAttributeNameCache = {};
function $fb2b12fdc6fd9506$var$isAttributeNameSafe(attributeName) {
    if ($fb2b12fdc6fd9506$var$hasOwnProperty.call($fb2b12fdc6fd9506$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($fb2b12fdc6fd9506$var$hasOwnProperty.call($fb2b12fdc6fd9506$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($fb2b12fdc6fd9506$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $fb2b12fdc6fd9506$var$validatedAttributeNameCache[attributeName] = !0;
    $fb2b12fdc6fd9506$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $fb2b12fdc6fd9506$var$setValueForAttribute(node, name, value) {
    if ($fb2b12fdc6fd9506$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $fb2b12fdc6fd9506$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $fb2b12fdc6fd9506$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $fb2b12fdc6fd9506$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $fb2b12fdc6fd9506$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $fb2b12fdc6fd9506$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $fb2b12fdc6fd9506$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $fb2b12fdc6fd9506$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $fb2b12fdc6fd9506$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $fb2b12fdc6fd9506$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $fb2b12fdc6fd9506$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $fb2b12fdc6fd9506$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $fb2b12fdc6fd9506$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $fb2b12fdc6fd9506$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($fb2b12fdc6fd9506$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $fb2b12fdc6fd9506$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $fb2b12fdc6fd9506$var$getToStringValue(value);
        } else element.value !== "" + $fb2b12fdc6fd9506$var$getToStringValue(value) && (element.value = "" + $fb2b12fdc6fd9506$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $fb2b12fdc6fd9506$var$setDefaultValue(element, type, $fb2b12fdc6fd9506$var$getToStringValue(value)) : null != defaultValue ? $fb2b12fdc6fd9506$var$setDefaultValue(element, type, $fb2b12fdc6fd9506$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $fb2b12fdc6fd9506$var$getToStringValue(name) : element.removeAttribute("name");
}
function $fb2b12fdc6fd9506$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $fb2b12fdc6fd9506$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $fb2b12fdc6fd9506$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $fb2b12fdc6fd9506$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $fb2b12fdc6fd9506$var$track(element);
}
function $fb2b12fdc6fd9506$var$setDefaultValue(node, type, value) {
    "number" === type && $fb2b12fdc6fd9506$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $fb2b12fdc6fd9506$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $fb2b12fdc6fd9506$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $fb2b12fdc6fd9506$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $fb2b12fdc6fd9506$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $fb2b12fdc6fd9506$var$getToStringValue(defaultValue) : "";
}
function $fb2b12fdc6fd9506$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(92));
            if ($fb2b12fdc6fd9506$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $fb2b12fdc6fd9506$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $fb2b12fdc6fd9506$var$track(element);
}
function $fb2b12fdc6fd9506$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $fb2b12fdc6fd9506$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $fb2b12fdc6fd9506$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $fb2b12fdc6fd9506$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $fb2b12fdc6fd9506$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $fb2b12fdc6fd9506$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $fb2b12fdc6fd9506$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $fb2b12fdc6fd9506$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $fb2b12fdc6fd9506$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $fb2b12fdc6fd9506$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $fb2b12fdc6fd9506$var$sanitizeURL(url) {
    return $fb2b12fdc6fd9506$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $fb2b12fdc6fd9506$var$noop$1() {}
var $fb2b12fdc6fd9506$var$currentReplayingEvent = null;
function $fb2b12fdc6fd9506$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $fb2b12fdc6fd9506$var$restoreTarget = null, $fb2b12fdc6fd9506$var$restoreQueue = null;
function $fb2b12fdc6fd9506$var$restoreStateOfTarget(target) {
    var internalInstance = $fb2b12fdc6fd9506$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$fb2b12fdc6fd9506$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $fb2b12fdc6fd9506$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $fb2b12fdc6fd9506$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$fb2b12fdc6fd9506$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(90));
                            $fb2b12fdc6fd9506$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $fb2b12fdc6fd9506$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $fb2b12fdc6fd9506$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $fb2b12fdc6fd9506$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $fb2b12fdc6fd9506$var$isInsideEventHandler = !1;
function $fb2b12fdc6fd9506$var$batchedUpdates$1(fn, a, b) {
    if ($fb2b12fdc6fd9506$var$isInsideEventHandler) return fn(a, b);
    $fb2b12fdc6fd9506$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($fb2b12fdc6fd9506$var$isInsideEventHandler = !1, null !== $fb2b12fdc6fd9506$var$restoreTarget || null !== $fb2b12fdc6fd9506$var$restoreQueue) {
            if ($fb2b12fdc6fd9506$var$flushSyncWork$1(), $fb2b12fdc6fd9506$var$restoreTarget && (a = $fb2b12fdc6fd9506$var$restoreTarget, fn = $fb2b12fdc6fd9506$var$restoreQueue, $fb2b12fdc6fd9506$var$restoreQueue = $fb2b12fdc6fd9506$var$restoreTarget = null, $fb2b12fdc6fd9506$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$fb2b12fdc6fd9506$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $fb2b12fdc6fd9506$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$fb2b12fdc6fd9506$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $fb2b12fdc6fd9506$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $fb2b12fdc6fd9506$var$passiveBrowserEventsSupported = !1;
if ($fb2b12fdc6fd9506$var$canUseDOM) try {
    var $fb2b12fdc6fd9506$var$options = {};
    Object.defineProperty($fb2b12fdc6fd9506$var$options, "passive", {
        get: function() {
            $fb2b12fdc6fd9506$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $fb2b12fdc6fd9506$var$options, $fb2b12fdc6fd9506$var$options);
    window.removeEventListener("test", $fb2b12fdc6fd9506$var$options, $fb2b12fdc6fd9506$var$options);
} catch (e) {
    $fb2b12fdc6fd9506$var$passiveBrowserEventsSupported = !1;
}
var $fb2b12fdc6fd9506$var$root = null, $fb2b12fdc6fd9506$var$startText = null, $fb2b12fdc6fd9506$var$fallbackText = null;
function $fb2b12fdc6fd9506$var$getData() {
    if ($fb2b12fdc6fd9506$var$fallbackText) return $fb2b12fdc6fd9506$var$fallbackText;
    var start, startValue = $fb2b12fdc6fd9506$var$startText, startLength = startValue.length, end, endValue = "value" in $fb2b12fdc6fd9506$var$root ? $fb2b12fdc6fd9506$var$root.value : $fb2b12fdc6fd9506$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $fb2b12fdc6fd9506$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $fb2b12fdc6fd9506$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $fb2b12fdc6fd9506$var$functionThatReturnsTrue() {
    return !0;
}
function $fb2b12fdc6fd9506$var$functionThatReturnsFalse() {
    return !1;
}
function $fb2b12fdc6fd9506$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $fb2b12fdc6fd9506$var$functionThatReturnsTrue : $fb2b12fdc6fd9506$var$functionThatReturnsFalse;
        this.isPropagationStopped = $fb2b12fdc6fd9506$var$functionThatReturnsFalse;
        return this;
    }
    $fb2b12fdc6fd9506$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $fb2b12fdc6fd9506$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $fb2b12fdc6fd9506$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $fb2b12fdc6fd9506$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $fb2b12fdc6fd9506$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $fb2b12fdc6fd9506$var$SyntheticEvent = $fb2b12fdc6fd9506$var$createSyntheticEvent($fb2b12fdc6fd9506$var$EventInterface), $fb2b12fdc6fd9506$var$UIEventInterface = $fb2b12fdc6fd9506$var$assign({}, $fb2b12fdc6fd9506$var$EventInterface, {
    view: 0,
    detail: 0
}), $fb2b12fdc6fd9506$var$SyntheticUIEvent = $fb2b12fdc6fd9506$var$createSyntheticEvent($fb2b12fdc6fd9506$var$UIEventInterface), $fb2b12fdc6fd9506$var$lastMovementX, $fb2b12fdc6fd9506$var$lastMovementY, $fb2b12fdc6fd9506$var$lastMouseEvent, $fb2b12fdc6fd9506$var$MouseEventInterface = $fb2b12fdc6fd9506$var$assign({}, $fb2b12fdc6fd9506$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $fb2b12fdc6fd9506$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $fb2b12fdc6fd9506$var$lastMouseEvent && ($fb2b12fdc6fd9506$var$lastMouseEvent && "mousemove" === event.type ? ($fb2b12fdc6fd9506$var$lastMovementX = event.screenX - $fb2b12fdc6fd9506$var$lastMouseEvent.screenX, $fb2b12fdc6fd9506$var$lastMovementY = event.screenY - $fb2b12fdc6fd9506$var$lastMouseEvent.screenY) : $fb2b12fdc6fd9506$var$lastMovementY = $fb2b12fdc6fd9506$var$lastMovementX = 0, $fb2b12fdc6fd9506$var$lastMouseEvent = event);
        return $fb2b12fdc6fd9506$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $fb2b12fdc6fd9506$var$lastMovementY;
    }
}), $fb2b12fdc6fd9506$var$SyntheticMouseEvent = $fb2b12fdc6fd9506$var$createSyntheticEvent($fb2b12fdc6fd9506$var$MouseEventInterface), $fb2b12fdc6fd9506$var$DragEventInterface = $fb2b12fdc6fd9506$var$assign({}, $fb2b12fdc6fd9506$var$MouseEventInterface, {
    dataTransfer: 0
}), $fb2b12fdc6fd9506$var$SyntheticDragEvent = $fb2b12fdc6fd9506$var$createSyntheticEvent($fb2b12fdc6fd9506$var$DragEventInterface), $fb2b12fdc6fd9506$var$FocusEventInterface = $fb2b12fdc6fd9506$var$assign({}, $fb2b12fdc6fd9506$var$UIEventInterface, {
    relatedTarget: 0
}), $fb2b12fdc6fd9506$var$SyntheticFocusEvent = $fb2b12fdc6fd9506$var$createSyntheticEvent($fb2b12fdc6fd9506$var$FocusEventInterface), $fb2b12fdc6fd9506$var$AnimationEventInterface = $fb2b12fdc6fd9506$var$assign({}, $fb2b12fdc6fd9506$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $fb2b12fdc6fd9506$var$SyntheticAnimationEvent = $fb2b12fdc6fd9506$var$createSyntheticEvent($fb2b12fdc6fd9506$var$AnimationEventInterface), $fb2b12fdc6fd9506$var$ClipboardEventInterface = $fb2b12fdc6fd9506$var$assign({}, $fb2b12fdc6fd9506$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $fb2b12fdc6fd9506$var$SyntheticClipboardEvent = $fb2b12fdc6fd9506$var$createSyntheticEvent($fb2b12fdc6fd9506$var$ClipboardEventInterface), $fb2b12fdc6fd9506$var$CompositionEventInterface = $fb2b12fdc6fd9506$var$assign({}, $fb2b12fdc6fd9506$var$EventInterface, {
    data: 0
}), $fb2b12fdc6fd9506$var$SyntheticCompositionEvent = $fb2b12fdc6fd9506$var$createSyntheticEvent($fb2b12fdc6fd9506$var$CompositionEventInterface), $fb2b12fdc6fd9506$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $fb2b12fdc6fd9506$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $fb2b12fdc6fd9506$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $fb2b12fdc6fd9506$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $fb2b12fdc6fd9506$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $fb2b12fdc6fd9506$var$getEventModifierState() {
    return $fb2b12fdc6fd9506$var$modifierStateGetter;
}
var $fb2b12fdc6fd9506$var$KeyboardEventInterface = $fb2b12fdc6fd9506$var$assign({}, $fb2b12fdc6fd9506$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $fb2b12fdc6fd9506$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $fb2b12fdc6fd9506$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $fb2b12fdc6fd9506$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $fb2b12fdc6fd9506$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $fb2b12fdc6fd9506$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $fb2b12fdc6fd9506$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $fb2b12fdc6fd9506$var$SyntheticKeyboardEvent = $fb2b12fdc6fd9506$var$createSyntheticEvent($fb2b12fdc6fd9506$var$KeyboardEventInterface), $fb2b12fdc6fd9506$var$PointerEventInterface = $fb2b12fdc6fd9506$var$assign({}, $fb2b12fdc6fd9506$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $fb2b12fdc6fd9506$var$SyntheticPointerEvent = $fb2b12fdc6fd9506$var$createSyntheticEvent($fb2b12fdc6fd9506$var$PointerEventInterface), $fb2b12fdc6fd9506$var$TouchEventInterface = $fb2b12fdc6fd9506$var$assign({}, $fb2b12fdc6fd9506$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $fb2b12fdc6fd9506$var$getEventModifierState
}), $fb2b12fdc6fd9506$var$SyntheticTouchEvent = $fb2b12fdc6fd9506$var$createSyntheticEvent($fb2b12fdc6fd9506$var$TouchEventInterface), $fb2b12fdc6fd9506$var$TransitionEventInterface = $fb2b12fdc6fd9506$var$assign({}, $fb2b12fdc6fd9506$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $fb2b12fdc6fd9506$var$SyntheticTransitionEvent = $fb2b12fdc6fd9506$var$createSyntheticEvent($fb2b12fdc6fd9506$var$TransitionEventInterface), $fb2b12fdc6fd9506$var$WheelEventInterface = $fb2b12fdc6fd9506$var$assign({}, $fb2b12fdc6fd9506$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $fb2b12fdc6fd9506$var$SyntheticWheelEvent = $fb2b12fdc6fd9506$var$createSyntheticEvent($fb2b12fdc6fd9506$var$WheelEventInterface), $fb2b12fdc6fd9506$var$ToggleEventInterface = $fb2b12fdc6fd9506$var$assign({}, $fb2b12fdc6fd9506$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $fb2b12fdc6fd9506$var$SyntheticToggleEvent = $fb2b12fdc6fd9506$var$createSyntheticEvent($fb2b12fdc6fd9506$var$ToggleEventInterface), $fb2b12fdc6fd9506$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $fb2b12fdc6fd9506$var$canUseCompositionEvent = $fb2b12fdc6fd9506$var$canUseDOM && "CompositionEvent" in window, $fb2b12fdc6fd9506$var$documentMode = null;
$fb2b12fdc6fd9506$var$canUseDOM && "documentMode" in document && ($fb2b12fdc6fd9506$var$documentMode = document.documentMode);
var $fb2b12fdc6fd9506$var$canUseTextInputEvent = $fb2b12fdc6fd9506$var$canUseDOM && "TextEvent" in window && !$fb2b12fdc6fd9506$var$documentMode, $fb2b12fdc6fd9506$var$useFallbackCompositionData = $fb2b12fdc6fd9506$var$canUseDOM && (!$fb2b12fdc6fd9506$var$canUseCompositionEvent || $fb2b12fdc6fd9506$var$documentMode && 8 < $fb2b12fdc6fd9506$var$documentMode && 11 >= $fb2b12fdc6fd9506$var$documentMode), $fb2b12fdc6fd9506$var$SPACEBAR_CHAR = String.fromCharCode(32), $fb2b12fdc6fd9506$var$hasSpaceKeypress = !1;
function $fb2b12fdc6fd9506$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $fb2b12fdc6fd9506$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $fb2b12fdc6fd9506$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $fb2b12fdc6fd9506$var$isComposing = !1;
function $fb2b12fdc6fd9506$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $fb2b12fdc6fd9506$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $fb2b12fdc6fd9506$var$hasSpaceKeypress = !0;
            return $fb2b12fdc6fd9506$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $fb2b12fdc6fd9506$var$SPACEBAR_CHAR && $fb2b12fdc6fd9506$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $fb2b12fdc6fd9506$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($fb2b12fdc6fd9506$var$isComposing) return "compositionend" === domEventName || !$fb2b12fdc6fd9506$var$canUseCompositionEvent && $fb2b12fdc6fd9506$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $fb2b12fdc6fd9506$var$getData(), $fb2b12fdc6fd9506$var$fallbackText = $fb2b12fdc6fd9506$var$startText = $fb2b12fdc6fd9506$var$root = null, $fb2b12fdc6fd9506$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $fb2b12fdc6fd9506$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $fb2b12fdc6fd9506$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $fb2b12fdc6fd9506$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$fb2b12fdc6fd9506$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $fb2b12fdc6fd9506$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $fb2b12fdc6fd9506$var$restoreTarget ? $fb2b12fdc6fd9506$var$restoreQueue ? $fb2b12fdc6fd9506$var$restoreQueue.push(target) : $fb2b12fdc6fd9506$var$restoreQueue = [
        target
    ] : $fb2b12fdc6fd9506$var$restoreTarget = target;
    inst = $fb2b12fdc6fd9506$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $fb2b12fdc6fd9506$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $fb2b12fdc6fd9506$var$activeElement$1 = null, $fb2b12fdc6fd9506$var$activeElementInst$1 = null;
function $fb2b12fdc6fd9506$var$runEventInBatch(dispatchQueue) {
    $fb2b12fdc6fd9506$var$processDispatchQueue(dispatchQueue, 0);
}
function $fb2b12fdc6fd9506$var$getInstIfValueChanged(targetInst) {
    var targetNode = $fb2b12fdc6fd9506$var$getNodeFromInstance(targetInst);
    if ($fb2b12fdc6fd9506$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $fb2b12fdc6fd9506$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $fb2b12fdc6fd9506$var$isInputEventSupported = !1;
if ($fb2b12fdc6fd9506$var$canUseDOM) {
    var $fb2b12fdc6fd9506$var$JSCompiler_inline_result$jscomp$286;
    if ($fb2b12fdc6fd9506$var$canUseDOM) {
        var $fb2b12fdc6fd9506$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$fb2b12fdc6fd9506$var$isSupported$jscomp$inline_427) {
            var $fb2b12fdc6fd9506$var$element$jscomp$inline_428 = document.createElement("div");
            $fb2b12fdc6fd9506$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $fb2b12fdc6fd9506$var$isSupported$jscomp$inline_427 = "function" === typeof $fb2b12fdc6fd9506$var$element$jscomp$inline_428.oninput;
        }
        $fb2b12fdc6fd9506$var$JSCompiler_inline_result$jscomp$286 = $fb2b12fdc6fd9506$var$isSupported$jscomp$inline_427;
    } else $fb2b12fdc6fd9506$var$JSCompiler_inline_result$jscomp$286 = !1;
    $fb2b12fdc6fd9506$var$isInputEventSupported = $fb2b12fdc6fd9506$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $fb2b12fdc6fd9506$var$stopWatchingForValueChange() {
    $fb2b12fdc6fd9506$var$activeElement$1 && ($fb2b12fdc6fd9506$var$activeElement$1.detachEvent("onpropertychange", $fb2b12fdc6fd9506$var$handlePropertyChange), $fb2b12fdc6fd9506$var$activeElementInst$1 = $fb2b12fdc6fd9506$var$activeElement$1 = null);
}
function $fb2b12fdc6fd9506$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $fb2b12fdc6fd9506$var$getInstIfValueChanged($fb2b12fdc6fd9506$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $fb2b12fdc6fd9506$var$createAndAccumulateChangeEvent(dispatchQueue, $fb2b12fdc6fd9506$var$activeElementInst$1, nativeEvent, $fb2b12fdc6fd9506$var$getEventTarget(nativeEvent));
        $fb2b12fdc6fd9506$var$batchedUpdates$1($fb2b12fdc6fd9506$var$runEventInBatch, dispatchQueue);
    }
}
function $fb2b12fdc6fd9506$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($fb2b12fdc6fd9506$var$stopWatchingForValueChange(), $fb2b12fdc6fd9506$var$activeElement$1 = target, $fb2b12fdc6fd9506$var$activeElementInst$1 = targetInst, $fb2b12fdc6fd9506$var$activeElement$1.attachEvent("onpropertychange", $fb2b12fdc6fd9506$var$handlePropertyChange)) : "focusout" === domEventName && $fb2b12fdc6fd9506$var$stopWatchingForValueChange();
}
function $fb2b12fdc6fd9506$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $fb2b12fdc6fd9506$var$getInstIfValueChanged($fb2b12fdc6fd9506$var$activeElementInst$1);
}
function $fb2b12fdc6fd9506$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $fb2b12fdc6fd9506$var$getInstIfValueChanged(targetInst);
}
function $fb2b12fdc6fd9506$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $fb2b12fdc6fd9506$var$getInstIfValueChanged(targetInst);
}
function $fb2b12fdc6fd9506$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $fb2b12fdc6fd9506$var$objectIs = "function" === typeof Object.is ? Object.is : $fb2b12fdc6fd9506$var$is;
function $fb2b12fdc6fd9506$var$shallowEqual(objA, objB) {
    if ($fb2b12fdc6fd9506$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$fb2b12fdc6fd9506$var$hasOwnProperty.call(objB, currentKey) || !$fb2b12fdc6fd9506$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $fb2b12fdc6fd9506$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $fb2b12fdc6fd9506$var$getNodeForCharacterOffset(root, offset) {
    var node = $fb2b12fdc6fd9506$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $fb2b12fdc6fd9506$var$getLeafNode(node);
    }
}
function $fb2b12fdc6fd9506$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $fb2b12fdc6fd9506$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $fb2b12fdc6fd9506$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $fb2b12fdc6fd9506$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $fb2b12fdc6fd9506$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $fb2b12fdc6fd9506$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $fb2b12fdc6fd9506$var$skipSelectionChangeEvent = $fb2b12fdc6fd9506$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $fb2b12fdc6fd9506$var$activeElement = null, $fb2b12fdc6fd9506$var$activeElementInst = null, $fb2b12fdc6fd9506$var$lastSelection = null, $fb2b12fdc6fd9506$var$mouseDown = !1;
function $fb2b12fdc6fd9506$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $fb2b12fdc6fd9506$var$mouseDown || null == $fb2b12fdc6fd9506$var$activeElement || $fb2b12fdc6fd9506$var$activeElement !== $fb2b12fdc6fd9506$var$getActiveElement(doc) || (doc = $fb2b12fdc6fd9506$var$activeElement, "selectionStart" in doc && $fb2b12fdc6fd9506$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $fb2b12fdc6fd9506$var$lastSelection && $fb2b12fdc6fd9506$var$shallowEqual($fb2b12fdc6fd9506$var$lastSelection, doc) || ($fb2b12fdc6fd9506$var$lastSelection = doc, doc = $fb2b12fdc6fd9506$var$accumulateTwoPhaseListeners($fb2b12fdc6fd9506$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $fb2b12fdc6fd9506$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $fb2b12fdc6fd9506$var$activeElement)));
}
function $fb2b12fdc6fd9506$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $fb2b12fdc6fd9506$var$vendorPrefixes = {
    animationend: $fb2b12fdc6fd9506$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $fb2b12fdc6fd9506$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $fb2b12fdc6fd9506$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $fb2b12fdc6fd9506$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $fb2b12fdc6fd9506$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $fb2b12fdc6fd9506$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $fb2b12fdc6fd9506$var$makePrefixMap("Transition", "TransitionEnd")
}, $fb2b12fdc6fd9506$var$prefixedEventNames = {}, $fb2b12fdc6fd9506$var$style = {};
$fb2b12fdc6fd9506$var$canUseDOM && ($fb2b12fdc6fd9506$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $fb2b12fdc6fd9506$var$vendorPrefixes.animationend.animation, delete $fb2b12fdc6fd9506$var$vendorPrefixes.animationiteration.animation, delete $fb2b12fdc6fd9506$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $fb2b12fdc6fd9506$var$vendorPrefixes.transitionend.transition);
function $fb2b12fdc6fd9506$var$getVendorPrefixedEventName(eventName) {
    if ($fb2b12fdc6fd9506$var$prefixedEventNames[eventName]) return $fb2b12fdc6fd9506$var$prefixedEventNames[eventName];
    if (!$fb2b12fdc6fd9506$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $fb2b12fdc6fd9506$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $fb2b12fdc6fd9506$var$style) return $fb2b12fdc6fd9506$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $fb2b12fdc6fd9506$var$ANIMATION_END = $fb2b12fdc6fd9506$var$getVendorPrefixedEventName("animationend"), $fb2b12fdc6fd9506$var$ANIMATION_ITERATION = $fb2b12fdc6fd9506$var$getVendorPrefixedEventName("animationiteration"), $fb2b12fdc6fd9506$var$ANIMATION_START = $fb2b12fdc6fd9506$var$getVendorPrefixedEventName("animationstart"), $fb2b12fdc6fd9506$var$TRANSITION_RUN = $fb2b12fdc6fd9506$var$getVendorPrefixedEventName("transitionrun"), $fb2b12fdc6fd9506$var$TRANSITION_START = $fb2b12fdc6fd9506$var$getVendorPrefixedEventName("transitionstart"), $fb2b12fdc6fd9506$var$TRANSITION_CANCEL = $fb2b12fdc6fd9506$var$getVendorPrefixedEventName("transitioncancel"), $fb2b12fdc6fd9506$var$TRANSITION_END = $fb2b12fdc6fd9506$var$getVendorPrefixedEventName("transitionend"), $fb2b12fdc6fd9506$var$topLevelEventsToReactNames = new Map(), $fb2b12fdc6fd9506$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$fb2b12fdc6fd9506$var$simpleEventPluginEvents.push("scrollEnd");
function $fb2b12fdc6fd9506$var$registerSimpleEvent(domEventName, reactName) {
    $fb2b12fdc6fd9506$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $fb2b12fdc6fd9506$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $fb2b12fdc6fd9506$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $fb2b12fdc6fd9506$var$concurrentQueues = [], $fb2b12fdc6fd9506$var$concurrentQueuesIndex = 0, $fb2b12fdc6fd9506$var$concurrentlyUpdatedLanes = 0;
function $fb2b12fdc6fd9506$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $fb2b12fdc6fd9506$var$concurrentQueuesIndex, i = $fb2b12fdc6fd9506$var$concurrentlyUpdatedLanes = $fb2b12fdc6fd9506$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $fb2b12fdc6fd9506$var$concurrentQueues[i];
        $fb2b12fdc6fd9506$var$concurrentQueues[i++] = null;
        var queue = $fb2b12fdc6fd9506$var$concurrentQueues[i];
        $fb2b12fdc6fd9506$var$concurrentQueues[i++] = null;
        var update = $fb2b12fdc6fd9506$var$concurrentQueues[i];
        $fb2b12fdc6fd9506$var$concurrentQueues[i++] = null;
        var lane = $fb2b12fdc6fd9506$var$concurrentQueues[i];
        $fb2b12fdc6fd9506$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $fb2b12fdc6fd9506$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $fb2b12fdc6fd9506$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $fb2b12fdc6fd9506$var$concurrentQueues[$fb2b12fdc6fd9506$var$concurrentQueuesIndex++] = fiber;
    $fb2b12fdc6fd9506$var$concurrentQueues[$fb2b12fdc6fd9506$var$concurrentQueuesIndex++] = queue;
    $fb2b12fdc6fd9506$var$concurrentQueues[$fb2b12fdc6fd9506$var$concurrentQueuesIndex++] = update;
    $fb2b12fdc6fd9506$var$concurrentQueues[$fb2b12fdc6fd9506$var$concurrentQueuesIndex++] = lane;
    $fb2b12fdc6fd9506$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $fb2b12fdc6fd9506$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $fb2b12fdc6fd9506$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $fb2b12fdc6fd9506$var$getRootForUpdatedFiber(fiber);
}
function $fb2b12fdc6fd9506$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $fb2b12fdc6fd9506$var$enqueueUpdate$1(fiber, null, null, lane);
    return $fb2b12fdc6fd9506$var$getRootForUpdatedFiber(fiber);
}
function $fb2b12fdc6fd9506$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $fb2b12fdc6fd9506$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $fb2b12fdc6fd9506$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $fb2b12fdc6fd9506$var$nestedUpdateCount) throw $fb2b12fdc6fd9506$var$nestedUpdateCount = 0, $fb2b12fdc6fd9506$var$rootWithNestedUpdates = null, Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $fb2b12fdc6fd9506$var$emptyContextObject = {};
function $fb2b12fdc6fd9506$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $fb2b12fdc6fd9506$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $fb2b12fdc6fd9506$var$FiberNode(tag, pendingProps, key, mode);
}
function $fb2b12fdc6fd9506$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $fb2b12fdc6fd9506$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $fb2b12fdc6fd9506$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $fb2b12fdc6fd9506$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $fb2b12fdc6fd9506$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $fb2b12fdc6fd9506$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $fb2b12fdc6fd9506$var$isHostHoistableType(type, pendingProps, $fb2b12fdc6fd9506$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $fb2b12fdc6fd9506$var$REACT_ACTIVITY_TYPE:
            return type = $fb2b12fdc6fd9506$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $fb2b12fdc6fd9506$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $fb2b12fdc6fd9506$var$REACT_FRAGMENT_TYPE:
            return $fb2b12fdc6fd9506$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $fb2b12fdc6fd9506$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $fb2b12fdc6fd9506$var$REACT_PROFILER_TYPE:
            return type = $fb2b12fdc6fd9506$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $fb2b12fdc6fd9506$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $fb2b12fdc6fd9506$var$REACT_SUSPENSE_TYPE:
            return type = $fb2b12fdc6fd9506$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $fb2b12fdc6fd9506$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $fb2b12fdc6fd9506$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $fb2b12fdc6fd9506$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $fb2b12fdc6fd9506$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $fb2b12fdc6fd9506$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $fb2b12fdc6fd9506$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $fb2b12fdc6fd9506$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $fb2b12fdc6fd9506$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $fb2b12fdc6fd9506$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $fb2b12fdc6fd9506$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $fb2b12fdc6fd9506$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $fb2b12fdc6fd9506$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $fb2b12fdc6fd9506$var$createFiberFromText(content, mode, lanes) {
    content = $fb2b12fdc6fd9506$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $fb2b12fdc6fd9506$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $fb2b12fdc6fd9506$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $fb2b12fdc6fd9506$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $fb2b12fdc6fd9506$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $fb2b12fdc6fd9506$var$CapturedStacks = new WeakMap();
function $fb2b12fdc6fd9506$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $fb2b12fdc6fd9506$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $fb2b12fdc6fd9506$var$getStackByFiberInDevAndProd(source)
        };
        $fb2b12fdc6fd9506$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $fb2b12fdc6fd9506$var$getStackByFiberInDevAndProd(source)
    };
}
var $fb2b12fdc6fd9506$var$forkStack = [], $fb2b12fdc6fd9506$var$forkStackIndex = 0, $fb2b12fdc6fd9506$var$treeForkProvider = null, $fb2b12fdc6fd9506$var$treeForkCount = 0, $fb2b12fdc6fd9506$var$idStack = [], $fb2b12fdc6fd9506$var$idStackIndex = 0, $fb2b12fdc6fd9506$var$treeContextProvider = null, $fb2b12fdc6fd9506$var$treeContextId = 1, $fb2b12fdc6fd9506$var$treeContextOverflow = "";
function $fb2b12fdc6fd9506$var$pushTreeFork(workInProgress, totalChildren) {
    $fb2b12fdc6fd9506$var$forkStack[$fb2b12fdc6fd9506$var$forkStackIndex++] = $fb2b12fdc6fd9506$var$treeForkCount;
    $fb2b12fdc6fd9506$var$forkStack[$fb2b12fdc6fd9506$var$forkStackIndex++] = $fb2b12fdc6fd9506$var$treeForkProvider;
    $fb2b12fdc6fd9506$var$treeForkProvider = workInProgress;
    $fb2b12fdc6fd9506$var$treeForkCount = totalChildren;
}
function $fb2b12fdc6fd9506$var$pushTreeId(workInProgress, totalChildren, index) {
    $fb2b12fdc6fd9506$var$idStack[$fb2b12fdc6fd9506$var$idStackIndex++] = $fb2b12fdc6fd9506$var$treeContextId;
    $fb2b12fdc6fd9506$var$idStack[$fb2b12fdc6fd9506$var$idStackIndex++] = $fb2b12fdc6fd9506$var$treeContextOverflow;
    $fb2b12fdc6fd9506$var$idStack[$fb2b12fdc6fd9506$var$idStackIndex++] = $fb2b12fdc6fd9506$var$treeContextProvider;
    $fb2b12fdc6fd9506$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $fb2b12fdc6fd9506$var$treeContextId;
    workInProgress = $fb2b12fdc6fd9506$var$treeContextOverflow;
    var baseLength = 32 - $fb2b12fdc6fd9506$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $fb2b12fdc6fd9506$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $fb2b12fdc6fd9506$var$treeContextId = 1 << 32 - $fb2b12fdc6fd9506$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $fb2b12fdc6fd9506$var$treeContextOverflow = length + workInProgress;
    } else $fb2b12fdc6fd9506$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $fb2b12fdc6fd9506$var$treeContextOverflow = workInProgress;
}
function $fb2b12fdc6fd9506$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($fb2b12fdc6fd9506$var$pushTreeFork(workInProgress, 1), $fb2b12fdc6fd9506$var$pushTreeId(workInProgress, 1, 0));
}
function $fb2b12fdc6fd9506$var$popTreeContext(workInProgress) {
    for(; workInProgress === $fb2b12fdc6fd9506$var$treeForkProvider;)$fb2b12fdc6fd9506$var$treeForkProvider = $fb2b12fdc6fd9506$var$forkStack[--$fb2b12fdc6fd9506$var$forkStackIndex], $fb2b12fdc6fd9506$var$forkStack[$fb2b12fdc6fd9506$var$forkStackIndex] = null, $fb2b12fdc6fd9506$var$treeForkCount = $fb2b12fdc6fd9506$var$forkStack[--$fb2b12fdc6fd9506$var$forkStackIndex], $fb2b12fdc6fd9506$var$forkStack[$fb2b12fdc6fd9506$var$forkStackIndex] = null;
    for(; workInProgress === $fb2b12fdc6fd9506$var$treeContextProvider;)$fb2b12fdc6fd9506$var$treeContextProvider = $fb2b12fdc6fd9506$var$idStack[--$fb2b12fdc6fd9506$var$idStackIndex], $fb2b12fdc6fd9506$var$idStack[$fb2b12fdc6fd9506$var$idStackIndex] = null, $fb2b12fdc6fd9506$var$treeContextOverflow = $fb2b12fdc6fd9506$var$idStack[--$fb2b12fdc6fd9506$var$idStackIndex], $fb2b12fdc6fd9506$var$idStack[$fb2b12fdc6fd9506$var$idStackIndex] = null, $fb2b12fdc6fd9506$var$treeContextId = $fb2b12fdc6fd9506$var$idStack[--$fb2b12fdc6fd9506$var$idStackIndex], $fb2b12fdc6fd9506$var$idStack[$fb2b12fdc6fd9506$var$idStackIndex] = null;
}
function $fb2b12fdc6fd9506$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $fb2b12fdc6fd9506$var$idStack[$fb2b12fdc6fd9506$var$idStackIndex++] = $fb2b12fdc6fd9506$var$treeContextId;
    $fb2b12fdc6fd9506$var$idStack[$fb2b12fdc6fd9506$var$idStackIndex++] = $fb2b12fdc6fd9506$var$treeContextOverflow;
    $fb2b12fdc6fd9506$var$idStack[$fb2b12fdc6fd9506$var$idStackIndex++] = $fb2b12fdc6fd9506$var$treeContextProvider;
    $fb2b12fdc6fd9506$var$treeContextId = suspendedContext.id;
    $fb2b12fdc6fd9506$var$treeContextOverflow = suspendedContext.overflow;
    $fb2b12fdc6fd9506$var$treeContextProvider = workInProgress;
}
var $fb2b12fdc6fd9506$var$hydrationParentFiber = null, $fb2b12fdc6fd9506$var$nextHydratableInstance = null, $fb2b12fdc6fd9506$var$isHydrating = !1, $fb2b12fdc6fd9506$var$hydrationErrors = null, $fb2b12fdc6fd9506$var$rootOrSingletonContext = !1, $fb2b12fdc6fd9506$var$HydrationMismatchException = Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(519));
function $fb2b12fdc6fd9506$var$throwOnHydrationMismatch(fiber) {
    var error = Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $fb2b12fdc6fd9506$var$queueHydrationError($fb2b12fdc6fd9506$var$createCapturedValueAtFiber(error, fiber));
    throw $fb2b12fdc6fd9506$var$HydrationMismatchException;
}
function $fb2b12fdc6fd9506$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$fb2b12fdc6fd9506$var$internalInstanceKey] = fiber;
    instance[$fb2b12fdc6fd9506$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $fb2b12fdc6fd9506$var$listenToNonDelegatedEvent("cancel", instance);
            $fb2b12fdc6fd9506$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $fb2b12fdc6fd9506$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $fb2b12fdc6fd9506$var$mediaEventTypes.length; type++)$fb2b12fdc6fd9506$var$listenToNonDelegatedEvent($fb2b12fdc6fd9506$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $fb2b12fdc6fd9506$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $fb2b12fdc6fd9506$var$listenToNonDelegatedEvent("error", instance);
            $fb2b12fdc6fd9506$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $fb2b12fdc6fd9506$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $fb2b12fdc6fd9506$var$listenToNonDelegatedEvent("invalid", instance);
            $fb2b12fdc6fd9506$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $fb2b12fdc6fd9506$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $fb2b12fdc6fd9506$var$listenToNonDelegatedEvent("invalid", instance), $fb2b12fdc6fd9506$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $fb2b12fdc6fd9506$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($fb2b12fdc6fd9506$var$listenToNonDelegatedEvent("beforetoggle", instance), $fb2b12fdc6fd9506$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $fb2b12fdc6fd9506$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $fb2b12fdc6fd9506$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $fb2b12fdc6fd9506$var$noop$1), instance = !0) : instance = !1;
    instance || $fb2b12fdc6fd9506$var$throwOnHydrationMismatch(fiber, !0);
}
function $fb2b12fdc6fd9506$var$popToNextHostParent(fiber) {
    for($fb2b12fdc6fd9506$var$hydrationParentFiber = fiber.return; $fb2b12fdc6fd9506$var$hydrationParentFiber;)switch($fb2b12fdc6fd9506$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $fb2b12fdc6fd9506$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $fb2b12fdc6fd9506$var$rootOrSingletonContext = !0;
            return;
        default:
            $fb2b12fdc6fd9506$var$hydrationParentFiber = $fb2b12fdc6fd9506$var$hydrationParentFiber.return;
    }
}
function $fb2b12fdc6fd9506$var$popHydrationState(fiber) {
    if (fiber !== $fb2b12fdc6fd9506$var$hydrationParentFiber) return !1;
    if (!$fb2b12fdc6fd9506$var$isHydrating) return $fb2b12fdc6fd9506$var$popToNextHostParent(fiber), $fb2b12fdc6fd9506$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $fb2b12fdc6fd9506$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $fb2b12fdc6fd9506$var$nextHydratableInstance && $fb2b12fdc6fd9506$var$throwOnHydrationMismatch(fiber);
    $fb2b12fdc6fd9506$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(317));
        $fb2b12fdc6fd9506$var$nextHydratableInstance = $fb2b12fdc6fd9506$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(317));
        $fb2b12fdc6fd9506$var$nextHydratableInstance = $fb2b12fdc6fd9506$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $fb2b12fdc6fd9506$var$nextHydratableInstance, $fb2b12fdc6fd9506$var$isSingletonScope(fiber.type) ? (fiber = $fb2b12fdc6fd9506$var$previousHydratableOnEnteringScopedSingleton, $fb2b12fdc6fd9506$var$previousHydratableOnEnteringScopedSingleton = null, $fb2b12fdc6fd9506$var$nextHydratableInstance = fiber) : $fb2b12fdc6fd9506$var$nextHydratableInstance = tag) : $fb2b12fdc6fd9506$var$nextHydratableInstance = $fb2b12fdc6fd9506$var$hydrationParentFiber ? $fb2b12fdc6fd9506$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $fb2b12fdc6fd9506$var$resetHydrationState() {
    $fb2b12fdc6fd9506$var$nextHydratableInstance = $fb2b12fdc6fd9506$var$hydrationParentFiber = null;
    $fb2b12fdc6fd9506$var$isHydrating = !1;
}
function $fb2b12fdc6fd9506$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $fb2b12fdc6fd9506$var$hydrationErrors;
    null !== queuedErrors && (null === $fb2b12fdc6fd9506$var$workInProgressRootRecoverableErrors ? $fb2b12fdc6fd9506$var$workInProgressRootRecoverableErrors = queuedErrors : $fb2b12fdc6fd9506$var$workInProgressRootRecoverableErrors.push.apply($fb2b12fdc6fd9506$var$workInProgressRootRecoverableErrors, queuedErrors), $fb2b12fdc6fd9506$var$hydrationErrors = null);
    return queuedErrors;
}
function $fb2b12fdc6fd9506$var$queueHydrationError(error) {
    null === $fb2b12fdc6fd9506$var$hydrationErrors ? $fb2b12fdc6fd9506$var$hydrationErrors = [
        error
    ] : $fb2b12fdc6fd9506$var$hydrationErrors.push(error);
}
var $fb2b12fdc6fd9506$var$valueCursor = $fb2b12fdc6fd9506$var$createCursor(null), $fb2b12fdc6fd9506$var$currentlyRenderingFiber$1 = null, $fb2b12fdc6fd9506$var$lastContextDependency = null;
function $fb2b12fdc6fd9506$var$pushProvider(providerFiber, context, nextValue) {
    $fb2b12fdc6fd9506$var$push($fb2b12fdc6fd9506$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $fb2b12fdc6fd9506$var$popProvider(context) {
    context._currentValue = $fb2b12fdc6fd9506$var$valueCursor.current;
    $fb2b12fdc6fd9506$var$pop($fb2b12fdc6fd9506$var$valueCursor);
}
function $fb2b12fdc6fd9506$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $fb2b12fdc6fd9506$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $fb2b12fdc6fd9506$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $fb2b12fdc6fd9506$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $fb2b12fdc6fd9506$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $fb2b12fdc6fd9506$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $fb2b12fdc6fd9506$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($fb2b12fdc6fd9506$var$HostTransitionContext) : current = [
                $fb2b12fdc6fd9506$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $fb2b12fdc6fd9506$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $fb2b12fdc6fd9506$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$fb2b12fdc6fd9506$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $fb2b12fdc6fd9506$var$prepareToReadContext(workInProgress) {
    $fb2b12fdc6fd9506$var$currentlyRenderingFiber$1 = workInProgress;
    $fb2b12fdc6fd9506$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $fb2b12fdc6fd9506$var$readContext(context) {
    return $fb2b12fdc6fd9506$var$readContextForConsumer($fb2b12fdc6fd9506$var$currentlyRenderingFiber$1, context);
}
function $fb2b12fdc6fd9506$var$readContextDuringReconciliation(consumer, context) {
    null === $fb2b12fdc6fd9506$var$currentlyRenderingFiber$1 && $fb2b12fdc6fd9506$var$prepareToReadContext(consumer);
    return $fb2b12fdc6fd9506$var$readContextForConsumer(consumer, context);
}
function $fb2b12fdc6fd9506$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $fb2b12fdc6fd9506$var$lastContextDependency) {
        if (null === consumer) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(308));
        $fb2b12fdc6fd9506$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $fb2b12fdc6fd9506$var$lastContextDependency = $fb2b12fdc6fd9506$var$lastContextDependency.next = context;
    return value;
}
var $fb2b12fdc6fd9506$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $fb2b12fdc6fd9506$var$scheduleCallback$2 = $8PV0D.unstable_scheduleCallback, $fb2b12fdc6fd9506$var$NormalPriority = $8PV0D.unstable_NormalPriority, $fb2b12fdc6fd9506$var$CacheContext = {
    $$typeof: $fb2b12fdc6fd9506$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $fb2b12fdc6fd9506$var$createCache() {
    return {
        controller: new $fb2b12fdc6fd9506$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $fb2b12fdc6fd9506$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $fb2b12fdc6fd9506$var$scheduleCallback$2($fb2b12fdc6fd9506$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $fb2b12fdc6fd9506$var$currentEntangledListeners = null, $fb2b12fdc6fd9506$var$currentEntangledPendingCount = 0, $fb2b12fdc6fd9506$var$currentEntangledLane = 0, $fb2b12fdc6fd9506$var$currentEntangledActionThenable = null;
function $fb2b12fdc6fd9506$var$entangleAsyncAction(transition, thenable) {
    if (null === $fb2b12fdc6fd9506$var$currentEntangledListeners) {
        var entangledListeners = $fb2b12fdc6fd9506$var$currentEntangledListeners = [];
        $fb2b12fdc6fd9506$var$currentEntangledPendingCount = 0;
        $fb2b12fdc6fd9506$var$currentEntangledLane = $fb2b12fdc6fd9506$var$requestTransitionLane();
        $fb2b12fdc6fd9506$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $fb2b12fdc6fd9506$var$currentEntangledPendingCount++;
    thenable.then($fb2b12fdc6fd9506$var$pingEngtangledActionScope, $fb2b12fdc6fd9506$var$pingEngtangledActionScope);
    return thenable;
}
function $fb2b12fdc6fd9506$var$pingEngtangledActionScope() {
    if (0 === --$fb2b12fdc6fd9506$var$currentEntangledPendingCount && null !== $fb2b12fdc6fd9506$var$currentEntangledListeners) {
        null !== $fb2b12fdc6fd9506$var$currentEntangledActionThenable && ($fb2b12fdc6fd9506$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $fb2b12fdc6fd9506$var$currentEntangledListeners;
        $fb2b12fdc6fd9506$var$currentEntangledListeners = null;
        $fb2b12fdc6fd9506$var$currentEntangledLane = 0;
        $fb2b12fdc6fd9506$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $fb2b12fdc6fd9506$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $fb2b12fdc6fd9506$var$prevOnStartTransitionFinish = $fb2b12fdc6fd9506$var$ReactSharedInternals.S;
$fb2b12fdc6fd9506$var$ReactSharedInternals.S = function(transition, returnValue) {
    $fb2b12fdc6fd9506$var$globalMostRecentTransitionTime = $fb2b12fdc6fd9506$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $fb2b12fdc6fd9506$var$entangleAsyncAction(transition, returnValue);
    null !== $fb2b12fdc6fd9506$var$prevOnStartTransitionFinish && $fb2b12fdc6fd9506$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $fb2b12fdc6fd9506$var$resumedCache = $fb2b12fdc6fd9506$var$createCursor(null);
function $fb2b12fdc6fd9506$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $fb2b12fdc6fd9506$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $fb2b12fdc6fd9506$var$workInProgressRoot.pooledCache;
}
function $fb2b12fdc6fd9506$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $fb2b12fdc6fd9506$var$push($fb2b12fdc6fd9506$var$resumedCache, $fb2b12fdc6fd9506$var$resumedCache.current) : $fb2b12fdc6fd9506$var$push($fb2b12fdc6fd9506$var$resumedCache, prevCachePool.pool);
}
function $fb2b12fdc6fd9506$var$getSuspendedCache() {
    var cacheFromPool = $fb2b12fdc6fd9506$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $fb2b12fdc6fd9506$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $fb2b12fdc6fd9506$var$SuspenseException = Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(460)), $fb2b12fdc6fd9506$var$SuspenseyCommitException = Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(474)), $fb2b12fdc6fd9506$var$SuspenseActionException = Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(542)), $fb2b12fdc6fd9506$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $fb2b12fdc6fd9506$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $fb2b12fdc6fd9506$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($fb2b12fdc6fd9506$var$noop$1, $fb2b12fdc6fd9506$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $fb2b12fdc6fd9506$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($fb2b12fdc6fd9506$var$noop$1, $fb2b12fdc6fd9506$var$noop$1);
            else {
                thenableState = $fb2b12fdc6fd9506$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $fb2b12fdc6fd9506$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $fb2b12fdc6fd9506$var$suspendedThenable = thenable;
            throw $fb2b12fdc6fd9506$var$SuspenseException;
    }
}
function $fb2b12fdc6fd9506$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $fb2b12fdc6fd9506$var$suspendedThenable = x, $fb2b12fdc6fd9506$var$SuspenseException;
        throw x;
    }
}
var $fb2b12fdc6fd9506$var$suspendedThenable = null;
function $fb2b12fdc6fd9506$var$getSuspendedThenable() {
    if (null === $fb2b12fdc6fd9506$var$suspendedThenable) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(459));
    var thenable = $fb2b12fdc6fd9506$var$suspendedThenable;
    $fb2b12fdc6fd9506$var$suspendedThenable = null;
    return thenable;
}
function $fb2b12fdc6fd9506$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $fb2b12fdc6fd9506$var$SuspenseException || rejectedReason === $fb2b12fdc6fd9506$var$SuspenseActionException) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(483));
}
var $fb2b12fdc6fd9506$var$thenableState$1 = null, $fb2b12fdc6fd9506$var$thenableIndexCounter$1 = 0;
function $fb2b12fdc6fd9506$var$unwrapThenable(thenable) {
    var index = $fb2b12fdc6fd9506$var$thenableIndexCounter$1;
    $fb2b12fdc6fd9506$var$thenableIndexCounter$1 += 1;
    null === $fb2b12fdc6fd9506$var$thenableState$1 && ($fb2b12fdc6fd9506$var$thenableState$1 = []);
    return $fb2b12fdc6fd9506$var$trackUsedThenable($fb2b12fdc6fd9506$var$thenableState$1, thenable, index);
}
function $fb2b12fdc6fd9506$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $fb2b12fdc6fd9506$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $fb2b12fdc6fd9506$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $fb2b12fdc6fd9506$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $fb2b12fdc6fd9506$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $fb2b12fdc6fd9506$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $fb2b12fdc6fd9506$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $fb2b12fdc6fd9506$var$REACT_LAZY_TYPE && $fb2b12fdc6fd9506$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $fb2b12fdc6fd9506$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $fb2b12fdc6fd9506$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $fb2b12fdc6fd9506$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $fb2b12fdc6fd9506$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $fb2b12fdc6fd9506$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $fb2b12fdc6fd9506$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $fb2b12fdc6fd9506$var$REACT_ELEMENT_TYPE:
                    return lanes = $fb2b12fdc6fd9506$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $fb2b12fdc6fd9506$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $fb2b12fdc6fd9506$var$REACT_PORTAL_TYPE:
                    return newChild = $fb2b12fdc6fd9506$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $fb2b12fdc6fd9506$var$REACT_LAZY_TYPE:
                    return newChild = $fb2b12fdc6fd9506$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($fb2b12fdc6fd9506$var$isArrayImpl(newChild) || $fb2b12fdc6fd9506$var$getIteratorFn(newChild)) return newChild = $fb2b12fdc6fd9506$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $fb2b12fdc6fd9506$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $fb2b12fdc6fd9506$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $fb2b12fdc6fd9506$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $fb2b12fdc6fd9506$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $fb2b12fdc6fd9506$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $fb2b12fdc6fd9506$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $fb2b12fdc6fd9506$var$REACT_LAZY_TYPE:
                    return newChild = $fb2b12fdc6fd9506$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($fb2b12fdc6fd9506$var$isArrayImpl(newChild) || $fb2b12fdc6fd9506$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $fb2b12fdc6fd9506$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $fb2b12fdc6fd9506$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $fb2b12fdc6fd9506$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $fb2b12fdc6fd9506$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $fb2b12fdc6fd9506$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $fb2b12fdc6fd9506$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $fb2b12fdc6fd9506$var$REACT_LAZY_TYPE:
                    return newChild = $fb2b12fdc6fd9506$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($fb2b12fdc6fd9506$var$isArrayImpl(newChild) || $fb2b12fdc6fd9506$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $fb2b12fdc6fd9506$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $fb2b12fdc6fd9506$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $fb2b12fdc6fd9506$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $fb2b12fdc6fd9506$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $fb2b12fdc6fd9506$var$isHydrating && $fb2b12fdc6fd9506$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $fb2b12fdc6fd9506$var$isHydrating && $fb2b12fdc6fd9506$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $fb2b12fdc6fd9506$var$isHydrating && $fb2b12fdc6fd9506$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $fb2b12fdc6fd9506$var$isHydrating && $fb2b12fdc6fd9506$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $fb2b12fdc6fd9506$var$isHydrating && $fb2b12fdc6fd9506$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $fb2b12fdc6fd9506$var$isHydrating && $fb2b12fdc6fd9506$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $fb2b12fdc6fd9506$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $fb2b12fdc6fd9506$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $fb2b12fdc6fd9506$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $fb2b12fdc6fd9506$var$REACT_LAZY_TYPE && $fb2b12fdc6fd9506$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $fb2b12fdc6fd9506$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $fb2b12fdc6fd9506$var$REACT_FRAGMENT_TYPE ? (lanes = $fb2b12fdc6fd9506$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $fb2b12fdc6fd9506$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $fb2b12fdc6fd9506$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $fb2b12fdc6fd9506$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $fb2b12fdc6fd9506$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $fb2b12fdc6fd9506$var$REACT_LAZY_TYPE:
                    return newChild = $fb2b12fdc6fd9506$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($fb2b12fdc6fd9506$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($fb2b12fdc6fd9506$var$getIteratorFn(newChild)) {
                key = $fb2b12fdc6fd9506$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $fb2b12fdc6fd9506$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $fb2b12fdc6fd9506$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $fb2b12fdc6fd9506$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $fb2b12fdc6fd9506$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $fb2b12fdc6fd9506$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $fb2b12fdc6fd9506$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $fb2b12fdc6fd9506$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $fb2b12fdc6fd9506$var$SuspenseException || x === $fb2b12fdc6fd9506$var$SuspenseActionException) throw x;
            var fiber = $fb2b12fdc6fd9506$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $fb2b12fdc6fd9506$var$reconcileChildFibers = $fb2b12fdc6fd9506$var$createChildReconciler(!0), $fb2b12fdc6fd9506$var$mountChildFibers = $fb2b12fdc6fd9506$var$createChildReconciler(!1), $fb2b12fdc6fd9506$var$hasForceUpdate = !1;
function $fb2b12fdc6fd9506$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $fb2b12fdc6fd9506$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $fb2b12fdc6fd9506$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $fb2b12fdc6fd9506$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($fb2b12fdc6fd9506$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $fb2b12fdc6fd9506$var$getRootForUpdatedFiber(fiber);
        $fb2b12fdc6fd9506$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $fb2b12fdc6fd9506$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $fb2b12fdc6fd9506$var$getRootForUpdatedFiber(fiber);
}
function $fb2b12fdc6fd9506$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $fb2b12fdc6fd9506$var$markRootEntangled(root, lane);
    }
}
function $fb2b12fdc6fd9506$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $fb2b12fdc6fd9506$var$didReadFromEntangledAsyncAction = !1;
function $fb2b12fdc6fd9506$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($fb2b12fdc6fd9506$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $fb2b12fdc6fd9506$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $fb2b12fdc6fd9506$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $fb2b12fdc6fd9506$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $fb2b12fdc6fd9506$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($fb2b12fdc6fd9506$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $fb2b12fdc6fd9506$var$currentEntangledLane && ($fb2b12fdc6fd9506$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $fb2b12fdc6fd9506$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $fb2b12fdc6fd9506$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $fb2b12fdc6fd9506$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $fb2b12fdc6fd9506$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $fb2b12fdc6fd9506$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$fb2b12fdc6fd9506$var$callCallback(callbacks[updateQueue], context);
}
var $fb2b12fdc6fd9506$var$currentTreeHiddenStackCursor = $fb2b12fdc6fd9506$var$createCursor(null), $fb2b12fdc6fd9506$var$prevEntangledRenderLanesCursor = $fb2b12fdc6fd9506$var$createCursor(0);
function $fb2b12fdc6fd9506$var$pushHiddenContext(fiber, context) {
    fiber = $fb2b12fdc6fd9506$var$entangledRenderLanes;
    $fb2b12fdc6fd9506$var$push($fb2b12fdc6fd9506$var$prevEntangledRenderLanesCursor, fiber);
    $fb2b12fdc6fd9506$var$push($fb2b12fdc6fd9506$var$currentTreeHiddenStackCursor, context);
    $fb2b12fdc6fd9506$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $fb2b12fdc6fd9506$var$reuseHiddenContextOnStack() {
    $fb2b12fdc6fd9506$var$push($fb2b12fdc6fd9506$var$prevEntangledRenderLanesCursor, $fb2b12fdc6fd9506$var$entangledRenderLanes);
    $fb2b12fdc6fd9506$var$push($fb2b12fdc6fd9506$var$currentTreeHiddenStackCursor, $fb2b12fdc6fd9506$var$currentTreeHiddenStackCursor.current);
}
function $fb2b12fdc6fd9506$var$popHiddenContext() {
    $fb2b12fdc6fd9506$var$entangledRenderLanes = $fb2b12fdc6fd9506$var$prevEntangledRenderLanesCursor.current;
    $fb2b12fdc6fd9506$var$pop($fb2b12fdc6fd9506$var$currentTreeHiddenStackCursor);
    $fb2b12fdc6fd9506$var$pop($fb2b12fdc6fd9506$var$prevEntangledRenderLanesCursor);
}
var $fb2b12fdc6fd9506$var$suspenseHandlerStackCursor = $fb2b12fdc6fd9506$var$createCursor(null), $fb2b12fdc6fd9506$var$shellBoundary = null;
function $fb2b12fdc6fd9506$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $fb2b12fdc6fd9506$var$push($fb2b12fdc6fd9506$var$suspenseStackCursor, $fb2b12fdc6fd9506$var$suspenseStackCursor.current & 1);
    $fb2b12fdc6fd9506$var$push($fb2b12fdc6fd9506$var$suspenseHandlerStackCursor, handler);
    null === $fb2b12fdc6fd9506$var$shellBoundary && (null === current || null !== $fb2b12fdc6fd9506$var$currentTreeHiddenStackCursor.current ? $fb2b12fdc6fd9506$var$shellBoundary = handler : null !== current.memoizedState && ($fb2b12fdc6fd9506$var$shellBoundary = handler));
}
function $fb2b12fdc6fd9506$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $fb2b12fdc6fd9506$var$push($fb2b12fdc6fd9506$var$suspenseStackCursor, $fb2b12fdc6fd9506$var$suspenseStackCursor.current);
    $fb2b12fdc6fd9506$var$push($fb2b12fdc6fd9506$var$suspenseHandlerStackCursor, fiber);
    null === $fb2b12fdc6fd9506$var$shellBoundary && ($fb2b12fdc6fd9506$var$shellBoundary = fiber);
}
function $fb2b12fdc6fd9506$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($fb2b12fdc6fd9506$var$push($fb2b12fdc6fd9506$var$suspenseStackCursor, $fb2b12fdc6fd9506$var$suspenseStackCursor.current), $fb2b12fdc6fd9506$var$push($fb2b12fdc6fd9506$var$suspenseHandlerStackCursor, fiber), null === $fb2b12fdc6fd9506$var$shellBoundary && ($fb2b12fdc6fd9506$var$shellBoundary = fiber)) : $fb2b12fdc6fd9506$var$reuseSuspenseHandlerOnStack(fiber);
}
function $fb2b12fdc6fd9506$var$reuseSuspenseHandlerOnStack() {
    $fb2b12fdc6fd9506$var$push($fb2b12fdc6fd9506$var$suspenseStackCursor, $fb2b12fdc6fd9506$var$suspenseStackCursor.current);
    $fb2b12fdc6fd9506$var$push($fb2b12fdc6fd9506$var$suspenseHandlerStackCursor, $fb2b12fdc6fd9506$var$suspenseHandlerStackCursor.current);
}
function $fb2b12fdc6fd9506$var$popSuspenseHandler(fiber) {
    $fb2b12fdc6fd9506$var$pop($fb2b12fdc6fd9506$var$suspenseHandlerStackCursor);
    $fb2b12fdc6fd9506$var$shellBoundary === fiber && ($fb2b12fdc6fd9506$var$shellBoundary = null);
    $fb2b12fdc6fd9506$var$pop($fb2b12fdc6fd9506$var$suspenseStackCursor);
}
var $fb2b12fdc6fd9506$var$suspenseStackCursor = $fb2b12fdc6fd9506$var$createCursor(0);
function $fb2b12fdc6fd9506$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $fb2b12fdc6fd9506$var$isSuspenseInstancePending(state) || $fb2b12fdc6fd9506$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $fb2b12fdc6fd9506$var$renderLanes = 0, $fb2b12fdc6fd9506$var$currentlyRenderingFiber = null, $fb2b12fdc6fd9506$var$currentHook = null, $fb2b12fdc6fd9506$var$workInProgressHook = null, $fb2b12fdc6fd9506$var$didScheduleRenderPhaseUpdate = !1, $fb2b12fdc6fd9506$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $fb2b12fdc6fd9506$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $fb2b12fdc6fd9506$var$localIdCounter = 0, $fb2b12fdc6fd9506$var$thenableIndexCounter = 0, $fb2b12fdc6fd9506$var$thenableState = null, $fb2b12fdc6fd9506$var$globalClientIdCounter = 0;
function $fb2b12fdc6fd9506$var$throwInvalidHookError() {
    throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(321));
}
function $fb2b12fdc6fd9506$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$fb2b12fdc6fd9506$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $fb2b12fdc6fd9506$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $fb2b12fdc6fd9506$var$renderLanes = nextRenderLanes;
    $fb2b12fdc6fd9506$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $fb2b12fdc6fd9506$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $fb2b12fdc6fd9506$var$HooksDispatcherOnMount : $fb2b12fdc6fd9506$var$HooksDispatcherOnUpdate;
    $fb2b12fdc6fd9506$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $fb2b12fdc6fd9506$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $fb2b12fdc6fd9506$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $fb2b12fdc6fd9506$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $fb2b12fdc6fd9506$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $fb2b12fdc6fd9506$var$finishRenderingHooks(current) {
    $fb2b12fdc6fd9506$var$ReactSharedInternals.H = $fb2b12fdc6fd9506$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $fb2b12fdc6fd9506$var$currentHook && null !== $fb2b12fdc6fd9506$var$currentHook.next;
    $fb2b12fdc6fd9506$var$renderLanes = 0;
    $fb2b12fdc6fd9506$var$workInProgressHook = $fb2b12fdc6fd9506$var$currentHook = $fb2b12fdc6fd9506$var$currentlyRenderingFiber = null;
    $fb2b12fdc6fd9506$var$didScheduleRenderPhaseUpdate = !1;
    $fb2b12fdc6fd9506$var$thenableIndexCounter = 0;
    $fb2b12fdc6fd9506$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(300));
    null === current || $fb2b12fdc6fd9506$var$didReceiveUpdate || (current = current.dependencies, null !== current && $fb2b12fdc6fd9506$var$checkIfContextChanged(current) && ($fb2b12fdc6fd9506$var$didReceiveUpdate = !0));
}
function $fb2b12fdc6fd9506$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $fb2b12fdc6fd9506$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $fb2b12fdc6fd9506$var$didScheduleRenderPhaseUpdateDuringThisPass && ($fb2b12fdc6fd9506$var$thenableState = null);
        $fb2b12fdc6fd9506$var$thenableIndexCounter = 0;
        $fb2b12fdc6fd9506$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $fb2b12fdc6fd9506$var$workInProgressHook = $fb2b12fdc6fd9506$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $fb2b12fdc6fd9506$var$ReactSharedInternals.H = $fb2b12fdc6fd9506$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($fb2b12fdc6fd9506$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $fb2b12fdc6fd9506$var$TransitionAwareHostComponent() {
    var dispatcher = $fb2b12fdc6fd9506$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $fb2b12fdc6fd9506$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $fb2b12fdc6fd9506$var$currentHook ? $fb2b12fdc6fd9506$var$currentHook.memoizedState : null) !== dispatcher && ($fb2b12fdc6fd9506$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $fb2b12fdc6fd9506$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $fb2b12fdc6fd9506$var$localIdCounter;
    $fb2b12fdc6fd9506$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $fb2b12fdc6fd9506$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $fb2b12fdc6fd9506$var$resetHooksOnUnwind(workInProgress) {
    if ($fb2b12fdc6fd9506$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $fb2b12fdc6fd9506$var$didScheduleRenderPhaseUpdate = !1;
    }
    $fb2b12fdc6fd9506$var$renderLanes = 0;
    $fb2b12fdc6fd9506$var$workInProgressHook = $fb2b12fdc6fd9506$var$currentHook = $fb2b12fdc6fd9506$var$currentlyRenderingFiber = null;
    $fb2b12fdc6fd9506$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $fb2b12fdc6fd9506$var$thenableIndexCounter = $fb2b12fdc6fd9506$var$localIdCounter = 0;
    $fb2b12fdc6fd9506$var$thenableState = null;
}
function $fb2b12fdc6fd9506$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $fb2b12fdc6fd9506$var$workInProgressHook ? $fb2b12fdc6fd9506$var$currentlyRenderingFiber.memoizedState = $fb2b12fdc6fd9506$var$workInProgressHook = hook : $fb2b12fdc6fd9506$var$workInProgressHook = $fb2b12fdc6fd9506$var$workInProgressHook.next = hook;
    return $fb2b12fdc6fd9506$var$workInProgressHook;
}
function $fb2b12fdc6fd9506$var$updateWorkInProgressHook() {
    if (null === $fb2b12fdc6fd9506$var$currentHook) {
        var nextCurrentHook = $fb2b12fdc6fd9506$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $fb2b12fdc6fd9506$var$currentHook.next;
    var nextWorkInProgressHook = null === $fb2b12fdc6fd9506$var$workInProgressHook ? $fb2b12fdc6fd9506$var$currentlyRenderingFiber.memoizedState : $fb2b12fdc6fd9506$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $fb2b12fdc6fd9506$var$workInProgressHook = nextWorkInProgressHook, $fb2b12fdc6fd9506$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $fb2b12fdc6fd9506$var$currentlyRenderingFiber.alternate) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(467));
            throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(310));
        }
        $fb2b12fdc6fd9506$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $fb2b12fdc6fd9506$var$currentHook.memoizedState,
            baseState: $fb2b12fdc6fd9506$var$currentHook.baseState,
            baseQueue: $fb2b12fdc6fd9506$var$currentHook.baseQueue,
            queue: $fb2b12fdc6fd9506$var$currentHook.queue,
            next: null
        };
        null === $fb2b12fdc6fd9506$var$workInProgressHook ? $fb2b12fdc6fd9506$var$currentlyRenderingFiber.memoizedState = $fb2b12fdc6fd9506$var$workInProgressHook = nextCurrentHook : $fb2b12fdc6fd9506$var$workInProgressHook = $fb2b12fdc6fd9506$var$workInProgressHook.next = nextCurrentHook;
    }
    return $fb2b12fdc6fd9506$var$workInProgressHook;
}
function $fb2b12fdc6fd9506$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $fb2b12fdc6fd9506$var$useThenable(thenable) {
    var index = $fb2b12fdc6fd9506$var$thenableIndexCounter;
    $fb2b12fdc6fd9506$var$thenableIndexCounter += 1;
    null === $fb2b12fdc6fd9506$var$thenableState && ($fb2b12fdc6fd9506$var$thenableState = []);
    thenable = $fb2b12fdc6fd9506$var$trackUsedThenable($fb2b12fdc6fd9506$var$thenableState, thenable, index);
    index = $fb2b12fdc6fd9506$var$currentlyRenderingFiber;
    null === (null === $fb2b12fdc6fd9506$var$workInProgressHook ? index.memoizedState : $fb2b12fdc6fd9506$var$workInProgressHook.next) && (index = index.alternate, $fb2b12fdc6fd9506$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $fb2b12fdc6fd9506$var$HooksDispatcherOnMount : $fb2b12fdc6fd9506$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $fb2b12fdc6fd9506$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $fb2b12fdc6fd9506$var$useThenable(usable);
        if (usable.$$typeof === $fb2b12fdc6fd9506$var$REACT_CONTEXT_TYPE) return $fb2b12fdc6fd9506$var$readContext(usable);
    }
    throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(438, String(usable)));
}
function $fb2b12fdc6fd9506$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $fb2b12fdc6fd9506$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $fb2b12fdc6fd9506$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $fb2b12fdc6fd9506$var$createFunctionComponentUpdateQueue(), $fb2b12fdc6fd9506$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $fb2b12fdc6fd9506$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $fb2b12fdc6fd9506$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $fb2b12fdc6fd9506$var$updateReducer(reducer) {
    var hook = $fb2b12fdc6fd9506$var$updateWorkInProgressHook();
    return $fb2b12fdc6fd9506$var$updateReducerImpl(hook, $fb2b12fdc6fd9506$var$currentHook, reducer);
}
function $fb2b12fdc6fd9506$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($fb2b12fdc6fd9506$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($fb2b12fdc6fd9506$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $fb2b12fdc6fd9506$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($fb2b12fdc6fd9506$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $fb2b12fdc6fd9506$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $fb2b12fdc6fd9506$var$currentlyRenderingFiber.lanes |= revertLane, $fb2b12fdc6fd9506$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $fb2b12fdc6fd9506$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $fb2b12fdc6fd9506$var$currentlyRenderingFiber.lanes |= updateLane, $fb2b12fdc6fd9506$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$fb2b12fdc6fd9506$var$objectIs(pendingQueue, hook.memoizedState) && ($fb2b12fdc6fd9506$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $fb2b12fdc6fd9506$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $fb2b12fdc6fd9506$var$rerenderReducer(reducer) {
    var hook = $fb2b12fdc6fd9506$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $fb2b12fdc6fd9506$var$objectIs(newState, hook.memoizedState) || ($fb2b12fdc6fd9506$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $fb2b12fdc6fd9506$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $fb2b12fdc6fd9506$var$currentlyRenderingFiber, hook = $fb2b12fdc6fd9506$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $fb2b12fdc6fd9506$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$fb2b12fdc6fd9506$var$objectIs(($fb2b12fdc6fd9506$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $fb2b12fdc6fd9506$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $fb2b12fdc6fd9506$var$updateEffect($fb2b12fdc6fd9506$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $fb2b12fdc6fd9506$var$workInProgressHook && $fb2b12fdc6fd9506$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $fb2b12fdc6fd9506$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $fb2b12fdc6fd9506$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $fb2b12fdc6fd9506$var$workInProgressRoot) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($fb2b12fdc6fd9506$var$renderLanes & 127) || $fb2b12fdc6fd9506$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $fb2b12fdc6fd9506$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $fb2b12fdc6fd9506$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $fb2b12fdc6fd9506$var$createFunctionComponentUpdateQueue(), $fb2b12fdc6fd9506$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $fb2b12fdc6fd9506$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $fb2b12fdc6fd9506$var$checkIfSnapshotChanged(inst) && $fb2b12fdc6fd9506$var$forceStoreRerender(fiber);
}
function $fb2b12fdc6fd9506$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $fb2b12fdc6fd9506$var$checkIfSnapshotChanged(inst) && $fb2b12fdc6fd9506$var$forceStoreRerender(fiber);
    });
}
function $fb2b12fdc6fd9506$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$fb2b12fdc6fd9506$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $fb2b12fdc6fd9506$var$forceStoreRerender(fiber) {
    var root = $fb2b12fdc6fd9506$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $fb2b12fdc6fd9506$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $fb2b12fdc6fd9506$var$mountStateImpl(initialState) {
    var hook = $fb2b12fdc6fd9506$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($fb2b12fdc6fd9506$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $fb2b12fdc6fd9506$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $fb2b12fdc6fd9506$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $fb2b12fdc6fd9506$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $fb2b12fdc6fd9506$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $fb2b12fdc6fd9506$var$updateReducerImpl(hook, $fb2b12fdc6fd9506$var$currentHook, "function" === typeof reducer ? reducer : $fb2b12fdc6fd9506$var$basicStateReducer);
}
function $fb2b12fdc6fd9506$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($fb2b12fdc6fd9506$var$isRenderPhaseUpdate(fiber)) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $fb2b12fdc6fd9506$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $fb2b12fdc6fd9506$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $fb2b12fdc6fd9506$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $fb2b12fdc6fd9506$var$ReactSharedInternals.T, currentTransition = {};
        $fb2b12fdc6fd9506$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $fb2b12fdc6fd9506$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $fb2b12fdc6fd9506$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $fb2b12fdc6fd9506$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $fb2b12fdc6fd9506$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $fb2b12fdc6fd9506$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $fb2b12fdc6fd9506$var$onActionError(actionQueue, node, error$66);
    }
}
function $fb2b12fdc6fd9506$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $fb2b12fdc6fd9506$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $fb2b12fdc6fd9506$var$onActionError(actionQueue, node, error);
    }) : $fb2b12fdc6fd9506$var$onActionSuccess(actionQueue, node, returnValue);
}
function $fb2b12fdc6fd9506$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $fb2b12fdc6fd9506$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $fb2b12fdc6fd9506$var$runActionStateAction(actionQueue, nextState)));
}
function $fb2b12fdc6fd9506$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $fb2b12fdc6fd9506$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $fb2b12fdc6fd9506$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $fb2b12fdc6fd9506$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $fb2b12fdc6fd9506$var$mountActionState(action, initialStateProp) {
    if ($fb2b12fdc6fd9506$var$isHydrating) {
        var ssrFormState = $fb2b12fdc6fd9506$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $fb2b12fdc6fd9506$var$currentlyRenderingFiber;
                if ($fb2b12fdc6fd9506$var$isHydrating) {
                    if ($fb2b12fdc6fd9506$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $fb2b12fdc6fd9506$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $fb2b12fdc6fd9506$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $fb2b12fdc6fd9506$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $fb2b12fdc6fd9506$var$nextHydratableInstance = $fb2b12fdc6fd9506$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $fb2b12fdc6fd9506$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $fb2b12fdc6fd9506$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $fb2b12fdc6fd9506$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $fb2b12fdc6fd9506$var$dispatchSetState.bind(null, $fb2b12fdc6fd9506$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $fb2b12fdc6fd9506$var$mountStateImpl(!1);
    inRootOrSingleton = $fb2b12fdc6fd9506$var$dispatchOptimisticSetState.bind(null, $fb2b12fdc6fd9506$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $fb2b12fdc6fd9506$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $fb2b12fdc6fd9506$var$dispatchActionState.bind(null, $fb2b12fdc6fd9506$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $fb2b12fdc6fd9506$var$updateActionState(action) {
    var stateHook = $fb2b12fdc6fd9506$var$updateWorkInProgressHook();
    return $fb2b12fdc6fd9506$var$updateActionStateImpl(stateHook, $fb2b12fdc6fd9506$var$currentHook, action);
}
function $fb2b12fdc6fd9506$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $fb2b12fdc6fd9506$var$updateReducerImpl(stateHook, currentStateHook, $fb2b12fdc6fd9506$var$actionStateReducer)[0];
    stateHook = $fb2b12fdc6fd9506$var$updateReducer($fb2b12fdc6fd9506$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $fb2b12fdc6fd9506$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $fb2b12fdc6fd9506$var$SuspenseException) throw $fb2b12fdc6fd9506$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $fb2b12fdc6fd9506$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($fb2b12fdc6fd9506$var$currentlyRenderingFiber.flags |= 2048, $fb2b12fdc6fd9506$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $fb2b12fdc6fd9506$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $fb2b12fdc6fd9506$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $fb2b12fdc6fd9506$var$rerenderActionState(action) {
    var stateHook = $fb2b12fdc6fd9506$var$updateWorkInProgressHook(), currentStateHook = $fb2b12fdc6fd9506$var$currentHook;
    if (null !== currentStateHook) return $fb2b12fdc6fd9506$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $fb2b12fdc6fd9506$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $fb2b12fdc6fd9506$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $fb2b12fdc6fd9506$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $fb2b12fdc6fd9506$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $fb2b12fdc6fd9506$var$createFunctionComponentUpdateQueue(), $fb2b12fdc6fd9506$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $fb2b12fdc6fd9506$var$updateRef() {
    return $fb2b12fdc6fd9506$var$updateWorkInProgressHook().memoizedState;
}
function $fb2b12fdc6fd9506$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $fb2b12fdc6fd9506$var$mountWorkInProgressHook();
    $fb2b12fdc6fd9506$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $fb2b12fdc6fd9506$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $fb2b12fdc6fd9506$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $fb2b12fdc6fd9506$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $fb2b12fdc6fd9506$var$currentHook && null !== deps && $fb2b12fdc6fd9506$var$areHookInputsEqual(deps, $fb2b12fdc6fd9506$var$currentHook.memoizedState.deps) ? hook.memoizedState = $fb2b12fdc6fd9506$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($fb2b12fdc6fd9506$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $fb2b12fdc6fd9506$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $fb2b12fdc6fd9506$var$mountEffect(create, deps) {
    $fb2b12fdc6fd9506$var$mountEffectImpl(8390656, 8, create, deps);
}
function $fb2b12fdc6fd9506$var$updateEffect(create, deps) {
    $fb2b12fdc6fd9506$var$updateEffectImpl(2048, 8, create, deps);
}
function $fb2b12fdc6fd9506$var$useEffectEventImpl(payload) {
    $fb2b12fdc6fd9506$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $fb2b12fdc6fd9506$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $fb2b12fdc6fd9506$var$createFunctionComponentUpdateQueue(), $fb2b12fdc6fd9506$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $fb2b12fdc6fd9506$var$updateEvent(callback) {
    var ref = $fb2b12fdc6fd9506$var$updateWorkInProgressHook().memoizedState;
    $fb2b12fdc6fd9506$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($fb2b12fdc6fd9506$var$executionContext & 2)) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $fb2b12fdc6fd9506$var$updateInsertionEffect(create, deps) {
    return $fb2b12fdc6fd9506$var$updateEffectImpl(4, 2, create, deps);
}
function $fb2b12fdc6fd9506$var$updateLayoutEffect(create, deps) {
    return $fb2b12fdc6fd9506$var$updateEffectImpl(4, 4, create, deps);
}
function $fb2b12fdc6fd9506$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $fb2b12fdc6fd9506$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $fb2b12fdc6fd9506$var$updateEffectImpl(4, 4, $fb2b12fdc6fd9506$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $fb2b12fdc6fd9506$var$mountDebugValue() {}
function $fb2b12fdc6fd9506$var$updateCallback(callback, deps) {
    var hook = $fb2b12fdc6fd9506$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $fb2b12fdc6fd9506$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $fb2b12fdc6fd9506$var$updateMemo(nextCreate, deps) {
    var hook = $fb2b12fdc6fd9506$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $fb2b12fdc6fd9506$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($fb2b12fdc6fd9506$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $fb2b12fdc6fd9506$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $fb2b12fdc6fd9506$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $fb2b12fdc6fd9506$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($fb2b12fdc6fd9506$var$renderLanes & 1073741824) && 0 === ($fb2b12fdc6fd9506$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $fb2b12fdc6fd9506$var$requestDeferredLane();
    $fb2b12fdc6fd9506$var$currentlyRenderingFiber.lanes |= hook;
    $fb2b12fdc6fd9506$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $fb2b12fdc6fd9506$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($fb2b12fdc6fd9506$var$objectIs(value, prevValue)) return value;
    if (null !== $fb2b12fdc6fd9506$var$currentTreeHiddenStackCursor.current) return hook = $fb2b12fdc6fd9506$var$mountDeferredValueImpl(hook, value, initialValue), $fb2b12fdc6fd9506$var$objectIs(hook, prevValue) || ($fb2b12fdc6fd9506$var$didReceiveUpdate = !0), hook;
    if (0 === ($fb2b12fdc6fd9506$var$renderLanes & 42) || 0 !== ($fb2b12fdc6fd9506$var$renderLanes & 1073741824) && 0 === ($fb2b12fdc6fd9506$var$workInProgressRootRenderLanes & 261930)) return $fb2b12fdc6fd9506$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $fb2b12fdc6fd9506$var$requestDeferredLane();
    $fb2b12fdc6fd9506$var$currentlyRenderingFiber.lanes |= hook;
    $fb2b12fdc6fd9506$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $fb2b12fdc6fd9506$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $fb2b12fdc6fd9506$var$ReactDOMSharedInternals.p;
    $fb2b12fdc6fd9506$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $fb2b12fdc6fd9506$var$ReactSharedInternals.T, currentTransition = {};
    $fb2b12fdc6fd9506$var$ReactSharedInternals.T = currentTransition;
    $fb2b12fdc6fd9506$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $fb2b12fdc6fd9506$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $fb2b12fdc6fd9506$var$chainThenableValue(returnValue, finishedState);
            $fb2b12fdc6fd9506$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $fb2b12fdc6fd9506$var$requestUpdateLane(fiber));
        } else $fb2b12fdc6fd9506$var$dispatchSetStateInternal(fiber, queue, finishedState, $fb2b12fdc6fd9506$var$requestUpdateLane(fiber));
    } catch (error) {
        $fb2b12fdc6fd9506$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $fb2b12fdc6fd9506$var$requestUpdateLane());
    } finally{
        $fb2b12fdc6fd9506$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $fb2b12fdc6fd9506$var$ReactSharedInternals.T = prevTransition;
    }
}
function $fb2b12fdc6fd9506$var$noop() {}
function $fb2b12fdc6fd9506$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(476));
    var queue = $fb2b12fdc6fd9506$var$ensureFormComponentIsStateful(formFiber).queue;
    $fb2b12fdc6fd9506$var$startTransition(formFiber, queue, pendingState, $fb2b12fdc6fd9506$var$sharedNotPendingObject, null === action ? $fb2b12fdc6fd9506$var$noop : function() {
        $fb2b12fdc6fd9506$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $fb2b12fdc6fd9506$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $fb2b12fdc6fd9506$var$sharedNotPendingObject,
        baseState: $fb2b12fdc6fd9506$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $fb2b12fdc6fd9506$var$basicStateReducer,
            lastRenderedState: $fb2b12fdc6fd9506$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $fb2b12fdc6fd9506$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $fb2b12fdc6fd9506$var$requestFormReset$1(formFiber) {
    var stateHook = $fb2b12fdc6fd9506$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $fb2b12fdc6fd9506$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $fb2b12fdc6fd9506$var$requestUpdateLane());
}
function $fb2b12fdc6fd9506$var$useHostTransitionStatus() {
    return $fb2b12fdc6fd9506$var$readContext($fb2b12fdc6fd9506$var$HostTransitionContext);
}
function $fb2b12fdc6fd9506$var$updateId() {
    return $fb2b12fdc6fd9506$var$updateWorkInProgressHook().memoizedState;
}
function $fb2b12fdc6fd9506$var$updateRefresh() {
    return $fb2b12fdc6fd9506$var$updateWorkInProgressHook().memoizedState;
}
function $fb2b12fdc6fd9506$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $fb2b12fdc6fd9506$var$requestUpdateLane();
                fiber = $fb2b12fdc6fd9506$var$createUpdate(lane);
                var root$69 = $fb2b12fdc6fd9506$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($fb2b12fdc6fd9506$var$scheduleUpdateOnFiber(root$69, provider, lane), $fb2b12fdc6fd9506$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $fb2b12fdc6fd9506$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $fb2b12fdc6fd9506$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $fb2b12fdc6fd9506$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $fb2b12fdc6fd9506$var$isRenderPhaseUpdate(fiber) ? $fb2b12fdc6fd9506$var$enqueueRenderPhaseUpdate(queue, action) : (action = $fb2b12fdc6fd9506$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($fb2b12fdc6fd9506$var$scheduleUpdateOnFiber(action, fiber, lane), $fb2b12fdc6fd9506$var$entangleTransitionUpdate(action, queue, lane)));
}
function $fb2b12fdc6fd9506$var$dispatchSetState(fiber, queue, action) {
    var lane = $fb2b12fdc6fd9506$var$requestUpdateLane();
    $fb2b12fdc6fd9506$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $fb2b12fdc6fd9506$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($fb2b12fdc6fd9506$var$isRenderPhaseUpdate(fiber)) $fb2b12fdc6fd9506$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($fb2b12fdc6fd9506$var$objectIs(eagerState, currentState)) return $fb2b12fdc6fd9506$var$enqueueUpdate$1(fiber, queue, update, 0), null === $fb2b12fdc6fd9506$var$workInProgressRoot && $fb2b12fdc6fd9506$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $fb2b12fdc6fd9506$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $fb2b12fdc6fd9506$var$scheduleUpdateOnFiber(action, fiber, lane), $fb2b12fdc6fd9506$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $fb2b12fdc6fd9506$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $fb2b12fdc6fd9506$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($fb2b12fdc6fd9506$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $fb2b12fdc6fd9506$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $fb2b12fdc6fd9506$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $fb2b12fdc6fd9506$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $fb2b12fdc6fd9506$var$currentlyRenderingFiber || null !== alternate && alternate === $fb2b12fdc6fd9506$var$currentlyRenderingFiber;
}
function $fb2b12fdc6fd9506$var$enqueueRenderPhaseUpdate(queue, update) {
    $fb2b12fdc6fd9506$var$didScheduleRenderPhaseUpdateDuringThisPass = $fb2b12fdc6fd9506$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $fb2b12fdc6fd9506$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $fb2b12fdc6fd9506$var$markRootEntangled(root, lane);
    }
}
var $fb2b12fdc6fd9506$var$ContextOnlyDispatcher = {
    readContext: $fb2b12fdc6fd9506$var$readContext,
    use: $fb2b12fdc6fd9506$var$use,
    useCallback: $fb2b12fdc6fd9506$var$throwInvalidHookError,
    useContext: $fb2b12fdc6fd9506$var$throwInvalidHookError,
    useEffect: $fb2b12fdc6fd9506$var$throwInvalidHookError,
    useImperativeHandle: $fb2b12fdc6fd9506$var$throwInvalidHookError,
    useLayoutEffect: $fb2b12fdc6fd9506$var$throwInvalidHookError,
    useInsertionEffect: $fb2b12fdc6fd9506$var$throwInvalidHookError,
    useMemo: $fb2b12fdc6fd9506$var$throwInvalidHookError,
    useReducer: $fb2b12fdc6fd9506$var$throwInvalidHookError,
    useRef: $fb2b12fdc6fd9506$var$throwInvalidHookError,
    useState: $fb2b12fdc6fd9506$var$throwInvalidHookError,
    useDebugValue: $fb2b12fdc6fd9506$var$throwInvalidHookError,
    useDeferredValue: $fb2b12fdc6fd9506$var$throwInvalidHookError,
    useTransition: $fb2b12fdc6fd9506$var$throwInvalidHookError,
    useSyncExternalStore: $fb2b12fdc6fd9506$var$throwInvalidHookError,
    useId: $fb2b12fdc6fd9506$var$throwInvalidHookError,
    useHostTransitionStatus: $fb2b12fdc6fd9506$var$throwInvalidHookError,
    useFormState: $fb2b12fdc6fd9506$var$throwInvalidHookError,
    useActionState: $fb2b12fdc6fd9506$var$throwInvalidHookError,
    useOptimistic: $fb2b12fdc6fd9506$var$throwInvalidHookError,
    useMemoCache: $fb2b12fdc6fd9506$var$throwInvalidHookError,
    useCacheRefresh: $fb2b12fdc6fd9506$var$throwInvalidHookError
};
$fb2b12fdc6fd9506$var$ContextOnlyDispatcher.useEffectEvent = $fb2b12fdc6fd9506$var$throwInvalidHookError;
var $fb2b12fdc6fd9506$var$HooksDispatcherOnMount = {
    readContext: $fb2b12fdc6fd9506$var$readContext,
    use: $fb2b12fdc6fd9506$var$use,
    useCallback: function(callback, deps) {
        $fb2b12fdc6fd9506$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $fb2b12fdc6fd9506$var$readContext,
    useEffect: $fb2b12fdc6fd9506$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $fb2b12fdc6fd9506$var$mountEffectImpl(4194308, 4, $fb2b12fdc6fd9506$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $fb2b12fdc6fd9506$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $fb2b12fdc6fd9506$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $fb2b12fdc6fd9506$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($fb2b12fdc6fd9506$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $fb2b12fdc6fd9506$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $fb2b12fdc6fd9506$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $fb2b12fdc6fd9506$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($fb2b12fdc6fd9506$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $fb2b12fdc6fd9506$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $fb2b12fdc6fd9506$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $fb2b12fdc6fd9506$var$dispatchReducerAction.bind(null, $fb2b12fdc6fd9506$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $fb2b12fdc6fd9506$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $fb2b12fdc6fd9506$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $fb2b12fdc6fd9506$var$dispatchSetState.bind(null, $fb2b12fdc6fd9506$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $fb2b12fdc6fd9506$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $fb2b12fdc6fd9506$var$mountWorkInProgressHook();
        return $fb2b12fdc6fd9506$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $fb2b12fdc6fd9506$var$mountStateImpl(!1);
        stateHook = $fb2b12fdc6fd9506$var$startTransition.bind(null, $fb2b12fdc6fd9506$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $fb2b12fdc6fd9506$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $fb2b12fdc6fd9506$var$currentlyRenderingFiber, hook = $fb2b12fdc6fd9506$var$mountWorkInProgressHook();
        if ($fb2b12fdc6fd9506$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $fb2b12fdc6fd9506$var$workInProgressRoot) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(349));
            0 !== ($fb2b12fdc6fd9506$var$workInProgressRootRenderLanes & 127) || $fb2b12fdc6fd9506$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $fb2b12fdc6fd9506$var$mountEffect($fb2b12fdc6fd9506$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $fb2b12fdc6fd9506$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $fb2b12fdc6fd9506$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $fb2b12fdc6fd9506$var$mountWorkInProgressHook(), identifierPrefix = $fb2b12fdc6fd9506$var$workInProgressRoot.identifierPrefix;
        if ($fb2b12fdc6fd9506$var$isHydrating) {
            var JSCompiler_inline_result = $fb2b12fdc6fd9506$var$treeContextOverflow;
            var idWithLeadingBit = $fb2b12fdc6fd9506$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $fb2b12fdc6fd9506$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $fb2b12fdc6fd9506$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $fb2b12fdc6fd9506$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $fb2b12fdc6fd9506$var$useHostTransitionStatus,
    useFormState: $fb2b12fdc6fd9506$var$mountActionState,
    useActionState: $fb2b12fdc6fd9506$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $fb2b12fdc6fd9506$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $fb2b12fdc6fd9506$var$dispatchOptimisticSetState.bind(null, $fb2b12fdc6fd9506$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $fb2b12fdc6fd9506$var$useMemoCache,
    useCacheRefresh: function() {
        return $fb2b12fdc6fd9506$var$mountWorkInProgressHook().memoizedState = $fb2b12fdc6fd9506$var$refreshCache.bind(null, $fb2b12fdc6fd9506$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $fb2b12fdc6fd9506$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($fb2b12fdc6fd9506$var$executionContext & 2)) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $fb2b12fdc6fd9506$var$HooksDispatcherOnUpdate = {
    readContext: $fb2b12fdc6fd9506$var$readContext,
    use: $fb2b12fdc6fd9506$var$use,
    useCallback: $fb2b12fdc6fd9506$var$updateCallback,
    useContext: $fb2b12fdc6fd9506$var$readContext,
    useEffect: $fb2b12fdc6fd9506$var$updateEffect,
    useImperativeHandle: $fb2b12fdc6fd9506$var$updateImperativeHandle,
    useInsertionEffect: $fb2b12fdc6fd9506$var$updateInsertionEffect,
    useLayoutEffect: $fb2b12fdc6fd9506$var$updateLayoutEffect,
    useMemo: $fb2b12fdc6fd9506$var$updateMemo,
    useReducer: $fb2b12fdc6fd9506$var$updateReducer,
    useRef: $fb2b12fdc6fd9506$var$updateRef,
    useState: function() {
        return $fb2b12fdc6fd9506$var$updateReducer($fb2b12fdc6fd9506$var$basicStateReducer);
    },
    useDebugValue: $fb2b12fdc6fd9506$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $fb2b12fdc6fd9506$var$updateWorkInProgressHook();
        return $fb2b12fdc6fd9506$var$updateDeferredValueImpl(hook, $fb2b12fdc6fd9506$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $fb2b12fdc6fd9506$var$updateReducer($fb2b12fdc6fd9506$var$basicStateReducer)[0], start = $fb2b12fdc6fd9506$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $fb2b12fdc6fd9506$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $fb2b12fdc6fd9506$var$updateSyncExternalStore,
    useId: $fb2b12fdc6fd9506$var$updateId,
    useHostTransitionStatus: $fb2b12fdc6fd9506$var$useHostTransitionStatus,
    useFormState: $fb2b12fdc6fd9506$var$updateActionState,
    useActionState: $fb2b12fdc6fd9506$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $fb2b12fdc6fd9506$var$updateWorkInProgressHook();
        return $fb2b12fdc6fd9506$var$updateOptimisticImpl(hook, $fb2b12fdc6fd9506$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $fb2b12fdc6fd9506$var$useMemoCache,
    useCacheRefresh: $fb2b12fdc6fd9506$var$updateRefresh
};
$fb2b12fdc6fd9506$var$HooksDispatcherOnUpdate.useEffectEvent = $fb2b12fdc6fd9506$var$updateEvent;
var $fb2b12fdc6fd9506$var$HooksDispatcherOnRerender = {
    readContext: $fb2b12fdc6fd9506$var$readContext,
    use: $fb2b12fdc6fd9506$var$use,
    useCallback: $fb2b12fdc6fd9506$var$updateCallback,
    useContext: $fb2b12fdc6fd9506$var$readContext,
    useEffect: $fb2b12fdc6fd9506$var$updateEffect,
    useImperativeHandle: $fb2b12fdc6fd9506$var$updateImperativeHandle,
    useInsertionEffect: $fb2b12fdc6fd9506$var$updateInsertionEffect,
    useLayoutEffect: $fb2b12fdc6fd9506$var$updateLayoutEffect,
    useMemo: $fb2b12fdc6fd9506$var$updateMemo,
    useReducer: $fb2b12fdc6fd9506$var$rerenderReducer,
    useRef: $fb2b12fdc6fd9506$var$updateRef,
    useState: function() {
        return $fb2b12fdc6fd9506$var$rerenderReducer($fb2b12fdc6fd9506$var$basicStateReducer);
    },
    useDebugValue: $fb2b12fdc6fd9506$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $fb2b12fdc6fd9506$var$updateWorkInProgressHook();
        return null === $fb2b12fdc6fd9506$var$currentHook ? $fb2b12fdc6fd9506$var$mountDeferredValueImpl(hook, value, initialValue) : $fb2b12fdc6fd9506$var$updateDeferredValueImpl(hook, $fb2b12fdc6fd9506$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $fb2b12fdc6fd9506$var$rerenderReducer($fb2b12fdc6fd9506$var$basicStateReducer)[0], start = $fb2b12fdc6fd9506$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $fb2b12fdc6fd9506$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $fb2b12fdc6fd9506$var$updateSyncExternalStore,
    useId: $fb2b12fdc6fd9506$var$updateId,
    useHostTransitionStatus: $fb2b12fdc6fd9506$var$useHostTransitionStatus,
    useFormState: $fb2b12fdc6fd9506$var$rerenderActionState,
    useActionState: $fb2b12fdc6fd9506$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $fb2b12fdc6fd9506$var$updateWorkInProgressHook();
        if (null !== $fb2b12fdc6fd9506$var$currentHook) return $fb2b12fdc6fd9506$var$updateOptimisticImpl(hook, $fb2b12fdc6fd9506$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $fb2b12fdc6fd9506$var$useMemoCache,
    useCacheRefresh: $fb2b12fdc6fd9506$var$updateRefresh
};
$fb2b12fdc6fd9506$var$HooksDispatcherOnRerender.useEffectEvent = $fb2b12fdc6fd9506$var$updateEvent;
function $fb2b12fdc6fd9506$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $fb2b12fdc6fd9506$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $fb2b12fdc6fd9506$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $fb2b12fdc6fd9506$var$requestUpdateLane(), update = $fb2b12fdc6fd9506$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $fb2b12fdc6fd9506$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($fb2b12fdc6fd9506$var$scheduleUpdateOnFiber(payload, inst, lane), $fb2b12fdc6fd9506$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $fb2b12fdc6fd9506$var$requestUpdateLane(), update = $fb2b12fdc6fd9506$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $fb2b12fdc6fd9506$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($fb2b12fdc6fd9506$var$scheduleUpdateOnFiber(payload, inst, lane), $fb2b12fdc6fd9506$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $fb2b12fdc6fd9506$var$requestUpdateLane(), update = $fb2b12fdc6fd9506$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $fb2b12fdc6fd9506$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($fb2b12fdc6fd9506$var$scheduleUpdateOnFiber(callback, inst, lane), $fb2b12fdc6fd9506$var$entangleTransitions(callback, inst, lane));
    }
};
function $fb2b12fdc6fd9506$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$fb2b12fdc6fd9506$var$shallowEqual(oldProps, newProps) || !$fb2b12fdc6fd9506$var$shallowEqual(oldState, newState) : !0;
}
function $fb2b12fdc6fd9506$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $fb2b12fdc6fd9506$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $fb2b12fdc6fd9506$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $fb2b12fdc6fd9506$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $fb2b12fdc6fd9506$var$defaultOnUncaughtError(error) {
    $fb2b12fdc6fd9506$var$reportGlobalError(error);
}
function $fb2b12fdc6fd9506$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $fb2b12fdc6fd9506$var$defaultOnRecoverableError(error) {
    $fb2b12fdc6fd9506$var$reportGlobalError(error);
}
function $fb2b12fdc6fd9506$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $fb2b12fdc6fd9506$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $fb2b12fdc6fd9506$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $fb2b12fdc6fd9506$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $fb2b12fdc6fd9506$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $fb2b12fdc6fd9506$var$createClassErrorUpdate(lane) {
    lane = $fb2b12fdc6fd9506$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $fb2b12fdc6fd9506$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $fb2b12fdc6fd9506$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $fb2b12fdc6fd9506$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $fb2b12fdc6fd9506$var$legacyErrorBoundariesThatAlreadyFailed ? $fb2b12fdc6fd9506$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $fb2b12fdc6fd9506$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $fb2b12fdc6fd9506$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $fb2b12fdc6fd9506$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $fb2b12fdc6fd9506$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $fb2b12fdc6fd9506$var$shellBoundary ? $fb2b12fdc6fd9506$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $fb2b12fdc6fd9506$var$workInProgressRootExitStatus && ($fb2b12fdc6fd9506$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $fb2b12fdc6fd9506$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $fb2b12fdc6fd9506$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $fb2b12fdc6fd9506$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $fb2b12fdc6fd9506$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $fb2b12fdc6fd9506$var$attachPingListener(root, value, rootRenderLanes);
        $fb2b12fdc6fd9506$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($fb2b12fdc6fd9506$var$isHydrating) return returnFiber = $fb2b12fdc6fd9506$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $fb2b12fdc6fd9506$var$HydrationMismatchException && (root = Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(422), {
        cause: value
    }), $fb2b12fdc6fd9506$var$queueHydrationError($fb2b12fdc6fd9506$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $fb2b12fdc6fd9506$var$HydrationMismatchException && (returnFiber = Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(423), {
        cause: value
    }), $fb2b12fdc6fd9506$var$queueHydrationError($fb2b12fdc6fd9506$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $fb2b12fdc6fd9506$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $fb2b12fdc6fd9506$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $fb2b12fdc6fd9506$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $fb2b12fdc6fd9506$var$workInProgressRootExitStatus && ($fb2b12fdc6fd9506$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $fb2b12fdc6fd9506$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $fb2b12fdc6fd9506$var$workInProgressRootConcurrentErrors ? $fb2b12fdc6fd9506$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $fb2b12fdc6fd9506$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $fb2b12fdc6fd9506$var$workInProgressRootExitStatus && ($fb2b12fdc6fd9506$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $fb2b12fdc6fd9506$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $fb2b12fdc6fd9506$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $fb2b12fdc6fd9506$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $fb2b12fdc6fd9506$var$legacyErrorBoundariesThatAlreadyFailed || !$fb2b12fdc6fd9506$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $fb2b12fdc6fd9506$var$createClassErrorUpdate(rootRenderLanes), $fb2b12fdc6fd9506$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $fb2b12fdc6fd9506$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $fb2b12fdc6fd9506$var$SelectiveHydrationException = Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(461)), $fb2b12fdc6fd9506$var$didReceiveUpdate = !1;
function $fb2b12fdc6fd9506$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $fb2b12fdc6fd9506$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $fb2b12fdc6fd9506$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $fb2b12fdc6fd9506$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $fb2b12fdc6fd9506$var$prepareToReadContext(workInProgress);
    nextProps = $fb2b12fdc6fd9506$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $fb2b12fdc6fd9506$var$checkDidRenderIdHook();
    if (null !== current && !$fb2b12fdc6fd9506$var$didReceiveUpdate) return $fb2b12fdc6fd9506$var$bailoutHooks(current, workInProgress, renderLanes), $fb2b12fdc6fd9506$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $fb2b12fdc6fd9506$var$isHydrating && key && $fb2b12fdc6fd9506$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $fb2b12fdc6fd9506$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $fb2b12fdc6fd9506$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$fb2b12fdc6fd9506$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $fb2b12fdc6fd9506$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $fb2b12fdc6fd9506$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$fb2b12fdc6fd9506$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $fb2b12fdc6fd9506$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $fb2b12fdc6fd9506$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $fb2b12fdc6fd9506$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $fb2b12fdc6fd9506$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($fb2b12fdc6fd9506$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($fb2b12fdc6fd9506$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $fb2b12fdc6fd9506$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($fb2b12fdc6fd9506$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $fb2b12fdc6fd9506$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $fb2b12fdc6fd9506$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $fb2b12fdc6fd9506$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $fb2b12fdc6fd9506$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $fb2b12fdc6fd9506$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $fb2b12fdc6fd9506$var$pushHiddenContext(workInProgress, prevState) : $fb2b12fdc6fd9506$var$reuseHiddenContextOnStack(), $fb2b12fdc6fd9506$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $fb2b12fdc6fd9506$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($fb2b12fdc6fd9506$var$pushTransition(workInProgress, prevState.cachePool), $fb2b12fdc6fd9506$var$pushHiddenContext(workInProgress, prevState), $fb2b12fdc6fd9506$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $fb2b12fdc6fd9506$var$pushTransition(workInProgress, null), $fb2b12fdc6fd9506$var$reuseHiddenContextOnStack(), $fb2b12fdc6fd9506$var$reuseSuspenseHandlerOnStack(workInProgress));
    $fb2b12fdc6fd9506$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $fb2b12fdc6fd9506$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $fb2b12fdc6fd9506$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $fb2b12fdc6fd9506$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $fb2b12fdc6fd9506$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $fb2b12fdc6fd9506$var$pushTransition(workInProgress, null);
    $fb2b12fdc6fd9506$var$reuseHiddenContextOnStack();
    $fb2b12fdc6fd9506$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $fb2b12fdc6fd9506$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $fb2b12fdc6fd9506$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $fb2b12fdc6fd9506$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $fb2b12fdc6fd9506$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $fb2b12fdc6fd9506$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $fb2b12fdc6fd9506$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $fb2b12fdc6fd9506$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $fb2b12fdc6fd9506$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($fb2b12fdc6fd9506$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $fb2b12fdc6fd9506$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $fb2b12fdc6fd9506$var$bailoutOffscreenComponent(null, current);
            $fb2b12fdc6fd9506$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $fb2b12fdc6fd9506$var$nextHydratableInstance) ? (current = $fb2b12fdc6fd9506$var$canHydrateHydrationBoundary(current, $fb2b12fdc6fd9506$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $fb2b12fdc6fd9506$var$treeContextProvider ? {
                    id: $fb2b12fdc6fd9506$var$treeContextId,
                    overflow: $fb2b12fdc6fd9506$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $fb2b12fdc6fd9506$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $fb2b12fdc6fd9506$var$hydrationParentFiber = workInProgress, $fb2b12fdc6fd9506$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $fb2b12fdc6fd9506$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $fb2b12fdc6fd9506$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $fb2b12fdc6fd9506$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $fb2b12fdc6fd9506$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(558));
        } else if ($fb2b12fdc6fd9506$var$didReceiveUpdate || $fb2b12fdc6fd9506$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $fb2b12fdc6fd9506$var$didReceiveUpdate || didSuspend) {
            nextProps = $fb2b12fdc6fd9506$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $fb2b12fdc6fd9506$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $fb2b12fdc6fd9506$var$enqueueConcurrentRenderForLane(current, dehydrated), $fb2b12fdc6fd9506$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $fb2b12fdc6fd9506$var$SelectiveHydrationException;
            $fb2b12fdc6fd9506$var$renderDidSuspendDelayIfPossible();
            workInProgress = $fb2b12fdc6fd9506$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $fb2b12fdc6fd9506$var$nextHydratableInstance = $fb2b12fdc6fd9506$var$getNextHydratable(dehydrated.nextSibling), $fb2b12fdc6fd9506$var$hydrationParentFiber = workInProgress, $fb2b12fdc6fd9506$var$isHydrating = !0, $fb2b12fdc6fd9506$var$hydrationErrors = null, $fb2b12fdc6fd9506$var$rootOrSingletonContext = !1, null !== current && $fb2b12fdc6fd9506$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $fb2b12fdc6fd9506$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $fb2b12fdc6fd9506$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $fb2b12fdc6fd9506$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $fb2b12fdc6fd9506$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $fb2b12fdc6fd9506$var$prepareToReadContext(workInProgress);
    Component = $fb2b12fdc6fd9506$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $fb2b12fdc6fd9506$var$checkDidRenderIdHook();
    if (null !== current && !$fb2b12fdc6fd9506$var$didReceiveUpdate) return $fb2b12fdc6fd9506$var$bailoutHooks(current, workInProgress, renderLanes), $fb2b12fdc6fd9506$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $fb2b12fdc6fd9506$var$isHydrating && nextProps && $fb2b12fdc6fd9506$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $fb2b12fdc6fd9506$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $fb2b12fdc6fd9506$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $fb2b12fdc6fd9506$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $fb2b12fdc6fd9506$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $fb2b12fdc6fd9506$var$finishRenderingHooks(current);
    Component = $fb2b12fdc6fd9506$var$checkDidRenderIdHook();
    if (null !== current && !$fb2b12fdc6fd9506$var$didReceiveUpdate) return $fb2b12fdc6fd9506$var$bailoutHooks(current, workInProgress, renderLanes), $fb2b12fdc6fd9506$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $fb2b12fdc6fd9506$var$isHydrating && Component && $fb2b12fdc6fd9506$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $fb2b12fdc6fd9506$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $fb2b12fdc6fd9506$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $fb2b12fdc6fd9506$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $fb2b12fdc6fd9506$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $fb2b12fdc6fd9506$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $fb2b12fdc6fd9506$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $fb2b12fdc6fd9506$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $fb2b12fdc6fd9506$var$readContext(contextType) : $fb2b12fdc6fd9506$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($fb2b12fdc6fd9506$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $fb2b12fdc6fd9506$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $fb2b12fdc6fd9506$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $fb2b12fdc6fd9506$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $fb2b12fdc6fd9506$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $fb2b12fdc6fd9506$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $fb2b12fdc6fd9506$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $fb2b12fdc6fd9506$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $fb2b12fdc6fd9506$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $fb2b12fdc6fd9506$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $fb2b12fdc6fd9506$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $fb2b12fdc6fd9506$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($fb2b12fdc6fd9506$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $fb2b12fdc6fd9506$var$hasForceUpdate || $fb2b12fdc6fd9506$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $fb2b12fdc6fd9506$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $fb2b12fdc6fd9506$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $fb2b12fdc6fd9506$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $fb2b12fdc6fd9506$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $fb2b12fdc6fd9506$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $fb2b12fdc6fd9506$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $fb2b12fdc6fd9506$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $fb2b12fdc6fd9506$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $fb2b12fdc6fd9506$var$hasForceUpdate || null !== current && null !== current.dependencies && $fb2b12fdc6fd9506$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($fb2b12fdc6fd9506$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $fb2b12fdc6fd9506$var$hasForceUpdate || $fb2b12fdc6fd9506$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $fb2b12fdc6fd9506$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $fb2b12fdc6fd9506$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $fb2b12fdc6fd9506$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $fb2b12fdc6fd9506$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $fb2b12fdc6fd9506$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $fb2b12fdc6fd9506$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $fb2b12fdc6fd9506$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $fb2b12fdc6fd9506$var$resetHydrationState();
    workInProgress.flags |= 256;
    $fb2b12fdc6fd9506$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $fb2b12fdc6fd9506$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $fb2b12fdc6fd9506$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $fb2b12fdc6fd9506$var$getSuspendedCache()
    };
}
function $fb2b12fdc6fd9506$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $fb2b12fdc6fd9506$var$workInProgressDeferredLane);
    return current;
}
function $fb2b12fdc6fd9506$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($fb2b12fdc6fd9506$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($fb2b12fdc6fd9506$var$isHydrating) {
            showFallback ? $fb2b12fdc6fd9506$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $fb2b12fdc6fd9506$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $fb2b12fdc6fd9506$var$nextHydratableInstance) ? (current = $fb2b12fdc6fd9506$var$canHydrateHydrationBoundary(current, $fb2b12fdc6fd9506$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $fb2b12fdc6fd9506$var$treeContextProvider ? {
                    id: $fb2b12fdc6fd9506$var$treeContextId,
                    overflow: $fb2b12fdc6fd9506$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $fb2b12fdc6fd9506$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $fb2b12fdc6fd9506$var$hydrationParentFiber = workInProgress, $fb2b12fdc6fd9506$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $fb2b12fdc6fd9506$var$throwOnHydrationMismatch(workInProgress);
            $fb2b12fdc6fd9506$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $fb2b12fdc6fd9506$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $fb2b12fdc6fd9506$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $fb2b12fdc6fd9506$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $fb2b12fdc6fd9506$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $fb2b12fdc6fd9506$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $fb2b12fdc6fd9506$var$SUSPENDED_MARKER, $fb2b12fdc6fd9506$var$bailoutOffscreenComponent(null, nextProps);
        $fb2b12fdc6fd9506$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $fb2b12fdc6fd9506$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($fb2b12fdc6fd9506$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $fb2b12fdc6fd9506$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($fb2b12fdc6fd9506$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($fb2b12fdc6fd9506$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $fb2b12fdc6fd9506$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $fb2b12fdc6fd9506$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $fb2b12fdc6fd9506$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $fb2b12fdc6fd9506$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $fb2b12fdc6fd9506$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $fb2b12fdc6fd9506$var$SUSPENDED_MARKER, workInProgress = $fb2b12fdc6fd9506$var$bailoutOffscreenComponent(null, nextProps));
        else if ($fb2b12fdc6fd9506$var$pushPrimaryTreeSuspenseHandler(workInProgress), $fb2b12fdc6fd9506$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $fb2b12fdc6fd9506$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $fb2b12fdc6fd9506$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($fb2b12fdc6fd9506$var$didReceiveUpdate || $fb2b12fdc6fd9506$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $fb2b12fdc6fd9506$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $fb2b12fdc6fd9506$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $fb2b12fdc6fd9506$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $fb2b12fdc6fd9506$var$enqueueConcurrentRenderForLane(current, nextProps), $fb2b12fdc6fd9506$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $fb2b12fdc6fd9506$var$SelectiveHydrationException;
            $fb2b12fdc6fd9506$var$isSuspenseInstancePending(nextPrimaryChildren) || $fb2b12fdc6fd9506$var$renderDidSuspendDelayIfPossible();
            workInProgress = $fb2b12fdc6fd9506$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $fb2b12fdc6fd9506$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $fb2b12fdc6fd9506$var$nextHydratableInstance = $fb2b12fdc6fd9506$var$getNextHydratable(nextPrimaryChildren.nextSibling), $fb2b12fdc6fd9506$var$hydrationParentFiber = workInProgress, $fb2b12fdc6fd9506$var$isHydrating = !0, $fb2b12fdc6fd9506$var$hydrationErrors = null, $fb2b12fdc6fd9506$var$rootOrSingletonContext = !1, null !== current && $fb2b12fdc6fd9506$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $fb2b12fdc6fd9506$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $fb2b12fdc6fd9506$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $fb2b12fdc6fd9506$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $fb2b12fdc6fd9506$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $fb2b12fdc6fd9506$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $fb2b12fdc6fd9506$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $fb2b12fdc6fd9506$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $fb2b12fdc6fd9506$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $fb2b12fdc6fd9506$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $fb2b12fdc6fd9506$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $fb2b12fdc6fd9506$var$SUSPENDED_MARKER, $fb2b12fdc6fd9506$var$bailoutOffscreenComponent(current.child, nextProps);
    $fb2b12fdc6fd9506$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $fb2b12fdc6fd9506$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $fb2b12fdc6fd9506$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $fb2b12fdc6fd9506$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $fb2b12fdc6fd9506$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $fb2b12fdc6fd9506$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $fb2b12fdc6fd9506$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $fb2b12fdc6fd9506$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $fb2b12fdc6fd9506$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $fb2b12fdc6fd9506$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $fb2b12fdc6fd9506$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $fb2b12fdc6fd9506$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $fb2b12fdc6fd9506$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $fb2b12fdc6fd9506$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $fb2b12fdc6fd9506$var$push($fb2b12fdc6fd9506$var$suspenseStackCursor, suspenseContext);
    $fb2b12fdc6fd9506$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $fb2b12fdc6fd9506$var$isHydrating ? $fb2b12fdc6fd9506$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $fb2b12fdc6fd9506$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $fb2b12fdc6fd9506$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $fb2b12fdc6fd9506$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $fb2b12fdc6fd9506$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $fb2b12fdc6fd9506$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $fb2b12fdc6fd9506$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $fb2b12fdc6fd9506$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $fb2b12fdc6fd9506$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $fb2b12fdc6fd9506$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($fb2b12fdc6fd9506$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $fb2b12fdc6fd9506$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $fb2b12fdc6fd9506$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $fb2b12fdc6fd9506$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $fb2b12fdc6fd9506$var$checkIfContextChanged(current) ? !0 : !1;
}
function $fb2b12fdc6fd9506$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $fb2b12fdc6fd9506$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $fb2b12fdc6fd9506$var$pushProvider(workInProgress, $fb2b12fdc6fd9506$var$CacheContext, current.memoizedState.cache);
            $fb2b12fdc6fd9506$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $fb2b12fdc6fd9506$var$pushHostContext(workInProgress);
            break;
        case 4:
            $fb2b12fdc6fd9506$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $fb2b12fdc6fd9506$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $fb2b12fdc6fd9506$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $fb2b12fdc6fd9506$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $fb2b12fdc6fd9506$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $fb2b12fdc6fd9506$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $fb2b12fdc6fd9506$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $fb2b12fdc6fd9506$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($fb2b12fdc6fd9506$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $fb2b12fdc6fd9506$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $fb2b12fdc6fd9506$var$push($fb2b12fdc6fd9506$var$suspenseStackCursor, $fb2b12fdc6fd9506$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $fb2b12fdc6fd9506$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $fb2b12fdc6fd9506$var$pushProvider(workInProgress, $fb2b12fdc6fd9506$var$CacheContext, current.memoizedState.cache);
    }
    return $fb2b12fdc6fd9506$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $fb2b12fdc6fd9506$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $fb2b12fdc6fd9506$var$didReceiveUpdate = !0;
        else {
            if (!$fb2b12fdc6fd9506$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $fb2b12fdc6fd9506$var$didReceiveUpdate = !1, $fb2b12fdc6fd9506$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $fb2b12fdc6fd9506$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $fb2b12fdc6fd9506$var$didReceiveUpdate = !1, $fb2b12fdc6fd9506$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $fb2b12fdc6fd9506$var$pushTreeId(workInProgress, $fb2b12fdc6fd9506$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $fb2b12fdc6fd9506$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $fb2b12fdc6fd9506$var$shouldConstruct(current) ? (props = $fb2b12fdc6fd9506$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $fb2b12fdc6fd9506$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $fb2b12fdc6fd9506$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $fb2b12fdc6fd9506$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $fb2b12fdc6fd9506$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $fb2b12fdc6fd9506$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $fb2b12fdc6fd9506$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $fb2b12fdc6fd9506$var$getComponentNameFromType(current) || current;
                    throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $fb2b12fdc6fd9506$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $fb2b12fdc6fd9506$var$resolveClassComponentProps(props, workInProgress.pendingProps), $fb2b12fdc6fd9506$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $fb2b12fdc6fd9506$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $fb2b12fdc6fd9506$var$cloneUpdateQueue(current, workInProgress);
                $fb2b12fdc6fd9506$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $fb2b12fdc6fd9506$var$pushProvider(workInProgress, $fb2b12fdc6fd9506$var$CacheContext, props);
                props !== prevState.cache && $fb2b12fdc6fd9506$var$propagateContextChanges(workInProgress, [
                    $fb2b12fdc6fd9506$var$CacheContext
                ], renderLanes, !0);
                $fb2b12fdc6fd9506$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $fb2b12fdc6fd9506$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $fb2b12fdc6fd9506$var$createCapturedValueAtFiber(Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(424)), workInProgress);
                        $fb2b12fdc6fd9506$var$queueHydrationError($$typeof);
                        workInProgress = $fb2b12fdc6fd9506$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $fb2b12fdc6fd9506$var$nextHydratableInstance = $fb2b12fdc6fd9506$var$getNextHydratable(current.firstChild);
                        $fb2b12fdc6fd9506$var$hydrationParentFiber = workInProgress;
                        $fb2b12fdc6fd9506$var$isHydrating = !0;
                        $fb2b12fdc6fd9506$var$hydrationErrors = null;
                        $fb2b12fdc6fd9506$var$rootOrSingletonContext = !0;
                        renderLanes = $fb2b12fdc6fd9506$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $fb2b12fdc6fd9506$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $fb2b12fdc6fd9506$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $fb2b12fdc6fd9506$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $fb2b12fdc6fd9506$var$markRef(current, workInProgress), null === current ? (renderLanes = $fb2b12fdc6fd9506$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $fb2b12fdc6fd9506$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $fb2b12fdc6fd9506$var$getOwnerDocumentFromRootContainer($fb2b12fdc6fd9506$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$fb2b12fdc6fd9506$var$internalInstanceKey] = workInProgress, props[$fb2b12fdc6fd9506$var$internalPropsKey] = current, $fb2b12fdc6fd9506$var$setInitialProperties(props, renderLanes, current), $fb2b12fdc6fd9506$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $fb2b12fdc6fd9506$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $fb2b12fdc6fd9506$var$pushHostContext(workInProgress), null === current && $fb2b12fdc6fd9506$var$isHydrating && (props = workInProgress.stateNode = $fb2b12fdc6fd9506$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $fb2b12fdc6fd9506$var$rootInstanceStackCursor.current), $fb2b12fdc6fd9506$var$hydrationParentFiber = workInProgress, $fb2b12fdc6fd9506$var$rootOrSingletonContext = !0, $$typeof = $fb2b12fdc6fd9506$var$nextHydratableInstance, $fb2b12fdc6fd9506$var$isSingletonScope(workInProgress.type) ? ($fb2b12fdc6fd9506$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $fb2b12fdc6fd9506$var$nextHydratableInstance = $fb2b12fdc6fd9506$var$getNextHydratable(props.firstChild)) : $fb2b12fdc6fd9506$var$nextHydratableInstance = $$typeof), $fb2b12fdc6fd9506$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $fb2b12fdc6fd9506$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $fb2b12fdc6fd9506$var$isHydrating) {
                if ($$typeof = props = $fb2b12fdc6fd9506$var$nextHydratableInstance) props = $fb2b12fdc6fd9506$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $fb2b12fdc6fd9506$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $fb2b12fdc6fd9506$var$hydrationParentFiber = workInProgress, $fb2b12fdc6fd9506$var$nextHydratableInstance = $fb2b12fdc6fd9506$var$getNextHydratable(props.firstChild), $fb2b12fdc6fd9506$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $fb2b12fdc6fd9506$var$throwOnHydrationMismatch(workInProgress);
            }
            $fb2b12fdc6fd9506$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $fb2b12fdc6fd9506$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $fb2b12fdc6fd9506$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $fb2b12fdc6fd9506$var$renderWithHooks(current, workInProgress, $fb2b12fdc6fd9506$var$TransitionAwareHostComponent, null, null, renderLanes), $fb2b12fdc6fd9506$var$HostTransitionContext._currentValue = $$typeof);
            $fb2b12fdc6fd9506$var$markRef(current, workInProgress);
            $fb2b12fdc6fd9506$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $fb2b12fdc6fd9506$var$isHydrating) {
                if (current = renderLanes = $fb2b12fdc6fd9506$var$nextHydratableInstance) renderLanes = $fb2b12fdc6fd9506$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $fb2b12fdc6fd9506$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $fb2b12fdc6fd9506$var$hydrationParentFiber = workInProgress, $fb2b12fdc6fd9506$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $fb2b12fdc6fd9506$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $fb2b12fdc6fd9506$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $fb2b12fdc6fd9506$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $fb2b12fdc6fd9506$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $fb2b12fdc6fd9506$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $fb2b12fdc6fd9506$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $fb2b12fdc6fd9506$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $fb2b12fdc6fd9506$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $fb2b12fdc6fd9506$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $fb2b12fdc6fd9506$var$pushProvider(workInProgress, workInProgress.type, props.value), $fb2b12fdc6fd9506$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $fb2b12fdc6fd9506$var$prepareToReadContext(workInProgress), $$typeof = $fb2b12fdc6fd9506$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $fb2b12fdc6fd9506$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $fb2b12fdc6fd9506$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $fb2b12fdc6fd9506$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $fb2b12fdc6fd9506$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $fb2b12fdc6fd9506$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $fb2b12fdc6fd9506$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $fb2b12fdc6fd9506$var$prepareToReadContext(workInProgress), props = $fb2b12fdc6fd9506$var$readContext($fb2b12fdc6fd9506$var$CacheContext), null === current ? ($$typeof = $fb2b12fdc6fd9506$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $fb2b12fdc6fd9506$var$workInProgressRoot, prevState = $fb2b12fdc6fd9506$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $fb2b12fdc6fd9506$var$initializeUpdateQueue(workInProgress), $fb2b12fdc6fd9506$var$pushProvider(workInProgress, $fb2b12fdc6fd9506$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($fb2b12fdc6fd9506$var$cloneUpdateQueue(current, workInProgress), $fb2b12fdc6fd9506$var$processUpdateQueue(workInProgress, null, null, renderLanes), $fb2b12fdc6fd9506$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $fb2b12fdc6fd9506$var$pushProvider(workInProgress, $fb2b12fdc6fd9506$var$CacheContext, props)) : (props = prevState.cache, $fb2b12fdc6fd9506$var$pushProvider(workInProgress, $fb2b12fdc6fd9506$var$CacheContext, props), props !== $$typeof.cache && $fb2b12fdc6fd9506$var$propagateContextChanges(workInProgress, [
                $fb2b12fdc6fd9506$var$CacheContext
            ], renderLanes, !0))), $fb2b12fdc6fd9506$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $fb2b12fdc6fd9506$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $fb2b12fdc6fd9506$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($fb2b12fdc6fd9506$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $fb2b12fdc6fd9506$var$suspendedThenable = $fb2b12fdc6fd9506$var$noopSuspenseyCommitThenable, $fb2b12fdc6fd9506$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $fb2b12fdc6fd9506$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$fb2b12fdc6fd9506$var$preloadResource(resource)) {
        if ($fb2b12fdc6fd9506$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $fb2b12fdc6fd9506$var$suspendedThenable = $fb2b12fdc6fd9506$var$noopSuspenseyCommitThenable, $fb2b12fdc6fd9506$var$SuspenseyCommitException;
    }
}
function $fb2b12fdc6fd9506$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $fb2b12fdc6fd9506$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $fb2b12fdc6fd9506$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $fb2b12fdc6fd9506$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$fb2b12fdc6fd9506$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $fb2b12fdc6fd9506$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $fb2b12fdc6fd9506$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $fb2b12fdc6fd9506$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $fb2b12fdc6fd9506$var$bubbleProperties(workInProgress), null;
        case 1:
            return $fb2b12fdc6fd9506$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $fb2b12fdc6fd9506$var$popProvider($fb2b12fdc6fd9506$var$CacheContext);
            $fb2b12fdc6fd9506$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $fb2b12fdc6fd9506$var$popHydrationState(workInProgress) ? $fb2b12fdc6fd9506$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $fb2b12fdc6fd9506$var$upgradeHydrationErrorsToRecoverable());
            $fb2b12fdc6fd9506$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($fb2b12fdc6fd9506$var$markUpdate(workInProgress), null !== nextResource ? ($fb2b12fdc6fd9506$var$bubbleProperties(workInProgress), $fb2b12fdc6fd9506$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($fb2b12fdc6fd9506$var$bubbleProperties(workInProgress), $fb2b12fdc6fd9506$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($fb2b12fdc6fd9506$var$markUpdate(workInProgress), $fb2b12fdc6fd9506$var$bubbleProperties(workInProgress), $fb2b12fdc6fd9506$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($fb2b12fdc6fd9506$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $fb2b12fdc6fd9506$var$markUpdate(workInProgress), $fb2b12fdc6fd9506$var$bubbleProperties(workInProgress), $fb2b12fdc6fd9506$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $fb2b12fdc6fd9506$var$popHostContext(workInProgress);
            renderLanes = $fb2b12fdc6fd9506$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $fb2b12fdc6fd9506$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(166));
                    $fb2b12fdc6fd9506$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $fb2b12fdc6fd9506$var$contextStackCursor.current;
                $fb2b12fdc6fd9506$var$popHydrationState(workInProgress) ? $fb2b12fdc6fd9506$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $fb2b12fdc6fd9506$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $fb2b12fdc6fd9506$var$markUpdate(workInProgress));
            }
            $fb2b12fdc6fd9506$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $fb2b12fdc6fd9506$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $fb2b12fdc6fd9506$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(166));
                    $fb2b12fdc6fd9506$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $fb2b12fdc6fd9506$var$contextStackCursor.current;
                if ($fb2b12fdc6fd9506$var$popHydrationState(workInProgress)) $fb2b12fdc6fd9506$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $fb2b12fdc6fd9506$var$getOwnerDocumentFromRootContainer($fb2b12fdc6fd9506$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$fb2b12fdc6fd9506$var$internalInstanceKey] = workInProgress;
                    nextResource[$fb2b12fdc6fd9506$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($fb2b12fdc6fd9506$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $fb2b12fdc6fd9506$var$markUpdate(workInProgress);
                }
            }
            $fb2b12fdc6fd9506$var$bubbleProperties(workInProgress);
            $fb2b12fdc6fd9506$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $fb2b12fdc6fd9506$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(166));
                current = $fb2b12fdc6fd9506$var$rootInstanceStackCursor.current;
                if ($fb2b12fdc6fd9506$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $fb2b12fdc6fd9506$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$fb2b12fdc6fd9506$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $fb2b12fdc6fd9506$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $fb2b12fdc6fd9506$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $fb2b12fdc6fd9506$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$fb2b12fdc6fd9506$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $fb2b12fdc6fd9506$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $fb2b12fdc6fd9506$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(557));
                        current[$fb2b12fdc6fd9506$var$internalInstanceKey] = workInProgress;
                    } else $fb2b12fdc6fd9506$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $fb2b12fdc6fd9506$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $fb2b12fdc6fd9506$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $fb2b12fdc6fd9506$var$popSuspenseHandler(workInProgress), workInProgress;
                    $fb2b12fdc6fd9506$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(558));
            }
            $fb2b12fdc6fd9506$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $fb2b12fdc6fd9506$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(317));
                        type[$fb2b12fdc6fd9506$var$internalInstanceKey] = workInProgress;
                    } else $fb2b12fdc6fd9506$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $fb2b12fdc6fd9506$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $fb2b12fdc6fd9506$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $fb2b12fdc6fd9506$var$popSuspenseHandler(workInProgress), workInProgress;
                    $fb2b12fdc6fd9506$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $fb2b12fdc6fd9506$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $fb2b12fdc6fd9506$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $fb2b12fdc6fd9506$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $fb2b12fdc6fd9506$var$popHostContainer(), null === current && $fb2b12fdc6fd9506$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $fb2b12fdc6fd9506$var$bubbleProperties(workInProgress), null;
        case 10:
            return $fb2b12fdc6fd9506$var$popProvider(workInProgress.type), $fb2b12fdc6fd9506$var$bubbleProperties(workInProgress), null;
        case 19:
            $fb2b12fdc6fd9506$var$pop($fb2b12fdc6fd9506$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $fb2b12fdc6fd9506$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $fb2b12fdc6fd9506$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $fb2b12fdc6fd9506$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $fb2b12fdc6fd9506$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $fb2b12fdc6fd9506$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $fb2b12fdc6fd9506$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$fb2b12fdc6fd9506$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $fb2b12fdc6fd9506$var$push($fb2b12fdc6fd9506$var$suspenseStackCursor, $fb2b12fdc6fd9506$var$suspenseStackCursor.current & 1 | 2);
                            $fb2b12fdc6fd9506$var$isHydrating && $fb2b12fdc6fd9506$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $fb2b12fdc6fd9506$var$now() > $fb2b12fdc6fd9506$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $fb2b12fdc6fd9506$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $fb2b12fdc6fd9506$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $fb2b12fdc6fd9506$var$scheduleRetryEffect(workInProgress, current), $fb2b12fdc6fd9506$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$fb2b12fdc6fd9506$var$isHydrating) return $fb2b12fdc6fd9506$var$bubbleProperties(workInProgress), null;
                    } else 2 * $fb2b12fdc6fd9506$var$now() - newProps.renderingStartTime > $fb2b12fdc6fd9506$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $fb2b12fdc6fd9506$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $fb2b12fdc6fd9506$var$now(), current.sibling = null, renderLanes = $fb2b12fdc6fd9506$var$suspenseStackCursor.current, $fb2b12fdc6fd9506$var$push($fb2b12fdc6fd9506$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $fb2b12fdc6fd9506$var$isHydrating && $fb2b12fdc6fd9506$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $fb2b12fdc6fd9506$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $fb2b12fdc6fd9506$var$popSuspenseHandler(workInProgress), $fb2b12fdc6fd9506$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($fb2b12fdc6fd9506$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $fb2b12fdc6fd9506$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $fb2b12fdc6fd9506$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $fb2b12fdc6fd9506$var$pop($fb2b12fdc6fd9506$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $fb2b12fdc6fd9506$var$popProvider($fb2b12fdc6fd9506$var$CacheContext), $fb2b12fdc6fd9506$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $fb2b12fdc6fd9506$var$unwindWork(current, workInProgress) {
    $fb2b12fdc6fd9506$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $fb2b12fdc6fd9506$var$popProvider($fb2b12fdc6fd9506$var$CacheContext), $fb2b12fdc6fd9506$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $fb2b12fdc6fd9506$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $fb2b12fdc6fd9506$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(340));
                $fb2b12fdc6fd9506$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $fb2b12fdc6fd9506$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(340));
                $fb2b12fdc6fd9506$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $fb2b12fdc6fd9506$var$pop($fb2b12fdc6fd9506$var$suspenseStackCursor), null;
        case 4:
            return $fb2b12fdc6fd9506$var$popHostContainer(), null;
        case 10:
            return $fb2b12fdc6fd9506$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $fb2b12fdc6fd9506$var$popSuspenseHandler(workInProgress), $fb2b12fdc6fd9506$var$popHiddenContext(), null !== current && $fb2b12fdc6fd9506$var$pop($fb2b12fdc6fd9506$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $fb2b12fdc6fd9506$var$popProvider($fb2b12fdc6fd9506$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $fb2b12fdc6fd9506$var$unwindInterruptedWork(current, interruptedWork) {
    $fb2b12fdc6fd9506$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $fb2b12fdc6fd9506$var$popProvider($fb2b12fdc6fd9506$var$CacheContext);
            $fb2b12fdc6fd9506$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $fb2b12fdc6fd9506$var$popHostContext(interruptedWork);
            break;
        case 4:
            $fb2b12fdc6fd9506$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $fb2b12fdc6fd9506$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $fb2b12fdc6fd9506$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $fb2b12fdc6fd9506$var$pop($fb2b12fdc6fd9506$var$suspenseStackCursor);
            break;
        case 10:
            $fb2b12fdc6fd9506$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $fb2b12fdc6fd9506$var$popSuspenseHandler(interruptedWork);
            $fb2b12fdc6fd9506$var$popHiddenContext();
            null !== current && $fb2b12fdc6fd9506$var$pop($fb2b12fdc6fd9506$var$resumedCache);
            break;
        case 24:
            $fb2b12fdc6fd9506$var$popProvider($fb2b12fdc6fd9506$var$CacheContext);
    }
}
function $fb2b12fdc6fd9506$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $fb2b12fdc6fd9506$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $fb2b12fdc6fd9506$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $fb2b12fdc6fd9506$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $fb2b12fdc6fd9506$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $fb2b12fdc6fd9506$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $fb2b12fdc6fd9506$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $fb2b12fdc6fd9506$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $fb2b12fdc6fd9506$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $fb2b12fdc6fd9506$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $fb2b12fdc6fd9506$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $fb2b12fdc6fd9506$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $fb2b12fdc6fd9506$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $fb2b12fdc6fd9506$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $fb2b12fdc6fd9506$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $fb2b12fdc6fd9506$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $fb2b12fdc6fd9506$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $fb2b12fdc6fd9506$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $fb2b12fdc6fd9506$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $fb2b12fdc6fd9506$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$fb2b12fdc6fd9506$var$internalPropsKey] = newProps;
    } catch (error) {
        $fb2b12fdc6fd9506$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $fb2b12fdc6fd9506$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $fb2b12fdc6fd9506$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $fb2b12fdc6fd9506$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $fb2b12fdc6fd9506$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $fb2b12fdc6fd9506$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $fb2b12fdc6fd9506$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $fb2b12fdc6fd9506$var$noop$1));
    else if (4 !== tag && (27 === tag && $fb2b12fdc6fd9506$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($fb2b12fdc6fd9506$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$fb2b12fdc6fd9506$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $fb2b12fdc6fd9506$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $fb2b12fdc6fd9506$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($fb2b12fdc6fd9506$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$fb2b12fdc6fd9506$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $fb2b12fdc6fd9506$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $fb2b12fdc6fd9506$var$setInitialProperties(singleton, type, props);
        singleton[$fb2b12fdc6fd9506$var$internalInstanceKey] = finishedWork;
        singleton[$fb2b12fdc6fd9506$var$internalPropsKey] = props;
    } catch (error) {
        $fb2b12fdc6fd9506$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $fb2b12fdc6fd9506$var$offscreenSubtreeIsHidden = !1, $fb2b12fdc6fd9506$var$offscreenSubtreeWasHidden = !1, $fb2b12fdc6fd9506$var$needsFormReset = !1, $fb2b12fdc6fd9506$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $fb2b12fdc6fd9506$var$nextEffect = null;
function $fb2b12fdc6fd9506$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $fb2b12fdc6fd9506$var$eventsEnabled = $fb2b12fdc6fd9506$var$_enabled;
    root = $fb2b12fdc6fd9506$var$getActiveElementDeep(root);
    if ($fb2b12fdc6fd9506$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $fb2b12fdc6fd9506$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $fb2b12fdc6fd9506$var$_enabled = !1;
    for($fb2b12fdc6fd9506$var$nextEffect = firstChild; null !== $fb2b12fdc6fd9506$var$nextEffect;)if (firstChild = $fb2b12fdc6fd9506$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $fb2b12fdc6fd9506$var$nextEffect = root;
    else for(; null !== $fb2b12fdc6fd9506$var$nextEffect;){
        firstChild = $fb2b12fdc6fd9506$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $fb2b12fdc6fd9506$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $fb2b12fdc6fd9506$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $fb2b12fdc6fd9506$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $fb2b12fdc6fd9506$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $fb2b12fdc6fd9506$var$nextEffect = root;
            break;
        }
        $fb2b12fdc6fd9506$var$nextEffect = firstChild.return;
    }
}
function $fb2b12fdc6fd9506$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $fb2b12fdc6fd9506$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $fb2b12fdc6fd9506$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $fb2b12fdc6fd9506$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $fb2b12fdc6fd9506$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $fb2b12fdc6fd9506$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $fb2b12fdc6fd9506$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $fb2b12fdc6fd9506$var$commitClassCallbacks(finishedWork);
            flags & 512 && $fb2b12fdc6fd9506$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $fb2b12fdc6fd9506$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $fb2b12fdc6fd9506$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $fb2b12fdc6fd9506$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $fb2b12fdc6fd9506$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $fb2b12fdc6fd9506$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $fb2b12fdc6fd9506$var$commitHostMount(finishedWork);
            flags & 512 && $fb2b12fdc6fd9506$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $fb2b12fdc6fd9506$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $fb2b12fdc6fd9506$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $fb2b12fdc6fd9506$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $fb2b12fdc6fd9506$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $fb2b12fdc6fd9506$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $fb2b12fdc6fd9506$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $fb2b12fdc6fd9506$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $fb2b12fdc6fd9506$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $fb2b12fdc6fd9506$var$offscreenSubtreeWasHidden;
                prevProps = $fb2b12fdc6fd9506$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $fb2b12fdc6fd9506$var$offscreenSubtreeWasHidden;
                $fb2b12fdc6fd9506$var$offscreenSubtreeIsHidden = flags;
                ($fb2b12fdc6fd9506$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $fb2b12fdc6fd9506$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $fb2b12fdc6fd9506$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $fb2b12fdc6fd9506$var$offscreenSubtreeIsHidden = prevProps;
                $fb2b12fdc6fd9506$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $fb2b12fdc6fd9506$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $fb2b12fdc6fd9506$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $fb2b12fdc6fd9506$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $fb2b12fdc6fd9506$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $fb2b12fdc6fd9506$var$hostParent = null, $fb2b12fdc6fd9506$var$hostParentIsContainer = !1;
function $fb2b12fdc6fd9506$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$fb2b12fdc6fd9506$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $fb2b12fdc6fd9506$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($fb2b12fdc6fd9506$var$injectedHook && "function" === typeof $fb2b12fdc6fd9506$var$injectedHook.onCommitFiberUnmount) try {
        $fb2b12fdc6fd9506$var$injectedHook.onCommitFiberUnmount($fb2b12fdc6fd9506$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $fb2b12fdc6fd9506$var$offscreenSubtreeWasHidden || $fb2b12fdc6fd9506$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $fb2b12fdc6fd9506$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $fb2b12fdc6fd9506$var$offscreenSubtreeWasHidden || $fb2b12fdc6fd9506$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $fb2b12fdc6fd9506$var$hostParent, prevHostParentIsContainer = $fb2b12fdc6fd9506$var$hostParentIsContainer;
            $fb2b12fdc6fd9506$var$isSingletonScope(deletedFiber.type) && ($fb2b12fdc6fd9506$var$hostParent = deletedFiber.stateNode, $fb2b12fdc6fd9506$var$hostParentIsContainer = !1);
            $fb2b12fdc6fd9506$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $fb2b12fdc6fd9506$var$releaseSingletonInstance(deletedFiber.stateNode);
            $fb2b12fdc6fd9506$var$hostParent = prevHostParent;
            $fb2b12fdc6fd9506$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $fb2b12fdc6fd9506$var$offscreenSubtreeWasHidden || $fb2b12fdc6fd9506$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $fb2b12fdc6fd9506$var$hostParent;
            prevHostParentIsContainer = $fb2b12fdc6fd9506$var$hostParentIsContainer;
            $fb2b12fdc6fd9506$var$hostParent = null;
            $fb2b12fdc6fd9506$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $fb2b12fdc6fd9506$var$hostParent = prevHostParent;
            $fb2b12fdc6fd9506$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $fb2b12fdc6fd9506$var$hostParent) {
                if ($fb2b12fdc6fd9506$var$hostParentIsContainer) try {
                    (9 === $fb2b12fdc6fd9506$var$hostParent.nodeType ? $fb2b12fdc6fd9506$var$hostParent.body : "HTML" === $fb2b12fdc6fd9506$var$hostParent.nodeName ? $fb2b12fdc6fd9506$var$hostParent.ownerDocument.body : $fb2b12fdc6fd9506$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $fb2b12fdc6fd9506$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $fb2b12fdc6fd9506$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $fb2b12fdc6fd9506$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $fb2b12fdc6fd9506$var$hostParent && ($fb2b12fdc6fd9506$var$hostParentIsContainer ? (finishedRoot = $fb2b12fdc6fd9506$var$hostParent, $fb2b12fdc6fd9506$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $fb2b12fdc6fd9506$var$retryIfBlockedOn(finishedRoot)) : $fb2b12fdc6fd9506$var$clearHydrationBoundary($fb2b12fdc6fd9506$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $fb2b12fdc6fd9506$var$hostParent;
            prevHostParentIsContainer = $fb2b12fdc6fd9506$var$hostParentIsContainer;
            $fb2b12fdc6fd9506$var$hostParent = deletedFiber.stateNode.containerInfo;
            $fb2b12fdc6fd9506$var$hostParentIsContainer = !0;
            $fb2b12fdc6fd9506$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $fb2b12fdc6fd9506$var$hostParent = prevHostParent;
            $fb2b12fdc6fd9506$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $fb2b12fdc6fd9506$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $fb2b12fdc6fd9506$var$offscreenSubtreeWasHidden || $fb2b12fdc6fd9506$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $fb2b12fdc6fd9506$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $fb2b12fdc6fd9506$var$offscreenSubtreeWasHidden || ($fb2b12fdc6fd9506$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $fb2b12fdc6fd9506$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $fb2b12fdc6fd9506$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $fb2b12fdc6fd9506$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $fb2b12fdc6fd9506$var$offscreenSubtreeWasHidden = (prevHostParent = $fb2b12fdc6fd9506$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $fb2b12fdc6fd9506$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $fb2b12fdc6fd9506$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $fb2b12fdc6fd9506$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $fb2b12fdc6fd9506$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $fb2b12fdc6fd9506$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $fb2b12fdc6fd9506$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $fb2b12fdc6fd9506$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $fb2b12fdc6fd9506$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $fb2b12fdc6fd9506$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $fb2b12fdc6fd9506$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $fb2b12fdc6fd9506$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $fb2b12fdc6fd9506$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $fb2b12fdc6fd9506$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $fb2b12fdc6fd9506$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $fb2b12fdc6fd9506$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $fb2b12fdc6fd9506$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($fb2b12fdc6fd9506$var$isSingletonScope(parent.type)) {
                        $fb2b12fdc6fd9506$var$hostParent = parent.stateNode;
                        $fb2b12fdc6fd9506$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $fb2b12fdc6fd9506$var$hostParent = parent.stateNode;
                    $fb2b12fdc6fd9506$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $fb2b12fdc6fd9506$var$hostParent = parent.stateNode.containerInfo;
                    $fb2b12fdc6fd9506$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $fb2b12fdc6fd9506$var$hostParent) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(160));
        $fb2b12fdc6fd9506$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $fb2b12fdc6fd9506$var$hostParent = null;
        $fb2b12fdc6fd9506$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$fb2b12fdc6fd9506$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $fb2b12fdc6fd9506$var$currentHoistableRoot = null;
function $fb2b12fdc6fd9506$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $fb2b12fdc6fd9506$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $fb2b12fdc6fd9506$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($fb2b12fdc6fd9506$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $fb2b12fdc6fd9506$var$commitHookEffectListMount(3, finishedWork), $fb2b12fdc6fd9506$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $fb2b12fdc6fd9506$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $fb2b12fdc6fd9506$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($fb2b12fdc6fd9506$var$offscreenSubtreeWasHidden || null === current || $fb2b12fdc6fd9506$var$safelyDetachRef(current, current.return));
            flags & 64 && $fb2b12fdc6fd9506$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $fb2b12fdc6fd9506$var$currentHoistableRoot;
            $fb2b12fdc6fd9506$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $fb2b12fdc6fd9506$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($fb2b12fdc6fd9506$var$offscreenSubtreeWasHidden || null === current || $fb2b12fdc6fd9506$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$fb2b12fdc6fd9506$var$internalHoistableMarker] || currentResource[$fb2b12fdc6fd9506$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $fb2b12fdc6fd9506$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$fb2b12fdc6fd9506$var$internalInstanceKey] = finishedWork;
                                        $fb2b12fdc6fd9506$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $fb2b12fdc6fd9506$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $fb2b12fdc6fd9506$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $fb2b12fdc6fd9506$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $fb2b12fdc6fd9506$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$fb2b12fdc6fd9506$var$internalInstanceKey] = finishedWork;
                                $fb2b12fdc6fd9506$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $fb2b12fdc6fd9506$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $fb2b12fdc6fd9506$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $fb2b12fdc6fd9506$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $fb2b12fdc6fd9506$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $fb2b12fdc6fd9506$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $fb2b12fdc6fd9506$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $fb2b12fdc6fd9506$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($fb2b12fdc6fd9506$var$offscreenSubtreeWasHidden || null === current || $fb2b12fdc6fd9506$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $fb2b12fdc6fd9506$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $fb2b12fdc6fd9506$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $fb2b12fdc6fd9506$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($fb2b12fdc6fd9506$var$offscreenSubtreeWasHidden || null === current || $fb2b12fdc6fd9506$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $fb2b12fdc6fd9506$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $fb2b12fdc6fd9506$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $fb2b12fdc6fd9506$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($fb2b12fdc6fd9506$var$needsFormReset = !0);
            break;
        case 6:
            $fb2b12fdc6fd9506$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $fb2b12fdc6fd9506$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $fb2b12fdc6fd9506$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $fb2b12fdc6fd9506$var$tagCaches = null;
            hoistableRoot = $fb2b12fdc6fd9506$var$currentHoistableRoot;
            $fb2b12fdc6fd9506$var$currentHoistableRoot = $fb2b12fdc6fd9506$var$getHoistableRoot(root.containerInfo);
            $fb2b12fdc6fd9506$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $fb2b12fdc6fd9506$var$currentHoistableRoot = hoistableRoot;
            $fb2b12fdc6fd9506$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $fb2b12fdc6fd9506$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $fb2b12fdc6fd9506$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $fb2b12fdc6fd9506$var$needsFormReset && ($fb2b12fdc6fd9506$var$needsFormReset = !1, $fb2b12fdc6fd9506$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $fb2b12fdc6fd9506$var$currentHoistableRoot;
            $fb2b12fdc6fd9506$var$currentHoistableRoot = $fb2b12fdc6fd9506$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $fb2b12fdc6fd9506$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $fb2b12fdc6fd9506$var$commitReconciliationEffects(finishedWork);
            $fb2b12fdc6fd9506$var$currentHoistableRoot = flags;
            break;
        case 12:
            $fb2b12fdc6fd9506$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $fb2b12fdc6fd9506$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $fb2b12fdc6fd9506$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $fb2b12fdc6fd9506$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $fb2b12fdc6fd9506$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $fb2b12fdc6fd9506$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $fb2b12fdc6fd9506$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($fb2b12fdc6fd9506$var$globalMostRecentFallbackTime = $fb2b12fdc6fd9506$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $fb2b12fdc6fd9506$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $fb2b12fdc6fd9506$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $fb2b12fdc6fd9506$var$offscreenSubtreeWasHidden;
            $fb2b12fdc6fd9506$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $fb2b12fdc6fd9506$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $fb2b12fdc6fd9506$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $fb2b12fdc6fd9506$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $fb2b12fdc6fd9506$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $fb2b12fdc6fd9506$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $fb2b12fdc6fd9506$var$offscreenSubtreeIsHidden || $fb2b12fdc6fd9506$var$offscreenSubtreeWasHidden || $fb2b12fdc6fd9506$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $fb2b12fdc6fd9506$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $fb2b12fdc6fd9506$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $fb2b12fdc6fd9506$var$hideOrUnhideDehydratedBoundary(instance, !0) : $fb2b12fdc6fd9506$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $fb2b12fdc6fd9506$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $fb2b12fdc6fd9506$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $fb2b12fdc6fd9506$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $fb2b12fdc6fd9506$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $fb2b12fdc6fd9506$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $fb2b12fdc6fd9506$var$recursivelyTraverseMutationEffects(root, finishedWork), $fb2b12fdc6fd9506$var$commitReconciliationEffects(finishedWork);
    }
}
function $fb2b12fdc6fd9506$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($fb2b12fdc6fd9506$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $fb2b12fdc6fd9506$var$getHostSibling(finishedWork);
                    $fb2b12fdc6fd9506$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($fb2b12fdc6fd9506$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $fb2b12fdc6fd9506$var$getHostSibling(finishedWork);
                    $fb2b12fdc6fd9506$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $fb2b12fdc6fd9506$var$getHostSibling(finishedWork);
                    $fb2b12fdc6fd9506$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $fb2b12fdc6fd9506$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $fb2b12fdc6fd9506$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $fb2b12fdc6fd9506$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $fb2b12fdc6fd9506$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$fb2b12fdc6fd9506$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $fb2b12fdc6fd9506$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $fb2b12fdc6fd9506$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $fb2b12fdc6fd9506$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $fb2b12fdc6fd9506$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $fb2b12fdc6fd9506$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $fb2b12fdc6fd9506$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $fb2b12fdc6fd9506$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $fb2b12fdc6fd9506$var$safelyDetachRef(finishedWork, finishedWork.return);
                $fb2b12fdc6fd9506$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $fb2b12fdc6fd9506$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $fb2b12fdc6fd9506$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $fb2b12fdc6fd9506$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $fb2b12fdc6fd9506$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $fb2b12fdc6fd9506$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $fb2b12fdc6fd9506$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $fb2b12fdc6fd9506$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $fb2b12fdc6fd9506$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$fb2b12fdc6fd9506$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $fb2b12fdc6fd9506$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $fb2b12fdc6fd9506$var$commitClassCallbacks(finishedWork);
                $fb2b12fdc6fd9506$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $fb2b12fdc6fd9506$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $fb2b12fdc6fd9506$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $fb2b12fdc6fd9506$var$commitHostMount(finishedWork);
                $fb2b12fdc6fd9506$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $fb2b12fdc6fd9506$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $fb2b12fdc6fd9506$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $fb2b12fdc6fd9506$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $fb2b12fdc6fd9506$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $fb2b12fdc6fd9506$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $fb2b12fdc6fd9506$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $fb2b12fdc6fd9506$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $fb2b12fdc6fd9506$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $fb2b12fdc6fd9506$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $fb2b12fdc6fd9506$var$releaseCache(previousCache));
}
function $fb2b12fdc6fd9506$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $fb2b12fdc6fd9506$var$releaseCache(current));
}
function $fb2b12fdc6fd9506$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$fb2b12fdc6fd9506$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $fb2b12fdc6fd9506$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $fb2b12fdc6fd9506$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $fb2b12fdc6fd9506$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $fb2b12fdc6fd9506$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $fb2b12fdc6fd9506$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $fb2b12fdc6fd9506$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $fb2b12fdc6fd9506$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $fb2b12fdc6fd9506$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $fb2b12fdc6fd9506$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $fb2b12fdc6fd9506$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $fb2b12fdc6fd9506$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $fb2b12fdc6fd9506$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $fb2b12fdc6fd9506$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $fb2b12fdc6fd9506$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $fb2b12fdc6fd9506$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $fb2b12fdc6fd9506$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $fb2b12fdc6fd9506$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $fb2b12fdc6fd9506$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $fb2b12fdc6fd9506$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $fb2b12fdc6fd9506$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $fb2b12fdc6fd9506$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $fb2b12fdc6fd9506$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $fb2b12fdc6fd9506$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $fb2b12fdc6fd9506$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $fb2b12fdc6fd9506$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $fb2b12fdc6fd9506$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $fb2b12fdc6fd9506$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $fb2b12fdc6fd9506$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $fb2b12fdc6fd9506$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $fb2b12fdc6fd9506$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $fb2b12fdc6fd9506$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $fb2b12fdc6fd9506$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $fb2b12fdc6fd9506$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $fb2b12fdc6fd9506$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $fb2b12fdc6fd9506$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $fb2b12fdc6fd9506$var$suspenseyCommitFlag = 8192;
function $fb2b12fdc6fd9506$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $fb2b12fdc6fd9506$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$fb2b12fdc6fd9506$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $fb2b12fdc6fd9506$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $fb2b12fdc6fd9506$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $fb2b12fdc6fd9506$var$suspenseyCommitFlag && null !== fiber.memoizedState && $fb2b12fdc6fd9506$var$suspendResource(suspendedState, $fb2b12fdc6fd9506$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $fb2b12fdc6fd9506$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $fb2b12fdc6fd9506$var$currentHoistableRoot;
            $fb2b12fdc6fd9506$var$currentHoistableRoot = $fb2b12fdc6fd9506$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $fb2b12fdc6fd9506$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $fb2b12fdc6fd9506$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $fb2b12fdc6fd9506$var$suspenseyCommitFlag, $fb2b12fdc6fd9506$var$suspenseyCommitFlag = 16777216, $fb2b12fdc6fd9506$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $fb2b12fdc6fd9506$var$suspenseyCommitFlag = previousHoistableRoot) : $fb2b12fdc6fd9506$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $fb2b12fdc6fd9506$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $fb2b12fdc6fd9506$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $fb2b12fdc6fd9506$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $fb2b12fdc6fd9506$var$nextEffect = childToDelete;
            $fb2b12fdc6fd9506$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $fb2b12fdc6fd9506$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$fb2b12fdc6fd9506$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $fb2b12fdc6fd9506$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $fb2b12fdc6fd9506$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $fb2b12fdc6fd9506$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $fb2b12fdc6fd9506$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $fb2b12fdc6fd9506$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $fb2b12fdc6fd9506$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $fb2b12fdc6fd9506$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $fb2b12fdc6fd9506$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $fb2b12fdc6fd9506$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $fb2b12fdc6fd9506$var$nextEffect = childToDelete;
            $fb2b12fdc6fd9506$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $fb2b12fdc6fd9506$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $fb2b12fdc6fd9506$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $fb2b12fdc6fd9506$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $fb2b12fdc6fd9506$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $fb2b12fdc6fd9506$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $fb2b12fdc6fd9506$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $fb2b12fdc6fd9506$var$nextEffect;){
        var fiber = $fb2b12fdc6fd9506$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $fb2b12fdc6fd9506$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $fb2b12fdc6fd9506$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $fb2b12fdc6fd9506$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $fb2b12fdc6fd9506$var$nextEffect;){
            cache = $fb2b12fdc6fd9506$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $fb2b12fdc6fd9506$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $fb2b12fdc6fd9506$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $fb2b12fdc6fd9506$var$nextEffect = sibling;
                break a;
            }
            $fb2b12fdc6fd9506$var$nextEffect = returnFiber;
        }
    }
}
var $fb2b12fdc6fd9506$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $fb2b12fdc6fd9506$var$readContext($fb2b12fdc6fd9506$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $fb2b12fdc6fd9506$var$readContext($fb2b12fdc6fd9506$var$CacheContext).controller.signal;
    }
}, $fb2b12fdc6fd9506$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $fb2b12fdc6fd9506$var$executionContext = 0, $fb2b12fdc6fd9506$var$workInProgressRoot = null, $fb2b12fdc6fd9506$var$workInProgress = null, $fb2b12fdc6fd9506$var$workInProgressRootRenderLanes = 0, $fb2b12fdc6fd9506$var$workInProgressSuspendedReason = 0, $fb2b12fdc6fd9506$var$workInProgressThrownValue = null, $fb2b12fdc6fd9506$var$workInProgressRootDidSkipSuspendedSiblings = !1, $fb2b12fdc6fd9506$var$workInProgressRootIsPrerendering = !1, $fb2b12fdc6fd9506$var$workInProgressRootDidAttachPingListener = !1, $fb2b12fdc6fd9506$var$entangledRenderLanes = 0, $fb2b12fdc6fd9506$var$workInProgressRootExitStatus = 0, $fb2b12fdc6fd9506$var$workInProgressRootSkippedLanes = 0, $fb2b12fdc6fd9506$var$workInProgressRootInterleavedUpdatedLanes = 0, $fb2b12fdc6fd9506$var$workInProgressRootPingedLanes = 0, $fb2b12fdc6fd9506$var$workInProgressDeferredLane = 0, $fb2b12fdc6fd9506$var$workInProgressSuspendedRetryLanes = 0, $fb2b12fdc6fd9506$var$workInProgressRootConcurrentErrors = null, $fb2b12fdc6fd9506$var$workInProgressRootRecoverableErrors = null, $fb2b12fdc6fd9506$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $fb2b12fdc6fd9506$var$globalMostRecentFallbackTime = 0, $fb2b12fdc6fd9506$var$globalMostRecentTransitionTime = 0, $fb2b12fdc6fd9506$var$workInProgressRootRenderTargetTime = Infinity, $fb2b12fdc6fd9506$var$workInProgressTransitions = null, $fb2b12fdc6fd9506$var$legacyErrorBoundariesThatAlreadyFailed = null, $fb2b12fdc6fd9506$var$pendingEffectsStatus = 0, $fb2b12fdc6fd9506$var$pendingEffectsRoot = null, $fb2b12fdc6fd9506$var$pendingFinishedWork = null, $fb2b12fdc6fd9506$var$pendingEffectsLanes = 0, $fb2b12fdc6fd9506$var$pendingEffectsRemainingLanes = 0, $fb2b12fdc6fd9506$var$pendingPassiveTransitions = null, $fb2b12fdc6fd9506$var$pendingRecoverableErrors = null, $fb2b12fdc6fd9506$var$nestedUpdateCount = 0, $fb2b12fdc6fd9506$var$rootWithNestedUpdates = null;
function $fb2b12fdc6fd9506$var$requestUpdateLane() {
    return 0 !== ($fb2b12fdc6fd9506$var$executionContext & 2) && 0 !== $fb2b12fdc6fd9506$var$workInProgressRootRenderLanes ? $fb2b12fdc6fd9506$var$workInProgressRootRenderLanes & -$fb2b12fdc6fd9506$var$workInProgressRootRenderLanes : null !== $fb2b12fdc6fd9506$var$ReactSharedInternals.T ? $fb2b12fdc6fd9506$var$requestTransitionLane() : $fb2b12fdc6fd9506$var$resolveUpdatePriority();
}
function $fb2b12fdc6fd9506$var$requestDeferredLane() {
    if (0 === $fb2b12fdc6fd9506$var$workInProgressDeferredLane) {
        if (0 === ($fb2b12fdc6fd9506$var$workInProgressRootRenderLanes & 536870912) || $fb2b12fdc6fd9506$var$isHydrating) {
            var lane = $fb2b12fdc6fd9506$var$nextTransitionDeferredLane;
            $fb2b12fdc6fd9506$var$nextTransitionDeferredLane <<= 1;
            0 === ($fb2b12fdc6fd9506$var$nextTransitionDeferredLane & 3932160) && ($fb2b12fdc6fd9506$var$nextTransitionDeferredLane = 262144);
            $fb2b12fdc6fd9506$var$workInProgressDeferredLane = lane;
        } else $fb2b12fdc6fd9506$var$workInProgressDeferredLane = 536870912;
    }
    lane = $fb2b12fdc6fd9506$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $fb2b12fdc6fd9506$var$workInProgressDeferredLane;
}
function $fb2b12fdc6fd9506$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $fb2b12fdc6fd9506$var$workInProgressRoot && (2 === $fb2b12fdc6fd9506$var$workInProgressSuspendedReason || 9 === $fb2b12fdc6fd9506$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $fb2b12fdc6fd9506$var$prepareFreshStack(root, 0), $fb2b12fdc6fd9506$var$markRootSuspended(root, $fb2b12fdc6fd9506$var$workInProgressRootRenderLanes, $fb2b12fdc6fd9506$var$workInProgressDeferredLane, !1);
    $fb2b12fdc6fd9506$var$markRootUpdated$1(root, lane);
    if (0 === ($fb2b12fdc6fd9506$var$executionContext & 2) || root !== $fb2b12fdc6fd9506$var$workInProgressRoot) root === $fb2b12fdc6fd9506$var$workInProgressRoot && (0 === ($fb2b12fdc6fd9506$var$executionContext & 2) && ($fb2b12fdc6fd9506$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $fb2b12fdc6fd9506$var$workInProgressRootExitStatus && $fb2b12fdc6fd9506$var$markRootSuspended(root, $fb2b12fdc6fd9506$var$workInProgressRootRenderLanes, $fb2b12fdc6fd9506$var$workInProgressDeferredLane, !1)), $fb2b12fdc6fd9506$var$ensureRootIsScheduled(root);
}
function $fb2b12fdc6fd9506$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($fb2b12fdc6fd9506$var$executionContext & 6)) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $fb2b12fdc6fd9506$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $fb2b12fdc6fd9506$var$renderRootConcurrent(root$jscomp$0, lanes) : $fb2b12fdc6fd9506$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $fb2b12fdc6fd9506$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $fb2b12fdc6fd9506$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$fb2b12fdc6fd9506$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $fb2b12fdc6fd9506$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $fb2b12fdc6fd9506$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($fb2b12fdc6fd9506$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $fb2b12fdc6fd9506$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($fb2b12fdc6fd9506$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $fb2b12fdc6fd9506$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $fb2b12fdc6fd9506$var$workInProgressRootRecoverableErrors;
                            $fb2b12fdc6fd9506$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $fb2b12fdc6fd9506$var$workInProgressRootRecoverableErrors ? $fb2b12fdc6fd9506$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $fb2b12fdc6fd9506$var$workInProgressRootRecoverableErrors.push.apply($fb2b12fdc6fd9506$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $fb2b12fdc6fd9506$var$prepareFreshStack(root$jscomp$0, 0);
                $fb2b12fdc6fd9506$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $fb2b12fdc6fd9506$var$markRootSuspended(shouldTimeSlice, lanes, $fb2b12fdc6fd9506$var$workInProgressDeferredLane, !$fb2b12fdc6fd9506$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $fb2b12fdc6fd9506$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $fb2b12fdc6fd9506$var$globalMostRecentFallbackTime + 300 - $fb2b12fdc6fd9506$var$now(), 10 < exitStatus)) {
                    $fb2b12fdc6fd9506$var$markRootSuspended(shouldTimeSlice, lanes, $fb2b12fdc6fd9506$var$workInProgressDeferredLane, !$fb2b12fdc6fd9506$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $fb2b12fdc6fd9506$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $fb2b12fdc6fd9506$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $fb2b12fdc6fd9506$var$scheduleTimeout($fb2b12fdc6fd9506$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $fb2b12fdc6fd9506$var$workInProgressRootRecoverableErrors, $fb2b12fdc6fd9506$var$workInProgressTransitions, $fb2b12fdc6fd9506$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $fb2b12fdc6fd9506$var$workInProgressDeferredLane, $fb2b12fdc6fd9506$var$workInProgressRootInterleavedUpdatedLanes, $fb2b12fdc6fd9506$var$workInProgressSuspendedRetryLanes, $fb2b12fdc6fd9506$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $fb2b12fdc6fd9506$var$commitRootWhenReady(shouldTimeSlice, forceSync, $fb2b12fdc6fd9506$var$workInProgressRootRecoverableErrors, $fb2b12fdc6fd9506$var$workInProgressTransitions, $fb2b12fdc6fd9506$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $fb2b12fdc6fd9506$var$workInProgressDeferredLane, $fb2b12fdc6fd9506$var$workInProgressRootInterleavedUpdatedLanes, $fb2b12fdc6fd9506$var$workInProgressSuspendedRetryLanes, $fb2b12fdc6fd9506$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $fb2b12fdc6fd9506$var$ensureRootIsScheduled(root$jscomp$0);
}
function $fb2b12fdc6fd9506$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $fb2b12fdc6fd9506$var$noop$1
        };
        $fb2b12fdc6fd9506$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $fb2b12fdc6fd9506$var$globalMostRecentFallbackTime - $fb2b12fdc6fd9506$var$now() : (lanes & 4194048) === lanes ? $fb2b12fdc6fd9506$var$globalMostRecentTransitionTime - $fb2b12fdc6fd9506$var$now() : 0;
        timeoutOffset = $fb2b12fdc6fd9506$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $fb2b12fdc6fd9506$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($fb2b12fdc6fd9506$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $fb2b12fdc6fd9506$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $fb2b12fdc6fd9506$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $fb2b12fdc6fd9506$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$fb2b12fdc6fd9506$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $fb2b12fdc6fd9506$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$fb2b12fdc6fd9506$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$fb2b12fdc6fd9506$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $fb2b12fdc6fd9506$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $fb2b12fdc6fd9506$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $fb2b12fdc6fd9506$var$flushSyncWork$1() {
    return 0 === ($fb2b12fdc6fd9506$var$executionContext & 6) ? ($fb2b12fdc6fd9506$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $fb2b12fdc6fd9506$var$resetWorkInProgressStack() {
    if (null !== $fb2b12fdc6fd9506$var$workInProgress) {
        if (0 === $fb2b12fdc6fd9506$var$workInProgressSuspendedReason) var interruptedWork = $fb2b12fdc6fd9506$var$workInProgress.return;
        else interruptedWork = $fb2b12fdc6fd9506$var$workInProgress, $fb2b12fdc6fd9506$var$lastContextDependency = $fb2b12fdc6fd9506$var$currentlyRenderingFiber$1 = null, $fb2b12fdc6fd9506$var$resetHooksOnUnwind(interruptedWork), $fb2b12fdc6fd9506$var$thenableState$1 = null, $fb2b12fdc6fd9506$var$thenableIndexCounter$1 = 0, interruptedWork = $fb2b12fdc6fd9506$var$workInProgress;
        for(; null !== interruptedWork;)$fb2b12fdc6fd9506$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $fb2b12fdc6fd9506$var$workInProgress = null;
    }
}
function $fb2b12fdc6fd9506$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $fb2b12fdc6fd9506$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $fb2b12fdc6fd9506$var$pendingEffectsLanes = 0;
    $fb2b12fdc6fd9506$var$resetWorkInProgressStack();
    $fb2b12fdc6fd9506$var$workInProgressRoot = root;
    $fb2b12fdc6fd9506$var$workInProgress = timeoutHandle = $fb2b12fdc6fd9506$var$createWorkInProgress(root.current, null);
    $fb2b12fdc6fd9506$var$workInProgressRootRenderLanes = lanes;
    $fb2b12fdc6fd9506$var$workInProgressSuspendedReason = 0;
    $fb2b12fdc6fd9506$var$workInProgressThrownValue = null;
    $fb2b12fdc6fd9506$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $fb2b12fdc6fd9506$var$workInProgressRootIsPrerendering = $fb2b12fdc6fd9506$var$checkIfRootIsPrerendering(root, lanes);
    $fb2b12fdc6fd9506$var$workInProgressRootDidAttachPingListener = !1;
    $fb2b12fdc6fd9506$var$workInProgressSuspendedRetryLanes = $fb2b12fdc6fd9506$var$workInProgressDeferredLane = $fb2b12fdc6fd9506$var$workInProgressRootPingedLanes = $fb2b12fdc6fd9506$var$workInProgressRootInterleavedUpdatedLanes = $fb2b12fdc6fd9506$var$workInProgressRootSkippedLanes = $fb2b12fdc6fd9506$var$workInProgressRootExitStatus = 0;
    $fb2b12fdc6fd9506$var$workInProgressRootRecoverableErrors = $fb2b12fdc6fd9506$var$workInProgressRootConcurrentErrors = null;
    $fb2b12fdc6fd9506$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $fb2b12fdc6fd9506$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $fb2b12fdc6fd9506$var$entangledRenderLanes = lanes;
    $fb2b12fdc6fd9506$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $fb2b12fdc6fd9506$var$handleThrow(root, thrownValue) {
    $fb2b12fdc6fd9506$var$currentlyRenderingFiber = null;
    $fb2b12fdc6fd9506$var$ReactSharedInternals.H = $fb2b12fdc6fd9506$var$ContextOnlyDispatcher;
    thrownValue === $fb2b12fdc6fd9506$var$SuspenseException || thrownValue === $fb2b12fdc6fd9506$var$SuspenseActionException ? (thrownValue = $fb2b12fdc6fd9506$var$getSuspendedThenable(), $fb2b12fdc6fd9506$var$workInProgressSuspendedReason = 3) : thrownValue === $fb2b12fdc6fd9506$var$SuspenseyCommitException ? (thrownValue = $fb2b12fdc6fd9506$var$getSuspendedThenable(), $fb2b12fdc6fd9506$var$workInProgressSuspendedReason = 4) : $fb2b12fdc6fd9506$var$workInProgressSuspendedReason = thrownValue === $fb2b12fdc6fd9506$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $fb2b12fdc6fd9506$var$workInProgressThrownValue = thrownValue;
    null === $fb2b12fdc6fd9506$var$workInProgress && ($fb2b12fdc6fd9506$var$workInProgressRootExitStatus = 1, $fb2b12fdc6fd9506$var$logUncaughtError(root, $fb2b12fdc6fd9506$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $fb2b12fdc6fd9506$var$shouldRemainOnPreviousScreen() {
    var handler = $fb2b12fdc6fd9506$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($fb2b12fdc6fd9506$var$workInProgressRootRenderLanes & 4194048) === $fb2b12fdc6fd9506$var$workInProgressRootRenderLanes ? null === $fb2b12fdc6fd9506$var$shellBoundary ? !0 : !1 : ($fb2b12fdc6fd9506$var$workInProgressRootRenderLanes & 62914560) === $fb2b12fdc6fd9506$var$workInProgressRootRenderLanes || 0 !== ($fb2b12fdc6fd9506$var$workInProgressRootRenderLanes & 536870912) ? handler === $fb2b12fdc6fd9506$var$shellBoundary : !1;
}
function $fb2b12fdc6fd9506$var$pushDispatcher() {
    var prevDispatcher = $fb2b12fdc6fd9506$var$ReactSharedInternals.H;
    $fb2b12fdc6fd9506$var$ReactSharedInternals.H = $fb2b12fdc6fd9506$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $fb2b12fdc6fd9506$var$ContextOnlyDispatcher : prevDispatcher;
}
function $fb2b12fdc6fd9506$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $fb2b12fdc6fd9506$var$ReactSharedInternals.A;
    $fb2b12fdc6fd9506$var$ReactSharedInternals.A = $fb2b12fdc6fd9506$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $fb2b12fdc6fd9506$var$renderDidSuspendDelayIfPossible() {
    $fb2b12fdc6fd9506$var$workInProgressRootExitStatus = 4;
    $fb2b12fdc6fd9506$var$workInProgressRootDidSkipSuspendedSiblings || ($fb2b12fdc6fd9506$var$workInProgressRootRenderLanes & 4194048) !== $fb2b12fdc6fd9506$var$workInProgressRootRenderLanes && null !== $fb2b12fdc6fd9506$var$suspenseHandlerStackCursor.current || ($fb2b12fdc6fd9506$var$workInProgressRootIsPrerendering = !0);
    0 === ($fb2b12fdc6fd9506$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($fb2b12fdc6fd9506$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $fb2b12fdc6fd9506$var$workInProgressRoot || $fb2b12fdc6fd9506$var$markRootSuspended($fb2b12fdc6fd9506$var$workInProgressRoot, $fb2b12fdc6fd9506$var$workInProgressRootRenderLanes, $fb2b12fdc6fd9506$var$workInProgressDeferredLane, !1);
}
function $fb2b12fdc6fd9506$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $fb2b12fdc6fd9506$var$executionContext;
    $fb2b12fdc6fd9506$var$executionContext |= 2;
    var prevDispatcher = $fb2b12fdc6fd9506$var$pushDispatcher(), prevAsyncDispatcher = $fb2b12fdc6fd9506$var$pushAsyncDispatcher();
    if ($fb2b12fdc6fd9506$var$workInProgressRoot !== root || $fb2b12fdc6fd9506$var$workInProgressRootRenderLanes !== lanes) $fb2b12fdc6fd9506$var$workInProgressTransitions = null, $fb2b12fdc6fd9506$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $fb2b12fdc6fd9506$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $fb2b12fdc6fd9506$var$workInProgressSuspendedReason && null !== $fb2b12fdc6fd9506$var$workInProgress) {
            var unitOfWork = $fb2b12fdc6fd9506$var$workInProgress, thrownValue = $fb2b12fdc6fd9506$var$workInProgressThrownValue;
            switch($fb2b12fdc6fd9506$var$workInProgressSuspendedReason){
                case 8:
                    $fb2b12fdc6fd9506$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $fb2b12fdc6fd9506$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $fb2b12fdc6fd9506$var$workInProgressSuspendedReason;
                    $fb2b12fdc6fd9506$var$workInProgressSuspendedReason = 0;
                    $fb2b12fdc6fd9506$var$workInProgressThrownValue = null;
                    $fb2b12fdc6fd9506$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $fb2b12fdc6fd9506$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $fb2b12fdc6fd9506$var$workInProgressSuspendedReason, $fb2b12fdc6fd9506$var$workInProgressSuspendedReason = 0, $fb2b12fdc6fd9506$var$workInProgressThrownValue = null, $fb2b12fdc6fd9506$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $fb2b12fdc6fd9506$var$workLoopSync();
        exitStatus = $fb2b12fdc6fd9506$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $fb2b12fdc6fd9506$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $fb2b12fdc6fd9506$var$lastContextDependency = $fb2b12fdc6fd9506$var$currentlyRenderingFiber$1 = null;
    $fb2b12fdc6fd9506$var$executionContext = prevExecutionContext;
    $fb2b12fdc6fd9506$var$ReactSharedInternals.H = prevDispatcher;
    $fb2b12fdc6fd9506$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $fb2b12fdc6fd9506$var$workInProgress && ($fb2b12fdc6fd9506$var$workInProgressRoot = null, $fb2b12fdc6fd9506$var$workInProgressRootRenderLanes = 0, $fb2b12fdc6fd9506$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $fb2b12fdc6fd9506$var$workLoopSync() {
    for(; null !== $fb2b12fdc6fd9506$var$workInProgress;)$fb2b12fdc6fd9506$var$performUnitOfWork($fb2b12fdc6fd9506$var$workInProgress);
}
function $fb2b12fdc6fd9506$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $fb2b12fdc6fd9506$var$executionContext;
    $fb2b12fdc6fd9506$var$executionContext |= 2;
    var prevDispatcher = $fb2b12fdc6fd9506$var$pushDispatcher(), prevAsyncDispatcher = $fb2b12fdc6fd9506$var$pushAsyncDispatcher();
    $fb2b12fdc6fd9506$var$workInProgressRoot !== root || $fb2b12fdc6fd9506$var$workInProgressRootRenderLanes !== lanes ? ($fb2b12fdc6fd9506$var$workInProgressTransitions = null, $fb2b12fdc6fd9506$var$workInProgressRootRenderTargetTime = $fb2b12fdc6fd9506$var$now() + 500, $fb2b12fdc6fd9506$var$prepareFreshStack(root, lanes)) : $fb2b12fdc6fd9506$var$workInProgressRootIsPrerendering = $fb2b12fdc6fd9506$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $fb2b12fdc6fd9506$var$workInProgressSuspendedReason && null !== $fb2b12fdc6fd9506$var$workInProgress) {
            lanes = $fb2b12fdc6fd9506$var$workInProgress;
            var thrownValue = $fb2b12fdc6fd9506$var$workInProgressThrownValue;
            b: switch($fb2b12fdc6fd9506$var$workInProgressSuspendedReason){
                case 1:
                    $fb2b12fdc6fd9506$var$workInProgressSuspendedReason = 0;
                    $fb2b12fdc6fd9506$var$workInProgressThrownValue = null;
                    $fb2b12fdc6fd9506$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($fb2b12fdc6fd9506$var$isThenableResolved(thrownValue)) {
                        $fb2b12fdc6fd9506$var$workInProgressSuspendedReason = 0;
                        $fb2b12fdc6fd9506$var$workInProgressThrownValue = null;
                        $fb2b12fdc6fd9506$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $fb2b12fdc6fd9506$var$workInProgressSuspendedReason && 9 !== $fb2b12fdc6fd9506$var$workInProgressSuspendedReason || $fb2b12fdc6fd9506$var$workInProgressRoot !== root || ($fb2b12fdc6fd9506$var$workInProgressSuspendedReason = 7);
                        $fb2b12fdc6fd9506$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $fb2b12fdc6fd9506$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $fb2b12fdc6fd9506$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $fb2b12fdc6fd9506$var$isThenableResolved(thrownValue) ? ($fb2b12fdc6fd9506$var$workInProgressSuspendedReason = 0, $fb2b12fdc6fd9506$var$workInProgressThrownValue = null, $fb2b12fdc6fd9506$var$replaySuspendedUnitOfWork(lanes)) : ($fb2b12fdc6fd9506$var$workInProgressSuspendedReason = 0, $fb2b12fdc6fd9506$var$workInProgressThrownValue = null, $fb2b12fdc6fd9506$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($fb2b12fdc6fd9506$var$workInProgress.tag){
                        case 26:
                            resource = $fb2b12fdc6fd9506$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $fb2b12fdc6fd9506$var$workInProgress;
                            if (resource ? $fb2b12fdc6fd9506$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $fb2b12fdc6fd9506$var$workInProgressSuspendedReason = 0;
                                $fb2b12fdc6fd9506$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $fb2b12fdc6fd9506$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($fb2b12fdc6fd9506$var$workInProgress = returnFiber, $fb2b12fdc6fd9506$var$completeUnitOfWork(returnFiber)) : $fb2b12fdc6fd9506$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $fb2b12fdc6fd9506$var$workInProgressSuspendedReason = 0;
                    $fb2b12fdc6fd9506$var$workInProgressThrownValue = null;
                    $fb2b12fdc6fd9506$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $fb2b12fdc6fd9506$var$workInProgressSuspendedReason = 0;
                    $fb2b12fdc6fd9506$var$workInProgressThrownValue = null;
                    $fb2b12fdc6fd9506$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $fb2b12fdc6fd9506$var$resetWorkInProgressStack();
                    $fb2b12fdc6fd9506$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(462));
            }
        }
        $fb2b12fdc6fd9506$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $fb2b12fdc6fd9506$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $fb2b12fdc6fd9506$var$lastContextDependency = $fb2b12fdc6fd9506$var$currentlyRenderingFiber$1 = null;
    $fb2b12fdc6fd9506$var$ReactSharedInternals.H = prevDispatcher;
    $fb2b12fdc6fd9506$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $fb2b12fdc6fd9506$var$executionContext = prevExecutionContext;
    if (null !== $fb2b12fdc6fd9506$var$workInProgress) return 0;
    $fb2b12fdc6fd9506$var$workInProgressRoot = null;
    $fb2b12fdc6fd9506$var$workInProgressRootRenderLanes = 0;
    $fb2b12fdc6fd9506$var$finishQueueingConcurrentUpdates();
    return $fb2b12fdc6fd9506$var$workInProgressRootExitStatus;
}
function $fb2b12fdc6fd9506$var$workLoopConcurrentByScheduler() {
    for(; null !== $fb2b12fdc6fd9506$var$workInProgress && !$fb2b12fdc6fd9506$var$shouldYield();)$fb2b12fdc6fd9506$var$performUnitOfWork($fb2b12fdc6fd9506$var$workInProgress);
}
function $fb2b12fdc6fd9506$var$performUnitOfWork(unitOfWork) {
    var next = $fb2b12fdc6fd9506$var$beginWork(unitOfWork.alternate, unitOfWork, $fb2b12fdc6fd9506$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $fb2b12fdc6fd9506$var$completeUnitOfWork(unitOfWork) : $fb2b12fdc6fd9506$var$workInProgress = next;
}
function $fb2b12fdc6fd9506$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $fb2b12fdc6fd9506$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $fb2b12fdc6fd9506$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $fb2b12fdc6fd9506$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $fb2b12fdc6fd9506$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $fb2b12fdc6fd9506$var$resetHooksOnUnwind(next);
        default:
            $fb2b12fdc6fd9506$var$unwindInterruptedWork(current, next), next = $fb2b12fdc6fd9506$var$workInProgress = $fb2b12fdc6fd9506$var$resetWorkInProgress(next, $fb2b12fdc6fd9506$var$entangledRenderLanes), next = $fb2b12fdc6fd9506$var$beginWork(current, next, $fb2b12fdc6fd9506$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $fb2b12fdc6fd9506$var$completeUnitOfWork(unitOfWork) : $fb2b12fdc6fd9506$var$workInProgress = next;
}
function $fb2b12fdc6fd9506$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $fb2b12fdc6fd9506$var$lastContextDependency = $fb2b12fdc6fd9506$var$currentlyRenderingFiber$1 = null;
    $fb2b12fdc6fd9506$var$resetHooksOnUnwind(unitOfWork);
    $fb2b12fdc6fd9506$var$thenableState$1 = null;
    $fb2b12fdc6fd9506$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($fb2b12fdc6fd9506$var$throwException(root, returnFiber, unitOfWork, thrownValue, $fb2b12fdc6fd9506$var$workInProgressRootRenderLanes)) {
            $fb2b12fdc6fd9506$var$workInProgressRootExitStatus = 1;
            $fb2b12fdc6fd9506$var$logUncaughtError(root, $fb2b12fdc6fd9506$var$createCapturedValueAtFiber(thrownValue, root.current));
            $fb2b12fdc6fd9506$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $fb2b12fdc6fd9506$var$workInProgress = returnFiber, error;
        $fb2b12fdc6fd9506$var$workInProgressRootExitStatus = 1;
        $fb2b12fdc6fd9506$var$logUncaughtError(root, $fb2b12fdc6fd9506$var$createCapturedValueAtFiber(thrownValue, root.current));
        $fb2b12fdc6fd9506$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($fb2b12fdc6fd9506$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($fb2b12fdc6fd9506$var$workInProgressRootIsPrerendering || 0 !== ($fb2b12fdc6fd9506$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($fb2b12fdc6fd9506$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $fb2b12fdc6fd9506$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $fb2b12fdc6fd9506$var$unwindUnitOfWork(unitOfWork, root);
    } else $fb2b12fdc6fd9506$var$completeUnitOfWork(unitOfWork);
}
function $fb2b12fdc6fd9506$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $fb2b12fdc6fd9506$var$unwindUnitOfWork(completedWork, $fb2b12fdc6fd9506$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $fb2b12fdc6fd9506$var$completeWork(completedWork.alternate, completedWork, $fb2b12fdc6fd9506$var$entangledRenderLanes);
        if (null !== next) {
            $fb2b12fdc6fd9506$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $fb2b12fdc6fd9506$var$workInProgress = completedWork;
            return;
        }
        $fb2b12fdc6fd9506$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $fb2b12fdc6fd9506$var$workInProgressRootExitStatus && ($fb2b12fdc6fd9506$var$workInProgressRootExitStatus = 5);
}
function $fb2b12fdc6fd9506$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $fb2b12fdc6fd9506$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $fb2b12fdc6fd9506$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $fb2b12fdc6fd9506$var$workInProgress = unitOfWork;
            return;
        }
        $fb2b12fdc6fd9506$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $fb2b12fdc6fd9506$var$workInProgressRootExitStatus = 6;
    $fb2b12fdc6fd9506$var$workInProgress = null;
}
function $fb2b12fdc6fd9506$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $fb2b12fdc6fd9506$var$flushPendingEffects();
    while (0 !== $fb2b12fdc6fd9506$var$pendingEffectsStatus);
    if (0 !== ($fb2b12fdc6fd9506$var$executionContext & 6)) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $fb2b12fdc6fd9506$var$concurrentlyUpdatedLanes;
        $fb2b12fdc6fd9506$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $fb2b12fdc6fd9506$var$workInProgressRoot && ($fb2b12fdc6fd9506$var$workInProgress = $fb2b12fdc6fd9506$var$workInProgressRoot = null, $fb2b12fdc6fd9506$var$workInProgressRootRenderLanes = 0);
        $fb2b12fdc6fd9506$var$pendingFinishedWork = finishedWork;
        $fb2b12fdc6fd9506$var$pendingEffectsRoot = root;
        $fb2b12fdc6fd9506$var$pendingEffectsLanes = lanes;
        $fb2b12fdc6fd9506$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $fb2b12fdc6fd9506$var$pendingPassiveTransitions = transitions;
        $fb2b12fdc6fd9506$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $fb2b12fdc6fd9506$var$scheduleCallback$1($fb2b12fdc6fd9506$var$NormalPriority$1, function() {
            $fb2b12fdc6fd9506$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $fb2b12fdc6fd9506$var$ReactSharedInternals.T;
            $fb2b12fdc6fd9506$var$ReactSharedInternals.T = null;
            transitions = $fb2b12fdc6fd9506$var$ReactDOMSharedInternals.p;
            $fb2b12fdc6fd9506$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $fb2b12fdc6fd9506$var$executionContext;
            $fb2b12fdc6fd9506$var$executionContext |= 4;
            try {
                $fb2b12fdc6fd9506$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $fb2b12fdc6fd9506$var$executionContext = spawnedLane, $fb2b12fdc6fd9506$var$ReactDOMSharedInternals.p = transitions, $fb2b12fdc6fd9506$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $fb2b12fdc6fd9506$var$pendingEffectsStatus = 1;
        $fb2b12fdc6fd9506$var$flushMutationEffects();
        $fb2b12fdc6fd9506$var$flushLayoutEffects();
        $fb2b12fdc6fd9506$var$flushSpawnedWork();
    }
}
function $fb2b12fdc6fd9506$var$flushMutationEffects() {
    if (1 === $fb2b12fdc6fd9506$var$pendingEffectsStatus) {
        $fb2b12fdc6fd9506$var$pendingEffectsStatus = 0;
        var root = $fb2b12fdc6fd9506$var$pendingEffectsRoot, finishedWork = $fb2b12fdc6fd9506$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $fb2b12fdc6fd9506$var$ReactSharedInternals.T;
            $fb2b12fdc6fd9506$var$ReactSharedInternals.T = null;
            var previousPriority = $fb2b12fdc6fd9506$var$ReactDOMSharedInternals.p;
            $fb2b12fdc6fd9506$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $fb2b12fdc6fd9506$var$executionContext;
            $fb2b12fdc6fd9506$var$executionContext |= 4;
            try {
                $fb2b12fdc6fd9506$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $fb2b12fdc6fd9506$var$selectionInformation, curFocusedElem = $fb2b12fdc6fd9506$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $fb2b12fdc6fd9506$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $fb2b12fdc6fd9506$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $fb2b12fdc6fd9506$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $fb2b12fdc6fd9506$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $fb2b12fdc6fd9506$var$_enabled = !!$fb2b12fdc6fd9506$var$eventsEnabled;
                $fb2b12fdc6fd9506$var$selectionInformation = $fb2b12fdc6fd9506$var$eventsEnabled = null;
            } finally{
                $fb2b12fdc6fd9506$var$executionContext = prevExecutionContext, $fb2b12fdc6fd9506$var$ReactDOMSharedInternals.p = previousPriority, $fb2b12fdc6fd9506$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $fb2b12fdc6fd9506$var$pendingEffectsStatus = 2;
    }
}
function $fb2b12fdc6fd9506$var$flushLayoutEffects() {
    if (2 === $fb2b12fdc6fd9506$var$pendingEffectsStatus) {
        $fb2b12fdc6fd9506$var$pendingEffectsStatus = 0;
        var root = $fb2b12fdc6fd9506$var$pendingEffectsRoot, finishedWork = $fb2b12fdc6fd9506$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $fb2b12fdc6fd9506$var$ReactSharedInternals.T;
            $fb2b12fdc6fd9506$var$ReactSharedInternals.T = null;
            var previousPriority = $fb2b12fdc6fd9506$var$ReactDOMSharedInternals.p;
            $fb2b12fdc6fd9506$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $fb2b12fdc6fd9506$var$executionContext;
            $fb2b12fdc6fd9506$var$executionContext |= 4;
            try {
                $fb2b12fdc6fd9506$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $fb2b12fdc6fd9506$var$executionContext = prevExecutionContext, $fb2b12fdc6fd9506$var$ReactDOMSharedInternals.p = previousPriority, $fb2b12fdc6fd9506$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $fb2b12fdc6fd9506$var$pendingEffectsStatus = 3;
    }
}
function $fb2b12fdc6fd9506$var$flushSpawnedWork() {
    if (4 === $fb2b12fdc6fd9506$var$pendingEffectsStatus || 3 === $fb2b12fdc6fd9506$var$pendingEffectsStatus) {
        $fb2b12fdc6fd9506$var$pendingEffectsStatus = 0;
        $fb2b12fdc6fd9506$var$requestPaint();
        var root = $fb2b12fdc6fd9506$var$pendingEffectsRoot, finishedWork = $fb2b12fdc6fd9506$var$pendingFinishedWork, lanes = $fb2b12fdc6fd9506$var$pendingEffectsLanes, recoverableErrors = $fb2b12fdc6fd9506$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $fb2b12fdc6fd9506$var$pendingEffectsStatus = 5 : ($fb2b12fdc6fd9506$var$pendingEffectsStatus = 0, $fb2b12fdc6fd9506$var$pendingFinishedWork = $fb2b12fdc6fd9506$var$pendingEffectsRoot = null, $fb2b12fdc6fd9506$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($fb2b12fdc6fd9506$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $fb2b12fdc6fd9506$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($fb2b12fdc6fd9506$var$injectedHook && "function" === typeof $fb2b12fdc6fd9506$var$injectedHook.onCommitFiberRoot) try {
            $fb2b12fdc6fd9506$var$injectedHook.onCommitFiberRoot($fb2b12fdc6fd9506$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $fb2b12fdc6fd9506$var$ReactSharedInternals.T;
            remainingLanes = $fb2b12fdc6fd9506$var$ReactDOMSharedInternals.p;
            $fb2b12fdc6fd9506$var$ReactDOMSharedInternals.p = 2;
            $fb2b12fdc6fd9506$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $fb2b12fdc6fd9506$var$ReactSharedInternals.T = finishedWork, $fb2b12fdc6fd9506$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($fb2b12fdc6fd9506$var$pendingEffectsLanes & 3) && $fb2b12fdc6fd9506$var$flushPendingEffects();
        $fb2b12fdc6fd9506$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $fb2b12fdc6fd9506$var$rootWithNestedUpdates ? $fb2b12fdc6fd9506$var$nestedUpdateCount++ : ($fb2b12fdc6fd9506$var$nestedUpdateCount = 0, $fb2b12fdc6fd9506$var$rootWithNestedUpdates = root) : $fb2b12fdc6fd9506$var$nestedUpdateCount = 0;
        $fb2b12fdc6fd9506$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $fb2b12fdc6fd9506$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $fb2b12fdc6fd9506$var$releaseCache(remainingLanes)));
}
function $fb2b12fdc6fd9506$var$flushPendingEffects() {
    $fb2b12fdc6fd9506$var$flushMutationEffects();
    $fb2b12fdc6fd9506$var$flushLayoutEffects();
    $fb2b12fdc6fd9506$var$flushSpawnedWork();
    return $fb2b12fdc6fd9506$var$flushPassiveEffects();
}
function $fb2b12fdc6fd9506$var$flushPassiveEffects() {
    if (5 !== $fb2b12fdc6fd9506$var$pendingEffectsStatus) return !1;
    var root = $fb2b12fdc6fd9506$var$pendingEffectsRoot, remainingLanes = $fb2b12fdc6fd9506$var$pendingEffectsRemainingLanes;
    $fb2b12fdc6fd9506$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $fb2b12fdc6fd9506$var$lanesToEventPriority($fb2b12fdc6fd9506$var$pendingEffectsLanes), prevTransition = $fb2b12fdc6fd9506$var$ReactSharedInternals.T, previousPriority = $fb2b12fdc6fd9506$var$ReactDOMSharedInternals.p;
    try {
        $fb2b12fdc6fd9506$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $fb2b12fdc6fd9506$var$ReactSharedInternals.T = null;
        renderPriority = $fb2b12fdc6fd9506$var$pendingPassiveTransitions;
        $fb2b12fdc6fd9506$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $fb2b12fdc6fd9506$var$pendingEffectsRoot, lanes = $fb2b12fdc6fd9506$var$pendingEffectsLanes;
        $fb2b12fdc6fd9506$var$pendingEffectsStatus = 0;
        $fb2b12fdc6fd9506$var$pendingFinishedWork = $fb2b12fdc6fd9506$var$pendingEffectsRoot = null;
        $fb2b12fdc6fd9506$var$pendingEffectsLanes = 0;
        if (0 !== ($fb2b12fdc6fd9506$var$executionContext & 6)) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(331));
        var prevExecutionContext = $fb2b12fdc6fd9506$var$executionContext;
        $fb2b12fdc6fd9506$var$executionContext |= 4;
        $fb2b12fdc6fd9506$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $fb2b12fdc6fd9506$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $fb2b12fdc6fd9506$var$executionContext = prevExecutionContext;
        $fb2b12fdc6fd9506$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($fb2b12fdc6fd9506$var$injectedHook && "function" === typeof $fb2b12fdc6fd9506$var$injectedHook.onPostCommitFiberRoot) try {
            $fb2b12fdc6fd9506$var$injectedHook.onPostCommitFiberRoot($fb2b12fdc6fd9506$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $fb2b12fdc6fd9506$var$ReactDOMSharedInternals.p = previousPriority, $fb2b12fdc6fd9506$var$ReactSharedInternals.T = prevTransition, $fb2b12fdc6fd9506$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $fb2b12fdc6fd9506$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $fb2b12fdc6fd9506$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $fb2b12fdc6fd9506$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $fb2b12fdc6fd9506$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($fb2b12fdc6fd9506$var$markRootUpdated$1(rootFiber, 2), $fb2b12fdc6fd9506$var$ensureRootIsScheduled(rootFiber));
}
function $fb2b12fdc6fd9506$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $fb2b12fdc6fd9506$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $fb2b12fdc6fd9506$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $fb2b12fdc6fd9506$var$legacyErrorBoundariesThatAlreadyFailed || !$fb2b12fdc6fd9506$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $fb2b12fdc6fd9506$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $fb2b12fdc6fd9506$var$createClassErrorUpdate(2);
                instance = $fb2b12fdc6fd9506$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($fb2b12fdc6fd9506$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $fb2b12fdc6fd9506$var$markRootUpdated$1(instance, 2), $fb2b12fdc6fd9506$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $fb2b12fdc6fd9506$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $fb2b12fdc6fd9506$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($fb2b12fdc6fd9506$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $fb2b12fdc6fd9506$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $fb2b12fdc6fd9506$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $fb2b12fdc6fd9506$var$workInProgressRoot === root && ($fb2b12fdc6fd9506$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $fb2b12fdc6fd9506$var$workInProgressRootExitStatus || 3 === $fb2b12fdc6fd9506$var$workInProgressRootExitStatus && ($fb2b12fdc6fd9506$var$workInProgressRootRenderLanes & 62914560) === $fb2b12fdc6fd9506$var$workInProgressRootRenderLanes && 300 > $fb2b12fdc6fd9506$var$now() - $fb2b12fdc6fd9506$var$globalMostRecentFallbackTime ? 0 === ($fb2b12fdc6fd9506$var$executionContext & 2) && $fb2b12fdc6fd9506$var$prepareFreshStack(root, 0) : $fb2b12fdc6fd9506$var$workInProgressRootPingedLanes |= pingedLanes, $fb2b12fdc6fd9506$var$workInProgressSuspendedRetryLanes === $fb2b12fdc6fd9506$var$workInProgressRootRenderLanes && ($fb2b12fdc6fd9506$var$workInProgressSuspendedRetryLanes = 0));
    $fb2b12fdc6fd9506$var$ensureRootIsScheduled(root);
}
function $fb2b12fdc6fd9506$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $fb2b12fdc6fd9506$var$claimNextRetryLane());
    boundaryFiber = $fb2b12fdc6fd9506$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($fb2b12fdc6fd9506$var$markRootUpdated$1(boundaryFiber, retryLane), $fb2b12fdc6fd9506$var$ensureRootIsScheduled(boundaryFiber));
}
function $fb2b12fdc6fd9506$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $fb2b12fdc6fd9506$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $fb2b12fdc6fd9506$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $fb2b12fdc6fd9506$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $fb2b12fdc6fd9506$var$scheduleCallback$1(priorityLevel, callback) {
    return $fb2b12fdc6fd9506$var$scheduleCallback$3(priorityLevel, callback);
}
var $fb2b12fdc6fd9506$var$firstScheduledRoot = null, $fb2b12fdc6fd9506$var$lastScheduledRoot = null, $fb2b12fdc6fd9506$var$didScheduleMicrotask = !1, $fb2b12fdc6fd9506$var$mightHavePendingSyncWork = !1, $fb2b12fdc6fd9506$var$isFlushingWork = !1, $fb2b12fdc6fd9506$var$currentEventTransitionLane = 0;
function $fb2b12fdc6fd9506$var$ensureRootIsScheduled(root) {
    root !== $fb2b12fdc6fd9506$var$lastScheduledRoot && null === root.next && (null === $fb2b12fdc6fd9506$var$lastScheduledRoot ? $fb2b12fdc6fd9506$var$firstScheduledRoot = $fb2b12fdc6fd9506$var$lastScheduledRoot = root : $fb2b12fdc6fd9506$var$lastScheduledRoot = $fb2b12fdc6fd9506$var$lastScheduledRoot.next = root);
    $fb2b12fdc6fd9506$var$mightHavePendingSyncWork = !0;
    $fb2b12fdc6fd9506$var$didScheduleMicrotask || ($fb2b12fdc6fd9506$var$didScheduleMicrotask = !0, $fb2b12fdc6fd9506$var$scheduleImmediateRootScheduleTask());
}
function $fb2b12fdc6fd9506$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$fb2b12fdc6fd9506$var$isFlushingWork && $fb2b12fdc6fd9506$var$mightHavePendingSyncWork) {
        $fb2b12fdc6fd9506$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $fb2b12fdc6fd9506$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $fb2b12fdc6fd9506$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $fb2b12fdc6fd9506$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $fb2b12fdc6fd9506$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $fb2b12fdc6fd9506$var$getNextLanes(root$170, root$170 === $fb2b12fdc6fd9506$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $fb2b12fdc6fd9506$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $fb2b12fdc6fd9506$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $fb2b12fdc6fd9506$var$isFlushingWork = !1;
    }
}
function $fb2b12fdc6fd9506$var$processRootScheduleInImmediateTask() {
    $fb2b12fdc6fd9506$var$processRootScheduleInMicrotask();
}
function $fb2b12fdc6fd9506$var$processRootScheduleInMicrotask() {
    $fb2b12fdc6fd9506$var$mightHavePendingSyncWork = $fb2b12fdc6fd9506$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $fb2b12fdc6fd9506$var$currentEventTransitionLane && $fb2b12fdc6fd9506$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $fb2b12fdc6fd9506$var$currentEventTransitionLane);
    for(var currentTime = $fb2b12fdc6fd9506$var$now(), prev = null, root = $fb2b12fdc6fd9506$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $fb2b12fdc6fd9506$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $fb2b12fdc6fd9506$var$firstScheduledRoot = next : prev.next = next, null === next && ($fb2b12fdc6fd9506$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $fb2b12fdc6fd9506$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $fb2b12fdc6fd9506$var$pendingEffectsStatus && 5 !== $fb2b12fdc6fd9506$var$pendingEffectsStatus || $fb2b12fdc6fd9506$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $fb2b12fdc6fd9506$var$currentEventTransitionLane && ($fb2b12fdc6fd9506$var$currentEventTransitionLane = 0);
}
function $fb2b12fdc6fd9506$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $fb2b12fdc6fd9506$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $fb2b12fdc6fd9506$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $fb2b12fdc6fd9506$var$workInProgressRoot;
    suspendedLanes = $fb2b12fdc6fd9506$var$workInProgressRootRenderLanes;
    suspendedLanes = $fb2b12fdc6fd9506$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $fb2b12fdc6fd9506$var$workInProgressSuspendedReason || 9 === $fb2b12fdc6fd9506$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $fb2b12fdc6fd9506$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $fb2b12fdc6fd9506$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $fb2b12fdc6fd9506$var$cancelCallback$1(pingedLanes);
        switch($fb2b12fdc6fd9506$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $fb2b12fdc6fd9506$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $fb2b12fdc6fd9506$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $fb2b12fdc6fd9506$var$IdlePriority;
                break;
            default:
                suspendedLanes = $fb2b12fdc6fd9506$var$NormalPriority$1;
        }
        pingedLanes = $fb2b12fdc6fd9506$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $fb2b12fdc6fd9506$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $fb2b12fdc6fd9506$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $fb2b12fdc6fd9506$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $fb2b12fdc6fd9506$var$pendingEffectsStatus && 5 !== $fb2b12fdc6fd9506$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($fb2b12fdc6fd9506$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $fb2b12fdc6fd9506$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $fb2b12fdc6fd9506$var$getNextLanes(root, root === $fb2b12fdc6fd9506$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $fb2b12fdc6fd9506$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $fb2b12fdc6fd9506$var$scheduleTaskForRootDuringMicrotask(root, $fb2b12fdc6fd9506$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $fb2b12fdc6fd9506$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $fb2b12fdc6fd9506$var$performSyncWorkOnRoot(root, lanes) {
    if ($fb2b12fdc6fd9506$var$flushPendingEffects()) return null;
    $fb2b12fdc6fd9506$var$performWorkOnRoot(root, lanes, !0);
}
function $fb2b12fdc6fd9506$var$scheduleImmediateRootScheduleTask() {
    $fb2b12fdc6fd9506$var$scheduleMicrotask(function() {
        0 !== ($fb2b12fdc6fd9506$var$executionContext & 6) ? $fb2b12fdc6fd9506$var$scheduleCallback$3($fb2b12fdc6fd9506$var$ImmediatePriority, $fb2b12fdc6fd9506$var$processRootScheduleInImmediateTask) : $fb2b12fdc6fd9506$var$processRootScheduleInMicrotask();
    });
}
function $fb2b12fdc6fd9506$var$requestTransitionLane() {
    if (0 === $fb2b12fdc6fd9506$var$currentEventTransitionLane) {
        var actionScopeLane = $fb2b12fdc6fd9506$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $fb2b12fdc6fd9506$var$nextTransitionUpdateLane, $fb2b12fdc6fd9506$var$nextTransitionUpdateLane <<= 1, 0 === ($fb2b12fdc6fd9506$var$nextTransitionUpdateLane & 261888) && ($fb2b12fdc6fd9506$var$nextTransitionUpdateLane = 256));
        $fb2b12fdc6fd9506$var$currentEventTransitionLane = actionScopeLane;
    }
    return $fb2b12fdc6fd9506$var$currentEventTransitionLane;
}
function $fb2b12fdc6fd9506$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $fb2b12fdc6fd9506$var$sanitizeURL("" + actionProp);
}
function $fb2b12fdc6fd9506$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $fb2b12fdc6fd9506$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $fb2b12fdc6fd9506$var$coerceFormActionProp((nativeEventTarget[$fb2b12fdc6fd9506$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$fb2b12fdc6fd9506$var$internalPropsKey] || null) ? $fb2b12fdc6fd9506$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $fb2b12fdc6fd9506$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $fb2b12fdc6fd9506$var$currentEventTransitionLane) {
                                var formData = submitter ? $fb2b12fdc6fd9506$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $fb2b12fdc6fd9506$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $fb2b12fdc6fd9506$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $fb2b12fdc6fd9506$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $fb2b12fdc6fd9506$var$i$jscomp$inline_1577 = 0; $fb2b12fdc6fd9506$var$i$jscomp$inline_1577 < $fb2b12fdc6fd9506$var$simpleEventPluginEvents.length; $fb2b12fdc6fd9506$var$i$jscomp$inline_1577++){
    var $fb2b12fdc6fd9506$var$eventName$jscomp$inline_1578 = $fb2b12fdc6fd9506$var$simpleEventPluginEvents[$fb2b12fdc6fd9506$var$i$jscomp$inline_1577], $fb2b12fdc6fd9506$var$domEventName$jscomp$inline_1579 = $fb2b12fdc6fd9506$var$eventName$jscomp$inline_1578.toLowerCase(), $fb2b12fdc6fd9506$var$capitalizedEvent$jscomp$inline_1580 = $fb2b12fdc6fd9506$var$eventName$jscomp$inline_1578[0].toUpperCase() + $fb2b12fdc6fd9506$var$eventName$jscomp$inline_1578.slice(1);
    $fb2b12fdc6fd9506$var$registerSimpleEvent($fb2b12fdc6fd9506$var$domEventName$jscomp$inline_1579, "on" + $fb2b12fdc6fd9506$var$capitalizedEvent$jscomp$inline_1580);
}
$fb2b12fdc6fd9506$var$registerSimpleEvent($fb2b12fdc6fd9506$var$ANIMATION_END, "onAnimationEnd");
$fb2b12fdc6fd9506$var$registerSimpleEvent($fb2b12fdc6fd9506$var$ANIMATION_ITERATION, "onAnimationIteration");
$fb2b12fdc6fd9506$var$registerSimpleEvent($fb2b12fdc6fd9506$var$ANIMATION_START, "onAnimationStart");
$fb2b12fdc6fd9506$var$registerSimpleEvent("dblclick", "onDoubleClick");
$fb2b12fdc6fd9506$var$registerSimpleEvent("focusin", "onFocus");
$fb2b12fdc6fd9506$var$registerSimpleEvent("focusout", "onBlur");
$fb2b12fdc6fd9506$var$registerSimpleEvent($fb2b12fdc6fd9506$var$TRANSITION_RUN, "onTransitionRun");
$fb2b12fdc6fd9506$var$registerSimpleEvent($fb2b12fdc6fd9506$var$TRANSITION_START, "onTransitionStart");
$fb2b12fdc6fd9506$var$registerSimpleEvent($fb2b12fdc6fd9506$var$TRANSITION_CANCEL, "onTransitionCancel");
$fb2b12fdc6fd9506$var$registerSimpleEvent($fb2b12fdc6fd9506$var$TRANSITION_END, "onTransitionEnd");
$fb2b12fdc6fd9506$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$fb2b12fdc6fd9506$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$fb2b12fdc6fd9506$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$fb2b12fdc6fd9506$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$fb2b12fdc6fd9506$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$fb2b12fdc6fd9506$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$fb2b12fdc6fd9506$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$fb2b12fdc6fd9506$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$fb2b12fdc6fd9506$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$fb2b12fdc6fd9506$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $fb2b12fdc6fd9506$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $fb2b12fdc6fd9506$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($fb2b12fdc6fd9506$var$mediaEventTypes));
function $fb2b12fdc6fd9506$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $fb2b12fdc6fd9506$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $fb2b12fdc6fd9506$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $fb2b12fdc6fd9506$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$fb2b12fdc6fd9506$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$fb2b12fdc6fd9506$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($fb2b12fdc6fd9506$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $fb2b12fdc6fd9506$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $fb2b12fdc6fd9506$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $fb2b12fdc6fd9506$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $fb2b12fdc6fd9506$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$fb2b12fdc6fd9506$var$listeningMarker]) {
        rootContainerElement[$fb2b12fdc6fd9506$var$listeningMarker] = !0;
        $fb2b12fdc6fd9506$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($fb2b12fdc6fd9506$var$nonDelegatedEvents.has(domEventName) || $fb2b12fdc6fd9506$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $fb2b12fdc6fd9506$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$fb2b12fdc6fd9506$var$listeningMarker] || (ownerDocument[$fb2b12fdc6fd9506$var$listeningMarker] = !0, $fb2b12fdc6fd9506$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $fb2b12fdc6fd9506$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($fb2b12fdc6fd9506$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $fb2b12fdc6fd9506$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $fb2b12fdc6fd9506$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $fb2b12fdc6fd9506$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$fb2b12fdc6fd9506$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $fb2b12fdc6fd9506$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $fb2b12fdc6fd9506$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $fb2b12fdc6fd9506$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $fb2b12fdc6fd9506$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $fb2b12fdc6fd9506$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $fb2b12fdc6fd9506$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $fb2b12fdc6fd9506$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $fb2b12fdc6fd9506$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $fb2b12fdc6fd9506$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $fb2b12fdc6fd9506$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $fb2b12fdc6fd9506$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $fb2b12fdc6fd9506$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $fb2b12fdc6fd9506$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $fb2b12fdc6fd9506$var$SyntheticTouchEvent;
                        break;
                    case $fb2b12fdc6fd9506$var$ANIMATION_END:
                    case $fb2b12fdc6fd9506$var$ANIMATION_ITERATION:
                    case $fb2b12fdc6fd9506$var$ANIMATION_START:
                        SyntheticEventCtor = $fb2b12fdc6fd9506$var$SyntheticAnimationEvent;
                        break;
                    case $fb2b12fdc6fd9506$var$TRANSITION_END:
                        SyntheticEventCtor = $fb2b12fdc6fd9506$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $fb2b12fdc6fd9506$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $fb2b12fdc6fd9506$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $fb2b12fdc6fd9506$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $fb2b12fdc6fd9506$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $fb2b12fdc6fd9506$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $fb2b12fdc6fd9506$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($fb2b12fdc6fd9506$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $fb2b12fdc6fd9506$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($fb2b12fdc6fd9506$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$fb2b12fdc6fd9506$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $fb2b12fdc6fd9506$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $fb2b12fdc6fd9506$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $fb2b12fdc6fd9506$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $fb2b12fdc6fd9506$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $fb2b12fdc6fd9506$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $fb2b12fdc6fd9506$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $fb2b12fdc6fd9506$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $fb2b12fdc6fd9506$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $fb2b12fdc6fd9506$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $fb2b12fdc6fd9506$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $fb2b12fdc6fd9506$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $fb2b12fdc6fd9506$var$getTargetInstForChangeEvent;
                else if ($fb2b12fdc6fd9506$var$isTextInputElement(reactName)) {
                    if ($fb2b12fdc6fd9506$var$isInputEventSupported) getTargetInstFunc = $fb2b12fdc6fd9506$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $fb2b12fdc6fd9506$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $fb2b12fdc6fd9506$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $fb2b12fdc6fd9506$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $fb2b12fdc6fd9506$var$getTargetInstForChangeEvent) : getTargetInstFunc = $fb2b12fdc6fd9506$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $fb2b12fdc6fd9506$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $fb2b12fdc6fd9506$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $fb2b12fdc6fd9506$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($fb2b12fdc6fd9506$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $fb2b12fdc6fd9506$var$activeElement = handleEventFunc, $fb2b12fdc6fd9506$var$activeElementInst = targetInst, $fb2b12fdc6fd9506$var$lastSelection = null;
                    break;
                case "focusout":
                    $fb2b12fdc6fd9506$var$lastSelection = $fb2b12fdc6fd9506$var$activeElementInst = $fb2b12fdc6fd9506$var$activeElement = null;
                    break;
                case "mousedown":
                    $fb2b12fdc6fd9506$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $fb2b12fdc6fd9506$var$mouseDown = !1;
                    $fb2b12fdc6fd9506$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($fb2b12fdc6fd9506$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $fb2b12fdc6fd9506$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($fb2b12fdc6fd9506$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $fb2b12fdc6fd9506$var$isComposing ? $fb2b12fdc6fd9506$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($fb2b12fdc6fd9506$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($fb2b12fdc6fd9506$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $fb2b12fdc6fd9506$var$isComposing && (fallbackData = $fb2b12fdc6fd9506$var$getData()) : ($fb2b12fdc6fd9506$var$root = nativeEventTarget, $fb2b12fdc6fd9506$var$startText = "value" in $fb2b12fdc6fd9506$var$root ? $fb2b12fdc6fd9506$var$root.value : $fb2b12fdc6fd9506$var$root.textContent, $fb2b12fdc6fd9506$var$isComposing = !0)), handleEventFunc = $fb2b12fdc6fd9506$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $fb2b12fdc6fd9506$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $fb2b12fdc6fd9506$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $fb2b12fdc6fd9506$var$canUseTextInputEvent ? $fb2b12fdc6fd9506$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $fb2b12fdc6fd9506$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $fb2b12fdc6fd9506$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $fb2b12fdc6fd9506$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $fb2b12fdc6fd9506$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $fb2b12fdc6fd9506$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $fb2b12fdc6fd9506$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $fb2b12fdc6fd9506$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $fb2b12fdc6fd9506$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($fb2b12fdc6fd9506$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $fb2b12fdc6fd9506$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($fb2b12fdc6fd9506$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $fb2b12fdc6fd9506$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $fb2b12fdc6fd9506$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $fb2b12fdc6fd9506$var$getListener(target, registrationName), null != stateNode && listeners.unshift($fb2b12fdc6fd9506$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $fb2b12fdc6fd9506$var$getListener(target, registrationName), null != stateNode && listeners.push($fb2b12fdc6fd9506$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $fb2b12fdc6fd9506$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $fb2b12fdc6fd9506$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $fb2b12fdc6fd9506$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($fb2b12fdc6fd9506$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($fb2b12fdc6fd9506$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $fb2b12fdc6fd9506$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $fb2b12fdc6fd9506$var$normalizeMarkupForTextOrAttribute(clientText);
    return $fb2b12fdc6fd9506$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $fb2b12fdc6fd9506$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $fb2b12fdc6fd9506$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $fb2b12fdc6fd9506$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $fb2b12fdc6fd9506$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $fb2b12fdc6fd9506$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $fb2b12fdc6fd9506$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $fb2b12fdc6fd9506$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $fb2b12fdc6fd9506$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $fb2b12fdc6fd9506$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $fb2b12fdc6fd9506$var$setProp(domElement, tag, "name", props.name, props, null), $fb2b12fdc6fd9506$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $fb2b12fdc6fd9506$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $fb2b12fdc6fd9506$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($fb2b12fdc6fd9506$var$setProp(domElement, tag, "encType", props.encType, props, null), $fb2b12fdc6fd9506$var$setProp(domElement, tag, "method", props.method, props, null), $fb2b12fdc6fd9506$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $fb2b12fdc6fd9506$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $fb2b12fdc6fd9506$var$noop$1);
            break;
        case "onScroll":
            null != value && $fb2b12fdc6fd9506$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $fb2b12fdc6fd9506$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $fb2b12fdc6fd9506$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $fb2b12fdc6fd9506$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $fb2b12fdc6fd9506$var$listenToNonDelegatedEvent("toggle", domElement);
            $fb2b12fdc6fd9506$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $fb2b12fdc6fd9506$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $fb2b12fdc6fd9506$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $fb2b12fdc6fd9506$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $fb2b12fdc6fd9506$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $fb2b12fdc6fd9506$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $fb2b12fdc6fd9506$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $fb2b12fdc6fd9506$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $fb2b12fdc6fd9506$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $fb2b12fdc6fd9506$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $fb2b12fdc6fd9506$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $fb2b12fdc6fd9506$var$aliases.get(key) || key, $fb2b12fdc6fd9506$var$setValueForAttribute(domElement, key, value);
    }
}
function $fb2b12fdc6fd9506$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $fb2b12fdc6fd9506$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $fb2b12fdc6fd9506$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $fb2b12fdc6fd9506$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $fb2b12fdc6fd9506$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $fb2b12fdc6fd9506$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $fb2b12fdc6fd9506$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$fb2b12fdc6fd9506$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$fb2b12fdc6fd9506$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $fb2b12fdc6fd9506$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $fb2b12fdc6fd9506$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $fb2b12fdc6fd9506$var$listenToNonDelegatedEvent("error", domElement);
            $fb2b12fdc6fd9506$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(137, tag));
                    default:
                        $fb2b12fdc6fd9506$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $fb2b12fdc6fd9506$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $fb2b12fdc6fd9506$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $fb2b12fdc6fd9506$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $fb2b12fdc6fd9506$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $fb2b12fdc6fd9506$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $fb2b12fdc6fd9506$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $fb2b12fdc6fd9506$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $fb2b12fdc6fd9506$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $fb2b12fdc6fd9506$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $fb2b12fdc6fd9506$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(91));
                    break;
                default:
                    $fb2b12fdc6fd9506$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $fb2b12fdc6fd9506$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $fb2b12fdc6fd9506$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $fb2b12fdc6fd9506$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $fb2b12fdc6fd9506$var$listenToNonDelegatedEvent("toggle", domElement);
            $fb2b12fdc6fd9506$var$listenToNonDelegatedEvent("cancel", domElement);
            $fb2b12fdc6fd9506$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $fb2b12fdc6fd9506$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $fb2b12fdc6fd9506$var$mediaEventTypes.length; hasSrc++)$fb2b12fdc6fd9506$var$listenToNonDelegatedEvent($fb2b12fdc6fd9506$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $fb2b12fdc6fd9506$var$listenToNonDelegatedEvent("error", domElement);
            $fb2b12fdc6fd9506$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $fb2b12fdc6fd9506$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $fb2b12fdc6fd9506$var$listenToNonDelegatedEvent("error", domElement), $fb2b12fdc6fd9506$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(137, tag));
                default:
                    $fb2b12fdc6fd9506$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($fb2b12fdc6fd9506$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $fb2b12fdc6fd9506$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $fb2b12fdc6fd9506$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $fb2b12fdc6fd9506$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $fb2b12fdc6fd9506$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $fb2b12fdc6fd9506$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $fb2b12fdc6fd9506$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $fb2b12fdc6fd9506$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $fb2b12fdc6fd9506$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $fb2b12fdc6fd9506$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $fb2b12fdc6fd9506$var$updateOptions(domElement, !!lastProps, tag, !0) : $fb2b12fdc6fd9506$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $fb2b12fdc6fd9506$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $fb2b12fdc6fd9506$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $fb2b12fdc6fd9506$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $fb2b12fdc6fd9506$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $fb2b12fdc6fd9506$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $fb2b12fdc6fd9506$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $fb2b12fdc6fd9506$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($fb2b12fdc6fd9506$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $fb2b12fdc6fd9506$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $fb2b12fdc6fd9506$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $fb2b12fdc6fd9506$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $fb2b12fdc6fd9506$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $fb2b12fdc6fd9506$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $fb2b12fdc6fd9506$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $fb2b12fdc6fd9506$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $fb2b12fdc6fd9506$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $fb2b12fdc6fd9506$var$eventsEnabled = null, $fb2b12fdc6fd9506$var$selectionInformation = null;
function $fb2b12fdc6fd9506$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $fb2b12fdc6fd9506$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $fb2b12fdc6fd9506$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $fb2b12fdc6fd9506$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $fb2b12fdc6fd9506$var$currentPopstateTransitionEvent = null;
function $fb2b12fdc6fd9506$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $fb2b12fdc6fd9506$var$currentPopstateTransitionEvent) return !1;
        $fb2b12fdc6fd9506$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $fb2b12fdc6fd9506$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $fb2b12fdc6fd9506$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $fb2b12fdc6fd9506$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $fb2b12fdc6fd9506$var$localPromise = "function" === typeof Promise ? Promise : void 0, $fb2b12fdc6fd9506$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $fb2b12fdc6fd9506$var$localPromise ? function(callback) {
    return $fb2b12fdc6fd9506$var$localPromise.resolve(null).then(callback).catch($fb2b12fdc6fd9506$var$handleErrorInNextTick);
} : $fb2b12fdc6fd9506$var$scheduleTimeout;
function $fb2b12fdc6fd9506$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $fb2b12fdc6fd9506$var$isSingletonScope(type) {
    return "head" === type;
}
function $fb2b12fdc6fd9506$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $fb2b12fdc6fd9506$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $fb2b12fdc6fd9506$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $fb2b12fdc6fd9506$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$fb2b12fdc6fd9506$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $fb2b12fdc6fd9506$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $fb2b12fdc6fd9506$var$retryIfBlockedOn(hydrationInstance);
}
function $fb2b12fdc6fd9506$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $fb2b12fdc6fd9506$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $fb2b12fdc6fd9506$var$clearContainerSparingly(node);
                $fb2b12fdc6fd9506$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $fb2b12fdc6fd9506$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$fb2b12fdc6fd9506$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $fb2b12fdc6fd9506$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $fb2b12fdc6fd9506$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $fb2b12fdc6fd9506$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $fb2b12fdc6fd9506$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $fb2b12fdc6fd9506$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $fb2b12fdc6fd9506$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $fb2b12fdc6fd9506$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $fb2b12fdc6fd9506$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $fb2b12fdc6fd9506$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $fb2b12fdc6fd9506$var$previousHydratableOnEnteringScopedSingleton = null;
function $fb2b12fdc6fd9506$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $fb2b12fdc6fd9506$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $fb2b12fdc6fd9506$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $fb2b12fdc6fd9506$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $fb2b12fdc6fd9506$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(451));
    }
}
function $fb2b12fdc6fd9506$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $fb2b12fdc6fd9506$var$detachDeletedInstance(instance);
}
var $fb2b12fdc6fd9506$var$preloadPropsMap = new Map(), $fb2b12fdc6fd9506$var$preconnectsSet = new Set();
function $fb2b12fdc6fd9506$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $fb2b12fdc6fd9506$var$previousDispatcher = $fb2b12fdc6fd9506$var$ReactDOMSharedInternals.d;
$fb2b12fdc6fd9506$var$ReactDOMSharedInternals.d = {
    f: $fb2b12fdc6fd9506$var$flushSyncWork,
    r: $fb2b12fdc6fd9506$var$requestFormReset,
    D: $fb2b12fdc6fd9506$var$prefetchDNS,
    C: $fb2b12fdc6fd9506$var$preconnect,
    L: $fb2b12fdc6fd9506$var$preload,
    m: $fb2b12fdc6fd9506$var$preloadModule,
    X: $fb2b12fdc6fd9506$var$preinitScript,
    S: $fb2b12fdc6fd9506$var$preinitStyle,
    M: $fb2b12fdc6fd9506$var$preinitModuleScript
};
function $fb2b12fdc6fd9506$var$flushSyncWork() {
    var previousWasRendering = $fb2b12fdc6fd9506$var$previousDispatcher.f(), wasRendering = $fb2b12fdc6fd9506$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $fb2b12fdc6fd9506$var$requestFormReset(form) {
    var formInst = $fb2b12fdc6fd9506$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $fb2b12fdc6fd9506$var$requestFormReset$1(formInst) : $fb2b12fdc6fd9506$var$previousDispatcher.r(form);
}
var $fb2b12fdc6fd9506$var$globalDocument = "undefined" === typeof document ? null : document;
function $fb2b12fdc6fd9506$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $fb2b12fdc6fd9506$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $fb2b12fdc6fd9506$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $fb2b12fdc6fd9506$var$preconnectsSet.has(limitedEscapedHref) || ($fb2b12fdc6fd9506$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $fb2b12fdc6fd9506$var$setInitialProperties(href, "link", rel), $fb2b12fdc6fd9506$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $fb2b12fdc6fd9506$var$prefetchDNS(href) {
    $fb2b12fdc6fd9506$var$previousDispatcher.D(href);
    $fb2b12fdc6fd9506$var$preconnectAs("dns-prefetch", href, null);
}
function $fb2b12fdc6fd9506$var$preconnect(href, crossOrigin) {
    $fb2b12fdc6fd9506$var$previousDispatcher.C(href, crossOrigin);
    $fb2b12fdc6fd9506$var$preconnectAs("preconnect", href, crossOrigin);
}
function $fb2b12fdc6fd9506$var$preload(href, as, options) {
    $fb2b12fdc6fd9506$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $fb2b12fdc6fd9506$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $fb2b12fdc6fd9506$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $fb2b12fdc6fd9506$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $fb2b12fdc6fd9506$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $fb2b12fdc6fd9506$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $fb2b12fdc6fd9506$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $fb2b12fdc6fd9506$var$getStyleKey(href);
                break;
            case "script":
                key = $fb2b12fdc6fd9506$var$getScriptKey(href);
        }
        $fb2b12fdc6fd9506$var$preloadPropsMap.has(key) || (href = $fb2b12fdc6fd9506$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $fb2b12fdc6fd9506$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($fb2b12fdc6fd9506$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($fb2b12fdc6fd9506$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $fb2b12fdc6fd9506$var$setInitialProperties(as, "link", href), $fb2b12fdc6fd9506$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $fb2b12fdc6fd9506$var$preloadModule(href, options) {
    $fb2b12fdc6fd9506$var$previousDispatcher.m(href, options);
    var ownerDocument = $fb2b12fdc6fd9506$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $fb2b12fdc6fd9506$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $fb2b12fdc6fd9506$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $fb2b12fdc6fd9506$var$getScriptKey(href);
        }
        if (!$fb2b12fdc6fd9506$var$preloadPropsMap.has(key) && (href = $fb2b12fdc6fd9506$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $fb2b12fdc6fd9506$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($fb2b12fdc6fd9506$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $fb2b12fdc6fd9506$var$setInitialProperties(as, "link", href);
            $fb2b12fdc6fd9506$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $fb2b12fdc6fd9506$var$preinitStyle(href, precedence, options) {
    $fb2b12fdc6fd9506$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $fb2b12fdc6fd9506$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $fb2b12fdc6fd9506$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $fb2b12fdc6fd9506$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($fb2b12fdc6fd9506$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $fb2b12fdc6fd9506$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $fb2b12fdc6fd9506$var$preloadPropsMap.get(key)) && $fb2b12fdc6fd9506$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $fb2b12fdc6fd9506$var$markNodeAsHoistable(link);
                $fb2b12fdc6fd9506$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $fb2b12fdc6fd9506$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $fb2b12fdc6fd9506$var$preinitScript(src, options) {
    $fb2b12fdc6fd9506$var$previousDispatcher.X(src, options);
    var ownerDocument = $fb2b12fdc6fd9506$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $fb2b12fdc6fd9506$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $fb2b12fdc6fd9506$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($fb2b12fdc6fd9506$var$getScriptSelectorFromKey(key)), resource || (src = $fb2b12fdc6fd9506$var$assign({
            src: src,
            async: !0
        }, options), (options = $fb2b12fdc6fd9506$var$preloadPropsMap.get(key)) && $fb2b12fdc6fd9506$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $fb2b12fdc6fd9506$var$markNodeAsHoistable(resource), $fb2b12fdc6fd9506$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $fb2b12fdc6fd9506$var$preinitModuleScript(src, options) {
    $fb2b12fdc6fd9506$var$previousDispatcher.M(src, options);
    var ownerDocument = $fb2b12fdc6fd9506$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $fb2b12fdc6fd9506$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $fb2b12fdc6fd9506$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($fb2b12fdc6fd9506$var$getScriptSelectorFromKey(key)), resource || (src = $fb2b12fdc6fd9506$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $fb2b12fdc6fd9506$var$preloadPropsMap.get(key)) && $fb2b12fdc6fd9506$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $fb2b12fdc6fd9506$var$markNodeAsHoistable(resource), $fb2b12fdc6fd9506$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $fb2b12fdc6fd9506$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $fb2b12fdc6fd9506$var$rootInstanceStackCursor.current) ? $fb2b12fdc6fd9506$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $fb2b12fdc6fd9506$var$getStyleKey(pendingProps.href), pendingProps = $fb2b12fdc6fd9506$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $fb2b12fdc6fd9506$var$getStyleKey(pendingProps.href);
                var styles$243 = $fb2b12fdc6fd9506$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($fb2b12fdc6fd9506$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $fb2b12fdc6fd9506$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $fb2b12fdc6fd9506$var$preloadPropsMap.set(type, pendingProps), styles$243 || $fb2b12fdc6fd9506$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $fb2b12fdc6fd9506$var$getScriptKey(pendingProps), pendingProps = $fb2b12fdc6fd9506$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(444, type));
    }
}
function $fb2b12fdc6fd9506$var$getStyleKey(href) {
    return 'href="' + $fb2b12fdc6fd9506$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $fb2b12fdc6fd9506$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $fb2b12fdc6fd9506$var$stylesheetPropsFromRawProps(rawProps) {
    return $fb2b12fdc6fd9506$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $fb2b12fdc6fd9506$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $fb2b12fdc6fd9506$var$setInitialProperties(key, "link", preloadProps), $fb2b12fdc6fd9506$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $fb2b12fdc6fd9506$var$getScriptKey(src) {
    return '[src="' + $fb2b12fdc6fd9506$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $fb2b12fdc6fd9506$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $fb2b12fdc6fd9506$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $fb2b12fdc6fd9506$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $fb2b12fdc6fd9506$var$markNodeAsHoistable(instance), instance;
            var styleProps = $fb2b12fdc6fd9506$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $fb2b12fdc6fd9506$var$markNodeAsHoistable(instance);
            $fb2b12fdc6fd9506$var$setInitialProperties(instance, "style", styleProps);
            $fb2b12fdc6fd9506$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $fb2b12fdc6fd9506$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($fb2b12fdc6fd9506$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $fb2b12fdc6fd9506$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $fb2b12fdc6fd9506$var$stylesheetPropsFromRawProps(props);
            (styleProps = $fb2b12fdc6fd9506$var$preloadPropsMap.get(styleProps)) && $fb2b12fdc6fd9506$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $fb2b12fdc6fd9506$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $fb2b12fdc6fd9506$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $fb2b12fdc6fd9506$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $fb2b12fdc6fd9506$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($fb2b12fdc6fd9506$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $fb2b12fdc6fd9506$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $fb2b12fdc6fd9506$var$preloadPropsMap.get(instance$249)) instance = $fb2b12fdc6fd9506$var$assign({}, props), $fb2b12fdc6fd9506$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $fb2b12fdc6fd9506$var$markNodeAsHoistable(styleProps);
            $fb2b12fdc6fd9506$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $fb2b12fdc6fd9506$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $fb2b12fdc6fd9506$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $fb2b12fdc6fd9506$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $fb2b12fdc6fd9506$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $fb2b12fdc6fd9506$var$tagCaches = null;
function $fb2b12fdc6fd9506$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $fb2b12fdc6fd9506$var$tagCaches) {
        var cache = new Map();
        var caches = $fb2b12fdc6fd9506$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $fb2b12fdc6fd9506$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$fb2b12fdc6fd9506$var$internalHoistableMarker] || node[$fb2b12fdc6fd9506$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $fb2b12fdc6fd9506$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $fb2b12fdc6fd9506$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $fb2b12fdc6fd9506$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $fb2b12fdc6fd9506$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $fb2b12fdc6fd9506$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($fb2b12fdc6fd9506$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $fb2b12fdc6fd9506$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $fb2b12fdc6fd9506$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $fb2b12fdc6fd9506$var$stylesheetPropsFromRawProps(props);
            (key = $fb2b12fdc6fd9506$var$preloadPropsMap.get(key)) && $fb2b12fdc6fd9506$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $fb2b12fdc6fd9506$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $fb2b12fdc6fd9506$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $fb2b12fdc6fd9506$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $fb2b12fdc6fd9506$var$estimatedBytesWithinLimit = 0;
function $fb2b12fdc6fd9506$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $fb2b12fdc6fd9506$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $fb2b12fdc6fd9506$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $fb2b12fdc6fd9506$var$estimatedBytesWithinLimit && ($fb2b12fdc6fd9506$var$estimatedBytesWithinLimit = 62500 * $fb2b12fdc6fd9506$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $fb2b12fdc6fd9506$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $fb2b12fdc6fd9506$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $fb2b12fdc6fd9506$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $fb2b12fdc6fd9506$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $fb2b12fdc6fd9506$var$precedencesByRoot = null;
function $fb2b12fdc6fd9506$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $fb2b12fdc6fd9506$var$precedencesByRoot = new Map(), resources.forEach($fb2b12fdc6fd9506$var$insertStylesheetIntoRoot, state), $fb2b12fdc6fd9506$var$precedencesByRoot = null, $fb2b12fdc6fd9506$var$onUnsuspend.call(state));
}
function $fb2b12fdc6fd9506$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $fb2b12fdc6fd9506$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $fb2b12fdc6fd9506$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $fb2b12fdc6fd9506$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $fb2b12fdc6fd9506$var$HostTransitionContext = {
    $$typeof: $fb2b12fdc6fd9506$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $fb2b12fdc6fd9506$var$sharedNotPendingObject,
    _currentValue2: $fb2b12fdc6fd9506$var$sharedNotPendingObject,
    _threadCount: 0
};
function $fb2b12fdc6fd9506$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $fb2b12fdc6fd9506$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $fb2b12fdc6fd9506$var$createLaneMap(0);
    this.hiddenUpdates = $fb2b12fdc6fd9506$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $fb2b12fdc6fd9506$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $fb2b12fdc6fd9506$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $fb2b12fdc6fd9506$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $fb2b12fdc6fd9506$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $fb2b12fdc6fd9506$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $fb2b12fdc6fd9506$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $fb2b12fdc6fd9506$var$emptyContextObject;
    parentComponent = $fb2b12fdc6fd9506$var$emptyContextObject;
    return parentComponent;
}
function $fb2b12fdc6fd9506$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $fb2b12fdc6fd9506$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $fb2b12fdc6fd9506$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $fb2b12fdc6fd9506$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($fb2b12fdc6fd9506$var$scheduleUpdateOnFiber(element, rootFiber, lane), $fb2b12fdc6fd9506$var$entangleTransitions(element, rootFiber, lane));
}
function $fb2b12fdc6fd9506$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $fb2b12fdc6fd9506$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $fb2b12fdc6fd9506$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $fb2b12fdc6fd9506$var$markRetryLaneImpl(fiber, retryLane);
}
function $fb2b12fdc6fd9506$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $fb2b12fdc6fd9506$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $fb2b12fdc6fd9506$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $fb2b12fdc6fd9506$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $fb2b12fdc6fd9506$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $fb2b12fdc6fd9506$var$requestUpdateLane();
        lane = $fb2b12fdc6fd9506$var$getBumpedLaneForHydrationByLane(lane);
        var root = $fb2b12fdc6fd9506$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $fb2b12fdc6fd9506$var$scheduleUpdateOnFiber(root, fiber, lane);
        $fb2b12fdc6fd9506$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $fb2b12fdc6fd9506$var$_enabled = !0;
function $fb2b12fdc6fd9506$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $fb2b12fdc6fd9506$var$ReactSharedInternals.T;
    $fb2b12fdc6fd9506$var$ReactSharedInternals.T = null;
    var previousPriority = $fb2b12fdc6fd9506$var$ReactDOMSharedInternals.p;
    try {
        $fb2b12fdc6fd9506$var$ReactDOMSharedInternals.p = 2, $fb2b12fdc6fd9506$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $fb2b12fdc6fd9506$var$ReactDOMSharedInternals.p = previousPriority, $fb2b12fdc6fd9506$var$ReactSharedInternals.T = prevTransition;
    }
}
function $fb2b12fdc6fd9506$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $fb2b12fdc6fd9506$var$ReactSharedInternals.T;
    $fb2b12fdc6fd9506$var$ReactSharedInternals.T = null;
    var previousPriority = $fb2b12fdc6fd9506$var$ReactDOMSharedInternals.p;
    try {
        $fb2b12fdc6fd9506$var$ReactDOMSharedInternals.p = 8, $fb2b12fdc6fd9506$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $fb2b12fdc6fd9506$var$ReactDOMSharedInternals.p = previousPriority, $fb2b12fdc6fd9506$var$ReactSharedInternals.T = prevTransition;
    }
}
function $fb2b12fdc6fd9506$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($fb2b12fdc6fd9506$var$_enabled) {
        var blockedOn = $fb2b12fdc6fd9506$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $fb2b12fdc6fd9506$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $fb2b12fdc6fd9506$var$return_targetInst, targetContainer), $fb2b12fdc6fd9506$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($fb2b12fdc6fd9506$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($fb2b12fdc6fd9506$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $fb2b12fdc6fd9506$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $fb2b12fdc6fd9506$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $fb2b12fdc6fd9506$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $fb2b12fdc6fd9506$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $fb2b12fdc6fd9506$var$ensureRootIsScheduled(fiber);
                                0 === ($fb2b12fdc6fd9506$var$executionContext & 6) && ($fb2b12fdc6fd9506$var$workInProgressRootRenderTargetTime = $fb2b12fdc6fd9506$var$now() + 500, $fb2b12fdc6fd9506$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $fb2b12fdc6fd9506$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $fb2b12fdc6fd9506$var$scheduleUpdateOnFiber(root, fiber, 2), $fb2b12fdc6fd9506$var$flushSyncWork$1(), $fb2b12fdc6fd9506$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $fb2b12fdc6fd9506$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $fb2b12fdc6fd9506$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $fb2b12fdc6fd9506$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $fb2b12fdc6fd9506$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $fb2b12fdc6fd9506$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $fb2b12fdc6fd9506$var$getEventTarget(nativeEvent);
    return $fb2b12fdc6fd9506$var$findInstanceBlockingTarget(nativeEvent);
}
var $fb2b12fdc6fd9506$var$return_targetInst = null;
function $fb2b12fdc6fd9506$var$findInstanceBlockingTarget(targetNode) {
    $fb2b12fdc6fd9506$var$return_targetInst = null;
    targetNode = $fb2b12fdc6fd9506$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $fb2b12fdc6fd9506$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $fb2b12fdc6fd9506$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $fb2b12fdc6fd9506$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $fb2b12fdc6fd9506$var$return_targetInst = targetNode;
    return null;
}
function $fb2b12fdc6fd9506$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($fb2b12fdc6fd9506$var$getCurrentPriorityLevel()){
                case $fb2b12fdc6fd9506$var$ImmediatePriority:
                    return 2;
                case $fb2b12fdc6fd9506$var$UserBlockingPriority:
                    return 8;
                case $fb2b12fdc6fd9506$var$NormalPriority$1:
                case $fb2b12fdc6fd9506$var$LowPriority:
                    return 32;
                case $fb2b12fdc6fd9506$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $fb2b12fdc6fd9506$var$hasScheduledReplayAttempt = !1, $fb2b12fdc6fd9506$var$queuedFocus = null, $fb2b12fdc6fd9506$var$queuedDrag = null, $fb2b12fdc6fd9506$var$queuedMouse = null, $fb2b12fdc6fd9506$var$queuedPointers = new Map(), $fb2b12fdc6fd9506$var$queuedPointerCaptures = new Map(), $fb2b12fdc6fd9506$var$queuedExplicitHydrationTargets = [], $fb2b12fdc6fd9506$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $fb2b12fdc6fd9506$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $fb2b12fdc6fd9506$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $fb2b12fdc6fd9506$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $fb2b12fdc6fd9506$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $fb2b12fdc6fd9506$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $fb2b12fdc6fd9506$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $fb2b12fdc6fd9506$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $fb2b12fdc6fd9506$var$getInstanceFromNode(blockedOn), null !== blockedOn && $fb2b12fdc6fd9506$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $fb2b12fdc6fd9506$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $fb2b12fdc6fd9506$var$queuedFocus = $fb2b12fdc6fd9506$var$accumulateOrCreateContinuousQueuedReplayableEvent($fb2b12fdc6fd9506$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $fb2b12fdc6fd9506$var$queuedDrag = $fb2b12fdc6fd9506$var$accumulateOrCreateContinuousQueuedReplayableEvent($fb2b12fdc6fd9506$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $fb2b12fdc6fd9506$var$queuedMouse = $fb2b12fdc6fd9506$var$accumulateOrCreateContinuousQueuedReplayableEvent($fb2b12fdc6fd9506$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $fb2b12fdc6fd9506$var$queuedPointers.set(pointerId, $fb2b12fdc6fd9506$var$accumulateOrCreateContinuousQueuedReplayableEvent($fb2b12fdc6fd9506$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $fb2b12fdc6fd9506$var$queuedPointerCaptures.set(pointerId, $fb2b12fdc6fd9506$var$accumulateOrCreateContinuousQueuedReplayableEvent($fb2b12fdc6fd9506$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $fb2b12fdc6fd9506$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $fb2b12fdc6fd9506$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $fb2b12fdc6fd9506$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $fb2b12fdc6fd9506$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $fb2b12fdc6fd9506$var$runWithPriority(queuedTarget.priority, function() {
                        $fb2b12fdc6fd9506$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $fb2b12fdc6fd9506$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $fb2b12fdc6fd9506$var$runWithPriority(queuedTarget.priority, function() {
                        $fb2b12fdc6fd9506$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $fb2b12fdc6fd9506$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $fb2b12fdc6fd9506$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $fb2b12fdc6fd9506$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $fb2b12fdc6fd9506$var$currentReplayingEvent = null;
        } else return targetContainers = $fb2b12fdc6fd9506$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $fb2b12fdc6fd9506$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $fb2b12fdc6fd9506$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $fb2b12fdc6fd9506$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $fb2b12fdc6fd9506$var$replayUnblockedEvents() {
    $fb2b12fdc6fd9506$var$hasScheduledReplayAttempt = !1;
    null !== $fb2b12fdc6fd9506$var$queuedFocus && $fb2b12fdc6fd9506$var$attemptReplayContinuousQueuedEvent($fb2b12fdc6fd9506$var$queuedFocus) && ($fb2b12fdc6fd9506$var$queuedFocus = null);
    null !== $fb2b12fdc6fd9506$var$queuedDrag && $fb2b12fdc6fd9506$var$attemptReplayContinuousQueuedEvent($fb2b12fdc6fd9506$var$queuedDrag) && ($fb2b12fdc6fd9506$var$queuedDrag = null);
    null !== $fb2b12fdc6fd9506$var$queuedMouse && $fb2b12fdc6fd9506$var$attemptReplayContinuousQueuedEvent($fb2b12fdc6fd9506$var$queuedMouse) && ($fb2b12fdc6fd9506$var$queuedMouse = null);
    $fb2b12fdc6fd9506$var$queuedPointers.forEach($fb2b12fdc6fd9506$var$attemptReplayContinuousQueuedEventInMap);
    $fb2b12fdc6fd9506$var$queuedPointerCaptures.forEach($fb2b12fdc6fd9506$var$attemptReplayContinuousQueuedEventInMap);
}
function $fb2b12fdc6fd9506$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $fb2b12fdc6fd9506$var$hasScheduledReplayAttempt || ($fb2b12fdc6fd9506$var$hasScheduledReplayAttempt = !0, $8PV0D.unstable_scheduleCallback($8PV0D.unstable_NormalPriority, $fb2b12fdc6fd9506$var$replayUnblockedEvents)));
}
var $fb2b12fdc6fd9506$var$lastScheduledReplayQueue = null;
function $fb2b12fdc6fd9506$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $fb2b12fdc6fd9506$var$lastScheduledReplayQueue !== formReplayingQueue && ($fb2b12fdc6fd9506$var$lastScheduledReplayQueue = formReplayingQueue, $8PV0D.unstable_scheduleCallback($8PV0D.unstable_NormalPriority, function() {
        $fb2b12fdc6fd9506$var$lastScheduledReplayQueue === formReplayingQueue && ($fb2b12fdc6fd9506$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $fb2b12fdc6fd9506$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $fb2b12fdc6fd9506$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $fb2b12fdc6fd9506$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $fb2b12fdc6fd9506$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $fb2b12fdc6fd9506$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $fb2b12fdc6fd9506$var$queuedFocus && $fb2b12fdc6fd9506$var$scheduleCallbackIfUnblocked($fb2b12fdc6fd9506$var$queuedFocus, unblocked);
    null !== $fb2b12fdc6fd9506$var$queuedDrag && $fb2b12fdc6fd9506$var$scheduleCallbackIfUnblocked($fb2b12fdc6fd9506$var$queuedDrag, unblocked);
    null !== $fb2b12fdc6fd9506$var$queuedMouse && $fb2b12fdc6fd9506$var$scheduleCallbackIfUnblocked($fb2b12fdc6fd9506$var$queuedMouse, unblocked);
    $fb2b12fdc6fd9506$var$queuedPointers.forEach(unblock);
    $fb2b12fdc6fd9506$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $fb2b12fdc6fd9506$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $fb2b12fdc6fd9506$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $fb2b12fdc6fd9506$var$queuedExplicitHydrationTargets.length && (i = $fb2b12fdc6fd9506$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$fb2b12fdc6fd9506$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $fb2b12fdc6fd9506$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$fb2b12fdc6fd9506$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $fb2b12fdc6fd9506$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$fb2b12fdc6fd9506$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $fb2b12fdc6fd9506$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $fb2b12fdc6fd9506$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $fb2b12fdc6fd9506$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $fb2b12fdc6fd9506$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$fb2b12fdc6fd9506$var$ReactDOMHydrationRoot.prototype.render = $fb2b12fdc6fd9506$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(409));
    var current = root.current, lane = $fb2b12fdc6fd9506$var$requestUpdateLane();
    $fb2b12fdc6fd9506$var$updateContainerImpl(current, lane, children, root, null, null);
};
$fb2b12fdc6fd9506$var$ReactDOMHydrationRoot.prototype.unmount = $fb2b12fdc6fd9506$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $fb2b12fdc6fd9506$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $fb2b12fdc6fd9506$var$flushSyncWork$1();
        container[$fb2b12fdc6fd9506$var$internalContainerInstanceKey] = null;
    }
};
function $fb2b12fdc6fd9506$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$fb2b12fdc6fd9506$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $fb2b12fdc6fd9506$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $fb2b12fdc6fd9506$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $fb2b12fdc6fd9506$var$queuedExplicitHydrationTargets[i].priority; i++);
        $fb2b12fdc6fd9506$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $fb2b12fdc6fd9506$var$attemptExplicitHydrationTarget(target);
    }
};
var $fb2b12fdc6fd9506$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $8v0nu.version;
if ("19.2.6" !== $fb2b12fdc6fd9506$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(527, $fb2b12fdc6fd9506$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.6"));
$fb2b12fdc6fd9506$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $fb2b12fdc6fd9506$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $fb2b12fdc6fd9506$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $fb2b12fdc6fd9506$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.6",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $fb2b12fdc6fd9506$var$ReactSharedInternals,
    reconcilerVersion: "19.2.6"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $fb2b12fdc6fd9506$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$fb2b12fdc6fd9506$var$hook$jscomp$inline_2348.isDisabled && $fb2b12fdc6fd9506$var$hook$jscomp$inline_2348.supportsFiber) try {
        $fb2b12fdc6fd9506$var$rendererID = $fb2b12fdc6fd9506$var$hook$jscomp$inline_2348.inject($fb2b12fdc6fd9506$var$internals$jscomp$inline_2347), $fb2b12fdc6fd9506$var$injectedHook = $fb2b12fdc6fd9506$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$fb2b12fdc6fd9506$export$882461b6382ed46c = function(container, options) {
    if (!$fb2b12fdc6fd9506$var$isValidContainer(container)) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $fb2b12fdc6fd9506$var$defaultOnUncaughtError, onCaughtError = $fb2b12fdc6fd9506$var$defaultOnCaughtError, onRecoverableError = $fb2b12fdc6fd9506$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $fb2b12fdc6fd9506$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $fb2b12fdc6fd9506$var$defaultOnDefaultTransitionIndicator);
    container[$fb2b12fdc6fd9506$var$internalContainerInstanceKey] = options.current;
    $fb2b12fdc6fd9506$var$listenToAllSupportedEvents(container);
    return new $fb2b12fdc6fd9506$var$ReactDOMRoot(options);
};
$fb2b12fdc6fd9506$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$fb2b12fdc6fd9506$var$isValidContainer(container)) throw Error($fb2b12fdc6fd9506$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $fb2b12fdc6fd9506$var$defaultOnUncaughtError, onCaughtError = $fb2b12fdc6fd9506$var$defaultOnCaughtError, onRecoverableError = $fb2b12fdc6fd9506$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $fb2b12fdc6fd9506$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $fb2b12fdc6fd9506$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $fb2b12fdc6fd9506$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $fb2b12fdc6fd9506$var$requestUpdateLane();
    isStrictMode = $fb2b12fdc6fd9506$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $fb2b12fdc6fd9506$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $fb2b12fdc6fd9506$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $fb2b12fdc6fd9506$var$markRootUpdated$1(initialChildren, options);
    $fb2b12fdc6fd9506$var$ensureRootIsScheduled(initialChildren);
    container[$fb2b12fdc6fd9506$var$internalContainerInstanceKey] = initialChildren.current;
    $fb2b12fdc6fd9506$var$listenToAllSupportedEvents(container);
    return new $fb2b12fdc6fd9506$var$ReactDOMHydrationRoot(initialChildren);
};
$fb2b12fdc6fd9506$export$83d89fbfd8236492 = "19.2.6";

});
parcelRegister("8PV0D", function(module, exports) {
'use strict';

module.exports = (parcelRequire("40dhB"));

});
parcelRegister("40dhB", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $2ea17739426ffb35$export$c4744153514ff05d; }, function (v) { return $2ea17739426ffb35$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $2ea17739426ffb35$export$3e506c1ccc9cc1a7; }, function (v) { return $2ea17739426ffb35$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $2ea17739426ffb35$export$e26fe2ed2fa76875; }, function (v) { return $2ea17739426ffb35$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $2ea17739426ffb35$export$502329bbf4b505b1; }, function (v) { return $2ea17739426ffb35$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $2ea17739426ffb35$export$6e3807111c4874c4; }, function (v) { return $2ea17739426ffb35$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $2ea17739426ffb35$export$c27134553091fb3a; }, function (v) { return $2ea17739426ffb35$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $2ea17739426ffb35$export$33ee1acdc04fd2a2; }, function (v) { return $2ea17739426ffb35$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $2ea17739426ffb35$export$b00a404bbd5edef2; }, function (v) { return $2ea17739426ffb35$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $2ea17739426ffb35$export$d66a1c1c77bd778b; }, function (v) { return $2ea17739426ffb35$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $2ea17739426ffb35$export$d3dfb8e4810cb555; }, function (v) { return $2ea17739426ffb35$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $2ea17739426ffb35$export$72fdf0e06517287b; }, function (v) { return $2ea17739426ffb35$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $2ea17739426ffb35$export$816d2913ae6b83b1; }, function (v) { return $2ea17739426ffb35$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $2ea17739426ffb35$export$61bcfe829111a1d0; }, function (v) { return $2ea17739426ffb35$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $2ea17739426ffb35$export$7ee8c9beb337bc3f; }, function (v) { return $2ea17739426ffb35$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $2ea17739426ffb35$export$b5836b71941fa3ed; }, function (v) { return $2ea17739426ffb35$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $2ea17739426ffb35$export$cf845f2c119da08a; }, function (v) { return $2ea17739426ffb35$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2ea17739426ffb35$export$c4744153514ff05d;
var $2ea17739426ffb35$export$3e506c1ccc9cc1a7;
var $2ea17739426ffb35$export$e26fe2ed2fa76875;
var $2ea17739426ffb35$export$502329bbf4b505b1;
var $2ea17739426ffb35$export$6e3807111c4874c4;
var $2ea17739426ffb35$export$c27134553091fb3a;
var $2ea17739426ffb35$export$33ee1acdc04fd2a2;
var $2ea17739426ffb35$export$b00a404bbd5edef2;
var $2ea17739426ffb35$export$d66a1c1c77bd778b;
var $2ea17739426ffb35$export$d3dfb8e4810cb555;
var $2ea17739426ffb35$export$72fdf0e06517287b;
var $2ea17739426ffb35$export$816d2913ae6b83b1;
var $2ea17739426ffb35$export$61bcfe829111a1d0;
var $2ea17739426ffb35$export$7ee8c9beb337bc3f;
var $2ea17739426ffb35$export$b5836b71941fa3ed;
var $2ea17739426ffb35$export$cf845f2c119da08a;
"use strict";
function $2ea17739426ffb35$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $2ea17739426ffb35$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $2ea17739426ffb35$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $2ea17739426ffb35$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $2ea17739426ffb35$var$compare(left, last)) rightIndex < length && 0 > $2ea17739426ffb35$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $2ea17739426ffb35$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $2ea17739426ffb35$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$2ea17739426ffb35$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $2ea17739426ffb35$var$localPerformance = performance;
    $2ea17739426ffb35$export$c4744153514ff05d = function() {
        return $2ea17739426ffb35$var$localPerformance.now();
    };
} else {
    var $2ea17739426ffb35$var$localDate = Date, $2ea17739426ffb35$var$initialTime = $2ea17739426ffb35$var$localDate.now();
    $2ea17739426ffb35$export$c4744153514ff05d = function() {
        return $2ea17739426ffb35$var$localDate.now() - $2ea17739426ffb35$var$initialTime;
    };
}
var $2ea17739426ffb35$var$taskQueue = [], $2ea17739426ffb35$var$timerQueue = [], $2ea17739426ffb35$var$taskIdCounter = 1, $2ea17739426ffb35$var$currentTask = null, $2ea17739426ffb35$var$currentPriorityLevel = 3, $2ea17739426ffb35$var$isPerformingWork = !1, $2ea17739426ffb35$var$isHostCallbackScheduled = !1, $2ea17739426ffb35$var$isHostTimeoutScheduled = !1, $2ea17739426ffb35$var$needsPaint = !1, $2ea17739426ffb35$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $2ea17739426ffb35$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $2ea17739426ffb35$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $2ea17739426ffb35$var$advanceTimers(currentTime) {
    for(var timer = $2ea17739426ffb35$var$peek($2ea17739426ffb35$var$timerQueue); null !== timer;){
        if (null === timer.callback) $2ea17739426ffb35$var$pop($2ea17739426ffb35$var$timerQueue);
        else if (timer.startTime <= currentTime) $2ea17739426ffb35$var$pop($2ea17739426ffb35$var$timerQueue), timer.sortIndex = timer.expirationTime, $2ea17739426ffb35$var$push($2ea17739426ffb35$var$taskQueue, timer);
        else break;
        timer = $2ea17739426ffb35$var$peek($2ea17739426ffb35$var$timerQueue);
    }
}
function $2ea17739426ffb35$var$handleTimeout(currentTime) {
    $2ea17739426ffb35$var$isHostTimeoutScheduled = !1;
    $2ea17739426ffb35$var$advanceTimers(currentTime);
    if (!$2ea17739426ffb35$var$isHostCallbackScheduled) {
        if (null !== $2ea17739426ffb35$var$peek($2ea17739426ffb35$var$taskQueue)) $2ea17739426ffb35$var$isHostCallbackScheduled = !0, $2ea17739426ffb35$var$isMessageLoopRunning || ($2ea17739426ffb35$var$isMessageLoopRunning = !0, $2ea17739426ffb35$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $2ea17739426ffb35$var$peek($2ea17739426ffb35$var$timerQueue);
            null !== firstTimer && $2ea17739426ffb35$var$requestHostTimeout($2ea17739426ffb35$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $2ea17739426ffb35$var$isMessageLoopRunning = !1, $2ea17739426ffb35$var$taskTimeoutID = -1, $2ea17739426ffb35$var$frameInterval = 5, $2ea17739426ffb35$var$startTime = -1;
function $2ea17739426ffb35$var$shouldYieldToHost() {
    return $2ea17739426ffb35$var$needsPaint ? !0 : $2ea17739426ffb35$export$c4744153514ff05d() - $2ea17739426ffb35$var$startTime < $2ea17739426ffb35$var$frameInterval ? !1 : !0;
}
function $2ea17739426ffb35$var$performWorkUntilDeadline() {
    $2ea17739426ffb35$var$needsPaint = !1;
    if ($2ea17739426ffb35$var$isMessageLoopRunning) {
        var currentTime = $2ea17739426ffb35$export$c4744153514ff05d();
        $2ea17739426ffb35$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $2ea17739426ffb35$var$isHostCallbackScheduled = !1;
                $2ea17739426ffb35$var$isHostTimeoutScheduled && ($2ea17739426ffb35$var$isHostTimeoutScheduled = !1, $2ea17739426ffb35$var$localClearTimeout($2ea17739426ffb35$var$taskTimeoutID), $2ea17739426ffb35$var$taskTimeoutID = -1);
                $2ea17739426ffb35$var$isPerformingWork = !0;
                var previousPriorityLevel = $2ea17739426ffb35$var$currentPriorityLevel;
                try {
                    b: {
                        $2ea17739426ffb35$var$advanceTimers(currentTime);
                        for($2ea17739426ffb35$var$currentTask = $2ea17739426ffb35$var$peek($2ea17739426ffb35$var$taskQueue); null !== $2ea17739426ffb35$var$currentTask && !($2ea17739426ffb35$var$currentTask.expirationTime > currentTime && $2ea17739426ffb35$var$shouldYieldToHost());){
                            var callback = $2ea17739426ffb35$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $2ea17739426ffb35$var$currentTask.callback = null;
                                $2ea17739426ffb35$var$currentPriorityLevel = $2ea17739426ffb35$var$currentTask.priorityLevel;
                                var continuationCallback = callback($2ea17739426ffb35$var$currentTask.expirationTime <= currentTime);
                                currentTime = $2ea17739426ffb35$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $2ea17739426ffb35$var$currentTask.callback = continuationCallback;
                                    $2ea17739426ffb35$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $2ea17739426ffb35$var$currentTask === $2ea17739426ffb35$var$peek($2ea17739426ffb35$var$taskQueue) && $2ea17739426ffb35$var$pop($2ea17739426ffb35$var$taskQueue);
                                $2ea17739426ffb35$var$advanceTimers(currentTime);
                            } else $2ea17739426ffb35$var$pop($2ea17739426ffb35$var$taskQueue);
                            $2ea17739426ffb35$var$currentTask = $2ea17739426ffb35$var$peek($2ea17739426ffb35$var$taskQueue);
                        }
                        if (null !== $2ea17739426ffb35$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $2ea17739426ffb35$var$peek($2ea17739426ffb35$var$timerQueue);
                            null !== firstTimer && $2ea17739426ffb35$var$requestHostTimeout($2ea17739426ffb35$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $2ea17739426ffb35$var$currentTask = null, $2ea17739426ffb35$var$currentPriorityLevel = previousPriorityLevel, $2ea17739426ffb35$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $2ea17739426ffb35$var$schedulePerformWorkUntilDeadline() : $2ea17739426ffb35$var$isMessageLoopRunning = !1;
        }
    }
}
var $2ea17739426ffb35$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $2ea17739426ffb35$var$localSetImmediate) $2ea17739426ffb35$var$schedulePerformWorkUntilDeadline = function() {
    $2ea17739426ffb35$var$localSetImmediate($2ea17739426ffb35$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $2ea17739426ffb35$var$channel = new MessageChannel(), $2ea17739426ffb35$var$port = $2ea17739426ffb35$var$channel.port2;
    $2ea17739426ffb35$var$channel.port1.onmessage = $2ea17739426ffb35$var$performWorkUntilDeadline;
    $2ea17739426ffb35$var$schedulePerformWorkUntilDeadline = function() {
        $2ea17739426ffb35$var$port.postMessage(null);
    };
} else $2ea17739426ffb35$var$schedulePerformWorkUntilDeadline = function() {
    $2ea17739426ffb35$var$localSetTimeout($2ea17739426ffb35$var$performWorkUntilDeadline, 0);
};
function $2ea17739426ffb35$var$requestHostTimeout(callback, ms) {
    $2ea17739426ffb35$var$taskTimeoutID = $2ea17739426ffb35$var$localSetTimeout(function() {
        callback($2ea17739426ffb35$export$c4744153514ff05d());
    }, ms);
}
$2ea17739426ffb35$export$3e506c1ccc9cc1a7 = 5;
$2ea17739426ffb35$export$e26fe2ed2fa76875 = 1;
$2ea17739426ffb35$export$502329bbf4b505b1 = 4;
$2ea17739426ffb35$export$6e3807111c4874c4 = 3;
$2ea17739426ffb35$export$c27134553091fb3a = null;
$2ea17739426ffb35$export$33ee1acdc04fd2a2 = 2;
$2ea17739426ffb35$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$2ea17739426ffb35$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $2ea17739426ffb35$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$2ea17739426ffb35$export$d3dfb8e4810cb555 = function() {
    return $2ea17739426ffb35$var$currentPriorityLevel;
};
$2ea17739426ffb35$export$72fdf0e06517287b = function(eventHandler) {
    switch($2ea17739426ffb35$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $2ea17739426ffb35$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $2ea17739426ffb35$var$currentPriorityLevel;
    $2ea17739426ffb35$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $2ea17739426ffb35$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$2ea17739426ffb35$export$816d2913ae6b83b1 = function() {
    $2ea17739426ffb35$var$needsPaint = !0;
};
$2ea17739426ffb35$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $2ea17739426ffb35$var$currentPriorityLevel;
    $2ea17739426ffb35$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $2ea17739426ffb35$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$2ea17739426ffb35$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $2ea17739426ffb35$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $2ea17739426ffb35$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $2ea17739426ffb35$var$push($2ea17739426ffb35$var$timerQueue, priorityLevel), null === $2ea17739426ffb35$var$peek($2ea17739426ffb35$var$taskQueue) && priorityLevel === $2ea17739426ffb35$var$peek($2ea17739426ffb35$var$timerQueue) && ($2ea17739426ffb35$var$isHostTimeoutScheduled ? ($2ea17739426ffb35$var$localClearTimeout($2ea17739426ffb35$var$taskTimeoutID), $2ea17739426ffb35$var$taskTimeoutID = -1) : $2ea17739426ffb35$var$isHostTimeoutScheduled = !0, $2ea17739426ffb35$var$requestHostTimeout($2ea17739426ffb35$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $2ea17739426ffb35$var$push($2ea17739426ffb35$var$taskQueue, priorityLevel), $2ea17739426ffb35$var$isHostCallbackScheduled || $2ea17739426ffb35$var$isPerformingWork || ($2ea17739426ffb35$var$isHostCallbackScheduled = !0, $2ea17739426ffb35$var$isMessageLoopRunning || ($2ea17739426ffb35$var$isMessageLoopRunning = !0, $2ea17739426ffb35$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$2ea17739426ffb35$export$b5836b71941fa3ed = $2ea17739426ffb35$var$shouldYieldToHost;
$2ea17739426ffb35$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $2ea17739426ffb35$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $2ea17739426ffb35$var$currentPriorityLevel;
        $2ea17739426ffb35$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $2ea17739426ffb35$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("8v0nu", function(module, exports) {
'use strict';

module.exports = (parcelRequire("7XjM8"));

});

parcelRegister("k2dbP", function(module, exports) {
'use strict';
function $e95e39c2a873bfa2$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($e95e39c2a873bfa2$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$e95e39c2a873bfa2$var$checkDCE();

module.exports = (parcelRequire("hv0c7"));

});
parcelRegister("hv0c7", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $cbd57b8f89b483c2$export$69ce8ef3fe5cead0; }, function (v) { return $cbd57b8f89b483c2$export$69ce8ef3fe5cead0 = v; });
$parcel$export(module.exports, "createPortal", function () { return $cbd57b8f89b483c2$export$d39a5bbd09211389; }, function (v) { return $cbd57b8f89b483c2$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "flushSync", function () { return $cbd57b8f89b483c2$export$cd75ccfd720a3cd4; }, function (v) { return $cbd57b8f89b483c2$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "preconnect", function () { return $cbd57b8f89b483c2$export$a0816fa17a9e79be; }, function (v) { return $cbd57b8f89b483c2$export$a0816fa17a9e79be = v; });
$parcel$export(module.exports, "prefetchDNS", function () { return $cbd57b8f89b483c2$export$7292efcadded39f3; }, function (v) { return $cbd57b8f89b483c2$export$7292efcadded39f3 = v; });
$parcel$export(module.exports, "preinit", function () { return $cbd57b8f89b483c2$export$da407abadb9b8f86; }, function (v) { return $cbd57b8f89b483c2$export$da407abadb9b8f86 = v; });
$parcel$export(module.exports, "preinitModule", function () { return $cbd57b8f89b483c2$export$314cfea32580671c; }, function (v) { return $cbd57b8f89b483c2$export$314cfea32580671c = v; });
$parcel$export(module.exports, "preload", function () { return $cbd57b8f89b483c2$export$513ccb98c53b8039; }, function (v) { return $cbd57b8f89b483c2$export$513ccb98c53b8039 = v; });
$parcel$export(module.exports, "preloadModule", function () { return $cbd57b8f89b483c2$export$dbca993bc2d264a; }, function (v) { return $cbd57b8f89b483c2$export$dbca993bc2d264a = v; });
$parcel$export(module.exports, "requestFormReset", function () { return $cbd57b8f89b483c2$export$4797a8006f0655d0; }, function (v) { return $cbd57b8f89b483c2$export$4797a8006f0655d0 = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $cbd57b8f89b483c2$export$c78a37762a8d58e1; }, function (v) { return $cbd57b8f89b483c2$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "useFormState", function () { return $cbd57b8f89b483c2$export$606f11b2eb45ecc6; }, function (v) { return $cbd57b8f89b483c2$export$606f11b2eb45ecc6 = v; });
$parcel$export(module.exports, "useFormStatus", function () { return $cbd57b8f89b483c2$export$f7e8a0bf92324b1e; }, function (v) { return $cbd57b8f89b483c2$export$f7e8a0bf92324b1e = v; });
$parcel$export(module.exports, "version", function () { return $cbd57b8f89b483c2$export$83d89fbfd8236492; }, function (v) { return $cbd57b8f89b483c2$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $cbd57b8f89b483c2$export$69ce8ef3fe5cead0;
var $cbd57b8f89b483c2$export$d39a5bbd09211389;
var $cbd57b8f89b483c2$export$cd75ccfd720a3cd4;
var $cbd57b8f89b483c2$export$a0816fa17a9e79be;
var $cbd57b8f89b483c2$export$7292efcadded39f3;
var $cbd57b8f89b483c2$export$da407abadb9b8f86;
var $cbd57b8f89b483c2$export$314cfea32580671c;
var $cbd57b8f89b483c2$export$513ccb98c53b8039;
var $cbd57b8f89b483c2$export$dbca993bc2d264a;
var $cbd57b8f89b483c2$export$4797a8006f0655d0;
var $cbd57b8f89b483c2$export$c78a37762a8d58e1;
var $cbd57b8f89b483c2$export$606f11b2eb45ecc6;
var $cbd57b8f89b483c2$export$f7e8a0bf92324b1e;
var $cbd57b8f89b483c2$export$83d89fbfd8236492;
"use strict";

var $8v0nu = parcelRequire("8v0nu");
function $cbd57b8f89b483c2$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $cbd57b8f89b483c2$var$noop() {}
var $cbd57b8f89b483c2$var$Internals = {
    d: {
        f: $cbd57b8f89b483c2$var$noop,
        r: function() {
            throw Error($cbd57b8f89b483c2$var$formatProdErrorMessage(522));
        },
        D: $cbd57b8f89b483c2$var$noop,
        C: $cbd57b8f89b483c2$var$noop,
        L: $cbd57b8f89b483c2$var$noop,
        m: $cbd57b8f89b483c2$var$noop,
        X: $cbd57b8f89b483c2$var$noop,
        S: $cbd57b8f89b483c2$var$noop,
        M: $cbd57b8f89b483c2$var$noop
    },
    p: 0,
    findDOMNode: null
}, $cbd57b8f89b483c2$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $cbd57b8f89b483c2$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $cbd57b8f89b483c2$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $cbd57b8f89b483c2$var$ReactSharedInternals = $8v0nu.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $cbd57b8f89b483c2$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$cbd57b8f89b483c2$export$69ce8ef3fe5cead0 = $cbd57b8f89b483c2$var$Internals;
$cbd57b8f89b483c2$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($cbd57b8f89b483c2$var$formatProdErrorMessage(299));
    return $cbd57b8f89b483c2$var$createPortal$1(children, container, null, key);
};
$cbd57b8f89b483c2$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $cbd57b8f89b483c2$var$ReactSharedInternals.T, previousUpdatePriority = $cbd57b8f89b483c2$var$Internals.p;
    try {
        if ($cbd57b8f89b483c2$var$ReactSharedInternals.T = null, $cbd57b8f89b483c2$var$Internals.p = 2, fn) return fn();
    } finally{
        $cbd57b8f89b483c2$var$ReactSharedInternals.T = previousTransition, $cbd57b8f89b483c2$var$Internals.p = previousUpdatePriority, $cbd57b8f89b483c2$var$Internals.d.f();
    }
};
$cbd57b8f89b483c2$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $cbd57b8f89b483c2$var$Internals.d.C(href, options));
};
$cbd57b8f89b483c2$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $cbd57b8f89b483c2$var$Internals.d.D(href);
};
$cbd57b8f89b483c2$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $cbd57b8f89b483c2$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $cbd57b8f89b483c2$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $cbd57b8f89b483c2$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$cbd57b8f89b483c2$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $cbd57b8f89b483c2$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $cbd57b8f89b483c2$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $cbd57b8f89b483c2$var$Internals.d.M(href);
    }
};
$cbd57b8f89b483c2$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $cbd57b8f89b483c2$var$getCrossOriginStringAs(as, options.crossOrigin);
        $cbd57b8f89b483c2$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$cbd57b8f89b483c2$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $cbd57b8f89b483c2$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $cbd57b8f89b483c2$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $cbd57b8f89b483c2$var$Internals.d.m(href);
    }
};
$cbd57b8f89b483c2$export$4797a8006f0655d0 = function(form) {
    $cbd57b8f89b483c2$var$Internals.d.r(form);
};
$cbd57b8f89b483c2$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$cbd57b8f89b483c2$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $cbd57b8f89b483c2$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$cbd57b8f89b483c2$export$f7e8a0bf92324b1e = function() {
    return $cbd57b8f89b483c2$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$cbd57b8f89b483c2$export$83d89fbfd8236492 = "19.2.6";

});



parcelRegister("72yBp", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $52038f9b18150c68$export$2b8d127b894957b9; }, function (v) { return $52038f9b18150c68$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $52038f9b18150c68$export$cea3a54a6425200c; }, function (v) { return $52038f9b18150c68$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $52038f9b18150c68$export$a7c73072b1a182ae; }, function (v) { return $52038f9b18150c68$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $52038f9b18150c68$export$9f27bc3417b4524d; }, function (v) { return $52038f9b18150c68$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $52038f9b18150c68$export$db77ccec0bb4ccac; }, function (v) { return $52038f9b18150c68$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $52038f9b18150c68$export$8392c0c9d3dcbd35; }, function (v) { return $52038f9b18150c68$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $52038f9b18150c68$export$ffb0004e005737fa; }, function (v) { return $52038f9b18150c68$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $52038f9b18150c68$export$b624eff549462981; }, function (v) { return $52038f9b18150c68$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $52038f9b18150c68$export$7897aa7841a5380c; }, function (v) { return $52038f9b18150c68$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $52038f9b18150c68$export$602eac185826482c; }, function (v) { return $52038f9b18150c68$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $52038f9b18150c68$export$e2c29f18771995cb; }, function (v) { return $52038f9b18150c68$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $52038f9b18150c68$export$5f8d39834fd61797; }, function (v) { return $52038f9b18150c68$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $52038f9b18150c68$export$74bf444e3cd11ea5; }, function (v) { return $52038f9b18150c68$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $52038f9b18150c68$export$92387174baf9b227; }, function (v) { return $52038f9b18150c68$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $52038f9b18150c68$export$ec112efeb987d9c6; }, function (v) { return $52038f9b18150c68$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $52038f9b18150c68$export$b706b080d889d2c9; }, function (v) { return $52038f9b18150c68$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $52038f9b18150c68$export$5be5a87408f70ddc; }, function (v) { return $52038f9b18150c68$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $52038f9b18150c68$export$45a5e7f76e0caa8d; }, function (v) { return $52038f9b18150c68$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $52038f9b18150c68$export$455c2e768291efa6; }, function (v) { return $52038f9b18150c68$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $52038f9b18150c68$export$9522e17588c12572; }, function (v) { return $52038f9b18150c68$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $52038f9b18150c68$export$2110ac352bb060b9; }, function (v) { return $52038f9b18150c68$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $52038f9b18150c68$export$56885ab8b9c456ab; }, function (v) { return $52038f9b18150c68$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $52038f9b18150c68$export$d927fcb6adf8f9de; }, function (v) { return $52038f9b18150c68$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $52038f9b18150c68$export$b82d16f27459e05a; }, function (v) { return $52038f9b18150c68$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $52038f9b18150c68$export$522c17b4f5e123e8; }, function (v) { return $52038f9b18150c68$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $52038f9b18150c68$export$1aabd8a0274ecfd6; }, function (v) { return $52038f9b18150c68$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $52038f9b18150c68$export$9b621391a187a31a; }, function (v) { return $52038f9b18150c68$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $52038f9b18150c68$export$f5bbd400c2f4426f; }, function (v) { return $52038f9b18150c68$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $52038f9b18150c68$export$2b8d127b894957b9;
var $52038f9b18150c68$export$cea3a54a6425200c;
var $52038f9b18150c68$export$a7c73072b1a182ae;
var $52038f9b18150c68$export$9f27bc3417b4524d;
var $52038f9b18150c68$export$db77ccec0bb4ccac;
var $52038f9b18150c68$export$8392c0c9d3dcbd35;
var $52038f9b18150c68$export$ffb0004e005737fa;
var $52038f9b18150c68$export$b624eff549462981;
var $52038f9b18150c68$export$7897aa7841a5380c;
var $52038f9b18150c68$export$602eac185826482c;
var $52038f9b18150c68$export$e2c29f18771995cb;
var $52038f9b18150c68$export$5f8d39834fd61797;
var $52038f9b18150c68$export$74bf444e3cd11ea5;
var $52038f9b18150c68$export$92387174baf9b227;
var $52038f9b18150c68$export$ec112efeb987d9c6;
var $52038f9b18150c68$export$b706b080d889d2c9;
var $52038f9b18150c68$export$5be5a87408f70ddc;
var $52038f9b18150c68$export$45a5e7f76e0caa8d;
var $52038f9b18150c68$export$455c2e768291efa6;
var $52038f9b18150c68$export$9522e17588c12572;
var $52038f9b18150c68$export$2110ac352bb060b9;
var $52038f9b18150c68$export$56885ab8b9c456ab;
var $52038f9b18150c68$export$d927fcb6adf8f9de;
var $52038f9b18150c68$export$b82d16f27459e05a;
var $52038f9b18150c68$export$522c17b4f5e123e8;
var $52038f9b18150c68$export$1aabd8a0274ecfd6;
var $52038f9b18150c68$export$9b621391a187a31a;
var $52038f9b18150c68$export$f5bbd400c2f4426f;
'use strict';
var $52038f9b18150c68$var$b = "function" === typeof Symbol && Symbol.for, $52038f9b18150c68$var$c = $52038f9b18150c68$var$b ? Symbol.for("react.element") : 60103, $52038f9b18150c68$var$d = $52038f9b18150c68$var$b ? Symbol.for("react.portal") : 60106, $52038f9b18150c68$var$e = $52038f9b18150c68$var$b ? Symbol.for("react.fragment") : 60107, $52038f9b18150c68$var$f = $52038f9b18150c68$var$b ? Symbol.for("react.strict_mode") : 60108, $52038f9b18150c68$var$g = $52038f9b18150c68$var$b ? Symbol.for("react.profiler") : 60114, $52038f9b18150c68$var$h = $52038f9b18150c68$var$b ? Symbol.for("react.provider") : 60109, $52038f9b18150c68$var$k = $52038f9b18150c68$var$b ? Symbol.for("react.context") : 60110, $52038f9b18150c68$var$l = $52038f9b18150c68$var$b ? Symbol.for("react.async_mode") : 60111, $52038f9b18150c68$var$m = $52038f9b18150c68$var$b ? Symbol.for("react.concurrent_mode") : 60111, $52038f9b18150c68$var$n = $52038f9b18150c68$var$b ? Symbol.for("react.forward_ref") : 60112, $52038f9b18150c68$var$p = $52038f9b18150c68$var$b ? Symbol.for("react.suspense") : 60113, $52038f9b18150c68$var$q = $52038f9b18150c68$var$b ? Symbol.for("react.suspense_list") : 60120, $52038f9b18150c68$var$r = $52038f9b18150c68$var$b ? Symbol.for("react.memo") : 60115, $52038f9b18150c68$var$t = $52038f9b18150c68$var$b ? Symbol.for("react.lazy") : 60116, $52038f9b18150c68$var$v = $52038f9b18150c68$var$b ? Symbol.for("react.block") : 60121, $52038f9b18150c68$var$w = $52038f9b18150c68$var$b ? Symbol.for("react.fundamental") : 60117, $52038f9b18150c68$var$x = $52038f9b18150c68$var$b ? Symbol.for("react.responder") : 60118, $52038f9b18150c68$var$y = $52038f9b18150c68$var$b ? Symbol.for("react.scope") : 60119;
function $52038f9b18150c68$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $52038f9b18150c68$var$c:
                switch(a = a.type, a){
                    case $52038f9b18150c68$var$l:
                    case $52038f9b18150c68$var$m:
                    case $52038f9b18150c68$var$e:
                    case $52038f9b18150c68$var$g:
                    case $52038f9b18150c68$var$f:
                    case $52038f9b18150c68$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $52038f9b18150c68$var$k:
                            case $52038f9b18150c68$var$n:
                            case $52038f9b18150c68$var$t:
                            case $52038f9b18150c68$var$r:
                            case $52038f9b18150c68$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $52038f9b18150c68$var$d:
                return u;
        }
    }
}
function $52038f9b18150c68$var$A(a) {
    return $52038f9b18150c68$var$z(a) === $52038f9b18150c68$var$m;
}
$52038f9b18150c68$export$2b8d127b894957b9 = $52038f9b18150c68$var$l;
$52038f9b18150c68$export$cea3a54a6425200c = $52038f9b18150c68$var$m;
$52038f9b18150c68$export$a7c73072b1a182ae = $52038f9b18150c68$var$k;
$52038f9b18150c68$export$9f27bc3417b4524d = $52038f9b18150c68$var$h;
$52038f9b18150c68$export$db77ccec0bb4ccac = $52038f9b18150c68$var$c;
$52038f9b18150c68$export$8392c0c9d3dcbd35 = $52038f9b18150c68$var$n;
$52038f9b18150c68$export$ffb0004e005737fa = $52038f9b18150c68$var$e;
$52038f9b18150c68$export$b624eff549462981 = $52038f9b18150c68$var$t;
$52038f9b18150c68$export$7897aa7841a5380c = $52038f9b18150c68$var$r;
$52038f9b18150c68$export$602eac185826482c = $52038f9b18150c68$var$d;
$52038f9b18150c68$export$e2c29f18771995cb = $52038f9b18150c68$var$g;
$52038f9b18150c68$export$5f8d39834fd61797 = $52038f9b18150c68$var$f;
$52038f9b18150c68$export$74bf444e3cd11ea5 = $52038f9b18150c68$var$p;
$52038f9b18150c68$export$92387174baf9b227 = function(a) {
    return $52038f9b18150c68$var$A(a) || $52038f9b18150c68$var$z(a) === $52038f9b18150c68$var$l;
};
$52038f9b18150c68$export$ec112efeb987d9c6 = $52038f9b18150c68$var$A;
$52038f9b18150c68$export$b706b080d889d2c9 = function(a) {
    return $52038f9b18150c68$var$z(a) === $52038f9b18150c68$var$k;
};
$52038f9b18150c68$export$5be5a87408f70ddc = function(a) {
    return $52038f9b18150c68$var$z(a) === $52038f9b18150c68$var$h;
};
$52038f9b18150c68$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $52038f9b18150c68$var$c;
};
$52038f9b18150c68$export$455c2e768291efa6 = function(a) {
    return $52038f9b18150c68$var$z(a) === $52038f9b18150c68$var$n;
};
$52038f9b18150c68$export$9522e17588c12572 = function(a) {
    return $52038f9b18150c68$var$z(a) === $52038f9b18150c68$var$e;
};
$52038f9b18150c68$export$2110ac352bb060b9 = function(a) {
    return $52038f9b18150c68$var$z(a) === $52038f9b18150c68$var$t;
};
$52038f9b18150c68$export$56885ab8b9c456ab = function(a) {
    return $52038f9b18150c68$var$z(a) === $52038f9b18150c68$var$r;
};
$52038f9b18150c68$export$d927fcb6adf8f9de = function(a) {
    return $52038f9b18150c68$var$z(a) === $52038f9b18150c68$var$d;
};
$52038f9b18150c68$export$b82d16f27459e05a = function(a) {
    return $52038f9b18150c68$var$z(a) === $52038f9b18150c68$var$g;
};
$52038f9b18150c68$export$522c17b4f5e123e8 = function(a) {
    return $52038f9b18150c68$var$z(a) === $52038f9b18150c68$var$f;
};
$52038f9b18150c68$export$1aabd8a0274ecfd6 = function(a) {
    return $52038f9b18150c68$var$z(a) === $52038f9b18150c68$var$p;
};
$52038f9b18150c68$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $52038f9b18150c68$var$e || a === $52038f9b18150c68$var$m || a === $52038f9b18150c68$var$g || a === $52038f9b18150c68$var$f || a === $52038f9b18150c68$var$p || a === $52038f9b18150c68$var$q || "object" === typeof a && null !== a && (a.$$typeof === $52038f9b18150c68$var$t || a.$$typeof === $52038f9b18150c68$var$r || a.$$typeof === $52038f9b18150c68$var$h || a.$$typeof === $52038f9b18150c68$var$k || a.$$typeof === $52038f9b18150c68$var$n || a.$$typeof === $52038f9b18150c68$var$w || a.$$typeof === $52038f9b18150c68$var$x || a.$$typeof === $52038f9b18150c68$var$y || a.$$typeof === $52038f9b18150c68$var$v);
};
$52038f9b18150c68$export$f5bbd400c2f4426f = $52038f9b18150c68$var$z;

});

parcelRegister("jTKGQ", function(module, exports) {

$parcel$export(module.exports, "useFormikContext", function () { return useFormikContext; });
$parcel$export(module.exports, "yupToFormErrors", function () { return yupToFormErrors; });
$parcel$export(module.exports, "Formik", function () { return Formik; });
$parcel$export(module.exports, "FieldArray", function () { return FieldArray; });
$parcel$export(module.exports, "FastField", function () { return FastField; });

var $l30Rn = parcelRequire("l30Rn");

var $336aN = parcelRequire("336aN");

var $jGWdr = parcelRequire("jGWdr");

var $8v0nu = parcelRequire("8v0nu");

var $5N63k = parcelRequire("5N63k");

var $7li8V = parcelRequire("7li8V");

var $aAHHW = parcelRequire("aAHHW");

var $cDRNl = parcelRequire("cDRNl");

var $1NGjT = parcelRequire("1NGjT");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
var FormikContext = /*#__PURE__*/ (0, $8v0nu.createContext)(undefined);
FormikContext.displayName = 'FormikContext';
var FormikProvider = FormikContext.Provider;
var FormikConsumer = FormikContext.Consumer;
function useFormikContext() {
    var formik = (0, $8v0nu.useContext)(FormikContext);
    !!!formik && (0, $7li8V.default)(false);
    return formik;
}
/** @private is the value an empty array? */ var isEmptyArray = function isEmptyArray(value) {
    return Array.isArray(value) && value.length === 0;
};
/** @private is the given object a Function? */ var isFunction = function isFunction(obj) {
    return typeof obj === 'function';
};
/** @private is the given object an Object? */ var isObject = function isObject(obj) {
    return obj !== null && typeof obj === 'object';
};
/** @private is the given object an integer? */ var isInteger = function isInteger(obj) {
    return String(Math.floor(Number(obj))) === obj;
};
/** @private is the given object a string? */ var isString = function isString(obj) {
    return Object.prototype.toString.call(obj) === '[object String]';
};
/** @private is the given object a NaN? */ // eslint-disable-next-line no-self-compare
var isNaN$1 = function isNaN1(obj) {
    return obj !== obj;
};
/** @private Does a React component have exactly 0 children? */ var isEmptyChildren = function isEmptyChildren(children) {
    return (0, $8v0nu.Children).count(children) === 0;
};
/** @private is the given object/value a promise? */ var isPromise = function isPromise(value) {
    return isObject(value) && isFunction(value.then);
};
/** @private is the given object/value a type of synthetic event? */ var isInputEvent = function isInputEvent(value) {
    return value && isObject(value) && isObject(value.target);
};
/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?Document} doc Defaults to current document.
 * @return {Element | null}
 * @see https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/dom/getActiveElement.js
 */ function getActiveElement(doc) {
    doc = doc || (typeof document !== 'undefined' ? document : undefined);
    if (typeof doc === 'undefined') return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
/**
 * Deeply get a value from an object via its path.
 */ function getIn(obj, key, def, p) {
    if (p === void 0) p = 0;
    var path = (0, $cDRNl.default)(key);
    while(obj && p < path.length)obj = obj[path[p++]];
     // check if path is not in the end
    if (p !== path.length && !obj) return def;
    return obj === undefined ? def : obj;
}
/**
 * Deeply set a value from in object via it's path. If the value at `path`
 * has changed, return a shallow copy of obj with `value` set at `path`.
 * If `value` has not changed, return the original `obj`.
 *
 * Existing objects / arrays along `path` are also shallow copied. Sibling
 * objects along path retain the same internal js reference. Since new
 * objects / arrays are only created along `path`, we can test if anything
 * changed in a nested structure by comparing the object's reference in
 * the old and new object, similar to how russian doll cache invalidation
 * works.
 *
 * In earlier versions of this function, which used cloneDeep, there were
 * issues whereby settings a nested value would mutate the parent
 * instead of creating a new object. `clone` avoids that bug making a
 * shallow copy of the objects along the update path
 * so no object is mutated in place.
 *
 * Before changing this function, please read through the following
 * discussions.
 *
 * @see https://github.com/developit/linkstate
 * @see https://github.com/jaredpalmer/formik/pull/123
 */ function setIn(obj, path, value) {
    var res = (0, $aAHHW.default)(obj); // this keeps inheritance when obj is a class
    var resVal = res;
    var i = 0;
    var pathArray = (0, $cDRNl.default)(path);
    for(; i < pathArray.length - 1; i++){
        var currentPath = pathArray[i];
        var currentObj = getIn(obj, pathArray.slice(0, i + 1));
        if (currentObj && (isObject(currentObj) || Array.isArray(currentObj))) resVal = resVal[currentPath] = (0, $aAHHW.default)(currentObj);
        else {
            var nextPath = pathArray[i + 1];
            resVal = resVal[currentPath] = isInteger(nextPath) && Number(nextPath) >= 0 ? [] : {};
        }
    } // Return original object if new value is the same as current
    if ((i === 0 ? obj : resVal)[pathArray[i]] === value) return obj;
    if (value === undefined) delete resVal[pathArray[i]];
    else resVal[pathArray[i]] = value;
     // If the path array has a single element, the loop did not run.
    // Deleting on `resVal` had no effect in this scenario, so we delete on the result instead.
    if (i === 0 && value === undefined) delete res[pathArray[i]];
    return res;
}
/**
 * Recursively a set the same value for all keys and arrays nested object, cloning
 * @param object
 * @param value
 * @param visited
 * @param response
 */ function setNestedObjectValues(object, value, visited, response) {
    if (visited === void 0) visited = new WeakMap();
    if (response === void 0) response = {};
    for(var _i = 0, _Object$keys = Object.keys(object); _i < _Object$keys.length; _i++){
        var k = _Object$keys[_i];
        var val = object[k];
        if (isObject(val)) {
            if (!visited.get(val)) {
                visited.set(val, true); // In order to keep array values consistent for both dot path  and
                // bracket syntax, we need to check if this is an array so that
                // this will output  { friends: [true] } and not { friends: { "0": true } }
                response[k] = Array.isArray(val) ? [] : {};
                setNestedObjectValues(val, value, visited, response[k]);
            }
        } else response[k] = value;
    }
    return response;
}
function formikReducer(state, msg) {
    switch(msg.type){
        case 'SET_VALUES':
            return _extends({}, state, {
                values: msg.payload
            });
        case 'SET_TOUCHED':
            return _extends({}, state, {
                touched: msg.payload
            });
        case 'SET_ERRORS':
            if ((0, (/*@__PURE__*/$parcel$interopDefault($5N63k)))(state.errors, msg.payload)) return state;
            return _extends({}, state, {
                errors: msg.payload
            });
        case 'SET_STATUS':
            return _extends({}, state, {
                status: msg.payload
            });
        case 'SET_ISSUBMITTING':
            return _extends({}, state, {
                isSubmitting: msg.payload
            });
        case 'SET_ISVALIDATING':
            return _extends({}, state, {
                isValidating: msg.payload
            });
        case 'SET_FIELD_VALUE':
            return _extends({}, state, {
                values: setIn(state.values, msg.payload.field, msg.payload.value)
            });
        case 'SET_FIELD_TOUCHED':
            return _extends({}, state, {
                touched: setIn(state.touched, msg.payload.field, msg.payload.value)
            });
        case 'SET_FIELD_ERROR':
            return _extends({}, state, {
                errors: setIn(state.errors, msg.payload.field, msg.payload.value)
            });
        case 'RESET_FORM':
            return _extends({}, state, msg.payload);
        case 'SET_FORMIK_STATE':
            return msg.payload(state);
        case 'SUBMIT_ATTEMPT':
            return _extends({}, state, {
                touched: setNestedObjectValues(state.values, true),
                isSubmitting: true,
                submitCount: state.submitCount + 1
            });
        case 'SUBMIT_FAILURE':
            return _extends({}, state, {
                isSubmitting: false
            });
        case 'SUBMIT_SUCCESS':
            return _extends({}, state, {
                isSubmitting: false
            });
        default:
            return state;
    }
} // Initial empty states // objects
var emptyErrors = {};
var emptyTouched = {};
function useFormik(_ref) {
    var _ref$validateOnChange = _ref.validateOnChange, validateOnChange = _ref$validateOnChange === void 0 ? true : _ref$validateOnChange, _ref$validateOnBlur = _ref.validateOnBlur, validateOnBlur = _ref$validateOnBlur === void 0 ? true : _ref$validateOnBlur, _ref$validateOnMount = _ref.validateOnMount, validateOnMount = _ref$validateOnMount === void 0 ? false : _ref$validateOnMount, isInitialValid = _ref.isInitialValid, _ref$enableReinitiali = _ref.enableReinitialize, enableReinitialize = _ref$enableReinitiali === void 0 ? false : _ref$enableReinitiali, onSubmit = _ref.onSubmit, rest = _objectWithoutPropertiesLoose(_ref, [
        "validateOnChange",
        "validateOnBlur",
        "validateOnMount",
        "isInitialValid",
        "enableReinitialize",
        "onSubmit"
    ]);
    var props = _extends({
        validateOnChange: validateOnChange,
        validateOnBlur: validateOnBlur,
        validateOnMount: validateOnMount,
        onSubmit: onSubmit
    }, rest);
    var initialValues = (0, $8v0nu.useRef)(props.initialValues);
    var initialErrors = (0, $8v0nu.useRef)(props.initialErrors || emptyErrors);
    var initialTouched = (0, $8v0nu.useRef)(props.initialTouched || emptyTouched);
    var initialStatus = (0, $8v0nu.useRef)(props.initialStatus);
    var isMounted = (0, $8v0nu.useRef)(false);
    var fieldRegistry = (0, $8v0nu.useRef)({});
    (0, $8v0nu.useEffect)(function() {
        isMounted.current = true;
        return function() {
            isMounted.current = false;
        };
    }, []);
    var _React$useState = (0, $8v0nu.useState)(0), setIteration = _React$useState[1];
    var stateRef = (0, $8v0nu.useRef)({
        values: (0, $jGWdr.default)(props.initialValues),
        errors: (0, $jGWdr.default)(props.initialErrors) || emptyErrors,
        touched: (0, $jGWdr.default)(props.initialTouched) || emptyTouched,
        status: (0, $jGWdr.default)(props.initialStatus),
        isSubmitting: false,
        isValidating: false,
        submitCount: 0
    });
    var state = stateRef.current;
    var dispatch = (0, $8v0nu.useCallback)(function(action) {
        var prev = stateRef.current;
        stateRef.current = formikReducer(prev, action); // force rerender
        if (prev !== stateRef.current) setIteration(function(x) {
            return x + 1;
        });
    }, []);
    var runValidateHandler = (0, $8v0nu.useCallback)(function(values, field) {
        return new Promise(function(resolve, reject) {
            var maybePromisedErrors = props.validate(values, field);
            if (maybePromisedErrors == null) // use loose null check here on purpose
            resolve(emptyErrors);
            else if (isPromise(maybePromisedErrors)) maybePromisedErrors.then(function(errors) {
                resolve(errors || emptyErrors);
            }, function(actualException) {
                reject(actualException);
            });
            else resolve(maybePromisedErrors);
        });
    }, [
        props.validate
    ]);
    /**
   * Run validation against a Yup schema and optionally run a function if successful
   */ var runValidationSchema = (0, $8v0nu.useCallback)(function(values, field) {
        var validationSchema = props.validationSchema;
        var schema = isFunction(validationSchema) ? validationSchema(field) : validationSchema;
        var promise = field && schema.validateAt ? schema.validateAt(field, values) : validateYupSchema(values, schema);
        return new Promise(function(resolve, reject) {
            promise.then(function() {
                resolve(emptyErrors);
            }, function(err) {
                // Yup will throw a validation error if validation fails. We catch those and
                // resolve them into Formik errors. We can sniff if something is a Yup error
                // by checking error.name.
                // @see https://github.com/jquense/yup#validationerrorerrors-string--arraystring-value-any-path-string
                if (err.name === 'ValidationError') resolve(yupToFormErrors(err));
                else reject(err);
            });
        });
    }, [
        props.validationSchema
    ]);
    var runSingleFieldLevelValidation = (0, $8v0nu.useCallback)(function(field, value) {
        return new Promise(function(resolve) {
            return resolve(fieldRegistry.current[field].validate(value));
        });
    }, []);
    var runFieldLevelValidations = (0, $8v0nu.useCallback)(function(values) {
        var fieldKeysWithValidation = Object.keys(fieldRegistry.current).filter(function(f) {
            return isFunction(fieldRegistry.current[f].validate);
        }); // Construct an array with all of the field validation functions
        var fieldValidations = fieldKeysWithValidation.length > 0 ? fieldKeysWithValidation.map(function(f) {
            return runSingleFieldLevelValidation(f, getIn(values, f));
        }) : [
            Promise.resolve('DO_NOT_DELETE_YOU_WILL_BE_FIRED')
        ]; // use special case ;)
        return Promise.all(fieldValidations).then(function(fieldErrorsList) {
            return fieldErrorsList.reduce(function(prev, curr, index) {
                if (curr === 'DO_NOT_DELETE_YOU_WILL_BE_FIRED') return prev;
                if (curr) prev = setIn(prev, fieldKeysWithValidation[index], curr);
                return prev;
            }, {});
        });
    }, [
        runSingleFieldLevelValidation
    ]); // Run all validations and return the result
    var runAllValidations = (0, $8v0nu.useCallback)(function(values) {
        return Promise.all([
            runFieldLevelValidations(values),
            props.validationSchema ? runValidationSchema(values) : {},
            props.validate ? runValidateHandler(values) : {}
        ]).then(function(_ref2) {
            var fieldErrors = _ref2[0], schemaErrors = _ref2[1], validateErrors = _ref2[2];
            var combinedErrors = (0, $l30Rn.default).all([
                fieldErrors,
                schemaErrors,
                validateErrors
            ], {
                arrayMerge: arrayMerge
            });
            return combinedErrors;
        });
    }, [
        props.validate,
        props.validationSchema,
        runFieldLevelValidations,
        runValidateHandler,
        runValidationSchema
    ]); // Run all validations methods and update state accordingly
    var validateFormWithHighPriority = useEventCallback(function(values) {
        if (values === void 0) values = state.values;
        dispatch({
            type: 'SET_ISVALIDATING',
            payload: true
        });
        return runAllValidations(values).then(function(combinedErrors) {
            if (!!isMounted.current) {
                dispatch({
                    type: 'SET_ISVALIDATING',
                    payload: false
                });
                dispatch({
                    type: 'SET_ERRORS',
                    payload: combinedErrors
                });
            }
            return combinedErrors;
        });
    });
    (0, $8v0nu.useEffect)(function() {
        if (validateOnMount && isMounted.current === true && (0, (/*@__PURE__*/$parcel$interopDefault($5N63k)))(initialValues.current, props.initialValues)) validateFormWithHighPriority(initialValues.current);
    }, [
        validateOnMount,
        validateFormWithHighPriority
    ]);
    var resetForm = (0, $8v0nu.useCallback)(function(nextState) {
        var values = nextState && nextState.values ? nextState.values : initialValues.current;
        var errors = nextState && nextState.errors ? nextState.errors : initialErrors.current ? initialErrors.current : props.initialErrors || {};
        var touched = nextState && nextState.touched ? nextState.touched : initialTouched.current ? initialTouched.current : props.initialTouched || {};
        var status = nextState && nextState.status ? nextState.status : initialStatus.current ? initialStatus.current : props.initialStatus;
        initialValues.current = values;
        initialErrors.current = errors;
        initialTouched.current = touched;
        initialStatus.current = status;
        var dispatchFn = function dispatchFn() {
            dispatch({
                type: 'RESET_FORM',
                payload: {
                    isSubmitting: !!nextState && !!nextState.isSubmitting,
                    errors: errors,
                    touched: touched,
                    status: status,
                    values: values,
                    isValidating: !!nextState && !!nextState.isValidating,
                    submitCount: !!nextState && !!nextState.submitCount && typeof nextState.submitCount === 'number' ? nextState.submitCount : 0
                }
            });
        };
        if (props.onReset) {
            var maybePromisedOnReset = props.onReset(state.values, imperativeMethods);
            if (isPromise(maybePromisedOnReset)) maybePromisedOnReset.then(dispatchFn);
            else dispatchFn();
        } else dispatchFn();
    }, [
        props.initialErrors,
        props.initialStatus,
        props.initialTouched,
        props.onReset
    ]);
    (0, $8v0nu.useEffect)(function() {
        if (isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($5N63k)))(initialValues.current, props.initialValues)) {
            if (enableReinitialize) {
                initialValues.current = props.initialValues;
                resetForm();
                if (validateOnMount) validateFormWithHighPriority(initialValues.current);
            }
        }
    }, [
        enableReinitialize,
        props.initialValues,
        resetForm,
        validateOnMount,
        validateFormWithHighPriority
    ]);
    (0, $8v0nu.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($5N63k)))(initialErrors.current, props.initialErrors)) {
            initialErrors.current = props.initialErrors || emptyErrors;
            dispatch({
                type: 'SET_ERRORS',
                payload: props.initialErrors || emptyErrors
            });
        }
    }, [
        enableReinitialize,
        props.initialErrors
    ]);
    (0, $8v0nu.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($5N63k)))(initialTouched.current, props.initialTouched)) {
            initialTouched.current = props.initialTouched || emptyTouched;
            dispatch({
                type: 'SET_TOUCHED',
                payload: props.initialTouched || emptyTouched
            });
        }
    }, [
        enableReinitialize,
        props.initialTouched
    ]);
    (0, $8v0nu.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($5N63k)))(initialStatus.current, props.initialStatus)) {
            initialStatus.current = props.initialStatus;
            dispatch({
                type: 'SET_STATUS',
                payload: props.initialStatus
            });
        }
    }, [
        enableReinitialize,
        props.initialStatus,
        props.initialTouched
    ]);
    var validateField = useEventCallback(function(name) {
        // This will efficiently validate a single field by avoiding state
        // changes if the validation function is synchronous. It's different from
        // what is called when using validateForm.
        if (fieldRegistry.current[name] && isFunction(fieldRegistry.current[name].validate)) {
            var value = getIn(state.values, name);
            var maybePromise = fieldRegistry.current[name].validate(value);
            if (isPromise(maybePromise)) {
                // Only flip isValidating if the function is async.
                dispatch({
                    type: 'SET_ISVALIDATING',
                    payload: true
                });
                return maybePromise.then(function(x) {
                    return x;
                }).then(function(error) {
                    dispatch({
                        type: 'SET_FIELD_ERROR',
                        payload: {
                            field: name,
                            value: error
                        }
                    });
                    dispatch({
                        type: 'SET_ISVALIDATING',
                        payload: false
                    });
                });
            } else {
                dispatch({
                    type: 'SET_FIELD_ERROR',
                    payload: {
                        field: name,
                        value: maybePromise
                    }
                });
                return Promise.resolve(maybePromise);
            }
        } else if (props.validationSchema) {
            dispatch({
                type: 'SET_ISVALIDATING',
                payload: true
            });
            return runValidationSchema(state.values, name).then(function(x) {
                return x;
            }).then(function(error) {
                dispatch({
                    type: 'SET_FIELD_ERROR',
                    payload: {
                        field: name,
                        value: getIn(error, name)
                    }
                });
                dispatch({
                    type: 'SET_ISVALIDATING',
                    payload: false
                });
            });
        }
        return Promise.resolve();
    });
    var registerField = (0, $8v0nu.useCallback)(function(name, _ref3) {
        var validate = _ref3.validate;
        fieldRegistry.current[name] = {
            validate: validate
        };
    }, []);
    var unregisterField = (0, $8v0nu.useCallback)(function(name) {
        delete fieldRegistry.current[name];
    }, []);
    var setTouched = useEventCallback(function(touched, shouldValidate) {
        dispatch({
            type: 'SET_TOUCHED',
            payload: touched
        });
        var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
        return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
    });
    var setErrors = (0, $8v0nu.useCallback)(function(errors) {
        dispatch({
            type: 'SET_ERRORS',
            payload: errors
        });
    }, []);
    var setValues = useEventCallback(function(values, shouldValidate) {
        var resolvedValues = isFunction(values) ? values(state.values) : values;
        dispatch({
            type: 'SET_VALUES',
            payload: resolvedValues
        });
        var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
        return willValidate ? validateFormWithHighPriority(resolvedValues) : Promise.resolve();
    });
    var setFieldError = (0, $8v0nu.useCallback)(function(field, value) {
        dispatch({
            type: 'SET_FIELD_ERROR',
            payload: {
                field: field,
                value: value
            }
        });
    }, []);
    var setFieldValue = useEventCallback(function(field, value, shouldValidate) {
        var resolvedValue = isFunction(value) ? value(getIn(state.values, field)) : value;
        dispatch({
            type: 'SET_FIELD_VALUE',
            payload: {
                field: field,
                value: resolvedValue
            }
        });
        var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
        return willValidate ? validateFormWithHighPriority(setIn(state.values, field, resolvedValue)) : Promise.resolve();
    });
    var executeChange = (0, $8v0nu.useCallback)(function(eventOrTextValue, maybePath) {
        // By default, assume that the first argument is a string. This allows us to use
        // handleChange with React Native and React Native Web's onChangeText prop which
        // provides just the value of the input.
        var field = maybePath;
        var val = eventOrTextValue;
        var parsed; // If the first argument is not a string though, it has to be a synthetic React Event (or a fake one),
        // so we handle like we would a normal HTML change event.
        if (!isString(eventOrTextValue)) {
            // If we can, persist the event
            // @see https://reactjs.org/docs/events.html#event-pooling
            if (eventOrTextValue.persist) eventOrTextValue.persist();
            var target = eventOrTextValue.target ? eventOrTextValue.target : eventOrTextValue.currentTarget;
            var type = target.type, name = target.name, id = target.id, value = target.value, checked = target.checked, outerHTML = target.outerHTML, options = target.options, multiple = target.multiple;
            field = maybePath ? maybePath : name ? name : id;
            field;
            val = /number|range/.test(type) ? (parsed = parseFloat(value), isNaN(parsed) ? '' : parsed) : /checkbox/.test(type) // checkboxes
             ? getValueForCheckbox(getIn(state.values, field), checked, value) : options && multiple // <select multiple>
             ? getSelectedValues(options) : value;
        }
        if (field) // Set form fields by name
        setFieldValue(field, val);
    }, [
        setFieldValue,
        state.values
    ]);
    var handleChange = useEventCallback(function(eventOrPath) {
        if (isString(eventOrPath)) return function(event) {
            return executeChange(event, eventOrPath);
        };
        else executeChange(eventOrPath);
    });
    var setFieldTouched = useEventCallback(function(field, touched, shouldValidate) {
        if (touched === void 0) touched = true;
        dispatch({
            type: 'SET_FIELD_TOUCHED',
            payload: {
                field: field,
                value: touched
            }
        });
        var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
        return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
    });
    var executeBlur = (0, $8v0nu.useCallback)(function(e, path) {
        if (e.persist) e.persist();
        var _e$target = e.target, name = _e$target.name, id = _e$target.id, outerHTML = _e$target.outerHTML;
        var field = path ? path : name ? name : id;
        field;
        setFieldTouched(field, true);
    }, [
        setFieldTouched
    ]);
    var handleBlur = useEventCallback(function(eventOrString) {
        if (isString(eventOrString)) return function(event) {
            return executeBlur(event, eventOrString);
        };
        else executeBlur(eventOrString);
    });
    var setFormikState = (0, $8v0nu.useCallback)(function(stateOrCb) {
        if (isFunction(stateOrCb)) dispatch({
            type: 'SET_FORMIK_STATE',
            payload: stateOrCb
        });
        else dispatch({
            type: 'SET_FORMIK_STATE',
            payload: function payload() {
                return stateOrCb;
            }
        });
    }, []);
    var setStatus = (0, $8v0nu.useCallback)(function(status) {
        dispatch({
            type: 'SET_STATUS',
            payload: status
        });
    }, []);
    var setSubmitting = (0, $8v0nu.useCallback)(function(isSubmitting) {
        dispatch({
            type: 'SET_ISSUBMITTING',
            payload: isSubmitting
        });
    }, []);
    var submitForm = useEventCallback(function() {
        dispatch({
            type: 'SUBMIT_ATTEMPT'
        });
        return validateFormWithHighPriority().then(function(combinedErrors) {
            // In case an error was thrown and passed to the resolved Promise,
            // `combinedErrors` can be an instance of an Error. We need to check
            // that and abort the submit.
            // If we don't do that, calling `Object.keys(new Error())` yields an
            // empty array, which causes the validation to pass and the form
            // to be submitted.
            var isInstanceOfError = combinedErrors instanceof Error;
            var isActuallyValid = !isInstanceOfError && Object.keys(combinedErrors).length === 0;
            if (isActuallyValid) {
                // Proceed with submit...
                //
                // To respect sync submit fns, we can't simply wrap executeSubmit in a promise and
                // _always_ dispatch SUBMIT_SUCCESS because isSubmitting would then always be false.
                // This would be fine in simple cases, but make it impossible to disable submit
                // buttons where people use callbacks or promises as side effects (which is basically
                // all of v1 Formik code). Instead, recall that we are inside of a promise chain already,
                //  so we can try/catch executeSubmit(), if it returns undefined, then just bail.
                // If there are errors, throw em. Otherwise, wrap executeSubmit in a promise and handle
                // cleanup of isSubmitting on behalf of the consumer.
                var promiseOrUndefined;
                try {
                    promiseOrUndefined = executeSubmit(); // Bail if it's sync, consumer is responsible for cleaning up
                    // via setSubmitting(false)
                    if (promiseOrUndefined === undefined) return;
                } catch (error) {
                    throw error;
                }
                return Promise.resolve(promiseOrUndefined).then(function(result) {
                    if (!!isMounted.current) dispatch({
                        type: 'SUBMIT_SUCCESS'
                    });
                    return result;
                })["catch"](function(_errors) {
                    if (!!isMounted.current) {
                        dispatch({
                            type: 'SUBMIT_FAILURE'
                        }); // This is a legit error rejected by the onSubmit fn
                        // so we don't want to break the promise chain
                        throw _errors;
                    }
                });
            } else if (!!isMounted.current) {
                // ^^^ Make sure Formik is still mounted before updating state
                dispatch({
                    type: 'SUBMIT_FAILURE'
                }); // throw combinedErrors;
                if (isInstanceOfError) throw combinedErrors;
            }
            return;
        });
    });
    var handleSubmit = useEventCallback(function(e) {
        if (e && e.preventDefault && isFunction(e.preventDefault)) e.preventDefault();
        if (e && e.stopPropagation && isFunction(e.stopPropagation)) e.stopPropagation();
         // Warn if form submission is triggered by a <button> without a
        var activeElement;
        submitForm()["catch"](function(reason) {
            console.warn("Warning: An unhandled error was caught from submitForm()", reason);
        });
    });
    var imperativeMethods = {
        resetForm: resetForm,
        validateForm: validateFormWithHighPriority,
        validateField: validateField,
        setErrors: setErrors,
        setFieldError: setFieldError,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        setStatus: setStatus,
        setSubmitting: setSubmitting,
        setTouched: setTouched,
        setValues: setValues,
        setFormikState: setFormikState,
        submitForm: submitForm
    };
    var executeSubmit = useEventCallback(function() {
        return onSubmit(state.values, imperativeMethods);
    });
    var handleReset = useEventCallback(function(e) {
        if (e && e.preventDefault && isFunction(e.preventDefault)) e.preventDefault();
        if (e && e.stopPropagation && isFunction(e.stopPropagation)) e.stopPropagation();
        resetForm();
    });
    var getFieldMeta = (0, $8v0nu.useCallback)(function(name) {
        return {
            value: getIn(state.values, name),
            error: getIn(state.errors, name),
            touched: !!getIn(state.touched, name),
            initialValue: getIn(initialValues.current, name),
            initialTouched: !!getIn(initialTouched.current, name),
            initialError: getIn(initialErrors.current, name)
        };
    }, [
        state.errors,
        state.touched,
        state.values
    ]);
    var getFieldHelpers = (0, $8v0nu.useCallback)(function(name) {
        return {
            setValue: function setValue(value, shouldValidate) {
                return setFieldValue(name, value, shouldValidate);
            },
            setTouched: function setTouched(value, shouldValidate) {
                return setFieldTouched(name, value, shouldValidate);
            },
            setError: function setError(value) {
                return setFieldError(name, value);
            }
        };
    }, [
        setFieldValue,
        setFieldTouched,
        setFieldError
    ]);
    var getFieldProps = (0, $8v0nu.useCallback)(function(nameOrOptions) {
        var isAnObject = isObject(nameOrOptions);
        var name = isAnObject ? nameOrOptions.name : nameOrOptions;
        var valueState = getIn(state.values, name);
        var field = {
            name: name,
            value: valueState,
            onChange: handleChange,
            onBlur: handleBlur
        };
        if (isAnObject) {
            var type = nameOrOptions.type, valueProp = nameOrOptions.value, is = nameOrOptions.as, multiple = nameOrOptions.multiple;
            if (type === 'checkbox') {
                if (valueProp === undefined) field.checked = !!valueState;
                else {
                    field.checked = !!(Array.isArray(valueState) && ~valueState.indexOf(valueProp));
                    field.value = valueProp;
                }
            } else if (type === 'radio') {
                field.checked = valueState === valueProp;
                field.value = valueProp;
            } else if (is === 'select' && multiple) {
                field.value = field.value || [];
                field.multiple = true;
            }
        }
        return field;
    }, [
        handleBlur,
        handleChange,
        state.values
    ]);
    var dirty = (0, $8v0nu.useMemo)(function() {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($5N63k)))(initialValues.current, state.values);
    }, [
        initialValues.current,
        state.values
    ]);
    var isValid = (0, $8v0nu.useMemo)(function() {
        return typeof isInitialValid !== 'undefined' ? dirty ? state.errors && Object.keys(state.errors).length === 0 : isInitialValid !== false && isFunction(isInitialValid) ? isInitialValid(props) : isInitialValid : state.errors && Object.keys(state.errors).length === 0;
    }, [
        isInitialValid,
        dirty,
        state.errors,
        props
    ]);
    var ctx = _extends({}, state, {
        initialValues: initialValues.current,
        initialErrors: initialErrors.current,
        initialTouched: initialTouched.current,
        initialStatus: initialStatus.current,
        handleBlur: handleBlur,
        handleChange: handleChange,
        handleReset: handleReset,
        handleSubmit: handleSubmit,
        resetForm: resetForm,
        setErrors: setErrors,
        setFormikState: setFormikState,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        setFieldError: setFieldError,
        setStatus: setStatus,
        setSubmitting: setSubmitting,
        setTouched: setTouched,
        setValues: setValues,
        submitForm: submitForm,
        validateForm: validateFormWithHighPriority,
        validateField: validateField,
        isValid: isValid,
        dirty: dirty,
        unregisterField: unregisterField,
        registerField: registerField,
        getFieldProps: getFieldProps,
        getFieldMeta: getFieldMeta,
        getFieldHelpers: getFieldHelpers,
        validateOnBlur: validateOnBlur,
        validateOnChange: validateOnChange,
        validateOnMount: validateOnMount
    });
    return ctx;
}
function Formik(props) {
    var formikbag = useFormik(props);
    var component = props.component, children = props.children, render = props.render, innerRef = props.innerRef; // This allows folks to pass a ref to <Formik />
    (0, $8v0nu.useImperativeHandle)(innerRef, function() {
        return formikbag;
    });
    return (0, $8v0nu.createElement)(FormikProvider, {
        value: formikbag
    }, component ? (0, $8v0nu.createElement)(component, formikbag) : render ? render(formikbag) : children // children come last, always called
     ? isFunction(children) ? children(formikbag) : !isEmptyChildren(children) ? (0, $8v0nu.Children).only(children) : null : null);
}
function warnAboutMissingIdentifier(_ref4) {
    var htmlContent = _ref4.htmlContent, documentationAnchorLink = _ref4.documentationAnchorLink, handlerName = _ref4.handlerName;
    console.warn("Warning: Formik called `" + handlerName + "`, but you forgot to pass an `id` or `name` attribute to your input:\n    " + htmlContent + "\n    Formik cannot determine which value to update. For more info see https://formik.org/docs/api/formik#" + documentationAnchorLink + "\n  ");
}
/**
 * Transform Yup ValidationError to a more usable object
 */ function yupToFormErrors(yupError) {
    var errors = {};
    if (yupError.inner) {
        if (yupError.inner.length === 0) return setIn(errors, yupError.path, yupError.message);
        for(var _iterator = yupError.inner, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
            var _ref5;
            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref5 = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref5 = _i.value;
            }
            var err = _ref5;
            if (!getIn(errors, err.path)) errors = setIn(errors, err.path, err.message);
        }
    }
    return errors;
}
/**
 * Validate a yup schema.
 */ function validateYupSchema(values, schema, sync, context) {
    if (sync === void 0) sync = false;
    var normalizedValues = prepareDataForValidation(values);
    return schema[sync ? 'validateSync' : 'validate'](normalizedValues, {
        abortEarly: false,
        context: context || normalizedValues
    });
}
/**
 * Recursively prepare values.
 */ function prepareDataForValidation(values) {
    var data = Array.isArray(values) ? [] : {};
    for(var k in values)if (Object.prototype.hasOwnProperty.call(values, k)) {
        var key = String(k);
        if (Array.isArray(values[key]) === true) data[key] = values[key].map(function(value) {
            if (Array.isArray(value) === true || (0, $336aN.default)(value)) return prepareDataForValidation(value);
            else return value !== '' ? value : undefined;
        });
        else if ((0, $336aN.default)(values[key])) data[key] = prepareDataForValidation(values[key]);
        else data[key] = values[key] !== '' ? values[key] : undefined;
    }
    return data;
}
/**
 * deepmerge array merging algorithm
 * https://github.com/KyleAMathews/deepmerge#combine-array
 */ function arrayMerge(target, source, options) {
    var destination = target.slice();
    source.forEach(function merge(e, i) {
        if (typeof destination[i] === 'undefined') {
            var cloneRequested = options.clone !== false;
            var shouldClone = cloneRequested && options.isMergeableObject(e);
            destination[i] = shouldClone ? (0, $l30Rn.default)(Array.isArray(e) ? [] : {}, e, options) : e;
        } else if (options.isMergeableObject(e)) destination[i] = (0, $l30Rn.default)(target[i], e, options);
        else if (target.indexOf(e) === -1) destination.push(e);
    });
    return destination;
}
/** Return multi select values based on an array of options */ function getSelectedValues(options) {
    return Array.from(options).filter(function(el) {
        return el.selected;
    }).map(function(el) {
        return el.value;
    });
}
/** Return the next value for a checkbox */ function getValueForCheckbox(currentValue, checked, valueProp) {
    // If the current value was a boolean, return a boolean
    if (typeof currentValue === 'boolean') return Boolean(checked);
     // If the currentValue was not a boolean we want to return an array
    var currentArrayOfValues = [];
    var isValueInArray = false;
    var index = -1;
    if (!Array.isArray(currentValue)) {
        // eslint-disable-next-line eqeqeq
        if (!valueProp || valueProp == 'true' || valueProp == 'false') return Boolean(checked);
    } else {
        // If the current value is already an array, use it
        currentArrayOfValues = currentValue;
        index = currentValue.indexOf(valueProp);
        isValueInArray = index >= 0;
    } // If the checkbox was checked and the value is not already present in the aray we want to add the new value to the array of values
    if (checked && valueProp && !isValueInArray) return currentArrayOfValues.concat(valueProp);
     // If the checkbox was unchecked and the value is not in the array, simply return the already existing array of values
    if (!isValueInArray) return currentArrayOfValues;
     // If the checkbox was unchecked and the value is in the array, remove the value and return the array
    return currentArrayOfValues.slice(0, index).concat(currentArrayOfValues.slice(index + 1));
} // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
// @see https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, $8v0nu.useLayoutEffect) : (0, $8v0nu.useEffect);
function useEventCallback(fn) {
    var ref = (0, $8v0nu.useRef)(fn); // we copy a ref to the callback scoped to the current state/props on each render
    useIsomorphicLayoutEffect(function() {
        ref.current = fn;
    });
    return (0, $8v0nu.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current.apply(void 0, args);
    }, []);
}
function useField(propsOrFieldName) {
    var formik = useFormikContext();
    var getFieldProps = formik.getFieldProps, getFieldMeta = formik.getFieldMeta, getFieldHelpers = formik.getFieldHelpers, registerField = formik.registerField, unregisterField = formik.unregisterField;
    var isAnObject = isObject(propsOrFieldName); // Normalize propsOrFieldName to FieldHookConfig<Val>
    var props = isAnObject ? propsOrFieldName : {
        name: propsOrFieldName
    };
    var fieldName = props.name, validateFn = props.validate;
    (0, $8v0nu.useEffect)(function() {
        if (fieldName) registerField(fieldName, {
            validate: validateFn
        });
        return function() {
            if (fieldName) unregisterField(fieldName);
        };
    }, [
        registerField,
        unregisterField,
        fieldName,
        validateFn
    ]);
    !fieldName && (0, $7li8V.default)(false);
    var fieldHelpers = (0, $8v0nu.useMemo)(function() {
        return getFieldHelpers(fieldName);
    }, [
        getFieldHelpers,
        fieldName
    ]);
    return [
        getFieldProps(props),
        getFieldMeta(fieldName),
        fieldHelpers
    ];
}
function Field(_ref) {
    var validate = _ref.validate, name = _ref.name, render = _ref.render, children = _ref.children, is = _ref.as, component = _ref.component, className = _ref.className, props = _objectWithoutPropertiesLoose(_ref, [
        "validate",
        "name",
        "render",
        "children",
        "as",
        "component",
        "className"
    ]);
    var _useFormikContext = useFormikContext(), formik = _objectWithoutPropertiesLoose(_useFormikContext, [
        "validate",
        "validationSchema"
    ]);
    var registerField = formik.registerField, unregisterField = formik.unregisterField;
    (0, $8v0nu.useEffect)(function() {
        registerField(name, {
            validate: validate
        });
        return function() {
            unregisterField(name);
        };
    }, [
        registerField,
        unregisterField,
        name,
        validate
    ]);
    var field = formik.getFieldProps(_extends({
        name: name
    }, props));
    var meta = formik.getFieldMeta(name);
    var legacyBag = {
        field: field,
        form: formik
    };
    if (render) return render(_extends({}, legacyBag, {
        meta: meta
    }));
    if (isFunction(children)) return children(_extends({}, legacyBag, {
        meta: meta
    }));
    if (component) {
        // This behavior is backwards compat with earlier Formik 0.9 to 1.x
        if (typeof component === 'string') {
            var innerRef = props.innerRef, rest = _objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, $8v0nu.createElement)(component, _extends({
                ref: innerRef
            }, field, rest, {
                className: className
            }), children);
        } // We don't pass `meta` for backwards compat
        return (0, $8v0nu.createElement)(component, _extends({
            field: field,
            form: formik
        }, props, {
            className: className
        }), children);
    } // default to input here so we can check for both `as` and `children` above
    var asElement = is || 'input';
    if (typeof asElement === 'string') {
        var _innerRef = props.innerRef, _rest = _objectWithoutPropertiesLoose(props, [
            "innerRef"
        ]);
        return (0, $8v0nu.createElement)(asElement, _extends({
            ref: _innerRef
        }, field, _rest, {
            className: className
        }), children);
    }
    return (0, $8v0nu.createElement)(asElement, _extends({}, field, props, {
        className: className
    }), children);
}
var Form = /*#__PURE__*/ (0, $8v0nu.forwardRef)(function(props, ref) {
    // iOS needs an "action" attribute for nice input: https://stackoverflow.com/a/39485162/406725
    // We default the action to "#" in case the preventDefault fails (just updates the URL hash)
    var action = props.action, rest = _objectWithoutPropertiesLoose(props, [
        "action"
    ]);
    var _action = action != null ? action : '#';
    var _useFormikContext = useFormikContext(), handleReset = _useFormikContext.handleReset, handleSubmit = _useFormikContext.handleSubmit;
    return (0, $8v0nu.createElement)("form", _extends({
        onSubmit: handleSubmit,
        ref: ref,
        onReset: handleReset,
        action: _action
    }, rest));
});
Form.displayName = 'Form';
/**
 * A public higher-order component to access the imperative API
 */ function withFormik(_ref) {
    var _ref$mapPropsToValues = _ref.mapPropsToValues, mapPropsToValues = _ref$mapPropsToValues === void 0 ? function(vanillaProps) {
        var val = {};
        for(var k in vanillaProps)if (vanillaProps.hasOwnProperty(k) && typeof vanillaProps[k] !== 'function') // @todo TypeScript fix
        val[k] = vanillaProps[k];
        return val;
    } : _ref$mapPropsToValues, config = _objectWithoutPropertiesLoose(_ref, [
        "mapPropsToValues"
    ]);
    return function createFormik(Component$1) {
        var componentDisplayName = Component$1.displayName || Component$1.name || Component$1.constructor && Component$1.constructor.name || 'Component';
        /**
     * We need to use closures here for to provide the wrapped component's props to
     * the respective withFormik config methods.
     */ var C = /*#__PURE__*/ function(_React$Component) {
            _inheritsLoose(C, _React$Component);
            function C() {
                var _this;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                _this = _React$Component.call.apply(_React$Component, [
                    this
                ].concat(args)) || this;
                _this.validate = function(values) {
                    return config.validate(values, _this.props);
                };
                _this.validationSchema = function() {
                    return isFunction(config.validationSchema) ? config.validationSchema(_this.props) : config.validationSchema;
                };
                _this.handleSubmit = function(values, actions) {
                    return config.handleSubmit(values, _extends({}, actions, {
                        props: _this.props
                    }));
                };
                _this.renderFormComponent = function(formikProps) {
                    return (0, $8v0nu.createElement)(Component$1, _extends({}, _this.props, formikProps));
                };
                return _this;
            }
            var _proto = C.prototype;
            _proto.render = function render() {
                var _this$props = this.props, props = _objectWithoutPropertiesLoose(_this$props, [
                    "children"
                ]);
                return (0, $8v0nu.createElement)(Formik, _extends({}, props, config, {
                    validate: config.validate && this.validate,
                    validationSchema: config.validationSchema && this.validationSchema,
                    initialValues: mapPropsToValues(this.props),
                    initialStatus: config.mapPropsToStatus && config.mapPropsToStatus(this.props),
                    initialErrors: config.mapPropsToErrors && config.mapPropsToErrors(this.props),
                    initialTouched: config.mapPropsToTouched && config.mapPropsToTouched(this.props),
                    onSubmit: this.handleSubmit,
                    children: this.renderFormComponent
                }));
            };
            return C;
        }((0, $8v0nu.Component));
        C.displayName = "WithFormik(" + componentDisplayName + ")";
        return (0, (/*@__PURE__*/$parcel$interopDefault($1NGjT)))(C, Component$1 // cast type to ComponentClass (even if SFC)
        );
    };
}
/**
 * Connect any component to Formik context, and inject as a prop called `formik`;
 * @param Comp React Component
 */ function connect(Comp) {
    var C = function C(props) {
        return (0, $8v0nu.createElement)(FormikConsumer, null, function(formik) {
            !!!formik && (0, $7li8V.default)(false);
            return (0, $8v0nu.createElement)(Comp, _extends({}, props, {
                formik: formik
            }));
        });
    };
    var componentDisplayName = Comp.displayName || Comp.name || Comp.constructor && Comp.constructor.name || 'Component'; // Assign Comp to C.WrappedComponent so we can access the inner component in tests
    // For example, <Field.WrappedComponent /> gets us <FieldInner/>
    C.WrappedComponent = Comp;
    C.displayName = "FormikConnect(" + componentDisplayName + ")";
    return (0, (/*@__PURE__*/$parcel$interopDefault($1NGjT)))(C, Comp // cast type to ComponentClass (even if SFC)
    );
}
/**
 * Some array helpers!
 */ var move = function move(array, from, to) {
    var copy = copyArrayLike(array);
    var value = copy[from];
    copy.splice(from, 1);
    copy.splice(to, 0, value);
    return copy;
};
var swap = function swap(arrayLike, indexA, indexB) {
    var copy = copyArrayLike(arrayLike);
    var a = copy[indexA];
    copy[indexA] = copy[indexB];
    copy[indexB] = a;
    return copy;
};
var insert = function insert(arrayLike, index, value) {
    var copy = copyArrayLike(arrayLike);
    copy.splice(index, 0, value);
    return copy;
};
var replace = function replace(arrayLike, index, value) {
    var copy = copyArrayLike(arrayLike);
    copy[index] = value;
    return copy;
};
var copyArrayLike = function copyArrayLike(arrayLike) {
    if (!arrayLike) return [];
    else if (Array.isArray(arrayLike)) return [].concat(arrayLike);
    else {
        var maxIndex = Object.keys(arrayLike).map(function(key) {
            return parseInt(key);
        }).reduce(function(max, el) {
            return el > max ? el : max;
        }, 0);
        return Array.from(_extends({}, arrayLike, {
            length: maxIndex + 1
        }));
    }
};
var createAlterationHandler = function createAlterationHandler(alteration, defaultFunction) {
    var fn = typeof alteration === 'function' ? alteration : defaultFunction;
    return function(data) {
        if (Array.isArray(data) || isObject(data)) {
            var clone = copyArrayLike(data);
            return fn(clone);
        } // This can be assumed to be a primitive, which
        // is a case for top level validation errors
        return data;
    };
};
var FieldArrayInner = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(FieldArrayInner, _React$Component);
    function FieldArrayInner(props) {
        var _this;
        _this = _React$Component.call(this, props) || this; // We need TypeScript generics on these, so we'll bind them in the constructor
        // @todo Fix TS 3.2.1
        _this.updateArrayField = function(fn, alterTouched, alterErrors) {
            var _this$props = _this.props, name = _this$props.name, setFormikState = _this$props.formik.setFormikState;
            setFormikState(function(prevState) {
                var updateErrors = createAlterationHandler(alterErrors, fn);
                var updateTouched = createAlterationHandler(alterTouched, fn); // values fn should be executed before updateErrors and updateTouched,
                // otherwise it causes an error with unshift.
                var values = setIn(prevState.values, name, fn(getIn(prevState.values, name)));
                var fieldError = alterErrors ? updateErrors(getIn(prevState.errors, name)) : undefined;
                var fieldTouched = alterTouched ? updateTouched(getIn(prevState.touched, name)) : undefined;
                if (isEmptyArray(fieldError)) fieldError = undefined;
                if (isEmptyArray(fieldTouched)) fieldTouched = undefined;
                return _extends({}, prevState, {
                    values: values,
                    errors: alterErrors ? setIn(prevState.errors, name, fieldError) : prevState.errors,
                    touched: alterTouched ? setIn(prevState.touched, name, fieldTouched) : prevState.touched
                });
            });
        };
        _this.push = function(value) {
            return _this.updateArrayField(function(arrayLike) {
                return [].concat(copyArrayLike(arrayLike), [
                    (0, $jGWdr.default)(value)
                ]);
            }, false, false);
        };
        _this.handlePush = function(value) {
            return function() {
                return _this.push(value);
            };
        };
        _this.swap = function(indexA, indexB) {
            return _this.updateArrayField(function(array) {
                return swap(array, indexA, indexB);
            }, true, true);
        };
        _this.handleSwap = function(indexA, indexB) {
            return function() {
                return _this.swap(indexA, indexB);
            };
        };
        _this.move = function(from, to) {
            return _this.updateArrayField(function(array) {
                return move(array, from, to);
            }, true, true);
        };
        _this.handleMove = function(from, to) {
            return function() {
                return _this.move(from, to);
            };
        };
        _this.insert = function(index, value) {
            return _this.updateArrayField(function(array) {
                return insert(array, index, value);
            }, function(array) {
                return insert(array, index, null);
            }, function(array) {
                return insert(array, index, null);
            });
        };
        _this.handleInsert = function(index, value) {
            return function() {
                return _this.insert(index, value);
            };
        };
        _this.replace = function(index, value) {
            return _this.updateArrayField(function(array) {
                return replace(array, index, value);
            }, false, false);
        };
        _this.handleReplace = function(index, value) {
            return function() {
                return _this.replace(index, value);
            };
        };
        _this.unshift = function(value) {
            var length = -1;
            _this.updateArrayField(function(array) {
                var arr = array ? [
                    value
                ].concat(array) : [
                    value
                ];
                length = arr.length;
                return arr;
            }, function(array) {
                return array ? [
                    null
                ].concat(array) : [
                    null
                ];
            }, function(array) {
                return array ? [
                    null
                ].concat(array) : [
                    null
                ];
            });
            return length;
        };
        _this.handleUnshift = function(value) {
            return function() {
                return _this.unshift(value);
            };
        };
        _this.handleRemove = function(index) {
            return function() {
                return _this.remove(index);
            };
        };
        _this.handlePop = function() {
            return function() {
                return _this.pop();
            };
        };
        _this.remove = _this.remove.bind(_assertThisInitialized(_this));
        _this.pop = _this.pop.bind(_assertThisInitialized(_this));
        return _this;
    }
    var _proto = FieldArrayInner.prototype;
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.validateOnChange && this.props.formik.validateOnChange && !(0, (/*@__PURE__*/$parcel$interopDefault($5N63k)))(getIn(prevProps.formik.values, prevProps.name), getIn(this.props.formik.values, this.props.name))) this.props.formik.validateForm(this.props.formik.values);
    };
    _proto.remove = function remove(index) {
        // We need to make sure we also remove relevant pieces of `touched` and `errors`
        var result;
        this.updateArrayField(function(array) {
            var copy = array ? copyArrayLike(array) : [];
            if (!result) result = copy[index];
            if (isFunction(copy.splice)) copy.splice(index, 1);
             // if the array only includes undefined values we have to return an empty array
            return isFunction(copy.every) ? copy.every(function(v) {
                return v === undefined;
            }) ? [] : copy : copy;
        }, true, true);
        return result;
    };
    _proto.pop = function pop() {
        // Remove relevant pieces of `touched` and `errors` too!
        var result;
        this.updateArrayField(function(array) {
            var tmp = array.slice();
            if (!result) result = tmp && tmp.pop && tmp.pop();
            return tmp;
        }, true, true);
        return result;
    };
    _proto.render = function render() {
        var arrayHelpers = {
            push: this.push,
            pop: this.pop,
            swap: this.swap,
            move: this.move,
            insert: this.insert,
            replace: this.replace,
            unshift: this.unshift,
            remove: this.remove,
            handlePush: this.handlePush,
            handlePop: this.handlePop,
            handleSwap: this.handleSwap,
            handleMove: this.handleMove,
            handleInsert: this.handleInsert,
            handleReplace: this.handleReplace,
            handleUnshift: this.handleUnshift,
            handleRemove: this.handleRemove
        };
        var _this$props2 = this.props, component = _this$props2.component, render = _this$props2.render, children = _this$props2.children, name = _this$props2.name, _this$props2$formik = _this$props2.formik, restOfFormik = _objectWithoutPropertiesLoose(_this$props2$formik, [
            "validate",
            "validationSchema"
        ]);
        var props = _extends({}, arrayHelpers, {
            form: restOfFormik,
            name: name
        });
        return component ? (0, $8v0nu.createElement)(component, props) : render ? render(props) : children // children come last, always called
         ? typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? (0, $8v0nu.Children).only(children) : null : null;
    };
    return FieldArrayInner;
}((0, $8v0nu.Component));
FieldArrayInner.defaultProps = {
    validateOnChange: true
};
var FieldArray = /*#__PURE__*/ connect(FieldArrayInner);
var ErrorMessageImpl = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(ErrorMessageImpl, _React$Component);
    function ErrorMessageImpl() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = ErrorMessageImpl.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (getIn(this.props.formik.errors, this.props.name) !== getIn(props.formik.errors, this.props.name) || getIn(this.props.formik.touched, this.props.name) !== getIn(props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length) return true;
        else return false;
    };
    _proto.render = function render() {
        var _this$props = this.props, component = _this$props.component, formik = _this$props.formik, render = _this$props.render, children = _this$props.children, name = _this$props.name, rest = _objectWithoutPropertiesLoose(_this$props, [
            "component",
            "formik",
            "render",
            "children",
            "name"
        ]);
        var touch = getIn(formik.touched, name);
        var error = getIn(formik.errors, name);
        return !!touch && !!error ? render ? isFunction(render) ? render(error) : null : children ? isFunction(children) ? children(error) : null : component ? (0, $8v0nu.createElement)(component, rest, error) : error : null;
    };
    return ErrorMessageImpl;
}((0, $8v0nu.Component));
var ErrorMessage = /*#__PURE__*/ connect(ErrorMessageImpl);
/**
 * Custom Field component for quickly hooking into Formik
 * context and wiring up forms.
 */ var FastFieldInner = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(FastFieldInner, _React$Component);
    function FastFieldInner(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        var render = props.render, children = props.children, component = props.component, is = props.as, name = props.name;
        !!render && (0, $7li8V.default)(false);
        !!(component && render) && (0, $7li8V.default)(false);
        !!(is && children && isFunction(children)) && (0, $7li8V.default)(false);
        !!(component && children && isFunction(children)) && (0, $7li8V.default)(false);
        !!(render && children && !isEmptyChildren(children)) && (0, $7li8V.default)(false);
        return _this;
    }
    var _proto = FastFieldInner.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (this.props.shouldUpdate) return this.props.shouldUpdate(props, this.props);
        else if (props.name !== this.props.name || getIn(props.formik.values, this.props.name) !== getIn(this.props.formik.values, this.props.name) || getIn(props.formik.errors, this.props.name) !== getIn(this.props.formik.errors, this.props.name) || getIn(props.formik.touched, this.props.name) !== getIn(this.props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length || props.formik.isSubmitting !== this.props.formik.isSubmitting) return true;
        else return false;
    };
    _proto.componentDidMount = function componentDidMount() {
        // Register the Field with the parent Formik. Parent will cycle through
        // registered Field's validate fns right prior to submit
        this.props.formik.registerField(this.props.name, {
            validate: this.props.validate
        });
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.name !== prevProps.name) {
            this.props.formik.unregisterField(prevProps.name);
            this.props.formik.registerField(this.props.name, {
                validate: this.props.validate
            });
        }
        if (this.props.validate !== prevProps.validate) this.props.formik.registerField(this.props.name, {
            validate: this.props.validate
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.props.formik.unregisterField(this.props.name);
    };
    _proto.render = function render() {
        var _this$props = this.props, name = _this$props.name, render = _this$props.render, is = _this$props.as, children = _this$props.children, component = _this$props.component, formik = _this$props.formik, props = _objectWithoutPropertiesLoose(_this$props, [
            "validate",
            "name",
            "render",
            "as",
            "children",
            "component",
            "shouldUpdate",
            "formik"
        ]);
        var restOfFormik = _objectWithoutPropertiesLoose(formik, [
            "validate",
            "validationSchema"
        ]);
        var field = formik.getFieldProps(_extends({
            name: name
        }, props));
        var meta = {
            value: getIn(formik.values, name),
            error: getIn(formik.errors, name),
            touched: !!getIn(formik.touched, name),
            initialValue: getIn(formik.initialValues, name),
            initialTouched: !!getIn(formik.initialTouched, name),
            initialError: getIn(formik.initialErrors, name)
        };
        var bag = {
            field: field,
            meta: meta,
            form: restOfFormik
        };
        if (render) return render(bag);
        if (isFunction(children)) return children(bag);
        if (component) {
            // This behavior is backwards compat with earlier Formik 0.9 to 1.x
            if (typeof component === 'string') {
                var innerRef = props.innerRef, rest = _objectWithoutPropertiesLoose(props, [
                    "innerRef"
                ]);
                return (0, $8v0nu.createElement)(component, _extends({
                    ref: innerRef
                }, field, rest), children);
            } // We don't pass `meta` for backwards compat
            return (0, $8v0nu.createElement)(component, _extends({
                field: field,
                form: formik
            }, props), children);
        } // default to input here so we can check for both `as` and `children` above
        var asElement = is || 'input';
        if (typeof asElement === 'string') {
            var _innerRef = props.innerRef, _rest = _objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, $8v0nu.createElement)(asElement, _extends({
                ref: _innerRef
            }, field, _rest), children);
        }
        return (0, $8v0nu.createElement)(asElement, _extends({}, field, props), children);
    };
    return FastFieldInner;
}((0, $8v0nu.Component));
var FastField = /*#__PURE__*/ connect(FastFieldInner);

});
parcelRegister("l30Rn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f52a8b88269c0d84$export$2e2bcd8739ae039; });
var $f52a8b88269c0d84$var$isMergeableObject = function isMergeableObject(value) {
    return $f52a8b88269c0d84$var$isNonNullObject(value) && !$f52a8b88269c0d84$var$isSpecial(value);
};
function $f52a8b88269c0d84$var$isNonNullObject(value) {
    return !!value && typeof value === 'object';
}
function $f52a8b88269c0d84$var$isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === '[object RegExp]' || stringValue === '[object Date]' || $f52a8b88269c0d84$var$isReactElement(value);
}
// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var $f52a8b88269c0d84$var$canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var $f52a8b88269c0d84$var$REACT_ELEMENT_TYPE = $f52a8b88269c0d84$var$canUseSymbol ? Symbol.for('react.element') : 0xeac7;
function $f52a8b88269c0d84$var$isReactElement(value) {
    return value.$$typeof === $f52a8b88269c0d84$var$REACT_ELEMENT_TYPE;
}
function $f52a8b88269c0d84$var$emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
}
function $f52a8b88269c0d84$var$cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? $f52a8b88269c0d84$var$deepmerge($f52a8b88269c0d84$var$emptyTarget(value), value, options) : value;
}
function $f52a8b88269c0d84$var$defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function(element) {
        return $f52a8b88269c0d84$var$cloneUnlessOtherwiseSpecified(element, options);
    });
}
function $f52a8b88269c0d84$var$mergeObject(target, source, options) {
    var destination = {};
    if (options.isMergeableObject(target)) Object.keys(target).forEach(function(key) {
        destination[key] = $f52a8b88269c0d84$var$cloneUnlessOtherwiseSpecified(target[key], options);
    });
    Object.keys(source).forEach(function(key) {
        if (!options.isMergeableObject(source[key]) || !target[key]) destination[key] = $f52a8b88269c0d84$var$cloneUnlessOtherwiseSpecified(source[key], options);
        else destination[key] = $f52a8b88269c0d84$var$deepmerge(target[key], source[key], options);
    });
    return destination;
}
function $f52a8b88269c0d84$var$deepmerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || $f52a8b88269c0d84$var$defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || $f52a8b88269c0d84$var$isMergeableObject;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) return $f52a8b88269c0d84$var$cloneUnlessOtherwiseSpecified(source, options);
    else if (sourceIsArray) return options.arrayMerge(target, source, options);
    else return $f52a8b88269c0d84$var$mergeObject(target, source, options);
}
$f52a8b88269c0d84$var$deepmerge.all = function deepmergeAll(array, options) {
    if (!Array.isArray(array)) throw new Error('first argument should be an array');
    return array.reduce(function(prev, next) {
        return $f52a8b88269c0d84$var$deepmerge(prev, next, options);
    }, {});
};
var $f52a8b88269c0d84$var$deepmerge_1 = $f52a8b88269c0d84$var$deepmerge;
var $f52a8b88269c0d84$export$2e2bcd8739ae039 = $f52a8b88269c0d84$var$deepmerge_1;

});

parcelRegister("336aN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $238670c1e2da118d$export$2e2bcd8739ae039; });

var $2cf7J = parcelRequire("2cf7J");

var $d18qD = parcelRequire("d18qD");

var $9XysK = parcelRequire("9XysK");
/** `Object#toString` result references. */ var $238670c1e2da118d$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $238670c1e2da118d$var$funcProto = Function.prototype, $238670c1e2da118d$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $238670c1e2da118d$var$funcToString = $238670c1e2da118d$var$funcProto.toString;
/** Used to check objects for own properties. */ var $238670c1e2da118d$var$hasOwnProperty = $238670c1e2da118d$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $238670c1e2da118d$var$objectCtorString = $238670c1e2da118d$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $238670c1e2da118d$var$isPlainObject(value) {
    if (!(0, $9XysK.default)(value) || (0, $2cf7J.default)(value) != $238670c1e2da118d$var$objectTag) return false;
    var proto = (0, $d18qD.default)(value);
    if (proto === null) return true;
    var Ctor = $238670c1e2da118d$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $238670c1e2da118d$var$funcToString.call(Ctor) == $238670c1e2da118d$var$objectCtorString;
}
var $238670c1e2da118d$export$2e2bcd8739ae039 = $238670c1e2da118d$var$isPlainObject;

});
parcelRegister("2cf7J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $19986f09efbc2ee5$export$2e2bcd8739ae039; });

var $hwtsf = parcelRequire("hwtsf");

var $95GlW = parcelRequire("95GlW");

var $gfHM9 = parcelRequire("gfHM9");
/** `Object#toString` result references. */ var $19986f09efbc2ee5$var$nullTag = '[object Null]', $19986f09efbc2ee5$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $19986f09efbc2ee5$var$symToStringTag = (0, $hwtsf.default) ? (0, $hwtsf.default).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $19986f09efbc2ee5$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $19986f09efbc2ee5$var$undefinedTag : $19986f09efbc2ee5$var$nullTag;
    return $19986f09efbc2ee5$var$symToStringTag && $19986f09efbc2ee5$var$symToStringTag in Object(value) ? (0, $95GlW.default)(value) : (0, $gfHM9.default)(value);
}
var $19986f09efbc2ee5$export$2e2bcd8739ae039 = $19986f09efbc2ee5$var$baseGetTag;

});
parcelRegister("hwtsf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cc1c45e16e5e82ba$export$2e2bcd8739ae039; });

var $cbL8G = parcelRequire("cbL8G");
/** Built-in value references. */ var $cc1c45e16e5e82ba$var$Symbol = (0, $cbL8G.default).Symbol;
var $cc1c45e16e5e82ba$export$2e2bcd8739ae039 = $cc1c45e16e5e82ba$var$Symbol;

});
parcelRegister("cbL8G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8dfb13f5a11de6c6$export$2e2bcd8739ae039; });

var $fJlIs = parcelRequire("fJlIs");
/** Detect free variable `self`. */ var $8dfb13f5a11de6c6$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $8dfb13f5a11de6c6$var$root = (0, $fJlIs.default) || $8dfb13f5a11de6c6$var$freeSelf || Function('return this')();
var $8dfb13f5a11de6c6$export$2e2bcd8739ae039 = $8dfb13f5a11de6c6$var$root;

});
parcelRegister("fJlIs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b73be75724971af0$export$2e2bcd8739ae039; });
/** Detect free variable `global` from Node.js. */ var $b73be75724971af0$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $b73be75724971af0$export$2e2bcd8739ae039 = $b73be75724971af0$var$freeGlobal;

});



parcelRegister("95GlW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $69e56f18a357fb9f$export$2e2bcd8739ae039; });

var $hwtsf = parcelRequire("hwtsf");
/** Used for built-in method references. */ var $69e56f18a357fb9f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $69e56f18a357fb9f$var$hasOwnProperty = $69e56f18a357fb9f$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $69e56f18a357fb9f$var$nativeObjectToString = $69e56f18a357fb9f$var$objectProto.toString;
/** Built-in value references. */ var $69e56f18a357fb9f$var$symToStringTag = (0, $hwtsf.default) ? (0, $hwtsf.default).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $69e56f18a357fb9f$var$getRawTag(value) {
    var isOwn = $69e56f18a357fb9f$var$hasOwnProperty.call(value, $69e56f18a357fb9f$var$symToStringTag), tag = value[$69e56f18a357fb9f$var$symToStringTag];
    try {
        value[$69e56f18a357fb9f$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $69e56f18a357fb9f$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$69e56f18a357fb9f$var$symToStringTag] = tag;
        else delete value[$69e56f18a357fb9f$var$symToStringTag];
    }
    return result;
}
var $69e56f18a357fb9f$export$2e2bcd8739ae039 = $69e56f18a357fb9f$var$getRawTag;

});

parcelRegister("gfHM9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd5000fc2b79f59c$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $bd5000fc2b79f59c$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $bd5000fc2b79f59c$var$nativeObjectToString = $bd5000fc2b79f59c$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $bd5000fc2b79f59c$var$objectToString(value) {
    return $bd5000fc2b79f59c$var$nativeObjectToString.call(value);
}
var $bd5000fc2b79f59c$export$2e2bcd8739ae039 = $bd5000fc2b79f59c$var$objectToString;

});


parcelRegister("d18qD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97a1e817f546ddc3$export$2e2bcd8739ae039; });

var $ayyI5 = parcelRequire("ayyI5");
/** Built-in value references. */ var $97a1e817f546ddc3$var$getPrototype = (0, $ayyI5.default)(Object.getPrototypeOf, Object);
var $97a1e817f546ddc3$export$2e2bcd8739ae039 = $97a1e817f546ddc3$var$getPrototype;

});
parcelRegister("ayyI5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7af8010f1828909b$export$2e2bcd8739ae039; });
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $7af8010f1828909b$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $7af8010f1828909b$export$2e2bcd8739ae039 = $7af8010f1828909b$var$overArg;

});


parcelRegister("9XysK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74045b551f728b99$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $74045b551f728b99$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
var $74045b551f728b99$export$2e2bcd8739ae039 = $74045b551f728b99$var$isObjectLike;

});


parcelRegister("jGWdr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e55f18fc038f72e8$export$2e2bcd8739ae039; });

var $5t0O7 = parcelRequire("5t0O7");
/** Used to compose bitmasks for cloning. */ var $e55f18fc038f72e8$var$CLONE_DEEP_FLAG = 1, $e55f18fc038f72e8$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $e55f18fc038f72e8$var$cloneDeep(value) {
    return (0, $5t0O7.default)(value, $e55f18fc038f72e8$var$CLONE_DEEP_FLAG | $e55f18fc038f72e8$var$CLONE_SYMBOLS_FLAG);
}
var $e55f18fc038f72e8$export$2e2bcd8739ae039 = $e55f18fc038f72e8$var$cloneDeep;

});
parcelRegister("5t0O7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3fb04983a3cdc23b$export$2e2bcd8739ae039; });

var $5dLfO = parcelRequire("5dLfO");

var $7KiuO = parcelRequire("7KiuO");

var $fOFG0 = parcelRequire("fOFG0");

var $dgPnQ = parcelRequire("dgPnQ");

var $fqUOE = parcelRequire("fqUOE");

var $jXF4S = parcelRequire("jXF4S");

var $7KNPo = parcelRequire("7KNPo");

var $XexYp = parcelRequire("XexYp");

var $8NC4G = parcelRequire("8NC4G");

var $eNbR6 = parcelRequire("eNbR6");

var $9atCI = parcelRequire("9atCI");

var $6JaTE = parcelRequire("6JaTE");

var $fGAmH = parcelRequire("fGAmH");

var $25BDK = parcelRequire("25BDK");

var $55JsH = parcelRequire("55JsH");

var $eA9yl = parcelRequire("eA9yl");

var $43Y3b = parcelRequire("43Y3b");

var $28u2G = parcelRequire("28u2G");

var $55CT4 = parcelRequire("55CT4");

var $eoSgZ = parcelRequire("eoSgZ");

var $31LnV = parcelRequire("31LnV");

var $efjUI = parcelRequire("efjUI");
/** Used to compose bitmasks for cloning. */ var $3fb04983a3cdc23b$var$CLONE_DEEP_FLAG = 1, $3fb04983a3cdc23b$var$CLONE_FLAT_FLAG = 2, $3fb04983a3cdc23b$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $3fb04983a3cdc23b$var$argsTag = '[object Arguments]', $3fb04983a3cdc23b$var$arrayTag = '[object Array]', $3fb04983a3cdc23b$var$boolTag = '[object Boolean]', $3fb04983a3cdc23b$var$dateTag = '[object Date]', $3fb04983a3cdc23b$var$errorTag = '[object Error]', $3fb04983a3cdc23b$var$funcTag = '[object Function]', $3fb04983a3cdc23b$var$genTag = '[object GeneratorFunction]', $3fb04983a3cdc23b$var$mapTag = '[object Map]', $3fb04983a3cdc23b$var$numberTag = '[object Number]', $3fb04983a3cdc23b$var$objectTag = '[object Object]', $3fb04983a3cdc23b$var$regexpTag = '[object RegExp]', $3fb04983a3cdc23b$var$setTag = '[object Set]', $3fb04983a3cdc23b$var$stringTag = '[object String]', $3fb04983a3cdc23b$var$symbolTag = '[object Symbol]', $3fb04983a3cdc23b$var$weakMapTag = '[object WeakMap]';
var $3fb04983a3cdc23b$var$arrayBufferTag = '[object ArrayBuffer]', $3fb04983a3cdc23b$var$dataViewTag = '[object DataView]', $3fb04983a3cdc23b$var$float32Tag = '[object Float32Array]', $3fb04983a3cdc23b$var$float64Tag = '[object Float64Array]', $3fb04983a3cdc23b$var$int8Tag = '[object Int8Array]', $3fb04983a3cdc23b$var$int16Tag = '[object Int16Array]', $3fb04983a3cdc23b$var$int32Tag = '[object Int32Array]', $3fb04983a3cdc23b$var$uint8Tag = '[object Uint8Array]', $3fb04983a3cdc23b$var$uint8ClampedTag = '[object Uint8ClampedArray]', $3fb04983a3cdc23b$var$uint16Tag = '[object Uint16Array]', $3fb04983a3cdc23b$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $3fb04983a3cdc23b$var$cloneableTags = {};
$3fb04983a3cdc23b$var$cloneableTags[$3fb04983a3cdc23b$var$argsTag] = $3fb04983a3cdc23b$var$cloneableTags[$3fb04983a3cdc23b$var$arrayTag] = $3fb04983a3cdc23b$var$cloneableTags[$3fb04983a3cdc23b$var$arrayBufferTag] = $3fb04983a3cdc23b$var$cloneableTags[$3fb04983a3cdc23b$var$dataViewTag] = $3fb04983a3cdc23b$var$cloneableTags[$3fb04983a3cdc23b$var$boolTag] = $3fb04983a3cdc23b$var$cloneableTags[$3fb04983a3cdc23b$var$dateTag] = $3fb04983a3cdc23b$var$cloneableTags[$3fb04983a3cdc23b$var$float32Tag] = $3fb04983a3cdc23b$var$cloneableTags[$3fb04983a3cdc23b$var$float64Tag] = $3fb04983a3cdc23b$var$cloneableTags[$3fb04983a3cdc23b$var$int8Tag] = $3fb04983a3cdc23b$var$cloneableTags[$3fb04983a3cdc23b$var$int16Tag] = $3fb04983a3cdc23b$var$cloneableTags[$3fb04983a3cdc23b$var$int32Tag] = $3fb04983a3cdc23b$var$cloneableTags[$3fb04983a3cdc23b$var$mapTag] = $3fb04983a3cdc23b$var$cloneableTags[$3fb04983a3cdc23b$var$numberTag] = $3fb04983a3cdc23b$var$cloneableTags[$3fb04983a3cdc23b$var$objectTag] = $3fb04983a3cdc23b$var$cloneableTags[$3fb04983a3cdc23b$var$regexpTag] = $3fb04983a3cdc23b$var$cloneableTags[$3fb04983a3cdc23b$var$setTag] = $3fb04983a3cdc23b$var$cloneableTags[$3fb04983a3cdc23b$var$stringTag] = $3fb04983a3cdc23b$var$cloneableTags[$3fb04983a3cdc23b$var$symbolTag] = $3fb04983a3cdc23b$var$cloneableTags[$3fb04983a3cdc23b$var$uint8Tag] = $3fb04983a3cdc23b$var$cloneableTags[$3fb04983a3cdc23b$var$uint8ClampedTag] = $3fb04983a3cdc23b$var$cloneableTags[$3fb04983a3cdc23b$var$uint16Tag] = $3fb04983a3cdc23b$var$cloneableTags[$3fb04983a3cdc23b$var$uint32Tag] = true;
$3fb04983a3cdc23b$var$cloneableTags[$3fb04983a3cdc23b$var$errorTag] = $3fb04983a3cdc23b$var$cloneableTags[$3fb04983a3cdc23b$var$funcTag] = $3fb04983a3cdc23b$var$cloneableTags[$3fb04983a3cdc23b$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $3fb04983a3cdc23b$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $3fb04983a3cdc23b$var$CLONE_DEEP_FLAG, isFlat = bitmask & $3fb04983a3cdc23b$var$CLONE_FLAT_FLAG, isFull = bitmask & $3fb04983a3cdc23b$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!(0, $55CT4.default)(value)) return value;
    var isArr = (0, $eA9yl.default)(value);
    if (isArr) {
        result = (0, $fGAmH.default)(value);
        if (!isDeep) return (0, $7KNPo.default)(value, result);
    } else {
        var tag = (0, $6JaTE.default)(value), isFunc = tag == $3fb04983a3cdc23b$var$funcTag || tag == $3fb04983a3cdc23b$var$genTag;
        if ((0, $43Y3b.default)(value)) return (0, $jXF4S.default)(value, isDeep);
        if (tag == $3fb04983a3cdc23b$var$objectTag || tag == $3fb04983a3cdc23b$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : (0, $55JsH.default)(value);
            if (!isDeep) return isFlat ? (0, $8NC4G.default)(value, (0, $fqUOE.default)(result, value)) : (0, $XexYp.default)(value, (0, $dgPnQ.default)(result, value));
        } else {
            if (!$3fb04983a3cdc23b$var$cloneableTags[tag]) return object ? value : {};
            result = (0, $25BDK.default)(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new (0, $5dLfO.default));
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ((0, $eoSgZ.default)(value)) value.forEach(function(subValue) {
        result.add($3fb04983a3cdc23b$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ((0, $28u2G.default)(value)) value.forEach(function(subValue, key) {
        result.set(key, $3fb04983a3cdc23b$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? (0, $9atCI.default) : (0, $eNbR6.default) : isFlat ? (0, $efjUI.default) : (0, $31LnV.default);
    var props = isArr ? undefined : keysFunc(value);
    (0, $7KiuO.default)(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        (0, $fOFG0.default)(result, key, $3fb04983a3cdc23b$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
var $3fb04983a3cdc23b$export$2e2bcd8739ae039 = $3fb04983a3cdc23b$var$baseClone;

});
parcelRegister("5dLfO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3cd2d24f98fbb036$export$2e2bcd8739ae039; });

var $dlf4P = parcelRequire("dlf4P");

var $kGKkA = parcelRequire("kGKkA");

var $23Mbg = parcelRequire("23Mbg");

var $i1fJz = parcelRequire("i1fJz");

var $gReuE = parcelRequire("gReuE");

var $6UH46 = parcelRequire("6UH46");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $3cd2d24f98fbb036$var$Stack(entries) {
    var data = this.__data__ = new (0, $dlf4P.default)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$3cd2d24f98fbb036$var$Stack.prototype.clear = (0, $kGKkA.default);
$3cd2d24f98fbb036$var$Stack.prototype['delete'] = (0, $23Mbg.default);
$3cd2d24f98fbb036$var$Stack.prototype.get = (0, $i1fJz.default);
$3cd2d24f98fbb036$var$Stack.prototype.has = (0, $gReuE.default);
$3cd2d24f98fbb036$var$Stack.prototype.set = (0, $6UH46.default);
var $3cd2d24f98fbb036$export$2e2bcd8739ae039 = $3cd2d24f98fbb036$var$Stack;

});
parcelRegister("dlf4P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b68ee780c997cac$export$2e2bcd8739ae039; });

var $8NGqa = parcelRequire("8NGqa");

var $9Dleu = parcelRequire("9Dleu");

var $cQgQJ = parcelRequire("cQgQJ");

var $iT8rO = parcelRequire("iT8rO");

var $gMJdO = parcelRequire("gMJdO");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $9b68ee780c997cac$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$9b68ee780c997cac$var$ListCache.prototype.clear = (0, $8NGqa.default);
$9b68ee780c997cac$var$ListCache.prototype['delete'] = (0, $9Dleu.default);
$9b68ee780c997cac$var$ListCache.prototype.get = (0, $cQgQJ.default);
$9b68ee780c997cac$var$ListCache.prototype.has = (0, $iT8rO.default);
$9b68ee780c997cac$var$ListCache.prototype.set = (0, $gMJdO.default);
var $9b68ee780c997cac$export$2e2bcd8739ae039 = $9b68ee780c997cac$var$ListCache;

});
parcelRegister("8NGqa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6683ce46208661b7$export$2e2bcd8739ae039; });
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $6683ce46208661b7$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $6683ce46208661b7$export$2e2bcd8739ae039 = $6683ce46208661b7$var$listCacheClear;

});

parcelRegister("9Dleu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $703839f14e9825b3$export$2e2bcd8739ae039; });

var $emTR9 = parcelRequire("emTR9");
/** Used for built-in method references. */ var $703839f14e9825b3$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $703839f14e9825b3$var$splice = $703839f14e9825b3$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $703839f14e9825b3$var$listCacheDelete(key) {
    var data = this.__data__, index = (0, $emTR9.default)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $703839f14e9825b3$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $703839f14e9825b3$export$2e2bcd8739ae039 = $703839f14e9825b3$var$listCacheDelete;

});
parcelRegister("emTR9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a75e72a7367a8fda$export$2e2bcd8739ae039; });

var $5TPq9 = parcelRequire("5TPq9");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $a75e72a7367a8fda$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, $5TPq9.default)(array[length][0], key)) return length;
    }
    return -1;
}
var $a75e72a7367a8fda$export$2e2bcd8739ae039 = $a75e72a7367a8fda$var$assocIndexOf;

});
parcelRegister("5TPq9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $44b9f9ea8066e509$export$2e2bcd8739ae039; });
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $44b9f9ea8066e509$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $44b9f9ea8066e509$export$2e2bcd8739ae039 = $44b9f9ea8066e509$var$eq;

});



parcelRegister("cQgQJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95976950a1bed355$export$2e2bcd8739ae039; });

var $emTR9 = parcelRequire("emTR9");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $95976950a1bed355$var$listCacheGet(key) {
    var data = this.__data__, index = (0, $emTR9.default)(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $95976950a1bed355$export$2e2bcd8739ae039 = $95976950a1bed355$var$listCacheGet;

});

parcelRegister("iT8rO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc03ea9648d19f85$export$2e2bcd8739ae039; });

var $emTR9 = parcelRequire("emTR9");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $dc03ea9648d19f85$var$listCacheHas(key) {
    return (0, $emTR9.default)(this.__data__, key) > -1;
}
var $dc03ea9648d19f85$export$2e2bcd8739ae039 = $dc03ea9648d19f85$var$listCacheHas;

});

parcelRegister("gMJdO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c3843523f18b7a46$export$2e2bcd8739ae039; });

var $emTR9 = parcelRequire("emTR9");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $c3843523f18b7a46$var$listCacheSet(key, value) {
    var data = this.__data__, index = (0, $emTR9.default)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $c3843523f18b7a46$export$2e2bcd8739ae039 = $c3843523f18b7a46$var$listCacheSet;

});


parcelRegister("kGKkA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f0fbab404ad9a4e6$export$2e2bcd8739ae039; });

var $dlf4P = parcelRequire("dlf4P");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $f0fbab404ad9a4e6$var$stackClear() {
    this.__data__ = new (0, $dlf4P.default);
    this.size = 0;
}
var $f0fbab404ad9a4e6$export$2e2bcd8739ae039 = $f0fbab404ad9a4e6$var$stackClear;

});

parcelRegister("23Mbg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $18013c45f6284200$export$2e2bcd8739ae039; });
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $18013c45f6284200$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
var $18013c45f6284200$export$2e2bcd8739ae039 = $18013c45f6284200$var$stackDelete;

});

parcelRegister("i1fJz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1e486694756753c$export$2e2bcd8739ae039; });
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $d1e486694756753c$var$stackGet(key) {
    return this.__data__.get(key);
}
var $d1e486694756753c$export$2e2bcd8739ae039 = $d1e486694756753c$var$stackGet;

});

parcelRegister("gReuE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c45cd6aa70f09604$export$2e2bcd8739ae039; });
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $c45cd6aa70f09604$var$stackHas(key) {
    return this.__data__.has(key);
}
var $c45cd6aa70f09604$export$2e2bcd8739ae039 = $c45cd6aa70f09604$var$stackHas;

});

parcelRegister("6UH46", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $508960e5f282e8fa$export$2e2bcd8739ae039; });

var $dlf4P = parcelRequire("dlf4P");

var $5Gj2X = parcelRequire("5Gj2X");

var $5Sw7u = parcelRequire("5Sw7u");
/** Used as the size to enable large array optimizations. */ var $508960e5f282e8fa$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $508960e5f282e8fa$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, $dlf4P.default)) {
        var pairs = data.__data__;
        if (!(0, $5Gj2X.default) || pairs.length < $508960e5f282e8fa$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, $5Sw7u.default)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
var $508960e5f282e8fa$export$2e2bcd8739ae039 = $508960e5f282e8fa$var$stackSet;

});
parcelRegister("5Gj2X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $422fa6479c5bd7ef$export$2e2bcd8739ae039; });

var $cnWT7 = parcelRequire("cnWT7");

var $cbL8G = parcelRequire("cbL8G");
/* Built-in method references that are verified to be native. */ var $422fa6479c5bd7ef$var$Map = (0, $cnWT7.default)((0, $cbL8G.default), 'Map');
var $422fa6479c5bd7ef$export$2e2bcd8739ae039 = $422fa6479c5bd7ef$var$Map;

});
parcelRegister("cnWT7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $90454fee56e3abff$export$2e2bcd8739ae039; });

var $6HHNz = parcelRequire("6HHNz");

var $e4At8 = parcelRequire("e4At8");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $90454fee56e3abff$var$getNative(object, key) {
    var value = (0, $e4At8.default)(object, key);
    return (0, $6HHNz.default)(value) ? value : undefined;
}
var $90454fee56e3abff$export$2e2bcd8739ae039 = $90454fee56e3abff$var$getNative;

});
parcelRegister("6HHNz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4e18bbb875da1870$export$2e2bcd8739ae039; });

var $65Nb9 = parcelRequire("65Nb9");

var $1UREy = parcelRequire("1UREy");

var $55CT4 = parcelRequire("55CT4");

var $ki9xX = parcelRequire("ki9xX");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $4e18bbb875da1870$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $4e18bbb875da1870$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $4e18bbb875da1870$var$funcProto = Function.prototype, $4e18bbb875da1870$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $4e18bbb875da1870$var$funcToString = $4e18bbb875da1870$var$funcProto.toString;
/** Used to check objects for own properties. */ var $4e18bbb875da1870$var$hasOwnProperty = $4e18bbb875da1870$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $4e18bbb875da1870$var$reIsNative = RegExp('^' + $4e18bbb875da1870$var$funcToString.call($4e18bbb875da1870$var$hasOwnProperty).replace($4e18bbb875da1870$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $4e18bbb875da1870$var$baseIsNative(value) {
    if (!(0, $55CT4.default)(value) || (0, $1UREy.default)(value)) return false;
    var pattern = (0, $65Nb9.default)(value) ? $4e18bbb875da1870$var$reIsNative : $4e18bbb875da1870$var$reIsHostCtor;
    return pattern.test((0, $ki9xX.default)(value));
}
var $4e18bbb875da1870$export$2e2bcd8739ae039 = $4e18bbb875da1870$var$baseIsNative;

});
parcelRegister("65Nb9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46f95b963f3247d9$export$2e2bcd8739ae039; });

var $2cf7J = parcelRequire("2cf7J");

var $55CT4 = parcelRequire("55CT4");
/** `Object#toString` result references. */ var $46f95b963f3247d9$var$asyncTag = '[object AsyncFunction]', $46f95b963f3247d9$var$funcTag = '[object Function]', $46f95b963f3247d9$var$genTag = '[object GeneratorFunction]', $46f95b963f3247d9$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $46f95b963f3247d9$var$isFunction(value) {
    if (!(0, $55CT4.default)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, $2cf7J.default)(value);
    return tag == $46f95b963f3247d9$var$funcTag || tag == $46f95b963f3247d9$var$genTag || tag == $46f95b963f3247d9$var$asyncTag || tag == $46f95b963f3247d9$var$proxyTag;
}
var $46f95b963f3247d9$export$2e2bcd8739ae039 = $46f95b963f3247d9$var$isFunction;

});
parcelRegister("55CT4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b4b9591942c6c05$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $3b4b9591942c6c05$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
var $3b4b9591942c6c05$export$2e2bcd8739ae039 = $3b4b9591942c6c05$var$isObject;

});


parcelRegister("1UREy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1654a3d1c253f392$export$2e2bcd8739ae039; });

var $gE3Lz = parcelRequire("gE3Lz");
/** Used to detect methods masquerading as native. */ var $1654a3d1c253f392$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, $gE3Lz.default) && (0, $gE3Lz.default).keys && (0, $gE3Lz.default).keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $1654a3d1c253f392$var$isMasked(func) {
    return !!$1654a3d1c253f392$var$maskSrcKey && $1654a3d1c253f392$var$maskSrcKey in func;
}
var $1654a3d1c253f392$export$2e2bcd8739ae039 = $1654a3d1c253f392$var$isMasked;

});
parcelRegister("gE3Lz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c1e34da8907984a5$export$2e2bcd8739ae039; });

var $cbL8G = parcelRequire("cbL8G");
/** Used to detect overreaching core-js shims. */ var $c1e34da8907984a5$var$coreJsData = (0, $cbL8G.default)['__core-js_shared__'];
var $c1e34da8907984a5$export$2e2bcd8739ae039 = $c1e34da8907984a5$var$coreJsData;

});


parcelRegister("ki9xX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec5ce4dc218ac235$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $ec5ce4dc218ac235$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $ec5ce4dc218ac235$var$funcToString = $ec5ce4dc218ac235$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $ec5ce4dc218ac235$var$toSource(func) {
    if (func != null) {
        try {
            return $ec5ce4dc218ac235$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
var $ec5ce4dc218ac235$export$2e2bcd8739ae039 = $ec5ce4dc218ac235$var$toSource;

});


parcelRegister("e4At8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3edba5b7bfad554$export$2e2bcd8739ae039; });
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $a3edba5b7bfad554$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
var $a3edba5b7bfad554$export$2e2bcd8739ae039 = $a3edba5b7bfad554$var$getValue;

});



parcelRegister("5Sw7u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $447ae933fe5b0e8b$export$2e2bcd8739ae039; });

var $koCjl = parcelRequire("koCjl");

var $krpQl = parcelRequire("krpQl");

var $9mwxA = parcelRequire("9mwxA");

var $66SSL = parcelRequire("66SSL");

var $gUJSA = parcelRequire("gUJSA");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $447ae933fe5b0e8b$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$447ae933fe5b0e8b$var$MapCache.prototype.clear = (0, $koCjl.default);
$447ae933fe5b0e8b$var$MapCache.prototype['delete'] = (0, $krpQl.default);
$447ae933fe5b0e8b$var$MapCache.prototype.get = (0, $9mwxA.default);
$447ae933fe5b0e8b$var$MapCache.prototype.has = (0, $66SSL.default);
$447ae933fe5b0e8b$var$MapCache.prototype.set = (0, $gUJSA.default);
var $447ae933fe5b0e8b$export$2e2bcd8739ae039 = $447ae933fe5b0e8b$var$MapCache;

});
parcelRegister("koCjl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed93c44e36f89c1f$export$2e2bcd8739ae039; });

var $8M2bs = parcelRequire("8M2bs");

var $dlf4P = parcelRequire("dlf4P");

var $5Gj2X = parcelRequire("5Gj2X");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $ed93c44e36f89c1f$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new (0, $8M2bs.default),
        'map': new ((0, $5Gj2X.default) || (0, $dlf4P.default)),
        'string': new (0, $8M2bs.default)
    };
}
var $ed93c44e36f89c1f$export$2e2bcd8739ae039 = $ed93c44e36f89c1f$var$mapCacheClear;

});
parcelRegister("8M2bs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $66348011ac2a110f$export$2e2bcd8739ae039; });

var $2aDSK = parcelRequire("2aDSK");

var $1VmKI = parcelRequire("1VmKI");

var $iT1ig = parcelRequire("iT1ig");

var $7gcvJ = parcelRequire("7gcvJ");

var $cF59f = parcelRequire("cF59f");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $66348011ac2a110f$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$66348011ac2a110f$var$Hash.prototype.clear = (0, $2aDSK.default);
$66348011ac2a110f$var$Hash.prototype['delete'] = (0, $1VmKI.default);
$66348011ac2a110f$var$Hash.prototype.get = (0, $iT1ig.default);
$66348011ac2a110f$var$Hash.prototype.has = (0, $7gcvJ.default);
$66348011ac2a110f$var$Hash.prototype.set = (0, $cF59f.default);
var $66348011ac2a110f$export$2e2bcd8739ae039 = $66348011ac2a110f$var$Hash;

});
parcelRegister("2aDSK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $194b73a92e4efb80$export$2e2bcd8739ae039; });

var $3HGab = parcelRequire("3HGab");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $194b73a92e4efb80$var$hashClear() {
    this.__data__ = (0, $3HGab.default) ? (0, $3HGab.default)(null) : {};
    this.size = 0;
}
var $194b73a92e4efb80$export$2e2bcd8739ae039 = $194b73a92e4efb80$var$hashClear;

});
parcelRegister("3HGab", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b2617f9b9d8b9fb$export$2e2bcd8739ae039; });

var $cnWT7 = parcelRequire("cnWT7");
/* Built-in method references that are verified to be native. */ var $2b2617f9b9d8b9fb$var$nativeCreate = (0, $cnWT7.default)(Object, 'create');
var $2b2617f9b9d8b9fb$export$2e2bcd8739ae039 = $2b2617f9b9d8b9fb$var$nativeCreate;

});


parcelRegister("1VmKI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $166cc379acadc80f$export$2e2bcd8739ae039; });
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $166cc379acadc80f$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $166cc379acadc80f$export$2e2bcd8739ae039 = $166cc379acadc80f$var$hashDelete;

});

parcelRegister("iT1ig", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dbfe5df2e345caa4$export$2e2bcd8739ae039; });

var $3HGab = parcelRequire("3HGab");
/** Used to stand-in for `undefined` hash values. */ var $dbfe5df2e345caa4$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $dbfe5df2e345caa4$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $dbfe5df2e345caa4$var$hasOwnProperty = $dbfe5df2e345caa4$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $dbfe5df2e345caa4$var$hashGet(key) {
    var data = this.__data__;
    if (0, $3HGab.default) {
        var result = data[key];
        return result === $dbfe5df2e345caa4$var$HASH_UNDEFINED ? undefined : result;
    }
    return $dbfe5df2e345caa4$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
var $dbfe5df2e345caa4$export$2e2bcd8739ae039 = $dbfe5df2e345caa4$var$hashGet;

});

parcelRegister("7gcvJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5493bb62f2318e87$export$2e2bcd8739ae039; });

var $3HGab = parcelRequire("3HGab");
/** Used for built-in method references. */ var $5493bb62f2318e87$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $5493bb62f2318e87$var$hasOwnProperty = $5493bb62f2318e87$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $5493bb62f2318e87$var$hashHas(key) {
    var data = this.__data__;
    return (0, $3HGab.default) ? data[key] !== undefined : $5493bb62f2318e87$var$hasOwnProperty.call(data, key);
}
var $5493bb62f2318e87$export$2e2bcd8739ae039 = $5493bb62f2318e87$var$hashHas;

});

parcelRegister("cF59f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $937d4eaa3405f6d2$export$2e2bcd8739ae039; });

var $3HGab = parcelRequire("3HGab");
/** Used to stand-in for `undefined` hash values. */ var $937d4eaa3405f6d2$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $937d4eaa3405f6d2$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, $3HGab.default) && value === undefined ? $937d4eaa3405f6d2$var$HASH_UNDEFINED : value;
    return this;
}
var $937d4eaa3405f6d2$export$2e2bcd8739ae039 = $937d4eaa3405f6d2$var$hashSet;

});



parcelRegister("krpQl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee1a603118669651$export$2e2bcd8739ae039; });

var $iFhDd = parcelRequire("iFhDd");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $ee1a603118669651$var$mapCacheDelete(key) {
    var result = (0, $iFhDd.default)(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $ee1a603118669651$export$2e2bcd8739ae039 = $ee1a603118669651$var$mapCacheDelete;

});
parcelRegister("iFhDd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d969bb91c9e7ba5a$export$2e2bcd8739ae039; });

var $ddQcW = parcelRequire("ddQcW");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $d969bb91c9e7ba5a$var$getMapData(map, key) {
    var data = map.__data__;
    return (0, $ddQcW.default)(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
var $d969bb91c9e7ba5a$export$2e2bcd8739ae039 = $d969bb91c9e7ba5a$var$getMapData;

});
parcelRegister("ddQcW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9a04fc9d720d6b3c$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $9a04fc9d720d6b3c$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
var $9a04fc9d720d6b3c$export$2e2bcd8739ae039 = $9a04fc9d720d6b3c$var$isKeyable;

});



parcelRegister("9mwxA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d0f690b48d61772$export$2e2bcd8739ae039; });

var $iFhDd = parcelRequire("iFhDd");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $6d0f690b48d61772$var$mapCacheGet(key) {
    return (0, $iFhDd.default)(this, key).get(key);
}
var $6d0f690b48d61772$export$2e2bcd8739ae039 = $6d0f690b48d61772$var$mapCacheGet;

});

parcelRegister("66SSL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $472de01be4d69782$export$2e2bcd8739ae039; });

var $iFhDd = parcelRequire("iFhDd");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $472de01be4d69782$var$mapCacheHas(key) {
    return (0, $iFhDd.default)(this, key).has(key);
}
var $472de01be4d69782$export$2e2bcd8739ae039 = $472de01be4d69782$var$mapCacheHas;

});

parcelRegister("gUJSA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c50576ffe7171011$export$2e2bcd8739ae039; });

var $iFhDd = parcelRequire("iFhDd");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $c50576ffe7171011$var$mapCacheSet(key, value) {
    var data = (0, $iFhDd.default)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $c50576ffe7171011$export$2e2bcd8739ae039 = $c50576ffe7171011$var$mapCacheSet;

});




parcelRegister("7KiuO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a3b2d300bbe54a8$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $5a3b2d300bbe54a8$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
var $5a3b2d300bbe54a8$export$2e2bcd8739ae039 = $5a3b2d300bbe54a8$var$arrayEach;

});

parcelRegister("fOFG0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b83bda9bf2fedf6b$export$2e2bcd8739ae039; });

var $8Xlz0 = parcelRequire("8Xlz0");

var $5TPq9 = parcelRequire("5TPq9");
/** Used for built-in method references. */ var $b83bda9bf2fedf6b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b83bda9bf2fedf6b$var$hasOwnProperty = $b83bda9bf2fedf6b$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $b83bda9bf2fedf6b$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($b83bda9bf2fedf6b$var$hasOwnProperty.call(object, key) && (0, $5TPq9.default)(objValue, value)) || value === undefined && !(key in object)) (0, $8Xlz0.default)(object, key, value);
}
var $b83bda9bf2fedf6b$export$2e2bcd8739ae039 = $b83bda9bf2fedf6b$var$assignValue;

});
parcelRegister("8Xlz0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68548f83f5ce07e3$export$2e2bcd8739ae039; });

var $2cPDw = parcelRequire("2cPDw");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $68548f83f5ce07e3$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && (0, $2cPDw.default)) (0, $2cPDw.default)(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
var $68548f83f5ce07e3$export$2e2bcd8739ae039 = $68548f83f5ce07e3$var$baseAssignValue;

});
parcelRegister("2cPDw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $19b4c1adbc8e7dc1$export$2e2bcd8739ae039; });

var $cnWT7 = parcelRequire("cnWT7");
var $19b4c1adbc8e7dc1$var$defineProperty = function() {
    try {
        var func = (0, $cnWT7.default)(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
var $19b4c1adbc8e7dc1$export$2e2bcd8739ae039 = $19b4c1adbc8e7dc1$var$defineProperty;

});



parcelRegister("dgPnQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9a94a0b89421f374$export$2e2bcd8739ae039; });

var $4Ekk0 = parcelRequire("4Ekk0");

var $31LnV = parcelRequire("31LnV");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $9a94a0b89421f374$var$baseAssign(object, source) {
    return object && (0, $4Ekk0.default)(source, (0, $31LnV.default)(source), object);
}
var $9a94a0b89421f374$export$2e2bcd8739ae039 = $9a94a0b89421f374$var$baseAssign;

});
parcelRegister("4Ekk0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $362aa94f6d2f95d1$export$2e2bcd8739ae039; });

var $fOFG0 = parcelRequire("fOFG0");

var $8Xlz0 = parcelRequire("8Xlz0");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $362aa94f6d2f95d1$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) (0, $8Xlz0.default)(object, key, newValue);
        else (0, $fOFG0.default)(object, key, newValue);
    }
    return object;
}
var $362aa94f6d2f95d1$export$2e2bcd8739ae039 = $362aa94f6d2f95d1$var$copyObject;

});

parcelRegister("31LnV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $234638bc457b2507$export$2e2bcd8739ae039; });

var $9uyOq = parcelRequire("9uyOq");

var $arXl8 = parcelRequire("arXl8");

var $b9DUl = parcelRequire("b9DUl");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $234638bc457b2507$var$keys(object) {
    return (0, $b9DUl.default)(object) ? (0, $9uyOq.default)(object) : (0, $arXl8.default)(object);
}
var $234638bc457b2507$export$2e2bcd8739ae039 = $234638bc457b2507$var$keys;

});
parcelRegister("9uyOq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e91eb6956218860$export$2e2bcd8739ae039; });

var $eASwy = parcelRequire("eASwy");

var $774DM = parcelRequire("774DM");

var $eA9yl = parcelRequire("eA9yl");

var $43Y3b = parcelRequire("43Y3b");

var $7Jqv7 = parcelRequire("7Jqv7");

var $dK8Wz = parcelRequire("dK8Wz");
/** Used for built-in method references. */ var $6e91eb6956218860$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $6e91eb6956218860$var$hasOwnProperty = $6e91eb6956218860$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $6e91eb6956218860$var$arrayLikeKeys(value, inherited) {
    var isArr = (0, $eA9yl.default)(value), isArg = !isArr && (0, $774DM.default)(value), isBuff = !isArr && !isArg && (0, $43Y3b.default)(value), isType = !isArr && !isArg && !isBuff && (0, $dK8Wz.default)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, $eASwy.default)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $6e91eb6956218860$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    (0, $7Jqv7.default)(key, length)))) result.push(key);
    return result;
}
var $6e91eb6956218860$export$2e2bcd8739ae039 = $6e91eb6956218860$var$arrayLikeKeys;

});
parcelRegister("eASwy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a9feb8d74cb60a7d$export$2e2bcd8739ae039; });
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $a9feb8d74cb60a7d$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
var $a9feb8d74cb60a7d$export$2e2bcd8739ae039 = $a9feb8d74cb60a7d$var$baseTimes;

});

parcelRegister("774DM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52dcc9623304e2de$export$2e2bcd8739ae039; });

var $8Zkg4 = parcelRequire("8Zkg4");

var $9XysK = parcelRequire("9XysK");
/** Used for built-in method references. */ var $52dcc9623304e2de$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $52dcc9623304e2de$var$hasOwnProperty = $52dcc9623304e2de$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $52dcc9623304e2de$var$propertyIsEnumerable = $52dcc9623304e2de$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $52dcc9623304e2de$var$isArguments = (0, $8Zkg4.default)(function() {
    return arguments;
}()) ? (0, $8Zkg4.default) : function(value) {
    return (0, $9XysK.default)(value) && $52dcc9623304e2de$var$hasOwnProperty.call(value, 'callee') && !$52dcc9623304e2de$var$propertyIsEnumerable.call(value, 'callee');
};
var $52dcc9623304e2de$export$2e2bcd8739ae039 = $52dcc9623304e2de$var$isArguments;

});
parcelRegister("8Zkg4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68b3bc174c908ae4$export$2e2bcd8739ae039; });

var $2cf7J = parcelRequire("2cf7J");

var $9XysK = parcelRequire("9XysK");
/** `Object#toString` result references. */ var $68b3bc174c908ae4$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $68b3bc174c908ae4$var$baseIsArguments(value) {
    return (0, $9XysK.default)(value) && (0, $2cf7J.default)(value) == $68b3bc174c908ae4$var$argsTag;
}
var $68b3bc174c908ae4$export$2e2bcd8739ae039 = $68b3bc174c908ae4$var$baseIsArguments;

});


parcelRegister("eA9yl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a9dbd684194449d8$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $a9dbd684194449d8$var$isArray = Array.isArray;
var $a9dbd684194449d8$export$2e2bcd8739ae039 = $a9dbd684194449d8$var$isArray;

});

parcelRegister("43Y3b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f5605ffe485255e$export$2e2bcd8739ae039; });

var $cbL8G = parcelRequire("cbL8G");

var $joVH4 = parcelRequire("joVH4");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $cbL8G.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, $joVH4.default);
var $2f5605ffe485255e$export$2e2bcd8739ae039 = isBuffer;

});
parcelRegister("joVH4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e1fd02fbb24c22b3$export$2e2bcd8739ae039; });
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $e1fd02fbb24c22b3$var$stubFalse() {
    return false;
}
var $e1fd02fbb24c22b3$export$2e2bcd8739ae039 = $e1fd02fbb24c22b3$var$stubFalse;

});


parcelRegister("7Jqv7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a114ae0fb35c4fe$export$2e2bcd8739ae039; });
/** Used as references for various `Number` constants. */ var $5a114ae0fb35c4fe$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $5a114ae0fb35c4fe$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $5a114ae0fb35c4fe$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $5a114ae0fb35c4fe$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $5a114ae0fb35c4fe$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var $5a114ae0fb35c4fe$export$2e2bcd8739ae039 = $5a114ae0fb35c4fe$var$isIndex;

});

parcelRegister("dK8Wz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a016824551b15f1b$export$2e2bcd8739ae039; });

var $KChjy = parcelRequire("KChjy");

var $aN9tr = parcelRequire("aN9tr");

var $lDlcQ = parcelRequire("lDlcQ");
/* Node.js helper references. */ var $a016824551b15f1b$var$nodeIsTypedArray = (0, $lDlcQ.default) && (0, $lDlcQ.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $a016824551b15f1b$var$isTypedArray = $a016824551b15f1b$var$nodeIsTypedArray ? (0, $aN9tr.default)($a016824551b15f1b$var$nodeIsTypedArray) : (0, $KChjy.default);
var $a016824551b15f1b$export$2e2bcd8739ae039 = $a016824551b15f1b$var$isTypedArray;

});
parcelRegister("KChjy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08c1fd421f878292$export$2e2bcd8739ae039; });

var $2cf7J = parcelRequire("2cf7J");

var $XPYOH = parcelRequire("XPYOH");

var $9XysK = parcelRequire("9XysK");
/** `Object#toString` result references. */ var $08c1fd421f878292$var$argsTag = '[object Arguments]', $08c1fd421f878292$var$arrayTag = '[object Array]', $08c1fd421f878292$var$boolTag = '[object Boolean]', $08c1fd421f878292$var$dateTag = '[object Date]', $08c1fd421f878292$var$errorTag = '[object Error]', $08c1fd421f878292$var$funcTag = '[object Function]', $08c1fd421f878292$var$mapTag = '[object Map]', $08c1fd421f878292$var$numberTag = '[object Number]', $08c1fd421f878292$var$objectTag = '[object Object]', $08c1fd421f878292$var$regexpTag = '[object RegExp]', $08c1fd421f878292$var$setTag = '[object Set]', $08c1fd421f878292$var$stringTag = '[object String]', $08c1fd421f878292$var$weakMapTag = '[object WeakMap]';
var $08c1fd421f878292$var$arrayBufferTag = '[object ArrayBuffer]', $08c1fd421f878292$var$dataViewTag = '[object DataView]', $08c1fd421f878292$var$float32Tag = '[object Float32Array]', $08c1fd421f878292$var$float64Tag = '[object Float64Array]', $08c1fd421f878292$var$int8Tag = '[object Int8Array]', $08c1fd421f878292$var$int16Tag = '[object Int16Array]', $08c1fd421f878292$var$int32Tag = '[object Int32Array]', $08c1fd421f878292$var$uint8Tag = '[object Uint8Array]', $08c1fd421f878292$var$uint8ClampedTag = '[object Uint8ClampedArray]', $08c1fd421f878292$var$uint16Tag = '[object Uint16Array]', $08c1fd421f878292$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $08c1fd421f878292$var$typedArrayTags = {};
$08c1fd421f878292$var$typedArrayTags[$08c1fd421f878292$var$float32Tag] = $08c1fd421f878292$var$typedArrayTags[$08c1fd421f878292$var$float64Tag] = $08c1fd421f878292$var$typedArrayTags[$08c1fd421f878292$var$int8Tag] = $08c1fd421f878292$var$typedArrayTags[$08c1fd421f878292$var$int16Tag] = $08c1fd421f878292$var$typedArrayTags[$08c1fd421f878292$var$int32Tag] = $08c1fd421f878292$var$typedArrayTags[$08c1fd421f878292$var$uint8Tag] = $08c1fd421f878292$var$typedArrayTags[$08c1fd421f878292$var$uint8ClampedTag] = $08c1fd421f878292$var$typedArrayTags[$08c1fd421f878292$var$uint16Tag] = $08c1fd421f878292$var$typedArrayTags[$08c1fd421f878292$var$uint32Tag] = true;
$08c1fd421f878292$var$typedArrayTags[$08c1fd421f878292$var$argsTag] = $08c1fd421f878292$var$typedArrayTags[$08c1fd421f878292$var$arrayTag] = $08c1fd421f878292$var$typedArrayTags[$08c1fd421f878292$var$arrayBufferTag] = $08c1fd421f878292$var$typedArrayTags[$08c1fd421f878292$var$boolTag] = $08c1fd421f878292$var$typedArrayTags[$08c1fd421f878292$var$dataViewTag] = $08c1fd421f878292$var$typedArrayTags[$08c1fd421f878292$var$dateTag] = $08c1fd421f878292$var$typedArrayTags[$08c1fd421f878292$var$errorTag] = $08c1fd421f878292$var$typedArrayTags[$08c1fd421f878292$var$funcTag] = $08c1fd421f878292$var$typedArrayTags[$08c1fd421f878292$var$mapTag] = $08c1fd421f878292$var$typedArrayTags[$08c1fd421f878292$var$numberTag] = $08c1fd421f878292$var$typedArrayTags[$08c1fd421f878292$var$objectTag] = $08c1fd421f878292$var$typedArrayTags[$08c1fd421f878292$var$regexpTag] = $08c1fd421f878292$var$typedArrayTags[$08c1fd421f878292$var$setTag] = $08c1fd421f878292$var$typedArrayTags[$08c1fd421f878292$var$stringTag] = $08c1fd421f878292$var$typedArrayTags[$08c1fd421f878292$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $08c1fd421f878292$var$baseIsTypedArray(value) {
    return (0, $9XysK.default)(value) && (0, $XPYOH.default)(value.length) && !!$08c1fd421f878292$var$typedArrayTags[(0, $2cf7J.default)(value)];
}
var $08c1fd421f878292$export$2e2bcd8739ae039 = $08c1fd421f878292$var$baseIsTypedArray;

});
parcelRegister("XPYOH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0b3dd4ee5450b764$export$2e2bcd8739ae039; });
/** Used as references for various `Number` constants. */ var $0b3dd4ee5450b764$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $0b3dd4ee5450b764$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $0b3dd4ee5450b764$var$MAX_SAFE_INTEGER;
}
var $0b3dd4ee5450b764$export$2e2bcd8739ae039 = $0b3dd4ee5450b764$var$isLength;

});


parcelRegister("aN9tr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7db5d44ae8b6fe1a$export$2e2bcd8739ae039; });
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $7db5d44ae8b6fe1a$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
var $7db5d44ae8b6fe1a$export$2e2bcd8739ae039 = $7db5d44ae8b6fe1a$var$baseUnary;

});

parcelRegister("lDlcQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fbfdb09b26f3ae19$export$2e2bcd8739ae039; });

var $fJlIs = parcelRequire("fJlIs");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, $fJlIs.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
var $fbfdb09b26f3ae19$export$2e2bcd8739ae039 = nodeUtil;

});



parcelRegister("arXl8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $79ba74a54de5c743$export$2e2bcd8739ae039; });

var $jcgNC = parcelRequire("jcgNC");

var $9CgKH = parcelRequire("9CgKH");
/** Used for built-in method references. */ var $79ba74a54de5c743$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $79ba74a54de5c743$var$hasOwnProperty = $79ba74a54de5c743$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $79ba74a54de5c743$var$baseKeys(object) {
    if (!(0, $jcgNC.default)(object)) return (0, $9CgKH.default)(object);
    var result = [];
    for(var key in Object(object))if ($79ba74a54de5c743$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
var $79ba74a54de5c743$export$2e2bcd8739ae039 = $79ba74a54de5c743$var$baseKeys;

});
parcelRegister("jcgNC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $df9c2b4f37188c4d$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $df9c2b4f37188c4d$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $df9c2b4f37188c4d$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $df9c2b4f37188c4d$var$objectProto;
    return value === proto;
}
var $df9c2b4f37188c4d$export$2e2bcd8739ae039 = $df9c2b4f37188c4d$var$isPrototype;

});

parcelRegister("9CgKH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7004a84f56b52e2e$export$2e2bcd8739ae039; });

var $ayyI5 = parcelRequire("ayyI5");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $7004a84f56b52e2e$var$nativeKeys = (0, $ayyI5.default)(Object.keys, Object);
var $7004a84f56b52e2e$export$2e2bcd8739ae039 = $7004a84f56b52e2e$var$nativeKeys;

});


parcelRegister("b9DUl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81ef7dd384cb8657$export$2e2bcd8739ae039; });

var $65Nb9 = parcelRequire("65Nb9");

var $XPYOH = parcelRequire("XPYOH");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $81ef7dd384cb8657$var$isArrayLike(value) {
    return value != null && (0, $XPYOH.default)(value.length) && !(0, $65Nb9.default)(value);
}
var $81ef7dd384cb8657$export$2e2bcd8739ae039 = $81ef7dd384cb8657$var$isArrayLike;

});



parcelRegister("fqUOE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b3c55b33a4ec0faa$export$2e2bcd8739ae039; });

var $4Ekk0 = parcelRequire("4Ekk0");

var $efjUI = parcelRequire("efjUI");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $b3c55b33a4ec0faa$var$baseAssignIn(object, source) {
    return object && (0, $4Ekk0.default)(source, (0, $efjUI.default)(source), object);
}
var $b3c55b33a4ec0faa$export$2e2bcd8739ae039 = $b3c55b33a4ec0faa$var$baseAssignIn;

});
parcelRegister("efjUI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a5f1e9df7c323e49$export$2e2bcd8739ae039; });

var $9uyOq = parcelRequire("9uyOq");

var $aUFmV = parcelRequire("aUFmV");

var $b9DUl = parcelRequire("b9DUl");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $a5f1e9df7c323e49$var$keysIn(object) {
    return (0, $b9DUl.default)(object) ? (0, $9uyOq.default)(object, true) : (0, $aUFmV.default)(object);
}
var $a5f1e9df7c323e49$export$2e2bcd8739ae039 = $a5f1e9df7c323e49$var$keysIn;

});
parcelRegister("aUFmV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7f1f3956e8977175$export$2e2bcd8739ae039; });

var $55CT4 = parcelRequire("55CT4");

var $jcgNC = parcelRequire("jcgNC");

var $aEMAF = parcelRequire("aEMAF");
/** Used for built-in method references. */ var $7f1f3956e8977175$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7f1f3956e8977175$var$hasOwnProperty = $7f1f3956e8977175$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $7f1f3956e8977175$var$baseKeysIn(object) {
    if (!(0, $55CT4.default)(object)) return (0, $aEMAF.default)(object);
    var isProto = (0, $jcgNC.default)(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$7f1f3956e8977175$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
var $7f1f3956e8977175$export$2e2bcd8739ae039 = $7f1f3956e8977175$var$baseKeysIn;

});
parcelRegister("aEMAF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c2354e0bd7393d1$export$2e2bcd8739ae039; });
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $7c2354e0bd7393d1$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
var $7c2354e0bd7393d1$export$2e2bcd8739ae039 = $7c2354e0bd7393d1$var$nativeKeysIn;

});




parcelRegister("jXF4S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e8836429fc7198d7$export$2e2bcd8739ae039; });

var $cbL8G = parcelRequire("cbL8G");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $cbL8G.default).Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
var $e8836429fc7198d7$export$2e2bcd8739ae039 = cloneBuffer;

});

parcelRegister("7KNPo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a537b0c8857c242$export$2e2bcd8739ae039; });
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $5a537b0c8857c242$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
var $5a537b0c8857c242$export$2e2bcd8739ae039 = $5a537b0c8857c242$var$copyArray;

});

parcelRegister("XexYp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0b20cb8671f49c29$export$2e2bcd8739ae039; });

var $4Ekk0 = parcelRequire("4Ekk0");

var $1QurG = parcelRequire("1QurG");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $0b20cb8671f49c29$var$copySymbols(source, object) {
    return (0, $4Ekk0.default)(source, (0, $1QurG.default)(source), object);
}
var $0b20cb8671f49c29$export$2e2bcd8739ae039 = $0b20cb8671f49c29$var$copySymbols;

});
parcelRegister("1QurG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1582439f74c1dc77$export$2e2bcd8739ae039; });

var $gehIv = parcelRequire("gehIv");

var $ag1N4 = parcelRequire("ag1N4");
/** Used for built-in method references. */ var $1582439f74c1dc77$var$objectProto = Object.prototype;
/** Built-in value references. */ var $1582439f74c1dc77$var$propertyIsEnumerable = $1582439f74c1dc77$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $1582439f74c1dc77$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $1582439f74c1dc77$var$getSymbols = !$1582439f74c1dc77$var$nativeGetSymbols ? (0, $ag1N4.default) : function(object) {
    if (object == null) return [];
    object = Object(object);
    return (0, $gehIv.default)($1582439f74c1dc77$var$nativeGetSymbols(object), function(symbol) {
        return $1582439f74c1dc77$var$propertyIsEnumerable.call(object, symbol);
    });
};
var $1582439f74c1dc77$export$2e2bcd8739ae039 = $1582439f74c1dc77$var$getSymbols;

});
parcelRegister("gehIv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd0bb256a5a104cb$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $bd0bb256a5a104cb$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
var $bd0bb256a5a104cb$export$2e2bcd8739ae039 = $bd0bb256a5a104cb$var$arrayFilter;

});

parcelRegister("ag1N4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $777cc98a7333c527$export$2e2bcd8739ae039; });
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $777cc98a7333c527$var$stubArray() {
    return [];
}
var $777cc98a7333c527$export$2e2bcd8739ae039 = $777cc98a7333c527$var$stubArray;

});



parcelRegister("8NC4G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $66806f1f76f1e804$export$2e2bcd8739ae039; });

var $4Ekk0 = parcelRequire("4Ekk0");

var $j2qXE = parcelRequire("j2qXE");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $66806f1f76f1e804$var$copySymbolsIn(source, object) {
    return (0, $4Ekk0.default)(source, (0, $j2qXE.default)(source), object);
}
var $66806f1f76f1e804$export$2e2bcd8739ae039 = $66806f1f76f1e804$var$copySymbolsIn;

});
parcelRegister("j2qXE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ddc31e2885df0493$export$2e2bcd8739ae039; });

var $b68hM = parcelRequire("b68hM");

var $d18qD = parcelRequire("d18qD");

var $1QurG = parcelRequire("1QurG");

var $ag1N4 = parcelRequire("ag1N4");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $ddc31e2885df0493$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $ddc31e2885df0493$var$getSymbolsIn = !$ddc31e2885df0493$var$nativeGetSymbols ? (0, $ag1N4.default) : function(object) {
    var result = [];
    while(object){
        (0, $b68hM.default)(result, (0, $1QurG.default)(object));
        object = (0, $d18qD.default)(object);
    }
    return result;
};
var $ddc31e2885df0493$export$2e2bcd8739ae039 = $ddc31e2885df0493$var$getSymbolsIn;

});
parcelRegister("b68hM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8146aea68b56bf82$export$2e2bcd8739ae039; });
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $8146aea68b56bf82$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
var $8146aea68b56bf82$export$2e2bcd8739ae039 = $8146aea68b56bf82$var$arrayPush;

});



parcelRegister("eNbR6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac4ed68d4381894e$export$2e2bcd8739ae039; });

var $aM6gW = parcelRequire("aM6gW");

var $1QurG = parcelRequire("1QurG");

var $31LnV = parcelRequire("31LnV");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $ac4ed68d4381894e$var$getAllKeys(object) {
    return (0, $aM6gW.default)(object, (0, $31LnV.default), (0, $1QurG.default));
}
var $ac4ed68d4381894e$export$2e2bcd8739ae039 = $ac4ed68d4381894e$var$getAllKeys;

});
parcelRegister("aM6gW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d8340a146618e30$export$2e2bcd8739ae039; });

var $b68hM = parcelRequire("b68hM");

var $eA9yl = parcelRequire("eA9yl");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $7d8340a146618e30$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return (0, $eA9yl.default)(object) ? result : (0, $b68hM.default)(result, symbolsFunc(object));
}
var $7d8340a146618e30$export$2e2bcd8739ae039 = $7d8340a146618e30$var$baseGetAllKeys;

});


parcelRegister("9atCI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6acc06d55696b3a6$export$2e2bcd8739ae039; });

var $aM6gW = parcelRequire("aM6gW");

var $j2qXE = parcelRequire("j2qXE");

var $efjUI = parcelRequire("efjUI");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $6acc06d55696b3a6$var$getAllKeysIn(object) {
    return (0, $aM6gW.default)(object, (0, $efjUI.default), (0, $j2qXE.default));
}
var $6acc06d55696b3a6$export$2e2bcd8739ae039 = $6acc06d55696b3a6$var$getAllKeysIn;

});

parcelRegister("6JaTE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4e5f65e85b625cf1$export$2e2bcd8739ae039; });

var $dZqjW = parcelRequire("dZqjW");

var $5Gj2X = parcelRequire("5Gj2X");

var $gY81o = parcelRequire("gY81o");

var $jJJkK = parcelRequire("jJJkK");

var $hmIjW = parcelRequire("hmIjW");

var $2cf7J = parcelRequire("2cf7J");

var $ki9xX = parcelRequire("ki9xX");
/** `Object#toString` result references. */ var $4e5f65e85b625cf1$var$mapTag = '[object Map]', $4e5f65e85b625cf1$var$objectTag = '[object Object]', $4e5f65e85b625cf1$var$promiseTag = '[object Promise]', $4e5f65e85b625cf1$var$setTag = '[object Set]', $4e5f65e85b625cf1$var$weakMapTag = '[object WeakMap]';
var $4e5f65e85b625cf1$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $4e5f65e85b625cf1$var$dataViewCtorString = (0, $ki9xX.default)((0, $dZqjW.default)), $4e5f65e85b625cf1$var$mapCtorString = (0, $ki9xX.default)((0, $5Gj2X.default)), $4e5f65e85b625cf1$var$promiseCtorString = (0, $ki9xX.default)((0, $gY81o.default)), $4e5f65e85b625cf1$var$setCtorString = (0, $ki9xX.default)((0, $jJJkK.default)), $4e5f65e85b625cf1$var$weakMapCtorString = (0, $ki9xX.default)((0, $hmIjW.default));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $4e5f65e85b625cf1$var$getTag = (0, $2cf7J.default);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, $dZqjW.default) && $4e5f65e85b625cf1$var$getTag(new (0, $dZqjW.default)(new ArrayBuffer(1))) != $4e5f65e85b625cf1$var$dataViewTag || (0, $5Gj2X.default) && $4e5f65e85b625cf1$var$getTag(new (0, $5Gj2X.default)) != $4e5f65e85b625cf1$var$mapTag || (0, $gY81o.default) && $4e5f65e85b625cf1$var$getTag((0, $gY81o.default).resolve()) != $4e5f65e85b625cf1$var$promiseTag || (0, $jJJkK.default) && $4e5f65e85b625cf1$var$getTag(new (0, $jJJkK.default)) != $4e5f65e85b625cf1$var$setTag || (0, $hmIjW.default) && $4e5f65e85b625cf1$var$getTag(new (0, $hmIjW.default)) != $4e5f65e85b625cf1$var$weakMapTag) $4e5f65e85b625cf1$var$getTag = function(value) {
    var result = (0, $2cf7J.default)(value), Ctor = result == $4e5f65e85b625cf1$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, $ki9xX.default)(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $4e5f65e85b625cf1$var$dataViewCtorString:
            return $4e5f65e85b625cf1$var$dataViewTag;
        case $4e5f65e85b625cf1$var$mapCtorString:
            return $4e5f65e85b625cf1$var$mapTag;
        case $4e5f65e85b625cf1$var$promiseCtorString:
            return $4e5f65e85b625cf1$var$promiseTag;
        case $4e5f65e85b625cf1$var$setCtorString:
            return $4e5f65e85b625cf1$var$setTag;
        case $4e5f65e85b625cf1$var$weakMapCtorString:
            return $4e5f65e85b625cf1$var$weakMapTag;
    }
    return result;
};
var $4e5f65e85b625cf1$export$2e2bcd8739ae039 = $4e5f65e85b625cf1$var$getTag;

});
parcelRegister("dZqjW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2f5639d4540d038$export$2e2bcd8739ae039; });

var $cnWT7 = parcelRequire("cnWT7");

var $cbL8G = parcelRequire("cbL8G");
/* Built-in method references that are verified to be native. */ var $a2f5639d4540d038$var$DataView = (0, $cnWT7.default)((0, $cbL8G.default), 'DataView');
var $a2f5639d4540d038$export$2e2bcd8739ae039 = $a2f5639d4540d038$var$DataView;

});

parcelRegister("gY81o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c5a878d0dd8cec2f$export$2e2bcd8739ae039; });

var $cnWT7 = parcelRequire("cnWT7");

var $cbL8G = parcelRequire("cbL8G");
/* Built-in method references that are verified to be native. */ var $c5a878d0dd8cec2f$var$Promise = (0, $cnWT7.default)((0, $cbL8G.default), 'Promise');
var $c5a878d0dd8cec2f$export$2e2bcd8739ae039 = $c5a878d0dd8cec2f$var$Promise;

});

parcelRegister("jJJkK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e5e5629a593ab776$export$2e2bcd8739ae039; });

var $cnWT7 = parcelRequire("cnWT7");

var $cbL8G = parcelRequire("cbL8G");
/* Built-in method references that are verified to be native. */ var $e5e5629a593ab776$var$Set = (0, $cnWT7.default)((0, $cbL8G.default), 'Set');
var $e5e5629a593ab776$export$2e2bcd8739ae039 = $e5e5629a593ab776$var$Set;

});

parcelRegister("hmIjW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca46dedfd4ba46c8$export$2e2bcd8739ae039; });

var $cnWT7 = parcelRequire("cnWT7");

var $cbL8G = parcelRequire("cbL8G");
/* Built-in method references that are verified to be native. */ var $ca46dedfd4ba46c8$var$WeakMap = (0, $cnWT7.default)((0, $cbL8G.default), 'WeakMap');
var $ca46dedfd4ba46c8$export$2e2bcd8739ae039 = $ca46dedfd4ba46c8$var$WeakMap;

});


parcelRegister("fGAmH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b6b6fca2f508e28b$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $b6b6fca2f508e28b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b6b6fca2f508e28b$var$hasOwnProperty = $b6b6fca2f508e28b$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $b6b6fca2f508e28b$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $b6b6fca2f508e28b$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
var $b6b6fca2f508e28b$export$2e2bcd8739ae039 = $b6b6fca2f508e28b$var$initCloneArray;

});

parcelRegister("25BDK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $18593ef69d45065f$export$2e2bcd8739ae039; });

var $1jUaD = parcelRequire("1jUaD");

var $9tIkH = parcelRequire("9tIkH");

var $8PUq0 = parcelRequire("8PUq0");

var $564q2 = parcelRequire("564q2");

var $1Z4Db = parcelRequire("1Z4Db");
/** `Object#toString` result references. */ var $18593ef69d45065f$var$boolTag = '[object Boolean]', $18593ef69d45065f$var$dateTag = '[object Date]', $18593ef69d45065f$var$mapTag = '[object Map]', $18593ef69d45065f$var$numberTag = '[object Number]', $18593ef69d45065f$var$regexpTag = '[object RegExp]', $18593ef69d45065f$var$setTag = '[object Set]', $18593ef69d45065f$var$stringTag = '[object String]', $18593ef69d45065f$var$symbolTag = '[object Symbol]';
var $18593ef69d45065f$var$arrayBufferTag = '[object ArrayBuffer]', $18593ef69d45065f$var$dataViewTag = '[object DataView]', $18593ef69d45065f$var$float32Tag = '[object Float32Array]', $18593ef69d45065f$var$float64Tag = '[object Float64Array]', $18593ef69d45065f$var$int8Tag = '[object Int8Array]', $18593ef69d45065f$var$int16Tag = '[object Int16Array]', $18593ef69d45065f$var$int32Tag = '[object Int32Array]', $18593ef69d45065f$var$uint8Tag = '[object Uint8Array]', $18593ef69d45065f$var$uint8ClampedTag = '[object Uint8ClampedArray]', $18593ef69d45065f$var$uint16Tag = '[object Uint16Array]', $18593ef69d45065f$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $18593ef69d45065f$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $18593ef69d45065f$var$arrayBufferTag:
            return (0, $1jUaD.default)(object);
        case $18593ef69d45065f$var$boolTag:
        case $18593ef69d45065f$var$dateTag:
            return new Ctor(+object);
        case $18593ef69d45065f$var$dataViewTag:
            return (0, $9tIkH.default)(object, isDeep);
        case $18593ef69d45065f$var$float32Tag:
        case $18593ef69d45065f$var$float64Tag:
        case $18593ef69d45065f$var$int8Tag:
        case $18593ef69d45065f$var$int16Tag:
        case $18593ef69d45065f$var$int32Tag:
        case $18593ef69d45065f$var$uint8Tag:
        case $18593ef69d45065f$var$uint8ClampedTag:
        case $18593ef69d45065f$var$uint16Tag:
        case $18593ef69d45065f$var$uint32Tag:
            return (0, $1Z4Db.default)(object, isDeep);
        case $18593ef69d45065f$var$mapTag:
            return new Ctor;
        case $18593ef69d45065f$var$numberTag:
        case $18593ef69d45065f$var$stringTag:
            return new Ctor(object);
        case $18593ef69d45065f$var$regexpTag:
            return (0, $8PUq0.default)(object);
        case $18593ef69d45065f$var$setTag:
            return new Ctor;
        case $18593ef69d45065f$var$symbolTag:
            return (0, $564q2.default)(object);
    }
}
var $18593ef69d45065f$export$2e2bcd8739ae039 = $18593ef69d45065f$var$initCloneByTag;

});
parcelRegister("1jUaD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f63231dbc1eaaed$export$2e2bcd8739ae039; });

var $hNU6C = parcelRequire("hNU6C");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $0f63231dbc1eaaed$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new (0, $hNU6C.default)(result).set(new (0, $hNU6C.default)(arrayBuffer));
    return result;
}
var $0f63231dbc1eaaed$export$2e2bcd8739ae039 = $0f63231dbc1eaaed$var$cloneArrayBuffer;

});
parcelRegister("hNU6C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf6288b37fed1716$export$2e2bcd8739ae039; });

var $cbL8G = parcelRequire("cbL8G");
/** Built-in value references. */ var $cf6288b37fed1716$var$Uint8Array = (0, $cbL8G.default).Uint8Array;
var $cf6288b37fed1716$export$2e2bcd8739ae039 = $cf6288b37fed1716$var$Uint8Array;

});


parcelRegister("9tIkH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e69360e8e6cb743$export$2e2bcd8739ae039; });

var $1jUaD = parcelRequire("1jUaD");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $6e69360e8e6cb743$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? (0, $1jUaD.default)(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
var $6e69360e8e6cb743$export$2e2bcd8739ae039 = $6e69360e8e6cb743$var$cloneDataView;

});

parcelRegister("8PUq0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $66eed9a82bb5fa2e$export$2e2bcd8739ae039; });
/** Used to match `RegExp` flags from their coerced string values. */ var $66eed9a82bb5fa2e$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $66eed9a82bb5fa2e$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $66eed9a82bb5fa2e$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
var $66eed9a82bb5fa2e$export$2e2bcd8739ae039 = $66eed9a82bb5fa2e$var$cloneRegExp;

});

parcelRegister("564q2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b60f0d384d5d47a$export$2e2bcd8739ae039; });

var $hwtsf = parcelRequire("hwtsf");
/** Used to convert symbols to primitives and strings. */ var $3b60f0d384d5d47a$var$symbolProto = (0, $hwtsf.default) ? (0, $hwtsf.default).prototype : undefined, $3b60f0d384d5d47a$var$symbolValueOf = $3b60f0d384d5d47a$var$symbolProto ? $3b60f0d384d5d47a$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $3b60f0d384d5d47a$var$cloneSymbol(symbol) {
    return $3b60f0d384d5d47a$var$symbolValueOf ? Object($3b60f0d384d5d47a$var$symbolValueOf.call(symbol)) : {};
}
var $3b60f0d384d5d47a$export$2e2bcd8739ae039 = $3b60f0d384d5d47a$var$cloneSymbol;

});

parcelRegister("1Z4Db", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $171f149280584028$export$2e2bcd8739ae039; });

var $1jUaD = parcelRequire("1jUaD");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $171f149280584028$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? (0, $1jUaD.default)(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var $171f149280584028$export$2e2bcd8739ae039 = $171f149280584028$var$cloneTypedArray;

});


parcelRegister("55JsH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b50af285f841ab5$export$2e2bcd8739ae039; });

var $79thx = parcelRequire("79thx");

var $d18qD = parcelRequire("d18qD");

var $jcgNC = parcelRequire("jcgNC");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $3b50af285f841ab5$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !(0, $jcgNC.default)(object) ? (0, $79thx.default)((0, $d18qD.default)(object)) : {};
}
var $3b50af285f841ab5$export$2e2bcd8739ae039 = $3b50af285f841ab5$var$initCloneObject;

});
parcelRegister("79thx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5350166b48b30c0b$export$2e2bcd8739ae039; });

var $55CT4 = parcelRequire("55CT4");
/** Built-in value references. */ var $5350166b48b30c0b$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $5350166b48b30c0b$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!(0, $55CT4.default)(proto)) return {};
        if ($5350166b48b30c0b$var$objectCreate) return $5350166b48b30c0b$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
var $5350166b48b30c0b$export$2e2bcd8739ae039 = $5350166b48b30c0b$var$baseCreate;

});


parcelRegister("28u2G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $18e3a1e0ceac94be$export$2e2bcd8739ae039; });

var $4MjHA = parcelRequire("4MjHA");

var $aN9tr = parcelRequire("aN9tr");

var $lDlcQ = parcelRequire("lDlcQ");
/* Node.js helper references. */ var $18e3a1e0ceac94be$var$nodeIsMap = (0, $lDlcQ.default) && (0, $lDlcQ.default).isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $18e3a1e0ceac94be$var$isMap = $18e3a1e0ceac94be$var$nodeIsMap ? (0, $aN9tr.default)($18e3a1e0ceac94be$var$nodeIsMap) : (0, $4MjHA.default);
var $18e3a1e0ceac94be$export$2e2bcd8739ae039 = $18e3a1e0ceac94be$var$isMap;

});
parcelRegister("4MjHA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $37aaed8c35f4b509$export$2e2bcd8739ae039; });

var $6JaTE = parcelRequire("6JaTE");

var $9XysK = parcelRequire("9XysK");
/** `Object#toString` result references. */ var $37aaed8c35f4b509$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $37aaed8c35f4b509$var$baseIsMap(value) {
    return (0, $9XysK.default)(value) && (0, $6JaTE.default)(value) == $37aaed8c35f4b509$var$mapTag;
}
var $37aaed8c35f4b509$export$2e2bcd8739ae039 = $37aaed8c35f4b509$var$baseIsMap;

});


parcelRegister("eoSgZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a7bd680c92dcfdec$export$2e2bcd8739ae039; });

var $hJqr3 = parcelRequire("hJqr3");

var $aN9tr = parcelRequire("aN9tr");

var $lDlcQ = parcelRequire("lDlcQ");
/* Node.js helper references. */ var $a7bd680c92dcfdec$var$nodeIsSet = (0, $lDlcQ.default) && (0, $lDlcQ.default).isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $a7bd680c92dcfdec$var$isSet = $a7bd680c92dcfdec$var$nodeIsSet ? (0, $aN9tr.default)($a7bd680c92dcfdec$var$nodeIsSet) : (0, $hJqr3.default);
var $a7bd680c92dcfdec$export$2e2bcd8739ae039 = $a7bd680c92dcfdec$var$isSet;

});
parcelRegister("hJqr3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce8b252015e19951$export$2e2bcd8739ae039; });

var $6JaTE = parcelRequire("6JaTE");

var $9XysK = parcelRequire("9XysK");
/** `Object#toString` result references. */ var $ce8b252015e19951$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $ce8b252015e19951$var$baseIsSet(value) {
    return (0, $9XysK.default)(value) && (0, $6JaTE.default)(value) == $ce8b252015e19951$var$setTag;
}
var $ce8b252015e19951$export$2e2bcd8739ae039 = $ce8b252015e19951$var$baseIsSet;

});




parcelRegister("5N63k", function(module, exports) {
'use strict';
var $4376394e3d10b334$var$isArray = Array.isArray;
var $4376394e3d10b334$var$keyList = Object.keys;
var $4376394e3d10b334$var$hasProp = Object.prototype.hasOwnProperty;
var $4376394e3d10b334$var$hasElementType = typeof Element !== 'undefined';
function $4376394e3d10b334$var$equal(a, b) {
    // fast-deep-equal index.js 2.0.1
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        var arrA = $4376394e3d10b334$var$isArray(a), arrB = $4376394e3d10b334$var$isArray(b), i, length, key;
        if (arrA && arrB) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$4376394e3d10b334$var$equal(a[i], b[i])) return false;
            return true;
        }
        if (arrA != arrB) return false;
        var dateA = a instanceof Date, dateB = b instanceof Date;
        if (dateA != dateB) return false;
        if (dateA && dateB) return a.getTime() == b.getTime();
        var regexpA = a instanceof RegExp, regexpB = b instanceof RegExp;
        if (regexpA != regexpB) return false;
        if (regexpA && regexpB) return a.toString() == b.toString();
        var keys = $4376394e3d10b334$var$keyList(a);
        length = keys.length;
        if (length !== $4376394e3d10b334$var$keyList(b).length) return false;
        for(i = length; i-- !== 0;)if (!$4376394e3d10b334$var$hasProp.call(b, keys[i])) return false;
        // end fast-deep-equal
        // start react-fast-compare
        // custom handling for DOM elements
        if ($4376394e3d10b334$var$hasElementType && a instanceof Element && b instanceof Element) return a === b;
        // custom handling for React
        for(i = length; i-- !== 0;){
            key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            else {
                // all other properties should be traversed as usual
                if (!$4376394e3d10b334$var$equal(a[key], b[key])) return false;
            }
        }
        // end react-fast-compare
        // fast-deep-equal index.js 2.0.1
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function exportedEqual(a, b) {
    try {
        return $4376394e3d10b334$var$equal(a, b);
    } catch (error) {
        if (error.message && error.message.match(/stack|recursion/i) || error.number === -2146828260) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});

parcelRegister("7li8V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $55889165d71428b3$export$2e2bcd8739ae039; });
var $55889165d71428b3$var$isProduction = true;
function $55889165d71428b3$var$warning(condition, message) {
    if (!$55889165d71428b3$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== 'undefined') console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $55889165d71428b3$export$2e2bcd8739ae039 = $55889165d71428b3$var$warning;

});

parcelRegister("aAHHW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b5f2b9be7f2363e$export$2e2bcd8739ae039; });

var $5t0O7 = parcelRequire("5t0O7");
/** Used to compose bitmasks for cloning. */ var $7b5f2b9be7f2363e$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */ function $7b5f2b9be7f2363e$var$clone(value) {
    return (0, $5t0O7.default)(value, $7b5f2b9be7f2363e$var$CLONE_SYMBOLS_FLAG);
}
var $7b5f2b9be7f2363e$export$2e2bcd8739ae039 = $7b5f2b9be7f2363e$var$clone;

});

parcelRegister("cDRNl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9342db154376ebed$export$2e2bcd8739ae039; });

var $51q5w = parcelRequire("51q5w");

var $7KNPo = parcelRequire("7KNPo");

var $eA9yl = parcelRequire("eA9yl");

var $fdbzE = parcelRequire("fdbzE");

var $2nPhd = parcelRequire("2nPhd");

var $e9clf = parcelRequire("e9clf");

var $hghOo = parcelRequire("hghOo");
/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */ function $9342db154376ebed$var$toPath(value) {
    if ((0, $eA9yl.default)(value)) return (0, $51q5w.default)(value, (0, $e9clf.default));
    return (0, $fdbzE.default)(value) ? [
        value
    ] : (0, $7KNPo.default)((0, $2nPhd.default)((0, $hghOo.default)(value)));
}
var $9342db154376ebed$export$2e2bcd8739ae039 = $9342db154376ebed$var$toPath;

});
parcelRegister("51q5w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3a81484c1238e5f7$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $3a81484c1238e5f7$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
var $3a81484c1238e5f7$export$2e2bcd8739ae039 = $3a81484c1238e5f7$var$arrayMap;

});

parcelRegister("fdbzE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b1310c491d0c8521$export$2e2bcd8739ae039; });

var $2cf7J = parcelRequire("2cf7J");

var $9XysK = parcelRequire("9XysK");
/** `Object#toString` result references. */ var $b1310c491d0c8521$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $b1310c491d0c8521$var$isSymbol(value) {
    return typeof value == 'symbol' || (0, $9XysK.default)(value) && (0, $2cf7J.default)(value) == $b1310c491d0c8521$var$symbolTag;
}
var $b1310c491d0c8521$export$2e2bcd8739ae039 = $b1310c491d0c8521$var$isSymbol;

});

parcelRegister("2nPhd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1bc58141c215843b$export$2e2bcd8739ae039; });

var $a2285 = parcelRequire("a2285");
/** Used to match property names within property paths. */ var $1bc58141c215843b$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $1bc58141c215843b$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $1bc58141c215843b$var$stringToPath = (0, $a2285.default)(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($1bc58141c215843b$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($1bc58141c215843b$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
var $1bc58141c215843b$export$2e2bcd8739ae039 = $1bc58141c215843b$var$stringToPath;

});
parcelRegister("a2285", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74dbbe287fd5bee4$export$2e2bcd8739ae039; });

var $saTWr = parcelRequire("saTWr");
/** Used as the maximum memoize cache size. */ var $74dbbe287fd5bee4$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $74dbbe287fd5bee4$var$memoizeCapped(func) {
    var result = (0, $saTWr.default)(func, function(key) {
        if (cache.size === $74dbbe287fd5bee4$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
var $74dbbe287fd5bee4$export$2e2bcd8739ae039 = $74dbbe287fd5bee4$var$memoizeCapped;

});
parcelRegister("saTWr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $054b12683a3892d1$export$2e2bcd8739ae039; });

var $5Sw7u = parcelRequire("5Sw7u");
/** Error message constants. */ var $054b12683a3892d1$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $054b12683a3892d1$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($054b12683a3892d1$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($054b12683a3892d1$var$memoize.Cache || (0, $5Sw7u.default));
    return memoized;
}
// Expose `MapCache`.
$054b12683a3892d1$var$memoize.Cache = (0, $5Sw7u.default);
var $054b12683a3892d1$export$2e2bcd8739ae039 = $054b12683a3892d1$var$memoize;

});



parcelRegister("e9clf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4cb7ac731de7b78$export$2e2bcd8739ae039; });

var $fdbzE = parcelRequire("fdbzE");
/** Used as references for various `Number` constants. */ var $a4cb7ac731de7b78$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $a4cb7ac731de7b78$var$toKey(value) {
    if (typeof value == 'string' || (0, $fdbzE.default)(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$a4cb7ac731de7b78$var$INFINITY ? '-0' : result;
}
var $a4cb7ac731de7b78$export$2e2bcd8739ae039 = $a4cb7ac731de7b78$var$toKey;

});

parcelRegister("hghOo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c911bf5df7535e60$export$2e2bcd8739ae039; });

var $gdpWJ = parcelRequire("gdpWJ");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $c911bf5df7535e60$var$toString(value) {
    return value == null ? '' : (0, $gdpWJ.default)(value);
}
var $c911bf5df7535e60$export$2e2bcd8739ae039 = $c911bf5df7535e60$var$toString;

});
parcelRegister("gdpWJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bce1fc9efd55e169$export$2e2bcd8739ae039; });

var $hwtsf = parcelRequire("hwtsf");

var $51q5w = parcelRequire("51q5w");

var $eA9yl = parcelRequire("eA9yl");

var $fdbzE = parcelRequire("fdbzE");
/** Used as references for various `Number` constants. */ var $bce1fc9efd55e169$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $bce1fc9efd55e169$var$symbolProto = (0, $hwtsf.default) ? (0, $hwtsf.default).prototype : undefined, $bce1fc9efd55e169$var$symbolToString = $bce1fc9efd55e169$var$symbolProto ? $bce1fc9efd55e169$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $bce1fc9efd55e169$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ((0, $eA9yl.default)(value)) // Recursively convert values (susceptible to call stack limits).
    return (0, $51q5w.default)(value, $bce1fc9efd55e169$var$baseToString) + '';
    if ((0, $fdbzE.default)(value)) return $bce1fc9efd55e169$var$symbolToString ? $bce1fc9efd55e169$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$bce1fc9efd55e169$var$INFINITY ? '-0' : result;
}
var $bce1fc9efd55e169$export$2e2bcd8739ae039 = $bce1fc9efd55e169$var$baseToString;

});



parcelRegister("1NGjT", function(module, exports) {
'use strict';

var $fpNyO = parcelRequire("fpNyO");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $14fb31dfeed2b451$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $14fb31dfeed2b451$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $14fb31dfeed2b451$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $14fb31dfeed2b451$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $14fb31dfeed2b451$var$TYPE_STATICS = {};
$14fb31dfeed2b451$var$TYPE_STATICS[$fpNyO.ForwardRef] = $14fb31dfeed2b451$var$FORWARD_REF_STATICS;
$14fb31dfeed2b451$var$TYPE_STATICS[$fpNyO.Memo] = $14fb31dfeed2b451$var$MEMO_STATICS;
function $14fb31dfeed2b451$var$getStatics(component) {
    // React v16.11 and below
    if ($fpNyO.isMemo(component)) return $14fb31dfeed2b451$var$MEMO_STATICS;
     // React v16.12 and above
    return $14fb31dfeed2b451$var$TYPE_STATICS[component['$$typeof']] || $14fb31dfeed2b451$var$REACT_STATICS;
}
var $14fb31dfeed2b451$var$defineProperty = Object.defineProperty;
var $14fb31dfeed2b451$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $14fb31dfeed2b451$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $14fb31dfeed2b451$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $14fb31dfeed2b451$var$getPrototypeOf = Object.getPrototypeOf;
var $14fb31dfeed2b451$var$objectPrototype = Object.prototype;
function $14fb31dfeed2b451$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($14fb31dfeed2b451$var$objectPrototype) {
            var inheritedComponent = $14fb31dfeed2b451$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $14fb31dfeed2b451$var$objectPrototype) $14fb31dfeed2b451$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $14fb31dfeed2b451$var$getOwnPropertyNames(sourceComponent);
        if ($14fb31dfeed2b451$var$getOwnPropertySymbols) keys = keys.concat($14fb31dfeed2b451$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $14fb31dfeed2b451$var$getStatics(targetComponent);
        var sourceStatics = $14fb31dfeed2b451$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$14fb31dfeed2b451$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $14fb31dfeed2b451$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $14fb31dfeed2b451$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $14fb31dfeed2b451$var$hoistNonReactStatics;

});
parcelRegister("fpNyO", function(module, exports) {
'use strict';

module.exports = (parcelRequire("72yBp"));

});



parcelRegister("f5gxW", function(module, exports) {

var $3IH32 = parcelRequire("3IH32");
const $afb4286b3f2a0c2e$var$_ = {
    e (str) {
        if (typeof str !== 'string') str = String(str);
        return str.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, '&apos;');
    },
    t (value, vars = null) {
        if (typeof $3IH32.translate === 'function') return $3IH32.translate(value, vars);
        else return $3IH32.format(value, vars);
    },
    toNothing (label = null) {
        if (label === null) label = $afb4286b3f2a0c2e$var$_.t('n/a');
        return `<i class="null">${label}</i>`;
    },
    toList (list, sort = false, formatter = null, ordered = null) {
        let tag = ordered === true ? 'ol' : 'ul';
        if (!Array.isArray(list)) list = [
            list
        ];
        if (sort) {
            list = list.slice(0);
            if (typeof sort === 'function') list.sort(sort);
            else list.sort();
            if (ordered === null) tag = 'ol';
        }
        if (typeof formatter === 'function') list = list.map(formatter);
        if (list.length === 0) return $afb4286b3f2a0c2e$var$_.toNothing();
        else if (list.length === 1) return list[0];
        else return `<${tag}><li>${list.join("</li><li>")}</li></${tag}>`;
    },
    toLink (url, title = "", rel = "", target = "_blank") {
        if (!title) {
            if (url.length > 50) title = url.replace(/^\w+:\/\/([^\/]+)((\/[^\/\?]+)*\/([^\/\?]+)(\?.*)?)?$/i, function(...x) {
                if (x[4]) return x[1] + "\u200B/[\u2026]/\u200B" + x[4]; // There are invisible zero-width whitespaces after and before the slashes. It allows breaking the link in the browser. Be careful when editing.
                return x[1];
            });
            else title = url.replace(/^\w+:\/\//i, '');
        }
        return `<a href="${$afb4286b3f2a0c2e$var$_.e(url)}" rel="${$afb4286b3f2a0c2e$var$_.e(rel)}" target="${$afb4286b3f2a0c2e$var$_.e(target)}">${$afb4286b3f2a0c2e$var$_.e(title)}</a>`;
    },
    toObject (obj, formatter = null, keyFormatter = null, keyOrder = [], filter = null, path = []) {
        let html = '<dl>';
        let keys = Array.isArray(keyOrder) && keyOrder.length >= 2 ? keyOrder : Object.keys(obj);
        for (let key of keys){
            if (!(key in obj) || typeof filter === 'function' && path.length > 0 && !filter(path[0], path.concat([
                key
            ]))) continue;
            let label;
            if (typeof keyFormatter === 'function') label = keyFormatter(key, obj);
            else label = $afb4286b3f2a0c2e$var$_.formatKey(key, true);
            let value = obj[key];
            if (typeof formatter === 'function') value = formatter(value, key, obj);
            html += `<dt>${label}</dt><dd>${value}</dd>`;
        }
        html += `</dl>`;
        return html;
    },
    abbrev (short, long) {
        return `<abbr title="${$afb4286b3f2a0c2e$var$_.e(long)}">${$afb4286b3f2a0c2e$var$_.e(short)}</abbr>`;
    },
    isObject (obj) {
        return typeof obj === 'object' && obj === Object(obj) && !Array.isArray(obj);
    },
    formatKey (key, prefix = false) {
        if (key.includes('/')) // Slashes are strong indicators for URIs or media types, don't format
        return $afb4286b3f2a0c2e$var$_.e($afb4286b3f2a0c2e$var$_.t(key));
        if (prefix === false) key = key.replace(/^[\w-]+:/i, '');
        let formatted = key.split(/[:_\-\s]/g).map((part)=>part.substr(0, 1).toUpperCase() + part.substr(1)).join(' ');
        return $afb4286b3f2a0c2e$var$_.e($afb4286b3f2a0c2e$var$_.t(formatted));
    },
    hexToUint8 (hexString) {
        if (hexString.length === 0 || hexString.length % 2 !== 0) throw new Error(`The string "${hexString}" is not valid hex.`);
        return new Uint8Array(hexString.match(/.{1,2}/g).map((byte)=>parseInt(byte, 16)));
    },
    uint8ToHex (bytes) {
        return bytes.reduce((str, byte)=>str + byte.toString(16).padStart(2, '0'), '');
    },
    keysFromListOfObjects (objectList) {
        return objectList.reduce((arr, o)=>Object.keys(o).reduce((a, k)=>{
                if (a.indexOf(k) == -1) a.push(k);
                return a;
            }, arr), []);
    },
    unit (value, unit = '') {
        if (typeof unit === 'string' && unit.length > 0) {
            unit = $afb4286b3f2a0c2e$var$_.t(unit);
            return `${value}&nbsp;<span class="unit">${unit}</unit>`;
        }
        return value;
    }
};
module.exports = $afb4286b3f2a0c2e$var$_;

});
parcelRegister("3IH32", function(module, exports) {
const $2b56df9ddee4ddf5$var$Defaults = {
    collatorOptions: {},
    numberFormatterOptions: {
        maximumFractionDigits: 10
    },
    dateFormatterOptions: {
        day: 'numeric',
        month: 'numeric',
        year: 'numeric'
    },
    dateTimeFormatterOptions: {
        day: 'numeric',
        month: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        timeZone: "UTC",
        timeZoneName: "short"
    }
};
const $2b56df9ddee4ddf5$var$I18N = {
    locales: [],
    collator: new Intl.Collator([], $2b56df9ddee4ddf5$var$Defaults.collatorOptions),
    dateFormatter: new Intl.DateTimeFormat([], $2b56df9ddee4ddf5$var$Defaults.dateFormatterOptions),
    dateTimeFormatter: new Intl.DateTimeFormat([], $2b56df9ddee4ddf5$var$Defaults.dateTimeFormatterOptions),
    numberFormatter: new Intl.NumberFormat([], $2b56df9ddee4ddf5$var$Defaults.numberFormatterOptions),
    translate: null,
    getDefaults () {
        return $2b56df9ddee4ddf5$var$Defaults;
    },
    setLocales (locales, dateFormatterOptions = {}, dateTimeFormatterOptions = {}, numberFormatterOptions = {}, collatorOptions = {}) {
        this.locales = locales;
        collatorOptions = Object.assign({}, $2b56df9ddee4ddf5$var$Defaults.collatorOptions, collatorOptions);
        this.collator = new Intl.Collator(locales, collatorOptions);
        dateFormatterOptions = Object.assign({}, $2b56df9ddee4ddf5$var$Defaults.dateFormatterOptions, dateFormatterOptions);
        this.dateFormatter = new Intl.DateTimeFormat(locales, dateFormatterOptions);
        dateTimeFormatterOptions = Object.assign({}, $2b56df9ddee4ddf5$var$Defaults.dateTimeFormatterOptions, dateTimeFormatterOptions);
        this.dateTimeFormatter = new Intl.DateTimeFormat(locales, dateTimeFormatterOptions);
        numberFormatterOptions = Object.assign({}, $2b56df9ddee4ddf5$var$Defaults.numberFormatterOptions, numberFormatterOptions);
        this.numberFormatter = new Intl.NumberFormat(locales, numberFormatterOptions);
    },
    setTranslator (fn) {
        this.translate = fn;
    },
    format (value, vars = null) {
        if (vars) for(let key in vars)value = value.replaceAll(`{${key}}`, vars[key]);
        return value;
    }
};
module.exports = $2b56df9ddee4ddf5$var$I18N;

});


parcelRegister("aUdEw", function(module, exports) {
module.exports = JSON.parse('{"extensions":{"alternate":"Alternative Access Methods","anon":"Anonymized Location","auth":"Authentication","card4l":{"label":"CARD4L","explain":"CEOS Analysis Ready Data for Land"},"ceosard":{"label":"CEOS-ARD","explain":"CEOS Analysis Ready Data"},"cf":{"label":"CF Metadata Conventions","explain":"Climate and Forecast Metadata Conventions"},"classification":"Classification","contacts":"Contacts","cube":"Data Cube","esa_cci_lc":"ESA Climate Change Initiative - Land Cover","eo":"Electro-Optical","forecast":"Forecast","file":"File","grid":"Gridded Data","goes":{"label":"NOAA GOES","explain":"NOAA Geostationary Operational Environmental Satellite"},"label":"Labels / ML","language":"Internationalization / Localization","mgrs":{"label":"MGRS","explain":"Military Grid Reference System"},"noaa_mrms_qpe":{"label":"NOAA MRMS QPE","explain":"NOAA Multi-Radar Multi-Sensor Quantitative Precipitation Estimation"},"odc":"Open Data Cube","order":"Order","pc":"Point Cloud","processing":"Processing","product":"Product","proj":"Projection","raster":"Raster Imagery","sar":{"label":"SAR","explain":"Synthetic Aperture Radar"},"sat":"Satellite","sci":"Scientific","ssys":"Solar System","stats":"STAC Statistics","storage":"Cloud Storage","table":"Tabular Data","themes":"Themes","tiles":"Tiled Assets","view":"View Geometry","web-map-links":"Web Maps","xarray":"xarray","gee":"Google Earth Engine","landsat":"Landsat","msft":"Microsoft","openeo":"openEO","pl":"Planet Labs PBC","s2":"Sentinel-2","sentinel":"Copernicus Sentinel","cbers":{"label":"CBERS","explain":"China-Brazil Earth Resources Satellite Program"},"geoadmin":{"label":"swisstopo","explain":"Federal Office of Topography (Switzerland)"}},"links":{"href":{"label":"URL","format":"Url"},"hreflang":{"label":"Language","format":"LanguageCode"},"rel":{"label":"Relation","explain":"Based on IANA relation types","mapping":{"self":"This document","root":"Root STAC Catalog","parent":"Parent STAC Catalog","collection":"STAC Collection","derived_from":"STAC Item for input data","about":"About this resource","alternate":"Alternative representation","via":"Source metadata","next":"Next page","prev":"Previous page","canonical":"Origin of this document","processing-expression":"Processing inctructions/code","latest-version":"Latest version","predecessor-version":"Predecessor version","successor-version":"Successor version","source":"Source data","cite-as":"Citation information","related":"Related resource","describedby":"Description of the resource","service-desc":"API definitions","service-doc":"API user documentation","conformance":"API conformance declaration","order":"Order details","3d-tiles":"3D Tiles","pmtiles":"PMTiles","tilejson":"TileJSON","wms":"OGC Web Map Service (WMS)","wmts":"OGC Web Map Tile Service (WMTS)","xyz":"XYZ Web Map","license":"License"}},"type":{"label":"File Format","explain":"Based on the IANA media (MIME) types","format":"MediaType"},"method":"HTTP Method","headers":"HTTP Headers","body":"Request Body"},"assets":{"href":{"label":"URL","format":"Url"},"hreflang":{"label":"Language","format":"LanguageCode"},"type":{"label":"File Format","explain":"Based on the IANA media (MIME) types","format":"MediaType"},"roles":{"label":"Purpose","mapping":{"thumbnail":"Preview","overview":"Overview","visual":"Visualization","data":"Data","metadata":"Metadata","graphic":"Illustration"}},"alternate":{"label":"Alternatives","listWithKeys":true,"items":{"alternate:name":"Identifier","href":{"label":"URL","format":"Url"},"title":{"alias":"title"},"description":{"alias":"description"}},"summary":false,"ext":"alternate"},"pl:asset_type":"Asset Type","pl:bundle_type":"Bundle Type","table:storage_options":{"alias":"xarray:storage_options"},"xarray:open_kwargs":{"label":"Read Options","custom":true,"summary":false},"xarray:storage_options":{"label":"fsspec Options","custom":true,"summary":false}},"metadata":{"id":"Identifier","keywords":"Keywords","datetime":{"label":"Time of Data","format":"Timestamp","summary":false},"title":{"label":"Title","summary":false},"description":{"label":"Description","format":"CommonMark","summary":false},"roles":"Purpose","start_datetime":{"label":"Time of Data begins","format":"Timestamp","summary":false},"end_datetime":{"label":"Time of Data ends","format":"Timestamp","summary":false},"created":{"label":"Created","format":"Timestamp","summary":"r"},"updated":{"label":"Updated","format":"Timestamp","summary":"r"},"published":{"label":"Published","format":"Timestamp","summary":"r"},"expires":{"label":"Expires","format":"Timestamp","summary":"r"},"unpublished":{"label":"Unpublished","format":"Timestamp","summary":"r"},"license":{"label":"License","format":"License","summary":false},"providers":{"label":"Providers","format":"Providers","summary":false},"platform":"Platform","instruments":{"label":"Instruments","format":"CSV"},"constellation":"Constellation","mission":"Mission","gsd":{"label":"GSD","explain":"Ground Sample Distance","unit":"m"},"bands":{"label":"Bands","items":{"name":{"label":"Name","sortable":true,"id":true,"order":0},"description":{"alias":"description","order":2},"gsd":{"alias":"gsd","sortable":true},"nodata":{"alias":"nodata"},"data_type":{"alias":"data_type","sortable":true},"statistics":{"alias":"statistics"},"eo:common_name":{"alias":"eo:common_name","sortable":true,"order":1},"eo:center_wavelength":{"alias":"eo:center_wavelength","sortable":true},"eo:full_width_half_max":{"alias":"eo:full_width_half_max","sortable":true},"eo:solar_illumination":{"alias":"eo:solar_illumination","sortable":true},"raster:sampling":{"alias":"raster:sampling","sortable":true},"unit":{"alias":"unit","sortable":true},"raster:bits_per_sample":{"alias":"raster:bits_per_sample","sortable":true},"raster:spatial_resolution":{"alias":"raster:spatial_resolution","sortable":true},"raster:scale":{"alias":"raster:scale","sortable":true},"raster:offset":{"alias":"raster:offset","sortable":true},"raster:histogram":{"alias":"raster:histogram"},"classification:classes":{"alias":"classification:classes"},"classification:bitfields":{"alias":"classification:bitfields"}}},"nodata":{"label":"No-Data Values","format":"CSV","summary":false},"data_type":{"label":"Data Type of Values","format":"FileDataType"},"unit":"Unit of Values","statistics":{"label":"Statistics","properties":{"mean":"Average","maximum":{"label":"Max.","explain":"Maximum value"},"minimum":{"label":"Min.","explain":"Minimum value"},"stdev":{"label":"Std. Dev.","explain":"Standard Deviation"},"count":{"label":"Count","explain":"Total number of values"},"valid_percent":{"label":"Valid","explain":"Percentage of valid values","unit":"%"}}},"version":{"label":"Data Version","summary":false},"deprecated":{"label":"Deprecated","summary":false},"experimental":{"label":"Experimental","summary":false},"language":{"label":"Current Language","ext":"language","summary":"v","properties":{"name":{"label":"Name"},"alternate":{"label":"Alternate Name"},"code":{"label":"Code"},"dir":{"label":"Direction","explain":"Reading and writing direction","mapping":{"ltr":"left-to-right","rtl":"right-to-left"},"default":"ltr"}}},"languages":{"label":"Available Languages","ext":"language","summary":false,"items":{"name":{"label":"Name","sortable":true,"order":0},"alternate":{"label":"Alternate Name","sortable":true,"order":1},"code":{"label":"Code","sortable":true,"order":2},"dir":{"label":"Direction","explain":"Reading and writing direction","sortable":true,"order":3,"mapping":{"ltr":"left-to-right","rtl":"right-to-left"},"default":"ltr"}}},"contacts":{"label":"Contacts","ext":"contacts","summary":"v","items":{"name":{"label":"Name"},"identifier":{"label":"Identifier"},"position":{"label":"Position"},"organization":{"label":"Organization"},"logo":{"label":"Logo","format":"Image"},"phones":{"label":"Phone","items":{"value":{"label":"Number","format":"Phone","order":0},"roles":{"label":"Used For","order":1,"mapping":{"work":"Work","home":"Personal","fax":"Fax"}}}},"emails":{"label":"Email","items":{"value":{"label":"Address","format":"Email","order":0},"roles":{"label":"Used For","order":1,"mapping":{"work":"Work","home":"Personal"}}}},"addresses":{"label":"Postal Addresses","format":"Address","items":{"deliveryPoint":{"label":"Street / House","order":0},"city":{"label":"City","order":1},"administrativeArea":{"label":"State / Province","order":2},"postalCode":{"label":"Postal Code","order":3},"country":{"label":"Country","order":4}}},"links":{"label":"Additional Resources","format":"Link"},"contactInstructions":"Further Instructions","roles":{"label":"Types","format":"CSV"}}},"themes":{"label":"Themes","ext":"themes","summary":false,"items":{"scheme":{"label":"Vocabulary","order":0,"format":"Url"},"concepts":{"label":"Terms","order":1,"format":"Concepts","items":{"id":{"label":"Identifier","order":0},"title":{"label":"Title","order":1},"description":{"label":"Description","order":2},"url":{"label":"URL","order":3,"format":"Url"}}}}},"crs":{"label":"CRS","format":"CRS","explain":"Coordinate Reference System"},"anon:size":{"label":"Uncertainty","unit":"\xb0","explain":"The size of one side of the anonymized bounding box"},"anon:warning":{"label":"Warning","summary":false},"ceosard:type":{"label":"Sensor Type","mapping":{"optical":"Optical","radar":"Radar (SAR)"}},"ceosard:specification":{"label":"PFS","explain":"CEOS-ARD Product Family Specification","mapping":{"SR":"Surface Reflectance","ST":"Surface Temperature","AR":"Aquatic Reflectance","NLSR":"Nighttime Lights Surface Radiance","NRB":"Normalised Radar Backscatter","POL":"Polarimetric Radar","ORB":"Ocean Radar Backscatter","GSLC":"Geocoded Single-Look Complex","INSAR":"Interferometric Radar"}},"ceosard:specification_version":"PFS Version","cf:parameter":{"label":"Parameters","items":{"name":{"label":"Standard Name","order":0},"unit":{"label":"Unit","order":1}}},"classification:classes":{"summary":false,"label":"Classes","items":{"color_hint":{"label":"Color","order":0,"format":"HexColor"},"value":{"label":"Value","sortable":true,"order":1},"title":{"label":"Title","sortable":true,"order":2},"name":{"label":"Identifier","sortable":true,"order":3},"description":{"label":"Description","order":4,"format":"CommonMark"},"percentage":{"label":"Percentage of samples","sortable":true,"order":5,"unit":"%"},"count":{"label":"Number of samples","sortable":true,"order":6},"nodata":{"label":"No-data value","order":7,"default":false}}},"classification:bitfields":{"summary":false,"label":"Bit Mask","items":{"name":{"label":"Name","sortable":true,"order":0},"offset":{"label":"Offset","explain":"Offset to the first bit","order":1},"length":{"label":"Number of bits","order":2},"description":{"label":"Description","order":3,"format":"CommonMark"},"classes":{"alias":"classification:classes"},"roles":{"label":"Purpose"}}},"cube:dimensions":{"label":"Dimensions","summary":false,"listWithKeys":true,"items":{"type":{"label":"Type","order":0},"axis":{"label":"Axis","order":1},"description":{"label":"Description","format":"CommonMark","order":2},"extent":{"label":"Extent","format":"Extent","order":3},"bbox":{"alias":"proj:bbox","order":3},"values":{"label":"Values","order":4},"step":{"label":"Step","order":5},"unit":{"alias":"unit","order":5},"geometry_types":{"label":"Geometry Types","order":5},"reference_system":{"label":"Reference System","explain":"Coordinate / Temporal / Other Reference System","order":6}}},"cube:variables":{"label":"Variables","summary":false,"listWithKeys":true,"items":{"dimensions":{"label":"Dimensions","order":0},"type":{"label":"Type","order":1,"mapping":{"data":"Measured values","auxiliary":"Coordinate data"}},"description":{"label":"Description","format":"CommonMark","order":2},"extent":{"label":"Extent","format":"Extent","order":3},"values":{"label":"Values","order":4},"step":{"label":"Step","order":5},"unit":{"alias":"unit","order":6}}},"eo:bands":{"label":"Spectral Bands","items":{"name":{"label":"Name","sortable":true,"id":true,"order":0},"common_name":{"alias":"eo:common_name","sortable":true,"order":1},"center_wavelength":{"alias":"eo:center_wavelength","sortable":true,"order":2},"full_width_half_max":{"alias":"eo:full_width_half_max","sortable":true,"order":3},"solar_illumination":{"alias":"eo:solar_illumination","sortable":true,"order":7},"description":{"alias":"description"},"gsd":{"alias":"gsd","sortable":true},"cloud_cover":{"alias":"eo:cloud_cover","sortable":true}}},"eo:cloud_cover":{"label":"Cloud Cover","unit":"%"},"eo:snow_cover":{"label":"Snow/Ice Cover","unit":"%"},"eo:common_name":"Common Name","eo:center_wavelength":{"label":"Wavelength","explain":"The center wavelength of the band","unit":"\u03BCm"},"eo:full_width_half_max":{"label":"FWHM","explain":"Full Width Half Max","unit":"\u03BCm"},"eo:solar_illumination":{"label":"Solar Illumination","unit":"W/m\xb2/\u03BCm"},"forecast:reference_datetime":{"label":"Reference Time","format":"Timestamp","summary":"r"},"forecast:horizon":{"label":"Forecast Horizon","explain":"The time between the reference time and the forecast time","format":"Duration"},"forecast:duration":{"label":"Forecast Length","format":"Duration"},"file:bits_per_sample":{"alias":"raster:bits_per_sample"},"file:byte_order":"Byte Order","file:checksum":{"label":"Checksum","format":"Checksum","summary":false},"file:data_type":{"alias":"data_type"},"file:header_size":{"label":"Header Size","format":"FileSize","summary":false},"file:nodata":{"alias":"nodata"},"file:size":{"label":"Size","format":"FileSize","summary":false},"file:unit":{"alias":"unit"},"file:values":{"label":"Map of Values","summary":false,"items":{"values":{"label":"Values","format":"CSV","order":1},"summary":{"label":"Summary","order":0}}},"file:local_path":{"label":"Local Path","summary":false},"nodata:values":{"alias":"nodata"},"goes:orbital_slot":"Orbital Slot","goes:system_environment":{"label":"System Environment","mapping":{"OR":"Operational system, real-time data","OT":"Operational system, test data","IR":"Test system, real-time data","IT":"Test system, test data","IP":"Test system, playback data","IS":"Test system, simulated data"}},"goes:image_type":{"label":"Area","mapping":{"FULL DISK":"The Americas (full disk)","CONUS":"North America (continental US)","MESOSCALE":"Central/South America (mesoscale)"}},"goes:mesoscale_image_number":{"label":"Area in Central/South America","mapping":{"1":"Region 1","2":"Region 2"}},"goes:mode":{"label":"Capture Mode","mapping":{"3":"3: 1x full disk, 3x continental US, 30x mesoscale region 1, 30x mesoscale region 2 (every 15 minutes)","4":"4: 1x full disk (every 5 minutes)","6":"6: 1x full disk, 2x continental US, 20x mesoscale region 1, 20x mesoscale region 2 (every 10 minutes)"}},"goes:group_time_threshold":{"label":"Time Threshold in a Group","explain":"Lightning group maximum time difference among lightning events in a group","unit":"s"},"goes:flash_time_threshold":{"label":"Time Threshold in a Flash","explain":"Lightning flash maximum time difference among lightning events in a flash","unit":"s"},"goes:lightning_wavelength":{"label":"Central Wavelength","unit":"nm"},"goes:yaw_flip_flag":{"label":"Yaw Flip Configuration","explain":"Flag indicating that the spacecraft is operating in yaw flip configuration.","mapping":{"0":"Upright","1":"Neither","2":"Inverted"}},"goes:event_count":"Lightning Events","goes:group_count":"Lightning Groups","goes:flash_count":"Lightning Flashes","goes:nominal_satellite_subpoint_lat":{"label":"Satellite Subpoint Latitude","unit":"\xb0N"},"goes:nominal_satellite_subpoint_lon":{"label":"Satellite Subpoint Longitude","unit":"\xb0E"},"goes:nominal_satellite_height":{"label":"Satellite Height","explain":"Nominal satellite height above GRS 80 ellipsoid","unit":"km"},"goes:percent_navigated_L1b_events":{"label":"Events navigated by Instrument","format":"Percent0to1","unit":"%"},"goes:percent_uncorrectable_L0_errors":{"label":"Data Lost","format":"Percent0to1","unit":"%"},"grid:code":{"label":"Grid","format":"GridCode"},"raster:bands":{"label":"Layers","items":{"nodata":{"alias":"nodata"},"sampling":{"alias":"raster:sampling","sortable":true},"data_type":{"alias":"data_type","sortable":true},"bits_per_sample":{"alias":"raster:bits_per_sample","sortable":true},"spatial_resolution":{"alias":"raster:spatial_resolution","sortable":true},"statistics":{"alias":"statistics"},"unit":{"alias":"unit","sortable":true},"scale":{"alias":"raster:scale","sortable":true},"offset":{"alias":"raster:offset","sortable":true},"histogram":{"alias":"raster:histogram"}}},"raster:sampling":{"label":"Sampling","mapping":{"area":"Area","point":"Point (at pixel center)"}},"raster:bits_per_sample":"Bits per Sample","raster:spatial_resolution":{"label":"Resolution","explain":"Average spatial resolution","unit":"m"},"raster:scale":"Scale","raster:offset":"Offset","raster:histogram":{"label":"Histogram","custom":true},"label:properties":{"label":"Properties","null":"raster data"},"label:classes":{"label":"Classes","items":{"name":{"label":"Name","null":"raster-formatted","sortable":true,"id":true},"classes":"Classes"}},"label:description":{"label":"Description","format":"CommonMark","summary":false},"label:type":"Type","label:tasks":"Tasks","label:methods":"Methods","label:overviews":{"label":"Overviews","summary":false,"items":{"property_key":{"label":"Property Key","id":true},"counts":{"label":"Counts","custom":true},"statistics":{"label":"Statistics","custom":true}}},"mgrs:latitude_band":"Latitude Band","mgrs:grid_square":"Grid Square","mgrs:utm_zone":"UTM Zone","noaa_mrms_qpe:pass":{"label":"Pass Number","mapping":{"1":"1 (less latency / less gauges)","2":"2 (more latency / more gauges)"}},"noaa_mrms_qpe:period":{"label":"Accumulation Period","unit":"h"},"noaa_mrms_qpe:region":{"label":"Region","mapping":{"CONUS":"Continental US","HAWAII":"Hawaii","GUAM":"Guam","ALASKA":"Alaska","CARIB":"Caribbean Islands"}},"openeo:status":"Processing Status","api_version":{"label":"API Version","ext":"openeo"},"backend_version":{"label":"Back-End Version","ext":"openeo"},"production":{"label":"Production-Ready","ext":"openeo"},"endpoints":{"label":"Supported Endpoints","ext":"openeo","summary":false,"items":{"path":{"label":"Path Template","order":0},"methods":{"label":"HTTP Methods","order":1,"format":"CSV"}}},"billing":{"label":"Billing","ext":"openeo","custom":true,"summary":false},"order:status":{"label":"Status","mapping":{"orderable":"Orderable (data can be ordered)","ordered":"Ordered (preparing to deliver data)","pending":"Pending (waiting for activation)","shipping":"Shipping (data is getting processed)","succeeded":"Delivered (data is available)","failed":"Failed (unable to deliver)","canceled":"Canceled (delivery stopped)"}},"order:id":"Identifier","order:date":{"label":"Submitted","format":"Timestamp","summary":"r"},"order:expiration_date":{"alias":"expires"},"pc:count":{"label":"Points","explain":"Number of Points"},"pc:type":"Type","pc:encoding":"Format","pc:schemas":{"label":"Schemas","summary":false,"items":{"name":{"label":"Name","sortable":true,"id":true},"size":{"label":"Size","unit":"bytes","sortable":true},"type":{"label":"Type","sortable":true}}},"pc:density":"Density","pc:statistics":{"label":"Statistics","summary":"s","items":{"name":{"label":"Name","id":true},"position":"Position","average":"Average","count":"Count","maximum":{"label":"Max.","explain":"Maximum value"},"minimum":{"label":"Min.","explain":"Minimum value"},"stddev":{"label":"Std. Dev.","explain":"Standard Deviation"},"variance":"Variance"}},"processing:expression":{"label":"Processing Instructions","summary":false},"processing:lineage":{"label":"Lineage","format":"CommonMark","summary":false},"processing:level":"Level","processing:facility":"Facility","processing:software":{"label":"Software","format":"Software","summary":false},"processing:version":"Processor Version","processing:datetime":{"label":"Processing Time","format":"Timestamp","summary":"r"},"product:type":"Product Type","product:timeliness":{"label":"Timeliness","format":"Duration"},"product:timeliness_category":"Timeliness Category","product:acquisition_type":{"label":"Acquisition Type","mapping":{"nominal":"Nominal","calibration":"Calibration","other":"Other"}},"proj:epsg":{"label":"EPSG Code","format":"EPSG","summary":"v"},"proj:code":{"label":"Code","format":"CrsCode","summary":"v"},"proj:wkt2":{"label":"WKT2","explain":"Well-Known Text, version 2","format":"WKT2","summary":false},"proj:projjson":{"label":"PROJJSON","explain":"JSON encoding of WKT2","format":"PROJJSON","summary":false},"proj:geometry":{"label":"Footprint","custom":true,"summary":false},"proj:bbox":{"label":"Bounding Box","custom":true,"summary":false},"proj:centroid":{"label":"Centroid","custom":true,"summary":false},"proj:shape":{"label":"Image Dimensions","format":"Shape","summary":false},"proj:transform":{"label":"Transformation Matrix","format":"Transform","summary":false},"sar:instrument_mode":"Instrument Mode","sar:frequency_band":"Frequency Band","sar:center_frequency":{"label":"Center Frequency","unit":"GHz"},"sar:polarizations":{"label":"Polarizations","format":"CSV"},"sar:product_type":"Product Type","sar:resolution_range":{"label":"Range Resolution","unit":"m"},"sar:resolution_azimuth":{"label":"Azimuth Resolution","unit":"m"},"sar:pixel_spacing_range":{"label":"Range Pixel Spacing","unit":"m"},"sar:pixel_spacing_azimuth":{"label":"Azimuth Pixel Spacing","unit":"m"},"sar:looks_range":"Range Looks","sar:looks_azimuth":"Azimuth Looks","sar:looks_equivalent_number":{"label":"ENL","explain":"Equivalent Number of Looks"},"sar:observation_direction":"Observation Direction","sat:platform_international_designator":{"label":"Int. Designator","explain":"International designator for the platform, also known as COSPAR ID and NSSDCA ID."},"sat:orbit_state":"Orbit State","sat:absolute_orbit":{"label":"Abs. Orbit Number","explain":"Absolute Orbit Number"},"sat:relative_orbit":{"label":"Rel. Orbit Number","explain":"Relative Orbit Number"},"sat:anx_datetime":{"label":"ANX Time","format":"Timestamp","explain":"Ascending Node Crossing time","summary":"r"},"sci:doi":{"label":"DOI","format":"DOI"},"sci:citation":"Citation","sci:publications":{"label":"Publications","summary":false,"items":{"citation":{"label":"Publication","sortable":true,"order":0},"doi":{"label":"DOI","format":"DOI","sortable":true,"order":1}}},"ssys:targets":"Target Body","auth:refs":"Methods","auth:schemes":{"label":"Methods","listWithKeys":true,"items":{"type":{"label":"Method","order":0,"mapping":{"http":"HTTP","s3":"S3","signedUrl":"Signed URL","oauth2":"OAuth2","openIdConnect":"OpenID Connect","apiKey":"API Token"}},"description":{"alias":"description","order":1},"in":{"label":"Provide token as","mapping":{"query":"Query parameter","header":"HTTP header","cookie":"Cookie"},"order":1},"name":{"label":"Parameter","order":2},"scheme":"HTTP Scheme","flows":"Flows","openIdConnectUrl":"OpenID Connect metadata"}},"storage:refs":"Providers","storage:schemes":{"label":"Providers","listWithKeys":true,"items":{"title":{"label":"Title","order":0},"description":{"title":"Description","format":"CommonMark","order":1},"type":{"label":"Type","order":2,"mapping":{"s3":"S3 (Amazon Web Services)","custom-s3":"S3 (self-hosted)","ms-azure":"Microsoft Azure"}},"platform":{"label":"Host","order":3},"region":{"label":"Region","order":4},"requester_pays":{"label":"Payment","mapping":{"true":"Requester Pays","false":"Provider Pays"},"order":5}}},"table:columns":{"label":"Columns","items":{"name":{"label":"Name","sortable":true,"id":true,"order":0},"type":{"label":"Data Type","sortable":true,"order":1},"description":{"label":"Description","format":"CommonMark","order":2}}},"table:primary_geometry":"Primary Geometry Column","table:row_count":"Rows","table:tables":{"label":"Tables","summary":false,"listWithKeys":true,"items":{"name":{"label":"Name","sortable":true,"id":true,"order":0},"description":{"label":"Description","format":"CommonMark","order":1}}},"tiles:tile_matrix_sets":{"label":"Tile Matrix Sets","custom":true,"summary":false},"tiles:tile_matrix_set_links":{"label":"Tile Matrix Set Links","custom":true,"summary":false},"view:off_nadir":{"label":"Off-Nadir Angle","unit":"\xb0"},"view:incidence_angle":{"label":"Incidence Angle","unit":"\xb0"},"view:azimuth":{"label":"Viewing Azimuth","unit":"\xb0"},"view:sun_azimuth":{"label":"Sun Azimuth","unit":"\xb0"},"view:sun_elevation":{"label":"Sun Elevation","unit":"\xb0"},"pl:black_fill":{"label":"Unfilled Image Parts","unit":"%"},"pl:clear_percent":{"label":"Clear Sky","unit":"%"},"pl:grid_cell":"Grid Cell","pl:ground_control":"Positional Accuracy","pl:ground_control_ratio":"Successful Rectification Ratio","pl:item_type":"Type","pl:pixel_resolution":{"label":"Spatial Resolution","unit":"m"},"pl:publishing_stage":{"label":"Publishing Stage","mapping":{"preview":"Preview","standard":"Standard","finalized":"Finalized"}},"pl:quality_category":{"label":"Quality Category","mapping":{"standard":"Standard","test":"Test"}},"pl:strip_id":"Image Strip ID","gee:type":{"label":"Type","mapping":{"image":"Single image","image_collection":"Image collection","table":"Table"}},"gee:cadence":"Cadence","gee:schema":{"label":"Variables","items":{"name":"Name","description":"Description","type":"Data Type"},"summary":false},"gee:revisit_interval":"Revisit Interval","gee:terms_of_use":{"label":"Terms of Use","format":"CommonMark","summary":false},"gee:visualizations":{"label":"Visualizations","custom":true,"summary":false},"landsat:scene_id":"Scene ID","landsat:collection_category":"Collection Category","landsat:collection_number":"Collection Number","landsat:wrs_type":{"label":"WRS Type","explain":"Worldwide Reference System Type"},"landsat:wrs_path":{"label":"WRS Path","explain":"Worldwide Reference System Path"},"landsat:wrs_row":{"label":"WRS Row","explain":"Worldwide Reference System Row"},"landsat:cloud_cover_land":{"label":"Land Cloud Cover","unit":"%"},"msft:container":"Container","msft:storage_account":"Storage Account","msft:short_description":{"label":"Summary","summary":false},"sentinel:utm_zone":"UTM Zone","sentinel:latitude_band":"Latitude Band","sentinel:grid_square":"Grid Square","sentinel:sequence":"Sequence","sentinel:product_id":{"label":"Product ID","summary":"s"},"sentinel:data_coverage":{"label":"Data Coverage","unit":"%"},"sentinel:valid_cloud_cover":"Valid Cloud Cover","cbers:data_type":{"label":"Processing Level","explain":"Geolocation precision level","mapping":{"L2":"Geolocation using only satellite telemetry","L3":"Control points used to geolocate image, no terrain correction","L4":"Control points used to geolocate image, orthorectified"},"summary":"v"},"cbers:path":"Reference Grid Path","cbers:row":"Reference Grid Row","card4l:specification":{"label":"Specification","mapping":{"SR":"Surface Reflectance","ST":"Surface Temperature","NRB":"Normalised Radar Backscatter","POL":"Polarimetric Radar"}},"card4l:specification_version":"Specification Version","card4l:orbit_mean_altitude":{"label":"Platform Altitude","unit":"m"},"card4l:incidence_angle_near_range":{"label":"Incidence Angle (near)","unit":"\xb0"},"card4l:incidence_angle_far_range":{"label":"Incidence Angle (far)","unit":"\xb0"},"card4l:noise_equivalent_intensity":{"label":"Noise Equivalent Intensity","unit":"dB"},"card4l:mean_faraday_rotation_angle":{"label":"Mean Faraday Rotation","unit":"\xb0"},"card4l:speckle_filtering":{"label":"Speckle Filtering","custom":true,"summary":false,"null":"not applied"},"card4l:relative_rtc_accuracy":{"label":"Rel. RTC Accuracy","explain":"Relative accuracy of the Radiometric Terrain Correction","unit":"dB"},"card4l:absolute_rtc_accuracy":{"label":"Abs. RTC Accuracy","explain":"Absolute accuracy of the Radiometric Terrain Correction","unit":"dB"},"card4l:northern_geometric_accuracy":{"label":"Northern Geometric Accuracy","unit":"m"},"card4l:eastern_geometric_accuracy":{"label":"Eastern Geometric Accuracy","unit":"m"},"card4l:ellipsoidal_height":{"label":"Ellipsoidal Height","unit":"m"},"geoadmin:variant":{"label":"Product Variant","mapping":{"krel":"RGB color with relief","komb":"RGB color without relief","kgrel":"Grayscale with relief","kgrs":"Grayscale without relief"}},"href:servers":{"label":"Servers","ext":"web-map-links"},"pmtiles:layers":{"label":"Layers","ext":"web-map-links"},"wms:layers":{"label":"Layers","ext":"web-map-links"},"wms:styles":{"label":"Styles","ext":"web-map-links"},"wms:dimensions":{"label":"Dimensions","ext":"web-map-links"},"wms:transparent":{"label":"Transparency","ext":"web-map-links"},"wmts:layer":{"label":"Layers","ext":"web-map-links"},"wmts:dimensions":{"label":"Dimensions","ext":"web-map-links"}}}');

});

parcelRegister("4mRY8", function(module, exports) {

$parcel$export(module.exports, "ar", function () { return $32e31499ba21895f$export$d24c54395ce0c509; });
$parcel$export(module.exports, "bg", function () { return $32e31499ba21895f$export$136fd86de524d3c2; });
$parcel$export(module.exports, "ca", function () { return $32e31499ba21895f$export$89e9012e902952b6; });
$parcel$export(module.exports, "cs", function () { return $32e31499ba21895f$export$bde1ed0f60b38f2f; });
$parcel$export(module.exports, "da", function () { return $32e31499ba21895f$export$8c8450b83b664ba4; });
$parcel$export(module.exports, "de", function () { return $32e31499ba21895f$export$2fa162a495d26869; });
$parcel$export(module.exports, "en", function () { return $32e31499ba21895f$export$84584c2a98eb6753; });
$parcel$export(module.exports, "es", function () { return $32e31499ba21895f$export$ca5e4045a55e76d2; });
$parcel$export(module.exports, "et", function () { return $32e31499ba21895f$export$457177dcde8472be; });
$parcel$export(module.exports, "fa", function () { return $32e31499ba21895f$export$48a262eaf0aadda2; });
$parcel$export(module.exports, "fi", function () { return $32e31499ba21895f$export$ed5179c818622fb; });
$parcel$export(module.exports, "fo", function () { return $32e31499ba21895f$export$8979478257f87fe6; });
$parcel$export(module.exports, "fr", function () { return $32e31499ba21895f$export$acb2a88f7d552ebf; });
$parcel$export(module.exports, "gr", function () { return $32e31499ba21895f$export$d911550c75100362; });
$parcel$export(module.exports, "he", function () { return $32e31499ba21895f$export$10cc7d172bb7969; });
$parcel$export(module.exports, "hr", function () { return $32e31499ba21895f$export$b4adb3f464574dcf; });
$parcel$export(module.exports, "hu", function () { return $32e31499ba21895f$export$9901d21957972d53; });
$parcel$export(module.exports, "is", function () { return $32e31499ba21895f$export$226b3eccf92c9ed9; });
$parcel$export(module.exports, "it", function () { return $32e31499ba21895f$export$3486a10f30cf1ee4; });
$parcel$export(module.exports, "ja", function () { return $32e31499ba21895f$export$8c6f505e9474ce90; });
$parcel$export(module.exports, "ko", function () { return $32e31499ba21895f$export$798cf677954c9533; });
$parcel$export(module.exports, "lo", function () { return $32e31499ba21895f$export$bb2182dfba3e387a; });
$parcel$export(module.exports, "lt", function () { return $32e31499ba21895f$export$b961576059b7aeb6; });
$parcel$export(module.exports, "lv", function () { return $32e31499ba21895f$export$54ca4d1eb7926f1; });
$parcel$export(module.exports, "ms", function () { return $32e31499ba21895f$export$5dd2165da01bec80; });
$parcel$export(module.exports, "nl", function () { return $32e31499ba21895f$export$9c64ee4d84d79ce1; });
$parcel$export(module.exports, "no", function () { return $32e31499ba21895f$export$401451a107dc42ce; });
$parcel$export(module.exports, "pl", function () { return $32e31499ba21895f$export$6ea5311eda92944f; });
$parcel$export(module.exports, "pt", function () { return $32e31499ba21895f$export$84175d5f1cb4e39d; });
$parcel$export(module.exports, "ro", function () { return $32e31499ba21895f$export$ea30ec7f37fb148d; });
$parcel$export(module.exports, "ru", function () { return $32e31499ba21895f$export$cf48009033a0126b; });
$parcel$export(module.exports, "sk", function () { return $32e31499ba21895f$export$d608fa5b5bfd2021; });
$parcel$export(module.exports, "sv", function () { return $32e31499ba21895f$export$65540e5f7f6e7dce; });
$parcel$export(module.exports, "tr", function () { return $32e31499ba21895f$export$72451b88a72ad9c2; });
$parcel$export(module.exports, "uk", function () { return $32e31499ba21895f$export$312745a8a3013c00; });
$parcel$export(module.exports, "ur", function () { return $32e31499ba21895f$export$bde472100d10f4c2; });
$parcel$export(module.exports, "vi", function () { return $32e31499ba21895f$export$e3786bf10a8abdf2; });
$parcel$export(module.exports, "zhCN", function () { return $32e31499ba21895f$export$836e793ad054f4a7; });
$parcel$export(module.exports, "zhTW", function () { return $32e31499ba21895f$export$3991fdf1bb6f66b9; });
$parcel$export(module.exports, "isoDuration", function () { return $32e31499ba21895f$export$b097d39b3dd34935; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ var $32e31499ba21895f$var$__assign = function() {
    $32e31499ba21895f$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $32e31499ba21895f$var$__assign.apply(this, arguments);
};
/**
 * The pattern used for parsing ISO8601 duration (PnYnMnDTnHnMnS).
 */ // PnYnMnDTnHnMnS || PnW
var $32e31499ba21895f$var$numbers = "\\d+(?:[\\.,]\\d+)?";
var $32e31499ba21895f$var$weekPattern = "(" + $32e31499ba21895f$var$numbers + "W)";
var $32e31499ba21895f$var$datePattern = "(" + $32e31499ba21895f$var$numbers + "Y)?(" + $32e31499ba21895f$var$numbers + "M)?(" + $32e31499ba21895f$var$numbers + "D)?";
var $32e31499ba21895f$var$timePattern = "T(" + $32e31499ba21895f$var$numbers + "H)?(" + $32e31499ba21895f$var$numbers + "M)?(" + $32e31499ba21895f$var$numbers + "S)?";
var $32e31499ba21895f$var$iso8601 = "^P(?:" + $32e31499ba21895f$var$weekPattern + "|" + $32e31499ba21895f$var$datePattern + "(?:" + $32e31499ba21895f$var$timePattern + ")?)$";
/**
 * The ISO8601 regex for matching / testing durations
 */ var $32e31499ba21895f$var$pattern = new RegExp($32e31499ba21895f$var$iso8601);
var $32e31499ba21895f$var$durationKeys = [
    "weeks",
    "years",
    "months",
    "days",
    "hours",
    "minutes",
    "seconds"
];
var $32e31499ba21895f$var$durationUnitToIsoKey = {
    years: "Y",
    months: "M",
    days: "D",
    hours: "H",
    minutes: "M",
    seconds: "S",
    weeks: "W"
};
var $32e31499ba21895f$var$durationZero = Object.freeze({
    weeks: 0,
    years: 0,
    months: 0,
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
});
/** Parse PnYnMnDTnHnMnS format to object
 * @param {string} durationString - PnYnMnDTnHnMnS or PnW formatted string
 * @return {Object} - With a property for each part of the pattern
 */ var $32e31499ba21895f$var$parseIsoString = function(durationString) {
    var durationMatchedPattern = durationString.match($32e31499ba21895f$var$pattern);
    if (!durationMatchedPattern) throw new Error("Invalid duration string");
    var parsed = durationMatchedPattern.slice(1).reduce(function(prev, next, idx) {
        prev[$32e31499ba21895f$var$durationKeys[idx]] = parseFloat(next) || 0;
        return prev;
    }, {});
    return parsed;
};
/** Normalize not completed Partial DurationObj to DurationObj;
 * ex: { days: 1, not_supported_key: 'bar' } => { years: 0, months: 0 days: 1, hours: 0, minutes: 0, seconds: 0 }
 * @param partialDurationObj
 */ var $32e31499ba21895f$var$normalizeDurationObj = function(partialDurationObj) {
    if (partialDurationObj.weeks && partialDurationObj.weeks > 0) return Object.assign({}, $32e31499ba21895f$var$durationZero, {
        weeks: partialDurationObj.weeks
    });
    return $32e31499ba21895f$var$durationKeys.reduce(function(res, key) {
        var _a;
        return $32e31499ba21895f$var$__assign($32e31499ba21895f$var$__assign({}, res), (_a = {}, _a[key] = partialDurationObj[key] || 0, _a));
    }, {});
};
var $32e31499ba21895f$var$config = {
    locales: {},
    options: {},
    setLocales: function(locales, options) {
        this.locales = $32e31499ba21895f$var$__assign($32e31499ba21895f$var$__assign({}, this.locales), locales);
        if (options) this.options = $32e31499ba21895f$var$__assign($32e31499ba21895f$var$__assign({}, this.options), options);
    },
    getLangConfig: function(lang) {
        var localesConfig = this.locales[lang];
        if (!localesConfig && this.options.fallbackLocale) localesConfig = this.locales[this.options.fallbackLocale];
        if (!localesConfig) throw new Error("isoDuration: Translations for language: " + lang + " are not provided");
        return localesConfig;
    }
};
var $32e31499ba21895f$var$getIsoDateElements = function(durationObj) {
    var isoItems = [
        "years",
        "months",
        "days"
    ];
    var isoDate = "";
    for(var _i = 0, isoItems_1 = isoItems; _i < isoItems_1.length; _i++){
        var item = isoItems_1[_i];
        if (durationObj[item]) isoDate += "" + durationObj[item] + $32e31499ba21895f$var$durationUnitToIsoKey[item];
    }
    return isoDate;
};
var $32e31499ba21895f$var$getIsoTimeElements = function(durationObj) {
    var isoItems = [
        "hours",
        "minutes",
        "seconds"
    ];
    var isoDate = "";
    for(var _i = 0, isoItems_2 = isoItems; _i < isoItems_2.length; _i++){
        var item = isoItems_2[_i];
        if (durationObj[item]) isoDate += "" + durationObj[item] + $32e31499ba21895f$var$durationUnitToIsoKey[item];
    }
    return isoDate;
};
var $32e31499ba21895f$var$durationObjToString = function(durationObj) {
    if (durationObj.weeks > 0) return "P" + durationObj.weeks + "W";
    else {
        var durationIsoString = "P";
        var isoDateElement = $32e31499ba21895f$var$getIsoDateElements(durationObj);
        if (isoDateElement) durationIsoString += isoDateElement;
        var isoTimeElement = $32e31499ba21895f$var$getIsoTimeElements(durationObj);
        if (isoTimeElement) durationIsoString += "T" + isoTimeElement;
        if (!isoDateElement && !isoTimeElement) durationIsoString += "0D";
        return durationIsoString;
    }
};
var $32e31499ba21895f$var$humanizeWeek = function(durationObj, lang) {
    var localeConfig = $32e31499ba21895f$var$config.getLangConfig(lang);
    return durationObj.weeks + " " + localeConfig.weeks(durationObj.weeks);
};
var $32e31499ba21895f$var$humanizeDate = function(durationObj, lang, humanizeConfig) {
    var localeConfig = $32e31499ba21895f$var$config.getLangConfig(lang);
    var humanizedTime = "";
    var humanizeOrder = [
        "years",
        "months",
        "days",
        "hours",
        "minutes",
        "seconds"
    ];
    var numOfHumanizedUnits = 0;
    for(var index = 0; index < humanizeOrder.length; index++){
        var item = humanizeOrder[index];
        var unitDuration = durationObj[item];
        if (unitDuration) {
            if (humanizedTime !== "") humanizedTime += " ";
            humanizedTime += unitDuration + " " + localeConfig[item](unitDuration);
            numOfHumanizedUnits++;
            if (humanizeConfig && humanizeConfig.largest && humanizeConfig.largest <= numOfHumanizedUnits) break;
        }
    }
    return humanizedTime;
};
var $32e31499ba21895f$var$humanize = function(durationObj, lang, humanizeConfig) {
    if (durationObj.weeks > 0) return $32e31499ba21895f$var$humanizeWeek(durationObj, lang);
    else return $32e31499ba21895f$var$humanizeDate(durationObj, lang, humanizeConfig);
};
var $32e31499ba21895f$var$normalizeOrder = [
    "seconds",
    "minutes",
    "hours",
    "days",
    "months"
];
var $32e31499ba21895f$var$getNormalizer = function(maxValue) {
    return function(val) {
        return {
            nextUnitValue: Math.floor(val / maxValue),
            value: val % maxValue
        };
    };
};
var $32e31499ba21895f$var$getDaysInMonth = function(month, year) {
    return new Date(year, month + 1, 0).getDate();
};
var $32e31499ba21895f$var$unitNormalizer = {
    seconds: $32e31499ba21895f$var$getNormalizer(60),
    minutes: $32e31499ba21895f$var$getNormalizer(60),
    hours: $32e31499ba21895f$var$getNormalizer(24),
    days: function(val, date) {
        var helperDate = date ? new Date(date.getTime()) : new Date();
        var days = val;
        var fullMonths = 0;
        var daysInMonth = $32e31499ba21895f$var$getDaysInMonth(helperDate.getMonth(), helperDate.getFullYear());
        while(days > daysInMonth){
            days = days - daysInMonth;
            fullMonths++;
            helperDate.setMonth(helperDate.getMonth() + 1);
            daysInMonth = $32e31499ba21895f$var$getDaysInMonth(helperDate.getMonth(), helperDate.getFullYear());
        }
        return {
            nextUnitValue: fullMonths,
            value: days
        };
    },
    months: $32e31499ba21895f$var$getNormalizer(12)
};
var $32e31499ba21895f$var$normalize = function(duration, date) {
    var normalizedDuration = $32e31499ba21895f$var$__assign({}, duration);
    for(var i = 0; i < $32e31499ba21895f$var$normalizeOrder.length; i++){
        var unit = $32e31499ba21895f$var$normalizeOrder[i];
        var unitValue = normalizedDuration[unit];
        if (unitValue > 0) {
            var temp = $32e31499ba21895f$var$unitNormalizer[unit](unitValue, date);
            normalizedDuration[unit] = temp.value;
            if (temp.nextUnitValue) {
                var nextUnit = unit === "months" ? "years" : $32e31499ba21895f$var$normalizeOrder[i + 1];
                normalizedDuration[nextUnit] = normalizedDuration[nextUnit] + temp.nextUnitValue;
            }
        }
    }
    return normalizedDuration;
};
var $32e31499ba21895f$var$IsoDuration = /** @class */ function() {
    function IsoDuration(durationObj) {
        this.durationObj = durationObj;
    }
    IsoDuration.prototype.parse = function() {
        return this.durationObj;
    };
    IsoDuration.prototype.toString = function() {
        return $32e31499ba21895f$var$durationObjToString(this.durationObj);
    };
    IsoDuration.prototype.humanize = function(lang, config) {
        return $32e31499ba21895f$var$humanize(this.durationObj, lang, config);
    };
    IsoDuration.prototype.normalize = function(date) {
        this.durationObj = $32e31499ba21895f$var$normalize(this.durationObj, date);
        return this;
    };
    IsoDuration.prototype.isEmpty = function() {
        var _this = this;
        return Object.keys(this.durationObj).every(function(key) {
            return _this.durationObj[key] === 0;
        });
    };
    return IsoDuration;
}();
function $32e31499ba21895f$var$getArabicForm(c) {
    if (c <= 2) return 0;
    if (c > 2 && c < 11) return 1;
    return 0;
}
var $32e31499ba21895f$export$d24c54395ce0c509 = {
    years: function(c) {
        return c === 1 ? "\u0633\u0646\u0629" : "\u0633\u0646\u0648\u0627\u062A";
    },
    months: function(c) {
        return c === 1 ? "\u0634\u0647\u0631" : "\u0623\u0634\u0647\u0631";
    },
    weeks: function(c) {
        return c === 1 ? "\u0623\u0633\u0628\u0648\u0639" : "\u0623\u0633\u0627\u0628\u064A\u0639";
    },
    days: function(c) {
        return c === 1 ? "\u064A\u0648\u0645" : "\u0623\u064A\u0627\u0645";
    },
    hours: function(c) {
        return c === 1 ? "\u0633\u0627\u0639\u0629" : "\u0633\u0627\u0639\u0627\u062A";
    },
    minutes: function(c) {
        return [
            "\u062F\u0642\u064A\u0642\u0629",
            "\u062F\u0642\u0627\u0626\u0642"
        ][$32e31499ba21895f$var$getArabicForm(c)];
    },
    seconds: function(c) {
        return c === 1 ? "\u062B\u0627\u0646\u064A\u0629" : "\u062B\u0648\u0627\u0646\u064A";
    },
    decimal: ","
};
function $32e31499ba21895f$var$getSlavicForm(c) {
    if (Math.floor(c) !== c) return 2;
    else if (c % 100 >= 5 && c % 100 <= 20 || c % 10 >= 5 && c % 10 <= 9 || c % 10 === 0) return 0;
    else if (c % 10 === 1) return 1;
    else if (c > 1) return 2;
    else return 0;
}
var $32e31499ba21895f$export$136fd86de524d3c2 = {
    years: function(c) {
        return [
            "\u0433\u043E\u0434\u0438\u043D\u0438",
            "\u0433\u043E\u0434\u0438\u043D\u0430",
            "\u0433\u043E\u0434\u0438\u043D\u0438"
        ][$32e31499ba21895f$var$getSlavicForm(c)];
    },
    months: function(c) {
        return [
            "\u043C\u0435\u0441\u0435\u0446\u0430",
            "\u043C\u0435\u0441\u0435\u0446",
            "\u043C\u0435\u0441\u0435\u0446\u0430"
        ][$32e31499ba21895f$var$getSlavicForm(c)];
    },
    weeks: function(c) {
        return [
            "\u0441\u0435\u0434\u043C\u0438\u0446\u0438",
            "\u0441\u0435\u0434\u043C\u0438\u0446\u0430",
            "\u0441\u0435\u0434\u043C\u0438\u0446\u0438"
        ][$32e31499ba21895f$var$getSlavicForm(c)];
    },
    days: function(c) {
        return [
            "\u0434\u043D\u0438",
            "\u0434\u0435\u043D",
            "\u0434\u043D\u0438"
        ][$32e31499ba21895f$var$getSlavicForm(c)];
    },
    hours: function(c) {
        return [
            "\u0447\u0430\u0441\u0430",
            "\u0447\u0430\u0441",
            "\u0447\u0430\u0441\u0430"
        ][$32e31499ba21895f$var$getSlavicForm(c)];
    },
    minutes: function(c) {
        return [
            "\u043C\u0438\u043D\u0443\u0442\u0438",
            "\u043C\u0438\u043D\u0443\u0442\u0430",
            "\u043C\u0438\u043D\u0443\u0442\u0438"
        ][$32e31499ba21895f$var$getSlavicForm(c)];
    },
    seconds: function(c) {
        return [
            "\u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            "\u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            "\u0441\u0435\u043A\u0443\u043D\u0434\u0438"
        ][$32e31499ba21895f$var$getSlavicForm(c)];
    },
    decimal: ","
};
var $32e31499ba21895f$export$89e9012e902952b6 = {
    years: function(c) {
        return "any" + (c === 1 ? "" : "s");
    },
    months: function(c) {
        return "mes" + (c === 1 ? "" : "os");
    },
    weeks: function(c) {
        return "setman" + (c === 1 ? "a" : "es");
    },
    days: function(c) {
        return "di" + (c === 1 ? "a" : "es");
    },
    hours: function(c) {
        return "hor" + (c === 1 ? "a" : "es");
    },
    minutes: function(c) {
        return "minut" + (c === 1 ? "" : "s");
    },
    seconds: function(c) {
        return "segon" + (c === 1 ? "" : "s");
    },
    decimal: ","
};
function $32e31499ba21895f$var$getCzechOrSlovakForm(c) {
    if (c === 1) return 0;
    else if (Math.floor(c) !== c) return 1;
    else if (c % 10 >= 2 && c % 10 <= 4 && c % 100 < 10) return 2;
    else return 3;
}
var $32e31499ba21895f$export$bde1ed0f60b38f2f = {
    years: function(c) {
        return [
            "rok",
            "roku",
            "roky",
            "let"
        ][$32e31499ba21895f$var$getCzechOrSlovakForm(c)];
    },
    months: function(c) {
        return [
            "m\u011Bs\xedc",
            "m\u011Bs\xedce",
            "m\u011Bs\xedce",
            "m\u011Bs\xedc\u016F"
        ][$32e31499ba21895f$var$getCzechOrSlovakForm(c)];
    },
    weeks: function(c) {
        return [
            "t\xfdden",
            "t\xfddne",
            "t\xfddny",
            "t\xfddn\u016F"
        ][$32e31499ba21895f$var$getCzechOrSlovakForm(c)];
    },
    days: function(c) {
        return [
            "den",
            "dne",
            "dny",
            "dn\xed"
        ][$32e31499ba21895f$var$getCzechOrSlovakForm(c)];
    },
    hours: function(c) {
        return [
            "hodina",
            "hodiny",
            "hodiny",
            "hodin"
        ][$32e31499ba21895f$var$getCzechOrSlovakForm(c)];
    },
    minutes: function(c) {
        return [
            "minuta",
            "minuty",
            "minuty",
            "minut"
        ][$32e31499ba21895f$var$getCzechOrSlovakForm(c)];
    },
    seconds: function(c) {
        return [
            "sekunda",
            "sekundy",
            "sekundy",
            "sekund"
        ][$32e31499ba21895f$var$getCzechOrSlovakForm(c)];
    },
    decimal: ","
};
var $32e31499ba21895f$export$8c8450b83b664ba4 = {
    years: function() {
        return "\xe5r";
    },
    months: function(c) {
        return "m\xe5ned" + (c === 1 ? "" : "er");
    },
    weeks: function(c) {
        return "uge" + (c === 1 ? "" : "r");
    },
    days: function(c) {
        return "dag" + (c === 1 ? "" : "e");
    },
    hours: function(c) {
        return "time" + (c === 1 ? "" : "r");
    },
    minutes: function(c) {
        return "minut" + (c === 1 ? "" : "ter");
    },
    seconds: function(c) {
        return "sekund" + (c === 1 ? "" : "er");
    },
    decimal: ","
};
var $32e31499ba21895f$export$2fa162a495d26869 = {
    years: function(c) {
        return "Jahr" + (c === 1 ? "" : "e");
    },
    months: function(c) {
        return "Monat" + (c === 1 ? "" : "e");
    },
    weeks: function(c) {
        return "Woche" + (c === 1 ? "" : "n");
    },
    days: function(c) {
        return "Tag" + (c === 1 ? "" : "e");
    },
    hours: function(c) {
        return "Stunde" + (c === 1 ? "" : "n");
    },
    minutes: function(c) {
        return "Minute" + (c === 1 ? "" : "n");
    },
    seconds: function(c) {
        return "Sekunde" + (c === 1 ? "" : "n");
    },
    decimal: ","
};
var $32e31499ba21895f$export$84584c2a98eb6753 = {
    years: function(c) {
        return "year" + (c === 1 ? "" : "s");
    },
    months: function(c) {
        return "month" + (c === 1 ? "" : "s");
    },
    weeks: function(c) {
        return "week" + (c === 1 ? "" : "s");
    },
    days: function(c) {
        return "day" + (c === 1 ? "" : "s");
    },
    hours: function(c) {
        return "hour" + (c === 1 ? "" : "s");
    },
    minutes: function(c) {
        return "minute" + (c === 1 ? "" : "s");
    },
    seconds: function(c) {
        return "second" + (c === 1 ? "" : "s");
    },
    decimal: "."
};
var $32e31499ba21895f$export$ca5e4045a55e76d2 = {
    years: function(c) {
        return "a\xf1o" + (c === 1 ? "" : "s");
    },
    months: function(c) {
        return "mes" + (c === 1 ? "" : "es");
    },
    weeks: function(c) {
        return "semana" + (c === 1 ? "" : "s");
    },
    days: function(c) {
        return "d\xeda" + (c === 1 ? "" : "s");
    },
    hours: function(c) {
        return "hora" + (c === 1 ? "" : "s");
    },
    minutes: function(c) {
        return "minuto" + (c === 1 ? "" : "s");
    },
    seconds: function(c) {
        return "segundo" + (c === 1 ? "" : "s");
    },
    decimal: ","
};
var $32e31499ba21895f$export$457177dcde8472be = {
    years: function(c) {
        return "aasta" + (c === 1 ? "" : "t");
    },
    months: function(c) {
        return "kuu" + (c === 1 ? "" : "d");
    },
    weeks: function(c) {
        return "n\xe4dal" + (c === 1 ? "" : "at");
    },
    days: function(c) {
        return "p\xe4ev" + (c === 1 ? "" : "a");
    },
    hours: function(c) {
        return "tund" + (c === 1 ? "" : "i");
    },
    minutes: function(c) {
        return "minut" + (c === 1 ? "" : "it");
    },
    seconds: function(c) {
        return "sekund" + (c === 1 ? "" : "it");
    },
    decimal: ","
};
var $32e31499ba21895f$export$48a262eaf0aadda2 = {
    years: function() {
        return "\u0633\u0627\u0644";
    },
    months: function() {
        return "\u0645\u0627\u0647";
    },
    weeks: function() {
        return "\u0647\u0641\u062A\u0647";
    },
    days: function() {
        return "\u0631\u0648\u0632";
    },
    hours: function() {
        return "\u0633\u0627\u0639\u062A";
    },
    minutes: function() {
        return "\u062F\u0642\u06CC\u0642\u0647";
    },
    seconds: function() {
        return "\u062B\u0627\u0646\u06CC\u0647";
    },
    decimal: "."
};
var $32e31499ba21895f$export$ed5179c818622fb = {
    years: function(c) {
        return c === 1 ? "vuosi" : "vuotta";
    },
    months: function(c) {
        return c === 1 ? "kuukausi" : "kuukautta";
    },
    weeks: function(c) {
        return "viikko" + (c === 1 ? "" : "a");
    },
    days: function(c) {
        return "p\xe4iv\xe4" + (c === 1 ? "" : "\xe4");
    },
    hours: function(c) {
        return "tunti" + (c === 1 ? "" : "a");
    },
    minutes: function(c) {
        return "minuutti" + (c === 1 ? "" : "a");
    },
    seconds: function(c) {
        return "sekunti" + (c === 1 ? "" : "a");
    },
    decimal: ","
};
var $32e31499ba21895f$export$8979478257f87fe6 = {
    years: function() {
        return "\xe1r";
    },
    months: function(c) {
        return c === 1 ? "m\xe1na\xf0ur" : "m\xe1na\xf0ir";
    },
    weeks: function(c) {
        return c === 1 ? "vika" : "vikur";
    },
    days: function(c) {
        return c === 1 ? "dagur" : "dagar";
    },
    hours: function(c) {
        return c === 1 ? "t\xedmi" : "t\xedmar";
    },
    minutes: function(c) {
        return c === 1 ? "minuttur" : "minuttir";
    },
    seconds: function() {
        return "sekund";
    },
    decimal: ","
};
var $32e31499ba21895f$export$acb2a88f7d552ebf = {
    years: function(c) {
        return "an" + (c >= 2 ? "s" : "");
    },
    months: function() {
        return "mois";
    },
    weeks: function(c) {
        return "semaine" + (c >= 2 ? "s" : "");
    },
    days: function(c) {
        return "jour" + (c >= 2 ? "s" : "");
    },
    hours: function(c) {
        return "heure" + (c >= 2 ? "s" : "");
    },
    minutes: function(c) {
        return "minute" + (c >= 2 ? "s" : "");
    },
    seconds: function(c) {
        return "seconde" + (c >= 2 ? "s" : "");
    },
    decimal: ","
};
var $32e31499ba21895f$export$d911550c75100362 = {
    years: function(c) {
        return c === 1 ? "\u03C7\u03C1\u03CC\u03BD\u03BF\u03C2" : "\u03C7\u03C1\u03CC\u03BD\u03B9\u03B1";
    },
    months: function(c) {
        return c === 1 ? "\u03BC\u03AE\u03BD\u03B1\u03C2" : "\u03BC\u03AE\u03BD\u03B5\u03C2";
    },
    weeks: function(c) {
        return c === 1 ? "\u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B1" : "\u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B5\u03C2";
    },
    days: function(c) {
        return c === 1 ? "\u03BC\u03AD\u03C1\u03B1" : "\u03BC\u03AD\u03C1\u03B5\u03C2";
    },
    hours: function(c) {
        return c === 1 ? "\u03CE\u03C1\u03B1" : "\u03CE\u03C1\u03B5\u03C2";
    },
    minutes: function(c) {
        return c === 1 ? "\u03BB\u03B5\u03C0\u03C4\u03CC" : "\u03BB\u03B5\u03C0\u03C4\u03AC";
    },
    seconds: function(c) {
        return c === 1 ? "\u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03BF" : "\u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03B1";
    },
    decimal: ","
};
var $32e31499ba21895f$export$10cc7d172bb7969 = {
    years: function(c) {
        return c === 1 ? "\u05E9\u05E0\u05D4" : "\u05E9\u05E0\u05D9\u05DD";
    },
    months: function(c) {
        return c === 1 ? "\u05D7\u05D5\u05D3\u05E9" : "\u05D7\u05D5\u05D3\u05E9\u05D9\u05DD";
    },
    weeks: function(c) {
        return c === 1 ? "\u05E9\u05D1\u05D5\u05E2" : "\u05E9\u05D1\u05D5\u05E2\u05D5\u05EA";
    },
    days: function(c) {
        return c === 1 ? "\u05D9\u05D5\u05DD" : "\u05D9\u05DE\u05D9\u05DD";
    },
    hours: function(c) {
        return c === 1 ? "\u05E9\u05E2\u05D4" : "\u05E9\u05E2\u05D5\u05EA";
    },
    minutes: function(c) {
        return c === 1 ? "\u05D3\u05E7\u05D4" : "\u05D3\u05E7\u05D5\u05EA";
    },
    seconds: function(c) {
        return c === 1 ? "\u05E9\u05E0\u05D9\u05D4" : "\u05E9\u05E0\u05D9\u05D5\u05EA";
    },
    decimal: "."
};
var $32e31499ba21895f$export$b4adb3f464574dcf = {
    years: function(c) {
        if (c % 10 === 2 || c % 10 === 3 || c % 10 === 4) return "godine";
        return "godina";
    },
    months: function(c) {
        if (c === 1) return "mjesec";
        else if (c === 2 || c === 3 || c === 4) return "mjeseca";
        return "mjeseci";
    },
    weeks: function(c) {
        if (c % 10 === 1 && c !== 11) return "tjedan";
        return "tjedna";
    },
    days: function(c) {
        return c === 1 ? "dan" : "dana";
    },
    hours: function(c) {
        if (c === 1) return "sat";
        else if (c === 2 || c === 3 || c === 4) return "sata";
        return "sati";
    },
    minutes: function(c) {
        var mod10 = c % 10;
        if ((mod10 === 2 || mod10 === 3 || mod10 === 4) && (c < 10 || c > 14)) return "minute";
        return "minuta";
    },
    seconds: function(c) {
        if (c === 10 || c === 11 || c === 12 || c === 13 || c === 14 || c === 16 || c === 17 || c === 18 || c === 19 || c % 10 === 5) return "sekundi";
        else if (c % 10 === 1) return "sekunda";
        else if (c % 10 === 2 || c % 10 === 3 || c % 10 === 4) return "sekunde";
        return "sekundi";
    },
    decimal: ","
};
var $32e31499ba21895f$export$9901d21957972d53 = {
    years: function() {
        return "\xe9v";
    },
    months: function() {
        return "h\xf3nap";
    },
    weeks: function() {
        return "h\xe9t";
    },
    days: function() {
        return "nap";
    },
    hours: function() {
        return "\xf3ra";
    },
    minutes: function() {
        return "perc";
    },
    seconds: function() {
        return "m\xe1sodperc";
    },
    decimal: ","
};
var $32e31499ba21895f$export$226b3eccf92c9ed9 = {
    years: function() {
        return "\xe1r";
    },
    months: function(c) {
        return "m\xe1nu\xf0" + (c === 1 ? "ur" : "ir");
    },
    weeks: function(c) {
        return "vik" + (c === 1 ? "a" : "ur");
    },
    days: function(c) {
        return "dag" + (c === 1 ? "ur" : "ar");
    },
    hours: function(c) {
        return "klukkut\xedm" + (c === 1 ? "i" : "ar");
    },
    minutes: function(c) {
        return "m\xedn\xfat" + (c === 1 ? "a" : "ur");
    },
    seconds: function(c) {
        return "sek\xfand" + (c === 1 ? "a" : "ur");
    },
    decimal: "."
};
var $32e31499ba21895f$export$3486a10f30cf1ee4 = {
    years: function(c) {
        return "ann" + (c === 1 ? "o" : "i");
    },
    months: function(c) {
        return "mes" + (c === 1 ? "e" : "i");
    },
    weeks: function(c) {
        return "settiman" + (c === 1 ? "a" : "e");
    },
    days: function(c) {
        return "giorn" + (c === 1 ? "o" : "i");
    },
    hours: function(c) {
        return "or" + (c === 1 ? "a" : "e");
    },
    minutes: function(c) {
        return "minut" + (c === 1 ? "o" : "i");
    },
    seconds: function(c) {
        return "second" + (c === 1 ? "o" : "i");
    },
    decimal: ","
};
var $32e31499ba21895f$export$8c6f505e9474ce90 = {
    years: function() {
        return "\u5E74";
    },
    months: function() {
        return "\u6708";
    },
    weeks: function() {
        return "\u9031";
    },
    days: function() {
        return "\u65E5";
    },
    hours: function() {
        return "\u6642\u9593";
    },
    minutes: function() {
        return "\u5206";
    },
    seconds: function() {
        return "\u79D2";
    },
    decimal: "."
};
var $32e31499ba21895f$export$798cf677954c9533 = {
    years: function() {
        return "\uB144";
    },
    months: function() {
        return "\uAC1C\uC6D4";
    },
    weeks: function() {
        return "\uC8FC\uC77C";
    },
    days: function() {
        return "\uC77C";
    },
    hours: function() {
        return "\uC2DC\uAC04";
    },
    minutes: function() {
        return "\uBD84";
    },
    seconds: function() {
        return "\uCD08";
    },
    decimal: "."
};
var $32e31499ba21895f$export$bb2182dfba3e387a = {
    years: function() {
        return "\u0E9B\u0EB5";
    },
    months: function() {
        return "\u0EC0\u0E94\u0EB7\u0EAD\u0E99";
    },
    weeks: function() {
        return "\u0EAD\u0EB2\u0E97\u0EB4\u0E94";
    },
    days: function() {
        return "\u0EA1\u0EB7\u0EC9";
    },
    hours: function() {
        return "\u0E8A\u0EBB\u0EC8\u0EA7\u0EC2\u0EA1\u0E87";
    },
    minutes: function() {
        return "\u0E99\u0EB2\u0E97\u0EB5";
    },
    seconds: function() {
        return "\u0EA7\u0EB4\u0E99\u0EB2\u0E97\u0EB5";
    },
    decimal: ","
};
function $32e31499ba21895f$var$getLithuanianForm(c) {
    if (c === 1 || c % 10 === 1 && c % 100 > 20) return 0;
    else if (Math.floor(c) !== c || c % 10 >= 2 && c % 100 > 20 || c % 10 >= 2 && c % 100 < 10) return 1;
    else return 2;
}
var $32e31499ba21895f$export$b961576059b7aeb6 = {
    years: function(c) {
        return c % 10 === 0 || c % 100 >= 10 && c % 100 <= 20 ? "met\u0173" : "metai";
    },
    months: function(c) {
        return [
            "m\u0117nuo",
            "m\u0117nesiai",
            "m\u0117nesi\u0173"
        ][$32e31499ba21895f$var$getLithuanianForm(c)];
    },
    weeks: function(c) {
        return [
            "savait\u0117",
            "savait\u0117s",
            "savai\u010Di\u0173"
        ][$32e31499ba21895f$var$getLithuanianForm(c)];
    },
    days: function(c) {
        return [
            "diena",
            "dienos",
            "dien\u0173"
        ][$32e31499ba21895f$var$getLithuanianForm(c)];
    },
    hours: function(c) {
        return [
            "valanda",
            "valandos",
            "valand\u0173"
        ][$32e31499ba21895f$var$getLithuanianForm(c)];
    },
    minutes: function(c) {
        return [
            "minut\u0117",
            "minut\u0117s",
            "minu\u010Di\u0173"
        ][$32e31499ba21895f$var$getLithuanianForm(c)];
    },
    seconds: function(c) {
        return [
            "sekund\u0117",
            "sekund\u0117s",
            "sekund\u017Ei\u0173"
        ][$32e31499ba21895f$var$getLithuanianForm(c)];
    },
    decimal: ","
};
function $32e31499ba21895f$var$getLatvianForm(c) {
    if (c === 1 || c % 10 === 1 && c % 100 !== 11) return 0;
    else return 1;
}
var $32e31499ba21895f$export$54ca4d1eb7926f1 = {
    years: function(c) {
        return [
            "gads",
            "gadi"
        ][$32e31499ba21895f$var$getLatvianForm(c)];
    },
    months: function(c) {
        return [
            "m\u0113nesis",
            "m\u0113ne\u0161i"
        ][$32e31499ba21895f$var$getLatvianForm(c)];
    },
    weeks: function(c) {
        return [
            "ned\u0113\u013Ca",
            "ned\u0113\u013Cas"
        ][$32e31499ba21895f$var$getLatvianForm(c)];
    },
    days: function(c) {
        return [
            "diena",
            "dienas"
        ][$32e31499ba21895f$var$getLatvianForm(c)];
    },
    hours: function(c) {
        return [
            "stunda",
            "stundas"
        ][$32e31499ba21895f$var$getLatvianForm(c)];
    },
    minutes: function(c) {
        return [
            "min\u016Bte",
            "min\u016Btes"
        ][$32e31499ba21895f$var$getLatvianForm(c)];
    },
    seconds: function(c) {
        return [
            "sekunde",
            "sekundes"
        ][$32e31499ba21895f$var$getLatvianForm(c)];
    },
    decimal: ","
};
var $32e31499ba21895f$export$5dd2165da01bec80 = {
    years: function() {
        return "tahun";
    },
    months: function() {
        return "bulan";
    },
    weeks: function() {
        return "minggu";
    },
    days: function() {
        return "hari";
    },
    hours: function() {
        return "jam";
    },
    minutes: function() {
        return "minit";
    },
    seconds: function() {
        return "saat";
    },
    decimal: "."
};
var $32e31499ba21895f$export$9c64ee4d84d79ce1 = {
    years: function() {
        return "jaar";
    },
    months: function(c) {
        return c === 1 ? "maand" : "maanden";
    },
    weeks: function(c) {
        return c === 1 ? "week" : "weken";
    },
    days: function(c) {
        return c === 1 ? "dag" : "dagen";
    },
    hours: function() {
        return "uur";
    },
    minutes: function(c) {
        return c === 1 ? "minuut" : "minuten";
    },
    seconds: function(c) {
        return c === 1 ? "seconde" : "seconden";
    },
    decimal: ","
};
var $32e31499ba21895f$export$401451a107dc42ce = {
    years: function() {
        return "\xe5r";
    },
    months: function(c) {
        return "m\xe5ned" + (c === 1 ? "" : "er");
    },
    weeks: function(c) {
        return "uke" + (c === 1 ? "" : "r");
    },
    days: function(c) {
        return "dag" + (c === 1 ? "" : "er");
    },
    hours: function(c) {
        return "time" + (c === 1 ? "" : "r");
    },
    minutes: function(c) {
        return "minutt" + (c === 1 ? "" : "er");
    },
    seconds: function(c) {
        return "sekund" + (c === 1 ? "" : "er");
    },
    decimal: ","
};
function $32e31499ba21895f$var$getPolishForm(c) {
    if (c === 1) return 0;
    else if (Math.floor(c) !== c) return 1;
    else if (c % 10 >= 2 && c % 10 <= 4 && !(c % 100 > 10 && c % 100 < 20)) return 2;
    else return 3;
}
var $32e31499ba21895f$export$6ea5311eda92944f = {
    years: function(c) {
        return [
            "rok",
            "roku",
            "lata",
            "lat"
        ][$32e31499ba21895f$var$getPolishForm(c)];
    },
    months: function(c) {
        return [
            "miesi\u0105c",
            "miesi\u0105ca",
            "miesi\u0105ce",
            "miesi\u0119cy"
        ][$32e31499ba21895f$var$getPolishForm(c)];
    },
    weeks: function(c) {
        return [
            "tydzie\u0144",
            "tygodnia",
            "tygodnie",
            "tygodni"
        ][$32e31499ba21895f$var$getPolishForm(c)];
    },
    days: function(c) {
        return [
            "dzie\u0144",
            "dnia",
            "dni",
            "dni"
        ][$32e31499ba21895f$var$getPolishForm(c)];
    },
    hours: function(c) {
        return [
            "godzina",
            "godziny",
            "godziny",
            "godzin"
        ][$32e31499ba21895f$var$getPolishForm(c)];
    },
    minutes: function(c) {
        return [
            "minuta",
            "minuty",
            "minuty",
            "minut"
        ][$32e31499ba21895f$var$getPolishForm(c)];
    },
    seconds: function(c) {
        return [
            "sekunda",
            "sekundy",
            "sekundy",
            "sekund"
        ][$32e31499ba21895f$var$getPolishForm(c)];
    },
    decimal: ","
};
var $32e31499ba21895f$export$84175d5f1cb4e39d = {
    years: function(c) {
        return "ano" + (c === 1 ? "" : "s");
    },
    months: function(c) {
        return c === 1 ? "m\xeas" : "meses";
    },
    weeks: function(c) {
        return "semana" + (c === 1 ? "" : "s");
    },
    days: function(c) {
        return "dia" + (c === 1 ? "" : "s");
    },
    hours: function(c) {
        return "hora" + (c === 1 ? "" : "s");
    },
    minutes: function(c) {
        return "minuto" + (c === 1 ? "" : "s");
    },
    seconds: function(c) {
        return "segundo" + (c === 1 ? "" : "s");
    },
    decimal: ","
};
var $32e31499ba21895f$export$ea30ec7f37fb148d = {
    years: function(c) {
        return c === 1 ? "an" : "ani";
    },
    months: function(c) {
        return c === 1 ? "lun\u0103" : "luni";
    },
    weeks: function(c) {
        return c === 1 ? "s\u0103pt\u0103m\xe2n\u0103" : "s\u0103pt\u0103m\xe2ni";
    },
    days: function(c) {
        return c === 1 ? "zi" : "zile";
    },
    hours: function(c) {
        return c === 1 ? "or\u0103" : "ore";
    },
    minutes: function(c) {
        return c === 1 ? "minut" : "minute";
    },
    seconds: function(c) {
        return c === 1 ? "secund\u0103" : "secunde";
    },
    decimal: ","
};
var $32e31499ba21895f$export$cf48009033a0126b = {
    years: function(c) {
        return [
            "\u043B\u0435\u0442",
            "\u0433\u043E\u0434",
            "\u0433\u043E\u0434\u0430"
        ][$32e31499ba21895f$var$getSlavicForm(c)];
    },
    months: function(c) {
        return [
            "\u043C\u0435\u0441\u044F\u0446\u0435\u0432",
            "\u043C\u0435\u0441\u044F\u0446",
            "\u043C\u0435\u0441\u044F\u0446\u0430"
        ][$32e31499ba21895f$var$getSlavicForm(c)];
    },
    weeks: function(c) {
        return [
            "\u043D\u0435\u0434\u0435\u043B\u044C",
            "\u043D\u0435\u0434\u0435\u043B\u044F",
            "\u043D\u0435\u0434\u0435\u043B\u0438"
        ][$32e31499ba21895f$var$getSlavicForm(c)];
    },
    days: function(c) {
        return [
            "\u0434\u043D\u0435\u0439",
            "\u0434\u0435\u043D\u044C",
            "\u0434\u043D\u044F"
        ][$32e31499ba21895f$var$getSlavicForm(c)];
    },
    hours: function(c) {
        return [
            "\u0447\u0430\u0441\u043E\u0432",
            "\u0447\u0430\u0441",
            "\u0447\u0430\u0441\u0430"
        ][$32e31499ba21895f$var$getSlavicForm(c)];
    },
    minutes: function(c) {
        return [
            "\u043C\u0438\u043D\u0443\u0442",
            "\u043C\u0438\u043D\u0443\u0442\u0430",
            "\u043C\u0438\u043D\u0443\u0442\u044B"
        ][$32e31499ba21895f$var$getSlavicForm(c)];
    },
    seconds: function(c) {
        return [
            "\u0441\u0435\u043A\u0443\u043D\u0434",
            "\u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            "\u0441\u0435\u043A\u0443\u043D\u0434\u044B"
        ][$32e31499ba21895f$var$getSlavicForm(c)];
    },
    decimal: ","
};
var $32e31499ba21895f$export$d608fa5b5bfd2021 = {
    years: function(c) {
        return [
            "rok",
            "roky",
            "roky",
            "rokov"
        ][$32e31499ba21895f$var$getCzechOrSlovakForm(c)];
    },
    months: function(c) {
        return [
            "mesiac",
            "mesiace",
            "mesiace",
            "mesiacov"
        ][$32e31499ba21895f$var$getCzechOrSlovakForm(c)];
    },
    weeks: function(c) {
        return [
            "t\xfd\u017Ede\u0148",
            "t\xfd\u017Edne",
            "t\xfd\u017Edne",
            "t\xfd\u017Ed\u0148ov"
        ][$32e31499ba21895f$var$getCzechOrSlovakForm(c)];
    },
    days: function(c) {
        return [
            "de\u0148",
            "dni",
            "dni",
            "dn\xed"
        ][$32e31499ba21895f$var$getCzechOrSlovakForm(c)];
    },
    hours: function(c) {
        return [
            "hodina",
            "hodiny",
            "hodiny",
            "hod\xedn"
        ][$32e31499ba21895f$var$getCzechOrSlovakForm(c)];
    },
    minutes: function(c) {
        return [
            "min\xfata",
            "min\xfaty",
            "min\xfaty",
            "min\xfat"
        ][$32e31499ba21895f$var$getCzechOrSlovakForm(c)];
    },
    seconds: function(c) {
        return [
            "sekunda",
            "sekundy",
            "sekundy",
            "sek\xfand"
        ][$32e31499ba21895f$var$getCzechOrSlovakForm(c)];
    },
    decimal: ","
};
var $32e31499ba21895f$export$65540e5f7f6e7dce = {
    years: function() {
        return "\xe5r";
    },
    months: function(c) {
        return "m\xe5nad" + (c === 1 ? "" : "er");
    },
    weeks: function(c) {
        return "veck" + (c === 1 ? "a" : "or");
    },
    days: function(c) {
        return "dag" + (c === 1 ? "" : "ar");
    },
    hours: function(c) {
        return "timm" + (c === 1 ? "e" : "ar");
    },
    minutes: function(c) {
        return "minut" + (c === 1 ? "" : "er");
    },
    seconds: function(c) {
        return "sekund" + (c === 1 ? "" : "er");
    },
    decimal: ","
};
var $32e31499ba21895f$export$72451b88a72ad9c2 = {
    years: function() {
        return "y\u0131l";
    },
    months: function() {
        return "ay";
    },
    weeks: function() {
        return "hafta";
    },
    days: function() {
        return "g\xfcn";
    },
    hours: function() {
        return "saat";
    },
    minutes: function() {
        return "dakika";
    },
    seconds: function() {
        return "saniye";
    },
    decimal: ","
};
var $32e31499ba21895f$export$312745a8a3013c00 = {
    years: function(c) {
        return [
            "\u0440\u043E\u043A\u0456\u0432",
            "\u0440\u0456\u043A",
            "\u0440\u043E\u043A\u0438"
        ][$32e31499ba21895f$var$getSlavicForm(c)];
    },
    months: function(c) {
        return [
            "\u043C\u0456\u0441\u044F\u0446\u0456\u0432",
            "\u043C\u0456\u0441\u044F\u0446\u044C",
            "\u043C\u0456\u0441\u044F\u0446\u0456"
        ][$32e31499ba21895f$var$getSlavicForm(c)];
    },
    weeks: function(c) {
        return [
            "\u0442\u0438\u0436\u043D\u0456\u0432",
            "\u0442\u0438\u0436\u0434\u0435\u043D\u044C",
            "\u0442\u0438\u0436\u043D\u0456"
        ][$32e31499ba21895f$var$getSlavicForm(c)];
    },
    days: function(c) {
        return [
            "\u0434\u043D\u0456\u0432",
            "\u0434\u0435\u043D\u044C",
            "\u0434\u043D\u0456"
        ][$32e31499ba21895f$var$getSlavicForm(c)];
    },
    hours: function(c) {
        return [
            "\u0433\u043E\u0434\u0438\u043D",
            "\u0433\u043E\u0434\u0438\u043D\u0430",
            "\u0433\u043E\u0434\u0438\u043D\u0438"
        ][$32e31499ba21895f$var$getSlavicForm(c)];
    },
    minutes: function(c) {
        return [
            "\u0445\u0432\u0438\u043B\u0438\u043D",
            "\u0445\u0432\u0438\u043B\u0438\u043D\u0430",
            "\u0445\u0432\u0438\u043B\u0438\u043D\u0438"
        ][$32e31499ba21895f$var$getSlavicForm(c)];
    },
    seconds: function(c) {
        return [
            "\u0441\u0435\u043A\u0443\u043D\u0434",
            "\u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            "\u0441\u0435\u043A\u0443\u043D\u0434\u0438"
        ][$32e31499ba21895f$var$getSlavicForm(c)];
    },
    decimal: ","
};
var $32e31499ba21895f$export$bde472100d10f4c2 = {
    years: function() {
        return "\u0633\u0627\u0644";
    },
    months: function(c) {
        return c === 1 ? "\u0645\u06C1\u06CC\u0646\u06C1" : "\u0645\u06C1\u06CC\u0646\u06D2";
    },
    weeks: function(c) {
        return c === 1 ? "\u06C1\u0641\u062A\u06C1" : "\u06C1\u0641\u062A\u06D2";
    },
    days: function() {
        return "\u062F\u0646";
    },
    hours: function(c) {
        return c === 1 ? "\u06AF\u06BE\u0646\u0679\u06C1" : "\u06AF\u06BE\u0646\u0679\u06D2";
    },
    minutes: function() {
        return "\u0645\u0646\u0679";
    },
    seconds: function() {
        return "\u0633\u06CC\u06A9\u0646\u0688";
    },
    decimal: "."
};
var $32e31499ba21895f$export$e3786bf10a8abdf2 = {
    years: function() {
        return "n\u0103m";
    },
    months: function() {
        return "th\xe1ng";
    },
    weeks: function() {
        return "tu\u1EA7n";
    },
    days: function() {
        return "ng\xe0y";
    },
    hours: function() {
        return "gi\u1EDD";
    },
    minutes: function() {
        return "ph\xfat";
    },
    seconds: function() {
        return "gi\xe2y";
    },
    decimal: ","
};
var $32e31499ba21895f$export$836e793ad054f4a7 = {
    years: function() {
        return "\u5E74";
    },
    months: function() {
        return "\u4E2A\u6708";
    },
    weeks: function() {
        return "\u5468";
    },
    days: function() {
        return "\u5929";
    },
    hours: function() {
        return "\u5C0F\u65F6";
    },
    minutes: function() {
        return "\u5206\u949F";
    },
    seconds: function() {
        return "\u79D2";
    },
    decimal: "."
};
var $32e31499ba21895f$export$3991fdf1bb6f66b9 = {
    years: function() {
        return "\u5E74";
    },
    months: function() {
        return "\u500B\u6708";
    },
    weeks: function() {
        return "\u5468";
    },
    days: function() {
        return "\u5929";
    },
    hours: function() {
        return "\u5C0F\u6642";
    },
    minutes: function() {
        return "\u5206\u9418";
    },
    seconds: function() {
        return "\u79D2";
    },
    decimal: "."
};
function $32e31499ba21895f$export$b097d39b3dd34935(duration) {
    if (typeof duration === "string") return new $32e31499ba21895f$var$IsoDuration($32e31499ba21895f$var$parseIsoString(duration));
    return new $32e31499ba21895f$var$IsoDuration($32e31499ba21895f$var$normalizeDurationObj(duration));
}
$32e31499ba21895f$export$b097d39b3dd34935.setLocales = function(obj, options) {
    $32e31499ba21895f$var$config.setLocales(obj, options);
};

});

parcelRegister("fJT3K", function(module, exports) {

$parcel$export(module.exports, "format", function () { return $b755c4a7bdc2d289$export$d9468344d3651243; }, function (v) { return $b755c4a7bdc2d289$export$d9468344d3651243 = v; });
$parcel$export(module.exports, "parse", function () { return $b755c4a7bdc2d289$export$98e6a39c04603d36; }, function (v) { return $b755c4a7bdc2d289$export$98e6a39c04603d36 = v; });
/*!
 * content-type
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */ /**
 * Module exports.
 * @public
 */ var $b755c4a7bdc2d289$export$d9468344d3651243;
var $b755c4a7bdc2d289$export$98e6a39c04603d36;
'use strict';
/**
 * RegExp to match *( ";" parameter ) in RFC 7231 sec 3.1.1.1
 *
 * parameter     = token "=" ( token / quoted-string )
 * token         = 1*tchar
 * tchar         = "!" / "#" / "$" / "%" / "&" / "'" / "*"
 *               / "+" / "-" / "." / "^" / "_" / "`" / "|" / "~"
 *               / DIGIT / ALPHA
 *               ; any VCHAR, except delimiters
 * quoted-string = DQUOTE *( qdtext / quoted-pair ) DQUOTE
 * qdtext        = HTAB / SP / %x21 / %x23-5B / %x5D-7E / obs-text
 * obs-text      = %x80-FF
 * quoted-pair   = "\" ( HTAB / SP / VCHAR / obs-text )
 */ var $b755c4a7bdc2d289$var$PARAM_REGEXP = /; *([!#$%&'*+.^_`|~0-9A-Za-z-]+) *= *("(?:[\u000b\u0020\u0021\u0023-\u005b\u005d-\u007e\u0080-\u00ff]|\\[\u000b\u0020-\u00ff])*"|[!#$%&'*+.^_`|~0-9A-Za-z-]+) */g // eslint-disable-line no-control-regex
;
var $b755c4a7bdc2d289$var$TEXT_REGEXP = /^[\u000b\u0020-\u007e\u0080-\u00ff]+$/ // eslint-disable-line no-control-regex
;
var $b755c4a7bdc2d289$var$TOKEN_REGEXP = /^[!#$%&'*+.^_`|~0-9A-Za-z-]+$/;
/**
 * RegExp to match quoted-pair in RFC 7230 sec 3.2.6
 *
 * quoted-pair = "\" ( HTAB / SP / VCHAR / obs-text )
 * obs-text    = %x80-FF
 */ var $b755c4a7bdc2d289$var$QESC_REGEXP = /\\([\u000b\u0020-\u00ff])/g // eslint-disable-line no-control-regex
;
/**
 * RegExp to match chars that must be quoted-pair in RFC 7230 sec 3.2.6
 */ var $b755c4a7bdc2d289$var$QUOTE_REGEXP = /([\\"])/g;
/**
 * RegExp to match type in RFC 7231 sec 3.1.1.1
 *
 * media-type = type "/" subtype
 * type       = token
 * subtype    = token
 */ var $b755c4a7bdc2d289$var$TYPE_REGEXP = /^[!#$%&'*+.^_`|~0-9A-Za-z-]+\/[!#$%&'*+.^_`|~0-9A-Za-z-]+$/;
$b755c4a7bdc2d289$export$d9468344d3651243 = $b755c4a7bdc2d289$var$format;
$b755c4a7bdc2d289$export$98e6a39c04603d36 = $b755c4a7bdc2d289$var$parse;
/**
 * Format object to media type.
 *
 * @param {object} obj
 * @return {string}
 * @public
 */ function $b755c4a7bdc2d289$var$format(obj) {
    if (!obj || typeof obj !== 'object') throw new TypeError('argument obj is required');
    var parameters = obj.parameters;
    var type = obj.type;
    if (!type || !$b755c4a7bdc2d289$var$TYPE_REGEXP.test(type)) throw new TypeError('invalid type');
    var string = type;
    // append parameters
    if (parameters && typeof parameters === 'object') {
        var param;
        var params = Object.keys(parameters).sort();
        for(var i = 0; i < params.length; i++){
            param = params[i];
            if (!$b755c4a7bdc2d289$var$TOKEN_REGEXP.test(param)) throw new TypeError('invalid parameter name');
            string += '; ' + param + '=' + $b755c4a7bdc2d289$var$qstring(parameters[param]);
        }
    }
    return string;
}
/**
 * Parse media type to object.
 *
 * @param {string|object} string
 * @return {Object}
 * @public
 */ function $b755c4a7bdc2d289$var$parse(string) {
    if (!string) throw new TypeError('argument string is required');
    // support req/res-like objects as argument
    var header = typeof string === 'object' ? $b755c4a7bdc2d289$var$getcontenttype(string) : string;
    if (typeof header !== 'string') throw new TypeError('argument string is required to be a string');
    var index = header.indexOf(';');
    var type = index !== -1 ? header.slice(0, index).trim() : header.trim();
    if (!$b755c4a7bdc2d289$var$TYPE_REGEXP.test(type)) throw new TypeError('invalid media type');
    var obj = new $b755c4a7bdc2d289$var$ContentType(type.toLowerCase());
    // parse parameters
    if (index !== -1) {
        var key;
        var match;
        var value;
        $b755c4a7bdc2d289$var$PARAM_REGEXP.lastIndex = index;
        while(match = $b755c4a7bdc2d289$var$PARAM_REGEXP.exec(header)){
            if (match.index !== index) throw new TypeError('invalid parameter format');
            index += match[0].length;
            key = match[1].toLowerCase();
            value = match[2];
            if (value.charCodeAt(0) === 0x22 /* " */ ) {
                // remove quotes
                value = value.slice(1, -1);
                // remove escapes
                if (value.indexOf('\\') !== -1) value = value.replace($b755c4a7bdc2d289$var$QESC_REGEXP, '$1');
            }
            obj.parameters[key] = value;
        }
        if (index !== header.length) throw new TypeError('invalid parameter format');
    }
    return obj;
}
/**
 * Get content-type from req/res objects.
 *
 * @param {object}
 * @return {Object}
 * @private
 */ function $b755c4a7bdc2d289$var$getcontenttype(obj) {
    var header;
    if (typeof obj.getHeader === 'function') // res-like
    header = obj.getHeader('content-type');
    else if (typeof obj.headers === 'object') // req-like
    header = obj.headers && obj.headers['content-type'];
    if (typeof header !== 'string') throw new TypeError('content-type header is missing from object');
    return header;
}
/**
 * Quote a string if necessary.
 *
 * @param {string} val
 * @return {string}
 * @private
 */ function $b755c4a7bdc2d289$var$qstring(val) {
    var str = String(val);
    // no need to quote tokens
    if ($b755c4a7bdc2d289$var$TOKEN_REGEXP.test(str)) return str;
    if (str.length > 0 && !$b755c4a7bdc2d289$var$TEXT_REGEXP.test(str)) throw new TypeError('invalid parameter value');
    return '"' + str.replace($b755c4a7bdc2d289$var$QUOTE_REGEXP, '\\$1') + '"';
}
/**
 * Class to represent a content type.
 * @private
 */ function $b755c4a7bdc2d289$var$ContentType(type) {
    this.parameters = Object.create(null);
    this.type = type;
}

});

parcelRegister("4TV4A", function(module, exports) {
/* commonmark 0.29 https://github.com/commonmark/commonmark.js @license BSD3 */ (function(global1, factory) {
    factory(module.exports);
})(module.exports, function(exports1) {
    'use strict';
    function isContainer(node) {
        switch(node._type){
            case "document":
            case "block_quote":
            case "list":
            case "item":
            case "paragraph":
            case "heading":
            case "emph":
            case "strong":
            case "link":
            case "image":
            case "custom_inline":
            case "custom_block":
                return true;
            default:
                return false;
        }
    }
    var resumeAt = function(node, entering) {
        this.current = node;
        this.entering = entering === true;
    };
    var next = function() {
        var cur = this.current;
        var entering = this.entering;
        if (cur === null) return null;
        var container = isContainer(cur);
        if (entering && container) {
            if (cur._firstChild) {
                this.current = cur._firstChild;
                this.entering = true;
            } else // stay on node but exit
            this.entering = false;
        } else if (cur === this.root) this.current = null;
        else if (cur._next === null) {
            this.current = cur._parent;
            this.entering = false;
        } else {
            this.current = cur._next;
            this.entering = true;
        }
        return {
            entering: entering,
            node: cur
        };
    };
    var NodeWalker = function(root) {
        return {
            current: root,
            root: root,
            entering: true,
            next: next,
            resumeAt: resumeAt
        };
    };
    var Node = function(nodeType, sourcepos) {
        this._type = nodeType;
        this._parent = null;
        this._firstChild = null;
        this._lastChild = null;
        this._prev = null;
        this._next = null;
        this._sourcepos = sourcepos;
        this._lastLineBlank = false;
        this._lastLineChecked = false;
        this._open = true;
        this._string_content = null;
        this._literal = null;
        this._listData = {};
        this._info = null;
        this._destination = null;
        this._title = null;
        this._isFenced = false;
        this._fenceChar = null;
        this._fenceLength = 0;
        this._fenceOffset = null;
        this._level = null;
        this._onEnter = null;
        this._onExit = null;
    };
    var proto = Node.prototype;
    Object.defineProperty(proto, "isContainer", {
        get: function() {
            return isContainer(this);
        }
    });
    Object.defineProperty(proto, "type", {
        get: function() {
            return this._type;
        }
    });
    Object.defineProperty(proto, "firstChild", {
        get: function() {
            return this._firstChild;
        }
    });
    Object.defineProperty(proto, "lastChild", {
        get: function() {
            return this._lastChild;
        }
    });
    Object.defineProperty(proto, "next", {
        get: function() {
            return this._next;
        }
    });
    Object.defineProperty(proto, "prev", {
        get: function() {
            return this._prev;
        }
    });
    Object.defineProperty(proto, "parent", {
        get: function() {
            return this._parent;
        }
    });
    Object.defineProperty(proto, "sourcepos", {
        get: function() {
            return this._sourcepos;
        }
    });
    Object.defineProperty(proto, "literal", {
        get: function() {
            return this._literal;
        },
        set: function(s) {
            this._literal = s;
        }
    });
    Object.defineProperty(proto, "destination", {
        get: function() {
            return this._destination;
        },
        set: function(s) {
            this._destination = s;
        }
    });
    Object.defineProperty(proto, "title", {
        get: function() {
            return this._title;
        },
        set: function(s) {
            this._title = s;
        }
    });
    Object.defineProperty(proto, "info", {
        get: function() {
            return this._info;
        },
        set: function(s) {
            this._info = s;
        }
    });
    Object.defineProperty(proto, "level", {
        get: function() {
            return this._level;
        },
        set: function(s) {
            this._level = s;
        }
    });
    Object.defineProperty(proto, "listType", {
        get: function() {
            return this._listData.type;
        },
        set: function(t) {
            this._listData.type = t;
        }
    });
    Object.defineProperty(proto, "listTight", {
        get: function() {
            return this._listData.tight;
        },
        set: function(t) {
            this._listData.tight = t;
        }
    });
    Object.defineProperty(proto, "listStart", {
        get: function() {
            return this._listData.start;
        },
        set: function(n) {
            this._listData.start = n;
        }
    });
    Object.defineProperty(proto, "listDelimiter", {
        get: function() {
            return this._listData.delimiter;
        },
        set: function(delim) {
            this._listData.delimiter = delim;
        }
    });
    Object.defineProperty(proto, "onEnter", {
        get: function() {
            return this._onEnter;
        },
        set: function(s) {
            this._onEnter = s;
        }
    });
    Object.defineProperty(proto, "onExit", {
        get: function() {
            return this._onExit;
        },
        set: function(s) {
            this._onExit = s;
        }
    });
    Node.prototype.appendChild = function(child) {
        child.unlink();
        child._parent = this;
        if (this._lastChild) {
            this._lastChild._next = child;
            child._prev = this._lastChild;
            this._lastChild = child;
        } else {
            this._firstChild = child;
            this._lastChild = child;
        }
    };
    Node.prototype.prependChild = function(child) {
        child.unlink();
        child._parent = this;
        if (this._firstChild) {
            this._firstChild._prev = child;
            child._next = this._firstChild;
            this._firstChild = child;
        } else {
            this._firstChild = child;
            this._lastChild = child;
        }
    };
    Node.prototype.unlink = function() {
        if (this._prev) this._prev._next = this._next;
        else if (this._parent) this._parent._firstChild = this._next;
        if (this._next) this._next._prev = this._prev;
        else if (this._parent) this._parent._lastChild = this._prev;
        this._parent = null;
        this._next = null;
        this._prev = null;
    };
    Node.prototype.insertAfter = function(sibling) {
        sibling.unlink();
        sibling._next = this._next;
        if (sibling._next) sibling._next._prev = sibling;
        sibling._prev = this;
        this._next = sibling;
        sibling._parent = this._parent;
        if (!sibling._next) sibling._parent._lastChild = sibling;
    };
    Node.prototype.insertBefore = function(sibling) {
        sibling.unlink();
        sibling._prev = this._prev;
        if (sibling._prev) sibling._prev._next = sibling;
        sibling._next = this;
        this._prev = sibling;
        sibling._parent = this._parent;
        if (!sibling._prev) sibling._parent._firstChild = sibling;
    };
    Node.prototype.walker = function() {
        var walker = new NodeWalker(this);
        return walker;
    };
    /* Example of use of walker:

     var walker = w.walker();
     var event;

     while (event = walker.next()) {
     console.log(event.entering, event.node.type);
     }

     */ var encodeCache = {};
    // Create a lookup array where anything but characters in `chars` string
    // and alphanumeric chars is percent-encoded.
    //
    function getEncodeCache(exclude) {
        var i, ch, cache = encodeCache[exclude];
        if (cache) return cache;
        cache = encodeCache[exclude] = [];
        for(i = 0; i < 128; i++){
            ch = String.fromCharCode(i);
            if (/^[0-9a-z]$/i.test(ch)) // always allow unencoded alphanumeric characters
            cache.push(ch);
            else cache.push('%' + ('0' + i.toString(16).toUpperCase()).slice(-2));
        }
        for(i = 0; i < exclude.length; i++)cache[exclude.charCodeAt(i)] = exclude[i];
        return cache;
    }
    // Encode unsafe characters with percent-encoding, skipping already
    // encoded sequences.
    //
    //  - string       - string to encode
    //  - exclude      - list of characters to ignore (in addition to a-zA-Z0-9)
    //  - keepEscaped  - don't encode '%' in a correct escape sequence (default: true)
    //
    function encode(string, exclude, keepEscaped) {
        var i, l, code, nextCode, cache, result = '';
        if (typeof exclude !== 'string') {
            // encode(string, keepEscaped)
            keepEscaped = exclude;
            exclude = encode.defaultChars;
        }
        if (typeof keepEscaped === 'undefined') keepEscaped = true;
        cache = getEncodeCache(exclude);
        for(i = 0, l = string.length; i < l; i++){
            code = string.charCodeAt(i);
            if (keepEscaped && code === 0x25 /* % */  && i + 2 < l) {
                if (/^[0-9a-f]{2}$/i.test(string.slice(i + 1, i + 3))) {
                    result += string.slice(i, i + 3);
                    i += 2;
                    continue;
                }
            }
            if (code < 128) {
                result += cache[code];
                continue;
            }
            if (code >= 0xD800 && code <= 0xDFFF) {
                if (code >= 0xD800 && code <= 0xDBFF && i + 1 < l) {
                    nextCode = string.charCodeAt(i + 1);
                    if (nextCode >= 0xDC00 && nextCode <= 0xDFFF) {
                        result += encodeURIComponent(string[i] + string[i + 1]);
                        i++;
                        continue;
                    }
                }
                result += '%EF%BF%BD';
                continue;
            }
            result += encodeURIComponent(string[i]);
        }
        return result;
    }
    encode.defaultChars = ";/?:@&=+$,-_.!~*'()#";
    encode.componentChars = "-_.!~*'()";
    var encode_1 = encode;
    var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
    function unwrapExports(x) {
        return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
    }
    function createCommonjsModule(fn, module) {
        return module = {
            exports: {}
        }, fn(module, module.exports), module.exports;
    }
    function getCjsExportFromNamespace(n) {
        return n && n['default'] || n;
    }
    var Aacute = "\xc1";
    var aacute = "\xe1";
    var Abreve = "\u0102";
    var abreve = "\u0103";
    var ac = "\u223E";
    var acd = "\u223F";
    var acE = "\u223E\u0333";
    var Acirc = "\xc2";
    var acirc = "\xe2";
    var acute = "\xb4";
    var Acy = "\u0410";
    var acy = "\u0430";
    var AElig = "\xc6";
    var aelig = "\xe6";
    var af = "\u2061";
    var Afr = "\uD835\uDD04";
    var afr = "\uD835\uDD1E";
    var Agrave = "\xc0";
    var agrave = "\xe0";
    var alefsym = "\u2135";
    var aleph = "\u2135";
    var Alpha = "\u0391";
    var alpha = "\u03B1";
    var Amacr = "\u0100";
    var amacr = "\u0101";
    var amalg = "\u2A3F";
    var amp = "&";
    var AMP = "&";
    var andand = "\u2A55";
    var And = "\u2A53";
    var and = "\u2227";
    var andd = "\u2A5C";
    var andslope = "\u2A58";
    var andv = "\u2A5A";
    var ang = "\u2220";
    var ange = "\u29A4";
    var angle = "\u2220";
    var angmsdaa = "\u29A8";
    var angmsdab = "\u29A9";
    var angmsdac = "\u29AA";
    var angmsdad = "\u29AB";
    var angmsdae = "\u29AC";
    var angmsdaf = "\u29AD";
    var angmsdag = "\u29AE";
    var angmsdah = "\u29AF";
    var angmsd = "\u2221";
    var angrt = "\u221F";
    var angrtvb = "\u22BE";
    var angrtvbd = "\u299D";
    var angsph = "\u2222";
    var angst = "\xc5";
    var angzarr = "\u237C";
    var Aogon = "\u0104";
    var aogon = "\u0105";
    var Aopf = "\uD835\uDD38";
    var aopf = "\uD835\uDD52";
    var apacir = "\u2A6F";
    var ap = "\u2248";
    var apE = "\u2A70";
    var ape = "\u224A";
    var apid = "\u224B";
    var apos = "'";
    var ApplyFunction = "\u2061";
    var approx = "\u2248";
    var approxeq = "\u224A";
    var Aring = "\xc5";
    var aring = "\xe5";
    var Ascr = "\uD835\uDC9C";
    var ascr = "\uD835\uDCB6";
    var Assign = "\u2254";
    var ast = "*";
    var asymp = "\u2248";
    var asympeq = "\u224D";
    var Atilde = "\xc3";
    var atilde = "\xe3";
    var Auml = "\xc4";
    var auml = "\xe4";
    var awconint = "\u2233";
    var awint = "\u2A11";
    var backcong = "\u224C";
    var backepsilon = "\u03F6";
    var backprime = "\u2035";
    var backsim = "\u223D";
    var backsimeq = "\u22CD";
    var Backslash = "\u2216";
    var Barv = "\u2AE7";
    var barvee = "\u22BD";
    var barwed = "\u2305";
    var Barwed = "\u2306";
    var barwedge = "\u2305";
    var bbrk = "\u23B5";
    var bbrktbrk = "\u23B6";
    var bcong = "\u224C";
    var Bcy = "\u0411";
    var bcy = "\u0431";
    var bdquo = "\u201E";
    var becaus = "\u2235";
    var because = "\u2235";
    var Because = "\u2235";
    var bemptyv = "\u29B0";
    var bepsi = "\u03F6";
    var bernou = "\u212C";
    var Bernoullis = "\u212C";
    var Beta = "\u0392";
    var beta = "\u03B2";
    var beth = "\u2136";
    var between = "\u226C";
    var Bfr = "\uD835\uDD05";
    var bfr = "\uD835\uDD1F";
    var bigcap = "\u22C2";
    var bigcirc = "\u25EF";
    var bigcup = "\u22C3";
    var bigodot = "\u2A00";
    var bigoplus = "\u2A01";
    var bigotimes = "\u2A02";
    var bigsqcup = "\u2A06";
    var bigstar = "\u2605";
    var bigtriangledown = "\u25BD";
    var bigtriangleup = "\u25B3";
    var biguplus = "\u2A04";
    var bigvee = "\u22C1";
    var bigwedge = "\u22C0";
    var bkarow = "\u290D";
    var blacklozenge = "\u29EB";
    var blacksquare = "\u25AA";
    var blacktriangle = "\u25B4";
    var blacktriangledown = "\u25BE";
    var blacktriangleleft = "\u25C2";
    var blacktriangleright = "\u25B8";
    var blank = "\u2423";
    var blk12 = "\u2592";
    var blk14 = "\u2591";
    var blk34 = "\u2593";
    var block = "\u2588";
    var bne = "=\u20E5";
    var bnequiv = "\u2261\u20E5";
    var bNot = "\u2AED";
    var bnot = "\u2310";
    var Bopf = "\uD835\uDD39";
    var bopf = "\uD835\uDD53";
    var bot = "\u22A5";
    var bottom = "\u22A5";
    var bowtie = "\u22C8";
    var boxbox = "\u29C9";
    var boxdl = "\u2510";
    var boxdL = "\u2555";
    var boxDl = "\u2556";
    var boxDL = "\u2557";
    var boxdr = "\u250C";
    var boxdR = "\u2552";
    var boxDr = "\u2553";
    var boxDR = "\u2554";
    var boxh = "\u2500";
    var boxH = "\u2550";
    var boxhd = "\u252C";
    var boxHd = "\u2564";
    var boxhD = "\u2565";
    var boxHD = "\u2566";
    var boxhu = "\u2534";
    var boxHu = "\u2567";
    var boxhU = "\u2568";
    var boxHU = "\u2569";
    var boxminus = "\u229F";
    var boxplus = "\u229E";
    var boxtimes = "\u22A0";
    var boxul = "\u2518";
    var boxuL = "\u255B";
    var boxUl = "\u255C";
    var boxUL = "\u255D";
    var boxur = "\u2514";
    var boxuR = "\u2558";
    var boxUr = "\u2559";
    var boxUR = "\u255A";
    var boxv = "\u2502";
    var boxV = "\u2551";
    var boxvh = "\u253C";
    var boxvH = "\u256A";
    var boxVh = "\u256B";
    var boxVH = "\u256C";
    var boxvl = "\u2524";
    var boxvL = "\u2561";
    var boxVl = "\u2562";
    var boxVL = "\u2563";
    var boxvr = "\u251C";
    var boxvR = "\u255E";
    var boxVr = "\u255F";
    var boxVR = "\u2560";
    var bprime = "\u2035";
    var breve = "\u02D8";
    var Breve = "\u02D8";
    var brvbar = "\xa6";
    var bscr = "\uD835\uDCB7";
    var Bscr = "\u212C";
    var bsemi = "\u204F";
    var bsim = "\u223D";
    var bsime = "\u22CD";
    var bsolb = "\u29C5";
    var bsol = "\\";
    var bsolhsub = "\u27C8";
    var bull = "\u2022";
    var bullet = "\u2022";
    var bump = "\u224E";
    var bumpE = "\u2AAE";
    var bumpe = "\u224F";
    var Bumpeq = "\u224E";
    var bumpeq = "\u224F";
    var Cacute = "\u0106";
    var cacute = "\u0107";
    var capand = "\u2A44";
    var capbrcup = "\u2A49";
    var capcap = "\u2A4B";
    var cap = "\u2229";
    var Cap = "\u22D2";
    var capcup = "\u2A47";
    var capdot = "\u2A40";
    var CapitalDifferentialD = "\u2145";
    var caps = "\u2229\uFE00";
    var caret = "\u2041";
    var caron = "\u02C7";
    var Cayleys = "\u212D";
    var ccaps = "\u2A4D";
    var Ccaron = "\u010C";
    var ccaron = "\u010D";
    var Ccedil = "\xc7";
    var ccedil = "\xe7";
    var Ccirc = "\u0108";
    var ccirc = "\u0109";
    var Cconint = "\u2230";
    var ccups = "\u2A4C";
    var ccupssm = "\u2A50";
    var Cdot = "\u010A";
    var cdot = "\u010B";
    var cedil = "\xb8";
    var Cedilla = "\xb8";
    var cemptyv = "\u29B2";
    var cent = "\xa2";
    var centerdot = "\xb7";
    var CenterDot = "\xb7";
    var cfr = "\uD835\uDD20";
    var Cfr = "\u212D";
    var CHcy = "\u0427";
    var chcy = "\u0447";
    var check = "\u2713";
    var checkmark = "\u2713";
    var Chi = "\u03A7";
    var chi = "\u03C7";
    var circ = "\u02C6";
    var circeq = "\u2257";
    var circlearrowleft = "\u21BA";
    var circlearrowright = "\u21BB";
    var circledast = "\u229B";
    var circledcirc = "\u229A";
    var circleddash = "\u229D";
    var CircleDot = "\u2299";
    var circledR = "\xae";
    var circledS = "\u24C8";
    var CircleMinus = "\u2296";
    var CirclePlus = "\u2295";
    var CircleTimes = "\u2297";
    var cir = "\u25CB";
    var cirE = "\u29C3";
    var cire = "\u2257";
    var cirfnint = "\u2A10";
    var cirmid = "\u2AEF";
    var cirscir = "\u29C2";
    var ClockwiseContourIntegral = "\u2232";
    var CloseCurlyDoubleQuote = "\u201D";
    var CloseCurlyQuote = "\u2019";
    var clubs = "\u2663";
    var clubsuit = "\u2663";
    var colon = ":";
    var Colon = "\u2237";
    var Colone = "\u2A74";
    var colone = "\u2254";
    var coloneq = "\u2254";
    var comma = ",";
    var commat = "@";
    var comp = "\u2201";
    var compfn = "\u2218";
    var complement = "\u2201";
    var complexes = "\u2102";
    var cong = "\u2245";
    var congdot = "\u2A6D";
    var Congruent = "\u2261";
    var conint = "\u222E";
    var Conint = "\u222F";
    var ContourIntegral = "\u222E";
    var copf = "\uD835\uDD54";
    var Copf = "\u2102";
    var coprod = "\u2210";
    var Coproduct = "\u2210";
    var copy = "\xa9";
    var COPY = "\xa9";
    var copysr = "\u2117";
    var CounterClockwiseContourIntegral = "\u2233";
    var crarr = "\u21B5";
    var cross = "\u2717";
    var Cross = "\u2A2F";
    var Cscr = "\uD835\uDC9E";
    var cscr = "\uD835\uDCB8";
    var csub = "\u2ACF";
    var csube = "\u2AD1";
    var csup = "\u2AD0";
    var csupe = "\u2AD2";
    var ctdot = "\u22EF";
    var cudarrl = "\u2938";
    var cudarrr = "\u2935";
    var cuepr = "\u22DE";
    var cuesc = "\u22DF";
    var cularr = "\u21B6";
    var cularrp = "\u293D";
    var cupbrcap = "\u2A48";
    var cupcap = "\u2A46";
    var CupCap = "\u224D";
    var cup = "\u222A";
    var Cup = "\u22D3";
    var cupcup = "\u2A4A";
    var cupdot = "\u228D";
    var cupor = "\u2A45";
    var cups = "\u222A\uFE00";
    var curarr = "\u21B7";
    var curarrm = "\u293C";
    var curlyeqprec = "\u22DE";
    var curlyeqsucc = "\u22DF";
    var curlyvee = "\u22CE";
    var curlywedge = "\u22CF";
    var curren = "\xa4";
    var curvearrowleft = "\u21B6";
    var curvearrowright = "\u21B7";
    var cuvee = "\u22CE";
    var cuwed = "\u22CF";
    var cwconint = "\u2232";
    var cwint = "\u2231";
    var cylcty = "\u232D";
    var dagger = "\u2020";
    var Dagger = "\u2021";
    var daleth = "\u2138";
    var darr = "\u2193";
    var Darr = "\u21A1";
    var dArr = "\u21D3";
    var dash = "\u2010";
    var Dashv = "\u2AE4";
    var dashv = "\u22A3";
    var dbkarow = "\u290F";
    var dblac = "\u02DD";
    var Dcaron = "\u010E";
    var dcaron = "\u010F";
    var Dcy = "\u0414";
    var dcy = "\u0434";
    var ddagger = "\u2021";
    var ddarr = "\u21CA";
    var DD = "\u2145";
    var dd = "\u2146";
    var DDotrahd = "\u2911";
    var ddotseq = "\u2A77";
    var deg = "\xb0";
    var Del = "\u2207";
    var Delta = "\u0394";
    var delta = "\u03B4";
    var demptyv = "\u29B1";
    var dfisht = "\u297F";
    var Dfr = "\uD835\uDD07";
    var dfr = "\uD835\uDD21";
    var dHar = "\u2965";
    var dharl = "\u21C3";
    var dharr = "\u21C2";
    var DiacriticalAcute = "\xb4";
    var DiacriticalDot = "\u02D9";
    var DiacriticalDoubleAcute = "\u02DD";
    var DiacriticalGrave = "`";
    var DiacriticalTilde = "\u02DC";
    var diam = "\u22C4";
    var diamond = "\u22C4";
    var Diamond = "\u22C4";
    var diamondsuit = "\u2666";
    var diams = "\u2666";
    var die = "\xa8";
    var DifferentialD = "\u2146";
    var digamma = "\u03DD";
    var disin = "\u22F2";
    var div = "\xf7";
    var divide = "\xf7";
    var divideontimes = "\u22C7";
    var divonx = "\u22C7";
    var DJcy = "\u0402";
    var djcy = "\u0452";
    var dlcorn = "\u231E";
    var dlcrop = "\u230D";
    var dollar = "$";
    var Dopf = "\uD835\uDD3B";
    var dopf = "\uD835\uDD55";
    var Dot = "\xa8";
    var dot = "\u02D9";
    var DotDot = "\u20DC";
    var doteq = "\u2250";
    var doteqdot = "\u2251";
    var DotEqual = "\u2250";
    var dotminus = "\u2238";
    var dotplus = "\u2214";
    var dotsquare = "\u22A1";
    var doublebarwedge = "\u2306";
    var DoubleContourIntegral = "\u222F";
    var DoubleDot = "\xa8";
    var DoubleDownArrow = "\u21D3";
    var DoubleLeftArrow = "\u21D0";
    var DoubleLeftRightArrow = "\u21D4";
    var DoubleLeftTee = "\u2AE4";
    var DoubleLongLeftArrow = "\u27F8";
    var DoubleLongLeftRightArrow = "\u27FA";
    var DoubleLongRightArrow = "\u27F9";
    var DoubleRightArrow = "\u21D2";
    var DoubleRightTee = "\u22A8";
    var DoubleUpArrow = "\u21D1";
    var DoubleUpDownArrow = "\u21D5";
    var DoubleVerticalBar = "\u2225";
    var DownArrowBar = "\u2913";
    var downarrow = "\u2193";
    var DownArrow = "\u2193";
    var Downarrow = "\u21D3";
    var DownArrowUpArrow = "\u21F5";
    var DownBreve = "\u0311";
    var downdownarrows = "\u21CA";
    var downharpoonleft = "\u21C3";
    var downharpoonright = "\u21C2";
    var DownLeftRightVector = "\u2950";
    var DownLeftTeeVector = "\u295E";
    var DownLeftVectorBar = "\u2956";
    var DownLeftVector = "\u21BD";
    var DownRightTeeVector = "\u295F";
    var DownRightVectorBar = "\u2957";
    var DownRightVector = "\u21C1";
    var DownTeeArrow = "\u21A7";
    var DownTee = "\u22A4";
    var drbkarow = "\u2910";
    var drcorn = "\u231F";
    var drcrop = "\u230C";
    var Dscr = "\uD835\uDC9F";
    var dscr = "\uD835\uDCB9";
    var DScy = "\u0405";
    var dscy = "\u0455";
    var dsol = "\u29F6";
    var Dstrok = "\u0110";
    var dstrok = "\u0111";
    var dtdot = "\u22F1";
    var dtri = "\u25BF";
    var dtrif = "\u25BE";
    var duarr = "\u21F5";
    var duhar = "\u296F";
    var dwangle = "\u29A6";
    var DZcy = "\u040F";
    var dzcy = "\u045F";
    var dzigrarr = "\u27FF";
    var Eacute = "\xc9";
    var eacute = "\xe9";
    var easter = "\u2A6E";
    var Ecaron = "\u011A";
    var ecaron = "\u011B";
    var Ecirc = "\xca";
    var ecirc = "\xea";
    var ecir = "\u2256";
    var ecolon = "\u2255";
    var Ecy = "\u042D";
    var ecy = "\u044D";
    var eDDot = "\u2A77";
    var Edot = "\u0116";
    var edot = "\u0117";
    var eDot = "\u2251";
    var ee = "\u2147";
    var efDot = "\u2252";
    var Efr = "\uD835\uDD08";
    var efr = "\uD835\uDD22";
    var eg = "\u2A9A";
    var Egrave = "\xc8";
    var egrave = "\xe8";
    var egs = "\u2A96";
    var egsdot = "\u2A98";
    var el = "\u2A99";
    var Element = "\u2208";
    var elinters = "\u23E7";
    var ell = "\u2113";
    var els = "\u2A95";
    var elsdot = "\u2A97";
    var Emacr = "\u0112";
    var emacr = "\u0113";
    var empty = "\u2205";
    var emptyset = "\u2205";
    var EmptySmallSquare = "\u25FB";
    var emptyv = "\u2205";
    var EmptyVerySmallSquare = "\u25AB";
    var emsp13 = "\u2004";
    var emsp14 = "\u2005";
    var emsp = "\u2003";
    var ENG = "\u014A";
    var eng = "\u014B";
    var ensp = "\u2002";
    var Eogon = "\u0118";
    var eogon = "\u0119";
    var Eopf = "\uD835\uDD3C";
    var eopf = "\uD835\uDD56";
    var epar = "\u22D5";
    var eparsl = "\u29E3";
    var eplus = "\u2A71";
    var epsi = "\u03B5";
    var Epsilon = "\u0395";
    var epsilon = "\u03B5";
    var epsiv = "\u03F5";
    var eqcirc = "\u2256";
    var eqcolon = "\u2255";
    var eqsim = "\u2242";
    var eqslantgtr = "\u2A96";
    var eqslantless = "\u2A95";
    var Equal = "\u2A75";
    var equals = "=";
    var EqualTilde = "\u2242";
    var equest = "\u225F";
    var Equilibrium = "\u21CC";
    var equiv = "\u2261";
    var equivDD = "\u2A78";
    var eqvparsl = "\u29E5";
    var erarr = "\u2971";
    var erDot = "\u2253";
    var escr = "\u212F";
    var Escr = "\u2130";
    var esdot = "\u2250";
    var Esim = "\u2A73";
    var esim = "\u2242";
    var Eta = "\u0397";
    var eta = "\u03B7";
    var ETH = "\xd0";
    var eth = "\xf0";
    var Euml = "\xcb";
    var euml = "\xeb";
    var euro = "\u20AC";
    var excl = "!";
    var exist = "\u2203";
    var Exists = "\u2203";
    var expectation = "\u2130";
    var exponentiale = "\u2147";
    var ExponentialE = "\u2147";
    var fallingdotseq = "\u2252";
    var Fcy = "\u0424";
    var fcy = "\u0444";
    var female = "\u2640";
    var ffilig = "\uFB03";
    var fflig = "\uFB00";
    var ffllig = "\uFB04";
    var Ffr = "\uD835\uDD09";
    var ffr = "\uD835\uDD23";
    var filig = "\uFB01";
    var FilledSmallSquare = "\u25FC";
    var FilledVerySmallSquare = "\u25AA";
    var fjlig = "fj";
    var flat = "\u266D";
    var fllig = "\uFB02";
    var fltns = "\u25B1";
    var fnof = "\u0192";
    var Fopf = "\uD835\uDD3D";
    var fopf = "\uD835\uDD57";
    var forall = "\u2200";
    var ForAll = "\u2200";
    var fork = "\u22D4";
    var forkv = "\u2AD9";
    var Fouriertrf = "\u2131";
    var fpartint = "\u2A0D";
    var frac12 = "\xbd";
    var frac13 = "\u2153";
    var frac14 = "\xbc";
    var frac15 = "\u2155";
    var frac16 = "\u2159";
    var frac18 = "\u215B";
    var frac23 = "\u2154";
    var frac25 = "\u2156";
    var frac34 = "\xbe";
    var frac35 = "\u2157";
    var frac38 = "\u215C";
    var frac45 = "\u2158";
    var frac56 = "\u215A";
    var frac58 = "\u215D";
    var frac78 = "\u215E";
    var frasl = "\u2044";
    var frown = "\u2322";
    var fscr = "\uD835\uDCBB";
    var Fscr = "\u2131";
    var gacute = "\u01F5";
    var Gamma = "\u0393";
    var gamma = "\u03B3";
    var Gammad = "\u03DC";
    var gammad = "\u03DD";
    var gap = "\u2A86";
    var Gbreve = "\u011E";
    var gbreve = "\u011F";
    var Gcedil = "\u0122";
    var Gcirc = "\u011C";
    var gcirc = "\u011D";
    var Gcy = "\u0413";
    var gcy = "\u0433";
    var Gdot = "\u0120";
    var gdot = "\u0121";
    var ge = "\u2265";
    var gE = "\u2267";
    var gEl = "\u2A8C";
    var gel = "\u22DB";
    var geq = "\u2265";
    var geqq = "\u2267";
    var geqslant = "\u2A7E";
    var gescc = "\u2AA9";
    var ges = "\u2A7E";
    var gesdot = "\u2A80";
    var gesdoto = "\u2A82";
    var gesdotol = "\u2A84";
    var gesl = "\u22DB\uFE00";
    var gesles = "\u2A94";
    var Gfr = "\uD835\uDD0A";
    var gfr = "\uD835\uDD24";
    var gg = "\u226B";
    var Gg = "\u22D9";
    var ggg = "\u22D9";
    var gimel = "\u2137";
    var GJcy = "\u0403";
    var gjcy = "\u0453";
    var gla = "\u2AA5";
    var gl = "\u2277";
    var glE = "\u2A92";
    var glj = "\u2AA4";
    var gnap = "\u2A8A";
    var gnapprox = "\u2A8A";
    var gne = "\u2A88";
    var gnE = "\u2269";
    var gneq = "\u2A88";
    var gneqq = "\u2269";
    var gnsim = "\u22E7";
    var Gopf = "\uD835\uDD3E";
    var gopf = "\uD835\uDD58";
    var grave = "`";
    var GreaterEqual = "\u2265";
    var GreaterEqualLess = "\u22DB";
    var GreaterFullEqual = "\u2267";
    var GreaterGreater = "\u2AA2";
    var GreaterLess = "\u2277";
    var GreaterSlantEqual = "\u2A7E";
    var GreaterTilde = "\u2273";
    var Gscr = "\uD835\uDCA2";
    var gscr = "\u210A";
    var gsim = "\u2273";
    var gsime = "\u2A8E";
    var gsiml = "\u2A90";
    var gtcc = "\u2AA7";
    var gtcir = "\u2A7A";
    var gt = ">";
    var GT = ">";
    var Gt = "\u226B";
    var gtdot = "\u22D7";
    var gtlPar = "\u2995";
    var gtquest = "\u2A7C";
    var gtrapprox = "\u2A86";
    var gtrarr = "\u2978";
    var gtrdot = "\u22D7";
    var gtreqless = "\u22DB";
    var gtreqqless = "\u2A8C";
    var gtrless = "\u2277";
    var gtrsim = "\u2273";
    var gvertneqq = "\u2269\uFE00";
    var gvnE = "\u2269\uFE00";
    var Hacek = "\u02C7";
    var hairsp = "\u200A";
    var half = "\xbd";
    var hamilt = "\u210B";
    var HARDcy = "\u042A";
    var hardcy = "\u044A";
    var harrcir = "\u2948";
    var harr = "\u2194";
    var hArr = "\u21D4";
    var harrw = "\u21AD";
    var Hat = "^";
    var hbar = "\u210F";
    var Hcirc = "\u0124";
    var hcirc = "\u0125";
    var hearts = "\u2665";
    var heartsuit = "\u2665";
    var hellip = "\u2026";
    var hercon = "\u22B9";
    var hfr = "\uD835\uDD25";
    var Hfr = "\u210C";
    var HilbertSpace = "\u210B";
    var hksearow = "\u2925";
    var hkswarow = "\u2926";
    var hoarr = "\u21FF";
    var homtht = "\u223B";
    var hookleftarrow = "\u21A9";
    var hookrightarrow = "\u21AA";
    var hopf = "\uD835\uDD59";
    var Hopf = "\u210D";
    var horbar = "\u2015";
    var HorizontalLine = "\u2500";
    var hscr = "\uD835\uDCBD";
    var Hscr = "\u210B";
    var hslash = "\u210F";
    var Hstrok = "\u0126";
    var hstrok = "\u0127";
    var HumpDownHump = "\u224E";
    var HumpEqual = "\u224F";
    var hybull = "\u2043";
    var hyphen = "\u2010";
    var Iacute = "\xcd";
    var iacute = "\xed";
    var ic = "\u2063";
    var Icirc = "\xce";
    var icirc = "\xee";
    var Icy = "\u0418";
    var icy = "\u0438";
    var Idot = "\u0130";
    var IEcy = "\u0415";
    var iecy = "\u0435";
    var iexcl = "\xa1";
    var iff = "\u21D4";
    var ifr = "\uD835\uDD26";
    var Ifr = "\u2111";
    var Igrave = "\xcc";
    var igrave = "\xec";
    var ii = "\u2148";
    var iiiint = "\u2A0C";
    var iiint = "\u222D";
    var iinfin = "\u29DC";
    var iiota = "\u2129";
    var IJlig = "\u0132";
    var ijlig = "\u0133";
    var Imacr = "\u012A";
    var imacr = "\u012B";
    var image = "\u2111";
    var ImaginaryI = "\u2148";
    var imagline = "\u2110";
    var imagpart = "\u2111";
    var imath = "\u0131";
    var Im = "\u2111";
    var imof = "\u22B7";
    var imped = "\u01B5";
    var Implies = "\u21D2";
    var incare = "\u2105";
    var infin = "\u221E";
    var infintie = "\u29DD";
    var inodot = "\u0131";
    var intcal = "\u22BA";
    var int = "\u222B";
    var Int = "\u222C";
    var integers = "\u2124";
    var Integral = "\u222B";
    var intercal = "\u22BA";
    var Intersection = "\u22C2";
    var intlarhk = "\u2A17";
    var intprod = "\u2A3C";
    var InvisibleComma = "\u2063";
    var InvisibleTimes = "\u2062";
    var IOcy = "\u0401";
    var iocy = "\u0451";
    var Iogon = "\u012E";
    var iogon = "\u012F";
    var Iopf = "\uD835\uDD40";
    var iopf = "\uD835\uDD5A";
    var Iota = "\u0399";
    var iota = "\u03B9";
    var iprod = "\u2A3C";
    var iquest = "\xbf";
    var iscr = "\uD835\uDCBE";
    var Iscr = "\u2110";
    var isin = "\u2208";
    var isindot = "\u22F5";
    var isinE = "\u22F9";
    var isins = "\u22F4";
    var isinsv = "\u22F3";
    var isinv = "\u2208";
    var it = "\u2062";
    var Itilde = "\u0128";
    var itilde = "\u0129";
    var Iukcy = "\u0406";
    var iukcy = "\u0456";
    var Iuml = "\xcf";
    var iuml = "\xef";
    var Jcirc = "\u0134";
    var jcirc = "\u0135";
    var Jcy = "\u0419";
    var jcy = "\u0439";
    var Jfr = "\uD835\uDD0D";
    var jfr = "\uD835\uDD27";
    var jmath = "\u0237";
    var Jopf = "\uD835\uDD41";
    var jopf = "\uD835\uDD5B";
    var Jscr = "\uD835\uDCA5";
    var jscr = "\uD835\uDCBF";
    var Jsercy = "\u0408";
    var jsercy = "\u0458";
    var Jukcy = "\u0404";
    var jukcy = "\u0454";
    var Kappa = "\u039A";
    var kappa = "\u03BA";
    var kappav = "\u03F0";
    var Kcedil = "\u0136";
    var kcedil = "\u0137";
    var Kcy = "\u041A";
    var kcy = "\u043A";
    var Kfr = "\uD835\uDD0E";
    var kfr = "\uD835\uDD28";
    var kgreen = "\u0138";
    var KHcy = "\u0425";
    var khcy = "\u0445";
    var KJcy = "\u040C";
    var kjcy = "\u045C";
    var Kopf = "\uD835\uDD42";
    var kopf = "\uD835\uDD5C";
    var Kscr = "\uD835\uDCA6";
    var kscr = "\uD835\uDCC0";
    var lAarr = "\u21DA";
    var Lacute = "\u0139";
    var lacute = "\u013A";
    var laemptyv = "\u29B4";
    var lagran = "\u2112";
    var Lambda = "\u039B";
    var lambda = "\u03BB";
    var lang = "\u27E8";
    var Lang = "\u27EA";
    var langd = "\u2991";
    var langle = "\u27E8";
    var lap = "\u2A85";
    var Laplacetrf = "\u2112";
    var laquo = "\xab";
    var larrb = "\u21E4";
    var larrbfs = "\u291F";
    var larr = "\u2190";
    var Larr = "\u219E";
    var lArr = "\u21D0";
    var larrfs = "\u291D";
    var larrhk = "\u21A9";
    var larrlp = "\u21AB";
    var larrpl = "\u2939";
    var larrsim = "\u2973";
    var larrtl = "\u21A2";
    var latail = "\u2919";
    var lAtail = "\u291B";
    var lat = "\u2AAB";
    var late = "\u2AAD";
    var lates = "\u2AAD\uFE00";
    var lbarr = "\u290C";
    var lBarr = "\u290E";
    var lbbrk = "\u2772";
    var lbrace = "{";
    var lbrack = "[";
    var lbrke = "\u298B";
    var lbrksld = "\u298F";
    var lbrkslu = "\u298D";
    var Lcaron = "\u013D";
    var lcaron = "\u013E";
    var Lcedil = "\u013B";
    var lcedil = "\u013C";
    var lceil = "\u2308";
    var lcub = "{";
    var Lcy = "\u041B";
    var lcy = "\u043B";
    var ldca = "\u2936";
    var ldquo = "\u201C";
    var ldquor = "\u201E";
    var ldrdhar = "\u2967";
    var ldrushar = "\u294B";
    var ldsh = "\u21B2";
    var le = "\u2264";
    var lE = "\u2266";
    var LeftAngleBracket = "\u27E8";
    var LeftArrowBar = "\u21E4";
    var leftarrow = "\u2190";
    var LeftArrow = "\u2190";
    var Leftarrow = "\u21D0";
    var LeftArrowRightArrow = "\u21C6";
    var leftarrowtail = "\u21A2";
    var LeftCeiling = "\u2308";
    var LeftDoubleBracket = "\u27E6";
    var LeftDownTeeVector = "\u2961";
    var LeftDownVectorBar = "\u2959";
    var LeftDownVector = "\u21C3";
    var LeftFloor = "\u230A";
    var leftharpoondown = "\u21BD";
    var leftharpoonup = "\u21BC";
    var leftleftarrows = "\u21C7";
    var leftrightarrow = "\u2194";
    var LeftRightArrow = "\u2194";
    var Leftrightarrow = "\u21D4";
    var leftrightarrows = "\u21C6";
    var leftrightharpoons = "\u21CB";
    var leftrightsquigarrow = "\u21AD";
    var LeftRightVector = "\u294E";
    var LeftTeeArrow = "\u21A4";
    var LeftTee = "\u22A3";
    var LeftTeeVector = "\u295A";
    var leftthreetimes = "\u22CB";
    var LeftTriangleBar = "\u29CF";
    var LeftTriangle = "\u22B2";
    var LeftTriangleEqual = "\u22B4";
    var LeftUpDownVector = "\u2951";
    var LeftUpTeeVector = "\u2960";
    var LeftUpVectorBar = "\u2958";
    var LeftUpVector = "\u21BF";
    var LeftVectorBar = "\u2952";
    var LeftVector = "\u21BC";
    var lEg = "\u2A8B";
    var leg = "\u22DA";
    var leq = "\u2264";
    var leqq = "\u2266";
    var leqslant = "\u2A7D";
    var lescc = "\u2AA8";
    var les = "\u2A7D";
    var lesdot = "\u2A7F";
    var lesdoto = "\u2A81";
    var lesdotor = "\u2A83";
    var lesg = "\u22DA\uFE00";
    var lesges = "\u2A93";
    var lessapprox = "\u2A85";
    var lessdot = "\u22D6";
    var lesseqgtr = "\u22DA";
    var lesseqqgtr = "\u2A8B";
    var LessEqualGreater = "\u22DA";
    var LessFullEqual = "\u2266";
    var LessGreater = "\u2276";
    var lessgtr = "\u2276";
    var LessLess = "\u2AA1";
    var lesssim = "\u2272";
    var LessSlantEqual = "\u2A7D";
    var LessTilde = "\u2272";
    var lfisht = "\u297C";
    var lfloor = "\u230A";
    var Lfr = "\uD835\uDD0F";
    var lfr = "\uD835\uDD29";
    var lg = "\u2276";
    var lgE = "\u2A91";
    var lHar = "\u2962";
    var lhard = "\u21BD";
    var lharu = "\u21BC";
    var lharul = "\u296A";
    var lhblk = "\u2584";
    var LJcy = "\u0409";
    var ljcy = "\u0459";
    var llarr = "\u21C7";
    var ll = "\u226A";
    var Ll = "\u22D8";
    var llcorner = "\u231E";
    var Lleftarrow = "\u21DA";
    var llhard = "\u296B";
    var lltri = "\u25FA";
    var Lmidot = "\u013F";
    var lmidot = "\u0140";
    var lmoustache = "\u23B0";
    var lmoust = "\u23B0";
    var lnap = "\u2A89";
    var lnapprox = "\u2A89";
    var lne = "\u2A87";
    var lnE = "\u2268";
    var lneq = "\u2A87";
    var lneqq = "\u2268";
    var lnsim = "\u22E6";
    var loang = "\u27EC";
    var loarr = "\u21FD";
    var lobrk = "\u27E6";
    var longleftarrow = "\u27F5";
    var LongLeftArrow = "\u27F5";
    var Longleftarrow = "\u27F8";
    var longleftrightarrow = "\u27F7";
    var LongLeftRightArrow = "\u27F7";
    var Longleftrightarrow = "\u27FA";
    var longmapsto = "\u27FC";
    var longrightarrow = "\u27F6";
    var LongRightArrow = "\u27F6";
    var Longrightarrow = "\u27F9";
    var looparrowleft = "\u21AB";
    var looparrowright = "\u21AC";
    var lopar = "\u2985";
    var Lopf = "\uD835\uDD43";
    var lopf = "\uD835\uDD5D";
    var loplus = "\u2A2D";
    var lotimes = "\u2A34";
    var lowast = "\u2217";
    var lowbar = "_";
    var LowerLeftArrow = "\u2199";
    var LowerRightArrow = "\u2198";
    var loz = "\u25CA";
    var lozenge = "\u25CA";
    var lozf = "\u29EB";
    var lpar = "(";
    var lparlt = "\u2993";
    var lrarr = "\u21C6";
    var lrcorner = "\u231F";
    var lrhar = "\u21CB";
    var lrhard = "\u296D";
    var lrm = "\u200E";
    var lrtri = "\u22BF";
    var lsaquo = "\u2039";
    var lscr = "\uD835\uDCC1";
    var Lscr = "\u2112";
    var lsh = "\u21B0";
    var Lsh = "\u21B0";
    var lsim = "\u2272";
    var lsime = "\u2A8D";
    var lsimg = "\u2A8F";
    var lsqb = "[";
    var lsquo = "\u2018";
    var lsquor = "\u201A";
    var Lstrok = "\u0141";
    var lstrok = "\u0142";
    var ltcc = "\u2AA6";
    var ltcir = "\u2A79";
    var lt = "<";
    var LT = "<";
    var Lt = "\u226A";
    var ltdot = "\u22D6";
    var lthree = "\u22CB";
    var ltimes = "\u22C9";
    var ltlarr = "\u2976";
    var ltquest = "\u2A7B";
    var ltri = "\u25C3";
    var ltrie = "\u22B4";
    var ltrif = "\u25C2";
    var ltrPar = "\u2996";
    var lurdshar = "\u294A";
    var luruhar = "\u2966";
    var lvertneqq = "\u2268\uFE00";
    var lvnE = "\u2268\uFE00";
    var macr = "\xaf";
    var male = "\u2642";
    var malt = "\u2720";
    var maltese = "\u2720";
    var map = "\u21A6";
    var mapsto = "\u21A6";
    var mapstodown = "\u21A7";
    var mapstoleft = "\u21A4";
    var mapstoup = "\u21A5";
    var marker = "\u25AE";
    var mcomma = "\u2A29";
    var Mcy = "\u041C";
    var mcy = "\u043C";
    var mdash = "\u2014";
    var mDDot = "\u223A";
    var measuredangle = "\u2221";
    var MediumSpace = "\u205F";
    var Mellintrf = "\u2133";
    var Mfr = "\uD835\uDD10";
    var mfr = "\uD835\uDD2A";
    var mho = "\u2127";
    var micro = "\xb5";
    var midast = "*";
    var midcir = "\u2AF0";
    var mid = "\u2223";
    var middot = "\xb7";
    var minusb = "\u229F";
    var minus = "\u2212";
    var minusd = "\u2238";
    var minusdu = "\u2A2A";
    var MinusPlus = "\u2213";
    var mlcp = "\u2ADB";
    var mldr = "\u2026";
    var mnplus = "\u2213";
    var models = "\u22A7";
    var Mopf = "\uD835\uDD44";
    var mopf = "\uD835\uDD5E";
    var mp = "\u2213";
    var mscr = "\uD835\uDCC2";
    var Mscr = "\u2133";
    var mstpos = "\u223E";
    var Mu = "\u039C";
    var mu = "\u03BC";
    var multimap = "\u22B8";
    var mumap = "\u22B8";
    var nabla = "\u2207";
    var Nacute = "\u0143";
    var nacute = "\u0144";
    var nang = "\u2220\u20D2";
    var nap = "\u2249";
    var napE = "\u2A70\u0338";
    var napid = "\u224B\u0338";
    var napos = "\u0149";
    var napprox = "\u2249";
    var natural = "\u266E";
    var naturals = "\u2115";
    var natur = "\u266E";
    var nbsp = "\xa0";
    var nbump = "\u224E\u0338";
    var nbumpe = "\u224F\u0338";
    var ncap = "\u2A43";
    var Ncaron = "\u0147";
    var ncaron = "\u0148";
    var Ncedil = "\u0145";
    var ncedil = "\u0146";
    var ncong = "\u2247";
    var ncongdot = "\u2A6D\u0338";
    var ncup = "\u2A42";
    var Ncy = "\u041D";
    var ncy = "\u043D";
    var ndash = "\u2013";
    var nearhk = "\u2924";
    var nearr = "\u2197";
    var neArr = "\u21D7";
    var nearrow = "\u2197";
    var ne = "\u2260";
    var nedot = "\u2250\u0338";
    var NegativeMediumSpace = "\u200B";
    var NegativeThickSpace = "\u200B";
    var NegativeThinSpace = "\u200B";
    var NegativeVeryThinSpace = "\u200B";
    var nequiv = "\u2262";
    var nesear = "\u2928";
    var nesim = "\u2242\u0338";
    var NestedGreaterGreater = "\u226B";
    var NestedLessLess = "\u226A";
    var NewLine = "\n";
    var nexist = "\u2204";
    var nexists = "\u2204";
    var Nfr = "\uD835\uDD11";
    var nfr = "\uD835\uDD2B";
    var ngE = "\u2267\u0338";
    var nge = "\u2271";
    var ngeq = "\u2271";
    var ngeqq = "\u2267\u0338";
    var ngeqslant = "\u2A7E\u0338";
    var nges = "\u2A7E\u0338";
    var nGg = "\u22D9\u0338";
    var ngsim = "\u2275";
    var nGt = "\u226B\u20D2";
    var ngt = "\u226F";
    var ngtr = "\u226F";
    var nGtv = "\u226B\u0338";
    var nharr = "\u21AE";
    var nhArr = "\u21CE";
    var nhpar = "\u2AF2";
    var ni = "\u220B";
    var nis = "\u22FC";
    var nisd = "\u22FA";
    var niv = "\u220B";
    var NJcy = "\u040A";
    var njcy = "\u045A";
    var nlarr = "\u219A";
    var nlArr = "\u21CD";
    var nldr = "\u2025";
    var nlE = "\u2266\u0338";
    var nle = "\u2270";
    var nleftarrow = "\u219A";
    var nLeftarrow = "\u21CD";
    var nleftrightarrow = "\u21AE";
    var nLeftrightarrow = "\u21CE";
    var nleq = "\u2270";
    var nleqq = "\u2266\u0338";
    var nleqslant = "\u2A7D\u0338";
    var nles = "\u2A7D\u0338";
    var nless = "\u226E";
    var nLl = "\u22D8\u0338";
    var nlsim = "\u2274";
    var nLt = "\u226A\u20D2";
    var nlt = "\u226E";
    var nltri = "\u22EA";
    var nltrie = "\u22EC";
    var nLtv = "\u226A\u0338";
    var nmid = "\u2224";
    var NoBreak = "\u2060";
    var NonBreakingSpace = "\xa0";
    var nopf = "\uD835\uDD5F";
    var Nopf = "\u2115";
    var Not = "\u2AEC";
    var not = "\xac";
    var NotCongruent = "\u2262";
    var NotCupCap = "\u226D";
    var NotDoubleVerticalBar = "\u2226";
    var NotElement = "\u2209";
    var NotEqual = "\u2260";
    var NotEqualTilde = "\u2242\u0338";
    var NotExists = "\u2204";
    var NotGreater = "\u226F";
    var NotGreaterEqual = "\u2271";
    var NotGreaterFullEqual = "\u2267\u0338";
    var NotGreaterGreater = "\u226B\u0338";
    var NotGreaterLess = "\u2279";
    var NotGreaterSlantEqual = "\u2A7E\u0338";
    var NotGreaterTilde = "\u2275";
    var NotHumpDownHump = "\u224E\u0338";
    var NotHumpEqual = "\u224F\u0338";
    var notin = "\u2209";
    var notindot = "\u22F5\u0338";
    var notinE = "\u22F9\u0338";
    var notinva = "\u2209";
    var notinvb = "\u22F7";
    var notinvc = "\u22F6";
    var NotLeftTriangleBar = "\u29CF\u0338";
    var NotLeftTriangle = "\u22EA";
    var NotLeftTriangleEqual = "\u22EC";
    var NotLess = "\u226E";
    var NotLessEqual = "\u2270";
    var NotLessGreater = "\u2278";
    var NotLessLess = "\u226A\u0338";
    var NotLessSlantEqual = "\u2A7D\u0338";
    var NotLessTilde = "\u2274";
    var NotNestedGreaterGreater = "\u2AA2\u0338";
    var NotNestedLessLess = "\u2AA1\u0338";
    var notni = "\u220C";
    var notniva = "\u220C";
    var notnivb = "\u22FE";
    var notnivc = "\u22FD";
    var NotPrecedes = "\u2280";
    var NotPrecedesEqual = "\u2AAF\u0338";
    var NotPrecedesSlantEqual = "\u22E0";
    var NotReverseElement = "\u220C";
    var NotRightTriangleBar = "\u29D0\u0338";
    var NotRightTriangle = "\u22EB";
    var NotRightTriangleEqual = "\u22ED";
    var NotSquareSubset = "\u228F\u0338";
    var NotSquareSubsetEqual = "\u22E2";
    var NotSquareSuperset = "\u2290\u0338";
    var NotSquareSupersetEqual = "\u22E3";
    var NotSubset = "\u2282\u20D2";
    var NotSubsetEqual = "\u2288";
    var NotSucceeds = "\u2281";
    var NotSucceedsEqual = "\u2AB0\u0338";
    var NotSucceedsSlantEqual = "\u22E1";
    var NotSucceedsTilde = "\u227F\u0338";
    var NotSuperset = "\u2283\u20D2";
    var NotSupersetEqual = "\u2289";
    var NotTilde = "\u2241";
    var NotTildeEqual = "\u2244";
    var NotTildeFullEqual = "\u2247";
    var NotTildeTilde = "\u2249";
    var NotVerticalBar = "\u2224";
    var nparallel = "\u2226";
    var npar = "\u2226";
    var nparsl = "\u2AFD\u20E5";
    var npart = "\u2202\u0338";
    var npolint = "\u2A14";
    var npr = "\u2280";
    var nprcue = "\u22E0";
    var nprec = "\u2280";
    var npreceq = "\u2AAF\u0338";
    var npre = "\u2AAF\u0338";
    var nrarrc = "\u2933\u0338";
    var nrarr = "\u219B";
    var nrArr = "\u21CF";
    var nrarrw = "\u219D\u0338";
    var nrightarrow = "\u219B";
    var nRightarrow = "\u21CF";
    var nrtri = "\u22EB";
    var nrtrie = "\u22ED";
    var nsc = "\u2281";
    var nsccue = "\u22E1";
    var nsce = "\u2AB0\u0338";
    var Nscr = "\uD835\uDCA9";
    var nscr = "\uD835\uDCC3";
    var nshortmid = "\u2224";
    var nshortparallel = "\u2226";
    var nsim = "\u2241";
    var nsime = "\u2244";
    var nsimeq = "\u2244";
    var nsmid = "\u2224";
    var nspar = "\u2226";
    var nsqsube = "\u22E2";
    var nsqsupe = "\u22E3";
    var nsub = "\u2284";
    var nsubE = "\u2AC5\u0338";
    var nsube = "\u2288";
    var nsubset = "\u2282\u20D2";
    var nsubseteq = "\u2288";
    var nsubseteqq = "\u2AC5\u0338";
    var nsucc = "\u2281";
    var nsucceq = "\u2AB0\u0338";
    var nsup = "\u2285";
    var nsupE = "\u2AC6\u0338";
    var nsupe = "\u2289";
    var nsupset = "\u2283\u20D2";
    var nsupseteq = "\u2289";
    var nsupseteqq = "\u2AC6\u0338";
    var ntgl = "\u2279";
    var Ntilde = "\xd1";
    var ntilde = "\xf1";
    var ntlg = "\u2278";
    var ntriangleleft = "\u22EA";
    var ntrianglelefteq = "\u22EC";
    var ntriangleright = "\u22EB";
    var ntrianglerighteq = "\u22ED";
    var Nu = "\u039D";
    var nu = "\u03BD";
    var num = "#";
    var numero = "\u2116";
    var numsp = "\u2007";
    var nvap = "\u224D\u20D2";
    var nvdash = "\u22AC";
    var nvDash = "\u22AD";
    var nVdash = "\u22AE";
    var nVDash = "\u22AF";
    var nvge = "\u2265\u20D2";
    var nvgt = ">\u20D2";
    var nvHarr = "\u2904";
    var nvinfin = "\u29DE";
    var nvlArr = "\u2902";
    var nvle = "\u2264\u20D2";
    var nvlt = "<\u20D2";
    var nvltrie = "\u22B4\u20D2";
    var nvrArr = "\u2903";
    var nvrtrie = "\u22B5\u20D2";
    var nvsim = "\u223C\u20D2";
    var nwarhk = "\u2923";
    var nwarr = "\u2196";
    var nwArr = "\u21D6";
    var nwarrow = "\u2196";
    var nwnear = "\u2927";
    var Oacute = "\xd3";
    var oacute = "\xf3";
    var oast = "\u229B";
    var Ocirc = "\xd4";
    var ocirc = "\xf4";
    var ocir = "\u229A";
    var Ocy = "\u041E";
    var ocy = "\u043E";
    var odash = "\u229D";
    var Odblac = "\u0150";
    var odblac = "\u0151";
    var odiv = "\u2A38";
    var odot = "\u2299";
    var odsold = "\u29BC";
    var OElig = "\u0152";
    var oelig = "\u0153";
    var ofcir = "\u29BF";
    var Ofr = "\uD835\uDD12";
    var ofr = "\uD835\uDD2C";
    var ogon = "\u02DB";
    var Ograve = "\xd2";
    var ograve = "\xf2";
    var ogt = "\u29C1";
    var ohbar = "\u29B5";
    var ohm = "\u03A9";
    var oint = "\u222E";
    var olarr = "\u21BA";
    var olcir = "\u29BE";
    var olcross = "\u29BB";
    var oline = "\u203E";
    var olt = "\u29C0";
    var Omacr = "\u014C";
    var omacr = "\u014D";
    var Omega = "\u03A9";
    var omega = "\u03C9";
    var Omicron = "\u039F";
    var omicron = "\u03BF";
    var omid = "\u29B6";
    var ominus = "\u2296";
    var Oopf = "\uD835\uDD46";
    var oopf = "\uD835\uDD60";
    var opar = "\u29B7";
    var OpenCurlyDoubleQuote = "\u201C";
    var OpenCurlyQuote = "\u2018";
    var operp = "\u29B9";
    var oplus = "\u2295";
    var orarr = "\u21BB";
    var Or = "\u2A54";
    var or = "\u2228";
    var ord = "\u2A5D";
    var order = "\u2134";
    var orderof = "\u2134";
    var ordf = "\xaa";
    var ordm = "\xba";
    var origof = "\u22B6";
    var oror = "\u2A56";
    var orslope = "\u2A57";
    var orv = "\u2A5B";
    var oS = "\u24C8";
    var Oscr = "\uD835\uDCAA";
    var oscr = "\u2134";
    var Oslash = "\xd8";
    var oslash = "\xf8";
    var osol = "\u2298";
    var Otilde = "\xd5";
    var otilde = "\xf5";
    var otimesas = "\u2A36";
    var Otimes = "\u2A37";
    var otimes = "\u2297";
    var Ouml = "\xd6";
    var ouml = "\xf6";
    var ovbar = "\u233D";
    var OverBar = "\u203E";
    var OverBrace = "\u23DE";
    var OverBracket = "\u23B4";
    var OverParenthesis = "\u23DC";
    var para = "\xb6";
    var parallel = "\u2225";
    var par = "\u2225";
    var parsim = "\u2AF3";
    var parsl = "\u2AFD";
    var part = "\u2202";
    var PartialD = "\u2202";
    var Pcy = "\u041F";
    var pcy = "\u043F";
    var percnt = "%";
    var period = ".";
    var permil = "\u2030";
    var perp = "\u22A5";
    var pertenk = "\u2031";
    var Pfr = "\uD835\uDD13";
    var pfr = "\uD835\uDD2D";
    var Phi = "\u03A6";
    var phi = "\u03C6";
    var phiv = "\u03D5";
    var phmmat = "\u2133";
    var phone = "\u260E";
    var Pi = "\u03A0";
    var pi = "\u03C0";
    var pitchfork = "\u22D4";
    var piv = "\u03D6";
    var planck = "\u210F";
    var planckh = "\u210E";
    var plankv = "\u210F";
    var plusacir = "\u2A23";
    var plusb = "\u229E";
    var pluscir = "\u2A22";
    var plus = "+";
    var plusdo = "\u2214";
    var plusdu = "\u2A25";
    var pluse = "\u2A72";
    var PlusMinus = "\xb1";
    var plusmn = "\xb1";
    var plussim = "\u2A26";
    var plustwo = "\u2A27";
    var pm = "\xb1";
    var Poincareplane = "\u210C";
    var pointint = "\u2A15";
    var popf = "\uD835\uDD61";
    var Popf = "\u2119";
    var pound = "\xa3";
    var prap = "\u2AB7";
    var Pr = "\u2ABB";
    var pr = "\u227A";
    var prcue = "\u227C";
    var precapprox = "\u2AB7";
    var prec = "\u227A";
    var preccurlyeq = "\u227C";
    var Precedes = "\u227A";
    var PrecedesEqual = "\u2AAF";
    var PrecedesSlantEqual = "\u227C";
    var PrecedesTilde = "\u227E";
    var preceq = "\u2AAF";
    var precnapprox = "\u2AB9";
    var precneqq = "\u2AB5";
    var precnsim = "\u22E8";
    var pre = "\u2AAF";
    var prE = "\u2AB3";
    var precsim = "\u227E";
    var prime = "\u2032";
    var Prime = "\u2033";
    var primes = "\u2119";
    var prnap = "\u2AB9";
    var prnE = "\u2AB5";
    var prnsim = "\u22E8";
    var prod = "\u220F";
    var Product = "\u220F";
    var profalar = "\u232E";
    var profline = "\u2312";
    var profsurf = "\u2313";
    var prop = "\u221D";
    var Proportional = "\u221D";
    var Proportion = "\u2237";
    var propto = "\u221D";
    var prsim = "\u227E";
    var prurel = "\u22B0";
    var Pscr = "\uD835\uDCAB";
    var pscr = "\uD835\uDCC5";
    var Psi = "\u03A8";
    var psi = "\u03C8";
    var puncsp = "\u2008";
    var Qfr = "\uD835\uDD14";
    var qfr = "\uD835\uDD2E";
    var qint = "\u2A0C";
    var qopf = "\uD835\uDD62";
    var Qopf = "\u211A";
    var qprime = "\u2057";
    var Qscr = "\uD835\uDCAC";
    var qscr = "\uD835\uDCC6";
    var quaternions = "\u210D";
    var quatint = "\u2A16";
    var quest = "?";
    var questeq = "\u225F";
    var quot = "\"";
    var QUOT = "\"";
    var rAarr = "\u21DB";
    var race = "\u223D\u0331";
    var Racute = "\u0154";
    var racute = "\u0155";
    var radic = "\u221A";
    var raemptyv = "\u29B3";
    var rang = "\u27E9";
    var Rang = "\u27EB";
    var rangd = "\u2992";
    var range = "\u29A5";
    var rangle = "\u27E9";
    var raquo = "\xbb";
    var rarrap = "\u2975";
    var rarrb = "\u21E5";
    var rarrbfs = "\u2920";
    var rarrc = "\u2933";
    var rarr = "\u2192";
    var Rarr = "\u21A0";
    var rArr = "\u21D2";
    var rarrfs = "\u291E";
    var rarrhk = "\u21AA";
    var rarrlp = "\u21AC";
    var rarrpl = "\u2945";
    var rarrsim = "\u2974";
    var Rarrtl = "\u2916";
    var rarrtl = "\u21A3";
    var rarrw = "\u219D";
    var ratail = "\u291A";
    var rAtail = "\u291C";
    var ratio = "\u2236";
    var rationals = "\u211A";
    var rbarr = "\u290D";
    var rBarr = "\u290F";
    var RBarr = "\u2910";
    var rbbrk = "\u2773";
    var rbrace = "}";
    var rbrack = "]";
    var rbrke = "\u298C";
    var rbrksld = "\u298E";
    var rbrkslu = "\u2990";
    var Rcaron = "\u0158";
    var rcaron = "\u0159";
    var Rcedil = "\u0156";
    var rcedil = "\u0157";
    var rceil = "\u2309";
    var rcub = "}";
    var Rcy = "\u0420";
    var rcy = "\u0440";
    var rdca = "\u2937";
    var rdldhar = "\u2969";
    var rdquo = "\u201D";
    var rdquor = "\u201D";
    var rdsh = "\u21B3";
    var real = "\u211C";
    var realine = "\u211B";
    var realpart = "\u211C";
    var reals = "\u211D";
    var Re = "\u211C";
    var rect = "\u25AD";
    var reg = "\xae";
    var REG = "\xae";
    var ReverseElement = "\u220B";
    var ReverseEquilibrium = "\u21CB";
    var ReverseUpEquilibrium = "\u296F";
    var rfisht = "\u297D";
    var rfloor = "\u230B";
    var rfr = "\uD835\uDD2F";
    var Rfr = "\u211C";
    var rHar = "\u2964";
    var rhard = "\u21C1";
    var rharu = "\u21C0";
    var rharul = "\u296C";
    var Rho = "\u03A1";
    var rho = "\u03C1";
    var rhov = "\u03F1";
    var RightAngleBracket = "\u27E9";
    var RightArrowBar = "\u21E5";
    var rightarrow = "\u2192";
    var RightArrow = "\u2192";
    var Rightarrow = "\u21D2";
    var RightArrowLeftArrow = "\u21C4";
    var rightarrowtail = "\u21A3";
    var RightCeiling = "\u2309";
    var RightDoubleBracket = "\u27E7";
    var RightDownTeeVector = "\u295D";
    var RightDownVectorBar = "\u2955";
    var RightDownVector = "\u21C2";
    var RightFloor = "\u230B";
    var rightharpoondown = "\u21C1";
    var rightharpoonup = "\u21C0";
    var rightleftarrows = "\u21C4";
    var rightleftharpoons = "\u21CC";
    var rightrightarrows = "\u21C9";
    var rightsquigarrow = "\u219D";
    var RightTeeArrow = "\u21A6";
    var RightTee = "\u22A2";
    var RightTeeVector = "\u295B";
    var rightthreetimes = "\u22CC";
    var RightTriangleBar = "\u29D0";
    var RightTriangle = "\u22B3";
    var RightTriangleEqual = "\u22B5";
    var RightUpDownVector = "\u294F";
    var RightUpTeeVector = "\u295C";
    var RightUpVectorBar = "\u2954";
    var RightUpVector = "\u21BE";
    var RightVectorBar = "\u2953";
    var RightVector = "\u21C0";
    var ring = "\u02DA";
    var risingdotseq = "\u2253";
    var rlarr = "\u21C4";
    var rlhar = "\u21CC";
    var rlm = "\u200F";
    var rmoustache = "\u23B1";
    var rmoust = "\u23B1";
    var rnmid = "\u2AEE";
    var roang = "\u27ED";
    var roarr = "\u21FE";
    var robrk = "\u27E7";
    var ropar = "\u2986";
    var ropf = "\uD835\uDD63";
    var Ropf = "\u211D";
    var roplus = "\u2A2E";
    var rotimes = "\u2A35";
    var RoundImplies = "\u2970";
    var rpar = ")";
    var rpargt = "\u2994";
    var rppolint = "\u2A12";
    var rrarr = "\u21C9";
    var Rrightarrow = "\u21DB";
    var rsaquo = "\u203A";
    var rscr = "\uD835\uDCC7";
    var Rscr = "\u211B";
    var rsh = "\u21B1";
    var Rsh = "\u21B1";
    var rsqb = "]";
    var rsquo = "\u2019";
    var rsquor = "\u2019";
    var rthree = "\u22CC";
    var rtimes = "\u22CA";
    var rtri = "\u25B9";
    var rtrie = "\u22B5";
    var rtrif = "\u25B8";
    var rtriltri = "\u29CE";
    var RuleDelayed = "\u29F4";
    var ruluhar = "\u2968";
    var rx = "\u211E";
    var Sacute = "\u015A";
    var sacute = "\u015B";
    var sbquo = "\u201A";
    var scap = "\u2AB8";
    var Scaron = "\u0160";
    var scaron = "\u0161";
    var Sc = "\u2ABC";
    var sc = "\u227B";
    var sccue = "\u227D";
    var sce = "\u2AB0";
    var scE = "\u2AB4";
    var Scedil = "\u015E";
    var scedil = "\u015F";
    var Scirc = "\u015C";
    var scirc = "\u015D";
    var scnap = "\u2ABA";
    var scnE = "\u2AB6";
    var scnsim = "\u22E9";
    var scpolint = "\u2A13";
    var scsim = "\u227F";
    var Scy = "\u0421";
    var scy = "\u0441";
    var sdotb = "\u22A1";
    var sdot = "\u22C5";
    var sdote = "\u2A66";
    var searhk = "\u2925";
    var searr = "\u2198";
    var seArr = "\u21D8";
    var searrow = "\u2198";
    var sect = "\xa7";
    var semi = ";";
    var seswar = "\u2929";
    var setminus = "\u2216";
    var setmn = "\u2216";
    var sext = "\u2736";
    var Sfr = "\uD835\uDD16";
    var sfr = "\uD835\uDD30";
    var sfrown = "\u2322";
    var sharp = "\u266F";
    var SHCHcy = "\u0429";
    var shchcy = "\u0449";
    var SHcy = "\u0428";
    var shcy = "\u0448";
    var ShortDownArrow = "\u2193";
    var ShortLeftArrow = "\u2190";
    var shortmid = "\u2223";
    var shortparallel = "\u2225";
    var ShortRightArrow = "\u2192";
    var ShortUpArrow = "\u2191";
    var shy = "\xad";
    var Sigma = "\u03A3";
    var sigma = "\u03C3";
    var sigmaf = "\u03C2";
    var sigmav = "\u03C2";
    var sim = "\u223C";
    var simdot = "\u2A6A";
    var sime = "\u2243";
    var simeq = "\u2243";
    var simg = "\u2A9E";
    var simgE = "\u2AA0";
    var siml = "\u2A9D";
    var simlE = "\u2A9F";
    var simne = "\u2246";
    var simplus = "\u2A24";
    var simrarr = "\u2972";
    var slarr = "\u2190";
    var SmallCircle = "\u2218";
    var smallsetminus = "\u2216";
    var smashp = "\u2A33";
    var smeparsl = "\u29E4";
    var smid = "\u2223";
    var smile = "\u2323";
    var smt = "\u2AAA";
    var smte = "\u2AAC";
    var smtes = "\u2AAC\uFE00";
    var SOFTcy = "\u042C";
    var softcy = "\u044C";
    var solbar = "\u233F";
    var solb = "\u29C4";
    var sol = "/";
    var Sopf = "\uD835\uDD4A";
    var sopf = "\uD835\uDD64";
    var spades = "\u2660";
    var spadesuit = "\u2660";
    var spar = "\u2225";
    var sqcap = "\u2293";
    var sqcaps = "\u2293\uFE00";
    var sqcup = "\u2294";
    var sqcups = "\u2294\uFE00";
    var Sqrt = "\u221A";
    var sqsub = "\u228F";
    var sqsube = "\u2291";
    var sqsubset = "\u228F";
    var sqsubseteq = "\u2291";
    var sqsup = "\u2290";
    var sqsupe = "\u2292";
    var sqsupset = "\u2290";
    var sqsupseteq = "\u2292";
    var square = "\u25A1";
    var Square = "\u25A1";
    var SquareIntersection = "\u2293";
    var SquareSubset = "\u228F";
    var SquareSubsetEqual = "\u2291";
    var SquareSuperset = "\u2290";
    var SquareSupersetEqual = "\u2292";
    var SquareUnion = "\u2294";
    var squarf = "\u25AA";
    var squ = "\u25A1";
    var squf = "\u25AA";
    var srarr = "\u2192";
    var Sscr = "\uD835\uDCAE";
    var sscr = "\uD835\uDCC8";
    var ssetmn = "\u2216";
    var ssmile = "\u2323";
    var sstarf = "\u22C6";
    var Star = "\u22C6";
    var star = "\u2606";
    var starf = "\u2605";
    var straightepsilon = "\u03F5";
    var straightphi = "\u03D5";
    var strns = "\xaf";
    var sub = "\u2282";
    var Sub = "\u22D0";
    var subdot = "\u2ABD";
    var subE = "\u2AC5";
    var sube = "\u2286";
    var subedot = "\u2AC3";
    var submult = "\u2AC1";
    var subnE = "\u2ACB";
    var subne = "\u228A";
    var subplus = "\u2ABF";
    var subrarr = "\u2979";
    var subset = "\u2282";
    var Subset = "\u22D0";
    var subseteq = "\u2286";
    var subseteqq = "\u2AC5";
    var SubsetEqual = "\u2286";
    var subsetneq = "\u228A";
    var subsetneqq = "\u2ACB";
    var subsim = "\u2AC7";
    var subsub = "\u2AD5";
    var subsup = "\u2AD3";
    var succapprox = "\u2AB8";
    var succ = "\u227B";
    var succcurlyeq = "\u227D";
    var Succeeds = "\u227B";
    var SucceedsEqual = "\u2AB0";
    var SucceedsSlantEqual = "\u227D";
    var SucceedsTilde = "\u227F";
    var succeq = "\u2AB0";
    var succnapprox = "\u2ABA";
    var succneqq = "\u2AB6";
    var succnsim = "\u22E9";
    var succsim = "\u227F";
    var SuchThat = "\u220B";
    var sum = "\u2211";
    var Sum = "\u2211";
    var sung = "\u266A";
    var sup1 = "\xb9";
    var sup2 = "\xb2";
    var sup3 = "\xb3";
    var sup = "\u2283";
    var Sup = "\u22D1";
    var supdot = "\u2ABE";
    var supdsub = "\u2AD8";
    var supE = "\u2AC6";
    var supe = "\u2287";
    var supedot = "\u2AC4";
    var Superset = "\u2283";
    var SupersetEqual = "\u2287";
    var suphsol = "\u27C9";
    var suphsub = "\u2AD7";
    var suplarr = "\u297B";
    var supmult = "\u2AC2";
    var supnE = "\u2ACC";
    var supne = "\u228B";
    var supplus = "\u2AC0";
    var supset = "\u2283";
    var Supset = "\u22D1";
    var supseteq = "\u2287";
    var supseteqq = "\u2AC6";
    var supsetneq = "\u228B";
    var supsetneqq = "\u2ACC";
    var supsim = "\u2AC8";
    var supsub = "\u2AD4";
    var supsup = "\u2AD6";
    var swarhk = "\u2926";
    var swarr = "\u2199";
    var swArr = "\u21D9";
    var swarrow = "\u2199";
    var swnwar = "\u292A";
    var szlig = "\xdf";
    var Tab = "\t";
    var target = "\u2316";
    var Tau = "\u03A4";
    var tau = "\u03C4";
    var tbrk = "\u23B4";
    var Tcaron = "\u0164";
    var tcaron = "\u0165";
    var Tcedil = "\u0162";
    var tcedil = "\u0163";
    var Tcy = "\u0422";
    var tcy = "\u0442";
    var tdot = "\u20DB";
    var telrec = "\u2315";
    var Tfr = "\uD835\uDD17";
    var tfr = "\uD835\uDD31";
    var there4 = "\u2234";
    var therefore = "\u2234";
    var Therefore = "\u2234";
    var Theta = "\u0398";
    var theta = "\u03B8";
    var thetasym = "\u03D1";
    var thetav = "\u03D1";
    var thickapprox = "\u2248";
    var thicksim = "\u223C";
    var ThickSpace = "\u205F\u200A";
    var ThinSpace = "\u2009";
    var thinsp = "\u2009";
    var thkap = "\u2248";
    var thksim = "\u223C";
    var THORN = "\xde";
    var thorn = "\xfe";
    var tilde = "\u02DC";
    var Tilde = "\u223C";
    var TildeEqual = "\u2243";
    var TildeFullEqual = "\u2245";
    var TildeTilde = "\u2248";
    var timesbar = "\u2A31";
    var timesb = "\u22A0";
    var times = "\xd7";
    var timesd = "\u2A30";
    var tint = "\u222D";
    var toea = "\u2928";
    var topbot = "\u2336";
    var topcir = "\u2AF1";
    var top = "\u22A4";
    var Topf = "\uD835\uDD4B";
    var topf = "\uD835\uDD65";
    var topfork = "\u2ADA";
    var tosa = "\u2929";
    var tprime = "\u2034";
    var trade = "\u2122";
    var TRADE = "\u2122";
    var triangle = "\u25B5";
    var triangledown = "\u25BF";
    var triangleleft = "\u25C3";
    var trianglelefteq = "\u22B4";
    var triangleq = "\u225C";
    var triangleright = "\u25B9";
    var trianglerighteq = "\u22B5";
    var tridot = "\u25EC";
    var trie = "\u225C";
    var triminus = "\u2A3A";
    var TripleDot = "\u20DB";
    var triplus = "\u2A39";
    var trisb = "\u29CD";
    var tritime = "\u2A3B";
    var trpezium = "\u23E2";
    var Tscr = "\uD835\uDCAF";
    var tscr = "\uD835\uDCC9";
    var TScy = "\u0426";
    var tscy = "\u0446";
    var TSHcy = "\u040B";
    var tshcy = "\u045B";
    var Tstrok = "\u0166";
    var tstrok = "\u0167";
    var twixt = "\u226C";
    var twoheadleftarrow = "\u219E";
    var twoheadrightarrow = "\u21A0";
    var Uacute = "\xda";
    var uacute = "\xfa";
    var uarr = "\u2191";
    var Uarr = "\u219F";
    var uArr = "\u21D1";
    var Uarrocir = "\u2949";
    var Ubrcy = "\u040E";
    var ubrcy = "\u045E";
    var Ubreve = "\u016C";
    var ubreve = "\u016D";
    var Ucirc = "\xdb";
    var ucirc = "\xfb";
    var Ucy = "\u0423";
    var ucy = "\u0443";
    var udarr = "\u21C5";
    var Udblac = "\u0170";
    var udblac = "\u0171";
    var udhar = "\u296E";
    var ufisht = "\u297E";
    var Ufr = "\uD835\uDD18";
    var ufr = "\uD835\uDD32";
    var Ugrave = "\xd9";
    var ugrave = "\xf9";
    var uHar = "\u2963";
    var uharl = "\u21BF";
    var uharr = "\u21BE";
    var uhblk = "\u2580";
    var ulcorn = "\u231C";
    var ulcorner = "\u231C";
    var ulcrop = "\u230F";
    var ultri = "\u25F8";
    var Umacr = "\u016A";
    var umacr = "\u016B";
    var uml = "\xa8";
    var UnderBar = "_";
    var UnderBrace = "\u23DF";
    var UnderBracket = "\u23B5";
    var UnderParenthesis = "\u23DD";
    var Union = "\u22C3";
    var UnionPlus = "\u228E";
    var Uogon = "\u0172";
    var uogon = "\u0173";
    var Uopf = "\uD835\uDD4C";
    var uopf = "\uD835\uDD66";
    var UpArrowBar = "\u2912";
    var uparrow = "\u2191";
    var UpArrow = "\u2191";
    var Uparrow = "\u21D1";
    var UpArrowDownArrow = "\u21C5";
    var updownarrow = "\u2195";
    var UpDownArrow = "\u2195";
    var Updownarrow = "\u21D5";
    var UpEquilibrium = "\u296E";
    var upharpoonleft = "\u21BF";
    var upharpoonright = "\u21BE";
    var uplus = "\u228E";
    var UpperLeftArrow = "\u2196";
    var UpperRightArrow = "\u2197";
    var upsi = "\u03C5";
    var Upsi = "\u03D2";
    var upsih = "\u03D2";
    var Upsilon = "\u03A5";
    var upsilon = "\u03C5";
    var UpTeeArrow = "\u21A5";
    var UpTee = "\u22A5";
    var upuparrows = "\u21C8";
    var urcorn = "\u231D";
    var urcorner = "\u231D";
    var urcrop = "\u230E";
    var Uring = "\u016E";
    var uring = "\u016F";
    var urtri = "\u25F9";
    var Uscr = "\uD835\uDCB0";
    var uscr = "\uD835\uDCCA";
    var utdot = "\u22F0";
    var Utilde = "\u0168";
    var utilde = "\u0169";
    var utri = "\u25B5";
    var utrif = "\u25B4";
    var uuarr = "\u21C8";
    var Uuml = "\xdc";
    var uuml = "\xfc";
    var uwangle = "\u29A7";
    var vangrt = "\u299C";
    var varepsilon = "\u03F5";
    var varkappa = "\u03F0";
    var varnothing = "\u2205";
    var varphi = "\u03D5";
    var varpi = "\u03D6";
    var varpropto = "\u221D";
    var varr = "\u2195";
    var vArr = "\u21D5";
    var varrho = "\u03F1";
    var varsigma = "\u03C2";
    var varsubsetneq = "\u228A\uFE00";
    var varsubsetneqq = "\u2ACB\uFE00";
    var varsupsetneq = "\u228B\uFE00";
    var varsupsetneqq = "\u2ACC\uFE00";
    var vartheta = "\u03D1";
    var vartriangleleft = "\u22B2";
    var vartriangleright = "\u22B3";
    var vBar = "\u2AE8";
    var Vbar = "\u2AEB";
    var vBarv = "\u2AE9";
    var Vcy = "\u0412";
    var vcy = "\u0432";
    var vdash = "\u22A2";
    var vDash = "\u22A8";
    var Vdash = "\u22A9";
    var VDash = "\u22AB";
    var Vdashl = "\u2AE6";
    var veebar = "\u22BB";
    var vee = "\u2228";
    var Vee = "\u22C1";
    var veeeq = "\u225A";
    var vellip = "\u22EE";
    var verbar = "|";
    var Verbar = "\u2016";
    var vert = "|";
    var Vert = "\u2016";
    var VerticalBar = "\u2223";
    var VerticalLine = "|";
    var VerticalSeparator = "\u2758";
    var VerticalTilde = "\u2240";
    var VeryThinSpace = "\u200A";
    var Vfr = "\uD835\uDD19";
    var vfr = "\uD835\uDD33";
    var vltri = "\u22B2";
    var vnsub = "\u2282\u20D2";
    var vnsup = "\u2283\u20D2";
    var Vopf = "\uD835\uDD4D";
    var vopf = "\uD835\uDD67";
    var vprop = "\u221D";
    var vrtri = "\u22B3";
    var Vscr = "\uD835\uDCB1";
    var vscr = "\uD835\uDCCB";
    var vsubnE = "\u2ACB\uFE00";
    var vsubne = "\u228A\uFE00";
    var vsupnE = "\u2ACC\uFE00";
    var vsupne = "\u228B\uFE00";
    var Vvdash = "\u22AA";
    var vzigzag = "\u299A";
    var Wcirc = "\u0174";
    var wcirc = "\u0175";
    var wedbar = "\u2A5F";
    var wedge = "\u2227";
    var Wedge = "\u22C0";
    var wedgeq = "\u2259";
    var weierp = "\u2118";
    var Wfr = "\uD835\uDD1A";
    var wfr = "\uD835\uDD34";
    var Wopf = "\uD835\uDD4E";
    var wopf = "\uD835\uDD68";
    var wp = "\u2118";
    var wr = "\u2240";
    var wreath = "\u2240";
    var Wscr = "\uD835\uDCB2";
    var wscr = "\uD835\uDCCC";
    var xcap = "\u22C2";
    var xcirc = "\u25EF";
    var xcup = "\u22C3";
    var xdtri = "\u25BD";
    var Xfr = "\uD835\uDD1B";
    var xfr = "\uD835\uDD35";
    var xharr = "\u27F7";
    var xhArr = "\u27FA";
    var Xi = "\u039E";
    var xi = "\u03BE";
    var xlarr = "\u27F5";
    var xlArr = "\u27F8";
    var xmap = "\u27FC";
    var xnis = "\u22FB";
    var xodot = "\u2A00";
    var Xopf = "\uD835\uDD4F";
    var xopf = "\uD835\uDD69";
    var xoplus = "\u2A01";
    var xotime = "\u2A02";
    var xrarr = "\u27F6";
    var xrArr = "\u27F9";
    var Xscr = "\uD835\uDCB3";
    var xscr = "\uD835\uDCCD";
    var xsqcup = "\u2A06";
    var xuplus = "\u2A04";
    var xutri = "\u25B3";
    var xvee = "\u22C1";
    var xwedge = "\u22C0";
    var Yacute = "\xdd";
    var yacute = "\xfd";
    var YAcy = "\u042F";
    var yacy = "\u044F";
    var Ycirc = "\u0176";
    var ycirc = "\u0177";
    var Ycy = "\u042B";
    var ycy = "\u044B";
    var yen = "\xa5";
    var Yfr = "\uD835\uDD1C";
    var yfr = "\uD835\uDD36";
    var YIcy = "\u0407";
    var yicy = "\u0457";
    var Yopf = "\uD835\uDD50";
    var yopf = "\uD835\uDD6A";
    var Yscr = "\uD835\uDCB4";
    var yscr = "\uD835\uDCCE";
    var YUcy = "\u042E";
    var yucy = "\u044E";
    var yuml = "\xff";
    var Yuml = "\u0178";
    var Zacute = "\u0179";
    var zacute = "\u017A";
    var Zcaron = "\u017D";
    var zcaron = "\u017E";
    var Zcy = "\u0417";
    var zcy = "\u0437";
    var Zdot = "\u017B";
    var zdot = "\u017C";
    var zeetrf = "\u2128";
    var ZeroWidthSpace = "\u200B";
    var Zeta = "\u0396";
    var zeta = "\u03B6";
    var zfr = "\uD835\uDD37";
    var Zfr = "\u2128";
    var ZHcy = "\u0416";
    var zhcy = "\u0436";
    var zigrarr = "\u21DD";
    var zopf = "\uD835\uDD6B";
    var Zopf = "\u2124";
    var Zscr = "\uD835\uDCB5";
    var zscr = "\uD835\uDCCF";
    var zwj = "\u200D";
    var zwnj = "\u200C";
    var entities = {
        Aacute: Aacute,
        aacute: aacute,
        Abreve: Abreve,
        abreve: abreve,
        ac: ac,
        acd: acd,
        acE: acE,
        Acirc: Acirc,
        acirc: acirc,
        acute: acute,
        Acy: Acy,
        acy: acy,
        AElig: AElig,
        aelig: aelig,
        af: af,
        Afr: Afr,
        afr: afr,
        Agrave: Agrave,
        agrave: agrave,
        alefsym: alefsym,
        aleph: aleph,
        Alpha: Alpha,
        alpha: alpha,
        Amacr: Amacr,
        amacr: amacr,
        amalg: amalg,
        amp: amp,
        AMP: AMP,
        andand: andand,
        And: And,
        and: and,
        andd: andd,
        andslope: andslope,
        andv: andv,
        ang: ang,
        ange: ange,
        angle: angle,
        angmsdaa: angmsdaa,
        angmsdab: angmsdab,
        angmsdac: angmsdac,
        angmsdad: angmsdad,
        angmsdae: angmsdae,
        angmsdaf: angmsdaf,
        angmsdag: angmsdag,
        angmsdah: angmsdah,
        angmsd: angmsd,
        angrt: angrt,
        angrtvb: angrtvb,
        angrtvbd: angrtvbd,
        angsph: angsph,
        angst: angst,
        angzarr: angzarr,
        Aogon: Aogon,
        aogon: aogon,
        Aopf: Aopf,
        aopf: aopf,
        apacir: apacir,
        ap: ap,
        apE: apE,
        ape: ape,
        apid: apid,
        apos: apos,
        ApplyFunction: ApplyFunction,
        approx: approx,
        approxeq: approxeq,
        Aring: Aring,
        aring: aring,
        Ascr: Ascr,
        ascr: ascr,
        Assign: Assign,
        ast: ast,
        asymp: asymp,
        asympeq: asympeq,
        Atilde: Atilde,
        atilde: atilde,
        Auml: Auml,
        auml: auml,
        awconint: awconint,
        awint: awint,
        backcong: backcong,
        backepsilon: backepsilon,
        backprime: backprime,
        backsim: backsim,
        backsimeq: backsimeq,
        Backslash: Backslash,
        Barv: Barv,
        barvee: barvee,
        barwed: barwed,
        Barwed: Barwed,
        barwedge: barwedge,
        bbrk: bbrk,
        bbrktbrk: bbrktbrk,
        bcong: bcong,
        Bcy: Bcy,
        bcy: bcy,
        bdquo: bdquo,
        becaus: becaus,
        because: because,
        Because: Because,
        bemptyv: bemptyv,
        bepsi: bepsi,
        bernou: bernou,
        Bernoullis: Bernoullis,
        Beta: Beta,
        beta: beta,
        beth: beth,
        between: between,
        Bfr: Bfr,
        bfr: bfr,
        bigcap: bigcap,
        bigcirc: bigcirc,
        bigcup: bigcup,
        bigodot: bigodot,
        bigoplus: bigoplus,
        bigotimes: bigotimes,
        bigsqcup: bigsqcup,
        bigstar: bigstar,
        bigtriangledown: bigtriangledown,
        bigtriangleup: bigtriangleup,
        biguplus: biguplus,
        bigvee: bigvee,
        bigwedge: bigwedge,
        bkarow: bkarow,
        blacklozenge: blacklozenge,
        blacksquare: blacksquare,
        blacktriangle: blacktriangle,
        blacktriangledown: blacktriangledown,
        blacktriangleleft: blacktriangleleft,
        blacktriangleright: blacktriangleright,
        blank: blank,
        blk12: blk12,
        blk14: blk14,
        blk34: blk34,
        block: block,
        bne: bne,
        bnequiv: bnequiv,
        bNot: bNot,
        bnot: bnot,
        Bopf: Bopf,
        bopf: bopf,
        bot: bot,
        bottom: bottom,
        bowtie: bowtie,
        boxbox: boxbox,
        boxdl: boxdl,
        boxdL: boxdL,
        boxDl: boxDl,
        boxDL: boxDL,
        boxdr: boxdr,
        boxdR: boxdR,
        boxDr: boxDr,
        boxDR: boxDR,
        boxh: boxh,
        boxH: boxH,
        boxhd: boxhd,
        boxHd: boxHd,
        boxhD: boxhD,
        boxHD: boxHD,
        boxhu: boxhu,
        boxHu: boxHu,
        boxhU: boxhU,
        boxHU: boxHU,
        boxminus: boxminus,
        boxplus: boxplus,
        boxtimes: boxtimes,
        boxul: boxul,
        boxuL: boxuL,
        boxUl: boxUl,
        boxUL: boxUL,
        boxur: boxur,
        boxuR: boxuR,
        boxUr: boxUr,
        boxUR: boxUR,
        boxv: boxv,
        boxV: boxV,
        boxvh: boxvh,
        boxvH: boxvH,
        boxVh: boxVh,
        boxVH: boxVH,
        boxvl: boxvl,
        boxvL: boxvL,
        boxVl: boxVl,
        boxVL: boxVL,
        boxvr: boxvr,
        boxvR: boxvR,
        boxVr: boxVr,
        boxVR: boxVR,
        bprime: bprime,
        breve: breve,
        Breve: Breve,
        brvbar: brvbar,
        bscr: bscr,
        Bscr: Bscr,
        bsemi: bsemi,
        bsim: bsim,
        bsime: bsime,
        bsolb: bsolb,
        bsol: bsol,
        bsolhsub: bsolhsub,
        bull: bull,
        bullet: bullet,
        bump: bump,
        bumpE: bumpE,
        bumpe: bumpe,
        Bumpeq: Bumpeq,
        bumpeq: bumpeq,
        Cacute: Cacute,
        cacute: cacute,
        capand: capand,
        capbrcup: capbrcup,
        capcap: capcap,
        cap: cap,
        Cap: Cap,
        capcup: capcup,
        capdot: capdot,
        CapitalDifferentialD: CapitalDifferentialD,
        caps: caps,
        caret: caret,
        caron: caron,
        Cayleys: Cayleys,
        ccaps: ccaps,
        Ccaron: Ccaron,
        ccaron: ccaron,
        Ccedil: Ccedil,
        ccedil: ccedil,
        Ccirc: Ccirc,
        ccirc: ccirc,
        Cconint: Cconint,
        ccups: ccups,
        ccupssm: ccupssm,
        Cdot: Cdot,
        cdot: cdot,
        cedil: cedil,
        Cedilla: Cedilla,
        cemptyv: cemptyv,
        cent: cent,
        centerdot: centerdot,
        CenterDot: CenterDot,
        cfr: cfr,
        Cfr: Cfr,
        CHcy: CHcy,
        chcy: chcy,
        check: check,
        checkmark: checkmark,
        Chi: Chi,
        chi: chi,
        circ: circ,
        circeq: circeq,
        circlearrowleft: circlearrowleft,
        circlearrowright: circlearrowright,
        circledast: circledast,
        circledcirc: circledcirc,
        circleddash: circleddash,
        CircleDot: CircleDot,
        circledR: circledR,
        circledS: circledS,
        CircleMinus: CircleMinus,
        CirclePlus: CirclePlus,
        CircleTimes: CircleTimes,
        cir: cir,
        cirE: cirE,
        cire: cire,
        cirfnint: cirfnint,
        cirmid: cirmid,
        cirscir: cirscir,
        ClockwiseContourIntegral: ClockwiseContourIntegral,
        CloseCurlyDoubleQuote: CloseCurlyDoubleQuote,
        CloseCurlyQuote: CloseCurlyQuote,
        clubs: clubs,
        clubsuit: clubsuit,
        colon: colon,
        Colon: Colon,
        Colone: Colone,
        colone: colone,
        coloneq: coloneq,
        comma: comma,
        commat: commat,
        comp: comp,
        compfn: compfn,
        complement: complement,
        complexes: complexes,
        cong: cong,
        congdot: congdot,
        Congruent: Congruent,
        conint: conint,
        Conint: Conint,
        ContourIntegral: ContourIntegral,
        copf: copf,
        Copf: Copf,
        coprod: coprod,
        Coproduct: Coproduct,
        copy: copy,
        COPY: COPY,
        copysr: copysr,
        CounterClockwiseContourIntegral: CounterClockwiseContourIntegral,
        crarr: crarr,
        cross: cross,
        Cross: Cross,
        Cscr: Cscr,
        cscr: cscr,
        csub: csub,
        csube: csube,
        csup: csup,
        csupe: csupe,
        ctdot: ctdot,
        cudarrl: cudarrl,
        cudarrr: cudarrr,
        cuepr: cuepr,
        cuesc: cuesc,
        cularr: cularr,
        cularrp: cularrp,
        cupbrcap: cupbrcap,
        cupcap: cupcap,
        CupCap: CupCap,
        cup: cup,
        Cup: Cup,
        cupcup: cupcup,
        cupdot: cupdot,
        cupor: cupor,
        cups: cups,
        curarr: curarr,
        curarrm: curarrm,
        curlyeqprec: curlyeqprec,
        curlyeqsucc: curlyeqsucc,
        curlyvee: curlyvee,
        curlywedge: curlywedge,
        curren: curren,
        curvearrowleft: curvearrowleft,
        curvearrowright: curvearrowright,
        cuvee: cuvee,
        cuwed: cuwed,
        cwconint: cwconint,
        cwint: cwint,
        cylcty: cylcty,
        dagger: dagger,
        Dagger: Dagger,
        daleth: daleth,
        darr: darr,
        Darr: Darr,
        dArr: dArr,
        dash: dash,
        Dashv: Dashv,
        dashv: dashv,
        dbkarow: dbkarow,
        dblac: dblac,
        Dcaron: Dcaron,
        dcaron: dcaron,
        Dcy: Dcy,
        dcy: dcy,
        ddagger: ddagger,
        ddarr: ddarr,
        DD: DD,
        dd: dd,
        DDotrahd: DDotrahd,
        ddotseq: ddotseq,
        deg: deg,
        Del: Del,
        Delta: Delta,
        delta: delta,
        demptyv: demptyv,
        dfisht: dfisht,
        Dfr: Dfr,
        dfr: dfr,
        dHar: dHar,
        dharl: dharl,
        dharr: dharr,
        DiacriticalAcute: DiacriticalAcute,
        DiacriticalDot: DiacriticalDot,
        DiacriticalDoubleAcute: DiacriticalDoubleAcute,
        DiacriticalGrave: DiacriticalGrave,
        DiacriticalTilde: DiacriticalTilde,
        diam: diam,
        diamond: diamond,
        Diamond: Diamond,
        diamondsuit: diamondsuit,
        diams: diams,
        die: die,
        DifferentialD: DifferentialD,
        digamma: digamma,
        disin: disin,
        div: div,
        divide: divide,
        divideontimes: divideontimes,
        divonx: divonx,
        DJcy: DJcy,
        djcy: djcy,
        dlcorn: dlcorn,
        dlcrop: dlcrop,
        dollar: dollar,
        Dopf: Dopf,
        dopf: dopf,
        Dot: Dot,
        dot: dot,
        DotDot: DotDot,
        doteq: doteq,
        doteqdot: doteqdot,
        DotEqual: DotEqual,
        dotminus: dotminus,
        dotplus: dotplus,
        dotsquare: dotsquare,
        doublebarwedge: doublebarwedge,
        DoubleContourIntegral: DoubleContourIntegral,
        DoubleDot: DoubleDot,
        DoubleDownArrow: DoubleDownArrow,
        DoubleLeftArrow: DoubleLeftArrow,
        DoubleLeftRightArrow: DoubleLeftRightArrow,
        DoubleLeftTee: DoubleLeftTee,
        DoubleLongLeftArrow: DoubleLongLeftArrow,
        DoubleLongLeftRightArrow: DoubleLongLeftRightArrow,
        DoubleLongRightArrow: DoubleLongRightArrow,
        DoubleRightArrow: DoubleRightArrow,
        DoubleRightTee: DoubleRightTee,
        DoubleUpArrow: DoubleUpArrow,
        DoubleUpDownArrow: DoubleUpDownArrow,
        DoubleVerticalBar: DoubleVerticalBar,
        DownArrowBar: DownArrowBar,
        downarrow: downarrow,
        DownArrow: DownArrow,
        Downarrow: Downarrow,
        DownArrowUpArrow: DownArrowUpArrow,
        DownBreve: DownBreve,
        downdownarrows: downdownarrows,
        downharpoonleft: downharpoonleft,
        downharpoonright: downharpoonright,
        DownLeftRightVector: DownLeftRightVector,
        DownLeftTeeVector: DownLeftTeeVector,
        DownLeftVectorBar: DownLeftVectorBar,
        DownLeftVector: DownLeftVector,
        DownRightTeeVector: DownRightTeeVector,
        DownRightVectorBar: DownRightVectorBar,
        DownRightVector: DownRightVector,
        DownTeeArrow: DownTeeArrow,
        DownTee: DownTee,
        drbkarow: drbkarow,
        drcorn: drcorn,
        drcrop: drcrop,
        Dscr: Dscr,
        dscr: dscr,
        DScy: DScy,
        dscy: dscy,
        dsol: dsol,
        Dstrok: Dstrok,
        dstrok: dstrok,
        dtdot: dtdot,
        dtri: dtri,
        dtrif: dtrif,
        duarr: duarr,
        duhar: duhar,
        dwangle: dwangle,
        DZcy: DZcy,
        dzcy: dzcy,
        dzigrarr: dzigrarr,
        Eacute: Eacute,
        eacute: eacute,
        easter: easter,
        Ecaron: Ecaron,
        ecaron: ecaron,
        Ecirc: Ecirc,
        ecirc: ecirc,
        ecir: ecir,
        ecolon: ecolon,
        Ecy: Ecy,
        ecy: ecy,
        eDDot: eDDot,
        Edot: Edot,
        edot: edot,
        eDot: eDot,
        ee: ee,
        efDot: efDot,
        Efr: Efr,
        efr: efr,
        eg: eg,
        Egrave: Egrave,
        egrave: egrave,
        egs: egs,
        egsdot: egsdot,
        el: el,
        Element: Element,
        elinters: elinters,
        ell: ell,
        els: els,
        elsdot: elsdot,
        Emacr: Emacr,
        emacr: emacr,
        empty: empty,
        emptyset: emptyset,
        EmptySmallSquare: EmptySmallSquare,
        emptyv: emptyv,
        EmptyVerySmallSquare: EmptyVerySmallSquare,
        emsp13: emsp13,
        emsp14: emsp14,
        emsp: emsp,
        ENG: ENG,
        eng: eng,
        ensp: ensp,
        Eogon: Eogon,
        eogon: eogon,
        Eopf: Eopf,
        eopf: eopf,
        epar: epar,
        eparsl: eparsl,
        eplus: eplus,
        epsi: epsi,
        Epsilon: Epsilon,
        epsilon: epsilon,
        epsiv: epsiv,
        eqcirc: eqcirc,
        eqcolon: eqcolon,
        eqsim: eqsim,
        eqslantgtr: eqslantgtr,
        eqslantless: eqslantless,
        Equal: Equal,
        equals: equals,
        EqualTilde: EqualTilde,
        equest: equest,
        Equilibrium: Equilibrium,
        equiv: equiv,
        equivDD: equivDD,
        eqvparsl: eqvparsl,
        erarr: erarr,
        erDot: erDot,
        escr: escr,
        Escr: Escr,
        esdot: esdot,
        Esim: Esim,
        esim: esim,
        Eta: Eta,
        eta: eta,
        ETH: ETH,
        eth: eth,
        Euml: Euml,
        euml: euml,
        euro: euro,
        excl: excl,
        exist: exist,
        Exists: Exists,
        expectation: expectation,
        exponentiale: exponentiale,
        ExponentialE: ExponentialE,
        fallingdotseq: fallingdotseq,
        Fcy: Fcy,
        fcy: fcy,
        female: female,
        ffilig: ffilig,
        fflig: fflig,
        ffllig: ffllig,
        Ffr: Ffr,
        ffr: ffr,
        filig: filig,
        FilledSmallSquare: FilledSmallSquare,
        FilledVerySmallSquare: FilledVerySmallSquare,
        fjlig: fjlig,
        flat: flat,
        fllig: fllig,
        fltns: fltns,
        fnof: fnof,
        Fopf: Fopf,
        fopf: fopf,
        forall: forall,
        ForAll: ForAll,
        fork: fork,
        forkv: forkv,
        Fouriertrf: Fouriertrf,
        fpartint: fpartint,
        frac12: frac12,
        frac13: frac13,
        frac14: frac14,
        frac15: frac15,
        frac16: frac16,
        frac18: frac18,
        frac23: frac23,
        frac25: frac25,
        frac34: frac34,
        frac35: frac35,
        frac38: frac38,
        frac45: frac45,
        frac56: frac56,
        frac58: frac58,
        frac78: frac78,
        frasl: frasl,
        frown: frown,
        fscr: fscr,
        Fscr: Fscr,
        gacute: gacute,
        Gamma: Gamma,
        gamma: gamma,
        Gammad: Gammad,
        gammad: gammad,
        gap: gap,
        Gbreve: Gbreve,
        gbreve: gbreve,
        Gcedil: Gcedil,
        Gcirc: Gcirc,
        gcirc: gcirc,
        Gcy: Gcy,
        gcy: gcy,
        Gdot: Gdot,
        gdot: gdot,
        ge: ge,
        gE: gE,
        gEl: gEl,
        gel: gel,
        geq: geq,
        geqq: geqq,
        geqslant: geqslant,
        gescc: gescc,
        ges: ges,
        gesdot: gesdot,
        gesdoto: gesdoto,
        gesdotol: gesdotol,
        gesl: gesl,
        gesles: gesles,
        Gfr: Gfr,
        gfr: gfr,
        gg: gg,
        Gg: Gg,
        ggg: ggg,
        gimel: gimel,
        GJcy: GJcy,
        gjcy: gjcy,
        gla: gla,
        gl: gl,
        glE: glE,
        glj: glj,
        gnap: gnap,
        gnapprox: gnapprox,
        gne: gne,
        gnE: gnE,
        gneq: gneq,
        gneqq: gneqq,
        gnsim: gnsim,
        Gopf: Gopf,
        gopf: gopf,
        grave: grave,
        GreaterEqual: GreaterEqual,
        GreaterEqualLess: GreaterEqualLess,
        GreaterFullEqual: GreaterFullEqual,
        GreaterGreater: GreaterGreater,
        GreaterLess: GreaterLess,
        GreaterSlantEqual: GreaterSlantEqual,
        GreaterTilde: GreaterTilde,
        Gscr: Gscr,
        gscr: gscr,
        gsim: gsim,
        gsime: gsime,
        gsiml: gsiml,
        gtcc: gtcc,
        gtcir: gtcir,
        gt: gt,
        GT: GT,
        Gt: Gt,
        gtdot: gtdot,
        gtlPar: gtlPar,
        gtquest: gtquest,
        gtrapprox: gtrapprox,
        gtrarr: gtrarr,
        gtrdot: gtrdot,
        gtreqless: gtreqless,
        gtreqqless: gtreqqless,
        gtrless: gtrless,
        gtrsim: gtrsim,
        gvertneqq: gvertneqq,
        gvnE: gvnE,
        Hacek: Hacek,
        hairsp: hairsp,
        half: half,
        hamilt: hamilt,
        HARDcy: HARDcy,
        hardcy: hardcy,
        harrcir: harrcir,
        harr: harr,
        hArr: hArr,
        harrw: harrw,
        Hat: Hat,
        hbar: hbar,
        Hcirc: Hcirc,
        hcirc: hcirc,
        hearts: hearts,
        heartsuit: heartsuit,
        hellip: hellip,
        hercon: hercon,
        hfr: hfr,
        Hfr: Hfr,
        HilbertSpace: HilbertSpace,
        hksearow: hksearow,
        hkswarow: hkswarow,
        hoarr: hoarr,
        homtht: homtht,
        hookleftarrow: hookleftarrow,
        hookrightarrow: hookrightarrow,
        hopf: hopf,
        Hopf: Hopf,
        horbar: horbar,
        HorizontalLine: HorizontalLine,
        hscr: hscr,
        Hscr: Hscr,
        hslash: hslash,
        Hstrok: Hstrok,
        hstrok: hstrok,
        HumpDownHump: HumpDownHump,
        HumpEqual: HumpEqual,
        hybull: hybull,
        hyphen: hyphen,
        Iacute: Iacute,
        iacute: iacute,
        ic: ic,
        Icirc: Icirc,
        icirc: icirc,
        Icy: Icy,
        icy: icy,
        Idot: Idot,
        IEcy: IEcy,
        iecy: iecy,
        iexcl: iexcl,
        iff: iff,
        ifr: ifr,
        Ifr: Ifr,
        Igrave: Igrave,
        igrave: igrave,
        ii: ii,
        iiiint: iiiint,
        iiint: iiint,
        iinfin: iinfin,
        iiota: iiota,
        IJlig: IJlig,
        ijlig: ijlig,
        Imacr: Imacr,
        imacr: imacr,
        image: image,
        ImaginaryI: ImaginaryI,
        imagline: imagline,
        imagpart: imagpart,
        imath: imath,
        Im: Im,
        imof: imof,
        imped: imped,
        Implies: Implies,
        incare: incare,
        "in": "\u2208",
        infin: infin,
        infintie: infintie,
        inodot: inodot,
        intcal: intcal,
        int: int,
        Int: Int,
        integers: integers,
        Integral: Integral,
        intercal: intercal,
        Intersection: Intersection,
        intlarhk: intlarhk,
        intprod: intprod,
        InvisibleComma: InvisibleComma,
        InvisibleTimes: InvisibleTimes,
        IOcy: IOcy,
        iocy: iocy,
        Iogon: Iogon,
        iogon: iogon,
        Iopf: Iopf,
        iopf: iopf,
        Iota: Iota,
        iota: iota,
        iprod: iprod,
        iquest: iquest,
        iscr: iscr,
        Iscr: Iscr,
        isin: isin,
        isindot: isindot,
        isinE: isinE,
        isins: isins,
        isinsv: isinsv,
        isinv: isinv,
        it: it,
        Itilde: Itilde,
        itilde: itilde,
        Iukcy: Iukcy,
        iukcy: iukcy,
        Iuml: Iuml,
        iuml: iuml,
        Jcirc: Jcirc,
        jcirc: jcirc,
        Jcy: Jcy,
        jcy: jcy,
        Jfr: Jfr,
        jfr: jfr,
        jmath: jmath,
        Jopf: Jopf,
        jopf: jopf,
        Jscr: Jscr,
        jscr: jscr,
        Jsercy: Jsercy,
        jsercy: jsercy,
        Jukcy: Jukcy,
        jukcy: jukcy,
        Kappa: Kappa,
        kappa: kappa,
        kappav: kappav,
        Kcedil: Kcedil,
        kcedil: kcedil,
        Kcy: Kcy,
        kcy: kcy,
        Kfr: Kfr,
        kfr: kfr,
        kgreen: kgreen,
        KHcy: KHcy,
        khcy: khcy,
        KJcy: KJcy,
        kjcy: kjcy,
        Kopf: Kopf,
        kopf: kopf,
        Kscr: Kscr,
        kscr: kscr,
        lAarr: lAarr,
        Lacute: Lacute,
        lacute: lacute,
        laemptyv: laemptyv,
        lagran: lagran,
        Lambda: Lambda,
        lambda: lambda,
        lang: lang,
        Lang: Lang,
        langd: langd,
        langle: langle,
        lap: lap,
        Laplacetrf: Laplacetrf,
        laquo: laquo,
        larrb: larrb,
        larrbfs: larrbfs,
        larr: larr,
        Larr: Larr,
        lArr: lArr,
        larrfs: larrfs,
        larrhk: larrhk,
        larrlp: larrlp,
        larrpl: larrpl,
        larrsim: larrsim,
        larrtl: larrtl,
        latail: latail,
        lAtail: lAtail,
        lat: lat,
        late: late,
        lates: lates,
        lbarr: lbarr,
        lBarr: lBarr,
        lbbrk: lbbrk,
        lbrace: lbrace,
        lbrack: lbrack,
        lbrke: lbrke,
        lbrksld: lbrksld,
        lbrkslu: lbrkslu,
        Lcaron: Lcaron,
        lcaron: lcaron,
        Lcedil: Lcedil,
        lcedil: lcedil,
        lceil: lceil,
        lcub: lcub,
        Lcy: Lcy,
        lcy: lcy,
        ldca: ldca,
        ldquo: ldquo,
        ldquor: ldquor,
        ldrdhar: ldrdhar,
        ldrushar: ldrushar,
        ldsh: ldsh,
        le: le,
        lE: lE,
        LeftAngleBracket: LeftAngleBracket,
        LeftArrowBar: LeftArrowBar,
        leftarrow: leftarrow,
        LeftArrow: LeftArrow,
        Leftarrow: Leftarrow,
        LeftArrowRightArrow: LeftArrowRightArrow,
        leftarrowtail: leftarrowtail,
        LeftCeiling: LeftCeiling,
        LeftDoubleBracket: LeftDoubleBracket,
        LeftDownTeeVector: LeftDownTeeVector,
        LeftDownVectorBar: LeftDownVectorBar,
        LeftDownVector: LeftDownVector,
        LeftFloor: LeftFloor,
        leftharpoondown: leftharpoondown,
        leftharpoonup: leftharpoonup,
        leftleftarrows: leftleftarrows,
        leftrightarrow: leftrightarrow,
        LeftRightArrow: LeftRightArrow,
        Leftrightarrow: Leftrightarrow,
        leftrightarrows: leftrightarrows,
        leftrightharpoons: leftrightharpoons,
        leftrightsquigarrow: leftrightsquigarrow,
        LeftRightVector: LeftRightVector,
        LeftTeeArrow: LeftTeeArrow,
        LeftTee: LeftTee,
        LeftTeeVector: LeftTeeVector,
        leftthreetimes: leftthreetimes,
        LeftTriangleBar: LeftTriangleBar,
        LeftTriangle: LeftTriangle,
        LeftTriangleEqual: LeftTriangleEqual,
        LeftUpDownVector: LeftUpDownVector,
        LeftUpTeeVector: LeftUpTeeVector,
        LeftUpVectorBar: LeftUpVectorBar,
        LeftUpVector: LeftUpVector,
        LeftVectorBar: LeftVectorBar,
        LeftVector: LeftVector,
        lEg: lEg,
        leg: leg,
        leq: leq,
        leqq: leqq,
        leqslant: leqslant,
        lescc: lescc,
        les: les,
        lesdot: lesdot,
        lesdoto: lesdoto,
        lesdotor: lesdotor,
        lesg: lesg,
        lesges: lesges,
        lessapprox: lessapprox,
        lessdot: lessdot,
        lesseqgtr: lesseqgtr,
        lesseqqgtr: lesseqqgtr,
        LessEqualGreater: LessEqualGreater,
        LessFullEqual: LessFullEqual,
        LessGreater: LessGreater,
        lessgtr: lessgtr,
        LessLess: LessLess,
        lesssim: lesssim,
        LessSlantEqual: LessSlantEqual,
        LessTilde: LessTilde,
        lfisht: lfisht,
        lfloor: lfloor,
        Lfr: Lfr,
        lfr: lfr,
        lg: lg,
        lgE: lgE,
        lHar: lHar,
        lhard: lhard,
        lharu: lharu,
        lharul: lharul,
        lhblk: lhblk,
        LJcy: LJcy,
        ljcy: ljcy,
        llarr: llarr,
        ll: ll,
        Ll: Ll,
        llcorner: llcorner,
        Lleftarrow: Lleftarrow,
        llhard: llhard,
        lltri: lltri,
        Lmidot: Lmidot,
        lmidot: lmidot,
        lmoustache: lmoustache,
        lmoust: lmoust,
        lnap: lnap,
        lnapprox: lnapprox,
        lne: lne,
        lnE: lnE,
        lneq: lneq,
        lneqq: lneqq,
        lnsim: lnsim,
        loang: loang,
        loarr: loarr,
        lobrk: lobrk,
        longleftarrow: longleftarrow,
        LongLeftArrow: LongLeftArrow,
        Longleftarrow: Longleftarrow,
        longleftrightarrow: longleftrightarrow,
        LongLeftRightArrow: LongLeftRightArrow,
        Longleftrightarrow: Longleftrightarrow,
        longmapsto: longmapsto,
        longrightarrow: longrightarrow,
        LongRightArrow: LongRightArrow,
        Longrightarrow: Longrightarrow,
        looparrowleft: looparrowleft,
        looparrowright: looparrowright,
        lopar: lopar,
        Lopf: Lopf,
        lopf: lopf,
        loplus: loplus,
        lotimes: lotimes,
        lowast: lowast,
        lowbar: lowbar,
        LowerLeftArrow: LowerLeftArrow,
        LowerRightArrow: LowerRightArrow,
        loz: loz,
        lozenge: lozenge,
        lozf: lozf,
        lpar: lpar,
        lparlt: lparlt,
        lrarr: lrarr,
        lrcorner: lrcorner,
        lrhar: lrhar,
        lrhard: lrhard,
        lrm: lrm,
        lrtri: lrtri,
        lsaquo: lsaquo,
        lscr: lscr,
        Lscr: Lscr,
        lsh: lsh,
        Lsh: Lsh,
        lsim: lsim,
        lsime: lsime,
        lsimg: lsimg,
        lsqb: lsqb,
        lsquo: lsquo,
        lsquor: lsquor,
        Lstrok: Lstrok,
        lstrok: lstrok,
        ltcc: ltcc,
        ltcir: ltcir,
        lt: lt,
        LT: LT,
        Lt: Lt,
        ltdot: ltdot,
        lthree: lthree,
        ltimes: ltimes,
        ltlarr: ltlarr,
        ltquest: ltquest,
        ltri: ltri,
        ltrie: ltrie,
        ltrif: ltrif,
        ltrPar: ltrPar,
        lurdshar: lurdshar,
        luruhar: luruhar,
        lvertneqq: lvertneqq,
        lvnE: lvnE,
        macr: macr,
        male: male,
        malt: malt,
        maltese: maltese,
        "Map": "\u2905",
        map: map,
        mapsto: mapsto,
        mapstodown: mapstodown,
        mapstoleft: mapstoleft,
        mapstoup: mapstoup,
        marker: marker,
        mcomma: mcomma,
        Mcy: Mcy,
        mcy: mcy,
        mdash: mdash,
        mDDot: mDDot,
        measuredangle: measuredangle,
        MediumSpace: MediumSpace,
        Mellintrf: Mellintrf,
        Mfr: Mfr,
        mfr: mfr,
        mho: mho,
        micro: micro,
        midast: midast,
        midcir: midcir,
        mid: mid,
        middot: middot,
        minusb: minusb,
        minus: minus,
        minusd: minusd,
        minusdu: minusdu,
        MinusPlus: MinusPlus,
        mlcp: mlcp,
        mldr: mldr,
        mnplus: mnplus,
        models: models,
        Mopf: Mopf,
        mopf: mopf,
        mp: mp,
        mscr: mscr,
        Mscr: Mscr,
        mstpos: mstpos,
        Mu: Mu,
        mu: mu,
        multimap: multimap,
        mumap: mumap,
        nabla: nabla,
        Nacute: Nacute,
        nacute: nacute,
        nang: nang,
        nap: nap,
        napE: napE,
        napid: napid,
        napos: napos,
        napprox: napprox,
        natural: natural,
        naturals: naturals,
        natur: natur,
        nbsp: nbsp,
        nbump: nbump,
        nbumpe: nbumpe,
        ncap: ncap,
        Ncaron: Ncaron,
        ncaron: ncaron,
        Ncedil: Ncedil,
        ncedil: ncedil,
        ncong: ncong,
        ncongdot: ncongdot,
        ncup: ncup,
        Ncy: Ncy,
        ncy: ncy,
        ndash: ndash,
        nearhk: nearhk,
        nearr: nearr,
        neArr: neArr,
        nearrow: nearrow,
        ne: ne,
        nedot: nedot,
        NegativeMediumSpace: NegativeMediumSpace,
        NegativeThickSpace: NegativeThickSpace,
        NegativeThinSpace: NegativeThinSpace,
        NegativeVeryThinSpace: NegativeVeryThinSpace,
        nequiv: nequiv,
        nesear: nesear,
        nesim: nesim,
        NestedGreaterGreater: NestedGreaterGreater,
        NestedLessLess: NestedLessLess,
        NewLine: NewLine,
        nexist: nexist,
        nexists: nexists,
        Nfr: Nfr,
        nfr: nfr,
        ngE: ngE,
        nge: nge,
        ngeq: ngeq,
        ngeqq: ngeqq,
        ngeqslant: ngeqslant,
        nges: nges,
        nGg: nGg,
        ngsim: ngsim,
        nGt: nGt,
        ngt: ngt,
        ngtr: ngtr,
        nGtv: nGtv,
        nharr: nharr,
        nhArr: nhArr,
        nhpar: nhpar,
        ni: ni,
        nis: nis,
        nisd: nisd,
        niv: niv,
        NJcy: NJcy,
        njcy: njcy,
        nlarr: nlarr,
        nlArr: nlArr,
        nldr: nldr,
        nlE: nlE,
        nle: nle,
        nleftarrow: nleftarrow,
        nLeftarrow: nLeftarrow,
        nleftrightarrow: nleftrightarrow,
        nLeftrightarrow: nLeftrightarrow,
        nleq: nleq,
        nleqq: nleqq,
        nleqslant: nleqslant,
        nles: nles,
        nless: nless,
        nLl: nLl,
        nlsim: nlsim,
        nLt: nLt,
        nlt: nlt,
        nltri: nltri,
        nltrie: nltrie,
        nLtv: nLtv,
        nmid: nmid,
        NoBreak: NoBreak,
        NonBreakingSpace: NonBreakingSpace,
        nopf: nopf,
        Nopf: Nopf,
        Not: Not,
        not: not,
        NotCongruent: NotCongruent,
        NotCupCap: NotCupCap,
        NotDoubleVerticalBar: NotDoubleVerticalBar,
        NotElement: NotElement,
        NotEqual: NotEqual,
        NotEqualTilde: NotEqualTilde,
        NotExists: NotExists,
        NotGreater: NotGreater,
        NotGreaterEqual: NotGreaterEqual,
        NotGreaterFullEqual: NotGreaterFullEqual,
        NotGreaterGreater: NotGreaterGreater,
        NotGreaterLess: NotGreaterLess,
        NotGreaterSlantEqual: NotGreaterSlantEqual,
        NotGreaterTilde: NotGreaterTilde,
        NotHumpDownHump: NotHumpDownHump,
        NotHumpEqual: NotHumpEqual,
        notin: notin,
        notindot: notindot,
        notinE: notinE,
        notinva: notinva,
        notinvb: notinvb,
        notinvc: notinvc,
        NotLeftTriangleBar: NotLeftTriangleBar,
        NotLeftTriangle: NotLeftTriangle,
        NotLeftTriangleEqual: NotLeftTriangleEqual,
        NotLess: NotLess,
        NotLessEqual: NotLessEqual,
        NotLessGreater: NotLessGreater,
        NotLessLess: NotLessLess,
        NotLessSlantEqual: NotLessSlantEqual,
        NotLessTilde: NotLessTilde,
        NotNestedGreaterGreater: NotNestedGreaterGreater,
        NotNestedLessLess: NotNestedLessLess,
        notni: notni,
        notniva: notniva,
        notnivb: notnivb,
        notnivc: notnivc,
        NotPrecedes: NotPrecedes,
        NotPrecedesEqual: NotPrecedesEqual,
        NotPrecedesSlantEqual: NotPrecedesSlantEqual,
        NotReverseElement: NotReverseElement,
        NotRightTriangleBar: NotRightTriangleBar,
        NotRightTriangle: NotRightTriangle,
        NotRightTriangleEqual: NotRightTriangleEqual,
        NotSquareSubset: NotSquareSubset,
        NotSquareSubsetEqual: NotSquareSubsetEqual,
        NotSquareSuperset: NotSquareSuperset,
        NotSquareSupersetEqual: NotSquareSupersetEqual,
        NotSubset: NotSubset,
        NotSubsetEqual: NotSubsetEqual,
        NotSucceeds: NotSucceeds,
        NotSucceedsEqual: NotSucceedsEqual,
        NotSucceedsSlantEqual: NotSucceedsSlantEqual,
        NotSucceedsTilde: NotSucceedsTilde,
        NotSuperset: NotSuperset,
        NotSupersetEqual: NotSupersetEqual,
        NotTilde: NotTilde,
        NotTildeEqual: NotTildeEqual,
        NotTildeFullEqual: NotTildeFullEqual,
        NotTildeTilde: NotTildeTilde,
        NotVerticalBar: NotVerticalBar,
        nparallel: nparallel,
        npar: npar,
        nparsl: nparsl,
        npart: npart,
        npolint: npolint,
        npr: npr,
        nprcue: nprcue,
        nprec: nprec,
        npreceq: npreceq,
        npre: npre,
        nrarrc: nrarrc,
        nrarr: nrarr,
        nrArr: nrArr,
        nrarrw: nrarrw,
        nrightarrow: nrightarrow,
        nRightarrow: nRightarrow,
        nrtri: nrtri,
        nrtrie: nrtrie,
        nsc: nsc,
        nsccue: nsccue,
        nsce: nsce,
        Nscr: Nscr,
        nscr: nscr,
        nshortmid: nshortmid,
        nshortparallel: nshortparallel,
        nsim: nsim,
        nsime: nsime,
        nsimeq: nsimeq,
        nsmid: nsmid,
        nspar: nspar,
        nsqsube: nsqsube,
        nsqsupe: nsqsupe,
        nsub: nsub,
        nsubE: nsubE,
        nsube: nsube,
        nsubset: nsubset,
        nsubseteq: nsubseteq,
        nsubseteqq: nsubseteqq,
        nsucc: nsucc,
        nsucceq: nsucceq,
        nsup: nsup,
        nsupE: nsupE,
        nsupe: nsupe,
        nsupset: nsupset,
        nsupseteq: nsupseteq,
        nsupseteqq: nsupseteqq,
        ntgl: ntgl,
        Ntilde: Ntilde,
        ntilde: ntilde,
        ntlg: ntlg,
        ntriangleleft: ntriangleleft,
        ntrianglelefteq: ntrianglelefteq,
        ntriangleright: ntriangleright,
        ntrianglerighteq: ntrianglerighteq,
        Nu: Nu,
        nu: nu,
        num: num,
        numero: numero,
        numsp: numsp,
        nvap: nvap,
        nvdash: nvdash,
        nvDash: nvDash,
        nVdash: nVdash,
        nVDash: nVDash,
        nvge: nvge,
        nvgt: nvgt,
        nvHarr: nvHarr,
        nvinfin: nvinfin,
        nvlArr: nvlArr,
        nvle: nvle,
        nvlt: nvlt,
        nvltrie: nvltrie,
        nvrArr: nvrArr,
        nvrtrie: nvrtrie,
        nvsim: nvsim,
        nwarhk: nwarhk,
        nwarr: nwarr,
        nwArr: nwArr,
        nwarrow: nwarrow,
        nwnear: nwnear,
        Oacute: Oacute,
        oacute: oacute,
        oast: oast,
        Ocirc: Ocirc,
        ocirc: ocirc,
        ocir: ocir,
        Ocy: Ocy,
        ocy: ocy,
        odash: odash,
        Odblac: Odblac,
        odblac: odblac,
        odiv: odiv,
        odot: odot,
        odsold: odsold,
        OElig: OElig,
        oelig: oelig,
        ofcir: ofcir,
        Ofr: Ofr,
        ofr: ofr,
        ogon: ogon,
        Ograve: Ograve,
        ograve: ograve,
        ogt: ogt,
        ohbar: ohbar,
        ohm: ohm,
        oint: oint,
        olarr: olarr,
        olcir: olcir,
        olcross: olcross,
        oline: oline,
        olt: olt,
        Omacr: Omacr,
        omacr: omacr,
        Omega: Omega,
        omega: omega,
        Omicron: Omicron,
        omicron: omicron,
        omid: omid,
        ominus: ominus,
        Oopf: Oopf,
        oopf: oopf,
        opar: opar,
        OpenCurlyDoubleQuote: OpenCurlyDoubleQuote,
        OpenCurlyQuote: OpenCurlyQuote,
        operp: operp,
        oplus: oplus,
        orarr: orarr,
        Or: Or,
        or: or,
        ord: ord,
        order: order,
        orderof: orderof,
        ordf: ordf,
        ordm: ordm,
        origof: origof,
        oror: oror,
        orslope: orslope,
        orv: orv,
        oS: oS,
        Oscr: Oscr,
        oscr: oscr,
        Oslash: Oslash,
        oslash: oslash,
        osol: osol,
        Otilde: Otilde,
        otilde: otilde,
        otimesas: otimesas,
        Otimes: Otimes,
        otimes: otimes,
        Ouml: Ouml,
        ouml: ouml,
        ovbar: ovbar,
        OverBar: OverBar,
        OverBrace: OverBrace,
        OverBracket: OverBracket,
        OverParenthesis: OverParenthesis,
        para: para,
        parallel: parallel,
        par: par,
        parsim: parsim,
        parsl: parsl,
        part: part,
        PartialD: PartialD,
        Pcy: Pcy,
        pcy: pcy,
        percnt: percnt,
        period: period,
        permil: permil,
        perp: perp,
        pertenk: pertenk,
        Pfr: Pfr,
        pfr: pfr,
        Phi: Phi,
        phi: phi,
        phiv: phiv,
        phmmat: phmmat,
        phone: phone,
        Pi: Pi,
        pi: pi,
        pitchfork: pitchfork,
        piv: piv,
        planck: planck,
        planckh: planckh,
        plankv: plankv,
        plusacir: plusacir,
        plusb: plusb,
        pluscir: pluscir,
        plus: plus,
        plusdo: plusdo,
        plusdu: plusdu,
        pluse: pluse,
        PlusMinus: PlusMinus,
        plusmn: plusmn,
        plussim: plussim,
        plustwo: plustwo,
        pm: pm,
        Poincareplane: Poincareplane,
        pointint: pointint,
        popf: popf,
        Popf: Popf,
        pound: pound,
        prap: prap,
        Pr: Pr,
        pr: pr,
        prcue: prcue,
        precapprox: precapprox,
        prec: prec,
        preccurlyeq: preccurlyeq,
        Precedes: Precedes,
        PrecedesEqual: PrecedesEqual,
        PrecedesSlantEqual: PrecedesSlantEqual,
        PrecedesTilde: PrecedesTilde,
        preceq: preceq,
        precnapprox: precnapprox,
        precneqq: precneqq,
        precnsim: precnsim,
        pre: pre,
        prE: prE,
        precsim: precsim,
        prime: prime,
        Prime: Prime,
        primes: primes,
        prnap: prnap,
        prnE: prnE,
        prnsim: prnsim,
        prod: prod,
        Product: Product,
        profalar: profalar,
        profline: profline,
        profsurf: profsurf,
        prop: prop,
        Proportional: Proportional,
        Proportion: Proportion,
        propto: propto,
        prsim: prsim,
        prurel: prurel,
        Pscr: Pscr,
        pscr: pscr,
        Psi: Psi,
        psi: psi,
        puncsp: puncsp,
        Qfr: Qfr,
        qfr: qfr,
        qint: qint,
        qopf: qopf,
        Qopf: Qopf,
        qprime: qprime,
        Qscr: Qscr,
        qscr: qscr,
        quaternions: quaternions,
        quatint: quatint,
        quest: quest,
        questeq: questeq,
        quot: quot,
        QUOT: QUOT,
        rAarr: rAarr,
        race: race,
        Racute: Racute,
        racute: racute,
        radic: radic,
        raemptyv: raemptyv,
        rang: rang,
        Rang: Rang,
        rangd: rangd,
        range: range,
        rangle: rangle,
        raquo: raquo,
        rarrap: rarrap,
        rarrb: rarrb,
        rarrbfs: rarrbfs,
        rarrc: rarrc,
        rarr: rarr,
        Rarr: Rarr,
        rArr: rArr,
        rarrfs: rarrfs,
        rarrhk: rarrhk,
        rarrlp: rarrlp,
        rarrpl: rarrpl,
        rarrsim: rarrsim,
        Rarrtl: Rarrtl,
        rarrtl: rarrtl,
        rarrw: rarrw,
        ratail: ratail,
        rAtail: rAtail,
        ratio: ratio,
        rationals: rationals,
        rbarr: rbarr,
        rBarr: rBarr,
        RBarr: RBarr,
        rbbrk: rbbrk,
        rbrace: rbrace,
        rbrack: rbrack,
        rbrke: rbrke,
        rbrksld: rbrksld,
        rbrkslu: rbrkslu,
        Rcaron: Rcaron,
        rcaron: rcaron,
        Rcedil: Rcedil,
        rcedil: rcedil,
        rceil: rceil,
        rcub: rcub,
        Rcy: Rcy,
        rcy: rcy,
        rdca: rdca,
        rdldhar: rdldhar,
        rdquo: rdquo,
        rdquor: rdquor,
        rdsh: rdsh,
        real: real,
        realine: realine,
        realpart: realpart,
        reals: reals,
        Re: Re,
        rect: rect,
        reg: reg,
        REG: REG,
        ReverseElement: ReverseElement,
        ReverseEquilibrium: ReverseEquilibrium,
        ReverseUpEquilibrium: ReverseUpEquilibrium,
        rfisht: rfisht,
        rfloor: rfloor,
        rfr: rfr,
        Rfr: Rfr,
        rHar: rHar,
        rhard: rhard,
        rharu: rharu,
        rharul: rharul,
        Rho: Rho,
        rho: rho,
        rhov: rhov,
        RightAngleBracket: RightAngleBracket,
        RightArrowBar: RightArrowBar,
        rightarrow: rightarrow,
        RightArrow: RightArrow,
        Rightarrow: Rightarrow,
        RightArrowLeftArrow: RightArrowLeftArrow,
        rightarrowtail: rightarrowtail,
        RightCeiling: RightCeiling,
        RightDoubleBracket: RightDoubleBracket,
        RightDownTeeVector: RightDownTeeVector,
        RightDownVectorBar: RightDownVectorBar,
        RightDownVector: RightDownVector,
        RightFloor: RightFloor,
        rightharpoondown: rightharpoondown,
        rightharpoonup: rightharpoonup,
        rightleftarrows: rightleftarrows,
        rightleftharpoons: rightleftharpoons,
        rightrightarrows: rightrightarrows,
        rightsquigarrow: rightsquigarrow,
        RightTeeArrow: RightTeeArrow,
        RightTee: RightTee,
        RightTeeVector: RightTeeVector,
        rightthreetimes: rightthreetimes,
        RightTriangleBar: RightTriangleBar,
        RightTriangle: RightTriangle,
        RightTriangleEqual: RightTriangleEqual,
        RightUpDownVector: RightUpDownVector,
        RightUpTeeVector: RightUpTeeVector,
        RightUpVectorBar: RightUpVectorBar,
        RightUpVector: RightUpVector,
        RightVectorBar: RightVectorBar,
        RightVector: RightVector,
        ring: ring,
        risingdotseq: risingdotseq,
        rlarr: rlarr,
        rlhar: rlhar,
        rlm: rlm,
        rmoustache: rmoustache,
        rmoust: rmoust,
        rnmid: rnmid,
        roang: roang,
        roarr: roarr,
        robrk: robrk,
        ropar: ropar,
        ropf: ropf,
        Ropf: Ropf,
        roplus: roplus,
        rotimes: rotimes,
        RoundImplies: RoundImplies,
        rpar: rpar,
        rpargt: rpargt,
        rppolint: rppolint,
        rrarr: rrarr,
        Rrightarrow: Rrightarrow,
        rsaquo: rsaquo,
        rscr: rscr,
        Rscr: Rscr,
        rsh: rsh,
        Rsh: Rsh,
        rsqb: rsqb,
        rsquo: rsquo,
        rsquor: rsquor,
        rthree: rthree,
        rtimes: rtimes,
        rtri: rtri,
        rtrie: rtrie,
        rtrif: rtrif,
        rtriltri: rtriltri,
        RuleDelayed: RuleDelayed,
        ruluhar: ruluhar,
        rx: rx,
        Sacute: Sacute,
        sacute: sacute,
        sbquo: sbquo,
        scap: scap,
        Scaron: Scaron,
        scaron: scaron,
        Sc: Sc,
        sc: sc,
        sccue: sccue,
        sce: sce,
        scE: scE,
        Scedil: Scedil,
        scedil: scedil,
        Scirc: Scirc,
        scirc: scirc,
        scnap: scnap,
        scnE: scnE,
        scnsim: scnsim,
        scpolint: scpolint,
        scsim: scsim,
        Scy: Scy,
        scy: scy,
        sdotb: sdotb,
        sdot: sdot,
        sdote: sdote,
        searhk: searhk,
        searr: searr,
        seArr: seArr,
        searrow: searrow,
        sect: sect,
        semi: semi,
        seswar: seswar,
        setminus: setminus,
        setmn: setmn,
        sext: sext,
        Sfr: Sfr,
        sfr: sfr,
        sfrown: sfrown,
        sharp: sharp,
        SHCHcy: SHCHcy,
        shchcy: shchcy,
        SHcy: SHcy,
        shcy: shcy,
        ShortDownArrow: ShortDownArrow,
        ShortLeftArrow: ShortLeftArrow,
        shortmid: shortmid,
        shortparallel: shortparallel,
        ShortRightArrow: ShortRightArrow,
        ShortUpArrow: ShortUpArrow,
        shy: shy,
        Sigma: Sigma,
        sigma: sigma,
        sigmaf: sigmaf,
        sigmav: sigmav,
        sim: sim,
        simdot: simdot,
        sime: sime,
        simeq: simeq,
        simg: simg,
        simgE: simgE,
        siml: siml,
        simlE: simlE,
        simne: simne,
        simplus: simplus,
        simrarr: simrarr,
        slarr: slarr,
        SmallCircle: SmallCircle,
        smallsetminus: smallsetminus,
        smashp: smashp,
        smeparsl: smeparsl,
        smid: smid,
        smile: smile,
        smt: smt,
        smte: smte,
        smtes: smtes,
        SOFTcy: SOFTcy,
        softcy: softcy,
        solbar: solbar,
        solb: solb,
        sol: sol,
        Sopf: Sopf,
        sopf: sopf,
        spades: spades,
        spadesuit: spadesuit,
        spar: spar,
        sqcap: sqcap,
        sqcaps: sqcaps,
        sqcup: sqcup,
        sqcups: sqcups,
        Sqrt: Sqrt,
        sqsub: sqsub,
        sqsube: sqsube,
        sqsubset: sqsubset,
        sqsubseteq: sqsubseteq,
        sqsup: sqsup,
        sqsupe: sqsupe,
        sqsupset: sqsupset,
        sqsupseteq: sqsupseteq,
        square: square,
        Square: Square,
        SquareIntersection: SquareIntersection,
        SquareSubset: SquareSubset,
        SquareSubsetEqual: SquareSubsetEqual,
        SquareSuperset: SquareSuperset,
        SquareSupersetEqual: SquareSupersetEqual,
        SquareUnion: SquareUnion,
        squarf: squarf,
        squ: squ,
        squf: squf,
        srarr: srarr,
        Sscr: Sscr,
        sscr: sscr,
        ssetmn: ssetmn,
        ssmile: ssmile,
        sstarf: sstarf,
        Star: Star,
        star: star,
        starf: starf,
        straightepsilon: straightepsilon,
        straightphi: straightphi,
        strns: strns,
        sub: sub,
        Sub: Sub,
        subdot: subdot,
        subE: subE,
        sube: sube,
        subedot: subedot,
        submult: submult,
        subnE: subnE,
        subne: subne,
        subplus: subplus,
        subrarr: subrarr,
        subset: subset,
        Subset: Subset,
        subseteq: subseteq,
        subseteqq: subseteqq,
        SubsetEqual: SubsetEqual,
        subsetneq: subsetneq,
        subsetneqq: subsetneqq,
        subsim: subsim,
        subsub: subsub,
        subsup: subsup,
        succapprox: succapprox,
        succ: succ,
        succcurlyeq: succcurlyeq,
        Succeeds: Succeeds,
        SucceedsEqual: SucceedsEqual,
        SucceedsSlantEqual: SucceedsSlantEqual,
        SucceedsTilde: SucceedsTilde,
        succeq: succeq,
        succnapprox: succnapprox,
        succneqq: succneqq,
        succnsim: succnsim,
        succsim: succsim,
        SuchThat: SuchThat,
        sum: sum,
        Sum: Sum,
        sung: sung,
        sup1: sup1,
        sup2: sup2,
        sup3: sup3,
        sup: sup,
        Sup: Sup,
        supdot: supdot,
        supdsub: supdsub,
        supE: supE,
        supe: supe,
        supedot: supedot,
        Superset: Superset,
        SupersetEqual: SupersetEqual,
        suphsol: suphsol,
        suphsub: suphsub,
        suplarr: suplarr,
        supmult: supmult,
        supnE: supnE,
        supne: supne,
        supplus: supplus,
        supset: supset,
        Supset: Supset,
        supseteq: supseteq,
        supseteqq: supseteqq,
        supsetneq: supsetneq,
        supsetneqq: supsetneqq,
        supsim: supsim,
        supsub: supsub,
        supsup: supsup,
        swarhk: swarhk,
        swarr: swarr,
        swArr: swArr,
        swarrow: swarrow,
        swnwar: swnwar,
        szlig: szlig,
        Tab: Tab,
        target: target,
        Tau: Tau,
        tau: tau,
        tbrk: tbrk,
        Tcaron: Tcaron,
        tcaron: tcaron,
        Tcedil: Tcedil,
        tcedil: tcedil,
        Tcy: Tcy,
        tcy: tcy,
        tdot: tdot,
        telrec: telrec,
        Tfr: Tfr,
        tfr: tfr,
        there4: there4,
        therefore: therefore,
        Therefore: Therefore,
        Theta: Theta,
        theta: theta,
        thetasym: thetasym,
        thetav: thetav,
        thickapprox: thickapprox,
        thicksim: thicksim,
        ThickSpace: ThickSpace,
        ThinSpace: ThinSpace,
        thinsp: thinsp,
        thkap: thkap,
        thksim: thksim,
        THORN: THORN,
        thorn: thorn,
        tilde: tilde,
        Tilde: Tilde,
        TildeEqual: TildeEqual,
        TildeFullEqual: TildeFullEqual,
        TildeTilde: TildeTilde,
        timesbar: timesbar,
        timesb: timesb,
        times: times,
        timesd: timesd,
        tint: tint,
        toea: toea,
        topbot: topbot,
        topcir: topcir,
        top: top,
        Topf: Topf,
        topf: topf,
        topfork: topfork,
        tosa: tosa,
        tprime: tprime,
        trade: trade,
        TRADE: TRADE,
        triangle: triangle,
        triangledown: triangledown,
        triangleleft: triangleleft,
        trianglelefteq: trianglelefteq,
        triangleq: triangleq,
        triangleright: triangleright,
        trianglerighteq: trianglerighteq,
        tridot: tridot,
        trie: trie,
        triminus: triminus,
        TripleDot: TripleDot,
        triplus: triplus,
        trisb: trisb,
        tritime: tritime,
        trpezium: trpezium,
        Tscr: Tscr,
        tscr: tscr,
        TScy: TScy,
        tscy: tscy,
        TSHcy: TSHcy,
        tshcy: tshcy,
        Tstrok: Tstrok,
        tstrok: tstrok,
        twixt: twixt,
        twoheadleftarrow: twoheadleftarrow,
        twoheadrightarrow: twoheadrightarrow,
        Uacute: Uacute,
        uacute: uacute,
        uarr: uarr,
        Uarr: Uarr,
        uArr: uArr,
        Uarrocir: Uarrocir,
        Ubrcy: Ubrcy,
        ubrcy: ubrcy,
        Ubreve: Ubreve,
        ubreve: ubreve,
        Ucirc: Ucirc,
        ucirc: ucirc,
        Ucy: Ucy,
        ucy: ucy,
        udarr: udarr,
        Udblac: Udblac,
        udblac: udblac,
        udhar: udhar,
        ufisht: ufisht,
        Ufr: Ufr,
        ufr: ufr,
        Ugrave: Ugrave,
        ugrave: ugrave,
        uHar: uHar,
        uharl: uharl,
        uharr: uharr,
        uhblk: uhblk,
        ulcorn: ulcorn,
        ulcorner: ulcorner,
        ulcrop: ulcrop,
        ultri: ultri,
        Umacr: Umacr,
        umacr: umacr,
        uml: uml,
        UnderBar: UnderBar,
        UnderBrace: UnderBrace,
        UnderBracket: UnderBracket,
        UnderParenthesis: UnderParenthesis,
        Union: Union,
        UnionPlus: UnionPlus,
        Uogon: Uogon,
        uogon: uogon,
        Uopf: Uopf,
        uopf: uopf,
        UpArrowBar: UpArrowBar,
        uparrow: uparrow,
        UpArrow: UpArrow,
        Uparrow: Uparrow,
        UpArrowDownArrow: UpArrowDownArrow,
        updownarrow: updownarrow,
        UpDownArrow: UpDownArrow,
        Updownarrow: Updownarrow,
        UpEquilibrium: UpEquilibrium,
        upharpoonleft: upharpoonleft,
        upharpoonright: upharpoonright,
        uplus: uplus,
        UpperLeftArrow: UpperLeftArrow,
        UpperRightArrow: UpperRightArrow,
        upsi: upsi,
        Upsi: Upsi,
        upsih: upsih,
        Upsilon: Upsilon,
        upsilon: upsilon,
        UpTeeArrow: UpTeeArrow,
        UpTee: UpTee,
        upuparrows: upuparrows,
        urcorn: urcorn,
        urcorner: urcorner,
        urcrop: urcrop,
        Uring: Uring,
        uring: uring,
        urtri: urtri,
        Uscr: Uscr,
        uscr: uscr,
        utdot: utdot,
        Utilde: Utilde,
        utilde: utilde,
        utri: utri,
        utrif: utrif,
        uuarr: uuarr,
        Uuml: Uuml,
        uuml: uuml,
        uwangle: uwangle,
        vangrt: vangrt,
        varepsilon: varepsilon,
        varkappa: varkappa,
        varnothing: varnothing,
        varphi: varphi,
        varpi: varpi,
        varpropto: varpropto,
        varr: varr,
        vArr: vArr,
        varrho: varrho,
        varsigma: varsigma,
        varsubsetneq: varsubsetneq,
        varsubsetneqq: varsubsetneqq,
        varsupsetneq: varsupsetneq,
        varsupsetneqq: varsupsetneqq,
        vartheta: vartheta,
        vartriangleleft: vartriangleleft,
        vartriangleright: vartriangleright,
        vBar: vBar,
        Vbar: Vbar,
        vBarv: vBarv,
        Vcy: Vcy,
        vcy: vcy,
        vdash: vdash,
        vDash: vDash,
        Vdash: Vdash,
        VDash: VDash,
        Vdashl: Vdashl,
        veebar: veebar,
        vee: vee,
        Vee: Vee,
        veeeq: veeeq,
        vellip: vellip,
        verbar: verbar,
        Verbar: Verbar,
        vert: vert,
        Vert: Vert,
        VerticalBar: VerticalBar,
        VerticalLine: VerticalLine,
        VerticalSeparator: VerticalSeparator,
        VerticalTilde: VerticalTilde,
        VeryThinSpace: VeryThinSpace,
        Vfr: Vfr,
        vfr: vfr,
        vltri: vltri,
        vnsub: vnsub,
        vnsup: vnsup,
        Vopf: Vopf,
        vopf: vopf,
        vprop: vprop,
        vrtri: vrtri,
        Vscr: Vscr,
        vscr: vscr,
        vsubnE: vsubnE,
        vsubne: vsubne,
        vsupnE: vsupnE,
        vsupne: vsupne,
        Vvdash: Vvdash,
        vzigzag: vzigzag,
        Wcirc: Wcirc,
        wcirc: wcirc,
        wedbar: wedbar,
        wedge: wedge,
        Wedge: Wedge,
        wedgeq: wedgeq,
        weierp: weierp,
        Wfr: Wfr,
        wfr: wfr,
        Wopf: Wopf,
        wopf: wopf,
        wp: wp,
        wr: wr,
        wreath: wreath,
        Wscr: Wscr,
        wscr: wscr,
        xcap: xcap,
        xcirc: xcirc,
        xcup: xcup,
        xdtri: xdtri,
        Xfr: Xfr,
        xfr: xfr,
        xharr: xharr,
        xhArr: xhArr,
        Xi: Xi,
        xi: xi,
        xlarr: xlarr,
        xlArr: xlArr,
        xmap: xmap,
        xnis: xnis,
        xodot: xodot,
        Xopf: Xopf,
        xopf: xopf,
        xoplus: xoplus,
        xotime: xotime,
        xrarr: xrarr,
        xrArr: xrArr,
        Xscr: Xscr,
        xscr: xscr,
        xsqcup: xsqcup,
        xuplus: xuplus,
        xutri: xutri,
        xvee: xvee,
        xwedge: xwedge,
        Yacute: Yacute,
        yacute: yacute,
        YAcy: YAcy,
        yacy: yacy,
        Ycirc: Ycirc,
        ycirc: ycirc,
        Ycy: Ycy,
        ycy: ycy,
        yen: yen,
        Yfr: Yfr,
        yfr: yfr,
        YIcy: YIcy,
        yicy: yicy,
        Yopf: Yopf,
        yopf: yopf,
        Yscr: Yscr,
        yscr: yscr,
        YUcy: YUcy,
        yucy: yucy,
        yuml: yuml,
        Yuml: Yuml,
        Zacute: Zacute,
        zacute: zacute,
        Zcaron: Zcaron,
        zcaron: zcaron,
        Zcy: Zcy,
        zcy: zcy,
        Zdot: Zdot,
        zdot: zdot,
        zeetrf: zeetrf,
        ZeroWidthSpace: ZeroWidthSpace,
        Zeta: Zeta,
        zeta: zeta,
        zfr: zfr,
        Zfr: Zfr,
        ZHcy: ZHcy,
        zhcy: zhcy,
        zigrarr: zigrarr,
        zopf: zopf,
        Zopf: Zopf,
        Zscr: Zscr,
        zscr: zscr,
        zwj: zwj,
        zwnj: zwnj
    };
    var entities$1 = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        Aacute: Aacute,
        aacute: aacute,
        Abreve: Abreve,
        abreve: abreve,
        ac: ac,
        acd: acd,
        acE: acE,
        Acirc: Acirc,
        acirc: acirc,
        acute: acute,
        Acy: Acy,
        acy: acy,
        AElig: AElig,
        aelig: aelig,
        af: af,
        Afr: Afr,
        afr: afr,
        Agrave: Agrave,
        agrave: agrave,
        alefsym: alefsym,
        aleph: aleph,
        Alpha: Alpha,
        alpha: alpha,
        Amacr: Amacr,
        amacr: amacr,
        amalg: amalg,
        amp: amp,
        AMP: AMP,
        andand: andand,
        And: And,
        and: and,
        andd: andd,
        andslope: andslope,
        andv: andv,
        ang: ang,
        ange: ange,
        angle: angle,
        angmsdaa: angmsdaa,
        angmsdab: angmsdab,
        angmsdac: angmsdac,
        angmsdad: angmsdad,
        angmsdae: angmsdae,
        angmsdaf: angmsdaf,
        angmsdag: angmsdag,
        angmsdah: angmsdah,
        angmsd: angmsd,
        angrt: angrt,
        angrtvb: angrtvb,
        angrtvbd: angrtvbd,
        angsph: angsph,
        angst: angst,
        angzarr: angzarr,
        Aogon: Aogon,
        aogon: aogon,
        Aopf: Aopf,
        aopf: aopf,
        apacir: apacir,
        ap: ap,
        apE: apE,
        ape: ape,
        apid: apid,
        apos: apos,
        ApplyFunction: ApplyFunction,
        approx: approx,
        approxeq: approxeq,
        Aring: Aring,
        aring: aring,
        Ascr: Ascr,
        ascr: ascr,
        Assign: Assign,
        ast: ast,
        asymp: asymp,
        asympeq: asympeq,
        Atilde: Atilde,
        atilde: atilde,
        Auml: Auml,
        auml: auml,
        awconint: awconint,
        awint: awint,
        backcong: backcong,
        backepsilon: backepsilon,
        backprime: backprime,
        backsim: backsim,
        backsimeq: backsimeq,
        Backslash: Backslash,
        Barv: Barv,
        barvee: barvee,
        barwed: barwed,
        Barwed: Barwed,
        barwedge: barwedge,
        bbrk: bbrk,
        bbrktbrk: bbrktbrk,
        bcong: bcong,
        Bcy: Bcy,
        bcy: bcy,
        bdquo: bdquo,
        becaus: becaus,
        because: because,
        Because: Because,
        bemptyv: bemptyv,
        bepsi: bepsi,
        bernou: bernou,
        Bernoullis: Bernoullis,
        Beta: Beta,
        beta: beta,
        beth: beth,
        between: between,
        Bfr: Bfr,
        bfr: bfr,
        bigcap: bigcap,
        bigcirc: bigcirc,
        bigcup: bigcup,
        bigodot: bigodot,
        bigoplus: bigoplus,
        bigotimes: bigotimes,
        bigsqcup: bigsqcup,
        bigstar: bigstar,
        bigtriangledown: bigtriangledown,
        bigtriangleup: bigtriangleup,
        biguplus: biguplus,
        bigvee: bigvee,
        bigwedge: bigwedge,
        bkarow: bkarow,
        blacklozenge: blacklozenge,
        blacksquare: blacksquare,
        blacktriangle: blacktriangle,
        blacktriangledown: blacktriangledown,
        blacktriangleleft: blacktriangleleft,
        blacktriangleright: blacktriangleright,
        blank: blank,
        blk12: blk12,
        blk14: blk14,
        blk34: blk34,
        block: block,
        bne: bne,
        bnequiv: bnequiv,
        bNot: bNot,
        bnot: bnot,
        Bopf: Bopf,
        bopf: bopf,
        bot: bot,
        bottom: bottom,
        bowtie: bowtie,
        boxbox: boxbox,
        boxdl: boxdl,
        boxdL: boxdL,
        boxDl: boxDl,
        boxDL: boxDL,
        boxdr: boxdr,
        boxdR: boxdR,
        boxDr: boxDr,
        boxDR: boxDR,
        boxh: boxh,
        boxH: boxH,
        boxhd: boxhd,
        boxHd: boxHd,
        boxhD: boxhD,
        boxHD: boxHD,
        boxhu: boxhu,
        boxHu: boxHu,
        boxhU: boxhU,
        boxHU: boxHU,
        boxminus: boxminus,
        boxplus: boxplus,
        boxtimes: boxtimes,
        boxul: boxul,
        boxuL: boxuL,
        boxUl: boxUl,
        boxUL: boxUL,
        boxur: boxur,
        boxuR: boxuR,
        boxUr: boxUr,
        boxUR: boxUR,
        boxv: boxv,
        boxV: boxV,
        boxvh: boxvh,
        boxvH: boxvH,
        boxVh: boxVh,
        boxVH: boxVH,
        boxvl: boxvl,
        boxvL: boxvL,
        boxVl: boxVl,
        boxVL: boxVL,
        boxvr: boxvr,
        boxvR: boxvR,
        boxVr: boxVr,
        boxVR: boxVR,
        bprime: bprime,
        breve: breve,
        Breve: Breve,
        brvbar: brvbar,
        bscr: bscr,
        Bscr: Bscr,
        bsemi: bsemi,
        bsim: bsim,
        bsime: bsime,
        bsolb: bsolb,
        bsol: bsol,
        bsolhsub: bsolhsub,
        bull: bull,
        bullet: bullet,
        bump: bump,
        bumpE: bumpE,
        bumpe: bumpe,
        Bumpeq: Bumpeq,
        bumpeq: bumpeq,
        Cacute: Cacute,
        cacute: cacute,
        capand: capand,
        capbrcup: capbrcup,
        capcap: capcap,
        cap: cap,
        Cap: Cap,
        capcup: capcup,
        capdot: capdot,
        CapitalDifferentialD: CapitalDifferentialD,
        caps: caps,
        caret: caret,
        caron: caron,
        Cayleys: Cayleys,
        ccaps: ccaps,
        Ccaron: Ccaron,
        ccaron: ccaron,
        Ccedil: Ccedil,
        ccedil: ccedil,
        Ccirc: Ccirc,
        ccirc: ccirc,
        Cconint: Cconint,
        ccups: ccups,
        ccupssm: ccupssm,
        Cdot: Cdot,
        cdot: cdot,
        cedil: cedil,
        Cedilla: Cedilla,
        cemptyv: cemptyv,
        cent: cent,
        centerdot: centerdot,
        CenterDot: CenterDot,
        cfr: cfr,
        Cfr: Cfr,
        CHcy: CHcy,
        chcy: chcy,
        check: check,
        checkmark: checkmark,
        Chi: Chi,
        chi: chi,
        circ: circ,
        circeq: circeq,
        circlearrowleft: circlearrowleft,
        circlearrowright: circlearrowright,
        circledast: circledast,
        circledcirc: circledcirc,
        circleddash: circleddash,
        CircleDot: CircleDot,
        circledR: circledR,
        circledS: circledS,
        CircleMinus: CircleMinus,
        CirclePlus: CirclePlus,
        CircleTimes: CircleTimes,
        cir: cir,
        cirE: cirE,
        cire: cire,
        cirfnint: cirfnint,
        cirmid: cirmid,
        cirscir: cirscir,
        ClockwiseContourIntegral: ClockwiseContourIntegral,
        CloseCurlyDoubleQuote: CloseCurlyDoubleQuote,
        CloseCurlyQuote: CloseCurlyQuote,
        clubs: clubs,
        clubsuit: clubsuit,
        colon: colon,
        Colon: Colon,
        Colone: Colone,
        colone: colone,
        coloneq: coloneq,
        comma: comma,
        commat: commat,
        comp: comp,
        compfn: compfn,
        complement: complement,
        complexes: complexes,
        cong: cong,
        congdot: congdot,
        Congruent: Congruent,
        conint: conint,
        Conint: Conint,
        ContourIntegral: ContourIntegral,
        copf: copf,
        Copf: Copf,
        coprod: coprod,
        Coproduct: Coproduct,
        copy: copy,
        COPY: COPY,
        copysr: copysr,
        CounterClockwiseContourIntegral: CounterClockwiseContourIntegral,
        crarr: crarr,
        cross: cross,
        Cross: Cross,
        Cscr: Cscr,
        cscr: cscr,
        csub: csub,
        csube: csube,
        csup: csup,
        csupe: csupe,
        ctdot: ctdot,
        cudarrl: cudarrl,
        cudarrr: cudarrr,
        cuepr: cuepr,
        cuesc: cuesc,
        cularr: cularr,
        cularrp: cularrp,
        cupbrcap: cupbrcap,
        cupcap: cupcap,
        CupCap: CupCap,
        cup: cup,
        Cup: Cup,
        cupcup: cupcup,
        cupdot: cupdot,
        cupor: cupor,
        cups: cups,
        curarr: curarr,
        curarrm: curarrm,
        curlyeqprec: curlyeqprec,
        curlyeqsucc: curlyeqsucc,
        curlyvee: curlyvee,
        curlywedge: curlywedge,
        curren: curren,
        curvearrowleft: curvearrowleft,
        curvearrowright: curvearrowright,
        cuvee: cuvee,
        cuwed: cuwed,
        cwconint: cwconint,
        cwint: cwint,
        cylcty: cylcty,
        dagger: dagger,
        Dagger: Dagger,
        daleth: daleth,
        darr: darr,
        Darr: Darr,
        dArr: dArr,
        dash: dash,
        Dashv: Dashv,
        dashv: dashv,
        dbkarow: dbkarow,
        dblac: dblac,
        Dcaron: Dcaron,
        dcaron: dcaron,
        Dcy: Dcy,
        dcy: dcy,
        ddagger: ddagger,
        ddarr: ddarr,
        DD: DD,
        dd: dd,
        DDotrahd: DDotrahd,
        ddotseq: ddotseq,
        deg: deg,
        Del: Del,
        Delta: Delta,
        delta: delta,
        demptyv: demptyv,
        dfisht: dfisht,
        Dfr: Dfr,
        dfr: dfr,
        dHar: dHar,
        dharl: dharl,
        dharr: dharr,
        DiacriticalAcute: DiacriticalAcute,
        DiacriticalDot: DiacriticalDot,
        DiacriticalDoubleAcute: DiacriticalDoubleAcute,
        DiacriticalGrave: DiacriticalGrave,
        DiacriticalTilde: DiacriticalTilde,
        diam: diam,
        diamond: diamond,
        Diamond: Diamond,
        diamondsuit: diamondsuit,
        diams: diams,
        die: die,
        DifferentialD: DifferentialD,
        digamma: digamma,
        disin: disin,
        div: div,
        divide: divide,
        divideontimes: divideontimes,
        divonx: divonx,
        DJcy: DJcy,
        djcy: djcy,
        dlcorn: dlcorn,
        dlcrop: dlcrop,
        dollar: dollar,
        Dopf: Dopf,
        dopf: dopf,
        Dot: Dot,
        dot: dot,
        DotDot: DotDot,
        doteq: doteq,
        doteqdot: doteqdot,
        DotEqual: DotEqual,
        dotminus: dotminus,
        dotplus: dotplus,
        dotsquare: dotsquare,
        doublebarwedge: doublebarwedge,
        DoubleContourIntegral: DoubleContourIntegral,
        DoubleDot: DoubleDot,
        DoubleDownArrow: DoubleDownArrow,
        DoubleLeftArrow: DoubleLeftArrow,
        DoubleLeftRightArrow: DoubleLeftRightArrow,
        DoubleLeftTee: DoubleLeftTee,
        DoubleLongLeftArrow: DoubleLongLeftArrow,
        DoubleLongLeftRightArrow: DoubleLongLeftRightArrow,
        DoubleLongRightArrow: DoubleLongRightArrow,
        DoubleRightArrow: DoubleRightArrow,
        DoubleRightTee: DoubleRightTee,
        DoubleUpArrow: DoubleUpArrow,
        DoubleUpDownArrow: DoubleUpDownArrow,
        DoubleVerticalBar: DoubleVerticalBar,
        DownArrowBar: DownArrowBar,
        downarrow: downarrow,
        DownArrow: DownArrow,
        Downarrow: Downarrow,
        DownArrowUpArrow: DownArrowUpArrow,
        DownBreve: DownBreve,
        downdownarrows: downdownarrows,
        downharpoonleft: downharpoonleft,
        downharpoonright: downharpoonright,
        DownLeftRightVector: DownLeftRightVector,
        DownLeftTeeVector: DownLeftTeeVector,
        DownLeftVectorBar: DownLeftVectorBar,
        DownLeftVector: DownLeftVector,
        DownRightTeeVector: DownRightTeeVector,
        DownRightVectorBar: DownRightVectorBar,
        DownRightVector: DownRightVector,
        DownTeeArrow: DownTeeArrow,
        DownTee: DownTee,
        drbkarow: drbkarow,
        drcorn: drcorn,
        drcrop: drcrop,
        Dscr: Dscr,
        dscr: dscr,
        DScy: DScy,
        dscy: dscy,
        dsol: dsol,
        Dstrok: Dstrok,
        dstrok: dstrok,
        dtdot: dtdot,
        dtri: dtri,
        dtrif: dtrif,
        duarr: duarr,
        duhar: duhar,
        dwangle: dwangle,
        DZcy: DZcy,
        dzcy: dzcy,
        dzigrarr: dzigrarr,
        Eacute: Eacute,
        eacute: eacute,
        easter: easter,
        Ecaron: Ecaron,
        ecaron: ecaron,
        Ecirc: Ecirc,
        ecirc: ecirc,
        ecir: ecir,
        ecolon: ecolon,
        Ecy: Ecy,
        ecy: ecy,
        eDDot: eDDot,
        Edot: Edot,
        edot: edot,
        eDot: eDot,
        ee: ee,
        efDot: efDot,
        Efr: Efr,
        efr: efr,
        eg: eg,
        Egrave: Egrave,
        egrave: egrave,
        egs: egs,
        egsdot: egsdot,
        el: el,
        Element: Element,
        elinters: elinters,
        ell: ell,
        els: els,
        elsdot: elsdot,
        Emacr: Emacr,
        emacr: emacr,
        empty: empty,
        emptyset: emptyset,
        EmptySmallSquare: EmptySmallSquare,
        emptyv: emptyv,
        EmptyVerySmallSquare: EmptyVerySmallSquare,
        emsp13: emsp13,
        emsp14: emsp14,
        emsp: emsp,
        ENG: ENG,
        eng: eng,
        ensp: ensp,
        Eogon: Eogon,
        eogon: eogon,
        Eopf: Eopf,
        eopf: eopf,
        epar: epar,
        eparsl: eparsl,
        eplus: eplus,
        epsi: epsi,
        Epsilon: Epsilon,
        epsilon: epsilon,
        epsiv: epsiv,
        eqcirc: eqcirc,
        eqcolon: eqcolon,
        eqsim: eqsim,
        eqslantgtr: eqslantgtr,
        eqslantless: eqslantless,
        Equal: Equal,
        equals: equals,
        EqualTilde: EqualTilde,
        equest: equest,
        Equilibrium: Equilibrium,
        equiv: equiv,
        equivDD: equivDD,
        eqvparsl: eqvparsl,
        erarr: erarr,
        erDot: erDot,
        escr: escr,
        Escr: Escr,
        esdot: esdot,
        Esim: Esim,
        esim: esim,
        Eta: Eta,
        eta: eta,
        ETH: ETH,
        eth: eth,
        Euml: Euml,
        euml: euml,
        euro: euro,
        excl: excl,
        exist: exist,
        Exists: Exists,
        expectation: expectation,
        exponentiale: exponentiale,
        ExponentialE: ExponentialE,
        fallingdotseq: fallingdotseq,
        Fcy: Fcy,
        fcy: fcy,
        female: female,
        ffilig: ffilig,
        fflig: fflig,
        ffllig: ffllig,
        Ffr: Ffr,
        ffr: ffr,
        filig: filig,
        FilledSmallSquare: FilledSmallSquare,
        FilledVerySmallSquare: FilledVerySmallSquare,
        fjlig: fjlig,
        flat: flat,
        fllig: fllig,
        fltns: fltns,
        fnof: fnof,
        Fopf: Fopf,
        fopf: fopf,
        forall: forall,
        ForAll: ForAll,
        fork: fork,
        forkv: forkv,
        Fouriertrf: Fouriertrf,
        fpartint: fpartint,
        frac12: frac12,
        frac13: frac13,
        frac14: frac14,
        frac15: frac15,
        frac16: frac16,
        frac18: frac18,
        frac23: frac23,
        frac25: frac25,
        frac34: frac34,
        frac35: frac35,
        frac38: frac38,
        frac45: frac45,
        frac56: frac56,
        frac58: frac58,
        frac78: frac78,
        frasl: frasl,
        frown: frown,
        fscr: fscr,
        Fscr: Fscr,
        gacute: gacute,
        Gamma: Gamma,
        gamma: gamma,
        Gammad: Gammad,
        gammad: gammad,
        gap: gap,
        Gbreve: Gbreve,
        gbreve: gbreve,
        Gcedil: Gcedil,
        Gcirc: Gcirc,
        gcirc: gcirc,
        Gcy: Gcy,
        gcy: gcy,
        Gdot: Gdot,
        gdot: gdot,
        ge: ge,
        gE: gE,
        gEl: gEl,
        gel: gel,
        geq: geq,
        geqq: geqq,
        geqslant: geqslant,
        gescc: gescc,
        ges: ges,
        gesdot: gesdot,
        gesdoto: gesdoto,
        gesdotol: gesdotol,
        gesl: gesl,
        gesles: gesles,
        Gfr: Gfr,
        gfr: gfr,
        gg: gg,
        Gg: Gg,
        ggg: ggg,
        gimel: gimel,
        GJcy: GJcy,
        gjcy: gjcy,
        gla: gla,
        gl: gl,
        glE: glE,
        glj: glj,
        gnap: gnap,
        gnapprox: gnapprox,
        gne: gne,
        gnE: gnE,
        gneq: gneq,
        gneqq: gneqq,
        gnsim: gnsim,
        Gopf: Gopf,
        gopf: gopf,
        grave: grave,
        GreaterEqual: GreaterEqual,
        GreaterEqualLess: GreaterEqualLess,
        GreaterFullEqual: GreaterFullEqual,
        GreaterGreater: GreaterGreater,
        GreaterLess: GreaterLess,
        GreaterSlantEqual: GreaterSlantEqual,
        GreaterTilde: GreaterTilde,
        Gscr: Gscr,
        gscr: gscr,
        gsim: gsim,
        gsime: gsime,
        gsiml: gsiml,
        gtcc: gtcc,
        gtcir: gtcir,
        gt: gt,
        GT: GT,
        Gt: Gt,
        gtdot: gtdot,
        gtlPar: gtlPar,
        gtquest: gtquest,
        gtrapprox: gtrapprox,
        gtrarr: gtrarr,
        gtrdot: gtrdot,
        gtreqless: gtreqless,
        gtreqqless: gtreqqless,
        gtrless: gtrless,
        gtrsim: gtrsim,
        gvertneqq: gvertneqq,
        gvnE: gvnE,
        Hacek: Hacek,
        hairsp: hairsp,
        half: half,
        hamilt: hamilt,
        HARDcy: HARDcy,
        hardcy: hardcy,
        harrcir: harrcir,
        harr: harr,
        hArr: hArr,
        harrw: harrw,
        Hat: Hat,
        hbar: hbar,
        Hcirc: Hcirc,
        hcirc: hcirc,
        hearts: hearts,
        heartsuit: heartsuit,
        hellip: hellip,
        hercon: hercon,
        hfr: hfr,
        Hfr: Hfr,
        HilbertSpace: HilbertSpace,
        hksearow: hksearow,
        hkswarow: hkswarow,
        hoarr: hoarr,
        homtht: homtht,
        hookleftarrow: hookleftarrow,
        hookrightarrow: hookrightarrow,
        hopf: hopf,
        Hopf: Hopf,
        horbar: horbar,
        HorizontalLine: HorizontalLine,
        hscr: hscr,
        Hscr: Hscr,
        hslash: hslash,
        Hstrok: Hstrok,
        hstrok: hstrok,
        HumpDownHump: HumpDownHump,
        HumpEqual: HumpEqual,
        hybull: hybull,
        hyphen: hyphen,
        Iacute: Iacute,
        iacute: iacute,
        ic: ic,
        Icirc: Icirc,
        icirc: icirc,
        Icy: Icy,
        icy: icy,
        Idot: Idot,
        IEcy: IEcy,
        iecy: iecy,
        iexcl: iexcl,
        iff: iff,
        ifr: ifr,
        Ifr: Ifr,
        Igrave: Igrave,
        igrave: igrave,
        ii: ii,
        iiiint: iiiint,
        iiint: iiint,
        iinfin: iinfin,
        iiota: iiota,
        IJlig: IJlig,
        ijlig: ijlig,
        Imacr: Imacr,
        imacr: imacr,
        image: image,
        ImaginaryI: ImaginaryI,
        imagline: imagline,
        imagpart: imagpart,
        imath: imath,
        Im: Im,
        imof: imof,
        imped: imped,
        Implies: Implies,
        incare: incare,
        infin: infin,
        infintie: infintie,
        inodot: inodot,
        intcal: intcal,
        int: int,
        Int: Int,
        integers: integers,
        Integral: Integral,
        intercal: intercal,
        Intersection: Intersection,
        intlarhk: intlarhk,
        intprod: intprod,
        InvisibleComma: InvisibleComma,
        InvisibleTimes: InvisibleTimes,
        IOcy: IOcy,
        iocy: iocy,
        Iogon: Iogon,
        iogon: iogon,
        Iopf: Iopf,
        iopf: iopf,
        Iota: Iota,
        iota: iota,
        iprod: iprod,
        iquest: iquest,
        iscr: iscr,
        Iscr: Iscr,
        isin: isin,
        isindot: isindot,
        isinE: isinE,
        isins: isins,
        isinsv: isinsv,
        isinv: isinv,
        it: it,
        Itilde: Itilde,
        itilde: itilde,
        Iukcy: Iukcy,
        iukcy: iukcy,
        Iuml: Iuml,
        iuml: iuml,
        Jcirc: Jcirc,
        jcirc: jcirc,
        Jcy: Jcy,
        jcy: jcy,
        Jfr: Jfr,
        jfr: jfr,
        jmath: jmath,
        Jopf: Jopf,
        jopf: jopf,
        Jscr: Jscr,
        jscr: jscr,
        Jsercy: Jsercy,
        jsercy: jsercy,
        Jukcy: Jukcy,
        jukcy: jukcy,
        Kappa: Kappa,
        kappa: kappa,
        kappav: kappav,
        Kcedil: Kcedil,
        kcedil: kcedil,
        Kcy: Kcy,
        kcy: kcy,
        Kfr: Kfr,
        kfr: kfr,
        kgreen: kgreen,
        KHcy: KHcy,
        khcy: khcy,
        KJcy: KJcy,
        kjcy: kjcy,
        Kopf: Kopf,
        kopf: kopf,
        Kscr: Kscr,
        kscr: kscr,
        lAarr: lAarr,
        Lacute: Lacute,
        lacute: lacute,
        laemptyv: laemptyv,
        lagran: lagran,
        Lambda: Lambda,
        lambda: lambda,
        lang: lang,
        Lang: Lang,
        langd: langd,
        langle: langle,
        lap: lap,
        Laplacetrf: Laplacetrf,
        laquo: laquo,
        larrb: larrb,
        larrbfs: larrbfs,
        larr: larr,
        Larr: Larr,
        lArr: lArr,
        larrfs: larrfs,
        larrhk: larrhk,
        larrlp: larrlp,
        larrpl: larrpl,
        larrsim: larrsim,
        larrtl: larrtl,
        latail: latail,
        lAtail: lAtail,
        lat: lat,
        late: late,
        lates: lates,
        lbarr: lbarr,
        lBarr: lBarr,
        lbbrk: lbbrk,
        lbrace: lbrace,
        lbrack: lbrack,
        lbrke: lbrke,
        lbrksld: lbrksld,
        lbrkslu: lbrkslu,
        Lcaron: Lcaron,
        lcaron: lcaron,
        Lcedil: Lcedil,
        lcedil: lcedil,
        lceil: lceil,
        lcub: lcub,
        Lcy: Lcy,
        lcy: lcy,
        ldca: ldca,
        ldquo: ldquo,
        ldquor: ldquor,
        ldrdhar: ldrdhar,
        ldrushar: ldrushar,
        ldsh: ldsh,
        le: le,
        lE: lE,
        LeftAngleBracket: LeftAngleBracket,
        LeftArrowBar: LeftArrowBar,
        leftarrow: leftarrow,
        LeftArrow: LeftArrow,
        Leftarrow: Leftarrow,
        LeftArrowRightArrow: LeftArrowRightArrow,
        leftarrowtail: leftarrowtail,
        LeftCeiling: LeftCeiling,
        LeftDoubleBracket: LeftDoubleBracket,
        LeftDownTeeVector: LeftDownTeeVector,
        LeftDownVectorBar: LeftDownVectorBar,
        LeftDownVector: LeftDownVector,
        LeftFloor: LeftFloor,
        leftharpoondown: leftharpoondown,
        leftharpoonup: leftharpoonup,
        leftleftarrows: leftleftarrows,
        leftrightarrow: leftrightarrow,
        LeftRightArrow: LeftRightArrow,
        Leftrightarrow: Leftrightarrow,
        leftrightarrows: leftrightarrows,
        leftrightharpoons: leftrightharpoons,
        leftrightsquigarrow: leftrightsquigarrow,
        LeftRightVector: LeftRightVector,
        LeftTeeArrow: LeftTeeArrow,
        LeftTee: LeftTee,
        LeftTeeVector: LeftTeeVector,
        leftthreetimes: leftthreetimes,
        LeftTriangleBar: LeftTriangleBar,
        LeftTriangle: LeftTriangle,
        LeftTriangleEqual: LeftTriangleEqual,
        LeftUpDownVector: LeftUpDownVector,
        LeftUpTeeVector: LeftUpTeeVector,
        LeftUpVectorBar: LeftUpVectorBar,
        LeftUpVector: LeftUpVector,
        LeftVectorBar: LeftVectorBar,
        LeftVector: LeftVector,
        lEg: lEg,
        leg: leg,
        leq: leq,
        leqq: leqq,
        leqslant: leqslant,
        lescc: lescc,
        les: les,
        lesdot: lesdot,
        lesdoto: lesdoto,
        lesdotor: lesdotor,
        lesg: lesg,
        lesges: lesges,
        lessapprox: lessapprox,
        lessdot: lessdot,
        lesseqgtr: lesseqgtr,
        lesseqqgtr: lesseqqgtr,
        LessEqualGreater: LessEqualGreater,
        LessFullEqual: LessFullEqual,
        LessGreater: LessGreater,
        lessgtr: lessgtr,
        LessLess: LessLess,
        lesssim: lesssim,
        LessSlantEqual: LessSlantEqual,
        LessTilde: LessTilde,
        lfisht: lfisht,
        lfloor: lfloor,
        Lfr: Lfr,
        lfr: lfr,
        lg: lg,
        lgE: lgE,
        lHar: lHar,
        lhard: lhard,
        lharu: lharu,
        lharul: lharul,
        lhblk: lhblk,
        LJcy: LJcy,
        ljcy: ljcy,
        llarr: llarr,
        ll: ll,
        Ll: Ll,
        llcorner: llcorner,
        Lleftarrow: Lleftarrow,
        llhard: llhard,
        lltri: lltri,
        Lmidot: Lmidot,
        lmidot: lmidot,
        lmoustache: lmoustache,
        lmoust: lmoust,
        lnap: lnap,
        lnapprox: lnapprox,
        lne: lne,
        lnE: lnE,
        lneq: lneq,
        lneqq: lneqq,
        lnsim: lnsim,
        loang: loang,
        loarr: loarr,
        lobrk: lobrk,
        longleftarrow: longleftarrow,
        LongLeftArrow: LongLeftArrow,
        Longleftarrow: Longleftarrow,
        longleftrightarrow: longleftrightarrow,
        LongLeftRightArrow: LongLeftRightArrow,
        Longleftrightarrow: Longleftrightarrow,
        longmapsto: longmapsto,
        longrightarrow: longrightarrow,
        LongRightArrow: LongRightArrow,
        Longrightarrow: Longrightarrow,
        looparrowleft: looparrowleft,
        looparrowright: looparrowright,
        lopar: lopar,
        Lopf: Lopf,
        lopf: lopf,
        loplus: loplus,
        lotimes: lotimes,
        lowast: lowast,
        lowbar: lowbar,
        LowerLeftArrow: LowerLeftArrow,
        LowerRightArrow: LowerRightArrow,
        loz: loz,
        lozenge: lozenge,
        lozf: lozf,
        lpar: lpar,
        lparlt: lparlt,
        lrarr: lrarr,
        lrcorner: lrcorner,
        lrhar: lrhar,
        lrhard: lrhard,
        lrm: lrm,
        lrtri: lrtri,
        lsaquo: lsaquo,
        lscr: lscr,
        Lscr: Lscr,
        lsh: lsh,
        Lsh: Lsh,
        lsim: lsim,
        lsime: lsime,
        lsimg: lsimg,
        lsqb: lsqb,
        lsquo: lsquo,
        lsquor: lsquor,
        Lstrok: Lstrok,
        lstrok: lstrok,
        ltcc: ltcc,
        ltcir: ltcir,
        lt: lt,
        LT: LT,
        Lt: Lt,
        ltdot: ltdot,
        lthree: lthree,
        ltimes: ltimes,
        ltlarr: ltlarr,
        ltquest: ltquest,
        ltri: ltri,
        ltrie: ltrie,
        ltrif: ltrif,
        ltrPar: ltrPar,
        lurdshar: lurdshar,
        luruhar: luruhar,
        lvertneqq: lvertneqq,
        lvnE: lvnE,
        macr: macr,
        male: male,
        malt: malt,
        maltese: maltese,
        map: map,
        mapsto: mapsto,
        mapstodown: mapstodown,
        mapstoleft: mapstoleft,
        mapstoup: mapstoup,
        marker: marker,
        mcomma: mcomma,
        Mcy: Mcy,
        mcy: mcy,
        mdash: mdash,
        mDDot: mDDot,
        measuredangle: measuredangle,
        MediumSpace: MediumSpace,
        Mellintrf: Mellintrf,
        Mfr: Mfr,
        mfr: mfr,
        mho: mho,
        micro: micro,
        midast: midast,
        midcir: midcir,
        mid: mid,
        middot: middot,
        minusb: minusb,
        minus: minus,
        minusd: minusd,
        minusdu: minusdu,
        MinusPlus: MinusPlus,
        mlcp: mlcp,
        mldr: mldr,
        mnplus: mnplus,
        models: models,
        Mopf: Mopf,
        mopf: mopf,
        mp: mp,
        mscr: mscr,
        Mscr: Mscr,
        mstpos: mstpos,
        Mu: Mu,
        mu: mu,
        multimap: multimap,
        mumap: mumap,
        nabla: nabla,
        Nacute: Nacute,
        nacute: nacute,
        nang: nang,
        nap: nap,
        napE: napE,
        napid: napid,
        napos: napos,
        napprox: napprox,
        natural: natural,
        naturals: naturals,
        natur: natur,
        nbsp: nbsp,
        nbump: nbump,
        nbumpe: nbumpe,
        ncap: ncap,
        Ncaron: Ncaron,
        ncaron: ncaron,
        Ncedil: Ncedil,
        ncedil: ncedil,
        ncong: ncong,
        ncongdot: ncongdot,
        ncup: ncup,
        Ncy: Ncy,
        ncy: ncy,
        ndash: ndash,
        nearhk: nearhk,
        nearr: nearr,
        neArr: neArr,
        nearrow: nearrow,
        ne: ne,
        nedot: nedot,
        NegativeMediumSpace: NegativeMediumSpace,
        NegativeThickSpace: NegativeThickSpace,
        NegativeThinSpace: NegativeThinSpace,
        NegativeVeryThinSpace: NegativeVeryThinSpace,
        nequiv: nequiv,
        nesear: nesear,
        nesim: nesim,
        NestedGreaterGreater: NestedGreaterGreater,
        NestedLessLess: NestedLessLess,
        NewLine: NewLine,
        nexist: nexist,
        nexists: nexists,
        Nfr: Nfr,
        nfr: nfr,
        ngE: ngE,
        nge: nge,
        ngeq: ngeq,
        ngeqq: ngeqq,
        ngeqslant: ngeqslant,
        nges: nges,
        nGg: nGg,
        ngsim: ngsim,
        nGt: nGt,
        ngt: ngt,
        ngtr: ngtr,
        nGtv: nGtv,
        nharr: nharr,
        nhArr: nhArr,
        nhpar: nhpar,
        ni: ni,
        nis: nis,
        nisd: nisd,
        niv: niv,
        NJcy: NJcy,
        njcy: njcy,
        nlarr: nlarr,
        nlArr: nlArr,
        nldr: nldr,
        nlE: nlE,
        nle: nle,
        nleftarrow: nleftarrow,
        nLeftarrow: nLeftarrow,
        nleftrightarrow: nleftrightarrow,
        nLeftrightarrow: nLeftrightarrow,
        nleq: nleq,
        nleqq: nleqq,
        nleqslant: nleqslant,
        nles: nles,
        nless: nless,
        nLl: nLl,
        nlsim: nlsim,
        nLt: nLt,
        nlt: nlt,
        nltri: nltri,
        nltrie: nltrie,
        nLtv: nLtv,
        nmid: nmid,
        NoBreak: NoBreak,
        NonBreakingSpace: NonBreakingSpace,
        nopf: nopf,
        Nopf: Nopf,
        Not: Not,
        not: not,
        NotCongruent: NotCongruent,
        NotCupCap: NotCupCap,
        NotDoubleVerticalBar: NotDoubleVerticalBar,
        NotElement: NotElement,
        NotEqual: NotEqual,
        NotEqualTilde: NotEqualTilde,
        NotExists: NotExists,
        NotGreater: NotGreater,
        NotGreaterEqual: NotGreaterEqual,
        NotGreaterFullEqual: NotGreaterFullEqual,
        NotGreaterGreater: NotGreaterGreater,
        NotGreaterLess: NotGreaterLess,
        NotGreaterSlantEqual: NotGreaterSlantEqual,
        NotGreaterTilde: NotGreaterTilde,
        NotHumpDownHump: NotHumpDownHump,
        NotHumpEqual: NotHumpEqual,
        notin: notin,
        notindot: notindot,
        notinE: notinE,
        notinva: notinva,
        notinvb: notinvb,
        notinvc: notinvc,
        NotLeftTriangleBar: NotLeftTriangleBar,
        NotLeftTriangle: NotLeftTriangle,
        NotLeftTriangleEqual: NotLeftTriangleEqual,
        NotLess: NotLess,
        NotLessEqual: NotLessEqual,
        NotLessGreater: NotLessGreater,
        NotLessLess: NotLessLess,
        NotLessSlantEqual: NotLessSlantEqual,
        NotLessTilde: NotLessTilde,
        NotNestedGreaterGreater: NotNestedGreaterGreater,
        NotNestedLessLess: NotNestedLessLess,
        notni: notni,
        notniva: notniva,
        notnivb: notnivb,
        notnivc: notnivc,
        NotPrecedes: NotPrecedes,
        NotPrecedesEqual: NotPrecedesEqual,
        NotPrecedesSlantEqual: NotPrecedesSlantEqual,
        NotReverseElement: NotReverseElement,
        NotRightTriangleBar: NotRightTriangleBar,
        NotRightTriangle: NotRightTriangle,
        NotRightTriangleEqual: NotRightTriangleEqual,
        NotSquareSubset: NotSquareSubset,
        NotSquareSubsetEqual: NotSquareSubsetEqual,
        NotSquareSuperset: NotSquareSuperset,
        NotSquareSupersetEqual: NotSquareSupersetEqual,
        NotSubset: NotSubset,
        NotSubsetEqual: NotSubsetEqual,
        NotSucceeds: NotSucceeds,
        NotSucceedsEqual: NotSucceedsEqual,
        NotSucceedsSlantEqual: NotSucceedsSlantEqual,
        NotSucceedsTilde: NotSucceedsTilde,
        NotSuperset: NotSuperset,
        NotSupersetEqual: NotSupersetEqual,
        NotTilde: NotTilde,
        NotTildeEqual: NotTildeEqual,
        NotTildeFullEqual: NotTildeFullEqual,
        NotTildeTilde: NotTildeTilde,
        NotVerticalBar: NotVerticalBar,
        nparallel: nparallel,
        npar: npar,
        nparsl: nparsl,
        npart: npart,
        npolint: npolint,
        npr: npr,
        nprcue: nprcue,
        nprec: nprec,
        npreceq: npreceq,
        npre: npre,
        nrarrc: nrarrc,
        nrarr: nrarr,
        nrArr: nrArr,
        nrarrw: nrarrw,
        nrightarrow: nrightarrow,
        nRightarrow: nRightarrow,
        nrtri: nrtri,
        nrtrie: nrtrie,
        nsc: nsc,
        nsccue: nsccue,
        nsce: nsce,
        Nscr: Nscr,
        nscr: nscr,
        nshortmid: nshortmid,
        nshortparallel: nshortparallel,
        nsim: nsim,
        nsime: nsime,
        nsimeq: nsimeq,
        nsmid: nsmid,
        nspar: nspar,
        nsqsube: nsqsube,
        nsqsupe: nsqsupe,
        nsub: nsub,
        nsubE: nsubE,
        nsube: nsube,
        nsubset: nsubset,
        nsubseteq: nsubseteq,
        nsubseteqq: nsubseteqq,
        nsucc: nsucc,
        nsucceq: nsucceq,
        nsup: nsup,
        nsupE: nsupE,
        nsupe: nsupe,
        nsupset: nsupset,
        nsupseteq: nsupseteq,
        nsupseteqq: nsupseteqq,
        ntgl: ntgl,
        Ntilde: Ntilde,
        ntilde: ntilde,
        ntlg: ntlg,
        ntriangleleft: ntriangleleft,
        ntrianglelefteq: ntrianglelefteq,
        ntriangleright: ntriangleright,
        ntrianglerighteq: ntrianglerighteq,
        Nu: Nu,
        nu: nu,
        num: num,
        numero: numero,
        numsp: numsp,
        nvap: nvap,
        nvdash: nvdash,
        nvDash: nvDash,
        nVdash: nVdash,
        nVDash: nVDash,
        nvge: nvge,
        nvgt: nvgt,
        nvHarr: nvHarr,
        nvinfin: nvinfin,
        nvlArr: nvlArr,
        nvle: nvle,
        nvlt: nvlt,
        nvltrie: nvltrie,
        nvrArr: nvrArr,
        nvrtrie: nvrtrie,
        nvsim: nvsim,
        nwarhk: nwarhk,
        nwarr: nwarr,
        nwArr: nwArr,
        nwarrow: nwarrow,
        nwnear: nwnear,
        Oacute: Oacute,
        oacute: oacute,
        oast: oast,
        Ocirc: Ocirc,
        ocirc: ocirc,
        ocir: ocir,
        Ocy: Ocy,
        ocy: ocy,
        odash: odash,
        Odblac: Odblac,
        odblac: odblac,
        odiv: odiv,
        odot: odot,
        odsold: odsold,
        OElig: OElig,
        oelig: oelig,
        ofcir: ofcir,
        Ofr: Ofr,
        ofr: ofr,
        ogon: ogon,
        Ograve: Ograve,
        ograve: ograve,
        ogt: ogt,
        ohbar: ohbar,
        ohm: ohm,
        oint: oint,
        olarr: olarr,
        olcir: olcir,
        olcross: olcross,
        oline: oline,
        olt: olt,
        Omacr: Omacr,
        omacr: omacr,
        Omega: Omega,
        omega: omega,
        Omicron: Omicron,
        omicron: omicron,
        omid: omid,
        ominus: ominus,
        Oopf: Oopf,
        oopf: oopf,
        opar: opar,
        OpenCurlyDoubleQuote: OpenCurlyDoubleQuote,
        OpenCurlyQuote: OpenCurlyQuote,
        operp: operp,
        oplus: oplus,
        orarr: orarr,
        Or: Or,
        or: or,
        ord: ord,
        order: order,
        orderof: orderof,
        ordf: ordf,
        ordm: ordm,
        origof: origof,
        oror: oror,
        orslope: orslope,
        orv: orv,
        oS: oS,
        Oscr: Oscr,
        oscr: oscr,
        Oslash: Oslash,
        oslash: oslash,
        osol: osol,
        Otilde: Otilde,
        otilde: otilde,
        otimesas: otimesas,
        Otimes: Otimes,
        otimes: otimes,
        Ouml: Ouml,
        ouml: ouml,
        ovbar: ovbar,
        OverBar: OverBar,
        OverBrace: OverBrace,
        OverBracket: OverBracket,
        OverParenthesis: OverParenthesis,
        para: para,
        parallel: parallel,
        par: par,
        parsim: parsim,
        parsl: parsl,
        part: part,
        PartialD: PartialD,
        Pcy: Pcy,
        pcy: pcy,
        percnt: percnt,
        period: period,
        permil: permil,
        perp: perp,
        pertenk: pertenk,
        Pfr: Pfr,
        pfr: pfr,
        Phi: Phi,
        phi: phi,
        phiv: phiv,
        phmmat: phmmat,
        phone: phone,
        Pi: Pi,
        pi: pi,
        pitchfork: pitchfork,
        piv: piv,
        planck: planck,
        planckh: planckh,
        plankv: plankv,
        plusacir: plusacir,
        plusb: plusb,
        pluscir: pluscir,
        plus: plus,
        plusdo: plusdo,
        plusdu: plusdu,
        pluse: pluse,
        PlusMinus: PlusMinus,
        plusmn: plusmn,
        plussim: plussim,
        plustwo: plustwo,
        pm: pm,
        Poincareplane: Poincareplane,
        pointint: pointint,
        popf: popf,
        Popf: Popf,
        pound: pound,
        prap: prap,
        Pr: Pr,
        pr: pr,
        prcue: prcue,
        precapprox: precapprox,
        prec: prec,
        preccurlyeq: preccurlyeq,
        Precedes: Precedes,
        PrecedesEqual: PrecedesEqual,
        PrecedesSlantEqual: PrecedesSlantEqual,
        PrecedesTilde: PrecedesTilde,
        preceq: preceq,
        precnapprox: precnapprox,
        precneqq: precneqq,
        precnsim: precnsim,
        pre: pre,
        prE: prE,
        precsim: precsim,
        prime: prime,
        Prime: Prime,
        primes: primes,
        prnap: prnap,
        prnE: prnE,
        prnsim: prnsim,
        prod: prod,
        Product: Product,
        profalar: profalar,
        profline: profline,
        profsurf: profsurf,
        prop: prop,
        Proportional: Proportional,
        Proportion: Proportion,
        propto: propto,
        prsim: prsim,
        prurel: prurel,
        Pscr: Pscr,
        pscr: pscr,
        Psi: Psi,
        psi: psi,
        puncsp: puncsp,
        Qfr: Qfr,
        qfr: qfr,
        qint: qint,
        qopf: qopf,
        Qopf: Qopf,
        qprime: qprime,
        Qscr: Qscr,
        qscr: qscr,
        quaternions: quaternions,
        quatint: quatint,
        quest: quest,
        questeq: questeq,
        quot: quot,
        QUOT: QUOT,
        rAarr: rAarr,
        race: race,
        Racute: Racute,
        racute: racute,
        radic: radic,
        raemptyv: raemptyv,
        rang: rang,
        Rang: Rang,
        rangd: rangd,
        range: range,
        rangle: rangle,
        raquo: raquo,
        rarrap: rarrap,
        rarrb: rarrb,
        rarrbfs: rarrbfs,
        rarrc: rarrc,
        rarr: rarr,
        Rarr: Rarr,
        rArr: rArr,
        rarrfs: rarrfs,
        rarrhk: rarrhk,
        rarrlp: rarrlp,
        rarrpl: rarrpl,
        rarrsim: rarrsim,
        Rarrtl: Rarrtl,
        rarrtl: rarrtl,
        rarrw: rarrw,
        ratail: ratail,
        rAtail: rAtail,
        ratio: ratio,
        rationals: rationals,
        rbarr: rbarr,
        rBarr: rBarr,
        RBarr: RBarr,
        rbbrk: rbbrk,
        rbrace: rbrace,
        rbrack: rbrack,
        rbrke: rbrke,
        rbrksld: rbrksld,
        rbrkslu: rbrkslu,
        Rcaron: Rcaron,
        rcaron: rcaron,
        Rcedil: Rcedil,
        rcedil: rcedil,
        rceil: rceil,
        rcub: rcub,
        Rcy: Rcy,
        rcy: rcy,
        rdca: rdca,
        rdldhar: rdldhar,
        rdquo: rdquo,
        rdquor: rdquor,
        rdsh: rdsh,
        real: real,
        realine: realine,
        realpart: realpart,
        reals: reals,
        Re: Re,
        rect: rect,
        reg: reg,
        REG: REG,
        ReverseElement: ReverseElement,
        ReverseEquilibrium: ReverseEquilibrium,
        ReverseUpEquilibrium: ReverseUpEquilibrium,
        rfisht: rfisht,
        rfloor: rfloor,
        rfr: rfr,
        Rfr: Rfr,
        rHar: rHar,
        rhard: rhard,
        rharu: rharu,
        rharul: rharul,
        Rho: Rho,
        rho: rho,
        rhov: rhov,
        RightAngleBracket: RightAngleBracket,
        RightArrowBar: RightArrowBar,
        rightarrow: rightarrow,
        RightArrow: RightArrow,
        Rightarrow: Rightarrow,
        RightArrowLeftArrow: RightArrowLeftArrow,
        rightarrowtail: rightarrowtail,
        RightCeiling: RightCeiling,
        RightDoubleBracket: RightDoubleBracket,
        RightDownTeeVector: RightDownTeeVector,
        RightDownVectorBar: RightDownVectorBar,
        RightDownVector: RightDownVector,
        RightFloor: RightFloor,
        rightharpoondown: rightharpoondown,
        rightharpoonup: rightharpoonup,
        rightleftarrows: rightleftarrows,
        rightleftharpoons: rightleftharpoons,
        rightrightarrows: rightrightarrows,
        rightsquigarrow: rightsquigarrow,
        RightTeeArrow: RightTeeArrow,
        RightTee: RightTee,
        RightTeeVector: RightTeeVector,
        rightthreetimes: rightthreetimes,
        RightTriangleBar: RightTriangleBar,
        RightTriangle: RightTriangle,
        RightTriangleEqual: RightTriangleEqual,
        RightUpDownVector: RightUpDownVector,
        RightUpTeeVector: RightUpTeeVector,
        RightUpVectorBar: RightUpVectorBar,
        RightUpVector: RightUpVector,
        RightVectorBar: RightVectorBar,
        RightVector: RightVector,
        ring: ring,
        risingdotseq: risingdotseq,
        rlarr: rlarr,
        rlhar: rlhar,
        rlm: rlm,
        rmoustache: rmoustache,
        rmoust: rmoust,
        rnmid: rnmid,
        roang: roang,
        roarr: roarr,
        robrk: robrk,
        ropar: ropar,
        ropf: ropf,
        Ropf: Ropf,
        roplus: roplus,
        rotimes: rotimes,
        RoundImplies: RoundImplies,
        rpar: rpar,
        rpargt: rpargt,
        rppolint: rppolint,
        rrarr: rrarr,
        Rrightarrow: Rrightarrow,
        rsaquo: rsaquo,
        rscr: rscr,
        Rscr: Rscr,
        rsh: rsh,
        Rsh: Rsh,
        rsqb: rsqb,
        rsquo: rsquo,
        rsquor: rsquor,
        rthree: rthree,
        rtimes: rtimes,
        rtri: rtri,
        rtrie: rtrie,
        rtrif: rtrif,
        rtriltri: rtriltri,
        RuleDelayed: RuleDelayed,
        ruluhar: ruluhar,
        rx: rx,
        Sacute: Sacute,
        sacute: sacute,
        sbquo: sbquo,
        scap: scap,
        Scaron: Scaron,
        scaron: scaron,
        Sc: Sc,
        sc: sc,
        sccue: sccue,
        sce: sce,
        scE: scE,
        Scedil: Scedil,
        scedil: scedil,
        Scirc: Scirc,
        scirc: scirc,
        scnap: scnap,
        scnE: scnE,
        scnsim: scnsim,
        scpolint: scpolint,
        scsim: scsim,
        Scy: Scy,
        scy: scy,
        sdotb: sdotb,
        sdot: sdot,
        sdote: sdote,
        searhk: searhk,
        searr: searr,
        seArr: seArr,
        searrow: searrow,
        sect: sect,
        semi: semi,
        seswar: seswar,
        setminus: setminus,
        setmn: setmn,
        sext: sext,
        Sfr: Sfr,
        sfr: sfr,
        sfrown: sfrown,
        sharp: sharp,
        SHCHcy: SHCHcy,
        shchcy: shchcy,
        SHcy: SHcy,
        shcy: shcy,
        ShortDownArrow: ShortDownArrow,
        ShortLeftArrow: ShortLeftArrow,
        shortmid: shortmid,
        shortparallel: shortparallel,
        ShortRightArrow: ShortRightArrow,
        ShortUpArrow: ShortUpArrow,
        shy: shy,
        Sigma: Sigma,
        sigma: sigma,
        sigmaf: sigmaf,
        sigmav: sigmav,
        sim: sim,
        simdot: simdot,
        sime: sime,
        simeq: simeq,
        simg: simg,
        simgE: simgE,
        siml: siml,
        simlE: simlE,
        simne: simne,
        simplus: simplus,
        simrarr: simrarr,
        slarr: slarr,
        SmallCircle: SmallCircle,
        smallsetminus: smallsetminus,
        smashp: smashp,
        smeparsl: smeparsl,
        smid: smid,
        smile: smile,
        smt: smt,
        smte: smte,
        smtes: smtes,
        SOFTcy: SOFTcy,
        softcy: softcy,
        solbar: solbar,
        solb: solb,
        sol: sol,
        Sopf: Sopf,
        sopf: sopf,
        spades: spades,
        spadesuit: spadesuit,
        spar: spar,
        sqcap: sqcap,
        sqcaps: sqcaps,
        sqcup: sqcup,
        sqcups: sqcups,
        Sqrt: Sqrt,
        sqsub: sqsub,
        sqsube: sqsube,
        sqsubset: sqsubset,
        sqsubseteq: sqsubseteq,
        sqsup: sqsup,
        sqsupe: sqsupe,
        sqsupset: sqsupset,
        sqsupseteq: sqsupseteq,
        square: square,
        Square: Square,
        SquareIntersection: SquareIntersection,
        SquareSubset: SquareSubset,
        SquareSubsetEqual: SquareSubsetEqual,
        SquareSuperset: SquareSuperset,
        SquareSupersetEqual: SquareSupersetEqual,
        SquareUnion: SquareUnion,
        squarf: squarf,
        squ: squ,
        squf: squf,
        srarr: srarr,
        Sscr: Sscr,
        sscr: sscr,
        ssetmn: ssetmn,
        ssmile: ssmile,
        sstarf: sstarf,
        Star: Star,
        star: star,
        starf: starf,
        straightepsilon: straightepsilon,
        straightphi: straightphi,
        strns: strns,
        sub: sub,
        Sub: Sub,
        subdot: subdot,
        subE: subE,
        sube: sube,
        subedot: subedot,
        submult: submult,
        subnE: subnE,
        subne: subne,
        subplus: subplus,
        subrarr: subrarr,
        subset: subset,
        Subset: Subset,
        subseteq: subseteq,
        subseteqq: subseteqq,
        SubsetEqual: SubsetEqual,
        subsetneq: subsetneq,
        subsetneqq: subsetneqq,
        subsim: subsim,
        subsub: subsub,
        subsup: subsup,
        succapprox: succapprox,
        succ: succ,
        succcurlyeq: succcurlyeq,
        Succeeds: Succeeds,
        SucceedsEqual: SucceedsEqual,
        SucceedsSlantEqual: SucceedsSlantEqual,
        SucceedsTilde: SucceedsTilde,
        succeq: succeq,
        succnapprox: succnapprox,
        succneqq: succneqq,
        succnsim: succnsim,
        succsim: succsim,
        SuchThat: SuchThat,
        sum: sum,
        Sum: Sum,
        sung: sung,
        sup1: sup1,
        sup2: sup2,
        sup3: sup3,
        sup: sup,
        Sup: Sup,
        supdot: supdot,
        supdsub: supdsub,
        supE: supE,
        supe: supe,
        supedot: supedot,
        Superset: Superset,
        SupersetEqual: SupersetEqual,
        suphsol: suphsol,
        suphsub: suphsub,
        suplarr: suplarr,
        supmult: supmult,
        supnE: supnE,
        supne: supne,
        supplus: supplus,
        supset: supset,
        Supset: Supset,
        supseteq: supseteq,
        supseteqq: supseteqq,
        supsetneq: supsetneq,
        supsetneqq: supsetneqq,
        supsim: supsim,
        supsub: supsub,
        supsup: supsup,
        swarhk: swarhk,
        swarr: swarr,
        swArr: swArr,
        swarrow: swarrow,
        swnwar: swnwar,
        szlig: szlig,
        Tab: Tab,
        target: target,
        Tau: Tau,
        tau: tau,
        tbrk: tbrk,
        Tcaron: Tcaron,
        tcaron: tcaron,
        Tcedil: Tcedil,
        tcedil: tcedil,
        Tcy: Tcy,
        tcy: tcy,
        tdot: tdot,
        telrec: telrec,
        Tfr: Tfr,
        tfr: tfr,
        there4: there4,
        therefore: therefore,
        Therefore: Therefore,
        Theta: Theta,
        theta: theta,
        thetasym: thetasym,
        thetav: thetav,
        thickapprox: thickapprox,
        thicksim: thicksim,
        ThickSpace: ThickSpace,
        ThinSpace: ThinSpace,
        thinsp: thinsp,
        thkap: thkap,
        thksim: thksim,
        THORN: THORN,
        thorn: thorn,
        tilde: tilde,
        Tilde: Tilde,
        TildeEqual: TildeEqual,
        TildeFullEqual: TildeFullEqual,
        TildeTilde: TildeTilde,
        timesbar: timesbar,
        timesb: timesb,
        times: times,
        timesd: timesd,
        tint: tint,
        toea: toea,
        topbot: topbot,
        topcir: topcir,
        top: top,
        Topf: Topf,
        topf: topf,
        topfork: topfork,
        tosa: tosa,
        tprime: tprime,
        trade: trade,
        TRADE: TRADE,
        triangle: triangle,
        triangledown: triangledown,
        triangleleft: triangleleft,
        trianglelefteq: trianglelefteq,
        triangleq: triangleq,
        triangleright: triangleright,
        trianglerighteq: trianglerighteq,
        tridot: tridot,
        trie: trie,
        triminus: triminus,
        TripleDot: TripleDot,
        triplus: triplus,
        trisb: trisb,
        tritime: tritime,
        trpezium: trpezium,
        Tscr: Tscr,
        tscr: tscr,
        TScy: TScy,
        tscy: tscy,
        TSHcy: TSHcy,
        tshcy: tshcy,
        Tstrok: Tstrok,
        tstrok: tstrok,
        twixt: twixt,
        twoheadleftarrow: twoheadleftarrow,
        twoheadrightarrow: twoheadrightarrow,
        Uacute: Uacute,
        uacute: uacute,
        uarr: uarr,
        Uarr: Uarr,
        uArr: uArr,
        Uarrocir: Uarrocir,
        Ubrcy: Ubrcy,
        ubrcy: ubrcy,
        Ubreve: Ubreve,
        ubreve: ubreve,
        Ucirc: Ucirc,
        ucirc: ucirc,
        Ucy: Ucy,
        ucy: ucy,
        udarr: udarr,
        Udblac: Udblac,
        udblac: udblac,
        udhar: udhar,
        ufisht: ufisht,
        Ufr: Ufr,
        ufr: ufr,
        Ugrave: Ugrave,
        ugrave: ugrave,
        uHar: uHar,
        uharl: uharl,
        uharr: uharr,
        uhblk: uhblk,
        ulcorn: ulcorn,
        ulcorner: ulcorner,
        ulcrop: ulcrop,
        ultri: ultri,
        Umacr: Umacr,
        umacr: umacr,
        uml: uml,
        UnderBar: UnderBar,
        UnderBrace: UnderBrace,
        UnderBracket: UnderBracket,
        UnderParenthesis: UnderParenthesis,
        Union: Union,
        UnionPlus: UnionPlus,
        Uogon: Uogon,
        uogon: uogon,
        Uopf: Uopf,
        uopf: uopf,
        UpArrowBar: UpArrowBar,
        uparrow: uparrow,
        UpArrow: UpArrow,
        Uparrow: Uparrow,
        UpArrowDownArrow: UpArrowDownArrow,
        updownarrow: updownarrow,
        UpDownArrow: UpDownArrow,
        Updownarrow: Updownarrow,
        UpEquilibrium: UpEquilibrium,
        upharpoonleft: upharpoonleft,
        upharpoonright: upharpoonright,
        uplus: uplus,
        UpperLeftArrow: UpperLeftArrow,
        UpperRightArrow: UpperRightArrow,
        upsi: upsi,
        Upsi: Upsi,
        upsih: upsih,
        Upsilon: Upsilon,
        upsilon: upsilon,
        UpTeeArrow: UpTeeArrow,
        UpTee: UpTee,
        upuparrows: upuparrows,
        urcorn: urcorn,
        urcorner: urcorner,
        urcrop: urcrop,
        Uring: Uring,
        uring: uring,
        urtri: urtri,
        Uscr: Uscr,
        uscr: uscr,
        utdot: utdot,
        Utilde: Utilde,
        utilde: utilde,
        utri: utri,
        utrif: utrif,
        uuarr: uuarr,
        Uuml: Uuml,
        uuml: uuml,
        uwangle: uwangle,
        vangrt: vangrt,
        varepsilon: varepsilon,
        varkappa: varkappa,
        varnothing: varnothing,
        varphi: varphi,
        varpi: varpi,
        varpropto: varpropto,
        varr: varr,
        vArr: vArr,
        varrho: varrho,
        varsigma: varsigma,
        varsubsetneq: varsubsetneq,
        varsubsetneqq: varsubsetneqq,
        varsupsetneq: varsupsetneq,
        varsupsetneqq: varsupsetneqq,
        vartheta: vartheta,
        vartriangleleft: vartriangleleft,
        vartriangleright: vartriangleright,
        vBar: vBar,
        Vbar: Vbar,
        vBarv: vBarv,
        Vcy: Vcy,
        vcy: vcy,
        vdash: vdash,
        vDash: vDash,
        Vdash: Vdash,
        VDash: VDash,
        Vdashl: Vdashl,
        veebar: veebar,
        vee: vee,
        Vee: Vee,
        veeeq: veeeq,
        vellip: vellip,
        verbar: verbar,
        Verbar: Verbar,
        vert: vert,
        Vert: Vert,
        VerticalBar: VerticalBar,
        VerticalLine: VerticalLine,
        VerticalSeparator: VerticalSeparator,
        VerticalTilde: VerticalTilde,
        VeryThinSpace: VeryThinSpace,
        Vfr: Vfr,
        vfr: vfr,
        vltri: vltri,
        vnsub: vnsub,
        vnsup: vnsup,
        Vopf: Vopf,
        vopf: vopf,
        vprop: vprop,
        vrtri: vrtri,
        Vscr: Vscr,
        vscr: vscr,
        vsubnE: vsubnE,
        vsubne: vsubne,
        vsupnE: vsupnE,
        vsupne: vsupne,
        Vvdash: Vvdash,
        vzigzag: vzigzag,
        Wcirc: Wcirc,
        wcirc: wcirc,
        wedbar: wedbar,
        wedge: wedge,
        Wedge: Wedge,
        wedgeq: wedgeq,
        weierp: weierp,
        Wfr: Wfr,
        wfr: wfr,
        Wopf: Wopf,
        wopf: wopf,
        wp: wp,
        wr: wr,
        wreath: wreath,
        Wscr: Wscr,
        wscr: wscr,
        xcap: xcap,
        xcirc: xcirc,
        xcup: xcup,
        xdtri: xdtri,
        Xfr: Xfr,
        xfr: xfr,
        xharr: xharr,
        xhArr: xhArr,
        Xi: Xi,
        xi: xi,
        xlarr: xlarr,
        xlArr: xlArr,
        xmap: xmap,
        xnis: xnis,
        xodot: xodot,
        Xopf: Xopf,
        xopf: xopf,
        xoplus: xoplus,
        xotime: xotime,
        xrarr: xrarr,
        xrArr: xrArr,
        Xscr: Xscr,
        xscr: xscr,
        xsqcup: xsqcup,
        xuplus: xuplus,
        xutri: xutri,
        xvee: xvee,
        xwedge: xwedge,
        Yacute: Yacute,
        yacute: yacute,
        YAcy: YAcy,
        yacy: yacy,
        Ycirc: Ycirc,
        ycirc: ycirc,
        Ycy: Ycy,
        ycy: ycy,
        yen: yen,
        Yfr: Yfr,
        yfr: yfr,
        YIcy: YIcy,
        yicy: yicy,
        Yopf: Yopf,
        yopf: yopf,
        Yscr: Yscr,
        yscr: yscr,
        YUcy: YUcy,
        yucy: yucy,
        yuml: yuml,
        Yuml: Yuml,
        Zacute: Zacute,
        zacute: zacute,
        Zcaron: Zcaron,
        zcaron: zcaron,
        Zcy: Zcy,
        zcy: zcy,
        Zdot: Zdot,
        zdot: zdot,
        zeetrf: zeetrf,
        ZeroWidthSpace: ZeroWidthSpace,
        Zeta: Zeta,
        zeta: zeta,
        zfr: zfr,
        Zfr: Zfr,
        ZHcy: ZHcy,
        zhcy: zhcy,
        zigrarr: zigrarr,
        zopf: zopf,
        Zopf: Zopf,
        Zscr: Zscr,
        zscr: zscr,
        zwj: zwj,
        zwnj: zwnj,
        'default': entities
    });
    var Aacute$1 = "\xc1";
    var aacute$1 = "\xe1";
    var Acirc$1 = "\xc2";
    var acirc$1 = "\xe2";
    var acute$1 = "\xb4";
    var AElig$1 = "\xc6";
    var aelig$1 = "\xe6";
    var Agrave$1 = "\xc0";
    var agrave$1 = "\xe0";
    var amp$1 = "&";
    var AMP$1 = "&";
    var Aring$1 = "\xc5";
    var aring$1 = "\xe5";
    var Atilde$1 = "\xc3";
    var atilde$1 = "\xe3";
    var Auml$1 = "\xc4";
    var auml$1 = "\xe4";
    var brvbar$1 = "\xa6";
    var Ccedil$1 = "\xc7";
    var ccedil$1 = "\xe7";
    var cedil$1 = "\xb8";
    var cent$1 = "\xa2";
    var copy$1 = "\xa9";
    var COPY$1 = "\xa9";
    var curren$1 = "\xa4";
    var deg$1 = "\xb0";
    var divide$1 = "\xf7";
    var Eacute$1 = "\xc9";
    var eacute$1 = "\xe9";
    var Ecirc$1 = "\xca";
    var ecirc$1 = "\xea";
    var Egrave$1 = "\xc8";
    var egrave$1 = "\xe8";
    var ETH$1 = "\xd0";
    var eth$1 = "\xf0";
    var Euml$1 = "\xcb";
    var euml$1 = "\xeb";
    var frac12$1 = "\xbd";
    var frac14$1 = "\xbc";
    var frac34$1 = "\xbe";
    var gt$1 = ">";
    var GT$1 = ">";
    var Iacute$1 = "\xcd";
    var iacute$1 = "\xed";
    var Icirc$1 = "\xce";
    var icirc$1 = "\xee";
    var iexcl$1 = "\xa1";
    var Igrave$1 = "\xcc";
    var igrave$1 = "\xec";
    var iquest$1 = "\xbf";
    var Iuml$1 = "\xcf";
    var iuml$1 = "\xef";
    var laquo$1 = "\xab";
    var lt$1 = "<";
    var LT$1 = "<";
    var macr$1 = "\xaf";
    var micro$1 = "\xb5";
    var middot$1 = "\xb7";
    var nbsp$1 = "\xa0";
    var not$1 = "\xac";
    var Ntilde$1 = "\xd1";
    var ntilde$1 = "\xf1";
    var Oacute$1 = "\xd3";
    var oacute$1 = "\xf3";
    var Ocirc$1 = "\xd4";
    var ocirc$1 = "\xf4";
    var Ograve$1 = "\xd2";
    var ograve$1 = "\xf2";
    var ordf$1 = "\xaa";
    var ordm$1 = "\xba";
    var Oslash$1 = "\xd8";
    var oslash$1 = "\xf8";
    var Otilde$1 = "\xd5";
    var otilde$1 = "\xf5";
    var Ouml$1 = "\xd6";
    var ouml$1 = "\xf6";
    var para$1 = "\xb6";
    var plusmn$1 = "\xb1";
    var pound$1 = "\xa3";
    var quot$1 = "\"";
    var QUOT$1 = "\"";
    var raquo$1 = "\xbb";
    var reg$1 = "\xae";
    var REG$1 = "\xae";
    var sect$1 = "\xa7";
    var shy$1 = "\xad";
    var sup1$1 = "\xb9";
    var sup2$1 = "\xb2";
    var sup3$1 = "\xb3";
    var szlig$1 = "\xdf";
    var THORN$1 = "\xde";
    var thorn$1 = "\xfe";
    var times$1 = "\xd7";
    var Uacute$1 = "\xda";
    var uacute$1 = "\xfa";
    var Ucirc$1 = "\xdb";
    var ucirc$1 = "\xfb";
    var Ugrave$1 = "\xd9";
    var ugrave$1 = "\xf9";
    var uml$1 = "\xa8";
    var Uuml$1 = "\xdc";
    var uuml$1 = "\xfc";
    var Yacute$1 = "\xdd";
    var yacute$1 = "\xfd";
    var yen$1 = "\xa5";
    var yuml$1 = "\xff";
    var legacy = {
        Aacute: Aacute$1,
        aacute: aacute$1,
        Acirc: Acirc$1,
        acirc: acirc$1,
        acute: acute$1,
        AElig: AElig$1,
        aelig: aelig$1,
        Agrave: Agrave$1,
        agrave: agrave$1,
        amp: amp$1,
        AMP: AMP$1,
        Aring: Aring$1,
        aring: aring$1,
        Atilde: Atilde$1,
        atilde: atilde$1,
        Auml: Auml$1,
        auml: auml$1,
        brvbar: brvbar$1,
        Ccedil: Ccedil$1,
        ccedil: ccedil$1,
        cedil: cedil$1,
        cent: cent$1,
        copy: copy$1,
        COPY: COPY$1,
        curren: curren$1,
        deg: deg$1,
        divide: divide$1,
        Eacute: Eacute$1,
        eacute: eacute$1,
        Ecirc: Ecirc$1,
        ecirc: ecirc$1,
        Egrave: Egrave$1,
        egrave: egrave$1,
        ETH: ETH$1,
        eth: eth$1,
        Euml: Euml$1,
        euml: euml$1,
        frac12: frac12$1,
        frac14: frac14$1,
        frac34: frac34$1,
        gt: gt$1,
        GT: GT$1,
        Iacute: Iacute$1,
        iacute: iacute$1,
        Icirc: Icirc$1,
        icirc: icirc$1,
        iexcl: iexcl$1,
        Igrave: Igrave$1,
        igrave: igrave$1,
        iquest: iquest$1,
        Iuml: Iuml$1,
        iuml: iuml$1,
        laquo: laquo$1,
        lt: lt$1,
        LT: LT$1,
        macr: macr$1,
        micro: micro$1,
        middot: middot$1,
        nbsp: nbsp$1,
        not: not$1,
        Ntilde: Ntilde$1,
        ntilde: ntilde$1,
        Oacute: Oacute$1,
        oacute: oacute$1,
        Ocirc: Ocirc$1,
        ocirc: ocirc$1,
        Ograve: Ograve$1,
        ograve: ograve$1,
        ordf: ordf$1,
        ordm: ordm$1,
        Oslash: Oslash$1,
        oslash: oslash$1,
        Otilde: Otilde$1,
        otilde: otilde$1,
        Ouml: Ouml$1,
        ouml: ouml$1,
        para: para$1,
        plusmn: plusmn$1,
        pound: pound$1,
        quot: quot$1,
        QUOT: QUOT$1,
        raquo: raquo$1,
        reg: reg$1,
        REG: REG$1,
        sect: sect$1,
        shy: shy$1,
        sup1: sup1$1,
        sup2: sup2$1,
        sup3: sup3$1,
        szlig: szlig$1,
        THORN: THORN$1,
        thorn: thorn$1,
        times: times$1,
        Uacute: Uacute$1,
        uacute: uacute$1,
        Ucirc: Ucirc$1,
        ucirc: ucirc$1,
        Ugrave: Ugrave$1,
        ugrave: ugrave$1,
        uml: uml$1,
        Uuml: Uuml$1,
        uuml: uuml$1,
        Yacute: Yacute$1,
        yacute: yacute$1,
        yen: yen$1,
        yuml: yuml$1
    };
    var legacy$1 = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        Aacute: Aacute$1,
        aacute: aacute$1,
        Acirc: Acirc$1,
        acirc: acirc$1,
        acute: acute$1,
        AElig: AElig$1,
        aelig: aelig$1,
        Agrave: Agrave$1,
        agrave: agrave$1,
        amp: amp$1,
        AMP: AMP$1,
        Aring: Aring$1,
        aring: aring$1,
        Atilde: Atilde$1,
        atilde: atilde$1,
        Auml: Auml$1,
        auml: auml$1,
        brvbar: brvbar$1,
        Ccedil: Ccedil$1,
        ccedil: ccedil$1,
        cedil: cedil$1,
        cent: cent$1,
        copy: copy$1,
        COPY: COPY$1,
        curren: curren$1,
        deg: deg$1,
        divide: divide$1,
        Eacute: Eacute$1,
        eacute: eacute$1,
        Ecirc: Ecirc$1,
        ecirc: ecirc$1,
        Egrave: Egrave$1,
        egrave: egrave$1,
        ETH: ETH$1,
        eth: eth$1,
        Euml: Euml$1,
        euml: euml$1,
        frac12: frac12$1,
        frac14: frac14$1,
        frac34: frac34$1,
        gt: gt$1,
        GT: GT$1,
        Iacute: Iacute$1,
        iacute: iacute$1,
        Icirc: Icirc$1,
        icirc: icirc$1,
        iexcl: iexcl$1,
        Igrave: Igrave$1,
        igrave: igrave$1,
        iquest: iquest$1,
        Iuml: Iuml$1,
        iuml: iuml$1,
        laquo: laquo$1,
        lt: lt$1,
        LT: LT$1,
        macr: macr$1,
        micro: micro$1,
        middot: middot$1,
        nbsp: nbsp$1,
        not: not$1,
        Ntilde: Ntilde$1,
        ntilde: ntilde$1,
        Oacute: Oacute$1,
        oacute: oacute$1,
        Ocirc: Ocirc$1,
        ocirc: ocirc$1,
        Ograve: Ograve$1,
        ograve: ograve$1,
        ordf: ordf$1,
        ordm: ordm$1,
        Oslash: Oslash$1,
        oslash: oslash$1,
        Otilde: Otilde$1,
        otilde: otilde$1,
        Ouml: Ouml$1,
        ouml: ouml$1,
        para: para$1,
        plusmn: plusmn$1,
        pound: pound$1,
        quot: quot$1,
        QUOT: QUOT$1,
        raquo: raquo$1,
        reg: reg$1,
        REG: REG$1,
        sect: sect$1,
        shy: shy$1,
        sup1: sup1$1,
        sup2: sup2$1,
        sup3: sup3$1,
        szlig: szlig$1,
        THORN: THORN$1,
        thorn: thorn$1,
        times: times$1,
        Uacute: Uacute$1,
        uacute: uacute$1,
        Ucirc: Ucirc$1,
        ucirc: ucirc$1,
        Ugrave: Ugrave$1,
        ugrave: ugrave$1,
        uml: uml$1,
        Uuml: Uuml$1,
        uuml: uuml$1,
        Yacute: Yacute$1,
        yacute: yacute$1,
        yen: yen$1,
        yuml: yuml$1,
        'default': legacy
    });
    var amp$2 = "&";
    var apos$1 = "'";
    var gt$2 = ">";
    var lt$2 = "<";
    var quot$2 = "\"";
    var xml = {
        amp: amp$2,
        apos: apos$1,
        gt: gt$2,
        lt: lt$2,
        quot: quot$2
    };
    var xml$1 = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        amp: amp$2,
        apos: apos$1,
        gt: gt$2,
        lt: lt$2,
        quot: quot$2,
        'default': xml
    });
    var decode = {
        "0": 65533,
        "128": 8364,
        "130": 8218,
        "131": 402,
        "132": 8222,
        "133": 8230,
        "134": 8224,
        "135": 8225,
        "136": 710,
        "137": 8240,
        "138": 352,
        "139": 8249,
        "140": 338,
        "142": 381,
        "145": 8216,
        "146": 8217,
        "147": 8220,
        "148": 8221,
        "149": 8226,
        "150": 8211,
        "151": 8212,
        "152": 732,
        "153": 8482,
        "154": 353,
        "155": 8250,
        "156": 339,
        "158": 382,
        "159": 376
    };
    var decode$1 = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        'default': decode
    });
    var require$$0 = getCjsExportFromNamespace(decode$1);
    var decode_codepoint = createCommonjsModule(function(module, exports1) {
        var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function(mod) {
            return mod && mod.__esModule ? mod : {
                "default": mod
            };
        };
        Object.defineProperty(exports1, "__esModule", {
            value: true
        });
        var decode_json_1 = __importDefault(require$$0);
        // modified version of https://github.com/mathiasbynens/he/blob/master/src/he.js#L94-L119
        function decodeCodePoint(codePoint) {
            if (codePoint >= 0xd800 && codePoint <= 0xdfff || codePoint > 0x10ffff) return "\uFFFD";
            if (codePoint in decode_json_1.default) // @ts-ignore
            codePoint = decode_json_1.default[codePoint];
            var output = "";
            if (codePoint > 0xffff) {
                codePoint -= 0x10000;
                output += String.fromCharCode(codePoint >>> 10 & 0x3ff | 0xd800);
                codePoint = 0xdc00 | codePoint & 0x3ff;
            }
            output += String.fromCharCode(codePoint);
            return output;
        }
        exports1.default = decodeCodePoint;
    });
    unwrapExports(decode_codepoint);
    var require$$1 = getCjsExportFromNamespace(entities$1);
    var require$$1$1 = getCjsExportFromNamespace(legacy$1);
    var require$$0$1 = getCjsExportFromNamespace(xml$1);
    var decode$2 = createCommonjsModule(function(module, exports1) {
        var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function(mod) {
            return mod && mod.__esModule ? mod : {
                "default": mod
            };
        };
        Object.defineProperty(exports1, "__esModule", {
            value: true
        });
        var entities_json_1 = __importDefault(require$$1);
        var legacy_json_1 = __importDefault(require$$1$1);
        var xml_json_1 = __importDefault(require$$0$1);
        var decode_codepoint_1 = __importDefault(decode_codepoint);
        exports1.decodeXML = getStrictDecoder(xml_json_1.default);
        exports1.decodeHTMLStrict = getStrictDecoder(entities_json_1.default);
        function getStrictDecoder(map) {
            var keys = Object.keys(map).join("|");
            var replace = getReplacer(map);
            keys += "|#[xX][\\da-fA-F]+|#\\d+";
            var re = new RegExp("&(?:" + keys + ");", "g");
            return function(str) {
                return String(str).replace(re, replace);
            };
        }
        var sorter = function(a, b) {
            return a < b ? 1 : -1;
        };
        exports1.decodeHTML = function() {
            var legacy = Object.keys(legacy_json_1.default).sort(sorter);
            var keys = Object.keys(entities_json_1.default).sort(sorter);
            for(var i = 0, j = 0; i < keys.length; i++)if (legacy[j] === keys[i]) {
                keys[i] += ";?";
                j++;
            } else keys[i] += ";";
            var re = new RegExp("&(?:" + keys.join("|") + "|#[xX][\\da-fA-F]+;?|#\\d+;?)", "g");
            var replace = getReplacer(entities_json_1.default);
            function replacer(str) {
                if (str.substr(-1) !== ";") str += ";";
                return replace(str);
            }
            //TODO consider creating a merged map
            return function(str) {
                return String(str).replace(re, replacer);
            };
        }();
        function getReplacer(map) {
            return function replace(str) {
                if (str.charAt(1) === "#") {
                    if (str.charAt(2) === "X" || str.charAt(2) === "x") return decode_codepoint_1.default(parseInt(str.substr(3), 16));
                    return decode_codepoint_1.default(parseInt(str.substr(2), 10));
                }
                return map[str.slice(1, -1)];
            };
        }
    });
    unwrapExports(decode$2);
    var decode_1 = decode$2.decodeXML;
    var decode_2 = decode$2.decodeHTMLStrict;
    var decode_3 = decode$2.decodeHTML;
    var encode$1 = createCommonjsModule(function(module, exports1) {
        var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function(mod) {
            return mod && mod.__esModule ? mod : {
                "default": mod
            };
        };
        Object.defineProperty(exports1, "__esModule", {
            value: true
        });
        var xml_json_1 = __importDefault(require$$0$1);
        var inverseXML = getInverseObj(xml_json_1.default);
        var xmlReplacer = getInverseReplacer(inverseXML);
        exports1.encodeXML = getInverse(inverseXML, xmlReplacer);
        var entities_json_1 = __importDefault(require$$1);
        var inverseHTML = getInverseObj(entities_json_1.default);
        var htmlReplacer = getInverseReplacer(inverseHTML);
        exports1.encodeHTML = getInverse(inverseHTML, htmlReplacer);
        function getInverseObj(obj) {
            return Object.keys(obj).sort().reduce(function(inverse, name) {
                inverse[obj[name]] = "&" + name + ";";
                return inverse;
            }, {});
        }
        function getInverseReplacer(inverse) {
            var single = [];
            var multiple = [];
            Object.keys(inverse).forEach(function(k) {
                return k.length === 1 ? single.push("\\" + k) : multiple.push(k);
            });
            //TODO add ranges
            multiple.unshift("[" + single.join("") + "]");
            return new RegExp(multiple.join("|"), "g");
        }
        var reNonASCII = /[^\0-\x7F]/g;
        var reAstralSymbols = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
        function singleCharReplacer(c) {
            return "&#x" + c.charCodeAt(0).toString(16).toUpperCase() + ";";
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
        function astralReplacer(c, _) {
            // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
            var high = c.charCodeAt(0);
            var low = c.charCodeAt(1);
            var codePoint = (high - 0xd800) * 0x400 + low - 0xdc00 + 0x10000;
            return "&#x" + codePoint.toString(16).toUpperCase() + ";";
        }
        function getInverse(inverse, re) {
            return function(data) {
                return data.replace(re, function(name) {
                    return inverse[name];
                }).replace(reAstralSymbols, astralReplacer).replace(reNonASCII, singleCharReplacer);
            };
        }
        var reXmlChars = getInverseReplacer(inverseXML);
        function escape(data) {
            return data.replace(reXmlChars, singleCharReplacer).replace(reAstralSymbols, astralReplacer).replace(reNonASCII, singleCharReplacer);
        }
        exports1.escape = escape;
    });
    unwrapExports(encode$1);
    var encode_1$1 = encode$1.encodeXML;
    var encode_2 = encode$1.encodeHTML;
    var encode_3 = encode$1.escape;
    var lib = createCommonjsModule(function(module, exports1) {
        Object.defineProperty(exports1, "__esModule", {
            value: true
        });
        function decode(data, level) {
            return (!level || level <= 0 ? decode$2.decodeXML : decode$2.decodeHTML)(data);
        }
        exports1.decode = decode;
        function decodeStrict(data, level) {
            return (!level || level <= 0 ? decode$2.decodeXML : decode$2.decodeHTMLStrict)(data);
        }
        exports1.decodeStrict = decodeStrict;
        function encode(data, level) {
            return (!level || level <= 0 ? encode$1.encodeXML : encode$1.encodeHTML)(data);
        }
        exports1.encode = encode;
        var encode_2 = encode$1;
        exports1.encodeXML = encode_2.encodeXML;
        exports1.encodeHTML = encode_2.encodeHTML;
        exports1.escape = encode_2.escape;
        // Legacy aliases
        exports1.encodeHTML4 = encode_2.encodeHTML;
        exports1.encodeHTML5 = encode_2.encodeHTML;
        var decode_2 = decode$2;
        exports1.decodeXML = decode_2.decodeXML;
        exports1.decodeHTML = decode_2.decodeHTML;
        exports1.decodeHTMLStrict = decode_2.decodeHTMLStrict;
        // Legacy aliases
        exports1.decodeHTML4 = decode_2.decodeHTML;
        exports1.decodeHTML5 = decode_2.decodeHTML;
        exports1.decodeHTML4Strict = decode_2.decodeHTMLStrict;
        exports1.decodeHTML5Strict = decode_2.decodeHTMLStrict;
        exports1.decodeXMLStrict = decode_2.decodeXML;
    });
    unwrapExports(lib);
    var lib_1 = lib.decode;
    var lib_2 = lib.decodeStrict;
    var lib_3 = lib.encode;
    var lib_4 = lib.encodeXML;
    var lib_5 = lib.encodeHTML;
    var lib_6 = lib.escape;
    var lib_7 = lib.encodeHTML4;
    var lib_8 = lib.encodeHTML5;
    var lib_9 = lib.decodeXML;
    var lib_10 = lib.decodeHTML;
    var lib_11 = lib.decodeHTMLStrict;
    var lib_12 = lib.decodeHTML4;
    var lib_13 = lib.decodeHTML5;
    var lib_14 = lib.decodeHTML4Strict;
    var lib_15 = lib.decodeHTML5Strict;
    var lib_16 = lib.decodeXMLStrict;
    var C_BACKSLASH = 92;
    var ENTITY = "&(?:#x[a-f0-9]{1,6}|#[0-9]{1,7}|[a-z][a-z0-9]{1,31});";
    var TAGNAME = "[A-Za-z][A-Za-z0-9-]*";
    var ATTRIBUTENAME = "[a-zA-Z_:][a-zA-Z0-9:._-]*";
    var UNQUOTEDVALUE = "[^\"'=<>`\\x00-\\x20]+";
    var SINGLEQUOTEDVALUE = "'[^']*'";
    var DOUBLEQUOTEDVALUE = '"[^"]*"';
    var ATTRIBUTEVALUE = "(?:" + UNQUOTEDVALUE + "|" + SINGLEQUOTEDVALUE + "|" + DOUBLEQUOTEDVALUE + ")";
    var ATTRIBUTEVALUESPEC = "(?:\\s*=\\s*" + ATTRIBUTEVALUE + ")";
    var ATTRIBUTE = "(?:\\s+" + ATTRIBUTENAME + ATTRIBUTEVALUESPEC + "?)";
    var OPENTAG = "<" + TAGNAME + ATTRIBUTE + "*" + "\\s*/?>";
    var CLOSETAG = "</" + TAGNAME + "\\s*[>]";
    var HTMLCOMMENT = "<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->";
    var PROCESSINGINSTRUCTION = "[<][?][\\s\\S]*?[?][>]";
    var DECLARATION = "<![A-Z]+\\s+[^>]*>";
    var CDATA = "<!\\[CDATA\\[[\\s\\S]*?\\]\\]>";
    var HTMLTAG = "(?:" + OPENTAG + "|" + CLOSETAG + "|" + HTMLCOMMENT + "|" + PROCESSINGINSTRUCTION + "|" + DECLARATION + "|" + CDATA + ")";
    var reHtmlTag = new RegExp("^" + HTMLTAG);
    var reBackslashOrAmp = /[\\&]/;
    var ESCAPABLE = "[!\"#$%&'()*+,./:;<=>?@[\\\\\\]^_`{|}~-]";
    var reEntityOrEscapedChar = new RegExp("\\\\" + ESCAPABLE + "|" + ENTITY, "gi");
    var XMLSPECIAL = '[&<>"]';
    var reXmlSpecial = new RegExp(XMLSPECIAL, "g");
    var unescapeChar = function(s) {
        if (s.charCodeAt(0) === C_BACKSLASH) return s.charAt(1);
        else return lib_10(s);
    };
    // Replace entities and backslash escapes with literal characters.
    var unescapeString = function(s) {
        if (reBackslashOrAmp.test(s)) return s.replace(reEntityOrEscapedChar, unescapeChar);
        else return s;
    };
    var normalizeURI = function(uri) {
        try {
            return encode_1(uri);
        } catch (err) {
            return uri;
        }
    };
    var replaceUnsafeChar = function(s) {
        switch(s){
            case "&":
                return "&amp;";
            case "<":
                return "&lt;";
            case ">":
                return "&gt;";
            case '"':
                return "&quot;";
            default:
                return s;
        }
    };
    var escapeXml = function(s) {
        if (reXmlSpecial.test(s)) return s.replace(reXmlSpecial, replaceUnsafeChar);
        else return s;
    };
    // derived from https://github.com/mathiasbynens/String.fromCodePoint
    /*! http://mths.be/fromcodepoint v0.2.1 by @mathias */ var _fromCodePoint;
    function fromCodePoint(_) {
        return _fromCodePoint(_);
    }
    if (String.fromCodePoint) _fromCodePoint = function(_) {
        try {
            return String.fromCodePoint(_);
        } catch (e) {
            if (e instanceof RangeError) return String.fromCharCode(0xfffd);
            throw e;
        }
    };
    else {
        var stringFromCharCode = String.fromCharCode;
        var floor = Math.floor;
        _fromCodePoint = function() {
            var MAX_SIZE = 0x4000;
            var codeUnits = [];
            var highSurrogate;
            var lowSurrogate;
            var index = -1;
            var length = arguments.length;
            if (!length) return "";
            var result = "";
            while(++index < length){
                var codePoint = Number(arguments[index]);
                if (!isFinite(codePoint) || // `NaN`, `+Infinity`, or `-Infinity`
                codePoint < 0 || // not a valid Unicode code point
                codePoint > 0x10ffff || // not a valid Unicode code point
                floor(codePoint) !== codePoint // not an integer
                ) return String.fromCharCode(0xfffd);
                if (codePoint <= 0xffff) // BMP code point
                codeUnits.push(codePoint);
                else {
                    // Astral code point; split in surrogate halves
                    // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
                    codePoint -= 0x10000;
                    highSurrogate = (codePoint >> 10) + 0xd800;
                    lowSurrogate = codePoint % 0x400 + 0xdc00;
                    codeUnits.push(highSurrogate, lowSurrogate);
                }
                if (index + 1 === length || codeUnits.length > MAX_SIZE) {
                    result += stringFromCharCode.apply(null, codeUnits);
                    codeUnits.length = 0;
                }
            }
            return result;
        };
    }
    /*! http://mths.be/repeat v0.2.0 by @mathias */ if (!String.prototype.repeat) (function() {
        var defineProperty = function() {
            // IE 8 only supports `Object.defineProperty` on DOM elements
            try {
                var object = {};
                var $defineProperty = Object.defineProperty;
                var result = $defineProperty(object, object, object) && $defineProperty;
            } catch (error) {}
            return result;
        }();
        var repeat = function(count) {
            if (this == null) throw TypeError();
            var string = String(this);
            // `ToInteger`
            var n = count ? Number(count) : 0;
            if (n != n) n = 0;
            // Account for out-of-bounds indices
            if (n < 0 || n == Infinity) throw RangeError();
            var result = '';
            while(n){
                if (n % 2 == 1) result += string;
                if (n > 1) string += string;
                n >>= 1;
            }
            return result;
        };
        if (defineProperty) defineProperty(String.prototype, 'repeat', {
            'value': repeat,
            'configurable': true,
            'writable': true
        });
        else String.prototype.repeat = repeat;
    })();
    var normalizeURI$1 = normalizeURI;
    var unescapeString$1 = unescapeString;
    // Constants for character codes:
    var C_NEWLINE = 10;
    var C_ASTERISK = 42;
    var C_UNDERSCORE = 95;
    var C_BACKTICK = 96;
    var C_OPEN_BRACKET = 91;
    var C_CLOSE_BRACKET = 93;
    var C_LESSTHAN = 60;
    var C_BANG = 33;
    var C_BACKSLASH$1 = 92;
    var C_AMPERSAND = 38;
    var C_OPEN_PAREN = 40;
    var C_CLOSE_PAREN = 41;
    var C_COLON = 58;
    var C_SINGLEQUOTE = 39;
    var C_DOUBLEQUOTE = 34;
    // Some regexps used in inline parser:
    var ESCAPABLE$1 = ESCAPABLE;
    var ESCAPED_CHAR = "\\\\" + ESCAPABLE$1;
    var ENTITY$1 = ENTITY;
    var reHtmlTag$1 = reHtmlTag;
    var rePunctuation = new RegExp(/[!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E42\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC9\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDF3C-\uDF3E]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]/);
    var reLinkTitle = new RegExp('^(?:"(' + ESCAPED_CHAR + '|[^"\\x00])*"' + "|" + "'(" + ESCAPED_CHAR + "|[^'\\x00])*'" + "|" + "\\((" + ESCAPED_CHAR + "|[^()\\x00])*\\))");
    var reLinkDestinationBraces = /^(?:<(?:[^<>\n\\\x00]|\\.)*>)/;
    var reEscapable = new RegExp("^" + ESCAPABLE$1);
    var reEntityHere = new RegExp("^" + ENTITY$1, "i");
    var reTicks = /`+/;
    var reTicksHere = /^`+/;
    var reEllipses = /\.\.\./g;
    var reDash = /--+/g;
    var reEmailAutolink = /^<([a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)>/;
    var reAutolink = /^<[A-Za-z][A-Za-z0-9.+-]{1,31}:[^<>\x00-\x20]*>/i;
    var reSpnl = /^ *(?:\n *)?/;
    var reWhitespaceChar = /^[ \t\n\x0b\x0c\x0d]/;
    var reUnicodeWhitespaceChar = /^\s/;
    var reFinalSpace = / *$/;
    var reInitialSpace = /^ */;
    var reSpaceAtEndOfLine = /^ *(?:\n|$)/;
    var reLinkLabel = /^\[(?:[^\\\[\]]|\\.){0,1000}\]/;
    // Matches a string of non-special characters.
    var reMain = /^[^\n`\[\]\\!<&*_'"]+/m;
    var text = function(s) {
        var node = new Node("text");
        node._literal = s;
        return node;
    };
    // normalize a reference in reference link (remove []s, trim,
    // collapse internal space, unicode case fold.
    // See commonmark/commonmark.js#168.
    var normalizeReference = function(string) {
        return string.slice(1, string.length - 1).trim().replace(/[ \t\r\n]+/, " ").toLowerCase().toUpperCase();
    };
    // INLINE PARSER
    // These are methods of an InlineParser object, defined below.
    // An InlineParser keeps track of a subject (a string to be
    // parsed) and a position in that subject.
    // If re matches at current position in the subject, advance
    // position in subject and return the match; otherwise return null.
    var match = function(re) {
        var m = re.exec(this.subject.slice(this.pos));
        if (m === null) return null;
        else {
            this.pos += m.index + m[0].length;
            return m[0];
        }
    };
    // Returns the code for the character at the current subject position, or -1
    // there are no more characters.
    var peek = function() {
        if (this.pos < this.subject.length) return this.subject.charCodeAt(this.pos);
        else return -1;
    };
    // Parse zero or more space characters, including at most one newline
    var spnl = function() {
        this.match(reSpnl);
        return true;
    };
    // All of the parsers below try to match something at the current position
    // in the subject.  If they succeed in matching anything, they
    // return the inline matched, advancing the subject.
    // Attempt to parse backticks, adding either a backtick code span or a
    // literal sequence of backticks.
    var parseBackticks = function(block) {
        var ticks = this.match(reTicksHere);
        if (ticks === null) return false;
        var afterOpenTicks = this.pos;
        var matched;
        var node;
        var contents;
        while((matched = this.match(reTicks)) !== null)if (matched === ticks) {
            node = new Node("code");
            contents = this.subject.slice(afterOpenTicks, this.pos - ticks.length).replace(/\n/gm, " ");
            if (contents.length > 0 && contents.match(/[^ ]/) !== null && contents[0] == " " && contents[contents.length - 1] == " ") node._literal = contents.slice(1, contents.length - 1);
            else node._literal = contents;
            block.appendChild(node);
            return true;
        }
        // If we got here, we didn't match a closing backtick sequence.
        this.pos = afterOpenTicks;
        block.appendChild(text(ticks));
        return true;
    };
    // Parse a backslash-escaped special character, adding either the escaped
    // character, a hard line break (if the backslash is followed by a newline),
    // or a literal backslash to the block's children.  Assumes current character
    // is a backslash.
    var parseBackslash = function(block) {
        var subj = this.subject;
        var node;
        this.pos += 1;
        if (this.peek() === C_NEWLINE) {
            this.pos += 1;
            node = new Node("linebreak");
            block.appendChild(node);
        } else if (reEscapable.test(subj.charAt(this.pos))) {
            block.appendChild(text(subj.charAt(this.pos)));
            this.pos += 1;
        } else block.appendChild(text("\\"));
        return true;
    };
    // Attempt to parse an autolink (URL or email in pointy brackets).
    var parseAutolink = function(block) {
        var m;
        var dest;
        var node;
        if (m = this.match(reEmailAutolink)) {
            dest = m.slice(1, m.length - 1);
            node = new Node("link");
            node._destination = normalizeURI$1("mailto:" + dest);
            node._title = "";
            node.appendChild(text(dest));
            block.appendChild(node);
            return true;
        } else if (m = this.match(reAutolink)) {
            dest = m.slice(1, m.length - 1);
            node = new Node("link");
            node._destination = normalizeURI$1(dest);
            node._title = "";
            node.appendChild(text(dest));
            block.appendChild(node);
            return true;
        } else return false;
    };
    // Attempt to parse a raw HTML tag.
    var parseHtmlTag = function(block) {
        var m = this.match(reHtmlTag$1);
        if (m === null) return false;
        else {
            var node = new Node("html_inline");
            node._literal = m;
            block.appendChild(node);
            return true;
        }
    };
    // Scan a sequence of characters with code cc, and return information about
    // the number of delimiters and whether they are positioned such that
    // they can open and/or close emphasis or strong emphasis.  A utility
    // function for strong/emph parsing.
    var scanDelims = function(cc) {
        var numdelims = 0;
        var char_before, char_after, cc_after;
        var startpos = this.pos;
        var left_flanking, right_flanking, can_open, can_close;
        var after_is_whitespace, after_is_punctuation, before_is_whitespace, before_is_punctuation;
        if (cc === C_SINGLEQUOTE || cc === C_DOUBLEQUOTE) {
            numdelims++;
            this.pos++;
        } else while(this.peek() === cc){
            numdelims++;
            this.pos++;
        }
        if (numdelims === 0) return null;
        char_before = startpos === 0 ? "\n" : this.subject.charAt(startpos - 1);
        cc_after = this.peek();
        if (cc_after === -1) char_after = "\n";
        else char_after = fromCodePoint(cc_after);
        after_is_whitespace = reUnicodeWhitespaceChar.test(char_after);
        after_is_punctuation = rePunctuation.test(char_after);
        before_is_whitespace = reUnicodeWhitespaceChar.test(char_before);
        before_is_punctuation = rePunctuation.test(char_before);
        left_flanking = !after_is_whitespace && (!after_is_punctuation || before_is_whitespace || before_is_punctuation);
        right_flanking = !before_is_whitespace && (!before_is_punctuation || after_is_whitespace || after_is_punctuation);
        if (cc === C_UNDERSCORE) {
            can_open = left_flanking && (!right_flanking || before_is_punctuation);
            can_close = right_flanking && (!left_flanking || after_is_punctuation);
        } else if (cc === C_SINGLEQUOTE || cc === C_DOUBLEQUOTE) {
            can_open = left_flanking && !right_flanking;
            can_close = right_flanking;
        } else {
            can_open = left_flanking;
            can_close = right_flanking;
        }
        this.pos = startpos;
        return {
            numdelims: numdelims,
            can_open: can_open,
            can_close: can_close
        };
    };
    // Handle a delimiter marker for emphasis or a quote.
    var handleDelim = function(cc, block) {
        var res = this.scanDelims(cc);
        if (!res) return false;
        var numdelims = res.numdelims;
        var startpos = this.pos;
        var contents;
        this.pos += numdelims;
        if (cc === C_SINGLEQUOTE) contents = "\u2019";
        else if (cc === C_DOUBLEQUOTE) contents = "\u201C";
        else contents = this.subject.slice(startpos, this.pos);
        var node = text(contents);
        block.appendChild(node);
        // Add entry to stack for this opener
        if ((res.can_open || res.can_close) && (this.options.smart || cc !== C_SINGLEQUOTE && cc !== C_DOUBLEQUOTE)) {
            this.delimiters = {
                cc: cc,
                numdelims: numdelims,
                origdelims: numdelims,
                node: node,
                previous: this.delimiters,
                next: null,
                can_open: res.can_open,
                can_close: res.can_close
            };
            if (this.delimiters.previous !== null) this.delimiters.previous.next = this.delimiters;
        }
        return true;
    };
    var removeDelimiter = function(delim) {
        if (delim.previous !== null) delim.previous.next = delim.next;
        if (delim.next === null) // top of stack
        this.delimiters = delim.previous;
        else delim.next.previous = delim.previous;
    };
    var removeDelimitersBetween = function(bottom, top) {
        if (bottom.next !== top) {
            bottom.next = top;
            top.previous = bottom;
        }
    };
    var processEmphasis = function(stack_bottom) {
        var opener, closer, old_closer;
        var opener_inl, closer_inl;
        var tempstack;
        var use_delims;
        var tmp, next;
        var opener_found;
        var openers_bottom = [
            [],
            [],
            []
        ];
        var odd_match = false;
        for(var i = 0; i < 3; i++){
            openers_bottom[i][C_UNDERSCORE] = stack_bottom;
            openers_bottom[i][C_ASTERISK] = stack_bottom;
            openers_bottom[i][C_SINGLEQUOTE] = stack_bottom;
            openers_bottom[i][C_DOUBLEQUOTE] = stack_bottom;
        }
        // find first closer above stack_bottom:
        closer = this.delimiters;
        while(closer !== null && closer.previous !== stack_bottom)closer = closer.previous;
        // move forward, looking for closers, and handling each
        while(closer !== null){
            var closercc = closer.cc;
            if (!closer.can_close) closer = closer.next;
            else {
                // found emphasis closer. now look back for first matching opener:
                opener = closer.previous;
                opener_found = false;
                while(opener !== null && opener !== stack_bottom && opener !== openers_bottom[closer.origdelims % 3][closercc]){
                    odd_match = (closer.can_open || opener.can_close) && closer.origdelims % 3 !== 0 && (opener.origdelims + closer.origdelims) % 3 === 0;
                    if (opener.cc === closer.cc && opener.can_open && !odd_match) {
                        opener_found = true;
                        break;
                    }
                    opener = opener.previous;
                }
                old_closer = closer;
                if (closercc === C_ASTERISK || closercc === C_UNDERSCORE) {
                    if (!opener_found) closer = closer.next;
                    else {
                        // calculate actual number of delimiters used from closer
                        use_delims = closer.numdelims >= 2 && opener.numdelims >= 2 ? 2 : 1;
                        opener_inl = opener.node;
                        closer_inl = closer.node;
                        // remove used delimiters from stack elts and inlines
                        opener.numdelims -= use_delims;
                        closer.numdelims -= use_delims;
                        opener_inl._literal = opener_inl._literal.slice(0, opener_inl._literal.length - use_delims);
                        closer_inl._literal = closer_inl._literal.slice(0, closer_inl._literal.length - use_delims);
                        // build contents for new emph element
                        var emph = new Node(use_delims === 1 ? "emph" : "strong");
                        tmp = opener_inl._next;
                        while(tmp && tmp !== closer_inl){
                            next = tmp._next;
                            tmp.unlink();
                            emph.appendChild(tmp);
                            tmp = next;
                        }
                        opener_inl.insertAfter(emph);
                        // remove elts between opener and closer in delimiters stack
                        removeDelimitersBetween(opener, closer);
                        // if opener has 0 delims, remove it and the inline
                        if (opener.numdelims === 0) {
                            opener_inl.unlink();
                            this.removeDelimiter(opener);
                        }
                        if (closer.numdelims === 0) {
                            closer_inl.unlink();
                            tempstack = closer.next;
                            this.removeDelimiter(closer);
                            closer = tempstack;
                        }
                    }
                } else if (closercc === C_SINGLEQUOTE) {
                    closer.node._literal = "\u2019";
                    if (opener_found) opener.node._literal = "\u2018";
                    closer = closer.next;
                } else if (closercc === C_DOUBLEQUOTE) {
                    closer.node._literal = "\u201D";
                    if (opener_found) opener.node.literal = "\u201C";
                    closer = closer.next;
                }
                if (!opener_found) {
                    // Set lower bound for future searches for openers:
                    openers_bottom[old_closer.origdelims % 3][closercc] = old_closer.previous;
                    if (!old_closer.can_open) // We can remove a closer that can't be an opener,
                    // once we've seen there's no matching opener:
                    this.removeDelimiter(old_closer);
                }
            }
        }
        // remove all delimiters
        while(this.delimiters !== null && this.delimiters !== stack_bottom)this.removeDelimiter(this.delimiters);
    };
    // Attempt to parse link title (sans quotes), returning the string
    // or null if no match.
    var parseLinkTitle = function() {
        var title = this.match(reLinkTitle);
        if (title === null) return null;
        else // chop off quotes from title and unescape:
        return unescapeString$1(title.substr(1, title.length - 2));
    };
    // Attempt to parse link destination, returning the string or
    // null if no match.
    var parseLinkDestination = function() {
        var res = this.match(reLinkDestinationBraces);
        if (res === null) {
            if (this.peek() === C_LESSTHAN) return null;
            // TODO handrolled parser; res should be null or the string
            var savepos = this.pos;
            var openparens = 0;
            var c;
            while((c = this.peek()) !== -1){
                if (c === C_BACKSLASH$1 && reEscapable.test(this.subject.charAt(this.pos + 1))) {
                    this.pos += 1;
                    if (this.peek() !== -1) this.pos += 1;
                } else if (c === C_OPEN_PAREN) {
                    this.pos += 1;
                    openparens += 1;
                } else if (c === C_CLOSE_PAREN) {
                    if (openparens < 1) break;
                    else {
                        this.pos += 1;
                        openparens -= 1;
                    }
                } else if (reWhitespaceChar.exec(fromCodePoint(c)) !== null) break;
                else this.pos += 1;
            }
            if (this.pos === savepos && c !== C_CLOSE_PAREN) return null;
            if (openparens !== 0) return null;
            res = this.subject.substr(savepos, this.pos - savepos);
            return normalizeURI$1(unescapeString$1(res));
        } else // chop off surrounding <..>:
        return normalizeURI$1(unescapeString$1(res.substr(1, res.length - 2)));
    };
    // Attempt to parse a link label, returning number of characters parsed.
    var parseLinkLabel = function() {
        var m = this.match(reLinkLabel);
        if (m === null || m.length > 1001) return 0;
        else return m.length;
    };
    // Add open bracket to delimiter stack and add a text node to block's children.
    var parseOpenBracket = function(block) {
        var startpos = this.pos;
        this.pos += 1;
        var node = text("[");
        block.appendChild(node);
        // Add entry to stack for this opener
        this.addBracket(node, startpos, false);
        return true;
    };
    // IF next character is [, and ! delimiter to delimiter stack and
    // add a text node to block's children.  Otherwise just add a text node.
    var parseBang = function(block) {
        var startpos = this.pos;
        this.pos += 1;
        if (this.peek() === C_OPEN_BRACKET) {
            this.pos += 1;
            var node = text("![");
            block.appendChild(node);
            // Add entry to stack for this opener
            this.addBracket(node, startpos + 1, true);
        } else block.appendChild(text("!"));
        return true;
    };
    // Try to match close bracket against an opening in the delimiter
    // stack.  Add either a link or image, or a plain [ character,
    // to block's children.  If there is a matching delimiter,
    // remove it from the delimiter stack.
    var parseCloseBracket = function(block) {
        var startpos;
        var is_image;
        var dest;
        var title;
        var matched = false;
        var reflabel;
        var opener;
        this.pos += 1;
        startpos = this.pos;
        // get last [ or ![
        opener = this.brackets;
        if (opener === null) {
            // no matched opener, just return a literal
            block.appendChild(text("]"));
            return true;
        }
        if (!opener.active) {
            // no matched opener, just return a literal
            block.appendChild(text("]"));
            // take opener off brackets stack
            this.removeBracket();
            return true;
        }
        // If we got here, open is a potential opener
        is_image = opener.image;
        // Check to see if we have a link/image
        var savepos = this.pos;
        // Inline link?
        if (this.peek() === C_OPEN_PAREN) {
            this.pos++;
            if (this.spnl() && (dest = this.parseLinkDestination()) !== null && this.spnl() && // make sure there's a space before the title:
            (reWhitespaceChar.test(this.subject.charAt(this.pos - 1)) && (title = this.parseLinkTitle()) || true) && this.spnl() && this.peek() === C_CLOSE_PAREN) {
                this.pos += 1;
                matched = true;
            } else this.pos = savepos;
        }
        if (!matched) {
            // Next, see if there's a link label
            var beforelabel = this.pos;
            var n = this.parseLinkLabel();
            if (n > 2) reflabel = this.subject.slice(beforelabel, beforelabel + n);
            else if (!opener.bracketAfter) // Empty or missing second label means to use the first label as the reference.
            // The reference must not contain a bracket. If we know there's a bracket, we don't even bother checking it.
            reflabel = this.subject.slice(opener.index, startpos);
            if (n === 0) // If shortcut reference link, rewind before spaces we skipped.
            this.pos = savepos;
            if (reflabel) {
                // lookup rawlabel in refmap
                var link = this.refmap[normalizeReference(reflabel)];
                if (link) {
                    dest = link.destination;
                    title = link.title;
                    matched = true;
                }
            }
        }
        if (matched) {
            var node = new Node(is_image ? "image" : "link");
            node._destination = dest;
            node._title = title || "";
            var tmp, next;
            tmp = opener.node._next;
            while(tmp){
                next = tmp._next;
                tmp.unlink();
                node.appendChild(tmp);
                tmp = next;
            }
            block.appendChild(node);
            this.processEmphasis(opener.previousDelimiter);
            this.removeBracket();
            opener.node.unlink();
            // We remove this bracket and processEmphasis will remove later delimiters.
            // Now, for a link, we also deactivate earlier link openers.
            // (no links in links)
            if (!is_image) {
                opener = this.brackets;
                while(opener !== null){
                    if (!opener.image) opener.active = false; // deactivate this opener
                    opener = opener.previous;
                }
            }
            return true;
        } else {
            // no match
            this.removeBracket(); // remove this opener from stack
            this.pos = startpos;
            block.appendChild(text("]"));
            return true;
        }
    };
    var addBracket = function(node, index, image) {
        if (this.brackets !== null) this.brackets.bracketAfter = true;
        this.brackets = {
            node: node,
            previous: this.brackets,
            previousDelimiter: this.delimiters,
            index: index,
            image: image,
            active: true
        };
    };
    var removeBracket = function() {
        this.brackets = this.brackets.previous;
    };
    // Attempt to parse an entity.
    var parseEntity = function(block) {
        var m;
        if (m = this.match(reEntityHere)) {
            block.appendChild(text(lib_10(m)));
            return true;
        } else return false;
    };
    // Parse a run of ordinary characters, or a single character with
    // a special meaning in markdown, as a plain string.
    var parseString = function(block) {
        var m;
        if (m = this.match(reMain)) {
            if (this.options.smart) block.appendChild(text(m.replace(reEllipses, "\u2026").replace(reDash, function(chars) {
                var enCount = 0;
                var emCount = 0;
                if (chars.length % 3 === 0) // If divisible by 3, use all em dashes
                emCount = chars.length / 3;
                else if (chars.length % 2 === 0) // If divisible by 2, use all en dashes
                enCount = chars.length / 2;
                else if (chars.length % 3 === 2) {
                    // If 2 extra dashes, use en dash for last 2; em dashes for rest
                    enCount = 1;
                    emCount = (chars.length - 2) / 3;
                } else {
                    // Use en dashes for last 4 hyphens; em dashes for rest
                    enCount = 2;
                    emCount = (chars.length - 4) / 3;
                }
                return "\u2014".repeat(emCount) + "\u2013".repeat(enCount);
            })));
            else block.appendChild(text(m));
            return true;
        } else return false;
    };
    // Parse a newline.  If it was preceded by two spaces, return a hard
    // line break; otherwise a soft line break.
    var parseNewline = function(block) {
        this.pos += 1; // assume we're at a \n
        // check previous node for trailing spaces
        var lastc = block._lastChild;
        if (lastc && lastc.type === "text" && lastc._literal[lastc._literal.length - 1] === " ") {
            var hardbreak = lastc._literal[lastc._literal.length - 2] === " ";
            lastc._literal = lastc._literal.replace(reFinalSpace, "");
            block.appendChild(new Node(hardbreak ? "linebreak" : "softbreak"));
        } else block.appendChild(new Node("softbreak"));
        this.match(reInitialSpace); // gobble leading spaces in next line
        return true;
    };
    // Attempt to parse a link reference, modifying refmap.
    var parseReference = function(s, refmap) {
        this.subject = s;
        this.pos = 0;
        var rawlabel;
        var dest;
        var title;
        var matchChars;
        var startpos = this.pos;
        // label:
        matchChars = this.parseLinkLabel();
        if (matchChars === 0) return 0;
        else rawlabel = this.subject.substr(0, matchChars);
        // colon:
        if (this.peek() === C_COLON) this.pos++;
        else {
            this.pos = startpos;
            return 0;
        }
        //  link url
        this.spnl();
        dest = this.parseLinkDestination();
        if (dest === null) {
            this.pos = startpos;
            return 0;
        }
        var beforetitle = this.pos;
        this.spnl();
        if (this.pos !== beforetitle) title = this.parseLinkTitle();
        if (title === null) {
            title = "";
            // rewind before spaces
            this.pos = beforetitle;
        }
        // make sure we're at line end:
        var atLineEnd = true;
        if (this.match(reSpaceAtEndOfLine) === null) {
            if (title === "") atLineEnd = false;
            else {
                // the potential title we found is not at the line end,
                // but it could still be a legal link reference if we
                // discard the title
                title = "";
                // rewind before spaces
                this.pos = beforetitle;
                // and instead check if the link URL is at the line end
                atLineEnd = this.match(reSpaceAtEndOfLine) !== null;
            }
        }
        if (!atLineEnd) {
            this.pos = startpos;
            return 0;
        }
        var normlabel = normalizeReference(rawlabel);
        if (normlabel === "") {
            // label must contain non-whitespace characters
            this.pos = startpos;
            return 0;
        }
        if (!refmap[normlabel]) refmap[normlabel] = {
            destination: dest,
            title: title
        };
        return this.pos - startpos;
    };
    // Parse the next inline element in subject, advancing subject position.
    // On success, add the result to block's children and return true.
    // On failure, return false.
    var parseInline = function(block) {
        var res = false;
        var c = this.peek();
        if (c === -1) return false;
        switch(c){
            case C_NEWLINE:
                res = this.parseNewline(block);
                break;
            case C_BACKSLASH$1:
                res = this.parseBackslash(block);
                break;
            case C_BACKTICK:
                res = this.parseBackticks(block);
                break;
            case C_ASTERISK:
            case C_UNDERSCORE:
                res = this.handleDelim(c, block);
                break;
            case C_SINGLEQUOTE:
            case C_DOUBLEQUOTE:
                res = this.options.smart && this.handleDelim(c, block);
                break;
            case C_OPEN_BRACKET:
                res = this.parseOpenBracket(block);
                break;
            case C_BANG:
                res = this.parseBang(block);
                break;
            case C_CLOSE_BRACKET:
                res = this.parseCloseBracket(block);
                break;
            case C_LESSTHAN:
                res = this.parseAutolink(block) || this.parseHtmlTag(block);
                break;
            case C_AMPERSAND:
                res = this.parseEntity(block);
                break;
            default:
                res = this.parseString(block);
                break;
        }
        if (!res) {
            this.pos += 1;
            block.appendChild(text(fromCodePoint(c)));
        }
        return true;
    };
    // Parse string content in block into inline children,
    // using refmap to resolve references.
    var parseInlines = function(block) {
        this.subject = block._string_content.trim();
        this.pos = 0;
        this.delimiters = null;
        this.brackets = null;
        while(this.parseInline(block));
        block._string_content = null; // allow raw string to be garbage collected
        this.processEmphasis(null);
    };
    // The InlineParser object.
    function InlineParser(options) {
        return {
            subject: "",
            delimiters: null,
            brackets: null,
            pos: 0,
            refmap: {},
            match: match,
            peek: peek,
            spnl: spnl,
            parseBackticks: parseBackticks,
            parseBackslash: parseBackslash,
            parseAutolink: parseAutolink,
            parseHtmlTag: parseHtmlTag,
            scanDelims: scanDelims,
            handleDelim: handleDelim,
            parseLinkTitle: parseLinkTitle,
            parseLinkDestination: parseLinkDestination,
            parseLinkLabel: parseLinkLabel,
            parseOpenBracket: parseOpenBracket,
            parseBang: parseBang,
            parseCloseBracket: parseCloseBracket,
            addBracket: addBracket,
            removeBracket: removeBracket,
            parseEntity: parseEntity,
            parseString: parseString,
            parseNewline: parseNewline,
            parseReference: parseReference,
            parseInline: parseInline,
            processEmphasis: processEmphasis,
            removeDelimiter: removeDelimiter,
            options: options || {},
            parse: parseInlines
        };
    }
    var CODE_INDENT = 4;
    var C_TAB = 9;
    var C_NEWLINE$1 = 10;
    var C_GREATERTHAN = 62;
    var C_LESSTHAN$1 = 60;
    var C_SPACE = 32;
    var C_OPEN_BRACKET$1 = 91;
    var reHtmlBlockOpen = [
        /./,
        /^<(?:script|pre|textarea|style)(?:\s|>|$)/i,
        /^<!--/,
        /^<[?]/,
        /^<![A-Z]/,
        /^<!\[CDATA\[/,
        /^<[/]?(?:address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[123456]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|nav|noframes|ol|optgroup|option|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul)(?:\s|[/]?[>]|$)/i,
        new RegExp("^(?:" + OPENTAG + "|" + CLOSETAG + ")\\s*$", "i")
    ];
    var reHtmlBlockClose = [
        /./,
        /<\/(?:script|pre|textarea|style)>/i,
        /-->/,
        /\?>/,
        />/,
        /\]\]>/
    ];
    var reThematicBreak = /^(?:(?:\*[ \t]*){3,}|(?:_[ \t]*){3,}|(?:-[ \t]*){3,})[ \t]*$/;
    var reMaybeSpecial = /^[#`~*+_=<>0-9-]/;
    var reNonSpace = /[^ \t\f\v\r\n]/;
    var reBulletListMarker = /^[*+-]/;
    var reOrderedListMarker = /^(\d{1,9})([.)])/;
    var reATXHeadingMarker = /^#{1,6}(?:[ \t]+|$)/;
    var reCodeFence = /^`{3,}(?!.*`)|^~{3,}/;
    var reClosingCodeFence = /^(?:`{3,}|~{3,})(?= *$)/;
    var reSetextHeadingLine = /^(?:=+|-+)[ \t]*$/;
    var reLineEnding = /\r\n|\n|\r/;
    // Returns true if string contains only space characters.
    var isBlank = function(s) {
        return !reNonSpace.test(s);
    };
    var isSpaceOrTab = function(c) {
        return c === C_SPACE || c === C_TAB;
    };
    var peek$1 = function(ln, pos) {
        if (pos < ln.length) return ln.charCodeAt(pos);
        else return -1;
    };
    // DOC PARSER
    // These are methods of a Parser object, defined below.
    // Returns true if block ends with a blank line, descending if needed
    // into lists and sublists.
    var endsWithBlankLine = function(block) {
        while(block){
            if (block._lastLineBlank) return true;
            var t = block.type;
            if (!block._lastLineChecked && (t === "list" || t === "item")) {
                block._lastLineChecked = true;
                block = block._lastChild;
            } else {
                block._lastLineChecked = true;
                break;
            }
        }
        return false;
    };
    // Add a line to the block at the tip.  We assume the tip
    // can accept lines -- that check should be done before calling this.
    var addLine = function() {
        if (this.partiallyConsumedTab) {
            this.offset += 1; // skip over tab
            // add space characters:
            var charsToTab = 4 - this.column % 4;
            this.tip._string_content += " ".repeat(charsToTab);
        }
        this.tip._string_content += this.currentLine.slice(this.offset) + "\n";
    };
    // Add block of type tag as a child of the tip.  If the tip can't
    // accept children, close and finalize it and try its parent,
    // and so on til we find a block that can accept children.
    var addChild = function(tag, offset) {
        while(!this.blocks[this.tip.type].canContain(tag))this.finalize(this.tip, this.lineNumber - 1);
        var column_number = offset + 1; // offset 0 = column 1
        var newBlock = new Node(tag, [
            [
                this.lineNumber,
                column_number
            ],
            [
                0,
                0
            ]
        ]);
        newBlock._string_content = "";
        this.tip.appendChild(newBlock);
        this.tip = newBlock;
        return newBlock;
    };
    // Parse a list marker and return data on the marker (type,
    // start, delimiter, bullet character, padding) or null.
    var parseListMarker = function(parser, container) {
        var rest = parser.currentLine.slice(parser.nextNonspace);
        var match;
        var nextc;
        var spacesStartCol;
        var spacesStartOffset;
        var data = {
            type: null,
            tight: true,
            bulletChar: null,
            start: null,
            delimiter: null,
            padding: null,
            markerOffset: parser.indent
        };
        if (parser.indent >= 4) return null;
        if (match = rest.match(reBulletListMarker)) {
            data.type = "bullet";
            data.bulletChar = match[0][0];
        } else if ((match = rest.match(reOrderedListMarker)) && (container.type !== "paragraph" || match[1] === "1")) {
            data.type = "ordered";
            data.start = parseInt(match[1]);
            data.delimiter = match[2];
        } else return null;
        // make sure we have spaces after
        nextc = peek$1(parser.currentLine, parser.nextNonspace + match[0].length);
        if (!(nextc === -1 || nextc === C_TAB || nextc === C_SPACE)) return null;
        // if it interrupts paragraph, make sure first line isn't blank
        if (container.type === "paragraph" && !parser.currentLine.slice(parser.nextNonspace + match[0].length).match(reNonSpace)) return null;
        // we've got a match! advance offset and calculate padding
        parser.advanceNextNonspace(); // to start of marker
        parser.advanceOffset(match[0].length, true); // to end of marker
        spacesStartCol = parser.column;
        spacesStartOffset = parser.offset;
        do {
            parser.advanceOffset(1, true);
            nextc = peek$1(parser.currentLine, parser.offset);
        }while (parser.column - spacesStartCol < 5 && isSpaceOrTab(nextc));
        var blank_item = peek$1(parser.currentLine, parser.offset) === -1;
        var spaces_after_marker = parser.column - spacesStartCol;
        if (spaces_after_marker >= 5 || spaces_after_marker < 1 || blank_item) {
            data.padding = match[0].length + 1;
            parser.column = spacesStartCol;
            parser.offset = spacesStartOffset;
            if (isSpaceOrTab(peek$1(parser.currentLine, parser.offset))) parser.advanceOffset(1, true);
        } else data.padding = match[0].length + spaces_after_marker;
        return data;
    };
    // Returns true if the two list items are of the same type,
    // with the same delimiter and bullet character.  This is used
    // in agglomerating list items into lists.
    var listsMatch = function(list_data, item_data) {
        return list_data.type === item_data.type && list_data.delimiter === item_data.delimiter && list_data.bulletChar === item_data.bulletChar;
    };
    // Finalize and close any unmatched blocks.
    var closeUnmatchedBlocks = function() {
        if (!this.allClosed) {
            // finalize any blocks not matched
            while(this.oldtip !== this.lastMatchedContainer){
                var parent = this.oldtip._parent;
                this.finalize(this.oldtip, this.lineNumber - 1);
                this.oldtip = parent;
            }
            this.allClosed = true;
        }
    };
    // 'finalize' is run when the block is closed.
    // 'continue' is run to check whether the block is continuing
    // at a certain line and offset (e.g. whether a block quote
    // contains a `>`.  It returns 0 for matched, 1 for not matched,
    // and 2 for "we've dealt with this line completely, go to next."
    var blocks = {
        document: {
            continue: function() {
                return 0;
            },
            finalize: function() {
                return;
            },
            canContain: function(t) {
                return t !== "item";
            },
            acceptsLines: false
        },
        list: {
            continue: function() {
                return 0;
            },
            finalize: function(parser, block) {
                var item = block._firstChild;
                while(item){
                    // check for non-final list item ending with blank line:
                    if (endsWithBlankLine(item) && item._next) {
                        block._listData.tight = false;
                        break;
                    }
                    // recurse into children of list item, to see if there are
                    // spaces between any of them:
                    var subitem = item._firstChild;
                    while(subitem){
                        if (endsWithBlankLine(subitem) && (item._next || subitem._next)) {
                            block._listData.tight = false;
                            break;
                        }
                        subitem = subitem._next;
                    }
                    item = item._next;
                }
            },
            canContain: function(t) {
                return t === "item";
            },
            acceptsLines: false
        },
        block_quote: {
            continue: function(parser) {
                var ln = parser.currentLine;
                if (!parser.indented && peek$1(ln, parser.nextNonspace) === C_GREATERTHAN) {
                    parser.advanceNextNonspace();
                    parser.advanceOffset(1, false);
                    if (isSpaceOrTab(peek$1(ln, parser.offset))) parser.advanceOffset(1, true);
                } else return 1;
                return 0;
            },
            finalize: function() {
                return;
            },
            canContain: function(t) {
                return t !== "item";
            },
            acceptsLines: false
        },
        item: {
            continue: function(parser, container) {
                if (parser.blank) {
                    if (container._firstChild == null) // Blank line after empty list item
                    return 1;
                    else parser.advanceNextNonspace();
                } else if (parser.indent >= container._listData.markerOffset + container._listData.padding) parser.advanceOffset(container._listData.markerOffset + container._listData.padding, true);
                else return 1;
                return 0;
            },
            finalize: function() {
                return;
            },
            canContain: function(t) {
                return t !== "item";
            },
            acceptsLines: false
        },
        heading: {
            continue: function() {
                // a heading can never container > 1 line, so fail to match:
                return 1;
            },
            finalize: function() {
                return;
            },
            canContain: function() {
                return false;
            },
            acceptsLines: false
        },
        thematic_break: {
            continue: function() {
                // a thematic break can never container > 1 line, so fail to match:
                return 1;
            },
            finalize: function() {
                return;
            },
            canContain: function() {
                return false;
            },
            acceptsLines: false
        },
        code_block: {
            continue: function(parser, container) {
                var ln = parser.currentLine;
                var indent = parser.indent;
                if (container._isFenced) {
                    // fenced
                    var match = indent <= 3 && ln.charAt(parser.nextNonspace) === container._fenceChar && ln.slice(parser.nextNonspace).match(reClosingCodeFence);
                    if (match && match[0].length >= container._fenceLength) {
                        // closing fence - we're at end of line, so we can return
                        parser.lastLineLength = parser.offset + indent + match[0].length;
                        parser.finalize(container, parser.lineNumber);
                        return 2;
                    } else {
                        // skip optional spaces of fence offset
                        var i = container._fenceOffset;
                        while(i > 0 && isSpaceOrTab(peek$1(ln, parser.offset))){
                            parser.advanceOffset(1, true);
                            i--;
                        }
                    }
                } else {
                    // indented
                    if (indent >= CODE_INDENT) parser.advanceOffset(CODE_INDENT, true);
                    else if (parser.blank) parser.advanceNextNonspace();
                    else return 1;
                }
                return 0;
            },
            finalize: function(parser, block) {
                if (block._isFenced) {
                    // fenced
                    // first line becomes info string
                    var content = block._string_content;
                    var newlinePos = content.indexOf("\n");
                    var firstLine = content.slice(0, newlinePos);
                    var rest = content.slice(newlinePos + 1);
                    block.info = unescapeString(firstLine.trim());
                    block._literal = rest;
                } else // indented
                block._literal = block._string_content.replace(/(\n *)+$/, "\n");
                block._string_content = null; // allow GC
            },
            canContain: function() {
                return false;
            },
            acceptsLines: true
        },
        html_block: {
            continue: function(parser, container) {
                return parser.blank && (container._htmlBlockType === 6 || container._htmlBlockType === 7) ? 1 : 0;
            },
            finalize: function(parser, block) {
                block._literal = block._string_content.replace(/(\n *)+$/, "");
                block._string_content = null; // allow GC
            },
            canContain: function() {
                return false;
            },
            acceptsLines: true
        },
        paragraph: {
            continue: function(parser) {
                return parser.blank ? 1 : 0;
            },
            finalize: function(parser, block) {
                var pos;
                var hasReferenceDefs = false;
                // try parsing the beginning as link reference definitions:
                while(peek$1(block._string_content, 0) === C_OPEN_BRACKET$1 && (pos = parser.inlineParser.parseReference(block._string_content, parser.refmap))){
                    block._string_content = block._string_content.slice(pos);
                    hasReferenceDefs = true;
                }
                if (hasReferenceDefs && isBlank(block._string_content)) block.unlink();
            },
            canContain: function() {
                return false;
            },
            acceptsLines: true
        }
    };
    // block start functions.  Return values:
    // 0 = no match
    // 1 = matched container, keep going
    // 2 = matched leaf, no more block starts
    var blockStarts = [
        // block quote
        function(parser) {
            if (!parser.indented && peek$1(parser.currentLine, parser.nextNonspace) === C_GREATERTHAN) {
                parser.advanceNextNonspace();
                parser.advanceOffset(1, false);
                // optional following space
                if (isSpaceOrTab(peek$1(parser.currentLine, parser.offset))) parser.advanceOffset(1, true);
                parser.closeUnmatchedBlocks();
                parser.addChild("block_quote", parser.nextNonspace);
                return 1;
            } else return 0;
        },
        // ATX heading
        function(parser) {
            var match;
            if (!parser.indented && (match = parser.currentLine.slice(parser.nextNonspace).match(reATXHeadingMarker))) {
                parser.advanceNextNonspace();
                parser.advanceOffset(match[0].length, false);
                parser.closeUnmatchedBlocks();
                var container = parser.addChild("heading", parser.nextNonspace);
                container.level = match[0].trim().length; // number of #s
                // remove trailing ###s:
                container._string_content = parser.currentLine.slice(parser.offset).replace(/^[ \t]*#+[ \t]*$/, "").replace(/[ \t]+#+[ \t]*$/, "");
                parser.advanceOffset(parser.currentLine.length - parser.offset);
                return 2;
            } else return 0;
        },
        // Fenced code block
        function(parser) {
            var match;
            if (!parser.indented && (match = parser.currentLine.slice(parser.nextNonspace).match(reCodeFence))) {
                var fenceLength = match[0].length;
                parser.closeUnmatchedBlocks();
                var container = parser.addChild("code_block", parser.nextNonspace);
                container._isFenced = true;
                container._fenceLength = fenceLength;
                container._fenceChar = match[0][0];
                container._fenceOffset = parser.indent;
                parser.advanceNextNonspace();
                parser.advanceOffset(fenceLength, false);
                return 2;
            } else return 0;
        },
        // HTML block
        function(parser, container) {
            if (!parser.indented && peek$1(parser.currentLine, parser.nextNonspace) === C_LESSTHAN$1) {
                var s = parser.currentLine.slice(parser.nextNonspace);
                var blockType;
                for(blockType = 1; blockType <= 7; blockType++)if (reHtmlBlockOpen[blockType].test(s) && (blockType < 7 || container.type !== "paragraph")) {
                    parser.closeUnmatchedBlocks();
                    // We don't adjust parser.offset;
                    // spaces are part of the HTML block:
                    var b = parser.addChild("html_block", parser.offset);
                    b._htmlBlockType = blockType;
                    return 2;
                }
            }
            return 0;
        },
        // Setext heading
        function(parser, container) {
            var match;
            if (!parser.indented && container.type === "paragraph" && (match = parser.currentLine.slice(parser.nextNonspace).match(reSetextHeadingLine))) {
                parser.closeUnmatchedBlocks();
                // resolve reference link definitiosn
                var pos;
                while(peek$1(container._string_content, 0) === C_OPEN_BRACKET$1 && (pos = parser.inlineParser.parseReference(container._string_content, parser.refmap)))container._string_content = container._string_content.slice(pos);
                if (container._string_content.length > 0) {
                    var heading = new Node("heading", container.sourcepos);
                    heading.level = match[0][0] === "=" ? 1 : 2;
                    heading._string_content = container._string_content;
                    container.insertAfter(heading);
                    container.unlink();
                    parser.tip = heading;
                    parser.advanceOffset(parser.currentLine.length - parser.offset, false);
                    return 2;
                } else return 0;
            } else return 0;
        },
        // thematic break
        function(parser) {
            if (!parser.indented && reThematicBreak.test(parser.currentLine.slice(parser.nextNonspace))) {
                parser.closeUnmatchedBlocks();
                parser.addChild("thematic_break", parser.nextNonspace);
                parser.advanceOffset(parser.currentLine.length - parser.offset, false);
                return 2;
            } else return 0;
        },
        // list item
        function(parser, container) {
            var data;
            if ((!parser.indented || container.type === "list") && (data = parseListMarker(parser, container))) {
                parser.closeUnmatchedBlocks();
                // add the list if needed
                if (parser.tip.type !== "list" || !listsMatch(container._listData, data)) {
                    container = parser.addChild("list", parser.nextNonspace);
                    container._listData = data;
                }
                // add the list item
                container = parser.addChild("item", parser.nextNonspace);
                container._listData = data;
                return 1;
            } else return 0;
        },
        // indented code block
        function(parser) {
            if (parser.indented && parser.tip.type !== "paragraph" && !parser.blank) {
                // indented code
                parser.advanceOffset(CODE_INDENT, true);
                parser.closeUnmatchedBlocks();
                parser.addChild("code_block", parser.offset);
                return 2;
            } else return 0;
        }
    ];
    var advanceOffset = function(count, columns) {
        var currentLine = this.currentLine;
        var charsToTab, charsToAdvance;
        var c;
        while(count > 0 && (c = currentLine[this.offset]))if (c === "\t") {
            charsToTab = 4 - this.column % 4;
            if (columns) {
                this.partiallyConsumedTab = charsToTab > count;
                charsToAdvance = charsToTab > count ? count : charsToTab;
                this.column += charsToAdvance;
                this.offset += this.partiallyConsumedTab ? 0 : 1;
                count -= charsToAdvance;
            } else {
                this.partiallyConsumedTab = false;
                this.column += charsToTab;
                this.offset += 1;
                count -= 1;
            }
        } else {
            this.partiallyConsumedTab = false;
            this.offset += 1;
            this.column += 1; // assume ascii; block starts are ascii
            count -= 1;
        }
    };
    var advanceNextNonspace = function() {
        this.offset = this.nextNonspace;
        this.column = this.nextNonspaceColumn;
        this.partiallyConsumedTab = false;
    };
    var findNextNonspace = function() {
        var currentLine = this.currentLine;
        var i = this.offset;
        var cols = this.column;
        var c;
        while((c = currentLine.charAt(i)) !== ""){
            if (c === " ") {
                i++;
                cols++;
            } else if (c === "\t") {
                i++;
                cols += 4 - cols % 4;
            } else break;
        }
        this.blank = c === "\n" || c === "\r" || c === "";
        this.nextNonspace = i;
        this.nextNonspaceColumn = cols;
        this.indent = this.nextNonspaceColumn - this.column;
        this.indented = this.indent >= CODE_INDENT;
    };
    // Analyze a line of text and update the document appropriately.
    // We parse markdown text by calling this on each line of input,
    // then finalizing the document.
    var incorporateLine = function(ln) {
        var all_matched = true;
        var t;
        var container = this.doc;
        this.oldtip = this.tip;
        this.offset = 0;
        this.column = 0;
        this.blank = false;
        this.partiallyConsumedTab = false;
        this.lineNumber += 1;
        // replace NUL characters for security
        if (ln.indexOf("\u0000") !== -1) ln = ln.replace(/\0/g, "\uFFFD");
        this.currentLine = ln;
        // For each containing block, try to parse the associated line start.
        // Bail out on failure: container will point to the last matching block.
        // Set all_matched to false if not all containers match.
        var lastChild;
        while((lastChild = container._lastChild) && lastChild._open){
            container = lastChild;
            this.findNextNonspace();
            switch(this.blocks[container.type].continue(this, container)){
                case 0:
                    break;
                case 1:
                    all_matched = false;
                    break;
                case 2:
                    return;
                default:
                    throw "continue returned illegal value, must be 0, 1, or 2";
            }
            if (!all_matched) {
                container = container._parent; // back up to last matching block
                break;
            }
        }
        this.allClosed = container === this.oldtip;
        this.lastMatchedContainer = container;
        var matchedLeaf = container.type !== "paragraph" && blocks[container.type].acceptsLines;
        var starts = this.blockStarts;
        var startsLen = starts.length;
        // Unless last matched container is a code block, try new container starts,
        // adding children to the last matched container:
        while(!matchedLeaf){
            this.findNextNonspace();
            // this is a little performance optimization:
            if (!this.indented && !reMaybeSpecial.test(ln.slice(this.nextNonspace))) {
                this.advanceNextNonspace();
                break;
            }
            var i = 0;
            while(i < startsLen){
                var res = starts[i](this, container);
                if (res === 1) {
                    container = this.tip;
                    break;
                } else if (res === 2) {
                    container = this.tip;
                    matchedLeaf = true;
                    break;
                } else i++;
            }
            if (i === startsLen) {
                // nothing matched
                this.advanceNextNonspace();
                break;
            }
        }
        // What remains at the offset is a text line.  Add the text to the
        // appropriate container.
        // First check for a lazy paragraph continuation:
        if (!this.allClosed && !this.blank && this.tip.type === "paragraph") // lazy paragraph continuation
        this.addLine();
        else {
            // not a lazy continuation
            // finalize any blocks not matched
            this.closeUnmatchedBlocks();
            if (this.blank && container.lastChild) container.lastChild._lastLineBlank = true;
            t = container.type;
            // Block quote lines are never blank as they start with >
            // and we don't count blanks in fenced code for purposes of tight/loose
            // lists or breaking out of lists.  We also don't set _lastLineBlank
            // on an empty list item, or if we just closed a fenced block.
            var lastLineBlank = this.blank && !(t === "block_quote" || t === "code_block" && container._isFenced || t === "item" && !container._firstChild && container.sourcepos[0][0] === this.lineNumber);
            // propagate lastLineBlank up through parents:
            var cont = container;
            while(cont){
                cont._lastLineBlank = lastLineBlank;
                cont = cont._parent;
            }
            if (this.blocks[t].acceptsLines) {
                this.addLine();
                // if HtmlBlock, check for end condition
                if (t === "html_block" && container._htmlBlockType >= 1 && container._htmlBlockType <= 5 && reHtmlBlockClose[container._htmlBlockType].test(this.currentLine.slice(this.offset))) {
                    this.lastLineLength = ln.length;
                    this.finalize(container, this.lineNumber);
                }
            } else if (this.offset < ln.length && !this.blank) {
                // create paragraph container for line
                container = this.addChild("paragraph", this.offset);
                this.advanceNextNonspace();
                this.addLine();
            }
        }
        this.lastLineLength = ln.length;
    };
    // Finalize a block.  Close it and do any necessary postprocessing,
    // e.g. creating string_content from strings, setting the 'tight'
    // or 'loose' status of a list, and parsing the beginnings
    // of paragraphs for reference definitions.  Reset the tip to the
    // parent of the closed block.
    var finalize = function(block, lineNumber) {
        var above = block._parent;
        block._open = false;
        block.sourcepos[1] = [
            lineNumber,
            this.lastLineLength
        ];
        this.blocks[block.type].finalize(this, block);
        this.tip = above;
    };
    // Walk through a block & children recursively, parsing string content
    // into inline content where appropriate.
    var processInlines = function(block) {
        var node, event, t;
        var walker = block.walker();
        this.inlineParser.refmap = this.refmap;
        this.inlineParser.options = this.options;
        while(event = walker.next()){
            node = event.node;
            t = node.type;
            if (!event.entering && (t === "paragraph" || t === "heading")) this.inlineParser.parse(node);
        }
    };
    var Document = function() {
        var doc = new Node("document", [
            [
                1,
                1
            ],
            [
                0,
                0
            ]
        ]);
        return doc;
    };
    // The main parsing function.  Returns a parsed document AST.
    var parse = function(input) {
        this.doc = new Document();
        this.tip = this.doc;
        this.refmap = {};
        this.lineNumber = 0;
        this.lastLineLength = 0;
        this.offset = 0;
        this.column = 0;
        this.lastMatchedContainer = this.doc;
        this.currentLine = "";
        if (this.options.time) console.time("preparing input");
        var lines = input.split(reLineEnding);
        var len = lines.length;
        if (input.charCodeAt(input.length - 1) === C_NEWLINE$1) // ignore last blank line created by final newline
        len -= 1;
        if (this.options.time) console.timeEnd("preparing input");
        if (this.options.time) console.time("block parsing");
        for(var i = 0; i < len; i++)this.incorporateLine(lines[i]);
        while(this.tip)this.finalize(this.tip, len);
        if (this.options.time) console.timeEnd("block parsing");
        if (this.options.time) console.time("inline parsing");
        this.processInlines(this.doc);
        if (this.options.time) console.timeEnd("inline parsing");
        return this.doc;
    };
    // The Parser object.
    function Parser(options) {
        return {
            doc: new Document(),
            blocks: blocks,
            blockStarts: blockStarts,
            tip: this.doc,
            oldtip: this.doc,
            currentLine: "",
            lineNumber: 0,
            offset: 0,
            column: 0,
            nextNonspace: 0,
            nextNonspaceColumn: 0,
            indent: 0,
            indented: false,
            blank: false,
            partiallyConsumedTab: false,
            allClosed: true,
            lastMatchedContainer: this.doc,
            refmap: {},
            lastLineLength: 0,
            inlineParser: new InlineParser(options),
            findNextNonspace: findNextNonspace,
            advanceOffset: advanceOffset,
            advanceNextNonspace: advanceNextNonspace,
            addLine: addLine,
            addChild: addChild,
            incorporateLine: incorporateLine,
            finalize: finalize,
            processInlines: processInlines,
            closeUnmatchedBlocks: closeUnmatchedBlocks,
            parse: parse,
            options: options || {}
        };
    }
    function Renderer() {}
    /**
     *  Walks the AST and calls member methods for each Node type.
     *
     *  @param ast {Node} The root of the abstract syntax tree.
     */ function render(ast) {
        var walker = ast.walker(), event, type;
        this.buffer = "";
        this.lastOut = "\n";
        while(event = walker.next()){
            type = event.node.type;
            if (this[type]) this[type](event.node, event.entering);
        }
        return this.buffer;
    }
    /**
     *  Concatenate a literal string to the buffer.
     *
     *  @param str {String} The string to concatenate.
     */ function lit(str) {
        this.buffer += str;
        this.lastOut = str;
    }
    /**
     *  Output a newline to the buffer.
     */ function cr() {
        if (this.lastOut !== "\n") this.lit("\n");
    }
    /**
     *  Concatenate a string to the buffer possibly escaping the content.
     *
     *  Concrete renderer implementations should override this method.
     *
     *  @param str {String} The string to concatenate.
     */ function out(str) {
        this.lit(str);
    }
    /**
     *  Escape a string for the target renderer.
     *
     *  Abstract function that should be implemented by concrete
     *  renderer implementations.
     *
     *  @param str {String} The string to escape.
     */ function esc(str) {
        return str;
    }
    Renderer.prototype.render = render;
    Renderer.prototype.out = out;
    Renderer.prototype.lit = lit;
    Renderer.prototype.cr = cr;
    Renderer.prototype.esc = esc;
    var reUnsafeProtocol = /^javascript:|vbscript:|file:|data:/i;
    var reSafeDataProtocol = /^data:image\/(?:png|gif|jpeg|webp)/i;
    var potentiallyUnsafe = function(url) {
        return reUnsafeProtocol.test(url) && !reSafeDataProtocol.test(url);
    };
    // Helper function to produce an HTML tag.
    function tag(name, attrs, selfclosing) {
        if (this.disableTags > 0) return;
        this.buffer += "<" + name;
        if (attrs && attrs.length > 0) {
            var i = 0;
            var attrib;
            while((attrib = attrs[i]) !== undefined){
                this.buffer += " " + attrib[0] + '="' + attrib[1] + '"';
                i++;
            }
        }
        if (selfclosing) this.buffer += " /";
        this.buffer += ">";
        this.lastOut = ">";
    }
    function HtmlRenderer(options) {
        options = options || {};
        // by default, soft breaks are rendered as newlines in HTML
        options.softbreak = options.softbreak || "\n";
        // set to "<br />" to make them hard breaks
        // set to " " if you want to ignore line wrapping in source
        this.disableTags = 0;
        this.lastOut = "\n";
        this.options = options;
    }
    /* Node methods */ function text$1(node) {
        this.out(node.literal);
    }
    function softbreak() {
        this.lit(this.options.softbreak);
    }
    function linebreak() {
        this.tag("br", [], true);
        this.cr();
    }
    function link(node, entering) {
        var attrs = this.attrs(node);
        if (entering) {
            if (!(this.options.safe && potentiallyUnsafe(node.destination))) attrs.push([
                "href",
                this.esc(node.destination)
            ]);
            if (node.title) attrs.push([
                "title",
                this.esc(node.title)
            ]);
            this.tag("a", attrs);
        } else this.tag("/a");
    }
    function image$1(node, entering) {
        if (entering) {
            if (this.disableTags === 0) {
                if (this.options.safe && potentiallyUnsafe(node.destination)) this.lit('<img src="" alt="');
                else this.lit('<img src="' + this.esc(node.destination) + '" alt="');
            }
            this.disableTags += 1;
        } else {
            this.disableTags -= 1;
            if (this.disableTags === 0) {
                if (node.title) this.lit('" title="' + this.esc(node.title));
                this.lit('" />');
            }
        }
    }
    function emph(node, entering) {
        this.tag(entering ? "em" : "/em");
    }
    function strong(node, entering) {
        this.tag(entering ? "strong" : "/strong");
    }
    function paragraph(node, entering) {
        var grandparent = node.parent.parent, attrs = this.attrs(node);
        if (grandparent !== null && grandparent.type === "list") {
            if (grandparent.listTight) return;
        }
        if (entering) {
            this.cr();
            this.tag("p", attrs);
        } else {
            this.tag("/p");
            this.cr();
        }
    }
    function heading(node, entering) {
        var tagname = "h" + node.level, attrs = this.attrs(node);
        if (entering) {
            this.cr();
            this.tag(tagname, attrs);
        } else {
            this.tag("/" + tagname);
            this.cr();
        }
    }
    function code(node) {
        this.tag("code");
        this.out(node.literal);
        this.tag("/code");
    }
    function code_block(node) {
        var info_words = node.info ? node.info.split(/\s+/) : [], attrs = this.attrs(node);
        if (info_words.length > 0 && info_words[0].length > 0) attrs.push([
            "class",
            "language-" + this.esc(info_words[0])
        ]);
        this.cr();
        this.tag("pre");
        this.tag("code", attrs);
        this.out(node.literal);
        this.tag("/code");
        this.tag("/pre");
        this.cr();
    }
    function thematic_break(node) {
        var attrs = this.attrs(node);
        this.cr();
        this.tag("hr", attrs, true);
        this.cr();
    }
    function block_quote(node, entering) {
        var attrs = this.attrs(node);
        if (entering) {
            this.cr();
            this.tag("blockquote", attrs);
            this.cr();
        } else {
            this.cr();
            this.tag("/blockquote");
            this.cr();
        }
    }
    function list(node, entering) {
        var tagname = node.listType === "bullet" ? "ul" : "ol", attrs = this.attrs(node);
        if (entering) {
            var start = node.listStart;
            if (start !== null && start !== 1) attrs.push([
                "start",
                start.toString()
            ]);
            this.cr();
            this.tag(tagname, attrs);
            this.cr();
        } else {
            this.cr();
            this.tag("/" + tagname);
            this.cr();
        }
    }
    function item(node, entering) {
        var attrs = this.attrs(node);
        if (entering) this.tag("li", attrs);
        else {
            this.tag("/li");
            this.cr();
        }
    }
    function html_inline(node) {
        if (this.options.safe) this.lit("<!-- raw HTML omitted -->");
        else this.lit(node.literal);
    }
    function html_block(node) {
        this.cr();
        if (this.options.safe) this.lit("<!-- raw HTML omitted -->");
        else this.lit(node.literal);
        this.cr();
    }
    function custom_inline(node, entering) {
        if (entering && node.onEnter) this.lit(node.onEnter);
        else if (!entering && node.onExit) this.lit(node.onExit);
    }
    function custom_block(node, entering) {
        this.cr();
        if (entering && node.onEnter) this.lit(node.onEnter);
        else if (!entering && node.onExit) this.lit(node.onExit);
        this.cr();
    }
    /* Helper methods */ function out$1(s) {
        this.lit(this.esc(s));
    }
    function attrs(node) {
        var att = [];
        if (this.options.sourcepos) {
            var pos = node.sourcepos;
            if (pos) att.push([
                "data-sourcepos",
                String(pos[0][0]) + ":" + String(pos[0][1]) + "-" + String(pos[1][0]) + ":" + String(pos[1][1])
            ]);
        }
        return att;
    }
    // quick browser-compatible inheritance
    HtmlRenderer.prototype = Object.create(Renderer.prototype);
    HtmlRenderer.prototype.text = text$1;
    HtmlRenderer.prototype.html_inline = html_inline;
    HtmlRenderer.prototype.html_block = html_block;
    HtmlRenderer.prototype.softbreak = softbreak;
    HtmlRenderer.prototype.linebreak = linebreak;
    HtmlRenderer.prototype.link = link;
    HtmlRenderer.prototype.image = image$1;
    HtmlRenderer.prototype.emph = emph;
    HtmlRenderer.prototype.strong = strong;
    HtmlRenderer.prototype.paragraph = paragraph;
    HtmlRenderer.prototype.heading = heading;
    HtmlRenderer.prototype.code = code;
    HtmlRenderer.prototype.code_block = code_block;
    HtmlRenderer.prototype.thematic_break = thematic_break;
    HtmlRenderer.prototype.block_quote = block_quote;
    HtmlRenderer.prototype.list = list;
    HtmlRenderer.prototype.item = item;
    HtmlRenderer.prototype.custom_inline = custom_inline;
    HtmlRenderer.prototype.custom_block = custom_block;
    HtmlRenderer.prototype.esc = escapeXml;
    HtmlRenderer.prototype.out = out$1;
    HtmlRenderer.prototype.tag = tag;
    HtmlRenderer.prototype.attrs = attrs;
    var reXMLTag = /\<[^>]*\>/;
    function toTagName(s) {
        return s.replace(/([a-z])([A-Z])/g, "$1_$2").toLowerCase();
    }
    function XmlRenderer(options) {
        options = options || {};
        this.disableTags = 0;
        this.lastOut = "\n";
        this.indentLevel = 0;
        this.indent = "  ";
        this.options = options;
    }
    function render$1(ast) {
        this.buffer = "";
        var attrs;
        var tagname;
        var walker = ast.walker();
        var event, node, entering;
        var container;
        var selfClosing;
        var nodetype;
        var options = this.options;
        if (options.time) console.time("rendering");
        this.buffer += '<?xml version="1.0" encoding="UTF-8"?>\n';
        this.buffer += '<!DOCTYPE document SYSTEM "CommonMark.dtd">\n';
        while(event = walker.next()){
            entering = event.entering;
            node = event.node;
            nodetype = node.type;
            container = node.isContainer;
            selfClosing = nodetype === "thematic_break" || nodetype === "linebreak" || nodetype === "softbreak";
            tagname = toTagName(nodetype);
            if (entering) {
                attrs = [];
                switch(nodetype){
                    case "document":
                        attrs.push([
                            "xmlns",
                            "http://commonmark.org/xml/1.0"
                        ]);
                        break;
                    case "list":
                        if (node.listType !== null) attrs.push([
                            "type",
                            node.listType.toLowerCase()
                        ]);
                        if (node.listStart !== null) attrs.push([
                            "start",
                            String(node.listStart)
                        ]);
                        if (node.listTight !== null) attrs.push([
                            "tight",
                            node.listTight ? "true" : "false"
                        ]);
                        var delim = node.listDelimiter;
                        if (delim !== null) {
                            var delimword = "";
                            if (delim === ".") delimword = "period";
                            else delimword = "paren";
                            attrs.push([
                                "delimiter",
                                delimword
                            ]);
                        }
                        break;
                    case "code_block":
                        if (node.info) attrs.push([
                            "info",
                            node.info
                        ]);
                        break;
                    case "heading":
                        attrs.push([
                            "level",
                            String(node.level)
                        ]);
                        break;
                    case "link":
                    case "image":
                        attrs.push([
                            "destination",
                            node.destination
                        ]);
                        attrs.push([
                            "title",
                            node.title
                        ]);
                        break;
                    case "custom_inline":
                    case "custom_block":
                        attrs.push([
                            "on_enter",
                            node.onEnter
                        ]);
                        attrs.push([
                            "on_exit",
                            node.onExit
                        ]);
                        break;
                }
                if (options.sourcepos) {
                    var pos = node.sourcepos;
                    if (pos) attrs.push([
                        "sourcepos",
                        String(pos[0][0]) + ":" + String(pos[0][1]) + "-" + String(pos[1][0]) + ":" + String(pos[1][1])
                    ]);
                }
                this.cr();
                this.out(this.tag(tagname, attrs, selfClosing));
                if (container) this.indentLevel += 1;
                else if (!container && !selfClosing) {
                    var lit = node.literal;
                    if (lit) this.out(this.esc(lit));
                    this.out(this.tag("/" + tagname));
                }
            } else {
                this.indentLevel -= 1;
                this.cr();
                this.out(this.tag("/" + tagname));
            }
        }
        if (options.time) console.timeEnd("rendering");
        this.buffer += "\n";
        return this.buffer;
    }
    function out$2(s) {
        if (this.disableTags > 0) this.buffer += s.replace(reXMLTag, "");
        else this.buffer += s;
        this.lastOut = s;
    }
    function cr$1() {
        if (this.lastOut !== "\n") {
            this.buffer += "\n";
            this.lastOut = "\n";
            for(var i = this.indentLevel; i > 0; i--)this.buffer += this.indent;
        }
    }
    // Helper function to produce an XML tag.
    function tag$1(name, attrs, selfclosing) {
        var result = "<" + name;
        if (attrs && attrs.length > 0) {
            var i = 0;
            var attrib;
            while((attrib = attrs[i]) !== undefined){
                result += " " + attrib[0] + '="' + this.esc(attrib[1]) + '"';
                i++;
            }
        }
        if (selfclosing) result += " /";
        result += ">";
        return result;
    }
    // quick browser-compatible inheritance
    XmlRenderer.prototype = Object.create(Renderer.prototype);
    XmlRenderer.prototype.render = render$1;
    XmlRenderer.prototype.out = out$2;
    XmlRenderer.prototype.cr = cr$1;
    XmlRenderer.prototype.tag = tag$1;
    XmlRenderer.prototype.esc = escapeXml;
    exports1.HtmlRenderer = HtmlRenderer;
    exports1.Node = Node;
    exports1.Parser = Parser;
    exports1.Renderer = Renderer;
    exports1.XmlRenderer = XmlRenderer;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});

});

parcelRegister("hci3a", function(module, exports) {
/**
 * Multihash implementation in JavaScript.
 *
 * @module multihash
 */ 'use strict';

var $3bFLy = parcelRequire("3bFLy");

var $lg1mP = parcelRequire("lg1mP");

var $lPX1n = parcelRequire("lPX1n");
var $c8518f0c26994259$require$names = $lPX1n.names;

var $57dKE = parcelRequire("57dKE");

var $cvLi9 = parcelRequire("cvLi9");

var $gg53d = parcelRequire("gg53d");
const $c8518f0c26994259$var$codes = /** @type {import('./types').CodeNameMap} */ {};
// eslint-disable-next-line guard-for-in
for(const key in $c8518f0c26994259$require$names){
    const name = /** @type {HashName} */ key;
    $c8518f0c26994259$var$codes[$c8518f0c26994259$require$names[name]] = name;
}
/**
 * Convert the given multihash to a hex encoded string.
 *
 * @param {Uint8Array} hash
 * @returns {string}
 */ function $c8518f0c26994259$var$toHexString(hash) {
    if (!(hash instanceof Uint8Array)) throw new Error('must be passed a Uint8Array');
    return $57dKE(hash, 'base16');
}
/**
 * Convert the given hex encoded string to a multihash.
 *
 * @param {string} hash
 * @returns {Uint8Array}
 */ function $c8518f0c26994259$var$fromHexString(hash) {
    return $cvLi9(hash, 'base16');
}
/**
 * Convert the given multihash to a base58 encoded string.
 *
 * @param {Uint8Array} hash
 * @returns {string}
 */ function $c8518f0c26994259$var$toB58String(hash) {
    if (!(hash instanceof Uint8Array)) throw new Error('must be passed a Uint8Array');
    return $57dKE($3bFLy.encode('base58btc', hash)).slice(1);
}
/**
 * Convert the given base58 encoded string to a multihash.
 *
 * @param {string|Uint8Array} hash
 * @returns {Uint8Array}
 */ function $c8518f0c26994259$var$fromB58String(hash) {
    const encoded = hash instanceof Uint8Array ? $57dKE(hash) : hash;
    return $3bFLy.decode('z' + encoded);
}
/**
 * Decode a hash from the given multihash.
 *
 * @param {Uint8Array} bytes
 * @returns {{code: HashCode, name: HashName, length: number, digest: Uint8Array}} result
 */ function $c8518f0c26994259$var$decode(bytes) {
    if (!(bytes instanceof Uint8Array)) throw new Error('multihash must be a Uint8Array');
    if (bytes.length < 2) throw new Error('multihash too short. must be > 2 bytes.');
    const code = /** @type {HashCode} */ $lg1mP.decode(bytes);
    if (!$c8518f0c26994259$var$isValidCode(code)) throw new Error(`multihash unknown function code: 0x${code.toString(16)}`);
    bytes = bytes.slice($lg1mP.decode.bytes);
    const len = $lg1mP.decode(bytes);
    if (len < 0) throw new Error(`multihash invalid length: ${len}`);
    bytes = bytes.slice($lg1mP.decode.bytes);
    if (bytes.length !== len) throw new Error(`multihash length inconsistent: 0x${$57dKE(bytes, 'base16')}`);
    return {
        code: code,
        name: $c8518f0c26994259$var$codes[code],
        length: len,
        digest: bytes
    };
}
/**
 * Encode a hash digest along with the specified function code.
 *
 * > **Note:** the length is derived from the length of the digest itself.
 *
 * @param {Uint8Array} digest
 * @param {HashName | HashCode} code
 * @param {number} [length]
 * @returns {Uint8Array}
 */ function $c8518f0c26994259$var$encode(digest, code, length) {
    if (!digest || code === undefined) throw new Error('multihash encode requires at least two args: digest, code');
    // ensure it's a hashfunction code.
    const hashfn = $c8518f0c26994259$var$coerceCode(code);
    if (!(digest instanceof Uint8Array)) throw new Error('digest should be a Uint8Array');
    if (length == null) length = digest.length;
    if (length && digest.length !== length) throw new Error('digest length should be equal to specified length.');
    const hash = $lg1mP.encode(hashfn);
    const len = $lg1mP.encode(length);
    return $gg53d([
        hash,
        len,
        digest
    ], hash.length + len.length + digest.length);
}
/**
 * Converts a hash function name into the matching code.
 * If passed a number it will return the number if it's a valid code.
 *
 * @param {HashName | number} name
 * @returns {number}
 */ function $c8518f0c26994259$var$coerceCode(name) {
    let code = name;
    if (typeof name === 'string') {
        if ($c8518f0c26994259$require$names[name] === undefined) throw new Error(`Unrecognized hash function named: ${name}`);
        code = $c8518f0c26994259$require$names[name];
    }
    if (typeof code !== 'number') throw new Error(`Hash function code should be a number. Got: ${code}`);
    // @ts-ignore
    if ($c8518f0c26994259$var$codes[code] === undefined && !$c8518f0c26994259$var$isAppCode(code)) throw new Error(`Unrecognized function code: ${code}`);
    return code;
}
/**
 * Checks if a code is part of the app range
 *
 * @param {number} code
 * @returns {boolean}
 */ function $c8518f0c26994259$var$isAppCode(code) {
    return code > 0 && code < 0x10;
}
/**
 * Checks whether a multihash code is valid.
 *
 * @param {HashCode} code
 * @returns {boolean}
 */ function $c8518f0c26994259$var$isValidCode(code) {
    if ($c8518f0c26994259$var$isAppCode(code)) return true;
    if ($c8518f0c26994259$var$codes[code]) return true;
    return false;
}
/**
 * Check if the given buffer is a valid multihash. Throws an error if it is not valid.
 *
 * @param {Uint8Array} multihash
 * @returns {void}
 * @throws {Error}
 */ function $c8518f0c26994259$var$validate(multihash) {
    $c8518f0c26994259$var$decode(multihash) // throws if bad.
    ;
}
/**
 * Returns a prefix from a valid multihash. Throws an error if it is not valid.
 *
 * @param {Uint8Array} multihash
 * @returns {Uint8Array}
 * @throws {Error}
 */ function $c8518f0c26994259$var$prefix(multihash) {
    $c8518f0c26994259$var$validate(multihash);
    return multihash.subarray(0, 2);
}
module.exports = {
    names: $c8518f0c26994259$require$names,
    codes: Object.freeze($c8518f0c26994259$var$codes),
    toHexString: $c8518f0c26994259$var$toHexString,
    fromHexString: $c8518f0c26994259$var$fromHexString,
    toB58String: $c8518f0c26994259$var$toB58String,
    fromB58String: $c8518f0c26994259$var$fromB58String,
    decode: $c8518f0c26994259$var$decode,
    encode: $c8518f0c26994259$var$encode,
    coerceCode: $c8518f0c26994259$var$coerceCode,
    isAppCode: $c8518f0c26994259$var$isAppCode,
    validate: $c8518f0c26994259$var$validate,
    prefix: $c8518f0c26994259$var$prefix,
    isValidCode: $c8518f0c26994259$var$isValidCode
} /**
 * @typedef { import("./constants").HashCode } HashCode
 * @typedef { import("./constants").HashName } HashName
 */ ;

});
parcelRegister("3bFLy", function(module, exports) {
/**
 * Implementation of the [multibase](https://github.com/multiformats/multibase) specification.
 *
 */ 'use strict';

var $3v55g = parcelRequire("3v55g");

var $1UdKz = parcelRequire("1UdKz");
var $2522cc0a9dabdd8a$require$encodeText = $1UdKz.encodeText;
var $2522cc0a9dabdd8a$require$decodeText = $1UdKz.decodeText;
var $2522cc0a9dabdd8a$require$concat = $1UdKz.concat;
/** @typedef {import('./base')} Base */ /** @typedef {import("./types").BaseNameOrCode} BaseNameOrCode */ /** @typedef {import("./types").BaseCode} BaseCode */ /** @typedef {import("./types").BaseName} BaseName */ /**
 * Create a new Uint8Array with the multibase varint+code.
 *
 * @param {BaseNameOrCode} nameOrCode - The multibase name or code number.
 * @param {Uint8Array} buf - The data to be prefixed with multibase.
 * @returns {Uint8Array}
 * @throws {Error} Will throw if the encoding is not supported
 */ function multibase(nameOrCode, buf) {
    if (!buf) throw new Error('requires an encoded Uint8Array');
    const { name, codeBuf } = encoding(nameOrCode);
    validEncode(name, buf);
    return $2522cc0a9dabdd8a$require$concat([
        codeBuf,
        buf
    ], codeBuf.length + buf.length);
}
/**
 * Encode data with the specified base and add the multibase prefix.
 *
 * @param {BaseNameOrCode} nameOrCode - The multibase name or code number.
 * @param {Uint8Array} buf - The data to be encoded.
 * @returns {Uint8Array}
 * @throws {Error} Will throw if the encoding is not supported
 *
 */ function encode(nameOrCode, buf) {
    const enc = encoding(nameOrCode);
    const data = $2522cc0a9dabdd8a$require$encodeText(enc.encode(buf));
    return $2522cc0a9dabdd8a$require$concat([
        enc.codeBuf,
        data
    ], enc.codeBuf.length + data.length);
}
/**
 * Takes a Uint8Array or string encoded with multibase header, decodes it and
 * returns the decoded buffer
 *
 * @param {Uint8Array|string} data
 * @returns {Uint8Array}
 * @throws {Error} Will throw if the encoding is not supported
 *
 */ function decode(data) {
    if (data instanceof Uint8Array) data = $2522cc0a9dabdd8a$require$decodeText(data);
    const prefix = data[0];
    // Make all encodings case-insensitive except the ones that include upper and lower chars in the alphabet
    if ([
        'f',
        'F',
        'v',
        'V',
        't',
        'T',
        'b',
        'B',
        'c',
        'C',
        'h',
        'k',
        'K'
    ].includes(prefix)) data = data.toLowerCase();
    const enc = encoding(/** @type {BaseCode} */ data[0]);
    return enc.decode(data.substring(1));
}
/**
 * Is the given data multibase encoded?
 *
 * @param {Uint8Array|string} data
 * @returns {false | string}
 */ function isEncoded(data) {
    if (data instanceof Uint8Array) data = $2522cc0a9dabdd8a$require$decodeText(data);
    // Ensure bufOrString is a string
    if (Object.prototype.toString.call(data) !== '[object String]') return false;
    try {
        const enc = encoding(/** @type {BaseCode} */ data[0]);
        return enc.name;
    } catch (err) {
        return false;
    }
}
/**
 * Validate encoded data
 *
 * @param {BaseNameOrCode} name
 * @param {Uint8Array} buf
 * @returns {void}
 * @throws {Error} Will throw if the encoding is not supported
 */ function validEncode(name, buf) {
    const enc = encoding(name);
    enc.decode($2522cc0a9dabdd8a$require$decodeText(buf));
}
/**
 * Get the encoding by name or code
 *
 * @param {BaseNameOrCode} nameOrCode
 * @returns {Base}
 * @throws {Error} Will throw if the encoding is not supported
 */ function encoding(nameOrCode) {
    if (Object.prototype.hasOwnProperty.call($3v55g.names, /** @type {BaseName} */ nameOrCode)) return $3v55g.names[/** @type {BaseName} */ nameOrCode];
    else if (Object.prototype.hasOwnProperty.call($3v55g.codes, /** @type {BaseCode} */ nameOrCode)) return $3v55g.codes[/** @type {BaseCode} */ nameOrCode];
    else throw new Error(`Unsupported encoding: ${nameOrCode}`);
}
/**
 * Get encoding from data
 *
 * @param {string|Uint8Array} data
 * @returns {Base}
 * @throws {Error} Will throw if the encoding is not supported
 */ function encodingFromData(data) {
    if (data instanceof Uint8Array) data = $2522cc0a9dabdd8a$require$decodeText(data);
    return encoding(/** @type {BaseCode} */ data[0]);
}
exports = module.exports = multibase;
exports.encode = encode;
exports.decode = decode;
exports.isEncoded = isEncoded;
exports.encoding = encoding;
exports.encodingFromData = encodingFromData;
exports.names = Object.freeze($3v55g.names);
exports.codes = Object.freeze($3v55g.codes);

});
parcelRegister("3v55g", function(module, exports) {
'use strict';

var $7m1F1 = parcelRequire("7m1F1");

var $d3Wj3 = parcelRequire("d3Wj3");

var $uyyW1 = parcelRequire("uyyW1");
var $28c835e139e8e77c$require$rfc4648 = $uyyW1.rfc4648;

var $1UdKz = parcelRequire("1UdKz");
var $28c835e139e8e77c$require$decodeText = $1UdKz.decodeText;
var $28c835e139e8e77c$require$encodeText = $1UdKz.encodeText;
/** @typedef {import('./types').CodecFactory} CodecFactory */ /** @typedef {import('./types').Codec} Codec */ /** @typedef {import('./types').BaseName} BaseName */ /** @typedef {import('./types').BaseCode} BaseCode */ /** @type {CodecFactory} */ const $28c835e139e8e77c$var$identity = ()=>{
    return {
        encode: $28c835e139e8e77c$require$decodeText,
        decode: $28c835e139e8e77c$require$encodeText
    };
};
/**
 *
 * name, code, implementation, alphabet
 *
 * @type {Array<[BaseName, BaseCode, CodecFactory, string]>}
 */ const $28c835e139e8e77c$var$constants = [
    [
        'identity',
        '\x00',
        $28c835e139e8e77c$var$identity,
        ''
    ],
    [
        'base2',
        '0',
        $28c835e139e8e77c$require$rfc4648(1),
        '01'
    ],
    [
        'base8',
        '7',
        $28c835e139e8e77c$require$rfc4648(3),
        '01234567'
    ],
    [
        'base10',
        '9',
        $7m1F1,
        '0123456789'
    ],
    [
        'base16',
        'f',
        $28c835e139e8e77c$require$rfc4648(4),
        '0123456789abcdef'
    ],
    [
        'base16upper',
        'F',
        $28c835e139e8e77c$require$rfc4648(4),
        '0123456789ABCDEF'
    ],
    [
        'base32hex',
        'v',
        $28c835e139e8e77c$require$rfc4648(5),
        '0123456789abcdefghijklmnopqrstuv'
    ],
    [
        'base32hexupper',
        'V',
        $28c835e139e8e77c$require$rfc4648(5),
        '0123456789ABCDEFGHIJKLMNOPQRSTUV'
    ],
    [
        'base32hexpad',
        't',
        $28c835e139e8e77c$require$rfc4648(5),
        '0123456789abcdefghijklmnopqrstuv='
    ],
    [
        'base32hexpadupper',
        'T',
        $28c835e139e8e77c$require$rfc4648(5),
        '0123456789ABCDEFGHIJKLMNOPQRSTUV='
    ],
    [
        'base32',
        'b',
        $28c835e139e8e77c$require$rfc4648(5),
        'abcdefghijklmnopqrstuvwxyz234567'
    ],
    [
        'base32upper',
        'B',
        $28c835e139e8e77c$require$rfc4648(5),
        'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567'
    ],
    [
        'base32pad',
        'c',
        $28c835e139e8e77c$require$rfc4648(5),
        'abcdefghijklmnopqrstuvwxyz234567='
    ],
    [
        'base32padupper',
        'C',
        $28c835e139e8e77c$require$rfc4648(5),
        'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567='
    ],
    [
        'base32z',
        'h',
        $28c835e139e8e77c$require$rfc4648(5),
        'ybndrfg8ejkmcpqxot1uwisza345h769'
    ],
    [
        'base36',
        'k',
        $7m1F1,
        '0123456789abcdefghijklmnopqrstuvwxyz'
    ],
    [
        'base36upper',
        'K',
        $7m1F1,
        '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ'
    ],
    [
        'base58btc',
        'z',
        $7m1F1,
        '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz'
    ],
    [
        'base58flickr',
        'Z',
        $7m1F1,
        '123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ'
    ],
    [
        'base64',
        'm',
        $28c835e139e8e77c$require$rfc4648(6),
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
    ],
    [
        'base64pad',
        'M',
        $28c835e139e8e77c$require$rfc4648(6),
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
    ],
    [
        'base64url',
        'u',
        $28c835e139e8e77c$require$rfc4648(6),
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_'
    ],
    [
        'base64urlpad',
        'U',
        $28c835e139e8e77c$require$rfc4648(6),
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_='
    ]
];
/** @type {Record<BaseName,Base>} */ const $28c835e139e8e77c$var$names = $28c835e139e8e77c$var$constants.reduce((prev, tupple)=>{
    prev[tupple[0]] = new $d3Wj3(tupple[0], tupple[1], tupple[2], tupple[3]);
    return prev;
}, /** @type {Record<BaseName,Base>} */ {});
/** @type {Record<BaseCode,Base>} */ const $28c835e139e8e77c$var$codes = $28c835e139e8e77c$var$constants.reduce((prev, tupple)=>{
    prev[tupple[1]] = $28c835e139e8e77c$var$names[tupple[0]];
    return prev;
}, /** @type {Record<BaseCode,Base>} */ {});
module.exports = {
    names: $28c835e139e8e77c$var$names,
    codes: $28c835e139e8e77c$var$codes
};

});
parcelRegister("7m1F1", function(module, exports) {
'use strict';
// base-x encoding / decoding
// Copyright (c) 2018 base-x contributors
// Copyright (c) 2014-2018 The Bitcoin Core developers (base58.cpp)
// Distributed under the MIT software license, see the accompanying
// file LICENSE or http://www.opensource.org/licenses/mit-license.php.
function $55abe0448d40c1ed$var$base(ALPHABET) {
    if (ALPHABET.length >= 255) throw new TypeError('Alphabet too long');
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + ' is ambiguous');
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256) // log(BASE) / log(256), rounded up
    ;
    var iFACTOR = Math.log(256) / Math.log(BASE) // log(256) / log(BASE), rounded up
    ;
    function encode(source) {
        if (source instanceof Uint8Array) ;
        else if (ArrayBuffer.isView(source)) source = new Uint8Array(source.buffer, source.byteOffset, source.byteLength);
        else if (Array.isArray(source)) source = Uint8Array.from(source);
        if (!(source instanceof Uint8Array)) throw new TypeError('Expected Uint8Array');
        if (source.length === 0) return '';
        // Skip & count leading zeroes.
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        // Allocate enough space in big-endian base58 representation.
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        // Process the bytes.
        while(pbegin !== pend){
            var carry = source[pbegin];
            // Apply "b58 = b58 * 256 + ch".
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error('Non-zero carry');
            length = i;
            pbegin++;
        }
        // Skip leading zeroes in base58 result.
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        // Translate the result into a string.
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== 'string') throw new TypeError('Expected String');
        if (source.length === 0) return new Uint8Array();
        var psz = 0;
        // Skip leading spaces.
        if (source[psz] === ' ') return;
        // Skip and count leading '1's.
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        // Allocate enough space in big-endian base256 representation.
        var size = (source.length - psz) * FACTOR + 1 >>> 0 // log(58) / log(256), rounded up.
        ;
        var b256 = new Uint8Array(size);
        // Process the characters.
        while(source[psz]){
            // Decode character
            var carry = BASE_MAP[source.charCodeAt(psz)];
            // Invalid character
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error('Non-zero carry');
            length = i;
            psz++;
        }
        // Skip trailing spaces.
        if (source[psz] === ' ') return;
        // Skip leading zeroes in b256.
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = new Uint8Array(zeroes + (size - it4));
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error('Non-base' + BASE + ' character');
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
module.exports = $55abe0448d40c1ed$var$base;

});

parcelRegister("d3Wj3", function(module, exports) {
'use strict';

var $1UdKz = parcelRequire("1UdKz");
var $9828c89444f0abac$require$encodeText = $1UdKz.encodeText;
/** @typedef {import('./types').CodecFactory} CodecFactory */ /** @typedef {import("./types").BaseName} BaseName */ /** @typedef {import("./types").BaseCode} BaseCode */ /**
 * Class to encode/decode in the supported Bases
 *
 */ class $9828c89444f0abac$var$Base {
    /**
   * @param {BaseName} name
   * @param {BaseCode} code
   * @param {CodecFactory} factory
   * @param {string} alphabet
   */ constructor(name, code, factory, alphabet){
        this.name = name;
        this.code = code;
        this.codeBuf = $9828c89444f0abac$require$encodeText(this.code);
        this.alphabet = alphabet;
        this.codec = factory(alphabet);
    }
    /**
   * @param {Uint8Array} buf
   * @returns {string}
   */ encode(buf) {
        return this.codec.encode(buf);
    }
    /**
   * @param {string} string
   * @returns {Uint8Array}
   */ decode(string) {
        for (const char of string){
            if (this.alphabet && this.alphabet.indexOf(char) < 0) throw new Error(`invalid character '${char}' in '${string}'`);
        }
        return this.codec.decode(string);
    }
}
module.exports = $9828c89444f0abac$var$Base;

});
parcelRegister("1UdKz", function(module, exports) {
'use strict';

var $l1lTW = parcelRequire("l1lTW");
var $1635afe7ad1d6a30$require$TextEncoder = $l1lTW.TextEncoder;
var $1635afe7ad1d6a30$require$TextDecoder = $l1lTW.TextDecoder;
const $1635afe7ad1d6a30$var$textDecoder = new $1635afe7ad1d6a30$require$TextDecoder();
/**
 * @param {ArrayBufferView|ArrayBuffer} bytes
 * @returns {string}
 */ const $1635afe7ad1d6a30$var$decodeText = (bytes)=>$1635afe7ad1d6a30$var$textDecoder.decode(bytes);
const $1635afe7ad1d6a30$var$textEncoder = new $1635afe7ad1d6a30$require$TextEncoder();
/**
 * @param {string} text
 * @returns {Uint8Array}
 */ const $1635afe7ad1d6a30$var$encodeText = (text)=>$1635afe7ad1d6a30$var$textEncoder.encode(text);
/**
 * Returns a new Uint8Array created by concatenating the passed Arrays
 *
 * @param {Array<ArrayLike<number>>} arrs
 * @param {number} length
 * @returns {Uint8Array}
 */ function $1635afe7ad1d6a30$var$concat(arrs, length) {
    const output = new Uint8Array(length);
    let offset = 0;
    for (const arr of arrs){
        output.set(arr, offset);
        offset += arr.length;
    }
    return output;
}
module.exports = {
    decodeText: $1635afe7ad1d6a30$var$decodeText,
    encodeText: $1635afe7ad1d6a30$var$encodeText,
    concat: $1635afe7ad1d6a30$var$concat
};

});
parcelRegister("l1lTW", function(module, exports) {

$parcel$export(module.exports, "TextEncoder", function () { return $f4daae1f784d5561$export$88fb0cfd153261a7; }, function (v) { return $f4daae1f784d5561$export$88fb0cfd153261a7 = v; });
$parcel$export(module.exports, "TextDecoder", function () { return $f4daae1f784d5561$export$9c6b53e35bc51b5c; }, function (v) { return $f4daae1f784d5561$export$9c6b53e35bc51b5c = v; });
var $f4daae1f784d5561$export$88fb0cfd153261a7;
var $f4daae1f784d5561$export$9c6b53e35bc51b5c;
"use strict";

$f4daae1f784d5561$export$88fb0cfd153261a7 = typeof TextEncoder !== "undefined" ? TextEncoder : (parcelRequire("ennut")).TextEncoder;

$f4daae1f784d5561$export$9c6b53e35bc51b5c = typeof TextDecoder !== "undefined" ? TextDecoder : (parcelRequire("ennut")).TextDecoder;

});
parcelRegister("ennut", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $fZVRp = parcelRequire("fZVRp");
var $a7756f67f9b306e8$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $a7756f67f9b306e8$var$formatRegExp = /%[sdj%]/g;
module.exports.format = function(f) {
    if (!$a7756f67f9b306e8$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($a7756f67f9b306e8$var$inspect(arguments[i]));
        return objects.join(' ');
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($a7756f67f9b306e8$var$formatRegExp, function(x) {
        if (x === '%%') return '%';
        if (i >= len) return x;
        switch(x){
            case '%s':
                return String(args[i++]);
            case '%d':
                return Number(args[i++]);
            case '%j':
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return '[Circular]';
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($a7756f67f9b306e8$var$isNull(x) || !$a7756f67f9b306e8$var$isObject(x)) str += ' ' + x;
    else str += ' ' + $a7756f67f9b306e8$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
module.exports.deprecate = function(fn, msg) {
    var warned;
    return function() {
        return module.exports.deprecate(fn, msg).apply(this, arguments);
    };
    function deprecated() {
        if (!warned) {
            if ($fZVRp.throwDeprecation) throw new Error(msg);
            else if ($fZVRp.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
};
var $a7756f67f9b306e8$var$debugs = {};
var $a7756f67f9b306e8$var$debugEnvRegex = /^$/;
var $a7756f67f9b306e8$var$debugEnv;
module.exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$a7756f67f9b306e8$var$debugs[set]) {
        if ($a7756f67f9b306e8$var$debugEnvRegex.test(set)) {
            var pid = $fZVRp.pid;
            $a7756f67f9b306e8$var$debugs[set] = function() {
                var msg = module.exports.format.apply(module.exports, arguments);
                console.error('%s %d: %s', set, pid, msg);
            };
        } else $a7756f67f9b306e8$var$debugs[set] = function() {};
    }
    return $a7756f67f9b306e8$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $a7756f67f9b306e8$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $a7756f67f9b306e8$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($a7756f67f9b306e8$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    module.exports._extend(ctx, opts);
    // set default options
    if ($a7756f67f9b306e8$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($a7756f67f9b306e8$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($a7756f67f9b306e8$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($a7756f67f9b306e8$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $a7756f67f9b306e8$var$stylizeWithColor;
    return $a7756f67f9b306e8$var$formatValue(ctx, obj, ctx.depth);
}
module.exports.inspect = $a7756f67f9b306e8$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$a7756f67f9b306e8$var$inspect.colors = {
    'bold': [
        1,
        22
    ],
    'italic': [
        3,
        23
    ],
    'underline': [
        4,
        24
    ],
    'inverse': [
        7,
        27
    ],
    'white': [
        37,
        39
    ],
    'grey': [
        90,
        39
    ],
    'black': [
        30,
        39
    ],
    'blue': [
        34,
        39
    ],
    'cyan': [
        36,
        39
    ],
    'green': [
        32,
        39
    ],
    'magenta': [
        35,
        39
    ],
    'red': [
        31,
        39
    ],
    'yellow': [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$a7756f67f9b306e8$var$inspect.styles = {
    'special': 'cyan',
    'number': 'yellow',
    'boolean': 'yellow',
    'undefined': 'grey',
    'null': 'bold',
    'string': 'green',
    'date': 'magenta',
    // "name": intentionally not styling
    'regexp': 'red'
};
function $a7756f67f9b306e8$var$stylizeWithColor(str, styleType) {
    var style = $a7756f67f9b306e8$var$inspect.styles[styleType];
    if (style) return '\u001b[' + $a7756f67f9b306e8$var$inspect.colors[style][0] + 'm' + str + '\u001b[' + $a7756f67f9b306e8$var$inspect.colors[style][1] + 'm';
    else return str;
}
function $a7756f67f9b306e8$var$stylizeNoColor(str, styleType) {
    return str;
}
function $a7756f67f9b306e8$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $a7756f67f9b306e8$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $a7756f67f9b306e8$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== module.exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$a7756f67f9b306e8$var$isString(ret)) ret = $a7756f67f9b306e8$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $a7756f67f9b306e8$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $a7756f67f9b306e8$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($a7756f67f9b306e8$var$isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) return $a7756f67f9b306e8$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($a7756f67f9b306e8$var$isFunction(value)) {
            var name = value.name ? ': ' + value.name : '';
            return ctx.stylize('[Function' + name + ']', 'special');
        }
        if ($a7756f67f9b306e8$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        if ($a7756f67f9b306e8$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), 'date');
        if ($a7756f67f9b306e8$var$isError(value)) return $a7756f67f9b306e8$var$formatError(value);
    }
    var base = '', array = false, braces = [
        '{',
        '}'
    ];
    // Make Array say that they are Array
    if ($a7756f67f9b306e8$var$isArray(value)) {
        array = true;
        braces = [
            '[',
            ']'
        ];
    }
    // Make functions say that they are functions
    if ($a7756f67f9b306e8$var$isFunction(value)) {
        var n = value.name ? ': ' + value.name : '';
        base = ' [Function' + n + ']';
    }
    // Make RegExps say that they are RegExps
    if ($a7756f67f9b306e8$var$isRegExp(value)) base = ' ' + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($a7756f67f9b306e8$var$isDate(value)) base = ' ' + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($a7756f67f9b306e8$var$isError(value)) base = ' ' + $a7756f67f9b306e8$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($a7756f67f9b306e8$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        else return ctx.stylize('[Object]', 'special');
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $a7756f67f9b306e8$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $a7756f67f9b306e8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $a7756f67f9b306e8$var$reduceToSingleString(output, base, braces);
}
function $a7756f67f9b306e8$var$formatPrimitive(ctx, value) {
    if ($a7756f67f9b306e8$var$isUndefined(value)) return ctx.stylize('undefined', 'undefined');
    if ($a7756f67f9b306e8$var$isString(value)) {
        var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
        return ctx.stylize(simple, 'string');
    }
    if ($a7756f67f9b306e8$var$isNumber(value)) return ctx.stylize('' + value, 'number');
    if ($a7756f67f9b306e8$var$isBoolean(value)) return ctx.stylize('' + value, 'boolean');
    // For some reason typeof null is "object", so special case here.
    if ($a7756f67f9b306e8$var$isNull(value)) return ctx.stylize('null', 'null');
}
function $a7756f67f9b306e8$var$formatError(value) {
    return '[' + Error.prototype.toString.call(value) + ']';
}
function $a7756f67f9b306e8$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($a7756f67f9b306e8$var$hasOwnProperty(value, String(i))) output.push($a7756f67f9b306e8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push('');
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($a7756f67f9b306e8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $a7756f67f9b306e8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize('[Getter/Setter]', 'special');
        else str = ctx.stylize('[Getter]', 'special');
    } else if (desc.set) str = ctx.stylize('[Setter]', 'special');
    if (!$a7756f67f9b306e8$var$hasOwnProperty(visibleKeys, key)) name = '[' + key + ']';
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($a7756f67f9b306e8$var$isNull(recurseTimes)) str = $a7756f67f9b306e8$var$formatValue(ctx, desc.value, null);
            else str = $a7756f67f9b306e8$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf('\n') > -1) {
                if (array) str = str.split('\n').map(function(line) {
                    return '  ' + line;
                }).join('\n').slice(2);
                else str = '\n' + str.split('\n').map(function(line) {
                    return '   ' + line;
                }).join('\n');
            }
        } else str = ctx.stylize('[Circular]', 'special');
    }
    if ($a7756f67f9b306e8$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify('' + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, 'name');
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, 'string');
        }
    }
    return name + ': ' + str;
}
function $a7756f67f9b306e8$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf('\n') >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
    return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
module.exports.types = (parcelRequire("lp8P9"));
function $a7756f67f9b306e8$var$isArray(ar) {
    return Array.isArray(ar);
}
module.exports.isArray = $a7756f67f9b306e8$var$isArray;
function $a7756f67f9b306e8$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
module.exports.isBoolean = $a7756f67f9b306e8$var$isBoolean;
function $a7756f67f9b306e8$var$isNull(arg) {
    return arg === null;
}
module.exports.isNull = $a7756f67f9b306e8$var$isNull;
function $a7756f67f9b306e8$var$isNullOrUndefined(arg) {
    return arg == null;
}
module.exports.isNullOrUndefined = $a7756f67f9b306e8$var$isNullOrUndefined;
function $a7756f67f9b306e8$var$isNumber(arg) {
    return typeof arg === 'number';
}
module.exports.isNumber = $a7756f67f9b306e8$var$isNumber;
function $a7756f67f9b306e8$var$isString(arg) {
    return typeof arg === 'string';
}
module.exports.isString = $a7756f67f9b306e8$var$isString;
function $a7756f67f9b306e8$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
module.exports.isSymbol = $a7756f67f9b306e8$var$isSymbol;
function $a7756f67f9b306e8$var$isUndefined(arg) {
    return arg === void 0;
}
module.exports.isUndefined = $a7756f67f9b306e8$var$isUndefined;
function $a7756f67f9b306e8$var$isRegExp(re) {
    return $a7756f67f9b306e8$var$isObject(re) && $a7756f67f9b306e8$var$objectToString(re) === '[object RegExp]';
}
module.exports.isRegExp = $a7756f67f9b306e8$var$isRegExp;
module.exports.types.isRegExp = $a7756f67f9b306e8$var$isRegExp;
function $a7756f67f9b306e8$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
module.exports.isObject = $a7756f67f9b306e8$var$isObject;
function $a7756f67f9b306e8$var$isDate(d) {
    return $a7756f67f9b306e8$var$isObject(d) && $a7756f67f9b306e8$var$objectToString(d) === '[object Date]';
}
module.exports.isDate = $a7756f67f9b306e8$var$isDate;
module.exports.types.isDate = $a7756f67f9b306e8$var$isDate;
function $a7756f67f9b306e8$var$isError(e) {
    return $a7756f67f9b306e8$var$isObject(e) && ($a7756f67f9b306e8$var$objectToString(e) === '[object Error]' || e instanceof Error);
}
module.exports.isError = $a7756f67f9b306e8$var$isError;
module.exports.types.isNativeError = $a7756f67f9b306e8$var$isError;
function $a7756f67f9b306e8$var$isFunction(arg) {
    return typeof arg === 'function';
}
module.exports.isFunction = $a7756f67f9b306e8$var$isFunction;
function $a7756f67f9b306e8$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
module.exports.isPrimitive = $a7756f67f9b306e8$var$isPrimitive;

module.exports.isBuffer = (parcelRequire("1ec4D"));
function $a7756f67f9b306e8$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $a7756f67f9b306e8$var$pad(n) {
    return n < 10 ? '0' + n.toString(10) : n.toString(10);
}
var $a7756f67f9b306e8$var$months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
// 26 Feb 16:19:34
function $a7756f67f9b306e8$var$timestamp() {
    var d = new Date();
    var time = [
        $a7756f67f9b306e8$var$pad(d.getHours()),
        $a7756f67f9b306e8$var$pad(d.getMinutes()),
        $a7756f67f9b306e8$var$pad(d.getSeconds())
    ].join(':');
    return [
        d.getDate(),
        $a7756f67f9b306e8$var$months[d.getMonth()],
        time
    ].join(' ');
}
// log is just a thin wrapper to console.log that prepends a timestamp
module.exports.log = function() {
    console.log('%s - %s', $a7756f67f9b306e8$var$timestamp(), module.exports.format.apply(module.exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ module.exports.inherits = (parcelRequire("fvL6U"));
module.exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$a7756f67f9b306e8$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $a7756f67f9b306e8$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $a7756f67f9b306e8$var$kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;
module.exports.promisify = function promisify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    if ($a7756f67f9b306e8$var$kCustomPromisifiedSymbol && original[$a7756f67f9b306e8$var$kCustomPromisifiedSymbol]) {
        var fn = original[$a7756f67f9b306e8$var$kCustomPromisifiedSymbol];
        if (typeof fn !== 'function') throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $a7756f67f9b306e8$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($a7756f67f9b306e8$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $a7756f67f9b306e8$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $a7756f67f9b306e8$var$getOwnPropertyDescriptors(original));
};
module.exports.promisify.custom = $a7756f67f9b306e8$var$kCustomPromisifiedSymbol;
function $a7756f67f9b306e8$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error('Promise was rejected with a falsy value');
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $a7756f67f9b306e8$var$callbackify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== 'function') throw new TypeError('The last argument must be of type Function');
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $fZVRp.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $fZVRp.nextTick($a7756f67f9b306e8$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $a7756f67f9b306e8$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
module.exports.callbackify = $a7756f67f9b306e8$var$callbackify;

});
parcelRegister("fZVRp", function(module, exports) {
// shim for using process in browser
var $ba596f6607e75a63$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $ba596f6607e75a63$var$cachedSetTimeout;
var $ba596f6607e75a63$var$cachedClearTimeout;
function $ba596f6607e75a63$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $ba596f6607e75a63$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $ba596f6607e75a63$var$cachedSetTimeout = setTimeout;
        else $ba596f6607e75a63$var$cachedSetTimeout = $ba596f6607e75a63$var$defaultSetTimout;
    } catch (e) {
        $ba596f6607e75a63$var$cachedSetTimeout = $ba596f6607e75a63$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $ba596f6607e75a63$var$cachedClearTimeout = clearTimeout;
        else $ba596f6607e75a63$var$cachedClearTimeout = $ba596f6607e75a63$var$defaultClearTimeout;
    } catch (e) {
        $ba596f6607e75a63$var$cachedClearTimeout = $ba596f6607e75a63$var$defaultClearTimeout;
    }
})();
function $ba596f6607e75a63$var$runTimeout(fun) {
    if ($ba596f6607e75a63$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($ba596f6607e75a63$var$cachedSetTimeout === $ba596f6607e75a63$var$defaultSetTimout || !$ba596f6607e75a63$var$cachedSetTimeout) && setTimeout) {
        $ba596f6607e75a63$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $ba596f6607e75a63$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $ba596f6607e75a63$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $ba596f6607e75a63$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $ba596f6607e75a63$var$runClearTimeout(marker) {
    if ($ba596f6607e75a63$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($ba596f6607e75a63$var$cachedClearTimeout === $ba596f6607e75a63$var$defaultClearTimeout || !$ba596f6607e75a63$var$cachedClearTimeout) && clearTimeout) {
        $ba596f6607e75a63$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $ba596f6607e75a63$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $ba596f6607e75a63$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $ba596f6607e75a63$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $ba596f6607e75a63$var$queue = [];
var $ba596f6607e75a63$var$draining = false;
var $ba596f6607e75a63$var$currentQueue;
var $ba596f6607e75a63$var$queueIndex = -1;
function $ba596f6607e75a63$var$cleanUpNextTick() {
    if (!$ba596f6607e75a63$var$draining || !$ba596f6607e75a63$var$currentQueue) return;
    $ba596f6607e75a63$var$draining = false;
    if ($ba596f6607e75a63$var$currentQueue.length) $ba596f6607e75a63$var$queue = $ba596f6607e75a63$var$currentQueue.concat($ba596f6607e75a63$var$queue);
    else $ba596f6607e75a63$var$queueIndex = -1;
    if ($ba596f6607e75a63$var$queue.length) $ba596f6607e75a63$var$drainQueue();
}
function $ba596f6607e75a63$var$drainQueue() {
    if ($ba596f6607e75a63$var$draining) return;
    var timeout = $ba596f6607e75a63$var$runTimeout($ba596f6607e75a63$var$cleanUpNextTick);
    $ba596f6607e75a63$var$draining = true;
    var len = $ba596f6607e75a63$var$queue.length;
    while(len){
        $ba596f6607e75a63$var$currentQueue = $ba596f6607e75a63$var$queue;
        $ba596f6607e75a63$var$queue = [];
        while(++$ba596f6607e75a63$var$queueIndex < len)if ($ba596f6607e75a63$var$currentQueue) $ba596f6607e75a63$var$currentQueue[$ba596f6607e75a63$var$queueIndex].run();
        $ba596f6607e75a63$var$queueIndex = -1;
        len = $ba596f6607e75a63$var$queue.length;
    }
    $ba596f6607e75a63$var$currentQueue = null;
    $ba596f6607e75a63$var$draining = false;
    $ba596f6607e75a63$var$runClearTimeout(timeout);
}
$ba596f6607e75a63$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $ba596f6607e75a63$var$queue.push(new $ba596f6607e75a63$var$Item(fun, args));
    if ($ba596f6607e75a63$var$queue.length === 1 && !$ba596f6607e75a63$var$draining) $ba596f6607e75a63$var$runTimeout($ba596f6607e75a63$var$drainQueue);
};
// v8 likes predictible objects
function $ba596f6607e75a63$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$ba596f6607e75a63$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$ba596f6607e75a63$var$process.title = 'browser';
$ba596f6607e75a63$var$process.browser = true;
$ba596f6607e75a63$var$process.env = {};
$ba596f6607e75a63$var$process.argv = [];
$ba596f6607e75a63$var$process.version = ''; // empty string to avoid regexp issues
$ba596f6607e75a63$var$process.versions = {};
function $ba596f6607e75a63$var$noop() {}
$ba596f6607e75a63$var$process.on = $ba596f6607e75a63$var$noop;
$ba596f6607e75a63$var$process.addListener = $ba596f6607e75a63$var$noop;
$ba596f6607e75a63$var$process.once = $ba596f6607e75a63$var$noop;
$ba596f6607e75a63$var$process.off = $ba596f6607e75a63$var$noop;
$ba596f6607e75a63$var$process.removeListener = $ba596f6607e75a63$var$noop;
$ba596f6607e75a63$var$process.removeAllListeners = $ba596f6607e75a63$var$noop;
$ba596f6607e75a63$var$process.emit = $ba596f6607e75a63$var$noop;
$ba596f6607e75a63$var$process.prependListener = $ba596f6607e75a63$var$noop;
$ba596f6607e75a63$var$process.prependOnceListener = $ba596f6607e75a63$var$noop;
$ba596f6607e75a63$var$process.listeners = function(name) {
    return [];
};
$ba596f6607e75a63$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$ba596f6607e75a63$var$process.cwd = function() {
    return '/';
};
$ba596f6607e75a63$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$ba596f6607e75a63$var$process.umask = function() {
    return 0;
};

});

parcelRegister("lp8P9", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';

var $9WLgc = parcelRequire("9WLgc");

var $fd7v8 = parcelRequire("fd7v8");

var $bC4MU = parcelRequire("bC4MU");

var $i9pTi = parcelRequire("i9pTi");
function $f952c70f2aa835f6$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $f952c70f2aa835f6$var$BigIntSupported = typeof BigInt !== 'undefined';
var $f952c70f2aa835f6$var$SymbolSupported = typeof Symbol !== 'undefined';
var $f952c70f2aa835f6$var$ObjectToString = $f952c70f2aa835f6$var$uncurryThis(Object.prototype.toString);
var $f952c70f2aa835f6$var$numberValue = $f952c70f2aa835f6$var$uncurryThis(Number.prototype.valueOf);
var $f952c70f2aa835f6$var$stringValue = $f952c70f2aa835f6$var$uncurryThis(String.prototype.valueOf);
var $f952c70f2aa835f6$var$booleanValue = $f952c70f2aa835f6$var$uncurryThis(Boolean.prototype.valueOf);
if ($f952c70f2aa835f6$var$BigIntSupported) var $f952c70f2aa835f6$var$bigIntValue = $f952c70f2aa835f6$var$uncurryThis(BigInt.prototype.valueOf);
if ($f952c70f2aa835f6$var$SymbolSupported) var $f952c70f2aa835f6$var$symbolValue = $f952c70f2aa835f6$var$uncurryThis(Symbol.prototype.valueOf);
function $f952c70f2aa835f6$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== 'object') return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $9WLgc;
module.exports.isGeneratorFunction = $fd7v8;
module.exports.isTypedArray = $i9pTi;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $f952c70f2aa835f6$var$isPromise(input) {
    return typeof Promise !== 'undefined' && input instanceof Promise || input !== null && typeof input === 'object' && typeof input.then === 'function' && typeof input.catch === 'function';
}
module.exports.isPromise = $f952c70f2aa835f6$var$isPromise;
function $f952c70f2aa835f6$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $i9pTi(value) || $f952c70f2aa835f6$var$isDataView(value);
}
module.exports.isArrayBufferView = $f952c70f2aa835f6$var$isArrayBufferView;
function $f952c70f2aa835f6$var$isUint8Array(value) {
    return $bC4MU(value) === 'Uint8Array';
}
module.exports.isUint8Array = $f952c70f2aa835f6$var$isUint8Array;
function $f952c70f2aa835f6$var$isUint8ClampedArray(value) {
    return $bC4MU(value) === 'Uint8ClampedArray';
}
module.exports.isUint8ClampedArray = $f952c70f2aa835f6$var$isUint8ClampedArray;
function $f952c70f2aa835f6$var$isUint16Array(value) {
    return $bC4MU(value) === 'Uint16Array';
}
module.exports.isUint16Array = $f952c70f2aa835f6$var$isUint16Array;
function $f952c70f2aa835f6$var$isUint32Array(value) {
    return $bC4MU(value) === 'Uint32Array';
}
module.exports.isUint32Array = $f952c70f2aa835f6$var$isUint32Array;
function $f952c70f2aa835f6$var$isInt8Array(value) {
    return $bC4MU(value) === 'Int8Array';
}
module.exports.isInt8Array = $f952c70f2aa835f6$var$isInt8Array;
function $f952c70f2aa835f6$var$isInt16Array(value) {
    return $bC4MU(value) === 'Int16Array';
}
module.exports.isInt16Array = $f952c70f2aa835f6$var$isInt16Array;
function $f952c70f2aa835f6$var$isInt32Array(value) {
    return $bC4MU(value) === 'Int32Array';
}
module.exports.isInt32Array = $f952c70f2aa835f6$var$isInt32Array;
function $f952c70f2aa835f6$var$isFloat32Array(value) {
    return $bC4MU(value) === 'Float32Array';
}
module.exports.isFloat32Array = $f952c70f2aa835f6$var$isFloat32Array;
function $f952c70f2aa835f6$var$isFloat64Array(value) {
    return $bC4MU(value) === 'Float64Array';
}
module.exports.isFloat64Array = $f952c70f2aa835f6$var$isFloat64Array;
function $f952c70f2aa835f6$var$isBigInt64Array(value) {
    return $bC4MU(value) === 'BigInt64Array';
}
module.exports.isBigInt64Array = $f952c70f2aa835f6$var$isBigInt64Array;
function $f952c70f2aa835f6$var$isBigUint64Array(value) {
    return $bC4MU(value) === 'BigUint64Array';
}
module.exports.isBigUint64Array = $f952c70f2aa835f6$var$isBigUint64Array;
function $f952c70f2aa835f6$var$isMapToString(value) {
    return $f952c70f2aa835f6$var$ObjectToString(value) === '[object Map]';
}
$f952c70f2aa835f6$var$isMapToString.working = typeof Map !== 'undefined' && $f952c70f2aa835f6$var$isMapToString(new Map());
function $f952c70f2aa835f6$var$isMap(value) {
    if (typeof Map === 'undefined') return false;
    return $f952c70f2aa835f6$var$isMapToString.working ? $f952c70f2aa835f6$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $f952c70f2aa835f6$var$isMap;
function $f952c70f2aa835f6$var$isSetToString(value) {
    return $f952c70f2aa835f6$var$ObjectToString(value) === '[object Set]';
}
$f952c70f2aa835f6$var$isSetToString.working = typeof Set !== 'undefined' && $f952c70f2aa835f6$var$isSetToString(new Set());
function $f952c70f2aa835f6$var$isSet(value) {
    if (typeof Set === 'undefined') return false;
    return $f952c70f2aa835f6$var$isSetToString.working ? $f952c70f2aa835f6$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $f952c70f2aa835f6$var$isSet;
function $f952c70f2aa835f6$var$isWeakMapToString(value) {
    return $f952c70f2aa835f6$var$ObjectToString(value) === '[object WeakMap]';
}
$f952c70f2aa835f6$var$isWeakMapToString.working = typeof WeakMap !== 'undefined' && $f952c70f2aa835f6$var$isWeakMapToString(new WeakMap());
function $f952c70f2aa835f6$var$isWeakMap(value) {
    if (typeof WeakMap === 'undefined') return false;
    return $f952c70f2aa835f6$var$isWeakMapToString.working ? $f952c70f2aa835f6$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $f952c70f2aa835f6$var$isWeakMap;
function $f952c70f2aa835f6$var$isWeakSetToString(value) {
    return $f952c70f2aa835f6$var$ObjectToString(value) === '[object WeakSet]';
}
$f952c70f2aa835f6$var$isWeakSetToString.working = typeof WeakSet !== 'undefined' && $f952c70f2aa835f6$var$isWeakSetToString(new WeakSet());
function $f952c70f2aa835f6$var$isWeakSet(value) {
    return $f952c70f2aa835f6$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $f952c70f2aa835f6$var$isWeakSet;
function $f952c70f2aa835f6$var$isArrayBufferToString(value) {
    return $f952c70f2aa835f6$var$ObjectToString(value) === '[object ArrayBuffer]';
}
$f952c70f2aa835f6$var$isArrayBufferToString.working = typeof ArrayBuffer !== 'undefined' && $f952c70f2aa835f6$var$isArrayBufferToString(new ArrayBuffer());
function $f952c70f2aa835f6$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === 'undefined') return false;
    return $f952c70f2aa835f6$var$isArrayBufferToString.working ? $f952c70f2aa835f6$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $f952c70f2aa835f6$var$isArrayBuffer;
function $f952c70f2aa835f6$var$isDataViewToString(value) {
    return $f952c70f2aa835f6$var$ObjectToString(value) === '[object DataView]';
}
$f952c70f2aa835f6$var$isDataViewToString.working = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined' && $f952c70f2aa835f6$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $f952c70f2aa835f6$var$isDataView(value) {
    if (typeof DataView === 'undefined') return false;
    return $f952c70f2aa835f6$var$isDataViewToString.working ? $f952c70f2aa835f6$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $f952c70f2aa835f6$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $f952c70f2aa835f6$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
function $f952c70f2aa835f6$var$isSharedArrayBufferToString(value) {
    return $f952c70f2aa835f6$var$ObjectToString(value) === '[object SharedArrayBuffer]';
}
function $f952c70f2aa835f6$var$isSharedArrayBuffer(value) {
    if (typeof $f952c70f2aa835f6$var$SharedArrayBufferCopy === 'undefined') return false;
    if (typeof $f952c70f2aa835f6$var$isSharedArrayBufferToString.working === 'undefined') $f952c70f2aa835f6$var$isSharedArrayBufferToString.working = $f952c70f2aa835f6$var$isSharedArrayBufferToString(new $f952c70f2aa835f6$var$SharedArrayBufferCopy());
    return $f952c70f2aa835f6$var$isSharedArrayBufferToString.working ? $f952c70f2aa835f6$var$isSharedArrayBufferToString(value) : value instanceof $f952c70f2aa835f6$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $f952c70f2aa835f6$var$isSharedArrayBuffer;
function $f952c70f2aa835f6$var$isAsyncFunction(value) {
    return $f952c70f2aa835f6$var$ObjectToString(value) === '[object AsyncFunction]';
}
module.exports.isAsyncFunction = $f952c70f2aa835f6$var$isAsyncFunction;
function $f952c70f2aa835f6$var$isMapIterator(value) {
    return $f952c70f2aa835f6$var$ObjectToString(value) === '[object Map Iterator]';
}
module.exports.isMapIterator = $f952c70f2aa835f6$var$isMapIterator;
function $f952c70f2aa835f6$var$isSetIterator(value) {
    return $f952c70f2aa835f6$var$ObjectToString(value) === '[object Set Iterator]';
}
module.exports.isSetIterator = $f952c70f2aa835f6$var$isSetIterator;
function $f952c70f2aa835f6$var$isGeneratorObject(value) {
    return $f952c70f2aa835f6$var$ObjectToString(value) === '[object Generator]';
}
module.exports.isGeneratorObject = $f952c70f2aa835f6$var$isGeneratorObject;
function $f952c70f2aa835f6$var$isWebAssemblyCompiledModule(value) {
    return $f952c70f2aa835f6$var$ObjectToString(value) === '[object WebAssembly.Module]';
}
module.exports.isWebAssemblyCompiledModule = $f952c70f2aa835f6$var$isWebAssemblyCompiledModule;
function $f952c70f2aa835f6$var$isNumberObject(value) {
    return $f952c70f2aa835f6$var$checkBoxedPrimitive(value, $f952c70f2aa835f6$var$numberValue);
}
module.exports.isNumberObject = $f952c70f2aa835f6$var$isNumberObject;
function $f952c70f2aa835f6$var$isStringObject(value) {
    return $f952c70f2aa835f6$var$checkBoxedPrimitive(value, $f952c70f2aa835f6$var$stringValue);
}
module.exports.isStringObject = $f952c70f2aa835f6$var$isStringObject;
function $f952c70f2aa835f6$var$isBooleanObject(value) {
    return $f952c70f2aa835f6$var$checkBoxedPrimitive(value, $f952c70f2aa835f6$var$booleanValue);
}
module.exports.isBooleanObject = $f952c70f2aa835f6$var$isBooleanObject;
function $f952c70f2aa835f6$var$isBigIntObject(value) {
    return $f952c70f2aa835f6$var$BigIntSupported && $f952c70f2aa835f6$var$checkBoxedPrimitive(value, $f952c70f2aa835f6$var$bigIntValue);
}
module.exports.isBigIntObject = $f952c70f2aa835f6$var$isBigIntObject;
function $f952c70f2aa835f6$var$isSymbolObject(value) {
    return $f952c70f2aa835f6$var$SymbolSupported && $f952c70f2aa835f6$var$checkBoxedPrimitive(value, $f952c70f2aa835f6$var$symbolValue);
}
module.exports.isSymbolObject = $f952c70f2aa835f6$var$isSymbolObject;
function $f952c70f2aa835f6$var$isBoxedPrimitive(value) {
    return $f952c70f2aa835f6$var$isNumberObject(value) || $f952c70f2aa835f6$var$isStringObject(value) || $f952c70f2aa835f6$var$isBooleanObject(value) || $f952c70f2aa835f6$var$isBigIntObject(value) || $f952c70f2aa835f6$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $f952c70f2aa835f6$var$isBoxedPrimitive;
function $f952c70f2aa835f6$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== 'undefined' && ($f952c70f2aa835f6$var$isArrayBuffer(value) || $f952c70f2aa835f6$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $f952c70f2aa835f6$var$isAnyArrayBuffer;
[
    'isProxy',
    'isExternal',
    'isModuleNamespaceObject'
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + ' is not supported in userland');
        }
    });
});

});
parcelRegister("9WLgc", function(module, exports) {
'use strict';

var $73de30bdcd34bd32$var$hasToStringTag = (parcelRequire("9lcIx"))();

var $8whRB = parcelRequire("8whRB");
var $73de30bdcd34bd32$var$$toString = $8whRB('Object.prototype.toString');
/** @type {import('.')} */ var $73de30bdcd34bd32$var$isStandardArguments = function isArguments(value) {
    if ($73de30bdcd34bd32$var$hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) return false;
    return $73de30bdcd34bd32$var$$toString(value) === '[object Arguments]';
};
/** @type {import('.')} */ var $73de30bdcd34bd32$var$isLegacyArguments = function isArguments(value) {
    if ($73de30bdcd34bd32$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === 'object' && 'length' in value && typeof value.length === 'number' && value.length >= 0 && $73de30bdcd34bd32$var$$toString(value) !== '[object Array]' && 'callee' in value && $73de30bdcd34bd32$var$$toString(value.callee) === '[object Function]';
};
var $73de30bdcd34bd32$var$supportsStandardArguments = function() {
    return $73de30bdcd34bd32$var$isStandardArguments(arguments);
}();
// @ts-expect-error TODO make this not error
$73de30bdcd34bd32$var$isStandardArguments.isLegacyArguments = $73de30bdcd34bd32$var$isLegacyArguments; // for tests
/** @type {import('.')} */ module.exports = $73de30bdcd34bd32$var$supportsStandardArguments ? $73de30bdcd34bd32$var$isStandardArguments : $73de30bdcd34bd32$var$isLegacyArguments;

});
parcelRegister("9lcIx", function(module, exports) {
'use strict';

var $lVmUo = parcelRequire("lVmUo");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $lVmUo() && !!Symbol.toStringTag;
};

});
parcelRegister("lVmUo", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("8whRB", function(module, exports) {
'use strict';

var $fFT7c = parcelRequire("fFT7c");

var $7F9VC = parcelRequire("7F9VC");
/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $633f2b388fa625f5$var$$indexOf = $7F9VC([
    $fFT7c('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ module.exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ $fFT7c(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $633f2b388fa625f5$var$$indexOf(name, '.prototype.') > -1) return $7F9VC(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};

});
parcelRegister("fFT7c", function(module, exports) {
'use strict';
var $b69570147c829841$var$undefined1;

var $hp3dm = parcelRequire("hp3dm");

var $1dJrz = parcelRequire("1dJrz");

var $kef4E = parcelRequire("kef4E");

var $7egBS = parcelRequire("7egBS");

var $kE1zH = parcelRequire("kE1zH");

var $ibUZq = parcelRequire("ibUZq");

var $68H9J = parcelRequire("68H9J");

var $hysju = parcelRequire("hysju");

var $9pE7R = parcelRequire("9pE7R");

var $xucj2 = parcelRequire("xucj2");

var $ltH5l = parcelRequire("ltH5l");

var $hgpdg = parcelRequire("hgpdg");

var $gk7fP = parcelRequire("gk7fP");

var $bkRTR = parcelRequire("bkRTR");

var $3RR93 = parcelRequire("3RR93");
var $b69570147c829841$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $b69570147c829841$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $b69570147c829841$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};

var $7sppP = parcelRequire("7sppP");

var $68OFr = parcelRequire("68OFr");
var $b69570147c829841$var$throwTypeError = function() {
    throw new $68H9J();
};
var $b69570147c829841$var$ThrowTypeError = $7sppP ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $b69570147c829841$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $7sppP(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $b69570147c829841$var$throwTypeError;
        }
    }
}() : $b69570147c829841$var$throwTypeError;

var $b69570147c829841$var$hasSymbols = (parcelRequire("lEsMR"))();

var $3oEvi = parcelRequire("3oEvi");

var $gKjOX = parcelRequire("gKjOX");

var $8SHYK = parcelRequire("8SHYK");

var $k4dWd = parcelRequire("k4dWd");

var $dIyvc = parcelRequire("dIyvc");
var $b69570147c829841$var$needsEval = {};
var $b69570147c829841$var$TypedArray = typeof Uint8Array === 'undefined' || !$3oEvi ? undefined : $3oEvi(Uint8Array);
var $b69570147c829841$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $b69570147c829841$var$hasSymbols && $3oEvi ? $3oEvi([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $b69570147c829841$var$needsEval,
    '%AsyncGenerator%': $b69570147c829841$var$needsEval,
    '%AsyncGeneratorFunction%': $b69570147c829841$var$needsEval,
    '%AsyncIteratorPrototype%': $b69570147c829841$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $1dJrz,
    '%eval%': eval,
    '%EvalError%': $kef4E,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $b69570147c829841$var$$Function,
    '%GeneratorFunction%': $b69570147c829841$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $b69570147c829841$var$hasSymbols && $3oEvi ? $3oEvi($3oEvi([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$b69570147c829841$var$hasSymbols || !$3oEvi ? undefined : $3oEvi(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $hp3dm,
    '%Object.getOwnPropertyDescriptor%': $7sppP,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $7egBS,
    '%ReferenceError%': $kE1zH,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$b69570147c829841$var$hasSymbols || !$3oEvi ? undefined : $3oEvi(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $b69570147c829841$var$hasSymbols && $3oEvi ? $3oEvi(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $b69570147c829841$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $ibUZq,
    '%ThrowTypeError%': $b69570147c829841$var$ThrowTypeError,
    '%TypedArray%': $b69570147c829841$var$TypedArray,
    '%TypeError%': $68H9J,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $hysju,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $dIyvc,
    '%Function.prototype.apply%': $k4dWd,
    '%Object.defineProperty%': $68OFr,
    '%Object.getPrototypeOf%': $gKjOX,
    '%Math.abs%': $9pE7R,
    '%Math.floor%': $xucj2,
    '%Math.max%': $ltH5l,
    '%Math.min%': $hgpdg,
    '%Math.pow%': $gk7fP,
    '%Math.round%': $bkRTR,
    '%Math.sign%': $3RR93,
    '%Reflect.getPrototypeOf%': $8SHYK
};
if ($3oEvi) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $b69570147c829841$var$errorProto = $3oEvi($3oEvi(e));
    $b69570147c829841$var$INTRINSICS['%Error.prototype%'] = $b69570147c829841$var$errorProto;
}
var $b69570147c829841$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $b69570147c829841$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $b69570147c829841$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $b69570147c829841$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $3oEvi) value = $3oEvi(gen.prototype);
    }
    $b69570147c829841$var$INTRINSICS[name] = value;
    return value;
};
var $b69570147c829841$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $32JYM = parcelRequire("32JYM");

var $2EFKW = parcelRequire("2EFKW");
var $b69570147c829841$var$$concat = $32JYM.call($dIyvc, Array.prototype.concat);
var $b69570147c829841$var$$spliceApply = $32JYM.call($k4dWd, Array.prototype.splice);
var $b69570147c829841$var$$replace = $32JYM.call($dIyvc, String.prototype.replace);
var $b69570147c829841$var$$strSlice = $32JYM.call($dIyvc, String.prototype.slice);
var $b69570147c829841$var$$exec = $32JYM.call($dIyvc, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $b69570147c829841$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $b69570147c829841$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $b69570147c829841$var$stringToPath = function stringToPath(string) {
    var first = $b69570147c829841$var$$strSlice(string, 0, 1);
    var last = $b69570147c829841$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $ibUZq('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $ibUZq('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $b69570147c829841$var$$replace(string, $b69570147c829841$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $b69570147c829841$var$$replace(subString, $b69570147c829841$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $b69570147c829841$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($2EFKW($b69570147c829841$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $b69570147c829841$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($2EFKW($b69570147c829841$var$INTRINSICS, intrinsicName)) {
        var value = $b69570147c829841$var$INTRINSICS[intrinsicName];
        if (value === $b69570147c829841$var$needsEval) value = $b69570147c829841$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $68H9J('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $ibUZq('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $68H9J('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $68H9J('"allowMissing" argument must be a boolean');
    if ($b69570147c829841$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $ibUZq('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $b69570147c829841$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $b69570147c829841$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $b69570147c829841$var$$spliceApply(parts, $b69570147c829841$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $b69570147c829841$var$$strSlice(part, 0, 1);
        var last = $b69570147c829841$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $ibUZq('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($2EFKW($b69570147c829841$var$INTRINSICS, intrinsicRealName)) value = $b69570147c829841$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $68H9J('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($7sppP && i + 1 >= parts.length) {
                var desc = $7sppP(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $2EFKW(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $b69570147c829841$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("hp3dm", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

});

parcelRegister("1dJrz", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("kef4E", function(module, exports) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("7egBS", function(module, exports) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("kE1zH", function(module, exports) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("ibUZq", function(module, exports) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("68H9J", function(module, exports) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("hysju", function(module, exports) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("9pE7R", function(module, exports) {
'use strict';
/** @type {import('./abs')} */ module.exports = Math.abs;

});

parcelRegister("xucj2", function(module, exports) {
'use strict';
/** @type {import('./floor')} */ module.exports = Math.floor;

});

parcelRegister("ltH5l", function(module, exports) {
'use strict';
/** @type {import('./max')} */ module.exports = Math.max;

});

parcelRegister("hgpdg", function(module, exports) {
'use strict';
/** @type {import('./min')} */ module.exports = Math.min;

});

parcelRegister("gk7fP", function(module, exports) {
'use strict';
/** @type {import('./pow')} */ module.exports = Math.pow;

});

parcelRegister("bkRTR", function(module, exports) {
'use strict';
/** @type {import('./round')} */ module.exports = Math.round;

});

parcelRegister("3RR93", function(module, exports) {
'use strict';

var $chaFx = parcelRequire("chaFx");
/** @type {import('./sign')} */ module.exports = function sign(number) {
    if ($chaFx(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};

});
parcelRegister("chaFx", function(module, exports) {
'use strict';
/** @type {import('./isNaN')} */ module.exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};

});


parcelRegister("7sppP", function(module, exports) {
'use strict';

var $gbx2J = parcelRequire("gbx2J");
var $56dedcf407f5fed4$require$$gOPD = $gbx2J;
if ($56dedcf407f5fed4$require$$gOPD) try {
    $56dedcf407f5fed4$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $56dedcf407f5fed4$require$$gOPD = null;
}
module.exports = $56dedcf407f5fed4$require$$gOPD;

});
parcelRegister("gbx2J", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});


parcelRegister("68OFr", function(module, exports) {
'use strict';
/** @type {import('.')} */ var $478acaecc09e872b$var$$defineProperty = Object.defineProperty || false;
if ($478acaecc09e872b$var$$defineProperty) try {
    $478acaecc09e872b$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $478acaecc09e872b$var$$defineProperty = false;
}
module.exports = $478acaecc09e872b$var$$defineProperty;

});

parcelRegister("lEsMR", function(module, exports) {
'use strict';
var $fc33a9e5f4baa1c6$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $lVmUo = parcelRequire("lVmUo");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $fc33a9e5f4baa1c6$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $fc33a9e5f4baa1c6$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $lVmUo();
};

});

parcelRegister("3oEvi", function(module, exports) {
'use strict';

var $8SHYK = parcelRequire("8SHYK");

var $gKjOX = parcelRequire("gKjOX");

var $eFs2b = parcelRequire("eFs2b");
/** @type {import('.')} */ module.exports = $8SHYK ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $8SHYK(O);
} : $gKjOX ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $gKjOX(O);
} : $eFs2b ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $eFs2b(O);
} : null;

});
parcelRegister("8SHYK", function(module, exports) {
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ module.exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;

});

parcelRegister("gKjOX", function(module, exports) {
'use strict';

var $hp3dm = parcelRequire("hp3dm");
/** @type {import('./Object.getPrototypeOf')} */ module.exports = $hp3dm.getPrototypeOf || null;

});

parcelRegister("eFs2b", function(module, exports) {
'use strict';

var $7F9VC = parcelRequire("7F9VC");

var $7sppP = parcelRequire("7sppP");
var $aadaa40724813a70$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $aadaa40724813a70$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $aadaa40724813a70$var$desc = !!$aadaa40724813a70$var$hasProtoAccessor && $7sppP && $7sppP(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $aadaa40724813a70$var$$Object = Object;
var $aadaa40724813a70$var$$getPrototypeOf = $aadaa40724813a70$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ module.exports = $aadaa40724813a70$var$desc && typeof $aadaa40724813a70$var$desc.get === 'function' ? $7F9VC([
    $aadaa40724813a70$var$desc.get
]) : typeof $aadaa40724813a70$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $aadaa40724813a70$var$$getPrototypeOf(value == null ? value : $aadaa40724813a70$var$$Object(value));
} : false;

});
parcelRegister("7F9VC", function(module, exports) {
'use strict';

var $32JYM = parcelRequire("32JYM");

var $68H9J = parcelRequire("68H9J");

var $dIyvc = parcelRequire("dIyvc");

var $CA11e = parcelRequire("CA11e");
/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $68H9J('a function is required');
    return $CA11e($32JYM, $dIyvc, args);
};

});
parcelRegister("32JYM", function(module, exports) {
'use strict';

var $gbazU = parcelRequire("gbazU");
module.exports = Function.prototype.bind || $gbazU;

});
parcelRegister("gbazU", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $bc75e103466337ba$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $bc75e103466337ba$var$toStr = Object.prototype.toString;
var $bc75e103466337ba$var$max = Math.max;
var $bc75e103466337ba$var$funcType = '[object Function]';
var $bc75e103466337ba$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $bc75e103466337ba$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $bc75e103466337ba$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $bc75e103466337ba$var$toStr.apply(target) !== $bc75e103466337ba$var$funcType) throw new TypeError($bc75e103466337ba$var$ERROR_MESSAGE + target);
    var args = $bc75e103466337ba$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $bc75e103466337ba$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $bc75e103466337ba$var$concatty(args, arguments));
    };
    var boundLength = $bc75e103466337ba$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $bc75e103466337ba$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("dIyvc", function(module, exports) {
'use strict';
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

});

parcelRegister("CA11e", function(module, exports) {
'use strict';

var $32JYM = parcelRequire("32JYM");

var $k4dWd = parcelRequire("k4dWd");

var $dIyvc = parcelRequire("dIyvc");

var $a9AUU = parcelRequire("a9AUU");
/** @type {import('./actualApply')} */ module.exports = $a9AUU || $32JYM.call($dIyvc, $k4dWd);

});
parcelRegister("k4dWd", function(module, exports) {
'use strict';
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

});

parcelRegister("a9AUU", function(module, exports) {
'use strict';
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

});





parcelRegister("2EFKW", function(module, exports) {
'use strict';
var $1eefb51acdc071dd$var$call = Function.prototype.call;
var $1eefb51acdc071dd$var$$hasOwn = Object.prototype.hasOwnProperty;

var $32JYM = parcelRequire("32JYM");
/** @type {import('.')} */ module.exports = $32JYM.call($1eefb51acdc071dd$var$call, $1eefb51acdc071dd$var$$hasOwn);

});




parcelRegister("fd7v8", function(module, exports) {
'use strict';

var $8whRB = parcelRequire("8whRB");

var $ipZGQ = parcelRequire("ipZGQ");
var $b12de3826adae023$var$isFnRegex = $ipZGQ(/^\s*(?:function)?\*/);

var $b12de3826adae023$var$hasToStringTag = (parcelRequire("9lcIx"))();

var $3oEvi = parcelRequire("3oEvi");
var $b12de3826adae023$var$toStr = $8whRB('Object.prototype.toString');
var $b12de3826adae023$var$fnToStr = $8whRB('Function.prototype.toString');

var $hMbLP = parcelRequire("hMbLP");
/** @type {import('.')} */ module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== 'function') return false;
    if ($b12de3826adae023$var$isFnRegex($b12de3826adae023$var$fnToStr(fn))) return true;
    if (!$b12de3826adae023$var$hasToStringTag) {
        var str = $b12de3826adae023$var$toStr(fn);
        return str === '[object GeneratorFunction]';
    }
    if (!$3oEvi) return false;
    var GeneratorFunction = $hMbLP();
    return GeneratorFunction && $3oEvi(fn) === GeneratorFunction.prototype;
};

});
parcelRegister("ipZGQ", function(module, exports) {
'use strict';

var $8whRB = parcelRequire("8whRB");

var $iPloM = parcelRequire("iPloM");
var $d68a6a269a55e870$var$$exec = $8whRB('RegExp.prototype.exec');

var $68H9J = parcelRequire("68H9J");
/** @type {import('.')} */ module.exports = function regexTester(regex) {
    if (!$iPloM(regex)) throw new $68H9J('`regex` must be a RegExp');
    return function test(s) {
        return $d68a6a269a55e870$var$$exec(regex, s) !== null;
    };
};

});
parcelRegister("iPloM", function(module, exports) {
'use strict';

var $8whRB = parcelRequire("8whRB");

var $db4d96bf9043d510$var$hasToStringTag = (parcelRequire("9lcIx"))();

var $2EFKW = parcelRequire("2EFKW");

var $7sppP = parcelRequire("7sppP");
/** @type {import('.')} */ var $db4d96bf9043d510$var$fn;
if ($db4d96bf9043d510$var$hasToStringTag) {
    /** @type {(receiver: ThisParameterType<typeof RegExp.prototype.exec>, ...args: Parameters<typeof RegExp.prototype.exec>) => ReturnType<typeof RegExp.prototype.exec>} */ var $db4d96bf9043d510$var$$exec = $8whRB('RegExp.prototype.exec');
    /** @type {object} */ var $db4d96bf9043d510$var$isRegexMarker = {};
    var $db4d96bf9043d510$var$throwRegexMarker = function() {
        throw $db4d96bf9043d510$var$isRegexMarker;
    };
    /** @type {{ toString(): never, valueOf(): never, [Symbol.toPrimitive]?(): never }} */ var $db4d96bf9043d510$var$badStringifier = {
        toString: $db4d96bf9043d510$var$throwRegexMarker,
        valueOf: $db4d96bf9043d510$var$throwRegexMarker
    };
    if (typeof Symbol.toPrimitive === 'symbol') $db4d96bf9043d510$var$badStringifier[Symbol.toPrimitive] = $db4d96bf9043d510$var$throwRegexMarker;
    /** @type {import('.')} */ // @ts-expect-error TS can't figure out that the $exec call always throws
    // eslint-disable-next-line consistent-return
    $db4d96bf9043d510$var$fn = function isRegex(value) {
        if (!value || typeof value !== 'object') return false;
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {NonNullable<typeof gOPD>} */ $7sppP(/** @type {{ lastIndex?: unknown }} */ value, 'lastIndex');
        var hasLastIndexDataProperty = descriptor && $2EFKW(descriptor, 'value');
        if (!hasLastIndexDataProperty) return false;
        try {
            // eslint-disable-next-line no-extra-parens
            $db4d96bf9043d510$var$$exec(value, /** @type {unknown} */ $db4d96bf9043d510$var$badStringifier);
        } catch (e) {
            return e === $db4d96bf9043d510$var$isRegexMarker;
        }
    };
} else {
    /** @type {(receiver: ThisParameterType<typeof Object.prototype.toString>, ...args: Parameters<typeof Object.prototype.toString>) => ReturnType<typeof Object.prototype.toString>} */ var $db4d96bf9043d510$var$$toString = $8whRB('Object.prototype.toString');
    /** @const @type {'[object RegExp]'} */ var $db4d96bf9043d510$var$regexClass = '[object RegExp]';
    /** @type {import('.')} */ $db4d96bf9043d510$var$fn = function isRegex(value) {
        // In older browsers, typeof regex incorrectly returns 'function'
        if (!value || typeof value !== 'object' && typeof value !== 'function') return false;
        return $db4d96bf9043d510$var$$toString(value) === $db4d96bf9043d510$var$regexClass;
    };
}
module.exports = $db4d96bf9043d510$var$fn;

});


parcelRegister("hMbLP", function(module, exports) {
'use strict';
// eslint-disable-next-line no-extra-parens, no-empty-function
const $cf100cb68f158650$var$cached = /** @type {GeneratorFunctionConstructor} */ (function*() {}).constructor;
/** @type {import('.')} */ module.exports = ()=>$cf100cb68f158650$var$cached;

});


parcelRegister("bC4MU", function(module, exports) {
'use strict';

var $jndmA = parcelRequire("jndmA");

var $1LWSh = parcelRequire("1LWSh");

var $4xYIQ = parcelRequire("4xYIQ");

var $8whRB = parcelRequire("8whRB");

var $7sppP = parcelRequire("7sppP");

var $3oEvi = parcelRequire("3oEvi");
var $8746f51bbd929fd1$var$$toString = $8whRB('Object.prototype.toString');

var $8746f51bbd929fd1$var$hasToStringTag = (parcelRequire("9lcIx"))();
var $8746f51bbd929fd1$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
var $8746f51bbd929fd1$var$typedArrays = $1LWSh();
var $8746f51bbd929fd1$var$$slice = $8whRB('String.prototype.slice');
/** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */ var $8746f51bbd929fd1$var$$indexOf = $8whRB('Array.prototype.indexOf', true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @typedef {import('./types').Getter} Getter */ /** @type {import('./types').Cache} */ var $8746f51bbd929fd1$var$cache = {
    __proto__: null
};
if ($8746f51bbd929fd1$var$hasToStringTag && $7sppP && $3oEvi) $jndmA($8746f51bbd929fd1$var$typedArrays, function(typedArray) {
    var arr = new $8746f51bbd929fd1$var$g[typedArray]();
    if (Symbol.toStringTag in arr && $3oEvi) {
        var proto = $3oEvi(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = $7sppP(proto, Symbol.toStringTag);
        if (!descriptor && proto) {
            var superProto = $3oEvi(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = $7sppP(superProto, Symbol.toStringTag);
        }
        if (descriptor && descriptor.get) {
            var bound = $4xYIQ(descriptor.get);
            $8746f51bbd929fd1$var$cache[/** @type {`$${import('.').TypedArrayName}`} */ '$' + typedArray] = bound;
        }
    }
});
else $jndmA($8746f51bbd929fd1$var$typedArrays, function(typedArray) {
    var arr = new $8746f51bbd929fd1$var$g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) {
        var bound = /** @type {import('./types').BoundSlice | import('./types').BoundSet} */ // @ts-expect-error TODO FIXME
        $4xYIQ(fn);
        $8746f51bbd929fd1$var$cache[/** @type {`$${import('.').TypedArrayName}`} */ '$' + typedArray] = bound;
    }
});
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $8746f51bbd929fd1$var$tryTypedArrays = function tryAllTypedArrays(value) {
    /** @type {ReturnType<typeof tryAllTypedArrays>} */ var found = false;
    $jndmA(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $8746f51bbd929fd1$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            if ('$' + getter(value) === typedArray) found = /** @type {import('.').TypedArrayName} */ $8746f51bbd929fd1$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $8746f51bbd929fd1$var$trySlices = function tryAllSlices(value) {
    /** @type {ReturnType<typeof tryAllSlices>} */ var found = false;
    $jndmA(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $8746f51bbd929fd1$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            getter(value);
            found = /** @type {import('.').TypedArrayName} */ $8746f51bbd929fd1$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {import('.')} */ module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== 'object') return false;
    if (!$8746f51bbd929fd1$var$hasToStringTag) {
        /** @type {string} */ var tag = $8746f51bbd929fd1$var$$slice($8746f51bbd929fd1$var$$toString(value), 8, -1);
        if ($8746f51bbd929fd1$var$$indexOf($8746f51bbd929fd1$var$typedArrays, tag) > -1) return tag;
        if (tag !== 'Object') return false;
        // node < 0.6 hits here on real Typed Arrays
        return $8746f51bbd929fd1$var$trySlices(value);
    }
    if (!$7sppP) return null;
     // unknown engine
    return $8746f51bbd929fd1$var$tryTypedArrays(value);
};

});
parcelRegister("jndmA", function(module, exports) {
'use strict';

var $6TAlO = parcelRequire("6TAlO");
var $e1aa87fa05e709ad$var$toStr = Object.prototype.toString;
var $e1aa87fa05e709ad$var$hasOwnProperty = Object.prototype.hasOwnProperty;
/** @type {<This, A extends readonly unknown[]>(arr: A, iterator: (this: This | void, value: A[number], index: number, arr: A) => void, receiver: This | undefined) => void} */ var $e1aa87fa05e709ad$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($e1aa87fa05e709ad$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
/** @type {<This, S extends string>(string: S, iterator: (this: This | void, value: S[number], index: number, string: S) => void, receiver: This | undefined) => void} */ var $e1aa87fa05e709ad$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
/** @type {<This, O>(obj: O, iterator: (this: This | void, value: O[keyof O], index: keyof O, obj: O) => void, receiver: This | undefined) => void} */ var $e1aa87fa05e709ad$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($e1aa87fa05e709ad$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
/** @type {(x: unknown) => x is readonly unknown[]} */ function $e1aa87fa05e709ad$var$isArray(x) {
    return $e1aa87fa05e709ad$var$toStr.call(x) === '[object Array]';
}
/** @type {import('.')._internal} */ module.exports = function forEach(list, iterator, thisArg) {
    if (!$6TAlO(iterator)) throw new TypeError('iterator must be a function');
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($e1aa87fa05e709ad$var$isArray(list)) $e1aa87fa05e709ad$var$forEachArray(list, iterator, receiver);
    else if (typeof list === 'string') $e1aa87fa05e709ad$var$forEachString(list, iterator, receiver);
    else $e1aa87fa05e709ad$var$forEachObject(list, iterator, receiver);
};

});
parcelRegister("6TAlO", function(module, exports) {
'use strict';
var $505413a71fb8121f$var$fnToStr = Function.prototype.toString;
var $505413a71fb8121f$var$reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var $505413a71fb8121f$var$badArrayLike;
var $505413a71fb8121f$var$isCallableMarker;
if (typeof $505413a71fb8121f$var$reflectApply === 'function' && typeof Object.defineProperty === 'function') try {
    $505413a71fb8121f$var$badArrayLike = Object.defineProperty({}, 'length', {
        get: function() {
            throw $505413a71fb8121f$var$isCallableMarker;
        }
    });
    $505413a71fb8121f$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $505413a71fb8121f$var$reflectApply(function() {
        throw 42;
    }, null, $505413a71fb8121f$var$badArrayLike);
} catch (_) {
    if (_ !== $505413a71fb8121f$var$isCallableMarker) $505413a71fb8121f$var$reflectApply = null;
}
else $505413a71fb8121f$var$reflectApply = null;
var $505413a71fb8121f$var$constructorRegex = /^\s*class\b/;
var $505413a71fb8121f$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $505413a71fb8121f$var$fnToStr.call(value);
        return $505413a71fb8121f$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $505413a71fb8121f$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($505413a71fb8121f$var$isES6ClassFn(value)) return false;
        $505413a71fb8121f$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $505413a71fb8121f$var$toStr = Object.prototype.toString;
var $505413a71fb8121f$var$objectClass = '[object Object]';
var $505413a71fb8121f$var$fnClass = '[object Function]';
var $505413a71fb8121f$var$genClass = '[object GeneratorFunction]';
var $505413a71fb8121f$var$ddaClass = '[object HTMLAllCollection]'; // IE 11
var $505413a71fb8121f$var$ddaClass2 = '[object HTML document.all class]';
var $505413a71fb8121f$var$ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var $505413a71fb8121f$var$hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $505413a71fb8121f$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $505413a71fb8121f$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === 'object') {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $505413a71fb8121f$var$all = document.all;
    if ($505413a71fb8121f$var$toStr.call($505413a71fb8121f$var$all) === $505413a71fb8121f$var$toStr.call(document.all)) $505413a71fb8121f$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($505413a71fb8121f$var$isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) try {
            var str = $505413a71fb8121f$var$toStr.call(value);
            return (str === $505413a71fb8121f$var$ddaClass || str === $505413a71fb8121f$var$ddaClass2 || str === $505413a71fb8121f$var$ddaClass3 // opera 12.16
             || str === $505413a71fb8121f$var$objectClass // IE 6-8
            ) && value('') == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $505413a71fb8121f$var$reflectApply ? function isCallable(value) {
    if ($505413a71fb8121f$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    try {
        $505413a71fb8121f$var$reflectApply(value, null, $505413a71fb8121f$var$badArrayLike);
    } catch (e) {
        if (e !== $505413a71fb8121f$var$isCallableMarker) return false;
    }
    return !$505413a71fb8121f$var$isES6ClassFn(value) && $505413a71fb8121f$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($505413a71fb8121f$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    if ($505413a71fb8121f$var$hasToStringTag) return $505413a71fb8121f$var$tryFunctionObject(value);
    if ($505413a71fb8121f$var$isES6ClassFn(value)) return false;
    var strClass = $505413a71fb8121f$var$toStr.call(value);
    if (strClass !== $505413a71fb8121f$var$fnClass && strClass !== $505413a71fb8121f$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $505413a71fb8121f$var$tryFunctionObject(value);
};

});


parcelRegister("1LWSh", function(module, exports) {
'use strict';

var $ghcFv = parcelRequire("ghcFv");
var $14a7d978ebc4e4ac$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < $ghcFv.length; i++)if (typeof $14a7d978ebc4e4ac$var$g[$ghcFv[i]] === 'function') // @ts-expect-error
    out[out.length] = $ghcFv[i];
    return out;
};

});
parcelRegister("ghcFv", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = [
    'Float16Array',
    'Float32Array',
    'Float64Array',
    'Int8Array',
    'Int16Array',
    'Int32Array',
    'Uint8Array',
    'Uint8ClampedArray',
    'Uint16Array',
    'Uint32Array',
    'BigInt64Array',
    'BigUint64Array'
];

});


parcelRegister("4xYIQ", function(module, exports) {
'use strict';

var $fxhsa = parcelRequire("fxhsa");

var $68OFr = parcelRequire("68OFr");

var $7F9VC = parcelRequire("7F9VC");

var $2QwbG = parcelRequire("2QwbG");
module.exports = function callBind(originalFunction) {
    var func = $7F9VC(arguments);
    var adjustedLength = 1 + originalFunction.length - (arguments.length - 1);
    return $fxhsa(func, adjustedLength > 0 ? adjustedLength : 0, true);
};
if ($68OFr) $68OFr(module.exports, 'apply', {
    value: $2QwbG
});
else module.exports.apply = $2QwbG;

});
parcelRegister("fxhsa", function(module, exports) {
'use strict';

var $fFT7c = parcelRequire("fFT7c");

var $2jDyv = parcelRequire("2jDyv");

var $b4f779f7718318e2$var$hasDescriptors = (parcelRequire("9A3by"))();

var $7sppP = parcelRequire("7sppP");

var $68H9J = parcelRequire("68H9J");
var $b4f779f7718318e2$var$$floor = $fFT7c('%Math.floor%');
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== 'function') throw new $68H9J('`fn` is not a function');
    if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $b4f779f7718318e2$var$$floor(length) !== length) throw new $68H9J('`length` must be a positive 32-bit integer');
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ('length' in fn && $7sppP) {
        var desc = $7sppP(fn, 'length');
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($b4f779f7718318e2$var$hasDescriptors) $2jDyv(/** @type {Parameters<define>[0]} */ fn, 'length', length, true, true);
        else $2jDyv(/** @type {Parameters<define>[0]} */ fn, 'length', length);
    }
    return fn;
};

});
parcelRegister("2jDyv", function(module, exports) {
'use strict';

var $68OFr = parcelRequire("68OFr");

var $ibUZq = parcelRequire("ibUZq");

var $68H9J = parcelRequire("68H9J");

var $7sppP = parcelRequire("7sppP");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== 'object' && typeof obj !== 'function') throw new $68H9J('`obj` must be an object or a function`');
    if (typeof property !== 'string' && typeof property !== 'symbol') throw new $68H9J('`property` must be a string or a symbol`');
    if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) throw new $68H9J('`nonEnumerable`, if provided, must be a boolean or null');
    if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) throw new $68H9J('`nonWritable`, if provided, must be a boolean or null');
    if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) throw new $68H9J('`nonConfigurable`, if provided, must be a boolean or null');
    if (arguments.length > 6 && typeof arguments[6] !== 'boolean') throw new $68H9J('`loose`, if provided, must be a boolean');
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$7sppP && $7sppP(obj, property);
    if ($68OFr) $68OFr(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $ibUZq('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
};

});

parcelRegister("9A3by", function(module, exports) {
'use strict';

var $68OFr = parcelRequire("68OFr");
var $6f99f26352031014$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$68OFr;
};
$6f99f26352031014$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$68OFr) return null;
    try {
        return $68OFr([], 'length', {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $6f99f26352031014$var$hasPropertyDescriptors;

});


parcelRegister("2QwbG", function(module, exports) {
'use strict';

var $32JYM = parcelRequire("32JYM");

var $k4dWd = parcelRequire("k4dWd");

var $CA11e = parcelRequire("CA11e");
/** @type {import('./applyBind')} */ module.exports = function applyBind() {
    return $CA11e($32JYM, $k4dWd, arguments);
};

});



parcelRegister("i9pTi", function(module, exports) {
'use strict';

var $bC4MU = parcelRequire("bC4MU");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!$bC4MU(value);
};

});


parcelRegister("1ec4D", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
};

});

parcelRegister("fvL6U", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});





parcelRegister("uyyW1", function(module, exports) {
'use strict';
/** @typedef {import('./types').CodecFactory} CodecFactory */ /**
 * @param {string} string
 * @param {string} alphabet
 * @param {number} bitsPerChar
 * @returns {Uint8Array}
 */ const $05bd9cd784b9de35$var$decode = (string, alphabet, bitsPerChar)=>{
    // Build the character lookup table:
    /** @type {Record<string, number>} */ const codes = {};
    for(let i = 0; i < alphabet.length; ++i)codes[alphabet[i]] = i;
    // Count the padding bytes:
    let end = string.length;
    while(string[end - 1] === '=')--end;
    // Allocate the output:
    const out = new Uint8Array(end * bitsPerChar / 8 | 0);
    // Parse the data:
    let bits = 0 // Number of bits currently in the buffer
    ;
    let buffer = 0 // Bits waiting to be written out, MSB first
    ;
    let written = 0 // Next byte to write
    ;
    for(let i = 0; i < end; ++i){
        // Read one character from the string:
        const value = codes[string[i]];
        if (value === undefined) throw new SyntaxError('Invalid character ' + string[i]);
        // Append the bits to the buffer:
        buffer = buffer << bitsPerChar | value;
        bits += bitsPerChar;
        // Write out some bits if the buffer has a byte's worth:
        if (bits >= 8) {
            bits -= 8;
            out[written++] = 0xff & buffer >> bits;
        }
    }
    // Verify that we have received just enough bits:
    if (bits >= bitsPerChar || 0xff & buffer << 8 - bits) throw new SyntaxError('Unexpected end of data');
    return out;
};
/**
 * @param {Uint8Array} data
 * @param {string} alphabet
 * @param {number} bitsPerChar
 * @returns {string}
 */ const $05bd9cd784b9de35$var$encode = (data, alphabet, bitsPerChar)=>{
    const pad = alphabet[alphabet.length - 1] === '=';
    const mask = (1 << bitsPerChar) - 1;
    let out = '';
    let bits = 0 // Number of bits currently in the buffer
    ;
    let buffer = 0 // Bits waiting to be written out, MSB first
    ;
    for(let i = 0; i < data.length; ++i){
        // Slurp data into the buffer:
        buffer = buffer << 8 | data[i];
        bits += 8;
        // Write out as much as we can:
        while(bits > bitsPerChar){
            bits -= bitsPerChar;
            out += alphabet[mask & buffer >> bits];
        }
    }
    // Partial character:
    if (bits) out += alphabet[mask & buffer << bitsPerChar - bits];
    // Add padding characters until we hit a byte boundary:
    if (pad) while(out.length * bitsPerChar & 7)out += '=';
    return out;
};
/**
 * RFC4648 Factory
 *
 * @param {number} bitsPerChar
 * @returns {CodecFactory}
 */ const $05bd9cd784b9de35$var$rfc4648 = (bitsPerChar)=>(alphabet)=>{
        return {
            /**
     * @param {Uint8Array} input
     * @returns {string}
     */ encode (input) {
                return $05bd9cd784b9de35$var$encode(input, alphabet, bitsPerChar);
            },
            /**
     * @param {string} input
     * @returns {Uint8Array}
     */ decode (input) {
                return $05bd9cd784b9de35$var$decode(input, alphabet, bitsPerChar);
            }
        };
    };
module.exports = {
    rfc4648: $05bd9cd784b9de35$var$rfc4648
};

});



parcelRegister("lg1mP", function(module, exports) {



module.exports = {
    encode: (parcelRequire("i4wfg")),
    decode: (parcelRequire("8WKGb")),
    encodingLength: (parcelRequire("0cSFE"))
};

});
parcelRegister("i4wfg", function(module, exports) {
module.exports = $d2819cf4ab326775$var$encode;
var $d2819cf4ab326775$var$MSB = 0x80, $d2819cf4ab326775$var$REST = 0x7F, $d2819cf4ab326775$var$MSBALL = ~$d2819cf4ab326775$var$REST, $d2819cf4ab326775$var$INT = Math.pow(2, 31);
function $d2819cf4ab326775$var$encode(num, out, offset) {
    if (Number.MAX_SAFE_INTEGER && num > Number.MAX_SAFE_INTEGER) {
        $d2819cf4ab326775$var$encode.bytes = 0;
        throw new RangeError('Could not encode varint');
    }
    out = out || [];
    offset = offset || 0;
    var oldOffset = offset;
    while(num >= $d2819cf4ab326775$var$INT){
        out[offset++] = num & 0xFF | $d2819cf4ab326775$var$MSB;
        num /= 128;
    }
    while(num & $d2819cf4ab326775$var$MSBALL){
        out[offset++] = num & 0xFF | $d2819cf4ab326775$var$MSB;
        num >>>= 7;
    }
    out[offset] = num | 0;
    $d2819cf4ab326775$var$encode.bytes = offset - oldOffset + 1;
    return out;
}

});

parcelRegister("8WKGb", function(module, exports) {
module.exports = $6837f31518090046$var$read;
var $6837f31518090046$var$MSB = 0x80, $6837f31518090046$var$REST = 0x7F;
function $6837f31518090046$var$read(buf, offset) {
    var res = 0, offset = offset || 0, shift = 0, counter = offset, b, l = buf.length;
    do {
        if (counter >= l || shift > 49) {
            $6837f31518090046$var$read.bytes = 0;
            throw new RangeError('Could not decode varint');
        }
        b = buf[counter++];
        res += shift < 28 ? (b & $6837f31518090046$var$REST) << shift : (b & $6837f31518090046$var$REST) * Math.pow(2, shift);
        shift += 7;
    }while (b >= $6837f31518090046$var$MSB);
    $6837f31518090046$var$read.bytes = counter - offset;
    return res;
}

});

parcelRegister("0cSFE", function(module, exports) {
var $0009fe0ebb08caf7$var$N1 = Math.pow(2, 7);
var $0009fe0ebb08caf7$var$N2 = Math.pow(2, 14);
var $0009fe0ebb08caf7$var$N3 = Math.pow(2, 21);
var $0009fe0ebb08caf7$var$N4 = Math.pow(2, 28);
var $0009fe0ebb08caf7$var$N5 = Math.pow(2, 35);
var $0009fe0ebb08caf7$var$N6 = Math.pow(2, 42);
var $0009fe0ebb08caf7$var$N7 = Math.pow(2, 49);
var $0009fe0ebb08caf7$var$N8 = Math.pow(2, 56);
var $0009fe0ebb08caf7$var$N9 = Math.pow(2, 63);
module.exports = function(value) {
    return value < $0009fe0ebb08caf7$var$N1 ? 1 : value < $0009fe0ebb08caf7$var$N2 ? 2 : value < $0009fe0ebb08caf7$var$N3 ? 3 : value < $0009fe0ebb08caf7$var$N4 ? 4 : value < $0009fe0ebb08caf7$var$N5 ? 5 : value < $0009fe0ebb08caf7$var$N6 ? 6 : value < $0009fe0ebb08caf7$var$N7 ? 7 : value < $0009fe0ebb08caf7$var$N8 ? 8 : value < $0009fe0ebb08caf7$var$N9 ? 9 : 10;
};

});


parcelRegister("lPX1n", function(module, exports) {
/* eslint quote-props: off */ 'use strict';
/**
 * Names for all available hashes
 *
 * @typedef { "identity" | "sha1" | "sha2-256" | "sha2-512" | "sha3-512" | "sha3-384" | "sha3-256" | "sha3-224" | "shake-128" | "shake-256" | "keccak-224" | "keccak-256" | "keccak-384" | "keccak-512" | "blake3" | "murmur3-128" | "murmur3-32" | "dbl-sha2-256" | "md4" | "md5" | "bmt" | "sha2-256-trunc254-padded" | "ripemd-128" | "ripemd-160" | "ripemd-256" | "ripemd-320" | "x11" | "kangarootwelve" | "sm3-256" | "blake2b-8" | "blake2b-16" | "blake2b-24" | "blake2b-32" | "blake2b-40" | "blake2b-48" | "blake2b-56" | "blake2b-64" | "blake2b-72" | "blake2b-80" | "blake2b-88" | "blake2b-96" | "blake2b-104" | "blake2b-112" | "blake2b-120" | "blake2b-128" | "blake2b-136" | "blake2b-144" | "blake2b-152" | "blake2b-160" | "blake2b-168" | "blake2b-176" | "blake2b-184" | "blake2b-192" | "blake2b-200" | "blake2b-208" | "blake2b-216" | "blake2b-224" | "blake2b-232" | "blake2b-240" | "blake2b-248" | "blake2b-256" | "blake2b-264" | "blake2b-272" | "blake2b-280" | "blake2b-288" | "blake2b-296" | "blake2b-304" | "blake2b-312" | "blake2b-320" | "blake2b-328" | "blake2b-336" | "blake2b-344" | "blake2b-352" | "blake2b-360" | "blake2b-368" | "blake2b-376" | "blake2b-384" | "blake2b-392" | "blake2b-400" | "blake2b-408" | "blake2b-416" | "blake2b-424" | "blake2b-432" | "blake2b-440" | "blake2b-448" | "blake2b-456" | "blake2b-464" | "blake2b-472" | "blake2b-480" | "blake2b-488" | "blake2b-496" | "blake2b-504" | "blake2b-512" | "blake2s-8" | "blake2s-16" | "blake2s-24" | "blake2s-32" | "blake2s-40" | "blake2s-48" | "blake2s-56" | "blake2s-64" | "blake2s-72" | "blake2s-80" | "blake2s-88" | "blake2s-96" | "blake2s-104" | "blake2s-112" | "blake2s-120" | "blake2s-128" | "blake2s-136" | "blake2s-144" | "blake2s-152" | "blake2s-160" | "blake2s-168" | "blake2s-176" | "blake2s-184" | "blake2s-192" | "blake2s-200" | "blake2s-208" | "blake2s-216" | "blake2s-224" | "blake2s-232" | "blake2s-240" | "blake2s-248" | "blake2s-256" | "skein256-8" | "skein256-16" | "skein256-24" | "skein256-32" | "skein256-40" | "skein256-48" | "skein256-56" | "skein256-64" | "skein256-72" | "skein256-80" | "skein256-88" | "skein256-96" | "skein256-104" | "skein256-112" | "skein256-120" | "skein256-128" | "skein256-136" | "skein256-144" | "skein256-152" | "skein256-160" | "skein256-168" | "skein256-176" | "skein256-184" | "skein256-192" | "skein256-200" | "skein256-208" | "skein256-216" | "skein256-224" | "skein256-232" | "skein256-240" | "skein256-248" | "skein256-256" | "skein512-8" | "skein512-16" | "skein512-24" | "skein512-32" | "skein512-40" | "skein512-48" | "skein512-56" | "skein512-64" | "skein512-72" | "skein512-80" | "skein512-88" | "skein512-96" | "skein512-104" | "skein512-112" | "skein512-120" | "skein512-128" | "skein512-136" | "skein512-144" | "skein512-152" | "skein512-160" | "skein512-168" | "skein512-176" | "skein512-184" | "skein512-192" | "skein512-200" | "skein512-208" | "skein512-216" | "skein512-224" | "skein512-232" | "skein512-240" | "skein512-248" | "skein512-256" | "skein512-264" | "skein512-272" | "skein512-280" | "skein512-288" | "skein512-296" | "skein512-304" | "skein512-312" | "skein512-320" | "skein512-328" | "skein512-336" | "skein512-344" | "skein512-352" | "skein512-360" | "skein512-368" | "skein512-376" | "skein512-384" | "skein512-392" | "skein512-400" | "skein512-408" | "skein512-416" | "skein512-424" | "skein512-432" | "skein512-440" | "skein512-448" | "skein512-456" | "skein512-464" | "skein512-472" | "skein512-480" | "skein512-488" | "skein512-496" | "skein512-504" | "skein512-512" | "skein1024-8" | "skein1024-16" | "skein1024-24" | "skein1024-32" | "skein1024-40" | "skein1024-48" | "skein1024-56" | "skein1024-64" | "skein1024-72" | "skein1024-80" | "skein1024-88" | "skein1024-96" | "skein1024-104" | "skein1024-112" | "skein1024-120" | "skein1024-128" | "skein1024-136" | "skein1024-144" | "skein1024-152" | "skein1024-160" | "skein1024-168" | "skein1024-176" | "skein1024-184" | "skein1024-192" | "skein1024-200" | "skein1024-208" | "skein1024-216" | "skein1024-224" | "skein1024-232" | "skein1024-240" | "skein1024-248" | "skein1024-256" | "skein1024-264" | "skein1024-272" | "skein1024-280" | "skein1024-288" | "skein1024-296" | "skein1024-304" | "skein1024-312" | "skein1024-320" | "skein1024-328" | "skein1024-336" | "skein1024-344" | "skein1024-352" | "skein1024-360" | "skein1024-368" | "skein1024-376" | "skein1024-384" | "skein1024-392" | "skein1024-400" | "skein1024-408" | "skein1024-416" | "skein1024-424" | "skein1024-432" | "skein1024-440" | "skein1024-448" | "skein1024-456" | "skein1024-464" | "skein1024-472" | "skein1024-480" | "skein1024-488" | "skein1024-496" | "skein1024-504" | "skein1024-512" | "skein1024-520" | "skein1024-528" | "skein1024-536" | "skein1024-544" | "skein1024-552" | "skein1024-560" | "skein1024-568" | "skein1024-576" | "skein1024-584" | "skein1024-592" | "skein1024-600" | "skein1024-608" | "skein1024-616" | "skein1024-624" | "skein1024-632" | "skein1024-640" | "skein1024-648" | "skein1024-656" | "skein1024-664" | "skein1024-672" | "skein1024-680" | "skein1024-688" | "skein1024-696" | "skein1024-704" | "skein1024-712" | "skein1024-720" | "skein1024-728" | "skein1024-736" | "skein1024-744" | "skein1024-752" | "skein1024-760" | "skein1024-768" | "skein1024-776" | "skein1024-784" | "skein1024-792" | "skein1024-800" | "skein1024-808" | "skein1024-816" | "skein1024-824" | "skein1024-832" | "skein1024-840" | "skein1024-848" | "skein1024-856" | "skein1024-864" | "skein1024-872" | "skein1024-880" | "skein1024-888" | "skein1024-896" | "skein1024-904" | "skein1024-912" | "skein1024-920" | "skein1024-928" | "skein1024-936" | "skein1024-944" | "skein1024-952" | "skein1024-960" | "skein1024-968" | "skein1024-976" | "skein1024-984" | "skein1024-992" | "skein1024-1000" | "skein1024-1008" | "skein1024-1016" | "skein1024-1024" | "poseidon-bls12_381-a2-fc1" | "poseidon-bls12_381-a2-fc1-sc" } HashName
 */ /**
 * Codes for all available hashes
 *
 * @typedef { 0x00 | 0x11 | 0x12 | 0x13 | 0x14 | 0x15 | 0x16 | 0x17 | 0x18 | 0x19 | 0x1a | 0x1b | 0x1c | 0x1d | 0x1e | 0x22 | 0x23 | 0x56 | 0xd4 | 0xd5 | 0xd6 | 0x1012 | 0x1052 | 0x1053 | 0x1054 | 0x1055 | 0x1100 | 0x1d01 | 0x534d | 0xb201 | 0xb202 | 0xb203 | 0xb204 | 0xb205 | 0xb206 | 0xb207 | 0xb208 | 0xb209 | 0xb20a | 0xb20b | 0xb20c | 0xb20d | 0xb20e | 0xb20f | 0xb210 | 0xb211 | 0xb212 | 0xb213 | 0xb214 | 0xb215 | 0xb216 | 0xb217 | 0xb218 | 0xb219 | 0xb21a | 0xb21b | 0xb21c | 0xb21d | 0xb21e | 0xb21f | 0xb220 | 0xb221 | 0xb222 | 0xb223 | 0xb224 | 0xb225 | 0xb226 | 0xb227 | 0xb228 | 0xb229 | 0xb22a | 0xb22b | 0xb22c | 0xb22d | 0xb22e | 0xb22f | 0xb230 | 0xb231 | 0xb232 | 0xb233 | 0xb234 | 0xb235 | 0xb236 | 0xb237 | 0xb238 | 0xb239 | 0xb23a | 0xb23b | 0xb23c | 0xb23d | 0xb23e | 0xb23f | 0xb240 | 0xb241 | 0xb242 | 0xb243 | 0xb244 | 0xb245 | 0xb246 | 0xb247 | 0xb248 | 0xb249 | 0xb24a | 0xb24b | 0xb24c | 0xb24d | 0xb24e | 0xb24f | 0xb250 | 0xb251 | 0xb252 | 0xb253 | 0xb254 | 0xb255 | 0xb256 | 0xb257 | 0xb258 | 0xb259 | 0xb25a | 0xb25b | 0xb25c | 0xb25d | 0xb25e | 0xb25f | 0xb260 | 0xb301 | 0xb302 | 0xb303 | 0xb304 | 0xb305 | 0xb306 | 0xb307 | 0xb308 | 0xb309 | 0xb30a | 0xb30b | 0xb30c | 0xb30d | 0xb30e | 0xb30f | 0xb310 | 0xb311 | 0xb312 | 0xb313 | 0xb314 | 0xb315 | 0xb316 | 0xb317 | 0xb318 | 0xb319 | 0xb31a | 0xb31b | 0xb31c | 0xb31d | 0xb31e | 0xb31f | 0xb320 | 0xb321 | 0xb322 | 0xb323 | 0xb324 | 0xb325 | 0xb326 | 0xb327 | 0xb328 | 0xb329 | 0xb32a | 0xb32b | 0xb32c | 0xb32d | 0xb32e | 0xb32f | 0xb330 | 0xb331 | 0xb332 | 0xb333 | 0xb334 | 0xb335 | 0xb336 | 0xb337 | 0xb338 | 0xb339 | 0xb33a | 0xb33b | 0xb33c | 0xb33d | 0xb33e | 0xb33f | 0xb340 | 0xb341 | 0xb342 | 0xb343 | 0xb344 | 0xb345 | 0xb346 | 0xb347 | 0xb348 | 0xb349 | 0xb34a | 0xb34b | 0xb34c | 0xb34d | 0xb34e | 0xb34f | 0xb350 | 0xb351 | 0xb352 | 0xb353 | 0xb354 | 0xb355 | 0xb356 | 0xb357 | 0xb358 | 0xb359 | 0xb35a | 0xb35b | 0xb35c | 0xb35d | 0xb35e | 0xb35f | 0xb360 | 0xb361 | 0xb362 | 0xb363 | 0xb364 | 0xb365 | 0xb366 | 0xb367 | 0xb368 | 0xb369 | 0xb36a | 0xb36b | 0xb36c | 0xb36d | 0xb36e | 0xb36f | 0xb370 | 0xb371 | 0xb372 | 0xb373 | 0xb374 | 0xb375 | 0xb376 | 0xb377 | 0xb378 | 0xb379 | 0xb37a | 0xb37b | 0xb37c | 0xb37d | 0xb37e | 0xb37f | 0xb380 | 0xb381 | 0xb382 | 0xb383 | 0xb384 | 0xb385 | 0xb386 | 0xb387 | 0xb388 | 0xb389 | 0xb38a | 0xb38b | 0xb38c | 0xb38d | 0xb38e | 0xb38f | 0xb390 | 0xb391 | 0xb392 | 0xb393 | 0xb394 | 0xb395 | 0xb396 | 0xb397 | 0xb398 | 0xb399 | 0xb39a | 0xb39b | 0xb39c | 0xb39d | 0xb39e | 0xb39f | 0xb3a0 | 0xb3a1 | 0xb3a2 | 0xb3a3 | 0xb3a4 | 0xb3a5 | 0xb3a6 | 0xb3a7 | 0xb3a8 | 0xb3a9 | 0xb3aa | 0xb3ab | 0xb3ac | 0xb3ad | 0xb3ae | 0xb3af | 0xb3b0 | 0xb3b1 | 0xb3b2 | 0xb3b3 | 0xb3b4 | 0xb3b5 | 0xb3b6 | 0xb3b7 | 0xb3b8 | 0xb3b9 | 0xb3ba | 0xb3bb | 0xb3bc | 0xb3bd | 0xb3be | 0xb3bf | 0xb3c0 | 0xb3c1 | 0xb3c2 | 0xb3c3 | 0xb3c4 | 0xb3c5 | 0xb3c6 | 0xb3c7 | 0xb3c8 | 0xb3c9 | 0xb3ca | 0xb3cb | 0xb3cc | 0xb3cd | 0xb3ce | 0xb3cf | 0xb3d0 | 0xb3d1 | 0xb3d2 | 0xb3d3 | 0xb3d4 | 0xb3d5 | 0xb3d6 | 0xb3d7 | 0xb3d8 | 0xb3d9 | 0xb3da | 0xb3db | 0xb3dc | 0xb3dd | 0xb3de | 0xb3df | 0xb3e0 | 0xb401 | 0xb402 } HashCode
 */ /**
 * @type { Record<HashName,HashCode> }
 */ const $fe5c24ccc9d8f463$var$names = Object.freeze({
    'identity': 0x00,
    'sha1': 0x11,
    'sha2-256': 0x12,
    'sha2-512': 0x13,
    'sha3-512': 0x14,
    'sha3-384': 0x15,
    'sha3-256': 0x16,
    'sha3-224': 0x17,
    'shake-128': 0x18,
    'shake-256': 0x19,
    'keccak-224': 0x1a,
    'keccak-256': 0x1b,
    'keccak-384': 0x1c,
    'keccak-512': 0x1d,
    'blake3': 0x1e,
    'murmur3-128': 0x22,
    'murmur3-32': 0x23,
    'dbl-sha2-256': 0x56,
    'md4': 0xd4,
    'md5': 0xd5,
    'bmt': 0xd6,
    'sha2-256-trunc254-padded': 0x1012,
    'ripemd-128': 0x1052,
    'ripemd-160': 0x1053,
    'ripemd-256': 0x1054,
    'ripemd-320': 0x1055,
    'x11': 0x1100,
    'kangarootwelve': 0x1d01,
    'sm3-256': 0x534d,
    'blake2b-8': 0xb201,
    'blake2b-16': 0xb202,
    'blake2b-24': 0xb203,
    'blake2b-32': 0xb204,
    'blake2b-40': 0xb205,
    'blake2b-48': 0xb206,
    'blake2b-56': 0xb207,
    'blake2b-64': 0xb208,
    'blake2b-72': 0xb209,
    'blake2b-80': 0xb20a,
    'blake2b-88': 0xb20b,
    'blake2b-96': 0xb20c,
    'blake2b-104': 0xb20d,
    'blake2b-112': 0xb20e,
    'blake2b-120': 0xb20f,
    'blake2b-128': 0xb210,
    'blake2b-136': 0xb211,
    'blake2b-144': 0xb212,
    'blake2b-152': 0xb213,
    'blake2b-160': 0xb214,
    'blake2b-168': 0xb215,
    'blake2b-176': 0xb216,
    'blake2b-184': 0xb217,
    'blake2b-192': 0xb218,
    'blake2b-200': 0xb219,
    'blake2b-208': 0xb21a,
    'blake2b-216': 0xb21b,
    'blake2b-224': 0xb21c,
    'blake2b-232': 0xb21d,
    'blake2b-240': 0xb21e,
    'blake2b-248': 0xb21f,
    'blake2b-256': 0xb220,
    'blake2b-264': 0xb221,
    'blake2b-272': 0xb222,
    'blake2b-280': 0xb223,
    'blake2b-288': 0xb224,
    'blake2b-296': 0xb225,
    'blake2b-304': 0xb226,
    'blake2b-312': 0xb227,
    'blake2b-320': 0xb228,
    'blake2b-328': 0xb229,
    'blake2b-336': 0xb22a,
    'blake2b-344': 0xb22b,
    'blake2b-352': 0xb22c,
    'blake2b-360': 0xb22d,
    'blake2b-368': 0xb22e,
    'blake2b-376': 0xb22f,
    'blake2b-384': 0xb230,
    'blake2b-392': 0xb231,
    'blake2b-400': 0xb232,
    'blake2b-408': 0xb233,
    'blake2b-416': 0xb234,
    'blake2b-424': 0xb235,
    'blake2b-432': 0xb236,
    'blake2b-440': 0xb237,
    'blake2b-448': 0xb238,
    'blake2b-456': 0xb239,
    'blake2b-464': 0xb23a,
    'blake2b-472': 0xb23b,
    'blake2b-480': 0xb23c,
    'blake2b-488': 0xb23d,
    'blake2b-496': 0xb23e,
    'blake2b-504': 0xb23f,
    'blake2b-512': 0xb240,
    'blake2s-8': 0xb241,
    'blake2s-16': 0xb242,
    'blake2s-24': 0xb243,
    'blake2s-32': 0xb244,
    'blake2s-40': 0xb245,
    'blake2s-48': 0xb246,
    'blake2s-56': 0xb247,
    'blake2s-64': 0xb248,
    'blake2s-72': 0xb249,
    'blake2s-80': 0xb24a,
    'blake2s-88': 0xb24b,
    'blake2s-96': 0xb24c,
    'blake2s-104': 0xb24d,
    'blake2s-112': 0xb24e,
    'blake2s-120': 0xb24f,
    'blake2s-128': 0xb250,
    'blake2s-136': 0xb251,
    'blake2s-144': 0xb252,
    'blake2s-152': 0xb253,
    'blake2s-160': 0xb254,
    'blake2s-168': 0xb255,
    'blake2s-176': 0xb256,
    'blake2s-184': 0xb257,
    'blake2s-192': 0xb258,
    'blake2s-200': 0xb259,
    'blake2s-208': 0xb25a,
    'blake2s-216': 0xb25b,
    'blake2s-224': 0xb25c,
    'blake2s-232': 0xb25d,
    'blake2s-240': 0xb25e,
    'blake2s-248': 0xb25f,
    'blake2s-256': 0xb260,
    'skein256-8': 0xb301,
    'skein256-16': 0xb302,
    'skein256-24': 0xb303,
    'skein256-32': 0xb304,
    'skein256-40': 0xb305,
    'skein256-48': 0xb306,
    'skein256-56': 0xb307,
    'skein256-64': 0xb308,
    'skein256-72': 0xb309,
    'skein256-80': 0xb30a,
    'skein256-88': 0xb30b,
    'skein256-96': 0xb30c,
    'skein256-104': 0xb30d,
    'skein256-112': 0xb30e,
    'skein256-120': 0xb30f,
    'skein256-128': 0xb310,
    'skein256-136': 0xb311,
    'skein256-144': 0xb312,
    'skein256-152': 0xb313,
    'skein256-160': 0xb314,
    'skein256-168': 0xb315,
    'skein256-176': 0xb316,
    'skein256-184': 0xb317,
    'skein256-192': 0xb318,
    'skein256-200': 0xb319,
    'skein256-208': 0xb31a,
    'skein256-216': 0xb31b,
    'skein256-224': 0xb31c,
    'skein256-232': 0xb31d,
    'skein256-240': 0xb31e,
    'skein256-248': 0xb31f,
    'skein256-256': 0xb320,
    'skein512-8': 0xb321,
    'skein512-16': 0xb322,
    'skein512-24': 0xb323,
    'skein512-32': 0xb324,
    'skein512-40': 0xb325,
    'skein512-48': 0xb326,
    'skein512-56': 0xb327,
    'skein512-64': 0xb328,
    'skein512-72': 0xb329,
    'skein512-80': 0xb32a,
    'skein512-88': 0xb32b,
    'skein512-96': 0xb32c,
    'skein512-104': 0xb32d,
    'skein512-112': 0xb32e,
    'skein512-120': 0xb32f,
    'skein512-128': 0xb330,
    'skein512-136': 0xb331,
    'skein512-144': 0xb332,
    'skein512-152': 0xb333,
    'skein512-160': 0xb334,
    'skein512-168': 0xb335,
    'skein512-176': 0xb336,
    'skein512-184': 0xb337,
    'skein512-192': 0xb338,
    'skein512-200': 0xb339,
    'skein512-208': 0xb33a,
    'skein512-216': 0xb33b,
    'skein512-224': 0xb33c,
    'skein512-232': 0xb33d,
    'skein512-240': 0xb33e,
    'skein512-248': 0xb33f,
    'skein512-256': 0xb340,
    'skein512-264': 0xb341,
    'skein512-272': 0xb342,
    'skein512-280': 0xb343,
    'skein512-288': 0xb344,
    'skein512-296': 0xb345,
    'skein512-304': 0xb346,
    'skein512-312': 0xb347,
    'skein512-320': 0xb348,
    'skein512-328': 0xb349,
    'skein512-336': 0xb34a,
    'skein512-344': 0xb34b,
    'skein512-352': 0xb34c,
    'skein512-360': 0xb34d,
    'skein512-368': 0xb34e,
    'skein512-376': 0xb34f,
    'skein512-384': 0xb350,
    'skein512-392': 0xb351,
    'skein512-400': 0xb352,
    'skein512-408': 0xb353,
    'skein512-416': 0xb354,
    'skein512-424': 0xb355,
    'skein512-432': 0xb356,
    'skein512-440': 0xb357,
    'skein512-448': 0xb358,
    'skein512-456': 0xb359,
    'skein512-464': 0xb35a,
    'skein512-472': 0xb35b,
    'skein512-480': 0xb35c,
    'skein512-488': 0xb35d,
    'skein512-496': 0xb35e,
    'skein512-504': 0xb35f,
    'skein512-512': 0xb360,
    'skein1024-8': 0xb361,
    'skein1024-16': 0xb362,
    'skein1024-24': 0xb363,
    'skein1024-32': 0xb364,
    'skein1024-40': 0xb365,
    'skein1024-48': 0xb366,
    'skein1024-56': 0xb367,
    'skein1024-64': 0xb368,
    'skein1024-72': 0xb369,
    'skein1024-80': 0xb36a,
    'skein1024-88': 0xb36b,
    'skein1024-96': 0xb36c,
    'skein1024-104': 0xb36d,
    'skein1024-112': 0xb36e,
    'skein1024-120': 0xb36f,
    'skein1024-128': 0xb370,
    'skein1024-136': 0xb371,
    'skein1024-144': 0xb372,
    'skein1024-152': 0xb373,
    'skein1024-160': 0xb374,
    'skein1024-168': 0xb375,
    'skein1024-176': 0xb376,
    'skein1024-184': 0xb377,
    'skein1024-192': 0xb378,
    'skein1024-200': 0xb379,
    'skein1024-208': 0xb37a,
    'skein1024-216': 0xb37b,
    'skein1024-224': 0xb37c,
    'skein1024-232': 0xb37d,
    'skein1024-240': 0xb37e,
    'skein1024-248': 0xb37f,
    'skein1024-256': 0xb380,
    'skein1024-264': 0xb381,
    'skein1024-272': 0xb382,
    'skein1024-280': 0xb383,
    'skein1024-288': 0xb384,
    'skein1024-296': 0xb385,
    'skein1024-304': 0xb386,
    'skein1024-312': 0xb387,
    'skein1024-320': 0xb388,
    'skein1024-328': 0xb389,
    'skein1024-336': 0xb38a,
    'skein1024-344': 0xb38b,
    'skein1024-352': 0xb38c,
    'skein1024-360': 0xb38d,
    'skein1024-368': 0xb38e,
    'skein1024-376': 0xb38f,
    'skein1024-384': 0xb390,
    'skein1024-392': 0xb391,
    'skein1024-400': 0xb392,
    'skein1024-408': 0xb393,
    'skein1024-416': 0xb394,
    'skein1024-424': 0xb395,
    'skein1024-432': 0xb396,
    'skein1024-440': 0xb397,
    'skein1024-448': 0xb398,
    'skein1024-456': 0xb399,
    'skein1024-464': 0xb39a,
    'skein1024-472': 0xb39b,
    'skein1024-480': 0xb39c,
    'skein1024-488': 0xb39d,
    'skein1024-496': 0xb39e,
    'skein1024-504': 0xb39f,
    'skein1024-512': 0xb3a0,
    'skein1024-520': 0xb3a1,
    'skein1024-528': 0xb3a2,
    'skein1024-536': 0xb3a3,
    'skein1024-544': 0xb3a4,
    'skein1024-552': 0xb3a5,
    'skein1024-560': 0xb3a6,
    'skein1024-568': 0xb3a7,
    'skein1024-576': 0xb3a8,
    'skein1024-584': 0xb3a9,
    'skein1024-592': 0xb3aa,
    'skein1024-600': 0xb3ab,
    'skein1024-608': 0xb3ac,
    'skein1024-616': 0xb3ad,
    'skein1024-624': 0xb3ae,
    'skein1024-632': 0xb3af,
    'skein1024-640': 0xb3b0,
    'skein1024-648': 0xb3b1,
    'skein1024-656': 0xb3b2,
    'skein1024-664': 0xb3b3,
    'skein1024-672': 0xb3b4,
    'skein1024-680': 0xb3b5,
    'skein1024-688': 0xb3b6,
    'skein1024-696': 0xb3b7,
    'skein1024-704': 0xb3b8,
    'skein1024-712': 0xb3b9,
    'skein1024-720': 0xb3ba,
    'skein1024-728': 0xb3bb,
    'skein1024-736': 0xb3bc,
    'skein1024-744': 0xb3bd,
    'skein1024-752': 0xb3be,
    'skein1024-760': 0xb3bf,
    'skein1024-768': 0xb3c0,
    'skein1024-776': 0xb3c1,
    'skein1024-784': 0xb3c2,
    'skein1024-792': 0xb3c3,
    'skein1024-800': 0xb3c4,
    'skein1024-808': 0xb3c5,
    'skein1024-816': 0xb3c6,
    'skein1024-824': 0xb3c7,
    'skein1024-832': 0xb3c8,
    'skein1024-840': 0xb3c9,
    'skein1024-848': 0xb3ca,
    'skein1024-856': 0xb3cb,
    'skein1024-864': 0xb3cc,
    'skein1024-872': 0xb3cd,
    'skein1024-880': 0xb3ce,
    'skein1024-888': 0xb3cf,
    'skein1024-896': 0xb3d0,
    'skein1024-904': 0xb3d1,
    'skein1024-912': 0xb3d2,
    'skein1024-920': 0xb3d3,
    'skein1024-928': 0xb3d4,
    'skein1024-936': 0xb3d5,
    'skein1024-944': 0xb3d6,
    'skein1024-952': 0xb3d7,
    'skein1024-960': 0xb3d8,
    'skein1024-968': 0xb3d9,
    'skein1024-976': 0xb3da,
    'skein1024-984': 0xb3db,
    'skein1024-992': 0xb3dc,
    'skein1024-1000': 0xb3dd,
    'skein1024-1008': 0xb3de,
    'skein1024-1016': 0xb3df,
    'skein1024-1024': 0xb3e0,
    'poseidon-bls12_381-a2-fc1': 0xb401,
    'poseidon-bls12_381-a2-fc1-sc': 0xb402
});
module.exports = {
    names: $fe5c24ccc9d8f463$var$names
};

});

parcelRegister("57dKE", function(module, exports) {
'use strict';

var $cKKV3 = parcelRequire("cKKV3");
/**
 * @typedef {import('./util/bases').SupportedEncodings} SupportedEncodings
 */ /**
 * Turns a `Uint8Array` into a string.
 *
 * Supports `utf8`, `utf-8` and any encoding supported by the multibase module.
 *
 * Also `ascii` which is similar to node's 'binary' encoding.
 *
 * @param {Uint8Array} array - The array to turn into a string
 * @param {SupportedEncodings} [encoding=utf8] - The encoding to use
 * @returns {string}
 */ function $3b9845f36f3548ab$var$toString(array, encoding = 'utf8') {
    const base = $cKKV3[encoding];
    if (!base) throw new Error(`Unsupported encoding "${encoding}"`);
    // strip multibase prefix
    return base.encoder.encode(array).substring(1);
}
module.exports = $3b9845f36f3548ab$var$toString;

});
parcelRegister("cKKV3", function(module, exports) {
'use strict';

var $c0Nzu = parcelRequire("c0Nzu");
var $948e2d1c026ff27e$require$bases = $c0Nzu.bases;
/**
 * @typedef {import('multiformats/bases/interface').MultibaseCodec<any>} MultibaseCodec
 */ /**
 * @param {string} name
 * @param {string} prefix
 * @param {(buf: Uint8Array) => string} encode
 * @param {(str: string) => Uint8Array} decode
 * @returns {MultibaseCodec}
 */ function $948e2d1c026ff27e$var$createCodec(name, prefix, encode, decode) {
    return {
        name: name,
        prefix: prefix,
        encoder: {
            name: name,
            prefix: prefix,
            encode: encode
        },
        decoder: {
            decode: decode
        }
    };
}
const $948e2d1c026ff27e$var$string = $948e2d1c026ff27e$var$createCodec('utf8', 'u', (buf)=>{
    const decoder = new TextDecoder('utf8');
    return 'u' + decoder.decode(buf);
}, (str)=>{
    const encoder = new TextEncoder();
    return encoder.encode(str.substring(1));
});
const $948e2d1c026ff27e$var$ascii = $948e2d1c026ff27e$var$createCodec('ascii', 'a', (buf)=>{
    let string = 'a';
    for(let i = 0; i < buf.length; i++)string += String.fromCharCode(buf[i]);
    return string;
}, (str)=>{
    str = str.substring(1);
    const buf = new Uint8Array(str.length);
    for(let i = 0; i < str.length; i++)buf[i] = str.charCodeAt(i);
    return buf;
});
/**
 * @typedef {'utf8' | 'utf-8' | 'hex' | 'latin1' | 'ascii' | 'binary' | keyof bases } SupportedEncodings
 */ /**
 * @type {Record<SupportedEncodings, MultibaseCodec>}
 */ const $948e2d1c026ff27e$var$BASES = {
    'utf8': $948e2d1c026ff27e$var$string,
    'utf-8': $948e2d1c026ff27e$var$string,
    'hex': $948e2d1c026ff27e$require$bases.base16,
    'latin1': $948e2d1c026ff27e$var$ascii,
    'ascii': $948e2d1c026ff27e$var$ascii,
    'binary': $948e2d1c026ff27e$var$ascii,
    ...$948e2d1c026ff27e$require$bases
};
module.exports = $948e2d1c026ff27e$var$BASES;

});
parcelRegister("c0Nzu", function(module, exports) {

$parcel$export(module.exports, "bases", function () { return $8bebeff6d6ff2db6$export$196f613671eb7dd9; });

var $1ffhG = parcelRequire("1ffhG");

var $7Sk9p = parcelRequire("7Sk9p");

var $aOvdb = parcelRequire("aOvdb");

var $8AoPD = parcelRequire("8AoPD");

var $1YvW3 = parcelRequire("1YvW3");

var $1sOTj = parcelRequire("1sOTj");

var $lVzdS = parcelRequire("lVzdS");

var $fkIEb = parcelRequire("fkIEb");

var $hAH2I = parcelRequire("hAH2I");

var $YF8aD = parcelRequire("YF8aD");

var $4etgu = parcelRequire("4etgu");

var $ghDf8 = parcelRequire("ghDf8");

var $5vV8E = parcelRequire("5vV8E");

var $df7WS = parcelRequire("df7WS");
parcelRequire("libLP");
var $gAVqk = parcelRequire("gAVqk");
var $45cfy = parcelRequire("45cfy");
var $lkuiA = parcelRequire("lkuiA");
var $1GK2R = parcelRequire("1GK2R");
var $7kX7z = parcelRequire("7kX7z");
const $8bebeff6d6ff2db6$export$196f613671eb7dd9 = {
    ...$1ffhG,
    ...$7Sk9p,
    ...$aOvdb,
    ...$8AoPD,
    ...$1YvW3,
    ...$1sOTj,
    ...$lVzdS,
    ...$fkIEb,
    ...$hAH2I,
    ...$YF8aD
};
const $8bebeff6d6ff2db6$export$cff071c6f82b8944 = {
    ...$4etgu,
    ...$ghDf8
};
const $8bebeff6d6ff2db6$export$b2c6ab3b27d60531 = {
    raw: $5vV8E,
    json: $df7WS
};

});
parcelRegister("1ffhG", function(module, exports) {

$parcel$export(module.exports, "identity", function () { return $0e830c4a14dab4ae$export$f0954fd7d5368655; });

var $hdc8N = parcelRequire("hdc8N");

var $7kX7z = parcelRequire("7kX7z");
const $0e830c4a14dab4ae$export$f0954fd7d5368655 = (0, $hdc8N.from)({
    prefix: '\0',
    name: 'identity',
    encode: (buf)=>(0, $7kX7z.toString)(buf),
    decode: (str)=>(0, $7kX7z.fromString)(str)
});

});
parcelRegister("hdc8N", function(module, exports) {

$parcel$export(module.exports, "from", function () { return $c87d117acb80876d$export$6788812c4e6611e6; });
$parcel$export(module.exports, "baseX", function () { return $c87d117acb80876d$export$180c73aedea7f385; });
$parcel$export(module.exports, "rfc4648", function () { return $c87d117acb80876d$export$fa9dde04c7d2f31a; });

var $4klY3 = parcelRequire("4klY3");

var $7kX7z = parcelRequire("7kX7z");
class $c87d117acb80876d$var$Encoder {
    constructor(name, prefix, baseEncode){
        this.name = name;
        this.prefix = prefix;
        this.baseEncode = baseEncode;
    }
    encode(bytes) {
        if (bytes instanceof Uint8Array) return `${this.prefix}${this.baseEncode(bytes)}`;
        else throw Error('Unknown type, must be binary type');
    }
}
class $c87d117acb80876d$var$Decoder {
    constructor(name, prefix, baseDecode){
        this.name = name;
        this.prefix = prefix;
        if (prefix.codePointAt(0) === undefined) throw new Error('Invalid prefix character');
        this.prefixCodePoint = prefix.codePointAt(0);
        this.baseDecode = baseDecode;
    }
    decode(text) {
        if (typeof text === 'string') {
            if (text.codePointAt(0) !== this.prefixCodePoint) throw Error(`Unable to decode multibase string ${JSON.stringify(text)}, ${this.name} decoder only supports inputs prefixed with ${this.prefix}`);
            return this.baseDecode(text.slice(this.prefix.length));
        } else throw Error('Can only multibase decode strings');
    }
    or(decoder) {
        return $c87d117acb80876d$export$252bb8b3bbdf6749(this, decoder);
    }
}
class $c87d117acb80876d$var$ComposedDecoder {
    constructor(decoders){
        this.decoders = decoders;
    }
    or(decoder) {
        return $c87d117acb80876d$export$252bb8b3bbdf6749(this, decoder);
    }
    decode(input) {
        const prefix = input[0];
        const decoder = this.decoders[prefix];
        if (decoder) return decoder.decode(input);
        else throw RangeError(`Unable to decode multibase string ${JSON.stringify(input)}, only inputs prefixed with ${Object.keys(this.decoders)} are supported`);
    }
}
const $c87d117acb80876d$export$252bb8b3bbdf6749 = (left, right)=>new $c87d117acb80876d$var$ComposedDecoder({
        ...left.decoders || {
            [left.prefix]: left
        },
        ...right.decoders || {
            [right.prefix]: right
        }
    });
class $c87d117acb80876d$export$a111e9ced3f1d2d0 {
    constructor(name, prefix, baseEncode, baseDecode){
        this.name = name;
        this.prefix = prefix;
        this.baseEncode = baseEncode;
        this.baseDecode = baseDecode;
        this.encoder = new $c87d117acb80876d$var$Encoder(name, prefix, baseEncode);
        this.decoder = new $c87d117acb80876d$var$Decoder(name, prefix, baseDecode);
    }
    encode(input) {
        return this.encoder.encode(input);
    }
    decode(input) {
        return this.decoder.decode(input);
    }
}
const $c87d117acb80876d$export$6788812c4e6611e6 = ({ name: name, prefix: prefix, encode: encode, decode: decode })=>new $c87d117acb80876d$export$a111e9ced3f1d2d0(name, prefix, encode, decode);
const $c87d117acb80876d$export$180c73aedea7f385 = ({ prefix: prefix, name: name, alphabet: alphabet })=>{
    const { encode: encode, decode: decode } = (0, $4klY3.default)(alphabet, name);
    return $c87d117acb80876d$export$6788812c4e6611e6({
        prefix: prefix,
        name: name,
        encode: encode,
        decode: (text)=>(0, $7kX7z.coerce)(decode(text))
    });
};
const $c87d117acb80876d$var$decode = (string, alphabet, bitsPerChar, name)=>{
    const codes = {};
    for(let i = 0; i < alphabet.length; ++i)codes[alphabet[i]] = i;
    let end = string.length;
    while(string[end - 1] === '=')--end;
    const out = new Uint8Array(end * bitsPerChar / 8 | 0);
    let bits = 0;
    let buffer = 0;
    let written = 0;
    for(let i = 0; i < end; ++i){
        const value = codes[string[i]];
        if (value === undefined) throw new SyntaxError(`Non-${name} character`);
        buffer = buffer << bitsPerChar | value;
        bits += bitsPerChar;
        if (bits >= 8) {
            bits -= 8;
            out[written++] = 255 & buffer >> bits;
        }
    }
    if (bits >= bitsPerChar || 255 & buffer << 8 - bits) throw new SyntaxError('Unexpected end of data');
    return out;
};
const $c87d117acb80876d$var$encode = (data, alphabet, bitsPerChar)=>{
    const pad = alphabet[alphabet.length - 1] === '=';
    const mask = (1 << bitsPerChar) - 1;
    let out = '';
    let bits = 0;
    let buffer = 0;
    for(let i = 0; i < data.length; ++i){
        buffer = buffer << 8 | data[i];
        bits += 8;
        while(bits > bitsPerChar){
            bits -= bitsPerChar;
            out += alphabet[mask & buffer >> bits];
        }
    }
    if (bits) out += alphabet[mask & buffer << bitsPerChar - bits];
    if (pad) while(out.length * bitsPerChar & 7)out += '=';
    return out;
};
const $c87d117acb80876d$export$fa9dde04c7d2f31a = ({ name: name, prefix: prefix, bitsPerChar: bitsPerChar, alphabet: alphabet })=>{
    return $c87d117acb80876d$export$6788812c4e6611e6({
        prefix: prefix,
        name: name,
        encode (input) {
            return $c87d117acb80876d$var$encode(input, alphabet, bitsPerChar);
        },
        decode (input) {
            return $c87d117acb80876d$var$decode(input, alphabet, bitsPerChar, name);
        }
    });
};

});
parcelRegister("4klY3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $326a11fcaf7036c5$export$2e2bcd8739ae039; });
function $326a11fcaf7036c5$var$base(ALPHABET, name) {
    if (ALPHABET.length >= 255) throw new TypeError('Alphabet too long');
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + ' is ambiguous');
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256);
    var iFACTOR = Math.log(256) / Math.log(BASE);
    function encode(source) {
        if (source instanceof Uint8Array) ;
        else if (ArrayBuffer.isView(source)) source = new Uint8Array(source.buffer, source.byteOffset, source.byteLength);
        else if (Array.isArray(source)) source = Uint8Array.from(source);
        if (!(source instanceof Uint8Array)) throw new TypeError('Expected Uint8Array');
        if (source.length === 0) return '';
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        while(pbegin !== pend){
            var carry = source[pbegin];
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error('Non-zero carry');
            length = i;
            pbegin++;
        }
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== 'string') throw new TypeError('Expected String');
        if (source.length === 0) return new Uint8Array();
        var psz = 0;
        if (source[psz] === ' ') return;
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        var size = (source.length - psz) * FACTOR + 1 >>> 0;
        var b256 = new Uint8Array(size);
        while(source[psz]){
            var carry = BASE_MAP[source.charCodeAt(psz)];
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error('Non-zero carry');
            length = i;
            psz++;
        }
        if (source[psz] === ' ') return;
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = new Uint8Array(zeroes + (size - it4));
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error(`Non-${name} character`);
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
var $326a11fcaf7036c5$var$src = $326a11fcaf7036c5$var$base;
var $326a11fcaf7036c5$var$_brrp__multiformats_scope_baseX = $326a11fcaf7036c5$var$src;
var $326a11fcaf7036c5$export$2e2bcd8739ae039 = $326a11fcaf7036c5$var$_brrp__multiformats_scope_baseX;

});

parcelRegister("7kX7z", function(module, exports) {

$parcel$export(module.exports, "equals", function () { return $557842dfb73dc22c$export$e9bab7fafb253603; });
$parcel$export(module.exports, "coerce", function () { return $557842dfb73dc22c$export$8c14e57e778d3873; });
$parcel$export(module.exports, "fromString", function () { return $557842dfb73dc22c$export$3004f64547af360e; });
$parcel$export(module.exports, "toString", function () { return $557842dfb73dc22c$export$f84e8e69fd4488a5; });
const $557842dfb73dc22c$export$6e22c362a0406a2c = new Uint8Array(0);
const $557842dfb73dc22c$export$7ea66e3774a60b67 = (d)=>d.reduce((hex, byte)=>hex + byte.toString(16).padStart(2, '0'), '');
const $557842dfb73dc22c$export$1a8ceedbd5845648 = (hex)=>{
    const hexes = hex.match(/../g);
    return hexes ? new Uint8Array(hexes.map((b)=>parseInt(b, 16))) : $557842dfb73dc22c$export$6e22c362a0406a2c;
};
const $557842dfb73dc22c$export$e9bab7fafb253603 = (aa, bb)=>{
    if (aa === bb) return true;
    if (aa.byteLength !== bb.byteLength) return false;
    for(let ii = 0; ii < aa.byteLength; ii++){
        if (aa[ii] !== bb[ii]) return false;
    }
    return true;
};
const $557842dfb73dc22c$export$8c14e57e778d3873 = (o)=>{
    if (o instanceof Uint8Array && o.constructor.name === 'Uint8Array') return o;
    if (o instanceof ArrayBuffer) return new Uint8Array(o);
    if (ArrayBuffer.isView(o)) return new Uint8Array(o.buffer, o.byteOffset, o.byteLength);
    throw new Error('Unknown type, must be binary type');
};
const $557842dfb73dc22c$export$37488ff1135b1696 = (o)=>o instanceof ArrayBuffer || ArrayBuffer.isView(o);
const $557842dfb73dc22c$export$3004f64547af360e = (str)=>new TextEncoder().encode(str);
const $557842dfb73dc22c$export$f84e8e69fd4488a5 = (b)=>new TextDecoder().decode(b);

});



parcelRegister("7Sk9p", function(module, exports) {

$parcel$export(module.exports, "base2", function () { return $5bbd350d07af480f$export$ed5f7917e37e31aa; });

var $hdc8N = parcelRequire("hdc8N");
const $5bbd350d07af480f$export$ed5f7917e37e31aa = (0, $hdc8N.rfc4648)({
    prefix: '0',
    name: 'base2',
    alphabet: '01',
    bitsPerChar: 1
});

});

parcelRegister("aOvdb", function(module, exports) {

$parcel$export(module.exports, "base8", function () { return $7df6c8deab17b7c1$export$43b580ac9deb5b96; });

var $hdc8N = parcelRequire("hdc8N");
const $7df6c8deab17b7c1$export$43b580ac9deb5b96 = (0, $hdc8N.rfc4648)({
    prefix: '7',
    name: 'base8',
    alphabet: '01234567',
    bitsPerChar: 3
});

});

parcelRegister("8AoPD", function(module, exports) {

$parcel$export(module.exports, "base10", function () { return $6404f29a0a0e3770$export$63d6a7de0ff813cc; });

var $hdc8N = parcelRequire("hdc8N");
const $6404f29a0a0e3770$export$63d6a7de0ff813cc = (0, $hdc8N.baseX)({
    prefix: '9',
    name: 'base10',
    alphabet: '0123456789'
});

});

parcelRegister("1YvW3", function(module, exports) {

$parcel$export(module.exports, "base16", function () { return $17042ab9e1e2ce77$export$586f61c71cb02fe4; });
$parcel$export(module.exports, "base16upper", function () { return $17042ab9e1e2ce77$export$2d835b8dd4032b62; });

var $hdc8N = parcelRequire("hdc8N");
const $17042ab9e1e2ce77$export$586f61c71cb02fe4 = (0, $hdc8N.rfc4648)({
    prefix: 'f',
    name: 'base16',
    alphabet: '0123456789abcdef',
    bitsPerChar: 4
});
const $17042ab9e1e2ce77$export$2d835b8dd4032b62 = (0, $hdc8N.rfc4648)({
    prefix: 'F',
    name: 'base16upper',
    alphabet: '0123456789ABCDEF',
    bitsPerChar: 4
});

});

parcelRegister("1sOTj", function(module, exports) {

$parcel$export(module.exports, "base32", function () { return $110fe1e079565019$export$4a4d5965e2738b2a; });
$parcel$export(module.exports, "base32upper", function () { return $110fe1e079565019$export$fbaa3bbbd754def4; });
$parcel$export(module.exports, "base32pad", function () { return $110fe1e079565019$export$e194fa100d329365; });
$parcel$export(module.exports, "base32padupper", function () { return $110fe1e079565019$export$3a9fc48d294dce32; });
$parcel$export(module.exports, "base32hex", function () { return $110fe1e079565019$export$c57d6760d519c8ac; });
$parcel$export(module.exports, "base32hexupper", function () { return $110fe1e079565019$export$8cf4640df3165d29; });
$parcel$export(module.exports, "base32hexpad", function () { return $110fe1e079565019$export$8c6a05c08ec7d456; });
$parcel$export(module.exports, "base32hexpadupper", function () { return $110fe1e079565019$export$29f73c6a744e639f; });
$parcel$export(module.exports, "base32z", function () { return $110fe1e079565019$export$fdad9af4bdc05e3; });

var $hdc8N = parcelRequire("hdc8N");
const $110fe1e079565019$export$4a4d5965e2738b2a = (0, $hdc8N.rfc4648)({
    prefix: 'b',
    name: 'base32',
    alphabet: 'abcdefghijklmnopqrstuvwxyz234567',
    bitsPerChar: 5
});
const $110fe1e079565019$export$fbaa3bbbd754def4 = (0, $hdc8N.rfc4648)({
    prefix: 'B',
    name: 'base32upper',
    alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567',
    bitsPerChar: 5
});
const $110fe1e079565019$export$e194fa100d329365 = (0, $hdc8N.rfc4648)({
    prefix: 'c',
    name: 'base32pad',
    alphabet: 'abcdefghijklmnopqrstuvwxyz234567=',
    bitsPerChar: 5
});
const $110fe1e079565019$export$3a9fc48d294dce32 = (0, $hdc8N.rfc4648)({
    prefix: 'C',
    name: 'base32padupper',
    alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=',
    bitsPerChar: 5
});
const $110fe1e079565019$export$c57d6760d519c8ac = (0, $hdc8N.rfc4648)({
    prefix: 'v',
    name: 'base32hex',
    alphabet: '0123456789abcdefghijklmnopqrstuv',
    bitsPerChar: 5
});
const $110fe1e079565019$export$8cf4640df3165d29 = (0, $hdc8N.rfc4648)({
    prefix: 'V',
    name: 'base32hexupper',
    alphabet: '0123456789ABCDEFGHIJKLMNOPQRSTUV',
    bitsPerChar: 5
});
const $110fe1e079565019$export$8c6a05c08ec7d456 = (0, $hdc8N.rfc4648)({
    prefix: 't',
    name: 'base32hexpad',
    alphabet: '0123456789abcdefghijklmnopqrstuv=',
    bitsPerChar: 5
});
const $110fe1e079565019$export$29f73c6a744e639f = (0, $hdc8N.rfc4648)({
    prefix: 'T',
    name: 'base32hexpadupper',
    alphabet: '0123456789ABCDEFGHIJKLMNOPQRSTUV=',
    bitsPerChar: 5
});
const $110fe1e079565019$export$fdad9af4bdc05e3 = (0, $hdc8N.rfc4648)({
    prefix: 'h',
    name: 'base32z',
    alphabet: 'ybndrfg8ejkmcpqxot1uwisza345h769',
    bitsPerChar: 5
});

});

parcelRegister("lVzdS", function(module, exports) {

$parcel$export(module.exports, "base36", function () { return $ff6a3e581d0198af$export$95b61e7c39ae893a; });
$parcel$export(module.exports, "base36upper", function () { return $ff6a3e581d0198af$export$bab7c9bdb963afd; });

var $hdc8N = parcelRequire("hdc8N");
const $ff6a3e581d0198af$export$95b61e7c39ae893a = (0, $hdc8N.baseX)({
    prefix: 'k',
    name: 'base36',
    alphabet: '0123456789abcdefghijklmnopqrstuvwxyz'
});
const $ff6a3e581d0198af$export$bab7c9bdb963afd = (0, $hdc8N.baseX)({
    prefix: 'K',
    name: 'base36upper',
    alphabet: '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ'
});

});

parcelRegister("fkIEb", function(module, exports) {

$parcel$export(module.exports, "base58btc", function () { return $b29b5b3fe2aef5ed$export$65c61748a9b98a2c; });
$parcel$export(module.exports, "base58flickr", function () { return $b29b5b3fe2aef5ed$export$c6a7baed2941aad2; });

var $hdc8N = parcelRequire("hdc8N");
const $b29b5b3fe2aef5ed$export$65c61748a9b98a2c = (0, $hdc8N.baseX)({
    name: 'base58btc',
    prefix: 'z',
    alphabet: '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz'
});
const $b29b5b3fe2aef5ed$export$c6a7baed2941aad2 = (0, $hdc8N.baseX)({
    name: 'base58flickr',
    prefix: 'Z',
    alphabet: '123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ'
});

});

parcelRegister("hAH2I", function(module, exports) {

$parcel$export(module.exports, "base64", function () { return $cce72fdbba8d1fb3$export$b3b2de96497acc47; });
$parcel$export(module.exports, "base64pad", function () { return $cce72fdbba8d1fb3$export$a9c086fc40b4563c; });
$parcel$export(module.exports, "base64url", function () { return $cce72fdbba8d1fb3$export$7d21597c7bc64465; });
$parcel$export(module.exports, "base64urlpad", function () { return $cce72fdbba8d1fb3$export$e87ddc9183aa53c9; });

var $hdc8N = parcelRequire("hdc8N");
const $cce72fdbba8d1fb3$export$b3b2de96497acc47 = (0, $hdc8N.rfc4648)({
    prefix: 'm',
    name: 'base64',
    alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',
    bitsPerChar: 6
});
const $cce72fdbba8d1fb3$export$a9c086fc40b4563c = (0, $hdc8N.rfc4648)({
    prefix: 'M',
    name: 'base64pad',
    alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
    bitsPerChar: 6
});
const $cce72fdbba8d1fb3$export$7d21597c7bc64465 = (0, $hdc8N.rfc4648)({
    prefix: 'u',
    name: 'base64url',
    alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_',
    bitsPerChar: 6
});
const $cce72fdbba8d1fb3$export$e87ddc9183aa53c9 = (0, $hdc8N.rfc4648)({
    prefix: 'U',
    name: 'base64urlpad',
    alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=',
    bitsPerChar: 6
});

});

parcelRegister("YF8aD", function(module, exports) {

$parcel$export(module.exports, "base256emoji", function () { return $0b65826d95574aba$export$6a5d4ab6075d2779; });

var $hdc8N = parcelRequire("hdc8N");
const $0b65826d95574aba$var$alphabet = Array.from('\uD83D\uDE80\uD83E\uDE90\u2604\uD83D\uDEF0\uD83C\uDF0C\uD83C\uDF11\uD83C\uDF12\uD83C\uDF13\uD83C\uDF14\uD83C\uDF15\uD83C\uDF16\uD83C\uDF17\uD83C\uDF18\uD83C\uDF0D\uD83C\uDF0F\uD83C\uDF0E\uD83D\uDC09\u2600\uD83D\uDCBB\uD83D\uDDA5\uD83D\uDCBE\uD83D\uDCBF\uD83D\uDE02\u2764\uD83D\uDE0D\uD83E\uDD23\uD83D\uDE0A\uD83D\uDE4F\uD83D\uDC95\uD83D\uDE2D\uD83D\uDE18\uD83D\uDC4D\uD83D\uDE05\uD83D\uDC4F\uD83D\uDE01\uD83D\uDD25\uD83E\uDD70\uD83D\uDC94\uD83D\uDC96\uD83D\uDC99\uD83D\uDE22\uD83E\uDD14\uD83D\uDE06\uD83D\uDE44\uD83D\uDCAA\uD83D\uDE09\u263A\uD83D\uDC4C\uD83E\uDD17\uD83D\uDC9C\uD83D\uDE14\uD83D\uDE0E\uD83D\uDE07\uD83C\uDF39\uD83E\uDD26\uD83C\uDF89\uD83D\uDC9E\u270C\u2728\uD83E\uDD37\uD83D\uDE31\uD83D\uDE0C\uD83C\uDF38\uD83D\uDE4C\uD83D\uDE0B\uD83D\uDC97\uD83D\uDC9A\uD83D\uDE0F\uD83D\uDC9B\uD83D\uDE42\uD83D\uDC93\uD83E\uDD29\uD83D\uDE04\uD83D\uDE00\uD83D\uDDA4\uD83D\uDE03\uD83D\uDCAF\uD83D\uDE48\uD83D\uDC47\uD83C\uDFB6\uD83D\uDE12\uD83E\uDD2D\u2763\uD83D\uDE1C\uD83D\uDC8B\uD83D\uDC40\uD83D\uDE2A\uD83D\uDE11\uD83D\uDCA5\uD83D\uDE4B\uD83D\uDE1E\uD83D\uDE29\uD83D\uDE21\uD83E\uDD2A\uD83D\uDC4A\uD83E\uDD73\uD83D\uDE25\uD83E\uDD24\uD83D\uDC49\uD83D\uDC83\uD83D\uDE33\u270B\uD83D\uDE1A\uD83D\uDE1D\uD83D\uDE34\uD83C\uDF1F\uD83D\uDE2C\uD83D\uDE43\uD83C\uDF40\uD83C\uDF37\uD83D\uDE3B\uD83D\uDE13\u2B50\u2705\uD83E\uDD7A\uD83C\uDF08\uD83D\uDE08\uD83E\uDD18\uD83D\uDCA6\u2714\uD83D\uDE23\uD83C\uDFC3\uD83D\uDC90\u2639\uD83C\uDF8A\uD83D\uDC98\uD83D\uDE20\u261D\uD83D\uDE15\uD83C\uDF3A\uD83C\uDF82\uD83C\uDF3B\uD83D\uDE10\uD83D\uDD95\uD83D\uDC9D\uD83D\uDE4A\uD83D\uDE39\uD83D\uDDE3\uD83D\uDCAB\uD83D\uDC80\uD83D\uDC51\uD83C\uDFB5\uD83E\uDD1E\uD83D\uDE1B\uD83D\uDD34\uD83D\uDE24\uD83C\uDF3C\uD83D\uDE2B\u26BD\uD83E\uDD19\u2615\uD83C\uDFC6\uD83E\uDD2B\uD83D\uDC48\uD83D\uDE2E\uD83D\uDE46\uD83C\uDF7B\uD83C\uDF43\uD83D\uDC36\uD83D\uDC81\uD83D\uDE32\uD83C\uDF3F\uD83E\uDDE1\uD83C\uDF81\u26A1\uD83C\uDF1E\uD83C\uDF88\u274C\u270A\uD83D\uDC4B\uD83D\uDE30\uD83E\uDD28\uD83D\uDE36\uD83E\uDD1D\uD83D\uDEB6\uD83D\uDCB0\uD83C\uDF53\uD83D\uDCA2\uD83E\uDD1F\uD83D\uDE41\uD83D\uDEA8\uD83D\uDCA8\uD83E\uDD2C\u2708\uD83C\uDF80\uD83C\uDF7A\uD83E\uDD13\uD83D\uDE19\uD83D\uDC9F\uD83C\uDF31\uD83D\uDE16\uD83D\uDC76\uD83E\uDD74\u25B6\u27A1\u2753\uD83D\uDC8E\uD83D\uDCB8\u2B07\uD83D\uDE28\uD83C\uDF1A\uD83E\uDD8B\uD83D\uDE37\uD83D\uDD7A\u26A0\uD83D\uDE45\uD83D\uDE1F\uD83D\uDE35\uD83D\uDC4E\uD83E\uDD32\uD83E\uDD20\uD83E\uDD27\uD83D\uDCCC\uD83D\uDD35\uD83D\uDC85\uD83E\uDDD0\uD83D\uDC3E\uD83C\uDF52\uD83D\uDE17\uD83E\uDD11\uD83C\uDF0A\uD83E\uDD2F\uD83D\uDC37\u260E\uD83D\uDCA7\uD83D\uDE2F\uD83D\uDC86\uD83D\uDC46\uD83C\uDFA4\uD83D\uDE47\uD83C\uDF51\u2744\uD83C\uDF34\uD83D\uDCA3\uD83D\uDC38\uD83D\uDC8C\uD83D\uDCCD\uD83E\uDD40\uD83E\uDD22\uD83D\uDC45\uD83D\uDCA1\uD83D\uDCA9\uD83D\uDC50\uD83D\uDCF8\uD83D\uDC7B\uD83E\uDD10\uD83E\uDD2E\uD83C\uDFBC\uD83E\uDD75\uD83D\uDEA9\uD83C\uDF4E\uD83C\uDF4A\uD83D\uDC7C\uD83D\uDC8D\uD83D\uDCE3\uD83E\uDD42');
const $0b65826d95574aba$var$alphabetBytesToChars = $0b65826d95574aba$var$alphabet.reduce((p, c, i)=>{
    p[i] = c;
    return p;
}, []);
const $0b65826d95574aba$var$alphabetCharsToBytes = $0b65826d95574aba$var$alphabet.reduce((p, c, i)=>{
    p[c.codePointAt(0)] = i;
    return p;
}, []);
function $0b65826d95574aba$var$encode(data) {
    return data.reduce((p, c)=>{
        p += $0b65826d95574aba$var$alphabetBytesToChars[c];
        return p;
    }, '');
}
function $0b65826d95574aba$var$decode(str) {
    const byts = [];
    for (const char of str){
        const byt = $0b65826d95574aba$var$alphabetCharsToBytes[char.codePointAt(0)];
        if (byt === undefined) throw new Error(`Non-base256emoji character: ${char}`);
        byts.push(byt);
    }
    return new Uint8Array(byts);
}
const $0b65826d95574aba$export$6a5d4ab6075d2779 = (0, $hdc8N.from)({
    prefix: '\uD83D\uDE80',
    name: 'base256emoji',
    encode: $0b65826d95574aba$var$encode,
    decode: $0b65826d95574aba$var$decode
});

});

parcelRegister("4etgu", function(module, exports) {

$parcel$export(module.exports, "sha256", function () { return $314f2ba2e2a4ed17$export$bced8d2aada2d1c9; });
$parcel$export(module.exports, "sha512", function () { return $314f2ba2e2a4ed17$export$a888d2532e6dc7bb; });

var $45cfy = parcelRequire("45cfy");
const $314f2ba2e2a4ed17$var$sha = (name)=>async (data)=>new Uint8Array(await crypto.subtle.digest(name, data));
const $314f2ba2e2a4ed17$export$bced8d2aada2d1c9 = (0, $45cfy.from)({
    name: 'sha2-256',
    code: 18,
    encode: $314f2ba2e2a4ed17$var$sha('SHA-256')
});
const $314f2ba2e2a4ed17$export$a888d2532e6dc7bb = (0, $45cfy.from)({
    name: 'sha2-512',
    code: 19,
    encode: $314f2ba2e2a4ed17$var$sha('SHA-512')
});

});
parcelRegister("45cfy", function(module, exports) {

$parcel$export(module.exports, "from", function () { return $2f9121a62a9fa05f$export$6788812c4e6611e6; });

var $lkuiA = parcelRequire("lkuiA");
const $2f9121a62a9fa05f$export$6788812c4e6611e6 = ({ name: name, code: code, encode: encode })=>new $2f9121a62a9fa05f$export$df06eed23808f4d0(name, code, encode);
class $2f9121a62a9fa05f$export$df06eed23808f4d0 {
    constructor(name, code, encode){
        this.name = name;
        this.code = code;
        this.encode = encode;
    }
    digest(input) {
        if (input instanceof Uint8Array) {
            const result = this.encode(input);
            return result instanceof Uint8Array ? $lkuiA.create(this.code, result) : result.then((digest)=>$lkuiA.create(this.code, digest));
        } else throw Error('Unknown type, must be binary type');
    }
}

});
parcelRegister("lkuiA", function(module, exports) {

$parcel$export(module.exports, "create", function () { return $f872f7f098bd3ac2$export$185802fd694ee1f5; });
$parcel$export(module.exports, "Digest", function () { return $f872f7f098bd3ac2$export$d67a82ff561eff43; });
$parcel$export(module.exports, "decode", function () { return $f872f7f098bd3ac2$export$2f872c0f2117be69; });
$parcel$export(module.exports, "equals", function () { return $f872f7f098bd3ac2$export$e9bab7fafb253603; });

var $7kX7z = parcelRequire("7kX7z");

var $1GK2R = parcelRequire("1GK2R");
const $f872f7f098bd3ac2$export$185802fd694ee1f5 = (code, digest)=>{
    const size = digest.byteLength;
    const sizeOffset = $1GK2R.encodingLength(code);
    const digestOffset = sizeOffset + $1GK2R.encodingLength(size);
    const bytes = new Uint8Array(digestOffset + size);
    $1GK2R.encodeTo(code, bytes, 0);
    $1GK2R.encodeTo(size, bytes, sizeOffset);
    bytes.set(digest, digestOffset);
    return new $f872f7f098bd3ac2$export$d67a82ff561eff43(code, size, digest, bytes);
};
const $f872f7f098bd3ac2$export$2f872c0f2117be69 = (multihash)=>{
    const bytes = (0, $7kX7z.coerce)(multihash);
    const [code, sizeOffset] = $1GK2R.decode(bytes);
    const [size, digestOffset] = $1GK2R.decode(bytes.subarray(sizeOffset));
    const digest = bytes.subarray(sizeOffset + digestOffset);
    if (digest.byteLength !== size) throw new Error('Incorrect length');
    return new $f872f7f098bd3ac2$export$d67a82ff561eff43(code, size, digest, bytes);
};
const $f872f7f098bd3ac2$export$e9bab7fafb253603 = (a, b)=>{
    if (a === b) return true;
    else return a.code === b.code && a.size === b.size && (0, $7kX7z.equals)(a.bytes, b.bytes);
};
class $f872f7f098bd3ac2$export$d67a82ff561eff43 {
    constructor(code, size, digest, bytes){
        this.code = code;
        this.size = size;
        this.digest = digest;
        this.bytes = bytes;
    }
}

});
parcelRegister("1GK2R", function(module, exports) {

$parcel$export(module.exports, "decode", function () { return $13ad6e4acc277cbb$export$2f872c0f2117be69; });
$parcel$export(module.exports, "encodeTo", function () { return $13ad6e4acc277cbb$export$8512cbe4228de3b3; });
$parcel$export(module.exports, "encodingLength", function () { return $13ad6e4acc277cbb$export$cbee51f25f0626d7; });

var $jInbk = parcelRequire("jInbk");
const $13ad6e4acc277cbb$export$2f872c0f2117be69 = (data, offset = 0)=>{
    const code = (0, $jInbk.default).decode(data, offset);
    return [
        code,
        (0, $jInbk.default).decode.bytes
    ];
};
const $13ad6e4acc277cbb$export$8512cbe4228de3b3 = (int, target, offset = 0)=>{
    (0, $jInbk.default).encode(int, target, offset);
    return target;
};
const $13ad6e4acc277cbb$export$cbee51f25f0626d7 = (int)=>{
    return (0, $jInbk.default).encodingLength(int);
};

});
parcelRegister("jInbk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e5a41bcd774ee19c$export$2e2bcd8739ae039; });
var $e5a41bcd774ee19c$var$encode_1 = $e5a41bcd774ee19c$var$encode;
var $e5a41bcd774ee19c$var$MSB = 128, $e5a41bcd774ee19c$var$REST = 127, $e5a41bcd774ee19c$var$MSBALL = ~$e5a41bcd774ee19c$var$REST, $e5a41bcd774ee19c$var$INT = Math.pow(2, 31);
function $e5a41bcd774ee19c$var$encode(num, out, offset) {
    out = out || [];
    offset = offset || 0;
    var oldOffset = offset;
    while(num >= $e5a41bcd774ee19c$var$INT){
        out[offset++] = num & 255 | $e5a41bcd774ee19c$var$MSB;
        num /= 128;
    }
    while(num & $e5a41bcd774ee19c$var$MSBALL){
        out[offset++] = num & 255 | $e5a41bcd774ee19c$var$MSB;
        num >>>= 7;
    }
    out[offset] = num | 0;
    $e5a41bcd774ee19c$var$encode.bytes = offset - oldOffset + 1;
    return out;
}
var $e5a41bcd774ee19c$var$decode = $e5a41bcd774ee19c$var$read;
var $e5a41bcd774ee19c$var$MSB$1 = 128, $e5a41bcd774ee19c$var$REST$1 = 127;
function $e5a41bcd774ee19c$var$read(buf, offset) {
    var res = 0, offset = offset || 0, shift = 0, counter = offset, b, l = buf.length;
    do {
        if (counter >= l) {
            $e5a41bcd774ee19c$var$read.bytes = 0;
            throw new RangeError('Could not decode varint');
        }
        b = buf[counter++];
        res += shift < 28 ? (b & $e5a41bcd774ee19c$var$REST$1) << shift : (b & $e5a41bcd774ee19c$var$REST$1) * Math.pow(2, shift);
        shift += 7;
    }while (b >= $e5a41bcd774ee19c$var$MSB$1);
    $e5a41bcd774ee19c$var$read.bytes = counter - offset;
    return res;
}
var $e5a41bcd774ee19c$var$N1 = Math.pow(2, 7);
var $e5a41bcd774ee19c$var$N2 = Math.pow(2, 14);
var $e5a41bcd774ee19c$var$N3 = Math.pow(2, 21);
var $e5a41bcd774ee19c$var$N4 = Math.pow(2, 28);
var $e5a41bcd774ee19c$var$N5 = Math.pow(2, 35);
var $e5a41bcd774ee19c$var$N6 = Math.pow(2, 42);
var $e5a41bcd774ee19c$var$N7 = Math.pow(2, 49);
var $e5a41bcd774ee19c$var$N8 = Math.pow(2, 56);
var $e5a41bcd774ee19c$var$N9 = Math.pow(2, 63);
var $e5a41bcd774ee19c$var$length = function(value) {
    return value < $e5a41bcd774ee19c$var$N1 ? 1 : value < $e5a41bcd774ee19c$var$N2 ? 2 : value < $e5a41bcd774ee19c$var$N3 ? 3 : value < $e5a41bcd774ee19c$var$N4 ? 4 : value < $e5a41bcd774ee19c$var$N5 ? 5 : value < $e5a41bcd774ee19c$var$N6 ? 6 : value < $e5a41bcd774ee19c$var$N7 ? 7 : value < $e5a41bcd774ee19c$var$N8 ? 8 : value < $e5a41bcd774ee19c$var$N9 ? 9 : 10;
};
var $e5a41bcd774ee19c$var$varint = {
    encode: $e5a41bcd774ee19c$var$encode_1,
    decode: $e5a41bcd774ee19c$var$decode,
    encodingLength: $e5a41bcd774ee19c$var$length
};
var $e5a41bcd774ee19c$var$_brrp_varint = $e5a41bcd774ee19c$var$varint;
var $e5a41bcd774ee19c$export$2e2bcd8739ae039 = $e5a41bcd774ee19c$var$_brrp_varint;

});





parcelRegister("ghDf8", function(module, exports) {

$parcel$export(module.exports, "identity", function () { return $bdacacb7db06ce88$export$f0954fd7d5368655; });

var $7kX7z = parcelRequire("7kX7z");

var $lkuiA = parcelRequire("lkuiA");
const $bdacacb7db06ce88$var$code = 0;
const $bdacacb7db06ce88$var$name = 'identity';
const $bdacacb7db06ce88$var$encode = (0, $7kX7z.coerce);
const $bdacacb7db06ce88$var$digest = (input)=>$lkuiA.create($bdacacb7db06ce88$var$code, $bdacacb7db06ce88$var$encode(input));
const $bdacacb7db06ce88$export$f0954fd7d5368655 = {
    code: $bdacacb7db06ce88$var$code,
    name: $bdacacb7db06ce88$var$name,
    encode: $bdacacb7db06ce88$var$encode,
    digest: $bdacacb7db06ce88$var$digest
};

});

parcelRegister("5vV8E", function(module, exports) {

$parcel$export(module.exports, "name", function () { return $403c2b878f1d3b39$export$a8ff84c12d48cfa6; });
$parcel$export(module.exports, "code", function () { return $403c2b878f1d3b39$export$6565f9f03506010b; });
$parcel$export(module.exports, "encode", function () { return $403c2b878f1d3b39$export$c564cdbbe6da493; });
$parcel$export(module.exports, "decode", function () { return $403c2b878f1d3b39$export$2f872c0f2117be69; });

var $7kX7z = parcelRequire("7kX7z");
const $403c2b878f1d3b39$export$a8ff84c12d48cfa6 = 'raw';
const $403c2b878f1d3b39$export$6565f9f03506010b = 85;
const $403c2b878f1d3b39$export$c564cdbbe6da493 = (node)=>(0, $7kX7z.coerce)(node);
const $403c2b878f1d3b39$export$2f872c0f2117be69 = (data)=>(0, $7kX7z.coerce)(data);

});

parcelRegister("df7WS", function(module, exports) {

$parcel$export(module.exports, "name", function () { return $9a42d77d7433efef$export$a8ff84c12d48cfa6; });
$parcel$export(module.exports, "code", function () { return $9a42d77d7433efef$export$6565f9f03506010b; });
$parcel$export(module.exports, "encode", function () { return $9a42d77d7433efef$export$c564cdbbe6da493; });
$parcel$export(module.exports, "decode", function () { return $9a42d77d7433efef$export$2f872c0f2117be69; });
const $9a42d77d7433efef$var$textEncoder = new TextEncoder();
const $9a42d77d7433efef$var$textDecoder = new TextDecoder();
const $9a42d77d7433efef$export$a8ff84c12d48cfa6 = 'json';
const $9a42d77d7433efef$export$6565f9f03506010b = 512;
const $9a42d77d7433efef$export$c564cdbbe6da493 = (node)=>$9a42d77d7433efef$var$textEncoder.encode(JSON.stringify(node));
const $9a42d77d7433efef$export$2f872c0f2117be69 = (data)=>JSON.parse($9a42d77d7433efef$var$textDecoder.decode(data));

});

parcelRegister("libLP", function(module, exports) {

var $gAVqk = parcelRequire("gAVqk");

var $1GK2R = parcelRequire("1GK2R");

var $7kX7z = parcelRequire("7kX7z");

var $45cfy = parcelRequire("45cfy");

var $lkuiA = parcelRequire("lkuiA");

});
parcelRegister("gAVqk", function(module, exports) {

var $1GK2R = parcelRequire("1GK2R");

var $lkuiA = parcelRequire("lkuiA");

var $fkIEb = parcelRequire("fkIEb");

var $1sOTj = parcelRequire("1sOTj");

var $7kX7z = parcelRequire("7kX7z");
class $c14c8d42c9ead59e$export$12d863fcef3f6aa {
    constructor(version, code, multihash, bytes){
        this.code = code;
        this.version = version;
        this.multihash = multihash;
        this.bytes = bytes;
        this.byteOffset = bytes.byteOffset;
        this.byteLength = bytes.byteLength;
        this.asCID = this;
        this._baseCache = new Map();
        Object.defineProperties(this, {
            byteOffset: $c14c8d42c9ead59e$var$hidden,
            byteLength: $c14c8d42c9ead59e$var$hidden,
            code: $c14c8d42c9ead59e$var$readonly,
            version: $c14c8d42c9ead59e$var$readonly,
            multihash: $c14c8d42c9ead59e$var$readonly,
            bytes: $c14c8d42c9ead59e$var$readonly,
            _baseCache: $c14c8d42c9ead59e$var$hidden,
            asCID: $c14c8d42c9ead59e$var$hidden
        });
    }
    toV0() {
        switch(this.version){
            case 0:
                return this;
            default:
                {
                    const { code: code, multihash: multihash } = this;
                    if (code !== $c14c8d42c9ead59e$var$DAG_PB_CODE) throw new Error('Cannot convert a non dag-pb CID to CIDv0');
                    if (multihash.code !== $c14c8d42c9ead59e$var$SHA_256_CODE) throw new Error('Cannot convert non sha2-256 multihash CID to CIDv0');
                    return $c14c8d42c9ead59e$export$12d863fcef3f6aa.createV0(multihash);
                }
        }
    }
    toV1() {
        switch(this.version){
            case 0:
                {
                    const { code: code, digest: digest } = this.multihash;
                    const multihash = $lkuiA.create(code, digest);
                    return $c14c8d42c9ead59e$export$12d863fcef3f6aa.createV1(this.code, multihash);
                }
            case 1:
                return this;
            default:
                throw Error(`Can not convert CID version ${this.version} to version 0. This is a bug please report`);
        }
    }
    equals(other) {
        return other && this.code === other.code && this.version === other.version && $lkuiA.equals(this.multihash, other.multihash);
    }
    toString(base) {
        const { bytes: bytes, version: version, _baseCache: _baseCache } = this;
        switch(version){
            case 0:
                return $c14c8d42c9ead59e$var$toStringV0(bytes, _baseCache, base || (0, $fkIEb.base58btc).encoder);
            default:
                return $c14c8d42c9ead59e$var$toStringV1(bytes, _baseCache, base || (0, $1sOTj.base32).encoder);
        }
    }
    toJSON() {
        return {
            code: this.code,
            version: this.version,
            hash: this.multihash.bytes
        };
    }
    get [Symbol.toStringTag]() {
        return 'CID';
    }
    [Symbol.for('nodejs.util.inspect.custom')]() {
        return 'CID(' + this.toString() + ')';
    }
    static isCID(value) {
        $c14c8d42c9ead59e$var$deprecate(/^0\.0/, $c14c8d42c9ead59e$var$IS_CID_DEPRECATION);
        return !!(value && (value[$c14c8d42c9ead59e$var$cidSymbol] || value.asCID === value));
    }
    get toBaseEncodedString() {
        throw new Error('Deprecated, use .toString()');
    }
    get codec() {
        throw new Error('"codec" property is deprecated, use integer "code" property instead');
    }
    get buffer() {
        throw new Error('Deprecated .buffer property, use .bytes to get Uint8Array instead');
    }
    get multibaseName() {
        throw new Error('"multibaseName" property is deprecated');
    }
    get prefix() {
        throw new Error('"prefix" property is deprecated');
    }
    static asCID(value) {
        if (value instanceof $c14c8d42c9ead59e$export$12d863fcef3f6aa) return value;
        else if (value != null && value.asCID === value) {
            const { version: version, code: code, multihash: multihash, bytes: bytes } = value;
            return new $c14c8d42c9ead59e$export$12d863fcef3f6aa(version, code, multihash, bytes || $c14c8d42c9ead59e$var$encodeCID(version, code, multihash.bytes));
        } else if (value != null && value[$c14c8d42c9ead59e$var$cidSymbol] === true) {
            const { version: version, multihash: multihash, code: code } = value;
            const digest = $lkuiA.decode(multihash);
            return $c14c8d42c9ead59e$export$12d863fcef3f6aa.create(version, code, digest);
        } else return null;
    }
    static create(version, code, digest) {
        if (typeof code !== 'number') throw new Error('String codecs are no longer supported');
        switch(version){
            case 0:
                if (code !== $c14c8d42c9ead59e$var$DAG_PB_CODE) throw new Error(`Version 0 CID must use dag-pb (code: ${$c14c8d42c9ead59e$var$DAG_PB_CODE}) block encoding`);
                else return new $c14c8d42c9ead59e$export$12d863fcef3f6aa(version, code, digest, digest.bytes);
            case 1:
                {
                    const bytes = $c14c8d42c9ead59e$var$encodeCID(version, code, digest.bytes);
                    return new $c14c8d42c9ead59e$export$12d863fcef3f6aa(version, code, digest, bytes);
                }
            default:
                throw new Error('Invalid version');
        }
    }
    static createV0(digest) {
        return $c14c8d42c9ead59e$export$12d863fcef3f6aa.create(0, $c14c8d42c9ead59e$var$DAG_PB_CODE, digest);
    }
    static createV1(code, digest) {
        return $c14c8d42c9ead59e$export$12d863fcef3f6aa.create(1, code, digest);
    }
    static decode(bytes) {
        const [cid, remainder] = $c14c8d42c9ead59e$export$12d863fcef3f6aa.decodeFirst(bytes);
        if (remainder.length) throw new Error('Incorrect length');
        return cid;
    }
    static decodeFirst(bytes) {
        const specs = $c14c8d42c9ead59e$export$12d863fcef3f6aa.inspectBytes(bytes);
        const prefixSize = specs.size - specs.multihashSize;
        const multihashBytes = (0, $7kX7z.coerce)(bytes.subarray(prefixSize, prefixSize + specs.multihashSize));
        if (multihashBytes.byteLength !== specs.multihashSize) throw new Error('Incorrect length');
        const digestBytes = multihashBytes.subarray(specs.multihashSize - specs.digestSize);
        const digest = new $lkuiA.Digest(specs.multihashCode, specs.digestSize, digestBytes, multihashBytes);
        const cid = specs.version === 0 ? $c14c8d42c9ead59e$export$12d863fcef3f6aa.createV0(digest) : $c14c8d42c9ead59e$export$12d863fcef3f6aa.createV1(specs.codec, digest);
        return [
            cid,
            bytes.subarray(specs.size)
        ];
    }
    static inspectBytes(initialBytes) {
        let offset = 0;
        const next = ()=>{
            const [i, length] = $1GK2R.decode(initialBytes.subarray(offset));
            offset += length;
            return i;
        };
        let version = next();
        let codec = $c14c8d42c9ead59e$var$DAG_PB_CODE;
        if (version === 18) {
            version = 0;
            offset = 0;
        } else if (version === 1) codec = next();
        if (version !== 0 && version !== 1) throw new RangeError(`Invalid CID version ${version}`);
        const prefixSize = offset;
        const multihashCode = next();
        const digestSize = next();
        const size = offset + digestSize;
        const multihashSize = size - prefixSize;
        return {
            version: version,
            codec: codec,
            multihashCode: multihashCode,
            digestSize: digestSize,
            multihashSize: multihashSize,
            size: size
        };
    }
    static parse(source, base) {
        const [prefix, bytes] = $c14c8d42c9ead59e$var$parseCIDtoBytes(source, base);
        const cid = $c14c8d42c9ead59e$export$12d863fcef3f6aa.decode(bytes);
        cid._baseCache.set(prefix, source);
        return cid;
    }
}
const $c14c8d42c9ead59e$var$parseCIDtoBytes = (source, base)=>{
    switch(source[0]){
        case 'Q':
            {
                const decoder = base || (0, $fkIEb.base58btc);
                return [
                    (0, $fkIEb.base58btc).prefix,
                    decoder.decode(`${(0, $fkIEb.base58btc).prefix}${source}`)
                ];
            }
        case (0, $fkIEb.base58btc).prefix:
            {
                const decoder = base || (0, $fkIEb.base58btc);
                return [
                    (0, $fkIEb.base58btc).prefix,
                    decoder.decode(source)
                ];
            }
        case (0, $1sOTj.base32).prefix:
            {
                const decoder = base || (0, $1sOTj.base32);
                return [
                    (0, $1sOTj.base32).prefix,
                    decoder.decode(source)
                ];
            }
        default:
            if (base == null) throw Error('To parse non base32 or base58btc encoded CID multibase decoder must be provided');
            return [
                source[0],
                base.decode(source)
            ];
    }
};
const $c14c8d42c9ead59e$var$toStringV0 = (bytes, cache, base)=>{
    const { prefix: prefix } = base;
    if (prefix !== (0, $fkIEb.base58btc).prefix) throw Error(`Cannot string encode V0 in ${base.name} encoding`);
    const cid = cache.get(prefix);
    if (cid == null) {
        const cid = base.encode(bytes).slice(1);
        cache.set(prefix, cid);
        return cid;
    } else return cid;
};
const $c14c8d42c9ead59e$var$toStringV1 = (bytes, cache, base)=>{
    const { prefix: prefix } = base;
    const cid = cache.get(prefix);
    if (cid == null) {
        const cid = base.encode(bytes);
        cache.set(prefix, cid);
        return cid;
    } else return cid;
};
const $c14c8d42c9ead59e$var$DAG_PB_CODE = 112;
const $c14c8d42c9ead59e$var$SHA_256_CODE = 18;
const $c14c8d42c9ead59e$var$encodeCID = (version, code, multihash)=>{
    const codeOffset = $1GK2R.encodingLength(version);
    const hashOffset = codeOffset + $1GK2R.encodingLength(code);
    const bytes = new Uint8Array(hashOffset + multihash.byteLength);
    $1GK2R.encodeTo(version, bytes, 0);
    $1GK2R.encodeTo(code, bytes, codeOffset);
    bytes.set(multihash, hashOffset);
    return bytes;
};
const $c14c8d42c9ead59e$var$cidSymbol = Symbol.for('@ipld/js-cid/CID');
const $c14c8d42c9ead59e$var$readonly = {
    writable: false,
    configurable: false,
    enumerable: true
};
const $c14c8d42c9ead59e$var$hidden = {
    writable: false,
    enumerable: false,
    configurable: false
};
const $c14c8d42c9ead59e$var$version = '0.0.0-dev';
const $c14c8d42c9ead59e$var$deprecate = (range, message)=>{
    if (range.test($c14c8d42c9ead59e$var$version)) console.warn(message);
    else throw new Error(message);
};
const $c14c8d42c9ead59e$var$IS_CID_DEPRECATION = `CID.isCID(v) is deprecated and will be removed in the next major release.
Following code pattern:

if (CID.isCID(value)) {
  doSomethingWithCID(value)
}

Is replaced with:

const cid = CID.asCID(value)
if (cid) {
  // Make sure to use cid instead of value
  doSomethingWithCID(cid)
}
`;

});





parcelRegister("cvLi9", function(module, exports) {
'use strict';

var $cKKV3 = parcelRequire("cKKV3");
/**
 * @typedef {import('./util/bases').SupportedEncodings} SupportedEncodings
 */ /**
 * Create a `Uint8Array` from the passed string
 *
 * Supports `utf8`, `utf-8`, `hex`, and any encoding supported by the multiformats module.
 *
 * Also `ascii` which is similar to node's 'binary' encoding.
 *
 * @param {string} string
 * @param {SupportedEncodings} [encoding=utf8] - utf8, base16, base64, base64urlpad, etc
 * @returns {Uint8Array}
 */ function $91bd107769b33832$var$fromString(string, encoding = 'utf8') {
    const base = $cKKV3[encoding];
    if (!base) throw new Error(`Unsupported encoding "${encoding}"`);
    // add multibase prefix
    return base.decoder.decode(`${base.prefix}${string}`);
}
module.exports = $91bd107769b33832$var$fromString;

});

parcelRegister("gg53d", function(module, exports) {
'use strict';
/**
 * Returns a new Uint8Array created by concatenating the passed ArrayLikes
 *
 * @param {Array<ArrayLike<number>>} arrays
 * @param {number} [length]
 */ function $bd620ef28c12eecb$var$concat(arrays, length) {
    if (!length) length = arrays.reduce((acc, curr)=>acc + curr.length, 0);
    const output = new Uint8Array(length);
    let offset = 0;
    for (const arr of arrays){
        output.set(arr, offset);
        offset += arr.length;
    }
    return output;
}
module.exports = $bd620ef28c12eecb$var$concat;

});


parcelRegister("5cAwf", function(module, exports) {

var $3Dz4Y = parcelRequire("3Dz4Y");

var $f5gxW = parcelRequire("f5gxW");

var $3IH32 = parcelRequire("3IH32");

var $cbZCz = parcelRequire("cbZCz");

var $e6fPk = parcelRequire("e6fPk");
function $3c9a66ad3cb1f258$var$formatGrouped(context, data, type, filter, coreKey) {
    // Group fields into extensions
    let groups = {};
    for(let field in data){
        let value;
        try {
            let parts = field.split(/:(.*)/);
            if (parts.length === 1) parts.unshift(coreKey);
            let ext = parts[0];
            if (typeof filter === 'function' && !filter(field, [
                field
            ])) continue;
            value = data[field];
            let spec = $3Dz4Y.getSpecification(field, type);
            // Move to another extension (e.g. if no prefix is provided)
            if (spec.ext) ext = spec.ext;
            // Special handling for summaries that contain a list with keys (e.g. cube:dimensions, gee:schema)
            // There's usually just a single object included, so get that as value
            let isSummarizedListWithKeys = false;
            if (type === 'summaries' && spec.listWithKeys && Array.isArray(value) && value.length > 0) {
                value = value[0];
                isSummarizedListWithKeys = true;
            }
            // Fill items with missing properties
            let items = null;
            let itemOrder = [];
            if ($f5gxW.isObject(spec.items)) {
                let temp = value;
                // Ignore keys for lists that are stored as object (e.g. cube:dimensions)
                if (spec.listWithKeys) temp = Object.values(temp);
                let itemFieldNames = [];
                if (Array.isArray(temp)) itemFieldNames = $f5gxW.keysFromListOfObjects(temp);
                else if ($f5gxW.isObject(temp)) itemFieldNames = Object.keys(temp);
                items = {};
                // Remove fields from list that are not available in the data
                itemOrder = spec.itemOrder.filter((fieldName)=>itemFieldNames.includes(fieldName));
                itemFieldNames.forEach((key)=>{
                    if (typeof spec.items[key] === 'undefined') {
                        // Add fields that are not specified in fields.json
                        items[key] = {
                            label: $f5gxW.formatKey(key),
                            explain: key
                        };
                        // Place non-specified fields at the end
                        itemOrder.push(key);
                    } else {
                        // Clone field spec from fields.json
                        items[key] = Object.assign({}, spec.items[key]);
                        items[key].label = $3c9a66ad3cb1f258$var$label(key, spec.items[key]);
                    }
                });
            }
            // Format values
            let formatted;
            // Handle summaries
            if (type === 'summaries') {
                if (!isSummarizedListWithKeys && $f5gxW.isObject(value)) {
                    if (typeof value.minimum !== 'undefined' && typeof value.maximum !== 'undefined') {
                        const formatSummaryValue = (x)=>$3c9a66ad3cb1f258$var$format(x, field, context, data, spec, filter, [
                                field
                            ]);
                        if (value.minimum === value.maximum) formatted = formatSummaryValue(value.minimum);
                        else if (value.minimum === null) formatted = `< ${formatSummaryValue(value.maximum)}`;
                        else if (value.maximum === null) formatted = `> ${formatSummaryValue(value.minimum)}`;
                        else formatted = `${formatSummaryValue(value.minimum)} \u{2013} ${formatSummaryValue(value.maximum)}`;
                    } else formatted = $cbZCz.object(value);
                } else if ($3Dz4Y.externalRenderer && items) {
                    let formatted = isSummarizedListWithKeys ? Object.assign({}, value) : value.slice(0);
                    // Go through each field's summary
                    for(let i in formatted){
                        let result = $f5gxW.isObject(formatted[i]) ? {} : [];
                        // Go through each entry in a field's summary (this is basically a single value as defined in the Item spec)
                        for(let key in items)result[key] = $3c9a66ad3cb1f258$var$format(formatted[i][key], key, context, data, items[key]);
                        formatted[i] = result;
                    }
                } else if (Array.isArray(value)) formatted = $f5gxW.toList(value, !spec.custom && !spec.items, (v)=>$3c9a66ad3cb1f258$var$format(v, field, context, data, spec));
                else console.warn(`Invalid summary value: ${value}`);
            }
            // Fallback to "normal" rendering if not handled by summaries yet
            if (typeof formatted === 'undefined') formatted = $3c9a66ad3cb1f258$var$format(value, field, context, data, spec, filter, [
                field
            ]);
            // Add group if missing
            if (!$f5gxW.isObject(groups[ext])) groups[ext] = {
                extension: ext,
                label: $3c9a66ad3cb1f258$var$extension(ext),
                properties: {}
            };
            groups[ext].properties[field] = {
                label: $3c9a66ad3cb1f258$var$label(field, spec),
                value: value,
                formatted: formatted,
                items: items,
                itemOrder: itemOrder,
                spec: spec
            };
        } catch (error) {
            console.error(`Field '${field}' with value '${value}' resulted in an error`, error);
        }
    }
    return Object.values(groups).sort((a, b)=>$3IH32.collator.compare(a.extension, b.extension));
}
// For assets (item and collection) and item-assets (extension)
function $3c9a66ad3cb1f258$var$formatAsset(asset, context, filter = null, coreKey = '') {
    return $3c9a66ad3cb1f258$var$formatGrouped(context, asset, 'assets', filter, coreKey);
}
// For links
function $3c9a66ad3cb1f258$var$formatLink(link, context, filter = null, coreKey = '') {
    return $3c9a66ad3cb1f258$var$formatGrouped(context, link, 'links', filter, coreKey);
}
// For Providers
function $3c9a66ad3cb1f258$var$formatProvider(provider, context, filter = null, coreKey = '') {
    return $3c9a66ad3cb1f258$var$formatGrouped(context, provider, 'providers', filter, coreKey);
}
// For Collection summaries
function $3c9a66ad3cb1f258$var$formatSummaries(collection, filter = null, coreKey = '') {
    return $3c9a66ad3cb1f258$var$formatGrouped(collection, collection.summaries, 'summaries', filter, coreKey);
}
// For Collections
function $3c9a66ad3cb1f258$var$formatCollection(collection, filter = null, coreKey = '') {
    return $3c9a66ad3cb1f258$var$formatGrouped(collection, collection, 'collection', filter, coreKey);
}
// For Catalogs
function $3c9a66ad3cb1f258$var$formatCatalog(catalog, filter = null, coreKey = '') {
    return $3c9a66ad3cb1f258$var$formatGrouped(catalog, catalog, 'catalog', filter, coreKey);
}
// For item properties
function $3c9a66ad3cb1f258$var$formatItemProperties(item, filter = null, coreKey = '') {
    return $3c9a66ad3cb1f258$var$formatGrouped(item, item.properties, 'metadata', filter, coreKey);
}
function $3c9a66ad3cb1f258$var$format(value, field, context = null, parent = null, spec = null, filter = null, path = []) {
    if (!$f5gxW.isObject(spec)) spec = $3Dz4Y.getSpecification(field);
    if (typeof spec.format === 'string') {
        let fn = $e6fPk[`format${spec.format}`];
        if (!fn) console.warn(`Formatter '${spec.format}' not available.`);
        return fn(value, field, spec, context, parent);
    } else if (typeof spec.formatter === 'function') return spec.formatter(value, field, spec, context, parent);
    else if ($f5gxW.isObject(spec.mapping)) {
        let key = String(value);
        if (typeof spec.mapping[key] !== 'undefined') value = spec.mapping[key];
        else if (typeof spec.mapping[key.toLowerCase()] !== 'undefined') value = spec.mapping[key.toLowerCase()];
        else if (typeof spec.mapping[key.toUpperCase()] !== 'undefined') value = spec.mapping[key.toUpperCase()];
        return $cbZCz.format($f5gxW.t(value), spec.unit);
    } else if (value === null && spec.null) return $cbZCz.null(spec.null);
    else if (Array.isArray(value)) {
        let callback = (v, i)=>$3c9a66ad3cb1f258$var$format(v, field, context, parent, spec, filter, path.concat([
                i
            ]));
        if (typeof filter === 'function' && path.length > 0) value = value.filter((v, i)=>filter(path[0], path.concat([
                i
            ])));
        if ($3Dz4Y.externalRenderer && (spec.custom || spec.items)) return value.map(callback);
        else return $f5gxW.toList(value, false, callback);
    } else if ($f5gxW.isObject(value)) {
        let callbackSpec = (k)=>{
            if ($f5gxW.isObject(spec.items)) return spec.listWithKeys ? {
                items: spec.items,
                itemOrder: spec.itemOrder
            } : spec.items[k];
            else if ($f5gxW.isObject(spec.properties)) return spec.properties[k];
            return {};
        };
        let callbackValue = (v, k, p)=>$3c9a66ad3cb1f258$var$format(v, k, context, p, callbackSpec(k), filter, path.concat([
                k
            ]));
        if ($3Dz4Y.externalRenderer && (spec.custom || spec.items || spec.properties)) {
            let formattedValues = {};
            for(let key in value){
                if (typeof filter === 'function' && path.length > 0 && !filter(path[0], path.concat([
                    key
                ]))) continue;
                formattedValues[key] = callbackValue(value[key], key, value);
            }
            return formattedValues;
        } else {
            let callbackLabel = (k)=>$3c9a66ad3cb1f258$var$label(k, callbackSpec(k));
            let itemOrder = spec.listWithKeys ? [] : spec.itemOrder;
            return $f5gxW.toObject(value, callbackValue, callbackLabel, itemOrder, filter, path);
        }
    } else return $cbZCz.format(value, spec.unit);
}
function $3c9a66ad3cb1f258$var$label(key, spec = null) {
    if (!$f5gxW.isObject(spec)) spec = $3Dz4Y.getSpecification(key);
    if ($f5gxW.isObject(spec) && typeof spec.label === 'string') {
        if (typeof spec.explain === 'string') {
            if (spec.explain.match(/^https?:\/\//i)) return $f5gxW.toLink(spec.explain, $f5gxW.t(spec.label), "about");
            else return $f5gxW.abbrev($f5gxW.t(spec.label), $f5gxW.t(spec.explain));
        } else if (typeof spec.label === 'string') return $f5gxW.t(spec.label);
    }
    return $f5gxW.formatKey(key);
}
function $3c9a66ad3cb1f258$var$extension(key) {
    return $3c9a66ad3cb1f258$var$label(key, $3Dz4Y.getExtension(key));
}
module.exports = {
    format: $3c9a66ad3cb1f258$var$format,
    label: $3c9a66ad3cb1f258$var$label,
    extension: $3c9a66ad3cb1f258$var$extension,
    formatCatalog: $3c9a66ad3cb1f258$var$formatCatalog,
    formatCollection: $3c9a66ad3cb1f258$var$formatCollection,
    formatSummaries: $3c9a66ad3cb1f258$var$formatSummaries,
    formatItemProperties: $3c9a66ad3cb1f258$var$formatItemProperties,
    formatAsset: $3c9a66ad3cb1f258$var$formatAsset,
    formatLink: $3c9a66ad3cb1f258$var$formatLink,
    formatProvider: $3c9a66ad3cb1f258$var$formatProvider,
    formatGrouped: $3c9a66ad3cb1f258$var$formatGrouped
};

});
parcelRegister("3Dz4Y", function(module, exports) {

var $fE1hr = parcelRequire("fE1hr");
const $2a6039a4382d66e3$var$Registry = {
    externalRenderer: false,
    dependencies: {},
    fields: {
        assets: {},
        extensions: {},
        links: {},
        metadata: {}
    },
    exportFields () {
        return this.fields;
    },
    importFields (fields) {
        fields = $fE1hr.fields(fields);
        for(let key in this.fields)Object.assign(this.fields[key], fields[key]);
    },
    getDependency (name) {
        if (!this.dependencies[name]) console.warn(`Dependency '${name}' not registered.`);
        return this.dependencies[name];
    },
    addDependency (name, library) {
        this.dependencies[name] = library;
    },
    addExtension (prefix, spec) {
        this.fields.extensions[prefix] = $fE1hr.field(spec, this.fields.extensions);
    },
    addMetadataField (field, spec) {
        this.fields.metadata[field] = $fE1hr.field(spec, this.fields.metadata);
    },
    addLinkField (field, spec) {
        this.fields.links[field] = $fE1hr.field(spec, this.fields.links);
    },
    addAssetField (field, spec) {
        this.fields.assets[field] = $fE1hr.field(spec, this.fields.assets);
    },
    addMetadataFields (specs) {
        for(var key in specs)$2a6039a4382d66e3$var$Registry.addMetadataField(key, specs[key]);
    },
    getExtension (name) {
        if (this.fields.extensions[name]) return this.fields.extensions[name];
        else return {};
    },
    getSpecification (field, type = null) {
        let spec = {};
        if (type === 'assets' && this.fields.assets[field]) spec = this.fields.assets[field];
        else if (type === 'links' && this.fields.links[field]) spec = this.fields.links[field];
        else if (this.fields.metadata[field]) spec = this.fields.metadata[field];
        return spec;
    }
};
module.exports = $2a6039a4382d66e3$var$Registry;

});
parcelRegister("fE1hr", function(module, exports) {

var $f5gxW = parcelRequire("f5gxW");

var $3IH32 = parcelRequire("3IH32");
const $b63b95a9e6d484fa$var$Normalize = {
    fields (fields) {
        let parts = [
            'extensions',
            'metadata',
            'links',
            'assets'
        ];
        for (let part of parts)for(let key in fields[part])fields[part][key] = $b63b95a9e6d484fa$var$Normalize.field(fields[part][key], fields[part], fields);
        return fields;
    },
    field (spec, fields = {}, allFields = {}) {
        // If just a string label is given, make a normal object with a label from it
        if (typeof spec === 'string') return {
            label: spec
        };
        // Resolve alias
        if (typeof spec.alias === 'string') {
            // As we don't know whether the alias has been resolved so far, resolve it here, too.
            let aliasedSpec = fields[spec.alias] || allFields.metadata[spec.alias];
            if (!aliasedSpec) throw new Error('Alias is invalid: ' + spec.alias);
            return Object.assign(spec, $b63b95a9e6d484fa$var$Normalize.field(aliasedSpec, fields, allFields));
        }
        // Normalize items
        if ($f5gxW.isObject(spec.items)) {
            let itemOrder = [];
            for(let key in spec.items){
                spec.items[key] = $b63b95a9e6d484fa$var$Normalize.field(spec.items[key], fields, allFields);
                itemOrder.push(Object.assign({
                    key: key
                }, spec.items[key]));
            }
            spec.itemOrder = itemOrder.sort((i1, i2)=>{
                if (i1.id === true) return -1;
                else if (i2.id === true) return 1;
                else if (typeof i1.order === 'number' && typeof i2.order === 'number') return i1.order - i2.order;
                else return $3IH32.collator.compare($f5gxW.t(i1.label), $f5gxW.t(i2.label));
            }).map((item)=>item.key);
        }
        // Normalize properties
        if ($f5gxW.isObject(spec.properties)) for(let key in spec.properties)spec.properties[key] = $b63b95a9e6d484fa$var$Normalize.field(spec.properties[key], fields, allFields);
        return spec;
    }
};
module.exports = $b63b95a9e6d484fa$var$Normalize;

});


parcelRegister("cbZCz", function(module, exports) {

var $f5gxW = parcelRequire("f5gxW");

var $3IH32 = parcelRequire("3IH32");
const $8e064fc8feee3a1d$var$DataTypes = {
    array (arr, sort = false, unit = '') {
        return $f5gxW.toList(arr, sort, (v)=>$8e064fc8feee3a1d$var$DataTypes.format(v, unit));
    },
    object (obj) {
        return $f5gxW.toObject(obj, (v)=>$8e064fc8feee3a1d$var$DataTypes.format(v));
    },
    null (label = null) {
        if (label === null) label = $f5gxW.t('n/a');
        return $f5gxW.toNothing(label);
    },
    number (num, unit = '') {
        if (typeof num !== 'number') num = parseFloat(num);
        return $f5gxW.unit($3IH32.numberFormatter.format(num), unit);
    },
    string (str, unit = '') {
        if (str.startsWith("http://") || str.startsWith("https://")) {
            const url = URL.parse(str);
            if (url) return $f5gxW.toLink(url.toString());
        }
        return $f5gxW.unit($f5gxW.e(str).replace(/(\r\n|\r|\n){2,}/g, '<br>'), unit);
    },
    boolean (bool) {
        return bool ? "\u2714\uFE0F" : "\u274C";
    },
    format (value, unit = '') {
        if (typeof value === 'boolean') return $8e064fc8feee3a1d$var$DataTypes.boolean(value);
        else if (typeof value === 'number') return $8e064fc8feee3a1d$var$DataTypes.number(value, unit);
        else if (typeof value === 'string') return $8e064fc8feee3a1d$var$DataTypes.string(value, unit);
        else if (Array.isArray(value)) return $8e064fc8feee3a1d$var$DataTypes.array(value, unit);
        else if ($f5gxW.isObject(value)) return $8e064fc8feee3a1d$var$DataTypes.object(value);
        else return $8e064fc8feee3a1d$var$DataTypes.null();
    }
};
module.exports = $8e064fc8feee3a1d$var$DataTypes;

});

parcelRegister("e6fPk", function(module, exports) {

var $f5gxW = parcelRequire("f5gxW");

var $cbZCz = parcelRequire("cbZCz");

var $3IH32 = parcelRequire("3IH32");

var $3Dz4Y = parcelRequire("3Dz4Y");

const $a43de722b9f1af91$var$Formatters = {
    allowHtmlInCommonMark: false,
    formatUrl (value, field, spec = {}, context = null, parent = null) {
        let title = $f5gxW.isObject(parent) && typeof parent === 'string' ? parent.title : value;
        return $f5gxW.toLink(value, title, parent.rel || "");
    },
    formatLink (value) {
        return $f5gxW.toList(value, false, (value)=>$f5gxW.toLink(value.href, value.title, value.rel));
    },
    formatMediaType (value, field, spec = {}) {
        return $f5gxW.e($f5gxW.t($a43de722b9f1af91$var$Formatters._formatMediaType(value, field, spec)));
    },
    _formatMediaType (value, field, spec = {}) {
        let short = Boolean(spec.shorten);
        const mediaType = $3Dz4Y.getDependency('content-type');
        if (!mediaType) return short ? "" : $f5gxW.e(value);
        let media;
        try {
            media = mediaType.parse(value);
        } catch (error) {
            console.warn(error);
            return short ? "" : $f5gxW.e(value);
        }
        switch(media.type){
            // not supported: image/vnd.stac.geotiff; cloud-optimized=true
            case 'image/vnd.stac.geotiff':
            case 'image/tiff':
                if (media.parameters.application === "geotiff") {
                    if (media.parameters.profile === "cloud-optimized") return short ? 'COG' : 'Cloud-Optimized GeoTIFF image';
                    else return short ? 'GeoTiff' : 'GeoTIFF image';
                } else return short ? 'TIFF' : 'TIFF image';
            case 'image/jp2':
                return short ? 'JPEG 2000' : 'JPEG 2000 image';
            case 'image/png':
            case 'image/apng':
            case 'image/vnd.mozilla.apng':
                return short ? 'PNG' : 'PNG image';
            case 'image/gif':
                return short ? 'GIF' : 'GIF image';
            case 'image/jpeg':
            case 'image/jpg':
                return short ? 'JPEG' : 'JPEG image';
            case 'image/webp':
                return short ? 'WebP' : 'WebP image';
            case 'image/bmp':
            case 'image/x-bmp':
            case 'image/x-ms-bmp':
            case 'image/wbmp':
                return short ? 'Bitmap' : 'Bitmap image';
            case 'image/svg+xml':
                return short ? 'SVG' : 'SVG vector image';
            case 'text/csv':
                return short ? 'CSV' : 'Comma-separated values (CSV)';
            case 'text/xml':
            case 'application/xml':
                return 'XML';
            case 'text/json':
            case 'application/json':
                return 'JSON';
            case 'application/x-ndjson':
                return short ? 'NDJSON' : 'Newline Delimited JSON';
            case 'text/yaml':
            case 'text/vnd.yaml':
            case 'text/x-yaml':
            case 'application/x-yaml':
                return 'YAML';
            case 'application/geo+json':
                return 'GeoJSON';
            case 'application/gml+xml':
                return 'GML';
            case 'application/vnd.google-earth.kml+xml':
            case 'application/vnd.google-earth.kmz':
                return 'KML';
            case 'application/geopackage+vnd.sqlite3':
            case 'application/geopackage+sqlite3':
                return 'GeoPackage';
            case 'text/html':
            case 'application/html':
            case 'application/xhtml+xml':
                return short ? 'HTML' : 'HTML (Website)';
            case 'text/plain':
                return short ? 'Text' : 'Text document';
            case 'text/markdown':
                return short ? 'Markdown' : 'Markdown document';
            case 'application/pdf':
                return short ? 'PDF' : 'PDF document';
            case 'application/zip':
                return short ? 'ZIP' : 'ZIP archive';
            case 'application/gzip':
                return short ? 'GZIP' : 'GZIP archive';
            case 'application/x-hdf':
                return 'HDF';
            case 'application/netcdf':
            case 'application/x-netcdf':
                return 'NetCDF';
            case 'application/x.mrf':
                return short ? 'MRF' : 'Meta Raster Format';
            case 'application/wmo-GRIB2':
                return 'GRIB 2';
            case 'application/grib':
                return `GRIB ${media.parameters.edition || ""}`.trim();
            case 'application/bufr':
                return `BUFR ${media.parameters.edition || ""}`.trim();
            case 'application/octet-stream':
                return short ? 'Binary' : 'Binary file';
            case 'application/vnd.laszip':
                return 'LASzip';
            case 'application/vnd.laszip+copc':
                return short ? 'COPC' : 'Cloud-Optimized Point Cloud (LASzip)';
            case 'application/vnd+zarr':
            case 'application/x-zarr':
            // both from https://github.com/zarr-developers/zarr-specs/issues/123
            case 'application/vnd.zarr':
                if (media.parameters.profile === 'multiscales') // from https://github.com/radiantearth/stac-best-practices/blob/main/best-practices-zarr.md#asset-organization
                return short ? 'WOZ' : 'Web-Optimized Zarr';
                else {
                    const version = media.parameters.version;
                    return !short && version ? `Zarr (${version})` : 'Zarr';
                }
            case 'application/x-parquet':
            case 'application/vnd.apache.parquet':
                return 'Parquet';
            case 'application/vnd.pmtiles':
                return 'PMTiles';
            case 'application/vnd.cov+json':
                return 'CoverageJSON';
            case 'application/vnd.flatgeobuf':
                return 'FlatGeobuf'; // unofficial: https://github.com/flatgeobuf/flatgeobuf/discussions/112
            case 'application/x-filegdb':
                return short ? 'Geodatabase' : 'Esri File Geodatabase';
            case 'application/vnd.nitf':
                return short ? 'NITF' : 'National Imagery Transmission Format';
            case 'application/3dtiles+json':
                return '3D Tiles';
            default:
                {
                    let [group, format] = media.type.split('/');
                    format = $f5gxW.formatKey(format.replace(/^(vnd|x)[.+-]/, ''));
                    if (short) return format;
                    switch(group){
                        case 'audio':
                            return `${format} audio`;
                        case 'image':
                            return `${format} image`;
                        case 'font':
                            return `Font`;
                        case 'model':
                            return `${format} 3D model`;
                        case 'video':
                            return `${format} video`;
                        case 'text':
                        case 'application':
                            return format;
                        default:
                            return value;
                    }
                }
        }
    },
    formatTimestamp (value) {
        if (typeof value === 'string') try {
            return $3IH32.dateTimeFormatter.format(new Date(value));
        } catch (error) {}
        return $cbZCz.null();
    },
    formatPercent0to1 (value, field, spec = {}) {
        return $cbZCz.number(value * 100, spec.unit);
    },
    formatDate (value) {
        if (typeof value === 'string') try {
            return $3IH32.dateFormatter.format(new Date(value));
        } catch (error) {}
        return $cbZCz.null();
    },
    formatDuration (value) {
        if (typeof value === 'string') {
            const lib = $3Dz4Y.getDependency('@musement/iso-duration');
            if (!lib) return $f5gxW.e(value);
            const { isoDuration: isoDuration, en: en } = lib;
            isoDuration.setLocales({
                en: en
            }, {
                fallbackLocale: 'en'
            });
            let formatted = isoDuration(value).humanize('en');
            if (formatted.length === 0) return $f5gxW.e($f5gxW.t('none'));
            else return $f5gxW.e(formatted);
        }
        return $cbZCz.null();
    },
    formatLanguageCode (value) {
        if (Array.isArray(value)) return $f5gxW.toList(value, true, $a43de722b9f1af91$var$Formatters.formatLanguageCode, false);
        else if (typeof value !== 'string' || value.length < 2) return $cbZCz.null();
        const list = (parcelRequire("ggVZQ"));
        const [code, ...rest] = value.split('-');
        if (code in list) {
            const name = list[code];
            if (rest.length > 0) return $f5gxW.e($f5gxW.t(`${name} (${rest.join(' ')})`));
            return $f5gxW.e($f5gxW.t(name));
        }
        return $f5gxW.e($f5gxW.t(value));
    },
    formatLicense (value, field, spec = {}, context = null) {
        if (typeof value !== 'string' || value.length === 0) return $cbZCz.null();
        // We could use the spdx-license-ids and/or spdx-to-html packages previously used in STAC Browser,
        // but let's try it without additional dependency for now.
        if (value !== 'other' && value !== 'proprietary' && value !== 'various' && value.match(/^[\w\.\-]+$/i)) return $f5gxW.toLink(`https://spdx.org/licenses/${value}.html`, value, "license");
        let licenses = Array.isArray(context.links) ? context.links.filter((link)=>$f5gxW.isObject(link) && typeof link.href === 'string' && link.rel === 'license') : [];
        if (licenses.length > 0) return $f5gxW.toList(licenses, false, (link)=>$f5gxW.toLink(link.href, link.title || value, "license"));
        else return $cbZCz.string(value);
    },
    formatProviders (value) {
        return $f5gxW.toList(value, false, (provider)=>{
            let name = provider.name;
            let roles = '';
            let description = '';
            if (typeof provider.url === 'string' && provider.url.length > 0) name = $f5gxW.toLink(provider.url, name);
            if (Array.isArray(provider.roles) && provider.roles.length > 0) {
                roles = provider.roles.map((r)=>$cbZCz.format(r)).join(', ');
                roles = ` (<em>${roles}</em>)`;
            }
            if (typeof provider.description === 'string' && provider.description.length > 0) description = $a43de722b9f1af91$var$Formatters.formatCommonMark(provider.description);
            return `${name}${roles}${description}`;
        });
    },
    formatCommonMark (value) {
        if (typeof value !== 'string' || value.length === 0) return $cbZCz.null();
        const commonmark = $3Dz4Y.getDependency('commonmark');
        let html;
        if (commonmark) {
            let reader = new commonmark.Parser();
            let writer = new commonmark.HtmlRenderer({
                safe: !$a43de722b9f1af91$var$Formatters.allowHtmlInCommonMark,
                smart: true
            });
            html = writer.render(reader.parse(value));
        } else if ($a43de722b9f1af91$var$Formatters.allowHtmlInCommonMark) html = value;
        else html = $f5gxW.e(value);
        return `<div class="description">${html}</div>`;
    },
    formatSoftware (value) {
        if (!$f5gxW.isObject(value)) return $cbZCz.null();
        let list = [];
        for(let software in value){
            let version = value[software];
            if (typeof version === 'string' && version.length > 0 || typeof version === 'number') list.push(`${software} (${version})`);
            else list.push(software);
        }
        return $f5gxW.toList(list, true, null, false);
    },
    formatDOI (value) {
        value = $cbZCz.format(value);
        return $f5gxW.toLink(`http://doi.org/${value}`, value);
    },
    formatCRS (value) {
        return $f5gxW.toList(value, false, (value)=>{
            if (typeof value === 'string') {
                let title = value.replace(/^https?:\/\/www\.opengis\.net\/def\/crs\//i, '') // HTTP(s) URI
                .replace(/^urn:ogc:def:crs:/i, ''); // OGC URN
                return $f5gxW.toLink(value, title);
            }
            return $cbZCz.format(value);
        });
    },
    formatCrsCode (value) {
        if (typeof value === 'string') {
            const [authority, code] = value.split(':', 2);
            switch(authority.toUpperCase()){
                case 'EPSG':
                case 'ESRI':
                case 'IAU_2015':
                case 'IGNF':
                case 'MKG':
                case 'OGC':
                    return $f5gxW.toLink(`https://spatialreference.org/ref/${authority.toLowerCase()}/${code}/`, value);
                default:
                    return $cbZCz.string(value);
            }
        }
        return $cbZCz.null();
    },
    /**
	 * @deprecated Use formatCrsCode instead
	 */ formatEPSG (value) {
        if (typeof value === 'number') return $a43de722b9f1af91$var$Formatters.formatCrsCode(`EPSG:${value}`);
        else if (typeof value === 'string') return $a43de722b9f1af91$var$Formatters.formatCrsCode(value);
        return $cbZCz.null();
    },
    formatExtent (value, field, spec = {}) {
        if (!Array.isArray(value) || value.length < 2) return $cbZCz.null();
        else if (value[0] === value[1]) return $cbZCz.format(value[0], spec.unit);
        else if (value[0] === null) return `< ${$cbZCz.format(value[1], spec.unit)}`;
        else if (value[1] === null) return `> ${$cbZCz.format(value[0], spec.unit)}`;
        else return value.map((v)=>$cbZCz.format(v, spec.unit)).join(" \u2013 ");
    },
    formatHexColor (value) {
        if (typeof value !== 'string' || !value.match(/^#?[\dA-F]{3,8}$/i)) return $cbZCz.null();
        if (value.startsWith('#')) value = value.substring(1);
        return `<div class="color" style="background-color: #${value}"><code class="color-code">#${value}</code></div>`;
    },
    formatPROJJSON (value) {
        if (!$f5gxW.isObject(value)) return $cbZCz.null();
        if ($f5gxW.isObject(value.id) && value.id.authority === 'EPSG' && typeof value.code === 'number' && value.code > 0) return 'EPSG ' + $a43de722b9f1af91$var$Formatters.formatEPSG(value);
        else if (typeof value.name === 'string') return $cbZCz.string(value.name);
        else return $cbZCz.object(value);
    },
    formatTemporalExtent (value, field, spec = {}) {
        if (!Array.isArray(value) || value.length !== 2) return $cbZCz.null();
        value = value.map((d)=>{
            try {
                return d ? new Date(d) : null;
            } catch (e) {
                return null;
            }
        });
        try {
            const [start, end] = value;
            if (start || end) {
                const base = spec.shorten ? $3IH32.dateFormatter : $3IH32.dateTimeFormatter;
                if (!start) return $f5gxW.t("Until {0}", [
                    base.format(end)
                ]);
                else if (!end) return $f5gxW.t("{0} until present", [
                    base.format(start)
                ]);
                else return base.formatRange(start, end);
            }
        } catch (error) {}
        return $cbZCz.null();
    },
    formatTemporalExtents (value, field, spec = {}) {
        let sortExtents = (a, b)=>{
            if (a[0] === null) return -1;
            else return $3IH32.collator.compare(a[0], b[0]);
        };
        return $f5gxW.toList(value, sortExtents, (v)=>$a43de722b9f1af91$var$Formatters.formatTemporalExtent(v, field, spec));
    },
    formatWKT2 (value) {
        if (typeof value !== 'string') return $cbZCz.null();
        // This is a VERY simplistic WKT2 formatter, which may fail to render properly in some cases.
        let indent = -1;
        let formatted;
        try {
            formatted = value.replace(/([A-Z]+)\[|\]/ig, (match, keyword)=>{
                if (match === ']') {
                    indent--;
                    return match;
                } else {
                    indent++;
                    let tabs = "  ".repeat(indent);
                    return `\n${tabs}${keyword}[`;
                }
            });
        } catch (e) {
            // In case the formatting did not work properly
            // (usually the number of [ and ] doesn't match)
            // just return the unformatted value
            formatted = value;
        }
        return `<pre>${formatted}</pre>`;
    },
    fileSizeUnits: [
        'B',
        'kB',
        'MB',
        'GB',
        'TB'
    ],
    formatFileSize (value) {
        if (typeof value !== 'number') return $cbZCz.format(value);
        var i = value == 0 ? 0 : Math.floor(Math.log(value) / Math.log(1024));
        return $f5gxW.unit((value / Math.pow(1024, i)).toFixed(2) * 1, $a43de722b9f1af91$var$Formatters.fileSizeUnits[i]);
    },
    formatChecksum (value) {
        if (typeof value !== 'string') return $cbZCz.null();
        const multihash = $3Dz4Y.getDependency('multihashes');
        if (!multihash) return $f5gxW.e(value);
        try {
            const meta = multihash.decode($f5gxW.hexToUint8(value));
            const name = $f5gxW.e(meta.name);
            const hex = $f5gxW.e($f5gxW.uint8ToHex(meta.digest));
            return `<div class="checksum"><input class="checksum-input" size="32" value="${hex}" readonly><br><span class="checksum-algo">${$f5gxW.t('Hashing algorithm:')} <strong>${name}</strong></span></div>`;
        } catch (error) {
            return $cbZCz.null();
        }
    },
    fileDataTypes: {
        "int8": "8-bit integer",
        "int16": "16-bit integer",
        "int32": "32-bit integer",
        "int64": "64-bit integer",
        "uint8": "unsigned 8-bit integer",
        "uint16": "unsigned 16-bit integer",
        "uint32": "unsigned 32-bit integer",
        "uint64": "unsigned 64-bit integer",
        "float16": "16-bit float",
        "float32": "32-bit float",
        "float64": "64-bit float",
        "cint16": "16-bit complex integer",
        "cint32": "32-bit complex integer",
        "cfloat32": "32-bit complex float",
        "cfloat64": "64-bit complex float"
    },
    formatFileDataType (value) {
        if (value === "other") return $f5gxW.t("non-standard");
        else if (typeof value === 'string' && value in $a43de722b9f1af91$var$Formatters.fileDataTypes) return $f5gxW.abbrev($f5gxW.t(value), $f5gxW.t($a43de722b9f1af91$var$Formatters.fileDataTypes[value]));
        return $cbZCz.null();
    },
    formatTransform (value) {
        if (Array.isArray(value) && value.length % 3 === 0) {
            let rows = [];
            for(let i = 0; i < value.length; i = i + 3){
                let chunk = value.slice(i, i + 3);
                rows.push(`[${$a43de722b9f1af91$var$Formatters.formatCSV(chunk)}]`);
            }
            return rows.join('<br>');
        } else return $a43de722b9f1af91$var$Formatters.formatCSV(value);
    },
    formatShape (value, field, spec = {}) {
        if (Array.isArray(value)) return value.map((x)=>$cbZCz.format(x, spec.unit)).join(" \xd7 ");
        else return $cbZCz.format(value, spec.unit);
    },
    formatCSV (value) {
        if (Array.isArray(value)) {
            let numeric = value.find((v)=>typeof v === 'number') !== undefined;
            // If there's potentially a comma in the values (decimal or thousand separators in numbers), use semicolon instead of comma.
            return value.map($cbZCz.format).join(numeric ? '; ' : ', ');
        } else return $cbZCz.format(value);
    },
    formatImage (value, field) {
        let title = "";
        let src = null;
        if ($f5gxW.isObject(value)) {
            src = value.href;
            title = value.title || "";
        } else if (typeof value === 'string') src = value;
        else return $cbZCz.format(src);
        return `<img src="${$f5gxW.e(src)}" title="${$f5gxW.e(title)}" class="${$f5gxW.e(field.replace(':', '_'))}">`;
    },
    formatPhone (value) {
        return $f5gxW.toLink(`tel:${value}`, value);
    },
    formatEmail (value) {
        return $f5gxW.toLink(`mailto:${value}`, value);
    },
    formatConcepts (value) {
        return $f5gxW.toList(value, false, (concept)=>{
            if (!$f5gxW.isObject(concept)) return $cbZCz.format(concept);
            let html = "";
            if (concept.title) {
                let title = concept.title;
                if (concept.url) title = $f5gxW.toLink(concept.url, concept.title);
                html += `<strong>${title}</strong> (<code>${$f5gxW.e(concept.id)}</code>)`;
            } else {
                let title = concept.id;
                if (concept.url) title = $f5gxW.toLink(concept.url, concept.id);
                html += `<strong><code>${title}</code></strong>`;
            }
            if (concept.description) html += `<br><small>${$f5gxW.e(concept.description)}</small>`;
            return html;
        });
    },
    formatAddress (value) {
        return $f5gxW.toList(value, false, (address)=>{
            if (!$f5gxW.isObject(address)) return $cbZCz.format(address);
            let lines = Array.isArray(address.deliveryPoint) ? address.deliveryPoint.slice(0) : [];
            if (address.postalCode && address.city) {
                // Try to create a compact address
                let line = `${address.postalCode} ${address.city}`;
                if (address.administrativeArea) line += ` (${address.administrativeArea})`;
                if (typeof address.country === 'string' && address.country.length > 0) {
                    if (address.country.length === 2 && address.country.toUpperCase() === address.country) {
                        line = address.country + '-' + line;
                        lines.push(line);
                    } else {
                        lines.push(line);
                        lines.push(address.country.toUpperCase());
                    }
                }
            } else {
                // Long version of the address
                if (address.city) lines.push(address.city);
                if (address.administrativeArea) lines.push(address.administrativeArea);
                if (address.postalCode) lines.push(address.postalCode);
                if (typeof address.country === 'string' && address.country.length > 0) lines.push(address.country.toUpperCase());
            }
            return $cbZCz.string(lines.join("\n\n"));
        });
    },
    formatGridCode (value) {
        if (typeof value !== 'string') return $cbZCz.format(value);
        let splitHalf = function(parts, value, labelA, labelB) {
            let len = value.length;
            if (len % 2 === 1) parts.push(`Code: ${value}`);
            else {
                let mid = len / 2;
                let a = value.substring(0, mid);
                parts.push(`${labelA}: ${a}`);
                let b = value.substring(mid, len);
                parts.push(`${labelB}: ${b}`);
            }
        };
        let [designator, code] = value.split(/-(.*)/);
        let parts = [];
        switch(designator){
            case 'MGRS':
                parts.push($f5gxW.abbrev($f5gxW.t(designator), $f5gxW.t('Military Grid Reference System')));
                let [, utm, band, sq, coord] = code.match(/^(\d{2})([C-X])([A-Z]{2})(\d*)$/);
                parts.push(`${$f5gxW.t("UTM Zone")}: ${utm}`);
                parts.push(`${$f5gxW.t("Latitude Band")}: ${band}`);
                parts.push(`${$f5gxW.t("Square Identifier")}: ${sq}`);
                if (coord) splitHalf(parts, coord, $f5gxW.t("Easting"), $f5gxW.t("Northing"));
                break;
            case 'MSIN':
                parts.push($f5gxW.t('MODIS Sinusoidal Tile Grid'));
                splitHalf(parts, code, $f5gxW.t('Horizontal'), $f5gxW.t('Vertical'));
                break;
            case 'WRS1':
            case 'WRS2':
                let version = designator.substring(3, 4);
                parts.push($f5gxW.abbrev($f5gxW.t('WRS-' + version), $f5gxW.t('Worldwide Reference System ' + version)));
                splitHalf(parts, code, $f5gxW.t('Path'), $f5gxW.t('Row'));
                break;
            case 'DOQ':
                parts.push(_abbrev($f5gxW.t(designator), $f5gxW.t('Digital Orthophoto Quadrangle')));
                parts.push(`${$f5gxW.t("Quadrangle")}: ${code}`);
                break;
            case 'DOQQ':
                parts.push(_abbrev($f5gxW.t(designator), $f5gxW.t('Digital Orthophoto Quarter Quadrangle')));
                let quad = code.substr(0, code.length - 2);
                parts.push(`${$f5gxW.t("Quadrangle")}: ${quad}`);
                let quarter = code.substr(-2);
                let a = quarter[0] === 'N' ? $f5gxW.t('North') : $f5gxW.t('South');
                let b = quarter[1] === 'E' ? $f5gxW.t('East') : $f5gxW.t('West');
                parts.push(`${$f5gxW.t("Quarter")}: ${a} ${b}`);
                break;
            case 'MXRA':
                parts.push($f5gxW.t('Maxar ARD Tile Grid'));
                let [zone, quadkey] = code.split(/-(.*)/);
                if (zone.startsWith('Z')) zone = zone.substring(1);
                parts.push(`${$f5gxW.t("UTM Zone")}: ${zone}`);
                parts.push(`${$f5gxW.t("Quadkey")}: ${quadkey}`);
                break;
            case 'EASE':
                let [dggs, components] = code.split('-');
                if (dggs === 'DGGS') {
                    parts.push($f5gxW.t('EASE-DGGS'));
                    let [level, rowcol, ...fractions] = components.split('.');
                    parts.push(`${$f5gxW.t("Level")}: ${level}`);
                    if (rowcol.length === 6) {
                        parts.push(`${$f5gxW.t("Level 0 row cell")}: ${rowcol.substring(0, 3)}`);
                        parts.push(`${$f5gxW.t("Level 0 column cell")}: ${rowcol.substring(3, 6)}`);
                        for(let i in fractions){
                            let value = fractions[i];
                            if (value.length === 2) {
                                parts.push(`${$f5gxW.t("Fraction of level {i} row cell", {
                                    i: i
                                })}: ${value[0]}`);
                                parts.push(`${$f5gxW.t("Fraction of level {i} column cell", {
                                    i: i
                                })}: ${value[1]}`);
                            }
                        }
                    }
                    break;
                }
            case 'CDEM':
                let [, n, e] = code.match(/^([A-Z]\d+)([A-Z]\d+)$/);
                parts.push($f5gxW.t("Copernicus Digital Elevation Model Grid"));
                parts.push(`${$f5gxW.t("Easting")}: ${e}`);
                parts.push(`${$f5gxW.t("Northing")}: ${n}`);
            default:
                parts.push(value);
        }
        return parts.join('<br>');
    }
};
module.exports = $a43de722b9f1af91$var$Formatters;

});
parcelRegister("ggVZQ", function(module, exports) {
module.exports = JSON.parse('{"aa":"Afar","ab":"Abkhazian","af":"Afrikaans","ak":"Akan","am":"Amharic","an":"Aragonese","ar":"Arabic","as":"Assamese","av":"Avar","ay":"Aymara","az":"Azerbaijani","ba":"Bashkir","be":"Belarusian","bg":"Bulgarian","bh":"Bihari","bi":"Bislama","bm":"Bambara","bn":"Bengali","bo":"Tibetan","br":"Breton","bs":"Bosnian","ca":"Catalan","ce":"Chechen","ch":"Chamorro","co":"Corsican","cr":"Cree","cs":"Czech","cu":"Old Bulgarian","cv":"Chuvash","cy":"Welsh","da":"Danish","de":"German","dv":"Divehi","dz":"Dzongkha","ee":"Ewe","el":"Greek","en":"English","eo":"Esperanto","es":"Spanish","et":"Estonian","eu":"Basque","fa":"Persian","ff":"Peul","fi":"Finnish","fj":"Fijian","fo":"Faroese","fr":"French","fy":"West Frisian","ga":"Irish","gd":"Scottish Gaelic","gl":"Galician","gn":"Guarani","gu":"Gujarati","gv":"Manx","ha":"Hausa","he":"Hebrew","hi":"Hindi","ho":"Hiri Motu","hr":"Croatian","ht":"Haitian","hu":"Hungarian","hy":"Armenian","hz":"Herero","ia":"Interlingua","id":"Indonesian","ie":"Interlingue","ig":"Igbo","ii":"Sichuan Yi","ik":"Inupiak","io":"Ido","is":"Icelandic","it":"Italian","iu":"Inuktitut","ja":"Japanese","jv":"Javanese","ka":"Georgian","kg":"Kongo","ki":"Kikuyu","kj":"Kuanyama","kk":"Kazakh","kl":"Greenlandic","km":"Cambodian","kn":"Kannada","ko":"Korean","kr":"Kanuri","ks":"Kashmiri","ku":"Kurdish","kv":"Komi","kw":"Cornish","ky":"Kirghiz","la":"Latin","lb":"Luxembourgish","lg":"Ganda","li":"Limburgian","ln":"Lingala","lo":"Laotian","lt":"Lithuanian","lv":"Latvian","mg":"Malagasy","mh":"Marshallese","mi":"Maori","mk":"Macedonian","ml":"Malayalam","mn":"Mongolian","mo":"Moldovan","mr":"Marathi","ms":"Malay","mt":"Maltese","my":"Burmese","na":"Nauruan","nd":"North Ndebele","ne":"Nepali","ng":"Ndonga","nl":"Dutch","nn":"Norwegian Nynorsk","no":"Norwegian","nr":"South Ndebele","nv":"Navajo","ny":"Chichewa","oc":"Occitan","oj":"Ojibwa","om":"Oromo","or":"Oriya","os":"Ossetian","pa":"Punjabi","pi":"Pali","pl":"Polish","ps":"Pashto","pt":"Portuguese","qu":"Quechua","rm":"Raeto Romance","rn":"Kirundi","ro":"Romanian","ru":"Russian","rw":"Rwandi","sa":"Sanskrit","sc":"Sardinian","sd":"Sindhi","sg":"Sango","sh":"Serbo-Croatian","si":"Sinhalese","sk":"Slovak","sl":"Slovenian","sm":"Samoan","sn":"Shona","so":"Somalia","sq":"Albanian","sr":"Serbian","ss":"Swati","st":"Southern Sotho","su":"Sundanese","sv":"Swedish","sw":"Swahili","ta":"Tamil","te":"Telugu","tg":"Tajik","th":"Thai","ti":"Tigrinya","tk":"Turkmen","tl":"Tagalog","tn":"Tswana","to":"Tonga","tr":"Turkish","ts":"Tsonga","tt":"Tatar","tw":"Twi","ty":"Tahitian","ug":"Uyghur","uk":"Ukrainian","ur":"Urdu","ve":"Venda","vi":"Vietnamese","vo":"Volap\xfck","wa":"Walloon","wo":"Wolof","xh":"Xhosa","yi":"Yiddish","yo":"Yoruba","za":"Zhuang","zh":"Chinese","zu":"Zulu"}');

});



parcelRegister("31zZV", function(module, exports) {
/* MapLibre GL JS is licensed under the 3-Clause BSD License. Full text of license: https://github.com/maplibre/maplibre-gl-js/blob/v3.6.2/LICENSE.txt */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    /* eslint-disable */ var shared, worker, maplibregl;
    // define gets called three times: one for each chunk. we rely on the order
    // they're imported to know which is which
    function define(_, chunk) {
        if (!shared) shared = chunk;
        else if (!worker) worker = chunk;
        else {
            var workerBundleString = 'var sharedChunk = {}; (' + shared + ')(sharedChunk); (' + worker + ')(sharedChunk);';
            var sharedChunk = {};
            shared(sharedChunk);
            maplibregl = chunk(sharedChunk);
            if (typeof window !== 'undefined') maplibregl.workerUrl = window.URL.createObjectURL(new Blob([
                workerBundleString
            ], {
                type: 'text/javascript'
            }));
        }
    }
    define([
        "exports"
    ], function(t) {
        "use strict";
        function e(t, e, r, n) {
            return new (r || (r = Promise))(function(i, a) {
                function s(t) {
                    try {
                        l(n.next(t));
                    } catch (t) {
                        a(t);
                    }
                }
                function o(t) {
                    try {
                        l(n.throw(t));
                    } catch (t) {
                        a(t);
                    }
                }
                function l(t) {
                    var e;
                    t.done ? i(t.value) : (e = t.value, e instanceof r ? e : new r(function(t) {
                        t(e);
                    })).then(s, o);
                }
                l((n = n.apply(t, e || [])).next());
            });
        }
        function r(t) {
            return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
        }
        "function" == typeof SuppressedError && SuppressedError;
        var n = i;
        function i(t, e) {
            this.x = t, this.y = e;
        }
        i.prototype = {
            clone: function() {
                return new i(this.x, this.y);
            },
            add: function(t) {
                return this.clone()._add(t);
            },
            sub: function(t) {
                return this.clone()._sub(t);
            },
            multByPoint: function(t) {
                return this.clone()._multByPoint(t);
            },
            divByPoint: function(t) {
                return this.clone()._divByPoint(t);
            },
            mult: function(t) {
                return this.clone()._mult(t);
            },
            div: function(t) {
                return this.clone()._div(t);
            },
            rotate: function(t) {
                return this.clone()._rotate(t);
            },
            rotateAround: function(t, e) {
                return this.clone()._rotateAround(t, e);
            },
            matMult: function(t) {
                return this.clone()._matMult(t);
            },
            unit: function() {
                return this.clone()._unit();
            },
            perp: function() {
                return this.clone()._perp();
            },
            round: function() {
                return this.clone()._round();
            },
            mag: function() {
                return Math.sqrt(this.x * this.x + this.y * this.y);
            },
            equals: function(t) {
                return this.x === t.x && this.y === t.y;
            },
            dist: function(t) {
                return Math.sqrt(this.distSqr(t));
            },
            distSqr: function(t) {
                var e = t.x - this.x, r = t.y - this.y;
                return e * e + r * r;
            },
            angle: function() {
                return Math.atan2(this.y, this.x);
            },
            angleTo: function(t) {
                return Math.atan2(this.y - t.y, this.x - t.x);
            },
            angleWith: function(t) {
                return this.angleWithSep(t.x, t.y);
            },
            angleWithSep: function(t, e) {
                return Math.atan2(this.x * e - this.y * t, this.x * t + this.y * e);
            },
            _matMult: function(t) {
                var e = t[2] * this.x + t[3] * this.y;
                return this.x = t[0] * this.x + t[1] * this.y, this.y = e, this;
            },
            _add: function(t) {
                return this.x += t.x, this.y += t.y, this;
            },
            _sub: function(t) {
                return this.x -= t.x, this.y -= t.y, this;
            },
            _mult: function(t) {
                return this.x *= t, this.y *= t, this;
            },
            _div: function(t) {
                return this.x /= t, this.y /= t, this;
            },
            _multByPoint: function(t) {
                return this.x *= t.x, this.y *= t.y, this;
            },
            _divByPoint: function(t) {
                return this.x /= t.x, this.y /= t.y, this;
            },
            _unit: function() {
                return this._div(this.mag()), this;
            },
            _perp: function() {
                var t = this.y;
                return this.y = this.x, this.x = -t, this;
            },
            _rotate: function(t) {
                var e = Math.cos(t), r = Math.sin(t), n = r * this.x + e * this.y;
                return this.x = e * this.x - r * this.y, this.y = n, this;
            },
            _rotateAround: function(t, e) {
                var r = Math.cos(t), n = Math.sin(t), i = e.y + n * (this.x - e.x) + r * (this.y - e.y);
                return this.x = e.x + r * (this.x - e.x) - n * (this.y - e.y), this.y = i, this;
            },
            _round: function() {
                return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
            }
        }, i.convert = function(t) {
            return t instanceof i ? t : Array.isArray(t) ? new i(t[0], t[1]) : t;
        };
        var a = r(n), s = o;
        function o(t, e, r, n) {
            this.cx = 3 * t, this.bx = 3 * (r - t) - this.cx, this.ax = 1 - this.cx - this.bx, this.cy = 3 * e, this.by = 3 * (n - e) - this.cy, this.ay = 1 - this.cy - this.by, this.p1x = t, this.p1y = e, this.p2x = r, this.p2y = n;
        }
        o.prototype = {
            sampleCurveX: function(t) {
                return ((this.ax * t + this.bx) * t + this.cx) * t;
            },
            sampleCurveY: function(t) {
                return ((this.ay * t + this.by) * t + this.cy) * t;
            },
            sampleCurveDerivativeX: function(t) {
                return (3 * this.ax * t + 2 * this.bx) * t + this.cx;
            },
            solveCurveX: function(t, e) {
                if (void 0 === e && (e = 1e-6), t < 0) return 0;
                if (t > 1) return 1;
                for(var r = t, n = 0; n < 8; n++){
                    var i = this.sampleCurveX(r) - t;
                    if (Math.abs(i) < e) return r;
                    var a = this.sampleCurveDerivativeX(r);
                    if (Math.abs(a) < 1e-6) break;
                    r -= i / a;
                }
                var s = 0, o = 1;
                for(r = t, n = 0; n < 20 && (i = this.sampleCurveX(r), !(Math.abs(i - t) < e)); n++)t > i ? s = r : o = r, r = .5 * (o - s) + s;
                return r;
            },
            solve: function(t, e) {
                return this.sampleCurveY(this.solveCurveX(t, e));
            }
        };
        var l = r(s);
        let u, c;
        function h() {
            return null == u && (u = "undefined" != typeof OffscreenCanvas && new OffscreenCanvas(1, 1).getContext("2d") && "function" == typeof createImageBitmap), u;
        }
        function p() {
            if (null == c && (c = !1, h())) {
                const t = 5, e = new OffscreenCanvas(t, t).getContext("2d", {
                    willReadFrequently: !0
                });
                if (e) {
                    for(let r = 0; r < t * t; r++){
                        const n = 4 * r;
                        e.fillStyle = `rgb(${n},${n + 1},${n + 2})`, e.fillRect(r % t, Math.floor(r / t), 1, 1);
                    }
                    const r = e.getImageData(0, 0, t, t).data;
                    for(let e = 0; e < t * t * 4; e++)if (e % 4 != 3 && r[e] !== e) {
                        c = !0;
                        break;
                    }
                }
            }
            return c || !1;
        }
        function f(t, e, r, n) {
            const i = new l(t, e, r, n);
            return function(t) {
                return i.solve(t);
            };
        }
        const d = f(.25, .1, .25, 1);
        function y(t, e, r) {
            return Math.min(r, Math.max(e, t));
        }
        function m(t, e, r) {
            const n = r - e, i = ((t - e) % n + n) % n + e;
            return i === e ? r : i;
        }
        function g(t, ...e) {
            for (const r of e)for(const e in r)t[e] = r[e];
            return t;
        }
        let x = 1;
        function v(t, e, r) {
            const n = {};
            for(const i in t)n[i] = e.call(r || this, t[i], i, t);
            return n;
        }
        function b(t, e, r) {
            const n = {};
            for(const i in t)e.call(r || this, t[i], i, t) && (n[i] = t[i]);
            return n;
        }
        function w(t) {
            return Array.isArray(t) ? t.map(w) : "object" == typeof t && t ? v(t, w) : t;
        }
        const _ = {};
        function A(t) {
            _[t] || ("undefined" != typeof console && console.warn(t), _[t] = !0);
        }
        function S(t, e, r) {
            return (r.y - t.y) * (e.x - t.x) > (e.y - t.y) * (r.x - t.x);
        }
        function k(t) {
            let e = 0;
            for(let r, n, i = 0, a = t.length, s = a - 1; i < a; s = i++)r = t[i], n = t[s], e += (n.x - r.x) * (r.y + n.y);
            return e;
        }
        function I() {
            return "undefined" != typeof WorkerGlobalScope && "undefined" != typeof self && self instanceof WorkerGlobalScope;
        }
        let z = null;
        function M(t) {
            return "undefined" != typeof ImageBitmap && t instanceof ImageBitmap;
        }
        const C = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAAIAAAUAAarVyFEAAAAASUVORK5CYII=";
        function B(t, r, n, i, a) {
            return e(this, void 0, void 0, function*() {
                if ("undefined" == typeof VideoFrame) throw new Error("VideoFrame not supported");
                const e = new VideoFrame(t, {
                    timestamp: 0
                });
                try {
                    const s = null == e ? void 0 : e.format;
                    if (!s || !s.startsWith("BGR") && !s.startsWith("RGB")) throw new Error(`Unrecognized format ${s}`);
                    const o = s.startsWith("BGR"), l = new Uint8ClampedArray(i * a * 4);
                    if (yield e.copyTo(l, function(t, e, r, n, i) {
                        const a = 4 * Math.max(-e, 0), s = (Math.max(0, r) - r) * n * 4 + a, o = 4 * n, l = Math.max(0, e), u = Math.max(0, r);
                        return {
                            rect: {
                                x: l,
                                y: u,
                                width: Math.min(t.width, e + n) - l,
                                height: Math.min(t.height, r + i) - u
                            },
                            layout: [
                                {
                                    offset: s,
                                    stride: o
                                }
                            ]
                        };
                    }(t, r, n, i, a)), o) for(let t = 0; t < l.length; t += 4){
                        const e = l[t];
                        l[t] = l[t + 2], l[t + 2] = e;
                    }
                    return l;
                } finally{
                    e.close();
                }
            });
        }
        let P, V, E, F;
        const T = {
            now: "undefined" != typeof performance && performance && performance.now ? performance.now.bind(performance) : Date.now.bind(Date),
            frame (t) {
                const e = requestAnimationFrame(t);
                return {
                    cancel: ()=>cancelAnimationFrame(e)
                };
            },
            getImageData (t, e = 0) {
                return this.getImageCanvasContext(t).getImageData(-e, -e, t.width + 2 * e, t.height + 2 * e);
            },
            getImageCanvasContext (t) {
                const e = window.document.createElement("canvas"), r = e.getContext("2d", {
                    willReadFrequently: !0
                });
                if (!r) throw new Error("failed to create canvas 2d context");
                return e.width = t.width, e.height = t.height, r.drawImage(t, 0, 0, t.width, t.height), r;
            },
            resolveURL: (t)=>(E || (E = document.createElement("a")), E.href = t, E.href),
            hardwareConcurrency: "undefined" != typeof navigator && navigator.hardwareConcurrency || 4,
            get prefersReducedMotion () {
                return !!matchMedia && (null == F && (F = matchMedia("(prefers-reduced-motion: reduce)")), F.matches);
            }
        }, $ = {
            MAX_PARALLEL_IMAGE_REQUESTS: 16,
            MAX_PARALLEL_IMAGE_REQUESTS_PER_FRAME: 8,
            MAX_TILE_CACHE_ZOOM_LEVELS: 5,
            REGISTERED_PROTOCOLS: {},
            WORKER_URL: ""
        };
        class L extends Error {
            constructor(t, e, r, n){
                super(`AJAXError: ${e} (${t}): ${r}`), this.status = t, this.statusText = e, this.url = r, this.body = n;
            }
        }
        const D = I() ? ()=>self.worker && self.worker.referrer : ()=>("blob:" === window.location.protocol ? window.parent : window).location.href, O = (t)=>$.REGISTERED_PROTOCOLS[t.substring(0, t.indexOf("://"))];
        function U(t, e) {
            const r = new AbortController, n = new Request(t.url, {
                method: t.method || "GET",
                body: t.body,
                credentials: t.credentials,
                headers: t.headers,
                cache: t.cache,
                referrer: D(),
                signal: r.signal
            });
            let i = !1, a = !1;
            "json" === t.type && n.headers.set("Accept", "application/json");
            return a || fetch(n).then((r)=>r.ok ? ((r)=>{
                    ("arrayBuffer" === t.type || "image" === t.type ? r.arrayBuffer() : "json" === t.type ? r.json() : r.text()).then((t)=>{
                        a || (i = !0, e(null, t, r.headers.get("Cache-Control"), r.headers.get("Expires")));
                    }).catch((t)=>{
                        a || e(new Error(t.message));
                    });
                })(r) : r.blob().then((n)=>e(new L(r.status, r.statusText, t.url, n)))).catch((t)=>{
                20 !== t.code && e(new Error(t.message));
            }), {
                cancel: ()=>{
                    a = !0, i || r.abort();
                }
            };
        }
        const R = function(t, e) {
            if (/:\/\//.test(t.url) && !/^https?:|^file:/.test(t.url)) {
                if (I() && self.worker && self.worker.actor) return self.worker.actor.send("getResource", t, e);
                if (!I()) return (O(t.url) || U)(t, e);
            }
            if (!(/^file:/.test(r = t.url) || /^file:/.test(D()) && !/^\w+:/.test(r))) {
                if (fetch && Request && AbortController && Object.prototype.hasOwnProperty.call(Request.prototype, "signal")) return U(t, e);
                if (I() && self.worker && self.worker.actor) return self.worker.actor.send("getResource", t, e, void 0, !0);
            }
            var r;
            return function(t, e) {
                const r = new XMLHttpRequest;
                r.open(t.method || "GET", t.url, !0), "arrayBuffer" !== t.type && "image" !== t.type || (r.responseType = "arraybuffer");
                for(const e in t.headers)r.setRequestHeader(e, t.headers[e]);
                return "json" === t.type && (r.responseType = "text", r.setRequestHeader("Accept", "application/json")), r.withCredentials = "include" === t.credentials, r.onerror = ()=>{
                    e(new Error(r.statusText));
                }, r.onload = ()=>{
                    if ((r.status >= 200 && r.status < 300 || 0 === r.status) && null !== r.response) {
                        let n = r.response;
                        if ("json" === t.type) try {
                            n = JSON.parse(r.response);
                        } catch (t) {
                            return e(t);
                        }
                        e(null, n, r.getResponseHeader("Cache-Control"), r.getResponseHeader("Expires"));
                    } else {
                        const n = new Blob([
                            r.response
                        ], {
                            type: r.getResponseHeader("Content-Type")
                        });
                        e(new L(r.status, r.statusText, t.url, n));
                    }
                }, r.send(t.body), {
                    cancel: ()=>r.abort()
                };
            }(t, e);
        }, q = function(t, e) {
            return R(g(t, {
                type: "arrayBuffer"
            }), e);
        };
        function j(t) {
            if (!t || t.indexOf("://") <= 0 || 0 === t.indexOf("data:image/") || 0 === t.indexOf("blob:")) return !0;
            const e = new URL(t), r = window.location;
            return e.protocol === r.protocol && e.host === r.host;
        }
        function N(t, e, r) {
            r[t] && -1 !== r[t].indexOf(e) || (r[t] = r[t] || [], r[t].push(e));
        }
        function Z(t, e, r) {
            if (r && r[t]) {
                const n = r[t].indexOf(e);
                -1 !== n && r[t].splice(n, 1);
            }
        }
        class K {
            constructor(t, e = {}){
                g(this, e), this.type = t;
            }
        }
        class G extends K {
            constructor(t, e = {}){
                super("error", g({
                    error: t
                }, e));
            }
        }
        class J {
            on(t, e) {
                return this._listeners = this._listeners || {}, N(t, e, this._listeners), this;
            }
            off(t, e) {
                return Z(t, e, this._listeners), Z(t, e, this._oneTimeListeners), this;
            }
            once(t, e) {
                return e ? (this._oneTimeListeners = this._oneTimeListeners || {}, N(t, e, this._oneTimeListeners), this) : new Promise((e)=>this.once(t, e));
            }
            fire(t, e) {
                "string" == typeof t && (t = new K(t, e || {}));
                const r = t.type;
                if (this.listens(r)) {
                    t.target = this;
                    const e = this._listeners && this._listeners[r] ? this._listeners[r].slice() : [];
                    for (const r of e)r.call(this, t);
                    const n = this._oneTimeListeners && this._oneTimeListeners[r] ? this._oneTimeListeners[r].slice() : [];
                    for (const e of n)Z(r, e, this._oneTimeListeners), e.call(this, t);
                    const i = this._eventedParent;
                    i && (g(t, "function" == typeof this._eventedParentData ? this._eventedParentData() : this._eventedParentData), i.fire(t));
                } else t instanceof G && console.error(t.error);
                return this;
            }
            listens(t) {
                return this._listeners && this._listeners[t] && this._listeners[t].length > 0 || this._oneTimeListeners && this._oneTimeListeners[t] && this._oneTimeListeners[t].length > 0 || this._eventedParent && this._eventedParent.listens(t);
            }
            setEventedParent(t, e) {
                return this._eventedParent = t, this._eventedParentData = e, this;
            }
        }
        var X = {
            $version: 8,
            $root: {
                version: {
                    required: !0,
                    type: "enum",
                    values: [
                        8
                    ]
                },
                name: {
                    type: "string"
                },
                metadata: {
                    type: "*"
                },
                center: {
                    type: "array",
                    value: "number"
                },
                zoom: {
                    type: "number"
                },
                bearing: {
                    type: "number",
                    default: 0,
                    period: 360,
                    units: "degrees"
                },
                pitch: {
                    type: "number",
                    default: 0,
                    units: "degrees"
                },
                light: {
                    type: "light"
                },
                terrain: {
                    type: "terrain"
                },
                sources: {
                    required: !0,
                    type: "sources"
                },
                sprite: {
                    type: "sprite"
                },
                glyphs: {
                    type: "string"
                },
                transition: {
                    type: "transition"
                },
                layers: {
                    required: !0,
                    type: "array",
                    value: "layer"
                }
            },
            sources: {
                "*": {
                    type: "source"
                }
            },
            source: [
                "source_vector",
                "source_raster",
                "source_raster_dem",
                "source_geojson",
                "source_video",
                "source_image"
            ],
            source_vector: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        vector: {}
                    }
                },
                url: {
                    type: "string"
                },
                tiles: {
                    type: "array",
                    value: "string"
                },
                bounds: {
                    type: "array",
                    value: "number",
                    length: 4,
                    default: [
                        -180,
                        -85.051129,
                        180,
                        85.051129
                    ]
                },
                scheme: {
                    type: "enum",
                    values: {
                        xyz: {},
                        tms: {}
                    },
                    default: "xyz"
                },
                minzoom: {
                    type: "number",
                    default: 0
                },
                maxzoom: {
                    type: "number",
                    default: 22
                },
                attribution: {
                    type: "string"
                },
                promoteId: {
                    type: "promoteId"
                },
                volatile: {
                    type: "boolean",
                    default: !1
                },
                "*": {
                    type: "*"
                }
            },
            source_raster: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        raster: {}
                    }
                },
                url: {
                    type: "string"
                },
                tiles: {
                    type: "array",
                    value: "string"
                },
                bounds: {
                    type: "array",
                    value: "number",
                    length: 4,
                    default: [
                        -180,
                        -85.051129,
                        180,
                        85.051129
                    ]
                },
                minzoom: {
                    type: "number",
                    default: 0
                },
                maxzoom: {
                    type: "number",
                    default: 22
                },
                tileSize: {
                    type: "number",
                    default: 512,
                    units: "pixels"
                },
                scheme: {
                    type: "enum",
                    values: {
                        xyz: {},
                        tms: {}
                    },
                    default: "xyz"
                },
                attribution: {
                    type: "string"
                },
                volatile: {
                    type: "boolean",
                    default: !1
                },
                "*": {
                    type: "*"
                }
            },
            source_raster_dem: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        "raster-dem": {}
                    }
                },
                url: {
                    type: "string"
                },
                tiles: {
                    type: "array",
                    value: "string"
                },
                bounds: {
                    type: "array",
                    value: "number",
                    length: 4,
                    default: [
                        -180,
                        -85.051129,
                        180,
                        85.051129
                    ]
                },
                minzoom: {
                    type: "number",
                    default: 0
                },
                maxzoom: {
                    type: "number",
                    default: 22
                },
                tileSize: {
                    type: "number",
                    default: 512,
                    units: "pixels"
                },
                attribution: {
                    type: "string"
                },
                encoding: {
                    type: "enum",
                    values: {
                        terrarium: {},
                        mapbox: {},
                        custom: {}
                    },
                    default: "mapbox"
                },
                redFactor: {
                    type: "number",
                    default: 1
                },
                blueFactor: {
                    type: "number",
                    default: 1
                },
                greenFactor: {
                    type: "number",
                    default: 1
                },
                baseShift: {
                    type: "number",
                    default: 0
                },
                volatile: {
                    type: "boolean",
                    default: !1
                },
                "*": {
                    type: "*"
                }
            },
            source_geojson: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        geojson: {}
                    }
                },
                data: {
                    required: !0,
                    type: "*"
                },
                maxzoom: {
                    type: "number",
                    default: 18
                },
                attribution: {
                    type: "string"
                },
                buffer: {
                    type: "number",
                    default: 128,
                    maximum: 512,
                    minimum: 0
                },
                filter: {
                    type: "*"
                },
                tolerance: {
                    type: "number",
                    default: .375
                },
                cluster: {
                    type: "boolean",
                    default: !1
                },
                clusterRadius: {
                    type: "number",
                    default: 50,
                    minimum: 0
                },
                clusterMaxZoom: {
                    type: "number"
                },
                clusterMinPoints: {
                    type: "number"
                },
                clusterProperties: {
                    type: "*"
                },
                lineMetrics: {
                    type: "boolean",
                    default: !1
                },
                generateId: {
                    type: "boolean",
                    default: !1
                },
                promoteId: {
                    type: "promoteId"
                }
            },
            source_video: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        video: {}
                    }
                },
                urls: {
                    required: !0,
                    type: "array",
                    value: "string"
                },
                coordinates: {
                    required: !0,
                    type: "array",
                    length: 4,
                    value: {
                        type: "array",
                        length: 2,
                        value: "number"
                    }
                }
            },
            source_image: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        image: {}
                    }
                },
                url: {
                    required: !0,
                    type: "string"
                },
                coordinates: {
                    required: !0,
                    type: "array",
                    length: 4,
                    value: {
                        type: "array",
                        length: 2,
                        value: "number"
                    }
                }
            },
            layer: {
                id: {
                    type: "string",
                    required: !0
                },
                type: {
                    type: "enum",
                    values: {
                        fill: {},
                        line: {},
                        symbol: {},
                        circle: {},
                        heatmap: {},
                        "fill-extrusion": {},
                        raster: {},
                        hillshade: {},
                        background: {}
                    },
                    required: !0
                },
                metadata: {
                    type: "*"
                },
                source: {
                    type: "string"
                },
                "source-layer": {
                    type: "string"
                },
                minzoom: {
                    type: "number",
                    minimum: 0,
                    maximum: 24
                },
                maxzoom: {
                    type: "number",
                    minimum: 0,
                    maximum: 24
                },
                filter: {
                    type: "filter"
                },
                layout: {
                    type: "layout"
                },
                paint: {
                    type: "paint"
                }
            },
            layout: [
                "layout_fill",
                "layout_line",
                "layout_circle",
                "layout_heatmap",
                "layout_fill-extrusion",
                "layout_symbol",
                "layout_raster",
                "layout_hillshade",
                "layout_background"
            ],
            layout_background: {
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_fill: {
                "fill-sort-key": {
                    type: "number",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_circle: {
                "circle-sort-key": {
                    type: "number",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_heatmap: {
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            "layout_fill-extrusion": {
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_line: {
                "line-cap": {
                    type: "enum",
                    values: {
                        butt: {},
                        round: {},
                        square: {}
                    },
                    default: "butt",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "line-join": {
                    type: "enum",
                    values: {
                        bevel: {},
                        round: {},
                        miter: {}
                    },
                    default: "miter",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-miter-limit": {
                    type: "number",
                    default: 2,
                    requires: [
                        {
                            "line-join": "miter"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "line-round-limit": {
                    type: "number",
                    default: 1.05,
                    requires: [
                        {
                            "line-join": "round"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "line-sort-key": {
                    type: "number",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_symbol: {
                "symbol-placement": {
                    type: "enum",
                    values: {
                        point: {},
                        line: {},
                        "line-center": {}
                    },
                    default: "point",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "symbol-spacing": {
                    type: "number",
                    default: 250,
                    minimum: 1,
                    units: "pixels",
                    requires: [
                        {
                            "symbol-placement": "line"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "symbol-avoid-edges": {
                    type: "boolean",
                    default: !1,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "symbol-sort-key": {
                    type: "number",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "symbol-z-order": {
                    type: "enum",
                    values: {
                        auto: {},
                        "viewport-y": {},
                        source: {}
                    },
                    default: "auto",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-allow-overlap": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "icon-image",
                        {
                            "!": "icon-overlap"
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-overlap": {
                    type: "enum",
                    values: {
                        never: {},
                        always: {},
                        cooperative: {}
                    },
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-ignore-placement": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-optional": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "icon-image",
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-rotation-alignment": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {},
                        auto: {}
                    },
                    default: "auto",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-size": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    units: "factor of the original icon size",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-text-fit": {
                    type: "enum",
                    values: {
                        none: {},
                        width: {},
                        height: {},
                        both: {}
                    },
                    default: "none",
                    requires: [
                        "icon-image",
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-text-fit-padding": {
                    type: "array",
                    value: "number",
                    length: 4,
                    default: [
                        0,
                        0,
                        0,
                        0
                    ],
                    units: "pixels",
                    requires: [
                        "icon-image",
                        "text-field",
                        {
                            "icon-text-fit": [
                                "both",
                                "width",
                                "height"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-image": {
                    type: "resolvedImage",
                    tokens: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-rotate": {
                    type: "number",
                    default: 0,
                    period: 360,
                    units: "degrees",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-padding": {
                    type: "padding",
                    default: [
                        2
                    ],
                    units: "pixels",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-keep-upright": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "icon-image",
                        {
                            "icon-rotation-alignment": "map"
                        },
                        {
                            "symbol-placement": [
                                "line",
                                "line-center"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-offset": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-anchor": {
                    type: "enum",
                    values: {
                        center: {},
                        left: {},
                        right: {},
                        top: {},
                        bottom: {},
                        "top-left": {},
                        "top-right": {},
                        "bottom-left": {},
                        "bottom-right": {}
                    },
                    default: "center",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-pitch-alignment": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {},
                        auto: {}
                    },
                    default: "auto",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-pitch-alignment": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {},
                        auto: {}
                    },
                    default: "auto",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-rotation-alignment": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {},
                        "viewport-glyph": {},
                        auto: {}
                    },
                    default: "auto",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-field": {
                    type: "formatted",
                    default: "",
                    tokens: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-font": {
                    type: "array",
                    value: "string",
                    default: [
                        "Open Sans Regular",
                        "Arial Unicode MS Regular"
                    ],
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-size": {
                    type: "number",
                    default: 16,
                    minimum: 0,
                    units: "pixels",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-max-width": {
                    type: "number",
                    default: 10,
                    minimum: 0,
                    units: "ems",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-line-height": {
                    type: "number",
                    default: 1.2,
                    units: "ems",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-letter-spacing": {
                    type: "number",
                    default: 0,
                    units: "ems",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-justify": {
                    type: "enum",
                    values: {
                        auto: {},
                        left: {},
                        center: {},
                        right: {}
                    },
                    default: "center",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-radial-offset": {
                    type: "number",
                    units: "ems",
                    default: 0,
                    requires: [
                        "text-field"
                    ],
                    "property-type": "data-driven",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    }
                },
                "text-variable-anchor": {
                    type: "array",
                    value: "enum",
                    values: {
                        center: {},
                        left: {},
                        right: {},
                        top: {},
                        bottom: {},
                        "top-left": {},
                        "top-right": {},
                        "bottom-left": {},
                        "bottom-right": {}
                    },
                    requires: [
                        "text-field",
                        {
                            "symbol-placement": [
                                "point"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-variable-anchor-offset": {
                    type: "variableAnchorOffsetCollection",
                    requires: [
                        "text-field",
                        {
                            "symbol-placement": [
                                "point"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-anchor": {
                    type: "enum",
                    values: {
                        center: {},
                        left: {},
                        right: {},
                        top: {},
                        bottom: {},
                        "top-left": {},
                        "top-right": {},
                        "bottom-left": {},
                        "bottom-right": {}
                    },
                    default: "center",
                    requires: [
                        "text-field",
                        {
                            "!": "text-variable-anchor"
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-max-angle": {
                    type: "number",
                    default: 45,
                    units: "degrees",
                    requires: [
                        "text-field",
                        {
                            "symbol-placement": [
                                "line",
                                "line-center"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-writing-mode": {
                    type: "array",
                    value: "enum",
                    values: {
                        horizontal: {},
                        vertical: {}
                    },
                    requires: [
                        "text-field",
                        {
                            "symbol-placement": [
                                "point"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-rotate": {
                    type: "number",
                    default: 0,
                    period: 360,
                    units: "degrees",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-padding": {
                    type: "number",
                    default: 2,
                    minimum: 0,
                    units: "pixels",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-keep-upright": {
                    type: "boolean",
                    default: !0,
                    requires: [
                        "text-field",
                        {
                            "text-rotation-alignment": "map"
                        },
                        {
                            "symbol-placement": [
                                "line",
                                "line-center"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-transform": {
                    type: "enum",
                    values: {
                        none: {},
                        uppercase: {},
                        lowercase: {}
                    },
                    default: "none",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-offset": {
                    type: "array",
                    value: "number",
                    units: "ems",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    requires: [
                        "text-field",
                        {
                            "!": "text-radial-offset"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-allow-overlap": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "text-field",
                        {
                            "!": "text-overlap"
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-overlap": {
                    type: "enum",
                    values: {
                        never: {},
                        always: {},
                        cooperative: {}
                    },
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-ignore-placement": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-optional": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "text-field",
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_raster: {
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_hillshade: {
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            filter: {
                type: "array",
                value: "*"
            },
            filter_operator: {
                type: "enum",
                values: {
                    "==": {},
                    "!=": {},
                    ">": {},
                    ">=": {},
                    "<": {},
                    "<=": {},
                    in: {},
                    "!in": {},
                    all: {},
                    any: {},
                    none: {},
                    has: {},
                    "!has": {},
                    within: {}
                }
            },
            geometry_type: {
                type: "enum",
                values: {
                    Point: {},
                    LineString: {},
                    Polygon: {}
                }
            },
            function: {
                expression: {
                    type: "expression"
                },
                stops: {
                    type: "array",
                    value: "function_stop"
                },
                base: {
                    type: "number",
                    default: 1,
                    minimum: 0
                },
                property: {
                    type: "string",
                    default: "$zoom"
                },
                type: {
                    type: "enum",
                    values: {
                        identity: {},
                        exponential: {},
                        interval: {},
                        categorical: {}
                    },
                    default: "exponential"
                },
                colorSpace: {
                    type: "enum",
                    values: {
                        rgb: {},
                        lab: {},
                        hcl: {}
                    },
                    default: "rgb"
                },
                default: {
                    type: "*",
                    required: !1
                }
            },
            function_stop: {
                type: "array",
                minimum: 0,
                maximum: 24,
                value: [
                    "number",
                    "color"
                ],
                length: 2
            },
            expression: {
                type: "array",
                value: "*",
                minimum: 1
            },
            light: {
                anchor: {
                    type: "enum",
                    default: "viewport",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    "property-type": "data-constant",
                    transition: !1,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    }
                },
                position: {
                    type: "array",
                    default: [
                        1.15,
                        210,
                        30
                    ],
                    length: 3,
                    value: "number",
                    "property-type": "data-constant",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    }
                },
                color: {
                    type: "color",
                    "property-type": "data-constant",
                    default: "#ffffff",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    transition: !0
                },
                intensity: {
                    type: "number",
                    "property-type": "data-constant",
                    default: .5,
                    minimum: 0,
                    maximum: 1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    transition: !0
                }
            },
            terrain: {
                source: {
                    type: "string",
                    required: !0
                },
                exaggeration: {
                    type: "number",
                    minimum: 0,
                    default: 1
                }
            },
            paint: [
                "paint_fill",
                "paint_line",
                "paint_circle",
                "paint_heatmap",
                "paint_fill-extrusion",
                "paint_symbol",
                "paint_raster",
                "paint_hillshade",
                "paint_background"
            ],
            paint_fill: {
                "fill-antialias": {
                    type: "boolean",
                    default: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    requires: [
                        {
                            "!": "fill-pattern"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-outline-color": {
                    type: "color",
                    transition: !0,
                    requires: [
                        {
                            "!": "fill-pattern"
                        },
                        {
                            "fill-antialias": !0
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "fill-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-pattern": {
                    type: "resolvedImage",
                    transition: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "cross-faded-data-driven"
                }
            },
            "paint_fill-extrusion": {
                "fill-extrusion-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-extrusion-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    requires: [
                        {
                            "!": "fill-extrusion-pattern"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-extrusion-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-extrusion-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "fill-extrusion-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-extrusion-pattern": {
                    type: "resolvedImage",
                    transition: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "cross-faded-data-driven"
                },
                "fill-extrusion-height": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    units: "meters",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-extrusion-base": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    units: "meters",
                    transition: !0,
                    requires: [
                        "fill-extrusion-height"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-extrusion-vertical-gradient": {
                    type: "boolean",
                    default: !0,
                    transition: !1,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            paint_line: {
                "line-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    requires: [
                        {
                            "!": "line-pattern"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "line-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "line-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "line-width": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-gap-width": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-offset": {
                    type: "number",
                    default: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-blur": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-dasharray": {
                    type: "array",
                    value: "number",
                    minimum: 0,
                    transition: !0,
                    units: "line widths",
                    requires: [
                        {
                            "!": "line-pattern"
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "cross-faded"
                },
                "line-pattern": {
                    type: "resolvedImage",
                    transition: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "cross-faded-data-driven"
                },
                "line-gradient": {
                    type: "color",
                    transition: !1,
                    requires: [
                        {
                            "!": "line-dasharray"
                        },
                        {
                            "!": "line-pattern"
                        },
                        {
                            source: "geojson",
                            has: {
                                lineMetrics: !0
                            }
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "line-progress"
                        ]
                    },
                    "property-type": "color-ramp"
                }
            },
            paint_circle: {
                "circle-radius": {
                    type: "number",
                    default: 5,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-blur": {
                    type: "number",
                    default: 0,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "circle-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "circle-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "circle-pitch-scale": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "circle-pitch-alignment": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "viewport",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "circle-stroke-width": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-stroke-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-stroke-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                }
            },
            paint_heatmap: {
                "heatmap-radius": {
                    type: "number",
                    default: 30,
                    minimum: 1,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "heatmap-weight": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    transition: !1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "heatmap-intensity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "heatmap-color": {
                    type: "color",
                    default: [
                        "interpolate",
                        [
                            "linear"
                        ],
                        [
                            "heatmap-density"
                        ],
                        0,
                        "rgba(0, 0, 255, 0)",
                        .1,
                        "royalblue",
                        .3,
                        "cyan",
                        .5,
                        "lime",
                        .7,
                        "yellow",
                        1,
                        "red"
                    ],
                    transition: !1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "heatmap-density"
                        ]
                    },
                    "property-type": "color-ramp"
                },
                "heatmap-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            paint_symbol: {
                "icon-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-halo-color": {
                    type: "color",
                    default: "rgba(0, 0, 0, 0)",
                    transition: !0,
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-halo-width": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-halo-blur": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "icon-image",
                        "icon-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    overridable: !0,
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-halo-color": {
                    type: "color",
                    default: "rgba(0, 0, 0, 0)",
                    transition: !0,
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-halo-width": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-halo-blur": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "text-field",
                        "text-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            paint_raster: {
                "raster-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-hue-rotate": {
                    type: "number",
                    default: 0,
                    period: 360,
                    transition: !0,
                    units: "degrees",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-brightness-min": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-brightness-max": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-saturation": {
                    type: "number",
                    default: 0,
                    minimum: -1,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-contrast": {
                    type: "number",
                    default: 0,
                    minimum: -1,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-resampling": {
                    type: "enum",
                    values: {
                        linear: {},
                        nearest: {}
                    },
                    default: "linear",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-fade-duration": {
                    type: "number",
                    default: 300,
                    minimum: 0,
                    transition: !1,
                    units: "milliseconds",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            paint_hillshade: {
                "hillshade-illumination-direction": {
                    type: "number",
                    default: 335,
                    minimum: 0,
                    maximum: 359,
                    transition: !1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-illumination-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "viewport",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-exaggeration": {
                    type: "number",
                    default: .5,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-shadow-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-highlight-color": {
                    type: "color",
                    default: "#FFFFFF",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-accent-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            paint_background: {
                "background-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    requires: [
                        {
                            "!": "background-pattern"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "background-pattern": {
                    type: "resolvedImage",
                    transition: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "cross-faded"
                },
                "background-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            transition: {
                duration: {
                    type: "number",
                    default: 300,
                    minimum: 0,
                    units: "milliseconds"
                },
                delay: {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    units: "milliseconds"
                }
            },
            "property-type": {
                "data-driven": {
                    type: "property-type"
                },
                "cross-faded": {
                    type: "property-type"
                },
                "cross-faded-data-driven": {
                    type: "property-type"
                },
                "color-ramp": {
                    type: "property-type"
                },
                "data-constant": {
                    type: "property-type"
                },
                constant: {
                    type: "property-type"
                }
            },
            promoteId: {
                "*": {
                    type: "string"
                }
            }
        };
        const Y = [
            "type",
            "source",
            "source-layer",
            "minzoom",
            "maxzoom",
            "filter",
            "layout"
        ];
        function H(t, e) {
            const r = {};
            for(const e in t)"ref" !== e && (r[e] = t[e]);
            return Y.forEach((t)=>{
                t in e && (r[t] = e[t]);
            }), r;
        }
        function W(t, e) {
            if (Array.isArray(t)) {
                if (!Array.isArray(e) || t.length !== e.length) return !1;
                for(let r = 0; r < t.length; r++)if (!W(t[r], e[r])) return !1;
                return !0;
            }
            if ("object" == typeof t && null !== t && null !== e) {
                if ("object" != typeof e) return !1;
                if (Object.keys(t).length !== Object.keys(e).length) return !1;
                for(const r in t)if (!W(t[r], e[r])) return !1;
                return !0;
            }
            return t === e;
        }
        const Q = {
            setStyle: "setStyle",
            addLayer: "addLayer",
            removeLayer: "removeLayer",
            setPaintProperty: "setPaintProperty",
            setLayoutProperty: "setLayoutProperty",
            setFilter: "setFilter",
            addSource: "addSource",
            removeSource: "removeSource",
            setGeoJSONSourceData: "setGeoJSONSourceData",
            setLayerZoomRange: "setLayerZoomRange",
            setLayerProperty: "setLayerProperty",
            setCenter: "setCenter",
            setZoom: "setZoom",
            setBearing: "setBearing",
            setPitch: "setPitch",
            setSprite: "setSprite",
            setGlyphs: "setGlyphs",
            setTransition: "setTransition",
            setLight: "setLight"
        };
        function tt(t, e, r) {
            r.push({
                command: Q.addSource,
                args: [
                    t,
                    e[t]
                ]
            });
        }
        function et(t, e, r) {
            e.push({
                command: Q.removeSource,
                args: [
                    t
                ]
            }), r[t] = !0;
        }
        function rt(t, e, r, n) {
            et(t, r, n), tt(t, e, r);
        }
        function nt(t, e, r) {
            let n;
            for(n in t[r])if (Object.prototype.hasOwnProperty.call(t[r], n) && "data" !== n && !W(t[r][n], e[r][n])) return !1;
            for(n in e[r])if (Object.prototype.hasOwnProperty.call(e[r], n) && "data" !== n && !W(t[r][n], e[r][n])) return !1;
            return !0;
        }
        function it(t, e, r, n, i, a) {
            let s;
            for(s in e = e || {}, t = t || {})Object.prototype.hasOwnProperty.call(t, s) && (W(t[s], e[s]) || r.push({
                command: a,
                args: [
                    n,
                    s,
                    e[s],
                    i
                ]
            }));
            for(s in e)Object.prototype.hasOwnProperty.call(e, s) && !Object.prototype.hasOwnProperty.call(t, s) && (W(t[s], e[s]) || r.push({
                command: a,
                args: [
                    n,
                    s,
                    e[s],
                    i
                ]
            }));
        }
        function at(t) {
            return t.id;
        }
        function st(t, e) {
            return t[e.id] = e, t;
        }
        class ot {
            constructor(t, e, r, n){
                this.message = (t ? `${t}: ` : "") + r, n && (this.identifier = n), null != e && e.__line__ && (this.line = e.__line__);
            }
        }
        function lt(t, ...e) {
            for (const r of e)for(const e in r)t[e] = r[e];
            return t;
        }
        class ut extends Error {
            constructor(t, e){
                super(e), this.message = e, this.key = t;
            }
        }
        class ct {
            constructor(t, e = []){
                this.parent = t, this.bindings = {};
                for (const [t, r] of e)this.bindings[t] = r;
            }
            concat(t) {
                return new ct(this, t);
            }
            get(t) {
                if (this.bindings[t]) return this.bindings[t];
                if (this.parent) return this.parent.get(t);
                throw new Error(`${t} not found in scope.`);
            }
            has(t) {
                return !!this.bindings[t] || !!this.parent && this.parent.has(t);
            }
        }
        const ht = {
            kind: "null"
        }, pt = {
            kind: "number"
        }, ft = {
            kind: "string"
        }, dt = {
            kind: "boolean"
        }, yt = {
            kind: "color"
        }, mt = {
            kind: "object"
        }, gt = {
            kind: "value"
        }, xt = {
            kind: "collator"
        }, vt = {
            kind: "formatted"
        }, bt = {
            kind: "padding"
        }, wt = {
            kind: "resolvedImage"
        }, _t = {
            kind: "variableAnchorOffsetCollection"
        };
        function At(t, e) {
            return {
                kind: "array",
                itemType: t,
                N: e
            };
        }
        function St(t) {
            if ("array" === t.kind) {
                const e = St(t.itemType);
                return "number" == typeof t.N ? `array<${e}, ${t.N}>` : "value" === t.itemType.kind ? "array" : `array<${e}>`;
            }
            return t.kind;
        }
        const kt = [
            ht,
            pt,
            ft,
            dt,
            yt,
            vt,
            mt,
            At(gt),
            bt,
            wt,
            _t
        ];
        function It(t, e) {
            if ("error" === e.kind) return null;
            if ("array" === t.kind) {
                if ("array" === e.kind && (0 === e.N && "value" === e.itemType.kind || !It(t.itemType, e.itemType)) && ("number" != typeof t.N || t.N === e.N)) return null;
            } else {
                if (t.kind === e.kind) return null;
                if ("value" === t.kind) {
                    for (const t of kt)if (!It(t, e)) return null;
                }
            }
            return `Expected ${St(t)} but found ${St(e)} instead.`;
        }
        function zt(t, e) {
            return e.some((e)=>e.kind === t.kind);
        }
        function Mt(t, e) {
            return e.some((e)=>"null" === e ? null === t : "array" === e ? Array.isArray(t) : "object" === e ? t && !Array.isArray(t) && "object" == typeof t : e === typeof t);
        }
        function Ct(t, e) {
            return "array" === t.kind && "array" === e.kind ? t.itemType.kind === e.itemType.kind && "number" == typeof t.N : t.kind === e.kind;
        }
        const Bt = .96422, Pt = .82521, Vt = 4 / 29, Et = 6 / 29, Ft = 3 * Et * Et, Tt = Et * Et * Et, $t = Math.PI / 180, Lt = 180 / Math.PI;
        function Dt(t) {
            return (t %= 360) < 0 && (t += 360), t;
        }
        function Ot([t, e, r, n]) {
            let i, a;
            const s = Rt((.2225045 * (t = Ut(t)) + .7168786 * (e = Ut(e)) + .0606169 * (r = Ut(r))) / 1);
            t === e && e === r ? i = a = s : (i = Rt((.4360747 * t + .3850649 * e + .1430804 * r) / Bt), a = Rt((.0139322 * t + .0971045 * e + .7141733 * r) / Pt));
            const o = 116 * s - 16;
            return [
                o < 0 ? 0 : o,
                500 * (i - s),
                200 * (s - a),
                n
            ];
        }
        function Ut(t) {
            return t <= .04045 ? t / 12.92 : Math.pow((t + .055) / 1.055, 2.4);
        }
        function Rt(t) {
            return t > Tt ? Math.pow(t, 1 / 3) : t / Ft + Vt;
        }
        function qt([t, e, r, n]) {
            let i = (t + 16) / 116, a = isNaN(e) ? i : i + e / 500, s = isNaN(r) ? i : i - r / 200;
            return i = 1 * Nt(i), a = Bt * Nt(a), s = Pt * Nt(s), [
                jt(3.1338561 * a - 1.6168667 * i - .4906146 * s),
                jt(-0.9787684 * a + 1.9161415 * i + .033454 * s),
                jt(.0719453 * a - .2289914 * i + 1.4052427 * s),
                n
            ];
        }
        function jt(t) {
            return (t = t <= .00304 ? 12.92 * t : 1.055 * Math.pow(t, 1 / 2.4) - .055) < 0 ? 0 : t > 1 ? 1 : t;
        }
        function Nt(t) {
            return t > Et ? t * t * t : Ft * (t - Vt);
        }
        function Zt(t) {
            return parseInt(t.padEnd(2, t), 16) / 255;
        }
        function Kt(t, e) {
            return Gt(e ? t / 100 : t, 0, 1);
        }
        function Gt(t, e, r) {
            return Math.min(Math.max(e, t), r);
        }
        function Jt(t) {
            return !t.some(Number.isNaN);
        }
        const Xt = {
            aliceblue: [
                240,
                248,
                255
            ],
            antiquewhite: [
                250,
                235,
                215
            ],
            aqua: [
                0,
                255,
                255
            ],
            aquamarine: [
                127,
                255,
                212
            ],
            azure: [
                240,
                255,
                255
            ],
            beige: [
                245,
                245,
                220
            ],
            bisque: [
                255,
                228,
                196
            ],
            black: [
                0,
                0,
                0
            ],
            blanchedalmond: [
                255,
                235,
                205
            ],
            blue: [
                0,
                0,
                255
            ],
            blueviolet: [
                138,
                43,
                226
            ],
            brown: [
                165,
                42,
                42
            ],
            burlywood: [
                222,
                184,
                135
            ],
            cadetblue: [
                95,
                158,
                160
            ],
            chartreuse: [
                127,
                255,
                0
            ],
            chocolate: [
                210,
                105,
                30
            ],
            coral: [
                255,
                127,
                80
            ],
            cornflowerblue: [
                100,
                149,
                237
            ],
            cornsilk: [
                255,
                248,
                220
            ],
            crimson: [
                220,
                20,
                60
            ],
            cyan: [
                0,
                255,
                255
            ],
            darkblue: [
                0,
                0,
                139
            ],
            darkcyan: [
                0,
                139,
                139
            ],
            darkgoldenrod: [
                184,
                134,
                11
            ],
            darkgray: [
                169,
                169,
                169
            ],
            darkgreen: [
                0,
                100,
                0
            ],
            darkgrey: [
                169,
                169,
                169
            ],
            darkkhaki: [
                189,
                183,
                107
            ],
            darkmagenta: [
                139,
                0,
                139
            ],
            darkolivegreen: [
                85,
                107,
                47
            ],
            darkorange: [
                255,
                140,
                0
            ],
            darkorchid: [
                153,
                50,
                204
            ],
            darkred: [
                139,
                0,
                0
            ],
            darksalmon: [
                233,
                150,
                122
            ],
            darkseagreen: [
                143,
                188,
                143
            ],
            darkslateblue: [
                72,
                61,
                139
            ],
            darkslategray: [
                47,
                79,
                79
            ],
            darkslategrey: [
                47,
                79,
                79
            ],
            darkturquoise: [
                0,
                206,
                209
            ],
            darkviolet: [
                148,
                0,
                211
            ],
            deeppink: [
                255,
                20,
                147
            ],
            deepskyblue: [
                0,
                191,
                255
            ],
            dimgray: [
                105,
                105,
                105
            ],
            dimgrey: [
                105,
                105,
                105
            ],
            dodgerblue: [
                30,
                144,
                255
            ],
            firebrick: [
                178,
                34,
                34
            ],
            floralwhite: [
                255,
                250,
                240
            ],
            forestgreen: [
                34,
                139,
                34
            ],
            fuchsia: [
                255,
                0,
                255
            ],
            gainsboro: [
                220,
                220,
                220
            ],
            ghostwhite: [
                248,
                248,
                255
            ],
            gold: [
                255,
                215,
                0
            ],
            goldenrod: [
                218,
                165,
                32
            ],
            gray: [
                128,
                128,
                128
            ],
            green: [
                0,
                128,
                0
            ],
            greenyellow: [
                173,
                255,
                47
            ],
            grey: [
                128,
                128,
                128
            ],
            honeydew: [
                240,
                255,
                240
            ],
            hotpink: [
                255,
                105,
                180
            ],
            indianred: [
                205,
                92,
                92
            ],
            indigo: [
                75,
                0,
                130
            ],
            ivory: [
                255,
                255,
                240
            ],
            khaki: [
                240,
                230,
                140
            ],
            lavender: [
                230,
                230,
                250
            ],
            lavenderblush: [
                255,
                240,
                245
            ],
            lawngreen: [
                124,
                252,
                0
            ],
            lemonchiffon: [
                255,
                250,
                205
            ],
            lightblue: [
                173,
                216,
                230
            ],
            lightcoral: [
                240,
                128,
                128
            ],
            lightcyan: [
                224,
                255,
                255
            ],
            lightgoldenrodyellow: [
                250,
                250,
                210
            ],
            lightgray: [
                211,
                211,
                211
            ],
            lightgreen: [
                144,
                238,
                144
            ],
            lightgrey: [
                211,
                211,
                211
            ],
            lightpink: [
                255,
                182,
                193
            ],
            lightsalmon: [
                255,
                160,
                122
            ],
            lightseagreen: [
                32,
                178,
                170
            ],
            lightskyblue: [
                135,
                206,
                250
            ],
            lightslategray: [
                119,
                136,
                153
            ],
            lightslategrey: [
                119,
                136,
                153
            ],
            lightsteelblue: [
                176,
                196,
                222
            ],
            lightyellow: [
                255,
                255,
                224
            ],
            lime: [
                0,
                255,
                0
            ],
            limegreen: [
                50,
                205,
                50
            ],
            linen: [
                250,
                240,
                230
            ],
            magenta: [
                255,
                0,
                255
            ],
            maroon: [
                128,
                0,
                0
            ],
            mediumaquamarine: [
                102,
                205,
                170
            ],
            mediumblue: [
                0,
                0,
                205
            ],
            mediumorchid: [
                186,
                85,
                211
            ],
            mediumpurple: [
                147,
                112,
                219
            ],
            mediumseagreen: [
                60,
                179,
                113
            ],
            mediumslateblue: [
                123,
                104,
                238
            ],
            mediumspringgreen: [
                0,
                250,
                154
            ],
            mediumturquoise: [
                72,
                209,
                204
            ],
            mediumvioletred: [
                199,
                21,
                133
            ],
            midnightblue: [
                25,
                25,
                112
            ],
            mintcream: [
                245,
                255,
                250
            ],
            mistyrose: [
                255,
                228,
                225
            ],
            moccasin: [
                255,
                228,
                181
            ],
            navajowhite: [
                255,
                222,
                173
            ],
            navy: [
                0,
                0,
                128
            ],
            oldlace: [
                253,
                245,
                230
            ],
            olive: [
                128,
                128,
                0
            ],
            olivedrab: [
                107,
                142,
                35
            ],
            orange: [
                255,
                165,
                0
            ],
            orangered: [
                255,
                69,
                0
            ],
            orchid: [
                218,
                112,
                214
            ],
            palegoldenrod: [
                238,
                232,
                170
            ],
            palegreen: [
                152,
                251,
                152
            ],
            paleturquoise: [
                175,
                238,
                238
            ],
            palevioletred: [
                219,
                112,
                147
            ],
            papayawhip: [
                255,
                239,
                213
            ],
            peachpuff: [
                255,
                218,
                185
            ],
            peru: [
                205,
                133,
                63
            ],
            pink: [
                255,
                192,
                203
            ],
            plum: [
                221,
                160,
                221
            ],
            powderblue: [
                176,
                224,
                230
            ],
            purple: [
                128,
                0,
                128
            ],
            rebeccapurple: [
                102,
                51,
                153
            ],
            red: [
                255,
                0,
                0
            ],
            rosybrown: [
                188,
                143,
                143
            ],
            royalblue: [
                65,
                105,
                225
            ],
            saddlebrown: [
                139,
                69,
                19
            ],
            salmon: [
                250,
                128,
                114
            ],
            sandybrown: [
                244,
                164,
                96
            ],
            seagreen: [
                46,
                139,
                87
            ],
            seashell: [
                255,
                245,
                238
            ],
            sienna: [
                160,
                82,
                45
            ],
            silver: [
                192,
                192,
                192
            ],
            skyblue: [
                135,
                206,
                235
            ],
            slateblue: [
                106,
                90,
                205
            ],
            slategray: [
                112,
                128,
                144
            ],
            slategrey: [
                112,
                128,
                144
            ],
            snow: [
                255,
                250,
                250
            ],
            springgreen: [
                0,
                255,
                127
            ],
            steelblue: [
                70,
                130,
                180
            ],
            tan: [
                210,
                180,
                140
            ],
            teal: [
                0,
                128,
                128
            ],
            thistle: [
                216,
                191,
                216
            ],
            tomato: [
                255,
                99,
                71
            ],
            turquoise: [
                64,
                224,
                208
            ],
            violet: [
                238,
                130,
                238
            ],
            wheat: [
                245,
                222,
                179
            ],
            white: [
                255,
                255,
                255
            ],
            whitesmoke: [
                245,
                245,
                245
            ],
            yellow: [
                255,
                255,
                0
            ],
            yellowgreen: [
                154,
                205,
                50
            ]
        };
        class Yt {
            constructor(t, e, r, n = 1, i = !0){
                this.r = t, this.g = e, this.b = r, this.a = n, i || (this.r *= n, this.g *= n, this.b *= n, n || this.overwriteGetter("rgb", [
                    t,
                    e,
                    r,
                    n
                ]));
            }
            static parse(t) {
                if (t instanceof Yt) return t;
                if ("string" != typeof t) return;
                const e = function(t) {
                    if ("transparent" === (t = t.toLowerCase().trim())) return [
                        0,
                        0,
                        0,
                        0
                    ];
                    const e = Xt[t];
                    if (e) {
                        const [t, r, n] = e;
                        return [
                            t / 255,
                            r / 255,
                            n / 255,
                            1
                        ];
                    }
                    if (t.startsWith("#") && /^#(?:[0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/.test(t)) {
                        const e = t.length < 6 ? 1 : 2;
                        let r = 1;
                        return [
                            Zt(t.slice(r, r += e)),
                            Zt(t.slice(r, r += e)),
                            Zt(t.slice(r, r += e)),
                            Zt(t.slice(r, r + e) || "ff")
                        ];
                    }
                    if (t.startsWith("rgb")) {
                        const e = t.match(/^rgba?\(\s*([\de.+-]+)(%)?(?:\s+|\s*(,)\s*)([\de.+-]+)(%)?(?:\s+|\s*(,)\s*)([\de.+-]+)(%)?(?:\s*([,\/])\s*([\de.+-]+)(%)?)?\s*\)$/);
                        if (e) {
                            const [t, r, n, i, a, s, o, l, u, c, h, p] = e, f = [
                                i || " ",
                                o || " ",
                                c
                            ].join("");
                            if ("  " === f || "  /" === f || ",," === f || ",,," === f) {
                                const t = [
                                    n,
                                    s,
                                    u
                                ].join(""), e = "%%%" === t ? 100 : "" === t ? 255 : 0;
                                if (e) {
                                    const t = [
                                        Gt(+r / e, 0, 1),
                                        Gt(+a / e, 0, 1),
                                        Gt(+l / e, 0, 1),
                                        h ? Kt(+h, p) : 1
                                    ];
                                    if (Jt(t)) return t;
                                }
                            }
                            return;
                        }
                    }
                    const r = t.match(/^hsla?\(\s*([\de.+-]+)(?:deg)?(?:\s+|\s*(,)\s*)([\de.+-]+)%(?:\s+|\s*(,)\s*)([\de.+-]+)%(?:\s*([,\/])\s*([\de.+-]+)(%)?)?\s*\)$/);
                    if (r) {
                        const [t, e, n, i, a, s, o, l, u] = r, c = [
                            n || " ",
                            a || " ",
                            o
                        ].join("");
                        if ("  " === c || "  /" === c || ",," === c || ",,," === c) {
                            const t = [
                                +e,
                                Gt(+i, 0, 100),
                                Gt(+s, 0, 100),
                                l ? Kt(+l, u) : 1
                            ];
                            if (Jt(t)) return function([t, e, r, n]) {
                                function i(n) {
                                    const i = (n + t / 30) % 12, a = e * Math.min(r, 1 - r);
                                    return r - a * Math.max(-1, Math.min(i - 3, 9 - i, 1));
                                }
                                return t = Dt(t), e /= 100, r /= 100, [
                                    i(0),
                                    i(8),
                                    i(4),
                                    n
                                ];
                            }(t);
                        }
                    }
                }(t);
                return e ? new Yt(...e, !1) : void 0;
            }
            get rgb() {
                const { r: t, g: e, b: r, a: n } = this, i = n || 1 / 0;
                return this.overwriteGetter("rgb", [
                    t / i,
                    e / i,
                    r / i,
                    n
                ]);
            }
            get hcl() {
                return this.overwriteGetter("hcl", function(t) {
                    const [e, r, n, i] = Ot(t), a = Math.sqrt(r * r + n * n);
                    return [
                        Math.round(1e4 * a) ? Dt(Math.atan2(n, r) * Lt) : NaN,
                        a,
                        e,
                        i
                    ];
                }(this.rgb));
            }
            get lab() {
                return this.overwriteGetter("lab", Ot(this.rgb));
            }
            overwriteGetter(t, e) {
                return Object.defineProperty(this, t, {
                    value: e
                }), e;
            }
            toString() {
                const [t, e, r, n] = this.rgb;
                return `rgba(${[
                    t,
                    e,
                    r
                ].map((t)=>Math.round(255 * t)).join(",")},${n})`;
            }
        }
        Yt.black = new Yt(0, 0, 0, 1), Yt.white = new Yt(1, 1, 1, 1), Yt.transparent = new Yt(0, 0, 0, 0), Yt.red = new Yt(1, 0, 0, 1);
        class Ht {
            constructor(t, e, r){
                this.sensitivity = t ? e ? "variant" : "case" : e ? "accent" : "base", this.locale = r, this.collator = new Intl.Collator(this.locale ? this.locale : [], {
                    sensitivity: this.sensitivity,
                    usage: "search"
                });
            }
            compare(t, e) {
                return this.collator.compare(t, e);
            }
            resolvedLocale() {
                return new Intl.Collator(this.locale ? this.locale : []).resolvedOptions().locale;
            }
        }
        class Wt {
            constructor(t, e, r, n, i){
                this.text = t, this.image = e, this.scale = r, this.fontStack = n, this.textColor = i;
            }
        }
        class Qt {
            constructor(t){
                this.sections = t;
            }
            static fromString(t) {
                return new Qt([
                    new Wt(t, null, null, null, null)
                ]);
            }
            isEmpty() {
                return 0 === this.sections.length || !this.sections.some((t)=>0 !== t.text.length || t.image && 0 !== t.image.name.length);
            }
            static factory(t) {
                return t instanceof Qt ? t : Qt.fromString(t);
            }
            toString() {
                return 0 === this.sections.length ? "" : this.sections.map((t)=>t.text).join("");
            }
        }
        class te {
            constructor(t){
                this.values = t.slice();
            }
            static parse(t) {
                if (t instanceof te) return t;
                if ("number" == typeof t) return new te([
                    t,
                    t,
                    t,
                    t
                ]);
                if (Array.isArray(t) && !(t.length < 1 || t.length > 4)) {
                    for (const e of t)if ("number" != typeof e) return;
                    switch(t.length){
                        case 1:
                            t = [
                                t[0],
                                t[0],
                                t[0],
                                t[0]
                            ];
                            break;
                        case 2:
                            t = [
                                t[0],
                                t[1],
                                t[0],
                                t[1]
                            ];
                            break;
                        case 3:
                            t = [
                                t[0],
                                t[1],
                                t[2],
                                t[1]
                            ];
                    }
                    return new te(t);
                }
            }
            toString() {
                return JSON.stringify(this.values);
            }
        }
        const ee = new Set([
            "center",
            "left",
            "right",
            "top",
            "bottom",
            "top-left",
            "top-right",
            "bottom-left",
            "bottom-right"
        ]);
        class re {
            constructor(t){
                this.values = t.slice();
            }
            static parse(t) {
                if (t instanceof re) return t;
                if (Array.isArray(t) && !(t.length < 1) && t.length % 2 == 0) {
                    for(let e = 0; e < t.length; e += 2){
                        const r = t[e], n = t[e + 1];
                        if ("string" != typeof r || !ee.has(r)) return;
                        if (!Array.isArray(n) || 2 !== n.length || "number" != typeof n[0] || "number" != typeof n[1]) return;
                    }
                    return new re(t);
                }
            }
            toString() {
                return JSON.stringify(this.values);
            }
        }
        class ne {
            constructor(t){
                this.name = t.name, this.available = t.available;
            }
            toString() {
                return this.name;
            }
            static fromString(t) {
                return t ? new ne({
                    name: t,
                    available: !1
                }) : null;
            }
        }
        function ie(t, e, r, n) {
            return "number" == typeof t && t >= 0 && t <= 255 && "number" == typeof e && e >= 0 && e <= 255 && "number" == typeof r && r >= 0 && r <= 255 ? void 0 === n || "number" == typeof n && n >= 0 && n <= 1 ? null : `Invalid rgba value [${[
                t,
                e,
                r,
                n
            ].join(", ")}]: 'a' must be between 0 and 1.` : `Invalid rgba value [${("number" == typeof n ? [
                t,
                e,
                r,
                n
            ] : [
                t,
                e,
                r
            ]).join(", ")}]: 'r', 'g', and 'b' must be between 0 and 255.`;
        }
        function ae(t) {
            if (null === t || "string" == typeof t || "boolean" == typeof t || "number" == typeof t || t instanceof Yt || t instanceof Ht || t instanceof Qt || t instanceof te || t instanceof re || t instanceof ne) return !0;
            if (Array.isArray(t)) {
                for (const e of t)if (!ae(e)) return !1;
                return !0;
            }
            if ("object" == typeof t) {
                for(const e in t)if (!ae(t[e])) return !1;
                return !0;
            }
            return !1;
        }
        function se(t) {
            if (null === t) return ht;
            if ("string" == typeof t) return ft;
            if ("boolean" == typeof t) return dt;
            if ("number" == typeof t) return pt;
            if (t instanceof Yt) return yt;
            if (t instanceof Ht) return xt;
            if (t instanceof Qt) return vt;
            if (t instanceof te) return bt;
            if (t instanceof re) return _t;
            if (t instanceof ne) return wt;
            if (Array.isArray(t)) {
                const e = t.length;
                let r;
                for (const e of t){
                    const t = se(e);
                    if (r) {
                        if (r === t) continue;
                        r = gt;
                        break;
                    }
                    r = t;
                }
                return At(r || gt, e);
            }
            return mt;
        }
        function oe(t) {
            const e = typeof t;
            return null === t ? "" : "string" === e || "number" === e || "boolean" === e ? String(t) : t instanceof Yt || t instanceof Qt || t instanceof te || t instanceof re || t instanceof ne ? t.toString() : JSON.stringify(t);
        }
        class le {
            constructor(t, e){
                this.type = t, this.value = e;
            }
            static parse(t, e) {
                if (2 !== t.length) return e.error(`'literal' expression requires exactly one argument, but found ${t.length - 1} instead.`);
                if (!ae(t[1])) return e.error("invalid value");
                const r = t[1];
                let n = se(r);
                const i = e.expectedType;
                return "array" !== n.kind || 0 !== n.N || !i || "array" !== i.kind || "number" == typeof i.N && 0 !== i.N || (n = i), new le(n, r);
            }
            evaluate() {
                return this.value;
            }
            eachChild() {}
            outputDefined() {
                return !0;
            }
        }
        class ue {
            constructor(t){
                this.name = "ExpressionEvaluationError", this.message = t;
            }
            toJSON() {
                return this.message;
            }
        }
        const ce = {
            string: ft,
            number: pt,
            boolean: dt,
            object: mt
        };
        class he {
            constructor(t, e){
                this.type = t, this.args = e;
            }
            static parse(t, e) {
                if (t.length < 2) return e.error("Expected at least one argument.");
                let r, n = 1;
                const i = t[0];
                if ("array" === i) {
                    let i, a;
                    if (t.length > 2) {
                        const r = t[1];
                        if ("string" != typeof r || !(r in ce) || "object" === r) return e.error('The item type argument of "array" must be one of string, number, boolean', 1);
                        i = ce[r], n++;
                    } else i = gt;
                    if (t.length > 3) {
                        if (null !== t[2] && ("number" != typeof t[2] || t[2] < 0 || t[2] !== Math.floor(t[2]))) return e.error('The length argument to "array" must be a positive integer literal', 2);
                        a = t[2], n++;
                    }
                    r = At(i, a);
                } else {
                    if (!ce[i]) throw new Error(`Types doesn't contain name = ${i}`);
                    r = ce[i];
                }
                const a = [];
                for(; n < t.length; n++){
                    const r = e.parse(t[n], n, gt);
                    if (!r) return null;
                    a.push(r);
                }
                return new he(r, a);
            }
            evaluate(t) {
                for(let e = 0; e < this.args.length; e++){
                    const r = this.args[e].evaluate(t);
                    if (!It(this.type, se(r))) return r;
                    if (e === this.args.length - 1) throw new ue(`Expected value to be of type ${St(this.type)}, but found ${St(se(r))} instead.`);
                }
                throw new Error;
            }
            eachChild(t) {
                this.args.forEach(t);
            }
            outputDefined() {
                return this.args.every((t)=>t.outputDefined());
            }
        }
        const pe = {
            "to-boolean": dt,
            "to-color": yt,
            "to-number": pt,
            "to-string": ft
        };
        class fe {
            constructor(t, e){
                this.type = t, this.args = e;
            }
            static parse(t, e) {
                if (t.length < 2) return e.error("Expected at least one argument.");
                const r = t[0];
                if (!pe[r]) throw new Error(`Can't parse ${r} as it is not part of the known types`);
                if (("to-boolean" === r || "to-string" === r) && 2 !== t.length) return e.error("Expected one argument.");
                const n = pe[r], i = [];
                for(let r = 1; r < t.length; r++){
                    const n = e.parse(t[r], r, gt);
                    if (!n) return null;
                    i.push(n);
                }
                return new fe(n, i);
            }
            evaluate(t) {
                switch(this.type.kind){
                    case "boolean":
                        return Boolean(this.args[0].evaluate(t));
                    case "color":
                        {
                            let e, r;
                            for (const n of this.args){
                                if (e = n.evaluate(t), r = null, e instanceof Yt) return e;
                                if ("string" == typeof e) {
                                    const r = t.parseColor(e);
                                    if (r) return r;
                                } else if (Array.isArray(e) && (r = e.length < 3 || e.length > 4 ? `Invalid rbga value ${JSON.stringify(e)}: expected an array containing either three or four numeric values.` : ie(e[0], e[1], e[2], e[3]), !r)) return new Yt(e[0] / 255, e[1] / 255, e[2] / 255, e[3]);
                            }
                            throw new ue(r || `Could not parse color from value '${"string" == typeof e ? e : JSON.stringify(e)}'`);
                        }
                    case "padding":
                        {
                            let e;
                            for (const r of this.args){
                                e = r.evaluate(t);
                                const n = te.parse(e);
                                if (n) return n;
                            }
                            throw new ue(`Could not parse padding from value '${"string" == typeof e ? e : JSON.stringify(e)}'`);
                        }
                    case "variableAnchorOffsetCollection":
                        {
                            let e;
                            for (const r of this.args){
                                e = r.evaluate(t);
                                const n = re.parse(e);
                                if (n) return n;
                            }
                            throw new ue(`Could not parse variableAnchorOffsetCollection from value '${"string" == typeof e ? e : JSON.stringify(e)}'`);
                        }
                    case "number":
                        {
                            let e = null;
                            for (const r of this.args){
                                if (e = r.evaluate(t), null === e) return 0;
                                const n = Number(e);
                                if (!isNaN(n)) return n;
                            }
                            throw new ue(`Could not convert ${JSON.stringify(e)} to number.`);
                        }
                    case "formatted":
                        return Qt.fromString(oe(this.args[0].evaluate(t)));
                    case "resolvedImage":
                        return ne.fromString(oe(this.args[0].evaluate(t)));
                    default:
                        return oe(this.args[0].evaluate(t));
                }
            }
            eachChild(t) {
                this.args.forEach(t);
            }
            outputDefined() {
                return this.args.every((t)=>t.outputDefined());
            }
        }
        const de = [
            "Unknown",
            "Point",
            "LineString",
            "Polygon"
        ];
        class ye {
            constructor(){
                this.globals = null, this.feature = null, this.featureState = null, this.formattedSection = null, this._parseColorCache = {}, this.availableImages = null, this.canonical = null;
            }
            id() {
                return this.feature && "id" in this.feature ? this.feature.id : null;
            }
            geometryType() {
                return this.feature ? "number" == typeof this.feature.type ? de[this.feature.type] : this.feature.type : null;
            }
            geometry() {
                return this.feature && "geometry" in this.feature ? this.feature.geometry : null;
            }
            canonicalID() {
                return this.canonical;
            }
            properties() {
                return this.feature && this.feature.properties || {};
            }
            parseColor(t) {
                let e = this._parseColorCache[t];
                return e || (e = this._parseColorCache[t] = Yt.parse(t)), e;
            }
        }
        class me {
            constructor(t, e, r = [], n, i = new ct, a = []){
                this.registry = t, this.path = r, this.key = r.map((t)=>`[${t}]`).join(""), this.scope = i, this.errors = a, this.expectedType = n, this._isConstant = e;
            }
            parse(t, e, r, n, i = {}) {
                return e ? this.concat(e, r, n)._parse(t, i) : this._parse(t, i);
            }
            _parse(t, e) {
                function r(t, e, r) {
                    return "assert" === r ? new he(e, [
                        t
                    ]) : "coerce" === r ? new fe(e, [
                        t
                    ]) : t;
                }
                if (null !== t && "string" != typeof t && "boolean" != typeof t && "number" != typeof t || (t = [
                    "literal",
                    t
                ]), Array.isArray(t)) {
                    if (0 === t.length) return this.error('Expected an array with at least one element. If you wanted a literal array, use ["literal", []].');
                    const n = t[0];
                    if ("string" != typeof n) return this.error(`Expression name must be a string, but found ${typeof n} instead. If you wanted a literal array, use ["literal", [...]].`, 0), null;
                    const i = this.registry[n];
                    if (i) {
                        let n = i.parse(t, this);
                        if (!n) return null;
                        if (this.expectedType) {
                            const t = this.expectedType, i = n.type;
                            if ("string" !== t.kind && "number" !== t.kind && "boolean" !== t.kind && "object" !== t.kind && "array" !== t.kind || "value" !== i.kind) {
                                if ("color" !== t.kind && "formatted" !== t.kind && "resolvedImage" !== t.kind || "value" !== i.kind && "string" !== i.kind) {
                                    if ("padding" !== t.kind || "value" !== i.kind && "number" !== i.kind && "array" !== i.kind) {
                                        if ("variableAnchorOffsetCollection" !== t.kind || "value" !== i.kind && "array" !== i.kind) {
                                            if (this.checkSubtype(t, i)) return null;
                                        } else n = r(n, t, e.typeAnnotation || "coerce");
                                    } else n = r(n, t, e.typeAnnotation || "coerce");
                                } else n = r(n, t, e.typeAnnotation || "coerce");
                            } else n = r(n, t, e.typeAnnotation || "assert");
                        }
                        if (!(n instanceof le) && "resolvedImage" !== n.type.kind && this._isConstant(n)) {
                            const t = new ye;
                            try {
                                n = new le(n.type, n.evaluate(t));
                            } catch (t) {
                                return this.error(t.message), null;
                            }
                        }
                        return n;
                    }
                    return this.error(`Unknown expression "${n}". If you wanted a literal array, use ["literal", [...]].`, 0);
                }
                return this.error(void 0 === t ? "'undefined' value invalid. Use null instead." : "object" == typeof t ? 'Bare objects invalid. Use ["literal", {...}] instead.' : `Expected an array, but found ${typeof t} instead.`);
            }
            concat(t, e, r) {
                const n = "number" == typeof t ? this.path.concat(t) : this.path, i = r ? this.scope.concat(r) : this.scope;
                return new me(this.registry, this._isConstant, n, e || null, i, this.errors);
            }
            error(t, ...e) {
                const r = `${this.key}${e.map((t)=>`[${t}]`).join("")}`;
                this.errors.push(new ut(r, t));
            }
            checkSubtype(t, e) {
                const r = It(t, e);
                return r && this.error(r), r;
            }
        }
        class ge {
            constructor(t, e, r){
                this.type = xt, this.locale = r, this.caseSensitive = t, this.diacriticSensitive = e;
            }
            static parse(t, e) {
                if (2 !== t.length) return e.error("Expected one argument.");
                const r = t[1];
                if ("object" != typeof r || Array.isArray(r)) return e.error("Collator options argument must be an object.");
                const n = e.parse(void 0 !== r["case-sensitive"] && r["case-sensitive"], 1, dt);
                if (!n) return null;
                const i = e.parse(void 0 !== r["diacritic-sensitive"] && r["diacritic-sensitive"], 1, dt);
                if (!i) return null;
                let a = null;
                return r.locale && (a = e.parse(r.locale, 1, ft), !a) ? null : new ge(n, i, a);
            }
            evaluate(t) {
                return new Ht(this.caseSensitive.evaluate(t), this.diacriticSensitive.evaluate(t), this.locale ? this.locale.evaluate(t) : null);
            }
            eachChild(t) {
                t(this.caseSensitive), t(this.diacriticSensitive), this.locale && t(this.locale);
            }
            outputDefined() {
                return !1;
            }
        }
        const xe = 8192;
        function ve(t, e) {
            t[0] = Math.min(t[0], e[0]), t[1] = Math.min(t[1], e[1]), t[2] = Math.max(t[2], e[0]), t[3] = Math.max(t[3], e[1]);
        }
        function be(t, e) {
            return !(t[0] <= e[0] || t[2] >= e[2] || t[1] <= e[1] || t[3] >= e[3]);
        }
        function we(t, e) {
            const r = (180 + t[0]) / 360, n = (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + t[1] * Math.PI / 360))) / 360, i = Math.pow(2, e.z);
            return [
                Math.round(r * i * xe),
                Math.round(n * i * xe)
            ];
        }
        function _e(t, e, r) {
            const n = t[0] - e[0], i = t[1] - e[1], a = t[0] - r[0], s = t[1] - r[1];
            return n * s - a * i == 0 && n * a <= 0 && i * s <= 0;
        }
        function Ae(t, e) {
            let r = !1;
            for(let s = 0, o = e.length; s < o; s++){
                const o = e[s];
                for(let e = 0, s = o.length; e < s - 1; e++){
                    if (_e(t, o[e], o[e + 1])) return !1;
                    (i = o[e])[1] > (n = t)[1] != (a = o[e + 1])[1] > n[1] && n[0] < (a[0] - i[0]) * (n[1] - i[1]) / (a[1] - i[1]) + i[0] && (r = !r);
                }
            }
            var n, i, a;
            return r;
        }
        function Se(t, e) {
            for(let r = 0; r < e.length; r++)if (Ae(t, e[r])) return !0;
            return !1;
        }
        function ke(t, e, r, n) {
            const i = n[0] - r[0], a = n[1] - r[1], s = (t[0] - r[0]) * a - i * (t[1] - r[1]), o = (e[0] - r[0]) * a - i * (e[1] - r[1]);
            return s > 0 && o < 0 || s < 0 && o > 0;
        }
        function Ie(t, e, r) {
            for (const u of r)for(let r = 0; r < u.length - 1; ++r)if (0 != (o = [
                (s = u[r + 1])[0] - (a = u[r])[0],
                s[1] - a[1]
            ])[0] * (l = [
                (i = e)[0] - (n = t)[0],
                i[1] - n[1]
            ])[1] - o[1] * l[0] && ke(n, i, a, s) && ke(a, s, n, i)) return !0;
            var n, i, a, s, o, l;
            return !1;
        }
        function ze(t, e) {
            for(let r = 0; r < t.length; ++r)if (!Ae(t[r], e)) return !1;
            for(let r = 0; r < t.length - 1; ++r)if (Ie(t[r], t[r + 1], e)) return !1;
            return !0;
        }
        function Me(t, e) {
            for(let r = 0; r < e.length; r++)if (ze(t, e[r])) return !0;
            return !1;
        }
        function Ce(t, e, r) {
            const n = [];
            for(let i = 0; i < t.length; i++){
                const a = [];
                for(let n = 0; n < t[i].length; n++){
                    const s = we(t[i][n], r);
                    ve(e, s), a.push(s);
                }
                n.push(a);
            }
            return n;
        }
        function Be(t, e, r) {
            const n = [];
            for(let i = 0; i < t.length; i++){
                const a = Ce(t[i], e, r);
                n.push(a);
            }
            return n;
        }
        function Pe(t, e, r, n) {
            if (t[0] < r[0] || t[0] > r[2]) {
                const e = .5 * n;
                let i = t[0] - r[0] > e ? -n : r[0] - t[0] > e ? n : 0;
                0 === i && (i = t[0] - r[2] > e ? -n : r[2] - t[0] > e ? n : 0), t[0] += i;
            }
            ve(e, t);
        }
        function Ve(t, e, r, n) {
            const i = Math.pow(2, n.z) * xe, a = [
                n.x * xe,
                n.y * xe
            ], s = [];
            for (const n of t)for (const t of n){
                const n = [
                    t.x + a[0],
                    t.y + a[1]
                ];
                Pe(n, e, r, i), s.push(n);
            }
            return s;
        }
        function Ee(t, e, r, n) {
            const i = Math.pow(2, n.z) * xe, a = [
                n.x * xe,
                n.y * xe
            ], s = [];
            for (const r of t){
                const t = [];
                for (const n of r){
                    const r = [
                        n.x + a[0],
                        n.y + a[1]
                    ];
                    ve(e, r), t.push(r);
                }
                s.push(t);
            }
            if (e[2] - e[0] <= i / 2) {
                (o = e)[0] = o[1] = 1 / 0, o[2] = o[3] = -1 / 0;
                for (const t of s)for (const n of t)Pe(n, e, r, i);
            }
            var o;
            return s;
        }
        class Fe {
            constructor(t, e){
                this.type = dt, this.geojson = t, this.geometries = e;
            }
            static parse(t, e) {
                if (2 !== t.length) return e.error(`'within' expression requires exactly one argument, but found ${t.length - 1} instead.`);
                if (ae(t[1])) {
                    const e = t[1];
                    if ("FeatureCollection" === e.type) for(let t = 0; t < e.features.length; ++t){
                        const r = e.features[t].geometry.type;
                        if ("Polygon" === r || "MultiPolygon" === r) return new Fe(e, e.features[t].geometry);
                    }
                    else if ("Feature" === e.type) {
                        const t = e.geometry.type;
                        if ("Polygon" === t || "MultiPolygon" === t) return new Fe(e, e.geometry);
                    } else if ("Polygon" === e.type || "MultiPolygon" === e.type) return new Fe(e, e);
                }
                return e.error("'within' expression requires valid geojson object that contains polygon geometry type.");
            }
            evaluate(t) {
                if (null != t.geometry() && null != t.canonicalID()) {
                    if ("Point" === t.geometryType()) return function(t, e) {
                        const r = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], n = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], i = t.canonicalID();
                        if ("Polygon" === e.type) {
                            const a = Ce(e.coordinates, n, i), s = Ve(t.geometry(), r, n, i);
                            if (!be(r, n)) return !1;
                            for (const t of s)if (!Ae(t, a)) return !1;
                        }
                        if ("MultiPolygon" === e.type) {
                            const a = Be(e.coordinates, n, i), s = Ve(t.geometry(), r, n, i);
                            if (!be(r, n)) return !1;
                            for (const t of s)if (!Se(t, a)) return !1;
                        }
                        return !0;
                    }(t, this.geometries);
                    if ("LineString" === t.geometryType()) return function(t, e) {
                        const r = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], n = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], i = t.canonicalID();
                        if ("Polygon" === e.type) {
                            const a = Ce(e.coordinates, n, i), s = Ee(t.geometry(), r, n, i);
                            if (!be(r, n)) return !1;
                            for (const t of s)if (!ze(t, a)) return !1;
                        }
                        if ("MultiPolygon" === e.type) {
                            const a = Be(e.coordinates, n, i), s = Ee(t.geometry(), r, n, i);
                            if (!be(r, n)) return !1;
                            for (const t of s)if (!Me(t, a)) return !1;
                        }
                        return !0;
                    }(t, this.geometries);
                }
                return !1;
            }
            eachChild() {}
            outputDefined() {
                return !0;
            }
        }
        class Te {
            constructor(t, e){
                this.type = e.type, this.name = t, this.boundExpression = e;
            }
            static parse(t, e) {
                if (2 !== t.length || "string" != typeof t[1]) return e.error("'var' expression requires exactly one string literal argument.");
                const r = t[1];
                return e.scope.has(r) ? new Te(r, e.scope.get(r)) : e.error(`Unknown variable "${r}". Make sure "${r}" has been bound in an enclosing "let" expression before using it.`, 1);
            }
            evaluate(t) {
                return this.boundExpression.evaluate(t);
            }
            eachChild() {}
            outputDefined() {
                return !1;
            }
        }
        class $e {
            constructor(t, e, r, n){
                this.name = t, this.type = e, this._evaluate = r, this.args = n;
            }
            evaluate(t) {
                return this._evaluate(t, this.args);
            }
            eachChild(t) {
                this.args.forEach(t);
            }
            outputDefined() {
                return !1;
            }
            static parse(t, e) {
                const r = t[0], n = $e.definitions[r];
                if (!n) return e.error(`Unknown expression "${r}". If you wanted a literal array, use ["literal", [...]].`, 0);
                const i = Array.isArray(n) ? n[0] : n.type, a = Array.isArray(n) ? [
                    [
                        n[1],
                        n[2]
                    ]
                ] : n.overloads, s = a.filter(([e])=>!Array.isArray(e) || e.length === t.length - 1);
                let o = null;
                for (const [n, a] of s){
                    o = new me(e.registry, Le, e.path, null, e.scope);
                    const s = [];
                    let l = !1;
                    for(let e = 1; e < t.length; e++){
                        const r = t[e], i = Array.isArray(n) ? n[e - 1] : n.type, a = o.parse(r, 1 + s.length, i);
                        if (!a) {
                            l = !0;
                            break;
                        }
                        s.push(a);
                    }
                    if (!l) {
                        if (Array.isArray(n) && n.length !== s.length) o.error(`Expected ${n.length} arguments, but found ${s.length} instead.`);
                        else {
                            for(let t = 0; t < s.length; t++){
                                const e = Array.isArray(n) ? n[t] : n.type, r = s[t];
                                o.concat(t + 1).checkSubtype(e, r.type);
                            }
                            if (0 === o.errors.length) return new $e(r, i, a, s);
                        }
                    }
                }
                if (1 === s.length) e.errors.push(...o.errors);
                else {
                    const r = (s.length ? s : a).map(([t])=>{
                        var e;
                        return e = t, Array.isArray(e) ? `(${e.map(St).join(", ")})` : `(${St(e.type)}...)`;
                    }).join(" | "), n = [];
                    for(let r = 1; r < t.length; r++){
                        const i = e.parse(t[r], 1 + n.length);
                        if (!i) return null;
                        n.push(St(i.type));
                    }
                    e.error(`Expected arguments of type ${r}, but found (${n.join(", ")}) instead.`);
                }
                return null;
            }
            static register(t, e) {
                $e.definitions = e;
                for(const r in e)t[r] = $e;
            }
        }
        function Le(t) {
            if (t instanceof Te) return Le(t.boundExpression);
            if (t instanceof $e && "error" === t.name) return !1;
            if (t instanceof ge) return !1;
            if (t instanceof Fe) return !1;
            const e = t instanceof fe || t instanceof he;
            let r = !0;
            return t.eachChild((t)=>{
                r = e ? r && Le(t) : r && t instanceof le;
            }), !!r && De(t) && Ue(t, [
                "zoom",
                "heatmap-density",
                "line-progress",
                "accumulated",
                "is-supported-script"
            ]);
        }
        function De(t) {
            if (t instanceof $e) {
                if ("get" === t.name && 1 === t.args.length) return !1;
                if ("feature-state" === t.name) return !1;
                if ("has" === t.name && 1 === t.args.length) return !1;
                if ("properties" === t.name || "geometry-type" === t.name || "id" === t.name) return !1;
                if (/^filter-/.test(t.name)) return !1;
            }
            if (t instanceof Fe) return !1;
            let e = !0;
            return t.eachChild((t)=>{
                e && !De(t) && (e = !1);
            }), e;
        }
        function Oe(t) {
            if (t instanceof $e && "feature-state" === t.name) return !1;
            let e = !0;
            return t.eachChild((t)=>{
                e && !Oe(t) && (e = !1);
            }), e;
        }
        function Ue(t, e) {
            if (t instanceof $e && e.indexOf(t.name) >= 0) return !1;
            let r = !0;
            return t.eachChild((t)=>{
                r && !Ue(t, e) && (r = !1);
            }), r;
        }
        function Re(t, e) {
            const r = t.length - 1;
            let n, i, a = 0, s = r, o = 0;
            for(; a <= s;)if (o = Math.floor((a + s) / 2), n = t[o], i = t[o + 1], n <= e) {
                if (o === r || e < i) return o;
                a = o + 1;
            } else {
                if (!(n > e)) throw new ue("Input is not a number.");
                s = o - 1;
            }
            return 0;
        }
        class qe {
            constructor(t, e, r){
                this.type = t, this.input = e, this.labels = [], this.outputs = [];
                for (const [t, e] of r)this.labels.push(t), this.outputs.push(e);
            }
            static parse(t, e) {
                if (t.length - 1 < 4) return e.error(`Expected at least 4 arguments, but found only ${t.length - 1}.`);
                if ((t.length - 1) % 2 != 0) return e.error("Expected an even number of arguments.");
                const r = e.parse(t[1], 1, pt);
                if (!r) return null;
                const n = [];
                let i = null;
                e.expectedType && "value" !== e.expectedType.kind && (i = e.expectedType);
                for(let r = 1; r < t.length; r += 2){
                    const a = 1 === r ? -1 / 0 : t[r], s = t[r + 1], o = r, l = r + 1;
                    if ("number" != typeof a) return e.error('Input/output pairs for "step" expressions must be defined using literal numeric values (not computed expressions) for the input values.', o);
                    if (n.length && n[n.length - 1][0] >= a) return e.error('Input/output pairs for "step" expressions must be arranged with input values in strictly ascending order.', o);
                    const u = e.parse(s, l, i);
                    if (!u) return null;
                    i = i || u.type, n.push([
                        a,
                        u
                    ]);
                }
                return new qe(i, r, n);
            }
            evaluate(t) {
                const e = this.labels, r = this.outputs;
                if (1 === e.length) return r[0].evaluate(t);
                const n = this.input.evaluate(t);
                if (n <= e[0]) return r[0].evaluate(t);
                const i = e.length;
                return n >= e[i - 1] ? r[i - 1].evaluate(t) : r[Re(e, n)].evaluate(t);
            }
            eachChild(t) {
                t(this.input);
                for (const e of this.outputs)t(e);
            }
            outputDefined() {
                return this.outputs.every((t)=>t.outputDefined());
            }
        }
        function je(t, e, r) {
            return t + r * (e - t);
        }
        function Ne(t, e, r) {
            return t.map((t, n)=>je(t, e[n], r));
        }
        const Ze = {
            number: je,
            color: function(t, e, r, n = "rgb") {
                switch(n){
                    case "rgb":
                        {
                            const [n, i, a, s] = Ne(t.rgb, e.rgb, r);
                            return new Yt(n, i, a, s, !1);
                        }
                    case "hcl":
                        {
                            const [n, i, a, s] = t.hcl, [o, l, u, c] = e.hcl;
                            let h, p;
                            if (isNaN(n) || isNaN(o)) isNaN(n) ? isNaN(o) ? h = NaN : (h = o, 1 !== a && 0 !== a || (p = l)) : (h = n, 1 !== u && 0 !== u || (p = i));
                            else {
                                let t = o - n;
                                o > n && t > 180 ? t -= 360 : o < n && n - o > 180 && (t += 360), h = n + r * t;
                            }
                            const [f, d, y, m] = function([t, e, r, n]) {
                                return t = isNaN(t) ? 0 : t * $t, qt([
                                    r,
                                    Math.cos(t) * e,
                                    Math.sin(t) * e,
                                    n
                                ]);
                            }([
                                h,
                                null != p ? p : je(i, l, r),
                                je(a, u, r),
                                je(s, c, r)
                            ]);
                            return new Yt(f, d, y, m, !1);
                        }
                    case "lab":
                        {
                            const [n, i, a, s] = qt(Ne(t.lab, e.lab, r));
                            return new Yt(n, i, a, s, !1);
                        }
                }
            },
            array: Ne,
            padding: function(t, e, r) {
                return new te(Ne(t.values, e.values, r));
            },
            variableAnchorOffsetCollection: function(t, e, r) {
                const n = t.values, i = e.values;
                if (n.length !== i.length) throw new ue(`Cannot interpolate values of different length. from: ${t.toString()}, to: ${e.toString()}`);
                const a = [];
                for(let t = 0; t < n.length; t += 2){
                    if (n[t] !== i[t]) throw new ue(`Cannot interpolate values containing mismatched anchors. from[${t}]: ${n[t]}, to[${t}]: ${i[t]}`);
                    a.push(n[t]);
                    const [e, s] = n[t + 1], [o, l] = i[t + 1];
                    a.push([
                        je(e, o, r),
                        je(s, l, r)
                    ]);
                }
                return new re(a);
            }
        };
        class Ke {
            constructor(t, e, r, n, i){
                this.type = t, this.operator = e, this.interpolation = r, this.input = n, this.labels = [], this.outputs = [];
                for (const [t, e] of i)this.labels.push(t), this.outputs.push(e);
            }
            static interpolationFactor(t, e, r, n) {
                let i = 0;
                if ("exponential" === t.name) i = Ge(e, t.base, r, n);
                else if ("linear" === t.name) i = Ge(e, 1, r, n);
                else if ("cubic-bezier" === t.name) {
                    const a = t.controlPoints;
                    i = new l(a[0], a[1], a[2], a[3]).solve(Ge(e, 1, r, n));
                }
                return i;
            }
            static parse(t, e) {
                let [r, n, i, ...a] = t;
                if (!Array.isArray(n) || 0 === n.length) return e.error("Expected an interpolation type expression.", 1);
                if ("linear" === n[0]) n = {
                    name: "linear"
                };
                else if ("exponential" === n[0]) {
                    const t = n[1];
                    if ("number" != typeof t) return e.error("Exponential interpolation requires a numeric base.", 1, 1);
                    n = {
                        name: "exponential",
                        base: t
                    };
                } else {
                    if ("cubic-bezier" !== n[0]) return e.error(`Unknown interpolation type ${String(n[0])}`, 1, 0);
                    {
                        const t = n.slice(1);
                        if (4 !== t.length || t.some((t)=>"number" != typeof t || t < 0 || t > 1)) return e.error("Cubic bezier interpolation requires four numeric arguments with values between 0 and 1.", 1);
                        n = {
                            name: "cubic-bezier",
                            controlPoints: t
                        };
                    }
                }
                if (t.length - 1 < 4) return e.error(`Expected at least 4 arguments, but found only ${t.length - 1}.`);
                if ((t.length - 1) % 2 != 0) return e.error("Expected an even number of arguments.");
                if (i = e.parse(i, 2, pt), !i) return null;
                const s = [];
                let o = null;
                "interpolate-hcl" === r || "interpolate-lab" === r ? o = yt : e.expectedType && "value" !== e.expectedType.kind && (o = e.expectedType);
                for(let t = 0; t < a.length; t += 2){
                    const r = a[t], n = a[t + 1], i = t + 3, l = t + 4;
                    if ("number" != typeof r) return e.error('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.', i);
                    if (s.length && s[s.length - 1][0] >= r) return e.error('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.', i);
                    const u = e.parse(n, l, o);
                    if (!u) return null;
                    o = o || u.type, s.push([
                        r,
                        u
                    ]);
                }
                return Ct(o, pt) || Ct(o, yt) || Ct(o, bt) || Ct(o, _t) || Ct(o, At(pt)) ? new Ke(o, r, n, i, s) : e.error(`Type ${St(o)} is not interpolatable.`);
            }
            evaluate(t) {
                const e = this.labels, r = this.outputs;
                if (1 === e.length) return r[0].evaluate(t);
                const n = this.input.evaluate(t);
                if (n <= e[0]) return r[0].evaluate(t);
                const i = e.length;
                if (n >= e[i - 1]) return r[i - 1].evaluate(t);
                const a = Re(e, n), s = Ke.interpolationFactor(this.interpolation, n, e[a], e[a + 1]), o = r[a].evaluate(t), l = r[a + 1].evaluate(t);
                switch(this.operator){
                    case "interpolate":
                        return Ze[this.type.kind](o, l, s);
                    case "interpolate-hcl":
                        return Ze.color(o, l, s, "hcl");
                    case "interpolate-lab":
                        return Ze.color(o, l, s, "lab");
                }
            }
            eachChild(t) {
                t(this.input);
                for (const e of this.outputs)t(e);
            }
            outputDefined() {
                return this.outputs.every((t)=>t.outputDefined());
            }
        }
        function Ge(t, e, r, n) {
            const i = n - r, a = t - r;
            return 0 === i ? 0 : 1 === e ? a / i : (Math.pow(e, a) - 1) / (Math.pow(e, i) - 1);
        }
        class Je {
            constructor(t, e){
                this.type = t, this.args = e;
            }
            static parse(t, e) {
                if (t.length < 2) return e.error("Expectected at least one argument.");
                let r = null;
                const n = e.expectedType;
                n && "value" !== n.kind && (r = n);
                const i = [];
                for (const n of t.slice(1)){
                    const t = e.parse(n, 1 + i.length, r, void 0, {
                        typeAnnotation: "omit"
                    });
                    if (!t) return null;
                    r = r || t.type, i.push(t);
                }
                if (!r) throw new Error("No output type");
                const a = n && i.some((t)=>It(n, t.type));
                return new Je(a ? gt : r, i);
            }
            evaluate(t) {
                let e, r = null, n = 0;
                for (const i of this.args)if (n++, r = i.evaluate(t), r && r instanceof ne && !r.available && (e || (e = r.name), r = null, n === this.args.length && (r = e)), null !== r) break;
                return r;
            }
            eachChild(t) {
                this.args.forEach(t);
            }
            outputDefined() {
                return this.args.every((t)=>t.outputDefined());
            }
        }
        class Xe {
            constructor(t, e){
                this.type = e.type, this.bindings = [].concat(t), this.result = e;
            }
            evaluate(t) {
                return this.result.evaluate(t);
            }
            eachChild(t) {
                for (const e of this.bindings)t(e[1]);
                t(this.result);
            }
            static parse(t, e) {
                if (t.length < 4) return e.error(`Expected at least 3 arguments, but found ${t.length - 1} instead.`);
                const r = [];
                for(let n = 1; n < t.length - 1; n += 2){
                    const i = t[n];
                    if ("string" != typeof i) return e.error(`Expected string, but found ${typeof i} instead.`, n);
                    if (/[^a-zA-Z0-9_]/.test(i)) return e.error("Variable names must contain only alphanumeric characters or '_'.", n);
                    const a = e.parse(t[n + 1], n + 1);
                    if (!a) return null;
                    r.push([
                        i,
                        a
                    ]);
                }
                const n = e.parse(t[t.length - 1], t.length - 1, e.expectedType, r);
                return n ? new Xe(r, n) : null;
            }
            outputDefined() {
                return this.result.outputDefined();
            }
        }
        class Ye {
            constructor(t, e, r){
                this.type = t, this.index = e, this.input = r;
            }
            static parse(t, e) {
                if (3 !== t.length) return e.error(`Expected 2 arguments, but found ${t.length - 1} instead.`);
                const r = e.parse(t[1], 1, pt), n = e.parse(t[2], 2, At(e.expectedType || gt));
                return r && n ? new Ye(n.type.itemType, r, n) : null;
            }
            evaluate(t) {
                const e = this.index.evaluate(t), r = this.input.evaluate(t);
                if (e < 0) throw new ue(`Array index out of bounds: ${e} < 0.`);
                if (e >= r.length) throw new ue(`Array index out of bounds: ${e} > ${r.length - 1}.`);
                if (e !== Math.floor(e)) throw new ue(`Array index must be an integer, but found ${e} instead.`);
                return r[e];
            }
            eachChild(t) {
                t(this.index), t(this.input);
            }
            outputDefined() {
                return !1;
            }
        }
        class He {
            constructor(t, e){
                this.type = dt, this.needle = t, this.haystack = e;
            }
            static parse(t, e) {
                if (3 !== t.length) return e.error(`Expected 2 arguments, but found ${t.length - 1} instead.`);
                const r = e.parse(t[1], 1, gt), n = e.parse(t[2], 2, gt);
                return r && n ? zt(r.type, [
                    dt,
                    ft,
                    pt,
                    ht,
                    gt
                ]) ? new He(r, n) : e.error(`Expected first argument to be of type boolean, string, number or null, but found ${St(r.type)} instead`) : null;
            }
            evaluate(t) {
                const e = this.needle.evaluate(t), r = this.haystack.evaluate(t);
                if (!r) return !1;
                if (!Mt(e, [
                    "boolean",
                    "string",
                    "number",
                    "null"
                ])) throw new ue(`Expected first argument to be of type boolean, string, number or null, but found ${St(se(e))} instead.`);
                if (!Mt(r, [
                    "string",
                    "array"
                ])) throw new ue(`Expected second argument to be of type array or string, but found ${St(se(r))} instead.`);
                return r.indexOf(e) >= 0;
            }
            eachChild(t) {
                t(this.needle), t(this.haystack);
            }
            outputDefined() {
                return !0;
            }
        }
        class We {
            constructor(t, e, r){
                this.type = pt, this.needle = t, this.haystack = e, this.fromIndex = r;
            }
            static parse(t, e) {
                if (t.length <= 2 || t.length >= 5) return e.error(`Expected 3 or 4 arguments, but found ${t.length - 1} instead.`);
                const r = e.parse(t[1], 1, gt), n = e.parse(t[2], 2, gt);
                if (!r || !n) return null;
                if (!zt(r.type, [
                    dt,
                    ft,
                    pt,
                    ht,
                    gt
                ])) return e.error(`Expected first argument to be of type boolean, string, number or null, but found ${St(r.type)} instead`);
                if (4 === t.length) {
                    const i = e.parse(t[3], 3, pt);
                    return i ? new We(r, n, i) : null;
                }
                return new We(r, n);
            }
            evaluate(t) {
                const e = this.needle.evaluate(t), r = this.haystack.evaluate(t);
                if (!Mt(e, [
                    "boolean",
                    "string",
                    "number",
                    "null"
                ])) throw new ue(`Expected first argument to be of type boolean, string, number or null, but found ${St(se(e))} instead.`);
                if (!Mt(r, [
                    "string",
                    "array"
                ])) throw new ue(`Expected second argument to be of type array or string, but found ${St(se(r))} instead.`);
                if (this.fromIndex) {
                    const n = this.fromIndex.evaluate(t);
                    return r.indexOf(e, n);
                }
                return r.indexOf(e);
            }
            eachChild(t) {
                t(this.needle), t(this.haystack), this.fromIndex && t(this.fromIndex);
            }
            outputDefined() {
                return !1;
            }
        }
        class Qe {
            constructor(t, e, r, n, i, a){
                this.inputType = t, this.type = e, this.input = r, this.cases = n, this.outputs = i, this.otherwise = a;
            }
            static parse(t, e) {
                if (t.length < 5) return e.error(`Expected at least 4 arguments, but found only ${t.length - 1}.`);
                if (t.length % 2 != 1) return e.error("Expected an even number of arguments.");
                let r, n;
                e.expectedType && "value" !== e.expectedType.kind && (n = e.expectedType);
                const i = {}, a = [];
                for(let s = 2; s < t.length - 1; s += 2){
                    let o = t[s];
                    const l = t[s + 1];
                    Array.isArray(o) || (o = [
                        o
                    ]);
                    const u = e.concat(s);
                    if (0 === o.length) return u.error("Expected at least one branch label.");
                    for (const t of o){
                        if ("number" != typeof t && "string" != typeof t) return u.error("Branch labels must be numbers or strings.");
                        if ("number" == typeof t && Math.abs(t) > Number.MAX_SAFE_INTEGER) return u.error(`Branch labels must be integers no larger than ${Number.MAX_SAFE_INTEGER}.`);
                        if ("number" == typeof t && Math.floor(t) !== t) return u.error("Numeric branch labels must be integer values.");
                        if (r) {
                            if (u.checkSubtype(r, se(t))) return null;
                        } else r = se(t);
                        if (void 0 !== i[String(t)]) return u.error("Branch labels must be unique.");
                        i[String(t)] = a.length;
                    }
                    const c = e.parse(l, s, n);
                    if (!c) return null;
                    n = n || c.type, a.push(c);
                }
                const s = e.parse(t[1], 1, gt);
                if (!s) return null;
                const o = e.parse(t[t.length - 1], t.length - 1, n);
                return o ? "value" !== s.type.kind && e.concat(1).checkSubtype(r, s.type) ? null : new Qe(r, n, s, i, a, o) : null;
            }
            evaluate(t) {
                const e = this.input.evaluate(t);
                return (se(e) === this.inputType && this.outputs[this.cases[e]] || this.otherwise).evaluate(t);
            }
            eachChild(t) {
                t(this.input), this.outputs.forEach(t), t(this.otherwise);
            }
            outputDefined() {
                return this.outputs.every((t)=>t.outputDefined()) && this.otherwise.outputDefined();
            }
        }
        class tr {
            constructor(t, e, r){
                this.type = t, this.branches = e, this.otherwise = r;
            }
            static parse(t, e) {
                if (t.length < 4) return e.error(`Expected at least 3 arguments, but found only ${t.length - 1}.`);
                if (t.length % 2 != 0) return e.error("Expected an odd number of arguments.");
                let r;
                e.expectedType && "value" !== e.expectedType.kind && (r = e.expectedType);
                const n = [];
                for(let i = 1; i < t.length - 1; i += 2){
                    const a = e.parse(t[i], i, dt);
                    if (!a) return null;
                    const s = e.parse(t[i + 1], i + 1, r);
                    if (!s) return null;
                    n.push([
                        a,
                        s
                    ]), r = r || s.type;
                }
                const i = e.parse(t[t.length - 1], t.length - 1, r);
                if (!i) return null;
                if (!r) throw new Error("Can't infer output type");
                return new tr(r, n, i);
            }
            evaluate(t) {
                for (const [e, r] of this.branches)if (e.evaluate(t)) return r.evaluate(t);
                return this.otherwise.evaluate(t);
            }
            eachChild(t) {
                for (const [e, r] of this.branches)t(e), t(r);
                t(this.otherwise);
            }
            outputDefined() {
                return this.branches.every(([t, e])=>e.outputDefined()) && this.otherwise.outputDefined();
            }
        }
        class er {
            constructor(t, e, r, n){
                this.type = t, this.input = e, this.beginIndex = r, this.endIndex = n;
            }
            static parse(t, e) {
                if (t.length <= 2 || t.length >= 5) return e.error(`Expected 3 or 4 arguments, but found ${t.length - 1} instead.`);
                const r = e.parse(t[1], 1, gt), n = e.parse(t[2], 2, pt);
                if (!r || !n) return null;
                if (!zt(r.type, [
                    At(gt),
                    ft,
                    gt
                ])) return e.error(`Expected first argument to be of type array or string, but found ${St(r.type)} instead`);
                if (4 === t.length) {
                    const i = e.parse(t[3], 3, pt);
                    return i ? new er(r.type, r, n, i) : null;
                }
                return new er(r.type, r, n);
            }
            evaluate(t) {
                const e = this.input.evaluate(t), r = this.beginIndex.evaluate(t);
                if (!Mt(e, [
                    "string",
                    "array"
                ])) throw new ue(`Expected first argument to be of type array or string, but found ${St(se(e))} instead.`);
                if (this.endIndex) {
                    const n = this.endIndex.evaluate(t);
                    return e.slice(r, n);
                }
                return e.slice(r);
            }
            eachChild(t) {
                t(this.input), t(this.beginIndex), this.endIndex && t(this.endIndex);
            }
            outputDefined() {
                return !1;
            }
        }
        function rr(t, e) {
            return "==" === t || "!=" === t ? "boolean" === e.kind || "string" === e.kind || "number" === e.kind || "null" === e.kind || "value" === e.kind : "string" === e.kind || "number" === e.kind || "value" === e.kind;
        }
        function nr(t, e, r, n) {
            return 0 === n.compare(e, r);
        }
        function ir(t, e, r) {
            const n = "==" !== t && "!=" !== t;
            return class i {
                constructor(t, e, r){
                    this.type = dt, this.lhs = t, this.rhs = e, this.collator = r, this.hasUntypedArgument = "value" === t.type.kind || "value" === e.type.kind;
                }
                static parse(t, e) {
                    if (3 !== t.length && 4 !== t.length) return e.error("Expected two or three arguments.");
                    const r = t[0];
                    let a = e.parse(t[1], 1, gt);
                    if (!a) return null;
                    if (!rr(r, a.type)) return e.concat(1).error(`"${r}" comparisons are not supported for type '${St(a.type)}'.`);
                    let s = e.parse(t[2], 2, gt);
                    if (!s) return null;
                    if (!rr(r, s.type)) return e.concat(2).error(`"${r}" comparisons are not supported for type '${St(s.type)}'.`);
                    if (a.type.kind !== s.type.kind && "value" !== a.type.kind && "value" !== s.type.kind) return e.error(`Cannot compare types '${St(a.type)}' and '${St(s.type)}'.`);
                    n && ("value" === a.type.kind && "value" !== s.type.kind ? a = new he(s.type, [
                        a
                    ]) : "value" !== a.type.kind && "value" === s.type.kind && (s = new he(a.type, [
                        s
                    ])));
                    let o = null;
                    if (4 === t.length) {
                        if ("string" !== a.type.kind && "string" !== s.type.kind && "value" !== a.type.kind && "value" !== s.type.kind) return e.error("Cannot use collator to compare non-string types.");
                        if (o = e.parse(t[3], 3, xt), !o) return null;
                    }
                    return new i(a, s, o);
                }
                evaluate(i) {
                    const a = this.lhs.evaluate(i), s = this.rhs.evaluate(i);
                    if (n && this.hasUntypedArgument) {
                        const e = se(a), r = se(s);
                        if (e.kind !== r.kind || "string" !== e.kind && "number" !== e.kind) throw new ue(`Expected arguments for "${t}" to be (string, string) or (number, number), but found (${e.kind}, ${r.kind}) instead.`);
                    }
                    if (this.collator && !n && this.hasUntypedArgument) {
                        const t = se(a), r = se(s);
                        if ("string" !== t.kind || "string" !== r.kind) return e(i, a, s);
                    }
                    return this.collator ? r(i, a, s, this.collator.evaluate(i)) : e(i, a, s);
                }
                eachChild(t) {
                    t(this.lhs), t(this.rhs), this.collator && t(this.collator);
                }
                outputDefined() {
                    return !0;
                }
            };
        }
        const ar = ir("==", function(t, e, r) {
            return e === r;
        }, nr), sr = ir("!=", function(t, e, r) {
            return e !== r;
        }, function(t, e, r, n) {
            return !nr(0, e, r, n);
        }), or = ir("<", function(t, e, r) {
            return e < r;
        }, function(t, e, r, n) {
            return n.compare(e, r) < 0;
        }), lr = ir(">", function(t, e, r) {
            return e > r;
        }, function(t, e, r, n) {
            return n.compare(e, r) > 0;
        }), ur = ir("<=", function(t, e, r) {
            return e <= r;
        }, function(t, e, r, n) {
            return n.compare(e, r) <= 0;
        }), cr = ir(">=", function(t, e, r) {
            return e >= r;
        }, function(t, e, r, n) {
            return n.compare(e, r) >= 0;
        });
        class hr {
            constructor(t, e, r, n, i){
                this.type = ft, this.number = t, this.locale = e, this.currency = r, this.minFractionDigits = n, this.maxFractionDigits = i;
            }
            static parse(t, e) {
                if (3 !== t.length) return e.error("Expected two arguments.");
                const r = e.parse(t[1], 1, pt);
                if (!r) return null;
                const n = t[2];
                if ("object" != typeof n || Array.isArray(n)) return e.error("NumberFormat options argument must be an object.");
                let i = null;
                if (n.locale && (i = e.parse(n.locale, 1, ft), !i)) return null;
                let a = null;
                if (n.currency && (a = e.parse(n.currency, 1, ft), !a)) return null;
                let s = null;
                if (n["min-fraction-digits"] && (s = e.parse(n["min-fraction-digits"], 1, pt), !s)) return null;
                let o = null;
                return n["max-fraction-digits"] && (o = e.parse(n["max-fraction-digits"], 1, pt), !o) ? null : new hr(r, i, a, s, o);
            }
            evaluate(t) {
                return new Intl.NumberFormat(this.locale ? this.locale.evaluate(t) : [], {
                    style: this.currency ? "currency" : "decimal",
                    currency: this.currency ? this.currency.evaluate(t) : void 0,
                    minimumFractionDigits: this.minFractionDigits ? this.minFractionDigits.evaluate(t) : void 0,
                    maximumFractionDigits: this.maxFractionDigits ? this.maxFractionDigits.evaluate(t) : void 0
                }).format(this.number.evaluate(t));
            }
            eachChild(t) {
                t(this.number), this.locale && t(this.locale), this.currency && t(this.currency), this.minFractionDigits && t(this.minFractionDigits), this.maxFractionDigits && t(this.maxFractionDigits);
            }
            outputDefined() {
                return !1;
            }
        }
        class pr {
            constructor(t){
                this.type = vt, this.sections = t;
            }
            static parse(t, e) {
                if (t.length < 2) return e.error("Expected at least one argument.");
                const r = t[1];
                if (!Array.isArray(r) && "object" == typeof r) return e.error("First argument must be an image or text section.");
                const n = [];
                let i = !1;
                for(let r = 1; r <= t.length - 1; ++r){
                    const a = t[r];
                    if (i && "object" == typeof a && !Array.isArray(a)) {
                        i = !1;
                        let t = null;
                        if (a["font-scale"] && (t = e.parse(a["font-scale"], 1, pt), !t)) return null;
                        let r = null;
                        if (a["text-font"] && (r = e.parse(a["text-font"], 1, At(ft)), !r)) return null;
                        let s = null;
                        if (a["text-color"] && (s = e.parse(a["text-color"], 1, yt), !s)) return null;
                        const o = n[n.length - 1];
                        o.scale = t, o.font = r, o.textColor = s;
                    } else {
                        const a = e.parse(t[r], 1, gt);
                        if (!a) return null;
                        const s = a.type.kind;
                        if ("string" !== s && "value" !== s && "null" !== s && "resolvedImage" !== s) return e.error("Formatted text type must be 'string', 'value', 'image' or 'null'.");
                        i = !0, n.push({
                            content: a,
                            scale: null,
                            font: null,
                            textColor: null
                        });
                    }
                }
                return new pr(n);
            }
            evaluate(t) {
                return new Qt(this.sections.map((e)=>{
                    const r = e.content.evaluate(t);
                    return se(r) === wt ? new Wt("", r, null, null, null) : new Wt(oe(r), null, e.scale ? e.scale.evaluate(t) : null, e.font ? e.font.evaluate(t).join(",") : null, e.textColor ? e.textColor.evaluate(t) : null);
                }));
            }
            eachChild(t) {
                for (const e of this.sections)t(e.content), e.scale && t(e.scale), e.font && t(e.font), e.textColor && t(e.textColor);
            }
            outputDefined() {
                return !1;
            }
        }
        class fr {
            constructor(t){
                this.type = wt, this.input = t;
            }
            static parse(t, e) {
                if (2 !== t.length) return e.error("Expected two arguments.");
                const r = e.parse(t[1], 1, ft);
                return r ? new fr(r) : e.error("No image name provided.");
            }
            evaluate(t) {
                const e = this.input.evaluate(t), r = ne.fromString(e);
                return r && t.availableImages && (r.available = t.availableImages.indexOf(e) > -1), r;
            }
            eachChild(t) {
                t(this.input);
            }
            outputDefined() {
                return !1;
            }
        }
        class dr {
            constructor(t){
                this.type = pt, this.input = t;
            }
            static parse(t, e) {
                if (2 !== t.length) return e.error(`Expected 1 argument, but found ${t.length - 1} instead.`);
                const r = e.parse(t[1], 1);
                return r ? "array" !== r.type.kind && "string" !== r.type.kind && "value" !== r.type.kind ? e.error(`Expected argument of type string or array, but found ${St(r.type)} instead.`) : new dr(r) : null;
            }
            evaluate(t) {
                const e = this.input.evaluate(t);
                if ("string" == typeof e) return e.length;
                if (Array.isArray(e)) return e.length;
                throw new ue(`Expected value to be of type string or array, but found ${St(se(e))} instead.`);
            }
            eachChild(t) {
                t(this.input);
            }
            outputDefined() {
                return !1;
            }
        }
        const yr = {
            "==": ar,
            "!=": sr,
            ">": lr,
            "<": or,
            ">=": cr,
            "<=": ur,
            array: he,
            at: Ye,
            boolean: he,
            case: tr,
            coalesce: Je,
            collator: ge,
            format: pr,
            image: fr,
            in: He,
            "index-of": We,
            interpolate: Ke,
            "interpolate-hcl": Ke,
            "interpolate-lab": Ke,
            length: dr,
            let: Xe,
            literal: le,
            match: Qe,
            number: he,
            "number-format": hr,
            object: he,
            slice: er,
            step: qe,
            string: he,
            "to-boolean": fe,
            "to-color": fe,
            "to-number": fe,
            "to-string": fe,
            var: Te,
            within: Fe
        };
        function mr(t, [e, r, n, i]) {
            e = e.evaluate(t), r = r.evaluate(t), n = n.evaluate(t);
            const a = i ? i.evaluate(t) : 1, s = ie(e, r, n, a);
            if (s) throw new ue(s);
            return new Yt(e / 255, r / 255, n / 255, a, !1);
        }
        function gr(t, e) {
            return t in e;
        }
        function xr(t, e) {
            const r = e[t];
            return void 0 === r ? null : r;
        }
        function vr(t) {
            return {
                type: t
            };
        }
        function br(t) {
            return {
                result: "success",
                value: t
            };
        }
        function wr(t) {
            return {
                result: "error",
                value: t
            };
        }
        function _r(t) {
            return "data-driven" === t["property-type"] || "cross-faded-data-driven" === t["property-type"];
        }
        function Ar(t) {
            return !!t.expression && t.expression.parameters.indexOf("zoom") > -1;
        }
        function Sr(t) {
            return !!t.expression && t.expression.interpolated;
        }
        function kr(t) {
            return t instanceof Number ? "number" : t instanceof String ? "string" : t instanceof Boolean ? "boolean" : Array.isArray(t) ? "array" : null === t ? "null" : typeof t;
        }
        function Ir(t) {
            return "object" == typeof t && null !== t && !Array.isArray(t);
        }
        function zr(t) {
            return t;
        }
        function Mr(t, e) {
            const r = "color" === e.type, n = t.stops && "object" == typeof t.stops[0][0], i = n || !(n || void 0 !== t.property), a = t.type || (Sr(e) ? "exponential" : "interval");
            if (r || "padding" === e.type) {
                const n = r ? Yt.parse : te.parse;
                (t = lt({}, t)).stops && (t.stops = t.stops.map((t)=>[
                        t[0],
                        n(t[1])
                    ])), t.default = n(t.default ? t.default : e.default);
            }
            if (t.colorSpace && "rgb" !== (s = t.colorSpace) && "hcl" !== s && "lab" !== s) throw new Error(`Unknown color space: "${t.colorSpace}"`);
            var s;
            let o, l, u;
            if ("exponential" === a) o = Vr;
            else if ("interval" === a) o = Pr;
            else if ("categorical" === a) {
                o = Br, l = Object.create(null);
                for (const e of t.stops)l[e[0]] = e[1];
                u = typeof t.stops[0][0];
            } else {
                if ("identity" !== a) throw new Error(`Unknown function type "${a}"`);
                o = Er;
            }
            if (n) {
                const r = {}, n = [];
                for(let e = 0; e < t.stops.length; e++){
                    const i = t.stops[e], a = i[0].zoom;
                    void 0 === r[a] && (r[a] = {
                        zoom: a,
                        type: t.type,
                        property: t.property,
                        default: t.default,
                        stops: []
                    }, n.push(a)), r[a].stops.push([
                        i[0].value,
                        i[1]
                    ]);
                }
                const i = [];
                for (const t of n)i.push([
                    r[t].zoom,
                    Mr(r[t], e)
                ]);
                const a = {
                    name: "linear"
                };
                return {
                    kind: "composite",
                    interpolationType: a,
                    interpolationFactor: Ke.interpolationFactor.bind(void 0, a),
                    zoomStops: i.map((t)=>t[0]),
                    evaluate: ({ zoom: r }, n)=>Vr({
                            stops: i,
                            base: t.base
                        }, e, r).evaluate(r, n)
                };
            }
            if (i) {
                const r = "exponential" === a ? {
                    name: "exponential",
                    base: void 0 !== t.base ? t.base : 1
                } : null;
                return {
                    kind: "camera",
                    interpolationType: r,
                    interpolationFactor: Ke.interpolationFactor.bind(void 0, r),
                    zoomStops: t.stops.map((t)=>t[0]),
                    evaluate: ({ zoom: r })=>o(t, e, r, l, u)
                };
            }
            return {
                kind: "source",
                evaluate (r, n) {
                    const i = n && n.properties ? n.properties[t.property] : void 0;
                    return void 0 === i ? Cr(t.default, e.default) : o(t, e, i, l, u);
                }
            };
        }
        function Cr(t, e, r) {
            return void 0 !== t ? t : void 0 !== e ? e : void 0 !== r ? r : void 0;
        }
        function Br(t, e, r, n, i) {
            return Cr(typeof r === i ? n[r] : void 0, t.default, e.default);
        }
        function Pr(t, e, r) {
            if ("number" !== kr(r)) return Cr(t.default, e.default);
            const n = t.stops.length;
            if (1 === n) return t.stops[0][1];
            if (r <= t.stops[0][0]) return t.stops[0][1];
            if (r >= t.stops[n - 1][0]) return t.stops[n - 1][1];
            const i = Re(t.stops.map((t)=>t[0]), r);
            return t.stops[i][1];
        }
        function Vr(t, e, r) {
            const n = void 0 !== t.base ? t.base : 1;
            if ("number" !== kr(r)) return Cr(t.default, e.default);
            const i = t.stops.length;
            if (1 === i) return t.stops[0][1];
            if (r <= t.stops[0][0]) return t.stops[0][1];
            if (r >= t.stops[i - 1][0]) return t.stops[i - 1][1];
            const a = Re(t.stops.map((t)=>t[0]), r), s = function(t, e, r, n) {
                const i = n - r, a = t - r;
                return 0 === i ? 0 : 1 === e ? a / i : (Math.pow(e, a) - 1) / (Math.pow(e, i) - 1);
            }(r, n, t.stops[a][0], t.stops[a + 1][0]), o = t.stops[a][1], l = t.stops[a + 1][1], u = Ze[e.type] || zr;
            return "function" == typeof o.evaluate ? {
                evaluate (...e) {
                    const r = o.evaluate.apply(void 0, e), n = l.evaluate.apply(void 0, e);
                    if (void 0 !== r && void 0 !== n) return u(r, n, s, t.colorSpace);
                }
            } : u(o, l, s, t.colorSpace);
        }
        function Er(t, e, r) {
            switch(e.type){
                case "color":
                    r = Yt.parse(r);
                    break;
                case "formatted":
                    r = Qt.fromString(r.toString());
                    break;
                case "resolvedImage":
                    r = ne.fromString(r.toString());
                    break;
                case "padding":
                    r = te.parse(r);
                    break;
                default:
                    kr(r) === e.type || "enum" === e.type && e.values[r] || (r = void 0);
            }
            return Cr(r, t.default, e.default);
        }
        $e.register(yr, {
            error: [
                {
                    kind: "error"
                },
                [
                    ft
                ],
                (t, [e])=>{
                    throw new ue(e.evaluate(t));
                }
            ],
            typeof: [
                ft,
                [
                    gt
                ],
                (t, [e])=>St(se(e.evaluate(t)))
            ],
            "to-rgba": [
                At(pt, 4),
                [
                    yt
                ],
                (t, [e])=>{
                    const [r, n, i, a] = e.evaluate(t).rgb;
                    return [
                        255 * r,
                        255 * n,
                        255 * i,
                        a
                    ];
                }
            ],
            rgb: [
                yt,
                [
                    pt,
                    pt,
                    pt
                ],
                mr
            ],
            rgba: [
                yt,
                [
                    pt,
                    pt,
                    pt,
                    pt
                ],
                mr
            ],
            has: {
                type: dt,
                overloads: [
                    [
                        [
                            ft
                        ],
                        (t, [e])=>gr(e.evaluate(t), t.properties())
                    ],
                    [
                        [
                            ft,
                            mt
                        ],
                        (t, [e, r])=>gr(e.evaluate(t), r.evaluate(t))
                    ]
                ]
            },
            get: {
                type: gt,
                overloads: [
                    [
                        [
                            ft
                        ],
                        (t, [e])=>xr(e.evaluate(t), t.properties())
                    ],
                    [
                        [
                            ft,
                            mt
                        ],
                        (t, [e, r])=>xr(e.evaluate(t), r.evaluate(t))
                    ]
                ]
            },
            "feature-state": [
                gt,
                [
                    ft
                ],
                (t, [e])=>xr(e.evaluate(t), t.featureState || {})
            ],
            properties: [
                mt,
                [],
                (t)=>t.properties()
            ],
            "geometry-type": [
                ft,
                [],
                (t)=>t.geometryType()
            ],
            id: [
                gt,
                [],
                (t)=>t.id()
            ],
            zoom: [
                pt,
                [],
                (t)=>t.globals.zoom
            ],
            "heatmap-density": [
                pt,
                [],
                (t)=>t.globals.heatmapDensity || 0
            ],
            "line-progress": [
                pt,
                [],
                (t)=>t.globals.lineProgress || 0
            ],
            accumulated: [
                gt,
                [],
                (t)=>void 0 === t.globals.accumulated ? null : t.globals.accumulated
            ],
            "+": [
                pt,
                vr(pt),
                (t, e)=>{
                    let r = 0;
                    for (const n of e)r += n.evaluate(t);
                    return r;
                }
            ],
            "*": [
                pt,
                vr(pt),
                (t, e)=>{
                    let r = 1;
                    for (const n of e)r *= n.evaluate(t);
                    return r;
                }
            ],
            "-": {
                type: pt,
                overloads: [
                    [
                        [
                            pt,
                            pt
                        ],
                        (t, [e, r])=>e.evaluate(t) - r.evaluate(t)
                    ],
                    [
                        [
                            pt
                        ],
                        (t, [e])=>-e.evaluate(t)
                    ]
                ]
            },
            "/": [
                pt,
                [
                    pt,
                    pt
                ],
                (t, [e, r])=>e.evaluate(t) / r.evaluate(t)
            ],
            "%": [
                pt,
                [
                    pt,
                    pt
                ],
                (t, [e, r])=>e.evaluate(t) % r.evaluate(t)
            ],
            ln2: [
                pt,
                [],
                ()=>Math.LN2
            ],
            pi: [
                pt,
                [],
                ()=>Math.PI
            ],
            e: [
                pt,
                [],
                ()=>Math.E
            ],
            "^": [
                pt,
                [
                    pt,
                    pt
                ],
                (t, [e, r])=>Math.pow(e.evaluate(t), r.evaluate(t))
            ],
            sqrt: [
                pt,
                [
                    pt
                ],
                (t, [e])=>Math.sqrt(e.evaluate(t))
            ],
            log10: [
                pt,
                [
                    pt
                ],
                (t, [e])=>Math.log(e.evaluate(t)) / Math.LN10
            ],
            ln: [
                pt,
                [
                    pt
                ],
                (t, [e])=>Math.log(e.evaluate(t))
            ],
            log2: [
                pt,
                [
                    pt
                ],
                (t, [e])=>Math.log(e.evaluate(t)) / Math.LN2
            ],
            sin: [
                pt,
                [
                    pt
                ],
                (t, [e])=>Math.sin(e.evaluate(t))
            ],
            cos: [
                pt,
                [
                    pt
                ],
                (t, [e])=>Math.cos(e.evaluate(t))
            ],
            tan: [
                pt,
                [
                    pt
                ],
                (t, [e])=>Math.tan(e.evaluate(t))
            ],
            asin: [
                pt,
                [
                    pt
                ],
                (t, [e])=>Math.asin(e.evaluate(t))
            ],
            acos: [
                pt,
                [
                    pt
                ],
                (t, [e])=>Math.acos(e.evaluate(t))
            ],
            atan: [
                pt,
                [
                    pt
                ],
                (t, [e])=>Math.atan(e.evaluate(t))
            ],
            min: [
                pt,
                vr(pt),
                (t, e)=>Math.min(...e.map((e)=>e.evaluate(t)))
            ],
            max: [
                pt,
                vr(pt),
                (t, e)=>Math.max(...e.map((e)=>e.evaluate(t)))
            ],
            abs: [
                pt,
                [
                    pt
                ],
                (t, [e])=>Math.abs(e.evaluate(t))
            ],
            round: [
                pt,
                [
                    pt
                ],
                (t, [e])=>{
                    const r = e.evaluate(t);
                    return r < 0 ? -Math.round(-r) : Math.round(r);
                }
            ],
            floor: [
                pt,
                [
                    pt
                ],
                (t, [e])=>Math.floor(e.evaluate(t))
            ],
            ceil: [
                pt,
                [
                    pt
                ],
                (t, [e])=>Math.ceil(e.evaluate(t))
            ],
            "filter-==": [
                dt,
                [
                    ft,
                    gt
                ],
                (t, [e, r])=>t.properties()[e.value] === r.value
            ],
            "filter-id-==": [
                dt,
                [
                    gt
                ],
                (t, [e])=>t.id() === e.value
            ],
            "filter-type-==": [
                dt,
                [
                    ft
                ],
                (t, [e])=>t.geometryType() === e.value
            ],
            "filter-<": [
                dt,
                [
                    ft,
                    gt
                ],
                (t, [e, r])=>{
                    const n = t.properties()[e.value], i = r.value;
                    return typeof n == typeof i && n < i;
                }
            ],
            "filter-id-<": [
                dt,
                [
                    gt
                ],
                (t, [e])=>{
                    const r = t.id(), n = e.value;
                    return typeof r == typeof n && r < n;
                }
            ],
            "filter->": [
                dt,
                [
                    ft,
                    gt
                ],
                (t, [e, r])=>{
                    const n = t.properties()[e.value], i = r.value;
                    return typeof n == typeof i && n > i;
                }
            ],
            "filter-id->": [
                dt,
                [
                    gt
                ],
                (t, [e])=>{
                    const r = t.id(), n = e.value;
                    return typeof r == typeof n && r > n;
                }
            ],
            "filter-<=": [
                dt,
                [
                    ft,
                    gt
                ],
                (t, [e, r])=>{
                    const n = t.properties()[e.value], i = r.value;
                    return typeof n == typeof i && n <= i;
                }
            ],
            "filter-id-<=": [
                dt,
                [
                    gt
                ],
                (t, [e])=>{
                    const r = t.id(), n = e.value;
                    return typeof r == typeof n && r <= n;
                }
            ],
            "filter->=": [
                dt,
                [
                    ft,
                    gt
                ],
                (t, [e, r])=>{
                    const n = t.properties()[e.value], i = r.value;
                    return typeof n == typeof i && n >= i;
                }
            ],
            "filter-id->=": [
                dt,
                [
                    gt
                ],
                (t, [e])=>{
                    const r = t.id(), n = e.value;
                    return typeof r == typeof n && r >= n;
                }
            ],
            "filter-has": [
                dt,
                [
                    gt
                ],
                (t, [e])=>e.value in t.properties()
            ],
            "filter-has-id": [
                dt,
                [],
                (t)=>null !== t.id() && void 0 !== t.id()
            ],
            "filter-type-in": [
                dt,
                [
                    At(ft)
                ],
                (t, [e])=>e.value.indexOf(t.geometryType()) >= 0
            ],
            "filter-id-in": [
                dt,
                [
                    At(gt)
                ],
                (t, [e])=>e.value.indexOf(t.id()) >= 0
            ],
            "filter-in-small": [
                dt,
                [
                    ft,
                    At(gt)
                ],
                (t, [e, r])=>r.value.indexOf(t.properties()[e.value]) >= 0
            ],
            "filter-in-large": [
                dt,
                [
                    ft,
                    At(gt)
                ],
                (t, [e, r])=>(function(t, e, r, n) {
                        for(; r <= n;){
                            const i = r + n >> 1;
                            if (e[i] === t) return !0;
                            e[i] > t ? n = i - 1 : r = i + 1;
                        }
                        return !1;
                    })(t.properties()[e.value], r.value, 0, r.value.length - 1)
            ],
            all: {
                type: dt,
                overloads: [
                    [
                        [
                            dt,
                            dt
                        ],
                        (t, [e, r])=>e.evaluate(t) && r.evaluate(t)
                    ],
                    [
                        vr(dt),
                        (t, e)=>{
                            for (const r of e)if (!r.evaluate(t)) return !1;
                            return !0;
                        }
                    ]
                ]
            },
            any: {
                type: dt,
                overloads: [
                    [
                        [
                            dt,
                            dt
                        ],
                        (t, [e, r])=>e.evaluate(t) || r.evaluate(t)
                    ],
                    [
                        vr(dt),
                        (t, e)=>{
                            for (const r of e)if (r.evaluate(t)) return !0;
                            return !1;
                        }
                    ]
                ]
            },
            "!": [
                dt,
                [
                    dt
                ],
                (t, [e])=>!e.evaluate(t)
            ],
            "is-supported-script": [
                dt,
                [
                    ft
                ],
                (t, [e])=>{
                    const r = t.globals && t.globals.isSupportedScript;
                    return !r || r(e.evaluate(t));
                }
            ],
            upcase: [
                ft,
                [
                    ft
                ],
                (t, [e])=>e.evaluate(t).toUpperCase()
            ],
            downcase: [
                ft,
                [
                    ft
                ],
                (t, [e])=>e.evaluate(t).toLowerCase()
            ],
            concat: [
                ft,
                vr(gt),
                (t, e)=>e.map((e)=>oe(e.evaluate(t))).join("")
            ],
            "resolved-locale": [
                ft,
                [
                    xt
                ],
                (t, [e])=>e.evaluate(t).resolvedLocale()
            ]
        });
        class Fr {
            constructor(t, e){
                var r;
                this.expression = t, this._warningHistory = {}, this._evaluator = new ye, this._defaultValue = e ? "color" === (r = e).type && Ir(r.default) ? new Yt(0, 0, 0, 0) : "color" === r.type ? Yt.parse(r.default) || null : "padding" === r.type ? te.parse(r.default) || null : "variableAnchorOffsetCollection" === r.type ? re.parse(r.default) || null : void 0 === r.default ? null : r.default : null, this._enumValues = e && "enum" === e.type ? e.values : null;
            }
            evaluateWithoutErrorHandling(t, e, r, n, i, a) {
                return this._evaluator.globals = t, this._evaluator.feature = e, this._evaluator.featureState = r, this._evaluator.canonical = n, this._evaluator.availableImages = i || null, this._evaluator.formattedSection = a, this.expression.evaluate(this._evaluator);
            }
            evaluate(t, e, r, n, i, a) {
                this._evaluator.globals = t, this._evaluator.feature = e || null, this._evaluator.featureState = r || null, this._evaluator.canonical = n, this._evaluator.availableImages = i || null, this._evaluator.formattedSection = a || null;
                try {
                    const t = this.expression.evaluate(this._evaluator);
                    if (null == t || "number" == typeof t && t != t) return this._defaultValue;
                    if (this._enumValues && !(t in this._enumValues)) throw new ue(`Expected value to be one of ${Object.keys(this._enumValues).map((t)=>JSON.stringify(t)).join(", ")}, but found ${JSON.stringify(t)} instead.`);
                    return t;
                } catch (t) {
                    return this._warningHistory[t.message] || (this._warningHistory[t.message] = !0, "undefined" != typeof console && console.warn(t.message)), this._defaultValue;
                }
            }
        }
        function Tr(t) {
            return Array.isArray(t) && t.length > 0 && "string" == typeof t[0] && t[0] in yr;
        }
        function $r(t, e) {
            const r = new me(yr, Le, [], e ? function(t) {
                const e = {
                    color: yt,
                    string: ft,
                    number: pt,
                    enum: ft,
                    boolean: dt,
                    formatted: vt,
                    padding: bt,
                    resolvedImage: wt,
                    variableAnchorOffsetCollection: _t
                };
                return "array" === t.type ? At(e[t.value] || gt, t.length) : e[t.type];
            }(e) : void 0), n = r.parse(t, void 0, void 0, void 0, e && "string" === e.type ? {
                typeAnnotation: "coerce"
            } : void 0);
            return n ? br(new Fr(n, e)) : wr(r.errors);
        }
        class Lr {
            constructor(t, e){
                this.kind = t, this._styleExpression = e, this.isStateDependent = "constant" !== t && !Oe(e.expression);
            }
            evaluateWithoutErrorHandling(t, e, r, n, i, a) {
                return this._styleExpression.evaluateWithoutErrorHandling(t, e, r, n, i, a);
            }
            evaluate(t, e, r, n, i, a) {
                return this._styleExpression.evaluate(t, e, r, n, i, a);
            }
        }
        class Dr {
            constructor(t, e, r, n){
                this.kind = t, this.zoomStops = r, this._styleExpression = e, this.isStateDependent = "camera" !== t && !Oe(e.expression), this.interpolationType = n;
            }
            evaluateWithoutErrorHandling(t, e, r, n, i, a) {
                return this._styleExpression.evaluateWithoutErrorHandling(t, e, r, n, i, a);
            }
            evaluate(t, e, r, n, i, a) {
                return this._styleExpression.evaluate(t, e, r, n, i, a);
            }
            interpolationFactor(t, e, r) {
                return this.interpolationType ? Ke.interpolationFactor(this.interpolationType, t, e, r) : 0;
            }
        }
        function Or(t, e) {
            const r = $r(t, e);
            if ("error" === r.result) return r;
            const n = r.value.expression, i = De(n);
            if (!i && !_r(e)) return wr([
                new ut("", "data expressions not supported")
            ]);
            const a = Ue(n, [
                "zoom"
            ]);
            if (!a && !Ar(e)) return wr([
                new ut("", "zoom expressions not supported")
            ]);
            const s = Rr(n);
            return s || a ? s instanceof ut ? wr([
                s
            ]) : s instanceof Ke && !Sr(e) ? wr([
                new ut("", '"interpolate" expressions cannot be used with this property')
            ]) : br(s ? new Dr(i ? "camera" : "composite", r.value, s.labels, s instanceof Ke ? s.interpolation : void 0) : new Lr(i ? "constant" : "source", r.value)) : wr([
                new ut("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.')
            ]);
        }
        class Ur {
            constructor(t, e){
                this._parameters = t, this._specification = e, lt(this, Mr(this._parameters, this._specification));
            }
            static deserialize(t) {
                return new Ur(t._parameters, t._specification);
            }
            static serialize(t) {
                return {
                    _parameters: t._parameters,
                    _specification: t._specification
                };
            }
        }
        function Rr(t) {
            let e = null;
            if (t instanceof Xe) e = Rr(t.result);
            else if (t instanceof Je) {
                for (const r of t.args)if (e = Rr(r), e) break;
            } else (t instanceof qe || t instanceof Ke) && t.input instanceof $e && "zoom" === t.input.name && (e = t);
            return e instanceof ut || t.eachChild((t)=>{
                const r = Rr(t);
                r instanceof ut ? e = r : !e && r ? e = new ut("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.') : e && r && e !== r && (e = new ut("", 'Only one zoom-based "step" or "interpolate" subexpression may be used in an expression.'));
            }), e;
        }
        function qr(t) {
            if (!0 === t || !1 === t) return !0;
            if (!Array.isArray(t) || 0 === t.length) return !1;
            switch(t[0]){
                case "has":
                    return t.length >= 2 && "$id" !== t[1] && "$type" !== t[1];
                case "in":
                    return t.length >= 3 && ("string" != typeof t[1] || Array.isArray(t[2]));
                case "!in":
                case "!has":
                case "none":
                    return !1;
                case "==":
                case "!=":
                case ">":
                case ">=":
                case "<":
                case "<=":
                    return 3 !== t.length || Array.isArray(t[1]) || Array.isArray(t[2]);
                case "any":
                case "all":
                    for (const e of t.slice(1))if (!qr(e) && "boolean" != typeof e) return !1;
                    return !0;
                default:
                    return !0;
            }
        }
        const jr = {
            type: "boolean",
            default: !1,
            transition: !1,
            "property-type": "data-driven",
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom",
                    "feature"
                ]
            }
        };
        function Nr(t) {
            if (null == t) return {
                filter: ()=>!0,
                needGeometry: !1
            };
            qr(t) || (t = Gr(t));
            const e = $r(t, jr);
            if ("error" === e.result) throw new Error(e.value.map((t)=>`${t.key}: ${t.message}`).join(", "));
            return {
                filter: (t, r, n)=>e.value.evaluate(t, r, {}, n),
                needGeometry: Kr(t)
            };
        }
        function Zr(t, e) {
            return t < e ? -1 : t > e ? 1 : 0;
        }
        function Kr(t) {
            if (!Array.isArray(t)) return !1;
            if ("within" === t[0]) return !0;
            for(let e = 1; e < t.length; e++)if (Kr(t[e])) return !0;
            return !1;
        }
        function Gr(t) {
            if (!t) return !0;
            const e = t[0];
            var r;
            return t.length <= 1 ? "any" !== e : "==" === e ? Jr(t[1], t[2], "==") : "!=" === e ? Hr(Jr(t[1], t[2], "==")) : "<" === e || ">" === e || "<=" === e || ">=" === e ? Jr(t[1], t[2], e) : "any" === e ? (r = t.slice(1), [
                "any"
            ].concat(r.map(Gr))) : "all" === e ? [
                "all"
            ].concat(t.slice(1).map(Gr)) : "none" === e ? [
                "all"
            ].concat(t.slice(1).map(Gr).map(Hr)) : "in" === e ? Xr(t[1], t.slice(2)) : "!in" === e ? Hr(Xr(t[1], t.slice(2))) : "has" === e ? Yr(t[1]) : "!has" === e ? Hr(Yr(t[1])) : "within" !== e || t;
        }
        function Jr(t, e, r) {
            switch(t){
                case "$type":
                    return [
                        `filter-type-${r}`,
                        e
                    ];
                case "$id":
                    return [
                        `filter-id-${r}`,
                        e
                    ];
                default:
                    return [
                        `filter-${r}`,
                        t,
                        e
                    ];
            }
        }
        function Xr(t, e) {
            if (0 === e.length) return !1;
            switch(t){
                case "$type":
                    return [
                        "filter-type-in",
                        [
                            "literal",
                            e
                        ]
                    ];
                case "$id":
                    return [
                        "filter-id-in",
                        [
                            "literal",
                            e
                        ]
                    ];
                default:
                    return e.length > 200 && !e.some((t)=>typeof t != typeof e[0]) ? [
                        "filter-in-large",
                        t,
                        [
                            "literal",
                            e.sort(Zr)
                        ]
                    ] : [
                        "filter-in-small",
                        t,
                        [
                            "literal",
                            e
                        ]
                    ];
            }
        }
        function Yr(t) {
            switch(t){
                case "$type":
                    return !0;
                case "$id":
                    return [
                        "filter-has-id"
                    ];
                default:
                    return [
                        "filter-has",
                        t
                    ];
            }
        }
        function Hr(t) {
            return [
                "!",
                t
            ];
        }
        function Wr(t) {
            const e = typeof t;
            if ("number" === e || "boolean" === e || "string" === e || null == t) return JSON.stringify(t);
            if (Array.isArray(t)) {
                let e = "[";
                for (const r of t)e += `${Wr(r)},`;
                return `${e}]`;
            }
            const r = Object.keys(t).sort();
            let n = "{";
            for(let e = 0; e < r.length; e++)n += `${JSON.stringify(r[e])}:${Wr(t[r[e]])},`;
            return `${n}}`;
        }
        function Qr(t) {
            let e = "";
            for (const r of Y)e += `/${Wr(t[r])}`;
            return e;
        }
        function tn(t) {
            const e = t.value;
            return e ? [
                new ot(t.key, e, "constants have been deprecated as of v8")
            ] : [];
        }
        function en(t) {
            return t instanceof Number || t instanceof String || t instanceof Boolean ? t.valueOf() : t;
        }
        function rn(t) {
            if (Array.isArray(t)) return t.map(rn);
            if (t instanceof Object && !(t instanceof Number || t instanceof String || t instanceof Boolean)) {
                const e = {};
                for(const r in t)e[r] = rn(t[r]);
                return e;
            }
            return en(t);
        }
        function nn(t) {
            const e = t.key, r = t.value, n = t.valueSpec || {}, i = t.objectElementValidators || {}, a = t.style, s = t.styleSpec, o = t.validateSpec;
            let l = [];
            const u = kr(r);
            if ("object" !== u) return [
                new ot(e, r, `object expected, ${u} found`)
            ];
            for(const t in r){
                const u = t.split(".")[0], c = n[u] || n["*"];
                let h;
                if (i[u]) h = i[u];
                else if (n[u]) h = o;
                else if (i["*"]) h = i["*"];
                else {
                    if (!n["*"]) {
                        l.push(new ot(e, r[t], `unknown property "${t}"`));
                        continue;
                    }
                    h = o;
                }
                l = l.concat(h({
                    key: (e ? `${e}.` : e) + t,
                    value: r[t],
                    valueSpec: c,
                    style: a,
                    styleSpec: s,
                    object: r,
                    objectKey: t,
                    validateSpec: o
                }, r));
            }
            for(const t in n)i[t] || n[t].required && void 0 === n[t].default && void 0 === r[t] && l.push(new ot(e, r, `missing required property "${t}"`));
            return l;
        }
        function an(t) {
            const e = t.value, r = t.valueSpec, n = t.style, i = t.styleSpec, a = t.key, s = t.arrayElementValidator || t.validateSpec;
            if ("array" !== kr(e)) return [
                new ot(a, e, `array expected, ${kr(e)} found`)
            ];
            if (r.length && e.length !== r.length) return [
                new ot(a, e, `array length ${r.length} expected, length ${e.length} found`)
            ];
            if (r["min-length"] && e.length < r["min-length"]) return [
                new ot(a, e, `array length at least ${r["min-length"]} expected, length ${e.length} found`)
            ];
            let o = {
                type: r.value,
                values: r.values
            };
            i.$version < 7 && (o.function = r.function), "object" === kr(r.value) && (o = r.value);
            let l = [];
            for(let r = 0; r < e.length; r++)l = l.concat(s({
                array: e,
                arrayIndex: r,
                value: e[r],
                valueSpec: o,
                validateSpec: t.validateSpec,
                style: n,
                styleSpec: i,
                key: `${a}[${r}]`
            }));
            return l;
        }
        function sn(t) {
            const e = t.key, r = t.value, n = t.valueSpec;
            let i = kr(r);
            return "number" === i && r != r && (i = "NaN"), "number" !== i ? [
                new ot(e, r, `number expected, ${i} found`)
            ] : "minimum" in n && r < n.minimum ? [
                new ot(e, r, `${r} is less than the minimum value ${n.minimum}`)
            ] : "maximum" in n && r > n.maximum ? [
                new ot(e, r, `${r} is greater than the maximum value ${n.maximum}`)
            ] : [];
        }
        function on(t) {
            const e = t.valueSpec, r = en(t.value.type);
            let n, i, a, s = {};
            const o = "categorical" !== r && void 0 === t.value.property, l = !o, u = "array" === kr(t.value.stops) && "array" === kr(t.value.stops[0]) && "object" === kr(t.value.stops[0][0]), c = nn({
                key: t.key,
                value: t.value,
                valueSpec: t.styleSpec.function,
                validateSpec: t.validateSpec,
                style: t.style,
                styleSpec: t.styleSpec,
                objectElementValidators: {
                    stops: function(t) {
                        if ("identity" === r) return [
                            new ot(t.key, t.value, 'identity function may not have a "stops" property')
                        ];
                        let e = [];
                        const n = t.value;
                        return e = e.concat(an({
                            key: t.key,
                            value: n,
                            valueSpec: t.valueSpec,
                            validateSpec: t.validateSpec,
                            style: t.style,
                            styleSpec: t.styleSpec,
                            arrayElementValidator: h
                        })), "array" === kr(n) && 0 === n.length && e.push(new ot(t.key, n, "array must have at least one stop")), e;
                    },
                    default: function(t) {
                        return t.validateSpec({
                            key: t.key,
                            value: t.value,
                            valueSpec: e,
                            validateSpec: t.validateSpec,
                            style: t.style,
                            styleSpec: t.styleSpec
                        });
                    }
                }
            });
            return "identity" === r && o && c.push(new ot(t.key, t.value, 'missing required property "property"')), "identity" === r || t.value.stops || c.push(new ot(t.key, t.value, 'missing required property "stops"')), "exponential" === r && t.valueSpec.expression && !Sr(t.valueSpec) && c.push(new ot(t.key, t.value, "exponential functions not supported")), t.styleSpec.$version >= 8 && (l && !_r(t.valueSpec) ? c.push(new ot(t.key, t.value, "property functions not supported")) : o && !Ar(t.valueSpec) && c.push(new ot(t.key, t.value, "zoom functions not supported"))), "categorical" !== r && !u || void 0 !== t.value.property || c.push(new ot(t.key, t.value, '"property" property is required')), c;
            function h(t) {
                let r = [];
                const n = t.value, o = t.key;
                if ("array" !== kr(n)) return [
                    new ot(o, n, `array expected, ${kr(n)} found`)
                ];
                if (2 !== n.length) return [
                    new ot(o, n, `array length 2 expected, length ${n.length} found`)
                ];
                if (u) {
                    if ("object" !== kr(n[0])) return [
                        new ot(o, n, `object expected, ${kr(n[0])} found`)
                    ];
                    if (void 0 === n[0].zoom) return [
                        new ot(o, n, "object stop key must have zoom")
                    ];
                    if (void 0 === n[0].value) return [
                        new ot(o, n, "object stop key must have value")
                    ];
                    if (a && a > en(n[0].zoom)) return [
                        new ot(o, n[0].zoom, "stop zoom values must appear in ascending order")
                    ];
                    en(n[0].zoom) !== a && (a = en(n[0].zoom), i = void 0, s = {}), r = r.concat(nn({
                        key: `${o}[0]`,
                        value: n[0],
                        valueSpec: {
                            zoom: {}
                        },
                        validateSpec: t.validateSpec,
                        style: t.style,
                        styleSpec: t.styleSpec,
                        objectElementValidators: {
                            zoom: sn,
                            value: p
                        }
                    }));
                } else r = r.concat(p({
                    key: `${o}[0]`,
                    value: n[0],
                    valueSpec: {},
                    validateSpec: t.validateSpec,
                    style: t.style,
                    styleSpec: t.styleSpec
                }, n));
                return Tr(rn(n[1])) ? r.concat([
                    new ot(`${o}[1]`, n[1], "expressions are not allowed in function stops.")
                ]) : r.concat(t.validateSpec({
                    key: `${o}[1]`,
                    value: n[1],
                    valueSpec: e,
                    validateSpec: t.validateSpec,
                    style: t.style,
                    styleSpec: t.styleSpec
                }));
            }
            function p(t, a) {
                const o = kr(t.value), l = en(t.value), u = null !== t.value ? t.value : a;
                if (n) {
                    if (o !== n) return [
                        new ot(t.key, u, `${o} stop domain type must match previous stop domain type ${n}`)
                    ];
                } else n = o;
                if ("number" !== o && "string" !== o && "boolean" !== o) return [
                    new ot(t.key, u, "stop domain value must be a number, string, or boolean")
                ];
                if ("number" !== o && "categorical" !== r) {
                    let n = `number expected, ${o} found`;
                    return _r(e) && void 0 === r && (n += '\nIf you intended to use a categorical function, specify `"type": "categorical"`.'), [
                        new ot(t.key, u, n)
                    ];
                }
                return "categorical" !== r || "number" !== o || isFinite(l) && Math.floor(l) === l ? "categorical" !== r && "number" === o && void 0 !== i && l < i ? [
                    new ot(t.key, u, "stop domain values must appear in ascending order")
                ] : (i = l, "categorical" === r && l in s ? [
                    new ot(t.key, u, "stop domain values must be unique")
                ] : (s[l] = !0, [])) : [
                    new ot(t.key, u, `integer expected, found ${l}`)
                ];
            }
        }
        function ln(t) {
            const e = ("property" === t.expressionContext ? Or : $r)(rn(t.value), t.valueSpec);
            if ("error" === e.result) return e.value.map((e)=>new ot(`${t.key}${e.key}`, t.value, e.message));
            const r = e.value.expression || e.value._styleExpression.expression;
            if ("property" === t.expressionContext && "text-font" === t.propertyKey && !r.outputDefined()) return [
                new ot(t.key, t.value, `Invalid data expression for "${t.propertyKey}". Output values must be contained as literals within the expression.`)
            ];
            if ("property" === t.expressionContext && "layout" === t.propertyType && !Oe(r)) return [
                new ot(t.key, t.value, '"feature-state" data expressions are not supported with layout properties.')
            ];
            if ("filter" === t.expressionContext && !Oe(r)) return [
                new ot(t.key, t.value, '"feature-state" data expressions are not supported with filters.')
            ];
            if (t.expressionContext && 0 === t.expressionContext.indexOf("cluster")) {
                if (!Ue(r, [
                    "zoom",
                    "feature-state"
                ])) return [
                    new ot(t.key, t.value, '"zoom" and "feature-state" expressions are not supported with cluster properties.')
                ];
                if ("cluster-initial" === t.expressionContext && !De(r)) return [
                    new ot(t.key, t.value, "Feature data expressions are not supported with initial expression part of cluster properties.")
                ];
            }
            return [];
        }
        function un(t) {
            const e = t.key, r = t.value, n = t.valueSpec, i = [];
            return Array.isArray(n.values) ? -1 === n.values.indexOf(en(r)) && i.push(new ot(e, r, `expected one of [${n.values.join(", ")}], ${JSON.stringify(r)} found`)) : -1 === Object.keys(n.values).indexOf(en(r)) && i.push(new ot(e, r, `expected one of [${Object.keys(n.values).join(", ")}], ${JSON.stringify(r)} found`)), i;
        }
        function cn(t) {
            return qr(rn(t.value)) ? ln(lt({}, t, {
                expressionContext: "filter",
                valueSpec: {
                    value: "boolean"
                }
            })) : hn(t);
        }
        function hn(t) {
            const e = t.value, r = t.key;
            if ("array" !== kr(e)) return [
                new ot(r, e, `array expected, ${kr(e)} found`)
            ];
            const n = t.styleSpec;
            let i, a = [];
            if (e.length < 1) return [
                new ot(r, e, "filter array must have at least 1 element")
            ];
            switch(a = a.concat(un({
                key: `${r}[0]`,
                value: e[0],
                valueSpec: n.filter_operator,
                style: t.style,
                styleSpec: t.styleSpec
            })), en(e[0])){
                case "<":
                case "<=":
                case ">":
                case ">=":
                    e.length >= 2 && "$type" === en(e[1]) && a.push(new ot(r, e, `"$type" cannot be use with operator "${e[0]}"`));
                case "==":
                case "!=":
                    3 !== e.length && a.push(new ot(r, e, `filter array for operator "${e[0]}" must have 3 elements`));
                case "in":
                case "!in":
                    e.length >= 2 && (i = kr(e[1]), "string" !== i && a.push(new ot(`${r}[1]`, e[1], `string expected, ${i} found`)));
                    for(let s = 2; s < e.length; s++)i = kr(e[s]), "$type" === en(e[1]) ? a = a.concat(un({
                        key: `${r}[${s}]`,
                        value: e[s],
                        valueSpec: n.geometry_type,
                        style: t.style,
                        styleSpec: t.styleSpec
                    })) : "string" !== i && "number" !== i && "boolean" !== i && a.push(new ot(`${r}[${s}]`, e[s], `string, number, or boolean expected, ${i} found`));
                    break;
                case "any":
                case "all":
                case "none":
                    for(let n = 1; n < e.length; n++)a = a.concat(hn({
                        key: `${r}[${n}]`,
                        value: e[n],
                        style: t.style,
                        styleSpec: t.styleSpec
                    }));
                    break;
                case "has":
                case "!has":
                    i = kr(e[1]), 2 !== e.length ? a.push(new ot(r, e, `filter array for "${e[0]}" operator must have 2 elements`)) : "string" !== i && a.push(new ot(`${r}[1]`, e[1], `string expected, ${i} found`));
                    break;
                case "within":
                    i = kr(e[1]), 2 !== e.length ? a.push(new ot(r, e, `filter array for "${e[0]}" operator must have 2 elements`)) : "object" !== i && a.push(new ot(`${r}[1]`, e[1], `object expected, ${i} found`));
            }
            return a;
        }
        function pn(t, e) {
            const r = t.key, n = t.validateSpec, i = t.style, a = t.styleSpec, s = t.value, o = t.objectKey, l = a[`${e}_${t.layerType}`];
            if (!l) return [];
            const u = o.match(/^(.*)-transition$/);
            if ("paint" === e && u && l[u[1]] && l[u[1]].transition) return n({
                key: r,
                value: s,
                valueSpec: a.transition,
                style: i,
                styleSpec: a
            });
            const c = t.valueSpec || l[o];
            if (!c) return [
                new ot(r, s, `unknown property "${o}"`)
            ];
            let h;
            if ("string" === kr(s) && _r(c) && !c.tokens && (h = /^{([^}]+)}$/.exec(s))) return [
                new ot(r, s, `"${o}" does not support interpolation syntax\nUse an identity property function instead: \`{ "type": "identity", "property": ${JSON.stringify(h[1])} }\`.`)
            ];
            const p = [];
            return "symbol" === t.layerType && ("text-field" === o && i && !i.glyphs && p.push(new ot(r, s, 'use of "text-field" requires a style "glyphs" property')), "text-font" === o && Ir(rn(s)) && "identity" === en(s.type) && p.push(new ot(r, s, '"text-font" does not support identity functions'))), p.concat(n({
                key: t.key,
                value: s,
                valueSpec: c,
                style: i,
                styleSpec: a,
                expressionContext: "property",
                propertyType: e,
                propertyKey: o
            }));
        }
        function fn(t) {
            return pn(t, "paint");
        }
        function dn(t) {
            return pn(t, "layout");
        }
        function yn(t) {
            let e = [];
            const r = t.value, n = t.key, i = t.style, a = t.styleSpec;
            r.type || r.ref || e.push(new ot(n, r, 'either "type" or "ref" is required'));
            let s = en(r.type);
            const o = en(r.ref);
            if (r.id) {
                const a = en(r.id);
                for(let s = 0; s < t.arrayIndex; s++){
                    const t = i.layers[s];
                    en(t.id) === a && e.push(new ot(n, r.id, `duplicate layer id "${r.id}", previously used at line ${t.id.__line__}`));
                }
            }
            if ("ref" in r) {
                let t;
                [
                    "type",
                    "source",
                    "source-layer",
                    "filter",
                    "layout"
                ].forEach((t)=>{
                    t in r && e.push(new ot(n, r[t], `"${t}" is prohibited for ref layers`));
                }), i.layers.forEach((e)=>{
                    en(e.id) === o && (t = e);
                }), t ? t.ref ? e.push(new ot(n, r.ref, "ref cannot reference another ref layer")) : s = en(t.type) : e.push(new ot(n, r.ref, `ref layer "${o}" not found`));
            } else if ("background" !== s) {
                if (r.source) {
                    const t = i.sources && i.sources[r.source], a = t && en(t.type);
                    t ? "vector" === a && "raster" === s ? e.push(new ot(n, r.source, `layer "${r.id}" requires a raster source`)) : "raster-dem" !== a && "hillshade" === s ? e.push(new ot(n, r.source, `layer "${r.id}" requires a raster-dem source`)) : "raster" === a && "raster" !== s ? e.push(new ot(n, r.source, `layer "${r.id}" requires a vector source`)) : "vector" !== a || r["source-layer"] ? "raster-dem" === a && "hillshade" !== s ? e.push(new ot(n, r.source, "raster-dem source can only be used with layer type 'hillshade'.")) : "line" !== s || !r.paint || !r.paint["line-gradient"] || "geojson" === a && t.lineMetrics || e.push(new ot(n, r, `layer "${r.id}" specifies a line-gradient, which requires a GeoJSON source with \`lineMetrics\` enabled.`)) : e.push(new ot(n, r, `layer "${r.id}" must specify a "source-layer"`)) : e.push(new ot(n, r.source, `source "${r.source}" not found`));
                } else e.push(new ot(n, r, 'missing required property "source"'));
            }
            return e = e.concat(nn({
                key: n,
                value: r,
                valueSpec: a.layer,
                style: t.style,
                styleSpec: t.styleSpec,
                validateSpec: t.validateSpec,
                objectElementValidators: {
                    "*": ()=>[],
                    type: ()=>t.validateSpec({
                            key: `${n}.type`,
                            value: r.type,
                            valueSpec: a.layer.type,
                            style: t.style,
                            styleSpec: t.styleSpec,
                            validateSpec: t.validateSpec,
                            object: r,
                            objectKey: "type"
                        }),
                    filter: cn,
                    layout: (t)=>nn({
                            layer: r,
                            key: t.key,
                            value: t.value,
                            style: t.style,
                            styleSpec: t.styleSpec,
                            validateSpec: t.validateSpec,
                            objectElementValidators: {
                                "*": (t)=>dn(lt({
                                        layerType: s
                                    }, t))
                            }
                        }),
                    paint: (t)=>nn({
                            layer: r,
                            key: t.key,
                            value: t.value,
                            style: t.style,
                            styleSpec: t.styleSpec,
                            validateSpec: t.validateSpec,
                            objectElementValidators: {
                                "*": (t)=>fn(lt({
                                        layerType: s
                                    }, t))
                            }
                        })
                }
            })), e;
        }
        function mn(t) {
            const e = t.value, r = t.key, n = kr(e);
            return "string" !== n ? [
                new ot(r, e, `string expected, ${n} found`)
            ] : [];
        }
        const gn = {
            promoteId: function({ key: t, value: e }) {
                if ("string" === kr(e)) return mn({
                    key: t,
                    value: e
                });
                {
                    const r = [];
                    for(const n in e)r.push(...mn({
                        key: `${t}.${n}`,
                        value: e[n]
                    }));
                    return r;
                }
            }
        };
        function xn(t) {
            const e = t.value, r = t.key, n = t.styleSpec, i = t.style, a = t.validateSpec;
            if (!e.type) return [
                new ot(r, e, '"type" is required')
            ];
            const s = en(e.type);
            let o;
            switch(s){
                case "vector":
                case "raster":
                    return o = nn({
                        key: r,
                        value: e,
                        valueSpec: n[`source_${s.replace("-", "_")}`],
                        style: t.style,
                        styleSpec: n,
                        objectElementValidators: gn,
                        validateSpec: a
                    }), o;
                case "raster-dem":
                    return o = function(t) {
                        var e;
                        const r = null !== (e = t.sourceName) && void 0 !== e ? e : "", n = t.value, i = t.styleSpec, a = i.source_raster_dem, s = t.style;
                        let o = [];
                        const l = kr(n);
                        if (void 0 === n) return o;
                        if ("object" !== l) return o.push(new ot("source_raster_dem", n, `object expected, ${l} found`)), o;
                        const u = "custom" === en(n.encoding), c = [
                            "redFactor",
                            "greenFactor",
                            "blueFactor",
                            "baseShift"
                        ], h = t.value.encoding ? `"${t.value.encoding}"` : "Default";
                        for(const e in n)!u && c.includes(e) ? o.push(new ot(e, n[e], `In "${r}": "${e}" is only valid when "encoding" is set to "custom". ${h} encoding found`)) : a[e] ? o = o.concat(t.validateSpec({
                            key: e,
                            value: n[e],
                            valueSpec: a[e],
                            validateSpec: t.validateSpec,
                            style: s,
                            styleSpec: i
                        })) : o.push(new ot(e, n[e], `unknown property "${e}"`));
                        return o;
                    }({
                        sourceName: r,
                        value: e,
                        style: t.style,
                        styleSpec: n,
                        validateSpec: a
                    }), o;
                case "geojson":
                    if (o = nn({
                        key: r,
                        value: e,
                        valueSpec: n.source_geojson,
                        style: i,
                        styleSpec: n,
                        validateSpec: a,
                        objectElementValidators: gn
                    }), e.cluster) for(const t in e.clusterProperties){
                        const [n, i] = e.clusterProperties[t], s = "string" == typeof n ? [
                            n,
                            [
                                "accumulated"
                            ],
                            [
                                "get",
                                t
                            ]
                        ] : n;
                        o.push(...ln({
                            key: `${r}.${t}.map`,
                            value: i,
                            validateSpec: a,
                            expressionContext: "cluster-map"
                        })), o.push(...ln({
                            key: `${r}.${t}.reduce`,
                            value: s,
                            validateSpec: a,
                            expressionContext: "cluster-reduce"
                        }));
                    }
                    return o;
                case "video":
                    return nn({
                        key: r,
                        value: e,
                        valueSpec: n.source_video,
                        style: i,
                        validateSpec: a,
                        styleSpec: n
                    });
                case "image":
                    return nn({
                        key: r,
                        value: e,
                        valueSpec: n.source_image,
                        style: i,
                        validateSpec: a,
                        styleSpec: n
                    });
                case "canvas":
                    return [
                        new ot(r, null, "Please use runtime APIs to add canvas sources, rather than including them in stylesheets.", "source.canvas")
                    ];
                default:
                    return un({
                        key: `${r}.type`,
                        value: e.type,
                        valueSpec: {
                            values: [
                                "vector",
                                "raster",
                                "raster-dem",
                                "geojson",
                                "video",
                                "image"
                            ]
                        },
                        style: i,
                        validateSpec: a,
                        styleSpec: n
                    });
            }
        }
        function vn(t) {
            const e = t.value, r = t.styleSpec, n = r.light, i = t.style;
            let a = [];
            const s = kr(e);
            if (void 0 === e) return a;
            if ("object" !== s) return a = a.concat([
                new ot("light", e, `object expected, ${s} found`)
            ]), a;
            for(const s in e){
                const o = s.match(/^(.*)-transition$/);
                a = a.concat(o && n[o[1]] && n[o[1]].transition ? t.validateSpec({
                    key: s,
                    value: e[s],
                    valueSpec: r.transition,
                    validateSpec: t.validateSpec,
                    style: i,
                    styleSpec: r
                }) : n[s] ? t.validateSpec({
                    key: s,
                    value: e[s],
                    valueSpec: n[s],
                    validateSpec: t.validateSpec,
                    style: i,
                    styleSpec: r
                }) : [
                    new ot(s, e[s], `unknown property "${s}"`)
                ]);
            }
            return a;
        }
        function bn(t) {
            const e = t.value, r = t.styleSpec, n = r.terrain, i = t.style;
            let a = [];
            const s = kr(e);
            if (void 0 === e) return a;
            if ("object" !== s) return a = a.concat([
                new ot("terrain", e, `object expected, ${s} found`)
            ]), a;
            for(const s in e)a = a.concat(n[s] ? t.validateSpec({
                key: s,
                value: e[s],
                valueSpec: n[s],
                validateSpec: t.validateSpec,
                style: i,
                styleSpec: r
            }) : [
                new ot(s, e[s], `unknown property "${s}"`)
            ]);
            return a;
        }
        function wn(t) {
            let e = [];
            const r = t.value, n = t.key;
            if (Array.isArray(r)) {
                const i = [], a = [];
                for(const s in r)r[s].id && i.includes(r[s].id) && e.push(new ot(n, r, `all the sprites' ids must be unique, but ${r[s].id} is duplicated`)), i.push(r[s].id), r[s].url && a.includes(r[s].url) && e.push(new ot(n, r, `all the sprites' URLs must be unique, but ${r[s].url} is duplicated`)), a.push(r[s].url), e = e.concat(nn({
                    key: `${n}[${s}]`,
                    value: r[s],
                    valueSpec: {
                        id: {
                            type: "string",
                            required: !0
                        },
                        url: {
                            type: "string",
                            required: !0
                        }
                    },
                    validateSpec: t.validateSpec
                }));
                return e;
            }
            return mn({
                key: n,
                value: r
            });
        }
        const _n = {
            "*": ()=>[],
            array: an,
            boolean: function(t) {
                const e = t.value, r = t.key, n = kr(e);
                return "boolean" !== n ? [
                    new ot(r, e, `boolean expected, ${n} found`)
                ] : [];
            },
            number: sn,
            color: function(t) {
                const e = t.key, r = t.value, n = kr(r);
                return "string" !== n ? [
                    new ot(e, r, `color expected, ${n} found`)
                ] : Yt.parse(String(r)) ? [] : [
                    new ot(e, r, `color expected, "${r}" found`)
                ];
            },
            constants: tn,
            enum: un,
            filter: cn,
            function: on,
            layer: yn,
            object: nn,
            source: xn,
            light: vn,
            terrain: bn,
            string: mn,
            formatted: function(t) {
                return 0 === mn(t).length ? [] : ln(t);
            },
            resolvedImage: function(t) {
                return 0 === mn(t).length ? [] : ln(t);
            },
            padding: function(t) {
                const e = t.key, r = t.value;
                if ("array" === kr(r)) {
                    if (r.length < 1 || r.length > 4) return [
                        new ot(e, r, `padding requires 1 to 4 values; ${r.length} values found`)
                    ];
                    const n = {
                        type: "number"
                    };
                    let i = [];
                    for(let a = 0; a < r.length; a++)i = i.concat(t.validateSpec({
                        key: `${e}[${a}]`,
                        value: r[a],
                        validateSpec: t.validateSpec,
                        valueSpec: n
                    }));
                    return i;
                }
                return sn({
                    key: e,
                    value: r,
                    valueSpec: {}
                });
            },
            variableAnchorOffsetCollection: function(t) {
                const e = t.key, r = t.value, n = kr(r), i = t.styleSpec;
                if ("array" !== n || r.length < 1 || r.length % 2 != 0) return [
                    new ot(e, r, "variableAnchorOffsetCollection requires a non-empty array of even length")
                ];
                let a = [];
                for(let n = 0; n < r.length; n += 2)a = a.concat(un({
                    key: `${e}[${n}]`,
                    value: r[n],
                    valueSpec: i.layout_symbol["text-anchor"]
                })), a = a.concat(an({
                    key: `${e}[${n + 1}]`,
                    value: r[n + 1],
                    valueSpec: {
                        length: 2,
                        value: "number"
                    },
                    validateSpec: t.validateSpec,
                    style: t.style,
                    styleSpec: i
                }));
                return a;
            },
            sprite: wn
        };
        function An(t) {
            const e = t.value, r = t.valueSpec, n = t.styleSpec;
            return t.validateSpec = An, r.expression && Ir(en(e)) ? on(t) : r.expression && Tr(rn(e)) ? ln(t) : r.type && _n[r.type] ? _n[r.type](t) : nn(lt({}, t, {
                valueSpec: r.type ? n[r.type] : r
            }));
        }
        function Sn(t) {
            const e = t.value, r = t.key, n = mn(t);
            return n.length || (-1 === e.indexOf("{fontstack}") && n.push(new ot(r, e, '"glyphs" url must include a "{fontstack}" token')), -1 === e.indexOf("{range}") && n.push(new ot(r, e, '"glyphs" url must include a "{range}" token'))), n;
        }
        function kn(t, e = X) {
            let r = [];
            return r = r.concat(An({
                key: "",
                value: t,
                valueSpec: e.$root,
                styleSpec: e,
                style: t,
                validateSpec: An,
                objectElementValidators: {
                    glyphs: Sn,
                    "*": ()=>[]
                }
            })), t.constants && (r = r.concat(tn({
                key: "constants",
                value: t.constants,
                style: t,
                styleSpec: e,
                validateSpec: An
            }))), zn(r);
        }
        function In(t) {
            return function(e) {
                return t({
                    ...e,
                    validateSpec: An
                });
            };
        }
        function zn(t) {
            return [].concat(t).sort((t, e)=>t.line - e.line);
        }
        function Mn(t) {
            return function(...e) {
                return zn(t.apply(this, e));
            };
        }
        kn.source = Mn(In(xn)), kn.sprite = Mn(In(wn)), kn.glyphs = Mn(In(Sn)), kn.light = Mn(In(vn)), kn.terrain = Mn(In(bn)), kn.layer = Mn(In(yn)), kn.filter = Mn(In(cn)), kn.paintProperty = Mn(In(fn)), kn.layoutProperty = Mn(In(dn));
        const Cn = kn, Bn = Cn.light, Pn = Cn.paintProperty, Vn = Cn.layoutProperty;
        function En(t, e) {
            let r = !1;
            if (e && e.length) for (const n of e)t.fire(new G(new Error(n.message))), r = !0;
            return r;
        }
        class Fn {
            constructor(t, e, r){
                const n = this.cells = [];
                if (t instanceof ArrayBuffer) {
                    this.arrayBuffer = t;
                    const i = new Int32Array(this.arrayBuffer);
                    t = i[0], this.d = (e = i[1]) + 2 * (r = i[2]);
                    for(let t = 0; t < this.d * this.d; t++){
                        const e = i[3 + t], r = i[3 + t + 1];
                        n.push(e === r ? null : i.subarray(e, r));
                    }
                    const a = i[3 + n.length + 1];
                    this.keys = i.subarray(i[3 + n.length], a), this.bboxes = i.subarray(a), this.insert = this._insertReadonly;
                } else {
                    this.d = e + 2 * r;
                    for(let t = 0; t < this.d * this.d; t++)n.push([]);
                    this.keys = [], this.bboxes = [];
                }
                this.n = e, this.extent = t, this.padding = r, this.scale = e / t, this.uid = 0;
                const i = r / e * t;
                this.min = -i, this.max = t + i;
            }
            insert(t, e, r, n, i) {
                this._forEachCell(e, r, n, i, this._insertCell, this.uid++, void 0, void 0), this.keys.push(t), this.bboxes.push(e), this.bboxes.push(r), this.bboxes.push(n), this.bboxes.push(i);
            }
            _insertReadonly() {
                throw new Error("Cannot insert into a GridIndex created from an ArrayBuffer.");
            }
            _insertCell(t, e, r, n, i, a) {
                this.cells[i].push(a);
            }
            query(t, e, r, n, i) {
                const a = this.min, s = this.max;
                if (t <= a && e <= a && s <= r && s <= n && !i) return Array.prototype.slice.call(this.keys);
                {
                    const a = [];
                    return this._forEachCell(t, e, r, n, this._queryCell, a, {}, i), a;
                }
            }
            _queryCell(t, e, r, n, i, a, s, o) {
                const l = this.cells[i];
                if (null !== l) {
                    const i = this.keys, u = this.bboxes;
                    for(let c = 0; c < l.length; c++){
                        const h = l[c];
                        if (void 0 === s[h]) {
                            const l = 4 * h;
                            (o ? o(u[l + 0], u[l + 1], u[l + 2], u[l + 3]) : t <= u[l + 2] && e <= u[l + 3] && r >= u[l + 0] && n >= u[l + 1]) ? (s[h] = !0, a.push(i[h])) : s[h] = !1;
                        }
                    }
                }
            }
            _forEachCell(t, e, r, n, i, a, s, o) {
                const l = this._convertToCellCoord(t), u = this._convertToCellCoord(e), c = this._convertToCellCoord(r), h = this._convertToCellCoord(n);
                for(let p = l; p <= c; p++)for(let l = u; l <= h; l++){
                    const u = this.d * l + p;
                    if ((!o || o(this._convertFromCellCoord(p), this._convertFromCellCoord(l), this._convertFromCellCoord(p + 1), this._convertFromCellCoord(l + 1))) && i.call(this, t, e, r, n, u, a, s, o)) return;
                }
            }
            _convertFromCellCoord(t) {
                return (t - this.padding) / this.scale;
            }
            _convertToCellCoord(t) {
                return Math.max(0, Math.min(this.d - 1, Math.floor(t * this.scale) + this.padding));
            }
            toArrayBuffer() {
                if (this.arrayBuffer) return this.arrayBuffer;
                const t = this.cells, e = 3 + this.cells.length + 1 + 1;
                let r = 0;
                for(let t = 0; t < this.cells.length; t++)r += this.cells[t].length;
                const n = new Int32Array(e + r + this.keys.length + this.bboxes.length);
                n[0] = this.extent, n[1] = this.n, n[2] = this.padding;
                let i = e;
                for(let e = 0; e < t.length; e++){
                    const r = t[e];
                    n[3 + e] = i, n.set(r, i), i += r.length;
                }
                return n[3 + t.length] = i, n.set(this.keys, i), i += this.keys.length, n[3 + t.length + 1] = i, n.set(this.bboxes, i), i += this.bboxes.length, n.buffer;
            }
            static serialize(t, e) {
                const r = t.toArrayBuffer();
                return e && e.push(r), {
                    buffer: r
                };
            }
            static deserialize(t) {
                return new Fn(t.buffer);
            }
        }
        const Tn = {};
        function $n(t, e, r = {}) {
            if (Tn[t]) throw new Error(`${t} is already registered.`);
            Object.defineProperty(e, "_classRegistryKey", {
                value: t,
                writeable: !1
            }), Tn[t] = {
                klass: e,
                omit: r.omit || [],
                shallow: r.shallow || []
            };
        }
        $n("Object", Object), $n("TransferableGridIndex", Fn), $n("Color", Yt), $n("Error", Error), $n("AJAXError", L), $n("ResolvedImage", ne), $n("StylePropertyFunction", Ur), $n("StyleExpression", Fr, {
            omit: [
                "_evaluator"
            ]
        }), $n("ZoomDependentExpression", Dr), $n("ZoomConstantExpression", Lr), $n("CompoundExpression", $e, {
            omit: [
                "_evaluate"
            ]
        });
        for(const t in yr)yr[t]._classRegistryKey || $n(`Expression_${t}`, yr[t]);
        function Ln(t) {
            return t && "undefined" != typeof ArrayBuffer && (t instanceof ArrayBuffer || t.constructor && "ArrayBuffer" === t.constructor.name);
        }
        function Dn(t, e) {
            if (null == t || "boolean" == typeof t || "number" == typeof t || "string" == typeof t || t instanceof Boolean || t instanceof Number || t instanceof String || t instanceof Date || t instanceof RegExp || t instanceof Blob) return t;
            if (Ln(t)) return e && e.push(t), t;
            if (M(t)) return e && e.push(t), t;
            if (ArrayBuffer.isView(t)) {
                const r = t;
                return e && e.push(r.buffer), r;
            }
            if (t instanceof ImageData) return e && e.push(t.data.buffer), t;
            if (Array.isArray(t)) {
                const r = [];
                for (const n of t)r.push(Dn(n, e));
                return r;
            }
            if ("object" == typeof t) {
                const r = t.constructor, n = r._classRegistryKey;
                if (!n) throw new Error("can't serialize object of unregistered class");
                if (!Tn[n]) throw new Error(`${n} is not registered.`);
                const i = r.serialize ? r.serialize(t, e) : {};
                if (r.serialize) {
                    if (e && i === e[e.length - 1]) throw new Error("statically serialized object won't survive transfer of $name property");
                } else {
                    for(const r in t){
                        if (!t.hasOwnProperty(r)) continue;
                        if (Tn[n].omit.indexOf(r) >= 0) continue;
                        const a = t[r];
                        i[r] = Tn[n].shallow.indexOf(r) >= 0 ? a : Dn(a, e);
                    }
                    t instanceof Error && (i.message = t.message);
                }
                if (i.$name) throw new Error("$name property is reserved for worker serialization logic.");
                return "Object" !== n && (i.$name = n), i;
            }
            throw new Error("can't serialize object of type " + typeof t);
        }
        function On(t) {
            if (null == t || "boolean" == typeof t || "number" == typeof t || "string" == typeof t || t instanceof Boolean || t instanceof Number || t instanceof String || t instanceof Date || t instanceof RegExp || t instanceof Blob || Ln(t) || M(t) || ArrayBuffer.isView(t) || t instanceof ImageData) return t;
            if (Array.isArray(t)) return t.map(On);
            if ("object" == typeof t) {
                const e = t.$name || "Object";
                if (!Tn[e]) throw new Error(`can't deserialize unregistered class ${e}`);
                const { klass: r } = Tn[e];
                if (!r) throw new Error(`can't deserialize unregistered class ${e}`);
                if (r.deserialize) return r.deserialize(t);
                const n = Object.create(r.prototype);
                for (const r of Object.keys(t)){
                    if ("$name" === r) continue;
                    const i = t[r];
                    n[r] = Tn[e].shallow.indexOf(r) >= 0 ? i : On(i);
                }
                return n;
            }
            throw new Error("can't deserialize object of type " + typeof t);
        }
        class Un {
            constructor(){
                this.first = !0;
            }
            update(t, e) {
                const r = Math.floor(t);
                return this.first ? (this.first = !1, this.lastIntegerZoom = r, this.lastIntegerZoomTime = 0, this.lastZoom = t, this.lastFloorZoom = r, !0) : (this.lastFloorZoom > r ? (this.lastIntegerZoom = r + 1, this.lastIntegerZoomTime = e) : this.lastFloorZoom < r && (this.lastIntegerZoom = r, this.lastIntegerZoomTime = e), t !== this.lastZoom && (this.lastZoom = t, this.lastFloorZoom = r, !0));
            }
        }
        const Rn = {
            "Latin-1 Supplement": (t)=>t >= 128 && t <= 255,
            Arabic: (t)=>t >= 1536 && t <= 1791,
            "Arabic Supplement": (t)=>t >= 1872 && t <= 1919,
            "Arabic Extended-A": (t)=>t >= 2208 && t <= 2303,
            "Hangul Jamo": (t)=>t >= 4352 && t <= 4607,
            "Unified Canadian Aboriginal Syllabics": (t)=>t >= 5120 && t <= 5759,
            Khmer: (t)=>t >= 6016 && t <= 6143,
            "Unified Canadian Aboriginal Syllabics Extended": (t)=>t >= 6320 && t <= 6399,
            "General Punctuation": (t)=>t >= 8192 && t <= 8303,
            "Letterlike Symbols": (t)=>t >= 8448 && t <= 8527,
            "Number Forms": (t)=>t >= 8528 && t <= 8591,
            "Miscellaneous Technical": (t)=>t >= 8960 && t <= 9215,
            "Control Pictures": (t)=>t >= 9216 && t <= 9279,
            "Optical Character Recognition": (t)=>t >= 9280 && t <= 9311,
            "Enclosed Alphanumerics": (t)=>t >= 9312 && t <= 9471,
            "Geometric Shapes": (t)=>t >= 9632 && t <= 9727,
            "Miscellaneous Symbols": (t)=>t >= 9728 && t <= 9983,
            "Miscellaneous Symbols and Arrows": (t)=>t >= 11008 && t <= 11263,
            "CJK Radicals Supplement": (t)=>t >= 11904 && t <= 12031,
            "Kangxi Radicals": (t)=>t >= 12032 && t <= 12255,
            "Ideographic Description Characters": (t)=>t >= 12272 && t <= 12287,
            "CJK Symbols and Punctuation": (t)=>t >= 12288 && t <= 12351,
            Hiragana: (t)=>t >= 12352 && t <= 12447,
            Katakana: (t)=>t >= 12448 && t <= 12543,
            Bopomofo: (t)=>t >= 12544 && t <= 12591,
            "Hangul Compatibility Jamo": (t)=>t >= 12592 && t <= 12687,
            Kanbun: (t)=>t >= 12688 && t <= 12703,
            "Bopomofo Extended": (t)=>t >= 12704 && t <= 12735,
            "CJK Strokes": (t)=>t >= 12736 && t <= 12783,
            "Katakana Phonetic Extensions": (t)=>t >= 12784 && t <= 12799,
            "Enclosed CJK Letters and Months": (t)=>t >= 12800 && t <= 13055,
            "CJK Compatibility": (t)=>t >= 13056 && t <= 13311,
            "CJK Unified Ideographs Extension A": (t)=>t >= 13312 && t <= 19903,
            "Yijing Hexagram Symbols": (t)=>t >= 19904 && t <= 19967,
            "CJK Unified Ideographs": (t)=>t >= 19968 && t <= 40959,
            "Yi Syllables": (t)=>t >= 40960 && t <= 42127,
            "Yi Radicals": (t)=>t >= 42128 && t <= 42191,
            "Hangul Jamo Extended-A": (t)=>t >= 43360 && t <= 43391,
            "Hangul Syllables": (t)=>t >= 44032 && t <= 55215,
            "Hangul Jamo Extended-B": (t)=>t >= 55216 && t <= 55295,
            "Private Use Area": (t)=>t >= 57344 && t <= 63743,
            "CJK Compatibility Ideographs": (t)=>t >= 63744 && t <= 64255,
            "Arabic Presentation Forms-A": (t)=>t >= 64336 && t <= 65023,
            "Vertical Forms": (t)=>t >= 65040 && t <= 65055,
            "CJK Compatibility Forms": (t)=>t >= 65072 && t <= 65103,
            "Small Form Variants": (t)=>t >= 65104 && t <= 65135,
            "Arabic Presentation Forms-B": (t)=>t >= 65136 && t <= 65279,
            "Halfwidth and Fullwidth Forms": (t)=>t >= 65280 && t <= 65519
        };
        function qn(t) {
            for (const e of t)if (Zn(e.charCodeAt(0))) return !0;
            return !1;
        }
        function jn(t) {
            for (const e of t)if (!Nn(e.charCodeAt(0))) return !1;
            return !0;
        }
        function Nn(t) {
            return !(Rn.Arabic(t) || Rn["Arabic Supplement"](t) || Rn["Arabic Extended-A"](t) || Rn["Arabic Presentation Forms-A"](t) || Rn["Arabic Presentation Forms-B"](t));
        }
        function Zn(t) {
            return !(746 !== t && 747 !== t && (t < 4352 || !(Rn["Bopomofo Extended"](t) || Rn.Bopomofo(t) || Rn["CJK Compatibility Forms"](t) && !(t >= 65097 && t <= 65103) || Rn["CJK Compatibility Ideographs"](t) || Rn["CJK Compatibility"](t) || Rn["CJK Radicals Supplement"](t) || Rn["CJK Strokes"](t) || !(!Rn["CJK Symbols and Punctuation"](t) || t >= 12296 && t <= 12305 || t >= 12308 && t <= 12319 || 12336 === t) || Rn["CJK Unified Ideographs Extension A"](t) || Rn["CJK Unified Ideographs"](t) || Rn["Enclosed CJK Letters and Months"](t) || Rn["Hangul Compatibility Jamo"](t) || Rn["Hangul Jamo Extended-A"](t) || Rn["Hangul Jamo Extended-B"](t) || Rn["Hangul Jamo"](t) || Rn["Hangul Syllables"](t) || Rn.Hiragana(t) || Rn["Ideographic Description Characters"](t) || Rn.Kanbun(t) || Rn["Kangxi Radicals"](t) || Rn["Katakana Phonetic Extensions"](t) || Rn.Katakana(t) && 12540 !== t || !(!Rn["Halfwidth and Fullwidth Forms"](t) || 65288 === t || 65289 === t || 65293 === t || t >= 65306 && t <= 65310 || 65339 === t || 65341 === t || 65343 === t || t >= 65371 && t <= 65503 || 65507 === t || t >= 65512 && t <= 65519) || !(!Rn["Small Form Variants"](t) || t >= 65112 && t <= 65118 || t >= 65123 && t <= 65126) || Rn["Unified Canadian Aboriginal Syllabics"](t) || Rn["Unified Canadian Aboriginal Syllabics Extended"](t) || Rn["Vertical Forms"](t) || Rn["Yijing Hexagram Symbols"](t) || Rn["Yi Syllables"](t) || Rn["Yi Radicals"](t))));
        }
        function Kn(t) {
            return !(Zn(t) || function(t) {
                return !!(Rn["Latin-1 Supplement"](t) && (167 === t || 169 === t || 174 === t || 177 === t || 188 === t || 189 === t || 190 === t || 215 === t || 247 === t) || Rn["General Punctuation"](t) && (8214 === t || 8224 === t || 8225 === t || 8240 === t || 8241 === t || 8251 === t || 8252 === t || 8258 === t || 8263 === t || 8264 === t || 8265 === t || 8273 === t) || Rn["Letterlike Symbols"](t) || Rn["Number Forms"](t) || Rn["Miscellaneous Technical"](t) && (t >= 8960 && t <= 8967 || t >= 8972 && t <= 8991 || t >= 8996 && t <= 9e3 || 9003 === t || t >= 9085 && t <= 9114 || t >= 9150 && t <= 9165 || 9167 === t || t >= 9169 && t <= 9179 || t >= 9186 && t <= 9215) || Rn["Control Pictures"](t) && 9251 !== t || Rn["Optical Character Recognition"](t) || Rn["Enclosed Alphanumerics"](t) || Rn["Geometric Shapes"](t) || Rn["Miscellaneous Symbols"](t) && !(t >= 9754 && t <= 9759) || Rn["Miscellaneous Symbols and Arrows"](t) && (t >= 11026 && t <= 11055 || t >= 11088 && t <= 11097 || t >= 11192 && t <= 11243) || Rn["CJK Symbols and Punctuation"](t) || Rn.Katakana(t) || Rn["Private Use Area"](t) || Rn["CJK Compatibility Forms"](t) || Rn["Small Form Variants"](t) || Rn["Halfwidth and Fullwidth Forms"](t) || 8734 === t || 8756 === t || 8757 === t || t >= 9984 && t <= 10087 || t >= 10102 && t <= 10131 || 65532 === t || 65533 === t);
            }(t));
        }
        function Gn(t) {
            return t >= 1424 && t <= 2303 || Rn["Arabic Presentation Forms-A"](t) || Rn["Arabic Presentation Forms-B"](t);
        }
        function Jn(t, e) {
            return !(!e && Gn(t) || t >= 2304 && t <= 3583 || t >= 3840 && t <= 4255 || Rn.Khmer(t));
        }
        function Xn(t) {
            for (const e of t)if (Gn(e.charCodeAt(0))) return !0;
            return !1;
        }
        const Yn = "deferred", Hn = "loading", Wn = "loaded";
        let Qn = null, ti = "unavailable", ei = null;
        const ri = function(t) {
            t && "string" == typeof t && t.indexOf("NetworkError") > -1 && (ti = "error"), Qn && Qn(t);
        };
        function ni() {
            ii.fire(new K("pluginStateChange", {
                pluginStatus: ti,
                pluginURL: ei
            }));
        }
        const ii = new J, ai = function() {
            return ti;
        }, si = function() {
            if (ti !== Yn || !ei) throw new Error("rtl-text-plugin cannot be downloaded unless a pluginURL is specified");
            ti = Hn, ni(), ei && q({
                url: ei
            }, (t)=>{
                t ? ri(t) : (ti = Wn, ni());
            });
        }, oi = {
            applyArabicShaping: null,
            processBidirectionalText: null,
            processStyledBidirectionalText: null,
            isLoaded: ()=>ti === Wn || null != oi.applyArabicShaping,
            isLoading: ()=>ti === Hn,
            setState (t) {
                if (!I()) throw new Error("Cannot set the state of the rtl-text-plugin when not in the web-worker context");
                ti = t.pluginStatus, ei = t.pluginURL;
            },
            isParsed () {
                if (!I()) throw new Error("rtl-text-plugin is only parsed on the worker-threads");
                return null != oi.applyArabicShaping && null != oi.processBidirectionalText && null != oi.processStyledBidirectionalText;
            },
            getPluginURL () {
                if (!I()) throw new Error("rtl-text-plugin url can only be queried from the worker threads");
                return ei;
            }
        };
        class li {
            constructor(t, e){
                this.zoom = t, e ? (this.now = e.now, this.fadeDuration = e.fadeDuration, this.zoomHistory = e.zoomHistory, this.transition = e.transition) : (this.now = 0, this.fadeDuration = 0, this.zoomHistory = new Un, this.transition = {});
            }
            isSupportedScript(t) {
                return function(t, e) {
                    for (const r of t)if (!Jn(r.charCodeAt(0), e)) return !1;
                    return !0;
                }(t, oi.isLoaded());
            }
            crossFadingFactor() {
                return 0 === this.fadeDuration ? 1 : Math.min((this.now - this.zoomHistory.lastIntegerZoomTime) / this.fadeDuration, 1);
            }
            getCrossfadeParameters() {
                const t = this.zoom, e = t - Math.floor(t), r = this.crossFadingFactor();
                return t > this.zoomHistory.lastIntegerZoom ? {
                    fromScale: 2,
                    toScale: 1,
                    t: e + (1 - e) * r
                } : {
                    fromScale: .5,
                    toScale: 1,
                    t: 1 - (1 - r) * e
                };
            }
        }
        class ui {
            constructor(t, e){
                this.property = t, this.value = e, this.expression = function(t, e) {
                    if (Ir(t)) return new Ur(t, e);
                    if (Tr(t)) {
                        const r = Or(t, e);
                        if ("error" === r.result) throw new Error(r.value.map((t)=>`${t.key}: ${t.message}`).join(", "));
                        return r.value;
                    }
                    {
                        let r = t;
                        return "color" === e.type && "string" == typeof t ? r = Yt.parse(t) : "padding" !== e.type || "number" != typeof t && !Array.isArray(t) ? "variableAnchorOffsetCollection" === e.type && Array.isArray(t) && (r = re.parse(t)) : r = te.parse(t), {
                            kind: "constant",
                            evaluate: ()=>r
                        };
                    }
                }(void 0 === e ? t.specification.default : e, t.specification);
            }
            isDataDriven() {
                return "source" === this.expression.kind || "composite" === this.expression.kind;
            }
            possiblyEvaluate(t, e, r) {
                return this.property.possiblyEvaluate(this, t, e, r);
            }
        }
        class ci {
            constructor(t){
                this.property = t, this.value = new ui(t, void 0);
            }
            transitioned(t, e) {
                return new pi(this.property, this.value, e, g({}, t.transition, this.transition), t.now);
            }
            untransitioned() {
                return new pi(this.property, this.value, null, {}, 0);
            }
        }
        class hi {
            constructor(t){
                this._properties = t, this._values = Object.create(t.defaultTransitionablePropertyValues);
            }
            getValue(t) {
                return w(this._values[t].value.value);
            }
            setValue(t, e) {
                Object.prototype.hasOwnProperty.call(this._values, t) || (this._values[t] = new ci(this._values[t].property)), this._values[t].value = new ui(this._values[t].property, null === e ? void 0 : w(e));
            }
            getTransition(t) {
                return w(this._values[t].transition);
            }
            setTransition(t, e) {
                Object.prototype.hasOwnProperty.call(this._values, t) || (this._values[t] = new ci(this._values[t].property)), this._values[t].transition = w(e) || void 0;
            }
            serialize() {
                const t = {};
                for (const e of Object.keys(this._values)){
                    const r = this.getValue(e);
                    void 0 !== r && (t[e] = r);
                    const n = this.getTransition(e);
                    void 0 !== n && (t[`${e}-transition`] = n);
                }
                return t;
            }
            transitioned(t, e) {
                const r = new fi(this._properties);
                for (const n of Object.keys(this._values))r._values[n] = this._values[n].transitioned(t, e._values[n]);
                return r;
            }
            untransitioned() {
                const t = new fi(this._properties);
                for (const e of Object.keys(this._values))t._values[e] = this._values[e].untransitioned();
                return t;
            }
        }
        class pi {
            constructor(t, e, r, n, i){
                this.property = t, this.value = e, this.begin = i + n.delay || 0, this.end = this.begin + n.duration || 0, t.specification.transition && (n.delay || n.duration) && (this.prior = r);
            }
            possiblyEvaluate(t, e, r) {
                const n = t.now || 0, i = this.value.possiblyEvaluate(t, e, r), a = this.prior;
                if (a) {
                    if (n > this.end) return this.prior = null, i;
                    if (this.value.isDataDriven()) return this.prior = null, i;
                    if (n < this.begin) return a.possiblyEvaluate(t, e, r);
                    {
                        const s = (n - this.begin) / (this.end - this.begin);
                        return this.property.interpolate(a.possiblyEvaluate(t, e, r), i, function(t) {
                            if (t <= 0) return 0;
                            if (t >= 1) return 1;
                            const e = t * t, r = e * t;
                            return 4 * (t < .5 ? r : 3 * (t - e) + r - .75);
                        }(s));
                    }
                }
                return i;
            }
        }
        class fi {
            constructor(t){
                this._properties = t, this._values = Object.create(t.defaultTransitioningPropertyValues);
            }
            possiblyEvaluate(t, e, r) {
                const n = new mi(this._properties);
                for (const i of Object.keys(this._values))n._values[i] = this._values[i].possiblyEvaluate(t, e, r);
                return n;
            }
            hasTransition() {
                for (const t of Object.keys(this._values))if (this._values[t].prior) return !0;
                return !1;
            }
        }
        class di {
            constructor(t){
                this._properties = t, this._values = Object.create(t.defaultPropertyValues);
            }
            hasValue(t) {
                return void 0 !== this._values[t].value;
            }
            getValue(t) {
                return w(this._values[t].value);
            }
            setValue(t, e) {
                this._values[t] = new ui(this._values[t].property, null === e ? void 0 : w(e));
            }
            serialize() {
                const t = {};
                for (const e of Object.keys(this._values)){
                    const r = this.getValue(e);
                    void 0 !== r && (t[e] = r);
                }
                return t;
            }
            possiblyEvaluate(t, e, r) {
                const n = new mi(this._properties);
                for (const i of Object.keys(this._values))n._values[i] = this._values[i].possiblyEvaluate(t, e, r);
                return n;
            }
        }
        class yi {
            constructor(t, e, r){
                this.property = t, this.value = e, this.parameters = r;
            }
            isConstant() {
                return "constant" === this.value.kind;
            }
            constantOr(t) {
                return "constant" === this.value.kind ? this.value.value : t;
            }
            evaluate(t, e, r, n) {
                return this.property.evaluate(this.value, this.parameters, t, e, r, n);
            }
        }
        class mi {
            constructor(t){
                this._properties = t, this._values = Object.create(t.defaultPossiblyEvaluatedValues);
            }
            get(t) {
                return this._values[t];
            }
        }
        class gi {
            constructor(t){
                this.specification = t;
            }
            possiblyEvaluate(t, e) {
                if (t.isDataDriven()) throw new Error("Value should not be data driven");
                return t.expression.evaluate(e);
            }
            interpolate(t, e, r) {
                const n = Ze[this.specification.type];
                return n ? n(t, e, r) : t;
            }
        }
        class xi {
            constructor(t, e){
                this.specification = t, this.overrides = e;
            }
            possiblyEvaluate(t, e, r, n) {
                return new yi(this, "constant" === t.expression.kind || "camera" === t.expression.kind ? {
                    kind: "constant",
                    value: t.expression.evaluate(e, null, {}, r, n)
                } : t.expression, e);
            }
            interpolate(t, e, r) {
                if ("constant" !== t.value.kind || "constant" !== e.value.kind) return t;
                if (void 0 === t.value.value || void 0 === e.value.value) return new yi(this, {
                    kind: "constant",
                    value: void 0
                }, t.parameters);
                const n = Ze[this.specification.type];
                if (n) {
                    const i = n(t.value.value, e.value.value, r);
                    return new yi(this, {
                        kind: "constant",
                        value: i
                    }, t.parameters);
                }
                return t;
            }
            evaluate(t, e, r, n, i, a) {
                return "constant" === t.kind ? t.value : t.evaluate(e, r, n, i, a);
            }
        }
        class vi extends xi {
            possiblyEvaluate(t, e, r, n) {
                if (void 0 === t.value) return new yi(this, {
                    kind: "constant",
                    value: void 0
                }, e);
                if ("constant" === t.expression.kind) {
                    const i = t.expression.evaluate(e, null, {}, r, n), a = "resolvedImage" === t.property.specification.type && "string" != typeof i ? i.name : i, s = this._calculate(a, a, a, e);
                    return new yi(this, {
                        kind: "constant",
                        value: s
                    }, e);
                }
                if ("camera" === t.expression.kind) {
                    const r = this._calculate(t.expression.evaluate({
                        zoom: e.zoom - 1
                    }), t.expression.evaluate({
                        zoom: e.zoom
                    }), t.expression.evaluate({
                        zoom: e.zoom + 1
                    }), e);
                    return new yi(this, {
                        kind: "constant",
                        value: r
                    }, e);
                }
                return new yi(this, t.expression, e);
            }
            evaluate(t, e, r, n, i, a) {
                if ("source" === t.kind) {
                    const s = t.evaluate(e, r, n, i, a);
                    return this._calculate(s, s, s, e);
                }
                return "composite" === t.kind ? this._calculate(t.evaluate({
                    zoom: Math.floor(e.zoom) - 1
                }, r, n), t.evaluate({
                    zoom: Math.floor(e.zoom)
                }, r, n), t.evaluate({
                    zoom: Math.floor(e.zoom) + 1
                }, r, n), e) : t.value;
            }
            _calculate(t, e, r, n) {
                return n.zoom > n.zoomHistory.lastIntegerZoom ? {
                    from: t,
                    to: e
                } : {
                    from: r,
                    to: e
                };
            }
            interpolate(t) {
                return t;
            }
        }
        class bi {
            constructor(t){
                this.specification = t;
            }
            possiblyEvaluate(t, e, r, n) {
                if (void 0 !== t.value) {
                    if ("constant" === t.expression.kind) {
                        const i = t.expression.evaluate(e, null, {}, r, n);
                        return this._calculate(i, i, i, e);
                    }
                    return this._calculate(t.expression.evaluate(new li(Math.floor(e.zoom - 1), e)), t.expression.evaluate(new li(Math.floor(e.zoom), e)), t.expression.evaluate(new li(Math.floor(e.zoom + 1), e)), e);
                }
            }
            _calculate(t, e, r, n) {
                return n.zoom > n.zoomHistory.lastIntegerZoom ? {
                    from: t,
                    to: e
                } : {
                    from: r,
                    to: e
                };
            }
            interpolate(t) {
                return t;
            }
        }
        class wi {
            constructor(t){
                this.specification = t;
            }
            possiblyEvaluate(t, e, r, n) {
                return !!t.expression.evaluate(e, null, {}, r, n);
            }
            interpolate() {
                return !1;
            }
        }
        class _i {
            constructor(t){
                this.properties = t, this.defaultPropertyValues = {}, this.defaultTransitionablePropertyValues = {}, this.defaultTransitioningPropertyValues = {}, this.defaultPossiblyEvaluatedValues = {}, this.overridableProperties = [];
                for(const e in t){
                    const r = t[e];
                    r.specification.overridable && this.overridableProperties.push(e);
                    const n = this.defaultPropertyValues[e] = new ui(r, void 0), i = this.defaultTransitionablePropertyValues[e] = new ci(r);
                    this.defaultTransitioningPropertyValues[e] = i.untransitioned(), this.defaultPossiblyEvaluatedValues[e] = n.possiblyEvaluate({});
                }
            }
        }
        $n("DataDrivenProperty", xi), $n("DataConstantProperty", gi), $n("CrossFadedDataDrivenProperty", vi), $n("CrossFadedProperty", bi), $n("ColorRampProperty", wi);
        const Ai = "-transition";
        class Si extends J {
            constructor(t, e){
                if (super(), this.id = t.id, this.type = t.type, this._featureFilter = {
                    filter: ()=>!0,
                    needGeometry: !1
                }, "custom" !== t.type && (this.metadata = t.metadata, this.minzoom = t.minzoom, this.maxzoom = t.maxzoom, "background" !== t.type && (this.source = t.source, this.sourceLayer = t["source-layer"], this.filter = t.filter), e.layout && (this._unevaluatedLayout = new di(e.layout)), e.paint)) {
                    this._transitionablePaint = new hi(e.paint);
                    for(const e in t.paint)this.setPaintProperty(e, t.paint[e], {
                        validate: !1
                    });
                    for(const e in t.layout)this.setLayoutProperty(e, t.layout[e], {
                        validate: !1
                    });
                    this._transitioningPaint = this._transitionablePaint.untransitioned(), this.paint = new mi(e.paint);
                }
            }
            getCrossfadeParameters() {
                return this._crossfadeParameters;
            }
            getLayoutProperty(t) {
                return "visibility" === t ? this.visibility : this._unevaluatedLayout.getValue(t);
            }
            setLayoutProperty(t, e, r = {}) {
                null != e && this._validate(Vn, `layers.${this.id}.layout.${t}`, t, e, r) || ("visibility" !== t ? this._unevaluatedLayout.setValue(t, e) : this.visibility = e);
            }
            getPaintProperty(t) {
                return t.endsWith(Ai) ? this._transitionablePaint.getTransition(t.slice(0, -11)) : this._transitionablePaint.getValue(t);
            }
            setPaintProperty(t, e, r = {}) {
                if (null != e && this._validate(Pn, `layers.${this.id}.paint.${t}`, t, e, r)) return !1;
                if (t.endsWith(Ai)) return this._transitionablePaint.setTransition(t.slice(0, -11), e || void 0), !1;
                {
                    const r = this._transitionablePaint._values[t], n = "cross-faded-data-driven" === r.property.specification["property-type"], i = r.value.isDataDriven(), a = r.value;
                    this._transitionablePaint.setValue(t, e), this._handleSpecialPaintPropertyUpdate(t);
                    const s = this._transitionablePaint._values[t].value;
                    return s.isDataDriven() || i || n || this._handleOverridablePaintPropertyUpdate(t, a, s);
                }
            }
            _handleSpecialPaintPropertyUpdate(t) {}
            _handleOverridablePaintPropertyUpdate(t, e, r) {
                return !1;
            }
            isHidden(t) {
                return !!(this.minzoom && t < this.minzoom) || !!(this.maxzoom && t >= this.maxzoom) || "none" === this.visibility;
            }
            updateTransitions(t) {
                this._transitioningPaint = this._transitionablePaint.transitioned(t, this._transitioningPaint);
            }
            hasTransition() {
                return this._transitioningPaint.hasTransition();
            }
            recalculate(t, e) {
                t.getCrossfadeParameters && (this._crossfadeParameters = t.getCrossfadeParameters()), this._unevaluatedLayout && (this.layout = this._unevaluatedLayout.possiblyEvaluate(t, void 0, e)), this.paint = this._transitioningPaint.possiblyEvaluate(t, void 0, e);
            }
            serialize() {
                const t = {
                    id: this.id,
                    type: this.type,
                    source: this.source,
                    "source-layer": this.sourceLayer,
                    metadata: this.metadata,
                    minzoom: this.minzoom,
                    maxzoom: this.maxzoom,
                    filter: this.filter,
                    layout: this._unevaluatedLayout && this._unevaluatedLayout.serialize(),
                    paint: this._transitionablePaint && this._transitionablePaint.serialize()
                };
                return this.visibility && (t.layout = t.layout || {}, t.layout.visibility = this.visibility), b(t, (t, e)=>!(void 0 === t || "layout" === e && !Object.keys(t).length || "paint" === e && !Object.keys(t).length));
            }
            _validate(t, e, r, n, i = {}) {
                return (!i || !1 !== i.validate) && En(this, t.call(Cn, {
                    key: e,
                    layerType: this.type,
                    objectKey: r,
                    value: n,
                    styleSpec: X,
                    style: {
                        glyphs: !0,
                        sprite: !0
                    }
                }));
            }
            is3D() {
                return !1;
            }
            isTileClipped() {
                return !1;
            }
            hasOffscreenPass() {
                return !1;
            }
            resize() {}
            isStateDependent() {
                for(const t in this.paint._values){
                    const e = this.paint.get(t);
                    if (e instanceof yi && _r(e.property.specification) && ("source" === e.value.kind || "composite" === e.value.kind) && e.value.isStateDependent) return !0;
                }
                return !1;
            }
        }
        const ki = {
            Int8: Int8Array,
            Uint8: Uint8Array,
            Int16: Int16Array,
            Uint16: Uint16Array,
            Int32: Int32Array,
            Uint32: Uint32Array,
            Float32: Float32Array
        };
        class Ii {
            constructor(t, e){
                this._structArray = t, this._pos1 = e * this.size, this._pos2 = this._pos1 / 2, this._pos4 = this._pos1 / 4, this._pos8 = this._pos1 / 8;
            }
        }
        class zi {
            constructor(){
                this.isTransferred = !1, this.capacity = -1, this.resize(0);
            }
            static serialize(t, e) {
                return t._trim(), e && (t.isTransferred = !0, e.push(t.arrayBuffer)), {
                    length: t.length,
                    arrayBuffer: t.arrayBuffer
                };
            }
            static deserialize(t) {
                const e = Object.create(this.prototype);
                return e.arrayBuffer = t.arrayBuffer, e.length = t.length, e.capacity = t.arrayBuffer.byteLength / e.bytesPerElement, e._refreshViews(), e;
            }
            _trim() {
                this.length !== this.capacity && (this.capacity = this.length, this.arrayBuffer = this.arrayBuffer.slice(0, this.length * this.bytesPerElement), this._refreshViews());
            }
            clear() {
                this.length = 0;
            }
            resize(t) {
                this.reserve(t), this.length = t;
            }
            reserve(t) {
                if (t > this.capacity) {
                    this.capacity = Math.max(t, Math.floor(5 * this.capacity), 128), this.arrayBuffer = new ArrayBuffer(this.capacity * this.bytesPerElement);
                    const e = this.uint8;
                    this._refreshViews(), e && this.uint8.set(e);
                }
            }
            _refreshViews() {
                throw new Error("_refreshViews() must be implemented by each concrete StructArray layout");
            }
        }
        function Mi(t, e = 1) {
            let r = 0, n = 0;
            return {
                members: t.map((t)=>{
                    const i = ki[t.type].BYTES_PER_ELEMENT, a = r = Ci(r, Math.max(e, i)), s = t.components || 1;
                    return n = Math.max(n, i), r += i * s, {
                        name: t.name,
                        type: t.type,
                        components: s,
                        offset: a
                    };
                }),
                size: Ci(r, Math.max(n, e)),
                alignment: e
            };
        }
        function Ci(t, e) {
            return Math.ceil(t / e) * e;
        }
        class Bi extends zi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t, e) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, t, e);
            }
            emplace(t, e, r) {
                const n = 2 * t;
                return this.int16[n + 0] = e, this.int16[n + 1] = r, t;
            }
        }
        Bi.prototype.bytesPerElement = 4, $n("StructArrayLayout2i4", Bi);
        class Pi extends zi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, t, e, r);
            }
            emplace(t, e, r, n) {
                const i = 3 * t;
                return this.int16[i + 0] = e, this.int16[i + 1] = r, this.int16[i + 2] = n, t;
            }
        }
        Pi.prototype.bytesPerElement = 6, $n("StructArrayLayout3i6", Pi);
        class Vi extends zi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r, n) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, t, e, r, n);
            }
            emplace(t, e, r, n, i) {
                const a = 4 * t;
                return this.int16[a + 0] = e, this.int16[a + 1] = r, this.int16[a + 2] = n, this.int16[a + 3] = i, t;
            }
        }
        Vi.prototype.bytesPerElement = 8, $n("StructArrayLayout4i8", Vi);
        class Ei extends zi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r, n, i, a) {
                const s = this.length;
                return this.resize(s + 1), this.emplace(s, t, e, r, n, i, a);
            }
            emplace(t, e, r, n, i, a, s) {
                const o = 6 * t;
                return this.int16[o + 0] = e, this.int16[o + 1] = r, this.int16[o + 2] = n, this.int16[o + 3] = i, this.int16[o + 4] = a, this.int16[o + 5] = s, t;
            }
        }
        Ei.prototype.bytesPerElement = 12, $n("StructArrayLayout2i4i12", Ei);
        class Fi extends zi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r, n, i, a) {
                const s = this.length;
                return this.resize(s + 1), this.emplace(s, t, e, r, n, i, a);
            }
            emplace(t, e, r, n, i, a, s) {
                const o = 4 * t, l = 8 * t;
                return this.int16[o + 0] = e, this.int16[o + 1] = r, this.uint8[l + 4] = n, this.uint8[l + 5] = i, this.uint8[l + 6] = a, this.uint8[l + 7] = s, t;
            }
        }
        Fi.prototype.bytesPerElement = 8, $n("StructArrayLayout2i4ub8", Fi);
        class Ti extends zi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t, e) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, t, e);
            }
            emplace(t, e, r) {
                const n = 2 * t;
                return this.float32[n + 0] = e, this.float32[n + 1] = r, t;
            }
        }
        Ti.prototype.bytesPerElement = 8, $n("StructArrayLayout2f8", Ti);
        class $i extends zi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r, n, i, a, s, o, l, u) {
                const c = this.length;
                return this.resize(c + 1), this.emplace(c, t, e, r, n, i, a, s, o, l, u);
            }
            emplace(t, e, r, n, i, a, s, o, l, u, c) {
                const h = 10 * t;
                return this.uint16[h + 0] = e, this.uint16[h + 1] = r, this.uint16[h + 2] = n, this.uint16[h + 3] = i, this.uint16[h + 4] = a, this.uint16[h + 5] = s, this.uint16[h + 6] = o, this.uint16[h + 7] = l, this.uint16[h + 8] = u, this.uint16[h + 9] = c, t;
            }
        }
        $i.prototype.bytesPerElement = 20, $n("StructArrayLayout10ui20", $i);
        class Li extends zi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r, n, i, a, s, o, l, u, c, h) {
                const p = this.length;
                return this.resize(p + 1), this.emplace(p, t, e, r, n, i, a, s, o, l, u, c, h);
            }
            emplace(t, e, r, n, i, a, s, o, l, u, c, h, p) {
                const f = 12 * t;
                return this.int16[f + 0] = e, this.int16[f + 1] = r, this.int16[f + 2] = n, this.int16[f + 3] = i, this.uint16[f + 4] = a, this.uint16[f + 5] = s, this.uint16[f + 6] = o, this.uint16[f + 7] = l, this.int16[f + 8] = u, this.int16[f + 9] = c, this.int16[f + 10] = h, this.int16[f + 11] = p, t;
            }
        }
        Li.prototype.bytesPerElement = 24, $n("StructArrayLayout4i4ui4i24", Li);
        class Di extends zi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, t, e, r);
            }
            emplace(t, e, r, n) {
                const i = 3 * t;
                return this.float32[i + 0] = e, this.float32[i + 1] = r, this.float32[i + 2] = n, t;
            }
        }
        Di.prototype.bytesPerElement = 12, $n("StructArrayLayout3f12", Di);
        class Oi extends zi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
            }
            emplaceBack(t) {
                const e = this.length;
                return this.resize(e + 1), this.emplace(e, t);
            }
            emplace(t, e) {
                return this.uint32[1 * t + 0] = e, t;
            }
        }
        Oi.prototype.bytesPerElement = 4, $n("StructArrayLayout1ul4", Oi);
        class Ui extends zi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r, n, i, a, s, o, l) {
                const u = this.length;
                return this.resize(u + 1), this.emplace(u, t, e, r, n, i, a, s, o, l);
            }
            emplace(t, e, r, n, i, a, s, o, l, u) {
                const c = 10 * t, h = 5 * t;
                return this.int16[c + 0] = e, this.int16[c + 1] = r, this.int16[c + 2] = n, this.int16[c + 3] = i, this.int16[c + 4] = a, this.int16[c + 5] = s, this.uint32[h + 3] = o, this.uint16[c + 8] = l, this.uint16[c + 9] = u, t;
            }
        }
        Ui.prototype.bytesPerElement = 20, $n("StructArrayLayout6i1ul2ui20", Ui);
        class Ri extends zi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r, n, i, a) {
                const s = this.length;
                return this.resize(s + 1), this.emplace(s, t, e, r, n, i, a);
            }
            emplace(t, e, r, n, i, a, s) {
                const o = 6 * t;
                return this.int16[o + 0] = e, this.int16[o + 1] = r, this.int16[o + 2] = n, this.int16[o + 3] = i, this.int16[o + 4] = a, this.int16[o + 5] = s, t;
            }
        }
        Ri.prototype.bytesPerElement = 12, $n("StructArrayLayout2i2i2i12", Ri);
        class qi extends zi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r, n, i) {
                const a = this.length;
                return this.resize(a + 1), this.emplace(a, t, e, r, n, i);
            }
            emplace(t, e, r, n, i, a) {
                const s = 4 * t, o = 8 * t;
                return this.float32[s + 0] = e, this.float32[s + 1] = r, this.float32[s + 2] = n, this.int16[o + 6] = i, this.int16[o + 7] = a, t;
            }
        }
        qi.prototype.bytesPerElement = 16, $n("StructArrayLayout2f1f2i16", qi);
        class ji extends zi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r, n) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, t, e, r, n);
            }
            emplace(t, e, r, n, i) {
                const a = 12 * t, s = 3 * t;
                return this.uint8[a + 0] = e, this.uint8[a + 1] = r, this.float32[s + 1] = n, this.float32[s + 2] = i, t;
            }
        }
        ji.prototype.bytesPerElement = 12, $n("StructArrayLayout2ub2f12", ji);
        class Ni extends zi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, t, e, r);
            }
            emplace(t, e, r, n) {
                const i = 3 * t;
                return this.uint16[i + 0] = e, this.uint16[i + 1] = r, this.uint16[i + 2] = n, t;
            }
        }
        Ni.prototype.bytesPerElement = 6, $n("StructArrayLayout3ui6", Ni);
        class Zi extends zi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r, n, i, a, s, o, l, u, c, h, p, f, d, y, m) {
                const g = this.length;
                return this.resize(g + 1), this.emplace(g, t, e, r, n, i, a, s, o, l, u, c, h, p, f, d, y, m);
            }
            emplace(t, e, r, n, i, a, s, o, l, u, c, h, p, f, d, y, m, g) {
                const x = 24 * t, v = 12 * t, b = 48 * t;
                return this.int16[x + 0] = e, this.int16[x + 1] = r, this.uint16[x + 2] = n, this.uint16[x + 3] = i, this.uint32[v + 2] = a, this.uint32[v + 3] = s, this.uint32[v + 4] = o, this.uint16[x + 10] = l, this.uint16[x + 11] = u, this.uint16[x + 12] = c, this.float32[v + 7] = h, this.float32[v + 8] = p, this.uint8[b + 36] = f, this.uint8[b + 37] = d, this.uint8[b + 38] = y, this.uint32[v + 10] = m, this.int16[x + 22] = g, t;
            }
        }
        Zi.prototype.bytesPerElement = 48, $n("StructArrayLayout2i2ui3ul3ui2f3ub1ul1i48", Zi);
        class Ki extends zi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r, n, i, a, s, o, l, u, c, h, p, f, d, y, m, g, x, v, b, w, _, A, S, k, I, z) {
                const M = this.length;
                return this.resize(M + 1), this.emplace(M, t, e, r, n, i, a, s, o, l, u, c, h, p, f, d, y, m, g, x, v, b, w, _, A, S, k, I, z);
            }
            emplace(t, e, r, n, i, a, s, o, l, u, c, h, p, f, d, y, m, g, x, v, b, w, _, A, S, k, I, z, M) {
                const C = 32 * t, B = 16 * t;
                return this.int16[C + 0] = e, this.int16[C + 1] = r, this.int16[C + 2] = n, this.int16[C + 3] = i, this.int16[C + 4] = a, this.int16[C + 5] = s, this.int16[C + 6] = o, this.int16[C + 7] = l, this.uint16[C + 8] = u, this.uint16[C + 9] = c, this.uint16[C + 10] = h, this.uint16[C + 11] = p, this.uint16[C + 12] = f, this.uint16[C + 13] = d, this.uint16[C + 14] = y, this.uint16[C + 15] = m, this.uint16[C + 16] = g, this.uint16[C + 17] = x, this.uint16[C + 18] = v, this.uint16[C + 19] = b, this.uint16[C + 20] = w, this.uint16[C + 21] = _, this.uint16[C + 22] = A, this.uint32[B + 12] = S, this.float32[B + 13] = k, this.float32[B + 14] = I, this.uint16[C + 30] = z, this.uint16[C + 31] = M, t;
            }
        }
        Ki.prototype.bytesPerElement = 64, $n("StructArrayLayout8i15ui1ul2f2ui64", Ki);
        class Gi extends zi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t) {
                const e = this.length;
                return this.resize(e + 1), this.emplace(e, t);
            }
            emplace(t, e) {
                return this.float32[1 * t + 0] = e, t;
            }
        }
        Gi.prototype.bytesPerElement = 4, $n("StructArrayLayout1f4", Gi);
        class Ji extends zi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, t, e, r);
            }
            emplace(t, e, r, n) {
                const i = 3 * t;
                return this.uint16[6 * t + 0] = e, this.float32[i + 1] = r, this.float32[i + 2] = n, t;
            }
        }
        Ji.prototype.bytesPerElement = 12, $n("StructArrayLayout1ui2f12", Ji);
        class Xi extends zi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, t, e, r);
            }
            emplace(t, e, r, n) {
                const i = 4 * t;
                return this.uint32[2 * t + 0] = e, this.uint16[i + 2] = r, this.uint16[i + 3] = n, t;
            }
        }
        Xi.prototype.bytesPerElement = 8, $n("StructArrayLayout1ul2ui8", Xi);
        class Yi extends zi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t, e) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, t, e);
            }
            emplace(t, e, r) {
                const n = 2 * t;
                return this.uint16[n + 0] = e, this.uint16[n + 1] = r, t;
            }
        }
        Yi.prototype.bytesPerElement = 4, $n("StructArrayLayout2ui4", Yi);
        class Hi extends zi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t) {
                const e = this.length;
                return this.resize(e + 1), this.emplace(e, t);
            }
            emplace(t, e) {
                return this.uint16[1 * t + 0] = e, t;
            }
        }
        Hi.prototype.bytesPerElement = 2, $n("StructArrayLayout1ui2", Hi);
        class Wi extends zi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r, n) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, t, e, r, n);
            }
            emplace(t, e, r, n, i) {
                const a = 4 * t;
                return this.float32[a + 0] = e, this.float32[a + 1] = r, this.float32[a + 2] = n, this.float32[a + 3] = i, t;
            }
        }
        Wi.prototype.bytesPerElement = 16, $n("StructArrayLayout4f16", Wi);
        class Qi extends Ii {
            get anchorPointX() {
                return this._structArray.int16[this._pos2 + 0];
            }
            get anchorPointY() {
                return this._structArray.int16[this._pos2 + 1];
            }
            get x1() {
                return this._structArray.int16[this._pos2 + 2];
            }
            get y1() {
                return this._structArray.int16[this._pos2 + 3];
            }
            get x2() {
                return this._structArray.int16[this._pos2 + 4];
            }
            get y2() {
                return this._structArray.int16[this._pos2 + 5];
            }
            get featureIndex() {
                return this._structArray.uint32[this._pos4 + 3];
            }
            get sourceLayerIndex() {
                return this._structArray.uint16[this._pos2 + 8];
            }
            get bucketIndex() {
                return this._structArray.uint16[this._pos2 + 9];
            }
            get anchorPoint() {
                return new a(this.anchorPointX, this.anchorPointY);
            }
        }
        Qi.prototype.size = 20;
        class ta extends Ui {
            get(t) {
                return new Qi(this, t);
            }
        }
        $n("CollisionBoxArray", ta);
        class ea extends Ii {
            get anchorX() {
                return this._structArray.int16[this._pos2 + 0];
            }
            get anchorY() {
                return this._structArray.int16[this._pos2 + 1];
            }
            get glyphStartIndex() {
                return this._structArray.uint16[this._pos2 + 2];
            }
            get numGlyphs() {
                return this._structArray.uint16[this._pos2 + 3];
            }
            get vertexStartIndex() {
                return this._structArray.uint32[this._pos4 + 2];
            }
            get lineStartIndex() {
                return this._structArray.uint32[this._pos4 + 3];
            }
            get lineLength() {
                return this._structArray.uint32[this._pos4 + 4];
            }
            get segment() {
                return this._structArray.uint16[this._pos2 + 10];
            }
            get lowerSize() {
                return this._structArray.uint16[this._pos2 + 11];
            }
            get upperSize() {
                return this._structArray.uint16[this._pos2 + 12];
            }
            get lineOffsetX() {
                return this._structArray.float32[this._pos4 + 7];
            }
            get lineOffsetY() {
                return this._structArray.float32[this._pos4 + 8];
            }
            get writingMode() {
                return this._structArray.uint8[this._pos1 + 36];
            }
            get placedOrientation() {
                return this._structArray.uint8[this._pos1 + 37];
            }
            set placedOrientation(t) {
                this._structArray.uint8[this._pos1 + 37] = t;
            }
            get hidden() {
                return this._structArray.uint8[this._pos1 + 38];
            }
            set hidden(t) {
                this._structArray.uint8[this._pos1 + 38] = t;
            }
            get crossTileID() {
                return this._structArray.uint32[this._pos4 + 10];
            }
            set crossTileID(t) {
                this._structArray.uint32[this._pos4 + 10] = t;
            }
            get associatedIconIndex() {
                return this._structArray.int16[this._pos2 + 22];
            }
        }
        ea.prototype.size = 48;
        class ra extends Zi {
            get(t) {
                return new ea(this, t);
            }
        }
        $n("PlacedSymbolArray", ra);
        class na extends Ii {
            get anchorX() {
                return this._structArray.int16[this._pos2 + 0];
            }
            get anchorY() {
                return this._structArray.int16[this._pos2 + 1];
            }
            get rightJustifiedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 2];
            }
            get centerJustifiedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 3];
            }
            get leftJustifiedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 4];
            }
            get verticalPlacedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 5];
            }
            get placedIconSymbolIndex() {
                return this._structArray.int16[this._pos2 + 6];
            }
            get verticalPlacedIconSymbolIndex() {
                return this._structArray.int16[this._pos2 + 7];
            }
            get key() {
                return this._structArray.uint16[this._pos2 + 8];
            }
            get textBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 9];
            }
            get textBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 10];
            }
            get verticalTextBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 11];
            }
            get verticalTextBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 12];
            }
            get iconBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 13];
            }
            get iconBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 14];
            }
            get verticalIconBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 15];
            }
            get verticalIconBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 16];
            }
            get featureIndex() {
                return this._structArray.uint16[this._pos2 + 17];
            }
            get numHorizontalGlyphVertices() {
                return this._structArray.uint16[this._pos2 + 18];
            }
            get numVerticalGlyphVertices() {
                return this._structArray.uint16[this._pos2 + 19];
            }
            get numIconVertices() {
                return this._structArray.uint16[this._pos2 + 20];
            }
            get numVerticalIconVertices() {
                return this._structArray.uint16[this._pos2 + 21];
            }
            get useRuntimeCollisionCircles() {
                return this._structArray.uint16[this._pos2 + 22];
            }
            get crossTileID() {
                return this._structArray.uint32[this._pos4 + 12];
            }
            set crossTileID(t) {
                this._structArray.uint32[this._pos4 + 12] = t;
            }
            get textBoxScale() {
                return this._structArray.float32[this._pos4 + 13];
            }
            get collisionCircleDiameter() {
                return this._structArray.float32[this._pos4 + 14];
            }
            get textAnchorOffsetStartIndex() {
                return this._structArray.uint16[this._pos2 + 30];
            }
            get textAnchorOffsetEndIndex() {
                return this._structArray.uint16[this._pos2 + 31];
            }
        }
        na.prototype.size = 64;
        class ia extends Ki {
            get(t) {
                return new na(this, t);
            }
        }
        $n("SymbolInstanceArray", ia);
        class aa extends Gi {
            getoffsetX(t) {
                return this.float32[1 * t + 0];
            }
        }
        $n("GlyphOffsetArray", aa);
        class sa extends Pi {
            getx(t) {
                return this.int16[3 * t + 0];
            }
            gety(t) {
                return this.int16[3 * t + 1];
            }
            gettileUnitDistanceFromAnchor(t) {
                return this.int16[3 * t + 2];
            }
        }
        $n("SymbolLineVertexArray", sa);
        class oa extends Ii {
            get textAnchor() {
                return this._structArray.uint16[this._pos2 + 0];
            }
            get textOffset0() {
                return this._structArray.float32[this._pos4 + 1];
            }
            get textOffset1() {
                return this._structArray.float32[this._pos4 + 2];
            }
        }
        oa.prototype.size = 12;
        class la extends Ji {
            get(t) {
                return new oa(this, t);
            }
        }
        $n("TextAnchorOffsetArray", la);
        class ua extends Ii {
            get featureIndex() {
                return this._structArray.uint32[this._pos4 + 0];
            }
            get sourceLayerIndex() {
                return this._structArray.uint16[this._pos2 + 2];
            }
            get bucketIndex() {
                return this._structArray.uint16[this._pos2 + 3];
            }
        }
        ua.prototype.size = 8;
        class ca extends Xi {
            get(t) {
                return new ua(this, t);
            }
        }
        $n("FeatureIndexArray", ca);
        class ha extends Bi {
        }
        class pa extends Bi {
        }
        class fa extends Bi {
        }
        class da extends Ei {
        }
        class ya extends Fi {
        }
        class ma extends Ti {
        }
        class ga extends $i {
        }
        class xa extends Li {
        }
        class va extends Di {
        }
        class ba extends Oi {
        }
        class wa extends Ri {
        }
        class _a extends ji {
        }
        class Aa extends Ni {
        }
        class Sa extends Yi {
        }
        const ka = Mi([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            }
        ], 4), { members: Ia } = ka;
        class za {
            constructor(t = []){
                this.segments = t;
            }
            prepareSegment(t, e, r, n) {
                let i = this.segments[this.segments.length - 1];
                return t > za.MAX_VERTEX_ARRAY_LENGTH && A(`Max vertices per segment is ${za.MAX_VERTEX_ARRAY_LENGTH}: bucket requested ${t}`), (!i || i.vertexLength + t > za.MAX_VERTEX_ARRAY_LENGTH || i.sortKey !== n) && (i = {
                    vertexOffset: e.length,
                    primitiveOffset: r.length,
                    vertexLength: 0,
                    primitiveLength: 0
                }, void 0 !== n && (i.sortKey = n), this.segments.push(i)), i;
            }
            get() {
                return this.segments;
            }
            destroy() {
                for (const t of this.segments)for(const e in t.vaos)t.vaos[e].destroy();
            }
            static simpleSegment(t, e, r, n) {
                return new za([
                    {
                        vertexOffset: t,
                        primitiveOffset: e,
                        vertexLength: r,
                        primitiveLength: n,
                        vaos: {},
                        sortKey: 0
                    }
                ]);
            }
        }
        function Ma(t, e) {
            return 256 * (t = y(Math.floor(t), 0, 255)) + y(Math.floor(e), 0, 255);
        }
        za.MAX_VERTEX_ARRAY_LENGTH = Math.pow(2, 16) - 1, $n("SegmentVector", za);
        const Ca = Mi([
            {
                name: "a_pattern_from",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_pattern_to",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_pixel_ratio_from",
                components: 1,
                type: "Uint16"
            },
            {
                name: "a_pixel_ratio_to",
                components: 1,
                type: "Uint16"
            }
        ]);
        var Ba = {
            exports: {}
        }, Pa = {
            exports: {}
        };
        Pa.exports = function(t, e) {
            var r, n, i, a, s, o, l, u;
            for(n = t.length - (r = 3 & t.length), i = e, s = 3432918353, o = 461845907, u = 0; u < n;)l = 255 & t.charCodeAt(u) | (255 & t.charCodeAt(++u)) << 8 | (255 & t.charCodeAt(++u)) << 16 | (255 & t.charCodeAt(++u)) << 24, ++u, i = 27492 + (65535 & (a = 5 * (65535 & (i = (i ^= l = (65535 & (l = (l = (65535 & l) * s + (((l >>> 16) * s & 65535) << 16) & 4294967295) << 15 | l >>> 17)) * o + (((l >>> 16) * o & 65535) << 16) & 4294967295) << 13 | i >>> 19)) + ((5 * (i >>> 16) & 65535) << 16) & 4294967295)) + ((58964 + (a >>> 16) & 65535) << 16);
            switch(l = 0, r){
                case 3:
                    l ^= (255 & t.charCodeAt(u + 2)) << 16;
                case 2:
                    l ^= (255 & t.charCodeAt(u + 1)) << 8;
                case 1:
                    i ^= l = (65535 & (l = (l = (65535 & (l ^= 255 & t.charCodeAt(u))) * s + (((l >>> 16) * s & 65535) << 16) & 4294967295) << 15 | l >>> 17)) * o + (((l >>> 16) * o & 65535) << 16) & 4294967295;
            }
            return i ^= t.length, i = 2246822507 * (65535 & (i ^= i >>> 16)) + ((2246822507 * (i >>> 16) & 65535) << 16) & 4294967295, i = 3266489909 * (65535 & (i ^= i >>> 13)) + ((3266489909 * (i >>> 16) & 65535) << 16) & 4294967295, (i ^= i >>> 16) >>> 0;
        };
        var Va = Pa.exports, Ea = {
            exports: {}
        };
        Ea.exports = function(t, e) {
            for(var r, n = t.length, i = e ^ n, a = 0; n >= 4;)r = 1540483477 * (65535 & (r = 255 & t.charCodeAt(a) | (255 & t.charCodeAt(++a)) << 8 | (255 & t.charCodeAt(++a)) << 16 | (255 & t.charCodeAt(++a)) << 24)) + ((1540483477 * (r >>> 16) & 65535) << 16), i = 1540483477 * (65535 & i) + ((1540483477 * (i >>> 16) & 65535) << 16) ^ (r = 1540483477 * (65535 & (r ^= r >>> 24)) + ((1540483477 * (r >>> 16) & 65535) << 16)), n -= 4, ++a;
            switch(n){
                case 3:
                    i ^= (255 & t.charCodeAt(a + 2)) << 16;
                case 2:
                    i ^= (255 & t.charCodeAt(a + 1)) << 8;
                case 1:
                    i = 1540483477 * (65535 & (i ^= 255 & t.charCodeAt(a))) + ((1540483477 * (i >>> 16) & 65535) << 16);
            }
            return i = 1540483477 * (65535 & (i ^= i >>> 13)) + ((1540483477 * (i >>> 16) & 65535) << 16), (i ^= i >>> 15) >>> 0;
        };
        var Fa = Va, Ta = Ea.exports;
        Ba.exports = Fa, Ba.exports.murmur3 = Fa, Ba.exports.murmur2 = Ta;
        var $a = r(Ba.exports);
        class La {
            constructor(){
                this.ids = [], this.positions = [], this.indexed = !1;
            }
            add(t, e, r, n) {
                this.ids.push(Da(t)), this.positions.push(e, r, n);
            }
            getPositions(t) {
                if (!this.indexed) throw new Error("Trying to get index, but feature positions are not indexed");
                const e = Da(t);
                let r = 0, n = this.ids.length - 1;
                for(; r < n;){
                    const t = r + n >> 1;
                    this.ids[t] >= e ? n = t : r = t + 1;
                }
                const i = [];
                for(; this.ids[r] === e;)i.push({
                    index: this.positions[3 * r],
                    start: this.positions[3 * r + 1],
                    end: this.positions[3 * r + 2]
                }), r++;
                return i;
            }
            static serialize(t, e) {
                const r = new Float64Array(t.ids), n = new Uint32Array(t.positions);
                return Oa(r, n, 0, r.length - 1), e && e.push(r.buffer, n.buffer), {
                    ids: r,
                    positions: n
                };
            }
            static deserialize(t) {
                const e = new La;
                return e.ids = t.ids, e.positions = t.positions, e.indexed = !0, e;
            }
        }
        function Da(t) {
            const e = +t;
            return !isNaN(e) && e <= Number.MAX_SAFE_INTEGER ? e : $a(String(t));
        }
        function Oa(t, e, r, n) {
            for(; r < n;){
                const i = t[r + n >> 1];
                let a = r - 1, s = n + 1;
                for(;;){
                    do a++;
                    while (t[a] < i);
                    do s--;
                    while (t[s] > i);
                    if (a >= s) break;
                    Ua(t, a, s), Ua(e, 3 * a, 3 * s), Ua(e, 3 * a + 1, 3 * s + 1), Ua(e, 3 * a + 2, 3 * s + 2);
                }
                s - r < n - s ? (Oa(t, e, r, s), r = s + 1) : (Oa(t, e, s + 1, n), n = s);
            }
        }
        function Ua(t, e, r) {
            const n = t[e];
            t[e] = t[r], t[r] = n;
        }
        $n("FeaturePositionMap", La);
        class Ra {
            constructor(t, e){
                this.gl = t.gl, this.location = e;
            }
        }
        class qa extends Ra {
            constructor(t, e){
                super(t, e), this.current = 0;
            }
            set(t) {
                this.current !== t && (this.current = t, this.gl.uniform1f(this.location, t));
            }
        }
        class ja extends Ra {
            constructor(t, e){
                super(t, e), this.current = [
                    0,
                    0,
                    0,
                    0
                ];
            }
            set(t) {
                t[0] === this.current[0] && t[1] === this.current[1] && t[2] === this.current[2] && t[3] === this.current[3] || (this.current = t, this.gl.uniform4f(this.location, t[0], t[1], t[2], t[3]));
            }
        }
        class Na extends Ra {
            constructor(t, e){
                super(t, e), this.current = Yt.transparent;
            }
            set(t) {
                t.r === this.current.r && t.g === this.current.g && t.b === this.current.b && t.a === this.current.a || (this.current = t, this.gl.uniform4f(this.location, t.r, t.g, t.b, t.a));
            }
        }
        const Za = new Float32Array(16);
        function Ka(t) {
            return [
                Ma(255 * t.r, 255 * t.g),
                Ma(255 * t.b, 255 * t.a)
            ];
        }
        class Ga {
            constructor(t, e, r){
                this.value = t, this.uniformNames = e.map((t)=>`u_${t}`), this.type = r;
            }
            setUniform(t, e, r) {
                t.set(r.constantOr(this.value));
            }
            getBinding(t, e, r) {
                return "color" === this.type ? new Na(t, e) : new qa(t, e);
            }
        }
        class Ja {
            constructor(t, e){
                this.uniformNames = e.map((t)=>`u_${t}`), this.patternFrom = null, this.patternTo = null, this.pixelRatioFrom = 1, this.pixelRatioTo = 1;
            }
            setConstantPatternPositions(t, e) {
                this.pixelRatioFrom = e.pixelRatio, this.pixelRatioTo = t.pixelRatio, this.patternFrom = e.tlbr, this.patternTo = t.tlbr;
            }
            setUniform(t, e, r, n) {
                const i = "u_pattern_to" === n ? this.patternTo : "u_pattern_from" === n ? this.patternFrom : "u_pixel_ratio_to" === n ? this.pixelRatioTo : "u_pixel_ratio_from" === n ? this.pixelRatioFrom : null;
                i && t.set(i);
            }
            getBinding(t, e, r) {
                return "u_pattern" === r.substr(0, 9) ? new ja(t, e) : new qa(t, e);
            }
        }
        class Xa {
            constructor(t, e, r, n){
                this.expression = t, this.type = r, this.maxValue = 0, this.paintVertexAttributes = e.map((t)=>({
                        name: `a_${t}`,
                        type: "Float32",
                        components: "color" === r ? 2 : 1,
                        offset: 0
                    })), this.paintVertexArray = new n;
            }
            populatePaintArray(t, e, r, n, i) {
                const a = this.paintVertexArray.length, s = this.expression.evaluate(new li(0), e, {}, n, [], i);
                this.paintVertexArray.resize(t), this._setPaintValue(a, t, s);
            }
            updatePaintArray(t, e, r, n) {
                const i = this.expression.evaluate({
                    zoom: 0
                }, r, n);
                this._setPaintValue(t, e, i);
            }
            _setPaintValue(t, e, r) {
                if ("color" === this.type) {
                    const n = Ka(r);
                    for(let r = t; r < e; r++)this.paintVertexArray.emplace(r, n[0], n[1]);
                } else {
                    for(let n = t; n < e; n++)this.paintVertexArray.emplace(n, r);
                    this.maxValue = Math.max(this.maxValue, Math.abs(r));
                }
            }
            upload(t) {
                this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = t.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent));
            }
            destroy() {
                this.paintVertexBuffer && this.paintVertexBuffer.destroy();
            }
        }
        class Ya {
            constructor(t, e, r, n, i, a){
                this.expression = t, this.uniformNames = e.map((t)=>`u_${t}_t`), this.type = r, this.useIntegerZoom = n, this.zoom = i, this.maxValue = 0, this.paintVertexAttributes = e.map((t)=>({
                        name: `a_${t}`,
                        type: "Float32",
                        components: "color" === r ? 4 : 2,
                        offset: 0
                    })), this.paintVertexArray = new a;
            }
            populatePaintArray(t, e, r, n, i) {
                const a = this.expression.evaluate(new li(this.zoom), e, {}, n, [], i), s = this.expression.evaluate(new li(this.zoom + 1), e, {}, n, [], i), o = this.paintVertexArray.length;
                this.paintVertexArray.resize(t), this._setPaintValue(o, t, a, s);
            }
            updatePaintArray(t, e, r, n) {
                const i = this.expression.evaluate({
                    zoom: this.zoom
                }, r, n), a = this.expression.evaluate({
                    zoom: this.zoom + 1
                }, r, n);
                this._setPaintValue(t, e, i, a);
            }
            _setPaintValue(t, e, r, n) {
                if ("color" === this.type) {
                    const i = Ka(r), a = Ka(n);
                    for(let r = t; r < e; r++)this.paintVertexArray.emplace(r, i[0], i[1], a[0], a[1]);
                } else {
                    for(let i = t; i < e; i++)this.paintVertexArray.emplace(i, r, n);
                    this.maxValue = Math.max(this.maxValue, Math.abs(r), Math.abs(n));
                }
            }
            upload(t) {
                this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = t.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent));
            }
            destroy() {
                this.paintVertexBuffer && this.paintVertexBuffer.destroy();
            }
            setUniform(t, e) {
                const r = this.useIntegerZoom ? Math.floor(e.zoom) : e.zoom, n = y(this.expression.interpolationFactor(r, this.zoom, this.zoom + 1), 0, 1);
                t.set(n);
            }
            getBinding(t, e, r) {
                return new qa(t, e);
            }
        }
        class Ha {
            constructor(t, e, r, n, i, a){
                this.expression = t, this.type = e, this.useIntegerZoom = r, this.zoom = n, this.layerId = a, this.zoomInPaintVertexArray = new i, this.zoomOutPaintVertexArray = new i;
            }
            populatePaintArray(t, e, r) {
                const n = this.zoomInPaintVertexArray.length;
                this.zoomInPaintVertexArray.resize(t), this.zoomOutPaintVertexArray.resize(t), this._setPaintValues(n, t, e.patterns && e.patterns[this.layerId], r);
            }
            updatePaintArray(t, e, r, n, i) {
                this._setPaintValues(t, e, r.patterns && r.patterns[this.layerId], i);
            }
            _setPaintValues(t, e, r, n) {
                if (!n || !r) return;
                const { min: i, mid: a, max: s } = r, o = n[i], l = n[a], u = n[s];
                if (o && l && u) for(let r = t; r < e; r++)this.zoomInPaintVertexArray.emplace(r, l.tl[0], l.tl[1], l.br[0], l.br[1], o.tl[0], o.tl[1], o.br[0], o.br[1], l.pixelRatio, o.pixelRatio), this.zoomOutPaintVertexArray.emplace(r, l.tl[0], l.tl[1], l.br[0], l.br[1], u.tl[0], u.tl[1], u.br[0], u.br[1], l.pixelRatio, u.pixelRatio);
            }
            upload(t) {
                this.zoomInPaintVertexArray && this.zoomInPaintVertexArray.arrayBuffer && this.zoomOutPaintVertexArray && this.zoomOutPaintVertexArray.arrayBuffer && (this.zoomInPaintVertexBuffer = t.createVertexBuffer(this.zoomInPaintVertexArray, Ca.members, this.expression.isStateDependent), this.zoomOutPaintVertexBuffer = t.createVertexBuffer(this.zoomOutPaintVertexArray, Ca.members, this.expression.isStateDependent));
            }
            destroy() {
                this.zoomOutPaintVertexBuffer && this.zoomOutPaintVertexBuffer.destroy(), this.zoomInPaintVertexBuffer && this.zoomInPaintVertexBuffer.destroy();
            }
        }
        class Wa {
            constructor(t, e, r){
                this.binders = {}, this._buffers = [];
                const n = [];
                for(const i in t.paint._values){
                    if (!r(i)) continue;
                    const a = t.paint.get(i);
                    if (!(a instanceof yi && _r(a.property.specification))) continue;
                    const s = ts(i, t.type), o = a.value, l = a.property.specification.type, u = a.property.useIntegerZoom, c = a.property.specification["property-type"], h = "cross-faded" === c || "cross-faded-data-driven" === c;
                    if ("constant" === o.kind) this.binders[i] = h ? new Ja(o.value, s) : new Ga(o.value, s, l), n.push(`/u_${i}`);
                    else if ("source" === o.kind || h) {
                        const r = es(i, l, "source");
                        this.binders[i] = h ? new Ha(o, l, u, e, r, t.id) : new Xa(o, s, l, r), n.push(`/a_${i}`);
                    } else {
                        const t = es(i, l, "composite");
                        this.binders[i] = new Ya(o, s, l, u, e, t), n.push(`/z_${i}`);
                    }
                }
                this.cacheKey = n.sort().join("");
            }
            getMaxValue(t) {
                const e = this.binders[t];
                return e instanceof Xa || e instanceof Ya ? e.maxValue : 0;
            }
            populatePaintArrays(t, e, r, n, i) {
                for(const a in this.binders){
                    const s = this.binders[a];
                    (s instanceof Xa || s instanceof Ya || s instanceof Ha) && s.populatePaintArray(t, e, r, n, i);
                }
            }
            setConstantPatternPositions(t, e) {
                for(const r in this.binders){
                    const n = this.binders[r];
                    n instanceof Ja && n.setConstantPatternPositions(t, e);
                }
            }
            updatePaintArrays(t, e, r, n, i) {
                let a = !1;
                for(const s in t){
                    const o = e.getPositions(s);
                    for (const e of o){
                        const o = r.feature(e.index);
                        for(const r in this.binders){
                            const l = this.binders[r];
                            if ((l instanceof Xa || l instanceof Ya || l instanceof Ha) && !0 === l.expression.isStateDependent) {
                                const u = n.paint.get(r);
                                l.expression = u.value, l.updatePaintArray(e.start, e.end, o, t[s], i), a = !0;
                            }
                        }
                    }
                }
                return a;
            }
            defines() {
                const t = [];
                for(const e in this.binders){
                    const r = this.binders[e];
                    (r instanceof Ga || r instanceof Ja) && t.push(...r.uniformNames.map((t)=>`#define HAS_UNIFORM_${t}`));
                }
                return t;
            }
            getBinderAttributes() {
                const t = [];
                for(const e in this.binders){
                    const r = this.binders[e];
                    if (r instanceof Xa || r instanceof Ya) for(let e = 0; e < r.paintVertexAttributes.length; e++)t.push(r.paintVertexAttributes[e].name);
                    else if (r instanceof Ha) for(let e = 0; e < Ca.members.length; e++)t.push(Ca.members[e].name);
                }
                return t;
            }
            getBinderUniforms() {
                const t = [];
                for(const e in this.binders){
                    const r = this.binders[e];
                    if (r instanceof Ga || r instanceof Ja || r instanceof Ya) for (const e of r.uniformNames)t.push(e);
                }
                return t;
            }
            getPaintVertexBuffers() {
                return this._buffers;
            }
            getUniforms(t, e) {
                const r = [];
                for(const n in this.binders){
                    const i = this.binders[n];
                    if (i instanceof Ga || i instanceof Ja || i instanceof Ya) {
                        for (const a of i.uniformNames)if (e[a]) {
                            const s = i.getBinding(t, e[a], a);
                            r.push({
                                name: a,
                                property: n,
                                binding: s
                            });
                        }
                    }
                }
                return r;
            }
            setUniforms(t, e, r, n) {
                for (const { name: t, property: i, binding: a } of e)this.binders[i].setUniform(a, n, r.get(i), t);
            }
            updatePaintBuffers(t) {
                this._buffers = [];
                for(const e in this.binders){
                    const r = this.binders[e];
                    if (t && r instanceof Ha) {
                        const e = 2 === t.fromScale ? r.zoomInPaintVertexBuffer : r.zoomOutPaintVertexBuffer;
                        e && this._buffers.push(e);
                    } else (r instanceof Xa || r instanceof Ya) && r.paintVertexBuffer && this._buffers.push(r.paintVertexBuffer);
                }
            }
            upload(t) {
                for(const e in this.binders){
                    const r = this.binders[e];
                    (r instanceof Xa || r instanceof Ya || r instanceof Ha) && r.upload(t);
                }
                this.updatePaintBuffers();
            }
            destroy() {
                for(const t in this.binders){
                    const e = this.binders[t];
                    (e instanceof Xa || e instanceof Ya || e instanceof Ha) && e.destroy();
                }
            }
        }
        class Qa {
            constructor(t, e, r = ()=>!0){
                this.programConfigurations = {};
                for (const n of t)this.programConfigurations[n.id] = new Wa(n, e, r);
                this.needsUpload = !1, this._featureMap = new La, this._bufferOffset = 0;
            }
            populatePaintArrays(t, e, r, n, i, a) {
                for(const r in this.programConfigurations)this.programConfigurations[r].populatePaintArrays(t, e, n, i, a);
                void 0 !== e.id && this._featureMap.add(e.id, r, this._bufferOffset, t), this._bufferOffset = t, this.needsUpload = !0;
            }
            updatePaintArrays(t, e, r, n) {
                for (const i of r)this.needsUpload = this.programConfigurations[i.id].updatePaintArrays(t, this._featureMap, e, i, n) || this.needsUpload;
            }
            get(t) {
                return this.programConfigurations[t];
            }
            upload(t) {
                if (this.needsUpload) {
                    for(const e in this.programConfigurations)this.programConfigurations[e].upload(t);
                    this.needsUpload = !1;
                }
            }
            destroy() {
                for(const t in this.programConfigurations)this.programConfigurations[t].destroy();
            }
        }
        function ts(t, e) {
            return ({
                "text-opacity": [
                    "opacity"
                ],
                "icon-opacity": [
                    "opacity"
                ],
                "text-color": [
                    "fill_color"
                ],
                "icon-color": [
                    "fill_color"
                ],
                "text-halo-color": [
                    "halo_color"
                ],
                "icon-halo-color": [
                    "halo_color"
                ],
                "text-halo-blur": [
                    "halo_blur"
                ],
                "icon-halo-blur": [
                    "halo_blur"
                ],
                "text-halo-width": [
                    "halo_width"
                ],
                "icon-halo-width": [
                    "halo_width"
                ],
                "line-gap-width": [
                    "gapwidth"
                ],
                "line-pattern": [
                    "pattern_to",
                    "pattern_from",
                    "pixel_ratio_to",
                    "pixel_ratio_from"
                ],
                "fill-pattern": [
                    "pattern_to",
                    "pattern_from",
                    "pixel_ratio_to",
                    "pixel_ratio_from"
                ],
                "fill-extrusion-pattern": [
                    "pattern_to",
                    "pattern_from",
                    "pixel_ratio_to",
                    "pixel_ratio_from"
                ]
            })[t] || [
                t.replace(`${e}-`, "").replace(/-/g, "_")
            ];
        }
        function es(t, e, r) {
            const n = {
                color: {
                    source: Ti,
                    composite: Wi
                },
                number: {
                    source: Gi,
                    composite: Ti
                }
            }, i = function(t) {
                return ({
                    "line-pattern": {
                        source: ga,
                        composite: ga
                    },
                    "fill-pattern": {
                        source: ga,
                        composite: ga
                    },
                    "fill-extrusion-pattern": {
                        source: ga,
                        composite: ga
                    }
                })[t];
            }(t);
            return i && i[r] || n[e][r];
        }
        $n("ConstantBinder", Ga), $n("CrossFadedConstantBinder", Ja), $n("SourceExpressionBinder", Xa), $n("CrossFadedCompositeBinder", Ha), $n("CompositeExpressionBinder", Ya), $n("ProgramConfiguration", Wa, {
            omit: [
                "_buffers"
            ]
        }), $n("ProgramConfigurationSet", Qa);
        const rs = 8192, ns = Math.pow(2, 14) - 1, is = -ns - 1;
        function as(t) {
            const e = rs / t.extent, r = t.loadGeometry();
            for(let t = 0; t < r.length; t++){
                const n = r[t];
                for(let t = 0; t < n.length; t++){
                    const r = n[t], i = Math.round(r.x * e), a = Math.round(r.y * e);
                    r.x = y(i, is, ns), r.y = y(a, is, ns), (i < r.x || i > r.x + 1 || a < r.y || a > r.y + 1) && A("Geometry exceeds allowed extent, reduce your vector tile buffer size");
                }
            }
            return r;
        }
        function ss(t, e) {
            return {
                type: t.type,
                id: t.id,
                properties: t.properties,
                geometry: e ? as(t) : []
            };
        }
        function os(t, e, r, n, i) {
            t.emplaceBack(2 * e + (n + 1) / 2, 2 * r + (i + 1) / 2);
        }
        class ls {
            constructor(t){
                this.zoom = t.zoom, this.overscaling = t.overscaling, this.layers = t.layers, this.layerIds = this.layers.map((t)=>t.id), this.index = t.index, this.hasPattern = !1, this.layoutVertexArray = new pa, this.indexArray = new Aa, this.segments = new za, this.programConfigurations = new Qa(t.layers, t.zoom), this.stateDependentLayerIds = this.layers.filter((t)=>t.isStateDependent()).map((t)=>t.id);
            }
            populate(t, e, r) {
                const n = this.layers[0], i = [];
                let a = null, s = !1;
                "circle" === n.type && (a = n.layout.get("circle-sort-key"), s = !a.isConstant());
                for (const { feature: e, id: n, index: o, sourceLayerIndex: l } of t){
                    const t = this.layers[0]._featureFilter.needGeometry, u = ss(e, t);
                    if (!this.layers[0]._featureFilter.filter(new li(this.zoom), u, r)) continue;
                    const c = s ? a.evaluate(u, {}, r) : void 0, h = {
                        id: n,
                        properties: e.properties,
                        type: e.type,
                        sourceLayerIndex: l,
                        index: o,
                        geometry: t ? u.geometry : as(e),
                        patterns: {},
                        sortKey: c
                    };
                    i.push(h);
                }
                s && i.sort((t, e)=>t.sortKey - e.sortKey);
                for (const n of i){
                    const { geometry: i, index: a, sourceLayerIndex: s } = n, o = t[a].feature;
                    this.addFeature(n, i, a, r), e.featureIndex.insert(o, i, a, s, this.index);
                }
            }
            update(t, e, r) {
                this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t, e, this.stateDependentLayers, r);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(t) {
                this.uploaded || (this.layoutVertexBuffer = t.createVertexBuffer(this.layoutVertexArray, Ia), this.indexBuffer = t.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(t), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
            }
            addFeature(t, e, r, n) {
                for (const r of e)for (const e of r){
                    const r = e.x, n = e.y;
                    if (r < 0 || r >= rs || n < 0 || n >= rs) continue;
                    const i = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray, t.sortKey), a = i.vertexLength;
                    os(this.layoutVertexArray, r, n, -1, -1), os(this.layoutVertexArray, r, n, 1, -1), os(this.layoutVertexArray, r, n, 1, 1), os(this.layoutVertexArray, r, n, -1, 1), this.indexArray.emplaceBack(a, a + 1, a + 2), this.indexArray.emplaceBack(a, a + 3, a + 2), i.vertexLength += 4, i.primitiveLength += 2;
                }
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t, r, {}, n);
            }
        }
        function us(t, e) {
            for(let r = 0; r < t.length; r++)if (xs(e, t[r])) return !0;
            for(let r = 0; r < e.length; r++)if (xs(t, e[r])) return !0;
            return !!fs(t, e);
        }
        function cs(t, e, r) {
            return !!xs(t, e) || !!ys(e, t, r);
        }
        function hs(t, e) {
            if (1 === t.length) return gs(e, t[0]);
            for(let r = 0; r < e.length; r++){
                const n = e[r];
                for(let e = 0; e < n.length; e++)if (xs(t, n[e])) return !0;
            }
            for(let r = 0; r < t.length; r++)if (gs(e, t[r])) return !0;
            for(let r = 0; r < e.length; r++)if (fs(t, e[r])) return !0;
            return !1;
        }
        function ps(t, e, r) {
            if (t.length > 1) {
                if (fs(t, e)) return !0;
                for(let n = 0; n < e.length; n++)if (ys(e[n], t, r)) return !0;
            }
            for(let n = 0; n < t.length; n++)if (ys(t[n], e, r)) return !0;
            return !1;
        }
        function fs(t, e) {
            if (0 === t.length || 0 === e.length) return !1;
            for(let r = 0; r < t.length - 1; r++){
                const n = t[r], i = t[r + 1];
                for(let t = 0; t < e.length - 1; t++)if (ds(n, i, e[t], e[t + 1])) return !0;
            }
            return !1;
        }
        function ds(t, e, r, n) {
            return S(t, r, n) !== S(e, r, n) && S(t, e, r) !== S(t, e, n);
        }
        function ys(t, e, r) {
            const n = r * r;
            if (1 === e.length) return t.distSqr(e[0]) < n;
            for(let r = 1; r < e.length; r++)if (ms(t, e[r - 1], e[r]) < n) return !0;
            return !1;
        }
        function ms(t, e, r) {
            const n = e.distSqr(r);
            if (0 === n) return t.distSqr(e);
            const i = ((t.x - e.x) * (r.x - e.x) + (t.y - e.y) * (r.y - e.y)) / n;
            return t.distSqr(i < 0 ? e : i > 1 ? r : r.sub(e)._mult(i)._add(e));
        }
        function gs(t, e) {
            let r, n, i, a = !1;
            for(let s = 0; s < t.length; s++){
                r = t[s];
                for(let t = 0, s = r.length - 1; t < r.length; s = t++)n = r[t], i = r[s], n.y > e.y != i.y > e.y && e.x < (i.x - n.x) * (e.y - n.y) / (i.y - n.y) + n.x && (a = !a);
            }
            return a;
        }
        function xs(t, e) {
            let r = !1;
            for(let n = 0, i = t.length - 1; n < t.length; i = n++){
                const a = t[n], s = t[i];
                a.y > e.y != s.y > e.y && e.x < (s.x - a.x) * (e.y - a.y) / (s.y - a.y) + a.x && (r = !r);
            }
            return r;
        }
        function vs(t, e, r) {
            const n = r[0], i = r[2];
            if (t.x < n.x && e.x < n.x || t.x > i.x && e.x > i.x || t.y < n.y && e.y < n.y || t.y > i.y && e.y > i.y) return !1;
            const a = S(t, e, r[0]);
            return a !== S(t, e, r[1]) || a !== S(t, e, r[2]) || a !== S(t, e, r[3]);
        }
        function bs(t, e, r) {
            const n = e.paint.get(t).value;
            return "constant" === n.kind ? n.value : r.programConfigurations.get(e.id).getMaxValue(t);
        }
        function ws(t) {
            return Math.sqrt(t[0] * t[0] + t[1] * t[1]);
        }
        function _s(t, e, r, n, i) {
            if (!e[0] && !e[1]) return t;
            const s = a.convert(e)._mult(i);
            "viewport" === r && s._rotate(-n);
            const o = [];
            for(let e = 0; e < t.length; e++)o.push(t[e].sub(s));
            return o;
        }
        let As, Ss;
        $n("CircleBucket", ls, {
            omit: [
                "layers"
            ]
        });
        var ks = {
            get paint () {
                return Ss = Ss || new _i({
                    "circle-radius": new xi(X.paint_circle["circle-radius"]),
                    "circle-color": new xi(X.paint_circle["circle-color"]),
                    "circle-blur": new xi(X.paint_circle["circle-blur"]),
                    "circle-opacity": new xi(X.paint_circle["circle-opacity"]),
                    "circle-translate": new gi(X.paint_circle["circle-translate"]),
                    "circle-translate-anchor": new gi(X.paint_circle["circle-translate-anchor"]),
                    "circle-pitch-scale": new gi(X.paint_circle["circle-pitch-scale"]),
                    "circle-pitch-alignment": new gi(X.paint_circle["circle-pitch-alignment"]),
                    "circle-stroke-width": new xi(X.paint_circle["circle-stroke-width"]),
                    "circle-stroke-color": new xi(X.paint_circle["circle-stroke-color"]),
                    "circle-stroke-opacity": new xi(X.paint_circle["circle-stroke-opacity"])
                });
            },
            get layout () {
                return As = As || new _i({
                    "circle-sort-key": new xi(X.layout_circle["circle-sort-key"])
                });
            }
        }, Is = 1e-6, zs = "undefined" != typeof Float32Array ? Float32Array : Array;
        function Ms(t) {
            return t[0] = 1, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = 1, t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[10] = 1, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, t;
        }
        function Cs(t, e, r) {
            var n = e[0], i = e[1], a = e[2], s = e[3], o = e[4], l = e[5], u = e[6], c = e[7], h = e[8], p = e[9], f = e[10], d = e[11], y = e[12], m = e[13], g = e[14], x = e[15], v = r[0], b = r[1], w = r[2], _ = r[3];
            return t[0] = v * n + b * o + w * h + _ * y, t[1] = v * i + b * l + w * p + _ * m, t[2] = v * a + b * u + w * f + _ * g, t[3] = v * s + b * c + w * d + _ * x, t[4] = (v = r[4]) * n + (b = r[5]) * o + (w = r[6]) * h + (_ = r[7]) * y, t[5] = v * i + b * l + w * p + _ * m, t[6] = v * a + b * u + w * f + _ * g, t[7] = v * s + b * c + w * d + _ * x, t[8] = (v = r[8]) * n + (b = r[9]) * o + (w = r[10]) * h + (_ = r[11]) * y, t[9] = v * i + b * l + w * p + _ * m, t[10] = v * a + b * u + w * f + _ * g, t[11] = v * s + b * c + w * d + _ * x, t[12] = (v = r[12]) * n + (b = r[13]) * o + (w = r[14]) * h + (_ = r[15]) * y, t[13] = v * i + b * l + w * p + _ * m, t[14] = v * a + b * u + w * f + _ * g, t[15] = v * s + b * c + w * d + _ * x, t;
        }
        Math.hypot || (Math.hypot = function() {
            for(var t = 0, e = arguments.length; e--;)t += arguments[e] * arguments[e];
            return Math.sqrt(t);
        });
        var Bs, Ps = Cs;
        function Vs(t, e, r) {
            var n = e[0], i = e[1], a = e[2], s = e[3];
            return t[0] = r[0] * n + r[4] * i + r[8] * a + r[12] * s, t[1] = r[1] * n + r[5] * i + r[9] * a + r[13] * s, t[2] = r[2] * n + r[6] * i + r[10] * a + r[14] * s, t[3] = r[3] * n + r[7] * i + r[11] * a + r[15] * s, t;
        }
        Bs = new zs(4), zs != Float32Array && (Bs[0] = 0, Bs[1] = 0, Bs[2] = 0, Bs[3] = 0);
        class Es extends Si {
            constructor(t){
                super(t, ks);
            }
            createBucket(t) {
                return new ls(t);
            }
            queryRadius(t) {
                const e = t;
                return bs("circle-radius", this, e) + bs("circle-stroke-width", this, e) + ws(this.paint.get("circle-translate"));
            }
            queryIntersectsFeature(t, e, r, n, i, a, s, o) {
                const l = _s(t, this.paint.get("circle-translate"), this.paint.get("circle-translate-anchor"), a.angle, s), u = this.paint.get("circle-radius").evaluate(e, r) + this.paint.get("circle-stroke-width").evaluate(e, r), c = "map" === this.paint.get("circle-pitch-alignment"), h = c ? l : function(t, e) {
                    return t.map((t)=>Fs(t, e));
                }(l, o), p = c ? u * s : u;
                for (const t of n)for (const e of t){
                    const t = c ? e : Fs(e, o);
                    let r = p;
                    const n = Vs([], [
                        e.x,
                        e.y,
                        0,
                        1
                    ], o);
                    if ("viewport" === this.paint.get("circle-pitch-scale") && "map" === this.paint.get("circle-pitch-alignment") ? r *= n[3] / a.cameraToCenterDistance : "map" === this.paint.get("circle-pitch-scale") && "viewport" === this.paint.get("circle-pitch-alignment") && (r *= a.cameraToCenterDistance / n[3]), cs(h, t, r)) return !0;
                }
                return !1;
            }
        }
        function Fs(t, e) {
            const r = Vs([], [
                t.x,
                t.y,
                0,
                1
            ], e);
            return new a(r[0] / r[3], r[1] / r[3]);
        }
        class Ts extends ls {
        }
        let $s;
        $n("HeatmapBucket", Ts, {
            omit: [
                "layers"
            ]
        });
        var Ls = {
            get paint () {
                return $s = $s || new _i({
                    "heatmap-radius": new xi(X.paint_heatmap["heatmap-radius"]),
                    "heatmap-weight": new xi(X.paint_heatmap["heatmap-weight"]),
                    "heatmap-intensity": new gi(X.paint_heatmap["heatmap-intensity"]),
                    "heatmap-color": new wi(X.paint_heatmap["heatmap-color"]),
                    "heatmap-opacity": new gi(X.paint_heatmap["heatmap-opacity"])
                });
            }
        };
        function Ds(t, { width: e, height: r }, n, i) {
            if (i) {
                if (i instanceof Uint8ClampedArray) i = new Uint8Array(i.buffer);
                else if (i.length !== e * r * n) throw new RangeError(`mismatched image size. expected: ${i.length} but got: ${e * r * n}`);
            } else i = new Uint8Array(e * r * n);
            return t.width = e, t.height = r, t.data = i, t;
        }
        function Os(t, { width: e, height: r }, n) {
            if (e === t.width && r === t.height) return;
            const i = Ds({}, {
                width: e,
                height: r
            }, n);
            Us(t, i, {
                x: 0,
                y: 0
            }, {
                x: 0,
                y: 0
            }, {
                width: Math.min(t.width, e),
                height: Math.min(t.height, r)
            }, n), t.width = e, t.height = r, t.data = i.data;
        }
        function Us(t, e, r, n, i, a) {
            if (0 === i.width || 0 === i.height) return e;
            if (i.width > t.width || i.height > t.height || r.x > t.width - i.width || r.y > t.height - i.height) throw new RangeError("out of range source coordinates for image copy");
            if (i.width > e.width || i.height > e.height || n.x > e.width - i.width || n.y > e.height - i.height) throw new RangeError("out of range destination coordinates for image copy");
            const s = t.data, o = e.data;
            if (s === o) throw new Error("srcData equals dstData, so image is already copied");
            for(let l = 0; l < i.height; l++){
                const u = ((r.y + l) * t.width + r.x) * a, c = ((n.y + l) * e.width + n.x) * a;
                for(let t = 0; t < i.width * a; t++)o[c + t] = s[u + t];
            }
            return e;
        }
        class Rs {
            constructor(t, e){
                Ds(this, t, 1, e);
            }
            resize(t) {
                Os(this, t, 1);
            }
            clone() {
                return new Rs({
                    width: this.width,
                    height: this.height
                }, new Uint8Array(this.data));
            }
            static copy(t, e, r, n, i) {
                Us(t, e, r, n, i, 1);
            }
        }
        class qs {
            constructor(t, e){
                Ds(this, t, 4, e);
            }
            resize(t) {
                Os(this, t, 4);
            }
            replace(t, e) {
                e ? this.data.set(t) : this.data = t instanceof Uint8ClampedArray ? new Uint8Array(t.buffer) : t;
            }
            clone() {
                return new qs({
                    width: this.width,
                    height: this.height
                }, new Uint8Array(this.data));
            }
            static copy(t, e, r, n, i) {
                Us(t, e, r, n, i, 4);
            }
        }
        function js(t) {
            const e = {}, r = t.resolution || 256, n = t.clips ? t.clips.length : 1, i = t.image || new qs({
                width: r,
                height: n
            });
            if (Math.log(r) / Math.LN2 % 1 != 0) throw new Error(`width is not a power of 2 - ${r}`);
            const a = (r, n, a)=>{
                e[t.evaluationKey] = a;
                const s = t.expression.evaluate(e);
                i.data[r + n + 0] = Math.floor(255 * s.r / s.a), i.data[r + n + 1] = Math.floor(255 * s.g / s.a), i.data[r + n + 2] = Math.floor(255 * s.b / s.a), i.data[r + n + 3] = Math.floor(255 * s.a);
            };
            if (t.clips) for(let e = 0, i = 0; e < n; ++e, i += 4 * r)for(let n = 0, s = 0; n < r; n++, s += 4){
                const o = n / (r - 1), { start: l, end: u } = t.clips[e];
                a(i, s, l * (1 - o) + u * o);
            }
            else for(let t = 0, e = 0; t < r; t++, e += 4)a(0, e, t / (r - 1));
            return i;
        }
        $n("AlphaImage", Rs), $n("RGBAImage", qs);
        class Ns extends Si {
            createBucket(t) {
                return new Ts(t);
            }
            constructor(t){
                super(t, Ls), this._updateColorRamp();
            }
            _handleSpecialPaintPropertyUpdate(t) {
                "heatmap-color" === t && this._updateColorRamp();
            }
            _updateColorRamp() {
                this.colorRamp = js({
                    expression: this._transitionablePaint._values["heatmap-color"].value.expression,
                    evaluationKey: "heatmapDensity",
                    image: this.colorRamp
                }), this.colorRampTexture = null;
            }
            resize() {
                this.heatmapFbo && (this.heatmapFbo.destroy(), this.heatmapFbo = null);
            }
            queryRadius() {
                return 0;
            }
            queryIntersectsFeature() {
                return !1;
            }
            hasOffscreenPass() {
                return 0 !== this.paint.get("heatmap-opacity") && "none" !== this.visibility;
            }
        }
        let Zs;
        var Ks = {
            get paint () {
                return Zs = Zs || new _i({
                    "hillshade-illumination-direction": new gi(X.paint_hillshade["hillshade-illumination-direction"]),
                    "hillshade-illumination-anchor": new gi(X.paint_hillshade["hillshade-illumination-anchor"]),
                    "hillshade-exaggeration": new gi(X.paint_hillshade["hillshade-exaggeration"]),
                    "hillshade-shadow-color": new gi(X.paint_hillshade["hillshade-shadow-color"]),
                    "hillshade-highlight-color": new gi(X.paint_hillshade["hillshade-highlight-color"]),
                    "hillshade-accent-color": new gi(X.paint_hillshade["hillshade-accent-color"])
                });
            }
        };
        class Gs extends Si {
            constructor(t){
                super(t, Ks);
            }
            hasOffscreenPass() {
                return 0 !== this.paint.get("hillshade-exaggeration") && "none" !== this.visibility;
            }
        }
        const Js = Mi([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            }
        ], 4), { members: Xs } = Js;
        var Ys = {
            exports: {}
        };
        function Hs(t, e, r) {
            r = r || 2;
            var n, i, a, s, o, l, u, c = e && e.length, h = c ? e[0] * r : t.length, p = Ws(t, 0, h, r, !0), f = [];
            if (!p || p.next === p.prev) return f;
            if (c && (p = function(t, e, r, n) {
                var i, a, s, o = [];
                for(i = 0, a = e.length; i < a; i++)(s = Ws(t, e[i] * n, i < a - 1 ? e[i + 1] * n : t.length, n, !1)) === s.next && (s.steiner = !0), o.push(uo(s));
                for(o.sort(ao), i = 0; i < o.length; i++)r = so(o[i], r);
                return r;
            }(t, e, p, r)), t.length > 80 * r) {
                n = a = t[0], i = s = t[1];
                for(var d = r; d < h; d += r)(o = t[d]) < n && (n = o), (l = t[d + 1]) < i && (i = l), o > a && (a = o), l > s && (s = l);
                u = 0 !== (u = Math.max(a - n, s - i)) ? 32767 / u : 0;
            }
            return to(p, f, r, n, i, u, 0), f;
        }
        function Ws(t, e, r, n, i) {
            var a, s;
            if (i === Ao(t, e, r, n) > 0) for(a = e; a < r; a += n)s = bo(a, t[a], t[a + 1], s);
            else for(a = r - n; a >= e; a -= n)s = bo(a, t[a], t[a + 1], s);
            return s && fo(s, s.next) && (wo(s), s = s.next), s;
        }
        function Qs(t, e) {
            if (!t) return t;
            e || (e = t);
            var r, n = t;
            do if (r = !1, n.steiner || !fo(n, n.next) && 0 !== po(n.prev, n, n.next)) n = n.next;
            else {
                if (wo(n), (n = e = n.prev) === n.next) break;
                r = !0;
            }
            while (r || n !== e);
            return e;
        }
        function to(t, e, r, n, i, a, s) {
            if (t) {
                !s && a && function(t, e, r, n) {
                    var i = t;
                    do 0 === i.z && (i.z = lo(i.x, i.y, e, r, n)), i.prevZ = i.prev, i.nextZ = i.next, i = i.next;
                    while (i !== t);
                    i.prevZ.nextZ = null, i.prevZ = null, function(t) {
                        var e, r, n, i, a, s, o, l, u = 1;
                        do {
                            for(r = t, t = null, a = null, s = 0; r;){
                                for(s++, n = r, o = 0, e = 0; e < u && (o++, n = n.nextZ); e++);
                                for(l = u; o > 0 || l > 0 && n;)0 !== o && (0 === l || !n || r.z <= n.z) ? (i = r, r = r.nextZ, o--) : (i = n, n = n.nextZ, l--), a ? a.nextZ = i : t = i, i.prevZ = a, a = i;
                                r = n;
                            }
                            a.nextZ = null, u *= 2;
                        }while (s > 1);
                    }(i);
                }(t, n, i, a);
                for(var o, l, u = t; t.prev !== t.next;)if (o = t.prev, l = t.next, a ? ro(t, n, i, a) : eo(t)) e.push(o.i / r | 0), e.push(t.i / r | 0), e.push(l.i / r | 0), wo(t), t = l.next, u = l.next;
                else if ((t = l) === u) {
                    s ? 1 === s ? to(t = no(Qs(t), e, r), e, r, n, i, a, 2) : 2 === s && io(t, e, r, n, i, a) : to(Qs(t), e, r, n, i, a, 1);
                    break;
                }
            }
        }
        function eo(t) {
            var e = t.prev, r = t, n = t.next;
            if (po(e, r, n) >= 0) return !1;
            for(var i = e.x, a = r.x, s = n.x, o = e.y, l = r.y, u = n.y, c = i < a ? i < s ? i : s : a < s ? a : s, h = o < l ? o < u ? o : u : l < u ? l : u, p = i > a ? i > s ? i : s : a > s ? a : s, f = o > l ? o > u ? o : u : l > u ? l : u, d = n.next; d !== e;){
                if (d.x >= c && d.x <= p && d.y >= h && d.y <= f && co(i, o, a, l, s, u, d.x, d.y) && po(d.prev, d, d.next) >= 0) return !1;
                d = d.next;
            }
            return !0;
        }
        function ro(t, e, r, n) {
            var i = t.prev, a = t, s = t.next;
            if (po(i, a, s) >= 0) return !1;
            for(var o = i.x, l = a.x, u = s.x, c = i.y, h = a.y, p = s.y, f = o < l ? o < u ? o : u : l < u ? l : u, d = c < h ? c < p ? c : p : h < p ? h : p, y = o > l ? o > u ? o : u : l > u ? l : u, m = c > h ? c > p ? c : p : h > p ? h : p, g = lo(f, d, e, r, n), x = lo(y, m, e, r, n), v = t.prevZ, b = t.nextZ; v && v.z >= g && b && b.z <= x;){
                if (v.x >= f && v.x <= y && v.y >= d && v.y <= m && v !== i && v !== s && co(o, c, l, h, u, p, v.x, v.y) && po(v.prev, v, v.next) >= 0) return !1;
                if (v = v.prevZ, b.x >= f && b.x <= y && b.y >= d && b.y <= m && b !== i && b !== s && co(o, c, l, h, u, p, b.x, b.y) && po(b.prev, b, b.next) >= 0) return !1;
                b = b.nextZ;
            }
            for(; v && v.z >= g;){
                if (v.x >= f && v.x <= y && v.y >= d && v.y <= m && v !== i && v !== s && co(o, c, l, h, u, p, v.x, v.y) && po(v.prev, v, v.next) >= 0) return !1;
                v = v.prevZ;
            }
            for(; b && b.z <= x;){
                if (b.x >= f && b.x <= y && b.y >= d && b.y <= m && b !== i && b !== s && co(o, c, l, h, u, p, b.x, b.y) && po(b.prev, b, b.next) >= 0) return !1;
                b = b.nextZ;
            }
            return !0;
        }
        function no(t, e, r) {
            var n = t;
            do {
                var i = n.prev, a = n.next.next;
                !fo(i, a) && yo(i, n, n.next, a) && xo(i, a) && xo(a, i) && (e.push(i.i / r | 0), e.push(n.i / r | 0), e.push(a.i / r | 0), wo(n), wo(n.next), n = t = a), n = n.next;
            }while (n !== t);
            return Qs(n);
        }
        function io(t, e, r, n, i, a) {
            var s = t;
            do {
                for(var o = s.next.next; o !== s.prev;){
                    if (s.i !== o.i && ho(s, o)) {
                        var l = vo(s, o);
                        return s = Qs(s, s.next), l = Qs(l, l.next), to(s, e, r, n, i, a, 0), void to(l, e, r, n, i, a, 0);
                    }
                    o = o.next;
                }
                s = s.next;
            }while (s !== t);
        }
        function ao(t, e) {
            return t.x - e.x;
        }
        function so(t, e) {
            var r = function(t, e) {
                var r, n = e, i = t.x, a = t.y, s = -1 / 0;
                do {
                    if (a <= n.y && a >= n.next.y && n.next.y !== n.y) {
                        var o = n.x + (a - n.y) * (n.next.x - n.x) / (n.next.y - n.y);
                        if (o <= i && o > s && (s = o, r = n.x < n.next.x ? n : n.next, o === i)) return r;
                    }
                    n = n.next;
                }while (n !== e);
                if (!r) return null;
                var l, u = r, c = r.x, h = r.y, p = 1 / 0;
                n = r;
                do i >= n.x && n.x >= c && i !== n.x && co(a < h ? i : s, a, c, h, a < h ? s : i, a, n.x, n.y) && (l = Math.abs(a - n.y) / (i - n.x), xo(n, t) && (l < p || l === p && (n.x > r.x || n.x === r.x && oo(r, n))) && (r = n, p = l)), n = n.next;
                while (n !== u);
                return r;
            }(t, e);
            if (!r) return e;
            var n = vo(r, t);
            return Qs(n, n.next), Qs(r, r.next);
        }
        function oo(t, e) {
            return po(t.prev, t, e.prev) < 0 && po(e.next, t, t.next) < 0;
        }
        function lo(t, e, r, n, i) {
            return (t = 1431655765 & ((t = 858993459 & ((t = 252645135 & ((t = 16711935 & ((t = (t - r) * i | 0) | t << 8)) | t << 4)) | t << 2)) | t << 1)) | (e = 1431655765 & ((e = 858993459 & ((e = 252645135 & ((e = 16711935 & ((e = (e - n) * i | 0) | e << 8)) | e << 4)) | e << 2)) | e << 1)) << 1;
        }
        function uo(t) {
            var e = t, r = t;
            do (e.x < r.x || e.x === r.x && e.y < r.y) && (r = e), e = e.next;
            while (e !== t);
            return r;
        }
        function co(t, e, r, n, i, a, s, o) {
            return (i - s) * (e - o) >= (t - s) * (a - o) && (t - s) * (n - o) >= (r - s) * (e - o) && (r - s) * (a - o) >= (i - s) * (n - o);
        }
        function ho(t, e) {
            return t.next.i !== e.i && t.prev.i !== e.i && !function(t, e) {
                var r = t;
                do {
                    if (r.i !== t.i && r.next.i !== t.i && r.i !== e.i && r.next.i !== e.i && yo(r, r.next, t, e)) return !0;
                    r = r.next;
                }while (r !== t);
                return !1;
            }(t, e) && (xo(t, e) && xo(e, t) && function(t, e) {
                var r = t, n = !1, i = (t.x + e.x) / 2, a = (t.y + e.y) / 2;
                do r.y > a != r.next.y > a && r.next.y !== r.y && i < (r.next.x - r.x) * (a - r.y) / (r.next.y - r.y) + r.x && (n = !n), r = r.next;
                while (r !== t);
                return n;
            }(t, e) && (po(t.prev, t, e.prev) || po(t, e.prev, e)) || fo(t, e) && po(t.prev, t, t.next) > 0 && po(e.prev, e, e.next) > 0);
        }
        function po(t, e, r) {
            return (e.y - t.y) * (r.x - e.x) - (e.x - t.x) * (r.y - e.y);
        }
        function fo(t, e) {
            return t.x === e.x && t.y === e.y;
        }
        function yo(t, e, r, n) {
            var i = go(po(t, e, r)), a = go(po(t, e, n)), s = go(po(r, n, t)), o = go(po(r, n, e));
            return i !== a && s !== o || !(0 !== i || !mo(t, r, e)) || !(0 !== a || !mo(t, n, e)) || !(0 !== s || !mo(r, t, n)) || !(0 !== o || !mo(r, e, n));
        }
        function mo(t, e, r) {
            return e.x <= Math.max(t.x, r.x) && e.x >= Math.min(t.x, r.x) && e.y <= Math.max(t.y, r.y) && e.y >= Math.min(t.y, r.y);
        }
        function go(t) {
            return t > 0 ? 1 : t < 0 ? -1 : 0;
        }
        function xo(t, e) {
            return po(t.prev, t, t.next) < 0 ? po(t, e, t.next) >= 0 && po(t, t.prev, e) >= 0 : po(t, e, t.prev) < 0 || po(t, t.next, e) < 0;
        }
        function vo(t, e) {
            var r = new _o(t.i, t.x, t.y), n = new _o(e.i, e.x, e.y), i = t.next, a = e.prev;
            return t.next = e, e.prev = t, r.next = i, i.prev = r, n.next = r, r.prev = n, a.next = n, n.prev = a, n;
        }
        function bo(t, e, r, n) {
            var i = new _o(t, e, r);
            return n ? (i.next = n.next, i.prev = n, n.next.prev = i, n.next = i) : (i.prev = i, i.next = i), i;
        }
        function wo(t) {
            t.next.prev = t.prev, t.prev.next = t.next, t.prevZ && (t.prevZ.nextZ = t.nextZ), t.nextZ && (t.nextZ.prevZ = t.prevZ);
        }
        function _o(t, e, r) {
            this.i = t, this.x = e, this.y = r, this.prev = null, this.next = null, this.z = 0, this.prevZ = null, this.nextZ = null, this.steiner = !1;
        }
        function Ao(t, e, r, n) {
            for(var i = 0, a = e, s = r - n; a < r; a += n)i += (t[s] - t[a]) * (t[a + 1] + t[s + 1]), s = a;
            return i;
        }
        Ys.exports = Hs, Ys.exports.default = Hs, Hs.deviation = function(t, e, r, n) {
            var i = e && e.length, a = Math.abs(Ao(t, 0, i ? e[0] * r : t.length, r));
            if (i) for(var s = 0, o = e.length; s < o; s++)a -= Math.abs(Ao(t, e[s] * r, s < o - 1 ? e[s + 1] * r : t.length, r));
            var l = 0;
            for(s = 0; s < n.length; s += 3){
                var u = n[s] * r, c = n[s + 1] * r, h = n[s + 2] * r;
                l += Math.abs((t[u] - t[h]) * (t[c + 1] - t[u + 1]) - (t[u] - t[c]) * (t[h + 1] - t[u + 1]));
            }
            return 0 === a && 0 === l ? 0 : Math.abs((l - a) / a);
        }, Hs.flatten = function(t) {
            for(var e = t[0][0].length, r = {
                vertices: [],
                holes: [],
                dimensions: e
            }, n = 0, i = 0; i < t.length; i++){
                for(var a = 0; a < t[i].length; a++)for(var s = 0; s < e; s++)r.vertices.push(t[i][a][s]);
                i > 0 && r.holes.push(n += t[i - 1].length);
            }
            return r;
        };
        var So = r(Ys.exports);
        function ko(t, e, r, n, i) {
            Io(t, e, r || 0, n || t.length - 1, i || Mo);
        }
        function Io(t, e, r, n, i) {
            for(; n > r;){
                if (n - r > 600) {
                    var a = n - r + 1, s = e - r + 1, o = Math.log(a), l = .5 * Math.exp(2 * o / 3), u = .5 * Math.sqrt(o * l * (a - l) / a) * (s - a / 2 < 0 ? -1 : 1);
                    Io(t, e, Math.max(r, Math.floor(e - s * l / a + u)), Math.min(n, Math.floor(e + (a - s) * l / a + u)), i);
                }
                var c = t[e], h = r, p = n;
                for(zo(t, r, e), i(t[n], c) > 0 && zo(t, r, n); h < p;){
                    for(zo(t, h, p), h++, p--; i(t[h], c) < 0;)h++;
                    for(; i(t[p], c) > 0;)p--;
                }
                0 === i(t[r], c) ? zo(t, r, p) : zo(t, ++p, n), p <= e && (r = p + 1), e <= p && (n = p - 1);
            }
        }
        function zo(t, e, r) {
            var n = t[e];
            t[e] = t[r], t[r] = n;
        }
        function Mo(t, e) {
            return t < e ? -1 : t > e ? 1 : 0;
        }
        function Co(t, e) {
            const r = t.length;
            if (r <= 1) return [
                t
            ];
            const n = [];
            let i, a;
            for(let e = 0; e < r; e++){
                const r = k(t[e]);
                0 !== r && (t[e].area = Math.abs(r), void 0 === a && (a = r < 0), a === r < 0 ? (i && n.push(i), i = [
                    t[e]
                ]) : i.push(t[e]));
            }
            if (i && n.push(i), e > 1) for(let t = 0; t < n.length; t++)n[t].length <= e || (ko(n[t], e, 1, n[t].length - 1, Bo), n[t] = n[t].slice(0, e));
            return n;
        }
        function Bo(t, e) {
            return e.area - t.area;
        }
        function Po(t, e, r) {
            const n = r.patternDependencies;
            let i = !1;
            for (const r of e){
                const e = r.paint.get(`${t}-pattern`);
                e.isConstant() || (i = !0);
                const a = e.constantOr(null);
                a && (i = !0, n[a.to] = !0, n[a.from] = !0);
            }
            return i;
        }
        function Vo(t, e, r, n, i) {
            const a = i.patternDependencies;
            for (const s of e){
                const e = s.paint.get(`${t}-pattern`).value;
                if ("constant" !== e.kind) {
                    let t = e.evaluate({
                        zoom: n - 1
                    }, r, {}, i.availableImages), o = e.evaluate({
                        zoom: n
                    }, r, {}, i.availableImages), l = e.evaluate({
                        zoom: n + 1
                    }, r, {}, i.availableImages);
                    t = t && t.name ? t.name : t, o = o && o.name ? o.name : o, l = l && l.name ? l.name : l, a[t] = !0, a[o] = !0, a[l] = !0, r.patterns[s.id] = {
                        min: t,
                        mid: o,
                        max: l
                    };
                }
            }
            return r;
        }
        class Eo {
            constructor(t){
                this.zoom = t.zoom, this.overscaling = t.overscaling, this.layers = t.layers, this.layerIds = this.layers.map((t)=>t.id), this.index = t.index, this.hasPattern = !1, this.patternFeatures = [], this.layoutVertexArray = new fa, this.indexArray = new Aa, this.indexArray2 = new Sa, this.programConfigurations = new Qa(t.layers, t.zoom), this.segments = new za, this.segments2 = new za, this.stateDependentLayerIds = this.layers.filter((t)=>t.isStateDependent()).map((t)=>t.id);
            }
            populate(t, e, r) {
                this.hasPattern = Po("fill", this.layers, e);
                const n = this.layers[0].layout.get("fill-sort-key"), i = !n.isConstant(), a = [];
                for (const { feature: s, id: o, index: l, sourceLayerIndex: u } of t){
                    const t = this.layers[0]._featureFilter.needGeometry, c = ss(s, t);
                    if (!this.layers[0]._featureFilter.filter(new li(this.zoom), c, r)) continue;
                    const h = i ? n.evaluate(c, {}, r, e.availableImages) : void 0, p = {
                        id: o,
                        properties: s.properties,
                        type: s.type,
                        sourceLayerIndex: u,
                        index: l,
                        geometry: t ? c.geometry : as(s),
                        patterns: {},
                        sortKey: h
                    };
                    a.push(p);
                }
                i && a.sort((t, e)=>t.sortKey - e.sortKey);
                for (const n of a){
                    const { geometry: i, index: a, sourceLayerIndex: s } = n;
                    if (this.hasPattern) {
                        const t = Vo("fill", this.layers, n, this.zoom, e);
                        this.patternFeatures.push(t);
                    } else this.addFeature(n, i, a, r, {});
                    e.featureIndex.insert(t[a].feature, i, a, s, this.index);
                }
            }
            update(t, e, r) {
                this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t, e, this.stateDependentLayers, r);
            }
            addFeatures(t, e, r) {
                for (const t of this.patternFeatures)this.addFeature(t, t.geometry, t.index, e, r);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(t) {
                this.uploaded || (this.layoutVertexBuffer = t.createVertexBuffer(this.layoutVertexArray, Xs), this.indexBuffer = t.createIndexBuffer(this.indexArray), this.indexBuffer2 = t.createIndexBuffer(this.indexArray2)), this.programConfigurations.upload(t), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.indexBuffer2.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.segments2.destroy());
            }
            addFeature(t, e, r, n, i) {
                for (const t of Co(e, 500)){
                    let e = 0;
                    for (const r of t)e += r.length;
                    const r = this.segments.prepareSegment(e, this.layoutVertexArray, this.indexArray), n = r.vertexLength, i = [], a = [];
                    for (const e of t){
                        if (0 === e.length) continue;
                        e !== t[0] && a.push(i.length / 2);
                        const r = this.segments2.prepareSegment(e.length, this.layoutVertexArray, this.indexArray2), n = r.vertexLength;
                        this.layoutVertexArray.emplaceBack(e[0].x, e[0].y), this.indexArray2.emplaceBack(n + e.length - 1, n), i.push(e[0].x), i.push(e[0].y);
                        for(let t = 1; t < e.length; t++)this.layoutVertexArray.emplaceBack(e[t].x, e[t].y), this.indexArray2.emplaceBack(n + t - 1, n + t), i.push(e[t].x), i.push(e[t].y);
                        r.vertexLength += e.length, r.primitiveLength += e.length;
                    }
                    const s = So(i, a);
                    for(let t = 0; t < s.length; t += 3)this.indexArray.emplaceBack(n + s[t], n + s[t + 1], n + s[t + 2]);
                    r.vertexLength += e, r.primitiveLength += s.length / 3;
                }
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t, r, i, n);
            }
        }
        let Fo, To;
        $n("FillBucket", Eo, {
            omit: [
                "layers",
                "patternFeatures"
            ]
        });
        var $o = {
            get paint () {
                return To = To || new _i({
                    "fill-antialias": new gi(X.paint_fill["fill-antialias"]),
                    "fill-opacity": new xi(X.paint_fill["fill-opacity"]),
                    "fill-color": new xi(X.paint_fill["fill-color"]),
                    "fill-outline-color": new xi(X.paint_fill["fill-outline-color"]),
                    "fill-translate": new gi(X.paint_fill["fill-translate"]),
                    "fill-translate-anchor": new gi(X.paint_fill["fill-translate-anchor"]),
                    "fill-pattern": new vi(X.paint_fill["fill-pattern"])
                });
            },
            get layout () {
                return Fo = Fo || new _i({
                    "fill-sort-key": new xi(X.layout_fill["fill-sort-key"])
                });
            }
        };
        class Lo extends Si {
            constructor(t){
                super(t, $o);
            }
            recalculate(t, e) {
                super.recalculate(t, e);
                const r = this.paint._values["fill-outline-color"];
                "constant" === r.value.kind && void 0 === r.value.value && (this.paint._values["fill-outline-color"] = this.paint._values["fill-color"]);
            }
            createBucket(t) {
                return new Eo(t);
            }
            queryRadius() {
                return ws(this.paint.get("fill-translate"));
            }
            queryIntersectsFeature(t, e, r, n, i, a, s) {
                return hs(_s(t, this.paint.get("fill-translate"), this.paint.get("fill-translate-anchor"), a.angle, s), n);
            }
            isTileClipped() {
                return !0;
            }
        }
        const Do = Mi([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_normal_ed",
                components: 4,
                type: "Int16"
            }
        ], 4), Oo = Mi([
            {
                name: "a_centroid",
                components: 2,
                type: "Int16"
            }
        ], 4), { members: Uo } = Do;
        var Ro = {}, qo = n, jo = No;
        function No(t, e, r, n, i) {
            this.properties = {}, this.extent = r, this.type = 0, this._pbf = t, this._geometry = -1, this._keys = n, this._values = i, t.readFields(Zo, this, e);
        }
        function Zo(t, e, r) {
            1 == t ? e.id = r.readVarint() : 2 == t ? function(t, e) {
                for(var r = t.readVarint() + t.pos; t.pos < r;){
                    var n = e._keys[t.readVarint()], i = e._values[t.readVarint()];
                    e.properties[n] = i;
                }
            }(r, e) : 3 == t ? e.type = r.readVarint() : 4 == t && (e._geometry = r.pos);
        }
        function Ko(t) {
            for(var e, r, n = 0, i = 0, a = t.length, s = a - 1; i < a; s = i++)n += ((r = t[s]).x - (e = t[i]).x) * (e.y + r.y);
            return n;
        }
        No.types = [
            "Unknown",
            "Point",
            "LineString",
            "Polygon"
        ], No.prototype.loadGeometry = function() {
            var t = this._pbf;
            t.pos = this._geometry;
            for(var e, r = t.readVarint() + t.pos, n = 1, i = 0, a = 0, s = 0, o = []; t.pos < r;){
                if (i <= 0) {
                    var l = t.readVarint();
                    n = 7 & l, i = l >> 3;
                }
                if (i--, 1 === n || 2 === n) a += t.readSVarint(), s += t.readSVarint(), 1 === n && (e && o.push(e), e = []), e.push(new qo(a, s));
                else {
                    if (7 !== n) throw new Error("unknown command " + n);
                    e && e.push(e[0].clone());
                }
            }
            return e && o.push(e), o;
        }, No.prototype.bbox = function() {
            var t = this._pbf;
            t.pos = this._geometry;
            for(var e = t.readVarint() + t.pos, r = 1, n = 0, i = 0, a = 0, s = 1 / 0, o = -1 / 0, l = 1 / 0, u = -1 / 0; t.pos < e;){
                if (n <= 0) {
                    var c = t.readVarint();
                    r = 7 & c, n = c >> 3;
                }
                if (n--, 1 === r || 2 === r) (i += t.readSVarint()) < s && (s = i), i > o && (o = i), (a += t.readSVarint()) < l && (l = a), a > u && (u = a);
                else if (7 !== r) throw new Error("unknown command " + r);
            }
            return [
                s,
                l,
                o,
                u
            ];
        }, No.prototype.toGeoJSON = function(t, e, r) {
            var n, i, a = this.extent * Math.pow(2, r), s = this.extent * t, o = this.extent * e, l = this.loadGeometry(), u = No.types[this.type];
            function c(t) {
                for(var e = 0; e < t.length; e++){
                    var r = t[e];
                    t[e] = [
                        360 * (r.x + s) / a - 180,
                        360 / Math.PI * Math.atan(Math.exp((180 - 360 * (r.y + o) / a) * Math.PI / 180)) - 90
                    ];
                }
            }
            switch(this.type){
                case 1:
                    var h = [];
                    for(n = 0; n < l.length; n++)h[n] = l[n][0];
                    c(l = h);
                    break;
                case 2:
                    for(n = 0; n < l.length; n++)c(l[n]);
                    break;
                case 3:
                    for(l = function(t) {
                        var e = t.length;
                        if (e <= 1) return [
                            t
                        ];
                        for(var r, n, i = [], a = 0; a < e; a++){
                            var s = Ko(t[a]);
                            0 !== s && (void 0 === n && (n = s < 0), n === s < 0 ? (r && i.push(r), r = [
                                t[a]
                            ]) : r.push(t[a]));
                        }
                        return r && i.push(r), i;
                    }(l), n = 0; n < l.length; n++)for(i = 0; i < l[n].length; i++)c(l[n][i]);
            }
            1 === l.length ? l = l[0] : u = "Multi" + u;
            var p = {
                type: "Feature",
                geometry: {
                    type: u,
                    coordinates: l
                },
                properties: this.properties
            };
            return "id" in this && (p.id = this.id), p;
        };
        var Go = jo, Jo = Xo;
        function Xo(t, e) {
            this.version = 1, this.name = null, this.extent = 4096, this.length = 0, this._pbf = t, this._keys = [], this._values = [], this._features = [], t.readFields(Yo, this, e), this.length = this._features.length;
        }
        function Yo(t, e, r) {
            15 === t ? e.version = r.readVarint() : 1 === t ? e.name = r.readString() : 5 === t ? e.extent = r.readVarint() : 2 === t ? e._features.push(r.pos) : 3 === t ? e._keys.push(r.readString()) : 4 === t && e._values.push(function(t) {
                for(var e = null, r = t.readVarint() + t.pos; t.pos < r;){
                    var n = t.readVarint() >> 3;
                    e = 1 === n ? t.readString() : 2 === n ? t.readFloat() : 3 === n ? t.readDouble() : 4 === n ? t.readVarint64() : 5 === n ? t.readVarint() : 6 === n ? t.readSVarint() : 7 === n ? t.readBoolean() : null;
                }
                return e;
            }(r));
        }
        Xo.prototype.feature = function(t) {
            if (t < 0 || t >= this._features.length) throw new Error("feature index out of bounds");
            this._pbf.pos = this._features[t];
            var e = this._pbf.readVarint() + this._pbf.pos;
            return new Go(this._pbf, e, this.extent, this._keys, this._values);
        };
        var Ho = Jo;
        function Wo(t, e, r) {
            if (3 === t) {
                var n = new Ho(r, r.readVarint() + r.pos);
                n.length && (e[n.name] = n);
            }
        }
        Ro.VectorTile = function(t, e) {
            this.layers = t.readFields(Wo, {}, e);
        }, Ro.VectorTileFeature = jo, Ro.VectorTileLayer = Jo;
        const Qo = Ro.VectorTileFeature.types, tl = Math.pow(2, 13);
        function el(t, e, r, n, i, a, s, o) {
            t.emplaceBack(e, r, 2 * Math.floor(n * tl) + s, i * tl * 2, a * tl * 2, Math.round(o));
        }
        class rl {
            constructor(t){
                this.zoom = t.zoom, this.overscaling = t.overscaling, this.layers = t.layers, this.layerIds = this.layers.map((t)=>t.id), this.index = t.index, this.hasPattern = !1, this.layoutVertexArray = new da, this.centroidVertexArray = new ha, this.indexArray = new Aa, this.programConfigurations = new Qa(t.layers, t.zoom), this.segments = new za, this.stateDependentLayerIds = this.layers.filter((t)=>t.isStateDependent()).map((t)=>t.id);
            }
            populate(t, e, r) {
                this.features = [], this.hasPattern = Po("fill-extrusion", this.layers, e);
                for (const { feature: n, id: i, index: a, sourceLayerIndex: s } of t){
                    const t = this.layers[0]._featureFilter.needGeometry, o = ss(n, t);
                    if (!this.layers[0]._featureFilter.filter(new li(this.zoom), o, r)) continue;
                    const l = {
                        id: i,
                        sourceLayerIndex: s,
                        index: a,
                        geometry: t ? o.geometry : as(n),
                        properties: n.properties,
                        type: n.type,
                        patterns: {}
                    };
                    this.hasPattern ? this.features.push(Vo("fill-extrusion", this.layers, l, this.zoom, e)) : this.addFeature(l, l.geometry, a, r, {}), e.featureIndex.insert(n, l.geometry, a, s, this.index, !0);
                }
            }
            addFeatures(t, e, r) {
                for (const t of this.features){
                    const { geometry: n } = t;
                    this.addFeature(t, n, t.index, e, r);
                }
            }
            update(t, e, r) {
                this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t, e, this.stateDependentLayers, r);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length && 0 === this.centroidVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(t) {
                this.uploaded || (this.layoutVertexBuffer = t.createVertexBuffer(this.layoutVertexArray, Uo), this.centroidVertexBuffer = t.createVertexBuffer(this.centroidVertexArray, Oo.members, !0), this.indexBuffer = t.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(t), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.centroidVertexBuffer.destroy());
            }
            addFeature(t, e, r, n, i) {
                const a = {
                    x: 0,
                    y: 0,
                    vertexCount: 0
                };
                for (const r of Co(e, 500)){
                    let e = 0;
                    for (const t of r)e += t.length;
                    let n = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray);
                    for (const t of r){
                        if (0 === t.length) continue;
                        if (il(t)) continue;
                        let e = 0;
                        for(let r = 0; r < t.length; r++){
                            const i = t[r];
                            if (r >= 1) {
                                const s = t[r - 1];
                                if (!nl(i, s)) {
                                    n.vertexLength + 4 > za.MAX_VERTEX_ARRAY_LENGTH && (n = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray));
                                    const t = i.sub(s)._perp()._unit(), r = s.dist(i);
                                    e + r > 32768 && (e = 0), el(this.layoutVertexArray, i.x, i.y, t.x, t.y, 0, 0, e), el(this.layoutVertexArray, i.x, i.y, t.x, t.y, 0, 1, e), a.x += 2 * i.x, a.y += 2 * i.y, a.vertexCount += 2, e += r, el(this.layoutVertexArray, s.x, s.y, t.x, t.y, 0, 0, e), el(this.layoutVertexArray, s.x, s.y, t.x, t.y, 0, 1, e), a.x += 2 * s.x, a.y += 2 * s.y, a.vertexCount += 2;
                                    const o = n.vertexLength;
                                    this.indexArray.emplaceBack(o, o + 2, o + 1), this.indexArray.emplaceBack(o + 1, o + 2, o + 3), n.vertexLength += 4, n.primitiveLength += 2;
                                }
                            }
                        }
                    }
                    if (n.vertexLength + e > za.MAX_VERTEX_ARRAY_LENGTH && (n = this.segments.prepareSegment(e, this.layoutVertexArray, this.indexArray)), "Polygon" !== Qo[t.type]) continue;
                    const i = [], s = [], o = n.vertexLength;
                    for (const t of r)if (0 !== t.length) {
                        t !== r[0] && s.push(i.length / 2);
                        for(let e = 0; e < t.length; e++){
                            const r = t[e];
                            el(this.layoutVertexArray, r.x, r.y, 0, 0, 1, 1, 0), a.x += r.x, a.y += r.y, a.vertexCount += 1, i.push(r.x), i.push(r.y);
                        }
                    }
                    const l = So(i, s);
                    for(let t = 0; t < l.length; t += 3)this.indexArray.emplaceBack(o + l[t], o + l[t + 2], o + l[t + 1]);
                    n.primitiveLength += l.length / 3, n.vertexLength += e;
                }
                for(let t = 0; t < a.vertexCount; t++)this.centroidVertexArray.emplaceBack(Math.floor(a.x / a.vertexCount), Math.floor(a.y / a.vertexCount));
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t, r, i, n);
            }
        }
        function nl(t, e) {
            return t.x === e.x && (t.x < 0 || t.x > rs) || t.y === e.y && (t.y < 0 || t.y > rs);
        }
        function il(t) {
            return t.every((t)=>t.x < 0) || t.every((t)=>t.x > rs) || t.every((t)=>t.y < 0) || t.every((t)=>t.y > rs);
        }
        let al;
        $n("FillExtrusionBucket", rl, {
            omit: [
                "layers",
                "features"
            ]
        });
        var sl = {
            get paint () {
                return al = al || new _i({
                    "fill-extrusion-opacity": new gi(X["paint_fill-extrusion"]["fill-extrusion-opacity"]),
                    "fill-extrusion-color": new xi(X["paint_fill-extrusion"]["fill-extrusion-color"]),
                    "fill-extrusion-translate": new gi(X["paint_fill-extrusion"]["fill-extrusion-translate"]),
                    "fill-extrusion-translate-anchor": new gi(X["paint_fill-extrusion"]["fill-extrusion-translate-anchor"]),
                    "fill-extrusion-pattern": new vi(X["paint_fill-extrusion"]["fill-extrusion-pattern"]),
                    "fill-extrusion-height": new xi(X["paint_fill-extrusion"]["fill-extrusion-height"]),
                    "fill-extrusion-base": new xi(X["paint_fill-extrusion"]["fill-extrusion-base"]),
                    "fill-extrusion-vertical-gradient": new gi(X["paint_fill-extrusion"]["fill-extrusion-vertical-gradient"])
                });
            }
        };
        class ol extends Si {
            constructor(t){
                super(t, sl);
            }
            createBucket(t) {
                return new rl(t);
            }
            queryRadius() {
                return ws(this.paint.get("fill-extrusion-translate"));
            }
            is3D() {
                return !0;
            }
            queryIntersectsFeature(t, e, r, n, i, s, o, l) {
                const u = _s(t, this.paint.get("fill-extrusion-translate"), this.paint.get("fill-extrusion-translate-anchor"), s.angle, o), c = this.paint.get("fill-extrusion-height").evaluate(e, r), h = this.paint.get("fill-extrusion-base").evaluate(e, r), p = function(t, e, r, n) {
                    const i = [];
                    for (const r of t){
                        const t = [
                            r.x,
                            r.y,
                            0,
                            1
                        ];
                        Vs(t, t, e), i.push(new a(t[0] / t[3], t[1] / t[3]));
                    }
                    return i;
                }(u, l), f = function(t, e, r, n) {
                    const i = [], s = [], o = n[8] * e, l = n[9] * e, u = n[10] * e, c = n[11] * e, h = n[8] * r, p = n[9] * r, f = n[10] * r, d = n[11] * r;
                    for (const e of t){
                        const t = [], r = [];
                        for (const i of e){
                            const e = i.x, s = i.y, y = n[0] * e + n[4] * s + n[12], m = n[1] * e + n[5] * s + n[13], g = n[2] * e + n[6] * s + n[14], x = n[3] * e + n[7] * s + n[15], v = g + u, b = x + c, w = y + h, _ = m + p, A = g + f, S = x + d, k = new a((y + o) / b, (m + l) / b);
                            k.z = v / b, t.push(k);
                            const I = new a(w / S, _ / S);
                            I.z = A / S, r.push(I);
                        }
                        i.push(t), s.push(r);
                    }
                    return [
                        i,
                        s
                    ];
                }(n, h, c, l);
                return function(t, e, r) {
                    let n = 1 / 0;
                    hs(r, e) && (n = ul(r, e[0]));
                    for(let i = 0; i < e.length; i++){
                        const a = e[i], s = t[i];
                        for(let t = 0; t < a.length - 1; t++){
                            const e = a[t], i = [
                                e,
                                a[t + 1],
                                s[t + 1],
                                s[t],
                                e
                            ];
                            us(r, i) && (n = Math.min(n, ul(r, i)));
                        }
                    }
                    return n !== 1 / 0 && n;
                }(f[0], f[1], p);
            }
        }
        function ll(t, e) {
            return t.x * e.x + t.y * e.y;
        }
        function ul(t, e) {
            if (1 === t.length) {
                let r = 0;
                const n = e[r++];
                let i;
                for(; !i || n.equals(i);)if (i = e[r++], !i) return 1 / 0;
                for(; r < e.length; r++){
                    const a = e[r], s = t[0], o = i.sub(n), l = a.sub(n), u = s.sub(n), c = ll(o, o), h = ll(o, l), p = ll(l, l), f = ll(u, o), d = ll(u, l), y = c * p - h * h, m = (p * f - h * d) / y, g = (c * d - h * f) / y, x = n.z * (1 - m - g) + i.z * m + a.z * g;
                    if (isFinite(x)) return x;
                }
                return 1 / 0;
            }
            {
                let t = 1 / 0;
                for (const r of e)t = Math.min(t, r.z);
                return t;
            }
        }
        const cl = Mi([
            {
                name: "a_pos_normal",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_data",
                components: 4,
                type: "Uint8"
            }
        ], 4), { members: hl } = cl, pl = Mi([
            {
                name: "a_uv_x",
                components: 1,
                type: "Float32"
            },
            {
                name: "a_split_index",
                components: 1,
                type: "Float32"
            }
        ]), { members: fl } = pl, dl = Ro.VectorTileFeature.types, yl = Math.cos(Math.PI / 180 * 37.5), ml = Math.pow(2, 14) / .5;
        class gl {
            constructor(t){
                this.zoom = t.zoom, this.overscaling = t.overscaling, this.layers = t.layers, this.layerIds = this.layers.map((t)=>t.id), this.index = t.index, this.hasPattern = !1, this.patternFeatures = [], this.lineClipsArray = [], this.gradients = {}, this.layers.forEach((t)=>{
                    this.gradients[t.id] = {};
                }), this.layoutVertexArray = new ya, this.layoutVertexArray2 = new ma, this.indexArray = new Aa, this.programConfigurations = new Qa(t.layers, t.zoom), this.segments = new za, this.maxLineLength = 0, this.stateDependentLayerIds = this.layers.filter((t)=>t.isStateDependent()).map((t)=>t.id);
            }
            populate(t, e, r) {
                this.hasPattern = Po("line", this.layers, e);
                const n = this.layers[0].layout.get("line-sort-key"), i = !n.isConstant(), a = [];
                for (const { feature: e, id: s, index: o, sourceLayerIndex: l } of t){
                    const t = this.layers[0]._featureFilter.needGeometry, u = ss(e, t);
                    if (!this.layers[0]._featureFilter.filter(new li(this.zoom), u, r)) continue;
                    const c = i ? n.evaluate(u, {}, r) : void 0, h = {
                        id: s,
                        properties: e.properties,
                        type: e.type,
                        sourceLayerIndex: l,
                        index: o,
                        geometry: t ? u.geometry : as(e),
                        patterns: {},
                        sortKey: c
                    };
                    a.push(h);
                }
                i && a.sort((t, e)=>t.sortKey - e.sortKey);
                for (const n of a){
                    const { geometry: i, index: a, sourceLayerIndex: s } = n;
                    if (this.hasPattern) {
                        const t = Vo("line", this.layers, n, this.zoom, e);
                        this.patternFeatures.push(t);
                    } else this.addFeature(n, i, a, r, {});
                    e.featureIndex.insert(t[a].feature, i, a, s, this.index);
                }
            }
            update(t, e, r) {
                this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t, e, this.stateDependentLayers, r);
            }
            addFeatures(t, e, r) {
                for (const t of this.patternFeatures)this.addFeature(t, t.geometry, t.index, e, r);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(t) {
                this.uploaded || (0 !== this.layoutVertexArray2.length && (this.layoutVertexBuffer2 = t.createVertexBuffer(this.layoutVertexArray2, fl)), this.layoutVertexBuffer = t.createVertexBuffer(this.layoutVertexArray, hl), this.indexBuffer = t.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(t), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
            }
            lineFeatureClips(t) {
                if (t.properties && Object.prototype.hasOwnProperty.call(t.properties, "mapbox_clip_start") && Object.prototype.hasOwnProperty.call(t.properties, "mapbox_clip_end")) return {
                    start: +t.properties.mapbox_clip_start,
                    end: +t.properties.mapbox_clip_end
                };
            }
            addFeature(t, e, r, n, i) {
                const a = this.layers[0].layout, s = a.get("line-join").evaluate(t, {}), o = a.get("line-cap"), l = a.get("line-miter-limit"), u = a.get("line-round-limit");
                this.lineClips = this.lineFeatureClips(t);
                for (const r of e)this.addLine(r, t, s, o, l, u);
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t, r, i, n);
            }
            addLine(t, e, r, n, i, a) {
                if (this.distance = 0, this.scaledDistance = 0, this.totalDistance = 0, this.lineClips) {
                    this.lineClipsArray.push(this.lineClips);
                    for(let e = 0; e < t.length - 1; e++)this.totalDistance += t[e].dist(t[e + 1]);
                    this.updateScaledDistance(), this.maxLineLength = Math.max(this.maxLineLength, this.totalDistance);
                }
                const s = "Polygon" === dl[e.type];
                let o = t.length;
                for(; o >= 2 && t[o - 1].equals(t[o - 2]);)o--;
                let l = 0;
                for(; l < o - 1 && t[l].equals(t[l + 1]);)l++;
                if (o < (s ? 3 : 2)) return;
                "bevel" === r && (i = 1.05);
                const u = this.overscaling <= 16 ? 15 * rs / (512 * this.overscaling) : 0, c = this.segments.prepareSegment(10 * o, this.layoutVertexArray, this.indexArray);
                let h, p, f, d, y;
                this.e1 = this.e2 = -1, s && (h = t[o - 2], y = t[l].sub(h)._unit()._perp());
                for(let e = l; e < o; e++){
                    if (f = e === o - 1 ? s ? t[l + 1] : void 0 : t[e + 1], f && t[e].equals(f)) continue;
                    y && (d = y), h && (p = h), h = t[e], y = f ? f.sub(h)._unit()._perp() : d, d = d || y;
                    let m = d.add(y);
                    0 === m.x && 0 === m.y || m._unit();
                    const g = d.x * y.x + d.y * y.y, x = m.x * y.x + m.y * y.y, v = 0 !== x ? 1 / x : 1 / 0, b = 2 * Math.sqrt(2 - 2 * x), w = x < yl && p && f, _ = d.x * y.y - d.y * y.x > 0;
                    if (w && e > l) {
                        const t = h.dist(p);
                        if (t > 2 * u) {
                            const e = h.sub(h.sub(p)._mult(u / t)._round());
                            this.updateDistance(p, e), this.addCurrentVertex(e, d, 0, 0, c), p = e;
                        }
                    }
                    const A = p && f;
                    let S = A ? r : s ? "butt" : n;
                    if (A && "round" === S && (v < a ? S = "miter" : v <= 2 && (S = "fakeround")), "miter" === S && v > i && (S = "bevel"), "bevel" === S && (v > 2 && (S = "flipbevel"), v < i && (S = "miter")), p && this.updateDistance(p, h), "miter" === S) m._mult(v), this.addCurrentVertex(h, m, 0, 0, c);
                    else if ("flipbevel" === S) {
                        if (v > 100) m = y.mult(-1);
                        else {
                            const t = v * d.add(y).mag() / d.sub(y).mag();
                            m._perp()._mult(t * (_ ? -1 : 1));
                        }
                        this.addCurrentVertex(h, m, 0, 0, c), this.addCurrentVertex(h, m.mult(-1), 0, 0, c);
                    } else if ("bevel" === S || "fakeround" === S) {
                        const t = -Math.sqrt(v * v - 1), e = _ ? t : 0, r = _ ? 0 : t;
                        if (p && this.addCurrentVertex(h, d, e, r, c), "fakeround" === S) {
                            const t = Math.round(180 * b / Math.PI / 20);
                            for(let e = 1; e < t; e++){
                                let r = e / t;
                                if (.5 !== r) {
                                    const t = r - .5;
                                    r += r * t * (r - 1) * ((1.0904 + g * (g * (3.55645 - 1.43519 * g) - 3.2452)) * t * t + (.848013 + g * (.215638 * g - 1.06021)));
                                }
                                const n = y.sub(d)._mult(r)._add(d)._unit()._mult(_ ? -1 : 1);
                                this.addHalfVertex(h, n.x, n.y, !1, _, 0, c);
                            }
                        }
                        f && this.addCurrentVertex(h, y, -e, -r, c);
                    } else if ("butt" === S) this.addCurrentVertex(h, m, 0, 0, c);
                    else if ("square" === S) {
                        const t = p ? 1 : -1;
                        this.addCurrentVertex(h, m, t, t, c);
                    } else "round" === S && (p && (this.addCurrentVertex(h, d, 0, 0, c), this.addCurrentVertex(h, d, 1, 1, c, !0)), f && (this.addCurrentVertex(h, y, -1, -1, c, !0), this.addCurrentVertex(h, y, 0, 0, c)));
                    if (w && e < o - 1) {
                        const t = h.dist(f);
                        if (t > 2 * u) {
                            const e = h.add(f.sub(h)._mult(u / t)._round());
                            this.updateDistance(h, e), this.addCurrentVertex(e, y, 0, 0, c), h = e;
                        }
                    }
                }
            }
            addCurrentVertex(t, e, r, n, i, a = !1) {
                const s = e.y * n - e.x, o = -e.y - e.x * n;
                this.addHalfVertex(t, e.x + e.y * r, e.y - e.x * r, a, !1, r, i), this.addHalfVertex(t, s, o, a, !0, -n, i), this.distance > ml / 2 && 0 === this.totalDistance && (this.distance = 0, this.updateScaledDistance(), this.addCurrentVertex(t, e, r, n, i, a));
            }
            addHalfVertex({ x: t, y: e }, r, n, i, a, s, o) {
                const l = .5 * (this.lineClips ? this.scaledDistance * (ml - 1) : this.scaledDistance);
                this.layoutVertexArray.emplaceBack((t << 1) + (i ? 1 : 0), (e << 1) + (a ? 1 : 0), Math.round(63 * r) + 128, Math.round(63 * n) + 128, 1 + (0 === s ? 0 : s < 0 ? -1 : 1) | (63 & l) << 2, l >> 6), this.lineClips && this.layoutVertexArray2.emplaceBack((this.scaledDistance - this.lineClips.start) / (this.lineClips.end - this.lineClips.start), this.lineClipsArray.length);
                const u = o.vertexLength++;
                this.e1 >= 0 && this.e2 >= 0 && (this.indexArray.emplaceBack(this.e1, this.e2, u), o.primitiveLength++), a ? this.e2 = u : this.e1 = u;
            }
            updateScaledDistance() {
                this.scaledDistance = this.lineClips ? this.lineClips.start + (this.lineClips.end - this.lineClips.start) * this.distance / this.totalDistance : this.distance;
            }
            updateDistance(t, e) {
                this.distance += t.dist(e), this.updateScaledDistance();
            }
        }
        let xl, vl;
        $n("LineBucket", gl, {
            omit: [
                "layers",
                "patternFeatures"
            ]
        });
        var bl = {
            get paint () {
                return vl = vl || new _i({
                    "line-opacity": new xi(X.paint_line["line-opacity"]),
                    "line-color": new xi(X.paint_line["line-color"]),
                    "line-translate": new gi(X.paint_line["line-translate"]),
                    "line-translate-anchor": new gi(X.paint_line["line-translate-anchor"]),
                    "line-width": new xi(X.paint_line["line-width"]),
                    "line-gap-width": new xi(X.paint_line["line-gap-width"]),
                    "line-offset": new xi(X.paint_line["line-offset"]),
                    "line-blur": new xi(X.paint_line["line-blur"]),
                    "line-dasharray": new bi(X.paint_line["line-dasharray"]),
                    "line-pattern": new vi(X.paint_line["line-pattern"]),
                    "line-gradient": new wi(X.paint_line["line-gradient"])
                });
            },
            get layout () {
                return xl = xl || new _i({
                    "line-cap": new gi(X.layout_line["line-cap"]),
                    "line-join": new xi(X.layout_line["line-join"]),
                    "line-miter-limit": new gi(X.layout_line["line-miter-limit"]),
                    "line-round-limit": new gi(X.layout_line["line-round-limit"]),
                    "line-sort-key": new xi(X.layout_line["line-sort-key"])
                });
            }
        };
        class wl extends xi {
            possiblyEvaluate(t, e) {
                return e = new li(Math.floor(e.zoom), {
                    now: e.now,
                    fadeDuration: e.fadeDuration,
                    zoomHistory: e.zoomHistory,
                    transition: e.transition
                }), super.possiblyEvaluate(t, e);
            }
            evaluate(t, e, r, n) {
                return e = g({}, e, {
                    zoom: Math.floor(e.zoom)
                }), super.evaluate(t, e, r, n);
            }
        }
        let _l;
        class Al extends Si {
            constructor(t){
                super(t, bl), this.gradientVersion = 0, _l || (_l = new wl(bl.paint.properties["line-width"].specification), _l.useIntegerZoom = !0);
            }
            _handleSpecialPaintPropertyUpdate(t) {
                if ("line-gradient" === t) {
                    const t = this.gradientExpression();
                    this.stepInterpolant = !!function(t) {
                        return void 0 !== t._styleExpression;
                    }(t) && t._styleExpression.expression instanceof qe, this.gradientVersion = (this.gradientVersion + 1) % Number.MAX_SAFE_INTEGER;
                }
            }
            gradientExpression() {
                return this._transitionablePaint._values["line-gradient"].value.expression;
            }
            recalculate(t, e) {
                super.recalculate(t, e), this.paint._values["line-floorwidth"] = _l.possiblyEvaluate(this._transitioningPaint._values["line-width"].value, t);
            }
            createBucket(t) {
                return new gl(t);
            }
            queryRadius(t) {
                const e = t, r = Sl(bs("line-width", this, e), bs("line-gap-width", this, e)), n = bs("line-offset", this, e);
                return r / 2 + Math.abs(n) + ws(this.paint.get("line-translate"));
            }
            queryIntersectsFeature(t, e, r, n, i, s, o) {
                const l = _s(t, this.paint.get("line-translate"), this.paint.get("line-translate-anchor"), s.angle, o), u = o / 2 * Sl(this.paint.get("line-width").evaluate(e, r), this.paint.get("line-gap-width").evaluate(e, r)), c = this.paint.get("line-offset").evaluate(e, r);
                return c && (n = function(t, e) {
                    const r = [];
                    for(let n = 0; n < t.length; n++){
                        const i = t[n], s = [];
                        for(let t = 0; t < i.length; t++){
                            const r = i[t - 1], n = i[t], o = i[t + 1], l = 0 === t ? new a(0, 0) : n.sub(r)._unit()._perp(), u = t === i.length - 1 ? new a(0, 0) : o.sub(n)._unit()._perp(), c = l._add(u)._unit(), h = c.x * u.x + c.y * u.y;
                            0 !== h && c._mult(1 / h), s.push(c._mult(e)._add(n));
                        }
                        r.push(s);
                    }
                    return r;
                }(n, c * o)), function(t, e, r) {
                    for(let n = 0; n < e.length; n++){
                        const i = e[n];
                        if (t.length >= 3) {
                            for(let e = 0; e < i.length; e++)if (xs(t, i[e])) return !0;
                        }
                        if (ps(t, i, r)) return !0;
                    }
                    return !1;
                }(l, n, u);
            }
            isTileClipped() {
                return !0;
            }
        }
        function Sl(t, e) {
            return e > 0 ? e + 2 * t : t;
        }
        const kl = Mi([
            {
                name: "a_pos_offset",
                components: 4,
                type: "Int16"
            },
            {
                name: "a_data",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_pixeloffset",
                components: 4,
                type: "Int16"
            }
        ], 4), Il = Mi([
            {
                name: "a_projected_pos",
                components: 3,
                type: "Float32"
            }
        ], 4);
        Mi([
            {
                name: "a_fade_opacity",
                components: 1,
                type: "Uint32"
            }
        ], 4);
        const zl = Mi([
            {
                name: "a_placed",
                components: 2,
                type: "Uint8"
            },
            {
                name: "a_shift",
                components: 2,
                type: "Float32"
            }
        ]);
        Mi([
            {
                type: "Int16",
                name: "anchorPointX"
            },
            {
                type: "Int16",
                name: "anchorPointY"
            },
            {
                type: "Int16",
                name: "x1"
            },
            {
                type: "Int16",
                name: "y1"
            },
            {
                type: "Int16",
                name: "x2"
            },
            {
                type: "Int16",
                name: "y2"
            },
            {
                type: "Uint32",
                name: "featureIndex"
            },
            {
                type: "Uint16",
                name: "sourceLayerIndex"
            },
            {
                type: "Uint16",
                name: "bucketIndex"
            }
        ]);
        const Ml = Mi([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_anchor_pos",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_extrude",
                components: 2,
                type: "Int16"
            }
        ], 4), Cl = Mi([
            {
                name: "a_pos",
                components: 2,
                type: "Float32"
            },
            {
                name: "a_radius",
                components: 1,
                type: "Float32"
            },
            {
                name: "a_flags",
                components: 2,
                type: "Int16"
            }
        ], 4);
        function Bl(t, e, r) {
            return t.sections.forEach((t)=>{
                t.text = function(t, e, r) {
                    const n = e.layout.get("text-transform").evaluate(r, {});
                    return "uppercase" === n ? t = t.toLocaleUpperCase() : "lowercase" === n && (t = t.toLocaleLowerCase()), oi.applyArabicShaping && (t = oi.applyArabicShaping(t)), t;
                }(t.text, e, r);
            }), t;
        }
        Mi([
            {
                name: "triangle",
                components: 3,
                type: "Uint16"
            }
        ]), Mi([
            {
                type: "Int16",
                name: "anchorX"
            },
            {
                type: "Int16",
                name: "anchorY"
            },
            {
                type: "Uint16",
                name: "glyphStartIndex"
            },
            {
                type: "Uint16",
                name: "numGlyphs"
            },
            {
                type: "Uint32",
                name: "vertexStartIndex"
            },
            {
                type: "Uint32",
                name: "lineStartIndex"
            },
            {
                type: "Uint32",
                name: "lineLength"
            },
            {
                type: "Uint16",
                name: "segment"
            },
            {
                type: "Uint16",
                name: "lowerSize"
            },
            {
                type: "Uint16",
                name: "upperSize"
            },
            {
                type: "Float32",
                name: "lineOffsetX"
            },
            {
                type: "Float32",
                name: "lineOffsetY"
            },
            {
                type: "Uint8",
                name: "writingMode"
            },
            {
                type: "Uint8",
                name: "placedOrientation"
            },
            {
                type: "Uint8",
                name: "hidden"
            },
            {
                type: "Uint32",
                name: "crossTileID"
            },
            {
                type: "Int16",
                name: "associatedIconIndex"
            }
        ]), Mi([
            {
                type: "Int16",
                name: "anchorX"
            },
            {
                type: "Int16",
                name: "anchorY"
            },
            {
                type: "Int16",
                name: "rightJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "centerJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "leftJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "verticalPlacedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "placedIconSymbolIndex"
            },
            {
                type: "Int16",
                name: "verticalPlacedIconSymbolIndex"
            },
            {
                type: "Uint16",
                name: "key"
            },
            {
                type: "Uint16",
                name: "textBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "textBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "verticalTextBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "verticalTextBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "iconBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "iconBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "verticalIconBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "verticalIconBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "featureIndex"
            },
            {
                type: "Uint16",
                name: "numHorizontalGlyphVertices"
            },
            {
                type: "Uint16",
                name: "numVerticalGlyphVertices"
            },
            {
                type: "Uint16",
                name: "numIconVertices"
            },
            {
                type: "Uint16",
                name: "numVerticalIconVertices"
            },
            {
                type: "Uint16",
                name: "useRuntimeCollisionCircles"
            },
            {
                type: "Uint32",
                name: "crossTileID"
            },
            {
                type: "Float32",
                name: "textBoxScale"
            },
            {
                type: "Float32",
                name: "collisionCircleDiameter"
            },
            {
                type: "Uint16",
                name: "textAnchorOffsetStartIndex"
            },
            {
                type: "Uint16",
                name: "textAnchorOffsetEndIndex"
            }
        ]), Mi([
            {
                type: "Float32",
                name: "offsetX"
            }
        ]), Mi([
            {
                type: "Int16",
                name: "x"
            },
            {
                type: "Int16",
                name: "y"
            },
            {
                type: "Int16",
                name: "tileUnitDistanceFromAnchor"
            }
        ]), Mi([
            {
                type: "Uint16",
                name: "textAnchor"
            },
            {
                type: "Float32",
                components: 2,
                name: "textOffset"
            }
        ]);
        const Pl = {
            "!": "\uFE15",
            "#": "\uFF03",
            $: "\uFF04",
            "%": "\uFF05",
            "&": "\uFF06",
            "(": "\uFE35",
            ")": "\uFE36",
            "*": "\uFF0A",
            "+": "\uFF0B",
            ",": "\uFE10",
            "-": "\uFE32",
            ".": "\u30FB",
            "/": "\uFF0F",
            ":": "\uFE13",
            ";": "\uFE14",
            "<": "\uFE3F",
            "=": "\uFF1D",
            ">": "\uFE40",
            "?": "\uFE16",
            "@": "\uFF20",
            "[": "\uFE47",
            "\\": "\uFF3C",
            "]": "\uFE48",
            "^": "\uFF3E",
            _: "\uFE33",
            "`": "\uFF40",
            "{": "\uFE37",
            "|": "\u2015",
            "}": "\uFE38",
            "~": "\uFF5E",
            "\xa2": "\uFFE0",
            "\xa3": "\uFFE1",
            "\xa5": "\uFFE5",
            "\xa6": "\uFFE4",
            "\xac": "\uFFE2",
            "\xaf": "\uFFE3",
            "\u2013": "\uFE32",
            "\u2014": "\uFE31",
            "\u2018": "\uFE43",
            "\u2019": "\uFE44",
            "\u201C": "\uFE41",
            "\u201D": "\uFE42",
            "\u2026": "\uFE19",
            "\u2027": "\u30FB",
            "\u20A9": "\uFFE6",
            "\u3001": "\uFE11",
            "\u3002": "\uFE12",
            "\u3008": "\uFE3F",
            "\u3009": "\uFE40",
            "\u300A": "\uFE3D",
            "\u300B": "\uFE3E",
            "\u300C": "\uFE41",
            "\u300D": "\uFE42",
            "\u300E": "\uFE43",
            "\u300F": "\uFE44",
            "\u3010": "\uFE3B",
            "\u3011": "\uFE3C",
            "\u3014": "\uFE39",
            "\u3015": "\uFE3A",
            "\u3016": "\uFE17",
            "\u3017": "\uFE18",
            "\uFF01": "\uFE15",
            "\uFF08": "\uFE35",
            "\uFF09": "\uFE36",
            "\uFF0C": "\uFE10",
            "\uFF0D": "\uFE32",
            "\uFF0E": "\u30FB",
            "\uFF1A": "\uFE13",
            "\uFF1B": "\uFE14",
            "\uFF1C": "\uFE3F",
            "\uFF1E": "\uFE40",
            "\uFF1F": "\uFE16",
            "\uFF3B": "\uFE47",
            "\uFF3D": "\uFE48",
            "\uFF3F": "\uFE33",
            "\uFF5B": "\uFE37",
            "\uFF5C": "\u2015",
            "\uFF5D": "\uFE38",
            "\uFF5F": "\uFE35",
            "\uFF60": "\uFE36",
            "\uFF61": "\uFE12",
            "\uFF62": "\uFE41",
            "\uFF63": "\uFE42"
        };
        var Vl = 24, El = $l, Fl = function(t, e, r, n, i) {
            var a, s, o = 8 * i - n - 1, l = (1 << o) - 1, u = l >> 1, c = -7, h = r ? i - 1 : 0, p = r ? -1 : 1, f = t[e + h];
            for(h += p, a = f & (1 << -c) - 1, f >>= -c, c += o; c > 0; a = 256 * a + t[e + h], h += p, c -= 8);
            for(s = a & (1 << -c) - 1, a >>= -c, c += n; c > 0; s = 256 * s + t[e + h], h += p, c -= 8);
            if (0 === a) a = 1 - u;
            else {
                if (a === l) return s ? NaN : 1 / 0 * (f ? -1 : 1);
                s += Math.pow(2, n), a -= u;
            }
            return (f ? -1 : 1) * s * Math.pow(2, a - n);
        }, Tl = function(t, e, r, n, i, a) {
            var s, o, l, u = 8 * a - i - 1, c = (1 << u) - 1, h = c >> 1, p = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0, f = n ? 0 : a - 1, d = n ? 1 : -1, y = e < 0 || 0 === e && 1 / e < 0 ? 1 : 0;
            for(e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (o = isNaN(e) ? 1 : 0, s = c) : (s = Math.floor(Math.log(e) / Math.LN2), e * (l = Math.pow(2, -s)) < 1 && (s--, l *= 2), (e += s + h >= 1 ? p / l : p * Math.pow(2, 1 - h)) * l >= 2 && (s++, l /= 2), s + h >= c ? (o = 0, s = c) : s + h >= 1 ? (o = (e * l - 1) * Math.pow(2, i), s += h) : (o = e * Math.pow(2, h - 1) * Math.pow(2, i), s = 0)); i >= 8; t[r + f] = 255 & o, f += d, o /= 256, i -= 8);
            for(s = s << i | o, u += i; u > 0; t[r + f] = 255 & s, f += d, s /= 256, u -= 8);
            t[r + f - d] |= 128 * y;
        };
        function $l(t) {
            this.buf = ArrayBuffer.isView && ArrayBuffer.isView(t) ? t : new Uint8Array(t || 0), this.pos = 0, this.type = 0, this.length = this.buf.length;
        }
        $l.Varint = 0, $l.Fixed64 = 1, $l.Bytes = 2, $l.Fixed32 = 5;
        var Ll = 4294967296, Dl = 1 / Ll, Ol = "undefined" == typeof TextDecoder ? null : new TextDecoder("utf8");
        function Ul(t) {
            return t.type === $l.Bytes ? t.readVarint() + t.pos : t.pos + 1;
        }
        function Rl(t, e, r) {
            return r ? 4294967296 * e + (t >>> 0) : 4294967296 * (e >>> 0) + (t >>> 0);
        }
        function ql(t, e, r) {
            var n = e <= 16383 ? 1 : e <= 2097151 ? 2 : e <= 268435455 ? 3 : Math.floor(Math.log(e) / (7 * Math.LN2));
            r.realloc(n);
            for(var i = r.pos - 1; i >= t; i--)r.buf[i + n] = r.buf[i];
        }
        function jl(t, e) {
            for(var r = 0; r < t.length; r++)e.writeVarint(t[r]);
        }
        function Nl(t, e) {
            for(var r = 0; r < t.length; r++)e.writeSVarint(t[r]);
        }
        function Zl(t, e) {
            for(var r = 0; r < t.length; r++)e.writeFloat(t[r]);
        }
        function Kl(t, e) {
            for(var r = 0; r < t.length; r++)e.writeDouble(t[r]);
        }
        function Gl(t, e) {
            for(var r = 0; r < t.length; r++)e.writeBoolean(t[r]);
        }
        function Jl(t, e) {
            for(var r = 0; r < t.length; r++)e.writeFixed32(t[r]);
        }
        function Xl(t, e) {
            for(var r = 0; r < t.length; r++)e.writeSFixed32(t[r]);
        }
        function Yl(t, e) {
            for(var r = 0; r < t.length; r++)e.writeFixed64(t[r]);
        }
        function Hl(t, e) {
            for(var r = 0; r < t.length; r++)e.writeSFixed64(t[r]);
        }
        function Wl(t, e) {
            return (t[e] | t[e + 1] << 8 | t[e + 2] << 16) + 16777216 * t[e + 3];
        }
        function Ql(t, e, r) {
            t[r] = e, t[r + 1] = e >>> 8, t[r + 2] = e >>> 16, t[r + 3] = e >>> 24;
        }
        function tu(t, e) {
            return (t[e] | t[e + 1] << 8 | t[e + 2] << 16) + (t[e + 3] << 24);
        }
        $l.prototype = {
            destroy: function() {
                this.buf = null;
            },
            readFields: function(t, e, r) {
                for(r = r || this.length; this.pos < r;){
                    var n = this.readVarint(), i = n >> 3, a = this.pos;
                    this.type = 7 & n, t(i, e, this), this.pos === a && this.skip(n);
                }
                return e;
            },
            readMessage: function(t, e) {
                return this.readFields(t, e, this.readVarint() + this.pos);
            },
            readFixed32: function() {
                var t = Wl(this.buf, this.pos);
                return this.pos += 4, t;
            },
            readSFixed32: function() {
                var t = tu(this.buf, this.pos);
                return this.pos += 4, t;
            },
            readFixed64: function() {
                var t = Wl(this.buf, this.pos) + Wl(this.buf, this.pos + 4) * Ll;
                return this.pos += 8, t;
            },
            readSFixed64: function() {
                var t = Wl(this.buf, this.pos) + tu(this.buf, this.pos + 4) * Ll;
                return this.pos += 8, t;
            },
            readFloat: function() {
                var t = Fl(this.buf, this.pos, !0, 23, 4);
                return this.pos += 4, t;
            },
            readDouble: function() {
                var t = Fl(this.buf, this.pos, !0, 52, 8);
                return this.pos += 8, t;
            },
            readVarint: function(t) {
                var e, r, n = this.buf;
                return e = 127 & (r = n[this.pos++]), r < 128 ? e : (e |= (127 & (r = n[this.pos++])) << 7, r < 128 ? e : (e |= (127 & (r = n[this.pos++])) << 14, r < 128 ? e : (e |= (127 & (r = n[this.pos++])) << 21, r < 128 ? e : function(t, e, r) {
                    var n, i, a = r.buf;
                    if (n = (112 & (i = a[r.pos++])) >> 4, i < 128) return Rl(t, n, e);
                    if (n |= (127 & (i = a[r.pos++])) << 3, i < 128) return Rl(t, n, e);
                    if (n |= (127 & (i = a[r.pos++])) << 10, i < 128) return Rl(t, n, e);
                    if (n |= (127 & (i = a[r.pos++])) << 17, i < 128) return Rl(t, n, e);
                    if (n |= (127 & (i = a[r.pos++])) << 24, i < 128) return Rl(t, n, e);
                    if (n |= (1 & (i = a[r.pos++])) << 31, i < 128) return Rl(t, n, e);
                    throw new Error("Expected varint not more than 10 bytes");
                }(e |= (15 & (r = n[this.pos])) << 28, t, this))));
            },
            readVarint64: function() {
                return this.readVarint(!0);
            },
            readSVarint: function() {
                var t = this.readVarint();
                return t % 2 == 1 ? (t + 1) / -2 : t / 2;
            },
            readBoolean: function() {
                return Boolean(this.readVarint());
            },
            readString: function() {
                var t = this.readVarint() + this.pos, e = this.pos;
                return this.pos = t, t - e >= 12 && Ol ? function(t, e, r) {
                    return Ol.decode(t.subarray(e, r));
                }(this.buf, e, t) : function(t, e, r) {
                    for(var n = "", i = e; i < r;){
                        var a, s, o, l = t[i], u = null, c = l > 239 ? 4 : l > 223 ? 3 : l > 191 ? 2 : 1;
                        if (i + c > r) break;
                        1 === c ? l < 128 && (u = l) : 2 === c ? 128 == (192 & (a = t[i + 1])) && (u = (31 & l) << 6 | 63 & a) <= 127 && (u = null) : 3 === c ? (s = t[i + 2], 128 == (192 & (a = t[i + 1])) && 128 == (192 & s) && ((u = (15 & l) << 12 | (63 & a) << 6 | 63 & s) <= 2047 || u >= 55296 && u <= 57343) && (u = null)) : 4 === c && (s = t[i + 2], o = t[i + 3], 128 == (192 & (a = t[i + 1])) && 128 == (192 & s) && 128 == (192 & o) && ((u = (15 & l) << 18 | (63 & a) << 12 | (63 & s) << 6 | 63 & o) <= 65535 || u >= 1114112) && (u = null)), null === u ? (u = 65533, c = 1) : u > 65535 && (u -= 65536, n += String.fromCharCode(u >>> 10 & 1023 | 55296), u = 56320 | 1023 & u), n += String.fromCharCode(u), i += c;
                    }
                    return n;
                }(this.buf, e, t);
            },
            readBytes: function() {
                var t = this.readVarint() + this.pos, e = this.buf.subarray(this.pos, t);
                return this.pos = t, e;
            },
            readPackedVarint: function(t, e) {
                if (this.type !== $l.Bytes) return t.push(this.readVarint(e));
                var r = Ul(this);
                for(t = t || []; this.pos < r;)t.push(this.readVarint(e));
                return t;
            },
            readPackedSVarint: function(t) {
                if (this.type !== $l.Bytes) return t.push(this.readSVarint());
                var e = Ul(this);
                for(t = t || []; this.pos < e;)t.push(this.readSVarint());
                return t;
            },
            readPackedBoolean: function(t) {
                if (this.type !== $l.Bytes) return t.push(this.readBoolean());
                var e = Ul(this);
                for(t = t || []; this.pos < e;)t.push(this.readBoolean());
                return t;
            },
            readPackedFloat: function(t) {
                if (this.type !== $l.Bytes) return t.push(this.readFloat());
                var e = Ul(this);
                for(t = t || []; this.pos < e;)t.push(this.readFloat());
                return t;
            },
            readPackedDouble: function(t) {
                if (this.type !== $l.Bytes) return t.push(this.readDouble());
                var e = Ul(this);
                for(t = t || []; this.pos < e;)t.push(this.readDouble());
                return t;
            },
            readPackedFixed32: function(t) {
                if (this.type !== $l.Bytes) return t.push(this.readFixed32());
                var e = Ul(this);
                for(t = t || []; this.pos < e;)t.push(this.readFixed32());
                return t;
            },
            readPackedSFixed32: function(t) {
                if (this.type !== $l.Bytes) return t.push(this.readSFixed32());
                var e = Ul(this);
                for(t = t || []; this.pos < e;)t.push(this.readSFixed32());
                return t;
            },
            readPackedFixed64: function(t) {
                if (this.type !== $l.Bytes) return t.push(this.readFixed64());
                var e = Ul(this);
                for(t = t || []; this.pos < e;)t.push(this.readFixed64());
                return t;
            },
            readPackedSFixed64: function(t) {
                if (this.type !== $l.Bytes) return t.push(this.readSFixed64());
                var e = Ul(this);
                for(t = t || []; this.pos < e;)t.push(this.readSFixed64());
                return t;
            },
            skip: function(t) {
                var e = 7 & t;
                if (e === $l.Varint) for(; this.buf[this.pos++] > 127;);
                else if (e === $l.Bytes) this.pos = this.readVarint() + this.pos;
                else if (e === $l.Fixed32) this.pos += 4;
                else {
                    if (e !== $l.Fixed64) throw new Error("Unimplemented type: " + e);
                    this.pos += 8;
                }
            },
            writeTag: function(t, e) {
                this.writeVarint(t << 3 | e);
            },
            realloc: function(t) {
                for(var e = this.length || 16; e < this.pos + t;)e *= 2;
                if (e !== this.length) {
                    var r = new Uint8Array(e);
                    r.set(this.buf), this.buf = r, this.length = e;
                }
            },
            finish: function() {
                return this.length = this.pos, this.pos = 0, this.buf.subarray(0, this.length);
            },
            writeFixed32: function(t) {
                this.realloc(4), Ql(this.buf, t, this.pos), this.pos += 4;
            },
            writeSFixed32: function(t) {
                this.realloc(4), Ql(this.buf, t, this.pos), this.pos += 4;
            },
            writeFixed64: function(t) {
                this.realloc(8), Ql(this.buf, -1 & t, this.pos), Ql(this.buf, Math.floor(t * Dl), this.pos + 4), this.pos += 8;
            },
            writeSFixed64: function(t) {
                this.realloc(8), Ql(this.buf, -1 & t, this.pos), Ql(this.buf, Math.floor(t * Dl), this.pos + 4), this.pos += 8;
            },
            writeVarint: function(t) {
                (t = +t || 0) > 268435455 || t < 0 ? function(t, e) {
                    var r, n;
                    if (t >= 0 ? (r = t % 4294967296 | 0, n = t / 4294967296 | 0) : (n = ~(-t / 4294967296), 4294967295 ^ (r = ~(-t % 4294967296)) ? r = r + 1 | 0 : (r = 0, n = n + 1 | 0)), t >= 0x10000000000000000 || t < -18446744073709552000) throw new Error("Given varint doesn't fit into 10 bytes");
                    e.realloc(10), function(t, e, r) {
                        r.buf[r.pos++] = 127 & t | 128, t >>>= 7, r.buf[r.pos++] = 127 & t | 128, t >>>= 7, r.buf[r.pos++] = 127 & t | 128, t >>>= 7, r.buf[r.pos++] = 127 & t | 128, r.buf[r.pos] = 127 & (t >>>= 7);
                    }(r, 0, e), function(t, e) {
                        var r = (7 & t) << 4;
                        e.buf[e.pos++] |= r | ((t >>>= 3) ? 128 : 0), t && (e.buf[e.pos++] = 127 & t | ((t >>>= 7) ? 128 : 0), t && (e.buf[e.pos++] = 127 & t | ((t >>>= 7) ? 128 : 0), t && (e.buf[e.pos++] = 127 & t | ((t >>>= 7) ? 128 : 0), t && (e.buf[e.pos++] = 127 & t | ((t >>>= 7) ? 128 : 0), t && (e.buf[e.pos++] = 127 & t)))));
                    }(n, e);
                }(t, this) : (this.realloc(4), this.buf[this.pos++] = 127 & t | (t > 127 ? 128 : 0), t <= 127 || (this.buf[this.pos++] = 127 & (t >>>= 7) | (t > 127 ? 128 : 0), t <= 127 || (this.buf[this.pos++] = 127 & (t >>>= 7) | (t > 127 ? 128 : 0), t <= 127 || (this.buf[this.pos++] = t >>> 7 & 127))));
            },
            writeSVarint: function(t) {
                this.writeVarint(t < 0 ? 2 * -t - 1 : 2 * t);
            },
            writeBoolean: function(t) {
                this.writeVarint(Boolean(t));
            },
            writeString: function(t) {
                t = String(t), this.realloc(4 * t.length), this.pos++;
                var e = this.pos;
                this.pos = function(t, e, r) {
                    for(var n, i, a = 0; a < e.length; a++){
                        if ((n = e.charCodeAt(a)) > 55295 && n < 57344) {
                            if (!i) {
                                n > 56319 || a + 1 === e.length ? (t[r++] = 239, t[r++] = 191, t[r++] = 189) : i = n;
                                continue;
                            }
                            if (n < 56320) {
                                t[r++] = 239, t[r++] = 191, t[r++] = 189, i = n;
                                continue;
                            }
                            n = i - 55296 << 10 | n - 56320 | 65536, i = null;
                        } else i && (t[r++] = 239, t[r++] = 191, t[r++] = 189, i = null);
                        n < 128 ? t[r++] = n : (n < 2048 ? t[r++] = n >> 6 | 192 : (n < 65536 ? t[r++] = n >> 12 | 224 : (t[r++] = n >> 18 | 240, t[r++] = n >> 12 & 63 | 128), t[r++] = n >> 6 & 63 | 128), t[r++] = 63 & n | 128);
                    }
                    return r;
                }(this.buf, t, this.pos);
                var r = this.pos - e;
                r >= 128 && ql(e, r, this), this.pos = e - 1, this.writeVarint(r), this.pos += r;
            },
            writeFloat: function(t) {
                this.realloc(4), Tl(this.buf, t, this.pos, !0, 23, 4), this.pos += 4;
            },
            writeDouble: function(t) {
                this.realloc(8), Tl(this.buf, t, this.pos, !0, 52, 8), this.pos += 8;
            },
            writeBytes: function(t) {
                var e = t.length;
                this.writeVarint(e), this.realloc(e);
                for(var r = 0; r < e; r++)this.buf[this.pos++] = t[r];
            },
            writeRawMessage: function(t, e) {
                this.pos++;
                var r = this.pos;
                t(e, this);
                var n = this.pos - r;
                n >= 128 && ql(r, n, this), this.pos = r - 1, this.writeVarint(n), this.pos += n;
            },
            writeMessage: function(t, e, r) {
                this.writeTag(t, $l.Bytes), this.writeRawMessage(e, r);
            },
            writePackedVarint: function(t, e) {
                e.length && this.writeMessage(t, jl, e);
            },
            writePackedSVarint: function(t, e) {
                e.length && this.writeMessage(t, Nl, e);
            },
            writePackedBoolean: function(t, e) {
                e.length && this.writeMessage(t, Gl, e);
            },
            writePackedFloat: function(t, e) {
                e.length && this.writeMessage(t, Zl, e);
            },
            writePackedDouble: function(t, e) {
                e.length && this.writeMessage(t, Kl, e);
            },
            writePackedFixed32: function(t, e) {
                e.length && this.writeMessage(t, Jl, e);
            },
            writePackedSFixed32: function(t, e) {
                e.length && this.writeMessage(t, Xl, e);
            },
            writePackedFixed64: function(t, e) {
                e.length && this.writeMessage(t, Yl, e);
            },
            writePackedSFixed64: function(t, e) {
                e.length && this.writeMessage(t, Hl, e);
            },
            writeBytesField: function(t, e) {
                this.writeTag(t, $l.Bytes), this.writeBytes(e);
            },
            writeFixed32Field: function(t, e) {
                this.writeTag(t, $l.Fixed32), this.writeFixed32(e);
            },
            writeSFixed32Field: function(t, e) {
                this.writeTag(t, $l.Fixed32), this.writeSFixed32(e);
            },
            writeFixed64Field: function(t, e) {
                this.writeTag(t, $l.Fixed64), this.writeFixed64(e);
            },
            writeSFixed64Field: function(t, e) {
                this.writeTag(t, $l.Fixed64), this.writeSFixed64(e);
            },
            writeVarintField: function(t, e) {
                this.writeTag(t, $l.Varint), this.writeVarint(e);
            },
            writeSVarintField: function(t, e) {
                this.writeTag(t, $l.Varint), this.writeSVarint(e);
            },
            writeStringField: function(t, e) {
                this.writeTag(t, $l.Bytes), this.writeString(e);
            },
            writeFloatField: function(t, e) {
                this.writeTag(t, $l.Fixed32), this.writeFloat(e);
            },
            writeDoubleField: function(t, e) {
                this.writeTag(t, $l.Fixed64), this.writeDouble(e);
            },
            writeBooleanField: function(t, e) {
                this.writeVarintField(t, Boolean(e));
            }
        };
        var eu = r(El);
        const ru = 3;
        function nu(t, e, r) {
            1 === t && r.readMessage(iu, e);
        }
        function iu(t, e, r) {
            if (3 === t) {
                const { id: t, bitmap: n, width: i, height: a, left: s, top: o, advance: l } = r.readMessage(au, {});
                e.push({
                    id: t,
                    bitmap: new Rs({
                        width: i + 2 * ru,
                        height: a + 2 * ru
                    }, n),
                    metrics: {
                        width: i,
                        height: a,
                        left: s,
                        top: o,
                        advance: l
                    }
                });
            }
        }
        function au(t, e, r) {
            1 === t ? e.id = r.readVarint() : 2 === t ? e.bitmap = r.readBytes() : 3 === t ? e.width = r.readVarint() : 4 === t ? e.height = r.readVarint() : 5 === t ? e.left = r.readSVarint() : 6 === t ? e.top = r.readSVarint() : 7 === t && (e.advance = r.readVarint());
        }
        const su = ru;
        function ou(t) {
            let e = 0, r = 0;
            for (const n of t)e += n.w * n.h, r = Math.max(r, n.w);
            t.sort((t, e)=>e.h - t.h);
            const n = [
                {
                    x: 0,
                    y: 0,
                    w: Math.max(Math.ceil(Math.sqrt(e / .95)), r),
                    h: 1 / 0
                }
            ];
            let i = 0, a = 0;
            for (const e of t)for(let t = n.length - 1; t >= 0; t--){
                const r = n[t];
                if (!(e.w > r.w || e.h > r.h)) {
                    if (e.x = r.x, e.y = r.y, a = Math.max(a, e.y + e.h), i = Math.max(i, e.x + e.w), e.w === r.w && e.h === r.h) {
                        const e = n.pop();
                        t < n.length && (n[t] = e);
                    } else e.h === r.h ? (r.x += e.w, r.w -= e.w) : e.w === r.w ? (r.y += e.h, r.h -= e.h) : (n.push({
                        x: r.x + e.w,
                        y: r.y,
                        w: r.w - e.w,
                        h: e.h
                    }), r.y += e.h, r.h -= e.h);
                    break;
                }
            }
            return {
                w: i,
                h: a,
                fill: e / (i * a) || 0
            };
        }
        const lu = 1;
        class uu {
            constructor(t, { pixelRatio: e, version: r, stretchX: n, stretchY: i, content: a }){
                this.paddedRect = t, this.pixelRatio = e, this.stretchX = n, this.stretchY = i, this.content = a, this.version = r;
            }
            get tl() {
                return [
                    this.paddedRect.x + lu,
                    this.paddedRect.y + lu
                ];
            }
            get br() {
                return [
                    this.paddedRect.x + this.paddedRect.w - lu,
                    this.paddedRect.y + this.paddedRect.h - lu
                ];
            }
            get tlbr() {
                return this.tl.concat(this.br);
            }
            get displaySize() {
                return [
                    (this.paddedRect.w - 2 * lu) / this.pixelRatio,
                    (this.paddedRect.h - 2 * lu) / this.pixelRatio
                ];
            }
        }
        class cu {
            constructor(t, e){
                const r = {}, n = {};
                this.haveRenderCallbacks = [];
                const i = [];
                this.addImages(t, r, i), this.addImages(e, n, i);
                const { w: a, h: s } = ou(i), o = new qs({
                    width: a || 1,
                    height: s || 1
                });
                for(const e in t){
                    const n = t[e], i = r[e].paddedRect;
                    qs.copy(n.data, o, {
                        x: 0,
                        y: 0
                    }, {
                        x: i.x + lu,
                        y: i.y + lu
                    }, n.data);
                }
                for(const t in e){
                    const r = e[t], i = n[t].paddedRect, a = i.x + lu, s = i.y + lu, l = r.data.width, u = r.data.height;
                    qs.copy(r.data, o, {
                        x: 0,
                        y: 0
                    }, {
                        x: a,
                        y: s
                    }, r.data), qs.copy(r.data, o, {
                        x: 0,
                        y: u - 1
                    }, {
                        x: a,
                        y: s - 1
                    }, {
                        width: l,
                        height: 1
                    }), qs.copy(r.data, o, {
                        x: 0,
                        y: 0
                    }, {
                        x: a,
                        y: s + u
                    }, {
                        width: l,
                        height: 1
                    }), qs.copy(r.data, o, {
                        x: l - 1,
                        y: 0
                    }, {
                        x: a - 1,
                        y: s
                    }, {
                        width: 1,
                        height: u
                    }), qs.copy(r.data, o, {
                        x: 0,
                        y: 0
                    }, {
                        x: a + l,
                        y: s
                    }, {
                        width: 1,
                        height: u
                    });
                }
                this.image = o, this.iconPositions = r, this.patternPositions = n;
            }
            addImages(t, e, r) {
                for(const n in t){
                    const i = t[n], a = {
                        x: 0,
                        y: 0,
                        w: i.data.width + 2 * lu,
                        h: i.data.height + 2 * lu
                    };
                    r.push(a), e[n] = new uu(a, i), i.hasRenderCallback && this.haveRenderCallbacks.push(n);
                }
            }
            patchUpdatedImages(t, e) {
                t.dispatchRenderCallbacks(this.haveRenderCallbacks);
                for(const r in t.updatedImages)this.patchUpdatedImage(this.iconPositions[r], t.getImage(r), e), this.patchUpdatedImage(this.patternPositions[r], t.getImage(r), e);
            }
            patchUpdatedImage(t, e, r) {
                if (!t || !e) return;
                if (t.version === e.version) return;
                t.version = e.version;
                const [n, i] = t.tl;
                r.update(e.data, void 0, {
                    x: n,
                    y: i
                });
            }
        }
        var hu;
        $n("ImagePosition", uu), $n("ImageAtlas", cu), t.ai = void 0, (hu = t.ai || (t.ai = {}))[hu.none = 0] = "none", hu[hu.horizontal = 1] = "horizontal", hu[hu.vertical = 2] = "vertical", hu[hu.horizontalOnly = 3] = "horizontalOnly";
        const pu = -17;
        class fu {
            constructor(){
                this.scale = 1, this.fontStack = "", this.imageName = null;
            }
            static forText(t, e) {
                const r = new fu;
                return r.scale = t || 1, r.fontStack = e, r;
            }
            static forImage(t) {
                const e = new fu;
                return e.imageName = t, e;
            }
        }
        class du {
            constructor(){
                this.text = "", this.sectionIndex = [], this.sections = [], this.imageSectionID = null;
            }
            static fromFeature(t, e) {
                const r = new du;
                for(let n = 0; n < t.sections.length; n++){
                    const i = t.sections[n];
                    i.image ? r.addImageSection(i) : r.addTextSection(i, e);
                }
                return r;
            }
            length() {
                return this.text.length;
            }
            getSection(t) {
                return this.sections[this.sectionIndex[t]];
            }
            getSectionIndex(t) {
                return this.sectionIndex[t];
            }
            getCharCode(t) {
                return this.text.charCodeAt(t);
            }
            verticalizePunctuation() {
                this.text = function(t) {
                    let e = "";
                    for(let r = 0; r < t.length; r++){
                        const n = t.charCodeAt(r + 1) || null, i = t.charCodeAt(r - 1) || null;
                        e += n && Kn(n) && !Pl[t[r + 1]] || i && Kn(i) && !Pl[t[r - 1]] || !Pl[t[r]] ? t[r] : Pl[t[r]];
                    }
                    return e;
                }(this.text);
            }
            trim() {
                let t = 0;
                for(let e = 0; e < this.text.length && mu[this.text.charCodeAt(e)]; e++)t++;
                let e = this.text.length;
                for(let r = this.text.length - 1; r >= 0 && r >= t && mu[this.text.charCodeAt(r)]; r--)e--;
                this.text = this.text.substring(t, e), this.sectionIndex = this.sectionIndex.slice(t, e);
            }
            substring(t, e) {
                const r = new du;
                return r.text = this.text.substring(t, e), r.sectionIndex = this.sectionIndex.slice(t, e), r.sections = this.sections, r;
            }
            toString() {
                return this.text;
            }
            getMaxScale() {
                return this.sectionIndex.reduce((t, e)=>Math.max(t, this.sections[e].scale), 0);
            }
            addTextSection(t, e) {
                this.text += t.text, this.sections.push(fu.forText(t.scale, t.fontStack || e));
                const r = this.sections.length - 1;
                for(let e = 0; e < t.text.length; ++e)this.sectionIndex.push(r);
            }
            addImageSection(t) {
                const e = t.image ? t.image.name : "";
                if (0 === e.length) return void A("Can't add FormattedSection with an empty image.");
                const r = this.getNextImageSectionCharCode();
                r ? (this.text += String.fromCharCode(r), this.sections.push(fu.forImage(e)), this.sectionIndex.push(this.sections.length - 1)) : A("Reached maximum number of images 6401");
            }
            getNextImageSectionCharCode() {
                return this.imageSectionID ? this.imageSectionID >= 63743 ? null : ++this.imageSectionID : (this.imageSectionID = 57344, this.imageSectionID);
            }
        }
        function yu(e, r, n, i, a, s, o, l, u, c, h, p, f, d, y, m) {
            const g = du.fromFeature(e, a);
            let x;
            p === t.ai.vertical && g.verticalizePunctuation();
            const { processBidirectionalText: v, processStyledBidirectionalText: b } = oi;
            if (v && 1 === g.sections.length) {
                x = [];
                const t = v(g.toString(), Au(g, c, s, r, i, d, y));
                for (const e of t){
                    const t = new du;
                    t.text = e, t.sections = g.sections;
                    for(let r = 0; r < e.length; r++)t.sectionIndex.push(0);
                    x.push(t);
                }
            } else if (b) {
                x = [];
                const t = b(g.text, g.sectionIndex, Au(g, c, s, r, i, d, y));
                for (const e of t){
                    const t = new du;
                    t.text = e[0], t.sectionIndex = e[1], t.sections = g.sections, x.push(t);
                }
            } else x = function(t, e) {
                const r = [], n = t.text;
                let i = 0;
                for (const n of e)r.push(t.substring(i, n)), i = n;
                return i < n.length && r.push(t.substring(i, n.length)), r;
            }(g, Au(g, c, s, r, i, d, y));
            const w = [], _ = {
                positionedLines: w,
                text: g.toString(),
                top: h[1],
                bottom: h[1],
                left: h[0],
                right: h[0],
                writingMode: p,
                iconsInText: !1,
                verticalizable: !1
            };
            return function(e, r, n, i, a, s, o, l, u, c, h, p) {
                let f = 0, d = pu, y = 0, m = 0;
                const g = "right" === l ? 1 : "left" === l ? 0 : .5;
                let x = 0;
                for (const o of a){
                    o.trim();
                    const a = o.getMaxScale(), l = (a - 1) * Vl, b = {
                        positionedGlyphs: [],
                        lineOffset: 0
                    };
                    e.positionedLines[x] = b;
                    const w = b.positionedGlyphs;
                    let _ = 0;
                    if (!o.length()) {
                        d += s, ++x;
                        continue;
                    }
                    for(let s = 0; s < o.length(); s++){
                        const y = o.getSection(s), m = o.getSectionIndex(s), g = o.getCharCode(s);
                        let x = 0, b = null, A = null, S = null, k = Vl;
                        const I = !(u === t.ai.horizontal || !h && !Zn(g) || h && (mu[g] || (v = g, Rn.Arabic(v) || Rn["Arabic Supplement"](v) || Rn["Arabic Extended-A"](v) || Rn["Arabic Presentation Forms-A"](v) || Rn["Arabic Presentation Forms-B"](v))));
                        if (y.imageName) {
                            const t = i[y.imageName];
                            if (!t) continue;
                            S = y.imageName, e.iconsInText = e.iconsInText || !0, A = t.paddedRect;
                            const r = t.displaySize;
                            y.scale = y.scale * Vl / p, b = {
                                width: r[0],
                                height: r[1],
                                left: lu,
                                top: -su,
                                advance: I ? r[1] : r[0]
                            }, x = l + (Vl - r[1] * y.scale), k = b.advance;
                            const n = I ? r[0] * y.scale - Vl * a : r[1] * y.scale - Vl * a;
                            n > 0 && n > _ && (_ = n);
                        } else {
                            const t = n[y.fontStack], e = t && t[g];
                            if (e && e.rect) A = e.rect, b = e.metrics;
                            else {
                                const t = r[y.fontStack], e = t && t[g];
                                if (!e) continue;
                                b = e.metrics;
                            }
                            x = (a - y.scale) * Vl;
                        }
                        I ? (e.verticalizable = !0, w.push({
                            glyph: g,
                            imageName: S,
                            x: f,
                            y: d + x,
                            vertical: I,
                            scale: y.scale,
                            fontStack: y.fontStack,
                            sectionIndex: m,
                            metrics: b,
                            rect: A
                        }), f += k * y.scale + c) : (w.push({
                            glyph: g,
                            imageName: S,
                            x: f,
                            y: d + x,
                            vertical: I,
                            scale: y.scale,
                            fontStack: y.fontStack,
                            sectionIndex: m,
                            metrics: b,
                            rect: A
                        }), f += b.advance * y.scale + c);
                    }
                    0 !== w.length && (y = Math.max(f - c, y), ku(w, 0, w.length - 1, g, _)), f = 0;
                    const A = s * a + _;
                    b.lineOffset = Math.max(_, l), d += A, m = Math.max(A, m), ++x;
                }
                var v;
                const b = d - pu, { horizontalAlign: w, verticalAlign: _ } = Su(o);
                (function(t, e, r, n, i, a, s, o, l) {
                    const u = (e - r) * i;
                    let c = 0;
                    c = a !== s ? -o * n - pu : (-n * l + .5) * s;
                    for (const e of t)for (const t of e.positionedGlyphs)t.x += u, t.y += c;
                })(e.positionedLines, g, w, _, y, m, s, b, a.length), e.top += -_ * b, e.bottom = e.top + b, e.left += -w * y, e.right = e.left + y;
            }(_, r, n, i, x, o, l, u, p, c, f, m), !function(t) {
                for (const e of t)if (0 !== e.positionedGlyphs.length) return !1;
                return !0;
            }(w) && _;
        }
        const mu = {
            9: !0,
            10: !0,
            11: !0,
            12: !0,
            13: !0,
            32: !0
        }, gu = {
            10: !0,
            32: !0,
            38: !0,
            40: !0,
            41: !0,
            43: !0,
            45: !0,
            47: !0,
            173: !0,
            183: !0,
            8203: !0,
            8208: !0,
            8211: !0,
            8231: !0
        };
        function xu(t, e, r, n, i, a) {
            if (e.imageName) {
                const t = n[e.imageName];
                return t ? t.displaySize[0] * e.scale * Vl / a + i : 0;
            }
            {
                const n = r[e.fontStack], a = n && n[t];
                return a ? a.metrics.advance * e.scale + i : 0;
            }
        }
        function vu(t, e, r, n) {
            const i = Math.pow(t - e, 2);
            return n ? t < e ? i / 2 : 2 * i : i + Math.abs(r) * r;
        }
        function bu(t, e, r) {
            let n = 0;
            return 10 === t && (n -= 1e4), r && (n += 150), 40 !== t && 65288 !== t || (n += 50), 41 !== e && 65289 !== e || (n += 50), n;
        }
        function wu(t, e, r, n, i, a) {
            let s = null, o = vu(e, r, i, a);
            for (const t of n){
                const n = vu(e - t.x, r, i, a) + t.badness;
                n <= o && (s = t, o = n);
            }
            return {
                index: t,
                x: e,
                priorBreak: s,
                badness: o
            };
        }
        function _u(t) {
            return t ? _u(t.priorBreak).concat(t.index) : [];
        }
        function Au(t, e, r, n, i, a, s) {
            if ("point" !== a) return [];
            if (!t) return [];
            const o = [], l = function(t, e, r, n, i, a) {
                let s = 0;
                for(let r = 0; r < t.length(); r++){
                    const o = t.getSection(r);
                    s += xu(t.getCharCode(r), o, n, i, e, a);
                }
                return s / Math.max(1, Math.ceil(s / r));
            }(t, e, r, n, i, s), u = t.text.indexOf("\u200B") >= 0;
            let c = 0;
            for(let r = 0; r < t.length(); r++){
                const a = t.getSection(r), p = t.getCharCode(r);
                if (mu[p] || (c += xu(p, a, n, i, e, s)), r < t.length() - 1) {
                    const e = !((h = p) < 11904 || !(Rn["Bopomofo Extended"](h) || Rn.Bopomofo(h) || Rn["CJK Compatibility Forms"](h) || Rn["CJK Compatibility Ideographs"](h) || Rn["CJK Compatibility"](h) || Rn["CJK Radicals Supplement"](h) || Rn["CJK Strokes"](h) || Rn["CJK Symbols and Punctuation"](h) || Rn["CJK Unified Ideographs Extension A"](h) || Rn["CJK Unified Ideographs"](h) || Rn["Enclosed CJK Letters and Months"](h) || Rn["Halfwidth and Fullwidth Forms"](h) || Rn.Hiragana(h) || Rn["Ideographic Description Characters"](h) || Rn["Kangxi Radicals"](h) || Rn["Katakana Phonetic Extensions"](h) || Rn.Katakana(h) || Rn["Vertical Forms"](h) || Rn["Yi Radicals"](h) || Rn["Yi Syllables"](h)));
                    (gu[p] || e || a.imageName) && o.push(wu(r + 1, c, l, o, bu(p, t.getCharCode(r + 1), e && u), !1));
                }
            }
            var h;
            return _u(wu(t.length(), c, l, o, 0, !0));
        }
        function Su(t) {
            let e = .5, r = .5;
            switch(t){
                case "right":
                case "top-right":
                case "bottom-right":
                    e = 1;
                    break;
                case "left":
                case "top-left":
                case "bottom-left":
                    e = 0;
            }
            switch(t){
                case "bottom":
                case "bottom-right":
                case "bottom-left":
                    r = 1;
                    break;
                case "top":
                case "top-right":
                case "top-left":
                    r = 0;
            }
            return {
                horizontalAlign: e,
                verticalAlign: r
            };
        }
        function ku(t, e, r, n, i) {
            if (!n && !i) return;
            const a = t[r], s = (t[r].x + a.metrics.advance * a.scale) * n;
            for(let n = e; n <= r; n++)t[n].x -= s, t[n].y += i;
        }
        function Iu(t, e, r) {
            const { horizontalAlign: n, verticalAlign: i } = Su(r), a = e[0] - t.displaySize[0] * n, s = e[1] - t.displaySize[1] * i;
            return {
                image: t,
                top: s,
                bottom: s + t.displaySize[1],
                left: a,
                right: a + t.displaySize[0]
            };
        }
        function zu(t, e, r, n, i, a) {
            const s = t.image;
            let o;
            if (s.content) {
                const t = s.content, e = s.pixelRatio || 1;
                o = [
                    t[0] / e,
                    t[1] / e,
                    s.displaySize[0] - t[2] / e,
                    s.displaySize[1] - t[3] / e
                ];
            }
            const l = e.left * a, u = e.right * a;
            let c, h, p, f;
            "width" === r || "both" === r ? (f = i[0] + l - n[3], h = i[0] + u + n[1]) : (f = i[0] + (l + u - s.displaySize[0]) / 2, h = f + s.displaySize[0]);
            const d = e.top * a, y = e.bottom * a;
            return "height" === r || "both" === r ? (c = i[1] + d - n[0], p = i[1] + y + n[2]) : (c = i[1] + (d + y - s.displaySize[1]) / 2, p = c + s.displaySize[1]), {
                image: s,
                top: c,
                right: h,
                bottom: p,
                left: f,
                collisionPadding: o
            };
        }
        const Mu = 255, Cu = 128, Bu = Mu * Cu;
        function Pu(t, e) {
            const { expression: r } = e;
            if ("constant" === r.kind) return {
                kind: "constant",
                layoutSize: r.evaluate(new li(t + 1))
            };
            if ("source" === r.kind) return {
                kind: "source"
            };
            {
                const { zoomStops: e, interpolationType: n } = r;
                let i = 0;
                for(; i < e.length && e[i] <= t;)i++;
                i = Math.max(0, i - 1);
                let a = i;
                for(; a < e.length && e[a] < t + 1;)a++;
                a = Math.min(e.length - 1, a);
                const s = e[i], o = e[a];
                return "composite" === r.kind ? {
                    kind: "composite",
                    minZoom: s,
                    maxZoom: o,
                    interpolationType: n
                } : {
                    kind: "camera",
                    minZoom: s,
                    maxZoom: o,
                    minSize: r.evaluate(new li(s)),
                    maxSize: r.evaluate(new li(o)),
                    interpolationType: n
                };
            }
        }
        function Vu(t, e, r) {
            let n = "never";
            const i = t.get(e);
            return i ? n = i : t.get(r) && (n = "always"), n;
        }
        const Eu = Ro.VectorTileFeature.types, Fu = [
            {
                name: "a_fade_opacity",
                components: 1,
                type: "Uint8",
                offset: 0
            }
        ];
        function Tu(t, e, r, n, i, a, s, o, l, u, c, h, p) {
            const f = o ? Math.min(Bu, Math.round(o[0])) : 0, d = o ? Math.min(Bu, Math.round(o[1])) : 0;
            t.emplaceBack(e, r, Math.round(32 * n), Math.round(32 * i), a, s, (f << 1) + (l ? 1 : 0), d, 16 * u, 16 * c, 256 * h, 256 * p);
        }
        function $u(t, e, r) {
            t.emplaceBack(e.x, e.y, r), t.emplaceBack(e.x, e.y, r), t.emplaceBack(e.x, e.y, r), t.emplaceBack(e.x, e.y, r);
        }
        function Lu(t) {
            for (const e of t.sections)if (Xn(e.text)) return !0;
            return !1;
        }
        class Du {
            constructor(t){
                this.layoutVertexArray = new xa, this.indexArray = new Aa, this.programConfigurations = t, this.segments = new za, this.dynamicLayoutVertexArray = new va, this.opacityVertexArray = new ba, this.hasVisibleVertices = !1, this.placedSymbolArray = new ra;
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length && 0 === this.indexArray.length && 0 === this.dynamicLayoutVertexArray.length && 0 === this.opacityVertexArray.length;
            }
            upload(t, e, r, n) {
                this.isEmpty() || (r && (this.layoutVertexBuffer = t.createVertexBuffer(this.layoutVertexArray, kl.members), this.indexBuffer = t.createIndexBuffer(this.indexArray, e), this.dynamicLayoutVertexBuffer = t.createVertexBuffer(this.dynamicLayoutVertexArray, Il.members, !0), this.opacityVertexBuffer = t.createVertexBuffer(this.opacityVertexArray, Fu, !0), this.opacityVertexBuffer.itemSize = 1), (r || n) && this.programConfigurations.upload(t));
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.dynamicLayoutVertexBuffer.destroy(), this.opacityVertexBuffer.destroy());
            }
        }
        $n("SymbolBuffers", Du);
        class Ou {
            constructor(t, e, r){
                this.layoutVertexArray = new t, this.layoutAttributes = e, this.indexArray = new r, this.segments = new za, this.collisionVertexArray = new _a;
            }
            upload(t) {
                this.layoutVertexBuffer = t.createVertexBuffer(this.layoutVertexArray, this.layoutAttributes), this.indexBuffer = t.createIndexBuffer(this.indexArray), this.collisionVertexBuffer = t.createVertexBuffer(this.collisionVertexArray, zl.members, !0);
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy(), this.collisionVertexBuffer.destroy());
            }
        }
        $n("CollisionBuffers", Ou);
        class Uu {
            constructor(e){
                this.collisionBoxArray = e.collisionBoxArray, this.zoom = e.zoom, this.overscaling = e.overscaling, this.layers = e.layers, this.layerIds = this.layers.map((t)=>t.id), this.index = e.index, this.pixelRatio = e.pixelRatio, this.sourceLayerIndex = e.sourceLayerIndex, this.hasPattern = !1, this.hasRTLText = !1, this.sortKeyRanges = [], this.collisionCircleArray = [], this.placementInvProjMatrix = Ms([]), this.placementViewportMatrix = Ms([]);
                const r = this.layers[0]._unevaluatedLayout._values;
                this.textSizeData = Pu(this.zoom, r["text-size"]), this.iconSizeData = Pu(this.zoom, r["icon-size"]);
                const n = this.layers[0].layout, i = n.get("symbol-sort-key"), a = n.get("symbol-z-order");
                this.canOverlap = "never" !== Vu(n, "text-overlap", "text-allow-overlap") || "never" !== Vu(n, "icon-overlap", "icon-allow-overlap") || n.get("text-ignore-placement") || n.get("icon-ignore-placement"), this.sortFeaturesByKey = "viewport-y" !== a && !i.isConstant(), this.sortFeaturesByY = ("viewport-y" === a || "auto" === a && !this.sortFeaturesByKey) && this.canOverlap, "point" === n.get("symbol-placement") && (this.writingModes = n.get("text-writing-mode").map((e)=>t.ai[e])), this.stateDependentLayerIds = this.layers.filter((t)=>t.isStateDependent()).map((t)=>t.id), this.sourceID = e.sourceID;
            }
            createArrays() {
                this.text = new Du(new Qa(this.layers, this.zoom, (t)=>/^text/.test(t))), this.icon = new Du(new Qa(this.layers, this.zoom, (t)=>/^icon/.test(t))), this.glyphOffsetArray = new aa, this.lineVertexArray = new sa, this.symbolInstances = new ia, this.textAnchorOffsets = new la;
            }
            calculateGlyphDependencies(t, e, r, n, i) {
                for(let a = 0; a < t.length; a++)if (e[t.charCodeAt(a)] = !0, (r || n) && i) {
                    const r = Pl[t.charAt(a)];
                    r && (e[r.charCodeAt(0)] = !0);
                }
            }
            populate(e, r, n) {
                const i = this.layers[0], a = i.layout, s = a.get("text-font"), o = a.get("text-field"), l = a.get("icon-image"), u = ("constant" !== o.value.kind || o.value.value instanceof Qt && !o.value.value.isEmpty() || o.value.value.toString().length > 0) && ("constant" !== s.value.kind || s.value.value.length > 0), c = "constant" !== l.value.kind || !!l.value.value || Object.keys(l.parameters).length > 0, h = a.get("symbol-sort-key");
                if (this.features = [], !u && !c) return;
                const p = r.iconDependencies, f = r.glyphDependencies, d = r.availableImages, y = new li(this.zoom);
                for (const { feature: r, id: o, index: l, sourceLayerIndex: m } of e){
                    const e = i._featureFilter.needGeometry, g = ss(r, e);
                    if (!i._featureFilter.filter(y, g, n)) continue;
                    let x, v;
                    if (e || (g.geometry = as(r)), u) {
                        const t = i.getValueAndResolveTokens("text-field", g, n, d), e = Qt.factory(t);
                        Lu(e) && (this.hasRTLText = !0), (!this.hasRTLText || "unavailable" === ai() || this.hasRTLText && oi.isParsed()) && (x = Bl(e, i, g));
                    }
                    if (c) {
                        const t = i.getValueAndResolveTokens("icon-image", g, n, d);
                        v = t instanceof ne ? t : ne.fromString(t);
                    }
                    if (!x && !v) continue;
                    const b = this.sortFeaturesByKey ? h.evaluate(g, {}, n) : void 0;
                    if (this.features.push({
                        id: o,
                        text: x,
                        icon: v,
                        index: l,
                        sourceLayerIndex: m,
                        geometry: g.geometry,
                        properties: r.properties,
                        type: Eu[r.type],
                        sortKey: b
                    }), v && (p[v.name] = !0), x) {
                        const e = s.evaluate(g, {}, n).join(","), r = "viewport" !== a.get("text-rotation-alignment") && "point" !== a.get("symbol-placement");
                        this.allowVerticalPlacement = this.writingModes && this.writingModes.indexOf(t.ai.vertical) >= 0;
                        for (const t of x.sections)if (t.image) p[t.image.name] = !0;
                        else {
                            const n = qn(x.toString()), i = t.fontStack || e, a = f[i] = f[i] || {};
                            this.calculateGlyphDependencies(t.text, a, r, this.allowVerticalPlacement, n);
                        }
                    }
                }
                "line" === a.get("symbol-placement") && (this.features = function(t) {
                    const e = {}, r = {}, n = [];
                    let i = 0;
                    function a(e) {
                        n.push(t[e]), i++;
                    }
                    function s(t, e, i) {
                        const a = r[t];
                        return delete r[t], r[e] = a, n[a].geometry[0].pop(), n[a].geometry[0] = n[a].geometry[0].concat(i[0]), a;
                    }
                    function o(t, r, i) {
                        const a = e[r];
                        return delete e[r], e[t] = a, n[a].geometry[0].shift(), n[a].geometry[0] = i[0].concat(n[a].geometry[0]), a;
                    }
                    function l(t, e, r) {
                        const n = r ? e[0][e[0].length - 1] : e[0][0];
                        return `${t}:${n.x}:${n.y}`;
                    }
                    for(let u = 0; u < t.length; u++){
                        const c = t[u], h = c.geometry, p = c.text ? c.text.toString() : null;
                        if (!p) {
                            a(u);
                            continue;
                        }
                        const f = l(p, h), d = l(p, h, !0);
                        if (f in r && d in e && r[f] !== e[d]) {
                            const t = o(f, d, h), i = s(f, d, n[t].geometry);
                            delete e[f], delete r[d], r[l(p, n[i].geometry, !0)] = i, n[t].geometry = null;
                        } else f in r ? s(f, d, h) : d in e ? o(f, d, h) : (a(u), e[f] = i - 1, r[d] = i - 1);
                    }
                    return n.filter((t)=>t.geometry);
                }(this.features)), this.sortFeaturesByKey && this.features.sort((t, e)=>t.sortKey - e.sortKey);
            }
            update(t, e, r) {
                this.stateDependentLayers.length && (this.text.programConfigurations.updatePaintArrays(t, e, this.layers, r), this.icon.programConfigurations.updatePaintArrays(t, e, this.layers, r));
            }
            isEmpty() {
                return 0 === this.symbolInstances.length && !this.hasRTLText;
            }
            uploadPending() {
                return !this.uploaded || this.text.programConfigurations.needsUpload || this.icon.programConfigurations.needsUpload;
            }
            upload(t) {
                !this.uploaded && this.hasDebugData() && (this.textCollisionBox.upload(t), this.iconCollisionBox.upload(t)), this.text.upload(t, this.sortFeaturesByY, !this.uploaded, this.text.programConfigurations.needsUpload), this.icon.upload(t, this.sortFeaturesByY, !this.uploaded, this.icon.programConfigurations.needsUpload), this.uploaded = !0;
            }
            destroyDebugData() {
                this.textCollisionBox.destroy(), this.iconCollisionBox.destroy();
            }
            destroy() {
                this.text.destroy(), this.icon.destroy(), this.hasDebugData() && this.destroyDebugData();
            }
            addToLineVertexArray(t, e) {
                const r = this.lineVertexArray.length;
                if (void 0 !== t.segment) {
                    let r = t.dist(e[t.segment + 1]), n = t.dist(e[t.segment]);
                    const i = {};
                    for(let n = t.segment + 1; n < e.length; n++)i[n] = {
                        x: e[n].x,
                        y: e[n].y,
                        tileUnitDistanceFromAnchor: r
                    }, n < e.length - 1 && (r += e[n + 1].dist(e[n]));
                    for(let r = t.segment || 0; r >= 0; r--)i[r] = {
                        x: e[r].x,
                        y: e[r].y,
                        tileUnitDistanceFromAnchor: n
                    }, r > 0 && (n += e[r - 1].dist(e[r]));
                    for(let t = 0; t < e.length; t++){
                        const e = i[t];
                        this.lineVertexArray.emplaceBack(e.x, e.y, e.tileUnitDistanceFromAnchor);
                    }
                }
                return {
                    lineStartIndex: r,
                    lineLength: this.lineVertexArray.length - r
                };
            }
            addSymbols(e, r, n, i, a, s, o, l, u, c, h, p) {
                const f = e.indexArray, d = e.layoutVertexArray, y = e.segments.prepareSegment(4 * r.length, d, f, this.canOverlap ? s.sortKey : void 0), m = this.glyphOffsetArray.length, g = y.vertexLength, x = this.allowVerticalPlacement && o === t.ai.vertical ? Math.PI / 2 : 0, v = s.text && s.text.sections;
                for(let t = 0; t < r.length; t++){
                    const { tl: i, tr: a, bl: o, br: u, tex: c, pixelOffsetTL: h, pixelOffsetBR: m, minFontScaleX: g, minFontScaleY: b, glyphOffset: w, isSDF: _, sectionIndex: A } = r[t], S = y.vertexLength, k = w[1];
                    Tu(d, l.x, l.y, i.x, k + i.y, c.x, c.y, n, _, h.x, h.y, g, b), Tu(d, l.x, l.y, a.x, k + a.y, c.x + c.w, c.y, n, _, m.x, h.y, g, b), Tu(d, l.x, l.y, o.x, k + o.y, c.x, c.y + c.h, n, _, h.x, m.y, g, b), Tu(d, l.x, l.y, u.x, k + u.y, c.x + c.w, c.y + c.h, n, _, m.x, m.y, g, b), $u(e.dynamicLayoutVertexArray, l, x), f.emplaceBack(S, S + 1, S + 2), f.emplaceBack(S + 1, S + 2, S + 3), y.vertexLength += 4, y.primitiveLength += 2, this.glyphOffsetArray.emplaceBack(w[0]), t !== r.length - 1 && A === r[t + 1].sectionIndex || e.programConfigurations.populatePaintArrays(d.length, s, s.index, {}, p, v && v[A]);
                }
                e.placedSymbolArray.emplaceBack(l.x, l.y, m, this.glyphOffsetArray.length - m, g, u, c, l.segment, n ? n[0] : 0, n ? n[1] : 0, i[0], i[1], o, 0, !1, 0, h);
            }
            _addCollisionDebugVertex(t, e, r, n, i, a) {
                return e.emplaceBack(0, 0), t.emplaceBack(r.x, r.y, n, i, Math.round(a.x), Math.round(a.y));
            }
            addCollisionDebugVertices(t, e, r, n, i, s, o) {
                const l = i.segments.prepareSegment(4, i.layoutVertexArray, i.indexArray), u = l.vertexLength, c = i.layoutVertexArray, h = i.collisionVertexArray, p = o.anchorX, f = o.anchorY;
                this._addCollisionDebugVertex(c, h, s, p, f, new a(t, e)), this._addCollisionDebugVertex(c, h, s, p, f, new a(r, e)), this._addCollisionDebugVertex(c, h, s, p, f, new a(r, n)), this._addCollisionDebugVertex(c, h, s, p, f, new a(t, n)), l.vertexLength += 4;
                const d = i.indexArray;
                d.emplaceBack(u, u + 1), d.emplaceBack(u + 1, u + 2), d.emplaceBack(u + 2, u + 3), d.emplaceBack(u + 3, u), l.primitiveLength += 4;
            }
            addDebugCollisionBoxes(t, e, r, n) {
                for(let i = t; i < e; i++){
                    const t = this.collisionBoxArray.get(i);
                    this.addCollisionDebugVertices(t.x1, t.y1, t.x2, t.y2, n ? this.textCollisionBox : this.iconCollisionBox, t.anchorPoint, r);
                }
            }
            generateCollisionDebugBuffers() {
                this.hasDebugData() && this.destroyDebugData(), this.textCollisionBox = new Ou(wa, Ml.members, Sa), this.iconCollisionBox = new Ou(wa, Ml.members, Sa);
                for(let t = 0; t < this.symbolInstances.length; t++){
                    const e = this.symbolInstances.get(t);
                    this.addDebugCollisionBoxes(e.textBoxStartIndex, e.textBoxEndIndex, e, !0), this.addDebugCollisionBoxes(e.verticalTextBoxStartIndex, e.verticalTextBoxEndIndex, e, !0), this.addDebugCollisionBoxes(e.iconBoxStartIndex, e.iconBoxEndIndex, e, !1), this.addDebugCollisionBoxes(e.verticalIconBoxStartIndex, e.verticalIconBoxEndIndex, e, !1);
                }
            }
            _deserializeCollisionBoxesForSymbol(t, e, r, n, i, a, s, o, l) {
                const u = {};
                for(let n = e; n < r; n++){
                    const e = t.get(n);
                    u.textBox = {
                        x1: e.x1,
                        y1: e.y1,
                        x2: e.x2,
                        y2: e.y2,
                        anchorPointX: e.anchorPointX,
                        anchorPointY: e.anchorPointY
                    }, u.textFeatureIndex = e.featureIndex;
                    break;
                }
                for(let e = n; e < i; e++){
                    const r = t.get(e);
                    u.verticalTextBox = {
                        x1: r.x1,
                        y1: r.y1,
                        x2: r.x2,
                        y2: r.y2,
                        anchorPointX: r.anchorPointX,
                        anchorPointY: r.anchorPointY
                    }, u.verticalTextFeatureIndex = r.featureIndex;
                    break;
                }
                for(let e = a; e < s; e++){
                    const r = t.get(e);
                    u.iconBox = {
                        x1: r.x1,
                        y1: r.y1,
                        x2: r.x2,
                        y2: r.y2,
                        anchorPointX: r.anchorPointX,
                        anchorPointY: r.anchorPointY
                    }, u.iconFeatureIndex = r.featureIndex;
                    break;
                }
                for(let e = o; e < l; e++){
                    const r = t.get(e);
                    u.verticalIconBox = {
                        x1: r.x1,
                        y1: r.y1,
                        x2: r.x2,
                        y2: r.y2,
                        anchorPointX: r.anchorPointX,
                        anchorPointY: r.anchorPointY
                    }, u.verticalIconFeatureIndex = r.featureIndex;
                    break;
                }
                return u;
            }
            deserializeCollisionBoxes(t) {
                this.collisionArrays = [];
                for(let e = 0; e < this.symbolInstances.length; e++){
                    const r = this.symbolInstances.get(e);
                    this.collisionArrays.push(this._deserializeCollisionBoxesForSymbol(t, r.textBoxStartIndex, r.textBoxEndIndex, r.verticalTextBoxStartIndex, r.verticalTextBoxEndIndex, r.iconBoxStartIndex, r.iconBoxEndIndex, r.verticalIconBoxStartIndex, r.verticalIconBoxEndIndex));
                }
            }
            hasTextData() {
                return this.text.segments.get().length > 0;
            }
            hasIconData() {
                return this.icon.segments.get().length > 0;
            }
            hasDebugData() {
                return this.textCollisionBox && this.iconCollisionBox;
            }
            hasTextCollisionBoxData() {
                return this.hasDebugData() && this.textCollisionBox.segments.get().length > 0;
            }
            hasIconCollisionBoxData() {
                return this.hasDebugData() && this.iconCollisionBox.segments.get().length > 0;
            }
            addIndicesForPlacedSymbol(t, e) {
                const r = t.placedSymbolArray.get(e), n = r.vertexStartIndex + 4 * r.numGlyphs;
                for(let e = r.vertexStartIndex; e < n; e += 4)t.indexArray.emplaceBack(e, e + 1, e + 2), t.indexArray.emplaceBack(e + 1, e + 2, e + 3);
            }
            getSortedSymbolIndexes(t) {
                if (this.sortedAngle === t && void 0 !== this.symbolInstanceIndexes) return this.symbolInstanceIndexes;
                const e = Math.sin(t), r = Math.cos(t), n = [], i = [], a = [];
                for(let t = 0; t < this.symbolInstances.length; ++t){
                    a.push(t);
                    const s = this.symbolInstances.get(t);
                    n.push(0 | Math.round(e * s.anchorX + r * s.anchorY)), i.push(s.featureIndex);
                }
                return a.sort((t, e)=>n[t] - n[e] || i[e] - i[t]), a;
            }
            addToSortKeyRanges(t, e) {
                const r = this.sortKeyRanges[this.sortKeyRanges.length - 1];
                r && r.sortKey === e ? r.symbolInstanceEnd = t + 1 : this.sortKeyRanges.push({
                    sortKey: e,
                    symbolInstanceStart: t,
                    symbolInstanceEnd: t + 1
                });
            }
            sortFeatures(t) {
                if (this.sortFeaturesByY && this.sortedAngle !== t && !(this.text.segments.get().length > 1 || this.icon.segments.get().length > 1)) {
                    this.symbolInstanceIndexes = this.getSortedSymbolIndexes(t), this.sortedAngle = t, this.text.indexArray.clear(), this.icon.indexArray.clear(), this.featureSortOrder = [];
                    for (const t of this.symbolInstanceIndexes){
                        const e = this.symbolInstances.get(t);
                        this.featureSortOrder.push(e.featureIndex), [
                            e.rightJustifiedTextSymbolIndex,
                            e.centerJustifiedTextSymbolIndex,
                            e.leftJustifiedTextSymbolIndex
                        ].forEach((t, e, r)=>{
                            t >= 0 && r.indexOf(t) === e && this.addIndicesForPlacedSymbol(this.text, t);
                        }), e.verticalPlacedTextSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.text, e.verticalPlacedTextSymbolIndex), e.placedIconSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.icon, e.placedIconSymbolIndex), e.verticalPlacedIconSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.icon, e.verticalPlacedIconSymbolIndex);
                    }
                    this.text.indexBuffer && this.text.indexBuffer.updateData(this.text.indexArray), this.icon.indexBuffer && this.icon.indexBuffer.updateData(this.icon.indexArray);
                }
            }
        }
        let Ru, qu;
        $n("SymbolBucket", Uu, {
            omit: [
                "layers",
                "collisionBoxArray",
                "features",
                "compareText"
            ]
        }), Uu.MAX_GLYPHS = 65535, Uu.addDynamicAttributes = $u;
        var ju = {
            get paint () {
                return qu = qu || new _i({
                    "icon-opacity": new xi(X.paint_symbol["icon-opacity"]),
                    "icon-color": new xi(X.paint_symbol["icon-color"]),
                    "icon-halo-color": new xi(X.paint_symbol["icon-halo-color"]),
                    "icon-halo-width": new xi(X.paint_symbol["icon-halo-width"]),
                    "icon-halo-blur": new xi(X.paint_symbol["icon-halo-blur"]),
                    "icon-translate": new gi(X.paint_symbol["icon-translate"]),
                    "icon-translate-anchor": new gi(X.paint_symbol["icon-translate-anchor"]),
                    "text-opacity": new xi(X.paint_symbol["text-opacity"]),
                    "text-color": new xi(X.paint_symbol["text-color"], {
                        runtimeType: yt,
                        getOverride: (t)=>t.textColor,
                        hasOverride: (t)=>!!t.textColor
                    }),
                    "text-halo-color": new xi(X.paint_symbol["text-halo-color"]),
                    "text-halo-width": new xi(X.paint_symbol["text-halo-width"]),
                    "text-halo-blur": new xi(X.paint_symbol["text-halo-blur"]),
                    "text-translate": new gi(X.paint_symbol["text-translate"]),
                    "text-translate-anchor": new gi(X.paint_symbol["text-translate-anchor"])
                });
            },
            get layout () {
                return Ru = Ru || new _i({
                    "symbol-placement": new gi(X.layout_symbol["symbol-placement"]),
                    "symbol-spacing": new gi(X.layout_symbol["symbol-spacing"]),
                    "symbol-avoid-edges": new gi(X.layout_symbol["symbol-avoid-edges"]),
                    "symbol-sort-key": new xi(X.layout_symbol["symbol-sort-key"]),
                    "symbol-z-order": new gi(X.layout_symbol["symbol-z-order"]),
                    "icon-allow-overlap": new gi(X.layout_symbol["icon-allow-overlap"]),
                    "icon-overlap": new gi(X.layout_symbol["icon-overlap"]),
                    "icon-ignore-placement": new gi(X.layout_symbol["icon-ignore-placement"]),
                    "icon-optional": new gi(X.layout_symbol["icon-optional"]),
                    "icon-rotation-alignment": new gi(X.layout_symbol["icon-rotation-alignment"]),
                    "icon-size": new xi(X.layout_symbol["icon-size"]),
                    "icon-text-fit": new gi(X.layout_symbol["icon-text-fit"]),
                    "icon-text-fit-padding": new gi(X.layout_symbol["icon-text-fit-padding"]),
                    "icon-image": new xi(X.layout_symbol["icon-image"]),
                    "icon-rotate": new xi(X.layout_symbol["icon-rotate"]),
                    "icon-padding": new xi(X.layout_symbol["icon-padding"]),
                    "icon-keep-upright": new gi(X.layout_symbol["icon-keep-upright"]),
                    "icon-offset": new xi(X.layout_symbol["icon-offset"]),
                    "icon-anchor": new xi(X.layout_symbol["icon-anchor"]),
                    "icon-pitch-alignment": new gi(X.layout_symbol["icon-pitch-alignment"]),
                    "text-pitch-alignment": new gi(X.layout_symbol["text-pitch-alignment"]),
                    "text-rotation-alignment": new gi(X.layout_symbol["text-rotation-alignment"]),
                    "text-field": new xi(X.layout_symbol["text-field"]),
                    "text-font": new xi(X.layout_symbol["text-font"]),
                    "text-size": new xi(X.layout_symbol["text-size"]),
                    "text-max-width": new xi(X.layout_symbol["text-max-width"]),
                    "text-line-height": new gi(X.layout_symbol["text-line-height"]),
                    "text-letter-spacing": new xi(X.layout_symbol["text-letter-spacing"]),
                    "text-justify": new xi(X.layout_symbol["text-justify"]),
                    "text-radial-offset": new xi(X.layout_symbol["text-radial-offset"]),
                    "text-variable-anchor": new gi(X.layout_symbol["text-variable-anchor"]),
                    "text-variable-anchor-offset": new xi(X.layout_symbol["text-variable-anchor-offset"]),
                    "text-anchor": new xi(X.layout_symbol["text-anchor"]),
                    "text-max-angle": new gi(X.layout_symbol["text-max-angle"]),
                    "text-writing-mode": new gi(X.layout_symbol["text-writing-mode"]),
                    "text-rotate": new xi(X.layout_symbol["text-rotate"]),
                    "text-padding": new gi(X.layout_symbol["text-padding"]),
                    "text-keep-upright": new gi(X.layout_symbol["text-keep-upright"]),
                    "text-transform": new xi(X.layout_symbol["text-transform"]),
                    "text-offset": new xi(X.layout_symbol["text-offset"]),
                    "text-allow-overlap": new gi(X.layout_symbol["text-allow-overlap"]),
                    "text-overlap": new gi(X.layout_symbol["text-overlap"]),
                    "text-ignore-placement": new gi(X.layout_symbol["text-ignore-placement"]),
                    "text-optional": new gi(X.layout_symbol["text-optional"])
                });
            }
        };
        class Nu {
            constructor(t){
                if (void 0 === t.property.overrides) throw new Error("overrides must be provided to instantiate FormatSectionOverride class");
                this.type = t.property.overrides ? t.property.overrides.runtimeType : ht, this.defaultValue = t;
            }
            evaluate(t) {
                if (t.formattedSection) {
                    const e = this.defaultValue.property.overrides;
                    if (e && e.hasOverride(t.formattedSection)) return e.getOverride(t.formattedSection);
                }
                return t.feature && t.featureState ? this.defaultValue.evaluate(t.feature, t.featureState) : this.defaultValue.property.specification.default;
            }
            eachChild(t) {
                this.defaultValue.isConstant() || t(this.defaultValue.value._styleExpression.expression);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                return null;
            }
        }
        $n("FormatSectionOverride", Nu, {
            omit: [
                "defaultValue"
            ]
        });
        class Zu extends Si {
            constructor(t){
                super(t, ju);
            }
            recalculate(t, e) {
                if (super.recalculate(t, e), "auto" === this.layout.get("icon-rotation-alignment") && (this.layout._values["icon-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-rotation-alignment") && (this.layout._values["text-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-pitch-alignment") && (this.layout._values["text-pitch-alignment"] = "map" === this.layout.get("text-rotation-alignment") ? "map" : "viewport"), "auto" === this.layout.get("icon-pitch-alignment") && (this.layout._values["icon-pitch-alignment"] = this.layout.get("icon-rotation-alignment")), "point" === this.layout.get("symbol-placement")) {
                    const t = this.layout.get("text-writing-mode");
                    if (t) {
                        const e = [];
                        for (const r of t)e.indexOf(r) < 0 && e.push(r);
                        this.layout._values["text-writing-mode"] = e;
                    } else this.layout._values["text-writing-mode"] = [
                        "horizontal"
                    ];
                }
                this._setPaintOverrides();
            }
            getValueAndResolveTokens(t, e, r, n) {
                const i = this.layout.get(t).evaluate(e, {}, r, n), a = this._unevaluatedLayout._values[t];
                return a.isDataDriven() || Tr(a.value) || !i ? i : function(t, e) {
                    return e.replace(/{([^{}]+)}/g, (e, r)=>t && r in t ? String(t[r]) : "");
                }(e.properties, i);
            }
            createBucket(t) {
                return new Uu(t);
            }
            queryRadius() {
                return 0;
            }
            queryIntersectsFeature() {
                throw new Error("Should take a different path in FeatureIndex");
            }
            _setPaintOverrides() {
                for (const t of ju.paint.overridableProperties){
                    if (!Zu.hasPaintOverride(this.layout, t)) continue;
                    const e = this.paint.get(t), r = new Nu(e), n = new Fr(r, e.property.specification);
                    let i = null;
                    i = "constant" === e.value.kind || "source" === e.value.kind ? new Lr("source", n) : new Dr("composite", n, e.value.zoomStops), this.paint._values[t] = new yi(e.property, i, e.parameters);
                }
            }
            _handleOverridablePaintPropertyUpdate(t, e, r) {
                return !(!this.layout || e.isDataDriven() || r.isDataDriven()) && Zu.hasPaintOverride(this.layout, t);
            }
            static hasPaintOverride(t, e) {
                const r = t.get("text-field"), n = ju.paint.properties[e];
                let i = !1;
                const a = (t)=>{
                    for (const e of t)if (n.overrides && n.overrides.hasOverride(e)) return void (i = !0);
                };
                if ("constant" === r.value.kind && r.value.value instanceof Qt) a(r.value.value.sections);
                else if ("source" === r.value.kind) {
                    const t = (e)=>{
                        i || (e instanceof le && se(e.value) === vt ? a(e.value.sections) : e instanceof pr ? a(e.sections) : e.eachChild(t));
                    }, e = r.value;
                    e._styleExpression && t(e._styleExpression.expression);
                }
                return i;
            }
        }
        let Ku;
        var Gu = {
            get paint () {
                return Ku = Ku || new _i({
                    "background-color": new gi(X.paint_background["background-color"]),
                    "background-pattern": new bi(X.paint_background["background-pattern"]),
                    "background-opacity": new gi(X.paint_background["background-opacity"])
                });
            }
        };
        class Ju extends Si {
            constructor(t){
                super(t, Gu);
            }
        }
        let Xu;
        var Yu = {
            get paint () {
                return Xu = Xu || new _i({
                    "raster-opacity": new gi(X.paint_raster["raster-opacity"]),
                    "raster-hue-rotate": new gi(X.paint_raster["raster-hue-rotate"]),
                    "raster-brightness-min": new gi(X.paint_raster["raster-brightness-min"]),
                    "raster-brightness-max": new gi(X.paint_raster["raster-brightness-max"]),
                    "raster-saturation": new gi(X.paint_raster["raster-saturation"]),
                    "raster-contrast": new gi(X.paint_raster["raster-contrast"]),
                    "raster-resampling": new gi(X.paint_raster["raster-resampling"]),
                    "raster-fade-duration": new gi(X.paint_raster["raster-fade-duration"])
                });
            }
        };
        class Hu extends Si {
            constructor(t){
                super(t, Yu);
            }
        }
        class Wu extends Si {
            constructor(t){
                super(t, {}), this.onAdd = (t)=>{
                    this.implementation.onAdd && this.implementation.onAdd(t, t.painter.context.gl);
                }, this.onRemove = (t)=>{
                    this.implementation.onRemove && this.implementation.onRemove(t, t.painter.context.gl);
                }, this.implementation = t;
            }
            is3D() {
                return "3d" === this.implementation.renderingMode;
            }
            hasOffscreenPass() {
                return void 0 !== this.implementation.prerender;
            }
            recalculate() {}
            updateTransitions() {}
            hasTransition() {
                return !1;
            }
            serialize() {
                throw new Error("Custom layers cannot be serialized");
            }
        }
        class Qu {
            constructor(t){
                this._callback = t, this._triggered = !1, "undefined" != typeof MessageChannel && (this._channel = new MessageChannel, this._channel.port2.onmessage = ()=>{
                    this._triggered = !1, this._callback();
                });
            }
            trigger() {
                this._triggered || (this._triggered = !0, this._channel ? this._channel.port1.postMessage(!0) : setTimeout(()=>{
                    this._triggered = !1, this._callback();
                }, 0));
            }
            remove() {
                delete this._channel, this._callback = ()=>{};
            }
        }
        const tc = 6371008.8;
        class ec {
            constructor(t, e){
                if (isNaN(t) || isNaN(e)) throw new Error(`Invalid LngLat object: (${t}, ${e})`);
                if (this.lng = +t, this.lat = +e, this.lat > 90 || this.lat < -90) throw new Error("Invalid LngLat latitude value: must be between -90 and 90");
            }
            wrap() {
                return new ec(m(this.lng, -180, 180), this.lat);
            }
            toArray() {
                return [
                    this.lng,
                    this.lat
                ];
            }
            toString() {
                return `LngLat(${this.lng}, ${this.lat})`;
            }
            distanceTo(t) {
                const e = Math.PI / 180, r = this.lat * e, n = t.lat * e, i = Math.sin(r) * Math.sin(n) + Math.cos(r) * Math.cos(n) * Math.cos((t.lng - this.lng) * e);
                return tc * Math.acos(Math.min(i, 1));
            }
            static convert(t) {
                if (t instanceof ec) return t;
                if (Array.isArray(t) && (2 === t.length || 3 === t.length)) return new ec(Number(t[0]), Number(t[1]));
                if (!Array.isArray(t) && "object" == typeof t && null !== t) return new ec(Number("lng" in t ? t.lng : t.lon), Number(t.lat));
                throw new Error("`LngLatLike` argument must be specified as a LngLat instance, an object {lng: <lng>, lat: <lat>}, an object {lon: <lng>, lat: <lat>}, or an array of [<lng>, <lat>]");
            }
        }
        const rc = 2 * Math.PI * tc;
        function nc(t) {
            return rc * Math.cos(t * Math.PI / 180);
        }
        function ic(t) {
            return (180 + t) / 360;
        }
        function ac(t) {
            return (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + t * Math.PI / 360))) / 360;
        }
        function sc(t, e) {
            return t / nc(e);
        }
        function oc(t) {
            return 360 * t - 180;
        }
        function lc(t) {
            return 360 / Math.PI * Math.atan(Math.exp((180 - 360 * t) * Math.PI / 180)) - 90;
        }
        class uc {
            constructor(t, e, r = 0){
                this.x = +t, this.y = +e, this.z = +r;
            }
            static fromLngLat(t, e = 0) {
                const r = ec.convert(t);
                return new uc(ic(r.lng), ac(r.lat), sc(e, r.lat));
            }
            toLngLat() {
                return new ec(oc(this.x), lc(this.y));
            }
            toAltitude() {
                return this.z * nc(lc(this.y));
            }
            meterInMercatorCoordinateUnits() {
                var t;
                return 1 / rc * (t = lc(this.y), 1 / Math.cos(t * Math.PI / 180));
            }
        }
        function cc(t, e, r) {
            var n = 2 * Math.PI * 6378137 / 256 / Math.pow(2, r);
            return [
                t * n - 2 * Math.PI * 6378137 / 2,
                e * n - 2 * Math.PI * 6378137 / 2
            ];
        }
        class hc {
            constructor(t, e, r){
                if (t < 0 || t > 25 || r < 0 || r >= Math.pow(2, t) || e < 0 || e >= Math.pow(2, t)) throw new Error(`x=${e}, y=${r}, z=${t} outside of bounds. 0<=x<${Math.pow(2, t)}, 0<=y<${Math.pow(2, t)} 0<=z<=25 `);
                this.z = t, this.x = e, this.y = r, this.key = dc(0, t, t, e, r);
            }
            equals(t) {
                return this.z === t.z && this.x === t.x && this.y === t.y;
            }
            url(t, e, r) {
                const n = (a = this.y, s = this.z, o = cc(256 * (i = this.x), 256 * (a = Math.pow(2, s) - a - 1), s), l = cc(256 * (i + 1), 256 * (a + 1), s), o[0] + "," + o[1] + "," + l[0] + "," + l[1]);
                var i, a, s, o, l;
                const u = function(t, e, r) {
                    let n, i = "";
                    for(let a = t; a > 0; a--)n = 1 << a - 1, i += (e & n ? 1 : 0) + (r & n ? 2 : 0);
                    return i;
                }(this.z, this.x, this.y);
                return t[(this.x + this.y) % t.length].replace(/{prefix}/g, (this.x % 16).toString(16) + (this.y % 16).toString(16)).replace(/{z}/g, String(this.z)).replace(/{x}/g, String(this.x)).replace(/{y}/g, String("tms" === r ? Math.pow(2, this.z) - this.y - 1 : this.y)).replace(/{ratio}/g, e > 1 ? "@2x" : "").replace(/{quadkey}/g, u).replace(/{bbox-epsg-3857}/g, n);
            }
            isChildOf(t) {
                const e = this.z - t.z;
                return e > 0 && t.x === this.x >> e && t.y === this.y >> e;
            }
            getTilePoint(t) {
                const e = Math.pow(2, this.z);
                return new a((t.x * e - this.x) * rs, (t.y * e - this.y) * rs);
            }
            toString() {
                return `${this.z}/${this.x}/${this.y}`;
            }
        }
        class pc {
            constructor(t, e){
                this.wrap = t, this.canonical = e, this.key = dc(t, e.z, e.z, e.x, e.y);
            }
        }
        class fc {
            constructor(t, e, r, n, i){
                if (t < r) throw new Error(`overscaledZ should be >= z; overscaledZ = ${t}; z = ${r}`);
                this.overscaledZ = t, this.wrap = e, this.canonical = new hc(r, +n, +i), this.key = dc(e, t, r, n, i);
            }
            clone() {
                return new fc(this.overscaledZ, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y);
            }
            equals(t) {
                return this.overscaledZ === t.overscaledZ && this.wrap === t.wrap && this.canonical.equals(t.canonical);
            }
            scaledTo(t) {
                if (t > this.overscaledZ) throw new Error(`targetZ > this.overscaledZ; targetZ = ${t}; overscaledZ = ${this.overscaledZ}`);
                const e = this.canonical.z - t;
                return t > this.canonical.z ? new fc(t, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y) : new fc(t, this.wrap, t, this.canonical.x >> e, this.canonical.y >> e);
            }
            calculateScaledKey(t, e) {
                if (t > this.overscaledZ) throw new Error(`targetZ > this.overscaledZ; targetZ = ${t}; overscaledZ = ${this.overscaledZ}`);
                const r = this.canonical.z - t;
                return t > this.canonical.z ? dc(this.wrap * +e, t, this.canonical.z, this.canonical.x, this.canonical.y) : dc(this.wrap * +e, t, t, this.canonical.x >> r, this.canonical.y >> r);
            }
            isChildOf(t) {
                if (t.wrap !== this.wrap) return !1;
                const e = this.canonical.z - t.canonical.z;
                return 0 === t.overscaledZ || t.overscaledZ < this.overscaledZ && t.canonical.x === this.canonical.x >> e && t.canonical.y === this.canonical.y >> e;
            }
            children(t) {
                if (this.overscaledZ >= t) return [
                    new fc(this.overscaledZ + 1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y)
                ];
                const e = this.canonical.z + 1, r = 2 * this.canonical.x, n = 2 * this.canonical.y;
                return [
                    new fc(e, this.wrap, e, r, n),
                    new fc(e, this.wrap, e, r + 1, n),
                    new fc(e, this.wrap, e, r, n + 1),
                    new fc(e, this.wrap, e, r + 1, n + 1)
                ];
            }
            isLessThan(t) {
                return this.wrap < t.wrap || !(this.wrap > t.wrap) && (this.overscaledZ < t.overscaledZ || !(this.overscaledZ > t.overscaledZ) && (this.canonical.x < t.canonical.x || !(this.canonical.x > t.canonical.x) && this.canonical.y < t.canonical.y));
            }
            wrapped() {
                return new fc(this.overscaledZ, 0, this.canonical.z, this.canonical.x, this.canonical.y);
            }
            unwrapTo(t) {
                return new fc(this.overscaledZ, t, this.canonical.z, this.canonical.x, this.canonical.y);
            }
            overscaleFactor() {
                return Math.pow(2, this.overscaledZ - this.canonical.z);
            }
            toUnwrapped() {
                return new pc(this.wrap, this.canonical);
            }
            toString() {
                return `${this.overscaledZ}/${this.canonical.x}/${this.canonical.y}`;
            }
            getTilePoint(t) {
                return this.canonical.getTilePoint(new uc(t.x - this.wrap, t.y));
            }
        }
        function dc(t, e, r, n, i) {
            (t *= 2) < 0 && (t = -1 * t - 1);
            const a = 1 << r;
            return (a * a * t + a * i + n).toString(36) + r.toString(36) + e.toString(36);
        }
        $n("CanonicalTileID", hc), $n("OverscaledTileID", fc, {
            omit: [
                "posMatrix"
            ]
        });
        class yc {
            constructor(t, e, r, n = 1, i = 1, a = 1, s = 0){
                if (this.uid = t, e.height !== e.width) throw new RangeError("DEM tiles must be square");
                if (r && ![
                    "mapbox",
                    "terrarium",
                    "custom"
                ].includes(r)) return void A(`"${r}" is not a valid encoding type. Valid types include "mapbox", "terrarium" and "custom".`);
                this.stride = e.height;
                const o = this.dim = e.height - 2;
                switch(this.data = new Uint32Array(e.data.buffer), r){
                    case "terrarium":
                        this.redFactor = 256, this.greenFactor = 1, this.blueFactor = 1 / 256, this.baseShift = 32768;
                        break;
                    case "custom":
                        this.redFactor = n, this.greenFactor = i, this.blueFactor = a, this.baseShift = s;
                        break;
                    default:
                        this.redFactor = 6553.6, this.greenFactor = 25.6, this.blueFactor = .1, this.baseShift = 1e4;
                }
                for(let t = 0; t < o; t++)this.data[this._idx(-1, t)] = this.data[this._idx(0, t)], this.data[this._idx(o, t)] = this.data[this._idx(o - 1, t)], this.data[this._idx(t, -1)] = this.data[this._idx(t, 0)], this.data[this._idx(t, o)] = this.data[this._idx(t, o - 1)];
                this.data[this._idx(-1, -1)] = this.data[this._idx(0, 0)], this.data[this._idx(o, -1)] = this.data[this._idx(o - 1, 0)], this.data[this._idx(-1, o)] = this.data[this._idx(0, o - 1)], this.data[this._idx(o, o)] = this.data[this._idx(o - 1, o - 1)], this.min = Number.MAX_SAFE_INTEGER, this.max = Number.MIN_SAFE_INTEGER;
                for(let t = 0; t < o; t++)for(let e = 0; e < o; e++){
                    const r = this.get(t, e);
                    r > this.max && (this.max = r), r < this.min && (this.min = r);
                }
            }
            get(t, e) {
                const r = new Uint8Array(this.data.buffer), n = 4 * this._idx(t, e);
                return this.unpack(r[n], r[n + 1], r[n + 2]);
            }
            getUnpackVector() {
                return [
                    this.redFactor,
                    this.greenFactor,
                    this.blueFactor,
                    this.baseShift
                ];
            }
            _idx(t, e) {
                if (t < -1 || t >= this.dim + 1 || e < -1 || e >= this.dim + 1) throw new RangeError("out of range source coordinates for DEM data");
                return (e + 1) * this.stride + (t + 1);
            }
            unpack(t, e, r) {
                return t * this.redFactor + e * this.greenFactor + r * this.blueFactor - this.baseShift;
            }
            getPixels() {
                return new qs({
                    width: this.stride,
                    height: this.stride
                }, new Uint8Array(this.data.buffer));
            }
            backfillBorder(t, e, r) {
                if (this.dim !== t.dim) throw new Error("dem dimension mismatch");
                let n = e * this.dim, i = e * this.dim + this.dim, a = r * this.dim, s = r * this.dim + this.dim;
                switch(e){
                    case -1:
                        n = i - 1;
                        break;
                    case 1:
                        i = n + 1;
                }
                switch(r){
                    case -1:
                        a = s - 1;
                        break;
                    case 1:
                        s = a + 1;
                }
                const o = -e * this.dim, l = -r * this.dim;
                for(let e = a; e < s; e++)for(let r = n; r < i; r++)this.data[this._idx(r, e)] = t.data[this._idx(r + o, e + l)];
            }
        }
        $n("DEMData", yc);
        class mc {
            constructor(t){
                this._stringToNumber = {}, this._numberToString = [];
                for(let e = 0; e < t.length; e++){
                    const r = t[e];
                    this._stringToNumber[r] = e, this._numberToString[e] = r;
                }
            }
            encode(t) {
                return this._stringToNumber[t];
            }
            decode(t) {
                if (t >= this._numberToString.length) throw new Error(`Out of bounds. Index requested n=${t} can't be >= this._numberToString.length ${this._numberToString.length}`);
                return this._numberToString[t];
            }
        }
        class gc {
            constructor(t, e, r, n, i){
                this.type = "Feature", this._vectorTileFeature = t, t._z = e, t._x = r, t._y = n, this.properties = t.properties, this.id = i;
            }
            get geometry() {
                return void 0 === this._geometry && (this._geometry = this._vectorTileFeature.toGeoJSON(this._vectorTileFeature._x, this._vectorTileFeature._y, this._vectorTileFeature._z).geometry), this._geometry;
            }
            set geometry(t) {
                this._geometry = t;
            }
            toJSON() {
                const t = {
                    geometry: this.geometry
                };
                for(const e in this)"_geometry" !== e && "_vectorTileFeature" !== e && (t[e] = this[e]);
                return t;
            }
        }
        class xc {
            constructor(t, e){
                this.tileID = t, this.x = t.canonical.x, this.y = t.canonical.y, this.z = t.canonical.z, this.grid = new Fn(rs, 16, 0), this.grid3D = new Fn(rs, 16, 0), this.featureIndexArray = new ca, this.promoteId = e;
            }
            insert(t, e, r, n, i, a) {
                const s = this.featureIndexArray.length;
                this.featureIndexArray.emplaceBack(r, n, i);
                const o = a ? this.grid3D : this.grid;
                for(let t = 0; t < e.length; t++){
                    const r = e[t], n = [
                        1 / 0,
                        1 / 0,
                        -1 / 0,
                        -1 / 0
                    ];
                    for(let t = 0; t < r.length; t++){
                        const e = r[t];
                        n[0] = Math.min(n[0], e.x), n[1] = Math.min(n[1], e.y), n[2] = Math.max(n[2], e.x), n[3] = Math.max(n[3], e.y);
                    }
                    n[0] < rs && n[1] < rs && n[2] >= 0 && n[3] >= 0 && o.insert(s, n[0], n[1], n[2], n[3]);
                }
            }
            loadVTLayers() {
                return this.vtLayers || (this.vtLayers = new Ro.VectorTile(new eu(this.rawTileData)).layers, this.sourceLayerCoder = new mc(this.vtLayers ? Object.keys(this.vtLayers).sort() : [
                    "_geojsonTileLayer"
                ])), this.vtLayers;
            }
            query(t, e, r, n) {
                this.loadVTLayers();
                const i = t.params || {}, s = rs / t.tileSize / t.scale, o = Nr(i.filter), l = t.queryGeometry, u = t.queryPadding * s, c = bc(l), h = this.grid.query(c.minX - u, c.minY - u, c.maxX + u, c.maxY + u), p = bc(t.cameraQueryGeometry), f = this.grid3D.query(p.minX - u, p.minY - u, p.maxX + u, p.maxY + u, (e, r, n, i)=>(function(t, e, r, n, i) {
                        for (const a of t)if (e <= a.x && r <= a.y && n >= a.x && i >= a.y) return !0;
                        const s = [
                            new a(e, r),
                            new a(e, i),
                            new a(n, i),
                            new a(n, r)
                        ];
                        if (t.length > 2) {
                            for (const e of s)if (xs(t, e)) return !0;
                        }
                        for(let e = 0; e < t.length - 1; e++)if (vs(t[e], t[e + 1], s)) return !0;
                        return !1;
                    })(t.cameraQueryGeometry, e - u, r - u, n + u, i + u));
                for (const t of f)h.push(t);
                h.sort(wc);
                const d = {};
                let y;
                for(let a = 0; a < h.length; a++){
                    const u = h[a];
                    if (u === y) continue;
                    y = u;
                    const c = this.featureIndexArray.get(u);
                    let p = null;
                    this.loadMatchingFeature(d, c.bucketIndex, c.sourceLayerIndex, c.featureIndex, o, i.layers, i.availableImages, e, r, n, (e, r, n)=>(p || (p = as(e)), r.queryIntersectsFeature(l, e, n, p, this.z, t.transform, s, t.pixelPosMatrix)));
                }
                return d;
            }
            loadMatchingFeature(t, e, r, n, i, a, s, o, l, u, c) {
                const h = this.bucketLayerIDs[e];
                if (a && !function(t, e) {
                    for(let r = 0; r < t.length; r++)if (e.indexOf(t[r]) >= 0) return !0;
                    return !1;
                }(a, h)) return;
                const p = this.sourceLayerCoder.decode(r), f = this.vtLayers[p].feature(n);
                if (i.needGeometry) {
                    const t = ss(f, !0);
                    if (!i.filter(new li(this.tileID.overscaledZ), t, this.tileID.canonical)) return;
                } else if (!i.filter(new li(this.tileID.overscaledZ), f)) return;
                const d = this.getId(f, p);
                for(let e = 0; e < h.length; e++){
                    const r = h[e];
                    if (a && a.indexOf(r) < 0) continue;
                    const i = o[r];
                    if (!i) continue;
                    let p = {};
                    d && u && (p = u.getState(i.sourceLayer || "_geojsonTileLayer", d));
                    const y = g({}, l[r]);
                    y.paint = vc(y.paint, i.paint, f, p, s), y.layout = vc(y.layout, i.layout, f, p, s);
                    const m = !c || c(f, i, p);
                    if (!m) continue;
                    const x = new gc(f, this.z, this.x, this.y, d);
                    x.layer = y;
                    let v = t[r];
                    void 0 === v && (v = t[r] = []), v.push({
                        featureIndex: n,
                        feature: x,
                        intersectionZ: m
                    });
                }
            }
            lookupSymbolFeatures(t, e, r, n, i, a, s, o) {
                const l = {};
                this.loadVTLayers();
                const u = Nr(i);
                for (const i of t)this.loadMatchingFeature(l, r, n, i, u, a, s, o, e);
                return l;
            }
            hasLayer(t) {
                for (const e of this.bucketLayerIDs)for (const r of e)if (t === r) return !0;
                return !1;
            }
            getId(t, e) {
                let r = t.id;
                return this.promoteId && (r = t.properties["string" == typeof this.promoteId ? this.promoteId : this.promoteId[e]], "boolean" == typeof r && (r = Number(r))), r;
            }
        }
        function vc(t, e, r, n, i) {
            return v(t, (t, a)=>{
                const s = e instanceof mi ? e.get(a) : null;
                return s && s.evaluate ? s.evaluate(r, n, i) : s;
            });
        }
        function bc(t) {
            let e = 1 / 0, r = 1 / 0, n = -1 / 0, i = -1 / 0;
            for (const a of t)e = Math.min(e, a.x), r = Math.min(r, a.y), n = Math.max(n, a.x), i = Math.max(i, a.y);
            return {
                minX: e,
                minY: r,
                maxX: n,
                maxY: i
            };
        }
        function wc(t, e) {
            return e - t;
        }
        function _c(t, e, r, n, i) {
            const s = [];
            for(let o = 0; o < t.length; o++){
                const l = t[o];
                let u;
                for(let t = 0; t < l.length - 1; t++){
                    let o = l[t], c = l[t + 1];
                    o.x < e && c.x < e || (o.x < e ? o = new a(e, o.y + (e - o.x) / (c.x - o.x) * (c.y - o.y))._round() : c.x < e && (c = new a(e, o.y + (e - o.x) / (c.x - o.x) * (c.y - o.y))._round()), o.y < r && c.y < r || (o.y < r ? o = new a(o.x + (r - o.y) / (c.y - o.y) * (c.x - o.x), r)._round() : c.y < r && (c = new a(o.x + (r - o.y) / (c.y - o.y) * (c.x - o.x), r)._round()), o.x >= n && c.x >= n || (o.x >= n ? o = new a(n, o.y + (n - o.x) / (c.x - o.x) * (c.y - o.y))._round() : c.x >= n && (c = new a(n, o.y + (n - o.x) / (c.x - o.x) * (c.y - o.y))._round()), o.y >= i && c.y >= i || (o.y >= i ? o = new a(o.x + (i - o.y) / (c.y - o.y) * (c.x - o.x), i)._round() : c.y >= i && (c = new a(o.x + (i - o.y) / (c.y - o.y) * (c.x - o.x), i)._round()), u && o.equals(u[u.length - 1]) || (u = [
                        o
                    ], s.push(u)), u.push(c)))));
                }
            }
            return s;
        }
        $n("FeatureIndex", xc, {
            omit: [
                "rawTileData",
                "sourceLayerCoder"
            ]
        });
        class Ac extends a {
            constructor(t, e, r, n){
                super(t, e), this.angle = r, void 0 !== n && (this.segment = n);
            }
            clone() {
                return new Ac(this.x, this.y, this.angle, this.segment);
            }
        }
        function Sc(t, e, r, n, i) {
            if (void 0 === e.segment || 0 === r) return !0;
            let a = e, s = e.segment + 1, o = 0;
            for(; o > -r / 2;){
                if (s--, s < 0) return !1;
                o -= t[s].dist(a), a = t[s];
            }
            o += t[s].dist(t[s + 1]), s++;
            const l = [];
            let u = 0;
            for(; o < r / 2;){
                const e = t[s], r = t[s + 1];
                if (!r) return !1;
                let a = t[s - 1].angleTo(e) - e.angleTo(r);
                for(a = Math.abs((a + 3 * Math.PI) % (2 * Math.PI) - Math.PI), l.push({
                    distance: o,
                    angleDelta: a
                }), u += a; o - l[0].distance > n;)u -= l.shift().angleDelta;
                if (u > i) return !1;
                s++, o += e.dist(r);
            }
            return !0;
        }
        function kc(t) {
            let e = 0;
            for(let r = 0; r < t.length - 1; r++)e += t[r].dist(t[r + 1]);
            return e;
        }
        function Ic(t, e, r) {
            return t ? .6 * e * r : 0;
        }
        function zc(t, e) {
            return Math.max(t ? t.right - t.left : 0, e ? e.right - e.left : 0);
        }
        function Mc(t, e, r, n, i, a) {
            const s = Ic(r, i, a), o = zc(r, n) * a;
            let l = 0;
            const u = kc(t) / 2;
            for(let r = 0; r < t.length - 1; r++){
                const n = t[r], i = t[r + 1], a = n.dist(i);
                if (l + a > u) {
                    const c = (u - l) / a, h = Ze.number(n.x, i.x, c), p = Ze.number(n.y, i.y, c), f = new Ac(h, p, i.angleTo(n), r);
                    return f._round(), !s || Sc(t, f, o, s, e) ? f : void 0;
                }
                l += a;
            }
        }
        function Cc(t, e, r, n, i, a, s, o, l) {
            const u = Ic(n, a, s), c = zc(n, i), h = c * s, p = 0 === t[0].x || t[0].x === l || 0 === t[0].y || t[0].y === l;
            return e - h < e / 4 && (e = h + e / 4), Bc(t, p ? e / 2 * o % e : (c / 2 + 2 * a) * s * o % e, e, u, r, h, p, !1, l);
        }
        function Bc(t, e, r, n, i, a, s, o, l) {
            const u = a / 2, c = kc(t);
            let h = 0, p = e - r, f = [];
            for(let e = 0; e < t.length - 1; e++){
                const s = t[e], o = t[e + 1], d = s.dist(o), y = o.angleTo(s);
                for(; p + r < h + d;){
                    p += r;
                    const m = (p - h) / d, g = Ze.number(s.x, o.x, m), x = Ze.number(s.y, o.y, m);
                    if (g >= 0 && g < l && x >= 0 && x < l && p - u >= 0 && p + u <= c) {
                        const r = new Ac(g, x, y, e);
                        r._round(), n && !Sc(t, r, a, n, i) || f.push(r);
                    }
                }
                h += d;
            }
            return o || f.length || s || (f = Bc(t, h / 2, r, n, i, a, s, !0, l)), f;
        }
        $n("Anchor", Ac);
        const Pc = lu;
        function Vc(t, e, r, n) {
            const i = [], s = t.image, o = s.pixelRatio, l = s.paddedRect.w - 2 * Pc, u = s.paddedRect.h - 2 * Pc, c = t.right - t.left, h = t.bottom - t.top, p = s.stretchX || [
                [
                    0,
                    l
                ]
            ], f = s.stretchY || [
                [
                    0,
                    u
                ]
            ], d = (t, e)=>t + e[1] - e[0], y = p.reduce(d, 0), m = f.reduce(d, 0), g = l - y, x = u - m;
            let v = 0, b = y, w = 0, _ = m, A = 0, S = g, k = 0, I = x;
            if (s.content && n) {
                const t = s.content;
                v = Ec(p, 0, t[0]), w = Ec(f, 0, t[1]), b = Ec(p, t[0], t[2]), _ = Ec(f, t[1], t[3]), A = t[0] - v, k = t[1] - w, S = t[2] - t[0] - b, I = t[3] - t[1] - _;
            }
            const z = (n, i, l, u)=>{
                const p = Tc(n.stretch - v, b, c, t.left), f = $c(n.fixed - A, S, n.stretch, y), d = Tc(i.stretch - w, _, h, t.top), g = $c(i.fixed - k, I, i.stretch, m), x = Tc(l.stretch - v, b, c, t.left), z = $c(l.fixed - A, S, l.stretch, y), M = Tc(u.stretch - w, _, h, t.top), C = $c(u.fixed - k, I, u.stretch, m), B = new a(p, d), P = new a(x, d), V = new a(x, M), E = new a(p, M), F = new a(f / o, g / o), T = new a(z / o, C / o), $ = e * Math.PI / 180;
                if ($) {
                    const t = Math.sin($), e = Math.cos($), r = [
                        e,
                        -t,
                        t,
                        e
                    ];
                    B._matMult(r), P._matMult(r), E._matMult(r), V._matMult(r);
                }
                const L = n.stretch + n.fixed, D = i.stretch + i.fixed;
                return {
                    tl: B,
                    tr: P,
                    bl: E,
                    br: V,
                    tex: {
                        x: s.paddedRect.x + Pc + L,
                        y: s.paddedRect.y + Pc + D,
                        w: l.stretch + l.fixed - L,
                        h: u.stretch + u.fixed - D
                    },
                    writingMode: void 0,
                    glyphOffset: [
                        0,
                        0
                    ],
                    sectionIndex: 0,
                    pixelOffsetTL: F,
                    pixelOffsetBR: T,
                    minFontScaleX: S / o / c,
                    minFontScaleY: I / o / h,
                    isSDF: r
                };
            };
            if (n && (s.stretchX || s.stretchY)) {
                const t = Fc(p, g, y), e = Fc(f, x, m);
                for(let r = 0; r < t.length - 1; r++){
                    const n = t[r], a = t[r + 1];
                    for(let t = 0; t < e.length - 1; t++)i.push(z(n, e[t], a, e[t + 1]));
                }
            } else i.push(z({
                fixed: 0,
                stretch: -1
            }, {
                fixed: 0,
                stretch: -1
            }, {
                fixed: 0,
                stretch: l + 1
            }, {
                fixed: 0,
                stretch: u + 1
            }));
            return i;
        }
        function Ec(t, e, r) {
            let n = 0;
            for (const i of t)n += Math.max(e, Math.min(r, i[1])) - Math.max(e, Math.min(r, i[0]));
            return n;
        }
        function Fc(t, e, r) {
            const n = [
                {
                    fixed: -Pc,
                    stretch: 0
                }
            ];
            for (const [e, r] of t){
                const t = n[n.length - 1];
                n.push({
                    fixed: e - t.stretch,
                    stretch: t.stretch
                }), n.push({
                    fixed: e - t.stretch,
                    stretch: t.stretch + (r - e)
                });
            }
            return n.push({
                fixed: e + Pc,
                stretch: r
            }), n;
        }
        function Tc(t, e, r, n) {
            return t / e * r + n;
        }
        function $c(t, e, r, n) {
            return t - e * r / n;
        }
        class Lc {
            constructor(t, e, r, n, i, s, o, l, u, c){
                if (this.boxStartIndex = t.length, u) {
                    let t = s.top, e = s.bottom;
                    const r = s.collisionPadding;
                    r && (t -= r[1], e += r[3]);
                    let n = e - t;
                    n > 0 && (n = Math.max(10, n), this.circleDiameter = n);
                } else {
                    let u = s.top * o - l[0], h = s.bottom * o + l[2], p = s.left * o - l[3], f = s.right * o + l[1];
                    const d = s.collisionPadding;
                    if (d && (p -= d[0] * o, u -= d[1] * o, f += d[2] * o, h += d[3] * o), c) {
                        const t = new a(p, u), e = new a(f, u), r = new a(p, h), n = new a(f, h), i = c * Math.PI / 180;
                        t._rotate(i), e._rotate(i), r._rotate(i), n._rotate(i), p = Math.min(t.x, e.x, r.x, n.x), f = Math.max(t.x, e.x, r.x, n.x), u = Math.min(t.y, e.y, r.y, n.y), h = Math.max(t.y, e.y, r.y, n.y);
                    }
                    t.emplaceBack(e.x, e.y, p, u, f, h, r, n, i);
                }
                this.boxEndIndex = t.length;
            }
        }
        class Dc {
            constructor(t = [], e = Oc){
                if (this.data = t, this.length = this.data.length, this.compare = e, this.length > 0) for(let t = (this.length >> 1) - 1; t >= 0; t--)this._down(t);
            }
            push(t) {
                this.data.push(t), this.length++, this._up(this.length - 1);
            }
            pop() {
                if (0 === this.length) return;
                const t = this.data[0], e = this.data.pop();
                return this.length--, this.length > 0 && (this.data[0] = e, this._down(0)), t;
            }
            peek() {
                return this.data[0];
            }
            _up(t) {
                const { data: e, compare: r } = this, n = e[t];
                for(; t > 0;){
                    const i = t - 1 >> 1, a = e[i];
                    if (r(n, a) >= 0) break;
                    e[t] = a, t = i;
                }
                e[t] = n;
            }
            _down(t) {
                const { data: e, compare: r } = this, n = this.length >> 1, i = e[t];
                for(; t < n;){
                    let n = 1 + (t << 1), a = e[n];
                    const s = n + 1;
                    if (s < this.length && r(e[s], a) < 0 && (n = s, a = e[s]), r(a, i) >= 0) break;
                    e[t] = a, t = n;
                }
                e[t] = i;
            }
        }
        function Oc(t, e) {
            return t < e ? -1 : t > e ? 1 : 0;
        }
        function Uc(t, e = 1, r = !1) {
            let n = 1 / 0, i = 1 / 0, s = -1 / 0, o = -1 / 0;
            const l = t[0];
            for(let t = 0; t < l.length; t++){
                const e = l[t];
                (!t || e.x < n) && (n = e.x), (!t || e.y < i) && (i = e.y), (!t || e.x > s) && (s = e.x), (!t || e.y > o) && (o = e.y);
            }
            const u = Math.min(s - n, o - i);
            let c = u / 2;
            const h = new Dc([], Rc);
            if (0 === u) return new a(n, i);
            for(let e = n; e < s; e += u)for(let r = i; r < o; r += u)h.push(new qc(e + c, r + c, c, t));
            let p = function(t) {
                let e = 0, r = 0, n = 0;
                const i = t[0];
                for(let t = 0, a = i.length, s = a - 1; t < a; s = t++){
                    const a = i[t], o = i[s], l = a.x * o.y - o.x * a.y;
                    r += (a.x + o.x) * l, n += (a.y + o.y) * l, e += 3 * l;
                }
                return new qc(r / e, n / e, 0, t);
            }(t), f = h.length;
            for(; h.length;){
                const n = h.pop();
                (n.d > p.d || !p.d) && (p = n, r && console.log("found best %d after %d probes", Math.round(1e4 * n.d) / 1e4, f)), n.max - p.d <= e || (c = n.h / 2, h.push(new qc(n.p.x - c, n.p.y - c, c, t)), h.push(new qc(n.p.x + c, n.p.y - c, c, t)), h.push(new qc(n.p.x - c, n.p.y + c, c, t)), h.push(new qc(n.p.x + c, n.p.y + c, c, t)), f += 4);
            }
            return r && (console.log(`num probes: ${f}`), console.log(`best distance: ${p.d}`)), p.p;
        }
        function Rc(t, e) {
            return e.max - t.max;
        }
        function qc(t, e, r, n) {
            this.p = new a(t, e), this.h = r, this.d = function(t, e) {
                let r = !1, n = 1 / 0;
                for(let i = 0; i < e.length; i++){
                    const a = e[i];
                    for(let e = 0, i = a.length, s = i - 1; e < i; s = e++){
                        const i = a[e], o = a[s];
                        i.y > t.y != o.y > t.y && t.x < (o.x - i.x) * (t.y - i.y) / (o.y - i.y) + i.x && (r = !r), n = Math.min(n, ms(t, i, o));
                    }
                }
                return (r ? 1 : -1) * Math.sqrt(n);
            }(this.p, n), this.max = this.d + this.h * Math.SQRT2;
        }
        var jc;
        t.aq = void 0, (jc = t.aq || (t.aq = {}))[jc.center = 1] = "center", jc[jc.left = 2] = "left", jc[jc.right = 3] = "right", jc[jc.top = 4] = "top", jc[jc.bottom = 5] = "bottom", jc[jc["top-left"] = 6] = "top-left", jc[jc["top-right"] = 7] = "top-right", jc[jc["bottom-left"] = 8] = "bottom-left", jc[jc["bottom-right"] = 9] = "bottom-right";
        const Nc = 7, Zc = Number.POSITIVE_INFINITY;
        function Kc(t, e) {
            return e[1] !== Zc ? function(t, e, r) {
                let n = 0, i = 0;
                switch(e = Math.abs(e), r = Math.abs(r), t){
                    case "top-right":
                    case "top-left":
                    case "top":
                        i = r - Nc;
                        break;
                    case "bottom-right":
                    case "bottom-left":
                    case "bottom":
                        i = -r + Nc;
                }
                switch(t){
                    case "top-right":
                    case "bottom-right":
                    case "right":
                        n = -e;
                        break;
                    case "top-left":
                    case "bottom-left":
                    case "left":
                        n = e;
                }
                return [
                    n,
                    i
                ];
            }(t, e[0], e[1]) : function(t, e) {
                let r = 0, n = 0;
                e < 0 && (e = 0);
                const i = e / Math.SQRT2;
                switch(t){
                    case "top-right":
                    case "top-left":
                        n = i - Nc;
                        break;
                    case "bottom-right":
                    case "bottom-left":
                        n = -i + Nc;
                        break;
                    case "bottom":
                        n = -e + Nc;
                        break;
                    case "top":
                        n = e - Nc;
                }
                switch(t){
                    case "top-right":
                    case "bottom-right":
                        r = -i;
                        break;
                    case "top-left":
                    case "bottom-left":
                        r = i;
                        break;
                    case "left":
                        r = e;
                        break;
                    case "right":
                        r = -e;
                }
                return [
                    r,
                    n
                ];
            }(t, e[0]);
        }
        function Gc(t, e, r) {
            var n;
            const i = t.layout, a = null === (n = i.get("text-variable-anchor-offset")) || void 0 === n ? void 0 : n.evaluate(e, {}, r);
            if (a) {
                const t = a.values, e = [];
                for(let r = 0; r < t.length; r += 2){
                    const n = e[r] = t[r], i = t[r + 1].map((t)=>t * Vl);
                    n.startsWith("top") ? i[1] -= Nc : n.startsWith("bottom") && (i[1] += Nc), e[r + 1] = i;
                }
                return new re(e);
            }
            const s = i.get("text-variable-anchor");
            if (s) {
                let n;
                n = void 0 !== t._unevaluatedLayout.getValue("text-radial-offset") ? [
                    i.get("text-radial-offset").evaluate(e, {}, r) * Vl,
                    Zc
                ] : i.get("text-offset").evaluate(e, {}, r).map((t)=>t * Vl);
                const a = [];
                for (const t of s)a.push(t, Kc(t, n));
                return new re(a);
            }
            return null;
        }
        function Jc(t) {
            switch(t){
                case "right":
                case "top-right":
                case "bottom-right":
                    return "right";
                case "left":
                case "top-left":
                case "bottom-left":
                    return "left";
            }
            return "center";
        }
        function Xc(e, r, n, i, a, s, o, l, u, c, h) {
            let p = s.textMaxSize.evaluate(r, {});
            void 0 === p && (p = o);
            const f = e.layers[0].layout, d = f.get("icon-offset").evaluate(r, {}, h), y = Hc(n.horizontal), m = o / 24, g = e.tilePixelRatio * m, x = e.tilePixelRatio * p / 24, v = e.tilePixelRatio * l, b = e.tilePixelRatio * f.get("symbol-spacing"), w = f.get("text-padding") * e.tilePixelRatio, _ = function(t, e, r, n = 1) {
                const i = t.get("icon-padding").evaluate(e, {}, r), a = i && i.values;
                return [
                    a[0] * n,
                    a[1] * n,
                    a[2] * n,
                    a[3] * n
                ];
            }(f, r, h, e.tilePixelRatio), S = f.get("text-max-angle") / 180 * Math.PI, k = "viewport" !== f.get("text-rotation-alignment") && "point" !== f.get("symbol-placement"), I = "map" === f.get("icon-rotation-alignment") && "point" !== f.get("symbol-placement"), z = f.get("symbol-placement"), M = b / 2, C = f.get("icon-text-fit");
            let B;
            i && "none" !== C && (e.allowVerticalPlacement && n.vertical && (B = zu(i, n.vertical, C, f.get("icon-text-fit-padding"), d, m)), y && (i = zu(i, y, C, f.get("icon-text-fit-padding"), d, m)));
            const P = (l, p)=>{
                p.x < 0 || p.x >= rs || p.y < 0 || p.y >= rs || function(e, r, n, i, a, s, o, l, u, c, h, p, f, d, y, m, g, x, v, b, w, _, S, k, I) {
                    const z = e.addToLineVertexArray(r, n);
                    let M, C, B, P, V = 0, E = 0, F = 0, T = 0, $ = -1, L = -1;
                    const D = {};
                    let O = $a("");
                    if (e.allowVerticalPlacement && i.vertical) {
                        const t = l.layout.get("text-rotate").evaluate(w, {}, k) + 90;
                        B = new Lc(u, r, c, h, p, i.vertical, f, d, y, t), o && (P = new Lc(u, r, c, h, p, o, g, x, y, t));
                    }
                    if (a) {
                        const n = l.layout.get("icon-rotate").evaluate(w, {}), i = "none" !== l.layout.get("icon-text-fit"), s = Vc(a, n, S, i), f = o ? Vc(o, n, S, i) : void 0;
                        C = new Lc(u, r, c, h, p, a, g, x, !1, n), V = 4 * s.length;
                        const d = e.iconSizeData;
                        let y = null;
                        "source" === d.kind ? (y = [
                            Cu * l.layout.get("icon-size").evaluate(w, {})
                        ], y[0] > Bu && A(`${e.layerIds[0]}: Value for "icon-size" is >= ${Mu}. Reduce your "icon-size".`)) : "composite" === d.kind && (y = [
                            Cu * _.compositeIconSizes[0].evaluate(w, {}, k),
                            Cu * _.compositeIconSizes[1].evaluate(w, {}, k)
                        ], (y[0] > Bu || y[1] > Bu) && A(`${e.layerIds[0]}: Value for "icon-size" is >= ${Mu}. Reduce your "icon-size".`)), e.addSymbols(e.icon, s, y, b, v, w, t.ai.none, r, z.lineStartIndex, z.lineLength, -1, k), $ = e.icon.placedSymbolArray.length - 1, f && (E = 4 * f.length, e.addSymbols(e.icon, f, y, b, v, w, t.ai.vertical, r, z.lineStartIndex, z.lineLength, -1, k), L = e.icon.placedSymbolArray.length - 1);
                    }
                    const U = Object.keys(i.horizontal);
                    for (const n of U){
                        const a = i.horizontal[n];
                        if (!M) {
                            O = $a(a.text);
                            const t = l.layout.get("text-rotate").evaluate(w, {}, k);
                            M = new Lc(u, r, c, h, p, a, f, d, y, t);
                        }
                        const o = 1 === a.positionedLines.length;
                        if (F += Yc(e, r, a, s, l, y, w, m, z, i.vertical ? t.ai.horizontal : t.ai.horizontalOnly, o ? U : [
                            n
                        ], D, $, _, k), o) break;
                    }
                    i.vertical && (T += Yc(e, r, i.vertical, s, l, y, w, m, z, t.ai.vertical, [
                        "vertical"
                    ], D, L, _, k));
                    const R = M ? M.boxStartIndex : e.collisionBoxArray.length, q = M ? M.boxEndIndex : e.collisionBoxArray.length, j = B ? B.boxStartIndex : e.collisionBoxArray.length, N = B ? B.boxEndIndex : e.collisionBoxArray.length, Z = C ? C.boxStartIndex : e.collisionBoxArray.length, K = C ? C.boxEndIndex : e.collisionBoxArray.length, G = P ? P.boxStartIndex : e.collisionBoxArray.length, J = P ? P.boxEndIndex : e.collisionBoxArray.length;
                    let X = -1;
                    const Y = (t, e)=>t && t.circleDiameter ? Math.max(t.circleDiameter, e) : e;
                    X = Y(M, X), X = Y(B, X), X = Y(C, X), X = Y(P, X);
                    const H = X > -1 ? 1 : 0;
                    H && (X *= I / Vl), e.glyphOffsetArray.length >= Uu.MAX_GLYPHS && A("Too many glyphs being rendered in a tile. See https://github.com/mapbox/mapbox-gl-js/issues/2907"), void 0 !== w.sortKey && e.addToSortKeyRanges(e.symbolInstances.length, w.sortKey);
                    const W = Gc(l, w, k), [Q, tt] = function(e, r) {
                        const n = e.length, i = null == r ? void 0 : r.values;
                        if ((null == i ? void 0 : i.length) > 0) for(let r = 0; r < i.length; r += 2){
                            const n = i[r + 1];
                            e.emplaceBack(t.aq[i[r]], n[0], n[1]);
                        }
                        return [
                            n,
                            e.length
                        ];
                    }(e.textAnchorOffsets, W);
                    e.symbolInstances.emplaceBack(r.x, r.y, D.right >= 0 ? D.right : -1, D.center >= 0 ? D.center : -1, D.left >= 0 ? D.left : -1, D.vertical || -1, $, L, O, R, q, j, N, Z, K, G, J, c, F, T, V, E, H, 0, f, X, Q, tt);
                }(e, p, l, n, i, a, B, e.layers[0], e.collisionBoxArray, r.index, r.sourceLayerIndex, e.index, g, [
                    w,
                    w,
                    w,
                    w
                ], k, u, v, _, I, d, r, s, c, h, o);
            };
            if ("line" === z) for (const t of _c(r.geometry, 0, 0, rs, rs)){
                const r = Cc(t, b, S, n.vertical || y, i, 24, x, e.overscaling, rs);
                for (const n of r)y && Wc(e, y.text, M, n) || P(t, n);
            }
            else if ("line-center" === z) {
                for (const t of r.geometry)if (t.length > 1) {
                    const e = Mc(t, S, n.vertical || y, i, 24, x);
                    e && P(t, e);
                }
            } else if ("Polygon" === r.type) for (const t of Co(r.geometry, 0)){
                const e = Uc(t, 16);
                P(t[0], new Ac(e.x, e.y, 0));
            }
            else if ("LineString" === r.type) for (const t of r.geometry)P(t, new Ac(t[0].x, t[0].y, 0));
            else if ("Point" === r.type) for (const t of r.geometry)for (const e of t)P([
                e
            ], new Ac(e.x, e.y, 0));
        }
        function Yc(t, e, r, n, i, s, o, l, u, c, h, p, f, d, y) {
            const m = function(t, e, r, n, i, s, o, l) {
                const u = n.layout.get("text-rotate").evaluate(s, {}) * Math.PI / 180, c = [];
                for (const t of e.positionedLines)for (const n of t.positionedGlyphs){
                    if (!n.rect) continue;
                    const s = n.rect || {};
                    let h = su + 1, p = !0, f = 1, d = 0;
                    const y = (i || l) && n.vertical, m = n.metrics.advance * n.scale / 2;
                    if (l && e.verticalizable && (d = t.lineOffset / 2 - (n.imageName ? -(Vl - n.metrics.width * n.scale) / 2 : (n.scale - 1) * Vl)), n.imageName) {
                        const t = o[n.imageName];
                        p = t.sdf, f = t.pixelRatio, h = lu / f;
                    }
                    const g = i ? [
                        n.x + m,
                        n.y
                    ] : [
                        0,
                        0
                    ];
                    let x = i ? [
                        0,
                        0
                    ] : [
                        n.x + m + r[0],
                        n.y + r[1] - d
                    ], v = [
                        0,
                        0
                    ];
                    y && (v = x, x = [
                        0,
                        0
                    ]);
                    const b = n.metrics.isDoubleResolution ? 2 : 1, w = (n.metrics.left - h) * n.scale - m + x[0], _ = (-n.metrics.top - h) * n.scale + x[1], A = w + s.w / b * n.scale / f, S = _ + s.h / b * n.scale / f, k = new a(w, _), I = new a(A, _), z = new a(w, S), M = new a(A, S);
                    if (y) {
                        const t = new a(-m, m - pu), e = -Math.PI / 2, r = Vl / 2 - m, i = new a(5 - pu - r, -(n.imageName ? r : 0)), s = new a(...v);
                        k._rotateAround(e, t)._add(i)._add(s), I._rotateAround(e, t)._add(i)._add(s), z._rotateAround(e, t)._add(i)._add(s), M._rotateAround(e, t)._add(i)._add(s);
                    }
                    if (u) {
                        const t = Math.sin(u), e = Math.cos(u), r = [
                            e,
                            -t,
                            t,
                            e
                        ];
                        k._matMult(r), I._matMult(r), z._matMult(r), M._matMult(r);
                    }
                    const C = new a(0, 0), B = new a(0, 0);
                    c.push({
                        tl: k,
                        tr: I,
                        bl: z,
                        br: M,
                        tex: s,
                        writingMode: e.writingMode,
                        glyphOffset: g,
                        sectionIndex: n.sectionIndex,
                        isSDF: p,
                        pixelOffsetTL: C,
                        pixelOffsetBR: B,
                        minFontScaleX: 0,
                        minFontScaleY: 0
                    });
                }
                return c;
            }(0, r, l, i, s, o, n, t.allowVerticalPlacement), g = t.textSizeData;
            let x = null;
            "source" === g.kind ? (x = [
                Cu * i.layout.get("text-size").evaluate(o, {})
            ], x[0] > Bu && A(`${t.layerIds[0]}: Value for "text-size" is >= ${Mu}. Reduce your "text-size".`)) : "composite" === g.kind && (x = [
                Cu * d.compositeTextSizes[0].evaluate(o, {}, y),
                Cu * d.compositeTextSizes[1].evaluate(o, {}, y)
            ], (x[0] > Bu || x[1] > Bu) && A(`${t.layerIds[0]}: Value for "text-size" is >= ${Mu}. Reduce your "text-size".`)), t.addSymbols(t.text, m, x, l, s, o, c, e, u.lineStartIndex, u.lineLength, f, y);
            for (const e of h)p[e] = t.text.placedSymbolArray.length - 1;
            return 4 * m.length;
        }
        function Hc(t) {
            for(const e in t)return t[e];
            return null;
        }
        function Wc(t, e, r, n) {
            const i = t.compareText;
            if (e in i) {
                const t = i[e];
                for(let e = t.length - 1; e >= 0; e--)if (n.dist(t[e]) < r) return !0;
            } else i[e] = [];
            return i[e].push(n), !1;
        }
        const Qc = [
            Int8Array,
            Uint8Array,
            Uint8ClampedArray,
            Int16Array,
            Uint16Array,
            Int32Array,
            Uint32Array,
            Float32Array,
            Float64Array
        ];
        class th {
            static from(t) {
                if (!(t instanceof ArrayBuffer)) throw new Error("Data must be an instance of ArrayBuffer.");
                const [e, r] = new Uint8Array(t, 0, 2);
                if (219 !== e) throw new Error("Data does not appear to be in a KDBush format.");
                const n = r >> 4;
                if (1 !== n) throw new Error(`Got v${n} data when expected v1.`);
                const i = Qc[15 & r];
                if (!i) throw new Error("Unrecognized array type.");
                const [a] = new Uint16Array(t, 2, 1), [s] = new Uint32Array(t, 4, 1);
                return new th(s, a, i, t);
            }
            constructor(t, e = 64, r = Float64Array, n){
                if (isNaN(t) || t < 0) throw new Error(`Unpexpected numItems value: ${t}.`);
                this.numItems = +t, this.nodeSize = Math.min(Math.max(+e, 2), 65535), this.ArrayType = r, this.IndexArrayType = t < 65536 ? Uint16Array : Uint32Array;
                const i = Qc.indexOf(this.ArrayType), a = 2 * t * this.ArrayType.BYTES_PER_ELEMENT, s = t * this.IndexArrayType.BYTES_PER_ELEMENT, o = (8 - s % 8) % 8;
                if (i < 0) throw new Error(`Unexpected typed array class: ${r}.`);
                n && n instanceof ArrayBuffer ? (this.data = n, this.ids = new this.IndexArrayType(this.data, 8, t), this.coords = new this.ArrayType(this.data, 8 + s + o, 2 * t), this._pos = 2 * t, this._finished = !0) : (this.data = new ArrayBuffer(8 + a + s + o), this.ids = new this.IndexArrayType(this.data, 8, t), this.coords = new this.ArrayType(this.data, 8 + s + o, 2 * t), this._pos = 0, this._finished = !1, new Uint8Array(this.data, 0, 2).set([
                    219,
                    16 + i
                ]), new Uint16Array(this.data, 2, 1)[0] = e, new Uint32Array(this.data, 4, 1)[0] = t);
            }
            add(t, e) {
                const r = this._pos >> 1;
                return this.ids[r] = r, this.coords[this._pos++] = t, this.coords[this._pos++] = e, r;
            }
            finish() {
                const t = this._pos >> 1;
                if (t !== this.numItems) throw new Error(`Added ${t} items when expected ${this.numItems}.`);
                return eh(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0), this._finished = !0, this;
            }
            range(t, e, r, n) {
                if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
                const { ids: i, coords: a, nodeSize: s } = this, o = [
                    0,
                    i.length - 1,
                    0
                ], l = [];
                for(; o.length;){
                    const u = o.pop() || 0, c = o.pop() || 0, h = o.pop() || 0;
                    if (c - h <= s) {
                        for(let s = h; s <= c; s++){
                            const o = a[2 * s], u = a[2 * s + 1];
                            o >= t && o <= r && u >= e && u <= n && l.push(i[s]);
                        }
                        continue;
                    }
                    const p = h + c >> 1, f = a[2 * p], d = a[2 * p + 1];
                    f >= t && f <= r && d >= e && d <= n && l.push(i[p]), (0 === u ? t <= f : e <= d) && (o.push(h), o.push(p - 1), o.push(1 - u)), (0 === u ? r >= f : n >= d) && (o.push(p + 1), o.push(c), o.push(1 - u));
                }
                return l;
            }
            within(t, e, r) {
                if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
                const { ids: n, coords: i, nodeSize: a } = this, s = [
                    0,
                    n.length - 1,
                    0
                ], o = [], l = r * r;
                for(; s.length;){
                    const u = s.pop() || 0, c = s.pop() || 0, h = s.pop() || 0;
                    if (c - h <= a) {
                        for(let r = h; r <= c; r++)ah(i[2 * r], i[2 * r + 1], t, e) <= l && o.push(n[r]);
                        continue;
                    }
                    const p = h + c >> 1, f = i[2 * p], d = i[2 * p + 1];
                    ah(f, d, t, e) <= l && o.push(n[p]), (0 === u ? t - r <= f : e - r <= d) && (s.push(h), s.push(p - 1), s.push(1 - u)), (0 === u ? t + r >= f : e + r >= d) && (s.push(p + 1), s.push(c), s.push(1 - u));
                }
                return o;
            }
        }
        function eh(t, e, r, n, i, a) {
            if (i - n <= r) return;
            const s = n + i >> 1;
            rh(t, e, s, n, i, a), eh(t, e, r, n, s - 1, 1 - a), eh(t, e, r, s + 1, i, 1 - a);
        }
        function rh(t, e, r, n, i, a) {
            for(; i > n;){
                if (i - n > 600) {
                    const s = i - n + 1, o = r - n + 1, l = Math.log(s), u = .5 * Math.exp(2 * l / 3), c = .5 * Math.sqrt(l * u * (s - u) / s) * (o - s / 2 < 0 ? -1 : 1);
                    rh(t, e, r, Math.max(n, Math.floor(r - o * u / s + c)), Math.min(i, Math.floor(r + (s - o) * u / s + c)), a);
                }
                const s = e[2 * r + a];
                let o = n, l = i;
                for(nh(t, e, n, r), e[2 * i + a] > s && nh(t, e, n, i); o < l;){
                    for(nh(t, e, o, l), o++, l--; e[2 * o + a] < s;)o++;
                    for(; e[2 * l + a] > s;)l--;
                }
                e[2 * n + a] === s ? nh(t, e, n, l) : (l++, nh(t, e, l, i)), l <= r && (n = l + 1), r <= l && (i = l - 1);
            }
        }
        function nh(t, e, r, n) {
            ih(t, r, n), ih(e, 2 * r, 2 * n), ih(e, 2 * r + 1, 2 * n + 1);
        }
        function ih(t, e, r) {
            const n = t[e];
            t[e] = t[r], t[r] = n;
        }
        function ah(t, e, r, n) {
            const i = t - r, a = e - n;
            return i * i + a * a;
        }
        var sh;
        t.bh = void 0, (sh = t.bh || (t.bh = {})).create = "create", sh.load = "load", sh.fullLoad = "fullLoad";
        let oh = null, lh = [];
        const uh = 1e3 / 60, ch = "loadTime", hh = "fullLoadTime", ph = {
            mark (t) {
                performance.mark(t);
            },
            frame (t) {
                const e = t;
                null != oh && lh.push(e - oh), oh = e;
            },
            clearMetrics () {
                oh = null, lh = [], performance.clearMeasures(ch), performance.clearMeasures(hh);
                for(const e in t.bh)performance.clearMarks(t.bh[e]);
            },
            getPerformanceMetrics () {
                performance.measure(ch, t.bh.create, t.bh.load), performance.measure(hh, t.bh.create, t.bh.fullLoad);
                const e = performance.getEntriesByName(ch)[0].duration, r = performance.getEntriesByName(hh)[0].duration, n = lh.length, i = 1 / (lh.reduce((t, e)=>t + e, 0) / n / 1e3), a = lh.filter((t)=>t > uh).reduce((t, e)=>t + (e - uh) / uh, 0);
                return {
                    loadTime: e,
                    fullLoadTime: r,
                    fps: i,
                    percentDroppedFrames: a / (n + a) * 100,
                    totalFrames: n
                };
            }
        };
        t.$ = function(t, e, r) {
            var n, i, a, s, o, l, u, c, h, p, f, d, y = r[0], m = r[1], g = r[2];
            return e === t ? (t[12] = e[0] * y + e[4] * m + e[8] * g + e[12], t[13] = e[1] * y + e[5] * m + e[9] * g + e[13], t[14] = e[2] * y + e[6] * m + e[10] * g + e[14], t[15] = e[3] * y + e[7] * m + e[11] * g + e[15]) : (i = e[1], a = e[2], s = e[3], o = e[4], l = e[5], u = e[6], c = e[7], h = e[8], p = e[9], f = e[10], d = e[11], t[0] = n = e[0], t[1] = i, t[2] = a, t[3] = s, t[4] = o, t[5] = l, t[6] = u, t[7] = c, t[8] = h, t[9] = p, t[10] = f, t[11] = d, t[12] = n * y + o * m + h * g + e[12], t[13] = i * y + l * m + p * g + e[13], t[14] = a * y + u * m + f * g + e[14], t[15] = s * y + c * m + d * g + e[15]), t;
        }, t.A = zs, t.B = Ze, t.C = class {
            constructor(t, e, r){
                this.receive = (t)=>{
                    const e = t.data, r = e.id;
                    if (r && (!e.targetMapId || this.mapId === e.targetMapId)) {
                        if ("<cancel>" === e.type) {
                            delete this.tasks[r];
                            const t = this.cancelCallbacks[r];
                            delete this.cancelCallbacks[r], t && t();
                        } else I() || e.mustQueue ? (this.tasks[r] = e, this.taskQueue.push(r), this.invoker.trigger()) : this.processTask(r, e);
                    }
                }, this.process = ()=>{
                    if (!this.taskQueue.length) return;
                    const t = this.taskQueue.shift(), e = this.tasks[t];
                    delete this.tasks[t], this.taskQueue.length && this.invoker.trigger(), e && this.processTask(t, e);
                }, this.target = t, this.parent = e, this.mapId = r, this.callbacks = {}, this.tasks = {}, this.taskQueue = [], this.cancelCallbacks = {}, this.invoker = new Qu(this.process), this.target.addEventListener("message", this.receive, !1), this.globalScope = I() ? t : window;
            }
            send(t, e, r, n, i = !1) {
                const a = Math.round(1e18 * Math.random()).toString(36).substring(0, 10);
                r && (this.callbacks[a] = r);
                const s = [], o = {
                    id: a,
                    type: t,
                    hasCallback: !!r,
                    targetMapId: n,
                    mustQueue: i,
                    sourceMapId: this.mapId,
                    data: Dn(e, s)
                };
                return this.target.postMessage(o, {
                    transfer: s
                }), {
                    cancel: ()=>{
                        r && delete this.callbacks[a], this.target.postMessage({
                            id: a,
                            type: "<cancel>",
                            targetMapId: n,
                            sourceMapId: this.mapId
                        });
                    }
                };
            }
            processTask(t, e) {
                if ("<response>" === e.type) {
                    const r = this.callbacks[t];
                    delete this.callbacks[t], r && (e.error ? r(On(e.error)) : r(null, On(e.data)));
                } else {
                    let r = !1;
                    const n = [], i = e.hasCallback ? (e, i)=>{
                        r = !0, delete this.cancelCallbacks[t];
                        const a = {
                            id: t,
                            type: "<response>",
                            sourceMapId: this.mapId,
                            error: e ? Dn(e) : null,
                            data: Dn(i, n)
                        };
                        this.target.postMessage(a, {
                            transfer: n
                        });
                    } : (t)=>{
                        r = !0;
                    };
                    let a = null;
                    const s = On(e.data);
                    if (this.parent[e.type]) a = this.parent[e.type](e.sourceMapId, s, i);
                    else if ("getWorkerSource" in this.parent) {
                        const t = e.type.split(".");
                        a = this.parent.getWorkerSource(e.sourceMapId, t[0], s.source)[t[1]](s, i);
                    } else i(new Error(`Could not find function ${e.type}`));
                    !r && a && a.cancel && (this.cancelCallbacks[t] = a.cancel);
                }
            }
            remove() {
                this.invoker.remove(), this.target.removeEventListener("message", this.receive, !1);
            }
        }, t.D = gi, t.E = J, t.F = function(t, e) {
            const r = {};
            for(let n = 0; n < e.length; n++){
                const i = e[n];
                i in t && (r[i] = t[i]);
            }
            return r;
        }, t.G = ic, t.H = ac, t.I = uu, t.J = h, t.K = p, t.L = ec, t.M = B, t.N = rs, t.O = fc, t.P = a, t.Q = Mi, t.R = qs, t.S = za, t.T = hi, t.U = uc, t.V = class extends Vi {
        }, t.W = hc, t.X = function(t, e) {
            const r = window.document.createElement("video");
            r.muted = !0, r.onloadstart = function() {
                e(null, r);
            };
            for(let e = 0; e < t.length; e++){
                const n = window.document.createElement("source");
                j(t[e]) || (r.crossOrigin = "Anonymous"), n.src = t[e], r.appendChild(n);
            }
            return {
                cancel: ()=>{}
            };
        }, t.Y = ot, t.Z = function() {
            var t = new zs(16);
            return zs != Float32Array && (t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0), t[0] = 1, t[5] = 1, t[10] = 1, t[15] = 1, t;
        }, t._ = e, t.a = M, t.a$ = class extends Hi {
        }, t.a0 = function(t, e, r) {
            var n = r[0], i = r[1], a = r[2];
            return t[0] = e[0] * n, t[1] = e[1] * n, t[2] = e[2] * n, t[3] = e[3] * n, t[4] = e[4] * i, t[5] = e[5] * i, t[6] = e[6] * i, t[7] = e[7] * i, t[8] = e[8] * a, t[9] = e[9] * a, t[10] = e[10] * a, t[11] = e[11] * a, t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15], t;
        }, t.a1 = Cs, t.a2 = function() {
            return x++;
        }, t.a3 = ta, t.a4 = Uu, t.a5 = function() {
            oi.isLoading() || oi.isLoaded() || "deferred" !== ai() || si();
        }, t.a6 = Nr, t.a7 = ss, t.a8 = li, t.a9 = gc, t.aA = ri, t.aB = function(t) {
            t = t.slice();
            const e = Object.create(null);
            for(let r = 0; r < t.length; r++)e[t[r].id] = t[r];
            for(let r = 0; r < t.length; r++)"ref" in t[r] && (t[r] = H(t[r], e[t[r].ref]));
            return t;
        }, t.aC = function(t) {
            if ("custom" === t.type) return new Wu(t);
            switch(t.type){
                case "background":
                    return new Ju(t);
                case "circle":
                    return new Es(t);
                case "fill":
                    return new Lo(t);
                case "fill-extrusion":
                    return new ol(t);
                case "heatmap":
                    return new Ns(t);
                case "hillshade":
                    return new Gs(t);
                case "line":
                    return new Al(t);
                case "raster":
                    return new Hu(t);
                case "symbol":
                    return new Zu(t);
            }
        }, t.aD = w, t.aE = function(t, e) {
            if (!t) return [
                {
                    command: Q.setStyle,
                    args: [
                        e
                    ]
                }
            ];
            let r = [];
            try {
                if (!W(t.version, e.version)) return [
                    {
                        command: Q.setStyle,
                        args: [
                            e
                        ]
                    }
                ];
                W(t.center, e.center) || r.push({
                    command: Q.setCenter,
                    args: [
                        e.center
                    ]
                }), W(t.zoom, e.zoom) || r.push({
                    command: Q.setZoom,
                    args: [
                        e.zoom
                    ]
                }), W(t.bearing, e.bearing) || r.push({
                    command: Q.setBearing,
                    args: [
                        e.bearing
                    ]
                }), W(t.pitch, e.pitch) || r.push({
                    command: Q.setPitch,
                    args: [
                        e.pitch
                    ]
                }), W(t.sprite, e.sprite) || r.push({
                    command: Q.setSprite,
                    args: [
                        e.sprite
                    ]
                }), W(t.glyphs, e.glyphs) || r.push({
                    command: Q.setGlyphs,
                    args: [
                        e.glyphs
                    ]
                }), W(t.transition, e.transition) || r.push({
                    command: Q.setTransition,
                    args: [
                        e.transition
                    ]
                }), W(t.light, e.light) || r.push({
                    command: Q.setLight,
                    args: [
                        e.light
                    ]
                });
                const n = {}, i = [];
                !function(t, e, r, n) {
                    let i;
                    for(i in e = e || {}, t = t || {})Object.prototype.hasOwnProperty.call(t, i) && (Object.prototype.hasOwnProperty.call(e, i) || et(i, r, n));
                    for(i in e)Object.prototype.hasOwnProperty.call(e, i) && (Object.prototype.hasOwnProperty.call(t, i) ? W(t[i], e[i]) || ("geojson" === t[i].type && "geojson" === e[i].type && nt(t, e, i) ? r.push({
                        command: Q.setGeoJSONSourceData,
                        args: [
                            i,
                            e[i].data
                        ]
                    }) : rt(i, e, r, n)) : tt(i, e, r));
                }(t.sources, e.sources, i, n);
                const a = [];
                t.layers && t.layers.forEach((t)=>{
                    n[t.source] ? r.push({
                        command: Q.removeLayer,
                        args: [
                            t.id
                        ]
                    }) : a.push(t);
                }), r = r.concat(i), function(t, e, r) {
                    e = e || [];
                    const n = (t = t || []).map(at), i = e.map(at), a = t.reduce(st, {}), s = e.reduce(st, {}), o = n.slice(), l = Object.create(null);
                    let u, c, h, p, f, d, y;
                    for(u = 0, c = 0; u < n.length; u++)h = n[u], Object.prototype.hasOwnProperty.call(s, h) ? c++ : (r.push({
                        command: Q.removeLayer,
                        args: [
                            h
                        ]
                    }), o.splice(o.indexOf(h, c), 1));
                    for(u = 0, c = 0; u < i.length; u++)h = i[i.length - 1 - u], o[o.length - 1 - u] !== h && (Object.prototype.hasOwnProperty.call(a, h) ? (r.push({
                        command: Q.removeLayer,
                        args: [
                            h
                        ]
                    }), o.splice(o.lastIndexOf(h, o.length - c), 1)) : c++, d = o[o.length - u], r.push({
                        command: Q.addLayer,
                        args: [
                            s[h],
                            d
                        ]
                    }), o.splice(o.length - u, 0, h), l[h] = !0);
                    for(u = 0; u < i.length; u++)if (h = i[u], p = a[h], f = s[h], !l[h] && !W(p, f)) {
                        if (W(p.source, f.source) && W(p["source-layer"], f["source-layer"]) && W(p.type, f.type)) {
                            for(y in it(p.layout, f.layout, r, h, null, Q.setLayoutProperty), it(p.paint, f.paint, r, h, null, Q.setPaintProperty), W(p.filter, f.filter) || r.push({
                                command: Q.setFilter,
                                args: [
                                    h,
                                    f.filter
                                ]
                            }), W(p.minzoom, f.minzoom) && W(p.maxzoom, f.maxzoom) || r.push({
                                command: Q.setLayerZoomRange,
                                args: [
                                    h,
                                    f.minzoom,
                                    f.maxzoom
                                ]
                            }), p)Object.prototype.hasOwnProperty.call(p, y) && "layout" !== y && "paint" !== y && "filter" !== y && "metadata" !== y && "minzoom" !== y && "maxzoom" !== y && (0 === y.indexOf("paint.") ? it(p[y], f[y], r, h, y.slice(6), Q.setPaintProperty) : W(p[y], f[y]) || r.push({
                                command: Q.setLayerProperty,
                                args: [
                                    h,
                                    y,
                                    f[y]
                                ]
                            }));
                            for(y in f)Object.prototype.hasOwnProperty.call(f, y) && !Object.prototype.hasOwnProperty.call(p, y) && "layout" !== y && "paint" !== y && "filter" !== y && "metadata" !== y && "minzoom" !== y && "maxzoom" !== y && (0 === y.indexOf("paint.") ? it(p[y], f[y], r, h, y.slice(6), Q.setPaintProperty) : W(p[y], f[y]) || r.push({
                                command: Q.setLayerProperty,
                                args: [
                                    h,
                                    y,
                                    f[y]
                                ]
                            }));
                        } else r.push({
                            command: Q.removeLayer,
                            args: [
                                h
                            ]
                        }), d = o[o.lastIndexOf(h) + 1], r.push({
                            command: Q.addLayer,
                            args: [
                                f,
                                d
                            ]
                        });
                    }
                }(a, e.layers, r);
            } catch (t) {
                console.warn("Unable to compute style diff:", t), r = [
                    {
                        command: Q.setStyle,
                        args: [
                            e
                        ]
                    }
                ];
            }
            return r;
        }, t.aF = function(t) {
            const e = [], r = t.id;
            return void 0 === r && e.push({
                message: `layers.${r}: missing required property "id"`
            }), void 0 === t.render && e.push({
                message: `layers.${r}: missing required method "render"`
            }), t.renderingMode && "2d" !== t.renderingMode && "3d" !== t.renderingMode && e.push({
                message: `layers.${r}: property "renderingMode" must be either "2d" or "3d"`
            }), e;
        }, t.aG = function t(e, r) {
            if (Array.isArray(e)) {
                if (!Array.isArray(r) || e.length !== r.length) return !1;
                for(let n = 0; n < e.length; n++)if (!t(e[n], r[n])) return !1;
                return !0;
            }
            if ("object" == typeof e && null !== e && null !== r) {
                if ("object" != typeof r) return !1;
                if (Object.keys(e).length !== Object.keys(r).length) return !1;
                for(const n in e)if (!t(e[n], r[n])) return !1;
                return !0;
            }
            return e === r;
        }, t.aH = v, t.aI = b, t.aJ = ii, t.aK = function(t) {
            return t({
                pluginStatus: ti,
                pluginURL: ei
            }), ii.on("pluginStateChange", t), t;
        }, t.aL = class extends Ra {
            constructor(t, e){
                super(t, e), this.current = 0;
            }
            set(t) {
                this.current !== t && (this.current = t, this.gl.uniform1i(this.location, t));
            }
        }, t.aM = qa, t.aN = class extends Ra {
            constructor(t, e){
                super(t, e), this.current = Za;
            }
            set(t) {
                if (t[12] !== this.current[12] || t[0] !== this.current[0]) return this.current = t, void this.gl.uniformMatrix4fv(this.location, !1, t);
                for(let e = 1; e < 16; e++)if (t[e] !== this.current[e]) {
                    this.current = t, this.gl.uniformMatrix4fv(this.location, !1, t);
                    break;
                }
            }
        }, t.aO = ja, t.aP = class extends Ra {
            constructor(t, e){
                super(t, e), this.current = [
                    0,
                    0,
                    0
                ];
            }
            set(t) {
                t[0] === this.current[0] && t[1] === this.current[1] && t[2] === this.current[2] || (this.current = t, this.gl.uniform3f(this.location, t[0], t[1], t[2]));
            }
        }, t.aQ = class extends Ra {
            constructor(t, e){
                super(t, e), this.current = [
                    0,
                    0
                ];
            }
            set(t) {
                t[0] === this.current[0] && t[1] === this.current[1] || (this.current = t, this.gl.uniform2f(this.location, t[0], t[1]));
            }
        }, t.aR = Na, t.aS = function(t, e, r, n, i, a, s) {
            var o = 1 / (e - r), l = 1 / (n - i), u = 1 / (a - s);
            return t[0] = -2 * o, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = -2 * l, t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[10] = 2 * u, t[11] = 0, t[12] = (e + r) * o, t[13] = (i + n) * l, t[14] = (s + a) * u, t[15] = 1, t;
        }, t.aT = Yt, t.aU = Ps, t.aV = class extends qi {
        }, t.aW = Cl, t.aX = class extends Ni {
        }, t.aY = function(t) {
            return t <= 1 ? 1 : Math.pow(2, Math.ceil(Math.log(t) / Math.LN2));
        }, t.aZ = js, t.a_ = ha, t.aa = function(t) {
            const e = {};
            if (t.replace(/(?:^|(?:\s*\,\s*))([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)(?:\=(?:([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)|(?:\"((?:[^"\\]|\\.)*)\")))?/g, (t, r, n, i)=>{
                const a = n || i;
                return e[r] = !a || a.toLowerCase(), "";
            }), e["max-age"]) {
                const t = parseInt(e["max-age"], 10);
                isNaN(t) ? delete e["max-age"] : e["max-age"] = t;
            }
            return e;
        }, t.ab = function(t, e) {
            const r = [];
            for(const n in t)n in e || r.push(n);
            return r;
        }, t.ac = function(t) {
            if (null == z) {
                const e = t.navigator ? t.navigator.userAgent : null;
                z = !!t.safari || !(!e || !(/\b(iPad|iPhone|iPod)\b/.test(e) || e.match("Safari") && !e.match("Chrome")));
            }
            return z;
        }, t.ad = y, t.ae = function(t, e, r) {
            var n = Math.sin(r), i = Math.cos(r), a = e[0], s = e[1], o = e[2], l = e[3], u = e[4], c = e[5], h = e[6], p = e[7];
            return e !== t && (t[8] = e[8], t[9] = e[9], t[10] = e[10], t[11] = e[11], t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15]), t[0] = a * i + u * n, t[1] = s * i + c * n, t[2] = o * i + h * n, t[3] = l * i + p * n, t[4] = u * i - a * n, t[5] = c * i - s * n, t[6] = h * i - o * n, t[7] = p * i - l * n, t;
        }, t.af = function(t) {
            var e = new zs(16);
            return e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e[4] = t[4], e[5] = t[5], e[6] = t[6], e[7] = t[7], e[8] = t[8], e[9] = t[9], e[10] = t[10], e[11] = t[11], e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15], e;
        }, t.ag = Vs, t.ah = function(t, e) {
            let r = 0, n = 0;
            if ("constant" === t.kind) n = t.layoutSize;
            else if ("source" !== t.kind) {
                const { interpolationType: i, minZoom: a, maxZoom: s } = t, o = i ? y(Ke.interpolationFactor(i, e, a, s), 0, 1) : 0;
                "camera" === t.kind ? n = Ze.number(t.minSize, t.maxSize, o) : r = o;
            }
            return {
                uSizeT: r,
                uSize: n
            };
        }, t.aj = function(t, { uSize: e, uSizeT: r }, { lowerSize: n, upperSize: i }) {
            return "source" === t.kind ? n / Cu : "composite" === t.kind ? Ze.number(n / Cu, i / Cu, r) : e;
        }, t.ak = $u, t.al = function(t, e, r, n) {
            const i = e.y - t.y, s = e.x - t.x, o = n.y - r.y, l = n.x - r.x, u = o * s - l * i;
            if (0 === u) return null;
            const c = (l * (t.y - r.y) - o * (t.x - r.x)) / u;
            return new a(t.x + c * s, t.y + c * i);
        }, t.am = _c, t.an = us, t.ao = Ms, t.ap = Vl, t.ar = Vu, t.as = function(t, e) {
            var r = e[0], n = e[1], i = e[2], a = e[3], s = e[4], o = e[5], l = e[6], u = e[7], c = e[8], h = e[9], p = e[10], f = e[11], d = e[12], y = e[13], m = e[14], g = e[15], x = r * o - n * s, v = r * l - i * s, b = r * u - a * s, w = n * l - i * o, _ = n * u - a * o, A = i * u - a * l, S = c * y - h * d, k = c * m - p * d, I = c * g - f * d, z = h * m - p * y, M = h * g - f * y, C = p * g - f * m, B = x * C - v * M + b * z + w * I - _ * k + A * S;
            return B ? (t[0] = (o * C - l * M + u * z) * (B = 1 / B), t[1] = (i * M - n * C - a * z) * B, t[2] = (y * A - m * _ + g * w) * B, t[3] = (p * _ - h * A - f * w) * B, t[4] = (l * I - s * C - u * k) * B, t[5] = (r * C - i * I + a * k) * B, t[6] = (m * b - d * A - g * v) * B, t[7] = (c * A - p * b + f * v) * B, t[8] = (s * M - o * I + u * S) * B, t[9] = (n * I - r * M - a * S) * B, t[10] = (d * _ - y * b + g * x) * B, t[11] = (h * b - c * _ - f * x) * B, t[12] = (o * k - s * z - l * S) * B, t[13] = (r * z - n * k + i * S) * B, t[14] = (y * v - d * w - m * x) * B, t[15] = (c * w - h * v + p * x) * B, t) : null;
        }, t.at = Jc, t.au = Su, t.av = th, t.aw = function() {
            const t = {}, e = X.$version;
            for(const r in X.$root){
                const n = X.$root[r];
                if (n.required) {
                    let i = null;
                    i = "version" === r ? e : "array" === n.type ? [] : {}, null != i && (t[r] = i);
                }
            }
            return t;
        }, t.ax = Q, t.ay = Un, t.az = D, t.b = function(t, e) {
            const r = new Blob([
                new Uint8Array(t)
            ], {
                type: "image/png"
            });
            createImageBitmap(r).then((t)=>{
                e(null, t);
            }).catch((t)=>{
                e(new Error(`Could not load image because of ${t.message}. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported.`));
            });
        }, t.b0 = Aa, t.b1 = function(t, e) {
            var r = t[0], n = t[1], i = t[2], a = t[3], s = t[4], o = t[5], l = t[6], u = t[7], c = t[8], h = t[9], p = t[10], f = t[11], d = t[12], y = t[13], m = t[14], g = t[15], x = e[0], v = e[1], b = e[2], w = e[3], _ = e[4], A = e[5], S = e[6], k = e[7], I = e[8], z = e[9], M = e[10], C = e[11], B = e[12], P = e[13], V = e[14], E = e[15];
            return Math.abs(r - x) <= Is * Math.max(1, Math.abs(r), Math.abs(x)) && Math.abs(n - v) <= Is * Math.max(1, Math.abs(n), Math.abs(v)) && Math.abs(i - b) <= Is * Math.max(1, Math.abs(i), Math.abs(b)) && Math.abs(a - w) <= Is * Math.max(1, Math.abs(a), Math.abs(w)) && Math.abs(s - _) <= Is * Math.max(1, Math.abs(s), Math.abs(_)) && Math.abs(o - A) <= Is * Math.max(1, Math.abs(o), Math.abs(A)) && Math.abs(l - S) <= Is * Math.max(1, Math.abs(l), Math.abs(S)) && Math.abs(u - k) <= Is * Math.max(1, Math.abs(u), Math.abs(k)) && Math.abs(c - I) <= Is * Math.max(1, Math.abs(c), Math.abs(I)) && Math.abs(h - z) <= Is * Math.max(1, Math.abs(h), Math.abs(z)) && Math.abs(p - M) <= Is * Math.max(1, Math.abs(p), Math.abs(M)) && Math.abs(f - C) <= Is * Math.max(1, Math.abs(f), Math.abs(C)) && Math.abs(d - B) <= Is * Math.max(1, Math.abs(d), Math.abs(B)) && Math.abs(y - P) <= Is * Math.max(1, Math.abs(y), Math.abs(P)) && Math.abs(m - V) <= Is * Math.max(1, Math.abs(m), Math.abs(V)) && Math.abs(g - E) <= Is * Math.max(1, Math.abs(g), Math.abs(E));
        }, t.b2 = function(t, e) {
            return t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[3], t[4] = e[4], t[5] = e[5], t[6] = e[6], t[7] = e[7], t[8] = e[8], t[9] = e[9], t[10] = e[10], t[11] = e[11], t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15], t;
        }, t.b3 = function(t, e, r) {
            return t[0] = e[0] * r[0], t[1] = e[1] * r[1], t[2] = e[2] * r[2], t[3] = e[3] * r[3], t;
        }, t.b4 = function(t, e) {
            return t[0] * e[0] + t[1] * e[1] + t[2] * e[2] + t[3] * e[3];
        }, t.b5 = m, t.b6 = pc, t.b7 = sc, t.b8 = function(t, e, r, n, i) {
            var a, s = 1 / Math.tan(e / 2);
            return t[0] = s / r, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = s, t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[11] = -1, t[12] = 0, t[13] = 0, t[15] = 0, null != i && i !== 1 / 0 ? (t[10] = (i + n) * (a = 1 / (n - i)), t[14] = 2 * i * n * a) : (t[10] = -1, t[14] = -2 * n), t;
        }, t.b9 = function(t, e, r) {
            var n = Math.sin(r), i = Math.cos(r), a = e[4], s = e[5], o = e[6], l = e[7], u = e[8], c = e[9], h = e[10], p = e[11];
            return e !== t && (t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[3], t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15]), t[4] = a * i + u * n, t[5] = s * i + c * n, t[6] = o * i + h * n, t[7] = l * i + p * n, t[8] = u * i - a * n, t[9] = c * i - s * n, t[10] = h * i - o * n, t[11] = p * i - l * n, t;
        }, t.bA = n, t.bB = El, t.bC = $r, t.bD = oi, t.ba = f, t.bb = d, t.bc = function(t, e) {
            return t[0] = e[0], t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = e[1], t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[10] = e[2], t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, t;
        }, t.bd = class extends Pi {
        }, t.be = tc, t.bf = oc, t.bg = ph, t.bi = L, t.bj = function(t, e, r = !1) {
            if (ti === Yn || ti === Hn || ti === Wn) throw new Error("setRTLTextPlugin cannot be called multiple times.");
            ei = T.resolveURL(t), ti = Yn, Qn = e, ni(), r || si();
        }, t.bk = ai, t.bl = function(t, e) {
            const r = {};
            for(let n = 0; n < t.length; n++){
                const i = e && e[t[n].id] || Qr(t[n]);
                e && (e[t[n].id] = i);
                let a = r[i];
                a || (a = r[i] = []), a.push(t[n]);
            }
            const n = [];
            for(const t in r)n.push(r[t]);
            return n;
        }, t.bm = $n, t.bn = mc, t.bo = xc, t.bp = cu, t.bq = function(e) {
            e.bucket.createArrays(), e.bucket.tilePixelRatio = rs / (512 * e.bucket.overscaling), e.bucket.compareText = {}, e.bucket.iconsNeedLinear = !1;
            const r = e.bucket.layers[0], n = r.layout, i = r._unevaluatedLayout._values, a = {
                layoutIconSize: i["icon-size"].possiblyEvaluate(new li(e.bucket.zoom + 1), e.canonical),
                layoutTextSize: i["text-size"].possiblyEvaluate(new li(e.bucket.zoom + 1), e.canonical),
                textMaxSize: i["text-size"].possiblyEvaluate(new li(18))
            };
            if ("composite" === e.bucket.textSizeData.kind) {
                const { minZoom: t, maxZoom: r } = e.bucket.textSizeData;
                a.compositeTextSizes = [
                    i["text-size"].possiblyEvaluate(new li(t), e.canonical),
                    i["text-size"].possiblyEvaluate(new li(r), e.canonical)
                ];
            }
            if ("composite" === e.bucket.iconSizeData.kind) {
                const { minZoom: t, maxZoom: r } = e.bucket.iconSizeData;
                a.compositeIconSizes = [
                    i["icon-size"].possiblyEvaluate(new li(t), e.canonical),
                    i["icon-size"].possiblyEvaluate(new li(r), e.canonical)
                ];
            }
            const s = n.get("text-line-height") * Vl, o = "viewport" !== n.get("text-rotation-alignment") && "point" !== n.get("symbol-placement"), l = n.get("text-keep-upright"), u = n.get("text-size");
            for (const i of e.bucket.features){
                const c = n.get("text-font").evaluate(i, {}, e.canonical).join(","), h = u.evaluate(i, {}, e.canonical), p = a.layoutTextSize.evaluate(i, {}, e.canonical), f = a.layoutIconSize.evaluate(i, {}, e.canonical), d = {
                    horizontal: {},
                    vertical: void 0
                }, y = i.text;
                let m, g = [
                    0,
                    0
                ];
                if (y) {
                    const a = y.toString(), u = n.get("text-letter-spacing").evaluate(i, {}, e.canonical) * Vl, f = jn(a) ? u : 0, m = n.get("text-anchor").evaluate(i, {}, e.canonical), x = Gc(r, i, e.canonical);
                    if (!x) {
                        const t = n.get("text-radial-offset").evaluate(i, {}, e.canonical);
                        g = t ? Kc(m, [
                            t * Vl,
                            Zc
                        ]) : n.get("text-offset").evaluate(i, {}, e.canonical).map((t)=>t * Vl);
                    }
                    let v = o ? "center" : n.get("text-justify").evaluate(i, {}, e.canonical);
                    const b = n.get("symbol-placement"), w = "point" === b ? n.get("text-max-width").evaluate(i, {}, e.canonical) * Vl : 0, _ = ()=>{
                        e.bucket.allowVerticalPlacement && qn(a) && (d.vertical = yu(y, e.glyphMap, e.glyphPositions, e.imagePositions, c, w, s, m, "left", f, g, t.ai.vertical, !0, b, p, h));
                    };
                    if (!o && x) {
                        const r = new Set;
                        if ("auto" === v) for(let t = 0; t < x.values.length; t += 2)r.add(Jc(x.values[t]));
                        else r.add(v);
                        let n = !1;
                        for (const i of r)if (!d.horizontal[i]) {
                            if (n) d.horizontal[i] = d.horizontal[0];
                            else {
                                const r = yu(y, e.glyphMap, e.glyphPositions, e.imagePositions, c, w, s, "center", i, f, g, t.ai.horizontal, !1, b, p, h);
                                r && (d.horizontal[i] = r, n = 1 === r.positionedLines.length);
                            }
                        }
                        _();
                    } else {
                        "auto" === v && (v = Jc(m));
                        const r = yu(y, e.glyphMap, e.glyphPositions, e.imagePositions, c, w, s, m, v, f, g, t.ai.horizontal, !1, b, p, h);
                        r && (d.horizontal[v] = r), _(), qn(a) && o && l && (d.vertical = yu(y, e.glyphMap, e.glyphPositions, e.imagePositions, c, w, s, m, v, f, g, t.ai.vertical, !1, b, p, h));
                    }
                }
                let x = !1;
                if (i.icon && i.icon.name) {
                    const t = e.imageMap[i.icon.name];
                    t && (m = Iu(e.imagePositions[i.icon.name], n.get("icon-offset").evaluate(i, {}, e.canonical), n.get("icon-anchor").evaluate(i, {}, e.canonical)), x = !!t.sdf, void 0 === e.bucket.sdfIcons ? e.bucket.sdfIcons = x : e.bucket.sdfIcons !== x && A("Style sheet warning: Cannot mix SDF and non-SDF icons in one buffer"), (t.pixelRatio !== e.bucket.pixelRatio || 0 !== n.get("icon-rotate").constantOr(1)) && (e.bucket.iconsNeedLinear = !0));
                }
                const v = Hc(d.horizontal) || d.vertical;
                e.bucket.iconsInText = !!v && v.iconsInText, (v || m) && Xc(e.bucket, i, d, m, e.imageMap, a, p, f, g, x, e.canonical);
            }
            e.showCollisionBoxes && e.bucket.generateCollisionDebugBuffers();
        }, t.br = gl, t.bs = Eo, t.bt = rl, t.bu = class {
            constructor(t){
                this._marks = {
                    start: [
                        t.url,
                        "start"
                    ].join("#"),
                    end: [
                        t.url,
                        "end"
                    ].join("#"),
                    measure: t.url.toString()
                }, performance.mark(this._marks.start);
            }
            finish() {
                performance.mark(this._marks.end);
                let t = performance.getEntriesByName(this._marks.measure);
                return 0 === t.length && (performance.measure(this._marks.measure, this._marks.start, this._marks.end), t = performance.getEntriesByName(this._marks.measure), performance.clearMarks(this._marks.start), performance.clearMarks(this._marks.end), performance.clearMeasures(this._marks.measure)), t;
            }
        }, t.bv = eu, t.bw = Ro, t.bx = function(t, r, n, i, a) {
            return e(this, void 0, void 0, function*() {
                if (p()) try {
                    return yield B(t, r, n, i, a);
                } catch (t) {}
                return function(t, e, r, n, i) {
                    const a = t.width, s = t.height;
                    P && V || (P = new OffscreenCanvas(a, s), V = P.getContext("2d", {
                        willReadFrequently: !0
                    })), P.width = a, P.height = s, V.drawImage(t, 0, 0, a, s);
                    const o = V.getImageData(e, r, n, i);
                    return V.clearRect(0, 0, a, s), o.data;
                }(t, r, n, i, a);
            });
        }, t.by = yc, t.bz = r, t.c = $, t.d = function(t, e) {
            const r = new Image;
            r.onload = ()=>{
                e(null, r), URL.revokeObjectURL(r.src), r.onload = null, window.requestAnimationFrame(()=>{
                    r.src = C;
                });
            }, r.onerror = ()=>e(new Error("Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."));
            const n = new Blob([
                new Uint8Array(t)
            ], {
                type: "image/png"
            });
            r.src = t.byteLength ? URL.createObjectURL(n) : C;
        }, t.e = g, t.f = function(t, e) {
            return R(g(t, {
                type: "json"
            }), e);
        }, t.g = O, t.h = T, t.i = I, t.j = G, t.k = K, t.l = q, t.m = R, t.n = function(t) {
            return new eu(t).readFields(nu, []);
        }, t.o = function(t, e, r) {
            if (!t.length) return r(null, []);
            let n = t.length;
            const i = new Array(t.length);
            let a = null;
            t.forEach((t, s)=>{
                e(t, (t, e)=>{
                    t && (a = t), i[s] = e, 0 == --n && r(a, i);
                });
            });
        }, t.p = ou, t.q = Rs, t.r = _i, t.s = j, t.t = Bn, t.u = Rn, t.v = X, t.w = A, t.x = En, t.y = Cn, t.z = function([t, e, r]) {
            return e += 90, e *= Math.PI / 180, r *= Math.PI / 180, {
                x: t * Math.cos(e) * Math.sin(r),
                y: t * Math.sin(e) * Math.sin(r),
                z: t * Math.cos(r)
            };
        };
    });
    define([
        "./shared"
    ], function(e) {
        "use strict";
        class t {
            constructor(e){
                this.keyCache = {}, e && this.replace(e);
            }
            replace(e) {
                this._layerConfigs = {}, this._layers = {}, this.update(e, []);
            }
            update(t, i) {
                for (const i of t){
                    this._layerConfigs[i.id] = i;
                    const t = this._layers[i.id] = e.aC(i);
                    t._featureFilter = e.a6(t.filter), this.keyCache[i.id] && delete this.keyCache[i.id];
                }
                for (const e of i)delete this.keyCache[e], delete this._layerConfigs[e], delete this._layers[e];
                this.familiesBySource = {};
                const o = e.bl(Object.values(this._layerConfigs), this.keyCache);
                for (const e of o){
                    const t = e.map((e)=>this._layers[e.id]), i = t[0];
                    if ("none" === i.visibility) continue;
                    const o = i.source || "";
                    let r = this.familiesBySource[o];
                    r || (r = this.familiesBySource[o] = {});
                    const s = i.sourceLayer || "_geojsonTileLayer";
                    let n = r[s];
                    n || (n = r[s] = []), n.push(t);
                }
            }
        }
        class i {
            constructor(t){
                const i = {}, o = [];
                for(const e in t){
                    const r = t[e], s = i[e] = {};
                    for(const e in r){
                        const t = r[+e];
                        if (!t || 0 === t.bitmap.width || 0 === t.bitmap.height) continue;
                        const i = {
                            x: 0,
                            y: 0,
                            w: t.bitmap.width + 2,
                            h: t.bitmap.height + 2
                        };
                        o.push(i), s[e] = {
                            rect: i,
                            metrics: t.metrics
                        };
                    }
                }
                const { w: r, h: s } = e.p(o), n = new e.q({
                    width: r || 1,
                    height: s || 1
                });
                for(const o in t){
                    const r = t[o];
                    for(const t in r){
                        const s = r[+t];
                        if (!s || 0 === s.bitmap.width || 0 === s.bitmap.height) continue;
                        const a = i[o][t].rect;
                        e.q.copy(s.bitmap, n, {
                            x: 0,
                            y: 0
                        }, {
                            x: a.x + 1,
                            y: a.y + 1
                        }, s.bitmap);
                    }
                }
                this.image = n, this.positions = i;
            }
        }
        e.bm("GlyphAtlas", i);
        class o {
            constructor(t){
                this.tileID = new e.O(t.tileID.overscaledZ, t.tileID.wrap, t.tileID.canonical.z, t.tileID.canonical.x, t.tileID.canonical.y), this.uid = t.uid, this.zoom = t.zoom, this.pixelRatio = t.pixelRatio, this.tileSize = t.tileSize, this.source = t.source, this.overscaling = this.tileID.overscaleFactor(), this.showCollisionBoxes = t.showCollisionBoxes, this.collectResourceTiming = !!t.collectResourceTiming, this.returnDependencies = !!t.returnDependencies, this.promoteId = t.promoteId, this.inFlightDependencies = [], this.dependencySentinel = -1;
            }
            parse(t, o, s, n, a) {
                this.status = "parsing", this.data = t, this.collisionBoxArray = new e.a3;
                const l = new e.bn(Object.keys(t.layers).sort()), c = new e.bo(this.tileID, this.promoteId);
                c.bucketLayerIDs = [];
                const h = {}, u = {
                    featureIndex: c,
                    iconDependencies: {},
                    patternDependencies: {},
                    glyphDependencies: {},
                    availableImages: s
                }, d = o.familiesBySource[this.source];
                for(const i in d){
                    const o = t.layers[i];
                    if (!o) continue;
                    1 === o.version && e.w(`Vector tile source "${this.source}" layer "${i}" does not use vector tile spec v2 and therefore may have some rendering errors.`);
                    const n = l.encode(i), a = [];
                    for(let e = 0; e < o.length; e++){
                        const t = o.feature(e), r = c.getId(t, i);
                        a.push({
                            feature: t,
                            id: r,
                            index: e,
                            sourceLayerIndex: n
                        });
                    }
                    for (const t of d[i]){
                        const i = t[0];
                        i.source !== this.source && e.w(`layer.source = ${i.source} does not equal this.source = ${this.source}`), i.minzoom && this.zoom < Math.floor(i.minzoom) || i.maxzoom && this.zoom >= i.maxzoom || "none" !== i.visibility && (r(t, this.zoom, s), (h[i.id] = i.createBucket({
                            index: c.bucketLayerIDs.length,
                            layers: t,
                            zoom: this.zoom,
                            pixelRatio: this.pixelRatio,
                            overscaling: this.overscaling,
                            collisionBoxArray: this.collisionBoxArray,
                            sourceLayerIndex: n,
                            sourceID: this.source
                        })).populate(a, u, this.tileID.canonical), c.bucketLayerIDs.push(t.map((e)=>e.id)));
                    }
                }
                let p, f, g, m;
                const y = e.aH(u.glyphDependencies, (e)=>Object.keys(e).map(Number));
                this.inFlightDependencies.forEach((e)=>null == e ? void 0 : e.cancel()), this.inFlightDependencies = [];
                const v = ++this.dependencySentinel;
                Object.keys(y).length ? this.inFlightDependencies.push(n.send("getGlyphs", {
                    uid: this.uid,
                    stacks: y,
                    source: this.source,
                    tileID: this.tileID,
                    type: "glyphs"
                }, (e, t)=>{
                    v === this.dependencySentinel && (p || (p = e, f = t, b.call(this)));
                })) : f = {};
                const w = Object.keys(u.iconDependencies);
                w.length ? this.inFlightDependencies.push(n.send("getImages", {
                    icons: w,
                    source: this.source,
                    tileID: this.tileID,
                    type: "icons"
                }, (e, t)=>{
                    v === this.dependencySentinel && (p || (p = e, g = t, b.call(this)));
                })) : g = {};
                const x = Object.keys(u.patternDependencies);
                function b() {
                    if (p) return a(p);
                    if (f && g && m) {
                        const t = new i(f), o = new e.bp(g, m);
                        for(const i in h){
                            const n = h[i];
                            n instanceof e.a4 ? (r(n.layers, this.zoom, s), e.bq({
                                bucket: n,
                                glyphMap: f,
                                glyphPositions: t.positions,
                                imageMap: g,
                                imagePositions: o.iconPositions,
                                showCollisionBoxes: this.showCollisionBoxes,
                                canonical: this.tileID.canonical
                            })) : n.hasPattern && (n instanceof e.br || n instanceof e.bs || n instanceof e.bt) && (r(n.layers, this.zoom, s), n.addFeatures(u, this.tileID.canonical, o.patternPositions));
                        }
                        this.status = "done", a(null, {
                            buckets: Object.values(h).filter((e)=>!e.isEmpty()),
                            featureIndex: c,
                            collisionBoxArray: this.collisionBoxArray,
                            glyphAtlasImage: t.image,
                            imageAtlas: o,
                            glyphMap: this.returnDependencies ? f : null,
                            iconMap: this.returnDependencies ? g : null,
                            glyphPositions: this.returnDependencies ? t.positions : null
                        });
                    }
                }
                x.length ? this.inFlightDependencies.push(n.send("getImages", {
                    icons: x,
                    source: this.source,
                    tileID: this.tileID,
                    type: "patterns"
                }, (e, t)=>{
                    v === this.dependencySentinel && (p || (p = e, m = t, b.call(this)));
                })) : m = {}, b.call(this);
            }
        }
        function r(t, i, o) {
            const r = new e.a8(i);
            for (const e of t)e.recalculate(r, o);
        }
        function s(t, i) {
            const o = e.l(t.request, (o, r, s, n)=>{
                if (o) i(o);
                else if (r) try {
                    const t = new e.bw.VectorTile(new e.bv(r));
                    i(null, {
                        vectorTile: t,
                        rawData: r,
                        cacheControl: s,
                        expires: n
                    });
                } catch (e) {
                    const o = new Uint8Array(r);
                    let s = `Unable to parse the tile at ${t.request.url}, `;
                    s += 31 === o[0] && 139 === o[1] ? "please make sure the data is not gzipped and that you have configured the relevant header in the server" : `got error: ${e.messge}`, i(new Error(s));
                }
            });
            return ()=>{
                o.cancel(), i();
            };
        }
        class n {
            constructor(e, t, i, o){
                this.actor = e, this.layerIndex = t, this.availableImages = i, this.loadVectorData = o || s, this.fetching = {}, this.loading = {}, this.loaded = {};
            }
            loadTile(t, i) {
                const r = t.uid;
                this.loading || (this.loading = {});
                const s = !!(t && t.request && t.request.collectResourceTiming) && new e.bu(t.request), n = this.loading[r] = new o(t);
                n.abort = this.loadVectorData(t, (t, o)=>{
                    if (delete this.loading[r], t || !o) return n.status = "done", this.loaded[r] = n, i(t);
                    const a = o.rawData, l = {};
                    o.expires && (l.expires = o.expires), o.cacheControl && (l.cacheControl = o.cacheControl);
                    const c = {};
                    if (s) {
                        const e = s.finish();
                        e && (c.resourceTiming = JSON.parse(JSON.stringify(e)));
                    }
                    n.vectorTile = o.vectorTile, n.parse(o.vectorTile, this.layerIndex, this.availableImages, this.actor, (t, o)=>{
                        if (delete this.fetching[r], t || !o) return i(t);
                        i(null, e.e({
                            rawTileData: a.slice(0)
                        }, o, l, c));
                    }), this.loaded = this.loaded || {}, this.loaded[r] = n, this.fetching[r] = {
                        rawTileData: a,
                        cacheControl: l,
                        resourceTiming: c
                    };
                });
            }
            reloadTile(t, i) {
                const o = this.loaded, r = t.uid;
                if (o && o[r]) {
                    const s = o[r];
                    s.showCollisionBoxes = t.showCollisionBoxes, "parsing" === s.status ? s.parse(s.vectorTile, this.layerIndex, this.availableImages, this.actor, (t, o)=>{
                        if (t || !o) return i(t, o);
                        let s;
                        if (this.fetching[r]) {
                            const { rawTileData: t, cacheControl: i, resourceTiming: n } = this.fetching[r];
                            delete this.fetching[r], s = e.e({
                                rawTileData: t.slice(0)
                            }, o, i, n);
                        } else s = o;
                        i(null, s);
                    }) : "done" === s.status && (s.vectorTile ? s.parse(s.vectorTile, this.layerIndex, this.availableImages, this.actor, i) : i());
                }
            }
            abortTile(e, t) {
                const i = this.loading, o = e.uid;
                i && i[o] && i[o].abort && (i[o].abort(), delete i[o]), t();
            }
            removeTile(e, t) {
                const i = this.loaded, o = e.uid;
                i && i[o] && delete i[o], t();
            }
        }
        class a {
            constructor(){
                this.loaded = {};
            }
            loadTile(t, i) {
                return e._(this, void 0, void 0, function*() {
                    const { uid: o, encoding: r, rawImageData: s, redFactor: n, greenFactor: a, blueFactor: l, baseShift: c } = t, h = s.width + 2, u = s.height + 2, d = e.a(s) ? new e.R({
                        width: h,
                        height: u
                    }, (yield e.bx(s, -1, -1, h, u))) : s, p = new e.by(o, d, r, n, a, l, c);
                    this.loaded = this.loaded || {}, this.loaded[o] = p, i(null, p);
                });
            }
            removeTile(e) {
                const t = this.loaded, i = e.uid;
                t && t[i] && delete t[i];
            }
        }
        function l(e, t) {
            if (0 !== e.length) {
                c(e[0], t);
                for(var i = 1; i < e.length; i++)c(e[i], !t);
            }
        }
        function c(e, t) {
            for(var i = 0, o = 0, r = 0, s = e.length, n = s - 1; r < s; n = r++){
                var a = (e[r][0] - e[n][0]) * (e[n][1] + e[r][1]), l = i + a;
                o += Math.abs(i) >= Math.abs(a) ? i - l + a : a - l + i, i = l;
            }
            i + o >= 0 != !!t && e.reverse();
        }
        var h = e.bz(function e(t, i) {
            var o, r = t && t.type;
            if ("FeatureCollection" === r) for(o = 0; o < t.features.length; o++)e(t.features[o], i);
            else if ("GeometryCollection" === r) for(o = 0; o < t.geometries.length; o++)e(t.geometries[o], i);
            else if ("Feature" === r) e(t.geometry, i);
            else if ("Polygon" === r) l(t.coordinates, i);
            else if ("MultiPolygon" === r) for(o = 0; o < t.coordinates.length; o++)l(t.coordinates[o], i);
            return t;
        });
        const u = e.bw.VectorTileFeature.prototype.toGeoJSON;
        var d = {
            exports: {}
        }, p = e.bA, f = e.bw.VectorTileFeature, g = m;
        function m(e, t) {
            this.options = t || {}, this.features = e, this.length = e.length;
        }
        function y(e, t) {
            this.id = "number" == typeof e.id ? e.id : void 0, this.type = e.type, this.rawGeometry = 1 === e.type ? [
                e.geometry
            ] : e.geometry, this.properties = e.tags, this.extent = t || 4096;
        }
        m.prototype.feature = function(e) {
            return new y(this.features[e], this.options.extent);
        }, y.prototype.loadGeometry = function() {
            var e = this.rawGeometry;
            this.geometry = [];
            for(var t = 0; t < e.length; t++){
                for(var i = e[t], o = [], r = 0; r < i.length; r++)o.push(new p(i[r][0], i[r][1]));
                this.geometry.push(o);
            }
            return this.geometry;
        }, y.prototype.bbox = function() {
            this.geometry || this.loadGeometry();
            for(var e = this.geometry, t = 1 / 0, i = -1 / 0, o = 1 / 0, r = -1 / 0, s = 0; s < e.length; s++)for(var n = e[s], a = 0; a < n.length; a++){
                var l = n[a];
                t = Math.min(t, l.x), i = Math.max(i, l.x), o = Math.min(o, l.y), r = Math.max(r, l.y);
            }
            return [
                t,
                o,
                i,
                r
            ];
        }, y.prototype.toGeoJSON = f.prototype.toGeoJSON;
        var v = e.bB, w = g;
        function x(e) {
            var t = new v;
            return function(e, t) {
                for(var i in e.layers)t.writeMessage(3, b, e.layers[i]);
            }(e, t), t.finish();
        }
        function b(e, t) {
            var i;
            t.writeVarintField(15, e.version || 1), t.writeStringField(1, e.name || ""), t.writeVarintField(5, e.extent || 4096);
            var o = {
                keys: [],
                values: [],
                keycache: {},
                valuecache: {}
            };
            for(i = 0; i < e.length; i++)o.feature = e.feature(i), t.writeMessage(2, S, o);
            var r = o.keys;
            for(i = 0; i < r.length; i++)t.writeStringField(3, r[i]);
            var s = o.values;
            for(i = 0; i < s.length; i++)t.writeMessage(4, _, s[i]);
        }
        function S(e, t) {
            var i = e.feature;
            void 0 !== i.id && t.writeVarintField(1, i.id), t.writeMessage(2, M, e), t.writeVarintField(3, i.type), t.writeMessage(4, T, i);
        }
        function M(e, t) {
            var i = e.feature, o = e.keys, r = e.values, s = e.keycache, n = e.valuecache;
            for(var a in i.properties){
                var l = i.properties[a], c = s[a];
                if (null !== l) {
                    void 0 === c && (o.push(a), s[a] = c = o.length - 1), t.writeVarint(c);
                    var h = typeof l;
                    "string" !== h && "boolean" !== h && "number" !== h && (l = JSON.stringify(l));
                    var u = h + ":" + l, d = n[u];
                    void 0 === d && (r.push(l), n[u] = d = r.length - 1), t.writeVarint(d);
                }
            }
        }
        function I(e, t) {
            return (t << 3) + (7 & e);
        }
        function P(e) {
            return e << 1 ^ e >> 31;
        }
        function T(e, t) {
            for(var i = e.loadGeometry(), o = e.type, r = 0, s = 0, n = i.length, a = 0; a < n; a++){
                var l = i[a], c = 1;
                1 === o && (c = l.length), t.writeVarint(I(1, c));
                for(var h = 3 === o ? l.length - 1 : l.length, u = 0; u < h; u++){
                    1 === u && 1 !== o && t.writeVarint(I(2, h - 1));
                    var d = l[u].x - r, p = l[u].y - s;
                    t.writeVarint(P(d)), t.writeVarint(P(p)), r += d, s += p;
                }
                3 === o && t.writeVarint(I(7, 1));
            }
        }
        function _(e, t) {
            var i = typeof e;
            "string" === i ? t.writeStringField(1, e) : "boolean" === i ? t.writeBooleanField(7, e) : "number" === i && (e % 1 != 0 ? t.writeDoubleField(3, e) : e < 0 ? t.writeSVarintField(6, e) : t.writeVarintField(5, e));
        }
        d.exports = x, d.exports.fromVectorTileJs = x, d.exports.fromGeojsonVt = function(e, t) {
            t = t || {};
            var i = {};
            for(var o in e)i[o] = new w(e[o].features, t), i[o].name = o, i[o].version = t.version, i[o].extent = t.extent;
            return x({
                layers: i
            });
        }, d.exports.GeoJSONWrapper = w;
        var k = e.bz(d.exports);
        const D = {
            minZoom: 0,
            maxZoom: 16,
            minPoints: 2,
            radius: 40,
            extent: 512,
            nodeSize: 64,
            log: !1,
            generateId: !1,
            reduce: null,
            map: (e)=>e
        }, O = Math.fround || (C = new Float32Array(1), (e)=>(C[0] = +e, C[0]));
        var C;
        const L = 3, F = 5, z = 6;
        class N {
            constructor(e){
                this.options = Object.assign(Object.create(D), e), this.trees = new Array(this.options.maxZoom + 1), this.stride = this.options.reduce ? 7 : 6, this.clusterProps = [];
            }
            load(e) {
                const { log: t, minZoom: i, maxZoom: o } = this.options;
                t && console.time("total time");
                const r = `prepare ${e.length} points`;
                t && console.time(r), this.points = e;
                const s = [];
                for(let t = 0; t < e.length; t++){
                    const i = e[t];
                    if (!i.geometry) continue;
                    const [o, r] = i.geometry.coordinates, n = O(Z(o)), a = O(G(r));
                    s.push(n, a, 1 / 0, t, -1, 1), this.options.reduce && s.push(0);
                }
                let n = this.trees[o + 1] = this._createTree(s);
                t && console.timeEnd(r);
                for(let e = o; e >= i; e--){
                    const i = +Date.now();
                    n = this.trees[e] = this._createTree(this._cluster(n, e)), t && console.log("z%d: %d clusters in %dms", e, n.numItems, +Date.now() - i);
                }
                return t && console.timeEnd("total time"), this;
            }
            getClusters(e, t) {
                let i = ((e[0] + 180) % 360 + 360) % 360 - 180;
                const o = Math.max(-90, Math.min(90, e[1]));
                let r = 180 === e[2] ? 180 : ((e[2] + 180) % 360 + 360) % 360 - 180;
                const s = Math.max(-90, Math.min(90, e[3]));
                if (e[2] - e[0] >= 360) i = -180, r = 180;
                else if (i > r) {
                    const e = this.getClusters([
                        i,
                        o,
                        180,
                        s
                    ], t), n = this.getClusters([
                        -180,
                        o,
                        r,
                        s
                    ], t);
                    return e.concat(n);
                }
                const n = this.trees[this._limitZoom(t)], a = n.range(Z(i), G(s), Z(r), G(o)), l = n.data, c = [];
                for (const e of a){
                    const t = this.stride * e;
                    c.push(l[t + F] > 1 ? E(l, t, this.clusterProps) : this.points[l[t + L]]);
                }
                return c;
            }
            getChildren(e) {
                const t = this._getOriginId(e), i = this._getOriginZoom(e), o = "No cluster with the specified id.", r = this.trees[i];
                if (!r) throw new Error(o);
                const s = r.data;
                if (t * this.stride >= s.length) throw new Error(o);
                const n = this.options.radius / (this.options.extent * Math.pow(2, i - 1)), a = r.within(s[t * this.stride], s[t * this.stride + 1], n), l = [];
                for (const t of a){
                    const i = t * this.stride;
                    s[i + 4] === e && l.push(s[i + F] > 1 ? E(s, i, this.clusterProps) : this.points[s[i + L]]);
                }
                if (0 === l.length) throw new Error(o);
                return l;
            }
            getLeaves(e, t, i) {
                const o = [];
                return this._appendLeaves(o, e, t = t || 10, i = i || 0, 0), o;
            }
            getTile(e, t, i) {
                const o = this.trees[this._limitZoom(e)], r = Math.pow(2, e), { extent: s, radius: n } = this.options, a = n / s, l = (i - a) / r, c = (i + 1 + a) / r, h = {
                    features: []
                };
                return this._addTileFeatures(o.range((t - a) / r, l, (t + 1 + a) / r, c), o.data, t, i, r, h), 0 === t && this._addTileFeatures(o.range(1 - a / r, l, 1, c), o.data, r, i, r, h), t === r - 1 && this._addTileFeatures(o.range(0, l, a / r, c), o.data, -1, i, r, h), h.features.length ? h : null;
            }
            getClusterExpansionZoom(e) {
                let t = this._getOriginZoom(e) - 1;
                for(; t <= this.options.maxZoom;){
                    const i = this.getChildren(e);
                    if (t++, 1 !== i.length) break;
                    e = i[0].properties.cluster_id;
                }
                return t;
            }
            _appendLeaves(e, t, i, o, r) {
                const s = this.getChildren(t);
                for (const t of s){
                    const s = t.properties;
                    if (s && s.cluster ? r + s.point_count <= o ? r += s.point_count : r = this._appendLeaves(e, s.cluster_id, i, o, r) : r < o ? r++ : e.push(t), e.length === i) break;
                }
                return r;
            }
            _createTree(t) {
                const i = new e.av(t.length / this.stride | 0, this.options.nodeSize, Float32Array);
                for(let e = 0; e < t.length; e += this.stride)i.add(t[e], t[e + 1]);
                return i.finish(), i.data = t, i;
            }
            _addTileFeatures(e, t, i, o, r, s) {
                for (const n of e){
                    const e = n * this.stride, a = t[e + F] > 1;
                    let l, c, h;
                    if (a) l = j(t, e, this.clusterProps), c = t[e], h = t[e + 1];
                    else {
                        const i = this.points[t[e + L]];
                        l = i.properties;
                        const [o, r] = i.geometry.coordinates;
                        c = Z(o), h = G(r);
                    }
                    const u = {
                        type: 1,
                        geometry: [
                            [
                                Math.round(this.options.extent * (c * r - i)),
                                Math.round(this.options.extent * (h * r - o))
                            ]
                        ],
                        tags: l
                    };
                    let d;
                    d = a || this.options.generateId ? t[e + L] : this.points[t[e + L]].id, void 0 !== d && (u.id = d), s.features.push(u);
                }
            }
            _limitZoom(e) {
                return Math.max(this.options.minZoom, Math.min(Math.floor(+e), this.options.maxZoom + 1));
            }
            _cluster(e, t) {
                const { radius: i, extent: o, reduce: r, minPoints: s } = this.options, n = i / (o * Math.pow(2, t)), a = e.data, l = [], c = this.stride;
                for(let i = 0; i < a.length; i += c){
                    if (a[i + 2] <= t) continue;
                    a[i + 2] = t;
                    const o = a[i], h = a[i + 1], u = e.within(a[i], a[i + 1], n), d = a[i + F];
                    let p = d;
                    for (const e of u){
                        const i = e * c;
                        a[i + 2] > t && (p += a[i + F]);
                    }
                    if (p > d && p >= s) {
                        let e, s = o * d, n = h * d, f = -1;
                        const g = ((i / c | 0) << 5) + (t + 1) + this.points.length;
                        for (const o of u){
                            const l = o * c;
                            if (a[l + 2] <= t) continue;
                            a[l + 2] = t;
                            const h = a[l + F];
                            s += a[l] * h, n += a[l + 1] * h, a[l + 4] = g, r && (e || (e = this._map(a, i, !0), f = this.clusterProps.length, this.clusterProps.push(e)), r(e, this._map(a, l)));
                        }
                        a[i + 4] = g, l.push(s / p, n / p, 1 / 0, g, -1, p), r && l.push(f);
                    } else {
                        for(let e = 0; e < c; e++)l.push(a[i + e]);
                        if (p > 1) for (const e of u){
                            const i = e * c;
                            if (!(a[i + 2] <= t)) {
                                a[i + 2] = t;
                                for(let e = 0; e < c; e++)l.push(a[i + e]);
                            }
                        }
                    }
                }
                return l;
            }
            _getOriginId(e) {
                return e - this.points.length >> 5;
            }
            _getOriginZoom(e) {
                return (e - this.points.length) % 32;
            }
            _map(e, t, i) {
                if (e[t + F] > 1) {
                    const o = this.clusterProps[e[t + z]];
                    return i ? Object.assign({}, o) : o;
                }
                const o = this.points[e[t + L]].properties, r = this.options.map(o);
                return i && r === o ? Object.assign({}, r) : r;
            }
        }
        function E(e, t, i) {
            var o;
            return {
                type: "Feature",
                id: e[t + L],
                properties: j(e, t, i),
                geometry: {
                    type: "Point",
                    coordinates: [
                        (o = e[t], 360 * (o - .5)),
                        J(e[t + 1])
                    ]
                }
            };
        }
        function j(e, t, i) {
            const o = e[t + F], r = o >= 1e4 ? `${Math.round(o / 1e3)}k` : o >= 1e3 ? Math.round(o / 100) / 10 + "k" : o, s = e[t + z], n = -1 === s ? {} : Object.assign({}, i[s]);
            return Object.assign(n, {
                cluster: !0,
                cluster_id: e[t + L],
                point_count: o,
                point_count_abbreviated: r
            });
        }
        function Z(e) {
            return e / 360 + .5;
        }
        function G(e) {
            const t = Math.sin(e * Math.PI / 180), i = .5 - .25 * Math.log((1 + t) / (1 - t)) / Math.PI;
            return i < 0 ? 0 : i > 1 ? 1 : i;
        }
        function J(e) {
            const t = (180 - 360 * e) * Math.PI / 180;
            return 360 * Math.atan(Math.exp(t)) / Math.PI - 90;
        }
        function Y(e, t, i, o) {
            for(var r, s = o, n = i - t >> 1, a = i - t, l = e[t], c = e[t + 1], h = e[i], u = e[i + 1], d = t + 3; d < i; d += 3){
                var p = A(e[d], e[d + 1], l, c, h, u);
                if (p > s) r = d, s = p;
                else if (p === s) {
                    var f = Math.abs(d - n);
                    f < a && (r = d, a = f);
                }
            }
            s > o && (r - t > 3 && Y(e, t, r, o), e[r + 2] = s, i - r > 3 && Y(e, r, i, o));
        }
        function A(e, t, i, o, r, s) {
            var n = r - i, a = s - o;
            if (0 !== n || 0 !== a) {
                var l = ((e - i) * n + (t - o) * a) / (n * n + a * a);
                l > 1 ? (i = r, o = s) : l > 0 && (i += n * l, o += a * l);
            }
            return (n = e - i) * n + (a = t - o) * a;
        }
        function V(e, t, i, o) {
            var r = {
                id: void 0 === e ? null : e,
                type: t,
                geometry: i,
                tags: o,
                minX: 1 / 0,
                minY: 1 / 0,
                maxX: -1 / 0,
                maxY: -1 / 0
            };
            return function(e) {
                var t = e.geometry, i = e.type;
                if ("Point" === i || "MultiPoint" === i || "LineString" === i) B(e, t);
                else if ("Polygon" === i || "MultiLineString" === i) for(var o = 0; o < t.length; o++)B(e, t[o]);
                else if ("MultiPolygon" === i) for(o = 0; o < t.length; o++)for(var r = 0; r < t[o].length; r++)B(e, t[o][r]);
            }(r), r;
        }
        function B(e, t) {
            for(var i = 0; i < t.length; i += 3)e.minX = Math.min(e.minX, t[i]), e.minY = Math.min(e.minY, t[i + 1]), e.maxX = Math.max(e.maxX, t[i]), e.maxY = Math.max(e.maxY, t[i + 1]);
        }
        function X(e, t, i, o) {
            if (t.geometry) {
                var r = t.geometry.coordinates, s = t.geometry.type, n = Math.pow(i.tolerance / ((1 << i.maxZoom) * i.extent), 2), a = [], l = t.id;
                if (i.promoteId ? l = t.properties[i.promoteId] : i.generateId && (l = o || 0), "Point" === s) q(r, a);
                else if ("MultiPoint" === s) for(var c = 0; c < r.length; c++)q(r[c], a);
                else if ("LineString" === s) R(r, a, n, !1);
                else if ("MultiLineString" === s) {
                    if (i.lineMetrics) {
                        for(c = 0; c < r.length; c++)R(r[c], a = [], n, !1), e.push(V(l, "LineString", a, t.properties));
                        return;
                    }
                    W(r, a, n, !1);
                } else if ("Polygon" === s) W(r, a, n, !0);
                else {
                    if ("MultiPolygon" !== s) {
                        if ("GeometryCollection" === s) {
                            for(c = 0; c < t.geometry.geometries.length; c++)X(e, {
                                id: l,
                                geometry: t.geometry.geometries[c],
                                properties: t.properties
                            }, i, o);
                            return;
                        }
                        throw new Error("Input data is not a valid GeoJSON object.");
                    }
                    for(c = 0; c < r.length; c++){
                        var h = [];
                        W(r[c], h, n, !0), a.push(h);
                    }
                }
                e.push(V(l, s, a, t.properties));
            }
        }
        function q(e, t) {
            t.push($(e[0])), t.push(U(e[1])), t.push(0);
        }
        function R(e, t, i, o) {
            for(var r, s, n = 0, a = 0; a < e.length; a++){
                var l = $(e[a][0]), c = U(e[a][1]);
                t.push(l), t.push(c), t.push(0), a > 0 && (n += o ? (r * c - l * s) / 2 : Math.sqrt(Math.pow(l - r, 2) + Math.pow(c - s, 2))), r = l, s = c;
            }
            var h = t.length - 3;
            t[2] = 1, Y(t, 0, h, i), t[h + 2] = 1, t.size = Math.abs(n), t.start = 0, t.end = t.size;
        }
        function W(e, t, i, o) {
            for(var r = 0; r < e.length; r++){
                var s = [];
                R(e[r], s, i, o), t.push(s);
            }
        }
        function $(e) {
            return e / 360 + .5;
        }
        function U(e) {
            var t = Math.sin(e * Math.PI / 180), i = .5 - .25 * Math.log((1 + t) / (1 - t)) / Math.PI;
            return i < 0 ? 0 : i > 1 ? 1 : i;
        }
        function H(e, t, i, o, r, s, n, a) {
            if (o /= t, s >= (i /= t) && n < o) return e;
            if (n < i || s >= o) return null;
            for(var l = [], c = 0; c < e.length; c++){
                var h = e[c], u = h.geometry, d = h.type, p = 0 === r ? h.minX : h.minY, f = 0 === r ? h.maxX : h.maxY;
                if (p >= i && f < o) l.push(h);
                else if (!(f < i || p >= o)) {
                    var g = [];
                    if ("Point" === d || "MultiPoint" === d) K(u, g, i, o, r);
                    else if ("LineString" === d) Q(u, g, i, o, r, !1, a.lineMetrics);
                    else if ("MultiLineString" === d) te(u, g, i, o, r, !1);
                    else if ("Polygon" === d) te(u, g, i, o, r, !0);
                    else if ("MultiPolygon" === d) for(var m = 0; m < u.length; m++){
                        var y = [];
                        te(u[m], y, i, o, r, !0), y.length && g.push(y);
                    }
                    if (g.length) {
                        if (a.lineMetrics && "LineString" === d) {
                            for(m = 0; m < g.length; m++)l.push(V(h.id, d, g[m], h.tags));
                            continue;
                        }
                        "LineString" !== d && "MultiLineString" !== d || (1 === g.length ? (d = "LineString", g = g[0]) : d = "MultiLineString"), "Point" !== d && "MultiPoint" !== d || (d = 3 === g.length ? "Point" : "MultiPoint"), l.push(V(h.id, d, g, h.tags));
                    }
                }
            }
            return l.length ? l : null;
        }
        function K(e, t, i, o, r) {
            for(var s = 0; s < e.length; s += 3){
                var n = e[s + r];
                n >= i && n <= o && (t.push(e[s]), t.push(e[s + 1]), t.push(e[s + 2]));
            }
        }
        function Q(e, t, i, o, r, s, n) {
            for(var a, l, c = ee(e), h = 0 === r ? oe : re, u = e.start, d = 0; d < e.length - 3; d += 3){
                var p = e[d], f = e[d + 1], g = e[d + 2], m = e[d + 3], y = e[d + 4], v = 0 === r ? p : f, w = 0 === r ? m : y, x = !1;
                n && (a = Math.sqrt(Math.pow(p - m, 2) + Math.pow(f - y, 2))), v < i ? w > i && (l = h(c, p, f, m, y, i), n && (c.start = u + a * l)) : v > o ? w < o && (l = h(c, p, f, m, y, o), n && (c.start = u + a * l)) : ie(c, p, f, g), w < i && v >= i && (l = h(c, p, f, m, y, i), x = !0), w > o && v <= o && (l = h(c, p, f, m, y, o), x = !0), !s && x && (n && (c.end = u + a * l), t.push(c), c = ee(e)), n && (u += a);
            }
            var b = e.length - 3;
            p = e[b], f = e[b + 1], g = e[b + 2], (v = 0 === r ? p : f) >= i && v <= o && ie(c, p, f, g), b = c.length - 3, s && b >= 3 && (c[b] !== c[0] || c[b + 1] !== c[1]) && ie(c, c[0], c[1], c[2]), c.length && t.push(c);
        }
        function ee(e) {
            var t = [];
            return t.size = e.size, t.start = e.start, t.end = e.end, t;
        }
        function te(e, t, i, o, r, s) {
            for(var n = 0; n < e.length; n++)Q(e[n], t, i, o, r, s, !1);
        }
        function ie(e, t, i, o) {
            e.push(t), e.push(i), e.push(o);
        }
        function oe(e, t, i, o, r, s) {
            var n = (s - t) / (o - t);
            return e.push(s), e.push(i + (r - i) * n), e.push(1), n;
        }
        function re(e, t, i, o, r, s) {
            var n = (s - i) / (r - i);
            return e.push(t + (o - t) * n), e.push(s), e.push(1), n;
        }
        function se(e, t) {
            for(var i = [], o = 0; o < e.length; o++){
                var r, s = e[o], n = s.type;
                if ("Point" === n || "MultiPoint" === n || "LineString" === n) r = ne(s.geometry, t);
                else if ("MultiLineString" === n || "Polygon" === n) {
                    r = [];
                    for(var a = 0; a < s.geometry.length; a++)r.push(ne(s.geometry[a], t));
                } else if ("MultiPolygon" === n) for(r = [], a = 0; a < s.geometry.length; a++){
                    for(var l = [], c = 0; c < s.geometry[a].length; c++)l.push(ne(s.geometry[a][c], t));
                    r.push(l);
                }
                i.push(V(s.id, n, r, s.tags));
            }
            return i;
        }
        function ne(e, t) {
            var i = [];
            i.size = e.size, void 0 !== e.start && (i.start = e.start, i.end = e.end);
            for(var o = 0; o < e.length; o += 3)i.push(e[o] + t, e[o + 1], e[o + 2]);
            return i;
        }
        function ae(e, t) {
            if (e.transformed) return e;
            var i, o, r, s = 1 << e.z, n = e.x, a = e.y;
            for(i = 0; i < e.features.length; i++){
                var l = e.features[i], c = l.geometry, h = l.type;
                if (l.geometry = [], 1 === h) for(o = 0; o < c.length; o += 2)l.geometry.push(le(c[o], c[o + 1], t, s, n, a));
                else for(o = 0; o < c.length; o++){
                    var u = [];
                    for(r = 0; r < c[o].length; r += 2)u.push(le(c[o][r], c[o][r + 1], t, s, n, a));
                    l.geometry.push(u);
                }
            }
            return e.transformed = !0, e;
        }
        function le(e, t, i, o, r, s) {
            return [
                Math.round(i * (e * o - r)),
                Math.round(i * (t * o - s))
            ];
        }
        function ce(e, t, i, o, r) {
            for(var s = t === r.maxZoom ? 0 : r.tolerance / ((1 << t) * r.extent), n = {
                features: [],
                numPoints: 0,
                numSimplified: 0,
                numFeatures: 0,
                source: null,
                x: i,
                y: o,
                z: t,
                transformed: !1,
                minX: 2,
                minY: 1,
                maxX: -1,
                maxY: 0
            }, a = 0; a < e.length; a++){
                n.numFeatures++, he(n, e[a], s, r);
                var l = e[a].minX, c = e[a].minY, h = e[a].maxX, u = e[a].maxY;
                l < n.minX && (n.minX = l), c < n.minY && (n.minY = c), h > n.maxX && (n.maxX = h), u > n.maxY && (n.maxY = u);
            }
            return n;
        }
        function he(e, t, i, o) {
            var r = t.geometry, s = t.type, n = [];
            if ("Point" === s || "MultiPoint" === s) for(var a = 0; a < r.length; a += 3)n.push(r[a]), n.push(r[a + 1]), e.numPoints++, e.numSimplified++;
            else if ("LineString" === s) ue(n, r, e, i, !1, !1);
            else if ("MultiLineString" === s || "Polygon" === s) for(a = 0; a < r.length; a++)ue(n, r[a], e, i, "Polygon" === s, 0 === a);
            else if ("MultiPolygon" === s) for(var l = 0; l < r.length; l++){
                var c = r[l];
                for(a = 0; a < c.length; a++)ue(n, c[a], e, i, !0, 0 === a);
            }
            if (n.length) {
                var h = t.tags || null;
                if ("LineString" === s && o.lineMetrics) {
                    for(var u in h = {}, t.tags)h[u] = t.tags[u];
                    h.mapbox_clip_start = r.start / r.size, h.mapbox_clip_end = r.end / r.size;
                }
                var d = {
                    geometry: n,
                    type: "Polygon" === s || "MultiPolygon" === s ? 3 : "LineString" === s || "MultiLineString" === s ? 2 : 1,
                    tags: h
                };
                null !== t.id && (d.id = t.id), e.features.push(d);
            }
        }
        function ue(e, t, i, o, r, s) {
            var n = o * o;
            if (o > 0 && t.size < (r ? n : o)) i.numPoints += t.length / 3;
            else {
                for(var a = [], l = 0; l < t.length; l += 3)(0 === o || t[l + 2] > n) && (i.numSimplified++, a.push(t[l]), a.push(t[l + 1])), i.numPoints++;
                r && function(e, t) {
                    for(var i = 0, o = 0, r = e.length, s = r - 2; o < r; s = o, o += 2)i += (e[o] - e[s]) * (e[o + 1] + e[s + 1]);
                    if (i > 0 === t) for(o = 0, r = e.length; o < r / 2; o += 2){
                        var n = e[o], a = e[o + 1];
                        e[o] = e[r - 2 - o], e[o + 1] = e[r - 1 - o], e[r - 2 - o] = n, e[r - 1 - o] = a;
                    }
                }(a, s), e.push(a);
            }
        }
        function de(e, t) {
            var i = (t = this.options = function(e, t) {
                for(var i in t)e[i] = t[i];
                return e;
            }(Object.create(this.options), t)).debug;
            if (i && console.time("preprocess data"), t.maxZoom < 0 || t.maxZoom > 24) throw new Error("maxZoom should be in the 0-24 range");
            if (t.promoteId && t.generateId) throw new Error("promoteId and generateId cannot be used together.");
            var o = function(e, t) {
                var i = [];
                if ("FeatureCollection" === e.type) for(var o = 0; o < e.features.length; o++)X(i, e.features[o], t, o);
                else X(i, "Feature" === e.type ? e : {
                    geometry: e
                }, t);
                return i;
            }(e, t);
            this.tiles = {}, this.tileCoords = [], i && (console.timeEnd("preprocess data"), console.log("index: maxZoom: %d, maxPoints: %d", t.indexMaxZoom, t.indexMaxPoints), console.time("generate tiles"), this.stats = {}, this.total = 0), o = function(e, t) {
                var i = t.buffer / t.extent, o = e, r = H(e, 1, -1 - i, i, 0, -1, 2, t), s = H(e, 1, 1 - i, 2 + i, 0, -1, 2, t);
                return (r || s) && (o = H(e, 1, -i, 1 + i, 0, -1, 2, t) || [], r && (o = se(r, 1).concat(o)), s && (o = o.concat(se(s, -1)))), o;
            }(o, t), o.length && this.splitTile(o, 0, 0, 0), i && (o.length && console.log("features: %d, points: %d", this.tiles[0].numFeatures, this.tiles[0].numPoints), console.timeEnd("generate tiles"), console.log("tiles generated:", this.total, JSON.stringify(this.stats)));
        }
        function pe(e, t, i) {
            return 32 * ((1 << e) * i + t) + e;
        }
        function fe(e, t) {
            return t ? e.properties[t] : e.id;
        }
        function ge(e, t) {
            if (null == e) return !0;
            if ("Feature" === e.type) return null != fe(e, t);
            if ("FeatureCollection" === e.type) {
                const i = new Set;
                for (const o of e.features){
                    const e = fe(o, t);
                    if (null == e) return !1;
                    if (i.has(e)) return !1;
                    i.add(e);
                }
                return !0;
            }
            return !1;
        }
        function me(e, t) {
            const i = new Map;
            if (null == e) ;
            else if ("Feature" === e.type) i.set(fe(e, t), e);
            else for (const o of e.features)i.set(fe(o, t), o);
            return i;
        }
        de.prototype.options = {
            maxZoom: 14,
            indexMaxZoom: 5,
            indexMaxPoints: 1e5,
            tolerance: 3,
            extent: 4096,
            buffer: 64,
            lineMetrics: !1,
            promoteId: null,
            generateId: !1,
            debug: 0
        }, de.prototype.splitTile = function(e, t, i, o, r, s, n) {
            for(var a = [
                e,
                t,
                i,
                o
            ], l = this.options, c = l.debug; a.length;){
                o = a.pop(), i = a.pop(), t = a.pop(), e = a.pop();
                var h = 1 << t, u = pe(t, i, o), d = this.tiles[u];
                if (!d && (c > 1 && console.time("creation"), d = this.tiles[u] = ce(e, t, i, o, l), this.tileCoords.push({
                    z: t,
                    x: i,
                    y: o
                }), c)) {
                    c > 1 && (console.log("tile z%d-%d-%d (features: %d, points: %d, simplified: %d)", t, i, o, d.numFeatures, d.numPoints, d.numSimplified), console.timeEnd("creation"));
                    var p = "z" + t;
                    this.stats[p] = (this.stats[p] || 0) + 1, this.total++;
                }
                if (d.source = e, r) {
                    if (t === l.maxZoom || t === r) continue;
                    var f = 1 << r - t;
                    if (i !== Math.floor(s / f) || o !== Math.floor(n / f)) continue;
                } else if (t === l.indexMaxZoom || d.numPoints <= l.indexMaxPoints) continue;
                if (d.source = null, 0 !== e.length) {
                    c > 1 && console.time("clipping");
                    var g, m, y, v, w, x, b = .5 * l.buffer / l.extent, S = .5 - b, M = .5 + b, I = 1 + b;
                    g = m = y = v = null, w = H(e, h, i - b, i + M, 0, d.minX, d.maxX, l), x = H(e, h, i + S, i + I, 0, d.minX, d.maxX, l), e = null, w && (g = H(w, h, o - b, o + M, 1, d.minY, d.maxY, l), m = H(w, h, o + S, o + I, 1, d.minY, d.maxY, l), w = null), x && (y = H(x, h, o - b, o + M, 1, d.minY, d.maxY, l), v = H(x, h, o + S, o + I, 1, d.minY, d.maxY, l), x = null), c > 1 && console.timeEnd("clipping"), a.push(g || [], t + 1, 2 * i, 2 * o), a.push(m || [], t + 1, 2 * i, 2 * o + 1), a.push(y || [], t + 1, 2 * i + 1, 2 * o), a.push(v || [], t + 1, 2 * i + 1, 2 * o + 1);
                }
            }
        }, de.prototype.getTile = function(e, t, i) {
            var o = this.options, r = o.extent, s = o.debug;
            if (e < 0 || e > 24) return null;
            var n = 1 << e, a = pe(e, t = (t % n + n) % n, i);
            if (this.tiles[a]) return ae(this.tiles[a], r);
            s > 1 && console.log("drilling down to z%d-%d-%d", e, t, i);
            for(var l, c = e, h = t, u = i; !l && c > 0;)c--, h = Math.floor(h / 2), u = Math.floor(u / 2), l = this.tiles[pe(c, h, u)];
            return l && l.source ? (s > 1 && console.log("found parent tile z%d-%d-%d", c, h, u), s > 1 && console.time("drilling down"), this.splitTile(l.source, c, h, u, e, t, i), s > 1 && console.timeEnd("drilling down"), this.tiles[a] ? ae(this.tiles[a], r) : null) : null;
        };
        class ye extends n {
            constructor(t, i, o, r){
                super(t, i, o), this._dataUpdateable = new Map, this.loadGeoJSON = (t, i)=>{
                    const { promoteId: o } = t;
                    if (t.request) return e.f(t.request, (e, t, r, s)=>{
                        this._dataUpdateable = ge(t, o) ? me(t, o) : void 0, i(e, t, r, s);
                    });
                    if ("string" == typeof t.data) try {
                        const e = JSON.parse(t.data);
                        this._dataUpdateable = ge(e, o) ? me(e, o) : void 0, i(null, e);
                    } catch (e) {
                        i(new Error(`Input data given to '${t.source}' is not a valid GeoJSON object.`));
                    }
                    else t.dataDiff ? this._dataUpdateable ? (function(e, t, i) {
                        var o, r, s, n;
                        if (t.removeAll && e.clear(), t.remove) for (const i of t.remove)e.delete(i);
                        if (t.add) for (const o of t.add){
                            const t = fe(o, i);
                            null != t && e.set(t, o);
                        }
                        if (t.update) for (const i of t.update){
                            let t = e.get(i.id);
                            if (null == t) continue;
                            const a = !i.removeAllProperties && ((null === (o = i.removeProperties) || void 0 === o ? void 0 : o.length) > 0 || (null === (r = i.addOrUpdateProperties) || void 0 === r ? void 0 : r.length) > 0);
                            if ((i.newGeometry || i.removeAllProperties || a) && (t = Object.assign({}, t), e.set(i.id, t), a && (t.properties = Object.assign({}, t.properties))), i.newGeometry && (t.geometry = i.newGeometry), i.removeAllProperties) t.properties = {};
                            else if ((null === (s = i.removeProperties) || void 0 === s ? void 0 : s.length) > 0) for (const e of i.removeProperties)Object.prototype.hasOwnProperty.call(t.properties, e) && delete t.properties[e];
                            if ((null === (n = i.addOrUpdateProperties) || void 0 === n ? void 0 : n.length) > 0) for (const { key: e, value: o } of i.addOrUpdateProperties)t.properties[e] = o;
                        }
                    }(this._dataUpdateable, t.dataDiff, o), i(null, {
                        type: "FeatureCollection",
                        features: Array.from(this._dataUpdateable.values())
                    })) : i(new Error(`Cannot update existing geojson data in ${t.source}`)) : i(new Error(`Input data given to '${t.source}' is not a valid GeoJSON object.`));
                    return {
                        cancel: ()=>{}
                    };
                }, this.loadVectorData = this.loadGeoJSONTile, r && (this.loadGeoJSON = r);
            }
            loadGeoJSONTile(t, i) {
                const o = t.tileID.canonical;
                if (!this._geoJSONIndex) return i(null, null);
                const r = this._geoJSONIndex.getTile(o.z, o.x, o.y);
                if (!r) return i(null, null);
                const s = new class {
                    constructor(t){
                        this.layers = {
                            _geojsonTileLayer: this
                        }, this.name = "_geojsonTileLayer", this.extent = e.N, this.length = t.length, this._features = t;
                    }
                    feature(t) {
                        return new class {
                            constructor(t){
                                this._feature = t, this.extent = e.N, this.type = t.type, this.properties = t.tags, "id" in t && !isNaN(t.id) && (this.id = parseInt(t.id, 10));
                            }
                            loadGeometry() {
                                if (1 === this._feature.type) {
                                    const t = [];
                                    for (const i of this._feature.geometry)t.push([
                                        new e.P(i[0], i[1])
                                    ]);
                                    return t;
                                }
                                {
                                    const t = [];
                                    for (const i of this._feature.geometry){
                                        const o = [];
                                        for (const t of i)o.push(new e.P(t[0], t[1]));
                                        t.push(o);
                                    }
                                    return t;
                                }
                            }
                            toGeoJSON(e, t, i) {
                                return u.call(this, e, t, i);
                            }
                        }(this._features[t]);
                    }
                }(r.features);
                let n = k(s);
                0 === n.byteOffset && n.byteLength === n.buffer.byteLength || (n = new Uint8Array(n)), i(null, {
                    vectorTile: s,
                    rawData: n.buffer
                });
            }
            loadData(t, i) {
                var o;
                null === (o = this._pendingRequest) || void 0 === o || o.cancel(), this._pendingCallback && this._pendingCallback(null, {
                    abandoned: !0
                });
                const r = !!(t && t.request && t.request.collectResourceTiming) && new e.bu(t.request);
                this._pendingCallback = i, this._pendingRequest = this.loadGeoJSON(t, (o, s)=>{
                    if (delete this._pendingCallback, delete this._pendingRequest, o || !s) return i(o);
                    if ("object" != typeof s) return i(new Error(`Input data given to '${t.source}' is not a valid GeoJSON object.`));
                    {
                        h(s, !0);
                        try {
                            if (t.filter) {
                                const i = e.bC(t.filter, {
                                    type: "boolean",
                                    "property-type": "data-driven",
                                    overridable: !1,
                                    transition: !1
                                });
                                if ("error" === i.result) throw new Error(i.value.map((e)=>`${e.key}: ${e.message}`).join(", "));
                                const o = s.features.filter((e)=>i.value.evaluate({
                                        zoom: 0
                                    }, e));
                                s = {
                                    type: "FeatureCollection",
                                    features: o
                                };
                            }
                            this._geoJSONIndex = t.cluster ? new N(function({ superclusterOptions: t, clusterProperties: i }) {
                                if (!i || !t) return t;
                                const o = {}, r = {}, s = {
                                    accumulated: null,
                                    zoom: 0
                                }, n = {
                                    properties: null
                                }, a = Object.keys(i);
                                for (const t of a){
                                    const [s, n] = i[t], a = e.bC(n), l = e.bC("string" == typeof s ? [
                                        s,
                                        [
                                            "accumulated"
                                        ],
                                        [
                                            "get",
                                            t
                                        ]
                                    ] : s);
                                    o[t] = a.value, r[t] = l.value;
                                }
                                return t.map = (e)=>{
                                    n.properties = e;
                                    const t = {};
                                    for (const e of a)t[e] = o[e].evaluate(s, n);
                                    return t;
                                }, t.reduce = (e, t)=>{
                                    n.properties = t;
                                    for (const t of a)s.accumulated = e[t], e[t] = r[t].evaluate(s, n);
                                }, t;
                            }(t)).load(s.features) : function(e, t) {
                                return new de(e, t);
                            }(s, t.geojsonVtOptions);
                        } catch (o) {
                            return i(o);
                        }
                        this.loaded = {};
                        const n = {};
                        if (r) {
                            const e = r.finish();
                            e && (n.resourceTiming = {}, n.resourceTiming[t.source] = JSON.parse(JSON.stringify(e)));
                        }
                        i(null, n);
                    }
                });
            }
            reloadTile(e, t) {
                const i = this.loaded;
                return i && i[e.uid] ? super.reloadTile(e, t) : this.loadTile(e, t);
            }
            removeSource(e, t) {
                this._pendingCallback && this._pendingCallback(null, {
                    abandoned: !0
                }), t();
            }
            getClusterExpansionZoom(e, t) {
                try {
                    t(null, this._geoJSONIndex.getClusterExpansionZoom(e.clusterId));
                } catch (e) {
                    t(e);
                }
            }
            getClusterChildren(e, t) {
                try {
                    t(null, this._geoJSONIndex.getChildren(e.clusterId));
                } catch (e) {
                    t(e);
                }
            }
            getClusterLeaves(e, t) {
                try {
                    t(null, this._geoJSONIndex.getLeaves(e.clusterId, e.limit, e.offset));
                } catch (e) {
                    t(e);
                }
            }
        }
        class ve {
            constructor(t){
                this.self = t, this.actor = new e.C(t, this), this.layerIndexes = {}, this.availableImages = {}, this.workerSourceTypes = {
                    vector: n,
                    geojson: ye
                }, this.workerSources = {}, this.demWorkerSources = {}, this.self.registerWorkerSource = (e, t)=>{
                    if (this.workerSourceTypes[e]) throw new Error(`Worker source with name "${e}" already registered.`);
                    this.workerSourceTypes[e] = t;
                }, this.self.registerRTLTextPlugin = (t)=>{
                    if (e.bD.isParsed()) throw new Error("RTL text plugin already registered.");
                    e.bD.applyArabicShaping = t.applyArabicShaping, e.bD.processBidirectionalText = t.processBidirectionalText, e.bD.processStyledBidirectionalText = t.processStyledBidirectionalText;
                };
            }
            setReferrer(e, t) {
                this.referrer = t;
            }
            setImages(e, t, i) {
                this.availableImages[e] = t;
                for(const i in this.workerSources[e]){
                    const o = this.workerSources[e][i];
                    for(const e in o)o[e].availableImages = t;
                }
                i();
            }
            setLayers(e, t, i) {
                this.getLayerIndex(e).replace(t), i();
            }
            updateLayers(e, t, i) {
                this.getLayerIndex(e).update(t.layers, t.removedIds), i();
            }
            loadTile(e, t, i) {
                this.getWorkerSource(e, t.type, t.source).loadTile(t, i);
            }
            loadDEMTile(e, t, i) {
                this.getDEMWorkerSource(e, t.source).loadTile(t, i);
            }
            reloadTile(e, t, i) {
                this.getWorkerSource(e, t.type, t.source).reloadTile(t, i);
            }
            abortTile(e, t, i) {
                this.getWorkerSource(e, t.type, t.source).abortTile(t, i);
            }
            removeTile(e, t, i) {
                this.getWorkerSource(e, t.type, t.source).removeTile(t, i);
            }
            removeDEMTile(e, t) {
                this.getDEMWorkerSource(e, t.source).removeTile(t);
            }
            removeSource(e, t, i) {
                if (!this.workerSources[e] || !this.workerSources[e][t.type] || !this.workerSources[e][t.type][t.source]) return;
                const o = this.workerSources[e][t.type][t.source];
                delete this.workerSources[e][t.type][t.source], void 0 !== o.removeSource ? o.removeSource(t, i) : i();
            }
            loadWorkerSource(e, t, i) {
                try {
                    this.self.importScripts(t.url), i();
                } catch (e) {
                    i(e.toString());
                }
            }
            syncRTLPluginState(t, i, o) {
                try {
                    e.bD.setState(i);
                    const t = e.bD.getPluginURL();
                    if (e.bD.isLoaded() && !e.bD.isParsed() && null != t) {
                        this.self.importScripts(t);
                        const i = e.bD.isParsed();
                        o(i ? void 0 : new Error(`RTL Text Plugin failed to import scripts from ${t}`), i);
                    }
                } catch (e) {
                    o(e.toString());
                }
            }
            getAvailableImages(e) {
                let t = this.availableImages[e];
                return t || (t = []), t;
            }
            getLayerIndex(e) {
                let i = this.layerIndexes[e];
                return i || (i = this.layerIndexes[e] = new t), i;
            }
            getWorkerSource(e, t, i) {
                return this.workerSources[e] || (this.workerSources[e] = {}), this.workerSources[e][t] || (this.workerSources[e][t] = {}), this.workerSources[e][t][i] || (this.workerSources[e][t][i] = new this.workerSourceTypes[t]({
                    send: (t, i, o)=>{
                        this.actor.send(t, i, o, e);
                    }
                }, this.getLayerIndex(e), this.getAvailableImages(e))), this.workerSources[e][t][i];
            }
            getDEMWorkerSource(e, t) {
                return this.demWorkerSources[e] || (this.demWorkerSources[e] = {}), this.demWorkerSources[e][t] || (this.demWorkerSources[e][t] = new a), this.demWorkerSources[e][t];
            }
        }
        return e.i() && (self.worker = new ve(self)), ve;
    });
    define([
        "./shared"
    ], function(t) {
        "use strict";
        var e = "3.6.2";
        class i {
            static testProp(t) {
                if (!i.docStyle) return t[0];
                for(let e = 0; e < t.length; e++)if (t[e] in i.docStyle) return t[e];
                return t[0];
            }
            static create(t, e, i) {
                const s = window.document.createElement(t);
                return void 0 !== e && (s.className = e), i && i.appendChild(s), s;
            }
            static createNS(t, e) {
                return window.document.createElementNS(t, e);
            }
            static disableDrag() {
                i.docStyle && i.selectProp && (i.userSelect = i.docStyle[i.selectProp], i.docStyle[i.selectProp] = "none");
            }
            static enableDrag() {
                i.docStyle && i.selectProp && (i.docStyle[i.selectProp] = i.userSelect);
            }
            static setTransform(t, e) {
                t.style[i.transformProp] = e;
            }
            static addEventListener(t, e, i, s = {}) {
                t.addEventListener(e, i, "passive" in s ? s : s.capture);
            }
            static removeEventListener(t, e, i, s = {}) {
                t.removeEventListener(e, i, "passive" in s ? s : s.capture);
            }
            static suppressClickInternal(t) {
                t.preventDefault(), t.stopPropagation(), window.removeEventListener("click", i.suppressClickInternal, !0);
            }
            static suppressClick() {
                window.addEventListener("click", i.suppressClickInternal, !0), window.setTimeout(()=>{
                    window.removeEventListener("click", i.suppressClickInternal, !0);
                }, 0);
            }
            static mousePos(e, i) {
                const s = e.getBoundingClientRect();
                return new t.P(i.clientX - s.left - e.clientLeft, i.clientY - s.top - e.clientTop);
            }
            static touchPos(e, i) {
                const s = e.getBoundingClientRect(), a = [];
                for(let o = 0; o < i.length; o++)a.push(new t.P(i[o].clientX - s.left - e.clientLeft, i[o].clientY - s.top - e.clientTop));
                return a;
            }
            static mouseButton(t) {
                return t.button;
            }
            static remove(t) {
                t.parentNode && t.parentNode.removeChild(t);
            }
        }
        i.docStyle = "undefined" != typeof window && window.document && window.document.documentElement.style, i.selectProp = i.testProp([
            "userSelect",
            "MozUserSelect",
            "WebkitUserSelect",
            "msUserSelect"
        ]), i.transformProp = i.testProp([
            "transform",
            "WebkitTransform"
        ]);
        const s = {
            supported: !1,
            testSupport: function(t) {
                !r && o && (n ? l(t) : a = t);
            }
        };
        let a, o, r = !1, n = !1;
        function l(t) {
            const e = t.createTexture();
            t.bindTexture(t.TEXTURE_2D, e);
            try {
                if (t.texImage2D(t.TEXTURE_2D, 0, t.RGBA, t.RGBA, t.UNSIGNED_BYTE, o), t.isContextLost()) return;
                s.supported = !0;
            } catch (t) {}
            t.deleteTexture(e), r = !0;
        }
        var h, c;
        "undefined" != typeof document && (o = document.createElement("img"), o.onload = function() {
            a && l(a), a = null, n = !0;
        }, o.onerror = function() {
            r = !0, a = null;
        }, o.src = "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAQAAAAfQ//73v/+BiOh/AAA="), function(e) {
            let i, a, o, r;
            e.resetRequestQueue = ()=>{
                i = [], a = 0, o = 0, r = {};
            }, e.addThrottleControl = (t)=>{
                const e = o++;
                return r[e] = t, e;
            }, e.removeThrottleControl = (t)=>{
                delete r[t], h();
            }, e.getImage = (t, e, o = !0)=>{
                s.supported && (t.headers || (t.headers = {}), t.headers.accept = "image/webp,*/*");
                const r = {
                    requestParameters: t,
                    supportImageRefresh: o,
                    callback: e,
                    cancelled: !1,
                    completed: !1,
                    cancel: ()=>{
                        r.completed || r.cancelled || (r.cancelled = !0, r.innerRequest && (r.innerRequest.cancel(), a--), h());
                    }
                };
                return i.push(r), h(), r;
            };
            const n = (e)=>{
                const { requestParameters: i, supportImageRefresh: s, callback: a } = e;
                return t.e(i, {
                    type: "image"
                }), (!1 !== s || t.i() || t.g(i.url) || i.headers && !Object.keys(i.headers).reduce((t, e)=>t && "accept" === e, !0) ? t.m : c)(i, (t, i, s, o)=>{
                    l(e, a, t, i, s, o);
                });
            }, l = (e, i, s, o, r, n)=>{
                s ? i(s) : o instanceof HTMLImageElement || t.a(o) ? i(null, o) : o && ((e, i)=>{
                    "function" == typeof createImageBitmap ? t.b(e, i) : t.d(e, i);
                })(o, (t, e)=>{
                    null != t ? i(t) : null != e && i(null, e, {
                        cacheControl: r,
                        expires: n
                    });
                }), e.cancelled || (e.completed = !0, a--, h());
            }, h = ()=>{
                const e = (()=>{
                    const t = Object.keys(r);
                    let e = !1;
                    if (t.length > 0) {
                        for (const i of t)if (e = r[i](), e) break;
                    }
                    return e;
                })() ? t.c.MAX_PARALLEL_IMAGE_REQUESTS_PER_FRAME : t.c.MAX_PARALLEL_IMAGE_REQUESTS;
                for(let t = a; t < e && i.length > 0; t++){
                    const e = i.shift();
                    if (e.cancelled) {
                        t--;
                        continue;
                    }
                    const s = n(e);
                    a++, e.innerRequest = s;
                }
            }, c = (e, i)=>{
                const s = new Image, a = e.url;
                let o = !1;
                const r = e.credentials;
                return r && "include" === r ? s.crossOrigin = "use-credentials" : (r && "same-origin" === r || !t.s(a)) && (s.crossOrigin = "anonymous"), s.fetchPriority = "high", s.onload = ()=>{
                    i(null, s), s.onerror = s.onload = null;
                }, s.onerror = ()=>{
                    o || i(new Error("Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported.")), s.onerror = s.onload = null;
                }, s.src = a, {
                    cancel: ()=>{
                        o = !0, s.src = "";
                    }
                };
            };
        }(h || (h = {})), h.resetRequestQueue(), function(t) {
            t.Glyphs = "Glyphs", t.Image = "Image", t.Source = "Source", t.SpriteImage = "SpriteImage", t.SpriteJSON = "SpriteJSON", t.Style = "Style", t.Tile = "Tile", t.Unknown = "Unknown";
        }(c || (c = {}));
        class u {
            constructor(t){
                this._transformRequestFn = t;
            }
            transformRequest(t, e) {
                return this._transformRequestFn && this._transformRequestFn(t, e) || {
                    url: t
                };
            }
            normalizeSpriteURL(t, e, i) {
                const s = function(t) {
                    const e = t.match(d);
                    if (!e) throw new Error(`Unable to parse URL "${t}"`);
                    return {
                        protocol: e[1],
                        authority: e[2],
                        path: e[3] || "/",
                        params: e[4] ? e[4].split("&") : []
                    };
                }(t);
                return s.path += `${e}${i}`, function(t) {
                    const e = t.params.length ? `?${t.params.join("&")}` : "";
                    return `${t.protocol}://${t.authority}${t.path}${e}`;
                }(s);
            }
            setTransformRequest(t) {
                this._transformRequestFn = t;
            }
        }
        const d = /^(\w+):\/\/([^/?]*)(\/[^?]+)?\??(.+)?/;
        function _(e) {
            var i = new t.A(3);
            return i[0] = e[0], i[1] = e[1], i[2] = e[2], i;
        }
        var p, m = function(t, e, i) {
            return t[0] = e[0] - i[0], t[1] = e[1] - i[1], t[2] = e[2] - i[2], t;
        };
        p = new t.A(3), t.A != Float32Array && (p[0] = 0, p[1] = 0, p[2] = 0);
        var f = function(t) {
            var e = t[0], i = t[1];
            return e * e + i * i;
        };
        function g(t) {
            const e = [];
            if ("string" == typeof t) e.push({
                id: "default",
                url: t
            });
            else if (t && t.length > 0) {
                const i = [];
                for (const { id: s, url: a } of t){
                    const t = `${s}${a}`;
                    -1 === i.indexOf(t) && (i.push(t), e.push({
                        id: s,
                        url: a
                    }));
                }
            }
            return e;
        }
        function v(e, i, s, a, o) {
            if (a) return void e(a);
            if (o !== Object.values(i).length || o !== Object.values(s).length) return;
            const r = {};
            for(const e in i){
                r[e] = {};
                const a = t.h.getImageCanvasContext(s[e]), o = i[e];
                for(const t in o){
                    const { width: i, height: s, x: n, y: l, sdf: h, pixelRatio: c, stretchX: u, stretchY: d, content: _ } = o[t];
                    r[e][t] = {
                        data: null,
                        pixelRatio: c,
                        sdf: h,
                        stretchX: u,
                        stretchY: d,
                        content: _,
                        spriteData: {
                            width: i,
                            height: s,
                            x: n,
                            y: l,
                            context: a
                        }
                    };
                }
            }
            e(null, r);
        }
        !function() {
            var e = new t.A(2);
            t.A != Float32Array && (e[0] = 0, e[1] = 0);
        }();
        class x {
            constructor(t, e, i, s){
                this.context = t, this.format = i, this.texture = t.gl.createTexture(), this.update(e, s);
            }
            update(e, i, s) {
                const { width: a, height: o } = e, r = !(this.size && this.size[0] === a && this.size[1] === o || s), { context: n } = this, { gl: l } = n;
                if (this.useMipmap = Boolean(i && i.useMipmap), l.bindTexture(l.TEXTURE_2D, this.texture), n.pixelStoreUnpackFlipY.set(!1), n.pixelStoreUnpack.set(1), n.pixelStoreUnpackPremultiplyAlpha.set(this.format === l.RGBA && (!i || !1 !== i.premultiply)), r) this.size = [
                    a,
                    o
                ], e instanceof HTMLImageElement || e instanceof HTMLCanvasElement || e instanceof HTMLVideoElement || e instanceof ImageData || t.a(e) ? l.texImage2D(l.TEXTURE_2D, 0, this.format, this.format, l.UNSIGNED_BYTE, e) : l.texImage2D(l.TEXTURE_2D, 0, this.format, a, o, 0, this.format, l.UNSIGNED_BYTE, e.data);
                else {
                    const { x: i, y: r } = s || {
                        x: 0,
                        y: 0
                    };
                    e instanceof HTMLImageElement || e instanceof HTMLCanvasElement || e instanceof HTMLVideoElement || e instanceof ImageData || t.a(e) ? l.texSubImage2D(l.TEXTURE_2D, 0, i, r, l.RGBA, l.UNSIGNED_BYTE, e) : l.texSubImage2D(l.TEXTURE_2D, 0, i, r, a, o, l.RGBA, l.UNSIGNED_BYTE, e.data);
                }
                this.useMipmap && this.isSizePowerOfTwo() && l.generateMipmap(l.TEXTURE_2D);
            }
            bind(t, e, i) {
                const { context: s } = this, { gl: a } = s;
                a.bindTexture(a.TEXTURE_2D, this.texture), i !== a.LINEAR_MIPMAP_NEAREST || this.isSizePowerOfTwo() || (i = a.LINEAR), t !== this.filter && (a.texParameteri(a.TEXTURE_2D, a.TEXTURE_MAG_FILTER, t), a.texParameteri(a.TEXTURE_2D, a.TEXTURE_MIN_FILTER, i || t), this.filter = t), e !== this.wrap && (a.texParameteri(a.TEXTURE_2D, a.TEXTURE_WRAP_S, e), a.texParameteri(a.TEXTURE_2D, a.TEXTURE_WRAP_T, e), this.wrap = e);
            }
            isSizePowerOfTwo() {
                return this.size[0] === this.size[1] && Math.log(this.size[0]) / Math.LN2 % 1 == 0;
            }
            destroy() {
                const { gl: t } = this.context;
                t.deleteTexture(this.texture), this.texture = null;
            }
        }
        function y(t) {
            const { userImage: e } = t;
            return !!(e && e.render && e.render()) && (t.data.replace(new Uint8Array(e.data.buffer)), !0);
        }
        class b extends t.E {
            constructor(){
                super(), this.images = {}, this.updatedImages = {}, this.callbackDispatchedThisFrame = {}, this.loaded = !1, this.requestors = [], this.patterns = {}, this.atlasImage = new t.R({
                    width: 1,
                    height: 1
                }), this.dirty = !0;
            }
            isLoaded() {
                return this.loaded;
            }
            setLoaded(t) {
                if (this.loaded !== t && (this.loaded = t, t)) {
                    for (const { ids: t, callback: e } of this.requestors)this._notify(t, e);
                    this.requestors = [];
                }
            }
            getImage(e) {
                const i = this.images[e];
                if (i && !i.data && i.spriteData) {
                    const e = i.spriteData;
                    i.data = new t.R({
                        width: e.width,
                        height: e.height
                    }, e.context.getImageData(e.x, e.y, e.width, e.height).data), i.spriteData = null;
                }
                return i;
            }
            addImage(t, e) {
                if (this.images[t]) throw new Error(`Image id ${t} already exist, use updateImage instead`);
                this._validate(t, e) && (this.images[t] = e);
            }
            _validate(e, i) {
                let s = !0;
                const a = i.data || i.spriteData;
                return this._validateStretch(i.stretchX, a && a.width) || (this.fire(new t.j(new Error(`Image "${e}" has invalid "stretchX" value`))), s = !1), this._validateStretch(i.stretchY, a && a.height) || (this.fire(new t.j(new Error(`Image "${e}" has invalid "stretchY" value`))), s = !1), this._validateContent(i.content, i) || (this.fire(new t.j(new Error(`Image "${e}" has invalid "content" value`))), s = !1), s;
            }
            _validateStretch(t, e) {
                if (!t) return !0;
                let i = 0;
                for (const s of t){
                    if (s[0] < i || s[1] < s[0] || e < s[1]) return !1;
                    i = s[1];
                }
                return !0;
            }
            _validateContent(t, e) {
                if (!t) return !0;
                if (4 !== t.length) return !1;
                const i = e.spriteData, s = i && i.width || e.data.width, a = i && i.height || e.data.height;
                return !(t[0] < 0 || s < t[0] || t[1] < 0 || a < t[1] || t[2] < 0 || s < t[2] || t[3] < 0 || a < t[3] || t[2] < t[0] || t[3] < t[1]);
            }
            updateImage(t, e, i = !0) {
                const s = this.getImage(t);
                if (i && (s.data.width !== e.data.width || s.data.height !== e.data.height)) throw new Error(`size mismatch between old image (${s.data.width}x${s.data.height}) and new image (${e.data.width}x${e.data.height}).`);
                e.version = s.version + 1, this.images[t] = e, this.updatedImages[t] = !0;
            }
            removeImage(t) {
                const e = this.images[t];
                delete this.images[t], delete this.patterns[t], e.userImage && e.userImage.onRemove && e.userImage.onRemove();
            }
            listImages() {
                return Object.keys(this.images);
            }
            getImages(t, e) {
                let i = !0;
                if (!this.isLoaded()) for (const e of t)this.images[e] || (i = !1);
                this.isLoaded() || i ? this._notify(t, e) : this.requestors.push({
                    ids: t,
                    callback: e
                });
            }
            _notify(e, i) {
                const s = {};
                for (const i of e){
                    let e = this.getImage(i);
                    e || (this.fire(new t.k("styleimagemissing", {
                        id: i
                    })), e = this.getImage(i)), e ? s[i] = {
                        data: e.data.clone(),
                        pixelRatio: e.pixelRatio,
                        sdf: e.sdf,
                        version: e.version,
                        stretchX: e.stretchX,
                        stretchY: e.stretchY,
                        content: e.content,
                        hasRenderCallback: Boolean(e.userImage && e.userImage.render)
                    } : t.w(`Image "${i}" could not be loaded. Please make sure you have added the image with map.addImage() or a "sprite" property in your style. You can provide missing images by listening for the "styleimagemissing" map event.`);
                }
                i(null, s);
            }
            getPixelSize() {
                const { width: t, height: e } = this.atlasImage;
                return {
                    width: t,
                    height: e
                };
            }
            getPattern(e) {
                const i = this.patterns[e], s = this.getImage(e);
                if (!s) return null;
                if (i && i.position.version === s.version) return i.position;
                if (i) i.position.version = s.version;
                else {
                    const i = {
                        w: s.data.width + 2,
                        h: s.data.height + 2,
                        x: 0,
                        y: 0
                    }, a = new t.I(i, s);
                    this.patterns[e] = {
                        bin: i,
                        position: a
                    };
                }
                return this._updatePatternAtlas(), this.patterns[e].position;
            }
            bind(t) {
                const e = t.gl;
                this.atlasTexture ? this.dirty && (this.atlasTexture.update(this.atlasImage), this.dirty = !1) : this.atlasTexture = new x(t, this.atlasImage, e.RGBA), this.atlasTexture.bind(e.LINEAR, e.CLAMP_TO_EDGE);
            }
            _updatePatternAtlas() {
                const e = [];
                for(const t in this.patterns)e.push(this.patterns[t].bin);
                const { w: i, h: s } = t.p(e), a = this.atlasImage;
                a.resize({
                    width: i || 1,
                    height: s || 1
                });
                for(const e in this.patterns){
                    const { bin: i } = this.patterns[e], s = i.x + 1, o = i.y + 1, r = this.getImage(e).data, n = r.width, l = r.height;
                    t.R.copy(r, a, {
                        x: 0,
                        y: 0
                    }, {
                        x: s,
                        y: o
                    }, {
                        width: n,
                        height: l
                    }), t.R.copy(r, a, {
                        x: 0,
                        y: l - 1
                    }, {
                        x: s,
                        y: o - 1
                    }, {
                        width: n,
                        height: 1
                    }), t.R.copy(r, a, {
                        x: 0,
                        y: 0
                    }, {
                        x: s,
                        y: o + l
                    }, {
                        width: n,
                        height: 1
                    }), t.R.copy(r, a, {
                        x: n - 1,
                        y: 0
                    }, {
                        x: s - 1,
                        y: o
                    }, {
                        width: 1,
                        height: l
                    }), t.R.copy(r, a, {
                        x: 0,
                        y: 0
                    }, {
                        x: s + n,
                        y: o
                    }, {
                        width: 1,
                        height: l
                    });
                }
                this.dirty = !0;
            }
            beginFrame() {
                this.callbackDispatchedThisFrame = {};
            }
            dispatchRenderCallbacks(e) {
                for (const i of e){
                    if (this.callbackDispatchedThisFrame[i]) continue;
                    this.callbackDispatchedThisFrame[i] = !0;
                    const e = this.getImage(i);
                    e || t.w(`Image with ID: "${i}" was not found`), y(e) && this.updateImage(i, e);
                }
            }
        }
        const w = 1e20;
        function T(t, e, i, s, a, o, r, n, l) {
            for(let h = e; h < e + s; h++)I(t, i * o + h, o, a, r, n, l);
            for(let h = i; h < i + a; h++)I(t, h * o + e, 1, s, r, n, l);
        }
        function I(t, e, i, s, a, o, r) {
            o[0] = 0, r[0] = -w, r[1] = w, a[0] = t[e];
            for(let n = 1, l = 0, h = 0; n < s; n++){
                a[n] = t[e + n * i];
                const s = n * n;
                do {
                    const t = o[l];
                    h = (a[n] - a[t] + s - t * t) / (n - t) / 2;
                }while (h <= r[l] && --l > -1);
                l++, o[l] = n, r[l] = h, r[l + 1] = w;
            }
            for(let n = 0, l = 0; n < s; n++){
                for(; r[l + 1] < n;)l++;
                const s = o[l], h = n - s;
                t[e + n * i] = a[s] + h * h;
            }
        }
        class E {
            constructor(t, e){
                this.requestManager = t, this.localIdeographFontFamily = e, this.entries = {};
            }
            setURL(t) {
                this.url = t;
            }
            getGlyphs(e, i) {
                const s = [];
                for(const t in e)for (const i of e[t])s.push({
                    stack: t,
                    id: i
                });
                t.o(s, ({ stack: t, id: e }, i)=>{
                    let s = this.entries[t];
                    s || (s = this.entries[t] = {
                        glyphs: {},
                        requests: {},
                        ranges: {}
                    });
                    let a = s.glyphs[e];
                    if (void 0 !== a) return void i(null, {
                        stack: t,
                        id: e,
                        glyph: a
                    });
                    if (a = this._tinySDF(s, t, e), a) return s.glyphs[e] = a, void i(null, {
                        stack: t,
                        id: e,
                        glyph: a
                    });
                    const o = Math.floor(e / 256);
                    if (256 * o > 65535) return void i(new Error("glyphs > 65535 not supported"));
                    if (s.ranges[o]) return void i(null, {
                        stack: t,
                        id: e,
                        glyph: a
                    });
                    if (!this.url) return void i(new Error("glyphsUrl is not set"));
                    let r = s.requests[o];
                    r || (r = s.requests[o] = [], E.loadGlyphRange(t, o, this.url, this.requestManager, (t, e)=>{
                        if (e) {
                            for(const t in e)this._doesCharSupportLocalGlyph(+t) || (s.glyphs[+t] = e[+t]);
                            s.ranges[o] = !0;
                        }
                        for (const i of r)i(t, e);
                        delete s.requests[o];
                    })), r.push((s, a)=>{
                        s ? i(s) : a && i(null, {
                            stack: t,
                            id: e,
                            glyph: a[e] || null
                        });
                    });
                }, (t, e)=>{
                    if (t) i(t);
                    else if (e) {
                        const t = {};
                        for (const { stack: i, id: s, glyph: a } of e)(t[i] || (t[i] = {}))[s] = a && {
                            id: a.id,
                            bitmap: a.bitmap.clone(),
                            metrics: a.metrics
                        };
                        i(null, t);
                    }
                });
            }
            _doesCharSupportLocalGlyph(e) {
                return !!this.localIdeographFontFamily && (t.u["CJK Unified Ideographs"](e) || t.u["Hangul Syllables"](e) || t.u.Hiragana(e) || t.u.Katakana(e));
            }
            _tinySDF(e, i, s) {
                const a = this.localIdeographFontFamily;
                if (!a) return;
                if (!this._doesCharSupportLocalGlyph(s)) return;
                let o = e.tinySDF;
                if (!o) {
                    let t = "400";
                    /bold/i.test(i) ? t = "900" : /medium/i.test(i) ? t = "500" : /light/i.test(i) && (t = "200"), o = e.tinySDF = new E.TinySDF({
                        fontSize: 48,
                        buffer: 6,
                        radius: 16,
                        cutoff: .25,
                        fontFamily: a,
                        fontWeight: t
                    });
                }
                const r = o.draw(String.fromCharCode(s));
                return {
                    id: s,
                    bitmap: new t.q({
                        width: r.width || 60,
                        height: r.height || 60
                    }, r.data),
                    metrics: {
                        width: r.glyphWidth / 2 || 24,
                        height: r.glyphHeight / 2 || 24,
                        left: r.glyphLeft / 2 + .5 || 0,
                        top: r.glyphTop / 2 - 27.5 || -8,
                        advance: r.glyphAdvance / 2 || 24,
                        isDoubleResolution: !0
                    }
                };
            }
        }
        E.loadGlyphRange = function(e, i, s, a, o) {
            const r = 256 * i, n = r + 255, l = a.transformRequest(s.replace("{fontstack}", e).replace("{range}", `${r}-${n}`), c.Glyphs);
            t.l(l, (e, i)=>{
                if (e) o(e);
                else if (i) {
                    const e = {};
                    for (const s of t.n(i))e[s.id] = s;
                    o(null, e);
                }
            });
        }, E.TinySDF = class {
            constructor({ fontSize: t = 24, buffer: e = 3, radius: i = 8, cutoff: s = .25, fontFamily: a = "sans-serif", fontWeight: o = "normal", fontStyle: r = "normal" } = {}){
                this.buffer = e, this.cutoff = s, this.radius = i;
                const n = this.size = t + 4 * e, l = this._createCanvas(n), h = this.ctx = l.getContext("2d", {
                    willReadFrequently: !0
                });
                h.font = `${r} ${o} ${t}px ${a}`, h.textBaseline = "alphabetic", h.textAlign = "left", h.fillStyle = "black", this.gridOuter = new Float64Array(n * n), this.gridInner = new Float64Array(n * n), this.f = new Float64Array(n), this.z = new Float64Array(n + 1), this.v = new Uint16Array(n);
            }
            _createCanvas(t) {
                const e = document.createElement("canvas");
                return e.width = e.height = t, e;
            }
            draw(t) {
                const { width: e, actualBoundingBoxAscent: i, actualBoundingBoxDescent: s, actualBoundingBoxLeft: a, actualBoundingBoxRight: o } = this.ctx.measureText(t), r = Math.ceil(i), n = Math.max(0, Math.min(this.size - this.buffer, Math.ceil(o - a))), l = Math.min(this.size - this.buffer, r + Math.ceil(s)), h = n + 2 * this.buffer, c = l + 2 * this.buffer, u = Math.max(h * c, 0), d = new Uint8ClampedArray(u), _ = {
                    data: d,
                    width: h,
                    height: c,
                    glyphWidth: n,
                    glyphHeight: l,
                    glyphTop: r,
                    glyphLeft: 0,
                    glyphAdvance: e
                };
                if (0 === n || 0 === l) return _;
                const { ctx: p, buffer: m, gridInner: f, gridOuter: g } = this;
                p.clearRect(m, m, n, l), p.fillText(t, m, m + r);
                const v = p.getImageData(m, m, n, l);
                g.fill(w, 0, u), f.fill(0, 0, u);
                for(let t = 0; t < l; t++)for(let e = 0; e < n; e++){
                    const i = v.data[4 * (t * n + e) + 3] / 255;
                    if (0 === i) continue;
                    const s = (t + m) * h + e + m;
                    if (1 === i) g[s] = 0, f[s] = w;
                    else {
                        const t = .5 - i;
                        g[s] = t > 0 ? t * t : 0, f[s] = t < 0 ? t * t : 0;
                    }
                }
                T(g, 0, 0, h, c, h, this.f, this.v, this.z), T(f, m, m, n, l, h, this.f, this.v, this.z);
                for(let t = 0; t < u; t++){
                    const e = Math.sqrt(g[t]) - Math.sqrt(f[t]);
                    d[t] = Math.round(255 - 255 * (e / this.radius + this.cutoff));
                }
                return _;
            }
        };
        class S {
            constructor(){
                this.specification = t.v.light.position;
            }
            possiblyEvaluate(e, i) {
                return t.z(e.expression.evaluate(i));
            }
            interpolate(e, i, s) {
                return {
                    x: t.B.number(e.x, i.x, s),
                    y: t.B.number(e.y, i.y, s),
                    z: t.B.number(e.z, i.z, s)
                };
            }
        }
        let C;
        class P extends t.E {
            constructor(e){
                super(), C = C || new t.r({
                    anchor: new t.D(t.v.light.anchor),
                    position: new S,
                    color: new t.D(t.v.light.color),
                    intensity: new t.D(t.v.light.intensity)
                }), this._transitionable = new t.T(C), this.setLight(e), this._transitioning = this._transitionable.untransitioned();
            }
            getLight() {
                return this._transitionable.serialize();
            }
            setLight(e, i = {}) {
                if (!this._validate(t.t, e, i)) for(const t in e){
                    const i = e[t];
                    t.endsWith("-transition") ? this._transitionable.setTransition(t.slice(0, -11), i) : this._transitionable.setValue(t, i);
                }
            }
            updateTransitions(t) {
                this._transitioning = this._transitionable.transitioned(t, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition();
            }
            recalculate(t) {
                this.properties = this._transitioning.possiblyEvaluate(t);
            }
            _validate(e, i, s) {
                return (!s || !1 !== s.validate) && t.x(this, e.call(t.y, t.e({
                    value: i,
                    style: {
                        glyphs: !0,
                        sprite: !0
                    },
                    styleSpec: t.v
                })));
            }
        }
        class D {
            constructor(t, e){
                this.width = t, this.height = e, this.nextRow = 0, this.data = new Uint8Array(this.width * this.height), this.dashEntry = {};
            }
            getDash(t, e) {
                const i = t.join(",") + String(e);
                return this.dashEntry[i] || (this.dashEntry[i] = this.addDash(t, e)), this.dashEntry[i];
            }
            getDashRanges(t, e, i) {
                const s = [];
                let a = t.length % 2 == 1 ? -t[t.length - 1] * i : 0, o = t[0] * i, r = !0;
                s.push({
                    left: a,
                    right: o,
                    isDash: r,
                    zeroLength: 0 === t[0]
                });
                let n = t[0];
                for(let e = 1; e < t.length; e++){
                    r = !r;
                    const l = t[e];
                    a = n * i, n += l, o = n * i, s.push({
                        left: a,
                        right: o,
                        isDash: r,
                        zeroLength: 0 === l
                    });
                }
                return s;
            }
            addRoundDash(t, e, i) {
                const s = e / 2;
                for(let e = -i; e <= i; e++){
                    const a = this.width * (this.nextRow + i + e);
                    let o = 0, r = t[o];
                    for(let n = 0; n < this.width; n++){
                        n / r.right > 1 && (r = t[++o]);
                        const l = Math.abs(n - r.left), h = Math.abs(n - r.right), c = Math.min(l, h);
                        let u;
                        const d = e / i * (s + 1);
                        if (r.isDash) {
                            const t = s - Math.abs(d);
                            u = Math.sqrt(c * c + t * t);
                        } else u = s - Math.sqrt(c * c + d * d);
                        this.data[a + n] = Math.max(0, Math.min(255, u + 128));
                    }
                }
            }
            addRegularDash(t) {
                for(let e = t.length - 1; e >= 0; --e){
                    const i = t[e], s = t[e + 1];
                    i.zeroLength ? t.splice(e, 1) : s && s.isDash === i.isDash && (s.left = i.left, t.splice(e, 1));
                }
                const e = t[0], i = t[t.length - 1];
                e.isDash === i.isDash && (e.left = i.left - this.width, i.right = e.right + this.width);
                const s = this.width * this.nextRow;
                let a = 0, o = t[a];
                for(let e = 0; e < this.width; e++){
                    e / o.right > 1 && (o = t[++a]);
                    const i = Math.abs(e - o.left), r = Math.abs(e - o.right), n = Math.min(i, r);
                    this.data[s + e] = Math.max(0, Math.min(255, (o.isDash ? n : -n) + 128));
                }
            }
            addDash(e, i) {
                const s = i ? 7 : 0, a = 2 * s + 1;
                if (this.nextRow + a > this.height) return t.w("LineAtlas out of space"), null;
                let o = 0;
                for(let t = 0; t < e.length; t++)o += e[t];
                if (0 !== o) {
                    const t = this.width / o, a = this.getDashRanges(e, this.width, t);
                    i ? this.addRoundDash(a, t, s) : this.addRegularDash(a);
                }
                const r = {
                    y: (this.nextRow + s + .5) / this.height,
                    height: 2 * s / this.height,
                    width: o
                };
                return this.nextRow += a, this.dirty = !0, r;
            }
            bind(t) {
                const e = t.gl;
                this.texture ? (e.bindTexture(e.TEXTURE_2D, this.texture), this.dirty && (this.dirty = !1, e.texSubImage2D(e.TEXTURE_2D, 0, 0, 0, this.width, this.height, e.ALPHA, e.UNSIGNED_BYTE, this.data))) : (this.texture = e.createTexture(), e.bindTexture(e.TEXTURE_2D, this.texture), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_S, e.REPEAT), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_T, e.REPEAT), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MIN_FILTER, e.LINEAR), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MAG_FILTER, e.LINEAR), e.texImage2D(e.TEXTURE_2D, 0, e.ALPHA, this.width, this.height, 0, e.ALPHA, e.UNSIGNED_BYTE, this.data));
            }
        }
        class M {
            constructor(e, i, s){
                this.workerPool = e, this.actors = [], this.currentActor = 0, this.id = s;
                const a = this.workerPool.acquire(s);
                for(let e = 0; e < a.length; e++){
                    const o = new t.C(a[e], i, s);
                    o.name = `Worker ${e}`, this.actors.push(o);
                }
                if (!this.actors.length) throw new Error("No actors found");
            }
            broadcast(e, i, s) {
                t.o(this.actors, (t, s)=>{
                    t.send(e, i, s);
                }, s = s || function() {});
            }
            getActor() {
                return this.currentActor = (this.currentActor + 1) % this.actors.length, this.actors[this.currentActor];
            }
            remove(t = !0) {
                this.actors.forEach((t)=>{
                    t.remove();
                }), this.actors = [], t && this.workerPool.release(this.id);
            }
        }
        function z(e, i, s) {
            const a = function(i, a) {
                if (i) return s(i);
                if (a) {
                    const i = t.F(t.e(a, e), [
                        "tiles",
                        "minzoom",
                        "maxzoom",
                        "attribution",
                        "bounds",
                        "scheme",
                        "tileSize",
                        "encoding"
                    ]);
                    a.vector_layers && (i.vectorLayers = a.vector_layers, i.vectorLayerIds = i.vectorLayers.map((t)=>t.id)), s(null, i);
                }
            };
            return e.url ? t.f(i.transformRequest(e.url, c.Source), a) : t.h.frame(()=>a(null, e));
        }
        class L {
            constructor(t, e){
                t && (e ? this.setSouthWest(t).setNorthEast(e) : Array.isArray(t) && (4 === t.length ? this.setSouthWest([
                    t[0],
                    t[1]
                ]).setNorthEast([
                    t[2],
                    t[3]
                ]) : this.setSouthWest(t[0]).setNorthEast(t[1])));
            }
            setNorthEast(e) {
                return this._ne = e instanceof t.L ? new t.L(e.lng, e.lat) : t.L.convert(e), this;
            }
            setSouthWest(e) {
                return this._sw = e instanceof t.L ? new t.L(e.lng, e.lat) : t.L.convert(e), this;
            }
            extend(e) {
                const i = this._sw, s = this._ne;
                let a, o;
                if (e instanceof t.L) a = e, o = e;
                else {
                    if (!(e instanceof L)) return Array.isArray(e) ? 4 === e.length || e.every(Array.isArray) ? this.extend(L.convert(e)) : this.extend(t.L.convert(e)) : e && ("lng" in e || "lon" in e) && "lat" in e ? this.extend(t.L.convert(e)) : this;
                    if (a = e._sw, o = e._ne, !a || !o) return this;
                }
                return i || s ? (i.lng = Math.min(a.lng, i.lng), i.lat = Math.min(a.lat, i.lat), s.lng = Math.max(o.lng, s.lng), s.lat = Math.max(o.lat, s.lat)) : (this._sw = new t.L(a.lng, a.lat), this._ne = new t.L(o.lng, o.lat)), this;
            }
            getCenter() {
                return new t.L((this._sw.lng + this._ne.lng) / 2, (this._sw.lat + this._ne.lat) / 2);
            }
            getSouthWest() {
                return this._sw;
            }
            getNorthEast() {
                return this._ne;
            }
            getNorthWest() {
                return new t.L(this.getWest(), this.getNorth());
            }
            getSouthEast() {
                return new t.L(this.getEast(), this.getSouth());
            }
            getWest() {
                return this._sw.lng;
            }
            getSouth() {
                return this._sw.lat;
            }
            getEast() {
                return this._ne.lng;
            }
            getNorth() {
                return this._ne.lat;
            }
            toArray() {
                return [
                    this._sw.toArray(),
                    this._ne.toArray()
                ];
            }
            toString() {
                return `LngLatBounds(${this._sw.toString()}, ${this._ne.toString()})`;
            }
            isEmpty() {
                return !(this._sw && this._ne);
            }
            contains(e) {
                const { lng: i, lat: s } = t.L.convert(e);
                let a = this._sw.lng <= i && i <= this._ne.lng;
                return this._sw.lng > this._ne.lng && (a = this._sw.lng >= i && i >= this._ne.lng), this._sw.lat <= s && s <= this._ne.lat && a;
            }
            static convert(t) {
                return t instanceof L ? t : t ? new L(t) : t;
            }
            static fromLngLat(e, i = 0) {
                const s = 360 * i / 40075017, a = s / Math.cos(Math.PI / 180 * e.lat);
                return new L(new t.L(e.lng - a, e.lat - s), new t.L(e.lng + a, e.lat + s));
            }
        }
        class A {
            constructor(t, e, i){
                this.bounds = L.convert(this.validateBounds(t)), this.minzoom = e || 0, this.maxzoom = i || 24;
            }
            validateBounds(t) {
                return Array.isArray(t) && 4 === t.length ? [
                    Math.max(-180, t[0]),
                    Math.max(-90, t[1]),
                    Math.min(180, t[2]),
                    Math.min(90, t[3])
                ] : [
                    -180,
                    -90,
                    180,
                    90
                ];
            }
            contains(e) {
                const i = Math.pow(2, e.z), s = Math.floor(t.G(this.bounds.getWest()) * i), a = Math.floor(t.H(this.bounds.getNorth()) * i), o = Math.ceil(t.G(this.bounds.getEast()) * i), r = Math.ceil(t.H(this.bounds.getSouth()) * i);
                return e.x >= s && e.x < o && e.y >= a && e.y < r;
            }
        }
        class R extends t.E {
            constructor(e, i, s, a){
                if (super(), this.load = ()=>{
                    this._loaded = !1, this.fire(new t.k("dataloading", {
                        dataType: "source"
                    })), this._tileJSONRequest = z(this._options, this.map._requestManager, (e, i)=>{
                        this._tileJSONRequest = null, this._loaded = !0, this.map.style.sourceCaches[this.id].clearTiles(), e ? this.fire(new t.j(e)) : i && (t.e(this, i), i.bounds && (this.tileBounds = new A(i.bounds, this.minzoom, this.maxzoom)), this.fire(new t.k("data", {
                            dataType: "source",
                            sourceDataType: "metadata"
                        })), this.fire(new t.k("data", {
                            dataType: "source",
                            sourceDataType: "content"
                        })));
                    });
                }, this.serialize = ()=>t.e({}, this._options), this.id = e, this.dispatcher = s, this.type = "vector", this.minzoom = 0, this.maxzoom = 22, this.scheme = "xyz", this.tileSize = 512, this.reparseOverscaled = !0, this.isTileClipped = !0, this._loaded = !1, t.e(this, t.F(i, [
                    "url",
                    "scheme",
                    "tileSize",
                    "promoteId"
                ])), this._options = t.e({
                    type: "vector"
                }, i), this._collectResourceTiming = i.collectResourceTiming, 512 !== this.tileSize) throw new Error("vector tile sources must have a tileSize of 512");
                this.setEventedParent(a);
            }
            loaded() {
                return this._loaded;
            }
            hasTile(t) {
                return !this.tileBounds || this.tileBounds.contains(t.canonical);
            }
            onAdd(t) {
                this.map = t, this.load();
            }
            setSourceProperty(t) {
                this._tileJSONRequest && this._tileJSONRequest.cancel(), t(), this.load();
            }
            setTiles(t) {
                return this.setSourceProperty(()=>{
                    this._options.tiles = t;
                }), this;
            }
            setUrl(t) {
                return this.setSourceProperty(()=>{
                    this.url = t, this._options.url = t;
                }), this;
            }
            onRemove() {
                this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
            }
            loadTile(t, e) {
                const i = t.tileID.canonical.url(this.tiles, this.map.getPixelRatio(), this.scheme), s = {
                    request: this.map._requestManager.transformRequest(i, c.Tile),
                    uid: t.uid,
                    tileID: t.tileID,
                    zoom: t.tileID.overscaledZ,
                    tileSize: this.tileSize * t.tileID.overscaleFactor(),
                    type: this.type,
                    source: this.id,
                    pixelRatio: this.map.getPixelRatio(),
                    showCollisionBoxes: this.map.showCollisionBoxes,
                    promoteId: this.promoteId
                };
                function a(i, s) {
                    return delete t.request, t.aborted ? e(null) : i && 404 !== i.status ? e(i) : (s && s.resourceTiming && (t.resourceTiming = s.resourceTiming), this.map._refreshExpiredTiles && s && t.setExpiryData(s), t.loadVectorData(s, this.map.painter), e(null), void (t.reloadCallback && (this.loadTile(t, t.reloadCallback), t.reloadCallback = null)));
                }
                s.request.collectResourceTiming = this._collectResourceTiming, t.actor && "expired" !== t.state ? "loading" === t.state ? t.reloadCallback = e : t.request = t.actor.send("reloadTile", s, a.bind(this)) : (t.actor = this.dispatcher.getActor(), t.request = t.actor.send("loadTile", s, a.bind(this)));
            }
            abortTile(t) {
                t.request && (t.request.cancel(), delete t.request), t.actor && t.actor.send("abortTile", {
                    uid: t.uid,
                    type: this.type,
                    source: this.id
                }, void 0);
            }
            unloadTile(t) {
                t.unloadVectorData(), t.actor && t.actor.send("removeTile", {
                    uid: t.uid,
                    type: this.type,
                    source: this.id
                }, void 0);
            }
            hasTransition() {
                return !1;
            }
        }
        class k extends t.E {
            constructor(e, i, s, a){
                super(), this.id = e, this.dispatcher = s, this.setEventedParent(a), this.type = "raster", this.minzoom = 0, this.maxzoom = 22, this.roundZoom = !0, this.scheme = "xyz", this.tileSize = 512, this._loaded = !1, this._options = t.e({
                    type: "raster"
                }, i), t.e(this, t.F(i, [
                    "url",
                    "scheme",
                    "tileSize"
                ]));
            }
            load() {
                this._loaded = !1, this.fire(new t.k("dataloading", {
                    dataType: "source"
                })), this._tileJSONRequest = z(this._options, this.map._requestManager, (e, i)=>{
                    this._tileJSONRequest = null, this._loaded = !0, e ? this.fire(new t.j(e)) : i && (t.e(this, i), i.bounds && (this.tileBounds = new A(i.bounds, this.minzoom, this.maxzoom)), this.fire(new t.k("data", {
                        dataType: "source",
                        sourceDataType: "metadata"
                    })), this.fire(new t.k("data", {
                        dataType: "source",
                        sourceDataType: "content"
                    })));
                });
            }
            loaded() {
                return this._loaded;
            }
            onAdd(t) {
                this.map = t, this.load();
            }
            onRemove() {
                this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
            }
            setSourceProperty(t) {
                this._tileJSONRequest && this._tileJSONRequest.cancel(), t(), this.load();
            }
            setTiles(t) {
                return this.setSourceProperty(()=>{
                    this._options.tiles = t;
                }), this;
            }
            serialize() {
                return t.e({}, this._options);
            }
            hasTile(t) {
                return !this.tileBounds || this.tileBounds.contains(t.canonical);
            }
            loadTile(t, e) {
                const i = t.tileID.canonical.url(this.tiles, this.map.getPixelRatio(), this.scheme);
                t.request = h.getImage(this.map._requestManager.transformRequest(i, c.Tile), (i, s, a)=>{
                    if (delete t.request, t.aborted) t.state = "unloaded", e(null);
                    else if (i) t.state = "errored", e(i);
                    else if (s) {
                        this.map._refreshExpiredTiles && a && t.setExpiryData(a);
                        const i = this.map.painter.context, o = i.gl;
                        t.texture = this.map.painter.getTileTexture(s.width), t.texture ? t.texture.update(s, {
                            useMipmap: !0
                        }) : (t.texture = new x(i, s, o.RGBA, {
                            useMipmap: !0
                        }), t.texture.bind(o.LINEAR, o.CLAMP_TO_EDGE, o.LINEAR_MIPMAP_NEAREST), i.extTextureFilterAnisotropic && o.texParameterf(o.TEXTURE_2D, i.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, i.extTextureFilterAnisotropicMax)), t.state = "loaded", e(null);
                    }
                }, this.map._refreshExpiredTiles);
            }
            abortTile(t, e) {
                t.request && (t.request.cancel(), delete t.request), e();
            }
            unloadTile(t, e) {
                t.texture && this.map.painter.saveTileTexture(t.texture), e();
            }
            hasTransition() {
                return !1;
            }
        }
        class F extends k {
            constructor(e, i, s, a){
                super(e, i, s, a), this.type = "raster-dem", this.maxzoom = 22, this._options = t.e({
                    type: "raster-dem"
                }, i), this.encoding = i.encoding || "mapbox", this.redFactor = i.redFactor, this.greenFactor = i.greenFactor, this.blueFactor = i.blueFactor, this.baseShift = i.baseShift;
            }
            loadTile(e, i) {
                const s = e.tileID.canonical.url(this.tiles, this.map.getPixelRatio(), this.scheme), a = this.map._requestManager.transformRequest(s, c.Tile);
                function o(t, s) {
                    t && (e.state = "errored", i(t)), s && (e.dem = s, e.needsHillshadePrepare = !0, e.needsTerrainPrepare = !0, e.state = "loaded", i(null));
                }
                e.neighboringTiles = this._getNeighboringTiles(e.tileID), e.request = h.getImage(a, (s, a, r)=>t._(this, void 0, void 0, function*() {
                        if (delete e.request, e.aborted) e.state = "unloaded", i(null);
                        else if (s) e.state = "errored", i(s);
                        else if (a) {
                            this.map._refreshExpiredTiles && e.setExpiryData(r);
                            const i = t.a(a) && t.J() ? a : yield function(e) {
                                return t._(this, void 0, void 0, function*() {
                                    if ("undefined" != typeof VideoFrame && t.K()) {
                                        const i = e.width + 2, s = e.height + 2;
                                        try {
                                            return new t.R({
                                                width: i,
                                                height: s
                                            }, (yield t.M(e, -1, -1, i, s)));
                                        } catch (t) {}
                                    }
                                    return t.h.getImageData(e, 1);
                                });
                            }(a), s = {
                                uid: e.uid,
                                coord: e.tileID,
                                source: this.id,
                                rawImageData: i,
                                encoding: this.encoding,
                                redFactor: this.redFactor,
                                greenFactor: this.greenFactor,
                                blueFactor: this.blueFactor,
                                baseShift: this.baseShift
                            };
                            e.actor && "expired" !== e.state || (e.actor = this.dispatcher.getActor(), e.actor.send("loadDEMTile", s, o));
                        }
                    }), this.map._refreshExpiredTiles);
            }
            _getNeighboringTiles(e) {
                const i = e.canonical, s = Math.pow(2, i.z), a = (i.x - 1 + s) % s, o = 0 === i.x ? e.wrap - 1 : e.wrap, r = (i.x + 1 + s) % s, n = i.x + 1 === s ? e.wrap + 1 : e.wrap, l = {};
                return l[new t.O(e.overscaledZ, o, i.z, a, i.y).key] = {
                    backfilled: !1
                }, l[new t.O(e.overscaledZ, n, i.z, r, i.y).key] = {
                    backfilled: !1
                }, i.y > 0 && (l[new t.O(e.overscaledZ, o, i.z, a, i.y - 1).key] = {
                    backfilled: !1
                }, l[new t.O(e.overscaledZ, e.wrap, i.z, i.x, i.y - 1).key] = {
                    backfilled: !1
                }, l[new t.O(e.overscaledZ, n, i.z, r, i.y - 1).key] = {
                    backfilled: !1
                }), i.y + 1 < s && (l[new t.O(e.overscaledZ, o, i.z, a, i.y + 1).key] = {
                    backfilled: !1
                }, l[new t.O(e.overscaledZ, e.wrap, i.z, i.x, i.y + 1).key] = {
                    backfilled: !1
                }, l[new t.O(e.overscaledZ, n, i.z, r, i.y + 1).key] = {
                    backfilled: !1
                }), l;
            }
            unloadTile(t) {
                t.demTexture && this.map.painter.saveTileTexture(t.demTexture), t.fbo && (t.fbo.destroy(), delete t.fbo), t.dem && delete t.dem, delete t.neighboringTiles, t.state = "unloaded", t.actor && t.actor.send("removeDEMTile", {
                    uid: t.uid,
                    source: this.id
                });
            }
        }
        class B extends t.E {
            constructor(e, i, s, a){
                super(), this.load = ()=>{
                    this._updateWorkerData();
                }, this.serialize = ()=>t.e({}, this._options, {
                        type: this.type,
                        data: this._data
                    }), this.id = e, this.type = "geojson", this.minzoom = 0, this.maxzoom = 18, this.tileSize = 512, this.isTileClipped = !0, this.reparseOverscaled = !0, this._removed = !1, this._pendingLoads = 0, this.actor = s.getActor(), this.setEventedParent(a), this._data = i.data, this._options = t.e({}, i), this._collectResourceTiming = i.collectResourceTiming, void 0 !== i.maxzoom && (this.maxzoom = i.maxzoom), i.type && (this.type = i.type), i.attribution && (this.attribution = i.attribution), this.promoteId = i.promoteId;
                const o = t.N / this.tileSize;
                this.workerOptions = t.e({
                    source: this.id,
                    cluster: i.cluster || !1,
                    geojsonVtOptions: {
                        buffer: (void 0 !== i.buffer ? i.buffer : 128) * o,
                        tolerance: (void 0 !== i.tolerance ? i.tolerance : .375) * o,
                        extent: t.N,
                        maxZoom: this.maxzoom,
                        lineMetrics: i.lineMetrics || !1,
                        generateId: i.generateId || !1
                    },
                    superclusterOptions: {
                        maxZoom: void 0 !== i.clusterMaxZoom ? i.clusterMaxZoom : this.maxzoom - 1,
                        minPoints: Math.max(2, i.clusterMinPoints || 2),
                        extent: t.N,
                        radius: (i.clusterRadius || 50) * o,
                        log: !1,
                        generateId: i.generateId || !1
                    },
                    clusterProperties: i.clusterProperties,
                    filter: i.filter
                }, i.workerOptions), "string" == typeof this.promoteId && (this.workerOptions.promoteId = this.promoteId);
            }
            onAdd(t) {
                this.map = t, this.load();
            }
            setData(t) {
                return this._data = t, this._updateWorkerData(), this;
            }
            updateData(t) {
                return this._updateWorkerData(t), this;
            }
            setClusterOptions(t) {
                return this.workerOptions.cluster = t.cluster, t && (void 0 !== t.clusterRadius && (this.workerOptions.superclusterOptions.radius = t.clusterRadius), void 0 !== t.clusterMaxZoom && (this.workerOptions.superclusterOptions.maxZoom = t.clusterMaxZoom)), this._updateWorkerData(), this;
            }
            getClusterExpansionZoom(t, e) {
                return this.actor.send("geojson.getClusterExpansionZoom", {
                    clusterId: t,
                    source: this.id
                }, e), this;
            }
            getClusterChildren(t, e) {
                return this.actor.send("geojson.getClusterChildren", {
                    clusterId: t,
                    source: this.id
                }, e), this;
            }
            getClusterLeaves(t, e, i, s) {
                return this.actor.send("geojson.getClusterLeaves", {
                    source: this.id,
                    clusterId: t,
                    limit: e,
                    offset: i
                }, s), this;
            }
            _updateWorkerData(e) {
                const i = t.e({}, this.workerOptions);
                e ? i.dataDiff = e : "string" == typeof this._data ? (i.request = this.map._requestManager.transformRequest(t.h.resolveURL(this._data), c.Source), i.request.collectResourceTiming = this._collectResourceTiming) : i.data = JSON.stringify(this._data), this._pendingLoads++, this.fire(new t.k("dataloading", {
                    dataType: "source"
                })), this.actor.send(`${this.type}.loadData`, i, (e, i)=>{
                    if (this._pendingLoads--, this._removed || i && i.abandoned) return void this.fire(new t.k("dataabort", {
                        dataType: "source"
                    }));
                    let s = null;
                    if (i && i.resourceTiming && i.resourceTiming[this.id] && (s = i.resourceTiming[this.id].slice(0)), e) return void this.fire(new t.j(e));
                    const a = {
                        dataType: "source"
                    };
                    this._collectResourceTiming && s && s.length > 0 && t.e(a, {
                        resourceTiming: s
                    }), this.fire(new t.k("data", Object.assign(Object.assign({}, a), {
                        sourceDataType: "metadata"
                    }))), this.fire(new t.k("data", Object.assign(Object.assign({}, a), {
                        sourceDataType: "content"
                    })));
                });
            }
            loaded() {
                return 0 === this._pendingLoads;
            }
            loadTile(t, e) {
                const i = t.actor ? "reloadTile" : "loadTile";
                t.actor = this.actor;
                const s = {
                    type: this.type,
                    uid: t.uid,
                    tileID: t.tileID,
                    zoom: t.tileID.overscaledZ,
                    maxZoom: this.maxzoom,
                    tileSize: this.tileSize,
                    source: this.id,
                    pixelRatio: this.map.getPixelRatio(),
                    showCollisionBoxes: this.map.showCollisionBoxes,
                    promoteId: this.promoteId
                };
                t.request = this.actor.send(i, s, (s, a)=>(delete t.request, t.unloadVectorData(), t.aborted ? e(null) : s ? e(s) : (t.loadVectorData(a, this.map.painter, "reloadTile" === i), e(null))));
            }
            abortTile(t) {
                t.request && (t.request.cancel(), delete t.request), t.aborted = !0;
            }
            unloadTile(t) {
                t.unloadVectorData(), this.actor.send("removeTile", {
                    uid: t.uid,
                    type: this.type,
                    source: this.id
                });
            }
            onRemove() {
                this._removed = !0, this.actor.send("removeSource", {
                    type: this.type,
                    source: this.id
                });
            }
            hasTransition() {
                return !1;
            }
        }
        var O = t.Q([
            {
                name: "a_pos",
                type: "Int16",
                components: 2
            },
            {
                name: "a_texture_pos",
                type: "Int16",
                components: 2
            }
        ]);
        class N extends t.E {
            constructor(e, i, s, a){
                super(), this.load = (e, i)=>{
                    this._loaded = !1, this.fire(new t.k("dataloading", {
                        dataType: "source"
                    })), this.url = this.options.url, this._request = h.getImage(this.map._requestManager.transformRequest(this.url, c.Image), (s, a)=>{
                        this._request = null, this._loaded = !0, s ? this.fire(new t.j(s)) : a && (this.image = a, e && (this.coordinates = e), i && i(), this._finishLoading());
                    });
                }, this.prepare = ()=>{
                    if (0 === Object.keys(this.tiles).length || !this.image) return;
                    const e = this.map.painter.context, i = e.gl;
                    this.boundsBuffer || (this.boundsBuffer = e.createVertexBuffer(this._boundsArray, O.members)), this.boundsSegments || (this.boundsSegments = t.S.simpleSegment(0, 0, 4, 2)), this.texture || (this.texture = new x(e, this.image, i.RGBA), this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE));
                    let s = !1;
                    for(const t in this.tiles){
                        const e = this.tiles[t];
                        "loaded" !== e.state && (e.state = "loaded", e.texture = this.texture, s = !0);
                    }
                    s && this.fire(new t.k("data", {
                        dataType: "source",
                        sourceDataType: "idle",
                        sourceId: this.id
                    }));
                }, this.serialize = ()=>({
                        type: "image",
                        url: this.options.url,
                        coordinates: this.coordinates
                    }), this.id = e, this.dispatcher = s, this.coordinates = i.coordinates, this.type = "image", this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this.tiles = {}, this._loaded = !1, this.setEventedParent(a), this.options = i;
            }
            loaded() {
                return this._loaded;
            }
            updateImage(t) {
                return t.url ? (this._request && (this._request.cancel(), this._request = null), this.options.url = t.url, this.load(t.coordinates, ()=>{
                    this.texture = null;
                }), this) : this;
            }
            _finishLoading() {
                this.map && (this.setCoordinates(this.coordinates), this.fire(new t.k("data", {
                    dataType: "source",
                    sourceDataType: "metadata"
                })));
            }
            onAdd(t) {
                this.map = t, this.load();
            }
            onRemove() {
                this._request && (this._request.cancel(), this._request = null);
            }
            setCoordinates(e) {
                this.coordinates = e;
                const i = e.map(t.U.fromLngLat);
                this.tileID = function(e) {
                    let i = 1 / 0, s = 1 / 0, a = -1 / 0, o = -1 / 0;
                    for (const t of e)i = Math.min(i, t.x), s = Math.min(s, t.y), a = Math.max(a, t.x), o = Math.max(o, t.y);
                    const r = Math.max(a - i, o - s), n = Math.max(0, Math.floor(-Math.log(r) / Math.LN2)), l = Math.pow(2, n);
                    return new t.W(n, Math.floor((i + a) / 2 * l), Math.floor((s + o) / 2 * l));
                }(i), this.minzoom = this.maxzoom = this.tileID.z;
                const s = i.map((t)=>this.tileID.getTilePoint(t)._round());
                return this._boundsArray = new t.V, this._boundsArray.emplaceBack(s[0].x, s[0].y, 0, 0), this._boundsArray.emplaceBack(s[1].x, s[1].y, t.N, 0), this._boundsArray.emplaceBack(s[3].x, s[3].y, 0, t.N), this._boundsArray.emplaceBack(s[2].x, s[2].y, t.N, t.N), this.boundsBuffer && (this.boundsBuffer.destroy(), delete this.boundsBuffer), this.fire(new t.k("data", {
                    dataType: "source",
                    sourceDataType: "content"
                })), this;
            }
            loadTile(t, e) {
                this.tileID && this.tileID.equals(t.tileID.canonical) ? (this.tiles[String(t.tileID.wrap)] = t, t.buckets = {}, e(null)) : (t.state = "errored", e(null));
            }
            hasTransition() {
                return !1;
            }
        }
        class U extends N {
            constructor(e, i, s, a){
                super(e, i, s, a), this.load = ()=>{
                    this._loaded = !1;
                    const e = this.options;
                    this.urls = [];
                    for (const t of e.urls)this.urls.push(this.map._requestManager.transformRequest(t, c.Source).url);
                    t.X(this.urls, (e, i)=>{
                        this._loaded = !0, e ? this.fire(new t.j(e)) : i && (this.video = i, this.video.loop = !0, this.video.addEventListener("playing", ()=>{
                            this.map.triggerRepaint();
                        }), this.map && this.video.play(), this._finishLoading());
                    });
                }, this.prepare = ()=>{
                    if (0 === Object.keys(this.tiles).length || this.video.readyState < 2) return;
                    const e = this.map.painter.context, i = e.gl;
                    this.boundsBuffer || (this.boundsBuffer = e.createVertexBuffer(this._boundsArray, O.members)), this.boundsSegments || (this.boundsSegments = t.S.simpleSegment(0, 0, 4, 2)), this.texture ? this.video.paused || (this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE), i.texSubImage2D(i.TEXTURE_2D, 0, 0, 0, i.RGBA, i.UNSIGNED_BYTE, this.video)) : (this.texture = new x(e, this.video, i.RGBA), this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE));
                    let s = !1;
                    for(const t in this.tiles){
                        const e = this.tiles[t];
                        "loaded" !== e.state && (e.state = "loaded", e.texture = this.texture, s = !0);
                    }
                    s && this.fire(new t.k("data", {
                        dataType: "source",
                        sourceDataType: "idle",
                        sourceId: this.id
                    }));
                }, this.serialize = ()=>({
                        type: "video",
                        urls: this.urls,
                        coordinates: this.coordinates
                    }), this.roundZoom = !0, this.type = "video", this.options = i;
            }
            pause() {
                this.video && this.video.pause();
            }
            play() {
                this.video && this.video.play();
            }
            seek(e) {
                if (this.video) {
                    const i = this.video.seekable;
                    e < i.start(0) || e > i.end(0) ? this.fire(new t.j(new t.Y(`sources.${this.id}`, null, `Playback for this video can be set only between the ${i.start(0)} and ${i.end(0)}-second mark.`))) : this.video.currentTime = e;
                }
            }
            getVideo() {
                return this.video;
            }
            onAdd(t) {
                this.map || (this.map = t, this.load(), this.video && (this.video.play(), this.setCoordinates(this.coordinates)));
            }
            hasTransition() {
                return this.video && !this.video.paused;
            }
        }
        class Z extends N {
            constructor(e, i, s, a){
                super(e, i, s, a), this.load = ()=>{
                    this._loaded = !0, this.canvas || (this.canvas = this.options.canvas instanceof HTMLCanvasElement ? this.options.canvas : document.getElementById(this.options.canvas)), this.width = this.canvas.width, this.height = this.canvas.height, this._hasInvalidDimensions() ? this.fire(new t.j(new Error("Canvas dimensions cannot be less than or equal to zero."))) : (this.play = function() {
                        this._playing = !0, this.map.triggerRepaint();
                    }, this.pause = function() {
                        this._playing && (this.prepare(), this._playing = !1);
                    }, this._finishLoading());
                }, this.prepare = ()=>{
                    let e = !1;
                    if (this.canvas.width !== this.width && (this.width = this.canvas.width, e = !0), this.canvas.height !== this.height && (this.height = this.canvas.height, e = !0), this._hasInvalidDimensions()) return;
                    if (0 === Object.keys(this.tiles).length) return;
                    const i = this.map.painter.context, s = i.gl;
                    this.boundsBuffer || (this.boundsBuffer = i.createVertexBuffer(this._boundsArray, O.members)), this.boundsSegments || (this.boundsSegments = t.S.simpleSegment(0, 0, 4, 2)), this.texture ? (e || this._playing) && this.texture.update(this.canvas, {
                        premultiply: !0
                    }) : this.texture = new x(i, this.canvas, s.RGBA, {
                        premultiply: !0
                    });
                    let a = !1;
                    for(const t in this.tiles){
                        const e = this.tiles[t];
                        "loaded" !== e.state && (e.state = "loaded", e.texture = this.texture, a = !0);
                    }
                    a && this.fire(new t.k("data", {
                        dataType: "source",
                        sourceDataType: "idle",
                        sourceId: this.id
                    }));
                }, this.serialize = ()=>({
                        type: "canvas",
                        coordinates: this.coordinates
                    }), i.coordinates ? Array.isArray(i.coordinates) && 4 === i.coordinates.length && !i.coordinates.some((t)=>!Array.isArray(t) || 2 !== t.length || t.some((t)=>"number" != typeof t)) || this.fire(new t.j(new t.Y(`sources.${e}`, null, '"coordinates" property must be an array of 4 longitude/latitude array pairs'))) : this.fire(new t.j(new t.Y(`sources.${e}`, null, 'missing required property "coordinates"'))), i.animate && "boolean" != typeof i.animate && this.fire(new t.j(new t.Y(`sources.${e}`, null, 'optional "animate" property must be a boolean value'))), i.canvas ? "string" == typeof i.canvas || i.canvas instanceof HTMLCanvasElement || this.fire(new t.j(new t.Y(`sources.${e}`, null, '"canvas" must be either a string representing the ID of the canvas element from which to read, or an HTMLCanvasElement instance'))) : this.fire(new t.j(new t.Y(`sources.${e}`, null, 'missing required property "canvas"'))), this.options = i, this.animate = void 0 === i.animate || i.animate;
            }
            getCanvas() {
                return this.canvas;
            }
            onAdd(t) {
                this.map = t, this.load(), this.canvas && this.animate && this.play();
            }
            onRemove() {
                this.pause();
            }
            hasTransition() {
                return this._playing;
            }
            _hasInvalidDimensions() {
                for (const t of [
                    this.canvas.width,
                    this.canvas.height
                ])if (isNaN(t) || t <= 0) return !0;
                return !1;
            }
        }
        const G = {}, j = (t)=>{
            switch(t){
                case "geojson":
                    return B;
                case "image":
                    return N;
                case "raster":
                    return k;
                case "raster-dem":
                    return F;
                case "vector":
                    return R;
                case "video":
                    return U;
                case "canvas":
                    return Z;
            }
            return G[t];
        };
        function V(e, i) {
            const s = t.Z();
            return t.$(s, s, [
                1,
                1,
                0
            ]), t.a0(s, s, [
                .5 * e.width,
                .5 * e.height,
                1
            ]), t.a1(s, s, e.calculatePosMatrix(i.toUnwrapped()));
        }
        function q(t, e, i, s, a, o) {
            const r = function(t, e, i) {
                if (t) for (const s of t){
                    const t = e[s];
                    if (t && t.source === i && "fill-extrusion" === t.type) return !0;
                }
                else for(const t in e){
                    const s = e[t];
                    if (s.source === i && "fill-extrusion" === s.type) return !0;
                }
                return !1;
            }(a && a.layers, e, t.id), n = o.maxPitchScaleFactor(), l = t.tilesIn(s, n, r);
            l.sort($);
            const h = [];
            for (const s of l)h.push({
                wrappedTileID: s.tileID.wrapped().key,
                queryResults: s.tile.queryRenderedFeatures(e, i, t._state, s.queryGeometry, s.cameraQueryGeometry, s.scale, a, o, n, V(t.transform, s.tileID))
            });
            const c = function(t) {
                const e = {}, i = {};
                for (const s of t){
                    const t = s.queryResults, a = s.wrappedTileID, o = i[a] = i[a] || {};
                    for(const i in t){
                        const s = t[i], a = o[i] = o[i] || {}, r = e[i] = e[i] || [];
                        for (const t of s)a[t.featureIndex] || (a[t.featureIndex] = !0, r.push(t));
                    }
                }
                return e;
            }(h);
            for(const e in c)c[e].forEach((e)=>{
                const i = e.feature, s = t.getFeatureState(i.layer["source-layer"], i.id);
                i.source = i.layer.source, i.layer["source-layer"] && (i.sourceLayer = i.layer["source-layer"]), i.state = s;
            });
            return c;
        }
        function $(t, e) {
            const i = t.tileID, s = e.tileID;
            return i.overscaledZ - s.overscaledZ || i.canonical.y - s.canonical.y || i.wrap - s.wrap || i.canonical.x - s.canonical.x;
        }
        class W {
            constructor(e, i){
                this.timeAdded = 0, this.fadeEndTime = 0, this.tileID = e, this.uid = t.a2(), this.uses = 0, this.tileSize = i, this.buckets = {}, this.expirationTime = null, this.queryPadding = 0, this.hasSymbolBuckets = !1, this.hasRTLText = !1, this.dependencies = {}, this.rtt = [], this.rttCoords = {}, this.expiredRequestCount = 0, this.state = "loading";
            }
            registerFadeDuration(t) {
                const e = t + this.timeAdded;
                e < this.fadeEndTime || (this.fadeEndTime = e);
            }
            wasRequested() {
                return "errored" === this.state || "loaded" === this.state || "reloading" === this.state;
            }
            clearTextures(t) {
                this.demTexture && t.saveTileTexture(this.demTexture), this.demTexture = null;
            }
            loadVectorData(e, i, s) {
                if (this.hasData() && this.unloadVectorData(), this.state = "loaded", e) {
                    e.featureIndex && (this.latestFeatureIndex = e.featureIndex, e.rawTileData ? (this.latestRawTileData = e.rawTileData, this.latestFeatureIndex.rawTileData = e.rawTileData) : this.latestRawTileData && (this.latestFeatureIndex.rawTileData = this.latestRawTileData)), this.collisionBoxArray = e.collisionBoxArray, this.buckets = function(t, e) {
                        const i = {};
                        if (!e) return i;
                        for (const s of t){
                            const t = s.layerIds.map((t)=>e.getLayer(t)).filter(Boolean);
                            if (0 !== t.length) {
                                s.layers = t, s.stateDependentLayerIds && (s.stateDependentLayers = s.stateDependentLayerIds.map((e)=>t.filter((t)=>t.id === e)[0]));
                                for (const e of t)i[e.id] = s;
                            }
                        }
                        return i;
                    }(e.buckets, i.style), this.hasSymbolBuckets = !1;
                    for(const e in this.buckets){
                        const i = this.buckets[e];
                        if (i instanceof t.a4) {
                            if (this.hasSymbolBuckets = !0, !s) break;
                            i.justReloaded = !0;
                        }
                    }
                    if (this.hasRTLText = !1, this.hasSymbolBuckets) for(const e in this.buckets){
                        const i = this.buckets[e];
                        if (i instanceof t.a4 && i.hasRTLText) {
                            this.hasRTLText = !0, t.a5();
                            break;
                        }
                    }
                    this.queryPadding = 0;
                    for(const t in this.buckets){
                        const e = this.buckets[t];
                        this.queryPadding = Math.max(this.queryPadding, i.style.getLayer(t).queryRadius(e));
                    }
                    e.imageAtlas && (this.imageAtlas = e.imageAtlas), e.glyphAtlasImage && (this.glyphAtlasImage = e.glyphAtlasImage);
                } else this.collisionBoxArray = new t.a3;
            }
            unloadVectorData() {
                for(const t in this.buckets)this.buckets[t].destroy();
                this.buckets = {}, this.imageAtlasTexture && this.imageAtlasTexture.destroy(), this.imageAtlas && (this.imageAtlas = null), this.glyphAtlasTexture && this.glyphAtlasTexture.destroy(), this.latestFeatureIndex = null, this.state = "unloaded";
            }
            getBucket(t) {
                return this.buckets[t.id];
            }
            upload(t) {
                for(const e in this.buckets){
                    const i = this.buckets[e];
                    i.uploadPending() && i.upload(t);
                }
                const e = t.gl;
                this.imageAtlas && !this.imageAtlas.uploaded && (this.imageAtlasTexture = new x(t, this.imageAtlas.image, e.RGBA), this.imageAtlas.uploaded = !0), this.glyphAtlasImage && (this.glyphAtlasTexture = new x(t, this.glyphAtlasImage, e.ALPHA), this.glyphAtlasImage = null);
            }
            prepare(t) {
                this.imageAtlas && this.imageAtlas.patchUpdatedImages(t, this.imageAtlasTexture);
            }
            queryRenderedFeatures(t, e, i, s, a, o, r, n, l, h) {
                return this.latestFeatureIndex && this.latestFeatureIndex.rawTileData ? this.latestFeatureIndex.query({
                    queryGeometry: s,
                    cameraQueryGeometry: a,
                    scale: o,
                    tileSize: this.tileSize,
                    pixelPosMatrix: h,
                    transform: n,
                    params: r,
                    queryPadding: this.queryPadding * l
                }, t, e, i) : {};
            }
            querySourceFeatures(e, i) {
                const s = this.latestFeatureIndex;
                if (!s || !s.rawTileData) return;
                const a = s.loadVTLayers(), o = i && i.sourceLayer ? i.sourceLayer : "", r = a._geojsonTileLayer || a[o];
                if (!r) return;
                const n = t.a6(i && i.filter), { z: l, x: h, y: c } = this.tileID.canonical, u = {
                    z: l,
                    x: h,
                    y: c
                };
                for(let i = 0; i < r.length; i++){
                    const a = r.feature(i);
                    if (n.needGeometry) {
                        const e = t.a7(a, !0);
                        if (!n.filter(new t.a8(this.tileID.overscaledZ), e, this.tileID.canonical)) continue;
                    } else if (!n.filter(new t.a8(this.tileID.overscaledZ), a)) continue;
                    const d = s.getId(a, o), _ = new t.a9(a, l, h, c, d);
                    _.tile = u, e.push(_);
                }
            }
            hasData() {
                return "loaded" === this.state || "reloading" === this.state || "expired" === this.state;
            }
            patternsLoaded() {
                return this.imageAtlas && !!Object.keys(this.imageAtlas.patternPositions).length;
            }
            setExpiryData(e) {
                const i = this.expirationTime;
                if (e.cacheControl) {
                    const i = t.aa(e.cacheControl);
                    i["max-age"] && (this.expirationTime = Date.now() + 1e3 * i["max-age"]);
                } else e.expires && (this.expirationTime = new Date(e.expires).getTime());
                if (this.expirationTime) {
                    const t = Date.now();
                    let e = !1;
                    if (this.expirationTime > t) e = !1;
                    else if (i) {
                        if (this.expirationTime < i) e = !0;
                        else {
                            const s = this.expirationTime - i;
                            s ? this.expirationTime = t + Math.max(s, 3e4) : e = !0;
                        }
                    } else e = !0;
                    e ? (this.expiredRequestCount++, this.state = "expired") : this.expiredRequestCount = 0;
                }
            }
            getExpiryTimeout() {
                if (this.expirationTime) return this.expiredRequestCount ? 1e3 * (1 << Math.min(this.expiredRequestCount - 1, 31)) : Math.min(this.expirationTime - (new Date).getTime(), Math.pow(2, 31) - 1);
            }
            setFeatureState(t, e) {
                if (!this.latestFeatureIndex || !this.latestFeatureIndex.rawTileData || 0 === Object.keys(t).length) return;
                const i = this.latestFeatureIndex.loadVTLayers();
                for(const s in this.buckets){
                    if (!e.style.hasLayer(s)) continue;
                    const a = this.buckets[s], o = a.layers[0].sourceLayer || "_geojsonTileLayer", r = i[o], n = t[o];
                    if (!r || !n || 0 === Object.keys(n).length) continue;
                    a.update(n, r, this.imageAtlas && this.imageAtlas.patternPositions || {});
                    const l = e && e.style && e.style.getLayer(s);
                    l && (this.queryPadding = Math.max(this.queryPadding, l.queryRadius(a)));
                }
            }
            holdingForFade() {
                return void 0 !== this.symbolFadeHoldUntil;
            }
            symbolFadeFinished() {
                return !this.symbolFadeHoldUntil || this.symbolFadeHoldUntil < t.h.now();
            }
            clearFadeHold() {
                this.symbolFadeHoldUntil = void 0;
            }
            setHoldDuration(e) {
                this.symbolFadeHoldUntil = t.h.now() + e;
            }
            setDependencies(t, e) {
                const i = {};
                for (const t of e)i[t] = !0;
                this.dependencies[t] = i;
            }
            hasDependency(t, e) {
                for (const i of t){
                    const t = this.dependencies[i];
                    if (t) {
                        for (const i of e)if (t[i]) return !0;
                    }
                }
                return !1;
            }
        }
        class H {
            constructor(t, e){
                this.max = t, this.onRemove = e, this.reset();
            }
            reset() {
                for(const t in this.data)for (const e of this.data[t])e.timeout && clearTimeout(e.timeout), this.onRemove(e.value);
                return this.data = {}, this.order = [], this;
            }
            add(t, e, i) {
                const s = t.wrapped().key;
                void 0 === this.data[s] && (this.data[s] = []);
                const a = {
                    value: e,
                    timeout: void 0
                };
                if (void 0 !== i && (a.timeout = setTimeout(()=>{
                    this.remove(t, a);
                }, i)), this.data[s].push(a), this.order.push(s), this.order.length > this.max) {
                    const t = this._getAndRemoveByKey(this.order[0]);
                    t && this.onRemove(t);
                }
                return this;
            }
            has(t) {
                return t.wrapped().key in this.data;
            }
            getAndRemove(t) {
                return this.has(t) ? this._getAndRemoveByKey(t.wrapped().key) : null;
            }
            _getAndRemoveByKey(t) {
                const e = this.data[t].shift();
                return e.timeout && clearTimeout(e.timeout), 0 === this.data[t].length && delete this.data[t], this.order.splice(this.order.indexOf(t), 1), e.value;
            }
            getByKey(t) {
                const e = this.data[t];
                return e ? e[0].value : null;
            }
            get(t) {
                return this.has(t) ? this.data[t.wrapped().key][0].value : null;
            }
            remove(t, e) {
                if (!this.has(t)) return this;
                const i = t.wrapped().key, s = void 0 === e ? 0 : this.data[i].indexOf(e), a = this.data[i][s];
                return this.data[i].splice(s, 1), a.timeout && clearTimeout(a.timeout), 0 === this.data[i].length && delete this.data[i], this.onRemove(a.value), this.order.splice(this.order.indexOf(i), 1), this;
            }
            setMaxSize(t) {
                for(this.max = t; this.order.length > this.max;){
                    const t = this._getAndRemoveByKey(this.order[0]);
                    t && this.onRemove(t);
                }
                return this;
            }
            filter(t) {
                const e = [];
                for(const i in this.data)for (const s of this.data[i])t(s.value) || e.push(s);
                for (const t of e)this.remove(t.value.tileID, t);
            }
        }
        class X {
            constructor(){
                this.state = {}, this.stateChanges = {}, this.deletedStates = {};
            }
            updateState(e, i, s) {
                const a = String(i);
                if (this.stateChanges[e] = this.stateChanges[e] || {}, this.stateChanges[e][a] = this.stateChanges[e][a] || {}, t.e(this.stateChanges[e][a], s), null === this.deletedStates[e]) {
                    this.deletedStates[e] = {};
                    for(const t in this.state[e])t !== a && (this.deletedStates[e][t] = null);
                } else if (this.deletedStates[e] && null === this.deletedStates[e][a]) {
                    this.deletedStates[e][a] = {};
                    for(const t in this.state[e][a])s[t] || (this.deletedStates[e][a][t] = null);
                } else for(const t in s)this.deletedStates[e] && this.deletedStates[e][a] && null === this.deletedStates[e][a][t] && delete this.deletedStates[e][a][t];
            }
            removeFeatureState(t, e, i) {
                if (null === this.deletedStates[t]) return;
                const s = String(e);
                if (this.deletedStates[t] = this.deletedStates[t] || {}, i && void 0 !== e) null !== this.deletedStates[t][s] && (this.deletedStates[t][s] = this.deletedStates[t][s] || {}, this.deletedStates[t][s][i] = null);
                else if (void 0 !== e) {
                    if (this.stateChanges[t] && this.stateChanges[t][s]) for(i in this.deletedStates[t][s] = {}, this.stateChanges[t][s])this.deletedStates[t][s][i] = null;
                    else this.deletedStates[t][s] = null;
                } else this.deletedStates[t] = null;
            }
            getState(e, i) {
                const s = String(i), a = t.e({}, (this.state[e] || {})[s], (this.stateChanges[e] || {})[s]);
                if (null === this.deletedStates[e]) return {};
                if (this.deletedStates[e]) {
                    const t = this.deletedStates[e][i];
                    if (null === t) return {};
                    for(const e in t)delete a[e];
                }
                return a;
            }
            initializeTileState(t, e) {
                t.setFeatureState(this.state, e);
            }
            coalesceChanges(e, i) {
                const s = {};
                for(const e in this.stateChanges){
                    this.state[e] = this.state[e] || {};
                    const i = {};
                    for(const s in this.stateChanges[e])this.state[e][s] || (this.state[e][s] = {}), t.e(this.state[e][s], this.stateChanges[e][s]), i[s] = this.state[e][s];
                    s[e] = i;
                }
                for(const e in this.deletedStates){
                    this.state[e] = this.state[e] || {};
                    const i = {};
                    if (null === this.deletedStates[e]) for(const t in this.state[e])i[t] = {}, this.state[e][t] = {};
                    else for(const t in this.deletedStates[e]){
                        if (null === this.deletedStates[e][t]) this.state[e][t] = {};
                        else for (const i of Object.keys(this.deletedStates[e][t]))delete this.state[e][t][i];
                        i[t] = this.state[e][t];
                    }
                    s[e] = s[e] || {}, t.e(s[e], i);
                }
                if (this.stateChanges = {}, this.deletedStates = {}, 0 !== Object.keys(s).length) for(const t in e)e[t].setFeatureState(s, i);
            }
        }
        class K extends t.E {
            constructor(t, e, i){
                super(), this.id = t, this.dispatcher = i, this.on("data", (t)=>{
                    "source" === t.dataType && "metadata" === t.sourceDataType && (this._sourceLoaded = !0), this._sourceLoaded && !this._paused && "source" === t.dataType && "content" === t.sourceDataType && (this.reload(), this.transform && this.update(this.transform, this.terrain), this._didEmitContent = !0);
                }), this.on("dataloading", ()=>{
                    this._sourceErrored = !1;
                }), this.on("error", ()=>{
                    this._sourceErrored = this._source.loaded();
                }), this._source = ((t, e, i, s)=>{
                    const a = new (j(e.type))(t, e, i, s);
                    if (a.id !== t) throw new Error(`Expected Source id to be ${t} instead of ${a.id}`);
                    return a;
                })(t, e, i, this), this._tiles = {}, this._cache = new H(0, this._unloadTile.bind(this)), this._timers = {}, this._cacheTimers = {}, this._maxTileCacheSize = null, this._maxTileCacheZoomLevels = null, this._loadedParentTiles = {}, this._coveredTiles = {}, this._state = new X, this._didEmitContent = !1, this._updated = !1;
            }
            onAdd(t) {
                this.map = t, this._maxTileCacheSize = t ? t._maxTileCacheSize : null, this._maxTileCacheZoomLevels = t ? t._maxTileCacheZoomLevels : null, this._source && this._source.onAdd && this._source.onAdd(t);
            }
            onRemove(t) {
                this.clearTiles(), this._source && this._source.onRemove && this._source.onRemove(t);
            }
            loaded() {
                if (this._sourceErrored) return !0;
                if (!this._sourceLoaded) return !1;
                if (!this._source.loaded()) return !1;
                if (!(void 0 === this.used && void 0 === this.usedForTerrain || this.used || this.usedForTerrain)) return !0;
                if (!this._updated) return !1;
                for(const t in this._tiles){
                    const e = this._tiles[t];
                    if ("loaded" !== e.state && "errored" !== e.state) return !1;
                }
                return !0;
            }
            getSource() {
                return this._source;
            }
            pause() {
                this._paused = !0;
            }
            resume() {
                if (!this._paused) return;
                const t = this._shouldReloadOnResume;
                this._paused = !1, this._shouldReloadOnResume = !1, t && this.reload(), this.transform && this.update(this.transform, this.terrain);
            }
            _loadTile(t, e) {
                return this._source.loadTile(t, e);
            }
            _unloadTile(t) {
                if (this._source.unloadTile) return this._source.unloadTile(t, ()=>{});
            }
            _abortTile(e) {
                this._source.abortTile && this._source.abortTile(e, ()=>{}), this._source.fire(new t.k("dataabort", {
                    tile: e,
                    coord: e.tileID,
                    dataType: "source"
                }));
            }
            serialize() {
                return this._source.serialize();
            }
            prepare(t) {
                this._source.prepare && this._source.prepare(), this._state.coalesceChanges(this._tiles, this.map ? this.map.painter : null);
                for(const e in this._tiles){
                    const i = this._tiles[e];
                    i.upload(t), i.prepare(this.map.style.imageManager);
                }
            }
            getIds() {
                return Object.values(this._tiles).map((t)=>t.tileID).sort(Q).map((t)=>t.key);
            }
            getRenderableIds(e) {
                const i = [];
                for(const t in this._tiles)this._isIdRenderable(t, e) && i.push(this._tiles[t]);
                return e ? i.sort((e, i)=>{
                    const s = e.tileID, a = i.tileID, o = new t.P(s.canonical.x, s.canonical.y)._rotate(this.transform.angle), r = new t.P(a.canonical.x, a.canonical.y)._rotate(this.transform.angle);
                    return s.overscaledZ - a.overscaledZ || r.y - o.y || r.x - o.x;
                }).map((t)=>t.tileID.key) : i.map((t)=>t.tileID).sort(Q).map((t)=>t.key);
            }
            hasRenderableParent(t) {
                const e = this.findLoadedParent(t, 0);
                return !!e && this._isIdRenderable(e.tileID.key);
            }
            _isIdRenderable(t, e) {
                return this._tiles[t] && this._tiles[t].hasData() && !this._coveredTiles[t] && (e || !this._tiles[t].holdingForFade());
            }
            reload() {
                if (this._paused) this._shouldReloadOnResume = !0;
                else {
                    this._cache.reset();
                    for(const t in this._tiles)"errored" !== this._tiles[t].state && this._reloadTile(t, "reloading");
                }
            }
            _reloadTile(t, e) {
                const i = this._tiles[t];
                i && ("loading" !== i.state && (i.state = e), this._loadTile(i, this._tileLoaded.bind(this, i, t, e)));
            }
            _tileLoaded(e, i, s, a) {
                if (a) return e.state = "errored", void (404 !== a.status ? this._source.fire(new t.j(a, {
                    tile: e
                })) : this.update(this.transform, this.terrain));
                e.timeAdded = t.h.now(), "expired" === s && (e.refreshedUponExpiration = !0), this._setTileReloadTimer(i, e), "raster-dem" === this.getSource().type && e.dem && this._backfillDEM(e), this._state.initializeTileState(e, this.map ? this.map.painter : null), e.aborted || this._source.fire(new t.k("data", {
                    dataType: "source",
                    tile: e,
                    coord: e.tileID
                }));
            }
            _backfillDEM(t) {
                const e = this.getRenderableIds();
                for(let s = 0; s < e.length; s++){
                    const a = e[s];
                    if (t.neighboringTiles && t.neighboringTiles[a]) {
                        const e = this.getTileByID(a);
                        i(t, e), i(e, t);
                    }
                }
                function i(t, e) {
                    t.needsHillshadePrepare = !0, t.needsTerrainPrepare = !0;
                    let i = e.tileID.canonical.x - t.tileID.canonical.x;
                    const s = e.tileID.canonical.y - t.tileID.canonical.y, a = Math.pow(2, t.tileID.canonical.z), o = e.tileID.key;
                    0 === i && 0 === s || Math.abs(s) > 1 || (Math.abs(i) > 1 && (1 === Math.abs(i + a) ? i += a : 1 === Math.abs(i - a) && (i -= a)), e.dem && t.dem && (t.dem.backfillBorder(e.dem, i, s), t.neighboringTiles && t.neighboringTiles[o] && (t.neighboringTiles[o].backfilled = !0)));
                }
            }
            getTile(t) {
                return this.getTileByID(t.key);
            }
            getTileByID(t) {
                return this._tiles[t];
            }
            _retainLoadedChildren(t, e, i, s) {
                for(const a in this._tiles){
                    let o = this._tiles[a];
                    if (s[a] || !o.hasData() || o.tileID.overscaledZ <= e || o.tileID.overscaledZ > i) continue;
                    let r = o.tileID;
                    for(; o && o.tileID.overscaledZ > e + 1;){
                        const t = o.tileID.scaledTo(o.tileID.overscaledZ - 1);
                        o = this._tiles[t.key], o && o.hasData() && (r = t);
                    }
                    let n = r;
                    for(; n.overscaledZ > e;)if (n = n.scaledTo(n.overscaledZ - 1), t[n.key]) {
                        s[r.key] = r;
                        break;
                    }
                }
            }
            findLoadedParent(t, e) {
                if (t.key in this._loadedParentTiles) {
                    const i = this._loadedParentTiles[t.key];
                    return i && i.tileID.overscaledZ >= e ? i : null;
                }
                for(let i = t.overscaledZ - 1; i >= e; i--){
                    const e = t.scaledTo(i), s = this._getLoadedTile(e);
                    if (s) return s;
                }
            }
            _getLoadedTile(t) {
                const e = this._tiles[t.key];
                return e && e.hasData() ? e : this._cache.getByKey(t.wrapped().key);
            }
            updateCacheSize(e) {
                const i = Math.ceil(e.width / this._source.tileSize) + 1, s = Math.ceil(e.height / this._source.tileSize) + 1, a = Math.floor(i * s * (null === this._maxTileCacheZoomLevels ? t.c.MAX_TILE_CACHE_ZOOM_LEVELS : this._maxTileCacheZoomLevels)), o = "number" == typeof this._maxTileCacheSize ? Math.min(this._maxTileCacheSize, a) : a;
                this._cache.setMaxSize(o);
            }
            handleWrapJump(t) {
                const e = Math.round((t - (void 0 === this._prevLng ? t : this._prevLng)) / 360);
                if (this._prevLng = t, e) {
                    const t = {};
                    for(const i in this._tiles){
                        const s = this._tiles[i];
                        s.tileID = s.tileID.unwrapTo(s.tileID.wrap + e), t[s.tileID.key] = s;
                    }
                    this._tiles = t;
                    for(const t in this._timers)clearTimeout(this._timers[t]), delete this._timers[t];
                    for(const t in this._tiles)this._setTileReloadTimer(t, this._tiles[t]);
                }
            }
            update(e, i) {
                if (this.transform = e, this.terrain = i, !this._sourceLoaded || this._paused) return;
                let s;
                this.updateCacheSize(e), this.handleWrapJump(this.transform.center.lng), this._coveredTiles = {}, this.used || this.usedForTerrain ? this._source.tileID ? s = e.getVisibleUnwrappedCoordinates(this._source.tileID).map((e)=>new t.O(e.canonical.z, e.wrap, e.canonical.z, e.canonical.x, e.canonical.y)) : (s = e.coveringTiles({
                    tileSize: this.usedForTerrain ? this.tileSize : this._source.tileSize,
                    minzoom: this._source.minzoom,
                    maxzoom: this._source.maxzoom,
                    roundZoom: !this.usedForTerrain && this._source.roundZoom,
                    reparseOverscaled: this._source.reparseOverscaled,
                    terrain: i
                }), this._source.hasTile && (s = s.filter((t)=>this._source.hasTile(t)))) : s = [];
                const a = e.coveringZoomLevel(this._source), o = Math.max(a - K.maxOverzooming, this._source.minzoom), r = Math.max(a + K.maxUnderzooming, this._source.minzoom);
                if (this.usedForTerrain) {
                    const t = {};
                    for (const e of s)if (e.canonical.z > this._source.minzoom) {
                        const i = e.scaledTo(e.canonical.z - 1);
                        t[i.key] = i;
                        const s = e.scaledTo(Math.max(this._source.minzoom, Math.min(e.canonical.z, 5)));
                        t[s.key] = s;
                    }
                    s = s.concat(Object.values(t));
                }
                const n = 0 === s.length && !this._updated && this._didEmitContent;
                this._updated = !0, n && this.fire(new t.k("data", {
                    sourceDataType: "idle",
                    dataType: "source",
                    sourceId: this.id
                }));
                const l = this._updateRetainedTiles(s, a);
                if (Y(this._source.type)) {
                    const e = {}, n = {}, h = Object.keys(l), c = t.h.now();
                    for (const t of h){
                        const i = l[t], s = this._tiles[t];
                        if (!s || 0 !== s.fadeEndTime && s.fadeEndTime <= c) continue;
                        const a = this.findLoadedParent(i, o);
                        a && (this._addTile(a.tileID), e[a.tileID.key] = a.tileID), n[t] = i;
                    }
                    this._retainLoadedChildren(n, a, r, l);
                    for(const t in e)l[t] || (this._coveredTiles[t] = !0, l[t] = e[t]);
                    if (i) {
                        const t = {}, e = {};
                        for (const i of s)this._tiles[i.key].hasData() ? t[i.key] = i : e[i.key] = i;
                        for(const i in e){
                            const s = e[i].children(this._source.maxzoom);
                            this._tiles[s[0].key] && this._tiles[s[1].key] && this._tiles[s[2].key] && this._tiles[s[3].key] && (t[s[0].key] = l[s[0].key] = s[0], t[s[1].key] = l[s[1].key] = s[1], t[s[2].key] = l[s[2].key] = s[2], t[s[3].key] = l[s[3].key] = s[3], delete e[i]);
                        }
                        for(const i in e){
                            const s = this.findLoadedParent(e[i], this._source.minzoom);
                            if (s) {
                                t[s.tileID.key] = l[s.tileID.key] = s.tileID;
                                for(const e in t)t[e].isChildOf(s.tileID) && delete t[e];
                            }
                        }
                        for(const e in this._tiles)t[e] || (this._coveredTiles[e] = !0);
                    }
                }
                for(const t in l)this._tiles[t].clearFadeHold();
                const h = t.ab(this._tiles, l);
                for (const t of h){
                    const e = this._tiles[t];
                    e.hasSymbolBuckets && !e.holdingForFade() ? e.setHoldDuration(this.map._fadeDuration) : e.hasSymbolBuckets && !e.symbolFadeFinished() || this._removeTile(t);
                }
                this._updateLoadedParentTileCache();
            }
            releaseSymbolFadeTiles() {
                for(const t in this._tiles)this._tiles[t].holdingForFade() && this._removeTile(t);
            }
            _updateRetainedTiles(t, e) {
                const i = {}, s = {}, a = Math.max(e - K.maxOverzooming, this._source.minzoom), o = Math.max(e + K.maxUnderzooming, this._source.minzoom), r = {};
                for (const s of t){
                    const t = this._addTile(s);
                    i[s.key] = s, t.hasData() || e < this._source.maxzoom && (r[s.key] = s);
                }
                this._retainLoadedChildren(r, e, o, i);
                for (const o of t){
                    let t = this._tiles[o.key];
                    if (t.hasData()) continue;
                    if (e + 1 > this._source.maxzoom) {
                        const t = o.children(this._source.maxzoom)[0], e = this.getTile(t);
                        if (e && e.hasData()) {
                            i[t.key] = t;
                            continue;
                        }
                    } else {
                        const t = o.children(this._source.maxzoom);
                        if (i[t[0].key] && i[t[1].key] && i[t[2].key] && i[t[3].key]) continue;
                    }
                    let r = t.wasRequested();
                    for(let e = o.overscaledZ - 1; e >= a; --e){
                        const a = o.scaledTo(e);
                        if (s[a.key]) break;
                        if (s[a.key] = !0, t = this.getTile(a), !t && r && (t = this._addTile(a)), t) {
                            const e = t.hasData();
                            if ((r || e) && (i[a.key] = a), r = t.wasRequested(), e) break;
                        }
                    }
                }
                return i;
            }
            _updateLoadedParentTileCache() {
                this._loadedParentTiles = {};
                for(const t in this._tiles){
                    const e = [];
                    let i, s = this._tiles[t].tileID;
                    for(; s.overscaledZ > 0;){
                        if (s.key in this._loadedParentTiles) {
                            i = this._loadedParentTiles[s.key];
                            break;
                        }
                        e.push(s.key);
                        const t = s.scaledTo(s.overscaledZ - 1);
                        if (i = this._getLoadedTile(t), i) break;
                        s = t;
                    }
                    for (const t of e)this._loadedParentTiles[t] = i;
                }
            }
            _addTile(e) {
                let i = this._tiles[e.key];
                if (i) return i;
                i = this._cache.getAndRemove(e), i && (this._setTileReloadTimer(e.key, i), i.tileID = e, this._state.initializeTileState(i, this.map ? this.map.painter : null), this._cacheTimers[e.key] && (clearTimeout(this._cacheTimers[e.key]), delete this._cacheTimers[e.key], this._setTileReloadTimer(e.key, i)));
                const s = i;
                return i || (i = new W(e, this._source.tileSize * e.overscaleFactor()), this._loadTile(i, this._tileLoaded.bind(this, i, e.key, i.state))), i.uses++, this._tiles[e.key] = i, s || this._source.fire(new t.k("dataloading", {
                    tile: i,
                    coord: i.tileID,
                    dataType: "source"
                })), i;
            }
            _setTileReloadTimer(t, e) {
                t in this._timers && (clearTimeout(this._timers[t]), delete this._timers[t]);
                const i = e.getExpiryTimeout();
                i && (this._timers[t] = setTimeout(()=>{
                    this._reloadTile(t, "expired"), delete this._timers[t];
                }, i));
            }
            _removeTile(t) {
                const e = this._tiles[t];
                e && (e.uses--, delete this._tiles[t], this._timers[t] && (clearTimeout(this._timers[t]), delete this._timers[t]), e.uses > 0 || (e.hasData() && "reloading" !== e.state ? this._cache.add(e.tileID, e, e.getExpiryTimeout()) : (e.aborted = !0, this._abortTile(e), this._unloadTile(e))));
            }
            clearTiles() {
                this._shouldReloadOnResume = !1, this._paused = !1;
                for(const t in this._tiles)this._removeTile(t);
                this._cache.reset();
            }
            tilesIn(e, i, s) {
                const a = [], o = this.transform;
                if (!o) return a;
                const r = s ? o.getCameraQueryGeometry(e) : e, n = e.map((t)=>o.pointCoordinate(t, this.terrain)), l = r.map((t)=>o.pointCoordinate(t, this.terrain)), h = this.getIds();
                let c = 1 / 0, u = 1 / 0, d = -1 / 0, _ = -1 / 0;
                for (const t of l)c = Math.min(c, t.x), u = Math.min(u, t.y), d = Math.max(d, t.x), _ = Math.max(_, t.y);
                for(let e = 0; e < h.length; e++){
                    const s = this._tiles[h[e]];
                    if (s.holdingForFade()) continue;
                    const r = s.tileID, p = Math.pow(2, o.zoom - s.tileID.overscaledZ), m = i * s.queryPadding * t.N / s.tileSize / p, f = [
                        r.getTilePoint(new t.U(c, u)),
                        r.getTilePoint(new t.U(d, _))
                    ];
                    if (f[0].x - m < t.N && f[0].y - m < t.N && f[1].x + m >= 0 && f[1].y + m >= 0) {
                        const t = n.map((t)=>r.getTilePoint(t)), e = l.map((t)=>r.getTilePoint(t));
                        a.push({
                            tile: s,
                            tileID: r,
                            queryGeometry: t,
                            cameraQueryGeometry: e,
                            scale: p
                        });
                    }
                }
                return a;
            }
            getVisibleCoordinates(t) {
                const e = this.getRenderableIds(t).map((t)=>this._tiles[t].tileID);
                for (const t of e)t.posMatrix = this.transform.calculatePosMatrix(t.toUnwrapped());
                return e;
            }
            hasTransition() {
                if (this._source.hasTransition()) return !0;
                if (Y(this._source.type)) {
                    const e = t.h.now();
                    for(const t in this._tiles)if (this._tiles[t].fadeEndTime >= e) return !0;
                }
                return !1;
            }
            setFeatureState(t, e, i) {
                this._state.updateState(t = t || "_geojsonTileLayer", e, i);
            }
            removeFeatureState(t, e, i) {
                this._state.removeFeatureState(t = t || "_geojsonTileLayer", e, i);
            }
            getFeatureState(t, e) {
                return this._state.getState(t = t || "_geojsonTileLayer", e);
            }
            setDependencies(t, e, i) {
                const s = this._tiles[t];
                s && s.setDependencies(e, i);
            }
            reloadTilesForDependencies(t, e) {
                for(const i in this._tiles)this._tiles[i].hasDependency(t, e) && this._reloadTile(i, "reloading");
                this._cache.filter((i)=>!i.hasDependency(t, e));
            }
        }
        function Q(t, e) {
            const i = Math.abs(2 * t.wrap) - +(t.wrap < 0), s = Math.abs(2 * e.wrap) - +(e.wrap < 0);
            return t.overscaledZ - e.overscaledZ || s - i || e.canonical.y - t.canonical.y || e.canonical.x - t.canonical.x;
        }
        function Y(t) {
            return "raster" === t || "image" === t || "video" === t;
        }
        K.maxOverzooming = 10, K.maxUnderzooming = 3;
        const J = "mapboxgl_preloaded_worker_pool";
        class tt {
            constructor(){
                this.active = {};
            }
            acquire(e) {
                if (!this.workers) for(this.workers = []; this.workers.length < tt.workerCount;)this.workers.push(new Worker(t.c.WORKER_URL));
                return this.active[e] = !0, this.workers.slice();
            }
            release(t) {
                delete this.active[t], 0 === this.numActive() && (this.workers.forEach((t)=>{
                    t.terminate();
                }), this.workers = null);
            }
            isPreloaded() {
                return !!this.active[J];
            }
            numActive() {
                return Object.keys(this.active).length;
            }
        }
        const et = Math.floor(t.h.hardwareConcurrency / 2);
        let it;
        function st() {
            return it || (it = new tt), it;
        }
        tt.workerCount = t.ac(globalThis) ? Math.max(Math.min(et, 3), 1) : 1;
        class at {
            constructor(t, e){
                this.reset(t, e);
            }
            reset(t, e) {
                this.points = t || [], this._distances = [
                    0
                ];
                for(let t = 1; t < this.points.length; t++)this._distances[t] = this._distances[t - 1] + this.points[t].dist(this.points[t - 1]);
                this.length = this._distances[this._distances.length - 1], this.padding = Math.min(e || 0, .5 * this.length), this.paddedLength = this.length - 2 * this.padding;
            }
            lerp(e) {
                if (1 === this.points.length) return this.points[0];
                e = t.ad(e, 0, 1);
                let i = 1, s = this._distances[i];
                const a = e * this.paddedLength + this.padding;
                for(; s < a && i < this._distances.length;)s = this._distances[++i];
                const o = i - 1, r = this._distances[o], n = s - r, l = n > 0 ? (a - r) / n : 0;
                return this.points[o].mult(1 - l).add(this.points[i].mult(l));
            }
        }
        function ot(t, e) {
            let i = !0;
            return "always" === t || "never" !== t && "never" !== e || (i = !1), i;
        }
        class rt {
            constructor(t, e, i){
                const s = this.boxCells = [], a = this.circleCells = [];
                this.xCellCount = Math.ceil(t / i), this.yCellCount = Math.ceil(e / i);
                for(let t = 0; t < this.xCellCount * this.yCellCount; t++)s.push([]), a.push([]);
                this.circleKeys = [], this.boxKeys = [], this.bboxes = [], this.circles = [], this.width = t, this.height = e, this.xScale = this.xCellCount / t, this.yScale = this.yCellCount / e, this.boxUid = 0, this.circleUid = 0;
            }
            keysLength() {
                return this.boxKeys.length + this.circleKeys.length;
            }
            insert(t, e, i, s, a) {
                this._forEachCell(e, i, s, a, this._insertBoxCell, this.boxUid++), this.boxKeys.push(t), this.bboxes.push(e), this.bboxes.push(i), this.bboxes.push(s), this.bboxes.push(a);
            }
            insertCircle(t, e, i, s) {
                this._forEachCell(e - s, i - s, e + s, i + s, this._insertCircleCell, this.circleUid++), this.circleKeys.push(t), this.circles.push(e), this.circles.push(i), this.circles.push(s);
            }
            _insertBoxCell(t, e, i, s, a, o) {
                this.boxCells[a].push(o);
            }
            _insertCircleCell(t, e, i, s, a, o) {
                this.circleCells[a].push(o);
            }
            _query(t, e, i, s, a, o, r) {
                if (i < 0 || t > this.width || s < 0 || e > this.height) return [];
                const n = [];
                if (t <= 0 && e <= 0 && this.width <= i && this.height <= s) {
                    if (a) return [
                        {
                            key: null,
                            x1: t,
                            y1: e,
                            x2: i,
                            y2: s
                        }
                    ];
                    for(let t = 0; t < this.boxKeys.length; t++)n.push({
                        key: this.boxKeys[t],
                        x1: this.bboxes[4 * t],
                        y1: this.bboxes[4 * t + 1],
                        x2: this.bboxes[4 * t + 2],
                        y2: this.bboxes[4 * t + 3]
                    });
                    for(let t = 0; t < this.circleKeys.length; t++){
                        const e = this.circles[3 * t], i = this.circles[3 * t + 1], s = this.circles[3 * t + 2];
                        n.push({
                            key: this.circleKeys[t],
                            x1: e - s,
                            y1: i - s,
                            x2: e + s,
                            y2: i + s
                        });
                    }
                } else this._forEachCell(t, e, i, s, this._queryCell, n, {
                    hitTest: a,
                    overlapMode: o,
                    seenUids: {
                        box: {},
                        circle: {}
                    }
                }, r);
                return n;
            }
            query(t, e, i, s) {
                return this._query(t, e, i, s, !1, null);
            }
            hitTest(t, e, i, s, a, o) {
                return this._query(t, e, i, s, !0, a, o).length > 0;
            }
            hitTestCircle(t, e, i, s, a) {
                const o = t - i, r = t + i, n = e - i, l = e + i;
                if (r < 0 || o > this.width || l < 0 || n > this.height) return !1;
                const h = [];
                return this._forEachCell(o, n, r, l, this._queryCellCircle, h, {
                    hitTest: !0,
                    overlapMode: s,
                    circle: {
                        x: t,
                        y: e,
                        radius: i
                    },
                    seenUids: {
                        box: {},
                        circle: {}
                    }
                }, a), h.length > 0;
            }
            _queryCell(t, e, i, s, a, o, r, n) {
                const { seenUids: l, hitTest: h, overlapMode: c } = r, u = this.boxCells[a];
                if (null !== u) {
                    const a = this.bboxes;
                    for (const r of u)if (!l.box[r]) {
                        l.box[r] = !0;
                        const u = 4 * r, d = this.boxKeys[r];
                        if (t <= a[u + 2] && e <= a[u + 3] && i >= a[u + 0] && s >= a[u + 1] && (!n || n(d)) && (!h || !ot(c, d.overlapMode)) && (o.push({
                            key: d,
                            x1: a[u],
                            y1: a[u + 1],
                            x2: a[u + 2],
                            y2: a[u + 3]
                        }), h)) return !0;
                    }
                }
                const d = this.circleCells[a];
                if (null !== d) {
                    const a = this.circles;
                    for (const r of d)if (!l.circle[r]) {
                        l.circle[r] = !0;
                        const u = 3 * r, d = this.circleKeys[r];
                        if (this._circleAndRectCollide(a[u], a[u + 1], a[u + 2], t, e, i, s) && (!n || n(d)) && (!h || !ot(c, d.overlapMode))) {
                            const t = a[u], e = a[u + 1], i = a[u + 2];
                            if (o.push({
                                key: d,
                                x1: t - i,
                                y1: e - i,
                                x2: t + i,
                                y2: e + i
                            }), h) return !0;
                        }
                    }
                }
                return !1;
            }
            _queryCellCircle(t, e, i, s, a, o, r, n) {
                const { circle: l, seenUids: h, overlapMode: c } = r, u = this.boxCells[a];
                if (null !== u) {
                    const t = this.bboxes;
                    for (const e of u)if (!h.box[e]) {
                        h.box[e] = !0;
                        const i = 4 * e, s = this.boxKeys[e];
                        if (this._circleAndRectCollide(l.x, l.y, l.radius, t[i + 0], t[i + 1], t[i + 2], t[i + 3]) && (!n || n(s)) && !ot(c, s.overlapMode)) return o.push(!0), !0;
                    }
                }
                const d = this.circleCells[a];
                if (null !== d) {
                    const t = this.circles;
                    for (const e of d)if (!h.circle[e]) {
                        h.circle[e] = !0;
                        const i = 3 * e, s = this.circleKeys[e];
                        if (this._circlesCollide(t[i], t[i + 1], t[i + 2], l.x, l.y, l.radius) && (!n || n(s)) && !ot(c, s.overlapMode)) return o.push(!0), !0;
                    }
                }
            }
            _forEachCell(t, e, i, s, a, o, r, n) {
                const l = this._convertToXCellCoord(t), h = this._convertToYCellCoord(e), c = this._convertToXCellCoord(i), u = this._convertToYCellCoord(s);
                for(let d = l; d <= c; d++)for(let l = h; l <= u; l++)if (a.call(this, t, e, i, s, this.xCellCount * l + d, o, r, n)) return;
            }
            _convertToXCellCoord(t) {
                return Math.max(0, Math.min(this.xCellCount - 1, Math.floor(t * this.xScale)));
            }
            _convertToYCellCoord(t) {
                return Math.max(0, Math.min(this.yCellCount - 1, Math.floor(t * this.yScale)));
            }
            _circlesCollide(t, e, i, s, a, o) {
                const r = s - t, n = a - e, l = i + o;
                return l * l > r * r + n * n;
            }
            _circleAndRectCollide(t, e, i, s, a, o, r) {
                const n = (o - s) / 2, l = Math.abs(t - (s + n));
                if (l > n + i) return !1;
                const h = (r - a) / 2, c = Math.abs(e - (a + h));
                if (c > h + i) return !1;
                if (l <= n || c <= h) return !0;
                const u = l - n, d = c - h;
                return u * u + d * d <= i * i;
            }
        }
        function nt(e, i, s, a, o) {
            const r = t.Z();
            return i ? (t.a0(r, r, [
                1 / o,
                1 / o,
                1
            ]), s || t.ae(r, r, a.angle)) : t.a1(r, a.labelPlaneMatrix, e), r;
        }
        function lt(e, i, s, a, o) {
            if (i) {
                const i = t.af(e);
                return t.a0(i, i, [
                    o,
                    o,
                    1
                ]), s || t.ae(i, i, -a.angle), i;
            }
            return a.glCoordMatrix;
        }
        function ht(e, i, s) {
            let a;
            s ? (a = [
                e.x,
                e.y,
                s(e.x, e.y),
                1
            ], t.ag(a, a, i)) : (a = [
                e.x,
                e.y,
                0,
                1
            ], Tt(a, a, i));
            const o = a[3];
            return {
                point: new t.P(a[0] / o, a[1] / o),
                signedDistanceFromCamera: o
            };
        }
        function ct(t, e) {
            return .5 + t / e * .5;
        }
        function ut(t, e) {
            const i = t[0] / t[3], s = t[1] / t[3];
            return i >= -e[0] && i <= e[0] && s >= -e[1] && s <= e[1];
        }
        function dt(e, i, s, a, o, r, n, l, h, c) {
            const u = a ? e.textSizeData : e.iconSizeData, d = t.ah(u, s.transform.zoom), _ = [
                256 / s.width * 2 + 1,
                256 / s.height * 2 + 1
            ], p = a ? e.text.dynamicLayoutVertexArray : e.icon.dynamicLayoutVertexArray;
            p.clear();
            const m = e.lineVertexArray, f = a ? e.text.placedSymbolArray : e.icon.placedSymbolArray, g = s.transform.width / s.transform.height;
            let v = !1;
            for(let a = 0; a < f.length; a++){
                const x = f.get(a);
                if (x.hidden || x.writingMode === t.ai.vertical && !v) {
                    wt(x.numGlyphs, p);
                    continue;
                }
                let y;
                if (v = !1, c ? (y = [
                    x.anchorX,
                    x.anchorY,
                    c(x.anchorX, x.anchorY),
                    1
                ], t.ag(y, y, i)) : (y = [
                    x.anchorX,
                    x.anchorY,
                    0,
                    1
                ], Tt(y, y, i)), !ut(y, _)) {
                    wt(x.numGlyphs, p);
                    continue;
                }
                const b = ct(s.transform.cameraToCenterDistance, y[3]), w = t.aj(u, d, x), T = n ? w / b : w * b, I = new t.P(x.anchorX, x.anchorY), E = ht(I, o, c).point, S = {
                    projections: {},
                    offsets: {}
                }, C = mt(x, T, !1, l, i, o, r, e.glyphOffsetArray, m, p, E, I, S, g, h, c);
                v = C.useVertical, (C.notEnoughRoom || v || C.needsFlipping && mt(x, T, !0, l, i, o, r, e.glyphOffsetArray, m, p, E, I, S, g, h, c).notEnoughRoom) && wt(x.numGlyphs, p);
            }
            a ? e.text.dynamicLayoutVertexBuffer.updateData(p) : e.icon.dynamicLayoutVertexBuffer.updateData(p);
        }
        function _t(t, e, i, s, a, o, r, n, l, h, c, u, d) {
            const _ = n.glyphStartIndex + n.numGlyphs, p = n.lineStartIndex, m = n.lineStartIndex + n.lineLength, f = e.getoffsetX(n.glyphStartIndex), g = e.getoffsetX(_ - 1), v = yt(t * f, i, s, a, o, r, n.segment, p, m, l, h, c, u, d);
            if (!v) return null;
            const x = yt(t * g, i, s, a, o, r, n.segment, p, m, l, h, c, u, d);
            return x ? {
                first: v,
                last: x
            } : null;
        }
        function pt(e, i, s, a) {
            return e === t.ai.horizontal && Math.abs(s.y - i.y) > Math.abs(s.x - i.x) * a ? {
                useVertical: !0
            } : (e === t.ai.vertical ? i.y < s.y : i.x > s.x) ? {
                needsFlipping: !0
            } : null;
        }
        function mt(e, i, s, a, o, r, n, l, h, c, u, d, _, p, m, f) {
            const g = i / 24, v = e.lineOffsetX * g, x = e.lineOffsetY * g;
            let y;
            if (e.numGlyphs > 1) {
                const t = e.glyphStartIndex + e.numGlyphs, i = e.lineStartIndex, o = e.lineStartIndex + e.lineLength, c = _t(g, l, v, x, s, u, d, e, h, r, _, m, f);
                if (!c) return {
                    notEnoughRoom: !0
                };
                const b = ht(c.first.point, n, f).point, w = ht(c.last.point, n, f).point;
                if (a && !s) {
                    const t = pt(e.writingMode, b, w, p);
                    if (t) return t;
                }
                y = [
                    c.first
                ];
                for(let a = e.glyphStartIndex + 1; a < t - 1; a++)y.push(yt(g * l.getoffsetX(a), v, x, s, u, d, e.segment, i, o, h, r, _, m, f));
                y.push(c.last);
            } else {
                if (a && !s) {
                    const i = ht(d, o, f).point, s = e.lineStartIndex + e.segment + 1, a = new t.P(h.getx(s), h.gety(s)), r = ht(a, o, f), n = r.signedDistanceFromCamera > 0 ? r.point : ft(d, a, i, 1, o, f), l = pt(e.writingMode, i, n, p);
                    if (l) return l;
                }
                const i = yt(g * l.getoffsetX(e.glyphStartIndex), v, x, s, u, d, e.segment, e.lineStartIndex, e.lineStartIndex + e.lineLength, h, r, _, m, f);
                if (!i) return {
                    notEnoughRoom: !0
                };
                y = [
                    i
                ];
            }
            for (const e of y)t.ak(c, e.point, e.angle);
            return {};
        }
        function ft(t, e, i, s, a, o) {
            const r = ht(t.add(t.sub(e)._unit()), a, o).point, n = i.sub(r);
            return i.add(n._mult(s / n.mag()));
        }
        function gt(e, i) {
            const { projectionCache: s, lineVertexArray: a, labelPlaneMatrix: o, tileAnchorPoint: r, distanceFromAnchor: n, getElevation: l, previousVertex: h, direction: c, absOffsetX: u } = i;
            if (s.projections[e]) return s.projections[e];
            const d = new t.P(a.getx(e), a.gety(e)), _ = ht(d, o, l);
            if (_.signedDistanceFromCamera > 0) return s.projections[e] = _.point, _.point;
            const p = e - c;
            return ft(0 === n ? r : new t.P(a.getx(p), a.gety(p)), d, h, u - n + 1, o, l);
        }
        function vt(t, e, i) {
            return t._unit()._perp()._mult(e * i);
        }
        function xt(e, i, s, a, o, r, n, l) {
            const { projectionCache: h, direction: c } = l;
            if (h.offsets[e]) return h.offsets[e];
            const u = s.add(i);
            if (e + c < a || e + c >= o) return h.offsets[e] = u, u;
            const d = gt(e + c, l), _ = vt(d.sub(s), n, c), p = s.add(_), m = d.add(_);
            return h.offsets[e] = t.al(r, u, p, m) || u, h.offsets[e];
        }
        function yt(t, e, i, s, a, o, r, n, l, h, c, u, d, _) {
            const p = s ? t - e : t + e;
            let m = p > 0 ? 1 : -1, f = 0;
            s && (m *= -1, f = Math.PI), m < 0 && (f += Math.PI);
            let g, v, x = m > 0 ? n + r : n + r + 1, y = a, b = a, w = 0, T = 0;
            const I = Math.abs(p), E = [];
            let S;
            for(; w + T <= I;){
                if (x += m, x < n || x >= l) return null;
                w += T, b = y, v = g;
                const t = {
                    projectionCache: u,
                    lineVertexArray: h,
                    labelPlaneMatrix: c,
                    tileAnchorPoint: o,
                    distanceFromAnchor: w,
                    getElevation: _,
                    previousVertex: b,
                    direction: m,
                    absOffsetX: I
                };
                if (y = gt(x, t), 0 === i) E.push(b), S = y.sub(b);
                else {
                    let e;
                    const s = y.sub(b);
                    e = 0 === s.mag() ? vt(gt(x + m, t).sub(y), i, m) : vt(s, i, m), v || (v = b.add(e)), g = xt(x, e, y, n, l, v, i, t), E.push(v), S = g.sub(v);
                }
                T = S.mag();
            }
            const C = S._mult((I - w) / T)._add(v || b), P = f + Math.atan2(y.y - b.y, y.x - b.x);
            return E.push(C), {
                point: C,
                angle: d ? P : 0,
                path: E
            };
        }
        const bt = new Float32Array([
            -1 / 0,
            -1 / 0,
            0,
            -1 / 0,
            -1 / 0,
            0,
            -1 / 0,
            -1 / 0,
            0,
            -1 / 0,
            -1 / 0,
            0
        ]);
        function wt(t, e) {
            for(let i = 0; i < t; i++){
                const t = e.length;
                e.resize(t + 4), e.float32.set(bt, 3 * t);
            }
        }
        function Tt(t, e, i) {
            const s = e[0], a = e[1];
            return t[0] = i[0] * s + i[4] * a + i[12], t[1] = i[1] * s + i[5] * a + i[13], t[3] = i[3] * s + i[7] * a + i[15], t;
        }
        const It = 100;
        class Et {
            constructor(t, e = new rt(t.width + 200, t.height + 200, 25), i = new rt(t.width + 200, t.height + 200, 25)){
                this.transform = t, this.grid = e, this.ignoredGrid = i, this.pitchfactor = Math.cos(t._pitch) * t.cameraToCenterDistance, this.screenRightBoundary = t.width + It, this.screenBottomBoundary = t.height + It, this.gridRightBoundary = t.width + 200, this.gridBottomBoundary = t.height + 200, this.perspectiveRatioCutoff = .6;
            }
            placeCollisionBox(t, e, i, s, a, o) {
                const r = this.projectAndGetPerspectiveRatio(s, t.anchorPointX, t.anchorPointY, o), n = i * r.perspectiveRatio, l = t.x1 * n + r.point.x, h = t.y1 * n + r.point.y, c = t.x2 * n + r.point.x, u = t.y2 * n + r.point.y;
                return !this.isInsideGrid(l, h, c, u) || "always" !== e && this.grid.hitTest(l, h, c, u, e, a) || r.perspectiveRatio < this.perspectiveRatioCutoff ? {
                    box: [],
                    offscreen: !1
                } : {
                    box: [
                        l,
                        h,
                        c,
                        u
                    ],
                    offscreen: this.isOffscreen(l, h, c, u)
                };
            }
            placeCollisionCircles(e, i, s, a, o, r, n, l, h, c, u, d, _, p) {
                const m = [], f = new t.P(i.anchorX, i.anchorY), g = ht(f, r, p), v = ct(this.transform.cameraToCenterDistance, g.signedDistanceFromCamera), x = (c ? o / v : o * v) / t.ap, y = ht(f, n, p).point, b = _t(x, a, i.lineOffsetX * x, i.lineOffsetY * x, !1, y, f, i, s, n, {
                    projections: {},
                    offsets: {}
                }, !1, p);
                let w = !1, T = !1, I = !0;
                if (b) {
                    const i = .5 * d * v + _, s = new t.P(-100, -100), a = new t.P(this.screenRightBoundary, this.screenBottomBoundary), o = new at, r = b.first, n = b.last;
                    let c = [];
                    for(let t = r.path.length - 1; t >= 1; t--)c.push(r.path[t]);
                    for(let t = 1; t < n.path.length; t++)c.push(n.path[t]);
                    const f = 2.5 * i;
                    if (l) {
                        const t = c.map((t)=>ht(t, l, p));
                        c = t.some((t)=>t.signedDistanceFromCamera <= 0) ? [] : t.map((t)=>t.point);
                    }
                    let g = [];
                    if (c.length > 0) {
                        const e = c[0].clone(), i = c[0].clone();
                        for(let t = 1; t < c.length; t++)e.x = Math.min(e.x, c[t].x), e.y = Math.min(e.y, c[t].y), i.x = Math.max(i.x, c[t].x), i.y = Math.max(i.y, c[t].y);
                        g = e.x >= s.x && i.x <= a.x && e.y >= s.y && i.y <= a.y ? [
                            c
                        ] : i.x < s.x || e.x > a.x || i.y < s.y || e.y > a.y ? [] : t.am([
                            c
                        ], s.x, s.y, a.x, a.y);
                    }
                    for (const t of g){
                        o.reset(t, .25 * i);
                        let s = 0;
                        s = o.length <= .5 * i ? 1 : Math.ceil(o.paddedLength / f) + 1;
                        for(let t = 0; t < s; t++){
                            const a = t / Math.max(s - 1, 1), r = o.lerp(a), n = r.x + It, l = r.y + It;
                            m.push(n, l, i, 0);
                            const c = n - i, d = l - i, _ = n + i, p = l + i;
                            if (I = I && this.isOffscreen(c, d, _, p), T = T || this.isInsideGrid(c, d, _, p), "always" !== e && this.grid.hitTestCircle(n, l, i, e, u) && (w = !0, !h)) return {
                                circles: [],
                                offscreen: !1,
                                collisionDetected: w
                            };
                        }
                    }
                }
                return {
                    circles: !h && w || !T || v < this.perspectiveRatioCutoff ? [] : m,
                    offscreen: I,
                    collisionDetected: w
                };
            }
            queryRenderedSymbols(e) {
                if (0 === e.length || 0 === this.grid.keysLength() && 0 === this.ignoredGrid.keysLength()) return {};
                const i = [];
                let s = 1 / 0, a = 1 / 0, o = -1 / 0, r = -1 / 0;
                for (const n of e){
                    const e = new t.P(n.x + It, n.y + It);
                    s = Math.min(s, e.x), a = Math.min(a, e.y), o = Math.max(o, e.x), r = Math.max(r, e.y), i.push(e);
                }
                const n = this.grid.query(s, a, o, r).concat(this.ignoredGrid.query(s, a, o, r)), l = {}, h = {};
                for (const e of n){
                    const s = e.key;
                    if (void 0 === l[s.bucketInstanceId] && (l[s.bucketInstanceId] = {}), l[s.bucketInstanceId][s.featureIndex]) continue;
                    const a = [
                        new t.P(e.x1, e.y1),
                        new t.P(e.x2, e.y1),
                        new t.P(e.x2, e.y2),
                        new t.P(e.x1, e.y2)
                    ];
                    t.an(i, a) && (l[s.bucketInstanceId][s.featureIndex] = !0, void 0 === h[s.bucketInstanceId] && (h[s.bucketInstanceId] = []), h[s.bucketInstanceId].push(s.featureIndex));
                }
                return h;
            }
            insertCollisionBox(t, e, i, s, a, o) {
                (i ? this.ignoredGrid : this.grid).insert({
                    bucketInstanceId: s,
                    featureIndex: a,
                    collisionGroupID: o,
                    overlapMode: e
                }, t[0], t[1], t[2], t[3]);
            }
            insertCollisionCircles(t, e, i, s, a, o) {
                const r = i ? this.ignoredGrid : this.grid, n = {
                    bucketInstanceId: s,
                    featureIndex: a,
                    collisionGroupID: o,
                    overlapMode: e
                };
                for(let e = 0; e < t.length; e += 4)r.insertCircle(n, t[e], t[e + 1], t[e + 2]);
            }
            projectAndGetPerspectiveRatio(e, i, s, a) {
                let o;
                return a ? (o = [
                    i,
                    s,
                    a(i, s),
                    1
                ], t.ag(o, o, e)) : (o = [
                    i,
                    s,
                    0,
                    1
                ], Tt(o, o, e)), {
                    point: new t.P((o[0] / o[3] + 1) / 2 * this.transform.width + It, (-o[1] / o[3] + 1) / 2 * this.transform.height + It),
                    perspectiveRatio: .5 + this.transform.cameraToCenterDistance / o[3] * .5
                };
            }
            isOffscreen(t, e, i, s) {
                return i < It || t >= this.screenRightBoundary || s < It || e > this.screenBottomBoundary;
            }
            isInsideGrid(t, e, i, s) {
                return i >= 0 && t < this.gridRightBoundary && s >= 0 && e < this.gridBottomBoundary;
            }
            getViewportMatrix() {
                const e = t.ao([]);
                return t.$(e, e, [
                    -100,
                    -100,
                    0
                ]), e;
            }
        }
        function St(e, i, s) {
            return i * (t.N / (e.tileSize * Math.pow(2, s - e.tileID.overscaledZ)));
        }
        class Ct {
            constructor(t, e, i, s){
                this.opacity = t ? Math.max(0, Math.min(1, t.opacity + (t.placed ? e : -e))) : s && i ? 1 : 0, this.placed = i;
            }
            isHidden() {
                return 0 === this.opacity && !this.placed;
            }
        }
        class Pt {
            constructor(t, e, i, s, a){
                this.text = new Ct(t ? t.text : null, e, i, a), this.icon = new Ct(t ? t.icon : null, e, s, a);
            }
            isHidden() {
                return this.text.isHidden() && this.icon.isHidden();
            }
        }
        class Dt {
            constructor(t, e, i){
                this.text = t, this.icon = e, this.skipFade = i;
            }
        }
        class Mt {
            constructor(){
                this.invProjMatrix = t.Z(), this.viewportMatrix = t.Z(), this.circles = [];
            }
        }
        class zt {
            constructor(t, e, i, s, a){
                this.bucketInstanceId = t, this.featureIndex = e, this.sourceLayerIndex = i, this.bucketIndex = s, this.tileID = a;
            }
        }
        class Lt {
            constructor(t){
                this.crossSourceCollisions = t, this.maxGroupID = 0, this.collisionGroups = {};
            }
            get(t) {
                if (this.crossSourceCollisions) return {
                    ID: 0,
                    predicate: null
                };
                if (!this.collisionGroups[t]) {
                    const e = ++this.maxGroupID;
                    this.collisionGroups[t] = {
                        ID: e,
                        predicate: (t)=>t.collisionGroupID === e
                    };
                }
                return this.collisionGroups[t];
            }
        }
        function At(e, i, s, a, o) {
            const { horizontalAlign: r, verticalAlign: n } = t.au(e);
            return new t.P(-(r - .5) * i + a[0] * o, -(n - .5) * s + a[1] * o);
        }
        function Rt(e, i, s, a, o, r) {
            const { x1: n, x2: l, y1: h, y2: c, anchorPointX: u, anchorPointY: d } = e, _ = new t.P(i, s);
            return a && _._rotate(o ? r : -r), {
                x1: n + _.x,
                y1: h + _.y,
                x2: l + _.x,
                y2: c + _.y,
                anchorPointX: u,
                anchorPointY: d
            };
        }
        class kt {
            constructor(t, e, i, s, a){
                this.transform = t.clone(), this.terrain = e, this.collisionIndex = new Et(this.transform), this.placements = {}, this.opacities = {}, this.variableOffsets = {}, this.stale = !1, this.commitTime = 0, this.fadeDuration = i, this.retainedQueryData = {}, this.collisionGroups = new Lt(s), this.collisionCircleArrays = {}, this.prevPlacement = a, a && (a.prevPlacement = void 0), this.placedOrientations = {};
            }
            getBucketParts(e, i, s, a) {
                const o = s.getBucket(i), r = s.latestFeatureIndex;
                if (!o || !r || i.id !== o.layerIds[0]) return;
                const n = s.collisionBoxArray, l = o.layers[0].layout, h = Math.pow(2, this.transform.zoom - s.tileID.overscaledZ), c = s.tileSize / t.N, u = this.transform.calculatePosMatrix(s.tileID.toUnwrapped()), d = "map" === l.get("text-pitch-alignment"), _ = "map" === l.get("text-rotation-alignment"), p = St(s, 1, this.transform.zoom), m = nt(u, d, _, this.transform, p);
                let f = null;
                if (d) {
                    const e = lt(u, d, _, this.transform, p);
                    f = t.a1([], this.transform.labelPlaneMatrix, e);
                }
                this.retainedQueryData[o.bucketInstanceId] = new zt(o.bucketInstanceId, r, o.sourceLayerIndex, o.index, s.tileID);
                const g = {
                    bucket: o,
                    layout: l,
                    posMatrix: u,
                    textLabelPlaneMatrix: m,
                    labelToScreenMatrix: f,
                    scale: h,
                    textPixelRatio: c,
                    holdingForFade: s.holdingForFade(),
                    collisionBoxArray: n,
                    partiallyEvaluatedTextSize: t.ah(o.textSizeData, this.transform.zoom),
                    collisionGroup: this.collisionGroups.get(o.sourceID)
                };
                if (a) for (const t of o.sortKeyRanges){
                    const { sortKey: i, symbolInstanceStart: s, symbolInstanceEnd: a } = t;
                    e.push({
                        sortKey: i,
                        symbolInstanceStart: s,
                        symbolInstanceEnd: a,
                        parameters: g
                    });
                }
                else e.push({
                    symbolInstanceStart: 0,
                    symbolInstanceEnd: o.symbolInstances.length,
                    parameters: g
                });
            }
            attemptAnchorPlacement(e, i, s, a, o, r, n, l, h, c, u, d, _, p, m, f) {
                const g = t.aq[e.textAnchor], v = [
                    e.textOffset0,
                    e.textOffset1
                ], x = At(g, s, a, v, o), y = this.collisionIndex.placeCollisionBox(Rt(i, x.x, x.y, r, n, this.transform.angle), u, l, h, c.predicate, f);
                if ((!m || 0 !== this.collisionIndex.placeCollisionBox(Rt(m, x.x, x.y, r, n, this.transform.angle), u, l, h, c.predicate, f).box.length) && y.box.length > 0) {
                    let t;
                    if (this.prevPlacement && this.prevPlacement.variableOffsets[d.crossTileID] && this.prevPlacement.placements[d.crossTileID] && this.prevPlacement.placements[d.crossTileID].text && (t = this.prevPlacement.variableOffsets[d.crossTileID].anchor), 0 === d.crossTileID) throw new Error("symbolInstance.crossTileID can't be 0");
                    return this.variableOffsets[d.crossTileID] = {
                        textOffset: v,
                        width: s,
                        height: a,
                        anchor: g,
                        textBoxScale: o,
                        prevAnchor: t
                    }, this.markUsedJustification(_, g, d, p), _.allowVerticalPlacement && (this.markUsedOrientation(_, p, d), this.placedOrientations[d.crossTileID] = p), {
                        shift: x,
                        placedGlyphBoxes: y
                    };
                }
            }
            placeLayerBucketPart(e, i, s) {
                const { bucket: a, layout: o, posMatrix: r, textLabelPlaneMatrix: n, labelToScreenMatrix: l, textPixelRatio: h, holdingForFade: c, collisionBoxArray: u, partiallyEvaluatedTextSize: d, collisionGroup: _ } = e.parameters, p = o.get("text-optional"), m = o.get("icon-optional"), f = t.ar(o, "text-overlap", "text-allow-overlap"), g = "always" === f, v = t.ar(o, "icon-overlap", "icon-allow-overlap"), x = "always" === v, y = "map" === o.get("text-rotation-alignment"), b = "map" === o.get("text-pitch-alignment"), w = "none" !== o.get("icon-text-fit"), T = "viewport-y" === o.get("symbol-z-order"), I = g && (x || !a.hasIconData() || m), E = x && (g || !a.hasTextData() || p);
                !a.collisionArrays && u && a.deserializeCollisionBoxes(u);
                const S = this.retainedQueryData[a.bucketInstanceId].tileID, C = this.terrain ? (t, e)=>this.terrain.getElevation(S, t, e) : null, P = (e, u)=>{
                    var x, T;
                    if (i[e.crossTileID]) return;
                    if (c) return void (this.placements[e.crossTileID] = new Dt(!1, !1, !1));
                    let S = !1, P = !1, D = !0, M = null, z = {
                        box: null,
                        offscreen: null
                    }, L = {
                        box: null,
                        offscreen: null
                    }, A = null, R = null, k = null, F = 0, B = 0, O = 0;
                    u.textFeatureIndex ? F = u.textFeatureIndex : e.useRuntimeCollisionCircles && (F = e.featureIndex), u.verticalTextFeatureIndex && (B = u.verticalTextFeatureIndex);
                    const N = u.textBox;
                    if (N) {
                        const i = (i)=>{
                            let s = t.ai.horizontal;
                            if (a.allowVerticalPlacement && !i && this.prevPlacement) {
                                const t = this.prevPlacement.placedOrientations[e.crossTileID];
                                t && (this.placedOrientations[e.crossTileID] = t, s = t, this.markUsedOrientation(a, s, e));
                            }
                            return s;
                        }, s = (i, s)=>{
                            if (a.allowVerticalPlacement && e.numVerticalGlyphVertices > 0 && u.verticalTextBox) {
                                for (const e of a.writingModes)if (e === t.ai.vertical ? (z = s(), L = z) : z = i(), z && z.box && z.box.length) break;
                            } else z = i();
                        }, o = e.textAnchorOffsetStartIndex, n = e.textAnchorOffsetEndIndex;
                        if (n === o) {
                            const o = (t, i)=>{
                                const s = this.collisionIndex.placeCollisionBox(t, f, h, r, _.predicate, C);
                                return s && s.box && s.box.length && (this.markUsedOrientation(a, i, e), this.placedOrientations[e.crossTileID] = i), s;
                            };
                            s(()=>o(N, t.ai.horizontal), ()=>{
                                const i = u.verticalTextBox;
                                return a.allowVerticalPlacement && e.numVerticalGlyphVertices > 0 && i ? o(i, t.ai.vertical) : {
                                    box: null,
                                    offscreen: null
                                };
                            }), i(z && z.box && z.box.length);
                        } else {
                            let l = t.aq[null === (T = null === (x = this.prevPlacement) || void 0 === x ? void 0 : x.variableOffsets[e.crossTileID]) || void 0 === T ? void 0 : T.anchor];
                            const c = (t, i, s)=>{
                                const c = t.x2 - t.x1, u = t.y2 - t.y1, d = e.textBoxScale, p = w && "never" === v ? i : null;
                                let m = {
                                    box: [],
                                    offscreen: !1
                                }, g = "never" === f ? 1 : 2, x = "never";
                                l && g++;
                                for(let i = 0; i < g; i++){
                                    for(let i = o; i < n; i++){
                                        const o = a.textAnchorOffsets.get(i);
                                        if (l && o.textAnchor !== l) continue;
                                        const n = this.attemptAnchorPlacement(o, t, c, u, d, y, b, h, r, _, x, e, a, s, p, C);
                                        if (n && (m = n.placedGlyphBoxes, m && m.box && m.box.length)) return S = !0, M = n.shift, m;
                                    }
                                    l ? l = null : x = f;
                                }
                                return m;
                            };
                            s(()=>c(N, u.iconBox, t.ai.horizontal), ()=>{
                                const i = u.verticalTextBox;
                                return a.allowVerticalPlacement && !(z && z.box && z.box.length) && e.numVerticalGlyphVertices > 0 && i ? c(i, u.verticalIconBox, t.ai.vertical) : {
                                    box: null,
                                    offscreen: null
                                };
                            }), z && (S = z.box, D = z.offscreen);
                            const d = i(z && z.box);
                            if (!S && this.prevPlacement) {
                                const t = this.prevPlacement.variableOffsets[e.crossTileID];
                                t && (this.variableOffsets[e.crossTileID] = t, this.markUsedJustification(a, t.anchor, e, d));
                            }
                        }
                    }
                    if (A = z, S = A && A.box && A.box.length > 0, D = A && A.offscreen, e.useRuntimeCollisionCircles) {
                        const i = a.text.placedSymbolArray.get(e.centerJustifiedTextSymbolIndex), h = t.aj(a.textSizeData, d, i), c = o.get("text-padding");
                        R = this.collisionIndex.placeCollisionCircles(f, i, a.lineVertexArray, a.glyphOffsetArray, h, r, n, l, s, b, _.predicate, e.collisionCircleDiameter, c, C), R.circles.length && R.collisionDetected && !s && t.w("Collisions detected, but collision boxes are not shown"), S = g || R.circles.length > 0 && !R.collisionDetected, D = D && R.offscreen;
                    }
                    if (u.iconFeatureIndex && (O = u.iconFeatureIndex), u.iconBox) {
                        const t = (t)=>{
                            const e = w && M ? Rt(t, M.x, M.y, y, b, this.transform.angle) : t;
                            return this.collisionIndex.placeCollisionBox(e, v, h, r, _.predicate, C);
                        };
                        L && L.box && L.box.length && u.verticalIconBox ? (k = t(u.verticalIconBox), P = k.box.length > 0) : (k = t(u.iconBox), P = k.box.length > 0), D = D && k.offscreen;
                    }
                    const U = p || 0 === e.numHorizontalGlyphVertices && 0 === e.numVerticalGlyphVertices, Z = m || 0 === e.numIconVertices;
                    if (U || Z ? Z ? U || (P = P && S) : S = P && S : P = S = P && S, S && A && A.box && this.collisionIndex.insertCollisionBox(A.box, f, o.get("text-ignore-placement"), a.bucketInstanceId, L && L.box && B ? B : F, _.ID), P && k && this.collisionIndex.insertCollisionBox(k.box, v, o.get("icon-ignore-placement"), a.bucketInstanceId, O, _.ID), R && (S && this.collisionIndex.insertCollisionCircles(R.circles, f, o.get("text-ignore-placement"), a.bucketInstanceId, F, _.ID), s)) {
                        const t = a.bucketInstanceId;
                        let e = this.collisionCircleArrays[t];
                        void 0 === e && (e = this.collisionCircleArrays[t] = new Mt);
                        for(let t = 0; t < R.circles.length; t += 4)e.circles.push(R.circles[t + 0]), e.circles.push(R.circles[t + 1]), e.circles.push(R.circles[t + 2]), e.circles.push(R.collisionDetected ? 1 : 0);
                    }
                    if (0 === e.crossTileID) throw new Error("symbolInstance.crossTileID can't be 0");
                    if (0 === a.bucketInstanceId) throw new Error("bucket.bucketInstanceId can't be 0");
                    this.placements[e.crossTileID] = new Dt(S || I, P || E, D || a.justReloaded), i[e.crossTileID] = !0;
                };
                if (T) {
                    if (0 !== e.symbolInstanceStart) throw new Error("bucket.bucketInstanceId should be 0");
                    const t = a.getSortedSymbolIndexes(this.transform.angle);
                    for(let e = t.length - 1; e >= 0; --e){
                        const i = t[e];
                        P(a.symbolInstances.get(i), a.collisionArrays[i]);
                    }
                } else for(let t = e.symbolInstanceStart; t < e.symbolInstanceEnd; t++)P(a.symbolInstances.get(t), a.collisionArrays[t]);
                if (s && a.bucketInstanceId in this.collisionCircleArrays) {
                    const e = this.collisionCircleArrays[a.bucketInstanceId];
                    t.as(e.invProjMatrix, r), e.viewportMatrix = this.collisionIndex.getViewportMatrix();
                }
                a.justReloaded = !1;
            }
            markUsedJustification(e, i, s, a) {
                let o;
                o = a === t.ai.vertical ? s.verticalPlacedTextSymbolIndex : ({
                    left: s.leftJustifiedTextSymbolIndex,
                    center: s.centerJustifiedTextSymbolIndex,
                    right: s.rightJustifiedTextSymbolIndex
                })[t.at(i)];
                const r = [
                    s.leftJustifiedTextSymbolIndex,
                    s.centerJustifiedTextSymbolIndex,
                    s.rightJustifiedTextSymbolIndex,
                    s.verticalPlacedTextSymbolIndex
                ];
                for (const t of r)t >= 0 && (e.text.placedSymbolArray.get(t).crossTileID = o >= 0 && t !== o ? 0 : s.crossTileID);
            }
            markUsedOrientation(e, i, s) {
                const a = i === t.ai.horizontal || i === t.ai.horizontalOnly ? i : 0, o = i === t.ai.vertical ? i : 0, r = [
                    s.leftJustifiedTextSymbolIndex,
                    s.centerJustifiedTextSymbolIndex,
                    s.rightJustifiedTextSymbolIndex
                ];
                for (const t of r)e.text.placedSymbolArray.get(t).placedOrientation = a;
                s.verticalPlacedTextSymbolIndex && (e.text.placedSymbolArray.get(s.verticalPlacedTextSymbolIndex).placedOrientation = o);
            }
            commit(t) {
                this.commitTime = t, this.zoomAtLastRecencyCheck = this.transform.zoom;
                const e = this.prevPlacement;
                let i = !1;
                this.prevZoomAdjustment = e ? e.zoomAdjustment(this.transform.zoom) : 0;
                const s = e ? e.symbolFadeChange(t) : 1, a = e ? e.opacities : {}, o = e ? e.variableOffsets : {}, r = e ? e.placedOrientations : {};
                for(const t in this.placements){
                    const e = this.placements[t], o = a[t];
                    o ? (this.opacities[t] = new Pt(o, s, e.text, e.icon), i = i || e.text !== o.text.placed || e.icon !== o.icon.placed) : (this.opacities[t] = new Pt(null, s, e.text, e.icon, e.skipFade), i = i || e.text || e.icon);
                }
                for(const t in a){
                    const e = a[t];
                    if (!this.opacities[t]) {
                        const a = new Pt(e, s, !1, !1);
                        a.isHidden() || (this.opacities[t] = a, i = i || e.text.placed || e.icon.placed);
                    }
                }
                for(const t in o)this.variableOffsets[t] || !this.opacities[t] || this.opacities[t].isHidden() || (this.variableOffsets[t] = o[t]);
                for(const t in r)this.placedOrientations[t] || !this.opacities[t] || this.opacities[t].isHidden() || (this.placedOrientations[t] = r[t]);
                if (e && void 0 === e.lastPlacementChangeTime) throw new Error("Last placement time for previous placement is not defined");
                i ? this.lastPlacementChangeTime = t : "number" != typeof this.lastPlacementChangeTime && (this.lastPlacementChangeTime = e ? e.lastPlacementChangeTime : t);
            }
            updateLayerOpacities(t, e) {
                const i = {};
                for (const s of e){
                    const e = s.getBucket(t);
                    e && s.latestFeatureIndex && t.id === e.layerIds[0] && this.updateBucketOpacities(e, i, s.collisionBoxArray);
                }
            }
            updateBucketOpacities(e, i, s) {
                e.hasTextData() && (e.text.opacityVertexArray.clear(), e.text.hasVisibleVertices = !1), e.hasIconData() && (e.icon.opacityVertexArray.clear(), e.icon.hasVisibleVertices = !1), e.hasIconCollisionBoxData() && e.iconCollisionBox.collisionVertexArray.clear(), e.hasTextCollisionBoxData() && e.textCollisionBox.collisionVertexArray.clear();
                const a = e.layers[0], o = a.layout, r = new Pt(null, 0, !1, !1, !0), n = o.get("text-allow-overlap"), l = o.get("icon-allow-overlap"), h = a._unevaluatedLayout.hasValue("text-variable-anchor") || a._unevaluatedLayout.hasValue("text-variable-anchor-offset"), c = "map" === o.get("text-rotation-alignment"), u = "map" === o.get("text-pitch-alignment"), d = "none" !== o.get("icon-text-fit"), _ = new Pt(null, 0, n && (l || !e.hasIconData() || o.get("icon-optional")), l && (n || !e.hasTextData() || o.get("text-optional")), !0);
                !e.collisionArrays && s && (e.hasIconCollisionBoxData() || e.hasTextCollisionBoxData()) && e.deserializeCollisionBoxes(s);
                const p = (t, e, i)=>{
                    for(let s = 0; s < e / 4; s++)t.opacityVertexArray.emplaceBack(i);
                    t.hasVisibleVertices = t.hasVisibleVertices || i !== qt;
                };
                for(let s = 0; s < e.symbolInstances.length; s++){
                    const a = e.symbolInstances.get(s), { numHorizontalGlyphVertices: o, numVerticalGlyphVertices: n, crossTileID: l } = a;
                    let m = this.opacities[l];
                    i[l] ? m = r : m || (m = _, this.opacities[l] = m), i[l] = !0;
                    const f = a.numIconVertices > 0, g = this.placedOrientations[a.crossTileID], v = g === t.ai.vertical, x = g === t.ai.horizontal || g === t.ai.horizontalOnly;
                    if (o > 0 || n > 0) {
                        const t = Vt(m.text);
                        p(e.text, o, v ? qt : t), p(e.text, n, x ? qt : t);
                        const i = m.text.isHidden();
                        [
                            a.rightJustifiedTextSymbolIndex,
                            a.centerJustifiedTextSymbolIndex,
                            a.leftJustifiedTextSymbolIndex
                        ].forEach((t)=>{
                            t >= 0 && (e.text.placedSymbolArray.get(t).hidden = i || v ? 1 : 0);
                        }), a.verticalPlacedTextSymbolIndex >= 0 && (e.text.placedSymbolArray.get(a.verticalPlacedTextSymbolIndex).hidden = i || x ? 1 : 0);
                        const s = this.variableOffsets[a.crossTileID];
                        s && this.markUsedJustification(e, s.anchor, a, g);
                        const r = this.placedOrientations[a.crossTileID];
                        r && (this.markUsedJustification(e, "left", a, r), this.markUsedOrientation(e, r, a));
                    }
                    if (f) {
                        const t = Vt(m.icon), i = !(d && a.verticalPlacedIconSymbolIndex && v);
                        a.placedIconSymbolIndex >= 0 && (p(e.icon, a.numIconVertices, i ? t : qt), e.icon.placedSymbolArray.get(a.placedIconSymbolIndex).hidden = m.icon.isHidden()), a.verticalPlacedIconSymbolIndex >= 0 && (p(e.icon, a.numVerticalIconVertices, i ? qt : t), e.icon.placedSymbolArray.get(a.verticalPlacedIconSymbolIndex).hidden = m.icon.isHidden());
                    }
                    if (e.hasIconCollisionBoxData() || e.hasTextCollisionBoxData()) {
                        const i = e.collisionArrays[s];
                        if (i) {
                            let s = new t.P(0, 0);
                            if (i.textBox || i.verticalTextBox) {
                                let t = !0;
                                if (h) {
                                    const e = this.variableOffsets[l];
                                    e ? (s = At(e.anchor, e.width, e.height, e.textOffset, e.textBoxScale), c && s._rotate(u ? this.transform.angle : -this.transform.angle)) : t = !1;
                                }
                                i.textBox && Ft(e.textCollisionBox.collisionVertexArray, m.text.placed, !t || v, s.x, s.y), i.verticalTextBox && Ft(e.textCollisionBox.collisionVertexArray, m.text.placed, !t || x, s.x, s.y);
                            }
                            const a = Boolean(!x && i.verticalIconBox);
                            i.iconBox && Ft(e.iconCollisionBox.collisionVertexArray, m.icon.placed, a, d ? s.x : 0, d ? s.y : 0), i.verticalIconBox && Ft(e.iconCollisionBox.collisionVertexArray, m.icon.placed, !a, d ? s.x : 0, d ? s.y : 0);
                        }
                    }
                }
                if (e.sortFeatures(this.transform.angle), this.retainedQueryData[e.bucketInstanceId] && (this.retainedQueryData[e.bucketInstanceId].featureSortOrder = e.featureSortOrder), e.hasTextData() && e.text.opacityVertexBuffer && e.text.opacityVertexBuffer.updateData(e.text.opacityVertexArray), e.hasIconData() && e.icon.opacityVertexBuffer && e.icon.opacityVertexBuffer.updateData(e.icon.opacityVertexArray), e.hasIconCollisionBoxData() && e.iconCollisionBox.collisionVertexBuffer && e.iconCollisionBox.collisionVertexBuffer.updateData(e.iconCollisionBox.collisionVertexArray), e.hasTextCollisionBoxData() && e.textCollisionBox.collisionVertexBuffer && e.textCollisionBox.collisionVertexBuffer.updateData(e.textCollisionBox.collisionVertexArray), e.text.opacityVertexArray.length !== e.text.layoutVertexArray.length / 4) throw new Error(`bucket.text.opacityVertexArray.length (= ${e.text.opacityVertexArray.length}) !== bucket.text.layoutVertexArray.length (= ${e.text.layoutVertexArray.length}) / 4`);
                if (e.icon.opacityVertexArray.length !== e.icon.layoutVertexArray.length / 4) throw new Error(`bucket.icon.opacityVertexArray.length (= ${e.icon.opacityVertexArray.length}) !== bucket.icon.layoutVertexArray.length (= ${e.icon.layoutVertexArray.length}) / 4`);
                if (e.bucketInstanceId in this.collisionCircleArrays) {
                    const t = this.collisionCircleArrays[e.bucketInstanceId];
                    e.placementInvProjMatrix = t.invProjMatrix, e.placementViewportMatrix = t.viewportMatrix, e.collisionCircleArray = t.circles, delete this.collisionCircleArrays[e.bucketInstanceId];
                }
            }
            symbolFadeChange(t) {
                return 0 === this.fadeDuration ? 1 : (t - this.commitTime) / this.fadeDuration + this.prevZoomAdjustment;
            }
            zoomAdjustment(t) {
                return Math.max(0, (this.transform.zoom - t) / 1.5);
            }
            hasTransitions(t) {
                return this.stale || t - this.lastPlacementChangeTime < this.fadeDuration;
            }
            stillRecent(t, e) {
                const i = this.zoomAtLastRecencyCheck === e ? 1 - this.zoomAdjustment(e) : 1;
                return this.zoomAtLastRecencyCheck = e, this.commitTime + this.fadeDuration * i > t;
            }
            setStale() {
                this.stale = !0;
            }
        }
        function Ft(t, e, i, s, a) {
            t.emplaceBack(e ? 1 : 0, i ? 1 : 0, s || 0, a || 0), t.emplaceBack(e ? 1 : 0, i ? 1 : 0, s || 0, a || 0), t.emplaceBack(e ? 1 : 0, i ? 1 : 0, s || 0, a || 0), t.emplaceBack(e ? 1 : 0, i ? 1 : 0, s || 0, a || 0);
        }
        const Bt = Math.pow(2, 25), Ot = Math.pow(2, 24), Nt = Math.pow(2, 17), Ut = Math.pow(2, 16), Zt = Math.pow(2, 9), Gt = Math.pow(2, 8), jt = Math.pow(2, 1);
        function Vt(t) {
            if (0 === t.opacity && !t.placed) return 0;
            if (1 === t.opacity && t.placed) return 4294967295;
            const e = t.placed ? 1 : 0, i = Math.floor(127 * t.opacity);
            return i * Bt + e * Ot + i * Nt + e * Ut + i * Zt + e * Gt + i * jt + e;
        }
        const qt = 0;
        class $t {
            constructor(t){
                this._sortAcrossTiles = "viewport-y" !== t.layout.get("symbol-z-order") && !t.layout.get("symbol-sort-key").isConstant(), this._currentTileIndex = 0, this._currentPartIndex = 0, this._seenCrossTileIDs = {}, this._bucketParts = [];
            }
            continuePlacement(t, e, i, s, a) {
                const o = this._bucketParts;
                for(; this._currentTileIndex < t.length;)if (e.getBucketParts(o, s, t[this._currentTileIndex], this._sortAcrossTiles), this._currentTileIndex++, a()) return !0;
                for(this._sortAcrossTiles && (this._sortAcrossTiles = !1, o.sort((t, e)=>t.sortKey - e.sortKey)); this._currentPartIndex < o.length;)if (e.placeLayerBucketPart(o[this._currentPartIndex], this._seenCrossTileIDs, i), this._currentPartIndex++, a()) return !0;
                return !1;
            }
        }
        class Wt {
            constructor(t, e, i, s, a, o, r, n){
                this.placement = new kt(t, e, o, r, n), this._currentPlacementIndex = i.length - 1, this._forceFullPlacement = s, this._showCollisionBoxes = a, this._done = !1;
            }
            isDone() {
                return this._done;
            }
            continuePlacement(e, i, s) {
                const a = t.h.now(), o = ()=>!this._forceFullPlacement && t.h.now() - a > 2;
                for(; this._currentPlacementIndex >= 0;){
                    const t = i[e[this._currentPlacementIndex]], a = this.placement.collisionIndex.transform.zoom;
                    if ("symbol" === t.type && (!t.minzoom || t.minzoom <= a) && (!t.maxzoom || t.maxzoom > a)) {
                        if (this._inProgressLayer || (this._inProgressLayer = new $t(t)), this._inProgressLayer.continuePlacement(s[t.source], this.placement, this._showCollisionBoxes, t, o)) return;
                        delete this._inProgressLayer;
                    }
                    this._currentPlacementIndex--;
                }
                this._done = !0;
            }
            commit(t) {
                return this.placement.commit(t), this.placement;
            }
        }
        const Ht = 512 / t.N / 2;
        class Xt {
            constructor(e, i, s){
                this.tileID = e, this.bucketInstanceId = s, this._symbolsByKey = {};
                const a = new Map;
                for(let t = 0; t < i.length; t++){
                    const e = i.get(t), s = e.key, o = a.get(s);
                    o ? o.push(e) : a.set(s, [
                        e
                    ]);
                }
                for (const [e, i] of a){
                    const s = {
                        positions: i.map((t)=>({
                                x: Math.floor(t.anchorX * Ht),
                                y: Math.floor(t.anchorY * Ht)
                            })),
                        crossTileIDs: i.map((t)=>t.crossTileID)
                    };
                    if (s.positions.length > 128) {
                        const e = new t.av(s.positions.length, 16, Uint16Array);
                        for (const { x: t, y: i } of s.positions)e.add(t, i);
                        e.finish(), delete s.positions, s.index = e;
                    }
                    this._symbolsByKey[e] = s;
                }
            }
            getScaledCoordinates(e, i) {
                const { x: s, y: a, z: o } = this.tileID.canonical, { x: r, y: n, z: l } = i.canonical, h = Ht / Math.pow(2, l - o), c = (n * t.N + e.anchorY) * h, u = a * t.N * Ht;
                return {
                    x: Math.floor((r * t.N + e.anchorX) * h - s * t.N * Ht),
                    y: Math.floor(c - u)
                };
            }
            findMatches(t, e, i) {
                const s = this.tileID.canonical.z < e.canonical.z ? 1 : Math.pow(2, this.tileID.canonical.z - e.canonical.z);
                for(let a = 0; a < t.length; a++){
                    const o = t.get(a);
                    if (o.crossTileID) continue;
                    const r = this._symbolsByKey[o.key];
                    if (!r) continue;
                    const n = this.getScaledCoordinates(o, e);
                    if (r.index) {
                        const t = r.index.range(n.x - s, n.y - s, n.x + s, n.y + s).sort();
                        for (const e of t){
                            const t = r.crossTileIDs[e];
                            if (!i[t]) {
                                i[t] = !0, o.crossTileID = t;
                                break;
                            }
                        }
                    } else if (r.positions) for(let t = 0; t < r.positions.length; t++){
                        const e = r.positions[t], a = r.crossTileIDs[t];
                        if (Math.abs(e.x - n.x) <= s && Math.abs(e.y - n.y) <= s && !i[a]) {
                            i[a] = !0, o.crossTileID = a;
                            break;
                        }
                    }
                }
            }
            getCrossTileIDsLists() {
                return Object.values(this._symbolsByKey).map(({ crossTileIDs: t })=>t);
            }
        }
        class Kt {
            constructor(){
                this.maxCrossTileID = 0;
            }
            generate() {
                return ++this.maxCrossTileID;
            }
        }
        class Qt {
            constructor(){
                this.indexes = {}, this.usedCrossTileIDs = {}, this.lng = 0;
            }
            handleWrapJump(t) {
                const e = Math.round((t - this.lng) / 360);
                if (0 !== e) for(const t in this.indexes){
                    const i = this.indexes[t], s = {};
                    for(const t in i){
                        const a = i[t];
                        a.tileID = a.tileID.unwrapTo(a.tileID.wrap + e), s[a.tileID.key] = a;
                    }
                    this.indexes[t] = s;
                }
                this.lng = t;
            }
            addBucket(t, e, i) {
                if (this.indexes[t.overscaledZ] && this.indexes[t.overscaledZ][t.key]) {
                    if (this.indexes[t.overscaledZ][t.key].bucketInstanceId === e.bucketInstanceId) return !1;
                    this.removeBucketCrossTileIDs(t.overscaledZ, this.indexes[t.overscaledZ][t.key]);
                }
                for(let t = 0; t < e.symbolInstances.length; t++)e.symbolInstances.get(t).crossTileID = 0;
                this.usedCrossTileIDs[t.overscaledZ] || (this.usedCrossTileIDs[t.overscaledZ] = {});
                const s = this.usedCrossTileIDs[t.overscaledZ];
                for(const i in this.indexes){
                    const a = this.indexes[i];
                    if (Number(i) > t.overscaledZ) for(const i in a){
                        const o = a[i];
                        o.tileID.isChildOf(t) && o.findMatches(e.symbolInstances, t, s);
                    }
                    else {
                        const o = a[t.scaledTo(Number(i)).key];
                        o && o.findMatches(e.symbolInstances, t, s);
                    }
                }
                for(let t = 0; t < e.symbolInstances.length; t++){
                    const a = e.symbolInstances.get(t);
                    a.crossTileID || (a.crossTileID = i.generate(), s[a.crossTileID] = !0);
                }
                return void 0 === this.indexes[t.overscaledZ] && (this.indexes[t.overscaledZ] = {}), this.indexes[t.overscaledZ][t.key] = new Xt(t, e.symbolInstances, e.bucketInstanceId), !0;
            }
            removeBucketCrossTileIDs(t, e) {
                for (const i of e.getCrossTileIDsLists())for (const e of i)delete this.usedCrossTileIDs[t][e];
            }
            removeStaleBuckets(t) {
                let e = !1;
                for(const i in this.indexes){
                    const s = this.indexes[i];
                    for(const a in s)t[s[a].bucketInstanceId] || (this.removeBucketCrossTileIDs(i, s[a]), delete s[a], e = !0);
                }
                return e;
            }
        }
        class Yt {
            constructor(){
                this.layerIndexes = {}, this.crossTileIDs = new Kt, this.maxBucketInstanceId = 0, this.bucketsInCurrentPlacement = {};
            }
            addLayer(t, e, i) {
                let s = this.layerIndexes[t.id];
                void 0 === s && (s = this.layerIndexes[t.id] = new Qt);
                let a = !1;
                const o = {};
                s.handleWrapJump(i);
                for (const i of e){
                    const e = i.getBucket(t);
                    e && t.id === e.layerIds[0] && (e.bucketInstanceId || (e.bucketInstanceId = ++this.maxBucketInstanceId), s.addBucket(i.tileID, e, this.crossTileIDs) && (a = !0), o[e.bucketInstanceId] = !0);
                }
                return s.removeStaleBuckets(o) && (a = !0), a;
            }
            pruneUnusedLayers(t) {
                const e = {};
                t.forEach((t)=>{
                    e[t] = !0;
                });
                for(const t in this.layerIndexes)e[t] || delete this.layerIndexes[t];
            }
        }
        const Jt = (e, i)=>t.x(e, i && i.filter((t)=>"source.canvas" !== t.identifier)), te = t.F(t.ax, [
            "addLayer",
            "removeLayer",
            "setPaintProperty",
            "setLayoutProperty",
            "setFilter",
            "addSource",
            "removeSource",
            "setLayerZoomRange",
            "setLight",
            "setTransition",
            "setGeoJSONSourceData",
            "setGlyphs",
            "setSprite"
        ]), ee = t.F(t.ax, [
            "setCenter",
            "setZoom",
            "setBearing",
            "setPitch"
        ]), ie = t.aw();
        class se extends t.E {
            constructor(e, i = {}){
                super(), this.map = e, this.dispatcher = new M(st(), this, e._getMapId()), this.imageManager = new b, this.imageManager.setEventedParent(this), this.glyphManager = new E(e._requestManager, i.localIdeographFontFamily), this.lineAtlas = new D(256, 512), this.crossTileSymbolIndex = new Yt, this._spritesImagesIds = {}, this._layers = {}, this._order = [], this.sourceCaches = {}, this.zoomHistory = new t.ay, this._loaded = !1, this._availableImages = [], this._resetUpdates(), this.dispatcher.broadcast("setReferrer", t.az());
                const s = this;
                this._rtlTextPluginCallback = se.registerForPluginStateChange((e)=>{
                    s.dispatcher.broadcast("syncRTLPluginState", {
                        pluginStatus: e.pluginStatus,
                        pluginURL: e.pluginURL
                    }, (e, i)=>{
                        if (t.aA(e), i && i.every((t)=>t)) for(const t in s.sourceCaches){
                            const e = s.sourceCaches[t].getSource().type;
                            "vector" !== e && "geojson" !== e || s.sourceCaches[t].reload();
                        }
                    });
                }), this.on("data", (t)=>{
                    if ("source" !== t.dataType || "metadata" !== t.sourceDataType) return;
                    const e = this.sourceCaches[t.sourceId];
                    if (!e) return;
                    const i = e.getSource();
                    if (i && i.vectorLayerIds) for(const t in this._layers){
                        const e = this._layers[t];
                        e.source === i.id && this._validateLayer(e);
                    }
                });
            }
            loadURL(e, i = {}, s) {
                this.fire(new t.k("dataloading", {
                    dataType: "style"
                })), i.validate = "boolean" != typeof i.validate || i.validate;
                const a = this.map._requestManager.transformRequest(e, c.Style);
                this._request = t.f(a, (e, a)=>{
                    this._request = null, e ? this.fire(new t.j(e)) : a && this._load(a, i, s);
                });
            }
            loadJSON(e, i = {}, s) {
                this.fire(new t.k("dataloading", {
                    dataType: "style"
                })), this._request = t.h.frame(()=>{
                    this._request = null, i.validate = !1 !== i.validate, this._load(e, i, s);
                });
            }
            loadEmpty() {
                this.fire(new t.k("dataloading", {
                    dataType: "style"
                })), this._load(ie, {
                    validate: !1
                });
            }
            _load(e, i, s) {
                var a;
                const o = i.transformStyle ? i.transformStyle(s, e) : e;
                if (!i.validate || !Jt(this, t.y(o))) {
                    this._loaded = !0, this.stylesheet = o;
                    for(const t in o.sources)this.addSource(t, o.sources[t], {
                        validate: !1
                    });
                    o.sprite ? this._loadSprite(o.sprite) : this.imageManager.setLoaded(!0), this.glyphManager.setURL(o.glyphs), this._createLayers(), this.light = new P(this.stylesheet.light), this.map.setTerrain(null !== (a = this.stylesheet.terrain) && void 0 !== a ? a : null), this.fire(new t.k("data", {
                        dataType: "style"
                    })), this.fire(new t.k("style.load"));
                }
            }
            _createLayers() {
                const e = t.aB(this.stylesheet.layers);
                this.dispatcher.broadcast("setLayers", e), this._order = e.map((t)=>t.id), this._layers = {}, this._serializedLayers = null;
                for (const i of e){
                    const e = t.aC(i);
                    e.setEventedParent(this, {
                        layer: {
                            id: i.id
                        }
                    }), this._layers[i.id] = e;
                }
            }
            _loadSprite(e, i = !1, s) {
                this.imageManager.setLoaded(!1), this._spriteRequest = function(e, i, s, a) {
                    const o = g(e), r = o.length, n = s > 1 ? "@2x" : "", l = {}, u = {}, d = {};
                    for (const { id: e, url: s } of o){
                        const o = i.transformRequest(i.normalizeSpriteURL(s, n, ".json"), c.SpriteJSON), _ = `${e}_${o.url}`;
                        l[_] = t.f(o, (t, i)=>{
                            delete l[_], u[e] = i, v(a, u, d, t, r);
                        });
                        const p = i.transformRequest(i.normalizeSpriteURL(s, n, ".png"), c.SpriteImage), m = `${e}_${p.url}`;
                        l[m] = h.getImage(p, (t, i)=>{
                            delete l[m], d[e] = i, v(a, u, d, t, r);
                        });
                    }
                    return {
                        cancel () {
                            for (const t of Object.values(l))t.cancel();
                        }
                    };
                }(e, this.map._requestManager, this.map.getPixelRatio(), (e, a)=>{
                    if (this._spriteRequest = null, e) this.fire(new t.j(e));
                    else if (a) for(const t in a){
                        this._spritesImagesIds[t] = [];
                        const e = this._spritesImagesIds[t] ? this._spritesImagesIds[t].filter((t)=>!(t in a)) : [];
                        for (const t of e)this.imageManager.removeImage(t), this._changedImages[t] = !0;
                        for(const e in a[t]){
                            const s = "default" === t ? e : `${t}:${e}`;
                            this._spritesImagesIds[t].push(s), s in this.imageManager.images ? this.imageManager.updateImage(s, a[t][e], !1) : this.imageManager.addImage(s, a[t][e]), i && (this._changedImages[s] = !0);
                        }
                    }
                    this.imageManager.setLoaded(!0), this._availableImages = this.imageManager.listImages(), i && (this._changed = !0), this.dispatcher.broadcast("setImages", this._availableImages), this.fire(new t.k("data", {
                        dataType: "style"
                    })), s && s(e);
                });
            }
            _unloadSprite() {
                for (const t of Object.values(this._spritesImagesIds).flat())this.imageManager.removeImage(t), this._changedImages[t] = !0;
                this._spritesImagesIds = {}, this._availableImages = this.imageManager.listImages(), this._changed = !0, this.dispatcher.broadcast("setImages", this._availableImages), this.fire(new t.k("data", {
                    dataType: "style"
                }));
            }
            _validateLayer(e) {
                const i = this.sourceCaches[e.source];
                if (!i) return;
                const s = e.sourceLayer;
                if (!s) return;
                const a = i.getSource();
                ("geojson" === a.type || a.vectorLayerIds && -1 === a.vectorLayerIds.indexOf(s)) && this.fire(new t.j(new Error(`Source layer "${s}" does not exist on source "${a.id}" as specified by style layer "${e.id}".`)));
            }
            loaded() {
                if (!this._loaded) return !1;
                if (Object.keys(this._updatedSources).length) return !1;
                for(const t in this.sourceCaches)if (!this.sourceCaches[t].loaded()) return !1;
                return !!this.imageManager.isLoaded();
            }
            _serializeByIds(t) {
                const e = this._serializedAllLayers();
                if (!t || 0 === t.length) return Object.values(e);
                const i = [];
                for (const s of t)e[s] && i.push(e[s]);
                return i;
            }
            _serializedAllLayers() {
                let t = this._serializedLayers;
                if (t) return t;
                t = this._serializedLayers = {};
                const e = Object.keys(this._layers);
                for (const i of e){
                    const e = this._layers[i];
                    "custom" !== e.type && (t[i] = e.serialize());
                }
                return t;
            }
            hasTransitions() {
                if (this.light && this.light.hasTransition()) return !0;
                for(const t in this.sourceCaches)if (this.sourceCaches[t].hasTransition()) return !0;
                for(const t in this._layers)if (this._layers[t].hasTransition()) return !0;
                return !1;
            }
            _checkLoaded() {
                if (!this._loaded) throw new Error("Style is not done loading.");
            }
            update(e) {
                if (!this._loaded) return;
                const i = this._changed;
                if (this._changed) {
                    const t = Object.keys(this._updatedLayers), i = Object.keys(this._removedLayers);
                    (t.length || i.length) && this._updateWorkerLayers(t, i);
                    for(const t in this._updatedSources){
                        const e = this._updatedSources[t];
                        if ("reload" === e) this._reloadSource(t);
                        else {
                            if ("clear" !== e) throw new Error(`Invalid action ${e}`);
                            this._clearSource(t);
                        }
                    }
                    this._updateTilesForChangedImages(), this._updateTilesForChangedGlyphs();
                    for(const t in this._updatedPaintProps)this._layers[t].updateTransitions(e);
                    this.light.updateTransitions(e), this._resetUpdates();
                }
                const s = {};
                for(const t in this.sourceCaches){
                    const e = this.sourceCaches[t];
                    s[t] = e.used, e.used = !1;
                }
                for (const t of this._order){
                    const i = this._layers[t];
                    i.recalculate(e, this._availableImages), !i.isHidden(e.zoom) && i.source && (this.sourceCaches[i.source].used = !0);
                }
                for(const e in s){
                    const i = this.sourceCaches[e];
                    s[e] !== i.used && i.fire(new t.k("data", {
                        sourceDataType: "visibility",
                        dataType: "source",
                        sourceId: e
                    }));
                }
                this.light.recalculate(e), this.z = e.zoom, i && this.fire(new t.k("data", {
                    dataType: "style"
                }));
            }
            _updateTilesForChangedImages() {
                const t = Object.keys(this._changedImages);
                if (t.length) {
                    for(const e in this.sourceCaches)this.sourceCaches[e].reloadTilesForDependencies([
                        "icons",
                        "patterns"
                    ], t);
                    this._changedImages = {};
                }
            }
            _updateTilesForChangedGlyphs() {
                if (this._glyphsDidChange) {
                    for(const t in this.sourceCaches)this.sourceCaches[t].reloadTilesForDependencies([
                        "glyphs"
                    ], [
                        ""
                    ]);
                    this._glyphsDidChange = !1;
                }
            }
            _updateWorkerLayers(t, e) {
                this.dispatcher.broadcast("updateLayers", {
                    layers: this._serializeByIds(t),
                    removedIds: e
                });
            }
            _resetUpdates() {
                this._changed = !1, this._updatedLayers = {}, this._removedLayers = {}, this._updatedSources = {}, this._updatedPaintProps = {}, this._changedImages = {}, this._glyphsDidChange = !1;
            }
            setState(e, i = {}) {
                this._checkLoaded();
                const s = this.serialize();
                if (e = i.transformStyle ? i.transformStyle(s, e) : e, Jt(this, t.y(e))) return !1;
                (e = t.aD(e)).layers = t.aB(e.layers);
                const a = t.aE(s, e).filter((t)=>!(t.command in ee));
                if (0 === a.length) return !1;
                const o = a.filter((t)=>!(t.command in te));
                if (o.length > 0) throw new Error(`Unimplemented: ${o.map((t)=>t.command).join(", ")}.`);
                for (const t of a)"setTransition" !== t.command && this[t.command].apply(this, t.args);
                return this.stylesheet = e, this._serializedLayers = null, !0;
            }
            addImage(e, i) {
                if (this.getImage(e)) return this.fire(new t.j(new Error(`An image named "${e}" already exists.`)));
                this.imageManager.addImage(e, i), this._afterImageUpdated(e);
            }
            updateImage(t, e) {
                this.imageManager.updateImage(t, e);
            }
            getImage(t) {
                return this.imageManager.getImage(t);
            }
            removeImage(e) {
                if (!this.getImage(e)) return this.fire(new t.j(new Error(`An image named "${e}" does not exist.`)));
                this.imageManager.removeImage(e), this._afterImageUpdated(e);
            }
            _afterImageUpdated(e) {
                this._availableImages = this.imageManager.listImages(), this._changedImages[e] = !0, this._changed = !0, this.dispatcher.broadcast("setImages", this._availableImages), this.fire(new t.k("data", {
                    dataType: "style"
                }));
            }
            listImages() {
                return this._checkLoaded(), this.imageManager.listImages();
            }
            addSource(e, i, s = {}) {
                if (this._checkLoaded(), void 0 !== this.sourceCaches[e]) throw new Error(`Source "${e}" already exists.`);
                if (!i.type) throw new Error(`The type property must be defined, but only the following properties were given: ${Object.keys(i).join(", ")}.`);
                if ([
                    "vector",
                    "raster",
                    "geojson",
                    "video",
                    "image"
                ].indexOf(i.type) >= 0 && this._validate(t.y.source, `sources.${e}`, i, null, s)) return;
                this.map && this.map._collectResourceTiming && (i.collectResourceTiming = !0);
                const a = this.sourceCaches[e] = new K(e, i, this.dispatcher);
                a.style = this, a.setEventedParent(this, ()=>({
                        isSourceLoaded: a.loaded(),
                        source: a.serialize(),
                        sourceId: e
                    })), a.onAdd(this.map), this._changed = !0;
            }
            removeSource(e) {
                if (this._checkLoaded(), void 0 === this.sourceCaches[e]) throw new Error("There is no source with this ID");
                for(const i in this._layers)if (this._layers[i].source === e) return this.fire(new t.j(new Error(`Source "${e}" cannot be removed while layer "${i}" is using it.`)));
                const i = this.sourceCaches[e];
                delete this.sourceCaches[e], delete this._updatedSources[e], i.fire(new t.k("data", {
                    sourceDataType: "metadata",
                    dataType: "source",
                    sourceId: e
                })), i.setEventedParent(null), i.onRemove(this.map), this._changed = !0;
            }
            setGeoJSONSourceData(t, e) {
                if (this._checkLoaded(), void 0 === this.sourceCaches[t]) throw new Error(`There is no source with this ID=${t}`);
                const i = this.sourceCaches[t].getSource();
                if ("geojson" !== i.type) throw new Error(`geojsonSource.type is ${i.type}, which is !== 'geojson`);
                i.setData(e), this._changed = !0;
            }
            getSource(t) {
                return this.sourceCaches[t] && this.sourceCaches[t].getSource();
            }
            addLayer(e, i, s = {}) {
                this._checkLoaded();
                const a = e.id;
                if (this.getLayer(a)) return void this.fire(new t.j(new Error(`Layer "${a}" already exists on this map.`)));
                let o;
                if ("custom" === e.type) {
                    if (Jt(this, t.aF(e))) return;
                    o = t.aC(e);
                } else {
                    if ("source" in e && "object" == typeof e.source && (this.addSource(a, e.source), e = t.aD(e), e = t.e(e, {
                        source: a
                    })), this._validate(t.y.layer, `layers.${a}`, e, {
                        arrayIndex: -1
                    }, s)) return;
                    o = t.aC(e), this._validateLayer(o), o.setEventedParent(this, {
                        layer: {
                            id: a
                        }
                    });
                }
                const r = i ? this._order.indexOf(i) : this._order.length;
                if (i && -1 === r) this.fire(new t.j(new Error(`Cannot add layer "${a}" before non-existing layer "${i}".`)));
                else {
                    if (this._order.splice(r, 0, a), this._layerOrderChanged = !0, this._layers[a] = o, this._removedLayers[a] && o.source && "custom" !== o.type) {
                        const t = this._removedLayers[a];
                        delete this._removedLayers[a], t.type !== o.type ? this._updatedSources[o.source] = "clear" : (this._updatedSources[o.source] = "reload", this.sourceCaches[o.source].pause());
                    }
                    this._updateLayer(o), o.onAdd && o.onAdd(this.map);
                }
            }
            moveLayer(e, i) {
                if (this._checkLoaded(), this._changed = !0, !this._layers[e]) return void this.fire(new t.j(new Error(`The layer '${e}' does not exist in the map's style and cannot be moved.`)));
                if (e === i) return;
                const s = this._order.indexOf(e);
                this._order.splice(s, 1);
                const a = i ? this._order.indexOf(i) : this._order.length;
                i && -1 === a ? this.fire(new t.j(new Error(`Cannot move layer "${e}" before non-existing layer "${i}".`))) : (this._order.splice(a, 0, e), this._layerOrderChanged = !0);
            }
            removeLayer(e) {
                this._checkLoaded();
                const i = this._layers[e];
                if (!i) return void this.fire(new t.j(new Error(`Cannot remove non-existing layer "${e}".`)));
                i.setEventedParent(null);
                const s = this._order.indexOf(e);
                this._order.splice(s, 1), this._layerOrderChanged = !0, this._changed = !0, this._removedLayers[e] = i, delete this._layers[e], this._serializedLayers && delete this._serializedLayers[e], delete this._updatedLayers[e], delete this._updatedPaintProps[e], i.onRemove && i.onRemove(this.map);
            }
            getLayer(t) {
                return this._layers[t];
            }
            getLayersOrder() {
                return [
                    ...this._order
                ];
            }
            hasLayer(t) {
                return t in this._layers;
            }
            setLayerZoomRange(e, i, s) {
                this._checkLoaded();
                const a = this.getLayer(e);
                a ? a.minzoom === i && a.maxzoom === s || (null != i && (a.minzoom = i), null != s && (a.maxzoom = s), this._updateLayer(a)) : this.fire(new t.j(new Error(`Cannot set the zoom range of non-existing layer "${e}".`)));
            }
            setFilter(e, i, s = {}) {
                this._checkLoaded();
                const a = this.getLayer(e);
                if (a) {
                    if (!t.aG(a.filter, i)) return null == i ? (a.filter = void 0, void this._updateLayer(a)) : void (this._validate(t.y.filter, `layers.${a.id}.filter`, i, null, s) || (a.filter = t.aD(i), this._updateLayer(a)));
                } else this.fire(new t.j(new Error(`Cannot filter non-existing layer "${e}".`)));
            }
            getFilter(e) {
                return t.aD(this.getLayer(e).filter);
            }
            setLayoutProperty(e, i, s, a = {}) {
                this._checkLoaded();
                const o = this.getLayer(e);
                o ? t.aG(o.getLayoutProperty(i), s) || (o.setLayoutProperty(i, s, a), this._updateLayer(o)) : this.fire(new t.j(new Error(`Cannot style non-existing layer "${e}".`)));
            }
            getLayoutProperty(e, i) {
                const s = this.getLayer(e);
                if (s) return s.getLayoutProperty(i);
                this.fire(new t.j(new Error(`Cannot get style of non-existing layer "${e}".`)));
            }
            setPaintProperty(e, i, s, a = {}) {
                this._checkLoaded();
                const o = this.getLayer(e);
                o ? t.aG(o.getPaintProperty(i), s) || (o.setPaintProperty(i, s, a) && this._updateLayer(o), this._changed = !0, this._updatedPaintProps[e] = !0) : this.fire(new t.j(new Error(`Cannot style non-existing layer "${e}".`)));
            }
            getPaintProperty(t, e) {
                return this.getLayer(t).getPaintProperty(e);
            }
            setFeatureState(e, i) {
                this._checkLoaded();
                const s = e.source, a = e.sourceLayer, o = this.sourceCaches[s];
                if (void 0 === o) return void this.fire(new t.j(new Error(`The source '${s}' does not exist in the map's style.`)));
                const r = o.getSource().type;
                "geojson" === r && a ? this.fire(new t.j(new Error("GeoJSON sources cannot have a sourceLayer parameter."))) : "vector" !== r || a ? (void 0 === e.id && this.fire(new t.j(new Error("The feature id parameter must be provided."))), o.setFeatureState(a, e.id, i)) : this.fire(new t.j(new Error("The sourceLayer parameter must be provided for vector source types.")));
            }
            removeFeatureState(e, i) {
                this._checkLoaded();
                const s = e.source, a = this.sourceCaches[s];
                if (void 0 === a) return void this.fire(new t.j(new Error(`The source '${s}' does not exist in the map's style.`)));
                const o = a.getSource().type, r = "vector" === o ? e.sourceLayer : void 0;
                "vector" !== o || r ? i && "string" != typeof e.id && "number" != typeof e.id ? this.fire(new t.j(new Error("A feature id is required to remove its specific state property."))) : a.removeFeatureState(r, e.id, i) : this.fire(new t.j(new Error("The sourceLayer parameter must be provided for vector source types.")));
            }
            getFeatureState(e) {
                this._checkLoaded();
                const i = e.source, s = e.sourceLayer, a = this.sourceCaches[i];
                if (void 0 !== a) return "vector" !== a.getSource().type || s ? (void 0 === e.id && this.fire(new t.j(new Error("The feature id parameter must be provided."))), a.getFeatureState(s, e.id)) : void this.fire(new t.j(new Error("The sourceLayer parameter must be provided for vector source types.")));
                this.fire(new t.j(new Error(`The source '${i}' does not exist in the map's style.`)));
            }
            getTransition() {
                return t.e({
                    duration: 300,
                    delay: 0
                }, this.stylesheet && this.stylesheet.transition);
            }
            serialize() {
                if (!this._loaded) return;
                const e = t.aH(this.sourceCaches, (t)=>t.serialize()), i = this._serializeByIds(this._order), s = this.map.getTerrain() || void 0, a = this.stylesheet;
                return t.aI({
                    version: a.version,
                    name: a.name,
                    metadata: a.metadata,
                    light: a.light,
                    center: a.center,
                    zoom: a.zoom,
                    bearing: a.bearing,
                    pitch: a.pitch,
                    sprite: a.sprite,
                    glyphs: a.glyphs,
                    transition: a.transition,
                    sources: e,
                    layers: i,
                    terrain: s
                }, (t)=>void 0 !== t);
            }
            _updateLayer(t) {
                this._updatedLayers[t.id] = !0, t.source && !this._updatedSources[t.source] && "raster" !== this.sourceCaches[t.source].getSource().type && (this._updatedSources[t.source] = "reload", this.sourceCaches[t.source].pause()), this._serializedLayers = null, this._changed = !0;
            }
            _flattenAndSortRenderedFeatures(t) {
                const e = (t)=>"fill-extrusion" === this._layers[t].type, i = {}, s = [];
                for(let a = this._order.length - 1; a >= 0; a--){
                    const o = this._order[a];
                    if (e(o)) {
                        i[o] = a;
                        for (const e of t){
                            const t = e[o];
                            if (t) for (const e of t)s.push(e);
                        }
                    }
                }
                s.sort((t, e)=>e.intersectionZ - t.intersectionZ);
                const a = [];
                for(let o = this._order.length - 1; o >= 0; o--){
                    const r = this._order[o];
                    if (e(r)) for(let t = s.length - 1; t >= 0; t--){
                        const e = s[t].feature;
                        if (i[e.layer.id] < o) break;
                        a.push(e), s.pop();
                    }
                    else for (const e of t){
                        const t = e[r];
                        if (t) for (const e of t)a.push(e.feature);
                    }
                }
                return a;
            }
            queryRenderedFeatures(e, i, s) {
                i && i.filter && this._validate(t.y.filter, "queryRenderedFeatures.filter", i.filter, null, i);
                const a = {};
                if (i && i.layers) {
                    if (!Array.isArray(i.layers)) return this.fire(new t.j(new Error("parameters.layers must be an Array."))), [];
                    for (const e of i.layers){
                        const i = this._layers[e];
                        if (!i) return this.fire(new t.j(new Error(`The layer '${e}' does not exist in the map's style and cannot be queried for features.`))), [];
                        a[i.source] = !0;
                    }
                }
                const o = [];
                i.availableImages = this._availableImages;
                const r = this._serializedAllLayers();
                for(const t in this.sourceCaches)i.layers && !a[t] || o.push(q(this.sourceCaches[t], this._layers, r, e, i, s));
                return this.placement && o.push(function(t, e, i, s, a, o, r) {
                    const n = {}, l = o.queryRenderedSymbols(s), h = [];
                    for (const t of Object.keys(l).map(Number))h.push(r[t]);
                    h.sort($);
                    for (const i of h){
                        const s = i.featureIndex.lookupSymbolFeatures(l[i.bucketInstanceId], e, i.bucketIndex, i.sourceLayerIndex, a.filter, a.layers, a.availableImages, t);
                        for(const t in s){
                            const e = n[t] = n[t] || [], a = s[t];
                            a.sort((t, e)=>{
                                const s = i.featureSortOrder;
                                if (s) {
                                    const i = s.indexOf(t.featureIndex);
                                    return s.indexOf(e.featureIndex) - i;
                                }
                                return e.featureIndex - t.featureIndex;
                            });
                            for (const t of a)e.push(t);
                        }
                    }
                    for(const e in n)n[e].forEach((s)=>{
                        const a = s.feature, o = i[t[e].source].getFeatureState(a.layer["source-layer"], a.id);
                        a.source = a.layer.source, a.layer["source-layer"] && (a.sourceLayer = a.layer["source-layer"]), a.state = o;
                    });
                    return n;
                }(this._layers, r, this.sourceCaches, e, i, this.placement.collisionIndex, this.placement.retainedQueryData)), this._flattenAndSortRenderedFeatures(o);
            }
            querySourceFeatures(e, i) {
                i && i.filter && this._validate(t.y.filter, "querySourceFeatures.filter", i.filter, null, i);
                const s = this.sourceCaches[e];
                return s ? function(t, e) {
                    const i = t.getRenderableIds().map((e)=>t.getTileByID(e)), s = [], a = {};
                    for(let t = 0; t < i.length; t++){
                        const o = i[t], r = o.tileID.canonical.key;
                        a[r] || (a[r] = !0, o.querySourceFeatures(s, e));
                    }
                    return s;
                }(s, i) : [];
            }
            addSourceType(t, e, i) {
                return j(t) ? i(new Error(`A source type called "${t}" already exists.`)) : (((t, e)=>{
                    G[t] = e;
                })(t, e), e.workerSourceURL ? void this.dispatcher.broadcast("loadWorkerSource", {
                    name: t,
                    url: e.workerSourceURL
                }, i) : i(null, null));
            }
            getLight() {
                return this.light.getLight();
            }
            setLight(e, i = {}) {
                this._checkLoaded();
                const s = this.light.getLight();
                let a = !1;
                for(const i in e)if (!t.aG(e[i], s[i])) {
                    a = !0;
                    break;
                }
                if (!a) return;
                const o = {
                    now: t.h.now(),
                    transition: t.e({
                        duration: 300,
                        delay: 0
                    }, this.stylesheet.transition)
                };
                this.light.setLight(e, i), this.light.updateTransitions(o);
            }
            _validate(e, i, s, a, o = {}) {
                return (!o || !1 !== o.validate) && Jt(this, e.call(t.y, t.e({
                    key: i,
                    style: this.serialize(),
                    value: s,
                    styleSpec: t.v
                }, a)));
            }
            _remove(e = !0) {
                this._request && (this._request.cancel(), this._request = null), this._spriteRequest && (this._spriteRequest.cancel(), this._spriteRequest = null), t.aJ.off("pluginStateChange", this._rtlTextPluginCallback);
                for(const t in this._layers)this._layers[t].setEventedParent(null);
                for(const t in this.sourceCaches){
                    const e = this.sourceCaches[t];
                    e.setEventedParent(null), e.onRemove(this.map);
                }
                this.imageManager.setEventedParent(null), this.setEventedParent(null), this.dispatcher.remove(e);
            }
            _clearSource(t) {
                this.sourceCaches[t].clearTiles();
            }
            _reloadSource(t) {
                this.sourceCaches[t].resume(), this.sourceCaches[t].reload();
            }
            _updateSources(t) {
                for(const e in this.sourceCaches)this.sourceCaches[e].update(t, this.map.terrain);
            }
            _generateCollisionBoxes() {
                for(const t in this.sourceCaches)this._reloadSource(t);
            }
            _updatePlacement(e, i, s, a, o = !1) {
                let r = !1, n = !1;
                const l = {};
                for (const t of this._order){
                    const i = this._layers[t];
                    if ("symbol" !== i.type) continue;
                    if (!l[i.source]) {
                        const t = this.sourceCaches[i.source];
                        l[i.source] = t.getRenderableIds(!0).map((e)=>t.getTileByID(e)).sort((t, e)=>e.tileID.overscaledZ - t.tileID.overscaledZ || (t.tileID.isLessThan(e.tileID) ? -1 : 1));
                    }
                    const s = this.crossTileSymbolIndex.addLayer(i, l[i.source], e.center.lng);
                    r = r || s;
                }
                if (this.crossTileSymbolIndex.pruneUnusedLayers(this._order), ((o = o || this._layerOrderChanged || 0 === s) || !this.pauseablePlacement || this.pauseablePlacement.isDone() && !this.placement.stillRecent(t.h.now(), e.zoom)) && (this.pauseablePlacement = new Wt(e, this.map.terrain, this._order, o, i, s, a, this.placement), this._layerOrderChanged = !1), this.pauseablePlacement.isDone() ? this.placement.setStale() : (this.pauseablePlacement.continuePlacement(this._order, this._layers, l), this.pauseablePlacement.isDone() && (this.placement = this.pauseablePlacement.commit(t.h.now()), n = !0), r && this.pauseablePlacement.placement.setStale()), n || r) for (const t of this._order){
                    const e = this._layers[t];
                    "symbol" === e.type && this.placement.updateLayerOpacities(e, l[e.source]);
                }
                return !this.pauseablePlacement.isDone() || this.placement.hasTransitions(t.h.now());
            }
            _releaseSymbolFadeTiles() {
                for(const t in this.sourceCaches)this.sourceCaches[t].releaseSymbolFadeTiles();
            }
            getImages(t, e, i) {
                this.imageManager.getImages(e.icons, i), this._updateTilesForChangedImages();
                const s = this.sourceCaches[e.source];
                s && s.setDependencies(e.tileID.key, e.type, e.icons);
            }
            getGlyphs(t, e, i) {
                this.glyphManager.getGlyphs(e.stacks, i);
                const s = this.sourceCaches[e.source];
                s && s.setDependencies(e.tileID.key, e.type, [
                    ""
                ]);
            }
            getResource(e, i, s) {
                return t.m(i, s);
            }
            getGlyphsUrl() {
                return this.stylesheet.glyphs || null;
            }
            setGlyphs(e, i = {}) {
                this._checkLoaded(), e && this._validate(t.y.glyphs, "glyphs", e, null, i) || (this._glyphsDidChange = !0, this.stylesheet.glyphs = e, this.glyphManager.entries = {}, this.glyphManager.setURL(e));
            }
            addSprite(e, i, s = {}, a) {
                this._checkLoaded();
                const o = [
                    {
                        id: e,
                        url: i
                    }
                ], r = [
                    ...g(this.stylesheet.sprite),
                    ...o
                ];
                this._validate(t.y.sprite, "sprite", r, null, s) || (this.stylesheet.sprite = r, this._loadSprite(o, !0, a));
            }
            removeSprite(e) {
                this._checkLoaded();
                const i = g(this.stylesheet.sprite);
                if (i.find((t)=>t.id === e)) {
                    if (this._spritesImagesIds[e]) for (const t of this._spritesImagesIds[e])this.imageManager.removeImage(t), this._changedImages[t] = !0;
                    i.splice(i.findIndex((t)=>t.id === e), 1), this.stylesheet.sprite = i.length > 0 ? i : void 0, delete this._spritesImagesIds[e], this._availableImages = this.imageManager.listImages(), this._changed = !0, this.dispatcher.broadcast("setImages", this._availableImages), this.fire(new t.k("data", {
                        dataType: "style"
                    }));
                } else this.fire(new t.j(new Error(`Sprite "${e}" doesn't exists on this map.`)));
            }
            getSprite() {
                return g(this.stylesheet.sprite);
            }
            setSprite(e, i = {}, s) {
                this._checkLoaded(), e && this._validate(t.y.sprite, "sprite", e, null, i) || (this.stylesheet.sprite = e, e ? this._loadSprite(e, !0, s) : (this._unloadSprite(), s && s(null)));
            }
        }
        se.registerForPluginStateChange = t.aK;
        var ae = t.Q([
            {
                name: "a_pos",
                type: "Int16",
                components: 2
            }
        ]), oe = "attribute vec3 a_pos3d;uniform mat4 u_matrix;uniform float u_ele_delta;varying vec2 v_texture_pos;varying float v_depth;void main() {float extent=8192.0;float ele_delta=a_pos3d.z==1.0 ? u_ele_delta : 0.0;v_texture_pos=a_pos3d.xy/extent;gl_Position=u_matrix*vec4(a_pos3d.xy,get_elevation(a_pos3d.xy)-ele_delta,1.0);v_depth=gl_Position.z/gl_Position.w;}";
        const re = {
            prelude: ne("#ifdef GL_ES\nprecision mediump float;\n#else\n#if !defined(lowp)\n#define lowp\n#endif\n#if !defined(mediump)\n#define mediump\n#endif\n#if !defined(highp)\n#define highp\n#endif\n#endif\n", "#ifdef GL_ES\nprecision highp float;\n#else\n#if !defined(lowp)\n#define lowp\n#endif\n#if !defined(mediump)\n#define mediump\n#endif\n#if !defined(highp)\n#define highp\n#endif\n#endif\nvec2 unpack_float(const float packedValue) {int packedIntValue=int(packedValue);int v0=packedIntValue/256;return vec2(v0,packedIntValue-v0*256);}vec2 unpack_opacity(const float packedOpacity) {int intOpacity=int(packedOpacity)/2;return vec2(float(intOpacity)/127.0,mod(packedOpacity,2.0));}vec4 decode_color(const vec2 encodedColor) {return vec4(unpack_float(encodedColor[0])/255.0,unpack_float(encodedColor[1])/255.0\n);}float unpack_mix_vec2(const vec2 packedValue,const float t) {return mix(packedValue[0],packedValue[1],t);}vec4 unpack_mix_color(const vec4 packedColors,const float t) {vec4 minColor=decode_color(vec2(packedColors[0],packedColors[1]));vec4 maxColor=decode_color(vec2(packedColors[2],packedColors[3]));return mix(minColor,maxColor,t);}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const float tile_units_to_pixels,const vec2 pos) {vec2 offset=mod(mod(mod(pixel_coord_upper,pattern_size)*256.0,pattern_size)*256.0+pixel_coord_lower,pattern_size);return (tile_units_to_pixels*pos+offset)/pattern_size;}\n#ifdef TERRAIN3D\nuniform sampler2D u_terrain;uniform float u_terrain_dim;uniform mat4 u_terrain_matrix;uniform vec4 u_terrain_unpack;uniform float u_terrain_exaggeration;uniform highp sampler2D u_depth;\n#endif\nconst highp vec4 bitSh=vec4(256.*256.*256.,256.*256.,256.,1.);const highp vec4 bitShifts=vec4(1.)/bitSh;highp float unpack(highp vec4 color) {return dot(color,bitShifts);}highp float depthOpacity(vec3 frag) {\n#ifdef TERRAIN3D\nhighp float d=unpack(texture2D(u_depth,frag.xy*0.5+0.5))+0.0001-frag.z;return 1.0-max(0.0,min(1.0,-d*500.0));\n#else\nreturn 1.0;\n#endif\n}float calculate_visibility(vec4 pos) {\n#ifdef TERRAIN3D\nvec3 frag=pos.xyz/pos.w;highp float d=depthOpacity(frag);if (d > 0.95) return 1.0;return (d+depthOpacity(frag+vec3(0.0,0.01,0.0)))/2.0;\n#else\nreturn 1.0;\n#endif\n}float ele(vec2 pos) {\n#ifdef TERRAIN3D\nvec4 rgb=(texture2D(u_terrain,pos)*255.0)*u_terrain_unpack;return rgb.r+rgb.g+rgb.b-u_terrain_unpack.a;\n#else\nreturn 0.0;\n#endif\n}float get_elevation(vec2 pos) {\n#ifdef TERRAIN3D\nvec2 coord=(u_terrain_matrix*vec4(pos,0.0,1.0)).xy*u_terrain_dim+1.0;vec2 f=fract(coord);vec2 c=(floor(coord)+0.5)/(u_terrain_dim+2.0);float d=1.0/(u_terrain_dim+2.0);float tl=ele(c);float tr=ele(c+vec2(d,0.0));float bl=ele(c+vec2(0.0,d));float br=ele(c+vec2(d,d));float elevation=mix(mix(tl,tr,f.x),mix(bl,br,f.x),f.y);return elevation*u_terrain_exaggeration;\n#else\nreturn 0.0;\n#endif\n}"),
            background: ne("uniform vec4 u_color;uniform float u_opacity;void main() {gl_FragColor=u_color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "attribute vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}"),
            backgroundPattern: ne("uniform vec2 u_pattern_tl_a;uniform vec2 u_pattern_br_a;uniform vec2 u_pattern_tl_b;uniform vec2 u_pattern_br_b;uniform vec2 u_texsize;uniform float u_mix;uniform float u_opacity;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;void main() {vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(u_pattern_tl_a/u_texsize,u_pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(u_pattern_tl_b/u_texsize,u_pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);gl_FragColor=mix(color1,color2,u_mix)*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_pattern_size_a;uniform vec2 u_pattern_size_b;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_scale_a;uniform float u_scale_b;uniform float u_tile_units_to_pixels;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_a*u_pattern_size_a,u_tile_units_to_pixels,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_b*u_pattern_size_b,u_tile_units_to_pixels,a_pos);}"),
            circle: ne("varying vec3 v_data;varying float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=v_data.xy;float extrude_length=length(extrude);lowp float antialiasblur=v_data.z;float antialiased_blur=-max(blur,antialiasblur);float opacity_t=smoothstep(0.0,antialiased_blur,extrude_length-1.0);float color_t=stroke_width < 0.01 ? 0.0 : smoothstep(antialiased_blur,0.0,extrude_length-radius/(radius+stroke_width));gl_FragColor=v_visibility*opacity_t*mix(color*opacity,stroke_color*stroke_opacity,color_t);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform bool u_scale_with_map;uniform bool u_pitch_with_map;uniform vec2 u_extrude_scale;uniform lowp float u_device_pixel_ratio;uniform highp float u_camera_to_center_distance;attribute vec2 a_pos;varying vec3 v_data;varying float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvoid main(void) {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=vec2(mod(a_pos,2.0)*2.0-1.0);vec2 circle_center=floor(a_pos*0.5);float ele=get_elevation(circle_center);v_visibility=calculate_visibility(u_matrix*vec4(circle_center,ele,1.0));if (u_pitch_with_map) {vec2 corner_position=circle_center;if (u_scale_with_map) {corner_position+=extrude*(radius+stroke_width)*u_extrude_scale;} else {vec4 projected_center=u_matrix*vec4(circle_center,0,1);corner_position+=extrude*(radius+stroke_width)*u_extrude_scale*(projected_center.w/u_camera_to_center_distance);}gl_Position=u_matrix*vec4(corner_position,ele,1);} else {gl_Position=u_matrix*vec4(circle_center,ele,1);if (u_scale_with_map) {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*u_camera_to_center_distance;} else {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*gl_Position.w;}}lowp float antialiasblur=1.0/u_device_pixel_ratio/(radius+stroke_width);v_data=vec3(extrude.x,extrude.y,antialiasblur);}"),
            clippingMask: ne("void main() {gl_FragColor=vec4(1.0);}", "attribute vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}"),
            heatmap: ne("uniform highp float u_intensity;varying vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#define GAUSS_COEF 0.3989422804014327\nvoid main() {\n#pragma mapbox: initialize highp float weight\nfloat d=-0.5*3.0*3.0*dot(v_extrude,v_extrude);float val=weight*u_intensity*GAUSS_COEF*exp(d);gl_FragColor=vec4(val,1.0,1.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform float u_extrude_scale;uniform float u_opacity;uniform float u_intensity;attribute vec2 a_pos;varying vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#pragma mapbox: define mediump float radius\nconst highp float ZERO=1.0/255.0/16.0;\n#define GAUSS_COEF 0.3989422804014327\nvoid main(void) {\n#pragma mapbox: initialize highp float weight\n#pragma mapbox: initialize mediump float radius\nvec2 unscaled_extrude=vec2(mod(a_pos,2.0)*2.0-1.0);float S=sqrt(-2.0*log(ZERO/weight/u_intensity/GAUSS_COEF))/3.0;v_extrude=S*unscaled_extrude;vec2 extrude=v_extrude*radius*u_extrude_scale;vec4 pos=vec4(floor(a_pos*0.5)+extrude,0,1);gl_Position=u_matrix*pos;}"),
            heatmapTexture: ne("uniform sampler2D u_image;uniform sampler2D u_color_ramp;uniform float u_opacity;varying vec2 v_pos;void main() {float t=texture2D(u_image,v_pos).r;vec4 color=texture2D(u_color_ramp,vec2(t,0.5));gl_FragColor=color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(0.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_world;attribute vec2 a_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos*u_world,0,1);v_pos.x=a_pos.x;v_pos.y=1.0-a_pos.y;}"),
            collisionBox: ne("varying float v_placed;varying float v_notUsed;void main() {float alpha=0.5;gl_FragColor=vec4(1.0,0.0,0.0,1.0)*alpha;if (v_placed > 0.5) {gl_FragColor=vec4(0.0,0.0,1.0,0.5)*alpha;}if (v_notUsed > 0.5) {gl_FragColor*=.1;}}", "attribute vec2 a_pos;attribute vec2 a_anchor_pos;attribute vec2 a_extrude;attribute vec2 a_placed;attribute vec2 a_shift;uniform mat4 u_matrix;uniform vec2 u_extrude_scale;uniform float u_camera_to_center_distance;varying float v_placed;varying float v_notUsed;void main() {vec4 projectedPoint=u_matrix*vec4(a_anchor_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float collision_perspective_ratio=clamp(0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);gl_Position=u_matrix*vec4(a_pos,get_elevation(a_pos),1.0);gl_Position.xy+=(a_extrude+a_shift)*u_extrude_scale*gl_Position.w*collision_perspective_ratio;v_placed=a_placed.x;v_notUsed=a_placed.y;}"),
            collisionCircle: ne("varying float v_radius;varying vec2 v_extrude;varying float v_perspective_ratio;varying float v_collision;void main() {float alpha=0.5*min(v_perspective_ratio,1.0);float stroke_radius=0.9*max(v_perspective_ratio,1.0);float distance_to_center=length(v_extrude);float distance_to_edge=abs(distance_to_center-v_radius);float opacity_t=smoothstep(-stroke_radius,0.0,-distance_to_edge);vec4 color=mix(vec4(0.0,0.0,1.0,0.5),vec4(1.0,0.0,0.0,1.0),v_collision);gl_FragColor=color*alpha*opacity_t;}", "attribute vec2 a_pos;attribute float a_radius;attribute vec2 a_flags;uniform mat4 u_matrix;uniform mat4 u_inv_matrix;uniform vec2 u_viewport_size;uniform float u_camera_to_center_distance;varying float v_radius;varying vec2 v_extrude;varying float v_perspective_ratio;varying float v_collision;vec3 toTilePosition(vec2 screenPos) {vec4 rayStart=u_inv_matrix*vec4(screenPos,-1.0,1.0);vec4 rayEnd  =u_inv_matrix*vec4(screenPos, 1.0,1.0);rayStart.xyz/=rayStart.w;rayEnd.xyz  /=rayEnd.w;highp float t=(0.0-rayStart.z)/(rayEnd.z-rayStart.z);return mix(rayStart.xyz,rayEnd.xyz,t);}void main() {vec2 quadCenterPos=a_pos;float radius=a_radius;float collision=a_flags.x;float vertexIdx=a_flags.y;vec2 quadVertexOffset=vec2(mix(-1.0,1.0,float(vertexIdx >=2.0)),mix(-1.0,1.0,float(vertexIdx >=1.0 && vertexIdx <=2.0)));vec2 quadVertexExtent=quadVertexOffset*radius;vec3 tilePos=toTilePosition(quadCenterPos);vec4 clipPos=u_matrix*vec4(tilePos,1.0);highp float camera_to_anchor_distance=clipPos.w;highp float collision_perspective_ratio=clamp(0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);float padding_factor=1.2;v_radius=radius;v_extrude=quadVertexExtent*padding_factor;v_perspective_ratio=collision_perspective_ratio;v_collision=collision;gl_Position=vec4(clipPos.xyz/clipPos.w,1.0)+vec4(quadVertexExtent*padding_factor/u_viewport_size*2.0,0.0,0.0);}"),
            debug: ne("uniform highp vec4 u_color;uniform sampler2D u_overlay;varying vec2 v_uv;void main() {vec4 overlay_color=texture2D(u_overlay,v_uv);gl_FragColor=mix(u_color,overlay_color,overlay_color.a);}", "attribute vec2 a_pos;varying vec2 v_uv;uniform mat4 u_matrix;uniform float u_overlay_scale;void main() {v_uv=a_pos/8192.0;gl_Position=u_matrix*vec4(a_pos*u_overlay_scale,get_elevation(a_pos),1);}"),
            fill: ne("#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\ngl_FragColor=color*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "attribute vec2 a_pos;uniform mat4 u_matrix;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=u_matrix*vec4(a_pos,0,1);}"),
            fillOutline: ne("varying vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);gl_FragColor=outline_color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "attribute vec2 a_pos;uniform mat4 u_matrix;uniform vec2 u_world;varying vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=u_matrix*vec4(a_pos,0,1);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;}"),
            fillOutlinePattern: ne("uniform vec2 u_texsize;uniform sampler2D u_image;uniform float u_fade;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);float dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);gl_FragColor=mix(color1,color2,u_fade)*alpha*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_world;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;gl_Position=u_matrix*vec4(a_pos,0,1);vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,a_pos);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;}"),
            fillPattern: ne("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);gl_FragColor=mix(color1,color2,u_fade)*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;gl_Position=u_matrix*vec4(a_pos,0,1);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileZoomRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileZoomRatio,a_pos);}"),
            fillExtrusion: ne("varying vec4 v_color;void main() {gl_FragColor=v_color;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;uniform float u_vertical_gradient;uniform lowp float u_opacity;attribute vec2 a_pos;attribute vec4 a_normal_ed;\n#ifdef TERRAIN3D\nattribute vec2 a_centroid;\n#endif\nvarying vec4 v_color;\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp vec4 color\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp vec4 color\nvec3 normal=a_normal_ed.xyz;\n#ifdef TERRAIN3D\nfloat height_terrain3d_offset=get_elevation(a_centroid);float base_terrain3d_offset=height_terrain3d_offset-(base > 0.0 ? 0.0 : 10.0);\n#else\nfloat height_terrain3d_offset=0.0;float base_terrain3d_offset=0.0;\n#endif\nbase=max(0.0,base)+base_terrain3d_offset;height=max(0.0,height)+height_terrain3d_offset;float t=mod(normal.x,2.0);gl_Position=u_matrix*vec4(a_pos,t > 0.0 ? height : base,1);float colorvalue=color.r*0.2126+color.g*0.7152+color.b*0.0722;v_color=vec4(0.0,0.0,0.0,1.0);vec4 ambientlight=vec4(0.03,0.03,0.03,1.0);color+=ambientlight;float directional=clamp(dot(normal/16384.0,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_color.r+=clamp(color.r*directional*u_lightcolor.r,mix(0.0,0.3,1.0-u_lightcolor.r),1.0);v_color.g+=clamp(color.g*directional*u_lightcolor.g,mix(0.0,0.3,1.0-u_lightcolor.g),1.0);v_color.b+=clamp(color.b*directional*u_lightcolor.b,mix(0.0,0.3,1.0-u_lightcolor.b),1.0);v_color*=u_opacity;}"),
            fillExtrusionPattern: ne("uniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec4 v_lighting;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);vec4 mixedColor=mix(color1,color2,u_fade);gl_FragColor=mixedColor*v_lighting;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_height_factor;uniform vec3 u_scale;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;attribute vec2 a_pos;attribute vec4 a_normal_ed;\n#ifdef TERRAIN3D\nattribute vec2 a_centroid;\n#endif\nvarying vec2 v_pos_a;varying vec2 v_pos_b;varying vec4 v_lighting;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec3 normal=a_normal_ed.xyz;float edgedistance=a_normal_ed.w;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;\n#ifdef TERRAIN3D\nfloat height_terrain3d_offset=get_elevation(a_centroid);float base_terrain3d_offset=height_terrain3d_offset-(base > 0.0 ? 0.0 : 10.0);\n#else\nfloat height_terrain3d_offset=0.0;float base_terrain3d_offset=0.0;\n#endif\nbase=max(0.0,base)+base_terrain3d_offset;height=max(0.0,height)+height_terrain3d_offset;float t=mod(normal.x,2.0);float z=t > 0.0 ? height : base;gl_Position=u_matrix*vec4(a_pos,z,1);vec2 pos=normal.x==1.0 && normal.y==0.0 && normal.z==16384.0\n? a_pos\n: vec2(edgedistance,z*u_height_factor);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,pos);v_lighting=vec4(0.0,0.0,0.0,1.0);float directional=clamp(dot(normal/16383.0,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((0.5+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_lighting.rgb+=clamp(directional*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_lighting*=u_opacity;}"),
            hillshadePrepare: ne("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform sampler2D u_image;varying vec2 v_pos;uniform vec2 u_dimension;uniform float u_zoom;uniform vec4 u_unpack;float getElevation(vec2 coord,float bias) {vec4 data=texture2D(u_image,coord)*255.0;data.a=-1.0;return dot(data,u_unpack)/4.0;}void main() {vec2 epsilon=1.0/u_dimension;float a=getElevation(v_pos+vec2(-epsilon.x,-epsilon.y),0.0);float b=getElevation(v_pos+vec2(0,-epsilon.y),0.0);float c=getElevation(v_pos+vec2(epsilon.x,-epsilon.y),0.0);float d=getElevation(v_pos+vec2(-epsilon.x,0),0.0);float e=getElevation(v_pos,0.0);float f=getElevation(v_pos+vec2(epsilon.x,0),0.0);float g=getElevation(v_pos+vec2(-epsilon.x,epsilon.y),0.0);float h=getElevation(v_pos+vec2(0,epsilon.y),0.0);float i=getElevation(v_pos+vec2(epsilon.x,epsilon.y),0.0);float exaggerationFactor=u_zoom < 2.0 ? 0.4 : u_zoom < 4.5 ? 0.35 : 0.3;float exaggeration=u_zoom < 15.0 ? (u_zoom-15.0)*exaggerationFactor : 0.0;vec2 deriv=vec2((c+f+f+i)-(a+d+d+g),(g+h+h+i)-(a+b+b+c))/pow(2.0,exaggeration+(19.2562-u_zoom));gl_FragColor=clamp(vec4(deriv.x/2.0+0.5,deriv.y/2.0+0.5,1.0,1.0),0.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_dimension;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);highp vec2 epsilon=1.0/u_dimension;float scale=(u_dimension.x-2.0)/u_dimension.x;v_pos=(a_texture_pos/8192.0)*scale+epsilon;}"),
            hillshade: ne("uniform sampler2D u_image;varying vec2 v_pos;uniform vec2 u_latrange;uniform vec2 u_light;uniform vec4 u_shadow;uniform vec4 u_highlight;uniform vec4 u_accent;\n#define PI 3.141592653589793\nvoid main() {vec4 pixel=texture2D(u_image,v_pos);vec2 deriv=((pixel.rg*2.0)-1.0);float scaleFactor=cos(radians((u_latrange[0]-u_latrange[1])*(1.0-v_pos.y)+u_latrange[1]));float slope=atan(1.25*length(deriv)/scaleFactor);float aspect=deriv.x !=0.0 ? atan(deriv.y,-deriv.x) : PI/2.0*(deriv.y > 0.0 ? 1.0 :-1.0);float intensity=u_light.x;float azimuth=u_light.y+PI;float base=1.875-intensity*1.75;float maxValue=0.5*PI;float scaledSlope=intensity !=0.5 ? ((pow(base,slope)-1.0)/(pow(base,maxValue)-1.0))*maxValue : slope;float accent=cos(scaledSlope);vec4 accent_color=(1.0-accent)*u_accent*clamp(intensity*2.0,0.0,1.0);float shade=abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);vec4 shade_color=mix(u_shadow,u_highlight,shade)*sin(scaledSlope)*clamp(intensity*2.0,0.0,1.0);gl_FragColor=accent_color*(1.0-shade_color.a)+shade_color;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=a_texture_pos/8192.0;}"),
            line: ne("uniform lowp float u_device_pixel_ratio;varying vec2 v_width2;varying vec2 v_normal;varying float v_gamma_scale;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);gl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\nattribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform vec2 u_units_to_pixels;uniform lowp float u_device_pixel_ratio;varying vec2 v_normal;varying vec2 v_width2;varying float v_gamma_scale;varying highp float v_linesofar;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;v_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*2.0;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nv_width2=vec2(outset,inset);}"),
            lineGradient: ne("uniform lowp float u_device_pixel_ratio;uniform sampler2D u_image;varying vec2 v_width2;varying vec2 v_normal;varying float v_gamma_scale;varying highp vec2 v_uv;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);vec4 color=texture2D(u_image,v_uv);gl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\nattribute vec2 a_pos_normal;attribute vec4 a_data;attribute float a_uv_x;attribute float a_split_index;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_units_to_pixels;uniform float u_image_height;varying vec2 v_normal;varying vec2 v_width2;varying float v_gamma_scale;varying highp vec2 v_uv;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;highp float texel_height=1.0/u_image_height;highp float half_texel_height=0.5*texel_height;v_uv=vec2(a_uv_x,a_split_index*texel_height-half_texel_height);vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nv_width2=vec2(outset,inset);}"),
            linePattern: ne("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform lowp float u_device_pixel_ratio;uniform vec2 u_texsize;uniform float u_fade;uniform mediump vec3 u_scale;uniform sampler2D u_image;varying vec2 v_normal;varying vec2 v_width2;varying float v_linesofar;varying float v_gamma_scale;varying float v_width;\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;vec2 pattern_size_a=vec2(display_size_a.x*fromScale/tileZoomRatio,display_size_a.y);vec2 pattern_size_b=vec2(display_size_b.x*toScale/tileZoomRatio,display_size_b.y);float aspect_a=display_size_a.y/v_width;float aspect_b=display_size_b.y/v_width;float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float x_a=mod(v_linesofar/pattern_size_a.x*aspect_a,1.0);float x_b=mod(v_linesofar/pattern_size_b.x*aspect_b,1.0);float y=0.5*v_normal.y+0.5;vec2 texel_size=1.0/u_texsize;vec2 pos_a=mix(pattern_tl_a*texel_size-texel_size,pattern_br_a*texel_size+texel_size,vec2(x_a,y));vec2 pos_b=mix(pattern_tl_b*texel_size-texel_size,pattern_br_b*texel_size+texel_size,vec2(x_b,y));vec4 color=mix(texture2D(u_image,pos_a),texture2D(u_image,pos_b),u_fade);gl_FragColor=color*alpha*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\nattribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform vec2 u_units_to_pixels;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;varying vec2 v_normal;varying vec2 v_width2;varying float v_linesofar;varying float v_gamma_scale;varying float v_width;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nv_linesofar=a_linesofar;v_width2=vec2(outset,inset);v_width=floorwidth;}"),
            lineSDF: ne("uniform lowp float u_device_pixel_ratio;uniform sampler2D u_image;uniform float u_sdfgamma;uniform float u_mix;varying vec2 v_normal;varying vec2 v_width2;varying vec2 v_tex_a;varying vec2 v_tex_b;varying float v_gamma_scale;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float sdfdist_a=texture2D(u_image,v_tex_a).a;float sdfdist_b=texture2D(u_image,v_tex_b).a;float sdfdist=mix(sdfdist_a,sdfdist_b,u_mix);alpha*=smoothstep(0.5-u_sdfgamma/floorwidth,0.5+u_sdfgamma/floorwidth,sdfdist);gl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\nattribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_patternscale_a;uniform float u_tex_y_a;uniform vec2 u_patternscale_b;uniform float u_tex_y_b;uniform vec2 u_units_to_pixels;varying vec2 v_normal;varying vec2 v_width2;varying vec2 v_tex_a;varying vec2 v_tex_b;varying float v_gamma_scale;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nv_tex_a=vec2(a_linesofar*u_patternscale_a.x/floorwidth,normal.y*u_patternscale_a.y+u_tex_y_a);v_tex_b=vec2(a_linesofar*u_patternscale_b.x/floorwidth,normal.y*u_patternscale_b.y+u_tex_y_b);v_width2=vec2(outset,inset);}"),
            raster: ne("uniform float u_fade_t;uniform float u_opacity;uniform sampler2D u_image0;uniform sampler2D u_image1;varying vec2 v_pos0;varying vec2 v_pos1;uniform float u_brightness_low;uniform float u_brightness_high;uniform float u_saturation_factor;uniform float u_contrast_factor;uniform vec3 u_spin_weights;void main() {vec4 color0=texture2D(u_image0,v_pos0);vec4 color1=texture2D(u_image1,v_pos1);if (color0.a > 0.0) {color0.rgb=color0.rgb/color0.a;}if (color1.a > 0.0) {color1.rgb=color1.rgb/color1.a;}vec4 color=mix(color0,color1,u_fade_t);color.a*=u_opacity;vec3 rgb=color.rgb;rgb=vec3(dot(rgb,u_spin_weights.xyz),dot(rgb,u_spin_weights.zxy),dot(rgb,u_spin_weights.yzx));float average=(color.r+color.g+color.b)/3.0;rgb+=(average-rgb)*u_saturation_factor;rgb=(rgb-0.5)*u_contrast_factor+0.5;vec3 u_high_vec=vec3(u_brightness_low,u_brightness_low,u_brightness_low);vec3 u_low_vec=vec3(u_brightness_high,u_brightness_high,u_brightness_high);gl_FragColor=vec4(mix(u_high_vec,u_low_vec,rgb)*color.a,color.a);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform float u_buffer_scale;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos0;varying vec2 v_pos1;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos0=(((a_texture_pos/8192.0)-0.5)/u_buffer_scale )+0.5;v_pos1=(v_pos0*u_scale_parent)+u_tl_parent;}"),
            symbolIcon: ne("uniform sampler2D u_texture;varying vec2 v_tex;varying float v_fade_opacity;\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\nlowp float alpha=opacity*v_fade_opacity;gl_FragColor=texture2D(u_texture,v_tex)*alpha;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "const float PI=3.141592653589793;attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec4 a_pixeloffset;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform highp float u_camera_to_center_distance;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform float u_fade_change;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform vec2 u_texsize;varying vec2 v_tex;varying float v_fade_opacity;\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;vec2 a_minFontScale=a_pixeloffset.zw/256.0;float ele=get_elevation(a_pos);highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec4 projectedPoint=u_matrix*vec4(a_pos,ele,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=u_matrix*vec4(a_pos+vec2(1,0),ele,1);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,ele,1.0);float z=float(u_pitch_with_map)*projected_pos.z/projected_pos.w;gl_Position=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*max(a_minFontScale,fontScale)+a_pxoffset/16.0),z,1.0);v_tex=a_tex/u_texsize;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float visibility=calculate_visibility(projectedPoint);v_fade_opacity=max(0.0,min(visibility,fade_opacity[0]+fade_change));}"),
            symbolSDF: ne("#define SDF_PX 8.0\nuniform bool u_is_halo;uniform sampler2D u_texture;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;uniform bool u_is_text;varying vec2 v_data0;varying vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nfloat EDGE_GAMMA=0.105/u_device_pixel_ratio;vec2 tex=v_data0.xy;float gamma_scale=v_data1.x;float size=v_data1.y;float fade_opacity=v_data1[2];float fontScale=u_is_text ? size/24.0 : size;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float inner_edge=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);inner_edge=inner_edge+gamma*gamma_scale;}lowp float dist=texture2D(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(inner_edge-gamma_scaled,inner_edge+gamma_scaled,dist);if (u_is_halo) {lowp float halo_edge=(6.0-halo_width/fontScale)/SDF_PX;alpha=min(smoothstep(halo_edge-gamma_scaled,halo_edge+gamma_scaled,dist),1.0-alpha);}gl_FragColor=color*(alpha*opacity*fade_opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "const float PI=3.141592653589793;attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec4 a_pixeloffset;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;varying vec2 v_data0;varying vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;float ele=get_elevation(a_pos);highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec4 projectedPoint=u_matrix*vec4(a_pos,ele,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=u_matrix*vec4(a_pos+vec2(1,0),ele,1);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,ele,1.0);float z=float(u_pitch_with_map)*projected_pos.z/projected_pos.w;gl_Position=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale+a_pxoffset),z,1.0);float gamma_scale=gl_Position.w;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float visibility=calculate_visibility(projectedPoint);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(visibility,fade_opacity[0]+fade_change));v_data0=a_tex/u_texsize;v_data1=vec3(gamma_scale,size,interpolated_fade_opacity);}"),
            symbolTextAndIcon: ne("#define SDF_PX 8.0\n#define SDF 1.0\n#define ICON 0.0\nuniform bool u_is_halo;uniform sampler2D u_texture;uniform sampler2D u_texture_icon;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;varying vec4 v_data0;varying vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nfloat fade_opacity=v_data1[2];if (v_data1.w==ICON) {vec2 tex_icon=v_data0.zw;lowp float alpha=opacity*fade_opacity;gl_FragColor=texture2D(u_texture_icon,tex_icon)*alpha;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\nreturn;}vec2 tex=v_data0.xy;float EDGE_GAMMA=0.105/u_device_pixel_ratio;float gamma_scale=v_data1.x;float size=v_data1.y;float fontScale=size/24.0;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture2D(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);gl_FragColor=color*(alpha*opacity*fade_opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "const float PI=3.141592653589793;attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec2 u_texsize_icon;varying vec4 v_data0;varying vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);float is_sdf=a_size[0]-2.0*a_size_min;float ele=get_elevation(a_pos);highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec4 projectedPoint=u_matrix*vec4(a_pos,ele,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=size/24.0;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=u_matrix*vec4(a_pos+vec2(1,0),ele,1);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,ele,1.0);float z=float(u_pitch_with_map)*projected_pos.z/projected_pos.w;gl_Position=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale),z,1.0);float gamma_scale=gl_Position.w;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float visibility=calculate_visibility(projectedPoint);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(visibility,fade_opacity[0]+fade_change));v_data0.xy=a_tex/u_texsize;v_data0.zw=a_tex/u_texsize_icon;v_data1=vec4(gamma_scale,size,interpolated_fade_opacity,is_sdf);}"),
            terrain: ne("uniform sampler2D u_texture;varying vec2 v_texture_pos;void main() {gl_FragColor=texture2D(u_texture,v_texture_pos);}", oe),
            terrainDepth: ne("varying float v_depth;const highp vec4 bitSh=vec4(256.*256.*256.,256.*256.,256.,1.);const highp vec4 bitMsk=vec4(0.,vec3(1./256.0));highp vec4 pack(highp float value) {highp vec4 comp=fract(value*bitSh);comp-=comp.xxyz*bitMsk;return comp;}void main() {gl_FragColor=pack(v_depth);}", oe),
            terrainCoords: ne("precision mediump float;uniform sampler2D u_texture;uniform float u_terrain_coords_id;varying vec2 v_texture_pos;void main() {vec4 rgba=texture2D(u_texture,v_texture_pos);gl_FragColor=vec4(rgba.r,rgba.g,rgba.b,u_terrain_coords_id);}", oe)
        };
        function ne(t, e) {
            const i = /#pragma mapbox: ([\w]+) ([\w]+) ([\w]+) ([\w]+)/g, s = e.match(/attribute ([\w]+) ([\w]+)/g), a = t.match(/uniform ([\w]+) ([\w]+)([\s]*)([\w]*)/g), o = e.match(/uniform ([\w]+) ([\w]+)([\s]*)([\w]*)/g), r = o ? o.concat(a) : a, n = {};
            return {
                fragmentSource: t = t.replace(i, (t, e, i, s, a)=>(n[a] = !0, "define" === e ? `\n#ifndef HAS_UNIFORM_u_${a}\nvarying ${i} ${s} ${a};\n#else\nuniform ${i} ${s} u_${a};\n#endif\n` : `\n#ifdef HAS_UNIFORM_u_${a}\n    ${i} ${s} ${a} = u_${a};\n#endif\n`)),
                vertexSource: e = e.replace(i, (t, e, i, s, a)=>{
                    const o = "float" === s ? "vec2" : "vec4", r = a.match(/color/) ? "color" : o;
                    return n[a] ? "define" === e ? `\n#ifndef HAS_UNIFORM_u_${a}\nuniform lowp float u_${a}_t;\nattribute ${i} ${o} a_${a};\nvarying ${i} ${s} ${a};\n#else\nuniform ${i} ${s} u_${a};\n#endif\n` : "vec4" === r ? `\n#ifndef HAS_UNIFORM_u_${a}\n    ${a} = a_${a};\n#else\n    ${i} ${s} ${a} = u_${a};\n#endif\n` : `\n#ifndef HAS_UNIFORM_u_${a}\n    ${a} = unpack_mix_${r}(a_${a}, u_${a}_t);\n#else\n    ${i} ${s} ${a} = u_${a};\n#endif\n` : "define" === e ? `\n#ifndef HAS_UNIFORM_u_${a}\nuniform lowp float u_${a}_t;\nattribute ${i} ${o} a_${a};\n#else\nuniform ${i} ${s} u_${a};\n#endif\n` : "vec4" === r ? `\n#ifndef HAS_UNIFORM_u_${a}\n    ${i} ${s} ${a} = a_${a};\n#else\n    ${i} ${s} ${a} = u_${a};\n#endif\n` : `\n#ifndef HAS_UNIFORM_u_${a}\n    ${i} ${s} ${a} = unpack_mix_${r}(a_${a}, u_${a}_t);\n#else\n    ${i} ${s} ${a} = u_${a};\n#endif\n`;
                }),
                staticAttributes: s,
                staticUniforms: r
            };
        }
        class le {
            constructor(){
                this.boundProgram = null, this.boundLayoutVertexBuffer = null, this.boundPaintVertexBuffers = [], this.boundIndexBuffer = null, this.boundVertexOffset = null, this.boundDynamicVertexBuffer = null, this.vao = null;
            }
            bind(t, e, i, s, a, o, r, n, l) {
                this.context = t;
                let h = this.boundPaintVertexBuffers.length !== s.length;
                for(let t = 0; !h && t < s.length; t++)this.boundPaintVertexBuffers[t] !== s[t] && (h = !0);
                !this.vao || this.boundProgram !== e || this.boundLayoutVertexBuffer !== i || h || this.boundIndexBuffer !== a || this.boundVertexOffset !== o || this.boundDynamicVertexBuffer !== r || this.boundDynamicVertexBuffer2 !== n || this.boundDynamicVertexBuffer3 !== l ? this.freshBind(e, i, s, a, o, r, n, l) : (t.bindVertexArray.set(this.vao), r && r.bind(), a && a.dynamicDraw && a.bind(), n && n.bind(), l && l.bind());
            }
            freshBind(t, e, i, s, a, o, r, n) {
                const l = t.numAttributes, h = this.context, c = h.gl;
                this.vao && this.destroy(), this.vao = h.createVertexArray(), h.bindVertexArray.set(this.vao), this.boundProgram = t, this.boundLayoutVertexBuffer = e, this.boundPaintVertexBuffers = i, this.boundIndexBuffer = s, this.boundVertexOffset = a, this.boundDynamicVertexBuffer = o, this.boundDynamicVertexBuffer2 = r, this.boundDynamicVertexBuffer3 = n, e.enableAttributes(c, t);
                for (const e of i)e.enableAttributes(c, t);
                o && o.enableAttributes(c, t), r && r.enableAttributes(c, t), n && n.enableAttributes(c, t), e.bind(), e.setVertexAttribPointers(c, t, a);
                for (const e of i)e.bind(), e.setVertexAttribPointers(c, t, a);
                o && (o.bind(), o.setVertexAttribPointers(c, t, a)), s && s.bind(), r && (r.bind(), r.setVertexAttribPointers(c, t, a)), n && (n.bind(), n.setVertexAttribPointers(c, t, a)), h.currentNumAttributes = l;
            }
            destroy() {
                this.vao && (this.context.deleteVertexArray(this.vao), this.vao = null);
            }
        }
        function he(t) {
            const e = [];
            for(let i = 0; i < t.length; i++){
                if (null === t[i]) continue;
                const s = t[i].split(" ");
                e.push(s.pop());
            }
            return e;
        }
        class ce {
            constructor(e, i, s, a, o, r){
                const n = e.gl;
                this.program = n.createProgram();
                const l = he(i.staticAttributes), h = s ? s.getBinderAttributes() : [], c = l.concat(h), u = re.prelude.staticUniforms ? he(re.prelude.staticUniforms) : [], d = i.staticUniforms ? he(i.staticUniforms) : [], _ = s ? s.getBinderUniforms() : [], p = u.concat(d).concat(_), m = [];
                for (const t of p)m.indexOf(t) < 0 && m.push(t);
                const f = s ? s.defines() : [];
                o && f.push("#define OVERDRAW_INSPECTOR;"), r && f.push("#define TERRAIN3D;");
                const g = f.concat(re.prelude.fragmentSource, i.fragmentSource).join("\n"), v = f.concat(re.prelude.vertexSource, i.vertexSource).join("\n"), x = n.createShader(n.FRAGMENT_SHADER);
                if (n.isContextLost()) return void (this.failedToCreate = !0);
                if (n.shaderSource(x, g), n.compileShader(x), !n.getShaderParameter(x, n.COMPILE_STATUS)) throw new Error(`Could not compile fragment shader: ${n.getShaderInfoLog(x)}`);
                n.attachShader(this.program, x);
                const y = n.createShader(n.VERTEX_SHADER);
                if (n.isContextLost()) return void (this.failedToCreate = !0);
                if (n.shaderSource(y, v), n.compileShader(y), !n.getShaderParameter(y, n.COMPILE_STATUS)) throw new Error(`Could not compile vertex shader: ${n.getShaderInfoLog(y)}`);
                n.attachShader(this.program, y), this.attributes = {};
                const b = {};
                this.numAttributes = c.length;
                for(let t = 0; t < this.numAttributes; t++)c[t] && (n.bindAttribLocation(this.program, t, c[t]), this.attributes[c[t]] = t);
                if (n.linkProgram(this.program), !n.getProgramParameter(this.program, n.LINK_STATUS)) throw new Error(`Program failed to link: ${n.getProgramInfoLog(this.program)}`);
                n.deleteShader(y), n.deleteShader(x);
                for(let t = 0; t < m.length; t++){
                    const e = m[t];
                    if (e && !b[e]) {
                        const t = n.getUniformLocation(this.program, e);
                        t && (b[e] = t);
                    }
                }
                this.fixedUniforms = a(e, b), this.terrainUniforms = ((e, i)=>({
                        u_depth: new t.aL(e, i.u_depth),
                        u_terrain: new t.aL(e, i.u_terrain),
                        u_terrain_dim: new t.aM(e, i.u_terrain_dim),
                        u_terrain_matrix: new t.aN(e, i.u_terrain_matrix),
                        u_terrain_unpack: new t.aO(e, i.u_terrain_unpack),
                        u_terrain_exaggeration: new t.aM(e, i.u_terrain_exaggeration)
                    }))(e, b), this.binderUniforms = s ? s.getUniforms(e, b) : [];
            }
            draw(t, e, i, s, a, o, r, n, l, h, c, u, d, _, p, m, f, g) {
                const v = t.gl;
                if (this.failedToCreate) return;
                if (t.program.set(this.program), t.setDepthMode(i), t.setStencilMode(s), t.setColorMode(a), t.setCullFace(o), n) {
                    t.activeTexture.set(v.TEXTURE2), v.bindTexture(v.TEXTURE_2D, n.depthTexture), t.activeTexture.set(v.TEXTURE3), v.bindTexture(v.TEXTURE_2D, n.texture);
                    for(const t in this.terrainUniforms)this.terrainUniforms[t].set(n[t]);
                }
                for(const t in this.fixedUniforms)this.fixedUniforms[t].set(r[t]);
                p && p.setUniforms(t, this.binderUniforms, d, {
                    zoom: _
                });
                let x = 0;
                switch(e){
                    case v.LINES:
                        x = 2;
                        break;
                    case v.TRIANGLES:
                        x = 3;
                        break;
                    case v.LINE_STRIP:
                        x = 1;
                }
                for (const i of u.get()){
                    const s = i.vaos || (i.vaos = {});
                    (s[l] || (s[l] = new le)).bind(t, this, h, p ? p.getPaintVertexBuffers() : [], c, i.vertexOffset, m, f, g), v.drawElements(e, i.primitiveLength * x, v.UNSIGNED_SHORT, i.primitiveOffset * x * 2);
                }
            }
        }
        function ue(t, e, i) {
            const s = 1 / St(i, 1, e.transform.tileZoom), a = Math.pow(2, i.tileID.overscaledZ), o = i.tileSize * Math.pow(2, e.transform.tileZoom) / a, r = o * (i.tileID.canonical.x + i.tileID.wrap * a), n = o * i.tileID.canonical.y;
            return {
                u_image: 0,
                u_texsize: i.imageAtlasTexture.size,
                u_scale: [
                    s,
                    t.fromScale,
                    t.toScale
                ],
                u_fade: t.t,
                u_pixel_coord_upper: [
                    r >> 16,
                    n >> 16
                ],
                u_pixel_coord_lower: [
                    65535 & r,
                    65535 & n
                ]
            };
        }
        const de = (e, i, s, a)=>{
            const o = i.style.light, r = o.properties.get("position"), n = [
                r.x,
                r.y,
                r.z
            ], l = function() {
                var e = new t.A(9);
                return t.A != Float32Array && (e[1] = 0, e[2] = 0, e[3] = 0, e[5] = 0, e[6] = 0, e[7] = 0), e[0] = 1, e[4] = 1, e[8] = 1, e;
            }();
            "viewport" === o.properties.get("anchor") && function(t, e) {
                var i = Math.sin(e), s = Math.cos(e);
                t[0] = s, t[1] = i, t[2] = 0, t[3] = -i, t[4] = s, t[5] = 0, t[6] = 0, t[7] = 0, t[8] = 1;
            }(l, -i.transform.angle), function(t, e, i) {
                var s = e[0], a = e[1], o = e[2];
                t[0] = s * i[0] + a * i[3] + o * i[6], t[1] = s * i[1] + a * i[4] + o * i[7], t[2] = s * i[2] + a * i[5] + o * i[8];
            }(n, n, l);
            const h = o.properties.get("color");
            return {
                u_matrix: e,
                u_lightpos: n,
                u_lightintensity: o.properties.get("intensity"),
                u_lightcolor: [
                    h.r,
                    h.g,
                    h.b
                ],
                u_vertical_gradient: +s,
                u_opacity: a
            };
        }, _e = (e, i, s, a, o, r, n)=>t.e(de(e, i, s, a), ue(r, i, n), {
                u_height_factor: -Math.pow(2, o.overscaledZ) / n.tileSize / 8
            }), pe = (t)=>({
                u_matrix: t
            }), me = (e, i, s, a)=>t.e(pe(e), ue(s, i, a)), fe = (t, e)=>({
                u_matrix: t,
                u_world: e
            }), ge = (e, i, s, a, o)=>t.e(me(e, i, s, a), {
                u_world: o
            }), ve = (t, e, i, s)=>{
            const a = t.transform;
            let o, r;
            if ("map" === s.paint.get("circle-pitch-alignment")) {
                const t = St(i, 1, a.zoom);
                o = !0, r = [
                    t,
                    t
                ];
            } else o = !1, r = a.pixelsToGLUnits;
            return {
                u_camera_to_center_distance: a.cameraToCenterDistance,
                u_scale_with_map: +("map" === s.paint.get("circle-pitch-scale")),
                u_matrix: t.translatePosMatrix(e.posMatrix, i, s.paint.get("circle-translate"), s.paint.get("circle-translate-anchor")),
                u_pitch_with_map: +o,
                u_device_pixel_ratio: t.pixelRatio,
                u_extrude_scale: r
            };
        }, xe = (t, e, i)=>{
            const s = St(i, 1, e.zoom), a = Math.pow(2, e.zoom - i.tileID.overscaledZ), o = i.tileID.overscaleFactor();
            return {
                u_matrix: t,
                u_camera_to_center_distance: e.cameraToCenterDistance,
                u_pixels_to_tile_units: s,
                u_extrude_scale: [
                    e.pixelsToGLUnits[0] / (s * a),
                    e.pixelsToGLUnits[1] / (s * a)
                ],
                u_overscale_factor: o
            };
        }, ye = (t, e, i = 1)=>({
                u_matrix: t,
                u_color: e,
                u_overlay: 0,
                u_overlay_scale: i
            }), be = (t)=>({
                u_matrix: t
            }), we = (t, e, i, s)=>({
                u_matrix: t,
                u_extrude_scale: St(e, 1, i),
                u_intensity: s
            });
        function Te(e, i) {
            const s = Math.pow(2, i.canonical.z), a = i.canonical.y;
            return [
                new t.U(0, a / s).toLngLat().lat,
                new t.U(0, (a + 1) / s).toLngLat().lat
            ];
        }
        const Ie = (t, e, i, s)=>{
            const a = t.transform;
            return {
                u_matrix: De(t, e, i, s),
                u_ratio: 1 / St(e, 1, a.zoom),
                u_device_pixel_ratio: t.pixelRatio,
                u_units_to_pixels: [
                    1 / a.pixelsToGLUnits[0],
                    1 / a.pixelsToGLUnits[1]
                ]
            };
        }, Ee = (e, i, s, a, o)=>t.e(Ie(e, i, s, o), {
                u_image: 0,
                u_image_height: a
            }), Se = (t, e, i, s, a)=>{
            const o = t.transform, r = Pe(e, o);
            return {
                u_matrix: De(t, e, i, a),
                u_texsize: e.imageAtlasTexture.size,
                u_ratio: 1 / St(e, 1, o.zoom),
                u_device_pixel_ratio: t.pixelRatio,
                u_image: 0,
                u_scale: [
                    r,
                    s.fromScale,
                    s.toScale
                ],
                u_fade: s.t,
                u_units_to_pixels: [
                    1 / o.pixelsToGLUnits[0],
                    1 / o.pixelsToGLUnits[1]
                ]
            };
        }, Ce = (e, i, s, a, o, r)=>{
            const n = e.lineAtlas, l = Pe(i, e.transform), h = "round" === s.layout.get("line-cap"), c = n.getDash(a.from, h), u = n.getDash(a.to, h), d = c.width * o.fromScale, _ = u.width * o.toScale;
            return t.e(Ie(e, i, s, r), {
                u_patternscale_a: [
                    l / d,
                    -c.height / 2
                ],
                u_patternscale_b: [
                    l / _,
                    -u.height / 2
                ],
                u_sdfgamma: n.width / (256 * Math.min(d, _) * e.pixelRatio) / 2,
                u_image: 0,
                u_tex_y_a: c.y,
                u_tex_y_b: u.y,
                u_mix: o.t
            });
        };
        function Pe(t, e) {
            return 1 / St(t, 1, e.tileZoom);
        }
        function De(t, e, i, s) {
            return t.translatePosMatrix(s ? s.posMatrix : e.tileID.posMatrix, e, i.paint.get("line-translate"), i.paint.get("line-translate-anchor"));
        }
        const Me = (t, e, i, s, a)=>{
            var o, r;
            return {
                u_matrix: t,
                u_tl_parent: e,
                u_scale_parent: i,
                u_buffer_scale: 1,
                u_fade_t: s.mix,
                u_opacity: s.opacity * a.paint.get("raster-opacity"),
                u_image0: 0,
                u_image1: 1,
                u_brightness_low: a.paint.get("raster-brightness-min"),
                u_brightness_high: a.paint.get("raster-brightness-max"),
                u_saturation_factor: (r = a.paint.get("raster-saturation"), r > 0 ? 1 - 1 / (1.001 - r) : -r),
                u_contrast_factor: (o = a.paint.get("raster-contrast"), o > 0 ? 1 / (1 - o) : 1 + o),
                u_spin_weights: ze(a.paint.get("raster-hue-rotate"))
            };
        };
        function ze(t) {
            t *= Math.PI / 180;
            const e = Math.sin(t), i = Math.cos(t);
            return [
                (2 * i + 1) / 3,
                (-Math.sqrt(3) * e - i + 1) / 3,
                (Math.sqrt(3) * e - i + 1) / 3
            ];
        }
        const Le = (t, e, i, s, a, o, r, n, l, h)=>{
            const c = a.transform;
            return {
                u_is_size_zoom_constant: +("constant" === t || "source" === t),
                u_is_size_feature_constant: +("constant" === t || "camera" === t),
                u_size_t: e ? e.uSizeT : 0,
                u_size: e ? e.uSize : 0,
                u_camera_to_center_distance: c.cameraToCenterDistance,
                u_pitch: c.pitch / 360 * 2 * Math.PI,
                u_rotate_symbol: +i,
                u_aspect_ratio: c.width / c.height,
                u_fade_change: a.options.fadeDuration ? a.symbolFadeChange : 1,
                u_matrix: o,
                u_label_plane_matrix: r,
                u_coord_matrix: n,
                u_is_text: +l,
                u_pitch_with_map: +s,
                u_texsize: h,
                u_texture: 0
            };
        }, Ae = (e, i, s, a, o, r, n, l, h, c, u)=>{
            const d = o.transform;
            return t.e(Le(e, i, s, a, o, r, n, l, h, c), {
                u_gamma_scale: a ? Math.cos(d._pitch) * d.cameraToCenterDistance : 1,
                u_device_pixel_ratio: o.pixelRatio,
                u_is_halo: +u
            });
        }, Re = (e, i, s, a, o, r, n, l, h, c)=>t.e(Ae(e, i, s, a, o, r, n, l, !0, h, !0), {
                u_texsize_icon: c,
                u_texture_icon: 1
            }), ke = (t, e, i)=>({
                u_matrix: t,
                u_opacity: e,
                u_color: i
            }), Fe = (e, i, s, a, o, r)=>t.e(function(t, e, i, s) {
                const a = i.imageManager.getPattern(t.from.toString()), o = i.imageManager.getPattern(t.to.toString()), { width: r, height: n } = i.imageManager.getPixelSize(), l = Math.pow(2, s.tileID.overscaledZ), h = s.tileSize * Math.pow(2, i.transform.tileZoom) / l, c = h * (s.tileID.canonical.x + s.tileID.wrap * l), u = h * s.tileID.canonical.y;
                return {
                    u_image: 0,
                    u_pattern_tl_a: a.tl,
                    u_pattern_br_a: a.br,
                    u_pattern_tl_b: o.tl,
                    u_pattern_br_b: o.br,
                    u_texsize: [
                        r,
                        n
                    ],
                    u_mix: e.t,
                    u_pattern_size_a: a.displaySize,
                    u_pattern_size_b: o.displaySize,
                    u_scale_a: e.fromScale,
                    u_scale_b: e.toScale,
                    u_tile_units_to_pixels: 1 / St(s, 1, i.transform.tileZoom),
                    u_pixel_coord_upper: [
                        c >> 16,
                        u >> 16
                    ],
                    u_pixel_coord_lower: [
                        65535 & c,
                        65535 & u
                    ]
                };
            }(a, r, s, o), {
                u_matrix: e,
                u_opacity: i
            }), Be = {
            fillExtrusion: (e, i)=>({
                    u_matrix: new t.aN(e, i.u_matrix),
                    u_lightpos: new t.aP(e, i.u_lightpos),
                    u_lightintensity: new t.aM(e, i.u_lightintensity),
                    u_lightcolor: new t.aP(e, i.u_lightcolor),
                    u_vertical_gradient: new t.aM(e, i.u_vertical_gradient),
                    u_opacity: new t.aM(e, i.u_opacity)
                }),
            fillExtrusionPattern: (e, i)=>({
                    u_matrix: new t.aN(e, i.u_matrix),
                    u_lightpos: new t.aP(e, i.u_lightpos),
                    u_lightintensity: new t.aM(e, i.u_lightintensity),
                    u_lightcolor: new t.aP(e, i.u_lightcolor),
                    u_vertical_gradient: new t.aM(e, i.u_vertical_gradient),
                    u_height_factor: new t.aM(e, i.u_height_factor),
                    u_image: new t.aL(e, i.u_image),
                    u_texsize: new t.aQ(e, i.u_texsize),
                    u_pixel_coord_upper: new t.aQ(e, i.u_pixel_coord_upper),
                    u_pixel_coord_lower: new t.aQ(e, i.u_pixel_coord_lower),
                    u_scale: new t.aP(e, i.u_scale),
                    u_fade: new t.aM(e, i.u_fade),
                    u_opacity: new t.aM(e, i.u_opacity)
                }),
            fill: (e, i)=>({
                    u_matrix: new t.aN(e, i.u_matrix)
                }),
            fillPattern: (e, i)=>({
                    u_matrix: new t.aN(e, i.u_matrix),
                    u_image: new t.aL(e, i.u_image),
                    u_texsize: new t.aQ(e, i.u_texsize),
                    u_pixel_coord_upper: new t.aQ(e, i.u_pixel_coord_upper),
                    u_pixel_coord_lower: new t.aQ(e, i.u_pixel_coord_lower),
                    u_scale: new t.aP(e, i.u_scale),
                    u_fade: new t.aM(e, i.u_fade)
                }),
            fillOutline: (e, i)=>({
                    u_matrix: new t.aN(e, i.u_matrix),
                    u_world: new t.aQ(e, i.u_world)
                }),
            fillOutlinePattern: (e, i)=>({
                    u_matrix: new t.aN(e, i.u_matrix),
                    u_world: new t.aQ(e, i.u_world),
                    u_image: new t.aL(e, i.u_image),
                    u_texsize: new t.aQ(e, i.u_texsize),
                    u_pixel_coord_upper: new t.aQ(e, i.u_pixel_coord_upper),
                    u_pixel_coord_lower: new t.aQ(e, i.u_pixel_coord_lower),
                    u_scale: new t.aP(e, i.u_scale),
                    u_fade: new t.aM(e, i.u_fade)
                }),
            circle: (e, i)=>({
                    u_camera_to_center_distance: new t.aM(e, i.u_camera_to_center_distance),
                    u_scale_with_map: new t.aL(e, i.u_scale_with_map),
                    u_pitch_with_map: new t.aL(e, i.u_pitch_with_map),
                    u_extrude_scale: new t.aQ(e, i.u_extrude_scale),
                    u_device_pixel_ratio: new t.aM(e, i.u_device_pixel_ratio),
                    u_matrix: new t.aN(e, i.u_matrix)
                }),
            collisionBox: (e, i)=>({
                    u_matrix: new t.aN(e, i.u_matrix),
                    u_camera_to_center_distance: new t.aM(e, i.u_camera_to_center_distance),
                    u_pixels_to_tile_units: new t.aM(e, i.u_pixels_to_tile_units),
                    u_extrude_scale: new t.aQ(e, i.u_extrude_scale),
                    u_overscale_factor: new t.aM(e, i.u_overscale_factor)
                }),
            collisionCircle: (e, i)=>({
                    u_matrix: new t.aN(e, i.u_matrix),
                    u_inv_matrix: new t.aN(e, i.u_inv_matrix),
                    u_camera_to_center_distance: new t.aM(e, i.u_camera_to_center_distance),
                    u_viewport_size: new t.aQ(e, i.u_viewport_size)
                }),
            debug: (e, i)=>({
                    u_color: new t.aR(e, i.u_color),
                    u_matrix: new t.aN(e, i.u_matrix),
                    u_overlay: new t.aL(e, i.u_overlay),
                    u_overlay_scale: new t.aM(e, i.u_overlay_scale)
                }),
            clippingMask: (e, i)=>({
                    u_matrix: new t.aN(e, i.u_matrix)
                }),
            heatmap: (e, i)=>({
                    u_extrude_scale: new t.aM(e, i.u_extrude_scale),
                    u_intensity: new t.aM(e, i.u_intensity),
                    u_matrix: new t.aN(e, i.u_matrix)
                }),
            heatmapTexture: (e, i)=>({
                    u_matrix: new t.aN(e, i.u_matrix),
                    u_world: new t.aQ(e, i.u_world),
                    u_image: new t.aL(e, i.u_image),
                    u_color_ramp: new t.aL(e, i.u_color_ramp),
                    u_opacity: new t.aM(e, i.u_opacity)
                }),
            hillshade: (e, i)=>({
                    u_matrix: new t.aN(e, i.u_matrix),
                    u_image: new t.aL(e, i.u_image),
                    u_latrange: new t.aQ(e, i.u_latrange),
                    u_light: new t.aQ(e, i.u_light),
                    u_shadow: new t.aR(e, i.u_shadow),
                    u_highlight: new t.aR(e, i.u_highlight),
                    u_accent: new t.aR(e, i.u_accent)
                }),
            hillshadePrepare: (e, i)=>({
                    u_matrix: new t.aN(e, i.u_matrix),
                    u_image: new t.aL(e, i.u_image),
                    u_dimension: new t.aQ(e, i.u_dimension),
                    u_zoom: new t.aM(e, i.u_zoom),
                    u_unpack: new t.aO(e, i.u_unpack)
                }),
            line: (e, i)=>({
                    u_matrix: new t.aN(e, i.u_matrix),
                    u_ratio: new t.aM(e, i.u_ratio),
                    u_device_pixel_ratio: new t.aM(e, i.u_device_pixel_ratio),
                    u_units_to_pixels: new t.aQ(e, i.u_units_to_pixels)
                }),
            lineGradient: (e, i)=>({
                    u_matrix: new t.aN(e, i.u_matrix),
                    u_ratio: new t.aM(e, i.u_ratio),
                    u_device_pixel_ratio: new t.aM(e, i.u_device_pixel_ratio),
                    u_units_to_pixels: new t.aQ(e, i.u_units_to_pixels),
                    u_image: new t.aL(e, i.u_image),
                    u_image_height: new t.aM(e, i.u_image_height)
                }),
            linePattern: (e, i)=>({
                    u_matrix: new t.aN(e, i.u_matrix),
                    u_texsize: new t.aQ(e, i.u_texsize),
                    u_ratio: new t.aM(e, i.u_ratio),
                    u_device_pixel_ratio: new t.aM(e, i.u_device_pixel_ratio),
                    u_image: new t.aL(e, i.u_image),
                    u_units_to_pixels: new t.aQ(e, i.u_units_to_pixels),
                    u_scale: new t.aP(e, i.u_scale),
                    u_fade: new t.aM(e, i.u_fade)
                }),
            lineSDF: (e, i)=>({
                    u_matrix: new t.aN(e, i.u_matrix),
                    u_ratio: new t.aM(e, i.u_ratio),
                    u_device_pixel_ratio: new t.aM(e, i.u_device_pixel_ratio),
                    u_units_to_pixels: new t.aQ(e, i.u_units_to_pixels),
                    u_patternscale_a: new t.aQ(e, i.u_patternscale_a),
                    u_patternscale_b: new t.aQ(e, i.u_patternscale_b),
                    u_sdfgamma: new t.aM(e, i.u_sdfgamma),
                    u_image: new t.aL(e, i.u_image),
                    u_tex_y_a: new t.aM(e, i.u_tex_y_a),
                    u_tex_y_b: new t.aM(e, i.u_tex_y_b),
                    u_mix: new t.aM(e, i.u_mix)
                }),
            raster: (e, i)=>({
                    u_matrix: new t.aN(e, i.u_matrix),
                    u_tl_parent: new t.aQ(e, i.u_tl_parent),
                    u_scale_parent: new t.aM(e, i.u_scale_parent),
                    u_buffer_scale: new t.aM(e, i.u_buffer_scale),
                    u_fade_t: new t.aM(e, i.u_fade_t),
                    u_opacity: new t.aM(e, i.u_opacity),
                    u_image0: new t.aL(e, i.u_image0),
                    u_image1: new t.aL(e, i.u_image1),
                    u_brightness_low: new t.aM(e, i.u_brightness_low),
                    u_brightness_high: new t.aM(e, i.u_brightness_high),
                    u_saturation_factor: new t.aM(e, i.u_saturation_factor),
                    u_contrast_factor: new t.aM(e, i.u_contrast_factor),
                    u_spin_weights: new t.aP(e, i.u_spin_weights)
                }),
            symbolIcon: (e, i)=>({
                    u_is_size_zoom_constant: new t.aL(e, i.u_is_size_zoom_constant),
                    u_is_size_feature_constant: new t.aL(e, i.u_is_size_feature_constant),
                    u_size_t: new t.aM(e, i.u_size_t),
                    u_size: new t.aM(e, i.u_size),
                    u_camera_to_center_distance: new t.aM(e, i.u_camera_to_center_distance),
                    u_pitch: new t.aM(e, i.u_pitch),
                    u_rotate_symbol: new t.aL(e, i.u_rotate_symbol),
                    u_aspect_ratio: new t.aM(e, i.u_aspect_ratio),
                    u_fade_change: new t.aM(e, i.u_fade_change),
                    u_matrix: new t.aN(e, i.u_matrix),
                    u_label_plane_matrix: new t.aN(e, i.u_label_plane_matrix),
                    u_coord_matrix: new t.aN(e, i.u_coord_matrix),
                    u_is_text: new t.aL(e, i.u_is_text),
                    u_pitch_with_map: new t.aL(e, i.u_pitch_with_map),
                    u_texsize: new t.aQ(e, i.u_texsize),
                    u_texture: new t.aL(e, i.u_texture)
                }),
            symbolSDF: (e, i)=>({
                    u_is_size_zoom_constant: new t.aL(e, i.u_is_size_zoom_constant),
                    u_is_size_feature_constant: new t.aL(e, i.u_is_size_feature_constant),
                    u_size_t: new t.aM(e, i.u_size_t),
                    u_size: new t.aM(e, i.u_size),
                    u_camera_to_center_distance: new t.aM(e, i.u_camera_to_center_distance),
                    u_pitch: new t.aM(e, i.u_pitch),
                    u_rotate_symbol: new t.aL(e, i.u_rotate_symbol),
                    u_aspect_ratio: new t.aM(e, i.u_aspect_ratio),
                    u_fade_change: new t.aM(e, i.u_fade_change),
                    u_matrix: new t.aN(e, i.u_matrix),
                    u_label_plane_matrix: new t.aN(e, i.u_label_plane_matrix),
                    u_coord_matrix: new t.aN(e, i.u_coord_matrix),
                    u_is_text: new t.aL(e, i.u_is_text),
                    u_pitch_with_map: new t.aL(e, i.u_pitch_with_map),
                    u_texsize: new t.aQ(e, i.u_texsize),
                    u_texture: new t.aL(e, i.u_texture),
                    u_gamma_scale: new t.aM(e, i.u_gamma_scale),
                    u_device_pixel_ratio: new t.aM(e, i.u_device_pixel_ratio),
                    u_is_halo: new t.aL(e, i.u_is_halo)
                }),
            symbolTextAndIcon: (e, i)=>({
                    u_is_size_zoom_constant: new t.aL(e, i.u_is_size_zoom_constant),
                    u_is_size_feature_constant: new t.aL(e, i.u_is_size_feature_constant),
                    u_size_t: new t.aM(e, i.u_size_t),
                    u_size: new t.aM(e, i.u_size),
                    u_camera_to_center_distance: new t.aM(e, i.u_camera_to_center_distance),
                    u_pitch: new t.aM(e, i.u_pitch),
                    u_rotate_symbol: new t.aL(e, i.u_rotate_symbol),
                    u_aspect_ratio: new t.aM(e, i.u_aspect_ratio),
                    u_fade_change: new t.aM(e, i.u_fade_change),
                    u_matrix: new t.aN(e, i.u_matrix),
                    u_label_plane_matrix: new t.aN(e, i.u_label_plane_matrix),
                    u_coord_matrix: new t.aN(e, i.u_coord_matrix),
                    u_is_text: new t.aL(e, i.u_is_text),
                    u_pitch_with_map: new t.aL(e, i.u_pitch_with_map),
                    u_texsize: new t.aQ(e, i.u_texsize),
                    u_texsize_icon: new t.aQ(e, i.u_texsize_icon),
                    u_texture: new t.aL(e, i.u_texture),
                    u_texture_icon: new t.aL(e, i.u_texture_icon),
                    u_gamma_scale: new t.aM(e, i.u_gamma_scale),
                    u_device_pixel_ratio: new t.aM(e, i.u_device_pixel_ratio),
                    u_is_halo: new t.aL(e, i.u_is_halo)
                }),
            background: (e, i)=>({
                    u_matrix: new t.aN(e, i.u_matrix),
                    u_opacity: new t.aM(e, i.u_opacity),
                    u_color: new t.aR(e, i.u_color)
                }),
            backgroundPattern: (e, i)=>({
                    u_matrix: new t.aN(e, i.u_matrix),
                    u_opacity: new t.aM(e, i.u_opacity),
                    u_image: new t.aL(e, i.u_image),
                    u_pattern_tl_a: new t.aQ(e, i.u_pattern_tl_a),
                    u_pattern_br_a: new t.aQ(e, i.u_pattern_br_a),
                    u_pattern_tl_b: new t.aQ(e, i.u_pattern_tl_b),
                    u_pattern_br_b: new t.aQ(e, i.u_pattern_br_b),
                    u_texsize: new t.aQ(e, i.u_texsize),
                    u_mix: new t.aM(e, i.u_mix),
                    u_pattern_size_a: new t.aQ(e, i.u_pattern_size_a),
                    u_pattern_size_b: new t.aQ(e, i.u_pattern_size_b),
                    u_scale_a: new t.aM(e, i.u_scale_a),
                    u_scale_b: new t.aM(e, i.u_scale_b),
                    u_pixel_coord_upper: new t.aQ(e, i.u_pixel_coord_upper),
                    u_pixel_coord_lower: new t.aQ(e, i.u_pixel_coord_lower),
                    u_tile_units_to_pixels: new t.aM(e, i.u_tile_units_to_pixels)
                }),
            terrain: (e, i)=>({
                    u_matrix: new t.aN(e, i.u_matrix),
                    u_texture: new t.aL(e, i.u_texture),
                    u_ele_delta: new t.aM(e, i.u_ele_delta)
                }),
            terrainDepth: (e, i)=>({
                    u_matrix: new t.aN(e, i.u_matrix),
                    u_ele_delta: new t.aM(e, i.u_ele_delta)
                }),
            terrainCoords: (e, i)=>({
                    u_matrix: new t.aN(e, i.u_matrix),
                    u_texture: new t.aL(e, i.u_texture),
                    u_terrain_coords_id: new t.aM(e, i.u_terrain_coords_id),
                    u_ele_delta: new t.aM(e, i.u_ele_delta)
                })
        };
        class Oe {
            constructor(t, e, i){
                this.context = t;
                const s = t.gl;
                this.buffer = s.createBuffer(), this.dynamicDraw = Boolean(i), this.context.unbindVAO(), t.bindElementBuffer.set(this.buffer), s.bufferData(s.ELEMENT_ARRAY_BUFFER, e.arrayBuffer, this.dynamicDraw ? s.DYNAMIC_DRAW : s.STATIC_DRAW), this.dynamicDraw || delete e.arrayBuffer;
            }
            bind() {
                this.context.bindElementBuffer.set(this.buffer);
            }
            updateData(t) {
                const e = this.context.gl;
                if (!this.dynamicDraw) throw new Error("Attempted to update data while not in dynamic mode.");
                this.context.unbindVAO(), this.bind(), e.bufferSubData(e.ELEMENT_ARRAY_BUFFER, 0, t.arrayBuffer);
            }
            destroy() {
                this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
            }
        }
        const Ne = {
            Int8: "BYTE",
            Uint8: "UNSIGNED_BYTE",
            Int16: "SHORT",
            Uint16: "UNSIGNED_SHORT",
            Int32: "INT",
            Uint32: "UNSIGNED_INT",
            Float32: "FLOAT"
        };
        class Ue {
            constructor(t, e, i, s){
                this.length = e.length, this.attributes = i, this.itemSize = e.bytesPerElement, this.dynamicDraw = s, this.context = t;
                const a = t.gl;
                this.buffer = a.createBuffer(), t.bindVertexBuffer.set(this.buffer), a.bufferData(a.ARRAY_BUFFER, e.arrayBuffer, this.dynamicDraw ? a.DYNAMIC_DRAW : a.STATIC_DRAW), this.dynamicDraw || delete e.arrayBuffer;
            }
            bind() {
                this.context.bindVertexBuffer.set(this.buffer);
            }
            updateData(t) {
                if (t.length !== this.length) throw new Error(`Length of new data is ${t.length}, which doesn't match current length of ${this.length}`);
                const e = this.context.gl;
                this.bind(), e.bufferSubData(e.ARRAY_BUFFER, 0, t.arrayBuffer);
            }
            enableAttributes(t, e) {
                for(let i = 0; i < this.attributes.length; i++){
                    const s = e.attributes[this.attributes[i].name];
                    void 0 !== s && t.enableVertexAttribArray(s);
                }
            }
            setVertexAttribPointers(t, e, i) {
                for(let s = 0; s < this.attributes.length; s++){
                    const a = this.attributes[s], o = e.attributes[a.name];
                    void 0 !== o && t.vertexAttribPointer(o, a.components, t[Ne[a.type]], !1, this.itemSize, a.offset + this.itemSize * (i || 0));
                }
            }
            destroy() {
                this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
            }
        }
        const Ze = new WeakMap;
        function Ge(t) {
            var e;
            if (Ze.has(t)) return Ze.get(t);
            {
                const i = null === (e = t.getParameter(t.VERSION)) || void 0 === e ? void 0 : e.startsWith("WebGL 2.0");
                return Ze.set(t, i), i;
            }
        }
        class je {
            constructor(t){
                this.gl = t.gl, this.default = this.getDefault(), this.current = this.default, this.dirty = !1;
            }
            get() {
                return this.current;
            }
            set(t) {}
            getDefault() {
                return this.default;
            }
            setDefault() {
                this.set(this.default);
            }
        }
        class Ve extends je {
            getDefault() {
                return t.aT.transparent;
            }
            set(t) {
                const e = this.current;
                (t.r !== e.r || t.g !== e.g || t.b !== e.b || t.a !== e.a || this.dirty) && (this.gl.clearColor(t.r, t.g, t.b, t.a), this.current = t, this.dirty = !1);
            }
        }
        class qe extends je {
            getDefault() {
                return 1;
            }
            set(t) {
                (t !== this.current || this.dirty) && (this.gl.clearDepth(t), this.current = t, this.dirty = !1);
            }
        }
        class $e extends je {
            getDefault() {
                return 0;
            }
            set(t) {
                (t !== this.current || this.dirty) && (this.gl.clearStencil(t), this.current = t, this.dirty = !1);
            }
        }
        class We extends je {
            getDefault() {
                return [
                    !0,
                    !0,
                    !0,
                    !0
                ];
            }
            set(t) {
                const e = this.current;
                (t[0] !== e[0] || t[1] !== e[1] || t[2] !== e[2] || t[3] !== e[3] || this.dirty) && (this.gl.colorMask(t[0], t[1], t[2], t[3]), this.current = t, this.dirty = !1);
            }
        }
        class He extends je {
            getDefault() {
                return !0;
            }
            set(t) {
                (t !== this.current || this.dirty) && (this.gl.depthMask(t), this.current = t, this.dirty = !1);
            }
        }
        class Xe extends je {
            getDefault() {
                return 255;
            }
            set(t) {
                (t !== this.current || this.dirty) && (this.gl.stencilMask(t), this.current = t, this.dirty = !1);
            }
        }
        class Ke extends je {
            getDefault() {
                return {
                    func: this.gl.ALWAYS,
                    ref: 0,
                    mask: 255
                };
            }
            set(t) {
                const e = this.current;
                (t.func !== e.func || t.ref !== e.ref || t.mask !== e.mask || this.dirty) && (this.gl.stencilFunc(t.func, t.ref, t.mask), this.current = t, this.dirty = !1);
            }
        }
        class Qe extends je {
            getDefault() {
                const t = this.gl;
                return [
                    t.KEEP,
                    t.KEEP,
                    t.KEEP
                ];
            }
            set(t) {
                const e = this.current;
                (t[0] !== e[0] || t[1] !== e[1] || t[2] !== e[2] || this.dirty) && (this.gl.stencilOp(t[0], t[1], t[2]), this.current = t, this.dirty = !1);
            }
        }
        class Ye extends je {
            getDefault() {
                return !1;
            }
            set(t) {
                if (t === this.current && !this.dirty) return;
                const e = this.gl;
                t ? e.enable(e.STENCIL_TEST) : e.disable(e.STENCIL_TEST), this.current = t, this.dirty = !1;
            }
        }
        class Je extends je {
            getDefault() {
                return [
                    0,
                    1
                ];
            }
            set(t) {
                const e = this.current;
                (t[0] !== e[0] || t[1] !== e[1] || this.dirty) && (this.gl.depthRange(t[0], t[1]), this.current = t, this.dirty = !1);
            }
        }
        class ti extends je {
            getDefault() {
                return !1;
            }
            set(t) {
                if (t === this.current && !this.dirty) return;
                const e = this.gl;
                t ? e.enable(e.DEPTH_TEST) : e.disable(e.DEPTH_TEST), this.current = t, this.dirty = !1;
            }
        }
        class ei extends je {
            getDefault() {
                return this.gl.LESS;
            }
            set(t) {
                (t !== this.current || this.dirty) && (this.gl.depthFunc(t), this.current = t, this.dirty = !1);
            }
        }
        class ii extends je {
            getDefault() {
                return !1;
            }
            set(t) {
                if (t === this.current && !this.dirty) return;
                const e = this.gl;
                t ? e.enable(e.BLEND) : e.disable(e.BLEND), this.current = t, this.dirty = !1;
            }
        }
        class si extends je {
            getDefault() {
                const t = this.gl;
                return [
                    t.ONE,
                    t.ZERO
                ];
            }
            set(t) {
                const e = this.current;
                (t[0] !== e[0] || t[1] !== e[1] || this.dirty) && (this.gl.blendFunc(t[0], t[1]), this.current = t, this.dirty = !1);
            }
        }
        class ai extends je {
            getDefault() {
                return t.aT.transparent;
            }
            set(t) {
                const e = this.current;
                (t.r !== e.r || t.g !== e.g || t.b !== e.b || t.a !== e.a || this.dirty) && (this.gl.blendColor(t.r, t.g, t.b, t.a), this.current = t, this.dirty = !1);
            }
        }
        class oi extends je {
            getDefault() {
                return this.gl.FUNC_ADD;
            }
            set(t) {
                (t !== this.current || this.dirty) && (this.gl.blendEquation(t), this.current = t, this.dirty = !1);
            }
        }
        class ri extends je {
            getDefault() {
                return !1;
            }
            set(t) {
                if (t === this.current && !this.dirty) return;
                const e = this.gl;
                t ? e.enable(e.CULL_FACE) : e.disable(e.CULL_FACE), this.current = t, this.dirty = !1;
            }
        }
        class ni extends je {
            getDefault() {
                return this.gl.BACK;
            }
            set(t) {
                (t !== this.current || this.dirty) && (this.gl.cullFace(t), this.current = t, this.dirty = !1);
            }
        }
        class li extends je {
            getDefault() {
                return this.gl.CCW;
            }
            set(t) {
                (t !== this.current || this.dirty) && (this.gl.frontFace(t), this.current = t, this.dirty = !1);
            }
        }
        class hi extends je {
            getDefault() {
                return null;
            }
            set(t) {
                (t !== this.current || this.dirty) && (this.gl.useProgram(t), this.current = t, this.dirty = !1);
            }
        }
        class ci extends je {
            getDefault() {
                return this.gl.TEXTURE0;
            }
            set(t) {
                (t !== this.current || this.dirty) && (this.gl.activeTexture(t), this.current = t, this.dirty = !1);
            }
        }
        class ui extends je {
            getDefault() {
                const t = this.gl;
                return [
                    0,
                    0,
                    t.drawingBufferWidth,
                    t.drawingBufferHeight
                ];
            }
            set(t) {
                const e = this.current;
                (t[0] !== e[0] || t[1] !== e[1] || t[2] !== e[2] || t[3] !== e[3] || this.dirty) && (this.gl.viewport(t[0], t[1], t[2], t[3]), this.current = t, this.dirty = !1);
            }
        }
        class di extends je {
            getDefault() {
                return null;
            }
            set(t) {
                if (t === this.current && !this.dirty) return;
                const e = this.gl;
                e.bindFramebuffer(e.FRAMEBUFFER, t), this.current = t, this.dirty = !1;
            }
        }
        class _i extends je {
            getDefault() {
                return null;
            }
            set(t) {
                if (t === this.current && !this.dirty) return;
                const e = this.gl;
                e.bindRenderbuffer(e.RENDERBUFFER, t), this.current = t, this.dirty = !1;
            }
        }
        class pi extends je {
            getDefault() {
                return null;
            }
            set(t) {
                if (t === this.current && !this.dirty) return;
                const e = this.gl;
                e.bindTexture(e.TEXTURE_2D, t), this.current = t, this.dirty = !1;
            }
        }
        class mi extends je {
            getDefault() {
                return null;
            }
            set(t) {
                if (t === this.current && !this.dirty) return;
                const e = this.gl;
                e.bindBuffer(e.ARRAY_BUFFER, t), this.current = t, this.dirty = !1;
            }
        }
        class fi extends je {
            getDefault() {
                return null;
            }
            set(t) {
                const e = this.gl;
                e.bindBuffer(e.ELEMENT_ARRAY_BUFFER, t), this.current = t, this.dirty = !1;
            }
        }
        class gi extends je {
            getDefault() {
                return null;
            }
            set(t) {
                var e;
                if (t === this.current && !this.dirty) return;
                const i = this.gl;
                Ge(i) ? i.bindVertexArray(t) : null === (e = i.getExtension("OES_vertex_array_object")) || void 0 === e || e.bindVertexArrayOES(t), this.current = t, this.dirty = !1;
            }
        }
        class vi extends je {
            getDefault() {
                return 4;
            }
            set(t) {
                if (t === this.current && !this.dirty) return;
                const e = this.gl;
                e.pixelStorei(e.UNPACK_ALIGNMENT, t), this.current = t, this.dirty = !1;
            }
        }
        class xi extends je {
            getDefault() {
                return !1;
            }
            set(t) {
                if (t === this.current && !this.dirty) return;
                const e = this.gl;
                e.pixelStorei(e.UNPACK_PREMULTIPLY_ALPHA_WEBGL, t), this.current = t, this.dirty = !1;
            }
        }
        class yi extends je {
            getDefault() {
                return !1;
            }
            set(t) {
                if (t === this.current && !this.dirty) return;
                const e = this.gl;
                e.pixelStorei(e.UNPACK_FLIP_Y_WEBGL, t), this.current = t, this.dirty = !1;
            }
        }
        class bi extends je {
            constructor(t, e){
                super(t), this.context = t, this.parent = e;
            }
            getDefault() {
                return null;
            }
        }
        class wi extends bi {
            setDirty() {
                this.dirty = !0;
            }
            set(t) {
                if (t === this.current && !this.dirty) return;
                this.context.bindFramebuffer.set(this.parent);
                const e = this.gl;
                e.framebufferTexture2D(e.FRAMEBUFFER, e.COLOR_ATTACHMENT0, e.TEXTURE_2D, t, 0), this.current = t, this.dirty = !1;
            }
        }
        class Ti extends bi {
            set(t) {
                if (t === this.current && !this.dirty) return;
                this.context.bindFramebuffer.set(this.parent);
                const e = this.gl;
                e.framebufferRenderbuffer(e.FRAMEBUFFER, e.DEPTH_ATTACHMENT, e.RENDERBUFFER, t), this.current = t, this.dirty = !1;
            }
        }
        class Ii extends bi {
            set(t) {
                if (t === this.current && !this.dirty) return;
                this.context.bindFramebuffer.set(this.parent);
                const e = this.gl;
                e.framebufferRenderbuffer(e.FRAMEBUFFER, e.DEPTH_STENCIL_ATTACHMENT, e.RENDERBUFFER, t), this.current = t, this.dirty = !1;
            }
        }
        class Ei {
            constructor(t, e, i, s, a){
                this.context = t, this.width = e, this.height = i;
                const o = t.gl, r = this.framebuffer = o.createFramebuffer();
                if (this.colorAttachment = new wi(t, r), s) this.depthAttachment = a ? new Ii(t, r) : new Ti(t, r);
                else if (a) throw new Error("Stencil cannot be setted without depth");
                if (o.checkFramebufferStatus(o.FRAMEBUFFER) !== o.FRAMEBUFFER_COMPLETE) throw new Error("Framebuffer is not complete");
            }
            destroy() {
                const t = this.context.gl, e = this.colorAttachment.get();
                if (e && t.deleteTexture(e), this.depthAttachment) {
                    const e = this.depthAttachment.get();
                    e && t.deleteRenderbuffer(e);
                }
                t.deleteFramebuffer(this.framebuffer);
            }
        }
        class Si {
            constructor(t, e, i){
                this.blendFunction = t, this.blendColor = e, this.mask = i;
            }
        }
        Si.Replace = [
            1,
            0
        ], Si.disabled = new Si(Si.Replace, t.aT.transparent, [
            !1,
            !1,
            !1,
            !1
        ]), Si.unblended = new Si(Si.Replace, t.aT.transparent, [
            !0,
            !0,
            !0,
            !0
        ]), Si.alphaBlended = new Si([
            1,
            771
        ], t.aT.transparent, [
            !0,
            !0,
            !0,
            !0
        ]);
        class Ci {
            constructor(t){
                var e, i;
                if (this.gl = t, this.clearColor = new Ve(this), this.clearDepth = new qe(this), this.clearStencil = new $e(this), this.colorMask = new We(this), this.depthMask = new He(this), this.stencilMask = new Xe(this), this.stencilFunc = new Ke(this), this.stencilOp = new Qe(this), this.stencilTest = new Ye(this), this.depthRange = new Je(this), this.depthTest = new ti(this), this.depthFunc = new ei(this), this.blend = new ii(this), this.blendFunc = new si(this), this.blendColor = new ai(this), this.blendEquation = new oi(this), this.cullFace = new ri(this), this.cullFaceSide = new ni(this), this.frontFace = new li(this), this.program = new hi(this), this.activeTexture = new ci(this), this.viewport = new ui(this), this.bindFramebuffer = new di(this), this.bindRenderbuffer = new _i(this), this.bindTexture = new pi(this), this.bindVertexBuffer = new mi(this), this.bindElementBuffer = new fi(this), this.bindVertexArray = new gi(this), this.pixelStoreUnpack = new vi(this), this.pixelStoreUnpackPremultiplyAlpha = new xi(this), this.pixelStoreUnpackFlipY = new yi(this), this.extTextureFilterAnisotropic = t.getExtension("EXT_texture_filter_anisotropic") || t.getExtension("MOZ_EXT_texture_filter_anisotropic") || t.getExtension("WEBKIT_EXT_texture_filter_anisotropic"), this.extTextureFilterAnisotropic && (this.extTextureFilterAnisotropicMax = t.getParameter(this.extTextureFilterAnisotropic.MAX_TEXTURE_MAX_ANISOTROPY_EXT)), this.maxTextureSize = t.getParameter(t.MAX_TEXTURE_SIZE), Ge(t)) {
                    this.HALF_FLOAT = t.HALF_FLOAT;
                    const s = t.getExtension("EXT_color_buffer_half_float");
                    this.RGBA16F = null !== (e = t.RGBA16F) && void 0 !== e ? e : null == s ? void 0 : s.RGBA16F_EXT, this.RGB16F = null !== (i = t.RGB16F) && void 0 !== i ? i : null == s ? void 0 : s.RGB16F_EXT, t.getExtension("EXT_color_buffer_float");
                } else {
                    t.getExtension("EXT_color_buffer_half_float"), t.getExtension("OES_texture_half_float_linear");
                    const e = t.getExtension("OES_texture_half_float");
                    this.HALF_FLOAT = null == e ? void 0 : e.HALF_FLOAT_OES;
                }
            }
            setDefault() {
                this.unbindVAO(), this.clearColor.setDefault(), this.clearDepth.setDefault(), this.clearStencil.setDefault(), this.colorMask.setDefault(), this.depthMask.setDefault(), this.stencilMask.setDefault(), this.stencilFunc.setDefault(), this.stencilOp.setDefault(), this.stencilTest.setDefault(), this.depthRange.setDefault(), this.depthTest.setDefault(), this.depthFunc.setDefault(), this.blend.setDefault(), this.blendFunc.setDefault(), this.blendColor.setDefault(), this.blendEquation.setDefault(), this.cullFace.setDefault(), this.cullFaceSide.setDefault(), this.frontFace.setDefault(), this.program.setDefault(), this.activeTexture.setDefault(), this.bindFramebuffer.setDefault(), this.pixelStoreUnpack.setDefault(), this.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.pixelStoreUnpackFlipY.setDefault();
            }
            setDirty() {
                this.clearColor.dirty = !0, this.clearDepth.dirty = !0, this.clearStencil.dirty = !0, this.colorMask.dirty = !0, this.depthMask.dirty = !0, this.stencilMask.dirty = !0, this.stencilFunc.dirty = !0, this.stencilOp.dirty = !0, this.stencilTest.dirty = !0, this.depthRange.dirty = !0, this.depthTest.dirty = !0, this.depthFunc.dirty = !0, this.blend.dirty = !0, this.blendFunc.dirty = !0, this.blendColor.dirty = !0, this.blendEquation.dirty = !0, this.cullFace.dirty = !0, this.cullFaceSide.dirty = !0, this.frontFace.dirty = !0, this.program.dirty = !0, this.activeTexture.dirty = !0, this.viewport.dirty = !0, this.bindFramebuffer.dirty = !0, this.bindRenderbuffer.dirty = !0, this.bindTexture.dirty = !0, this.bindVertexBuffer.dirty = !0, this.bindElementBuffer.dirty = !0, this.bindVertexArray.dirty = !0, this.pixelStoreUnpack.dirty = !0, this.pixelStoreUnpackPremultiplyAlpha.dirty = !0, this.pixelStoreUnpackFlipY.dirty = !0;
            }
            createIndexBuffer(t, e) {
                return new Oe(this, t, e);
            }
            createVertexBuffer(t, e, i) {
                return new Ue(this, t, e, i);
            }
            createRenderbuffer(t, e, i) {
                const s = this.gl, a = s.createRenderbuffer();
                return this.bindRenderbuffer.set(a), s.renderbufferStorage(s.RENDERBUFFER, t, e, i), this.bindRenderbuffer.set(null), a;
            }
            createFramebuffer(t, e, i, s) {
                return new Ei(this, t, e, i, s);
            }
            clear({ color: t, depth: e, stencil: i }) {
                const s = this.gl;
                let a = 0;
                t && (a |= s.COLOR_BUFFER_BIT, this.clearColor.set(t), this.colorMask.set([
                    !0,
                    !0,
                    !0,
                    !0
                ])), void 0 !== e && (a |= s.DEPTH_BUFFER_BIT, this.depthRange.set([
                    0,
                    1
                ]), this.clearDepth.set(e), this.depthMask.set(!0)), void 0 !== i && (a |= s.STENCIL_BUFFER_BIT, this.clearStencil.set(i), this.stencilMask.set(255)), s.clear(a);
            }
            setCullFace(t) {
                !1 === t.enable ? this.cullFace.set(!1) : (this.cullFace.set(!0), this.cullFaceSide.set(t.mode), this.frontFace.set(t.frontFace));
            }
            setDepthMode(t) {
                t.func !== this.gl.ALWAYS || t.mask ? (this.depthTest.set(!0), this.depthFunc.set(t.func), this.depthMask.set(t.mask), this.depthRange.set(t.range)) : this.depthTest.set(!1);
            }
            setStencilMode(t) {
                t.test.func !== this.gl.ALWAYS || t.mask ? (this.stencilTest.set(!0), this.stencilMask.set(t.mask), this.stencilOp.set([
                    t.fail,
                    t.depthFail,
                    t.pass
                ]), this.stencilFunc.set({
                    func: t.test.func,
                    ref: t.ref,
                    mask: t.test.mask
                })) : this.stencilTest.set(!1);
            }
            setColorMode(e) {
                t.aG(e.blendFunction, Si.Replace) ? this.blend.set(!1) : (this.blend.set(!0), this.blendFunc.set(e.blendFunction), this.blendColor.set(e.blendColor)), this.colorMask.set(e.mask);
            }
            createVertexArray() {
                var t;
                return Ge(this.gl) ? this.gl.createVertexArray() : null === (t = this.gl.getExtension("OES_vertex_array_object")) || void 0 === t ? void 0 : t.createVertexArrayOES();
            }
            deleteVertexArray(t) {
                var e;
                return Ge(this.gl) ? this.gl.deleteVertexArray(t) : null === (e = this.gl.getExtension("OES_vertex_array_object")) || void 0 === e ? void 0 : e.deleteVertexArrayOES(t);
            }
            unbindVAO() {
                this.bindVertexArray.set(null);
            }
        }
        class Pi {
            constructor(t, e, i){
                this.func = t, this.mask = e, this.range = i;
            }
        }
        Pi.ReadOnly = !1, Pi.ReadWrite = !0, Pi.disabled = new Pi(519, Pi.ReadOnly, [
            0,
            1
        ]);
        const Di = 7680;
        class Mi {
            constructor(t, e, i, s, a, o){
                this.test = t, this.ref = e, this.mask = i, this.fail = s, this.depthFail = a, this.pass = o;
            }
        }
        Mi.disabled = new Mi({
            func: 519,
            mask: 0
        }, 0, 0, Di, Di, Di);
        class zi {
            constructor(t, e, i){
                this.enable = t, this.mode = e, this.frontFace = i;
            }
        }
        let Li;
        function Ai(e, i, s, a, o, r, n) {
            const l = e.context, h = l.gl, c = e.useProgram("collisionBox"), u = [];
            let d = 0, _ = 0;
            for(let p = 0; p < a.length; p++){
                const m = a[p], f = i.getTile(m), g = f.getBucket(s);
                if (!g) continue;
                let v = m.posMatrix;
                0 === o[0] && 0 === o[1] || (v = e.translatePosMatrix(m.posMatrix, f, o, r));
                const x = n ? g.textCollisionBox : g.iconCollisionBox, y = g.collisionCircleArray;
                if (y.length > 0) {
                    const i = t.Z(), s = v;
                    t.aU(i, g.placementInvProjMatrix, e.transform.glCoordMatrix), t.aU(i, i, g.placementViewportMatrix), u.push({
                        circleArray: y,
                        circleOffset: _,
                        transform: s,
                        invTransform: i,
                        coord: m
                    }), d += y.length / 4, _ = d;
                }
                x && c.draw(l, h.LINES, Pi.disabled, Mi.disabled, e.colorModeForRenderPass(), zi.disabled, xe(v, e.transform, f), e.style.map.terrain && e.style.map.terrain.getTerrainData(m), s.id, x.layoutVertexBuffer, x.indexBuffer, x.segments, null, e.transform.zoom, null, null, x.collisionVertexBuffer);
            }
            if (!n || !u.length) return;
            const p = e.useProgram("collisionCircle"), m = new t.aV;
            m.resize(4 * d), m._trim();
            let f = 0;
            for (const t of u)for(let e = 0; e < t.circleArray.length / 4; e++){
                const i = 4 * e, s = t.circleArray[i + 0], a = t.circleArray[i + 1], o = t.circleArray[i + 2], r = t.circleArray[i + 3];
                m.emplace(f++, s, a, o, r, 0), m.emplace(f++, s, a, o, r, 1), m.emplace(f++, s, a, o, r, 2), m.emplace(f++, s, a, o, r, 3);
            }
            (!Li || Li.length < 2 * d) && (Li = function(e) {
                const i = 2 * e, s = new t.aX;
                s.resize(i), s._trim();
                for(let t = 0; t < i; t++){
                    const e = 6 * t;
                    s.uint16[e + 0] = 4 * t + 0, s.uint16[e + 1] = 4 * t + 1, s.uint16[e + 2] = 4 * t + 2, s.uint16[e + 3] = 4 * t + 2, s.uint16[e + 4] = 4 * t + 3, s.uint16[e + 5] = 4 * t + 0;
                }
                return s;
            }(d));
            const g = l.createIndexBuffer(Li, !0), v = l.createVertexBuffer(m, t.aW.members, !0);
            for (const i of u){
                const a = {
                    u_matrix: i.transform,
                    u_inv_matrix: i.invTransform,
                    u_camera_to_center_distance: (x = e.transform).cameraToCenterDistance,
                    u_viewport_size: [
                        x.width,
                        x.height
                    ]
                };
                p.draw(l, h.TRIANGLES, Pi.disabled, Mi.disabled, e.colorModeForRenderPass(), zi.disabled, a, e.style.map.terrain && e.style.map.terrain.getTerrainData(i.coord), s.id, v, g, t.S.simpleSegment(0, 2 * i.circleOffset, i.circleArray.length, i.circleArray.length / 2), null, e.transform.zoom, null, null, null);
            }
            var x;
            v.destroy(), g.destroy();
        }
        zi.disabled = new zi(!1, 1029, 2305), zi.backCCW = new zi(!0, 1029, 2305);
        const Ri = t.ao(new Float32Array(16));
        function ki(e, i, s, a, o, r) {
            const { horizontalAlign: n, verticalAlign: l } = t.au(e);
            return new t.P((-(n - .5) * i / o + a[0]) * r, (-(l - .5) * s / o + a[1]) * r);
        }
        function Fi(e, i, s, a, o, r, n, l, h, c, u) {
            const d = e.text.placedSymbolArray, _ = e.text.dynamicLayoutVertexArray, p = e.icon.dynamicLayoutVertexArray, m = {};
            _.clear();
            for(let p = 0; p < d.length; p++){
                const f = d.get(p), g = f.hidden || !f.crossTileID || e.allowVerticalPlacement && !f.placedOrientation ? null : a[f.crossTileID];
                if (g) {
                    const a = new t.P(f.anchorX, f.anchorY), d = ht(a, s ? n : r, u), p = ct(o.cameraToCenterDistance, d.signedDistanceFromCamera);
                    let v = t.aj(e.textSizeData, h, f) * p / t.ap;
                    s && (v *= e.tilePixelRatio / l);
                    const { width: x, height: y, anchor: b, textOffset: w, textBoxScale: T } = g, I = ki(b, x, y, w, T, v), E = s ? ht(a.add(I), r, u).point : d.point.add(i ? I.rotate(-o.angle) : I), S = e.allowVerticalPlacement && f.placedOrientation === t.ai.vertical ? Math.PI / 2 : 0;
                    for(let e = 0; e < f.numGlyphs; e++)t.ak(_, E, S);
                    c && f.associatedIconIndex >= 0 && (m[f.associatedIconIndex] = {
                        shiftedAnchor: E,
                        angle: S
                    });
                } else wt(f.numGlyphs, _);
            }
            if (c) {
                p.clear();
                const i = e.icon.placedSymbolArray;
                for(let e = 0; e < i.length; e++){
                    const s = i.get(e);
                    if (s.hidden) wt(s.numGlyphs, p);
                    else {
                        const i = m[e];
                        if (i) for(let e = 0; e < s.numGlyphs; e++)t.ak(p, i.shiftedAnchor, i.angle);
                        else wt(s.numGlyphs, p);
                    }
                }
                e.icon.dynamicLayoutVertexBuffer.updateData(p);
            }
            e.text.dynamicLayoutVertexBuffer.updateData(_);
        }
        function Bi(t, e, i) {
            return i.iconsInText && e ? "symbolTextAndIcon" : t ? "symbolSDF" : "symbolIcon";
        }
        function Oi(e, i, s, a, o, r, n, l, h, c, u, d) {
            const _ = e.context, p = _.gl, m = e.transform, f = "map" === l, g = "map" === h, v = "viewport" !== l && "point" !== s.layout.get("symbol-placement"), x = f && !g && !v, y = !s.layout.get("symbol-sort-key").isConstant();
            let b = !1;
            const w = e.depthModeForSublayer(0, Pi.ReadOnly), T = s._unevaluatedLayout.hasValue("text-variable-anchor") || s._unevaluatedLayout.hasValue("text-variable-anchor-offset"), I = [];
            for (const l of a){
                const a = i.getTile(l), h = a.getBucket(s);
                if (!h) continue;
                const u = o ? h.text : h.icon;
                if (!u || !u.segments.get().length || !u.hasVisibleVertices) continue;
                const d = u.programConfigurations.get(s.id), _ = o || h.sdfIcons, w = o ? h.textSizeData : h.iconSizeData, E = g || 0 !== m.pitch, S = e.useProgram(Bi(_, o, h), d), C = t.ah(w, m.zoom), P = e.style.map.terrain && e.style.map.terrain.getTerrainData(l);
                let D, M, z, L, A = [
                    0,
                    0
                ], R = null;
                if (o) M = a.glyphAtlasTexture, z = p.LINEAR, D = a.glyphAtlasTexture.size, h.iconsInText && (A = a.imageAtlasTexture.size, R = a.imageAtlasTexture, L = E || e.options.rotating || e.options.zooming || "composite" === w.kind || "camera" === w.kind ? p.LINEAR : p.NEAREST);
                else {
                    const t = 1 !== s.layout.get("icon-size").constantOr(0) || h.iconsNeedLinear;
                    M = a.imageAtlasTexture, z = _ || e.options.rotating || e.options.zooming || t || E ? p.LINEAR : p.NEAREST, D = a.imageAtlasTexture.size;
                }
                const k = St(a, 1, e.transform.zoom), F = nt(l.posMatrix, g, f, e.transform, k), B = lt(l.posMatrix, g, f, e.transform, k), O = T && h.hasTextData(), N = "none" !== s.layout.get("icon-text-fit") && O && h.hasIconData();
                if (v) {
                    const t = e.style.map.terrain ? (t, i)=>e.style.map.terrain.getElevation(l, t, i) : null, i = "map" === s.layout.get("text-rotation-alignment");
                    dt(h, l.posMatrix, e, o, F, B, g, c, i, t);
                }
                const U = e.translatePosMatrix(l.posMatrix, a, r, n), Z = v || o && T || N ? Ri : F, G = e.translatePosMatrix(B, a, r, n, !0), j = _ && 0 !== s.paint.get(o ? "text-halo-width" : "icon-halo-width").constantOr(1);
                let V;
                V = _ ? h.iconsInText ? Re(w.kind, C, x, g, e, U, Z, G, D, A) : Ae(w.kind, C, x, g, e, U, Z, G, o, D, !0) : Le(w.kind, C, x, g, e, U, Z, G, o, D);
                const q = {
                    program: S,
                    buffers: u,
                    uniformValues: V,
                    atlasTexture: M,
                    atlasTextureIcon: R,
                    atlasInterpolation: z,
                    atlasInterpolationIcon: L,
                    isSDF: _,
                    hasHalo: j
                };
                if (y && h.canOverlap) {
                    b = !0;
                    const e = u.segments.get();
                    for (const i of e)I.push({
                        segments: new t.S([
                            i
                        ]),
                        sortKey: i.sortKey,
                        state: q,
                        terrainData: P
                    });
                } else I.push({
                    segments: u.segments,
                    sortKey: 0,
                    state: q,
                    terrainData: P
                });
            }
            b && I.sort((t, e)=>t.sortKey - e.sortKey);
            for (const t of I){
                const i = t.state;
                if (_.activeTexture.set(p.TEXTURE0), i.atlasTexture.bind(i.atlasInterpolation, p.CLAMP_TO_EDGE), i.atlasTextureIcon && (_.activeTexture.set(p.TEXTURE1), i.atlasTextureIcon && i.atlasTextureIcon.bind(i.atlasInterpolationIcon, p.CLAMP_TO_EDGE)), i.isSDF) {
                    const a = i.uniformValues;
                    i.hasHalo && (a.u_is_halo = 1, Ni(i.buffers, t.segments, s, e, i.program, w, u, d, a, t.terrainData)), a.u_is_halo = 0;
                }
                Ni(i.buffers, t.segments, s, e, i.program, w, u, d, i.uniformValues, t.terrainData);
            }
        }
        function Ni(t, e, i, s, a, o, r, n, l, h) {
            const c = s.context;
            a.draw(c, c.gl.TRIANGLES, o, r, n, zi.disabled, l, h, i.id, t.layoutVertexBuffer, t.indexBuffer, e, i.paint, s.transform.zoom, t.programConfigurations.get(i.id), t.dynamicLayoutVertexBuffer, t.opacityVertexBuffer);
        }
        function Ui(t, e, i, s, a) {
            if (!i || !s || !s.imageAtlas) return;
            const o = s.imageAtlas.patternPositions;
            let r = o[i.to.toString()], n = o[i.from.toString()];
            if (!r && n && (r = n), !n && r && (n = r), !r || !n) {
                const t = a.getPaintProperty(e);
                r = o[t], n = o[t];
            }
            r && n && t.setConstantPatternPositions(r, n);
        }
        function Zi(t, e, i, s, a, o, r) {
            const n = t.context.gl, l = "fill-pattern", h = i.paint.get(l), c = h && h.constantOr(1), u = i.getCrossfadeParameters();
            let d, _, p, m, f;
            r ? (_ = c && !i.getPaintProperty("fill-outline-color") ? "fillOutlinePattern" : "fillOutline", d = n.LINES) : (_ = c ? "fillPattern" : "fill", d = n.TRIANGLES);
            const g = h.constantOr(null);
            for (const h of s){
                const s = e.getTile(h);
                if (c && !s.patternsLoaded()) continue;
                const v = s.getBucket(i);
                if (!v) continue;
                const x = v.programConfigurations.get(i.id), y = t.useProgram(_, x), b = t.style.map.terrain && t.style.map.terrain.getTerrainData(h);
                c && (t.context.activeTexture.set(n.TEXTURE0), s.imageAtlasTexture.bind(n.LINEAR, n.CLAMP_TO_EDGE), x.updatePaintBuffers(u)), Ui(x, l, g, s, i);
                const w = b ? h : null, T = t.translatePosMatrix(w ? w.posMatrix : h.posMatrix, s, i.paint.get("fill-translate"), i.paint.get("fill-translate-anchor"));
                if (r) {
                    m = v.indexBuffer2, f = v.segments2;
                    const e = [
                        n.drawingBufferWidth,
                        n.drawingBufferHeight
                    ];
                    p = "fillOutlinePattern" === _ && c ? ge(T, t, u, s, e) : fe(T, e);
                } else m = v.indexBuffer, f = v.segments, p = c ? me(T, t, u, s) : pe(T);
                y.draw(t.context, d, a, t.stencilModeForClipping(h), o, zi.disabled, p, b, i.id, v.layoutVertexBuffer, m, f, i.paint, t.transform.zoom, x);
            }
        }
        function Gi(t, e, i, s, a, o, r) {
            const n = t.context, l = n.gl, h = "fill-extrusion-pattern", c = i.paint.get(h), u = c.constantOr(1), d = i.getCrossfadeParameters(), _ = i.paint.get("fill-extrusion-opacity"), p = c.constantOr(null);
            for (const c of s){
                const s = e.getTile(c), m = s.getBucket(i);
                if (!m) continue;
                const f = t.style.map.terrain && t.style.map.terrain.getTerrainData(c), g = m.programConfigurations.get(i.id), v = t.useProgram(u ? "fillExtrusionPattern" : "fillExtrusion", g);
                u && (t.context.activeTexture.set(l.TEXTURE0), s.imageAtlasTexture.bind(l.LINEAR, l.CLAMP_TO_EDGE), g.updatePaintBuffers(d)), Ui(g, h, p, s, i);
                const x = t.translatePosMatrix(c.posMatrix, s, i.paint.get("fill-extrusion-translate"), i.paint.get("fill-extrusion-translate-anchor")), y = i.paint.get("fill-extrusion-vertical-gradient"), b = u ? _e(x, t, y, _, c, d, s) : de(x, t, y, _);
                v.draw(n, n.gl.TRIANGLES, a, o, r, zi.backCCW, b, f, i.id, m.layoutVertexBuffer, m.indexBuffer, m.segments, i.paint, t.transform.zoom, g, t.style.map.terrain && m.centroidVertexBuffer);
            }
        }
        function ji(t, e, i, s, a, o, r) {
            const n = t.context, l = n.gl, h = i.fbo;
            if (!h) return;
            const c = t.useProgram("hillshade"), u = t.style.map.terrain && t.style.map.terrain.getTerrainData(e);
            n.activeTexture.set(l.TEXTURE0), l.bindTexture(l.TEXTURE_2D, h.colorAttachment.get()), c.draw(n, l.TRIANGLES, a, o, r, zi.disabled, ((t, e, i, s)=>{
                const a = i.paint.get("hillshade-shadow-color"), o = i.paint.get("hillshade-highlight-color"), r = i.paint.get("hillshade-accent-color");
                let n = i.paint.get("hillshade-illumination-direction") * (Math.PI / 180);
                "viewport" === i.paint.get("hillshade-illumination-anchor") && (n -= t.transform.angle);
                const l = !t.options.moving;
                return {
                    u_matrix: s ? s.posMatrix : t.transform.calculatePosMatrix(e.tileID.toUnwrapped(), l),
                    u_image: 0,
                    u_latrange: Te(0, e.tileID),
                    u_light: [
                        i.paint.get("hillshade-exaggeration"),
                        n
                    ],
                    u_shadow: a,
                    u_highlight: o,
                    u_accent: r
                };
            })(t, i, s, u ? e : null), u, s.id, t.rasterBoundsBuffer, t.quadTriangleIndexBuffer, t.rasterBoundsSegments);
        }
        function Vi(e, i, s, a, o, r) {
            const n = e.context, l = n.gl, h = i.dem;
            if (h && h.data) {
                const c = h.dim, u = h.stride, d = h.getPixels();
                if (n.activeTexture.set(l.TEXTURE1), n.pixelStoreUnpackPremultiplyAlpha.set(!1), i.demTexture = i.demTexture || e.getTileTexture(u), i.demTexture) {
                    const t = i.demTexture;
                    t.update(d, {
                        premultiply: !1
                    }), t.bind(l.NEAREST, l.CLAMP_TO_EDGE);
                } else i.demTexture = new x(n, d, l.RGBA, {
                    premultiply: !1
                }), i.demTexture.bind(l.NEAREST, l.CLAMP_TO_EDGE);
                n.activeTexture.set(l.TEXTURE0);
                let _ = i.fbo;
                if (!_) {
                    const t = new x(n, {
                        width: c,
                        height: c,
                        data: null
                    }, l.RGBA);
                    t.bind(l.LINEAR, l.CLAMP_TO_EDGE), _ = i.fbo = n.createFramebuffer(c, c, !0, !1), _.colorAttachment.set(t.texture);
                }
                n.bindFramebuffer.set(_.framebuffer), n.viewport.set([
                    0,
                    0,
                    c,
                    c
                ]), e.useProgram("hillshadePrepare").draw(n, l.TRIANGLES, a, o, r, zi.disabled, ((e, i)=>{
                    const s = i.stride, a = t.Z();
                    return t.aS(a, 0, t.N, -t.N, 0, 0, 1), t.$(a, a, [
                        0,
                        -t.N,
                        0
                    ]), {
                        u_matrix: a,
                        u_image: 1,
                        u_dimension: [
                            s,
                            s
                        ],
                        u_zoom: e.overscaledZ,
                        u_unpack: i.getUnpackVector()
                    };
                })(i.tileID, h), null, s.id, e.rasterBoundsBuffer, e.quadTriangleIndexBuffer, e.rasterBoundsSegments), i.needsHillshadePrepare = !1;
            }
        }
        function qi(e, i, s, a, o, r) {
            const n = a.paint.get("raster-fade-duration");
            if (!r && n > 0) {
                const a = t.h.now(), r = (a - e.timeAdded) / n, l = i ? (a - i.timeAdded) / n : -1, h = s.getSource(), c = o.coveringZoomLevel({
                    tileSize: h.tileSize,
                    roundZoom: h.roundZoom
                }), u = !i || Math.abs(i.tileID.overscaledZ - c) > Math.abs(e.tileID.overscaledZ - c), d = u && e.refreshedUponExpiration ? 1 : t.ad(u ? r : 1 - l, 0, 1);
                return e.refreshedUponExpiration && r >= 1 && (e.refreshedUponExpiration = !1), i ? {
                    opacity: 1,
                    mix: 1 - d
                } : {
                    opacity: d,
                    mix: 0
                };
            }
            return {
                opacity: 1,
                mix: 0
            };
        }
        const $i = new t.aT(1, 0, 0, 1), Wi = new t.aT(0, 1, 0, 1), Hi = new t.aT(0, 0, 1, 1), Xi = new t.aT(1, 0, 1, 1), Ki = new t.aT(0, 1, 1, 1);
        function Qi(t, e, i, s) {
            Ji(t, 0, e + i / 2, t.transform.width, i, s);
        }
        function Yi(t, e, i, s) {
            Ji(t, e - i / 2, 0, i, t.transform.height, s);
        }
        function Ji(t, e, i, s, a, o) {
            const r = t.context, n = r.gl;
            n.enable(n.SCISSOR_TEST), n.scissor(e * t.pixelRatio, i * t.pixelRatio, s * t.pixelRatio, a * t.pixelRatio), r.clear({
                color: o
            }), n.disable(n.SCISSOR_TEST);
        }
        function ts(e, i, s) {
            const a = e.context, o = a.gl, r = s.posMatrix, n = e.useProgram("debug"), l = Pi.disabled, h = Mi.disabled, c = e.colorModeForRenderPass(), u = "$debug", d = e.style.map.terrain && e.style.map.terrain.getTerrainData(s);
            a.activeTexture.set(o.TEXTURE0);
            const _ = i.getTileByID(s.key).latestRawTileData, p = Math.floor((_ && _.byteLength || 0) / 1024), m = i.getTile(s).tileSize, f = 512 / Math.min(m, 512) * (s.overscaledZ / e.transform.zoom) * .5;
            let g = s.canonical.toString();
            s.overscaledZ !== s.canonical.z && (g += ` => ${s.overscaledZ}`), function(t, e) {
                t.initDebugOverlayCanvas();
                const i = t.debugOverlayCanvas, s = t.context.gl, a = t.debugOverlayCanvas.getContext("2d");
                a.clearRect(0, 0, i.width, i.height), a.shadowColor = "white", a.shadowBlur = 2, a.lineWidth = 1.5, a.strokeStyle = "white", a.textBaseline = "top", a.font = "bold 36px Open Sans, sans-serif", a.fillText(e, 5, 5), a.strokeText(e, 5, 5), t.debugOverlayTexture.update(i), t.debugOverlayTexture.bind(s.LINEAR, s.CLAMP_TO_EDGE);
            }(e, `${g} ${p}kB`), n.draw(a, o.TRIANGLES, l, h, Si.alphaBlended, zi.disabled, ye(r, t.aT.transparent, f), null, u, e.debugBuffer, e.quadTriangleIndexBuffer, e.debugSegments), n.draw(a, o.LINE_STRIP, l, h, c, zi.disabled, ye(r, t.aT.red), d, u, e.debugBuffer, e.tileBorderIndexBuffer, e.debugSegments);
        }
        function es(t, e, i) {
            const s = t.context, a = s.gl, o = t.colorModeForRenderPass(), r = new Pi(a.LEQUAL, Pi.ReadWrite, t.depthRangeFor3D), n = t.useProgram("terrain"), l = e.getTerrainMesh();
            s.bindFramebuffer.set(null), s.viewport.set([
                0,
                0,
                t.width,
                t.height
            ]);
            for (const h of i){
                const i = t.renderToTexture.getTexture(h), c = e.getTerrainData(h.tileID);
                s.activeTexture.set(a.TEXTURE0), a.bindTexture(a.TEXTURE_2D, i.texture);
                const u = {
                    u_matrix: t.transform.calculatePosMatrix(h.tileID.toUnwrapped()),
                    u_texture: 0,
                    u_ele_delta: e.getMeshFrameDelta(t.transform.zoom)
                };
                n.draw(s, a.TRIANGLES, r, Mi.disabled, o, zi.backCCW, u, c, "terrain", l.vertexBuffer, l.indexBuffer, l.segments);
            }
        }
        class is {
            constructor(e, i){
                this.context = new Ci(e), this.transform = i, this._tileTextures = {}, this.terrainFacilitator = {
                    dirty: !0,
                    matrix: t.Z(),
                    renderTime: 0
                }, this.setup(), this.numSublayers = K.maxUnderzooming + K.maxOverzooming + 1, this.depthEpsilon = 1 / Math.pow(2, 16), this.crossTileSymbolIndex = new Yt;
            }
            resize(t, e, i) {
                if (this.width = Math.floor(t * i), this.height = Math.floor(e * i), this.pixelRatio = i, this.context.viewport.set([
                    0,
                    0,
                    this.width,
                    this.height
                ]), this.style) for (const t of this.style._order)this.style._layers[t].resize();
            }
            setup() {
                const e = this.context, i = new t.a_;
                i.emplaceBack(0, 0), i.emplaceBack(t.N, 0), i.emplaceBack(0, t.N), i.emplaceBack(t.N, t.N), this.tileExtentBuffer = e.createVertexBuffer(i, ae.members), this.tileExtentSegments = t.S.simpleSegment(0, 0, 4, 2);
                const s = new t.a_;
                s.emplaceBack(0, 0), s.emplaceBack(t.N, 0), s.emplaceBack(0, t.N), s.emplaceBack(t.N, t.N), this.debugBuffer = e.createVertexBuffer(s, ae.members), this.debugSegments = t.S.simpleSegment(0, 0, 4, 5);
                const a = new t.V;
                a.emplaceBack(0, 0, 0, 0), a.emplaceBack(t.N, 0, t.N, 0), a.emplaceBack(0, t.N, 0, t.N), a.emplaceBack(t.N, t.N, t.N, t.N), this.rasterBoundsBuffer = e.createVertexBuffer(a, O.members), this.rasterBoundsSegments = t.S.simpleSegment(0, 0, 4, 2);
                const o = new t.a_;
                o.emplaceBack(0, 0), o.emplaceBack(1, 0), o.emplaceBack(0, 1), o.emplaceBack(1, 1), this.viewportBuffer = e.createVertexBuffer(o, ae.members), this.viewportSegments = t.S.simpleSegment(0, 0, 4, 2);
                const r = new t.a$;
                r.emplaceBack(0), r.emplaceBack(1), r.emplaceBack(3), r.emplaceBack(2), r.emplaceBack(0), this.tileBorderIndexBuffer = e.createIndexBuffer(r);
                const n = new t.b0;
                n.emplaceBack(0, 1, 2), n.emplaceBack(2, 1, 3), this.quadTriangleIndexBuffer = e.createIndexBuffer(n);
                const l = this.context.gl;
                this.stencilClearMode = new Mi({
                    func: l.ALWAYS,
                    mask: 0
                }, 0, 255, l.ZERO, l.ZERO, l.ZERO);
            }
            clearStencil() {
                const e = this.context, i = e.gl;
                this.nextStencilID = 1, this.currentStencilSource = void 0;
                const s = t.Z();
                t.aS(s, 0, this.width, this.height, 0, 0, 1), t.a0(s, s, [
                    i.drawingBufferWidth,
                    i.drawingBufferHeight,
                    0
                ]), this.useProgram("clippingMask").draw(e, i.TRIANGLES, Pi.disabled, this.stencilClearMode, Si.disabled, zi.disabled, be(s), null, "$clipping", this.viewportBuffer, this.quadTriangleIndexBuffer, this.viewportSegments);
            }
            _renderTileClippingMasks(t, e) {
                if (this.currentStencilSource === t.source || !t.isTileClipped() || !e || !e.length) return;
                this.currentStencilSource = t.source;
                const i = this.context, s = i.gl;
                this.nextStencilID + e.length > 256 && this.clearStencil(), i.setColorMode(Si.disabled), i.setDepthMode(Pi.disabled);
                const a = this.useProgram("clippingMask");
                this._tileClippingMaskIDs = {};
                for (const t of e){
                    const e = this._tileClippingMaskIDs[t.key] = this.nextStencilID++, o = this.style.map.terrain && this.style.map.terrain.getTerrainData(t);
                    a.draw(i, s.TRIANGLES, Pi.disabled, new Mi({
                        func: s.ALWAYS,
                        mask: 0
                    }, e, 255, s.KEEP, s.KEEP, s.REPLACE), Si.disabled, zi.disabled, be(t.posMatrix), o, "$clipping", this.tileExtentBuffer, this.quadTriangleIndexBuffer, this.tileExtentSegments);
                }
            }
            stencilModeFor3D() {
                this.currentStencilSource = void 0, this.nextStencilID + 1 > 256 && this.clearStencil();
                const t = this.nextStencilID++, e = this.context.gl;
                return new Mi({
                    func: e.NOTEQUAL,
                    mask: 255
                }, t, 255, e.KEEP, e.KEEP, e.REPLACE);
            }
            stencilModeForClipping(t) {
                const e = this.context.gl;
                return new Mi({
                    func: e.EQUAL,
                    mask: 255
                }, this._tileClippingMaskIDs[t.key], 0, e.KEEP, e.KEEP, e.REPLACE);
            }
            stencilConfigForOverlap(t) {
                const e = this.context.gl, i = t.sort((t, e)=>e.overscaledZ - t.overscaledZ), s = i[i.length - 1].overscaledZ, a = i[0].overscaledZ - s + 1;
                if (a > 1) {
                    this.currentStencilSource = void 0, this.nextStencilID + a > 256 && this.clearStencil();
                    const t = {};
                    for(let i = 0; i < a; i++)t[i + s] = new Mi({
                        func: e.GEQUAL,
                        mask: 255
                    }, i + this.nextStencilID, 255, e.KEEP, e.KEEP, e.REPLACE);
                    return this.nextStencilID += a, [
                        t,
                        i
                    ];
                }
                return [
                    {
                        [s]: Mi.disabled
                    },
                    i
                ];
            }
            colorModeForRenderPass() {
                const e = this.context.gl;
                if (this._showOverdrawInspector) {
                    const i = 1 / 8;
                    return new Si([
                        e.CONSTANT_COLOR,
                        e.ONE
                    ], new t.aT(i, i, i, 0), [
                        !0,
                        !0,
                        !0,
                        !0
                    ]);
                }
                return "opaque" === this.renderPass ? Si.unblended : Si.alphaBlended;
            }
            depthModeForSublayer(t, e, i) {
                if (!this.opaquePassEnabledForLayer()) return Pi.disabled;
                const s = 1 - ((1 + this.currentLayer) * this.numSublayers + t) * this.depthEpsilon;
                return new Pi(i || this.context.gl.LEQUAL, e, [
                    s,
                    s
                ]);
            }
            opaquePassEnabledForLayer() {
                return this.currentLayer < this.opaquePassCutoff;
            }
            render(e, i) {
                this.style = e, this.options = i, this.lineAtlas = e.lineAtlas, this.imageManager = e.imageManager, this.glyphManager = e.glyphManager, this.symbolFadeChange = e.placement.symbolFadeChange(t.h.now()), this.imageManager.beginFrame();
                const s = this.style._order, a = this.style.sourceCaches, o = {}, r = {}, n = {};
                for(const t in a){
                    const e = a[t];
                    e.used && e.prepare(this.context), o[t] = e.getVisibleCoordinates(), r[t] = o[t].slice().reverse(), n[t] = e.getVisibleCoordinates(!0).reverse();
                }
                this.opaquePassCutoff = 1 / 0;
                for(let t = 0; t < s.length; t++)if (this.style._layers[s[t]].is3D()) {
                    this.opaquePassCutoff = t;
                    break;
                }
                if (this.renderToTexture) {
                    this.renderToTexture.prepareForRender(this.style, this.transform.zoom), this.opaquePassCutoff = 0;
                    const e = this.style.map.terrain.sourceCache.tilesAfterTime(this.terrainFacilitator.renderTime);
                    (this.terrainFacilitator.dirty || !t.b1(this.terrainFacilitator.matrix, this.transform.projMatrix) || e.length) && (t.b2(this.terrainFacilitator.matrix, this.transform.projMatrix), this.terrainFacilitator.renderTime = Date.now(), this.terrainFacilitator.dirty = !1, function(e, i) {
                        const s = e.context, a = s.gl, o = Si.unblended, r = new Pi(a.LEQUAL, Pi.ReadWrite, [
                            0,
                            1
                        ]), n = i.getTerrainMesh(), l = i.sourceCache.getRenderableTiles(), h = e.useProgram("terrainDepth");
                        s.bindFramebuffer.set(i.getFramebuffer("depth").framebuffer), s.viewport.set([
                            0,
                            0,
                            e.width / devicePixelRatio,
                            e.height / devicePixelRatio
                        ]), s.clear({
                            color: t.aT.transparent,
                            depth: 1
                        });
                        for (const t of l){
                            const l = i.getTerrainData(t.tileID), c = {
                                u_matrix: e.transform.calculatePosMatrix(t.tileID.toUnwrapped()),
                                u_ele_delta: i.getMeshFrameDelta(e.transform.zoom)
                            };
                            h.draw(s, a.TRIANGLES, r, Mi.disabled, o, zi.backCCW, c, l, "terrain", n.vertexBuffer, n.indexBuffer, n.segments);
                        }
                        s.bindFramebuffer.set(null), s.viewport.set([
                            0,
                            0,
                            e.width,
                            e.height
                        ]);
                    }(this, this.style.map.terrain), function(e, i) {
                        const s = e.context, a = s.gl, o = Si.unblended, r = new Pi(a.LEQUAL, Pi.ReadWrite, [
                            0,
                            1
                        ]), n = i.getTerrainMesh(), l = i.getCoordsTexture(), h = i.sourceCache.getRenderableTiles(), c = e.useProgram("terrainCoords");
                        s.bindFramebuffer.set(i.getFramebuffer("coords").framebuffer), s.viewport.set([
                            0,
                            0,
                            e.width / devicePixelRatio,
                            e.height / devicePixelRatio
                        ]), s.clear({
                            color: t.aT.transparent,
                            depth: 1
                        }), i.coordsIndex = [];
                        for (const t of h){
                            const h = i.getTerrainData(t.tileID);
                            s.activeTexture.set(a.TEXTURE0), a.bindTexture(a.TEXTURE_2D, l.texture);
                            const u = {
                                u_matrix: e.transform.calculatePosMatrix(t.tileID.toUnwrapped()),
                                u_terrain_coords_id: (255 - i.coordsIndex.length) / 255,
                                u_texture: 0,
                                u_ele_delta: i.getMeshFrameDelta(e.transform.zoom)
                            };
                            c.draw(s, a.TRIANGLES, r, Mi.disabled, o, zi.backCCW, u, h, "terrain", n.vertexBuffer, n.indexBuffer, n.segments), i.coordsIndex.push(t.tileID.key);
                        }
                        s.bindFramebuffer.set(null), s.viewport.set([
                            0,
                            0,
                            e.width,
                            e.height
                        ]);
                    }(this, this.style.map.terrain));
                }
                this.renderPass = "offscreen";
                for (const t of s){
                    const e = this.style._layers[t];
                    if (!e.hasOffscreenPass() || e.isHidden(this.transform.zoom)) continue;
                    const i = r[e.source];
                    ("custom" === e.type || i.length) && this.renderLayer(this, a[e.source], e, i);
                }
                if (this.context.bindFramebuffer.set(null), this.context.clear({
                    color: i.showOverdrawInspector ? t.aT.black : t.aT.transparent,
                    depth: 1
                }), this.clearStencil(), this._showOverdrawInspector = i.showOverdrawInspector, this.depthRangeFor3D = [
                    0,
                    1 - (e._order.length + 2) * this.numSublayers * this.depthEpsilon
                ], !this.renderToTexture) for(this.renderPass = "opaque", this.currentLayer = s.length - 1; this.currentLayer >= 0; this.currentLayer--){
                    const t = this.style._layers[s[this.currentLayer]], e = a[t.source], i = o[t.source];
                    this._renderTileClippingMasks(t, i), this.renderLayer(this, e, t, i);
                }
                for(this.renderPass = "translucent", this.currentLayer = 0; this.currentLayer < s.length; this.currentLayer++){
                    const t = this.style._layers[s[this.currentLayer]], e = a[t.source];
                    if (this.renderToTexture && this.renderToTexture.renderLayer(t)) continue;
                    const i = ("symbol" === t.type ? n : r)[t.source];
                    this._renderTileClippingMasks(t, o[t.source]), this.renderLayer(this, e, t, i);
                }
                if (this.options.showTileBoundaries) {
                    const t = function(t, e) {
                        let i = null;
                        const s = Object.values(t._layers).flatMap((i)=>i.source && !i.isHidden(e) ? [
                                t.sourceCaches[i.source]
                            ] : []), a = s.filter((t)=>"vector" === t.getSource().type), o = s.filter((t)=>"vector" !== t.getSource().type), r = (t)=>{
                            (!i || i.getSource().maxzoom < t.getSource().maxzoom) && (i = t);
                        };
                        return a.forEach((t)=>r(t)), i || o.forEach((t)=>r(t)), i;
                    }(this.style, this.transform.zoom);
                    t && function(t, e, i) {
                        for(let s = 0; s < i.length; s++)ts(t, e, i[s]);
                    }(this, t, t.getVisibleCoordinates());
                }
                this.options.showPadding && function(t) {
                    const e = t.transform.padding;
                    Qi(t, t.transform.height - (e.top || 0), 3, $i), Qi(t, e.bottom || 0, 3, Wi), Yi(t, e.left || 0, 3, Hi), Yi(t, t.transform.width - (e.right || 0), 3, Xi);
                    const i = t.transform.centerPoint;
                    !function(t, e, i, s) {
                        Ji(t, e - 1, i - 10, 2, 20, s), Ji(t, e - 10, i - 1, 20, 2, s);
                    }(t, i.x, t.transform.height - i.y, Ki);
                }(this), this.context.setDefault();
            }
            renderLayer(e, i, s, a) {
                if (!s.isHidden(this.transform.zoom) && ("background" === s.type || "custom" === s.type || (a || []).length)) switch(this.id = s.id, s.type){
                    case "symbol":
                        !function(e, i, s, a, o) {
                            if ("translucent" !== e.renderPass) return;
                            const r = Mi.disabled, n = e.colorModeForRenderPass();
                            (s._unevaluatedLayout.hasValue("text-variable-anchor") || s._unevaluatedLayout.hasValue("text-variable-anchor-offset")) && function(e, i, s, a, o, r, n) {
                                const l = i.transform, h = "map" === o, c = "map" === r;
                                for (const o of e){
                                    const e = a.getTile(o), r = e.getBucket(s);
                                    if (!r || !r.text || !r.text.segments.get().length) continue;
                                    const u = t.ah(r.textSizeData, l.zoom), d = St(e, 1, i.transform.zoom), _ = nt(o.posMatrix, c, h, i.transform, d), p = "none" !== s.layout.get("icon-text-fit") && r.hasIconData();
                                    if (u) {
                                        const t = Math.pow(2, l.zoom - e.tileID.overscaledZ);
                                        Fi(r, h, c, n, l, _, o.posMatrix, t, u, p, i.style.map.terrain ? (t, e)=>i.style.map.terrain.getElevation(o, t, e) : null);
                                    }
                                }
                            }(a, e, s, i, s.layout.get("text-rotation-alignment"), s.layout.get("text-pitch-alignment"), o), 0 !== s.paint.get("icon-opacity").constantOr(1) && Oi(e, i, s, a, !1, s.paint.get("icon-translate"), s.paint.get("icon-translate-anchor"), s.layout.get("icon-rotation-alignment"), s.layout.get("icon-pitch-alignment"), s.layout.get("icon-keep-upright"), r, n), 0 !== s.paint.get("text-opacity").constantOr(1) && Oi(e, i, s, a, !0, s.paint.get("text-translate"), s.paint.get("text-translate-anchor"), s.layout.get("text-rotation-alignment"), s.layout.get("text-pitch-alignment"), s.layout.get("text-keep-upright"), r, n), i.map.showCollisionBoxes && (Ai(e, i, s, a, s.paint.get("text-translate"), s.paint.get("text-translate-anchor"), !0), Ai(e, i, s, a, s.paint.get("icon-translate"), s.paint.get("icon-translate-anchor"), !1));
                        }(e, i, s, a, this.style.placement.variableOffsets);
                        break;
                    case "circle":
                        !function(e, i, s, a) {
                            if ("translucent" !== e.renderPass) return;
                            const o = s.paint.get("circle-opacity"), r = s.paint.get("circle-stroke-width"), n = s.paint.get("circle-stroke-opacity"), l = !s.layout.get("circle-sort-key").isConstant();
                            if (0 === o.constantOr(1) && (0 === r.constantOr(1) || 0 === n.constantOr(1))) return;
                            const h = e.context, c = h.gl, u = e.depthModeForSublayer(0, Pi.ReadOnly), d = Mi.disabled, _ = e.colorModeForRenderPass(), p = [];
                            for(let o = 0; o < a.length; o++){
                                const r = a[o], n = i.getTile(r), h = n.getBucket(s);
                                if (!h) continue;
                                const c = h.programConfigurations.get(s.id), u = e.useProgram("circle", c), d = h.layoutVertexBuffer, _ = h.indexBuffer, m = e.style.map.terrain && e.style.map.terrain.getTerrainData(r), f = {
                                    programConfiguration: c,
                                    program: u,
                                    layoutVertexBuffer: d,
                                    indexBuffer: _,
                                    uniformValues: ve(e, r, n, s),
                                    terrainData: m
                                };
                                if (l) {
                                    const e = h.segments.get();
                                    for (const i of e)p.push({
                                        segments: new t.S([
                                            i
                                        ]),
                                        sortKey: i.sortKey,
                                        state: f
                                    });
                                } else p.push({
                                    segments: h.segments,
                                    sortKey: 0,
                                    state: f
                                });
                            }
                            l && p.sort((t, e)=>t.sortKey - e.sortKey);
                            for (const t of p){
                                const { programConfiguration: i, program: a, layoutVertexBuffer: o, indexBuffer: r, uniformValues: n, terrainData: l } = t.state;
                                a.draw(h, c.TRIANGLES, u, d, _, zi.disabled, n, l, s.id, o, r, t.segments, s.paint, e.transform.zoom, i);
                            }
                        }(e, i, s, a);
                        break;
                    case "heatmap":
                        !function(e, i, s, a) {
                            if (0 !== s.paint.get("heatmap-opacity")) {
                                if ("offscreen" === e.renderPass) {
                                    const o = e.context, r = o.gl, n = Mi.disabled, l = new Si([
                                        r.ONE,
                                        r.ONE
                                    ], t.aT.transparent, [
                                        !0,
                                        !0,
                                        !0,
                                        !0
                                    ]);
                                    !function(t, e, i) {
                                        const s = t.gl;
                                        t.activeTexture.set(s.TEXTURE1), t.viewport.set([
                                            0,
                                            0,
                                            e.width / 4,
                                            e.height / 4
                                        ]);
                                        let a = i.heatmapFbo;
                                        if (a) s.bindTexture(s.TEXTURE_2D, a.colorAttachment.get()), t.bindFramebuffer.set(a.framebuffer);
                                        else {
                                            const o = s.createTexture();
                                            s.bindTexture(s.TEXTURE_2D, o), s.texParameteri(s.TEXTURE_2D, s.TEXTURE_WRAP_S, s.CLAMP_TO_EDGE), s.texParameteri(s.TEXTURE_2D, s.TEXTURE_WRAP_T, s.CLAMP_TO_EDGE), s.texParameteri(s.TEXTURE_2D, s.TEXTURE_MIN_FILTER, s.LINEAR), s.texParameteri(s.TEXTURE_2D, s.TEXTURE_MAG_FILTER, s.LINEAR), a = i.heatmapFbo = t.createFramebuffer(e.width / 4, e.height / 4, !1, !1), function(t, e, i, s) {
                                                var a, o;
                                                const r = t.gl, n = null !== (a = t.HALF_FLOAT) && void 0 !== a ? a : r.UNSIGNED_BYTE, l = null !== (o = t.RGBA16F) && void 0 !== o ? o : r.RGBA;
                                                r.texImage2D(r.TEXTURE_2D, 0, l, e.width / 4, e.height / 4, 0, r.RGBA, n, null), s.colorAttachment.set(i);
                                            }(t, e, o, a);
                                        }
                                    }(o, e, s), o.clear({
                                        color: t.aT.transparent
                                    });
                                    for(let t = 0; t < a.length; t++){
                                        const h = a[t];
                                        if (i.hasRenderableParent(h)) continue;
                                        const c = i.getTile(h), u = c.getBucket(s);
                                        if (!u) continue;
                                        const d = u.programConfigurations.get(s.id), _ = e.useProgram("heatmap", d), { zoom: p } = e.transform;
                                        _.draw(o, r.TRIANGLES, Pi.disabled, n, l, zi.disabled, we(h.posMatrix, c, p, s.paint.get("heatmap-intensity")), null, s.id, u.layoutVertexBuffer, u.indexBuffer, u.segments, s.paint, e.transform.zoom, d);
                                    }
                                    o.viewport.set([
                                        0,
                                        0,
                                        e.width,
                                        e.height
                                    ]);
                                } else "translucent" === e.renderPass && (e.context.setColorMode(e.colorModeForRenderPass()), function(e, i) {
                                    const s = e.context, a = s.gl, o = i.heatmapFbo;
                                    if (!o) return;
                                    s.activeTexture.set(a.TEXTURE0), a.bindTexture(a.TEXTURE_2D, o.colorAttachment.get()), s.activeTexture.set(a.TEXTURE1);
                                    let r = i.colorRampTexture;
                                    r || (r = i.colorRampTexture = new x(s, i.colorRamp, a.RGBA)), r.bind(a.LINEAR, a.CLAMP_TO_EDGE), e.useProgram("heatmapTexture").draw(s, a.TRIANGLES, Pi.disabled, Mi.disabled, e.colorModeForRenderPass(), zi.disabled, ((e, i, s, a)=>{
                                        const o = t.Z();
                                        t.aS(o, 0, e.width, e.height, 0, 0, 1);
                                        const r = e.context.gl;
                                        return {
                                            u_matrix: o,
                                            u_world: [
                                                r.drawingBufferWidth,
                                                r.drawingBufferHeight
                                            ],
                                            u_image: 0,
                                            u_color_ramp: 1,
                                            u_opacity: i.paint.get("heatmap-opacity")
                                        };
                                    })(e, i), null, i.id, e.viewportBuffer, e.quadTriangleIndexBuffer, e.viewportSegments, i.paint, e.transform.zoom);
                                }(e, s));
                            }
                        }(e, i, s, a);
                        break;
                    case "line":
                        !function(e, i, s, a) {
                            if ("translucent" !== e.renderPass) return;
                            const o = s.paint.get("line-opacity"), r = s.paint.get("line-width");
                            if (0 === o.constantOr(1) || 0 === r.constantOr(1)) return;
                            const n = e.depthModeForSublayer(0, Pi.ReadOnly), l = e.colorModeForRenderPass(), h = s.paint.get("line-dasharray"), c = s.paint.get("line-pattern"), u = c.constantOr(1), d = s.paint.get("line-gradient"), _ = s.getCrossfadeParameters(), p = u ? "linePattern" : h ? "lineSDF" : d ? "lineGradient" : "line", m = e.context, f = m.gl;
                            let g = !0;
                            for (const o of a){
                                const a = i.getTile(o);
                                if (u && !a.patternsLoaded()) continue;
                                const r = a.getBucket(s);
                                if (!r) continue;
                                const v = r.programConfigurations.get(s.id), y = e.context.program.get(), b = e.useProgram(p, v), w = g || b.program !== y, T = e.style.map.terrain && e.style.map.terrain.getTerrainData(o), I = c.constantOr(null);
                                if (I && a.imageAtlas) {
                                    const t = a.imageAtlas, e = t.patternPositions[I.to.toString()], i = t.patternPositions[I.from.toString()];
                                    e && i && v.setConstantPatternPositions(e, i);
                                }
                                const E = T ? o : null, S = u ? Se(e, a, s, _, E) : h ? Ce(e, a, s, h, _, E) : d ? Ee(e, a, s, r.lineClipsArray.length, E) : Ie(e, a, s, E);
                                if (u) m.activeTexture.set(f.TEXTURE0), a.imageAtlasTexture.bind(f.LINEAR, f.CLAMP_TO_EDGE), v.updatePaintBuffers(_);
                                else if (h && (w || e.lineAtlas.dirty)) m.activeTexture.set(f.TEXTURE0), e.lineAtlas.bind(m);
                                else if (d) {
                                    const a = r.gradients[s.id];
                                    let n = a.texture;
                                    if (s.gradientVersion !== a.version) {
                                        let l = 256;
                                        if (s.stepInterpolant) {
                                            const s = i.getSource().maxzoom, a = o.canonical.z === s ? Math.ceil(1 << e.transform.maxZoom - o.canonical.z) : 1;
                                            l = t.ad(t.aY(r.maxLineLength / t.N * 1024 * a), 256, m.maxTextureSize);
                                        }
                                        a.gradient = t.aZ({
                                            expression: s.gradientExpression(),
                                            evaluationKey: "lineProgress",
                                            resolution: l,
                                            image: a.gradient || void 0,
                                            clips: r.lineClipsArray
                                        }), a.texture ? a.texture.update(a.gradient) : a.texture = new x(m, a.gradient, f.RGBA), a.version = s.gradientVersion, n = a.texture;
                                    }
                                    m.activeTexture.set(f.TEXTURE0), n.bind(s.stepInterpolant ? f.NEAREST : f.LINEAR, f.CLAMP_TO_EDGE);
                                }
                                b.draw(m, f.TRIANGLES, n, e.stencilModeForClipping(o), l, zi.disabled, S, T, s.id, r.layoutVertexBuffer, r.indexBuffer, r.segments, s.paint, e.transform.zoom, v, r.layoutVertexBuffer2), g = !1;
                            }
                        }(e, i, s, a);
                        break;
                    case "fill":
                        !function(e, i, s, a) {
                            const o = s.paint.get("fill-color"), r = s.paint.get("fill-opacity");
                            if (0 === r.constantOr(1)) return;
                            const n = e.colorModeForRenderPass(), l = s.paint.get("fill-pattern"), h = e.opaquePassEnabledForLayer() && !l.constantOr(1) && 1 === o.constantOr(t.aT.transparent).a && 1 === r.constantOr(0) ? "opaque" : "translucent";
                            if (e.renderPass === h) {
                                const t = e.depthModeForSublayer(1, "opaque" === e.renderPass ? Pi.ReadWrite : Pi.ReadOnly);
                                Zi(e, i, s, a, t, n, !1);
                            }
                            if ("translucent" === e.renderPass && s.paint.get("fill-antialias")) {
                                const t = e.depthModeForSublayer(s.getPaintProperty("fill-outline-color") ? 2 : 0, Pi.ReadOnly);
                                Zi(e, i, s, a, t, n, !0);
                            }
                        }(e, i, s, a);
                        break;
                    case "fill-extrusion":
                        !function(t, e, i, s) {
                            const a = i.paint.get("fill-extrusion-opacity");
                            if (0 !== a && "translucent" === t.renderPass) {
                                const o = new Pi(t.context.gl.LEQUAL, Pi.ReadWrite, t.depthRangeFor3D);
                                if (1 !== a || i.paint.get("fill-extrusion-pattern").constantOr(1)) Gi(t, e, i, s, o, Mi.disabled, Si.disabled), Gi(t, e, i, s, o, t.stencilModeFor3D(), t.colorModeForRenderPass());
                                else {
                                    const a = t.colorModeForRenderPass();
                                    Gi(t, e, i, s, o, Mi.disabled, a);
                                }
                            }
                        }(e, i, s, a);
                        break;
                    case "hillshade":
                        !function(t, e, i, s) {
                            if ("offscreen" !== t.renderPass && "translucent" !== t.renderPass) return;
                            const a = t.context, o = t.depthModeForSublayer(0, Pi.ReadOnly), r = t.colorModeForRenderPass(), [n, l] = "translucent" === t.renderPass ? t.stencilConfigForOverlap(s) : [
                                {},
                                s
                            ];
                            for (const s of l){
                                const a = e.getTile(s);
                                void 0 !== a.needsHillshadePrepare && a.needsHillshadePrepare && "offscreen" === t.renderPass ? Vi(t, a, i, o, Mi.disabled, r) : "translucent" === t.renderPass && ji(t, s, a, i, o, n[s.overscaledZ], r);
                            }
                            a.viewport.set([
                                0,
                                0,
                                t.width,
                                t.height
                            ]);
                        }(e, i, s, a);
                        break;
                    case "raster":
                        !function(t, e, i, s) {
                            if ("translucent" !== t.renderPass) return;
                            if (0 === i.paint.get("raster-opacity")) return;
                            if (!s.length) return;
                            const a = t.context, o = a.gl, r = e.getSource(), n = t.useProgram("raster"), l = t.colorModeForRenderPass(), [h, c] = r instanceof N ? [
                                {},
                                s
                            ] : t.stencilConfigForOverlap(s), u = c[c.length - 1].overscaledZ, d = !t.options.moving;
                            for (const s of c){
                                const c = t.depthModeForSublayer(s.overscaledZ - u, 1 === i.paint.get("raster-opacity") ? Pi.ReadWrite : Pi.ReadOnly, o.LESS), _ = e.getTile(s);
                                _.registerFadeDuration(i.paint.get("raster-fade-duration"));
                                const p = e.findLoadedParent(s, 0), m = qi(_, p, e, i, t.transform, t.style.map.terrain);
                                let f, g;
                                const v = "nearest" === i.paint.get("raster-resampling") ? o.NEAREST : o.LINEAR;
                                a.activeTexture.set(o.TEXTURE0), _.texture.bind(v, o.CLAMP_TO_EDGE, o.LINEAR_MIPMAP_NEAREST), a.activeTexture.set(o.TEXTURE1), p ? (p.texture.bind(v, o.CLAMP_TO_EDGE, o.LINEAR_MIPMAP_NEAREST), f = Math.pow(2, p.tileID.overscaledZ - _.tileID.overscaledZ), g = [
                                    _.tileID.canonical.x * f % 1,
                                    _.tileID.canonical.y * f % 1
                                ]) : _.texture.bind(v, o.CLAMP_TO_EDGE, o.LINEAR_MIPMAP_NEAREST);
                                const x = t.style.map.terrain && t.style.map.terrain.getTerrainData(s), y = x ? s : null, b = y ? y.posMatrix : t.transform.calculatePosMatrix(s.toUnwrapped(), d), w = Me(b, g || [
                                    0,
                                    0
                                ], f || 1, m, i);
                                r instanceof N ? n.draw(a, o.TRIANGLES, c, Mi.disabled, l, zi.disabled, w, x, i.id, r.boundsBuffer, t.quadTriangleIndexBuffer, r.boundsSegments) : n.draw(a, o.TRIANGLES, c, h[s.overscaledZ], l, zi.disabled, w, x, i.id, t.rasterBoundsBuffer, t.quadTriangleIndexBuffer, t.rasterBoundsSegments);
                            }
                        }(e, i, s, a);
                        break;
                    case "background":
                        !function(t, e, i, s) {
                            const a = i.paint.get("background-color"), o = i.paint.get("background-opacity");
                            if (0 === o) return;
                            const r = t.context, n = r.gl, l = t.transform, h = l.tileSize, c = i.paint.get("background-pattern");
                            if (t.isPatternMissing(c)) return;
                            const u = !c && 1 === a.a && 1 === o && t.opaquePassEnabledForLayer() ? "opaque" : "translucent";
                            if (t.renderPass !== u) return;
                            const d = Mi.disabled, _ = t.depthModeForSublayer(0, "opaque" === u ? Pi.ReadWrite : Pi.ReadOnly), p = t.colorModeForRenderPass(), m = t.useProgram(c ? "backgroundPattern" : "background"), f = s || l.coveringTiles({
                                tileSize: h,
                                terrain: t.style.map.terrain
                            });
                            c && (r.activeTexture.set(n.TEXTURE0), t.imageManager.bind(t.context));
                            const g = i.getCrossfadeParameters();
                            for (const e of f){
                                const l = s ? e.posMatrix : t.transform.calculatePosMatrix(e.toUnwrapped()), u = c ? Fe(l, o, t, c, {
                                    tileID: e,
                                    tileSize: h
                                }, g) : ke(l, o, a), f = t.style.map.terrain && t.style.map.terrain.getTerrainData(e);
                                m.draw(r, n.TRIANGLES, _, d, p, zi.disabled, u, f, i.id, t.tileExtentBuffer, t.quadTriangleIndexBuffer, t.tileExtentSegments);
                            }
                        }(e, 0, s, a);
                        break;
                    case "custom":
                        !function(t, e, i) {
                            const s = t.context, a = i.implementation;
                            if ("offscreen" === t.renderPass) {
                                const e = a.prerender;
                                e && (t.setCustomLayerDefaults(), s.setColorMode(t.colorModeForRenderPass()), e.call(a, s.gl, t.transform.customLayerMatrix()), s.setDirty(), t.setBaseState());
                            } else if ("translucent" === t.renderPass) {
                                t.setCustomLayerDefaults(), s.setColorMode(t.colorModeForRenderPass()), s.setStencilMode(Mi.disabled);
                                const e = "3d" === a.renderingMode ? new Pi(t.context.gl.LEQUAL, Pi.ReadWrite, t.depthRangeFor3D) : t.depthModeForSublayer(0, Pi.ReadOnly);
                                s.setDepthMode(e), a.render(s.gl, t.transform.customLayerMatrix()), s.setDirty(), t.setBaseState(), s.bindFramebuffer.set(null);
                            }
                        }(e, 0, s);
                }
            }
            translatePosMatrix(e, i, s, a, o) {
                if (!s[0] && !s[1]) return e;
                const r = o ? "map" === a ? this.transform.angle : 0 : "viewport" === a ? -this.transform.angle : 0;
                if (r) {
                    const t = Math.sin(r), e = Math.cos(r);
                    s = [
                        s[0] * e - s[1] * t,
                        s[0] * t + s[1] * e
                    ];
                }
                const n = [
                    o ? s[0] : St(i, s[0], this.transform.zoom),
                    o ? s[1] : St(i, s[1], this.transform.zoom),
                    0
                ], l = new Float32Array(16);
                return t.$(l, e, n), l;
            }
            saveTileTexture(t) {
                const e = this._tileTextures[t.size[0]];
                e ? e.push(t) : this._tileTextures[t.size[0]] = [
                    t
                ];
            }
            getTileTexture(t) {
                const e = this._tileTextures[t];
                return e && e.length > 0 ? e.pop() : null;
            }
            isPatternMissing(t) {
                if (!t) return !1;
                if (!t.from || !t.to) return !0;
                const e = this.imageManager.getPattern(t.from.toString()), i = this.imageManager.getPattern(t.to.toString());
                return !e || !i;
            }
            useProgram(t, e) {
                this.cache = this.cache || {};
                const i = t + (e ? e.cacheKey : "") + (this._showOverdrawInspector ? "/overdraw" : "") + (this.style.map.terrain ? "/terrain" : "");
                return this.cache[i] || (this.cache[i] = new ce(this.context, re[t], e, Be[t], this._showOverdrawInspector, this.style.map.terrain)), this.cache[i];
            }
            setCustomLayerDefaults() {
                this.context.unbindVAO(), this.context.cullFace.setDefault(), this.context.activeTexture.setDefault(), this.context.pixelStoreUnpack.setDefault(), this.context.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.context.pixelStoreUnpackFlipY.setDefault();
            }
            setBaseState() {
                const t = this.context.gl;
                this.context.cullFace.set(!1), this.context.viewport.set([
                    0,
                    0,
                    this.width,
                    this.height
                ]), this.context.blendEquation.set(t.FUNC_ADD);
            }
            initDebugOverlayCanvas() {
                null == this.debugOverlayCanvas && (this.debugOverlayCanvas = document.createElement("canvas"), this.debugOverlayCanvas.width = 512, this.debugOverlayCanvas.height = 512, this.debugOverlayTexture = new x(this.context, this.debugOverlayCanvas, this.context.gl.RGBA));
            }
            destroy() {
                this.debugOverlayTexture && this.debugOverlayTexture.destroy();
            }
            overLimit() {
                const { drawingBufferWidth: t, drawingBufferHeight: e } = this.context.gl;
                return this.width !== t || this.height !== e;
            }
        }
        class ss {
            constructor(t, e){
                this.points = t, this.planes = e;
            }
            static fromInvProjectionMatrix(e, i, s) {
                const a = Math.pow(2, s), o = [
                    [
                        -1,
                        1,
                        -1,
                        1
                    ],
                    [
                        1,
                        1,
                        -1,
                        1
                    ],
                    [
                        1,
                        -1,
                        -1,
                        1
                    ],
                    [
                        -1,
                        -1,
                        -1,
                        1
                    ],
                    [
                        -1,
                        1,
                        1,
                        1
                    ],
                    [
                        1,
                        1,
                        1,
                        1
                    ],
                    [
                        1,
                        -1,
                        1,
                        1
                    ],
                    [
                        -1,
                        -1,
                        1,
                        1
                    ]
                ].map((s)=>{
                    const o = 1 / (s = t.ag([], s, e))[3] / i * a;
                    return t.b3(s, s, [
                        o,
                        o,
                        1 / s[3],
                        o
                    ]);
                }), r = [
                    [
                        0,
                        1,
                        2
                    ],
                    [
                        6,
                        5,
                        4
                    ],
                    [
                        0,
                        3,
                        7
                    ],
                    [
                        2,
                        1,
                        5
                    ],
                    [
                        3,
                        2,
                        6
                    ],
                    [
                        0,
                        4,
                        5
                    ]
                ].map((t)=>{
                    const e = function(t, e) {
                        var i = e[0], s = e[1], a = e[2], o = i * i + s * s + a * a;
                        return o > 0 && (o = 1 / Math.sqrt(o)), t[0] = e[0] * o, t[1] = e[1] * o, t[2] = e[2] * o, t;
                    }([], function(t, e, i) {
                        var s = e[0], a = e[1], o = e[2], r = i[0], n = i[1], l = i[2];
                        return t[0] = a * l - o * n, t[1] = o * r - s * l, t[2] = s * n - a * r, t;
                    }([], m([], o[t[0]], o[t[1]]), m([], o[t[2]], o[t[1]]))), i = -((s = e)[0] * (a = o[t[1]])[0] + s[1] * a[1] + s[2] * a[2]);
                    var s, a;
                    return e.concat(i);
                });
                return new ss(o, r);
            }
        }
        class as {
            constructor(t, e){
                this.min = t, this.max = e, this.center = function(t, e, i) {
                    return t[0] = .5 * e[0], t[1] = .5 * e[1], t[2] = .5 * e[2], t;
                }([], function(t, e, i) {
                    return t[0] = e[0] + i[0], t[1] = e[1] + i[1], t[2] = e[2] + i[2], t;
                }([], this.min, this.max));
            }
            quadrant(t) {
                const e = [
                    t % 2 == 0,
                    t < 2
                ], i = _(this.min), s = _(this.max);
                for(let t = 0; t < e.length; t++)i[t] = e[t] ? this.min[t] : this.center[t], s[t] = e[t] ? this.center[t] : this.max[t];
                return s[2] = this.max[2], new as(i, s);
            }
            distanceX(t) {
                return Math.max(Math.min(this.max[0], t[0]), this.min[0]) - t[0];
            }
            distanceY(t) {
                return Math.max(Math.min(this.max[1], t[1]), this.min[1]) - t[1];
            }
            intersects(e) {
                const i = [
                    [
                        this.min[0],
                        this.min[1],
                        this.min[2],
                        1
                    ],
                    [
                        this.max[0],
                        this.min[1],
                        this.min[2],
                        1
                    ],
                    [
                        this.max[0],
                        this.max[1],
                        this.min[2],
                        1
                    ],
                    [
                        this.min[0],
                        this.max[1],
                        this.min[2],
                        1
                    ],
                    [
                        this.min[0],
                        this.min[1],
                        this.max[2],
                        1
                    ],
                    [
                        this.max[0],
                        this.min[1],
                        this.max[2],
                        1
                    ],
                    [
                        this.max[0],
                        this.max[1],
                        this.max[2],
                        1
                    ],
                    [
                        this.min[0],
                        this.max[1],
                        this.max[2],
                        1
                    ]
                ];
                let s = !0;
                for(let a = 0; a < e.planes.length; a++){
                    const o = e.planes[a];
                    let r = 0;
                    for(let e = 0; e < i.length; e++)t.b4(o, i[e]) >= 0 && r++;
                    if (0 === r) return 0;
                    r !== i.length && (s = !1);
                }
                if (s) return 2;
                for(let t = 0; t < 3; t++){
                    let i = Number.MAX_VALUE, s = -Number.MAX_VALUE;
                    for(let a = 0; a < e.points.length; a++){
                        const o = e.points[a][t] - this.min[t];
                        i = Math.min(i, o), s = Math.max(s, o);
                    }
                    if (s < 0 || i > this.max[t] - this.min[t]) return 0;
                }
                return 1;
            }
        }
        class os {
            constructor(t = 0, e = 0, i = 0, s = 0){
                if (isNaN(t) || t < 0 || isNaN(e) || e < 0 || isNaN(i) || i < 0 || isNaN(s) || s < 0) throw new Error("Invalid value for edge-insets, top, bottom, left and right must all be numbers");
                this.top = t, this.bottom = e, this.left = i, this.right = s;
            }
            interpolate(e, i, s) {
                return null != i.top && null != e.top && (this.top = t.B.number(e.top, i.top, s)), null != i.bottom && null != e.bottom && (this.bottom = t.B.number(e.bottom, i.bottom, s)), null != i.left && null != e.left && (this.left = t.B.number(e.left, i.left, s)), null != i.right && null != e.right && (this.right = t.B.number(e.right, i.right, s)), this;
            }
            getCenter(e, i) {
                const s = t.ad((this.left + e - this.right) / 2, 0, e), a = t.ad((this.top + i - this.bottom) / 2, 0, i);
                return new t.P(s, a);
            }
            equals(t) {
                return this.top === t.top && this.bottom === t.bottom && this.left === t.left && this.right === t.right;
            }
            clone() {
                return new os(this.top, this.bottom, this.left, this.right);
            }
            toJSON() {
                return {
                    top: this.top,
                    bottom: this.bottom,
                    left: this.left,
                    right: this.right
                };
            }
        }
        class rs {
            constructor(e, i, s, a, o){
                this.tileSize = 512, this.maxValidLatitude = 85.051129, this._renderWorldCopies = void 0 === o || !!o, this._minZoom = e || 0, this._maxZoom = i || 22, this._minPitch = null == s ? 0 : s, this._maxPitch = null == a ? 60 : a, this.setMaxBounds(), this.width = 0, this.height = 0, this._center = new t.L(0, 0), this._elevation = 0, this.zoom = 0, this.angle = 0, this._fov = .6435011087932844, this._pitch = 0, this._unmodified = !0, this._edgeInsets = new os, this._posMatrixCache = {}, this._alignedPosMatrixCache = {}, this._minEleveationForCurrentTile = 0;
            }
            clone() {
                const t = new rs(this._minZoom, this._maxZoom, this._minPitch, this.maxPitch, this._renderWorldCopies);
                return t.apply(this), t;
            }
            apply(t) {
                this.tileSize = t.tileSize, this.latRange = t.latRange, this.width = t.width, this.height = t.height, this._center = t._center, this._elevation = t._elevation, this._minEleveationForCurrentTile = t._minEleveationForCurrentTile, this.zoom = t.zoom, this.angle = t.angle, this._fov = t._fov, this._pitch = t._pitch, this._unmodified = t._unmodified, this._edgeInsets = t._edgeInsets.clone(), this._calcMatrices();
            }
            get minZoom() {
                return this._minZoom;
            }
            set minZoom(t) {
                this._minZoom !== t && (this._minZoom = t, this.zoom = Math.max(this.zoom, t));
            }
            get maxZoom() {
                return this._maxZoom;
            }
            set maxZoom(t) {
                this._maxZoom !== t && (this._maxZoom = t, this.zoom = Math.min(this.zoom, t));
            }
            get minPitch() {
                return this._minPitch;
            }
            set minPitch(t) {
                this._minPitch !== t && (this._minPitch = t, this.pitch = Math.max(this.pitch, t));
            }
            get maxPitch() {
                return this._maxPitch;
            }
            set maxPitch(t) {
                this._maxPitch !== t && (this._maxPitch = t, this.pitch = Math.min(this.pitch, t));
            }
            get renderWorldCopies() {
                return this._renderWorldCopies;
            }
            set renderWorldCopies(t) {
                void 0 === t ? t = !0 : null === t && (t = !1), this._renderWorldCopies = t;
            }
            get worldSize() {
                return this.tileSize * this.scale;
            }
            get centerOffset() {
                return this.centerPoint._sub(this.size._div(2));
            }
            get size() {
                return new t.P(this.width, this.height);
            }
            get bearing() {
                return -this.angle / Math.PI * 180;
            }
            set bearing(e) {
                const i = -t.b5(e, -180, 180) * Math.PI / 180;
                this.angle !== i && (this._unmodified = !1, this.angle = i, this._calcMatrices(), this.rotationMatrix = function() {
                    var e = new t.A(4);
                    return t.A != Float32Array && (e[1] = 0, e[2] = 0), e[0] = 1, e[3] = 1, e;
                }(), function(t, e, i) {
                    var s = e[0], a = e[1], o = e[2], r = e[3], n = Math.sin(i), l = Math.cos(i);
                    t[0] = s * l + o * n, t[1] = a * l + r * n, t[2] = s * -n + o * l, t[3] = a * -n + r * l;
                }(this.rotationMatrix, this.rotationMatrix, this.angle));
            }
            get pitch() {
                return this._pitch / Math.PI * 180;
            }
            set pitch(e) {
                const i = t.ad(e, this.minPitch, this.maxPitch) / 180 * Math.PI;
                this._pitch !== i && (this._unmodified = !1, this._pitch = i, this._calcMatrices());
            }
            get fov() {
                return this._fov / Math.PI * 180;
            }
            set fov(t) {
                t = Math.max(.01, Math.min(60, t)), this._fov !== t && (this._unmodified = !1, this._fov = t / 180 * Math.PI, this._calcMatrices());
            }
            get zoom() {
                return this._zoom;
            }
            set zoom(t) {
                const e = Math.min(Math.max(t, this.minZoom), this.maxZoom);
                this._zoom !== e && (this._unmodified = !1, this._zoom = e, this.tileZoom = Math.max(0, Math.floor(e)), this.scale = this.zoomScale(e), this._constrain(), this._calcMatrices());
            }
            get center() {
                return this._center;
            }
            set center(t) {
                t.lat === this._center.lat && t.lng === this._center.lng || (this._unmodified = !1, this._center = t, this._constrain(), this._calcMatrices());
            }
            get elevation() {
                return this._elevation;
            }
            set elevation(t) {
                t !== this._elevation && (this._elevation = t, this._constrain(), this._calcMatrices());
            }
            get padding() {
                return this._edgeInsets.toJSON();
            }
            set padding(t) {
                this._edgeInsets.equals(t) || (this._unmodified = !1, this._edgeInsets.interpolate(this._edgeInsets, t, 1), this._calcMatrices());
            }
            get centerPoint() {
                return this._edgeInsets.getCenter(this.width, this.height);
            }
            isPaddingEqual(t) {
                return this._edgeInsets.equals(t);
            }
            interpolatePadding(t, e, i) {
                this._unmodified = !1, this._edgeInsets.interpolate(t, e, i), this._constrain(), this._calcMatrices();
            }
            coveringZoomLevel(t) {
                const e = (t.roundZoom ? Math.round : Math.floor)(this.zoom + this.scaleZoom(this.tileSize / t.tileSize));
                return Math.max(0, e);
            }
            getVisibleUnwrappedCoordinates(e) {
                const i = [
                    new t.b6(0, e)
                ];
                if (this._renderWorldCopies) {
                    const s = this.pointCoordinate(new t.P(0, 0)), a = this.pointCoordinate(new t.P(this.width, 0)), o = this.pointCoordinate(new t.P(this.width, this.height)), r = this.pointCoordinate(new t.P(0, this.height)), n = Math.floor(Math.min(s.x, a.x, o.x, r.x)), l = Math.floor(Math.max(s.x, a.x, o.x, r.x)), h = 1;
                    for(let s = n - h; s <= l + h; s++)0 !== s && i.push(new t.b6(s, e));
                }
                return i;
            }
            coveringTiles(e) {
                var i, s;
                let a = this.coveringZoomLevel(e);
                const o = a;
                if (void 0 !== e.minzoom && a < e.minzoom) return [];
                void 0 !== e.maxzoom && a > e.maxzoom && (a = e.maxzoom);
                const r = this.pointCoordinate(this.getCameraPoint()), n = t.U.fromLngLat(this.center), l = Math.pow(2, a), h = [
                    l * r.x,
                    l * r.y,
                    0
                ], c = [
                    l * n.x,
                    l * n.y,
                    0
                ], u = ss.fromInvProjectionMatrix(this.invProjMatrix, this.worldSize, a);
                let d = e.minzoom || 0;
                !e.terrain && this.pitch <= 60 && this._edgeInsets.top < .1 && (d = a);
                const _ = e.terrain ? 2 / Math.min(this.tileSize, e.tileSize) * this.tileSize : 3, p = (t)=>({
                        aabb: new as([
                            t * l,
                            0,
                            0
                        ], [
                            (t + 1) * l,
                            l,
                            0
                        ]),
                        zoom: 0,
                        x: 0,
                        y: 0,
                        wrap: t,
                        fullyVisible: !1
                    }), m = [], g = [], v = a, x = e.reparseOverscaled ? o : a;
                if (this._renderWorldCopies) for(let t = 1; t <= 3; t++)m.push(p(-t)), m.push(p(t));
                for(m.push(p(0)); m.length > 0;){
                    const a = m.pop(), o = a.x, r = a.y;
                    let n = a.fullyVisible;
                    if (!n) {
                        const t = a.aabb.intersects(u);
                        if (0 === t) continue;
                        n = 2 === t;
                    }
                    const l = e.terrain ? h : c, p = a.aabb.distanceX(l), y = a.aabb.distanceY(l), b = Math.max(Math.abs(p), Math.abs(y));
                    if (a.zoom === v || b > _ + (1 << v - a.zoom) - 2 && a.zoom >= d) {
                        const e = v - a.zoom, i = h[0] - .5 - (o << e), s = h[1] - .5 - (r << e);
                        g.push({
                            tileID: new t.O(a.zoom === v ? x : a.zoom, a.wrap, a.zoom, o, r),
                            distanceSq: f([
                                c[0] - .5 - o,
                                c[1] - .5 - r
                            ]),
                            tileDistanceToCamera: Math.sqrt(i * i + s * s)
                        });
                    } else for(let l = 0; l < 4; l++){
                        const h = (o << 1) + l % 2, c = (r << 1) + (l >> 1), u = a.zoom + 1;
                        let d = a.aabb.quadrant(l);
                        if (e.terrain) {
                            const o = new t.O(u, a.wrap, u, h, c), r = e.terrain.getMinMaxElevation(o), n = null !== (i = r.minElevation) && void 0 !== i ? i : this.elevation, l = null !== (s = r.maxElevation) && void 0 !== s ? s : this.elevation;
                            d = new as([
                                d.min[0],
                                d.min[1],
                                n
                            ], [
                                d.max[0],
                                d.max[1],
                                l
                            ]);
                        }
                        m.push({
                            aabb: d,
                            zoom: u,
                            x: h,
                            y: c,
                            wrap: a.wrap,
                            fullyVisible: n
                        });
                    }
                }
                return g.sort((t, e)=>t.distanceSq - e.distanceSq).map((t)=>t.tileID);
            }
            resize(t, e) {
                this.width = t, this.height = e, this.pixelsToGLUnits = [
                    2 / t,
                    -2 / e
                ], this._constrain(), this._calcMatrices();
            }
            get unmodified() {
                return this._unmodified;
            }
            zoomScale(t) {
                return Math.pow(2, t);
            }
            scaleZoom(t) {
                return Math.log(t) / Math.LN2;
            }
            project(e) {
                const i = t.ad(e.lat, -this.maxValidLatitude, this.maxValidLatitude);
                return new t.P(t.G(e.lng) * this.worldSize, t.H(i) * this.worldSize);
            }
            unproject(e) {
                return new t.U(e.x / this.worldSize, e.y / this.worldSize).toLngLat();
            }
            get point() {
                return this.project(this.center);
            }
            getCameraPosition() {
                return {
                    lngLat: this.pointLocation(this.getCameraPoint()),
                    altitude: Math.cos(this._pitch) * this.cameraToCenterDistance / this._pixelPerMeter + this.elevation
                };
            }
            recalculateZoom(e) {
                const i = this.pointLocation(this.centerPoint, e), s = e.getElevationForLngLatZoom(i, this.tileZoom);
                if (!(this.elevation - s)) return;
                const a = this.getCameraPosition(), o = t.U.fromLngLat(a.lngLat, a.altitude), r = t.U.fromLngLat(i, s), n = o.x - r.x, l = o.y - r.y, h = o.z - r.z, c = Math.sqrt(n * n + l * l + h * h), u = this.scaleZoom(this.cameraToCenterDistance / c / this.tileSize);
                this._elevation = s, this._center = i, this.zoom = u;
            }
            setLocationAtPoint(e, i) {
                const s = this.pointCoordinate(i), a = this.pointCoordinate(this.centerPoint), o = this.locationCoordinate(e), r = new t.U(o.x - (s.x - a.x), o.y - (s.y - a.y));
                this.center = this.coordinateLocation(r), this._renderWorldCopies && (this.center = this.center.wrap());
            }
            locationPoint(t, e) {
                return e ? this.coordinatePoint(this.locationCoordinate(t), e.getElevationForLngLatZoom(t, this.tileZoom), this.pixelMatrix3D) : this.coordinatePoint(this.locationCoordinate(t));
            }
            pointLocation(t, e) {
                return this.coordinateLocation(this.pointCoordinate(t, e));
            }
            locationCoordinate(e) {
                return t.U.fromLngLat(e);
            }
            coordinateLocation(t) {
                return t && t.toLngLat();
            }
            pointCoordinate(e, i) {
                if (i) {
                    const t = i.pointCoordinate(e);
                    if (null != t) return t;
                }
                const s = [
                    e.x,
                    e.y,
                    0,
                    1
                ], a = [
                    e.x,
                    e.y,
                    1,
                    1
                ];
                t.ag(s, s, this.pixelMatrixInverse), t.ag(a, a, this.pixelMatrixInverse);
                const o = s[3], r = a[3], n = s[1] / o, l = a[1] / r, h = s[2] / o, c = a[2] / r, u = h === c ? 0 : (0 - h) / (c - h);
                return new t.U(t.B.number(s[0] / o, a[0] / r, u) / this.worldSize, t.B.number(n, l, u) / this.worldSize);
            }
            coordinatePoint(e, i = 0, s = this.pixelMatrix) {
                const a = [
                    e.x * this.worldSize,
                    e.y * this.worldSize,
                    i,
                    1
                ];
                return t.ag(a, a, s), new t.P(a[0] / a[3], a[1] / a[3]);
            }
            getBounds() {
                const e = Math.max(0, this.height / 2 - this.getHorizon());
                return (new L).extend(this.pointLocation(new t.P(0, e))).extend(this.pointLocation(new t.P(this.width, e))).extend(this.pointLocation(new t.P(this.width, this.height))).extend(this.pointLocation(new t.P(0, this.height)));
            }
            getMaxBounds() {
                return this.latRange && 2 === this.latRange.length && this.lngRange && 2 === this.lngRange.length ? new L([
                    this.lngRange[0],
                    this.latRange[0]
                ], [
                    this.lngRange[1],
                    this.latRange[1]
                ]) : null;
            }
            getHorizon() {
                return Math.tan(Math.PI / 2 - this._pitch) * this.cameraToCenterDistance * .85;
            }
            setMaxBounds(t) {
                t ? (this.lngRange = [
                    t.getWest(),
                    t.getEast()
                ], this.latRange = [
                    t.getSouth(),
                    t.getNorth()
                ], this._constrain()) : (this.lngRange = null, this.latRange = [
                    -this.maxValidLatitude,
                    this.maxValidLatitude
                ]);
            }
            calculatePosMatrix(e, i = !1) {
                const s = e.key, a = i ? this._alignedPosMatrixCache : this._posMatrixCache;
                if (a[s]) return a[s];
                const o = e.canonical, r = this.worldSize / this.zoomScale(o.z), n = o.x + Math.pow(2, o.z) * e.wrap, l = t.ao(new Float64Array(16));
                return t.$(l, l, [
                    n * r,
                    o.y * r,
                    0
                ]), t.a0(l, l, [
                    r / t.N,
                    r / t.N,
                    1
                ]), t.a1(l, i ? this.alignedProjMatrix : this.projMatrix, l), a[s] = new Float32Array(l), a[s];
            }
            customLayerMatrix() {
                return this.mercatorMatrix.slice();
            }
            _constrain() {
                if (!this.center || !this.width || !this.height || this._constraining) return;
                this._constraining = !0;
                let e, i, s, a, o = -90, r = 90, n = -180, l = 180;
                const h = this.size, c = this._unmodified;
                if (this.latRange) {
                    const i = this.latRange;
                    o = t.H(i[1]) * this.worldSize, r = t.H(i[0]) * this.worldSize, e = r - o < h.y ? h.y / (r - o) : 0;
                }
                if (this.lngRange) {
                    const e = this.lngRange;
                    n = t.b5(t.G(e[0]) * this.worldSize, 0, this.worldSize), l = t.b5(t.G(e[1]) * this.worldSize, 0, this.worldSize), l < n && (l += this.worldSize), i = l - n < h.x ? h.x / (l - n) : 0;
                }
                const u = this.point, d = Math.max(i || 0, e || 0);
                if (d) return this.center = this.unproject(new t.P(i ? (l + n) / 2 : u.x, e ? (r + o) / 2 : u.y)), this.zoom += this.scaleZoom(d), this._unmodified = c, void (this._constraining = !1);
                if (this.latRange) {
                    const t = u.y, e = h.y / 2;
                    t - e < o && (a = o + e), t + e > r && (a = r - e);
                }
                if (this.lngRange) {
                    const e = (n + l) / 2, i = t.b5(u.x, e - this.worldSize / 2, e + this.worldSize / 2), a = h.x / 2;
                    i - a < n && (s = n + a), i + a > l && (s = l - a);
                }
                void 0 === s && void 0 === a || (this.center = this.unproject(new t.P(void 0 !== s ? s : u.x, void 0 !== a ? a : u.y)).wrap()), this._unmodified = c, this._constraining = !1;
            }
            _calcMatrices() {
                if (!this.height) return;
                const e = this.centerOffset, i = this.point.x, s = this.point.y;
                this.cameraToCenterDistance = .5 / Math.tan(this._fov / 2) * this.height, this._pixelPerMeter = t.b7(1, this.center.lat) * this.worldSize;
                let a = t.ao(new Float64Array(16));
                t.a0(a, a, [
                    this.width / 2,
                    -this.height / 2,
                    1
                ]), t.$(a, a, [
                    1,
                    -1,
                    0
                ]), this.labelPlaneMatrix = a, a = t.ao(new Float64Array(16)), t.a0(a, a, [
                    1,
                    -1,
                    1
                ]), t.$(a, a, [
                    -1,
                    -1,
                    0
                ]), t.a0(a, a, [
                    2 / this.width,
                    2 / this.height,
                    1
                ]), this.glCoordMatrix = a;
                const o = this.cameraToCenterDistance + this._elevation * this._pixelPerMeter / Math.cos(this._pitch), r = Math.min(this.elevation, this._minEleveationForCurrentTile), n = o - r * this._pixelPerMeter / Math.cos(this._pitch), l = r < 0 ? n : o, h = Math.PI / 2 + this._pitch, c = this._fov * (.5 + e.y / this.height), u = Math.sin(c) * l / Math.sin(t.ad(Math.PI - h - c, .01, Math.PI - .01)), d = this.getHorizon(), _ = 2 * Math.atan(d / this.cameraToCenterDistance) * (.5 + e.y / (2 * d)), p = Math.sin(_) * l / Math.sin(t.ad(Math.PI - h - _, .01, Math.PI - .01)), m = Math.min(u, p), f = 1.01 * (Math.cos(Math.PI / 2 - this._pitch) * m + l), g = this.height / 50;
                a = new Float64Array(16), t.b8(a, this._fov, this.width / this.height, g, f), a[8] = 2 * -e.x / this.width, a[9] = 2 * e.y / this.height, t.a0(a, a, [
                    1,
                    -1,
                    1
                ]), t.$(a, a, [
                    0,
                    0,
                    -this.cameraToCenterDistance
                ]), t.b9(a, a, this._pitch), t.ae(a, a, this.angle), t.$(a, a, [
                    -i,
                    -s,
                    0
                ]), this.mercatorMatrix = t.a0([], a, [
                    this.worldSize,
                    this.worldSize,
                    this.worldSize
                ]), t.a0(a, a, [
                    1,
                    1,
                    this._pixelPerMeter
                ]), this.pixelMatrix = t.a1(new Float64Array(16), this.labelPlaneMatrix, a), t.$(a, a, [
                    0,
                    0,
                    -this.elevation
                ]), this.projMatrix = a, this.invProjMatrix = t.as([], a), this.pixelMatrix3D = t.a1(new Float64Array(16), this.labelPlaneMatrix, a);
                const v = this.width % 2 / 2, x = this.height % 2 / 2, y = Math.cos(this.angle), b = Math.sin(this.angle), w = i - Math.round(i) + y * v + b * x, T = s - Math.round(s) + y * x + b * v, I = new Float64Array(a);
                if (t.$(I, I, [
                    w > .5 ? w - 1 : w,
                    T > .5 ? T - 1 : T,
                    0
                ]), this.alignedProjMatrix = I, a = t.as(new Float64Array(16), this.pixelMatrix), !a) throw new Error("failed to invert matrix");
                this.pixelMatrixInverse = a, this._posMatrixCache = {}, this._alignedPosMatrixCache = {};
            }
            maxPitchScaleFactor() {
                if (!this.pixelMatrixInverse) return 1;
                const e = this.pointCoordinate(new t.P(0, 0)), i = [
                    e.x * this.worldSize,
                    e.y * this.worldSize,
                    0,
                    1
                ];
                return t.ag(i, i, this.pixelMatrix)[3] / this.cameraToCenterDistance;
            }
            getCameraPoint() {
                const e = Math.tan(this._pitch) * (this.cameraToCenterDistance || 1);
                return this.centerPoint.add(new t.P(0, e));
            }
            getCameraQueryGeometry(e) {
                const i = this.getCameraPoint();
                if (1 === e.length) return [
                    e[0],
                    i
                ];
                {
                    let s = i.x, a = i.y, o = i.x, r = i.y;
                    for (const t of e)s = Math.min(s, t.x), a = Math.min(a, t.y), o = Math.max(o, t.x), r = Math.max(r, t.y);
                    return [
                        new t.P(s, a),
                        new t.P(o, a),
                        new t.P(o, r),
                        new t.P(s, r),
                        new t.P(s, a)
                    ];
                }
            }
        }
        function ns(t, e) {
            let i, s = !1, a = null, o = null;
            const r = ()=>{
                a = null, s && (t.apply(o, i), a = setTimeout(r, e), s = !1);
            };
            return (...t)=>(s = !0, o = this, i = t, a || r(), a);
        }
        class ls {
            constructor(t){
                this._getCurrentHash = ()=>{
                    const t = window.location.hash.replace("#", "");
                    if (this._hashName) {
                        let e;
                        return t.split("&").map((t)=>t.split("=")).forEach((t)=>{
                            t[0] === this._hashName && (e = t);
                        }), (e && e[1] || "").split("/");
                    }
                    return t.split("/");
                }, this._onHashChange = ()=>{
                    const t = this._getCurrentHash();
                    if (t.length >= 3 && !t.some((t)=>isNaN(t))) {
                        const e = this._map.dragRotate.isEnabled() && this._map.touchZoomRotate.isEnabled() ? +(t[3] || 0) : this._map.getBearing();
                        return this._map.jumpTo({
                            center: [
                                +t[2],
                                +t[1]
                            ],
                            zoom: +t[0],
                            bearing: e,
                            pitch: +(t[4] || 0)
                        }), !0;
                    }
                    return !1;
                }, this._updateHashUnthrottled = ()=>{
                    const t = window.location.href.replace(/(#.+)?$/, this.getHashString());
                    try {
                        window.history.replaceState(window.history.state, null, t);
                    } catch (t) {}
                }, this._updateHash = ns(this._updateHashUnthrottled, 300), this._hashName = t && encodeURIComponent(t);
            }
            addTo(t) {
                return this._map = t, addEventListener("hashchange", this._onHashChange, !1), this._map.on("moveend", this._updateHash), this;
            }
            remove() {
                return removeEventListener("hashchange", this._onHashChange, !1), this._map.off("moveend", this._updateHash), clearTimeout(this._updateHash()), delete this._map, this;
            }
            getHashString(t) {
                const e = this._map.getCenter(), i = Math.round(100 * this._map.getZoom()) / 100, s = Math.ceil((i * Math.LN2 + Math.log(512 / 360 / .5)) / Math.LN10), a = Math.pow(10, s), o = Math.round(e.lng * a) / a, r = Math.round(e.lat * a) / a, n = this._map.getBearing(), l = this._map.getPitch();
                let h = "";
                if (h += t ? `/${o}/${r}/${i}` : `${i}/${r}/${o}`, (n || l) && (h += "/" + Math.round(10 * n) / 10), l && (h += `/${Math.round(l)}`), this._hashName) {
                    const t = this._hashName;
                    let e = !1;
                    const i = window.location.hash.slice(1).split("&").map((i)=>{
                        const s = i.split("=")[0];
                        return s === t ? (e = !0, `${s}=${h}`) : i;
                    }).filter((t)=>t);
                    return e || i.push(`${t}=${h}`), `#${i.join("&")}`;
                }
                return `#${h}`;
            }
        }
        const hs = {
            linearity: .3,
            easing: t.ba(0, 0, .3, 1)
        }, cs = t.e({
            deceleration: 2500,
            maxSpeed: 1400
        }, hs), us = t.e({
            deceleration: 20,
            maxSpeed: 1400
        }, hs), ds = t.e({
            deceleration: 1e3,
            maxSpeed: 360
        }, hs), _s = t.e({
            deceleration: 1e3,
            maxSpeed: 90
        }, hs);
        class ps {
            constructor(t){
                this._map = t, this.clear();
            }
            clear() {
                this._inertiaBuffer = [];
            }
            record(e) {
                this._drainInertiaBuffer(), this._inertiaBuffer.push({
                    time: t.h.now(),
                    settings: e
                });
            }
            _drainInertiaBuffer() {
                const e = this._inertiaBuffer, i = t.h.now();
                for(; e.length > 0 && i - e[0].time > 160;)e.shift();
            }
            _onMoveEnd(e) {
                if (this._drainInertiaBuffer(), this._inertiaBuffer.length < 2) return;
                const i = {
                    zoom: 0,
                    bearing: 0,
                    pitch: 0,
                    pan: new t.P(0, 0),
                    pinchAround: void 0,
                    around: void 0
                };
                for (const { settings: t } of this._inertiaBuffer)i.zoom += t.zoomDelta || 0, i.bearing += t.bearingDelta || 0, i.pitch += t.pitchDelta || 0, t.panDelta && i.pan._add(t.panDelta), t.around && (i.around = t.around), t.pinchAround && (i.pinchAround = t.pinchAround);
                const s = this._inertiaBuffer[this._inertiaBuffer.length - 1].time - this._inertiaBuffer[0].time, a = {};
                if (i.pan.mag()) {
                    const o = fs(i.pan.mag(), s, t.e({}, cs, e || {}));
                    a.offset = i.pan.mult(o.amount / i.pan.mag()), a.center = this._map.transform.center, ms(a, o);
                }
                if (i.zoom) {
                    const t = fs(i.zoom, s, us);
                    a.zoom = this._map.transform.zoom + t.amount, ms(a, t);
                }
                if (i.bearing) {
                    const e = fs(i.bearing, s, ds);
                    a.bearing = this._map.transform.bearing + t.ad(e.amount, -179, 179), ms(a, e);
                }
                if (i.pitch) {
                    const t = fs(i.pitch, s, _s);
                    a.pitch = this._map.transform.pitch + t.amount, ms(a, t);
                }
                if (a.zoom || a.bearing) {
                    const t = void 0 === i.pinchAround ? i.around : i.pinchAround;
                    a.around = t ? this._map.unproject(t) : this._map.getCenter();
                }
                return this.clear(), t.e(a, {
                    noMoveStart: !0
                });
            }
        }
        function ms(t, e) {
            (!t.duration || t.duration < e.duration) && (t.duration = e.duration, t.easing = e.easing);
        }
        function fs(e, i, s) {
            const { maxSpeed: a, linearity: o, deceleration: r } = s, n = t.ad(e * o / (i / 1e3), -a, a), l = Math.abs(n) / (r * o);
            return {
                easing: s.easing,
                duration: 1e3 * l,
                amount: n * (l / 2)
            };
        }
        class gs extends t.k {
            preventDefault() {
                this._defaultPrevented = !0;
            }
            get defaultPrevented() {
                return this._defaultPrevented;
            }
            constructor(e, s, a, o = {}){
                const r = i.mousePos(s.getCanvasContainer(), a), n = s.unproject(r);
                super(e, t.e({
                    point: r,
                    lngLat: n,
                    originalEvent: a
                }, o)), this._defaultPrevented = !1, this.target = s;
            }
        }
        class vs extends t.k {
            preventDefault() {
                this._defaultPrevented = !0;
            }
            get defaultPrevented() {
                return this._defaultPrevented;
            }
            constructor(e, s, a){
                const o = "touchend" === e ? a.changedTouches : a.touches, r = i.touchPos(s.getCanvasContainer(), o), n = r.map((t)=>s.unproject(t)), l = r.reduce((t, e, i, s)=>t.add(e.div(s.length)), new t.P(0, 0));
                super(e, {
                    points: r,
                    point: l,
                    lngLats: n,
                    lngLat: s.unproject(l),
                    originalEvent: a
                }), this._defaultPrevented = !1;
            }
        }
        class xs extends t.k {
            preventDefault() {
                this._defaultPrevented = !0;
            }
            get defaultPrevented() {
                return this._defaultPrevented;
            }
            constructor(t, e, i){
                super(t, {
                    originalEvent: i
                }), this._defaultPrevented = !1;
            }
        }
        class ys {
            constructor(t, e){
                this._map = t, this._clickTolerance = e.clickTolerance;
            }
            reset() {
                delete this._mousedownPos;
            }
            wheel(t) {
                return this._firePreventable(new xs(t.type, this._map, t));
            }
            mousedown(t, e) {
                return this._mousedownPos = e, this._firePreventable(new gs(t.type, this._map, t));
            }
            mouseup(t) {
                this._map.fire(new gs(t.type, this._map, t));
            }
            click(t, e) {
                this._mousedownPos && this._mousedownPos.dist(e) >= this._clickTolerance || this._map.fire(new gs(t.type, this._map, t));
            }
            dblclick(t) {
                return this._firePreventable(new gs(t.type, this._map, t));
            }
            mouseover(t) {
                this._map.fire(new gs(t.type, this._map, t));
            }
            mouseout(t) {
                this._map.fire(new gs(t.type, this._map, t));
            }
            touchstart(t) {
                return this._firePreventable(new vs(t.type, this._map, t));
            }
            touchmove(t) {
                this._map.fire(new vs(t.type, this._map, t));
            }
            touchend(t) {
                this._map.fire(new vs(t.type, this._map, t));
            }
            touchcancel(t) {
                this._map.fire(new vs(t.type, this._map, t));
            }
            _firePreventable(t) {
                if (this._map.fire(t), t.defaultPrevented) return {};
            }
            isEnabled() {
                return !0;
            }
            isActive() {
                return !1;
            }
            enable() {}
            disable() {}
        }
        class bs {
            constructor(t){
                this._map = t;
            }
            reset() {
                this._delayContextMenu = !1, this._ignoreContextMenu = !0, delete this._contextMenuEvent;
            }
            mousemove(t) {
                this._map.fire(new gs(t.type, this._map, t));
            }
            mousedown() {
                this._delayContextMenu = !0, this._ignoreContextMenu = !1;
            }
            mouseup() {
                this._delayContextMenu = !1, this._contextMenuEvent && (this._map.fire(new gs("contextmenu", this._map, this._contextMenuEvent)), delete this._contextMenuEvent);
            }
            contextmenu(t) {
                this._delayContextMenu ? this._contextMenuEvent = t : this._ignoreContextMenu || this._map.fire(new gs(t.type, this._map, t)), this._map.listens("contextmenu") && t.preventDefault();
            }
            isEnabled() {
                return !0;
            }
            isActive() {
                return !1;
            }
            enable() {}
            disable() {}
        }
        class ws {
            constructor(t){
                this._map = t;
            }
            get transform() {
                return this._map._requestedCameraState || this._map.transform;
            }
            get center() {
                return {
                    lng: this.transform.center.lng,
                    lat: this.transform.center.lat
                };
            }
            get zoom() {
                return this.transform.zoom;
            }
            get pitch() {
                return this.transform.pitch;
            }
            get bearing() {
                return this.transform.bearing;
            }
            unproject(e) {
                return this.transform.pointLocation(t.P.convert(e), this._map.terrain);
            }
        }
        class Ts {
            constructor(t, e){
                this._map = t, this._tr = new ws(t), this._el = t.getCanvasContainer(), this._container = t.getContainer(), this._clickTolerance = e.clickTolerance || 1;
            }
            isEnabled() {
                return !!this._enabled;
            }
            isActive() {
                return !!this._active;
            }
            enable() {
                this.isEnabled() || (this._enabled = !0);
            }
            disable() {
                this.isEnabled() && (this._enabled = !1);
            }
            mousedown(t, e) {
                this.isEnabled() && t.shiftKey && 0 === t.button && (i.disableDrag(), this._startPos = this._lastPos = e, this._active = !0);
            }
            mousemoveWindow(t, e) {
                if (!this._active) return;
                const s = e;
                if (this._lastPos.equals(s) || !this._box && s.dist(this._startPos) < this._clickTolerance) return;
                const a = this._startPos;
                this._lastPos = s, this._box || (this._box = i.create("div", "maplibregl-boxzoom", this._container), this._container.classList.add("maplibregl-crosshair"), this._fireEvent("boxzoomstart", t));
                const o = Math.min(a.x, s.x), r = Math.max(a.x, s.x), n = Math.min(a.y, s.y), l = Math.max(a.y, s.y);
                i.setTransform(this._box, `translate(${o}px,${n}px)`), this._box.style.width = r - o + "px", this._box.style.height = l - n + "px";
            }
            mouseupWindow(e, s) {
                if (!this._active) return;
                if (0 !== e.button) return;
                const a = this._startPos, o = s;
                if (this.reset(), i.suppressClick(), a.x !== o.x || a.y !== o.y) return this._map.fire(new t.k("boxzoomend", {
                    originalEvent: e
                })), {
                    cameraAnimation: (t)=>t.fitScreenCoordinates(a, o, this._tr.bearing, {
                            linear: !0
                        })
                };
                this._fireEvent("boxzoomcancel", e);
            }
            keydown(t) {
                this._active && 27 === t.keyCode && (this.reset(), this._fireEvent("boxzoomcancel", t));
            }
            reset() {
                this._active = !1, this._container.classList.remove("maplibregl-crosshair"), this._box && (i.remove(this._box), this._box = null), i.enableDrag(), delete this._startPos, delete this._lastPos;
            }
            _fireEvent(e, i) {
                return this._map.fire(new t.k(e, {
                    originalEvent: i
                }));
            }
        }
        function Is(t, e) {
            if (t.length !== e.length) throw new Error(`The number of touches and points are not equal - touches ${t.length}, points ${e.length}`);
            const i = {};
            for(let s = 0; s < t.length; s++)i[t[s].identifier] = e[s];
            return i;
        }
        class Es {
            constructor(t){
                this.reset(), this.numTouches = t.numTouches;
            }
            reset() {
                delete this.centroid, delete this.startTime, delete this.touches, this.aborted = !1;
            }
            touchstart(e, i, s) {
                (this.centroid || s.length > this.numTouches) && (this.aborted = !0), this.aborted || (void 0 === this.startTime && (this.startTime = e.timeStamp), s.length === this.numTouches && (this.centroid = function(e) {
                    const i = new t.P(0, 0);
                    for (const t of e)i._add(t);
                    return i.div(e.length);
                }(i), this.touches = Is(s, i)));
            }
            touchmove(t, e, i) {
                if (this.aborted || !this.centroid) return;
                const s = Is(i, e);
                for(const t in this.touches){
                    const e = s[t];
                    (!e || e.dist(this.touches[t]) > 30) && (this.aborted = !0);
                }
            }
            touchend(t, e, i) {
                if ((!this.centroid || t.timeStamp - this.startTime > 500) && (this.aborted = !0), 0 === i.length) {
                    const t = !this.aborted && this.centroid;
                    if (this.reset(), t) return t;
                }
            }
        }
        class Ss {
            constructor(t){
                this.singleTap = new Es(t), this.numTaps = t.numTaps, this.reset();
            }
            reset() {
                this.lastTime = 1 / 0, delete this.lastTap, this.count = 0, this.singleTap.reset();
            }
            touchstart(t, e, i) {
                this.singleTap.touchstart(t, e, i);
            }
            touchmove(t, e, i) {
                this.singleTap.touchmove(t, e, i);
            }
            touchend(t, e, i) {
                const s = this.singleTap.touchend(t, e, i);
                if (s) {
                    const e = t.timeStamp - this.lastTime < 500, i = !this.lastTap || this.lastTap.dist(s) < 30;
                    if (e && i || this.reset(), this.count++, this.lastTime = t.timeStamp, this.lastTap = s, this.count === this.numTaps) return this.reset(), s;
                }
            }
        }
        class Cs {
            constructor(t){
                this._tr = new ws(t), this._zoomIn = new Ss({
                    numTouches: 1,
                    numTaps: 2
                }), this._zoomOut = new Ss({
                    numTouches: 2,
                    numTaps: 1
                }), this.reset();
            }
            reset() {
                this._active = !1, this._zoomIn.reset(), this._zoomOut.reset();
            }
            touchstart(t, e, i) {
                this._zoomIn.touchstart(t, e, i), this._zoomOut.touchstart(t, e, i);
            }
            touchmove(t, e, i) {
                this._zoomIn.touchmove(t, e, i), this._zoomOut.touchmove(t, e, i);
            }
            touchend(t, e, i) {
                const s = this._zoomIn.touchend(t, e, i), a = this._zoomOut.touchend(t, e, i), o = this._tr;
                return s ? (this._active = !0, t.preventDefault(), setTimeout(()=>this.reset(), 0), {
                    cameraAnimation: (e)=>e.easeTo({
                            duration: 300,
                            zoom: o.zoom + 1,
                            around: o.unproject(s)
                        }, {
                            originalEvent: t
                        })
                }) : a ? (this._active = !0, t.preventDefault(), setTimeout(()=>this.reset(), 0), {
                    cameraAnimation: (e)=>e.easeTo({
                            duration: 300,
                            zoom: o.zoom - 1,
                            around: o.unproject(a)
                        }, {
                            originalEvent: t
                        })
                }) : void 0;
            }
            touchcancel() {
                this.reset();
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        class Ps {
            constructor(t){
                this._enabled = !!t.enable, this._moveStateManager = t.moveStateManager, this._clickTolerance = t.clickTolerance || 1, this._moveFunction = t.move, this._activateOnStart = !!t.activateOnStart, t.assignEvents(this), this.reset();
            }
            reset(t) {
                this._active = !1, this._moved = !1, delete this._lastPoint, this._moveStateManager.endMove(t);
            }
            _move(...t) {
                const e = this._moveFunction(...t);
                if (e.bearingDelta || e.pitchDelta || e.around || e.panDelta) return this._active = !0, e;
            }
            dragStart(t, e) {
                this.isEnabled() && !this._lastPoint && this._moveStateManager.isValidStartEvent(t) && (this._moveStateManager.startMove(t), this._lastPoint = e.length ? e[0] : e, this._activateOnStart && this._lastPoint && (this._active = !0));
            }
            dragMove(t, e) {
                if (!this.isEnabled()) return;
                const i = this._lastPoint;
                if (!i) return;
                if (t.preventDefault(), !this._moveStateManager.isValidMoveEvent(t)) return void this.reset(t);
                const s = e.length ? e[0] : e;
                return !this._moved && s.dist(i) < this._clickTolerance ? void 0 : (this._moved = !0, this._lastPoint = s, this._move(i, s));
            }
            dragEnd(t) {
                this.isEnabled() && this._lastPoint && this._moveStateManager.isValidEndEvent(t) && (this._moved && i.suppressClick(), this.reset(t));
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
            getClickTolerance() {
                return this._clickTolerance;
            }
        }
        const Ds = {
            0: 1,
            2: 2
        };
        class Ms {
            constructor(t){
                this._correctEvent = t.checkCorrectEvent;
            }
            startMove(t) {
                const e = i.mouseButton(t);
                this._eventButton = e;
            }
            endMove(t) {
                delete this._eventButton;
            }
            isValidStartEvent(t) {
                return this._correctEvent(t);
            }
            isValidMoveEvent(t) {
                return !function(t, e) {
                    const i = Ds[e];
                    return void 0 === t.buttons || (t.buttons & i) !== i;
                }(t, this._eventButton);
            }
            isValidEndEvent(t) {
                return i.mouseButton(t) === this._eventButton;
            }
        }
        class zs {
            constructor(){
                this._firstTouch = void 0;
            }
            _isOneFingerTouch(t) {
                return 1 === t.targetTouches.length;
            }
            _isSameTouchEvent(t) {
                return t.targetTouches[0].identifier === this._firstTouch;
            }
            startMove(t) {
                this._firstTouch = t.targetTouches[0].identifier;
            }
            endMove(t) {
                delete this._firstTouch;
            }
            isValidStartEvent(t) {
                return this._isOneFingerTouch(t);
            }
            isValidMoveEvent(t) {
                return this._isOneFingerTouch(t) && this._isSameTouchEvent(t);
            }
            isValidEndEvent(t) {
                return this._isOneFingerTouch(t) && this._isSameTouchEvent(t);
            }
        }
        const Ls = (t)=>{
            t.mousedown = t.dragStart, t.mousemoveWindow = t.dragMove, t.mouseup = t.dragEnd, t.contextmenu = function(t) {
                t.preventDefault();
            };
        }, As = ({ enable: t, clickTolerance: e, bearingDegreesPerPixelMoved: s = .8 })=>{
            const a = new Ms({
                checkCorrectEvent: (t)=>0 === i.mouseButton(t) && t.ctrlKey || 2 === i.mouseButton(t)
            });
            return new Ps({
                clickTolerance: e,
                move: (t, e)=>({
                        bearingDelta: (e.x - t.x) * s
                    }),
                moveStateManager: a,
                enable: t,
                assignEvents: Ls
            });
        }, Rs = ({ enable: t, clickTolerance: e, pitchDegreesPerPixelMoved: s = -0.5 })=>{
            const a = new Ms({
                checkCorrectEvent: (t)=>0 === i.mouseButton(t) && t.ctrlKey || 2 === i.mouseButton(t)
            });
            return new Ps({
                clickTolerance: e,
                move: (t, e)=>({
                        pitchDelta: (e.y - t.y) * s
                    }),
                moveStateManager: a,
                enable: t,
                assignEvents: Ls
            });
        };
        class ks {
            constructor(t, e){
                this._minTouches = t.cooperativeGestures ? 2 : 1, this._clickTolerance = t.clickTolerance || 1, this._map = e, this.reset();
            }
            reset() {
                this._active = !1, this._touches = {}, this._sum = new t.P(0, 0), setTimeout(()=>{
                    this._cancelCooperativeMessage = !1;
                }, 200);
            }
            touchstart(t, e, i) {
                return this._calculateTransform(t, e, i);
            }
            touchmove(t, e, i) {
                if (this._map._cooperativeGestures && (2 === this._minTouches && i.length < 2 && !this._cancelCooperativeMessage ? this._map._onCooperativeGesture(t, !1, i.length) : this._cancelCooperativeMessage || (this._cancelCooperativeMessage = !0)), this._active && !(i.length < this._minTouches)) return t.preventDefault(), this._calculateTransform(t, e, i);
            }
            touchend(t, e, i) {
                this._calculateTransform(t, e, i), this._active && i.length < this._minTouches && this.reset();
            }
            touchcancel() {
                this.reset();
            }
            _calculateTransform(e, i, s) {
                s.length > 0 && (this._active = !0);
                const a = Is(s, i), o = new t.P(0, 0), r = new t.P(0, 0);
                let n = 0;
                for(const t in a){
                    const e = a[t], i = this._touches[t];
                    i && (o._add(e), r._add(e.sub(i)), n++, a[t] = e);
                }
                if (this._touches = a, n < this._minTouches || !r.mag()) return;
                const l = r.div(n);
                return this._sum._add(l), this._sum.mag() < this._clickTolerance ? void 0 : {
                    around: o.div(n),
                    panDelta: l
                };
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        class Fs {
            constructor(){
                this.reset();
            }
            reset() {
                this._active = !1, delete this._firstTwoTouches;
            }
            touchstart(t, e, i) {
                this._firstTwoTouches || i.length < 2 || (this._firstTwoTouches = [
                    i[0].identifier,
                    i[1].identifier
                ], this._start([
                    e[0],
                    e[1]
                ]));
            }
            touchmove(t, e, i) {
                if (!this._firstTwoTouches) return;
                t.preventDefault();
                const [s, a] = this._firstTwoTouches, o = Bs(i, e, s), r = Bs(i, e, a);
                if (!o || !r) return;
                const n = this._aroundCenter ? null : o.add(r).div(2);
                return this._move([
                    o,
                    r
                ], n, t);
            }
            touchend(t, e, s) {
                if (!this._firstTwoTouches) return;
                const [a, o] = this._firstTwoTouches, r = Bs(s, e, a), n = Bs(s, e, o);
                r && n || (this._active && i.suppressClick(), this.reset());
            }
            touchcancel() {
                this.reset();
            }
            enable(t) {
                this._enabled = !0, this._aroundCenter = !!t && "center" === t.around;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        function Bs(t, e, i) {
            for(let s = 0; s < t.length; s++)if (t[s].identifier === i) return e[s];
        }
        function Os(t, e) {
            return Math.log(t / e) / Math.LN2;
        }
        class Ns extends Fs {
            reset() {
                super.reset(), delete this._distance, delete this._startDistance;
            }
            _start(t) {
                this._startDistance = this._distance = t[0].dist(t[1]);
            }
            _move(t, e) {
                const i = this._distance;
                if (this._distance = t[0].dist(t[1]), this._active || !(Math.abs(Os(this._distance, this._startDistance)) < .1)) return this._active = !0, {
                    zoomDelta: Os(this._distance, i),
                    pinchAround: e
                };
            }
        }
        function Us(t, e) {
            return 180 * t.angleWith(e) / Math.PI;
        }
        class Zs extends Fs {
            reset() {
                super.reset(), delete this._minDiameter, delete this._startVector, delete this._vector;
            }
            _start(t) {
                this._startVector = this._vector = t[0].sub(t[1]), this._minDiameter = t[0].dist(t[1]);
            }
            _move(t, e) {
                const i = this._vector;
                if (this._vector = t[0].sub(t[1]), this._active || !this._isBelowThreshold(this._vector)) return this._active = !0, {
                    bearingDelta: Us(this._vector, i),
                    pinchAround: e
                };
            }
            _isBelowThreshold(t) {
                this._minDiameter = Math.min(this._minDiameter, t.mag());
                const e = 25 / (Math.PI * this._minDiameter) * 360, i = Us(t, this._startVector);
                return Math.abs(i) < e;
            }
        }
        function Gs(t) {
            return Math.abs(t.y) > Math.abs(t.x);
        }
        class js extends Fs {
            constructor(t){
                super(), this._map = t;
            }
            reset() {
                super.reset(), this._valid = void 0, delete this._firstMove, delete this._lastPoints;
            }
            touchstart(t, e, i) {
                super.touchstart(t, e, i), this._currentTouchCount = i.length;
            }
            _start(t) {
                this._lastPoints = t, Gs(t[0].sub(t[1])) && (this._valid = !1);
            }
            _move(t, e, i) {
                if (this._map._cooperativeGestures && this._currentTouchCount < 3) return;
                const s = t[0].sub(this._lastPoints[0]), a = t[1].sub(this._lastPoints[1]);
                return this._valid = this.gestureBeginsVertically(s, a, i.timeStamp), this._valid ? (this._lastPoints = t, this._active = !0, {
                    pitchDelta: (s.y + a.y) / 2 * -0.5
                }) : void 0;
            }
            gestureBeginsVertically(t, e, i) {
                if (void 0 !== this._valid) return this._valid;
                const s = t.mag() >= 2, a = e.mag() >= 2;
                if (!s && !a) return;
                if (!s || !a) return void 0 === this._firstMove && (this._firstMove = i), i - this._firstMove < 100 && void 0;
                const o = t.y > 0 == e.y > 0;
                return Gs(t) && Gs(e) && o;
            }
        }
        const Vs = {
            panStep: 100,
            bearingStep: 15,
            pitchStep: 10
        };
        class qs {
            constructor(t){
                this._tr = new ws(t);
                const e = Vs;
                this._panStep = e.panStep, this._bearingStep = e.bearingStep, this._pitchStep = e.pitchStep, this._rotationDisabled = !1;
            }
            reset() {
                this._active = !1;
            }
            keydown(t) {
                if (t.altKey || t.ctrlKey || t.metaKey) return;
                let e = 0, i = 0, s = 0, a = 0, o = 0;
                switch(t.keyCode){
                    case 61:
                    case 107:
                    case 171:
                    case 187:
                        e = 1;
                        break;
                    case 189:
                    case 109:
                    case 173:
                        e = -1;
                        break;
                    case 37:
                        t.shiftKey ? i = -1 : (t.preventDefault(), a = -1);
                        break;
                    case 39:
                        t.shiftKey ? i = 1 : (t.preventDefault(), a = 1);
                        break;
                    case 38:
                        t.shiftKey ? s = 1 : (t.preventDefault(), o = -1);
                        break;
                    case 40:
                        t.shiftKey ? s = -1 : (t.preventDefault(), o = 1);
                        break;
                    default:
                        return;
                }
                return this._rotationDisabled && (i = 0, s = 0), {
                    cameraAnimation: (r)=>{
                        const n = this._tr;
                        r.easeTo({
                            duration: 300,
                            easeId: "keyboardHandler",
                            easing: $s,
                            zoom: e ? Math.round(n.zoom) + e * (t.shiftKey ? 2 : 1) : n.zoom,
                            bearing: n.bearing + i * this._bearingStep,
                            pitch: n.pitch + s * this._pitchStep,
                            offset: [
                                -a * this._panStep,
                                -o * this._panStep
                            ],
                            center: n.center
                        }, {
                            originalEvent: t
                        });
                    }
                };
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
            disableRotation() {
                this._rotationDisabled = !0;
            }
            enableRotation() {
                this._rotationDisabled = !1;
            }
        }
        function $s(t) {
            return t * (2 - t);
        }
        const Ws = 4.000244140625;
        class Hs {
            constructor(t, e){
                this._onTimeout = (t)=>{
                    this._type = "wheel", this._delta -= this._lastValue, this._active || this._start(t);
                }, this._map = t, this._tr = new ws(t), this._el = t.getCanvasContainer(), this._triggerRenderFrame = e, this._delta = 0, this._defaultZoomRate = .01, this._wheelZoomRate = .0022222222222222222;
            }
            setZoomRate(t) {
                this._defaultZoomRate = t;
            }
            setWheelZoomRate(t) {
                this._wheelZoomRate = t;
            }
            isEnabled() {
                return !!this._enabled;
            }
            isActive() {
                return !!this._active || void 0 !== this._finishTimeout;
            }
            isZooming() {
                return !!this._zooming;
            }
            enable(t) {
                this.isEnabled() || (this._enabled = !0, this._aroundCenter = !!t && "center" === t.around);
            }
            disable() {
                this.isEnabled() && (this._enabled = !1);
            }
            wheel(e) {
                if (!this.isEnabled()) return;
                if (this._map._cooperativeGestures) {
                    if (!e[this._map._metaKey]) return;
                    e.preventDefault();
                }
                let i = e.deltaMode === WheelEvent.DOM_DELTA_LINE ? 40 * e.deltaY : e.deltaY;
                const s = t.h.now(), a = s - (this._lastWheelEventTime || 0);
                this._lastWheelEventTime = s, 0 !== i && i % Ws == 0 ? this._type = "wheel" : 0 !== i && Math.abs(i) < 4 ? this._type = "trackpad" : a > 400 ? (this._type = null, this._lastValue = i, this._timeout = setTimeout(this._onTimeout, 40, e)) : this._type || (this._type = Math.abs(a * i) < 200 ? "trackpad" : "wheel", this._timeout && (clearTimeout(this._timeout), this._timeout = null, i += this._lastValue)), e.shiftKey && i && (i /= 4), this._type && (this._lastWheelEvent = e, this._delta -= i, this._active || this._start(e)), e.preventDefault();
            }
            _start(e) {
                if (!this._delta) return;
                this._frameId && (this._frameId = null), this._active = !0, this.isZooming() || (this._zooming = !0), this._finishTimeout && (clearTimeout(this._finishTimeout), delete this._finishTimeout);
                const s = i.mousePos(this._el, e), a = this._tr;
                this._around = t.L.convert(this._aroundCenter ? a.center : a.unproject(s)), this._aroundPoint = a.transform.locationPoint(this._around), this._frameId || (this._frameId = !0, this._triggerRenderFrame());
            }
            renderFrame() {
                if (!this._frameId) return;
                if (this._frameId = null, !this.isActive()) return;
                const e = this._tr.transform;
                if (0 !== this._delta) {
                    const t = "wheel" === this._type && Math.abs(this._delta) > Ws ? this._wheelZoomRate : this._defaultZoomRate;
                    let i = 2 / (1 + Math.exp(-Math.abs(this._delta * t)));
                    this._delta < 0 && 0 !== i && (i = 1 / i);
                    const s = "number" == typeof this._targetZoom ? e.zoomScale(this._targetZoom) : e.scale;
                    this._targetZoom = Math.min(e.maxZoom, Math.max(e.minZoom, e.scaleZoom(s * i))), "wheel" === this._type && (this._startZoom = e.zoom, this._easing = this._smoothOutEasing(200)), this._delta = 0;
                }
                const i = "number" == typeof this._targetZoom ? this._targetZoom : e.zoom, s = this._startZoom, a = this._easing;
                let o, r = !1;
                if ("wheel" === this._type && s && a) {
                    const e = Math.min((t.h.now() - this._lastWheelEventTime) / 200, 1), n = a(e);
                    o = t.B.number(s, i, n), e < 1 ? this._frameId || (this._frameId = !0) : r = !0;
                } else o = i, r = !0;
                return this._active = !0, r && (this._active = !1, this._finishTimeout = setTimeout(()=>{
                    this._zooming = !1, this._triggerRenderFrame(), delete this._targetZoom, delete this._finishTimeout;
                }, 200)), {
                    noInertia: !0,
                    needsRenderFrame: !r,
                    zoomDelta: o - e.zoom,
                    around: this._aroundPoint,
                    originalEvent: this._lastWheelEvent
                };
            }
            _smoothOutEasing(e) {
                let i = t.bb;
                if (this._prevEase) {
                    const e = this._prevEase, s = (t.h.now() - e.start) / e.duration, a = e.easing(s + .01) - e.easing(s), o = .27 / Math.sqrt(a * a + 1e-4) * .01, r = Math.sqrt(.0729 - o * o);
                    i = t.ba(o, r, .25, 1);
                }
                return this._prevEase = {
                    start: t.h.now(),
                    duration: e,
                    easing: i
                }, i;
            }
            reset() {
                this._active = !1, this._zooming = !1, delete this._targetZoom, this._finishTimeout && (clearTimeout(this._finishTimeout), delete this._finishTimeout);
            }
        }
        class Xs {
            constructor(t, e){
                this._clickZoom = t, this._tapZoom = e;
            }
            enable() {
                this._clickZoom.enable(), this._tapZoom.enable();
            }
            disable() {
                this._clickZoom.disable(), this._tapZoom.disable();
            }
            isEnabled() {
                return this._clickZoom.isEnabled() && this._tapZoom.isEnabled();
            }
            isActive() {
                return this._clickZoom.isActive() || this._tapZoom.isActive();
            }
        }
        class Ks {
            constructor(t){
                this._tr = new ws(t), this.reset();
            }
            reset() {
                this._active = !1;
            }
            dblclick(t, e) {
                return t.preventDefault(), {
                    cameraAnimation: (i)=>{
                        i.easeTo({
                            duration: 300,
                            zoom: this._tr.zoom + (t.shiftKey ? -1 : 1),
                            around: this._tr.unproject(e)
                        }, {
                            originalEvent: t
                        });
                    }
                };
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        class Qs {
            constructor(){
                this._tap = new Ss({
                    numTouches: 1,
                    numTaps: 1
                }), this.reset();
            }
            reset() {
                this._active = !1, delete this._swipePoint, delete this._swipeTouch, delete this._tapTime, delete this._tapPoint, this._tap.reset();
            }
            touchstart(t, e, i) {
                if (!this._swipePoint) {
                    if (this._tapTime) {
                        const s = e[0], a = t.timeStamp - this._tapTime < 500, o = this._tapPoint.dist(s) < 30;
                        a && o ? i.length > 0 && (this._swipePoint = s, this._swipeTouch = i[0].identifier) : this.reset();
                    } else this._tap.touchstart(t, e, i);
                }
            }
            touchmove(t, e, i) {
                if (this._tapTime) {
                    if (this._swipePoint) {
                        if (i[0].identifier !== this._swipeTouch) return;
                        const s = e[0], a = s.y - this._swipePoint.y;
                        return this._swipePoint = s, t.preventDefault(), this._active = !0, {
                            zoomDelta: a / 128
                        };
                    }
                } else this._tap.touchmove(t, e, i);
            }
            touchend(t, e, i) {
                if (this._tapTime) this._swipePoint && 0 === i.length && this.reset();
                else {
                    const s = this._tap.touchend(t, e, i);
                    s && (this._tapTime = t.timeStamp, this._tapPoint = s);
                }
            }
            touchcancel() {
                this.reset();
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        class Ys {
            constructor(t, e, i){
                this._el = t, this._mousePan = e, this._touchPan = i;
            }
            enable(t) {
                this._inertiaOptions = t || {}, this._mousePan.enable(), this._touchPan.enable(), this._el.classList.add("maplibregl-touch-drag-pan");
            }
            disable() {
                this._mousePan.disable(), this._touchPan.disable(), this._el.classList.remove("maplibregl-touch-drag-pan");
            }
            isEnabled() {
                return this._mousePan.isEnabled() && this._touchPan.isEnabled();
            }
            isActive() {
                return this._mousePan.isActive() || this._touchPan.isActive();
            }
        }
        class Js {
            constructor(t, e, i){
                this._pitchWithRotate = t.pitchWithRotate, this._mouseRotate = e, this._mousePitch = i;
            }
            enable() {
                this._mouseRotate.enable(), this._pitchWithRotate && this._mousePitch.enable();
            }
            disable() {
                this._mouseRotate.disable(), this._mousePitch.disable();
            }
            isEnabled() {
                return this._mouseRotate.isEnabled() && (!this._pitchWithRotate || this._mousePitch.isEnabled());
            }
            isActive() {
                return this._mouseRotate.isActive() || this._mousePitch.isActive();
            }
        }
        class ta {
            constructor(t, e, i, s){
                this._el = t, this._touchZoom = e, this._touchRotate = i, this._tapDragZoom = s, this._rotationDisabled = !1, this._enabled = !0;
            }
            enable(t) {
                this._touchZoom.enable(t), this._rotationDisabled || this._touchRotate.enable(t), this._tapDragZoom.enable(), this._el.classList.add("maplibregl-touch-zoom-rotate");
            }
            disable() {
                this._touchZoom.disable(), this._touchRotate.disable(), this._tapDragZoom.disable(), this._el.classList.remove("maplibregl-touch-zoom-rotate");
            }
            isEnabled() {
                return this._touchZoom.isEnabled() && (this._rotationDisabled || this._touchRotate.isEnabled()) && this._tapDragZoom.isEnabled();
            }
            isActive() {
                return this._touchZoom.isActive() || this._touchRotate.isActive() || this._tapDragZoom.isActive();
            }
            disableRotation() {
                this._rotationDisabled = !0, this._touchRotate.disable();
            }
            enableRotation() {
                this._rotationDisabled = !1, this._touchZoom.isEnabled() && this._touchRotate.enable();
            }
        }
        const ea = (t)=>t.zoom || t.drag || t.pitch || t.rotate;
        class ia extends t.k {
        }
        function sa(t) {
            return t.panDelta && t.panDelta.mag() || t.zoomDelta || t.bearingDelta || t.pitchDelta;
        }
        class aa {
            constructor(t, e){
                this.handleWindowEvent = (t)=>{
                    this.handleEvent(t, `${t.type}Window`);
                }, this.handleEvent = (t, e)=>{
                    if ("blur" === t.type) return void this.stop(!0);
                    this._updatingCamera = !0;
                    const s = "renderFrame" === t.type ? void 0 : t, a = {
                        needsRenderFrame: !1
                    }, o = {}, r = {}, n = t.touches, l = n ? this._getMapTouches(n) : void 0, h = l ? i.touchPos(this._el, l) : i.mousePos(this._el, t);
                    for (const { handlerName: i, handler: n, allowed: c } of this._handlers){
                        if (!n.isEnabled()) continue;
                        let u;
                        this._blockedByActive(r, c, i) ? n.reset() : n[e || t.type] && (u = n[e || t.type](t, h, l), this.mergeHandlerResult(a, o, u, i, s), u && u.needsRenderFrame && this._triggerRenderFrame()), (u || n.isActive()) && (r[i] = n);
                    }
                    const c = {};
                    for(const t in this._previousActiveHandlers)r[t] || (c[t] = s);
                    this._previousActiveHandlers = r, (Object.keys(c).length || sa(a)) && (this._changes.push([
                        a,
                        o,
                        c
                    ]), this._triggerRenderFrame()), (Object.keys(r).length || sa(a)) && this._map._stop(!0), this._updatingCamera = !1;
                    const { cameraAnimation: u } = a;
                    u && (this._inertia.clear(), this._fireEvents({}, {}, !0), this._changes = [], u(this._map));
                }, this._map = t, this._el = this._map.getCanvasContainer(), this._handlers = [], this._handlersById = {}, this._changes = [], this._inertia = new ps(t), this._bearingSnap = e.bearingSnap, this._previousActiveHandlers = {}, this._eventsInProgress = {}, this._addDefaultHandlers(e);
                const s = this._el;
                this._listeners = [
                    [
                        s,
                        "touchstart",
                        {
                            passive: !0
                        }
                    ],
                    [
                        s,
                        "touchmove",
                        {
                            passive: !1
                        }
                    ],
                    [
                        s,
                        "touchend",
                        void 0
                    ],
                    [
                        s,
                        "touchcancel",
                        void 0
                    ],
                    [
                        s,
                        "mousedown",
                        void 0
                    ],
                    [
                        s,
                        "mousemove",
                        void 0
                    ],
                    [
                        s,
                        "mouseup",
                        void 0
                    ],
                    [
                        document,
                        "mousemove",
                        {
                            capture: !0
                        }
                    ],
                    [
                        document,
                        "mouseup",
                        void 0
                    ],
                    [
                        s,
                        "mouseover",
                        void 0
                    ],
                    [
                        s,
                        "mouseout",
                        void 0
                    ],
                    [
                        s,
                        "dblclick",
                        void 0
                    ],
                    [
                        s,
                        "click",
                        void 0
                    ],
                    [
                        s,
                        "keydown",
                        {
                            capture: !1
                        }
                    ],
                    [
                        s,
                        "keyup",
                        void 0
                    ],
                    [
                        s,
                        "wheel",
                        {
                            passive: !1
                        }
                    ],
                    [
                        s,
                        "contextmenu",
                        void 0
                    ],
                    [
                        window,
                        "blur",
                        void 0
                    ]
                ];
                for (const [t, e, s] of this._listeners)i.addEventListener(t, e, t === document ? this.handleWindowEvent : this.handleEvent, s);
            }
            destroy() {
                for (const [t, e, s] of this._listeners)i.removeEventListener(t, e, t === document ? this.handleWindowEvent : this.handleEvent, s);
            }
            _addDefaultHandlers(t) {
                const e = this._map, s = e.getCanvasContainer();
                this._add("mapEvent", new ys(e, t));
                const a = e.boxZoom = new Ts(e, t);
                this._add("boxZoom", a), t.interactive && t.boxZoom && a.enable();
                const o = new Cs(e), r = new Ks(e);
                e.doubleClickZoom = new Xs(r, o), this._add("tapZoom", o), this._add("clickZoom", r), t.interactive && t.doubleClickZoom && e.doubleClickZoom.enable();
                const n = new Qs;
                this._add("tapDragZoom", n);
                const l = e.touchPitch = new js(e);
                this._add("touchPitch", l), t.interactive && t.touchPitch && e.touchPitch.enable(t.touchPitch);
                const h = As(t), c = Rs(t);
                e.dragRotate = new Js(t, h, c), this._add("mouseRotate", h, [
                    "mousePitch"
                ]), this._add("mousePitch", c, [
                    "mouseRotate"
                ]), t.interactive && t.dragRotate && e.dragRotate.enable();
                const u = (({ enable: t, clickTolerance: e })=>{
                    const s = new Ms({
                        checkCorrectEvent: (t)=>0 === i.mouseButton(t) && !t.ctrlKey
                    });
                    return new Ps({
                        clickTolerance: e,
                        move: (t, e)=>({
                                around: e,
                                panDelta: e.sub(t)
                            }),
                        activateOnStart: !0,
                        moveStateManager: s,
                        enable: t,
                        assignEvents: Ls
                    });
                })(t), d = new ks(t, e);
                e.dragPan = new Ys(s, u, d), this._add("mousePan", u), this._add("touchPan", d, [
                    "touchZoom",
                    "touchRotate"
                ]), t.interactive && t.dragPan && e.dragPan.enable(t.dragPan);
                const _ = new Zs, p = new Ns;
                e.touchZoomRotate = new ta(s, p, _, n), this._add("touchRotate", _, [
                    "touchPan",
                    "touchZoom"
                ]), this._add("touchZoom", p, [
                    "touchPan",
                    "touchRotate"
                ]), t.interactive && t.touchZoomRotate && e.touchZoomRotate.enable(t.touchZoomRotate);
                const m = e.scrollZoom = new Hs(e, ()=>this._triggerRenderFrame());
                this._add("scrollZoom", m, [
                    "mousePan"
                ]), t.interactive && t.scrollZoom && e.scrollZoom.enable(t.scrollZoom);
                const f = e.keyboard = new qs(e);
                this._add("keyboard", f), t.interactive && t.keyboard && e.keyboard.enable(), this._add("blockableMapEvent", new bs(e));
            }
            _add(t, e, i) {
                this._handlers.push({
                    handlerName: t,
                    handler: e,
                    allowed: i
                }), this._handlersById[t] = e;
            }
            stop(t) {
                if (!this._updatingCamera) {
                    for (const { handler: t } of this._handlers)t.reset();
                    this._inertia.clear(), this._fireEvents({}, {}, t), this._changes = [];
                }
            }
            isActive() {
                for (const { handler: t } of this._handlers)if (t.isActive()) return !0;
                return !1;
            }
            isZooming() {
                return !!this._eventsInProgress.zoom || this._map.scrollZoom.isZooming();
            }
            isRotating() {
                return !!this._eventsInProgress.rotate;
            }
            isMoving() {
                return Boolean(ea(this._eventsInProgress)) || this.isZooming();
            }
            _blockedByActive(t, e, i) {
                for(const s in t)if (s !== i && (!e || e.indexOf(s) < 0)) return !0;
                return !1;
            }
            _getMapTouches(t) {
                const e = [];
                for (const i of t)this._el.contains(i.target) && e.push(i);
                return e;
            }
            mergeHandlerResult(e, i, s, a, o) {
                if (!s) return;
                t.e(e, s);
                const r = {
                    handlerName: a,
                    originalEvent: s.originalEvent || o
                };
                void 0 !== s.zoomDelta && (i.zoom = r), void 0 !== s.panDelta && (i.drag = r), void 0 !== s.pitchDelta && (i.pitch = r), void 0 !== s.bearingDelta && (i.rotate = r);
            }
            _applyChanges() {
                const e = {}, i = {}, s = {};
                for (const [a, o, r] of this._changes)a.panDelta && (e.panDelta = (e.panDelta || new t.P(0, 0))._add(a.panDelta)), a.zoomDelta && (e.zoomDelta = (e.zoomDelta || 0) + a.zoomDelta), a.bearingDelta && (e.bearingDelta = (e.bearingDelta || 0) + a.bearingDelta), a.pitchDelta && (e.pitchDelta = (e.pitchDelta || 0) + a.pitchDelta), void 0 !== a.around && (e.around = a.around), void 0 !== a.pinchAround && (e.pinchAround = a.pinchAround), a.noInertia && (e.noInertia = a.noInertia), t.e(i, o), t.e(s, r);
                this._updateMapTransform(e, i, s), this._changes = [];
            }
            _updateMapTransform(t, e, i) {
                const s = this._map, a = s._getTransformForUpdate(), o = s.terrain;
                if (!(sa(t) || o && this._terrainMovement)) return this._fireEvents(e, i, !0);
                let { panDelta: r, zoomDelta: n, bearingDelta: l, pitchDelta: h, around: c, pinchAround: u } = t;
                void 0 !== u && (c = u), s._stop(!0), c = c || s.transform.centerPoint;
                const d = a.pointLocation(r ? c.sub(r) : c);
                l && (a.bearing += l), h && (a.pitch += h), n && (a.zoom += n), o ? this._terrainMovement || !e.drag && !e.zoom ? e.drag && this._terrainMovement ? a.center = a.pointLocation(a.centerPoint.sub(r)) : a.setLocationAtPoint(d, c) : (this._terrainMovement = !0, this._map._elevationFreeze = !0, a.setLocationAtPoint(d, c), this._map.once("moveend", ()=>{
                    this._map._elevationFreeze = !1, this._terrainMovement = !1, a.recalculateZoom(s.terrain);
                })) : a.setLocationAtPoint(d, c), s._applyUpdatedTransform(a), this._map._update(), t.noInertia || this._inertia.record(t), this._fireEvents(e, i, !0);
            }
            _fireEvents(e, i, s) {
                const a = ea(this._eventsInProgress), o = ea(e), r = {};
                for(const t in e){
                    const { originalEvent: i } = e[t];
                    this._eventsInProgress[t] || (r[`${t}start`] = i), this._eventsInProgress[t] = e[t];
                }
                !a && o && this._fireEvent("movestart", o.originalEvent);
                for(const t in r)this._fireEvent(t, r[t]);
                o && this._fireEvent("move", o.originalEvent);
                for(const t in e){
                    const { originalEvent: i } = e[t];
                    this._fireEvent(t, i);
                }
                const n = {};
                let l;
                for(const t in this._eventsInProgress){
                    const { handlerName: e, originalEvent: s } = this._eventsInProgress[t];
                    this._handlersById[e].isActive() || (delete this._eventsInProgress[t], l = i[e] || s, n[`${t}end`] = l);
                }
                for(const t in n)this._fireEvent(t, n[t]);
                const h = ea(this._eventsInProgress);
                if (s && (a || o) && !h) {
                    this._updatingCamera = !0;
                    const e = this._inertia._onMoveEnd(this._map.dragPan._inertiaOptions), i = (t)=>0 !== t && -this._bearingSnap < t && t < this._bearingSnap;
                    !e || !e.essential && t.h.prefersReducedMotion ? (this._map.fire(new t.k("moveend", {
                        originalEvent: l
                    })), i(this._map.getBearing()) && this._map.resetNorth()) : (i(e.bearing || this._map.getBearing()) && (e.bearing = 0), e.freezeElevation = !0, this._map.easeTo(e, {
                        originalEvent: l
                    })), this._updatingCamera = !1;
                }
            }
            _fireEvent(e, i) {
                this._map.fire(new t.k(e, i ? {
                    originalEvent: i
                } : {}));
            }
            _requestFrame() {
                return this._map.triggerRepaint(), this._map._renderTaskQueue.add((t)=>{
                    delete this._frameId, this.handleEvent(new ia("renderFrame", {
                        timeStamp: t
                    })), this._applyChanges();
                });
            }
            _triggerRenderFrame() {
                void 0 === this._frameId && (this._frameId = this._requestFrame());
            }
        }
        class oa extends t.E {
            constructor(e, i){
                super(), this._renderFrameCallback = ()=>{
                    const e = Math.min((t.h.now() - this._easeStart) / this._easeOptions.duration, 1);
                    this._onEaseFrame(this._easeOptions.easing(e)), e < 1 && this._easeFrameId ? this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback) : this.stop();
                }, this._moving = !1, this._zooming = !1, this.transform = e, this._bearingSnap = i.bearingSnap, this.on("moveend", ()=>{
                    delete this._requestedCameraState;
                });
            }
            getCenter() {
                return new t.L(this.transform.center.lng, this.transform.center.lat);
            }
            setCenter(t, e) {
                return this.jumpTo({
                    center: t
                }, e);
            }
            panBy(e, i, s) {
                return e = t.P.convert(e).mult(-1), this.panTo(this.transform.center, t.e({
                    offset: e
                }, i), s);
            }
            panTo(e, i, s) {
                return this.easeTo(t.e({
                    center: e
                }, i), s);
            }
            getZoom() {
                return this.transform.zoom;
            }
            setZoom(t, e) {
                return this.jumpTo({
                    zoom: t
                }, e), this;
            }
            zoomTo(e, i, s) {
                return this.easeTo(t.e({
                    zoom: e
                }, i), s);
            }
            zoomIn(t, e) {
                return this.zoomTo(this.getZoom() + 1, t, e), this;
            }
            zoomOut(t, e) {
                return this.zoomTo(this.getZoom() - 1, t, e), this;
            }
            getBearing() {
                return this.transform.bearing;
            }
            setBearing(t, e) {
                return this.jumpTo({
                    bearing: t
                }, e), this;
            }
            getPadding() {
                return this.transform.padding;
            }
            setPadding(t, e) {
                return this.jumpTo({
                    padding: t
                }, e), this;
            }
            rotateTo(e, i, s) {
                return this.easeTo(t.e({
                    bearing: e
                }, i), s);
            }
            resetNorth(e, i) {
                return this.rotateTo(0, t.e({
                    duration: 1e3
                }, e), i), this;
            }
            resetNorthPitch(e, i) {
                return this.easeTo(t.e({
                    bearing: 0,
                    pitch: 0,
                    duration: 1e3
                }, e), i), this;
            }
            snapToNorth(t, e) {
                return Math.abs(this.getBearing()) < this._bearingSnap ? this.resetNorth(t, e) : this;
            }
            getPitch() {
                return this.transform.pitch;
            }
            setPitch(t, e) {
                return this.jumpTo({
                    pitch: t
                }, e), this;
            }
            cameraForBounds(t, e) {
                t = L.convert(t);
                const i = e && e.bearing || 0;
                return this._cameraForBoxAndBearing(t.getNorthWest(), t.getSouthEast(), i, e);
            }
            _cameraForBoxAndBearing(e, i, s, a) {
                const o = {
                    top: 0,
                    bottom: 0,
                    right: 0,
                    left: 0
                };
                if ("number" == typeof (a = t.e({
                    padding: o,
                    offset: [
                        0,
                        0
                    ],
                    maxZoom: this.transform.maxZoom
                }, a)).padding) {
                    const t = a.padding;
                    a.padding = {
                        top: t,
                        bottom: t,
                        right: t,
                        left: t
                    };
                }
                a.padding = t.e(o, a.padding);
                const r = this.transform, n = r.padding, l = r.project(t.L.convert(e)), h = r.project(t.L.convert(i)), c = l.rotate(-s * Math.PI / 180), u = h.rotate(-s * Math.PI / 180), d = new t.P(Math.max(c.x, u.x), Math.max(c.y, u.y)), _ = new t.P(Math.min(c.x, u.x), Math.min(c.y, u.y)), p = d.sub(_), m = (r.width - (n.left + n.right + a.padding.left + a.padding.right)) / p.x, f = (r.height - (n.top + n.bottom + a.padding.top + a.padding.bottom)) / p.y;
                if (f < 0 || m < 0) return void t.w("Map cannot fit within canvas with the given bounds, padding, and/or offset.");
                const g = Math.min(r.scaleZoom(r.scale * Math.min(m, f)), a.maxZoom), v = t.P.convert(a.offset), x = new t.P((a.padding.left - a.padding.right) / 2, (a.padding.top - a.padding.bottom) / 2).rotate(s * Math.PI / 180), y = v.add(x).mult(r.scale / r.zoomScale(g));
                return {
                    center: r.unproject(l.add(h).div(2).sub(y)),
                    zoom: g,
                    bearing: s
                };
            }
            fitBounds(t, e, i) {
                return this._fitInternal(this.cameraForBounds(t, e), e, i);
            }
            fitScreenCoordinates(e, i, s, a, o) {
                return this._fitInternal(this._cameraForBoxAndBearing(this.transform.pointLocation(t.P.convert(e)), this.transform.pointLocation(t.P.convert(i)), s, a), a, o);
            }
            _fitInternal(e, i, s) {
                return e ? (delete (i = t.e(e, i)).padding, i.linear ? this.easeTo(i, s) : this.flyTo(i, s)) : this;
            }
            jumpTo(e, i) {
                this.stop();
                const s = this._getTransformForUpdate();
                let a = !1, o = !1, r = !1;
                return "zoom" in e && s.zoom !== +e.zoom && (a = !0, s.zoom = +e.zoom), void 0 !== e.center && (s.center = t.L.convert(e.center)), "bearing" in e && s.bearing !== +e.bearing && (o = !0, s.bearing = +e.bearing), "pitch" in e && s.pitch !== +e.pitch && (r = !0, s.pitch = +e.pitch), null == e.padding || s.isPaddingEqual(e.padding) || (s.padding = e.padding), this._applyUpdatedTransform(s), this.fire(new t.k("movestart", i)).fire(new t.k("move", i)), a && this.fire(new t.k("zoomstart", i)).fire(new t.k("zoom", i)).fire(new t.k("zoomend", i)), o && this.fire(new t.k("rotatestart", i)).fire(new t.k("rotate", i)).fire(new t.k("rotateend", i)), r && this.fire(new t.k("pitchstart", i)).fire(new t.k("pitch", i)).fire(new t.k("pitchend", i)), this.fire(new t.k("moveend", i));
            }
            calculateCameraOptionsFromTo(e, i, s, a = 0) {
                const o = t.U.fromLngLat(e, i), r = t.U.fromLngLat(s, a), n = r.x - o.x, l = r.y - o.y, h = r.z - o.z, c = Math.hypot(n, l, h);
                if (0 === c) throw new Error("Can't calculate camera options with same From and To");
                const u = Math.hypot(n, l), d = this.transform.scaleZoom(this.transform.cameraToCenterDistance / c / this.transform.tileSize), _ = 180 * Math.atan2(n, -l) / Math.PI;
                let p = 180 * Math.acos(u / c) / Math.PI;
                return p = h < 0 ? 90 - p : 90 + p, {
                    center: r.toLngLat(),
                    zoom: d,
                    pitch: p,
                    bearing: _
                };
            }
            easeTo(e, i) {
                this._stop(!1, e.easeId), (!1 === (e = t.e({
                    offset: [
                        0,
                        0
                    ],
                    duration: 500,
                    easing: t.bb
                }, e)).animate || !e.essential && t.h.prefersReducedMotion) && (e.duration = 0);
                const s = this._getTransformForUpdate(), a = this.getZoom(), o = this.getBearing(), r = this.getPitch(), n = this.getPadding(), l = "zoom" in e ? +e.zoom : a, h = "bearing" in e ? this._normalizeBearing(e.bearing, o) : o, c = "pitch" in e ? +e.pitch : r, u = "padding" in e ? e.padding : s.padding, d = t.P.convert(e.offset);
                let _ = s.centerPoint.add(d);
                const p = s.pointLocation(_), m = t.L.convert(e.center || p);
                this._normalizeCenter(m);
                const f = s.project(p), g = s.project(m).sub(f), v = s.zoomScale(l - a);
                let x, y;
                e.around && (x = t.L.convert(e.around), y = s.locationPoint(x));
                const b = {
                    moving: this._moving,
                    zooming: this._zooming,
                    rotating: this._rotating,
                    pitching: this._pitching
                };
                return this._zooming = this._zooming || l !== a, this._rotating = this._rotating || o !== h, this._pitching = this._pitching || c !== r, this._padding = !s.isPaddingEqual(u), this._easeId = e.easeId, this._prepareEase(i, e.noMoveStart, b), this.terrain && this._prepareElevation(m), this._ease((p)=>{
                    if (this._zooming && (s.zoom = t.B.number(a, l, p)), this._rotating && (s.bearing = t.B.number(o, h, p)), this._pitching && (s.pitch = t.B.number(r, c, p)), this._padding && (s.interpolatePadding(n, u, p), _ = s.centerPoint.add(d)), this.terrain && !e.freezeElevation && this._updateElevation(p), x) s.setLocationAtPoint(x, y);
                    else {
                        const t = s.zoomScale(s.zoom - a), e = l > a ? Math.min(2, v) : Math.max(.5, v), i = Math.pow(e, 1 - p), o = s.unproject(f.add(g.mult(p * i)).mult(t));
                        s.setLocationAtPoint(s.renderWorldCopies ? o.wrap() : o, _);
                    }
                    this._applyUpdatedTransform(s), this._fireMoveEvents(i);
                }, (t)=>{
                    this.terrain && this._finalizeElevation(), this._afterEase(i, t);
                }, e), this;
            }
            _prepareEase(e, i, s = {}) {
                this._moving = !0, i || s.moving || this.fire(new t.k("movestart", e)), this._zooming && !s.zooming && this.fire(new t.k("zoomstart", e)), this._rotating && !s.rotating && this.fire(new t.k("rotatestart", e)), this._pitching && !s.pitching && this.fire(new t.k("pitchstart", e));
            }
            _prepareElevation(t) {
                this._elevationCenter = t, this._elevationStart = this.transform.elevation, this._elevationTarget = this.terrain.getElevationForLngLatZoom(t, this.transform.tileZoom), this._elevationFreeze = !0;
            }
            _updateElevation(e) {
                this.transform._minEleveationForCurrentTile = this.terrain.getMinTileElevationForLngLatZoom(this._elevationCenter, this.transform.tileZoom);
                const i = this.terrain.getElevationForLngLatZoom(this._elevationCenter, this.transform.tileZoom);
                if (e < 1 && i !== this._elevationTarget) {
                    const t = this._elevationTarget - this._elevationStart;
                    this._elevationStart += e * (t - (i - (t * e + this._elevationStart)) / (1 - e)), this._elevationTarget = i;
                }
                this.transform.elevation = t.B.number(this._elevationStart, this._elevationTarget, e);
            }
            _finalizeElevation() {
                this._elevationFreeze = !1, this.transform.recalculateZoom(this.terrain);
            }
            _getTransformForUpdate() {
                return this.transformCameraUpdate ? (this._requestedCameraState || (this._requestedCameraState = this.transform.clone()), this._requestedCameraState) : this.transform;
            }
            _applyUpdatedTransform(t) {
                if (!this.transformCameraUpdate) return;
                const e = t.clone(), { center: i, zoom: s, pitch: a, bearing: o, elevation: r } = this.transformCameraUpdate(e);
                i && (e.center = i), void 0 !== s && (e.zoom = s), void 0 !== a && (e.pitch = a), void 0 !== o && (e.bearing = o), void 0 !== r && (e.elevation = r), this.transform.apply(e);
            }
            _fireMoveEvents(e) {
                this.fire(new t.k("move", e)), this._zooming && this.fire(new t.k("zoom", e)), this._rotating && this.fire(new t.k("rotate", e)), this._pitching && this.fire(new t.k("pitch", e));
            }
            _afterEase(e, i) {
                if (this._easeId && i && this._easeId === i) return;
                delete this._easeId;
                const s = this._zooming, a = this._rotating, o = this._pitching;
                this._moving = !1, this._zooming = !1, this._rotating = !1, this._pitching = !1, this._padding = !1, s && this.fire(new t.k("zoomend", e)), a && this.fire(new t.k("rotateend", e)), o && this.fire(new t.k("pitchend", e)), this.fire(new t.k("moveend", e));
            }
            flyTo(e, i) {
                if (!e.essential && t.h.prefersReducedMotion) {
                    const s = t.F(e, [
                        "center",
                        "zoom",
                        "bearing",
                        "pitch",
                        "around"
                    ]);
                    return this.jumpTo(s, i);
                }
                this.stop(), e = t.e({
                    offset: [
                        0,
                        0
                    ],
                    speed: 1.2,
                    curve: 1.42,
                    easing: t.bb
                }, e);
                const s = this._getTransformForUpdate(), a = this.getZoom(), o = this.getBearing(), r = this.getPitch(), n = this.getPadding(), l = "zoom" in e ? t.ad(+e.zoom, s.minZoom, s.maxZoom) : a, h = "bearing" in e ? this._normalizeBearing(e.bearing, o) : o, c = "pitch" in e ? +e.pitch : r, u = "padding" in e ? e.padding : s.padding, d = s.zoomScale(l - a), _ = t.P.convert(e.offset);
                let p = s.centerPoint.add(_);
                const m = s.pointLocation(p), f = t.L.convert(e.center || m);
                this._normalizeCenter(f);
                const g = s.project(m), v = s.project(f).sub(g);
                let x = e.curve;
                const y = Math.max(s.width, s.height), b = y / d, w = v.mag();
                if ("minZoom" in e) {
                    const i = t.ad(Math.min(e.minZoom, a, l), s.minZoom, s.maxZoom), o = y / s.zoomScale(i - a);
                    x = Math.sqrt(o / w * 2);
                }
                const T = x * x;
                function I(t) {
                    const e = (b * b - y * y + (t ? -1 : 1) * T * T * w * w) / (2 * (t ? b : y) * T * w);
                    return Math.log(Math.sqrt(e * e + 1) - e);
                }
                function E(t) {
                    return (Math.exp(t) - Math.exp(-t)) / 2;
                }
                function S(t) {
                    return (Math.exp(t) + Math.exp(-t)) / 2;
                }
                const C = I(!1);
                let P = function(t) {
                    return S(C) / S(C + x * t);
                }, D = function(t) {
                    var e;
                    return y * ((S(C) * (E(e = C + x * t) / S(e)) - E(C)) / T) / w;
                }, M = (I(!0) - C) / x;
                if (Math.abs(w) < 1e-6 || !isFinite(M)) {
                    if (Math.abs(y - b) < 1e-6) return this.easeTo(e, i);
                    const t = b < y ? -1 : 1;
                    M = Math.abs(Math.log(b / y)) / x, D = function() {
                        return 0;
                    }, P = function(e) {
                        return Math.exp(t * x * e);
                    };
                }
                return e.duration = "duration" in e ? +e.duration : 1e3 * M / ("screenSpeed" in e ? +e.screenSpeed / x : +e.speed), e.maxDuration && e.duration > e.maxDuration && (e.duration = 0), this._zooming = !0, this._rotating = o !== h, this._pitching = c !== r, this._padding = !s.isPaddingEqual(u), this._prepareEase(i, !1), this.terrain && this._prepareElevation(f), this._ease((d)=>{
                    const m = d * M, x = 1 / P(m);
                    s.zoom = 1 === d ? l : a + s.scaleZoom(x), this._rotating && (s.bearing = t.B.number(o, h, d)), this._pitching && (s.pitch = t.B.number(r, c, d)), this._padding && (s.interpolatePadding(n, u, d), p = s.centerPoint.add(_)), this.terrain && !e.freezeElevation && this._updateElevation(d);
                    const y = 1 === d ? f : s.unproject(g.add(v.mult(D(m))).mult(x));
                    s.setLocationAtPoint(s.renderWorldCopies ? y.wrap() : y, p), this._applyUpdatedTransform(s), this._fireMoveEvents(i);
                }, ()=>{
                    this.terrain && this._finalizeElevation(), this._afterEase(i);
                }, e), this;
            }
            isEasing() {
                return !!this._easeFrameId;
            }
            stop() {
                return this._stop();
            }
            _stop(t, e) {
                if (this._easeFrameId && (this._cancelRenderFrame(this._easeFrameId), delete this._easeFrameId, delete this._onEaseFrame), this._onEaseEnd) {
                    const t = this._onEaseEnd;
                    delete this._onEaseEnd, t.call(this, e);
                }
                if (!t) {
                    const t = this.handlers;
                    t && t.stop(!1);
                }
                return this;
            }
            _ease(e, i, s) {
                !1 === s.animate || 0 === s.duration ? (e(1), i()) : (this._easeStart = t.h.now(), this._easeOptions = s, this._onEaseFrame = e, this._onEaseEnd = i, this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback));
            }
            _normalizeBearing(e, i) {
                e = t.b5(e, -180, 180);
                const s = Math.abs(e - i);
                return Math.abs(e - 360 - i) < s && (e -= 360), Math.abs(e + 360 - i) < s && (e += 360), e;
            }
            _normalizeCenter(t) {
                const e = this.transform;
                if (!e.renderWorldCopies || e.lngRange) return;
                const i = t.lng - e.center.lng;
                t.lng += i > 180 ? -360 : i < -180 ? 360 : 0;
            }
            queryTerrainElevation(e) {
                return this.terrain ? this.terrain.getElevationForLngLatZoom(t.L.convert(e), this.transform.tileZoom) - this.transform.elevation : null;
            }
        }
        class ra {
            constructor(t = {}){
                this._toggleAttribution = ()=>{
                    this._container.classList.contains("maplibregl-compact") && (this._container.classList.contains("maplibregl-compact-show") ? (this._container.setAttribute("open", ""), this._container.classList.remove("maplibregl-compact-show")) : (this._container.classList.add("maplibregl-compact-show"), this._container.removeAttribute("open")));
                }, this._updateData = (t)=>{
                    !t || "metadata" !== t.sourceDataType && "visibility" !== t.sourceDataType && "style" !== t.dataType && "terrain" !== t.type || this._updateAttributions();
                }, this._updateCompact = ()=>{
                    this._map.getCanvasContainer().offsetWidth <= 640 || this._compact ? !1 === this._compact ? this._container.setAttribute("open", "") : this._container.classList.contains("maplibregl-compact") || this._container.classList.contains("maplibregl-attrib-empty") || (this._container.setAttribute("open", ""), this._container.classList.add("maplibregl-compact", "maplibregl-compact-show")) : (this._container.setAttribute("open", ""), this._container.classList.contains("maplibregl-compact") && this._container.classList.remove("maplibregl-compact", "maplibregl-compact-show"));
                }, this._updateCompactMinimize = ()=>{
                    this._container.classList.contains("maplibregl-compact") && this._container.classList.contains("maplibregl-compact-show") && this._container.classList.remove("maplibregl-compact-show");
                }, this.options = t;
            }
            getDefaultPosition() {
                return "bottom-right";
            }
            onAdd(t) {
                return this._map = t, this._compact = this.options && this.options.compact, this._container = i.create("details", "maplibregl-ctrl maplibregl-ctrl-attrib"), this._compactButton = i.create("summary", "maplibregl-ctrl-attrib-button", this._container), this._compactButton.addEventListener("click", this._toggleAttribution), this._setElementTitle(this._compactButton, "ToggleAttribution"), this._innerContainer = i.create("div", "maplibregl-ctrl-attrib-inner", this._container), this._updateAttributions(), this._updateCompact(), this._map.on("styledata", this._updateData), this._map.on("sourcedata", this._updateData), this._map.on("terrain", this._updateData), this._map.on("resize", this._updateCompact), this._map.on("drag", this._updateCompactMinimize), this._container;
            }
            onRemove() {
                i.remove(this._container), this._map.off("styledata", this._updateData), this._map.off("sourcedata", this._updateData), this._map.off("terrain", this._updateData), this._map.off("resize", this._updateCompact), this._map.off("drag", this._updateCompactMinimize), this._map = void 0, this._compact = void 0, this._attribHTML = void 0;
            }
            _setElementTitle(t, e) {
                const i = this._map._getUIString(`AttributionControl.${e}`);
                t.title = i, t.setAttribute("aria-label", i);
            }
            _updateAttributions() {
                if (!this._map.style) return;
                let t = [];
                if (this.options.customAttribution && (Array.isArray(this.options.customAttribution) ? t = t.concat(this.options.customAttribution.map((t)=>"string" != typeof t ? "" : t)) : "string" == typeof this.options.customAttribution && t.push(this.options.customAttribution)), this._map.style.stylesheet) {
                    const t = this._map.style.stylesheet;
                    this.styleOwner = t.owner, this.styleId = t.id;
                }
                const e = this._map.style.sourceCaches;
                for(const i in e){
                    const s = e[i];
                    if (s.used || s.usedForTerrain) {
                        const e = s.getSource();
                        e.attribution && t.indexOf(e.attribution) < 0 && t.push(e.attribution);
                    }
                }
                t = t.filter((t)=>String(t).trim()), t.sort((t, e)=>t.length - e.length), t = t.filter((e, i)=>{
                    for(let s = i + 1; s < t.length; s++)if (t[s].indexOf(e) >= 0) return !1;
                    return !0;
                });
                const i = t.join(" | ");
                i !== this._attribHTML && (this._attribHTML = i, t.length ? (this._innerContainer.innerHTML = i, this._container.classList.remove("maplibregl-attrib-empty")) : this._container.classList.add("maplibregl-attrib-empty"), this._updateCompact(), this._editLink = null);
            }
        }
        class na {
            constructor(t = {}){
                this._updateCompact = ()=>{
                    const t = this._container.children;
                    if (t.length) {
                        const e = t[0];
                        this._map.getCanvasContainer().offsetWidth <= 640 || this._compact ? !1 !== this._compact && e.classList.add("maplibregl-compact") : e.classList.remove("maplibregl-compact");
                    }
                }, this.options = t;
            }
            getDefaultPosition() {
                return "bottom-left";
            }
            onAdd(t) {
                this._map = t, this._compact = this.options && this.options.compact, this._container = i.create("div", "maplibregl-ctrl");
                const e = i.create("a", "maplibregl-ctrl-logo");
                return e.target = "_blank", e.rel = "noopener nofollow", e.href = "https://maplibre.org/", e.setAttribute("aria-label", this._map._getUIString("LogoControl.Title")), e.setAttribute("rel", "noopener nofollow"), this._container.appendChild(e), this._container.style.display = "block", this._map.on("resize", this._updateCompact), this._updateCompact(), this._container;
            }
            onRemove() {
                i.remove(this._container), this._map.off("resize", this._updateCompact), this._map = void 0, this._compact = void 0;
            }
        }
        class la {
            constructor(){
                this._queue = [], this._id = 0, this._cleared = !1, this._currentlyRunning = !1;
            }
            add(t) {
                const e = ++this._id;
                return this._queue.push({
                    callback: t,
                    id: e,
                    cancelled: !1
                }), e;
            }
            remove(t) {
                const e = this._currentlyRunning, i = e ? this._queue.concat(e) : this._queue;
                for (const e of i)if (e.id === t) return void (e.cancelled = !0);
            }
            run(t = 0) {
                if (this._currentlyRunning) throw new Error("Attempting to run(), but is already running.");
                const e = this._currentlyRunning = this._queue;
                this._queue = [];
                for (const i of e)if (!i.cancelled && (i.callback(t), this._cleared)) break;
                this._cleared = !1, this._currentlyRunning = !1;
            }
            clear() {
                this._currentlyRunning && (this._cleared = !0), this._queue = [];
            }
        }
        const ha = {
            "AttributionControl.ToggleAttribution": "Toggle attribution",
            "AttributionControl.MapFeedback": "Map feedback",
            "FullscreenControl.Enter": "Enter fullscreen",
            "FullscreenControl.Exit": "Exit fullscreen",
            "GeolocateControl.FindMyLocation": "Find my location",
            "GeolocateControl.LocationNotAvailable": "Location not available",
            "LogoControl.Title": "Mapbox logo",
            "NavigationControl.ResetBearing": "Reset bearing to north",
            "NavigationControl.ZoomIn": "Zoom in",
            "NavigationControl.ZoomOut": "Zoom out",
            "ScaleControl.Feet": "ft",
            "ScaleControl.Meters": "m",
            "ScaleControl.Kilometers": "km",
            "ScaleControl.Miles": "mi",
            "ScaleControl.NauticalMiles": "nm",
            "TerrainControl.enableTerrain": "Enable terrain",
            "TerrainControl.disableTerrain": "Disable terrain"
        };
        var ca = t.Q([
            {
                name: "a_pos3d",
                type: "Int16",
                components: 3
            }
        ]);
        class ua extends t.E {
            constructor(t){
                super(), this.sourceCache = t, this._tiles = {}, this._renderableTilesKeys = [], this._sourceTileCache = {}, this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this.deltaZoom = 1, t.usedForTerrain = !0, t.tileSize = this.tileSize * 2 ** this.deltaZoom;
            }
            destruct() {
                this.sourceCache.usedForTerrain = !1, this.sourceCache.tileSize = null;
            }
            update(e, i) {
                this.sourceCache.update(e, i), this._renderableTilesKeys = [];
                const s = {};
                for (const a of e.coveringTiles({
                    tileSize: this.tileSize,
                    minzoom: this.minzoom,
                    maxzoom: this.maxzoom,
                    reparseOverscaled: !1,
                    terrain: i
                }))s[a.key] = !0, this._renderableTilesKeys.push(a.key), this._tiles[a.key] || (a.posMatrix = new Float64Array(16), t.aS(a.posMatrix, 0, t.N, 0, t.N, 0, 1), this._tiles[a.key] = new W(a, this.tileSize));
                for(const t in this._tiles)s[t] || delete this._tiles[t];
            }
            freeRtt(t) {
                for(const e in this._tiles){
                    const i = this._tiles[e];
                    (!t || i.tileID.equals(t) || i.tileID.isChildOf(t) || t.isChildOf(i.tileID)) && (i.rtt = []);
                }
            }
            getRenderableTiles() {
                return this._renderableTilesKeys.map((t)=>this.getTileByID(t));
            }
            getTileByID(t) {
                return this._tiles[t];
            }
            getTerrainCoords(e) {
                const i = {};
                for (const s of this._renderableTilesKeys){
                    const a = this._tiles[s].tileID;
                    if (a.canonical.equals(e.canonical)) {
                        const a = e.clone();
                        a.posMatrix = new Float64Array(16), t.aS(a.posMatrix, 0, t.N, 0, t.N, 0, 1), i[s] = a;
                    } else if (a.canonical.isChildOf(e.canonical)) {
                        const o = e.clone();
                        o.posMatrix = new Float64Array(16);
                        const r = a.canonical.z - e.canonical.z, n = a.canonical.x - (a.canonical.x >> r << r), l = a.canonical.y - (a.canonical.y >> r << r), h = t.N >> r;
                        t.aS(o.posMatrix, 0, h, 0, h, 0, 1), t.$(o.posMatrix, o.posMatrix, [
                            -n * h,
                            -l * h,
                            0
                        ]), i[s] = o;
                    } else if (e.canonical.isChildOf(a.canonical)) {
                        const o = e.clone();
                        o.posMatrix = new Float64Array(16);
                        const r = e.canonical.z - a.canonical.z, n = e.canonical.x - (e.canonical.x >> r << r), l = e.canonical.y - (e.canonical.y >> r << r), h = t.N >> r;
                        t.aS(o.posMatrix, 0, t.N, 0, t.N, 0, 1), t.$(o.posMatrix, o.posMatrix, [
                            n * h,
                            l * h,
                            0
                        ]), t.a0(o.posMatrix, o.posMatrix, [
                            1 / 2 ** r,
                            1 / 2 ** r,
                            0
                        ]), i[s] = o;
                    }
                }
                return i;
            }
            getSourceTile(t, e) {
                const i = this.sourceCache._source;
                let s = t.overscaledZ - this.deltaZoom;
                if (s > i.maxzoom && (s = i.maxzoom), s < i.minzoom) return null;
                this._sourceTileCache[t.key] || (this._sourceTileCache[t.key] = t.scaledTo(s).key);
                let a = this.sourceCache.getTileByID(this._sourceTileCache[t.key]);
                if ((!a || !a.dem) && e) for(; s >= i.minzoom && (!a || !a.dem);)a = this.sourceCache.getTileByID(t.scaledTo(s--).key);
                return a;
            }
            tilesAfterTime(t = Date.now()) {
                return Object.values(this._tiles).filter((e)=>e.timeAdded >= t);
            }
        }
        class da {
            constructor(t, e, i){
                this.painter = t, this.sourceCache = new ua(e), this.options = i, this.exaggeration = "number" == typeof i.exaggeration ? i.exaggeration : 1, this.qualityFactor = 2, this.meshSize = 128, this._demMatrixCache = {}, this.coordsIndex = [], this._coordsTextureSize = 1024;
            }
            getDEMElevation(e, i, s, a = t.N) {
                var o;
                if (!(i >= 0 && i < a && s >= 0 && s < a)) return 0;
                const r = this.getTerrainData(e), n = null === (o = r.tile) || void 0 === o ? void 0 : o.dem;
                if (!n) return 0;
                const l = function(t, e, i) {
                    var s = e[0], a = e[1];
                    return t[0] = i[0] * s + i[4] * a + i[12], t[1] = i[1] * s + i[5] * a + i[13], t;
                }([], [
                    i / a * t.N,
                    s / a * t.N
                ], r.u_terrain_matrix), h = [
                    l[0] * n.dim,
                    l[1] * n.dim
                ], c = Math.floor(h[0]), u = Math.floor(h[1]), d = h[0] - c, _ = h[1] - u;
                return n.get(c, u) * (1 - d) * (1 - _) + n.get(c + 1, u) * d * (1 - _) + n.get(c, u + 1) * (1 - d) * _ + n.get(c + 1, u + 1) * d * _;
            }
            getElevationForLngLatZoom(e, i) {
                const { tileID: s, mercatorX: a, mercatorY: o } = this._getOverscaledTileIDFromLngLatZoom(e, i);
                return this.getElevation(s, a % t.N, o % t.N, t.N);
            }
            getElevation(e, i, s, a = t.N) {
                return this.getDEMElevation(e, i, s, a) * this.exaggeration;
            }
            getTerrainData(e) {
                if (!this._emptyDemTexture) {
                    const e = this.painter.context, i = new t.R({
                        width: 1,
                        height: 1
                    }, new Uint8Array(4));
                    this._emptyDepthTexture = new x(e, i, e.gl.RGBA, {
                        premultiply: !1
                    }), this._emptyDemUnpack = [
                        0,
                        0,
                        0,
                        0
                    ], this._emptyDemTexture = new x(e, new t.R({
                        width: 1,
                        height: 1
                    }), e.gl.RGBA, {
                        premultiply: !1
                    }), this._emptyDemTexture.bind(e.gl.NEAREST, e.gl.CLAMP_TO_EDGE), this._emptyDemMatrix = t.ao([]);
                }
                const i = this.sourceCache.getSourceTile(e, !0);
                if (i && i.dem && (!i.demTexture || i.needsTerrainPrepare)) {
                    const t = this.painter.context;
                    i.demTexture = this.painter.getTileTexture(i.dem.stride), i.demTexture ? i.demTexture.update(i.dem.getPixels(), {
                        premultiply: !1
                    }) : i.demTexture = new x(t, i.dem.getPixels(), t.gl.RGBA, {
                        premultiply: !1
                    }), i.demTexture.bind(t.gl.NEAREST, t.gl.CLAMP_TO_EDGE), i.needsTerrainPrepare = !1;
                }
                const s = i && i + i.tileID.key + e.key;
                if (s && !this._demMatrixCache[s]) {
                    const s = this.sourceCache.sourceCache._source.maxzoom;
                    let a = e.canonical.z - i.tileID.canonical.z;
                    e.overscaledZ > e.canonical.z && (e.canonical.z >= s ? a = e.canonical.z - s : t.w("cannot calculate elevation if elevation maxzoom > source.maxzoom"));
                    const o = e.canonical.x - (e.canonical.x >> a << a), r = e.canonical.y - (e.canonical.y >> a << a), n = t.bc(new Float64Array(16), [
                        1 / (t.N << a),
                        1 / (t.N << a),
                        0
                    ]);
                    t.$(n, n, [
                        o * t.N,
                        r * t.N,
                        0
                    ]), this._demMatrixCache[e.key] = {
                        matrix: n,
                        coord: e
                    };
                }
                return {
                    u_depth: 2,
                    u_terrain: 3,
                    u_terrain_dim: i && i.dem && i.dem.dim || 1,
                    u_terrain_matrix: s ? this._demMatrixCache[e.key].matrix : this._emptyDemMatrix,
                    u_terrain_unpack: i && i.dem && i.dem.getUnpackVector() || this._emptyDemUnpack,
                    u_terrain_exaggeration: this.exaggeration,
                    texture: (i && i.demTexture || this._emptyDemTexture).texture,
                    depthTexture: (this._fboDepthTexture || this._emptyDepthTexture).texture,
                    tile: i
                };
            }
            getFramebuffer(t) {
                const e = this.painter, i = e.width / devicePixelRatio, s = e.height / devicePixelRatio;
                return !this._fbo || this._fbo.width === i && this._fbo.height === s || (this._fbo.destroy(), this._fboCoordsTexture.destroy(), this._fboDepthTexture.destroy(), delete this._fbo, delete this._fboDepthTexture, delete this._fboCoordsTexture), this._fboCoordsTexture || (this._fboCoordsTexture = new x(e.context, {
                    width: i,
                    height: s,
                    data: null
                }, e.context.gl.RGBA, {
                    premultiply: !1
                }), this._fboCoordsTexture.bind(e.context.gl.NEAREST, e.context.gl.CLAMP_TO_EDGE)), this._fboDepthTexture || (this._fboDepthTexture = new x(e.context, {
                    width: i,
                    height: s,
                    data: null
                }, e.context.gl.RGBA, {
                    premultiply: !1
                }), this._fboDepthTexture.bind(e.context.gl.NEAREST, e.context.gl.CLAMP_TO_EDGE)), this._fbo || (this._fbo = e.context.createFramebuffer(i, s, !0, !1), this._fbo.depthAttachment.set(e.context.createRenderbuffer(e.context.gl.DEPTH_COMPONENT16, i, s))), this._fbo.colorAttachment.set("coords" === t ? this._fboCoordsTexture.texture : this._fboDepthTexture.texture), this._fbo;
            }
            getCoordsTexture() {
                const e = this.painter.context;
                if (this._coordsTexture) return this._coordsTexture;
                const i = new Uint8Array(this._coordsTextureSize * this._coordsTextureSize * 4);
                for(let t = 0, e = 0; t < this._coordsTextureSize; t++)for(let s = 0; s < this._coordsTextureSize; s++, e += 4)i[e + 0] = 255 & s, i[e + 1] = 255 & t, i[e + 2] = s >> 8 << 4 | t >> 8, i[e + 3] = 0;
                const s = new t.R({
                    width: this._coordsTextureSize,
                    height: this._coordsTextureSize
                }, new Uint8Array(i.buffer)), a = new x(e, s, e.gl.RGBA, {
                    premultiply: !1
                });
                return a.bind(e.gl.NEAREST, e.gl.CLAMP_TO_EDGE), this._coordsTexture = a, a;
            }
            pointCoordinate(e) {
                const i = new Uint8Array(4), s = this.painter.context, a = s.gl;
                s.bindFramebuffer.set(this.getFramebuffer("coords").framebuffer), a.readPixels(e.x, this.painter.height / devicePixelRatio - e.y - 1, 1, 1, a.RGBA, a.UNSIGNED_BYTE, i), s.bindFramebuffer.set(null);
                const o = i[0] + (i[2] >> 4 << 8), r = i[1] + ((15 & i[2]) << 8), n = this.coordsIndex[255 - i[3]], l = n && this.sourceCache.getTileByID(n);
                if (!l) return null;
                const h = this._coordsTextureSize, c = (1 << l.tileID.canonical.z) * h;
                return new t.U(this._allowMercatorOverflow(e, (l.tileID.canonical.x * h + o) / c), (l.tileID.canonical.y * h + r) / c, this.getElevation(l.tileID, o, r, h));
            }
            getTerrainMesh() {
                if (this._mesh) return this._mesh;
                const e = this.painter.context, i = new t.bd, s = new t.b0, a = this.meshSize, o = t.N / a, r = a * a;
                for(let t = 0; t <= a; t++)for(let e = 0; e <= a; e++)i.emplaceBack(e * o, t * o, 0);
                for(let t = 0; t < r; t += a + 1)for(let e = 0; e < a; e++)s.emplaceBack(e + t, a + e + t + 1, a + e + t + 2), s.emplaceBack(e + t, a + e + t + 2, e + t + 1);
                const n = i.length, l = n + 2 * (a + 1);
                for (const e of [
                    0,
                    1
                ])for(let s = 0; s <= a; s++)for (const a of [
                    0,
                    1
                ])i.emplaceBack(s * o, e * t.N, a);
                for(let t = 0; t < 2 * a; t += 2)s.emplaceBack(l + t, l + t + 1, l + t + 3), s.emplaceBack(l + t, l + t + 3, l + t + 2), s.emplaceBack(n + t, n + t + 3, n + t + 1), s.emplaceBack(n + t, n + t + 2, n + t + 3);
                const h = i.length, c = h + 2 * (a + 1);
                for (const e of [
                    0,
                    1
                ])for(let s = 0; s <= a; s++)for (const a of [
                    0,
                    1
                ])i.emplaceBack(e * t.N, s * o, a);
                for(let t = 0; t < 2 * a; t += 2)s.emplaceBack(h + t, h + t + 1, h + t + 3), s.emplaceBack(h + t, h + t + 3, h + t + 2), s.emplaceBack(c + t, c + t + 3, c + t + 1), s.emplaceBack(c + t, c + t + 2, c + t + 3);
                return this._mesh = {
                    indexBuffer: e.createIndexBuffer(s),
                    vertexBuffer: e.createVertexBuffer(i, ca.members),
                    segments: t.S.simpleSegment(0, 0, i.length, s.length)
                }, this._mesh;
            }
            getMeshFrameDelta(e) {
                return 2 * Math.PI * t.be / Math.pow(2, e) / 5;
            }
            getMinTileElevationForLngLatZoom(t, e) {
                var i;
                const { tileID: s } = this._getOverscaledTileIDFromLngLatZoom(t, e);
                return null !== (i = this.getMinMaxElevation(s).minElevation) && void 0 !== i ? i : 0;
            }
            getMinMaxElevation(t) {
                const e = this.getTerrainData(t).tile, i = {
                    minElevation: null,
                    maxElevation: null
                };
                return e && e.dem && (i.minElevation = e.dem.min * this.exaggeration, i.maxElevation = e.dem.max * this.exaggeration), i;
            }
            _getOverscaledTileIDFromLngLatZoom(e, i) {
                const s = t.U.fromLngLat(e.wrap()), a = (1 << i) * t.N, o = s.x * a, r = s.y * a, n = Math.floor(o / t.N), l = Math.floor(r / t.N);
                return {
                    tileID: new t.O(i, 0, i, n, l),
                    mercatorX: o,
                    mercatorY: r
                };
            }
            _allowMercatorOverflow(e, i) {
                const s = e.x < this.painter.width / 2;
                let a = t.bf(i);
                const o = this.painter.transform.center.lng;
                return s && Math.sign(a) > 0 && Math.sign(o) < 0 || !s && Math.sign(a) < 0 && Math.sign(o) > 0 ? (a = 360 * Math.sign(o) + a, t.G(a)) : i;
            }
        }
        class _a {
            constructor(t, e, i){
                this._context = t, this._size = e, this._tileSize = i, this._objects = [], this._recentlyUsed = [], this._stamp = 0;
            }
            destruct() {
                for (const t of this._objects)t.texture.destroy(), t.fbo.destroy();
            }
            _createObject(t) {
                const e = this._context.createFramebuffer(this._tileSize, this._tileSize, !0, !0), i = new x(this._context, {
                    width: this._tileSize,
                    height: this._tileSize,
                    data: null
                }, this._context.gl.RGBA);
                return i.bind(this._context.gl.LINEAR, this._context.gl.CLAMP_TO_EDGE), e.depthAttachment.set(this._context.createRenderbuffer(this._context.gl.DEPTH_STENCIL, this._tileSize, this._tileSize)), e.colorAttachment.set(i.texture), {
                    id: t,
                    fbo: e,
                    texture: i,
                    stamp: -1,
                    inUse: !1
                };
            }
            getObjectForId(t) {
                return this._objects[t];
            }
            useObject(t) {
                t.inUse = !0, this._recentlyUsed = this._recentlyUsed.filter((e)=>t.id !== e), this._recentlyUsed.push(t.id);
            }
            stampObject(t) {
                t.stamp = ++this._stamp;
            }
            getOrCreateFreeObject() {
                for (const t of this._recentlyUsed)if (!this._objects[t].inUse) return this._objects[t];
                if (this._objects.length >= this._size) throw new Error("No free RenderPool available, call freeAllObjects() required!");
                const t = this._createObject(this._objects.length);
                return this._objects.push(t), t;
            }
            freeObject(t) {
                t.inUse = !1;
            }
            freeAllObjects() {
                for (const t of this._objects)this.freeObject(t);
            }
            isFull() {
                return !(this._objects.length < this._size) && !1 === this._objects.some((t)=>!t.inUse);
            }
        }
        const pa = {
            background: !0,
            fill: !0,
            line: !0,
            raster: !0,
            hillshade: !0
        };
        class ma {
            constructor(t, e){
                this.painter = t, this.terrain = e, this.pool = new _a(t.context, 30, e.sourceCache.tileSize * e.qualityFactor);
            }
            destruct() {
                this.pool.destruct();
            }
            getTexture(t) {
                return this.pool.getObjectForId(t.rtt[this._stacks.length - 1].id).texture;
            }
            prepareForRender(t, e) {
                this._stacks = [], this._prevType = null, this._rttTiles = [], this._renderableTiles = this.terrain.sourceCache.getRenderableTiles(), this._renderableLayerIds = t._order.filter((i)=>!t._layers[i].isHidden(e)), this._coordsDescendingInv = {};
                for(const e in t.sourceCaches){
                    this._coordsDescendingInv[e] = {};
                    const i = t.sourceCaches[e].getVisibleCoordinates();
                    for (const t of i){
                        const i = this.terrain.sourceCache.getTerrainCoords(t);
                        for(const t in i)this._coordsDescendingInv[e][t] || (this._coordsDescendingInv[e][t] = []), this._coordsDescendingInv[e][t].push(i[t]);
                    }
                }
                this._coordsDescendingInvStr = {};
                for (const e of t._order){
                    const i = t._layers[e], s = i.source;
                    if (pa[i.type] && !this._coordsDescendingInvStr[s]) {
                        this._coordsDescendingInvStr[s] = {};
                        for(const t in this._coordsDescendingInv[s])this._coordsDescendingInvStr[s][t] = this._coordsDescendingInv[s][t].map((t)=>t.key).sort().join();
                    }
                }
                for (const t of this._renderableTiles)for(const e in this._coordsDescendingInvStr){
                    const i = this._coordsDescendingInvStr[e][t.tileID.key];
                    i && i !== t.rttCoords[e] && (t.rtt = []);
                }
            }
            renderLayer(e) {
                if (e.isHidden(this.painter.transform.zoom)) return !1;
                const i = e.type, s = this.painter, a = this._renderableLayerIds[this._renderableLayerIds.length - 1] === e.id;
                if (pa[i] && (this._prevType && pa[this._prevType] || this._stacks.push([]), this._prevType = i, this._stacks[this._stacks.length - 1].push(e.id), !a)) return !0;
                if (pa[this._prevType] || pa[i] && a) {
                    this._prevType = i;
                    const e = this._stacks.length - 1, a = this._stacks[e] || [];
                    for (const i of this._renderableTiles){
                        if (this.pool.isFull() && (es(this.painter, this.terrain, this._rttTiles), this._rttTiles = [], this.pool.freeAllObjects()), this._rttTiles.push(i), i.rtt[e]) {
                            const t = this.pool.getObjectForId(i.rtt[e].id);
                            if (t.stamp === i.rtt[e].stamp) {
                                this.pool.useObject(t);
                                continue;
                            }
                        }
                        const o = this.pool.getOrCreateFreeObject();
                        this.pool.useObject(o), this.pool.stampObject(o), i.rtt[e] = {
                            id: o.id,
                            stamp: o.stamp
                        }, s.context.bindFramebuffer.set(o.fbo.framebuffer), s.context.clear({
                            color: t.aT.transparent,
                            stencil: 0
                        }), s.currentStencilSource = void 0;
                        for(let t = 0; t < a.length; t++){
                            const e = s.style._layers[a[t]], r = e.source ? this._coordsDescendingInv[e.source][i.tileID.key] : [
                                i.tileID
                            ];
                            s.context.viewport.set([
                                0,
                                0,
                                o.fbo.width,
                                o.fbo.height
                            ]), s._renderTileClippingMasks(e, r), s.renderLayer(s, s.style.sourceCaches[e.source], e, r), e.source && (i.rttCoords[e.source] = this._coordsDescendingInvStr[e.source][i.tileID.key]);
                        }
                    }
                    return es(this.painter, this.terrain, this._rttTiles), this._rttTiles = [], this.pool.freeAllObjects(), pa[i];
                }
                return !1;
            }
        }
        const fa = e, ga = {
            center: [
                0,
                0
            ],
            zoom: 0,
            bearing: 0,
            pitch: 0,
            minZoom: -2,
            maxZoom: 22,
            minPitch: 0,
            maxPitch: 60,
            interactive: !0,
            scrollZoom: !0,
            boxZoom: !0,
            dragRotate: !0,
            dragPan: !0,
            keyboard: !0,
            doubleClickZoom: !0,
            touchZoomRotate: !0,
            touchPitch: !0,
            cooperativeGestures: void 0,
            bearingSnap: 7,
            clickTolerance: 3,
            pitchWithRotate: !0,
            hash: !1,
            attributionControl: !0,
            maplibreLogo: !1,
            failIfMajorPerformanceCaveat: !1,
            preserveDrawingBuffer: !1,
            trackResize: !0,
            renderWorldCopies: !0,
            refreshExpiredTiles: !0,
            maxTileCacheSize: null,
            maxTileCacheZoomLevels: t.c.MAX_TILE_CACHE_ZOOM_LEVELS,
            localIdeographFontFamily: "sans-serif",
            transformRequest: null,
            transformCameraUpdate: null,
            fadeDuration: 300,
            crossSourceCollisions: !0,
            validateStyle: !0,
            maxCanvasSize: [
                4096,
                4096
            ]
        }, va = (t)=>{
            t.touchstart = t.dragStart, t.touchmoveWindow = t.dragMove, t.touchend = t.dragEnd;
        }, xa = {
            showCompass: !0,
            showZoom: !0,
            visualizePitch: !1
        };
        class ya {
            constructor(e, s, a = !1){
                this.mousedown = (e)=>{
                    this.startMouse(t.e({}, e, {
                        ctrlKey: !0,
                        preventDefault: ()=>e.preventDefault()
                    }), i.mousePos(this.element, e)), i.addEventListener(window, "mousemove", this.mousemove), i.addEventListener(window, "mouseup", this.mouseup);
                }, this.mousemove = (t)=>{
                    this.moveMouse(t, i.mousePos(this.element, t));
                }, this.mouseup = (t)=>{
                    this.mouseRotate.dragEnd(t), this.mousePitch && this.mousePitch.dragEnd(t), this.offTemp();
                }, this.touchstart = (t)=>{
                    1 !== t.targetTouches.length ? this.reset() : (this._startPos = this._lastPos = i.touchPos(this.element, t.targetTouches)[0], this.startTouch(t, this._startPos), i.addEventListener(window, "touchmove", this.touchmove, {
                        passive: !1
                    }), i.addEventListener(window, "touchend", this.touchend));
                }, this.touchmove = (t)=>{
                    1 !== t.targetTouches.length ? this.reset() : (this._lastPos = i.touchPos(this.element, t.targetTouches)[0], this.moveTouch(t, this._lastPos));
                }, this.touchend = (t)=>{
                    0 === t.targetTouches.length && this._startPos && this._lastPos && this._startPos.dist(this._lastPos) < this._clickTolerance && this.element.click(), delete this._startPos, delete this._lastPos, this.offTemp();
                }, this.reset = ()=>{
                    this.mouseRotate.reset(), this.mousePitch && this.mousePitch.reset(), this.touchRotate.reset(), this.touchPitch && this.touchPitch.reset(), delete this._startPos, delete this._lastPos, this.offTemp();
                }, this._clickTolerance = 10;
                const o = e.dragRotate._mouseRotate.getClickTolerance(), r = e.dragRotate._mousePitch.getClickTolerance();
                this.element = s, this.mouseRotate = As({
                    clickTolerance: o,
                    enable: !0
                }), this.touchRotate = (({ enable: t, clickTolerance: e, bearingDegreesPerPixelMoved: i = .8 })=>{
                    const s = new zs;
                    return new Ps({
                        clickTolerance: e,
                        move: (t, e)=>({
                                bearingDelta: (e.x - t.x) * i
                            }),
                        moveStateManager: s,
                        enable: t,
                        assignEvents: va
                    });
                })({
                    clickTolerance: o,
                    enable: !0
                }), this.map = e, a && (this.mousePitch = Rs({
                    clickTolerance: r,
                    enable: !0
                }), this.touchPitch = (({ enable: t, clickTolerance: e, pitchDegreesPerPixelMoved: i = -0.5 })=>{
                    const s = new zs;
                    return new Ps({
                        clickTolerance: e,
                        move: (t, e)=>({
                                pitchDelta: (e.y - t.y) * i
                            }),
                        moveStateManager: s,
                        enable: t,
                        assignEvents: va
                    });
                })({
                    clickTolerance: r,
                    enable: !0
                })), i.addEventListener(s, "mousedown", this.mousedown), i.addEventListener(s, "touchstart", this.touchstart, {
                    passive: !1
                }), i.addEventListener(s, "touchcancel", this.reset);
            }
            startMouse(t, e) {
                this.mouseRotate.dragStart(t, e), this.mousePitch && this.mousePitch.dragStart(t, e), i.disableDrag();
            }
            startTouch(t, e) {
                this.touchRotate.dragStart(t, e), this.touchPitch && this.touchPitch.dragStart(t, e), i.disableDrag();
            }
            moveMouse(t, e) {
                const i = this.map, { bearingDelta: s } = this.mouseRotate.dragMove(t, e) || {};
                if (s && i.setBearing(i.getBearing() + s), this.mousePitch) {
                    const { pitchDelta: s } = this.mousePitch.dragMove(t, e) || {};
                    s && i.setPitch(i.getPitch() + s);
                }
            }
            moveTouch(t, e) {
                const i = this.map, { bearingDelta: s } = this.touchRotate.dragMove(t, e) || {};
                if (s && i.setBearing(i.getBearing() + s), this.touchPitch) {
                    const { pitchDelta: s } = this.touchPitch.dragMove(t, e) || {};
                    s && i.setPitch(i.getPitch() + s);
                }
            }
            off() {
                const t = this.element;
                i.removeEventListener(t, "mousedown", this.mousedown), i.removeEventListener(t, "touchstart", this.touchstart, {
                    passive: !1
                }), i.removeEventListener(window, "touchmove", this.touchmove, {
                    passive: !1
                }), i.removeEventListener(window, "touchend", this.touchend), i.removeEventListener(t, "touchcancel", this.reset), this.offTemp();
            }
            offTemp() {
                i.enableDrag(), i.removeEventListener(window, "mousemove", this.mousemove), i.removeEventListener(window, "mouseup", this.mouseup), i.removeEventListener(window, "touchmove", this.touchmove, {
                    passive: !1
                }), i.removeEventListener(window, "touchend", this.touchend);
            }
        }
        let ba;
        function wa(e, i, s) {
            if (e = new t.L(e.lng, e.lat), i) {
                const a = new t.L(e.lng - 360, e.lat), o = new t.L(e.lng + 360, e.lat), r = s.locationPoint(e).distSqr(i);
                s.locationPoint(a).distSqr(i) < r ? e = a : s.locationPoint(o).distSqr(i) < r && (e = o);
            }
            for(; Math.abs(e.lng - s.center.lng) > 180;){
                const t = s.locationPoint(e);
                if (t.x >= 0 && t.y >= 0 && t.x <= s.width && t.y <= s.height) break;
                e.lng > s.center.lng ? e.lng -= 360 : e.lng += 360;
            }
            return e;
        }
        const Ta = {
            center: "translate(-50%,-50%)",
            top: "translate(-50%,0)",
            "top-left": "translate(0,0)",
            "top-right": "translate(-100%,0)",
            bottom: "translate(-50%,-100%)",
            "bottom-left": "translate(0,-100%)",
            "bottom-right": "translate(-100%,-100%)",
            left: "translate(0,-50%)",
            right: "translate(-100%,-50%)"
        };
        function Ia(t, e, i) {
            const s = t.classList;
            for(const t in Ta)s.remove(`maplibregl-${i}-anchor-${t}`);
            s.add(`maplibregl-${i}-anchor-${e}`);
        }
        class Ea extends t.E {
            constructor(e){
                if (super(), this._onKeyPress = (t)=>{
                    const e = t.code, i = t.charCode || t.keyCode;
                    "Space" !== e && "Enter" !== e && 32 !== i && 13 !== i || this.togglePopup();
                }, this._onMapClick = (t)=>{
                    const e = t.originalEvent.target, i = this._element;
                    this._popup && (e === i || i.contains(e)) && this.togglePopup();
                }, this._update = (t)=>{
                    if (!this._map) return;
                    const e = this._map.loaded() && !this._map.isMoving();
                    ("terrain" === (null == t ? void 0 : t.type) || "render" === (null == t ? void 0 : t.type) && !e) && this._map.once("render", this._update), this._map.transform.renderWorldCopies && (this._lngLat = wa(this._lngLat, this._pos, this._map.transform)), this._pos = this._map.project(this._lngLat)._add(this._offset);
                    let s = "";
                    "viewport" === this._rotationAlignment || "auto" === this._rotationAlignment ? s = `rotateZ(${this._rotation}deg)` : "map" === this._rotationAlignment && (s = `rotateZ(${this._rotation - this._map.getBearing()}deg)`);
                    let a = "";
                    "viewport" === this._pitchAlignment || "auto" === this._pitchAlignment ? a = "rotateX(0deg)" : "map" === this._pitchAlignment && (a = `rotateX(${this._map.getPitch()}deg)`), t && "moveend" !== t.type || (this._pos = this._pos.round()), i.setTransform(this._element, `${Ta[this._anchor]} translate(${this._pos.x}px, ${this._pos.y}px) ${a} ${s}`), this._map.terrain && !this._opacityTimeout && (this._opacityTimeout = setTimeout(()=>{
                        const t = this._map.unproject(this._pos), e = 40075016.686 * Math.abs(Math.cos(this._lngLat.lat * Math.PI / 180)) / Math.pow(2, this._map.transform.tileZoom + 8);
                        this._element.style.opacity = t.distanceTo(this._lngLat) > 20 * e ? "0.2" : "1.0", this._opacityTimeout = null;
                    }, 100));
                }, this._onMove = (e)=>{
                    if (!this._isDragging) {
                        const t = this._clickTolerance || this._map._clickTolerance;
                        this._isDragging = e.point.dist(this._pointerdownPos) >= t;
                    }
                    this._isDragging && (this._pos = e.point.sub(this._positionDelta), this._lngLat = this._map.unproject(this._pos), this.setLngLat(this._lngLat), this._element.style.pointerEvents = "none", "pending" === this._state && (this._state = "active", this.fire(new t.k("dragstart"))), this.fire(new t.k("drag")));
                }, this._onUp = ()=>{
                    this._element.style.pointerEvents = "auto", this._positionDelta = null, this._pointerdownPos = null, this._isDragging = !1, this._map.off("mousemove", this._onMove), this._map.off("touchmove", this._onMove), "active" === this._state && this.fire(new t.k("dragend")), this._state = "inactive";
                }, this._addDragHandler = (t)=>{
                    this._element.contains(t.originalEvent.target) && (t.preventDefault(), this._positionDelta = t.point.sub(this._pos).add(this._offset), this._pointerdownPos = t.point, this._state = "pending", this._map.on("mousemove", this._onMove), this._map.on("touchmove", this._onMove), this._map.once("mouseup", this._onUp), this._map.once("touchend", this._onUp));
                }, this._anchor = e && e.anchor || "center", this._color = e && e.color || "#3FB1CE", this._scale = e && e.scale || 1, this._draggable = e && e.draggable || !1, this._clickTolerance = e && e.clickTolerance || 0, this._isDragging = !1, this._state = "inactive", this._rotation = e && e.rotation || 0, this._rotationAlignment = e && e.rotationAlignment || "auto", this._pitchAlignment = e && e.pitchAlignment && "auto" !== e.pitchAlignment ? e.pitchAlignment : this._rotationAlignment, e && e.element) this._element = e.element, this._offset = t.P.convert(e && e.offset || [
                    0,
                    0
                ]);
                else {
                    this._defaultMarker = !0, this._element = i.create("div"), this._element.setAttribute("aria-label", "Map marker");
                    const s = i.createNS("http://www.w3.org/2000/svg", "svg"), a = 41, o = 27;
                    s.setAttributeNS(null, "display", "block"), s.setAttributeNS(null, "height", `${a}px`), s.setAttributeNS(null, "width", `${o}px`), s.setAttributeNS(null, "viewBox", `0 0 ${o} ${a}`);
                    const r = i.createNS("http://www.w3.org/2000/svg", "g");
                    r.setAttributeNS(null, "stroke", "none"), r.setAttributeNS(null, "stroke-width", "1"), r.setAttributeNS(null, "fill", "none"), r.setAttributeNS(null, "fill-rule", "evenodd");
                    const n = i.createNS("http://www.w3.org/2000/svg", "g");
                    n.setAttributeNS(null, "fill-rule", "nonzero");
                    const l = i.createNS("http://www.w3.org/2000/svg", "g");
                    l.setAttributeNS(null, "transform", "translate(3.0, 29.0)"), l.setAttributeNS(null, "fill", "#000000");
                    const h = [
                        {
                            rx: "10.5",
                            ry: "5.25002273"
                        },
                        {
                            rx: "10.5",
                            ry: "5.25002273"
                        },
                        {
                            rx: "9.5",
                            ry: "4.77275007"
                        },
                        {
                            rx: "8.5",
                            ry: "4.29549936"
                        },
                        {
                            rx: "7.5",
                            ry: "3.81822308"
                        },
                        {
                            rx: "6.5",
                            ry: "3.34094679"
                        },
                        {
                            rx: "5.5",
                            ry: "2.86367051"
                        },
                        {
                            rx: "4.5",
                            ry: "2.38636864"
                        }
                    ];
                    for (const t of h){
                        const e = i.createNS("http://www.w3.org/2000/svg", "ellipse");
                        e.setAttributeNS(null, "opacity", "0.04"), e.setAttributeNS(null, "cx", "10.5"), e.setAttributeNS(null, "cy", "5.80029008"), e.setAttributeNS(null, "rx", t.rx), e.setAttributeNS(null, "ry", t.ry), l.appendChild(e);
                    }
                    const c = i.createNS("http://www.w3.org/2000/svg", "g");
                    c.setAttributeNS(null, "fill", this._color);
                    const u = i.createNS("http://www.w3.org/2000/svg", "path");
                    u.setAttributeNS(null, "d", "M27,13.5 C27,19.074644 20.250001,27.000002 14.75,34.500002 C14.016665,35.500004 12.983335,35.500004 12.25,34.500002 C6.7499993,27.000002 0,19.222562 0,13.5 C0,6.0441559 6.0441559,0 13.5,0 C20.955844,0 27,6.0441559 27,13.5 Z"), c.appendChild(u);
                    const d = i.createNS("http://www.w3.org/2000/svg", "g");
                    d.setAttributeNS(null, "opacity", "0.25"), d.setAttributeNS(null, "fill", "#000000");
                    const _ = i.createNS("http://www.w3.org/2000/svg", "path");
                    _.setAttributeNS(null, "d", "M13.5,0 C6.0441559,0 0,6.0441559 0,13.5 C0,19.222562 6.7499993,27 12.25,34.5 C13,35.522727 14.016664,35.500004 14.75,34.5 C20.250001,27 27,19.074644 27,13.5 C27,6.0441559 20.955844,0 13.5,0 Z M13.5,1 C20.415404,1 26,6.584596 26,13.5 C26,15.898657 24.495584,19.181431 22.220703,22.738281 C19.945823,26.295132 16.705119,30.142167 13.943359,33.908203 C13.743445,34.180814 13.612715,34.322738 13.5,34.441406 C13.387285,34.322738 13.256555,34.180814 13.056641,33.908203 C10.284481,30.127985 7.4148684,26.314159 5.015625,22.773438 C2.6163816,19.232715 1,15.953538 1,13.5 C1,6.584596 6.584596,1 13.5,1 Z"), d.appendChild(_);
                    const p = i.createNS("http://www.w3.org/2000/svg", "g");
                    p.setAttributeNS(null, "transform", "translate(6.0, 7.0)"), p.setAttributeNS(null, "fill", "#FFFFFF");
                    const m = i.createNS("http://www.w3.org/2000/svg", "g");
                    m.setAttributeNS(null, "transform", "translate(8.0, 8.0)");
                    const f = i.createNS("http://www.w3.org/2000/svg", "circle");
                    f.setAttributeNS(null, "fill", "#000000"), f.setAttributeNS(null, "opacity", "0.25"), f.setAttributeNS(null, "cx", "5.5"), f.setAttributeNS(null, "cy", "5.5"), f.setAttributeNS(null, "r", "5.4999962");
                    const g = i.createNS("http://www.w3.org/2000/svg", "circle");
                    g.setAttributeNS(null, "fill", "#FFFFFF"), g.setAttributeNS(null, "cx", "5.5"), g.setAttributeNS(null, "cy", "5.5"), g.setAttributeNS(null, "r", "5.4999962"), m.appendChild(f), m.appendChild(g), n.appendChild(l), n.appendChild(c), n.appendChild(d), n.appendChild(p), n.appendChild(m), s.appendChild(n), s.setAttributeNS(null, "height", a * this._scale + "px"), s.setAttributeNS(null, "width", o * this._scale + "px"), this._element.appendChild(s), this._offset = t.P.convert(e && e.offset || [
                        0,
                        -14
                    ]);
                }
                if (this._element.classList.add("maplibregl-marker"), this._element.addEventListener("dragstart", (t)=>{
                    t.preventDefault();
                }), this._element.addEventListener("mousedown", (t)=>{
                    t.preventDefault();
                }), Ia(this._element, this._anchor, "marker"), e && e.className) for (const t of e.className.split(" "))this._element.classList.add(t);
                this._popup = null;
            }
            addTo(t) {
                return this.remove(), this._map = t, t.getCanvasContainer().appendChild(this._element), t.on("move", this._update), t.on("moveend", this._update), t.on("terrain", this._update), this.setDraggable(this._draggable), this._update(), this._map.on("click", this._onMapClick), this;
            }
            remove() {
                return this._opacityTimeout && (clearTimeout(this._opacityTimeout), delete this._opacityTimeout), this._map && (this._map.off("click", this._onMapClick), this._map.off("move", this._update), this._map.off("moveend", this._update), this._map.off("mousedown", this._addDragHandler), this._map.off("touchstart", this._addDragHandler), this._map.off("mouseup", this._onUp), this._map.off("touchend", this._onUp), this._map.off("mousemove", this._onMove), this._map.off("touchmove", this._onMove), delete this._map), i.remove(this._element), this._popup && this._popup.remove(), this;
            }
            getLngLat() {
                return this._lngLat;
            }
            setLngLat(e) {
                return this._lngLat = t.L.convert(e), this._pos = null, this._popup && this._popup.setLngLat(this._lngLat), this._update(), this;
            }
            getElement() {
                return this._element;
            }
            setPopup(t) {
                if (this._popup && (this._popup.remove(), this._popup = null, this._element.removeEventListener("keypress", this._onKeyPress), this._originalTabIndex || this._element.removeAttribute("tabindex")), t) {
                    if (!("offset" in t.options)) {
                        const e = 38.1, i = 13.5, s = Math.abs(i) / Math.SQRT2;
                        t.options.offset = this._defaultMarker ? {
                            top: [
                                0,
                                0
                            ],
                            "top-left": [
                                0,
                                0
                            ],
                            "top-right": [
                                0,
                                0
                            ],
                            bottom: [
                                0,
                                -e
                            ],
                            "bottom-left": [
                                s,
                                -1 * (e - i + s)
                            ],
                            "bottom-right": [
                                -s,
                                -1 * (e - i + s)
                            ],
                            left: [
                                i,
                                -1 * (e - i)
                            ],
                            right: [
                                -i,
                                -1 * (e - i)
                            ]
                        } : this._offset;
                    }
                    this._popup = t, this._lngLat && this._popup.setLngLat(this._lngLat), this._originalTabIndex = this._element.getAttribute("tabindex"), this._originalTabIndex || this._element.setAttribute("tabindex", "0"), this._element.addEventListener("keypress", this._onKeyPress);
                }
                return this;
            }
            getPopup() {
                return this._popup;
            }
            togglePopup() {
                const t = this._popup;
                return t ? (t.isOpen() ? t.remove() : t.addTo(this._map), this) : this;
            }
            getOffset() {
                return this._offset;
            }
            setOffset(e) {
                return this._offset = t.P.convert(e), this._update(), this;
            }
            addClassName(t) {
                this._element.classList.add(t);
            }
            removeClassName(t) {
                this._element.classList.remove(t);
            }
            toggleClassName(t) {
                return this._element.classList.toggle(t);
            }
            setDraggable(t) {
                return this._draggable = !!t, this._map && (t ? (this._map.on("mousedown", this._addDragHandler), this._map.on("touchstart", this._addDragHandler)) : (this._map.off("mousedown", this._addDragHandler), this._map.off("touchstart", this._addDragHandler))), this;
            }
            isDraggable() {
                return this._draggable;
            }
            setRotation(t) {
                return this._rotation = t || 0, this._update(), this;
            }
            getRotation() {
                return this._rotation;
            }
            setRotationAlignment(t) {
                return this._rotationAlignment = t || "auto", this._update(), this;
            }
            getRotationAlignment() {
                return this._rotationAlignment;
            }
            setPitchAlignment(t) {
                return this._pitchAlignment = t && "auto" !== t ? t : this._rotationAlignment, this._update(), this;
            }
            getPitchAlignment() {
                return this._pitchAlignment;
            }
        }
        const Sa = {
            positionOptions: {
                enableHighAccuracy: !1,
                maximumAge: 0,
                timeout: 6e3
            },
            fitBoundsOptions: {
                maxZoom: 15
            },
            trackUserLocation: !1,
            showAccuracyCircle: !0,
            showUserLocation: !0
        };
        let Ca = 0, Pa = !1;
        const Da = {
            maxWidth: 100,
            unit: "metric"
        };
        function Ma(t, e, i) {
            const s = i && i.maxWidth || 100, a = t._container.clientHeight / 2, o = t.unproject([
                0,
                a
            ]), r = t.unproject([
                s,
                a
            ]), n = o.distanceTo(r);
            if (i && "imperial" === i.unit) {
                const i = 3.2808 * n;
                i > 5280 ? za(e, s, i / 5280, t._getUIString("ScaleControl.Miles")) : za(e, s, i, t._getUIString("ScaleControl.Feet"));
            } else i && "nautical" === i.unit ? za(e, s, n / 1852, t._getUIString("ScaleControl.NauticalMiles")) : n >= 1e3 ? za(e, s, n / 1e3, t._getUIString("ScaleControl.Kilometers")) : za(e, s, n, t._getUIString("ScaleControl.Meters"));
        }
        function za(t, e, i, s) {
            const a = function(t) {
                const e = Math.pow(10, `${Math.floor(t)}`.length - 1);
                let i = t / e;
                return i = i >= 10 ? 10 : i >= 5 ? 5 : i >= 3 ? 3 : i >= 2 ? 2 : i >= 1 ? 1 : function(t) {
                    const e = Math.pow(10, Math.ceil(-Math.log(t) / Math.LN10));
                    return Math.round(t * e) / e;
                }(i), e * i;
            }(i);
            t.style.width = e * (a / i) + "px", t.innerHTML = `${a}&nbsp;${s}`;
        }
        const La = {
            closeButton: !0,
            closeOnClick: !0,
            focusAfterOpen: !0,
            className: "",
            maxWidth: "240px"
        }, Aa = [
            "a[href]",
            "[tabindex]:not([tabindex='-1'])",
            "[contenteditable]:not([contenteditable='false'])",
            "button:not([disabled])",
            "input:not([disabled])",
            "select:not([disabled])",
            "textarea:not([disabled])"
        ].join(", ");
        function Ra(e) {
            if (e) {
                if ("number" == typeof e) {
                    const i = Math.round(Math.abs(e) / Math.SQRT2);
                    return {
                        center: new t.P(0, 0),
                        top: new t.P(0, e),
                        "top-left": new t.P(i, i),
                        "top-right": new t.P(-i, i),
                        bottom: new t.P(0, -e),
                        "bottom-left": new t.P(i, -i),
                        "bottom-right": new t.P(-i, -i),
                        left: new t.P(e, 0),
                        right: new t.P(-e, 0)
                    };
                }
                if (e instanceof t.P || Array.isArray(e)) {
                    const i = t.P.convert(e);
                    return {
                        center: i,
                        top: i,
                        "top-left": i,
                        "top-right": i,
                        bottom: i,
                        "bottom-left": i,
                        "bottom-right": i,
                        left: i,
                        right: i
                    };
                }
                return {
                    center: t.P.convert(e.center || [
                        0,
                        0
                    ]),
                    top: t.P.convert(e.top || [
                        0,
                        0
                    ]),
                    "top-left": t.P.convert(e["top-left"] || [
                        0,
                        0
                    ]),
                    "top-right": t.P.convert(e["top-right"] || [
                        0,
                        0
                    ]),
                    bottom: t.P.convert(e.bottom || [
                        0,
                        0
                    ]),
                    "bottom-left": t.P.convert(e["bottom-left"] || [
                        0,
                        0
                    ]),
                    "bottom-right": t.P.convert(e["bottom-right"] || [
                        0,
                        0
                    ]),
                    left: t.P.convert(e.left || [
                        0,
                        0
                    ]),
                    right: t.P.convert(e.right || [
                        0,
                        0
                    ])
                };
            }
            return Ra(new t.P(0, 0));
        }
        const ka = {
            extend: (e, ...i)=>t.e(e, ...i),
            run (t) {
                t();
            },
            logToElement (t, e = !1, i = "log") {
                const s = window.document.getElementById(i);
                s && (e && (s.innerHTML = ""), s.innerHTML += `<br>${t}`);
            }
        }, Fa = e;
        class Ba {
            static get version() {
                return Fa;
            }
            static get workerCount() {
                return tt.workerCount;
            }
            static set workerCount(t) {
                tt.workerCount = t;
            }
            static get maxParallelImageRequests() {
                return t.c.MAX_PARALLEL_IMAGE_REQUESTS;
            }
            static set maxParallelImageRequests(e) {
                t.c.MAX_PARALLEL_IMAGE_REQUESTS = e;
            }
            static get workerUrl() {
                return t.c.WORKER_URL;
            }
            static set workerUrl(e) {
                t.c.WORKER_URL = e;
            }
            static addProtocol(e, i) {
                t.c.REGISTERED_PROTOCOLS[e] = i;
            }
            static removeProtocol(e) {
                delete t.c.REGISTERED_PROTOCOLS[e];
            }
        }
        return Ba.Map = class extends oa {
            constructor(e){
                if (t.bg.mark(t.bh.create), null != (e = t.e({}, ga, e)).minZoom && null != e.maxZoom && e.minZoom > e.maxZoom) throw new Error("maxZoom must be greater than or equal to minZoom");
                if (null != e.minPitch && null != e.maxPitch && e.minPitch > e.maxPitch) throw new Error("maxPitch must be greater than or equal to minPitch");
                if (null != e.minPitch && e.minPitch < 0) throw new Error("minPitch must be greater than or equal to 0");
                if (null != e.maxPitch && e.maxPitch > 85) throw new Error("maxPitch must be less than or equal to 85");
                if (super(new rs(e.minZoom, e.maxZoom, e.minPitch, e.maxPitch, e.renderWorldCopies), {
                    bearingSnap: e.bearingSnap
                }), this._cooperativeGesturesOnWheel = (t)=>{
                    this._onCooperativeGesture(t, t[this._metaKey], 1);
                }, this._contextLost = (e)=>{
                    e.preventDefault(), this._frame && (this._frame.cancel(), this._frame = null), this.fire(new t.k("webglcontextlost", {
                        originalEvent: e
                    }));
                }, this._contextRestored = (e)=>{
                    this._setupPainter(), this.resize(), this._update(), this.fire(new t.k("webglcontextrestored", {
                        originalEvent: e
                    }));
                }, this._onMapScroll = (t)=>{
                    if (t.target === this._container) return this._container.scrollTop = 0, this._container.scrollLeft = 0, !1;
                }, this._onWindowOnline = ()=>{
                    this._update();
                }, this._interactive = e.interactive, this._cooperativeGestures = e.cooperativeGestures, this._metaKey = 0 === navigator.platform.indexOf("Mac") ? "metaKey" : "ctrlKey", this._maxTileCacheSize = e.maxTileCacheSize, this._maxTileCacheZoomLevels = e.maxTileCacheZoomLevels, this._failIfMajorPerformanceCaveat = e.failIfMajorPerformanceCaveat, this._preserveDrawingBuffer = e.preserveDrawingBuffer, this._antialias = e.antialias, this._trackResize = e.trackResize, this._bearingSnap = e.bearingSnap, this._refreshExpiredTiles = e.refreshExpiredTiles, this._fadeDuration = e.fadeDuration, this._crossSourceCollisions = e.crossSourceCollisions, this._crossFadingFactor = 1, this._collectResourceTiming = e.collectResourceTiming, this._renderTaskQueue = new la, this._controls = [], this._mapId = t.a2(), this._locale = t.e({}, ha, e.locale), this._clickTolerance = e.clickTolerance, this._overridePixelRatio = e.pixelRatio, this._maxCanvasSize = e.maxCanvasSize, this.transformCameraUpdate = e.transformCameraUpdate, this._imageQueueHandle = h.addThrottleControl(()=>this.isMoving()), this._requestManager = new u(e.transformRequest), "string" == typeof e.container) {
                    if (this._container = document.getElementById(e.container), !this._container) throw new Error(`Container '${e.container}' not found.`);
                } else {
                    if (!(e.container instanceof HTMLElement)) throw new Error("Invalid type: 'container' must be a String or HTMLElement.");
                    this._container = e.container;
                }
                if (e.maxBounds && this.setMaxBounds(e.maxBounds), this._setupContainer(), this._setupPainter(), this.on("move", ()=>this._update(!1)), this.on("moveend", ()=>this._update(!1)), this.on("zoom", ()=>this._update(!0)), this.on("terrain", ()=>{
                    this.painter.terrainFacilitator.dirty = !0, this._update(!0);
                }), this.once("idle", ()=>{
                    this._idleTriggered = !0;
                }), "undefined" != typeof window) {
                    addEventListener("online", this._onWindowOnline, !1);
                    let t = !1;
                    const e = ns((t)=>{
                        this._trackResize && !this._removed && this.resize(t)._update();
                    }, 50);
                    this._resizeObserver = new ResizeObserver((i)=>{
                        t ? e(i) : t = !0;
                    }), this._resizeObserver.observe(this._container);
                }
                this.handlers = new aa(this, e), this._cooperativeGestures && this._setupCooperativeGestures(), this._hash = e.hash && new ls("string" == typeof e.hash && e.hash || void 0).addTo(this), this._hash && this._hash._onHashChange() || (this.jumpTo({
                    center: e.center,
                    zoom: e.zoom,
                    bearing: e.bearing,
                    pitch: e.pitch
                }), e.bounds && (this.resize(), this.fitBounds(e.bounds, t.e({}, e.fitBoundsOptions, {
                    duration: 0
                })))), this.resize(), this._localIdeographFontFamily = e.localIdeographFontFamily, this._validateStyle = e.validateStyle, e.style && this.setStyle(e.style, {
                    localIdeographFontFamily: e.localIdeographFontFamily
                }), e.attributionControl && this.addControl(new ra({
                    customAttribution: e.customAttribution
                })), e.maplibreLogo && this.addControl(new na, e.logoPosition), this.on("style.load", ()=>{
                    this.transform.unmodified && this.jumpTo(this.style.stylesheet);
                }), this.on("data", (e)=>{
                    this._update("style" === e.dataType), this.fire(new t.k(`${e.dataType}data`, e));
                }), this.on("dataloading", (e)=>{
                    this.fire(new t.k(`${e.dataType}dataloading`, e));
                }), this.on("dataabort", (e)=>{
                    this.fire(new t.k("sourcedataabort", e));
                });
            }
            _getMapId() {
                return this._mapId;
            }
            addControl(e, i) {
                if (void 0 === i && (i = e.getDefaultPosition ? e.getDefaultPosition() : "top-right"), !e || !e.onAdd) return this.fire(new t.j(new Error("Invalid argument to map.addControl(). Argument must be a control with onAdd and onRemove methods.")));
                const s = e.onAdd(this);
                this._controls.push(e);
                const a = this._controlPositions[i];
                return -1 !== i.indexOf("bottom") ? a.insertBefore(s, a.firstChild) : a.appendChild(s), this;
            }
            removeControl(e) {
                if (!e || !e.onRemove) return this.fire(new t.j(new Error("Invalid argument to map.removeControl(). Argument must be a control with onAdd and onRemove methods.")));
                const i = this._controls.indexOf(e);
                return i > -1 && this._controls.splice(i, 1), e.onRemove(this), this;
            }
            hasControl(t) {
                return this._controls.indexOf(t) > -1;
            }
            calculateCameraOptionsFromTo(t, e, i, s) {
                return null == s && this.terrain && (s = this.terrain.getElevationForLngLatZoom(i, this.transform.tileZoom)), super.calculateCameraOptionsFromTo(t, e, i, s);
            }
            resize(e) {
                var i;
                const s = this._containerDimensions(), a = s[0], o = s[1], r = this._getClampedPixelRatio(a, o);
                if (this._resizeCanvas(a, o, r), this.painter.resize(a, o, r), this.painter.overLimit()) {
                    const t = this.painter.context.gl;
                    this._maxCanvasSize = [
                        t.drawingBufferWidth,
                        t.drawingBufferHeight
                    ];
                    const e = this._getClampedPixelRatio(a, o);
                    this._resizeCanvas(a, o, e), this.painter.resize(a, o, e);
                }
                this.transform.resize(a, o), null === (i = this._requestedCameraState) || void 0 === i || i.resize(a, o);
                const n = !this._moving;
                return n && (this.stop(), this.fire(new t.k("movestart", e)).fire(new t.k("move", e))), this.fire(new t.k("resize", e)), n && this.fire(new t.k("moveend", e)), this;
            }
            _getClampedPixelRatio(t, e) {
                const { 0: i, 1: s } = this._maxCanvasSize, a = this.getPixelRatio(), o = t * a, r = e * a;
                return Math.min(o > i ? i / o : 1, r > s ? s / r : 1) * a;
            }
            getPixelRatio() {
                var t;
                return null !== (t = this._overridePixelRatio) && void 0 !== t ? t : devicePixelRatio;
            }
            setPixelRatio(t) {
                this._overridePixelRatio = t, this.resize();
            }
            getBounds() {
                return this.transform.getBounds();
            }
            getMaxBounds() {
                return this.transform.getMaxBounds();
            }
            setMaxBounds(t) {
                return this.transform.setMaxBounds(L.convert(t)), this._update();
            }
            setMinZoom(t) {
                if ((t = null == t ? -2 : t) >= -2 && t <= this.transform.maxZoom) return this.transform.minZoom = t, this._update(), this.getZoom() < t && this.setZoom(t), this;
                throw new Error("minZoom must be between -2 and the current maxZoom, inclusive");
            }
            getMinZoom() {
                return this.transform.minZoom;
            }
            setMaxZoom(t) {
                if ((t = null == t ? 22 : t) >= this.transform.minZoom) return this.transform.maxZoom = t, this._update(), this.getZoom() > t && this.setZoom(t), this;
                throw new Error("maxZoom must be greater than the current minZoom");
            }
            getMaxZoom() {
                return this.transform.maxZoom;
            }
            setMinPitch(t) {
                if ((t = null == t ? 0 : t) < 0) throw new Error("minPitch must be greater than or equal to 0");
                if (t >= 0 && t <= this.transform.maxPitch) return this.transform.minPitch = t, this._update(), this.getPitch() < t && this.setPitch(t), this;
                throw new Error("minPitch must be between 0 and the current maxPitch, inclusive");
            }
            getMinPitch() {
                return this.transform.minPitch;
            }
            setMaxPitch(t) {
                if ((t = null == t ? 60 : t) > 85) throw new Error("maxPitch must be less than or equal to 85");
                if (t >= this.transform.minPitch) return this.transform.maxPitch = t, this._update(), this.getPitch() > t && this.setPitch(t), this;
                throw new Error("maxPitch must be greater than the current minPitch");
            }
            getMaxPitch() {
                return this.transform.maxPitch;
            }
            getRenderWorldCopies() {
                return this.transform.renderWorldCopies;
            }
            setRenderWorldCopies(t) {
                return this.transform.renderWorldCopies = t, this._update();
            }
            getCooperativeGestures() {
                return this._cooperativeGestures;
            }
            setCooperativeGestures(t) {
                return this._cooperativeGestures = t, this._cooperativeGestures ? this._setupCooperativeGestures() : this._destroyCooperativeGestures(), this;
            }
            project(e) {
                return this.transform.locationPoint(t.L.convert(e), this.style && this.terrain);
            }
            unproject(e) {
                return this.transform.pointLocation(t.P.convert(e), this.terrain);
            }
            isMoving() {
                var t;
                return this._moving || (null === (t = this.handlers) || void 0 === t ? void 0 : t.isMoving());
            }
            isZooming() {
                var t;
                return this._zooming || (null === (t = this.handlers) || void 0 === t ? void 0 : t.isZooming());
            }
            isRotating() {
                var t;
                return this._rotating || (null === (t = this.handlers) || void 0 === t ? void 0 : t.isRotating());
            }
            _createDelegatedListener(t, e, i) {
                if ("mouseenter" === t || "mouseover" === t) {
                    let s = !1;
                    const a = (a)=>{
                        const o = this.getLayer(e) ? this.queryRenderedFeatures(a.point, {
                            layers: [
                                e
                            ]
                        }) : [];
                        o.length ? s || (s = !0, i.call(this, new gs(t, this, a.originalEvent, {
                            features: o
                        }))) : s = !1;
                    };
                    return {
                        layer: e,
                        listener: i,
                        delegates: {
                            mousemove: a,
                            mouseout: ()=>{
                                s = !1;
                            }
                        }
                    };
                }
                if ("mouseleave" === t || "mouseout" === t) {
                    let s = !1;
                    const a = (a)=>{
                        (this.getLayer(e) ? this.queryRenderedFeatures(a.point, {
                            layers: [
                                e
                            ]
                        }) : []).length ? s = !0 : s && (s = !1, i.call(this, new gs(t, this, a.originalEvent)));
                    }, o = (e)=>{
                        s && (s = !1, i.call(this, new gs(t, this, e.originalEvent)));
                    };
                    return {
                        layer: e,
                        listener: i,
                        delegates: {
                            mousemove: a,
                            mouseout: o
                        }
                    };
                }
                {
                    const s = (t)=>{
                        const s = this.getLayer(e) ? this.queryRenderedFeatures(t.point, {
                            layers: [
                                e
                            ]
                        }) : [];
                        s.length && (t.features = s, i.call(this, t), delete t.features);
                    };
                    return {
                        layer: e,
                        listener: i,
                        delegates: {
                            [t]: s
                        }
                    };
                }
            }
            on(t, e, i) {
                if (void 0 === i) return super.on(t, e);
                const s = this._createDelegatedListener(t, e, i);
                this._delegatedListeners = this._delegatedListeners || {}, this._delegatedListeners[t] = this._delegatedListeners[t] || [], this._delegatedListeners[t].push(s);
                for(const t in s.delegates)this.on(t, s.delegates[t]);
                return this;
            }
            once(t, e, i) {
                if (void 0 === i) return super.once(t, e);
                const s = this._createDelegatedListener(t, e, i);
                for(const t in s.delegates)this.once(t, s.delegates[t]);
                return this;
            }
            off(t, e, i) {
                return void 0 === i ? super.off(t, e) : (this._delegatedListeners && this._delegatedListeners[t] && ((s)=>{
                    const a = this._delegatedListeners[t];
                    for(let t = 0; t < a.length; t++){
                        const s = a[t];
                        if (s.layer === e && s.listener === i) {
                            for(const t in s.delegates)this.off(t, s.delegates[t]);
                            return a.splice(t, 1), this;
                        }
                    }
                })(), this);
            }
            queryRenderedFeatures(e, i) {
                if (!this.style) return [];
                let s;
                const a = e instanceof t.P || Array.isArray(e), o = a ? e : [
                    [
                        0,
                        0
                    ],
                    [
                        this.transform.width,
                        this.transform.height
                    ]
                ];
                if (i = i || (a ? {} : e) || {}, o instanceof t.P || "number" == typeof o[0]) s = [
                    t.P.convert(o)
                ];
                else {
                    const e = t.P.convert(o[0]), i = t.P.convert(o[1]);
                    s = [
                        e,
                        new t.P(i.x, e.y),
                        i,
                        new t.P(e.x, i.y),
                        e
                    ];
                }
                return this.style.queryRenderedFeatures(s, i, this.transform);
            }
            querySourceFeatures(t, e) {
                return this.style.querySourceFeatures(t, e);
            }
            setStyle(e, i) {
                return !1 !== (i = t.e({}, {
                    localIdeographFontFamily: this._localIdeographFontFamily,
                    validate: this._validateStyle
                }, i)).diff && i.localIdeographFontFamily === this._localIdeographFontFamily && this.style && e ? (this._diffStyle(e, i), this) : (this._localIdeographFontFamily = i.localIdeographFontFamily, this._updateStyle(e, i));
            }
            setTransformRequest(t) {
                return this._requestManager.setTransformRequest(t), this;
            }
            _getUIString(t) {
                const e = this._locale[t];
                if (null == e) throw new Error(`Missing UI string '${t}'`);
                return e;
            }
            _updateStyle(t, e) {
                if (e.transformStyle && this.style && !this.style._loaded) return void this.style.once("style.load", ()=>this._updateStyle(t, e));
                const i = this.style && e.transformStyle ? this.style.serialize() : void 0;
                return this.style && (this.style.setEventedParent(null), this.style._remove(!t)), t ? (this.style = new se(this, e || {}), this.style.setEventedParent(this, {
                    style: this.style
                }), "string" == typeof t ? this.style.loadURL(t, e, i) : this.style.loadJSON(t, e, i), this) : (delete this.style, this);
            }
            _lazyInitEmptyStyle() {
                this.style || (this.style = new se(this, {}), this.style.setEventedParent(this, {
                    style: this.style
                }), this.style.loadEmpty());
            }
            _diffStyle(e, i) {
                if ("string" == typeof e) {
                    const s = this._requestManager.transformRequest(e, c.Style);
                    t.f(s, (e, s)=>{
                        e ? this.fire(new t.j(e)) : s && this._updateDiff(s, i);
                    });
                } else "object" == typeof e && this._updateDiff(e, i);
            }
            _updateDiff(e, i) {
                try {
                    this.style.setState(e, i) && this._update(!0);
                } catch (s) {
                    t.w(`Unable to perform style diff: ${s.message || s.error || s}.  Rebuilding the style from scratch.`), this._updateStyle(e, i);
                }
            }
            getStyle() {
                if (this.style) return this.style.serialize();
            }
            isStyleLoaded() {
                return this.style ? this.style.loaded() : t.w("There is no style added to the map.");
            }
            addSource(t, e) {
                return this._lazyInitEmptyStyle(), this.style.addSource(t, e), this._update(!0);
            }
            isSourceLoaded(e) {
                const i = this.style && this.style.sourceCaches[e];
                if (void 0 !== i) return i.loaded();
                this.fire(new t.j(new Error(`There is no source with ID '${e}'`)));
            }
            setTerrain(e) {
                if (this.style._checkLoaded(), this._terrainDataCallback && this.style.off("data", this._terrainDataCallback), e) {
                    const i = this.style.sourceCaches[e.source];
                    if (!i) throw new Error(`cannot load terrain, because there exists no source with ID: ${e.source}`);
                    for(const i in this.style._layers){
                        const s = this.style._layers[i];
                        "hillshade" === s.type && s.source === e.source && t.w("You are using the same source for a hillshade layer and for 3D terrain. Please consider using two separate sources to improve rendering quality.");
                    }
                    this.terrain = new da(this.painter, i, e), this.painter.renderToTexture = new ma(this.painter, this.terrain), this.transform._minEleveationForCurrentTile = this.terrain.getMinTileElevationForLngLatZoom(this.transform.center, this.transform.tileZoom), this.transform.elevation = this.terrain.getElevationForLngLatZoom(this.transform.center, this.transform.tileZoom), this._terrainDataCallback = (t)=>{
                        "style" === t.dataType ? this.terrain.sourceCache.freeRtt() : "source" === t.dataType && t.tile && (t.sourceId !== e.source || this._elevationFreeze || (this.transform._minEleveationForCurrentTile = this.terrain.getMinTileElevationForLngLatZoom(this.transform.center, this.transform.tileZoom), this.transform.elevation = this.terrain.getElevationForLngLatZoom(this.transform.center, this.transform.tileZoom)), this.terrain.sourceCache.freeRtt(t.tile.tileID));
                    }, this.style.on("data", this._terrainDataCallback);
                } else this.terrain && this.terrain.sourceCache.destruct(), this.terrain = null, this.painter.renderToTexture && this.painter.renderToTexture.destruct(), this.painter.renderToTexture = null, this.transform._minEleveationForCurrentTile = 0, this.transform.elevation = 0;
                return this.fire(new t.k("terrain", {
                    terrain: e
                })), this;
            }
            getTerrain() {
                var t, e;
                return null !== (e = null === (t = this.terrain) || void 0 === t ? void 0 : t.options) && void 0 !== e ? e : null;
            }
            areTilesLoaded() {
                const t = this.style && this.style.sourceCaches;
                for(const e in t){
                    const i = t[e]._tiles;
                    for(const t in i){
                        const e = i[t];
                        if ("loaded" !== e.state && "errored" !== e.state) return !1;
                    }
                }
                return !0;
            }
            addSourceType(t, e, i) {
                return this._lazyInitEmptyStyle(), this.style.addSourceType(t, e, i);
            }
            removeSource(t) {
                return this.style.removeSource(t), this._update(!0);
            }
            getSource(t) {
                return this.style.getSource(t);
            }
            addImage(e, i, s = {}) {
                const { pixelRatio: a = 1, sdf: o = !1, stretchX: r, stretchY: n, content: l } = s;
                if (this._lazyInitEmptyStyle(), !(i instanceof HTMLImageElement || t.a(i))) {
                    if (void 0 === i.width || void 0 === i.height) return this.fire(new t.j(new Error("Invalid arguments to map.addImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
                    {
                        const { width: s, height: h, data: c } = i, u = i;
                        return this.style.addImage(e, {
                            data: new t.R({
                                width: s,
                                height: h
                            }, new Uint8Array(c)),
                            pixelRatio: a,
                            stretchX: r,
                            stretchY: n,
                            content: l,
                            sdf: o,
                            version: 0,
                            userImage: u
                        }), u.onAdd && u.onAdd(this, e), this;
                    }
                }
                {
                    const { width: s, height: h, data: c } = t.h.getImageData(i);
                    this.style.addImage(e, {
                        data: new t.R({
                            width: s,
                            height: h
                        }, c),
                        pixelRatio: a,
                        stretchX: r,
                        stretchY: n,
                        content: l,
                        sdf: o,
                        version: 0
                    });
                }
            }
            updateImage(e, i) {
                const s = this.style.getImage(e);
                if (!s) return this.fire(new t.j(new Error("The map has no image with that id. If you are adding a new image use `map.addImage(...)` instead.")));
                const a = i instanceof HTMLImageElement || t.a(i) ? t.h.getImageData(i) : i, { width: o, height: r, data: n } = a;
                if (void 0 === o || void 0 === r) return this.fire(new t.j(new Error("Invalid arguments to map.updateImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
                if (o !== s.data.width || r !== s.data.height) return this.fire(new t.j(new Error("The width and height of the updated image must be that same as the previous version of the image")));
                const l = !(i instanceof HTMLImageElement || t.a(i));
                return s.data.replace(n, l), this.style.updateImage(e, s), this;
            }
            getImage(t) {
                return this.style.getImage(t);
            }
            hasImage(e) {
                return e ? !!this.style.getImage(e) : (this.fire(new t.j(new Error("Missing required image id"))), !1);
            }
            removeImage(t) {
                this.style.removeImage(t);
            }
            loadImage(t, e) {
                h.getImage(this._requestManager.transformRequest(t, c.Image), e);
            }
            listImages() {
                return this.style.listImages();
            }
            addLayer(t, e) {
                return this._lazyInitEmptyStyle(), this.style.addLayer(t, e), this._update(!0);
            }
            moveLayer(t, e) {
                return this.style.moveLayer(t, e), this._update(!0);
            }
            removeLayer(t) {
                return this.style.removeLayer(t), this._update(!0);
            }
            getLayer(t) {
                return this.style.getLayer(t);
            }
            getLayersOrder() {
                return this.style.getLayersOrder();
            }
            setLayerZoomRange(t, e, i) {
                return this.style.setLayerZoomRange(t, e, i), this._update(!0);
            }
            setFilter(t, e, i = {}) {
                return this.style.setFilter(t, e, i), this._update(!0);
            }
            getFilter(t) {
                return this.style.getFilter(t);
            }
            setPaintProperty(t, e, i, s = {}) {
                return this.style.setPaintProperty(t, e, i, s), this._update(!0);
            }
            getPaintProperty(t, e) {
                return this.style.getPaintProperty(t, e);
            }
            setLayoutProperty(t, e, i, s = {}) {
                return this.style.setLayoutProperty(t, e, i, s), this._update(!0);
            }
            getLayoutProperty(t, e) {
                return this.style.getLayoutProperty(t, e);
            }
            setGlyphs(t, e = {}) {
                return this._lazyInitEmptyStyle(), this.style.setGlyphs(t, e), this._update(!0);
            }
            getGlyphs() {
                return this.style.getGlyphsUrl();
            }
            addSprite(t, e, i = {}) {
                return this._lazyInitEmptyStyle(), this.style.addSprite(t, e, i, (t)=>{
                    t || this._update(!0);
                }), this;
            }
            removeSprite(t) {
                return this._lazyInitEmptyStyle(), this.style.removeSprite(t), this._update(!0);
            }
            getSprite() {
                return this.style.getSprite();
            }
            setSprite(t, e = {}) {
                return this._lazyInitEmptyStyle(), this.style.setSprite(t, e, (t)=>{
                    t || this._update(!0);
                }), this;
            }
            setLight(t, e = {}) {
                return this._lazyInitEmptyStyle(), this.style.setLight(t, e), this._update(!0);
            }
            getLight() {
                return this.style.getLight();
            }
            setFeatureState(t, e) {
                return this.style.setFeatureState(t, e), this._update();
            }
            removeFeatureState(t, e) {
                return this.style.removeFeatureState(t, e), this._update();
            }
            getFeatureState(t) {
                return this.style.getFeatureState(t);
            }
            getContainer() {
                return this._container;
            }
            getCanvasContainer() {
                return this._canvasContainer;
            }
            getCanvas() {
                return this._canvas;
            }
            _containerDimensions() {
                let t = 0, e = 0;
                return this._container && (t = this._container.clientWidth || 400, e = this._container.clientHeight || 300), [
                    t,
                    e
                ];
            }
            _setupContainer() {
                const t = this._container;
                t.classList.add("maplibregl-map");
                const e = this._canvasContainer = i.create("div", "maplibregl-canvas-container", t);
                this._interactive && e.classList.add("maplibregl-interactive"), this._canvas = i.create("canvas", "maplibregl-canvas", e), this._canvas.addEventListener("webglcontextlost", this._contextLost, !1), this._canvas.addEventListener("webglcontextrestored", this._contextRestored, !1), this._canvas.setAttribute("tabindex", "0"), this._canvas.setAttribute("aria-label", "Map"), this._canvas.setAttribute("role", "region");
                const s = this._containerDimensions(), a = this._getClampedPixelRatio(s[0], s[1]);
                this._resizeCanvas(s[0], s[1], a);
                const o = this._controlContainer = i.create("div", "maplibregl-control-container", t), r = this._controlPositions = {};
                [
                    "top-left",
                    "top-right",
                    "bottom-left",
                    "bottom-right"
                ].forEach((t)=>{
                    r[t] = i.create("div", `maplibregl-ctrl-${t} `, o);
                }), this._container.addEventListener("scroll", this._onMapScroll, !1);
            }
            _setupCooperativeGestures() {
                this._cooperativeGesturesScreen = i.create("div", "maplibregl-cooperative-gesture-screen", this._container);
                let t = "boolean" != typeof this._cooperativeGestures && this._cooperativeGestures.windowsHelpText ? this._cooperativeGestures.windowsHelpText : "Use Ctrl + scroll to zoom the map";
                0 === navigator.platform.indexOf("Mac") && (t = "boolean" != typeof this._cooperativeGestures && this._cooperativeGestures.macHelpText ? this._cooperativeGestures.macHelpText : "Use \u2318 + scroll to zoom the map"), this._cooperativeGesturesScreen.innerHTML = `\n            <div class="maplibregl-desktop-message">${t}</div>\n            <div class="maplibregl-mobile-message">${"boolean" != typeof this._cooperativeGestures && this._cooperativeGestures.mobileHelpText ? this._cooperativeGestures.mobileHelpText : "Use two fingers to move the map"}</div>\n        `, this._cooperativeGesturesScreen.setAttribute("aria-hidden", "true"), this._canvasContainer.addEventListener("wheel", this._cooperativeGesturesOnWheel, !1), this._canvasContainer.classList.add("maplibregl-cooperative-gestures");
            }
            _destroyCooperativeGestures() {
                i.remove(this._cooperativeGesturesScreen), this._canvasContainer.removeEventListener("wheel", this._cooperativeGesturesOnWheel, !1), this._canvasContainer.classList.remove("maplibregl-cooperative-gestures");
            }
            _resizeCanvas(t, e, i) {
                this._canvas.width = Math.floor(i * t), this._canvas.height = Math.floor(i * e), this._canvas.style.width = `${t}px`, this._canvas.style.height = `${e}px`;
            }
            _setupPainter() {
                const t = {
                    alpha: !0,
                    stencil: !0,
                    depth: !0,
                    failIfMajorPerformanceCaveat: this._failIfMajorPerformanceCaveat,
                    preserveDrawingBuffer: this._preserveDrawingBuffer,
                    antialias: this._antialias || !1
                };
                let e = null;
                this._canvas.addEventListener("webglcontextcreationerror", (i)=>{
                    e = {
                        requestedAttributes: t
                    }, i && (e.statusMessage = i.statusMessage, e.type = i.type);
                }, {
                    once: !0
                });
                const i = this._canvas.getContext("webgl2", t) || this._canvas.getContext("webgl", t);
                if (!i) {
                    const t = "Failed to initialize WebGL";
                    throw e ? (e.message = t, new Error(JSON.stringify(e))) : new Error(t);
                }
                this.painter = new is(i, this.transform), s.testSupport(i);
            }
            _onCooperativeGesture(t, e, i) {
                return !e && i < 2 && (this._cooperativeGesturesScreen.classList.add("maplibregl-show"), setTimeout(()=>{
                    this._cooperativeGesturesScreen.classList.remove("maplibregl-show");
                }, 100)), !1;
            }
            loaded() {
                return !this._styleDirty && !this._sourcesDirty && !!this.style && this.style.loaded();
            }
            _update(t) {
                return this.style && this.style._loaded ? (this._styleDirty = this._styleDirty || t, this._sourcesDirty = !0, this.triggerRepaint(), this) : this;
            }
            _requestRenderFrame(t) {
                return this._update(), this._renderTaskQueue.add(t);
            }
            _cancelRenderFrame(t) {
                this._renderTaskQueue.remove(t);
            }
            _render(e) {
                const i = this._idleTriggered ? this._fadeDuration : 0;
                if (this.painter.context.setDirty(), this.painter.setBaseState(), this._renderTaskQueue.run(e), this._removed) return;
                let s = !1;
                if (this.style && this._styleDirty) {
                    this._styleDirty = !1;
                    const e = this.transform.zoom, a = t.h.now();
                    this.style.zoomHistory.update(e, a);
                    const o = new t.a8(e, {
                        now: a,
                        fadeDuration: i,
                        zoomHistory: this.style.zoomHistory,
                        transition: this.style.getTransition()
                    }), r = o.crossFadingFactor();
                    1 === r && r === this._crossFadingFactor || (s = !0, this._crossFadingFactor = r), this.style.update(o);
                }
                this.style && this._sourcesDirty && (this._sourcesDirty = !1, this.style._updateSources(this.transform)), this.terrain ? (this.terrain.sourceCache.update(this.transform, this.terrain), this.transform._minEleveationForCurrentTile = this.terrain.getMinTileElevationForLngLatZoom(this.transform.center, this.transform.tileZoom), this._elevationFreeze || (this.transform.elevation = this.terrain.getElevationForLngLatZoom(this.transform.center, this.transform.tileZoom))) : (this.transform._minEleveationForCurrentTile = 0, this.transform.elevation = 0), this._placementDirty = this.style && this.style._updatePlacement(this.painter.transform, this.showCollisionBoxes, i, this._crossSourceCollisions), this.painter.render(this.style, {
                    showTileBoundaries: this.showTileBoundaries,
                    showOverdrawInspector: this._showOverdrawInspector,
                    rotating: this.isRotating(),
                    zooming: this.isZooming(),
                    moving: this.isMoving(),
                    fadeDuration: i,
                    showPadding: this.showPadding
                }), this.fire(new t.k("render")), this.loaded() && !this._loaded && (this._loaded = !0, t.bg.mark(t.bh.load), this.fire(new t.k("load"))), this.style && (this.style.hasTransitions() || s) && (this._styleDirty = !0), this.style && !this._placementDirty && this.style._releaseSymbolFadeTiles();
                const a = this._sourcesDirty || this._styleDirty || this._placementDirty;
                return a || this._repaint ? this.triggerRepaint() : !this.isMoving() && this.loaded() && this.fire(new t.k("idle")), !this._loaded || this._fullyLoaded || a || (this._fullyLoaded = !0, t.bg.mark(t.bh.fullLoad)), this;
            }
            redraw() {
                return this.style && (this._frame && (this._frame.cancel(), this._frame = null), this._render(0)), this;
            }
            remove() {
                var e;
                this._hash && this._hash.remove();
                for (const t of this._controls)t.onRemove(this);
                this._controls = [], this._frame && (this._frame.cancel(), this._frame = null), this._renderTaskQueue.clear(), this.painter.destroy(), this.handlers.destroy(), delete this.handlers, this.setStyle(null), "undefined" != typeof window && removeEventListener("online", this._onWindowOnline, !1), h.removeThrottleControl(this._imageQueueHandle), null === (e = this._resizeObserver) || void 0 === e || e.disconnect();
                const s = this.painter.context.gl.getExtension("WEBGL_lose_context");
                s && s.loseContext(), this._canvas.removeEventListener("webglcontextrestored", this._contextRestored, !1), this._canvas.removeEventListener("webglcontextlost", this._contextLost, !1), i.remove(this._canvasContainer), i.remove(this._controlContainer), this._cooperativeGestures && this._destroyCooperativeGestures(), this._container.classList.remove("maplibregl-map"), t.bg.clearMetrics(), this._removed = !0, this.fire(new t.k("remove"));
            }
            triggerRepaint() {
                this.style && !this._frame && (this._frame = t.h.frame((e)=>{
                    t.bg.frame(e), this._frame = null, this._render(e);
                }));
            }
            get showTileBoundaries() {
                return !!this._showTileBoundaries;
            }
            set showTileBoundaries(t) {
                this._showTileBoundaries !== t && (this._showTileBoundaries = t, this._update());
            }
            get showPadding() {
                return !!this._showPadding;
            }
            set showPadding(t) {
                this._showPadding !== t && (this._showPadding = t, this._update());
            }
            get showCollisionBoxes() {
                return !!this._showCollisionBoxes;
            }
            set showCollisionBoxes(t) {
                this._showCollisionBoxes !== t && (this._showCollisionBoxes = t, t ? this.style._generateCollisionBoxes() : this._update());
            }
            get showOverdrawInspector() {
                return !!this._showOverdrawInspector;
            }
            set showOverdrawInspector(t) {
                this._showOverdrawInspector !== t && (this._showOverdrawInspector = t, this._update());
            }
            get repaint() {
                return !!this._repaint;
            }
            set repaint(t) {
                this._repaint !== t && (this._repaint = t, this.triggerRepaint());
            }
            get vertices() {
                return !!this._vertices;
            }
            set vertices(t) {
                this._vertices = t, this._update();
            }
            get version() {
                return fa;
            }
            getCameraTargetElevation() {
                return this.transform.elevation;
            }
        }, Ba.NavigationControl = class {
            constructor(e){
                this._updateZoomButtons = ()=>{
                    const t = this._map.getZoom(), e = t === this._map.getMaxZoom(), i = t === this._map.getMinZoom();
                    this._zoomInButton.disabled = e, this._zoomOutButton.disabled = i, this._zoomInButton.setAttribute("aria-disabled", e.toString()), this._zoomOutButton.setAttribute("aria-disabled", i.toString());
                }, this._rotateCompassArrow = ()=>{
                    const t = this.options.visualizePitch ? `scale(${1 / Math.pow(Math.cos(this._map.transform.pitch * (Math.PI / 180)), .5)}) rotateX(${this._map.transform.pitch}deg) rotateZ(${this._map.transform.angle * (180 / Math.PI)}deg)` : `rotate(${this._map.transform.angle * (180 / Math.PI)}deg)`;
                    this._compassIcon.style.transform = t;
                }, this._setButtonTitle = (t, e)=>{
                    const i = this._map._getUIString(`NavigationControl.${e}`);
                    t.title = i, t.setAttribute("aria-label", i);
                }, this.options = t.e({}, xa, e), this._container = i.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._container.addEventListener("contextmenu", (t)=>t.preventDefault()), this.options.showZoom && (this._zoomInButton = this._createButton("maplibregl-ctrl-zoom-in", (t)=>this._map.zoomIn({}, {
                        originalEvent: t
                    })), i.create("span", "maplibregl-ctrl-icon", this._zoomInButton).setAttribute("aria-hidden", "true"), this._zoomOutButton = this._createButton("maplibregl-ctrl-zoom-out", (t)=>this._map.zoomOut({}, {
                        originalEvent: t
                    })), i.create("span", "maplibregl-ctrl-icon", this._zoomOutButton).setAttribute("aria-hidden", "true")), this.options.showCompass && (this._compass = this._createButton("maplibregl-ctrl-compass", (t)=>{
                    this.options.visualizePitch ? this._map.resetNorthPitch({}, {
                        originalEvent: t
                    }) : this._map.resetNorth({}, {
                        originalEvent: t
                    });
                }), this._compassIcon = i.create("span", "maplibregl-ctrl-icon", this._compass), this._compassIcon.setAttribute("aria-hidden", "true"));
            }
            onAdd(t) {
                return this._map = t, this.options.showZoom && (this._setButtonTitle(this._zoomInButton, "ZoomIn"), this._setButtonTitle(this._zoomOutButton, "ZoomOut"), this._map.on("zoom", this._updateZoomButtons), this._updateZoomButtons()), this.options.showCompass && (this._setButtonTitle(this._compass, "ResetBearing"), this.options.visualizePitch && this._map.on("pitch", this._rotateCompassArrow), this._map.on("rotate", this._rotateCompassArrow), this._rotateCompassArrow(), this._handler = new ya(this._map, this._compass, this.options.visualizePitch)), this._container;
            }
            onRemove() {
                i.remove(this._container), this.options.showZoom && this._map.off("zoom", this._updateZoomButtons), this.options.showCompass && (this.options.visualizePitch && this._map.off("pitch", this._rotateCompassArrow), this._map.off("rotate", this._rotateCompassArrow), this._handler.off(), delete this._handler), delete this._map;
            }
            _createButton(t, e) {
                const s = i.create("button", t, this._container);
                return s.type = "button", s.addEventListener("click", e), s;
            }
        }, Ba.GeolocateControl = class extends t.E {
            constructor(e){
                super(), this._onSuccess = (e)=>{
                    if (this._map) {
                        if (this._isOutOfMapMaxBounds(e)) return this._setErrorState(), this.fire(new t.k("outofmaxbounds", e)), this._updateMarker(), void this._finish();
                        if (this.options.trackUserLocation) switch(this._lastKnownPosition = e, this._watchState){
                            case "WAITING_ACTIVE":
                            case "ACTIVE_LOCK":
                            case "ACTIVE_ERROR":
                                this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active");
                                break;
                            case "BACKGROUND":
                            case "BACKGROUND_ERROR":
                                this._watchState = "BACKGROUND", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-background");
                                break;
                            default:
                                throw new Error(`Unexpected watchState ${this._watchState}`);
                        }
                        this.options.showUserLocation && "OFF" !== this._watchState && this._updateMarker(e), this.options.trackUserLocation && "ACTIVE_LOCK" !== this._watchState || this._updateCamera(e), this.options.showUserLocation && this._dotElement.classList.remove("maplibregl-user-location-dot-stale"), this.fire(new t.k("geolocate", e)), this._finish();
                    }
                }, this._updateCamera = (e)=>{
                    const i = new t.L(e.coords.longitude, e.coords.latitude), s = e.coords.accuracy, a = this._map.getBearing(), o = t.e({
                        bearing: a
                    }, this.options.fitBoundsOptions), r = L.fromLngLat(i, s);
                    this._map.fitBounds(r, o, {
                        geolocateSource: !0
                    });
                }, this._updateMarker = (e)=>{
                    if (e) {
                        const i = new t.L(e.coords.longitude, e.coords.latitude);
                        this._accuracyCircleMarker.setLngLat(i).addTo(this._map), this._userLocationDotMarker.setLngLat(i).addTo(this._map), this._accuracy = e.coords.accuracy, this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
                    } else this._userLocationDotMarker.remove(), this._accuracyCircleMarker.remove();
                }, this._onZoom = ()=>{
                    this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
                }, this._onError = (e)=>{
                    if (this._map) {
                        if (this.options.trackUserLocation) {
                            if (1 === e.code) {
                                this._watchState = "OFF", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background-error"), this._geolocateButton.disabled = !0;
                                const t = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                                this._geolocateButton.title = t, this._geolocateButton.setAttribute("aria-label", t), void 0 !== this._geolocationWatchID && this._clearWatch();
                            } else {
                                if (3 === e.code && Pa) return;
                                this._setErrorState();
                            }
                        }
                        "OFF" !== this._watchState && this.options.showUserLocation && this._dotElement.classList.add("maplibregl-user-location-dot-stale"), this.fire(new t.k("error", e)), this._finish();
                    }
                }, this._finish = ()=>{
                    this._timeoutId && clearTimeout(this._timeoutId), this._timeoutId = void 0;
                }, this._setupUI = (e)=>{
                    if (this._map) {
                        if (this._container.addEventListener("contextmenu", (t)=>t.preventDefault()), this._geolocateButton = i.create("button", "maplibregl-ctrl-geolocate", this._container), i.create("span", "maplibregl-ctrl-icon", this._geolocateButton).setAttribute("aria-hidden", "true"), this._geolocateButton.type = "button", !1 === e) {
                            t.w("Geolocation support is not available so the GeolocateControl will be disabled.");
                            const e = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                            this._geolocateButton.disabled = !0, this._geolocateButton.title = e, this._geolocateButton.setAttribute("aria-label", e);
                        } else {
                            const t = this._map._getUIString("GeolocateControl.FindMyLocation");
                            this._geolocateButton.title = t, this._geolocateButton.setAttribute("aria-label", t);
                        }
                        this.options.trackUserLocation && (this._geolocateButton.setAttribute("aria-pressed", "false"), this._watchState = "OFF"), this.options.showUserLocation && (this._dotElement = i.create("div", "maplibregl-user-location-dot"), this._userLocationDotMarker = new Ea({
                            element: this._dotElement
                        }), this._circleElement = i.create("div", "maplibregl-user-location-accuracy-circle"), this._accuracyCircleMarker = new Ea({
                            element: this._circleElement,
                            pitchAlignment: "map"
                        }), this.options.trackUserLocation && (this._watchState = "OFF"), this._map.on("zoom", this._onZoom)), this._geolocateButton.addEventListener("click", this.trigger.bind(this)), this._setup = !0, this.options.trackUserLocation && this._map.on("movestart", (e)=>{
                            e.geolocateSource || "ACTIVE_LOCK" !== this._watchState || e.originalEvent && "resize" === e.originalEvent.type || (this._watchState = "BACKGROUND", this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this.fire(new t.k("trackuserlocationend")));
                        });
                    }
                }, this.options = t.e({}, Sa, e);
            }
            onAdd(t) {
                return this._map = t, this._container = i.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), function(t, e = !1) {
                    void 0 === ba || e ? void 0 !== window.navigator.permissions ? window.navigator.permissions.query({
                        name: "geolocation"
                    }).then((e)=>{
                        ba = "denied" !== e.state, t(ba);
                    }).catch(()=>{
                        ba = !!window.navigator.geolocation, t(ba);
                    }) : (ba = !!window.navigator.geolocation, t(ba)) : t(ba);
                }(this._setupUI), this._container;
            }
            onRemove() {
                void 0 !== this._geolocationWatchID && (window.navigator.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0), this.options.showUserLocation && this._userLocationDotMarker && this._userLocationDotMarker.remove(), this.options.showAccuracyCircle && this._accuracyCircleMarker && this._accuracyCircleMarker.remove(), i.remove(this._container), this._map.off("zoom", this._onZoom), this._map = void 0, Ca = 0, Pa = !1;
            }
            _isOutOfMapMaxBounds(t) {
                const e = this._map.getMaxBounds(), i = t.coords;
                return e && (i.longitude < e.getWest() || i.longitude > e.getEast() || i.latitude < e.getSouth() || i.latitude > e.getNorth());
            }
            _setErrorState() {
                switch(this._watchState){
                    case "WAITING_ACTIVE":
                        this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active-error");
                        break;
                    case "ACTIVE_LOCK":
                        this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting");
                        break;
                    case "BACKGROUND":
                        this._watchState = "BACKGROUND_ERROR", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting");
                        break;
                    case "ACTIVE_ERROR":
                        break;
                    default:
                        throw new Error(`Unexpected watchState ${this._watchState}`);
                }
            }
            _updateCircleRadius() {
                const t = this._map.getBounds(), e = t.getSouthEast(), i = t.getNorthEast(), s = e.distanceTo(i), a = Math.ceil(this._accuracy / (s / this._map._container.clientHeight) * 2);
                this._circleElement.style.width = `${a}px`, this._circleElement.style.height = `${a}px`;
            }
            trigger() {
                if (!this._setup) return t.w("Geolocate control triggered before added to a map"), !1;
                if (this.options.trackUserLocation) {
                    switch(this._watchState){
                        case "OFF":
                            this._watchState = "WAITING_ACTIVE", this.fire(new t.k("trackuserlocationstart"));
                            break;
                        case "WAITING_ACTIVE":
                        case "ACTIVE_LOCK":
                        case "ACTIVE_ERROR":
                        case "BACKGROUND_ERROR":
                            Ca--, Pa = !1, this._watchState = "OFF", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background-error"), this.fire(new t.k("trackuserlocationend"));
                            break;
                        case "BACKGROUND":
                            this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background"), this._lastKnownPosition && this._updateCamera(this._lastKnownPosition), this.fire(new t.k("trackuserlocationstart"));
                            break;
                        default:
                            throw new Error(`Unexpected watchState ${this._watchState}`);
                    }
                    switch(this._watchState){
                        case "WAITING_ACTIVE":
                            this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active");
                            break;
                        case "ACTIVE_LOCK":
                            this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active");
                            break;
                        case "OFF":
                            break;
                        default:
                            throw new Error(`Unexpected watchState ${this._watchState}`);
                    }
                    if ("OFF" === this._watchState && void 0 !== this._geolocationWatchID) this._clearWatch();
                    else if (void 0 === this._geolocationWatchID) {
                        let t;
                        this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "true"), Ca++, Ca > 1 ? (t = {
                            maximumAge: 6e5,
                            timeout: 0
                        }, Pa = !0) : (t = this.options.positionOptions, Pa = !1), this._geolocationWatchID = window.navigator.geolocation.watchPosition(this._onSuccess, this._onError, t);
                    }
                } else window.navigator.geolocation.getCurrentPosition(this._onSuccess, this._onError, this.options.positionOptions), this._timeoutId = setTimeout(this._finish, 1e4);
                return !0;
            }
            _clearWatch() {
                window.navigator.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0, this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "false"), this.options.showUserLocation && this._updateMarker(null);
            }
        }, Ba.AttributionControl = ra, Ba.LogoControl = na, Ba.ScaleControl = class {
            constructor(e){
                this._onMove = ()=>{
                    Ma(this._map, this._container, this.options);
                }, this.setUnit = (t)=>{
                    this.options.unit = t, Ma(this._map, this._container, this.options);
                }, this.options = t.e({}, Da, e);
            }
            getDefaultPosition() {
                return "bottom-left";
            }
            onAdd(t) {
                return this._map = t, this._container = i.create("div", "maplibregl-ctrl maplibregl-ctrl-scale", t.getContainer()), this._map.on("move", this._onMove), this._onMove(), this._container;
            }
            onRemove() {
                i.remove(this._container), this._map.off("move", this._onMove), this._map = void 0;
            }
        }, Ba.FullscreenControl = class extends t.E {
            constructor(e = {}){
                super(), this._onFullscreenChange = ()=>{
                    (window.document.fullscreenElement || window.document.mozFullScreenElement || window.document.webkitFullscreenElement || window.document.msFullscreenElement) === this._container !== this._fullscreen && this._handleFullscreenChange();
                }, this._onClickFullscreen = ()=>{
                    this._isFullscreen() ? this._exitFullscreen() : this._requestFullscreen();
                }, this._fullscreen = !1, e && e.container && (e.container instanceof HTMLElement ? this._container = e.container : t.w("Full screen control 'container' must be a DOM element.")), "onfullscreenchange" in document ? this._fullscreenchange = "fullscreenchange" : "onmozfullscreenchange" in document ? this._fullscreenchange = "mozfullscreenchange" : "onwebkitfullscreenchange" in document ? this._fullscreenchange = "webkitfullscreenchange" : "onmsfullscreenchange" in document && (this._fullscreenchange = "MSFullscreenChange");
            }
            onAdd(t) {
                return this._map = t, this._container || (this._container = this._map.getContainer()), this._controlContainer = i.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._setupUI(), this._controlContainer;
            }
            onRemove() {
                i.remove(this._controlContainer), this._map = null, window.document.removeEventListener(this._fullscreenchange, this._onFullscreenChange);
            }
            _setupUI() {
                const t = this._fullscreenButton = i.create("button", "maplibregl-ctrl-fullscreen", this._controlContainer);
                i.create("span", "maplibregl-ctrl-icon", t).setAttribute("aria-hidden", "true"), t.type = "button", this._updateTitle(), this._fullscreenButton.addEventListener("click", this._onClickFullscreen), window.document.addEventListener(this._fullscreenchange, this._onFullscreenChange);
            }
            _updateTitle() {
                const t = this._getTitle();
                this._fullscreenButton.setAttribute("aria-label", t), this._fullscreenButton.title = t;
            }
            _getTitle() {
                return this._map._getUIString(this._isFullscreen() ? "FullscreenControl.Exit" : "FullscreenControl.Enter");
            }
            _isFullscreen() {
                return this._fullscreen;
            }
            _handleFullscreenChange() {
                this._fullscreen = !this._fullscreen, this._fullscreenButton.classList.toggle("maplibregl-ctrl-shrink"), this._fullscreenButton.classList.toggle("maplibregl-ctrl-fullscreen"), this._updateTitle(), this._fullscreen ? (this.fire(new t.k("fullscreenstart")), this._map._cooperativeGestures && (this._prevCooperativeGestures = this._map._cooperativeGestures, this._map.setCooperativeGestures())) : (this.fire(new t.k("fullscreenend")), this._prevCooperativeGestures && (this._map.setCooperativeGestures(this._prevCooperativeGestures), delete this._prevCooperativeGestures));
            }
            _exitFullscreen() {
                window.document.exitFullscreen ? window.document.exitFullscreen() : window.document.mozCancelFullScreen ? window.document.mozCancelFullScreen() : window.document.msExitFullscreen ? window.document.msExitFullscreen() : window.document.webkitCancelFullScreen ? window.document.webkitCancelFullScreen() : this._togglePseudoFullScreen();
            }
            _requestFullscreen() {
                this._container.requestFullscreen ? this._container.requestFullscreen() : this._container.mozRequestFullScreen ? this._container.mozRequestFullScreen() : this._container.msRequestFullscreen ? this._container.msRequestFullscreen() : this._container.webkitRequestFullscreen ? this._container.webkitRequestFullscreen() : this._togglePseudoFullScreen();
            }
            _togglePseudoFullScreen() {
                this._container.classList.toggle("maplibregl-pseudo-fullscreen"), this._handleFullscreenChange(), this._map.resize();
            }
        }, Ba.TerrainControl = class {
            constructor(t){
                this._toggleTerrain = ()=>{
                    this._map.getTerrain() ? this._map.setTerrain(null) : this._map.setTerrain(this.options), this._updateTerrainIcon();
                }, this._updateTerrainIcon = ()=>{
                    this._terrainButton.classList.remove("maplibregl-ctrl-terrain"), this._terrainButton.classList.remove("maplibregl-ctrl-terrain-enabled"), this._map.terrain ? (this._terrainButton.classList.add("maplibregl-ctrl-terrain-enabled"), this._terrainButton.title = this._map._getUIString("TerrainControl.disableTerrain")) : (this._terrainButton.classList.add("maplibregl-ctrl-terrain"), this._terrainButton.title = this._map._getUIString("TerrainControl.enableTerrain"));
                }, this.options = t;
            }
            onAdd(t) {
                return this._map = t, this._container = i.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._terrainButton = i.create("button", "maplibregl-ctrl-terrain", this._container), i.create("span", "maplibregl-ctrl-icon", this._terrainButton).setAttribute("aria-hidden", "true"), this._terrainButton.type = "button", this._terrainButton.addEventListener("click", this._toggleTerrain), this._updateTerrainIcon(), this._map.on("terrain", this._updateTerrainIcon), this._container;
            }
            onRemove() {
                i.remove(this._container), this._map.off("terrain", this._updateTerrainIcon), this._map = void 0;
            }
        }, Ba.Popup = class extends t.E {
            constructor(e){
                super(), this.remove = ()=>(this._content && i.remove(this._content), this._container && (i.remove(this._container), delete this._container), this._map && (this._map.off("move", this._update), this._map.off("move", this._onClose), this._map.off("click", this._onClose), this._map.off("remove", this.remove), this._map.off("mousemove", this._onMouseMove), this._map.off("mouseup", this._onMouseUp), this._map.off("drag", this._onDrag), delete this._map), this.fire(new t.k("close")), this), this._onMouseUp = (t)=>{
                    this._update(t.point);
                }, this._onMouseMove = (t)=>{
                    this._update(t.point);
                }, this._onDrag = (t)=>{
                    this._update(t.point);
                }, this._update = (t)=>{
                    if (!this._map || !this._lngLat && !this._trackPointer || !this._content) return;
                    if (!this._container) {
                        if (this._container = i.create("div", "maplibregl-popup", this._map.getContainer()), this._tip = i.create("div", "maplibregl-popup-tip", this._container), this._container.appendChild(this._content), this.options.className) for (const t of this.options.className.split(" "))this._container.classList.add(t);
                        this._trackPointer && this._container.classList.add("maplibregl-popup-track-pointer");
                    }
                    if (this.options.maxWidth && this._container.style.maxWidth !== this.options.maxWidth && (this._container.style.maxWidth = this.options.maxWidth), this._map.transform.renderWorldCopies && !this._trackPointer && (this._lngLat = wa(this._lngLat, this._pos, this._map.transform)), this._trackPointer && !t) return;
                    const e = this._pos = this._trackPointer && t ? t : this._map.project(this._lngLat);
                    let s = this.options.anchor;
                    const a = Ra(this.options.offset);
                    if (!s) {
                        const t = this._container.offsetWidth, i = this._container.offsetHeight;
                        let o;
                        o = e.y + a.bottom.y < i ? [
                            "top"
                        ] : e.y > this._map.transform.height - i ? [
                            "bottom"
                        ] : [], e.x < t / 2 ? o.push("left") : e.x > this._map.transform.width - t / 2 && o.push("right"), s = 0 === o.length ? "bottom" : o.join("-");
                    }
                    const o = e.add(a[s]).round();
                    i.setTransform(this._container, `${Ta[s]} translate(${o.x}px,${o.y}px)`), Ia(this._container, s, "popup");
                }, this._onClose = ()=>{
                    this.remove();
                }, this.options = t.e(Object.create(La), e);
            }
            addTo(e) {
                return this._map && this.remove(), this._map = e, this.options.closeOnClick && this._map.on("click", this._onClose), this.options.closeOnMove && this._map.on("move", this._onClose), this._map.on("remove", this.remove), this._update(), this._focusFirstElement(), this._trackPointer ? (this._map.on("mousemove", this._onMouseMove), this._map.on("mouseup", this._onMouseUp), this._container && this._container.classList.add("maplibregl-popup-track-pointer"), this._map._canvasContainer.classList.add("maplibregl-track-pointer")) : this._map.on("move", this._update), this.fire(new t.k("open")), this;
            }
            isOpen() {
                return !!this._map;
            }
            getLngLat() {
                return this._lngLat;
            }
            setLngLat(e) {
                return this._lngLat = t.L.convert(e), this._pos = null, this._trackPointer = !1, this._update(), this._map && (this._map.on("move", this._update), this._map.off("mousemove", this._onMouseMove), this._container && this._container.classList.remove("maplibregl-popup-track-pointer"), this._map._canvasContainer.classList.remove("maplibregl-track-pointer")), this;
            }
            trackPointer() {
                return this._trackPointer = !0, this._pos = null, this._update(), this._map && (this._map.off("move", this._update), this._map.on("mousemove", this._onMouseMove), this._map.on("drag", this._onDrag), this._container && this._container.classList.add("maplibregl-popup-track-pointer"), this._map._canvasContainer.classList.add("maplibregl-track-pointer")), this;
            }
            getElement() {
                return this._container;
            }
            setText(t) {
                return this.setDOMContent(document.createTextNode(t));
            }
            setHTML(t) {
                const e = document.createDocumentFragment(), i = document.createElement("body");
                let s;
                for(i.innerHTML = t; s = i.firstChild, s;)e.appendChild(s);
                return this.setDOMContent(e);
            }
            getMaxWidth() {
                var t;
                return null === (t = this._container) || void 0 === t ? void 0 : t.style.maxWidth;
            }
            setMaxWidth(t) {
                return this.options.maxWidth = t, this._update(), this;
            }
            setDOMContent(t) {
                if (this._content) for(; this._content.hasChildNodes();)this._content.firstChild && this._content.removeChild(this._content.firstChild);
                else this._content = i.create("div", "maplibregl-popup-content", this._container);
                return this._content.appendChild(t), this._createCloseButton(), this._update(), this._focusFirstElement(), this;
            }
            addClassName(t) {
                this._container && this._container.classList.add(t);
            }
            removeClassName(t) {
                this._container && this._container.classList.remove(t);
            }
            setOffset(t) {
                return this.options.offset = t, this._update(), this;
            }
            toggleClassName(t) {
                if (this._container) return this._container.classList.toggle(t);
            }
            _createCloseButton() {
                this.options.closeButton && (this._closeButton = i.create("button", "maplibregl-popup-close-button", this._content), this._closeButton.type = "button", this._closeButton.setAttribute("aria-label", "Close popup"), this._closeButton.innerHTML = "&#215;", this._closeButton.addEventListener("click", this._onClose));
            }
            _focusFirstElement() {
                if (!this.options.focusAfterOpen || !this._container) return;
                const t = this._container.querySelector(Aa);
                t && t.focus();
            }
        }, Ba.Marker = Ea, Ba.Style = se, Ba.LngLat = t.L, Ba.LngLatBounds = L, Ba.Point = t.P, Ba.MercatorCoordinate = t.U, Ba.Evented = t.E, Ba.AJAXError = t.bi, Ba.config = t.c, Ba.CanvasSource = Z, Ba.GeoJSONSource = B, Ba.ImageSource = N, Ba.RasterDEMTileSource = F, Ba.RasterTileSource = k, Ba.VectorTileSource = R, Ba.VideoSource = U, Ba.setRTLTextPlugin = t.bj, Ba.getRTLTextPluginStatus = t.bk, Ba.prewarm = function() {
            st().acquire(J);
        }, Ba.clearPrewarmedResources = function() {
            const t = it;
            t && (t.isPreloaded() && 1 === t.numActive() ? (t.release(J), it = null) : console.warn("Could not clear WebWorkers since there are active Map instances that still reference it. The pre-warmed WebWorker pool can only be cleared when all map instances have been removed with map.remove()"));
        }, ka.extend(Ba, {
            isSafari: t.ac,
            getPerformanceMetrics: t.bg.getPerformanceMetrics
        }), Ba;
    });
    //
    // Our custom intro provides a specialized "define()" function, called by the
    // AMD modules below, that sets up the worker blob URL and then executes the
    // main module, storing its exported value as 'maplibregl'
    var maplibregl$1 = maplibregl;
    return maplibregl$1;
});

});

var $ef524fb144c5d632$exports = {};
'use strict';

$ef524fb144c5d632$exports = (parcelRequire("cxvHN"));



var $8v0nu = parcelRequire("8v0nu");
var $70200245338e5781$exports = {};
'use strict';
function $70200245338e5781$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($70200245338e5781$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$70200245338e5781$var$checkDCE();

$70200245338e5781$exports = (parcelRequire("lyXGN"));


/**
 * React Router DOM v6.30.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $8v0nu = parcelRequire("8v0nu");

var $k2dbP = parcelRequire("k2dbP");
/**
 * @remix-run/router v1.23.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $318e60a76c97e9b3$var$_extends() {
    $318e60a76c97e9b3$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $318e60a76c97e9b3$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $318e60a76c97e9b3$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($318e60a76c97e9b3$export$e19cd5f9376f8cee || ($318e60a76c97e9b3$export$e19cd5f9376f8cee = {}));
const $318e60a76c97e9b3$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $318e60a76c97e9b3$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $318e60a76c97e9b3$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $318e60a76c97e9b3$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $318e60a76c97e9b3$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $318e60a76c97e9b3$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $318e60a76c97e9b3$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $318e60a76c97e9b3$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $318e60a76c97e9b3$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $318e60a76c97e9b3$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $318e60a76c97e9b3$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $318e60a76c97e9b3$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $318e60a76c97e9b3$export$fe53371bee54353d(to);
    }
    return $318e60a76c97e9b3$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $318e60a76c97e9b3$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $318e60a76c97e9b3$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $318e60a76c97e9b3$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $318e60a76c97e9b3$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $318e60a76c97e9b3$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $318e60a76c97e9b3$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $318e60a76c97e9b3$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $318e60a76c97e9b3$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $318e60a76c97e9b3$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $318e60a76c97e9b3$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $318e60a76c97e9b3$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $318e60a76c97e9b3$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $318e60a76c97e9b3$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $318e60a76c97e9b3$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $318e60a76c97e9b3$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $318e60a76c97e9b3$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $318e60a76c97e9b3$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $318e60a76c97e9b3$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($318e60a76c97e9b3$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $318e60a76c97e9b3$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $318e60a76c97e9b3$export$e19cd5f9376f8cee.Push;
        let location = $318e60a76c97e9b3$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $318e60a76c97e9b3$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $318e60a76c97e9b3$export$e19cd5f9376f8cee.Replace;
        let location = $318e60a76c97e9b3$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $318e60a76c97e9b3$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $318e60a76c97e9b3$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $318e60a76c97e9b3$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($318e60a76c97e9b3$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($318e60a76c97e9b3$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $318e60a76c97e9b3$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($318e60a76c97e9b3$var$ResultType || ($318e60a76c97e9b3$var$ResultType = {}));
const $318e60a76c97e9b3$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $318e60a76c97e9b3$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $318e60a76c97e9b3$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $318e60a76c97e9b3$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $318e60a76c97e9b3$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($318e60a76c97e9b3$var$isIndexRoute(route)) {
            let indexRoute = $318e60a76c97e9b3$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $318e60a76c97e9b3$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $318e60a76c97e9b3$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $318e60a76c97e9b3$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $318e60a76c97e9b3$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $318e60a76c97e9b3$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $318e60a76c97e9b3$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $318e60a76c97e9b3$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $318e60a76c97e9b3$var$flattenRoutes(routes);
    $318e60a76c97e9b3$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $318e60a76c97e9b3$export$30d21fd6d7295f52(pathname);
        matches = $318e60a76c97e9b3$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $318e60a76c97e9b3$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $318e60a76c97e9b3$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $318e60a76c97e9b3$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $318e60a76c97e9b3$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $318e60a76c97e9b3$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $318e60a76c97e9b3$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $318e60a76c97e9b3$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $318e60a76c97e9b3$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $318e60a76c97e9b3$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $318e60a76c97e9b3$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $318e60a76c97e9b3$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $318e60a76c97e9b3$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $318e60a76c97e9b3$var$paramRe = /^:[\w-]+$/;
const $318e60a76c97e9b3$var$dynamicSegmentValue = 3;
const $318e60a76c97e9b3$var$indexRouteValue = 2;
const $318e60a76c97e9b3$var$emptySegmentValue = 1;
const $318e60a76c97e9b3$var$staticSegmentValue = 10;
const $318e60a76c97e9b3$var$splatPenalty = -2;
const $318e60a76c97e9b3$var$isSplat = (s)=>s === "*";
function $318e60a76c97e9b3$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($318e60a76c97e9b3$var$isSplat)) initialScore += $318e60a76c97e9b3$var$splatPenalty;
    if (index) initialScore += $318e60a76c97e9b3$var$indexRouteValue;
    return segments.filter((s)=>!$318e60a76c97e9b3$var$isSplat(s)).reduce((score, segment)=>score + ($318e60a76c97e9b3$var$paramRe.test(segment) ? $318e60a76c97e9b3$var$dynamicSegmentValue : segment === "" ? $318e60a76c97e9b3$var$emptySegmentValue : $318e60a76c97e9b3$var$staticSegmentValue), initialScore);
}
function $318e60a76c97e9b3$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $318e60a76c97e9b3$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $318e60a76c97e9b3$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $318e60a76c97e9b3$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $318e60a76c97e9b3$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $318e60a76c97e9b3$export$a5c6d149b50c1d86($318e60a76c97e9b3$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $318e60a76c97e9b3$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $318e60a76c97e9b3$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $318e60a76c97e9b3$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $318e60a76c97e9b3$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $318e60a76c97e9b3$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $318e60a76c97e9b3$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $318e60a76c97e9b3$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $318e60a76c97e9b3$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $318e60a76c97e9b3$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $318e60a76c97e9b3$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $318e60a76c97e9b3$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
const $318e60a76c97e9b3$var$ABSOLUTE_URL_REGEX$1 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $318e60a76c97e9b3$var$isAbsoluteUrl = (url)=>$318e60a76c97e9b3$var$ABSOLUTE_URL_REGEX$1.test(url);
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $318e60a76c97e9b3$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $318e60a76c97e9b3$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        if ($318e60a76c97e9b3$var$isAbsoluteUrl(toPathname)) pathname = toPathname;
        else {
            if (toPathname.includes("//")) {
                let oldPathname = toPathname;
                toPathname = toPathname.replace(/\/\/+/g, "/");
                $318e60a76c97e9b3$export$c0e02632e14916fd(false, "Pathnames cannot have embedded double slashes - normalizing " + (oldPathname + " -> " + toPathname));
            }
            if (toPathname.startsWith("/")) pathname = $318e60a76c97e9b3$var$resolvePathname(toPathname.substring(1), "/");
            else pathname = $318e60a76c97e9b3$var$resolvePathname(toPathname, fromPathname);
        }
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $318e60a76c97e9b3$var$normalizeSearch(search),
        hash: $318e60a76c97e9b3$var$normalizeHash(hash)
    };
}
function $318e60a76c97e9b3$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $318e60a76c97e9b3$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $318e60a76c97e9b3$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $318e60a76c97e9b3$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $318e60a76c97e9b3$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $318e60a76c97e9b3$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $318e60a76c97e9b3$export$8ccf933b0513f8d0(toArg);
    else {
        to = $318e60a76c97e9b3$var$_extends({}, toArg);
        $318e60a76c97e9b3$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $318e60a76c97e9b3$var$getInvalidPathError("?", "pathname", "search", to));
        $318e60a76c97e9b3$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $318e60a76c97e9b3$var$getInvalidPathError("#", "pathname", "hash", to));
        $318e60a76c97e9b3$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $318e60a76c97e9b3$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $318e60a76c97e9b3$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $318e60a76c97e9b3$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $318e60a76c97e9b3$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $318e60a76c97e9b3$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $318e60a76c97e9b3$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $318e60a76c97e9b3$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $318e60a76c97e9b3$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $318e60a76c97e9b3$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $318e60a76c97e9b3$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $318e60a76c97e9b3$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $318e60a76c97e9b3$export$4051a07651545597(data, init) {
    return new $318e60a76c97e9b3$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $318e60a76c97e9b3$export$42a99a7a4bc0e76a extends Error {
}
class $318e60a76c97e9b3$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $318e60a76c97e9b3$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $318e60a76c97e9b3$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $318e60a76c97e9b3$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $318e60a76c97e9b3$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $318e60a76c97e9b3$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $318e60a76c97e9b3$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $318e60a76c97e9b3$var$unwrapTrackedPromise(value) {
    if (!$318e60a76c97e9b3$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $318e60a76c97e9b3$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $318e60a76c97e9b3$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $318e60a76c97e9b3$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $318e60a76c97e9b3$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $318e60a76c97e9b3$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $318e60a76c97e9b3$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $318e60a76c97e9b3$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $318e60a76c97e9b3$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $318e60a76c97e9b3$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $318e60a76c97e9b3$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $318e60a76c97e9b3$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $318e60a76c97e9b3$var$validMutationMethods = new Set($318e60a76c97e9b3$var$validMutationMethodsArr);
const $318e60a76c97e9b3$var$validRequestMethodsArr = [
    "get",
    ...$318e60a76c97e9b3$var$validMutationMethodsArr
];
const $318e60a76c97e9b3$var$validRequestMethods = new Set($318e60a76c97e9b3$var$validRequestMethodsArr);
const $318e60a76c97e9b3$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $318e60a76c97e9b3$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $318e60a76c97e9b3$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $318e60a76c97e9b3$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $318e60a76c97e9b3$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $318e60a76c97e9b3$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $318e60a76c97e9b3$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $318e60a76c97e9b3$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $318e60a76c97e9b3$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $318e60a76c97e9b3$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $318e60a76c97e9b3$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $318e60a76c97e9b3$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $318e60a76c97e9b3$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $318e60a76c97e9b3$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $318e60a76c97e9b3$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $318e60a76c97e9b3$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $318e60a76c97e9b3$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$318e60a76c97e9b3$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$318e60a76c97e9b3$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $318e60a76c97e9b3$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $318e60a76c97e9b3$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $318e60a76c97e9b3$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $318e60a76c97e9b3$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $318e60a76c97e9b3$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$318e60a76c97e9b3$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($318e60a76c97e9b3$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $318e60a76c97e9b3$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $318e60a76c97e9b3$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $318e60a76c97e9b3$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $318e60a76c97e9b3$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $318e60a76c97e9b3$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $318e60a76c97e9b3$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $318e60a76c97e9b3$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $318e60a76c97e9b3$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $318e60a76c97e9b3$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($318e60a76c97e9b3$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $318e60a76c97e9b3$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $318e60a76c97e9b3$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $318e60a76c97e9b3$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $318e60a76c97e9b3$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $318e60a76c97e9b3$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $318e60a76c97e9b3$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $318e60a76c97e9b3$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $318e60a76c97e9b3$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $318e60a76c97e9b3$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $318e60a76c97e9b3$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $318e60a76c97e9b3$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $318e60a76c97e9b3$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $318e60a76c97e9b3$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $318e60a76c97e9b3$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $318e60a76c97e9b3$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $318e60a76c97e9b3$var$findNearestBoundary(matches).route.id,
            {
                type: $318e60a76c97e9b3$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $318e60a76c97e9b3$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($318e60a76c97e9b3$var$isErrorResult(result) && $318e60a76c97e9b3$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $318e60a76c97e9b3$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $318e60a76c97e9b3$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $318e60a76c97e9b3$var$_extends({
            matches: updatedMatches || matches
        }, $318e60a76c97e9b3$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $318e60a76c97e9b3$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $318e60a76c97e9b3$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $318e60a76c97e9b3$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $318e60a76c97e9b3$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $318e60a76c97e9b3$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $318e60a76c97e9b3$var$ResultType.error,
            error: $318e60a76c97e9b3$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($318e60a76c97e9b3$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $318e60a76c97e9b3$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($318e60a76c97e9b3$var$isDeferredResult(result)) throw $318e60a76c97e9b3$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($318e60a76c97e9b3$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $318e60a76c97e9b3$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $318e60a76c97e9b3$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $318e60a76c97e9b3$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $318e60a76c97e9b3$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($318e60a76c97e9b3$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $318e60a76c97e9b3$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $318e60a76c97e9b3$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $318e60a76c97e9b3$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $318e60a76c97e9b3$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $318e60a76c97e9b3$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $318e60a76c97e9b3$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $318e60a76c97e9b3$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $318e60a76c97e9b3$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $318e60a76c97e9b3$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $318e60a76c97e9b3$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$318e60a76c97e9b3$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $318e60a76c97e9b3$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $318e60a76c97e9b3$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $318e60a76c97e9b3$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $318e60a76c97e9b3$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $318e60a76c97e9b3$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $318e60a76c97e9b3$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $318e60a76c97e9b3$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $318e60a76c97e9b3$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $318e60a76c97e9b3$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $318e60a76c97e9b3$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $318e60a76c97e9b3$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $318e60a76c97e9b3$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($318e60a76c97e9b3$var$isRedirectResult(actionResult) || $318e60a76c97e9b3$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $318e60a76c97e9b3$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($318e60a76c97e9b3$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $318e60a76c97e9b3$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $318e60a76c97e9b3$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($318e60a76c97e9b3$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($318e60a76c97e9b3$var$isDeferredResult(actionResult)) throw $318e60a76c97e9b3$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $318e60a76c97e9b3$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $318e60a76c97e9b3$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $318e60a76c97e9b3$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $318e60a76c97e9b3$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $318e60a76c97e9b3$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $318e60a76c97e9b3$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $318e60a76c97e9b3$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $318e60a76c97e9b3$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $318e60a76c97e9b3$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $318e60a76c97e9b3$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $318e60a76c97e9b3$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $318e60a76c97e9b3$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $318e60a76c97e9b3$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $318e60a76c97e9b3$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $318e60a76c97e9b3$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $318e60a76c97e9b3$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($318e60a76c97e9b3$var$isDeferredResult(result)) result = await $318e60a76c97e9b3$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $318e60a76c97e9b3$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($318e60a76c97e9b3$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $318e60a76c97e9b3$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($318e60a76c97e9b3$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $318e60a76c97e9b3$export$3e9cee6b33872309(!$318e60a76c97e9b3$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $318e60a76c97e9b3$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $318e60a76c97e9b3$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $318e60a76c97e9b3$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $318e60a76c97e9b3$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($318e60a76c97e9b3$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $318e60a76c97e9b3$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $318e60a76c97e9b3$export$e19cd5f9376f8cee.Replace : $318e60a76c97e9b3$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $318e60a76c97e9b3$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($318e60a76c97e9b3$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $318e60a76c97e9b3$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $318e60a76c97e9b3$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $318e60a76c97e9b3$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $318e60a76c97e9b3$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $318e60a76c97e9b3$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($318e60a76c97e9b3$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $318e60a76c97e9b3$var$ResultType.redirect,
                response: $318e60a76c97e9b3$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $318e60a76c97e9b3$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $318e60a76c97e9b3$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $318e60a76c97e9b3$var$ResultType.error,
                    error: $318e60a76c97e9b3$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $318e60a76c97e9b3$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $318e60a76c97e9b3$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $318e60a76c97e9b3$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $318e60a76c97e9b3$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $318e60a76c97e9b3$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $318e60a76c97e9b3$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $318e60a76c97e9b3$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $318e60a76c97e9b3$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $318e60a76c97e9b3$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $318e60a76c97e9b3$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $318e60a76c97e9b3$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $318e60a76c97e9b3$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $318e60a76c97e9b3$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $318e60a76c97e9b3$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$318e60a76c97e9b3$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $318e60a76c97e9b3$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $318e60a76c97e9b3$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $318e60a76c97e9b3$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $318e60a76c97e9b3$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $318e60a76c97e9b3$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $318e60a76c97e9b3$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $318e60a76c97e9b3$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $318e60a76c97e9b3$export$4d0306f8f6a4585b = Symbol("deferred");
function $318e60a76c97e9b3$export$3336b097a6fbc59a(routes, opts) {
    $318e60a76c97e9b3$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $318e60a76c97e9b3$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $318e60a76c97e9b3$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $318e60a76c97e9b3$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $318e60a76c97e9b3$var$createLocation("", $318e60a76c97e9b3$export$fe53371bee54353d(url), null, "default");
        let matches = $318e60a76c97e9b3$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$318e60a76c97e9b3$var$isValidMethod(method) && method !== "HEAD") {
            let error = $318e60a76c97e9b3$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $318e60a76c97e9b3$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $318e60a76c97e9b3$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $318e60a76c97e9b3$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($318e60a76c97e9b3$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $318e60a76c97e9b3$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $318e60a76c97e9b3$var$createLocation("", $318e60a76c97e9b3$export$fe53371bee54353d(url), null, "default");
        let matches = $318e60a76c97e9b3$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$318e60a76c97e9b3$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $318e60a76c97e9b3$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $318e60a76c97e9b3$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $318e60a76c97e9b3$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $318e60a76c97e9b3$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $318e60a76c97e9b3$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($318e60a76c97e9b3$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$318e60a76c97e9b3$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $318e60a76c97e9b3$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($318e60a76c97e9b3$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $318e60a76c97e9b3$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $318e60a76c97e9b3$var$isResponse(result) ? result : $318e60a76c97e9b3$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($318e60a76c97e9b3$var$isDataStrategyResult(e) && $318e60a76c97e9b3$var$isResponse(e.result)) {
                if (e.type === $318e60a76c97e9b3$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($318e60a76c97e9b3$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $318e60a76c97e9b3$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $318e60a76c97e9b3$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $318e60a76c97e9b3$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($318e60a76c97e9b3$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($318e60a76c97e9b3$var$isDeferredResult(result)) {
            let error = $318e60a76c97e9b3$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $318e60a76c97e9b3$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($318e60a76c97e9b3$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($318e60a76c97e9b3$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $318e60a76c97e9b3$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $318e60a76c97e9b3$var$_extends({}, context, {
                statusCode: $318e60a76c97e9b3$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $318e60a76c97e9b3$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $318e60a76c97e9b3$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $318e60a76c97e9b3$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $318e60a76c97e9b3$var$isErrorResult(pendingActionResult[1]) ? $318e60a76c97e9b3$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $318e60a76c97e9b3$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $318e60a76c97e9b3$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $318e60a76c97e9b3$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $318e60a76c97e9b3$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $318e60a76c97e9b3$var$callDataStrategyImpl(dataStrategy || $318e60a76c97e9b3$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($318e60a76c97e9b3$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $318e60a76c97e9b3$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($318e60a76c97e9b3$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $318e60a76c97e9b3$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $318e60a76c97e9b3$export$fec11da027c70692(routes, context, error) {
    let newContext = $318e60a76c97e9b3$var$_extends({}, context, {
        statusCode: $318e60a76c97e9b3$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $318e60a76c97e9b3$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $318e60a76c97e9b3$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $318e60a76c97e9b3$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $318e60a76c97e9b3$export$cae722b0cc860f13(to ? to : ".", $318e60a76c97e9b3$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $318e60a76c97e9b3$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $318e60a76c97e9b3$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $318e60a76c97e9b3$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $318e60a76c97e9b3$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $318e60a76c97e9b3$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$318e60a76c97e9b3$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$318e60a76c97e9b3$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $318e60a76c97e9b3$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $318e60a76c97e9b3$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $318e60a76c97e9b3$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$318e60a76c97e9b3$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$318e60a76c97e9b3$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $318e60a76c97e9b3$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $318e60a76c97e9b3$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $318e60a76c97e9b3$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $318e60a76c97e9b3$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $318e60a76c97e9b3$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($318e60a76c97e9b3$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $318e60a76c97e9b3$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $318e60a76c97e9b3$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $318e60a76c97e9b3$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $318e60a76c97e9b3$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $318e60a76c97e9b3$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $318e60a76c97e9b3$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $318e60a76c97e9b3$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $318e60a76c97e9b3$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $318e60a76c97e9b3$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $318e60a76c97e9b3$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($318e60a76c97e9b3$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $318e60a76c97e9b3$var$shouldRevalidateLoader(match, $318e60a76c97e9b3$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $318e60a76c97e9b3$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $318e60a76c97e9b3$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $318e60a76c97e9b3$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $318e60a76c97e9b3$var$shouldRevalidateLoader(fetcherMatch, $318e60a76c97e9b3$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $318e60a76c97e9b3$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $318e60a76c97e9b3$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $318e60a76c97e9b3$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $318e60a76c97e9b3$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $318e60a76c97e9b3$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $318e60a76c97e9b3$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$318e60a76c97e9b3$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $318e60a76c97e9b3$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $318e60a76c97e9b3$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$318e60a76c97e9b3$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $318e60a76c97e9b3$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $318e60a76c97e9b3$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $318e60a76c97e9b3$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$318e60a76c97e9b3$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $318e60a76c97e9b3$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $318e60a76c97e9b3$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $318e60a76c97e9b3$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $318e60a76c97e9b3$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $318e60a76c97e9b3$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $318e60a76c97e9b3$var$ResultType.data,
                result: undefined
            });
        };
        return $318e60a76c97e9b3$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $318e60a76c97e9b3$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $318e60a76c97e9b3$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $318e60a76c97e9b3$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $318e60a76c97e9b3$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $318e60a76c97e9b3$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $318e60a76c97e9b3$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $318e60a76c97e9b3$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($318e60a76c97e9b3$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $318e60a76c97e9b3$var$ResultType.error,
                error: e
            };
        }
        if (type === $318e60a76c97e9b3$var$ResultType.error) return {
            type: $318e60a76c97e9b3$var$ResultType.error,
            error: new $318e60a76c97e9b3$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $318e60a76c97e9b3$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $318e60a76c97e9b3$var$ResultType.error) {
        if ($318e60a76c97e9b3$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $318e60a76c97e9b3$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $318e60a76c97e9b3$var$ResultType.error,
                error: new $318e60a76c97e9b3$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $318e60a76c97e9b3$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $318e60a76c97e9b3$var$ResultType.error,
            error: result,
            statusCode: $318e60a76c97e9b3$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($318e60a76c97e9b3$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $318e60a76c97e9b3$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($318e60a76c97e9b3$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $318e60a76c97e9b3$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $318e60a76c97e9b3$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $318e60a76c97e9b3$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $318e60a76c97e9b3$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$318e60a76c97e9b3$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $318e60a76c97e9b3$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $318e60a76c97e9b3$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    // Match Chrome's behavior:
    // https://github.com/chromium/chromium/blob/216dbeb61db0c667e62082e5f5400a32d6983df3/content/public/common/url_utils.cc#L82
    let invalidProtocols = [
        "about:",
        "blob:",
        "chrome:",
        "chrome-untrusted:",
        "content:",
        "data:",
        "devtools:",
        "file:",
        "filesystem:",
        // eslint-disable-next-line no-script-url
        "javascript:"
    ];
    if ($318e60a76c97e9b3$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $318e60a76c97e9b3$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $318e60a76c97e9b3$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($318e60a76c97e9b3$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $318e60a76c97e9b3$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $318e60a76c97e9b3$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $318e60a76c97e9b3$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $318e60a76c97e9b3$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $318e60a76c97e9b3$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $318e60a76c97e9b3$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $318e60a76c97e9b3$export$3e9cee6b33872309(!$318e60a76c97e9b3$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($318e60a76c97e9b3$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $318e60a76c97e9b3$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $318e60a76c97e9b3$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($318e60a76c97e9b3$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $318e60a76c97e9b3$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $318e60a76c97e9b3$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $318e60a76c97e9b3$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($318e60a76c97e9b3$var$isErrorResult(result)) {
            let boundaryMatch = $318e60a76c97e9b3$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $318e60a76c97e9b3$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($318e60a76c97e9b3$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $318e60a76c97e9b3$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($318e60a76c97e9b3$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $318e60a76c97e9b3$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $318e60a76c97e9b3$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $318e60a76c97e9b3$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $318e60a76c97e9b3$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $318e60a76c97e9b3$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $318e60a76c97e9b3$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $318e60a76c97e9b3$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $318e60a76c97e9b3$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $318e60a76c97e9b3$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $318e60a76c97e9b3$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $318e60a76c97e9b3$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($318e60a76c97e9b3$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $318e60a76c97e9b3$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $318e60a76c97e9b3$export$8ccf933b0513f8d0(path) : path;
    return $318e60a76c97e9b3$export$fe53371bee54353d($318e60a76c97e9b3$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $318e60a76c97e9b3$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $318e60a76c97e9b3$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $318e60a76c97e9b3$var$ResultType.data || result.type === $318e60a76c97e9b3$var$ResultType.error);
}
function $318e60a76c97e9b3$var$isRedirectDataStrategyResultResult(result) {
    return $318e60a76c97e9b3$var$isResponse(result.result) && $318e60a76c97e9b3$var$redirectStatusCodes.has(result.result.status);
}
function $318e60a76c97e9b3$var$isDeferredResult(result) {
    return result.type === $318e60a76c97e9b3$var$ResultType.deferred;
}
function $318e60a76c97e9b3$var$isErrorResult(result) {
    return result.type === $318e60a76c97e9b3$var$ResultType.error;
}
function $318e60a76c97e9b3$var$isRedirectResult(result) {
    return (result && result.type) === $318e60a76c97e9b3$var$ResultType.redirect;
}
function $318e60a76c97e9b3$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $318e60a76c97e9b3$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $318e60a76c97e9b3$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $318e60a76c97e9b3$var$isRedirectResponse(result) {
    if (!$318e60a76c97e9b3$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $318e60a76c97e9b3$var$isValidMethod(method) {
    return $318e60a76c97e9b3$var$validRequestMethods.has(method.toLowerCase());
}
function $318e60a76c97e9b3$var$isMutationMethod(method) {
    return $318e60a76c97e9b3$var$validMutationMethods.has(method.toLowerCase());
}
async function $318e60a76c97e9b3$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$318e60a76c97e9b3$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($318e60a76c97e9b3$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $318e60a76c97e9b3$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $318e60a76c97e9b3$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($318e60a76c97e9b3$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $318e60a76c97e9b3$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $318e60a76c97e9b3$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $318e60a76c97e9b3$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $318e60a76c97e9b3$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $318e60a76c97e9b3$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $318e60a76c97e9b3$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $318e60a76c97e9b3$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $318e60a76c97e9b3$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $318e60a76c97e9b3$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $318e60a76c97e9b3$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $318e60a76c97e9b3$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $318e60a76c97e9b3$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $318e60a76c97e9b3$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $318e60a76c97e9b3$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $318e60a76c97e9b3$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $318e60a76c97e9b3$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $318e60a76c97e9b3$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $318e60a76c97e9b3$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($318e60a76c97e9b3$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $318e60a76c97e9b3$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($318e60a76c97e9b3$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $318e60a76c97e9b3$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.30.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $8v0nu = parcelRequire("8v0nu");

function $aa6b6e9e15323f83$var$_extends() {
    $aa6b6e9e15323f83$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $aa6b6e9e15323f83$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $aa6b6e9e15323f83$export$3add0d5dce533e2e = /*#__PURE__*/ $8v0nu.createContext(null);
const $aa6b6e9e15323f83$export$145dfa71566a64dc = /*#__PURE__*/ $8v0nu.createContext(null);
const $aa6b6e9e15323f83$var$AwaitContext = /*#__PURE__*/ $8v0nu.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $aa6b6e9e15323f83$export$26749e8557646306 = /*#__PURE__*/ $8v0nu.createContext(null);
const $aa6b6e9e15323f83$export$c7914228fb69b0f5 = /*#__PURE__*/ $8v0nu.createContext(null);
const $aa6b6e9e15323f83$export$9072aa6dd1f93057 = /*#__PURE__*/ $8v0nu.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $aa6b6e9e15323f83$var$RouteErrorContext = /*#__PURE__*/ $8v0nu.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $aa6b6e9e15323f83$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$aa6b6e9e15323f83$export$9c954a9d03d32f4a() && (0, $318e60a76c97e9b3$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $8v0nu.useContext($aa6b6e9e15323f83$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $aa6b6e9e15323f83$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $318e60a76c97e9b3$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $aa6b6e9e15323f83$export$9c954a9d03d32f4a() {
    return $8v0nu.useContext($aa6b6e9e15323f83$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $aa6b6e9e15323f83$export$45d76561a5302f2b() {
    !$aa6b6e9e15323f83$export$9c954a9d03d32f4a() && (0, $318e60a76c97e9b3$export$3e9cee6b33872309)(false);
    return $8v0nu.useContext($aa6b6e9e15323f83$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $aa6b6e9e15323f83$export$1b3f31771c5d07c() {
    return $8v0nu.useContext($aa6b6e9e15323f83$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $aa6b6e9e15323f83$export$6c330e8992e8a295(pattern) {
    !$aa6b6e9e15323f83$export$9c954a9d03d32f4a() && (0, $318e60a76c97e9b3$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $aa6b6e9e15323f83$export$45d76561a5302f2b();
    return $8v0nu.useMemo(()=>(0, $318e60a76c97e9b3$export$81336c211d5ff295)(pattern, (0, $318e60a76c97e9b3$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $aa6b6e9e15323f83$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $aa6b6e9e15323f83$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $8v0nu.useContext($aa6b6e9e15323f83$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $8v0nu.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $aa6b6e9e15323f83$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $8v0nu.useContext($aa6b6e9e15323f83$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $aa6b6e9e15323f83$var$useNavigateStable() : $aa6b6e9e15323f83$var$useNavigateUnstable();
}
function $aa6b6e9e15323f83$var$useNavigateUnstable() {
    !$aa6b6e9e15323f83$export$9c954a9d03d32f4a() && (0, $318e60a76c97e9b3$export$3e9cee6b33872309)(false);
    let dataRouterContext = $8v0nu.useContext($aa6b6e9e15323f83$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $8v0nu.useContext($aa6b6e9e15323f83$export$26749e8557646306);
    let { matches: matches } = $8v0nu.useContext($aa6b6e9e15323f83$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $aa6b6e9e15323f83$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $318e60a76c97e9b3$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $8v0nu.useRef(false);
    $aa6b6e9e15323f83$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $8v0nu.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $318e60a76c97e9b3$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $318e60a76c97e9b3$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $aa6b6e9e15323f83$var$OutletContext = /*#__PURE__*/ $8v0nu.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $aa6b6e9e15323f83$export$4138103a3ae699cc() {
    return $8v0nu.useContext($aa6b6e9e15323f83$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $aa6b6e9e15323f83$export$a3be3530d8e40d0b(context) {
    let outlet = $8v0nu.useContext($aa6b6e9e15323f83$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $8v0nu.createElement($aa6b6e9e15323f83$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $aa6b6e9e15323f83$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $8v0nu.useContext($aa6b6e9e15323f83$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $aa6b6e9e15323f83$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $8v0nu.useContext($aa6b6e9e15323f83$export$26749e8557646306);
    let { matches: matches } = $8v0nu.useContext($aa6b6e9e15323f83$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $aa6b6e9e15323f83$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $318e60a76c97e9b3$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $8v0nu.useMemo(()=>(0, $318e60a76c97e9b3$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $aa6b6e9e15323f83$export$5d3fca4a98652595(routes, locationArg) {
    return $aa6b6e9e15323f83$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $aa6b6e9e15323f83$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$aa6b6e9e15323f83$export$9c954a9d03d32f4a() && (0, $318e60a76c97e9b3$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $8v0nu.useContext($aa6b6e9e15323f83$export$26749e8557646306);
    let { matches: parentMatches } = $8v0nu.useContext($aa6b6e9e15323f83$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $aa6b6e9e15323f83$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $318e60a76c97e9b3$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $318e60a76c97e9b3$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $318e60a76c97e9b3$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $aa6b6e9e15323f83$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $318e60a76c97e9b3$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $318e60a76c97e9b3$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $8v0nu.createElement($aa6b6e9e15323f83$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $aa6b6e9e15323f83$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $318e60a76c97e9b3$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $aa6b6e9e15323f83$var$DefaultErrorComponent() {
    let error = $aa6b6e9e15323f83$export$ed527bf60f6e05f2();
    let message = (0, $318e60a76c97e9b3$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $8v0nu.createElement($8v0nu.Fragment, null, /*#__PURE__*/ $8v0nu.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $8v0nu.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $8v0nu.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $aa6b6e9e15323f83$var$defaultErrorElement = /*#__PURE__*/ $8v0nu.createElement($aa6b6e9e15323f83$var$DefaultErrorComponent, null);
class $aa6b6e9e15323f83$var$RenderErrorBoundary extends $8v0nu.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $8v0nu.createElement($aa6b6e9e15323f83$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $8v0nu.createElement($aa6b6e9e15323f83$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $aa6b6e9e15323f83$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $8v0nu.useContext($aa6b6e9e15323f83$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $8v0nu.createElement($aa6b6e9e15323f83$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $aa6b6e9e15323f83$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $318e60a76c97e9b3$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $aa6b6e9e15323f83$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $aa6b6e9e15323f83$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $8v0nu.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $8v0nu.createElement($aa6b6e9e15323f83$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $8v0nu.createElement($aa6b6e9e15323f83$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $aa6b6e9e15323f83$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($aa6b6e9e15323f83$var$DataRouterHook || {});
var $aa6b6e9e15323f83$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($aa6b6e9e15323f83$var$DataRouterStateHook || {});
function $aa6b6e9e15323f83$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $aa6b6e9e15323f83$var$useDataRouterContext(hookName) {
    let ctx = $8v0nu.useContext($aa6b6e9e15323f83$export$3add0d5dce533e2e);
    !ctx && (0, $318e60a76c97e9b3$export$3e9cee6b33872309)(false);
    return ctx;
}
function $aa6b6e9e15323f83$var$useDataRouterState(hookName) {
    let state = $8v0nu.useContext($aa6b6e9e15323f83$export$145dfa71566a64dc);
    !state && (0, $318e60a76c97e9b3$export$3e9cee6b33872309)(false);
    return state;
}
function $aa6b6e9e15323f83$var$useRouteContext(hookName) {
    let route = $8v0nu.useContext($aa6b6e9e15323f83$export$9072aa6dd1f93057);
    !route && (0, $318e60a76c97e9b3$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $aa6b6e9e15323f83$var$useCurrentRouteId(hookName) {
    let route = $aa6b6e9e15323f83$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $318e60a76c97e9b3$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $aa6b6e9e15323f83$export$5fc8298006ad9e58() {
    return $aa6b6e9e15323f83$var$useCurrentRouteId($aa6b6e9e15323f83$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $aa6b6e9e15323f83$export$d0fd4b7106de2769() {
    let state = $aa6b6e9e15323f83$var$useDataRouterState($aa6b6e9e15323f83$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $aa6b6e9e15323f83$export$600dc272ed516c15() {
    let dataRouterContext = $aa6b6e9e15323f83$var$useDataRouterContext($aa6b6e9e15323f83$var$DataRouterHook.UseRevalidator);
    let state = $aa6b6e9e15323f83$var$useDataRouterState($aa6b6e9e15323f83$var$DataRouterStateHook.UseRevalidator);
    return $8v0nu.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $aa6b6e9e15323f83$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $aa6b6e9e15323f83$var$useDataRouterState($aa6b6e9e15323f83$var$DataRouterStateHook.UseMatches);
    return $8v0nu.useMemo(()=>matches.map((m)=>(0, $318e60a76c97e9b3$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $aa6b6e9e15323f83$export$1448a5050d252c4d() {
    let state = $aa6b6e9e15323f83$var$useDataRouterState($aa6b6e9e15323f83$var$DataRouterStateHook.UseLoaderData);
    let routeId = $aa6b6e9e15323f83$var$useCurrentRouteId($aa6b6e9e15323f83$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $aa6b6e9e15323f83$export$fd5d37484eab868d(routeId) {
    let state = $aa6b6e9e15323f83$var$useDataRouterState($aa6b6e9e15323f83$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $aa6b6e9e15323f83$export$fdc00f3f26066d5e() {
    let state = $aa6b6e9e15323f83$var$useDataRouterState($aa6b6e9e15323f83$var$DataRouterStateHook.UseActionData);
    let routeId = $aa6b6e9e15323f83$var$useCurrentRouteId($aa6b6e9e15323f83$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $aa6b6e9e15323f83$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $8v0nu.useContext($aa6b6e9e15323f83$var$RouteErrorContext);
    let state = $aa6b6e9e15323f83$var$useDataRouterState($aa6b6e9e15323f83$var$DataRouterStateHook.UseRouteError);
    let routeId = $aa6b6e9e15323f83$var$useCurrentRouteId($aa6b6e9e15323f83$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $aa6b6e9e15323f83$export$78a72ddb39bdd145() {
    let value = $8v0nu.useContext($aa6b6e9e15323f83$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $aa6b6e9e15323f83$export$17f53340677d5831() {
    let value = $8v0nu.useContext($aa6b6e9e15323f83$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $aa6b6e9e15323f83$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $aa6b6e9e15323f83$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $aa6b6e9e15323f83$var$useDataRouterContext($aa6b6e9e15323f83$var$DataRouterHook.UseBlocker);
    let state = $aa6b6e9e15323f83$var$useDataRouterState($aa6b6e9e15323f83$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $8v0nu.useState("");
    let blockerFunction = $8v0nu.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $aa6b6e9e15323f83$var$_extends({}, currentLocation, {
                pathname: (0, $318e60a76c97e9b3$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $aa6b6e9e15323f83$var$_extends({}, nextLocation, {
                pathname: (0, $318e60a76c97e9b3$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $8v0nu.useEffect(()=>{
        let key = String(++$aa6b6e9e15323f83$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $8v0nu.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $318e60a76c97e9b3$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $aa6b6e9e15323f83$var$useNavigateStable() {
    let { router: router } = $aa6b6e9e15323f83$var$useDataRouterContext($aa6b6e9e15323f83$var$DataRouterHook.UseNavigateStable);
    let id = $aa6b6e9e15323f83$var$useCurrentRouteId($aa6b6e9e15323f83$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $8v0nu.useRef(false);
    $aa6b6e9e15323f83$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $8v0nu.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $aa6b6e9e15323f83$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $aa6b6e9e15323f83$var$alreadyWarned$1 = {};
function $aa6b6e9e15323f83$var$warningOnce(key, cond, message) {
    if (!cond && !$aa6b6e9e15323f83$var$alreadyWarned$1[key]) $aa6b6e9e15323f83$var$alreadyWarned$1[key] = true;
}
const $aa6b6e9e15323f83$var$alreadyWarned = {};
function $aa6b6e9e15323f83$var$warnOnce(key, message) {}
const $aa6b6e9e15323f83$var$logDeprecation = (flag, msg, link)=>$aa6b6e9e15323f83$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $aa6b6e9e15323f83$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $aa6b6e9e15323f83$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $aa6b6e9e15323f83$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $aa6b6e9e15323f83$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $aa6b6e9e15323f83$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $aa6b6e9e15323f83$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $aa6b6e9e15323f83$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $aa6b6e9e15323f83$var$START_TRANSITION = "startTransition";
const $aa6b6e9e15323f83$var$startTransitionImpl = $8v0nu[$aa6b6e9e15323f83$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $aa6b6e9e15323f83$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $8v0nu.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8v0nu.useCallback((newState)=>{
        if (v7_startTransition && $aa6b6e9e15323f83$var$startTransitionImpl) $aa6b6e9e15323f83$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $8v0nu.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $8v0nu.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $8v0nu.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $8v0nu.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $8v0nu.useEffect(()=>$aa6b6e9e15323f83$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $8v0nu.createElement($8v0nu.Fragment, null, /*#__PURE__*/ $8v0nu.createElement($aa6b6e9e15323f83$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $8v0nu.createElement($aa6b6e9e15323f83$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $8v0nu.createElement($aa6b6e9e15323f83$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $8v0nu.createElement($aa6b6e9e15323f83$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $aa6b6e9e15323f83$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $aa6b6e9e15323f83$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $aa6b6e9e15323f83$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $8v0nu.useRef();
    if (historyRef.current == null) historyRef.current = (0, $318e60a76c97e9b3$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $8v0nu.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8v0nu.useCallback((newState)=>{
        v7_startTransition && $aa6b6e9e15323f83$var$startTransitionImpl ? $aa6b6e9e15323f83$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8v0nu.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $8v0nu.useEffect(()=>$aa6b6e9e15323f83$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $8v0nu.createElement($aa6b6e9e15323f83$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $aa6b6e9e15323f83$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$aa6b6e9e15323f83$export$9c954a9d03d32f4a() && (0, $318e60a76c97e9b3$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $8v0nu.useContext($aa6b6e9e15323f83$export$26749e8557646306);
    let { matches: matches } = $8v0nu.useContext($aa6b6e9e15323f83$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $aa6b6e9e15323f83$export$45d76561a5302f2b();
    let navigate = $aa6b6e9e15323f83$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $318e60a76c97e9b3$export$cae722b0cc860f13)(to, (0, $318e60a76c97e9b3$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $8v0nu.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $aa6b6e9e15323f83$export$910ae8079b2c2852(props) {
    return $aa6b6e9e15323f83$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $aa6b6e9e15323f83$export$e7b0ac011bb776c6(_props) {
    (0, $318e60a76c97e9b3$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $aa6b6e9e15323f83$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $318e60a76c97e9b3$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$aa6b6e9e15323f83$export$9c954a9d03d32f4a() && (0, $318e60a76c97e9b3$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $8v0nu.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $aa6b6e9e15323f83$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $318e60a76c97e9b3$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $8v0nu.useMemo(()=>{
        let trailingPathname = (0, $318e60a76c97e9b3$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $8v0nu.createElement($aa6b6e9e15323f83$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $8v0nu.createElement($aa6b6e9e15323f83$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $aa6b6e9e15323f83$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $aa6b6e9e15323f83$export$5d3fca4a98652595($aa6b6e9e15323f83$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $aa6b6e9e15323f83$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $8v0nu.createElement($aa6b6e9e15323f83$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $8v0nu.createElement($aa6b6e9e15323f83$var$ResolveAwait, null, children));
}
var $aa6b6e9e15323f83$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($aa6b6e9e15323f83$var$AwaitRenderStatus || {});
const $aa6b6e9e15323f83$var$neverSettledPromise = new Promise(()=>{});
class $aa6b6e9e15323f83$var$AwaitErrorBoundary extends $8v0nu.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $aa6b6e9e15323f83$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $aa6b6e9e15323f83$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $aa6b6e9e15323f83$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $aa6b6e9e15323f83$var$AwaitRenderStatus.error : "_data" in promise ? $aa6b6e9e15323f83$var$AwaitRenderStatus.success : $aa6b6e9e15323f83$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $aa6b6e9e15323f83$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $aa6b6e9e15323f83$var$AwaitRenderStatus.error && promise._error instanceof (0, $318e60a76c97e9b3$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $aa6b6e9e15323f83$var$neverSettledPromise;
        if (status === $aa6b6e9e15323f83$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $aa6b6e9e15323f83$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $8v0nu.createElement($aa6b6e9e15323f83$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $aa6b6e9e15323f83$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $8v0nu.createElement($aa6b6e9e15323f83$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $aa6b6e9e15323f83$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $aa6b6e9e15323f83$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $8v0nu.createElement($8v0nu.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $aa6b6e9e15323f83$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $8v0nu.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $8v0nu.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $8v0nu.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $aa6b6e9e15323f83$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $aa6b6e9e15323f83$export$e7b0ac011bb776c6) && (0, $318e60a76c97e9b3$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $318e60a76c97e9b3$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $aa6b6e9e15323f83$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $aa6b6e9e15323f83$export$daf73786167a7f72(matches) {
    return $aa6b6e9e15323f83$var$_renderMatches(matches);
}
function $aa6b6e9e15323f83$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $8v0nu.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $8v0nu.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $8v0nu.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $aa6b6e9e15323f83$export$f30f7e456d254e83(routes, opts) {
    return (0, $318e60a76c97e9b3$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $aa6b6e9e15323f83$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $318e60a76c97e9b3$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $aa6b6e9e15323f83$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $d9197f3f1e79e9d9$var$_extends() {
    $d9197f3f1e79e9d9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d9197f3f1e79e9d9$var$_extends.apply(this, arguments);
}
function $d9197f3f1e79e9d9$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $d9197f3f1e79e9d9$var$defaultMethod = "get";
const $d9197f3f1e79e9d9$var$defaultEncType = "application/x-www-form-urlencoded";
function $d9197f3f1e79e9d9$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $d9197f3f1e79e9d9$var$isButtonElement(object) {
    return $d9197f3f1e79e9d9$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $d9197f3f1e79e9d9$var$isFormElement(object) {
    return $d9197f3f1e79e9d9$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $d9197f3f1e79e9d9$var$isInputElement(object) {
    return $d9197f3f1e79e9d9$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $d9197f3f1e79e9d9$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $d9197f3f1e79e9d9$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$d9197f3f1e79e9d9$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $d9197f3f1e79e9d9$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $d9197f3f1e79e9d9$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $d9197f3f1e79e9d9$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $d9197f3f1e79e9d9$var$_formDataSupportsSubmitter = null;
function $d9197f3f1e79e9d9$var$isFormDataSubmitterSupported() {
    if ($d9197f3f1e79e9d9$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $d9197f3f1e79e9d9$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $d9197f3f1e79e9d9$var$_formDataSupportsSubmitter = true;
    }
    return $d9197f3f1e79e9d9$var$_formDataSupportsSubmitter;
}
const $d9197f3f1e79e9d9$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $d9197f3f1e79e9d9$var$getFormEncType(encType) {
    if (encType != null && !$d9197f3f1e79e9d9$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $d9197f3f1e79e9d9$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($d9197f3f1e79e9d9$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $318e60a76c97e9b3$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $d9197f3f1e79e9d9$var$defaultMethod;
        encType = $d9197f3f1e79e9d9$var$getFormEncType(target.getAttribute("enctype")) || $d9197f3f1e79e9d9$var$defaultEncType;
        formData = new FormData(target);
    } else if ($d9197f3f1e79e9d9$var$isButtonElement(target) || $d9197f3f1e79e9d9$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $318e60a76c97e9b3$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $d9197f3f1e79e9d9$var$defaultMethod;
        encType = $d9197f3f1e79e9d9$var$getFormEncType(target.getAttribute("formenctype")) || $d9197f3f1e79e9d9$var$getFormEncType(form.getAttribute("enctype")) || $d9197f3f1e79e9d9$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$d9197f3f1e79e9d9$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($d9197f3f1e79e9d9$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $d9197f3f1e79e9d9$var$defaultMethod;
        action = null;
        encType = $d9197f3f1e79e9d9$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $d9197f3f1e79e9d9$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $d9197f3f1e79e9d9$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $d9197f3f1e79e9d9$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $d9197f3f1e79e9d9$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $d9197f3f1e79e9d9$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $d9197f3f1e79e9d9$export$1f3f55432a00e06d(routes, opts) {
    return (0, $318e60a76c97e9b3$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $d9197f3f1e79e9d9$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $318e60a76c97e9b3$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $d9197f3f1e79e9d9$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $aa6b6e9e15323f83$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $d9197f3f1e79e9d9$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $318e60a76c97e9b3$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $d9197f3f1e79e9d9$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $318e60a76c97e9b3$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $d9197f3f1e79e9d9$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $aa6b6e9e15323f83$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $d9197f3f1e79e9d9$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $d9197f3f1e79e9d9$var$_extends({}, state, {
        errors: $d9197f3f1e79e9d9$var$deserializeErrors(state.errors)
    });
    return state;
}
function $d9197f3f1e79e9d9$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $318e60a76c97e9b3$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $d9197f3f1e79e9d9$export$7ad602f0e94e62d1 = /*#__PURE__*/ $8v0nu.createContext({
    isTransitioning: false
});
const $d9197f3f1e79e9d9$export$148fd98d095596d4 = /*#__PURE__*/ $8v0nu.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $d9197f3f1e79e9d9$var$START_TRANSITION = "startTransition";
const $d9197f3f1e79e9d9$var$startTransitionImpl = $8v0nu[$d9197f3f1e79e9d9$var$START_TRANSITION];
const $d9197f3f1e79e9d9$var$FLUSH_SYNC = "flushSync";
const $d9197f3f1e79e9d9$var$flushSyncImpl = $k2dbP[$d9197f3f1e79e9d9$var$FLUSH_SYNC];
const $d9197f3f1e79e9d9$var$USE_ID = "useId";
const $d9197f3f1e79e9d9$var$useIdImpl = $8v0nu[$d9197f3f1e79e9d9$var$USE_ID];
function $d9197f3f1e79e9d9$var$startTransitionSafe(cb) {
    if ($d9197f3f1e79e9d9$var$startTransitionImpl) $d9197f3f1e79e9d9$var$startTransitionImpl(cb);
    else cb();
}
function $d9197f3f1e79e9d9$var$flushSyncSafe(cb) {
    if ($d9197f3f1e79e9d9$var$flushSyncImpl) $d9197f3f1e79e9d9$var$flushSyncImpl(cb);
    else cb();
}
class $d9197f3f1e79e9d9$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $d9197f3f1e79e9d9$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $8v0nu.useState(router.state);
    let [pendingState, setPendingState] = $8v0nu.useState();
    let [vtContext, setVtContext] = $8v0nu.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $8v0nu.useState();
    let [transition, setTransition] = $8v0nu.useState();
    let [interruption, setInterruption] = $8v0nu.useState();
    let fetcherData = $8v0nu.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $8v0nu.useCallback((cb)=>{
        if (v7_startTransition) $d9197f3f1e79e9d9$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $8v0nu.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $d9197f3f1e79e9d9$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $d9197f3f1e79e9d9$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $d9197f3f1e79e9d9$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $d9197f3f1e79e9d9$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $d9197f3f1e79e9d9$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $8v0nu.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $8v0nu.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $d9197f3f1e79e9d9$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $8v0nu.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $8v0nu.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $8v0nu.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $8v0nu.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $8v0nu.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $8v0nu.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $8v0nu.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $8v0nu.useEffect(()=>(0, $aa6b6e9e15323f83$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $8v0nu.createElement($8v0nu.Fragment, null, /*#__PURE__*/ $8v0nu.createElement((0, $aa6b6e9e15323f83$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $8v0nu.createElement((0, $aa6b6e9e15323f83$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $8v0nu.createElement($d9197f3f1e79e9d9$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $8v0nu.createElement($d9197f3f1e79e9d9$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $8v0nu.createElement((0, $aa6b6e9e15323f83$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $8v0nu.createElement($d9197f3f1e79e9d9$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $d9197f3f1e79e9d9$var$MemoizedDataRoutes = /*#__PURE__*/ $8v0nu.memo($d9197f3f1e79e9d9$var$DataRoutes);
function $d9197f3f1e79e9d9$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $aa6b6e9e15323f83$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $d9197f3f1e79e9d9$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $8v0nu.useRef();
    if (historyRef.current == null) historyRef.current = (0, $318e60a76c97e9b3$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $8v0nu.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8v0nu.useCallback((newState)=>{
        v7_startTransition && $d9197f3f1e79e9d9$var$startTransitionImpl ? $d9197f3f1e79e9d9$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8v0nu.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $8v0nu.useEffect(()=>(0, $aa6b6e9e15323f83$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $8v0nu.createElement((0, $aa6b6e9e15323f83$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $d9197f3f1e79e9d9$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $8v0nu.useRef();
    if (historyRef.current == null) historyRef.current = (0, $318e60a76c97e9b3$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $8v0nu.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8v0nu.useCallback((newState)=>{
        v7_startTransition && $d9197f3f1e79e9d9$var$startTransitionImpl ? $d9197f3f1e79e9d9$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8v0nu.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $8v0nu.useEffect(()=>(0, $aa6b6e9e15323f83$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $8v0nu.createElement((0, $aa6b6e9e15323f83$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $d9197f3f1e79e9d9$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $8v0nu.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8v0nu.useCallback((newState)=>{
        v7_startTransition && $d9197f3f1e79e9d9$var$startTransitionImpl ? $d9197f3f1e79e9d9$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8v0nu.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $8v0nu.useEffect(()=>(0, $aa6b6e9e15323f83$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $8v0nu.createElement((0, $aa6b6e9e15323f83$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $d9197f3f1e79e9d9$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $d9197f3f1e79e9d9$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $d9197f3f1e79e9d9$export$a6c7ac8248d6e38a = /*#__PURE__*/ $8v0nu.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $d9197f3f1e79e9d9$var$_objectWithoutPropertiesLoose(_ref7, $d9197f3f1e79e9d9$var$_excluded);
    let { basename: basename } = $8v0nu.useContext((0, $aa6b6e9e15323f83$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $d9197f3f1e79e9d9$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($d9197f3f1e79e9d9$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $318e60a76c97e9b3$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $aa6b6e9e15323f83$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $d9197f3f1e79e9d9$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $8v0nu.createElement("a", $d9197f3f1e79e9d9$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $d9197f3f1e79e9d9$export$b0d92dbee9b5b60d = /*#__PURE__*/ $8v0nu.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $d9197f3f1e79e9d9$var$_objectWithoutPropertiesLoose(_ref8, $d9197f3f1e79e9d9$var$_excluded2);
    let path = (0, $aa6b6e9e15323f83$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $aa6b6e9e15323f83$export$45d76561a5302f2b)();
    let routerState = $8v0nu.useContext((0, $aa6b6e9e15323f83$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $8v0nu.useContext((0, $aa6b6e9e15323f83$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $d9197f3f1e79e9d9$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $318e60a76c97e9b3$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $8v0nu.createElement($d9197f3f1e79e9d9$export$a6c7ac8248d6e38a, $d9197f3f1e79e9d9$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $d9197f3f1e79e9d9$export$a7fed597f4b8afd8 = /*#__PURE__*/ $8v0nu.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $d9197f3f1e79e9d9$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $d9197f3f1e79e9d9$var$_objectWithoutPropertiesLoose(_ref9, $d9197f3f1e79e9d9$var$_excluded3);
    let submit = $d9197f3f1e79e9d9$export$47c85c6e3a081d3();
    let formAction = $d9197f3f1e79e9d9$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $8v0nu.createElement("form", $d9197f3f1e79e9d9$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $d9197f3f1e79e9d9$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $d9197f3f1e79e9d9$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $d9197f3f1e79e9d9$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($d9197f3f1e79e9d9$var$DataRouterHook || ($d9197f3f1e79e9d9$var$DataRouterHook = {}));
var $d9197f3f1e79e9d9$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($d9197f3f1e79e9d9$var$DataRouterStateHook || ($d9197f3f1e79e9d9$var$DataRouterStateHook = {}));
// Internal hooks
function $d9197f3f1e79e9d9$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $d9197f3f1e79e9d9$var$useDataRouterContext(hookName) {
    let ctx = $8v0nu.useContext((0, $aa6b6e9e15323f83$export$3add0d5dce533e2e));
    !ctx && (0, $318e60a76c97e9b3$export$3e9cee6b33872309)(false);
    return ctx;
}
function $d9197f3f1e79e9d9$var$useDataRouterState(hookName) {
    let state = $8v0nu.useContext((0, $aa6b6e9e15323f83$export$145dfa71566a64dc));
    !state && (0, $318e60a76c97e9b3$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $d9197f3f1e79e9d9$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $aa6b6e9e15323f83$export$9770f232ac06a008)();
    let location = (0, $aa6b6e9e15323f83$export$45d76561a5302f2b)();
    let path = (0, $aa6b6e9e15323f83$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $8v0nu.useCallback((event)=>{
        if ($d9197f3f1e79e9d9$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $318e60a76c97e9b3$export$fe53371bee54353d)(location) === (0, $318e60a76c97e9b3$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $d9197f3f1e79e9d9$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $8v0nu.useRef($d9197f3f1e79e9d9$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $8v0nu.useRef(false);
    let location = (0, $aa6b6e9e15323f83$export$45d76561a5302f2b)();
    let searchParams = $8v0nu.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $d9197f3f1e79e9d9$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $aa6b6e9e15323f83$export$9770f232ac06a008)();
    let setSearchParams = $8v0nu.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $d9197f3f1e79e9d9$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $d9197f3f1e79e9d9$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $d9197f3f1e79e9d9$var$fetcherId = 0;
let $d9197f3f1e79e9d9$var$getUniqueFetcherId = ()=>"__" + String(++$d9197f3f1e79e9d9$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $d9197f3f1e79e9d9$export$47c85c6e3a081d3() {
    let { router: router } = $d9197f3f1e79e9d9$var$useDataRouterContext($d9197f3f1e79e9d9$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $8v0nu.useContext((0, $aa6b6e9e15323f83$export$26749e8557646306));
    let currentRouteId = (0, $aa6b6e9e15323f83$export$5fc8298006ad9e58)();
    return $8v0nu.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $d9197f3f1e79e9d9$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $d9197f3f1e79e9d9$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $d9197f3f1e79e9d9$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $d9197f3f1e79e9d9$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $8v0nu.useContext((0, $aa6b6e9e15323f83$export$26749e8557646306));
    let routeContext = $8v0nu.useContext((0, $aa6b6e9e15323f83$export$9072aa6dd1f93057));
    !routeContext && (0, $318e60a76c97e9b3$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $d9197f3f1e79e9d9$var$_extends({}, (0, $aa6b6e9e15323f83$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $aa6b6e9e15323f83$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $318e60a76c97e9b3$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $318e60a76c97e9b3$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $d9197f3f1e79e9d9$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $d9197f3f1e79e9d9$var$useDataRouterContext($d9197f3f1e79e9d9$var$DataRouterHook.UseFetcher);
    let state = $d9197f3f1e79e9d9$var$useDataRouterState($d9197f3f1e79e9d9$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $8v0nu.useContext($d9197f3f1e79e9d9$export$148fd98d095596d4);
    let route = $8v0nu.useContext((0, $aa6b6e9e15323f83$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $318e60a76c97e9b3$export$3e9cee6b33872309)(false);
    !route && (0, $318e60a76c97e9b3$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $318e60a76c97e9b3$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $d9197f3f1e79e9d9$var$useIdImpl ? $d9197f3f1e79e9d9$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $8v0nu.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($d9197f3f1e79e9d9$var$getUniqueFetcherId());
    // Registration/cleanup
    $8v0nu.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $8v0nu.useCallback((href, opts)=>{
        !routeId && (0, $318e60a76c97e9b3$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $d9197f3f1e79e9d9$export$47c85c6e3a081d3();
    let submit = $8v0nu.useCallback((target, opts)=>{
        submitImpl(target, $d9197f3f1e79e9d9$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $8v0nu.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $8v0nu.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $8v0nu.createElement($d9197f3f1e79e9d9$export$a7fed597f4b8afd8, $d9197f3f1e79e9d9$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $318e60a76c97e9b3$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $8v0nu.useMemo(()=>$d9197f3f1e79e9d9$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $d9197f3f1e79e9d9$export$fa996778a3a31087() {
    let state = $d9197f3f1e79e9d9$var$useDataRouterState($d9197f3f1e79e9d9$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $d9197f3f1e79e9d9$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $d9197f3f1e79e9d9$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $d9197f3f1e79e9d9$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $d9197f3f1e79e9d9$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $d9197f3f1e79e9d9$var$useDataRouterContext($d9197f3f1e79e9d9$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $d9197f3f1e79e9d9$var$useDataRouterState($d9197f3f1e79e9d9$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $8v0nu.useContext((0, $aa6b6e9e15323f83$export$26749e8557646306));
    let location = (0, $aa6b6e9e15323f83$export$45d76561a5302f2b)();
    let matches = (0, $aa6b6e9e15323f83$export$2378eb7f5ff86053)();
    let navigation = (0, $aa6b6e9e15323f83$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $8v0nu.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $d9197f3f1e79e9d9$var$usePageHide($8v0nu.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $d9197f3f1e79e9d9$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $d9197f3f1e79e9d9$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($d9197f3f1e79e9d9$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8v0nu.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $d9197f3f1e79e9d9$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $d9197f3f1e79e9d9$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8v0nu.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($d9197f3f1e79e9d9$var$_extends({}, location, {
                    pathname: (0, $318e60a76c97e9b3$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($d9197f3f1e79e9d9$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8v0nu.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $d9197f3f1e79e9d9$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $8v0nu.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $d9197f3f1e79e9d9$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $8v0nu.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $d9197f3f1e79e9d9$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $aa6b6e9e15323f83$export$b273b3273281a049)(when);
    $8v0nu.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $8v0nu.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $d9197f3f1e79e9d9$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $8v0nu.useContext($d9197f3f1e79e9d9$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $318e60a76c97e9b3$export$3e9cee6b33872309)(false);
    let { basename: basename } = $d9197f3f1e79e9d9$var$useDataRouterContext($d9197f3f1e79e9d9$var$DataRouterHook.useViewTransitionState);
    let path = (0, $aa6b6e9e15323f83$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $318e60a76c97e9b3$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $318e60a76c97e9b3$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $318e60a76c97e9b3$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $318e60a76c97e9b3$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}




var $8v0nu = parcelRequire("8v0nu");
var $c643e5ed062df6b9$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $c643e5ed062df6b9$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $c643e5ed062df6b9$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $c643e5ed062df6b9$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$c643e5ed062df6b9$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($c643e5ed062df6b9$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $c643e5ed062df6b9$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();


/**
 * @param {number}
 * @return {number}
 */ var $e562b52475b1e492$export$2335f513bbd82c6d = Math.abs;
var $e562b52475b1e492$export$6788812c4e6611e6 = String.fromCharCode;
var $e562b52475b1e492$export$e6e34fd1f2686227 = Object.assign;
function $e562b52475b1e492$export$d6af199866bfb566(value, length) {
    return $e562b52475b1e492$export$a9db5e087081082d(value, 0) ^ 45 ? (((length << 2 ^ $e562b52475b1e492$export$a9db5e087081082d(value, 0)) << 2 ^ $e562b52475b1e492$export$a9db5e087081082d(value, 1)) << 2 ^ $e562b52475b1e492$export$a9db5e087081082d(value, 2)) << 2 ^ $e562b52475b1e492$export$a9db5e087081082d(value, 3) : 0;
}
function $e562b52475b1e492$export$87c2784dc9fc4ab(value) {
    return value.trim();
}
function $e562b52475b1e492$export$4659b591c19bdf3d(value, pattern) {
    return (value = pattern.exec(value)) ? value[0] : value;
}
function $e562b52475b1e492$export$77ad94ebf1c2b9ed(value, pattern, replacement) {
    return value.replace(pattern, replacement);
}
function $e562b52475b1e492$export$f8e21b1e77979a08(value, search) {
    return value.indexOf(search);
}
function $e562b52475b1e492$export$a9db5e087081082d(value, index) {
    return value.charCodeAt(index) | 0;
}
function $e562b52475b1e492$export$2f35ab04d2335697(value, begin, end) {
    return value.slice(begin, end);
}
function $e562b52475b1e492$export$36776f635604f274(value) {
    return value.length;
}
function $e562b52475b1e492$export$f9084667e487ed46(value) {
    return value.length;
}
function $e562b52475b1e492$export$10d8903dec122b9d(value, array) {
    return array.push(value), value;
}
function $e562b52475b1e492$export$1be1fc439b849fdf(array, callback) {
    return array.map(callback).join('');
}


var $f8c2a28b14853b69$export$53f1d5ea8de3d7c = 1;
var $f8c2a28b14853b69$export$4e0c71f277ca26b3 = 1;
var $f8c2a28b14853b69$export$f24224f1c91d8156 = 0;
var $f8c2a28b14853b69$export$5880b8b5730aff45 = 0;
var $f8c2a28b14853b69$export$c0306caf338ac095 = 0;
var $f8c2a28b14853b69$export$30a86d91af8ff6e6 = '';
function $f8c2a28b14853b69$export$35059013cd4a06db(value, root, parent, type, props, children, length) {
    return {
        value: value,
        root: root,
        parent: parent,
        type: type,
        props: props,
        children: children,
        line: $f8c2a28b14853b69$export$53f1d5ea8de3d7c,
        column: $f8c2a28b14853b69$export$4e0c71f277ca26b3,
        length: length,
        return: ''
    };
}
function $f8c2a28b14853b69$export$784d13d8ee351f07(root, props) {
    return (0, $e562b52475b1e492$export$e6e34fd1f2686227)($f8c2a28b14853b69$export$35059013cd4a06db('', null, null, '', null, null, 0), root, {
        length: -root.length
    }, props);
}
function $f8c2a28b14853b69$export$eba6f6f03b0a92e7() {
    return $f8c2a28b14853b69$export$c0306caf338ac095;
}
function $f8c2a28b14853b69$export$232faf9add678146() {
    $f8c2a28b14853b69$export$c0306caf338ac095 = $f8c2a28b14853b69$export$5880b8b5730aff45 > 0 ? (0, $e562b52475b1e492$export$a9db5e087081082d)($f8c2a28b14853b69$export$30a86d91af8ff6e6, --$f8c2a28b14853b69$export$5880b8b5730aff45) : 0;
    if ($f8c2a28b14853b69$export$4e0c71f277ca26b3--, $f8c2a28b14853b69$export$c0306caf338ac095 === 10) $f8c2a28b14853b69$export$4e0c71f277ca26b3 = 1, $f8c2a28b14853b69$export$53f1d5ea8de3d7c--;
    return $f8c2a28b14853b69$export$c0306caf338ac095;
}
function $f8c2a28b14853b69$export$48cfd1e771a65c4f() {
    $f8c2a28b14853b69$export$c0306caf338ac095 = $f8c2a28b14853b69$export$5880b8b5730aff45 < $f8c2a28b14853b69$export$f24224f1c91d8156 ? (0, $e562b52475b1e492$export$a9db5e087081082d)($f8c2a28b14853b69$export$30a86d91af8ff6e6, $f8c2a28b14853b69$export$5880b8b5730aff45++) : 0;
    if ($f8c2a28b14853b69$export$4e0c71f277ca26b3++, $f8c2a28b14853b69$export$c0306caf338ac095 === 10) $f8c2a28b14853b69$export$4e0c71f277ca26b3 = 1, $f8c2a28b14853b69$export$53f1d5ea8de3d7c++;
    return $f8c2a28b14853b69$export$c0306caf338ac095;
}
function $f8c2a28b14853b69$export$4d3fb11e950abb9e() {
    return (0, $e562b52475b1e492$export$a9db5e087081082d)($f8c2a28b14853b69$export$30a86d91af8ff6e6, $f8c2a28b14853b69$export$5880b8b5730aff45);
}
function $f8c2a28b14853b69$export$e88cb2efb12ae807() {
    return $f8c2a28b14853b69$export$5880b8b5730aff45;
}
function $f8c2a28b14853b69$export$58adb3bec8346d0f(begin, end) {
    return (0, $e562b52475b1e492$export$2f35ab04d2335697)($f8c2a28b14853b69$export$30a86d91af8ff6e6, begin, end);
}
function $f8c2a28b14853b69$export$9e1725a4cfeada27(type) {
    switch(type){
        // \0 \t \n \r \s whitespace token
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        // ! + , / > @ ~ isolate token
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        // ; { } breakpoint token
        case 59:
        case 123:
        case 125:
            return 4;
        // : accompanied token
        case 58:
            return 3;
        // " ' ( [ opening delimit token
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        // ) ] closing delimit token
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $f8c2a28b14853b69$export$2de70f21292aac9e(value) {
    return $f8c2a28b14853b69$export$53f1d5ea8de3d7c = $f8c2a28b14853b69$export$4e0c71f277ca26b3 = 1, $f8c2a28b14853b69$export$f24224f1c91d8156 = (0, $e562b52475b1e492$export$36776f635604f274)($f8c2a28b14853b69$export$30a86d91af8ff6e6 = value), $f8c2a28b14853b69$export$5880b8b5730aff45 = 0, [];
}
function $f8c2a28b14853b69$export$45918ac1574455b1(value) {
    return $f8c2a28b14853b69$export$30a86d91af8ff6e6 = '', value;
}
function $f8c2a28b14853b69$export$410ac95b9ec204b8(type) {
    return (0, $e562b52475b1e492$export$87c2784dc9fc4ab)($f8c2a28b14853b69$export$58adb3bec8346d0f($f8c2a28b14853b69$export$5880b8b5730aff45 - 1, $f8c2a28b14853b69$export$c889f2fcc19dbf12(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function $f8c2a28b14853b69$export$660b2ee2d4fb4eff(value) {
    return $f8c2a28b14853b69$export$45918ac1574455b1($f8c2a28b14853b69$export$5f8c09e3ae6f64e1($f8c2a28b14853b69$export$2de70f21292aac9e(value)));
}
function $f8c2a28b14853b69$export$7af1228ff777d175(type) {
    while($f8c2a28b14853b69$export$c0306caf338ac095 = $f8c2a28b14853b69$export$4d3fb11e950abb9e())if ($f8c2a28b14853b69$export$c0306caf338ac095 < 33) $f8c2a28b14853b69$export$48cfd1e771a65c4f();
    else break;
    return $f8c2a28b14853b69$export$9e1725a4cfeada27(type) > 2 || $f8c2a28b14853b69$export$9e1725a4cfeada27($f8c2a28b14853b69$export$c0306caf338ac095) > 3 ? '' : ' ';
}
function $f8c2a28b14853b69$export$5f8c09e3ae6f64e1(children) {
    while($f8c2a28b14853b69$export$48cfd1e771a65c4f())switch($f8c2a28b14853b69$export$9e1725a4cfeada27($f8c2a28b14853b69$export$c0306caf338ac095)){
        case 0:
            (0, $e562b52475b1e492$export$10d8903dec122b9d)($f8c2a28b14853b69$export$c2ab62c7bf24634($f8c2a28b14853b69$export$5880b8b5730aff45 - 1), children);
            break;
        case 2:
            (0, $e562b52475b1e492$export$10d8903dec122b9d)($f8c2a28b14853b69$export$410ac95b9ec204b8($f8c2a28b14853b69$export$c0306caf338ac095), children);
            break;
        default:
            (0, $e562b52475b1e492$export$10d8903dec122b9d)((0, $e562b52475b1e492$export$6788812c4e6611e6)($f8c2a28b14853b69$export$c0306caf338ac095), children);
    }
    return children;
}
function $f8c2a28b14853b69$export$955ba06d119e085e(index, count) {
    while(--count && $f8c2a28b14853b69$export$48cfd1e771a65c4f())// not 0-9 A-F a-f
    if ($f8c2a28b14853b69$export$c0306caf338ac095 < 48 || $f8c2a28b14853b69$export$c0306caf338ac095 > 102 || $f8c2a28b14853b69$export$c0306caf338ac095 > 57 && $f8c2a28b14853b69$export$c0306caf338ac095 < 65 || $f8c2a28b14853b69$export$c0306caf338ac095 > 70 && $f8c2a28b14853b69$export$c0306caf338ac095 < 97) break;
    return $f8c2a28b14853b69$export$58adb3bec8346d0f(index, $f8c2a28b14853b69$export$e88cb2efb12ae807() + (count < 6 && $f8c2a28b14853b69$export$4d3fb11e950abb9e() == 32 && $f8c2a28b14853b69$export$48cfd1e771a65c4f() == 32));
}
function $f8c2a28b14853b69$export$c889f2fcc19dbf12(type) {
    while($f8c2a28b14853b69$export$48cfd1e771a65c4f())switch($f8c2a28b14853b69$export$c0306caf338ac095){
        // ] ) " '
        case type:
            return $f8c2a28b14853b69$export$5880b8b5730aff45;
        // " '
        case 34:
        case 39:
            if (type !== 34 && type !== 39) $f8c2a28b14853b69$export$c889f2fcc19dbf12($f8c2a28b14853b69$export$c0306caf338ac095);
            break;
        // (
        case 40:
            if (type === 41) $f8c2a28b14853b69$export$c889f2fcc19dbf12(type);
            break;
        // \
        case 92:
            $f8c2a28b14853b69$export$48cfd1e771a65c4f();
            break;
    }
    return $f8c2a28b14853b69$export$5880b8b5730aff45;
}
function $f8c2a28b14853b69$export$4254d4e2b3745c4c(type, index) {
    while($f8c2a28b14853b69$export$48cfd1e771a65c4f())// //
    if (type + $f8c2a28b14853b69$export$c0306caf338ac095 === 57) break;
    else if (type + $f8c2a28b14853b69$export$c0306caf338ac095 === 84 && $f8c2a28b14853b69$export$4d3fb11e950abb9e() === 47) break;
    return '/*' + $f8c2a28b14853b69$export$58adb3bec8346d0f(index, $f8c2a28b14853b69$export$5880b8b5730aff45 - 1) + '*' + (0, $e562b52475b1e492$export$6788812c4e6611e6)(type === 47 ? type : $f8c2a28b14853b69$export$48cfd1e771a65c4f());
}
function $f8c2a28b14853b69$export$c2ab62c7bf24634(index) {
    while(!$f8c2a28b14853b69$export$9e1725a4cfeada27($f8c2a28b14853b69$export$4d3fb11e950abb9e()))$f8c2a28b14853b69$export$48cfd1e771a65c4f();
    return $f8c2a28b14853b69$export$58adb3bec8346d0f(index, $f8c2a28b14853b69$export$5880b8b5730aff45);
}

var $acc489014c5872c4$export$71ad59f2e432cfe8 = '-ms-';
var $acc489014c5872c4$export$2c0f367103c8d01c = '-moz-';
var $acc489014c5872c4$export$39dfd62a25e0fe93 = '-webkit-';
var $acc489014c5872c4$export$a29989082612d0d9 = 'comm';
var $acc489014c5872c4$export$aa3a2e812ca8570d = 'rule';
var $acc489014c5872c4$export$527d108ccf083c2b = 'decl';
var $acc489014c5872c4$export$d3d35020fa5b54f0 = '@page';
var $acc489014c5872c4$export$500415a86c544f73 = '@media';
var $acc489014c5872c4$export$a763edbf796b780a = '@import';
var $acc489014c5872c4$export$2790aeb8b4e5c826 = '@charset';
var $acc489014c5872c4$export$1cc683e23b84b133 = '@viewport';
var $acc489014c5872c4$export$9447a5efea57e862 = '@supports';
var $acc489014c5872c4$export$ef011b4e114b1fba = '@document';
var $acc489014c5872c4$export$6aad947bda0f3f46 = '@namespace';
var $acc489014c5872c4$export$b44a8529a35fcb60 = '@keyframes';
var $acc489014c5872c4$export$2c16de31893252e6 = '@font-face';
var $acc489014c5872c4$export$3d846dd52e150c6f = '@counter-style';
var $acc489014c5872c4$export$22314bfbb57653fe = '@font-feature-values';
var $acc489014c5872c4$export$d773506282b3cfe6 = '@layer';




function $6859efbb8a2fab01$export$ef7acd7185315e22(value) {
    return (0, $f8c2a28b14853b69$export$45918ac1574455b1)($6859efbb8a2fab01$export$98e6a39c04603d36('', null, null, null, [
        ''
    ], value = (0, $f8c2a28b14853b69$export$2de70f21292aac9e)(value), 0, [
        0
    ], value));
}
function $6859efbb8a2fab01$export$98e6a39c04603d36(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
    var index = 0;
    var offset = 0;
    var length = pseudo;
    var atrule = 0;
    var property = 0;
    var previous = 0;
    var variable = 1;
    var scanning = 1;
    var ampersand = 1;
    var character = 0;
    var type = '';
    var props = rules;
    var children = rulesets;
    var reference = rule;
    var characters = type;
    while(scanning)switch(previous = character, character = (0, $f8c2a28b14853b69$export$48cfd1e771a65c4f)()){
        // (
        case 40:
            if (previous != 108 && (0, $e562b52475b1e492$export$a9db5e087081082d)(characters, length - 1) == 58) {
                if ((0, $e562b52475b1e492$export$f8e21b1e77979a08)(characters += (0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)((0, $f8c2a28b14853b69$export$410ac95b9ec204b8)(character), '&', '&\f'), '&\f') != -1) ampersand = -1;
                break;
            }
        // " ' [
        case 34:
        case 39:
        case 91:
            characters += (0, $f8c2a28b14853b69$export$410ac95b9ec204b8)(character);
            break;
        // \t \n \r \s
        case 9:
        case 10:
        case 13:
        case 32:
            characters += (0, $f8c2a28b14853b69$export$7af1228ff777d175)(previous);
            break;
        // \
        case 92:
            characters += (0, $f8c2a28b14853b69$export$955ba06d119e085e)((0, $f8c2a28b14853b69$export$e88cb2efb12ae807)() - 1, 7);
            continue;
        // /
        case 47:
            switch((0, $f8c2a28b14853b69$export$4d3fb11e950abb9e)()){
                case 42:
                case 47:
                    (0, $e562b52475b1e492$export$10d8903dec122b9d)($6859efbb8a2fab01$export$4a34f930e789283c((0, $f8c2a28b14853b69$export$4254d4e2b3745c4c)((0, $f8c2a28b14853b69$export$48cfd1e771a65c4f)(), (0, $f8c2a28b14853b69$export$e88cb2efb12ae807)()), root, parent), declarations);
                    break;
                default:
                    characters += '/';
            }
            break;
        // {
        case 123 * variable:
            points[index++] = (0, $e562b52475b1e492$export$36776f635604f274)(characters) * ampersand;
        // } ; \0
        case 125 * variable:
        case 59:
        case 0:
            switch(character){
                // \0 }
                case 0:
                case 125:
                    scanning = 0;
                // ;
                case 59 + offset:
                    if (ampersand == -1) characters = (0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)(characters, /\f/g, '');
                    if (property > 0 && (0, $e562b52475b1e492$export$36776f635604f274)(characters) - length) (0, $e562b52475b1e492$export$10d8903dec122b9d)(property > 32 ? $6859efbb8a2fab01$export$f8483753829ec8f3(characters + ';', rule, parent, length - 1) : $6859efbb8a2fab01$export$f8483753829ec8f3((0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)(characters, ' ', '') + ';', rule, parent, length - 2), declarations);
                    break;
                // @ ;
                case 59:
                    characters += ';';
                // { rule/at-rule
                default:
                    (0, $e562b52475b1e492$export$10d8903dec122b9d)(reference = $6859efbb8a2fab01$export$3307ffa7023ede1e(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);
                    if (character === 123) {
                        if (offset === 0) $6859efbb8a2fab01$export$98e6a39c04603d36(characters, root, reference, reference, props, rulesets, length, points, children);
                        else switch(atrule === 99 && (0, $e562b52475b1e492$export$a9db5e087081082d)(characters, 3) === 110 ? 100 : atrule){
                            // d l m s
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $6859efbb8a2fab01$export$98e6a39c04603d36(value, reference, reference, rule && (0, $e562b52475b1e492$export$10d8903dec122b9d)($6859efbb8a2fab01$export$3307ffa7023ede1e(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
                                break;
                            default:
                                $6859efbb8a2fab01$export$98e6a39c04603d36(characters, reference, reference, reference, [
                                    ''
                                ], children, 0, points, children);
                        }
                    }
            }
            index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
            break;
        // :
        case 58:
            length = 1 + (0, $e562b52475b1e492$export$36776f635604f274)(characters), property = previous;
        default:
            if (variable < 1) {
                if (character == 123) --variable;
                else if (character == 125 && variable++ == 0 && (0, $f8c2a28b14853b69$export$232faf9add678146)() == 125) continue;
            }
            switch(characters += (0, $e562b52475b1e492$export$6788812c4e6611e6)(character), character * variable){
                // &
                case 38:
                    ampersand = offset > 0 ? 1 : (characters += '\f', -1);
                    break;
                // ,
                case 44:
                    points[index++] = ((0, $e562b52475b1e492$export$36776f635604f274)(characters) - 1) * ampersand, ampersand = 1;
                    break;
                // @
                case 64:
                    // -
                    if ((0, $f8c2a28b14853b69$export$4d3fb11e950abb9e)() === 45) characters += (0, $f8c2a28b14853b69$export$410ac95b9ec204b8)((0, $f8c2a28b14853b69$export$48cfd1e771a65c4f)());
                    atrule = (0, $f8c2a28b14853b69$export$4d3fb11e950abb9e)(), offset = length = (0, $e562b52475b1e492$export$36776f635604f274)(type = characters += (0, $f8c2a28b14853b69$export$c2ab62c7bf24634)((0, $f8c2a28b14853b69$export$e88cb2efb12ae807)())), character++;
                    break;
                // -
                case 45:
                    if (previous === 45 && (0, $e562b52475b1e492$export$36776f635604f274)(characters) == 2) variable = 0;
            }
    }
    return rulesets;
}
function $6859efbb8a2fab01$export$3307ffa7023ede1e(value, root, parent, index, offset, rules, points, type, props, children, length) {
    var post = offset - 1;
    var rule = offset === 0 ? rules : [
        ''
    ];
    var size = (0, $e562b52475b1e492$export$f9084667e487ed46)(rule);
    for(var i = 0, j = 0, k = 0; i < index; ++i)for(var x = 0, y = (0, $e562b52475b1e492$export$2f35ab04d2335697)(value, post + 1, post = (0, $e562b52475b1e492$export$2335f513bbd82c6d)(j = points[i])), z = value; x < size; ++x)if (z = (0, $e562b52475b1e492$export$87c2784dc9fc4ab)(j > 0 ? rule[x] + ' ' + y : (0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)(y, /&\f/g, rule[x]))) props[k++] = z;
    return (0, $f8c2a28b14853b69$export$35059013cd4a06db)(value, root, parent, offset === 0 ? (0, $acc489014c5872c4$export$aa3a2e812ca8570d) : type, props, children, length);
}
function $6859efbb8a2fab01$export$4a34f930e789283c(value, root, parent) {
    return (0, $f8c2a28b14853b69$export$35059013cd4a06db)(value, root, parent, (0, $acc489014c5872c4$export$a29989082612d0d9), (0, $e562b52475b1e492$export$6788812c4e6611e6)((0, $f8c2a28b14853b69$export$eba6f6f03b0a92e7)()), (0, $e562b52475b1e492$export$2f35ab04d2335697)(value, 2, -2), 0);
}
function $6859efbb8a2fab01$export$f8483753829ec8f3(value, root, parent, length) {
    return (0, $f8c2a28b14853b69$export$35059013cd4a06db)(value, root, parent, (0, $acc489014c5872c4$export$527d108ccf083c2b), (0, $e562b52475b1e492$export$2f35ab04d2335697)(value, 0, length), (0, $e562b52475b1e492$export$2f35ab04d2335697)(value, length + 1, -1), length);
}






function $82be013fdc68c24d$export$dfdc1655ccc5b9cb(children, callback) {
    var output = '';
    var length = (0, $e562b52475b1e492$export$f9084667e487ed46)(children);
    for(var i = 0; i < length; i++)output += callback(children[i], i, children, callback) || '';
    return output;
}
function $82be013fdc68c24d$export$fac44ee5b035f737(element, index, children, callback) {
    switch(element.type){
        case 0, $acc489014c5872c4$export$d773506282b3cfe6:
            if (element.children.length) break;
        case 0, $acc489014c5872c4$export$a763edbf796b780a:
        case 0, $acc489014c5872c4$export$527d108ccf083c2b:
            return element.return = element.return || element.value;
        case 0, $acc489014c5872c4$export$a29989082612d0d9:
            return '';
        case 0, $acc489014c5872c4$export$b44a8529a35fcb60:
            return element.return = element.value + '{' + $82be013fdc68c24d$export$dfdc1655ccc5b9cb(element.children, callback) + '}';
        case 0, $acc489014c5872c4$export$aa3a2e812ca8570d:
            element.value = element.props.join(',');
    }
    return (0, $e562b52475b1e492$export$36776f635604f274)(children = $82be013fdc68c24d$export$dfdc1655ccc5b9cb(element.children, callback)) ? element.return = element.value + '{' + children + '}' : '';
}




function $847aec06bd93db01$export$82e9f45cca5ba907(value, length, children) {
    switch((0, $e562b52475b1e492$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $acc489014c5872c4$export$39dfd62a25e0fe93) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $acc489014c5872c4$export$39dfd62a25e0fe93) + value + value;
        // tab-size
        case 4789:
            return (0, $acc489014c5872c4$export$2c0f367103c8d01c) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $acc489014c5872c4$export$39dfd62a25e0fe93) + value + (0, $acc489014c5872c4$export$2c0f367103c8d01c) + value + (0, $acc489014c5872c4$export$71ad59f2e432cfe8) + value + value;
        // writing-mode
        case 5936:
            switch((0, $e562b52475b1e492$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $acc489014c5872c4$export$39dfd62a25e0fe93) + value + (0, $acc489014c5872c4$export$71ad59f2e432cfe8) + (0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $acc489014c5872c4$export$39dfd62a25e0fe93) + value + (0, $acc489014c5872c4$export$71ad59f2e432cfe8) + (0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $acc489014c5872c4$export$39dfd62a25e0fe93) + value + (0, $acc489014c5872c4$export$71ad59f2e432cfe8) + (0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
        // flex, flex-direction, scroll-snap-type, writing-mode
        case 6828:
        case 4268:
        case 2903:
            return (0, $acc489014c5872c4$export$39dfd62a25e0fe93) + value + (0, $acc489014c5872c4$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $acc489014c5872c4$export$39dfd62a25e0fe93) + value + (0, $acc489014c5872c4$export$71ad59f2e432cfe8) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $acc489014c5872c4$export$39dfd62a25e0fe93) + value + (0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $acc489014c5872c4$export$39dfd62a25e0fe93) + 'box-$1$2' + (0, $acc489014c5872c4$export$71ad59f2e432cfe8) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $acc489014c5872c4$export$39dfd62a25e0fe93) + value + (0, $acc489014c5872c4$export$71ad59f2e432cfe8) + 'flex-item-' + (0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)(value, /flex-|-self/g, '') + (!(0, $e562b52475b1e492$export$4659b591c19bdf3d)(value, /flex-|baseline/) ? (0, $acc489014c5872c4$export$71ad59f2e432cfe8) + 'grid-row-' + (0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)(value, /flex-|-self/g, '') : '') + value;
        // align-content
        case 4675:
            return (0, $acc489014c5872c4$export$39dfd62a25e0fe93) + value + (0, $acc489014c5872c4$export$71ad59f2e432cfe8) + 'flex-line-pack' + (0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/g, '') + value;
        // flex-shrink
        case 5548:
            return (0, $acc489014c5872c4$export$39dfd62a25e0fe93) + value + (0, $acc489014c5872c4$export$71ad59f2e432cfe8) + (0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $acc489014c5872c4$export$39dfd62a25e0fe93) + value + (0, $acc489014c5872c4$export$71ad59f2e432cfe8) + (0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $acc489014c5872c4$export$39dfd62a25e0fe93) + 'box-' + (0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)(value, '-grow', '') + (0, $acc489014c5872c4$export$39dfd62a25e0fe93) + value + (0, $acc489014c5872c4$export$71ad59f2e432cfe8) + (0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $acc489014c5872c4$export$39dfd62a25e0fe93) + (0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, '$1' + (0, $acc489014c5872c4$export$39dfd62a25e0fe93) + '$2') + value;
        // cursor
        case 6187:
            return (0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)((0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)((0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $acc489014c5872c4$export$39dfd62a25e0fe93) + '$1'), /(image-set)/, (0, $acc489014c5872c4$export$39dfd62a25e0fe93) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $acc489014c5872c4$export$39dfd62a25e0fe93) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)((0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $acc489014c5872c4$export$39dfd62a25e0fe93) + 'box-pack:$3' + (0, $acc489014c5872c4$export$71ad59f2e432cfe8) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $acc489014c5872c4$export$39dfd62a25e0fe93) + value + value;
        // justify-self
        case 4200:
            if (!(0, $e562b52475b1e492$export$4659b591c19bdf3d)(value, /flex-|baseline/)) return (0, $acc489014c5872c4$export$71ad59f2e432cfe8) + 'grid-column-align' + (0, $e562b52475b1e492$export$2f35ab04d2335697)(value, length) + value;
            break;
        // grid-template-(columns|rows)
        case 2592:
        case 3360:
            return (0, $acc489014c5872c4$export$71ad59f2e432cfe8) + (0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)(value, 'template-', '') + value;
        // grid-(row|column)-start
        case 4384:
        case 3616:
            if (children && children.some(function(element, index) {
                return length = index, (0, $e562b52475b1e492$export$4659b591c19bdf3d)(element.props, /grid-\w+-end/);
            })) return ~(0, $e562b52475b1e492$export$f8e21b1e77979a08)(value + (children = children[length].value), 'span') ? value : (0, $acc489014c5872c4$export$71ad59f2e432cfe8) + (0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)(value, '-start', '') + value + (0, $acc489014c5872c4$export$71ad59f2e432cfe8) + 'grid-row-span:' + (~(0, $e562b52475b1e492$export$f8e21b1e77979a08)(children, 'span') ? (0, $e562b52475b1e492$export$4659b591c19bdf3d)(children, /\d+/) : +(0, $e562b52475b1e492$export$4659b591c19bdf3d)(children, /\d+/) - +(0, $e562b52475b1e492$export$4659b591c19bdf3d)(value, /\d+/)) + ';';
            return (0, $acc489014c5872c4$export$71ad59f2e432cfe8) + (0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)(value, '-start', '') + value;
        // grid-(row|column)-end
        case 4896:
        case 4128:
            return children && children.some(function(element) {
                return (0, $e562b52475b1e492$export$4659b591c19bdf3d)(element.props, /grid-\w+-start/);
            }) ? value : (0, $acc489014c5872c4$export$71ad59f2e432cfe8) + (0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)((0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)(value, '-end', '-span'), 'span ', '') + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $acc489014c5872c4$export$39dfd62a25e0fe93) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $e562b52475b1e492$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $e562b52475b1e492$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $e562b52475b1e492$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $acc489014c5872c4$export$39dfd62a25e0fe93) + '$2-$3' + '$1' + (0, $acc489014c5872c4$export$2c0f367103c8d01c) + ((0, $e562b52475b1e492$export$a9db5e087081082d)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $e562b52475b1e492$export$f8e21b1e77979a08)(value, 'stretch') ? $847aec06bd93db01$export$82e9f45cca5ba907((0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)(value, 'stretch', 'fill-available'), length, children) + value : value;
            }
            break;
        // grid-(column|row)
        case 5152:
        case 5920:
            return (0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)(value, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(_, a, b, c, d, e, f) {
                return (0, $acc489014c5872c4$export$71ad59f2e432cfe8) + a + ':' + b + f + (c ? (0, $acc489014c5872c4$export$71ad59f2e432cfe8) + a + '-span:' + (d ? e : +e - +b) + f : '') + value;
            });
        // position: sticky
        case 4949:
            // stick(y)?
            if ((0, $e562b52475b1e492$export$a9db5e087081082d)(value, length + 6) === 121) return (0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $acc489014c5872c4$export$39dfd62a25e0fe93)) + value;
            break;
        // display: (flex|inline-flex|grid|inline-grid)
        case 6444:
            switch((0, $e562b52475b1e492$export$a9db5e087081082d)(value, (0, $e562b52475b1e492$export$a9db5e087081082d)(value, 14) === 45 ? 18 : 11)){
                // (inline-)?fle(x)
                case 120:
                    return (0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, '$1' + (0, $acc489014c5872c4$export$39dfd62a25e0fe93) + ((0, $e562b52475b1e492$export$a9db5e087081082d)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $acc489014c5872c4$export$39dfd62a25e0fe93) + '$2$3' + '$1' + (0, $acc489014c5872c4$export$71ad59f2e432cfe8) + '$2box$3') + value;
                // (inline-)?gri(d)
                case 100:
                    return (0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $acc489014c5872c4$export$71ad59f2e432cfe8)) + value;
            }
            break;
        // scroll-margin, scroll-margin-(top|right|bottom|left)
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return (0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)(value, 'scroll-', 'scroll-snap-') + value;
    }
    return value;
}


function $9a3fa8006b78417a$export$5a7767152ae0305f(collection) {
    var length = (0, $e562b52475b1e492$export$f9084667e487ed46)(collection);
    return function(element, index, children, callback) {
        var output = '';
        for(var i = 0; i < length; i++)output += collection[i](element, index, children, callback) || '';
        return output;
    };
}
function $9a3fa8006b78417a$export$38bcb760f1d4871c(callback) {
    return function(element) {
        if (!element.root) {
            if (element = element.return) callback(element);
        }
    };
}
function $9a3fa8006b78417a$export$e08c7d021b829b7a(element, index, children, callback) {
    if (element.length > -1) {
        if (!element.return) switch(element.type){
            case 0, $acc489014c5872c4$export$527d108ccf083c2b:
                element.return = (0, $847aec06bd93db01$export$82e9f45cca5ba907)(element.value, element.length, children);
                return;
            case 0, $acc489014c5872c4$export$b44a8529a35fcb60:
                return (0, $82be013fdc68c24d$export$dfdc1655ccc5b9cb)([
                    (0, $f8c2a28b14853b69$export$784d13d8ee351f07)(element, {
                        value: (0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)(element.value, '@', '@' + (0, $acc489014c5872c4$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $acc489014c5872c4$export$aa3a2e812ca8570d:
                if (element.length) return (0, $e562b52475b1e492$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $e562b52475b1e492$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $82be013fdc68c24d$export$dfdc1655ccc5b9cb)([
                                (0, $f8c2a28b14853b69$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ':' + (0, $acc489014c5872c4$export$2c0f367103c8d01c) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $82be013fdc68c24d$export$dfdc1655ccc5b9cb)([
                                (0, $f8c2a28b14853b69$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $acc489014c5872c4$export$39dfd62a25e0fe93) + 'input-$1')
                                    ]
                                }),
                                (0, $f8c2a28b14853b69$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $acc489014c5872c4$export$2c0f367103c8d01c) + '$1')
                                    ]
                                }),
                                (0, $f8c2a28b14853b69$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $acc489014c5872c4$export$71ad59f2e432cfe8) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
}
function $9a3fa8006b78417a$export$76a88f7de6507443(element) {
    switch(element.type){
        case 0, $acc489014c5872c4$export$aa3a2e812ca8570d:
            element.props = element.props.map(function(value) {
                return (0, $e562b52475b1e492$export$1be1fc439b849fdf)((0, $f8c2a28b14853b69$export$660b2ee2d4fb4eff)(value), function(value, index, children) {
                    switch((0, $e562b52475b1e492$export$a9db5e087081082d)(value, 0)){
                        // \f
                        case 12:
                            return (0, $e562b52475b1e492$export$2f35ab04d2335697)(value, 1, (0, $e562b52475b1e492$export$36776f635604f274)(value));
                        // \0 ( + > ~
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return value;
                        // :
                        case 58:
                            if (children[++index] === 'global') children[index] = '', children[++index] = '\f' + (0, $e562b52475b1e492$export$2f35ab04d2335697)(children[index], index = 1, -1);
                        // \s
                        case 32:
                            return index === 1 ? '' : value;
                        default:
                            switch(index){
                                case 0:
                                    element = value;
                                    return (0, $e562b52475b1e492$export$f9084667e487ed46)(children) > 1 ? '' : value;
                                case index = (0, $e562b52475b1e492$export$f9084667e487ed46)(children) - 1:
                                case 2:
                                    return index === 2 ? value + element + element : value + element;
                                default:
                                    return value;
                            }
                    }
                });
            });
    }
}


var $bb5bbcb52531674b$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};


function $efa66df610ae0ce8$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $1c8035d6c52d1652$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $f8c2a28b14853b69$export$4d3fb11e950abb9e)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $f8c2a28b14853b69$export$9e1725a4cfeada27)(character)) break;
        (0, $f8c2a28b14853b69$export$48cfd1e771a65c4f)();
    }
    return (0, $f8c2a28b14853b69$export$58adb3bec8346d0f)(begin, (0, $f8c2a28b14853b69$export$5880b8b5730aff45));
};
var $1c8035d6c52d1652$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $f8c2a28b14853b69$export$9e1725a4cfeada27)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $f8c2a28b14853b69$export$4d3fb11e950abb9e)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $1c8035d6c52d1652$var$identifierWithPointTracking((0, $f8c2a28b14853b69$export$5880b8b5730aff45) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $f8c2a28b14853b69$export$410ac95b9ec204b8)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $f8c2a28b14853b69$export$4d3fb11e950abb9e)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $e562b52475b1e492$export$6788812c4e6611e6)(character);
    }
    while (character = (0, $f8c2a28b14853b69$export$48cfd1e771a65c4f)());
    return parsed;
};
var $1c8035d6c52d1652$var$getRules = function getRules(value, points) {
    return (0, $f8c2a28b14853b69$export$45918ac1574455b1)($1c8035d6c52d1652$var$toRules((0, $f8c2a28b14853b69$export$2de70f21292aac9e)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $1c8035d6c52d1652$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $1c8035d6c52d1652$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$1c8035d6c52d1652$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $1c8035d6c52d1652$var$fixedElements.set(element, true);
    var points = [];
    var rules = $1c8035d6c52d1652$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $1c8035d6c52d1652$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $1c8035d6c52d1652$var$prefix(value, length) {
    switch((0, $e562b52475b1e492$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $acc489014c5872c4$export$39dfd62a25e0fe93) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $acc489014c5872c4$export$39dfd62a25e0fe93) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $acc489014c5872c4$export$39dfd62a25e0fe93) + value + (0, $acc489014c5872c4$export$2c0f367103c8d01c) + value + (0, $acc489014c5872c4$export$71ad59f2e432cfe8) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $acc489014c5872c4$export$39dfd62a25e0fe93) + value + (0, $acc489014c5872c4$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $acc489014c5872c4$export$39dfd62a25e0fe93) + value + (0, $acc489014c5872c4$export$71ad59f2e432cfe8) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $acc489014c5872c4$export$39dfd62a25e0fe93) + value + (0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $acc489014c5872c4$export$39dfd62a25e0fe93) + 'box-$1$2' + (0, $acc489014c5872c4$export$71ad59f2e432cfe8) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $acc489014c5872c4$export$39dfd62a25e0fe93) + value + (0, $acc489014c5872c4$export$71ad59f2e432cfe8) + 'flex-item-' + (0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $acc489014c5872c4$export$39dfd62a25e0fe93) + value + (0, $acc489014c5872c4$export$71ad59f2e432cfe8) + 'flex-line-pack' + (0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $acc489014c5872c4$export$39dfd62a25e0fe93) + value + (0, $acc489014c5872c4$export$71ad59f2e432cfe8) + (0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $acc489014c5872c4$export$39dfd62a25e0fe93) + value + (0, $acc489014c5872c4$export$71ad59f2e432cfe8) + (0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $acc489014c5872c4$export$39dfd62a25e0fe93) + 'box-' + (0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)(value, '-grow', '') + (0, $acc489014c5872c4$export$39dfd62a25e0fe93) + value + (0, $acc489014c5872c4$export$71ad59f2e432cfe8) + (0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $acc489014c5872c4$export$39dfd62a25e0fe93) + (0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, '$1' + (0, $acc489014c5872c4$export$39dfd62a25e0fe93) + '$2') + value;
        // cursor
        case 6187:
            return (0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)((0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)((0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $acc489014c5872c4$export$39dfd62a25e0fe93) + '$1'), /(image-set)/, (0, $acc489014c5872c4$export$39dfd62a25e0fe93) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $acc489014c5872c4$export$39dfd62a25e0fe93) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)((0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $acc489014c5872c4$export$39dfd62a25e0fe93) + 'box-pack:$3' + (0, $acc489014c5872c4$export$71ad59f2e432cfe8) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $acc489014c5872c4$export$39dfd62a25e0fe93) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $acc489014c5872c4$export$39dfd62a25e0fe93) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $e562b52475b1e492$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $e562b52475b1e492$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $e562b52475b1e492$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $acc489014c5872c4$export$39dfd62a25e0fe93) + '$2-$3' + '$1' + (0, $acc489014c5872c4$export$2c0f367103c8d01c) + ((0, $e562b52475b1e492$export$a9db5e087081082d)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $e562b52475b1e492$export$f8e21b1e77979a08)(value, 'stretch') ? $1c8035d6c52d1652$var$prefix((0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $e562b52475b1e492$export$a9db5e087081082d)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $e562b52475b1e492$export$a9db5e087081082d)(value, (0, $e562b52475b1e492$export$36776f635604f274)(value) - 3 - (~(0, $e562b52475b1e492$export$f8e21b1e77979a08)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $acc489014c5872c4$export$39dfd62a25e0fe93)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $acc489014c5872c4$export$39dfd62a25e0fe93) + ((0, $e562b52475b1e492$export$a9db5e087081082d)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $acc489014c5872c4$export$39dfd62a25e0fe93) + '$2$3' + '$1' + (0, $acc489014c5872c4$export$71ad59f2e432cfe8) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $e562b52475b1e492$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $acc489014c5872c4$export$39dfd62a25e0fe93) + value + (0, $acc489014c5872c4$export$71ad59f2e432cfe8) + (0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $acc489014c5872c4$export$39dfd62a25e0fe93) + value + (0, $acc489014c5872c4$export$71ad59f2e432cfe8) + (0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $acc489014c5872c4$export$39dfd62a25e0fe93) + value + (0, $acc489014c5872c4$export$71ad59f2e432cfe8) + (0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $acc489014c5872c4$export$39dfd62a25e0fe93) + value + (0, $acc489014c5872c4$export$71ad59f2e432cfe8) + value + value;
    }
    return value;
}
var $1c8035d6c52d1652$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $acc489014c5872c4$export$527d108ccf083c2b:
                element["return"] = $1c8035d6c52d1652$var$prefix(element.value, element.length);
                break;
            case 0, $acc489014c5872c4$export$b44a8529a35fcb60:
                return (0, $82be013fdc68c24d$export$dfdc1655ccc5b9cb)([
                    (0, $f8c2a28b14853b69$export$784d13d8ee351f07)(element, {
                        value: (0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)(element.value, '@', '@' + (0, $acc489014c5872c4$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $acc489014c5872c4$export$aa3a2e812ca8570d:
                if (element.length) return (0, $e562b52475b1e492$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $e562b52475b1e492$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $82be013fdc68c24d$export$dfdc1655ccc5b9cb)([
                                (0, $f8c2a28b14853b69$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ':' + (0, $acc489014c5872c4$export$2c0f367103c8d01c) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $82be013fdc68c24d$export$dfdc1655ccc5b9cb)([
                                (0, $f8c2a28b14853b69$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $acc489014c5872c4$export$39dfd62a25e0fe93) + 'input-$1')
                                    ]
                                }),
                                (0, $f8c2a28b14853b69$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $acc489014c5872c4$export$2c0f367103c8d01c) + '$1')
                                    ]
                                }),
                                (0, $f8c2a28b14853b69$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $e562b52475b1e492$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $acc489014c5872c4$export$71ad59f2e432cfe8) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $1c8035d6c52d1652$var$defaultStylisPlugins = [
    $1c8035d6c52d1652$var$prefixer
];
var $1c8035d6c52d1652$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $1c8035d6c52d1652$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
        var attrib = node.getAttribute("data-emotion").split(' ');
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $1c8035d6c52d1652$var$compat,
        $1c8035d6c52d1652$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $82be013fdc68c24d$export$fac44ee5b035f737),
        (0, $9a3fa8006b78417a$export$38bcb760f1d4871c)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $9a3fa8006b78417a$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $82be013fdc68c24d$export$dfdc1655ccc5b9cb)((0, $6859efbb8a2fab01$export$ef7acd7185315e22)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $c643e5ed062df6b9$export$9d753cd7ae895cce)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};


function $1fcc864778fe3a17$export$2e2bcd8739ae039() {
    return $1fcc864778fe3a17$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1fcc864778fe3a17$export$2e2bcd8739ae039.apply(null, arguments);
}




var $1NGjT = parcelRequire("1NGjT");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $091a16fe69851125$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($1NGjT)))(targetComponent, sourceComponent);
};


var $ec8233c4b7481c30$var$isBrowser = true;
function $ec8233c4b7481c30$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $ec8233c4b7481c30$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $ec8233c4b7481c30$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $ec8233c4b7481c30$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $ec8233c4b7481c30$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};


/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $f69c5d9c4592a0a7$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}


var $fefc3fb3701da7c9$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};



var $45627b3f8cf327d3$var$isDevelopment = false;
var $45627b3f8cf327d3$var$hyphenateRegex = /[A-Z]|^ms/g;
var $45627b3f8cf327d3$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $45627b3f8cf327d3$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $45627b3f8cf327d3$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $45627b3f8cf327d3$var$processStyleName = /* #__PURE__ */ (0, $efa66df610ae0ce8$export$2e2bcd8739ae039)(function(styleName) {
    return $45627b3f8cf327d3$var$isCustomProperty(styleName) ? styleName : styleName.replace($45627b3f8cf327d3$var$hyphenateRegex, '-$&').toLowerCase();
});
var $45627b3f8cf327d3$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($45627b3f8cf327d3$var$animationRegex, function(match, p1, p2) {
                $45627b3f8cf327d3$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $45627b3f8cf327d3$var$cursor
                };
                return p1;
            });
    }
    if ((0, $fefc3fb3701da7c9$export$2e2bcd8739ae039)[key] !== 1 && !$45627b3f8cf327d3$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $45627b3f8cf327d3$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $45627b3f8cf327d3$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $45627b3f8cf327d3$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $45627b3f8cf327d3$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $45627b3f8cf327d3$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $45627b3f8cf327d3$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $45627b3f8cf327d3$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $45627b3f8cf327d3$var$cursor;
                var result = interpolation(mergedProps);
                $45627b3f8cf327d3$var$cursor = previousCursor;
                return $45627b3f8cf327d3$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $45627b3f8cf327d3$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $45627b3f8cf327d3$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($45627b3f8cf327d3$var$isProcessableValue(asString)) string += $45627b3f8cf327d3$var$processStyleName(key) + ":" + $45627b3f8cf327d3$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $45627b3f8cf327d3$var$isDevelopment) throw new Error($45627b3f8cf327d3$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($45627b3f8cf327d3$var$isProcessableValue(value[_i])) string += $45627b3f8cf327d3$var$processStyleName(key) + ":" + $45627b3f8cf327d3$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $45627b3f8cf327d3$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $45627b3f8cf327d3$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $45627b3f8cf327d3$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $45627b3f8cf327d3$var$cursor;
function $45627b3f8cf327d3$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $45627b3f8cf327d3$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $45627b3f8cf327d3$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $45627b3f8cf327d3$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $45627b3f8cf327d3$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $45627b3f8cf327d3$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $f69c5d9c4592a0a7$export$2e2bcd8739ae039)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $45627b3f8cf327d3$var$cursor
    };
}



var $8v0nu = parcelRequire("8v0nu");
var $1b33946bd210aca0$var$syncFallback = function syncFallback(create) {
    return create();
};
var $1b33946bd210aca0$var$useInsertionEffect = $8v0nu.useInsertionEffect ? $8v0nu.useInsertionEffect : false;
var $1b33946bd210aca0$export$db21c7ffa21794e7 = $1b33946bd210aca0$var$useInsertionEffect || $1b33946bd210aca0$var$syncFallback;
var $1b33946bd210aca0$export$811a713a7276cb9d = $1b33946bd210aca0$var$useInsertionEffect || $8v0nu.useLayoutEffect;


var $a2100d053ea71e0f$export$23f2a1d2818174ef = false;
var $a2100d053ea71e0f$var$EmotionCacheContext = /* #__PURE__ */ $8v0nu.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $1c8035d6c52d1652$export$2e2bcd8739ae039)({
    key: 'css'
}) : null);
var $a2100d053ea71e0f$export$e7094788287c5e9b = $a2100d053ea71e0f$var$EmotionCacheContext.Provider;
var $a2100d053ea71e0f$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $8v0nu.useContext)($a2100d053ea71e0f$var$EmotionCacheContext);
};
var $a2100d053ea71e0f$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $8v0nu.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $8v0nu.useContext)($a2100d053ea71e0f$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
var $a2100d053ea71e0f$export$971d5caa766a69d7 = /* #__PURE__ */ $8v0nu.createContext({});
var $a2100d053ea71e0f$export$3b14a55fb2447963 = function useTheme() {
    return $8v0nu.useContext($a2100d053ea71e0f$export$971d5caa766a69d7);
};
var $a2100d053ea71e0f$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({}, outerTheme, theme);
};
var $a2100d053ea71e0f$var$createCacheWithTheme = /* #__PURE__ */ (0, $bb5bbcb52531674b$export$2e2bcd8739ae039)(function(outerTheme) {
    return (0, $bb5bbcb52531674b$export$2e2bcd8739ae039)(function(theme) {
        return $a2100d053ea71e0f$var$getTheme(outerTheme, theme);
    });
});
var $a2100d053ea71e0f$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $8v0nu.useContext($a2100d053ea71e0f$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $a2100d053ea71e0f$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $8v0nu.createElement($a2100d053ea71e0f$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $a2100d053ea71e0f$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $8v0nu.forwardRef(function render(props, ref) {
        var theme = $8v0nu.useContext($a2100d053ea71e0f$export$971d5caa766a69d7);
        return /*#__PURE__*/ $8v0nu.createElement(Component, (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $091a16fe69851125$export$2e2bcd8739ae039)(WithTheme, Component);
}
var $a2100d053ea71e0f$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $a2100d053ea71e0f$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $a2100d053ea71e0f$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($a2100d053ea71e0f$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$a2100d053ea71e0f$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $a2100d053ea71e0f$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $ec8233c4b7481c30$export$580009a5da2a8b4b)(cache, serialized, isStringTag);
    (0, $1b33946bd210aca0$export$db21c7ffa21794e7)(function() {
        return (0, $ec8233c4b7481c30$export$6f077d94b33a01aa)(cache, serialized, isStringTag);
    });
    return null;
};
var $a2100d053ea71e0f$var$Emotion = /* #__PURE__ */ $a2100d053ea71e0f$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$a2100d053ea71e0f$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $ec8233c4b7481c30$export$95d99596f328fd52)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $45627b3f8cf327d3$export$6321afa313b251b5)(registeredStyles, undefined, $8v0nu.useContext($a2100d053ea71e0f$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($a2100d053ea71e0f$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $a2100d053ea71e0f$var$typePropName && !$a2100d053ea71e0f$export$23f2a1d2818174ef) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $8v0nu.createElement($8v0nu.Fragment, null, /*#__PURE__*/ $8v0nu.createElement($a2100d053ea71e0f$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $8v0nu.createElement(WrappedComponent, newProps));
});
var $a2100d053ea71e0f$export$a9c23c6ac3fc3eca = $a2100d053ea71e0f$var$Emotion;



var $8v0nu = parcelRequire("8v0nu");







parcelRequire("1NGjT");
var $4968c539ba80adb3$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $a2100d053ea71e0f$export$dda1d9f60106f0e9).call(props, 'css')) return $8v0nu.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $a2100d053ea71e0f$export$a9c23c6ac3fc3eca);
    createElementArgArray[1] = (0, $a2100d053ea71e0f$export$db3b6bfb95261072)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $8v0nu.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($4968c539ba80adb3$export$c8a8987d4410bf2d || ($4968c539ba80adb3$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $4968c539ba80adb3$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $a2100d053ea71e0f$export$efccba1c4a2ef57b)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $45627b3f8cf327d3$export$6321afa313b251b5)([
        styles
    ], undefined, $8v0nu.useContext((0, $a2100d053ea71e0f$export$971d5caa766a69d7)));
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $8v0nu.useRef();
    (0, $1b33946bd210aca0$export$811a713a7276cb9d)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $1b33946bd210aca0$export$811a713a7276cb9d)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $ec8233c4b7481c30$export$6f077d94b33a01aa)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $4968c539ba80adb3$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $45627b3f8cf327d3$export$6321afa313b251b5)(args);
}
function $4968c539ba80adb3$export$d25ddfdf17c3ad3e() {
    var insertable = $4968c539ba80adb3$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $4968c539ba80adb3$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $4968c539ba80adb3$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $ec8233c4b7481c30$export$95d99596f328fd52)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $4968c539ba80adb3$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $1b33946bd210aca0$export$db21c7ffa21794e7)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $ec8233c4b7481c30$export$6f077d94b33a01aa)(cache, serializedArr[i], false);
    });
    return null;
};
var $4968c539ba80adb3$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $a2100d053ea71e0f$export$efccba1c4a2ef57b)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $a2100d053ea71e0f$export$23f2a1d2818174ef)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $45627b3f8cf327d3$export$6321afa313b251b5)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $ec8233c4b7481c30$export$580009a5da2a8b4b)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $a2100d053ea71e0f$export$23f2a1d2818174ef)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $4968c539ba80adb3$var$merge(cache.registered, css, $4968c539ba80adb3$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $8v0nu.useContext((0, $a2100d053ea71e0f$export$971d5caa766a69d7))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $8v0nu.createElement($8v0nu.Fragment, null, /*#__PURE__*/ $8v0nu.createElement($4968c539ba80adb3$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});



var $8v0nu = parcelRequire("8v0nu");
"use strict";
"use client";
function $542c4e2ea7b8b6b9$var$getErrorMessage(hook, provider) {
    return `${hook} returned \`undefined\`. Seems you forgot to wrap component within ${provider}`;
}
function $542c4e2ea7b8b6b9$export$fd42f52fd3ae1109(options = {}) {
    const { name: name, strict: strict = true, hookName: hookName = "useContext", providerName: providerName = "Provider", errorMessage: errorMessage, defaultValue: defaultValue } = options;
    const Context = (0, $8v0nu.createContext)(defaultValue);
    Context.displayName = name;
    function useContext$1() {
        const context = (0, $8v0nu.useContext)(Context);
        if (!context && strict) {
            const error = new Error(errorMessage ?? $542c4e2ea7b8b6b9$var$getErrorMessage(hookName, providerName));
            error.name = "ContextError";
            Error.captureStackTrace?.(error, useContext$1);
            throw error;
        }
        return context;
    }
    return [
        Context.Provider,
        useContext$1,
        Context
    ];
}


"use strict";
"use client";
const [$771f18fb4c7e08d8$var$ChakraContextProvider, $771f18fb4c7e08d8$export$e4f18fbc74d20572] = (0, $542c4e2ea7b8b6b9$export$fd42f52fd3ae1109)({
    name: "ChakraContext",
    strict: true,
    providerName: "<ChakraProvider />"
});
function $771f18fb4c7e08d8$export$80dbe0482bcbd25a(props) {
    const { value: sys, children: children } = props;
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsxs)($771f18fb4c7e08d8$var$ChakraContextProvider, {
        value: sys,
        children: [
            !sys._config.disableLayers && /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $4968c539ba80adb3$export$98f03c5d19621d70), {
                styles: sys.layers.atRule
            }),
            /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $4968c539ba80adb3$export$98f03c5d19621d70), {
                styles: sys._global
            }),
            children
        ]
    });
}



var $8v0nu = parcelRequire("8v0nu");
// src/queryClient.ts
// src/utils.ts
// src/timeoutManager.ts
var $ac05d08220c5256b$export$d235812f9125bf47 = {
    // We need the wrapper function syntax below instead of direct references to
    // global setTimeout etc.
    //
    // BAD: `setTimeout: setTimeout`
    // GOOD: `setTimeout: (cb, delay) => setTimeout(cb, delay)`
    //
    // If we use direct references here, then anything that wants to spy on or
    // replace the global setTimeout (like tests) won't work since we'll already
    // have a hard reference to the original implementation at the time when this
    // file was imported.
    setTimeout: (callback, delay)=>setTimeout(callback, delay),
    clearTimeout: (timeoutId)=>clearTimeout(timeoutId),
    setInterval: (callback, delay)=>setInterval(callback, delay),
    clearInterval: (intervalId)=>clearInterval(intervalId)
};
var $ac05d08220c5256b$export$6336d90323f0ab52 = class {
    // We cannot have TimeoutManager<T> as we must instantiate it with a concrete
    // type at app boot; and if we leave that type, then any new timer provider
    // would need to support the default provider's concrete timer ID, which is
    // infeasible across environments.
    //
    // We settle for type safety for the TimeoutProvider type, and accept that
    // this class is unsafe internally to allow for extension.
    #provider = $ac05d08220c5256b$export$d235812f9125bf47;
    #providerCalled = false;
    setTimeoutProvider(provider) {
        this.#provider = provider;
    }
    setTimeout(callback, delay) {
        return this.#provider.setTimeout(callback, delay);
    }
    clearTimeout(timeoutId) {
        this.#provider.clearTimeout(timeoutId);
    }
    setInterval(callback, delay) {
        return this.#provider.setInterval(callback, delay);
    }
    clearInterval(intervalId) {
        this.#provider.clearInterval(intervalId);
    }
};
var $ac05d08220c5256b$export$94a2700736e69372 = new $ac05d08220c5256b$export$6336d90323f0ab52();
function $ac05d08220c5256b$export$5086591e51e32a18(callback) {
    setTimeout(callback, 0);
}


var $5aa1eeceeb4e99eb$export$6acf61af03e62db = typeof window === "undefined" || "Deno" in globalThis;
function $5aa1eeceeb4e99eb$export$8793edee2d425525() {}
function $5aa1eeceeb4e99eb$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function $5aa1eeceeb4e99eb$export$e539f754e934e270(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function $5aa1eeceeb4e99eb$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $5aa1eeceeb4e99eb$export$cb3145f011bda3ac(staleTime, query) {
    return typeof staleTime === "function" ? staleTime(query) : staleTime;
}
function $5aa1eeceeb4e99eb$export$d7ee3961208f79c1(option, query) {
    return typeof option === "function" ? option(query) : option;
}
function $5aa1eeceeb4e99eb$export$c5d1efe363797780(filters, query) {
    const { type: type = "all", exact: exact, fetchStatus: fetchStatus, predicate: predicate, queryKey: queryKey, stale: stale } = filters;
    if (queryKey) {
        if (exact) {
            if (query.queryHash !== $5aa1eeceeb4e99eb$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$5aa1eeceeb4e99eb$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== "all") {
        const isActive = query.isActive();
        if (type === "active" && !isActive) return false;
        if (type === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (fetchStatus && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $5aa1eeceeb4e99eb$export$a1ea5fb559f63ae3(filters, mutation) {
    const { exact: exact, status: status, predicate: predicate, mutationKey: mutationKey } = filters;
    if (mutationKey) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($5aa1eeceeb4e99eb$export$1e87d19d4aab5805(mutation.options.mutationKey) !== $5aa1eeceeb4e99eb$export$1e87d19d4aab5805(mutationKey)) return false;
        } else if (!$5aa1eeceeb4e99eb$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (status && mutation.state.status !== status) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $5aa1eeceeb4e99eb$export$cc90ca97bc0d73fd(queryKey, options) {
    const hashFn = options?.queryKeyHashFn || $5aa1eeceeb4e99eb$export$1e87d19d4aab5805;
    return hashFn(queryKey);
}
function $5aa1eeceeb4e99eb$export$1e87d19d4aab5805(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>$5aa1eeceeb4e99eb$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
function $5aa1eeceeb4e99eb$export$2f07189bb9fa26a7(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") return Object.keys(b).every((key)=>$5aa1eeceeb4e99eb$export$2f07189bb9fa26a7(a[key], b[key]));
    return false;
}
var $5aa1eeceeb4e99eb$var$hasOwn = Object.prototype.hasOwnProperty;
function $5aa1eeceeb4e99eb$export$77a71fc411098696(a, b, depth = 0) {
    if (a === b) return a;
    if (depth > 500) return b;
    const array = $5aa1eeceeb4e99eb$export$7a8558113332b71e(a) && $5aa1eeceeb4e99eb$export$7a8558113332b71e(b);
    if (!array && !($5aa1eeceeb4e99eb$export$53b83ca8eaab0383(a) && $5aa1eeceeb4e99eb$export$53b83ca8eaab0383(b))) return b;
    const aItems = array ? a : Object.keys(a);
    const aSize = aItems.length;
    const bItems = array ? b : Object.keys(b);
    const bSize = bItems.length;
    const copy = array ? new Array(bSize) : {};
    let equalItems = 0;
    for(let i = 0; i < bSize; i++){
        const key = array ? i : bItems[i];
        const aItem = a[key];
        const bItem = b[key];
        if (aItem === bItem) {
            copy[key] = aItem;
            if (array ? i < aSize : $5aa1eeceeb4e99eb$var$hasOwn.call(a, key)) equalItems++;
            continue;
        }
        if (aItem === null || bItem === null || typeof aItem !== "object" || typeof bItem !== "object") {
            copy[key] = bItem;
            continue;
        }
        const v = $5aa1eeceeb4e99eb$export$77a71fc411098696(aItem, bItem, depth + 1);
        copy[key] = v;
        if (v === aItem) equalItems++;
    }
    return aSize === bSize && equalItems === aSize ? a : copy;
}
function $5aa1eeceeb4e99eb$export$3e67810a3f0e9f1c(a, b) {
    if (!b || Object.keys(a).length !== Object.keys(b).length) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $5aa1eeceeb4e99eb$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
}
function $5aa1eeceeb4e99eb$export$53b83ca8eaab0383(o) {
    if (!$5aa1eeceeb4e99eb$var$hasObjectPrototype(o)) return false;
    const ctor = o.constructor;
    if (ctor === void 0) return true;
    const prot = ctor.prototype;
    if (!$5aa1eeceeb4e99eb$var$hasObjectPrototype(prot)) return false;
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
    if (Object.getPrototypeOf(o) !== Object.prototype) return false;
    return true;
}
function $5aa1eeceeb4e99eb$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $5aa1eeceeb4e99eb$export$e772c8ff12451969(timeout) {
    return new Promise((resolve)=>{
        (0, $ac05d08220c5256b$export$94a2700736e69372).setTimeout(resolve, timeout);
    });
}
function $5aa1eeceeb4e99eb$export$17619bac5b909b23(prevData, data, options) {
    if (typeof options.structuralSharing === "function") return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) {
        var error;
        return $5aa1eeceeb4e99eb$export$77a71fc411098696(prevData, data);
    }
    return data;
}
function $5aa1eeceeb4e99eb$export$f537417e7e421eac(previousData) {
    return previousData;
}
function $5aa1eeceeb4e99eb$export$ccce65a22a26f2bc(items, item, max = 0) {
    const newItems = [
        ...items,
        item
    ];
    return max && newItems.length > max ? newItems.slice(1) : newItems;
}
function $5aa1eeceeb4e99eb$export$8c6246b73dd61f4a(items, item, max = 0) {
    const newItems = [
        item,
        ...items
    ];
    return max && newItems.length > max ? newItems.slice(0, -1) : newItems;
}
var $5aa1eeceeb4e99eb$export$1aa5a89531b7670d = /* @__PURE__ */ Symbol();
function $5aa1eeceeb4e99eb$export$c71c44209368a3bc(options, fetchOptions) {
    if (!options.queryFn && fetchOptions?.initialPromise) return ()=>fetchOptions.initialPromise;
    if (!options.queryFn || options.queryFn === $5aa1eeceeb4e99eb$export$1aa5a89531b7670d) return ()=>Promise.reject(new Error(`Missing queryFn: '${options.queryHash}'`));
    return options.queryFn;
}
function $5aa1eeceeb4e99eb$export$2072f68e6c3507cf(throwOnError, params) {
    if (typeof throwOnError === "function") return throwOnError(...params);
    return !!throwOnError;
}
function $5aa1eeceeb4e99eb$export$83f813cd1f8a4973(object, getSignal, onCancelled) {
    let consumed = false;
    let signal;
    Object.defineProperty(object, "signal", {
        enumerable: true,
        get: ()=>{
            signal ??= getSignal();
            if (consumed) return signal;
            consumed = true;
            if (signal.aborted) onCancelled();
            else signal.addEventListener("abort", onCancelled, {
                once: true
            });
            return signal;
        }
    });
    return object;
}


// src/queryCache.ts

// src/query.ts

// src/notifyManager.ts

var $6b738da3f846af52$export$7c76da44185e6090 = (0, $ac05d08220c5256b$export$5086591e51e32a18);
function $6b738da3f846af52$export$316a8efd03cd1458() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    let scheduleFn = $6b738da3f846af52$export$7c76da44185e6090;
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else scheduleFn(()=>{
            notifyFn(callback);
        });
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) scheduleFn(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    return {
        batch: (callback)=>{
            let result;
            transactions++;
            try {
                result = callback();
            } finally{
                transactions--;
                if (!transactions) flush();
            }
            return result;
        },
        /**
     * All calls to the wrapped function will be batched.
     */ batchCalls: (callback)=>{
            return (...args)=>{
                schedule(()=>{
                    callback(...args);
                });
            };
        },
        schedule: schedule,
        /**
     * Use this method to set a custom notify function.
     * This can be used to for example wrap notifications with `React.act` while running tests.
     */ setNotifyFunction: (fn)=>{
            notifyFn = fn;
        },
        /**
     * Use this method to set a custom function to batch notifications together into a single tick.
     * By default React Query will use the batch function provided by ReactDOM or React Native.
     */ setBatchNotifyFunction: (fn)=>{
            batchNotifyFn = fn;
        },
        setScheduler: (fn)=>{
            scheduleFn = fn;
        }
    };
}
var $6b738da3f846af52$export$520687f44db6e1ab = $6b738da3f846af52$export$316a8efd03cd1458();


// src/retryer.ts
// src/focusManager.ts
// src/subscribable.ts
var $7bdf67e33108b654$export$d26086b469ecdbcc = class {
    constructor(){
        this.listeners = /* @__PURE__ */ new Set();
        this.subscribe = this.subscribe.bind(this);
    }
    subscribe(listener) {
        this.listeners.add(listener);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(listener);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
};


var $0f3813798503d4aa$export$86f1af424b2ca4de = class extends (0, $7bdf67e33108b654$export$d26086b469ecdbcc) {
    #focused;
    #cleanup;
    #setup;
    constructor(){
        super();
        this.#setup = (onFocus)=>{
            if (typeof window !== "undefined" && window.addEventListener) {
                const listener = ()=>onFocus();
                window.addEventListener("visibilitychange", listener, false);
                return ()=>{
                    window.removeEventListener("visibilitychange", listener);
                };
            }
            return;
        };
    }
    onSubscribe() {
        if (!this.#cleanup) this.setEventListener(this.#setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            this.#cleanup?.();
            this.#cleanup = void 0;
        }
    }
    setEventListener(setup) {
        this.#setup = setup;
        this.#cleanup?.();
        this.#cleanup = setup((focused)=>{
            if (typeof focused === "boolean") this.setFocused(focused);
            else this.onFocus();
        });
    }
    setFocused(focused) {
        const changed = this.#focused !== focused;
        if (changed) {
            this.#focused = focused;
            this.onFocus();
        }
    }
    onFocus() {
        const isFocused = this.isFocused();
        this.listeners.forEach((listener)=>{
            listener(isFocused);
        });
    }
    isFocused() {
        if (typeof this.#focused === "boolean") return this.#focused;
        return globalThis.document?.visibilityState !== "hidden";
    }
};
var $0f3813798503d4aa$export$6bf54661be5b02cf = new $0f3813798503d4aa$export$86f1af424b2ca4de();


// src/onlineManager.ts

var $5f59bf8b0f5af6bd$export$58774fb55d5ff7fc = class extends (0, $7bdf67e33108b654$export$d26086b469ecdbcc) {
    #online = true;
    #cleanup;
    #setup;
    constructor(){
        super();
        this.#setup = (onOnline)=>{
            if (typeof window !== "undefined" && window.addEventListener) {
                const onlineListener = ()=>onOnline(true);
                const offlineListener = ()=>onOnline(false);
                window.addEventListener("online", onlineListener, false);
                window.addEventListener("offline", offlineListener, false);
                return ()=>{
                    window.removeEventListener("online", onlineListener);
                    window.removeEventListener("offline", offlineListener);
                };
            }
            return;
        };
    }
    onSubscribe() {
        if (!this.#cleanup) this.setEventListener(this.#setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            this.#cleanup?.();
            this.#cleanup = void 0;
        }
    }
    setEventListener(setup) {
        this.#setup = setup;
        this.#cleanup?.();
        this.#cleanup = setup(this.setOnline.bind(this));
    }
    setOnline(online) {
        const changed = this.#online !== online;
        if (changed) {
            this.#online = online;
            this.listeners.forEach((listener)=>{
                listener(online);
            });
        }
    }
    isOnline() {
        return this.#online;
    }
};
var $5f59bf8b0f5af6bd$export$b113e788b2dd3fdc = new $5f59bf8b0f5af6bd$export$58774fb55d5ff7fc();


// src/thenable.ts

function $7b67638c91bd60df$export$d54630db02a12b72() {
    let resolve;
    let reject;
    const thenable = new Promise((_resolve, _reject)=>{
        resolve = _resolve;
        reject = _reject;
    });
    thenable.status = "pending";
    thenable.catch(()=>{});
    function finalize(data) {
        Object.assign(thenable, data);
        delete thenable.resolve;
        delete thenable.reject;
    }
    thenable.resolve = (value)=>{
        finalize({
            status: "fulfilled",
            value: value
        });
        resolve(value);
    };
    thenable.reject = (reason)=>{
        finalize({
            status: "rejected",
            reason: reason
        });
        reject(reason);
    };
    return thenable;
}
function $7b67638c91bd60df$export$216296c47a9d1275(promise) {
    let data;
    promise.then((result)=>{
        data = result;
        return result;
    }, (0, $5aa1eeceeb4e99eb$export$8793edee2d425525))?.catch((0, $5aa1eeceeb4e99eb$export$8793edee2d425525));
    if (data !== void 0) return {
        data: data
    };
    return void 0;
}


// src/environmentManager.ts

var $6cf3367ecf2ce011$export$2d935f1a9c9d3f3e = /* @__PURE__ */ (()=>{
    let isServerFn = ()=>(0, $5aa1eeceeb4e99eb$export$6acf61af03e62db);
    return {
        /**
     * Returns whether the current runtime should be treated as a server environment.
     */ isServer () {
            return isServerFn();
        },
        /**
     * Overrides the server check globally.
     */ setIsServer (isServerValue) {
            isServerFn = isServerValue;
        }
    };
})();



function $06ece8b5ad95e805$var$defaultRetryDelay(failureCount) {
    return Math.min(1e3 * 2 ** failureCount, 3e4);
}
function $06ece8b5ad95e805$export$61b92f63f30245cf(networkMode) {
    return (networkMode ?? "online") === "online" ? (0, $5f59bf8b0f5af6bd$export$b113e788b2dd3fdc).isOnline() : true;
}
var $06ece8b5ad95e805$export$a8430ed4188f35a9 = class extends Error {
    constructor(options){
        super("CancelledError");
        this.revert = options?.revert;
        this.silent = options?.silent;
    }
};
function $06ece8b5ad95e805$export$986cc6445c1d323(value) {
    return value instanceof $06ece8b5ad95e805$export$a8430ed4188f35a9;
}
function $06ece8b5ad95e805$export$2cbd00fe8a2c8d85(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let continueFn;
    const thenable = (0, $7b67638c91bd60df$export$d54630db02a12b72)();
    const isResolved = ()=>thenable.status !== "pending";
    const cancel = (cancelOptions)=>{
        if (!isResolved()) {
            const error = new $06ece8b5ad95e805$export$a8430ed4188f35a9(cancelOptions);
            reject(error);
            config.onCancel?.(error);
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const canContinue = ()=>(0, $0f3813798503d4aa$export$6bf54661be5b02cf).isFocused() && (config.networkMode === "always" || (0, $5f59bf8b0f5af6bd$export$b113e788b2dd3fdc).isOnline()) && config.canRun();
    const canStart = ()=>$06ece8b5ad95e805$export$61b92f63f30245cf(config.networkMode) && config.canRun();
    const resolve = (value)=>{
        if (!isResolved()) {
            continueFn?.();
            thenable.resolve(value);
        }
    };
    const reject = (value)=>{
        if (!isResolved()) {
            continueFn?.();
            thenable.reject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            continueFn = (value)=>{
                if (isResolved() || canContinue()) continueResolve(value);
            };
            config.onPause?.();
        }).then(()=>{
            continueFn = void 0;
            if (!isResolved()) config.onContinue?.();
        });
    };
    const run = ()=>{
        if (isResolved()) return;
        let promiseOrValue;
        const initialPromise = failureCount === 0 ? config.initialPromise : void 0;
        try {
            promiseOrValue = initialPromise ?? config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            if (isResolved()) return;
            const retry = config.retry ?? ((0, $6cf3367ecf2ce011$export$2d935f1a9c9d3f3e).isServer() ? 0 : 3);
            const retryDelay = config.retryDelay ?? $06ece8b5ad95e805$var$defaultRetryDelay;
            const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                reject(error);
                return;
            }
            failureCount++;
            config.onFail?.(failureCount, error);
            (0, $5aa1eeceeb4e99eb$export$e772c8ff12451969)(delay).then(()=>{
                return canContinue() ? void 0 : pause();
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    };
    return {
        promise: thenable,
        status: ()=>thenable.status,
        cancel: cancel,
        continue: ()=>{
            continueFn?.();
            return thenable;
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry,
        canStart: canStart,
        start: ()=>{
            if (canStart()) run();
            else pause().then(run);
            return thenable;
        }
    };
}


// src/removable.ts



var $3778ea23cb7955ac$export$e09608847fcc8c59 = class {
    #gcTimeout;
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, $5aa1eeceeb4e99eb$export$e539f754e934e270)(this.gcTime)) this.#gcTimeout = (0, $ac05d08220c5256b$export$94a2700736e69372).setTimeout(()=>{
            this.optionalRemove();
        }, this.gcTime);
    }
    updateGcTime(newGcTime) {
        this.gcTime = Math.max(this.gcTime || 0, newGcTime ?? ((0, $6cf3367ecf2ce011$export$2d935f1a9c9d3f3e).isServer() ? Infinity : 300000));
    }
    clearGcTimeout() {
        if (this.#gcTimeout !== void 0) {
            (0, $ac05d08220c5256b$export$94a2700736e69372).clearTimeout(this.#gcTimeout);
            this.#gcTimeout = void 0;
        }
    }
};


// src/infiniteQueryBehavior.ts

function $672bfddfaa6d1e25$export$84470d1367601e8d(pages) {
    return {
        onFetch: (context, query)=>{
            const options = context.options;
            const direction = context.fetchOptions?.meta?.fetchMore?.direction;
            const oldPages = context.state.data?.pages || [];
            const oldPageParams = context.state.data?.pageParams || [];
            let result = {
                pages: [],
                pageParams: []
            };
            let currentPage = 0;
            const fetchFn = async ()=>{
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    (0, $5aa1eeceeb4e99eb$export$83f813cd1f8a4973)(object, ()=>context.signal, ()=>cancelled = true);
                };
                const queryFn = (0, $5aa1eeceeb4e99eb$export$c71c44209368a3bc)(context.options, context.fetchOptions);
                const fetchPage = async (data, param, previous)=>{
                    if (cancelled) return Promise.reject(context.signal.reason);
                    if (param == null && data.pages.length) return Promise.resolve(data);
                    const createQueryFnContext = ()=>{
                        const queryFnContext2 = {
                            client: context.client,
                            queryKey: context.queryKey,
                            pageParam: param,
                            direction: previous ? "backward" : "forward",
                            meta: context.options.meta
                        };
                        addSignalProperty(queryFnContext2);
                        return queryFnContext2;
                    };
                    const queryFnContext = createQueryFnContext();
                    const page = await queryFn(queryFnContext);
                    const { maxPages: maxPages } = context.options;
                    const addTo = previous ? (0, $5aa1eeceeb4e99eb$export$8c6246b73dd61f4a) : (0, $5aa1eeceeb4e99eb$export$ccce65a22a26f2bc);
                    return {
                        pages: addTo(data.pages, page, maxPages),
                        pageParams: addTo(data.pageParams, param, maxPages)
                    };
                };
                if (direction && oldPages.length) {
                    const previous = direction === "backward";
                    const pageParamFn = previous ? $672bfddfaa6d1e25$var$getPreviousPageParam : $672bfddfaa6d1e25$var$getNextPageParam;
                    const oldData = {
                        pages: oldPages,
                        pageParams: oldPageParams
                    };
                    const param = pageParamFn(options, oldData);
                    result = await fetchPage(oldData, param, previous);
                } else {
                    const remainingPages = pages ?? oldPages.length;
                    do {
                        const param = currentPage === 0 ? oldPageParams[0] ?? options.initialPageParam : $672bfddfaa6d1e25$var$getNextPageParam(options, result);
                        if (currentPage > 0 && param == null) break;
                        result = await fetchPage(result, param);
                        currentPage++;
                    }while (currentPage < remainingPages);
                }
                return result;
            };
            if (context.options.persister) context.fetchFn = ()=>{
                return context.options.persister?.(fetchFn, {
                    client: context.client,
                    queryKey: context.queryKey,
                    meta: context.options.meta,
                    signal: context.signal
                }, query);
            };
            else context.fetchFn = fetchFn;
        }
    };
}
function $672bfddfaa6d1e25$var$getNextPageParam(options, { pages: pages, pageParams: pageParams }) {
    const lastIndex = pages.length - 1;
    return pages.length > 0 ? options.getNextPageParam(pages[lastIndex], pages, pageParams[lastIndex], pageParams) : void 0;
}
function $672bfddfaa6d1e25$var$getPreviousPageParam(options, { pages: pages, pageParams: pageParams }) {
    return pages.length > 0 ? options.getPreviousPageParam?.(pages[0], pages, pageParams[0], pageParams) : void 0;
}
function $672bfddfaa6d1e25$export$b9c88add8b8b5e6a(options, data) {
    if (!data) return false;
    return $672bfddfaa6d1e25$var$getNextPageParam(options, data) != null;
}
function $672bfddfaa6d1e25$export$db1663b730a8e6e4(options, data) {
    if (!data || !options.getPreviousPageParam) return false;
    return $672bfddfaa6d1e25$var$getPreviousPageParam(options, data) != null;
}


var $be21b923a35a99d9$export$62297b13309008b2 = class extends (0, $3778ea23cb7955ac$export$e09608847fcc8c59) {
    #queryType;
    #initialState;
    #revertState;
    #cache;
    #client;
    #retryer;
    #defaultOptions;
    #abortSignalConsumed;
    constructor(config){
        super();
        this.#abortSignalConsumed = false;
        this.#defaultOptions = config.defaultOptions;
        this.setOptions(config.options);
        this.observers = [];
        this.#client = config.client;
        this.#cache = this.#client.getQueryCache();
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        this.#initialState = $be21b923a35a99d9$var$getDefaultState(this.options);
        this.state = config.state ?? this.#initialState;
        this.scheduleGc();
    }
    get meta() {
        return this.options.meta;
    }
    get queryType() {
        return this.#queryType;
    }
    get promise() {
        return this.#retryer?.promise;
    }
    setOptions(options) {
        this.options = {
            ...this.#defaultOptions,
            ...options
        };
        if (options?._type) this.#queryType = options._type;
        this.updateGcTime(this.options.gcTime);
        if (this.state && this.state.data === void 0) {
            const defaultState = $be21b923a35a99d9$var$getDefaultState(this.options);
            if (defaultState.data !== void 0) {
                this.setState($be21b923a35a99d9$var$successState(defaultState.data, defaultState.dataUpdatedAt));
                this.#initialState = defaultState;
            }
        }
    }
    optionalRemove() {
        if (!this.observers.length && this.state.fetchStatus === "idle") this.#cache.remove(this);
    }
    setData(newData, options) {
        const data = (0, $5aa1eeceeb4e99eb$export$17619bac5b909b23)(this.state.data, newData, this.options);
        this.#dispatch({
            data: data,
            type: "success",
            dataUpdatedAt: options?.updatedAt,
            manual: options?.manual
        });
        return data;
    }
    setState(state) {
        this.#dispatch({
            type: "setState",
            state: state
        });
    }
    cancel(options) {
        const promise = this.#retryer?.promise;
        this.#retryer?.cancel(options);
        return promise ? promise.then((0, $5aa1eeceeb4e99eb$export$8793edee2d425525)).catch((0, $5aa1eeceeb4e99eb$export$8793edee2d425525)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    get resetState() {
        return this.#initialState;
    }
    reset() {
        this.destroy();
        this.setState(this.resetState);
    }
    isActive() {
        return this.observers.some((observer)=>(0, $5aa1eeceeb4e99eb$export$d7ee3961208f79c1)(observer.options.enabled, this) !== false);
    }
    isDisabled() {
        if (this.getObserversCount() > 0) return !this.isActive();
        return this.options.queryFn === (0, $5aa1eeceeb4e99eb$export$1aa5a89531b7670d) || !this.isFetched();
    }
    isFetched() {
        return this.state.dataUpdateCount + this.state.errorUpdateCount > 0;
    }
    isStatic() {
        if (this.getObserversCount() > 0) return this.observers.some((observer)=>(0, $5aa1eeceeb4e99eb$export$cb3145f011bda3ac)(observer.options.staleTime, this) === "static");
        return false;
    }
    isStale() {
        if (this.getObserversCount() > 0) return this.observers.some((observer)=>observer.getCurrentResult().isStale);
        return this.state.data === void 0 || this.state.isInvalidated;
    }
    isStaleByTime(staleTime = 0) {
        if (this.state.data === void 0) return true;
        if (staleTime === "static") return false;
        if (this.state.isInvalidated) return true;
        return !(0, $5aa1eeceeb4e99eb$export$811b83d62bcf47f0)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        const observer = this.observers.find((x)=>x.shouldFetchOnWindowFocus());
        observer?.refetch({
            cancelRefetch: false
        });
        this.#retryer?.continue();
    }
    onOnline() {
        const observer = this.observers.find((x)=>x.shouldFetchOnReconnect());
        observer?.refetch({
            cancelRefetch: false
        });
        this.#retryer?.continue();
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer);
            this.clearGcTimeout();
            this.#cache.notify({
                type: "observerAdded",
                query: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        if (this.observers.includes(observer)) {
            this.observers = this.observers.filter((x)=>x !== observer);
            if (!this.observers.length) {
                if (this.#retryer) {
                    if (this.#abortSignalConsumed || this.#isInitialPausedFetch()) this.#retryer.cancel({
                        revert: true
                    });
                    else this.#retryer.cancelRetry();
                }
                this.scheduleGc();
            }
            this.#cache.notify({
                type: "observerRemoved",
                query: this,
                observer: observer
            });
        }
    }
    getObserversCount() {
        return this.observers.length;
    }
    #isInitialPausedFetch() {
        return this.state.fetchStatus === "paused" && this.state.status === "pending";
    }
    invalidate() {
        if (!this.state.isInvalidated) this.#dispatch({
            type: "invalidate"
        });
    }
    async fetch(options, fetchOptions) {
        if (this.state.fetchStatus !== "idle" && // If the promise in the retryer is already rejected, we have to definitely
        // re-start the fetch; there is a chance that the query is still in a
        // pending state when that happens
        this.#retryer?.status() !== "rejected") {
            if (this.state.data !== void 0 && fetchOptions?.cancelRefetch) this.cancel({
                silent: true
            });
            else if (this.#retryer) {
                this.#retryer.continueRetry();
                return this.#retryer.promise;
            }
        }
        if (options) this.setOptions(options);
        if (!this.options.queryFn) {
            const observer = this.observers.find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        const abortController = new AbortController();
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, "signal", {
                enumerable: true,
                get: ()=>{
                    this.#abortSignalConsumed = true;
                    return abortController.signal;
                }
            });
        };
        const fetchFn = ()=>{
            const queryFn = (0, $5aa1eeceeb4e99eb$export$c71c44209368a3bc)(this.options, fetchOptions);
            const createQueryFnContext = ()=>{
                const queryFnContext2 = {
                    client: this.#client,
                    queryKey: this.queryKey,
                    meta: this.meta
                };
                addSignalProperty(queryFnContext2);
                return queryFnContext2;
            };
            const queryFnContext = createQueryFnContext();
            this.#abortSignalConsumed = false;
            if (this.options.persister) return this.options.persister(queryFn, queryFnContext, this);
            return queryFn(queryFnContext);
        };
        const createFetchContext = ()=>{
            const context2 = {
                fetchOptions: fetchOptions,
                options: this.options,
                queryKey: this.queryKey,
                client: this.#client,
                state: this.state,
                fetchFn: fetchFn
            };
            addSignalProperty(context2);
            return context2;
        };
        const context = createFetchContext();
        const behavior = this.#queryType === "infinite" ? (0, $672bfddfaa6d1e25$export$84470d1367601e8d)(this.options.pages) : this.options.behavior;
        behavior?.onFetch(context, this);
        this.#revertState = this.state;
        if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== context.fetchOptions?.meta) this.#dispatch({
            type: "fetch",
            meta: context.fetchOptions?.meta
        });
        this.#retryer = (0, $06ece8b5ad95e805$export$2cbd00fe8a2c8d85)({
            initialPromise: fetchOptions?.initialPromise,
            fn: context.fetchFn,
            onCancel: (error)=>{
                if (error instanceof (0, $06ece8b5ad95e805$export$a8430ed4188f35a9) && error.revert) this.setState({
                    ...this.#revertState,
                    fetchStatus: "idle"
                });
                abortController.abort();
            },
            onFail: (failureCount, error)=>{
                this.#dispatch({
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                this.#dispatch({
                    type: "pause"
                });
            },
            onContinue: ()=>{
                this.#dispatch({
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode,
            canRun: ()=>true
        });
        try {
            const data = await this.#retryer.start();
            if (data === void 0) throw new Error(`${this.queryHash} data is undefined`);
            this.setData(data);
            this.#cache.config.onSuccess?.(data, this);
            this.#cache.config.onSettled?.(data, this.state.error, this);
            return data;
        } catch (error) {
            if (error instanceof (0, $06ece8b5ad95e805$export$a8430ed4188f35a9)) {
                if (error.silent) return this.#retryer.promise;
                else if (error.revert) {
                    if (this.state.data === void 0) throw error;
                    return this.state.data;
                }
            }
            this.#dispatch({
                type: "error",
                error: error
            });
            this.#cache.config.onError?.(error, this);
            this.#cache.config.onSettled?.(this.state.data, error, this);
            throw error;
        } finally{
            this.scheduleGc();
        }
    }
    #dispatch(action) {
        const reducer = (state)=>{
            switch(action.type){
                case "failed":
                    return {
                        ...state,
                        fetchFailureCount: action.failureCount,
                        fetchFailureReason: action.error
                    };
                case "pause":
                    return {
                        ...state,
                        fetchStatus: "paused"
                    };
                case "continue":
                    return {
                        ...state,
                        fetchStatus: "fetching"
                    };
                case "fetch":
                    return {
                        ...state,
                        ...$be21b923a35a99d9$export$f3df9013f2b58bce(state.data, this.options),
                        fetchMeta: action.meta ?? null
                    };
                case "success":
                    const newState = {
                        ...state,
                        ...$be21b923a35a99d9$var$successState(action.data, action.dataUpdatedAt),
                        dataUpdateCount: state.dataUpdateCount + 1,
                        ...!action.manual && {
                            fetchStatus: "idle",
                            fetchFailureCount: 0,
                            fetchFailureReason: null
                        }
                    };
                    this.#revertState = action.manual ? newState : void 0;
                    return newState;
                case "error":
                    const error = action.error;
                    return {
                        ...state,
                        error: error,
                        errorUpdateCount: state.errorUpdateCount + 1,
                        errorUpdatedAt: Date.now(),
                        fetchFailureCount: state.fetchFailureCount + 1,
                        fetchFailureReason: error,
                        fetchStatus: "idle",
                        status: "error",
                        // flag existing data as invalidated if we get a background error
                        // note that "no data" always means stale so we can set unconditionally here
                        isInvalidated: true
                    };
                case "invalidate":
                    return {
                        ...state,
                        isInvalidated: true
                    };
                case "setState":
                    return {
                        ...state,
                        ...action.state
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $6b738da3f846af52$export$520687f44db6e1ab).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onQueryUpdate();
            });
            this.#cache.notify({
                query: this,
                type: "updated",
                action: action
            });
        });
    }
};
function $be21b923a35a99d9$export$f3df9013f2b58bce(data, options) {
    return {
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchStatus: (0, $06ece8b5ad95e805$export$61b92f63f30245cf)(options.networkMode) ? "fetching" : "paused",
        ...data === void 0 && {
            error: null,
            status: "pending"
        }
    };
}
function $be21b923a35a99d9$var$successState(data, dataUpdatedAt) {
    return {
        data: data,
        dataUpdatedAt: dataUpdatedAt ?? Date.now(),
        error: null,
        isInvalidated: false,
        status: "success"
    };
}
function $be21b923a35a99d9$var$getDefaultState(options) {
    const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
    const hasData = data !== void 0;
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt ?? Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? "success" : "pending",
        fetchStatus: "idle"
    };
}




var $52d9cd16d34d400b$export$5dde0cd941da8468 = class extends (0, $7bdf67e33108b654$export$d26086b469ecdbcc) {
    constructor(config = {}){
        super();
        this.config = config;
        this.#queries = /* @__PURE__ */ new Map();
    }
    #queries;
    build(client, options, state) {
        const queryKey = options.queryKey;
        const queryHash = options.queryHash ?? (0, $5aa1eeceeb4e99eb$export$cc90ca97bc0d73fd)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, $be21b923a35a99d9$export$62297b13309008b2)({
                client: client,
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!this.#queries.has(query.queryHash)) {
            this.#queries.set(query.queryHash, query);
            this.notify({
                type: "added",
                query: query
            });
        }
    }
    remove(query) {
        const queryInMap = this.#queries.get(query.queryHash);
        if (queryInMap) {
            query.destroy();
            if (queryInMap === query) this.#queries.delete(query.queryHash);
            this.notify({
                type: "removed",
                query: query
            });
        }
    }
    clear() {
        (0, $6b738da3f846af52$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return this.#queries.get(queryHash);
    }
    getAll() {
        return [
            ...this.#queries.values()
        ];
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((query)=>(0, $5aa1eeceeb4e99eb$export$c5d1efe363797780)(defaultedFilters, query));
    }
    findAll(filters = {}) {
        const queries = this.getAll();
        return Object.keys(filters).length > 0 ? queries.filter((query)=>(0, $5aa1eeceeb4e99eb$export$c5d1efe363797780)(filters, query)) : queries;
    }
    notify(event) {
        (0, $6b738da3f846af52$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, $6b738da3f846af52$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, $6b738da3f846af52$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onOnline();
            });
        });
    }
};


// src/mutationCache.ts

// src/mutation.ts



var $0ce2635dd446001f$export$17b8b19c814bcf56 = class extends (0, $3778ea23cb7955ac$export$e09608847fcc8c59) {
    #client;
    #observers;
    #mutationCache;
    #retryer;
    constructor(config){
        super();
        this.#client = config.client;
        this.mutationId = config.mutationId;
        this.#mutationCache = config.mutationCache;
        this.#observers = [];
        this.state = config.state || $0ce2635dd446001f$export$a1659b54bac3252a();
        this.setOptions(config.options);
        this.scheduleGc();
    }
    setOptions(options) {
        this.options = options;
        this.updateGcTime(this.options.gcTime);
    }
    get meta() {
        return this.options.meta;
    }
    addObserver(observer) {
        if (!this.#observers.includes(observer)) {
            this.#observers.push(observer);
            this.clearGcTimeout();
            this.#mutationCache.notify({
                type: "observerAdded",
                mutation: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        this.#observers = this.#observers.filter((x)=>x !== observer);
        this.scheduleGc();
        this.#mutationCache.notify({
            type: "observerRemoved",
            mutation: this,
            observer: observer
        });
    }
    optionalRemove() {
        if (!this.#observers.length) {
            if (this.state.status === "pending") this.scheduleGc();
            else this.#mutationCache.remove(this);
        }
    }
    continue() {
        return this.#retryer?.continue() ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
        this.execute(this.state.variables);
    }
    async execute(variables) {
        const onContinue = ()=>{
            this.#dispatch({
                type: "continue"
            });
        };
        const mutationFnContext = {
            client: this.#client,
            meta: this.options.meta,
            mutationKey: this.options.mutationKey
        };
        this.#retryer = (0, $06ece8b5ad95e805$export$2cbd00fe8a2c8d85)({
            fn: ()=>{
                if (!this.options.mutationFn) return Promise.reject(new Error("No mutationFn found"));
                return this.options.mutationFn(variables, mutationFnContext);
            },
            onFail: (failureCount, error)=>{
                this.#dispatch({
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                this.#dispatch({
                    type: "pause"
                });
            },
            onContinue: onContinue,
            retry: this.options.retry ?? 0,
            retryDelay: this.options.retryDelay,
            networkMode: this.options.networkMode,
            canRun: ()=>this.#mutationCache.canRun(this)
        });
        const restored = this.state.status === "pending";
        const isPaused = !this.#retryer.canStart();
        try {
            if (restored) onContinue();
            else {
                this.#dispatch({
                    type: "pending",
                    variables: variables,
                    isPaused: isPaused
                });
                if (this.#mutationCache.config.onMutate) await this.#mutationCache.config.onMutate(variables, this, mutationFnContext);
                const context = await this.options.onMutate?.(variables, mutationFnContext);
                if (context !== this.state.context) this.#dispatch({
                    type: "pending",
                    context: context,
                    variables: variables,
                    isPaused: isPaused
                });
            }
            const data = await this.#retryer.start();
            await this.#mutationCache.config.onSuccess?.(data, variables, this.state.context, this, mutationFnContext);
            await this.options.onSuccess?.(data, variables, this.state.context, mutationFnContext);
            await this.#mutationCache.config.onSettled?.(data, null, this.state.variables, this.state.context, this, mutationFnContext);
            await this.options.onSettled?.(data, null, variables, this.state.context, mutationFnContext);
            this.#dispatch({
                type: "success",
                data: data
            });
            return data;
        } catch (error) {
            try {
                await this.#mutationCache.config.onError?.(error, variables, this.state.context, this, mutationFnContext);
            } catch (e) {
                Promise.reject(e);
            }
            try {
                await this.options.onError?.(error, variables, this.state.context, mutationFnContext);
            } catch (e) {
                Promise.reject(e);
            }
            try {
                await this.#mutationCache.config.onSettled?.(void 0, error, this.state.variables, this.state.context, this, mutationFnContext);
            } catch (e) {
                Promise.reject(e);
            }
            try {
                await this.options.onSettled?.(void 0, error, variables, this.state.context, mutationFnContext);
            } catch (e) {
                Promise.reject(e);
            }
            this.#dispatch({
                type: "error",
                error: error
            });
            throw error;
        } finally{
            this.#mutationCache.runNext(this);
        }
    }
    #dispatch(action) {
        const reducer = (state)=>{
            switch(action.type){
                case "failed":
                    return {
                        ...state,
                        failureCount: action.failureCount,
                        failureReason: action.error
                    };
                case "pause":
                    return {
                        ...state,
                        isPaused: true
                    };
                case "continue":
                    return {
                        ...state,
                        isPaused: false
                    };
                case "pending":
                    return {
                        ...state,
                        context: action.context,
                        data: void 0,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        isPaused: action.isPaused,
                        status: "pending",
                        variables: action.variables,
                        submittedAt: Date.now()
                    };
                case "success":
                    return {
                        ...state,
                        data: action.data,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        status: "success",
                        isPaused: false
                    };
                case "error":
                    return {
                        ...state,
                        data: void 0,
                        error: action.error,
                        failureCount: state.failureCount + 1,
                        failureReason: action.error,
                        isPaused: false,
                        status: "error"
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $6b738da3f846af52$export$520687f44db6e1ab).batch(()=>{
            this.#observers.forEach((observer)=>{
                observer.onMutationUpdate(action);
            });
            this.#mutationCache.notify({
                mutation: this,
                type: "updated",
                action: action
            });
        });
    }
};
function $0ce2635dd446001f$export$a1659b54bac3252a() {
    return {
        context: void 0,
        data: void 0,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: "idle",
        variables: void 0,
        submittedAt: 0
    };
}




var $14ea6f8c5dbe4ab6$export$1fcfd9a244434844 = class extends (0, $7bdf67e33108b654$export$d26086b469ecdbcc) {
    constructor(config = {}){
        super();
        this.config = config;
        this.#mutations = /* @__PURE__ */ new Set();
        this.#scopes = /* @__PURE__ */ new Map();
        this.#mutationId = 0;
    }
    #mutations;
    #scopes;
    #mutationId;
    build(client, options, state) {
        const mutation = new (0, $0ce2635dd446001f$export$17b8b19c814bcf56)({
            client: client,
            mutationCache: this,
            mutationId: ++this.#mutationId,
            options: client.defaultMutationOptions(options),
            state: state
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        this.#mutations.add(mutation);
        const scope = $14ea6f8c5dbe4ab6$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const scopedMutations = this.#scopes.get(scope);
            if (scopedMutations) scopedMutations.push(mutation);
            else this.#scopes.set(scope, [
                mutation
            ]);
        }
        this.notify({
            type: "added",
            mutation: mutation
        });
    }
    remove(mutation) {
        if (this.#mutations.delete(mutation)) {
            const scope = $14ea6f8c5dbe4ab6$var$scopeFor(mutation);
            if (typeof scope === "string") {
                const scopedMutations = this.#scopes.get(scope);
                if (scopedMutations) {
                    if (scopedMutations.length > 1) {
                        const index = scopedMutations.indexOf(mutation);
                        if (index !== -1) scopedMutations.splice(index, 1);
                    } else if (scopedMutations[0] === mutation) this.#scopes.delete(scope);
                }
            }
        }
        this.notify({
            type: "removed",
            mutation: mutation
        });
    }
    canRun(mutation) {
        const scope = $14ea6f8c5dbe4ab6$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const mutationsWithSameScope = this.#scopes.get(scope);
            const firstPendingMutation = mutationsWithSameScope?.find((m)=>m.state.status === "pending");
            return !firstPendingMutation || firstPendingMutation === mutation;
        } else return true;
    }
    runNext(mutation) {
        const scope = $14ea6f8c5dbe4ab6$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const foundMutation = this.#scopes.get(scope)?.find((m)=>m !== mutation && m.state.isPaused);
            return foundMutation?.continue() ?? Promise.resolve();
        } else return Promise.resolve();
    }
    clear() {
        (0, $6b738da3f846af52$export$520687f44db6e1ab).batch(()=>{
            this.#mutations.forEach((mutation)=>{
                this.notify({
                    type: "removed",
                    mutation: mutation
                });
            });
            this.#mutations.clear();
            this.#scopes.clear();
        });
    }
    getAll() {
        return Array.from(this.#mutations);
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((mutation)=>(0, $5aa1eeceeb4e99eb$export$a1ea5fb559f63ae3)(defaultedFilters, mutation));
    }
    findAll(filters = {}) {
        return this.getAll().filter((mutation)=>(0, $5aa1eeceeb4e99eb$export$a1ea5fb559f63ae3)(filters, mutation));
    }
    notify(event) {
        (0, $6b738da3f846af52$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        const pausedMutations = this.getAll().filter((x)=>x.state.isPaused);
        return (0, $6b738da3f846af52$export$520687f44db6e1ab).batch(()=>Promise.all(pausedMutations.map((mutation)=>mutation.continue().catch((0, $5aa1eeceeb4e99eb$export$8793edee2d425525)))));
    }
};
function $14ea6f8c5dbe4ab6$var$scopeFor(mutation) {
    return mutation.options.scope?.id;
}





var $f160a69bc6d21d68$export$405d0624ed55a03f = class {
    #queryCache;
    #mutationCache;
    #defaultOptions;
    #queryDefaults;
    #mutationDefaults;
    #mountCount;
    #unsubscribeFocus;
    #unsubscribeOnline;
    constructor(config = {}){
        this.#queryCache = config.queryCache || new (0, $52d9cd16d34d400b$export$5dde0cd941da8468)();
        this.#mutationCache = config.mutationCache || new (0, $14ea6f8c5dbe4ab6$export$1fcfd9a244434844)();
        this.#defaultOptions = config.defaultOptions || {};
        this.#queryDefaults = /* @__PURE__ */ new Map();
        this.#mutationDefaults = /* @__PURE__ */ new Map();
        this.#mountCount = 0;
    }
    mount() {
        this.#mountCount++;
        if (this.#mountCount !== 1) return;
        this.#unsubscribeFocus = (0, $0f3813798503d4aa$export$6bf54661be5b02cf).subscribe(async (focused)=>{
            if (focused) {
                await this.resumePausedMutations();
                this.#queryCache.onFocus();
            }
        });
        this.#unsubscribeOnline = (0, $5f59bf8b0f5af6bd$export$b113e788b2dd3fdc).subscribe(async (online)=>{
            if (online) {
                await this.resumePausedMutations();
                this.#queryCache.onOnline();
            }
        });
    }
    unmount() {
        this.#mountCount--;
        if (this.#mountCount !== 0) return;
        this.#unsubscribeFocus?.();
        this.#unsubscribeFocus = void 0;
        this.#unsubscribeOnline?.();
        this.#unsubscribeOnline = void 0;
    }
    isFetching(filters) {
        return this.#queryCache.findAll({
            ...filters,
            fetchStatus: "fetching"
        }).length;
    }
    isMutating(filters) {
        return this.#mutationCache.findAll({
            ...filters,
            status: "pending"
        }).length;
    }
    /**
   * Imperative (non-reactive) way to retrieve data for a QueryKey.
   * Should only be used in callbacks or functions where reading the latest data is necessary, e.g. for optimistic updates.
   *
   * Hint: Do not use this function inside a component, because it won't receive updates.
   * Use `useQuery` to create a `QueryObserver` that subscribes to changes.
   */ getQueryData(queryKey) {
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return this.#queryCache.get(options.queryHash)?.state.data;
    }
    ensureQueryData(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        const query = this.#queryCache.build(this, defaultedOptions);
        const cachedData = query.state.data;
        if (cachedData === void 0) return this.fetchQuery(options);
        if (options.revalidateIfStale && query.isStaleByTime((0, $5aa1eeceeb4e99eb$export$cb3145f011bda3ac)(defaultedOptions.staleTime, query))) this.prefetchQuery(defaultedOptions);
        return Promise.resolve(cachedData);
    }
    getQueriesData(filters) {
        return this.#queryCache.findAll(filters).map(({ queryKey: queryKey, state: state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const defaultedOptions = this.defaultQueryOptions({
            queryKey: queryKey
        });
        const query = this.#queryCache.get(defaultedOptions.queryHash);
        const prevData = query?.state.data;
        const data = (0, $5aa1eeceeb4e99eb$export$7f095f455ad5af3f)(updater, prevData);
        if (data === void 0) return void 0;
        return this.#queryCache.build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    setQueriesData(filters, updater, options) {
        return (0, $6b738da3f846af52$export$520687f44db6e1ab).batch(()=>this.#queryCache.findAll(filters).map(({ queryKey: queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey) {
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return this.#queryCache.get(options.queryHash)?.state;
    }
    removeQueries(filters) {
        const queryCache = this.#queryCache;
        (0, $6b738da3f846af52$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    resetQueries(filters, options) {
        const queryCache = this.#queryCache;
        return (0, $6b738da3f846af52$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries({
                type: "active",
                ...filters
            }, options);
        });
    }
    cancelQueries(filters, cancelOptions = {}) {
        const defaultedCancelOptions = {
            revert: true,
            ...cancelOptions
        };
        const promises = (0, $6b738da3f846af52$export$520687f44db6e1ab).batch(()=>this.#queryCache.findAll(filters).map((query)=>query.cancel(defaultedCancelOptions)));
        return Promise.all(promises).then((0, $5aa1eeceeb4e99eb$export$8793edee2d425525)).catch((0, $5aa1eeceeb4e99eb$export$8793edee2d425525));
    }
    invalidateQueries(filters, options = {}) {
        return (0, $6b738da3f846af52$export$520687f44db6e1ab).batch(()=>{
            this.#queryCache.findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if (filters?.refetchType === "none") return Promise.resolve();
            return this.refetchQueries({
                ...filters,
                type: filters?.refetchType ?? filters?.type ?? "active"
            }, options);
        });
    }
    refetchQueries(filters, options = {}) {
        const fetchOptions = {
            ...options,
            cancelRefetch: options.cancelRefetch ?? true
        };
        const promises = (0, $6b738da3f846af52$export$520687f44db6e1ab).batch(()=>this.#queryCache.findAll(filters).filter((query)=>!query.isDisabled() && !query.isStatic()).map((query)=>{
                let promise = query.fetch(void 0, fetchOptions);
                if (!fetchOptions.throwOnError) promise = promise.catch((0, $5aa1eeceeb4e99eb$export$8793edee2d425525));
                return query.state.fetchStatus === "paused" ? Promise.resolve() : promise;
            }));
        return Promise.all(promises).then((0, $5aa1eeceeb4e99eb$export$8793edee2d425525));
    }
    fetchQuery(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        if (defaultedOptions.retry === void 0) defaultedOptions.retry = false;
        const query = this.#queryCache.build(this, defaultedOptions);
        return query.isStaleByTime((0, $5aa1eeceeb4e99eb$export$cb3145f011bda3ac)(defaultedOptions.staleTime, query)) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    prefetchQuery(options) {
        return this.fetchQuery(options).then((0, $5aa1eeceeb4e99eb$export$8793edee2d425525)).catch((0, $5aa1eeceeb4e99eb$export$8793edee2d425525));
    }
    fetchInfiniteQuery(options) {
        options._type = "infinite";
        return this.fetchQuery(options);
    }
    prefetchInfiniteQuery(options) {
        return this.fetchInfiniteQuery(options).then((0, $5aa1eeceeb4e99eb$export$8793edee2d425525)).catch((0, $5aa1eeceeb4e99eb$export$8793edee2d425525));
    }
    ensureInfiniteQueryData(options) {
        options._type = "infinite";
        return this.ensureQueryData(options);
    }
    resumePausedMutations() {
        if ((0, $5f59bf8b0f5af6bd$export$b113e788b2dd3fdc).isOnline()) return this.#mutationCache.resumePausedMutations();
        return Promise.resolve();
    }
    getQueryCache() {
        return this.#queryCache;
    }
    getMutationCache() {
        return this.#mutationCache;
    }
    getDefaultOptions() {
        return this.#defaultOptions;
    }
    setDefaultOptions(options) {
        this.#defaultOptions = options;
    }
    setQueryDefaults(queryKey, options) {
        this.#queryDefaults.set((0, $5aa1eeceeb4e99eb$export$1e87d19d4aab5805)(queryKey), {
            queryKey: queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        const defaults = [
            ...this.#queryDefaults.values()
        ];
        const result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $5aa1eeceeb4e99eb$export$2f07189bb9fa26a7)(queryKey, queryDefault.queryKey)) Object.assign(result, queryDefault.defaultOptions);
        });
        return result;
    }
    setMutationDefaults(mutationKey, options) {
        this.#mutationDefaults.set((0, $5aa1eeceeb4e99eb$export$1e87d19d4aab5805)(mutationKey), {
            mutationKey: mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        const defaults = [
            ...this.#mutationDefaults.values()
        ];
        const result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $5aa1eeceeb4e99eb$export$2f07189bb9fa26a7)(mutationKey, queryDefault.mutationKey)) Object.assign(result, queryDefault.defaultOptions);
        });
        return result;
    }
    defaultQueryOptions(options) {
        if (options._defaulted) return options;
        const defaultedOptions = {
            ...this.#defaultOptions.queries,
            ...this.getQueryDefaults(options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash) defaultedOptions.queryHash = (0, $5aa1eeceeb4e99eb$export$cc90ca97bc0d73fd)(defaultedOptions.queryKey, defaultedOptions);
        if (defaultedOptions.refetchOnReconnect === void 0) defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
        if (defaultedOptions.throwOnError === void 0) defaultedOptions.throwOnError = !!defaultedOptions.suspense;
        if (!defaultedOptions.networkMode && defaultedOptions.persister) defaultedOptions.networkMode = "offlineFirst";
        if (defaultedOptions.queryFn === (0, $5aa1eeceeb4e99eb$export$1aa5a89531b7670d)) defaultedOptions.enabled = false;
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options?._defaulted) return options;
        return {
            ...this.#defaultOptions.mutations,
            ...options?.mutationKey && this.getMutationDefaults(options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    clear() {
        this.#queryCache.clear();
        this.#mutationCache.clear();
    }
};


var $8v0nu = parcelRequire("8v0nu");

"use client";
var $54ac0c945c77c9fc$export$da112d31b0149f31 = $8v0nu.createContext(void 0);
var $54ac0c945c77c9fc$export$22e77b9572c4fded = (queryClient)=>{
    const client = $8v0nu.useContext($54ac0c945c77c9fc$export$da112d31b0149f31);
    if (queryClient) return queryClient;
    if (!client) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return client;
};
var $54ac0c945c77c9fc$export$45604f0cc8ae667b = ({ client: client, children: children })=>{
    $8v0nu.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)($54ac0c945c77c9fc$export$da112d31b0149f31.Provider, {
        value: client,
        children: children
    });
};

// src/queryObserver.ts








var $2c409a77992b1be1$export$a06cf8c0066f0d4c = class extends (0, $7bdf67e33108b654$export$d26086b469ecdbcc) {
    constructor(client, options){
        super();
        this.options = options;
        this.#client = client;
        this.#selectError = null;
        this.#currentThenable = (0, $7b67638c91bd60df$export$d54630db02a12b72)();
        this.bindMethods();
        this.setOptions(options);
    }
    #client;
    #currentQuery = void 0;
    #currentQueryInitialState = void 0;
    #currentResult = void 0;
    #currentResultState;
    #currentResultOptions;
    #currentThenable;
    #selectError;
    #selectFn;
    #selectResult;
    // This property keeps track of the last query with defined data.
    // It will be used to pass the previous data and query to the placeholder function between renders.
    #lastQueryWithDefinedData;
    #staleTimeoutId;
    #refetchIntervalId;
    #currentRefetchInterval;
    #trackedProps = /* @__PURE__ */ new Set();
    bindMethods() {
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.size === 1) {
            this.#currentQuery.addObserver(this);
            if ($2c409a77992b1be1$var$shouldFetchOnMount(this.#currentQuery, this.options)) this.#executeFetch();
            else this.updateResult();
            this.#updateTimers();
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.destroy();
    }
    shouldFetchOnReconnect() {
        return $2c409a77992b1be1$var$shouldFetchOn(this.#currentQuery, this.options, this.options.refetchOnReconnect);
    }
    shouldFetchOnWindowFocus() {
        return $2c409a77992b1be1$var$shouldFetchOn(this.#currentQuery, this.options, this.options.refetchOnWindowFocus);
    }
    destroy() {
        this.listeners = /* @__PURE__ */ new Set();
        this.#clearStaleTimeout();
        this.#clearRefetchInterval();
        this.#currentQuery.removeObserver(this);
    }
    setOptions(options) {
        const prevOptions = this.options;
        const prevQuery = this.#currentQuery;
        this.options = this.#client.defaultQueryOptions(options);
        if (this.options.enabled !== void 0 && typeof this.options.enabled !== "boolean" && typeof this.options.enabled !== "function" && typeof (0, $5aa1eeceeb4e99eb$export$d7ee3961208f79c1)(this.options.enabled, this.#currentQuery) !== "boolean") throw new Error("Expected enabled to be a boolean or a callback that returns a boolean");
        this.#updateQuery();
        this.#currentQuery.setOptions(this.options);
        if (prevOptions._defaulted && !(0, $5aa1eeceeb4e99eb$export$3e67810a3f0e9f1c)(this.options, prevOptions)) this.#client.getQueryCache().notify({
            type: "observerOptionsUpdated",
            query: this.#currentQuery,
            observer: this
        });
        const mounted = this.hasListeners();
        if (mounted && $2c409a77992b1be1$var$shouldFetchOptionally(this.#currentQuery, prevQuery, this.options, prevOptions)) this.#executeFetch();
        this.updateResult();
        if (mounted && (this.#currentQuery !== prevQuery || (0, $5aa1eeceeb4e99eb$export$d7ee3961208f79c1)(this.options.enabled, this.#currentQuery) !== (0, $5aa1eeceeb4e99eb$export$d7ee3961208f79c1)(prevOptions.enabled, this.#currentQuery) || (0, $5aa1eeceeb4e99eb$export$cb3145f011bda3ac)(this.options.staleTime, this.#currentQuery) !== (0, $5aa1eeceeb4e99eb$export$cb3145f011bda3ac)(prevOptions.staleTime, this.#currentQuery))) this.#updateStaleTimeout();
        const nextRefetchInterval = this.#computeRefetchInterval();
        if (mounted && (this.#currentQuery !== prevQuery || (0, $5aa1eeceeb4e99eb$export$d7ee3961208f79c1)(this.options.enabled, this.#currentQuery) !== (0, $5aa1eeceeb4e99eb$export$d7ee3961208f79c1)(prevOptions.enabled, this.#currentQuery) || nextRefetchInterval !== this.#currentRefetchInterval)) this.#updateRefetchInterval(nextRefetchInterval);
    }
    getOptimisticResult(options) {
        const query = this.#client.getQueryCache().build(this.#client, options);
        const result = this.createResult(query, options);
        if ($2c409a77992b1be1$var$shouldAssignObserverCurrentProperties(this, result)) {
            this.#currentResult = result;
            this.#currentResultOptions = this.options;
            this.#currentResultState = this.#currentQuery.state;
        }
        return result;
    }
    getCurrentResult() {
        return this.#currentResult;
    }
    trackResult(result, onPropTracked) {
        return new Proxy(result, {
            get: (target, key)=>{
                this.trackProp(key);
                onPropTracked?.(key);
                if (key === "promise") {
                    this.trackProp("data");
                    if (!this.options.experimental_prefetchInRender && this.#currentThenable.status === "pending") this.#currentThenable.reject(new Error("experimental_prefetchInRender feature flag is not enabled"));
                }
                return Reflect.get(target, key);
            }
        });
    }
    trackProp(key) {
        this.#trackedProps.add(key);
    }
    getCurrentQuery() {
        return this.#currentQuery;
    }
    refetch({ ...options } = {}) {
        return this.fetch({
            ...options
        });
    }
    fetchOptimistic(options) {
        const defaultedOptions = this.#client.defaultQueryOptions(options);
        const query = this.#client.getQueryCache().build(this.#client, defaultedOptions);
        return query.fetch().then(()=>this.createResult(query, defaultedOptions));
    }
    fetch(fetchOptions) {
        return this.#executeFetch({
            ...fetchOptions,
            cancelRefetch: fetchOptions.cancelRefetch ?? true
        }).then(()=>{
            this.updateResult();
            return this.#currentResult;
        });
    }
    #executeFetch(fetchOptions) {
        this.#updateQuery();
        let promise = this.#currentQuery.fetch(this.options, fetchOptions);
        if (!fetchOptions?.throwOnError) promise = promise.catch((0, $5aa1eeceeb4e99eb$export$8793edee2d425525));
        return promise;
    }
    #updateStaleTimeout() {
        this.#clearStaleTimeout();
        const staleTime = (0, $5aa1eeceeb4e99eb$export$cb3145f011bda3ac)(this.options.staleTime, this.#currentQuery);
        if ((0, $6cf3367ecf2ce011$export$2d935f1a9c9d3f3e).isServer() || this.#currentResult.isStale || !(0, $5aa1eeceeb4e99eb$export$e539f754e934e270)(staleTime)) return;
        const time = (0, $5aa1eeceeb4e99eb$export$811b83d62bcf47f0)(this.#currentResult.dataUpdatedAt, staleTime);
        const timeout = time + 1;
        this.#staleTimeoutId = (0, $ac05d08220c5256b$export$94a2700736e69372).setTimeout(()=>{
            if (!this.#currentResult.isStale) this.updateResult();
        }, timeout);
    }
    #computeRefetchInterval() {
        return (typeof this.options.refetchInterval === "function" ? this.options.refetchInterval(this.#currentQuery) : this.options.refetchInterval) ?? false;
    }
    #updateRefetchInterval(nextInterval) {
        this.#clearRefetchInterval();
        this.#currentRefetchInterval = nextInterval;
        if ((0, $6cf3367ecf2ce011$export$2d935f1a9c9d3f3e).isServer() || (0, $5aa1eeceeb4e99eb$export$d7ee3961208f79c1)(this.options.enabled, this.#currentQuery) === false || !(0, $5aa1eeceeb4e99eb$export$e539f754e934e270)(this.#currentRefetchInterval) || this.#currentRefetchInterval === 0) return;
        this.#refetchIntervalId = (0, $ac05d08220c5256b$export$94a2700736e69372).setInterval(()=>{
            if (this.options.refetchIntervalInBackground || (0, $0f3813798503d4aa$export$6bf54661be5b02cf).isFocused()) this.#executeFetch();
        }, this.#currentRefetchInterval);
    }
    #updateTimers() {
        this.#updateStaleTimeout();
        this.#updateRefetchInterval(this.#computeRefetchInterval());
    }
    #clearStaleTimeout() {
        if (this.#staleTimeoutId !== void 0) {
            (0, $ac05d08220c5256b$export$94a2700736e69372).clearTimeout(this.#staleTimeoutId);
            this.#staleTimeoutId = void 0;
        }
    }
    #clearRefetchInterval() {
        if (this.#refetchIntervalId !== void 0) {
            (0, $ac05d08220c5256b$export$94a2700736e69372).clearInterval(this.#refetchIntervalId);
            this.#refetchIntervalId = void 0;
        }
    }
    createResult(query, options) {
        const prevQuery = this.#currentQuery;
        const prevOptions = this.options;
        const prevResult = this.#currentResult;
        const prevResultState = this.#currentResultState;
        const prevResultOptions = this.#currentResultOptions;
        const queryChange = query !== prevQuery;
        const queryInitialState = queryChange ? query.state : this.#currentQueryInitialState;
        const { state: state } = query;
        let newState = {
            ...state
        };
        let isPlaceholderData = false;
        let data;
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && $2c409a77992b1be1$var$shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && $2c409a77992b1be1$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) newState = {
                ...newState,
                ...(0, $be21b923a35a99d9$export$f3df9013f2b58bce)(state.data, query.options)
            };
            if (options._optimisticResults === "isRestoring") newState.fetchStatus = "idle";
        }
        let { error: error, errorUpdatedAt: errorUpdatedAt, status: status } = newState;
        data = newState.data;
        let skipSelect = false;
        if (options.placeholderData !== void 0 && data === void 0 && status === "pending") {
            let placeholderData;
            if (prevResult?.isPlaceholderData && options.placeholderData === prevResultOptions?.placeholderData) {
                placeholderData = prevResult.data;
                skipSelect = true;
            } else placeholderData = typeof options.placeholderData === "function" ? options.placeholderData(this.#lastQueryWithDefinedData?.state.data, this.#lastQueryWithDefinedData) : options.placeholderData;
            if (placeholderData !== void 0) {
                status = "success";
                data = (0, $5aa1eeceeb4e99eb$export$17619bac5b909b23)(prevResult?.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if (options.select && data !== void 0 && !skipSelect) {
            if (prevResult && data === prevResultState?.data && options.select === this.#selectFn) data = this.#selectResult;
            else try {
                this.#selectFn = options.select;
                data = options.select(data);
                data = (0, $5aa1eeceeb4e99eb$export$17619bac5b909b23)(prevResult?.data, data, options);
                this.#selectResult = data;
                this.#selectError = null;
            } catch (selectError) {
                this.#selectError = selectError;
            }
        }
        if (this.#selectError) {
            error = this.#selectError;
            data = this.#selectResult;
            errorUpdatedAt = Date.now();
            status = "error";
        }
        const isFetching = newState.fetchStatus === "fetching";
        const isPending = status === "pending";
        const isError = status === "error";
        const isLoading = isPending && isFetching;
        const hasData = data !== void 0;
        const result = {
            status: status,
            fetchStatus: newState.fetchStatus,
            isPending: isPending,
            isSuccess: status === "success",
            isError: isError,
            isInitialLoading: isLoading,
            isLoading: isLoading,
            data: data,
            dataUpdatedAt: newState.dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: newState.fetchFailureCount,
            failureReason: newState.fetchFailureReason,
            errorUpdateCount: newState.errorUpdateCount,
            isFetched: query.isFetched(),
            isFetchedAfterMount: newState.dataUpdateCount > queryInitialState.dataUpdateCount || newState.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && !isPending,
            isLoadingError: isError && !hasData,
            isPaused: newState.fetchStatus === "paused",
            isPlaceholderData: isPlaceholderData,
            isRefetchError: isError && hasData,
            isStale: $2c409a77992b1be1$var$isStale(query, options),
            refetch: this.refetch,
            promise: this.#currentThenable,
            isEnabled: (0, $5aa1eeceeb4e99eb$export$d7ee3961208f79c1)(options.enabled, query) !== false
        };
        const nextResult = result;
        if (this.options.experimental_prefetchInRender) {
            const hasResultData = nextResult.data !== void 0;
            const isErrorWithoutData = nextResult.status === "error" && !hasResultData;
            const finalizeThenableIfPossible = (thenable)=>{
                if (isErrorWithoutData) thenable.reject(nextResult.error);
                else if (hasResultData) thenable.resolve(nextResult.data);
            };
            const recreateThenable = ()=>{
                const pending = this.#currentThenable = nextResult.promise = (0, $7b67638c91bd60df$export$d54630db02a12b72)();
                finalizeThenableIfPossible(pending);
            };
            const prevThenable = this.#currentThenable;
            switch(prevThenable.status){
                case "pending":
                    if (query.queryHash === prevQuery.queryHash) finalizeThenableIfPossible(prevThenable);
                    break;
                case "fulfilled":
                    if (isErrorWithoutData || nextResult.data !== prevThenable.value) recreateThenable();
                    break;
                case "rejected":
                    if (!isErrorWithoutData || nextResult.error !== prevThenable.reason) recreateThenable();
                    break;
            }
        }
        return nextResult;
    }
    updateResult() {
        const prevResult = this.#currentResult;
        const nextResult = this.createResult(this.#currentQuery, this.options);
        this.#currentResultState = this.#currentQuery.state;
        this.#currentResultOptions = this.options;
        if (this.#currentResultState.data !== void 0) this.#lastQueryWithDefinedData = this.#currentQuery;
        if ((0, $5aa1eeceeb4e99eb$export$3e67810a3f0e9f1c)(nextResult, prevResult)) return;
        this.#currentResult = nextResult;
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps: notifyOnChangeProps } = this.options;
            const notifyOnChangePropsValue = typeof notifyOnChangeProps === "function" ? notifyOnChangeProps() : notifyOnChangeProps;
            if (notifyOnChangePropsValue === "all" || !notifyOnChangePropsValue && !this.#trackedProps.size) return true;
            const includedProps = new Set(notifyOnChangePropsValue ?? this.#trackedProps);
            if (this.options.throwOnError) includedProps.add("error");
            return Object.keys(this.#currentResult).some((key)=>{
                const typedKey = key;
                const changed = this.#currentResult[typedKey] !== prevResult[typedKey];
                return changed && includedProps.has(typedKey);
            });
        };
        this.#notify({
            listeners: shouldNotifyListeners()
        });
    }
    #updateQuery() {
        const query = this.#client.getQueryCache().build(this.#client, this.options);
        if (query === this.#currentQuery) return;
        const prevQuery = this.#currentQuery;
        this.#currentQuery = query;
        this.#currentQueryInitialState = query.state;
        if (this.hasListeners()) {
            prevQuery?.removeObserver(this);
            query.addObserver(this);
        }
    }
    onQueryUpdate() {
        this.updateResult();
        if (this.hasListeners()) this.#updateTimers();
    }
    #notify(notifyOptions) {
        (0, $6b738da3f846af52$export$520687f44db6e1ab).batch(()=>{
            if (notifyOptions.listeners) this.listeners.forEach((listener)=>{
                listener(this.#currentResult);
            });
            this.#client.getQueryCache().notify({
                query: this.#currentQuery,
                type: "observerResultsUpdated"
            });
        });
    }
};
function $2c409a77992b1be1$var$shouldLoadOnMount(query, options) {
    return (0, $5aa1eeceeb4e99eb$export$d7ee3961208f79c1)(options.enabled, query) !== false && query.state.data === void 0 && !(query.state.status === "error" && (0, $5aa1eeceeb4e99eb$export$d7ee3961208f79c1)(options.retryOnMount, query) === false);
}
function $2c409a77992b1be1$var$shouldFetchOnMount(query, options) {
    return $2c409a77992b1be1$var$shouldLoadOnMount(query, options) || query.state.data !== void 0 && $2c409a77992b1be1$var$shouldFetchOn(query, options, options.refetchOnMount);
}
function $2c409a77992b1be1$var$shouldFetchOn(query, options, field) {
    if ((0, $5aa1eeceeb4e99eb$export$d7ee3961208f79c1)(options.enabled, query) !== false && (0, $5aa1eeceeb4e99eb$export$cb3145f011bda3ac)(options.staleTime, query) !== "static") {
        const value = typeof field === "function" ? field(query) : field;
        return value === "always" || value !== false && $2c409a77992b1be1$var$isStale(query, options);
    }
    return false;
}
function $2c409a77992b1be1$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return (query !== prevQuery || (0, $5aa1eeceeb4e99eb$export$d7ee3961208f79c1)(prevOptions.enabled, query) === false) && (!options.suspense || query.state.status !== "error") && $2c409a77992b1be1$var$isStale(query, options);
}
function $2c409a77992b1be1$var$isStale(query, options) {
    return (0, $5aa1eeceeb4e99eb$export$d7ee3961208f79c1)(options.enabled, query) !== false && query.isStaleByTime((0, $5aa1eeceeb4e99eb$export$cb3145f011bda3ac)(options.staleTime, query));
}
function $2c409a77992b1be1$var$shouldAssignObserverCurrentProperties(observer, optimisticResult) {
    if (!(0, $5aa1eeceeb4e99eb$export$3e67810a3f0e9f1c)(observer.getCurrentResult(), optimisticResult)) return true;
    return false;
}



var $8v0nu = parcelRequire("8v0nu");



var $8v0nu = parcelRequire("8v0nu");

"use client";
function $45f1157864479597$var$createValue() {
    let isReset = false;
    return {
        clearReset: ()=>{
            isReset = false;
        },
        reset: ()=>{
            isReset = true;
        },
        isReset: ()=>{
            return isReset;
        }
    };
}
var $45f1157864479597$var$QueryErrorResetBoundaryContext = $8v0nu.createContext($45f1157864479597$var$createValue());
var $45f1157864479597$export$50dfac555130cafd = ()=>$8v0nu.useContext($45f1157864479597$var$QueryErrorResetBoundaryContext);
var $45f1157864479597$export$ddb9962d870f2330 = ({ children: children })=>{
    const [value] = $8v0nu.useState(()=>$45f1157864479597$var$createValue());
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)($45f1157864479597$var$QueryErrorResetBoundaryContext.Provider, {
        value: value,
        children: typeof children === "function" ? children(value) : children
    });
};



var $8v0nu = parcelRequire("8v0nu");

"use client";
var $caffb0b4e04c274b$export$ae8adb3de3d77633 = (options, errorResetBoundary, query)=>{
    const throwOnError = query?.state.error && typeof options.throwOnError === "function" ? (0, $5aa1eeceeb4e99eb$export$2072f68e6c3507cf)(options.throwOnError, [
        query.state.error,
        query
    ]) : options.throwOnError;
    if (options.suspense || options.experimental_prefetchInRender || throwOnError) {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
var $caffb0b4e04c274b$export$b2b17ca3a1fb0229 = (errorResetBoundary)=>{
    $8v0nu.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
var $caffb0b4e04c274b$export$1fbcf724762d607 = ({ result: result, errorResetBoundary: errorResetBoundary, throwOnError: throwOnError, query: query, suspense: suspense })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && query && (suspense && result.data === void 0 || (0, $5aa1eeceeb4e99eb$export$2072f68e6c3507cf)(throwOnError, [
        result.error,
        query
    ]));
};



var $8v0nu = parcelRequire("8v0nu");
"use client";
var $989f33f39cde9c15$var$IsRestoringContext = $8v0nu.createContext(false);
var $989f33f39cde9c15$export$4da0178d6b5f553 = ()=>$8v0nu.useContext($989f33f39cde9c15$var$IsRestoringContext);
var $989f33f39cde9c15$export$593807d4e94f9621 = $989f33f39cde9c15$var$IsRestoringContext.Provider;


// src/suspense.ts
var $344da632f150cf98$export$8bed2f8d02206063 = (_error, query)=>query.state.data === void 0;
var $344da632f150cf98$export$274d2a1db5a20c09 = (defaultedOptions)=>{
    if (defaultedOptions.suspense) {
        const MIN_SUSPENSE_TIME_MS = 1e3;
        const clamp = (value)=>value === "static" ? value : Math.max(value ?? MIN_SUSPENSE_TIME_MS, MIN_SUSPENSE_TIME_MS);
        const originalStaleTime = defaultedOptions.staleTime;
        defaultedOptions.staleTime = typeof originalStaleTime === "function" ? (...args)=>clamp(originalStaleTime(...args)) : clamp(originalStaleTime);
        if (typeof defaultedOptions.gcTime === "number") defaultedOptions.gcTime = Math.max(defaultedOptions.gcTime, MIN_SUSPENSE_TIME_MS);
    }
};
var $344da632f150cf98$export$e0a3f29513afe430 = (result, isRestoring)=>result.isLoading && result.isFetching && !isRestoring;
var $344da632f150cf98$export$88d3586dfed64df9 = (defaultedOptions, result)=>defaultedOptions?.suspense && result.isPending;
var $344da632f150cf98$export$defdc11a9c9acfcf = (defaultedOptions, observer, errorResetBoundary)=>observer.fetchOptimistic(defaultedOptions).catch(()=>{
        errorResetBoundary.clearReset();
    });


"use client";
function $b41dde6955e27e2d$export$fff0865807e996c5(options, Observer, queryClient) {
    const isRestoring = (0, $989f33f39cde9c15$export$4da0178d6b5f553)();
    const errorResetBoundary = (0, $45f1157864479597$export$50dfac555130cafd)();
    const client = (0, $54ac0c945c77c9fc$export$22e77b9572c4fded)(queryClient);
    const defaultedOptions = client.defaultQueryOptions(options);
    client.getDefaultOptions().queries?._experimental_beforeQuery?.(defaultedOptions);
    const query = client.getQueryCache().get(defaultedOptions.queryHash);
    const subscribed = options.subscribed !== false;
    defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : subscribed ? "optimistic" : void 0;
    (0, $344da632f150cf98$export$274d2a1db5a20c09)(defaultedOptions);
    (0, $caffb0b4e04c274b$export$ae8adb3de3d77633)(defaultedOptions, errorResetBoundary, query);
    (0, $caffb0b4e04c274b$export$b2b17ca3a1fb0229)(errorResetBoundary);
    const isNewCacheEntry = !client.getQueryCache().get(defaultedOptions.queryHash);
    const [observer] = $8v0nu.useState(()=>new Observer(client, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    const shouldSubscribe = !isRestoring && subscribed;
    $8v0nu.useSyncExternalStore($8v0nu.useCallback((onStoreChange)=>{
        const unsubscribe = shouldSubscribe ? observer.subscribe((0, $6b738da3f846af52$export$520687f44db6e1ab).batchCalls(onStoreChange)) : (0, $5aa1eeceeb4e99eb$export$8793edee2d425525);
        observer.updateResult();
        return unsubscribe;
    }, [
        observer,
        shouldSubscribe
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $8v0nu.useEffect(()=>{
        observer.setOptions(defaultedOptions);
    }, [
        defaultedOptions,
        observer
    ]);
    if ((0, $344da632f150cf98$export$88d3586dfed64df9)(defaultedOptions, result)) throw (0, $344da632f150cf98$export$defdc11a9c9acfcf)(defaultedOptions, observer, errorResetBoundary);
    if ((0, $caffb0b4e04c274b$export$1fbcf724762d607)({
        result: result,
        errorResetBoundary: errorResetBoundary,
        throwOnError: defaultedOptions.throwOnError,
        query: query,
        suspense: defaultedOptions.suspense
    })) throw result.error;
    client.getDefaultOptions().queries?._experimental_afterQuery?.(defaultedOptions, result);
    if (defaultedOptions.experimental_prefetchInRender && !(0, $6cf3367ecf2ce011$export$2d935f1a9c9d3f3e).isServer() && (0, $344da632f150cf98$export$e0a3f29513afe430)(result, isRestoring)) {
        const promise = isNewCacheEntry ? // Fetch immediately on render in order to ensure `.promise` is resolved even if the component is unmounted
        (0, $344da632f150cf98$export$defdc11a9c9acfcf)(defaultedOptions, observer, errorResetBoundary) : // subscribe to the "cache promise" so that we can finalize the currentThenable once data comes in
        query?.promise;
        promise?.catch((0, $5aa1eeceeb4e99eb$export$8793edee2d425525)).finally(()=>{
            observer.updateResult();
        });
    }
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}


"use client";
function $e0e811f29cb6fba3$export$dd0a697e1782aedd(options, queryClient) {
    return (0, $b41dde6955e27e2d$export$fff0865807e996c5)(options, (0, $2c409a77992b1be1$export$a06cf8c0066f0d4c), queryClient);
}


const $65e1a4342c129241$var$X = (e, t = 250)=>{
    let r;
    const n = function(...o) {
        clearTimeout(r), r = setTimeout(()=>e.apply(this, o), t);
    };
    return n.cancel = ()=>{
        clearTimeout(r);
    }, n;
};
function $65e1a4342c129241$var$ee(e) {
    const t = {};
    if (e.ids !== void 0 && (t.ids = e.ids), e.bbox !== void 0 && (t.bbox = e.bbox), e.collections !== void 0 && (t.collections = e.collections), e.datetime !== void 0) t.datetime = e.datetime;
    else if (e.dateRange !== void 0) {
        const { from: r, to: n } = e.dateRange;
        (r || n) && (t.datetime = `${r || ".."}/${n || ".."}`);
    }
    return e.sortby !== void 0 && (t.sortby = e.sortby), e.limit !== void 0 && (t.limit = e.limit), e.token !== void 0 && (t.token = e.token), e.page !== void 0 && (t.page = e.page), e.merge !== void 0 && (t.merge = e.merge), t;
}
function $65e1a4342c129241$var$te() {
    return [
        "collections"
    ];
}
function $65e1a4342c129241$var$re(e) {
    return [
        "collection",
        e
    ];
}
function $65e1a4342c129241$var$ne(e) {
    return [
        "item",
        e
    ];
}
function $65e1a4342c129241$var$oe(e) {
    return [
        "stacApi",
        e
    ];
}
function $65e1a4342c129241$var$ie(e) {
    return e.type === "get" ? [
        "stacSearch",
        "page",
        e.url
    ] : [
        "stacSearch",
        "search",
        $65e1a4342c129241$var$ee(e.payload)
    ];
}
class $65e1a4342c129241$var$A extends Error {
    constructor(t, r, n, o){
        super(t), this.name = "ApiError", this.status = r, this.detail = n, this.url = o, Error.captureStackTrace && Error.captureStackTrace(this, $65e1a4342c129241$var$A);
    }
}
async function $65e1a4342c129241$var$g(e) {
    const t = e.clone();
    if (!e.ok) {
        let r;
        try {
            r = await e.json();
        } catch  {
            r = await t.text();
        }
        throw new $65e1a4342c129241$var$A(e.statusText, e.status, r, e.url);
    }
    try {
        return await e.json();
    } catch (r) {
        throw new $65e1a4342c129241$var$A(`Invalid JSON: ${r instanceof Error ? r.message : String(r)}`, e.status, await t.text(), e.url);
    }
}
const $65e1a4342c129241$var$D = (0, $8v0nu.createContext)({});
function $65e1a4342c129241$var$x() {
    const { stacApi: e } = (0, $8v0nu.useContext)($65e1a4342c129241$var$D);
    return {
        stacApi: e
    };
}
function $65e1a4342c129241$export$47c1284bb8faa96() {
    const { stacApi: e } = $65e1a4342c129241$var$x(), t = (0, $54ac0c945c77c9fc$export$22e77b9572c4fded)(), [r, n] = (0, $8v0nu.useState)(), [o, i] = (0, $8v0nu.useState)(), [s, a] = (0, $8v0nu.useState)(), [u, d] = (0, $8v0nu.useState)(), [y, I] = (0, $8v0nu.useState)(), [E, K] = (0, $8v0nu.useState)(25), [$, O] = (0, $8v0nu.useState)(), [v, P] = (0, $8v0nu.useState)(null), [b, k] = (0, $8v0nu.useState)(), [S, N] = (0, $8v0nu.useState)(), M = ()=>{
        i(void 0), a(void 0), n(void 0), d(void 0), I(void 0), O(void 0), K(25), P(null), k(void 0), N(void 0);
    };
    (0, $8v0nu.useEffect)(()=>{
        e && (M(), t.invalidateQueries({
            queryKey: [
                "stacSearch"
            ]
        }));
    }, [
        e,
        t
    ]);
    const L = (0, $8v0nu.useCallback)((c)=>{
        k(c.find(({ rel: f })=>f === "next")), N(c.find(({ rel: f })=>[
                "prev",
                "previous"
            ].includes(f)));
    }, []), C = (0, $8v0nu.useCallback)(()=>({
            ids: r,
            bbox: o,
            collections: s,
            dateRange: {
                from: u,
                to: y
            },
            sortby: $,
            limit: E
        }), [
        r,
        o,
        s,
        u,
        y,
        $,
        E
    ]), G = async (c)=>{
        if (!e) throw new Error("No STAC API configured");
        const f = c.type === "search" ? await e.search(c.payload, c.headers) : await e.get(c.url);
        return $65e1a4342c129241$var$g(f);
    }, { data: T, error: _, isLoading: U, isFetching: B } = (0, $e0e811f29cb6fba3$export$dd0a697e1782aedd)({
        queryKey: v ? $65e1a4342c129241$var$ie(v) : [
            "stacSearch",
            "idle"
        ],
        queryFn: ()=>G(v),
        enabled: v !== null,
        retry: !1
    });
    (0, $8v0nu.useEffect)(()=>{
        T?.links && L(T.links);
    }, [
        T,
        L
    ]);
    const p = (0, $8v0nu.useCallback)((c)=>c.body ? {
            type: "search",
            payload: c.body.merge ? {
                ...c.body,
                ...C()
            } : c.body,
            headers: c.headers
        } : {
            type: "get",
            url: c.href
        }, [
        C
    ]), J = (0, $8v0nu.useCallback)(()=>{
        b && P(p(b));
    }, [
        b,
        p
    ]), Z = (0, $8v0nu.useCallback)(()=>{
        S && P(p(S));
    }, [
        S,
        p
    ]), j = (0, $8v0nu.useCallback)(()=>{
        const c = C();
        P({
            type: "search",
            payload: c
        });
    }, [
        C
    ]), q = (0, $8v0nu.useMemo)(()=>$65e1a4342c129241$var$X(j, 300), [
        j
    ]);
    return (0, $8v0nu.useEffect)(()=>()=>{
            q.cancel();
        }, [
        q
    ]), {
        submit: q,
        ids: r,
        setIds: n,
        bbox: o,
        setBbox: i,
        collections: s,
        setCollections: a,
        dateRangeFrom: u,
        setDateRangeFrom: d,
        dateRangeTo: y,
        setDateRangeTo: I,
        results: T,
        isLoading: U,
        isFetching: B,
        error: _,
        sortby: $,
        setSortby: O,
        limit: E,
        setLimit: K,
        nextPage: b ? J : void 0,
        previousPage: S ? Z : void 0
    };
}
function $65e1a4342c129241$export$2b5787016ed09c4d() {
    const { stacApi: e } = $65e1a4342c129241$var$x(), t = async ()=>{
        if (!e) throw new Error("No STAC API configured");
        const a = await e.getCollections();
        return $65e1a4342c129241$var$g(a);
    }, { data: r, error: n, isLoading: o, isFetching: i, refetch: s } = (0, $e0e811f29cb6fba3$export$dd0a697e1782aedd)({
        queryKey: $65e1a4342c129241$var$te(),
        queryFn: t,
        enabled: !!e,
        retry: !1
    });
    return {
        collections: r,
        refetch: s,
        isLoading: o,
        isFetching: i,
        error: n
    };
}
function $65e1a4342c129241$export$6cd28814d92fa9c9(e) {
    const { stacApi: t } = $65e1a4342c129241$var$x(), r = async ()=>{
        if (!t) throw new Error("No STAC API configured");
        const u = await t.getCollection(e);
        return $65e1a4342c129241$var$g(u);
    }, { data: n, error: o, isLoading: i, isFetching: s, refetch: a } = (0, $e0e811f29cb6fba3$export$dd0a697e1782aedd)({
        queryKey: $65e1a4342c129241$var$re(e),
        queryFn: r,
        enabled: !!t,
        retry: !1
    });
    return {
        collection: n,
        isLoading: i,
        isFetching: s,
        refetch: a,
        error: o
    };
}
function $65e1a4342c129241$export$9842ce616dcc8723(e) {
    const { stacApi: t } = $65e1a4342c129241$var$x(), r = async ()=>{
        if (!t) throw new Error("No STAC API configured");
        const u = await t.get(e);
        return $65e1a4342c129241$var$g(u);
    }, { data: n, error: o, isLoading: i, isFetching: s, refetch: a } = (0, $e0e811f29cb6fba3$export$dd0a697e1782aedd)({
        queryKey: $65e1a4342c129241$var$ne(e),
        queryFn: r,
        enabled: !!t,
        retry: !1
    });
    return {
        item: n,
        isLoading: i,
        isFetching: s,
        error: o,
        refetch: a
    };
}
var $65e1a4342c129241$var$R = /* @__PURE__ */ ((e)=>(e.GET = "GET", e.POST = "POST", e))($65e1a4342c129241$var$R || {});
class $65e1a4342c129241$var$se {
    constructor(t, r, n){
        this.searchMode = "GET", this.baseUrl = t.endsWith("/") ? t.slice(0, -1) : t, this.searchMode = r, this.options = n;
    }
    fixBboxCoordinateOrder(t) {
        if (!t) return;
        const [r, n, o, i] = t, s = [
            r,
            n,
            o,
            i
        ];
        return r > o && (s[0] = o, s[2] = r), n > i && (s[1] = i, s[3] = n), s;
    }
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any */ makeArrayPayload(t) {
        return t?.length ? t : void 0;
    }
    makeDatetimePayload(t) {
        if (!t?.from && !t?.to) return;
        const r = (n, o)=>{
            if (!n) return "..";
            const i = o ? "T23:59:59Z" : "T00:00:00Z";
            return n.includes("T") ? n : `${n}${i}`;
        };
        return `${r(t?.from)}/${r(t?.to, !0)}`;
    }
    payloadToQuery({ sortby: t, ...r }) {
        const n = {};
        for (const [o, i] of Object.entries(r))i && (Array.isArray(i) ? n[o] = i.join(",") : n[o] = i);
        return t && (n.sortby = t.map(({ field: o, direction: i })=>`${i === "asc" ? "+" : "-"}${o}`).join(",")), new URLSearchParams(n).toString();
    }
    async fetch(t, r = {}) {
        const { method: n = "GET", payload: o, headers: i = {} } = r;
        return fetch(t, {
            method: n,
            headers: {
                ...this.options?.headers,
                ...i
            },
            body: o ? JSON.stringify(o) : void 0
        });
    }
    search(t, r = {}) {
        const { ids: n, bbox: o, dateRange: i, collections: s, ...a } = t, u = {
            ...a,
            ids: this.makeArrayPayload(n),
            collections: this.makeArrayPayload(s),
            bbox: this.fixBboxCoordinateOrder(o),
            datetime: this.makeDatetimePayload(i)
        };
        if (this.searchMode === "POST") return this.fetch(`${this.baseUrl}/search`, {
            method: "POST",
            payload: u,
            headers: {
                "Content-Type": "application/json",
                ...r
            }
        });
        {
            const d = this.payloadToQuery(u);
            return this.fetch(`${this.baseUrl}/search?${d}`, {
                method: "GET",
                headers: r
            });
        }
    }
    getCollections() {
        return this.fetch(`${this.baseUrl}/collections`);
    }
    getCollection(t) {
        return this.fetch(`${this.baseUrl}/collections/${t}`);
    }
    get(t, r = {}) {
        return this.fetch(t, {
            headers: r
        });
    }
}
function $65e1a4342c129241$export$d5f91e9964fa0ed1(e, t) {
    const { data: r, isSuccess: n, isLoading: o, isError: i } = (0, $e0e811f29cb6fba3$export$dd0a697e1782aedd)({
        queryKey: $65e1a4342c129241$var$oe(e),
        queryFn: async ()=>{
            const s = await fetch(e, {
                headers: {
                    ...t?.headers
                }
            });
            return {
                mode: (await $65e1a4342c129241$var$g(s)).links?.find(({ rel: d, method: y })=>d === "search" && y === "POST") ? $65e1a4342c129241$var$R.POST : $65e1a4342c129241$var$R.GET,
                url: s.url
            };
        },
        staleTime: 1 / 0
    });
    return (0, $8v0nu.useMemo)(()=>n ? {
            stacApi: new $65e1a4342c129241$var$se(r.url, r.mode, t),
            isLoading: o,
            isError: i
        } : {
            stacApi: void 0,
            isLoading: o,
            isError: i
        }, [
        r,
        n,
        o,
        i,
        t
    ]);
}
function $65e1a4342c129241$var$ae({ children: e, apiUrl: t, options: r }) {
    const { stacApi: n } = $65e1a4342c129241$export$d5f91e9964fa0ed1(t, r), o = (0, $8v0nu.useMemo)(()=>({
            stacApi: n
        }), [
        n
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($8v0nu))).createElement($65e1a4342c129241$var$D.Provider, {
        value: o
    }, e);
}
function $65e1a4342c129241$export$dc253927969915ae({ children: e, apiUrl: t, options: r, queryClient: n, enableDevTools: o }) {
    const i = (0, $8v0nu.useMemo)(()=>new (0, $f160a69bc6d21d68$export$405d0624ed55a03f)(), []), s = n ?? i;
    return o && typeof window < "u" && (window.__TANSTACK_QUERY_CLIENT__ = s), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($8v0nu))).createElement((0, $54ac0c945c77c9fc$export$45604f0cc8ae667b), {
        client: s
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($8v0nu))).createElement($65e1a4342c129241$var$ae, {
        apiUrl: t,
        options: r
    }, e));
}




var $8v0nu = parcelRequire("8v0nu");
// Create context
const $c14d6b556e5e27a6$var$PluginConfigContext = /*#__PURE__*/ (0, $8v0nu.createContext)(null);
function $c14d6b556e5e27a6$export$1bd450f81b7fc15b(props) {
    const { config: config, children: children } = props;
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)($c14d6b556e5e27a6$var$PluginConfigContext.Provider, {
        value: {
            config: config
        },
        children: children
    });
}
const $c14d6b556e5e27a6$export$bb6ca6e2ef1fe760 = ()=>{
    const context = (0, $8v0nu.useContext)($c14d6b556e5e27a6$var$PluginConfigContext);
    if (!context) throw new Error('usePluginConfig must be used within a PluginConfigProvider');
    return context.config;
};



parcelRequire("8v0nu");


var $8v0nu = parcelRequire("8v0nu");

"use strict";
function $bf86327674cc5153$export$9dd9a52f2dd5b9ce(...fns) {
    return function mergedFn(...args) {
        fns.forEach((fn)=>fn?.(...args));
    };
}


"use strict";
const $c138fae1cd321339$var$clsx = (...args)=>args.map((str)=>str?.trim?.()).filter(Boolean).join(" ");
const $c138fae1cd321339$var$eventRegex = /^on[A-Z]/;
function $c138fae1cd321339$export$9d1611c77c2fe928(...args) {
    let result = {};
    for (let props of args){
        for(let key in result){
            if ($c138fae1cd321339$var$eventRegex.test(key) && typeof result[key] === "function" && typeof props[key] === "function") {
                result[key] = (0, $bf86327674cc5153$export$9dd9a52f2dd5b9ce)(result[key], props[key]);
                continue;
            }
            if (key === "className" || key === "class") {
                result[key] = $c138fae1cd321339$var$clsx(result[key], props[key]);
                continue;
            }
            if (key === "style") {
                result[key] = Object.assign({}, result[key] ?? {}, props[key] ?? {});
                continue;
            }
            result[key] = props[key] !== void 0 ? props[key] : result[key];
        }
        for(let key in props)if (result[key] === void 0) result[key] = props[key];
    }
    return result;
}


"use strict";
const $02f5f697eb6a66a5$export$a6cdc56e425d0d0a = (v)=>v != null && typeof v === "object" && !Array.isArray(v);
const $02f5f697eb6a66a5$export$30a9abfd5fb9f5f6 = (v)=>/^var\(--.+\)$/.test(v);
const $02f5f697eb6a66a5$export$844ec244b1367d54 = (v)=>typeof v === "string";
const $02f5f697eb6a66a5$export$f6e2535fb5126e54 = (v)=>typeof v === "function";


"use strict";
const $99474b193e949655$export$a274e22fb40f762e = (...classNames)=>{
    const classes = [];
    for(let i = 0; i < classNames.length; i++){
        const className = classNames[i];
        if (!(0, $02f5f697eb6a66a5$export$844ec244b1367d54)(className)) continue;
        const trimmed = className.trim();
        if (trimmed) classes.push(trimmed);
    }
    return classes.join(" ");
};


"use strict";
function $53eb36df3e1e11a3$export$781f7f324ca6010c(Component) {
    if (typeof Component === "string") return void 0;
    return Component.displayName || Component.name;
}
function $53eb36df3e1e11a3$export$3061f22cd819074d(str) {
    if (!str) return str;
    return str.charAt(0).toUpperCase() + str.slice(1);
}
function $53eb36df3e1e11a3$export$f044e71dd8693dc7(contextName, slot) {
    return contextName + $53eb36df3e1e11a3$export$3061f22cd819074d(slot);
}
function $53eb36df3e1e11a3$export$6b3393e9b9dbb0d(contextName, innerDisplayNameOrName) {
    if (!innerDisplayNameOrName) return void 0;
    return contextName + $53eb36df3e1e11a3$export$3061f22cd819074d(innerDisplayNameOrName);
}


"use strict";
const $0fb716203df70dd7$export$e37f626c01cb373a = Object.freeze({});
const $0fb716203df70dd7$export$d3d148c3a490a1e4 = Object.freeze({});




// eslint-disable-next-line no-undef
var $5148c87bb48179e4$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $5148c87bb48179e4$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $efa66df610ae0ce8$export$2e2bcd8739ae039)(function(prop) {
    return $5148c87bb48179e4$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});







var $8v0nu = parcelRequire("8v0nu");


var $8v0nu = parcelRequire("8v0nu");
"use strict";
const $832c7248c1f770ce$var$majorVersion = parseInt($8v0nu.version.split(".")[0], 10);
const $832c7248c1f770ce$var$shouldReturnCleanup = $832c7248c1f770ce$var$majorVersion >= 19;
function $832c7248c1f770ce$export$d734136a7b018efe(ref, value) {
    if (ref == null) return;
    if (typeof ref === "function") return ref(value);
    try {
        ref.current = value;
    } catch (error) {
        throw new Error(`Cannot assign value '${value}' to ref '${ref}'`);
    }
}
function $832c7248c1f770ce$export$c9058316764c140e(...refs) {
    const availableRefs = refs.filter((ref)=>ref != null);
    if ($832c7248c1f770ce$var$shouldReturnCleanup) {
        const cleanupMap = /* @__PURE__ */ new Map();
        return (node)=>{
            availableRefs.forEach((ref)=>{
                const cleanup = $832c7248c1f770ce$export$d734136a7b018efe(ref, node);
                if (cleanup) cleanupMap.set(ref, cleanup);
            });
            return ()=>{
                availableRefs.forEach((ref)=>{
                    const cleanup = cleanupMap.get(ref);
                    if (cleanup && typeof cleanup === "function") cleanup();
                    else $832c7248c1f770ce$export$d734136a7b018efe(ref, null);
                });
                cleanupMap.clear();
            };
        };
    } else return (node)=>{
        availableRefs.forEach((ref)=>{
            $832c7248c1f770ce$export$d734136a7b018efe(ref, node);
        });
    };
}


"use strict";
function $e1589b4b448a2f71$export$8e16b83750b44988(object) {
    const clone = Object.assign({}, object);
    for(let key in clone)if (clone[key] === void 0) delete clone[key];
    return clone;
}



"use strict";
function $85d4e536cfb07d17$export$c77b7fefca3cef07(mod) {
    return mod.default || mod;
}



var $8v0nu = parcelRequire("8v0nu");

"use strict";
function $e37da3f4acd2dde0$export$9a1094f4b3924ae7(el) {
    const version = $8v0nu.version;
    if (!(0, $02f5f697eb6a66a5$export$844ec244b1367d54)(version)) return el?.ref;
    if (version.startsWith("18.")) return el?.ref;
    return el?.props?.ref;
}


"use strict";
const $a9ab35ecde99cc3b$export$f70730c3d1fc524e = (...items)=>{
    const set = items.reduce((acc, curr)=>{
        if (curr != null) curr.forEach((item)=>acc.add(item));
        return acc;
    }, /* @__PURE__ */ new Set([]));
    return Array.from(set);
};




var $8v0nu = parcelRequire("8v0nu");

"use strict";
const $a3a5d89effecc869$var$splitPropFn = (props, predicate)=>{
    const rest = {};
    const result = {};
    const allKeys = Object.keys(props);
    for (const key of allKeys)if (predicate(key)) result[key] = props[key];
    else rest[key] = props[key];
    return [
        result,
        rest
    ];
};
const $a3a5d89effecc869$export$45029c61b0073d87 = (props, keys)=>{
    const predicate = (0, $02f5f697eb6a66a5$export$f6e2535fb5126e54)(keys) ? keys : (key)=>keys.includes(key);
    return $a3a5d89effecc869$var$splitPropFn(props, predicate);
};
const $a3a5d89effecc869$export$3ea53b214fbc1986 = (keys)=>{
    return function split(props) {
        return $a3a5d89effecc869$export$45029c61b0073d87(props, keys);
    };
};



"use strict";
const $b42aa27940eea71a$var$htmlProps = /* @__PURE__ */ new Set([
    "htmlWidth",
    "htmlHeight",
    "htmlSize",
    "htmlTranslate"
]);
function $b42aa27940eea71a$export$4790f84f88141745(prop) {
    return typeof prop === "string" && $b42aa27940eea71a$var$htmlProps.has(prop);
}
function $b42aa27940eea71a$export$6c54c1eadfbe24b8(inProps, cvaRecipe, shouldForwardProps) {
    const { css: css, isValidProperty: isValidProperty } = (0, $771f18fb4c7e08d8$export$e4f18fbc74d20572)();
    const { children: children, ...props } = inProps;
    const result = (0, $8v0nu.useMemo)(()=>{
        const [forwardedProps, restProps_B] = (0, $a3a5d89effecc869$export$45029c61b0073d87)(props, (key)=>shouldForwardProps(key, cvaRecipe.variantKeys));
        const [variantProps, restProps_C] = (0, $a3a5d89effecc869$export$45029c61b0073d87)(restProps_B, cvaRecipe.variantKeys);
        const [styleProps, elementProps] = (0, $a3a5d89effecc869$export$45029c61b0073d87)(restProps_C, isValidProperty);
        return {
            forwardedProps: forwardedProps,
            variantProps: variantProps,
            styleProps: styleProps,
            elementProps: elementProps
        };
    }, [
        cvaRecipe.variantKeys,
        shouldForwardProps,
        props,
        isValidProperty
    ]);
    const { css: cssStyles, ...propStyles } = result.styleProps;
    const cvaStyles = (0, $8v0nu.useMemo)(()=>{
        const variantProps = {
            ...result.variantProps
        };
        const hasColorPalette = cvaRecipe.variantKeys.includes("colorPalette");
        const hasOrientation = cvaRecipe.variantKeys.includes("orientation");
        if (!hasColorPalette) variantProps.colorPalette = props.colorPalette;
        if (!hasOrientation) variantProps.orientation = props.orientation;
        return cvaRecipe(variantProps);
    }, [
        cvaRecipe,
        result.variantProps,
        props.colorPalette,
        props.orientation
    ]);
    const styles = (0, $8v0nu.useMemo)(()=>{
        return css(cvaStyles, ...$b42aa27940eea71a$var$toArray(cssStyles), propStyles);
    }, [
        css,
        cvaStyles,
        cssStyles,
        propStyles
    ]);
    return {
        styles: styles,
        props: {
            ...result.forwardedProps,
            ...result.elementProps,
            children: children
        }
    };
}
const $b42aa27940eea71a$var$toArray = (val)=>{
    const res = Array.isArray(val) ? val : [
        val
    ];
    return res.filter(Boolean).flat();
};


"use strict";
"use client";
const $4042601bfa1a9d25$var$isPropValid = (0, $85d4e536cfb07d17$export$c77b7fefca3cef07)((0, $5148c87bb48179e4$export$2e2bcd8739ae039));
const $4042601bfa1a9d25$var$testOmitPropsOnStringTag = $4042601bfa1a9d25$var$isPropValid;
const $4042601bfa1a9d25$var$testOmitPropsOnComponent = (key)=>key !== "theme";
const $4042601bfa1a9d25$var$composeShouldForwardProps = (tag, options, isReal)=>{
    let shouldForwardProp;
    if (options) {
        const optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? (propName)=>tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName) : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== "function" && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
let $4042601bfa1a9d25$var$isBrowser = typeof document !== "undefined";
const $4042601bfa1a9d25$var$Insertion = ({ cache: cache2, serialized: serialized, isStringTag: isStringTag })=>{
    (0, $ec8233c4b7481c30$export$580009a5da2a8b4b)(cache2, serialized, isStringTag);
    const rules = (0, $1b33946bd210aca0$export$db21c7ffa21794e7)(()=>(0, $ec8233c4b7481c30$export$6f077d94b33a01aa)(cache2, serialized, isStringTag));
    if (!$4042601bfa1a9d25$var$isBrowser && rules !== void 0) {
        let serializedNames = serialized.name;
        let next = serialized.next;
        while(next !== void 0){
            serializedNames = (0, $99474b193e949655$export$a274e22fb40f762e)(serializedNames, next.name);
            next = next.next;
        }
        return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)("style", {
            [`data-emotion`]: (0, $99474b193e949655$export$a274e22fb40f762e)(cache2.key, serializedNames),
            dangerouslySetInnerHTML: {
                __html: rules
            },
            nonce: cache2.sheet.nonce
        });
    }
    return null;
};
const $4042601bfa1a9d25$var$exceptionPropMap = {
    path: [
        "d"
    ],
    text: [
        "x",
        "y"
    ],
    circle: [
        "cx",
        "cy",
        "r"
    ],
    rect: [
        "width",
        "height",
        "x",
        "y",
        "rx",
        "ry"
    ],
    ellipse: [
        "cx",
        "cy",
        "rx",
        "ry"
    ],
    g: [
        "transform"
    ],
    stop: [
        "offset",
        "stopOpacity"
    ]
};
const $4042601bfa1a9d25$var$hasProp = (obj, prop)=>{
    return Object.prototype.hasOwnProperty.call(obj, prop);
};
const $4042601bfa1a9d25$var$createStyled = (tag, configOrCva = {}, options = {})=>{
    if ($4042601bfa1a9d25$var$hasProp($4042601bfa1a9d25$var$exceptionPropMap, tag)) {
        options.forwardProps || (options.forwardProps = []);
        const props = $4042601bfa1a9d25$var$exceptionPropMap[tag];
        options.forwardProps = (0, $a9ab35ecde99cc3b$export$f70730c3d1fc524e)([
            ...options.forwardProps,
            ...props
        ]);
    }
    const isReal = tag.__emotion_real === tag;
    const baseTag = isReal && tag.__emotion_base || tag;
    let identifierName;
    let targetClassName;
    if (options !== void 0) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    let styles = [];
    const Styled = (0, $a2100d053ea71e0f$export$efccba1c4a2ef57b)((inProps, cache2, ref)=>{
        const { cva: cva, isValidProperty: isValidProperty } = (0, $771f18fb4c7e08d8$export$e4f18fbc74d20572)();
        const cvaFn = configOrCva.__cva__ ? configOrCva : cva(configOrCva);
        const cvaRecipe = $4042601bfa1a9d25$var$mergeCva(tag.__emotion_cva, cvaFn);
        const createShouldForwardProps = (props2)=>{
            return (prop, variantKeys)=>{
                if (props2.includes(prop)) return true;
                return !variantKeys?.includes(prop) && !isValidProperty(prop);
            };
        };
        if (!options.shouldForwardProp && options.forwardProps) options.shouldForwardProp = createShouldForwardProps(options.forwardProps);
        const fallbackShouldForwardProp = (prop, variantKeys)=>{
            const emotionSfp = typeof tag === "string" && tag.charCodeAt(0) > 96 ? $4042601bfa1a9d25$var$testOmitPropsOnStringTag : $4042601bfa1a9d25$var$testOmitPropsOnComponent;
            const chakraSfp = !variantKeys?.includes(prop) && !isValidProperty(prop);
            return emotionSfp(prop) && chakraSfp;
        };
        const shouldForwardProp = $4042601bfa1a9d25$var$composeShouldForwardProps(tag, options, isReal) || fallbackShouldForwardProp;
        const propsWithDefault = $8v0nu.useMemo(()=>Object.assign({}, options.defaultProps, (0, $e1589b4b448a2f71$export$8e16b83750b44988)(inProps)), [
            inProps
        ]);
        const { props: props, styles: styleProps } = (0, $b42aa27940eea71a$export$6c54c1eadfbe24b8)(propsWithDefault, cvaRecipe, shouldForwardProp);
        let className = "";
        let classInterpolations = [
            styleProps
        ];
        let mergedProps = props;
        if (props.theme == null) {
            mergedProps = {};
            for(let key in props)mergedProps[key] = props[key];
            mergedProps.theme = $8v0nu.useContext((0, $a2100d053ea71e0f$export$971d5caa766a69d7));
        }
        if (typeof props.className === "string") className = (0, $ec8233c4b7481c30$export$95d99596f328fd52)(cache2.registered, classInterpolations, props.className);
        else if (props.className != null) className = (0, $99474b193e949655$export$a274e22fb40f762e)(className, props.className);
        const serialized = (0, $45627b3f8cf327d3$export$6321afa313b251b5)(styles.concat(classInterpolations), cache2.registered, mergedProps);
        if (serialized.styles) className = (0, $99474b193e949655$export$a274e22fb40f762e)(className, `${cache2.key}-${serialized.name}`);
        if (targetClassName !== void 0) className = (0, $99474b193e949655$export$a274e22fb40f762e)(className, targetClassName);
        const shouldUseAs = !shouldForwardProp("as");
        let FinalTag = shouldUseAs && props.as || baseTag;
        let finalProps = {};
        for(let prop in props){
            if (shouldUseAs && prop === "as") continue;
            if ((0, $b42aa27940eea71a$export$4790f84f88141745)(prop)) {
                const nativeProp = prop.replace("html", "").toLowerCase();
                finalProps[nativeProp] = props[prop];
                continue;
            }
            if (shouldForwardProp(prop)) finalProps[prop] = props[prop];
        }
        let classNameToUse = className.trim();
        if (classNameToUse) finalProps.className = classNameToUse;
        else Reflect.deleteProperty(finalProps, "className");
        finalProps.ref = ref;
        const forwardAsChild = options.forwardAsChild || options.forwardProps?.includes("asChild");
        if (props.asChild && !forwardAsChild) {
            const child = $8v0nu.isValidElement(props.children) ? $8v0nu.Children.only(props.children) : $8v0nu.Children.toArray(props.children).find($8v0nu.isValidElement);
            if (!child) throw new Error("[chakra-ui > factory] No valid child found");
            FinalTag = child.type;
            finalProps.children = null;
            Reflect.deleteProperty(finalProps, "asChild");
            finalProps = (0, $c138fae1cd321339$export$9d1611c77c2fe928)(finalProps, child.props);
            finalProps.ref = (0, $832c7248c1f770ce$export$c9058316764c140e)(ref, (0, $e37da3f4acd2dde0$export$9a1094f4b3924ae7)(child));
        }
        if (finalProps.as && forwardAsChild) {
            finalProps.as = void 0;
            return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsxs)($8v0nu.Fragment, {
                children: [
                    /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)($4042601bfa1a9d25$var$Insertion, {
                        cache: cache2,
                        serialized: serialized,
                        isStringTag: typeof FinalTag === "string"
                    }),
                    /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)(FinalTag, {
                        asChild: true,
                        ...finalProps,
                        children: /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)(props.as, {
                            children: finalProps.children
                        })
                    })
                ]
            });
        }
        return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsxs)($8v0nu.Fragment, {
            children: [
                /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)($4042601bfa1a9d25$var$Insertion, {
                    cache: cache2,
                    serialized: serialized,
                    isStringTag: typeof FinalTag === "string"
                }),
                /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)(FinalTag, {
                    ...finalProps
                })
            ]
        });
    });
    Styled.displayName = identifierName !== void 0 ? identifierName : `chakra(${typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component"})`;
    Styled.__emotion_real = Styled;
    Styled.__emotion_base = baseTag;
    Styled.__emotion_forwardProp = options.shouldForwardProp;
    Styled.__emotion_cva = configOrCva;
    Object.defineProperty(Styled, "toString", {
        value () {
            targetClassName;
            return `.${targetClassName}`;
        }
    });
    return Styled;
};
const $4042601bfa1a9d25$var$styledFn = $4042601bfa1a9d25$var$createStyled.bind();
const $4042601bfa1a9d25$var$cache = /* @__PURE__ */ new Map();
const $4042601bfa1a9d25$var$chakraImpl = new Proxy($4042601bfa1a9d25$var$styledFn, {
    apply (_, __, args) {
        return $4042601bfa1a9d25$var$styledFn(...args);
    },
    get (_, el) {
        if (!$4042601bfa1a9d25$var$cache.has(el)) $4042601bfa1a9d25$var$cache.set(el, $4042601bfa1a9d25$var$styledFn(el));
        return $4042601bfa1a9d25$var$cache.get(el);
    }
});
const $4042601bfa1a9d25$export$7cd122d781af9fa4 = $4042601bfa1a9d25$var$chakraImpl;
const $4042601bfa1a9d25$var$mergeCva = (cvaA, cvaB)=>{
    if (cvaA && !cvaB) return cvaA;
    if (!cvaA && cvaB) return cvaB;
    return cvaA.merge(cvaB);
};



var $8v0nu = parcelRequire("8v0nu");

"use strict";
"use client";
function $971213434541a23d$export$cf0e09a7086104ff(options) {
    const { key: key, recipe: recipeProp } = options;
    const sys = (0, $771f18fb4c7e08d8$export$e4f18fbc74d20572)();
    return (0, $8v0nu.useMemo)(()=>{
        const recipe = recipeProp || (key != null ? sys.getRecipe(key) : {});
        return sys.cva(structuredClone(recipe));
    }, [
        key,
        recipeProp,
        sys
    ]);
}


"use strict";
"use client";
function $aa5f4d03028a5427$export$e99ac154c18649c5(options) {
    const { key: recipeKey, recipe: recipeConfig } = options;
    const contextName = (0, $53eb36df3e1e11a3$export$3061f22cd819074d)(recipeKey || recipeConfig.className || "Component");
    const [PropsProvider, usePropsContext] = (0, $542c4e2ea7b8b6b9$export$fd42f52fd3ae1109)({
        strict: false,
        name: `${contextName}PropsContext`,
        providerName: `${contextName}PropsContext`
    });
    function useRecipeResult(props) {
        const { unstyled: unstyled, ...restProps } = props;
        const recipe = (0, $971213434541a23d$export$cf0e09a7086104ff)({
            key: recipeKey,
            recipe: restProps.recipe || recipeConfig
        });
        const [variantProps, otherProps] = (0, $8v0nu.useMemo)(()=>recipe.splitVariantProps(restProps), [
            recipe,
            restProps
        ]);
        const styles = unstyled ? (0, $0fb716203df70dd7$export$e37f626c01cb373a) : recipe(variantProps);
        return {
            styles: styles,
            className: recipe.className,
            props: otherProps
        };
    }
    const withContext = (Component, options2)=>{
        const { displayName: displayNameOverride, ...chakraOptions } = options2 ?? {};
        const SuperComponent = (0, $4042601bfa1a9d25$export$7cd122d781af9fa4)(Component, {}, chakraOptions);
        const StyledComponent = (0, $8v0nu.forwardRef)((inProps, ref)=>{
            const propsContext = usePropsContext();
            const props = (0, $8v0nu.useMemo)(()=>(0, $c138fae1cd321339$export$9d1611c77c2fe928)(propsContext, inProps), [
                inProps,
                propsContext
            ]);
            const { styles: styles, className: className, props: localProps } = useRecipeResult(props);
            return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)(SuperComponent, {
                ...localProps,
                ref: ref,
                css: [
                    styles,
                    props.css
                ],
                className: (0, $99474b193e949655$export$a274e22fb40f762e)(className, props.className)
            });
        });
        StyledComponent.displayName = displayNameOverride ?? contextName ?? (0, $53eb36df3e1e11a3$export$781f7f324ca6010c)(Component);
        return StyledComponent;
    };
    function withPropsProvider() {
        return PropsProvider;
    }
    return {
        withContext: withContext,
        PropsProvider: PropsProvider,
        withPropsProvider: withPropsProvider,
        usePropsContext: usePropsContext,
        useRecipeResult: useRecipeResult
    };
}


"use strict";
"use client";
const { PropsProvider: $486a1f24d187216b$export$4e02b9968dad1f, withContext: $486a1f24d187216b$export$86775893490a9f43 } = (0, $aa5f4d03028a5427$export$e99ac154c18649c5)({
    key: "badge"
});
const $486a1f24d187216b$export$37acb3580601e69a = $486a1f24d187216b$export$86775893490a9f43("span");
const $486a1f24d187216b$export$15940449b0746c49 = $486a1f24d187216b$export$4e02b9968dad1f;


"use strict";
"use client";
const $1415810625b263eb$export$e71c4d32a2263218 = (0, $4042601bfa1a9d25$export$7cd122d781af9fa4)("div");
$1415810625b263eb$export$e71c4d32a2263218.displayName = "Box";


"use strict";
"use client";
const { withContext: $655f1686b6512ed9$var$withContext, PropsProvider: $655f1686b6512ed9$var$PropsProvider } = (0, $aa5f4d03028a5427$export$e99ac154c18649c5)({
    key: "container"
});
const $655f1686b6512ed9$export$42a852a2b6b56249 = $655f1686b6512ed9$var$withContext("div");
const $655f1686b6512ed9$export$65f1f05d2478f85b = $655f1686b6512ed9$var$PropsProvider;



var $8v0nu = parcelRequire("8v0nu");

"use strict";
"use client";
const $386ff1fd0b4cfff1$export$f51f4c4ede09e011 = (0, $8v0nu.forwardRef)(function Flex2(props, ref) {
    const { direction: direction, align: align, justify: justify, wrap: wrap, basis: basis, grow: grow, shrink: shrink, inline: inline, ...rest } = props;
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $4042601bfa1a9d25$export$7cd122d781af9fa4).div, {
        ref: ref,
        ...rest,
        css: {
            display: inline ? "inline-flex" : "flex",
            flexDirection: direction,
            alignItems: align,
            justifyContent: justify,
            flexWrap: wrap,
            flexBasis: basis,
            flexGrow: grow,
            flexShrink: shrink,
            ...props.css
        }
    });
});
$386ff1fd0b4cfff1$export$f51f4c4ede09e011.displayName = "Flex";


"use strict";
"use client";
const { withContext: $5dcf33ee745c0ffc$var$withContext, PropsProvider: $5dcf33ee745c0ffc$var$PropsProvider } = (0, $aa5f4d03028a5427$export$e99ac154c18649c5)({
    key: "heading"
});
const $5dcf33ee745c0ffc$export$a8a3e93435678ff9 = $5dcf33ee745c0ffc$var$withContext("h2");
const $5dcf33ee745c0ffc$export$75dc054942fe7313 = $5dcf33ee745c0ffc$var$PropsProvider;



var $8v0nu = parcelRequire("8v0nu");


"use strict";
"use client";
const $b3ebe15a85950994$export$3e431a229df88919 = (0, $8v0nu.forwardRef)(function Image2(props, ref) {
    const { align: align, fit: fit = "cover", ...rest } = props;
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $4042601bfa1a9d25$export$7cd122d781af9fa4).img, {
        ref: ref,
        objectFit: fit,
        objectPosition: align,
        className: (0, $99474b193e949655$export$a274e22fb40f762e)("chakra-image", props.className),
        ...rest
    });
});
$b3ebe15a85950994$export$3e431a229df88919.displayName = "Image";



var $8v0nu = parcelRequire("8v0nu");




"use strict";
function $e505178ce7dbf967$export$30a06c8d3562193f(object, keysToOmit = []) {
    const clone = Object.assign({}, object);
    for (const key of keysToOmit)if (key in clone) delete clone[key];
    return clone;
}


"use strict";
"use client";
const { useRecipeResult: $01474eb65f0b7d4e$var$useRecipeResult, PropsProvider: $01474eb65f0b7d4e$var$PropsProvider } = (0, $aa5f4d03028a5427$export$e99ac154c18649c5)({
    key: "separator"
});
const $01474eb65f0b7d4e$export$1ff3c3f08ae963c0 = (0, $8v0nu.forwardRef)(function Separator2(props, ref) {
    const { styles: styles, className: className, props: otherProps } = $01474eb65f0b7d4e$var$useRecipeResult(props);
    const orientation = props.orientation || "horizontal";
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $4042601bfa1a9d25$export$7cd122d781af9fa4).span, {
        ref: ref,
        role: (0, $02f5f697eb6a66a5$export$844ec244b1367d54)(orientation) ? "separator" : "presentation",
        "aria-orientation": (0, $02f5f697eb6a66a5$export$844ec244b1367d54)(orientation) ? orientation : void 0,
        ...(0, $e505178ce7dbf967$export$30a06c8d3562193f)(otherProps, [
            "orientation"
        ]),
        className: (0, $99474b193e949655$export$a274e22fb40f762e)(className, props.className),
        css: [
            styles,
            props.css
        ]
    });
});
$01474eb65f0b7d4e$export$1ff3c3f08ae963c0.displayName = "Separator";
const $01474eb65f0b7d4e$export$adfab695983766e1 = $01474eb65f0b7d4e$var$PropsProvider;


"use strict";
"use client";
const { withContext: $9318c0c5b8c25a88$var$withContext, PropsProvider: $9318c0c5b8c25a88$var$PropsProvider } = (0, $aa5f4d03028a5427$export$e99ac154c18649c5)({
    key: "text"
});
const $9318c0c5b8c25a88$export$5f1af8db9871e1d6 = $9318c0c5b8c25a88$var$withContext("p");
const $9318c0c5b8c25a88$export$36a604bba6f5a410 = $9318c0c5b8c25a88$var$PropsProvider;




var $8v0nu = parcelRequire("8v0nu");

var $8v0nu = parcelRequire("8v0nu");
"use client";
const $f8fa84f618a4fe1a$export$a3579ca508007a95 = (0, $8v0nu.createContext)({});



var $8v0nu = parcelRequire("8v0nu");
"use client";
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $01b8aedaf4ac1f4d$export$fe4300aa8eebea86(init) {
    const ref = (0, $8v0nu.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}



var $8v0nu = parcelRequire("8v0nu");
const $e1934d508facd30d$export$4e09c449d6c407f7 = typeof window !== "undefined";


"use client";
const $0e2bf99806b8255e$export$700979bc83e7db82 = (0, $e1934d508facd30d$export$4e09c449d6c407f7) ? (0, $8v0nu.useLayoutEffect) : (0, $8v0nu.useEffect);




var $8v0nu = parcelRequire("8v0nu");

var $8v0nu = parcelRequire("8v0nu");
"use client";
/**
 * @public
 */ const $af42344d352b5efc$export$f224e4635b6f8ce2 = /* @__PURE__ */ (0, $8v0nu.createContext)(null);




const $8d70e9a72ff93dfc$export$a6cdc56e425d0d0a = (value)=>typeof value === "object" && value !== null;


/**
 * Checks if an element is an HTML element in a way
 * that works across iframes
 */ function $a9f5ee1e84ae0957$export$1b3bfaa9684536aa(element) {
    return (0, $8d70e9a72ff93dfc$export$a6cdc56e425d0d0a)(element) && "offsetHeight" in element && !("ownerSVGElement" in element);
}



var $8v0nu = parcelRequire("8v0nu");

var $8v0nu = parcelRequire("8v0nu");
"use client";
/**
 * @public
 */ const $1dcdcab29f5a59b3$export$22a697fb29aac98d = (0, $8v0nu.createContext)({
    transformPagePoint: (p)=>p,
    isStatic: false,
    reducedMotion: "never"
});



var $8v0nu = parcelRequire("8v0nu");
/**
 * Taken from https://github.com/radix-ui/primitives/blob/main/packages/react/compose-refs/src/compose-refs.tsx
 */ /**
 * Set a given ref to a given value
 * This utility takes care of different types of refs: callback refs and RefObject(s)
 */ function $e2b0dbb8ee0c1ecf$var$setRef(ref, value) {
    if (typeof ref === "function") return ref(value);
    else if (ref !== null && ref !== undefined) ref.current = value;
}
/**
 * A utility to compose multiple refs together
 * Accepts callback refs and RefObject(s)
 */ function $e2b0dbb8ee0c1ecf$var$composeRefs(...refs) {
    return (node)=>{
        let hasCleanup = false;
        const cleanups = refs.map((ref)=>{
            const cleanup = $e2b0dbb8ee0c1ecf$var$setRef(ref, node);
            if (!hasCleanup && typeof cleanup === "function") hasCleanup = true;
            return cleanup;
        });
        // React <19 will log an error to the console if a callback ref returns a
        // value. We don't use ref cleanups internally so this will only happen if a
        // user's ref callback returns a value, which we only expect if they are
        // using the cleanup functionality added in React 19.
        if (hasCleanup) return ()=>{
            for(let i = 0; i < cleanups.length; i++){
                const cleanup = cleanups[i];
                if (typeof cleanup === "function") cleanup();
                else $e2b0dbb8ee0c1ecf$var$setRef(refs[i], null);
            }
        };
    };
}
/**
 * A custom hook that composes multiple refs
 * Accepts callback refs and RefObject(s)
 */ function $e2b0dbb8ee0c1ecf$export$c7b2cbe3552a0d05(...refs) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return $8v0nu.useCallback($e2b0dbb8ee0c1ecf$var$composeRefs(...refs), refs);
}


"use client";
/**
 * Measurement functionality has to be within a separate component
 * to leverage snapshot lifecycle.
 */ class $dad16b534d3de887$var$PopChildMeasure extends $8v0nu.Component {
    getSnapshotBeforeUpdate(prevProps) {
        const element = this.props.childRef.current;
        if ((0, $a9f5ee1e84ae0957$export$1b3bfaa9684536aa)(element) && prevProps.isPresent && !this.props.isPresent && this.props.pop !== false) {
            const parent = element.offsetParent;
            const parentWidth = (0, $a9f5ee1e84ae0957$export$1b3bfaa9684536aa)(parent) ? parent.offsetWidth || 0 : 0;
            const parentHeight = (0, $a9f5ee1e84ae0957$export$1b3bfaa9684536aa)(parent) ? parent.offsetHeight || 0 : 0;
            const computedStyle = getComputedStyle(element);
            const size = this.props.sizeRef.current;
            size.height = parseFloat(computedStyle.height);
            size.width = parseFloat(computedStyle.width);
            size.top = element.offsetTop;
            size.left = element.offsetLeft;
            size.right = parentWidth - size.width - size.left;
            size.bottom = parentHeight - size.height - size.top;
            size.direction = computedStyle.direction;
        }
        return null;
    }
    /**
     * Required with getSnapshotBeforeUpdate to stop React complaining.
     */ componentDidUpdate() {}
    render() {
        return this.props.children;
    }
}
function $dad16b534d3de887$export$1d6cdde0c6816c6d({ children: children, isPresent: isPresent, anchorX: anchorX, anchorY: anchorY, root: root, pop: pop }) {
    const id = (0, $8v0nu.useId)();
    const ref = (0, $8v0nu.useRef)(null);
    const size = (0, $8v0nu.useRef)({
        width: 0,
        height: 0,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        direction: "ltr"
    });
    const { nonce: nonce } = (0, $8v0nu.useContext)((0, $1dcdcab29f5a59b3$export$22a697fb29aac98d));
    /**
     * In React 19, refs are passed via props.ref instead of element.ref.
     * We check props.ref first (React 19) and fall back to element.ref (React 18).
     */ const childRef = children.props?.ref ?? children?.ref;
    const composedRef = (0, $e2b0dbb8ee0c1ecf$export$c7b2cbe3552a0d05)(ref, childRef);
    /**
     * We create and inject a style block so we can apply this explicit
     * sizing in a non-destructive manner by just deleting the style block.
     *
     * We can't apply size via render as the measurement happens
     * in getSnapshotBeforeUpdate (post-render), likewise if we apply the
     * styles directly on the DOM node, we might be overwriting
     * styles set via the style prop.
     */ (0, $8v0nu.useInsertionEffect)(()=>{
        const { width: width, height: height, top: top, left: left, right: right, bottom: bottom, direction: direction } = size.current;
        if (isPresent || pop === false || !ref.current || !width || !height) return;
        const isRTL = direction === "rtl";
        const x = anchorX === "left" ? isRTL ? `right: ${right}` : `left: ${left}` : isRTL ? `left: ${left}` : `right: ${right}`;
        const y = anchorY === "bottom" ? `bottom: ${bottom}` : `top: ${top}`;
        ref.current.dataset.motionPopId = id;
        const style = document.createElement("style");
        if (nonce) style.nonce = nonce;
        const parent = root ?? document.head;
        parent.appendChild(style);
        if (style.sheet) style.sheet.insertRule(`
          [data-motion-pop-id="${id}"] {
            position: absolute !important;
            width: ${width}px !important;
            height: ${height}px !important;
            ${x}px !important;
            ${y}px !important;
          }
        `);
        return ()=>{
            ref.current?.removeAttribute("data-motion-pop-id");
            if (parent.contains(style)) parent.removeChild(style);
        };
    }, [
        isPresent
    ]);
    return (0, $ef524fb144c5d632$exports.jsx)($dad16b534d3de887$var$PopChildMeasure, {
        isPresent: isPresent,
        childRef: ref,
        sizeRef: size,
        pop: pop,
        children: pop === false ? children : $8v0nu.cloneElement(children, {
            ref: composedRef
        })
    });
}


"use client";
const $b408ae5bb45d75d9$export$979daf65881a382a = ({ children: children, initial: initial, isPresent: isPresent, onExitComplete: onExitComplete, custom: custom, presenceAffectsLayout: presenceAffectsLayout, mode: mode, anchorX: anchorX, anchorY: anchorY, root: root })=>{
    const presenceChildren = (0, $01b8aedaf4ac1f4d$export$fe4300aa8eebea86)($b408ae5bb45d75d9$var$newChildrenMap);
    const id = (0, $8v0nu.useId)();
    let isReusedContext = true;
    let context = (0, $8v0nu.useMemo)(()=>{
        isReusedContext = false;
        return {
            id: id,
            initial: initial,
            isPresent: isPresent,
            custom: custom,
            onExitComplete: (childId)=>{
                presenceChildren.set(childId, true);
                for (const isComplete of presenceChildren.values()){
                    if (!isComplete) return; // can stop searching when any is incomplete
                }
                onExitComplete && onExitComplete();
            },
            register: (childId)=>{
                presenceChildren.set(childId, false);
                return ()=>presenceChildren.delete(childId);
            }
        };
    }, [
        isPresent,
        presenceChildren,
        onExitComplete
    ]);
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */ if (presenceAffectsLayout && isReusedContext) context = {
        ...context
    };
    (0, $8v0nu.useMemo)(()=>{
        presenceChildren.forEach((_, key)=>presenceChildren.set(key, false));
    }, [
        isPresent
    ]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */ $8v0nu.useEffect(()=>{
        !isPresent && !presenceChildren.size && onExitComplete && onExitComplete();
    }, [
        isPresent
    ]);
    children = (0, $ef524fb144c5d632$exports.jsx)((0, $dad16b534d3de887$export$1d6cdde0c6816c6d), {
        pop: mode === "popLayout",
        isPresent: isPresent,
        anchorX: anchorX,
        anchorY: anchorY,
        root: root,
        children: children
    });
    return (0, $ef524fb144c5d632$exports.jsx)((0, $af42344d352b5efc$export$f224e4635b6f8ce2).Provider, {
        value: context,
        children: children
    });
};
function $b408ae5bb45d75d9$var$newChildrenMap() {
    return new Map();
}



var $8v0nu = parcelRequire("8v0nu");

"use client";
/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed from the tree,
 * but `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $178906c13254c0f7$export$2a8c16d82a0a0e26(subscribe = true) {
    const context = (0, $8v0nu.useContext)((0, $af42344d352b5efc$export$f224e4635b6f8ce2));
    if (context === null) return [
        true,
        null
    ];
    const { isPresent: isPresent, onExitComplete: onExitComplete, register: register } = context;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    const id = (0, $8v0nu.useId)();
    (0, $8v0nu.useEffect)(()=>{
        if (subscribe) return register(id);
    }, [
        subscribe
    ]);
    const safeToRemove = (0, $8v0nu.useCallback)(()=>subscribe && onExitComplete && onExitComplete(id), [
        id,
        onExitComplete,
        subscribe
    ]);
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $178906c13254c0f7$export$8249053f690ea39a() {
    return $178906c13254c0f7$export$ee27c052bca048fb((0, $8v0nu.useContext)((0, $af42344d352b5efc$export$f224e4635b6f8ce2)));
}
function $178906c13254c0f7$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}



var $8v0nu = parcelRequire("8v0nu");
const $3549615a7019db97$export$10e61aed958678dd = (child)=>child.key || "";
function $3549615a7019db97$export$872a3a1281f4b357(children) {
    const filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    (0, $8v0nu.Children).forEach(children, (child)=>{
        if ((0, $8v0nu.isValidElement)(child)) filtered.push(child);
    });
    return filtered;
}


"use client";
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */ const $f1f51be609a91d37$export$3ae376d12526dd6f = ({ children: children, custom: custom, initial: initial = true, onExitComplete: onExitComplete, presenceAffectsLayout: presenceAffectsLayout = true, mode: mode = "sync", propagate: propagate = false, anchorX: anchorX = "left", anchorY: anchorY = "top", root: root })=>{
    const [isParentPresent, safeToRemove] = (0, $178906c13254c0f7$export$2a8c16d82a0a0e26)(propagate);
    /**
     * Filter any children that aren't ReactElements. We can only track components
     * between renders with a props.key.
     */ const presentChildren = (0, $8v0nu.useMemo)(()=>(0, $3549615a7019db97$export$872a3a1281f4b357)(children), [
        children
    ]);
    /**
     * Track the keys of the currently rendered children. This is used to
     * determine which children are exiting.
     */ const presentKeys = propagate && !isParentPresent ? [] : presentChildren.map((0, $3549615a7019db97$export$10e61aed958678dd));
    /**
     * If `initial={false}` we only want to pass this to components in the first render.
     */ const isInitialRender = (0, $8v0nu.useRef)(true);
    /**
     * A ref containing the currently present children. When all exit animations
     * are complete, we use this to re-render the component with the latest children
     * *committed* rather than the latest children *rendered*.
     */ const pendingPresentChildren = (0, $8v0nu.useRef)(presentChildren);
    /**
     * Track which exiting children have finished animating out.
     */ const exitComplete = (0, $01b8aedaf4ac1f4d$export$fe4300aa8eebea86)(()=>new Map());
    /**
     * Track which components are currently processing exit to prevent duplicate processing.
     */ const exitingComponents = (0, $8v0nu.useRef)(new Set());
    /**
     * Save children to render as React state. To ensure this component is concurrent-safe,
     * we check for exiting children via an effect.
     */ const [diffedChildren, setDiffedChildren] = (0, $8v0nu.useState)(presentChildren);
    const [renderedChildren, setRenderedChildren] = (0, $8v0nu.useState)(presentChildren);
    (0, $0e2bf99806b8255e$export$700979bc83e7db82)(()=>{
        isInitialRender.current = false;
        pendingPresentChildren.current = presentChildren;
        /**
         * Update complete status of exiting children.
         */ for(let i = 0; i < renderedChildren.length; i++){
            const key = (0, $3549615a7019db97$export$10e61aed958678dd)(renderedChildren[i]);
            if (!presentKeys.includes(key)) {
                if (exitComplete.get(key) !== true) exitComplete.set(key, false);
            } else {
                exitComplete.delete(key);
                exitingComponents.current.delete(key);
            }
        }
    }, [
        renderedChildren,
        presentKeys.length,
        presentKeys.join("-")
    ]);
    const exitingChildren = [];
    if (presentChildren !== diffedChildren) {
        let nextChildren = [
            ...presentChildren
        ];
        /**
         * Loop through all the currently rendered components and decide which
         * are exiting.
         */ for(let i = 0; i < renderedChildren.length; i++){
            const child = renderedChildren[i];
            const key = (0, $3549615a7019db97$export$10e61aed958678dd)(child);
            if (!presentKeys.includes(key)) {
                nextChildren.splice(i, 0, child);
                exitingChildren.push(child);
            }
        }
        /**
         * If we're in "wait" mode, and we have exiting children, we want to
         * only render these until they've all exited.
         */ if (mode === "wait" && exitingChildren.length) nextChildren = exitingChildren;
        setRenderedChildren((0, $3549615a7019db97$export$872a3a1281f4b357)(nextChildren));
        setDiffedChildren(presentChildren);
        /**
         * Early return to ensure once we've set state with the latest diffed
         * children, we can immediately re-render.
         */ return null;
    }
    /**
     * If we've been provided a forceRender function by the LayoutGroupContext,
     * we can use it to force a re-render amongst all surrounding components once
     * all components have finished animating out.
     */ const { forceRender: forceRender } = (0, $8v0nu.useContext)((0, $f8fa84f618a4fe1a$export$a3579ca508007a95));
    return (0, $ef524fb144c5d632$exports.jsx)((0, $ef524fb144c5d632$exports.Fragment), {
        children: renderedChildren.map((child)=>{
            const key = (0, $3549615a7019db97$export$10e61aed958678dd)(child);
            const isPresent = propagate && !isParentPresent ? false : presentChildren === renderedChildren || presentKeys.includes(key);
            const onExit = ()=>{
                if (exitingComponents.current.has(key)) return;
                if (exitComplete.has(key)) {
                    exitingComponents.current.add(key);
                    exitComplete.set(key, true);
                } else return;
                let isEveryExitComplete = true;
                exitComplete.forEach((isExitComplete)=>{
                    if (!isExitComplete) isEveryExitComplete = false;
                });
                if (isEveryExitComplete) {
                    forceRender?.();
                    setRenderedChildren(pendingPresentChildren.current);
                    propagate && safeToRemove?.();
                    onExitComplete && onExitComplete();
                }
            };
            return (0, $ef524fb144c5d632$exports.jsx)((0, $b408ae5bb45d75d9$export$979daf65881a382a), {
                isPresent: isPresent,
                initial: !isInitialRender.current || initial ? undefined : false,
                custom: custom,
                presenceAffectsLayout: presenceAffectsLayout,
                mode: mode,
                root: root,
                onExitComplete: isPresent ? undefined : onExit,
                anchorX: anchorX,
                anchorY: anchorY,
                children: child
            }, key);
        })
    });
};

const $8c245764d0d5c573$var$checkStringStartsWith = (token)=>(key)=>typeof key === "string" && key.startsWith(token);
const $8c245764d0d5c573$export$9de1236619d9e756 = /*@__PURE__*/ $8c245764d0d5c573$var$checkStringStartsWith("--");
const $8c245764d0d5c573$var$startsAsVariableToken = /*@__PURE__*/ $8c245764d0d5c573$var$checkStringStartsWith("var(--");
const $8c245764d0d5c573$export$31f9caa2600b5723 = (value)=>{
    const startsWithToken = $8c245764d0d5c573$var$startsAsVariableToken(value);
    if (!startsWithToken) return false;
    // Ensure any comments are stripped from the value as this can harm performance of the regex.
    return $8c245764d0d5c573$var$singleCssVariableRegex.test(value.split("/*")[0].trim());
};
const $8c245764d0d5c573$var$singleCssVariableRegex = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;
/**
 * Check if a value contains a CSS variable anywhere (e.g. inside calc()).
 * Unlike isCSSVariableToken which checks if the value IS a var() token,
 * this checks if the value CONTAINS var() somewhere in the string.
 */ function $8c245764d0d5c573$export$df8f90ab5d0b05fa(value) {
    if (typeof value !== "string") return false;
    // Strip comments to avoid false positives
    return value.split("/*")[0].includes("var(--");
}


/**
 * Generate a list of every possible transform key.
 */ const $505b0017451a5f76$export$280dc01950909d86 = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 *
 * `pathRotation` is a transform for routing purposes (skipped from raw
 * style application, wired to the transform composite, flags transform
 * dirty) but is intentionally NOT in `transformPropOrder` — it is
 * composed onto `rotate` at the build sites, not serialized in its own
 * slot, and must stay out of the order-array consumers (parse-transform,
 * unit-conversion, keys-position).
 */ const $505b0017451a5f76$export$7b42a0094fb00b6e = /*@__PURE__*/ (()=>new Set([
        ...$505b0017451a5f76$export$280dc01950909d86,
        "pathRotation"
    ]))();


const $ffe0bf72d53f9a3c$var$radToDeg = (rad)=>rad * 180 / Math.PI;
const $ffe0bf72d53f9a3c$var$rotate = (v)=>{
    const angle = $ffe0bf72d53f9a3c$var$radToDeg(Math.atan2(v[1], v[0]));
    return $ffe0bf72d53f9a3c$var$rebaseAngle(angle);
};
const $ffe0bf72d53f9a3c$var$matrix2dParsers = {
    x: 4,
    y: 5,
    translateX: 4,
    translateY: 5,
    scaleX: 0,
    scaleY: 3,
    scale: (v)=>(Math.abs(v[0]) + Math.abs(v[3])) / 2,
    rotate: $ffe0bf72d53f9a3c$var$rotate,
    rotateZ: $ffe0bf72d53f9a3c$var$rotate,
    skewX: (v)=>$ffe0bf72d53f9a3c$var$radToDeg(Math.atan(v[1])),
    skewY: (v)=>$ffe0bf72d53f9a3c$var$radToDeg(Math.atan(v[2])),
    skew: (v)=>(Math.abs(v[1]) + Math.abs(v[2])) / 2
};
const $ffe0bf72d53f9a3c$var$rebaseAngle = (angle)=>{
    angle = angle % 360;
    if (angle < 0) angle += 360;
    return angle;
};
const $ffe0bf72d53f9a3c$var$rotateZ = $ffe0bf72d53f9a3c$var$rotate;
const $ffe0bf72d53f9a3c$var$scaleX = (v)=>Math.sqrt(v[0] * v[0] + v[1] * v[1]);
const $ffe0bf72d53f9a3c$var$scaleY = (v)=>Math.sqrt(v[4] * v[4] + v[5] * v[5]);
const $ffe0bf72d53f9a3c$var$matrix3dParsers = {
    x: 12,
    y: 13,
    z: 14,
    translateX: 12,
    translateY: 13,
    translateZ: 14,
    scaleX: $ffe0bf72d53f9a3c$var$scaleX,
    scaleY: $ffe0bf72d53f9a3c$var$scaleY,
    scale: (v)=>($ffe0bf72d53f9a3c$var$scaleX(v) + $ffe0bf72d53f9a3c$var$scaleY(v)) / 2,
    rotateX: (v)=>$ffe0bf72d53f9a3c$var$rebaseAngle($ffe0bf72d53f9a3c$var$radToDeg(Math.atan2(v[6], v[5]))),
    rotateY: (v)=>$ffe0bf72d53f9a3c$var$rebaseAngle($ffe0bf72d53f9a3c$var$radToDeg(Math.atan2(-v[2], v[0]))),
    rotateZ: $ffe0bf72d53f9a3c$var$rotateZ,
    rotate: $ffe0bf72d53f9a3c$var$rotateZ,
    skewX: (v)=>$ffe0bf72d53f9a3c$var$radToDeg(Math.atan(v[4])),
    skewY: (v)=>$ffe0bf72d53f9a3c$var$radToDeg(Math.atan(v[1])),
    skew: (v)=>(Math.abs(v[1]) + Math.abs(v[4])) / 2
};
function $ffe0bf72d53f9a3c$export$1f10c01143b9f089(name) {
    return name.includes("scale") ? 1 : 0;
}
function $ffe0bf72d53f9a3c$export$f9111f9e16b73a26(transform, name) {
    if (!transform || transform === "none") return $ffe0bf72d53f9a3c$export$1f10c01143b9f089(name);
    const matrix3dMatch = transform.match(/^matrix3d\(([-\d.e\s,]+)\)$/u);
    let parsers;
    let match;
    if (matrix3dMatch) {
        parsers = $ffe0bf72d53f9a3c$var$matrix3dParsers;
        match = matrix3dMatch;
    } else {
        const matrix2dMatch = transform.match(/^matrix\(([-\d.e\s,]+)\)$/u);
        parsers = $ffe0bf72d53f9a3c$var$matrix2dParsers;
        match = matrix2dMatch;
    }
    if (!match) return $ffe0bf72d53f9a3c$export$1f10c01143b9f089(name);
    const valueParser = parsers[name];
    const values = match[1].split(",").map($ffe0bf72d53f9a3c$var$convertTransformToNumber);
    return typeof valueParser === "function" ? valueParser(values) : values[valueParser];
}
const $ffe0bf72d53f9a3c$export$bcd97e0e03ba17f6 = (instance, name)=>{
    const { transform: transform = "none" } = getComputedStyle(instance);
    return $ffe0bf72d53f9a3c$export$f9111f9e16b73a26(transform, name);
};
function $ffe0bf72d53f9a3c$var$convertTransformToNumber(value) {
    return parseFloat(value.trim());
}


/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $528c11c0d7848230$export$d3955c6a8f65a36b({ top: top, left: left, right: right, bottom: bottom }) {
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $528c11c0d7848230$export$b6b9cd4198191a47({ x: x, y: y }) {
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $528c11c0d7848230$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    const topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    const bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}


/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ const $33875f370c178373$export$3bb0b4ff1037b8dd = (from, to, progress)=>{
    return from + (to - from) * progress;
};


function $3b8111ac66a02336$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $3b8111ac66a02336$export$bdf30dca883ea463({ scale: scale, scaleX: scaleX, scaleY: scaleY }) {
    return !$3b8111ac66a02336$var$isIdentityScale(scale) || !$3b8111ac66a02336$var$isIdentityScale(scaleX) || !$3b8111ac66a02336$var$isIdentityScale(scaleY);
}
function $3b8111ac66a02336$export$a545127cf1fbb600(values) {
    return $3b8111ac66a02336$export$bdf30dca883ea463(values) || $3b8111ac66a02336$export$bf80f5f8f4dc327f(values) || values.z || values.rotate || values.rotateX || values.rotateY || values.skewX || values.skewY;
}
function $3b8111ac66a02336$export$bf80f5f8f4dc327f(values) {
    return $3b8111ac66a02336$var$is2DTranslate(values.x) || $3b8111ac66a02336$var$is2DTranslate(values.y);
}
function $3b8111ac66a02336$var$is2DTranslate(value) {
    return value && value !== "0%";
}


/**
 * Scales a point based on a factor and an originPoint
 */ function $ee10a003285526dc$export$2290ec7febe36dd6(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $ee10a003285526dc$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $ee10a003285526dc$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $ee10a003285526dc$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $ee10a003285526dc$export$e8e3a712e9ebf422(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = $ee10a003285526dc$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $ee10a003285526dc$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $ee10a003285526dc$export$d80074982803af5c(box, { x: x, y: y }) {
    $ee10a003285526dc$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $ee10a003285526dc$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
const $ee10a003285526dc$var$TREE_SCALE_SNAP_MIN = 0.999999999999;
const $ee10a003285526dc$var$TREE_SCALE_SNAP_MAX = 1.0000000000001;
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $ee10a003285526dc$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition = false) {
    const treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for(let i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ const { visualElement: visualElement } = node.options;
        if (visualElement && visualElement.props.style && visualElement.props.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) {
            $ee10a003285526dc$export$a807a5ce5ebb3895(box.x, -node.scroll.offset.x);
            $ee10a003285526dc$export$a807a5ce5ebb3895(box.y, -node.scroll.offset.y);
        }
        if (delta) {
            // Incoporate each ancestor's scale into a cumulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $ee10a003285526dc$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $3b8111ac66a02336$export$a545127cf1fbb600)(node.latestValues)) $ee10a003285526dc$export$58b16271041fbfb(box, node.latestValues, node.layout?.layoutBox);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ if (treeScale.x < $ee10a003285526dc$var$TREE_SCALE_SNAP_MAX && treeScale.x > $ee10a003285526dc$var$TREE_SCALE_SNAP_MIN) treeScale.x = 1.0;
    if (treeScale.y < $ee10a003285526dc$var$TREE_SCALE_SNAP_MAX && treeScale.y > $ee10a003285526dc$var$TREE_SCALE_SNAP_MIN) treeScale.y = 1.0;
}
function $ee10a003285526dc$export$a807a5ce5ebb3895(axis, distance) {
    axis.min += distance;
    axis.max += distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $ee10a003285526dc$export$625f1dd140a2f5e7(axis, axisTranslate, axisScale, boxScale, axisOrigin = 0.5) {
    const originPoint = (0, $33875f370c178373$export$3bb0b4ff1037b8dd)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $ee10a003285526dc$export$e8e3a712e9ebf422(axis, axisTranslate, axisScale, originPoint, boxScale);
}
function $ee10a003285526dc$var$resolveAxisTranslate(value, axis) {
    if (typeof value === "string") return parseFloat(value) / 100 * (axis.max - axis.min);
    return value;
}
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $ee10a003285526dc$export$58b16271041fbfb(box, transform, sourceBox) {
    const resolveBox = sourceBox ?? box;
    $ee10a003285526dc$export$625f1dd140a2f5e7(box.x, $ee10a003285526dc$var$resolveAxisTranslate(transform.x, resolveBox.x), transform.scaleX, transform.scale, transform.originX);
    $ee10a003285526dc$export$625f1dd140a2f5e7(box.y, $ee10a003285526dc$var$resolveAxisTranslate(transform.y, resolveBox.y), transform.scaleY, transform.scale, transform.originY);
}


function $a55bdfd27a922601$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $528c11c0d7848230$export$d3955c6a8f65a36b)((0, $528c11c0d7848230$export$21543fb75483a50)(instance.getBoundingClientRect(), transformPoint));
}
function $a55bdfd27a922601$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = $a55bdfd27a922601$export$d8718b6a7e5c624e(element, transformPagePoint);
    const { scroll: scroll } = rootProjectionNode;
    if (scroll) {
        (0, $ee10a003285526dc$export$a807a5ce5ebb3895)(viewportBox.x, scroll.offset.x);
        (0, $ee10a003285526dc$export$a807a5ce5ebb3895)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}


const $b2042ca666edf2e9$export$605d60a2578142d3 = (value)=>Boolean(value && value.getVelocity);



const $2597a137a910406a$export$c66c0d5db2a205d = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    ...(0, $505b0017451a5f76$export$280dc01950909d86)
]);


/**
 * ValueType for "auto"
 */ const $efdb1bfcfc56afa5$export$dfb5619354ba860 = {
    test: (v)=>v === "auto",
    parse: (v)=>v
};


const $c7d27346dbc155b2$export$7d15b64cf5a3a4c4 = (min, max, v)=>{
    if (v > max) return max;
    if (v < min) return min;
    return v;
};


const $b719c908463ef3b6$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $b719c908463ef3b6$export$58f0f39f63f3cf42 = {
    ...$b719c908463ef3b6$export$98e628dec113755e,
    transform: (v)=>(0, $c7d27346dbc155b2$export$7d15b64cf5a3a4c4)(0, 1, v)
};
const $b719c908463ef3b6$export$dcdf75081b88279d = {
    ...$b719c908463ef3b6$export$98e628dec113755e,
    default: 1
};


/*#__NO_SIDE_EFFECTS__*/ const $b70b0cd340f5c11d$var$createUnitType = (unit)=>({
        test: (v)=>typeof v === "string" && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $b70b0cd340f5c11d$export$41fc368e1a942b97 = /*@__PURE__*/ $b70b0cd340f5c11d$var$createUnitType("deg");
const $b70b0cd340f5c11d$export$626336c2cd4b14de = /*@__PURE__*/ $b70b0cd340f5c11d$var$createUnitType("%");
const $b70b0cd340f5c11d$export$91c0eda1d06bf008 = /*@__PURE__*/ $b70b0cd340f5c11d$var$createUnitType("px");
const $b70b0cd340f5c11d$export$f91e8c45a95a32f2 = /*@__PURE__*/ $b70b0cd340f5c11d$var$createUnitType("vh");
const $b70b0cd340f5c11d$export$aed3d7b7d206c196 = /*@__PURE__*/ $b70b0cd340f5c11d$var$createUnitType("vw");
const $b70b0cd340f5c11d$export$44e2e1705876d7ed = /*@__PURE__*/ (()=>({
        ...$b70b0cd340f5c11d$export$626336c2cd4b14de,
        parse: (v)=>$b70b0cd340f5c11d$export$626336c2cd4b14de.parse(v) / 100,
        transform: (v)=>$b70b0cd340f5c11d$export$626336c2cd4b14de.transform(v * 100)
    }))();


/**
 * Tests a provided value against a ValueType
 */ const $17df7f4e324410c3$export$6eae4d0a6a7ca7cd = (v)=>(type)=>type.test(v);


/**
 * A list of value types commonly used for dimensions
 */ const $1e9b40bf478fdf7c$export$d176691c1998a1f5 = [
    (0, $b719c908463ef3b6$export$98e628dec113755e),
    (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008),
    (0, $b70b0cd340f5c11d$export$626336c2cd4b14de),
    (0, $b70b0cd340f5c11d$export$41fc368e1a942b97),
    (0, $b70b0cd340f5c11d$export$aed3d7b7d206c196),
    (0, $b70b0cd340f5c11d$export$f91e8c45a95a32f2),
    (0, $efdb1bfcfc56afa5$export$dfb5619354ba860)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ const $1e9b40bf478fdf7c$export$eefdd52e3ccae428 = (v)=>$1e9b40bf478fdf7c$export$d176691c1998a1f5.find((0, $17df7f4e324410c3$export$6eae4d0a6a7ca7cd)(v));



let $a41eb4452ff76a35$export$491112666e282270 = ()=>{};
let $a41eb4452ff76a35$export$f5708dca728d7177 = ()=>{};
var $a41eb4452ff76a35$var$check, $a41eb4452ff76a35$var$message, $a41eb4452ff76a35$var$errorCode, $a41eb4452ff76a35$var$check1, $a41eb4452ff76a35$var$message1, $a41eb4452ff76a35$var$errorCode1;

/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ const $99950dc4fad68cb3$export$65583ed5a868f2d9 = (v)=>/^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(v);



/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ const $b6971640a17ce46d$var$splitCSSVariableRegex = // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
/^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u;
function $b6971640a17ce46d$export$b9f0c1f373aee2b0(current) {
    const match = $b6971640a17ce46d$var$splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token1, token2, fallback] = match;
    return [
        `--${token1 ?? token2}`,
        fallback
    ];
}
const $b6971640a17ce46d$var$maxDepth = 4;
function $b6971640a17ce46d$export$289398774300c991(current, element, depth = 1) {
    (0, $a41eb4452ff76a35$export$f5708dca728d7177)(depth <= $b6971640a17ce46d$var$maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`, "max-css-var-depth");
    const [token, fallback] = $b6971640a17ce46d$export$b9f0c1f373aee2b0(current);
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        const trimmed = resolved.trim();
        return (0, $99950dc4fad68cb3$export$65583ed5a868f2d9)(trimmed) ? parseFloat(trimmed) : trimmed;
    }
    return (0, $8c245764d0d5c573$export$31f9caa2600b5723)(fallback) ? $b6971640a17ce46d$export$289398774300c991(fallback, element, depth + 1) : fallback;
}



function $d9ea03024183291b$export$5a98a90409277f5a(keyframes) {
    for(let i = 1; i < keyframes.length; i++)keyframes[i] ?? (keyframes[i] = keyframes[i - 1]);
}






const $8f350b2834907002$export$8e5250d1aa9bf370 = (v)=>v === (0, $b719c908463ef3b6$export$98e628dec113755e) || v === (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008);
const $8f350b2834907002$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
const $8f350b2834907002$var$nonTranslationalTransformKeys = (0, $505b0017451a5f76$export$280dc01950909d86).filter((key)=>!$8f350b2834907002$var$transformKeys.has(key));
function $8f350b2834907002$export$39d4bc9655f3f632(visualElement) {
    const removedTransforms = [];
    $8f350b2834907002$var$nonTranslationalTransformKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    return removedTransforms;
}
const $8f350b2834907002$export$781d46a8aa670d52 = {
    // Dimensions
    width: ({ x: x }, { paddingLeft: paddingLeft = "0", paddingRight: paddingRight = "0", boxSizing: boxSizing })=>{
        const width = x.max - x.min;
        return boxSizing === "border-box" ? width : width - parseFloat(paddingLeft) - parseFloat(paddingRight);
    },
    height: ({ y: y }, { paddingTop: paddingTop = "0", paddingBottom: paddingBottom = "0", boxSizing: boxSizing })=>{
        const height = y.max - y.min;
        return boxSizing === "border-box" ? height : height - parseFloat(paddingTop) - parseFloat(paddingBottom);
    },
    top: (_bbox, { top: top })=>parseFloat(top),
    left: (_bbox, { left: left })=>parseFloat(left),
    bottom: ({ y: y }, { top: top })=>parseFloat(top) + (y.max - y.min),
    right: ({ x: x }, { left: left })=>parseFloat(left) + (x.max - x.min),
    // Transform
    x: (_bbox, { transform: transform })=>(0, $ffe0bf72d53f9a3c$export$f9111f9e16b73a26)(transform, "x"),
    y: (_bbox, { transform: transform })=>(0, $ffe0bf72d53f9a3c$export$f9111f9e16b73a26)(transform, "y")
};
// Alias translate longform names
$8f350b2834907002$export$781d46a8aa670d52.translateX = $8f350b2834907002$export$781d46a8aa670d52.x;
$8f350b2834907002$export$781d46a8aa670d52.translateY = $8f350b2834907002$export$781d46a8aa670d52.y;


/*#__NO_SIDE_EFFECTS__*/ const $518547564f355e33$export$8793edee2d425525 = (any)=>any;


const $fbf024f08bc41b75$export$dd826089e3c5e502 = {};


const $3ef16e3f64b2b8ba$export$71ecace0a033b35a = [
    "setup",
    "read",
    "resolveKeyframes",
    "preUpdate",
    "update",
    "preRender",
    "render",
    "postRender"
];


const $37850638fe93a8b7$export$84ce9a476f53d110 = {
    value: null,
    addProjectionMetrics: null
};


function $1bbd9c40c2bb3c93$export$b995e5e85f5c8289(runNextFrame, stepName) {
    /**
     * We create and reuse two queues, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ let thisFrame = new Set();
    let nextFrame = new Set();
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ const toKeepAlive = new WeakSet();
    let latestFrameData = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    let numCalls = 0;
    function triggerCallback(callback) {
        if (toKeepAlive.has(callback)) {
            step.schedule(callback);
            runNextFrame();
        }
        numCalls++;
        callback(latestFrameData);
    }
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            queue.add(callback);
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: (callback)=>{
            nextFrame.delete(callback);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: (frameData)=>{
            latestFrameData = frameData;
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            // Swap this frame and the next to avoid GC
            const prevFrame = thisFrame;
            thisFrame = nextFrame;
            nextFrame = prevFrame;
            // Execute this frame
            thisFrame.forEach(triggerCallback);
            /**
             * If we're recording stats then
             */ if (stepName && (0, $37850638fe93a8b7$export$84ce9a476f53d110).value) (0, $37850638fe93a8b7$export$84ce9a476f53d110).value.frameloop[stepName].push(numCalls);
            numCalls = 0;
            // Clear the frame so no callbacks remain. This is to avoid
            // memory leaks should this render step not run for a while.
            thisFrame.clear();
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}


const $652c1620c567d9d0$var$maxElapsed = 40;
function $652c1620c567d9d0$export$510b0596a933801a(scheduleNextBatch, allowKeepAlive) {
    let runNextFrame = false;
    let useDefaultElapsed = true;
    const state = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    const flagRunNextFrame = ()=>runNextFrame = true;
    const steps = (0, $3ef16e3f64b2b8ba$export$71ecace0a033b35a).reduce((acc, key)=>{
        acc[key] = (0, $1bbd9c40c2bb3c93$export$b995e5e85f5c8289)(flagRunNextFrame, allowKeepAlive ? key : undefined);
        return acc;
    }, {});
    const { setup: setup, read: read, resolveKeyframes: resolveKeyframes, preUpdate: preUpdate, update: update, preRender: preRender, render: render, postRender: postRender } = steps;
    const processBatch = ()=>{
        const useManualTiming = (0, $fbf024f08bc41b75$export$dd826089e3c5e502).useManualTiming;
        const timestamp = useManualTiming ? state.timestamp : performance.now();
        runNextFrame = false;
        if (!useManualTiming) state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, $652c1620c567d9d0$var$maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        // Unrolled render loop for better per-frame performance
        setup.process(state);
        read.process(state);
        resolveKeyframes.process(state);
        preUpdate.process(state);
        update.process(state);
        preRender.process(state);
        render.process(state);
        postRender.process(state);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    const wake = ()=>{
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) scheduleNextBatch(processBatch);
    };
    const schedule = (0, $3ef16e3f64b2b8ba$export$71ecace0a033b35a).reduce((acc, key)=>{
        const step = steps[key];
        acc[key] = (process, keepAlive = false, immediate = false)=>{
            if (!runNextFrame) wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    const cancel = (process)=>{
        for(let i = 0; i < (0, $3ef16e3f64b2b8ba$export$71ecace0a033b35a).length; i++)steps[(0, $3ef16e3f64b2b8ba$export$71ecace0a033b35a)[i]].cancel(process);
    };
    return {
        schedule: schedule,
        cancel: cancel,
        state: state,
        steps: steps
    };
}


const { schedule: $f28d1a4d8c26f6e5$export$2cef06c20297c17d, cancel: $f28d1a4d8c26f6e5$export$ec99c0ef4978dccb, state: $f28d1a4d8c26f6e5$export$fff89137e9e818ce, steps: $f28d1a4d8c26f6e5$export$1811c3a7e3af92f0 } = /* @__PURE__ */ (0, $652c1620c567d9d0$export$510b0596a933801a)(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : (0, $518547564f355e33$export$8793edee2d425525), true);


const $b4c6185e0f3b6dcd$var$toResolve = new Set();
let $b4c6185e0f3b6dcd$var$isScheduled = false;
let $b4c6185e0f3b6dcd$var$anyNeedsMeasurement = false;
let $b4c6185e0f3b6dcd$var$isForced = false;
function $b4c6185e0f3b6dcd$var$measureAllKeyframes() {
    if ($b4c6185e0f3b6dcd$var$anyNeedsMeasurement) {
        const resolversToMeasure = Array.from($b4c6185e0f3b6dcd$var$toResolve).filter((resolver)=>resolver.needsMeasurement);
        const elementsToMeasure = new Set(resolversToMeasure.map((resolver)=>resolver.element));
        const transformsToRestore = new Map();
        /**
         * Write pass
         * If we're measuring elements we want to remove bounding box-changing transforms.
         */ elementsToMeasure.forEach((element)=>{
            const removedTransforms = (0, $8f350b2834907002$export$39d4bc9655f3f632)(element);
            if (!removedTransforms.length) return;
            transformsToRestore.set(element, removedTransforms);
            element.render();
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureInitialState());
        // Write
        elementsToMeasure.forEach((element)=>{
            element.render();
            const restore = transformsToRestore.get(element);
            if (restore) restore.forEach(([key, value])=>{
                element.getValue(key)?.set(value);
            });
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureEndState());
        // Write
        resolversToMeasure.forEach((resolver)=>{
            if (resolver.suspendedScrollY !== undefined) window.scrollTo(0, resolver.suspendedScrollY);
        });
    }
    $b4c6185e0f3b6dcd$var$anyNeedsMeasurement = false;
    $b4c6185e0f3b6dcd$var$isScheduled = false;
    $b4c6185e0f3b6dcd$var$toResolve.forEach((resolver)=>resolver.complete($b4c6185e0f3b6dcd$var$isForced));
    $b4c6185e0f3b6dcd$var$toResolve.clear();
}
function $b4c6185e0f3b6dcd$var$readAllKeyframes() {
    $b4c6185e0f3b6dcd$var$toResolve.forEach((resolver)=>{
        resolver.readKeyframes();
        if (resolver.needsMeasurement) $b4c6185e0f3b6dcd$var$anyNeedsMeasurement = true;
    });
}
function $b4c6185e0f3b6dcd$export$78b96d2a12593b05() {
    $b4c6185e0f3b6dcd$var$isForced = true;
    $b4c6185e0f3b6dcd$var$readAllKeyframes();
    $b4c6185e0f3b6dcd$var$measureAllKeyframes();
    $b4c6185e0f3b6dcd$var$isForced = false;
}
class $b4c6185e0f3b6dcd$export$74d34ca3182f1750 {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element, isAsync = false){
        this.state = "pending";
        /**
         * Track whether this resolver is async. If it is, it'll be added to the
         * resolver queue and flushed in the next frame. Resolvers that aren't going
         * to trigger read/write thrashing don't need to be async.
         */ this.isAsync = false;
        /**
         * Track whether this resolver needs to perform a measurement
         * to resolve its keyframes.
         */ this.needsMeasurement = false;
        this.unresolvedKeyframes = [
            ...unresolvedKeyframes
        ];
        this.onComplete = onComplete;
        this.name = name;
        this.motionValue = motionValue;
        this.element = element;
        this.isAsync = isAsync;
    }
    scheduleResolve() {
        this.state = "scheduled";
        if (this.isAsync) {
            $b4c6185e0f3b6dcd$var$toResolve.add(this);
            if (!$b4c6185e0f3b6dcd$var$isScheduled) {
                $b4c6185e0f3b6dcd$var$isScheduled = true;
                (0, $f28d1a4d8c26f6e5$export$2cef06c20297c17d).read($b4c6185e0f3b6dcd$var$readAllKeyframes);
                (0, $f28d1a4d8c26f6e5$export$2cef06c20297c17d).resolveKeyframes($b4c6185e0f3b6dcd$var$measureAllKeyframes);
            }
        } else {
            this.readKeyframes();
            this.complete();
        }
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name, element: element, motionValue: motionValue } = this;
        // If initial keyframe is null we need to read it from the DOM
        if (unresolvedKeyframes[0] === null) {
            const currentValue = motionValue?.get();
            // TODO: This doesn't work if the final keyframe is a wildcard
            const finalKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
            if (currentValue !== undefined) unresolvedKeyframes[0] = currentValue;
            else if (element && name) {
                const valueAsRead = element.readValue(name, finalKeyframe);
                if (valueAsRead !== undefined && valueAsRead !== null) unresolvedKeyframes[0] = valueAsRead;
            }
            if (unresolvedKeyframes[0] === undefined) unresolvedKeyframes[0] = finalKeyframe;
            if (motionValue && currentValue === undefined) motionValue.set(unresolvedKeyframes[0]);
        }
        (0, $d9ea03024183291b$export$5a98a90409277f5a)(unresolvedKeyframes);
    }
    setFinalKeyframe() {}
    measureInitialState() {}
    renderEndStyles() {}
    measureEndState() {}
    complete(isForcedComplete = false) {
        this.state = "complete";
        this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, isForcedComplete);
        $b4c6185e0f3b6dcd$var$toResolve.delete(this);
    }
    cancel() {
        if (this.state === "scheduled") {
            $b4c6185e0f3b6dcd$var$toResolve.delete(this);
            this.state = "pending";
        }
    }
    resume() {
        if (this.state === "pending") this.scheduleResolve();
    }
}


/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ const $1583088b6e4985b0$export$ade84c85e44a6cb1 = (v)=>/^0[^.\s]+$/u.test(v);


function $2af90e7cd7f43e2d$export$e56af863d5645d5f(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, $1583088b6e4985b0$export$ade84c85e44a6cb1)(value);
    else return true;
}




// If this number is a decimal, make it just five decimal places
// to avoid exponents
const $6af7453eded5c19c$export$83d2e9e3e4ee39ed = (v)=>Math.round(v * 100000) / 100000;


const $416e495bd9a58040$export$2444ca58c08448e4 = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;


function $c42e317faa1a11a1$export$b931b78cbb3caf86(v) {
    return v == null;
}


const $be23468a8bcaef9f$export$ed808ff6ecd39e8d = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu;


/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ const $df5b707925414626$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean(typeof v === "string" && (0, $be23468a8bcaef9f$export$ed808ff6ecd39e8d).test(v) && v.startsWith(type) || testProp && !(0, $c42e317faa1a11a1$export$b931b78cbb3caf86)(v) && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $df5b707925414626$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (typeof v !== "string") return v;
        const [a, b, c, alpha] = v.match((0, $416e495bd9a58040$export$2444ca58c08448e4));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };


const $c272d087ceaaf3e3$var$clampRgbUnit = (v)=>(0, $c7d27346dbc155b2$export$7d15b64cf5a3a4c4)(0, 255, v);
const $c272d087ceaaf3e3$export$7a99c86b5b1f4c9e = {
    ...(0, $b719c908463ef3b6$export$98e628dec113755e),
    transform: (v)=>Math.round($c272d087ceaaf3e3$var$clampRgbUnit(v))
};
const $c272d087ceaaf3e3$export$4e46ac54fc82cf3b = {
    test: /*@__PURE__*/ (0, $df5b707925414626$export$2c8400d58aca05e)("rgb", "red"),
    parse: /*@__PURE__*/ (0, $df5b707925414626$export$73d6f35be992df24)("red", "green", "blue"),
    transform: ({ red: red, green: green, blue: blue, alpha: alpha$1 = 1 })=>"rgba(" + $c272d087ceaaf3e3$export$7a99c86b5b1f4c9e.transform(red) + ", " + $c272d087ceaaf3e3$export$7a99c86b5b1f4c9e.transform(green) + ", " + $c272d087ceaaf3e3$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $6af7453eded5c19c$export$83d2e9e3e4ee39ed)((0, $b719c908463ef3b6$export$58f0f39f63f3cf42).transform(alpha$1)) + ")"
};



function $b71702bd9b151187$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $b71702bd9b151187$export$834dfc94dde4b3d8 = {
    test: /*@__PURE__*/ (0, $df5b707925414626$export$2c8400d58aca05e)("#"),
    parse: $b71702bd9b151187$var$parseHex,
    transform: (0, $c272d087ceaaf3e3$export$4e46ac54fc82cf3b).transform
};






const $62d2dc45b4bb2303$export$810b04175080204c = {
    test: /*@__PURE__*/ (0, $df5b707925414626$export$2c8400d58aca05e)("hsl", "hue"),
    parse: /*@__PURE__*/ (0, $df5b707925414626$export$73d6f35be992df24)("hue", "saturation", "lightness"),
    transform: ({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $b70b0cd340f5c11d$export$626336c2cd4b14de).transform((0, $6af7453eded5c19c$export$83d2e9e3e4ee39ed)(saturation)) + ", " + (0, $b70b0cd340f5c11d$export$626336c2cd4b14de).transform((0, $6af7453eded5c19c$export$83d2e9e3e4ee39ed)(lightness)) + ", " + (0, $6af7453eded5c19c$export$83d2e9e3e4ee39ed)((0, $b719c908463ef3b6$export$58f0f39f63f3cf42).transform(alpha$1)) + ")";
    }
};



const $c0d5455d86887039$export$35e9368ef982300f = {
    test: (v)=>(0, $c272d087ceaaf3e3$export$4e46ac54fc82cf3b).test(v) || (0, $b71702bd9b151187$export$834dfc94dde4b3d8).test(v) || (0, $62d2dc45b4bb2303$export$810b04175080204c).test(v),
    parse: (v)=>{
        if ((0, $c272d087ceaaf3e3$export$4e46ac54fc82cf3b).test(v)) return (0, $c272d087ceaaf3e3$export$4e46ac54fc82cf3b).parse(v);
        else if ((0, $62d2dc45b4bb2303$export$810b04175080204c).test(v)) return (0, $62d2dc45b4bb2303$export$810b04175080204c).parse(v);
        else return (0, $b71702bd9b151187$export$834dfc94dde4b3d8).parse(v);
    },
    transform: (v)=>{
        return typeof v === "string" ? v : v.hasOwnProperty("red") ? (0, $c272d087ceaaf3e3$export$4e46ac54fc82cf3b).transform(v) : (0, $62d2dc45b4bb2303$export$810b04175080204c).transform(v);
    },
    getAnimatableNone: (v)=>{
        const parsed = $c0d5455d86887039$export$35e9368ef982300f.parse(v);
        parsed.alpha = 0;
        return $c0d5455d86887039$export$35e9368ef982300f.transform(parsed);
    }
};


const $8f139a6c6fc1f297$export$740b69c5fad25dba = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;




function $cfd2572e4bd61faa$var$test(v) {
    return isNaN(v) && typeof v === "string" && (v.match((0, $416e495bd9a58040$export$2444ca58c08448e4))?.length || 0) + (v.match((0, $8f139a6c6fc1f297$export$740b69c5fad25dba))?.length || 0) > 0;
}
const $cfd2572e4bd61faa$var$NUMBER_TOKEN = "number";
const $cfd2572e4bd61faa$var$COLOR_TOKEN = "color";
const $cfd2572e4bd61faa$var$VAR_TOKEN = "var";
const $cfd2572e4bd61faa$var$VAR_FUNCTION_TOKEN = "var(";
const $cfd2572e4bd61faa$var$SPLIT_TOKEN = "${}";
// this regex consists of the `singleCssVariableRegex|rgbHSLValueRegex|digitRegex`
const $cfd2572e4bd61faa$var$complexRegex = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function $cfd2572e4bd61faa$export$b61fc7c44bf646d5(value) {
    const originalValue = value.toString();
    const values = [];
    const indexes = {
        color: [],
        number: [],
        var: []
    };
    const types = [];
    let i = 0;
    const tokenised = originalValue.replace($cfd2572e4bd61faa$var$complexRegex, (parsedValue)=>{
        if ((0, $c0d5455d86887039$export$35e9368ef982300f).test(parsedValue)) {
            indexes.color.push(i);
            types.push($cfd2572e4bd61faa$var$COLOR_TOKEN);
            values.push((0, $c0d5455d86887039$export$35e9368ef982300f).parse(parsedValue));
        } else if (parsedValue.startsWith($cfd2572e4bd61faa$var$VAR_FUNCTION_TOKEN)) {
            indexes.var.push(i);
            types.push($cfd2572e4bd61faa$var$VAR_TOKEN);
            values.push(parsedValue);
        } else {
            indexes.number.push(i);
            types.push($cfd2572e4bd61faa$var$NUMBER_TOKEN);
            values.push(parseFloat(parsedValue));
        }
        ++i;
        return $cfd2572e4bd61faa$var$SPLIT_TOKEN;
    });
    const split = tokenised.split($cfd2572e4bd61faa$var$SPLIT_TOKEN);
    return {
        values: values,
        split: split,
        indexes: indexes,
        types: types
    };
}
function $cfd2572e4bd61faa$var$parseComplexValue(v) {
    return $cfd2572e4bd61faa$export$b61fc7c44bf646d5(v).values;
}
function $cfd2572e4bd61faa$var$buildTransformer({ split: split, types: types }) {
    const numSections = split.length;
    return (v)=>{
        let output = "";
        for(let i = 0; i < numSections; i++){
            output += split[i];
            if (v[i] !== undefined) {
                const type = types[i];
                if (type === $cfd2572e4bd61faa$var$NUMBER_TOKEN) output += (0, $6af7453eded5c19c$export$83d2e9e3e4ee39ed)(v[i]);
                else if (type === $cfd2572e4bd61faa$var$COLOR_TOKEN) output += (0, $c0d5455d86887039$export$35e9368ef982300f).transform(v[i]);
                else output += v[i];
            }
        }
        return output;
    };
}
function $cfd2572e4bd61faa$var$createTransformer(source) {
    return $cfd2572e4bd61faa$var$buildTransformer($cfd2572e4bd61faa$export$b61fc7c44bf646d5(source));
}
const $cfd2572e4bd61faa$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : (0, $c0d5455d86887039$export$35e9368ef982300f).test(v) ? (0, $c0d5455d86887039$export$35e9368ef982300f).getAnimatableNone(v) : v;
/**
 * Convert a parsed value to its zero equivalent, but preserve numbers
 * that act as divisors in CSS calc() expressions.
 *
 * analyseComplexValue extracts numbers from CSS strings and puts the
 * surrounding text into a `split` template array. For example:
 *   "calc(var(--gap) / 5)"  →  values: [var(--gap), 5]
 *                               split:  ["calc(", " / ", ")"]
 *
 * When building a zero-equivalent for animation, naively zeroing all
 * numbers turns the divisor into 0 → "calc(var(--gap) / 0)" → NaN.
 * We detect this by checking whether the text preceding a number
 * (split[i]) ends with "/" — the CSS calc division operator.
 */ const $cfd2572e4bd61faa$var$convertToZero = (value, splitBefore)=>{
    if (typeof value === "number") return splitBefore?.trim().endsWith("/") ? value : 0;
    return $cfd2572e4bd61faa$var$convertNumbersToZero(value);
};
function $cfd2572e4bd61faa$var$getAnimatableNone(v) {
    const info = $cfd2572e4bd61faa$export$b61fc7c44bf646d5(v);
    const transformer = $cfd2572e4bd61faa$var$buildTransformer(info);
    return transformer(info.values.map((value, i)=>$cfd2572e4bd61faa$var$convertToZero(value, info.split[i])));
}
const $cfd2572e4bd61faa$export$83a0e34f1302825b = {
    test: $cfd2572e4bd61faa$var$test,
    parse: $cfd2572e4bd61faa$var$parseComplexValue,
    createTransformer: $cfd2572e4bd61faa$var$createTransformer,
    getAnimatableNone: $cfd2572e4bd61faa$var$getAnimatableNone
};





/**
 * Properties that should default to 1 or 100%
 */ const $891c5958f9ee3343$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $891c5958f9ee3343$var$applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $416e495bd9a58040$export$2444ca58c08448e4)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $891c5958f9ee3343$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $891c5958f9ee3343$var$functionRegex = /\b([a-z-]*)\(.*?\)/gu;
const $891c5958f9ee3343$export$3dea766d36a8935f = {
    ...(0, $cfd2572e4bd61faa$export$83a0e34f1302825b),
    getAnimatableNone: (v)=>{
        const functions = v.match($891c5958f9ee3343$var$functionRegex);
        return functions ? functions.map($891c5958f9ee3343$var$applyDefaultFilter).join(" ") : v;
    }
};



const $a9af002e44388805$export$d99f0801a68bbcf1 = {
    ...(0, $cfd2572e4bd61faa$export$83a0e34f1302825b),
    getAnimatableNone: (v)=>{
        const parsed = (0, $cfd2572e4bd61faa$export$83a0e34f1302825b).parse(v);
        const transformer = (0, $cfd2572e4bd61faa$export$83a0e34f1302825b).createTransformer(v);
        return transformer(parsed.map((v)=>typeof v === "number" ? 0 : typeof v === "object" ? {
                ...v,
                alpha: 1
            } : v));
    }
};






const $79eae54a7c9a5fec$export$7d260a2a5f8bc19e = {
    ...(0, $b719c908463ef3b6$export$98e628dec113755e),
    transform: Math.round
};






const $742d1a9d310b8f37$export$f2e4285fee37e26 = {
    rotate: (0, $b70b0cd340f5c11d$export$41fc368e1a942b97),
    /**
     * Internal channel for `transition.path` orientToPath. Composed onto
     * `rotate` at the transform-build sites so the user's `rotate` is
     * never read or overwritten. Not part of `transformPropOrder`.
     */ pathRotation: (0, $b70b0cd340f5c11d$export$41fc368e1a942b97),
    rotateX: (0, $b70b0cd340f5c11d$export$41fc368e1a942b97),
    rotateY: (0, $b70b0cd340f5c11d$export$41fc368e1a942b97),
    rotateZ: (0, $b70b0cd340f5c11d$export$41fc368e1a942b97),
    scale: $b719c908463ef3b6$export$dcdf75081b88279d,
    scaleX: (0, $b719c908463ef3b6$export$dcdf75081b88279d),
    scaleY: (0, $b719c908463ef3b6$export$dcdf75081b88279d),
    scaleZ: (0, $b719c908463ef3b6$export$dcdf75081b88279d),
    skew: (0, $b70b0cd340f5c11d$export$41fc368e1a942b97),
    skewX: (0, $b70b0cd340f5c11d$export$41fc368e1a942b97),
    skewY: (0, $b70b0cd340f5c11d$export$41fc368e1a942b97),
    distance: (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008),
    translateX: (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008),
    translateY: (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008),
    translateZ: (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008),
    x: (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008),
    y: (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008),
    z: (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008),
    perspective: (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008),
    transformPerspective: (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008),
    opacity: (0, $b719c908463ef3b6$export$58f0f39f63f3cf42),
    originX: (0, $b70b0cd340f5c11d$export$44e2e1705876d7ed),
    originY: (0, $b70b0cd340f5c11d$export$44e2e1705876d7ed),
    originZ: (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008)
};


const $c8706b17cc70099b$export$eec14432cd1cb67b = {
    // Border props
    borderWidth: (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008),
    borderTopWidth: (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008),
    borderRightWidth: (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008),
    borderBottomWidth: (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008),
    borderLeftWidth: (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008),
    borderRadius: (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008),
    borderTopLeftRadius: (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008),
    borderTopRightRadius: (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008),
    borderBottomRightRadius: (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008),
    borderBottomLeftRadius: (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008),
    // Positioning props
    width: (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008),
    maxWidth: (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008),
    height: (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008),
    maxHeight: (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008),
    top: (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008),
    right: (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008),
    bottom: (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008),
    left: (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008),
    inset: (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008),
    insetBlock: (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008),
    insetBlockStart: (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008),
    insetBlockEnd: (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008),
    insetInline: (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008),
    insetInlineStart: (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008),
    insetInlineEnd: (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008),
    // Spacing props
    padding: (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008),
    paddingTop: (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008),
    paddingRight: (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008),
    paddingBottom: (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008),
    paddingLeft: (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008),
    paddingBlock: (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008),
    paddingBlockStart: (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008),
    paddingBlockEnd: (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008),
    paddingInline: (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008),
    paddingInlineStart: (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008),
    paddingInlineEnd: (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008),
    margin: (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008),
    marginTop: (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008),
    marginRight: (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008),
    marginBottom: (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008),
    marginLeft: (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008),
    marginBlock: (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008),
    marginBlockStart: (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008),
    marginBlockEnd: (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008),
    marginInline: (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008),
    marginInlineStart: (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008),
    marginInlineEnd: (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008),
    // Typography
    fontSize: (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008),
    // Misc
    backgroundPositionX: (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008),
    backgroundPositionY: (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008),
    ...(0, $742d1a9d310b8f37$export$f2e4285fee37e26),
    zIndex: (0, $79eae54a7c9a5fec$export$7d260a2a5f8bc19e),
    // SVG
    fillOpacity: (0, $b719c908463ef3b6$export$58f0f39f63f3cf42),
    strokeOpacity: (0, $b719c908463ef3b6$export$58f0f39f63f3cf42),
    numOctaves: (0, $79eae54a7c9a5fec$export$7d260a2a5f8bc19e)
};


/**
 * A map of default value types for common values
 */ const $9d3e5596a4892dc3$export$98cd7c72c5a731fb = {
    ...(0, $c8706b17cc70099b$export$eec14432cd1cb67b),
    color: // Color props
    $c0d5455d86887039$export$35e9368ef982300f,
    backgroundColor: (0, $c0d5455d86887039$export$35e9368ef982300f),
    outlineColor: (0, $c0d5455d86887039$export$35e9368ef982300f),
    fill: (0, $c0d5455d86887039$export$35e9368ef982300f),
    stroke: (0, $c0d5455d86887039$export$35e9368ef982300f),
    // Border props
    borderColor: (0, $c0d5455d86887039$export$35e9368ef982300f),
    borderTopColor: (0, $c0d5455d86887039$export$35e9368ef982300f),
    borderRightColor: (0, $c0d5455d86887039$export$35e9368ef982300f),
    borderBottomColor: (0, $c0d5455d86887039$export$35e9368ef982300f),
    borderLeftColor: (0, $c0d5455d86887039$export$35e9368ef982300f),
    filter: $891c5958f9ee3343$export$3dea766d36a8935f,
    WebkitFilter: (0, $891c5958f9ee3343$export$3dea766d36a8935f),
    mask: $a9af002e44388805$export$d99f0801a68bbcf1,
    WebkitMask: (0, $a9af002e44388805$export$d99f0801a68bbcf1)
};
/**
 * Gets the default ValueType for the provided value key
 */ const $9d3e5596a4892dc3$export$67d1babe0338d23b = (key)=>$9d3e5596a4892dc3$export$98cd7c72c5a731fb[key];


const $8e8a8e07dd5e5c17$var$customTypes = /*@__PURE__*/ new Set([
    (0, $891c5958f9ee3343$export$3dea766d36a8935f),
    (0, $a9af002e44388805$export$d99f0801a68bbcf1)
]);
function $8e8a8e07dd5e5c17$export$cea0cedcb94873b5(key, value) {
    let defaultValueType = (0, $9d3e5596a4892dc3$export$67d1babe0338d23b)(key);
    if (!$8e8a8e07dd5e5c17$var$customTypes.has(defaultValueType)) defaultValueType = (0, $cfd2572e4bd61faa$export$83a0e34f1302825b);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}


/**
 * If we encounter keyframes like "none" or "0" and we also have keyframes like
 * "#fff" or "200px 200px" we want to find a keyframe to serve as a template for
 * the "none" keyframes. In this case "#fff" or "200px 200px" - then these get turned into
 * zero equivalents, i.e. "#fff0" or "0px 0px".
 */ const $61751c3c48e1b11c$var$invalidTemplates = new Set([
    "auto",
    "none",
    "0"
]);
function $61751c3c48e1b11c$export$8cc4958f8e540f37(unresolvedKeyframes, noneKeyframeIndexes, name) {
    let i = 0;
    let animatableTemplate = undefined;
    while(i < unresolvedKeyframes.length && !animatableTemplate){
        const keyframe = unresolvedKeyframes[i];
        if (typeof keyframe === "string" && !$61751c3c48e1b11c$var$invalidTemplates.has(keyframe) && (0, $cfd2572e4bd61faa$export$b61fc7c44bf646d5)(keyframe).values.length) animatableTemplate = unresolvedKeyframes[i];
        i++;
    }
    if (animatableTemplate && name) for (const noneIndex of noneKeyframeIndexes)unresolvedKeyframes[noneIndex] = (0, $8e8a8e07dd5e5c17$export$cea0cedcb94873b5)(name, animatableTemplate);
}



class $08f7b98a2ff2d146$export$4983792d11b61017 extends (0, $b4c6185e0f3b6dcd$export$74d34ca3182f1750) {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element){
        super(unresolvedKeyframes, onComplete, name, motionValue, element, true);
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, element: element, name: name } = this;
        if (!element || !element.current) return;
        super.readKeyframes();
        /**
         * If any keyframe is a CSS variable, we need to find its value by sampling the element
         */ for(let i = 0; i < unresolvedKeyframes.length; i++){
            let keyframe = unresolvedKeyframes[i];
            if (typeof keyframe === "string") {
                keyframe = keyframe.trim();
                if ((0, $8c245764d0d5c573$export$31f9caa2600b5723)(keyframe)) {
                    const resolved = (0, $b6971640a17ce46d$export$289398774300c991)(keyframe, element.current);
                    if (resolved !== undefined) unresolvedKeyframes[i] = resolved;
                    if (i === unresolvedKeyframes.length - 1) this.finalKeyframe = keyframe;
                }
            }
        }
        /**
         * Resolve "none" values. We do this potentially twice - once before and once after measuring keyframes.
         * This could be seen as inefficient but it's a trade-off to avoid measurements in more situations, which
         * have a far bigger performance impact.
         */ this.resolveNoneKeyframes();
        /**
         * Check to see if unit type has changed. If so schedule jobs that will
         * temporarily set styles to the destination keyframes.
         * Skip if we have more than two keyframes or this isn't a positional value.
         * TODO: We can throw if there are multiple keyframes and the value type changes.
         */ if (!(0, $2597a137a910406a$export$c66c0d5db2a205d).has(name) || unresolvedKeyframes.length !== 2) return;
        const [origin, target] = unresolvedKeyframes;
        const originType = (0, $1e9b40bf478fdf7c$export$eefdd52e3ccae428)(origin);
        const targetType = (0, $1e9b40bf478fdf7c$export$eefdd52e3ccae428)(target);
        /**
         * If one keyframe contains embedded CSS variables (e.g. in calc()) and the other
         * doesn't, we need to measure to convert to pixels. This handles GitHub issue #3410.
         */ const originHasVar = (0, $8c245764d0d5c573$export$df8f90ab5d0b05fa)(origin);
        const targetHasVar = (0, $8c245764d0d5c573$export$df8f90ab5d0b05fa)(target);
        if (originHasVar !== targetHasVar && (0, $8f350b2834907002$export$781d46a8aa670d52)[name]) {
            this.needsMeasurement = true;
            return;
        }
        /**
         * Either we don't recognise these value types or we can animate between them.
         */ if (originType === targetType) return;
        /**
         * If both values are numbers or pixels, we can animate between them by
         * converting them to numbers.
         */ if ((0, $8f350b2834907002$export$8e5250d1aa9bf370)(originType) && (0, $8f350b2834907002$export$8e5250d1aa9bf370)(targetType)) for(let i = 0; i < unresolvedKeyframes.length; i++){
            const value = unresolvedKeyframes[i];
            if (typeof value === "string") unresolvedKeyframes[i] = parseFloat(value);
        }
        else if ((0, $8f350b2834907002$export$781d46a8aa670d52)[name]) /**
             * Else, the only way to resolve this is by measuring the element.
             */ this.needsMeasurement = true;
    }
    resolveNoneKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        const noneKeyframeIndexes = [];
        for(let i = 0; i < unresolvedKeyframes.length; i++)if (unresolvedKeyframes[i] === null || (0, $2af90e7cd7f43e2d$export$e56af863d5645d5f)(unresolvedKeyframes[i])) noneKeyframeIndexes.push(i);
        if (noneKeyframeIndexes.length) (0, $61751c3c48e1b11c$export$8cc4958f8e540f37)(unresolvedKeyframes, noneKeyframeIndexes, name);
    }
    measureInitialState() {
        const { element: element, unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        if (!element || !element.current) return;
        if (name === "height") this.suspendedScrollY = window.pageYOffset;
        this.measuredOrigin = (0, $8f350b2834907002$export$781d46a8aa670d52)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        unresolvedKeyframes[0] = this.measuredOrigin;
        // Set final key frame to measure after next render
        const measureKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
        if (measureKeyframe !== undefined) element.getValue(name, measureKeyframe).jump(measureKeyframe, false);
    }
    measureEndState() {
        const { element: element, name: name, unresolvedKeyframes: unresolvedKeyframes } = this;
        if (!element || !element.current) return;
        const value = element.getValue(name);
        value && value.jump(this.measuredOrigin, false);
        const finalKeyframeIndex = unresolvedKeyframes.length - 1;
        const finalKeyframe = unresolvedKeyframes[finalKeyframeIndex];
        unresolvedKeyframes[finalKeyframeIndex] = (0, $8f350b2834907002$export$781d46a8aa670d52)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        if (finalKeyframe !== null && this.finalKeyframe === undefined) this.finalKeyframe = finalKeyframe;
        // If we removed transform values, reapply them before the next render
        if (this.removedTransforms?.length) this.removedTransforms.forEach(([unsetTransformName, unsetTransformValue])=>{
            element.getValue(unsetTransformName).set(unsetTransformValue);
        });
        this.resolveNoneKeyframes();
    }
}


/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ /*#__NO_SIDE_EFFECTS__*/ const $a69653fc318d2500$export$fc3e7e8557f8c8c7 = (seconds)=>seconds * 1000;
/*#__NO_SIDE_EFFECTS__*/ const $a69653fc318d2500$export$f64c3bfbc58eec0f = (milliseconds)=>milliseconds / 1000;

function $940e5f5cfec6dbd6$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $940e5f5cfec6dbd6$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $940e5f5cfec6dbd6$export$ec937e64de6c1257([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}


class $450ebeef08659e3e$export$e7dff9482a5fd23c {
    constructor(){
        this.subscriptions = [];
    }
    add(handler) {
        (0, $940e5f5cfec6dbd6$export$20e507e47fae79fd)(this.subscriptions, handler);
        return ()=>(0, $940e5f5cfec6dbd6$export$fe2d9b4e03920b4c)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(let i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ const handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
}




const $72a0521b46f058e7$export$c9f584638d388483 = (name)=>name.startsWith("--");


function $f4049e50b6bfb14d$export$37a5fde709c1db82(element, name, value) {
    (0, $72a0521b46f058e7$export$c9f584638d388483)(name) ? element.style.setProperty(name, value) : element.style[name] = value;
}


/*#__NO_SIDE_EFFECTS__*/ function $77ac62143ab19cfb$export$7c73462e0d25e514(callback) {
    let result;
    return ()=>{
        if (result === undefined) result = callback();
        return result;
    };
}


/**
 * Add the ability for test suites to manually set support flags
 * to better test more environments.
 */ const $ead9c1214533f192$export$e3ad02c335474dee = {};


function $4e01c6f1f0560b84$export$1964673d5ec13c3a(callback, supportsFlag) {
    const memoized = (0, $77ac62143ab19cfb$export$7c73462e0d25e514)(callback);
    return ()=>(0, $ead9c1214533f192$export$e3ad02c335474dee)[supportsFlag] ?? memoized();
}


const $99cf8af27b024625$export$20d68f04f30763a5 = /* @__PURE__ */ (0, $4e01c6f1f0560b84$export$1964673d5ec13c3a)(()=>window.ScrollTimeline !== undefined, "scrollTimeline");
const $99cf8af27b024625$export$206321d8c5f8fd38 = /* @__PURE__ */ (0, $4e01c6f1f0560b84$export$1964673d5ec13c3a)(()=>window.ViewTimeline !== undefined, "viewTimeline");


const $650926dc8a2fe658$var$isNotNull = (value)=>value !== null;
function $650926dc8a2fe658$export$14de59408fad90b(keyframes, { repeat: repeat, repeatType: repeatType = "loop" }, finalKeyframe, speed = 1) {
    const resolvedKeyframes = keyframes.filter($650926dc8a2fe658$var$isNotNull);
    const useFirstKeyframe = speed < 0 || repeat && repeatType !== "loop" && repeat % 2 === 1;
    const index = useFirstKeyframe ? 0 : resolvedKeyframes.length - 1;
    return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}


class $8788fd356985045d$export$655db786091c33e0 {
    constructor(){
        this.updateFinished();
    }
    get finished() {
        return this._finished;
    }
    updateFinished() {
        this._finished = new Promise((resolve)=>{
            this.resolve = resolve;
        });
    }
    notifyFinished() {
        this.resolve();
    }
    /**
     * Allows the animation to be awaited.
     *
     * @deprecated Use `finished` instead.
     */ then(onResolve, onReject) {
        return this.finished.then(onResolve, onReject);
    }
}


const $3f382d8314d26340$export$d921fb2475e2900c = {
    layout: 0,
    mainThread: 0,
    waapi: 0
};



/*#__NO_SIDE_EFFECTS__*/ const $d912dc831f0025a3$export$ff43f99925d7366b = (easing)=>Array.isArray(easing) && typeof easing[0] === "number";



const $102d61f4d56469c8$export$866c1d07a1ac2ab = /*@__PURE__*/ (0, $4e01c6f1f0560b84$export$1964673d5ec13c3a)(()=>{
    try {
        document.createElement("div").animate({
            opacity: 0
        }, {
            easing: "linear(0, 1)"
        });
    } catch (e) {
        return false;
    }
    return true;
}, "linearEasing");


const $fa56f16bf2818b99$export$66d3851e2b1ec912 = (easing, duration, resolution = 10 // as milliseconds
)=>{
    let points = "";
    const numPoints = Math.max(Math.round(duration / resolution), 2);
    for(let i = 0; i < numPoints; i++)points += Math.round(easing(i / (numPoints - 1)) * 10000) / 10000 + ", ";
    return `linear(${points.substring(0, points.length - 2)})`;
};


const $376e4dbd133efbc4$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;



const $24ad7625047cfb99$export$2cf569f5e2221176 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: /*@__PURE__*/ (0, $376e4dbd133efbc4$export$2523b8f0bd8f44cb)([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: /*@__PURE__*/ (0, $376e4dbd133efbc4$export$2523b8f0bd8f44cb)([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: /*@__PURE__*/ (0, $376e4dbd133efbc4$export$2523b8f0bd8f44cb)([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: /*@__PURE__*/ (0, $376e4dbd133efbc4$export$2523b8f0bd8f44cb)([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};


function $52eb13fdd02de589$export$916ea73bcd3a6030(easing, duration) {
    if (!easing) return undefined;
    else if (typeof easing === "function") return (0, $102d61f4d56469c8$export$866c1d07a1ac2ab)() ? (0, $fa56f16bf2818b99$export$66d3851e2b1ec912)(easing, duration) : "ease-out";
    else if ((0, $d912dc831f0025a3$export$ff43f99925d7366b)(easing)) return (0, $376e4dbd133efbc4$export$2523b8f0bd8f44cb)(easing);
    else if (Array.isArray(easing)) return easing.map((segmentEasing)=>$52eb13fdd02de589$export$916ea73bcd3a6030(segmentEasing, duration) || (0, $24ad7625047cfb99$export$2cf569f5e2221176).easeOut);
    else return (0, $24ad7625047cfb99$export$2cf569f5e2221176)[easing];
}


function $e3295aeaa5942a67$export$d896de52f97cb615(element, valueName, keyframes, { delay: delay = 0, duration: duration = 300, repeat: repeat = 0, repeatType: repeatType = "loop", ease: ease = "easeOut", times: times } = {}, pseudoElement) {
    const keyframeOptions = {
        [valueName]: keyframes
    };
    if (times) keyframeOptions.offset = times;
    const easing = (0, $52eb13fdd02de589$export$916ea73bcd3a6030)(ease, duration);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    if ((0, $37850638fe93a8b7$export$84ce9a476f53d110).value) (0, $3f382d8314d26340$export$d921fb2475e2900c).waapi++;
    const options = {
        delay: delay,
        duration: duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    };
    if (pseudoElement) options.pseudoElement = pseudoElement;
    const animation = element.animate(keyframeOptions, options);
    if ((0, $37850638fe93a8b7$export$84ce9a476f53d110).value) animation.finished.finally(()=>{
        (0, $3f382d8314d26340$export$d921fb2475e2900c).waapi--;
    });
    return animation;
}



function $37fee822b2633340$export$6ab7812f1bac68be(type) {
    return typeof type === "function" && "applyToOptions" in type;
}


function $f8ccb8f3280e25db$export$a31269144d66b4a({ type: type, ...options }) {
    if ((0, $37fee822b2633340$export$6ab7812f1bac68be)(type) && (0, $102d61f4d56469c8$export$866c1d07a1ac2ab)()) return type.applyToOptions(options);
    else {
        options.duration ?? (options.duration = 300);
        options.ease ?? (options.ease = "easeOut");
    }
    return options;
}


/**
 * NativeAnimation implements AnimationPlaybackControls for the browser's Web Animations API.
 */ class $a13be77b2bd23e68$export$6c0f9803d8aa7219 extends (0, $8788fd356985045d$export$655db786091c33e0) {
    constructor(options){
        super();
        this.finishedTime = null;
        this.isStopped = false;
        /**
         * Tracks a manually-set start time that takes precedence over WAAPI's
         * dynamic startTime. This is cleared when play() or time setter is called,
         * allowing WAAPI to take over timing.
         */ this.manualStartTime = null;
        if (!options) return;
        const { element: element, name: name, keyframes: keyframes, pseudoElement: pseudoElement, allowFlatten: allowFlatten = false, finalKeyframe: finalKeyframe, onComplete: onComplete } = options;
        this.isPseudoElement = Boolean(pseudoElement);
        this.allowFlatten = allowFlatten;
        this.options = options;
        (0, $a41eb4452ff76a35$export$f5708dca728d7177)(typeof options.type !== "string", `Mini animate() doesn't support "type" as a string.`, "mini-spring");
        const transition = (0, $f8ccb8f3280e25db$export$a31269144d66b4a)(options);
        this.animation = (0, $e3295aeaa5942a67$export$d896de52f97cb615)(element, name, keyframes, transition, pseudoElement);
        if (transition.autoplay === false) this.animation.pause();
        this.animation.onfinish = ()=>{
            this.finishedTime = this.time;
            if (!pseudoElement) {
                const keyframe = (0, $650926dc8a2fe658$export$14de59408fad90b)(keyframes, this.options, finalKeyframe, this.speed);
                if (this.updateMotionValue) this.updateMotionValue(keyframe);
                /**
                 * If we can, we want to commit the final style as set by the user,
                 * rather than the computed keyframe value supplied by the animation.
                 * We always do this, even when a motion value is present, to prevent
                 * a visual flash in Firefox where the WAAPI animation's fill is removed
                 * during cancel() before the scheduled render can apply the correct value.
                 */ (0, $f4049e50b6bfb14d$export$37a5fde709c1db82)(element, name, keyframe);
                this.animation.cancel();
            }
            onComplete?.();
            this.notifyFinished();
        };
    }
    play() {
        if (this.isStopped) return;
        this.manualStartTime = null;
        this.animation.play();
        if (this.state === "finished") this.updateFinished();
    }
    pause() {
        this.animation.pause();
    }
    complete() {
        this.animation.finish?.();
    }
    cancel() {
        try {
            this.animation.cancel();
        } catch (e) {}
    }
    stop() {
        if (this.isStopped) return;
        this.isStopped = true;
        const { state: state } = this;
        if (state === "idle" || state === "finished") return;
        if (this.updateMotionValue) this.updateMotionValue();
        else this.commitStyles();
        if (!this.isPseudoElement) this.cancel();
    }
    /**
     * WAAPI doesn't natively have any interruption capabilities.
     *
     * In this method, we commit styles back to the DOM before cancelling
     * the animation.
     *
     * This is designed to be overridden by NativeAnimationExtended, which
     * will create a renderless JS animation and sample it twice to calculate
     * its current value, "previous" value, and therefore allow
     * Motion to also correctly calculate velocity for any subsequent animation
     * while deferring the commit until the next animation frame.
     */ commitStyles() {
        const element = this.options?.element;
        if (!this.isPseudoElement && element?.isConnected) this.animation.commitStyles?.();
    }
    get duration() {
        const duration = this.animation.effect?.getComputedTiming?.().duration || 0;
        return (0, $a69653fc318d2500$export$f64c3bfbc58eec0f)(Number(duration));
    }
    get iterationDuration() {
        const { delay: delay = 0 } = this.options || {};
        return this.duration + (0, $a69653fc318d2500$export$f64c3bfbc58eec0f)(delay);
    }
    get time() {
        return (0, $a69653fc318d2500$export$f64c3bfbc58eec0f)(Number(this.animation.currentTime) || 0);
    }
    set time(newTime) {
        const wasFinished = this.finishedTime !== null;
        this.manualStartTime = null;
        this.finishedTime = null;
        this.animation.currentTime = (0, $a69653fc318d2500$export$fc3e7e8557f8c8c7)(newTime);
        if (wasFinished) this.animation.pause();
    }
    /**
     * The playback speed of the animation.
     * 1 = normal speed, 2 = double speed, 0.5 = half speed.
     */ get speed() {
        return this.animation.playbackRate;
    }
    set speed(newSpeed) {
        // Allow backwards playback after finishing
        if (newSpeed < 0) this.finishedTime = null;
        this.animation.playbackRate = newSpeed;
    }
    get state() {
        return this.finishedTime !== null ? "finished" : this.animation.playState;
    }
    get startTime() {
        return this.manualStartTime ?? Number(this.animation.startTime);
    }
    set startTime(newStartTime) {
        this.manualStartTime = this.animation.startTime = newStartTime;
    }
    /**
     * Attaches a timeline to the animation, for instance the `ScrollTimeline`.
     */ attachTimeline({ timeline: timeline, rangeStart: rangeStart, rangeEnd: rangeEnd, observe: observe }) {
        if (this.allowFlatten) this.animation.effect?.updateTiming({
            easing: "linear"
        });
        this.animation.onfinish = null;
        if (timeline && (0, $99cf8af27b024625$export$20d68f04f30763a5)()) {
            this.animation.timeline = timeline;
            if (rangeStart) this.animation.rangeStart = rangeStart;
            if (rangeEnd) this.animation.rangeEnd = rangeEnd;
            return 0, $518547564f355e33$export$8793edee2d425525;
        } else return observe(this);
    }
}


/**
 * A list of values that can be hardware-accelerated.
 */ const $0bbb7ed9e051efbb$export$a27eefbd8fb5e404 = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform"
]);



const { schedule: $72c587626bccb82b$export$bb76eed83315504c, cancel: $72c587626bccb82b$export$3252729004b8456e } = /* @__PURE__ */ (0, $652c1620c567d9d0$export$510b0596a933801a)(queueMicrotask, false);




let $111e7cbe8a4123f4$var$now;
function $111e7cbe8a4123f4$var$clearTime() {
    $111e7cbe8a4123f4$var$now = undefined;
}
/**
 * An eventloop-synchronous alternative to performance.now().
 *
 * Ensures that time measurements remain consistent within a synchronous context.
 * Usually calling performance.now() twice within the same synchronous context
 * will return different values which isn't useful for animations when we're usually
 * trying to sync animations to the same frame.
 */ const $111e7cbe8a4123f4$export$2da9be4cfdb689b1 = {
    now: ()=>{
        if ($111e7cbe8a4123f4$var$now === undefined) $111e7cbe8a4123f4$export$2da9be4cfdb689b1.set((0, $f28d1a4d8c26f6e5$export$fff89137e9e818ce).isProcessing || (0, $fbf024f08bc41b75$export$dd826089e3c5e502).useManualTiming ? (0, $f28d1a4d8c26f6e5$export$fff89137e9e818ce).timestamp : performance.now());
        return $111e7cbe8a4123f4$var$now;
    },
    set: (newTime)=>{
        $111e7cbe8a4123f4$var$now = newTime;
        queueMicrotask($111e7cbe8a4123f4$var$clearTime);
    }
};


const $536f8c4470f7cfa4$export$ff25708b37f72782 = ()=>({
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    });
const $536f8c4470f7cfa4$export$3d227df54007d73a = ()=>({
        x: $536f8c4470f7cfa4$export$ff25708b37f72782(),
        y: $536f8c4470f7cfa4$export$ff25708b37f72782()
    });
const $536f8c4470f7cfa4$export$6db76765312617ac = ()=>({
        min: 0,
        max: 0
    });
const $536f8c4470f7cfa4$export$6459fc9e86be362e = ()=>({
        x: $536f8c4470f7cfa4$export$6db76765312617ac(),
        y: $536f8c4470f7cfa4$export$6db76765312617ac()
    });


/*
  Convert velocity into velocity per second
*/ /*#__NO_SIDE_EFFECTS__*/ const $f384b8b627a7fd13$export$eab0632f7ad4f9d7 = (velocity, frameDuration)=>frameDuration ? velocity * (1000 / frameDuration) : 0;




/**
 * Maximum time between the value of two frames, beyond which we
 * assume the velocity has since been 0.
 */ const $fdf0a8816be57e7f$var$MAX_VELOCITY_DELTA = 30;
const $fdf0a8816be57e7f$var$isFloat = (value)=>{
    return !isNaN(parseFloat(value));
};
const $fdf0a8816be57e7f$export$67fcd818a264039d = {
    current: undefined
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ class $fdf0a8816be57e7f$export$8cea36d14ee64562 {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     */ constructor(init, options = {}){
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = null;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = (v)=>{
            const currentTime = (0, $111e7cbe8a4123f4$export$2da9be4cfdb689b1).now();
            /**
             * If we're updating the value during another frame or eventloop
             * than the previous frame, then the we set the previous frame value
             * to current.
             */ if (this.updatedAt !== currentTime) this.setPrevFrameValue();
            this.prev = this.current;
            this.setCurrent(v);
            // Update update subscribers
            if (this.current !== this.prev) {
                this.events.change?.notify(this.current);
                if (this.dependents) for (const dependent of this.dependents)dependent.dirty();
            }
        };
        this.hasAnimated = false;
        this.setCurrent(init);
        this.owner = options.owner;
    }
    setCurrent(current) {
        this.current = current;
        this.updatedAt = (0, $111e7cbe8a4123f4$export$2da9be4cfdb689b1).now();
        if (this.canTrackVelocity === null && current !== undefined) this.canTrackVelocity = $fdf0a8816be57e7f$var$isFloat(this.current);
    }
    setPrevFrameValue(prevFrameValue = this.current) {
        this.prevFrameValue = prevFrameValue;
        this.prevUpdatedAt = this.updatedAt;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ onChange(subscription) {
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $450ebeef08659e3e$export$e7dff9482a5fd23c)();
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") return ()=>{
            unsubscribe();
            /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, $f28d1a4d8c26f6e5$export$2cef06c20297c17d).read(()=>{
                if (!this.events.change.getSize()) this.stop();
            });
        };
        return unsubscribe;
    }
    clearListeners() {
        for(const eventManagers in this.events)this.events[eventManagers].clear();
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     */ attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ set(v) {
        if (!this.passiveEffect) this.updateAndNotify(v);
        else this.passiveEffect(v, this.updateAndNotify);
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = undefined;
        this.prevFrameValue = prev;
        this.prevUpdatedAt = this.updatedAt - delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ jump(v, endAnimation = true) {
        this.updateAndNotify(v);
        this.prev = v;
        this.prevUpdatedAt = this.prevFrameValue = undefined;
        endAnimation && this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    dirty() {
        this.events.change?.notify(this.current);
    }
    addDependent(dependent) {
        if (!this.dependents) this.dependents = new Set();
        this.dependents.add(dependent);
    }
    removeDependent(dependent) {
        if (this.dependents) this.dependents.delete(dependent);
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ get() {
        if ($fdf0a8816be57e7f$export$67fcd818a264039d.current) $fdf0a8816be57e7f$export$67fcd818a264039d.current.push(this);
        return this.current;
    }
    /**
     * @public
     */ getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ getVelocity() {
        const currentTime = (0, $111e7cbe8a4123f4$export$2da9be4cfdb689b1).now();
        if (!this.canTrackVelocity || this.prevFrameValue === undefined || currentTime - this.updatedAt > $fdf0a8816be57e7f$var$MAX_VELOCITY_DELTA) return 0;
        const delta = Math.min(this.updatedAt - this.prevUpdatedAt, $fdf0a8816be57e7f$var$MAX_VELOCITY_DELTA);
        // Casts because of parseFloat's poor typing
        return (0, $f384b8b627a7fd13$export$eab0632f7ad4f9d7)(parseFloat(this.current) - parseFloat(this.prevFrameValue), delta);
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     */ start(startAnimation) {
        this.stop();
        return new Promise((resolve)=>{
            this.hasAnimated = true;
            this.animation = startAnimation(resolve);
            if (this.events.animationStart) this.events.animationStart.notify();
        }).then(()=>{
            if (this.events.animationComplete) this.events.animationComplete.notify();
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */ stop() {
        if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) this.events.animationCancel.notify();
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ isAnimating() {
        return !!this.animation;
    }
    clearAnimation() {
        delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ destroy() {
        this.dependents?.clear();
        this.events.destroy?.notify();
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
}
function $fdf0a8816be57e7f$export$ce8bdc721e76545f(init, options) {
    return new $fdf0a8816be57e7f$export$8cea36d14ee64562(init, options);
}








/**
 * A list of all ValueTypes
 */ const $00673f3cc2ebb84f$var$valueTypes = [
    ...(0, $1e9b40bf478fdf7c$export$d176691c1998a1f5),
    (0, $c0d5455d86887039$export$35e9368ef982300f),
    (0, $cfd2572e4bd61faa$export$83a0e34f1302825b)
];
/**
 * Tests a value against the list of ValueTypes
 */ const $00673f3cc2ebb84f$export$950e7e59ea1ffed7 = (v)=>$00673f3cc2ebb84f$var$valueTypes.find((0, $17df7f4e324410c3$export$6eae4d0a6a7ca7cd)(v));



const $7b018e85ab6314e3$export$bc2a978a17abfdde = new WeakMap();


function $91a47968b972d848$export$aa71198ceeaf53ce(v) {
    return v !== null && typeof v === "object" && typeof v.start === "function";
}


/**
 * Decides if the supplied variable is variant label
 */ function $eadf3b720b2072c8$export$720b90e312cea233(v) {
    return typeof v === "string" || Array.isArray(v);
}


const $5d862b5000c3db57$export$16e45afcc206d3a8 = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
const $5d862b5000c3db57$export$1405a65085f40b9 = [
    "initial",
    ...$5d862b5000c3db57$export$16e45afcc206d3a8
];


function $1a7023d285f8cd18$export$4b3c3bd8d910d78d(props) {
    return (0, $91a47968b972d848$export$aa71198ceeaf53ce)(props.animate) || (0, $5d862b5000c3db57$export$1405a65085f40b9).some((name)=>(0, $eadf3b720b2072c8$export$720b90e312cea233)(props[name]));
}
function $1a7023d285f8cd18$export$ce46fa4165cdec40(props) {
    return Boolean($1a7023d285f8cd18$export$4b3c3bd8d910d78d(props) || props.variants);
}





/**
 * Updates motion values from props changes.
 * Uses `any` type for element to avoid circular dependencies with VisualElement.
 */ function $11a0ddb34835ff0c$export$9a552858d5197f6e(element, next, prev) {
    for(const key in next){
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0, $b2042ca666edf2e9$export$605d60a2578142d3)(nextValue)) /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
        else if ((0, $b2042ca666edf2e9$export$605d60a2578142d3)(prevValue)) /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $fdf0a8816be57e7f$export$ce8bdc721e76545f)(nextValue, {
            owner: element
        }));
        else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                if (existingValue.liveStyle === true) existingValue.jump(nextValue);
                else if (!existingValue.hasAnimated) existingValue.set(nextValue);
            } else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, (0, $fdf0a8816be57e7f$export$ce8bdc721e76545f)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(const key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}


// Does this device prefer reduced motion? Returns `null` server-side.
const $c174288c278603db$export$ff7706047246b98b = {
    current: null
};
const $c174288c278603db$export$6476d16e2fd2d0db = {
    current: false
};


const $712b1d015b15e4aa$var$isBrowser = typeof window !== "undefined";
function $712b1d015b15e4aa$export$ca9f41fb23dded3d() {
    (0, $c174288c278603db$export$6476d16e2fd2d0db).current = true;
    if (!$712b1d015b15e4aa$var$isBrowser) return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = ()=>(0, $c174288c278603db$export$ff7706047246b98b).current = motionMediaQuery.matches;
        motionMediaQuery.addEventListener("change", setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, $c174288c278603db$export$ff7706047246b98b).current = false;
}


function $161db3d11edd337b$var$getValueState(visualElement) {
    const state = [
        {},
        {}
    ];
    visualElement?.values.forEach((value, key)=>{
        state[0][key] = value.get();
        state[1][key] = value.getVelocity();
    });
    return state;
}
function $161db3d11edd337b$export$d68f140c4d9b48bc(props, definition, custom, visualElement) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") {
        const [current, velocity] = $161db3d11edd337b$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") {
        const [current, velocity] = $161db3d11edd337b$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    return definition;
}




const $d212cef4845b2412$var$propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
/**
 * Static feature definitions - can be injected by framework layer
 */ let $d212cef4845b2412$var$featureDefinitions = {};
/**
 * Set feature definitions for all VisualElements.
 * This should be called by the framework layer (e.g., framer-motion) during initialization.
 */ function $d212cef4845b2412$export$8ad214844176d967(definitions) {
    $d212cef4845b2412$var$featureDefinitions = definitions;
}
/**
 * Get the current feature definitions
 */ function $d212cef4845b2412$export$e183cb9c018608ba() {
    return $d212cef4845b2412$var$featureDefinitions;
}
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ class $d212cef4845b2412$export$fa8b653c0f3714e5 {
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ scrapeMotionValuesFromProps(_props, _prevProps, _visualElement) {
        return {};
    }
    constructor({ parent: parent, props: props, presenceContext: presenceContext, reducedMotionConfig: reducedMotionConfig, skipAnimations: skipAnimations, blockInitialAnimation: blockInitialAnimation, visualState: visualState }, options = {}){
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * Decides whether animations should be skipped for this VisualElement.
         * Useful for E2E tests and visual regression testing.
         */ this.shouldSkipAnimations = false;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        this.KeyframeResolver = (0, $b4c6185e0f3b6dcd$export$74d34ca3182f1750);
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * Track whether this element has been mounted before, to detect
         * remounts after Suspense unmount/remount cycles.
         */ this.hasBeenMounted = false;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = ()=>this.notify("Update", this.latestValues);
        this.render = ()=>{
            if (!this.current) return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.renderScheduledAt = 0.0;
        this.scheduleRender = ()=>{
            const now = (0, $111e7cbe8a4123f4$export$2da9be4cfdb689b1).now();
            if (this.renderScheduledAt < now) {
                this.renderScheduledAt = now;
                (0, $f28d1a4d8c26f6e5$export$2cef06c20297c17d).render(this.render, false, true);
            }
        };
        const { latestValues: latestValues, renderState: renderState } = visualState;
        this.latestValues = latestValues;
        this.baseTarget = {
            ...latestValues
        };
        this.initialValues = props.initial ? {
            ...latestValues
        } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.skipAnimationsConfig = skipAnimations;
        this.options = options;
        this.blockInitialAnimation = Boolean(blockInitialAnimation);
        this.isControllingVariants = (0, $1a7023d285f8cd18$export$4b3c3bd8d910d78d)(props);
        this.isVariantNode = (0, $1a7023d285f8cd18$export$ce46fa4165cdec40)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't necessarily a breaking change,
         * more a reflection of the test.
         */ const { willChange: willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {}, this);
        for(const key in initialMotionValues){
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $b2042ca666edf2e9$export$605d60a2578142d3)(value)) value.set(latestValues[key]);
        }
    }
    mount(instance) {
        /**
         * If this element has been mounted before (e.g. after a Suspense
         * unmount/remount), reset motion values to their initial state
         * so animations replay correctly from initial → animate.
         */ if (this.hasBeenMounted) for(const key in this.initialValues){
            this.values.get(key)?.jump(this.initialValues[key]);
            this.latestValues[key] = this.initialValues[key];
        }
        this.current = instance;
        (0, $7b018e85ab6314e3$export$bc2a978a17abfdde).set(instance, this);
        if (this.projection && !this.projection.instance) this.projection.mount(instance);
        if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
        this.values.forEach((value, key)=>this.bindToMotionValue(key, value));
        /**
         * Determine reduced motion preference. Only initialize the matchMedia
         * listener if we actually need the dynamic value (i.e., when config
         * is neither "never" nor "always").
         */ if (this.reducedMotionConfig === "never") this.shouldReduceMotion = false;
        else if (this.reducedMotionConfig === "always") this.shouldReduceMotion = true;
        else {
            if (!(0, $c174288c278603db$export$6476d16e2fd2d0db).current) (0, $712b1d015b15e4aa$export$ca9f41fb23dded3d)();
            this.shouldReduceMotion = (0, $c174288c278603db$export$ff7706047246b98b).current;
        }
        /**
         * Set whether animations should be skipped based on the config.
         */ this.shouldSkipAnimations = this.skipAnimationsConfig ?? false;
        this.parent?.addChild(this);
        this.update(this.props, this.presenceContext);
        this.hasBeenMounted = true;
    }
    unmount() {
        this.projection && this.projection.unmount();
        (0, $f28d1a4d8c26f6e5$export$ec99c0ef4978dccb)(this.notifyUpdate);
        (0, $f28d1a4d8c26f6e5$export$ec99c0ef4978dccb)(this.render);
        this.valueSubscriptions.forEach((remove)=>remove());
        this.valueSubscriptions.clear();
        this.removeFromVariantTree && this.removeFromVariantTree();
        this.parent?.removeChild(this);
        for(const key in this.events)this.events[key].clear();
        for(const key in this.features){
            const feature = this.features[key];
            if (feature) {
                feature.unmount();
                feature.isMounted = false;
            }
        }
        this.current = null;
    }
    addChild(child) {
        this.children.add(child);
        this.enteringChildren ?? (this.enteringChildren = new Set());
        this.enteringChildren.add(child);
    }
    removeChild(child) {
        this.children.delete(child);
        this.enteringChildren && this.enteringChildren.delete(child);
    }
    bindToMotionValue(key, value) {
        if (this.valueSubscriptions.has(key)) this.valueSubscriptions.get(key)();
        if (value.accelerate && (0, $0bbb7ed9e051efbb$export$a27eefbd8fb5e404).has(key) && this.current instanceof HTMLElement) {
            const { factory: factory, keyframes: keyframes, times: times, ease: ease, duration: duration } = value.accelerate;
            const animation = new (0, $a13be77b2bd23e68$export$6c0f9803d8aa7219)({
                element: this.current,
                name: key,
                keyframes: keyframes,
                times: times,
                ease: ease,
                duration: (0, $a69653fc318d2500$export$fc3e7e8557f8c8c7)(duration)
            });
            const cleanup = factory(animation);
            this.valueSubscriptions.set(key, ()=>{
                cleanup();
                animation.cancel();
            });
            return;
        }
        const valueIsTransform = (0, $505b0017451a5f76$export$7b42a0094fb00b6e).has(key);
        if (valueIsTransform && this.onBindTransform) this.onBindTransform();
        const removeOnChange = value.on("change", (latestValue)=>{
            this.latestValues[key] = latestValue;
            this.props.onUpdate && (0, $f28d1a4d8c26f6e5$export$2cef06c20297c17d).preRender(this.notifyUpdate);
            if (valueIsTransform && this.projection) this.projection.isTransformDirty = true;
            this.scheduleRender();
        });
        let removeSyncCheck;
        if (typeof window !== "undefined" && window.MotionCheckAppearSync) removeSyncCheck = window.MotionCheckAppearSync(this, key, value);
        this.valueSubscriptions.set(key, ()=>{
            removeOnChange();
            if (removeSyncCheck) removeSyncCheck();
        // Defer to MotionValue.on("change") auto-stop so React 19 remounts
        // can resubscribe before the animation is cancelled (#3315).
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    updateFeatures() {
        let key = "animation";
        for(key in $d212cef4845b2412$var$featureDefinitions){
            const featureDefinition = $d212cef4845b2412$var$featureDefinitions[key];
            if (!featureDefinition) continue;
            const { isEnabled: isEnabled, Feature: FeatureConstructor } = featureDefinition;
            /**
             * If this feature is enabled but not active, make a new instance.
             */ if (!this.features[key] && FeatureConstructor && isEnabled(this.props)) this.features[key] = new FeatureConstructor(this);
            /**
             * If we have a feature, mount or update it.
             */ if (this.features[key]) {
                const feature = this.features[key];
                if (feature.isMounted) feature.update();
                else {
                    feature.mount();
                    feature.isMounted = true;
                }
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, $536f8c4470f7cfa4$export$6459fc9e86be362e)();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ update(props, presenceContext) {
        if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
        this.prevProps = this.props;
        this.props = props;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = presenceContext;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(let i = 0; i < $d212cef4845b2412$var$propEventHandlers.length; i++){
            const key = $d212cef4845b2412$var$propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listenerName = "on" + key;
            const listener = props[listenerName];
            if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
        }
        this.prevMotionValues = (0, $11a0ddb34835ff0c$export$9a552858d5197f6e)(this, this.scrapeMotionValuesFromProps(props, this.prevProps || {}, this), this.prevMotionValues);
        if (this.handleChildMotionValue) this.handleChildMotionValue();
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */ getVariant(name) {
        return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */ getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
    /**
     * Add a child visual element to our set of children.
     */ addVariantChild(child) {
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
            return ()=>closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */ addValue(key, value) {
        // Remove existing value if it exists
        const existingValue = this.values.get(key);
        if (value !== existingValue) {
            if (existingValue) this.removeValue(key);
            this.bindToMotionValue(key, value);
            this.values.set(key, value);
            this.latestValues[key] = value.get();
        }
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */ removeValue(key) {
        this.values.delete(key);
        const unsubscribe = this.valueSubscriptions.get(key);
        if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
        }
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */ hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) return this.props.values[key];
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = (0, $fdf0a8816be57e7f$export$ce8bdc721e76545f)(defaultValue === null ? undefined : defaultValue, {
                owner: this
            });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ readValue(key, target) {
        let value = this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : this.getBaseTargetFromProps(this.props, key) ?? this.readValueFromInstance(this.current, key, this.options);
        if (value !== undefined && value !== null) {
            if (typeof value === "string" && ((0, $99950dc4fad68cb3$export$65583ed5a868f2d9)(value) || (0, $1583088b6e4985b0$export$ade84c85e44a6cb1)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
            value = parseFloat(value);
            else if (!(0, $00673f3cc2ebb84f$export$950e7e59ea1ffed7)(value) && (0, $cfd2572e4bd61faa$export$83a0e34f1302825b).test(target)) value = (0, $8e8a8e07dd5e5c17$export$cea0cedcb94873b5)(key, target);
            this.setBaseTarget(key, (0, $b2042ca666edf2e9$export$605d60a2578142d3)(value) ? value.get() : value);
        }
        return (0, $b2042ca666edf2e9$export$605d60a2578142d3)(value) ? value.get() : value;
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ getBaseTarget(key) {
        const { initial: initial } = this.props;
        let valueFromInitial;
        if (typeof initial === "string" || typeof initial === "object") {
            const variant = (0, $161db3d11edd337b$export$d68f140c4d9b48bc)(this.props, initial, this.presenceContext?.custom);
            if (variant) valueFromInitial = variant[key];
        }
        /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !(0, $b2042ca666edf2e9$export$605d60a2578142d3)(target)) return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $450ebeef08659e3e$export$e7dff9482a5fd23c)();
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        if (this.events[eventName]) this.events[eventName].notify(...args);
    }
    scheduleRenderMicrotask() {
        (0, $72c587626bccb82b$export$bb76eed83315504c).render(this.render);
    }
}


class $89115eaae95ab7fb$export$e49735c2a366bdc7 extends (0, $d212cef4845b2412$export$fa8b653c0f3714e5) {
    constructor(){
        super(...arguments);
        this.KeyframeResolver = (0, $08f7b98a2ff2d146$export$4983792d11b61017);
    }
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        const style = props.style;
        return style ? style[key] : undefined;
    }
    removeValueFromRenderState(key, { vars: vars, style: style }) {
        delete vars[key];
        delete style[key];
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children: children } = this.props;
        if ((0, $b2042ca666edf2e9$export$605d60a2578142d3)(children)) this.childSubscription = children.on("change", (latest)=>{
            if (this.current) this.current.textContent = `${latest}`;
        });
    }
}


/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ const $9a214a356c6e3ff1$export$453ef540a9a1bd6b = (value, type)=>{
    return type && typeof value === "number" ? type.transform(value) : value;
};








const $130b4f1a99ed2dd0$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
const $130b4f1a99ed2dd0$var$numTransforms = (0, $505b0017451a5f76$export$280dc01950909d86).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $130b4f1a99ed2dd0$export$bdc96e0d5c8f914(latestValues, transform, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    let transformIsDefault = true;
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(let i = 0; i < $130b4f1a99ed2dd0$var$numTransforms; i++){
        const key = (0, $505b0017451a5f76$export$280dc01950909d86)[i];
        const value = latestValues[key];
        if (value === undefined) continue;
        let valueIsDefault = true;
        if (typeof value === "number") valueIsDefault = value === (key.startsWith("scale") ? 1 : 0);
        else {
            const parsed = parseFloat(value);
            valueIsDefault = key.startsWith("scale") ? parsed === 1 : parsed === 0;
        }
        if (!valueIsDefault || transformTemplate) {
            const valueAsType = (0, $9a214a356c6e3ff1$export$453ef540a9a1bd6b)(value, (0, $c8706b17cc70099b$export$eec14432cd1cb67b)[key]);
            if (!valueIsDefault) {
                transformIsDefault = false;
                const transformName = $130b4f1a99ed2dd0$var$translateAlias[key] || key;
                transformString += `${transformName}(${valueAsType}) `;
            }
            if (transformTemplate) transform[key] = valueAsType;
        }
    }
    // `pathRotation` composes onto `rotate` as a separate additive term so
    // the user's `rotate` is never clobbered. Deliberately not a slot in
    // `transformPropOrder`.
    const pathRotation = latestValues.pathRotation;
    if (pathRotation) {
        transformIsDefault = false;
        transformString += `rotate(${(0, $9a214a356c6e3ff1$export$453ef540a9a1bd6b)(pathRotation, (0, $c8706b17cc70099b$export$eec14432cd1cb67b).pathRotation)}) `;
    }
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (transformIsDefault) transformString = "none";
    return transformString;
}


function $874423f187491206$export$bb517f8b40f8e99d(state, latestValues, transformTemplate) {
    const { style: style, vars: vars, transformOrigin: transformOrigin } = state;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept separately for further processing.
     */ for(const key in latestValues){
        const value = latestValues[key];
        if ((0, $505b0017451a5f76$export$7b42a0094fb00b6e).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            continue;
        } else if ((0, $8c245764d0d5c573$export$9de1236619d9e756)(key)) {
            vars[key] = value;
            continue;
        } else {
            // Convert the value to its default value type, ie 0 -> "0px"
            const valueAsType = (0, $9a214a356c6e3ff1$export$453ef540a9a1bd6b)(value, (0, $c8706b17cc70099b$export$eec14432cd1cb67b)[key]);
            if (key.startsWith("origin")) {
                // If this is a transform origin, flag and enable further transform-origin processing
                hasTransformOrigin = true;
                transformOrigin[key] = valueAsType;
            } else style[key] = valueAsType;
        }
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, $130b4f1a99ed2dd0$export$bdc96e0d5c8f914)(latestValues, state.transform, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        const { originX: originX = "50%", originY: originY = "50%", originZ: originZ = 0 } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}


function $1ed940f8336a029d$export$1a32bf6229c258c0(element, { style: style, vars: vars }, styleProp, projection) {
    const elementStyle = element.style;
    let key;
    for(key in style)// CSSStyleDeclaration has [index: number]: string; in the types, so we use that as key type.
    elementStyle[key] = style[key];
    // Write projection styles directly to element style
    projection?.applyProjectionStyles(elementStyle, styleProp);
    for(key in vars)// Loop over any CSS variables and assign those.
    // They can only be assigned using `setProperty`.
    elementStyle.setProperty(key, vars[key]);
}






function $306704060071f45a$export$fafff692be55225d(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ const $306704060071f45a$export$5eafb6257a5844c = {
    correct: (latest, node)=>{
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, $b70b0cd340f5c11d$export$91c0eda1d06bf008).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ const x = $306704060071f45a$export$fafff692be55225d(latest, node.target.x);
        const y = $306704060071f45a$export$fafff692be55225d(latest, node.target.y);
        return `${x}% ${y}%`;
    }
};




const $d16df58c6894047c$export$eb0bc629e74dcf8 = {
    correct: (latest, { treeScale: treeScale, projectionDelta: projectionDelta })=>{
        const original = latest;
        const shadow = (0, $cfd2572e4bd61faa$export$83a0e34f1302825b).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        const template = (0, $cfd2572e4bd61faa$export$83a0e34f1302825b).createTransformer(latest);
        const offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        const xScale = projectionDelta.x.scale * treeScale.x;
        const yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ const averageScale = (0, $33875f370c178373$export$3bb0b4ff1037b8dd)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        return template(shadow);
    }
};


const $af519f1fd2f08378$export$91ddd985b97788d1 = {
    borderRadius: {
        ...(0, $306704060071f45a$export$5eafb6257a5844c),
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    },
    borderTopLeftRadius: (0, $306704060071f45a$export$5eafb6257a5844c),
    borderTopRightRadius: (0, $306704060071f45a$export$5eafb6257a5844c),
    borderBottomLeftRadius: (0, $306704060071f45a$export$5eafb6257a5844c),
    borderBottomRightRadius: (0, $306704060071f45a$export$5eafb6257a5844c),
    boxShadow: (0, $d16df58c6894047c$export$eb0bc629e74dcf8)
};
function $af519f1fd2f08378$export$de9e7791c71225fd(correctors) {
    for(const key in correctors){
        $af519f1fd2f08378$export$91ddd985b97788d1[key] = correctors[key];
        if ((0, $8c245764d0d5c573$export$9de1236619d9e756)(key)) $af519f1fd2f08378$export$91ddd985b97788d1[key].isCSSVariable = true;
    }
}


function $f4639d0a3ef3ab74$export$6d27ce8e3de1c3cf(key, { layout: layout, layoutId: layoutId }) {
    return (0, $505b0017451a5f76$export$7b42a0094fb00b6e).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, $af519f1fd2f08378$export$91ddd985b97788d1)[key] || key === "opacity");
}


function $074924943c816e8b$export$16da615486abaa45(props, prevProps, visualElement) {
    const style = props.style;
    const prevStyle = prevProps?.style;
    const newValues = {};
    if (!style) return newValues;
    for(const key in style)if ((0, $b2042ca666edf2e9$export$605d60a2578142d3)(style[key]) || prevStyle && (0, $b2042ca666edf2e9$export$605d60a2578142d3)(prevStyle[key]) || (0, $f4639d0a3ef3ab74$export$6d27ce8e3de1c3cf)(key, props) || visualElement?.getValue(key)?.liveStyle !== undefined) newValues[key] = style[key];
    return newValues;
}


function $10bc446e177a09cb$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
class $10bc446e177a09cb$export$23fea75b03ac16b3 extends (0, $89115eaae95ab7fb$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.type = "html";
        this.renderInstance = (0, $1ed940f8336a029d$export$1a32bf6229c258c0);
    }
    readValueFromInstance(instance, key) {
        if ((0, $505b0017451a5f76$export$7b42a0094fb00b6e).has(key)) return this.projection?.isProjecting ? (0, $ffe0bf72d53f9a3c$export$1f10c01143b9f089)(key) : (0, $ffe0bf72d53f9a3c$export$bcd97e0e03ba17f6)(instance, key);
        else {
            const computedStyle = $10bc446e177a09cb$export$3735103072e4a80(instance);
            const value = ((0, $8c245764d0d5c573$export$9de1236619d9e756)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint: transformPagePoint }) {
        return (0, $a55bdfd27a922601$export$d8718b6a7e5c624e)(instance, transformPagePoint);
    }
    build(renderState, latestValues, props) {
        (0, $874423f187491206$export$bb517f8b40f8e99d)(renderState, latestValues, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $074924943c816e8b$export$16da615486abaa45)(props, prevProps, visualElement);
    }
}





function $d256ed06f8c3ce8e$export$9fd24a634729c672(str) {
    return str.replace(/([A-Z])/g, (match)=>`-${match.toLowerCase()}`);
}



const $43fbfa5f6b784104$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
const $43fbfa5f6b784104$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 *
 * Note: We use unitless values for stroke-dasharray and stroke-dashoffset
 * because Safari incorrectly scales px values when the page is zoomed.
 */ function $43fbfa5f6b784104$export$311b43f666da1d82(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? $43fbfa5f6b784104$var$dashKeys : $43fbfa5f6b784104$var$camelKeys;
    // Build the dash offset (unitless to avoid Safari zoom bug)
    attrs[keys.offset] = `${-offset}`;
    // Build the dash array (unitless to avoid Safari zoom bug)
    attrs[keys.array] = `${length} ${spacing}`;
}


/**
 * CSS Motion Path properties that should remain as CSS styles on SVG elements.
 */ const $b587c5c45be9cc39$var$cssMotionPathProperties = [
    "offsetDistance",
    "offsetPath",
    "offsetRotate",
    "offsetAnchor"
];
/**
 * Build SVG visual attributes, like cx and style.transform
 */ function $b587c5c45be9cc39$export$5475d24f125d7053(state, { attrX: attrX, attrY: attrY, attrScale: attrScale, pathLength: pathLength, pathSpacing: pathSpacing = 1, pathOffset: pathOffset = 0, // This is object creation, which we try to avoid per-frame.
...latest }, isSVGTag, transformTemplate, styleProp) {
    (0, $874423f187491206$export$bb517f8b40f8e99d)(state, latest, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs: attrs, style: style } = state;
    /**
     * However, we apply transforms as CSS transforms.
     * So if we detect a transform, transformOrigin we take it from attrs and copy it into style.
     */ if (attrs.transform) {
        style.transform = attrs.transform;
        delete attrs.transform;
    }
    if (style.transform || attrs.transformOrigin) {
        style.transformOrigin = attrs.transformOrigin ?? "50% 50%";
        delete attrs.transformOrigin;
    }
    if (style.transform) {
        /**
         * SVG's element transform-origin uses its own median as a reference.
         * Therefore, transformBox becomes a fill-box
         */ style.transformBox = styleProp?.transformBox ?? "fill-box";
        delete attrs.transformBox;
    }
    for (const key of $b587c5c45be9cc39$var$cssMotionPathProperties)if (attrs[key] !== undefined) {
        style[key] = attrs[key];
        delete attrs[key];
    }
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $43fbfa5f6b784104$export$311b43f666da1d82)(attrs, pathLength, pathSpacing, pathOffset, false);
}


/**
 * A set of attribute names that are always read/written as camel case.
 */ const $c3c2c268fee37fb6$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);


const $db85136ce329988b$export$6328ce7565ea1049 = (tag)=>typeof tag === "string" && tag.toLowerCase() === "svg";





function $051bfd2da06c3709$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $1ed940f8336a029d$export$1a32bf6229c258c0)(element, renderState, undefined, projection);
    for(const key in renderState.attrs)element.setAttribute(!(0, $c3c2c268fee37fb6$export$28931db5d57958e5).has(key) ? (0, $d256ed06f8c3ce8e$export$9fd24a634729c672)(key) : key, renderState.attrs[key]);
}





function $1ecd798ce9c81296$export$16da615486abaa45(props, prevProps, visualElement) {
    const newValues = (0, $074924943c816e8b$export$16da615486abaa45)(props, prevProps, visualElement);
    for(const key in props)if ((0, $b2042ca666edf2e9$export$605d60a2578142d3)(props[key]) || (0, $b2042ca666edf2e9$export$605d60a2578142d3)(prevProps[key])) {
        const targetKey = (0, $505b0017451a5f76$export$280dc01950909d86).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}


class $11384e967cf95171$export$86bcdffbaf733d84 extends (0, $89115eaae95ab7fb$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.type = "svg";
        this.isSVGTag = false;
        this.measureInstanceViewportBox = (0, $536f8c4470f7cfa4$export$6459fc9e86be362e);
    }
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if ((0, $505b0017451a5f76$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $9d3e5596a4892dc3$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !(0, $c3c2c268fee37fb6$export$28931db5d57958e5).has(key) ? (0, $d256ed06f8c3ce8e$export$9fd24a634729c672)(key) : key;
        return instance.getAttribute(key);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $1ecd798ce9c81296$export$16da615486abaa45)(props, prevProps, visualElement);
    }
    build(renderState, latestValues, props) {
        (0, $b587c5c45be9cc39$export$5475d24f125d7053)(renderState, latestValues, this.isSVGTag, props.transformTemplate, props.style);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $051bfd2da06c3709$export$c5f8399d19a7394b)(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = (0, $db85136ce329988b$export$6328ce7565ea1049)(instance.tagName);
        super.mount(instance);
    }
}



var $8v0nu = parcelRequire("8v0nu");
/**
 * We keep these listed separately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ const $074c6b22688d52a7$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view"
];


function $8da896a5df5bb10c$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $074c6b22688d52a7$export$40209c4c512158e6).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/u.test(Component)) return true;
    return false;
}


const $2ed68384d46bf5e0$export$56ba0183203348f5 = (Component, options)=>{
    /**
     * Use explicit isSVG override if provided, otherwise auto-detect
     */ const isSVG = options.isSVG ?? (0, $8da896a5df5bb10c$export$88f3fc2fd3766989)(Component);
    return isSVG ? new (0, $11384e967cf95171$export$86bcdffbaf733d84)(options) : new (0, $10bc446e177a09cb$export$23fea75b03ac16b3)(options, {
        allowProjection: Component !== (0, $8v0nu.Fragment)
    });
};






var $8v0nu = parcelRequire("8v0nu");


var $8v0nu = parcelRequire("8v0nu");
"use client";
const $16011037ea920e2b$export$40f10139ecf1f171 = (0, $8v0nu.createContext)({
    strict: false
});




var $8v0nu = parcelRequire("8v0nu");
"use client";
const $bb7a60e717387246$export$2285bbca2c666415 = /* @__PURE__ */ (0, $8v0nu.createContext)({});



var $8v0nu = parcelRequire("8v0nu");


function $7481a28f44d5b4c1$export$12fc32fc096a04a3(props, context) {
    if ((0, $1a7023d285f8cd18$export$4b3c3bd8d910d78d)(props)) {
        const { initial: initial, animate: animate } = props;
        return {
            initial: initial === false || (0, $eadf3b720b2072c8$export$720b90e312cea233)(initial) ? initial : undefined,
            animate: (0, $eadf3b720b2072c8$export$720b90e312cea233)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}


"use client";
function $260e5925d2bbc616$export$c5638d843b37a176(props) {
    const { initial: initial, animate: animate } = (0, $7481a28f44d5b4c1$export$12fc32fc096a04a3)(props, (0, $8v0nu.useContext)((0, $bb7a60e717387246$export$2285bbca2c666415)));
    return (0, $8v0nu.useMemo)(()=>({
            initial: initial,
            animate: animate
        }), [
        $260e5925d2bbc616$var$variantLabelsAsDependency(initial),
        $260e5925d2bbc616$var$variantLabelsAsDependency(animate)
    ]);
}
function $260e5925d2bbc616$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}




var $8v0nu = parcelRequire("8v0nu");


var $8v0nu = parcelRequire("8v0nu");
const $c8111101bbe2ffd4$export$8940b483cf52eeda = ()=>({
        style: {},
        transform: {},
        transformOrigin: {},
        vars: {}
    });


"use client";
function $98b95a9386733211$export$40dafdb8630c956b(target, source, props) {
    for(const key in source)if (!(0, $b2042ca666edf2e9$export$605d60a2578142d3)(source[key]) && !(0, $f4639d0a3ef3ab74$export$6d27ce8e3de1c3cf)(key, props)) target[key] = source[key];
}
function $98b95a9386733211$var$useInitialMotionValues({ transformTemplate: transformTemplate }, visualState) {
    return (0, $8v0nu.useMemo)(()=>{
        const state = (0, $c8111101bbe2ffd4$export$8940b483cf52eeda)();
        (0, $874423f187491206$export$bb517f8b40f8e99d)(state, visualState, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [
        visualState
    ]);
}
function $98b95a9386733211$var$useStyle(props, visualState) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $98b95a9386733211$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $98b95a9386733211$var$useInitialMotionValues(props, visualState));
    return style;
}
function $98b95a9386733211$export$57be0a314572d87d(props, visualState) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = $98b95a9386733211$var$useStyle(props, visualState);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    if (props.tabIndex === undefined && (props.onTap || props.onTapStart || props.whileTap)) htmlProps.tabIndex = 0;
    htmlProps.style = style;
    return htmlProps;
}




var $8v0nu = parcelRequire("8v0nu");


const $7c6b441b4b9274e9$export$41be8b43e1c4d4f9 = ()=>({
        ...(0, $c8111101bbe2ffd4$export$8940b483cf52eeda)(),
        attrs: {}
    });


"use client";
function $2b8926df5fb75707$export$84309c4f53cb1bd5(props, visualState, _isStatic, Component) {
    const visualProps = (0, $8v0nu.useMemo)(()=>{
        const state = (0, $7c6b441b4b9274e9$export$41be8b43e1c4d4f9)();
        (0, $b587c5c45be9cc39$export$5475d24f125d7053)(state, visualState, (0, $db85136ce329988b$export$6328ce7565ea1049)(Component), props.transformTemplate, props.style);
        return {
            ...state.attrs,
            style: {
                ...state.style
            }
        };
    }, [
        visualState
    ]);
    if (props.style) {
        const rawStyles = {};
        (0, $98b95a9386733211$export$40dafdb8630c956b)(rawStyles, props.style, props);
        visualProps.style = {
            ...rawStyles,
            ...visualProps.style
        };
    }
    return visualProps;
}



/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ const $ef6e9b9940eefba5$var$validMotionProps = new Set([
    "animate",
    "exit",
    "variants",
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "custom",
    "inherit",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "_dragX",
    "_dragY",
    "onHoverStart",
    "onHoverEnd",
    "onViewportEnter",
    "onViewportLeave",
    "globalTapTarget",
    "propagate",
    "ignoreStrict",
    "viewport"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $ef6e9b9940eefba5$export$2f9c46555243bf04(key) {
    return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || key.startsWith("onLayout") || $ef6e9b9940eefba5$var$validMotionProps.has(key);
}


let $1a71b3f4aaf781b2$var$shouldForward = (key)=>!(0, $ef6e9b9940eefba5$export$2f9c46555243bf04)(key);
function $1a71b3f4aaf781b2$export$59d6962c470509a5(isValidProp) {
    if (typeof isValidProp !== "function") return;
    // Explicitly filter our events
    $1a71b3f4aaf781b2$var$shouldForward = (key)=>key.startsWith("on") ? !(0, $ef6e9b9940eefba5$export$2f9c46555243bf04)(key) : isValidProp(key);
}
/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     *
     * String concatenation prevents bundlers like webpack (e.g. Storybook)
     * from statically resolving this optional dependency at build time.
     */ const emotionPkg = "@emotion/is-prop-valid";
    $1a71b3f4aaf781b2$export$59d6962c470509a5(require(emotionPkg).default);
} catch  {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $1a71b3f4aaf781b2$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for(const key in props){
        /**
         * values is considered a valid prop by Emotion, so if it's present
         * this will be rendered out to the DOM unless explicitly filtered.
         *
         * We check the type as it could be used with the `feColorMatrix`
         * element, which we support.
         */ if (key === "values" && typeof props.values === "object") continue;
        if ((0, $b2042ca666edf2e9$export$605d60a2578142d3)(props[key])) continue;
        if ($1a71b3f4aaf781b2$var$shouldForward(key) || forwardMotionProps === true && (0, $ef6e9b9940eefba5$export$2f9c46555243bf04)(key) || !isDom && !(0, $ef6e9b9940eefba5$export$2f9c46555243bf04)(key) || // If trying to use native HTML drag events, forward drag listeners
        props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    }
    return filteredProps;
}



"use client";
function $7770e214ebb5f5f8$export$e25bb1e5b53cbdff(Component, props, ref, { latestValues: latestValues }, isStatic, forwardMotionProps = false, isSVG) {
    const useVisualProps = isSVG ?? (0, $8da896a5df5bb10c$export$88f3fc2fd3766989)(Component) ? (0, $2b8926df5fb75707$export$84309c4f53cb1bd5) : (0, $98b95a9386733211$export$57be0a314572d87d);
    const visualProps = useVisualProps(props, latestValues, isStatic, Component);
    const filteredProps = (0, $1a71b3f4aaf781b2$export$d697c39a2985a4c)(props, typeof Component === "string", forwardMotionProps);
    const elementProps = Component !== (0, $8v0nu.Fragment) ? {
        ...filteredProps,
        ...visualProps,
        ref: ref
    } : {};
    /**
     * If component has been handed a motion value as its child,
     * memoise its initial value and render that. Subsequent updates
     * will be handled by the onChange handler
     */ const { children: children } = props;
    const renderedChildren = (0, $8v0nu.useMemo)(()=>(0, $b2042ca666edf2e9$export$605d60a2578142d3)(children) ? children.get() : children, [
        children
    ]);
    return (0, $8v0nu.createElement)(Component, {
        ...elementProps,
        children: renderedChildren
    });
}





/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 */ function $23078a4ec1c4a1f0$export$fcc2206ecb6d74b(value) {
    return (0, $b2042ca666edf2e9$export$605d60a2578142d3)(value) ? value.get() : value;
}



var $8v0nu = parcelRequire("8v0nu");



"use client";
function $677b4d6a54b7deb3$var$makeState({ scrapeMotionValuesFromProps: scrapeMotionValuesFromProps, createRenderState: createRenderState }, props, context, presenceContext) {
    const state = {
        latestValues: $677b4d6a54b7deb3$var$makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    return state;
}
function $677b4d6a54b7deb3$var$makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    const values = {};
    const motionValues = scrapeMotionValues(props, {});
    for(const key in motionValues)values[key] = (0, $23078a4ec1c4a1f0$export$fcc2206ecb6d74b)(motionValues[key]);
    let { initial: initial, animate: animate } = props;
    const isControllingVariants$1 = (0, $1a7023d285f8cd18$export$4b3c3bd8d910d78d)(props);
    const isVariantNode$1 = (0, $1a7023d285f8cd18$export$ce46fa4165cdec40)(props);
    if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
        if (initial === undefined) initial = context.initial;
        if (animate === undefined) animate = context.animate;
    }
    let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    const variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $91a47968b972d848$export$aa71198ceeaf53ce)(variantToSet)) {
        const list = Array.isArray(variantToSet) ? variantToSet : [
            variantToSet
        ];
        for(let i = 0; i < list.length; i++){
            const resolved = (0, $161db3d11edd337b$export$d68f140c4d9b48bc)(props, list[i]);
            if (resolved) {
                const { transitionEnd: transitionEnd, transition: transition, ...target } = resolved;
                for(const key in target){
                    let valueTarget = target[key];
                    if (Array.isArray(valueTarget)) {
                        /**
                         * Take final keyframe if the initial animation is blocked because
                         * we want to initialise at the end of that blocked animation.
                         */ const index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
                        valueTarget = valueTarget[index];
                    }
                    if (valueTarget !== null) values[key] = valueTarget;
                }
                for(const key in transitionEnd)values[key] = transitionEnd[key];
            }
        }
    }
    return values;
}
const $677b4d6a54b7deb3$export$e91e107bc6d03a8e = (config)=>(props, isStatic)=>{
        const context = (0, $8v0nu.useContext)((0, $bb7a60e717387246$export$2285bbca2c666415));
        const presenceContext = (0, $8v0nu.useContext)((0, $af42344d352b5efc$export$f224e4635b6f8ce2));
        const make = ()=>$677b4d6a54b7deb3$var$makeState(config, props, context, presenceContext);
        return isStatic ? make() : (0, $01b8aedaf4ac1f4d$export$fe4300aa8eebea86)(make);
    };



"use client";
const $ff44cc85583f3d74$export$851cf1f78cb3feac = /*@__PURE__*/ (0, $677b4d6a54b7deb3$export$e91e107bc6d03a8e)({
    scrapeMotionValuesFromProps: (0, $074924943c816e8b$export$16da615486abaa45),
    createRenderState: (0, $c8111101bbe2ffd4$export$8940b483cf52eeda)
});





"use client";
const $1873b3ae6c21f0b8$export$9922240e40b88c48 = /*@__PURE__*/ (0, $677b4d6a54b7deb3$export$e91e107bc6d03a8e)({
    scrapeMotionValuesFromProps: (0, $1ecd798ce9c81296$export$16da615486abaa45),
    createRenderState: (0, $7c6b441b4b9274e9$export$41be8b43e1c4d4f9)
});



const $e6b85364d2a9bfe7$var$featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag"
    ],
    exit: [
        "exit"
    ],
    drag: [
        "drag",
        "dragControls"
    ],
    focus: [
        "whileFocus"
    ],
    hover: [
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ],
    tap: [
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ],
    pan: [
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ],
    inView: [
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ],
    layout: [
        "layout",
        "layoutId"
    ]
};
let $e6b85364d2a9bfe7$var$isInitialized = false;
/**
 * Initialize feature definitions with isEnabled checks.
 * This must be called before any motion components are rendered.
 */ function $e6b85364d2a9bfe7$export$e7d3655c4e2f701f() {
    if ($e6b85364d2a9bfe7$var$isInitialized) return;
    const initialFeatureDefinitions = {};
    for(const key in $e6b85364d2a9bfe7$var$featureProps)initialFeatureDefinitions[key] = {
        isEnabled: (props)=>$e6b85364d2a9bfe7$var$featureProps[key].some((name)=>!!props[name])
    };
    (0, $d212cef4845b2412$export$8ad214844176d967)(initialFeatureDefinitions);
    $e6b85364d2a9bfe7$var$isInitialized = true;
}
/**
 * Get the current feature definitions, initializing if needed.
 */ function $e6b85364d2a9bfe7$export$350148171c356c79() {
    $e6b85364d2a9bfe7$export$e7d3655c4e2f701f();
    return (0, $d212cef4845b2412$export$e183cb9c018608ba)();
}




function $9b1c1ed11de10b20$export$449561ec5703cdc8(features) {
    const featureDefinitions = (0, $e6b85364d2a9bfe7$export$350148171c356c79)();
    for(const key in features)featureDefinitions[key] = {
        ...featureDefinitions[key],
        ...features[key]
    };
    (0, $d212cef4845b2412$export$8ad214844176d967)(featureDefinitions);
}


const $1dc9feb9cadcf21c$export$28e2e4cce424ae23 = Symbol.for("motionComponentSymbol");



var $8v0nu = parcelRequire("8v0nu");
"use client";
/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $270aa8ab7f4fd0fc$export$c684914703d321fd(visualState, visualElement, externalRef) {
    /**
     * Store externalRef in a ref to avoid including it in the useCallback
     * dependency array. Including externalRef in dependencies causes issues
     * with libraries like Radix UI that create new callback refs on each render
     * when using asChild - this would cause the callback to be recreated,
     * triggering element remounts and breaking AnimatePresence exit animations.
     */ const externalRefContainer = (0, $8v0nu.useRef)(externalRef);
    (0, $8v0nu.useInsertionEffect)(()=>{
        externalRefContainer.current = externalRef;
    });
    // Store cleanup function returned by callback refs (React 19 feature)
    const refCleanup = (0, $8v0nu.useRef)(null);
    return (0, $8v0nu.useCallback)((instance)=>{
        if (instance) visualState.onMount?.(instance);
        if (visualElement) instance ? visualElement.mount(instance) : visualElement.unmount();
        const ref = externalRefContainer.current;
        if (typeof ref === "function") {
            if (instance) {
                const cleanup = ref(instance);
                if (typeof cleanup === "function") refCleanup.current = cleanup;
            } else if (refCleanup.current) {
                refCleanup.current();
                refCleanup.current = null;
            } else ref(instance);
        } else if (ref) ref.current = instance;
    }, [
        visualElement
    ]);
}



const $42742662b0cbdb1f$export$ed7b8fa9dbf0105d = "framerAppearId";
const $42742662b0cbdb1f$export$8592e1c077c890a6 = "data-" + (0, $d256ed06f8c3ce8e$export$9fd24a634729c672)($42742662b0cbdb1f$export$ed7b8fa9dbf0105d);



var $8v0nu = parcelRequire("8v0nu");





var $8v0nu = parcelRequire("8v0nu");
"use client";
/**
 * Internal, exported only for usage in Framer
 */ const $970c209bfbf3f8ee$export$da5f7b802957459a = (0, $8v0nu.createContext)({});


function $cddfc7e2c37cb099$export$dedd81df7bc1307(ref) {
    return ref && typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}



"use client";
function $4b0ed2f25349061e$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement, ProjectionNodeConstructor, isSVG) {
    const { visualElement: parent } = (0, $8v0nu.useContext)((0, $bb7a60e717387246$export$2285bbca2c666415));
    const lazyContext = (0, $8v0nu.useContext)((0, $16011037ea920e2b$export$40f10139ecf1f171));
    const presenceContext = (0, $8v0nu.useContext)((0, $af42344d352b5efc$export$f224e4635b6f8ce2));
    const motionConfig = (0, $8v0nu.useContext)((0, $1dcdcab29f5a59b3$export$22a697fb29aac98d));
    const reducedMotionConfig = motionConfig.reducedMotion;
    const skipAnimations = motionConfig.skipAnimations;
    const visualElementRef = (0, $8v0nu.useRef)(null);
    /**
     * Track whether the component has been through React's commit phase.
     * Used to detect when LazyMotion features load after the component has mounted.
     */ const hasMountedOnce = (0, $8v0nu.useRef)(false);
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) {
        visualElementRef.current = createVisualElement(Component, {
            visualState: visualState,
            parent: parent,
            props: props,
            presenceContext: presenceContext,
            blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
            reducedMotionConfig: reducedMotionConfig,
            skipAnimations: skipAnimations,
            isSVG: isSVG
        });
        /**
         * If the component has already mounted before features loaded (e.g. via
         * LazyMotion with async feature loading), we need to force the initial
         * animation to run. Otherwise state changes that occurred before features
         * loaded will be lost and the element will snap to its final state.
         */ if (hasMountedOnce.current && visualElementRef.current) visualElementRef.current.manuallyAnimateOnMount = true;
    }
    const visualElement = visualElementRef.current;
    /**
     * Load Motion gesture and animation features. These are rendered as renderless
     * components so each feature can optionally make use of React lifecycle methods.
     */ const initialLayoutGroupConfig = (0, $8v0nu.useContext)((0, $970c209bfbf3f8ee$export$da5f7b802957459a));
    if (visualElement && !visualElement.projection && ProjectionNodeConstructor && (visualElement.type === "html" || visualElement.type === "svg")) $4b0ed2f25349061e$var$createProjectionNode(visualElementRef.current, props, ProjectionNodeConstructor, initialLayoutGroupConfig);
    const isMounted = (0, $8v0nu.useRef)(false);
    (0, $8v0nu.useInsertionEffect)(()=>{
        /**
         * Check the component has already mounted before calling
         * `update` unnecessarily. This ensures we skip the initial update.
         */ if (visualElement && isMounted.current) visualElement.update(props, presenceContext);
    });
    /**
     * Cache this value as we want to know whether HandoffAppearAnimations
     * was present on initial render - it will be deleted after this.
     */ const optimisedAppearId = props[0, $42742662b0cbdb1f$export$8592e1c077c890a6];
    const wantsHandoff = (0, $8v0nu.useRef)(Boolean(optimisedAppearId) && typeof window !== "undefined" && !window.MotionHandoffIsComplete?.(optimisedAppearId) && window.MotionHasOptimisedAnimation?.(optimisedAppearId));
    (0, $0e2bf99806b8255e$export$700979bc83e7db82)(()=>{
        /**
         * Track that this component has mounted. This is used to detect when
         * LazyMotion features load after the component has already committed.
         */ hasMountedOnce.current = true;
        if (!visualElement) return;
        isMounted.current = true;
        window.MotionIsMounted = true;
        visualElement.updateFeatures();
        visualElement.scheduleRenderMicrotask();
        /**
         * Ideally this function would always run in a useEffect.
         *
         * However, if we have optimised appear animations to handoff from,
         * it needs to happen synchronously to ensure there's no flash of
         * incorrect styles in the event of a hydration error.
         *
         * So if we detect a situtation where optimised appear animations
         * are running, we use useLayoutEffect to trigger animations.
         */ if (wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
    });
    (0, $8v0nu.useEffect)(()=>{
        if (!visualElement) return;
        if (!wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
        if (wantsHandoff.current) {
            // This ensures all future calls to animateChanges() in this component will run in useEffect
            queueMicrotask(()=>{
                window.MotionHandoffMarkAsComplete?.(optimisedAppearId);
            });
            wantsHandoff.current = false;
        }
        /**
         * Now we've finished triggering animations for this element we
         * can wipe the enteringChildren set for the next render.
         */ visualElement.enteringChildren = undefined;
    });
    return visualElement;
}
function $4b0ed2f25349061e$var$createProjectionNode(visualElement, props, ProjectionNodeConstructor, initialPromotionConfig) {
    const { layoutId: layoutId, layout: layout, drag: drag, dragConstraints: dragConstraints, layoutScroll: layoutScroll, layoutRoot: layoutRoot, layoutAnchor: layoutAnchor, layoutCrossfade: layoutCrossfade } = props;
    visualElement.projection = new ProjectionNodeConstructor(visualElement.latestValues, props["data-framer-portal-id"] ? undefined : $4b0ed2f25349061e$var$getClosestProjectingNode(visualElement.parent));
    visualElement.projection.setOptions({
        layoutId: layoutId,
        layout: layout,
        alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $cddfc7e2c37cb099$export$dedd81df7bc1307)(dragConstraints),
        visualElement: visualElement,
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */ animationType: typeof layout === "string" ? layout : "both",
        initialPromotionConfig: initialPromotionConfig,
        crossfade: layoutCrossfade,
        layoutScroll: layoutScroll,
        layoutRoot: layoutRoot,
        layoutAnchor: layoutAnchor
    });
}
function $4b0ed2f25349061e$var$getClosestProjectingNode(visualElement) {
    if (!visualElement) return undefined;
    return visualElement.options.allowProjection !== false ? visualElement.projection : $4b0ed2f25349061e$var$getClosestProjectingNode(visualElement.parent);
}


"use client";
/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function $0bb08eeb023bf43d$export$46b7e4b9dc6110c3(Component, { forwardMotionProps: forwardMotionProps = false, type: type } = {}, preloadedFeatures, createVisualElement) {
    preloadedFeatures && (0, $9b1c1ed11de10b20$export$449561ec5703cdc8)(preloadedFeatures);
    /**
     * Determine whether to use SVG or HTML rendering based on:
     * 1. Explicit `type` option (highest priority)
     * 2. Auto-detection via `isSVGComponent`
     */ const isSVG = type ? type === "svg" : (0, $8da896a5df5bb10c$export$88f3fc2fd3766989)(Component);
    const useVisualState = isSVG ? (0, $1873b3ae6c21f0b8$export$9922240e40b88c48) : (0, $ff44cc85583f3d74$export$851cf1f78cb3feac);
    function MotionDOMComponent(props, externalRef) {
        /**
         * If we need to measure the element we load this functionality in a
         * separate class component in order to gain access to getSnapshotBeforeUpdate.
         */ let MeasureLayout;
        const configAndProps = {
            ...(0, $8v0nu.useContext)((0, $1dcdcab29f5a59b3$export$22a697fb29aac98d)),
            ...props,
            layoutId: $0bb08eeb023bf43d$var$useLayoutId(props)
        };
        const { isStatic: isStatic } = configAndProps;
        const context = (0, $260e5925d2bbc616$export$c5638d843b37a176)(props);
        const visualState = useVisualState(props, isStatic);
        if (!isStatic && typeof window !== "undefined") {
            $0bb08eeb023bf43d$var$useStrictMode(configAndProps, preloadedFeatures);
            const layoutProjection = $0bb08eeb023bf43d$var$getProjectionFunctionality(configAndProps);
            MeasureLayout = layoutProjection.MeasureLayout;
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $4b0ed2f25349061e$export$dc0335d73ab0b115)(Component, visualState, configAndProps, createVisualElement, layoutProjection.ProjectionNode, isSVG);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return (0, $ef524fb144c5d632$exports.jsxs)((0, $bb7a60e717387246$export$2285bbca2c666415).Provider, {
            value: context,
            children: [
                MeasureLayout && context.visualElement ? (0, $ef524fb144c5d632$exports.jsx)(MeasureLayout, {
                    visualElement: context.visualElement,
                    ...configAndProps
                }) : null,
                (0, $7770e214ebb5f5f8$export$e25bb1e5b53cbdff)(Component, props, (0, $270aa8ab7f4fd0fc$export$c684914703d321fd)(visualState, context.visualElement, externalRef), visualState, isStatic, forwardMotionProps, isSVG)
            ]
        });
    }
    MotionDOMComponent.displayName = `motion.${typeof Component === "string" ? Component : `create(${Component.displayName ?? Component.name ?? ""})`}`;
    const ForwardRefMotionComponent = (0, $8v0nu.forwardRef)(MotionDOMComponent);
    ForwardRefMotionComponent[0, $1dc9feb9cadcf21c$export$28e2e4cce424ae23] = Component;
    return ForwardRefMotionComponent;
}
function $0bb08eeb023bf43d$var$useLayoutId({ layoutId: layoutId }) {
    const layoutGroupId = (0, $8v0nu.useContext)((0, $f8fa84f618a4fe1a$export$a3579ca508007a95)).id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}
function $0bb08eeb023bf43d$var$useStrictMode(configAndProps, preloadedFeatures) {
    const isStrict = (0, $8v0nu.useContext)((0, $16011037ea920e2b$export$40f10139ecf1f171)).strict;
}
function $0bb08eeb023bf43d$var$getProjectionFunctionality(props) {
    const featureDefinitions = (0, $e6b85364d2a9bfe7$export$350148171c356c79)();
    const { drag: drag, layout: layout } = featureDefinitions;
    if (!drag && !layout) return {};
    const combined = {
        ...drag,
        ...layout
    };
    return {
        MeasureLayout: drag?.isEnabled(props) || layout?.isEnabled(props) ? combined.MeasureLayout : undefined,
        ProjectionNode: combined.ProjectionNode
    };
}


function $2caddd150a756909$export$a28d6df673050e18(preloadedFeatures, createVisualElement) {
    if (typeof Proxy === "undefined") return 0, $0bb08eeb023bf43d$export$46b7e4b9dc6110c3;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ const componentCache = new Map();
    const factory = (Component, options)=>{
        return (0, $0bb08eeb023bf43d$export$46b7e4b9dc6110c3)(Component, options, preloadedFeatures, createVisualElement);
    };
    /**
     * Support for deprecated`motion(Component)` pattern
     */ const deprecatedFactoryFunction = (Component, options)=>{
        return factory(Component, options);
    };
    return new Proxy(deprecatedFactoryFunction, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: (_target, key)=>{
            if (key === "create") return factory;
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, (0, $0bb08eeb023bf43d$export$46b7e4b9dc6110c3)(key, undefined, preloadedFeatures, createVisualElement));
            return componentCache.get(key);
        }
    });
}



function $6170d4d3fca30ebd$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return (0, $161db3d11edd337b$export$d68f140c4d9b48bc)(props, definition, custom !== undefined ? custom : props.custom, visualElement);
}


/**
 * If `transition` has `inherit: true`, shallow-merge it with
 * `parentTransition` (child keys win) and strip the `inherit` key.
 * Otherwise return `transition` unchanged.
 */ function $dda4e0b3f2a3e4ad$export$b180037f8f468d61(transition, parentTransition) {
    if (transition?.inherit && parentTransition) {
        const { inherit: _, ...rest } = transition;
        return {
            ...parentTransition,
            ...rest
        };
    }
    return transition;
}


function $3c7dca54dc1f20a3$export$7c1391340308742e(transition, key) {
    const valueTransition = transition?.[key] ?? transition?.["default"] ?? transition;
    if (valueTransition !== transition) return (0, $dda4e0b3f2a3e4ad$export$b180037f8f468d61)(valueTransition, transition);
    return valueTransition;
}






const $b2767e1885a0e038$export$9153ad4c4999f4a0 = (v)=>{
    return Array.isArray(v);
};


/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $fee5b5cd09d23025$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $fdf0a8816be57e7f$export$ce8bdc721e76545f)(value));
}
function $fee5b5cd09d23025$var$resolveFinalValueInKeyframes(v) {
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $b2767e1885a0e038$export$9153ad4c4999f4a0)(v) ? v[v.length - 1] || 0 : v;
}
function $fee5b5cd09d23025$export$1f61c53461aff4a5(visualElement, definition) {
    const resolved = (0, $6170d4d3fca30ebd$export$7b1b1c981f4f0558)(visualElement, definition);
    let { transitionEnd: transitionEnd = {}, transition: transition = {}, ...target } = resolved || {};
    target = {
        ...target,
        ...transitionEnd
    };
    for(const key in target){
        const value = $fee5b5cd09d23025$var$resolveFinalValueInKeyframes(target[key]);
        $fee5b5cd09d23025$var$setMotionValue(visualElement, key, value);
    }
}




function $dad0a879ed529280$export$98397f3adbf6259f(value) {
    return Boolean((0, $b2042ca666edf2e9$export$605d60a2578142d3)(value) && value.add);
}


function $8e65e92243d8e093$export$3ac5aed310be0bee(visualElement, key) {
    const willChange = visualElement.getValue("willChange");
    /**
     * It could be that a user has set willChange to a regular MotionValue,
     * in which case we can't add the value to it.
     */ if ((0, $dad0a879ed529280$export$98397f3adbf6259f)(willChange)) return willChange.add(key);
    else if (!willChange && (0, $fbf024f08bc41b75$export$dd826089e3c5e502).WillChange) {
        const newWillChange = new (0, $fbf024f08bc41b75$export$dd826089e3c5e502).WillChange("auto");
        visualElement.addValue("willChange", newWillChange);
        newWillChange.add(key);
    }
}



function $20e886dfc046eeda$export$5f8d21e84d1d84fc(visualElement) {
    return visualElement.props[0, $42742662b0cbdb1f$export$8592e1c077c890a6];
}





/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ const $df67593b734d7628$export$a4627e546088548d = (...transformers)=>transformers.reduce((a, b)=>(v)=>b(a(v)));











// Adapted from https://gist.github.com/mjackson/5311256
function $10bae8b2f00efa1f$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $10bae8b2f00efa1f$export$6ae64dbcd6bfc33e({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $10bae8b2f00efa1f$var$hueToRgb(p, q, hue + 1 / 3);
        green = $10bae8b2f00efa1f$var$hueToRgb(p, q, hue);
        blue = $10bae8b2f00efa1f$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}



function $f1ea424cc4caaa7c$export$a6f92d4bae65c0f1(a, b) {
    return (p)=>p > 0 ? b : a;
}



// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const $8e69da99e91cf725$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    const expo = v * (to * to - fromExpo) + fromExpo;
    return expo < 0 ? 0 : Math.sqrt(expo);
};
const $8e69da99e91cf725$var$colorTypes = [
    (0, $b71702bd9b151187$export$834dfc94dde4b3d8),
    (0, $c272d087ceaaf3e3$export$4e46ac54fc82cf3b),
    (0, $62d2dc45b4bb2303$export$810b04175080204c)
];
const $8e69da99e91cf725$var$getColorType = (v)=>$8e69da99e91cf725$var$colorTypes.find((type)=>type.test(v));
function $8e69da99e91cf725$var$asRGBA(color) {
    const type = $8e69da99e91cf725$var$getColorType(color);
    (0, $a41eb4452ff76a35$export$491112666e282270)(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`, "color-not-animatable");
    if (!Boolean(type)) return false;
    let model = type.parse(color);
    if (type === (0, $62d2dc45b4bb2303$export$810b04175080204c)) // TODO Remove this cast - needed since Motion's stricter typing
    model = (0, $10bae8b2f00efa1f$export$6ae64dbcd6bfc33e)(model);
    return model;
}
const $8e69da99e91cf725$export$51e568cf5c039bac = (from, to)=>{
    const fromRGBA = $8e69da99e91cf725$var$asRGBA(from);
    const toRGBA = $8e69da99e91cf725$var$asRGBA(to);
    if (!fromRGBA || !toRGBA) return (0, $f1ea424cc4caaa7c$export$a6f92d4bae65c0f1)(from, to);
    const blended = {
        ...fromRGBA
    };
    return (v)=>{
        blended.red = $8e69da99e91cf725$export$d4ecea248cce73c(fromRGBA.red, toRGBA.red, v);
        blended.green = $8e69da99e91cf725$export$d4ecea248cce73c(fromRGBA.green, toRGBA.green, v);
        blended.blue = $8e69da99e91cf725$export$d4ecea248cce73c(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, $33875f370c178373$export$3bb0b4ff1037b8dd)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, $c272d087ceaaf3e3$export$4e46ac54fc82cf3b).transform(blended);
    };
};




const $eba3e3bfd90aee53$export$e5a55ae567dd4ac7 = new Set([
    "none",
    "hidden"
]);
/**
 * Returns a function that, when provided a progress value between 0 and 1,
 * will return the "none" or "hidden" string only when the progress is that of
 * the origin or target.
 */ function $eba3e3bfd90aee53$export$fed62ccc3fb1a568(origin, target) {
    if ($eba3e3bfd90aee53$export$e5a55ae567dd4ac7.has(origin)) return (p)=>p <= 0 ? origin : target;
    else return (p)=>p >= 1 ? target : origin;
}


function $dee4768151ed4003$var$mixNumber(a, b) {
    return (p)=>(0, $33875f370c178373$export$3bb0b4ff1037b8dd)(a, b, p);
}
function $dee4768151ed4003$export$36ec24672cd098e0(a) {
    if (typeof a === "number") return $dee4768151ed4003$var$mixNumber;
    else if (typeof a === "string") return (0, $8c245764d0d5c573$export$31f9caa2600b5723)(a) ? (0, $f1ea424cc4caaa7c$export$a6f92d4bae65c0f1) : (0, $c0d5455d86887039$export$35e9368ef982300f).test(a) ? (0, $8e69da99e91cf725$export$51e568cf5c039bac) : $dee4768151ed4003$export$65516310a87d8205;
    else if (Array.isArray(a)) return $dee4768151ed4003$export$3bbefa2f402845c4;
    else if (typeof a === "object") return (0, $c0d5455d86887039$export$35e9368ef982300f).test(a) ? (0, $8e69da99e91cf725$export$51e568cf5c039bac) : $dee4768151ed4003$export$ebc23b6840c51ba1;
    return 0, $f1ea424cc4caaa7c$export$a6f92d4bae65c0f1;
}
function $dee4768151ed4003$export$3bbefa2f402845c4(a, b) {
    const output = [
        ...a
    ];
    const numValues = output.length;
    const blendValue = a.map((v, i)=>$dee4768151ed4003$export$36ec24672cd098e0(v)(v, b[i]));
    return (p)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](p);
        return output;
    };
}
function $dee4768151ed4003$export$ebc23b6840c51ba1(a, b) {
    const output = {
        ...a,
        ...b
    };
    const blendValue = {};
    for(const key in output)if (a[key] !== undefined && b[key] !== undefined) blendValue[key] = $dee4768151ed4003$export$36ec24672cd098e0(a[key])(a[key], b[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
}
function $dee4768151ed4003$var$matchOrder(origin, target) {
    const orderedOrigin = [];
    const pointers = {
        color: 0,
        var: 0,
        number: 0
    };
    for(let i = 0; i < target.values.length; i++){
        const type = target.types[i];
        const originIndex = origin.indexes[type][pointers[type]];
        const originValue = origin.values[originIndex] ?? 0;
        orderedOrigin[i] = originValue;
        pointers[type]++;
    }
    return orderedOrigin;
}
const $dee4768151ed4003$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $cfd2572e4bd61faa$export$83a0e34f1302825b).createTransformer(target);
    const originStats = (0, $cfd2572e4bd61faa$export$b61fc7c44bf646d5)(origin);
    const targetStats = (0, $cfd2572e4bd61faa$export$b61fc7c44bf646d5)(target);
    const canInterpolate = originStats.indexes.var.length === targetStats.indexes.var.length && originStats.indexes.color.length === targetStats.indexes.color.length && originStats.indexes.number.length >= targetStats.indexes.number.length;
    if (canInterpolate) {
        if ((0, $eba3e3bfd90aee53$export$e5a55ae567dd4ac7).has(origin) && !targetStats.values.length || (0, $eba3e3bfd90aee53$export$e5a55ae567dd4ac7).has(target) && !originStats.values.length) return (0, $eba3e3bfd90aee53$export$fed62ccc3fb1a568)(origin, target);
        return (0, $df67593b734d7628$export$a4627e546088548d)($dee4768151ed4003$export$3bbefa2f402845c4($dee4768151ed4003$var$matchOrder(originStats, targetStats), targetStats.values), template);
    } else {
        (0, $a41eb4452ff76a35$export$491112666e282270)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`, "complex-values-different");
        return (0, $f1ea424cc4caaa7c$export$a6f92d4bae65c0f1)(origin, target);
    }
};



function $9ebafa1b1d58799f$export$2c9e8a9632a706b2(from, to, p) {
    if (typeof from === "number" && typeof to === "number" && typeof p === "number") return (0, $33875f370c178373$export$3bb0b4ff1037b8dd)(from, to, p);
    const mixer = (0, $dee4768151ed4003$export$36ec24672cd098e0)(from);
    return mixer(from, to);
}




const $9d4cabcfa63e3fa3$export$c1033964b5ad7fef = (update)=>{
    const passTimestamp = ({ timestamp: timestamp })=>update(timestamp);
    return {
        start: (keepAlive = true)=>(0, $f28d1a4d8c26f6e5$export$2cef06c20297c17d).update(passTimestamp, keepAlive),
        stop: ()=>(0, $f28d1a4d8c26f6e5$export$ec99c0ef4978dccb)(passTimestamp),
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: ()=>(0, $f28d1a4d8c26f6e5$export$fff89137e9e818ce).isProcessing ? (0, $f28d1a4d8c26f6e5$export$fff89137e9e818ce).timestamp : (0, $111e7cbe8a4123f4$export$2da9be4cfdb689b1).now()
    };
};




/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $afc86d3e7dfcb581$export$f4ff70a5b4808fd8 = 20000;
function $afc86d3e7dfcb581$export$cbdd6b3d40ea54e2(generator) {
    let duration = 0;
    const timeStep = 50;
    let state = generator.next(duration);
    while(!state.done && duration < $afc86d3e7dfcb581$export$f4ff70a5b4808fd8){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= $afc86d3e7dfcb581$export$f4ff70a5b4808fd8 ? Infinity : duration;
}




/**
 * Create a progress => progress easing function from a generator.
 */ function $4c15cbcb98fcc98e$export$7f1511d09ee75a99(options, scale = 100, createGenerator) {
    const generator = createGenerator({
        ...options,
        keyframes: [
            0,
            scale
        ]
    });
    const duration = Math.min((0, $afc86d3e7dfcb581$export$cbdd6b3d40ea54e2)(generator), (0, $afc86d3e7dfcb581$export$f4ff70a5b4808fd8));
    return {
        type: "keyframes",
        ease: (progress)=>{
            return generator.next(duration * progress).value / scale;
        },
        duration: (0, $a69653fc318d2500$export$f64c3bfbc58eec0f)(duration)
    };
}


const $950df7ae05e12cc8$var$springDefaults = {
    // Default spring physics
    stiffness: 100,
    damping: 10,
    mass: 1.0,
    velocity: 0.0,
    // Default duration/bounce-based options
    duration: 800,
    bounce: 0.3,
    visualDuration: 0.3,
    // Rest thresholds
    restSpeed: {
        granular: 0.01,
        default: 2
    },
    restDelta: {
        granular: 0.005,
        default: 0.5
    },
    // Limits
    minDuration: 0.01,
    maxDuration: 10.0,
    minDamping: 0.05,
    maxDamping: 1
};
function $950df7ae05e12cc8$var$calcAngularFreq(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}
const $950df7ae05e12cc8$var$rootIterations = 12;
function $950df7ae05e12cc8$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $950df7ae05e12cc8$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
/**
 * This is ported from the Framer implementation of duration-based spring resolution.
 */ const $950df7ae05e12cc8$var$safeMin = 0.001;
function $950df7ae05e12cc8$var$findSpring({ duration: duration = $950df7ae05e12cc8$var$springDefaults.duration, bounce: bounce = $950df7ae05e12cc8$var$springDefaults.bounce, velocity: velocity = $950df7ae05e12cc8$var$springDefaults.velocity, mass: mass = $950df7ae05e12cc8$var$springDefaults.mass }) {
    let envelope;
    let derivative;
    (0, $a41eb4452ff76a35$export$491112666e282270)(duration <= (0, $a69653fc318d2500$export$fc3e7e8557f8c8c7)($950df7ae05e12cc8$var$springDefaults.maxDuration), "Spring duration must be 10 seconds or less", "spring-duration-limit");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, $c7d27346dbc155b2$export$7d15b64cf5a3a4c4)($950df7ae05e12cc8$var$springDefaults.minDamping, $950df7ae05e12cc8$var$springDefaults.maxDamping, dampingRatio);
    duration = (0, $c7d27346dbc155b2$export$7d15b64cf5a3a4c4)($950df7ae05e12cc8$var$springDefaults.minDuration, $950df7ae05e12cc8$var$springDefaults.maxDuration, (0, $a69653fc318d2500$export$f64c3bfbc58eec0f)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $950df7ae05e12cc8$var$calcAngularFreq(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $950df7ae05e12cc8$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $950df7ae05e12cc8$var$calcAngularFreq(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $950df7ae05e12cc8$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$950df7ae05e12cc8$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $950df7ae05e12cc8$var$approximateRoot(envelope, derivative, initialGuess);
    duration = (0, $a69653fc318d2500$export$fc3e7e8557f8c8c7)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: $950df7ae05e12cc8$var$springDefaults.stiffness,
        damping: $950df7ae05e12cc8$var$springDefaults.damping,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $950df7ae05e12cc8$var$durationKeys = [
    "duration",
    "bounce"
];
const $950df7ae05e12cc8$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $950df7ae05e12cc8$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $950df7ae05e12cc8$var$getSpringOptions(options) {
    let springOptions = {
        velocity: $950df7ae05e12cc8$var$springDefaults.velocity,
        stiffness: $950df7ae05e12cc8$var$springDefaults.stiffness,
        damping: $950df7ae05e12cc8$var$springDefaults.damping,
        mass: $950df7ae05e12cc8$var$springDefaults.mass,
        isResolvedFromDuration: false,
        ...options
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!$950df7ae05e12cc8$var$isSpringType(options, $950df7ae05e12cc8$var$physicsKeys) && $950df7ae05e12cc8$var$isSpringType(options, $950df7ae05e12cc8$var$durationKeys)) {
        // Time-defined springs should ignore inherited velocity.
        // Velocity from interrupted animations can cause findSpring()
        // to compute wildly different spring parameters, leading to
        // massive oscillation on small-range animations.
        springOptions.velocity = 0;
        if (options.visualDuration) {
            const visualDuration = options.visualDuration;
            const root = 2 * Math.PI / (visualDuration * 1.2);
            const stiffness = root * root;
            const damping = 2 * (0, $c7d27346dbc155b2$export$7d15b64cf5a3a4c4)(0.05, 1, 1 - (options.bounce || 0)) * Math.sqrt(stiffness);
            springOptions = {
                ...springOptions,
                mass: $950df7ae05e12cc8$var$springDefaults.mass,
                stiffness: stiffness,
                damping: damping
            };
        } else {
            const derived = $950df7ae05e12cc8$var$findSpring({
                ...options,
                velocity: 0
            });
            springOptions = {
                ...springOptions,
                ...derived,
                mass: $950df7ae05e12cc8$var$springDefaults.mass
            };
            springOptions.isResolvedFromDuration = true;
        }
    }
    return springOptions;
}
function $950df7ae05e12cc8$export$b36281d89752ae66(optionsOrVisualDuration = $950df7ae05e12cc8$var$springDefaults.visualDuration, bounce = $950df7ae05e12cc8$var$springDefaults.bounce) {
    const options = typeof optionsOrVisualDuration !== "object" ? {
        visualDuration: optionsOrVisualDuration,
        keyframes: [
            0,
            1
        ],
        bounce: bounce
    } : optionsOrVisualDuration;
    let { restSpeed: restSpeed, restDelta: restDelta } = options;
    const origin = options.keyframes[0];
    const target = options.keyframes[options.keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    const { stiffness: stiffness, damping: damping, mass: mass, duration: duration, velocity: velocity, isResolvedFromDuration: isResolvedFromDuration } = $950df7ae05e12cc8$var$getSpringOptions({
        ...options,
        velocity: -(0, $a69653fc318d2500$export$f64c3bfbc58eec0f)(options.velocity || 0)
    });
    const initialVelocity = velocity || 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const initialDelta = target - origin;
    const undampedAngularFreq = (0, $a69653fc318d2500$export$f64c3bfbc58eec0f)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? $950df7ae05e12cc8$var$springDefaults.restSpeed.granular : $950df7ae05e12cc8$var$springDefaults.restSpeed.default);
    restDelta || (restDelta = isGranularScale ? $950df7ae05e12cc8$var$springDefaults.restDelta.granular : $950df7ae05e12cc8$var$springDefaults.restDelta.default);
    let resolveSpring;
    let resolveVelocity;
    // Underdamped coefficients, hoisted for use in the inlined next() hot path
    let angularFreq;
    let A;
    let sinCoeff;
    let cosCoeff;
    if (dampingRatio < 1) {
        angularFreq = $950df7ae05e12cc8$var$calcAngularFreq(undampedAngularFreq, dampingRatio);
        A = (initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq;
        // Underdamped spring
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * (A * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
        // Analytical derivative of underdamped spring (px/ms)
        sinCoeff = dampingRatio * undampedAngularFreq * A + initialDelta * angularFreq;
        cosCoeff = dampingRatio * undampedAngularFreq * initialDelta - A * angularFreq;
        resolveVelocity = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return envelope * (sinCoeff * Math.sin(angularFreq * t) + cosCoeff * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) {
        // Critically damped spring
        resolveSpring = (t)=>target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
        // Analytical derivative of critically damped spring (px/ms)
        const C = initialVelocity + undampedAngularFreq * initialDelta;
        resolveVelocity = (t)=>Math.exp(-undampedAngularFreq * t) * (undampedAngularFreq * C * t - initialVelocity);
    } else {
        // Overdamped spring
        const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
        // Analytical derivative of overdamped spring (px/ms)
        const P = (initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / dampedAngularFreq;
        const sinhCoeff = dampingRatio * undampedAngularFreq * P - initialDelta * dampedAngularFreq;
        const coshCoeff = dampingRatio * undampedAngularFreq * initialDelta - P * dampedAngularFreq;
        resolveVelocity = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return envelope * (sinhCoeff * Math.sinh(freqForT) + coshCoeff * Math.cosh(freqForT));
        };
    }
    const generator = {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        velocity: (t)=>(0, $a69653fc318d2500$export$fc3e7e8557f8c8c7)(resolveVelocity(t)),
        next: (t)=>{
            /**
             * For underdamped physics springs we need both position and
             * velocity each tick. Compute shared trig values once to avoid
             * duplicate Math.exp/sin/cos calls on the hot path.
             */ if (!isResolvedFromDuration && dampingRatio < 1) {
                const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                const sin = Math.sin(angularFreq * t);
                const cos = Math.cos(angularFreq * t);
                const current = target - envelope * (A * sin + initialDelta * cos);
                const currentVelocity = (0, $a69653fc318d2500$export$fc3e7e8557f8c8c7)(envelope * (sinCoeff * sin + cosCoeff * cos));
                state.done = Math.abs(currentVelocity) <= restSpeed && Math.abs(target - current) <= restDelta;
                state.value = state.done ? target : current;
                return state;
            }
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                const currentVelocity = (0, $a69653fc318d2500$export$fc3e7e8557f8c8c7)(resolveVelocity(t));
                state.done = Math.abs(currentVelocity) <= restSpeed && Math.abs(target - current) <= restDelta;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        },
        toString: ()=>{
            const calculatedDuration = Math.min((0, $afc86d3e7dfcb581$export$cbdd6b3d40ea54e2)(generator), (0, $afc86d3e7dfcb581$export$f4ff70a5b4808fd8));
            const easing = (0, $fa56f16bf2818b99$export$66d3851e2b1ec912)((progress)=>generator.next(calculatedDuration * progress).value, calculatedDuration, 30);
            return calculatedDuration + "ms " + easing;
        },
        toTransition: ()=>{}
    };
    return generator;
}
$950df7ae05e12cc8$export$b36281d89752ae66.applyToOptions = (options)=>{
    const generatorOptions = (0, $4c15cbcb98fcc98e$export$7f1511d09ee75a99)(options, 100, $950df7ae05e12cc8$export$b36281d89752ae66);
    options.ease = generatorOptions.ease;
    options.duration = (0, $a69653fc318d2500$export$fc3e7e8557f8c8c7)(generatorOptions.duration);
    options.type = "keyframes";
    return options;
};



const $77f4527b05940765$var$velocitySampleDuration = 5; // ms
function $77f4527b05940765$export$279c5e002bb29070(resolveValue, t, current) {
    const prevT = Math.max(t - $77f4527b05940765$var$velocitySampleDuration, 0);
    return (0, $f384b8b627a7fd13$export$eab0632f7ad4f9d7)(current - resolveValue(prevT), t - prevT);
}


function $d5d80ef6b491251e$export$ee3ff3a17106998({ keyframes: keyframes, velocity: velocity = 0.0, power: power = 0.8, timeConstant: timeConstant = 325, bounceDamping: bounceDamping = 10, bounceStiffness: bounceStiffness = 500, modifyTarget: modifyTarget, min: min, max: max, restDelta: restDelta = 0.5, restSpeed: restSpeed }) {
    const origin = keyframes[0];
    const state = {
        done: false,
        value: origin
    };
    const isOutOfBounds = (v)=>min !== undefined && v < min || max !== undefined && v > max;
    const nearestBoundary = (v)=>{
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    const calcDelta = (t)=>-amplitude * Math.exp(-t / timeConstant);
    const calcLatest = (t)=>target + calcDelta(t);
    const applyFriction = (t)=>{
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t)=>{
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, $950df7ae05e12cc8$export$b36281d89752ae66)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, $77f4527b05940765$export$279c5e002bb29070)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta: restDelta,
            restSpeed: restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: (t)=>{
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ let hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t >= timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}



/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticeably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $0b058e6d0e925e86$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $0b058e6d0e925e86$var$subdivisionPrecision = 0.0000001;
const $0b058e6d0e925e86$var$subdivisionMaxIterations = 12;
function $0b058e6d0e925e86$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $0b058e6d0e925e86$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $0b058e6d0e925e86$var$subdivisionPrecision && ++i < $0b058e6d0e925e86$var$subdivisionMaxIterations);
    return currentT;
}
/*#__NO_SIDE_EFFECTS__*/ function $0b058e6d0e925e86$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $518547564f355e33$export$8793edee2d425525;
    const getTForX = (aX)=>$0b058e6d0e925e86$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $0b058e6d0e925e86$var$calcBezier(getTForX(t), mY1, mY2);
}


const $1df31f04bf5723d3$export$929e5a82286172a6 = /*@__PURE__*/ (0, $0b058e6d0e925e86$export$2c575fa1d20488bd)(0.42, 0, 1, 1);
const $1df31f04bf5723d3$export$57636bb43b1ccbb0 = /*@__PURE__*/ (0, $0b058e6d0e925e86$export$2c575fa1d20488bd)(0, 0, 0.58, 1);
const $1df31f04bf5723d3$export$c07234257a03d5e9 = /*@__PURE__*/ (0, $0b058e6d0e925e86$export$2c575fa1d20488bd)(0.42, 0, 0.58, 1);




// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
/*#__NO_SIDE_EFFECTS__*/ const $766b1f75591f1455$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;


// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
/*#__NO_SIDE_EFFECTS__*/ const $c3971caab04ca1f7$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);


const $503509fd0c631706$export$77edfce482316a60 = /*@__PURE__*/ (0, $0b058e6d0e925e86$export$2c575fa1d20488bd)(0.33, 1.53, 0.69, 0.99);
const $503509fd0c631706$export$b01116c84cdfe1a2 = /*@__PURE__*/ (0, $c3971caab04ca1f7$export$2c07eeff45156d4d)($503509fd0c631706$export$77edfce482316a60);
const $503509fd0c631706$export$ddc5fd596f6c71b2 = /*@__PURE__*/ (0, $766b1f75591f1455$export$f946554fb8aeaf0d)($503509fd0c631706$export$b01116c84cdfe1a2);


const $6925d83a61a4d6b7$export$6b0af63b873d419e = (p)=>p >= 1 ? 1 : (p *= 2) < 1 ? 0.5 * (0, $503509fd0c631706$export$b01116c84cdfe1a2)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));





const $1e47753e64ae3dcd$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $1e47753e64ae3dcd$export$c8d67a19199d1a50 = (0, $c3971caab04ca1f7$export$2c07eeff45156d4d)($1e47753e64ae3dcd$export$e444123e42d03385);
const $1e47753e64ae3dcd$export$30d3455eee55bed5 = (0, $766b1f75591f1455$export$f946554fb8aeaf0d)($1e47753e64ae3dcd$export$e444123e42d03385);





const $4fe33a1eef24c9cb$var$easingLookup = {
    linear: (0, $518547564f355e33$export$8793edee2d425525),
    easeIn: $1df31f04bf5723d3$export$929e5a82286172a6,
    easeInOut: $1df31f04bf5723d3$export$c07234257a03d5e9,
    easeOut: $1df31f04bf5723d3$export$57636bb43b1ccbb0,
    circIn: $1e47753e64ae3dcd$export$e444123e42d03385,
    circInOut: $1e47753e64ae3dcd$export$30d3455eee55bed5,
    circOut: $1e47753e64ae3dcd$export$c8d67a19199d1a50,
    backIn: $503509fd0c631706$export$b01116c84cdfe1a2,
    backInOut: $503509fd0c631706$export$ddc5fd596f6c71b2,
    backOut: $503509fd0c631706$export$77edfce482316a60,
    anticipate: $6925d83a61a4d6b7$export$6b0af63b873d419e
};
const $4fe33a1eef24c9cb$var$isValidEasing = (easing)=>{
    return typeof easing === "string";
};
const $4fe33a1eef24c9cb$export$ef97fe084f156ca4 = (definition)=>{
    if ((0, $d912dc831f0025a3$export$ff43f99925d7366b)(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $a41eb4452ff76a35$export$f5708dca728d7177)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`, "cubic-bezier-length");
        const [x1, y1, x2, y2] = definition;
        return (0, $0b058e6d0e925e86$export$2c575fa1d20488bd)(x1, y1, x2, y2);
    } else if ($4fe33a1eef24c9cb$var$isValidEasing(definition)) {
        // Else lookup from table
        (0, $a41eb4452ff76a35$export$f5708dca728d7177)($4fe33a1eef24c9cb$var$easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`, "invalid-easing-type");
        return $4fe33a1eef24c9cb$var$easingLookup[definition];
    }
    return definition;
};

/*#__NO_SIDE_EFFECTS__*/ const $4eda47282ed38001$export$216948827bbdc797 = (ease)=>{
    return Array.isArray(ease) && typeof ease[0] !== "number";
};


/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.
*/ /*#__NO_SIDE_EFFECTS__*/ const $cf400a7bc85048be$export$504d7abb21fa8c9 = (from, to, value)=>{
    const range = to - from;
    return range ? (value - from) / range : 1;
};



function $4ed44c16903da119$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || (0, $fbf024f08bc41b75$export$dd826089e3c5e502).mix || (0, $9ebafa1b1d58799f$export$2c9e8a9632a706b2);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] || (0, $518547564f355e33$export$8793edee2d425525) : ease;
            mixer = (0, $df67593b734d7628$export$a4627e546088548d)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revisit this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function $4ed44c16903da119$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true, ease: ease, mixer: mixer } = {}) {
    const inputLength = input.length;
    (0, $a41eb4452ff76a35$export$f5708dca728d7177)(inputLength === output.length, "Both input and output ranges must be the same length", "range-length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return ()=>output[0];
    if (inputLength === 2 && output[0] === output[1]) return ()=>output[1];
    const isZeroDeltaRange = input[0] === input[1];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [
            ...input
        ].reverse();
        output = [
            ...output
        ].reverse();
    }
    const mixers = $4ed44c16903da119$var$createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v)=>{
        if (isZeroDeltaRange && v < input[0]) return output[0];
        let i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        const progressInRange = (0, $cf400a7bc85048be$export$504d7abb21fa8c9)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? (v)=>interpolator((0, $c7d27346dbc155b2$export$7d15b64cf5a3a4c4)(input[0], input[inputLength - 1], v)) : interpolator;
}




function $476e1a79effbfc3e$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $cf400a7bc85048be$export$504d7abb21fa8c9)(0, remaining, i);
        offset.push((0, $33875f370c178373$export$3bb0b4ff1037b8dd)(min, 1, offsetProgress));
    }
}


function $8f402d5ecaeaf7cd$export$24dbcec0b26e6d9d(arr) {
    const offset = [
        0
    ];
    (0, $476e1a79effbfc3e$export$dafee61230cf05c6)(offset, arr.length - 1);
    return offset;
}


function $1d9b4bd3638e9f72$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}


function $37686930fdcc0b08$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $1df31f04bf5723d3$export$c07234257a03d5e9)).splice(0, values.length - 1);
}
function $37686930fdcc0b08$export$d25ddfdf17c3ad3e({ duration: duration = 300, keyframes: keyframeValues, times: times, ease: ease = "easeInOut" }) {
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ const easingFunctions = (0, $4eda47282ed38001$export$216948827bbdc797)(ease) ? ease.map((0, $4fe33a1eef24c9cb$export$ef97fe084f156ca4)) : (0, $4fe33a1eef24c9cb$export$ef97fe084f156ca4)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ const absoluteTimes = (0, $1d9b4bd3638e9f72$export$2a91b4e3a4539316)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, $8f402d5ecaeaf7cd$export$24dbcec0b26e6d9d)(keyframeValues), duration);
    const mapTimeToKeyframe = (0, $4ed44c16903da119$export$89e29e4ab65e70a9)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : $37686930fdcc0b08$export$6b60b58e4ea7d715(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: (t)=>{
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}








const $2e3e2588a76a0591$var$transitionTypeMap = {
    decay: (0, $d5d80ef6b491251e$export$ee3ff3a17106998),
    inertia: $d5d80ef6b491251e$export$ee3ff3a17106998,
    tween: (0, $37686930fdcc0b08$export$d25ddfdf17c3ad3e),
    keyframes: (0, $37686930fdcc0b08$export$d25ddfdf17c3ad3e),
    spring: $950df7ae05e12cc8$export$b36281d89752ae66
};
function $2e3e2588a76a0591$export$98db6ef1242dfa2(transition) {
    if (typeof transition.type === "string") transition.type = $2e3e2588a76a0591$var$transitionTypeMap[transition.type];
}



const $550b229570d28db0$var$percentToProgress = (percent)=>percent / 100;
class $550b229570d28db0$export$3394f837405475c7 extends (0, $8788fd356985045d$export$655db786091c33e0) {
    constructor(options){
        super();
        this.state = "idle";
        this.startTime = null;
        this.isStopped = false;
        /**
         * The current time of the animation.
         */ this.currentTime = 0;
        /**
         * The time at which the animation was paused.
         */ this.holdTime = null;
        /**
         * Playback speed as a factor. 0 would be stopped, -1 reverse and 2 double speed.
         */ this.playbackSpeed = 1;
        /**
         * Reusable state object for the delay phase to avoid
         * allocating a new object every frame.
         */ this.delayState = {
            done: false,
            value: undefined
        };
        /**
         * This method is bound to the instance to fix a pattern where
         * animation.stop is returned as a reference from a useEffect.
         */ this.stop = ()=>{
            const { motionValue: motionValue } = this.options;
            if (motionValue && motionValue.updatedAt !== (0, $111e7cbe8a4123f4$export$2da9be4cfdb689b1).now()) this.tick((0, $111e7cbe8a4123f4$export$2da9be4cfdb689b1).now());
            this.isStopped = true;
            if (this.state === "idle") return;
            this.teardown();
            this.options.onStop?.();
        };
        (0, $3f382d8314d26340$export$d921fb2475e2900c).mainThread++;
        this.options = options;
        this.initAnimation();
        this.play();
        if (options.autoplay === false) this.pause();
    }
    initAnimation() {
        const { options: options } = this;
        (0, $2e3e2588a76a0591$export$98db6ef1242dfa2)(options);
        const { type: type = (0, $37686930fdcc0b08$export$d25ddfdf17c3ad3e), repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType, velocity: velocity = 0 } = options;
        let { keyframes: keyframes$1 } = options;
        const generatorFactory = type || (0, $37686930fdcc0b08$export$d25ddfdf17c3ad3e);
        if (generatorFactory !== (0, $37686930fdcc0b08$export$d25ddfdf17c3ad3e) && typeof keyframes$1[0] !== "number") {
            this.mixKeyframes = (0, $df67593b734d7628$export$a4627e546088548d)($550b229570d28db0$var$percentToProgress, (0, $9ebafa1b1d58799f$export$2c9e8a9632a706b2)(keyframes$1[0], keyframes$1[1]));
            keyframes$1 = [
                0,
                100
            ];
        }
        const generator = generatorFactory({
            ...options,
            keyframes: keyframes$1
        });
        /**
         * If we have a mirror repeat type we need to create a second generator that outputs the
         * mirrored (not reversed) animation and later ping pong between the two generators.
         */ if (repeatType === "mirror") this.mirroredGenerator = generatorFactory({
            ...options,
            keyframes: [
                ...keyframes$1
            ].reverse(),
            velocity: -velocity
        });
        /**
         * If duration is undefined and we have repeat options,
         * we need to calculate a duration from the generator.
         *
         * We set it to the generator itself to cache the duration.
         * Any timeline resolver will need to have already precalculated
         * the duration by this step.
         */ if (generator.calculatedDuration === null) generator.calculatedDuration = (0, $afc86d3e7dfcb581$export$cbdd6b3d40ea54e2)(generator);
        const { calculatedDuration: calculatedDuration } = generator;
        this.calculatedDuration = calculatedDuration;
        this.resolvedDuration = calculatedDuration + repeatDelay;
        this.totalDuration = this.resolvedDuration * (repeat + 1) - repeatDelay;
        this.generator = generator;
    }
    updateTime(timestamp) {
        const animationTime = Math.round(timestamp - this.startTime) * this.playbackSpeed;
        // Update currentTime
        if (this.holdTime !== null) this.currentTime = this.holdTime;
        else // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
        // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
        // example.
        this.currentTime = animationTime;
    }
    tick(timestamp, sample = false) {
        const { generator: generator, totalDuration: totalDuration, mixKeyframes: mixKeyframes, mirroredGenerator: mirroredGenerator, resolvedDuration: resolvedDuration, calculatedDuration: calculatedDuration } = this;
        if (this.startTime === null) return generator.next(0);
        const { delay: delay = 0, keyframes: keyframes, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, type: type, onUpdate: onUpdate, finalKeyframe: finalKeyframe } = this.options;
        /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (this.speed > 0) this.startTime = Math.min(this.startTime, timestamp);
        else if (this.speed < 0) this.startTime = Math.min(timestamp - totalDuration / this.speed, this.startTime);
        if (sample) this.currentTime = timestamp;
        else this.updateTime(timestamp);
        // Rebase on delay
        const timeWithoutDelay = this.currentTime - delay * (this.playbackSpeed >= 0 ? 1 : -1);
        const isInDelayPhase = this.playbackSpeed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
        this.currentTime = Math.max(timeWithoutDelay, 0);
        // If this animation has finished, set the current time  to the total duration.
        if (this.state === "finished" && this.holdTime === null) this.currentTime = totalDuration;
        let elapsed = this.currentTime;
        let frameGenerator = generator;
        if (repeat) {
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = Math.min(this.currentTime, totalDuration) / resolvedDuration;
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
            iterationProgress === 1 && currentIteration--;
            currentIteration = Math.min(currentIteration, repeat + 1);
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const isOddIteration = Boolean(currentIteration % 2);
            if (isOddIteration) {
                if (repeatType === "reverse") {
                    iterationProgress = 1 - iterationProgress;
                    if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
            }
            elapsed = (0, $c7d27346dbc155b2$export$7d15b64cf5a3a4c4)(0, 1, iterationProgress) * resolvedDuration;
        }
        /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ let state;
        if (isInDelayPhase) {
            this.delayState.value = keyframes[0];
            state = this.delayState;
        } else state = frameGenerator.next(elapsed);
        if (mixKeyframes && !isInDelayPhase) state.value = mixKeyframes(state.value);
        let { done: done } = state;
        if (!isInDelayPhase && calculatedDuration !== null) done = this.playbackSpeed >= 0 ? this.currentTime >= totalDuration : this.currentTime <= 0;
        const isAnimationFinished = this.holdTime === null && (this.state === "finished" || this.state === "running" && done);
        // TODO: The exception for inertia could be cleaner here
        if (isAnimationFinished && type !== (0, $d5d80ef6b491251e$export$ee3ff3a17106998)) state.value = (0, $650926dc8a2fe658$export$14de59408fad90b)(keyframes, this.options, finalKeyframe, this.speed);
        if (onUpdate) onUpdate(state.value);
        if (isAnimationFinished) this.finish();
        return state;
    }
    /**
     * Allows the returned animation to be awaited or promise-chained. Currently
     * resolves when the animation finishes at all but in a future update could/should
     * reject if its cancels.
     */ then(resolve, reject) {
        return this.finished.then(resolve, reject);
    }
    get duration() {
        return (0, $a69653fc318d2500$export$f64c3bfbc58eec0f)(this.calculatedDuration);
    }
    get iterationDuration() {
        const { delay: delay = 0 } = this.options || {};
        return this.duration + (0, $a69653fc318d2500$export$f64c3bfbc58eec0f)(delay);
    }
    get time() {
        return (0, $a69653fc318d2500$export$f64c3bfbc58eec0f)(this.currentTime);
    }
    set time(newTime) {
        newTime = (0, $a69653fc318d2500$export$fc3e7e8557f8c8c7)(newTime);
        this.currentTime = newTime;
        if (this.startTime === null || this.holdTime !== null || this.playbackSpeed === 0) this.holdTime = newTime;
        else if (this.driver) this.startTime = this.driver.now() - newTime / this.playbackSpeed;
        if (this.driver) this.driver.start(false);
        else {
            this.startTime = 0;
            this.state = "paused";
            this.holdTime = newTime;
            this.tick(newTime);
        }
    }
    /**
     * Returns the generator's velocity at the current time in units/second.
     * Uses the analytical derivative when available (springs), avoiding
     * the MotionValue's frame-dependent velocity estimation.
     */ getGeneratorVelocity() {
        const t = this.currentTime;
        if (t <= 0) return this.options.velocity || 0;
        if (this.generator.velocity) return this.generator.velocity(t);
        // Fallback: finite difference
        const current = this.generator.next(t).value;
        return (0, $77f4527b05940765$export$279c5e002bb29070)((s)=>this.generator.next(s).value, t, current);
    }
    get speed() {
        return this.playbackSpeed;
    }
    set speed(newSpeed) {
        const hasChanged = this.playbackSpeed !== newSpeed;
        if (hasChanged && this.driver) this.updateTime((0, $111e7cbe8a4123f4$export$2da9be4cfdb689b1).now());
        this.playbackSpeed = newSpeed;
        if (hasChanged && this.driver) this.time = (0, $a69653fc318d2500$export$f64c3bfbc58eec0f)(this.currentTime);
    }
    play() {
        if (this.isStopped) return;
        const { driver: driver = (0, $9d4cabcfa63e3fa3$export$c1033964b5ad7fef), startTime: startTime } = this.options;
        if (!this.driver) this.driver = driver((timestamp)=>this.tick(timestamp));
        this.options.onPlay?.();
        const now = this.driver.now();
        if (this.state === "finished") {
            this.updateFinished();
            this.startTime = now;
        } else if (this.holdTime !== null) this.startTime = now - this.holdTime;
        else if (!this.startTime) this.startTime = startTime ?? now;
        if (this.state === "finished" && this.speed < 0) this.startTime += this.calculatedDuration;
        this.holdTime = null;
        /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ this.state = "running";
        this.driver.start();
    }
    pause() {
        this.state = "paused";
        this.updateTime((0, $111e7cbe8a4123f4$export$2da9be4cfdb689b1).now());
        this.holdTime = this.currentTime;
    }
    complete() {
        if (this.state !== "running") this.play();
        this.state = "finished";
        this.holdTime = null;
    }
    finish() {
        this.notifyFinished();
        this.teardown();
        this.state = "finished";
        this.options.onComplete?.();
    }
    cancel() {
        this.holdTime = null;
        this.startTime = 0;
        this.tick(0);
        this.teardown();
        this.options.onCancel?.();
    }
    teardown() {
        this.state = "idle";
        this.stopDriver();
        this.startTime = this.holdTime = null;
        (0, $3f382d8314d26340$export$d921fb2475e2900c).mainThread--;
    }
    stopDriver() {
        if (!this.driver) return;
        this.driver.stop();
        this.driver = undefined;
    }
    sample(sampleTime) {
        this.startTime = 0;
        return this.tick(sampleTime, true);
    }
    attachTimeline(timeline) {
        if (this.options.allowFlatten) {
            this.options.type = "keyframes";
            this.options.ease = "linear";
            this.initAnimation();
        }
        this.driver?.stop();
        return timeline.observe(this);
    }
}
// Legacy function support
function $550b229570d28db0$export$ee9b76de7353d815(options) {
    return new $550b229570d28db0$export$3394f837405475c7(options);
}











const $f2968140271b3b19$var$unsupportedEasingFunctions = {
    anticipate: $6925d83a61a4d6b7$export$6b0af63b873d419e,
    backInOut: $503509fd0c631706$export$ddc5fd596f6c71b2,
    circInOut: $1e47753e64ae3dcd$export$30d3455eee55bed5
};
function $f2968140271b3b19$var$isUnsupportedEase(key) {
    return key in $f2968140271b3b19$var$unsupportedEasingFunctions;
}
function $f2968140271b3b19$export$5195f232c29d1f82(transition) {
    if (typeof transition.ease === "string" && $f2968140271b3b19$var$isUnsupportedEase(transition.ease)) transition.ease = $f2968140271b3b19$var$unsupportedEasingFunctions[transition.ease];
}


/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ const $c512faa93d704bd0$var$sampleDelta = 10; //ms
class $c512faa93d704bd0$export$bd2cd6a048093d96 extends (0, $a13be77b2bd23e68$export$6c0f9803d8aa7219) {
    constructor(options){
        /**
         * The base NativeAnimation function only supports a subset
         * of Motion easings, and WAAPI also only supports some
         * easing functions via string/cubic-bezier definitions.
         *
         * This function replaces those unsupported easing functions
         * with a JS easing function. This will later get compiled
         * to a linear() easing function.
         */ (0, $f2968140271b3b19$export$5195f232c29d1f82)(options);
        /**
         * Ensure we replace the transition type with a generator function
         * before passing to WAAPI.
         *
         * TODO: Does this have a better home? It could be shared with
         * JSAnimation.
         */ (0, $2e3e2588a76a0591$export$98db6ef1242dfa2)(options);
        super(options);
        /**
         * Only set startTime when the animation should autoplay.
         * Setting startTime on a paused WAAPI animation unpauses it
         * (per the WAAPI spec), which breaks autoplay: false.
         */ if (options.startTime !== undefined && options.autoplay !== false) this.startTime = options.startTime;
        this.options = options;
    }
    /**
     * WAAPI doesn't natively have any interruption capabilities.
     *
     * Rather than read committed styles back out of the DOM, we can
     * create a renderless JS animation and sample it twice to calculate
     * its current value, "previous" value, and therefore allow
     * Motion to calculate velocity for any subsequent animation.
     */ updateMotionValue(value) {
        const { motionValue: motionValue, onUpdate: onUpdate, onComplete: onComplete, element: element, ...options } = this.options;
        if (!motionValue) return;
        if (value !== undefined) {
            motionValue.set(value);
            return;
        }
        const sampleAnimation = new (0, $550b229570d28db0$export$3394f837405475c7)({
            ...options,
            autoplay: false
        });
        /**
         * Use wall-clock elapsed time for sampling.
         * Under CPU load, WAAPI's currentTime may not reflect actual
         * elapsed time, causing incorrect sampling and visual jumps.
         */ const sampleTime = Math.max($c512faa93d704bd0$var$sampleDelta, (0, $111e7cbe8a4123f4$export$2da9be4cfdb689b1).now() - this.startTime);
        const delta = (0, $c7d27346dbc155b2$export$7d15b64cf5a3a4c4)(0, $c512faa93d704bd0$var$sampleDelta, sampleTime - $c512faa93d704bd0$var$sampleDelta);
        const current = sampleAnimation.sample(sampleTime).value;
        /**
         * Write the estimated value to inline style so it persists
         * after cancel(), covering the async gap before the next
         * animation starts.
         */ const { name: name } = this.options;
        if (element && name) (0, $f4049e50b6bfb14d$export$37a5fde709c1db82)(element, name, current);
        motionValue.setWithVelocity(sampleAnimation.sample(Math.max(0, sampleTime - delta)).value, current, delta);
        sampleAnimation.stop();
    }
}





/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ const $6cd4d70ff5ccfa15$export$65676b58b122bc38 = (value, name)=>{
    // If the list of keys that might be non-animatable grows, replace with Set
    if (name === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, $cfd2572e4bd61faa$export$83a0e34f1302825b).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};


function $680fd70f3e96d059$var$hasKeyframesChanged(keyframes) {
    const current = keyframes[0];
    if (keyframes.length === 1) return true;
    for(let i = 0; i < keyframes.length; i++){
        if (keyframes[i] !== current) return true;
    }
}
function $680fd70f3e96d059$export$1b109e6c9968df4f(keyframes, name, type, velocity) {
    /**
     * Check if we're able to animate between the start and end keyframes,
     * and throw a warning if we're attempting to animate between one that's
     * animatable and another that isn't.
     */ const originKeyframe = keyframes[0];
    if (originKeyframe === null) return false;
    /**
     * These aren't traditionally animatable but we do support them.
     * In future we could look into making this more generic or replacing
     * this function with mix() === mixImmediate
     */ if (name === "display" || name === "visibility") return true;
    const targetKeyframe = keyframes[keyframes.length - 1];
    const isOriginAnimatable = (0, $6cd4d70ff5ccfa15$export$65676b58b122bc38)(originKeyframe, name);
    const isTargetAnimatable = (0, $6cd4d70ff5ccfa15$export$65676b58b122bc38)(targetKeyframe, name);
    (0, $a41eb4452ff76a35$export$491112666e282270)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${name} from "${originKeyframe}" to "${targetKeyframe}". "${isOriginAnimatable ? targetKeyframe : originKeyframe}" is not an animatable value.`, "value-not-animatable");
    // Always skip if any of these are true
    if (!isOriginAnimatable || !isTargetAnimatable) return false;
    return $680fd70f3e96d059$var$hasKeyframesChanged(keyframes) || (type === "spring" || (0, $37fee822b2633340$export$6ab7812f1bac68be)(type)) && velocity;
}


function $c74638054f8418d1$export$b2585dd3c345da47(options) {
    options.duration = 0;
    options.type = "keyframes";
}





const $4de577dc412670b3$var$browserColorFunctions = /^(?:oklch|oklab|lab|lch|color|color-mix|light-dark)\(/;
function $4de577dc412670b3$export$1af9e65d1501d15(keyframes) {
    for(let i = 0; i < keyframes.length; i++){
        if (typeof keyframes[i] === "string" && $4de577dc412670b3$var$browserColorFunctions.test(keyframes[i])) return true;
    }
    return false;
}


const $0e64151a142e1075$var$colorProperties = new Set([
    "color",
    "backgroundColor",
    "outlineColor",
    "fill",
    "stroke",
    "borderColor",
    "borderTopColor",
    "borderRightColor",
    "borderBottomColor",
    "borderLeftColor"
]);
const $0e64151a142e1075$var$supportsWaapi = /*@__PURE__*/ (0, $77ac62143ab19cfb$export$7c73462e0d25e514)(()=>Object.hasOwnProperty.call(Element.prototype, "animate"));
function $0e64151a142e1075$export$ea92bde116fda821(options) {
    const { motionValue: motionValue, name: name, repeatDelay: repeatDelay, repeatType: repeatType, damping: damping, type: type, keyframes: keyframes } = options;
    const subject = motionValue?.owner?.current;
    /**
     * We use this check instead of isHTMLElement() because we explicitly
     * **don't** want elements in different timing contexts (i.e. popups)
     * to be accelerated, as it's not possible to sync these animations
     * properly with those driven from the main window frameloop.
     */ if (!(subject instanceof HTMLElement)) return false;
    const { onUpdate: onUpdate, transformTemplate: transformTemplate } = motionValue.owner.getProps();
    return $0e64151a142e1075$var$supportsWaapi() && name && /**
         * Force WAAPI for color properties with browser-only color formats
         * (oklch, oklab, lab, lch, etc.) that the JS animation path can't parse.
         */ ((0, $0bbb7ed9e051efbb$export$a27eefbd8fb5e404).has(name) || $0e64151a142e1075$var$colorProperties.has(name) && (0, $4de577dc412670b3$export$1af9e65d1501d15)(keyframes)) && (name !== "transform" || !transformTemplate) && /**
         * If we're outputting values to onUpdate then we can't use WAAPI as there's
         * no way to read the value from WAAPI every frame.
         */ !onUpdate && !repeatDelay && repeatType !== "mirror" && damping !== 0 && type !== "inertia";
}


/**
 * Maximum time allowed between an animation being created and it being
 * resolved for us to use the latter as the start time.
 *
 * This is to ensure that while we prefer to "start" an animation as soon
 * as it's triggered, we also want to avoid a visual jump if there's a big delay
 * between these two moments.
 */ const $b1b27e91dbbd0900$var$MAX_RESOLVE_DELAY = 40;
class $b1b27e91dbbd0900$export$b9855e2a7dee3dd2 extends (0, $8788fd356985045d$export$655db786091c33e0) {
    constructor({ autoplay: autoplay = true, delay: delay = 0, type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType = "loop", keyframes: keyframes, name: name, motionValue: motionValue, element: element, ...options }){
        super();
        /**
         * Bound to support return animation.stop pattern
         */ this.stop = ()=>{
            if (this._animation) {
                this._animation.stop();
                this.stopTimeline?.();
            }
            this.keyframeResolver?.cancel();
        };
        this.createdAt = (0, $111e7cbe8a4123f4$export$2da9be4cfdb689b1).now();
        const optionsWithDefaults = {
            autoplay: autoplay,
            delay: delay,
            type: type,
            repeat: repeat,
            repeatDelay: repeatDelay,
            repeatType: repeatType,
            name: name,
            motionValue: motionValue,
            element: element,
            ...options
        };
        const KeyframeResolver$1 = element?.KeyframeResolver || (0, $b4c6185e0f3b6dcd$export$74d34ca3182f1750);
        this.keyframeResolver = new KeyframeResolver$1(keyframes, (resolvedKeyframes, finalKeyframe, forced)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe, optionsWithDefaults, !forced), name, motionValue, element);
        this.keyframeResolver?.scheduleResolve();
    }
    onKeyframesResolved(keyframes, finalKeyframe, options, sync) {
        this.keyframeResolver = undefined;
        const { name: name, type: type, velocity: velocity, delay: delay, isHandoff: isHandoff, onUpdate: onUpdate } = options;
        this.resolvedAt = (0, $111e7cbe8a4123f4$export$2da9be4cfdb689b1).now();
        /**
         * If we can't animate this value with the resolved keyframes
         * then we should complete it immediately.
         */ let canAnimateValue = true;
        if (!(0, $680fd70f3e96d059$export$1b109e6c9968df4f)(keyframes, name, type, velocity)) {
            canAnimateValue = false;
            if ((0, $fbf024f08bc41b75$export$dd826089e3c5e502).instantAnimations || !delay) onUpdate?.((0, $650926dc8a2fe658$export$14de59408fad90b)(keyframes, options, finalKeyframe));
            keyframes[0] = keyframes[keyframes.length - 1];
            (0, $c74638054f8418d1$export$b2585dd3c345da47)(options);
            options.repeat = 0;
        }
        /**
         * Resolve startTime for the animation.
         *
         * This method uses the createdAt and resolvedAt to calculate the
         * animation startTime. *Ideally*, we would use the createdAt time as t=0
         * as the following frame would then be the first frame of the animation in
         * progress, which would feel snappier.
         *
         * However, if there's a delay (main thread work) between the creation of
         * the animation and the first committed frame, we prefer to use resolvedAt
         * to avoid a sudden jump into the animation.
         */ const startTime = sync ? !this.resolvedAt ? this.createdAt : this.resolvedAt - this.createdAt > $b1b27e91dbbd0900$var$MAX_RESOLVE_DELAY ? this.resolvedAt : this.createdAt : undefined;
        const resolvedOptions = {
            startTime: startTime,
            finalKeyframe: finalKeyframe,
            ...options,
            keyframes: keyframes
        };
        /**
         * Animate via WAAPI if possible. If this is a handoff animation, the optimised animation will be running via
         * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
         * optimised animation.
         *
         * Also skip WAAPI when keyframes aren't animatable, as the resolved
         * values may not be valid CSS and would trigger browser warnings.
         */ const useWaapi = canAnimateValue && !isHandoff && (0, $0e64151a142e1075$export$ea92bde116fda821)(resolvedOptions);
        const element = resolvedOptions.motionValue?.owner?.current;
        let animation;
        if (useWaapi) try {
            animation = new (0, $c512faa93d704bd0$export$bd2cd6a048093d96)({
                ...resolvedOptions,
                element: element
            });
        } catch  {
            animation = new (0, $550b229570d28db0$export$3394f837405475c7)(resolvedOptions);
        }
        else animation = new (0, $550b229570d28db0$export$3394f837405475c7)(resolvedOptions);
        animation.finished.then(()=>{
            this.notifyFinished();
        }).catch((0, $518547564f355e33$export$8793edee2d425525));
        if (this.pendingTimeline) {
            this.stopTimeline = animation.attachTimeline(this.pendingTimeline);
            this.pendingTimeline = undefined;
        }
        this._animation = animation;
    }
    get finished() {
        if (!this._animation) return this._finished;
        else return this.animation.finished;
    }
    then(onResolve, _onReject) {
        return this.finished.finally(onResolve).then(()=>{});
    }
    get animation() {
        if (!this._animation) {
            this.keyframeResolver?.resume();
            (0, $b4c6185e0f3b6dcd$export$78b96d2a12593b05)();
        }
        return this._animation;
    }
    get duration() {
        return this.animation.duration;
    }
    get iterationDuration() {
        return this.animation.iterationDuration;
    }
    get time() {
        return this.animation.time;
    }
    set time(newTime) {
        this.animation.time = newTime;
    }
    get speed() {
        return this.animation.speed;
    }
    get state() {
        return this.animation.state;
    }
    set speed(newSpeed) {
        this.animation.speed = newSpeed;
    }
    get startTime() {
        return this.animation.startTime;
    }
    attachTimeline(timeline) {
        if (this._animation) this.stopTimeline = this.animation.attachTimeline(timeline);
        else this.pendingTimeline = timeline;
        return ()=>this.stop();
    }
    play() {
        this.animation.play();
    }
    pause() {
        this.animation.pause();
    }
    complete() {
        this.animation.complete();
    }
    cancel() {
        if (this._animation) this.animation.cancel();
        this.keyframeResolver?.cancel();
    }
}






const $a63b9398f737d395$var$underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
const $a63b9398f737d395$var$criticallyDampedSpring = (target)=>({
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    });
const $a63b9398f737d395$var$keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ const $a63b9398f737d395$var$ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
const $a63b9398f737d395$export$262124b154b9f1c0 = (valueKey, { keyframes: keyframes })=>{
    if (keyframes.length > 2) return $a63b9398f737d395$var$keyframesTransition;
    else if ((0, $505b0017451a5f76$export$7b42a0094fb00b6e).has(valueKey)) return valueKey.startsWith("scale") ? $a63b9398f737d395$var$criticallyDampedSpring(keyframes[1]) : $a63b9398f737d395$var$underDampedSpring;
    return $a63b9398f737d395$var$ease;
};



const $b4b630f3b58e0aae$var$orchestrationKeys = new Set([
    "when",
    "delay",
    "delayChildren",
    "staggerChildren",
    "staggerDirection",
    "repeat",
    "repeatType",
    "repeatDelay",
    "from",
    "elapsed"
]);
/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $b4b630f3b58e0aae$export$ca8e47dc8ed5a9d7(transition) {
    for(const key in transition){
        if (!$b4b630f3b58e0aae$var$orchestrationKeys.has(key)) return true;
    }
    return false;
}



const $d2bd59c5f116d70d$export$90b3dfc33ff3548 = (name, value, target, transition = {}, element, isHandoff)=>(onComplete)=>{
        const valueTransition = (0, $3c7dca54dc1f20a3$export$7c1391340308742e)(transition, name) || {};
        /**
     * Most transition values are currently completely overwritten by value-specific
     * transitions. In the future it'd be nicer to blend these transitions. But for now
     * delay actually does inherit from the root transition if not value-specific.
     */ const delay = valueTransition.delay || transition.delay || 0;
        /**
     * Elapsed isn't a public transition option but can be passed through from
     * optimized appear effects in milliseconds.
     */ let { elapsed: elapsed = 0 } = transition;
        elapsed = elapsed - (0, $a69653fc318d2500$export$fc3e7e8557f8c8c7)(delay);
        const options = {
            keyframes: Array.isArray(target) ? target : [
                null,
                target
            ],
            ease: "easeOut",
            velocity: value.getVelocity(),
            ...valueTransition,
            delay: -elapsed,
            onUpdate: (v)=>{
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: ()=>{
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            },
            name: name,
            motionValue: value,
            element: isHandoff ? undefined : element
        };
        /**
     * If there's no transition defined for this value, we can generate
     * unique transition settings for this value.
     */ if (!(0, $b4b630f3b58e0aae$export$ca8e47dc8ed5a9d7)(valueTransition)) Object.assign(options, (0, $a63b9398f737d395$export$262124b154b9f1c0)(name, options));
        /**
     * Both WAAPI and our internal animation functions use durations
     * as defined by milliseconds, while our external API defines them
     * as seconds.
     */ options.duration && (options.duration = (0, $a69653fc318d2500$export$fc3e7e8557f8c8c7)(options.duration));
        options.repeatDelay && (options.repeatDelay = (0, $a69653fc318d2500$export$fc3e7e8557f8c8c7)(options.repeatDelay));
        /**
     * Support deprecated way to set initial value. Prefer keyframe syntax.
     */ if (options.from !== undefined) options.keyframes[0] = options.from;
        let shouldSkip = false;
        if (options.type === false || options.duration === 0 && !options.repeatDelay) {
            (0, $c74638054f8418d1$export$b2585dd3c345da47)(options);
            if (options.delay === 0) shouldSkip = true;
        }
        if ((0, $fbf024f08bc41b75$export$dd826089e3c5e502).instantAnimations || (0, $fbf024f08bc41b75$export$dd826089e3c5e502).skipAnimations || element?.shouldSkipAnimations || valueTransition.skipAnimations) {
            shouldSkip = true;
            (0, $c74638054f8418d1$export$b2585dd3c345da47)(options);
            options.delay = 0;
        }
        /**
     * If the transition type or easing has been explicitly set by the user
     * then we don't want to allow flattening the animation.
     */ options.allowFlatten = !valueTransition.type && !valueTransition.ease;
        /**
     * If we can or must skip creating the animation, and apply only
     * the final keyframe, do so. We also check once keyframes are resolved but
     * this early check prevents the need to create an animation at all.
     */ if (shouldSkip && !isHandoff && value.get() !== undefined) {
            const finalKeyframe = (0, $650926dc8a2fe658$export$14de59408fad90b)(options.keyframes, valueTransition);
            if (finalKeyframe !== undefined) {
                (0, $f28d1a4d8c26f6e5$export$2cef06c20297c17d).update(()=>{
                    options.onUpdate(finalKeyframe);
                    options.onComplete();
                });
                return;
            }
        }
        return valueTransition.isSync ? new (0, $550b229570d28db0$export$3394f837405475c7)(options) : new (0, $b1b27e91dbbd0900$export$b9855e2a7dee3dd2)(options);
    };



/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $122d914506b40196$var$shouldBlockAnimation({ protectedKeys: protectedKeys, needsAnimating: needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function $122d914506b40196$export$68cacfeee78d98d2(visualElement, targetAndTransition, { delay: delay = 0, transitionOverride: transitionOverride, type: type } = {}) {
    let { transition: transition, transitionEnd: transitionEnd, ...target } = targetAndTransition;
    const defaultTransition = visualElement.getDefaultTransition();
    transition = transition ? (0, $dda4e0b3f2a3e4ad$export$b180037f8f468d61)(transition, defaultTransition) : defaultTransition;
    const reduceMotion = transition?.reduceMotion;
    const skipAnimations = transition?.skipAnimations;
    if (transitionOverride) transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    const path = transition?.path;
    if (path) // path mutates `target` to claim x/y; loop below skips them.
    path.animateVisualElement(visualElement, target, transition, delay, animations);
    for(const key in target){
        const value = visualElement.getValue(key, visualElement.latestValues[key] ?? null);
        const valueTarget = target[key];
        if (valueTarget === undefined || animationTypeState && $122d914506b40196$var$shouldBlockAnimation(animationTypeState, key)) continue;
        const valueTransition = {
            delay: delay,
            ...(0, $3c7dca54dc1f20a3$export$7c1391340308742e)(transition || {}, key)
        };
        if (skipAnimations) valueTransition.skipAnimations = true;
        /**
         * If the value is already at the defined target, skip the animation.
         * We still re-assert the value via frame.update to take precedence
         * over any stale transitionEnd callbacks from previous animations.
         */ const currentValue = value.get();
        if (currentValue !== undefined && !value.isAnimating() && !Array.isArray(valueTarget) && valueTarget === currentValue && !valueTransition.velocity) {
            (0, $f28d1a4d8c26f6e5$export$2cef06c20297c17d).update(()=>value.set(valueTarget));
            continue;
        }
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ let isHandoff = false;
        if (window.MotionHandoffAnimation) {
            const appearId = (0, $20e886dfc046eeda$export$5f8d21e84d1d84fc)(visualElement);
            if (appearId) {
                const startTime = window.MotionHandoffAnimation(appearId, key, (0, $f28d1a4d8c26f6e5$export$2cef06c20297c17d));
                if (startTime !== null) {
                    valueTransition.startTime = startTime;
                    isHandoff = true;
                }
            }
        }
        (0, $8e65e92243d8e093$export$3ac5aed310be0bee)(visualElement, key);
        const shouldReduceMotion = reduceMotion ?? visualElement.shouldReduceMotion;
        value.start((0, $d2bd59c5f116d70d$export$90b3dfc33ff3548)(key, value, valueTarget, shouldReduceMotion && (0, $2597a137a910406a$export$c66c0d5db2a205d).has(key) ? {
            type: false
        } : valueTransition, visualElement, isHandoff));
        const animation = value.animation;
        if (animation) animations.push(animation);
    }
    if (transitionEnd) {
        const applyTransitionEnd = ()=>(0, $f28d1a4d8c26f6e5$export$2cef06c20297c17d).update(()=>{
                transitionEnd && (0, $fee5b5cd09d23025$export$1f61c53461aff4a5)(visualElement, transitionEnd);
            });
        if (animations.length) Promise.all(animations).then(applyTransitionEnd);
        else applyTransitionEnd();
    }
    return animations;
}



function $d4faf015dff1f75b$export$6e01cb2cb232d79b(children, child, delayChildren, staggerChildren = 0, staggerDirection = 1) {
    const index = Array.from(children).sort((a, b)=>a.sortNodePosition(b)).indexOf(child);
    const numChildren = children.size;
    const maxStaggerDuration = (numChildren - 1) * staggerChildren;
    const delayIsFunction = typeof delayChildren === "function";
    return delayIsFunction ? delayChildren(index, numChildren) : staggerDirection === 1 ? index * staggerChildren : maxStaggerDuration - index * staggerChildren;
}



function $2a20b2398ed27d4d$export$4709dc300705b2af(visualElement, variant, options = {}) {
    const resolved = (0, $6170d4d3fca30ebd$export$7b1b1c981f4f0558)(visualElement, variant, options.type === "exit" ? visualElement.presenceContext?.custom : undefined);
    let { transition: transition = visualElement.getDefaultTransition() || {} } = resolved || {};
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getAnimation = resolved ? ()=>Promise.all((0, $122d914506b40196$export$68cacfeee78d98d2)(visualElement, resolved, options)) : ()=>Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? (forwardDelay = 0)=>{
        const { delayChildren: delayChildren = 0, staggerChildren: staggerChildren, staggerDirection: staggerDirection } = transition;
        return $2a20b2398ed27d4d$var$animateChildren(visualElement, variant, forwardDelay, delayChildren, staggerChildren, staggerDirection, options);
    } : ()=>Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ const { when: when } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ];
        return first().then(()=>last());
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
function $2a20b2398ed27d4d$var$animateChildren(visualElement, variant, delay = 0, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    for (const child of visualElement.variantChildren){
        child.notify("AnimationStart", variant);
        animations.push($2a20b2398ed27d4d$export$4709dc300705b2af(child, variant, {
            ...options,
            delay: delay + (typeof delayChildren === "function" ? 0 : delayChildren) + (0, $d4faf015dff1f75b$export$6e01cb2cb232d79b)(visualElement.variantChildren, child, delayChildren, staggerChildren, staggerDirection)
        }).then(()=>child.notify("AnimationComplete", variant)));
    }
    return Promise.all(animations);
}


function $6f32fd7893209100$export$ff62cf473653f109(visualElement, definition, options = {}) {
    visualElement.notify("AnimationStart", definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant)=>(0, $2a20b2398ed27d4d$export$4709dc300705b2af)(visualElement, variant, options));
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = (0, $2a20b2398ed27d4d$export$4709dc300705b2af)(visualElement, definition, options);
    else {
        const resolvedDefinition = typeof definition === "function" ? (0, $6170d4d3fca30ebd$export$7b1b1c981f4f0558)(visualElement, definition, options.custom) : definition;
        animation = Promise.all((0, $122d914506b40196$export$68cacfeee78d98d2)(visualElement, resolvedDefinition, options));
    }
    return animation.then(()=>{
        visualElement.notify("AnimationComplete", definition);
    });
}





const $367378cc39f26116$var$numVariantProps = (0, $5d862b5000c3db57$export$1405a65085f40b9).length;
/**
 * Get variant context from a visual element's parent chain.
 * Uses `any` type for visualElement to avoid circular dependencies.
 */ function $367378cc39f26116$export$6669f52f7ffa343b(visualElement) {
    if (!visualElement) return undefined;
    if (!visualElement.isControllingVariants) {
        const context = visualElement.parent ? $367378cc39f26116$export$6669f52f7ffa343b(visualElement.parent) || {} : {};
        if (visualElement.props.initial !== undefined) context.initial = visualElement.props.initial;
        return context;
    }
    const context = {};
    for(let i = 0; i < $367378cc39f26116$var$numVariantProps; i++){
        const name = (0, $5d862b5000c3db57$export$1405a65085f40b9)[i];
        const prop = visualElement.props[name];
        if ((0, $eadf3b720b2072c8$export$720b90e312cea233)(prop) || prop === false) context[name] = prop;
    }
    return context;
}






function $84e0493cc51ffa17$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    const prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(let i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}



const $2a07d0abb4591b8f$var$reversePriorityOrder = [
    ...(0, $5d862b5000c3db57$export$16e45afcc206d3a8)
].reverse();
const $2a07d0abb4591b8f$var$numAnimationTypes = (0, $5d862b5000c3db57$export$16e45afcc206d3a8).length;
function $2a07d0abb4591b8f$var$createAnimateFunction(visualElement) {
    return (animations)=>{
        return Promise.all(animations.map(({ animation: animation, options: options })=>(0, $6f32fd7893209100$export$ff62cf473653f109)(visualElement, animation, options)));
    };
}
function $2a07d0abb4591b8f$export$bb53502b7a672aa8(visualElement) {
    let animate = $2a07d0abb4591b8f$var$createAnimateFunction(visualElement);
    let state = $2a07d0abb4591b8f$var$createState();
    let isInitialRender = true;
    /**
     * Track whether the animation state has been reset (e.g. via StrictMode
     * double-invocation or Suspense unmount/remount). On the first
     * animateChanges() call after a reset we need to behave like the initial
     * render for variant-inheritance checks, even though isInitialRender is
     * already false.
     */ let wasReset = false;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ const buildResolvedTypeValues = (type)=>(acc, definition)=>{
            const resolved = (0, $6170d4d3fca30ebd$export$7b1b1c981f4f0558)(visualElement, definition, type === "exit" ? visualElement.presenceContext?.custom : undefined);
            if (resolved) {
                const { transition: transition, transitionEnd: transitionEnd, ...target } = resolved;
                acc = {
                    ...acc,
                    ...target,
                    ...transitionEnd
                };
            }
            return acc;
        };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(changedActiveType) {
        const { props: props } = visualElement;
        const context = (0, $367378cc39f26116$export$6669f52f7ffa343b)(visualElement.parent) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(let i = 0; i < $2a07d0abb4591b8f$var$numAnimationTypes; i++){
            const type = $2a07d0abb4591b8f$var$reversePriorityOrder[i];
            const typeState = state[type];
            const prop = props[type] !== undefined ? props[type] : context[type];
            const propIsVariant = (0, $eadf3b720b2072c8$export$720b90e312cea233)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            if (isInherited && (isInitialRender || wasReset) && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = {
                ...encounteredKeys
            };
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $91a47968b972d848$export$aa71198ceeaf53ce)(prop) || typeof prop === "boolean") continue;
            /**
             * If exit is already active and wasn't just activated, skip
             * re-processing to prevent interrupting running exit animations.
             * Re-resolving exit with a changed custom value can start new
             * value animations that stop the originals, leaving the exit
             * animation promise unresolved and the component stuck in the DOM.
             */ if (type === "exit" && typeState.isActive && activeDelta !== true) {
                if (typeState.prevResolvedValues) encounteredKeys = {
                    ...encounteredKeys,
                    ...typeState.prevResolvedValues
                };
                continue;
            }
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ const variantDidChange = $2a07d0abb4591b8f$export$68651800594fd43c(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            let handledRemovedValues = false;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ const definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ let resolvedValues = definitionList.reduce(buildResolvedTypeValues(type), {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ const { prevResolvedValues: prevResolvedValues = {} } = typeState;
            const allKeys = {
                ...prevResolvedValues,
                ...resolvedValues
            };
            const markToAnimate = (key)=>{
                shouldAnimateType = true;
                if (removedKeys.has(key)) {
                    handledRemovedValues = true;
                    removedKeys.delete(key);
                }
                typeState.needsAnimating[key] = true;
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = false;
            };
            for(const key in allKeys){
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ let valueHasChanged = false;
                if ((0, $b2767e1885a0e038$export$9153ad4c4999f4a0)(next) && (0, $b2767e1885a0e038$export$9153ad4c4999f4a0)(prev)) valueHasChanged = !(0, $84e0493cc51ffa17$export$90e866afbd6b9f1a)(next, prev) || variantDidChange;
                else valueHasChanged = next !== prev;
                if (valueHasChanged) {
                    if (next !== undefined && next !== null) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            if (typeState.isActive) encounteredKeys = {
                ...encounteredKeys,
                ...resolvedValues
            };
            if ((isInitialRender || wasReset) && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to skip this animation
             * unless the inherited variants haven't changed on this render.
             */ const willAnimateViaParent = isInherited && variantDidChange;
            const needsAnimating = !willAnimateViaParent || handledRemovedValues;
            if (shouldAnimateType && needsAnimating) animations.push(...definitionList.map((animation)=>{
                const options = {
                    type: type
                };
                /**
                     * If we're performing the initial animation, but we're not
                     * rendering at the same time as the variant-controlling parent,
                     * we want to use the parent's transition to calculate the stagger.
                     */ if (typeof animation === "string" && (isInitialRender || wasReset) && !willAnimateViaParent && visualElement.manuallyAnimateOnMount && visualElement.parent) {
                    const { parent: parent } = visualElement;
                    const parentVariant = (0, $6170d4d3fca30ebd$export$7b1b1c981f4f0558)(parent, animation);
                    if (parent.enteringChildren && parentVariant) {
                        const { delayChildren: delayChildren } = parentVariant.transition || {};
                        options.delay = (0, $d4faf015dff1f75b$export$6e01cb2cb232d79b)(parent.enteringChildren, visualElement, delayChildren);
                    }
                }
                return {
                    animation: animation,
                    options: options
                };
            }));
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            const fallbackAnimation = {};
            /**
             * If the initial prop contains a transition we can use that, otherwise
             * allow the animation function to use the visual element's default.
             */ if (typeof props.initial !== "boolean") {
                const initialTransition = (0, $6170d4d3fca30ebd$export$7b1b1c981f4f0558)(visualElement, Array.isArray(props.initial) ? props.initial[0] : props.initial);
                if (initialTransition && initialTransition.transition) fallbackAnimation.transition = initialTransition.transition;
            }
            removedKeys.forEach((key)=>{
                const fallbackTarget = visualElement.getBaseTarget(key);
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = true;
                // @ts-expect-error - @mattgperry to figure if we should do something here
                fallbackAnimation[key] = fallbackTarget ?? null;
            });
            animations.push({
                animation: fallbackAnimation
            });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender && (props.initial === false || props.initial === props.animate) && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        wasReset = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive) {
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        visualElement.variantChildren?.forEach((child)=>child.animationState?.setActive(type, isActive));
        state[type].isActive = isActive;
        const animations = animateChanges(type);
        for(const key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: ()=>state,
        reset: ()=>{
            state = $2a07d0abb4591b8f$var$createState();
            wasReset = true;
        }
    };
}
function $2a07d0abb4591b8f$export$68651800594fd43c(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if (Array.isArray(next)) return !(0, $84e0493cc51ffa17$export$90e866afbd6b9f1a)(next, prev);
    return false;
}
function $2a07d0abb4591b8f$var$createTypeState(isActive = false) {
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $2a07d0abb4591b8f$var$createState() {
    return {
        animate: $2a07d0abb4591b8f$var$createTypeState(true),
        whileInView: $2a07d0abb4591b8f$var$createTypeState(),
        whileHover: $2a07d0abb4591b8f$var$createTypeState(),
        whileTap: $2a07d0abb4591b8f$var$createTypeState(),
        whileDrag: $2a07d0abb4591b8f$var$createTypeState(),
        whileFocus: $2a07d0abb4591b8f$var$createTypeState(),
        exit: $2a07d0abb4591b8f$var$createTypeState()
    };
}

/**
 * Feature base class for extending VisualElement functionality.
 * Features are plugins that can be mounted/unmounted to add behavior
 * like gestures, animations, or layout tracking.
 */ class $baf88f17ccf98c7a$export$6e91cf7616333d5 {
    constructor(node){
        this.isMounted = false;
        this.node = node;
    }
    update() {}
}


class $157fd3be837bcd23$export$b45b3fe5caabdca extends (0, $baf88f17ccf98c7a$export$6e91cf7616333d5) {
    /**
     * We dynamically generate the AnimationState manager as it contains a reference
     * to the underlying animation library. We only want to load that if we load this,
     * so people can optionally code split it out using the `m` component.
     */ constructor(node){
        super(node);
        node.animationState || (node.animationState = (0, $2a07d0abb4591b8f$export$bb53502b7a672aa8)(node));
    }
    updateAnimationControlsSubscription() {
        const { animate: animate } = this.node.getProps();
        if ((0, $91a47968b972d848$export$aa71198ceeaf53ce)(animate)) this.unmountControls = animate.subscribe(this.node);
    }
    /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */ mount() {
        this.updateAnimationControlsSubscription();
    }
    update() {
        const { animate: animate } = this.node.getProps();
        const { animate: prevAnimate } = this.node.prevProps || {};
        if (animate !== prevAnimate) this.updateAnimationControlsSubscription();
    }
    unmount() {
        this.node.animationState.reset();
        this.unmountControls?.();
    }
}



let $455e223518e62b4a$var$id = 0;
class $455e223518e62b4a$export$4989d1eb6104cc6c extends (0, $baf88f17ccf98c7a$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.id = $455e223518e62b4a$var$id++;
        this.isExitComplete = false;
    }
    update() {
        if (!this.node.presenceContext) return;
        const { isPresent: isPresent, onExitComplete: onExitComplete } = this.node.presenceContext;
        const { isPresent: prevIsPresent } = this.node.prevPresenceContext || {};
        if (!this.node.animationState || isPresent === prevIsPresent) return;
        if (isPresent && prevIsPresent === false) {
            /**
             * When re-entering, if the exit animation already completed
             * (element is at rest), reset to initial values so the enter
             * animation replays from the correct position.
             */ if (this.isExitComplete) {
                const { initial: initial, custom: custom } = this.node.getProps();
                if (typeof initial === "string" || typeof initial === "object" && initial !== null && !Array.isArray(initial)) {
                    const resolved = (0, $6170d4d3fca30ebd$export$7b1b1c981f4f0558)(this.node, initial, custom);
                    if (resolved) {
                        const { transition: transition, transitionEnd: transitionEnd, ...target } = resolved;
                        for(const key in target)this.node.getValue(key)?.jump(target[key]);
                    }
                }
                this.node.animationState.reset();
                this.node.animationState.animateChanges();
            } else this.node.animationState.setActive("exit", false);
            this.isExitComplete = false;
            return;
        }
        const exitAnimation = this.node.animationState.setActive("exit", !isPresent);
        if (onExitComplete && !isPresent) exitAnimation.then(()=>{
            this.isExitComplete = true;
            onExitComplete(this.id);
        });
    }
    mount() {
        const { register: register, onExitComplete: onExitComplete } = this.node.presenceContext || {};
        if (onExitComplete) onExitComplete(this.id);
        if (register) this.unmount = register(this.id);
    }
    unmount() {}
}


const $eb9271000c09ec39$export$7f9953c70dacfd7f = {
    animation: {
        Feature: (0, $157fd3be837bcd23$export$b45b3fe5caabdca)
    },
    exit: {
        Feature: (0, $455e223518e62b4a$export$4989d1eb6104cc6c)
    }
};




function $921c1cbb23e436b4$export$b1d829ddf82884aa(target, eventName, handler, options = {
    passive: true
}) {
    target.addEventListener(eventName, handler, options);
    return ()=>target.removeEventListener(eventName, handler);
}


const $ec5f5eba7167d679$var$SCALE_PRECISION = 0.0001;
const $ec5f5eba7167d679$var$SCALE_MIN = 1 - $ec5f5eba7167d679$var$SCALE_PRECISION;
const $ec5f5eba7167d679$var$SCALE_MAX = 1 + $ec5f5eba7167d679$var$SCALE_PRECISION;
const $ec5f5eba7167d679$var$TRANSLATE_PRECISION = 0.01;
const $ec5f5eba7167d679$var$TRANSLATE_MIN = 0 - $ec5f5eba7167d679$var$TRANSLATE_PRECISION;
const $ec5f5eba7167d679$var$TRANSLATE_MAX = 0 + $ec5f5eba7167d679$var$TRANSLATE_PRECISION;
function $ec5f5eba7167d679$export$c1c127004b72a37(axis) {
    return axis.max - axis.min;
}
function $ec5f5eba7167d679$export$28d0384c4b79bde2(value, target, maxDistance) {
    return Math.abs(value - target) <= maxDistance;
}
function $ec5f5eba7167d679$export$e90fc1ae5e3e48ed(delta, source, target, origin = 0.5) {
    delta.origin = origin;
    delta.originPoint = (0, $33875f370c178373$export$3bb0b4ff1037b8dd)(source.min, source.max, delta.origin);
    delta.scale = $ec5f5eba7167d679$export$c1c127004b72a37(target) / $ec5f5eba7167d679$export$c1c127004b72a37(source);
    delta.translate = (0, $33875f370c178373$export$3bb0b4ff1037b8dd)(target.min, target.max, delta.origin) - delta.originPoint;
    if (delta.scale >= $ec5f5eba7167d679$var$SCALE_MIN && delta.scale <= $ec5f5eba7167d679$var$SCALE_MAX || isNaN(delta.scale)) delta.scale = 1.0;
    if (delta.translate >= $ec5f5eba7167d679$var$TRANSLATE_MIN && delta.translate <= $ec5f5eba7167d679$var$TRANSLATE_MAX || isNaN(delta.translate)) delta.translate = 0.0;
}
function $ec5f5eba7167d679$export$c0d25e96fc67d310(delta, source, target, origin) {
    $ec5f5eba7167d679$export$e90fc1ae5e3e48ed(delta.x, source.x, target.x, origin ? origin.originX : undefined);
    $ec5f5eba7167d679$export$e90fc1ae5e3e48ed(delta.y, source.y, target.y, origin ? origin.originY : undefined);
}
function $ec5f5eba7167d679$export$cabef5b392704b41(target, relative, parent, anchor = 0) {
    const anchorPoint = anchor ? (0, $33875f370c178373$export$3bb0b4ff1037b8dd)(parent.min, parent.max, anchor) : parent.min;
    target.min = anchorPoint + relative.min;
    target.max = target.min + $ec5f5eba7167d679$export$c1c127004b72a37(relative);
}
function $ec5f5eba7167d679$export$426154f9d100f99(target, relative, parent, anchor) {
    $ec5f5eba7167d679$export$cabef5b392704b41(target.x, relative.x, parent.x, anchor?.x);
    $ec5f5eba7167d679$export$cabef5b392704b41(target.y, relative.y, parent.y, anchor?.y);
}
function $ec5f5eba7167d679$export$ecd3d3bef81102c3(target, layout, parent, anchor = 0) {
    const anchorPoint = anchor ? (0, $33875f370c178373$export$3bb0b4ff1037b8dd)(parent.min, parent.max, anchor) : parent.min;
    target.min = layout.min - anchorPoint;
    target.max = target.min + $ec5f5eba7167d679$export$c1c127004b72a37(layout);
}
function $ec5f5eba7167d679$export$2785bfcc929c5650(target, layout, parent, anchor) {
    $ec5f5eba7167d679$export$ecd3d3bef81102c3(target.x, layout.x, parent.x, anchor?.x);
    $ec5f5eba7167d679$export$ecd3d3bef81102c3(target.y, layout.y, parent.y, anchor?.y);
}

function $2a7fbad2236ba94a$export$b789de563eb43b1(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}

const $b69ffc823be5b99f$var$keyboardAccessibleElements = new Set([
    "BUTTON",
    "INPUT",
    "SELECT",
    "TEXTAREA",
    "A"
]);
/**
 * Checks if an element is natively keyboard accessible (focusable).
 * Used by the press gesture to determine if we need to add tabIndex.
 */ function $b69ffc823be5b99f$export$5f6976e2f961e8b7(element) {
    return $b69ffc823be5b99f$var$keyboardAccessibleElements.has(element.tagName) || element.isContentEditable === true;
}
const $b69ffc823be5b99f$var$textInputElements = new Set([
    "INPUT",
    "SELECT",
    "TEXTAREA"
]);
/**
 * Checks if an element has text selection or direct interaction behavior
 * that should block drag gestures from starting.
 *
 * This specifically targets form controls where the user might want to select
 * text or interact with the control (e.g., sliders, dropdowns).
 *
 * Buttons and links are NOT included because they don't have click-and-move
 * actions of their own - they only respond to click events, so dragging
 * should still work when initiated from these elements.
 */ function $b69ffc823be5b99f$export$41e5a41992b76128(element) {
    return $b69ffc823be5b99f$var$textInputElements.has(element.tagName) || element.isContentEditable === true;
}


/**
 * Checks if an element is an SVG element in a way
 * that works across iframes
 */ function $aaafa67702233fc7$export$17eda790a720ec57(element) {
    return (0, $8d70e9a72ff93dfc$export$a6cdc56e425d0d0a)(element) && "ownerSVGElement" in element;
}


function $fddf2622f5e3077b$export$90ceba2564a894f8(elementOrSelector, scope, selectorCache) {
    if (elementOrSelector == null) return [];
    if (elementOrSelector instanceof EventTarget) return [
        elementOrSelector
    ];
    else if (typeof elementOrSelector === "string") {
        let root = document;
        if (scope) root = scope.current;
        const elements = selectorCache?.[elementOrSelector] ?? root.querySelectorAll(elementOrSelector);
        return elements ? Array.from(elements) : [];
    }
    return Array.from(elementOrSelector).filter((element)=>element != null);
}


const $781919742c5312f3$var$resizeHandlers = new WeakMap();
let $781919742c5312f3$var$observer;
const $781919742c5312f3$var$getSize = (borderBoxAxis, svgAxis, htmlAxis)=>(target, borderBoxSize)=>{
        if (borderBoxSize && borderBoxSize[0]) return borderBoxSize[0][borderBoxAxis + "Size"];
        else if ((0, $aaafa67702233fc7$export$17eda790a720ec57)(target) && "getBBox" in target) return target.getBBox()[svgAxis];
        else return target[htmlAxis];
    };
const $781919742c5312f3$var$getWidth = /*@__PURE__*/ $781919742c5312f3$var$getSize("inline", "width", "offsetWidth");
const $781919742c5312f3$var$getHeight = /*@__PURE__*/ $781919742c5312f3$var$getSize("block", "height", "offsetHeight");
function $781919742c5312f3$var$notifyTarget({ target: target, borderBoxSize: borderBoxSize }) {
    $781919742c5312f3$var$resizeHandlers.get(target)?.forEach((handler)=>{
        handler(target, {
            get width () {
                return $781919742c5312f3$var$getWidth(target, borderBoxSize);
            },
            get height () {
                return $781919742c5312f3$var$getHeight(target, borderBoxSize);
            }
        });
    });
}
function $781919742c5312f3$var$notifyAll(entries) {
    entries.forEach($781919742c5312f3$var$notifyTarget);
}
function $781919742c5312f3$var$createResizeObserver() {
    if (typeof ResizeObserver === "undefined") return;
    $781919742c5312f3$var$observer = new ResizeObserver($781919742c5312f3$var$notifyAll);
}
function $781919742c5312f3$export$81a0e12ec749d682(target, handler) {
    if (!$781919742c5312f3$var$observer) $781919742c5312f3$var$createResizeObserver();
    const elements = (0, $fddf2622f5e3077b$export$90ceba2564a894f8)(target);
    elements.forEach((element)=>{
        let elementHandlers = $781919742c5312f3$var$resizeHandlers.get(element);
        if (!elementHandlers) {
            elementHandlers = new Set();
            $781919742c5312f3$var$resizeHandlers.set(element, elementHandlers);
        }
        elementHandlers.add(handler);
        $781919742c5312f3$var$observer?.observe(element);
    });
    return ()=>{
        elements.forEach((element)=>{
            const elementHandlers = $781919742c5312f3$var$resizeHandlers.get(element);
            elementHandlers?.delete(handler);
            if (!elementHandlers?.size) $781919742c5312f3$var$observer?.unobserve(element);
        });
    };
}


const $a44a53617c981924$var$windowCallbacks = new Set();
let $a44a53617c981924$var$windowResizeHandler;
function $a44a53617c981924$var$createWindowResizeHandler() {
    $a44a53617c981924$var$windowResizeHandler = ()=>{
        const info = {
            get width () {
                return window.innerWidth;
            },
            get height () {
                return window.innerHeight;
            }
        };
        $a44a53617c981924$var$windowCallbacks.forEach((callback)=>callback(info));
    };
    window.addEventListener("resize", $a44a53617c981924$var$windowResizeHandler);
}
function $a44a53617c981924$export$7fc81011b72cd94d(callback) {
    $a44a53617c981924$var$windowCallbacks.add(callback);
    if (!$a44a53617c981924$var$windowResizeHandler) $a44a53617c981924$var$createWindowResizeHandler();
    return ()=>{
        $a44a53617c981924$var$windowCallbacks.delete(callback);
        if (!$a44a53617c981924$var$windowCallbacks.size && typeof $a44a53617c981924$var$windowResizeHandler === "function") {
            window.removeEventListener("resize", $a44a53617c981924$var$windowResizeHandler);
            $a44a53617c981924$var$windowResizeHandler = undefined;
        }
    };
}


function $1210754fb37f9d28$export$4380c87abf28fdf(a, b) {
    return typeof a === "function" ? (0, $a44a53617c981924$export$7fc81011b72cd94d)(a) : (0, $781919742c5312f3$export$81a0e12ec749d682)(a, b);
}

const $ce5887a2ddc4272e$export$9e9bc3c487fccc00 = {
    x: false,
    y: false
};
function $ce5887a2ddc4272e$export$1b3dd616664938e4() {
    return $ce5887a2ddc4272e$export$9e9bc3c487fccc00.x || $ce5887a2ddc4272e$export$9e9bc3c487fccc00.y;
}


function $952b8481012716b8$export$64d8a3fd7eb621d5(axis) {
    if (axis === "x" || axis === "y") {
        if ((0, $ce5887a2ddc4272e$export$9e9bc3c487fccc00)[axis]) return null;
        else {
            (0, $ce5887a2ddc4272e$export$9e9bc3c487fccc00)[axis] = true;
            return ()=>{
                (0, $ce5887a2ddc4272e$export$9e9bc3c487fccc00)[axis] = false;
            };
        }
    } else {
        if ((0, $ce5887a2ddc4272e$export$9e9bc3c487fccc00).x || (0, $ce5887a2ddc4272e$export$9e9bc3c487fccc00).y) return null;
        else {
            (0, $ce5887a2ddc4272e$export$9e9bc3c487fccc00).x = (0, $ce5887a2ddc4272e$export$9e9bc3c487fccc00).y = true;
            return ()=>{
                (0, $ce5887a2ddc4272e$export$9e9bc3c487fccc00).x = (0, $ce5887a2ddc4272e$export$9e9bc3c487fccc00).y = false;
            };
        }
    }
}




const $054aea5116346b18$export$a4cf9c8a4b063a6e = (event)=>{
    if (event.pointerType === "mouse") return typeof event.button !== "number" || event.button <= 0;
    else /**
         * isPrimary is true for all mice buttons, whereas every touch point
         * is regarded as its own input. So subsequent concurrent touch points
         * will be false.
         *
         * Specifically match against false here as incomplete versions of
         * PointerEvents in very old browser might have it set as undefined.
         */ return event.isPrimary !== false;
};


function $b5ad284edca80238$export$12f84bb882d06e1a(event) {
    return {
        point: {
            x: event.pageX,
            y: event.pageY
        }
    };
}
const $b5ad284edca80238$export$c404e80f92c98d29 = (handler)=>(event)=>(0, $054aea5116346b18$export$a4cf9c8a4b063a6e)(event) && handler(event, $b5ad284edca80238$export$12f84bb882d06e1a(event));


function $72c76525032a2230$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $921c1cbb23e436b4$export$b1d829ddf82884aa)(target, eventName, (0, $b5ad284edca80238$export$c404e80f92c98d29)(handler), options);
}



// Fixes https://github.com/motiondivision/motion/issues/2270
const $bd5aa336cdaff265$export$d533d84f9871c879 = ({ current: current })=>{
    return current ? current.ownerDocument.defaultView : null;
};







const $58c819ee51481345$export$9f17032d917177de = (a, b)=>Math.abs(a - b);
function $58c819ee51481345$export$503a1d513f12e38b(a, b) {
    // Multi-dimensional
    const xDelta = $58c819ee51481345$export$9f17032d917177de(a.x, b.x);
    const yDelta = $58c819ee51481345$export$9f17032d917177de(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}


const $2d1c7bc68ffa3f23$var$overflowStyles = /*#__PURE__*/ new Set([
    "auto",
    "scroll"
]);
/**
 * @internal
 */ class $2d1c7bc68ffa3f23$export$d9c66232c9c4689c {
    constructor(event, handlers, { transformPagePoint: transformPagePoint, contextWindow: contextWindow = window, dragSnapToOrigin: dragSnapToOrigin = false, distanceThreshold: distanceThreshold = 3, element: element } = {}){
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * Raw (untransformed) event info, re-transformed each frame
         * so transformPagePoint sees the current parent matrix.
         * @internal
         */ this.lastRawMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        /**
         * @internal
         */ this.contextWindow = window;
        /**
         * Scroll positions of scrollable ancestors and window.
         * @internal
         */ this.scrollPositions = new Map();
        /**
         * Cleanup function for scroll listeners.
         * @internal
         */ this.removeScrollListeners = null;
        this.onElementScroll = (event)=>{
            this.handleScroll(event.target);
        };
        this.onWindowScroll = ()=>{
            this.handleScroll(window);
        };
        this.updatePoint = ()=>{
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            // Re-transform raw point through current transformPagePoint so
            // animated parent transforms (e.g. rotation) are picked up each frame
            if (this.lastRawMoveEventInfo) this.lastMoveEventInfo = $2d1c7bc68ffa3f23$var$transformPoint(this.lastRawMoveEventInfo, this.transformPagePoint);
            const info = $2d1c7bc68ffa3f23$var$getPanInfo(this.lastMoveEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursor.
            const isDistancePastThreshold = (0, $58c819ee51481345$export$503a1d513f12e38b)(info.offset, {
                x: 0,
                y: 0
            }) >= this.distanceThreshold;
            if (!isPanStarted && !isDistancePastThreshold) return;
            const { point: point } = info;
            const { timestamp: timestamp } = (0, $f28d1a4d8c26f6e5$export$fff89137e9e818ce);
            this.history.push({
                ...point,
                timestamp: timestamp
            });
            const { onStart: onStart, onMove: onMove } = this.handlers;
            if (!isPanStarted) {
                onStart && onStart(this.lastMoveEvent, info);
                this.startEvent = this.lastMoveEvent;
            }
            onMove && onMove(this.lastMoveEvent, info);
        };
        this.handlePointerMove = (event, info)=>{
            this.lastMoveEvent = event;
            this.lastRawMoveEventInfo = info;
            this.lastMoveEventInfo = $2d1c7bc68ffa3f23$var$transformPoint(info, this.transformPagePoint);
            // Throttle mouse move event to once per frame
            (0, $f28d1a4d8c26f6e5$export$2cef06c20297c17d).update(this.updatePoint, true);
        };
        this.handlePointerUp = (event, info)=>{
            this.end();
            const { onEnd: onEnd, onSessionEnd: onSessionEnd, resumeAnimation: resumeAnimation } = this.handlers;
            // Resume animation if dragSnapToOrigin is set OR if no drag started (user just clicked)
            // This ensures constraint animations continue when interrupted by a click
            if (this.dragSnapToOrigin || !this.startEvent) resumeAnimation && resumeAnimation();
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const panInfo = $2d1c7bc68ffa3f23$var$getPanInfo(event.type === "pointercancel" ? this.lastMoveEventInfo : $2d1c7bc68ffa3f23$var$transformPoint(info, this.transformPagePoint), this.history);
            if (this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (!(0, $054aea5116346b18$export$a4cf9c8a4b063a6e)(event)) return;
        this.dragSnapToOrigin = dragSnapToOrigin;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        this.distanceThreshold = distanceThreshold;
        this.contextWindow = contextWindow || window;
        const info = (0, $b5ad284edca80238$export$12f84bb882d06e1a)(event);
        const initialInfo = $2d1c7bc68ffa3f23$var$transformPoint(info, this.transformPagePoint);
        const { point: point } = initialInfo;
        const { timestamp: timestamp } = (0, $f28d1a4d8c26f6e5$export$fff89137e9e818ce);
        this.history = [
            {
                ...point,
                timestamp: timestamp
            }
        ];
        const { onSessionStart: onSessionStart } = handlers;
        onSessionStart && onSessionStart(event, $2d1c7bc68ffa3f23$var$getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, $df67593b734d7628$export$a4627e546088548d)((0, $72c76525032a2230$export$fcff2e64e6676b81)(this.contextWindow, "pointermove", this.handlePointerMove), (0, $72c76525032a2230$export$fcff2e64e6676b81)(this.contextWindow, "pointerup", this.handlePointerUp), (0, $72c76525032a2230$export$fcff2e64e6676b81)(this.contextWindow, "pointercancel", this.handlePointerUp));
        // Start scroll tracking if element provided
        if (element) this.startScrollTracking(element);
    }
    /**
     * Start tracking scroll on ancestors and window.
     */ startScrollTracking(element) {
        // Store initial scroll positions for scrollable ancestors
        let current = element.parentElement;
        while(current){
            const style = getComputedStyle(current);
            if ($2d1c7bc68ffa3f23$var$overflowStyles.has(style.overflowX) || $2d1c7bc68ffa3f23$var$overflowStyles.has(style.overflowY)) this.scrollPositions.set(current, {
                x: current.scrollLeft,
                y: current.scrollTop
            });
            current = current.parentElement;
        }
        // Track window scroll
        this.scrollPositions.set(window, {
            x: window.scrollX,
            y: window.scrollY
        });
        // Capture listener catches element scroll events as they bubble
        window.addEventListener("scroll", this.onElementScroll, {
            capture: true
        });
        // Direct window scroll listener (window scroll doesn't bubble)
        window.addEventListener("scroll", this.onWindowScroll);
        this.removeScrollListeners = ()=>{
            window.removeEventListener("scroll", this.onElementScroll, {
                capture: true
            });
            window.removeEventListener("scroll", this.onWindowScroll);
        };
    }
    /**
     * Handle scroll compensation during drag.
     *
     * For element scroll: adjusts history origin since pageX/pageY doesn't change.
     * For window scroll: adjusts lastMoveEventInfo since pageX/pageY would change.
     */ handleScroll(target) {
        const initial = this.scrollPositions.get(target);
        if (!initial) return;
        const isWindow = target === window;
        const current = isWindow ? {
            x: window.scrollX,
            y: window.scrollY
        } : {
            x: target.scrollLeft,
            y: target.scrollTop
        };
        const delta = {
            x: current.x - initial.x,
            y: current.y - initial.y
        };
        if (delta.x === 0 && delta.y === 0) return;
        if (isWindow) // Window scroll: pageX/pageY changes, so update lastMoveEventInfo
        {
            if (this.lastMoveEventInfo) {
                this.lastMoveEventInfo.point.x += delta.x;
                this.lastMoveEventInfo.point.y += delta.y;
            }
        } else // Element scroll: pageX/pageY unchanged, so adjust history origin
        if (this.history.length > 0) {
            this.history[0].x -= delta.x;
            this.history[0].y -= delta.y;
        }
        this.scrollPositions.set(target, current);
        (0, $f28d1a4d8c26f6e5$export$2cef06c20297c17d).update(this.updatePoint, true);
    }
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        this.removeListeners && this.removeListeners();
        this.removeScrollListeners && this.removeScrollListeners();
        this.scrollPositions.clear();
        (0, $f28d1a4d8c26f6e5$export$ec99c0ef4978dccb)(this.updatePoint);
    }
}
function $2d1c7bc68ffa3f23$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $2d1c7bc68ffa3f23$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $2d1c7bc68ffa3f23$var$getPanInfo({ point: point }, history) {
    return {
        point: point,
        delta: $2d1c7bc68ffa3f23$var$subtractPoint(point, $2d1c7bc68ffa3f23$var$lastDevicePoint(history)),
        offset: $2d1c7bc68ffa3f23$var$subtractPoint(point, $2d1c7bc68ffa3f23$var$startDevicePoint(history)),
        velocity: $2d1c7bc68ffa3f23$var$getVelocity(history, 0.1)
    };
}
function $2d1c7bc68ffa3f23$var$startDevicePoint(history) {
    return history[0];
}
function $2d1c7bc68ffa3f23$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $2d1c7bc68ffa3f23$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = $2d1c7bc68ffa3f23$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $a69653fc318d2500$export$fc3e7e8557f8c8c7)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    /**
     * If the selected point is the pointer-down origin (history[0]),
     * there are better movement points available, and the time gap
     * is suspiciously large (>2x timeDelta), use the next point instead.
     * This prevents stale pointer-down points from diluting velocity
     * in hold-then-flick gestures.
     */ if (timestampedPoint === history[0] && history.length > 2 && lastPoint.timestamp - timestampedPoint.timestamp > (0, $a69653fc318d2500$export$fc3e7e8557f8c8c7)(timeDelta) * 2) timestampedPoint = history[1];
    const time = (0, $a69653fc318d2500$export$f64c3bfbc58eec0f)(lastPoint.timestamp - timestampedPoint.timestamp);
    if (time === 0) return {
        x: 0,
        y: 0
    };
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}




/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $7f5bc3e929ead266$export$b3c764d3fca3ffe3(point, { min: min, max: max }, elastic) {
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $33875f370c178373$export$3bb0b4ff1037b8dd)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $33875f370c178373$export$3bb0b4ff1037b8dd)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $7f5bc3e929ead266$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $7f5bc3e929ead266$export$4e9195bf7793bc78(layoutBox, { top: top, left: left, bottom: bottom, right: right }) {
    return {
        x: $7f5bc3e929ead266$export$690c180aa5775042(layoutBox.x, left, right),
        y: $7f5bc3e929ead266$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $7f5bc3e929ead266$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    let min = constraintsAxis.min - layoutAxis.min;
    let max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) [min, max] = [
        max,
        min
    ];
    return {
        min: min,
        max: max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $7f5bc3e929ead266$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $7f5bc3e929ead266$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $7f5bc3e929ead266$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function $7f5bc3e929ead266$export$13abbfca044ca46d(source, target) {
    let origin = 0.5;
    const sourceLength = (0, $ec5f5eba7167d679$export$c1c127004b72a37)(source);
    const targetLength = (0, $ec5f5eba7167d679$export$c1c127004b72a37)(target);
    if (targetLength > sourceLength) origin = (0, $cf400a7bc85048be$export$504d7abb21fa8c9)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, $cf400a7bc85048be$export$504d7abb21fa8c9)(source.min, source.max - targetLength, target.min);
    return (0, $c7d27346dbc155b2$export$7d15b64cf5a3a4c4)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $7f5bc3e929ead266$export$e9672cc4c36a8b87(layout, constraints) {
    const relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
const $7f5bc3e929ead266$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $7f5bc3e929ead266$export$7c5eaef8f4723d22(dragElastic = $7f5bc3e929ead266$export$a3366d3bac43a742) {
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $7f5bc3e929ead266$export$a3366d3bac43a742;
    return {
        x: $7f5bc3e929ead266$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $7f5bc3e929ead266$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $7f5bc3e929ead266$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $7f5bc3e929ead266$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $7f5bc3e929ead266$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $7f5bc3e929ead266$export$bbbc10b82e6c0afb(dragElastic, label) {
    return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}


const $8e573d0750749e1a$export$f0a15892c27dc07c = new WeakMap();
class $8e573d0750749e1a$export$86bff71f18910307 {
    constructor(visualElement){
        this.openDragLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, $536f8c4470f7cfa4$export$6459fc9e86be362e)();
        /**
         * The latest pointer event. Used as fallback when the `cancel` and `stop` functions are called without arguments.
         */ this.latestPointerEvent = null;
        /**
         * The latest pan info. Used as fallback when the `cancel` and `stop` functions are called without arguments.
         */ this.latestPanInfo = null;
        this.visualElement = visualElement;
    }
    start(originEvent, { snapToCursor: snapToCursor = false, distanceThreshold: distanceThreshold } = {}) {
        /**
         * Don't start dragging if this component is exiting
         */ const { presenceContext: presenceContext } = this.visualElement;
        if (presenceContext && presenceContext.isPresent === false) return;
        const onSessionStart = (event)=>{
            if (snapToCursor) this.snapToCursor((0, $b5ad284edca80238$export$12f84bb882d06e1a)(event).point);
            this.stopAnimation();
        };
        const onStart = (event, info)=>{
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            const { drag: drag, dragPropagation: dragPropagation, onDragStart: onDragStart } = this.getProps();
            if (drag && !dragPropagation) {
                if (this.openDragLock) this.openDragLock();
                this.openDragLock = (0, $952b8481012716b8$export$64d8a3fd7eb621d5)(drag);
                // If we don 't have the lock, don't start dragging
                if (!this.openDragLock) return;
            }
            this.latestPointerEvent = event;
            this.latestPanInfo = info;
            this.isDragging = true;
            this.currentDirection = null;
            this.resolveConstraints();
            if (this.visualElement.projection) {
                this.visualElement.projection.isAnimationBlocked = true;
                this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin and pointer offset
             */ (0, $2a7fbad2236ba94a$export$b789de563eb43b1)((axis)=>{
                let current = this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */ if ((0, $b70b0cd340f5c11d$export$626336c2cd4b14de).test(current)) {
                    const { projection: projection } = this.visualElement;
                    if (projection && projection.layout) {
                        const measuredAxis = projection.layout.layoutBox[axis];
                        if (measuredAxis) {
                            const length = (0, $ec5f5eba7167d679$export$c1c127004b72a37)(measuredAxis);
                            current = length * (parseFloat(current) / 100);
                        }
                    }
                }
                this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            if (onDragStart) (0, $f28d1a4d8c26f6e5$export$2cef06c20297c17d).update(()=>onDragStart(event, info), false, true);
            (0, $8e65e92243d8e093$export$3ac5aed310be0bee)(this.visualElement, "transform");
            const { animationState: animationState } = this.visualElement;
            animationState && animationState.setActive("whileDrag", true);
        };
        const onMove = (event, info)=>{
            this.latestPointerEvent = event;
            this.latestPanInfo = info;
            const { dragPropagation: dragPropagation, dragDirectionLock: dragDirectionLock, onDirectionLock: onDirectionLock, onDrag: onDrag } = this.getProps();
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !this.openDragLock) return;
            const { offset: offset } = info;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && this.currentDirection === null) {
                this.currentDirection = $8e573d0750749e1a$var$getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (this.currentDirection !== null) onDirectionLock && onDirectionLock(this.currentDirection);
                return;
            }
            // Update each point with the latest position
            this.updateAxis("x", info.point, offset);
            this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ this.visualElement.render();
            /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */ if (onDrag) (0, $f28d1a4d8c26f6e5$export$2cef06c20297c17d).update(()=>onDrag(event, info), false, true);
        };
        const onSessionEnd = (event, info)=>{
            this.latestPointerEvent = event;
            this.latestPanInfo = info;
            this.stop(event, info);
            this.latestPointerEvent = null;
            this.latestPanInfo = null;
        };
        const resumeAnimation = ()=>{
            const { dragSnapToOrigin: snap } = this.getProps();
            if (snap || this.constraints) this.startAnimation({
                x: 0,
                y: 0
            });
        };
        const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
        this.panSession = new (0, $2d1c7bc68ffa3f23$export$d9c66232c9c4689c)(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd,
            resumeAnimation: resumeAnimation
        }, {
            transformPagePoint: this.visualElement.getTransformPagePoint(),
            dragSnapToOrigin: dragSnapToOrigin,
            distanceThreshold: distanceThreshold,
            contextWindow: (0, $bd5aa336cdaff265$export$d533d84f9871c879)(this.visualElement),
            element: this.visualElement.current
        });
    }
    /**
     * @internal
     */ stop(event, panInfo) {
        const finalEvent = event || this.latestPointerEvent;
        const finalPanInfo = panInfo || this.latestPanInfo;
        const isDragging = this.isDragging;
        this.cancel();
        if (!isDragging || !finalPanInfo || !finalEvent) return;
        const { velocity: velocity } = finalPanInfo;
        this.startAnimation(velocity);
        const { onDragEnd: onDragEnd } = this.getProps();
        if (onDragEnd) (0, $f28d1a4d8c26f6e5$export$2cef06c20297c17d).postRender(()=>onDragEnd(finalEvent, finalPanInfo));
    }
    /**
     * @internal
     */ cancel() {
        this.isDragging = false;
        const { projection: projection, animationState: animationState } = this.visualElement;
        if (projection) projection.isAnimationBlocked = false;
        this.endPanSession();
        const { dragPropagation: dragPropagation } = this.getProps();
        if (!dragPropagation && this.openDragLock) {
            this.openDragLock();
            this.openDragLock = null;
        }
        animationState && animationState.setActive("whileDrag", false);
    }
    /**
     * Clean up the pan session without modifying other drag state.
     * This is used during unmount to ensure event listeners are removed
     * without affecting projection animations or drag locks.
     * @internal
     */ endPanSession() {
        this.panSession && this.panSession.end();
        this.panSession = undefined;
    }
    updateAxis(axis, _point, offset) {
        const { drag: drag } = this.getProps();
        // If we're not dragging this axis, do an early return.
        if (!offset || !$8e573d0750749e1a$var$shouldDrag(axis, drag, this.currentDirection)) return;
        const axisValue = this.getAxisMotionValue(axis);
        let next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) next = (0, $7f5bc3e929ead266$export$b3c764d3fca3ffe3)(next, this.constraints[axis], this.elastic[axis]);
        axisValue.set(next);
    }
    resolveConstraints() {
        const { dragConstraints: dragConstraints, dragElastic: dragElastic } = this.getProps();
        const layout = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(false) : this.visualElement.projection?.layout;
        const prevConstraints = this.constraints;
        if (dragConstraints && (0, $cddfc7e2c37cb099$export$dedd81df7bc1307)(dragConstraints)) {
            if (!this.constraints) this.constraints = this.resolveRefConstraints();
        } else if (dragConstraints && layout) this.constraints = (0, $7f5bc3e929ead266$export$4e9195bf7793bc78)(layout.layoutBox, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, $7f5bc3e929ead266$export$7c5eaef8f4723d22)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative. This only applies to relative (non-ref)
         * constraints, as ref-based constraints from calcViewportConstraints are already in the
         * correct coordinate space for the motion value transform offset.
         */ if (prevConstraints !== this.constraints && !(0, $cddfc7e2c37cb099$export$dedd81df7bc1307)(dragConstraints) && layout && this.constraints && !this.hasMutatedConstraints) (0, $2a7fbad2236ba94a$export$b789de563eb43b1)((axis)=>{
            if (this.constraints !== false && this.getAxisMotionValue(axis)) this.constraints[axis] = (0, $7f5bc3e929ead266$export$e9672cc4c36a8b87)(layout.layoutBox[axis], this.constraints[axis]);
        });
    }
    resolveRefConstraints() {
        const { dragConstraints: constraints, onMeasureDragConstraints: onMeasureDragConstraints } = this.getProps();
        if (!constraints || !(0, $cddfc7e2c37cb099$export$dedd81df7bc1307)(constraints)) return false;
        const constraintsElement = constraints.current;
        (0, $a41eb4452ff76a35$export$f5708dca728d7177)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.", "drag-constraints-ref");
        const { projection: projection } = this.visualElement;
        // TODO
        if (!projection || !projection.layout) return false;
        /**
         * Refresh the root scroll offset so the constraint's viewport box
         * translates to correct page coordinates. The scroll captured at
         * drag mount can be stale if the document was scrolled afterwards —
         * e.g. via the browser restoring scroll on refresh, or an ancestor
         * layout effect running after this element's mount (#2829).
         *
         * Clear the cached scroll first so `updateScroll` bypasses its
         * per-animationId cache and re-reads the live value.
         */ if (projection.root) {
            projection.root.scroll = undefined;
            projection.root.updateScroll();
        }
        const constraintsBox = (0, $a55bdfd27a922601$export$6a597be7a7940a96)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        let measuredConstraints = (0, $7f5bc3e929ead266$export$4228500f19d4cdf7)(projection.layout.layoutBox, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            const userConstraints = onMeasureDragConstraints((0, $528c11c0d7848230$export$b6b9cd4198191a47)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, $528c11c0d7848230$export$d3955c6a8f65a36b)(userConstraints);
        }
        return measuredConstraints;
    }
    startAnimation(velocity) {
        const { drag: drag, dragMomentum: dragMomentum, dragElastic: dragElastic, dragTransition: dragTransition, dragSnapToOrigin: dragSnapToOrigin, onDragTransitionEnd: onDragTransitionEnd } = this.getProps();
        const constraints = this.constraints || {};
        const momentumAnimations = (0, $2a7fbad2236ba94a$export$b789de563eb43b1)((axis)=>{
            if (!$8e573d0750749e1a$var$shouldDrag(axis, drag, this.currentDirection)) return;
            let transition = constraints && constraints[axis] || {};
            if (dragSnapToOrigin === true || dragSnapToOrigin === axis) transition = {
                min: 0,
                max: 0
            };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ const bounceStiffness = dragElastic ? 200 : 1000000;
            const bounceDamping = dragElastic ? 40 : 10000000;
            const inertia = {
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10,
                ...dragTransition,
                ...transition
            };
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
    startAxisValueAnimation(axis, transition) {
        const axisValue = this.getAxisMotionValue(axis);
        (0, $8e65e92243d8e093$export$3ac5aed310be0bee)(this.visualElement, axis);
        return axisValue.start((0, $d2bd59c5f116d70d$export$90b3dfc33ff3548)(axis, axisValue, 0, transition, this.visualElement, false));
    }
    stopAnimation() {
        (0, $2a7fbad2236ba94a$export$b789de563eb43b1)((axis)=>this.getAxisMotionValue(axis).stop());
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ getAxisMotionValue(axis) {
        const dragKey = `_drag${axis.toUpperCase()}`;
        const props = this.visualElement.getProps();
        const externalMotionValue = props[dragKey];
        return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, this.visualElement.latestValues[axis] ?? 0);
    }
    snapToCursor(point) {
        (0, $2a7fbad2236ba94a$export$b789de563eb43b1)((axis)=>{
            const { drag: drag } = this.getProps();
            // If we're not dragging this axis, do an early return.
            if (!$8e573d0750749e1a$var$shouldDrag(axis, drag, this.currentDirection)) return;
            const { projection: projection } = this.visualElement;
            const axisValue = this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                const { min: min, max: max } = projection.layout.layoutBox[axis];
                /**
                 * The layout measurement includes the current transform value,
                 * so we need to add it back to get the correct snap position.
                 * This fixes an issue where elements with initial coordinates
                 * would snap to the wrong position on the first drag.
                 */ const current = axisValue.get() || 0;
                axisValue.set(point[axis] - (0, $33875f370c178373$export$3bb0b4ff1037b8dd)(min, max, 0.5) + current);
            }
        });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ scalePositionWithinConstraints() {
        if (!this.visualElement.current) return;
        const { drag: drag, dragConstraints: dragConstraints } = this.getProps();
        const { projection: projection } = this.visualElement;
        if (!(0, $cddfc7e2c37cb099$export$dedd81df7bc1307)(dragConstraints) || !projection || !this.constraints) return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ const boxProgress = {
            x: 0,
            y: 0
        };
        (0, $2a7fbad2236ba94a$export$b789de563eb43b1)((axis)=>{
            const axisValue = this.getAxisMotionValue(axis);
            if (axisValue && this.constraints !== false) {
                const latest = axisValue.get();
                boxProgress[axis] = (0, $7f5bc3e929ead266$export$13abbfca044ca46d)({
                    min: latest,
                    max: latest
                }, this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */ const { transformTemplate: transformTemplate } = this.visualElement.getProps();
        this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        projection.root && projection.root.updateScroll();
        projection.updateLayout();
        /**
         * Reset constraints so resolveConstraints() will recalculate them
         * with the freshly measured layout rather than returning the cached value.
         */ this.constraints = false;
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ (0, $2a7fbad2236ba94a$export$b789de563eb43b1)((axis)=>{
            if (!$8e573d0750749e1a$var$shouldDrag(axis, drag, null)) return;
            /**
             * Calculate a new transform based on the previous box progress
             */ const axisValue = this.getAxisMotionValue(axis);
            const { min: min, max: max } = this.constraints[axis];
            axisValue.set((0, $33875f370c178373$export$3bb0b4ff1037b8dd)(min, max, boxProgress[axis]));
        });
        /**
         * Flush the updated transform to the DOM synchronously to prevent
         * a visual flash at the element's CSS layout position (0,0) when
         * the transform was stripped for measurement.
         */ this.visualElement.render();
    }
    addListeners() {
        if (!this.visualElement.current) return;
        $8e573d0750749e1a$export$f0a15892c27dc07c.set(this.visualElement, this);
        const element = this.visualElement.current;
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ const stopPointerListener = (0, $72c76525032a2230$export$fcff2e64e6676b81)(element, "pointerdown", (event)=>{
            const { drag: drag, dragListener: dragListener = true } = this.getProps();
            const target = event.target;
            /**
             * Only block drag if clicking on a text input child element
             * (input, textarea, select, contenteditable) where users might
             * want to select text or interact with the control.
             *
             * Buttons and links don't block drag since they don't have
             * click-and-move actions of their own.
             */ const isClickingTextInputChild = target !== element && (0, $b69ffc823be5b99f$export$41e5a41992b76128)(target);
            if (drag && dragListener && !isClickingTextInputChild) this.start(event);
        });
        /**
         * If using ref-based constraints, observe both the draggable element
         * and the constraint container for size changes via ResizeObserver.
         * Setup is deferred because dragConstraints.current is null when
         * addListeners first runs (React hasn't committed the ref yet).
         */ let stopResizeObservers;
        const measureDragConstraints = ()=>{
            const { dragConstraints: dragConstraints } = this.getProps();
            if ((0, $cddfc7e2c37cb099$export$dedd81df7bc1307)(dragConstraints) && dragConstraints.current) {
                this.constraints = this.resolveRefConstraints();
                if (!stopResizeObservers) stopResizeObservers = $8e573d0750749e1a$var$startResizeObservers(element, dragConstraints.current, ()=>this.scalePositionWithinConstraints());
            }
        };
        const { projection: projection } = this.visualElement;
        const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            projection.root && projection.root.updateScroll();
            projection.updateLayout();
        }
        (0, $f28d1a4d8c26f6e5$export$2cef06c20297c17d).read(measureDragConstraints);
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ const stopResizeListener = (0, $921c1cbb23e436b4$export$b1d829ddf82884aa)(window, "resize", ()=>this.scalePositionWithinConstraints());
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ const stopLayoutUpdateListener = projection.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged })=>{
            if (this.isDragging && hasLayoutChanged) {
                (0, $2a7fbad2236ba94a$export$b789de563eb43b1)((axis)=>{
                    const motionValue = this.getAxisMotionValue(axis);
                    if (!motionValue) return;
                    this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                this.visualElement.render();
            }
        });
        return ()=>{
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
            stopLayoutUpdateListener && stopLayoutUpdateListener();
            stopResizeObservers && stopResizeObservers();
        };
    }
    getProps() {
        const props = this.visualElement.getProps();
        const { drag: drag = false, dragDirectionLock: dragDirectionLock = false, dragPropagation: dragPropagation = false, dragConstraints: dragConstraints = false, dragElastic: dragElastic = (0, $7f5bc3e929ead266$export$a3366d3bac43a742), dragMomentum: dragMomentum = true } = props;
        return {
            ...props,
            drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum
        };
    }
}
function $8e573d0750749e1a$var$skipFirstCall(callback) {
    let isFirst = true;
    return ()=>{
        if (isFirst) {
            isFirst = false;
            return;
        }
        callback();
    };
}
function $8e573d0750749e1a$var$startResizeObservers(element, constraintsElement, onResize) {
    const stopElement = (0, $1210754fb37f9d28$export$4380c87abf28fdf)(element, $8e573d0750749e1a$var$skipFirstCall(onResize));
    const stopContainer = (0, $1210754fb37f9d28$export$4380c87abf28fdf)(constraintsElement, $8e573d0750749e1a$var$skipFirstCall(onResize));
    return ()=>{
        stopElement();
        stopContainer();
    };
}
function $8e573d0750749e1a$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $8e573d0750749e1a$var$getCurrentDirection(offset, lockThreshold = 10) {
    let direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}


class $28c1c17ce2591278$export$5d97dc2872682820 extends (0, $baf88f17ccf98c7a$export$6e91cf7616333d5) {
    constructor(node){
        super(node);
        this.removeGroupControls = (0, $518547564f355e33$export$8793edee2d425525);
        this.removeListeners = (0, $518547564f355e33$export$8793edee2d425525);
        this.controls = new (0, $8e573d0750749e1a$export$86bff71f18910307)(node);
    }
    mount() {
        // If we've been provided a DragControls for manual control over the drag gesture,
        // subscribe this component to it on mount.
        const { dragControls: dragControls } = this.node.getProps();
        if (dragControls) this.removeGroupControls = dragControls.subscribe(this.controls);
        this.removeListeners = this.controls.addListeners() || (0, $518547564f355e33$export$8793edee2d425525);
    }
    update() {
        const { dragControls: dragControls } = this.node.getProps();
        const { dragControls: prevDragControls } = this.node.prevProps || {};
        if (dragControls !== prevDragControls) {
            this.removeGroupControls();
            if (dragControls) this.removeGroupControls = dragControls.subscribe(this.controls);
        }
    }
    unmount() {
        this.removeGroupControls();
        this.removeListeners();
        /**
         * In React 19, during list reorder reconciliation, components may
         * briefly unmount and remount while the drag is still active. If we're
         * actively dragging, we should NOT end the pan session - it will
         * continue tracking pointer events via its window-level listeners.
         *
         * The pan session will be properly cleaned up when:
         * 1. The drag ends naturally (pointerup/pointercancel)
         * 2. The component is truly removed from the DOM
         */ if (!this.controls.isDragging) this.controls.endPanSession();
    }
}







const $1be04a0d843be2d0$var$asyncHandler = (handler)=>(event, info)=>{
        if (handler) (0, $f28d1a4d8c26f6e5$export$2cef06c20297c17d).update(()=>handler(event, info), false, true);
    };
class $1be04a0d843be2d0$export$b4f8f1ee75ce5859 extends (0, $baf88f17ccf98c7a$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.removePointerDownListener = (0, $518547564f355e33$export$8793edee2d425525);
    }
    onPointerDown(pointerDownEvent) {
        this.session = new (0, $2d1c7bc68ffa3f23$export$d9c66232c9c4689c)(pointerDownEvent, this.createPanHandlers(), {
            transformPagePoint: this.node.getTransformPagePoint(),
            contextWindow: (0, $bd5aa336cdaff265$export$d533d84f9871c879)(this.node)
        });
    }
    createPanHandlers() {
        const { onPanSessionStart: onPanSessionStart, onPanStart: onPanStart, onPan: onPan, onPanEnd: onPanEnd } = this.node.getProps();
        return {
            onSessionStart: $1be04a0d843be2d0$var$asyncHandler(onPanSessionStart),
            onStart: $1be04a0d843be2d0$var$asyncHandler(onPanStart),
            onMove: $1be04a0d843be2d0$var$asyncHandler(onPan),
            onEnd: (event, info)=>{
                delete this.session;
                if (onPanEnd) (0, $f28d1a4d8c26f6e5$export$2cef06c20297c17d).postRender(()=>onPanEnd(event, info));
            }
        };
    }
    mount() {
        this.removePointerDownListener = (0, $72c76525032a2230$export$fcff2e64e6676b81)(this.node.current, "pointerdown", (event)=>this.onPointerDown(event));
    }
    update() {
        this.session && this.session.updateHandlers(this.createPanHandlers());
    }
    unmount() {
        this.removePointerDownListener();
        this.session && this.session.end();
    }
}



/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ const $bdff0e3c701943d8$export$97db156a3ed1593b = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};



var $8v0nu = parcelRequire("8v0nu");



"use client";
/**
 * Track whether we've taken any snapshots yet. If not,
 * we can safely skip notification of didUpdate.
 *
 * Difficult to capture in a test but to prevent flickering
 * we must set this to true either on update or unmount.
 * Running `next-env/layout-id` in Safari will show this behaviour if broken.
 */ let $43797e3e47d3582a$var$hasTakenAnySnapshot = false;
class $43797e3e47d3582a$var$MeasureLayoutWithContext extends (0, $8v0nu.Component) {
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ componentDidMount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: switchLayoutGroup, layoutId: layoutId } = this.props;
        const { projection: projection } = visualElement;
        if (projection) {
            if (layoutGroup.group) layoutGroup.group.add(projection);
            if (switchLayoutGroup && switchLayoutGroup.register && layoutId) switchLayoutGroup.register(projection);
            if ($43797e3e47d3582a$var$hasTakenAnySnapshot) projection.root.didUpdate();
            projection.addEventListener("animationComplete", ()=>{
                this.safeToRemove();
            });
            projection.setOptions({
                ...projection.options,
                layoutDependency: this.props.layoutDependency,
                onExitComplete: ()=>this.safeToRemove()
            });
        }
        (0, $bdff0e3c701943d8$export$97db156a3ed1593b).hasEverUpdated = true;
    }
    getSnapshotBeforeUpdate(prevProps) {
        const { layoutDependency: layoutDependency, visualElement: visualElement, drag: drag, isPresent: isPresent } = this.props;
        const { projection: projection } = visualElement;
        if (!projection) return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
        if (prevProps.layoutDependency !== layoutDependency) projection.setOptions({
            ...projection.options,
            layoutDependency: layoutDependency
        });
        $43797e3e47d3582a$var$hasTakenAnySnapshot = true;
        if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined || prevProps.isPresent !== isPresent) projection.willUpdate();
        else this.safeToRemove();
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) projection.promote();
            else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ (0, $f28d1a4d8c26f6e5$export$2cef06c20297c17d).postRender(()=>{
                const stack = projection.getStack();
                if (!stack || !stack.members.length) this.safeToRemove();
            });
        }
        return null;
    }
    componentDidUpdate() {
        const { visualElement: visualElement, layoutAnchor: layoutAnchor } = this.props;
        const { projection: projection } = visualElement;
        if (projection) {
            projection.options.layoutAnchor = layoutAnchor;
            projection.root.didUpdate();
            (0, $72c587626bccb82b$export$bb76eed83315504c).postRender(()=>{
                if (!projection.currentAnimation && projection.isLead()) this.safeToRemove();
            });
        }
    }
    componentWillUnmount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: promoteContext } = this.props;
        const { projection: projection } = visualElement;
        $43797e3e47d3582a$var$hasTakenAnySnapshot = true;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup && layoutGroup.group) layoutGroup.group.remove(projection);
            if (promoteContext && promoteContext.deregister) promoteContext.deregister(projection);
        }
    }
    safeToRemove() {
        const { safeToRemove: safeToRemove } = this.props;
        safeToRemove && safeToRemove();
    }
    render() {
        return null;
    }
}
function $43797e3e47d3582a$export$779f5fb01ad751cd(props) {
    const [isPresent, safeToRemove] = (0, $178906c13254c0f7$export$2a8c16d82a0a0e26)();
    const layoutGroup = (0, $8v0nu.useContext)((0, $f8fa84f618a4fe1a$export$a3579ca508007a95));
    return (0, $ef524fb144c5d632$exports.jsx)($43797e3e47d3582a$var$MeasureLayoutWithContext, {
        ...props,
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, $8v0nu.useContext)((0, $970c209bfbf3f8ee$export$da5f7b802957459a)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    });
}






function $d7b4c1ec598d8531$export$335a17c977067b99(value, keyframes, options) {
    const motionValue$1 = (0, $b2042ca666edf2e9$export$605d60a2578142d3)(value) ? value : (0, $fdf0a8816be57e7f$export$ce8bdc721e76545f)(value);
    motionValue$1.start((0, $d2bd59c5f116d70d$export$90b3dfc33ff3548)("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}












/**
 * Timeout defined in ms
 */ function $cc1e1ac4b9ea470f$export$1391212d75b2ee65(callback, timeout) {
    const start = (0, $111e7cbe8a4123f4$export$2da9be4cfdb689b1).now();
    const checkElapsed = ({ timestamp: timestamp })=>{
        const elapsed = timestamp - start;
        if (elapsed >= timeout) {
            (0, $f28d1a4d8c26f6e5$export$ec99c0ef4978dccb)(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    (0, $f28d1a4d8c26f6e5$export$2cef06c20297c17d).setup(checkElapsed, true);
    return ()=>(0, $f28d1a4d8c26f6e5$export$ec99c0ef4978dccb)(checkElapsed);
}
function $cc1e1ac4b9ea470f$export$fcd451ca460f8a2a(callback, timeout) {
    return $cc1e1ac4b9ea470f$export$1391212d75b2ee65(callback, (0, $a69653fc318d2500$export$fc3e7e8557f8c8c7)(timeout));
}




/**
 * Checks if an element is specifically an SVGSVGElement (the root SVG element)
 * in a way that works across iframes
 */ function $9cc60b98e13c070e$export$66957ea77182581d(element) {
    return (0, $aaafa67702233fc7$export$17eda790a720ec57)(element) && element.tagName === "svg";
}








const $329107cc959583cd$var$borderLabels = [
    "borderTopLeftRadius",
    "borderTopRightRadius",
    "borderBottomLeftRadius",
    "borderBottomRightRadius"
];
const $329107cc959583cd$var$numBorders = $329107cc959583cd$var$borderLabels.length;
const $329107cc959583cd$var$asNumber = (value)=>typeof value === "string" ? parseFloat(value) : value;
const $329107cc959583cd$var$isPx = (value)=>typeof value === "number" || (0, $b70b0cd340f5c11d$export$91c0eda1d06bf008).test(value);
function $329107cc959583cd$export$739e279c17d51c3d(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    if (shouldCrossfadeOpacity) {
        target.opacity = (0, $33875f370c178373$export$3bb0b4ff1037b8dd)(0, lead.opacity ?? 1, $329107cc959583cd$var$easeCrossfadeIn(progress));
        target.opacityExit = (0, $33875f370c178373$export$3bb0b4ff1037b8dd)(follow.opacity ?? 1, 0, $329107cc959583cd$var$easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, $33875f370c178373$export$3bb0b4ff1037b8dd)(follow.opacity ?? 1, lead.opacity ?? 1, progress);
    /**
     * Mix border radius
     */ for(let i = 0; i < $329107cc959583cd$var$numBorders; i++){
        const borderLabel = $329107cc959583cd$var$borderLabels[i];
        let followRadius = $329107cc959583cd$var$getRadius(follow, borderLabel);
        let leadRadius = $329107cc959583cd$var$getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        const canMix = followRadius === 0 || leadRadius === 0 || $329107cc959583cd$var$isPx(followRadius) === $329107cc959583cd$var$isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0, $33875f370c178373$export$3bb0b4ff1037b8dd)($329107cc959583cd$var$asNumber(followRadius), $329107cc959583cd$var$asNumber(leadRadius), progress), 0);
            if ((0, $b70b0cd340f5c11d$export$626336c2cd4b14de).test(leadRadius) || (0, $b70b0cd340f5c11d$export$626336c2cd4b14de).test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, $33875f370c178373$export$3bb0b4ff1037b8dd)(follow.rotate || 0, lead.rotate || 0, progress);
}
function $329107cc959583cd$var$getRadius(values, radiusName) {
    return values[radiusName] !== undefined ? values[radiusName] : values.borderRadius;
}
const $329107cc959583cd$var$easeCrossfadeIn = /*@__PURE__*/ $329107cc959583cd$var$compress(0, 0.5, (0, $1e47753e64ae3dcd$export$c8d67a19199d1a50));
const $329107cc959583cd$var$easeCrossfadeOut = /*@__PURE__*/ $329107cc959583cd$var$compress(0.5, 0.95, (0, $518547564f355e33$export$8793edee2d425525));
function $329107cc959583cd$var$compress(min, max, easing) {
    return (p)=>{
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, $cf400a7bc85048be$export$504d7abb21fa8c9)(min, max, p));
    };
}


/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $03c28f778a6c816a$export$a0230ae482601ae8(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $03c28f778a6c816a$export$c53fd88f45d77e4b(box, originBox) {
    $03c28f778a6c816a$export$a0230ae482601ae8(box.x, originBox.x);
    $03c28f778a6c816a$export$a0230ae482601ae8(box.y, originBox.y);
}
/**
 * Reset a delta to the provided origin box.
 *
 * This is a mutative operation.
 */ function $03c28f778a6c816a$export$8ead6a7d6b225ef(delta, originDelta) {
    delta.translate = originDelta.translate;
    delta.scale = originDelta.scale;
    delta.originPoint = originDelta.originPoint;
    delta.origin = originDelta.origin;
}







/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $d38c11745f2935b3$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, $ee10a003285526dc$export$2290ec7febe36dd6)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, $ee10a003285526dc$export$2290ec7febe36dd6)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $d38c11745f2935b3$export$cc12a0672fae5b4a(axis, translate = 0, scale = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
    if ((0, $b70b0cd340f5c11d$export$626336c2cd4b14de).test(translate)) {
        translate = parseFloat(translate);
        const relativeProgress = (0, $33875f370c178373$export$3bb0b4ff1037b8dd)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    let originPoint = (0, $33875f370c178373$export$3bb0b4ff1037b8dd)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = $d38c11745f2935b3$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $d38c11745f2935b3$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $d38c11745f2935b3$export$42b76f1d0d16d5b(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
    $d38c11745f2935b3$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $d38c11745f2935b3$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $d38c11745f2935b3$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $d38c11745f2935b3$export$73e1ad0a9694e25c(box, transforms, originBox, sourceBox) {
    $d38c11745f2935b3$export$42b76f1d0d16d5b(box.x, transforms, $d38c11745f2935b3$var$xKeys, originBox ? originBox.x : undefined, sourceBox ? sourceBox.x : undefined);
    $d38c11745f2935b3$export$42b76f1d0d16d5b(box.y, transforms, $d38c11745f2935b3$var$yKeys, originBox ? originBox.y : undefined, sourceBox ? sourceBox.y : undefined);
}




function $3d71933370253f8d$var$isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function $3d71933370253f8d$export$a7ec7642fe550fb6(delta) {
    return $3d71933370253f8d$var$isAxisDeltaZero(delta.x) && $3d71933370253f8d$var$isAxisDeltaZero(delta.y);
}
function $3d71933370253f8d$export$7a9a6f114ddd0fdb(a, b) {
    return a.min === b.min && a.max === b.max;
}
function $3d71933370253f8d$export$8d5cf76bb7daff09(a, b) {
    return $3d71933370253f8d$export$7a9a6f114ddd0fdb(a.x, b.x) && $3d71933370253f8d$export$7a9a6f114ddd0fdb(a.y, b.y);
}
function $3d71933370253f8d$export$22adf28bfca1c186(a, b) {
    return Math.round(a.min) === Math.round(b.min) && Math.round(a.max) === Math.round(b.max);
}
function $3d71933370253f8d$export$ef641b782d85522(a, b) {
    return $3d71933370253f8d$export$22adf28bfca1c186(a.x, b.x) && $3d71933370253f8d$export$22adf28bfca1c186(a.y, b.y);
}
function $3d71933370253f8d$export$c5706146bc63213(box) {
    return (0, $ec5f5eba7167d679$export$c1c127004b72a37)(box.x) / (0, $ec5f5eba7167d679$export$c1c127004b72a37)(box.y);
}
function $3d71933370253f8d$export$444620505e28fe92(a, b) {
    return a.translate === b.translate && a.scale === b.scale && a.originPoint === b.originPoint;
}



class $443a9b7ba92194c5$export$39be5b2d82fc9dc7 {
    constructor(){
        this.members = [];
    }
    add(node) {
        (0, $940e5f5cfec6dbd6$export$20e507e47fae79fd)(this.members, node);
        for(let i = this.members.length - 1; i >= 0; i--){
            const member = this.members[i];
            if (member === node || member === this.lead || member === this.prevLead) continue;
            const inst = member.instance;
            if ((!inst || inst.isConnected === false) && !member.snapshot) {
                (0, $940e5f5cfec6dbd6$export$fe2d9b4e03920b4c)(this.members, member);
                member.unmount();
            }
        }
        node.scheduleRender();
    }
    remove(node) {
        (0, $940e5f5cfec6dbd6$export$fe2d9b4e03920b4c)(this.members, node);
        if (node === this.prevLead) this.prevLead = undefined;
        if (node === this.lead) {
            const prevLead = this.members[this.members.length - 1];
            if (prevLead) this.promote(prevLead);
        }
    }
    relegate(node) {
        for(let i = this.members.indexOf(node) - 1; i >= 0; i--){
            const member = this.members[i];
            if (member.isPresent !== false && member.instance?.isConnected !== false) {
                this.promote(member);
                return true;
            }
        }
        return false;
    }
    promote(node, preserveFollowOpacity) {
        const prevLead = this.lead;
        if (node === prevLead) return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.updateSnapshot();
            node.scheduleRender();
            const { layoutDependency: prevDep } = prevLead.options;
            const { layoutDependency: nextDep } = node.options;
            if (prevDep === undefined || prevDep !== nextDep) {
                node.resumeFrom = prevLead;
                if (preserveFollowOpacity) prevLead.preserveOpacity = true;
                if (prevLead.snapshot) {
                    node.snapshot = prevLead.snapshot;
                    node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
                }
                if (node.root?.isUpdating) node.isLayoutDirty = true;
            }
            if (node.options.crossfade === false) prevLead.hide();
        }
    }
    exitAnimationComplete() {
        this.members.forEach((member)=>{
            member.options.onExitComplete?.();
            member.resumingFrom?.options.onExitComplete?.();
        });
    }
    scheduleRender() {
        this.members.forEach((member)=>member.instance && member.scheduleRender(false));
    }
    removeLeadSnapshot() {
        if (this.lead?.snapshot) this.lead.snapshot = undefined;
    }
}


function $11a13b85fd48f8da$export$d33653b270fe725c(delta, treeScale, latestTransform) {
    let transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ const xTranslate = delta.x.translate / treeScale.x;
    const yTranslate = delta.y.translate / treeScale.y;
    const zTranslate = latestTransform?.z || 0;
    if (xTranslate || yTranslate || zTranslate) transform = `translate3d(${xTranslate}px, ${yTranslate}px, ${zTranslate}px) `;
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ if (treeScale.x !== 1 || treeScale.y !== 1) transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
    if (latestTransform) {
        const { transformPerspective: transformPerspective, rotate: rotate, pathRotation: pathRotation, rotateX: rotateX, rotateY: rotateY, skewX: skewX, skewY: skewY } = latestTransform;
        if (transformPerspective) transform = `perspective(${transformPerspective}px) ${transform}`;
        if (rotate) transform += `rotate(${rotate}deg) `;
        // Additive `rotate()` so user `rotate` isn't clobbered.
        if (pathRotation) transform += `rotate(${pathRotation}deg) `;
        if (rotateX) transform += `rotateX(${rotateX}deg) `;
        if (rotateY) transform += `rotateY(${rotateY}deg) `;
        if (skewX) transform += `skewX(${skewX}deg) `;
        if (skewY) transform += `skewY(${skewY}deg) `;
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ const elementScaleX = delta.x.scale * treeScale.x;
    const elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) transform += `scale(${elementScaleX}, ${elementScaleY})`;
    return transform || "none";
}




const $cbc7af87694dac0e$export$d689d9dec5ad338 = (a, b)=>a.depth - b.depth;


class $4df37c6772413f6f$export$1465d17e3de78a96 {
    constructor(){
        this.children = [];
        this.isDirty = false;
    }
    add(child) {
        (0, $940e5f5cfec6dbd6$export$20e507e47fae79fd)(this.children, child);
        this.isDirty = true;
    }
    remove(child) {
        (0, $940e5f5cfec6dbd6$export$fe2d9b4e03920b4c)(this.children, child);
        this.isDirty = true;
    }
    forEach(callback) {
        this.isDirty && this.children.sort((0, $cbc7af87694dac0e$export$d689d9dec5ad338));
        this.isDirty = false;
        this.children.forEach(callback);
    }
}





const $a4346bb27070f751$var$metrics = {
    nodes: 0,
    calculatedTargetDeltas: 0,
    calculatedProjections: 0
};
const $a4346bb27070f751$var$transformAxes = [
    "",
    "X",
    "Y",
    "Z"
];
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ const $a4346bb27070f751$var$animationTarget = 1000;
let $a4346bb27070f751$var$id = 0;
function $a4346bb27070f751$var$resetDistortingTransform(key, visualElement, values, sharedAnimationValues) {
    const { latestValues: latestValues } = visualElement;
    // Record the distorting transform and then temporarily set it to 0
    if (latestValues[key]) {
        values[key] = latestValues[key];
        visualElement.setStaticValue(key, 0);
        if (sharedAnimationValues) sharedAnimationValues[key] = 0;
    }
}
function $a4346bb27070f751$var$cancelTreeOptimisedTransformAnimations(projectionNode) {
    projectionNode.hasCheckedOptimisedAppear = true;
    if (projectionNode.root === projectionNode) return;
    const { visualElement: visualElement } = projectionNode.options;
    if (!visualElement) return;
    const appearId = (0, $20e886dfc046eeda$export$5f8d21e84d1d84fc)(visualElement);
    if (window.MotionHasOptimisedAnimation(appearId, "transform")) {
        const { layout: layout, layoutId: layoutId } = projectionNode.options;
        window.MotionCancelOptimisedAnimation(appearId, "transform", (0, $f28d1a4d8c26f6e5$export$2cef06c20297c17d), !(layout || layoutId));
    }
    const { parent: parent } = projectionNode;
    if (parent && !parent.hasCheckedOptimisedAppear) $a4346bb27070f751$var$cancelTreeOptimisedTransformAnimations(parent);
}
function $a4346bb27070f751$export$a84b61f69daa9da0({ attachResizeListener: attachResizeListener, defaultParent: defaultParent, measureScroll: measureScroll, checkIsScrollRoot: checkIsScrollRoot, resetTransform: resetTransform }) {
    return class ProjectionNode {
        constructor(latestValues = {}, parent = defaultParent?.()){
            /**
             * A unique ID generated for every projection node.
             */ this.id = $a4346bb27070f751$var$id++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */ this.animationId = 0;
            this.animationCommitId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            /**
             * Flag to true if we think the projection calculations for this node needs
             * recalculating as a result of an updated transform or layout animation.
             */ this.isProjectionDirty = false;
            /**
             * Flag to true if the layout *or* transform has changed. This then gets propagated
             * throughout the projection tree, forcing any element below to recalculate on the next frame.
             */ this.isSharedProjectionDirty = false;
            /**
             * Flag transform dirty. This gets propagated throughout the whole tree but is only
             * respected by shared nodes.
             */ this.isTransformDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * Store whether this node has been checked for optimised appear animations. As
             * effects fire bottom-up, and we want to look up the tree for appear animations,
             * this makes sure we only check each path once, stopping at nodes that
             * have already been checked.
             */ this.hasCheckedOptimisedAppear = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            this.hasTreeAnimated = false;
            this.layoutVersion = 0;
            // Note: Currently only running on root node
            this.updateScheduled = false;
            this.scheduleUpdate = ()=>this.update();
            this.projectionUpdateScheduled = false;
            this.checkUpdateFailed = ()=>{
                if (this.isUpdating) {
                    this.isUpdating = false;
                    this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */ this.updateProjection = ()=>{
                this.projectionUpdateScheduled = false;
                /**
                 * Reset debug counts. Manually resetting rather than creating a new
                 * object each frame.
                 */ if ((0, $37850638fe93a8b7$export$84ce9a476f53d110).value) $a4346bb27070f751$var$metrics.nodes = $a4346bb27070f751$var$metrics.calculatedTargetDeltas = $a4346bb27070f751$var$metrics.calculatedProjections = 0;
                this.nodes.forEach($a4346bb27070f751$export$131f2f0cc5fe9609);
                this.nodes.forEach($a4346bb27070f751$var$resolveTargetDelta);
                this.nodes.forEach($a4346bb27070f751$var$calcProjection);
                this.nodes.forEach($a4346bb27070f751$export$c2664f37bc951031);
                if ((0, $37850638fe93a8b7$export$84ce9a476f53d110).addProjectionMetrics) (0, $37850638fe93a8b7$export$84ce9a476f53d110).addProjectionMetrics($a4346bb27070f751$var$metrics);
            };
            /**
             * Frame calculations
             */ this.resolvedRelativeTargetAt = 0.0;
            this.linkedParentVersion = 0;
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? [
                ...parent.path,
                parent
            ] : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            for(let i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, $4df37c6772413f6f$export$1465d17e3de78a96)();
        }
        addEventListener(name, handler) {
            if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, $450ebeef08659e3e$export$e7dff9482a5fd23c)());
            return this.eventHandlers.get(name).add(handler);
        }
        notifyListeners(name, ...args) {
            const subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager && subscriptionManager.notify(...args);
        }
        hasListeners(name) {
            return this.eventHandlers.has(name);
        }
        /**
         * Lifecycles
         */ mount(instance) {
            if (this.instance) return;
            this.isSVG = (0, $aaafa67702233fc7$export$17eda790a720ec57)(instance) && !(0, $9cc60b98e13c070e$export$66957ea77182581d)(instance);
            this.instance = instance;
            const { layoutId: layoutId, layout: layout, visualElement: visualElement } = this.options;
            if (visualElement && !visualElement.current) visualElement.mount(instance);
            this.root.nodes.add(this);
            this.parent && this.parent.children.add(this);
            if (this.root.hasTreeAnimated && (layout || layoutId)) this.isLayoutDirty = true;
            if (attachResizeListener) {
                let cancelDelay;
                let innerWidth = 0;
                const resizeUnblockUpdate = ()=>this.root.updateBlockedByResize = false;
                // Set initial innerWidth in a frame.read callback to batch the read
                (0, $f28d1a4d8c26f6e5$export$2cef06c20297c17d).read(()=>{
                    innerWidth = window.innerWidth;
                });
                attachResizeListener(instance, ()=>{
                    const newInnerWidth = window.innerWidth;
                    if (newInnerWidth === innerWidth) return;
                    innerWidth = newInnerWidth;
                    this.root.updateBlockedByResize = true;
                    cancelDelay && cancelDelay();
                    cancelDelay = (0, $cc1e1ac4b9ea470f$export$1391212d75b2ee65)(resizeUnblockUpdate, 250);
                    if ((0, $bdff0e3c701943d8$export$97db156a3ed1593b).hasAnimatedSinceResize) {
                        (0, $bdff0e3c701943d8$export$97db156a3ed1593b).hasAnimatedSinceResize = false;
                        this.nodes.forEach($a4346bb27070f751$var$finishAnimation);
                    }
                });
            }
            if (layoutId) this.root.registerSharedNode(layoutId, this);
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged, hasRelativeLayoutChanged: hasRelativeLayoutChanged, layout: newLayout })=>{
                if (this.isTreeAnimationBlocked()) {
                    this.target = undefined;
                    this.relativeTarget = undefined;
                    return;
                }
                // TODO: Check here if an animation exists
                const layoutTransition = this.options.transition || visualElement.getDefaultTransition() || $a4346bb27070f751$var$defaultLayoutTransition;
                const { onLayoutAnimationStart: onLayoutAnimationStart, onLayoutAnimationComplete: onLayoutAnimationComplete } = visualElement.getProps();
                /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ const hasTargetChanged = !this.targetLayout || !(0, $3d71933370253f8d$export$ef641b782d85522)(this.targetLayout, newLayout);
                /*
                     * Note: Disabled to fix relative animations always triggering new
                     * layout animations. If this causes further issues, we can try
                     * a different approach to detecting relative target changes.
                     */ // || hasRelativeLayoutChanged
                /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeLayoutChanged;
                if (this.options.layoutRoot || this.resumeFrom || hasOnlyRelativeTargetChanged || hasLayoutChanged && (hasTargetChanged || !this.currentAnimation)) {
                    if (this.resumeFrom) {
                        this.resumingFrom = this.resumeFrom;
                        this.resumingFrom.resumingFrom = undefined;
                    }
                    const animationOptions = {
                        ...(0, $3c7dca54dc1f20a3$export$7c1391340308742e)(layoutTransition, "layout"),
                        onPlay: onLayoutAnimationStart,
                        onComplete: onLayoutAnimationComplete
                    };
                    if (visualElement.shouldReduceMotion || this.options.layoutRoot) {
                        animationOptions.delay = 0;
                        animationOptions.type = false;
                    }
                    this.startAnimation(animationOptions);
                    /**
                         * Set animation origin after starting animation to avoid layout jump
                         * caused by stopping previous layout animation
                         */ this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged, animationOptions.path);
                } else {
                    /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never committed to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged) $a4346bb27070f751$var$finishAnimation(this);
                    if (this.isLead() && this.options.onExitComplete) this.options.onExitComplete();
                }
                this.targetLayout = newLayout;
            });
        }
        unmount() {
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            const stack = this.getStack();
            stack && stack.remove(this);
            this.parent && this.parent.children.delete(this);
            this.instance = undefined;
            this.eventHandlers.clear();
            (0, $f28d1a4d8c26f6e5$export$ec99c0ef4978dccb)(this.updateProjection);
        }
        // only on the root
        blockUpdate() {
            this.updateManuallyBlocked = true;
        }
        unblockUpdate() {
            this.updateManuallyBlocked = false;
        }
        isUpdateBlocked() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        }
        isTreeAnimationBlocked() {
            return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
        }
        // Note: currently only running on root node
        startUpdate() {
            if (this.isUpdateBlocked()) return;
            this.isUpdating = true;
            this.nodes && this.nodes.forEach($a4346bb27070f751$var$resetSkewAndRotation);
            this.animationId++;
        }
        getTransformTemplate() {
            const { visualElement: visualElement } = this.options;
            return visualElement && visualElement.getProps().transformTemplate;
        }
        willUpdate(shouldNotifyListeners = true) {
            this.root.hasTreeAnimated = true;
            if (this.root.isUpdateBlocked()) {
                this.options.onExitComplete && this.options.onExitComplete();
                return;
            }
            /**
             * If we're running optimised appear animations then these must be
             * cancelled before measuring the DOM. This is so we can measure
             * the true layout of the element rather than the WAAPI animation
             * which will be unaffected by the resetSkewAndRotate step.
             *
             * Note: This is a DOM write. Worst case scenario is this is sandwiched
             * between other snapshot reads which will cause unnecessary style recalculations.
             * This has to happen here though, as we don't yet know which nodes will need
             * snapshots in startUpdate(), but we only want to cancel optimised animations
             * if a layout animation measurement is actually going to be affected by them.
             */ if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear) $a4346bb27070f751$var$cancelTreeOptimisedTransformAnimations(this);
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty) return;
            this.isLayoutDirty = true;
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.shouldResetTransform = true;
                /**
                 * Percentage translates resolve against layoutBox dimensions,
                 * so ancestors with them must be re-measured after transform reset.
                 */ if (typeof node.latestValues.x === "string" || typeof node.latestValues.y === "string") node.isLayoutDirty = true;
                node.updateScroll("snapshot");
                if (node.options.layoutRoot) node.willUpdate(false);
            }
            const { layoutId: layoutId, layout: layout } = this.options;
            if (layoutId === undefined && !layout) return;
            const transformTemplate = this.getTransformTemplate();
            this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        }
        update() {
            this.updateScheduled = false;
            const updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                const wasBlockedByResize = this.updateBlockedByResize;
                this.unblockUpdate();
                this.updateBlockedByResize = false;
                this.clearAllSnapshots();
                /**
                 * When blocked by resize, still measure layouts so
                 * callbacks like onLayoutMeasure fire (e.g. Reorder).
                 * Skip notifyLayoutUpdate to prevent animations.
                 */ if (wasBlockedByResize) this.nodes.forEach($a4346bb27070f751$var$forceLayoutMeasure);
                this.nodes.forEach($a4346bb27070f751$var$clearMeasurements);
                return;
            }
            /**
             * If this is a repeat of didUpdate then ignore the animation.
             */ if (this.animationId <= this.animationCommitId) {
                this.nodes.forEach($a4346bb27070f751$var$clearIsLayoutDirty);
                return;
            }
            this.animationCommitId = this.animationId;
            if (!this.isUpdating) this.nodes.forEach($a4346bb27070f751$var$clearIsLayoutDirty);
            else {
                this.isUpdating = false;
                /**
                 * Ensure animation-blocked nodes (e.g. during drag)
                 * get measured even when memoized (willUpdate skipped).
                 */ this.nodes.forEach($a4346bb27070f751$var$ensureDraggedNodesSnapshotted);
                /**
                 * Write
                 */ this.nodes.forEach($a4346bb27070f751$var$resetTransformStyle);
                /**
                 * Read ==================
                 */ // Update layout measurements of updated children
                this.nodes.forEach($a4346bb27070f751$var$updateLayout);
                /**
                 * Write
                 */ // Notify listeners that the layout is updated
                this.nodes.forEach($a4346bb27070f751$var$notifyLayoutUpdate);
            }
            this.clearAllSnapshots();
            /**
             * Manually flush any pending updates. Ideally
             * we could leave this to the following requestAnimationFrame but this seems
             * to leave a flash of incorrectly styled content.
             */ const now = (0, $111e7cbe8a4123f4$export$2da9be4cfdb689b1).now();
            (0, $f28d1a4d8c26f6e5$export$fff89137e9e818ce).delta = (0, $c7d27346dbc155b2$export$7d15b64cf5a3a4c4)(0, 1000 / 60, now - (0, $f28d1a4d8c26f6e5$export$fff89137e9e818ce).timestamp);
            (0, $f28d1a4d8c26f6e5$export$fff89137e9e818ce).timestamp = now;
            (0, $f28d1a4d8c26f6e5$export$fff89137e9e818ce).isProcessing = true;
            (0, $f28d1a4d8c26f6e5$export$1811c3a7e3af92f0).update.process((0, $f28d1a4d8c26f6e5$export$fff89137e9e818ce));
            (0, $f28d1a4d8c26f6e5$export$1811c3a7e3af92f0).preRender.process((0, $f28d1a4d8c26f6e5$export$fff89137e9e818ce));
            (0, $f28d1a4d8c26f6e5$export$1811c3a7e3af92f0).render.process((0, $f28d1a4d8c26f6e5$export$fff89137e9e818ce));
            (0, $f28d1a4d8c26f6e5$export$fff89137e9e818ce).isProcessing = false;
        }
        didUpdate() {
            if (!this.updateScheduled) {
                this.updateScheduled = true;
                (0, $72c587626bccb82b$export$bb76eed83315504c).read(this.scheduleUpdate);
            }
        }
        clearAllSnapshots() {
            this.nodes.forEach($a4346bb27070f751$var$clearSnapshot);
            this.sharedNodes.forEach($a4346bb27070f751$var$removeLeadSnapshots);
        }
        scheduleUpdateProjection() {
            if (!this.projectionUpdateScheduled) {
                this.projectionUpdateScheduled = true;
                (0, $f28d1a4d8c26f6e5$export$2cef06c20297c17d).preRender(this.updateProjection, false, true);
            }
        }
        scheduleCheckAfterUnmount() {
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, $f28d1a4d8c26f6e5$export$2cef06c20297c17d).postRender(()=>{
                if (this.isLayoutDirty) this.root.didUpdate();
                else this.root.checkUpdateFailed();
            });
        }
        /**
         * Update measurements
         */ updateSnapshot() {
            if (this.snapshot || !this.instance) return;
            this.snapshot = this.measure();
            if (this.snapshot && !(0, $ec5f5eba7167d679$export$c1c127004b72a37)(this.snapshot.measuredBox.x) && !(0, $ec5f5eba7167d679$export$c1c127004b72a37)(this.snapshot.measuredBox.y)) this.snapshot = undefined;
        }
        updateLayout() {
            if (!this.instance) return;
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.updateScroll();
            }
            const prevLayout = this.layout;
            this.layout = this.measure(false);
            this.layoutVersion++;
            if (!this.layoutCorrected) this.layoutCorrected = (0, $536f8c4470f7cfa4$export$6459fc9e86be362e)();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.layoutBox);
            const { visualElement: visualElement } = this.options;
            visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : undefined);
        }
        updateScroll(phase = "measure") {
            let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
            if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) needsMeasurement = false;
            if (needsMeasurement && this.instance) {
                const isRoot = checkIsScrollRoot(this.instance);
                this.scroll = {
                    animationId: this.root.animationId,
                    phase: phase,
                    isRoot: isRoot,
                    offset: measureScroll(this.instance),
                    wasRoot: this.scroll ? this.scroll.isRoot : isRoot
                };
            }
        }
        resetTransform() {
            if (!resetTransform) return;
            const isResetRequested = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout;
            const hasProjection = this.projectionDelta && !(0, $3d71933370253f8d$export$a7ec7642fe550fb6)(this.projectionDelta);
            const transformTemplate = this.getTransformTemplate();
            const transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested && this.instance && (hasProjection || (0, $3b8111ac66a02336$export$a545127cf1fbb600)(this.latestValues) || transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        }
        measure(removeTransform = true) {
            const pageBox = this.measurePageBox();
            let layoutBox = this.removeElementScroll(pageBox);
            /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */ if (removeTransform) layoutBox = this.removeTransform(layoutBox);
            $a4346bb27070f751$var$roundBox(layoutBox);
            return {
                animationId: this.root.animationId,
                measuredBox: pageBox,
                layoutBox: layoutBox,
                latestValues: {},
                source: this.id
            };
        }
        measurePageBox() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return (0, $536f8c4470f7cfa4$export$6459fc9e86be362e)();
            const box = visualElement.measureViewportBox();
            const wasInScrollRoot = this.scroll?.wasRoot || this.path.some($a4346bb27070f751$var$checkNodeWasScrollRoot);
            if (!wasInScrollRoot) {
                // Remove viewport scroll to give page-relative coordinates
                const { scroll: scroll } = this.root;
                if (scroll) {
                    (0, $ee10a003285526dc$export$a807a5ce5ebb3895)(box.x, scroll.offset.x);
                    (0, $ee10a003285526dc$export$a807a5ce5ebb3895)(box.y, scroll.offset.y);
                }
            }
            return box;
        }
        removeElementScroll(box) {
            const boxWithoutScroll = (0, $536f8c4470f7cfa4$export$6459fc9e86be362e)();
            (0, $03c28f778a6c816a$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
            if (this.scroll?.wasRoot) return boxWithoutScroll;
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                const { scroll: scroll, options: options } = node;
                if (node !== this.root && scroll && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (scroll.wasRoot) (0, $03c28f778a6c816a$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
                    (0, $ee10a003285526dc$export$a807a5ce5ebb3895)(boxWithoutScroll.x, scroll.offset.x);
                    (0, $ee10a003285526dc$export$a807a5ce5ebb3895)(boxWithoutScroll.y, scroll.offset.y);
                }
            }
            return boxWithoutScroll;
        }
        applyTransform(box, transformOnly = false, output) {
            const withTransforms = output || (0, $536f8c4470f7cfa4$export$6459fc9e86be362e)();
            (0, $03c28f778a6c816a$export$c53fd88f45d77e4b)(withTransforms, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) {
                    (0, $ee10a003285526dc$export$a807a5ce5ebb3895)(withTransforms.x, -node.scroll.offset.x);
                    (0, $ee10a003285526dc$export$a807a5ce5ebb3895)(withTransforms.y, -node.scroll.offset.y);
                }
                if (!(0, $3b8111ac66a02336$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $ee10a003285526dc$export$58b16271041fbfb)(withTransforms, node.latestValues, node.layout?.layoutBox);
            }
            if ((0, $3b8111ac66a02336$export$a545127cf1fbb600)(this.latestValues)) (0, $ee10a003285526dc$export$58b16271041fbfb)(withTransforms, this.latestValues, this.layout?.layoutBox);
            return withTransforms;
        }
        removeTransform(box) {
            const boxWithoutTransform = (0, $536f8c4470f7cfa4$export$6459fc9e86be362e)();
            (0, $03c28f778a6c816a$export$c53fd88f45d77e4b)(boxWithoutTransform, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!(0, $3b8111ac66a02336$export$a545127cf1fbb600)(node.latestValues)) continue;
                let sourceBox;
                if (node.instance) {
                    (0, $3b8111ac66a02336$export$bdf30dca883ea463)(node.latestValues) && node.updateSnapshot();
                    sourceBox = (0, $536f8c4470f7cfa4$export$6459fc9e86be362e)();
                    (0, $03c28f778a6c816a$export$c53fd88f45d77e4b)(sourceBox, node.measurePageBox());
                }
                (0, $d38c11745f2935b3$export$73e1ad0a9694e25c)(boxWithoutTransform, node.latestValues, node.snapshot?.layoutBox, sourceBox);
            }
            if ((0, $3b8111ac66a02336$export$a545127cf1fbb600)(this.latestValues)) (0, $d38c11745f2935b3$export$73e1ad0a9694e25c)(boxWithoutTransform, this.latestValues);
            return boxWithoutTransform;
        }
        setTargetDelta(delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
            this.isProjectionDirty = true;
        }
        setOptions(options) {
            this.options = {
                ...this.options,
                ...options,
                crossfade: options.crossfade !== undefined ? options.crossfade : true
            };
        }
        clearMeasurements() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        }
        forceRelativeParentToResolveTarget() {
            if (!this.relativeParent) return;
            /**
             * If the parent target isn't up-to-date, force it to update.
             * This is an unfortunate de-optimisation as it means any updating relative
             * projection will cause all the relative parents to recalculate back
             * up the tree.
             */ if (this.relativeParent.resolvedRelativeTargetAt !== (0, $f28d1a4d8c26f6e5$export$fff89137e9e818ce).timestamp) this.relativeParent.resolveTargetDelta(true);
        }
        resolveTargetDelta(forceRecalculation = false) {
            /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */ const lead = this.getLead();
            this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
            this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
            this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */ const canSkip = !(forceRecalculation || isShared && this.isSharedProjectionDirty || this.isProjectionDirty || this.parent?.isProjectionDirty || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize);
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
            this.resolvedRelativeTargetAt = (0, $f28d1a4d8c26f6e5$export$fff89137e9e818ce).timestamp;
            const relativeParent = this.getClosestProjectingParent();
            if (relativeParent && this.linkedParentVersion !== relativeParent.layoutVersion && !relativeParent.options.layoutRoot) this.removeRelativeTarget();
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ if (!this.targetDelta && !this.relativeTarget) {
                if (this.options.layoutAnchor !== false && relativeParent && relativeParent.layout) this.createRelativeTarget(relativeParent, this.layout.layoutBox, relativeParent.layout.layoutBox);
                else this.removeRelativeTarget();
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
            /**
             * Lazy-init target data structure
             */ if (!this.target) {
                this.target = (0, $536f8c4470f7cfa4$export$6459fc9e86be362e)();
                this.targetWithTransforms = (0, $536f8c4470f7cfa4$export$6459fc9e86be362e)();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target) {
                this.forceRelativeParentToResolveTarget();
                (0, $ec5f5eba7167d679$export$426154f9d100f99)(this.target, this.relativeTarget, this.relativeParent.target, this.options.layoutAnchor || undefined);
            /**
                 * If we've only got a targetDelta, resolve it into a target
                 */ } else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) this.applyTransform(this.layout.layoutBox, false, this.target);
                else (0, $03c28f778a6c816a$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
                (0, $ee10a003285526dc$export$d80074982803af5c)(this.target, this.targetDelta);
            } else /**
                 * If no target, use own layout as target
                 */ (0, $03c28f778a6c816a$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                if (this.options.layoutAnchor !== false && relativeParent && Boolean(relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent.options.layoutScroll && relativeParent.target && this.animationProgress !== 1) this.createRelativeTarget(relativeParent, this.target, relativeParent.target);
                else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * Increase debug counter for resolved target deltas
             */ if ((0, $37850638fe93a8b7$export$84ce9a476f53d110).value) $a4346bb27070f751$var$metrics.calculatedTargetDeltas++;
        }
        getClosestProjectingParent() {
            if (!this.parent || (0, $3b8111ac66a02336$export$bdf30dca883ea463)(this.parent.latestValues) || (0, $3b8111ac66a02336$export$bf80f5f8f4dc327f)(this.parent.latestValues)) return undefined;
            if (this.parent.isProjecting()) return this.parent;
            else return this.parent.getClosestProjectingParent();
        }
        isProjecting() {
            return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
        }
        createRelativeTarget(relativeParent, layout, parentLayout) {
            this.relativeParent = relativeParent;
            this.linkedParentVersion = relativeParent.layoutVersion;
            this.forceRelativeParentToResolveTarget();
            this.relativeTarget = (0, $536f8c4470f7cfa4$export$6459fc9e86be362e)();
            this.relativeTargetOrigin = (0, $536f8c4470f7cfa4$export$6459fc9e86be362e)();
            (0, $ec5f5eba7167d679$export$2785bfcc929c5650)(this.relativeTargetOrigin, layout, parentLayout, this.options.layoutAnchor || undefined);
            (0, $03c28f778a6c816a$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
        }
        removeRelativeTarget() {
            this.relativeParent = this.relativeTarget = undefined;
        }
        calcProjection() {
            const lead = this.getLead();
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            let canSkip = true;
            /**
             * If this is a normal layout animation and neither this node nor its nearest projecting
             * is dirty then we can't skip.
             */ if (this.isProjectionDirty || this.parent?.isProjectionDirty) canSkip = false;
            /**
             * If this is a shared layout animation and this node's shared projection is dirty then
             * we can't skip.
             */ if (isShared && (this.isSharedProjectionDirty || this.isTransformDirty)) canSkip = false;
            /**
             * If we have resolved the target this frame we must recalculate the
             * projection to ensure it visually represents the internal calculations.
             */ if (this.resolvedRelativeTargetAt === (0, $f28d1a4d8c26f6e5$export$fff89137e9e818ce).timestamp) canSkip = false;
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation);
            if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
            if (!this.layout || !(layout || layoutId)) return;
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, $03c28f778a6c816a$export$c53fd88f45d77e4b)(this.layoutCorrected, this.layout.layoutBox);
            /**
             * Record previous tree scales before updating.
             */ const prevTreeScaleX = this.treeScale.x;
            const prevTreeScaleY = this.treeScale.y;
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, $ee10a003285526dc$export$e2a980535c55eabb)(this.layoutCorrected, this.treeScale, this.path, isShared);
            /**
             * If this layer needs to perform scale correction but doesn't have a target,
             * use the layout as the target.
             */ if (lead.layout && !lead.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1)) {
                lead.target = lead.layout.layoutBox;
                lead.targetWithTransforms = (0, $536f8c4470f7cfa4$export$6459fc9e86be362e)();
            }
            const { target: target } = lead;
            if (!target) {
                /**
                 * If we don't have a target to project into, but we were previously
                 * projecting, we want to remove the stored transform and schedule
                 * a render to ensure the elements reflect the removed transform.
                 */ if (this.prevProjectionDelta) {
                    this.createProjectionDeltas();
                    this.scheduleRender();
                }
                return;
            }
            if (!this.projectionDelta || !this.prevProjectionDelta) this.createProjectionDeltas();
            else {
                (0, $03c28f778a6c816a$export$8ead6a7d6b225ef)(this.prevProjectionDelta.x, this.projectionDelta.x);
                (0, $03c28f778a6c816a$export$8ead6a7d6b225ef)(this.prevProjectionDelta.y, this.projectionDelta.y);
            }
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, $ec5f5eba7167d679$export$c0d25e96fc67d310)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            if (this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY || !(0, $3d71933370253f8d$export$444620505e28fe92)(this.projectionDelta.x, this.prevProjectionDelta.x) || !(0, $3d71933370253f8d$export$444620505e28fe92)(this.projectionDelta.y, this.prevProjectionDelta.y)) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
            /**
             * Increase debug counter for recalculated projections
             */ if ((0, $37850638fe93a8b7$export$84ce9a476f53d110).value) $a4346bb27070f751$var$metrics.calculatedProjections++;
        }
        hide() {
            this.isVisible = false;
        // TODO: Schedule render
        }
        show() {
            this.isVisible = true;
        // TODO: Schedule render
        }
        scheduleRender(notifyAll = true) {
            this.options.visualElement?.scheduleRender();
            if (notifyAll) {
                const stack = this.getStack();
                stack && stack.scheduleRender();
            }
            if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
        }
        createProjectionDeltas() {
            this.prevProjectionDelta = (0, $536f8c4470f7cfa4$export$3d227df54007d73a)();
            this.projectionDelta = (0, $536f8c4470f7cfa4$export$3d227df54007d73a)();
            this.projectionDeltaWithTransform = (0, $536f8c4470f7cfa4$export$3d227df54007d73a)();
        }
        setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false, pathFn) {
            const snapshot = this.snapshot;
            const snapshotLatestValues = snapshot ? snapshot.latestValues : {};
            const mixedValues = {
                ...this.latestValues
            };
            const targetDelta = (0, $536f8c4470f7cfa4$export$3d227df54007d73a)();
            if (!this.relativeParent || !this.relativeParent.options.layoutRoot) this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            const relativeLayout = (0, $536f8c4470f7cfa4$export$6459fc9e86be362e)();
            const snapshotSource = snapshot ? snapshot.source : undefined;
            const layoutSource = this.layout ? this.layout.source : undefined;
            const isSharedLayoutAnimation = snapshotSource !== layoutSource;
            const stack = this.getStack();
            const isOnlyMember = !stack || stack.members.length <= 1;
            const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some($a4346bb27070f751$var$hasOpacityCrossfade));
            this.animationProgress = 0;
            let prevRelativeTarget;
            // The path decides whether the layout shift is worth curving
            // (distance floor) and resolves the interpolator from the delta.
            const interpolate = pathFn?.interpolateProjection(delta);
            this.mixTargetDelta = (latest)=>{
                const progress = latest / 1000;
                const point = interpolate?.(progress);
                if (point) {
                    targetDelta.x.translate = point.x;
                    targetDelta.x.scale = (0, $33875f370c178373$export$3bb0b4ff1037b8dd)(delta.x.scale, 1, progress);
                    targetDelta.x.origin = delta.x.origin;
                    targetDelta.x.originPoint = delta.x.originPoint;
                    targetDelta.y.translate = point.y;
                    targetDelta.y.scale = (0, $33875f370c178373$export$3bb0b4ff1037b8dd)(delta.y.scale, 1, progress);
                    targetDelta.y.origin = delta.y.origin;
                    targetDelta.y.originPoint = delta.y.originPoint;
                } else {
                    $a4346bb27070f751$var$mixAxisDeltaLinear(targetDelta.x, delta.x, progress);
                    $a4346bb27070f751$var$mixAxisDeltaLinear(targetDelta.y, delta.y, progress);
                }
                this.setTargetDelta(targetDelta);
                if (this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout) {
                    (0, $ec5f5eba7167d679$export$2785bfcc929c5650)(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox, this.options.layoutAnchor || undefined);
                    $a4346bb27070f751$export$6ffd3e6ae339a132(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress);
                    /**
                     * If this is an unchanged relative target we can consider the
                     * projection not dirty.
                     */ if (prevRelativeTarget && (0, $3d71933370253f8d$export$8d5cf76bb7daff09)(this.relativeTarget, prevRelativeTarget)) this.isProjectionDirty = false;
                    if (!prevRelativeTarget) prevRelativeTarget = (0, $536f8c4470f7cfa4$export$6459fc9e86be362e)();
                    (0, $03c28f778a6c816a$export$c53fd88f45d77e4b)(prevRelativeTarget, this.relativeTarget);
                }
                if (isSharedLayoutAnimation) {
                    this.animationValues = mixedValues;
                    (0, $329107cc959583cd$export$739e279c17d51c3d)(mixedValues, snapshotLatestValues, this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                if (point && point.rotate !== undefined) {
                    // Dedicated `pathRotation` channel, not `rotate`, so an
                    // animating `rotate` is composed with, never clobbered.
                    if (!this.animationValues) this.animationValues = mixedValues;
                    this.animationValues.pathRotation = point.rotate;
                }
                this.root.scheduleUpdateProjection();
                this.scheduleRender();
                this.animationProgress = progress;
            };
            this.mixTargetDelta(this.options.layoutRoot ? 1000 : 0);
        }
        startAnimation(options) {
            this.notifyListeners("animationStart");
            this.currentAnimation?.stop();
            this.resumingFrom?.currentAnimation?.stop();
            if (this.pendingAnimation) {
                (0, $f28d1a4d8c26f6e5$export$ec99c0ef4978dccb)(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, $f28d1a4d8c26f6e5$export$2cef06c20297c17d).update(()=>{
                (0, $bdff0e3c701943d8$export$97db156a3ed1593b).hasAnimatedSinceResize = true;
                (0, $3f382d8314d26340$export$d921fb2475e2900c).layout++;
                this.motionValue || (this.motionValue = (0, $fdf0a8816be57e7f$export$ce8bdc721e76545f)(0));
                this.motionValue.jump(0, false);
                this.currentAnimation = (0, $d7b4c1ec598d8531$export$335a17c977067b99)(this.motionValue, [
                    0,
                    1000
                ], {
                    ...options,
                    velocity: 0,
                    isSync: true,
                    onUpdate: (latest)=>{
                        this.mixTargetDelta(latest);
                        options.onUpdate && options.onUpdate(latest);
                    },
                    onStop: ()=>{
                        (0, $3f382d8314d26340$export$d921fb2475e2900c).layout--;
                    },
                    onComplete: ()=>{
                        (0, $3f382d8314d26340$export$d921fb2475e2900c).layout--;
                        options.onComplete && options.onComplete();
                        this.completeAnimation();
                    }
                });
                if (this.resumingFrom) this.resumingFrom.currentAnimation = this.currentAnimation;
                this.pendingAnimation = undefined;
            });
        }
        completeAnimation() {
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            const stack = this.getStack();
            stack && stack.exitAnimationComplete();
            this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
            this.notifyListeners("animationComplete");
        }
        finishAnimation() {
            if (this.currentAnimation) {
                this.mixTargetDelta && this.mixTargetDelta($a4346bb27070f751$var$animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        }
        applyTransformsToTarget() {
            const lead = this.getLead();
            let { targetWithTransforms: targetWithTransforms, target: target, layout: layout, latestValues: latestValues } = lead;
            if (!targetWithTransforms || !target || !layout) return;
            /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */ if (this !== lead && this.layout && layout && $a4346bb27070f751$var$shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                target = this.target || (0, $536f8c4470f7cfa4$export$6459fc9e86be362e)();
                const xLength = (0, $ec5f5eba7167d679$export$c1c127004b72a37)(this.layout.layoutBox.x);
                target.x.min = lead.target.x.min;
                target.x.max = target.x.min + xLength;
                const yLength = (0, $ec5f5eba7167d679$export$c1c127004b72a37)(this.layout.layoutBox.y);
                target.y.min = lead.target.y.min;
                target.y.max = target.y.min + yLength;
            }
            (0, $03c28f778a6c816a$export$c53fd88f45d77e4b)(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, $ee10a003285526dc$export$58b16271041fbfb)(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */ (0, $ec5f5eba7167d679$export$c0d25e96fc67d310)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        }
        registerSharedNode(layoutId, node) {
            if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, $443a9b7ba92194c5$export$39be5b2d82fc9dc7)());
            const stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            const config = node.options.initialPromotionConfig;
            node.promote({
                transition: config ? config.transition : undefined,
                preserveFollowOpacity: config && config.shouldPreserveFollowOpacity ? config.shouldPreserveFollowOpacity(node) : undefined
            });
        }
        isLead() {
            const stack = this.getStack();
            return stack ? stack.lead === this : true;
        }
        getLead() {
            const { layoutId: layoutId } = this.options;
            return layoutId ? this.getStack()?.lead || this : this;
        }
        getPrevLead() {
            const { layoutId: layoutId } = this.options;
            return layoutId ? this.getStack()?.prevLead : undefined;
        }
        getStack() {
            const { layoutId: layoutId } = this.options;
            if (layoutId) return this.root.sharedNodes.get(layoutId);
        }
        promote({ needsReset: needsReset, transition: transition, preserveFollowOpacity: preserveFollowOpacity } = {}) {
            const stack = this.getStack();
            if (stack) stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition) this.setOptions({
                transition: transition
            });
        }
        relegate() {
            const stack = this.getStack();
            if (stack) return stack.relegate(this);
            else return false;
        }
        resetSkewAndRotation() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return;
            // If there's no detected skew or rotation values, we can early return without a forced render.
            let hasDistortingTransform = false;
            /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */ const { latestValues: latestValues } = visualElement;
            if (latestValues.z || latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ || latestValues.skewX || latestValues.skewY) hasDistortingTransform = true;
            // If there's no distorting values, we don't need to do any more.
            if (!hasDistortingTransform) return;
            const resetValues = {};
            if (latestValues.z) $a4346bb27070f751$var$resetDistortingTransform("z", visualElement, resetValues, this.animationValues);
            // Check the skew and rotate value of all axes and reset to 0
            for(let i = 0; i < $a4346bb27070f751$var$transformAxes.length; i++){
                $a4346bb27070f751$var$resetDistortingTransform(`rotate${$a4346bb27070f751$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
                $a4346bb27070f751$var$resetDistortingTransform(`skew${$a4346bb27070f751$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
            }
            // Force a render of this element to apply the transform with all skews and rotations
            // set to 0.
            visualElement.render();
            // Put back all the values we reset
            for(const key in resetValues){
                visualElement.setStaticValue(key, resetValues[key]);
                if (this.animationValues) this.animationValues[key] = resetValues[key];
            }
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        }
        applyProjectionStyles(targetStyle, styleProp) {
            if (!this.instance || this.isSVG) return;
            if (!this.isVisible) {
                targetStyle.visibility = "hidden";
                return;
            }
            const transformTemplate = this.getTransformTemplate();
            if (this.needsReset) {
                this.needsReset = false;
                targetStyle.visibility = "";
                targetStyle.opacity = "";
                targetStyle.pointerEvents = (0, $23078a4ec1c4a1f0$export$fcc2206ecb6d74b)(styleProp?.pointerEvents) || "";
                targetStyle.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                return;
            }
            const lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                if (this.options.layoutId) {
                    targetStyle.opacity = this.latestValues.opacity !== undefined ? this.latestValues.opacity : 1;
                    targetStyle.pointerEvents = (0, $23078a4ec1c4a1f0$export$fcc2206ecb6d74b)(styleProp?.pointerEvents) || "";
                }
                if (this.hasProjected && !(0, $3b8111ac66a02336$export$a545127cf1fbb600)(this.latestValues)) {
                    targetStyle.transform = transformTemplate ? transformTemplate({}, "") : "none";
                    this.hasProjected = false;
                }
                return;
            }
            targetStyle.visibility = "";
            const valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            let transform = (0, $11a13b85fd48f8da$export$d33653b270fe725c)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) transform = transformTemplate(valuesToRender, transform);
            targetStyle.transform = transform;
            const { x: x, y: y } = this.projectionDelta;
            targetStyle.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
            if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ targetStyle.opacity = lead === this ? valuesToRender.opacity ?? this.latestValues.opacity ?? 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
            else /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */ targetStyle.opacity = lead === this ? valuesToRender.opacity !== undefined ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== undefined ? valuesToRender.opacityExit : 0;
            /**
             * Apply scale correction
             */ for(const key in 0, $af519f1fd2f08378$export$91ddd985b97788d1){
                if (valuesToRender[key] === undefined) continue;
                const { correct: correct, applyTo: applyTo, isCSSVariable: isCSSVariable } = (0, $af519f1fd2f08378$export$91ddd985b97788d1)[key];
                /**
                 * Only apply scale correction to the value if we have an
                 * active projection transform. Otherwise these values become
                 * vulnerable to distortion if the element changes size without
                 * a corresponding layout animation.
                 */ const corrected = transform === "none" ? valuesToRender[key] : correct(valuesToRender[key], lead);
                if (applyTo) {
                    const num = applyTo.length;
                    for(let i = 0; i < num; i++)targetStyle[applyTo[i]] = corrected;
                } else // If this is a CSS variable, set it directly on the instance.
                // Replacing this function from creating styles to setting them
                // would be a good place to remove per frame object creation
                if (isCSSVariable) this.options.visualElement.renderState.vars[key] = corrected;
                else targetStyle[key] = corrected;
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) targetStyle.pointerEvents = lead === this ? (0, $23078a4ec1c4a1f0$export$fcc2206ecb6d74b)(styleProp?.pointerEvents) || "" : "none";
        }
        clearSnapshot() {
            this.resumeFrom = this.snapshot = undefined;
        }
        // Only run on root
        resetTree() {
            this.root.nodes.forEach((node)=>node.currentAnimation?.stop());
            this.root.nodes.forEach($a4346bb27070f751$var$clearMeasurements);
            this.root.sharedNodes.clear();
        }
    };
}
function $a4346bb27070f751$var$updateLayout(node) {
    node.updateLayout();
}
function $a4346bb27070f751$var$notifyLayoutUpdate(node) {
    const snapshot = node.resumeFrom?.snapshot || node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        const { layoutBox: layout, measuredBox: measuredLayout } = node.layout;
        const { animationType: animationType } = node.options;
        const isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") (0, $2a7fbad2236ba94a$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $ec5f5eba7167d679$export$c1c127004b72a37)(axisSnapshot);
            axisSnapshot.min = layout[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if (animationType === "x" || animationType === "y") {
            const snapAxis = animationType === "x" ? "y" : "x";
            (0, $03c28f778a6c816a$export$a0230ae482601ae8)(isShared ? snapshot.measuredBox[snapAxis] : snapshot.layoutBox[snapAxis], layout[snapAxis]);
        } else if ($a4346bb27070f751$var$shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) (0, $2a7fbad2236ba94a$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $ec5f5eba7167d679$export$c1c127004b72a37)(layout[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
            /**
                 * Ensure relative target gets resized and rerendererd
                 */ if (node.relativeTarget && !node.currentAnimation) {
                node.isProjectionDirty = true;
                node.relativeTarget[axis].max = node.relativeTarget[axis].min + length;
            }
        });
        const layoutDelta = (0, $536f8c4470f7cfa4$export$3d227df54007d73a)();
        (0, $ec5f5eba7167d679$export$c0d25e96fc67d310)(layoutDelta, layout, snapshot.layoutBox);
        const visualDelta = (0, $536f8c4470f7cfa4$export$3d227df54007d73a)();
        if (isShared) (0, $ec5f5eba7167d679$export$c0d25e96fc67d310)(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        else (0, $ec5f5eba7167d679$export$c0d25e96fc67d310)(visualDelta, layout, snapshot.layoutBox);
        const hasLayoutChanged = !(0, $3d71933370253f8d$export$a7ec7642fe550fb6)(layoutDelta);
        let hasRelativeLayoutChanged = false;
        if (!node.resumeFrom) {
            const relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (relativeParent && !relativeParent.resumeFrom) {
                const { snapshot: parentSnapshot, layout: parentLayout } = relativeParent;
                if (parentSnapshot && parentLayout) {
                    const anchor = node.options.layoutAnchor || undefined;
                    const relativeSnapshot = (0, $536f8c4470f7cfa4$export$6459fc9e86be362e)();
                    (0, $ec5f5eba7167d679$export$2785bfcc929c5650)(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox, anchor);
                    const relativeLayout = (0, $536f8c4470f7cfa4$export$6459fc9e86be362e)();
                    (0, $ec5f5eba7167d679$export$2785bfcc929c5650)(relativeLayout, layout, parentLayout.layoutBox, anchor);
                    if (!(0, $3d71933370253f8d$export$ef641b782d85522)(relativeSnapshot, relativeLayout)) hasRelativeLayoutChanged = true;
                    if (relativeParent.options.layoutRoot) {
                        node.relativeTarget = relativeLayout;
                        node.relativeTargetOrigin = relativeSnapshot;
                        node.relativeParent = relativeParent;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeLayoutChanged: hasRelativeLayoutChanged
        });
    } else if (node.isLead()) {
        const { onExitComplete: onExitComplete } = node.options;
        onExitComplete && onExitComplete();
    }
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function $a4346bb27070f751$export$131f2f0cc5fe9609(node) {
    /**
     * Increase debug counter for nodes encountered this frame
     */ if ((0, $37850638fe93a8b7$export$84ce9a476f53d110).value) $a4346bb27070f751$var$metrics.nodes++;
    if (!node.parent) return;
    /**
     * If this node isn't projecting, propagate isProjectionDirty. It will have
     * no performance impact but it will allow the next child that *is* projecting
     * but *isn't* dirty to just check its parent to see if *any* ancestor needs
     * correcting.
     */ if (!node.isProjecting()) node.isProjectionDirty = node.parent.isProjectionDirty;
    /**
     * Propagate isSharedProjectionDirty and isTransformDirty
     * throughout the whole tree. A future revision can take another look at
     * this but for safety we still recalcualte shared nodes.
     */ node.isSharedProjectionDirty || (node.isSharedProjectionDirty = Boolean(node.isProjectionDirty || node.parent.isProjectionDirty || node.parent.isSharedProjectionDirty));
    node.isTransformDirty || (node.isTransformDirty = node.parent.isTransformDirty);
}
function $a4346bb27070f751$export$c2664f37bc951031(node) {
    node.isProjectionDirty = node.isSharedProjectionDirty = node.isTransformDirty = false;
}
function $a4346bb27070f751$var$clearSnapshot(node) {
    node.clearSnapshot();
}
function $a4346bb27070f751$var$clearMeasurements(node) {
    node.clearMeasurements();
}
function $a4346bb27070f751$var$forceLayoutMeasure(node) {
    node.isLayoutDirty = true;
    node.updateLayout();
}
function $a4346bb27070f751$var$clearIsLayoutDirty(node) {
    node.isLayoutDirty = false;
}
/**
 * When a node is animation-blocked (e.g. during drag) and its component
 * didn't re-render (memoized), willUpdate() is never called so there's
 * no snapshot. Use the previous layout as a snapshot and mark dirty so
 * resetTransform/updateLayout/notifyLayoutUpdate process it normally.
 */ function $a4346bb27070f751$var$ensureDraggedNodesSnapshotted(node) {
    if (node.isAnimationBlocked && node.layout && !node.isLayoutDirty) {
        node.snapshot = node.layout;
        node.isLayoutDirty = true;
    }
}
function $a4346bb27070f751$var$resetTransformStyle(node) {
    const { visualElement: visualElement } = node.options;
    if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) visualElement.notify("BeforeLayoutMeasure");
    node.resetTransform();
}
function $a4346bb27070f751$var$finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
    node.isProjectionDirty = true;
}
function $a4346bb27070f751$var$resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function $a4346bb27070f751$var$calcProjection(node) {
    node.calcProjection();
}
function $a4346bb27070f751$var$resetSkewAndRotation(node) {
    node.resetSkewAndRotation();
}
function $a4346bb27070f751$var$removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function $a4346bb27070f751$var$mixAxisDeltaLinear(output, delta, p) {
    output.translate = (0, $33875f370c178373$export$3bb0b4ff1037b8dd)(delta.translate, 0, p);
    output.scale = (0, $33875f370c178373$export$3bb0b4ff1037b8dd)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function $a4346bb27070f751$export$8f9f6b0c76c773c7(output, from, to, p) {
    output.min = (0, $33875f370c178373$export$3bb0b4ff1037b8dd)(from.min, to.min, p);
    output.max = (0, $33875f370c178373$export$3bb0b4ff1037b8dd)(from.max, to.max, p);
}
function $a4346bb27070f751$export$6ffd3e6ae339a132(output, from, to, p) {
    $a4346bb27070f751$export$8f9f6b0c76c773c7(output.x, from.x, to.x, p);
    $a4346bb27070f751$export$8f9f6b0c76c773c7(output.y, from.y, to.y, p);
}
function $a4346bb27070f751$var$hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
const $a4346bb27070f751$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
const $a4346bb27070f751$var$userAgentContains = (string)=>typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(string);
/**
 * Measured bounding boxes must be rounded in Safari and
 * left untouched in Chrome, otherwise non-integer layouts within scaled-up elements
 * can appear to jump.
 */ const $a4346bb27070f751$var$roundPoint = $a4346bb27070f751$var$userAgentContains("applewebkit/") && !$a4346bb27070f751$var$userAgentContains("chrome/") ? Math.round : (0, $518547564f355e33$export$8793edee2d425525);
function $a4346bb27070f751$var$roundAxis(axis) {
    // Round to the nearest .5 pixels to support subpixel layouts
    axis.min = $a4346bb27070f751$var$roundPoint(axis.min);
    axis.max = $a4346bb27070f751$var$roundPoint(axis.max);
}
function $a4346bb27070f751$var$roundBox(box) {
    $a4346bb27070f751$var$roundAxis(box.x);
    $a4346bb27070f751$var$roundAxis(box.y);
}
function $a4346bb27070f751$var$shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return animationType === "position" || animationType === "preserve-aspect" && !(0, $ec5f5eba7167d679$export$28d0384c4b79bde2)((0, $3d71933370253f8d$export$c5706146bc63213)(snapshot), (0, $3d71933370253f8d$export$c5706146bc63213)(layout), 0.2);
}
function $a4346bb27070f751$var$checkNodeWasScrollRoot(node) {
    return node !== node.root && node.scroll?.wasRoot;
}




const $5b09ac75b5e6a8e6$export$2d029a49a09b6177 = (0, $a4346bb27070f751$export$a84b61f69daa9da0)({
    attachResizeListener: (ref, notify)=>(0, $921c1cbb23e436b4$export$b1d829ddf82884aa)(ref, "resize", notify),
    measureScroll: ()=>({
            x: document.documentElement.scrollLeft || document.body?.scrollLeft || 0,
            y: document.documentElement.scrollTop || document.body?.scrollTop || 0
        }),
    checkIsScrollRoot: ()=>true
});


const $841e25639f5c7562$export$b91509fcf893b648 = {
    current: undefined
};
const $841e25639f5c7562$export$b61a9eb3dbde8858 = (0, $a4346bb27070f751$export$a84b61f69daa9da0)({
    measureScroll: (instance)=>({
            x: instance.scrollLeft,
            y: instance.scrollTop
        }),
    defaultParent: ()=>{
        if (!$841e25639f5c7562$export$b91509fcf893b648.current) {
            const documentNode = new (0, $5b09ac75b5e6a8e6$export$2d029a49a09b6177)({});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            $841e25639f5c7562$export$b91509fcf893b648.current = documentNode;
        }
        return $841e25639f5c7562$export$b91509fcf893b648.current;
    },
    resetTransform: (instance, value)=>{
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: (instance)=>Boolean(window.getComputedStyle(instance).position === "fixed")
});


const $8ee2ff021c4b535a$export$d7d5d435647ed5a0 = {
    pan: {
        Feature: (0, $1be04a0d843be2d0$export$b4f8f1ee75ce5859)
    },
    drag: {
        Feature: (0, $28c1c17ce2591278$export$5d97dc2872682820),
        ProjectionNode: (0, $841e25639f5c7562$export$b61a9eb3dbde8858),
        MeasureLayout: $43797e3e47d3582a$export$779f5fb01ad751cd
    }
};




function $d5c1cfecf9ff6f25$export$edc0ace9d5e7e842(elementOrSelector, options) {
    const elements = (0, $fddf2622f5e3077b$export$90ceba2564a894f8)(elementOrSelector);
    const gestureAbortController = new AbortController();
    const eventOptions = {
        passive: true,
        ...options,
        signal: gestureAbortController.signal
    };
    const cancel = ()=>gestureAbortController.abort();
    return [
        elements,
        eventOptions,
        cancel
    ];
}


function $44c428a9743b50cc$var$isValidHover(event) {
    return !(event.pointerType === "touch" || (0, $ce5887a2ddc4272e$export$1b3dd616664938e4)());
}
/**
 * Create a hover gesture. hover() is different to .addEventListener("pointerenter")
 * in that it has an easier syntax, filters out polyfilled touch events, interoperates
 * with drag gestures, and automatically removes the "pointerennd" event listener when the hover ends.
 *
 * @public
 */ function $44c428a9743b50cc$export$3f60957f5dbf3876(elementOrSelector, onHoverStart, options = {}) {
    const [elements, eventOptions, cancel] = (0, $d5c1cfecf9ff6f25$export$edc0ace9d5e7e842)(elementOrSelector, options);
    elements.forEach((element)=>{
        let isPressed = false;
        let deferredHoverEnd = false;
        let hoverEndCallback;
        const removePointerLeave = ()=>{
            element.removeEventListener("pointerleave", onPointerLeave);
        };
        const endHover = (event)=>{
            if (hoverEndCallback) {
                hoverEndCallback(event);
                hoverEndCallback = undefined;
            }
            removePointerLeave();
        };
        const onPointerUp = (event)=>{
            isPressed = false;
            window.removeEventListener("pointerup", onPointerUp);
            window.removeEventListener("pointercancel", onPointerUp);
            if (deferredHoverEnd) {
                deferredHoverEnd = false;
                endHover(event);
            }
        };
        const onPointerDown = ()=>{
            isPressed = true;
            window.addEventListener("pointerup", onPointerUp, eventOptions);
            window.addEventListener("pointercancel", onPointerUp, eventOptions);
        };
        const onPointerLeave = (leaveEvent)=>{
            if (leaveEvent.pointerType === "touch") return;
            if (isPressed) {
                deferredHoverEnd = true;
                return;
            }
            endHover(leaveEvent);
        };
        const onPointerEnter = (enterEvent)=>{
            if (!$44c428a9743b50cc$var$isValidHover(enterEvent)) return;
            deferredHoverEnd = false;
            const onHoverEnd = onHoverStart(element, enterEvent);
            if (typeof onHoverEnd !== "function") return;
            hoverEndCallback = onHoverEnd;
            element.addEventListener("pointerleave", onPointerLeave, eventOptions);
        };
        element.addEventListener("pointerenter", onPointerEnter, eventOptions);
        element.addEventListener("pointerdown", onPointerDown, eventOptions);
    });
    return cancel;
}



function $cc15e52ee567d9ef$var$handleHoverEvent(node, event, lifecycle) {
    const { props: props } = node;
    if (node.animationState && props.whileHover) node.animationState.setActive("whileHover", lifecycle === "Start");
    const eventName = "onHover" + lifecycle;
    const callback = props[eventName];
    if (callback) (0, $f28d1a4d8c26f6e5$export$2cef06c20297c17d).postRender(()=>callback(event, (0, $b5ad284edca80238$export$12f84bb882d06e1a)(event)));
}
class $cc15e52ee567d9ef$export$93a81ea037eac456 extends (0, $baf88f17ccf98c7a$export$6e91cf7616333d5) {
    mount() {
        const { current: current } = this.node;
        if (!current) return;
        this.unmount = (0, $44c428a9743b50cc$export$3f60957f5dbf3876)(current, (_element, startEvent)=>{
            $cc15e52ee567d9ef$var$handleHoverEvent(this.node, startEvent, "Start");
            return (endEvent)=>$cc15e52ee567d9ef$var$handleHoverEvent(this.node, endEvent, "End");
        });
    }
    unmount() {}
}




class $78ae3a229bdfd739$export$d4826db40d47595b extends (0, $baf88f17ccf98c7a$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.isActive = false;
    }
    onFocus() {
        let isFocusVisible = false;
        /**
         * If this element doesn't match focus-visible then don't
         * apply whileHover. But, if matches throws that focus-visible
         * is not a valid selector then in that browser outline styles will be applied
         * to the element by default and we want to match that behaviour with whileFocus.
         */ try {
            isFocusVisible = this.node.current.matches(":focus-visible");
        } catch (e) {
            isFocusVisible = true;
        }
        if (!isFocusVisible || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", true);
        this.isActive = true;
    }
    onBlur() {
        if (!this.isActive || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", false);
        this.isActive = false;
    }
    mount() {
        this.unmount = (0, $df67593b734d7628$export$a4627e546088548d)((0, $921c1cbb23e436b4$export$b1d829ddf82884aa)(this.node.current, "focus", ()=>this.onFocus()), (0, $921c1cbb23e436b4$export$b1d829ddf82884aa)(this.node.current, "blur", ()=>this.onBlur()));
    }
    unmount() {}
}




/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ const $456d1b3e0b8fea84$export$e841ada32ff745b = (parent, child)=>{
    if (!child) return false;
    else if (parent === child) return true;
    else return $456d1b3e0b8fea84$export$e841ada32ff745b(parent, child.parentElement);
};





const $2bb87a6a1fbf2d97$export$7987404a4e35b84b = new WeakSet();


/**
 * Filter out events that are not "Enter" keys.
 */ function $73b00902dd658932$var$filterEvents(callback) {
    return (event)=>{
        if (event.key !== "Enter") return;
        callback(event);
    };
}
function $73b00902dd658932$var$firePointerEvent(target, type) {
    target.dispatchEvent(new PointerEvent("pointer" + type, {
        isPrimary: true,
        bubbles: true
    }));
}
const $73b00902dd658932$export$4b5790288fe12a79 = (focusEvent, eventOptions)=>{
    const element = focusEvent.currentTarget;
    if (!element) return;
    const handleKeydown = $73b00902dd658932$var$filterEvents(()=>{
        if ((0, $2bb87a6a1fbf2d97$export$7987404a4e35b84b).has(element)) return;
        $73b00902dd658932$var$firePointerEvent(element, "down");
        const handleKeyup = $73b00902dd658932$var$filterEvents(()=>{
            $73b00902dd658932$var$firePointerEvent(element, "up");
        });
        const handleBlur = ()=>$73b00902dd658932$var$firePointerEvent(element, "cancel");
        element.addEventListener("keyup", handleKeyup, eventOptions);
        element.addEventListener("blur", handleBlur, eventOptions);
    });
    element.addEventListener("keydown", handleKeydown, eventOptions);
    /**
     * Add an event listener that fires on blur to remove the keydown events.
     */ element.addEventListener("blur", ()=>element.removeEventListener("keydown", handleKeydown), eventOptions);
};



/**
 * Filter out events that are not primary pointer events, or are triggering
 * while a Motion gesture is active.
 */ function $d9066d737c9fd29e$var$isValidPressEvent(event) {
    return (0, $054aea5116346b18$export$a4cf9c8a4b063a6e)(event) && !(0, $ce5887a2ddc4272e$export$1b3dd616664938e4)();
}
const $d9066d737c9fd29e$var$claimedPointerDownEvents = new WeakSet();
/**
 * Create a press gesture.
 *
 * Press is different to `"pointerdown"`, `"pointerup"` in that it
 * automatically filters out secondary pointer events like right
 * click and multitouch.
 *
 * It also adds accessibility support for keyboards, where
 * an element with a press gesture will receive focus and
 *  trigger on Enter `"keydown"` and `"keyup"` events.
 *
 * This is different to a browser's `"click"` event, which does
 * respond to keyboards but only for the `"click"` itself, rather
 * than the press start and end/cancel. The element also needs
 * to be focusable for this to work, whereas a press gesture will
 * make an element focusable by default.
 *
 * @public
 */ function $d9066d737c9fd29e$export$dbe9198142dace0c(targetOrSelector, onPressStart, options = {}) {
    const [targets, eventOptions, cancelEvents] = (0, $d5c1cfecf9ff6f25$export$edc0ace9d5e7e842)(targetOrSelector, options);
    const startPress = (startEvent)=>{
        const target = startEvent.currentTarget;
        if (!$d9066d737c9fd29e$var$isValidPressEvent(startEvent)) return;
        if ($d9066d737c9fd29e$var$claimedPointerDownEvents.has(startEvent)) return;
        (0, $2bb87a6a1fbf2d97$export$7987404a4e35b84b).add(target);
        if (options.stopPropagation) $d9066d737c9fd29e$var$claimedPointerDownEvents.add(startEvent);
        const onPressEnd = onPressStart(target, startEvent);
        const onPointerEnd = (endEvent, success)=>{
            window.removeEventListener("pointerup", onPointerUp);
            window.removeEventListener("pointercancel", onPointerCancel);
            if ((0, $2bb87a6a1fbf2d97$export$7987404a4e35b84b).has(target)) (0, $2bb87a6a1fbf2d97$export$7987404a4e35b84b).delete(target);
            if (!$d9066d737c9fd29e$var$isValidPressEvent(endEvent)) return;
            if (typeof onPressEnd === "function") onPressEnd(endEvent, {
                success: success
            });
        };
        const onPointerUp = (upEvent)=>{
            onPointerEnd(upEvent, target === window || target === document || options.useGlobalTarget || (0, $456d1b3e0b8fea84$export$e841ada32ff745b)(target, upEvent.target));
        };
        const onPointerCancel = (cancelEvent)=>{
            onPointerEnd(cancelEvent, false);
        };
        window.addEventListener("pointerup", onPointerUp, eventOptions);
        window.addEventListener("pointercancel", onPointerCancel, eventOptions);
    };
    targets.forEach((target)=>{
        const pointerDownTarget = options.useGlobalTarget ? window : target;
        pointerDownTarget.addEventListener("pointerdown", startPress, eventOptions);
        if ((0, $a9f5ee1e84ae0957$export$1b3bfaa9684536aa)(target)) {
            target.addEventListener("focus", (event)=>(0, $73b00902dd658932$export$4b5790288fe12a79)(event, eventOptions));
            if (!(0, $b69ffc823be5b99f$export$5f6976e2f961e8b7)(target) && !target.hasAttribute("tabindex")) target.tabIndex = 0;
        }
    });
    return cancelEvents;
}



function $c31d8ac99222e41b$var$handlePressEvent(node, event, lifecycle) {
    const { props: props } = node;
    if (node.current instanceof HTMLButtonElement && node.current.disabled) return;
    if (node.animationState && props.whileTap) node.animationState.setActive("whileTap", lifecycle === "Start");
    const eventName = "onTap" + (lifecycle === "End" ? "" : lifecycle);
    const callback = props[eventName];
    if (callback) (0, $f28d1a4d8c26f6e5$export$2cef06c20297c17d).postRender(()=>callback(event, (0, $b5ad284edca80238$export$12f84bb882d06e1a)(event)));
}
class $c31d8ac99222e41b$export$f026abdbba7f0c9e extends (0, $baf88f17ccf98c7a$export$6e91cf7616333d5) {
    mount() {
        const { current: current } = this.node;
        if (!current) return;
        const { globalTapTarget: globalTapTarget, propagate: propagate } = this.node.props;
        this.unmount = (0, $d9066d737c9fd29e$export$dbe9198142dace0c)(current, (_element, startEvent)=>{
            $c31d8ac99222e41b$var$handlePressEvent(this.node, startEvent, "Start");
            return (endEvent, { success: success })=>$c31d8ac99222e41b$var$handlePressEvent(this.node, endEvent, success ? "End" : "Cancel");
        }, {
            useGlobalTarget: globalTapTarget,
            stopPropagation: propagate?.tap === false
        });
    }
    unmount() {}
}



/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ const $52783e887ce4601a$var$observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ const $52783e887ce4601a$var$observers = new WeakMap();
const $52783e887ce4601a$var$fireObserverCallback = (entry)=>{
    const callback = $52783e887ce4601a$var$observerCallbacks.get(entry.target);
    callback && callback(entry);
};
const $52783e887ce4601a$var$fireAllObserverCallbacks = (entries)=>{
    entries.forEach($52783e887ce4601a$var$fireObserverCallback);
};
function $52783e887ce4601a$var$initIntersectionObserver({ root: root, ...options }) {
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!$52783e887ce4601a$var$observers.has(lookupRoot)) $52783e887ce4601a$var$observers.set(lookupRoot, {});
    const rootObservers = $52783e887ce4601a$var$observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver($52783e887ce4601a$var$fireAllObserverCallbacks, {
        root: root,
        ...options
    });
    return rootObservers[key];
}
function $52783e887ce4601a$export$b2bcd62fb7925aa5(element, options, callback) {
    const rootInteresectionObserver = $52783e887ce4601a$var$initIntersectionObserver(options);
    $52783e887ce4601a$var$observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return ()=>{
        $52783e887ce4601a$var$observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}


const $c1283771cafee117$var$thresholdNames = {
    some: 0,
    all: 1
};
class $c1283771cafee117$export$150851c8cc2f0c72 extends (0, $baf88f17ccf98c7a$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.hasEnteredView = false;
        this.isInView = false;
    }
    startObserver() {
        this.stopObserver?.();
        const { viewport: viewport = {} } = this.node.getProps();
        const { root: root, margin: rootMargin, amount: amount = "some", once: once } = viewport;
        const options = {
            root: root ? root.current : undefined,
            rootMargin: rootMargin,
            threshold: typeof amount === "number" ? amount : $c1283771cafee117$var$thresholdNames[amount]
        };
        const onIntersectionUpdate = (entry)=>{
            const { isIntersecting: isIntersecting } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */ if (this.isInView === isIntersecting) return;
            this.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && this.hasEnteredView) return;
            else if (isIntersecting) this.hasEnteredView = true;
            if (this.node.animationState) this.node.animationState.setActive("whileInView", isIntersecting);
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ const { onViewportEnter: onViewportEnter, onViewportLeave: onViewportLeave } = this.node.getProps();
            const callback = isIntersecting ? onViewportEnter : onViewportLeave;
            callback && callback(entry);
        };
        this.stopObserver = (0, $52783e887ce4601a$export$b2bcd62fb7925aa5)(this.node.current, options, onIntersectionUpdate);
    }
    mount() {
        this.startObserver();
    }
    update() {
        if (typeof IntersectionObserver === "undefined") return;
        const { props: props, prevProps: prevProps } = this.node;
        const hasOptionsChanged = [
            "amount",
            "margin",
            "root"
        ].some($c1283771cafee117$var$hasViewportOptionChanged(props, prevProps));
        if (hasOptionsChanged) this.startObserver();
    }
    unmount() {
        this.stopObserver?.();
        this.hasEnteredView = false;
        this.isInView = false;
    }
}
function $c1283771cafee117$var$hasViewportOptionChanged({ viewport: viewport = {} }, { viewport: prevViewport = {} } = {}) {
    return (name)=>viewport[name] !== prevViewport[name];
}


const $a46435c1e154ac53$export$e5b72898e5a201f1 = {
    inView: {
        Feature: (0, $c1283771cafee117$export$150851c8cc2f0c72)
    },
    tap: {
        Feature: (0, $c31d8ac99222e41b$export$f026abdbba7f0c9e)
    },
    focus: {
        Feature: (0, $78ae3a229bdfd739$export$d4826db40d47595b)
    },
    hover: {
        Feature: (0, $cc15e52ee567d9ef$export$93a81ea037eac456)
    }
};




const $f2d1729f079fc421$export$b3219800bda33a1f = {
    layout: {
        ProjectionNode: (0, $841e25639f5c7562$export$b61a9eb3dbde8858),
        MeasureLayout: $43797e3e47d3582a$export$779f5fb01ad751cd
    }
};


const $97e59e9b83870bbd$export$d596cd8841d25433 = {
    ...(0, $eb9271000c09ec39$export$7f9953c70dacfd7f),
    ...(0, $a46435c1e154ac53$export$e5b72898e5a201f1),
    ...(0, $8ee2ff021c4b535a$export$d7d5d435647ed5a0),
    ...(0, $f2d1729f079fc421$export$b3219800bda33a1f)
};


const $43985e09e2ba1586$export$e25e478948902b8b = /*@__PURE__*/ (0, $2caddd150a756909$export$a28d6df673050e18)((0, $97e59e9b83870bbd$export$d596cd8841d25433), (0, $2ed68384d46bf5e0$export$56ba0183203348f5));





var $8v0nu = parcelRequire("8v0nu");


var $8v0nu = parcelRequire("8v0nu");



"use strict";
"use client";
const { useRecipeResult: $bd1cd963a7426b0d$var$useRecipeResult, PropsProvider: $bd1cd963a7426b0d$var$PropsProvider } = (0, $aa5f4d03028a5427$export$e99ac154c18649c5)({
    key: "icon"
});
const $bd1cd963a7426b0d$export$f04a61298a47a40f = $8v0nu.forwardRef(function Icon2(props, ref) {
    const { styles: styles, className: className, props: otherProps } = $bd1cd963a7426b0d$var$useRecipeResult({
        asChild: !props.as,
        ...props
    });
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $4042601bfa1a9d25$export$7cd122d781af9fa4).svg, {
        ref: ref,
        focusable: false,
        "aria-hidden": "true",
        ...otherProps,
        css: [
            styles,
            props.css
        ],
        className: (0, $99474b193e949655$export$a274e22fb40f762e)(className, props.className)
    });
});
const $bd1cd963a7426b0d$export$36c42a57bca547a8 = $bd1cd963a7426b0d$var$PropsProvider;


/**
 * Creates a collecticons component.
 *
 * @param {function} creatorFn Function to create the collecticon.
 */ function $9138db1f951ed55c$export$7209ba2b0568490(creatorFn, iconSvgProps = {}) {
    const CollecticonChakra = (0, (/*@__PURE__*/$parcel$interopDefault($8v0nu))).forwardRef((props, ref)=>{
        const { title: title, fontSize: fontSize, meaningful: meaningful, ...rest } = props;
        const s = typeof fontSize !== 'undefined' ? fontSize : '1rem';
        const iconProps = {
            title: title,
            width: s,
            height: s,
            fill: 'currentColor',
            role: 'img',
            viewBox: '0 0 16 16',
            xmlns: 'http://www.w3.org/2000/svg',
            // By default icons are rendered decoratively (aria hidden true) Using
            // "meaningful" prop (together with a descriptive title) will enable the
            // icon to be understood by assistive technologies.
            'aria-hidden': !meaningful,
            ...iconSvgProps,
            ...rest
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($8v0nu))).createElement((0, $bd1cd963a7426b0d$export$f04a61298a47a40f), {
            ...iconProps,
            ref: ref
        }, (0, (/*@__PURE__*/$parcel$interopDefault($8v0nu))).createElement("svg", null, title && (0, (/*@__PURE__*/$parcel$interopDefault($8v0nu))).createElement("title", null, title), creatorFn(iconProps)));
    });
    CollecticonChakra.displayName = 'CollecticonChakra';
    return CollecticonChakra;
}
const $9138db1f951ed55c$export$fb146e0ebe1880c9 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M4 12v1h8v-1h1V4h-1V3H4v1H3v8zm3-5h2v2H7zm9 5v4h-4v-1H4v1H0v-4h1V4H0V0h4v1h8V0h4v4h-1v8z'
    })));
const $9138db1f951ed55c$export$4d7881fd068b9554 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M12 12H5.414l9.607-9.607L13.607.979 4 10.586V4H2v10h10z'
    })));
const $9138db1f951ed55c$export$ff31736f1164b93d = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M12 4v6.586L2.393.979.979 2.393 10.586 12H4v2h10V4z'
    })));
const $9138db1f951ed55c$export$bab927fca1b80a3 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M13.586 7.586 9 12.172V0H7v12.172L2.414 7.586 1 9l7 7 7-7z'
    })));
const $9138db1f951ed55c$export$7c84e7446b64c8ba = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M8.414 13.586 3.828 9H16V7H3.828l4.586-4.586L7 1 0 8l7 7z'
    })));
const $9138db1f951ed55c$export$669f6b165f77f8e7 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M6 4H3.528q.112-.121.228-.244C4.891 2.625 6.397 2 8 2s3.109.625 4.244 1.756A5.97 5.97 0 0 1 14 8h2a8 8 0 0 0-8-8 7.98 7.98 0 0 0-6 2.709V0H0v6h6zm4 8h2.472q-.112.122-.228.244C11.109 13.375 9.603 14 8 14s-3.109-.625-4.244-1.756A5.97 5.97 0 0 1 2 8H0a8 8 0 0 0 8 8 7.98 7.98 0 0 0 6-2.709V16h2v-6h-6z'
    })));
const $9138db1f951ed55c$export$d4555cec95ec110c = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M7.5 1.924 5.773 3.651l-.712-.712L8 0l2.939 2.939-.712.712L8.5 1.924V7.5h5.576l-1.727-1.727.712-.712L16 8l-2.939 2.939-.712-.712L14.076 8.5H8.5v5.576l1.727-1.727.712.712L8 16l-2.939-2.939.712-.712L7.5 14.076V8.5H1.924l1.727 1.727-.712.712L0 8l2.939-2.939.712.712L1.924 7.5H7.5z'
    })));
const $9138db1f951ed55c$export$4337670c5d4a46ab = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M16 11a4 4 0 0 0-4-4H3.828l2.586-2.586L5 3 0 8l5 5 1.414-1.414L3.828 9H12a2 2 0 0 1 2 2v3h2z'
    })));
const $9138db1f951ed55c$export$404215554288eeeb = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M14.238 5.762A5.96 5.96 0 0 0 10 4H3.828l2.586-2.586L5 0 0 5l5 5 1.414-1.414L3.828 6H10c1.063 0 2.066.418 2.824 1.176S14 8.937 14 10s-.418 2.066-1.176 2.824A3.97 3.97 0 0 1 10 14H6v2h4c1.597 0 3.102-.626 4.238-1.762S16 11.597 16 10s-.626-3.102-1.762-4.238'
    })));
const $9138db1f951ed55c$export$45ced6d791f6eabf = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M0 0h2v2.709A7.98 7.98 0 0 1 8 0a8 8 0 0 1 8 8 8 8 0 0 1-8 8 8 8 0 0 1-8-8h2c0 1.603.624 3.11 1.756 4.244A5.96 5.96 0 0 0 8 14a5.97 5.97 0 0 0 4.244-1.756A5.97 5.97 0 0 0 14 8a5.97 5.97 0 0 0-1.756-4.244A5.97 5.97 0 0 0 8 2a5.97 5.97 0 0 0-4.472 2H6v2H0zm10.784 4.916 1.485 1.337L7.1 12 3.856 8.794l1.406-1.422 1.754 1.731z'
    })));
const $9138db1f951ed55c$export$d30f3c1f95f9e187 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M7.586 2.414 12.172 7H0v2h12.172l-4.586 4.586L9 15l7-7-7-7z'
    })));
const $9138db1f951ed55c$export$d33a98b6c97f9bcf = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M0 0v6h6V4H3.528q.11-.127.228-.244C4.891 2.625 6.397 2 8 2s3.109.625 4.244 1.756C13.375 4.891 14 6.397 14 8s-.625 3.109-1.756 4.244A5.97 5.97 0 0 1 8 14v2c4.419 0 8-3.581 8-8s-3.581-8-8-8a7.98 7.98 0 0 0-6 2.709V0z'
    })));
const $9138db1f951ed55c$export$65b63483548348e7 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M14 0v2.709A7.98 7.98 0 0 0 8 0C3.581 0 0 3.581 0 8s3.581 8 8 8v-2a5.97 5.97 0 0 1-4.244-1.756C2.625 11.109 2 9.603 2 8s.625-3.109 1.756-4.244C4.891 2.625 6.397 2 8 2a5.97 5.97 0 0 1 4.472 2H10v2h6V0z'
    })));
const $9138db1f951ed55c$export$1e31cff672fc44e7 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M0 0v6h6V4H3.528q.11-.127.228-.244C4.891 2.625 6.397 2 8 2s3.109.625 4.244 1.756C13.375 4.891 14 6.397 14 8s-.625 3.109-1.756 4.244C11.109 13.375 9.603 14 8 14s-3.112-.622-4.244-1.756S2 9.603 2 8H0c0 4.419 3.581 8 8 8s8-3.581 8-8-3.581-8-8-8a7.98 7.98 0 0 0-6 2.709V0z'
    })));
const $9138db1f951ed55c$export$8b2c6a502c5588cb = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M14 0v2.709A7.98 7.98 0 0 0 8 0C3.581 0 0 3.581 0 8s3.581 8 8 8 8-3.581 8-8h-2c0 1.603-.625 3.109-1.756 4.244S9.603 14 8 14s-3.109-.625-4.244-1.756C2.625 11.109 2 9.603 2 8s.625-3.109 1.756-4.244C4.891 2.625 6.397 2 8 2a5.97 5.97 0 0 1 4.472 2H10v2h6V0z'
    })));
const $9138db1f951ed55c$export$e18c7fe3ad046317 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M4 12V5.414l9.607 9.607 1.414-1.414L5.414 4H12V2H2v10z'
    })));
const $9138db1f951ed55c$export$c59521707fa9adf4 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M4 4h6.586L.979 13.607l1.414 1.414L12 5.414V12h2V2H4z'
    })));
const $9138db1f951ed55c$export$44382674197c7e20 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M2.414 8.414 7 3.828V16h2V3.828l4.586 4.586L15 7 8 0 1 7z'
    })));
const $9138db1f951ed55c$export$6d44efda105760b1 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M13 9V6.5c0-2.306-1.759-4.222-4-4.472V1.5a1 1 0 1 0-2 0v.528c-2.241.25-4 2.166-4 4.472V9c0 1.103-.897 2-2 2v2h14v-2c-1.103 0-2-.897-2-2m-5 6.5c.931 0 1.716-.638 1.938-1.5H6.062A2 2 0 0 0 8 15.5'
    })));
const $9138db1f951ed55c$export$67ac5bddd7c814c4 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M8 3a3.001 3.001 0 0 0-6 0h2c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1H0v2h5c1.656 0 3-1.344 3-3m4-2a4 4 0 0 0-4 4v1h2V5c0-1.103.897-2 2-2s2 .897 2 2-.897 2-2 2H1v2h11.5v-.031A4.001 4.001 0 0 0 12 1m-3 9H2v2h7c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1H6a3.001 3.001 0 0 0 6 0c0-1.656-1.344-3-3-3'
    })));
const $9138db1f951ed55c$export$bd738f28ecacfb4c = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M9 1H3v14h6a4.001 4.001 0 0 0 2.645-7A4.001 4.001 0 0 0 9 1M8 9a2 2 0 0 1 0 4H6V9zm0-6a2 2 0 0 1 0 4H6V3z'
    })));
const $9138db1f951ed55c$export$32797ac8ba9dbc26 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M5 12h9V0H9v6L7 4 5 6V0H4C2.9 0 2 .9 2 2v12c0 1.1.9 2 2 2h10v-2H5c-.6 0-1-.4-1-1s.4-1 1-1'
    })));
const $9138db1f951ed55c$export$f27e10809e8ad7c = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M5 12h9V0H4C2.9 0 2 .9 2 2v12c0 1.1.9 2 2 2h10v-2H5c-.6 0-1-.4-1-1s.4-1 1-1M5 2h7v2H5z'
    })));
const $9138db1f951ed55c$export$8619dc02de403f24 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M5.304 15.028c-.996.112-1.699-.432-2.397-1.038-.999-.867-1.615-2.159-.782-3.171.807-.98 2.412-1.22 2.412-1.22s-1.957.258-3.175-.826C.74 8.22.392 7.497.305 6.66.194 5.584.013 3.383 0 2.57c-.014-.918.335-1.533.941-1.6C2.394.808 4.1 2.175 5.757 4.195 7.369 6.159 8 7.548 8 7.548s.631-1.389 2.243-3.353C11.9 2.175 13.606.808 15.058.97c.607.067.956.682.942 1.6-.013.813-.194 3.014-.305 4.09-.087.837-.435 1.56-1.056 2.113-1.219 1.084-3.176.826-3.176.826s1.605.24 2.412 1.22c.833 1.012.217 2.304-.782 3.171-.698.606-1.401 1.15-2.397 1.038C8.883 14.825 8 11.448 8 11.448s-.883 3.377-2.696 3.58'
    })));
const $9138db1f951ed55c$export$a7cf23fc039bccca = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M12.042 0h-8v2h8zM10.87 11.828C10.114 12.584 9.111 13 8.042 13s-2.072-.416-2.828-1.172S4.042 10.069 4.042 9s.416-2.072 1.172-2.828S6.973 5 8.042 5s2.072.416 2.828 1.172A4 4 0 0 1 11.917 8h2.041a6 6 0 1 0 0 2h-2.041a4 4 0 0 1-1.047 1.828'
    })));
const $9138db1f951ed55c$export$3fd46276f478a1b0 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M9.053 13.581c-.003-.322.084-.6.219-.891-.288.253-.403.541-.506.931.028-.456.25-3.45.25-3.6.766-2.188.425-8.722 1.4-9.534C9.291.691 8.913 1.841 8.55 2.753 8.194 1.681 8.475 1 7.294.625c.944.8.756 1.491.95 2.594-.566-.734-.391-1.65-1.041-2.4-.184-.191-.797-.657-.797-.657 0 .028.491 1.009.581 1.528.091.519.306 1.556.275 1.938.079 2.119.613 4.172.979 6.25.059.353.244 1.391.244 1.391l.04.431c-.066-.284-.125-.541-.163-.65-.106-.312-.366-1.103-.428-1.431-.89-1.832-2.518-5.419-4.693-5.95C4.475 4.763 5.803 6.206 6.1 7.6c-.663-.931-3.269-2.919-4.328-3.644 1.997 2.072 3.6 4.219 5.337 6.522.503.653 1.131 1.978 1.178 2.278.034.222.075 1.05.1 1.559-.972-2.344-1.506-3.534-3.297-4.587-.306-.162-1.256-.491-1.256-.491.431.475.959.5 1.353 1.166-.815-.534-1.662-.628-2.593-.659 2.991 1.547 4.606 1.978 5.616 4.95.081.487-.041.856-.032 1.306h.669c-.003-.316.003-.616 0-.678.031-.206.041-.831.131-1.022.312-.794.819-1.169 1.525-1.631-.641.206-.962.128-1.45.912m2.944-7.003c-.247.234-.978 1.162-.978 1.162.044-1.312.372-2.719 1.209-3.7-1.163.762-1.822 2.644-2.125 3.794-.119.463-1.497 3.144-.856 4.584.125-.525.422-1.038.75-1.487.153-.203.794-1.228 1.438-2.688.566-1.469 1.491-2.328 2.8-3.056-.985.151-1.548.719-2.238 1.391'
    })));
const $9138db1f951ed55c$export$dd983756265c5ba0 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M15 0H1a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h7.178c-.009-.45.113-.819.031-1.306-1.009-2.972-2.625-3.403-5.616-4.95.931.031 1.778.125 2.594.659-.393-.665-.921-.69-1.353-1.165 0 0 .95.328 1.256.491 1.791 1.053 2.325 2.244 3.297 4.587-.025-.509-.066-1.337-.1-1.559-.047-.3-.675-1.625-1.178-2.278-1.737-2.303-3.341-4.45-5.338-6.522C2.831 4.681 5.438 6.669 6.1 7.6c-.297-1.394-1.625-2.837-2.859-3.931 2.175.531 3.803 4.119 4.693 5.95.062.328.322 1.119.428 1.431.038.109.097.366.163.65l-.041-.431S8.3 10.231 8.24 9.878c-.366-2.078-.9-4.131-.978-6.25.031-.381-.184-1.419-.275-1.938S6.406.19 6.406.162c0 0 .613.466.797.656.65.75.475 1.666 1.041 2.4-.194-1.102-.006-1.793-.95-2.593 1.181.375.9 1.056 1.256 2.128.363-.913.741-2.062 1.866-2.266-.975.812-.634 7.347-1.4 9.534 0 .15-.222 3.144-.25 3.6.103-.391.219-.678.506-.931-.134.291-.222.569-.219.891.488-.784.809-.706 1.45-.913-.706.462-1.212.837-1.525 1.631-.091.191-.1.816-.131 1.022.003.062-.003.359 0 .675H15a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1m-3.566 8.244c-.644 1.459-1.284 2.484-1.438 2.688-.328.45-.625.962-.75 1.488-.641-1.441.738-4.122.856-4.584.303-1.15.962-3.031 2.125-3.794-.837.981-1.166 2.387-1.209 3.7 0 0 .731-.928.978-1.162.691-.672 1.253-1.241 2.238-1.391-1.309.727-2.234 1.586-2.8 3.055'
    })));
const $9138db1f951ed55c$export$c9ea3985d0020928 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M8.011 3.76 4.005 6.317 8.01 8.874 4.005 11.43 0 8.852l4.005-2.557L0 3.76l4.005-2.557zm-4.027 8.48 4.005-2.557 4.005 2.557-4.005 2.557zm4.027-3.388 4.005-2.557L8.011 3.76l3.984-2.557L16 3.76l-4.005 2.557L16 8.874l-4.005 2.557z'
    })));
const $9138db1f951ed55c$export$834c92baa9723134 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M15.117 0H.883A.883.883 0 0 0 0 .883v14.234c0 .488.395.883.883.883h7.664V9.812H6.469V7.391h2.078V5.608c0-2.067 1.262-3.192 3.106-3.192.883 0 1.642.066 1.863.095v2.16l-1.271.001c-1.003 0-1.197.477-1.197 1.176v1.543h2.398l-.312 2.422h-2.086V16h4.07a.88.88 0 0 0 .882-.883V.883A.883.883 0 0 0 15.117 0'
    })));
const $9138db1f951ed55c$export$d8149c9a6ffff702 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M0 8a3.5 3.5 0 1 0 7 0 3.5 3.5 0 0 0-7 0m9 0a3.5 3.5 0 1 0 7 0 3.5 3.5 0 0 0-7 0'
    })));
const $9138db1f951ed55c$export$68cfb6157bb0630 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        fillRule: 'evenodd',
        d: 'M7.999 0a8 8 0 0 0-2.528 15.591c.4.073.546-.174.546-.386 0-.19-.007-.693-.011-1.361-2.225.483-2.695-1.072-2.695-1.072-.364-.924-.888-1.17-.888-1.17-.726-.496.055-.486.055-.486.803.057 1.225.824 1.225.824.714 1.223 1.872.87 2.328.665.073-.517.279-.87.508-1.069-1.776-.202-3.644-.888-3.644-3.954 0-.873.312-1.587.823-2.147-.081-.202-.356-1.016.08-2.117 0 0 .672-.215 2.2.82A7.7 7.7 0 0 1 8 3.869a7.7 7.7 0 0 1 2.003.269c1.527-1.035 2.198-.82 2.198-.82.436 1.101.162 1.915.08 2.117.513.559.822 1.273.822 2.147 0 3.073-1.87 3.75-3.653 3.948.287.247.543.735.543 1.481 0 1.069-.01 1.932-.01 2.195 0 .214.144.463.55.385A8 8 0 0 0 7.999 0',
        clipRule: 'evenodd'
    })));
const $9138db1f951ed55c$export$41b74980cc97582d = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M14.544 7.272V5.816h-1.456v1.456h-1.453v1.453h1.456v1.456h1.459V8.725H16V7.272zm-9.453 0v1.747h2.891c-.116.75-.872 2.197-2.887 2.197-1.737 0-3.156-1.441-3.156-3.216s1.416-3.216 3.153-3.216c.991 0 1.653.422 2.031.784L8.504 4.24c-.888-.831-2.038-1.331-3.41-1.331a5.09 5.09 0 1 0-.003 10.182c2.941 0 4.887-2.066 4.887-4.975a4.7 4.7 0 0 0-.081-.844z'
    })));
const $9138db1f951ed55c$export$eabd4486e49012ba = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M7.734 0c.334.184 1.469.938 1.469 2.297 0 1.203-1.941 4.791-1.188 5.722l4.812-6s1.197 1.456.478 2.688c-.747 1.281-2.588 2.781-3.325 3.897-.456.69-.234 1.059-.234 1.059l5.834-3.194s.469 1.391-.641 2.391c-1.172 1.056-3.931 1.475-3.931 2.575h4.006s-.409 1.216-1.184 1.384c-.684.15-2.144-.247-2.831.372C10.271 13.847 9.456 16 7.015 16c-1.641 0-2.912-1.184-3.703-2.738-.913-1.797-1.938-2.663-2.991-2.881 0 0 .575-1.359 2.088-1.359 2.081 0 2.972 3.409 4.544 3.409.453 0 .934-.234.934-.903 0-.725-1.044-1.325-1.334-1.525-.691-.481-1.244-1.247-.888-2.531z'
    })));
const $9138db1f951ed55c$export$b32786cce09df9e0 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M0 14.462h2.518V4.963H0zM0 3.83h2.518V1.538H0zm15.756 1.769a5.7 5.7 0 0 0-.916-2.074 4.24 4.24 0 0 0-2.189-1.629q-.794-.261-1.988-.279H5.124v12.845h5.538q2.913 0 4.308-2.396Q16 10.288 16 7.725q0-1.01-.244-2.126m-2.894 4.758q-.75 1.874-2.653 1.874H7.73V3.847h2.479q1.833 0 2.448 1.05t.615 3.011q0 1.422-.41 2.449'
    })));
const $9138db1f951ed55c$export$c85efb9e6a50791b = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M8 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8m0 6c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2m3-10H5C2.237 0 0 2.237 0 5v6c0 2.762 2.237 5 5 5h6a5 5 0 0 0 5-5V5c0-2.763-2.238-5-5-5m3 11c0 1.653-1.347 3-3 3H5c-1.653 0-3-1.347-3-3V5c0-1.653 1.347-3 3-3h6c1.653 0 3 1.347 3 3zm-2-8a1 1 0 1 0 0 2 1 1 0 1 0 0-2'
    })));
const $9138db1f951ed55c$export$4238e97612e0856e = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M3.997 12.445c2.072 0 3.059-.972 3.059-.972L6.469 9.88s-.953 1.062-2.381 1.062c-1.266 0-2.162-1.1-2.162-2.859 0-2.253 1.138-3.059 2.253-3.059 1.613 0 2.125 1.044 2.566 2.381l.588 1.831c.588 1.778 1.688 3.206 4.856 3.206 2.272 0 3.812-.697 3.812-2.528 0-1.484-.844-2.253-2.419-2.622l-1.172-.256c-.806-.184-1.044-.512-1.044-1.062 0-.622.494-.991 1.3-.991.878 0 1.356.331 1.428 1.119l1.831-.219c-.147-1.65-1.284-2.328-3.153-2.328-1.65 0-3.262.622-3.262 2.622 0 1.247.606 2.034 2.125 2.4l1.247.294c.934.219 1.247.606 1.247 1.137 0 .678-.659.953-1.906.953-1.85 0-2.622-.972-3.059-2.309L8.556 6.82c-.765-2.384-1.994-3.262-4.431-3.262C1.428 3.558 0 5.261 0 8.158c0 2.784 1.428 4.287 3.997 4.287'
    })));
const $9138db1f951ed55c$export$a2e102bc44d355e3 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M14.815 0H1.18C.53 0 0 .517 0 1.153v13.694C0 15.485.53 16 1.18 16h13.636c.651 0 1.184-.515 1.184-1.153V1.153C16 .517 15.467 0 14.815 0M4.746 13.634H2.371V5.999h2.376zM3.559 4.955a1.376 1.376 0 1 1-.001-2.753 1.376 1.376 0 0 1 .001 2.753m10.074 8.679h-2.371V9.922c0-.886-.017-2.025-1.233-2.025-1.235 0-1.423.964-1.423 1.96v3.778H6.235V5.999h2.274v1.043h.033c.317-.6 1.091-1.233 2.245-1.233 2.401 0 2.845 1.581 2.845 3.638z'
    })));
const $9138db1f951ed55c$export$435e172f1afd8f3 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M0 0v16h16V0zm13.292 3.791-.858.823a.25.25 0 0 0-.095.241V10.9a.25.25 0 0 0 .095.241l.838.823v.181H9.057v-.181l.868-.843c.085-.085.085-.11.085-.241V5.993l-2.414 6.13h-.325l-2.81-6.13v4.109a.57.57 0 0 0 .156.472l1.129 1.37v.181H2.544v-.181l1.129-1.37a.55.55 0 0 0 .146-.472V5.351A.42.42 0 0 0 3.683 5L2.679 3.791V3.61h3.116l2.409 5.283 2.118-5.283h2.971v.181z'
    })));
const $9138db1f951ed55c$export$b3ee3fb5dcd7cd96 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M11 5 9 7V4L8 3 7 4v3L5 5H0v6h5l2-2v4h2V9l2 2h5V5zm-9 5H1V6h1zm2 0H3V6h1zm9 0h-1V6h1zm2 0h-1V6h1z'
    })));
const $9138db1f951ed55c$export$f01132691dc82ba2 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M15.239 9.03q.068-.487.069-.992c0-4.036-3.29-7.309-7.347-7.309a7.3 7.3 0 0 0-1.183.096A4.384 4.384 0 0 0 .706 6.886a7 7 0 0 0-.091 1.152c0 4.037 3.288 7.309 7.346 7.309.458 0 .904-.045 1.337-.123a4.384 4.384 0 0 0 6.701-3.724 4.36 4.36 0 0 0-.76-2.47m-6.591 4.395c-2.335.122-3.427-.395-4.428-1.334-1.118-1.049-.669-2.245.242-2.306.91-.061 1.456 1.032 1.942 1.335.485.303 2.331.993 3.306-.122 1.062-1.213-.706-1.841-2.002-2.031-1.85-.274-4.186-1.275-4.004-3.247S5.379 2.738 6.95 2.595c2.002-.182 3.306.303 4.337 1.183 1.192 1.017.547 2.153-.212 2.244-.757.092-1.607-1.671-3.275-1.698-1.72-.027-2.882 1.79-.759 2.306s4.398.728 5.218 2.669c.819 1.942-1.274 4.004-3.611 4.126'
    })));
const $9138db1f951ed55c$export$8b71514e84056695 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M0 10.111c0 .925.756 1.681 1.681 1.681s1.681-.756 1.681-1.681V8.43H1.681C.756 8.43 0 9.186 0 10.111m16-4.222c0-.925-.756-1.681-1.681-1.681s-1.681.756-1.681 1.681V7.57h1.681c.925 0 1.681-.756 1.681-1.681M10.111 7.57c.925 0 1.681-.756 1.681-1.681V1.681C11.792.756 11.036 0 10.111 0S8.43.756 8.43 1.681v4.208c0 .925.756 1.681 1.681 1.681m-4.222.86c-.925 0-1.681.756-1.681 1.681v4.208c0 .925.756 1.681 1.681 1.681s1.681-.756 1.681-1.681v-4.208c0-.925-.756-1.681-1.681-1.681m0-4.222H1.681C.756 4.208 0 4.964 0 5.889S.756 7.57 1.681 7.57h4.208c.925 0 1.681-.756 1.681-1.681s-.756-1.681-1.681-1.681m0-4.208c-.925 0-1.681.756-1.681 1.681s.756 1.681 1.681 1.681H7.57V1.681C7.57.756 6.814 0 5.889 0m8.43 8.43h-4.208c-.925 0-1.681.756-1.681 1.681s.756 1.681 1.681 1.681h4.208c.925 0 1.681-.756 1.681-1.681s-.756-1.681-1.681-1.681m-4.208 4.208H8.43v1.681c0 .925.756 1.681 1.681 1.681s1.681-.756 1.681-1.681-.756-1.681-1.681-1.681'
    })));
const $9138db1f951ed55c$export$4eeeb34c908b13d0 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M2.035 7.791a.097.097 0 0 0-.094.094L1.8 9.638l.141 1.694a.094.094 0 0 0 .094.091c.05 0 .091-.041.094-.091l.159-1.694-.159-1.754c-.004-.056-.044-.093-.094-.093m.641.112a.11.11 0 0 0-.107.106l-.134 1.626.134 1.71a.11.11 0 0 0 .106.106.11.11 0 0 0 .106-.106l.15-1.71-.149-1.626a.11.11 0 0 0-.106-.106m.643-1.031a.123.123 0 0 0-.122.119l-.125 2.644.125 1.71a.123.123 0 0 0 .122.119.123.123 0 0 0 .122-.119l.141-1.71-.141-2.645a.125.125 0 0 0-.122-.118M1.4 7.85c-.044 0-.075.034-.081.078l-.15 1.707.15 1.644a.08.08 0 0 0 .081.078c.041 0 .075-.034.081-.078l.169-1.644-.168-1.707c-.007-.047-.038-.078-.082-.078m-1.219.831c-.034 0-.059.025-.066.063L0 9.635l.116.875a.065.065 0 0 0 .066.063c.031 0 .059-.025.063-.063l.138-.875-.139-.888c-.003-.041-.031-.066-.063-.066m.591-.55c-.034 0-.063.028-.066.066L.55 9.635l.156 1.407c.003.038.031.066.066.066.034 0 .063-.025.066-.066l.178-1.407-.178-1.438c-.003-.038-.032-.066-.066-.066m3.185-1.869a.137.137 0 0 0-.134.134l-.116 3.248.116 1.697a.137.137 0 0 0 .134.134.137.137 0 0 0 .134-.134l.131-1.697-.131-3.247a.135.135 0 0 0-.134-.135m3.448-.859q-.05-.034-.113-.035c-.063-.001-.078.013-.109.034a.2.2 0 0 0-.094.169v.038l-.075 4.026.078 1.635v.006a.2.2 0 0 0 .047.122.2.2 0 0 0 .156.075.2.2 0 0 0 .141-.059.22.22 0 0 0 .063-.144l.009-.163.078-1.469-.085-4.067a.24.24 0 0 0-.096-.168m6.629 2.134c-.269 0-.528.053-.763.153a3.473 3.473 0 0 0-3.46-3.166c-.444 0-.878.088-1.26.234-.149.057-.187.116-.19.232v6.248a.23.23 0 0 0 .213.225h5.457a1.964 1.964 0 1 0 .003-3.926M6.617 6.031a.193.193 0 0 0-.191.188l-.084 3.416.084 1.644a.191.191 0 0 0 .382 0l.094-1.644-.094-3.417a.19.19 0 0 0-.191-.187m1.456-1.013a.2.2 0 0 0-.109-.031q-.08.002-.138.05a.24.24 0 0 0-.081.166v.022l-.087 4.413.044.816.044.794c0 .119.1.216.216.216a.216.216 0 0 0 .216-.216v.003l.097-1.61-.098-4.435a.21.21 0 0 0-.104-.188m-2.125.897a.175.175 0 0 0-.175.175l-.094 3.545.094 1.653c.003.097.078.175.175.175s.172-.078.175-.175l.103-1.653-.103-3.548a.176.176 0 0 0-.175-.172m-.666-.081a.166.166 0 0 0-.163.163l-.1 3.638.1 1.669c.003.091.075.159.163.159s.159-.072.163-.159l.113-1.669-.113-3.639a.165.165 0 0 0-.163-.162m-.659.134a.15.15 0 0 0-.15.147l-.11 3.52.109 1.682c.003.081.069.147.15.147s.144-.066.15-.147l.122-1.682-.121-3.52a.154.154 0 0 0-.15-.147'
    })));
const $9138db1f951ed55c$export$cb0b56e133ef23a1 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M11.212 11.359 4.23 9.891l.294-1.396 6.981 1.468zm.409-1.799L5.154 6.548l.602-1.293 6.468 3.012zm.806-1.619L6.944 3.375l.913-1.096 5.483 4.565zM9.338.852 10.483 0l4.258 5.725-1.145.852zm1.872 12.305H4.102v-1.422h7.108zm2.843-2.843h-1.421v4.264H2.681v-4.264H1.259V16h12.794z'
    })));
const $9138db1f951ed55c$export$e582f877f685c307 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M9.707 15.997c-3.396 0-4.687-2.503-4.687-4.274V6.496H3.412V4.43C5.83 3.555 6.421 1.368 6.552.118A.13.13 0 0 1 6.667 0H9.01v4.074h3.199v2.421H8.995v4.98c.009.669.25 1.581 1.472 1.581h.059c.422-.012.99-.137 1.29-.278l.772 2.284c-.291.425-1.6.915-2.771.937h-.119c0-.002.009-.002.009-.002'
    })));
const $9138db1f951ed55c$export$f26b4f060f08f8f9 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M16 3.038a6.6 6.6 0 0 1-1.885.517 3.3 3.3 0 0 0 1.443-1.816 6.6 6.6 0 0 1-2.085.797 3.283 3.283 0 0 0-5.594 2.993 9.32 9.32 0 0 1-6.766-3.43A3.3 3.3 0 0 0 .669 3.75c0 1.139.579 2.144 1.46 2.732a3.3 3.3 0 0 1-1.486-.411v.041a3.286 3.286 0 0 0 2.633 3.219 3.3 3.3 0 0 1-1.483.057 3.29 3.29 0 0 0 3.066 2.28 6.6 6.6 0 0 1-4.86 1.359 9.3 9.3 0 0 0 5.032 1.475c6.038 0 9.34-5.002 9.34-9.34a9 9 0 0 0-.01-.425A6.7 6.7 0 0 0 16 3.038'
    })));
const $9138db1f951ed55c$export$c07c7d541b672534 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M2.096 1.031h2.188l9.658 12.914h-2.187zM.039 0l6.177 8.26L0 14.975h1.399l5.443-5.879 4.397 5.879H16L9.475 6.251 15.261 0h-1.399L8.85 5.415 4.8 0z'
    })));
const $9138db1f951ed55c$export$5e55219a763bfc51 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M6.364 10.379V5.621L10.545 8zm9.302-6.255A2.01 2.01 0 0 0 14.251 2.7C13.003 2.364 8 2.364 8 2.364s-5.003 0-6.251.336A2.01 2.01 0 0 0 .334 4.124C0 5.38 0 8 0 8s0 2.62.334 3.876A2.01 2.01 0 0 0 1.749 13.3c1.248.336 6.251.336 6.251.336s5.003 0 6.251-.336a2.01 2.01 0 0 0 1.415-1.424C16 10.62 16 8 16 8s0-2.62-.334-3.876'
    })));
const $9138db1f951ed55c$export$3f241c3fc4d9dd7a = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M6 2h4v1h2V2c0-1.1-.9-2-2-2H6C4.9 0 4 .9 4 2v1h2zM0 14c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V8H0zm7-5h2v1a1 1 0 1 1-2 0zm8-5H1c-.55 0-1 .45-1 1v2h16V5c0-.55-.45-1-1-1'
    })));
const $9138db1f951ed55c$export$7e0d7941fbd8a620 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M11.5 0H10v3H9V1H5V0H3.5v3h-1V1H1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h4.341A6 6 0 0 1 5 11H2V5h10c1 0 1.393.368 2 .72V2a1 1 0 0 0-1-1h-1.5z'
    }), $8v0nu.createElement("path", {
        d: 'M16 11a5 5 0 1 1-10.001-.001A5 5 0 0 1 16 11m-7.5.625h5v-1.25h-5z'
    })));
const $9138db1f951ed55c$export$8266db1827cb2822 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M11.5 0H10v3H9V1H5V0H3.5v3h-1V1H1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h4.341A6 6 0 0 1 5 11H2V5h10c1 0 1.393.368 2 .72V2a1 1 0 0 0-1-1h-1.5z'
    }), $8v0nu.createElement("path", {
        d: 'M16 11a5 5 0 1 1-10 0 5 5 0 0 1 10 0m-5.625-2.5v1.875H8.5v1.25h1.875V13.5h1.25v-1.875H13.5v-1.25h-1.875V8.5z'
    })));
const $9138db1f951ed55c$export$16c0cbaf2c55e7b6 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M15 15H1a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h1v2h3V2h6v2h3V2h1a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1m-1-9H2v7h12zm-5 6H7v-2h2zm-3 0H4v-2h2zm6-3h-2V7h2zM9 9H7V7h2zM4 3H3V.494C3 .222 3.222 0 3.497 0h.009C3.778 0 4 .222 4 .494zm9 0h-1V.494c0-.272.222-.494.497-.494h.009c.272 0 .494.222.494.494z'
    })));
const $9138db1f951ed55c$export$edaa4810f882e615 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M6 7H4v2h2zm9-5h-1v2h-3V2H5v2H2V2H1a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1m-1 11H2V6h12zM4 .494A.495.495 0 0 0 3.506 0h-.009A.496.496 0 0 0 3 .494V3h1zm9 0A.495.495 0 0 0 12.506 0h-.009A.496.496 0 0 0 12 .494V3h1z',
        style: {
            fillRule: 'nonzero'
        }
    })));
const $9138db1f951ed55c$export$af3433002e85528f = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M6 7H4v2h2zm0 3H4v2h2zm3-3H7v2h2zm0 3H7v2h2zm3-3h-2v2h2zm0 3h-2v2h2zm3-8h-1v2h-3V2H5v2H2V2H1a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1m-1 11H2V6h12zM4 .494A.495.495 0 0 0 3.506 0h-.009A.496.496 0 0 0 3 .494V3h1zm9 0A.495.495 0 0 0 12.506 0h-.009A.496.496 0 0 0 12 .494V3h1z'
    })));
const $9138db1f951ed55c$export$ebaef9cfe20e1737 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M6 8.5c0 1.103.897 2 2 2s2-.897 2-2-.897-2-2-2-2 .897-2 2M15 3h-3.5c-.25-1-.5-2-1.5-2H6C5 1 4.75 2 4.5 3H1c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1m-7 9.5a4 4 0 1 1 0-8 4 4 0 0 1 0 8'
    })));
const $9138db1f951ed55c$export$e71f7b946c7cc127 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M16 14v2H0v-2zm-5-9v8H9V5zm4-4v12h-2V1zM3 9v4H1V9zm4-6v10H5V3z'
    })));
const $9138db1f951ed55c$export$51e1bcc8c9b70cf = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M16 14v2H0v-2zm-2.708-9.61A1.499 1.499 0 0 1 14.5 2a1.5 1.5 0 0 1 0 3l-.052-.001-3.74 5.611A1.499 1.499 0 0 1 9.5 13a1.5 1.5 0 0 1-1.249-2.33L5.626 6.995a2 2 0 0 1-.252 0L2.749 10.67a1.5 1.5 0 1 1-1.123-.665L4.251 6.33a1.5 1.5 0 1 1 2.498 0l2.625 3.675a2 2 0 0 1 .178-.004z'
    })));
const $9138db1f951ed55c$export$acdc8ffe67b5cfdc = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M7 9h7c-.05 3.913-3.167 7-7 7-3.863 0-7-3.137-7-7s3.137-7 7-7zm9-2H9V0l1.41.142C13.576.793 15.962 3.577 16 7'
    })));
const $9138db1f951ed55c$export$c99fa69b6fe4cbfa = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M12.586 4.586 8 9.172 3.414 4.586 2 6l6 6 6-6z'
    })));
const $9138db1f951ed55c$export$d24fe4633d517542 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M12.586 6.586 8 11.172 3.414 6.586 2 8l6 6 6-6zM8.172 8.828h-.344l-.25-.25h.844zm.5-.5H7.328l-.25-.25h1.844zm.5-.5H6.828l-.25-.25h2.844zm.5-.5H6.328l-.25-.25h3.844zm.5-.5H5.828l-.25-.25h4.844zm.5-.5H5.328l-.25-.25h2.828L8 6.172l.094-.094h2.828zm-3.016-.5H4.828l-.25-.25h2.828zm3.516 0H8.344l.25-.25h2.828zm-4.016-.5H4.328l-.25-.25h2.828zm4.516 0H8.844l.25-.25h2.828zm-5.016-.5H3.828l-.25-.25h2.828zm5.516 0H9.344l.25-.25h2.828zm-6.016-.5H3.328l-.25-.25h2.828zm6.516 0H9.844l.25-.25h2.828zm-7.016-.5H2.828l-.25-.25h2.828zm7.516 0h-2.828l.25-.25h2.828zm-8.016-.5H2.328l-.25-.25h2.828zm8.516 0h-2.828l.25-.25h2.828zm-9.016-.5H2.172l.25-.25h1.984zm9.172 0h-2.484l.25-.25h1.984zm-9.672-.5H2.672l.242-.242h1zm9.172 0h-1.484l.242-.242h1zm-9.664-.492h-.5l.25-.25zm9.172 0h-.5l.25-.25z'
    })));
const $9138db1f951ed55c$export$6be9a9d30ce9b0ed = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M14.586 3.586 8 10.172 1.414 3.586 0 5l8 8 8-8z'
    })));
const $9138db1f951ed55c$export$5257c06aa807f52c = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M11.414 12.586 6.828 8l4.586-4.586L10 2 4 8l6 6z'
    })));
const $9138db1f951ed55c$export$bd98fc092ca567ad = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M9.414 12.586 4.828 8l4.586-4.586L8 2 2 8l6 6zM7.172 8.172v-.344l.25-.25v.844zm.5.5V7.328l.25-.25v1.844zm.5.5V6.828l.25-.25v2.844zm.5.5V6.328l.25-.25v3.844zm.5.5V5.828l.25-.25v4.844zm.5.5V5.328l.25-.25v2.828L9.828 8l.094.094v2.828zm.5-3.016V4.828l.25-.25v2.828zm0 3.516V8.344l.25.25v2.828zm.5-4.016V4.328l.25-.25v2.828zm0 4.516V8.844l.25.25v2.828zm.5-5.016V3.828l.25-.25v2.828zm0 5.516V9.344l.25.25v2.828zm.5-6.016V3.328l.25-.25v2.828zm0 6.516V9.844l.25.25v2.828zm.5-7.016V2.828l.25-.25v2.828zm0 7.516v-2.828l.25.25v2.828zm.5-8.016V2.328l.25-.25v2.828zm0 8.516v-2.828l.25.25v2.828zm.5-9.016V2.172l.25.25v1.984zm0 9.172v-2.484l.25.25v1.984zm.5-9.672V2.672l.242.242v1zm0 9.172v-1.484l.242.242v1zm.492-9.664v-.5l.25.25zm0 9.172v-.5l.25.25z'
    })));
const $9138db1f951ed55c$export$87375f63e1783ecd = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M12.414 14.586 5.828 8l6.586-6.586L11 0 3 8l8 8z'
    })));
const $9138db1f951ed55c$export$1871f85e3a28ae2d = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M4.586 3.414 9.172 8l-4.586 4.586L6 14l6-6-6-6z'
    })));
const $9138db1f951ed55c$export$5bb5160993ff67f0 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M6.586 3.414 11.172 8l-4.586 4.586L8 14l6-6-6-6zm2.242 4.414v.344l-.25.25v-.844zm-.5-.5v1.344l-.25.25V7.078zm-.5-.5v2.344l-.25.25V6.578zm-.5-.5v3.344l-.25.25V6.078zm-.5-.5v4.344l-.25.25V5.578zm-.5-.5v5.344l-.25.25V8.094L6.172 8l-.094-.094V5.078zm-.5 3.016v2.828l-.25.25V8.594zm0-3.516v2.828l-.25-.25V4.578zm-.5 4.016v2.828l-.25.25V9.094zm0-4.516v2.828l-.25-.25V4.078zm-.5 5.016v2.828l-.25.25V9.594zm0-5.516v2.828l-.25-.25V3.578zm-.5 6.016v2.828l-.25.25v-2.828zm0-6.516v2.828l-.25-.25V3.078zm-.5 7.016v2.828l-.25.25v-2.828zm0-7.516v2.828l-.25-.25V2.578zm-.5 8.016v2.828l-.25.25v-2.828zm0-8.516v2.828l-.25-.25V2.078zm-.5 9.016v2.484l-.25-.25v-1.984zm0-9.172v2.484l-.25-.25V2.422zm-.5 9.672v1.484l-.242-.242v-1zm0-9.172v1.484l-.242-.242v-1zm-.492 9.664v.5l-.25-.25zm0-9.172v.5l-.25-.25z'
    })));
const $9138db1f951ed55c$export$f98cf460e7941c2b = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M3.586 1.414 10.172 8l-6.586 6.586L5 16l8-8-8-8z'
    })));
const $9138db1f951ed55c$export$61133413a12a7ef4 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M2 15h2V1H2zM14.4 2.4 13 1 6 8l7 7 1.4-1.4L8.8 8z'
    })));
const $9138db1f951ed55c$export$e4779f93e989d6cc = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M14 1h-2v14h2zM7.2 8l-5.6 5.6L3 15l7-7-7-7-1.4 1.4z'
    })));
const $9138db1f951ed55c$export$66e62118032befb3 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M3.414 11.414 8 6.828l4.586 4.586L14 10 8 4l-6 6z'
    })));
const $9138db1f951ed55c$export$ef1b2d050d1d9596 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M3.414 9.414 8 4.828l4.586 4.586L14 8 8 2 2 8zm4.414-2.242h.344l.25.25h-.844zm-.5.5h1.344l.25.25H7.078zm-.5.5h2.344l.25.25H6.578zm-.5.5h3.344l.25.25H6.078zm-.5.5h4.344l.25.25H5.578zm-.5.5h5.344l.25.25H8.094L8 9.828l-.094.094H5.078zm3.016.5h2.828l.25.25H8.594zm-3.516 0h2.828l-.25.25H4.578zm4.016.5h2.828l.25.25H9.094zm-4.516 0h2.828l-.25.25H4.078zm5.016.5h2.828l.25.25H9.594zm-5.516 0h2.828l-.25.25H3.578zm6.016.5h2.828l.25.25h-2.828zm-6.516 0h2.828l-.25.25H3.078zm7.016.5h2.828l.25.25h-2.828zm-7.516 0h2.828l-.25.25H2.578zm8.016.5h2.828l.25.25h-2.828zm-8.516 0h2.828l-.25.25H2.078zm9.016.5h2.484l-.25.25h-1.984zm-9.172 0h2.484l-.25.25H2.422zm9.672.5h1.484l-.242.242h-1zm-9.172 0h1.484l-.242.242h-1zm9.664.492h.5l-.25.25zm-9.172 0h.5l-.25.25z'
    })));
const $9138db1f951ed55c$export$cd6ea45e6c6fa795 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M1.414 12.414 8 5.828l6.586 6.586L16 11 8 3l-8 8z'
    })));
const $9138db1f951ed55c$export$f72e08a2ef494448 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M7 9h2V4H7zm2 2a1 1 0 1 0-2 0 1 1 0 1 0 2 0m7-3c0-4.419-3.581-8-8-8S0 3.581 0 8s3.581 8 8 8 8-3.581 8-8m-2 0a5.97 5.97 0 0 1-1.756 4.244C11.109 13.375 9.603 14 8 14s-3.109-.625-4.244-1.756C2.625 11.109 2 9.603 2 8s.625-3.109 1.756-4.244C4.891 2.625 6.397 2 8 2s3.109.625 4.244 1.756A5.97 5.97 0 0 1 14 8'
    })));
const $9138db1f951ed55c$export$543083732c6741d9 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M0 8c0 4.419 3.581 8 8 8s8-3.581 8-8-3.581-8-8-8-8 3.581-8 8m12.891 3.478L4.522 3.109A5.97 5.97 0 0 1 8 2c1.603 0 3.109.625 4.244 1.756A5.97 5.97 0 0 1 14 8a5.97 5.97 0 0 1-1.109 3.478M2 8c0-1.266.391-2.469 1.109-3.478l8.369 8.369A5.97 5.97 0 0 1 8 14a5.97 5.97 0 0 1-4.244-1.756A5.97 5.97 0 0 1 2 8'
    })));
const $9138db1f951ed55c$export$5ec4aa1366cd882 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M7 12h2V7H7zm1-8a1 1 0 1 0 0 2 1 1 0 0 0 0-2m0-4a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.243 12.243C11.109 13.376 9.603 14 8 14s-3.109-.624-4.243-1.757C2.624 11.109 2 9.603 2 8s.624-3.109 1.757-4.243C4.891 2.624 6.397 2 8 2s3.109.624 4.243 1.757A5.96 5.96 0 0 1 14 8a5.96 5.96 0 0 1-1.757 4.243'
    })));
const $9138db1f951ed55c$export$e356a46c6dfa0cd = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M8 0C3.581 0 0 3.581 0 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8m4.244 12.244C11.109 13.375 9.603 14 8 14s-3.109-.625-4.244-1.756A5.97 5.97 0 0 1 2 8c0-1.603.625-3.109 1.756-4.244C4.891 2.625 6.397 2 8 2s3.109.625 4.244 1.756A5.97 5.97 0 0 1 14 8a5.97 5.97 0 0 1-1.756 4.244M5 11h2V5H5zm4 0h2V5H9z'
    })));
const $9138db1f951ed55c$export$f251922d9c0b7d86 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'm5 11 4-3-4-3zM8 0C3.581 0 0 3.581 0 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8m4.244 12.244C11.109 13.375 9.603 14 8 14s-3.109-.625-4.244-1.756A5.97 5.97 0 0 1 2 8c0-1.603.625-3.109 1.756-4.244C4.891 2.625 6.397 2 8 2s3.109.625 4.244 1.756A5.97 5.97 0 0 1 14 8a5.97 5.97 0 0 1-1.756 4.244M9 8v3h2V5H9z'
    })));
const $9138db1f951ed55c$export$b8c4b2c7e344e0c3 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'm6 12 6-4-6-4zM8 0C3.581 0 0 3.581 0 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8m4.244 12.244C11.109 13.375 9.603 14 8 14s-3.109-.625-4.244-1.756C2.625 11.109 2 9.603 2 8s.625-3.109 1.756-4.244C4.891 2.625 6.397 2 8 2s3.109.625 4.244 1.756C13.375 4.891 14 6.397 14 8s-.625 3.109-1.756 4.244'
    })));
const $9138db1f951ed55c$export$94c33b488623435e = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M8 10.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.243 12.243C11.109 13.376 9.603 14 8 14s-3.109-.624-4.243-1.757C2.624 11.109 2 9.603 2 8s.624-3.109 1.757-4.243C4.891 2.624 6.397 2 8 2s3.109.624 4.243 1.757A5.96 5.96 0 0 1 14 8a5.96 5.96 0 0 1-1.757 4.243M7.927 3.755c-2.248 0-2.76 1.695-2.802 2.906h1.571c.028-.256.101-1.418 1.221-1.418.672 0 1.206.406 1.206 1.175 0 .695-.724 1.155-1.303 1.711s-.652 1.196-.652 1.695V10h1.615v-.176c0-1.256 1.967-1.594 1.967-3.541 0-1.224-.876-2.528-2.823-2.528'
    })));
const $9138db1f951ed55c$export$1d64b5b770b4b3ed = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M8 .035a7.986 7.986 0 0 1 7.983 7.982A7.987 7.987 0 0 1 8 16 7.987 7.987 0 0 1 .017 8.017 7.986 7.986 0 0 1 8 .035m0 2a5.986 5.986 0 0 0-5.983 5.982A5.986 5.986 0 0 0 8 14a5.986 5.986 0 0 0 5.983-5.983A5.986 5.986 0 0 0 8 2.035m-.011 2.982a2.984 2.984 0 0 1 0 5.966 2.984 2.984 0 0 1 0-5.966'
    })));
const $9138db1f951ed55c$export$5836eb8e2e3e864d = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M5 11h6V5H5zM8 0C3.581 0 0 3.581 0 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8m4.244 12.244C11.109 13.375 9.603 14 8 14s-3.109-.625-4.244-1.756C2.625 11.109 2 9.603 2 8s.625-3.109 1.756-4.244C4.891 2.625 6.397 2 8 2s3.109.625 4.244 1.756C13.375 4.891 14 6.397 14 8s-.625 3.109-1.756 4.244'
    })));
const $9138db1f951ed55c$export$c65898577f07616b = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M8 0C3.581 0 0 3.581 0 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8m4.244 12.244C11.109 13.375 9.603 14 8 14s-3.109-.625-4.244-1.756C2.625 11.109 2 9.603 2 8s.625-3.109 1.756-4.244C4.891 2.625 6.397 2 8 2s3.109.625 4.244 1.756C13.375 4.891 14 6.397 14 8s-.625 3.109-1.756 4.244m-1.46-7.328L7.016 9.103 5.262 7.372 3.856 8.794 7.1 12l5.169-5.747z'
    })));
const $9138db1f951ed55c$export$6fb1bca6e16c2c94 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M10.294 4.294 8 6.584 5.706 4.291 4.291 5.706 6.584 8 4.29 10.294l1.416 1.416L8 9.416l2.294 2.294 1.416-1.416L9.416 8l2.294-2.294zM8 0C3.581 0 0 3.581 0 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8m4.244 12.244C11.109 13.375 9.603 14 8 14s-3.109-.625-4.244-1.756C2.625 11.109 2 9.603 2 8s.625-3.109 1.756-4.244C4.891 2.625 6.397 2 8 2s3.109.625 4.244 1.756C13.375 4.891 14 6.397 14 8s-.625 3.109-1.756 4.244'
    })));
const $9138db1f951ed55c$export$5a17af862a7576da = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M11 2c0-.6-.4-1-1-1h-.6C9.2.4 8.7 0 8 0S6.8.4 6.6 1H6c-.6 0-1 .4-1 1v2h6zm2 0h-1v2h1v10H3V4h1V2H3c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2M7 9.7 5.2 8 3.8 9.4 7 12.6l5.2-5.7-1.5-1.3z'
    })));
const $9138db1f951ed55c$export$b21a11de10d6bf76 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M11 6H5v2h6zm0-4c0-.6-.4-1-1-1h-.6C9.2.4 8.7 0 8 0S6.8.4 6.6 1H6c-.6 0-1 .4-1 1v2h6zm0 8H5v2h6zm2-8h-1v2h1v10H3V4h1V2H3c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2'
    })));
const $9138db1f951ed55c$export$17345b07225e0aa = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M8 0a7.97 7.97 0 0 0-6 2.709V0H0v6h6V4H3.528c.072-.084.153-.162.228-.244C4.891 2.625 6.397 2 8 2s3.109.625 4.244 1.756C13.375 4.891 14 6.397 14 8s-.625 3.109-1.756 4.244C11.109 13.375 9.603 14 8 14s-3.113-.619-4.244-1.756S2 9.603 2 8H0c0 4.419 3.581 8 8 8s8-3.581 8-8-3.581-8-8-8M7 4v4.416l3.291 3.291 1.416-1.416L9 7.584V4z'
    })));
const $9138db1f951ed55c$export$bbbb9b7c1aff7988 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M9 4H7v4.416l3.294 3.291 1.413-1.416L9 7.584zM8 0C3.581 0 0 3.581 0 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8m0 14c-3.312 0-6-2.688-6-6s2.688-6 6-6 6 2.688 6 6-2.688 6-6 6'
    })));
const $9138db1f951ed55c$export$1610bcb056ae58bb = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M12.294 3.294 10.878 4.71 13.5 8l-2.622 3.294 1.416 1.416L16 8zM5.122 4.706 3.706 3.291 0 8l3.706 4.706 1.416-1.416L2.5 8zM6 13h2l2-10H8z'
    })));
const $9138db1f951ed55c$export$4073c4c5b5a233d4 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M16 9V7l-2.259-.753a6 6 0 0 0-.441-1.066l1.066-2.131-1.416-1.416L10.819 2.7a6.3 6.3 0 0 0-1.066-.441L9 0H7l-.753 2.259a6 6 0 0 0-1.066.441L3.05 1.638 1.638 3.05l1.066 2.131a6 6 0 0 0-.445 1.066L0 7v2l2.259.753c.112.372.263.728.441 1.066L1.634 12.95l1.416 1.416L5.181 13.3c.338.178.694.328 1.066.441L7 16h2l.753-2.259a6 6 0 0 0 1.066-.441l2.131 1.066 1.416-1.416-1.066-2.131c.178-.337.328-.694.441-1.066zm-8 2a3.001 3.001 0 0 1 0-6 3.001 3.001 0 0 1 0 6'
    })));
const $9138db1f951ed55c$export$fa207a04e28a42cb = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M15 1 1 6l7 2 2 7z'
    })));
const $9138db1f951ed55c$export$6df11ed8ec8f8d62 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M8 0C3.581 0 0 3.581 0 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8m0 14c-3.312 0-6-2.688-6-6s2.688-6 6-6 6 2.688 6 6-2.688 6-6 6M6.5 6.5 4 11v1h1l4.5-2.5L12 5V4h-1zM8 9a1 1 0 1 1 0-2 1 1 0 1 1 0 2'
    })));
const $9138db1f951ed55c$export$ec3499dc3f62d571 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M8 0C3.581 0 0 3.581 0 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8m4.244 12.244A5.95 5.95 0 0 1 9 13.919V11H7v2.919a5.96 5.96 0 0 1-3.244-1.675A5.98 5.98 0 0 1 2.081 9H5V7H2.081c.203-1.222.781-2.35 1.675-3.244S5.775 2.284 7 2.081V5h2V2.081a5.96 5.96 0 0 1 3.244 1.675A5.95 5.95 0 0 1 13.919 7H11v2h2.919a6 6 0 0 1-1.675 3.244'
    })));
const $9138db1f951ed55c$export$daacca6cce9e30d3 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M13.916 7A6.005 6.005 0 0 0 9 2.084V0H7v2.084A6.005 6.005 0 0 0 2.084 7H0v2h2.084A6.005 6.005 0 0 0 7 13.916V16h2v-2.084A6 6 0 0 0 13.916 9H16V7zm-3.088 3.828C10.072 11.584 9.069 12 8 12s-2.072-.416-2.828-1.172S4 9.069 4 8s.416-2.072 1.172-2.828S6.931 4 8 4s2.072.416 2.828 1.172S12 6.931 12 8s-.416 2.072-1.172 2.828M8 6c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2'
    })));
const $9138db1f951ed55c$export$23ce67b3071ee16e = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M8 0C3.581 0 0 3.581 0 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8m4 6H6.181a.494.494 0 0 0-.493.494v.009c0 .272.222.494.494.494H10c1.103 0 2 .897 2 2v1c0 1.103-.897 2-2 2H9v1H7v-1H4v-2h5.506A.495.495 0 0 0 10 9.503v-.009A.495.495 0 0 0 9.506 9H5.981A1.98 1.98 0 0 1 4 7.019V6c0-1.103.897-2 2-2h1V3h2v1h3z'
    })));
const $9138db1f951ed55c$export$65f71275cd169acd = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.707 11.293-1.414 1.414L8 9.414l-3.293 3.293-1.414-1.414L6.586 8 3.293 4.707l1.414-1.414L8 6.586l3.293-3.293 1.414 1.414L9.414 8z'
    })));
const $9138db1f951ed55c$export$cb9a136b7e677418 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M12.706 8.294 11.29 6.878 9 9.172V0H7v9.172L4.706 6.878 3.291 8.294 8 13zM16 14H0v2h16z'
    })));
const $9138db1f951ed55c$export$2982342031c9fea6 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M4.71 5.878 3.294 7.294 8 12l4.71-4.706-1.416-1.416L9 8.172V0H7v8.172zM2 14v-2H0v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2h-2v2z'
    })));
const $9138db1f951ed55c$export$70f26903e40c814d = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M12.706 8.294 11.29 6.878 9 9.172V0H7v9.172L4.706 6.878 3.291 8.294 8 13zM14 4v10H2V4H0v12h16V4z'
    })));
const $9138db1f951ed55c$export$d5822d1e3e781a7c = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M8 13c2 0 4.497-1.5 4-4-1 0-6 4-4 4M8 0S1 5 1 10c0 4 3.688 6 7 6s7-2 7-6C15 5 8 0 8 0m4.606 11.687c-.244.456-.6.866-1.062 1.209a5.4 5.4 0 0 1-1.641.816C9.294 13.9 8.637 14 8 14s-1.294-.1-1.903-.288a5.3 5.3 0 0 1-1.641-.816 3.7 3.7 0 0 1-1.062-1.209C3.131 11.194 3 10.625 3 10c0-.788.278-1.684.825-2.669.494-.891 1.2-1.831 2.094-2.794A25 25 0 0 1 8 2.553a24 24 0 0 1 2.084 1.984c.894.966 1.6 1.906 2.094 2.794.544.985.822 1.881.822 2.669 0 .625-.134 1.194-.394 1.687'
    })));
const $9138db1f951ed55c$export$74e5b01e82a6f5df = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M4 8c0-1.103-.897-2-2-2s-2 .897-2 2 .897 2 2 2 2-.897 2-2m2 0c0 1.103.897 2 2 2s2-.897 2-2-.897-2-2-2-2 .897-2 2m6 0c0 1.103.897 2 2 2s2-.897 2-2-.897-2-2-2-2 .897-2 2'
    })));
const $9138db1f951ed55c$export$b307b75901e71920 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M8 4c1.103 0 2-.897 2-2s-.897-2-2-2-2 .897-2 2 .897 2 2 2m0 2c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2m0 6c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2'
    })));
const $9138db1f951ed55c$export$8f179830d10593db = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M0 6v8h16V6l-8 5zm0-4v2l8 5 8-5V2z'
    })));
const $9138db1f951ed55c$export$5af68724e0a1bf3d = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M2 11h12V9H2zm0-6v2h12V5z'
    })));
const $9138db1f951ed55c$export$35a394b139d2779b = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M1 11h14V9H1zm0-6v2h14V5z'
    })));
const $9138db1f951ed55c$export$d37d6805b1edaaab = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M9 11a1 1 0 1 0-2 0 1 1 0 1 0 2 0m0-7v5H7V4z'
    })));
const $9138db1f951ed55c$export$5edd362dbec83f16 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M4.414 15.414 8 11.828l3.586 3.586L13 14 8 9l-5 5zM11.586.586 8 4.172 4.414.586 3 2l5 5 5-5z',
        style: {
            fillRule: 'nonzero'
        }
    })));
const $9138db1f951ed55c$export$2a5f2ff1590ba9f0 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M13 11H9v2h6V1H3v6h2V3h8zM0 8v8h8v-2H3.412l6.294-6.294-1.412-1.412L2 12.587V8z'
    })));
const $9138db1f951ed55c$export$e4d1c1f093ddfc94 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M3 3h8v4h2V1H1v12h6v-2H3zm11 5v4.587L7.706 6.294 6.294 7.706 12.587 14H8v2h8V8z'
    })));
const $9138db1f951ed55c$export$b96e2b4e5f7775c1 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M16 16H0V0h16zM4 2v12h10V2zm1.586 3.414L8.172 8l-2.586 2.586L7 12l4-4-4-4z'
    })));
const $9138db1f951ed55c$export$bfc74f0b8ad1f2ce = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M0 0h16v16H0zm12 14V2H2v12zm-1.586-3.414L7.828 8l2.586-2.586L9 4 5 8l4 4z'
    })));
const $9138db1f951ed55c$export$c5cb8522150f3be8 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M13 13H5V9H3v6h12V3H9v2h4zM2 8V3.413l6.294 6.294 1.413-1.413L3.412 2H8V0H0v8z'
    })));
const $9138db1f951ed55c$export$10a0ddbd1861a097 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M3 5h4V3H1v12h12V9h-2v4H3zm13 3V0H8v2h4.587L6.294 8.294l1.413 1.413L14 3.413V8z'
    })));
const $9138db1f951ed55c$export$c52792559dd5fde = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M11.685 2.886zl2.9-2.9L16 1.4l-2.655 2.655C15.264 5.792 16 8 16 8s-2 6-8 6c-1.463 0-2.688-.357-3.704-.896L1.4 16l-1.414-1.414 2.654-2.654 1.415-1.416L5.472 9.1zm-5.879 8.708A5.9 5.9 0 0 0 8 12c3.479 0 5.214-2.733 5.832-4-.313-.644-.915-1.662-1.883-2.51.021.168.051.335.051.51a4 4 0 0 1-4.561 3.961zm-4.137-.692C.478 9.435 0 8 0 8s2-6 8-6a8 8 0 0 1 2.26.311L4.549 8.023A4 4 0 0 1 4 6c0-.174.03-.34.051-.509C3.082 6.34 2.481 7.358 2.168 8c.193.396.493.932.92 1.484z'
    })));
const $9138db1f951ed55c$export$5b296b74fc93300b = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M8 2C2 2 0 8 0 8s2 6 8 6 8-6 8-6-2-6-8-6m0 10c-3.481 0-5.213-2.728-5.832-4 .313-.642.914-1.66 1.883-2.509C4.03 5.66 4 5.826 4 6a4 4 0 0 0 8 0c0-.175-.03-.342-.051-.51.968.848 1.57 1.866 1.883 2.51-.618 1.267-2.353 4-5.832 4'
    })));
const $9138db1f951ed55c$export$baa7a52704f72315 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M5 7a1 1 0 1 0 0-2 1 1 0 1 0 0 2m3 3a2 2 0 0 1-1.731-1H4.125a4.001 4.001 0 0 0 7.75 0H9.731c-.347.597-.993 1-1.731 1M8 0a8 8 0 0 0-8 8 8 8 0 0 0 8 8 8 8 0 0 0 8-8 8 8 0 0 0-8-8m4.244 12.244A5.97 5.97 0 0 1 8 14a5.97 5.97 0 0 1-4.244-1.756A5.97 5.97 0 0 1 2 8c0-1.603.625-3.109 1.756-4.244A5.97 5.97 0 0 1 8 2c1.603 0 3.109.625 4.244 1.756A5.97 5.97 0 0 1 14 8a5.97 5.97 0 0 1-1.756 4.244M11 5a1 1 0 1 0 0 2 1 1 0 1 0 0-2'
    })));
const $9138db1f951ed55c$export$3ca36d1b1b6880d8 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M8 8a4 4 0 0 0-3.875 3h2.144c.347-.597.994-1 1.731-1s1.384.403 1.731 1h2.144A4.004 4.004 0 0 0 8 8M5 7a1 1 0 1 0 0-2 1 1 0 1 0 0 2m3-7a8 8 0 0 0-8 8 8 8 0 0 0 8 8 8 8 0 0 0 8-8 8 8 0 0 0-8-8m4.244 12.244A5.97 5.97 0 0 1 8 14a5.97 5.97 0 0 1-4.244-1.756A5.97 5.97 0 0 1 2 8c0-1.603.625-3.109 1.756-4.244A5.97 5.97 0 0 1 8 2c1.603 0 3.109.625 4.244 1.756A5.97 5.97 0 0 1 14 8a5.97 5.97 0 0 1-1.756 4.244M11 5a1 1 0 1 0 0 2 1 1 0 1 0 0-2'
    })));
const $9138db1f951ed55c$export$d05ae46b0b12cd6f = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M0 16h3V0H0zm10-8V4L4 8v8h6v-4h2v4h4V4z'
    })));
const $9138db1f951ed55c$export$ccb23f910e5c3193 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'm14 0-2 2v2h-2V2L8 0 6 2v2H4V2L2 0 0 2v14h4v-2h2v2h4v-2h2v2h4V2zM4 12V6h2v6zm6 0V6h2v6z'
    })));
const $9138db1f951ed55c$export$f153bd1599ddd890 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M7 16v-6L0 2V0h16v2l-7 8v4z'
    })));
const $9138db1f951ed55c$export$9fcd2875a6bf0e38 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M2.009 0h-.018A.99.99 0 0 0 1 .991V16h2V.991A.99.99 0 0 0 2.009 0M16 1H4v8h12l-4-4z'
    })));
const $9138db1f951ed55c$export$964c15ec9e30ae83 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'm9.65 4.05.45.45c.9.95 1.6 1.9 2.1 2.8.55 1 .85 1.9.85 2.65 0 .6-.15 1.2-.4 1.7q-.375.675-1.05 1.2c-.45.35-1 .6-1.65.8-.65.25-1.3.35-1.95.35s-1.3-.1-1.9-.3-1.15-.45-1.65-.8q-.675-.525-1.05-1.2c-.25-.5-.4-1.05-.4-1.7 0-.6.2-1.3.65-2.1.1-.2.2-.4.35-.6.8.65 1.55.8 2.05.8.85 0 1.65-.4 2.3-1.1.4-.5.75-1.1 1-1.85.1-.35.2-.7.3-1.1M8 0c0 3.9-.85 6.1-1.95 6.1C5.45 6.1 4.7 5.45 4 4c-1.65 1.85-3 4-3 6 0 4 3.7 6 7 6s7-2 7-6C15 5 8 0 8 0'
    })));
const $9138db1f951ed55c$export$5c5e312ef0488786 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M5 2v4L.817 12.971A2.001 2.001 0 0 0 2.532 16h10.936a2 2 0 0 0 1.715-3.029L11 6V2h1V0H4v2zm6.068 8H4.932L7 6.554V2h2v4.554z'
    })));
const $9138db1f951ed55c$export$22e733acfe1431e6 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'm7 1 2 2h7v11H0V1z'
    })));
const $9138db1f951ed55c$export$cc646d2f0b9a8ed7 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M8 14v2H0v-2zM1 7h14a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1m1 2v2h12V9zM1 0h14a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1m1 2v2h12V2z'
    })));
const $9138db1f951ed55c$export$6c64be5e42deae66 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M8 0C3.581 0 0 3.581 0 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8m0 14c-3.312 0-6-2.688-6-6s2.688-6 6-6 6 2.688 6 6-2.688 6-6 6m.225-5.984L6.172 5.387l.575 3.287a1.5 1.5 0 1 0 1.478-.658M8 3a5 5 0 0 0-4.9 4h1.141A3.84 3.84 0 0 1 5.25 5.25C5.984 4.516 6.963 4.113 8 4.113s2.016.403 2.75 1.137A3.85 3.85 0 0 1 11.759 7H12.9A5 5 0 0 0 8 3'
    })));
const $9138db1f951ed55c$export$476bfa1ddc2dfe7a = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M13 9v2h-2.488a.5.5 0 0 1-.169-.069L7.416 8l2.931-2.931A.5.5 0 0 1 10.516 5H13v2l3-3-3-3v2h-2.5c-.538 0-1.181.266-1.559.647L6.584 6H0v4h6.584l2.353 2.353c.382.381 1.022.647 1.56.647h2.5v2l3-3z'
    })));
const $9138db1f951ed55c$export$922c85641f9f6751 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M8 0C3.581 0 0 3.581 0 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8M3.756 12.244A5.97 5.97 0 0 1 2 8q0-.855.231-1.653l.506 1.334 2.819 2.225.469.106-.691 1.106 1.022 2.653a6 6 0 0 1-2.6-1.527m9.066-.669a6 6 0 0 1-.578.669 5.96 5.96 0 0 1-4.041 1.753l1.678-1.325.216-1.131-4.241-1.972-.262-.457-.344-.237-.178-.784-.581.237.194-.762.694-.091.619.688.202-1.188.759-1.05.809-.287.082-.547-.175-.188.766-.125.087-.6-.694-.716-.593.079-.735-.366-.4 1.253-.884-.537 1.284-1.344-1.644.334a5.96 5.96 0 0 1 2.759-.869L9.484 3.65l.684.184.144-.528.703-.491c.441.256.85.572 1.219.941q.276.278.516.584l-.544.941-.534.106.656 4.137.731.766zm.037-5.384.247-.331.281.34z'
    })));
const $9138db1f951ed55c$export$4a42f583c9418002 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        fillRule: 'evenodd',
        d: 'M2 5h12v1h-1v8h2v1h1v1H0v-1h1v-1h2V6H2zm5 1H5v8h2zm2 0h2v8H9zM8.112.056a.25.25 0 0 0-.224 0l-6.94 3.47C.71 3.644.794 4 1.058 4h13.882c.264 0 .348-.356.112-.474zM8 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2',
        clipRule: 'evenodd'
    })));
const $9138db1f951ed55c$export$384500bdee9cfb28 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M3 7V5H1v2zm0 4V9H1v2zm4-4V5H5v2zm0 4V9H5v2zm4-4V5H9v2zm0 4V9H9v2zm4-4V5h-2v2zm0 4V9h-2v2z'
    })));
const $9138db1f951ed55c$export$686e909ad6dbb500 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M7 13H5v2h2zm4 0H9v2h2zM7 9H5v2h2zm4 0H9v2h2zM7 5H5v2h2zm4 0H9v2h2zM7 1H5v2h2zm4 0H9v2h2z'
    })));
const $9138db1f951ed55c$export$77134c21538c4a4c = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M1 9h14V7H1zm0 5h14v-2H1zM1 2v2h14V2z'
    })));
const $9138db1f951ed55c$export$89331070f6fc9967 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M8 8V1a1 1 0 0 1 2 0v7h1V2a1 1 0 0 1 2 0v6h1V5a1 1 0 0 1 2 0v9a2 2 0 0 1-2 2H7c-.63 0-1.222-.296-1.6-.8L0 8a1.63 1.63 0 0 1 2.131-.152L5 10V3a1 1 0 0 1 2 0v5z'
    })));
const $9138db1f951ed55c$export$90416b71b616b91 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M5 11V4.5a1.5 1.5 0 0 1 3 0V8h1.528c.31 0 .617.072.894.211l2.472 1.236A2 2 0 0 1 14 11.236V14a2 2 0 0 1-2 2H6.702c-.455 0-.895-.155-1.25-.438L1 12a1 1 0 0 1 1-1zM2 4.5C2 2.016 4.016 0 6.5 0S11 2.016 11 4.5H9a2.5 2.5 0 0 0-5 0z'
    })));
const $9138db1f951ed55c$export$84d82bc35f21d6b6 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M3 10V1H0v9zm12 1a.997.997 0 0 0 1-1V6.277a1 1 0 0 0-.143-.515l-2.274-3.791A2 2 0 0 0 11.868 1H6a2 2 0 0 0-2 2v7.298c0 .455.155.895.438 1.25L8 16a1 1 0 0 0 1-1v-4z'
    })));
const $9138db1f951ed55c$export$ffd6616d7f2ec8c7 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M3 6v9H0V6zm12-1a.997.997 0 0 1 1 1v3.723a1 1 0 0 1-.143.515l-2.274 3.791a2 2 0 0 1-1.715.971H6a2 2 0 0 1-2-2V5.702c0-.455.155-.895.438-1.25L8 0a1 1 0 0 1 1 1v4z'
    })));
const $9138db1f951ed55c$export$9551e39be92a9bc5 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M11 8H5V1H3v14h2v-5h6v5h2V1h-2z'
    })));
const $9138db1f951ed55c$export$3094a1b9f32c68d5 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M11.75 1A4.25 4.25 0 0 0 8 3.249 4.25 4.25 0 0 0 0 5.25C0 11 8 15 8 15s8-4 8-9.75A4.25 4.25 0 0 0 11.75 1'
    })));
const $9138db1f951ed55c$export$62a58013efdd2c1a = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M0 6v10h6v-6h4v6h6V6L8 0z'
    })));
const $9138db1f951ed55c$export$72fd52d03f766e5d = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M0 8v7h3v-4h3v4h6V8L6 3zm10-7L7.6 3 13 7.5V13h3V6z'
    })));
const $9138db1f951ed55c$export$b7a766f44e29e48c = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M8 9 0 5l8-4 8 4zm6.397-1.8L16 8l-8 4-8-4 1.603-.8L8 10.397zm0 3L16 11l-8 4-8-4 1.603-.8L8 13.397z'
    })));
const $9138db1f951ed55c$export$f6547b3d6e6e28f2 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'm9.439 3-5 10H1v2h9v-2H6.561l5-10H15V1H6v2z'
    })));
const $9138db1f951ed55c$export$bf1e1a02918ee573 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M16 4a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zm-4 6v2H4v-2zM4 7v2H2V7zm3 0v2H5V7zm3 0v2H8V7zm4 0v2h-3V7zM4 4v2H2V4zm3 0v2H5V4zm3 0v2H8V4zm4 0v2h-3V4z'
    })));
const $9138db1f951ed55c$export$4c6f701ae5fe9073 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M0 16h7V0H0zm15 0V0H8v16z'
    })));
const $9138db1f951ed55c$export$af3a5aeff000074d = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M7 9v7H0V9zm8 0v7H8V9zM7 1v7H0V1zm8 0v7H8V1z'
    })));
const $9138db1f951ed55c$export$3b51a6b9653487d2 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M1 1h4v4H1zm5 0h4v4H6zm5 0h4v4h-4zM1 6h4v4H1zm5 0h4v4H6zm5 0h4v4h-4zM1 11h4v4H1zm5 0h4v4H6zm5 0h4v4h-4z'
    })));
const $9138db1f951ed55c$export$ae59d452b696795b = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M0 0v7h16V0zm0 15h16V8H0z'
    })));
const $9138db1f951ed55c$export$b64d86384c92f1e0 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M8 0a7 7 0 0 0-7 7v9h2v-4a7 7 0 0 1 7-7h2a7 7 0 0 0-7 7v2h3a7 7 0 0 0 7-7V0z'
    })));
const $9138db1f951ed55c$export$c1c6fe15475bbb7e = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M6.794 12.794c-.478.475-1.113.737-1.794.737s-1.316-.262-1.794-.738a2.54 2.54 0 0 1 0-3.584L5.5 6.916 4.084 5.5 1.791 7.794a4.54 4.54 0 0 0 .003 6.413c.853.855 1.99 1.324 3.206 1.324s2.353-.469 3.206-1.325l2.294-2.294L9.084 10.5zm7.412-11C13.353.938 12.216.469 11 .469S8.647.938 7.794 1.794L5.5 4.084 6.916 5.5 9.21 3.206c.474-.475 1.109-.737 1.79-.737s1.316.263 1.794.737a2.537 2.537 0 0 1 0 3.584L10.5 9.084l1.416 1.416 2.294-2.294a4.54 4.54 0 0 0-.004-6.412m-2.5 3.912L10.29 4.29l-6 6 1.416 1.416z'
    })));
const $9138db1f951ed55c$export$8eec6b150ddf7426 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M0 10V9h2a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-.75a.25.25 0 0 0-.25.25v.5a.25.25 0 0 0 .25.25H3v1H1a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h.75a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25zm4 1h12v2H4zm0-4h12v2H4zM1 3.25A.25.25 0 0 0 .75 3H0V2h1a1 1 0 0 1 1 1v4H1zM4 3h12v2H4z'
    })));
const $9138db1f951ed55c$export$8e6bd23949fc26d0 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M4 3v2h12V3zM0 5h2V3H0zm4 4h12V7H4zM0 9h2V7H0zm4 4h12v-2H4zm-4 0h2v-2H0z'
    })));
const $9138db1f951ed55c$export$70cca5edf1a67180 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M12.25 7H12V4c0-1.653-1.347-3-3-3H7C5.347 1 4 2.347 4 4v1h2V4c0-.55.45-1 1-1h2c.55 0 1 .45 1 1v3H3.75a.753.753 0 0 0-.75.75v6.5c0 .412.338.75.75.75h8.5c.412 0 .75-.338.75-.75v-6.5a.753.753 0 0 0-.75-.75'
    })));
const $9138db1f951ed55c$export$d5b6665210f0a539 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M12.25 7H12V4c0-1.653-1.347-3-3-3H7C5.347 1 4 2.347 4 4v3h-.25a.753.753 0 0 0-.75.75v6.5c0 .413.338.75.75.75h8.5c.413 0 .75-.337.75-.75v-6.5a.75.75 0 0 0-.75-.75M6 4c0-.55.45-1 1-1h2c.55 0 1 .45 1 1v3H6z'
    })));
const $9138db1f951ed55c$export$247536f07b7c3b83 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M14 7h-1V4c0-2.206-1.794-4-4-4H7C4.794 0 3 1.794 3 4h2c0-1.103.897-2 2-2h2c1.103 0 2 .897 2 2v3H2c-.55 0-1 .45-1 1v7c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1m-5 5.731v.769c0 .55-.45 1-1 1s-1-.45-1-1v-.769a2 2 0 1 1 2 0'
    })));
const $9138db1f951ed55c$export$5c8bd75215c9ed1f = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M14 7h-1V4c0-2.206-1.794-4-4-4H7C4.794 0 3 1.794 3 4v3H2c-.55 0-1 .45-1 1v7c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1m-5 5.731v.769c0 .55-.45 1-1 1s-1-.45-1-1v-.769a2 2 0 1 1 2 0M5 7V4c0-1.103.897-2 2-2h2c1.103 0 2 .897 2 2v3z'
    })));
const $9138db1f951ed55c$export$1692611780ac32d = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M14 14V2H8V0h8v16H8v-2zm-6.998-.998L12 8 7 3 5.584 4.416 8.172 7H0v2h8.172l-2.586 2.586z'
    })));
const $9138db1f951ed55c$export$2d4c748bd12d78e0 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M14 14V2H8V0h8v16H8v-2zm-9.002-.998L0 8l5-5 1.416 1.416L3.828 7H12v2H3.828l2.586 2.586z'
    })));
const $9138db1f951ed55c$export$b2a4ca5137e627ff = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'm15.708 13.587-3.675-3.675a6.5 6.5 0 1 0-2.121 2.121l3.675 3.675a1.003 1.003 0 0 0 1.414 0l.707-.707a1.003 1.003 0 0 0 0-1.414M3.318 9.682C2.468 8.832 2 7.702 2 6.5s.468-2.332 1.318-3.182S5.298 2 6.5 2s2.332.468 3.182 1.318S11 5.298 11 6.5s-.468 2.332-1.318 3.182S7.702 11 6.5 11s-2.332-.468-3.182-1.318'
    })));
const $9138db1f951ed55c$export$2b187ab490e92c13 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M3.5 5.5h6v2h-6z'
    }), $8v0nu.createElement("path", {
        d: 'm12.033 9.912 3.675 3.675a1.003 1.003 0 0 1 0 1.414l-.707.707a1.003 1.003 0 0 1-1.414 0l-3.675-3.675a6.5 6.5 0 1 1 2.121-2.121m-8.715-.23A4.47 4.47 0 0 0 6.5 11a4.47 4.47 0 0 0 3.182-1.318A4.47 4.47 0 0 0 11 6.5a4.47 4.47 0 0 0-1.318-3.182A4.47 4.47 0 0 0 6.5 2a4.47 4.47 0 0 0-3.182 1.318A4.47 4.47 0 0 0 2 6.5a4.47 4.47 0 0 0 1.318 3.182'
    })));
const $9138db1f951ed55c$export$aef499440d07757c = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M7.5 7.5h2v-2h-2v-2h-2v2h-2v2h2v2h2z'
    }), $8v0nu.createElement("path", {
        d: 'M15.708 13.587a1.003 1.003 0 0 1 0 1.414l-.707.707a1.003 1.003 0 0 1-1.414 0l-3.675-3.675a6.5 6.5 0 1 1 2.121-2.121zM2 6.5a4.47 4.47 0 0 0 1.318 3.182A4.47 4.47 0 0 0 6.5 11a4.47 4.47 0 0 0 3.182-1.318A4.47 4.47 0 0 0 11 6.5a4.47 4.47 0 0 0-1.318-3.182A4.47 4.47 0 0 0 6.5 2a4.47 4.47 0 0 0-3.182 1.318A4.47 4.47 0 0 0 2 6.5'
    })));
const $9138db1f951ed55c$export$89ad07d969809ef0 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'm.292 15.001.707.707a1.003 1.003 0 0 0 1.414 0l3.675-3.675a6.5 6.5 0 1 0-2.121-2.121L.292 13.587a1.003 1.003 0 0 0 0 1.414M9.5 11a4.47 4.47 0 0 1-3.182-1.318C5.468 8.832 5 7.702 5 6.5s.468-2.332 1.318-3.182S8.298 2 9.5 2s2.332.468 3.182 1.318S14 5.298 14 6.5s-.468 2.332-1.318 3.182A4.47 4.47 0 0 1 9.5 11'
    })));
const $9138db1f951ed55c$export$a85a53f46ea5d4e1 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'm0 3 5-2v12l-5 2zm11 0v12l-5-1.667v-12zm5-2v12l-4 1.6v-12z'
    })));
const $9138db1f951ed55c$export$ddb0bcf29e4fc4bb = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M8 0C4.688 0 2 2.688 2 6c0 6 6 10 6 10s6-4 6-10c0-3.312-2.688-6-6-6m0 8a3.001 3.001 0 0 1 0-6 3.001 3.001 0 0 1 0 6'
    })));
const $9138db1f951ed55c$export$41cf3a9d8250975e = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M4 10.471V16l4-2 4 2v-5.529A5.99 5.99 0 0 0 14 6c0-3.311-2.689-6-6-6S2 2.689 2 6c0 1.775.773 3.372 2 4.471M8 3a3.001 3.001 0 0 1 0 6 3.001 3.001 0 0 1 0-6'
    })));
const $9138db1f951ed55c$export$448b293f3d913b8a = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M14 7H2v2h12z'
    })));
const $9138db1f951ed55c$export$8b95d566fbd56482 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M15 7H1v2h14z'
    })));
const $9138db1f951ed55c$export$40baeeb0bb7c9f71 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M11.5 0h-7C3.675 0 3 .675 3 1.5v13c0 .825.675 1.5 1.5 1.5h7c.825 0 1.5-.675 1.5-1.5v-13c0-.825-.675-1.5-1.5-1.5M8 15a1 1 0 1 1 0-2 1 1 0 1 1 0 2m4-3H4V2h8z'
    })));
const $9138db1f951ed55c$export$d7458318da00be20 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M16 5H4.988v9H16v1.988H3V3.012h13zM0 .012h14V2H1.988v12H0V.012m8.2 8.36L6.794 9.794 10.037 13l5.169-5.747-1.484-1.338-3.769 4.187z'
    })));
const $9138db1f951ed55c$export$c5e5312dcf5a204f = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M14.706 4.206 10.794.294A1 1 0 0 0 10.088 0H1v7h2V2h7v3h3v9H9v2h6V4.916c0-.266-.106-.522-.294-.71m-7.114 8.179L9 12.15v-1.288l-1.408-.231a3 3 0 0 0-.288-.697l.833-1.164-.91-.91-1.161.832a3.2 3.2 0 0 0-.689-.285L5.146 7H3.857l-.231 1.407a3.1 3.1 0 0 0-.692.285L1.771 7.86l-.911.91.832 1.163a3.2 3.2 0 0 0-.285.691L0 10.856v1.288l1.408.231c.066.244.166.475.285.691L.86 14.23l.91.91 1.164-.832c.219.119.447.219.691.285L3.857 16h1.289l.231-1.407c.244-.066.476-.166.688-.285l1.164.832.91-.91-.829-1.154c.116-.219.217-.447.282-.691m-3.1.403c-.71 0-1.289-.579-1.289-1.288s.579-1.288 1.289-1.288a1.289 1.289 0 1 1 0 2.576'
    })));
const $9138db1f951ed55c$export$4de7d3a780aa7d4b = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M14.706 4.206 10.794.294A1 1 0 0 0 10.088 0H1v8H0v4h10V8H3V2h7v3h3v9H3v-1H1v3h14V4.916c0-.266-.106-.522-.294-.71'
    })));
const $9138db1f951ed55c$export$37ce21e1ba043044 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M14.706 4.206 10.793.293A1 1 0 0 0 10.087 0H1v9h2V2h7v3h3v9H9v2h6V4.916c0-.266-.106-.522-.294-.71M9 10h2V9c0-1.653-1.347-3-3-3S5 7.347 5 9v1H.991a.995.995 0 0 0-.991.991v4.019c0 .543.447.99.991.99H7.01c.543 0 .99-.447.99-.991V10.99a.995.995 0 0 0-.991-.99H7V9c0-.55.45-1 1-1s1 .45 1 1zm-5 4a1 1 0 1 1 0-2 1 1 0 1 1 0 2'
    })));
const $9138db1f951ed55c$export$505d1154312c1f4d = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M14.706 4.206c.188.188.294.444.294.71V16H1V0h9.087c.266 0 .519.106.706.293zM13 14V5h-3V2H3v12zm-1-6H9V5H7v3H4v2h3v3h2v-3h3z'
    })));
const $9138db1f951ed55c$export$4a8a225852a3176 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M14.706 4.206 10.793.293A1 1 0 0 0 10.087 0H1v16h14V4.916c0-.266-.106-.522-.294-.71M13 14H3V2h7v3h3zM5.2 8.372 3.794 9.794 7.037 13l5.169-5.747-1.484-1.338-3.769 4.187z'
    })));
const $9138db1f951ed55c$export$63c83462b6ec5fb6 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M14.706 4.206c.188.188.294.444.294.71V16H1V0h9.087c.266 0 .519.106.706.293zM13 14V5h-3V2H3v12zm-7.586-3.586L4 9l4-4 4 4-1.414 1.414L9 8.828V13H7V8.828z'
    })));
const $9138db1f951ed55c$export$c04e66d9f370f139 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M14.706 4.206 10.793.293A1 1 0 0 0 10.087 0H1v16h14V4.916c0-.266-.106-.522-.294-.71M13 14H3V2h7v3h3z'
    })));
const $9138db1f951ed55c$export$509fad11b885abb0 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M3 3H1v13h11v-2H3zm9-3H4v13h11V3zm1 11H6V2h5v2h2z'
    })));
const $9138db1f951ed55c$export$b8f31e9a5cf17074 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M1 11v4h4l7-7-4-4zM11 1 9 3l4 4 2-2z'
    })));
const $9138db1f951ed55c$export$20df3a4d38f4449c = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M4 4h2v10H4zm10 10h-2a2 2 0 0 1-2-2V4h2v7.5c0 .133.053.26.146.354A.5.5 0 0 0 12.5 12H14zM2 2h12v2H2z'
    })));
const $9138db1f951ed55c$export$c273953023f3b0d9 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M11.5 7a1.5 1.5 0 1 0-.001-3.001A1.5 1.5 0 0 0 11.5 7M13 8l-4 2-3-5-3 6v1h10zM0 1v14h16V1zm14 12H2V3h12z'
    })));
const $9138db1f951ed55c$export$1f35cd9a970948ef = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M8 14H6v-4c-2.208 0-4-1.792-4-4 0-2.177 1.742-3.949 4-4h8v2h-2v10h-2V4H8z'
    })));
const $9138db1f951ed55c$export$3a9f56a1d1f9a714 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M14 7H9V2H7v5H2v2h5v5h2V9h5z'
    })));
const $9138db1f951ed55c$export$889d6f1a30ea74d6 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M15 7H9V1H7v6H1v2h6v6h2V9h6z'
    })));
const $9138db1f951ed55c$export$37ff0821c075ffdb = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M2 14h10V5H2zm2-7h6v5H4zm1-5v2h8v7h2V2z'
    })));
const $9138db1f951ed55c$export$f4bc043c492a6c31 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M4 2v9h10V2zm8 7H6V4h6zM3 5H1v9h10v-2H3z'
    })));
const $9138db1f951ed55c$export$cabb19bc45ece1c2 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M13 1H3v2h10zm2 3H1c-.55 0-1 .45-1 1v5c0 .55.45 1 1 1h2v4h10v-4h2c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1m-4 9H5V9h6zm3-6a1 1 0 1 1 0-2 1 1 0 0 1 0 2'
    })));
const $9138db1f951ed55c$export$1a26968bd5e528c1 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M15.938 9h-2.02a6 6 0 0 1-1.674 3.244A5.97 5.97 0 0 1 8 14a5.97 5.97 0 0 1-4.244-1.756A5.97 5.97 0 0 1 2 8a5.97 5.97 0 0 1 2-4.472V6h2V0H0v2h2.709A7.98 7.98 0 0 0 0 8a8 8 0 0 0 8 8 8 8 0 0 0 7.938-7m-5.154-4.084 1.485 1.337L7.1 12 3.856 8.794l1.406-1.422 1.754 1.731zm3.536-1.822-1.427 1.427A5.9 5.9 0 0 1 13.918 7h2.02a7.96 7.96 0 0 0-1.618-3.906m-2.842.014 1.428-1.428A7.97 7.97 0 0 0 8 0v2a5.96 5.96 0 0 1 3.478 1.108'
    })));
const $9138db1f951ed55c$export$bf479e9952d124c2 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M4.522 12.892 3.094 14.32A7.96 7.96 0 0 0 7 15.938v-2.02a5.95 5.95 0 0 1-2.478-1.026m6.956 0A5.95 5.95 0 0 1 9 13.918v2.02a7.96 7.96 0 0 0 3.906-1.618zM13.918 9a5.95 5.95 0 0 1-1.026 2.478l1.428 1.428A7.96 7.96 0 0 0 15.938 9zM2.082 9H.062a7.96 7.96 0 0 0 1.618 3.906l1.428-1.428A5.95 5.95 0 0 1 2.082 9m8.702-4.084 1.485 1.337L7.1 12 3.856 8.794l1.406-1.422 1.754 1.731zm3.536-1.822-1.427 1.427A5.9 5.9 0 0 1 13.918 7h2.02a7.96 7.96 0 0 0-1.618-3.906M.062 7h2.02A5.98 5.98 0 0 1 4 3.528V6h2V0H0v2h2.709A7.98 7.98 0 0 0 .062 7m11.416-3.892 1.428-1.428A7.97 7.97 0 0 0 8 0v2a5.96 5.96 0 0 1 3.478 1.108'
    })));
const $9138db1f951ed55c$export$e936722be7af186a = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M7 15.938v-2.02a6 6 0 0 1-3.244-1.674A5.97 5.97 0 0 1 2 8a5.97 5.97 0 0 1 2-4.472V6h2V0H0v2h2.709A7.98 7.98 0 0 0 0 8a8 8 0 0 0 7 7.938m4.478-3.046A5.95 5.95 0 0 1 9 13.918v2.02a7.96 7.96 0 0 0 3.906-1.618zM15.938 9h-2.02a5.95 5.95 0 0 1-1.026 2.478l1.428 1.428A7.96 7.96 0 0 0 15.938 9m-5.154-4.084 1.485 1.337L7.1 12 3.856 8.794l1.406-1.422 1.754 1.731zm3.536-1.822-1.427 1.427A5.9 5.9 0 0 1 13.918 7h2.02a7.96 7.96 0 0 0-1.618-3.906m-2.842.014 1.428-1.428A7.97 7.97 0 0 0 8 0v2a5.96 5.96 0 0 1 3.478 1.108'
    })));
const $9138db1f951ed55c$export$cc12b47c9c533761 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M16 3V1c-4.188 0-7 2.812-7 7v7h7V8h-5c0-3.084 1.916-5 5-5M0 8v7h7V8H2c0-3.084 1.916-5 5-5V1C2.812 1 0 3.812 0 8'
    })));
const $9138db1f951ed55c$export$31a206cffc6bcef8 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M0 8h5c0 3.084-1.916 5-5 5v2c4.188 0 7-2.812 7-7V1H0zm9-7v7h5c0 3.084-1.916 5-5 5v2c4.188 0 7-2.812 7-7V1z'
    })));
const $9138db1f951ed55c$export$8aa06688994ea65a = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M6.999 16h2.002V0H6.999zM5.414 5.414 4 4 0 8l4 4 1.414-1.414L3.828 9H6V7H3.828zM12 4l-1.414 1.414L12.172 7H10v2h2.172l-1.586 1.586L12 12l4-4z'
    })));
const $9138db1f951ed55c$export$ce07c1505fc240fa = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M0 6.999v2.002h16V6.999zm7-3.171V6h2V3.828l1.586 1.586L12 4 8 0 4 4l1.414 1.414zm2 8.344V10H7v2.172l-1.586-1.586L4 12l4 4 4-4-1.414-1.414z'
    })));
const $9138db1f951ed55c$export$4ec862b3067b2249 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M2 8h6v6H6v-2.6L1.4 16l-1.414-1.414L4.572 10H2zm6-6h2v2.6L14.6 0l1.414 1.414L11.428 6H14v2H8z'
    })));
const $9138db1f951ed55c$export$3c2cb1e70bb7ddf8 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'm1.986 12.6 4.6-4.6L8 9.414 3.414 14h2.572v2h-6v-6h2zM12.586 2h-2.572V0h6v6h-2V3.4L9.414 8 8 6.586z'
    })));
const $9138db1f951ed55c$export$62497cdf6d0d1934 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M16 16 13 0H9v1H7V0H3L0 16h7v-4h2v4zM7 3h2v2H7zm0 7V7h2v3z'
    })));
const $9138db1f951ed55c$export$a7789793f3c2c8cc = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'm6.516 2.612 2.809.938.734 2.934.188.75.644.428 2.238 1.494.605 4.844H2.441l.331-1.65 1.125-.562.875-.438.191-.959zM5 0 3 10l-2 1-1 5h16l-1-8-3-2-1-4z'
    })));
const $9138db1f951ed55c$export$67a54af4fd4d9a2e = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M1 5v2a7.982 7.982 0 0 1 5.656 2.343A7.98 7.98 0 0 1 9 15h2C11 9.477 6.523 5 1 5m3 5a2 2 0 1 0-.001 3.999A2 2 0 0 0 4 10M1 1v2a11.955 11.955 0 0 1 8.485 3.515 12 12 0 0 1 2.573 3.815c.625 1.478.942 3.049.942 4.67h2C15 7.268 8.732 1 1 1'
    })));
const $9138db1f951ed55c$export$611ca684c7a93fe1 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M13.5 11c-.609 0-1.169.219-1.603.581l-6.9-3.45Q5.001 8.066 5 8q0-.066-.003-.131l6.9-3.45a2.5 2.5 0 1 0-.894-1.788l-6.9 3.45a2.5 2.5 0 1 0 0 3.838l6.9 3.45q-.004.065-.003.131a2.5 2.5 0 1 0 2.5-2.5'
    })));
const $9138db1f951ed55c$export$7cffb2c8835f2a25 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M10 6v2h3v6H3V8h3V6H1v10h14V6zM7 3.328V11h2V3.328l1.834 1.834L12 4 8 0 4 4l1.166 1.166z'
    })));
const $9138db1f951ed55c$export$72c7f3691d5e45db = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M16 16H0V0h16zM4 2v12h10V2zm6.414 8.586L7.828 8l2.586-2.586L9 4 5 8l4 4z'
    })));
const $9138db1f951ed55c$export$d11c632cbde2be34 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M0 0h16v16H0zm12 14V2H2v12zM5.586 5.414 8.172 8l-2.586 2.586L7 12l4-4-4-4z'
    })));
const $9138db1f951ed55c$export$3b59d4afb984fe49 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M15.006 12.262 8.994 1.737c-.547-.956-1.438-.956-1.984 0L.994 12.262C.447 13.219.9 14 2 14h12c1.1 0 1.553-.781 1.006-1.738M8 13a1.25 1.25 0 1 1-.002-2.498A1.25 1.25 0 0 1 8 13m1-3H7V5h2z'
    })));
const $9138db1f951ed55c$export$1ff70e20de9defba = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M4 12H0v2h4v1h3v-4H4zm5-2h3V6H9v1H0v2h9zM3 5h3V1H3v1H0v2h3zm5 9h8v-2H8zM7 2v2h9V2zm6 7h3V7h-3z'
    })));
const $9138db1f951ed55c$export$5363c08acc839f14 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M12 12v4h2v-4h1V9h-4v3zm-2-5V4H6v3h1v9h2V7zm-5 6v-3H1v3h1v3h2v-3zm9-5V0h-2v8zM2 9h2V0H2zm7-6V0H7v3z'
    })));
const $9138db1f951ed55c$export$7306271c30123976 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M11.292 8.878 11.139 9h.275zm.872.872h-1.966l-.312.25h2.531zm-.5-.5h-.837l-.313.25h1.403zM8.627 11h3.181l.319-.25H8.939zm-.629 3 .319-.25h-.634zM6.73 13h2.54l.319-.25H6.411zm-.635-.5h3.809l.319-.25H5.777zm1.269 1h1.269l.319-.25H7.048zM5.458 12h5.078l.319-.25H5.142zm-.95-.75.319.25h3.172l-.312-.25zm5.059-1-.312.25h3.188l.262-.206-.044-.044zM7.998 11.5h3.175l.319-.25H8.311zM4.705 8.878 4.583 9h.275zm.468.372h-.837l-.25.25h1.403zm1.885 1.5H3.87l.319.25H7.37zm-.628-.5H3.336l-.044.044.263.206h3.188zm-.628-.5H3.836l-.25.25h2.531zM7.998 4.5l3.294 2.622 1.416-1.416L7.998 2 3.292 5.706l1.416 1.416z'
    })));
const $9138db1f951ed55c$export$d51a5d41a86d4b55 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M9.27 3H6.73l-.319.25h3.175zM7.373 5H4.192l-.319.25h3.184zm1.263-2.5H7.367l-.319.25h1.903zM10.542 4H5.461l-.319.25h5.712zm-.637-.5H6.098l-.318.25h4.444zM8.002 2l-.319.25h.634zm3.49 2.75-.319-.25H8.002l.312.25zm-3.49-.25H4.827l-.319.25h3.181zM9.57 5.75h3.094l.044-.044-.263-.206H9.258zm-.628-.5h3.184L11.808 5H8.63zm2.975 1.25h-1.403l.312.25h.837zm-.775.5.153.122.122-.122zM6.433 5.75l.312-.25H3.558l-.263.206.044.044zm5.984.25H9.886l.312.25h1.966zm-6.928.5H4.086l.25.25h.838zm-.903.5.122.122L4.861 7zm1.531-1H3.586l.25.25h1.966zm1.885 5.5L4.708 8.878l-1.416 1.416L8.002 14l4.706-3.706-1.416-1.416z'
    })));
const $9138db1f951ed55c$export$24bdafc250bc28ef = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M9.269 3H6.728l-.319.25h3.175zM7.372 5H4.191l-.319.25h3.184zm1.262-2.5H7.366l-.319.25H8.95zM10.541 4H5.459l-.318.25h5.712zm-.638-.5H6.097l-.319.25h4.444zM8 2l-.319.25h.634zm3.491 2.75-.319-.25H8l.312.25zM8 4.5H4.825l-.319.25h3.181zm1.569 1.25h3.094l.044-.044-.263-.206H9.256zm-.628-.5h3.184L11.806 5H8.628zm2.975 1.25h-1.403l.312.25h.837zm-.775.5.153.122.122-.122zm-4.71-1.25.313-.25H3.556l-.262.206.044.044zm4.863 3.128L11.141 9h.275zm.872.872H10.2l-.313.25h2.531zm-.5-.5h-.837l-.313.25h1.403zm.75-3.25H9.884l.312.25h1.966zm-3.788 5h3.181l.319-.25H8.941zM8 14l.319-.25h-.635zm-1.269-1h2.541l.319-.25H6.412zm-.634-.5h3.809l.319-.25H5.778zm1.269 1h1.269l.319-.25H7.05zM5.459 12h5.078l.319-.25H5.144zm-.95-.75.319.25H8l-.312-.25zm5.06-1-.313.25h3.188l.262-.206-.044-.044zM8 11.5h3.175l.319-.25H8.312zM4.706 8.878 4.584 9h.275zm.469.372h-.837l-.25.25h1.403zm.313-2.75H4.084l.25.25h.838zm-.904.5.122.122L4.859 7zm2.475 3.75H3.872l.319.25h3.181zM6.116 6H3.584l.25.25H5.8zm.315 4.25H3.338l-.044.044.262.206h3.188zm-.628-.5H3.837l-.25.25h2.531z'
    })));
const $9138db1f951ed55c$export$ee66e65f9bacd0b7 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M8 11.5 4.706 8.878 3.29 10.294 8 14l4.706-3.706-1.416-1.416zm0-7 3.294 2.622 1.416-1.416L8 2 3.294 5.706 4.71 7.122z'
    })));
const $9138db1f951ed55c$export$f0833711cb9f68ce = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M10 1 3 9h4.5L6 15l7-8H8.5z'
    })));
const $9138db1f951ed55c$export$154cb3948df3efa1 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M4 13H2a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H8l-4 3z'
    })));
const $9138db1f951ed55c$export$b347ffcee0e953cc = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M4 4h8v8H4z'
    })));
const $9138db1f951ed55c$export$ade582b79af72d78 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M2 2h12v12H2z'
    })));
const $9138db1f951ed55c$export$75f6b5de4cbd2386 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'm16 6.204-5.528-.803L8 .392 5.528 5.401 0 6.204l4 3.899-.944 5.505L8 13.009l4.944 2.599L12 10.103z'
    })));
const $9138db1f951ed55c$export$2bdb2cf27f0a265 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M7 16h2v-6H7zm5.603-12.956A5 5 0 0 0 8 0C5.238 0 3 2.237 3 5a3.001 3.001 0 0 0 0 6h.284L4 15h2L5 9H3c-.55 0-1-.45-1-1s.45-1 1-1h2V5c0-1.653 1.347-3 3-3 1.206 0 2.291.719 2.762 1.828l.438 1.028 1.103.166c.466.072.897.306 1.209.669A2.002 2.002 0 0 1 12 9h-1l-1 6h2l.725-4.066a4 4 0 0 0-.122-7.89'
    })));
const $9138db1f951ed55c$export$18836a3de4fad05d = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M13.656 2.344A7.98 7.98 0 0 1 16 8a7.98 7.98 0 0 1-2.344 5.656l-1.414-1.414A5.98 5.98 0 0 0 14 8a5.98 5.98 0 0 0-1.758-4.242zm-11.312 0 1.414 1.414A5.98 5.98 0 0 0 2 8c0 1.656.672 3.156 1.758 4.242l-1.414 1.414A7.98 7.98 0 0 1 0 8c0-2.208.896-4.208 2.344-5.656m9.191 2.121A4.98 4.98 0 0 1 13 8c0 1.38-.56 2.63-1.465 3.535l-1.414-1.414A3 3 0 0 0 11 8a3 3 0 0 0-.879-2.121zm-7.07 0 1.414 1.414A3 3 0 0 0 5 8c0 .828.336 1.578.879 2.121l-1.414 1.414A4.98 4.98 0 0 1 3 8c0-1.38.56-2.63 1.465-3.535M8 6a2 2 0 1 1-.001 4.001A2 2 0 0 1 8 6'
    })));
const $9138db1f951ed55c$export$2eb1b0b2d752ea4b = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M13 12v-1h2a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-.75a.25.25 0 0 0-.25.25v.5a.25.25 0 0 0 .25.25H16v1h-2a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h.75a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25zm-1 3h-2v-5H4v5H2V6c0-2.76 2.24-5 5-5s5 2.24 5 5zm-2-7V6a3.001 3.001 0 0 0-6 0v2z',
        style: {
            fillRule: 'nonzero'
        }
    })));
const $9138db1f951ed55c$export$b147170bf0ac6406 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M13 12v-1h2a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-.75a.25.25 0 0 0-.25.25v.5a.25.25 0 0 0 .25.25H16v1h-2a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h.75a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25zM8.414 8l4 4H9.586L7 9.414 4.414 12H1.586l4-4-4-4h2.828L7 6.586 9.586 4h2.828z'
    })));
const $9138db1f951ed55c$export$831d605561b8cca5 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M12 15h-2v-5H4v5H2V6c0-2.76 2.24-5 5-5s5 2.24 5 5zm-2-7V6a3.001 3.001 0 0 0-6 0v2zm3-7V0h2a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-.75a.25.25 0 0 0-.25.25v.5a.25.25 0 0 0 .25.25H16v1h-2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h.75a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25z'
    })));
const $9138db1f951ed55c$export$3a4c80bfe15d601a = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'm8.414 8 4 4H9.586L7 9.414 4.414 12H1.586l4-4-4-4h2.828L7 6.586 9.586 4h2.828zM13 1V0h2a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-.75a.25.25 0 0 0-.25.25v.5a.25.25 0 0 0 .25.25H16v1h-2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h.75a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25z'
    })));
const $9138db1f951ed55c$export$8702548ed1d7ac29 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M0 11h11.2l-2.6 2.6L10 15l6-6H0zm4.8-6 2.6-2.6L6 1 0 7h16V5z'
    })));
const $9138db1f951ed55c$export$4a3cdaf8654d6ecf = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M5 16V4.8L2.4 7.4 1 6l6-6v16zm6-4.8 2.6-2.6L15 10l-6 6V0h2z'
    })));
const $9138db1f951ed55c$export$7f7b28202d8c7331 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M12 11v2h2v-2h2V9h-2V7h-2v2h-2v2zm2-5V1a.997.997 0 0 0-1-1H3a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-1H9V2h3v4zM4 2h3v12H4z'
    })));
const $9138db1f951ed55c$export$ca16e8c9b654c9e9 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M11 12h2v2h-2v2H9v-2H7v-2h2v-2h2zm-5 2H1a.997.997 0 0 1-1-1V3a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-1V9H2v3h4zM2 4v3h12V4z'
    })));
const $9138db1f951ed55c$export$5784f2a304a439e3 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M11.414 13 13 11.414 14.586 13 16 11.586 14.414 10 16 8.414 14.586 7 13 8.586 11.414 7 10 8.414 11.586 10 10 11.586zM14 6V1a.997.997 0 0 0-1-1H3a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-1H9V2h3v4zM4 2h3v12H4z'
    })));
const $9138db1f951ed55c$export$51fa6d51058f66a4 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M13 11.414 11.414 13 13 14.586 11.586 16 10 14.414 8.414 16 7 14.586 8.586 13 7 11.414 8.414 10 10 11.586 11.586 10zM6 14H1a.997.997 0 0 1-1-1V3a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-1V9H2v3h4zM2 4v3h12V4z'
    })));
const $9138db1f951ed55c$export$c69ace2e6416b89c = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M1 16a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1zm1-9v7h2V7zm4 0v7h4V7zm6 0v7h2V7zM2 2v3h12V2z'
    })));
const $9138db1f951ed55c$export$7b73804de18dac8e = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M14.497 0H9.988c-.826 0-1.981.478-2.565 1.063L.438 8.047a1.506 1.506 0 0 0 0 2.125l5.389 5.389a1.506 1.506 0 0 0 2.125 0l6.984-6.984C15.522 7.993 16 6.838 16 6.012V1.503C16 .676 15.324 0 14.497 0M12.5 5a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 12.5 5'
    })));
const $9138db1f951ed55c$export$40d1ddcefe169242 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M8 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8m0 6.5c-1.378 0-2.5-1.122-2.5-2.5S6.622 5.5 8 5.5s2.5 1.122 2.5 2.5-1.122 2.5-2.5 2.5M8 7a1 1 0 1 0 0 2 1 1 0 1 0 0-2m0-7C3.581 0 0 3.581 0 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8m4.244 12.244C11.109 13.375 9.603 14 8 14s-3.109-.625-4.244-1.756S2 9.603 2 8s.625-3.109 1.756-4.244S6.397 2 8 2s3.109.625 4.244 1.756S14 6.397 14 8s-.625 3.109-1.756 4.244'
    })));
const $9138db1f951ed55c$export$3b8ef319a6c5f131 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M0 10h16V8H0zM0 0v2h16V0zm0 14h8v-2H0zm0-8h16V4H0z'
    })));
const $9138db1f951ed55c$export$7679025d661a5f99 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M2 9.014 3.414 7.6l2.59 2.589L12.593 3.6l1.414 1.414-8.004 8.003z'
    })));
const $9138db1f951ed55c$export$6a564a3c64a0c770 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M0 9.014 1.414 7.6l3.59 3.589L14.593 1.6l1.414 1.414L5.003 14.017z'
    })));
const $9138db1f951ed55c$export$5918e8962b6636e9 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M11 5h2v8.5c0 .825-.675 1.5-1.5 1.5h-7c-.825 0-1.5-.675-1.5-1.5V5h2v8h2V5h2v8h2zM2 2h12v2H2zm4-2h4v1H6z'
    })));
const $9138db1f951ed55c$export$f7790cfaf03c8a87 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M8 11 3 6h10z'
    })));
const $9138db1f951ed55c$export$d0e1eaac53e25db1 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M8 13 0 5h16z'
    })));
const $9138db1f951ed55c$export$668e2789cbc708d7 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'm5 8 5-5v10z'
    })));
const $9138db1f951ed55c$export$1974c1a52230d9bf = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'm3 8 8-8v16z'
    })));
const $9138db1f951ed55c$export$501ada128b32fc9e = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'm11 8-5 5V3z'
    })));
const $9138db1f951ed55c$export$79a26f2c80e33f90 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'm13 8-8 8V0z'
    })));
const $9138db1f951ed55c$export$18dba1b5898bbfb1 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'm8 5 5 5H3z'
    })));
const $9138db1f951ed55c$export$9bef3663bbeb4db3 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'm8 3 8 8H0z'
    })));
const $9138db1f951ed55c$export$3c99c824037eed46 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M2 5h10.672l-1.837 1.834L12 8l4-4-4-4-1.166 1.166L12.672 3H0v7l2-2zm12 6H3.328l1.838-1.834L4 8l-4 4 4 4 1.166-1.166L3.328 13H16V6l-2 2z'
    })));
const $9138db1f951ed55c$export$bf9bd1a6e1a39cb5 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'm6 13-3 2 .889-2.667L0 10h16l-3.889 2.333L13 15l-3-2zm10-4H0V8l3-2c0-2.76 2.24-5 5-5s5 2.24 5 5l3 2z'
    })));
const $9138db1f951ed55c$export$193ca764ca13a0c5 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M3 13h10v2H3zm8-12h2v6c0 2.76-2.24 5-5 5S3 9.76 3 7V1h2v6a3.001 3.001 0 0 0 6 0z'
    })));
const $9138db1f951ed55c$export$6ec63552fd597a0c = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M3.294 7.706 4.71 9.122 7 6.828V16h2V6.828l2.294 2.294 1.416-1.416L8 3zM0 2h16V0H0z'
    })));
const $9138db1f951ed55c$export$1a820bf437484746 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M4.71 6.122 3.294 4.706 8 0l4.71 4.706-1.416 1.416L9 3.828V12H7V3.828zM2 14v-2H0v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2h-2v2z'
    })));
const $9138db1f951ed55c$export$65f5fd8d1a192873 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M3.294 7.706 4.71 9.122 7 6.828V16h2V6.828l2.294 2.294 1.416-1.416L8 3zM2 12V2h12v10h2V0H0v12z'
    })));
const $9138db1f951ed55c$export$de7094d8f3d0eff8 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M14 12.5a2.5 2.5 0 0 0-2.5-2.5h-7A2.5 2.5 0 0 0 2 12.5V15h12zM12 6h2a2 2 0 0 1 2 2v3h-1.337A3.5 3.5 0 0 0 11.5 9h-.855A4 4 0 0 0 12 6M1.337 11H0V8a2 2 0 0 1 2-2h2a4 4 0 0 0 1.355 3H4.5a3.5 3.5 0 0 0-3.163 2M8 3a3.001 3.001 0 0 1 0 6 3.001 3.001 0 0 1 0-6M4.127 4.996a2 2 0 1 1 1.825-2.432 4.01 4.01 0 0 0-1.825 2.432m5.921-2.432a2 2 0 1 1 1.825 2.432 4.01 4.01 0 0 0-1.825-2.432'
    })));
const $9138db1f951ed55c$export$24f630ce129477b6 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M8 8a4 4 0 1 0 0-8 4 4 0 0 0 0 8m4 2H4a4 4 0 0 0-4 4v2h16v-2a4 4 0 0 0-4-4'
    })));
const $9138db1f951ed55c$export$7c42224f1c8d83b0 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M16 12.5a2.5 2.5 0 0 0-2.5-2.5h-7A2.5 2.5 0 0 0 4 12.5V15h12zM3 13H0v-2.5A2.5 2.5 0 0 1 2.5 8h4.036c.218.376.495.714.819 1H6.5A3.5 3.5 0 0 0 3 12.5zm7-10a3.001 3.001 0 0 1 0 6 3.001 3.001 0 0 1 0-6M6.126 6.997 6 7a3.001 3.001 0 0 1 0-6c1.026 0 1.932.516 2.473 1.302a4.004 4.004 0 0 0-2.347 4.695'
    })));
const $9138db1f951ed55c$export$25372d620e7a1b0b = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M15 3v1.268A1.999 1.999 0 0 1 14 8a2 2 0 0 1-1-3.732V3.5a1.5 1.5 0 0 0-3 0v8.513A4 4 0 0 1 6 16c-2.208 0-4-1.792-4-4v-.171A3.001 3.001 0 1 1 6 9a3 3 0 0 1-2 2.829v.177a1.95 1.95 0 0 0 .157.772A2.001 2.001 0 0 0 8 12V3.5a3.501 3.501 0 0 1 6.964-.5zM3 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2'
    })));
const $9138db1f951ed55c$export$db99d8e121938012 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'M15.379 12.379 8.79 5.79c.123-.411.21-.839.21-1.29A4.5 4.5 0 0 0 4.5 0c-.451 0-.879.087-1.29.21l2.291 2.291a2.12 2.12 0 0 1 0 2.998l-.002.002a2.12 2.12 0 0 1-2.998 0L.21 3.21C.087 3.621 0 4.049 0 4.5A4.5 4.5 0 0 0 4.5 9c.451 0 .879-.087 1.29-.21l6.589 6.589a2.12 2.12 0 0 0 2.998 0l.002-.002a2.12 2.12 0 0 0 0-2.998M13.75 14.75a1 1 0 1 1 0-2 1 1 0 0 1 0 2'
    })));
const $9138db1f951ed55c$export$4cca98ab4f54f41d = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'm13.707 3.707-1.414-1.414L8 6.586 3.707 2.293 2.293 3.707 6.586 8l-4.293 4.293 1.414 1.414L8 9.414l4.293 4.293 1.414-1.414L9.414 8z'
    })));
const $9138db1f951ed55c$export$eeb267586df04918 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: 'none',
        d: 'M0 0h16v16H0z'
    }), $8v0nu.createElement("path", {
        d: 'm14.707 2.707-1.414-1.414L8 6.586 2.707 1.293 1.293 2.707 6.586 8l-5.293 5.293 1.414 1.414L8 9.414l5.293 5.293 1.414-1.414L9.414 8z'
    })));
const $9138db1f951ed55c$export$83d89fbfd8236492 = '4.0.0';



parcelRequire("8v0nu");


var $8v0nu = parcelRequire("8v0nu");



"use strict";
const $f85b338274abd06b$export$5cc3b7b83e34ade7 = (condition)=>condition ? "" : void 0;





var $8v0nu = parcelRequire("8v0nu");

"use strict";
"use client";
const $f80be8aeb6fc9430$export$5f1714a13ed34c01 = (0, $4042601bfa1a9d25$export$7cd122d781af9fa4)("span");
$f80be8aeb6fc9430$export$5f1714a13ed34c01.displayName = "Span";



"use strict";
"use client";
const { withContext: $87b59c672c3b6825$var$withContext, PropsProvider: $87b59c672c3b6825$var$PropsProvider } = (0, $aa5f4d03028a5427$export$e99ac154c18649c5)({
    key: "spinner"
});
const $87b59c672c3b6825$export$7f7cbe89f1eacd2 = $87b59c672c3b6825$var$withContext("span");
const $87b59c672c3b6825$export$ac4069e6bc5c57c5 = $87b59c672c3b6825$var$PropsProvider;



"use strict";
"use client";
const $91d5bccddd3f9d47$export$335dd19f2cdf1a5c = (0, $4042601bfa1a9d25$export$7cd122d781af9fa4)("div", {
    base: {
        position: "absolute",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    variants: {
        axis: {
            horizontal: {
                insetStart: "50%",
                translate: "-50%",
                _rtl: {
                    translate: "50%"
                }
            },
            vertical: {
                top: "50%",
                translate: "0 -50%"
            },
            both: {
                insetStart: "50%",
                top: "50%",
                translate: "-50% -50%",
                _rtl: {
                    translate: "50% -50%"
                }
            }
        }
    },
    defaultVariants: {
        axis: "both"
    }
});
$91d5bccddd3f9d47$export$335dd19f2cdf1a5c.displayName = "AbsoluteCenter";


"use strict";
const $c994b0c8eb791395$export$3b0d6d7590275603 = $8v0nu.forwardRef(function Loader2(props, ref) {
    const { spinner: spinner = /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $87b59c672c3b6825$export$7f7cbe89f1eacd2), {
        size: "inherit",
        borderWidth: "0.125em",
        color: "inherit"
    }), spinnerPlacement: spinnerPlacement = "start", children: children, text: text, visible: visible = true, ...rest } = props;
    if (!visible) return children;
    if (text) return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsxs)((0, $f80be8aeb6fc9430$export$5f1714a13ed34c01), {
        ref: ref,
        display: "contents",
        ...rest,
        children: [
            spinnerPlacement === "start" && spinner,
            text,
            spinnerPlacement === "end" && spinner
        ]
    });
    if (spinner) return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsxs)((0, $f80be8aeb6fc9430$export$5f1714a13ed34c01), {
        ref: ref,
        display: "contents",
        ...rest,
        children: [
            /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $91d5bccddd3f9d47$export$335dd19f2cdf1a5c), {
                display: "inline-flex",
                children: spinner
            }),
            /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $f80be8aeb6fc9430$export$5f1714a13ed34c01), {
                visibility: "hidden",
                display: "contents",
                children: children
            })
        ]
    });
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $f80be8aeb6fc9430$export$5f1714a13ed34c01), {
        ref: ref,
        display: "contents",
        ...rest,
        children: children
    });
});
$c994b0c8eb791395$export$3b0d6d7590275603.displayName = "Loader";


"use strict";
"use client";
const { useRecipeResult: $a987639d7be6b91e$var$useRecipeResult, PropsProvider: $a987639d7be6b91e$var$PropsProvider, usePropsContext: $a987639d7be6b91e$var$usePropsContext } = (0, $aa5f4d03028a5427$export$e99ac154c18649c5)({
    key: "button"
});
const $a987639d7be6b91e$export$353f5b6fc5456de1 = (0, $8v0nu.forwardRef)(function Button2(inProps, ref) {
    const propsContext = $a987639d7be6b91e$var$usePropsContext();
    const props = (0, $8v0nu.useMemo)(()=>(0, $c138fae1cd321339$export$9d1611c77c2fe928)(propsContext, inProps), [
        propsContext,
        inProps
    ]);
    const result = $a987639d7be6b91e$var$useRecipeResult(props);
    const { loading: loading, loadingText: loadingText, children: children, spinner: spinner, spinnerPlacement: spinnerPlacement, ...rest } = result.props;
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $4042601bfa1a9d25$export$7cd122d781af9fa4).button, {
        type: "button",
        ref: ref,
        ...rest,
        "data-loading": (0, $f85b338274abd06b$export$5cc3b7b83e34ade7)(loading),
        disabled: loading || rest.disabled,
        className: (0, $99474b193e949655$export$a274e22fb40f762e)(result.className, props.className),
        css: [
            result.styles,
            props.css
        ],
        children: !props.asChild && loading ? /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $c994b0c8eb791395$export$3b0d6d7590275603), {
            spinner: spinner,
            text: loadingText,
            spinnerPlacement: spinnerPlacement,
            children: children
        }) : children
    });
});
$a987639d7be6b91e$export$353f5b6fc5456de1.displayName = "Button";
const $a987639d7be6b91e$export$1e26e075ed062b9a = $a987639d7be6b91e$var$PropsProvider;




var $8v0nu = parcelRequire("8v0nu");

function $dfd76aae8c4830bc$export$644c29b44a905178({ title: title, overline: overline, actions: actions, ref: ref, ...rest }) {
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
        ref: ref,
        bg: "base.50",
        borderRadius: "md",
        p: 8,
        direction: "column",
        gap: 2,
        ...rest,
        children: [
            overline && /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9318c0c5b8c25a88$export$5f1af8db9871e1d6), {
                as: "p",
                color: "base.400",
                children: overline
            }),
            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
                gap: 4,
                justifyContent: "space-between",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $5dcf33ee745c0ffc$export$a8a3e93435678ff9), {
                        size: "lg",
                        lineClamp: 1,
                        as: "h1",
                        children: title
                    }),
                    actions && /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
                        gap: 2,
                        children: actions
                    })
                ]
            })
        ]
    });
}
function $dfd76aae8c4830bc$export$47c5baa971b64ccb(props) {
    const [isAtTop, setIsAtTop] = (0, $8v0nu.useState)(false);
    const ref = (0, $8v0nu.useRef)(null);
    (0, $8v0nu.useEffect)(()=>{
        const el = ref.current;
        if (!el) return;
        const observer = new IntersectionObserver(([entry])=>{
            setIsAtTop(entry.intersectionRatio < 1);
        }, {
            threshold: [
                1
            ]
        });
        observer.observe(el);
        return ()=>{
            observer.unobserve(el);
        };
    }, []);
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)($dfd76aae8c4830bc$export$644c29b44a905178, {
        ref: ref,
        position: "sticky",
        top: "-1px",
        boxShadow: isAtTop ? 'md' : 'none',
        zIndex: 100,
        ...props
    });
}



var $8v0nu = parcelRequire("8v0nu");
function $aec39e40387762bd$var$usePageTitle(title) {
    (0, $8v0nu.useEffect)(()=>{
        document.title = title;
    }, [
        title
    ]);
}
var $aec39e40387762bd$export$2e2bcd8739ae039 = $aec39e40387762bd$var$usePageTitle;




var $8v0nu = parcelRequire("8v0nu");
// src/AuthContext.ts

var $8v0nu = parcelRequire("8v0nu");
// src/utils/Logger.ts
class $763c7880287ce6c8$export$b9721ef022f71a68 extends Error {
}
$763c7880287ce6c8$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
function $763c7880287ce6c8$var$b64DecodeUnicode(str) {
    return decodeURIComponent(atob(str).replace(/(.)/g, (m, p)=>{
        let code = p.charCodeAt(0).toString(16).toUpperCase();
        if (code.length < 2) code = "0" + code;
        return "%" + code;
    }));
}
function $763c7880287ce6c8$var$base64UrlDecode(str) {
    let output = str.replace(/-/g, "+").replace(/_/g, "/");
    switch(output.length % 4){
        case 0:
            break;
        case 2:
            output += "==";
            break;
        case 3:
            output += "=";
            break;
        default:
            throw new Error("base64 string is not of the correct length");
    }
    try {
        return $763c7880287ce6c8$var$b64DecodeUnicode(output);
    } catch (err) {
        return atob(output);
    }
}
function $763c7880287ce6c8$export$fa1e2fb699b7861e(token, options) {
    if (typeof token !== "string") throw new $763c7880287ce6c8$export$b9721ef022f71a68("Invalid token specified: must be a string");
    options || (options = {});
    const pos = options.header === true ? 0 : 1;
    const part = token.split(".")[pos];
    if (typeof part !== "string") throw new $763c7880287ce6c8$export$b9721ef022f71a68(`Invalid token specified: missing part #${pos + 1}`);
    let decoded;
    try {
        decoded = $763c7880287ce6c8$var$base64UrlDecode(part);
    } catch (e) {
        throw new $763c7880287ce6c8$export$b9721ef022f71a68(`Invalid token specified: invalid base64 for part #${pos + 1} (${e.message})`);
    }
    try {
        return JSON.parse(decoded);
    } catch (e) {
        throw new $763c7880287ce6c8$export$b9721ef022f71a68(`Invalid token specified: invalid json for part #${pos + 1} (${e.message})`);
    }
}


var $91cdf6b8491513ba$var$nopLogger = {
    debug: ()=>void 0,
    info: ()=>void 0,
    warn: ()=>void 0,
    error: ()=>void 0
};
var $91cdf6b8491513ba$var$level;
var $91cdf6b8491513ba$var$logger;
var $91cdf6b8491513ba$export$ce30dbb46644d06c = /* @__PURE__ */ ((Log2)=>{
    Log2[Log2["NONE"] = 0] = "NONE";
    Log2[Log2["ERROR"] = 1] = "ERROR";
    Log2[Log2["WARN"] = 2] = "WARN";
    Log2[Log2["INFO"] = 3] = "INFO";
    Log2[Log2["DEBUG"] = 4] = "DEBUG";
    return Log2;
})($91cdf6b8491513ba$export$ce30dbb46644d06c || {});
((Log2)=>{
    function reset() {
        $91cdf6b8491513ba$var$level = 3 /* INFO */ ;
        $91cdf6b8491513ba$var$logger = $91cdf6b8491513ba$var$nopLogger;
    }
    Log2.reset = reset;
    function setLevel(value) {
        if (!(0 /* NONE */  <= value && value <= 4 /* DEBUG */ )) throw new Error("Invalid log level");
        $91cdf6b8491513ba$var$level = value;
    }
    Log2.setLevel = setLevel;
    function setLogger(value) {
        $91cdf6b8491513ba$var$logger = value;
    }
    Log2.setLogger = setLogger;
})($91cdf6b8491513ba$export$ce30dbb46644d06c || ($91cdf6b8491513ba$export$ce30dbb46644d06c = {}));
var $91cdf6b8491513ba$export$efa9a398d6368992 = class _Logger {
    constructor(_name){
        this._name = _name;
    }
    /* eslint-disable @typescript-eslint/no-unsafe-enum-comparison */ debug(...args) {
        if ($91cdf6b8491513ba$var$level >= 4 /* DEBUG */ ) $91cdf6b8491513ba$var$logger.debug(_Logger._format(this._name, this._method), ...args);
    }
    info(...args) {
        if ($91cdf6b8491513ba$var$level >= 3 /* INFO */ ) $91cdf6b8491513ba$var$logger.info(_Logger._format(this._name, this._method), ...args);
    }
    warn(...args) {
        if ($91cdf6b8491513ba$var$level >= 2 /* WARN */ ) $91cdf6b8491513ba$var$logger.warn(_Logger._format(this._name, this._method), ...args);
    }
    error(...args) {
        if ($91cdf6b8491513ba$var$level >= 1 /* ERROR */ ) $91cdf6b8491513ba$var$logger.error(_Logger._format(this._name, this._method), ...args);
    }
    /* eslint-enable @typescript-eslint/no-unsafe-enum-comparison */ throw(err) {
        this.error(err);
        throw err;
    }
    create(method) {
        const methodLogger = Object.create(this);
        methodLogger._method = method;
        methodLogger.debug("begin");
        return methodLogger;
    }
    static createStatic(name, staticMethod) {
        const staticLogger = new _Logger(`${name}.${staticMethod}`);
        staticLogger.debug("begin");
        return staticLogger;
    }
    static _format(name, method) {
        const prefix = `[${name}]`;
        return method ? `${prefix} ${method}:` : prefix;
    }
    /* eslint-disable @typescript-eslint/no-unsafe-enum-comparison */ // helpers for static class methods
    static debug(name, ...args) {
        if ($91cdf6b8491513ba$var$level >= 4 /* DEBUG */ ) $91cdf6b8491513ba$var$logger.debug(_Logger._format(name), ...args);
    }
    static info(name, ...args) {
        if ($91cdf6b8491513ba$var$level >= 3 /* INFO */ ) $91cdf6b8491513ba$var$logger.info(_Logger._format(name), ...args);
    }
    static warn(name, ...args) {
        if ($91cdf6b8491513ba$var$level >= 2 /* WARN */ ) $91cdf6b8491513ba$var$logger.warn(_Logger._format(name), ...args);
    }
    static error(name, ...args) {
        if ($91cdf6b8491513ba$var$level >= 1 /* ERROR */ ) $91cdf6b8491513ba$var$logger.error(_Logger._format(name), ...args);
    }
};
$91cdf6b8491513ba$export$ce30dbb46644d06c.reset();
var $91cdf6b8491513ba$var$JwtUtils = class {
    // IMPORTANT: doesn't validate the token
    static decode(token) {
        try {
            return (0, $763c7880287ce6c8$export$fa1e2fb699b7861e)(token);
        } catch (err) {
            $91cdf6b8491513ba$export$efa9a398d6368992.error("JwtUtils.decode", err);
            throw err;
        }
    }
    static async generateSignedJwt(header, payload, privateKey) {
        const encodedHeader = $91cdf6b8491513ba$var$CryptoUtils.encodeBase64Url(new TextEncoder().encode(JSON.stringify(header)));
        const encodedPayload = $91cdf6b8491513ba$var$CryptoUtils.encodeBase64Url(new TextEncoder().encode(JSON.stringify(payload)));
        const encodedToken = `${encodedHeader}.${encodedPayload}`;
        const signature = await window.crypto.subtle.sign({
            name: "ECDSA",
            hash: {
                name: "SHA-256"
            }
        }, privateKey, new TextEncoder().encode(encodedToken));
        const encodedSignature = $91cdf6b8491513ba$var$CryptoUtils.encodeBase64Url(new Uint8Array(signature));
        return `${encodedToken}.${encodedSignature}`;
    }
    static async generateSignedJwtWithHmac(header, payload, secretKey) {
        const encodedHeader = $91cdf6b8491513ba$var$CryptoUtils.encodeBase64Url(new TextEncoder().encode(JSON.stringify(header)));
        const encodedPayload = $91cdf6b8491513ba$var$CryptoUtils.encodeBase64Url(new TextEncoder().encode(JSON.stringify(payload)));
        const encodedToken = `${encodedHeader}.${encodedPayload}`;
        const signature = await window.crypto.subtle.sign("HMAC", secretKey, new TextEncoder().encode(encodedToken));
        const encodedSignature = $91cdf6b8491513ba$var$CryptoUtils.encodeBase64Url(new Uint8Array(signature));
        return `${encodedToken}.${encodedSignature}`;
    }
};
// src/utils/CryptoUtils.ts
var $91cdf6b8491513ba$var$UUID_V4_TEMPLATE = "10000000-1000-4000-8000-100000000000";
var $91cdf6b8491513ba$var$toBase64 = (val)=>btoa([
        ...new Uint8Array(val)
    ].map((chr)=>String.fromCharCode(chr)).join(""));
var $91cdf6b8491513ba$var$_CryptoUtils = class _CryptoUtils {
    static _randomWord() {
        const arr = new Uint32Array(1);
        crypto.getRandomValues(arr);
        return arr[0];
    }
    /**
   * Generates RFC4122 version 4 guid
   */ static generateUUIDv4() {
        const uuid = $91cdf6b8491513ba$var$UUID_V4_TEMPLATE.replace(/[018]/g, (c)=>(+c ^ _CryptoUtils._randomWord() & 15 >> +c / 4).toString(16));
        return uuid.replace(/-/g, "");
    }
    /**
   * PKCE: Generate a code verifier
   */ static generateCodeVerifier() {
        return _CryptoUtils.generateUUIDv4() + _CryptoUtils.generateUUIDv4() + _CryptoUtils.generateUUIDv4();
    }
    /**
   * PKCE: Generate a code challenge
   */ static async generateCodeChallenge(code_verifier) {
        if (!crypto.subtle) throw new Error("Crypto.subtle is available only in secure contexts (HTTPS).");
        try {
            const encoder = new TextEncoder();
            const data = encoder.encode(code_verifier);
            const hashed = await crypto.subtle.digest("SHA-256", data);
            return $91cdf6b8491513ba$var$toBase64(hashed).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
        } catch (err) {
            $91cdf6b8491513ba$export$efa9a398d6368992.error("CryptoUtils.generateCodeChallenge", err);
            throw err;
        }
    }
    /**
   * Generates a base64-encoded string for a basic auth header
   */ static generateBasicAuth(client_id, client_secret) {
        const encoder = new TextEncoder();
        const data = encoder.encode([
            client_id,
            client_secret
        ].join(":"));
        return $91cdf6b8491513ba$var$toBase64(data);
    }
    /**
   * Generates a hash of a string using a given algorithm
   * @param alg
   * @param message
   */ static async hash(alg, message) {
        const msgUint8 = new TextEncoder().encode(message);
        const hashBuffer = await crypto.subtle.digest(alg, msgUint8);
        return new Uint8Array(hashBuffer);
    }
    /**
   * Generates a rfc7638 compliant jwk thumbprint
   * @param jwk
   */ static async customCalculateJwkThumbprint(jwk) {
        let jsonObject;
        switch(jwk.kty){
            case "RSA":
                jsonObject = {
                    "e": jwk.e,
                    "kty": jwk.kty,
                    "n": jwk.n
                };
                break;
            case "EC":
                jsonObject = {
                    "crv": jwk.crv,
                    "kty": jwk.kty,
                    "x": jwk.x,
                    "y": jwk.y
                };
                break;
            case "OKP":
                jsonObject = {
                    "crv": jwk.crv,
                    "kty": jwk.kty,
                    "x": jwk.x
                };
                break;
            case "oct":
                jsonObject = {
                    "crv": jwk.k,
                    "kty": jwk.kty
                };
                break;
            default:
                throw new Error("Unknown jwk type");
        }
        const utf8encodedAndHashed = await _CryptoUtils.hash("SHA-256", JSON.stringify(jsonObject));
        return _CryptoUtils.encodeBase64Url(utf8encodedAndHashed);
    }
    static async generateDPoPProof({ url: url, accessToken: accessToken, httpMethod: httpMethod, keyPair: keyPair, nonce: nonce }) {
        let hashedToken;
        let encodedHash;
        const payload = {
            "jti": window.crypto.randomUUID(),
            "htm": httpMethod != null ? httpMethod : "GET",
            "htu": url,
            "iat": Math.floor(Date.now() / 1e3)
        };
        if (accessToken) {
            hashedToken = await _CryptoUtils.hash("SHA-256", accessToken);
            encodedHash = _CryptoUtils.encodeBase64Url(hashedToken);
            payload.ath = encodedHash;
        }
        if (nonce) payload.nonce = nonce;
        try {
            const publicJwk = await crypto.subtle.exportKey("jwk", keyPair.publicKey);
            const header = {
                "alg": "ES256",
                "typ": "dpop+jwt",
                "jwk": {
                    "crv": publicJwk.crv,
                    "kty": publicJwk.kty,
                    "x": publicJwk.x,
                    "y": publicJwk.y
                }
            };
            return await $91cdf6b8491513ba$var$JwtUtils.generateSignedJwt(header, payload, keyPair.privateKey);
        } catch (err) {
            if (err instanceof TypeError) throw new Error(`Error exporting dpop public key: ${err.message}`);
            else throw err;
        }
    }
    static async generateDPoPJkt(keyPair) {
        try {
            const publicJwk = await crypto.subtle.exportKey("jwk", keyPair.publicKey);
            return await _CryptoUtils.customCalculateJwkThumbprint(publicJwk);
        } catch (err) {
            if (err instanceof TypeError) throw new Error(`Could not retrieve dpop keys from storage: ${err.message}`);
            else throw err;
        }
    }
    static async generateDPoPKeys() {
        return await window.crypto.subtle.generateKey({
            name: "ECDSA",
            namedCurve: "P-256"
        }, false, [
            "sign",
            "verify"
        ]);
    }
    /**
   * Generates a client assertion JWT for client_secret_jwt authentication
   * @param client_id The client identifier
   * @param client_secret The client secret
   * @param audience The token endpoint URL (audience)
   * @param algorithm The HMAC algorithm to use (HS256, HS384, HS512). Defaults to HS256
   */ static async generateClientAssertionJwt(client_id, client_secret, audience, algorithm = "HS256") {
        const now = Math.floor(Date.now() / 1e3);
        const header = {
            "alg": algorithm,
            "typ": "JWT"
        };
        const payload = {
            "iss": client_id,
            "sub": client_id,
            "aud": audience,
            "jti": _CryptoUtils.generateUUIDv4(),
            "exp": now + 300,
            // 5 minutes
            "iat": now
        };
        const hashMap = {
            "HS256": "SHA-256",
            "HS384": "SHA-384",
            "HS512": "SHA-512"
        };
        const hashFunction = hashMap[algorithm];
        if (!hashFunction) throw new Error(`Unsupported algorithm: ${algorithm}. Supported algorithms are: HS256, HS384, HS512`);
        const encoder = new TextEncoder();
        const secretKey = await crypto.subtle.importKey("raw", encoder.encode(client_secret), {
            name: "HMAC",
            hash: hashFunction
        }, false, [
            "sign"
        ]);
        return await $91cdf6b8491513ba$var$JwtUtils.generateSignedJwtWithHmac(header, payload, secretKey);
    }
};
/**
 * Generates a base64url encoded string
 */ $91cdf6b8491513ba$var$_CryptoUtils.encodeBase64Url = (input)=>{
    return $91cdf6b8491513ba$var$toBase64(input).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
};
var $91cdf6b8491513ba$var$CryptoUtils = $91cdf6b8491513ba$var$_CryptoUtils;
// src/utils/Event.ts
var $91cdf6b8491513ba$var$Event = class {
    constructor(_name){
        this._name = _name;
        this._callbacks = [];
        this._logger = new $91cdf6b8491513ba$export$efa9a398d6368992(`Event('${this._name}')`);
    }
    addHandler(cb) {
        this._callbacks.push(cb);
        return ()=>this.removeHandler(cb);
    }
    removeHandler(cb) {
        const idx = this._callbacks.lastIndexOf(cb);
        if (idx >= 0) this._callbacks.splice(idx, 1);
    }
    async raise(...ev) {
        this._logger.debug("raise:", ...ev);
        for (const cb of this._callbacks)await cb(...ev);
    }
};
// src/utils/PopupUtils.ts
var $91cdf6b8491513ba$var$PopupUtils = class {
    /**
   * Populates a map of window features with a placement centered in front of
   * the current window. If no explicit width is given, a default value is
   * binned into [800, 720, 600, 480, 360] based on the current window's width.
   */ static center({ ...features }) {
        var _a, _b, _c;
        if (features.width == null) features.width = (_a = [
            800,
            720,
            600,
            480
        ].find((width)=>width <= window.outerWidth / 1.618)) != null ? _a : 360;
        (_b = features.left) != null ? _b : features.left = Math.max(0, Math.round(window.screenX + (window.outerWidth - features.width) / 2));
        if (features.height != null) (_c = features.top) != null ? _c : features.top = Math.max(0, Math.round(window.screenY + (window.outerHeight - features.height) / 2));
        return features;
    }
    static serialize(features) {
        return Object.entries(features).filter(([, value])=>value != null).map(([key, value])=>`${key}=${typeof value !== "boolean" ? value : value ? "yes" : "no"}`).join(",");
    }
};
// src/utils/Timer.ts
var $91cdf6b8491513ba$var$Timer = class _Timer extends $91cdf6b8491513ba$var$Event {
    constructor(){
        super(...arguments);
        this._logger = new $91cdf6b8491513ba$export$efa9a398d6368992(`Timer('${this._name}')`);
        this._timerHandle = null;
        this._expiration = 0;
        this._callback = ()=>{
            const diff = this._expiration - _Timer.getEpochTime();
            this._logger.debug("timer completes in", diff);
            if (this._expiration <= _Timer.getEpochTime()) {
                this.cancel();
                super.raise();
            }
        };
    }
    // get the time
    static getEpochTime() {
        return Math.floor(Date.now() / 1e3);
    }
    init(durationInSeconds) {
        const logger2 = this._logger.create("init");
        durationInSeconds = Math.max(Math.floor(durationInSeconds), 1);
        const expiration = _Timer.getEpochTime() + durationInSeconds;
        if (this.expiration === expiration && this._timerHandle) {
            logger2.debug("skipping since already initialized for expiration at", this.expiration);
            return;
        }
        this.cancel();
        logger2.debug("using duration", durationInSeconds);
        this._expiration = expiration;
        const timerDurationInSeconds = Math.min(durationInSeconds, 5);
        this._timerHandle = setInterval(this._callback, timerDurationInSeconds * 1e3);
    }
    get expiration() {
        return this._expiration;
    }
    cancel() {
        this._logger.create("cancel");
        if (this._timerHandle) {
            clearInterval(this._timerHandle);
            this._timerHandle = null;
        }
    }
};
// src/utils/UrlUtils.ts
var $91cdf6b8491513ba$var$UrlUtils = class {
    static readParams(url, responseMode = "query") {
        if (!url) throw new TypeError("Invalid URL");
        const parsedUrl = new URL(url, "http://127.0.0.1");
        const params = parsedUrl[responseMode === "fragment" ? "hash" : "search"];
        return new URLSearchParams(params.slice(1));
    }
};
var $91cdf6b8491513ba$var$URL_STATE_DELIMITER = ";";
// src/errors/ErrorResponse.ts
var $91cdf6b8491513ba$export$acf1a680051f5031 = class extends Error {
    constructor(args, form){
        var _a, _b, _c;
        super(args.error_description || args.error || "");
        this.form = form;
        /** Marker to detect class: "ErrorResponse" */ this.name = "ErrorResponse";
        if (!args.error) {
            $91cdf6b8491513ba$export$efa9a398d6368992.error("ErrorResponse", "No error passed");
            throw new Error("No error passed");
        }
        this.error = args.error;
        this.error_description = (_a = args.error_description) != null ? _a : null;
        this.error_uri = (_b = args.error_uri) != null ? _b : null;
        this.state = args.userState;
        this.session_state = (_c = args.session_state) != null ? _c : null;
        this.url_state = args.url_state;
    }
};
// src/errors/ErrorTimeout.ts
var $91cdf6b8491513ba$export$5312ab5d2c8d859c = class extends Error {
    constructor(message){
        super(message);
        /** Marker to detect class: "ErrorTimeout" */ this.name = "ErrorTimeout";
    }
};
// src/AccessTokenEvents.ts
var $91cdf6b8491513ba$export$3b2b5f2b57921d4f = class {
    constructor(args){
        this._logger = new $91cdf6b8491513ba$export$efa9a398d6368992("AccessTokenEvents");
        this._expiringTimer = new $91cdf6b8491513ba$var$Timer("Access token expiring");
        this._expiredTimer = new $91cdf6b8491513ba$var$Timer("Access token expired");
        this._expiringNotificationTimeInSeconds = args.expiringNotificationTimeInSeconds;
    }
    async load(container) {
        const logger2 = this._logger.create("load");
        if (container.access_token && container.expires_in !== void 0) {
            const duration = container.expires_in;
            logger2.debug("access token present, remaining duration:", duration);
            if (duration > 0) {
                let expiring = duration - this._expiringNotificationTimeInSeconds;
                if (expiring <= 0) expiring = 1;
                logger2.debug("registering expiring timer, raising in", expiring, "seconds");
                this._expiringTimer.init(expiring);
            } else {
                logger2.debug("canceling existing expiring timer because we're past expiration.");
                this._expiringTimer.cancel();
            }
            const expired = duration + 1;
            logger2.debug("registering expired timer, raising in", expired, "seconds");
            this._expiredTimer.init(expired);
        } else {
            this._expiringTimer.cancel();
            this._expiredTimer.cancel();
        }
    }
    async unload() {
        this._logger.debug("unload: canceling existing access token timers");
        this._expiringTimer.cancel();
        this._expiredTimer.cancel();
    }
    /**
   * Add callback: Raised prior to the access token expiring.
   */ addAccessTokenExpiring(cb) {
        return this._expiringTimer.addHandler(cb);
    }
    /**
   * Remove callback: Raised prior to the access token expiring.
   */ removeAccessTokenExpiring(cb) {
        this._expiringTimer.removeHandler(cb);
    }
    /**
   * Add callback: Raised after the access token has expired.
   */ addAccessTokenExpired(cb) {
        return this._expiredTimer.addHandler(cb);
    }
    /**
   * Remove callback: Raised after the access token has expired.
   */ removeAccessTokenExpired(cb) {
        this._expiredTimer.removeHandler(cb);
    }
};
// src/CheckSessionIFrame.ts
var $91cdf6b8491513ba$export$e3e6062266eff2d4 = class {
    constructor(_callback, _client_id, url, _intervalInSeconds, _stopOnError){
        this._callback = _callback;
        this._client_id = _client_id;
        this._intervalInSeconds = _intervalInSeconds;
        this._stopOnError = _stopOnError;
        this._logger = new $91cdf6b8491513ba$export$efa9a398d6368992("CheckSessionIFrame");
        this._timer = null;
        this._session_state = null;
        this._message = (e)=>{
            if (e.origin === this._frame_origin && e.source === this._frame.contentWindow) {
                if (e.data === "error") {
                    this._logger.error("error message from check session op iframe");
                    if (this._stopOnError) this.stop();
                } else if (e.data === "changed") {
                    this._logger.debug("changed message from check session op iframe");
                    this.stop();
                    this._callback();
                } else this._logger.debug(e.data + " message from check session op iframe");
            }
        };
        const parsedUrl = new URL(url);
        this._frame_origin = parsedUrl.origin;
        this._frame = window.document.createElement("iframe");
        this._frame.style.visibility = "hidden";
        this._frame.style.position = "fixed";
        this._frame.style.left = "-1000px";
        this._frame.style.top = "0";
        this._frame.width = "0";
        this._frame.height = "0";
        this._frame.src = parsedUrl.href;
    }
    load() {
        return new Promise((resolve)=>{
            this._frame.onload = ()=>{
                resolve();
            };
            window.document.body.appendChild(this._frame);
            window.addEventListener("message", this._message, false);
        });
    }
    start(session_state) {
        if (this._session_state === session_state) return;
        this._logger.create("start");
        this.stop();
        this._session_state = session_state;
        const send = ()=>{
            if (!this._frame.contentWindow || !this._session_state) return;
            this._frame.contentWindow.postMessage(this._client_id + " " + this._session_state, this._frame_origin);
        };
        send();
        this._timer = setInterval(send, this._intervalInSeconds * 1e3);
    }
    stop() {
        this._logger.create("stop");
        this._session_state = null;
        if (this._timer) {
            clearInterval(this._timer);
            this._timer = null;
        }
    }
};
// src/InMemoryWebStorage.ts
var $91cdf6b8491513ba$export$46e428416143c79c = class {
    constructor(){
        this._logger = new $91cdf6b8491513ba$export$efa9a398d6368992("InMemoryWebStorage");
        this._data = {};
    }
    clear() {
        this._logger.create("clear");
        this._data = {};
    }
    getItem(key) {
        this._logger.create(`getItem('${key}')`);
        return this._data[key];
    }
    setItem(key, value) {
        this._logger.create(`setItem('${key}')`);
        this._data[key] = value;
    }
    removeItem(key) {
        this._logger.create(`removeItem('${key}')`);
        delete this._data[key];
    }
    get length() {
        return Object.getOwnPropertyNames(this._data).length;
    }
    key(index) {
        return Object.getOwnPropertyNames(this._data)[index];
    }
};
// src/errors/ErrorDPoPNonce.ts
var $91cdf6b8491513ba$var$ErrorDPoPNonce = class extends Error {
    constructor(nonce, message){
        super(message);
        /** Marker to detect class: "ErrorDPoPNonce" */ this.name = "ErrorDPoPNonce";
        this.nonce = nonce;
    }
};
// src/JsonService.ts
var $91cdf6b8491513ba$var$JsonService = class {
    constructor(additionalContentTypes = [], _jwtHandler = null, _extraHeaders = {}){
        this._jwtHandler = _jwtHandler;
        this._extraHeaders = _extraHeaders;
        this._logger = new $91cdf6b8491513ba$export$efa9a398d6368992("JsonService");
        this._contentTypes = [];
        this._contentTypes.push(...additionalContentTypes, "application/json");
        if (_jwtHandler) this._contentTypes.push("application/jwt");
    }
    async fetchWithTimeout(input, init = {}) {
        const { timeoutInSeconds: timeoutInSeconds, ...initFetch } = init;
        if (!timeoutInSeconds) return await fetch(input, initFetch);
        const controller = new AbortController();
        const timeoutId = setTimeout(()=>controller.abort(), timeoutInSeconds * 1e3);
        try {
            const response = await fetch(input, {
                ...init,
                signal: controller.signal
            });
            return response;
        } catch (err) {
            if (err instanceof DOMException && err.name === "AbortError") throw new $91cdf6b8491513ba$export$5312ab5d2c8d859c("Network timed out");
            throw err;
        } finally{
            clearTimeout(timeoutId);
        }
    }
    async getJson(url, { token: token, credentials: credentials, timeoutInSeconds: timeoutInSeconds } = {}) {
        const logger2 = this._logger.create("getJson");
        const headers = {
            "Accept": this._contentTypes.join(", ")
        };
        if (token) {
            logger2.debug("token passed, setting Authorization header");
            headers["Authorization"] = "Bearer " + token;
        }
        this._appendExtraHeaders(headers);
        let response;
        try {
            logger2.debug("url:", url);
            response = await this.fetchWithTimeout(url, {
                method: "GET",
                headers: headers,
                timeoutInSeconds: timeoutInSeconds,
                credentials: credentials
            });
        } catch (err) {
            logger2.error("Network Error");
            throw err;
        }
        logger2.debug("HTTP response received, status", response.status);
        const contentType = response.headers.get("Content-Type");
        if (contentType && !this._contentTypes.find((item)=>contentType.startsWith(item))) logger2.throw(new Error(`Invalid response Content-Type: ${contentType != null ? contentType : "undefined"}, from URL: ${url}`));
        if (response.ok && this._jwtHandler && (contentType == null ? void 0 : contentType.startsWith("application/jwt"))) return await this._jwtHandler(await response.text());
        let json;
        try {
            json = await response.json();
        } catch (err) {
            logger2.error("Error parsing JSON response", err);
            if (response.ok) throw err;
            throw new Error(`${response.statusText} (${response.status})`);
        }
        if (!response.ok) {
            logger2.error("Error from server:", json);
            if (json.error) throw new $91cdf6b8491513ba$export$acf1a680051f5031(json);
            throw new Error(`${response.statusText} (${response.status}): ${JSON.stringify(json)}`);
        }
        return json;
    }
    async postForm(url, { body: body, basicAuth: basicAuth, timeoutInSeconds: timeoutInSeconds, initCredentials: initCredentials, extraHeaders: extraHeaders }) {
        const logger2 = this._logger.create("postForm");
        const headers = {
            "Accept": this._contentTypes.join(", "),
            "Content-Type": "application/x-www-form-urlencoded",
            ...extraHeaders
        };
        if (basicAuth !== void 0) headers["Authorization"] = "Basic " + basicAuth;
        this._appendExtraHeaders(headers);
        let response;
        try {
            logger2.debug("url:", url);
            response = await this.fetchWithTimeout(url, {
                method: "POST",
                headers: headers,
                body: body,
                timeoutInSeconds: timeoutInSeconds,
                credentials: initCredentials
            });
        } catch (err) {
            logger2.error("Network error");
            throw err;
        }
        logger2.debug("HTTP response received, status", response.status);
        const contentType = response.headers.get("Content-Type");
        if (contentType && !this._contentTypes.find((item)=>contentType.startsWith(item))) throw new Error(`Invalid response Content-Type: ${contentType != null ? contentType : "undefined"}, from URL: ${url}`);
        const responseText = await response.text();
        let json = {};
        if (responseText) try {
            json = JSON.parse(responseText);
        } catch (err) {
            logger2.error("Error parsing JSON response", err);
            if (response.ok) throw err;
            throw new Error(`${response.statusText} (${response.status})`);
        }
        if (!response.ok) {
            logger2.error("Error from server:", json);
            if (response.headers.has("dpop-nonce")) {
                const nonce = response.headers.get("dpop-nonce");
                throw new $91cdf6b8491513ba$var$ErrorDPoPNonce(nonce, `${JSON.stringify(json)}`);
            }
            if (json.error) throw new $91cdf6b8491513ba$export$acf1a680051f5031(json, body);
            throw new Error(`${response.statusText} (${response.status}): ${JSON.stringify(json)}`);
        }
        return json;
    }
    _appendExtraHeaders(headers) {
        const logger2 = this._logger.create("appendExtraHeaders");
        const customKeys = Object.keys(this._extraHeaders);
        const protectedHeaders = [
            "accept",
            "content-type"
        ];
        const preventOverride = [
            "authorization"
        ];
        if (customKeys.length === 0) return;
        customKeys.forEach((headerName)=>{
            if (protectedHeaders.includes(headerName.toLocaleLowerCase())) {
                logger2.warn("Protected header could not be set", headerName, protectedHeaders);
                return;
            }
            if (preventOverride.includes(headerName.toLocaleLowerCase()) && Object.keys(headers).includes(headerName)) {
                logger2.warn("Header could not be overridden", headerName, preventOverride);
                return;
            }
            const content = typeof this._extraHeaders[headerName] === "function" ? this._extraHeaders[headerName]() : this._extraHeaders[headerName];
            if (content && content !== "") headers[headerName] = content;
        });
    }
};
// src/MetadataService.ts
var $91cdf6b8491513ba$export$b732ab16be80c4ec = class {
    constructor(_settings){
        this._settings = _settings;
        this._logger = new $91cdf6b8491513ba$export$efa9a398d6368992("MetadataService");
        this._signingKeys = null;
        this._metadata = null;
        this._metadataUrl = this._settings.metadataUrl;
        this._jsonService = new $91cdf6b8491513ba$var$JsonService([
            "application/jwk-set+json"
        ], null, this._settings.extraHeaders);
        if (this._settings.signingKeys) {
            this._logger.debug("using signingKeys from settings");
            this._signingKeys = this._settings.signingKeys;
        }
        if (this._settings.metadata) {
            this._logger.debug("using metadata from settings");
            this._metadata = this._settings.metadata;
        }
        if (this._settings.fetchRequestCredentials) {
            this._logger.debug("using fetchRequestCredentials from settings");
            this._fetchRequestCredentials = this._settings.fetchRequestCredentials;
        }
    }
    resetSigningKeys() {
        this._signingKeys = null;
    }
    async getMetadata() {
        const logger2 = this._logger.create("getMetadata");
        if (this._metadata) {
            logger2.debug("using cached values");
            return this._metadata;
        }
        if (!this._metadataUrl) {
            logger2.throw(new Error("No authority or metadataUrl configured on settings"));
            throw null;
        }
        logger2.debug("getting metadata from", this._metadataUrl);
        const metadata = await this._jsonService.getJson(this._metadataUrl, {
            credentials: this._fetchRequestCredentials,
            timeoutInSeconds: this._settings.requestTimeoutInSeconds
        });
        logger2.debug("merging remote JSON with seed metadata");
        this._metadata = Object.assign({}, metadata, this._settings.metadataSeed);
        return this._metadata;
    }
    getIssuer() {
        return this._getMetadataProperty("issuer");
    }
    getAuthorizationEndpoint() {
        return this._getMetadataProperty("authorization_endpoint");
    }
    getUserInfoEndpoint() {
        return this._getMetadataProperty("userinfo_endpoint");
    }
    getTokenEndpoint(optional = true) {
        return this._getMetadataProperty("token_endpoint", optional);
    }
    getCheckSessionIframe() {
        return this._getMetadataProperty("check_session_iframe", true);
    }
    getEndSessionEndpoint() {
        return this._getMetadataProperty("end_session_endpoint", true);
    }
    getRevocationEndpoint(optional = true) {
        return this._getMetadataProperty("revocation_endpoint", optional);
    }
    getKeysEndpoint(optional = true) {
        return this._getMetadataProperty("jwks_uri", optional);
    }
    async _getMetadataProperty(name, optional = false) {
        const logger2 = this._logger.create(`_getMetadataProperty('${name}')`);
        const metadata = await this.getMetadata();
        logger2.debug("resolved");
        if (metadata[name] === void 0) {
            if (optional === true) {
                logger2.warn("Metadata does not contain optional property");
                return void 0;
            }
            logger2.throw(new Error("Metadata does not contain property " + name));
        }
        return metadata[name];
    }
    async getSigningKeys() {
        const logger2 = this._logger.create("getSigningKeys");
        if (this._signingKeys) {
            logger2.debug("returning signingKeys from cache");
            return this._signingKeys;
        }
        const jwks_uri = await this.getKeysEndpoint(false);
        logger2.debug("got jwks_uri", jwks_uri);
        const keySet = await this._jsonService.getJson(jwks_uri, {
            timeoutInSeconds: this._settings.requestTimeoutInSeconds
        });
        logger2.debug("got key set", keySet);
        if (!Array.isArray(keySet.keys)) {
            logger2.throw(new Error("Missing keys on keyset"));
            throw null;
        }
        this._signingKeys = keySet.keys;
        return this._signingKeys;
    }
};
// src/WebStorageStateStore.ts
var $91cdf6b8491513ba$export$6a5d9eefd8f07eee = class {
    constructor({ prefix: prefix = "oidc.", store: store = localStorage } = {}){
        this._logger = new $91cdf6b8491513ba$export$efa9a398d6368992("WebStorageStateStore");
        this._store = store;
        this._prefix = prefix;
    }
    async set(key, value) {
        this._logger.create(`set('${key}')`);
        key = this._prefix + key;
        await this._store.setItem(key, value);
    }
    async get(key) {
        this._logger.create(`get('${key}')`);
        key = this._prefix + key;
        const item = await this._store.getItem(key);
        return item;
    }
    async remove(key) {
        this._logger.create(`remove('${key}')`);
        key = this._prefix + key;
        const item = await this._store.getItem(key);
        await this._store.removeItem(key);
        return item;
    }
    async getAllKeys() {
        this._logger.create("getAllKeys");
        const len = await this._store.length;
        const keys = [];
        for(let index = 0; index < len; index++){
            const key = await this._store.key(index);
            if (key && key.indexOf(this._prefix) === 0) keys.push(key.substr(this._prefix.length));
        }
        return keys;
    }
};
// src/OidcClientSettings.ts
var $91cdf6b8491513ba$var$DefaultResponseType = "code";
var $91cdf6b8491513ba$var$DefaultScope = "openid";
var $91cdf6b8491513ba$var$DefaultClientAuthentication = "client_secret_post";
var $91cdf6b8491513ba$var$DefaultStaleStateAgeInSeconds = 900;
var $91cdf6b8491513ba$export$f0d75c4d483197bb = class {
    constructor({ authority: // metadata related
    authority, metadataUrl: metadataUrl, metadata: metadata, signingKeys: signingKeys, metadataSeed: metadataSeed, client_id: // client related
    client_id, client_secret: client_secret, response_type: response_type = $91cdf6b8491513ba$var$DefaultResponseType, scope: scope = $91cdf6b8491513ba$var$DefaultScope, redirect_uri: redirect_uri, post_logout_redirect_uri: post_logout_redirect_uri, client_authentication: client_authentication = $91cdf6b8491513ba$var$DefaultClientAuthentication, token_endpoint_auth_signing_alg: token_endpoint_auth_signing_alg = "HS256", prompt: // optional protocol
    prompt, display: display, max_age: max_age, ui_locales: ui_locales, acr_values: acr_values, resource: resource, response_mode: response_mode, filterProtocolClaims: // behavior flags
    filterProtocolClaims = true, loadUserInfo: loadUserInfo = false, requestTimeoutInSeconds: requestTimeoutInSeconds, staleStateAgeInSeconds: staleStateAgeInSeconds = $91cdf6b8491513ba$var$DefaultStaleStateAgeInSeconds, mergeClaimsStrategy: mergeClaimsStrategy = {
        array: "replace"
    }, disablePKCE: disablePKCE = false, stateStore: // other behavior
    stateStore, revokeTokenAdditionalContentTypes: revokeTokenAdditionalContentTypes, fetchRequestCredentials: fetchRequestCredentials, refreshTokenAllowedScope: refreshTokenAllowedScope, extraQueryParams: // extra
    extraQueryParams = {}, extraTokenParams: extraTokenParams = {}, extraHeaders: extraHeaders = {}, dpop: dpop, omitScopeWhenRequesting: omitScopeWhenRequesting = false }){
        var _a;
        this.authority = authority;
        if (metadataUrl) this.metadataUrl = metadataUrl;
        else {
            this.metadataUrl = authority;
            if (authority) {
                if (!this.metadataUrl.endsWith("/")) this.metadataUrl += "/";
                this.metadataUrl += ".well-known/openid-configuration";
            }
        }
        this.metadata = metadata;
        this.metadataSeed = metadataSeed;
        this.signingKeys = signingKeys;
        this.client_id = client_id;
        this.client_secret = client_secret;
        this.response_type = response_type;
        this.scope = scope;
        this.redirect_uri = redirect_uri;
        this.post_logout_redirect_uri = post_logout_redirect_uri;
        this.client_authentication = client_authentication;
        this.token_endpoint_auth_signing_alg = token_endpoint_auth_signing_alg;
        this.prompt = prompt;
        this.display = display;
        this.max_age = max_age;
        this.ui_locales = ui_locales;
        this.acr_values = acr_values;
        this.resource = resource;
        this.response_mode = response_mode;
        this.filterProtocolClaims = filterProtocolClaims != null ? filterProtocolClaims : true;
        this.loadUserInfo = !!loadUserInfo;
        this.staleStateAgeInSeconds = staleStateAgeInSeconds;
        this.mergeClaimsStrategy = mergeClaimsStrategy;
        this.omitScopeWhenRequesting = omitScopeWhenRequesting;
        this.disablePKCE = !!disablePKCE;
        this.revokeTokenAdditionalContentTypes = revokeTokenAdditionalContentTypes;
        this.fetchRequestCredentials = fetchRequestCredentials ? fetchRequestCredentials : "same-origin";
        this.requestTimeoutInSeconds = requestTimeoutInSeconds;
        if (stateStore) this.stateStore = stateStore;
        else {
            const store = typeof window !== "undefined" ? window.localStorage : new $91cdf6b8491513ba$export$46e428416143c79c();
            this.stateStore = new $91cdf6b8491513ba$export$6a5d9eefd8f07eee({
                store: store
            });
        }
        this.refreshTokenAllowedScope = refreshTokenAllowedScope;
        this.extraQueryParams = extraQueryParams;
        this.extraTokenParams = extraTokenParams;
        this.extraHeaders = extraHeaders;
        this.dpop = dpop;
        if (this.dpop && !((_a = this.dpop) == null ? void 0 : _a.store)) throw new Error("A DPoPStore is required when dpop is enabled");
    }
};
// src/UserInfoService.ts
var $91cdf6b8491513ba$var$UserInfoService = class {
    constructor(_settings, _metadataService){
        this._settings = _settings;
        this._metadataService = _metadataService;
        this._logger = new $91cdf6b8491513ba$export$efa9a398d6368992("UserInfoService");
        this._getClaimsFromJwt = async (responseText)=>{
            const logger2 = this._logger.create("_getClaimsFromJwt");
            try {
                const payload = $91cdf6b8491513ba$var$JwtUtils.decode(responseText);
                logger2.debug("JWT decoding successful");
                return payload;
            } catch (err) {
                logger2.error("Error parsing JWT response");
                throw err;
            }
        };
        this._jsonService = new $91cdf6b8491513ba$var$JsonService(void 0, this._getClaimsFromJwt, this._settings.extraHeaders);
    }
    async getClaims(token) {
        const logger2 = this._logger.create("getClaims");
        if (!token) this._logger.throw(new Error("No token passed"));
        const url = await this._metadataService.getUserInfoEndpoint();
        logger2.debug("got userinfo url", url);
        const claims = await this._jsonService.getJson(url, {
            token: token,
            credentials: this._settings.fetchRequestCredentials,
            timeoutInSeconds: this._settings.requestTimeoutInSeconds
        });
        logger2.debug("got claims", claims);
        return claims;
    }
};
// src/TokenClient.ts
var $91cdf6b8491513ba$var$TokenClient = class {
    constructor(_settings, _metadataService){
        this._settings = _settings;
        this._metadataService = _metadataService;
        this._logger = new $91cdf6b8491513ba$export$efa9a398d6368992("TokenClient");
        this._jsonService = new $91cdf6b8491513ba$var$JsonService(this._settings.revokeTokenAdditionalContentTypes, null, this._settings.extraHeaders);
    }
    /**
   * Exchange code.
   *
   * @see https://www.rfc-editor.org/rfc/rfc6749#section-4.1.3
   */ async exchangeCode({ grant_type: grant_type = "authorization_code", redirect_uri: redirect_uri = this._settings.redirect_uri, client_id: client_id = this._settings.client_id, client_secret: client_secret = this._settings.client_secret, extraHeaders: extraHeaders, ...args }) {
        const logger2 = this._logger.create("exchangeCode");
        if (!client_id) logger2.throw(new Error("A client_id is required"));
        if (!redirect_uri) logger2.throw(new Error("A redirect_uri is required"));
        if (!args.code) logger2.throw(new Error("A code is required"));
        const params = new URLSearchParams({
            grant_type: grant_type,
            redirect_uri: redirect_uri
        });
        for (const [key, value] of Object.entries(args))if (value != null) params.set(key, value);
        if ((this._settings.client_authentication === "client_secret_basic" || this._settings.client_authentication === "client_secret_jwt") && (client_secret === void 0 || client_secret === null)) {
            logger2.throw(new Error("A client_secret is required"));
            throw null;
        }
        let basicAuth;
        const url = await this._metadataService.getTokenEndpoint(false);
        switch(this._settings.client_authentication){
            case "client_secret_basic":
                basicAuth = $91cdf6b8491513ba$var$CryptoUtils.generateBasicAuth(client_id, client_secret);
                break;
            case "client_secret_post":
                params.append("client_id", client_id);
                if (client_secret) params.append("client_secret", client_secret);
                break;
            case "client_secret_jwt":
                {
                    const clientAssertion = await $91cdf6b8491513ba$var$CryptoUtils.generateClientAssertionJwt(client_id, client_secret, url, this._settings.token_endpoint_auth_signing_alg);
                    params.append("client_id", client_id);
                    params.append("client_assertion_type", "urn:ietf:params:oauth:client-assertion-type:jwt-bearer");
                    params.append("client_assertion", clientAssertion);
                    break;
                }
        }
        logger2.debug("got token endpoint");
        const response = await this._jsonService.postForm(url, {
            body: params,
            basicAuth: basicAuth,
            timeoutInSeconds: this._settings.requestTimeoutInSeconds,
            initCredentials: this._settings.fetchRequestCredentials,
            extraHeaders: extraHeaders
        });
        logger2.debug("got response");
        return response;
    }
    /**
   * Exchange credentials.
   *
   * @see https://www.rfc-editor.org/rfc/rfc6749#section-4.3.2
   */ async exchangeCredentials({ grant_type: grant_type = "password", client_id: client_id = this._settings.client_id, client_secret: client_secret = this._settings.client_secret, scope: scope = this._settings.scope, ...args }) {
        const logger2 = this._logger.create("exchangeCredentials");
        if (!client_id) logger2.throw(new Error("A client_id is required"));
        const params = new URLSearchParams({
            grant_type: grant_type
        });
        if (!this._settings.omitScopeWhenRequesting) params.set("scope", scope);
        for (const [key, value] of Object.entries(args))if (value != null) params.set(key, value);
        if ((this._settings.client_authentication === "client_secret_basic" || this._settings.client_authentication === "client_secret_jwt") && (client_secret === void 0 || client_secret === null)) {
            logger2.throw(new Error("A client_secret is required"));
            throw null;
        }
        let basicAuth;
        const url = await this._metadataService.getTokenEndpoint(false);
        switch(this._settings.client_authentication){
            case "client_secret_basic":
                basicAuth = $91cdf6b8491513ba$var$CryptoUtils.generateBasicAuth(client_id, client_secret);
                break;
            case "client_secret_post":
                params.append("client_id", client_id);
                if (client_secret) params.append("client_secret", client_secret);
                break;
            case "client_secret_jwt":
                {
                    const clientAssertion = await $91cdf6b8491513ba$var$CryptoUtils.generateClientAssertionJwt(client_id, client_secret, url, this._settings.token_endpoint_auth_signing_alg);
                    params.append("client_id", client_id);
                    params.append("client_assertion_type", "urn:ietf:params:oauth:client-assertion-type:jwt-bearer");
                    params.append("client_assertion", clientAssertion);
                    break;
                }
        }
        logger2.debug("got token endpoint");
        const response = await this._jsonService.postForm(url, {
            body: params,
            basicAuth: basicAuth,
            timeoutInSeconds: this._settings.requestTimeoutInSeconds,
            initCredentials: this._settings.fetchRequestCredentials
        });
        logger2.debug("got response");
        return response;
    }
    /**
   * Exchange a refresh token.
   *
   * @see https://www.rfc-editor.org/rfc/rfc6749#section-6
   */ async exchangeRefreshToken({ grant_type: grant_type = "refresh_token", client_id: client_id = this._settings.client_id, client_secret: client_secret = this._settings.client_secret, timeoutInSeconds: timeoutInSeconds, extraHeaders: extraHeaders, ...args }) {
        const logger2 = this._logger.create("exchangeRefreshToken");
        if (!client_id) logger2.throw(new Error("A client_id is required"));
        if (!args.refresh_token) logger2.throw(new Error("A refresh_token is required"));
        const params = new URLSearchParams({
            grant_type: grant_type
        });
        for (const [key, value] of Object.entries(args)){
            if (Array.isArray(value)) value.forEach((param)=>params.append(key, param));
            else if (value != null) params.set(key, value);
        }
        if ((this._settings.client_authentication === "client_secret_basic" || this._settings.client_authentication === "client_secret_jwt") && (client_secret === void 0 || client_secret === null)) {
            logger2.throw(new Error("A client_secret is required"));
            throw null;
        }
        let basicAuth;
        const url = await this._metadataService.getTokenEndpoint(false);
        switch(this._settings.client_authentication){
            case "client_secret_basic":
                basicAuth = $91cdf6b8491513ba$var$CryptoUtils.generateBasicAuth(client_id, client_secret);
                break;
            case "client_secret_post":
                params.append("client_id", client_id);
                if (client_secret) params.append("client_secret", client_secret);
                break;
            case "client_secret_jwt":
                {
                    const clientAssertion = await $91cdf6b8491513ba$var$CryptoUtils.generateClientAssertionJwt(client_id, client_secret, url, this._settings.token_endpoint_auth_signing_alg);
                    params.append("client_id", client_id);
                    params.append("client_assertion_type", "urn:ietf:params:oauth:client-assertion-type:jwt-bearer");
                    params.append("client_assertion", clientAssertion);
                    break;
                }
        }
        logger2.debug("got token endpoint");
        const response = await this._jsonService.postForm(url, {
            body: params,
            basicAuth: basicAuth,
            timeoutInSeconds: timeoutInSeconds,
            initCredentials: this._settings.fetchRequestCredentials,
            extraHeaders: extraHeaders
        });
        logger2.debug("got response");
        return response;
    }
    /**
   * Revoke an access or refresh token.
   *
   * @see https://datatracker.ietf.org/doc/html/rfc7009#section-2.1
   */ async revoke(args) {
        var _a;
        const logger2 = this._logger.create("revoke");
        if (!args.token) logger2.throw(new Error("A token is required"));
        const url = await this._metadataService.getRevocationEndpoint(false);
        logger2.debug(`got revocation endpoint, revoking ${(_a = args.token_type_hint) != null ? _a : "default token type"}`);
        const params = new URLSearchParams();
        for (const [key, value] of Object.entries(args))if (value != null) params.set(key, value);
        params.set("client_id", this._settings.client_id);
        if (this._settings.client_secret) params.set("client_secret", this._settings.client_secret);
        await this._jsonService.postForm(url, {
            body: params,
            timeoutInSeconds: this._settings.requestTimeoutInSeconds
        });
        logger2.debug("got response");
    }
};
// src/ResponseValidator.ts
var $91cdf6b8491513ba$var$ResponseValidator = class {
    constructor(_settings, _metadataService, _claimsService){
        this._settings = _settings;
        this._metadataService = _metadataService;
        this._claimsService = _claimsService;
        this._logger = new $91cdf6b8491513ba$export$efa9a398d6368992("ResponseValidator");
        this._userInfoService = new $91cdf6b8491513ba$var$UserInfoService(this._settings, this._metadataService);
        this._tokenClient = new $91cdf6b8491513ba$var$TokenClient(this._settings, this._metadataService);
    }
    async validateSigninResponse(response, state, extraHeaders) {
        const logger2 = this._logger.create("validateSigninResponse");
        this._processSigninState(response, state);
        logger2.debug("state processed");
        await this._processCode(response, state, extraHeaders);
        logger2.debug("code processed");
        if (response.isOpenId) this._validateIdTokenAttributes(response, "", state.nonce);
        logger2.debug("tokens validated");
        await this._processClaims(response, state == null ? void 0 : state.skipUserInfo, response.isOpenId);
        logger2.debug("claims processed");
    }
    async validateCredentialsResponse(response, skipUserInfo) {
        const logger2 = this._logger.create("validateCredentialsResponse");
        const shouldValidateSubClaim = response.isOpenId && !!response.id_token;
        if (shouldValidateSubClaim) this._validateIdTokenAttributes(response);
        logger2.debug("tokens validated");
        await this._processClaims(response, skipUserInfo, shouldValidateSubClaim);
        logger2.debug("claims processed");
    }
    async validateRefreshResponse(response, state) {
        var _a, _b;
        const logger2 = this._logger.create("validateRefreshResponse");
        response.userState = state.data;
        (_a = response.session_state) != null ? _a : response.session_state = state.session_state;
        (_b = response.scope) != null ? _b : response.scope = state.scope;
        if (response.isOpenId && !!response.id_token) {
            this._validateIdTokenAttributes(response, state.id_token);
            logger2.debug("ID Token validated");
        }
        if (!response.id_token) {
            response.id_token = state.id_token;
            response.profile = state.profile;
        }
        const hasIdToken = response.isOpenId && !!response.id_token;
        await this._processClaims(response, false, hasIdToken);
        logger2.debug("claims processed");
    }
    validateSignoutResponse(response, state) {
        const logger2 = this._logger.create("validateSignoutResponse");
        if (state.id !== response.state) logger2.throw(new Error("State does not match"));
        logger2.debug("state validated");
        response.userState = state.data;
        if (response.error) {
            logger2.warn("Response was error", response.error);
            throw new $91cdf6b8491513ba$export$acf1a680051f5031(response);
        }
    }
    _processSigninState(response, state) {
        var _a;
        const logger2 = this._logger.create("_processSigninState");
        if (state.id !== response.state) logger2.throw(new Error("State does not match"));
        if (!state.client_id) logger2.throw(new Error("No client_id on state"));
        if (!state.authority) logger2.throw(new Error("No authority on state"));
        if (this._settings.authority !== state.authority) logger2.throw(new Error("authority mismatch on settings vs. signin state"));
        if (this._settings.client_id && this._settings.client_id !== state.client_id) logger2.throw(new Error("client_id mismatch on settings vs. signin state"));
        logger2.debug("state validated");
        response.userState = state.data;
        response.url_state = state.url_state;
        (_a = response.scope) != null ? _a : response.scope = state.scope;
        if (response.error) {
            logger2.warn("Response was error", response.error);
            throw new $91cdf6b8491513ba$export$acf1a680051f5031(response);
        }
        if (state.code_verifier && !response.code) logger2.throw(new Error("Expected code in response"));
    }
    async _processClaims(response, skipUserInfo = false, validateSub = true) {
        const logger2 = this._logger.create("_processClaims");
        response.profile = this._claimsService.filterProtocolClaims(response.profile);
        if (skipUserInfo || !this._settings.loadUserInfo || !response.access_token) {
            logger2.debug("not loading user info");
            return;
        }
        logger2.debug("loading user info");
        const claims = await this._userInfoService.getClaims(response.access_token);
        logger2.debug("user info claims received from user info endpoint");
        if (validateSub && claims.sub !== response.profile.sub) logger2.throw(new Error("subject from UserInfo response does not match subject in ID Token"));
        response.profile = this._claimsService.mergeClaims(response.profile, this._claimsService.filterProtocolClaims(claims));
        logger2.debug("user info claims received, updated profile:", response.profile);
    }
    async _processCode(response, state, extraHeaders) {
        const logger2 = this._logger.create("_processCode");
        if (response.code) {
            logger2.debug("Validating code");
            const tokenResponse = await this._tokenClient.exchangeCode({
                client_id: state.client_id,
                client_secret: state.client_secret,
                code: response.code,
                redirect_uri: state.redirect_uri,
                code_verifier: state.code_verifier,
                extraHeaders: extraHeaders,
                ...state.extraTokenParams
            });
            Object.assign(response, tokenResponse);
        } else logger2.debug("No code to process");
    }
    _validateIdTokenAttributes(response, existingToken, nonce) {
        var _a;
        const logger2 = this._logger.create("_validateIdTokenAttributes");
        logger2.debug("decoding ID Token JWT");
        const incoming = $91cdf6b8491513ba$var$JwtUtils.decode((_a = response.id_token) != null ? _a : "");
        if (!incoming.sub) logger2.throw(new Error("ID Token is missing a subject claim"));
        if (nonce && incoming.nonce !== nonce) logger2.throw(new Error("nonce in id_token does not match nonce in client storage"));
        if (existingToken) {
            const existing = $91cdf6b8491513ba$var$JwtUtils.decode(existingToken);
            if (incoming.sub !== existing.sub) logger2.throw(new Error("sub in id_token does not match current sub"));
            if (incoming.auth_time && incoming.auth_time !== existing.auth_time) logger2.throw(new Error("auth_time in id_token does not match original auth_time"));
            if (incoming.azp && incoming.azp !== existing.azp) logger2.throw(new Error("azp in id_token does not match original azp"));
            if (!incoming.azp && existing.azp) logger2.throw(new Error("azp not in id_token, but present in original id_token"));
        }
        response.profile = incoming;
    }
};
// src/State.ts
var $91cdf6b8491513ba$export$7254cc27399e90bd = class _State {
    constructor(args){
        this.id = args.id || $91cdf6b8491513ba$var$CryptoUtils.generateUUIDv4();
        this.data = args.data;
        if (args.created && args.created > 0) this.created = args.created;
        else this.created = $91cdf6b8491513ba$var$Timer.getEpochTime();
        this.request_type = args.request_type;
        this.url_state = args.url_state;
    }
    toStorageString() {
        new $91cdf6b8491513ba$export$efa9a398d6368992("State").create("toStorageString");
        return JSON.stringify({
            id: this.id,
            data: this.data,
            created: this.created,
            request_type: this.request_type,
            url_state: this.url_state
        });
    }
    static fromStorageString(storageString) {
        $91cdf6b8491513ba$export$efa9a398d6368992.createStatic("State", "fromStorageString");
        return Promise.resolve(new _State(JSON.parse(storageString)));
    }
    static async clearStaleState(storage, age) {
        const logger2 = $91cdf6b8491513ba$export$efa9a398d6368992.createStatic("State", "clearStaleState");
        const cutoff = $91cdf6b8491513ba$var$Timer.getEpochTime() - age;
        const keys = await storage.getAllKeys();
        logger2.debug("got keys", keys);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const item = await storage.get(key);
            let remove = false;
            if (item) try {
                const state = await _State.fromStorageString(item);
                logger2.debug("got item from key:", key, state.created);
                if (state.created <= cutoff) remove = true;
            } catch (err) {
                logger2.error("Error parsing state for key:", key, err);
                remove = true;
            }
            else {
                logger2.debug("no item in storage for key:", key);
                remove = true;
            }
            if (remove) {
                logger2.debug("removed item for key:", key);
                storage.remove(key);
            }
        }
    }
};
// src/SigninState.ts
var $91cdf6b8491513ba$export$d12e9f373447e92a = class _SigninState extends $91cdf6b8491513ba$export$7254cc27399e90bd {
    constructor(args){
        super(args);
        this.code_verifier = args.code_verifier;
        this.code_challenge = args.code_challenge;
        this.authority = args.authority;
        this.client_id = args.client_id;
        this.redirect_uri = args.redirect_uri;
        this.scope = args.scope;
        this.client_secret = args.client_secret;
        this.extraTokenParams = args.extraTokenParams;
        this.response_mode = args.response_mode;
        this.skipUserInfo = args.skipUserInfo;
        this.nonce = args.nonce;
    }
    static async create(args) {
        const code_verifier = args.code_verifier === true ? $91cdf6b8491513ba$var$CryptoUtils.generateCodeVerifier() : args.code_verifier || void 0;
        const code_challenge = code_verifier ? await $91cdf6b8491513ba$var$CryptoUtils.generateCodeChallenge(code_verifier) : void 0;
        return new _SigninState({
            ...args,
            code_verifier: code_verifier,
            code_challenge: code_challenge
        });
    }
    toStorageString() {
        new $91cdf6b8491513ba$export$efa9a398d6368992("SigninState").create("toStorageString");
        return JSON.stringify({
            id: this.id,
            data: this.data,
            created: this.created,
            request_type: this.request_type,
            url_state: this.url_state,
            code_verifier: this.code_verifier,
            authority: this.authority,
            client_id: this.client_id,
            redirect_uri: this.redirect_uri,
            scope: this.scope,
            client_secret: this.client_secret,
            extraTokenParams: this.extraTokenParams,
            response_mode: this.response_mode,
            skipUserInfo: this.skipUserInfo,
            nonce: this.nonce
        });
    }
    static fromStorageString(storageString) {
        $91cdf6b8491513ba$export$efa9a398d6368992.createStatic("SigninState", "fromStorageString");
        const data = JSON.parse(storageString);
        return _SigninState.create(data);
    }
};
// src/SigninRequest.ts
var $91cdf6b8491513ba$var$_SigninRequest = class _SigninRequest {
    constructor(args){
        this.url = args.url;
        this.state = args.state;
    }
    static async create({ url: // mandatory
    url, authority: authority, client_id: client_id, redirect_uri: redirect_uri, response_type: response_type, scope: scope, state_data: // optional
    state_data, response_mode: response_mode, request_type: request_type, client_secret: client_secret, nonce: nonce, url_state: url_state, resource: resource, skipUserInfo: skipUserInfo, extraQueryParams: extraQueryParams, extraTokenParams: extraTokenParams, disablePKCE: disablePKCE, dpopJkt: dpopJkt, omitScopeWhenRequesting: omitScopeWhenRequesting, ...optionalParams }) {
        if (!url) {
            this._logger.error("create: No url passed");
            throw new Error("url");
        }
        if (!client_id) {
            this._logger.error("create: No client_id passed");
            throw new Error("client_id");
        }
        if (!redirect_uri) {
            this._logger.error("create: No redirect_uri passed");
            throw new Error("redirect_uri");
        }
        if (!response_type) {
            this._logger.error("create: No response_type passed");
            throw new Error("response_type");
        }
        if (!scope) {
            this._logger.error("create: No scope passed");
            throw new Error("scope");
        }
        if (!authority) {
            this._logger.error("create: No authority passed");
            throw new Error("authority");
        }
        const state = await $91cdf6b8491513ba$export$d12e9f373447e92a.create({
            data: state_data,
            request_type: request_type,
            url_state: url_state,
            code_verifier: !disablePKCE,
            client_id: client_id,
            authority: authority,
            redirect_uri: redirect_uri,
            response_mode: response_mode,
            client_secret: client_secret,
            scope: scope,
            extraTokenParams: extraTokenParams,
            skipUserInfo: skipUserInfo,
            nonce: nonce
        });
        const parsedUrl = new URL(url);
        parsedUrl.searchParams.append("client_id", client_id);
        parsedUrl.searchParams.append("redirect_uri", redirect_uri);
        parsedUrl.searchParams.append("response_type", response_type);
        if (!omitScopeWhenRequesting) parsedUrl.searchParams.append("scope", scope);
        if (nonce) parsedUrl.searchParams.append("nonce", nonce);
        if (dpopJkt) parsedUrl.searchParams.append("dpop_jkt", dpopJkt);
        let stateParam = state.id;
        if (url_state) stateParam = `${stateParam}${$91cdf6b8491513ba$var$URL_STATE_DELIMITER}${url_state}`;
        parsedUrl.searchParams.append("state", stateParam);
        if (state.code_challenge) {
            parsedUrl.searchParams.append("code_challenge", state.code_challenge);
            parsedUrl.searchParams.append("code_challenge_method", "S256");
        }
        if (resource) {
            const resources = Array.isArray(resource) ? resource : [
                resource
            ];
            resources.forEach((r)=>parsedUrl.searchParams.append("resource", r));
        }
        for (const [key, value] of Object.entries({
            response_mode: response_mode,
            ...optionalParams,
            ...extraQueryParams
        }))if (value != null) parsedUrl.searchParams.append(key, value.toString());
        return new _SigninRequest({
            url: parsedUrl.href,
            state: state
        });
    }
};
$91cdf6b8491513ba$var$_SigninRequest._logger = new $91cdf6b8491513ba$export$efa9a398d6368992("SigninRequest");
var $91cdf6b8491513ba$var$SigninRequest = $91cdf6b8491513ba$var$_SigninRequest;
// src/SigninResponse.ts
var $91cdf6b8491513ba$var$OidcScope = "openid";
var $91cdf6b8491513ba$export$60021acc97e24041 = class {
    constructor(params){
        /** @see {@link User.access_token} */ this.access_token = "";
        /** @see {@link User.token_type} */ this.token_type = "";
        /** @see {@link User.profile} */ this.profile = {};
        this.state = params.get("state");
        this.session_state = params.get("session_state");
        if (this.state) {
            const splitState = decodeURIComponent(this.state).split($91cdf6b8491513ba$var$URL_STATE_DELIMITER);
            this.state = splitState[0];
            if (splitState.length > 1) this.url_state = splitState.slice(1).join($91cdf6b8491513ba$var$URL_STATE_DELIMITER);
        }
        this.error = params.get("error");
        this.error_description = params.get("error_description");
        this.error_uri = params.get("error_uri");
        this.code = params.get("code");
    }
    get expires_in() {
        if (this.expires_at === void 0) return void 0;
        return this.expires_at - $91cdf6b8491513ba$var$Timer.getEpochTime();
    }
    set expires_in(value) {
        if (typeof value === "string") value = Number(value);
        if (value !== void 0 && value >= 0) this.expires_at = Math.floor(value) + $91cdf6b8491513ba$var$Timer.getEpochTime();
    }
    get isOpenId() {
        var _a;
        return ((_a = this.scope) == null ? void 0 : _a.split(" ").includes($91cdf6b8491513ba$var$OidcScope)) || !!this.id_token;
    }
};
// src/SignoutRequest.ts
var $91cdf6b8491513ba$var$SignoutRequest = class {
    constructor({ url: url, state_data: state_data, id_token_hint: id_token_hint, post_logout_redirect_uri: post_logout_redirect_uri, extraQueryParams: extraQueryParams, request_type: request_type, client_id: client_id, url_state: url_state }){
        this._logger = new $91cdf6b8491513ba$export$efa9a398d6368992("SignoutRequest");
        if (!url) {
            this._logger.error("ctor: No url passed");
            throw new Error("url");
        }
        const parsedUrl = new URL(url);
        if (id_token_hint) parsedUrl.searchParams.append("id_token_hint", id_token_hint);
        if (client_id) parsedUrl.searchParams.append("client_id", client_id);
        if (post_logout_redirect_uri) {
            parsedUrl.searchParams.append("post_logout_redirect_uri", post_logout_redirect_uri);
            if (state_data || url_state) {
                this.state = new $91cdf6b8491513ba$export$7254cc27399e90bd({
                    data: state_data,
                    request_type: request_type,
                    url_state: url_state
                });
                let stateParam = this.state.id;
                if (url_state) stateParam = `${stateParam}${$91cdf6b8491513ba$var$URL_STATE_DELIMITER}${url_state}`;
                parsedUrl.searchParams.append("state", stateParam);
            }
        }
        for (const [key, value] of Object.entries({
            ...extraQueryParams
        }))if (value != null) parsedUrl.searchParams.append(key, value.toString());
        this.url = parsedUrl.href;
    }
};
// src/SignoutResponse.ts
var $91cdf6b8491513ba$export$7ddf7038233313f6 = class {
    constructor(params){
        this.state = params.get("state");
        if (this.state) {
            const splitState = decodeURIComponent(this.state).split($91cdf6b8491513ba$var$URL_STATE_DELIMITER);
            this.state = splitState[0];
            if (splitState.length > 1) this.url_state = splitState.slice(1).join($91cdf6b8491513ba$var$URL_STATE_DELIMITER);
        }
        this.error = params.get("error");
        this.error_description = params.get("error_description");
        this.error_uri = params.get("error_uri");
    }
};
// src/ClaimsService.ts
var $91cdf6b8491513ba$var$DefaultProtocolClaims = [
    "nbf",
    "jti",
    "auth_time",
    "nonce",
    "acr",
    "amr",
    "azp",
    "at_hash"
];
var $91cdf6b8491513ba$var$InternalRequiredProtocolClaims = [
    "sub",
    "iss",
    "aud",
    "exp",
    "iat"
];
var $91cdf6b8491513ba$var$ClaimsService = class {
    constructor(_settings){
        this._settings = _settings;
        this._logger = new $91cdf6b8491513ba$export$efa9a398d6368992("ClaimsService");
    }
    filterProtocolClaims(claims) {
        const result = {
            ...claims
        };
        if (this._settings.filterProtocolClaims) {
            let protocolClaims;
            if (Array.isArray(this._settings.filterProtocolClaims)) protocolClaims = this._settings.filterProtocolClaims;
            else protocolClaims = $91cdf6b8491513ba$var$DefaultProtocolClaims;
            for (const claim of protocolClaims)if (!$91cdf6b8491513ba$var$InternalRequiredProtocolClaims.includes(claim)) delete result[claim];
        }
        return result;
    }
    mergeClaims(claims1, claims2) {
        const result = {
            ...claims1
        };
        for (const [claim, values] of Object.entries(claims2))if (result[claim] !== values) {
            if (Array.isArray(result[claim]) || Array.isArray(values)) {
                if (this._settings.mergeClaimsStrategy.array == "replace") result[claim] = values;
                else {
                    const mergedValues = Array.isArray(result[claim]) ? result[claim] : [
                        result[claim]
                    ];
                    for (const value of Array.isArray(values) ? values : [
                        values
                    ])if (!mergedValues.includes(value)) mergedValues.push(value);
                    result[claim] = mergedValues;
                }
            } else if (typeof result[claim] === "object" && typeof values === "object") result[claim] = this.mergeClaims(result[claim], values);
            else result[claim] = values;
        }
        return result;
    }
};
// src/DPoPStore.ts
var $91cdf6b8491513ba$export$dc765d984eae7c82 = class {
    constructor(keys, nonce){
        this.keys = keys;
        this.nonce = nonce;
    }
};
// src/OidcClient.ts
var $91cdf6b8491513ba$export$b112d407fa897c7e = class {
    constructor(settings, metadataService){
        this._logger = new $91cdf6b8491513ba$export$efa9a398d6368992("OidcClient");
        this.settings = settings instanceof $91cdf6b8491513ba$export$f0d75c4d483197bb ? settings : new $91cdf6b8491513ba$export$f0d75c4d483197bb(settings);
        this.metadataService = metadataService != null ? metadataService : new $91cdf6b8491513ba$export$b732ab16be80c4ec(this.settings);
        this._claimsService = new $91cdf6b8491513ba$var$ClaimsService(this.settings);
        this._validator = new $91cdf6b8491513ba$var$ResponseValidator(this.settings, this.metadataService, this._claimsService);
        this._tokenClient = new $91cdf6b8491513ba$var$TokenClient(this.settings, this.metadataService);
    }
    async createSigninRequest({ state: state, request: request, request_uri: request_uri, request_type: request_type, id_token_hint: id_token_hint, login_hint: login_hint, skipUserInfo: skipUserInfo, nonce: nonce, url_state: url_state, response_type: response_type = this.settings.response_type, scope: scope = this.settings.scope, redirect_uri: redirect_uri = this.settings.redirect_uri, prompt: prompt = this.settings.prompt, display: display = this.settings.display, max_age: max_age = this.settings.max_age, ui_locales: ui_locales = this.settings.ui_locales, acr_values: acr_values = this.settings.acr_values, resource: resource = this.settings.resource, response_mode: response_mode = this.settings.response_mode, extraQueryParams: extraQueryParams = this.settings.extraQueryParams, extraTokenParams: extraTokenParams = this.settings.extraTokenParams, dpopJkt: dpopJkt, omitScopeWhenRequesting: omitScopeWhenRequesting = this.settings.omitScopeWhenRequesting }) {
        const logger2 = this._logger.create("createSigninRequest");
        if (response_type !== "code") throw new Error("Only the Authorization Code flow (with PKCE) is supported");
        const url = await this.metadataService.getAuthorizationEndpoint();
        logger2.debug("Received authorization endpoint", url);
        const signinRequest = await $91cdf6b8491513ba$var$SigninRequest.create({
            url: url,
            authority: this.settings.authority,
            client_id: this.settings.client_id,
            redirect_uri: redirect_uri,
            response_type: response_type,
            scope: scope,
            state_data: state,
            url_state: url_state,
            prompt: prompt,
            display: display,
            max_age: max_age,
            ui_locales: ui_locales,
            id_token_hint: id_token_hint,
            login_hint: login_hint,
            acr_values: acr_values,
            dpopJkt: dpopJkt,
            resource: resource,
            request: request,
            request_uri: request_uri,
            extraQueryParams: extraQueryParams,
            extraTokenParams: extraTokenParams,
            request_type: request_type,
            response_mode: response_mode,
            client_secret: this.settings.client_secret,
            skipUserInfo: skipUserInfo,
            nonce: nonce,
            disablePKCE: this.settings.disablePKCE,
            omitScopeWhenRequesting: omitScopeWhenRequesting
        });
        await this.clearStaleState();
        const signinState = signinRequest.state;
        await this.settings.stateStore.set(signinState.id, signinState.toStorageString());
        return signinRequest;
    }
    async readSigninResponseState(url, removeState = false) {
        const logger2 = this._logger.create("readSigninResponseState");
        const response = new $91cdf6b8491513ba$export$60021acc97e24041($91cdf6b8491513ba$var$UrlUtils.readParams(url, this.settings.response_mode));
        if (!response.state) {
            logger2.throw(new Error("No state in response"));
            throw null;
        }
        const storedStateString = await this.settings.stateStore[removeState ? "remove" : "get"](response.state);
        if (!storedStateString) {
            logger2.throw(new Error("No matching state found in storage"));
            throw null;
        }
        const state = await $91cdf6b8491513ba$export$d12e9f373447e92a.fromStorageString(storedStateString);
        return {
            state: state,
            response: response
        };
    }
    async processSigninResponse(url, extraHeaders, removeState = true) {
        const logger2 = this._logger.create("processSigninResponse");
        const { state: state, response: response } = await this.readSigninResponseState(url, removeState);
        logger2.debug("received state from storage; validating response");
        if (this.settings.dpop && this.settings.dpop.store) {
            const dpopProof = await this.getDpopProof(this.settings.dpop.store);
            extraHeaders = {
                ...extraHeaders,
                "DPoP": dpopProof
            };
        }
        try {
            await this._validator.validateSigninResponse(response, state, extraHeaders);
        } catch (err) {
            if (err instanceof $91cdf6b8491513ba$var$ErrorDPoPNonce && this.settings.dpop) {
                const dpopProof = await this.getDpopProof(this.settings.dpop.store, err.nonce);
                extraHeaders["DPoP"] = dpopProof;
                await this._validator.validateSigninResponse(response, state, extraHeaders);
            } else throw err;
        }
        return response;
    }
    async getDpopProof(dpopStore, nonce) {
        let keyPair;
        let dpopState;
        if (!(await dpopStore.getAllKeys()).includes(this.settings.client_id)) {
            keyPair = await $91cdf6b8491513ba$var$CryptoUtils.generateDPoPKeys();
            dpopState = new $91cdf6b8491513ba$export$dc765d984eae7c82(keyPair, nonce);
            await dpopStore.set(this.settings.client_id, dpopState);
        } else {
            dpopState = await dpopStore.get(this.settings.client_id);
            if (dpopState.nonce !== nonce && nonce) {
                dpopState.nonce = nonce;
                await dpopStore.set(this.settings.client_id, dpopState);
            }
        }
        return await $91cdf6b8491513ba$var$CryptoUtils.generateDPoPProof({
            url: await this.metadataService.getTokenEndpoint(false),
            httpMethod: "POST",
            keyPair: dpopState.keys,
            nonce: dpopState.nonce
        });
    }
    async processResourceOwnerPasswordCredentials({ username: username, password: password, skipUserInfo: skipUserInfo = false, extraTokenParams: extraTokenParams = {} }) {
        const tokenResponse = await this._tokenClient.exchangeCredentials({
            username: username,
            password: password,
            ...extraTokenParams
        });
        const signinResponse = new $91cdf6b8491513ba$export$60021acc97e24041(new URLSearchParams());
        Object.assign(signinResponse, tokenResponse);
        await this._validator.validateCredentialsResponse(signinResponse, skipUserInfo);
        return signinResponse;
    }
    async useRefreshToken({ state: state, redirect_uri: redirect_uri, resource: resource, timeoutInSeconds: timeoutInSeconds, extraHeaders: extraHeaders, extraTokenParams: extraTokenParams }) {
        var _a;
        const logger2 = this._logger.create("useRefreshToken");
        let scope;
        if (this.settings.refreshTokenAllowedScope === void 0) scope = state.scope;
        else {
            const allowableScopes = this.settings.refreshTokenAllowedScope.split(" ");
            const providedScopes = ((_a = state.scope) == null ? void 0 : _a.split(" ")) || [];
            scope = providedScopes.filter((s)=>allowableScopes.includes(s)).join(" ");
        }
        if (this.settings.dpop && this.settings.dpop.store) {
            const dpopProof = await this.getDpopProof(this.settings.dpop.store);
            extraHeaders = {
                ...extraHeaders,
                "DPoP": dpopProof
            };
        }
        let result;
        try {
            result = await this._tokenClient.exchangeRefreshToken({
                refresh_token: state.refresh_token,
                scope: // provide the (possible filtered) scope list
                scope,
                redirect_uri: redirect_uri,
                resource: resource,
                timeoutInSeconds: timeoutInSeconds,
                extraHeaders: extraHeaders,
                ...extraTokenParams
            });
        } catch (err) {
            if (err instanceof $91cdf6b8491513ba$var$ErrorDPoPNonce && this.settings.dpop) {
                extraHeaders["DPoP"] = await this.getDpopProof(this.settings.dpop.store, err.nonce);
                result = await this._tokenClient.exchangeRefreshToken({
                    refresh_token: state.refresh_token,
                    scope: // provide the (possible filtered) scope list
                    scope,
                    redirect_uri: redirect_uri,
                    resource: resource,
                    timeoutInSeconds: timeoutInSeconds,
                    extraHeaders: extraHeaders,
                    ...extraTokenParams
                });
            } else throw err;
        }
        const response = new $91cdf6b8491513ba$export$60021acc97e24041(new URLSearchParams());
        Object.assign(response, result);
        logger2.debug("validating response", response);
        await this._validator.validateRefreshResponse(response, {
            ...state,
            scope: // override the scope in the state handed over to the validator
            // so it can set the granted scope to the requested scope in case none is included in the response
            scope
        });
        return response;
    }
    async createSignoutRequest({ state: state, id_token_hint: id_token_hint, client_id: client_id, request_type: request_type, url_state: url_state, post_logout_redirect_uri: post_logout_redirect_uri = this.settings.post_logout_redirect_uri, extraQueryParams: extraQueryParams = this.settings.extraQueryParams } = {}) {
        const logger2 = this._logger.create("createSignoutRequest");
        const url = await this.metadataService.getEndSessionEndpoint();
        if (!url) {
            logger2.throw(new Error("No end session endpoint"));
            throw null;
        }
        logger2.debug("Received end session endpoint", url);
        if (!client_id && post_logout_redirect_uri && !id_token_hint) client_id = this.settings.client_id;
        const request = new $91cdf6b8491513ba$var$SignoutRequest({
            url: url,
            id_token_hint: id_token_hint,
            client_id: client_id,
            post_logout_redirect_uri: post_logout_redirect_uri,
            state_data: state,
            extraQueryParams: extraQueryParams,
            request_type: request_type,
            url_state: url_state
        });
        await this.clearStaleState();
        const signoutState = request.state;
        if (signoutState) {
            logger2.debug("Signout request has state to persist");
            await this.settings.stateStore.set(signoutState.id, signoutState.toStorageString());
        }
        return request;
    }
    async readSignoutResponseState(url, removeState = false) {
        const logger2 = this._logger.create("readSignoutResponseState");
        const response = new $91cdf6b8491513ba$export$7ddf7038233313f6($91cdf6b8491513ba$var$UrlUtils.readParams(url, this.settings.response_mode));
        if (!response.state) {
            logger2.debug("No state in response");
            if (response.error) {
                logger2.warn("Response was error:", response.error);
                throw new $91cdf6b8491513ba$export$acf1a680051f5031(response);
            }
            return {
                state: void 0,
                response: response
            };
        }
        const storedStateString = await this.settings.stateStore[removeState ? "remove" : "get"](response.state);
        if (!storedStateString) {
            logger2.throw(new Error("No matching state found in storage"));
            throw null;
        }
        const state = await $91cdf6b8491513ba$export$7254cc27399e90bd.fromStorageString(storedStateString);
        return {
            state: state,
            response: response
        };
    }
    async processSignoutResponse(url) {
        const logger2 = this._logger.create("processSignoutResponse");
        const { state: state, response: response } = await this.readSignoutResponseState(url, true);
        if (state) {
            logger2.debug("Received state from storage; validating response");
            this._validator.validateSignoutResponse(response, state);
        } else logger2.debug("No state from storage; skipping response validation");
        return response;
    }
    clearStaleState() {
        this._logger.create("clearStaleState");
        return $91cdf6b8491513ba$export$7254cc27399e90bd.clearStaleState(this.settings.stateStore, this.settings.staleStateAgeInSeconds);
    }
    async revokeToken(token, type) {
        this._logger.create("revokeToken");
        return await this._tokenClient.revoke({
            token: token,
            token_type_hint: type
        });
    }
};
// src/SessionMonitor.ts
var $91cdf6b8491513ba$export$d962324009a92d99 = class {
    constructor(_userManager){
        this._userManager = _userManager;
        this._logger = new $91cdf6b8491513ba$export$efa9a398d6368992("SessionMonitor");
        this._start = async (user)=>{
            const session_state = user.session_state;
            if (!session_state) return;
            const logger2 = this._logger.create("_start");
            if (user.profile) {
                this._sub = user.profile.sub;
                logger2.debug("session_state", session_state, ", sub", this._sub);
            } else {
                this._sub = void 0;
                logger2.debug("session_state", session_state, ", anonymous user");
            }
            if (this._checkSessionIFrame) {
                this._checkSessionIFrame.start(session_state);
                return;
            }
            try {
                const url = await this._userManager.metadataService.getCheckSessionIframe();
                if (url) {
                    logger2.debug("initializing check session iframe");
                    const client_id = this._userManager.settings.client_id;
                    const intervalInSeconds = this._userManager.settings.checkSessionIntervalInSeconds;
                    const stopOnError = this._userManager.settings.stopCheckSessionOnError;
                    const checkSessionIFrame = new $91cdf6b8491513ba$export$e3e6062266eff2d4(this._callback, client_id, url, intervalInSeconds, stopOnError);
                    await checkSessionIFrame.load();
                    this._checkSessionIFrame = checkSessionIFrame;
                    checkSessionIFrame.start(session_state);
                } else logger2.warn("no check session iframe found in the metadata");
            } catch (err) {
                logger2.error("Error from getCheckSessionIframe:", err instanceof Error ? err.message : err);
            }
        };
        this._stop = ()=>{
            const logger2 = this._logger.create("_stop");
            this._sub = void 0;
            if (this._checkSessionIFrame) this._checkSessionIFrame.stop();
            if (this._userManager.settings.monitorAnonymousSession) {
                const timerHandle = setInterval(async ()=>{
                    clearInterval(timerHandle);
                    try {
                        const session = await this._userManager.querySessionStatus();
                        if (session) {
                            const tmpUser = {
                                session_state: session.session_state,
                                profile: session.sub ? {
                                    sub: session.sub
                                } : null
                            };
                            this._start(tmpUser);
                        }
                    } catch (err) {
                        logger2.error("error from querySessionStatus", err instanceof Error ? err.message : err);
                    }
                }, 1e3);
            }
        };
        this._callback = async ()=>{
            const logger2 = this._logger.create("_callback");
            try {
                const session = await this._userManager.querySessionStatus();
                let raiseEvent = true;
                if (session && this._checkSessionIFrame) {
                    if (session.sub === this._sub) {
                        raiseEvent = false;
                        this._checkSessionIFrame.start(session.session_state);
                        logger2.debug("same sub still logged in at OP, session state has changed, restarting check session iframe; session_state", session.session_state);
                        await this._userManager.events._raiseUserSessionChanged();
                    } else logger2.debug("different subject signed into OP", session.sub);
                } else logger2.debug("subject no longer signed into OP");
                if (raiseEvent) {
                    if (this._sub) await this._userManager.events._raiseUserSignedOut();
                    else await this._userManager.events._raiseUserSignedIn();
                } else logger2.debug("no change in session detected, no event to raise");
            } catch (err) {
                if (this._sub) {
                    logger2.debug("Error calling queryCurrentSigninSession; raising signed out event", err);
                    await this._userManager.events._raiseUserSignedOut();
                }
            }
        };
        if (!_userManager) this._logger.throw(new Error("No user manager passed"));
        this._userManager.events.addUserLoaded(this._start);
        this._userManager.events.addUserUnloaded(this._stop);
        this._init().catch((err)=>{
            this._logger.error(err);
        });
    }
    async _init() {
        this._logger.create("_init");
        const user = await this._userManager.getUser();
        if (user) this._start(user);
        else if (this._userManager.settings.monitorAnonymousSession) {
            const session = await this._userManager.querySessionStatus();
            if (session) {
                const tmpUser = {
                    session_state: session.session_state,
                    profile: session.sub ? {
                        sub: session.sub
                    } : null
                };
                this._start(tmpUser);
            }
        }
    }
};
// src/User.ts
var $91cdf6b8491513ba$export$1f44aaf2ec115b54 = class _User {
    constructor(args){
        var _a;
        this.id_token = args.id_token;
        this.session_state = (_a = args.session_state) != null ? _a : null;
        this.access_token = args.access_token;
        this.refresh_token = args.refresh_token;
        this.token_type = args.token_type;
        this.scope = args.scope;
        this.profile = args.profile;
        this.expires_at = args.expires_at;
        this.state = args.userState;
        this.url_state = args.url_state;
    }
    /** Computed number of seconds the access token has remaining. */ get expires_in() {
        if (this.expires_at === void 0) return void 0;
        return this.expires_at - $91cdf6b8491513ba$var$Timer.getEpochTime();
    }
    set expires_in(value) {
        if (value !== void 0) this.expires_at = Math.floor(value) + $91cdf6b8491513ba$var$Timer.getEpochTime();
    }
    /** Computed value indicating if the access token is expired. */ get expired() {
        const expires_in = this.expires_in;
        if (expires_in === void 0) return void 0;
        return expires_in <= 0;
    }
    /** Array representing the parsed values from the `scope`. */ get scopes() {
        var _a, _b;
        return (_b = (_a = this.scope) == null ? void 0 : _a.split(" ")) != null ? _b : [];
    }
    toStorageString() {
        new $91cdf6b8491513ba$export$efa9a398d6368992("User").create("toStorageString");
        return JSON.stringify({
            id_token: this.id_token,
            session_state: this.session_state,
            access_token: this.access_token,
            refresh_token: this.refresh_token,
            token_type: this.token_type,
            scope: this.scope,
            profile: this.profile,
            expires_at: this.expires_at
        });
    }
    static fromStorageString(storageString) {
        $91cdf6b8491513ba$export$efa9a398d6368992.createStatic("User", "fromStorageString");
        return new _User(JSON.parse(storageString));
    }
};
// src/navigators/AbstractChildWindow.ts
var $91cdf6b8491513ba$var$messageSource = "oidc-client";
var $91cdf6b8491513ba$var$AbstractChildWindow = class {
    constructor(){
        this._abort = new $91cdf6b8491513ba$var$Event("Window navigation aborted");
        this._disposeHandlers = /* @__PURE__ */ new Set();
        this._window = null;
    }
    async navigate(params) {
        const logger2 = this._logger.create("navigate");
        if (!this._window) throw new Error("Attempted to navigate on a disposed window");
        logger2.debug("setting URL in window");
        this._window.location.replace(params.url);
        const { url: url, keepOpen: keepOpen } = await new Promise((resolve, reject)=>{
            const listener = (e)=>{
                var _a;
                const data = e.data;
                const origin = (_a = params.scriptOrigin) != null ? _a : window.location.origin;
                if (e.origin !== origin || (data == null ? void 0 : data.source) !== $91cdf6b8491513ba$var$messageSource) return;
                try {
                    const state = $91cdf6b8491513ba$var$UrlUtils.readParams(data.url, params.response_mode).get("state");
                    if (!state) logger2.warn("no state found in response url");
                    if (e.source !== this._window && state !== params.state) return;
                } catch  {
                    this._dispose();
                    reject(new Error("Invalid response from window"));
                }
                resolve(data);
            };
            window.addEventListener("message", listener, false);
            this._disposeHandlers.add(()=>window.removeEventListener("message", listener, false));
            const channel = new BroadcastChannel(`oidc-client-popup-${params.state}`);
            channel.addEventListener("message", listener, false);
            this._disposeHandlers.add(()=>channel.close());
            this._disposeHandlers.add(this._abort.addHandler((reason)=>{
                this._dispose();
                reject(reason);
            }));
        });
        logger2.debug("got response from window");
        this._dispose();
        if (!keepOpen) this.close();
        return {
            url: url
        };
    }
    _dispose() {
        this._logger.create("_dispose");
        for (const dispose of this._disposeHandlers)dispose();
        this._disposeHandlers.clear();
    }
    static _notifyParent(parent, url, keepOpen = false, targetOrigin = window.location.origin) {
        const msgData = {
            source: $91cdf6b8491513ba$var$messageSource,
            url: url,
            keepOpen: keepOpen
        };
        const logger2 = new $91cdf6b8491513ba$export$efa9a398d6368992("_notifyParent");
        if (parent) {
            logger2.debug("With parent. Using parent.postMessage.");
            parent.postMessage(msgData, targetOrigin);
        } else {
            logger2.debug("No parent. Using BroadcastChannel.");
            const state = new URL(url).searchParams.get("state");
            if (!state) throw new Error("No parent and no state in URL. Can't complete notification.");
            const channel = new BroadcastChannel(`oidc-client-popup-${state}`);
            channel.postMessage(msgData);
            channel.close();
        }
    }
};
// src/UserManagerSettings.ts
var $91cdf6b8491513ba$var$DefaultPopupWindowFeatures = {
    location: false,
    toolbar: false,
    height: 640,
    closePopupWindowAfterInSeconds: -1
};
var $91cdf6b8491513ba$var$DefaultPopupTarget = "_blank";
var $91cdf6b8491513ba$var$DefaultAccessTokenExpiringNotificationTimeInSeconds = 60;
var $91cdf6b8491513ba$var$DefaultCheckSessionIntervalInSeconds = 2;
var $91cdf6b8491513ba$var$DefaultSilentRequestTimeoutInSeconds = 10;
var $91cdf6b8491513ba$export$620f0a652f69895a = class extends $91cdf6b8491513ba$export$f0d75c4d483197bb {
    constructor(args){
        const { popup_redirect_uri: popup_redirect_uri = args.redirect_uri, popup_post_logout_redirect_uri: popup_post_logout_redirect_uri = args.post_logout_redirect_uri, popupWindowFeatures: popupWindowFeatures = $91cdf6b8491513ba$var$DefaultPopupWindowFeatures, popupWindowTarget: popupWindowTarget = $91cdf6b8491513ba$var$DefaultPopupTarget, redirectMethod: redirectMethod = "assign", redirectTarget: redirectTarget = "self", iframeNotifyParentOrigin: iframeNotifyParentOrigin = args.iframeNotifyParentOrigin, iframeScriptOrigin: iframeScriptOrigin = args.iframeScriptOrigin, requestTimeoutInSeconds: requestTimeoutInSeconds, silent_redirect_uri: silent_redirect_uri = args.redirect_uri, silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds, automaticSilentRenew: automaticSilentRenew = true, validateSubOnSilentRenew: validateSubOnSilentRenew = true, includeIdTokenInSilentRenew: includeIdTokenInSilentRenew = false, monitorSession: monitorSession = false, monitorAnonymousSession: monitorAnonymousSession = false, checkSessionIntervalInSeconds: checkSessionIntervalInSeconds = $91cdf6b8491513ba$var$DefaultCheckSessionIntervalInSeconds, query_status_response_type: query_status_response_type = "code", stopCheckSessionOnError: stopCheckSessionOnError = true, revokeTokenTypes: revokeTokenTypes = [
            "access_token",
            "refresh_token"
        ], revokeTokensOnSignout: revokeTokensOnSignout = false, includeIdTokenInSilentSignout: includeIdTokenInSilentSignout = false, accessTokenExpiringNotificationTimeInSeconds: accessTokenExpiringNotificationTimeInSeconds = $91cdf6b8491513ba$var$DefaultAccessTokenExpiringNotificationTimeInSeconds, maxSilentRenewTimeoutRetries: maxSilentRenewTimeoutRetries, userStore: userStore } = args;
        super(args);
        this.popup_redirect_uri = popup_redirect_uri;
        this.popup_post_logout_redirect_uri = popup_post_logout_redirect_uri;
        this.popupWindowFeatures = popupWindowFeatures;
        this.popupWindowTarget = popupWindowTarget;
        this.redirectMethod = redirectMethod;
        this.redirectTarget = redirectTarget;
        this.iframeNotifyParentOrigin = iframeNotifyParentOrigin;
        this.iframeScriptOrigin = iframeScriptOrigin;
        this.silent_redirect_uri = silent_redirect_uri;
        this.silentRequestTimeoutInSeconds = silentRequestTimeoutInSeconds || requestTimeoutInSeconds || $91cdf6b8491513ba$var$DefaultSilentRequestTimeoutInSeconds;
        this.automaticSilentRenew = automaticSilentRenew;
        this.validateSubOnSilentRenew = validateSubOnSilentRenew;
        this.includeIdTokenInSilentRenew = includeIdTokenInSilentRenew;
        this.monitorSession = monitorSession;
        this.monitorAnonymousSession = monitorAnonymousSession;
        this.checkSessionIntervalInSeconds = checkSessionIntervalInSeconds;
        this.stopCheckSessionOnError = stopCheckSessionOnError;
        this.query_status_response_type = query_status_response_type;
        this.revokeTokenTypes = revokeTokenTypes;
        this.revokeTokensOnSignout = revokeTokensOnSignout;
        this.includeIdTokenInSilentSignout = includeIdTokenInSilentSignout;
        this.accessTokenExpiringNotificationTimeInSeconds = accessTokenExpiringNotificationTimeInSeconds;
        this.maxSilentRenewTimeoutRetries = maxSilentRenewTimeoutRetries;
        if (userStore) this.userStore = userStore;
        else {
            const store = typeof window !== "undefined" ? window.sessionStorage : new $91cdf6b8491513ba$export$46e428416143c79c();
            this.userStore = new $91cdf6b8491513ba$export$6a5d9eefd8f07eee({
                store: store
            });
        }
    }
};
// src/navigators/IFrameWindow.ts
var $91cdf6b8491513ba$var$IFrameWindow = class _IFrameWindow extends $91cdf6b8491513ba$var$AbstractChildWindow {
    constructor({ silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds = $91cdf6b8491513ba$var$DefaultSilentRequestTimeoutInSeconds }){
        super();
        this._logger = new $91cdf6b8491513ba$export$efa9a398d6368992("IFrameWindow");
        this._timeoutInSeconds = silentRequestTimeoutInSeconds;
        this._frame = _IFrameWindow.createHiddenIframe();
        this._window = this._frame.contentWindow;
    }
    static createHiddenIframe() {
        const iframe = window.document.createElement("iframe");
        iframe.style.visibility = "hidden";
        iframe.style.position = "fixed";
        iframe.style.left = "-1000px";
        iframe.style.top = "0";
        iframe.width = "0";
        iframe.height = "0";
        window.document.body.appendChild(iframe);
        return iframe;
    }
    async navigate(params) {
        this._logger.debug("navigate: Using timeout of:", this._timeoutInSeconds);
        const timer = setTimeout(()=>void this._abort.raise(new $91cdf6b8491513ba$export$5312ab5d2c8d859c("IFrame timed out without a response")), this._timeoutInSeconds * 1e3);
        this._disposeHandlers.add(()=>clearTimeout(timer));
        return await super.navigate(params);
    }
    close() {
        var _a;
        if (this._frame) {
            if (this._frame.parentNode) {
                this._frame.addEventListener("load", (ev)=>{
                    var _a2;
                    const frame = ev.target;
                    (_a2 = frame.parentNode) == null || _a2.removeChild(frame);
                    this._abort.raise(new Error("IFrame removed from DOM"));
                }, true);
                (_a = this._frame.contentWindow) == null || _a.location.replace("about:blank");
            }
            this._frame = null;
        }
        this._window = null;
    }
    static notifyParent(url, targetOrigin) {
        return super._notifyParent(window.parent, url, false, targetOrigin);
    }
};
// src/navigators/IFrameNavigator.ts
var $91cdf6b8491513ba$var$IFrameNavigator = class {
    constructor(_settings){
        this._settings = _settings;
        this._logger = new $91cdf6b8491513ba$export$efa9a398d6368992("IFrameNavigator");
    }
    async prepare({ silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds = this._settings.silentRequestTimeoutInSeconds }) {
        return new $91cdf6b8491513ba$var$IFrameWindow({
            silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds
        });
    }
    async callback(url) {
        this._logger.create("callback");
        $91cdf6b8491513ba$var$IFrameWindow.notifyParent(url, this._settings.iframeNotifyParentOrigin);
    }
};
// src/navigators/PopupWindow.ts
var $91cdf6b8491513ba$var$checkForPopupClosedInterval = 500;
var $91cdf6b8491513ba$var$second = 1e3;
var $91cdf6b8491513ba$var$PopupWindow = class extends $91cdf6b8491513ba$var$AbstractChildWindow {
    constructor({ popupWindowTarget: popupWindowTarget = $91cdf6b8491513ba$var$DefaultPopupTarget, popupWindowFeatures: popupWindowFeatures = {}, popupSignal: popupSignal, popupAbortOnClose: popupAbortOnClose }){
        super();
        this._logger = new $91cdf6b8491513ba$export$efa9a398d6368992("PopupWindow");
        const centeredPopup = $91cdf6b8491513ba$var$PopupUtils.center({
            ...$91cdf6b8491513ba$var$DefaultPopupWindowFeatures,
            ...popupWindowFeatures
        });
        this._window = window.open(void 0, popupWindowTarget, $91cdf6b8491513ba$var$PopupUtils.serialize(centeredPopup));
        this.abortOnClose = Boolean(popupAbortOnClose);
        if (popupSignal) popupSignal.addEventListener("abort", ()=>{
            var _a;
            this._abort.raise(new Error((_a = popupSignal.reason) != null ? _a : "Popup aborted"));
        });
        if (popupWindowFeatures.closePopupWindowAfterInSeconds && popupWindowFeatures.closePopupWindowAfterInSeconds > 0) setTimeout(()=>{
            if (!this._window || typeof this._window.closed !== "boolean" || this._window.closed) {
                this._abort.raise(new Error("Popup blocked by user"));
                return;
            }
            this.close();
        }, popupWindowFeatures.closePopupWindowAfterInSeconds * $91cdf6b8491513ba$var$second);
    }
    async navigate(params) {
        var _a;
        (_a = this._window) == null || _a.focus();
        const popupClosedInterval = setInterval(()=>{
            if (!this._window || this._window.closed) {
                this._logger.debug("Popup closed by user or isolated by redirect");
                clearPopupClosedInterval();
                this._disposeHandlers.delete(clearPopupClosedInterval);
                if (this.abortOnClose) this._abort.raise(new Error("Popup closed by user"));
            }
        }, $91cdf6b8491513ba$var$checkForPopupClosedInterval);
        const clearPopupClosedInterval = ()=>clearInterval(popupClosedInterval);
        this._disposeHandlers.add(clearPopupClosedInterval);
        return await super.navigate(params);
    }
    close() {
        if (this._window) {
            if (!this._window.closed) {
                this._window.close();
                this._abort.raise(new Error("Popup closed"));
            }
        }
        this._window = null;
    }
    static notifyOpener(url, keepOpen) {
        super._notifyParent(window.opener, url, keepOpen);
        if (!keepOpen && !window.opener) window.close();
    }
};
// src/navigators/PopupNavigator.ts
var $91cdf6b8491513ba$var$PopupNavigator = class {
    constructor(_settings){
        this._settings = _settings;
        this._logger = new $91cdf6b8491513ba$export$efa9a398d6368992("PopupNavigator");
    }
    async prepare({ popupWindowFeatures: popupWindowFeatures = this._settings.popupWindowFeatures, popupWindowTarget: popupWindowTarget = this._settings.popupWindowTarget, popupSignal: popupSignal, popupAbortOnClose: popupAbortOnClose }) {
        return new $91cdf6b8491513ba$var$PopupWindow({
            popupWindowFeatures: popupWindowFeatures,
            popupWindowTarget: popupWindowTarget,
            popupSignal: popupSignal,
            popupAbortOnClose: popupAbortOnClose
        });
    }
    async callback(url, { keepOpen: keepOpen = false }) {
        this._logger.create("callback");
        $91cdf6b8491513ba$var$PopupWindow.notifyOpener(url, keepOpen);
    }
};
// src/navigators/RedirectNavigator.ts
var $91cdf6b8491513ba$var$RedirectNavigator = class {
    constructor(_settings){
        this._settings = _settings;
        this._logger = new $91cdf6b8491513ba$export$efa9a398d6368992("RedirectNavigator");
    }
    async prepare({ redirectMethod: redirectMethod = this._settings.redirectMethod, redirectTarget: redirectTarget = this._settings.redirectTarget }) {
        var _a;
        this._logger.create("prepare");
        let targetWindow = window.self;
        if (redirectTarget === "top") targetWindow = (_a = window.top) != null ? _a : window.self;
        const redirect = targetWindow.location[redirectMethod].bind(targetWindow.location);
        let abort;
        return {
            navigate: async (params)=>{
                this._logger.create("navigate");
                const promise = new Promise((resolve, reject)=>{
                    abort = reject;
                    window.addEventListener("pageshow", ()=>resolve(window.location.href));
                    redirect(params.url);
                });
                return await promise;
            },
            close: ()=>{
                this._logger.create("close");
                abort == null || abort(new Error("Redirect aborted"));
                targetWindow.stop();
            }
        };
    }
    async callback() {
        return;
    }
};
// src/UserManagerEvents.ts
var $91cdf6b8491513ba$var$UserManagerEvents = class extends $91cdf6b8491513ba$export$3b2b5f2b57921d4f {
    constructor(settings){
        super({
            expiringNotificationTimeInSeconds: settings.accessTokenExpiringNotificationTimeInSeconds
        });
        this._logger = new $91cdf6b8491513ba$export$efa9a398d6368992("UserManagerEvents");
        this._userLoaded = new $91cdf6b8491513ba$var$Event("User loaded");
        this._userUnloaded = new $91cdf6b8491513ba$var$Event("User unloaded");
        this._silentRenewError = new $91cdf6b8491513ba$var$Event("Silent renew error");
        this._userSignedIn = new $91cdf6b8491513ba$var$Event("User signed in");
        this._userSignedOut = new $91cdf6b8491513ba$var$Event("User signed out");
        this._userSessionChanged = new $91cdf6b8491513ba$var$Event("User session changed");
    }
    async load(user, raiseEvent = true) {
        await super.load(user);
        if (raiseEvent) await this._userLoaded.raise(user);
    }
    async unload() {
        await super.unload();
        await this._userUnloaded.raise();
    }
    /**
   * Add callback: Raised when a user session has been established (or re-established).
   */ addUserLoaded(cb) {
        return this._userLoaded.addHandler(cb);
    }
    /**
   * Remove callback: Raised when a user session has been established (or re-established).
   */ removeUserLoaded(cb) {
        return this._userLoaded.removeHandler(cb);
    }
    /**
   * Add callback: Raised when a user session has been terminated.
   */ addUserUnloaded(cb) {
        return this._userUnloaded.addHandler(cb);
    }
    /**
   * Remove callback: Raised when a user session has been terminated.
   */ removeUserUnloaded(cb) {
        return this._userUnloaded.removeHandler(cb);
    }
    /**
   * Add callback: Raised when the automatic silent renew has failed.
   */ addSilentRenewError(cb) {
        return this._silentRenewError.addHandler(cb);
    }
    /**
   * Remove callback: Raised when the automatic silent renew has failed.
   */ removeSilentRenewError(cb) {
        return this._silentRenewError.removeHandler(cb);
    }
    /**
   * @internal
   */ async _raiseSilentRenewError(e) {
        await this._silentRenewError.raise(e);
    }
    /**
   * Add callback: Raised when the user is signed in (when `monitorSession` is set).
   * @see {@link UserManagerSettings.monitorSession}
   */ addUserSignedIn(cb) {
        return this._userSignedIn.addHandler(cb);
    }
    /**
   * Remove callback: Raised when the user is signed in (when `monitorSession` is set).
   */ removeUserSignedIn(cb) {
        this._userSignedIn.removeHandler(cb);
    }
    /**
   * @internal
   */ async _raiseUserSignedIn() {
        await this._userSignedIn.raise();
    }
    /**
   * Add callback: Raised when the user's sign-in status at the OP has changed (when `monitorSession` is set).
   * @see {@link UserManagerSettings.monitorSession}
   */ addUserSignedOut(cb) {
        return this._userSignedOut.addHandler(cb);
    }
    /**
   * Remove callback: Raised when the user's sign-in status at the OP has changed (when `monitorSession` is set).
   */ removeUserSignedOut(cb) {
        this._userSignedOut.removeHandler(cb);
    }
    /**
   * @internal
   */ async _raiseUserSignedOut() {
        await this._userSignedOut.raise();
    }
    /**
   * Add callback: Raised when the user session changed (when `monitorSession` is set).
   * @see {@link UserManagerSettings.monitorSession}
   */ addUserSessionChanged(cb) {
        return this._userSessionChanged.addHandler(cb);
    }
    /**
   * Remove callback: Raised when the user session changed (when `monitorSession` is set).
   */ removeUserSessionChanged(cb) {
        this._userSessionChanged.removeHandler(cb);
    }
    /**
   * @internal
   */ async _raiseUserSessionChanged() {
        await this._userSessionChanged.raise();
    }
};
// src/SilentRenewService.ts
var $91cdf6b8491513ba$var$SilentRenewService = class {
    constructor(_userManager){
        this._userManager = _userManager;
        this._logger = new $91cdf6b8491513ba$export$efa9a398d6368992("SilentRenewService");
        this._isStarted = false;
        this._retryTimer = new $91cdf6b8491513ba$var$Timer("Retry Silent Renew");
        this._timeoutRetryCount = 0;
        this._tokenExpiring = async ()=>{
            const logger2 = this._logger.create("_tokenExpiring");
            try {
                await this._userManager.signinSilent();
                this._timeoutRetryCount = 0;
                logger2.debug("silent token renewal successful");
            } catch (err) {
                if (err instanceof $91cdf6b8491513ba$export$5312ab5d2c8d859c) {
                    this._timeoutRetryCount++;
                    const maxRetries = this._userManager.settings.maxSilentRenewTimeoutRetries;
                    const hasReachedLimit = maxRetries !== void 0 && this._timeoutRetryCount > maxRetries;
                    if (hasReachedLimit) {
                        logger2.error(`Timeout retry limit reached (${this._timeoutRetryCount} > ${maxRetries}), raising silentRenewError:`, err);
                        this._timeoutRetryCount = 0;
                        await this._userManager.events._raiseSilentRenewError(err);
                        return;
                    }
                    logger2.warn(`ErrorTimeout from signinSilent (attempt ${this._timeoutRetryCount}), retry in 5s:`, err);
                    this._retryTimer.init(5);
                    return;
                }
                logger2.error("Error from signinSilent:", err);
                this._timeoutRetryCount = 0;
                await this._userManager.events._raiseSilentRenewError(err);
            }
        };
    }
    async start() {
        const logger2 = this._logger.create("start");
        if (!this._isStarted) {
            this._isStarted = true;
            this._userManager.events.addAccessTokenExpiring(this._tokenExpiring);
            this._retryTimer.addHandler(this._tokenExpiring);
            try {
                await this._userManager.getUser();
            } catch (err) {
                logger2.error("getUser error", err);
            }
        }
    }
    stop() {
        if (this._isStarted) {
            this._retryTimer.cancel();
            this._retryTimer.removeHandler(this._tokenExpiring);
            this._userManager.events.removeAccessTokenExpiring(this._tokenExpiring);
            this._isStarted = false;
        }
    }
};
// src/RefreshState.ts
var $91cdf6b8491513ba$var$RefreshState = class {
    constructor(args){
        this.refresh_token = args.refresh_token;
        this.id_token = args.id_token;
        this.session_state = args.session_state;
        this.scope = args.scope;
        this.profile = args.profile;
        this.data = args.state;
    }
};
// src/UserManager.ts
var $91cdf6b8491513ba$export$4c4d82ee86d9366d = class {
    constructor(settings, redirectNavigator, popupNavigator, iframeNavigator){
        this._logger = new $91cdf6b8491513ba$export$efa9a398d6368992("UserManager");
        this.settings = new $91cdf6b8491513ba$export$620f0a652f69895a(settings);
        this._client = new $91cdf6b8491513ba$export$b112d407fa897c7e(settings);
        this._redirectNavigator = redirectNavigator != null ? redirectNavigator : new $91cdf6b8491513ba$var$RedirectNavigator(this.settings);
        this._popupNavigator = popupNavigator != null ? popupNavigator : new $91cdf6b8491513ba$var$PopupNavigator(this.settings);
        this._iframeNavigator = iframeNavigator != null ? iframeNavigator : new $91cdf6b8491513ba$var$IFrameNavigator(this.settings);
        this._events = new $91cdf6b8491513ba$var$UserManagerEvents(this.settings);
        this._silentRenewService = new $91cdf6b8491513ba$var$SilentRenewService(this);
        if (this.settings.automaticSilentRenew) this.startSilentRenew();
        this._sessionMonitor = null;
        if (this.settings.monitorSession) this._sessionMonitor = new $91cdf6b8491513ba$export$d962324009a92d99(this);
    }
    /**
   * Get object used to register for events raised by the `UserManager`.
   */ get events() {
        return this._events;
    }
    /**
   * Get object used to access the metadata configuration of the identity provider.
   */ get metadataService() {
        return this._client.metadataService;
    }
    /**
   * Load the `User` object for the currently authenticated user.
   *
   * @param raiseEvent - If `true`, the `UserLoaded` event will be raised. Defaults to false.
   * @returns A promise
   */ async getUser(raiseEvent = false) {
        const logger2 = this._logger.create("getUser");
        const user = await this._loadUser();
        if (user) {
            logger2.info("user loaded");
            await this._events.load(user, raiseEvent);
            return user;
        }
        logger2.info("user not found in storage");
        return null;
    }
    /**
   * Remove from any storage the currently authenticated user.
   *
   * @returns A promise
   */ async removeUser() {
        const logger2 = this._logger.create("removeUser");
        await this.storeUser(null);
        logger2.info("user removed from storage");
        await this._events.unload();
    }
    /**
   * Trigger a redirect of the current window to the authorization endpoint.
   *
   * @returns A promise
   *
   * @throws `Error` In cases of wrong authentication.
   */ async signinRedirect(args = {}) {
        var _a;
        this._logger.create("signinRedirect");
        const { redirectMethod: redirectMethod, ...requestArgs } = args;
        let dpopJkt;
        if ((_a = this.settings.dpop) == null ? void 0 : _a.bind_authorization_code) dpopJkt = await this.generateDPoPJkt(this.settings.dpop);
        const handle = await this._redirectNavigator.prepare({
            redirectMethod: redirectMethod
        });
        await this._signinStart({
            request_type: "si:r",
            dpopJkt: dpopJkt,
            ...requestArgs
        }, handle);
    }
    /**
   * Process the response (callback) from the authorization endpoint.
   * It is recommended to use {@link UserManager.signinCallback} instead.
   *
   * @returns A promise containing the authenticated `User`.
   *
   * @see {@link UserManager.signinCallback}
   */ async signinRedirectCallback(url = window.location.href) {
        const logger2 = this._logger.create("signinRedirectCallback");
        const user = await this._signinEnd(url);
        if (user.profile && user.profile.sub) logger2.info("success, signed in subject", user.profile.sub);
        else logger2.info("no subject");
        return user;
    }
    /**
   * Trigger the signin with user/password.
   *
   * @returns A promise containing the authenticated `User`.
   * @throws {@link ErrorResponse} In cases of wrong authentication.
   */ async signinResourceOwnerCredentials({ username: username, password: password, skipUserInfo: skipUserInfo = false }) {
        const logger2 = this._logger.create("signinResourceOwnerCredential");
        const signinResponse = await this._client.processResourceOwnerPasswordCredentials({
            username: username,
            password: password,
            skipUserInfo: skipUserInfo,
            extraTokenParams: this.settings.extraTokenParams
        });
        logger2.debug("got signin response");
        const user = await this._buildUser(signinResponse);
        if (user.profile && user.profile.sub) logger2.info("success, signed in subject", user.profile.sub);
        else logger2.info("no subject");
        return user;
    }
    /**
   * Trigger a request (via a popup window) to the authorization endpoint.
   *
   * @returns A promise containing the authenticated `User`.
   * @throws `Error` In cases of wrong authentication.
   */ async signinPopup(args = {}) {
        var _a;
        const logger2 = this._logger.create("signinPopup");
        let dpopJkt;
        if ((_a = this.settings.dpop) == null ? void 0 : _a.bind_authorization_code) dpopJkt = await this.generateDPoPJkt(this.settings.dpop);
        const { popupWindowFeatures: popupWindowFeatures, popupWindowTarget: popupWindowTarget, popupSignal: popupSignal, popupAbortOnClose: popupAbortOnClose, ...requestArgs } = args;
        const url = this.settings.popup_redirect_uri;
        if (!url) logger2.throw(new Error("No popup_redirect_uri configured"));
        const handle = await this._popupNavigator.prepare({
            popupWindowFeatures: popupWindowFeatures,
            popupWindowTarget: popupWindowTarget,
            popupSignal: popupSignal,
            popupAbortOnClose: popupAbortOnClose
        });
        const user = await this._signin({
            request_type: "si:p",
            redirect_uri: url,
            display: "popup",
            dpopJkt: dpopJkt,
            ...requestArgs
        }, handle);
        if (user) {
            if (user.profile && user.profile.sub) logger2.info("success, signed in subject", user.profile.sub);
            else logger2.info("no subject");
        }
        return user;
    }
    /**
   * Notify the opening window of response (callback) from the authorization endpoint.
   * It is recommended to use {@link UserManager.signinCallback} instead.
   *
   * @returns A promise
   *
   * @see {@link UserManager.signinCallback}
   */ async signinPopupCallback(url = window.location.href, keepOpen = false) {
        const logger2 = this._logger.create("signinPopupCallback");
        await this._popupNavigator.callback(url, {
            keepOpen: keepOpen
        });
        logger2.info("success");
    }
    /**
   * Trigger a silent request (via refresh token or an iframe) to the authorization endpoint.
   *
   * @returns A promise that contains the authenticated `User`.
   */ async signinSilent(args = {}) {
        var _a, _b;
        const logger2 = this._logger.create("signinSilent");
        const { silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds, ...requestArgs } = args;
        let user = await this._loadUser();
        if (!args.forceIframeAuth && (user == null ? void 0 : user.refresh_token)) {
            logger2.debug("using refresh token");
            const state = new $91cdf6b8491513ba$var$RefreshState(user);
            return await this._useRefreshToken({
                state: state,
                redirect_uri: requestArgs.redirect_uri,
                resource: requestArgs.resource,
                extraTokenParams: requestArgs.extraTokenParams,
                timeoutInSeconds: silentRequestTimeoutInSeconds
            });
        }
        let dpopJkt;
        if ((_a = this.settings.dpop) == null ? void 0 : _a.bind_authorization_code) dpopJkt = await this.generateDPoPJkt(this.settings.dpop);
        const url = this.settings.silent_redirect_uri;
        if (!url) logger2.throw(new Error("No silent_redirect_uri configured"));
        let verifySub;
        if (user && this.settings.validateSubOnSilentRenew) {
            logger2.debug("subject prior to silent renew:", user.profile.sub);
            verifySub = user.profile.sub;
        }
        const handle = await this._iframeNavigator.prepare({
            silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds
        });
        user = await this._signin({
            request_type: "si:s",
            redirect_uri: url,
            prompt: "none",
            id_token_hint: this.settings.includeIdTokenInSilentRenew ? user == null ? void 0 : user.id_token : void 0,
            dpopJkt: dpopJkt,
            ...requestArgs
        }, handle, verifySub);
        if (user) {
            if ((_b = user.profile) == null ? void 0 : _b.sub) logger2.info("success, signed in subject", user.profile.sub);
            else logger2.info("no subject");
        }
        return user;
    }
    async _useRefreshToken(args) {
        const response = await this._client.useRefreshToken({
            timeoutInSeconds: this.settings.silentRequestTimeoutInSeconds,
            ...args
        });
        const user = new $91cdf6b8491513ba$export$1f44aaf2ec115b54({
            ...args.state,
            ...response
        });
        await this.storeUser(user);
        await this._events.load(user);
        return user;
    }
    /**
   *
   * Notify the parent window of response (callback) from the authorization endpoint.
   * It is recommended to use {@link UserManager.signinCallback} instead.
   *
   * @returns A promise
   *
   * @see {@link UserManager.signinCallback}
   */ async signinSilentCallback(url = window.location.href) {
        const logger2 = this._logger.create("signinSilentCallback");
        await this._iframeNavigator.callback(url);
        logger2.info("success");
    }
    /**
   * Process any response (callback) from the authorization endpoint, by dispatching the request_type
   * and executing one of the following functions:
   * - {@link UserManager.signinRedirectCallback}
   * - {@link UserManager.signinPopupCallback}
   * - {@link UserManager.signinSilentCallback}
   *
   * @throws `Error` If request_type is unknown or signin cannot be processed.
   */ async signinCallback(url = window.location.href) {
        const { state: state } = await this._client.readSigninResponseState(url);
        switch(state.request_type){
            case "si:r":
                return await this.signinRedirectCallback(url);
            case "si:p":
                await this.signinPopupCallback(url);
                break;
            case "si:s":
                await this.signinSilentCallback(url);
                break;
            default:
                throw new Error("invalid request_type in state");
        }
        return void 0;
    }
    /**
   * Process any response (callback) from the end session endpoint, by dispatching the request_type
   * and executing one of the following functions:
   * - {@link UserManager.signoutRedirectCallback}
   * - {@link UserManager.signoutPopupCallback}
   * - {@link UserManager.signoutSilentCallback}
   *
   * @throws `Error` If request_type is unknown or signout cannot be processed.
   */ async signoutCallback(url = window.location.href, keepOpen = false) {
        const { state: state } = await this._client.readSignoutResponseState(url);
        if (!state) return void 0;
        switch(state.request_type){
            case "so:r":
                return await this.signoutRedirectCallback(url);
            case "so:p":
                await this.signoutPopupCallback(url, keepOpen);
                break;
            case "so:s":
                await this.signoutSilentCallback(url);
                break;
            default:
                throw new Error("invalid request_type in state");
        }
        return void 0;
    }
    /**
   * Query OP for user's current signin status.
   *
   * @returns A promise object with session_state and subject identifier.
   */ async querySessionStatus(args = {}) {
        const logger2 = this._logger.create("querySessionStatus");
        const { silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds, ...requestArgs } = args;
        const url = this.settings.silent_redirect_uri;
        if (!url) logger2.throw(new Error("No silent_redirect_uri configured"));
        const user = await this._loadUser();
        const handle = await this._iframeNavigator.prepare({
            silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds
        });
        const navResponse = await this._signinStart({
            request_type: "si:s",
            // this acts like a signin silent
            redirect_uri: url,
            prompt: "none",
            id_token_hint: this.settings.includeIdTokenInSilentRenew ? user == null ? void 0 : user.id_token : void 0,
            response_type: this.settings.query_status_response_type,
            scope: "openid",
            skipUserInfo: true,
            ...requestArgs
        }, handle);
        try {
            const extraHeaders = {};
            const signinResponse = await this._client.processSigninResponse(navResponse.url, extraHeaders);
            logger2.debug("got signin response");
            if (signinResponse.session_state && signinResponse.profile.sub) {
                logger2.info("success for subject", signinResponse.profile.sub);
                return {
                    session_state: signinResponse.session_state,
                    sub: signinResponse.profile.sub
                };
            }
            logger2.info("success, user not authenticated");
            return null;
        } catch (err) {
            if (this.settings.monitorAnonymousSession && err instanceof $91cdf6b8491513ba$export$acf1a680051f5031) switch(err.error){
                case "login_required":
                case "consent_required":
                case "interaction_required":
                case "account_selection_required":
                    logger2.info("success for anonymous user");
                    return {
                        session_state: err.session_state
                    };
            }
            throw err;
        }
    }
    async _signin(args, handle, verifySub) {
        const navResponse = await this._signinStart(args, handle);
        return await this._signinEnd(navResponse.url, verifySub);
    }
    async _signinStart(args, handle) {
        const logger2 = this._logger.create("_signinStart");
        try {
            const signinRequest = await this._client.createSigninRequest(args);
            logger2.debug("got signin request");
            return await handle.navigate({
                url: signinRequest.url,
                state: signinRequest.state.id,
                response_mode: signinRequest.state.response_mode,
                scriptOrigin: this.settings.iframeScriptOrigin
            });
        } catch (err) {
            logger2.debug("error after preparing navigator, closing navigator window");
            handle.close();
            throw err;
        }
    }
    async _signinEnd(url, verifySub) {
        const logger2 = this._logger.create("_signinEnd");
        const extraHeaders = {};
        const signinResponse = await this._client.processSigninResponse(url, extraHeaders);
        logger2.debug("got signin response");
        const user = await this._buildUser(signinResponse, verifySub);
        return user;
    }
    async _buildUser(signinResponse, verifySub) {
        const logger2 = this._logger.create("_buildUser");
        const user = new $91cdf6b8491513ba$export$1f44aaf2ec115b54(signinResponse);
        if (verifySub) {
            if (verifySub !== user.profile.sub) {
                logger2.debug("current user does not match user returned from signin. sub from signin:", user.profile.sub);
                throw new $91cdf6b8491513ba$export$acf1a680051f5031({
                    ...signinResponse,
                    error: "login_required"
                });
            }
            logger2.debug("current user matches user returned from signin");
        }
        await this.storeUser(user);
        logger2.debug("user stored");
        await this._events.load(user);
        return user;
    }
    /**
   * Trigger a redirect of the current window to the end session endpoint.
   *
   * @returns A promise
   */ async signoutRedirect(args = {}) {
        const logger2 = this._logger.create("signoutRedirect");
        const { redirectMethod: redirectMethod, ...requestArgs } = args;
        const handle = await this._redirectNavigator.prepare({
            redirectMethod: redirectMethod
        });
        await this._signoutStart({
            request_type: "so:r",
            post_logout_redirect_uri: this.settings.post_logout_redirect_uri,
            ...requestArgs
        }, handle);
        logger2.info("success");
    }
    /**
   * Process response (callback) from the end session endpoint.
   * It is recommended to use {@link UserManager.signoutCallback} instead.
   *
   * @returns A promise containing signout response
   *
   * @see {@link UserManager.signoutCallback}
   */ async signoutRedirectCallback(url = window.location.href) {
        const logger2 = this._logger.create("signoutRedirectCallback");
        const response = await this._signoutEnd(url);
        logger2.info("success");
        return response;
    }
    /**
   * Trigger a redirect of a popup window to the end session endpoint.
   *
   * @returns A promise
   */ async signoutPopup(args = {}) {
        const logger2 = this._logger.create("signoutPopup");
        const { popupWindowFeatures: popupWindowFeatures, popupWindowTarget: popupWindowTarget, popupSignal: popupSignal, ...requestArgs } = args;
        const url = this.settings.popup_post_logout_redirect_uri;
        const handle = await this._popupNavigator.prepare({
            popupWindowFeatures: popupWindowFeatures,
            popupWindowTarget: popupWindowTarget,
            popupSignal: popupSignal
        });
        await this._signout({
            request_type: "so:p",
            post_logout_redirect_uri: url,
            // we're putting a dummy entry in here because we
            // need a unique id from the state for notification
            // to the parent window, which is necessary if we
            // plan to return back to the client after signout
            // and so we can close the popup after signout
            state: url == null ? void 0 : {},
            ...requestArgs
        }, handle);
        logger2.info("success");
    }
    /**
   * Process response (callback) from the end session endpoint from a popup window.
   * It is recommended to use {@link UserManager.signoutCallback} instead.
   *
   * @returns A promise
   *
   * @see {@link UserManager.signoutCallback}
   */ async signoutPopupCallback(url = window.location.href, keepOpen = false) {
        const logger2 = this._logger.create("signoutPopupCallback");
        await this._popupNavigator.callback(url, {
            keepOpen: keepOpen
        });
        logger2.info("success");
    }
    async _signout(args, handle) {
        const navResponse = await this._signoutStart(args, handle);
        return await this._signoutEnd(navResponse.url);
    }
    async _signoutStart(args = {}, handle) {
        var _a;
        const logger2 = this._logger.create("_signoutStart");
        try {
            const user = await this._loadUser();
            logger2.debug("loaded current user from storage");
            if (this.settings.revokeTokensOnSignout) await this._revokeInternal(user);
            const id_token = args.id_token_hint || user && user.id_token;
            if (id_token) {
                logger2.debug("setting id_token_hint in signout request");
                args.id_token_hint = id_token;
            }
            await this.removeUser();
            logger2.debug("user removed, creating signout request");
            const signoutRequest = await this._client.createSignoutRequest(args);
            logger2.debug("got signout request");
            return await handle.navigate({
                url: signoutRequest.url,
                state: (_a = signoutRequest.state) == null ? void 0 : _a.id,
                scriptOrigin: this.settings.iframeScriptOrigin
            });
        } catch (err) {
            logger2.debug("error after preparing navigator, closing navigator window");
            handle.close();
            throw err;
        }
    }
    async _signoutEnd(url) {
        const logger2 = this._logger.create("_signoutEnd");
        const signoutResponse = await this._client.processSignoutResponse(url);
        logger2.debug("got signout response");
        return signoutResponse;
    }
    /**
   * Trigger a silent request (via an iframe) to the end session endpoint.
   *
   * @returns A promise
   */ async signoutSilent(args = {}) {
        var _a;
        const logger2 = this._logger.create("signoutSilent");
        const { silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds, ...requestArgs } = args;
        const id_token_hint = this.settings.includeIdTokenInSilentSignout ? (_a = await this._loadUser()) == null ? void 0 : _a.id_token : void 0;
        const url = this.settings.popup_post_logout_redirect_uri;
        const handle = await this._iframeNavigator.prepare({
            silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds
        });
        await this._signout({
            request_type: "so:s",
            post_logout_redirect_uri: url,
            id_token_hint: id_token_hint,
            ...requestArgs
        }, handle);
        logger2.info("success");
    }
    /**
   * Notify the parent window of response (callback) from the end session endpoint.
   * It is recommended to use {@link UserManager.signoutCallback} instead.
   *
   * @returns A promise
   *
   * @see {@link UserManager.signoutCallback}
   */ async signoutSilentCallback(url = window.location.href) {
        const logger2 = this._logger.create("signoutSilentCallback");
        await this._iframeNavigator.callback(url);
        logger2.info("success");
    }
    async revokeTokens(types) {
        const user = await this._loadUser();
        await this._revokeInternal(user, types);
    }
    async _revokeInternal(user, types = this.settings.revokeTokenTypes) {
        const logger2 = this._logger.create("_revokeInternal");
        if (!user) return;
        const typesPresent = types.filter((type)=>typeof user[type] === "string");
        if (!typesPresent.length) {
            logger2.debug("no need to revoke due to no token(s)");
            return;
        }
        for (const type of typesPresent){
            await this._client.revokeToken(user[type], type);
            logger2.info(`${type} revoked successfully`);
            if (type !== "access_token") user[type] = null;
        }
        await this.storeUser(user);
        logger2.debug("user stored");
        await this._events.load(user);
    }
    /**
   * Enables silent renew for the `UserManager`.
   */ startSilentRenew() {
        this._logger.create("startSilentRenew");
        this._silentRenewService.start();
    }
    /**
   * Disables silent renew for the `UserManager`.
   */ stopSilentRenew() {
        this._silentRenewService.stop();
    }
    get _userStoreKey() {
        return `user:${this.settings.authority}:${this.settings.client_id}`;
    }
    async _loadUser() {
        const logger2 = this._logger.create("_loadUser");
        const storageString = await this.settings.userStore.get(this._userStoreKey);
        if (storageString) {
            logger2.debug("user storageString loaded");
            return $91cdf6b8491513ba$export$1f44aaf2ec115b54.fromStorageString(storageString);
        }
        logger2.debug("no user storageString");
        return null;
    }
    async storeUser(user) {
        const logger2 = this._logger.create("storeUser");
        if (user) {
            logger2.debug("storing user");
            const storageString = user.toStorageString();
            await this.settings.userStore.set(this._userStoreKey, storageString);
        } else {
            this._logger.debug("removing user");
            await this.settings.userStore.remove(this._userStoreKey);
            if (this.settings.dpop) await this.settings.dpop.store.remove(this.settings.client_id);
        }
    }
    /**
   * Removes stale state entries in storage for incomplete authorize requests.
   */ async clearStaleState() {
        await this._client.clearStaleState();
    }
    /**
   * Dynamically generates a DPoP proof for a given user, URL and optional Http method.
   * This method is useful when you need to make a request to a resource server
   * with fetch or similar, and you need to include a DPoP proof in a DPoP header.
   * @param url - The URL to generate the DPoP proof for
   * @param user - The user to generate the DPoP proof for
   * @param httpMethod - Optional, defaults to "GET"
   * @param nonce - Optional nonce provided by the resource server
   *
   * @returns A promise containing the DPoP proof or undefined if DPoP is not enabled/no user is found.
   */ async dpopProof(url, user, httpMethod, nonce) {
        var _a, _b;
        const dpopState = await ((_b = (_a = this.settings.dpop) == null ? void 0 : _a.store) == null ? void 0 : _b.get(this.settings.client_id));
        if (dpopState) return await $91cdf6b8491513ba$var$CryptoUtils.generateDPoPProof({
            url: url,
            accessToken: user == null ? void 0 : user.access_token,
            httpMethod: httpMethod,
            keyPair: dpopState.keys,
            nonce: nonce
        });
        return void 0;
    }
    async generateDPoPJkt(dpopSettings) {
        let dpopState = await dpopSettings.store.get(this.settings.client_id);
        if (!dpopState) {
            const dpopKeys = await $91cdf6b8491513ba$var$CryptoUtils.generateDPoPKeys();
            dpopState = new $91cdf6b8491513ba$export$dc765d984eae7c82(dpopKeys);
            await dpopSettings.store.set(this.settings.client_id, dpopState);
        }
        return await $91cdf6b8491513ba$var$CryptoUtils.generateDPoPJkt(dpopState.keys);
    }
};
// package.json
var $91cdf6b8491513ba$var$version = "3.5.0";
// src/Version.ts
var $91cdf6b8491513ba$export$682c179f50ab847d = $91cdf6b8491513ba$var$version;
// src/IndexedDbDPoPStore.ts
var $91cdf6b8491513ba$export$400f3eb0d146981b = class {
    constructor(){
        this._dbName = "oidc";
        this._storeName = "dpop";
    }
    async set(key, value) {
        const store = await this.createStore(this._dbName, this._storeName);
        await store("readwrite", (str)=>{
            str.put(value, key);
            return this.promisifyRequest(str.transaction);
        });
    }
    async get(key) {
        const store = await this.createStore(this._dbName, this._storeName);
        return await store("readonly", (str)=>{
            return this.promisifyRequest(str.get(key));
        });
    }
    async remove(key) {
        const item = await this.get(key);
        const store = await this.createStore(this._dbName, this._storeName);
        await store("readwrite", (str)=>{
            return this.promisifyRequest(str.delete(key));
        });
        return item;
    }
    async getAllKeys() {
        const store = await this.createStore(this._dbName, this._storeName);
        return await store("readonly", (str)=>{
            return this.promisifyRequest(str.getAllKeys());
        });
    }
    promisifyRequest(request) {
        return new Promise((resolve, reject)=>{
            request.oncomplete = request.onsuccess = ()=>resolve(request.result);
            request.onabort = request.onerror = ()=>reject(request.error);
        });
    }
    async createStore(dbName, storeName) {
        const request = indexedDB.open(dbName);
        request.onupgradeneeded = ()=>request.result.createObjectStore(storeName);
        const db = await this.promisifyRequest(request);
        return async (txMode, callback)=>{
            const tx = db.transaction(storeName, txMode);
            const store = tx.objectStore(storeName);
            return await callback(store);
        };
    }
};


var $0d5ae4184fc53fd0$export$a0fd8390cfe8ae69 = (0, (/*@__PURE__*/$parcel$interopDefault($8v0nu))).createContext(void 0);
$0d5ae4184fc53fd0$export$a0fd8390cfe8ae69.displayName = "AuthContext";
// src/AuthState.ts
var $0d5ae4184fc53fd0$var$initialAuthState = {
    isLoading: true,
    isAuthenticated: false
};
// src/reducer.ts
var $0d5ae4184fc53fd0$var$reducer = (state, action)=>{
    switch(action.type){
        case "INITIALISED":
        case "USER_LOADED":
            return {
                ...state,
                user: action.user,
                isLoading: false,
                isAuthenticated: action.user ? !action.user.expired : false,
                error: void 0
            };
        case "USER_SIGNED_OUT":
        case "USER_UNLOADED":
            return {
                ...state,
                user: void 0,
                isAuthenticated: false
            };
        case "NAVIGATOR_INIT":
            return {
                ...state,
                isLoading: true,
                activeNavigator: action.method
            };
        case "NAVIGATOR_CLOSE":
            return {
                ...state,
                isLoading: false,
                activeNavigator: void 0
            };
        case "ERROR":
            {
                const error = action.error;
                error["toString"] = ()=>`${error.name}: ${error.message}`;
                return {
                    ...state,
                    isLoading: false,
                    error: error
                };
            }
        default:
            {
                const innerError = new TypeError(`unknown type ${action["type"]}`);
                const error = {
                    name: innerError.name,
                    message: innerError.message,
                    innerError: innerError,
                    stack: innerError.stack,
                    source: "unknown"
                };
                error["toString"] = ()=>`${error.name}: ${error.message}`;
                return {
                    ...state,
                    isLoading: false,
                    error: error
                };
            }
    }
};
// src/utils.ts
var $0d5ae4184fc53fd0$export$431ecbe9d31d54bd = (location = window.location)=>{
    let searchParams = new URLSearchParams(location.search);
    if ((searchParams.get("code") || searchParams.get("error")) && searchParams.get("state")) return true;
    searchParams = new URLSearchParams(location.hash.replace("#", "?"));
    if ((searchParams.get("code") || searchParams.get("error")) && searchParams.get("state")) return true;
    return false;
};
var $0d5ae4184fc53fd0$var$signinError = $0d5ae4184fc53fd0$var$normalizeErrorFn("signinCallback", "Sign-in failed");
var $0d5ae4184fc53fd0$var$signoutError = $0d5ae4184fc53fd0$var$normalizeErrorFn("signoutCallback", "Sign-out failed");
var $0d5ae4184fc53fd0$var$renewSilentError = $0d5ae4184fc53fd0$var$normalizeErrorFn("renewSilent", "Renew silent failed");
function $0d5ae4184fc53fd0$var$normalizeError(error, fallbackMessage) {
    return {
        name: $0d5ae4184fc53fd0$var$stringFieldOf(error, "name", ()=>"Error"),
        message: $0d5ae4184fc53fd0$var$stringFieldOf(error, "message", ()=>fallbackMessage),
        stack: $0d5ae4184fc53fd0$var$stringFieldOf(error, "stack", ()=>new Error().stack),
        innerError: error
    };
}
function $0d5ae4184fc53fd0$var$normalizeErrorFn(source, fallbackMessage) {
    return (error)=>{
        return {
            ...$0d5ae4184fc53fd0$var$normalizeError(error, fallbackMessage),
            source: source
        };
    };
}
function $0d5ae4184fc53fd0$var$stringFieldOf(element, fieldName, or) {
    if (element && typeof element === "object") {
        const value = element[fieldName];
        if (typeof value === "string") return value;
    }
    return or();
}
// src/AuthProvider.tsx
var $0d5ae4184fc53fd0$var$userManagerContextKeys = [
    "clearStaleState",
    "querySessionStatus",
    "revokeTokens",
    "startSilentRenew",
    "stopSilentRenew"
];
var $0d5ae4184fc53fd0$var$navigatorKeys = [
    "signinPopup",
    "signinSilent",
    "signinRedirect",
    "signinResourceOwnerCredentials",
    "signoutPopup",
    "signoutRedirect",
    "signoutSilent"
];
var $0d5ae4184fc53fd0$var$unsupportedEnvironment = (fnName)=>()=>{
        throw new Error(`UserManager#${fnName} was called from an unsupported context. If this is a server-rendered page, defer this call with useEffect() or pass a custom UserManager implementation.`);
    };
var $0d5ae4184fc53fd0$var$UserManagerImpl = typeof window === "undefined" ? null : (0, $91cdf6b8491513ba$export$4c4d82ee86d9366d);
var $0d5ae4184fc53fd0$export$87091915187a1a85 = (props)=>{
    const { children: children, onSigninCallback: onSigninCallback, skipSigninCallback: skipSigninCallback, matchSignoutCallback: matchSignoutCallback, onSignoutCallback: onSignoutCallback, onRemoveUser: onRemoveUser, userManager: userManagerProp = null, ...userManagerSettings } = props;
    const [userManager] = (0, (/*@__PURE__*/$parcel$interopDefault($8v0nu))).useState(()=>{
        return userManagerProp != null ? userManagerProp : $0d5ae4184fc53fd0$var$UserManagerImpl ? new $0d5ae4184fc53fd0$var$UserManagerImpl(userManagerSettings) : {
            settings: userManagerSettings
        };
    });
    const [state, dispatch] = (0, (/*@__PURE__*/$parcel$interopDefault($8v0nu))).useReducer($0d5ae4184fc53fd0$var$reducer, $0d5ae4184fc53fd0$var$initialAuthState);
    const userManagerContext = (0, (/*@__PURE__*/$parcel$interopDefault($8v0nu))).useMemo(()=>Object.assign({
            settings: userManager.settings,
            events: userManager.events
        }, Object.fromEntries($0d5ae4184fc53fd0$var$userManagerContextKeys.map((key)=>{
            var _a, _b;
            return [
                key,
                (_b = (_a = userManager[key]) == null ? void 0 : _a.bind(userManager)) != null ? _b : $0d5ae4184fc53fd0$var$unsupportedEnvironment(key)
            ];
        })), Object.fromEntries($0d5ae4184fc53fd0$var$navigatorKeys.map((key)=>[
                key,
                userManager[key] ? async (args)=>{
                    dispatch({
                        type: "NAVIGATOR_INIT",
                        method: key
                    });
                    try {
                        return await userManager[key](args);
                    } catch (error) {
                        dispatch({
                            type: "ERROR",
                            error: {
                                ...$0d5ae4184fc53fd0$var$normalizeError(error, `Unknown error while executing ${key}(...).`),
                                source: key,
                                args: args
                            }
                        });
                        return null;
                    } finally{
                        dispatch({
                            type: "NAVIGATOR_CLOSE"
                        });
                    }
                } : $0d5ae4184fc53fd0$var$unsupportedEnvironment(key)
            ]))), [
        userManager
    ]);
    const didInitialize = (0, (/*@__PURE__*/$parcel$interopDefault($8v0nu))).useRef(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($8v0nu))).useEffect(()=>{
        if (!userManager || didInitialize.current) return;
        didInitialize.current = true;
        (async ()=>{
            try {
                let user = null;
                if ($0d5ae4184fc53fd0$export$431ecbe9d31d54bd() && !skipSigninCallback) {
                    user = await userManager.signinCallback();
                    if (onSigninCallback) await onSigninCallback(user);
                }
                user = !user ? await userManager.getUser() : user;
                dispatch({
                    type: "INITIALISED",
                    user: user
                });
            } catch (error) {
                dispatch({
                    type: "ERROR",
                    error: $0d5ae4184fc53fd0$var$signinError(error)
                });
            }
            try {
                if (matchSignoutCallback && matchSignoutCallback(userManager.settings)) {
                    const resp = await userManager.signoutCallback();
                    if (onSignoutCallback) await onSignoutCallback(resp);
                }
            } catch (error) {
                dispatch({
                    type: "ERROR",
                    error: $0d5ae4184fc53fd0$var$signoutError(error)
                });
            }
        })();
    }, [
        userManager,
        skipSigninCallback,
        onSigninCallback,
        onSignoutCallback,
        matchSignoutCallback
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8v0nu))).useEffect(()=>{
        if (!userManager) return void 0;
        const handleUserLoaded = (user)=>{
            dispatch({
                type: "USER_LOADED",
                user: user
            });
        };
        userManager.events.addUserLoaded(handleUserLoaded);
        const handleUserUnloaded = ()=>{
            dispatch({
                type: "USER_UNLOADED"
            });
        };
        userManager.events.addUserUnloaded(handleUserUnloaded);
        const handleUserSignedOut = ()=>{
            dispatch({
                type: "USER_SIGNED_OUT"
            });
        };
        userManager.events.addUserSignedOut(handleUserSignedOut);
        const handleSilentRenewError = (error)=>{
            dispatch({
                type: "ERROR",
                error: $0d5ae4184fc53fd0$var$renewSilentError(error)
            });
        };
        userManager.events.addSilentRenewError(handleSilentRenewError);
        return ()=>{
            userManager.events.removeUserLoaded(handleUserLoaded);
            userManager.events.removeUserUnloaded(handleUserUnloaded);
            userManager.events.removeUserSignedOut(handleUserSignedOut);
            userManager.events.removeSilentRenewError(handleSilentRenewError);
        };
    }, [
        userManager
    ]);
    const removeUser = (0, (/*@__PURE__*/$parcel$interopDefault($8v0nu))).useCallback(async ()=>{
        if (!userManager) $0d5ae4184fc53fd0$var$unsupportedEnvironment("removeUser");
        await userManager.removeUser();
        if (onRemoveUser) await onRemoveUser();
    }, [
        userManager,
        onRemoveUser
    ]);
    const contextValue = (0, (/*@__PURE__*/$parcel$interopDefault($8v0nu))).useMemo(()=>{
        return {
            ...state,
            ...userManagerContext,
            removeUser: removeUser
        };
    }, [
        state,
        userManagerContext,
        removeUser
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($8v0nu))).createElement($0d5ae4184fc53fd0$export$a0fd8390cfe8ae69.Provider, {
        value: contextValue
    }, children);
};
var $0d5ae4184fc53fd0$export$1d39dc5b47e56ff0 = ()=>{
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($8v0nu))).useContext($0d5ae4184fc53fd0$export$a0fd8390cfe8ae69);
    if (!context) console.warn("AuthProvider context is undefined, please verify you are calling useAuth() as child of a <AuthProvider> component.");
    return context;
};
function $0d5ae4184fc53fd0$export$427f722d7a79eb97({ signinMethod: signinMethod = "signinRedirect", signinArgs: signinArgs } = {}) {
    const auth = $0d5ae4184fc53fd0$export$1d39dc5b47e56ff0();
    const [hasTriedSignin, setHasTriedSignin] = (0, (/*@__PURE__*/$parcel$interopDefault($8v0nu))).useState(false);
    const shouldAttemptSignin = (0, (/*@__PURE__*/$parcel$interopDefault($8v0nu))).useMemo(()=>!$0d5ae4184fc53fd0$export$431ecbe9d31d54bd() && !auth.isAuthenticated && !auth.activeNavigator && !auth.isLoading && !hasTriedSignin, [
        auth.activeNavigator,
        auth.isAuthenticated,
        auth.isLoading,
        hasTriedSignin
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8v0nu))).useEffect(()=>{
        if (shouldAttemptSignin) {
            switch(signinMethod){
                case "signinPopup":
                    auth.signinPopup(signinArgs);
                    break;
                case "signinRedirect":
                default:
                    auth.signinRedirect(signinArgs);
                    break;
            }
            setHasTriedSignin(true);
        }
    }, [
        auth,
        hasTriedSignin,
        shouldAttemptSignin,
        signinMethod,
        signinArgs
    ]);
    return {
        isLoading: auth.isLoading,
        isAuthenticated: auth.isAuthenticated,
        error: auth.error
    };
}
function $0d5ae4184fc53fd0$export$edfabac72365802(Component) {
    const displayName = `withAuth(${Component.displayName || Component.name})`;
    const C = (props)=>{
        const auth = $0d5ae4184fc53fd0$export$1d39dc5b47e56ff0();
        return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($8v0nu))).createElement(Component, {
            ...props,
            auth: auth
        });
    };
    C.displayName = displayName;
    return C;
}
var $0d5ae4184fc53fd0$export$2cfd0b285ff12c70 = (Component, options = {})=>{
    const { OnRedirecting: OnRedirecting = ()=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($8v0nu))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8v0nu))).Fragment, null), onBeforeSignin: onBeforeSignin, signinRedirectArgs: signinRedirectArgs } = options;
    const displayName = `withAuthenticationRequired(${Component.displayName || Component.name})`;
    const C = (props)=>{
        const auth = $0d5ae4184fc53fd0$export$1d39dc5b47e56ff0();
        (0, (/*@__PURE__*/$parcel$interopDefault($8v0nu))).useEffect(()=>{
            if ($0d5ae4184fc53fd0$export$431ecbe9d31d54bd() || auth.isLoading || auth.activeNavigator || auth.isAuthenticated) return;
            (async ()=>{
                if (onBeforeSignin) await onBeforeSignin();
                await auth.signinRedirect(signinRedirectArgs);
            })();
        }, [
            auth.isLoading,
            auth.isAuthenticated,
            auth
        ]);
        return auth.isAuthenticated ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($8v0nu))).createElement(Component, {
            ...props
        }) : OnRedirecting();
    };
    C.displayName = displayName;
    return C;
};



// Trigger a silent renewal this many seconds before the access token expires.
// Matches oidc-client-ts's default; restated here so the visibility-change
// top-up uses the same threshold.
const $c837ac9c698038bc$var$REFRESH_THRESHOLD_SECONDS = 60;
const $c837ac9c698038bc$var$DisabledContext = {
    isEnabled: false,
    isLoading: false,
    isAuthenticated: false,
    login: ()=>Promise.resolve(),
    logout: ()=>Promise.resolve(),
    refreshAuth: ()=>Promise.resolve(undefined)
};
const $c837ac9c698038bc$var$AuthContext = /*#__PURE__*/ (0, $8v0nu.createContext)($c837ac9c698038bc$var$DisabledContext);
const $c837ac9c698038bc$var$config = undefined;
function $c837ac9c698038bc$var$EnabledAuthBridge(props) {
    const oidc = (0, $0d5ae4184fc53fd0$export$1d39dc5b47e56ff0)();
    // Single failure policy for any refresh path. Only a definitive answer
    // from the IdP — an OAuth error response such as invalid_grant — means the
    // session is dead, so only then drop local user state (removeUser, not
    // signoutRedirect, so no IdP round-trip is needed). Anything else is
    // transient: the visibility top-up fires the instant a hibernated tab
    // becomes visible, typically before Wi-Fi has reconnected after laptop
    // wake, and a plain network error there must not destroy a session whose
    // refresh token is still valid.
    const handleRefreshFailure = (0, $8v0nu.useCallback)((err)=>{
        // eslint-disable-next-line no-console
        console.warn('Silent token refresh failed:', err);
        if (err instanceof (0, $91cdf6b8491513ba$export$acf1a680051f5031)) oidc.removeUser();
    }, [
        oidc
    ]);
    // Shared wrapper around signinSilent that funnels every failure through
    // handleRefreshFailure. Used by both the visibility-change top-up and the
    // API-layer's 401 self-heal. Concurrent callers — e.g. several requests
    // 401ing at once, or a 401 retry overlapping the visibility/expired
    // handlers — share one in-flight refresh: under IdP refresh-token rotation
    // with reuse detection, racing two refresh_token grants can revoke the
    // whole session.
    const inflightRefresh = (0, $8v0nu.useRef)(null);
    const silentRefresh = (0, $8v0nu.useCallback)(()=>{
        if (inflightRefresh.current) return inflightRefresh.current;
        inflightRefresh.current = (async ()=>{
            try {
                const user = await oidc.signinSilent();
                return user?.access_token;
            } catch (err) {
                handleRefreshFailure(err);
                return undefined;
            } finally{
                inflightRefresh.current = null;
            }
        })();
        return inflightRefresh.current;
    }, [
        oidc,
        handleRefreshFailure
    ]);
    // Top up the access token whenever the tab comes back from hibernation.
    // automaticSilentRenew uses setTimeout, which browsers can throttle or
    // skip entirely while the tab is hidden — so a token that "should" have
    // refreshed in the background may be expired when the user returns.
    (0, $8v0nu.useEffect)(()=>{
        if (!oidc.isAuthenticated) return;
        const maybeRefresh = ()=>{
            if (document.visibilityState !== 'visible') return;
            const expiresAt = oidc.user?.expires_at; // seconds since epoch
            if (!expiresAt) return;
            const now = Math.floor(Date.now() / 1000);
            if (expiresAt - now > $c837ac9c698038bc$var$REFRESH_THRESHOLD_SECONDS) return;
            silentRefresh();
        };
        document.addEventListener('visibilitychange', maybeRefresh);
        return ()=>{
            document.removeEventListener('visibilitychange', maybeRefresh);
        };
    }, [
        oidc,
        silentRefresh
    ]);
    // Background automaticSilentRenew failures don't surface as a thrown error
    // here — oidc-client-ts emits them via UserManagerEvents, so we hook the
    // same failure policy onto that event.
    (0, $8v0nu.useEffect)(()=>{
        oidc.events.addSilentRenewError(handleRefreshFailure);
        return ()=>{
            oidc.events.removeSilentRenewError(handleRefreshFailure);
        };
    }, [
        oidc,
        handleRefreshFailure
    ]);
    // Backstop for the case where automaticSilentRenew never even attempts a
    // refresh (scheduling glitch, no refresh_token, throttled background tab).
    // Without this, the token can sit in oidc.user past its expiry and every
    // request through stac-react — which has no 401-retry — fails with 401.
    // On success the new token propagates via context; on failure
    // handleRefreshFailure clears the user so the bridge stops attaching the
    // dead bearer.
    (0, $8v0nu.useEffect)(()=>{
        const onExpired = ()=>{
            silentRefresh();
        };
        oidc.events.addAccessTokenExpired(onExpired);
        return ()=>{
            oidc.events.removeAccessTokenExpired(onExpired);
        };
    }, [
        oidc,
        silentRefresh
    ]);
    const value = (0, $8v0nu.useMemo)(()=>{
        const p = oidc.user?.profile;
        const profile = p ? {
            username: p.preferred_username,
            email: p.email,
            firstName: p.given_name,
            lastName: p.family_name,
            emailVerified: p.email_verified
        } : undefined;
        return {
            isEnabled: true,
            // react-oidc-context flips isLoading for the whole duration of a
            // wrapped signinSilent call (visibility top-up, accessTokenExpired
            // backstop, 401 self-heal). Surfacing that would swap the app for the
            // loading spinner mid-session — a full unmount/remount that loses
            // form state — so silent renews are exempted here.
            isLoading: oidc.isLoading && oidc.activeNavigator !== 'signinSilent',
            isAuthenticated: !!oidc.isAuthenticated,
            profile: profile,
            token: oidc.user?.access_token,
            login: (opts)=>oidc.signinRedirect({
                    redirect_uri: opts?.redirectUri ?? window.location.href
                }),
            logout: (opts)=>oidc.signoutRedirect({
                    post_logout_redirect_uri: opts?.redirectUri ?? window.location.href
                }),
            refreshAuth: silentRefresh
        };
    }, [
        oidc,
        silentRefresh
    ]);
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)($c837ac9c698038bc$var$AuthContext.Provider, {
        value: value,
        children: props.children
    });
}
function $c837ac9c698038bc$export$87091915187a1a85(props) {
    if (!$c837ac9c698038bc$var$config) {
        // eslint-disable-next-line no-console
        console.debug('OIDC config not found, authentication disabled. To enable, set REACT_APP_OIDC_AUTHORITY and REACT_APP_OIDC_CLIENT_ID environment variables.');
        return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)($c837ac9c698038bc$var$AuthContext.Provider, {
            value: $c837ac9c698038bc$var$DisabledContext,
            children: props.children
        });
    }
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $0d5ae4184fc53fd0$export$87091915187a1a85), {
        authority: $c837ac9c698038bc$var$config.authority,
        client_id: $c837ac9c698038bc$var$config.clientId,
        redirect_uri: window.location.origin + window.location.pathname,
        post_logout_redirect_uri: window.location.origin + window.location.pathname,
        // `offline_access` asks the IdP for a refresh token. Without it most
        // providers issue access-token-only sessions, and oidc-client-ts falls
        // back to iframe-based silent renewal — which is unreliable under
        // modern third-party-cookie restrictions. With a refresh token, silent
        // renewal uses the refresh_token grant and just works.
        scope: "openid profile email offline_access",
        automaticSilentRenew: true,
        userStore: new (0, $91cdf6b8491513ba$export$6a5d9eefd8f07eee)({
            store: window.localStorage
        }),
        onSigninCallback: ()=>{
            // Remove code/state params from URL after successful login
            window.history.replaceState({}, document.title, window.location.pathname);
        },
        children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)($c837ac9c698038bc$var$EnabledAuthBridge, {
            children: props.children
        })
    });
}
function $c837ac9c698038bc$export$1d39dc5b47e56ff0() {
    return (0, $8v0nu.useContext)($c837ac9c698038bc$var$AuthContext);
}


function $ab8658d5c674cf12$export$8ef2ed426dede42d(props) {
    const { Component: Component, ...rest } = props;
    (0, $aec39e40387762bd$export$2e2bcd8739ae039)('Authentication Required');
    const auth = (0, $c837ac9c698038bc$export$1d39dc5b47e56ff0)();
    if (!auth.isEnabled) return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)(Component, {
        ...rest
    });
    if (auth.isAuthenticated) return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)(Component, {
        ...rest
    });
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
        direction: "column",
        gap: 4,
        children: [
            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $dfd76aae8c4830bc$export$644c29b44a905178), {
                title: "Authentication Required",
                overline: "Oops"
            }),
            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
                direction: "column",
                gap: 2,
                p: 4,
                children: [
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9318c0c5b8c25a88$export$5f1af8db9871e1d6), {
                        children: "You need to login to access this content."
                    }),
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $a987639d7be6b91e$export$353f5b6fc5456de1), {
                        alignSelf: "flex-start",
                        variant: "solid",
                        colorPalette: "primary",
                        onClick: ()=>auth.login({
                                redirectUri: window.location.href
                            }),
                        children: "Login"
                    })
                ]
            })
        ]
    });
}



parcelRequire("8v0nu");
var $31d9364a1b2177e0$exports = {};

$parcel$export($31d9364a1b2177e0$exports, "Indicator", function () { return $e935b23ac4c7f3ad$export$d375f1eed74d6a0e; });
$parcel$export($31d9364a1b2177e0$exports, "Item", function () { return $e935b23ac4c7f3ad$export$a7b06bfba60a8a78; });
$parcel$export($31d9364a1b2177e0$exports, "Root", function () { return $e935b23ac4c7f3ad$export$3fd2536aa7317f19; });
$parcel$export($31d9364a1b2177e0$exports, "RootPropsProvider", function () { return $e935b23ac4c7f3ad$export$189b7c86fd2ac639; });


var $8v0nu = parcelRequire("8v0nu");







var $8v0nu = parcelRequire("8v0nu");

"use strict";
"use client";
function $b8301707a52df201$export$51a14f30f34875a5(options) {
    const { key: key, recipe: recipeProp } = options;
    const sys = (0, $771f18fb4c7e08d8$export$e4f18fbc74d20572)();
    return (0, $8v0nu.useMemo)(()=>{
        const recipe = recipeProp || (key != null ? sys.getSlotRecipe(key) : {});
        return sys.sva(structuredClone(recipe));
    }, [
        key,
        recipeProp,
        sys
    ]);
}


"use strict";
"use client";
const $04636a451c2392c0$export$ac7f79c9443925b8 = (options)=>{
    const { key: recipeKey, recipe: recipeConfig } = options;
    const contextName = (0, $53eb36df3e1e11a3$export$3061f22cd819074d)(recipeKey || recipeConfig.className || "Component");
    const [StylesProvider, useStyles] = (0, $542c4e2ea7b8b6b9$export$fd42f52fd3ae1109)({
        name: `${contextName}StylesContext`,
        errorMessage: `use${contextName}Styles returned is 'undefined'. Seems you forgot to wrap the components in "<${contextName}.Root />" `
    });
    const [ClassNamesProvider, useClassNames] = (0, $542c4e2ea7b8b6b9$export$fd42f52fd3ae1109)({
        name: `${contextName}ClassNameContext`,
        errorMessage: `use${contextName}ClassNames returned is 'undefined'. Seems you forgot to wrap the components in "<${contextName}.Root />" `,
        strict: false
    });
    const [PropsProvider, usePropsContext] = (0, $542c4e2ea7b8b6b9$export$fd42f52fd3ae1109)({
        strict: false,
        name: `${contextName}PropsContext`,
        providerName: `${contextName}PropsContext`,
        defaultValue: {}
    });
    function useRecipeResult(props) {
        const { unstyled: unstyled, ...restProps } = props;
        const slotRecipe = (0, $b8301707a52df201$export$51a14f30f34875a5)({
            key: recipeKey,
            recipe: restProps.recipe || recipeConfig
        });
        const [variantProps, otherProps] = (0, $8v0nu.useMemo)(()=>slotRecipe.splitVariantProps(restProps), [
            restProps,
            slotRecipe
        ]);
        const styles = (0, $8v0nu.useMemo)(()=>unstyled ? (0, $0fb716203df70dd7$export$d3d148c3a490a1e4) : slotRecipe(variantProps), [
            unstyled,
            variantProps,
            slotRecipe
        ]);
        return {
            styles: styles,
            classNames: slotRecipe.classNameMap,
            props: otherProps
        };
    }
    function withRootProvider(Component, options2 = {}) {
        const { defaultProps: defaultProps, displayName: displayNameOverride } = options2;
        const innerName = (0, $53eb36df3e1e11a3$export$781f7f324ca6010c)(Component);
        const inferredDisplayName = (0, $53eb36df3e1e11a3$export$6b3393e9b9dbb0d)(contextName, innerName);
        const StyledComponent = (inProps)=>{
            const propsContext = usePropsContext();
            const props = (0, $8v0nu.useMemo)(()=>(0, $c138fae1cd321339$export$9d1611c77c2fe928)(defaultProps, propsContext, inProps), [
                propsContext,
                inProps
            ]);
            const { styles: styles, classNames: classNames, props: rootProps } = useRecipeResult(props);
            return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)(StylesProvider, {
                value: styles,
                children: /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)(ClassNamesProvider, {
                    value: classNames,
                    children: /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)(Component, {
                        ...rootProps
                    })
                })
            });
        };
        StyledComponent.displayName = displayNameOverride ?? inferredDisplayName ?? innerName;
        return StyledComponent;
    }
    const withProvider = (Component, slot, options2)=>{
        const { defaultProps: defaultProps, displayName: displayNameOverride, wrapElement: wrapElement, ...restOptions } = options2 ?? {};
        const inferredDisplayName = (0, $53eb36df3e1e11a3$export$f044e71dd8693dc7)(contextName, String(slot));
        const SuperComponent = (0, $4042601bfa1a9d25$export$7cd122d781af9fa4)(Component, {}, restOptions);
        const StyledComponent = (0, $8v0nu.forwardRef)((inProps, ref)=>{
            const propsContext = usePropsContext();
            const props = (0, $8v0nu.useMemo)(()=>(0, $c138fae1cd321339$export$9d1611c77c2fe928)(defaultProps ?? {}, propsContext, inProps), [
                propsContext,
                inProps
            ]);
            const { styles: styles, props: rootProps, classNames: classNames } = useRecipeResult(props);
            const className = classNames[slot];
            const element = /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)(StylesProvider, {
                value: styles,
                children: /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)(ClassNamesProvider, {
                    value: classNames,
                    children: /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)(SuperComponent, {
                        ref: ref,
                        ...rootProps,
                        css: [
                            styles[slot],
                            props.css
                        ],
                        className: (0, $99474b193e949655$export$a274e22fb40f762e)(props.className, className)
                    })
                })
            });
            return wrapElement?.(element, props) ?? element;
        });
        StyledComponent.displayName = displayNameOverride ?? inferredDisplayName ?? (0, $53eb36df3e1e11a3$export$781f7f324ca6010c)(Component);
        return StyledComponent;
    };
    const withContext = (Component, slot, options2)=>{
        const { displayName: displayNameOverride, ...chakraOptions } = options2 ?? {};
        const inferredDisplayName = slot != null && slot !== "" ? (0, $53eb36df3e1e11a3$export$f044e71dd8693dc7)(contextName, String(slot)) : contextName;
        const SuperComponent = (0, $4042601bfa1a9d25$export$7cd122d781af9fa4)(Component, {}, chakraOptions);
        const StyledComponent = (0, $8v0nu.forwardRef)((props, ref)=>{
            const { unstyled: unstyled, ...restProps } = props;
            const styles = useStyles();
            const classNames = useClassNames();
            const className = classNames?.[slot];
            return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)(SuperComponent, {
                ...restProps,
                css: [
                    !unstyled && slot ? styles[slot] : void 0,
                    props.css
                ],
                ref: ref,
                className: (0, $99474b193e949655$export$a274e22fb40f762e)(props.className, className)
            });
        });
        StyledComponent.displayName = displayNameOverride ?? inferredDisplayName ?? (0, $53eb36df3e1e11a3$export$781f7f324ca6010c)(Component);
        return StyledComponent;
    };
    return {
        StylesProvider: StylesProvider,
        ClassNamesProvider: ClassNamesProvider,
        PropsProvider: PropsProvider,
        usePropsContext: usePropsContext,
        useRecipeResult: useRecipeResult,
        withProvider: withProvider,
        withContext: withContext,
        withRootProvider: withRootProvider,
        useStyles: useStyles,
        useClassNames: useClassNames
    };
};


"use strict";
"use client";
const { withProvider: $e935b23ac4c7f3ad$var$withProvider, withContext: $e935b23ac4c7f3ad$var$withContext, useStyles: $e935b23ac4c7f3ad$export$cc8f1462c0be9565, PropsProvider: $e935b23ac4c7f3ad$var$PropsProvider } = (0, $04636a451c2392c0$export$ac7f79c9443925b8)({
    key: "list"
});
const $e935b23ac4c7f3ad$export$3fd2536aa7317f19 = $e935b23ac4c7f3ad$var$withProvider("ul", "root", {
    defaultProps: {
        role: "list"
    }
});
const $e935b23ac4c7f3ad$export$189b7c86fd2ac639 = $e935b23ac4c7f3ad$var$PropsProvider;
const $e935b23ac4c7f3ad$export$a7b06bfba60a8a78 = $e935b23ac4c7f3ad$var$withContext("li", "item");
const $e935b23ac4c7f3ad$export$d375f1eed74d6a0e = $e935b23ac4c7f3ad$var$withContext("span", "indicator");


"use strict";





var $8v0nu = parcelRequire("8v0nu");

"use strict";
"use client";
const { withContext: $eeccda9af68d4392$var$withContext, PropsProvider: $eeccda9af68d4392$var$PropsProvider } = (0, $aa5f4d03028a5427$export$e99ac154c18649c5)({
    key: "link"
});
const $eeccda9af68d4392$export$a6c7ac8248d6e38a = $eeccda9af68d4392$var$withContext("a");
const $eeccda9af68d4392$export$5d1a7d87cf890a12 = $eeccda9af68d4392$var$PropsProvider;



var $78d29a24c660df8a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8v0nu))).forwardRef(function SmartLink(props, ref) {
    const { to: to, children: children, ...rest } = props;
    const isExternal = to.match(/^(https?:)?\/\//) || to.match(/^(mailto|tel):/);
    return isExternal ? /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $eeccda9af68d4392$export$a6c7ac8248d6e38a), {
        ref: ref,
        href: to,
        ...rest,
        children: children
    }) : /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $eeccda9af68d4392$export$a6c7ac8248d6e38a), {
        ref: ref,
        ...rest,
        asChild: true,
        children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $d9197f3f1e79e9d9$export$a6c7ac8248d6e38a), {
            to: to,
            children: children
        })
    });
});




var $8v0nu = parcelRequire("8v0nu");
var $2207a5f1a4e8d6ed$exports = {};

$parcel$export($2207a5f1a4e8d6ed$exports, "Context", function () { return $c54e04054e4b82c0$export$a20dad690e1279e2; });
$parcel$export($2207a5f1a4e8d6ed$exports, "Fallback", function () { return $c54e04054e4b82c0$export$69fffb6a9571fbfe; });
$parcel$export($2207a5f1a4e8d6ed$exports, "Icon", function () { return $c54e04054e4b82c0$export$b1f22795a41806ac; });
$parcel$export($2207a5f1a4e8d6ed$exports, "Image", function () { return $c54e04054e4b82c0$export$2cd8ae1985206fe8; });
$parcel$export($2207a5f1a4e8d6ed$exports, "PropsProvider", function () { return $c54e04054e4b82c0$export$c8ffe73a8586b78c; });
$parcel$export($2207a5f1a4e8d6ed$exports, "Root", function () { return $c54e04054e4b82c0$export$c38023ffdf1cc3ea; });
$parcel$export($2207a5f1a4e8d6ed$exports, "RootProvider", function () { return $c54e04054e4b82c0$export$10d1cc2b80f71976; });

//#region \0rolldown/runtime.js
var $57db88e2bf337fea$var$__defProp = Object.defineProperty;
var $57db88e2bf337fea$export$8126e515a7516e2 = (all, no_symbols)=>{
    let target = {};
    for(var name in all)$57db88e2bf337fea$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
    if (!no_symbols) $57db88e2bf337fea$var$__defProp(target, Symbol.toStringTag, {
        value: "Module"
    });
    return target;
};



// src/guard.ts
var $9a966d729185a601$export$40edfb7eeb78c4e8 = ()=>false;
var $9a966d729185a601$export$43bee75e5e14138e = (v)=>Array.isArray(v);
var $9a966d729185a601$export$f9ce7b637dfbe238 = (v)=>v === true || v === false;
var $9a966d729185a601$export$c10d0b04eaa80a43 = (v)=>v != null && typeof v === "object";
var $9a966d729185a601$export$a6cdc56e425d0d0a = (v)=>$9a966d729185a601$export$c10d0b04eaa80a43(v) && !$9a966d729185a601$export$43bee75e5e14138e(v);
var $9a966d729185a601$export$7e4aa119212bc614 = (v)=>typeof v === "number" && !Number.isNaN(v);
var $9a966d729185a601$export$844ec244b1367d54 = (v)=>typeof v === "string";
var $9a966d729185a601$export$f6e2535fb5126e54 = (v)=>typeof v === "function";
var $9a966d729185a601$export$630801d484da15df = (v)=>v == null;
var $9a966d729185a601$export$dd642ef726dcde21 = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
var $9a966d729185a601$var$baseGetTag = (v)=>Object.prototype.toString.call(v);
var $9a966d729185a601$var$fnToString = Function.prototype.toString;
var $9a966d729185a601$var$objectCtorString = $9a966d729185a601$var$fnToString.call(Object);
var $9a966d729185a601$export$53b83ca8eaab0383 = (v)=>{
    if (!$9a966d729185a601$export$c10d0b04eaa80a43(v) || $9a966d729185a601$var$baseGetTag(v) != "[object Object]" || $9a966d729185a601$var$isFrameworkElement(v)) return false;
    const proto = Object.getPrototypeOf(v);
    if (proto === null) return true;
    const Ctor = $9a966d729185a601$export$dd642ef726dcde21(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $9a966d729185a601$var$fnToString.call(Ctor) == $9a966d729185a601$var$objectCtorString;
};
var $9a966d729185a601$var$isReactElement = (x)=>typeof x === "object" && x !== null && "$$typeof" in x && "props" in x;
var $9a966d729185a601$var$isVueElement = (x)=>typeof x === "object" && x !== null && "__v_isVNode" in x;
var $9a966d729185a601$var$isFrameworkElement = (x)=>$9a966d729185a601$var$isReactElement(x) || $9a966d729185a601$var$isVueElement(x);



var $8v0nu = parcelRequire("8v0nu");
//#region src/utils/create-context.ts
function $51a09ee1e9e91bf5$var$getErrorMessage(hook, provider) {
    return `${hook} returned \`undefined\`. Seems you forgot to wrap component within ${provider}`;
}
function $51a09ee1e9e91bf5$export$fd42f52fd3ae1109(options = {}) {
    const { name: name, strict: strict = true, hookName: hookName = "useContext", providerName: providerName = "Provider", errorMessage: errorMessage, defaultValue: defaultValue } = options;
    const Context = (0, $8v0nu.createContext)(defaultValue);
    Context.displayName = name;
    function useContext$1() {
        const context = (0, $8v0nu.useContext)(Context);
        if (!context && strict) {
            const error = new Error(errorMessage ?? $51a09ee1e9e91bf5$var$getErrorMessage(hookName, providerName));
            error.name = "ContextError";
            if ((0, $9a966d729185a601$export$dd642ef726dcde21)(Error, "captureStackTrace") && (0, $9a966d729185a601$export$f6e2535fb5126e54)(Error.captureStackTrace)) Error.captureStackTrace(error, useContext$1);
            throw error;
        }
        return context;
    }
    return [
        Context.Provider,
        useContext$1,
        Context
    ];
}


"use client";
//#region src/components/avatar/use-avatar-context.ts
var [$8f4b94f67fb0f0b6$export$f0ddb3045e4d5906, $8f4b94f67fb0f0b6$export$b50b87a1c4086b23] = (0, $51a09ee1e9e91bf5$export$fd42f52fd3ae1109)({
    name: "AvatarContext",
    hookName: "useAvatarContext",
    providerName: "<AvatarProvider />"
});


"use client";
//#region src/components/avatar/avatar-context.tsx
var $3371280203c0e151$export$a20dad690e1279e2 = (props)=>props.children((0, $8f4b94f67fb0f0b6$export$b50b87a1c4086b23)());


//#region src/utils/compose-refs.ts
function $ab7129f9bbf0085f$export$43e446d32b3d21af(...refs) {
    return (node)=>{
        const cleanUps = [];
        for (const ref of refs)if (typeof ref === "function") {
            const cb = ref(node);
            if (typeof cb === "function") cleanUps.push(cb);
        } else if (ref) ref.current = node;
        if (cleanUps.length) return ()=>{
            for (const cleanUp of cleanUps)cleanUp();
        };
    };
}



var $8v0nu = parcelRequire("8v0nu");
// src/merge-props.ts


var $5246d161dcdee685$export$624e501d81f5ffce = (v, ...a)=>{
    const res = typeof v === "function" ? v(...a) : v;
    return res ?? void 0;
};
var $5246d161dcdee685$export$f2db7d5238e1d23f = (v)=>v;
var $5246d161dcdee685$export$f0954fd7d5368655 = (v)=>v();
var $5246d161dcdee685$export$8793edee2d425525 = ()=>{};
var $5246d161dcdee685$export$9dd9a52f2dd5b9ce = (...fns)=>(...a)=>{
        fns.forEach(function(fn) {
            fn?.(...a);
        });
    };
var $5246d161dcdee685$export$31b40729666a4ae0 = /* @__PURE__ */ (()=>{
    let id = 0;
    return ()=>{
        id++;
        return id.toString(36);
    };
})();
function $5246d161dcdee685$export$4659b591c19bdf3d(key, record, ...args) {
    if (key in record) {
        const fn = record[key];
        return (0, $9a966d729185a601$export$f6e2535fb5126e54)(fn) ? fn(...args) : fn;
    }
    const error = new Error(`No matching key: ${JSON.stringify(key)} in ${JSON.stringify(Object.keys(record))}`);
    Error.captureStackTrace?.(error, $5246d161dcdee685$export$4659b591c19bdf3d);
    throw error;
}
var $5246d161dcdee685$export$d234c058d1d4e435 = (fn, fallback)=>{
    try {
        return fn();
    } catch (error) {
        if (error instanceof Error) Error.captureStackTrace?.(error, $5246d161dcdee685$export$d234c058d1d4e435);
        return fallback?.();
    }
};
function $5246d161dcdee685$export$de363e709c412c8a(fn, wait = 0) {
    let lastCall = 0;
    let timeout = null;
    return (...args)=>{
        const now = Date.now();
        const timeSinceLastCall = now - lastCall;
        if (timeSinceLastCall >= wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            fn(...args);
            lastCall = now;
        } else if (!timeout) timeout = setTimeout(()=>{
            fn(...args);
            lastCall = Date.now();
            timeout = null;
        }, wait - timeSinceLastCall);
    };
}
function $5246d161dcdee685$export$61fc7d43ac8f84b0(fn, wait = 0) {
    let timeout = null;
    return (...args)=>{
        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }
        timeout = setTimeout(()=>{
            fn(...args);
        }, wait);
    };
}
var $5246d161dcdee685$var$toChar = (code)=>String.fromCharCode(code + (code > 25 ? 39 : 97));
function $5246d161dcdee685$var$toName(code) {
    let name = "";
    let x;
    for(x = Math.abs(code); x > 52; x = x / 52 | 0)name = $5246d161dcdee685$var$toChar(x % 52) + name;
    return $5246d161dcdee685$var$toChar(x % 52) + name;
}
function $5246d161dcdee685$var$toPhash(h, x) {
    let i = x.length;
    while(i)h = h * 33 ^ x.charCodeAt(--i);
    return h;
}
var $5246d161dcdee685$export$d6af199866bfb566 = (value)=>$5246d161dcdee685$var$toName($5246d161dcdee685$var$toPhash(5381, value) >>> 0);


var $ea59bff5c9936d72$var$clsx = (...args)=>args.map((str)=>str?.trim?.()).filter(Boolean).join(" ");
var $ea59bff5c9936d72$var$CSS_REGEX = /((?:--)?(?:\w+-?)+)\s*:\s*([^;]*)/g;
var $ea59bff5c9936d72$var$serialize = (style)=>{
    const res = {};
    let match;
    while(match = $ea59bff5c9936d72$var$CSS_REGEX.exec(style))res[match[1]] = match[2];
    return res;
};
var $ea59bff5c9936d72$var$css = (a, b)=>{
    if ((0, $9a966d729185a601$export$844ec244b1367d54)(a)) {
        if ((0, $9a966d729185a601$export$844ec244b1367d54)(b)) return `${a};${b}`;
        a = $ea59bff5c9936d72$var$serialize(a);
    } else if ((0, $9a966d729185a601$export$844ec244b1367d54)(b)) b = $ea59bff5c9936d72$var$serialize(b);
    return Object.assign({}, a ?? {}, b ?? {});
};
function $ea59bff5c9936d72$export$9d1611c77c2fe928(...args) {
    let result = {};
    for (let props of args){
        if (!props) continue;
        for(let key in result){
            if (key.startsWith("on") && typeof result[key] === "function" && typeof props[key] === "function") {
                result[key] = (0, $5246d161dcdee685$export$9dd9a52f2dd5b9ce)(props[key], result[key]);
                continue;
            }
            if (key === "className" || key === "class") {
                result[key] = $ea59bff5c9936d72$var$clsx(result[key], props[key]);
                continue;
            }
            if (key === "style") {
                result[key] = $ea59bff5c9936d72$var$css(result[key], props[key]);
                continue;
            }
            result[key] = props[key] !== void 0 ? props[key] : result[key];
        }
        for(let key in props)if (result[key] === void 0) result[key] = props[key];
        const symbols = Object.getOwnPropertySymbols(props);
        for (let symbol of symbols)result[symbol] = props[symbol];
    }
    return result;
}


//#region src/components/factory.ts
function $cc83854fb8cf60d1$var$getRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}
var $cc83854fb8cf60d1$var$withAsChild = (Component)=>{
    const Comp = (0, $8v0nu.memo)((0, $8v0nu.forwardRef)((props, ref)=>{
        const { asChild: asChild, children: children, ...restProps } = props;
        if (!asChild) return (0, $8v0nu.createElement)(Component, {
            ...restProps,
            ref: ref
        }, children);
        if (!(0, $8v0nu.isValidElement)(children)) return null;
        const onlyChild = (0, $8v0nu.Children).only(children);
        const childRef = $cc83854fb8cf60d1$var$getRef(onlyChild);
        return (0, $8v0nu.cloneElement)(onlyChild, {
            ...(0, $ea59bff5c9936d72$export$9d1611c77c2fe928)(restProps, onlyChild.props),
            ref: ref ? (0, $ab7129f9bbf0085f$export$43e446d32b3d21af)(ref, childRef) : childRef
        });
    }));
    Comp.displayName = Component.displayName || Component.name;
    return Comp;
};
var $cc83854fb8cf60d1$export$6953726f95ce7a26 = ()=>{
    const cache = /* @__PURE__ */ new Map();
    return new Proxy($cc83854fb8cf60d1$var$withAsChild, {
        apply (_target, _thisArg, argArray) {
            return $cc83854fb8cf60d1$var$withAsChild(argArray[0]);
        },
        get (_, element) {
            const asElement = element;
            if (!cache.has(asElement)) cache.set(asElement, $cc83854fb8cf60d1$var$withAsChild(asElement));
            return cache.get(asElement);
        }
    });
};
var $cc83854fb8cf60d1$export$d4dd0c6fc02249a9 = $cc83854fb8cf60d1$export$6953726f95ce7a26();




var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/avatar/avatar-fallback.tsx
var $5fd08ebf2958aff7$export$69fffb6a9571fbfe = (0, $8v0nu.forwardRef)((props, ref)=>{
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)((0, $8f4b94f67fb0f0b6$export$b50b87a1c4086b23)().getFallbackProps(), props);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).span, {
        ...mergedProps,
        ref: ref
    });
});
$5fd08ebf2958aff7$export$69fffb6a9571fbfe.displayName = "AvatarFallback";





var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/avatar/avatar-image.tsx
var $f8fa0aa353da7d39$export$2cd8ae1985206fe8 = (0, $8v0nu.forwardRef)((props, ref)=>{
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)((0, $8f4b94f67fb0f0b6$export$b50b87a1c4086b23)().getImageProps(), props);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).img, {
        ...mergedProps,
        ref: ref
    });
});
$f8fa0aa353da7d39$export$2cd8ae1985206fe8.displayName = "AvatarImage";


//#region src/utils/create-split-props.ts
var $41bdb03050f91b76$export$3ea53b214fbc1986 = ()=>(props, keys)=>keys.reduce((previousValue, currentValue)=>{
            const [target, source] = previousValue;
            const key = currentValue;
            if (source[key] !== void 0) target[key] = source[key];
            delete source[key];
            return [
                target,
                source
            ];
        }, [
            {},
            {
                ...props
            }
        ]);





"use client";
//#region src/providers/environment/use-environment-context.ts
var [$cfa7a900a06000ef$export$f25ed4a90a0c3c0c, $cfa7a900a06000ef$export$899b1e582a0b3c80] = (0, $51a09ee1e9e91bf5$export$fd42f52fd3ae1109)({
    name: "EnvironmentContext",
    hookName: "useEnvironmentContext",
    providerName: "<EnvironmentProvider />",
    strict: false,
    defaultValue: {
        getRootNode: ()=>document,
        getDocument: ()=>document,
        getWindow: ()=>window
    }
});



"use client";
//#region src/providers/locale/use-locale-context.ts
var [$af19f2672b388a39$export$ff34e5addbd1eccb, $af19f2672b388a39$export$2a7b1d9f665d6730] = (0, $51a09ee1e9e91bf5$export$fd42f52fd3ae1109)({
    name: "LocaleContext",
    hookName: "useLocaleContext",
    providerName: "<LocaleProvider />",
    strict: false,
    defaultValue: {
        dir: "ltr",
        locale: "en-US"
    }
});


// src/avatar.connect.ts
// src/avatar.anatomy.ts
// src/create-anatomy.ts
var $07b08c6ef332e8db$export$197e6e8d4b33fd6c = (name, parts = [])=>({
        parts: (...values)=>{
            if ($07b08c6ef332e8db$var$isEmpty(parts)) return $07b08c6ef332e8db$export$197e6e8d4b33fd6c(name, values);
            throw new Error("createAnatomy().parts(...) should only be called once. Did you mean to use .extendWith(...) ?");
        },
        extendWith: (...values)=>$07b08c6ef332e8db$export$197e6e8d4b33fd6c(name, [
                ...parts,
                ...values
            ]),
        omit: (...values)=>$07b08c6ef332e8db$export$197e6e8d4b33fd6c(name, parts.filter((part)=>!values.includes(part))),
        rename: (newName)=>$07b08c6ef332e8db$export$197e6e8d4b33fd6c(newName, parts),
        keys: ()=>parts,
        build: ()=>[
                ...new Set(parts)
            ].reduce((prev, part)=>Object.assign(prev, {
                    [part]: {
                        selector: [
                            `&[data-scope="${$07b08c6ef332e8db$var$toKebabCase(name)}"][data-part="${$07b08c6ef332e8db$var$toKebabCase(part)}"]`,
                            `& [data-scope="${$07b08c6ef332e8db$var$toKebabCase(name)}"][data-part="${$07b08c6ef332e8db$var$toKebabCase(part)}"]`
                        ].join(", "),
                        attrs: {
                            "data-scope": $07b08c6ef332e8db$var$toKebabCase(name),
                            "data-part": $07b08c6ef332e8db$var$toKebabCase(part)
                        }
                    }
                }), {})
    });
var $07b08c6ef332e8db$var$toKebabCase = (value)=>value.replace(/([A-Z])([A-Z])/g, "$1-$2").replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_]+/g, "-").toLowerCase();
var $07b08c6ef332e8db$var$isEmpty = (v)=>v.length === 0;


var $bae7990bd2b56513$export$477202748c7242bf = (0, $07b08c6ef332e8db$export$197e6e8d4b33fd6c)("avatar").parts("root", "image", "fallback");
var $bae7990bd2b56513$export$6e2410c1d27f06e7 = $bae7990bd2b56513$export$477202748c7242bf.build();


// src/avatar.dom.ts
var $b8942f9d243ff422$export$dfdcab00b0f585a9 = (ctx)=>ctx.ids?.root ?? `avatar:${ctx.id}`;
var $b8942f9d243ff422$export$8aaf31f1731561fd = (ctx)=>ctx.ids?.image ?? `avatar:${ctx.id}:image`;
var $b8942f9d243ff422$export$8ddcb56c40f77308 = (ctx)=>ctx.ids?.fallback ?? `avatar:${ctx.id}:fallback`;
var $b8942f9d243ff422$export$5688053fba312fa5 = (ctx)=>ctx.getById($b8942f9d243ff422$export$dfdcab00b0f585a9(ctx));
var $b8942f9d243ff422$export$a31b96d9dc141173 = (ctx)=>ctx.getById($b8942f9d243ff422$export$8aaf31f1731561fd(ctx));


function $dfd3d9237dd60c00$export$64605811ab45167f(service, normalize) {
    const { state: state, send: send, prop: prop, scope: scope } = service;
    const loaded = state.matches("loaded");
    return {
        loaded: loaded,
        setSrc (src) {
            const img = $b8942f9d243ff422$export$a31b96d9dc141173(scope);
            img?.setAttribute("src", src);
        },
        setLoaded () {
            send({
                type: "img.loaded",
                src: "api"
            });
        },
        setError () {
            send({
                type: "img.error",
                src: "api"
            });
        },
        getRootProps () {
            return normalize.element({
                ...(0, $bae7990bd2b56513$export$6e2410c1d27f06e7).root.attrs,
                dir: prop("dir"),
                id: $b8942f9d243ff422$export$dfdcab00b0f585a9(scope)
            });
        },
        getImageProps () {
            return normalize.img({
                ...(0, $bae7990bd2b56513$export$6e2410c1d27f06e7).image.attrs,
                hidden: !loaded,
                dir: prop("dir"),
                id: $b8942f9d243ff422$export$8aaf31f1731561fd(scope),
                "data-state": loaded ? "visible" : "hidden",
                onLoad () {
                    send({
                        type: "img.loaded",
                        src: "element"
                    });
                },
                onError () {
                    send({
                        type: "img.error",
                        src: "element"
                    });
                }
            });
        },
        getFallbackProps () {
            return normalize.element({
                ...(0, $bae7990bd2b56513$export$6e2410c1d27f06e7).fallback.attrs,
                dir: prop("dir"),
                id: $b8942f9d243ff422$export$8ddcb56c40f77308(scope),
                hidden: loaded,
                "data-state": loaded ? "hidden" : "visible"
            });
        }
    };
}

// src/avatar.machine.ts

var $15589ce76e06e947$var$__defProp = Object.defineProperty;
var $15589ce76e06e947$var$__defNormalProp = (obj, key, value)=>key in obj ? $15589ce76e06e947$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $15589ce76e06e947$export$5cb848ba4d1f099 = (obj, key, value)=>$15589ce76e06e947$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);


// src/raf.ts
var $7eacfb22d5a39e52$export$1f3d5b43727c648a = class _AnimationFrame {
    constructor(){
        (0, $15589ce76e06e947$export$5cb848ba4d1f099)(this, "id", null);
        (0, $15589ce76e06e947$export$5cb848ba4d1f099)(this, "fn_cleanup");
        (0, $15589ce76e06e947$export$5cb848ba4d1f099)(this, "cleanup", ()=>{
            this.cancel();
        });
    }
    static create() {
        return new _AnimationFrame();
    }
    request(fn) {
        this.cancel();
        this.id = globalThis.requestAnimationFrame(()=>{
            this.id = null;
            this.fn_cleanup = fn?.();
        });
    }
    cancel() {
        if (this.id !== null) {
            globalThis.cancelAnimationFrame(this.id);
            this.id = null;
        }
        this.fn_cleanup?.();
        this.fn_cleanup = void 0;
    }
    isActive() {
        return this.id !== null;
    }
};
function $7eacfb22d5a39e52$export$27f233d61a9e2fa4(fn) {
    const frame = $7eacfb22d5a39e52$export$1f3d5b43727c648a.create();
    frame.request(fn);
    return frame.cleanup;
}
function $7eacfb22d5a39e52$export$bdd553fddd433dcb(fn) {
    const set = /* @__PURE__ */ new Set();
    function raf2(fn2) {
        const id = globalThis.requestAnimationFrame(fn2);
        set.add(()=>globalThis.cancelAnimationFrame(id));
    }
    raf2(()=>raf2(fn));
    return function cleanup() {
        set.forEach((fn2)=>fn2());
    };
}
function $7eacfb22d5a39e52$export$77d693d38001d697(el, type, cb) {
    const cancelTimer = $7eacfb22d5a39e52$export$27f233d61a9e2fa4(()=>{
        el.removeEventListener(type, exec, true);
        cb();
    });
    const exec = ()=>{
        cancelTimer();
        cb();
    };
    el.addEventListener(type, exec, {
        once: true,
        capture: true
    });
    return cancelTimer;
}


function $40156009e740736b$var$observeAttributesImpl(node, options) {
    if (!node) return;
    const { attributes: attributes, callback: fn } = options;
    const win = node.ownerDocument.defaultView || window;
    const obs = new win.MutationObserver((changes)=>{
        for (const change of changes)if (change.type === "attributes" && change.attributeName && attributes.includes(change.attributeName)) fn(change);
    });
    obs.observe(node, {
        attributes: true,
        attributeFilter: attributes
    });
    return ()=>obs.disconnect();
}
function $40156009e740736b$export$343af0d656c88488(nodeOrFn, options) {
    const { defer: defer } = options;
    const func = defer ? (0, $7eacfb22d5a39e52$export$27f233d61a9e2fa4) : (v)=>v();
    const cleanups = [];
    cleanups.push(func(()=>{
        const node = typeof nodeOrFn === "function" ? nodeOrFn() : nodeOrFn;
        cleanups.push($40156009e740736b$var$observeAttributesImpl(node, options));
    }));
    return ()=>{
        cleanups.forEach((fn)=>fn?.());
    };
}
function $40156009e740736b$var$observeChildrenImpl(node, options) {
    const { callback: fn } = options;
    if (!node) return;
    const win = node.ownerDocument.defaultView || window;
    const obs = new win.MutationObserver(fn);
    obs.observe(node, {
        childList: true,
        subtree: true
    });
    return ()=>obs.disconnect();
}
function $40156009e740736b$export$c7ed990b38b19ee7(nodeOrFn, options) {
    const { defer: defer } = options;
    const func = defer ? (0, $7eacfb22d5a39e52$export$27f233d61a9e2fa4) : (v)=>v();
    const cleanups = [];
    cleanups.push(func(()=>{
        const node = typeof nodeOrFn === "function" ? nodeOrFn() : nodeOrFn;
        cleanups.push($40156009e740736b$var$observeChildrenImpl(node, options));
    }));
    return ()=>{
        cleanups.forEach((fn)=>fn?.());
    };
}


// src/create-machine.ts
// src/state.ts

// src/warning.ts
function $db2b97a8c70ba27b$export$c106dd0671a0fc2d(...a) {
    const m = a.length === 1 ? a[0] : a[1];
    const c = a.length === 2 ? a[0] : true;
}
function $db2b97a8c70ba27b$export$f5708dca728d7177(...a) {
    const m = a.length === 1 ? a[0] : a[1];
    const c = a.length === 2 ? a[0] : true;
}
function $db2b97a8c70ba27b$export$c291509e8e0abb43(c, m) {
    if (c == null) throw new Error(m());
}
function $db2b97a8c70ba27b$export$c96bf300e5609ed5(props, keys, scope) {
    let missingKeys = [];
    for (const key of keys)if (props[key] == null) missingKeys.push(key);
    if (missingKeys.length > 0) throw new Error(`[zag-js${scope ? ` > ${scope}` : ""}] missing required props: ${missingKeys.join(", ")}`);
}


var $b3416b19f62aaa20$var$STATE_DELIMITER = ".";
var $b3416b19f62aaa20$var$ABSOLUTE_PREFIX = "#";
var $b3416b19f62aaa20$var$stateIndexCache = /* @__PURE__ */ new WeakMap();
var $b3416b19f62aaa20$var$stateIdIndexCache = /* @__PURE__ */ new WeakMap();
function $b3416b19f62aaa20$var$joinStatePath(parts) {
    return parts.join($b3416b19f62aaa20$var$STATE_DELIMITER);
}
function $b3416b19f62aaa20$var$isAbsoluteStatePath(value) {
    return value.includes($b3416b19f62aaa20$var$STATE_DELIMITER);
}
function $b3416b19f62aaa20$var$isExplicitAbsoluteStatePath(value) {
    return value.startsWith($b3416b19f62aaa20$var$ABSOLUTE_PREFIX);
}
function $b3416b19f62aaa20$var$isChildTarget(value) {
    return value.startsWith($b3416b19f62aaa20$var$STATE_DELIMITER);
}
function $b3416b19f62aaa20$var$stripAbsolutePrefix(value) {
    return $b3416b19f62aaa20$var$isExplicitAbsoluteStatePath(value) ? value.slice($b3416b19f62aaa20$var$ABSOLUTE_PREFIX.length) : value;
}
function $b3416b19f62aaa20$var$appendStatePath(base, segment) {
    return base ? `${base}${$b3416b19f62aaa20$var$STATE_DELIMITER}${segment}` : segment;
}
function $b3416b19f62aaa20$var$buildStateIndex(machine) {
    const index = /* @__PURE__ */ new Map();
    const idIndex = /* @__PURE__ */ new Map();
    const visit = (basePath, state)=>{
        index.set(basePath, state);
        const stateId = state.id;
        if (stateId) {
            if (idIndex.has(stateId)) (0, $db2b97a8c70ba27b$export$f5708dca728d7177)(`[zag-js] Duplicate state id: "${stateId}"`);
            idIndex.set(stateId, basePath);
        }
        const childStates = state.states;
        if (!childStates) return;
        (0, $db2b97a8c70ba27b$export$c291509e8e0abb43)(state.initial, ()=>`[zag-js] Compound state "${basePath}" has child states but no "initial" property`);
        if (!(state.initial in childStates)) (0, $db2b97a8c70ba27b$export$f5708dca728d7177)(`[zag-js] Compound state "${basePath}" has initial "${String(state.initial)}" which is not a child state`);
        for (const [childKey, childState] of Object.entries(childStates)){
            if (!childState) continue;
            const childPath = $b3416b19f62aaa20$var$appendStatePath(basePath, childKey);
            visit(childPath, childState);
        }
    };
    for (const [topKey, topState] of Object.entries(machine.states)){
        if (!topState) continue;
        visit(topKey, topState);
    }
    return {
        index: index,
        idIndex: idIndex
    };
}
function $b3416b19f62aaa20$export$654ce1074944c610(machine) {
    const cached = $b3416b19f62aaa20$var$stateIndexCache.get(machine);
    if (cached) return cached;
    const { index: index, idIndex: idIndex } = $b3416b19f62aaa20$var$buildStateIndex(machine);
    $b3416b19f62aaa20$var$stateIndexCache.set(machine, index);
    $b3416b19f62aaa20$var$stateIdIndexCache.set(machine, idIndex);
    return index;
}
function $b3416b19f62aaa20$var$getStatePathById(machine, stateId) {
    $b3416b19f62aaa20$export$654ce1074944c610(machine);
    return $b3416b19f62aaa20$var$stateIdIndexCache.get(machine)?.get(stateId);
}
function $b3416b19f62aaa20$var$toSegments(value) {
    if (!value) return [];
    return String(value).split($b3416b19f62aaa20$var$STATE_DELIMITER).filter(Boolean);
}
function $b3416b19f62aaa20$export$b585357d473cfd9b(machine, state) {
    if (!state) return [];
    const stateIndex = $b3416b19f62aaa20$export$654ce1074944c610(machine);
    const segments = $b3416b19f62aaa20$var$toSegments(state);
    const chain = [];
    const statePath = [];
    for (const segment of segments){
        statePath.push(segment);
        const path = $b3416b19f62aaa20$var$joinStatePath(statePath);
        const current = stateIndex.get(path);
        if (!current) break;
        chain.push({
            path: path,
            state: current
        });
    }
    return chain;
}
function $b3416b19f62aaa20$var$resolveAbsoluteStateValue(machine, value) {
    const stateIndex = $b3416b19f62aaa20$export$654ce1074944c610(machine);
    const segments = $b3416b19f62aaa20$var$toSegments(value);
    if (!segments.length) return value;
    const resolved = [];
    for (const segment of segments){
        resolved.push(segment);
        const path = $b3416b19f62aaa20$var$joinStatePath(resolved);
        if (!stateIndex.has(path)) return value;
    }
    let resolvedPath = $b3416b19f62aaa20$var$joinStatePath(resolved);
    let current = stateIndex.get(resolvedPath);
    while(current?.initial){
        const nextPath = `${resolvedPath}${$b3416b19f62aaa20$var$STATE_DELIMITER}${current.initial}`;
        const nextState = stateIndex.get(nextPath);
        if (!nextState) break;
        resolvedPath = nextPath;
        current = nextState;
    }
    return resolvedPath;
}
function $b3416b19f62aaa20$var$hasStatePath(machine, value) {
    const stateIndex = $b3416b19f62aaa20$export$654ce1074944c610(machine);
    return stateIndex.has(value);
}
function $b3416b19f62aaa20$export$18ea49be145b0a40(machine, value, source) {
    const stateValue = String(value);
    if ($b3416b19f62aaa20$var$isExplicitAbsoluteStatePath(stateValue)) {
        const stateId = $b3416b19f62aaa20$var$stripAbsolutePrefix(stateValue);
        const statePath = $b3416b19f62aaa20$var$getStatePathById(machine, stateId);
        (0, $db2b97a8c70ba27b$export$c291509e8e0abb43)(statePath, ()=>`[zag-js] Unknown state id: "${stateId}"`);
        return $b3416b19f62aaa20$var$resolveAbsoluteStateValue(machine, statePath);
    }
    if ($b3416b19f62aaa20$var$isChildTarget(stateValue) && source) {
        const childPath = $b3416b19f62aaa20$var$appendStatePath(source, stateValue.slice(1));
        return $b3416b19f62aaa20$var$resolveAbsoluteStateValue(machine, childPath);
    }
    if (!$b3416b19f62aaa20$var$isAbsoluteStatePath(stateValue) && source) {
        const sourceSegments = $b3416b19f62aaa20$var$toSegments(source);
        for(let index = sourceSegments.length - 1; index >= 1; index--){
            const base = sourceSegments.slice(0, index).join($b3416b19f62aaa20$var$STATE_DELIMITER);
            const candidate = $b3416b19f62aaa20$var$appendStatePath(base, stateValue);
            if ($b3416b19f62aaa20$var$hasStatePath(machine, candidate)) return $b3416b19f62aaa20$var$resolveAbsoluteStateValue(machine, candidate);
        }
        if ($b3416b19f62aaa20$var$hasStatePath(machine, stateValue)) return $b3416b19f62aaa20$var$resolveAbsoluteStateValue(machine, stateValue);
    }
    return $b3416b19f62aaa20$var$resolveAbsoluteStateValue(machine, stateValue);
}
function $b3416b19f62aaa20$export$9b67d48a119139e4(machine, state) {
    const chain = $b3416b19f62aaa20$export$b585357d473cfd9b(machine, state);
    return chain[chain.length - 1]?.state;
}
function $b3416b19f62aaa20$export$626c044c30210039(machine, state, eventType) {
    const chain = $b3416b19f62aaa20$export$b585357d473cfd9b(machine, state);
    for(let index = chain.length - 1; index >= 0; index--){
        const transitionMap = chain[index]?.state.on;
        const transition = transitionMap?.[eventType];
        if (transition) return {
            transitions: transition,
            source: chain[index]?.path
        };
    }
    const rootTransitionMap = machine.on;
    return {
        transitions: rootTransitionMap?.[eventType],
        source: void 0
    };
}
function $b3416b19f62aaa20$export$4ae96ac553b79c5d(machine, prevState, nextState, reenter) {
    const prevChain = prevState ? $b3416b19f62aaa20$export$b585357d473cfd9b(machine, prevState) : [];
    const nextChain = $b3416b19f62aaa20$export$b585357d473cfd9b(machine, nextState);
    let commonIndex = 0;
    while(commonIndex < prevChain.length && commonIndex < nextChain.length && prevChain[commonIndex]?.path === nextChain[commonIndex]?.path)commonIndex += 1;
    let exiting = prevChain.slice(commonIndex).reverse();
    let entering = nextChain.slice(commonIndex);
    const sameLeaf = prevChain.at(-1)?.path === nextChain.at(-1)?.path;
    if (reenter && sameLeaf) {
        exiting = prevChain.slice().reverse();
        entering = nextChain;
    }
    return {
        exiting: exiting,
        entering: entering
    };
}
function $b3416b19f62aaa20$export$2870710bf0eac88e(current, value) {
    if (!current) return false;
    return current === value || current.startsWith(`${value}${$b3416b19f62aaa20$var$STATE_DELIMITER}`);
}
function $b3416b19f62aaa20$export$655b6c0cde448269(machine, state, tag) {
    return $b3416b19f62aaa20$export$b585357d473cfd9b(machine, state).some((item)=>item.state.tags?.includes(tag));
}


function $9aa7f39f9520657f$export$285462e61607a24f() {
    return {
        and: (...guards)=>{
            return function andGuard(params) {
                return guards.every((str)=>params.guard(str));
            };
        },
        or: (...guards)=>{
            return function orGuard(params) {
                return guards.some((str)=>params.guard(str));
            };
        },
        not: (guard)=>{
            return function notGuard(params) {
                return !params.guard(guard);
            };
        }
    };
}
function $9aa7f39f9520657f$export$aaa7fa18f8e9b2e8(config) {
    (0, $b3416b19f62aaa20$export$654ce1074944c610)(config);
    return config;
}
function $9aa7f39f9520657f$export$de27182ff8187d6c() {
    return {
        guards: $9aa7f39f9520657f$export$285462e61607a24f(),
        createMachine: (config)=>{
            return $9aa7f39f9520657f$export$aaa7fa18f8e9b2e8(config);
        },
        choose: (transitions)=>{
            return function chooseFn({ choose: choose }) {
                return choose(transitions)?.actions;
            };
        }
    };
}



var $b47e3a786f9fa53e$export$ea56d40cd27c3480 = (0, $9aa7f39f9520657f$export$aaa7fa18f8e9b2e8)({
    initialState () {
        return "loading";
    },
    effects: [
        "trackImageRemoval",
        "trackSrcChange"
    ],
    on: {
        "src.change": {
            target: "loading"
        },
        "img.unmount": {
            target: "error"
        }
    },
    states: {
        loading: {
            entry: [
                "checkImageStatus"
            ],
            on: {
                "img.loaded": {
                    target: "loaded",
                    actions: [
                        "invokeOnLoad"
                    ]
                },
                "img.error": {
                    target: "error",
                    actions: [
                        "invokeOnError"
                    ]
                }
            }
        },
        error: {
            on: {
                "img.loaded": {
                    target: "loaded",
                    actions: [
                        "invokeOnLoad"
                    ]
                }
            }
        },
        loaded: {
            on: {
                "img.error": {
                    target: "error",
                    actions: [
                        "invokeOnError"
                    ]
                }
            }
        }
    },
    implementations: {
        actions: {
            invokeOnLoad ({ prop: prop }) {
                prop("onStatusChange")?.({
                    status: "loaded"
                });
            },
            invokeOnError ({ prop: prop }) {
                prop("onStatusChange")?.({
                    status: "error"
                });
            },
            checkImageStatus ({ send: send, scope: scope }) {
                const imageEl = $b8942f9d243ff422$export$a31b96d9dc141173(scope);
                if (!imageEl?.complete) return;
                const type = $b47e3a786f9fa53e$var$hasLoaded(imageEl) ? "img.loaded" : "img.error";
                send({
                    type: type,
                    src: "ssr"
                });
            }
        },
        effects: {
            trackImageRemoval ({ send: send, scope: scope }) {
                const rootEl = $b8942f9d243ff422$export$5688053fba312fa5(scope);
                return (0, $40156009e740736b$export$c7ed990b38b19ee7)(rootEl, {
                    callback (records) {
                        const removedNodes = Array.from(records[0].removedNodes);
                        const removed = removedNodes.find((node)=>node.nodeType === Node.ELEMENT_NODE && node.matches("[data-scope=avatar][data-part=image]"));
                        if (removed) send({
                            type: "img.unmount"
                        });
                    }
                });
            },
            trackSrcChange ({ send: send, scope: scope }) {
                const imageEl = $b8942f9d243ff422$export$a31b96d9dc141173(scope);
                return (0, $40156009e740736b$export$343af0d656c88488)(imageEl, {
                    attributes: [
                        "src",
                        "srcset"
                    ],
                    callback () {
                        send({
                            type: "src.change"
                        });
                    }
                });
            }
        }
    }
});
function $b47e3a786f9fa53e$var$hasLoaded(image) {
    return image.complete && image.naturalWidth !== 0 && image.naturalHeight !== 0;
}



var $8v0nu = parcelRequire("8v0nu");
// src/normalize-props.ts
// src/prop-types.ts
function $7bc88a44f810481c$export$adbadfb4429588ef(fn) {
    return new Proxy({}, {
        get (_target, key) {
            if (key === "style") return (props)=>{
                return fn({
                    style: props
                }).style;
            };
            return fn;
        }
    });
}


var $06b0a2ce147a2fe4$export$601abcd8103db5e4 = (0, $7bc88a44f810481c$export$adbadfb4429588ef)((v)=>v);

// src/scope.ts


// src/shared.ts
var $dbd9babc41e226bd$export$7d15b64cf5a3a4c4 = (value)=>Math.max(0, Math.min(1, value));
var $dbd9babc41e226bd$export$4997ffc0176396a6 = (v, idx)=>{
    return v.map((_, index)=>v[(Math.max(idx, 0) + index) % v.length]);
};
var $dbd9babc41e226bd$export$a4627e546088548d = (...fns)=>(arg)=>fns.reduce((acc, fn)=>fn(acc), arg);
var $dbd9babc41e226bd$export$8793edee2d425525 = ()=>void 0;
var $dbd9babc41e226bd$export$a6cdc56e425d0d0a = (v)=>typeof v === "object" && v !== null;
var $dbd9babc41e226bd$export$e2f9a725ee199e81 = 2147483647;
var $dbd9babc41e226bd$export$5cc3b7b83e34ade7 = (guard)=>guard ? "" : void 0;
var $dbd9babc41e226bd$export$91a6105db3d4be7b = (guard)=>guard ? "true" : void 0;
var $dbd9babc41e226bd$export$83d2e9e3e4ee39ed = (str)=>str.split("").map((char)=>{
        const code = char.charCodeAt(0);
        if (code > 0 && code < 128) return char;
        if (code >= 128 && code <= 255) return `/x${code.toString(16)}`.replace("/", "\\");
        return "";
    }).join("").trim();


var $2020ec4601cca401$var$ELEMENT_NODE = 1;
var $2020ec4601cca401$var$DOCUMENT_NODE = 9;
var $2020ec4601cca401$var$DOCUMENT_FRAGMENT_NODE = 11;
var $2020ec4601cca401$export$1b3bfaa9684536aa = (el)=>(0, $dbd9babc41e226bd$export$a6cdc56e425d0d0a)(el) && el.nodeType === $2020ec4601cca401$var$ELEMENT_NODE && typeof el.nodeName === "string";
var $2020ec4601cca401$export$62858bae88b53fd0 = (el)=>(0, $dbd9babc41e226bd$export$a6cdc56e425d0d0a)(el) && el.nodeType === $2020ec4601cca401$var$DOCUMENT_NODE;
var $2020ec4601cca401$export$5a096129d439f843 = (el)=>(0, $dbd9babc41e226bd$export$a6cdc56e425d0d0a)(el) && el === el.window;
var $2020ec4601cca401$export$d4522fa375bab361 = (el)=>(0, $dbd9babc41e226bd$export$a6cdc56e425d0d0a)(el) && el.constructor.name === "VisualViewport";
var $2020ec4601cca401$export$651544f548703224 = (node)=>{
    if ($2020ec4601cca401$export$1b3bfaa9684536aa(node)) return node.localName || "";
    return "#document";
};
function $2020ec4601cca401$export$7b296c28e0fa3aed(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes($2020ec4601cca401$export$651544f548703224(node));
}
var $2020ec4601cca401$export$8ee0fc9ee280b4ee = (el)=>(0, $dbd9babc41e226bd$export$a6cdc56e425d0d0a)(el) && el.nodeType !== void 0;
var $2020ec4601cca401$export$af51f0f06c0f328a = (el)=>$2020ec4601cca401$export$8ee0fc9ee280b4ee(el) && el.nodeType === $2020ec4601cca401$var$DOCUMENT_FRAGMENT_NODE && "host" in el;
var $2020ec4601cca401$export$63ed1d20cf8213cf = (el)=>$2020ec4601cca401$export$1b3bfaa9684536aa(el) && el.localName === "input";
var $2020ec4601cca401$export$1800cc20d529d764 = (el)=>!!el?.matches("a[href]");
var $2020ec4601cca401$export$e989c0fffaa6b27a = (el)=>{
    if (!$2020ec4601cca401$export$1b3bfaa9684536aa(el)) return false;
    return el.offsetWidth > 0 || el.offsetHeight > 0 || el.getClientRects().length > 0;
};
function $2020ec4601cca401$export$8a2eb51c14bb8899(element) {
    if (!element) return false;
    const rootNode = element.getRootNode();
    return $2020ec4601cca401$export$cd4e5573fbe2b576(rootNode) === element;
}
var $2020ec4601cca401$var$TEXTAREA_SELECT_REGEX = /(textarea|select)/;
function $2020ec4601cca401$export$2780cb57de98fa3a(el) {
    if (el == null || !$2020ec4601cca401$export$1b3bfaa9684536aa(el)) return false;
    try {
        return $2020ec4601cca401$export$63ed1d20cf8213cf(el) && el.selectionStart != null || $2020ec4601cca401$var$TEXTAREA_SELECT_REGEX.test(el.localName) || el.isContentEditable || el.getAttribute("contenteditable") === "true" || el.getAttribute("contenteditable") === "";
    } catch  {
        return false;
    }
}
function $2020ec4601cca401$export$169e5491001d3ed6(node) {
    const parentNode = node.parentNode;
    if ($2020ec4601cca401$export$af51f0f06c0f328a(parentNode)) return parentNode.host;
    return parentNode;
}
function $2020ec4601cca401$export$7bed2c54bae5460c(node) {
    const ancestors = [];
    while(node){
        ancestors.push(node);
        node = $2020ec4601cca401$export$169e5491001d3ed6(node);
    }
    return ancestors;
}
function $2020ec4601cca401$export$2344b14b097df817(parent, child) {
    if (!parent || !child) return false;
    if (!$2020ec4601cca401$export$1b3bfaa9684536aa(parent) || !$2020ec4601cca401$export$8ee0fc9ee280b4ee(child)) return false;
    if ($2020ec4601cca401$export$1b3bfaa9684536aa(child) && parent === child) return true;
    if (parent.contains(child)) return true;
    const rootNode = child.getRootNode?.();
    if (rootNode && $2020ec4601cca401$export$af51f0f06c0f328a(rootNode)) {
        let next = child;
        while(next){
            if (parent === next) return true;
            next = next.parentNode || next.host;
        }
    }
    return false;
}
function $2020ec4601cca401$export$f65ca476c09acec0(el) {
    if ($2020ec4601cca401$export$62858bae88b53fd0(el)) return el;
    if ($2020ec4601cca401$export$5a096129d439f843(el)) return el.document;
    return el?.ownerDocument ?? document;
}
function $2020ec4601cca401$export$e495491855dc5418(el) {
    return $2020ec4601cca401$export$f65ca476c09acec0(el).documentElement;
}
function $2020ec4601cca401$export$38b2d434cce3ea22(el) {
    if ($2020ec4601cca401$export$af51f0f06c0f328a(el)) return $2020ec4601cca401$export$38b2d434cce3ea22(el.host);
    if ($2020ec4601cca401$export$62858bae88b53fd0(el)) return el.defaultView ?? window;
    if ($2020ec4601cca401$export$1b3bfaa9684536aa(el)) return el.ownerDocument?.defaultView ?? window;
    return window;
}
function $2020ec4601cca401$export$cd4e5573fbe2b576(rootNode) {
    let activeElement = rootNode.activeElement;
    while(activeElement?.shadowRoot){
        const el = activeElement.shadowRoot.activeElement;
        if (!el || el === activeElement) break;
        else activeElement = el;
    }
    return activeElement;
}
function $2020ec4601cca401$export$4e12058fc4d51d56(node) {
    if ($2020ec4601cca401$export$651544f548703224(node) === "html") return node;
    const result = node.assignedSlot || node.parentNode || $2020ec4601cca401$export$af51f0f06c0f328a(node) && node.host || $2020ec4601cca401$export$e495491855dc5418(node);
    return $2020ec4601cca401$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $2020ec4601cca401$export$9bfe85d84666e58(node) {
    let result;
    try {
        result = node.getRootNode({
            composed: true
        });
        if ($2020ec4601cca401$export$62858bae88b53fd0(result) || $2020ec4601cca401$export$af51f0f06c0f328a(result)) return result;
    } catch  {}
    return node.ownerDocument ?? document;
}


function $9570b0327825431c$export$41a9651decfe2bde(props) {
    const getRootNode = ()=>props.getRootNode?.() ?? document;
    const getDoc = ()=>(0, $2020ec4601cca401$export$f65ca476c09acec0)(getRootNode());
    const getWin = ()=>getDoc().defaultView ?? window;
    const getActiveElementFn = ()=>(0, $2020ec4601cca401$export$cd4e5573fbe2b576)(getRootNode());
    const getById = (id)=>getRootNode().getElementById(id);
    return {
        ...props,
        getRootNode: getRootNode,
        getDoc: getDoc,
        getWin: getWin,
        getActiveElement: getActiveElementFn,
        isActiveElement: $2020ec4601cca401$export$8a2eb51c14bb8899,
        getById: getById
    };
}

// src/types.ts
var $31c1f0c464a79008$export$ba278f1145e3432e = /* @__PURE__ */ ((MachineStatus2)=>{
    MachineStatus2["NotStarted"] = "Not Started";
    MachineStatus2["Started"] = "Started";
    MachineStatus2["Stopped"] = "Stopped";
    return MachineStatus2;
})($31c1f0c464a79008$export$ba278f1145e3432e || {});
var $31c1f0c464a79008$export$9fb9c1637a49011a = "__init__";




function $6f7aa98cfa48efba$export$8e16b83750b44988(obj) {
    if (!(0, $9a966d729185a601$export$53b83ca8eaab0383)(obj) || obj === void 0) return obj;
    const keys = Reflect.ownKeys(obj).filter((key)=>typeof key === "string");
    const filtered = {};
    for (const key of keys){
        const value = obj[key];
        if (value !== void 0) filtered[key] = $6f7aa98cfa48efba$export$8e16b83750b44988(value);
    }
    return filtered;
}
var $6f7aa98cfa48efba$export$7b419323e6ed4f31 = (v)=>JSON.parse(JSON.stringify(v));
function $6f7aa98cfa48efba$export$357523c63a2253b9(obj, keys) {
    const filtered = {};
    for (const key of keys){
        const value = obj[key];
        if (value !== void 0) filtered[key] = value;
    }
    return filtered;
}
function $6f7aa98cfa48efba$export$45029c61b0073d87(props, keys) {
    const rest = {};
    const result = {};
    const keySet = new Set(keys);
    const ownKeys = Reflect.ownKeys(props);
    for (const key of ownKeys)if (keySet.has(key)) result[key] = props[key];
    else rest[key] = props[key];
    return [
        result,
        rest
    ];
}
var $6f7aa98cfa48efba$export$3ea53b214fbc1986 = (keys)=>{
    return function split(props) {
        return $6f7aa98cfa48efba$export$45029c61b0073d87(props, keys);
    };
};
function $6f7aa98cfa48efba$export$30a06c8d3562193f(obj, keys) {
    return $6f7aa98cfa48efba$export$3ea53b214fbc1986(keys)(obj)[1];
}


// src/array.ts
function $94dddd4ee90a9c15$export$45b10814cc054894(v) {
    if (v == null) return [];
    return Array.isArray(v) ? v : [
        v
    ];
}
var $94dddd4ee90a9c15$export$126fef020408babd = (length)=>Array.from(Array(length).keys());
var $94dddd4ee90a9c15$export$43128fadae87b74a = (v)=>v[0];
var $94dddd4ee90a9c15$export$4c7897fafd92b108 = (v)=>v[v.length - 1];
var $94dddd4ee90a9c15$export$dd1bc94b04021eeb = (v)=>v.length === 0;
var $94dddd4ee90a9c15$export$a4f4bb6b1453fff5 = (v, t)=>v.indexOf(t) !== -1;
var $94dddd4ee90a9c15$export$e16d8520af44a096 = (v, ...items)=>v.concat(items);
var $94dddd4ee90a9c15$export$cd7f480d6b8286c3 = (v, ...items)=>v.filter((t)=>!items.includes(t));
var $94dddd4ee90a9c15$export$aa72b1a59562dee2 = (v, i)=>v.filter((_, idx)=>idx !== i);
var $94dddd4ee90a9c15$export$9f200c4466975173 = (v, i, ...items)=>[
        ...v.slice(0, i),
        ...items,
        ...v.slice(i)
    ];
var $94dddd4ee90a9c15$export$f70730c3d1fc524e = (v)=>Array.from(new Set(v));
var $94dddd4ee90a9c15$export$a37e3c603d7117e5 = (a, b)=>{
    const set = new Set(b);
    return a.filter((t)=>!set.has(t));
};
var $94dddd4ee90a9c15$export$daf1e94085156e29 = (v, item)=>$94dddd4ee90a9c15$export$a4f4bb6b1453fff5(v, item) ? $94dddd4ee90a9c15$export$cd7f480d6b8286c3(v, item) : $94dddd4ee90a9c15$export$e16d8520af44a096(v, item);
function $94dddd4ee90a9c15$export$42ffd38884aecdac(v) {
    while(v.length > 0)v.pop();
    return v;
}
function $94dddd4ee90a9c15$export$7db462fe6be63e0(v, idx, opts = {}) {
    const { step: step = 1, loop: loop = true } = opts;
    const next2 = idx + step;
    const len = v.length;
    const last2 = len - 1;
    if (idx === -1) return step > 0 ? 0 : last2;
    if (next2 < 0) return loop ? last2 : 0;
    if (next2 >= len) return loop ? 0 : idx > len ? len : idx;
    return next2;
}
function $94dddd4ee90a9c15$export$48cfd1e771a65c4f(v, idx, opts = {}) {
    return v[$94dddd4ee90a9c15$export$7db462fe6be63e0(v, idx, opts)];
}
function $94dddd4ee90a9c15$export$9041fedbf960fcef(v, idx, opts = {}) {
    const { step: step = 1, loop: loop = true } = opts;
    return $94dddd4ee90a9c15$export$7db462fe6be63e0(v, idx, {
        step: -step,
        loop: loop
    });
}
function $94dddd4ee90a9c15$export$232faf9add678146(v, index, opts = {}) {
    return v[$94dddd4ee90a9c15$export$9041fedbf960fcef(v, index, opts)];
}
function $94dddd4ee90a9c15$export$5f7ec48d69707ddd(v, size) {
    return v.reduce((rows, value, index)=>{
        if (index % size === 0) rows.push([
            value
        ]);
        else $94dddd4ee90a9c15$export$4c7897fafd92b108(rows)?.push(value);
        return rows;
    }, []);
}
function $94dddd4ee90a9c15$export$82741f9ea1bad77f(arr) {
    return arr.reduce((flat, item)=>{
        if (Array.isArray(item)) return flat.concat($94dddd4ee90a9c15$export$82741f9ea1bad77f(item));
        return flat.concat(item);
    }, []);
}
function $94dddd4ee90a9c15$export$b29f828819edca8d(arr, fn) {
    return arr.reduce(([pass, fail], value)=>{
        if (fn(value)) pass.push(value);
        else fail.push(value);
        return [
            pass,
            fail
        ];
    }, [
        [],
        []
    ]);
}



var $8v0nu = parcelRequire("8v0nu");

var $k2dbP = parcelRequire("k2dbP");


var $8v0nu = parcelRequire("8v0nu");

var $k2dbP = parcelRequire("k2dbP");

var $8v0nu = parcelRequire("8v0nu");
"use client";
var $644e772973e10cd8$export$deebe11a338de063 = typeof globalThis.document !== "undefined" ? (0, $8v0nu.useLayoutEffect) : (0, $8v0nu.useEffect);


"use client";
function $b8e8a86ce6978f10$export$a04b7d240c2bc4e9(props) {
    const initial = props().value ?? props().defaultValue;
    const eq = props().isEqual ?? Object.is;
    const [initialValue] = (0, $8v0nu.useState)(initial);
    const [value, setValue] = (0, $8v0nu.useState)(initialValue);
    const controlled = props().value !== void 0;
    const valueRef = (0, $8v0nu.useRef)(value);
    valueRef.current = controlled ? props().value : value;
    const prevValue = (0, $8v0nu.useRef)(valueRef.current);
    (0, $644e772973e10cd8$export$deebe11a338de063)(()=>{
        prevValue.current = valueRef.current;
    }, [
        value,
        props().value
    ]);
    const setFn = (value2)=>{
        const prev = prevValue.current;
        const next = (0, $9a966d729185a601$export$f6e2535fb5126e54)(value2) ? value2(prev) : value2;
        if (props().debug) console.log(`[bindable > ${props().debug}] setValue`, {
            next: next,
            prev: prev
        });
        if (!controlled) setValue(next);
        if (!eq(next, prev)) props().onChange?.(next, prev);
    };
    function get() {
        return controlled ? props().value : value;
    }
    return {
        initial: initialValue,
        ref: valueRef,
        get: get,
        set (value2) {
            const exec = props().sync ? (0, $k2dbP.flushSync) : (0, $5246d161dcdee685$export$f0954fd7d5368655);
            exec(()=>setFn(value2));
        },
        invoke (nextValue, prevValue2) {
            props().onChange?.(nextValue, prevValue2);
        },
        hash (value2) {
            return props().hash?.(value2) ?? String(value2);
        }
    };
}
$b8e8a86ce6978f10$export$a04b7d240c2bc4e9.cleanup = (fn)=>{
    (0, $8v0nu.useEffect)(()=>fn, []);
};
$b8e8a86ce6978f10$export$a04b7d240c2bc4e9.ref = (defaultValue)=>{
    const value = (0, $8v0nu.useRef)(defaultValue);
    return {
        get: ()=>value.current,
        set: (next)=>{
            value.current = next;
        }
    };
};



var $8v0nu = parcelRequire("8v0nu");
"use client";
function $d69e5a30615754bf$export$14a2d388602b1453(refs) {
    const ref = (0, $8v0nu.useRef)(refs);
    return {
        get (key) {
            return ref.current[key];
        },
        set (key, value) {
            ref.current[key] = value;
        }
    };
}



var $8v0nu = parcelRequire("8v0nu");
"use client";
var $34ab4fddfc6dabf6$export$60a459a981d7d2d9 = (deps, effect)=>{
    const render = (0, $8v0nu.useRef)(false);
    const called = (0, $8v0nu.useRef)(false);
    (0, $8v0nu.useEffect)(()=>{
        const mounted = render.current;
        const run = mounted && called.current;
        if (run) return effect();
        called.current = true;
    }, [
        ...(deps ?? []).map((d)=>typeof d === "function" ? d() : d)
    ]);
    (0, $8v0nu.useEffect)(()=>{
        render.current = true;
        return ()=>{
            render.current = false;
        };
    }, []);
};



"use client";
function $54265883fb157840$export$e0338c4153421160(machine, userProps = {}) {
    const scope = (0, $8v0nu.useMemo)(()=>{
        const { id: id, ids: ids, getRootNode: getRootNode } = userProps;
        return (0, $9570b0327825431c$export$41a9651decfe2bde)({
            id: id,
            ids: ids,
            getRootNode: getRootNode
        });
    }, [
        userProps
    ]);
    const debug = (...args)=>{
        if (machine.debug) console.log(...args);
    };
    const props = machine.props?.({
        props: (0, $6f7aa98cfa48efba$export$8e16b83750b44988)(userProps),
        scope: scope
    }) ?? userProps;
    const prop = $54265883fb157840$var$useProp(props);
    const context = machine.context?.({
        prop: prop,
        bindable: (0, $b8e8a86ce6978f10$export$a04b7d240c2bc4e9),
        scope: scope,
        flush: $54265883fb157840$var$flush,
        getContext () {
            return ctx;
        },
        getComputed () {
            return computed;
        },
        getRefs () {
            return refs;
        },
        getEvent () {
            return getEvent();
        }
    });
    const contextRef = $54265883fb157840$var$useLiveRef(context);
    const ctx = {
        get (key) {
            return contextRef.current?.[key].ref.current;
        },
        set (key, value) {
            contextRef.current?.[key].set(value);
        },
        initial (key) {
            return contextRef.current?.[key].initial;
        },
        hash (key) {
            const current = contextRef.current?.[key].get();
            return contextRef.current?.[key].hash(current);
        }
    };
    const effects = (0, $8v0nu.useRef)(/* @__PURE__ */ new Map());
    const transitionRef = (0, $8v0nu.useRef)(null);
    const previousEventRef = (0, $8v0nu.useRef)(null);
    const eventRef = (0, $8v0nu.useRef)({
        type: ""
    });
    const getEvent = ()=>({
            ...eventRef.current,
            current () {
                return eventRef.current;
            },
            previous () {
                return previousEventRef.current;
            }
        });
    const getState = ()=>({
            ...state,
            matches (...values) {
                return values.some((value)=>(0, $b3416b19f62aaa20$export$2870710bf0eac88e)(state.ref.current, value));
            },
            hasTag (tag) {
                return (0, $b3416b19f62aaa20$export$655b6c0cde448269)(machine, state.ref.current, tag);
            }
        });
    const refs = (0, $d69e5a30615754bf$export$14a2d388602b1453)(machine.refs?.({
        prop: prop,
        context: ctx
    }) ?? {});
    const getParams = ()=>({
            state: getState(),
            context: ctx,
            event: getEvent(),
            prop: prop,
            send: send,
            action: action,
            guard: guard,
            track: (0, $34ab4fddfc6dabf6$export$60a459a981d7d2d9),
            refs: refs,
            computed: computed,
            flush: $54265883fb157840$var$flush,
            scope: scope,
            choose: choose
        });
    const action = (keys)=>{
        const strs = (0, $9a966d729185a601$export$f6e2535fb5126e54)(keys) ? keys(getParams()) : keys;
        if (!strs) return;
        const fns = strs.map((s)=>{
            const fn = machine.implementations?.actions?.[s];
            if (!fn) (0, $db2b97a8c70ba27b$export$c106dd0671a0fc2d)(`[zag-js] No implementation found for action "${JSON.stringify(s)}"`);
            return fn;
        });
        for (const fn of fns)fn?.(getParams());
    };
    const guard = (str)=>{
        if ((0, $9a966d729185a601$export$f6e2535fb5126e54)(str)) return str(getParams());
        return machine.implementations?.guards?.[str](getParams());
    };
    const effect = (keys)=>{
        const strs = (0, $9a966d729185a601$export$f6e2535fb5126e54)(keys) ? keys(getParams()) : keys;
        if (!strs) return;
        const fns = strs.map((s)=>{
            const fn = machine.implementations?.effects?.[s];
            if (!fn) (0, $db2b97a8c70ba27b$export$c106dd0671a0fc2d)(`[zag-js] No implementation found for effect "${JSON.stringify(s)}"`);
            return fn;
        });
        const cleanups = [];
        for (const fn of fns){
            const cleanup = fn?.(getParams());
            if (cleanup) cleanups.push(cleanup);
        }
        return ()=>cleanups.forEach((fn)=>fn?.());
    };
    const choose = (transitions)=>{
        return (0, $94dddd4ee90a9c15$export$45b10814cc054894)(transitions).find((t)=>{
            let result = !t.guard;
            if ((0, $9a966d729185a601$export$844ec244b1367d54)(t.guard)) result = !!guard(t.guard);
            else if ((0, $9a966d729185a601$export$f6e2535fb5126e54)(t.guard)) result = t.guard(getParams());
            return result;
        });
    };
    const computed = (key)=>{
        (0, $db2b97a8c70ba27b$export$c291509e8e0abb43)(machine.computed, ()=>`[zag-js] No computed object found on machine`);
        const fn = machine.computed[key];
        return fn({
            context: ctx,
            event: getEvent(),
            prop: prop,
            refs: refs,
            scope: scope,
            computed: computed
        });
    };
    const state = (0, $b8e8a86ce6978f10$export$a04b7d240c2bc4e9)(()=>({
            defaultValue: (0, $b3416b19f62aaa20$export$18ea49be145b0a40)(machine, machine.initialState({
                prop: prop
            })),
            onChange (nextState, prevState) {
                const { exiting: exiting, entering: entering } = (0, $b3416b19f62aaa20$export$4ae96ac553b79c5d)(machine, prevState, nextState, transitionRef.current?.reenter);
                exiting.forEach((item)=>{
                    const exitEffects = effects.current.get(item.path);
                    exitEffects?.();
                    effects.current.delete(item.path);
                });
                exiting.forEach((item)=>{
                    action(item.state?.exit);
                });
                action(transitionRef.current?.actions);
                entering.forEach((item)=>{
                    const cleanup = effect(item.state?.effects);
                    if (cleanup) effects.current.set(item.path, cleanup);
                });
                if (prevState === (0, $31c1f0c464a79008$export$9fb9c1637a49011a)) {
                    action(machine.entry);
                    const cleanup = effect(machine.effects);
                    if (cleanup) effects.current.set((0, $31c1f0c464a79008$export$9fb9c1637a49011a), cleanup);
                }
                entering.forEach((item)=>{
                    action(item.state?.entry);
                });
            }
        }));
    const hydratedStateRef = (0, $8v0nu.useRef)(void 0);
    const statusRef = (0, $8v0nu.useRef)((0, $31c1f0c464a79008$export$ba278f1145e3432e).NotStarted);
    (0, $644e772973e10cd8$export$deebe11a338de063)(()=>{
        queueMicrotask(()=>{
            const started = statusRef.current === (0, $31c1f0c464a79008$export$ba278f1145e3432e).Started;
            statusRef.current = (0, $31c1f0c464a79008$export$ba278f1145e3432e).Started;
            debug(started ? "rehydrating..." : "initializing...");
            const initialState = hydratedStateRef.current ?? state.initial;
            state.invoke(initialState, started ? state.get() : (0, $31c1f0c464a79008$export$9fb9c1637a49011a));
        });
        const fns = effects.current;
        return ()=>{
            const currentState = getCurrentState();
            debug("unmounting...");
            hydratedStateRef.current = currentState;
            statusRef.current = (0, $31c1f0c464a79008$export$ba278f1145e3432e).Stopped;
            fns.forEach((fn)=>fn?.());
            effects.current = /* @__PURE__ */ new Map();
            transitionRef.current = null;
            queueMicrotask(()=>{
                action(machine.exit);
                statusRef.current = (0, $31c1f0c464a79008$export$ba278f1145e3432e).Stopped;
            });
        };
    }, []);
    const getCurrentState = ()=>{
        if ("ref" in state) return state.ref.current;
        return state.get();
    };
    const send = (event)=>{
        queueMicrotask(()=>{
            if (statusRef.current !== (0, $31c1f0c464a79008$export$ba278f1145e3432e).Started) return;
            previousEventRef.current = eventRef.current;
            eventRef.current = event;
            let currentState = getCurrentState();
            const { transitions: transitions, source: source } = (0, $b3416b19f62aaa20$export$626c044c30210039)(machine, currentState, event.type);
            const transition = choose(transitions);
            if (!transition) return;
            transitionRef.current = transition;
            const target = (0, $b3416b19f62aaa20$export$18ea49be145b0a40)(machine, transition.target ?? currentState, source);
            debug("transition", event.type, transition.target || currentState, `(${transition.actions})`);
            const changed = target !== currentState;
            if (changed) (0, $k2dbP.flushSync)(()=>state.set(target));
            else if (transition.reenter) state.invoke(currentState, currentState);
            else action(transition.actions ?? []);
        });
    };
    machine.watch?.(getParams());
    return {
        state: getState(),
        send: send,
        context: ctx,
        prop: prop,
        scope: scope,
        refs: refs,
        computed: computed,
        event: getEvent(),
        getStatus: ()=>statusRef.current
    };
}
function $54265883fb157840$var$useLiveRef(value) {
    const ref = (0, $8v0nu.useRef)(value);
    ref.current = value;
    return ref;
}
function $54265883fb157840$var$useProp(value) {
    const ref = $54265883fb157840$var$useLiveRef(value);
    return function get(key) {
        return ref.current[key];
    };
}
function $54265883fb157840$var$flush(fn) {
    queueMicrotask(()=>{
        (0, $k2dbP.flushSync)(()=>fn());
    });
}


"use client";
//#region src/components/avatar/use-avatar.ts
var $47cde8993f2e2482$export$e81fcf1d7807b0c = (props)=>{
    const id = (0, $8v0nu.useId)();
    const { getRootNode: getRootNode } = (0, $cfa7a900a06000ef$export$899b1e582a0b3c80)();
    const { dir: dir } = (0, $af19f2672b388a39$export$2a7b1d9f665d6730)();
    const context = {
        id: id,
        dir: dir,
        getRootNode: getRootNode,
        ...props
    };
    const service = (0, $54265883fb157840$export$e0338c4153421160)($b47e3a786f9fa53e$export$ea56d40cd27c3480, context);
    return $dfd3d9237dd60c00$export$64605811ab45167f(service, (0, $06b0a2ce147a2fe4$export$601abcd8103db5e4));
};



var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/avatar/avatar-root.tsx
var $e472a1cd70fa9814$var$splitRootProps = (0, $41bdb03050f91b76$export$3ea53b214fbc1986)();
var $e472a1cd70fa9814$export$c38023ffdf1cc3ea = (0, $8v0nu.forwardRef)((props, ref)=>{
    const [useAvatarProps, localProps] = $e472a1cd70fa9814$var$splitRootProps(props, [
        "id",
        "ids",
        "onStatusChange"
    ]);
    const avatar = (0, $47cde8993f2e2482$export$e81fcf1d7807b0c)(useAvatarProps);
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)(avatar.getRootProps(), localProps);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $8f4b94f67fb0f0b6$export$f0ddb3045e4d5906), {
        value: avatar,
        children: /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).div, {
            ...mergedProps,
            ref: ref
        })
    });
});
$e472a1cd70fa9814$export$c38023ffdf1cc3ea.displayName = "AvatarRoot";






var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/avatar/avatar-root-provider.tsx
var $a3f1cac9b662dff4$var$splitRootProviderProps = (0, $41bdb03050f91b76$export$3ea53b214fbc1986)();
var $a3f1cac9b662dff4$export$10d1cc2b80f71976 = (0, $8v0nu.forwardRef)((props, ref)=>{
    const [{ value: avatar }, localProps] = $a3f1cac9b662dff4$var$splitRootProviderProps(props, [
        "value"
    ]);
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)(avatar.getRootProps(), localProps);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $8f4b94f67fb0f0b6$export$f0ddb3045e4d5906), {
        value: avatar,
        children: /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).div, {
            ...mergedProps,
            ref: ref
        })
    });
});
$a3f1cac9b662dff4$export$10d1cc2b80f71976.displayName = "AvatarRootProvider";


//#region src/components/avatar/avatar.ts
var $2ee5824619699054$export$f5d9b2daa45aa107 = /* @__PURE__ */ (0, $57db88e2bf337fea$export$8126e515a7516e2)({
    Context: ()=>(0, $3371280203c0e151$export$a20dad690e1279e2),
    Fallback: ()=>(0, $5fd08ebf2958aff7$export$69fffb6a9571fbfe),
    Image: ()=>(0, $f8fa0aa353da7d39$export$2cd8ae1985206fe8),
    Root: ()=>(0, $e472a1cd70fa9814$export$c38023ffdf1cc3ea),
    RootProvider: ()=>(0, $a3f1cac9b662dff4$export$10d1cc2b80f71976)
});



var $8v0nu = parcelRequire("8v0nu");






var $8v0nu = parcelRequire("8v0nu");



"use strict";
"use client";
const $8ce9521b7a4b2ead$var$StyledGroup = (0, $4042601bfa1a9d25$export$7cd122d781af9fa4)("div", {
    base: {
        display: "inline-flex",
        gap: "var(--group-gap, 0.5rem)",
        isolation: "isolate",
        position: "relative",
        "& [data-group-item]": {
            _focusVisible: {
                zIndex: 1
            }
        }
    },
    variants: {
        orientation: {
            horizontal: {
                flexDirection: "row"
            },
            vertical: {
                flexDirection: "column"
            }
        },
        attached: {
            true: {
                gap: "0!"
            }
        },
        grow: {
            true: {
                display: "flex",
                "& > *": {
                    flex: 1
                }
            }
        },
        stacking: {
            "first-on-top": {
                "& > [data-group-item]": {
                    zIndex: "calc(var(--group-count) - var(--group-index))"
                }
            },
            "last-on-top": {
                "& > [data-group-item]": {
                    zIndex: "var(--group-index)"
                }
            }
        }
    },
    compoundVariants: [
        {
            orientation: "horizontal",
            attached: true,
            css: {
                "& > *[data-first]": {
                    borderEndRadius: "0!",
                    marginEnd: "-1px"
                },
                "& > *[data-between]": {
                    borderRadius: "0!",
                    marginEnd: "-1px"
                },
                "& > *[data-last]": {
                    borderStartRadius: "0!"
                }
            }
        },
        {
            orientation: "vertical",
            attached: true,
            css: {
                "& > *[data-first]": {
                    borderBottomRadius: "0!",
                    marginBottom: "-1px"
                },
                "& > *[data-between]": {
                    borderRadius: "0!",
                    marginBottom: "-1px"
                },
                "& > *[data-last]": {
                    borderTopRadius: "0!"
                }
            }
        }
    ],
    defaultVariants: {
        orientation: "horizontal"
    }
});
const $8ce9521b7a4b2ead$export$eb2fcfdbd7ba97d4 = (0, $8v0nu.memo)((0, $8v0nu.forwardRef)(function Group2(props, ref) {
    const { align: align = "center", justify: justify = "flex-start", children: children, wrap: wrap, skip: skip, ...rest } = props;
    const _children = (0, $8v0nu.useMemo)(()=>{
        let childArray = (0, $8v0nu.Children).toArray(children).filter((0, $8v0nu.isValidElement));
        if (childArray.length === 1) return childArray;
        const validChildArray = childArray.filter((child)=>!skip?.(child));
        const validChildCount = validChildArray.length;
        if (validChildArray.length === 1) return childArray;
        return childArray.map((child)=>{
            const childProps = child.props;
            if (skip?.(child)) return child;
            const index = validChildArray.indexOf(child);
            return (0, $8v0nu.cloneElement)(child, {
                ...childProps,
                "data-group-item": "",
                "data-first": (0, $f85b338274abd06b$export$5cc3b7b83e34ade7)(index === 0),
                "data-last": (0, $f85b338274abd06b$export$5cc3b7b83e34ade7)(index === validChildCount - 1),
                "data-between": (0, $f85b338274abd06b$export$5cc3b7b83e34ade7)(index > 0 && index < validChildCount - 1),
                style: {
                    "--group-count": validChildCount,
                    "--group-index": index,
                    ...childProps?.style ?? {}
                }
            });
        });
    }, [
        children,
        skip
    ]);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)($8ce9521b7a4b2ead$var$StyledGroup, {
        ref: ref,
        alignItems: align,
        justifyContent: justify,
        flexWrap: wrap,
        ...rest,
        className: (0, $99474b193e949655$export$a274e22fb40f762e)("chakra-group", props.className),
        children: _children
    });
}));
$8ce9521b7a4b2ead$export$eb2fcfdbd7ba97d4.displayName = "Group";


"use strict";
"use client";
const { withProvider: $c54e04054e4b82c0$var$withProvider, withContext: $c54e04054e4b82c0$var$withContext, useStyles: $c54e04054e4b82c0$export$766de4db34c66f23, useClassNames: $c54e04054e4b82c0$var$useClassNames, PropsProvider: $c54e04054e4b82c0$var$PropsProvider } = (0, $04636a451c2392c0$export$ac7f79c9443925b8)({
    key: "avatar"
});
const $c54e04054e4b82c0$export$10d1cc2b80f71976 = $c54e04054e4b82c0$var$withProvider((0, $2ee5824619699054$export$f5d9b2daa45aa107).RootProvider, "root", {
    forwardAsChild: true
});
const $c54e04054e4b82c0$export$c38023ffdf1cc3ea = $c54e04054e4b82c0$var$withProvider((0, $2ee5824619699054$export$f5d9b2daa45aa107).Root, "root", {
    forwardAsChild: true
});
const $c54e04054e4b82c0$export$c8ffe73a8586b78c = $c54e04054e4b82c0$var$PropsProvider;
const $c54e04054e4b82c0$var$StyledFallback = (0, $4042601bfa1a9d25$export$7cd122d781af9fa4)((0, $2ee5824619699054$export$f5d9b2daa45aa107).Fallback, {}, {
    forwardAsChild: true
});
function $c54e04054e4b82c0$var$getFallbackChildren(props) {
    if (props.children || props.asChild) return props.children;
    if (props.name) return $c54e04054e4b82c0$var$getInitials(props.name);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)($c54e04054e4b82c0$export$b1f22795a41806ac, {});
}
function $c54e04054e4b82c0$var$getInitials(name) {
    const names = name.trim().split(" ");
    const firstName = names[0] != null ? names[0] : "";
    const lastName = names.length > 1 ? names[names.length - 1] : "";
    return firstName && lastName ? `${firstName.charAt(0)}${lastName.charAt(0)}` : firstName.charAt(0);
}
const $c54e04054e4b82c0$export$69fffb6a9571fbfe = (0, $8v0nu.forwardRef)(function AvatarFallback2(props, ref) {
    const styles = $c54e04054e4b82c0$export$766de4db34c66f23();
    const classNames = $c54e04054e4b82c0$var$useClassNames();
    const { name: _, ...rest } = props;
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)($c54e04054e4b82c0$var$StyledFallback, {
        ref: ref,
        ...rest,
        className: (0, $99474b193e949655$export$a274e22fb40f762e)(props.className, classNames.fallback),
        css: [
            styles.fallback,
            props.css
        ],
        children: $c54e04054e4b82c0$var$getFallbackChildren(props)
    });
});
const $c54e04054e4b82c0$export$2cd8ae1985206fe8 = $c54e04054e4b82c0$var$withContext((0, $2ee5824619699054$export$f5d9b2daa45aa107).Image, "image", {
    forwardAsChild: true,
    defaultProps: {
        draggable: "false",
        referrerPolicy: "no-referrer"
    }
});
const $c54e04054e4b82c0$export$b1f22795a41806ac = (0, $8v0nu.forwardRef)(function AvatarIcon2(props, ref) {
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $4042601bfa1a9d25$export$7cd122d781af9fa4).svg, {
        stroke: "currentColor",
        fill: "currentColor",
        strokeWidth: "0",
        viewBox: "0 0 24 24",
        height: "1.2em",
        width: "1.2em",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)("path", {
            d: "M20 22H18V20C18 18.3431 16.6569 17 15 17H9C7.34315 17 6 18.3431 6 20V22H4V20C4 17.2386 6.23858 15 9 15H15C17.7614 15 20 17.2386 20 20V22ZM12 13C8.68629 13 6 10.3137 6 7C6 3.68629 8.68629 1 12 1C15.3137 1 18 3.68629 18 7C18 10.3137 15.3137 13 12 13ZM12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"
        })
    });
});
const $c54e04054e4b82c0$export$a20dad690e1279e2 = (0, $2ee5824619699054$export$f5d9b2daa45aa107).Context;
const $c54e04054e4b82c0$export$5b26ebaf2b105908 = (0, $8v0nu.forwardRef)(function AvatarGroup2(props, ref) {
    const recipe = (0, $b8301707a52df201$export$51a14f30f34875a5)({
        key: "avatar"
    });
    const [variantProps, localProps] = (0, $8v0nu.useMemo)(()=>recipe.splitVariantProps(props), [
        props,
        recipe
    ]);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)($c54e04054e4b82c0$var$PropsProvider, {
        value: variantProps,
        children: /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $8ce9521b7a4b2ead$export$eb2fcfdbd7ba97d4), {
            gap: "0",
            spaceX: "-3",
            ref: ref,
            ...localProps
        })
    });
});


"use strict";




async function $0a265d2a46e29432$var$hash(string) {
    const utf8 = new TextEncoder().encode(string);
    const hashBuffer = await crypto.subtle.digest('SHA-256', utf8);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map((bytes)=>bytes.toString(16).padStart(2, '0')).join('');
    return hashHex;
}
function $0a265d2a46e29432$export$c6ede3bfc40c5e4b() {
    const { profile: profile, isLoading: isLoading, isEnabled: isEnabled, isAuthenticated: isAuthenticated, login: login, logout: logout } = (0, $c837ac9c698038bc$export$1d39dc5b47e56ff0)();
    const [userEmailHash, setUserEmailHash] = (0, $8v0nu.useState)('');
    (0, $8v0nu.useEffect)(()=>{
        if (profile?.email) $0a265d2a46e29432$var$hash(profile.email).then(setUserEmailHash);
    }, [
        profile?.email
    ]);
    if (!isEnabled) return null;
    if (!isAuthenticated || !profile || isLoading) return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $a987639d7be6b91e$export$353f5b6fc5456de1), {
        variant: "outline",
        onClick: ()=>{
            if (!isLoading) login({
                redirectUri: window.location.href
            });
        },
        children: [
            "Login",
            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9138db1f951ed55c$export$1692611780ac32d), {})
        ]
    });
    const username = `${profile.firstName} ${profile.lastName}`.trim() || profile.username;
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $a987639d7be6b91e$export$353f5b6fc5456de1), {
        variant: "outline",
        pl: "2px",
        "aria-label": username,
        onClick: ()=>{
            if (!isLoading) logout({
                redirectUri: window.location.href
            });
        },
        children: [
            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $2207a5f1a4e8d6ed$exports).Root, {
                asChild: true,
                size: "xs",
                bg: "secondary.500",
                color: "white",
                borderRadius: "4px",
                children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)("span", {
                    children: [
                        /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $2207a5f1a4e8d6ed$exports).Image, {
                            src: `https://www.gravatar.com/avatar/${userEmailHash}?d=404`
                        }),
                        /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $2207a5f1a4e8d6ed$exports).Fallback, {
                            name: username
                        })
                    ]
                })
            }),
            "Logout",
            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9138db1f951ed55c$export$2d4c748bd12d78e0), {})
        ]
    });
}



function $e206030315a52ed9$var$NavItem(props) {
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $31d9364a1b2177e0$exports).Item, {
        children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $a987639d7be6b91e$export$353f5b6fc5456de1), {
            as: (0, $78d29a24c660df8a$export$2e2bcd8739ae039),
            variant: "ghost",
            css: {
                '&:hover': {
                    textDecoration: 'none'
                }
            },
            ...props
        })
    });
}
function $e206030315a52ed9$var$MainNavigation() {
    const { isEnabled: isEnabled, isAuthenticated: isAuthenticated } = (0, $c837ac9c698038bc$export$1d39dc5b47e56ff0)();
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
        as: "nav",
        "aria-label": "Main",
        gap: 4,
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $31d9364a1b2177e0$exports).Root, {
                flexDirection: "row",
                gap: 2,
                listStyle: "none",
                children: [
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)($e206030315a52ed9$var$NavItem, {
                        to: "/collections/",
                        children: [
                            "Browse",
                            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9138db1f951ed55c$export$22e733acfe1431e6), {})
                        ]
                    }),
                    isAuthenticated && /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)($e206030315a52ed9$var$NavItem, {
                        to: "/collections/new",
                        children: [
                            "Create",
                            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9138db1f951ed55c$export$3a9f56a1d1f9a714), {})
                        ]
                    })
                ]
            }),
            isEnabled && /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $ef524fb144c5d632$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $01474eb65f0b7d4e$export$1ff3c3f08ae963c0), {
                        orientation: "vertical",
                        borderLeftWidth: "2px",
                        borderColor: "base.200",
                        h: "1rem"
                    }),
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $0a265d2a46e29432$export$c6ede3bfc40c5e4b), {})
                ]
            })
        ]
    });
}
var $e206030315a52ed9$export$2e2bcd8739ae039 = $e206030315a52ed9$var$MainNavigation;



parcelRequire("8v0nu");




function $d26150280087d264$var$Home() {
    (0, $aec39e40387762bd$export$2e2bcd8739ae039)("STAC Manager Demo");
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $aa6b6e9e15323f83$export$444b3ab0cb9aec40), {
        to: "/collections",
        replace: true
    });
}
var $d26150280087d264$export$2e2bcd8739ae039 = $d26150280087d264$var$Home;




var $8v0nu = parcelRequire("8v0nu");


var $8v0nu = parcelRequire("8v0nu");

"use strict";
"use client";
const $756da344c07e2b07$export$c25acd513dcc8062 = (0, $8v0nu.forwardRef)(function IconButton2(props, ref) {
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $a987639d7be6b91e$export$353f5b6fc5456de1), {
        px: "0",
        py: "0",
        _icon: {
            fontSize: "1.2em"
        },
        ref: ref,
        ...props
    });
});
$756da344c07e2b07$export$c25acd513dcc8062.displayName = "IconButton";



"use client";
//#region src/components/field/use-field-context.ts
var [$df31a980f7a28a5b$export$2d8567833d33b737, $df31a980f7a28a5b$export$d02e393030f1ec84] = (0, $51a09ee1e9e91bf5$export$fd42f52fd3ae1109)({
    name: "FieldContext",
    hookName: "useFieldContext",
    providerName: "<FieldProvider />",
    strict: false
});


"use client";
//#region src/components/field/field-context.tsx
var $77a51379c83d21b4$export$f630cb8464d0f36 = (props)=>props.children((0, $df31a980f7a28a5b$export$d02e393030f1ec84)());





var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/field/field-error-text.tsx
var $6bb0e1885e941989$export$71fe3e2630a403d6 = (0, $8v0nu.forwardRef)((props, ref)=>{
    const field = (0, $df31a980f7a28a5b$export$d02e393030f1ec84)();
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)(field.getErrorTextProps(), props);
    if (field?.invalid) return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).span, {
        ...mergedProps,
        ref: ref
    });
    return null;
});
$6bb0e1885e941989$export$71fe3e2630a403d6.displayName = "FieldErrorText";





var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/field/field-helper-text.tsx
var $a7ebcaf20207c2a8$export$ce9510a731ecfe22 = (0, $8v0nu.forwardRef)((props, ref)=>{
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)((0, $df31a980f7a28a5b$export$d02e393030f1ec84)()?.getHelperTextProps(), props);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).span, {
        ...mergedProps,
        ref: ref
    });
});
$a7ebcaf20207c2a8$export$ce9510a731ecfe22.displayName = "FieldHelperText";





var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/field/field-input.tsx
var $3386bd15d8edac16$export$e47947e41f368277 = (0, $8v0nu.forwardRef)((props, ref)=>{
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)((0, $df31a980f7a28a5b$export$d02e393030f1ec84)()?.getInputProps(), props);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).input, {
        ...mergedProps,
        ref: ref
    });
});
$3386bd15d8edac16$export$e47947e41f368277.displayName = "FieldInput";



"use client";
//#region src/components/field/field.anatomy.ts
var $4473332d2db12625$export$a43048b0d2808e4e = (0, $07b08c6ef332e8db$export$197e6e8d4b33fd6c)("field").parts("root", "errorText", "helperText", "input", "label", "select", "textarea", "requiredIndicator");
var $4473332d2db12625$export$6e2410c1d27f06e7 = $4473332d2db12625$export$a43048b0d2808e4e.build();




var $8v0nu = parcelRequire("8v0nu");

"use client";
//#region src/components/field/field-item.tsx
var $6ae406ff2fd72a14$export$d0a9fb76f948d598 = (props)=>{
    const { value: value, children: children } = props;
    const parentField = (0, $df31a980f7a28a5b$export$d02e393030f1ec84)();
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $df31a980f7a28a5b$export$2d8567833d33b737), {
        value: (0, $8v0nu.useMemo)(()=>{
            if (!parentField) throw new Error("Field.Item must be used within Field.Root");
            const controlId = `field::${parentField.ids.control}::item::${value}`;
            const labelId = `${controlId}::label`;
            const getControlProps = ()=>({
                    ...parentField.getInputProps(),
                    id: controlId
                });
            return {
                ...parentField,
                ids: {
                    ...parentField.ids,
                    control: controlId,
                    label: labelId
                },
                getLabelProps: ()=>({
                        ...parentField.getLabelProps(),
                        id: labelId,
                        htmlFor: controlId
                    }),
                getInputProps: ()=>({
                        ...getControlProps(),
                        ...(0, $4473332d2db12625$export$6e2410c1d27f06e7).input.attrs
                    }),
                getSelectProps: ()=>({
                        ...getControlProps(),
                        ...(0, $4473332d2db12625$export$6e2410c1d27f06e7).select.attrs
                    }),
                getTextareaProps: ()=>({
                        ...getControlProps(),
                        ...(0, $4473332d2db12625$export$6e2410c1d27f06e7).textarea.attrs
                    })
            };
        }, [
            parentField,
            value
        ]),
        children: children
    });
};
$6ae406ff2fd72a14$export$d0a9fb76f948d598.displayName = "FieldItem";





var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/field/field-label.tsx
var $e92ca4e12a75e98c$export$1acdcf5a973a8414 = (0, $8v0nu.forwardRef)((props, ref)=>{
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)((0, $df31a980f7a28a5b$export$d02e393030f1ec84)()?.getLabelProps(), props);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).label, {
        ...mergedProps,
        ref: ref
    });
});
$e92ca4e12a75e98c$export$1acdcf5a973a8414.displayName = "FieldLabel";





var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/field/field-required-indicator.tsx
var $28ef062469172a17$export$9c2e1d1b54e4a192 = (0, $8v0nu.forwardRef)(({ fallback: fallback, ...props }, ref)=>{
    const field = (0, $df31a980f7a28a5b$export$d02e393030f1ec84)();
    if (!field.required) return fallback;
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)(field.getRequiredIndicatorProps(), props);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).span, {
        ...mergedProps,
        ref: ref,
        children: props.children ?? "*"
    });
});
$28ef062469172a17$export$9c2e1d1b54e4a192.displayName = "FieldRequiredIndicator";









"use client";
//#region src/components/fieldset/use-fieldset-context.ts
var [$2a2f69e4c1ad7c1b$export$57473b03a87606d3, $2a2f69e4c1ad7c1b$export$e46e66a55913b34c] = (0, $51a09ee1e9e91bf5$export$fd42f52fd3ae1109)({
    name: "FieldsetContext",
    hookName: "useFieldsetContext",
    providerName: "<FieldsetProvider />",
    strict: false
});



var $8v0nu = parcelRequire("8v0nu");
"use client";
//#region src/utils/use-safe-layout-effect.ts
var $9ae467e0bcfbf220$export$deebe11a338de063 = typeof window !== "undefined" ? (0, $8v0nu.useLayoutEffect) : (0, $8v0nu.useEffect);



var $8v0nu = parcelRequire("8v0nu");

"use client";
//#region src/components/field/use-field.ts
var $f6cd6617cee57d28$export$294aa081a6c6f55d = (props = {})=>{
    const fieldset = (0, $2a2f69e4c1ad7c1b$export$e46e66a55913b34c)();
    const env = (0, $cfa7a900a06000ef$export$899b1e582a0b3c80)();
    const { ids: ids, target: target, disabled: disabled = Boolean(fieldset?.disabled), invalid: invalid = false, readOnly: readOnly = false, required: required = false } = props;
    const [hasErrorText, setHasErrorText] = (0, $8v0nu.useState)(false);
    const [hasHelperText, setHasHelperText] = (0, $8v0nu.useState)(false);
    const uid = (0, $8v0nu.useId)();
    const id = props.id ?? uid;
    const rootRef = (0, $8v0nu.useRef)(null);
    const rootId = ids?.control ?? `field::${id}`;
    const errorTextId = ids?.errorText ?? `field::${id}::error-text`;
    const helperTextId = ids?.helperText ?? `field::${id}::helper-text`;
    const labelId = ids?.label ?? `field::${id}::label`;
    (0, $9ae467e0bcfbf220$export$deebe11a338de063)(()=>{
        const rootNode = rootRef.current;
        if (!rootNode) return;
        const checkTextElements = ()=>{
            const docOrShadowRoot = env.getRootNode();
            setHasErrorText(!!docOrShadowRoot.getElementById(errorTextId));
            setHasHelperText(!!docOrShadowRoot.getElementById(helperTextId));
        };
        checkTextElements();
        const observer = new (env.getWindow()).MutationObserver(checkTextElements);
        observer.observe(rootNode, {
            childList: true,
            subtree: true
        });
        return ()=>observer.disconnect();
    }, [
        env,
        errorTextId,
        helperTextId
    ]);
    const labelIds = (0, $8v0nu.useMemo)(()=>{
        const ids = [];
        if (hasErrorText && invalid) ids.push(errorTextId);
        if (hasHelperText) ids.push(helperTextId);
        return ids.join(" ") || void 0;
    }, [
        invalid,
        errorTextId,
        helperTextId,
        hasErrorText,
        hasHelperText
    ]);
    const getRootProps = (0, $8v0nu.useMemo)(()=>()=>({
                ...(0, $4473332d2db12625$export$6e2410c1d27f06e7).root.attrs,
                id: rootId,
                ref: rootRef,
                role: "group",
                "data-disabled": (0, $dbd9babc41e226bd$export$5cc3b7b83e34ade7)(disabled),
                "data-invalid": (0, $dbd9babc41e226bd$export$5cc3b7b83e34ade7)(invalid),
                "data-readonly": (0, $dbd9babc41e226bd$export$5cc3b7b83e34ade7)(readOnly)
            }), [
        disabled,
        invalid,
        readOnly,
        rootId
    ]);
    const targetControlId = target ? `field::${id}::item::${target}` : void 0;
    const getLabelProps = (0, $8v0nu.useMemo)(()=>()=>({
                ...(0, $4473332d2db12625$export$6e2410c1d27f06e7).label.attrs,
                id: labelId,
                "data-disabled": (0, $dbd9babc41e226bd$export$5cc3b7b83e34ade7)(disabled),
                "data-invalid": (0, $dbd9babc41e226bd$export$5cc3b7b83e34ade7)(invalid),
                "data-readonly": (0, $dbd9babc41e226bd$export$5cc3b7b83e34ade7)(readOnly),
                "data-required": (0, $dbd9babc41e226bd$export$5cc3b7b83e34ade7)(required),
                htmlFor: targetControlId ?? id
            }), [
        disabled,
        invalid,
        readOnly,
        required,
        id,
        labelId,
        targetControlId
    ]);
    const getControlProps = (0, $8v0nu.useMemo)(()=>()=>({
                "aria-describedby": labelIds,
                "aria-invalid": (0, $dbd9babc41e226bd$export$91a6105db3d4be7b)(invalid),
                "data-invalid": (0, $dbd9babc41e226bd$export$5cc3b7b83e34ade7)(invalid),
                "data-required": (0, $dbd9babc41e226bd$export$5cc3b7b83e34ade7)(required),
                "data-readonly": (0, $dbd9babc41e226bd$export$5cc3b7b83e34ade7)(readOnly),
                id: id,
                required: required,
                disabled: disabled,
                readOnly: readOnly
            }), [
        labelIds,
        invalid,
        required,
        readOnly,
        id,
        disabled
    ]);
    const getInputProps = (0, $8v0nu.useMemo)(()=>()=>({
                ...getControlProps(),
                ...(0, $4473332d2db12625$export$6e2410c1d27f06e7).input.attrs
            }), [
        getControlProps
    ]);
    const getTextareaProps = (0, $8v0nu.useMemo)(()=>()=>({
                ...getControlProps(),
                ...(0, $4473332d2db12625$export$6e2410c1d27f06e7).textarea.attrs
            }), [
        getControlProps
    ]);
    const getSelectProps = (0, $8v0nu.useMemo)(()=>()=>({
                ...getControlProps(),
                ...(0, $4473332d2db12625$export$6e2410c1d27f06e7).select.attrs
            }), [
        getControlProps
    ]);
    const getHelperTextProps = (0, $8v0nu.useMemo)(()=>()=>({
                id: helperTextId,
                ...(0, $4473332d2db12625$export$6e2410c1d27f06e7).helperText.attrs,
                "data-disabled": (0, $dbd9babc41e226bd$export$5cc3b7b83e34ade7)(disabled)
            }), [
        disabled,
        helperTextId
    ]);
    const getErrorTextProps = (0, $8v0nu.useMemo)(()=>()=>({
                id: errorTextId,
                ...(0, $4473332d2db12625$export$6e2410c1d27f06e7).errorText.attrs,
                "aria-live": "polite"
            }), [
        errorTextId
    ]);
    const getRequiredIndicatorProps = (0, $8v0nu.useMemo)(()=>()=>({
                "aria-hidden": true,
                ...(0, $4473332d2db12625$export$6e2410c1d27f06e7).requiredIndicator.attrs
            }), []);
    return {
        ariaDescribedby: labelIds,
        ids: {
            root: rootId,
            control: id,
            label: labelId,
            errorText: errorTextId,
            helperText: helperTextId
        },
        refs: {
            rootRef: rootRef
        },
        disabled: disabled,
        invalid: invalid,
        readOnly: readOnly,
        required: required,
        getLabelProps: getLabelProps,
        getRootProps: getRootProps,
        getInputProps: getInputProps,
        getTextareaProps: getTextareaProps,
        getSelectProps: getSelectProps,
        getHelperTextProps: getHelperTextProps,
        getErrorTextProps: getErrorTextProps,
        getRequiredIndicatorProps: getRequiredIndicatorProps
    };
};



var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/field/field-root.tsx
var $724a832c0056baa8$var$splitRootProps = (0, $41bdb03050f91b76$export$3ea53b214fbc1986)();
var $724a832c0056baa8$export$7c6bb459c5438342 = (0, $8v0nu.forwardRef)((props, ref)=>{
    const [useFieldProps, localProps] = $724a832c0056baa8$var$splitRootProps(props, [
        "id",
        "ids",
        "disabled",
        "invalid",
        "readOnly",
        "required",
        "target"
    ]);
    const field = (0, $f6cd6617cee57d28$export$294aa081a6c6f55d)(useFieldProps);
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)(field.getRootProps(), localProps);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $df31a980f7a28a5b$export$2d8567833d33b737), {
        value: field,
        children: /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).div, {
            ...mergedProps,
            ref: (0, $ab7129f9bbf0085f$export$43e446d32b3d21af)(ref, field.refs.rootRef)
        })
    });
});
$724a832c0056baa8$export$7c6bb459c5438342.displayName = "FieldRoot";






var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/field/field-root-provider.tsx
var $1cd32c3b8bdd47eb$var$splitRootProviderProps = (0, $41bdb03050f91b76$export$3ea53b214fbc1986)();
var $1cd32c3b8bdd47eb$export$f2b87bd7270bd3e3 = (0, $8v0nu.forwardRef)((props, ref)=>{
    const [{ value: field }, localProps] = $1cd32c3b8bdd47eb$var$splitRootProviderProps(props, [
        "value"
    ]);
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)(field.getRootProps(), localProps);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $df31a980f7a28a5b$export$2d8567833d33b737), {
        value: field,
        children: /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).div, {
            ...mergedProps,
            ref: ref
        })
    });
});
$1cd32c3b8bdd47eb$export$f2b87bd7270bd3e3.displayName = "FieldRootProvider";





var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/field/field-select.tsx
var $fd03517ff2abf9d8$export$f458baad8d8346bf = (0, $8v0nu.forwardRef)((props, ref)=>{
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)((0, $df31a980f7a28a5b$export$d02e393030f1ec84)()?.getSelectProps(), props);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).select, {
        ...mergedProps,
        ref: ref
    });
});
$fd03517ff2abf9d8$export$f458baad8d8346bf.displayName = "FieldSelect";






var $8v0nu = parcelRequire("8v0nu");


// src/autoresize-textarea.ts


var $8c3f3ba8f408b68b$var$styleCache = /* @__PURE__ */ new WeakMap();
function $8c3f3ba8f408b68b$export$3735103072e4a80(el) {
    if (!$8c3f3ba8f408b68b$var$styleCache.has(el)) $8c3f3ba8f408b68b$var$styleCache.set(el, (0, $2020ec4601cca401$export$38b2d434cce3ea22)(el).getComputedStyle(el));
    return $8c3f3ba8f408b68b$var$styleCache.get(el);
}


var $29f6fcda2bb43ae1$export$470f5a0a9a4bcaaa = (el)=>{
    if (!el) return;
    const style = (0, $8c3f3ba8f408b68b$export$3735103072e4a80)(el);
    const win = (0, $2020ec4601cca401$export$38b2d434cce3ea22)(el);
    const doc = (0, $2020ec4601cca401$export$f65ca476c09acec0)(el);
    const resize = ()=>{
        requestAnimationFrame(()=>{
            el.style.height = "auto";
            let newHeight;
            if (style.boxSizing === "content-box") newHeight = el.scrollHeight - (parseFloat(style.paddingTop) + parseFloat(style.paddingBottom));
            else newHeight = el.scrollHeight + parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
            if (style.maxHeight !== "none" && newHeight > parseFloat(style.maxHeight)) {
                if (style.overflowY === "hidden") el.style.overflowY = "scroll";
                newHeight = parseFloat(style.maxHeight);
            } else if (style.overflowY !== "hidden") el.style.overflowY = "hidden";
            el.style.height = `${newHeight}px`;
        });
    };
    el.addEventListener("input", resize);
    el.form?.addEventListener("reset", resize);
    const elementPrototype = Object.getPrototypeOf(el);
    const descriptor = Object.getOwnPropertyDescriptor(elementPrototype, "value");
    if (descriptor) Object.defineProperty(el, "value", {
        ...descriptor,
        set (newValue) {
            const prevValue = descriptor.get?.call(this);
            descriptor.set?.call(this, newValue);
            resize();
            if (prevValue !== newValue) queueMicrotask(()=>{
                el.dispatchEvent(new win.InputEvent("input", {
                    bubbles: true
                }));
            });
        }
    });
    const resizeObserver = new win.ResizeObserver(()=>{
        requestAnimationFrame(()=>resize());
    });
    resizeObserver.observe(el);
    const attrObserver = new win.MutationObserver(()=>resize());
    attrObserver.observe(el, {
        attributes: true,
        attributeFilter: [
            "rows",
            "placeholder"
        ]
    });
    doc.fonts?.addEventListener("loadingdone", resize);
    return ()=>{
        el.removeEventListener("input", resize);
        el.form?.removeEventListener("reset", resize);
        doc.fonts?.removeEventListener("loadingdone", resize);
        resizeObserver.disconnect();
        attrObserver.disconnect();
    };
};


"use client";
//#region src/components/field/field-textarea.tsx
var $a588453687984ee7$export$1f64bed01e8e3e33 = (0, $8v0nu.forwardRef)((props, ref)=>{
    const { autoresize: autoresize, ...textareaProps } = props;
    const textareaRef = (0, $8v0nu.useRef)(null);
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)((0, $df31a980f7a28a5b$export$d02e393030f1ec84)()?.getTextareaProps(), {
        style: {
            resize: autoresize ? "none" : void 0
        }
    }, textareaProps);
    (0, $8v0nu.useEffect)(()=>{
        if (!autoresize) return;
        return (0, $29f6fcda2bb43ae1$export$470f5a0a9a4bcaaa)(textareaRef.current);
    }, [
        autoresize
    ]);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).textarea, {
        ...mergedProps,
        ref: (0, $ab7129f9bbf0085f$export$43e446d32b3d21af)(ref, textareaRef)
    });
});
$a588453687984ee7$export$1f64bed01e8e3e33.displayName = "FieldTextarea";


//#region src/components/field/field.ts
var $61e790c8e9adb68c$export$583ec68827c6c3b1 = /* @__PURE__ */ (0, $57db88e2bf337fea$export$8126e515a7516e2)({
    Context: ()=>(0, $77a51379c83d21b4$export$f630cb8464d0f36),
    ErrorText: ()=>(0, $6bb0e1885e941989$export$71fe3e2630a403d6),
    HelperText: ()=>(0, $a7ebcaf20207c2a8$export$ce9510a731ecfe22),
    Input: ()=>(0, $3386bd15d8edac16$export$e47947e41f368277),
    Item: ()=>(0, $6ae406ff2fd72a14$export$d0a9fb76f948d598),
    Label: ()=>(0, $e92ca4e12a75e98c$export$1acdcf5a973a8414),
    RequiredIndicator: ()=>(0, $28ef062469172a17$export$9c2e1d1b54e4a192),
    Root: ()=>(0, $724a832c0056baa8$export$7c6bb459c5438342),
    RootProvider: ()=>(0, $1cd32c3b8bdd47eb$export$f2b87bd7270bd3e3),
    Select: ()=>(0, $fd03517ff2abf9d8$export$f458baad8d8346bf),
    Textarea: ()=>(0, $a588453687984ee7$export$1f64bed01e8e3e33)
});



"use strict";
"use client";
const { withContext: $88b24aa7301f8cd5$var$withContext, PropsProvider: $88b24aa7301f8cd5$var$PropsProvider } = (0, $aa5f4d03028a5427$export$e99ac154c18649c5)({
    key: "input"
});
const $88b24aa7301f8cd5$export$f5b8910cec6cf069 = $88b24aa7301f8cd5$var$withContext((0, $61e790c8e9adb68c$export$583ec68827c6c3b1).Input);
const $88b24aa7301f8cd5$export$f3f96a4870e83415 = $88b24aa7301f8cd5$var$PropsProvider;



var $8v0nu = parcelRequire("8v0nu");


var $8v0nu = parcelRequire("8v0nu");



"use strict";
"use client";
const $9b002c5f87744d9b$export$bc91d778bb7f4691 = (0, $8v0nu.forwardRef)(function InputAddon2({ unstyled: unstyled, ...props }, ref) {
    const recipe = (0, $971213434541a23d$export$cf0e09a7086104ff)({
        key: "inputAddon",
        recipe: props.recipe
    });
    const [variantProps, localProps] = recipe.splitVariantProps(props);
    const styles = unstyled ? (0, $0fb716203df70dd7$export$d3d148c3a490a1e4) : recipe(variantProps);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $4042601bfa1a9d25$export$7cd122d781af9fa4).div, {
        ref: ref,
        ...localProps,
        css: [
            styles,
            props.css
        ]
    });
});



"use strict";
"use client";
const $65aa6ba502bac8b8$export$db469dc6762063cb = (0, $4042601bfa1a9d25$export$7cd122d781af9fa4)("div", {
    base: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        zIndex: 2,
        color: "fg.muted",
        height: "full",
        fontSize: "sm",
        px: "3"
    },
    variants: {
        placement: {
            start: {
                insetInlineStart: "0"
            },
            end: {
                insetInlineEnd: "0"
            }
        }
    }
});



"use strict";
"use client";
const $4118161e107f6861$export$6e5a9cd40e0c9b97 = (0, $8v0nu.forwardRef)(function InputGroup2(props, ref) {
    const { startElement: startElement, startElementProps: startElementProps, endElement: endElement, endElementProps: endElementProps, startAddon: startAddon, startAddonProps: startAddonProps, endAddon: endAddon, endAddonProps: endAddonProps, children: children, startOffset: startOffset = "0px", endOffset: endOffset = "0px", ...rest } = props;
    const child = (0, $8v0nu.Children).only(children);
    const attached = Boolean(startAddon || endAddon);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsxs)((0, $8ce9521b7a4b2ead$export$eb2fcfdbd7ba97d4), {
        width: "full",
        ref: ref,
        attached: attached,
        skip: (el)=>el.type === (0, $65aa6ba502bac8b8$export$db469dc6762063cb),
        ...rest,
        children: [
            startAddon && /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $9b002c5f87744d9b$export$bc91d778bb7f4691), {
                ...startAddonProps,
                children: startAddon
            }),
            startElement && /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $65aa6ba502bac8b8$export$db469dc6762063cb), {
                pointerEvents: "none",
                ...startElementProps,
                children: startElement
            }),
            (0, $8v0nu.cloneElement)(child, {
                ...startElement && {
                    ps: `calc(var(--input-height) - ${startOffset})`
                },
                ...endElement && {
                    pe: `calc(var(--input-height) - ${endOffset})`
                },
                ...children.props
            }),
            endElement && /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $65aa6ba502bac8b8$export$db469dc6762063cb), {
                placement: "end",
                ...endElementProps,
                children: endElement
            }),
            endAddon && /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $9b002c5f87744d9b$export$bc91d778bb7f4691), {
                ...endAddonProps,
                children: endAddon
            })
        ]
    });
});

var $32db75c38a72e4b5$exports = {};

$parcel$export($32db75c38a72e4b5$exports, "Arrow", function () { return $1e03a4173b333d49$export$bcdda4773debf5fa; });
$parcel$export($32db75c38a72e4b5$exports, "ArrowTip", function () { return $1e03a4173b333d49$export$e60171086407adcc; });
$parcel$export($32db75c38a72e4b5$exports, "CheckboxItem", function () { return $1e03a4173b333d49$export$f6f243521332502d; });
$parcel$export($32db75c38a72e4b5$exports, "Content", function () { return $1e03a4173b333d49$export$479f0f2f71193efe; });
$parcel$export($32db75c38a72e4b5$exports, "Context", function () { return $1e03a4173b333d49$export$c7e742effb1c51e2; });
$parcel$export($32db75c38a72e4b5$exports, "ContextTrigger", function () { return $1e03a4173b333d49$export$cc43c1053d79d159; });
$parcel$export($32db75c38a72e4b5$exports, "Indicator", function () { return $1e03a4173b333d49$export$ec65978f4ff53791; });
$parcel$export($32db75c38a72e4b5$exports, "Item", function () { return $1e03a4173b333d49$export$2ce376c2cc3355c8; });
$parcel$export($32db75c38a72e4b5$exports, "ItemCommand", function () { return $1e03a4173b333d49$export$aed05792769368ea; });
$parcel$export($32db75c38a72e4b5$exports, "ItemContext", function () { return $1e03a4173b333d49$export$5ebb73512afd7119; });
$parcel$export($32db75c38a72e4b5$exports, "ItemGroup", function () { return $1e03a4173b333d49$export$d9dfbb355b82c7b6; });
$parcel$export($32db75c38a72e4b5$exports, "ItemGroupLabel", function () { return $1e03a4173b333d49$export$22708feb2fdc2491; });
$parcel$export($32db75c38a72e4b5$exports, "ItemIndicator", function () { return $1e03a4173b333d49$export$a2593e23056970a3; });
$parcel$export($32db75c38a72e4b5$exports, "ItemText", function () { return $1e03a4173b333d49$export$c4774e9097375cc0; });
$parcel$export($32db75c38a72e4b5$exports, "Positioner", function () { return $1e03a4173b333d49$export$fbbef597793ae27b; });
$parcel$export($32db75c38a72e4b5$exports, "RadioItem", function () { return $1e03a4173b333d49$export$69bd225e9817f6d0; });
$parcel$export($32db75c38a72e4b5$exports, "RadioItemGroup", function () { return $1e03a4173b333d49$export$181455e1ce4c2f0e; });
$parcel$export($32db75c38a72e4b5$exports, "Root", function () { return $1e03a4173b333d49$export$5ef9b2654717bfc2; });
$parcel$export($32db75c38a72e4b5$exports, "RootPropsProvider", function () { return $1e03a4173b333d49$export$158a7cd4e9091aae; });
$parcel$export($32db75c38a72e4b5$exports, "RootProvider", function () { return $1e03a4173b333d49$export$4d80086a8fd3b665; });
$parcel$export($32db75c38a72e4b5$exports, "Separator", function () { return $1e03a4173b333d49$export$1cec7dcdd713e220; });
$parcel$export($32db75c38a72e4b5$exports, "Trigger", function () { return $1e03a4173b333d49$export$27d2ad3c5815583e; });
$parcel$export($32db75c38a72e4b5$exports, "TriggerItem", function () { return $1e03a4173b333d49$export$e338118280a98c94; });




"use client";
//#region src/components/menu/use-menu-context.ts
var [$fe3ef04ecfa88898$export$62b22d151866115d, $fe3ef04ecfa88898$export$21c7ab35b39f78ec] = (0, $51a09ee1e9e91bf5$export$fd42f52fd3ae1109)({
    name: "MenuContext",
    hookName: "useMenuContext",
    providerName: "<MenuProvider />",
    strict: false
});



var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/menu/menu-arrow.tsx
var $b642d58c113413ac$export$bcdda4773debf5fa = (0, $8v0nu.forwardRef)((props, ref)=>{
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)((0, $fe3ef04ecfa88898$export$21c7ab35b39f78ec)().getArrowProps(), props);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).div, {
        ...mergedProps,
        ref: ref
    });
});
$b642d58c113413ac$export$bcdda4773debf5fa.displayName = "MenuArrow";





var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/menu/menu-arrow-tip.tsx
var $24a7dfc44c49fbf2$export$e60171086407adcc = (0, $8v0nu.forwardRef)((props, ref)=>{
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)((0, $fe3ef04ecfa88898$export$21c7ab35b39f78ec)().getArrowTipProps(), props);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).div, {
        ...mergedProps,
        ref: ref
    });
});
$24a7dfc44c49fbf2$export$e60171086407adcc.displayName = "MenuArrowTip";






"use client";
//#region src/components/menu/use-menu-item-context.ts
var [$0cb9b73f4ccaccdd$export$ccf0abc209268163, $0cb9b73f4ccaccdd$export$24f3082e80be231f] = (0, $51a09ee1e9e91bf5$export$fd42f52fd3ae1109)({
    name: "MenuItemContext",
    hookName: "useMenuItemContext",
    providerName: "<MenuItemProvider />"
});



"use client";
//#region src/components/menu/use-menu-option-item-props-context.ts
var [$56f60baf4f4260db$export$301e650d1d2106a, $56f60baf4f4260db$export$2c65eca70cd5917d] = (0, $51a09ee1e9e91bf5$export$fd42f52fd3ae1109)({
    name: "MenuItemPropsContext",
    hookName: "useMenuItemPropsContext",
    providerName: "<MenuItemPropsProvider />"
});



var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/menu/menu-checkbox-item.tsx
var $97257316e30fb28b$var$splitOptionItemProps = (0, $41bdb03050f91b76$export$3ea53b214fbc1986)();
var $97257316e30fb28b$export$f6f243521332502d = (0, $8v0nu.forwardRef)((props, ref)=>{
    const [partialOptionItemProps, localProps] = $97257316e30fb28b$var$splitOptionItemProps(props, [
        "checked",
        "closeOnSelect",
        "disabled",
        "onCheckedChange",
        "value",
        "valueText"
    ]);
    const optionItemProps = {
        ...partialOptionItemProps,
        type: "checkbox"
    };
    const menu = (0, $fe3ef04ecfa88898$export$21c7ab35b39f78ec)();
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)(menu.getOptionItemProps(optionItemProps), localProps);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $56f60baf4f4260db$export$301e650d1d2106a), {
        value: optionItemProps,
        children: /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $0cb9b73f4ccaccdd$export$ccf0abc209268163), {
            value: menu.getOptionItemState(optionItemProps),
            children: /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).div, {
                ...mergedProps,
                ref: ref
            })
        })
    });
});
$97257316e30fb28b$export$f6f243521332502d.displayName = "MenuCheckboxItem";





"use client";
//#region src/components/presence/use-presence-context.ts
var [$a356685fe9cf7378$export$446d8ecac66007a1, $a356685fe9cf7378$export$de7b90475d798ca5] = (0, $51a09ee1e9e91bf5$export$fd42f52fd3ae1109)({
    name: "PresenceContext",
    hookName: "usePresenceContext",
    providerName: "<PresenceProvider />"
});




var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/menu/menu-content.tsx
var $7af7d7b7fdf8c9e4$export$479f0f2f71193efe = (0, $8v0nu.forwardRef)((props, ref)=>{
    const menu = (0, $fe3ef04ecfa88898$export$21c7ab35b39f78ec)();
    const presence = (0, $a356685fe9cf7378$export$de7b90475d798ca5)();
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)(menu.getContentProps(), presence.getPresenceProps(), props);
    if (presence.unmounted) return null;
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).div, {
        ...mergedProps,
        ref: (0, $ab7129f9bbf0085f$export$43e446d32b3d21af)(presence.ref, ref)
    });
});
$7af7d7b7fdf8c9e4$export$479f0f2f71193efe.displayName = "MenuContent";



"use client";
//#region src/components/menu/menu-context.tsx
var $37347a1a39c2703c$export$c7e742effb1c51e2 = (props)=>props.children((0, $fe3ef04ecfa88898$export$21c7ab35b39f78ec)());





var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/menu/menu-context-trigger.tsx
var $4c991aa70fd7878e$export$cc43c1053d79d159 = (0, $8v0nu.forwardRef)((props, ref)=>{
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)((0, $fe3ef04ecfa88898$export$21c7ab35b39f78ec)().getContextTriggerProps(), props);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).button, {
        ...mergedProps,
        ref: ref
    });
});
$4c991aa70fd7878e$export$cc43c1053d79d159.displayName = "MenuContextTrigger";





var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/menu/menu-indicator.tsx
var $aac7e959ebbb79ec$export$ec65978f4ff53791 = (0, $8v0nu.forwardRef)((props, ref)=>{
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)((0, $fe3ef04ecfa88898$export$21c7ab35b39f78ec)().getIndicatorProps(), props);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).div, {
        ...mergedProps,
        ref: ref
    });
});
$aac7e959ebbb79ec$export$ec65978f4ff53791.displayName = "MenuIndicator";








var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/menu/menu-item.tsx
var $3b30a542c92e4009$var$splitItemBaseProps = (0, $41bdb03050f91b76$export$3ea53b214fbc1986)();
var $3b30a542c92e4009$export$2ce376c2cc3355c8 = (0, $8v0nu.forwardRef)((props, ref)=>{
    const [itemProps, localProps] = $3b30a542c92e4009$var$splitItemBaseProps(props, [
        "closeOnSelect",
        "disabled",
        "value",
        "valueText",
        "onSelect"
    ]);
    const menu = (0, $fe3ef04ecfa88898$export$21c7ab35b39f78ec)();
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)(menu.getItemProps(itemProps), localProps);
    const itemState = menu.getItemState(itemProps);
    (0, $8v0nu.useEffect)(()=>{
        return menu.addItemListener({
            id: itemState.id,
            onSelect: itemProps.onSelect
        });
    }, [
        itemState.id,
        itemProps.onSelect
    ]);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $56f60baf4f4260db$export$301e650d1d2106a), {
        value: itemProps,
        children: /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $0cb9b73f4ccaccdd$export$ccf0abc209268163), {
            value: itemState,
            children: /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).div, {
                ...mergedProps,
                ref: ref
            })
        })
    });
});
$3b30a542c92e4009$export$2ce376c2cc3355c8.displayName = "MenuItem";



"use client";
//#region src/components/menu/menu-item-context.tsx
var $87a7f13b804517f0$export$5ebb73512afd7119 = (props)=>props.children((0, $0cb9b73f4ccaccdd$export$24f3082e80be231f)());






"use client";
//#region src/components/menu/use-menu-item-group-context.ts
var [$4957181108dda80a$export$1d503a7cf5556c2, $4957181108dda80a$export$7204b4f8f14c3c2a] = (0, $51a09ee1e9e91bf5$export$fd42f52fd3ae1109)({
    name: "MenuItemGroupContext",
    hookName: "useMenuItemGroupContext",
    providerName: "<MenuItemGroupProvider />"
});



var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/menu/menu-item-group.tsx
var $e7dda0e862ae8182$var$splitItemGroupProps = (0, $41bdb03050f91b76$export$3ea53b214fbc1986)();
var $e7dda0e862ae8182$export$d9dfbb355b82c7b6 = (0, $8v0nu.forwardRef)((props, ref)=>{
    const [optionalItemGroupProps, localProps] = $e7dda0e862ae8182$var$splitItemGroupProps(props, [
        "id"
    ]);
    const menu = (0, $fe3ef04ecfa88898$export$21c7ab35b39f78ec)();
    const itemGroupProps = {
        id: (0, $8v0nu.useId)(),
        ...optionalItemGroupProps
    };
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)(menu.getItemGroupProps(itemGroupProps), localProps);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $4957181108dda80a$export$1d503a7cf5556c2), {
        value: itemGroupProps,
        children: /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).div, {
            ...mergedProps,
            ref: ref
        })
    });
});
$e7dda0e862ae8182$export$d9dfbb355b82c7b6.displayName = "MenuItemGroup";






var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/menu/menu-item-group-label.tsx
var $9d541bd178a4f05b$export$22708feb2fdc2491 = (0, $8v0nu.forwardRef)((props, ref)=>{
    const menu = (0, $fe3ef04ecfa88898$export$21c7ab35b39f78ec)();
    const itemGroup = (0, $4957181108dda80a$export$7204b4f8f14c3c2a)();
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)(menu.getItemGroupLabelProps({
        htmlFor: itemGroup.id
    }), props);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).div, {
        ...mergedProps,
        ref: ref
    });
});
$9d541bd178a4f05b$export$22708feb2fdc2491.displayName = "MenuItemGroupLabel";






var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/menu/menu-item-indicator.tsx
var $92ac553bf71d7d67$export$a2593e23056970a3 = (0, $8v0nu.forwardRef)((props, ref)=>{
    const menu = (0, $fe3ef04ecfa88898$export$21c7ab35b39f78ec)();
    const itemProps = (0, $56f60baf4f4260db$export$2c65eca70cd5917d)();
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)(menu.getItemIndicatorProps(itemProps), props);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).div, {
        ...mergedProps,
        ref: ref
    });
});
$92ac553bf71d7d67$export$a2593e23056970a3.displayName = "MenuItemIndicator";






var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/menu/menu-item-text.tsx
var $8a6f4cb61954c15f$export$c4774e9097375cc0 = (0, $8v0nu.forwardRef)((props, ref)=>{
    const menu = (0, $fe3ef04ecfa88898$export$21c7ab35b39f78ec)();
    const itemProps = (0, $56f60baf4f4260db$export$2c65eca70cd5917d)();
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)(menu.getItemTextProps(itemProps), props);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).div, {
        ...mergedProps,
        ref: ref
    });
});
$8a6f4cb61954c15f$export$c4774e9097375cc0.displayName = "MenuItemText";






var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/menu/menu-positioner.tsx
var $0369648f50437010$export$fbbef597793ae27b = (0, $8v0nu.forwardRef)((props, ref)=>{
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)((0, $fe3ef04ecfa88898$export$21c7ab35b39f78ec)().getPositionerProps(), props);
    if ((0, $a356685fe9cf7378$export$de7b90475d798ca5)().unmounted) return null;
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).div, {
        ...mergedProps,
        ref: ref
    });
});
$0369648f50437010$export$fbbef597793ae27b.displayName = "MenuPositioner";









var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/menu/menu-radio-item.tsx
var $bd55a706326b28d1$var$splitOptionItemProps = (0, $41bdb03050f91b76$export$3ea53b214fbc1986)();
var $bd55a706326b28d1$export$69bd225e9817f6d0 = (0, $8v0nu.forwardRef)((props, ref)=>{
    const [partialItemProps, localProps] = $bd55a706326b28d1$var$splitOptionItemProps(props, [
        "closeOnSelect",
        "disabled",
        "value",
        "valueText"
    ]);
    const menu = (0, $fe3ef04ecfa88898$export$21c7ab35b39f78ec)();
    const itemGroup = (0, $4957181108dda80a$export$7204b4f8f14c3c2a)();
    const optionItemProps = {
        ...partialItemProps,
        checked: itemGroup.value === partialItemProps.value,
        type: "radio",
        onCheckedChange: ()=>itemGroup.onValueChange?.({
                value: partialItemProps.value
            })
    };
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)(menu.getOptionItemProps(optionItemProps), localProps);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $56f60baf4f4260db$export$301e650d1d2106a), {
        value: optionItemProps,
        children: /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $0cb9b73f4ccaccdd$export$ccf0abc209268163), {
            value: menu.getOptionItemState(optionItemProps),
            children: /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).div, {
                ...mergedProps,
                ref: ref
            })
        })
    });
});
$bd55a706326b28d1$export$69bd225e9817f6d0.displayName = "MenuRadioItem";







var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/menu/menu-radio-item-group.tsx
var $27be9a83a6c6682c$var$splitItemGroupProps = (0, $41bdb03050f91b76$export$3ea53b214fbc1986)();
var $27be9a83a6c6682c$export$181455e1ce4c2f0e = (0, $8v0nu.forwardRef)((props, ref)=>{
    const [optionalItemGroupProps, localProps] = $27be9a83a6c6682c$var$splitItemGroupProps(props, [
        "id",
        "onValueChange",
        "value"
    ]);
    const menu = (0, $fe3ef04ecfa88898$export$21c7ab35b39f78ec)();
    const itemGroupProps = {
        id: (0, $8v0nu.useId)(),
        ...optionalItemGroupProps
    };
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)(menu.getItemGroupProps({
        id: itemGroupProps.id
    }), localProps);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $4957181108dda80a$export$1d503a7cf5556c2), {
        value: itemGroupProps,
        children: /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).div, {
            ...mergedProps,
            ref: ref
        })
    });
});
$27be9a83a6c6682c$export$181455e1ce4c2f0e.displayName = "MenuRadioItemGroup";




"use client";
//#region src/components/presence/split-presence-props.ts
var $efed63aa977b1a61$export$785dc0c15a64f8f7 = (props)=>(0, $41bdb03050f91b76$export$3ea53b214fbc1986)()(props, [
        "immediate",
        "lazyMount",
        "onExitComplete",
        "present",
        "skipAnimationOnMount",
        "unmountOnExit"
    ]);



var $8v0nu = parcelRequire("8v0nu");
"use client";
//#region src/utils/use-event.ts
/**
* Returns a memoized callback that will flushSync the callback if sync is true
*/ function $f47133aa934004c8$export$90fc3a17d93f704c(callback, opts = {}) {
    const { sync: sync = false } = opts;
    const callbackRef = $f47133aa934004c8$var$useLatestRef(callback);
    return (0, $8v0nu.useCallback)((...args)=>{
        if (sync) return queueMicrotask(()=>callbackRef.current?.(...args));
        return callbackRef.current?.(...args);
    }, [
        sync,
        callbackRef
    ]);
}
function $f47133aa934004c8$var$useLatestRef(value) {
    const ref = (0, $8v0nu.useRef)(value);
    ref.current = value;
    return ref;
}



var $8v0nu = parcelRequire("8v0nu");

// src/presence.connect.ts
function $f99d14e497e11194$export$64605811ab45167f(service, _normalize) {
    const { state: state, send: send, context: context } = service;
    const present = state.matches("mounted", "unmountSuspended");
    return {
        skip: !context.get("initial"),
        present: present,
        setNode (node) {
            if (!node) return;
            send({
                type: "NODE.SET",
                node: node
            });
        },
        unmount () {
            send({
                type: "UNMOUNT"
            });
        }
    };
}

// src/presence.machine.ts



// src/platform.ts
var $1bdb5bdc36ac2529$export$9f57505b7bd8dae = ()=>typeof document !== "undefined";
function $1bdb5bdc36ac2529$export$867a782338812cb4() {
    const agent = navigator.userAgentData;
    return agent?.platform ?? navigator.platform;
}
function $1bdb5bdc36ac2529$export$7935961ef7719cb0() {
    const ua2 = navigator.userAgentData;
    if (ua2 && Array.isArray(ua2.brands)) return ua2.brands.map(({ brand: brand, version: version })=>`${brand}/${version}`).join(" ");
    return navigator.userAgent;
}
var $1bdb5bdc36ac2529$var$pt = (v)=>$1bdb5bdc36ac2529$export$9f57505b7bd8dae() && v.test($1bdb5bdc36ac2529$export$867a782338812cb4());
var $1bdb5bdc36ac2529$var$ua = (v)=>$1bdb5bdc36ac2529$export$9f57505b7bd8dae() && v.test($1bdb5bdc36ac2529$export$7935961ef7719cb0());
var $1bdb5bdc36ac2529$var$vn = (v)=>$1bdb5bdc36ac2529$export$9f57505b7bd8dae() && v.test(navigator.vendor);
var $1bdb5bdc36ac2529$export$a1d0d20ee9546562 = ()=>$1bdb5bdc36ac2529$export$9f57505b7bd8dae() && !!navigator.maxTouchPoints;
var $1bdb5bdc36ac2529$export$186c6964ca17d99 = ()=>$1bdb5bdc36ac2529$var$pt(/^iPhone/i);
var $1bdb5bdc36ac2529$export$7bef049ce92e4224 = ()=>$1bdb5bdc36ac2529$var$pt(/^iPad/i) || $1bdb5bdc36ac2529$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
var $1bdb5bdc36ac2529$export$41a665f744414057 = ()=>$1bdb5bdc36ac2529$export$186c6964ca17d99() || $1bdb5bdc36ac2529$export$7bef049ce92e4224();
var $1bdb5bdc36ac2529$export$5231b1f790f5c149 = ()=>$1bdb5bdc36ac2529$export$9ac100e40613ea10() || $1bdb5bdc36ac2529$export$41a665f744414057();
var $1bdb5bdc36ac2529$export$9ac100e40613ea10 = ()=>$1bdb5bdc36ac2529$var$pt(/^Mac/i);
var $1bdb5bdc36ac2529$export$95df08bae54cb4df = ()=>$1bdb5bdc36ac2529$export$5231b1f790f5c149() && $1bdb5bdc36ac2529$var$vn(/apple/i);
var $1bdb5bdc36ac2529$export$b7d78993b74f766d = ()=>$1bdb5bdc36ac2529$var$ua(/Firefox/i);
var $1bdb5bdc36ac2529$export$6446a186d09e379e = ()=>$1bdb5bdc36ac2529$var$ua(/Chrome/i);
var $1bdb5bdc36ac2529$export$78551043582a6a98 = ()=>$1bdb5bdc36ac2529$var$ua(/AppleWebKit/i) && !$1bdb5bdc36ac2529$export$6446a186d09e379e();
var $1bdb5bdc36ac2529$export$a11b0059900ceec8 = ()=>$1bdb5bdc36ac2529$var$ua(/Android/i);


function $3921311bf0c8eca9$export$28ed887a50e27461(event) {
    const { selectionStart: selectionStart, selectionEnd: selectionEnd, value: value } = event.currentTarget;
    const data = event.data;
    return value.slice(0, selectionStart) + (data ?? "") + value.slice(selectionEnd);
}
function $3921311bf0c8eca9$var$getComposedPath(event) {
    return event.composedPath?.() ?? event.nativeEvent?.composedPath?.();
}
function $3921311bf0c8eca9$export$e58f029f0fbfdb29(event) {
    const composedPath = $3921311bf0c8eca9$var$getComposedPath(event);
    return composedPath?.[0] ?? event.target;
}
function $3921311bf0c8eca9$export$ca85c990e080b373(event) {
    const element = event.currentTarget;
    if (!element) return false;
    const validElement = element.matches("a[href], button[type='submit'], input[type='submit']");
    if (!validElement) return false;
    const isMiddleClick = event.button === 1;
    const isModKeyClick = $3921311bf0c8eca9$export$47d8bb423ff107f6(event);
    return isMiddleClick || isModKeyClick;
}
function $3921311bf0c8eca9$export$e2c2f0d64f6a549a(event) {
    const element = event.currentTarget;
    if (!element) return false;
    const localName = element.localName;
    if (!event.altKey) return false;
    if (localName === "a") return true;
    if (localName === "button" && element.type === "submit") return true;
    if (localName === "input" && element.type === "submit") return true;
    return false;
}
function $3921311bf0c8eca9$export$49e72d3db4288c1(event) {
    return $3921311bf0c8eca9$export$4abe0e945399ac1d(event).isComposing || event.keyCode === 229;
}
function $3921311bf0c8eca9$export$746ace428e2a5877(e) {
    return e.detail === 0 || e.clientX === 0 && e.clientY === 0;
}
function $3921311bf0c8eca9$export$47d8bb423ff107f6(e) {
    if ((0, $1bdb5bdc36ac2529$export$9ac100e40613ea10)()) return e.metaKey;
    return e.ctrlKey;
}
function $3921311bf0c8eca9$export$b3f2c64190cf8c4(e) {
    return e.key.length === 1 && !e.ctrlKey && !e.metaKey;
}
function $3921311bf0c8eca9$export$29bf1b5f2c56cf63(e) {
    return e.width === 0 && e.height === 0 || e.width === 1 && e.height === 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "mouse";
}
function $3921311bf0c8eca9$export$60278871457622de(e) {
    if (e.pointerType === "" && e.isTrusted) return true;
    if ((0, $1bdb5bdc36ac2529$export$a11b0059900ceec8)() && e.pointerType) return e.type === "click" && e.buttons === 1;
    return e.detail === 0 && !e.pointerType;
}
var $3921311bf0c8eca9$export$698c4f0ff5e11e52 = (e)=>e.button === 0;
var $3921311bf0c8eca9$export$6faedb510c176c60 = (e)=>{
    return e.button === 2 || (0, $1bdb5bdc36ac2529$export$9ac100e40613ea10)() && e.ctrlKey && e.button === 0;
};
var $3921311bf0c8eca9$export$90788ad2c69b4f50 = (e)=>e.ctrlKey || e.altKey || e.metaKey;
var $3921311bf0c8eca9$export$c4dfce035d43d1e0 = (event)=>"touches" in event && event.touches.length > 0;
var $3921311bf0c8eca9$var$keyMap = {
    Up: "ArrowUp",
    Down: "ArrowDown",
    Esc: "Escape",
    " ": "Space",
    ",": "Comma",
    Left: "ArrowLeft",
    Right: "ArrowRight"
};
var $3921311bf0c8eca9$var$rtlKeyMap = {
    ArrowLeft: "ArrowRight",
    ArrowRight: "ArrowLeft"
};
function $3921311bf0c8eca9$export$f7a7490116b79d4d(event, options = {}) {
    const { dir: dir = "ltr", orientation: orientation = "horizontal" } = options;
    let key = event.key;
    key = $3921311bf0c8eca9$var$keyMap[key] ?? key;
    const isRtl = dir === "rtl" && orientation === "horizontal";
    if (isRtl && key in $3921311bf0c8eca9$var$rtlKeyMap) key = $3921311bf0c8eca9$var$rtlKeyMap[key];
    return key;
}
function $3921311bf0c8eca9$export$4abe0e945399ac1d(event) {
    return event.nativeEvent ?? event;
}
var $3921311bf0c8eca9$var$pageKeys = /* @__PURE__ */ new Set([
    "PageUp",
    "PageDown"
]);
var $3921311bf0c8eca9$var$arrowKeys = /* @__PURE__ */ new Set([
    "ArrowUp",
    "ArrowDown",
    "ArrowLeft",
    "ArrowRight"
]);
function $3921311bf0c8eca9$export$587b7b5379932dd6(event) {
    if (event.ctrlKey || event.metaKey) return 0.1;
    else {
        const isPageKey = $3921311bf0c8eca9$var$pageKeys.has(event.key);
        const isSkipKey = isPageKey || event.shiftKey && $3921311bf0c8eca9$var$arrowKeys.has(event.key);
        return isSkipKey ? 10 : 1;
    }
}
function $3921311bf0c8eca9$export$a8637644cbd23a7b(event, type = "client") {
    const point = $3921311bf0c8eca9$export$c4dfce035d43d1e0(event) ? event.touches[0] || event.changedTouches[0] : event;
    return {
        x: point[`${type}X`],
        y: point[`${type}Y`]
    };
}
var $3921311bf0c8eca9$export$b1d829ddf82884aa = (target, eventName, handler, options)=>{
    const node = typeof target === "function" ? target() : target;
    node?.addEventListener(eventName, handler, options);
    return ()=>{
        node?.removeEventListener(eventName, handler, options);
    };
};
var $3921311bf0c8eca9$export$7bced8f45c53f2f = (event)=>{
    const composedPath = $3921311bf0c8eca9$var$getComposedPath(event);
    const target = composedPath?.[0] ?? event.target;
    return event.currentTarget === target;
};



function $7ac6bc7380fa7b77$export$9fec4d97f1922e0b(el, attr, v) {
    const prev = el.getAttribute(attr);
    const exists = prev != null;
    if (prev === v) return 0, $dbd9babc41e226bd$export$8793edee2d425525;
    el.setAttribute(attr, v);
    return ()=>{
        if (!exists) el.removeAttribute(attr);
        else el.setAttribute(attr, prev);
    };
}
function $7ac6bc7380fa7b77$export$a41c68a4eb5ff164(el, prop, v) {
    const exists = prop in el;
    const prev = el[prop];
    if (prev === v) return 0, $dbd9babc41e226bd$export$8793edee2d425525;
    el[prop] = v;
    return ()=>{
        if (!exists) delete el[prop];
        else el[prop] = prev;
    };
}
function $7ac6bc7380fa7b77$export$37a5fde709c1db82(el, style) {
    if (!el) return 0, $dbd9babc41e226bd$export$8793edee2d425525;
    const prev = Object.keys(style).reduce((acc, key)=>{
        acc[key] = el.style.getPropertyValue(key);
        return acc;
    }, {});
    if ($7ac6bc7380fa7b77$var$isEqual(prev, style)) return 0, $dbd9babc41e226bd$export$8793edee2d425525;
    Object.assign(el.style, style);
    return ()=>{
        Object.assign(el.style, prev);
        if (el.style.length === 0) el.removeAttribute("style");
    };
}
function $7ac6bc7380fa7b77$export$36a7c0615a5a1a31(el, prop, value) {
    if (!el) return 0, $dbd9babc41e226bd$export$8793edee2d425525;
    const prev = el.style.getPropertyValue(prop);
    if (prev === value) return 0, $dbd9babc41e226bd$export$8793edee2d425525;
    el.style.setProperty(prop, value);
    return ()=>{
        el.style.setProperty(prop, prev);
        if (el.style.length === 0) el.removeAttribute("style");
    };
}
function $7ac6bc7380fa7b77$var$isEqual(a, b) {
    return Object.keys(a).every((key)=>a[key] === b[key]);
}


var $43b41a5907c2eb29$export$ea56d40cd27c3480 = (0, $9aa7f39f9520657f$export$aaa7fa18f8e9b2e8)({
    props ({ props: props }) {
        return {
            ...props,
            present: !!props.present
        };
    },
    initialState ({ prop: prop }) {
        return prop("present") ? "mounted" : "unmounted";
    },
    refs () {
        return {
            node: null,
            styles: null
        };
    },
    context ({ bindable: bindable }) {
        return {
            unmountAnimationName: bindable(()=>({
                    defaultValue: null
                })),
            prevAnimationName: bindable(()=>({
                    defaultValue: null
                })),
            present: bindable(()=>({
                    defaultValue: false
                })),
            initial: bindable(()=>({
                    sync: true,
                    defaultValue: false
                }))
        };
    },
    exit: [
        "cleanupNode"
    ],
    watch ({ track: track, prop: prop, send: send }) {
        track([
            ()=>prop("present")
        ], ()=>{
            send({
                type: "PRESENCE.CHANGED"
            });
        });
    },
    on: {
        "NODE.SET": {
            actions: [
                "setupNode"
            ]
        },
        "PRESENCE.CHANGED": {
            actions: [
                "setInitial",
                "syncPresence"
            ]
        }
    },
    states: {
        mounted: {
            on: {
                UNMOUNT: {
                    target: "unmounted",
                    actions: [
                        "clearPrevAnimationName",
                        "invokeOnExitComplete"
                    ]
                },
                "UNMOUNT.SUSPEND": {
                    target: "unmountSuspended"
                }
            }
        },
        unmountSuspended: {
            effects: [
                "trackAnimationEvents"
            ],
            on: {
                MOUNT: {
                    target: "mounted",
                    actions: [
                        "setPrevAnimationName"
                    ]
                },
                UNMOUNT: {
                    target: "unmounted",
                    actions: [
                        "clearPrevAnimationName",
                        "invokeOnExitComplete"
                    ]
                }
            }
        },
        unmounted: {
            on: {
                MOUNT: {
                    target: "mounted",
                    actions: [
                        "setPrevAnimationName"
                    ]
                }
            }
        }
    },
    implementations: {
        actions: {
            setInitial: ({ context: context })=>{
                if (context.get("initial")) return;
                queueMicrotask(()=>{
                    context.set("initial", true);
                });
            },
            invokeOnExitComplete: ({ prop: prop, refs: refs })=>{
                prop("onExitComplete")?.();
                const node = refs.get("node");
                if (!node) return;
                const win = (0, $2020ec4601cca401$export$38b2d434cce3ea22)(node);
                const event = new win.CustomEvent("exitcomplete", {
                    bubbles: false
                });
                node.dispatchEvent(event);
            },
            setupNode: ({ refs: refs, event: event })=>{
                if (refs.get("node") === event.node) return;
                refs.set("node", event.node);
                refs.set("styles", (0, $8c3f3ba8f408b68b$export$3735103072e4a80)(event.node));
            },
            cleanupNode: ({ refs: refs })=>{
                refs.set("node", null);
                refs.set("styles", null);
            },
            syncPresence: ({ context: context, refs: refs, send: send, prop: prop })=>{
                const presentProp = prop("present");
                if (presentProp) return send({
                    type: "MOUNT",
                    src: "presence.changed"
                });
                const node = refs.get("node");
                if (!presentProp && node?.ownerDocument.visibilityState === "hidden") return send({
                    type: "UNMOUNT",
                    src: "visibilitychange"
                });
                (0, $7eacfb22d5a39e52$export$27f233d61a9e2fa4)(()=>{
                    if (prop("present")) return;
                    const animationName = $43b41a5907c2eb29$var$getAnimationName(refs.get("styles"));
                    context.set("unmountAnimationName", animationName);
                    if (animationName === "none" || animationName === context.get("prevAnimationName") || refs.get("styles")?.display === "none" || refs.get("styles")?.animationDuration === "0s") send({
                        type: "UNMOUNT",
                        src: "presence.changed"
                    });
                    else send({
                        type: "UNMOUNT.SUSPEND"
                    });
                });
            },
            setPrevAnimationName: ({ context: context, refs: refs })=>{
                (0, $7eacfb22d5a39e52$export$27f233d61a9e2fa4)(()=>{
                    context.set("prevAnimationName", $43b41a5907c2eb29$var$getAnimationName(refs.get("styles")));
                });
            },
            clearPrevAnimationName: ({ context: context })=>{
                context.set("prevAnimationName", null);
            }
        },
        effects: {
            trackAnimationEvents: ({ context: context, refs: refs, send: send, prop: prop })=>{
                const node = refs.get("node");
                if (!node) return;
                const onStart = (event)=>{
                    const target = event.composedPath?.()?.[0] ?? event.target;
                    if (target === node) context.set("prevAnimationName", $43b41a5907c2eb29$var$getAnimationName(refs.get("styles")));
                };
                const onEnd = (event)=>{
                    const animationName = $43b41a5907c2eb29$var$getAnimationName(refs.get("styles"));
                    const target = (0, $3921311bf0c8eca9$export$e58f029f0fbfdb29)(event);
                    if (target === node && animationName === context.get("unmountAnimationName") && !prop("present")) send({
                        type: "UNMOUNT",
                        src: "animationend"
                    });
                };
                const onCancel = (event)=>{
                    const target = (0, $3921311bf0c8eca9$export$e58f029f0fbfdb29)(event);
                    if (target === node && !prop("present")) send({
                        type: "UNMOUNT",
                        src: "animationcancel"
                    });
                };
                node.addEventListener("animationstart", onStart);
                node.addEventListener("animationcancel", onCancel);
                node.addEventListener("animationend", onEnd);
                const cleanupStyles = (0, $7ac6bc7380fa7b77$export$37a5fde709c1db82)(node, {
                    animationFillMode: "forwards"
                });
                return ()=>{
                    node.removeEventListener("animationstart", onStart);
                    node.removeEventListener("animationcancel", onCancel);
                    node.removeEventListener("animationend", onEnd);
                    (0, $7eacfb22d5a39e52$export$bdd553fddd433dcb)(()=>cleanupStyles());
                };
            }
        }
    }
});
function $43b41a5907c2eb29$var$getAnimationName(styles) {
    return styles?.animationName || "none";
}


"use client";
//#region src/components/presence/use-presence.ts
var $3e7c90e8656e783c$export$2a8c16d82a0a0e26 = (props = {})=>{
    const { lazyMount: lazyMount, unmountOnExit: unmountOnExit, present: present, skipAnimationOnMount: skipAnimationOnMount = false, ...rest } = props;
    const wasEverPresent = (0, $8v0nu.useRef)(false);
    const machineProps = {
        ...rest,
        present: present,
        onExitComplete: (0, $f47133aa934004c8$export$90fc3a17d93f704c)(props.onExitComplete)
    };
    const service = (0, $54265883fb157840$export$e0338c4153421160)($43b41a5907c2eb29$export$ea56d40cd27c3480, machineProps);
    const api = $f99d14e497e11194$export$64605811ab45167f(service, (0, $06b0a2ce147a2fe4$export$601abcd8103db5e4));
    if (api.present) wasEverPresent.current = true;
    const unmounted = !api.present && !wasEverPresent.current && lazyMount || unmountOnExit && !api.present && wasEverPresent.current;
    const getPresenceProps = ()=>({
            "data-state": api.skip && skipAnimationOnMount ? void 0 : present ? "open" : "closed",
            hidden: !api.present
        });
    return {
        ref: api.setNode,
        getPresenceProps: getPresenceProps,
        present: api.present,
        unmounted: unmounted
    };
};





var $8v0nu = parcelRequire("8v0nu");
"use client";
//#region src/utils/use-effect-once.ts
var $47fcd6611aacf1cb$export$b558662bb0641046 = (cb)=>{
    const savedCallback = (0, $8v0nu.useRef)(cb);
    const effectGuard = (0, $8v0nu.useRef)(false);
    (0, $8v0nu.useEffect)(()=>{
        savedCallback.current = cb;
    });
    (0, $8v0nu.useEffect)(()=>{
        if (effectGuard.current !== true) {
            effectGuard.current = true;
            savedCallback.current();
        }
    }, []);
};




// src/menu.connect.ts





var $07c78e08d1e50b44$var$isFrame = (el)=>(0, $2020ec4601cca401$export$1b3bfaa9684536aa)(el) && el.tagName === "IFRAME";
var $07c78e08d1e50b44$var$NATURALLY_TABBABLE_REGEX = /^(audio|video|details)$/;
function $07c78e08d1e50b44$var$parseTabIndex(el) {
    const attr = el.getAttribute("tabindex");
    if (!attr) return NaN;
    return parseInt(attr, 10);
}
var $07c78e08d1e50b44$var$hasTabIndex = (el)=>!Number.isNaN($07c78e08d1e50b44$var$parseTabIndex(el));
var $07c78e08d1e50b44$var$hasNegativeTabIndex = (el)=>$07c78e08d1e50b44$var$parseTabIndex(el) < 0;
function $07c78e08d1e50b44$var$isRadioInput(element) {
    return (0, $2020ec4601cca401$export$63ed1d20cf8213cf)(element) && element.type === "radio";
}
function $07c78e08d1e50b44$var$isTabbableRadio(element) {
    if (!$07c78e08d1e50b44$var$isRadioInput(element) || !element.name) return true;
    if (element.checked) return true;
    const selector = `input[type="radio"][name="${CSS.escape(element.name)}"]`;
    const scope = element.form ?? element.ownerDocument;
    const group = Array.from(scope.querySelectorAll(selector)).filter((radio)=>radio.form === element.form && $07c78e08d1e50b44$export$4c063cf1350e6fed(radio));
    const checked = group.find((radio)=>radio.checked);
    if (checked) return checked === element;
    return group[0] === element;
}
function $07c78e08d1e50b44$var$getShadowRootForNode(element, getShadowRoot) {
    if (!getShadowRoot) return null;
    if (getShadowRoot === true) return element.shadowRoot || null;
    const result = getShadowRoot(element);
    return (result === true ? element.shadowRoot : result) || null;
}
function $07c78e08d1e50b44$var$collectElementsWithShadowDOM(elements, getShadowRoot, filterFn) {
    const allElements = [
        ...elements
    ];
    const toProcess = [
        ...elements
    ];
    const processed = /* @__PURE__ */ new Set();
    const positionMap = /* @__PURE__ */ new Map();
    elements.forEach((el, i)=>positionMap.set(el, i));
    let processIndex = 0;
    while(processIndex < toProcess.length){
        const element = toProcess[processIndex++];
        if (!element || processed.has(element)) continue;
        processed.add(element);
        const shadowRoot = $07c78e08d1e50b44$var$getShadowRootForNode(element, getShadowRoot);
        if (shadowRoot) {
            const shadowElements = Array.from(shadowRoot.querySelectorAll($07c78e08d1e50b44$var$focusableSelector)).filter(filterFn);
            const hostIndex = positionMap.get(element);
            if (hostIndex !== void 0) {
                const insertPosition = hostIndex + 1;
                allElements.splice(insertPosition, 0, ...shadowElements);
                shadowElements.forEach((el, i)=>{
                    positionMap.set(el, insertPosition + i);
                });
                for(let i = insertPosition + shadowElements.length; i < allElements.length; i++)positionMap.set(allElements[i], i);
            } else {
                const insertPosition = allElements.length;
                allElements.push(...shadowElements);
                shadowElements.forEach((el, i)=>{
                    positionMap.set(el, insertPosition + i);
                });
            }
            toProcess.push(...shadowElements);
        }
    }
    return allElements;
}
var $07c78e08d1e50b44$var$focusableSelector = "input:not([type='hidden']):not([disabled]), select:not([disabled]), textarea:not([disabled]), a[href], button:not([disabled]), [tabindex], iframe, object, embed, area[href], audio[controls], video[controls], [contenteditable]:not([contenteditable='false']), details > summary:first-of-type";
var $07c78e08d1e50b44$export$f6768025e418420e = (container, options = {})=>{
    if (!container) return [];
    const { includeContainer: includeContainer = false, getShadowRoot: getShadowRoot } = options;
    const elements = Array.from(container.querySelectorAll($07c78e08d1e50b44$var$focusableSelector));
    const include = includeContainer == true || includeContainer == "if-empty" && elements.length === 0;
    if (include && (0, $2020ec4601cca401$export$1b3bfaa9684536aa)(container) && $07c78e08d1e50b44$export$4c063cf1350e6fed(container)) elements.unshift(container);
    const focusableElements = [];
    for (const element of elements){
        if (!$07c78e08d1e50b44$export$4c063cf1350e6fed(element)) continue;
        if ($07c78e08d1e50b44$var$isFrame(element) && element.contentDocument) {
            const frameBody = element.contentDocument.body;
            focusableElements.push(...$07c78e08d1e50b44$export$f6768025e418420e(frameBody, {
                getShadowRoot: getShadowRoot
            }));
            continue;
        }
        focusableElements.push(element);
    }
    if (getShadowRoot) return $07c78e08d1e50b44$var$collectElementsWithShadowDOM(focusableElements, getShadowRoot, $07c78e08d1e50b44$export$4c063cf1350e6fed);
    return focusableElements;
};
function $07c78e08d1e50b44$export$4c063cf1350e6fed(element) {
    if (!(0, $2020ec4601cca401$export$1b3bfaa9684536aa)(element) || element.closest("[inert]")) return false;
    return element.matches($07c78e08d1e50b44$var$focusableSelector) && (0, $2020ec4601cca401$export$e989c0fffaa6b27a)(element);
}
function $07c78e08d1e50b44$export$748138f04a69bf21(container, options = {}) {
    const [first] = $07c78e08d1e50b44$export$f6768025e418420e(container, options);
    return first || null;
}
function $07c78e08d1e50b44$export$5f161a4b62f9e29a(container, options = {}) {
    if (!container) return [];
    const { includeContainer: includeContainer, getShadowRoot: getShadowRoot } = options;
    const elements = Array.from(container.querySelectorAll($07c78e08d1e50b44$var$focusableSelector));
    if (includeContainer && $07c78e08d1e50b44$export$bebd5a1431fec25d(container)) elements.unshift(container);
    const tabbableElements = [];
    for (const element of elements){
        if (!$07c78e08d1e50b44$export$bebd5a1431fec25d(element)) continue;
        if ($07c78e08d1e50b44$var$isFrame(element) && element.contentDocument) {
            const frameBody = element.contentDocument.body;
            tabbableElements.push(...$07c78e08d1e50b44$export$5f161a4b62f9e29a(frameBody, {
                getShadowRoot: getShadowRoot
            }));
            continue;
        }
        tabbableElements.push(element);
    }
    if (getShadowRoot) {
        const allElements = $07c78e08d1e50b44$var$collectElementsWithShadowDOM(tabbableElements, getShadowRoot, $07c78e08d1e50b44$export$bebd5a1431fec25d);
        if (!allElements.length && includeContainer) return elements;
        return allElements;
    }
    if (!tabbableElements.length && includeContainer) return elements;
    return tabbableElements;
}
function $07c78e08d1e50b44$export$bebd5a1431fec25d(el) {
    if ((0, $2020ec4601cca401$export$1b3bfaa9684536aa)(el) && el.tabIndex > 0) return true;
    if (!$07c78e08d1e50b44$export$4c063cf1350e6fed(el) || $07c78e08d1e50b44$var$hasNegativeTabIndex(el)) return false;
    return $07c78e08d1e50b44$var$isTabbableRadio(el);
}
function $07c78e08d1e50b44$export$9beaf9bf6ff178ae(container, options = {}) {
    const [first] = $07c78e08d1e50b44$export$5f161a4b62f9e29a(container, options);
    return first || null;
}
function $07c78e08d1e50b44$export$73cc6e682b257cff(container, options = {}) {
    const elements = $07c78e08d1e50b44$export$5f161a4b62f9e29a(container, options);
    return elements[elements.length - 1] || null;
}
function $07c78e08d1e50b44$export$1b7701f2d138464c(container, options = {}) {
    const elements = $07c78e08d1e50b44$export$5f161a4b62f9e29a(container, options);
    const first = elements[0] || null;
    const last = elements[elements.length - 1] || null;
    return [
        first,
        last
    ];
}
function $07c78e08d1e50b44$export$28f33206776129a7(container, options = {}) {
    const { current: current, getShadowRoot: getShadowRoot } = options;
    const tabbables = $07c78e08d1e50b44$export$5f161a4b62f9e29a(container, {
        getShadowRoot: getShadowRoot
    });
    const doc = container?.ownerDocument || document;
    const currentElement = current ?? (0, $2020ec4601cca401$export$cd4e5573fbe2b576)(doc);
    if (!currentElement) return null;
    const index = tabbables.indexOf(currentElement);
    return tabbables[index + 1] || null;
}
function $07c78e08d1e50b44$export$a4672efddb4181b8(node) {
    if (node.tabIndex < 0) {
        if (($07c78e08d1e50b44$var$NATURALLY_TABBABLE_REGEX.test(node.localName) || (0, $2020ec4601cca401$export$2780cb57de98fa3a)(node)) && !$07c78e08d1e50b44$var$hasTabIndex(node)) return 0;
    }
    return node.tabIndex;
}


function $0fc785dfc7f02888$export$af1ff6d51ec218ea(options) {
    const { root: root, getInitialEl: getInitialEl, filter: filter, enabled: enabled = true } = options;
    if (!enabled) return;
    let node = null;
    node || (node = typeof getInitialEl === "function" ? getInitialEl() : getInitialEl);
    node || (node = root?.querySelector("[data-autofocus],[autofocus]"));
    if (!node) {
        const tabbables = (0, $07c78e08d1e50b44$export$5f161a4b62f9e29a)(root);
        node = filter ? tabbables.filter(filter)[0] : tabbables[0];
    }
    return node || root || void 0;
}
function $0fc785dfc7f02888$export$605ed6bb305230a3(event) {
    const container = event.currentTarget;
    if (!container) return false;
    const [firstTabbable, lastTabbable] = (0, $07c78e08d1e50b44$export$1b7701f2d138464c)(container);
    if ((0, $2020ec4601cca401$export$8a2eb51c14bb8899)(firstTabbable) && event.shiftKey) return false;
    if ((0, $2020ec4601cca401$export$8a2eb51c14bb8899)(lastTabbable) && !event.shiftKey) return false;
    if (!firstTabbable && !lastTabbable) return false;
    return true;
}


// src/get-styles.ts
// src/middleware.ts
var $a472e305795b1189$var$toVar = (value)=>({
        variable: value,
        reference: `var(${value})`
    });
var $a472e305795b1189$export$fd62969fb0b7081c = {
    arrowSize: $a472e305795b1189$var$toVar("--arrow-size"),
    arrowSizeHalf: $a472e305795b1189$var$toVar("--arrow-size-half"),
    arrowBg: $a472e305795b1189$var$toVar("--arrow-background"),
    transformOrigin: $a472e305795b1189$var$toVar("--transform-origin"),
    arrowOffset: $a472e305795b1189$var$toVar("--arrow-offset")
};
var $a472e305795b1189$var$getSideAxis = (side)=>side === "top" || side === "bottom" ? "y" : "x";
function $a472e305795b1189$export$c1bd4048a8e2d599(opts, arrowEl) {
    return {
        name: "transformOrigin",
        fn (state) {
            const { elements: elements, middlewareData: middlewareData, placement: placement, rects: rects, y: y } = state;
            const side = placement.split("-")[0];
            const axis = $a472e305795b1189$var$getSideAxis(side);
            const arrowX = middlewareData.arrow?.x || 0;
            const arrowY = middlewareData.arrow?.y || 0;
            const arrowWidth = arrowEl?.clientWidth || 0;
            const arrowHeight = arrowEl?.clientHeight || 0;
            const transformX = arrowX + arrowWidth / 2;
            const transformY = arrowY + arrowHeight / 2;
            const shiftY = Math.abs(middlewareData.shift?.y || 0);
            const halfAnchorHeight = rects.reference.height / 2;
            const arrowOffset = arrowHeight / 2;
            const gutter = opts.offset?.mainAxis ?? opts.gutter;
            const sideOffsetValue = typeof gutter === "number" ? gutter + arrowOffset : gutter ?? arrowOffset;
            const isOverlappingAnchor = shiftY > sideOffsetValue;
            const adjacentTransformOrigin = {
                top: `${transformX}px calc(100% + ${sideOffsetValue}px)`,
                bottom: `${transformX}px ${-sideOffsetValue}px`,
                left: `calc(100% + ${sideOffsetValue}px) ${transformY}px`,
                right: `${-sideOffsetValue}px ${transformY}px`
            }[side];
            const overlapTransformOrigin = `${transformX}px ${rects.reference.y + halfAnchorHeight - y}px`;
            const useOverlap = Boolean(opts.overlap) && axis === "y" && isOverlappingAnchor;
            elements.floating.style.setProperty($a472e305795b1189$export$fd62969fb0b7081c.transformOrigin.variable, useOverlap ? overlapTransformOrigin : adjacentTransformOrigin);
            return {
                data: {
                    transformOrigin: useOverlap ? overlapTransformOrigin : adjacentTransformOrigin
                }
            };
        }
    };
}
var $a472e305795b1189$export$f48b311ab78f8eae = {
    name: "rects",
    fn ({ rects: rects }) {
        return {
            data: rects
        };
    }
};
var $a472e305795b1189$export$cb81845185688a22 = (arrowEl)=>{
    if (!arrowEl) return;
    return {
        name: "shiftArrow",
        fn ({ placement: placement, middlewareData: middlewareData }) {
            if (!middlewareData.arrow) return {};
            const { x: x, y: y } = middlewareData.arrow;
            const dir = placement.split("-")[0];
            Object.assign(arrowEl.style, {
                left: x != null ? `${x}px` : "",
                top: y != null ? `${y}px` : "",
                [dir]: `calc(100% + ${$a472e305795b1189$export$fd62969fb0b7081c.arrowOffset.reference})`
            });
            return {};
        }
    };
};


var $c1525c906b88b106$var$ARROW_FLOATING_STYLE = {
    bottom: "rotate(45deg)",
    left: "rotate(135deg)",
    top: "rotate(225deg)",
    right: "rotate(315deg)"
};
function $c1525c906b88b106$export$736498a3bfbba398(options = {}) {
    const { placement: placement, sameWidth: sameWidth, fitViewport: fitViewport, strategy: strategy = "absolute" } = options;
    return {
        arrow: {
            position: "absolute",
            width: (0, $a472e305795b1189$export$fd62969fb0b7081c).arrowSize.reference,
            height: (0, $a472e305795b1189$export$fd62969fb0b7081c).arrowSize.reference,
            [(0, $a472e305795b1189$export$fd62969fb0b7081c).arrowSizeHalf.variable]: `calc(${(0, $a472e305795b1189$export$fd62969fb0b7081c).arrowSize.reference} / 2)`,
            [(0, $a472e305795b1189$export$fd62969fb0b7081c).arrowOffset.variable]: `calc(${(0, $a472e305795b1189$export$fd62969fb0b7081c).arrowSizeHalf.reference} * -1)`
        },
        arrowTip: {
            // @ts-expect-error - Fix this
            transform: placement ? $c1525c906b88b106$var$ARROW_FLOATING_STYLE[placement.split("-")[0]] : void 0,
            background: (0, $a472e305795b1189$export$fd62969fb0b7081c).arrowBg.reference,
            top: "0",
            left: "0",
            width: "100%",
            height: "100%",
            position: "absolute",
            zIndex: "inherit"
        },
        floating: {
            position: strategy,
            isolation: "isolate",
            minWidth: sameWidth ? void 0 : "max-content",
            width: sameWidth ? "var(--reference-width)" : void 0,
            maxWidth: fitViewport ? "var(--available-width)" : void 0,
            maxHeight: fitViewport ? "var(--available-height)" : void 0,
            pointerEvents: !placement ? "none" : void 0,
            top: "0px",
            left: "0px",
            // move off-screen if placement is not defined
            transform: placement ? "translate3d(var(--x), var(--y), 0)" : "translate3d(0, -100vh, 0)",
            zIndex: "var(--z-index)"
        }
    };
}



// src/menu.anatomy.ts

var $b870bcac6acae260$export$477202748c7242bf = (0, $07b08c6ef332e8db$export$197e6e8d4b33fd6c)("menu").parts("arrow", "arrowTip", "content", "contextTrigger", "indicator", "item", "itemGroup", "itemGroupLabel", "itemIndicator", "itemText", "positioner", "separator", "trigger", "triggerItem");
var $b870bcac6acae260$export$6e2410c1d27f06e7 = $b870bcac6acae260$export$477202748c7242bf.build();


// src/menu.dom.ts



// src/query.ts
function $0a4b14a4ad082330$export$dcd0d083aa86c355(root, selector) {
    return Array.from(root?.querySelectorAll(selector) ?? []);
}
function $0a4b14a4ad082330$export$2fa187e846a241c4(root, selector) {
    return root?.querySelector(selector) ?? null;
}
var $0a4b14a4ad082330$export$b1c92eba80c58b85 = (v)=>v.id;
function $0a4b14a4ad082330$export$9c576e34c0103ac9(v, id, itemToId = $0a4b14a4ad082330$export$b1c92eba80c58b85) {
    return v.find((item)=>itemToId(item) === id);
}
function $0a4b14a4ad082330$export$b3919dc3604f191c(v, id, itemToId = $0a4b14a4ad082330$export$b1c92eba80c58b85) {
    const item = $0a4b14a4ad082330$export$9c576e34c0103ac9(v, id, itemToId);
    return item ? v.indexOf(item) : -1;
}
function $0a4b14a4ad082330$export$f3d559454b8c0d00(v, id, loop = true) {
    let idx = $0a4b14a4ad082330$export$b3919dc3604f191c(v, id);
    idx = loop ? (idx + 1) % v.length : Math.min(idx + 1, v.length - 1);
    return v[idx];
}
function $0a4b14a4ad082330$export$326274ae311c62fd(v, id, loop = true) {
    let idx = $0a4b14a4ad082330$export$b3919dc3604f191c(v, id);
    if (idx === -1) return loop ? v[v.length - 1] : null;
    idx = loop ? (idx - 1 + v.length) % v.length : Math.max(0, idx - 1);
    return v[idx];
}



var $9d9cf1e65f835ae9$var$sanitize = (str)=>str.split("").map((char)=>{
        const code = char.charCodeAt(0);
        if (code > 0 && code < 128) return char;
        if (code >= 128 && code <= 255) return `/x${code.toString(16)}`.replace("/", "\\");
        return "";
    }).join("").trim();
var $9d9cf1e65f835ae9$var$getValueText = (el)=>{
    return $9d9cf1e65f835ae9$var$sanitize(el.dataset?.valuetext ?? el.textContent ?? "");
};
var $9d9cf1e65f835ae9$var$match = (valueText, query)=>{
    return valueText.trim().toLowerCase().startsWith(query.toLowerCase());
};
function $9d9cf1e65f835ae9$export$cade8123d3662a60(v, text, currentId, itemToId = (0, $0a4b14a4ad082330$export$b1c92eba80c58b85)) {
    const index = currentId ? (0, $0a4b14a4ad082330$export$b3919dc3604f191c)(v, currentId, itemToId) : -1;
    let items = currentId ? (0, $dbd9babc41e226bd$export$4997ffc0176396a6)(v, index) : v;
    const isSingleKey = text.length === 1;
    if (isSingleKey) items = items.filter((item)=>itemToId(item) !== currentId);
    return items.find((item)=>$9d9cf1e65f835ae9$var$match($9d9cf1e65f835ae9$var$getValueText(item), text));
}


function $003f865683614b2e$var$getByTypeaheadImpl(baseItems, options) {
    const { state: state, activeId: activeId, key: key, timeout: timeout = 350, itemToId: itemToId } = options;
    const search = state.keysSoFar + key;
    const isRepeated = search.length > 1 && Array.from(search).every((char)=>char === search[0]);
    const query = isRepeated ? search[0] : search;
    let items = baseItems.slice();
    const next = (0, $9d9cf1e65f835ae9$export$cade8123d3662a60)(items, query, activeId, itemToId);
    function cleanup() {
        clearTimeout(state.timer);
        state.timer = -1;
    }
    function update(value) {
        state.keysSoFar = value;
        cleanup();
        if (value !== "") state.timer = +setTimeout(()=>{
            update("");
            cleanup();
        }, timeout);
    }
    update(search);
    return next;
}
var $003f865683614b2e$export$ec2dfd1ac255c804 = /* @__PURE__ */ Object.assign($003f865683614b2e$var$getByTypeaheadImpl, {
    defaultOptions: {
        keysSoFar: "",
        timer: -1
    },
    isValidEvent: $003f865683614b2e$var$isValidTypeaheadEvent
});
function $003f865683614b2e$var$isValidTypeaheadEvent(event) {
    return event.key.length === 1 && !event.ctrlKey && !event.metaKey;
}



var $e2a831972683bd14$export$1e04a9a9d2b169fc = (ctx, value)=>{
    const customId = ctx.ids?.trigger;
    if (customId != null) return (0, $9a966d729185a601$export$f6e2535fb5126e54)(customId) ? customId(value) : customId;
    return value ? `menu:${ctx.id}:trigger:${value}` : `menu:${ctx.id}:trigger`;
};
var $e2a831972683bd14$export$bcb585ec9be6f4ce = (ctx, value)=>{
    const customId = ctx.ids?.contextTrigger;
    if (customId != null) return (0, $9a966d729185a601$export$f6e2535fb5126e54)(customId) ? customId(value) : customId;
    return value ? `menu:${ctx.id}:ctx-trigger:${value}` : `menu:${ctx.id}:ctx-trigger`;
};
var $e2a831972683bd14$export$90a11d81f952f37f = (ctx)=>ctx.ids?.content ?? `menu:${ctx.id}:content`;
var $e2a831972683bd14$export$7deab7528f89fcdf = (ctx)=>ctx.ids?.arrow ?? `menu:${ctx.id}:arrow`;
var $e2a831972683bd14$export$4d71d3401bdedcfa = (ctx)=>ctx.ids?.positioner ?? `menu:${ctx.id}:popper`;
var $e2a831972683bd14$export$c90f1d20779795a4 = (ctx, id)=>ctx.ids?.group?.(id) ?? `menu:${ctx.id}:group:${id}`;
var $e2a831972683bd14$export$9145995848b05025 = (ctx, id)=>`${ctx.id}/${id}`;
var $e2a831972683bd14$export$eb68a5138033012f = (el)=>el?.dataset.value ?? null;
var $e2a831972683bd14$export$9b031582742f0867 = (ctx, id)=>ctx.ids?.groupLabel?.(id) ?? `menu:${ctx.id}:group-label:${id}`;
var $e2a831972683bd14$export$64fc6550ad675c6a = (ctx)=>ctx.getById($e2a831972683bd14$export$90a11d81f952f37f(ctx));
var $e2a831972683bd14$export$804920e034783925 = (ctx)=>ctx.getById($e2a831972683bd14$export$4d71d3401bdedcfa(ctx));
var $e2a831972683bd14$export$12a544abb5462f68 = (ctx)=>ctx.getById($e2a831972683bd14$export$1e04a9a9d2b169fc(ctx));
var $e2a831972683bd14$export$6e8e39b439e87795 = (ctx, value)=>value ? ctx.getById($e2a831972683bd14$export$9145995848b05025(ctx, value)) : null;
var $e2a831972683bd14$export$4f67fcfead07c2c8 = (ctx)=>ctx.getById($e2a831972683bd14$export$7deab7528f89fcdf(ctx));
var $e2a831972683bd14$export$c494aba29bd73987 = (ctx)=>ctx.getById($e2a831972683bd14$export$bcb585ec9be6f4ce(ctx));
var $e2a831972683bd14$export$cb60912464303603 = (ctx)=>(0, $0a4b14a4ad082330$export$dcd0d083aa86c355)(ctx.getDoc(), `[data-scope="menu"][data-part="trigger"][data-ownedby="${ctx.id}"]`);
var $e2a831972683bd14$export$f457fab4bd77e2ea = (ctx)=>(0, $0a4b14a4ad082330$export$dcd0d083aa86c355)(ctx.getDoc(), `[data-scope="menu"][data-part="context-trigger"][data-ownedby="${ctx.id}"]`);
var $e2a831972683bd14$export$65278ba5d6c7842c = (ctx, value)=>{
    if (value == null) return $e2a831972683bd14$export$12a544abb5462f68(ctx) ?? $e2a831972683bd14$export$cb60912464303603(ctx)[0];
    return ctx.getById($e2a831972683bd14$export$1e04a9a9d2b169fc(ctx, value));
};
var $e2a831972683bd14$export$73eac51a39d6b0eb = (ctx)=>{
    const ownerId = CSS.escape($e2a831972683bd14$export$90a11d81f952f37f(ctx));
    const selector = `[role^="menuitem"][data-ownedby=${ownerId}]:not([data-disabled])`;
    return (0, $0a4b14a4ad082330$export$dcd0d083aa86c355)($e2a831972683bd14$export$64fc6550ad675c6a(ctx), selector);
};
var $e2a831972683bd14$export$b14393ce5c5ed429 = (ctx)=>(0, $94dddd4ee90a9c15$export$43128fadae87b74a)($e2a831972683bd14$export$73eac51a39d6b0eb(ctx));
var $e2a831972683bd14$export$469c33ba501dacae = (ctx)=>(0, $94dddd4ee90a9c15$export$4c7897fafd92b108)($e2a831972683bd14$export$73eac51a39d6b0eb(ctx));
var $e2a831972683bd14$var$isMatch = (el, value)=>{
    if (!value) return false;
    return el.id === value || el.dataset.value === value;
};
var $e2a831972683bd14$export$cd67ed7569e5b07c = (ctx, opts)=>{
    const items = $e2a831972683bd14$export$73eac51a39d6b0eb(ctx);
    const index = items.findIndex((el)=>$e2a831972683bd14$var$isMatch(el, opts.value));
    return (0, $94dddd4ee90a9c15$export$48cfd1e771a65c4f)(items, index, {
        loop: opts.loop ?? opts.loopFocus
    });
};
var $e2a831972683bd14$export$b4cefc370d4fb9bf = (ctx, opts)=>{
    const items = $e2a831972683bd14$export$73eac51a39d6b0eb(ctx);
    const index = items.findIndex((el)=>$e2a831972683bd14$var$isMatch(el, opts.value));
    return (0, $94dddd4ee90a9c15$export$232faf9add678146)(items, index, {
        loop: opts.loop ?? opts.loopFocus
    });
};
var $e2a831972683bd14$export$a4c95f003f8db604 = (ctx, opts)=>{
    const items = $e2a831972683bd14$export$73eac51a39d6b0eb(ctx);
    const item = items.find((el)=>$e2a831972683bd14$var$isMatch(el, opts.value));
    return (0, $003f865683614b2e$export$ec2dfd1ac255c804)(items, {
        state: opts.typeaheadState,
        key: opts.key,
        activeId: item?.id ?? null
    });
};
var $e2a831972683bd14$export$5e974ee4c432c2f6 = (v)=>{
    return (0, $2020ec4601cca401$export$1b3bfaa9684536aa)(v) && (v.dataset.disabled === "" || v.hasAttribute("disabled"));
};
var $e2a831972683bd14$export$346e78231de82972 = (el)=>{
    return !!el?.getAttribute("role")?.startsWith("menuitem") && !!el?.hasAttribute("data-controls");
};
var $e2a831972683bd14$export$ee7fbbaabbf67d41 = (el)=>{
    return {
        id: el.id,
        name: el.dataset.name,
        value: el.dataset.value,
        valueText: el.dataset.valueText,
        type: el.dataset.type
    };
};
var $e2a831972683bd14$export$b1c01a0ddb678327 = "menu:select";
function $e2a831972683bd14$export$95d5aa9cdb910210(el, value) {
    if (!el) return;
    const win = (0, $2020ec4601cca401$export$38b2d434cce3ea22)(el);
    const event = new win.CustomEvent($e2a831972683bd14$export$b1c01a0ddb678327, {
        detail: {
            value: value
        }
    });
    el.dispatchEvent(event);
}
function $e2a831972683bd14$var$getPortaledContentEl(scope) {
    const contentId = $e2a831972683bd14$export$90a11d81f952f37f(scope);
    return $e2a831972683bd14$export$64fc6550ad675c6a(scope) ?? scope.getDoc().getElementById(contentId);
}
function $e2a831972683bd14$export$885fe302e905afa4(target, children) {
    if (!(0, $2020ec4601cca401$export$1b3bfaa9684536aa)(target)) return false;
    for(const id in children){
        const child = children[id];
        const childContent = $e2a831972683bd14$var$getPortaledContentEl(child.scope);
        if (childContent && (0, $2020ec4601cca401$export$2344b14b097df817)(childContent, target)) return true;
        const nested = child.refs.get("children");
        if (Object.keys(nested).length > 0 && $e2a831972683bd14$export$885fe302e905afa4(target, nested)) return true;
    }
    return false;
}


// src/menu.utils.ts


// src/rect.ts
var $3b9d50b561dcb4ea$export$c139681dc522a264 = (x, y)=>({
        x: x,
        y: y
    });
var $3b9d50b561dcb4ea$export$f5f828077cd06751 = (a, b)=>{
    if (!b) return a;
    return $3b9d50b561dcb4ea$export$c139681dc522a264(a.x - b.x, a.y - b.y);
};
var $3b9d50b561dcb4ea$export$bf5bf75051d7b104 = (a, b)=>$3b9d50b561dcb4ea$export$c139681dc522a264(a.x + b.x, a.y + b.y);
function $3b9d50b561dcb4ea$export$aff838a5553f2a92(v) {
    return Reflect.has(v, "x") && Reflect.has(v, "y");
}
function $3b9d50b561dcb4ea$export$bd5271f935fe8c1a(r) {
    const { x: x, y: y, width: width, height: height } = r;
    const midX = x + width / 2;
    const midY = y + height / 2;
    return {
        x: x,
        y: y,
        width: width,
        height: height,
        minX: x,
        minY: y,
        maxX: x + width,
        maxY: y + height,
        midX: midX,
        midY: midY,
        center: $3b9d50b561dcb4ea$export$c139681dc522a264(midX, midY)
    };
}
function $3b9d50b561dcb4ea$export$707a34ba392ff427(v) {
    return Reflect.has(v, "x") && Reflect.has(v, "y") && Reflect.has(v, "width") && Reflect.has(v, "height");
}
function $3b9d50b561dcb4ea$export$34bf3eeb6c129ebd(v) {
    const top = $3b9d50b561dcb4ea$export$c139681dc522a264(v.midX, v.minY);
    const right = $3b9d50b561dcb4ea$export$c139681dc522a264(v.maxX, v.midY);
    const bottom = $3b9d50b561dcb4ea$export$c139681dc522a264(v.midX, v.maxY);
    const left = $3b9d50b561dcb4ea$export$c139681dc522a264(v.minX, v.midY);
    return {
        top: top,
        right: right,
        bottom: bottom,
        left: left
    };
}
function $3b9d50b561dcb4ea$export$2f7bf41810db260c(v) {
    const top = $3b9d50b561dcb4ea$export$c139681dc522a264(v.minX, v.minY);
    const right = $3b9d50b561dcb4ea$export$c139681dc522a264(v.maxX, v.minY);
    const bottom = $3b9d50b561dcb4ea$export$c139681dc522a264(v.maxX, v.maxY);
    const left = $3b9d50b561dcb4ea$export$c139681dc522a264(v.minX, v.maxY);
    return {
        top: top,
        right: right,
        bottom: bottom,
        left: left
    };
}
function $3b9d50b561dcb4ea$export$8edcba27febab644(v) {
    const c = $3b9d50b561dcb4ea$export$2f7bf41810db260c(v);
    const top = [
        c.top,
        c.right
    ];
    const right = [
        c.right,
        c.bottom
    ];
    const bottom = [
        c.left,
        c.bottom
    ];
    const left = [
        c.top,
        c.left
    ];
    return {
        top: top,
        right: right,
        bottom: bottom,
        left: left
    };
}


function $cfeed72c908c33f9$export$a818e5abc94ef05a(rectValue, placement) {
    const rect = (0, $3b9d50b561dcb4ea$export$bd5271f935fe8c1a)(rectValue);
    const { top: top, right: right, left: left, bottom: bottom } = (0, $3b9d50b561dcb4ea$export$2f7bf41810db260c)(rect);
    const [base] = placement.split("-");
    return ({
        top: [
            left,
            top,
            right,
            bottom
        ],
        right: [
            top,
            right,
            bottom,
            left
        ],
        bottom: [
            top,
            left,
            bottom,
            right
        ],
        left: [
            right,
            top,
            left,
            bottom
        ]
    })[base];
}
function $cfeed72c908c33f9$export$f1c31811357415ac(polygon, point) {
    const { x: x, y: y } = point;
    let c = false;
    for(let i = 0, j = polygon.length - 1; i < polygon.length; j = i++){
        const xi = polygon[i].x;
        const yi = polygon[i].y;
        const xj = polygon[j].x;
        const yj = polygon[j].y;
        if (yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi) c = !c;
    }
    return c;
}
function $cfeed72c908c33f9$var$createPolygonElement() {
    const id = "debug-polygon";
    const existingPolygon = document.getElementById(id);
    if (existingPolygon) return existingPolygon;
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    Object.assign(svg.style, {
        top: "0",
        left: "0",
        width: "100%",
        height: "100%",
        opacity: "0.15",
        position: "fixed",
        pointerEvents: "none",
        fill: "red"
    });
    const polygon = document.createElementNS("http://www.w3.org/2000/svg", "polygon");
    polygon.setAttribute("id", id);
    polygon.setAttribute("points", "0,0 0,0");
    svg.appendChild(polygon);
    document.body.appendChild(svg);
    return polygon;
}
function $cfeed72c908c33f9$export$ef95a236463e8239(polygon) {
    const el = $cfeed72c908c33f9$var$createPolygonElement();
    const points = polygon.map((point)=>`${point.x},${point.y}`).join(" ");
    el.setAttribute("points", points);
    return ()=>{
        el.remove();
    };
}



function $c141fa4f0b98c2f1$export$a414386e289ef249(ctx) {
    let parent = ctx.parent;
    while(parent && parent.context.get("isSubmenu"))parent = parent.refs.get("parent");
    parent?.send({
        type: "CLOSE"
    });
}
function $c141fa4f0b98c2f1$export$543769d13aa9fabe(polygon, point) {
    if (!polygon) return false;
    return (0, $cfeed72c908c33f9$export$f1c31811357415ac)(polygon, point);
}
function $c141fa4f0b98c2f1$export$2795e608634ff49d(children, value, scope) {
    const hasChildren = Object.keys(children).length > 0;
    if (!value) return null;
    if (!hasChildren) return $e2a831972683bd14$export$9145995848b05025(scope, value);
    for(const id in children){
        const childMenu = children[id];
        const childTriggerId = $e2a831972683bd14$export$1e04a9a9d2b169fc(childMenu.scope);
        if (childTriggerId === value) return childTriggerId;
    }
    return $e2a831972683bd14$export$9145995848b05025(scope, value);
}
function $c141fa4f0b98c2f1$export$8877b15d2440adec(parent, locked) {
    if (!parent) return;
    parent.refs.set("pointerRoutingLocked", locked);
    parent.context.set("pointerRoutingMode", locked ? "locked" : "interactive");
}
function $c141fa4f0b98c2f1$var$isHighlightedItemSubmenuOpen(parent) {
    const highlighted = parent.context.get("highlightedValue");
    if (!highlighted) return false;
    const children = parent.refs.get("children");
    for(const id in children){
        const child = children[id];
        if (!child.state.hasTag("open")) continue;
        if ($e2a831972683bd14$export$1e04a9a9d2b169fc(child.scope) === highlighted) return true;
    }
    return false;
}
function $c141fa4f0b98c2f1$export$497a7b39249085d4(parent, childIsSubmenu) {
    if (!parent) return;
    if (parent.refs.get("pointerRoutingLocked")) return;
    if (childIsSubmenu && $c141fa4f0b98c2f1$var$isHighlightedItemSubmenuOpen(parent)) return;
    $c141fa4f0b98c2f1$export$8877b15d2440adec(parent, false);
}
function $c141fa4f0b98c2f1$export$eada56661b3fb874(parent) {
    if (!parent) return;
    if (!$c141fa4f0b98c2f1$var$isHighlightedItemSubmenuOpen(parent)) $c141fa4f0b98c2f1$export$8877b15d2440adec(parent, false);
}


function $4a7e7d375e0ffad4$export$64605811ab45167f(service, normalize) {
    const { context: context, send: send, state: state, computed: computed, prop: prop, scope: scope } = service;
    const open = state.hasTag("open");
    const isSubmenu = context.get("isSubmenu");
    const isTypingAhead = computed("isTypingAhead");
    const composite = prop("composite");
    const currentPlacement = context.get("currentPlacement");
    const anchorPoint = context.get("anchorPoint");
    const highlightedValue = context.get("highlightedValue");
    const triggerValue = context.get("triggerValue");
    const popperStyles = (0, $c1525c906b88b106$export$736498a3bfbba398)({
        ...prop("positioning"),
        placement: anchorPoint ? "bottom" : currentPlacement
    });
    function getItemState(props) {
        return {
            id: $e2a831972683bd14$export$9145995848b05025(scope, props.value),
            disabled: !!props.disabled,
            highlighted: highlightedValue === props.value
        };
    }
    function getOptionItemProps(props) {
        const valueText = props.valueText ?? props.value;
        return {
            ...props,
            id: props.value,
            valueText: valueText
        };
    }
    function getOptionItemState(props) {
        const itemState = getItemState(getOptionItemProps(props));
        return {
            ...itemState,
            checked: !!props.checked
        };
    }
    function getItemProps(props) {
        const { closeOnSelect: closeOnSelect, valueText: valueText, value: value } = props;
        const itemState = getItemState(props);
        const id = $e2a831972683bd14$export$9145995848b05025(scope, value);
        return normalize.element({
            ...(0, $b870bcac6acae260$export$6e2410c1d27f06e7).item.attrs,
            id: id,
            role: "menuitem",
            "aria-disabled": (0, $dbd9babc41e226bd$export$91a6105db3d4be7b)(itemState.disabled),
            "data-disabled": (0, $dbd9babc41e226bd$export$5cc3b7b83e34ade7)(itemState.disabled),
            "data-ownedby": $e2a831972683bd14$export$90a11d81f952f37f(scope),
            "data-highlighted": (0, $dbd9babc41e226bd$export$5cc3b7b83e34ade7)(itemState.highlighted),
            "data-value": value,
            "data-valuetext": valueText,
            onDragStart (event) {
                const isLink = event.currentTarget.matches("a[href]");
                if (isLink) event.preventDefault();
            },
            onPointerMove (event) {
                if (itemState.disabled) return;
                if (event.pointerType !== "mouse") return;
                const target = event.currentTarget;
                if (itemState.highlighted) return;
                const point = (0, $3921311bf0c8eca9$export$a8637644cbd23a7b)(event);
                send({
                    type: "ITEM_POINTERMOVE",
                    id: id,
                    target: target,
                    closeOnSelect: closeOnSelect,
                    point: point
                });
            },
            onPointerLeave (event) {
                if (itemState.disabled) return;
                if (event.pointerType !== "mouse") return;
                const pointerMoved = service.event.previous()?.type.includes("POINTER");
                if (!pointerMoved) return;
                const target = event.currentTarget;
                send({
                    type: "ITEM_POINTERLEAVE",
                    id: id,
                    target: target,
                    closeOnSelect: closeOnSelect
                });
            },
            onPointerDown (event) {
                if (itemState.disabled) return;
                const target = event.currentTarget;
                send({
                    type: "ITEM_POINTERDOWN",
                    target: target,
                    id: id,
                    closeOnSelect: closeOnSelect
                });
            },
            onClick (event) {
                if ((0, $3921311bf0c8eca9$export$e2c2f0d64f6a549a)(event)) return;
                if ((0, $3921311bf0c8eca9$export$ca85c990e080b373)(event)) return;
                if (itemState.disabled) return;
                const target = event.currentTarget;
                send({
                    type: "ITEM_CLICK",
                    target: target,
                    id: id,
                    closeOnSelect: closeOnSelect
                });
            }
        });
    }
    return {
        highlightedValue: highlightedValue,
        open: open,
        setOpen (nextOpen) {
            const open2 = state.hasTag("open");
            if (open2 === nextOpen) return;
            send({
                type: nextOpen ? "OPEN" : "CLOSE"
            });
        },
        triggerValue: triggerValue,
        setTriggerValue (value) {
            send({
                type: "TRIGGER_VALUE.SET",
                value: value
            });
        },
        setHighlightedValue (value) {
            send({
                type: "HIGHLIGHTED.SET",
                value: value
            });
        },
        setParent (parent) {
            send({
                type: "PARENT.SET",
                value: parent,
                id: parent.prop("id")
            });
        },
        setChild (child) {
            send({
                type: "CHILD.SET",
                value: child,
                id: child.prop("id")
            });
        },
        reposition (options = {}) {
            send({
                type: "POSITIONING.SET",
                options: options
            });
        },
        addItemListener (props) {
            const node = scope.getById(props.id);
            if (!node) return;
            const listener = ()=>props.onSelect?.();
            node.addEventListener($e2a831972683bd14$export$b1c01a0ddb678327, listener);
            return ()=>node.removeEventListener($e2a831972683bd14$export$b1c01a0ddb678327, listener);
        },
        getContextTriggerProps (props = {}) {
            const { value: value } = props;
            const current = value == null ? false : triggerValue === value;
            const contextTriggerId = $e2a831972683bd14$export$bcb585ec9be6f4ce(scope, value);
            return normalize.element({
                ...(0, $b870bcac6acae260$export$6e2410c1d27f06e7).contextTrigger.attrs,
                dir: prop("dir"),
                id: contextTriggerId,
                "data-ownedby": scope.id,
                "data-value": value,
                "data-current": (0, $dbd9babc41e226bd$export$5cc3b7b83e34ade7)(current),
                "data-state": open ? "open" : "closed",
                onPointerDown (event) {
                    if (event.pointerType === "mouse") return;
                    const point = (0, $3921311bf0c8eca9$export$a8637644cbd23a7b)(event);
                    send({
                        type: "CONTEXT_MENU_START",
                        point: point,
                        value: value
                    });
                },
                onPointerCancel (event) {
                    if (event.pointerType === "mouse") return;
                    send({
                        type: "CONTEXT_MENU_CANCEL"
                    });
                },
                onPointerMove (event) {
                    if (event.pointerType === "mouse") return;
                    send({
                        type: "CONTEXT_MENU_CANCEL"
                    });
                },
                onPointerUp (event) {
                    if (event.pointerType === "mouse") return;
                    send({
                        type: "CONTEXT_MENU_CANCEL"
                    });
                },
                onContextMenu (event) {
                    const point = (0, $3921311bf0c8eca9$export$a8637644cbd23a7b)(event);
                    const shouldSwitch = open && value != null && !current;
                    send({
                        type: shouldSwitch ? "TRIGGER_VALUE.SET" : "CONTEXT_MENU",
                        point: point,
                        value: value
                    });
                    event.preventDefault();
                },
                style: {
                    WebkitTouchCallout: "none",
                    WebkitUserSelect: "none",
                    userSelect: "none"
                }
            });
        },
        getTriggerItemProps (childApi) {
            const triggerProps = childApi.getTriggerProps();
            return (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)(getItemProps({
                value: triggerProps.id
            }), triggerProps);
        },
        getTriggerProps (props = {}) {
            const { value: value } = props;
            const current = value == null ? false : triggerValue === value;
            const triggerId = $e2a831972683bd14$export$1e04a9a9d2b169fc(scope, value);
            return normalize.button({
                ...isSubmenu ? (0, $b870bcac6acae260$export$6e2410c1d27f06e7).triggerItem.attrs : (0, $b870bcac6acae260$export$6e2410c1d27f06e7).trigger.attrs,
                "data-placement": context.get("currentPlacement"),
                type: "button",
                dir: prop("dir"),
                id: triggerId,
                // Multi-trigger attributes - only included when value is provided
                ...value != null && {
                    "data-ownedby": scope.id,
                    "data-value": value,
                    "data-current": (0, $dbd9babc41e226bd$export$5cc3b7b83e34ade7)(current)
                },
                "data-uid": prop("id"),
                "aria-haspopup": composite ? "menu" : "dialog",
                "aria-controls": $e2a831972683bd14$export$90a11d81f952f37f(scope),
                "data-controls": $e2a831972683bd14$export$90a11d81f952f37f(scope),
                "aria-expanded": value == null ? open : open && current,
                "data-state": open ? "open" : "closed",
                onPointerMove (event) {
                    if (event.pointerType !== "mouse") return;
                    const disabled = $e2a831972683bd14$export$5e974ee4c432c2f6(event.currentTarget);
                    if (disabled || !isSubmenu) return;
                    const point = (0, $3921311bf0c8eca9$export$a8637644cbd23a7b)(event);
                    send({
                        type: "TRIGGER_POINTERMOVE",
                        target: event.currentTarget,
                        point: point
                    });
                },
                onPointerLeave (event) {
                    if ($e2a831972683bd14$export$5e974ee4c432c2f6(event.currentTarget)) return;
                    if (event.pointerType !== "mouse") return;
                    if (!isSubmenu) return;
                    (0, $c141fa4f0b98c2f1$export$8877b15d2440adec)(service.refs.get("parent"), true);
                    const point = (0, $3921311bf0c8eca9$export$a8637644cbd23a7b)(event);
                    send({
                        type: "TRIGGER_POINTERLEAVE",
                        target: event.currentTarget,
                        point: point
                    });
                },
                onPointerDown (event) {
                    if ($e2a831972683bd14$export$5e974ee4c432c2f6(event.currentTarget)) return;
                    if ((0, $3921311bf0c8eca9$export$6faedb510c176c60)(event)) return;
                    event.preventDefault();
                },
                onClick (event) {
                    if (event.defaultPrevented) return;
                    if ($e2a831972683bd14$export$5e974ee4c432c2f6(event.currentTarget)) return;
                    const shouldSwitch = open && value != null && !current;
                    send({
                        type: shouldSwitch ? "TRIGGER_VALUE.SET" : "TRIGGER_CLICK",
                        target: event.currentTarget,
                        value: value
                    });
                },
                onBlur () {
                    send({
                        type: "TRIGGER_BLUR"
                    });
                },
                onFocus () {
                    send({
                        type: "TRIGGER_FOCUS"
                    });
                },
                onKeyDown (event) {
                    if (event.defaultPrevented) return;
                    const keyMap = {
                        ArrowDown () {
                            send({
                                type: "ARROW_DOWN",
                                value: value
                            });
                        },
                        ArrowUp () {
                            send({
                                type: "ARROW_UP",
                                value: value
                            });
                        },
                        Enter () {
                            send({
                                type: "ARROW_DOWN",
                                src: "enter",
                                value: value
                            });
                        },
                        Space () {
                            send({
                                type: "ARROW_DOWN",
                                src: "space",
                                value: value
                            });
                        }
                    };
                    const key = (0, $3921311bf0c8eca9$export$f7a7490116b79d4d)(event, {
                        orientation: "vertical",
                        dir: prop("dir")
                    });
                    const exec = keyMap[key];
                    if (exec) {
                        event.preventDefault();
                        exec(event);
                    }
                }
            });
        },
        getIndicatorProps () {
            return normalize.element({
                ...(0, $b870bcac6acae260$export$6e2410c1d27f06e7).indicator.attrs,
                dir: prop("dir"),
                "data-state": open ? "open" : "closed"
            });
        },
        getPositionerProps () {
            return normalize.element({
                ...(0, $b870bcac6acae260$export$6e2410c1d27f06e7).positioner.attrs,
                dir: prop("dir"),
                id: $e2a831972683bd14$export$4d71d3401bdedcfa(scope),
                style: popperStyles.floating
            });
        },
        getArrowProps () {
            return normalize.element({
                id: $e2a831972683bd14$export$7deab7528f89fcdf(scope),
                ...(0, $b870bcac6acae260$export$6e2410c1d27f06e7).arrow.attrs,
                dir: prop("dir"),
                style: popperStyles.arrow
            });
        },
        getArrowTipProps () {
            return normalize.element({
                ...(0, $b870bcac6acae260$export$6e2410c1d27f06e7).arrowTip.attrs,
                dir: prop("dir"),
                style: popperStyles.arrowTip
            });
        },
        getContentProps () {
            return normalize.element({
                ...(0, $b870bcac6acae260$export$6e2410c1d27f06e7).content.attrs,
                id: $e2a831972683bd14$export$90a11d81f952f37f(scope),
                "aria-label": prop("aria-label"),
                hidden: !open,
                "data-state": open ? "open" : "closed",
                role: composite ? "menu" : "dialog",
                tabIndex: 0,
                dir: prop("dir"),
                "aria-activedescendant": computed("highlightedId") || void 0,
                "aria-labelledby": anchorPoint ? $e2a831972683bd14$export$bcb585ec9be6f4ce(scope, triggerValue ?? void 0) : $e2a831972683bd14$export$1e04a9a9d2b169fc(scope, triggerValue ?? void 0),
                "data-placement": currentPlacement,
                onPointerEnter (event) {
                    if (event.pointerType !== "mouse") return;
                    send({
                        type: "MENU_POINTERENTER"
                    });
                },
                onKeyDown (event) {
                    if (event.defaultPrevented) return;
                    if (!(0, $2020ec4601cca401$export$2344b14b097df817)(event.currentTarget, (0, $3921311bf0c8eca9$export$e58f029f0fbfdb29)(event))) return;
                    const target = (0, $3921311bf0c8eca9$export$e58f029f0fbfdb29)(event);
                    const sameMenu = target?.closest("[role=menu]") === event.currentTarget || target === event.currentTarget;
                    if (!sameMenu) return;
                    if (event.key === "Tab") {
                        const valid = (0, $0fc785dfc7f02888$export$605ed6bb305230a3)(event);
                        if (!valid) {
                            event.preventDefault();
                            return;
                        }
                    }
                    const keyMap = {
                        ArrowDown () {
                            send({
                                type: "ARROW_DOWN"
                            });
                        },
                        ArrowUp () {
                            send({
                                type: "ARROW_UP"
                            });
                        },
                        ArrowLeft () {
                            send({
                                type: "ARROW_LEFT"
                            });
                        },
                        ArrowRight () {
                            send({
                                type: "ARROW_RIGHT"
                            });
                        },
                        Enter () {
                            send({
                                type: "ENTER"
                            });
                        },
                        Space (event2) {
                            if (isTypingAhead) send({
                                type: "TYPEAHEAD",
                                key: event2.key
                            });
                            else keyMap.Enter?.(event2);
                        },
                        Home () {
                            send({
                                type: "HOME"
                            });
                        },
                        End () {
                            send({
                                type: "END"
                            });
                        }
                    };
                    const key = (0, $3921311bf0c8eca9$export$f7a7490116b79d4d)(event, {
                        dir: prop("dir")
                    });
                    const exec = keyMap[key];
                    if (exec) {
                        exec(event);
                        event.stopPropagation();
                        event.preventDefault();
                        return;
                    }
                    if (!prop("typeahead")) return;
                    if (!(0, $3921311bf0c8eca9$export$b3f2c64190cf8c4)(event)) return;
                    if ((0, $3921311bf0c8eca9$export$90788ad2c69b4f50)(event)) return;
                    if ((0, $2020ec4601cca401$export$2780cb57de98fa3a)(target)) return;
                    send({
                        type: "TYPEAHEAD",
                        key: event.key
                    });
                    event.preventDefault();
                }
            });
        },
        getSeparatorProps () {
            return normalize.element({
                ...(0, $b870bcac6acae260$export$6e2410c1d27f06e7).separator.attrs,
                role: "separator",
                dir: prop("dir"),
                "aria-orientation": "horizontal"
            });
        },
        getItemState: getItemState,
        getItemProps: getItemProps,
        getOptionItemState: getOptionItemState,
        getOptionItemProps (props) {
            const { type: type, disabled: disabled, closeOnSelect: closeOnSelect } = props;
            const option = getOptionItemProps(props);
            const itemState = getOptionItemState(props);
            return {
                ...getItemProps(option),
                ...normalize.element({
                    "data-type": type,
                    ...(0, $b870bcac6acae260$export$6e2410c1d27f06e7).item.attrs,
                    dir: prop("dir"),
                    "data-value": option.value,
                    role: `menuitem${type}`,
                    "aria-checked": !!itemState.checked,
                    "data-state": itemState.checked ? "checked" : "unchecked",
                    onClick (event) {
                        if (disabled) return;
                        if ((0, $3921311bf0c8eca9$export$e2c2f0d64f6a549a)(event)) return;
                        if ((0, $3921311bf0c8eca9$export$ca85c990e080b373)(event)) return;
                        const target = event.currentTarget;
                        send({
                            type: "ITEM_CLICK",
                            target: target,
                            option: option,
                            closeOnSelect: closeOnSelect
                        });
                    }
                })
            };
        },
        getItemIndicatorProps (props) {
            const itemState = getOptionItemState((0, $5246d161dcdee685$export$f2db7d5238e1d23f)(props));
            const dataState = itemState.checked ? "checked" : "unchecked";
            return normalize.element({
                ...(0, $b870bcac6acae260$export$6e2410c1d27f06e7).itemIndicator.attrs,
                dir: prop("dir"),
                "data-disabled": (0, $dbd9babc41e226bd$export$5cc3b7b83e34ade7)(itemState.disabled),
                "data-highlighted": (0, $dbd9babc41e226bd$export$5cc3b7b83e34ade7)(itemState.highlighted),
                "data-state": (0, $9a966d729185a601$export$dd642ef726dcde21)(props, "checked") ? dataState : void 0,
                hidden: (0, $9a966d729185a601$export$dd642ef726dcde21)(props, "checked") ? !itemState.checked : void 0
            });
        },
        getItemTextProps (props) {
            const itemState = getOptionItemState((0, $5246d161dcdee685$export$f2db7d5238e1d23f)(props));
            const dataState = itemState.checked ? "checked" : "unchecked";
            return normalize.element({
                ...(0, $b870bcac6acae260$export$6e2410c1d27f06e7).itemText.attrs,
                dir: prop("dir"),
                "data-disabled": (0, $dbd9babc41e226bd$export$5cc3b7b83e34ade7)(itemState.disabled),
                "data-highlighted": (0, $dbd9babc41e226bd$export$5cc3b7b83e34ade7)(itemState.highlighted),
                "data-state": (0, $9a966d729185a601$export$dd642ef726dcde21)(props, "checked") ? dataState : void 0
            });
        },
        getItemGroupLabelProps (props) {
            return normalize.element({
                ...(0, $b870bcac6acae260$export$6e2410c1d27f06e7).itemGroupLabel.attrs,
                id: $e2a831972683bd14$export$9b031582742f0867(scope, props.htmlFor),
                dir: prop("dir")
            });
        },
        getItemGroupProps (props) {
            return normalize.element({
                id: $e2a831972683bd14$export$c90f1d20779795a4(scope, props.id),
                ...(0, $b870bcac6acae260$export$6e2410c1d27f06e7).itemGroup.attrs,
                dir: prop("dir"),
                "aria-labelledby": $e2a831972683bd14$export$9b031582742f0867(scope, props.id),
                role: "group"
            });
        }
    };
}

// src/menu.machine.ts

// src/dismissable-layer.ts

// src/index.ts


function $fbb58d2afdfa6a78$export$7cd01a57c8ca906c(el) {
    const parentNode = (0, $2020ec4601cca401$export$4e12058fc4d51d56)(el);
    if ((0, $2020ec4601cca401$export$7b296c28e0fa3aed)(parentNode)) return (0, $2020ec4601cca401$export$f65ca476c09acec0)(parentNode).body;
    if ((0, $2020ec4601cca401$export$1b3bfaa9684536aa)(parentNode) && $fbb58d2afdfa6a78$export$989e911fa9af580a(parentNode)) return parentNode;
    return $fbb58d2afdfa6a78$export$7cd01a57c8ca906c(parentNode);
}
function $fbb58d2afdfa6a78$export$3b57c1601291186b(el, list = []) {
    const scrollableAncestor = $fbb58d2afdfa6a78$export$7cd01a57c8ca906c(el);
    const isBody = scrollableAncestor === el.ownerDocument.body;
    const win = (0, $2020ec4601cca401$export$38b2d434cce3ea22)(scrollableAncestor);
    if (isBody) return list.concat(win, win.visualViewport || [], $fbb58d2afdfa6a78$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : []);
    return list.concat(scrollableAncestor, $fbb58d2afdfa6a78$export$3b57c1601291186b(scrollableAncestor, []));
}
var $fbb58d2afdfa6a78$var$getElementRect = (el)=>{
    if ((0, $2020ec4601cca401$export$1b3bfaa9684536aa)(el)) return el.getBoundingClientRect();
    if ((0, $2020ec4601cca401$export$d4522fa375bab361)(el)) return {
        top: 0,
        left: 0,
        bottom: el.height,
        right: el.width
    };
    return {
        top: 0,
        left: 0,
        bottom: el.innerHeight,
        right: el.innerWidth
    };
};
function $fbb58d2afdfa6a78$export$62976f5619263b39(el, ancestor) {
    if (!(0, $2020ec4601cca401$export$1b3bfaa9684536aa)(el)) return true;
    const ancestorRect = $fbb58d2afdfa6a78$var$getElementRect(ancestor);
    const elRect = el.getBoundingClientRect();
    return elRect.top >= ancestorRect.top && elRect.left >= ancestorRect.left && elRect.bottom <= ancestorRect.bottom && elRect.right <= ancestorRect.right;
}
var $fbb58d2afdfa6a78$var$OVERFLOW_RE = /auto|scroll|overlay|hidden|clip/;
var $fbb58d2afdfa6a78$var$nonOverflowValues = /* @__PURE__ */ new Set([
    "inline",
    "contents"
]);
function $fbb58d2afdfa6a78$export$989e911fa9af580a(el) {
    const win = (0, $2020ec4601cca401$export$38b2d434cce3ea22)(el);
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = win.getComputedStyle(el);
    return $fbb58d2afdfa6a78$var$OVERFLOW_RE.test(overflow + overflowY + overflowX) && !$fbb58d2afdfa6a78$var$nonOverflowValues.has(display);
}
function $fbb58d2afdfa6a78$var$isScrollable(el) {
    return el.scrollHeight > el.clientHeight || el.scrollWidth > el.clientWidth;
}
function $fbb58d2afdfa6a78$export$53a0910f038337bd(el, options) {
    const { rootEl: rootEl, ...scrollOptions } = options || {};
    if (!el || !rootEl) return;
    if (!$fbb58d2afdfa6a78$export$989e911fa9af580a(rootEl) || !$fbb58d2afdfa6a78$var$isScrollable(rootEl)) return;
    el.scrollIntoView(scrollOptions);
}
function $fbb58d2afdfa6a78$export$3abe133d5501edeb(element) {
    if ((0, $2020ec4601cca401$export$1b3bfaa9684536aa)(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}



var $912bae6dd4ff9bca$var$INTERACTIVE_CONTAINER_ROLE = /* @__PURE__ */ new Set([
    "menu",
    "listbox",
    "dialog",
    "grid",
    "tree",
    "region"
]);
var $912bae6dd4ff9bca$var$isInteractiveContainerRole = (role)=>$912bae6dd4ff9bca$var$INTERACTIVE_CONTAINER_ROLE.has(role);
var $912bae6dd4ff9bca$var$getAriaControls = (element)=>element.getAttribute("aria-controls")?.split(" ") || [];
function $912bae6dd4ff9bca$export$e5e931dc5029df72(container, element) {
    const visitedIds = /* @__PURE__ */ new Set();
    const rootNode = (0, $2020ec4601cca401$export$9bfe85d84666e58)(container);
    const checkElement = (searchRoot)=>{
        const controllingElements = searchRoot.querySelectorAll("[aria-controls]");
        for (const controller of controllingElements){
            if (controller.getAttribute("aria-expanded") !== "true") continue;
            const controlledIds = $912bae6dd4ff9bca$var$getAriaControls(controller);
            for (const id of controlledIds){
                if (!id || visitedIds.has(id)) continue;
                visitedIds.add(id);
                const controlledElement = rootNode.getElementById(id);
                if (controlledElement) {
                    const role = controlledElement.getAttribute("role");
                    const modal = controlledElement.getAttribute("aria-modal") === "true";
                    if (role && $912bae6dd4ff9bca$var$isInteractiveContainerRole(role) && !modal) {
                        if (controlledElement === element || controlledElement.contains(element)) return true;
                        if (checkElement(controlledElement)) return true;
                    }
                }
            }
        }
        return false;
    };
    return checkElement(container);
}
function $912bae6dd4ff9bca$export$af976ebb0ca4d827(searchRoot, callback) {
    const rootNode = (0, $2020ec4601cca401$export$9bfe85d84666e58)(searchRoot);
    const visitedIds = /* @__PURE__ */ new Set();
    const findRecursive = (root)=>{
        const controllingElements = root.querySelectorAll("[aria-controls]");
        for (const controller of controllingElements){
            if (controller.getAttribute("aria-expanded") !== "true") continue;
            const controlledIds = $912bae6dd4ff9bca$var$getAriaControls(controller);
            for (const id of controlledIds){
                if (!id || visitedIds.has(id)) continue;
                visitedIds.add(id);
                const controlledElement = rootNode.getElementById(id);
                if (controlledElement) {
                    const role = controlledElement.getAttribute("role");
                    const modal = controlledElement.getAttribute("aria-modal") === "true";
                    if (role && $912bae6dd4ff9bca$var$INTERACTIVE_CONTAINER_ROLE.has(role) && !modal) {
                        callback(controlledElement);
                        findRecursive(controlledElement);
                    }
                }
            }
        }
    };
    findRecursive(searchRoot);
}
function $912bae6dd4ff9bca$export$6160e89b490c5e0b(container) {
    const controlledElements = /* @__PURE__ */ new Set();
    $912bae6dd4ff9bca$export$af976ebb0ca4d827(container, (controlledElement)=>{
        if (!container.contains(controlledElement)) controlledElements.add(controlledElement);
    });
    return Array.from(controlledElements);
}
function $912bae6dd4ff9bca$export$af524ad53f2f0d04(element) {
    const role = element.getAttribute("role");
    return Boolean(role && $912bae6dd4ff9bca$var$INTERACTIVE_CONTAINER_ROLE.has(role));
}
function $912bae6dd4ff9bca$export$214b0c6f7e6411bb(element) {
    return element.hasAttribute("aria-controls") && element.getAttribute("aria-expanded") === "true";
}
function $912bae6dd4ff9bca$export$1ebdf3db449817ba(element) {
    if ($912bae6dd4ff9bca$export$214b0c6f7e6411bb(element)) return true;
    return Boolean(element.querySelector?.('[aria-controls][aria-expanded="true"]'));
}
function $912bae6dd4ff9bca$export$144f869056b2a98(element) {
    if (!element.id) return false;
    const rootNode = (0, $2020ec4601cca401$export$9bfe85d84666e58)(element);
    const escapedId = CSS.escape(element.id);
    const selector = `[aria-controls~="${escapedId}"][aria-expanded="true"], [aria-controls="${escapedId}"][aria-expanded="true"]`;
    const controller = rootNode.querySelector(selector);
    return Boolean(controller && $912bae6dd4ff9bca$export$af524ad53f2f0d04(element));
}



// src/frame-utils.ts
function $054bf1b7ec150915$export$2f90922a2c27394f(win) {
    const frames = {
        each (cb) {
            for(let i = 0; i < win.frames?.length; i += 1){
                const frame = win.frames[i];
                if (frame) cb(frame);
            }
        },
        addEventListener (event, listener, options) {
            frames.each((frame)=>{
                try {
                    frame.document.addEventListener(event, listener, options);
                } catch  {}
            });
            return ()=>{
                try {
                    frames.removeEventListener(event, listener, options);
                } catch  {}
            };
        },
        removeEventListener (event, listener, options) {
            frames.each((frame)=>{
                try {
                    frame.document.removeEventListener(event, listener, options);
                } catch  {}
            });
        }
    };
    return frames;
}
function $054bf1b7ec150915$export$b33fe42e38dbfd66(win) {
    const parent = win.frameElement != null ? win.parent : null;
    return {
        addEventListener: (event, listener, options)=>{
            try {
                parent?.addEventListener(event, listener, options);
            } catch  {}
            return ()=>{
                try {
                    parent?.removeEventListener(event, listener, options);
                } catch  {}
            };
        },
        removeEventListener: (event, listener, options)=>{
            try {
                parent?.removeEventListener(event, listener, options);
            } catch  {}
        }
    };
}


var $2961b14a9f6a0993$var$POINTER_OUTSIDE_EVENT = "pointerdown.outside";
var $2961b14a9f6a0993$var$FOCUS_OUTSIDE_EVENT = "focus.outside";
function $2961b14a9f6a0993$var$isComposedPathFocusable(composedPath) {
    for (const node of composedPath){
        if ((0, $2020ec4601cca401$export$1b3bfaa9684536aa)(node) && (0, $07c78e08d1e50b44$export$4c063cf1350e6fed)(node)) return true;
    }
    return false;
}
var $2961b14a9f6a0993$var$isPointerEvent = (event)=>"clientY" in event;
function $2961b14a9f6a0993$var$isEventPointWithin(node, event) {
    if (!$2961b14a9f6a0993$var$isPointerEvent(event) || !node) return false;
    const rect = node.getBoundingClientRect();
    if (rect.width === 0 || rect.height === 0) return false;
    return rect.top <= event.clientY && event.clientY <= rect.top + rect.height && rect.left <= event.clientX && event.clientX <= rect.left + rect.width;
}
function $2961b14a9f6a0993$var$isPointInRect(rect, point) {
    return rect.y <= point.y && point.y <= rect.y + rect.height && rect.x <= point.x && point.x <= rect.x + rect.width;
}
function $2961b14a9f6a0993$var$isEventWithinScrollbar(event, ancestor) {
    if (!ancestor || !$2961b14a9f6a0993$var$isPointerEvent(event)) return false;
    const isScrollableY = ancestor.scrollHeight > ancestor.clientHeight;
    const onScrollbarY = isScrollableY && event.clientX > ancestor.offsetLeft + ancestor.clientWidth;
    const isScrollableX = ancestor.scrollWidth > ancestor.clientWidth;
    const onScrollbarX = isScrollableX && event.clientY > ancestor.offsetTop + ancestor.clientHeight;
    const rect = {
        x: ancestor.offsetLeft,
        y: ancestor.offsetTop,
        width: ancestor.clientWidth + (isScrollableY ? 16 : 0),
        height: ancestor.clientHeight + (isScrollableX ? 16 : 0)
    };
    const point = {
        x: event.clientX,
        y: event.clientY
    };
    if (!$2961b14a9f6a0993$var$isPointInRect(rect, point)) return false;
    return onScrollbarY || onScrollbarX;
}
function $2961b14a9f6a0993$var$trackInteractOutsideImpl(node, options) {
    const { exclude: exclude, onFocusOutside: onFocusOutside, onPointerDownOutside: onPointerDownOutside, onInteractOutside: onInteractOutside, defer: defer, followControlledElements: followControlledElements = true } = options;
    if (!node) return;
    const doc = (0, $2020ec4601cca401$export$f65ca476c09acec0)(node);
    const win = (0, $2020ec4601cca401$export$38b2d434cce3ea22)(node);
    const frames = (0, $054bf1b7ec150915$export$2f90922a2c27394f)(win);
    const parentWin = (0, $054bf1b7ec150915$export$b33fe42e38dbfd66)(win);
    function isEventOutside(event, target) {
        if (!(0, $2020ec4601cca401$export$1b3bfaa9684536aa)(target)) return false;
        if (!target.isConnected) return false;
        if ((0, $2020ec4601cca401$export$2344b14b097df817)(node, target)) return false;
        if ($2961b14a9f6a0993$var$isEventPointWithin(node, event)) return false;
        if (followControlledElements && (0, $912bae6dd4ff9bca$export$e5e931dc5029df72)(node, target)) return false;
        const triggerEl = doc.querySelector(`[aria-controls="${node.id}"]`);
        if (triggerEl) {
            const triggerAncestor = (0, $fbb58d2afdfa6a78$export$7cd01a57c8ca906c)(triggerEl);
            if ($2961b14a9f6a0993$var$isEventWithinScrollbar(event, triggerAncestor)) return false;
        }
        const nodeAncestor = (0, $fbb58d2afdfa6a78$export$7cd01a57c8ca906c)(node);
        if ($2961b14a9f6a0993$var$isEventWithinScrollbar(event, nodeAncestor)) return false;
        return !exclude?.(target);
    }
    const pointerdownCleanups = /* @__PURE__ */ new Set();
    const isInShadowRoot = (0, $2020ec4601cca401$export$af51f0f06c0f328a)(node?.getRootNode());
    let isPointerDown = false;
    function onPointerDown(event) {
        isPointerDown = true;
        const onPointerUp = ()=>{
            isPointerDown = false;
        };
        doc.addEventListener("pointerup", onPointerUp, {
            once: true
        });
        win.addEventListener("pointerup", onPointerUp, {
            once: true
        });
        function handler(clickEvent) {
            const func = defer && !(0, $1bdb5bdc36ac2529$export$a1d0d20ee9546562)() ? (0, $7eacfb22d5a39e52$export$27f233d61a9e2fa4) : (v)=>v();
            const evt = clickEvent ?? event;
            const composedPath = evt?.composedPath?.() ?? [
                evt?.target
            ];
            func(()=>{
                const target = isInShadowRoot ? composedPath[0] : (0, $3921311bf0c8eca9$export$e58f029f0fbfdb29)(event);
                if (!node || !isEventOutside(event, target)) return;
                if (onPointerDownOutside || onInteractOutside) {
                    const handler2 = (0, $5246d161dcdee685$export$9dd9a52f2dd5b9ce)(onPointerDownOutside, onInteractOutside);
                    node.addEventListener($2961b14a9f6a0993$var$POINTER_OUTSIDE_EVENT, handler2, {
                        once: true
                    });
                }
                $2961b14a9f6a0993$var$fireCustomEvent(node, $2961b14a9f6a0993$var$POINTER_OUTSIDE_EVENT, {
                    bubbles: false,
                    cancelable: true,
                    detail: {
                        originalEvent: evt,
                        contextmenu: (0, $3921311bf0c8eca9$export$6faedb510c176c60)(evt),
                        focusable: $2961b14a9f6a0993$var$isComposedPathFocusable(composedPath),
                        target: target
                    }
                });
            });
        }
        if (event.pointerType === "touch") {
            pointerdownCleanups.forEach((fn)=>fn());
            pointerdownCleanups.add((0, $3921311bf0c8eca9$export$b1d829ddf82884aa)(doc, "click", handler, {
                once: true
            }));
            pointerdownCleanups.add(parentWin.addEventListener("click", handler, {
                once: true
            }));
            pointerdownCleanups.add(frames.addEventListener("click", handler, {
                once: true
            }));
        } else handler();
    }
    const cleanups = /* @__PURE__ */ new Set();
    const timer = setTimeout(()=>{
        cleanups.add((0, $3921311bf0c8eca9$export$b1d829ddf82884aa)(doc, "pointerdown", onPointerDown, true));
        cleanups.add(parentWin.addEventListener("pointerdown", onPointerDown, true));
        cleanups.add(frames.addEventListener("pointerdown", onPointerDown, true));
    }, 0);
    function onFocusin(event) {
        if (isPointerDown) return;
        const func = defer ? (0, $7eacfb22d5a39e52$export$27f233d61a9e2fa4) : (v)=>v();
        func(()=>{
            const composedPath = event?.composedPath?.() ?? [
                event?.target
            ];
            const target = isInShadowRoot ? composedPath[0] : (0, $3921311bf0c8eca9$export$e58f029f0fbfdb29)(event);
            if (!node || !isEventOutside(event, target)) return;
            if (onFocusOutside || onInteractOutside) {
                const handler = (0, $5246d161dcdee685$export$9dd9a52f2dd5b9ce)(onFocusOutside, onInteractOutside);
                node.addEventListener($2961b14a9f6a0993$var$FOCUS_OUTSIDE_EVENT, handler, {
                    once: true
                });
            }
            $2961b14a9f6a0993$var$fireCustomEvent(node, $2961b14a9f6a0993$var$FOCUS_OUTSIDE_EVENT, {
                bubbles: false,
                cancelable: true,
                detail: {
                    originalEvent: event,
                    contextmenu: false,
                    focusable: (0, $07c78e08d1e50b44$export$4c063cf1350e6fed)(target),
                    target: target
                }
            });
        });
    }
    if (!(0, $1bdb5bdc36ac2529$export$a1d0d20ee9546562)()) {
        cleanups.add((0, $3921311bf0c8eca9$export$b1d829ddf82884aa)(doc, "focusin", onFocusin, true));
        cleanups.add(parentWin.addEventListener("focusin", onFocusin, true));
        cleanups.add(frames.addEventListener("focusin", onFocusin, true));
    }
    return ()=>{
        clearTimeout(timer);
        pointerdownCleanups.forEach((fn)=>fn());
        cleanups.forEach((fn)=>fn());
    };
}
function $2961b14a9f6a0993$export$15e1dde088f1e162(nodeOrFn, options) {
    const { defer: defer } = options;
    const func = defer ? (0, $7eacfb22d5a39e52$export$27f233d61a9e2fa4) : (v)=>v();
    const cleanups = [];
    cleanups.push(func(()=>{
        const node = typeof nodeOrFn === "function" ? nodeOrFn() : nodeOrFn;
        cleanups.push($2961b14a9f6a0993$var$trackInteractOutsideImpl(node, options));
    }));
    return ()=>{
        cleanups.forEach((fn)=>fn?.());
    };
}
function $2961b14a9f6a0993$var$fireCustomEvent(el, type, init) {
    const win = el.ownerDocument.defaultView || window;
    const event = new win.CustomEvent(type, init);
    return el.dispatchEvent(event);
}



// src/escape-keydown.ts

function $c28407d185931e60$export$ecfbb6c53f825a4b(node, fn) {
    const handleKeyDown = (event)=>{
        if (event.key !== "Escape") return;
        if (event.isComposing) return;
        fn?.(event);
    };
    return (0, $3921311bf0c8eca9$export$b1d829ddf82884aa)((0, $2020ec4601cca401$export$f65ca476c09acec0)(node), "keydown", handleKeyDown, {
        capture: true
    });
}


// src/layer-stack.ts

var $3b4f3edd5b800887$var$LAYER_REQUEST_DISMISS_EVENT = "layer:request-dismiss";
var $3b4f3edd5b800887$export$5eb92e2747fc47de = {
    layers: [],
    branches: [],
    recentlyRemoved: /* @__PURE__ */ new Set(),
    count () {
        return this.layers.length;
    },
    pointerBlockingLayers () {
        return this.layers.filter((layer)=>layer.pointerBlocking);
    },
    topMostPointerBlockingLayer () {
        return [
            ...this.pointerBlockingLayers()
        ].slice(-1)[0];
    },
    hasPointerBlockingLayer () {
        return this.pointerBlockingLayers().length > 0;
    },
    isBelowPointerBlockingLayer (node) {
        const index = this.indexOf(node);
        const highestBlockingIndex = this.topMostPointerBlockingLayer() ? this.indexOf(this.topMostPointerBlockingLayer()?.node) : -1;
        return index < highestBlockingIndex;
    },
    isTopMost (node) {
        const layer = this.layers[this.count() - 1];
        return layer?.node === node;
    },
    getNestedLayers (node) {
        return Array.from(this.layers).slice(this.indexOf(node) + 1);
    },
    getLayersByType (type) {
        return this.layers.filter((layer)=>layer.type === type);
    },
    getNestedLayersByType (node, type) {
        const index = this.indexOf(node);
        if (index === -1) return [];
        return this.layers.slice(index + 1).filter((layer)=>layer.type === type);
    },
    getParentLayerOfType (node, type) {
        const index = this.indexOf(node);
        if (index <= 0) return void 0;
        return this.layers.slice(0, index).reverse().find((layer)=>layer.type === type);
    },
    countNestedLayersOfType (node, type) {
        return this.getNestedLayersByType(node, type).length;
    },
    isInNestedLayer (node, target) {
        const inNested = this.getNestedLayers(node).some((layer)=>(0, $2020ec4601cca401$export$2344b14b097df817)(layer.node, target));
        if (inNested) return true;
        if (this.recentlyRemoved.size > 0) return true;
        return false;
    },
    isInBranch (target) {
        return Array.from(this.branches).some((branch)=>(0, $2020ec4601cca401$export$2344b14b097df817)(branch, target));
    },
    add (layer) {
        this.layers.push(layer);
        this.syncLayers();
    },
    addBranch (node) {
        this.branches.push(node);
    },
    remove (node) {
        const index = this.indexOf(node);
        if (index < 0) return;
        this.recentlyRemoved.add(node);
        (0, $7eacfb22d5a39e52$export$bdd553fddd433dcb)(()=>this.recentlyRemoved.delete(node));
        if (index < this.count() - 1) {
            const _layers = this.getNestedLayers(node);
            _layers.forEach((layer)=>$3b4f3edd5b800887$export$5eb92e2747fc47de.dismiss(layer.node, node));
        }
        this.layers.splice(index, 1);
        this.syncLayers();
    },
    removeBranch (node) {
        const index = this.branches.indexOf(node);
        if (index >= 0) this.branches.splice(index, 1);
    },
    syncLayers () {
        this.layers.forEach((layer, index)=>{
            layer.node.style.setProperty("--layer-index", `${index}`);
            layer.node.removeAttribute("data-nested");
            layer.node.removeAttribute("data-has-nested");
            const parentOfSameType = this.getParentLayerOfType(layer.node, layer.type);
            if (parentOfSameType) layer.node.setAttribute("data-nested", layer.type);
            const nestedCount = this.countNestedLayersOfType(layer.node, layer.type);
            if (nestedCount > 0) layer.node.setAttribute("data-has-nested", layer.type);
            layer.node.style.setProperty("--nested-layer-count", `${nestedCount}`);
        });
    },
    indexOf (node) {
        return this.layers.findIndex((layer)=>layer.node === node);
    },
    dismiss (node, parent) {
        const index = this.indexOf(node);
        if (index === -1) return;
        const layer = this.layers[index];
        $3b4f3edd5b800887$var$addListenerOnce(node, $3b4f3edd5b800887$var$LAYER_REQUEST_DISMISS_EVENT, (event)=>{
            layer.requestDismiss?.(event);
            if (!event.defaultPrevented) layer?.dismiss();
        });
        $3b4f3edd5b800887$var$fireCustomEvent(node, $3b4f3edd5b800887$var$LAYER_REQUEST_DISMISS_EVENT, {
            originalLayer: node,
            targetLayer: parent,
            originalIndex: index,
            targetIndex: parent ? this.indexOf(parent) : -1
        });
        this.syncLayers();
    },
    clear () {
        this.remove(this.layers[0].node);
    }
};
function $3b4f3edd5b800887$var$fireCustomEvent(el, type, detail) {
    const win = el.ownerDocument.defaultView || window;
    const event = new win.CustomEvent(type, {
        cancelable: true,
        bubbles: true,
        detail: detail
    });
    return el.dispatchEvent(event);
}
function $3b4f3edd5b800887$var$addListenerOnce(el, type, callback) {
    el.addEventListener(type, callback, {
        once: true
    });
}


// src/pointer-event-outside.ts


function $f4f5183e05a42759$export$8ff1eaf047b0904b(promise, controller, timeout) {
    const { signal: signal } = controller;
    const wrappedPromise = new Promise((resolve, reject)=>{
        const timeoutId = setTimeout(()=>{
            reject(new Error(`Timeout of ${timeout}ms exceeded`));
        }, timeout);
        signal.addEventListener("abort", ()=>{
            clearTimeout(timeoutId);
            reject(new DOMException("Promise aborted", "AbortError"));
        });
        promise.then((result)=>{
            if (!signal.aborted) {
                clearTimeout(timeoutId);
                resolve(result);
            }
        }).catch((error)=>{
            if (!signal.aborted) {
                clearTimeout(timeoutId);
                reject(error);
            }
        });
    });
    const abort = ()=>controller.abort();
    return [
        wrappedPromise,
        abort
    ];
}
function $f4f5183e05a42759$export$1a1c301579a08d1e(target, options) {
    const { timeout: timeout, rootNode: rootNode } = options;
    const win = (0, $2020ec4601cca401$export$38b2d434cce3ea22)(rootNode);
    const doc = (0, $2020ec4601cca401$export$f65ca476c09acec0)(rootNode);
    const controller = new win.AbortController();
    return $f4f5183e05a42759$export$8ff1eaf047b0904b(new Promise((resolve)=>{
        const el = target();
        if (el) {
            resolve(el);
            return;
        }
        const observer = new win.MutationObserver(()=>{
            const el2 = target();
            if (el2 && el2.isConnected) {
                observer.disconnect();
                resolve(el2);
            }
        });
        observer.observe(doc.body, {
            childList: true,
            subtree: true
        });
    }), controller, timeout);
}
function $f4f5183e05a42759$export$6608ab6fe9313967(target, event, options) {
    let cleanup;
    const { predicate: predicate, ...listenerOptions } = options ?? {};
    const promise = new Promise((resolve)=>{
        const element = target?.();
        if (!element) return;
        const handler = (e)=>{
            if (!predicate || predicate(element)) {
                resolve(e);
                cleanup?.();
            }
        };
        element.addEventListener(event, handler, listenerOptions);
        cleanup = ()=>element.removeEventListener(event, handler, listenerOptions);
    });
    return [
        promise,
        ()=>cleanup?.()
    ];
}



var $f6587e4d20d11bd9$var$originalBodyPointerEvents;
function $f6587e4d20d11bd9$export$e1e35978c45ff2b9() {
    (0, $3b4f3edd5b800887$export$5eb92e2747fc47de).layers.forEach(({ node: node })=>{
        node.style.pointerEvents = (0, $3b4f3edd5b800887$export$5eb92e2747fc47de).isBelowPointerBlockingLayer(node) ? "none" : "auto";
    });
}
function $f6587e4d20d11bd9$export$ce5cf54942f90ce7(node) {
    node.style.pointerEvents = "";
}
function $f6587e4d20d11bd9$export$25c9772fb839447d(node, persistentElements) {
    const doc = (0, $2020ec4601cca401$export$f65ca476c09acec0)(node);
    const cleanups = [];
    if ((0, $3b4f3edd5b800887$export$5eb92e2747fc47de).hasPointerBlockingLayer() && !doc.body.hasAttribute("data-inert")) {
        $f6587e4d20d11bd9$var$originalBodyPointerEvents = document.body.style.pointerEvents;
        queueMicrotask(()=>{
            doc.body.style.pointerEvents = "none";
            doc.body.setAttribute("data-inert", "");
        });
    }
    persistentElements?.forEach((el)=>{
        const [promise, abort] = (0, $f4f5183e05a42759$export$1a1c301579a08d1e)(()=>{
            const node2 = el();
            return (0, $2020ec4601cca401$export$1b3bfaa9684536aa)(node2) ? node2 : null;
        }, {
            timeout: 1e3
        });
        promise.then((el2)=>cleanups.push((0, $7ac6bc7380fa7b77$export$37a5fde709c1db82)(el2, {
                pointerEvents: "auto"
            })));
        cleanups.push(abort);
    });
    return ()=>{
        if ((0, $3b4f3edd5b800887$export$5eb92e2747fc47de).hasPointerBlockingLayer()) return;
        queueMicrotask(()=>{
            doc.body.style.pointerEvents = $f6587e4d20d11bd9$var$originalBodyPointerEvents;
            doc.body.removeAttribute("data-inert");
            if (doc.body.style.length === 0) doc.body.removeAttribute("style");
        });
        cleanups.forEach((fn)=>fn());
    };
}


function $1492ced6e5ccca82$var$trackDismissableElementImpl(node, options) {
    const { warnOnMissingNode: warnOnMissingNode = true } = options;
    if (warnOnMissingNode && !node) {
        (0, $db2b97a8c70ba27b$export$c106dd0671a0fc2d)("[@zag-js/dismissable] node is `null` or `undefined`");
        return;
    }
    if (!node) return;
    const { onDismiss: onDismiss, onRequestDismiss: onRequestDismiss, pointerBlocking: pointerBlocking, exclude: excludeContainers, debug: debug, type: type = "dialog" } = options;
    const layer = {
        dismiss: onDismiss,
        node: node,
        type: type,
        pointerBlocking: pointerBlocking,
        requestDismiss: onRequestDismiss
    };
    (0, $3b4f3edd5b800887$export$5eb92e2747fc47de).add(layer);
    (0, $f6587e4d20d11bd9$export$e1e35978c45ff2b9)();
    function onPointerDownOutside(event) {
        const target = (0, $3921311bf0c8eca9$export$e58f029f0fbfdb29)(event.detail.originalEvent);
        if ((0, $3b4f3edd5b800887$export$5eb92e2747fc47de).isBelowPointerBlockingLayer(node) || (0, $3b4f3edd5b800887$export$5eb92e2747fc47de).isInBranch(target)) return;
        options.onPointerDownOutside?.(event);
        options.onInteractOutside?.(event);
        if (event.defaultPrevented) return;
        if (debug) console.log("onPointerDownOutside:", event.detail.originalEvent);
        onDismiss?.();
    }
    function onFocusOutside(event) {
        const target = (0, $3921311bf0c8eca9$export$e58f029f0fbfdb29)(event.detail.originalEvent);
        if ((0, $3b4f3edd5b800887$export$5eb92e2747fc47de).isInBranch(target)) return;
        options.onFocusOutside?.(event);
        options.onInteractOutside?.(event);
        if (event.defaultPrevented) return;
        if (debug) console.log("onFocusOutside:", event.detail.originalEvent);
        onDismiss?.();
    }
    function onEscapeKeyDown(event) {
        if (!(0, $3b4f3edd5b800887$export$5eb92e2747fc47de).isTopMost(node)) return;
        options.onEscapeKeyDown?.(event);
        if (!event.defaultPrevented && onDismiss) {
            event.preventDefault();
            onDismiss();
        }
    }
    function exclude(target) {
        if (!node) return false;
        const containers = typeof excludeContainers === "function" ? excludeContainers() : excludeContainers;
        const _containers = Array.isArray(containers) ? containers : [
            containers
        ];
        const persistentElements = options.persistentElements?.map((fn)=>fn()).filter((0, $2020ec4601cca401$export$1b3bfaa9684536aa));
        if (persistentElements) _containers.push(...persistentElements);
        return _containers.some((node2)=>(0, $2020ec4601cca401$export$2344b14b097df817)(node2, target)) || (0, $3b4f3edd5b800887$export$5eb92e2747fc47de).isInNestedLayer(node, target);
    }
    const cleanups = [
        pointerBlocking ? (0, $f6587e4d20d11bd9$export$25c9772fb839447d)(node, options.persistentElements) : void 0,
        (0, $c28407d185931e60$export$ecfbb6c53f825a4b)(node, onEscapeKeyDown),
        (0, $2961b14a9f6a0993$export$15e1dde088f1e162)(node, {
            exclude: exclude,
            onFocusOutside: onFocusOutside,
            onPointerDownOutside: onPointerDownOutside,
            defer: options.defer
        })
    ];
    return ()=>{
        (0, $3b4f3edd5b800887$export$5eb92e2747fc47de).remove(node);
        (0, $f6587e4d20d11bd9$export$e1e35978c45ff2b9)();
        (0, $f6587e4d20d11bd9$export$ce5cf54942f90ce7)(node);
        cleanups.forEach((fn)=>fn?.());
    };
}
function $1492ced6e5ccca82$export$72bda0e502b8ea31(nodeOrFn, options) {
    const { defer: defer } = options;
    const func = defer ? (0, $7eacfb22d5a39e52$export$27f233d61a9e2fa4) : (v)=>v();
    const cleanups = [];
    cleanups.push(func(()=>{
        const node = (0, $9a966d729185a601$export$f6e2535fb5126e54)(nodeOrFn) ? nodeOrFn() : nodeOrFn;
        cleanups.push($1492ced6e5ccca82$var$trackDismissableElementImpl(node, options));
    }));
    return ()=>{
        cleanups.forEach((fn)=>fn?.());
    };
}
function $1492ced6e5ccca82$export$42019839bfd578e2(nodeOrFn, options = {}) {
    const { defer: defer } = options;
    const func = defer ? (0, $7eacfb22d5a39e52$export$27f233d61a9e2fa4) : (v)=>v();
    const cleanups = [];
    cleanups.push(func(()=>{
        const node = (0, $9a966d729185a601$export$f6e2535fb5126e54)(nodeOrFn) ? nodeOrFn() : nodeOrFn;
        if (!node) {
            (0, $db2b97a8c70ba27b$export$c106dd0671a0fc2d)("[@zag-js/dismissable] branch node is `null` or `undefined`");
            return;
        }
        (0, $3b4f3edd5b800887$export$5eb92e2747fc47de).addBranch(node);
        cleanups.push(()=>{
            (0, $3b4f3edd5b800887$export$5eb92e2747fc47de).removeBranch(node);
        });
    }));
    return ()=>{
        cleanups.forEach((fn)=>fn?.());
    };
}






function $4583cdbeefbe32b8$export$ff7962acd6052c28(items, current, options = {}) {
    if (!current) return null;
    const { orientation: orientation = "both", loop: loop = true, dir: dir = "ltr", key: key } = options;
    if (!items.length || !key) return null;
    const isVertical = key === "ArrowUp" || key === "ArrowDown";
    const isHorizontal = key === "ArrowLeft" || key === "ArrowRight";
    if (!isVertical && !isHorizontal && key !== "Home" && key !== "End") return null;
    if (orientation === "vertical" && isHorizontal || orientation === "horizontal" && isVertical) return null;
    if (key === "Home") return items[0] || null;
    if (key === "End") return items[items.length - 1] || null;
    const idx = items.indexOf(current);
    if (idx === -1) return null;
    let isForward;
    if (orientation === "both") isForward = key === "ArrowDown" || (dir === "ltr" ? key === "ArrowRight" : key === "ArrowLeft");
    else isForward = isVertical ? key === "ArrowDown" : dir === "ltr" ? key === "ArrowRight" : key === "ArrowLeft";
    const nextIdx = isForward ? loop ? (idx + 1) % items.length : Math.min(idx + 1, items.length - 1) : loop ? (idx - 1 + items.length) % items.length : Math.max(0, idx - 1);
    return items[nextIdx] || null;
}
function $4583cdbeefbe32b8$export$e91dc30618113dbe(el) {
    const click = ()=>{
        const win = (0, $2020ec4601cca401$export$38b2d434cce3ea22)(el);
        el.dispatchEvent(new win.MouseEvent("click"));
    };
    if ((0, $1bdb5bdc36ac2529$export$b7d78993b74f766d)()) (0, $7eacfb22d5a39e52$export$77d693d38001d697)(el, "keyup", click);
    else queueMicrotask(click);
}


// src/index.ts

function $855e001ba27d7a0a$var$isValidKey(e) {
    return !(e.metaKey || !(0, $1bdb5bdc36ac2529$export$9ac100e40613ea10)() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
var $855e001ba27d7a0a$var$nonTextInputTypes = /* @__PURE__ */ new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
function $855e001ba27d7a0a$var$isKeyboardFocusEvent(isTextInput, modality, e) {
    const eventTarget = e ? (0, $3921311bf0c8eca9$export$e58f029f0fbfdb29)(e) : null;
    const doc = (0, $2020ec4601cca401$export$f65ca476c09acec0)(eventTarget);
    const win = (0, $2020ec4601cca401$export$38b2d434cce3ea22)(eventTarget);
    const activeElement = (0, $2020ec4601cca401$export$cd4e5573fbe2b576)(doc);
    isTextInput = isTextInput || activeElement instanceof win.HTMLInputElement && !$855e001ba27d7a0a$var$nonTextInputTypes.has(activeElement?.type) || activeElement instanceof win.HTMLTextAreaElement || activeElement instanceof win.HTMLElement && activeElement.isContentEditable;
    return !(isTextInput && modality === "keyboard" && e instanceof win.KeyboardEvent && !Reflect.has($855e001ba27d7a0a$var$FOCUS_VISIBLE_INPUT_KEYS, e.key));
}
var $855e001ba27d7a0a$var$currentModality = null;
var $855e001ba27d7a0a$var$changeHandlers = /* @__PURE__ */ new Set();
var $855e001ba27d7a0a$export$b9f54f824a756af3 = /* @__PURE__ */ new Map();
var $855e001ba27d7a0a$var$hasEventBeforeFocus = false;
var $855e001ba27d7a0a$var$hasBlurredWindowRecently = false;
var $855e001ba27d7a0a$export$fda7da73ab5d4c48 = false;
var $855e001ba27d7a0a$var$FOCUS_VISIBLE_INPUT_KEYS = {
    Tab: true,
    Escape: true
};
function $855e001ba27d7a0a$var$triggerChangeHandlers(modality, e) {
    for (let handler of $855e001ba27d7a0a$var$changeHandlers)handler(modality, e);
}
function $855e001ba27d7a0a$var$handleKeyboardEvent(e) {
    $855e001ba27d7a0a$var$hasEventBeforeFocus = true;
    if ($855e001ba27d7a0a$var$isValidKey(e)) {
        $855e001ba27d7a0a$var$currentModality = "keyboard";
        $855e001ba27d7a0a$var$triggerChangeHandlers("keyboard", e);
    }
}
function $855e001ba27d7a0a$var$handlePointerEvent(e) {
    $855e001ba27d7a0a$var$currentModality = "pointer";
    if (e.type === "mousedown" || e.type === "pointerdown") {
        $855e001ba27d7a0a$var$hasEventBeforeFocus = true;
        $855e001ba27d7a0a$var$triggerChangeHandlers("pointer", e);
    }
}
function $855e001ba27d7a0a$var$handleClickEvent(e) {
    if ((0, $3921311bf0c8eca9$export$60278871457622de)(e)) {
        $855e001ba27d7a0a$var$hasEventBeforeFocus = true;
        $855e001ba27d7a0a$var$currentModality = "virtual";
    }
}
function $855e001ba27d7a0a$var$handleFocusEvent(e) {
    const target = (0, $3921311bf0c8eca9$export$e58f029f0fbfdb29)(e);
    if (target === (0, $2020ec4601cca401$export$38b2d434cce3ea22)(target) || target === (0, $2020ec4601cca401$export$f65ca476c09acec0)(target) || $855e001ba27d7a0a$export$fda7da73ab5d4c48 || !e.isTrusted) return;
    if (!$855e001ba27d7a0a$var$hasEventBeforeFocus && !$855e001ba27d7a0a$var$hasBlurredWindowRecently) {
        $855e001ba27d7a0a$var$currentModality = "virtual";
        $855e001ba27d7a0a$var$triggerChangeHandlers("virtual", e);
    }
    $855e001ba27d7a0a$var$hasEventBeforeFocus = false;
    $855e001ba27d7a0a$var$hasBlurredWindowRecently = false;
}
function $855e001ba27d7a0a$var$handleWindowBlur() {
    if ($855e001ba27d7a0a$export$fda7da73ab5d4c48) return;
    $855e001ba27d7a0a$var$hasEventBeforeFocus = false;
    $855e001ba27d7a0a$var$hasBlurredWindowRecently = true;
}
function $855e001ba27d7a0a$var$setupGlobalFocusEvents(root) {
    if (typeof window === "undefined" || $855e001ba27d7a0a$export$b9f54f824a756af3.get((0, $2020ec4601cca401$export$38b2d434cce3ea22)(root))) return;
    const win = (0, $2020ec4601cca401$export$38b2d434cce3ea22)(root);
    const doc = (0, $2020ec4601cca401$export$f65ca476c09acec0)(root);
    let focus = win.HTMLElement.prototype.focus;
    function patchedFocus() {
        $855e001ba27d7a0a$var$hasEventBeforeFocus = true;
        focus.apply(this, arguments);
    }
    try {
        Object.defineProperty(win.HTMLElement.prototype, "focus", {
            configurable: true,
            value: patchedFocus
        });
    } catch  {}
    doc.addEventListener("keydown", $855e001ba27d7a0a$var$handleKeyboardEvent, true);
    doc.addEventListener("keyup", $855e001ba27d7a0a$var$handleKeyboardEvent, true);
    doc.addEventListener("click", $855e001ba27d7a0a$var$handleClickEvent, true);
    win.addEventListener("focus", $855e001ba27d7a0a$var$handleFocusEvent, true);
    win.addEventListener("blur", $855e001ba27d7a0a$var$handleWindowBlur, false);
    if (typeof win.PointerEvent !== "undefined") {
        doc.addEventListener("pointerdown", $855e001ba27d7a0a$var$handlePointerEvent, true);
        doc.addEventListener("pointermove", $855e001ba27d7a0a$var$handlePointerEvent, true);
        doc.addEventListener("pointerup", $855e001ba27d7a0a$var$handlePointerEvent, true);
    } else {
        doc.addEventListener("mousedown", $855e001ba27d7a0a$var$handlePointerEvent, true);
        doc.addEventListener("mousemove", $855e001ba27d7a0a$var$handlePointerEvent, true);
        doc.addEventListener("mouseup", $855e001ba27d7a0a$var$handlePointerEvent, true);
    }
    win.addEventListener("beforeunload", ()=>{
        $855e001ba27d7a0a$var$tearDownWindowFocusTracking(root);
    }, {
        once: true
    });
    $855e001ba27d7a0a$export$b9f54f824a756af3.set(win, {
        focus: focus
    });
}
var $855e001ba27d7a0a$var$tearDownWindowFocusTracking = (root, loadListener)=>{
    const win = (0, $2020ec4601cca401$export$38b2d434cce3ea22)(root);
    const doc = (0, $2020ec4601cca401$export$f65ca476c09acec0)(root);
    if (loadListener) doc.removeEventListener("DOMContentLoaded", loadListener);
    const listenerData = $855e001ba27d7a0a$export$b9f54f824a756af3.get(win);
    if (!listenerData) return;
    try {
        Object.defineProperty(win.HTMLElement.prototype, "focus", {
            configurable: true,
            value: listenerData.focus
        });
    } catch  {}
    doc.removeEventListener("keydown", $855e001ba27d7a0a$var$handleKeyboardEvent, true);
    doc.removeEventListener("keyup", $855e001ba27d7a0a$var$handleKeyboardEvent, true);
    doc.removeEventListener("click", $855e001ba27d7a0a$var$handleClickEvent, true);
    win.removeEventListener("focus", $855e001ba27d7a0a$var$handleFocusEvent, true);
    win.removeEventListener("blur", $855e001ba27d7a0a$var$handleWindowBlur, false);
    if (typeof win.PointerEvent !== "undefined") {
        doc.removeEventListener("pointerdown", $855e001ba27d7a0a$var$handlePointerEvent, true);
        doc.removeEventListener("pointermove", $855e001ba27d7a0a$var$handlePointerEvent, true);
        doc.removeEventListener("pointerup", $855e001ba27d7a0a$var$handlePointerEvent, true);
    } else {
        doc.removeEventListener("mousedown", $855e001ba27d7a0a$var$handlePointerEvent, true);
        doc.removeEventListener("mousemove", $855e001ba27d7a0a$var$handlePointerEvent, true);
        doc.removeEventListener("mouseup", $855e001ba27d7a0a$var$handlePointerEvent, true);
    }
    $855e001ba27d7a0a$export$b9f54f824a756af3.delete(win);
};
function $855e001ba27d7a0a$export$630ff653c5ada6a9() {
    return $855e001ba27d7a0a$var$currentModality;
}
function $855e001ba27d7a0a$export$8397ddfc504fdb9a(modality) {
    $855e001ba27d7a0a$var$currentModality = modality;
    $855e001ba27d7a0a$var$triggerChangeHandlers(modality, null);
}
function $855e001ba27d7a0a$export$1238a82db5699f92(props) {
    const { onChange: onChange, root: root } = props;
    $855e001ba27d7a0a$var$setupGlobalFocusEvents(root);
    onChange({
        modality: $855e001ba27d7a0a$var$currentModality
    });
    const handler = ()=>onChange({
            modality: $855e001ba27d7a0a$var$currentModality
        });
    $855e001ba27d7a0a$var$changeHandlers.add(handler);
    return ()=>{
        $855e001ba27d7a0a$var$changeHandlers.delete(handler);
    };
}
function $855e001ba27d7a0a$export$b9b3dfddab17db27() {
    return $855e001ba27d7a0a$var$currentModality === "keyboard" || $855e001ba27d7a0a$var$currentModality === "virtual";
}
function $855e001ba27d7a0a$export$920b4983565c6f4d(props = {}) {
    const { isTextInput: isTextInput, autoFocus: autoFocus, onChange: onChange, root: root } = props;
    $855e001ba27d7a0a$var$setupGlobalFocusEvents(root);
    onChange?.({
        isFocusVisible: autoFocus || $855e001ba27d7a0a$export$b9b3dfddab17db27(),
        modality: $855e001ba27d7a0a$var$currentModality
    });
    const handler = (modality, e)=>{
        if (!$855e001ba27d7a0a$var$isKeyboardFocusEvent(!!isTextInput, modality, e)) return;
        onChange?.({
            isFocusVisible: $855e001ba27d7a0a$export$b9b3dfddab17db27(),
            modality: modality
        });
    };
    $855e001ba27d7a0a$var$changeHandlers.add(handler);
    return ()=>{
        $855e001ba27d7a0a$var$changeHandlers.delete(handler);
    };
}


// src/get-placement.ts
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $abcde9a5beae68a3$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $abcde9a5beae68a3$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $abcde9a5beae68a3$export$803cd8101b6c182b = /*#__PURE__*/ $abcde9a5beae68a3$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $abcde9a5beae68a3$export$27b07d8a310ed8b5[0], side + "-" + $abcde9a5beae68a3$export$27b07d8a310ed8b5[1]), []);
const $abcde9a5beae68a3$export$96ec731ed4dcb222 = Math.min;
const $abcde9a5beae68a3$export$8960430cfd85939f = Math.max;
const $abcde9a5beae68a3$export$2077e0241d6afd3c = Math.round;
const $abcde9a5beae68a3$export$a3fe094919f356fd = Math.floor;
const $abcde9a5beae68a3$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $abcde9a5beae68a3$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $abcde9a5beae68a3$export$7d15b64cf5a3a4c4(start, value, end) {
    return $abcde9a5beae68a3$export$8960430cfd85939f(start, $abcde9a5beae68a3$export$96ec731ed4dcb222(value, end));
}
function $abcde9a5beae68a3$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $abcde9a5beae68a3$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $abcde9a5beae68a3$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $abcde9a5beae68a3$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $abcde9a5beae68a3$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $abcde9a5beae68a3$export$f28e8f882010718a(placement) {
    const firstChar = placement[0];
    return firstChar === 't' || firstChar === 'b' ? 'y' : 'x';
}
function $abcde9a5beae68a3$export$2b57e0052a6d6d4c(placement) {
    return $abcde9a5beae68a3$export$8a000a963141ac32($abcde9a5beae68a3$export$f28e8f882010718a(placement));
}
function $abcde9a5beae68a3$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $abcde9a5beae68a3$export$f0989780f32bfcda(placement);
    const alignmentAxis = $abcde9a5beae68a3$export$2b57e0052a6d6d4c(placement);
    const length = $abcde9a5beae68a3$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $abcde9a5beae68a3$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $abcde9a5beae68a3$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $abcde9a5beae68a3$export$496432a3699e50b1(placement) {
    const oppositePlacement = $abcde9a5beae68a3$export$9c5e28bad23365fa(placement);
    return [
        $abcde9a5beae68a3$export$2b182c584985588b(placement),
        oppositePlacement,
        $abcde9a5beae68a3$export$2b182c584985588b(oppositePlacement)
    ];
}
function $abcde9a5beae68a3$export$2b182c584985588b(placement) {
    return placement.includes('start') ? placement.replace('start', 'end') : placement.replace('end', 'start');
}
const $abcde9a5beae68a3$var$lrPlacement = [
    'left',
    'right'
];
const $abcde9a5beae68a3$var$rlPlacement = [
    'right',
    'left'
];
const $abcde9a5beae68a3$var$tbPlacement = [
    'top',
    'bottom'
];
const $abcde9a5beae68a3$var$btPlacement = [
    'bottom',
    'top'
];
function $abcde9a5beae68a3$var$getSideList(side, isStart, rtl) {
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? $abcde9a5beae68a3$var$rlPlacement : $abcde9a5beae68a3$var$lrPlacement;
            return isStart ? $abcde9a5beae68a3$var$lrPlacement : $abcde9a5beae68a3$var$rlPlacement;
        case 'left':
        case 'right':
            return isStart ? $abcde9a5beae68a3$var$tbPlacement : $abcde9a5beae68a3$var$btPlacement;
        default:
            return [];
    }
}
function $abcde9a5beae68a3$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $abcde9a5beae68a3$export$f0989780f32bfcda(placement);
    let list = $abcde9a5beae68a3$var$getSideList($abcde9a5beae68a3$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($abcde9a5beae68a3$export$2b182c584985588b));
    }
    return list;
}
function $abcde9a5beae68a3$export$9c5e28bad23365fa(placement) {
    const side = $abcde9a5beae68a3$export$3c915306cb7fc97a(placement);
    return $abcde9a5beae68a3$var$oppositeSideMap[side] + placement.slice(side.length);
}
function $abcde9a5beae68a3$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $abcde9a5beae68a3$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $abcde9a5beae68a3$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $abcde9a5beae68a3$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}


function $baea33fbd448a692$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $abcde9a5beae68a3$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $abcde9a5beae68a3$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $abcde9a5beae68a3$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $abcde9a5beae68a3$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $abcde9a5beae68a3$export$f0989780f32bfcda)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $baea33fbd448a692$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $abcde9a5beae68a3$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $abcde9a5beae68a3$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $abcde9a5beae68a3$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $abcde9a5beae68a3$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
// Maximum number of resets that can occur before bailing to avoid infinite reset loops.
const $baea33fbd448a692$var$MAX_RESET_COUNT = 50;
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $baea33fbd448a692$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const platformWithDetectOverflow = platform.detectOverflow ? platform : {
        ...platform,
        detectOverflow: $baea33fbd448a692$export$37b6bde19b108ecc
    };
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $baea33fbd448a692$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let resetCount = 0;
    const middlewareData = {};
    for(let i = 0; i < middleware.length; i++){
        const currentMiddleware = middleware[i];
        if (!currentMiddleware) continue;
        const { name: name, fn: fn } = currentMiddleware;
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platformWithDetectOverflow,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData[name] = {
            ...middlewareData[name],
            ...data
        };
        if (reset && resetCount < $baea33fbd448a692$var$MAX_RESET_COUNT) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $baea33fbd448a692$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $baea33fbd448a692$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $abcde9a5beae68a3$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $abcde9a5beae68a3$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $abcde9a5beae68a3$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $abcde9a5beae68a3$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $abcde9a5beae68a3$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $abcde9a5beae68a3$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $abcde9a5beae68a3$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $abcde9a5beae68a3$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $baea33fbd448a692$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $abcde9a5beae68a3$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $abcde9a5beae68a3$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $abcde9a5beae68a3$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $abcde9a5beae68a3$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $abcde9a5beae68a3$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $baea33fbd448a692$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $abcde9a5beae68a3$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $abcde9a5beae68a3$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $abcde9a5beae68a3$export$803cd8101b6c182b) ? $baea33fbd448a692$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $abcde9a5beae68a3$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $abcde9a5beae68a3$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $abcde9a5beae68a3$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $abcde9a5beae68a3$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $baea33fbd448a692$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $abcde9a5beae68a3$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $abcde9a5beae68a3$export$3c915306cb7fc97a)(placement);
            const initialSideAxis = (0, $abcde9a5beae68a3$export$f28e8f882010718a)(initialPlacement);
            const isBasePlacement = (0, $abcde9a5beae68a3$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $abcde9a5beae68a3$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $abcde9a5beae68a3$export$496432a3699e50b1)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $abcde9a5beae68a3$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $abcde9a5beae68a3$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) {
                    const ignoreCrossAxisOverflow = checkCrossAxis === 'alignment' ? initialSideAxis !== (0, $abcde9a5beae68a3$export$f28e8f882010718a)(nextPlacement) : false;
                    if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
                    // overflows the main axis.
                    overflowsData.every((d)=>(0, $abcde9a5beae68a3$export$f28e8f882010718a)(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true)) // Try next placement and re-run the lifecycle.
                    return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                }
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $abcde9a5beae68a3$export$f28e8f882010718a)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $baea33fbd448a692$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $baea33fbd448a692$var$isAnySideFullyClipped(overflow) {
    return (0, $abcde9a5beae68a3$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $baea33fbd448a692$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects, platform: platform } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $abcde9a5beae68a3$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $baea33fbd448a692$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $baea33fbd448a692$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $baea33fbd448a692$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $baea33fbd448a692$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $baea33fbd448a692$var$getBoundingRect(rects) {
    const minX = (0, $abcde9a5beae68a3$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $abcde9a5beae68a3$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $abcde9a5beae68a3$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $abcde9a5beae68a3$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $baea33fbd448a692$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $abcde9a5beae68a3$export$ee05aea0aeecbad4)($baea33fbd448a692$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $baea33fbd448a692$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $abcde9a5beae68a3$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $baea33fbd448a692$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $abcde9a5beae68a3$export$ee05aea0aeecbad4)($baea33fbd448a692$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $abcde9a5beae68a3$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $abcde9a5beae68a3$export$f28e8f882010718a)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $abcde9a5beae68a3$export$3c915306cb7fc97a)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $abcde9a5beae68a3$export$3c915306cb7fc97a)(placement) === 'left';
                    const maxRight = (0, $abcde9a5beae68a3$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $abcde9a5beae68a3$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
const $baea33fbd448a692$var$originSides = /*#__PURE__*/ new Set([
    'left',
    'top'
]);
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $baea33fbd448a692$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $abcde9a5beae68a3$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $abcde9a5beae68a3$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $abcde9a5beae68a3$export$f28e8f882010718a)(placement) === 'y';
    const mainAxisMulti = $baea33fbd448a692$var$originSides.has(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $abcde9a5beae68a3$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $baea33fbd448a692$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $baea33fbd448a692$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $baea33fbd448a692$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, platform: platform } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $abcde9a5beae68a3$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const crossAxis = (0, $abcde9a5beae68a3$export$f28e8f882010718a)((0, $abcde9a5beae68a3$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $abcde9a5beae68a3$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $abcde9a5beae68a3$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $abcde9a5beae68a3$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $baea33fbd448a692$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $abcde9a5beae68a3$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $abcde9a5beae68a3$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $abcde9a5beae68a3$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $abcde9a5beae68a3$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = $baea33fbd448a692$var$originSides.has((0, $abcde9a5beae68a3$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $baea33fbd448a692$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $abcde9a5beae68a3$export$fef61f332f2c0afc)(options, state);
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const side = (0, $abcde9a5beae68a3$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $abcde9a5beae68a3$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $abcde9a5beae68a3$export$f28e8f882010718a)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $abcde9a5beae68a3$export$96ec731ed4dcb222)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $abcde9a5beae68a3$export$96ec731ed4dcb222)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $abcde9a5beae68a3$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $abcde9a5beae68a3$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $abcde9a5beae68a3$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $abcde9a5beae68a3$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $abcde9a5beae68a3$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $abcde9a5beae68a3$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $4e9f7fee644b6873$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $4e9f7fee644b6873$export$651544f548703224(node) {
    if ($4e9f7fee644b6873$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $4e9f7fee644b6873$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $4e9f7fee644b6873$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($4e9f7fee644b6873$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $4e9f7fee644b6873$export$8ee0fc9ee280b4ee(value) {
    if (!$4e9f7fee644b6873$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $4e9f7fee644b6873$export$38b2d434cce3ea22(value).Node;
}
function $4e9f7fee644b6873$export$45a5e7f76e0caa8d(value) {
    if (!$4e9f7fee644b6873$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $4e9f7fee644b6873$export$38b2d434cce3ea22(value).Element;
}
function $4e9f7fee644b6873$export$1b3bfaa9684536aa(value) {
    if (!$4e9f7fee644b6873$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $4e9f7fee644b6873$export$38b2d434cce3ea22(value).HTMLElement;
}
function $4e9f7fee644b6873$export$af51f0f06c0f328a(value) {
    if (!$4e9f7fee644b6873$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $4e9f7fee644b6873$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $4e9f7fee644b6873$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $4e9f7fee644b6873$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && display !== 'inline' && display !== 'contents';
}
function $4e9f7fee644b6873$export$71535ffaa902797f(element) {
    return /^(table|td|th)$/.test($4e9f7fee644b6873$export$651544f548703224(element));
}
function $4e9f7fee644b6873$export$89e651af02346cd4(element) {
    try {
        if (element.matches(':popover-open')) return true;
    } catch (_e) {
    // no-op
    }
    try {
        return element.matches(':modal');
    } catch (_e) {
        return false;
    }
}
const $4e9f7fee644b6873$var$willChangeRe = /transform|translate|scale|rotate|perspective|filter/;
const $4e9f7fee644b6873$var$containRe = /paint|layout|strict|content/;
const $4e9f7fee644b6873$var$isNotNone = (value)=>!!value && value !== 'none';
let $4e9f7fee644b6873$var$isWebKitValue;
function $4e9f7fee644b6873$export$d6c4e8150c35fed1(elementOrCss) {
    const css = $4e9f7fee644b6873$export$45a5e7f76e0caa8d(elementOrCss) ? $4e9f7fee644b6873$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return $4e9f7fee644b6873$var$isNotNone(css.transform) || $4e9f7fee644b6873$var$isNotNone(css.translate) || $4e9f7fee644b6873$var$isNotNone(css.scale) || $4e9f7fee644b6873$var$isNotNone(css.rotate) || $4e9f7fee644b6873$var$isNotNone(css.perspective) || !$4e9f7fee644b6873$export$78551043582a6a98() && ($4e9f7fee644b6873$var$isNotNone(css.backdropFilter) || $4e9f7fee644b6873$var$isNotNone(css.filter)) || $4e9f7fee644b6873$var$willChangeRe.test(css.willChange || '') || $4e9f7fee644b6873$var$containRe.test(css.contain || '');
}
function $4e9f7fee644b6873$export$940d8225183e1404(element) {
    let currentNode = $4e9f7fee644b6873$export$4e12058fc4d51d56(element);
    while($4e9f7fee644b6873$export$1b3bfaa9684536aa(currentNode) && !$4e9f7fee644b6873$export$d1162fb0b6d4cd51(currentNode)){
        if ($4e9f7fee644b6873$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($4e9f7fee644b6873$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $4e9f7fee644b6873$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $4e9f7fee644b6873$export$78551043582a6a98() {
    if ($4e9f7fee644b6873$var$isWebKitValue == null) $4e9f7fee644b6873$var$isWebKitValue = typeof CSS !== 'undefined' && CSS.supports && CSS.supports('-webkit-backdrop-filter', 'none');
    return $4e9f7fee644b6873$var$isWebKitValue;
}
function $4e9f7fee644b6873$export$d1162fb0b6d4cd51(node) {
    return /^(html|body|#document)$/.test($4e9f7fee644b6873$export$651544f548703224(node));
}
function $4e9f7fee644b6873$export$3735103072e4a80(element) {
    return $4e9f7fee644b6873$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $4e9f7fee644b6873$export$dc8fc79fa2800137(element) {
    if ($4e9f7fee644b6873$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $4e9f7fee644b6873$export$4e12058fc4d51d56(node) {
    if ($4e9f7fee644b6873$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $4e9f7fee644b6873$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $4e9f7fee644b6873$export$e495491855dc5418(node);
    return $4e9f7fee644b6873$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $4e9f7fee644b6873$export$7cd01a57c8ca906c(node) {
    const parentNode = $4e9f7fee644b6873$export$4e12058fc4d51d56(node);
    if ($4e9f7fee644b6873$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($4e9f7fee644b6873$export$1b3bfaa9684536aa(parentNode) && $4e9f7fee644b6873$export$989e911fa9af580a(parentNode)) return parentNode;
    return $4e9f7fee644b6873$export$7cd01a57c8ca906c(parentNode);
}
function $4e9f7fee644b6873$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $4e9f7fee644b6873$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $4e9f7fee644b6873$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $4e9f7fee644b6873$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $4e9f7fee644b6873$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $4e9f7fee644b6873$export$3b57c1601291186b(frameElement) : []);
    } else return list.concat(scrollableAncestor, $4e9f7fee644b6873$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $4e9f7fee644b6873$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}


function $e09b833f247449ac$var$getCssDimensions(element) {
    const css = (0, $4e9f7fee644b6873$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $4e9f7fee644b6873$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $abcde9a5beae68a3$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $abcde9a5beae68a3$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $e09b833f247449ac$var$unwrapElement(element) {
    return !(0, $4e9f7fee644b6873$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $e09b833f247449ac$var$getScale(element) {
    const domElement = $e09b833f247449ac$var$unwrapElement(element);
    if (!(0, $4e9f7fee644b6873$export$1b3bfaa9684536aa)(domElement)) return (0, $abcde9a5beae68a3$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $e09b833f247449ac$var$getCssDimensions(domElement);
    let x = ($ ? (0, $abcde9a5beae68a3$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $abcde9a5beae68a3$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $e09b833f247449ac$var$noOffsets = /*#__PURE__*/ (0, $abcde9a5beae68a3$export$a397704b5e280835)(0);
function $e09b833f247449ac$var$getVisualOffsets(element) {
    const win = (0, $4e9f7fee644b6873$export$38b2d434cce3ea22)(element);
    if (!(0, $4e9f7fee644b6873$export$78551043582a6a98)() || !win.visualViewport) return $e09b833f247449ac$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $e09b833f247449ac$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $4e9f7fee644b6873$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $e09b833f247449ac$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $e09b833f247449ac$var$unwrapElement(element);
    let scale = (0, $abcde9a5beae68a3$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $4e9f7fee644b6873$export$45a5e7f76e0caa8d)(offsetParent)) scale = $e09b833f247449ac$var$getScale(offsetParent);
        } else scale = $e09b833f247449ac$var$getScale(element);
    }
    const visualOffsets = $e09b833f247449ac$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $e09b833f247449ac$var$getVisualOffsets(domElement) : (0, $abcde9a5beae68a3$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $4e9f7fee644b6873$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $4e9f7fee644b6873$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $4e9f7fee644b6873$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $4e9f7fee644b6873$export$7bf1f8740e3e34af)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $e09b833f247449ac$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $4e9f7fee644b6873$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $4e9f7fee644b6873$export$38b2d434cce3ea22)(currentIFrame);
            currentIFrame = (0, $4e9f7fee644b6873$export$7bf1f8740e3e34af)(currentWin);
        }
    }
    return (0, $abcde9a5beae68a3$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $e09b833f247449ac$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $4e9f7fee644b6873$export$dc8fc79fa2800137)(element).scrollLeft;
    if (!rect) return $e09b833f247449ac$var$getBoundingClientRect((0, $4e9f7fee644b6873$export$e495491855dc5418)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $e09b833f247449ac$var$getHTMLOffset(documentElement, scroll) {
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - $e09b833f247449ac$var$getWindowScrollBarX(documentElement, htmlRect);
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $e09b833f247449ac$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $4e9f7fee644b6873$export$e495491855dc5418)(offsetParent);
    const topLayer = elements ? (0, $4e9f7fee644b6873$export$89e651af02346cd4)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $abcde9a5beae68a3$export$a397704b5e280835)(1);
    const offsets = (0, $abcde9a5beae68a3$export$a397704b5e280835)(0);
    const isOffsetParentAnElement = (0, $4e9f7fee644b6873$export$1b3bfaa9684536aa)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $4e9f7fee644b6873$export$651544f548703224)(offsetParent) !== 'body' || (0, $4e9f7fee644b6873$export$989e911fa9af580a)(documentElement)) scroll = (0, $4e9f7fee644b6873$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $e09b833f247449ac$var$getBoundingClientRect(offsetParent);
            scale = $e09b833f247449ac$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $e09b833f247449ac$var$getHTMLOffset(documentElement, scroll) : (0, $abcde9a5beae68a3$export$a397704b5e280835)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $e09b833f247449ac$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $e09b833f247449ac$var$getDocumentRect(element) {
    const html = (0, $4e9f7fee644b6873$export$e495491855dc5418)(element);
    const scroll = (0, $4e9f7fee644b6873$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $abcde9a5beae68a3$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $abcde9a5beae68a3$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $e09b833f247449ac$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $4e9f7fee644b6873$export$3735103072e4a80)(body).direction === 'rtl') x += (0, $abcde9a5beae68a3$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Safety check: ensure the scrollbar space is reasonable in case this
// calculation is affected by unusual styles.
// Most scrollbars leave 15-18px of space.
const $e09b833f247449ac$var$SCROLLBAR_MAX = 25;
function $e09b833f247449ac$var$getViewportRect(element, strategy) {
    const win = (0, $4e9f7fee644b6873$export$38b2d434cce3ea22)(element);
    const html = (0, $4e9f7fee644b6873$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $4e9f7fee644b6873$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    const windowScrollbarX = $e09b833f247449ac$var$getWindowScrollBarX(html);
    // <html> `overflow: hidden` + `scrollbar-gutter: stable` reduces the
    // visual width of the <html> but this is not considered in the size
    // of `html.clientWidth`.
    if (windowScrollbarX <= 0) {
        const doc = html.ownerDocument;
        const body = doc.body;
        const bodyStyles = getComputedStyle(body);
        const bodyMarginInline = doc.compatMode === 'CSS1Compat' ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
        const clippingStableScrollbarWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
        if (clippingStableScrollbarWidth <= $e09b833f247449ac$var$SCROLLBAR_MAX) width -= clippingStableScrollbarWidth;
    } else if (windowScrollbarX <= $e09b833f247449ac$var$SCROLLBAR_MAX) // If the <body> scrollbar is on the left, the width needs to be extended
    // by the scrollbar amount so there isn't extra space on the right.
    width += windowScrollbarX;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $e09b833f247449ac$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $e09b833f247449ac$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $4e9f7fee644b6873$export$1b3bfaa9684536aa)(element) ? $e09b833f247449ac$var$getScale(element) : (0, $abcde9a5beae68a3$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $e09b833f247449ac$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $e09b833f247449ac$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $e09b833f247449ac$var$getDocumentRect((0, $4e9f7fee644b6873$export$e495491855dc5418)(element));
    else if ((0, $4e9f7fee644b6873$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $e09b833f247449ac$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $e09b833f247449ac$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $abcde9a5beae68a3$export$ee05aea0aeecbad4)(rect);
}
function $e09b833f247449ac$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $4e9f7fee644b6873$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $4e9f7fee644b6873$export$45a5e7f76e0caa8d)(parentNode) || (0, $4e9f7fee644b6873$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $4e9f7fee644b6873$export$3735103072e4a80)(parentNode).position === 'fixed' || $e09b833f247449ac$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $e09b833f247449ac$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $4e9f7fee644b6873$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $4e9f7fee644b6873$export$45a5e7f76e0caa8d)(el) && (0, $4e9f7fee644b6873$export$651544f548703224)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $4e9f7fee644b6873$export$3735103072e4a80)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $4e9f7fee644b6873$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $4e9f7fee644b6873$export$45a5e7f76e0caa8d)(currentNode) && !(0, $4e9f7fee644b6873$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $4e9f7fee644b6873$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $4e9f7fee644b6873$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && (currentContainingBlockComputedStyle.position === 'absolute' || currentContainingBlockComputedStyle.position === 'fixed') || (0, $4e9f7fee644b6873$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $e09b833f247449ac$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $4e9f7fee644b6873$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $e09b833f247449ac$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $4e9f7fee644b6873$export$89e651af02346cd4)(element) ? [] : $e09b833f247449ac$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstRect = $e09b833f247449ac$var$getClientRectFromClippingAncestor(element, clippingAncestors[0], strategy);
    let top = firstRect.top;
    let right = firstRect.right;
    let bottom = firstRect.bottom;
    let left = firstRect.left;
    for(let i = 1; i < clippingAncestors.length; i++){
        const rect = $e09b833f247449ac$var$getClientRectFromClippingAncestor(element, clippingAncestors[i], strategy);
        top = (0, $abcde9a5beae68a3$export$8960430cfd85939f)(rect.top, top);
        right = (0, $abcde9a5beae68a3$export$96ec731ed4dcb222)(rect.right, right);
        bottom = (0, $abcde9a5beae68a3$export$96ec731ed4dcb222)(rect.bottom, bottom);
        left = (0, $abcde9a5beae68a3$export$8960430cfd85939f)(rect.left, left);
    }
    return {
        width: right - left,
        height: bottom - top,
        x: left,
        y: top
    };
}
function $e09b833f247449ac$var$getDimensions(element) {
    const { width: width, height: height } = $e09b833f247449ac$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $e09b833f247449ac$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $4e9f7fee644b6873$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $4e9f7fee644b6873$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $e09b833f247449ac$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $abcde9a5beae68a3$export$a397704b5e280835)(0);
    // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
    // Firefox with layout.scrollbar.side = 3 in about:config to test this.
    function setLeftRTLScrollbarOffset() {
        offsets.x = $e09b833f247449ac$var$getWindowScrollBarX(documentElement);
    }
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $4e9f7fee644b6873$export$651544f548703224)(offsetParent) !== 'body' || (0, $4e9f7fee644b6873$export$989e911fa9af580a)(documentElement)) scroll = (0, $4e9f7fee644b6873$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $e09b833f247449ac$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) setLeftRTLScrollbarOffset();
    }
    if (isFixed && !isOffsetParentAnElement && documentElement) setLeftRTLScrollbarOffset();
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $e09b833f247449ac$var$getHTMLOffset(documentElement, scroll) : (0, $abcde9a5beae68a3$export$a397704b5e280835)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $e09b833f247449ac$var$isStaticPositioned(element) {
    return (0, $4e9f7fee644b6873$export$3735103072e4a80)(element).position === 'static';
}
function $e09b833f247449ac$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $4e9f7fee644b6873$export$1b3bfaa9684536aa)(element) || (0, $4e9f7fee644b6873$export$3735103072e4a80)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $4e9f7fee644b6873$export$e495491855dc5418)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $e09b833f247449ac$var$getOffsetParent(element, polyfill) {
    const win = (0, $4e9f7fee644b6873$export$38b2d434cce3ea22)(element);
    if ((0, $4e9f7fee644b6873$export$89e651af02346cd4)(element)) return win;
    if (!(0, $4e9f7fee644b6873$export$1b3bfaa9684536aa)(element)) {
        let svgOffsetParent = (0, $4e9f7fee644b6873$export$4e12058fc4d51d56)(element);
        while(svgOffsetParent && !(0, $4e9f7fee644b6873$export$d1162fb0b6d4cd51)(svgOffsetParent)){
            if ((0, $4e9f7fee644b6873$export$45a5e7f76e0caa8d)(svgOffsetParent) && !$e09b833f247449ac$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $4e9f7fee644b6873$export$4e12058fc4d51d56)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $e09b833f247449ac$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $4e9f7fee644b6873$export$71535ffaa902797f)(offsetParent) && $e09b833f247449ac$var$isStaticPositioned(offsetParent))offsetParent = $e09b833f247449ac$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $4e9f7fee644b6873$export$d1162fb0b6d4cd51)(offsetParent) && $e09b833f247449ac$var$isStaticPositioned(offsetParent) && !(0, $4e9f7fee644b6873$export$d6c4e8150c35fed1)(offsetParent)) return win;
    return offsetParent || (0, $4e9f7fee644b6873$export$940d8225183e1404)(element) || win;
}
const $e09b833f247449ac$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $e09b833f247449ac$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $e09b833f247449ac$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $e09b833f247449ac$var$isRTL(element) {
    return (0, $4e9f7fee644b6873$export$3735103072e4a80)(element).direction === 'rtl';
}
const $e09b833f247449ac$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $e09b833f247449ac$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $4e9f7fee644b6873$export$e495491855dc5418,
    getClippingRect: $e09b833f247449ac$var$getClippingRect,
    getOffsetParent: $e09b833f247449ac$var$getOffsetParent,
    getElementRects: $e09b833f247449ac$var$getElementRects,
    getClientRects: $e09b833f247449ac$var$getClientRects,
    getDimensions: $e09b833f247449ac$var$getDimensions,
    getScale: $e09b833f247449ac$var$getScale,
    isElement: $4e9f7fee644b6873$export$45a5e7f76e0caa8d,
    isRTL: $e09b833f247449ac$var$isRTL
};
function $e09b833f247449ac$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $e09b833f247449ac$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $4e9f7fee644b6873$export$e495491855dc5418)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left: left, top: top, width: width, height: height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $abcde9a5beae68a3$export$a3fe094919f356fd)(top);
        const insetRight = (0, $abcde9a5beae68a3$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $abcde9a5beae68a3$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $abcde9a5beae68a3$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $abcde9a5beae68a3$export$8960430cfd85939f)(0, (0, $abcde9a5beae68a3$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            if (ratio === 1 && !$e09b833f247449ac$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) // It's possible that even though the ratio is reported as 1, the
            // element is not actually fully within the IntersectionObserver's root
            // area anymore. This can happen under performance constraints. This may
            // be a bug in the browser's IntersectionObserver implementation. To
            // work around this, we compare the element's bounding rect now with
            // what it was at the time we created the IntersectionObserver. If they
            // are not equal then the element moved, so we refresh.
            refresh();
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (_e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $e09b833f247449ac$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $e09b833f247449ac$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $4e9f7fee644b6873$export$3b57c1601291186b)(referenceEl) : [],
        ...floating ? (0, $4e9f7fee644b6873$export$3b57c1601291186b)(floating) : []
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $e09b833f247449ac$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver && floating) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        if (floating) resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $e09b833f247449ac$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $e09b833f247449ac$var$getBoundingClientRect(reference);
        if (prevRefRect && !$e09b833f247449ac$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $e09b833f247449ac$export$37b6bde19b108ecc = (0, $baea33fbd448a692$export$37b6bde19b108ecc);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $e09b833f247449ac$export$cc800923e997bb8 = (0, $baea33fbd448a692$export$cc800923e997bb8);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $e09b833f247449ac$export$91fb6ecbd551914 = (0, $baea33fbd448a692$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $e09b833f247449ac$export$fba63a578e423eb = (0, $baea33fbd448a692$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $e09b833f247449ac$export$8a83211c878a3f1f = (0, $baea33fbd448a692$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $e09b833f247449ac$export$346677f925de839c = (0, $baea33fbd448a692$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $e09b833f247449ac$export$fe8985bb6374093c = (0, $baea33fbd448a692$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $e09b833f247449ac$export$f2120bbfa5450bd2 = (0, $baea33fbd448a692$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $e09b833f247449ac$export$18c8ad048e32c7d5 = (0, $baea33fbd448a692$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $e09b833f247449ac$export$7bf07e38f3dc4b69 = (0, $baea33fbd448a692$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $e09b833f247449ac$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $e09b833f247449ac$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $baea33fbd448a692$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};




// src/get-anchor.ts

function $15b09f2e04124430$export$5cc1ab75d98b37f7(x = 0, y = 0, width = 0, height = 0) {
    if (typeof DOMRect === "function") return new DOMRect(x, y, width, height);
    const rect = {
        x: x,
        y: y,
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x
    };
    return {
        ...rect,
        toJSON: ()=>rect
    };
}
function $15b09f2e04124430$var$getDOMRect(anchorRect) {
    if (!anchorRect) return $15b09f2e04124430$export$5cc1ab75d98b37f7();
    const { x: x, y: y, width: width, height: height } = anchorRect;
    return $15b09f2e04124430$export$5cc1ab75d98b37f7(x, y, width, height);
}
function $15b09f2e04124430$export$ac81f1ba58a5f363(anchorElement, getAnchorRect) {
    return {
        contextElement: (0, $2020ec4601cca401$export$1b3bfaa9684536aa)(anchorElement) ? anchorElement : anchorElement?.contextElement,
        getBoundingClientRect: ()=>{
            const anchor = anchorElement;
            const anchorRect = getAnchorRect?.(anchor);
            if (anchorRect || !anchor) return $15b09f2e04124430$var$getDOMRect(anchorRect);
            return anchor.getBoundingClientRect();
        }
    };
}



// src/placement.ts
function $666fb7dd4ba30f64$export$8cf10a75ab4aab46(v) {
    return /^(?:top|bottom|left|right)(?:-(?:start|end))?$/.test(v);
}
function $666fb7dd4ba30f64$export$21559465299d9849(placement) {
    const [side, align] = placement.split("-");
    return {
        side: side,
        align: align,
        hasAlign: align != null
    };
}
function $666fb7dd4ba30f64$export$2f5876c005418271(placement) {
    return placement.split("-")[0];
}


var $21d1221b99f40370$var$defaultOptions = {
    strategy: "absolute",
    placement: "bottom",
    listeners: true,
    restoreStyles: false,
    gutter: 8,
    flip: true,
    slide: true,
    overlap: false,
    sameWidth: false,
    fitViewport: false,
    overflowPadding: 8,
    arrowPadding: 4
};
function $21d1221b99f40370$var$roundByDpr(win, value) {
    const dpr = win.devicePixelRatio || 1;
    return Math.round(value * dpr) / dpr;
}
function $21d1221b99f40370$var$isApproximatelyEqual(a, b) {
    return a != null && Math.abs(a - b) < 0.5;
}
function $21d1221b99f40370$var$resolveBoundaryOption(boundary) {
    if (typeof boundary === "function") return boundary();
    if (boundary === "clipping-ancestors") return "clippingAncestors";
    return boundary;
}
function $21d1221b99f40370$var$getArrowMiddleware(arrowElement, doc, opts) {
    const element = arrowElement || doc.createElement("div");
    return (0, $e09b833f247449ac$export$f2120bbfa5450bd2)({
        element: element,
        padding: opts.arrowPadding
    });
}
function $21d1221b99f40370$var$getOffsetMiddleware(arrowElement, opts) {
    if ((0, $9a966d729185a601$export$630801d484da15df)(opts.offset ?? opts.gutter)) return;
    return (0, $e09b833f247449ac$export$cc800923e997bb8)(({ placement: placement })=>{
        const arrowOffset = (arrowElement?.clientHeight || 0) / 2;
        const gutter = opts.offset?.mainAxis ?? opts.gutter;
        const mainAxis = typeof gutter === "number" ? gutter + arrowOffset : gutter ?? arrowOffset;
        const { hasAlign: hasAlign } = (0, $666fb7dd4ba30f64$export$21559465299d9849)(placement);
        const shift2 = !hasAlign ? opts.shift : void 0;
        const crossAxis = opts.offset?.crossAxis ?? shift2;
        return (0, $6f7aa98cfa48efba$export$8e16b83750b44988)({
            crossAxis: crossAxis,
            mainAxis: mainAxis,
            alignmentAxis: opts.shift
        });
    });
}
function $21d1221b99f40370$var$getFlipMiddleware(opts) {
    if (!opts.flip) return;
    const boundary = $21d1221b99f40370$var$resolveBoundaryOption(opts.boundary);
    return (0, $e09b833f247449ac$export$8a83211c878a3f1f)({
        ...boundary ? {
            boundary: boundary
        } : void 0,
        padding: opts.overflowPadding,
        fallbackPlacements: opts.flip === true ? void 0 : opts.flip
    });
}
function $21d1221b99f40370$var$getShiftMiddleware(opts) {
    if (!opts.slide && !opts.overlap) return;
    const boundary = $21d1221b99f40370$var$resolveBoundaryOption(opts.boundary);
    return (0, $e09b833f247449ac$export$fba63a578e423eb)({
        ...boundary ? {
            boundary: boundary
        } : void 0,
        mainAxis: opts.slide,
        crossAxis: opts.overlap,
        padding: opts.overflowPadding,
        limiter: (0, $e09b833f247449ac$export$7bf07e38f3dc4b69)()
    });
}
function $21d1221b99f40370$var$getSizeMiddleware(opts) {
    if (opts.sizeMiddleware === false && !opts.sameWidth && !opts.fitViewport) return;
    let lastReferenceWidth;
    let lastReferenceHeight;
    let lastAvailableWidth;
    let lastAvailableHeight;
    return (0, $e09b833f247449ac$export$346677f925de839c)({
        padding: opts.overflowPadding,
        apply ({ elements: elements, rects: rects, availableHeight: availableHeight, availableWidth: availableWidth }) {
            const floating = elements.floating;
            const referenceWidth = Math.round(rects.reference.width);
            const referenceHeight = Math.round(rects.reference.height);
            availableWidth = Math.floor(availableWidth);
            availableHeight = Math.floor(availableHeight);
            if (!$21d1221b99f40370$var$isApproximatelyEqual(lastReferenceWidth, referenceWidth)) {
                floating.style.setProperty("--reference-width", `${referenceWidth}px`);
                lastReferenceWidth = referenceWidth;
            }
            if (!$21d1221b99f40370$var$isApproximatelyEqual(lastReferenceHeight, referenceHeight)) {
                floating.style.setProperty("--reference-height", `${referenceHeight}px`);
                lastReferenceHeight = referenceHeight;
            }
            if (!$21d1221b99f40370$var$isApproximatelyEqual(lastAvailableWidth, availableWidth)) {
                floating.style.setProperty("--available-width", `${availableWidth}px`);
                lastAvailableWidth = availableWidth;
            }
            if (!$21d1221b99f40370$var$isApproximatelyEqual(lastAvailableHeight, availableHeight)) {
                floating.style.setProperty("--available-height", `${availableHeight}px`);
                lastAvailableHeight = availableHeight;
            }
        }
    });
}
function $21d1221b99f40370$var$hideWhenDetachedMiddleware(opts) {
    if (!opts.hideWhenDetached) return;
    return (0, $e09b833f247449ac$export$fe8985bb6374093c)({
        strategy: "referenceHidden",
        boundary: $21d1221b99f40370$var$resolveBoundaryOption(opts.boundary) ?? "clippingAncestors"
    });
}
function $21d1221b99f40370$var$getAutoUpdateOptions(opts) {
    if (!opts) return {};
    if (opts === true) return {
        ancestorResize: true,
        ancestorScroll: true,
        elementResize: true,
        layoutShift: true
    };
    return opts;
}
var $21d1221b99f40370$var$floatingStyleProps = [
    "transform",
    "visibility",
    "pointer-events",
    "--x",
    "--y",
    "--z-index",
    "--reference-width",
    "--reference-height",
    "--available-width",
    "--available-height",
    "--transform-origin"
];
var $21d1221b99f40370$var$arrowStyleProps = [
    "top",
    "right",
    "bottom",
    "left"
];
function $21d1221b99f40370$var$createStyleCleanup(el, props) {
    if (!el) return 0, $5246d161dcdee685$export$8793edee2d425525;
    const prev = new Map(props.map((prop)=>[
            prop,
            el.style.getPropertyValue(prop)
        ]));
    return ()=>{
        prev.forEach((value, prop)=>{
            if (value) el.style.setProperty(prop, value);
            else el.style.removeProperty(prop);
        });
        if (el.style.length === 0) el.removeAttribute("style");
    };
}
function $21d1221b99f40370$var$anchorIdentity(anchor) {
    if (anchor == null) return null;
    if ((0, $2020ec4601cca401$export$1b3bfaa9684536aa)(anchor)) return anchor;
    if (typeof anchor === "object" && anchor && "contextElement" in anchor && anchor.contextElement) return anchor.contextElement;
    return anchor;
}
function $21d1221b99f40370$var$getPlacementImpl(referenceOrVirtual, floatingOrVirtual, opts = {}) {
    const resolveFloating = ()=>{
        const raw = typeof floatingOrVirtual === "function" ? floatingOrVirtual() : floatingOrVirtual;
        return raw ?? null;
    };
    const resolveAnchor = ()=>{
        const raw = typeof referenceOrVirtual === "function" ? referenceOrVirtual() : referenceOrVirtual;
        return opts.getAnchorElement?.() ?? raw;
    };
    const resolveReference = ()=>{
        const anchor = resolveAnchor();
        if (!anchor && !opts.getAnchorRect) return null;
        return (0, $15b09f2e04124430$export$ac81f1ba58a5f363)(anchor, opts.getAnchorRect);
    };
    const options = Object.assign({}, $21d1221b99f40370$var$defaultOptions, opts);
    let middleware = [];
    let cachedMiddlewareFloating = null;
    let restoreFloatingStyles;
    let restoreArrowStyles;
    function rebuildMiddlewareForFloating(floating) {
        restoreFloatingStyles?.();
        restoreArrowStyles?.();
        cachedMiddlewareFloating = floating;
        restoreFloatingStyles = options.restoreStyles ? $21d1221b99f40370$var$createStyleCleanup(floating, $21d1221b99f40370$var$floatingStyleProps) : void 0;
        const arrowEl = floating.querySelector("[data-part=arrow]");
        restoreArrowStyles = options.restoreStyles ? $21d1221b99f40370$var$createStyleCleanup(arrowEl, $21d1221b99f40370$var$arrowStyleProps) : void 0;
        middleware = [
            $21d1221b99f40370$var$getOffsetMiddleware(arrowEl, options),
            $21d1221b99f40370$var$getFlipMiddleware(options),
            $21d1221b99f40370$var$getShiftMiddleware(options),
            $21d1221b99f40370$var$getArrowMiddleware(arrowEl, floating.ownerDocument, options),
            (0, $a472e305795b1189$export$cb81845185688a22)(arrowEl),
            (0, $a472e305795b1189$export$c1bd4048a8e2d599)({
                gutter: options.gutter,
                offset: options.offset,
                overlap: options.overlap
            }, arrowEl),
            $21d1221b99f40370$var$getSizeMiddleware(options),
            $21d1221b99f40370$var$hideWhenDetachedMiddleware(options),
            (0, $a472e305795b1189$export$f48b311ab78f8eae)
        ];
    }
    const { placement: placement, strategy: strategy, onComplete: onComplete, onPositioned: onPositioned } = options;
    let lastX;
    let lastY;
    let zIndexComputed = false;
    let lastAnchorForObserve = void 0;
    let lastFloatingForObserve = void 0;
    let cancelAutoUpdate = (0, $5246d161dcdee685$export$8793edee2d425525);
    const autoUpdateOptions = $21d1221b99f40370$var$getAutoUpdateOptions(options.listeners);
    function syncAutoUpdateObservers() {
        if (!options.listeners) return;
        const anchor = resolveAnchor();
        const reference = resolveReference();
        const floating = resolveFloating();
        if (!reference || !floating) return;
        const anchorChanged = $21d1221b99f40370$var$anchorIdentity(anchor) !== $21d1221b99f40370$var$anchorIdentity(lastAnchorForObserve);
        const floatingChanged = floating !== lastFloatingForObserve;
        if (anchorChanged || floatingChanged) {
            cancelAutoUpdate();
            lastAnchorForObserve = anchor;
            lastFloatingForObserve = floating;
            cancelAutoUpdate = (0, $e09b833f247449ac$export$deee3a793edee05f)(reference, floating, runUpdate, autoUpdateOptions);
        }
    }
    async function updatePosition() {
        syncAutoUpdateObservers();
        const floating = resolveFloating();
        if (!floating) return;
        if (floating !== cachedMiddlewareFloating) {
            rebuildMiddlewareForFloating(floating);
            zIndexComputed = false;
        }
        const reference = resolveReference();
        if (!reference) return;
        const pos = await (0, $e09b833f247449ac$export$48a53dcb22e581d0)(reference, floating, {
            placement: placement,
            middleware: middleware,
            strategy: strategy
        });
        onComplete?.(pos);
        const win = (0, $2020ec4601cca401$export$38b2d434cce3ea22)(floating);
        const x = $21d1221b99f40370$var$roundByDpr(win, pos.x);
        const y = $21d1221b99f40370$var$roundByDpr(win, pos.y);
        if (!$21d1221b99f40370$var$isApproximatelyEqual(lastX, x)) {
            floating.style.setProperty("--x", `${x}px`);
            lastX = x;
        }
        if (!$21d1221b99f40370$var$isApproximatelyEqual(lastY, y)) {
            floating.style.setProperty("--y", `${y}px`);
            lastY = y;
        }
        if (options.hideWhenDetached) {
            const isHidden = pos.middlewareData.hide?.referenceHidden;
            if (isHidden) {
                floating.style.setProperty("visibility", "hidden");
                floating.style.setProperty("pointer-events", "none");
            } else {
                floating.style.removeProperty("visibility");
                floating.style.removeProperty("pointer-events");
            }
        }
        if (!zIndexComputed) {
            const contentEl = floating.firstElementChild;
            if (contentEl) {
                floating.style.setProperty("--z-index", (0, $8c3f3ba8f408b68b$export$3735103072e4a80)(contentEl).zIndex);
                zIndexComputed = true;
            }
        }
    }
    async function runUpdate() {
        if (opts.updatePosition) {
            await opts.updatePosition({
                updatePosition: updatePosition,
                floatingElement: resolveFloating()
            });
            onPositioned?.({
                placed: true
            });
        } else await updatePosition();
    }
    runUpdate();
    return ()=>{
        cancelAutoUpdate();
        restoreArrowStyles?.();
        restoreFloatingStyles?.();
        onPositioned?.({
            placed: false
        });
    };
}
function $21d1221b99f40370$export$a9fe23cfa43a7b55(referenceOrFn, floatingOrFn, opts = {}) {
    const { defer: defer, ...options } = opts;
    const func = defer ? (0, $7eacfb22d5a39e52$export$27f233d61a9e2fa4) : (v)=>v();
    const cleanups = [];
    cleanups.push(func(()=>{
        cleanups.push($21d1221b99f40370$var$getPlacementImpl(referenceOrFn, floatingOrFn, options));
    }));
    return ()=>{
        cleanups.forEach((fn)=>fn?.());
    };
}




// src/equal.ts
var $762ebc5b7ffef91d$var$isArrayLike = (value)=>value?.constructor.name === "Array";
var $762ebc5b7ffef91d$var$isArrayEqual = (a, b)=>{
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; i++){
        if (!$762ebc5b7ffef91d$export$248d38f6296296c5(a[i], b[i])) return false;
    }
    return true;
};
var $762ebc5b7ffef91d$export$248d38f6296296c5 = (a, b)=>{
    if (Object.is(a, b)) return true;
    if (a == null && b != null || a != null && b == null) return false;
    if (typeof a?.isEqual === "function" && typeof b?.isEqual === "function") return a.isEqual(b);
    if (typeof a === "function" && typeof b === "function") return a.toString() === b.toString();
    if ($762ebc5b7ffef91d$var$isArrayLike(a) && $762ebc5b7ffef91d$var$isArrayLike(b)) return $762ebc5b7ffef91d$var$isArrayEqual(Array.from(a), Array.from(b));
    if (!(typeof a === "object") || !(typeof b === "object")) return false;
    const keys = Object.keys(b ?? /* @__PURE__ */ Object.create(null));
    const length = keys.length;
    for(let i = 0; i < length; i++){
        const hasKey = Reflect.has(a, keys[i]);
        if (!hasKey) return false;
    }
    for(let i = 0; i < length; i++){
        const key = keys[i];
        if (!$762ebc5b7ffef91d$export$248d38f6296296c5(a[key], b[key])) return false;
    }
    return true;
};




var { not: $0d3e2a822fd3cd61$var$not, and: $0d3e2a822fd3cd61$var$and, or: $0d3e2a822fd3cd61$var$or } = (0, $9aa7f39f9520657f$export$285462e61607a24f)();
var $0d3e2a822fd3cd61$export$ea56d40cd27c3480 = (0, $9aa7f39f9520657f$export$aaa7fa18f8e9b2e8)({
    props ({ props: props }) {
        return {
            closeOnSelect: true,
            typeahead: true,
            composite: true,
            loopFocus: false,
            navigate (details) {
                (0, $4583cdbeefbe32b8$export$e91dc30618113dbe)(details.node);
            },
            ...props,
            positioning: {
                placement: "bottom-start",
                gutter: 8,
                ...props.positioning
            }
        };
    },
    initialState ({ prop: prop }) {
        const open = prop("open") || prop("defaultOpen");
        return open ? "open" : "idle";
    },
    context ({ bindable: bindable, prop: prop, scope: scope }) {
        return {
            highlightedValue: bindable(()=>({
                    defaultValue: prop("defaultHighlightedValue") || null,
                    value: prop("highlightedValue"),
                    onChange (value) {
                        prop("onHighlightChange")?.({
                            highlightedValue: value
                        });
                    }
                })),
            lastHighlightedValue: bindable(()=>({
                    defaultValue: null
                })),
            currentPlacement: bindable(()=>({
                    defaultValue: void 0
                })),
            intentPolygon: bindable(()=>({
                    defaultValue: null
                })),
            anchorPoint: bindable(()=>({
                    defaultValue: null,
                    hash (value) {
                        return `x: ${value?.x}, y: ${value?.y}`;
                    }
                })),
            isSubmenu: bindable(()=>({
                    defaultValue: false
                })),
            triggerValue: bindable(()=>({
                    defaultValue: prop("defaultTriggerValue") ?? null,
                    value: prop("triggerValue"),
                    onChange (value) {
                        const onTriggerValueChange = prop("onTriggerValueChange");
                        if (!onTriggerValueChange) return;
                        const triggerElement = $e2a831972683bd14$export$65278ba5d6c7842c(scope, value);
                        onTriggerValueChange({
                            value: value,
                            triggerElement: triggerElement
                        });
                    }
                })),
            pointerRoutingMode: bindable(()=>({
                    defaultValue: "interactive"
                }))
        };
    },
    refs () {
        return {
            parent: null,
            children: {},
            pointerRoutingLocked: false,
            typeaheadState: {
                ...(0, $003f865683614b2e$export$ec2dfd1ac255c804).defaultOptions
            },
            positioningOverride: {}
        };
    },
    computed: {
        isRtl: ({ prop: prop })=>prop("dir") === "rtl",
        isTypingAhead: ({ refs: refs })=>refs.get("typeaheadState").keysSoFar !== "",
        highlightedId: ({ context: context, scope: scope, refs: refs })=>(0, $c141fa4f0b98c2f1$export$2795e608634ff49d)(refs.get("children"), context.get("highlightedValue"), scope)
    },
    watch ({ track: track, action: action, context: context, prop: prop }) {
        track([
            ()=>context.get("isSubmenu")
        ], ()=>{
            action([
                "setSubmenuPlacement"
            ]);
        });
        track([
            ()=>context.hash("anchorPoint")
        ], ()=>{
            if (!context.get("anchorPoint")) return;
            action([
                "reposition"
            ]);
        });
        track([
            ()=>prop("open")
        ], ()=>{
            action([
                "toggleVisibility"
            ]);
        });
    },
    on: {
        "TRIGGER_VALUE.SET": {
            actions: [
                "setTriggerValue",
                "setAnchorPoint",
                "reposition",
                "focusMenu"
            ]
        },
        "PARENT.SET": {
            actions: [
                "setParentMenu"
            ]
        },
        "CHILD.SET": {
            actions: [
                "setChildMenu"
            ]
        },
        OPEN: [
            {
                guard: "isOpenControlled",
                actions: [
                    "setTriggerValue",
                    "invokeOnOpen"
                ]
            },
            {
                target: "open",
                actions: [
                    "setTriggerValue",
                    "invokeOnOpen"
                ]
            }
        ],
        OPEN_AUTOFOCUS: [
            {
                guard: "isOpenControlled",
                actions: [
                    "setTriggerValue",
                    "invokeOnOpen"
                ]
            },
            {
                // internal: true,
                target: "open",
                actions: [
                    "setTriggerValue",
                    "highlightFirstItem",
                    "invokeOnOpen"
                ]
            }
        ],
        CLOSE: [
            {
                guard: "isOpenControlled",
                actions: [
                    "invokeOnClose",
                    "releaseParentRoutingLock"
                ]
            },
            {
                target: "closed",
                actions: [
                    "invokeOnClose",
                    "releaseParentRoutingLock",
                    "focusTrigger"
                ]
            }
        ],
        "HIGHLIGHTED.RESTORE": {
            actions: [
                "restoreHighlightedItem"
            ]
        },
        "HIGHLIGHTED.SET": {
            actions: [
                "setHighlightedItem"
            ]
        },
        "HIGHLIGHTED.SUGGEST": {
            actions: [
                "suggestHighlightedItem"
            ]
        }
    },
    states: {
        idle: {
            tags: [
                "closed"
            ],
            on: {
                "CONTROLLED.OPEN": {
                    target: "open"
                },
                "CONTROLLED.CLOSE": {
                    target: "closed"
                },
                CONTEXT_MENU_START: {
                    target: "opening:contextmenu",
                    actions: [
                        "setAnchorPoint",
                        "setTriggerValue"
                    ]
                },
                CONTEXT_MENU: [
                    {
                        guard: "isOpenControlled",
                        actions: [
                            "setAnchorPoint",
                            "setTriggerValue",
                            "invokeOnOpen"
                        ]
                    },
                    {
                        target: "open",
                        actions: [
                            "setAnchorPoint",
                            "setTriggerValue",
                            "invokeOnOpen"
                        ]
                    }
                ],
                TRIGGER_CLICK: [
                    {
                        guard: "isOpenControlled",
                        actions: [
                            "invokeOnOpen",
                            "setTriggerValue"
                        ]
                    },
                    {
                        target: "open",
                        actions: [
                            "invokeOnOpen",
                            "setTriggerValue"
                        ]
                    }
                ],
                TRIGGER_FOCUS: {
                    guard: $0d3e2a822fd3cd61$var$not("isSubmenu"),
                    target: "closed"
                },
                TRIGGER_POINTERMOVE: {
                    guard: "isSubmenu",
                    target: "opening"
                }
            }
        },
        "opening:contextmenu": {
            tags: [
                "closed"
            ],
            effects: [
                "waitForLongPress"
            ],
            on: {
                "CONTROLLED.OPEN": {
                    target: "open"
                },
                "CONTROLLED.CLOSE": {
                    target: "closed",
                    actions: [
                        "focusTrigger"
                    ]
                },
                CONTEXT_MENU_CANCEL: [
                    {
                        guard: "isOpenControlled",
                        actions: [
                            "invokeOnClose",
                            "releaseParentRoutingLock"
                        ]
                    },
                    {
                        target: "closed",
                        actions: [
                            "invokeOnClose",
                            "releaseParentRoutingLock",
                            "focusTrigger"
                        ]
                    }
                ],
                "LONG_PRESS.OPEN": [
                    {
                        guard: "isOpenControlled",
                        actions: [
                            "setTriggerValue",
                            "invokeOnOpen"
                        ]
                    },
                    {
                        target: "open",
                        actions: [
                            "setTriggerValue",
                            "invokeOnOpen"
                        ]
                    }
                ]
            }
        },
        opening: {
            tags: [
                "closed"
            ],
            effects: [
                "waitForOpenDelay"
            ],
            on: {
                "CONTROLLED.OPEN": {
                    target: "open"
                },
                "CONTROLLED.CLOSE": {
                    target: "closed",
                    actions: [
                        "focusTrigger"
                    ]
                },
                BLUR: [
                    {
                        guard: "isOpenControlled",
                        actions: [
                            "invokeOnClose",
                            "releaseParentRoutingLock"
                        ]
                    },
                    {
                        target: "closed",
                        actions: [
                            "invokeOnClose",
                            "releaseParentRoutingLock",
                            "focusTrigger"
                        ]
                    }
                ],
                TRIGGER_POINTERLEAVE: [
                    {
                        guard: "isOpenControlled",
                        actions: [
                            "invokeOnClose",
                            "releaseParentRoutingLock"
                        ]
                    },
                    {
                        target: "closed",
                        actions: [
                            "invokeOnClose",
                            "releaseParentRoutingLock",
                            "focusTrigger"
                        ]
                    }
                ],
                "DELAY.OPEN": [
                    {
                        guard: "isOpenControlled",
                        actions: [
                            "invokeOnOpen"
                        ]
                    },
                    {
                        target: "open",
                        actions: [
                            "invokeOnOpen"
                        ]
                    }
                ]
            }
        },
        closing: {
            tags: [
                "open"
            ],
            effects: [
                "trackPointerMove",
                "trackInteractOutside",
                "waitForCloseDelay"
            ],
            on: {
                "CONTROLLED.OPEN": {
                    target: "open"
                },
                "CONTROLLED.CLOSE": {
                    target: "closed",
                    actions: [
                        "focusParentMenu",
                        "restoreParentHighlightedItem"
                    ]
                },
                // don't invoke on open here since the menu is still open (we're only keeping it open)
                MENU_POINTERENTER: {
                    target: "open",
                    actions: [
                        "clearIntentPolygon"
                    ]
                },
                POINTER_MOVED_AWAY_FROM_SUBMENU: [
                    {
                        guard: "isOpenControlled",
                        actions: [
                            "invokeOnClose",
                            "releaseParentRoutingLock"
                        ]
                    },
                    {
                        target: "closed",
                        actions: [
                            "focusParentMenu",
                            "restoreParentHighlightedItem"
                        ]
                    }
                ],
                "DELAY.CLOSE": [
                    {
                        guard: "isOpenControlled",
                        actions: [
                            "invokeOnClose",
                            "releaseParentRoutingLock"
                        ]
                    },
                    {
                        target: "closed",
                        actions: [
                            "focusParentMenu",
                            "restoreParentHighlightedItem",
                            "invokeOnClose",
                            "releaseParentRoutingLock"
                        ]
                    }
                ]
            }
        },
        closed: {
            tags: [
                "closed"
            ],
            entry: [
                "clearHighlightedItem",
                "unlockParentOnClose",
                "clearAnchorPoint"
            ],
            on: {
                "CONTROLLED.OPEN": [
                    {
                        guard: $0d3e2a822fd3cd61$var$or("isOpenAutoFocusEvent", "isArrowDownEvent"),
                        target: "open",
                        actions: [
                            "highlightFirstItem"
                        ]
                    },
                    {
                        guard: "isArrowUpEvent",
                        target: "open",
                        actions: [
                            "highlightLastItem"
                        ]
                    },
                    {
                        target: "open"
                    }
                ],
                CONTEXT_MENU_START: {
                    target: "opening:contextmenu",
                    actions: [
                        "setAnchorPoint",
                        "setTriggerValue"
                    ]
                },
                CONTEXT_MENU: [
                    {
                        guard: "isOpenControlled",
                        actions: [
                            "setAnchorPoint",
                            "setTriggerValue",
                            "invokeOnOpen"
                        ]
                    },
                    {
                        target: "open",
                        actions: [
                            "setAnchorPoint",
                            "setTriggerValue",
                            "invokeOnOpen"
                        ]
                    }
                ],
                TRIGGER_CLICK: [
                    {
                        guard: "isOpenControlled",
                        actions: [
                            "invokeOnOpen",
                            "setTriggerValue"
                        ]
                    },
                    {
                        target: "open",
                        actions: [
                            "invokeOnOpen",
                            "setTriggerValue"
                        ]
                    }
                ],
                TRIGGER_POINTERMOVE: {
                    guard: "isTriggerItem",
                    target: "opening"
                },
                TRIGGER_BLUR: {
                    target: "idle"
                },
                ARROW_DOWN: [
                    {
                        guard: "isOpenControlled",
                        actions: [
                            "setTriggerValue",
                            "invokeOnOpen"
                        ]
                    },
                    {
                        target: "open",
                        actions: [
                            "setTriggerValue",
                            "highlightFirstItem",
                            "invokeOnOpen"
                        ]
                    }
                ],
                ARROW_UP: [
                    {
                        guard: "isOpenControlled",
                        actions: [
                            "setTriggerValue",
                            "invokeOnOpen"
                        ]
                    },
                    {
                        target: "open",
                        actions: [
                            "setTriggerValue",
                            "highlightLastItem",
                            "invokeOnOpen"
                        ]
                    }
                ]
            }
        },
        open: {
            tags: [
                "open"
            ],
            effects: [
                "trackInteractOutside",
                "trackFocusVisible",
                "trackPositioning",
                "scrollToHighlightedItem"
            ],
            entry: [
                "focusMenu",
                "unlockParentOnOpen"
            ],
            on: {
                "CONTROLLED.CLOSE": [
                    {
                        target: "closed",
                        guard: "isArrowLeftEvent",
                        actions: [
                            "focusParentMenu"
                        ]
                    },
                    {
                        target: "closed",
                        actions: [
                            "focusTrigger"
                        ]
                    }
                ],
                TRIGGER_CLICK: [
                    {
                        guard: $0d3e2a822fd3cd61$var$and($0d3e2a822fd3cd61$var$not("isTriggerItem"), "isOpenControlled"),
                        actions: [
                            "invokeOnClose",
                            "releaseParentRoutingLock"
                        ]
                    },
                    {
                        guard: $0d3e2a822fd3cd61$var$not("isTriggerItem"),
                        target: "closed",
                        actions: [
                            "invokeOnClose",
                            "releaseParentRoutingLock",
                            "focusTrigger"
                        ]
                    }
                ],
                CONTEXT_MENU: {
                    actions: [
                        "setAnchorPoint",
                        "setTriggerValue",
                        "focusMenu"
                    ]
                },
                ARROW_UP: {
                    actions: [
                        "highlightPrevItem",
                        "focusMenu"
                    ]
                },
                ARROW_DOWN: {
                    actions: [
                        "highlightNextItem",
                        "focusMenu"
                    ]
                },
                ARROW_LEFT: [
                    {
                        guard: $0d3e2a822fd3cd61$var$and("isSubmenu", "isOpenControlled"),
                        actions: [
                            "invokeOnClose",
                            "releaseParentRoutingLock"
                        ]
                    },
                    {
                        guard: "isSubmenu",
                        target: "closed",
                        actions: [
                            "focusParentMenu",
                            "invokeOnClose",
                            "releaseParentRoutingLock"
                        ]
                    }
                ],
                HOME: {
                    actions: [
                        "highlightFirstItem",
                        "focusMenu"
                    ]
                },
                END: {
                    actions: [
                        "highlightLastItem",
                        "focusMenu"
                    ]
                },
                ARROW_RIGHT: {
                    guard: "isTriggerItemHighlighted",
                    actions: [
                        "openSubmenu"
                    ]
                },
                ENTER: [
                    {
                        guard: "isTriggerItemHighlighted",
                        actions: [
                            "openSubmenu"
                        ]
                    },
                    {
                        actions: [
                            "clickHighlightedItem"
                        ]
                    }
                ],
                ITEM_POINTERMOVE: [
                    {
                        guard: $0d3e2a822fd3cd61$var$not("isPointerRoutingLocked"),
                        actions: [
                            "setHighlightedItem",
                            "focusMenu",
                            "closeSiblingMenus"
                        ]
                    },
                    {
                        actions: [
                            "setLastHighlightedItem",
                            "closeSiblingMenus"
                        ]
                    }
                ],
                ITEM_POINTERLEAVE: {
                    guard: $0d3e2a822fd3cd61$var$and($0d3e2a822fd3cd61$var$not("isPointerRoutingLocked"), $0d3e2a822fd3cd61$var$not("isTriggerItem")),
                    actions: [
                        "clearHighlightedItem"
                    ]
                },
                ITEM_CLICK: [
                    // == grouped ==
                    {
                        guard: $0d3e2a822fd3cd61$var$and($0d3e2a822fd3cd61$var$not("isTriggerItemHighlighted"), $0d3e2a822fd3cd61$var$not("isHighlightedItemEditable"), "closeOnSelect", "isOpenControlled"),
                        actions: [
                            "invokeOnSelect",
                            "setOptionState",
                            "closeRootMenu",
                            "invokeOnClose",
                            "releaseParentRoutingLock"
                        ]
                    },
                    {
                        guard: $0d3e2a822fd3cd61$var$and($0d3e2a822fd3cd61$var$not("isTriggerItemHighlighted"), $0d3e2a822fd3cd61$var$not("isHighlightedItemEditable"), "closeOnSelect"),
                        target: "closed",
                        actions: [
                            "invokeOnSelect",
                            "setOptionState",
                            "closeRootMenu",
                            "invokeOnClose",
                            "releaseParentRoutingLock",
                            "focusTrigger"
                        ]
                    },
                    //
                    {
                        guard: $0d3e2a822fd3cd61$var$and($0d3e2a822fd3cd61$var$not("isTriggerItemHighlighted"), $0d3e2a822fd3cd61$var$not("isHighlightedItemEditable")),
                        actions: [
                            "invokeOnSelect",
                            "setOptionState"
                        ]
                    },
                    {
                        actions: [
                            "setHighlightedItem"
                        ]
                    }
                ],
                TRIGGER_POINTERMOVE: {
                    guard: "isTriggerItem",
                    actions: [
                        "setIntentPolygon"
                    ]
                },
                TRIGGER_POINTERLEAVE: {
                    target: "closing",
                    actions: [
                        "setIntentPolygon"
                    ]
                },
                ITEM_POINTERDOWN: {
                    actions: [
                        "setHighlightedItem"
                    ]
                },
                TYPEAHEAD: {
                    actions: [
                        "highlightMatchedItem"
                    ]
                },
                FOCUS_MENU: {
                    actions: [
                        "focusMenu"
                    ]
                },
                "POSITIONING.SET": {
                    actions: [
                        "reposition"
                    ]
                }
            }
        }
    },
    implementations: {
        guards: {
            closeOnSelect: ({ prop: prop, event: event })=>!!(event?.closeOnSelect ?? prop("closeOnSelect")),
            // whether the trigger is also a menu item
            isTriggerItem: ({ event: event })=>$e2a831972683bd14$export$346e78231de82972(event.target),
            // whether the trigger item is the active item
            isTriggerItemHighlighted: ({ event: event, scope: scope, computed: computed })=>{
                const target = event.target ?? scope.getById(computed("highlightedId"));
                return !!target?.hasAttribute("data-controls");
            },
            isSubmenu: ({ context: context })=>context.get("isSubmenu"),
            isPointerRoutingLocked: ({ refs: refs })=>refs.get("pointerRoutingLocked"),
            isHighlightedItemEditable: ({ scope: scope, computed: computed })=>(0, $2020ec4601cca401$export$2780cb57de98fa3a)(scope.getById(computed("highlightedId"))),
            // guard assertions (for controlled mode)
            isOpenControlled: ({ prop: prop })=>prop("open") !== void 0,
            isArrowLeftEvent: ({ event: event })=>event.previousEvent?.type === "ARROW_LEFT",
            isArrowUpEvent: ({ event: event })=>event.previousEvent?.type === "ARROW_UP",
            isArrowDownEvent: ({ event: event })=>event.previousEvent?.type === "ARROW_DOWN",
            isOpenAutoFocusEvent: ({ event: event })=>event.previousEvent?.type === "OPEN_AUTOFOCUS"
        },
        effects: {
            waitForOpenDelay ({ send: send }) {
                const timer = setTimeout(()=>{
                    send({
                        type: "DELAY.OPEN"
                    });
                }, 200);
                return ()=>clearTimeout(timer);
            },
            waitForCloseDelay ({ send: send }) {
                const timer = setTimeout(()=>{
                    send({
                        type: "DELAY.CLOSE"
                    });
                }, 100);
                return ()=>clearTimeout(timer);
            },
            waitForLongPress ({ send: send }) {
                const timer = setTimeout(()=>{
                    send({
                        type: "LONG_PRESS.OPEN"
                    });
                }, 700);
                return ()=>clearTimeout(timer);
            },
            trackFocusVisible ({ scope: scope }) {
                return (0, $855e001ba27d7a0a$export$920b4983565c6f4d)({
                    root: scope.getRootNode?.()
                });
            },
            trackPositioning ({ context: context, prop: prop, scope: scope, refs: refs }) {
                const hasContextTrigger = $e2a831972683bd14$export$c494aba29bd73987(scope) || $e2a831972683bd14$export$f457fab4bd77e2ea(scope).length > 0;
                if (hasContextTrigger) return;
                const positioning = {
                    ...prop("positioning"),
                    ...refs.get("positioningOverride")
                };
                context.set("currentPlacement", positioning.placement);
                const getPositionerEl2 = ()=>$e2a831972683bd14$export$804920e034783925(scope);
                const getTriggerEl2 = ()=>$e2a831972683bd14$export$65278ba5d6c7842c(scope, context.get("triggerValue"));
                return (0, $21d1221b99f40370$export$a9fe23cfa43a7b55)(getTriggerEl2, getPositionerEl2, {
                    ...positioning,
                    defer: true,
                    onComplete (data) {
                        context.set("currentPlacement", data.placement);
                    }
                });
            },
            trackInteractOutside ({ refs: refs, scope: scope, prop: prop, context: context, send: send }) {
                const getContentEl2 = ()=>$e2a831972683bd14$export$64fc6550ad675c6a(scope);
                let restoreFocus = true;
                const isWithinAnyContextTrigger = (target)=>{
                    return $e2a831972683bd14$export$f457fab4bd77e2ea(scope).some((el)=>(0, $2020ec4601cca401$export$2344b14b097df817)(el, target));
                };
                return (0, $1492ced6e5ccca82$export$72bda0e502b8ea31)(getContentEl2, {
                    type: "menu",
                    defer: true,
                    exclude: [
                        $e2a831972683bd14$export$12a544abb5462f68(scope),
                        ...$e2a831972683bd14$export$cb60912464303603(scope)
                    ].filter(Boolean),
                    onInteractOutside: prop("onInteractOutside"),
                    onRequestDismiss: prop("onRequestDismiss"),
                    onFocusOutside (event) {
                        prop("onFocusOutside")?.(event);
                        const target = (0, $3921311bf0c8eca9$export$e58f029f0fbfdb29)(event.detail.originalEvent);
                        if (isWithinAnyContextTrigger(target)) {
                            event.preventDefault();
                            return;
                        }
                        if ($e2a831972683bd14$export$885fe302e905afa4(target, refs.get("children"))) {
                            event.preventDefault();
                            return;
                        }
                    },
                    onEscapeKeyDown (event) {
                        prop("onEscapeKeyDown")?.(event);
                        if (context.get("isSubmenu")) event.preventDefault();
                        (0, $c141fa4f0b98c2f1$export$a414386e289ef249)({
                            parent: refs.get("parent")
                        });
                    },
                    onPointerDownOutside (event) {
                        prop("onPointerDownOutside")?.(event);
                        const target = (0, $3921311bf0c8eca9$export$e58f029f0fbfdb29)(event.detail.originalEvent);
                        if (isWithinAnyContextTrigger(target) && event.detail.contextmenu) {
                            event.preventDefault();
                            return;
                        }
                        restoreFocus = !event.detail.focusable;
                    },
                    onDismiss () {
                        send({
                            type: "CLOSE",
                            src: "interact-outside",
                            restoreFocus: restoreFocus
                        });
                    }
                });
            },
            trackPointerMove ({ context: context, scope: scope, send: send, refs: refs }) {
                const parent = refs.get("parent");
                if (!parent) return;
                (0, $c141fa4f0b98c2f1$export$8877b15d2440adec)(parent, true);
                const doc = scope.getDoc();
                return (0, $3921311bf0c8eca9$export$b1d829ddf82884aa)(doc, "pointermove", (e)=>{
                    const isMovingToSubmenu = (0, $c141fa4f0b98c2f1$export$543769d13aa9fabe)(context.get("intentPolygon"), {
                        x: e.clientX,
                        y: e.clientY
                    });
                    if (!isMovingToSubmenu) {
                        send({
                            type: "POINTER_MOVED_AWAY_FROM_SUBMENU"
                        });
                        (0, $c141fa4f0b98c2f1$export$8877b15d2440adec)(parent, false);
                    }
                });
            },
            scrollToHighlightedItem ({ scope: scope, computed: computed }) {
                const exec = ()=>{
                    const modality = (0, $855e001ba27d7a0a$export$630ff653c5ada6a9)();
                    if (modality === "pointer") return;
                    const itemEl = scope.getById(computed("highlightedId"));
                    const contentEl2 = $e2a831972683bd14$export$64fc6550ad675c6a(scope);
                    (0, $fbb58d2afdfa6a78$export$53a0910f038337bd)(itemEl, {
                        rootEl: contentEl2,
                        block: "nearest"
                    });
                };
                (0, $7eacfb22d5a39e52$export$27f233d61a9e2fa4)(()=>{
                    (0, $855e001ba27d7a0a$export$8397ddfc504fdb9a)("virtual");
                    exec();
                });
                const contentEl = ()=>$e2a831972683bd14$export$64fc6550ad675c6a(scope);
                return (0, $40156009e740736b$export$343af0d656c88488)(contentEl, {
                    defer: true,
                    attributes: [
                        "aria-activedescendant"
                    ],
                    callback: exec
                });
            }
        },
        actions: {
            setAnchorPoint ({ context: context, event: event }) {
                context.set("anchorPoint", (prev)=>(0, $762ebc5b7ffef91d$export$248d38f6296296c5)(prev, event.point) ? prev : event.point);
            },
            setSubmenuPlacement ({ context: context, computed: computed, refs: refs }) {
                if (!context.get("isSubmenu")) return;
                const placement = computed("isRtl") ? "left-start" : "right-start";
                refs.set("positioningOverride", {
                    placement: placement,
                    gutter: 0
                });
            },
            reposition ({ context: context, scope: scope, prop: prop, event: event, refs: refs }) {
                const getPositionerEl2 = ()=>$e2a831972683bd14$export$804920e034783925(scope);
                const anchorPoint = event.point ?? context.get("anchorPoint");
                const getAnchorRect = anchorPoint ? ()=>({
                        width: 0,
                        height: 0,
                        ...anchorPoint
                    }) : void 0;
                const positioning = {
                    ...prop("positioning"),
                    ...refs.get("positioningOverride")
                };
                const triggerValue = event.value ?? context.get("triggerValue");
                const getTriggerEl2 = ()=>$e2a831972683bd14$export$65278ba5d6c7842c(scope, triggerValue);
                (0, $21d1221b99f40370$export$a9fe23cfa43a7b55)(getTriggerEl2, getPositionerEl2, {
                    ...positioning,
                    defer: true,
                    getAnchorRect: getAnchorRect,
                    ...event.options ?? {},
                    listeners: false,
                    onComplete (data) {
                        context.set("currentPlacement", data.placement);
                    }
                });
            },
            setOptionState ({ event: event }) {
                if (!event.option) return;
                const { checked: checked, onCheckedChange: onCheckedChange, type: type } = event.option;
                if (type === "radio") onCheckedChange?.(true);
                else if (type === "checkbox") onCheckedChange?.(!checked);
            },
            clickHighlightedItem ({ scope: scope, computed: computed, prop: prop, context: context }) {
                const itemEl = scope.getById(computed("highlightedId"));
                if (!itemEl || itemEl.dataset.disabled) return;
                const highlightedValue = context.get("highlightedValue");
                if ((0, $2020ec4601cca401$export$1800cc20d529d764)(itemEl)) prop("navigate")?.({
                    value: highlightedValue,
                    node: itemEl,
                    href: itemEl.href
                });
                else queueMicrotask(()=>itemEl.click());
            },
            setIntentPolygon ({ context: context, scope: scope, event: event }) {
                const menu = $e2a831972683bd14$export$64fc6550ad675c6a(scope);
                const placement = context.get("currentPlacement");
                if (!menu || !placement) return;
                const rect = menu.getBoundingClientRect();
                const polygon = (0, $cfeed72c908c33f9$export$a818e5abc94ef05a)(rect, placement);
                if (!polygon) return;
                const rightSide = (0, $666fb7dd4ba30f64$export$2f5876c005418271)(placement) === "right";
                const bleed = rightSide ? -5 : 5;
                context.set("intentPolygon", [
                    {
                        ...event.point,
                        x: event.point.x + bleed
                    },
                    ...polygon
                ]);
            },
            clearIntentPolygon ({ context: context }) {
                context.set("intentPolygon", null);
            },
            clearAnchorPoint ({ context: context }) {
                context.set("anchorPoint", null);
            },
            unlockParentOnOpen ({ refs: refs, context: context, scope: scope }) {
                const parent = refs.get("parent");
                if (context.get("isSubmenu")) {
                    const value = $e2a831972683bd14$export$1e04a9a9d2b169fc(scope);
                    parent?.send({
                        type: "HIGHLIGHTED.SUGGEST",
                        value: value
                    });
                }
                (0, $c141fa4f0b98c2f1$export$8877b15d2440adec)(parent, false);
            },
            unlockParentOnClose ({ refs: refs, context: context }) {
                (0, $c141fa4f0b98c2f1$export$497a7b39249085d4)(refs.get("parent"), context.get("isSubmenu"));
            },
            setHighlightedItem ({ context: context, event: event }) {
                const value = event.value || $e2a831972683bd14$export$eb68a5138033012f(event.target);
                context.set("highlightedValue", value);
            },
            clearHighlightedItem ({ context: context }) {
                context.set("highlightedValue", null);
            },
            focusMenu ({ scope: scope }) {
                (0, $7eacfb22d5a39e52$export$27f233d61a9e2fa4)(()=>{
                    const contentEl = $e2a831972683bd14$export$64fc6550ad675c6a(scope);
                    const initialFocusEl = (0, $0fc785dfc7f02888$export$af1ff6d51ec218ea)({
                        root: contentEl,
                        enabled: !(0, $2020ec4601cca401$export$2344b14b097df817)(contentEl, scope.getActiveElement()),
                        filter (node) {
                            return !node.role?.startsWith("menuitem");
                        }
                    });
                    initialFocusEl?.focus({
                        preventScroll: true
                    });
                });
            },
            highlightFirstItem ({ context: context, scope: scope }) {
                const fn = $e2a831972683bd14$export$64fc6550ad675c6a(scope) ? queueMicrotask : (0, $7eacfb22d5a39e52$export$27f233d61a9e2fa4);
                fn(()=>{
                    const first = $e2a831972683bd14$export$b14393ce5c5ed429(scope);
                    if (!first) return;
                    context.set("highlightedValue", $e2a831972683bd14$export$eb68a5138033012f(first));
                });
            },
            highlightLastItem ({ context: context, scope: scope }) {
                const fn = $e2a831972683bd14$export$64fc6550ad675c6a(scope) ? queueMicrotask : (0, $7eacfb22d5a39e52$export$27f233d61a9e2fa4);
                fn(()=>{
                    const last = $e2a831972683bd14$export$469c33ba501dacae(scope);
                    if (!last) return;
                    context.set("highlightedValue", $e2a831972683bd14$export$eb68a5138033012f(last));
                });
            },
            highlightNextItem ({ context: context, scope: scope, event: event, prop: prop }) {
                const next = $e2a831972683bd14$export$cd67ed7569e5b07c(scope, {
                    loop: event.loop,
                    value: context.get("highlightedValue"),
                    loopFocus: prop("loopFocus")
                });
                context.set("highlightedValue", $e2a831972683bd14$export$eb68a5138033012f(next));
            },
            highlightPrevItem ({ context: context, scope: scope, event: event, prop: prop }) {
                const prev = $e2a831972683bd14$export$b4cefc370d4fb9bf(scope, {
                    loop: event.loop,
                    value: context.get("highlightedValue"),
                    loopFocus: prop("loopFocus")
                });
                context.set("highlightedValue", $e2a831972683bd14$export$eb68a5138033012f(prev));
            },
            invokeOnSelect ({ context: context, prop: prop, scope: scope }) {
                const value = context.get("highlightedValue");
                if (value == null) return;
                const node = $e2a831972683bd14$export$6e8e39b439e87795(scope, value);
                $e2a831972683bd14$export$95d5aa9cdb910210(node, value);
                prop("onSelect")?.({
                    value: value
                });
            },
            focusTrigger ({ scope: scope, context: context, event: event }) {
                if (context.get("isSubmenu") || context.get("anchorPoint") || event.restoreFocus === false) return;
                queueMicrotask(()=>{
                    const triggerEl = $e2a831972683bd14$export$65278ba5d6c7842c(scope, context.get("triggerValue"));
                    triggerEl?.focus({
                        preventScroll: true
                    });
                });
            },
            highlightMatchedItem ({ scope: scope, context: context, event: event, refs: refs }) {
                const node = $e2a831972683bd14$export$a4c95f003f8db604(scope, {
                    key: event.key,
                    value: context.get("highlightedValue"),
                    typeaheadState: refs.get("typeaheadState")
                });
                if (!node) return;
                context.set("highlightedValue", $e2a831972683bd14$export$eb68a5138033012f(node));
            },
            setParentMenu ({ refs: refs, event: event, context: context }) {
                refs.set("parent", event.value);
                context.set("isSubmenu", true);
            },
            setChildMenu ({ refs: refs, event: event }) {
                const children = refs.get("children");
                children[event.id] = event.value;
                refs.set("children", children);
            },
            closeSiblingMenus ({ refs: refs, event: event, scope: scope }) {
                const target = event.target;
                if (!$e2a831972683bd14$export$346e78231de82972(target)) return;
                const hoveredChildId = target?.getAttribute("data-uid");
                const children = refs.get("children");
                for(const id in children){
                    if (id === hoveredChildId) continue;
                    const child = children[id];
                    const intentPolygon = child.context.get("intentPolygon");
                    if (intentPolygon && event.point && (0, $cfeed72c908c33f9$export$f1c31811357415ac)(intentPolygon, event.point)) continue;
                    $e2a831972683bd14$export$64fc6550ad675c6a(scope)?.focus({
                        preventScroll: true
                    });
                    child.send({
                        type: "CLOSE"
                    });
                }
            },
            closeRootMenu ({ refs: refs }) {
                (0, $c141fa4f0b98c2f1$export$a414386e289ef249)({
                    parent: refs.get("parent")
                });
            },
            openSubmenu ({ refs: refs, scope: scope, computed: computed }) {
                const item = scope.getById(computed("highlightedId"));
                const id = item?.getAttribute("data-uid");
                const children = refs.get("children");
                const child = id ? children[id] : null;
                child?.send({
                    type: "OPEN_AUTOFOCUS"
                });
            },
            focusParentMenu ({ refs: refs }) {
                refs.get("parent")?.send({
                    type: "FOCUS_MENU"
                });
            },
            setLastHighlightedItem ({ context: context, event: event }) {
                context.set("lastHighlightedValue", $e2a831972683bd14$export$eb68a5138033012f(event.target));
            },
            suggestHighlightedItem ({ context: context, event: event }) {
                const value = event.value;
                if (!value) return;
                if (context.get("highlightedValue") != null) {
                    context.set("lastHighlightedValue", value);
                    return;
                }
                context.set("highlightedValue", value);
            },
            restoreHighlightedItem ({ context: context }) {
                const last = context.get("lastHighlightedValue");
                context.set("lastHighlightedValue", null);
                if (!last) return;
                context.set("highlightedValue", last);
            },
            restoreParentHighlightedItem ({ refs: refs }) {
                refs.get("parent")?.send({
                    type: "HIGHLIGHTED.RESTORE"
                });
            },
            invokeOnOpen ({ prop: prop }) {
                prop("onOpenChange")?.({
                    open: true
                });
            },
            invokeOnClose ({ prop: prop }) {
                prop("onOpenChange")?.({
                    open: false
                });
            },
            releaseParentRoutingLock ({ refs: refs, context: context }) {
                if (!context.get("isSubmenu")) return;
                (0, $c141fa4f0b98c2f1$export$eada56661b3fb874)(refs.get("parent"));
            },
            toggleVisibility ({ prop: prop, event: event, send: send }) {
                send({
                    type: prop("open") ? "CONTROLLED.OPEN" : "CONTROLLED.CLOSE",
                    previousEvent: event
                });
            },
            setTriggerValue ({ context: context, event: event }) {
                if (event.value === void 0) return;
                context.set("triggerValue", event.value);
            }
        }
    }
});



var $8v0nu = parcelRequire("8v0nu");

"use client";
//#region src/components/menu/use-menu.ts
var $92c71339b0190e3b$export$38eaa17faae8f579 = (props)=>{
    const id = (0, $8v0nu.useId)();
    const { getRootNode: getRootNode } = (0, $cfa7a900a06000ef$export$899b1e582a0b3c80)();
    const { dir: dir } = (0, $af19f2672b388a39$export$2a7b1d9f665d6730)();
    const machineProps = {
        id: id,
        dir: dir,
        getRootNode: getRootNode,
        ...props
    };
    const service = (0, $54265883fb157840$export$e0338c4153421160)($0d3e2a822fd3cd61$export$ea56d40cd27c3480, machineProps);
    return {
        api: $4a7e7d375e0ffad4$export$64605811ab45167f(service, (0, $06b0a2ce147a2fe4$export$601abcd8103db5e4)),
        service: service
    };
};



"use client";
//#region src/components/menu/use-menu-machine-context.ts
var [$01f48bf60ddf03ce$export$a6d4316fc49661b4, $01f48bf60ddf03ce$export$3be2a17d43f51472] = (0, $51a09ee1e9e91bf5$export$fd42f52fd3ae1109)({
    name: "MenuMachineContext",
    hookName: "useMenuMachineContext",
    providerName: "<MenuMachineProvider />",
    strict: false
});



"use client";
//#region src/components/menu/use-menu-trigger-item-context.ts
var [$4b4fa5d1e1d55a36$export$720f6f8173d299da, $4b4fa5d1e1d55a36$export$bf56882eb39bd785] = (0, $51a09ee1e9e91bf5$export$fd42f52fd3ae1109)({
    name: "MenuMachineContext",
    hookName: "useMenuMachineContext",
    providerName: "<MenuMachineProvider />",
    strict: false
});



var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/menu/menu-root.tsx
var $572603a76f83e537$var$splitRootProps = (0, $41bdb03050f91b76$export$3ea53b214fbc1986)();
var $572603a76f83e537$export$5ef9b2654717bfc2 = (props)=>{
    const [presenceProps, menuProps] = (0, $efed63aa977b1a61$export$785dc0c15a64f8f7)(props);
    const [useMenuProps, localProps] = $572603a76f83e537$var$splitRootProps(menuProps, [
        "anchorPoint",
        "aria-label",
        "closeOnSelect",
        "composite",
        "defaultHighlightedValue",
        "defaultOpen",
        "highlightedValue",
        "id",
        "ids",
        "loopFocus",
        "navigate",
        "onEscapeKeyDown",
        "onFocusOutside",
        "onHighlightChange",
        "onInteractOutside",
        "onOpenChange",
        "onPointerDownOutside",
        "onRequestDismiss",
        "onSelect",
        "onTriggerValueChange",
        "open",
        "positioning",
        "triggerValue",
        "defaultTriggerValue",
        "typeahead"
    ]);
    const parentApi = (0, $fe3ef04ecfa88898$export$21c7ab35b39f78ec)();
    const parentMachine = (0, $01f48bf60ddf03ce$export$3be2a17d43f51472)();
    const { api: api, service: service } = (0, $92c71339b0190e3b$export$38eaa17faae8f579)(useMenuProps);
    const presence = (0, $3e7c90e8656e783c$export$2a8c16d82a0a0e26)((0, $ea59bff5c9936d72$export$9d1611c77c2fe928)({
        present: api.open
    }, presenceProps));
    (0, $47fcd6611aacf1cb$export$b558662bb0641046)(()=>{
        if (!parentMachine) return;
        if (!parentApi) return;
        parentApi.setChild(service);
        api.setParent(parentMachine);
    });
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $4b4fa5d1e1d55a36$export$720f6f8173d299da), {
        value: (0, $8v0nu.useCallback)(()=>parentApi?.getTriggerItemProps(api), [
            api,
            parentApi
        ]),
        children: /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $01f48bf60ddf03ce$export$a6d4316fc49661b4), {
            value: service,
            children: /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $fe3ef04ecfa88898$export$62b22d151866115d), {
                value: api,
                children: /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $a356685fe9cf7378$export$446d8ecac66007a1), {
                    value: presence,
                    ...localProps
                })
            })
        })
    });
};










var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/menu/menu-root-provider.tsx
var $b30ecb210b13241e$export$4d80086a8fd3b665 = (props)=>{
    const parentApi = (0, $fe3ef04ecfa88898$export$21c7ab35b39f78ec)();
    const parentMachine = (0, $01f48bf60ddf03ce$export$3be2a17d43f51472)();
    const [presenceProps, { value: menu, children: children }] = (0, $efed63aa977b1a61$export$785dc0c15a64f8f7)(props);
    const { api: api, service: service } = menu;
    const presence = (0, $3e7c90e8656e783c$export$2a8c16d82a0a0e26)((0, $ea59bff5c9936d72$export$9d1611c77c2fe928)({
        present: api.open
    }, presenceProps));
    (0, $47fcd6611aacf1cb$export$b558662bb0641046)(()=>{
        if (!parentMachine) return;
        if (!parentApi) return;
        parentApi.setChild(service);
        api.setParent(parentMachine);
    });
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $4b4fa5d1e1d55a36$export$720f6f8173d299da), {
        value: (0, $8v0nu.useCallback)(()=>parentApi?.getTriggerItemProps(api), [
            api,
            parentApi
        ]),
        children: /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $01f48bf60ddf03ce$export$a6d4316fc49661b4), {
            value: service,
            children: /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $fe3ef04ecfa88898$export$62b22d151866115d), {
                value: api,
                children: /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $a356685fe9cf7378$export$446d8ecac66007a1), {
                    value: presence,
                    children: children
                })
            })
        })
    });
};





var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/menu/menu-separator.tsx
var $60700ebd123a0959$export$1cec7dcdd713e220 = (0, $8v0nu.forwardRef)((props, ref)=>{
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)((0, $fe3ef04ecfa88898$export$21c7ab35b39f78ec)().getSeparatorProps(), props);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).hr, {
        ...mergedProps,
        ref: ref
    });
});
$60700ebd123a0959$export$1cec7dcdd713e220.displayName = "MenuSeparator";







var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/menu/menu-trigger.tsx
var $3615b202ad06fcfa$var$splitTriggerProps = (0, $41bdb03050f91b76$export$3ea53b214fbc1986)();
var $3615b202ad06fcfa$export$27d2ad3c5815583e = (0, $8v0nu.forwardRef)((props, ref)=>{
    const [triggerProps, localProps] = $3615b202ad06fcfa$var$splitTriggerProps(props, [
        "value"
    ]);
    const menu = (0, $fe3ef04ecfa88898$export$21c7ab35b39f78ec)();
    const presence = (0, $a356685fe9cf7378$export$de7b90475d798ca5)();
    const triggerPropsRaw = menu.getTriggerProps(triggerProps);
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)({
        ...triggerPropsRaw,
        "aria-controls": presence.unmounted ? void 0 : triggerPropsRaw["aria-controls"]
    }, localProps);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).button, {
        ...mergedProps,
        ref: ref
    });
});
$3615b202ad06fcfa$export$27d2ad3c5815583e.displayName = "MenuTrigger";






var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/menu/menu-trigger-item.tsx
var $5384d4df624584a5$export$e338118280a98c94 = (0, $8v0nu.forwardRef)((props, ref)=>{
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)((0, $4b4fa5d1e1d55a36$export$bf56882eb39bd785)()?.() ?? {}, props);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $56f60baf4f4260db$export$301e650d1d2106a), {
        value: {
            value: mergedProps["data-value"]
        },
        children: /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).div, {
            ...mergedProps,
            ref: ref
        })
    });
});
$5384d4df624584a5$export$e338118280a98c94.displayName = "MenuTriggerItem";


//#region src/components/menu/menu.ts
var $be0577af0de8f4b6$export$1eb36069d400aef2 = /* @__PURE__ */ (0, $57db88e2bf337fea$export$8126e515a7516e2)({
    Arrow: ()=>(0, $b642d58c113413ac$export$bcdda4773debf5fa),
    ArrowTip: ()=>(0, $24a7dfc44c49fbf2$export$e60171086407adcc),
    CheckboxItem: ()=>(0, $97257316e30fb28b$export$f6f243521332502d),
    Content: ()=>(0, $7af7d7b7fdf8c9e4$export$479f0f2f71193efe),
    Context: ()=>(0, $37347a1a39c2703c$export$c7e742effb1c51e2),
    ContextTrigger: ()=>(0, $4c991aa70fd7878e$export$cc43c1053d79d159),
    Indicator: ()=>(0, $aac7e959ebbb79ec$export$ec65978f4ff53791),
    Item: ()=>(0, $3b30a542c92e4009$export$2ce376c2cc3355c8),
    ItemContext: ()=>(0, $87a7f13b804517f0$export$5ebb73512afd7119),
    ItemGroup: ()=>(0, $e7dda0e862ae8182$export$d9dfbb355b82c7b6),
    ItemGroupLabel: ()=>(0, $9d541bd178a4f05b$export$22708feb2fdc2491),
    ItemIndicator: ()=>(0, $92ac553bf71d7d67$export$a2593e23056970a3),
    ItemText: ()=>(0, $8a6f4cb61954c15f$export$c4774e9097375cc0),
    Positioner: ()=>(0, $0369648f50437010$export$fbbef597793ae27b),
    RadioItem: ()=>(0, $bd55a706326b28d1$export$69bd225e9817f6d0),
    RadioItemGroup: ()=>(0, $27be9a83a6c6682c$export$181455e1ce4c2f0e),
    Root: ()=>(0, $572603a76f83e537$export$5ef9b2654717bfc2),
    RootProvider: ()=>(0, $b30ecb210b13241e$export$4d80086a8fd3b665),
    Separator: ()=>(0, $60700ebd123a0959$export$1cec7dcdd713e220),
    Trigger: ()=>(0, $3615b202ad06fcfa$export$27d2ad3c5815583e),
    TriggerItem: ()=>(0, $5384d4df624584a5$export$e338118280a98c94)
});





"use strict";
"use client";
const $2ec3c16c879c0088$export$7dd004358974b05d = (props)=>{
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $4042601bfa1a9d25$export$7cd122d781af9fa4).svg, {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        ...props,
        children: /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)("path", {
            d: "M20 6 9 17l-5-5"
        })
    });
};
const $2ec3c16c879c0088$export$20bc5960c3c9eebb = (props)=>/* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $4042601bfa1a9d25$export$7cd122d781af9fa4).svg, {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        ...props,
        children: /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)("path", {
            d: "m15 18-6-6 6-6"
        })
    });
const $2ec3c16c879c0088$export$7f01a6cbee61a0f2 = (props)=>/* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $4042601bfa1a9d25$export$7cd122d781af9fa4).svg, {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        ...props,
        children: /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)("path", {
            d: "m18 15-6-6-6 6"
        })
    });
const $2ec3c16c879c0088$export$4857d3f3f5f8319b = (props)=>{
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $4042601bfa1a9d25$export$7cd122d781af9fa4).svg, {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        ...props,
        children: /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)("path", {
            d: "m6 9 6 6 6-6"
        })
    });
};
const $2ec3c16c879c0088$export$b837bd7eac09a33e = (props)=>/* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $4042601bfa1a9d25$export$7cd122d781af9fa4).svg, {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        ...props,
        children: /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)("path", {
            d: "m9 18 6-6-6-6"
        })
    });
const $2ec3c16c879c0088$export$438199b039d33c65 = (props)=>/* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsxs)((0, $4042601bfa1a9d25$export$7cd122d781af9fa4).svg, {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        ...props,
        children: [
            /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "1"
            }),
            /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)("circle", {
                cx: "19",
                cy: "12",
                r: "1"
            }),
            /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)("circle", {
                cx: "5",
                cy: "12",
                r: "1"
            })
        ]
    });
const $2ec3c16c879c0088$export$f1a507b991affc46 = (props)=>/* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsxs)((0, $4042601bfa1a9d25$export$7cd122d781af9fa4).svg, {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "3",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        ...props,
        children: [
            /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)("path", {
                d: "m5 12 7-7 7 7"
            }),
            /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)("path", {
                d: "M12 19V5"
            })
        ]
    });
const $2ec3c16c879c0088$export$1c939d3c9b6931b = (props)=>/* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsxs)((0, $4042601bfa1a9d25$export$7cd122d781af9fa4).svg, {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "3",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        ...props,
        children: [
            /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)("path", {
                d: "M12 5v14"
            }),
            /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)("path", {
                d: "m19 12-7 7-7-7"
            })
        ]
    });
const $2ec3c16c879c0088$export$f6dd727656c97851 = (props)=>/* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $4042601bfa1a9d25$export$7cd122d781af9fa4).svg, {
        stroke: "currentColor",
        fill: "currentColor",
        strokeWidth: "0",
        viewBox: "0 0 24 24",
        ...props,
        children: /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)("path", {
            d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM11.0026 16L6.75999 11.7574L8.17421 10.3431L11.0026 13.1716L16.6595 7.51472L18.0737 8.92893L11.0026 16Z"
        })
    });
const $2ec3c16c879c0088$export$f7dc499a72baa103 = (props)=>/* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $4042601bfa1a9d25$export$7cd122d781af9fa4).svg, {
        stroke: "currentColor",
        fill: "currentColor",
        strokeWidth: "0",
        viewBox: "0 0 24 24",
        ...props,
        children: /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)("path", {
            d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM11 15H13V17H11V15ZM11 7H13V13H11V7Z"
        })
    });
const $2ec3c16c879c0088$export$2957fc44b3d2481 = (props)=>/* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $4042601bfa1a9d25$export$7cd122d781af9fa4).svg, {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        stroke: "currentColor",
        strokeWidth: "0",
        ...props,
        children: /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)("path", {
            d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM11 7H13V9H11V7ZM11 11H13V17H11V11Z"
        })
    });
const $2ec3c16c879c0088$export$62bd98fc131b5caa = (props)=>/* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $4042601bfa1a9d25$export$7cd122d781af9fa4).svg, {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        ...props,
        children: /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)("path", {
            d: "M6.5 10c-.223 0-.437.034-.65.065.069-.232.14-.468.254-.68.114-.308.292-.575.469-.844.148-.291.409-.488.601-.737.201-.242.475-.403.692-.604.213-.21.492-.315.714-.463.232-.133.434-.28.65-.35l.539-.222.474-.197-.485-1.938-.597.144c-.191.048-.424.104-.689.171-.271.05-.56.187-.882.312-.318.142-.686.238-1.028.466-.344.218-.741.4-1.091.692-.339.301-.748.562-1.05.945-.33.358-.656.734-.909 1.162-.293.408-.492.856-.702 1.299-.19.443-.343.896-.468 1.336-.237.882-.343 1.72-.384 2.437-.034.718-.014 1.315.028 1.747.015.204.043.402.063.539l.025.168.026-.006A4.5 4.5 0 1 0 6.5 10zm11 0c-.223 0-.437.034-.65.065.069-.232.14-.468.254-.68.114-.308.292-.575.469-.844.148-.291.409-.488.601-.737.201-.242.475-.403.692-.604.213-.21.492-.315.714-.463.232-.133.434-.28.65-.35l.539-.222.474-.197-.485-1.938-.597.144c-.191.048-.424.104-.689.171-.271.05-.56.187-.882.312-.317.143-.686.238-1.028.467-.344.218-.741.4-1.091.692-.339.301-.748.562-1.05.944-.33.358-.656.734-.909 1.162-.293.408-.492.856-.702 1.299-.19.443-.343.896-.468 1.336-.237.882-.343 1.72-.384 2.437-.034.718-.014 1.315.028 1.747.015.204.043.402.063.539l.025.168.026-.006A4.5 4.5 0 1 0 17.5 10z"
        })
    });
const $2ec3c16c879c0088$export$2ee28caa7f1e962e = (props)=>/* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $4042601bfa1a9d25$export$7cd122d781af9fa4).svg, {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        ...props,
        children: /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)("path", {
            d: "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
        })
    });
const $2ec3c16c879c0088$export$19bc16ee58e19b3d = (props)=>/* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $4042601bfa1a9d25$export$7cd122d781af9fa4).svg, {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        ...props,
        children: /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)("path", {
            d: "M11.983,0a12.206,12.206,0,0,0-8.51,3.653A11.8,11.8,0,0,0,0,12.207,11.779,11.779,0,0,0,11.8,24h.214A12.111,12.111,0,0,0,24,11.791h0A11.766,11.766,0,0,0,11.983,0ZM10.5,16.542a1.476,1.476,0,0,1,1.449-1.53h.027a1.527,1.527,0,0,1,1.523,1.47,1.475,1.475,0,0,1-1.449,1.53h-.027A1.529,1.529,0,0,1,10.5,16.542ZM11,12.5v-6a1,1,0,0,1,2,0v6a1,1,0,1,1-2,0Z"
        })
    });
const $2ec3c16c879c0088$export$cae179f078f4b4a4 = (props)=>/* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $4042601bfa1a9d25$export$7cd122d781af9fa4).svg, {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        ...props,
        children: /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M18.7071 6.70711C19.0976 6.31658 19.0976 5.68342 18.7071 5.29289C18.3166 4.90237 17.6834 4.90237 17.2929 5.29289L12 10.5858L6.70711 5.29289C6.31658 4.90237 5.68342 4.90237 5.29289 5.29289C4.90237 5.68342 4.90237 6.31658 5.29289 6.70711L10.5858 12L5.29289 17.2929C4.90237 17.6834 4.90237 18.3166 5.29289 18.7071C5.68342 19.0976 6.31658 19.0976 6.70711 18.7071L12 13.4142L17.2929 18.7071C17.6834 19.0976 18.3166 19.0976 18.7071 18.7071C19.0976 18.3166 19.0976 17.6834 18.7071 17.2929L13.4142 12L18.7071 6.70711Z"
        })
    });
const $2ec3c16c879c0088$export$8c1a3d13e85d78b7 = (props)=>/* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsxs)((0, $4042601bfa1a9d25$export$7cd122d781af9fa4).svg, {
        stroke: "currentColor",
        fill: "none",
        strokeWidth: "2",
        viewBox: "0 0 24 24",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        ...props,
        children: [
            /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)("path", {
                d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
            }),
            /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)("path", {
                d: "M14 2v4a2 2 0 0 0 2 2h4"
            })
        ]
    });
const $2ec3c16c879c0088$export$51b6cd98f8778f0d = (props)=>/* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsxs)((0, $4042601bfa1a9d25$export$7cd122d781af9fa4).svg, {
        stroke: "currentColor",
        fill: "none",
        strokeWidth: "2",
        viewBox: "0 0 24 24",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        ...props,
        children: [
            /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)("rect", {
                width: "14",
                height: "14",
                x: "8",
                y: "8",
                rx: "2",
                ry: "2"
            }),
            /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)("path", {
                d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"
            })
        ]
    });
const $2ec3c16c879c0088$export$f37dac2a8117bdb = (props)=>/* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsxs)((0, $4042601bfa1a9d25$export$7cd122d781af9fa4).svg, {
        stroke: "currentColor",
        fill: "none",
        strokeWidth: "2",
        viewBox: "0 0 24 24",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        ...props,
        children: [
            /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)("path", {
                d: "m2 22 1-1h3l9-9"
            }),
            /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)("path", {
                d: "M3 21v-3l9-9"
            }),
            /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)("path", {
                d: "m15 6 3.4-3.4a2.1 2.1 0 1 1 3 3L18 9l.4.4a2.1 2.1 0 1 1-3 3l-3.8-3.8a2.1 2.1 0 1 1 3-3l.4.4Z"
            })
        ]
    });
const $2ec3c16c879c0088$export$fc6234d5b1c606d7 = (props)=>/* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsxs)((0, $4042601bfa1a9d25$export$7cd122d781af9fa4).svg, {
        stroke: "currentColor",
        fill: "none",
        strokeWidth: "2",
        viewBox: "0 0 24 24",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        ...props,
        children: [
            /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "1"
            }),
            /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)("circle", {
                cx: "19",
                cy: "12",
                r: "1"
            }),
            /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)("circle", {
                cx: "5",
                cy: "12",
                r: "1"
            })
        ]
    });


"use strict";
"use client";
const { withRootProvider: $1e03a4173b333d49$var$withRootProvider, withContext: $1e03a4173b333d49$var$withContext, useStyles: $1e03a4173b333d49$export$e7aea412cbc2ca01, PropsProvider: $1e03a4173b333d49$var$PropsProvider } = (0, $04636a451c2392c0$export$ac7f79c9443925b8)({
    key: "menu"
});
const $1e03a4173b333d49$export$4d80086a8fd3b665 = $1e03a4173b333d49$var$withRootProvider((0, $be0577af0de8f4b6$export$1eb36069d400aef2).RootProvider);
const $1e03a4173b333d49$export$5ef9b2654717bfc2 = $1e03a4173b333d49$var$withRootProvider((0, $be0577af0de8f4b6$export$1eb36069d400aef2).Root, {
    defaultProps: {
        lazyMount: true,
        unmountOnExit: true
    }
});
const $1e03a4173b333d49$export$158a7cd4e9091aae = $1e03a4173b333d49$var$PropsProvider;
const $1e03a4173b333d49$export$27d2ad3c5815583e = $1e03a4173b333d49$var$withContext((0, $be0577af0de8f4b6$export$1eb36069d400aef2).Trigger, "trigger", {
    forwardAsChild: true
});
const $1e03a4173b333d49$export$cc43c1053d79d159 = $1e03a4173b333d49$var$withContext((0, $be0577af0de8f4b6$export$1eb36069d400aef2).ContextTrigger, "contextTrigger", {
    forwardAsChild: true
});
const $1e03a4173b333d49$export$fbbef597793ae27b = $1e03a4173b333d49$var$withContext((0, $be0577af0de8f4b6$export$1eb36069d400aef2).Positioner, "positioner", {
    forwardAsChild: true
});
const $1e03a4173b333d49$export$1cec7dcdd713e220 = $1e03a4173b333d49$var$withContext((0, $be0577af0de8f4b6$export$1eb36069d400aef2).Separator, "separator", {
    forwardAsChild: true
});
const $1e03a4173b333d49$export$479f0f2f71193efe = $1e03a4173b333d49$var$withContext((0, $be0577af0de8f4b6$export$1eb36069d400aef2).Content, "content", {
    forwardAsChild: true
});
const $1e03a4173b333d49$export$e60171086407adcc = $1e03a4173b333d49$var$withContext((0, $be0577af0de8f4b6$export$1eb36069d400aef2).ArrowTip, "arrowTip", {
    forwardAsChild: true
});
const $1e03a4173b333d49$export$bcdda4773debf5fa = $1e03a4173b333d49$var$withContext((0, $be0577af0de8f4b6$export$1eb36069d400aef2).Arrow, "arrow", {
    forwardAsChild: true,
    defaultProps: {
        children: /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)($1e03a4173b333d49$export$e60171086407adcc, {})
    }
});
const $1e03a4173b333d49$export$ec65978f4ff53791 = $1e03a4173b333d49$var$withContext((0, $be0577af0de8f4b6$export$1eb36069d400aef2).Indicator, "indicator", {
    forwardAsChild: true
});
const $1e03a4173b333d49$export$d9dfbb355b82c7b6 = $1e03a4173b333d49$var$withContext((0, $be0577af0de8f4b6$export$1eb36069d400aef2).ItemGroup, "itemGroup", {
    forwardAsChild: true
});
const $1e03a4173b333d49$export$22708feb2fdc2491 = $1e03a4173b333d49$var$withContext((0, $be0577af0de8f4b6$export$1eb36069d400aef2).ItemGroupLabel, "itemGroupLabel", {
    forwardAsChild: true
});
const $1e03a4173b333d49$export$2ce376c2cc3355c8 = $1e03a4173b333d49$var$withContext((0, $be0577af0de8f4b6$export$1eb36069d400aef2).Item, "item", {
    forwardAsChild: true
});
const $1e03a4173b333d49$export$e338118280a98c94 = $1e03a4173b333d49$var$withContext((0, $be0577af0de8f4b6$export$1eb36069d400aef2).TriggerItem, "item", {
    forwardAsChild: true
});
const $1e03a4173b333d49$export$c4774e9097375cc0 = $1e03a4173b333d49$var$withContext((0, $be0577af0de8f4b6$export$1eb36069d400aef2).ItemText, "itemText", {
    forwardAsChild: true
});
const $1e03a4173b333d49$export$aed05792769368ea = $1e03a4173b333d49$var$withContext("kbd", "itemCommand");
const $1e03a4173b333d49$export$a2593e23056970a3 = $1e03a4173b333d49$var$withContext((0, $be0577af0de8f4b6$export$1eb36069d400aef2).ItemIndicator, "itemIndicator", {
    forwardAsChild: true,
    defaultProps: {
        children: /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $2ec3c16c879c0088$export$7dd004358974b05d), {
            boxSize: "4"
        })
    }
});
const $1e03a4173b333d49$export$f6f243521332502d = $1e03a4173b333d49$var$withContext((0, $be0577af0de8f4b6$export$1eb36069d400aef2).CheckboxItem, "item", {
    forwardAsChild: true
});
const $1e03a4173b333d49$export$181455e1ce4c2f0e = $1e03a4173b333d49$var$withContext((0, $be0577af0de8f4b6$export$1eb36069d400aef2).RadioItemGroup, "itemGroup", {
    forwardAsChild: true
});
const $1e03a4173b333d49$export$69bd225e9817f6d0 = $1e03a4173b333d49$var$withContext((0, $be0577af0de8f4b6$export$1eb36069d400aef2).RadioItem, "item", {
    forwardAsChild: true
});
const $1e03a4173b333d49$export$c7e742effb1c51e2 = (0, $be0577af0de8f4b6$export$1eb36069d400aef2).Context;
const $1e03a4173b333d49$export$5ebb73512afd7119 = (0, $be0577af0de8f4b6$export$1eb36069d400aef2).ItemContext;


"use strict";

var $70295da2572f7f22$exports = {};

$parcel$export($70295da2572f7f22$exports, "Field", function () { return $5080b5affd2e2429$export$e1b4f800e67ca2cd; });
$parcel$export($70295da2572f7f22$exports, "Indicator", function () { return $5080b5affd2e2429$export$37a677e0f696702; });
$parcel$export($70295da2572f7f22$exports, "PropsProvider", function () { return $5080b5affd2e2429$export$53a29d47e2ead5b1; });
$parcel$export($70295da2572f7f22$exports, "Root", function () { return $5080b5affd2e2429$export$1fc1fe9a7e570858; });



var $8v0nu = parcelRequire("8v0nu");






"use strict";
"use client";
const [$5080b5affd2e2429$var$NativeSelectBasePropsProvider, $5080b5affd2e2429$var$useNativeSelectBaseProps] = (0, $542c4e2ea7b8b6b9$export$fd42f52fd3ae1109)({
    name: "NativeSelectBasePropsContext",
    hookName: "useNativeSelectBaseProps",
    providerName: "<NativeSelectRoot />",
    strict: false
});
const { withProvider: $5080b5affd2e2429$var$withProvider, useClassNames: $5080b5affd2e2429$var$useClassNames, useStyles: $5080b5affd2e2429$export$4f71c266d401b097, PropsProvider: $5080b5affd2e2429$var$PropsProvider } = (0, $04636a451c2392c0$export$ac7f79c9443925b8)({
    key: "nativeSelect"
});
const $5080b5affd2e2429$export$1fc1fe9a7e570858 = $5080b5affd2e2429$var$withProvider("div", "root", {
    wrapElement (element, props) {
        const field = (0, $df31a980f7a28a5b$export$d02e393030f1ec84)();
        const disabled = Boolean(field?.disabled ?? props.disabled);
        const invalid = Boolean(field?.invalid ?? props.invalid);
        return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)($5080b5affd2e2429$var$NativeSelectBasePropsProvider, {
            value: {
                disabled: disabled,
                invalid: invalid
            },
            children: element
        });
    }
});
const $5080b5affd2e2429$export$53a29d47e2ead5b1 = $5080b5affd2e2429$var$PropsProvider;
const $5080b5affd2e2429$var$StyledSelect = (0, $4042601bfa1a9d25$export$7cd122d781af9fa4)((0, $61e790c8e9adb68c$export$583ec68827c6c3b1).Select, {}, {
    forwardAsChild: true
});
const $5080b5affd2e2429$export$e1b4f800e67ca2cd = (0, $8v0nu.forwardRef)(function NativeSelectField2(props, ref) {
    const { children: children, placeholder: placeholder, unstyled: unstyled, ...restProps } = props;
    const { disabled: disabled, invalid: invalid } = $5080b5affd2e2429$var$useNativeSelectBaseProps();
    const styles = $5080b5affd2e2429$export$4f71c266d401b097();
    const classNames = $5080b5affd2e2429$var$useClassNames();
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsxs)($5080b5affd2e2429$var$StyledSelect, {
        disabled: disabled,
        "data-invalid": (0, $f85b338274abd06b$export$5cc3b7b83e34ade7)(invalid),
        ...restProps,
        ref: ref,
        className: (0, $99474b193e949655$export$a274e22fb40f762e)(classNames.field, props.className),
        css: [
            !unstyled ? styles.field : void 0,
            props.css
        ],
        children: [
            placeholder && /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)("option", {
                value: "",
                children: placeholder
            }),
            children
        ]
    });
});
function $5080b5affd2e2429$export$37a677e0f696702(props) {
    const { unstyled: unstyled, ...restProps } = props;
    const styles = $5080b5affd2e2429$export$4f71c266d401b097();
    const { disabled: disabled, invalid: invalid } = $5080b5affd2e2429$var$useNativeSelectBaseProps();
    const classNames = $5080b5affd2e2429$var$useClassNames();
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $4042601bfa1a9d25$export$7cd122d781af9fa4).div, {
        ...restProps,
        "data-disabled": (0, $f85b338274abd06b$export$5cc3b7b83e34ade7)(disabled),
        "data-invalid": (0, $f85b338274abd06b$export$5cc3b7b83e34ade7)(invalid),
        className: (0, $99474b193e949655$export$a274e22fb40f762e)(classNames.indicator, props.className),
        css: [
            !unstyled ? styles.indicator : void 0,
            props.css
        ],
        children: props.children ?? /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $2ec3c16c879c0088$export$4857d3f3f5f8319b), {})
    });
}


"use strict";



var $8v0nu = parcelRequire("8v0nu");



var $k2dbP = parcelRequire("k2dbP");
"use client";
//#region src/components/portal/portal.tsx
var $25e8aada90e0332f$export$602eac185826482c = (props)=>{
    const { children: children, disabled: disabled } = props;
    const [container, setContainer] = (0, $8v0nu.useState)(props.container?.current);
    const isServer = (0, $8v0nu.useSyncExternalStore)($25e8aada90e0332f$var$subscribe, ()=>false, ()=>true);
    const { getRootNode: getRootNode } = (0, $cfa7a900a06000ef$export$899b1e582a0b3c80)();
    (0, $8v0nu.useEffect)(()=>{
        setContainer(()=>props.container?.current);
    }, [
        props.container
    ]);
    if (isServer || disabled) return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $ef524fb144c5d632$exports.Fragment), {
        children: children
    });
    const mountNode = container ?? $25e8aada90e0332f$var$getPortalNode(getRootNode);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $ef524fb144c5d632$exports.Fragment), {
        children: (0, $8v0nu.Children).map(children, (child)=>(0, $k2dbP.createPortal)(child, mountNode))
    });
};
var $25e8aada90e0332f$var$getPortalNode = (cb)=>{
    const node = cb?.();
    const rootNode = node.getRootNode();
    if ((0, $2020ec4601cca401$export$af51f0f06c0f328a)(rootNode)) return rootNode;
    return (0, $2020ec4601cca401$export$f65ca476c09acec0)(node).body;
};
var $25e8aada90e0332f$var$subscribe = ()=>()=>{};



var $8v0nu = parcelRequire("8v0nu");


"use strict";
const $73e475e2b22cc1e3$var$isNotNullish = (element)=>element != null;
function $73e475e2b22cc1e3$export$915658b6215945a4(target, predicate, options = {}) {
    const { stop: stop, getKey: getKey } = options;
    function inner(value, path = []) {
        if ((0, $02f5f697eb6a66a5$export$a6cdc56e425d0d0a)(value) || Array.isArray(value)) {
            const result = {};
            for (const [prop, child] of Object.entries(value)){
                const key = getKey?.(prop, child) ?? prop;
                const childPath = [
                    ...path,
                    key
                ];
                if (stop?.(value, childPath)) return predicate(value, path);
                const next = inner(child, childPath);
                if ($73e475e2b22cc1e3$var$isNotNullish(next)) result[key] = next;
            }
            return result;
        }
        return predicate(value, path);
    }
    return inner(target);
}
function $73e475e2b22cc1e3$export$d6051a0f7a227332(obj, fn) {
    if (Array.isArray(obj)) return obj.map((value)=>{
        return $73e475e2b22cc1e3$var$isNotNullish(value) ? fn(value) : value;
    });
    if (!(0, $02f5f697eb6a66a5$export$a6cdc56e425d0d0a)(obj)) return $73e475e2b22cc1e3$var$isNotNullish(obj) ? fn(obj) : obj;
    return $73e475e2b22cc1e3$export$915658b6215945a4(obj, (value)=>fn(value));
}




var $8v0nu = parcelRequire("8v0nu");

"use strict";
"use client";
const $b0c5791b137f2783$export$ef2184bd89960b14 = (0, $8v0nu.forwardRef)(function Grid2(props, ref) {
    const { templateAreas: templateAreas, column: column, row: row, autoFlow: autoFlow, autoRows: autoRows, templateRows: templateRows, autoColumns: autoColumns, templateColumns: templateColumns, inline: inline, ...rest } = props;
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $4042601bfa1a9d25$export$7cd122d781af9fa4).div, {
        ...rest,
        ref: ref,
        css: [
            {
                display: inline ? "inline-grid" : "grid",
                gridTemplateAreas: templateAreas,
                gridAutoColumns: autoColumns,
                gridColumn: column,
                gridRow: row,
                gridAutoFlow: autoFlow,
                gridAutoRows: autoRows,
                gridTemplateRows: templateRows,
                gridTemplateColumns: templateColumns
            },
            props.css
        ]
    });
});
$b0c5791b137f2783$export$ef2184bd89960b14.displayName = "Grid";


"use strict";
"use client";
const $64f958309d0faa1a$export$de97fecb6d4b30a5 = (0, $8v0nu.forwardRef)(function SimpleGrid2(props, ref) {
    const { columns: columns, minChildWidth: minChildWidth, ...rest } = props;
    const sys = (0, $771f18fb4c7e08d8$export$e4f18fbc74d20572)();
    const templateColumns = minChildWidth ? $64f958309d0faa1a$var$widthToColumns(minChildWidth, sys) : $64f958309d0faa1a$var$countToColumns(columns);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $b0c5791b137f2783$export$ef2184bd89960b14), {
        ref: ref,
        templateColumns: templateColumns,
        ...rest
    });
});
$64f958309d0faa1a$export$de97fecb6d4b30a5.displayName = "SimpleGrid";
function $64f958309d0faa1a$var$toPx(n) {
    return typeof n === "number" ? `${n}px` : n;
}
function $64f958309d0faa1a$var$widthToColumns(width, sys) {
    return (0, $73e475e2b22cc1e3$export$d6051a0f7a227332)(width, (value)=>{
        const _value = sys.tokens.getVar(`sizes.${value}`, $64f958309d0faa1a$var$toPx(value));
        return value === null ? null : `repeat(auto-fit, minmax(${_value}, 1fr))`;
    });
}
function $64f958309d0faa1a$var$countToColumns(count) {
    return (0, $73e475e2b22cc1e3$export$d6051a0f7a227332)(count, (value)=>value === null ? null : `repeat(${value}, minmax(0, 1fr))`);
}







parcelRequire("8v0nu");
var $d7719bbf505e26b3$exports = {};

$parcel$export($d7719bbf505e26b3$exports, "Body", function () { return $3c5c5b5c512feb20$export$851de33184ecdac4; });
$parcel$export($d7719bbf505e26b3$exports, "Description", function () { return $3c5c5b5c512feb20$export$16e0ed4cb97c00d4; });
$parcel$export($d7719bbf505e26b3$exports, "Footer", function () { return $3c5c5b5c512feb20$export$e9897d434e0741ee; });
$parcel$export($d7719bbf505e26b3$exports, "Header", function () { return $3c5c5b5c512feb20$export$5665775b26e26c5d; });
$parcel$export($d7719bbf505e26b3$exports, "PropsProvider", function () { return $3c5c5b5c512feb20$export$db7463f3ddbe2745; });
$parcel$export($d7719bbf505e26b3$exports, "Root", function () { return $3c5c5b5c512feb20$export$f8ea8bcd9bc2b88c; });
$parcel$export($d7719bbf505e26b3$exports, "Title", function () { return $3c5c5b5c512feb20$export$474db65c3c394e1c; });

"use strict";
"use client";
const { withProvider: $3c5c5b5c512feb20$var$withProvider, withContext: $3c5c5b5c512feb20$var$withContext, useStyles: $3c5c5b5c512feb20$export$7e0f545483b3a68c, PropsProvider: $3c5c5b5c512feb20$var$PropsProvider } = (0, $04636a451c2392c0$export$ac7f79c9443925b8)({
    key: "card"
});
const $3c5c5b5c512feb20$export$f8ea8bcd9bc2b88c = $3c5c5b5c512feb20$var$withProvider("div", "root");
const $3c5c5b5c512feb20$export$db7463f3ddbe2745 = $3c5c5b5c512feb20$var$PropsProvider;
const $3c5c5b5c512feb20$export$851de33184ecdac4 = $3c5c5b5c512feb20$var$withContext("div", "body");
const $3c5c5b5c512feb20$export$5665775b26e26c5d = $3c5c5b5c512feb20$var$withContext("div", "header");
const $3c5c5b5c512feb20$export$e9897d434e0741ee = $3c5c5b5c512feb20$var$withContext("div", "footer");
const $3c5c5b5c512feb20$export$474db65c3c394e1c = $3c5c5b5c512feb20$var$withContext("h3", "title");
const $3c5c5b5c512feb20$export$16e0ed4cb97c00d4 = $3c5c5b5c512feb20$var$withContext("p", "description");


"use strict";



var $8v0nu = parcelRequire("8v0nu");


var $8v0nu = parcelRequire("8v0nu");



"use strict";
function $9a925755a39695e0$export$d5e24a9e96f05b33(options) {
    const { gap: gap, direction: direction } = options;
    const styles = {
        column: {
            marginY: gap,
            marginX: 0,
            borderInlineStartWidth: 0,
            borderTopWidth: "1px"
        },
        "column-reverse": {
            marginY: gap,
            marginX: 0,
            borderInlineStartWidth: 0,
            borderTopWidth: "1px"
        },
        row: {
            marginX: gap,
            marginY: 0,
            borderInlineStartWidth: "1px",
            borderTopWidth: 0
        },
        "row-reverse": {
            marginX: gap,
            marginY: 0,
            borderInlineStartWidth: "1px",
            borderTopWidth: 0
        }
    };
    return {
        "&": (0, $73e475e2b22cc1e3$export$d6051a0f7a227332)(direction, (value)=>styles[value])
    };
}


"use strict";
"use client";
function $ce146c420d45bae1$var$getValidChildren(children) {
    return (0, $8v0nu.Children).toArray(children).filter((child)=>(0, $8v0nu.isValidElement)(child));
}
const $ce146c420d45bae1$export$694e0d28c7ffc90c = (0, $8v0nu.forwardRef)(function Stack2(props, ref) {
    const { direction: direction = "column", align: align, justify: justify, gap: gap = "0.5rem", wrap: wrap, children: children, separator: separator, className: className, ...rest } = props;
    const separatorStyle = (0, $8v0nu.useMemo)(()=>(0, $9a925755a39695e0$export$d5e24a9e96f05b33)({
            gap: gap,
            direction: direction
        }), [
        gap,
        direction
    ]);
    const clones = (0, $8v0nu.useMemo)(()=>{
        if (!(0, $8v0nu.isValidElement)(separator)) return children;
        return $ce146c420d45bae1$var$getValidChildren(children).map((child, index, arr)=>{
            const key = typeof child.key !== "undefined" ? child.key : index;
            const typedSep = separator;
            const sep = (0, $8v0nu.cloneElement)(typedSep, {
                css: [
                    separatorStyle,
                    typedSep.props.css
                ]
            });
            return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsxs)((0, $8v0nu.Fragment), {
                children: [
                    child,
                    index === arr.length - 1 ? null : sep
                ]
            }, key);
        });
    }, [
        children,
        separator,
        separatorStyle
    ]);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $4042601bfa1a9d25$export$7cd122d781af9fa4).div, {
        ref: ref,
        display: "flex",
        alignItems: align,
        justifyContent: justify,
        flexDirection: direction,
        flexWrap: wrap,
        gap: separator ? void 0 : gap,
        className: (0, $99474b193e949655$export$a274e22fb40f762e)("chakra-stack", className),
        ...rest,
        children: clones
    });
});
$ce146c420d45bae1$export$694e0d28c7ffc90c.displayName = "Stack";


"use strict";
"use client";
const $16fbc3bd2b5bc884$export$15e411dc07b9c834 = (0, $8v0nu.forwardRef)(function HStack2(props, ref) {
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $ce146c420d45bae1$export$694e0d28c7ffc90c), {
        align: "center",
        ...props,
        direction: "row",
        ref: ref
    });
});
$16fbc3bd2b5bc884$export$15e411dc07b9c834.displayName = "HStack";



var $8v0nu = parcelRequire("8v0nu");



var $8v0nu = parcelRequire("8v0nu");


var $8v0nu = parcelRequire("8v0nu");

"use strict";
"use client";
const $d89847dde09cf7f1$export$b09fb900337259de = (0, $8v0nu.forwardRef)(function Square2(props, ref) {
    const { size: size, ...rest } = props;
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $1415810625b263eb$export$e71c4d32a2263218), {
        ...rest,
        ref: ref,
        boxSize: size,
        css: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
            flexGrow: 0,
            ...props.css
        }
    });
});
$d89847dde09cf7f1$export$b09fb900337259de.displayName = "Square";


"use strict";
"use client";
const $cd1b3ff14dc91c0f$export$c89a927ffc67e6fa = (0, $8v0nu.forwardRef)(function Circle2(props, ref) {
    const { size: size, ...rest } = props;
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $d89847dde09cf7f1$export$b09fb900337259de), {
        size: size,
        ref: ref,
        borderRadius: "9999px",
        ...rest
    });
});
$cd1b3ff14dc91c0f$export$c89a927ffc67e6fa.displayName = "Circle";



"use strict";
"use client";
const { withContext: $e2f153dab803da15$var$withContext, PropsProvider: $e2f153dab803da15$var$PropsProvider } = (0, $aa5f4d03028a5427$export$e99ac154c18649c5)({
    key: "skeleton"
});
const $e2f153dab803da15$export$8f31e4c4a37b8e9c = $e2f153dab803da15$var$withContext("div");
const $e2f153dab803da15$export$33dfb38e5e89d08e = $e2f153dab803da15$var$PropsProvider;
const $e2f153dab803da15$export$7d2444dbb58007d7 = $8v0nu.forwardRef(function SkeletonCircle2(props, ref) {
    const { size: size, ...rest } = props;
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cd1b3ff14dc91c0f$export$c89a927ffc67e6fa), {
        size: size,
        asChild: true,
        ref: ref,
        children: /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)($e2f153dab803da15$export$8f31e4c4a37b8e9c, {
            ...rest
        })
    });
});
$e2f153dab803da15$export$7d2444dbb58007d7.displayName = "SkeletonCircle";
const $e2f153dab803da15$export$cb6ddd830302c2a8 = $8v0nu.forwardRef(function SkeletonText2(props, ref) {
    const { loading: loading = true, noOfLines: noOfLines = 3, gap: gap, rootProps: rootProps, ...rest } = props;
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $ce146c420d45bae1$export$694e0d28c7ffc90c), {
        gap: gap,
        width: "full",
        ref: ref,
        ...rootProps,
        children: Array.from({
            length: loading ? noOfLines : 1
        }).map((_, index)=>/* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)($e2f153dab803da15$export$8f31e4c4a37b8e9c, {
                loading: loading,
                height: loading ? "4" : void 0,
                maxW: loading ? index === noOfLines - 1 && noOfLines > 1 ? "80%" : "100%" : void 0,
                ...rest
            }, index))
    });
});
$e2f153dab803da15$export$cb6ddd830302c2a8.displayName = "SkeletonText";

var $90c39535b5b4c9ce$exports = {};

$parcel$export($90c39535b5b4c9ce$exports, "CloseTrigger", function () { return $e6e7cf17daa15ff9$export$729c03aa1f9a1a53; });
$parcel$export($90c39535b5b4c9ce$exports, "EndElement", function () { return $e6e7cf17daa15ff9$export$5de253fe7fc62a92; });
$parcel$export($90c39535b5b4c9ce$exports, "Label", function () { return $e6e7cf17daa15ff9$export$f5486329f0fd0847; });
$parcel$export($90c39535b5b4c9ce$exports, "Root", function () { return $e6e7cf17daa15ff9$export$74b43295ae1f48d9; });
$parcel$export($90c39535b5b4c9ce$exports, "RootPropsProvider", function () { return $e6e7cf17daa15ff9$export$d959d9f0995a0f4c; });
$parcel$export($90c39535b5b4c9ce$exports, "StartElement", function () { return $e6e7cf17daa15ff9$export$aa2b6cc6e87895e8; });



"use strict";
"use client";
const { withProvider: $e6e7cf17daa15ff9$var$withProvider, withContext: $e6e7cf17daa15ff9$var$withContext, useStyles: $e6e7cf17daa15ff9$export$fa5e32657e7ee8a0, PropsProvider: $e6e7cf17daa15ff9$var$PropsProvider } = (0, $04636a451c2392c0$export$ac7f79c9443925b8)({
    key: "tag"
});
const $e6e7cf17daa15ff9$export$74b43295ae1f48d9 = $e6e7cf17daa15ff9$var$withProvider("div", "root");
const $e6e7cf17daa15ff9$export$d959d9f0995a0f4c = $e6e7cf17daa15ff9$var$PropsProvider;
const $e6e7cf17daa15ff9$export$f5486329f0fd0847 = $e6e7cf17daa15ff9$var$withContext("span", "label");
const $e6e7cf17daa15ff9$export$729c03aa1f9a1a53 = $e6e7cf17daa15ff9$var$withContext("button", "closeTrigger", {
    defaultProps: {
        children: /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $2ec3c16c879c0088$export$cae179f078f4b4a4), {})
    }
});
const $e6e7cf17daa15ff9$export$aa2b6cc6e87895e8 = $e6e7cf17daa15ff9$var$withContext("span", "startElement");
const $e6e7cf17daa15ff9$export$5de253fe7fc62a92 = $e6e7cf17daa15ff9$var$withContext("span", "endElement");


"use strict";




parcelRequire("8v0nu");

function $98471c1be9617cb6$export$bc53e36006268bd5(props) {
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $4042601bfa1a9d25$export$7cd122d781af9fa4).svg, {
        viewBox: "0 0 640 320",
        fill: "primary.100",
        xmlns: "http://www.w3.org/2000/svg",
        objectFit: "cover",
        borderRadius: "md",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)("g", {
                clipPath: "url(#clip0_1139_3165)",
                children: [
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)("rect", {
                        width: "640",
                        height: "320",
                        fill: ""
                    }),
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)("path", {
                        d: "M112.905 -168.033C85.1573 -152.445 80.2157 -115.289 78.449 -83.5117C78.1219 -77.645 77.8344 -71.5471 80.0886 -66.1221C86.7094 -50.1888 109.745 -49.3742 121.43 -36.6804C138.401 -18.245 123.103 10.6759 121.707 35.7009C119.83 69.4176 143.764 96.6385 156.232 126.007C167.428 152.372 172.118 197.932 150.366 220.072C139.393 231.241 125.028 239.899 118.526 254.143C113.209 265.787 112.505 281.618 100.895 287.009C87.5178 293.224 72.899 279.295 58.1719 280.105C49.099 280.607 41.4344 286.589 33.4344 290.895C25.4344 295.199 14.7635 297.657 7.84271 291.77C4.36354 288.812 2.6281 284.343 1.02393 280.066C-4.69274 264.822 -10.4115 249.576 -16.1302 234.332C-54.8678 244.082 -94.8824 248.751 -134.824 248.178C-140.089 248.103 -145.695 248.026 -150.162 250.809C-158.728 256.149 -158.555 268.295 -160.139 278.266C-163.226 297.707 -177.503 314.962 -196.02 321.637C-205.13 324.92 -215.503 326.032 -222.674 332.541C-232.699 341.641 -232.395 357.201 -237.272 369.83C-246.962 394.926 -278.316 410.868 -277.939 437.766C-277.745 451.614 -268.693 463.635 -259.401 473.903C-245.228 489.568 -229.482 503.808 -212.476 516.339C-217.61 529.066 -208.845 544.053 -196.639 550.326C-184.432 556.599 -169.982 556.266 -156.307 555.112C-142.632 553.958 -128.589 552.166 -115.393 555.931C-103.399 559.353 -93.1761 567.076 -83.2616 574.643C-64.2657 589.133 -45.274 603.624 -26.2802 618.116C-17.7323 624.639 -8.6969 631.839 -5.59273 642.135C-4.24898 646.589 -3.95731 651.703 -0.684389 655.012C1.69478 657.416 5.16144 658.318 8.44686 659.12C30.0802 664.399 54.4698 669.293 73.3656 657.51C83.3865 651.262 90.2615 641.162 96.8386 631.354C117.834 600.041 133.991 556.833 158.512 529.128C181.118 503.587 220.143 482.887 251.693 471.366C299.141 454.039 354.81 449.718 389.608 413.103C413.57 387.889 421.449 353.37 428.847 320.507C432.651 303.603 438.333 286.487 441.403 269.522C444.276 253.655 439.714 236.764 445.516 221.42C450.406 208.497 459.62 197.757 468.662 187.309C481.556 172.409 494.447 157.509 507.341 142.609C512.703 136.409 518.751 129.816 526.845 128.52C532.906 127.547 538.972 129.774 544.71 131.961C560.618 138.03 576.526 144.097 592.433 150.164C597.372 152.049 602.774 154.347 605.008 159.139C607.014 163.441 605.849 168.493 604.514 173.049C600.666 186.189 595.693 198.999 589.668 211.295C600.947 227.293 616.604 245.253 635.904 241.978C645.818 240.297 653.827 233.155 663.045 229.13C672.264 225.107 685.533 225.78 689.464 235.041C691.141 238.997 690.612 243.516 691.464 247.728C693.441 257.497 702.645 264.33 712.164 267.284C721.683 270.237 731.833 270.243 741.672 271.828C767.25 275.953 791.281 291.999 802.352 315.424C813.427 338.849 809.814 369.207 791.549 387.585C782.174 397.018 769.293 403.522 763.368 415.43C760.831 420.528 759.512 426.672 754.912 430.03C749.818 433.749 742.843 432.57 736.543 432.299C715 431.37 694.525 443.372 680.139 459.437C665.754 475.501 656.447 495.36 647.343 514.908C660.943 521.891 674.86 529.108 685.129 540.435C695.395 551.76 701.397 568.253 696.241 582.645C695.122 585.774 693.491 588.824 693.395 592.143C693.227 598.047 697.802 602.826 701.364 607.537C742.987 662.537 640.854 744.295 616.283 788.679C593.295 830.193 585.162 886.322 616.11 922.295",
                        stroke: "white",
                        strokeWidth: "8",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)("path", {
                        d: "M-107.312 -166.705C-95.6844 -138.803 -106.872 -106.933 -104.268 -76.8179C-101.205 -41.422 -79.1657 -9.78868 -76.0636 25.603C-73.2594 57.6218 -86.0678 91.301 -74.4344 121.266C-60.0969 158.199 -15.6948 172.866 9.78442 203.205C19.3678 214.618 27.3615 229.126 41.5782 233.597C60.0553 239.407 78.9636 224.83 89.2803 208.439C97.6991 195.064 103.199 178.918 99.9574 163.451C95.4116 141.768 75.3553 126.857 66.4511 106.572C57.2907 85.7114 60.8615 61.6968 65.1595 39.3218C66.5282 32.1968 67.9199 24.6259 65.3115 17.8551C62.2574 9.92592 54.524 5.01967 48.3719 -0.842836C26.4073 -21.7741 24.2553 -56.3846 30.5469 -86.0638C36.8407 -115.747 49.9886 -143.889 53.5553 -174.018",
                        stroke: "white",
                        strokeWidth: "8",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)("path", {
                        d: "M-55.2991 -160.516C-49.1553 -132.341 -42.9866 -103.956 -42.3303 -75.1246C-41.9845 -59.9767 -43.1657 -44.7517 -41.3886 -29.7038C-39.6136 -14.6537 -34.4928 0.633777 -23.572 11.138C-21.597 13.038 -19.2824 14.8359 -16.5574 15.1255C-10.4199 15.7755 -6.3657 8.91503 -4.74487 2.96086C-0.555279 -12.4267 -1.4157 -28.6933 -2.70737 -44.5892C-4.58653 -67.6934 -7.30528 -90.9746 -4.38237 -113.968C-1.46153 -136.962 7.85514 -160.139 25.9406 -174.639",
                        stroke: "white",
                        strokeWidth: "8",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)("path", {
                        d: "M-9.74683 120.591C-4.00933 124.772 2.96568 126.838 9.27193 130.103C21.7636 136.57 31.5865 148.02 36.0824 161.347C37.5678 165.753 38.9282 170.895 43.1136 172.92C49.2928 175.909 56.4595 168.863 56.4553 161.999C56.4491 155.136 52.0386 149.174 48.0324 143.599C35.7511 126.497 26.7324 91.5488 7.94902 81.1218C-21.6635 64.6863 -31.6656 104.618 -9.74683 120.591Z",
                        stroke: "white",
                        strokeWidth: "8",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)("path", {
                        d: "M-5.78639 328.88C-27.5781 323.174 -43.751 303.826 -65.4781 297.876C-86.9198 292.005 -110.072 300.449 -127.911 313.714C-145.751 326.98 -159.645 344.724 -175.001 360.801C-187.414 373.793 -201.143 386.145 -209.037 402.287C-216.93 418.428 -217.38 439.918 -204.595 452.543C-194.051 462.953 -176.064 466.262 -170.587 480.028C-168.37 485.601 -168.718 492.06 -165.818 497.308C-160.257 507.389 -146.409 508.135 -134.907 508.645C-77.251 511.203 -21.4281 541.341 12.3449 588.141C19.149 597.57 26.7907 608.67 38.3907 609.499C47.0741 610.122 55.0574 604.414 60.4907 597.612C75.2782 579.103 76.0907 553.489 83.147 530.876C89.6283 510.101 101.882 491.16 118.176 476.733C136.124 460.841 160.276 448.247 166.21 425.022C174.251 393.537 137.726 351.749 113.141 334.47C75.997 308.37 33.4428 339.153 -5.78639 328.88Z",
                        stroke: "white",
                        strokeWidth: "8",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)("path", {
                        d: "M564.781 -183.514C584.57 -159.755 594.124 -128.714 596.268 -97.8679C598.416 -67.02 593.624 -36.1137 587.408 -5.8241C584.008 10.7509 579.991 27.6676 570.485 41.6635C555.187 64.1885 528.508 75.4489 505.935 90.676C443.562 132.749 411.135 207.484 395.558 281.091C392.041 297.718 389.116 314.776 381.249 329.841C372.858 345.914 359.322 358.724 344.899 369.718C327.666 382.855 308.385 394.022 287.151 398.357C265.918 402.695 242.464 399.499 225.278 386.295C213.701 377.399 205.662 364.649 199.485 351.42C189.184 329.364 183.401 304.876 185.291 280.607C189.374 228.124 228.343 178.149 214.205 127.441C204.593 92.9593 171.445 65.7614 172.093 29.9697C172.43 11.3697 182.23 -6.92619 178.359 -25.122C174.093 -45.1825 154.797 -58.2262 145.237 -76.37C138.328 -89.4783 136.807 -104.662 135.409 -119.412C133.812 -136.289 135.491 -158.364 151.755 -163.135C174.184 -169.716 186.416 -188.858 206.62 -200.614C225.482 -211.593 244.503 -222.643 265.172 -229.658C289.528 -237.926 315.497 -240.349 341.216 -240.762C415.762 -241.96 517.062 -240.799 564.781 -183.514Z",
                        stroke: "white",
                        strokeWidth: "8",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)("path", {
                        d: "M199.718 -138.566C216.868 -144.012 226.512 -158.493 242.106 -167.599C256.666 -176.101 271.372 -184.641 287.339 -190.135C306.124 -196.593 326.151 -198.547 346.024 -199.16C381.568 -200.258 423.814 -200.549 459.929 -190.974C484.524 -184.493 506.202 -173.478 520.987 -155.295C536.772 -135.878 543.643 -109.891 544.67 -83.7658C544.783 -80.8846 544.843 -77.9971 544.831 -75.1117C544.76 -52.5429 540.762 -29.8616 535.875 -7.61996C532.852 6.12588 529.406 20.1384 521.752 31.803C509.981 49.7488 489.447 58.9822 472.249 71.351C446.543 89.8468 427.485 115.138 413.758 142.839C401.447 167.682 393.231 195.028 387.647 222.149C384.954 235.237 382.662 248.632 376.679 260.557C370.193 273.484 359.804 284.003 348.581 293.055C336.154 303.093 322.233 311.747 306.831 315.989C305.597 316.328 304.358 316.639 303.106 316.918C286.228 320.687 267.431 318.389 253.539 308.147C244.153 301.237 237.518 291.226 232.533 280.632C228.67 272.437 225.764 263.762 223.803 254.916C221.489 244.497 220.468 233.77 221.126 223.057C222.893 194.949 236.072 167.472 241.616 140.039C244.46 126.155 245.312 112.288 241.645 98.3551C234.256 70.2405 209.318 47.5676 209.933 18.5342C210.255 3.36338 217.741 -11.5512 215.053 -26.3471C212.103 -42.7242 197.991 -53.7783 191.316 -68.5742C188.472 -74.9054 187.066 -81.7659 186.285 -88.7617C185.743 -93.6055 185.503 -98.5159 185.295 -103.364C184.699 -116.903 186.628 -134.41 199.718 -138.566Z",
                        stroke: "white",
                        strokeWidth: "8",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)("path", {
                        d: "M247.678 -113.995C259.557 -118.255 266.605 -128.128 277.591 -134.583C287.851 -140.61 298.241 -146.637 309.503 -150.61C322.718 -155.26 336.81 -156.764 350.83 -157.558C377.295 -159.055 407.551 -159.749 433.21 -153.112C451.187 -148.537 466.756 -140.443 477.193 -127.076C488.968 -111.993 493.185 -91.0763 493.07 -69.6637C493.056 -67.3804 493.018 -65.095 492.92 -62.8033C492.208 -45.0387 488.599 -27.0283 484.341 -9.4137C481.697 1.50297 478.814 12.5988 473.02 21.9447C464.747 35.2863 450.391 42.5405 438.566 52.028C420.339 66.6551 406.953 85.576 397.691 105.17C389.078 123.393 383.614 143.401 379.735 163.205C377.864 172.755 376.21 182.495 372.105 191.272C367.533 201.059 360.285 209.282 352.262 216.395C343.364 224.301 333.235 231.139 321.822 234.695C320.91 234.978 319.987 235.241 319.06 235.478C306.535 238.682 292.397 237.28 281.797 229.999C274.603 225.078 269.374 217.801 265.582 209.847C262.576 203.557 260.53 196.824 259.128 189.999C257.48 182.022 256.668 173.782 256.962 165.505C257.791 144.045 266.085 122.738 269.489 101.374C271.189 90.6926 271.641 80.0093 269.08 69.2697C263.916 47.5218 247.189 29.3759 247.77 7.09673C248.08 -4.64077 253.251 -16.1741 251.749 -27.5741C250.114 -40.2637 241.16 -49.3221 237.393 -60.7783C235.778 -65.6929 235.178 -70.945 235.02 -76.2596C234.914 -79.9409 235.024 -83.6554 235.176 -87.3117C235.585 -97.52 237.76 -110.437 247.678 -113.995Z",
                        stroke: "white",
                        strokeWidth: "8",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)("path", {
                        d: "M295.639 -89.4242C302.268 -92.3825 306.701 -97.7617 313.076 -101.566C319.033 -105.118 325.108 -108.635 331.668 -111.085C339.31 -113.924 347.472 -115.035 355.635 -115.955C373.037 -117.918 391.272 -118.889 406.489 -115.249C417.839 -112.535 427.277 -107.378 433.397 -98.8575C441.137 -88.0784 442.779 -72.2659 441.468 -55.5617C441.335 -53.8804 441.195 -52.1908 441.012 -50.495C439.652 -37.5325 436.437 -24.1971 432.806 -11.2096C430.537 -3.11996 428.191 5.03838 424.285 12.0863C419.46 20.7842 411.356 26.1592 404.881 32.7071C394.158 43.5467 386.456 56.0405 381.626 67.4988C376.726 79.1197 373.997 91.7718 371.822 104.261C370.774 110.274 369.772 116.366 367.533 121.991C364.883 128.643 360.764 134.561 355.941 139.734C350.574 145.511 344.239 150.528 336.814 153.399C336.22 153.628 335.618 153.843 335.01 154.038C326.843 156.676 317.364 156.17 310.056 151.853C305.053 148.918 301.231 144.378 298.633 139.059C296.478 134.678 295.297 129.886 294.453 125.084C293.47 119.547 292.853 113.793 292.795 107.955C292.649 93.1426 296.151 78.0176 297.358 62.7093C297.947 55.2363 297.97 47.728 296.516 40.1842C293.576 24.8051 285.058 11.1842 285.606 -4.33871C285.906 -12.645 288.741 -20.7991 288.441 -28.7992C288.103 -37.8033 284.347 -44.8804 283.47 -52.9804C283.093 -56.4846 283.287 -60.1242 283.756 -63.7575C284.083 -66.2763 284.545 -68.7929 285.058 -71.2617C286.47 -78.1346 288.881 -86.4096 295.639 -89.4242Z",
                        stroke: "white",
                        strokeWidth: "8",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)("path", {
                        d: "M329.78 60.1696C330.066 62.9467 330.385 65.8009 331.68 68.2738C335.247 75.0738 345.326 76.2259 351.805 72.1051C358.283 67.9822 361.589 60.2592 362.96 52.7051C364.33 45.1509 364.149 37.378 365.56 29.83C366.451 25.0717 370.703 14.7175 375.549 2.22586C380.395 -10.2658 385.837 -24.8908 389.101 -38.1888C392.368 -51.4867 393.458 -63.4575 389.603 -70.6409C387.676 -74.2305 384.514 -76.6242 379.77 -77.3867C375.024 -78.1513 368.697 -77.2846 360.443 -74.3534C353.76 -71.9825 348.201 -68.7596 343.599 -64.8554C338.997 -60.9492 335.351 -56.3596 332.493 -51.2554C326.774 -41.045 324.208 -28.7721 323.443 -15.7762C322.683 -2.77831 323.726 10.9425 325.23 24.0467C326.735 37.1509 328.699 49.6384 329.78 60.1696Z",
                        stroke: "white",
                        strokeWidth: "8",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)("path", {
                        d: "M630.837 44.0196C624.25 52.203 614.324 56.8009 605.799 62.9384C597.274 69.0759 589.454 78.4426 590.706 88.8718C591.893 98.7489 600.781 105.866 609.735 110.197C618.689 114.53 628.629 117.382 636.027 124.034C643.956 131.163 647.977 142.395 646.375 152.936C645.472 158.861 643.014 165.291 645.962 170.509C647.633 173.466 650.754 175.318 653.927 176.528C665.027 180.753 677.377 178.557 689.252 178.711C701.129 178.868 714.72 182.845 719.262 193.818C721.766 199.861 720.95 206.87 723.375 212.945C728.966 226.961 747.316 229.111 762.108 232.107C814.558 242.728 855.183 295.066 852.46 348.512C851.581 365.799 847.296 385.207 857.937 398.86C865.779 408.922 879.287 412.257 891.752 414.966C909.239 418.762 929.716 421.853 943.127 410.007C950.775 403.251 954.227 393.053 957.364 383.343C966.244 355.882 975.123 328.424 984 300.966C986.577 292.995 989.162 284.987 990.473 276.712C992.55 263.609 991.352 250.093 987.81 237.309C984.458 225.214 978.971 213.622 971.004 203.922C957.637 187.643 938.137 177.511 923.8 162.078C900.56 137.059 891.843 99.2718 863.548 80.1551C842.191 65.7259 815.641 65.7759 791.464 59.6697C765.364 53.0801 745.295 38.9321 729.858 16.9592C713.341 -6.54916 697.183 -59.7513 659.489 -30.9721C635.485 -12.645 648.495 22.0863 630.837 44.0196Z",
                        stroke: "white",
                        strokeWidth: "8",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)("path", {
                        d: "M216.012 731.908C203.872 719.499 188.097 710.906 176.895 697.643C148.009 663.443 159.845 608.341 190.518 575.737C221.191 543.133 265.259 527.426 307.503 512.612C349.745 497.797 393.743 481.578 423.745 448.355C461.422 406.632 469.47 347.105 482.951 292.53C486.155 279.557 490.016 266.184 498.895 256.201C507.776 246.218 523.106 240.72 534.901 246.997C546.32 253.072 550.353 267.078 557.512 277.851C573.353 301.697 604.766 309.339 633.347 310.92C661.933 312.501 691.76 310.182 718.012 321.601C725.204 324.73 732.547 329.582 734.568 337.162C737.499 348.162 728.114 358.266 719.581 365.801L628.797 445.945C618.774 454.793 608.568 463.864 601.941 475.474C588.703 498.674 593.149 530.56 612.235 549.245C617.974 554.868 624.787 559.316 630.445 565.02C650.951 585.689 652.547 619.266 643.674 646.997C634.804 674.731 617.339 698.735 603.176 724.176C573.762 777.008 558.278 837.516 558.699 897.985C558.743 903.977 558.847 910.331 555.781 915.477C552.735 920.589 547.135 923.531 541.743 926.043C480.512 954.541 408.812 958.683 344.243 939.464C322.726 933.062 288.068 923.71 273.157 905.37C256.526 884.912 255.264 848.952 251.268 824.052C246.037 791.445 240.066 756.497 216.012 731.908Z",
                        stroke: "white",
                        strokeWidth: "8",
                        strokeMiterlimit: "10"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)("clipPath", {
                    id: "clip0_1139_3165",
                    children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)("rect", {
                        width: "640",
                        height: "320"
                    })
                })
            })
        ]
    });
}


function $3456399f909bb134$export$f55f1d663c7efb35({ imageSrc: imageSrc, imageAlt: imageAlt, showPlaceholder: showPlaceholder, title: title, subtitle: subtitle, description: description, tags: tags, to: to, renderMenu: renderMenu }) {
    const renderLink = (children)=>{
        return to ? /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $78d29a24c660df8a$export$2e2bcd8739ae039), {
            to: to,
            color: "inherit",
            children: children
        }) : /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $ef524fb144c5d632$exports.Fragment), {
            children: children
        });
    };
    const shouldUsePlaceholder = showPlaceholder && !imageSrc;
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $d7719bbf505e26b3$exports).Root, {
        as: "article",
        variant: "filled",
        children: [
            imageSrc && renderLink(/*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $b3ebe15a85950994$export$3e431a229df88919), {
                src: imageSrc,
                alt: imageAlt,
                width: "100%",
                aspectRatio: 2,
                objectFit: "cover",
                borderRadius: "md"
            })),
            shouldUsePlaceholder && renderLink(/*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $98471c1be9617cb6$export$bc53e36006268bd5), {})),
            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $d7719bbf505e26b3$exports).Header, {
                as: "header",
                children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
                    direction: "row",
                    gap: 4,
                    children: [
                        (title || subtitle) && /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $1415810625b263eb$export$e71c4d32a2263218), {
                            flexBasis: "100%",
                            children: [
                                title && /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $5dcf33ee745c0ffc$export$a8a3e93435678ff9), {
                                    size: "sm",
                                    as: "h3",
                                    wordBreak: "break-word",
                                    children: renderLink(title)
                                }),
                                subtitle && /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9318c0c5b8c25a88$export$5f1af8db9871e1d6), {
                                    as: "p",
                                    fontSize: "sm",
                                    color: "base.400",
                                    children: subtitle
                                })
                            ]
                        }),
                        renderMenu && /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $1415810625b263eb$export$e71c4d32a2263218), {
                            children: renderMenu()
                        })
                    ]
                })
            }),
            description && /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $d7719bbf505e26b3$exports).Body, {
                children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9318c0c5b8c25a88$export$5f1af8db9871e1d6), {
                    children: description
                })
            }),
            tags && tags.length > 0 && /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $d7719bbf505e26b3$exports).Footer, {
                as: "footer",
                children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $16fbc3bd2b5bc884$export$15e411dc07b9c834), {
                    gap: 2,
                    wrap: "wrap",
                    children: tags.map((tag)=>/*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $90c39535b5b4c9ce$exports).Root, {
                            size: "sm",
                            colorPalette: "primary",
                            children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $90c39535b5b4c9ce$exports).Label, {
                                children: tag
                            })
                        }, tag))
                })
            })
        ]
    });
}
function $3456399f909bb134$export$d49dc2f4fca0ae8c(props) {
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $d7719bbf505e26b3$exports).Root, {
        as: "article",
        variant: "filled",
        p: 8,
        children: [
            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
                direction: "column",
                gap: 2,
                children: [
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $e2f153dab803da15$export$8f31e4c4a37b8e9c), {
                        h: 6,
                        width: "40%"
                    }),
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $e2f153dab803da15$export$8f31e4c4a37b8e9c), {
                        h: 4,
                        width: "30%"
                    })
                ]
            }),
            !props.mini && /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $ef524fb144c5d632$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $e2f153dab803da15$export$cb6ddd830302c2a8), {
                        mt: 8,
                        noOfLines: 4
                    }),
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
                        gap: 2,
                        mt: 12,
                        children: [
                            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $e2f153dab803da15$export$8f31e4c4a37b8e9c), {
                                h: 4,
                                width: 12
                            }),
                            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $e2f153dab803da15$export$8f31e4c4a37b8e9c), {
                                h: 4,
                                width: 12
                            }),
                            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $e2f153dab803da15$export$8f31e4c4a37b8e9c), {
                                h: 4,
                                width: 12
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



parcelRequire("8v0nu");



function $43aa0a8514afe58f$export$c8d4523fa9306542(props) {
    const { isEnabled: isEnabled, isAuthenticated: isAuthenticated } = (0, $c837ac9c698038bc$export$1d39dc5b47e56ff0)();
    if (!isEnabled) return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $a987639d7be6b91e$export$353f5b6fc5456de1), {
        as: (0, $78d29a24c660df8a$export$2e2bcd8739ae039),
        ...props
    });
    return isAuthenticated && /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $a987639d7be6b91e$export$353f5b6fc5456de1), {
        as: (0, $78d29a24c660df8a$export$2e2bcd8739ae039),
        ...props
    });
}



parcelRequire("8v0nu");


function $488a343786980c50$export$6831baa95aeeaf1e(props) {
    const { isEnabled: isEnabled, isAuthenticated: isAuthenticated } = (0, $c837ac9c698038bc$export$1d39dc5b47e56ff0)();
    if (!isEnabled) return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $32db75c38a72e4b5$exports).Item, {
        ...props
    });
    return isAuthenticated && /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $32db75c38a72e4b5$exports).Item, {
        ...props
    });
}


/**
 * Rounds a number to a specified amount of decimals.
 *
 * @param {number} value The value to round
 * @param {number} decimals The number of decimals to keep. Default to 2
 */ function $f55c5bb8e60e90fc$export$2077e0241d6afd3c(value, decimals = 2) {
    return Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
}
function $f55c5bb8e60e90fc$export$7ecd32ca6b3ae583(value, decimals = 2) {
    if (value / 1e9 >= 1) return {
        num: $f55c5bb8e60e90fc$export$2077e0241d6afd3c(value / 1e9, decimals),
        unit: 'B'
    };
    else if (value / 1e6 >= 1) return {
        num: $f55c5bb8e60e90fc$export$2077e0241d6afd3c(value / 1e6, decimals),
        unit: 'M'
    };
    else if (value / 1e3 >= 1) return {
        num: $f55c5bb8e60e90fc$export$2077e0241d6afd3c(value / 1e3, decimals),
        unit: 'K'
    };
    return {
        num: value,
        unit: ''
    };
}
function $f55c5bb8e60e90fc$export$aa9294712332dc16(num, options) {
    const opts = {
        decimals: 2,
        separator: ',',
        forceDecimals: false,
        shorten: false,
        ...options
    };
    // isNaN(null) === true
    if (isNaN(num) || !num && num !== 0) return '--';
    const repeat = (char, length)=>{
        let str = '';
        for(let i = 0; i < length; i++)str += char + '';
        return str;
    };
    const sign = num < 0 ? '-' : '';
    const absNum = Math.abs(num);
    let [int, dec] = Number($f55c5bb8e60e90fc$export$2077e0241d6afd3c(absNum, opts.decimals)).toString().split('.');
    let largeNumUnit = '';
    if (opts.shorten) {
        const { num: num, unit: unit } = $f55c5bb8e60e90fc$export$7ecd32ca6b3ae583(Number(int), 0);
        int = num.toString();
        largeNumUnit = unit;
    }
    // Space the integer part of the number.
    int = int.replace(/\B(?=(\d{3})+(?!\d))/g, opts.separator);
    // Round the decimals.
    dec = (dec || '').substring(0, opts.decimals);
    // Add decimals if forced.
    dec = opts.forceDecimals ? `${dec}${repeat('0', opts.decimals - dec.length)}` : dec;
    return dec !== '' ? `${sign}${int}.${dec} ${largeNumUnit}` : `${sign}${int} ${largeNumUnit}`;
}
function $f55c5bb8e60e90fc$export$3cdc770bf8b2ed3d(num, length = 2) {
    const prefix = num < 0 ? '-' : '';
    const abdsNum = Math.abs(num);
    const wholeNum = Math.floor(abdsNum);
    const padLength = Math.max(length - String(wholeNum).length, 0);
    const pads = new Array(padLength + 1).join('0');
    return prefix + pads + abdsNum;
}
function $f55c5bb8e60e90fc$export$a5c7fd3700da7bdd(num, decimals = 2) {
    if (!isFinite(num)) return `${Math.sign(num) === -1 ? '-' : ''}\u{221E}`;
    const [coefficient, exponent] = num.toExponential().split('e').map((item)=>Number(item));
    const sups = "\u2070\xb9\xb2\xb3\u2074\u2075\u2076\u2077\u2078\u2079";
    const exponentSup = Math.abs(exponent).toString().split('').map((v)=>sups[Number(v)]).join('');
    const sign = exponent < 0 ? "\u207B" : '';
    return `${$f55c5bb8e60e90fc$export$2077e0241d6afd3c(coefficient, decimals)}x10${sign}${exponentSup}`;
}
function $f55c5bb8e60e90fc$export$7d15b64cf5a3a4c4(num, min, max) {
    return Math.min(Math.max(num, min), max);
}


/**
 * Why this file exists:
 * @developmentseed/stac-react does not allow to change the limit and offset of
 * the collections endpoint. This file is a temporary workaround to allow
 * pagination.
 *
 * Auth wiring is handled centrally by the StacApiAuthBridge in main.tsx, which
 * builds the authed `Api` instance exposed via ApiContext. This hook reads that
 * instance through useApi() rather than re-deriving an Authorization header
 * from useAuth().token — the two paths are then guaranteed to stay in sync.
 */ 
var $8v0nu = parcelRequire("8v0nu");

var $8v0nu = parcelRequire("8v0nu");
const $e60c4cd554136647$export$b919fd560f065399 = "https://eoapi.develop.eoepca.org/stac/"?.replace(/\/+$/, '');
// Authed fetcher for direct (non-stac-react) calls to the STAC API — used by
// mutations (PUT/POST/DELETE) and any reads outside the stac-react hook tree.
// Each instance is immutable; the bridge constructs a new one when the token
// changes, which propagates to consumers via ApiContext.
class $e60c4cd554136647$var$Api {
    token;
    stacBaseUrl;
    refreshAuth;
    constructor(token, stacBaseUrl = $e60c4cd554136647$export$b919fd560f065399, refreshAuth){
        this.token = token;
        this.stacBaseUrl = stacBaseUrl;
        this.refreshAuth = refreshAuth;
    }
    // Scope guard: only attach Authorization for URLs under the configured STAC
    // base. Prevents leaking the bearer to OIDC discovery, static assets, or
    // unrelated third-party origins. Path-boundary check ensures `/stac-admin`
    // does not match a `/stac` base.
    isStacUrl(url) {
        if (!this.stacBaseUrl) return false;
        return url === this.stacBaseUrl || url.startsWith(`${this.stacBaseUrl}/`);
    }
    // Build the final fetch options, injecting the Authorization header for
    // STAC-scoped URLs. `tokenOverride` lets the 401-retry path swap in a
    // freshly-refreshed token without rebuilding the instance.
    buildOptions(url, options, tokenOverride) {
        const t = tokenOverride ?? this.token;
        const injected = t && this.isStacUrl(url) ? {
            Authorization: `Bearer ${t}`
        } : {};
        // Caller-provided headers win on collision, so a caller can override the
        // injected Authorization (e.g. force an explicit anonymous request).
        return {
            ...options,
            headers: {
                ...injected,
                ...options.headers || {}
            }
        };
    }
    async fetch(url, options = {}) {
        let response = await fetch(url, this.buildOptions(url, options));
        // Self-heal a single 401 on a STAC-authed request: refresh the access
        // token via the OIDC client and retry once with the new bearer. Guards
        // against infinite loops by only retrying when a refresh callback is
        // wired and the original request was for a STAC URL with a token.
        if (response.status === 401 && this.refreshAuth && this.token && this.isStacUrl(url)) {
            const fresh = await this.refreshAuth();
            if (fresh && fresh !== this.token) response = await fetch(url, this.buildOptions(url, options, fresh));
        }
        if (response.ok) {
            // 204 No Content has no body; calling .json() on it would throw a
            // parse error. Return undefined for empty-body responses so callers
            // that issue PUT/DELETE against STAC APIs don't have to unwrap.
            if (response.status === 204) return undefined;
            return response.json();
        }
        const { status: status, statusText: statusText } = response;
        const e = {
            status: status,
            statusText: statusText
        };
        // Some STAC APIs return errors as JSON others as string.
        // Clone the response so we can read the body as text if json fails.
        const clone = response.clone();
        try {
            e.detail = await response.json();
        /* eslint-disable-next-line @typescript-eslint/no-unused-vars */ } catch (err) {
            e.detail = await clone.text();
        }
        throw e;
    }
}
const $e60c4cd554136647$export$f6d52655da4aa77d = (0, $8v0nu.createContext)(null);
function $e60c4cd554136647$export$eb2799109db70ffd() {
    const api = (0, $8v0nu.useContext)($e60c4cd554136647$export$f6d52655da4aa77d);
    if (!api) throw new Error('useApi must be used within an ApiContext.Provider');
    return api;
}
var $e60c4cd554136647$export$2e2bcd8739ae039 = $e60c4cd554136647$var$Api;


function $2109a06c072f006f$export$2b5787016ed09c4d(opts) {
    const { limit: limit = 10, initialOffset: initialOffset = 0 } = opts || {};
    const api = (0, $e60c4cd554136647$export$eb2799109db70ffd)();
    const [collections, setCollections] = (0, $8v0nu.useState)();
    const [state, setState] = (0, $8v0nu.useState)('IDLE');
    const [error, setError] = (0, $8v0nu.useState)();
    const [offset, setOffset] = (0, $8v0nu.useState)(initialOffset);
    const [hasNext, setHasNext] = (0, $8v0nu.useState)(false);
    const [hasPrev, setHasPrev] = (0, $8v0nu.useState)(false);
    // One controller for whichever request is currently in flight — whether it
    // came from the effect below or from reload(). Starting a new request
    // aborts the previous one, so a slow response can never clobber a newer
    // one, and unmount cleanup aborts reloads too.
    const abortRef = (0, $8v0nu.useRef)(null);
    const getCollections = (0, $8v0nu.useCallback)(async (offset, limit)=>{
        if (!(0, $e60c4cd554136647$export$b919fd560f065399)) return;
        abortRef.current?.abort();
        const controller = new AbortController();
        abortRef.current = controller;
        const { signal: signal } = controller;
        setState('LOADING');
        try {
            const data = await api.fetch(`${(0, $e60c4cd554136647$export$b919fd560f065399)}/collections?limit=${limit}&offset=${offset}`, {
                signal: signal
            });
            if (signal?.aborted) return;
            setHasNext(!!data.links.find((l)=>l.rel === 'next'));
            setHasPrev(!!data.links.find((l)=>[
                    'prev',
                    'previous'
                ].includes(l.rel)));
            setCollections(data);
            setError(undefined);
        } catch (err) {
            if (err?.name === 'AbortError' || signal?.aborted) return;
            setError(err);
            setCollections(undefined);
        } finally{
            if (!signal?.aborted) setState('IDLE');
        }
    }, [
        api
    ]);
    const nextPage = (0, $8v0nu.useCallback)(()=>{
        setOffset(offset + limit);
    }, [
        offset,
        limit
    ]);
    const prevPage = (0, $8v0nu.useCallback)(()=>{
        setOffset(offset - limit);
    }, [
        offset,
        limit
    ]);
    (0, $8v0nu.useEffect)(()=>{
        getCollections(offset, limit);
        return ()=>abortRef.current?.abort();
    }, [
        getCollections,
        offset,
        limit
    ]);
    return {
        collections: collections,
        reload: (0, $8v0nu.useCallback)(()=>getCollections(offset, limit), [
            getCollections,
            offset,
            limit
        ]),
        nextPage: hasNext ? nextPage : undefined,
        prevPage: hasPrev ? prevPage : undefined,
        setOffset: setOffset,
        state: state,
        error: error
    };
}


function $16109d62536d0cfb$var$CollectionList() {
    (0, $aec39e40387762bd$export$2e2bcd8739ae039)('Collections');
    const { collections: collections, state: state } = (0, $2109a06c072f006f$export$2b5787016ed09c4d)({
        limit: 1000
    });
    // Quick search system.
    const [searchTerm, setSearchTerm] = (0, $8v0nu.useState)('');
    const [keyword, setKeyword] = (0, $8v0nu.useState)('');
    const handleKeywordChange = (e)=>setKeyword(e.target.value);
    const keywords = (0, $8v0nu.useMemo)(()=>{
        if (!collections) return [];
        const k = collections.collections.reduce((acc, col)=>[
                ...acc,
                ...col.keywords || []
            ], []);
        return Array.from(new Set(k));
    }, [
        collections
    ]);
    const filteredCollections = (0, $8v0nu.useMemo)(()=>{
        if (!collections) return [];
        return collections.collections.filter((col)=>{
            const title = col.title?.toLowerCase();
            const description = col.description?.toLowerCase();
            const term = searchTerm.toLowerCase().trim();
            const foundTerm = !term || title?.includes(term) || description?.includes(term);
            const keywords = col.keywords || [];
            const key = keyword.toLowerCase();
            const foundKeyword = !key || keywords.find((k)=>k.toLowerCase() === key);
            return foundTerm && foundKeyword;
        });
    }, [
        collections,
        searchTerm,
        keyword
    ]);
    const collectionsCount = collections?.numberMatched || 0;
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
        direction: "column",
        gap: 8,
        children: [
            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $dfd76aae8c4830bc$export$644c29b44a905178), {
                title: "Catalog",
                overline: "Browsing",
                actions: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $43aa0a8514afe58f$export$c8d4523fa9306542), {
                    colorPalette: "primary",
                    to: "/collections/new",
                    children: [
                        /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9138db1f951ed55c$export$3a9f56a1d1f9a714), {}),
                        "Create"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
                direction: "column",
                gap: "8",
                as: "section",
                children: [
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
                        direction: "row",
                        px: "8",
                        gap: "8",
                        as: "header",
                        children: [
                            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $1415810625b263eb$export$e71c4d32a2263218), {
                                flexBasis: "100%",
                                children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $5dcf33ee745c0ffc$export$a8a3e93435678ff9), {
                                    size: "md",
                                    as: "h2",
                                    children: [
                                        "Collections",
                                        ' ',
                                        !!collectionsCount && /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $486a1f24d187216b$export$37acb3580601e69a), {
                                            variant: "solid",
                                            children: (0, $f55c5bb8e60e90fc$export$3cdc770bf8b2ed3d)(collectionsCount)
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
                                direction: "row",
                                gap: "4",
                                children: [
                                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
                                        direction: "row",
                                        gap: "2",
                                        alignItems: "center",
                                        children: [
                                            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $5dcf33ee745c0ffc$export$a8a3e93435678ff9), {
                                                size: "xs",
                                                as: "h3",
                                                children: "Search"
                                            }),
                                            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $4118161e107f6861$export$6e5a9cd40e0c9b97), {
                                                width: "16rem",
                                                endElement: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9138db1f951ed55c$export$89ad07d969809ef0), {}),
                                                children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $88b24aa7301f8cd5$export$f5b8910cec6cf069), {
                                                    type: "search",
                                                    placeholder: "Title or description",
                                                    onChange: (e)=>setSearchTerm(e.target.value)
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
                                        direction: "row",
                                        gap: "2",
                                        alignItems: "center",
                                        children: [
                                            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $5dcf33ee745c0ffc$export$a8a3e93435678ff9), {
                                                size: "xs",
                                                as: "h3",
                                                children: "Filter"
                                            }),
                                            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $70295da2572f7f22$exports).Root, {
                                                size: "md",
                                                width: "12rem",
                                                children: [
                                                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $70295da2572f7f22$exports).Field, {
                                                        placeholder: "All keywords",
                                                        onChange: handleKeywordChange,
                                                        children: keywords.map((k)=>/*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)("option", {
                                                                value: k,
                                                                children: k
                                                            }, k))
                                                    }),
                                                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $70295da2572f7f22$exports).Indicator, {})
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $64f958309d0faa1a$export$de97fecb6d4b30a5), {
                        gap: 8,
                        templateColumns: "repeat(auto-fill, minmax(26rem, 1fr))",
                        children: !collections || state === 'LOADING' ? /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $ef524fb144c5d632$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $3456399f909bb134$export$d49dc2f4fca0ae8c), {}),
                                /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $3456399f909bb134$export$d49dc2f4fca0ae8c), {})
                            ]
                        }) : filteredCollections.map((col)=>/*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $3456399f909bb134$export$f55f1d663c7efb35), {
                                imageSrc: col.assets?.thumbnail?.href,
                                imageAlt: col.assets?.thumbnail?.title,
                                showPlaceholder: true,
                                title: col.title || col.id,
                                description: col.description,
                                tags: col.keywords,
                                to: `/collections/${col.id}/`,
                                renderMenu: ()=>/*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $32db75c38a72e4b5$exports).Root, {
                                        positioning: {
                                            placement: 'bottom-end'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $32db75c38a72e4b5$exports).Trigger, {
                                                asChild: true,
                                                children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $756da344c07e2b07$export$c25acd513dcc8062), {
                                                    "aria-label": "Options",
                                                    variant: "soft-outline",
                                                    colorPalette: "base",
                                                    size: "sm",
                                                    children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9138db1f951ed55c$export$b307b75901e71920), {})
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $25e8aada90e0332f$export$602eac185826482c), {
                                                children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $32db75c38a72e4b5$exports).Positioner, {
                                                    children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $32db75c38a72e4b5$exports).Content, {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $32db75c38a72e4b5$exports).Item, {
                                                                value: "view",
                                                                asChild: true,
                                                                children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $78d29a24c660df8a$export$2e2bcd8739ae039), {
                                                                    to: `/collections/${col.id}/`,
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9138db1f951ed55c$export$3b8ef319a6c5f131), {}),
                                                                        "View"
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $488a343786980c50$export$6831baa95aeeaf1e), {
                                                                value: "edit",
                                                                asChild: true,
                                                                children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $78d29a24c660df8a$export$2e2bcd8739ae039), {
                                                                    to: `/collections/${col.id}/edit`,
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9138db1f951ed55c$export$b8f31e9a5cf17074), {}),
                                                                        "Edit"
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    })
                            }, col.id))
                    })
                ]
            })
        ]
    });
}
var $16109d62536d0cfb$export$2e2bcd8739ae039 = $16109d62536d0cfb$var$CollectionList;




var $8v0nu = parcelRequire("8v0nu");


parcelRequire("8v0nu");
// src/toast.store.ts

var $c6a4c24176c53ca1$var$withDefaults = (options, defaults)=>{
    return {
        ...defaults,
        ...(0, $6f7aa98cfa48efba$export$8e16b83750b44988)(options)
    };
};
var $c6a4c24176c53ca1$var$priorities = {
    error: [
        1,
        2
    ],
    warning: [
        3,
        6
    ],
    loading: [
        4,
        5
    ],
    success: [
        5,
        7
    ],
    info: [
        6,
        8
    ]
};
var $c6a4c24176c53ca1$var$DEFAULT_TYPE = "info";
var $c6a4c24176c53ca1$var$getPriorityForType = (type, hasAction)=>{
    const [actionable, nonActionable] = $c6a4c24176c53ca1$var$priorities[type ?? $c6a4c24176c53ca1$var$DEFAULT_TYPE];
    return hasAction ? actionable : nonActionable;
};
var $c6a4c24176c53ca1$var$sortToastsByPriority = (toastArray)=>{
    return toastArray.sort((a, b)=>{
        const priorityA = a.priority ?? $c6a4c24176c53ca1$var$getPriorityForType(a.type, !!a.action);
        const priorityB = b.priority ?? $c6a4c24176c53ca1$var$getPriorityForType(b.type, !!b.action);
        return priorityA - priorityB;
    });
};
function $c6a4c24176c53ca1$export$4e7084a8e57753a8(props = {}) {
    const attrs = $c6a4c24176c53ca1$var$withDefaults(props, {
        placement: "bottom",
        overlap: false,
        max: 24,
        gap: 16,
        offsets: "1rem",
        hotkey: [
            "altKey",
            "KeyT"
        ],
        removeDelay: 200,
        pauseOnPageIdle: true
    });
    let subscribers = [];
    let toasts = [];
    let dismissedToasts = /* @__PURE__ */ new Set();
    let toastQueue = [];
    const subscribe = (subscriber)=>{
        subscribers.push(subscriber);
        return ()=>{
            const index = subscribers.indexOf(subscriber);
            subscribers.splice(index, 1);
        };
    };
    const publish = (data)=>{
        subscribers.forEach((subscriber)=>subscriber(data));
        return data;
    };
    const addToast = (data)=>{
        if (toasts.length >= attrs.max) {
            toastQueue.push(data);
            return;
        }
        publish(data);
        toasts.unshift(data);
    };
    const processQueue = ()=>{
        toastQueue = $c6a4c24176c53ca1$var$sortToastsByPriority(toastQueue);
        while(toastQueue.length > 0 && toasts.length < attrs.max){
            const nextToast = toastQueue.shift();
            if (nextToast) {
                publish(nextToast);
                toasts.unshift(nextToast);
            }
        }
    };
    const create = (data)=>{
        const id = data.id ?? `toast:${(0, $5246d161dcdee685$export$31b40729666a4ae0)()}`;
        const exists = toasts.find((toast)=>toast.id === id);
        if (dismissedToasts.has(id)) dismissedToasts.delete(id);
        if (exists) toasts = toasts.map((toast)=>{
            if (toast.id === id) return publish({
                ...toast,
                ...data,
                id: id
            });
            return toast;
        });
        else {
            const newToast = {
                id: id,
                duration: attrs.duration,
                removeDelay: attrs.removeDelay,
                type: $c6a4c24176c53ca1$var$DEFAULT_TYPE,
                ...data,
                stacked: !attrs.overlap,
                gap: attrs.gap
            };
            const priority = newToast.priority ?? $c6a4c24176c53ca1$var$getPriorityForType(newToast.type, !!newToast.action);
            addToast({
                ...newToast,
                priority: priority
            });
        }
        return id;
    };
    const remove = (id)=>{
        dismissedToasts.add(id);
        if (!id) {
            toasts.forEach((toast)=>{
                subscribers.forEach((subscriber)=>subscriber({
                        id: toast.id,
                        dismiss: true
                    }));
            });
            toasts = [];
            toastQueue = [];
        } else {
            subscribers.forEach((subscriber)=>subscriber({
                    id: id,
                    dismiss: true
                }));
            toasts = toasts.filter((toast)=>toast.id !== id);
            processQueue();
        }
        return id;
    };
    const error = (data)=>{
        return create({
            ...data,
            type: "error"
        });
    };
    const success = (data)=>{
        return create({
            ...data,
            type: "success"
        });
    };
    const info = (data)=>{
        return create({
            ...data,
            type: "info"
        });
    };
    const warning = (data)=>{
        return create({
            ...data,
            type: "warning"
        });
    };
    const loading = (data)=>{
        return create({
            ...data,
            type: "loading"
        });
    };
    const getVisibleToasts = ()=>{
        return toasts.filter((toast)=>!dismissedToasts.has(toast.id));
    };
    const getCount = ()=>{
        return toasts.length;
    };
    const promise = (promise2, options, shared = {})=>{
        if (!options || !options.loading) {
            (0, $db2b97a8c70ba27b$export$c106dd0671a0fc2d)("[zag-js > toast] toaster.promise() requires at least a 'loading' option to be specified");
            return;
        }
        const id = create({
            ...shared,
            ...options.loading,
            promise: promise2,
            type: "loading"
        });
        let removable = true;
        let result;
        const prom = (0, $5246d161dcdee685$export$624e501d81f5ffce)(promise2).then(async (response)=>{
            result = [
                "resolve",
                response
            ];
            if ($c6a4c24176c53ca1$var$isHttpResponse(response) && !response.ok) {
                removable = false;
                const errorOptions = (0, $5246d161dcdee685$export$624e501d81f5ffce)(options.error, `HTTP Error! status: ${response.status}`);
                create({
                    ...shared,
                    ...errorOptions,
                    id: id,
                    type: "error"
                });
            } else if (options.success !== void 0) {
                removable = false;
                const successOptions = (0, $5246d161dcdee685$export$624e501d81f5ffce)(options.success, response);
                create({
                    ...shared,
                    ...successOptions,
                    id: id,
                    type: successOptions.type ?? "success"
                });
            }
        }).catch(async (error2)=>{
            result = [
                "reject",
                error2
            ];
            if (options.error !== void 0) {
                removable = false;
                const errorOptions = (0, $5246d161dcdee685$export$624e501d81f5ffce)(options.error, error2);
                create({
                    ...shared,
                    ...errorOptions,
                    id: id,
                    type: "error"
                });
            }
        }).finally(()=>{
            if (removable) remove(id);
            options.finally?.();
        });
        const unwrap = ()=>new Promise((resolve, reject)=>prom.then(()=>result[0] === "reject" ? reject(result[1]) : resolve(result[1])).catch(reject));
        return {
            id: id,
            unwrap: unwrap
        };
    };
    const update = (id, data)=>{
        return create({
            id: id,
            ...data
        });
    };
    const pause = (id)=>{
        if (id != null) toasts = toasts.map((toast)=>{
            if (toast.id === id) return publish({
                ...toast,
                message: "PAUSE"
            });
            return toast;
        });
        else toasts = toasts.map((toast)=>publish({
                ...toast,
                message: "PAUSE"
            }));
    };
    const resume = (id)=>{
        if (id != null) toasts = toasts.map((toast)=>{
            if (toast.id === id) return publish({
                ...toast,
                message: "RESUME"
            });
            return toast;
        });
        else toasts = toasts.map((toast)=>publish({
                ...toast,
                message: "RESUME"
            }));
    };
    const dismiss = (id)=>{
        if (id != null) toasts = toasts.map((toast)=>{
            if (toast.id === id) return publish({
                ...toast,
                message: "DISMISS"
            });
            return toast;
        });
        else toasts = toasts.map((toast)=>publish({
                ...toast,
                message: "DISMISS"
            }));
    };
    const isVisible = (id)=>{
        return !dismissedToasts.has(id) && !!toasts.find((toast)=>toast.id === id);
    };
    const isDismissed = (id)=>{
        return dismissedToasts.has(id);
    };
    const expand = ()=>{
        toasts = toasts.map((toast)=>publish({
                ...toast,
                stacked: true
            }));
    };
    const collapse = ()=>{
        toasts = toasts.map((toast)=>publish({
                ...toast,
                stacked: false
            }));
    };
    return {
        attrs: attrs,
        subscribe: subscribe,
        create: create,
        update: update,
        remove: remove,
        dismiss: dismiss,
        error: error,
        success: success,
        info: info,
        warning: warning,
        loading: loading,
        getVisibleToasts: getVisibleToasts,
        getCount: getCount,
        promise: promise,
        pause: pause,
        resume: resume,
        isVisible: isVisible,
        isDismissed: isDismissed,
        expand: expand,
        collapse: collapse
    };
}
var $c6a4c24176c53ca1$var$isHttpResponse = (data)=>{
    return data && typeof data === "object" && "ok" in data && typeof data.ok === "boolean" && "status" in data && typeof data.status === "number";
};


"use client";
//#region src/components/toast/create-toaster.tsx
var $22c2a82039340f2c$export$485098e18d680f1a = (props)=>{
    return $c6a4c24176c53ca1$export$4e7084a8e57753a8(props);
};

var $776869f4a947130c$exports = {};

$parcel$export($776869f4a947130c$exports, "ActionTrigger", function () { return $5e0ddd0f2d32d482$export$40c7bd277b2b5f0f; });
$parcel$export($776869f4a947130c$exports, "CloseTrigger", function () { return $5e0ddd0f2d32d482$export$f5ef638cf70daa7c; });
$parcel$export($776869f4a947130c$exports, "Description", function () { return $5e0ddd0f2d32d482$export$ecddd96c53621d9a; });
$parcel$export($776869f4a947130c$exports, "Indicator", function () { return $5e0ddd0f2d32d482$export$c5f1a77e8dc95e53; });
$parcel$export($776869f4a947130c$exports, "Root", function () { return $5e0ddd0f2d32d482$export$23ad0642d3ca56f8; });
$parcel$export($776869f4a947130c$exports, "Title", function () { return $5e0ddd0f2d32d482$export$16d42d7c29b95a4; });




"use client";
//#region src/components/toast/use-toast-context.ts
var [$09f4670cb5c31849$export$f5d03d415824e0e, $09f4670cb5c31849$export$91b3d218c74c79e4] = (0, $51a09ee1e9e91bf5$export$fd42f52fd3ae1109)({
    name: "ToastContext",
    hookName: "useToastContext",
    providerName: "<ToastProvider />"
});



var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/toast/toast-action-trigger.tsx
var $9eb1f6885d1501b3$export$40c7bd277b2b5f0f = (0, $8v0nu.forwardRef)((props, ref)=>{
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)((0, $09f4670cb5c31849$export$91b3d218c74c79e4)().getActionTriggerProps(), props);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).button, {
        ...mergedProps,
        ref: ref
    });
});
$9eb1f6885d1501b3$export$40c7bd277b2b5f0f.displayName = "ToastActionTrigger";





var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/toast/toast-close-trigger.tsx
var $35953d019764bc8a$export$f5ef638cf70daa7c = (0, $8v0nu.forwardRef)((props, ref)=>{
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)((0, $09f4670cb5c31849$export$91b3d218c74c79e4)().getCloseTriggerProps(), props);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).button, {
        ...mergedProps,
        ref: ref
    });
});
$35953d019764bc8a$export$f5ef638cf70daa7c.displayName = "ToastCloseTrigger";



"use client";
//#region src/components/toast/toast-context.tsx
var $d68908b7b4866a19$export$29d4e2ed4674ecfc = (props)=>props.children((0, $09f4670cb5c31849$export$91b3d218c74c79e4)());





var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/toast/toast-description.tsx
var $c03302195f19f7d2$export$ecddd96c53621d9a = (0, $8v0nu.forwardRef)((props, ref)=>{
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)((0, $09f4670cb5c31849$export$91b3d218c74c79e4)().getDescriptionProps(), props);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).div, {
        ...mergedProps,
        ref: ref
    });
});
$c03302195f19f7d2$export$ecddd96c53621d9a.displayName = "ToastDescription";




var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/toast/toast-root.tsx
var $5346a9cc0b9b2a9c$export$23ad0642d3ca56f8 = (0, $8v0nu.forwardRef)((props, ref)=>{
    const toast = (0, $09f4670cb5c31849$export$91b3d218c74c79e4)();
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsxs)("div", {
        ...(0, $ea59bff5c9936d72$export$9d1611c77c2fe928)(toast.getRootProps(), props),
        ref: ref,
        children: [
            /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)("div", {
                ...toast.getGhostBeforeProps()
            }),
            props.children,
            /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)("div", {
                ...toast.getGhostAfterProps()
            })
        ]
    });
});
$5346a9cc0b9b2a9c$export$23ad0642d3ca56f8.displayName = "ToastRoot";





var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/toast/toast-title.tsx
var $f3448e81cf602f9e$export$16d42d7c29b95a4 = (0, $8v0nu.forwardRef)((props, ref)=>{
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)((0, $09f4670cb5c31849$export$91b3d218c74c79e4)().getTitleProps(), props);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).div, {
        ...mergedProps,
        ref: ref
    });
});
$f3448e81cf602f9e$export$16d42d7c29b95a4.displayName = "ToastTitle";


//#region src/components/toast/toast.ts
var $31de3b58cb54507d$export$86736d28bad4679b = /* @__PURE__ */ (0, $57db88e2bf337fea$export$8126e515a7516e2)({
    ActionTrigger: ()=>(0, $9eb1f6885d1501b3$export$40c7bd277b2b5f0f),
    CloseTrigger: ()=>(0, $35953d019764bc8a$export$f5ef638cf70daa7c),
    Context: ()=>(0, $d68908b7b4866a19$export$29d4e2ed4674ecfc),
    Description: ()=>(0, $c03302195f19f7d2$export$ecddd96c53621d9a),
    Root: ()=>(0, $5346a9cc0b9b2a9c$export$23ad0642d3ca56f8),
    Title: ()=>(0, $f3448e81cf602f9e$export$16d42d7c29b95a4)
});





// src/toast.connect.ts

// src/toast.anatomy.ts

var $e1099a19913879a5$export$477202748c7242bf = (0, $07b08c6ef332e8db$export$197e6e8d4b33fd6c)("toast").parts("group", "root", "title", "description", "actionTrigger", "closeTrigger");
var $e1099a19913879a5$export$6e2410c1d27f06e7 = $e1099a19913879a5$export$477202748c7242bf.build();


// src/toast.dom.ts
var $8141bd6b70fa174e$export$49f220d8acb9e944 = (placement)=>`toast-group:${placement}`;
var $8141bd6b70fa174e$export$d436e90f012ec60b = (ctx, placement)=>ctx.getById(`toast-group:${placement}`);
var $8141bd6b70fa174e$export$dfdcab00b0f585a9 = (ctx)=>`toast:${ctx.id}`;
var $8141bd6b70fa174e$export$5688053fba312fa5 = (ctx)=>ctx.getById($8141bd6b70fa174e$export$dfdcab00b0f585a9(ctx));
var $8141bd6b70fa174e$export$aed19156d565b1d7 = (ctx)=>`toast:${ctx.id}:title`;
var $8141bd6b70fa174e$export$abcfdc629db68a85 = (ctx)=>`toast:${ctx.id}:description`;
var $8141bd6b70fa174e$export$eae8ddee3c3e583f = (ctx)=>`toast${ctx.id}:close`;


// src/toast.utils.ts

var $a2968e013ced240e$export$53f09ef13e71fdbd = {
    info: 5e3,
    error: 5e3,
    success: 2e3,
    loading: Infinity,
    warning: 5e3,
    DEFAULT: 5e3
};
function $a2968e013ced240e$export$9ff39afc2486f8cc(duration, type) {
    return duration ?? $a2968e013ced240e$export$53f09ef13e71fdbd[type] ?? $a2968e013ced240e$export$53f09ef13e71fdbd.DEFAULT;
}
var $a2968e013ced240e$var$getOffsets = (offsets)=>typeof offsets === "string" ? {
        left: offsets,
        right: offsets,
        bottom: offsets,
        top: offsets
    } : offsets;
function $a2968e013ced240e$export$fcd226e73046c9a4(service, placement) {
    const { prop: prop, computed: computed, context: context } = service;
    const { offsets: offsets, gap: gap } = prop("store").attrs;
    const heights = context.get("heights");
    const computedOffset = $a2968e013ced240e$var$getOffsets(offsets);
    const rtl = prop("dir") === "rtl";
    const computedPlacement = placement.replace("-start", rtl ? "-right" : "-left").replace("-end", rtl ? "-left" : "-right");
    const isRighty = computedPlacement.includes("right");
    const isLefty = computedPlacement.includes("left");
    const styles = {
        position: "fixed",
        pointerEvents: computed("count") > 0 ? void 0 : "none",
        display: "flex",
        flexDirection: "column",
        "--gap": `${gap}px`,
        "--first-height": `${heights[0]?.height || 0}px`,
        "--viewport-offset-left": computedOffset.left,
        "--viewport-offset-right": computedOffset.right,
        "--viewport-offset-top": computedOffset.top,
        "--viewport-offset-bottom": computedOffset.bottom,
        zIndex: (0, $dbd9babc41e226bd$export$e2f9a725ee199e81)
    };
    let alignItems = "center";
    if (isRighty) alignItems = "flex-end";
    if (isLefty) alignItems = "flex-start";
    styles.alignItems = alignItems;
    if (computedPlacement.includes("top")) {
        const offset = computedOffset.top;
        styles.top = `max(env(safe-area-inset-top, 0px), ${offset})`;
    }
    if (computedPlacement.includes("bottom")) {
        const offset = computedOffset.bottom;
        styles.bottom = `max(env(safe-area-inset-bottom, 0px), ${offset})`;
    }
    if (!computedPlacement.includes("left")) {
        const offset = computedOffset.right;
        styles.insetInlineEnd = `calc(env(safe-area-inset-right, 0px) + ${offset})`;
    }
    if (!computedPlacement.includes("right")) {
        const offset = computedOffset.left;
        styles.insetInlineStart = `calc(env(safe-area-inset-left, 0px) + ${offset})`;
    }
    return styles;
}
function $a2968e013ced240e$export$c3e7864cecc29b16(service, visible) {
    const { prop: prop, context: context, computed: computed } = service;
    const parent = prop("parent");
    const placement = parent.computed("placement");
    const { gap: gap } = parent.prop("store").attrs;
    const [side] = placement.split("-");
    const mounted = context.get("mounted");
    const remainingTime = context.get("remainingTime");
    const height = computed("height");
    const frontmost = computed("frontmost");
    const sibling = !frontmost;
    const overlap = !prop("stacked");
    const stacked = prop("stacked");
    const type = prop("type");
    const duration = type === "loading" ? Number.MAX_SAFE_INTEGER : remainingTime;
    const offset = computed("heightIndex") * gap + computed("heightBefore");
    const styles = {
        position: "absolute",
        pointerEvents: "auto",
        "--opacity": "0",
        "--remove-delay": `${prop("removeDelay")}ms`,
        "--duration": `${duration}ms`,
        "--initial-height": `${height}px`,
        "--offset": `${offset}px`,
        "--index": prop("index"),
        "--z-index": computed("zIndex"),
        "--lift-amount": "calc(var(--lift) * var(--gap))",
        "--y": "100%",
        "--x": "0"
    };
    const assign = (overrides)=>Object.assign(styles, overrides);
    if (side === "top") assign({
        top: "0",
        "--sign": "-1",
        "--y": "-100%",
        "--lift": "1"
    });
    else if (side === "bottom") assign({
        bottom: "0",
        "--sign": "1",
        "--y": "100%",
        "--lift": "-1"
    });
    if (mounted) {
        assign({
            "--y": "0",
            "--opacity": "1"
        });
        if (stacked) assign({
            "--y": "calc(var(--lift) * var(--offset))",
            "--height": "var(--initial-height)"
        });
    }
    if (!visible) assign({
        "--opacity": "0",
        pointerEvents: "none"
    });
    if (sibling && overlap) {
        assign({
            "--base-scale": "var(--index) * 0.05 + 1",
            "--y": "calc(var(--lift-amount) * var(--index))",
            "--scale": "calc(-1 * var(--base-scale))",
            "--height": "var(--first-height)"
        });
        if (!visible) assign({
            "--y": "calc(var(--sign) * 40%)"
        });
    }
    if (sibling && stacked && !visible) assign({
        "--y": "calc(var(--lift) * var(--offset) + var(--lift) * -100%)"
    });
    if (frontmost && !visible) assign({
        "--y": "calc(var(--lift) * -100%)"
    });
    return styles;
}
function $a2968e013ced240e$export$597297f46960059(service, visible) {
    const { computed: computed } = service;
    const styles = {
        position: "absolute",
        inset: "0",
        scale: "1 2",
        pointerEvents: visible ? "none" : "auto"
    };
    const assign = (overrides)=>Object.assign(styles, overrides);
    if (computed("frontmost") && !visible) assign({
        height: "calc(var(--initial-height) + 80%)"
    });
    return styles;
}
function $a2968e013ced240e$export$eaa991be70027c94() {
    return {
        position: "absolute",
        left: "0",
        height: "calc(var(--gap) + 2px)",
        bottom: "100%",
        width: "100%"
    };
}


function $c24977ae36f92554$export$64605811ab45167f(service, normalize) {
    const { state: state, send: send, prop: prop, scope: scope, context: context, computed: computed } = service;
    const translations = prop("translations");
    const visible = state.hasTag("visible");
    const paused = state.hasTag("paused");
    const mounted = context.get("mounted");
    const frontmost = computed("frontmost");
    const placement = prop("parent").computed("placement");
    const type = prop("type");
    const stacked = prop("stacked");
    const title = prop("title");
    const description = prop("description");
    const action = prop("action");
    const [side, align = "center"] = placement.split("-");
    return {
        type: type,
        title: title,
        description: description,
        placement: placement,
        visible: visible,
        paused: paused,
        closable: !!prop("closable"),
        pause () {
            send({
                type: "PAUSE"
            });
        },
        resume () {
            send({
                type: "RESUME"
            });
        },
        dismiss () {
            send({
                type: "DISMISS",
                src: "programmatic"
            });
        },
        getRootProps () {
            return normalize.element({
                ...(0, $e1099a19913879a5$export$6e2410c1d27f06e7).root.attrs,
                dir: prop("dir"),
                id: $8141bd6b70fa174e$export$dfdcab00b0f585a9(scope),
                "data-state": visible ? "open" : "closed",
                "data-type": type,
                "data-placement": placement,
                "data-align": align,
                "data-side": side,
                "data-mounted": (0, $dbd9babc41e226bd$export$5cc3b7b83e34ade7)(mounted),
                "data-paused": (0, $dbd9babc41e226bd$export$5cc3b7b83e34ade7)(paused),
                "data-first": (0, $dbd9babc41e226bd$export$5cc3b7b83e34ade7)(frontmost),
                "data-sibling": (0, $dbd9babc41e226bd$export$5cc3b7b83e34ade7)(!frontmost),
                "data-stack": (0, $dbd9babc41e226bd$export$5cc3b7b83e34ade7)(stacked),
                "data-overlap": (0, $dbd9babc41e226bd$export$5cc3b7b83e34ade7)(!stacked),
                role: "status",
                "aria-atomic": "true",
                "aria-describedby": description ? $8141bd6b70fa174e$export$abcfdc629db68a85(scope) : void 0,
                "aria-labelledby": title ? $8141bd6b70fa174e$export$aed19156d565b1d7(scope) : void 0,
                tabIndex: 0,
                style: (0, $a2968e013ced240e$export$c3e7864cecc29b16)(service, visible),
                onKeyDown (event) {
                    if (event.defaultPrevented) return;
                    if (event.key == "Escape") {
                        send({
                            type: "DISMISS",
                            src: "keyboard"
                        });
                        event.preventDefault();
                    }
                }
            });
        },
        /* Leave a ghost div to avoid setting hover to false when transitioning out */ getGhostBeforeProps () {
            return normalize.element({
                "data-ghost": "before",
                style: (0, $a2968e013ced240e$export$597297f46960059)(service, visible)
            });
        },
        /* Needed to avoid setting hover to false when in between toasts */ getGhostAfterProps () {
            return normalize.element({
                "data-ghost": "after",
                style: (0, $a2968e013ced240e$export$eaa991be70027c94)()
            });
        },
        getTitleProps () {
            return normalize.element({
                ...(0, $e1099a19913879a5$export$6e2410c1d27f06e7).title.attrs,
                id: $8141bd6b70fa174e$export$aed19156d565b1d7(scope)
            });
        },
        getDescriptionProps () {
            return normalize.element({
                ...(0, $e1099a19913879a5$export$6e2410c1d27f06e7).description.attrs,
                id: $8141bd6b70fa174e$export$abcfdc629db68a85(scope)
            });
        },
        getActionTriggerProps () {
            return normalize.button({
                ...(0, $e1099a19913879a5$export$6e2410c1d27f06e7).actionTrigger.attrs,
                type: "button",
                onClick (event) {
                    if (event.defaultPrevented) return;
                    action?.onClick?.();
                    send({
                        type: "DISMISS",
                        src: "user"
                    });
                }
            });
        },
        getCloseTriggerProps () {
            return normalize.button({
                id: $8141bd6b70fa174e$export$eae8ddee3c3e583f(scope),
                ...(0, $e1099a19913879a5$export$6e2410c1d27f06e7).closeTrigger.attrs,
                type: "button",
                "aria-label": translations?.closeTriggerLabel,
                onClick (event) {
                    if (event.defaultPrevented) return;
                    send({
                        type: "DISMISS",
                        src: "user"
                    });
                }
            });
        }
    };
}

// src/index.ts
// src/toast-group.connect.ts




function $ab9e306324d7c3cb$export$db16d4faa4cb2b8f(service, normalize) {
    const { context: context, prop: prop, send: send, refs: refs, computed: computed } = service;
    return {
        getCount () {
            return context.get("toasts").length;
        },
        getToasts () {
            return context.get("toasts");
        },
        getGroupProps (options = {}) {
            const { label: label = "Notifications" } = options;
            const { hotkey: hotkey } = prop("store").attrs;
            const hotkeyLabel = hotkey.join("+").replace(/Key/g, "").replace(/Digit/g, "");
            const placement = computed("placement");
            const [side, align = "center"] = placement.split("-");
            return normalize.element({
                ...(0, $e1099a19913879a5$export$6e2410c1d27f06e7).group.attrs,
                dir: prop("dir"),
                tabIndex: -1,
                role: "region",
                "aria-label": `${label}, ${placement} (${hotkeyLabel})`,
                id: $8141bd6b70fa174e$export$49f220d8acb9e944(placement),
                "data-placement": placement,
                "data-side": side,
                "data-align": align,
                "aria-live": "polite",
                "aria-relevant": "additions text",
                "aria-atomic": "false",
                style: (0, $a2968e013ced240e$export$fcd226e73046c9a4)(service, placement),
                onMouseEnter () {
                    if (refs.get("ignoreMouseTimer").isActive()) return;
                    send({
                        type: "REGION.POINTER_ENTER",
                        placement: placement
                    });
                },
                onMouseMove () {
                    if (refs.get("ignoreMouseTimer").isActive()) return;
                    send({
                        type: "REGION.POINTER_ENTER",
                        placement: placement
                    });
                },
                onMouseLeave () {
                    if (refs.get("ignoreMouseTimer").isActive()) return;
                    send({
                        type: "REGION.POINTER_LEAVE",
                        placement: placement
                    });
                },
                onFocus (event) {
                    send({
                        type: "REGION.FOCUS",
                        target: event.relatedTarget
                    });
                },
                onBlur (event) {
                    if (refs.get("isFocusWithin") && !(0, $2020ec4601cca401$export$2344b14b097df817)(event.currentTarget, event.relatedTarget)) queueMicrotask(()=>send({
                            type: "REGION.BLUR"
                        }));
                }
            });
        },
        subscribe (fn) {
            const store = prop("store");
            return store.subscribe(()=>fn(context.get("toasts")));
        }
    };
}


// src/toast-group.machine.ts





var { guards: $7ca5379fa32331e6$var$guards, createMachine: $7ca5379fa32331e6$var$createMachine } = (0, $9aa7f39f9520657f$export$de27182ff8187d6c)();
var { and: $7ca5379fa32331e6$var$and } = $7ca5379fa32331e6$var$guards;
var $7ca5379fa32331e6$export$bb9b40b999ae9dbb = $7ca5379fa32331e6$var$createMachine({
    props ({ props: props }) {
        return {
            dir: "ltr",
            id: (0, $5246d161dcdee685$export$31b40729666a4ae0)(),
            ...props,
            store: props.store
        };
    },
    initialState ({ prop: prop }) {
        return prop("store").attrs.overlap ? "overlap" : "stack";
    },
    refs () {
        return {
            lastFocusedEl: null,
            isFocusWithin: false,
            isPointerWithin: false,
            ignoreMouseTimer: (0, $7eacfb22d5a39e52$export$1f3d5b43727c648a).create(),
            dismissableCleanup: void 0
        };
    },
    context ({ bindable: bindable }) {
        return {
            toasts: bindable(()=>({
                    defaultValue: [],
                    sync: true,
                    hash: (toasts)=>toasts.map((t)=>t.id).join(",")
                })),
            heights: bindable(()=>({
                    defaultValue: [],
                    sync: true
                }))
        };
    },
    computed: {
        count: ({ context: context })=>context.get("toasts").length,
        overlap: ({ prop: prop })=>prop("store").attrs.overlap,
        placement: ({ prop: prop })=>prop("store").attrs.placement
    },
    effects: [
        "subscribeToStore",
        "trackDocumentVisibility",
        "trackHotKeyPress"
    ],
    watch ({ track: track, context: context, action: action }) {
        track([
            ()=>context.hash("toasts")
        ], ()=>{
            queueMicrotask(()=>{
                action([
                    "collapsedIfEmpty",
                    "setDismissableBranch"
                ]);
            });
        });
    },
    exit: [
        "clearDismissableBranch",
        "clearLastFocusedEl",
        "clearMouseEventTimer"
    ],
    on: {
        "DOC.HOTKEY": {
            actions: [
                "focusRegionEl"
            ]
        },
        "REGION.BLUR": [
            {
                guard: $7ca5379fa32331e6$var$and("isOverlapping", "isPointerOut"),
                target: "overlap",
                actions: [
                    "collapseToasts",
                    "resumeToasts",
                    "restoreFocusIfPointerOut"
                ]
            },
            {
                guard: "isPointerOut",
                target: "stack",
                actions: [
                    "resumeToasts",
                    "restoreFocusIfPointerOut"
                ]
            },
            {
                actions: [
                    "clearFocusWithin"
                ]
            }
        ],
        "TOAST.REMOVE": {
            actions: [
                "removeToast",
                "removeHeight",
                "ignoreMouseEventsTemporarily"
            ]
        },
        "TOAST.PAUSE": {
            actions: [
                "pauseToasts"
            ]
        }
    },
    states: {
        stack: {
            on: {
                "REGION.POINTER_LEAVE": [
                    {
                        guard: "isOverlapping",
                        target: "overlap",
                        actions: [
                            "clearPointerWithin",
                            "resumeToasts",
                            "collapseToasts"
                        ]
                    },
                    {
                        actions: [
                            "clearPointerWithin",
                            "resumeToasts"
                        ]
                    }
                ],
                "REGION.OVERLAP": {
                    target: "overlap",
                    actions: [
                        "collapseToasts"
                    ]
                },
                "REGION.FOCUS": {
                    actions: [
                        "setLastFocusedEl",
                        "pauseToasts"
                    ]
                },
                "REGION.POINTER_ENTER": {
                    actions: [
                        "setPointerWithin",
                        "pauseToasts"
                    ]
                }
            }
        },
        overlap: {
            on: {
                "REGION.STACK": {
                    target: "stack",
                    actions: [
                        "expandToasts"
                    ]
                },
                "REGION.POINTER_ENTER": {
                    target: "stack",
                    actions: [
                        "setPointerWithin",
                        "pauseToasts",
                        "expandToasts"
                    ]
                },
                "REGION.FOCUS": {
                    target: "stack",
                    actions: [
                        "setLastFocusedEl",
                        "pauseToasts",
                        "expandToasts"
                    ]
                }
            }
        }
    },
    implementations: {
        guards: {
            isOverlapping: ({ computed: computed })=>computed("overlap"),
            isPointerOut: ({ refs: refs })=>!refs.get("isPointerWithin")
        },
        effects: {
            subscribeToStore ({ context: context, prop: prop }) {
                const store = prop("store");
                context.set("toasts", store.getVisibleToasts());
                return store.subscribe((toast)=>{
                    if (toast.dismiss) {
                        context.set("toasts", (prev)=>prev.filter((t)=>t.id !== toast.id));
                        return;
                    }
                    context.set("toasts", (prev)=>{
                        const index = prev.findIndex((t)=>t.id === toast.id);
                        if (index !== -1) return [
                            ...prev.slice(0, index),
                            {
                                ...prev[index],
                                ...toast
                            },
                            ...prev.slice(index + 1)
                        ];
                        return [
                            toast,
                            ...prev
                        ];
                    });
                });
            },
            trackHotKeyPress ({ prop: prop, send: send }) {
                const handleKeyDown = (event)=>{
                    const { hotkey: hotkey } = prop("store").attrs;
                    const isHotkeyPressed = hotkey.every((key)=>event[key] || event.code === key);
                    if (!isHotkeyPressed) return;
                    send({
                        type: "DOC.HOTKEY"
                    });
                };
                return (0, $3921311bf0c8eca9$export$b1d829ddf82884aa)(document, "keydown", handleKeyDown, {
                    capture: true
                });
            },
            trackDocumentVisibility ({ prop: prop, send: send, scope: scope }) {
                const { pauseOnPageIdle: pauseOnPageIdle } = prop("store").attrs;
                if (!pauseOnPageIdle) return;
                const doc = scope.getDoc();
                return (0, $3921311bf0c8eca9$export$b1d829ddf82884aa)(doc, "visibilitychange", ()=>{
                    const isHidden = doc.visibilityState === "hidden";
                    send({
                        type: isHidden ? "PAUSE_ALL" : "RESUME_ALL"
                    });
                });
            }
        },
        actions: {
            setDismissableBranch ({ refs: refs, context: context, computed: computed, scope: scope }) {
                const toasts = context.get("toasts");
                const placement = computed("placement");
                const hasToasts = toasts.length > 0;
                if (!hasToasts) {
                    refs.get("dismissableCleanup")?.();
                    return;
                }
                if (hasToasts && refs.get("dismissableCleanup")) return;
                const groupEl = ()=>$8141bd6b70fa174e$export$d436e90f012ec60b(scope, placement);
                const cleanup = (0, $1492ced6e5ccca82$export$42019839bfd578e2)(groupEl, {
                    defer: true
                });
                refs.set("dismissableCleanup", cleanup);
            },
            clearDismissableBranch ({ refs: refs }) {
                refs.get("dismissableCleanup")?.();
            },
            focusRegionEl ({ scope: scope, computed: computed }) {
                queueMicrotask(()=>{
                    $8141bd6b70fa174e$export$d436e90f012ec60b(scope, computed("placement"))?.focus();
                });
            },
            pauseToasts ({ prop: prop }) {
                prop("store").pause();
            },
            resumeToasts ({ prop: prop }) {
                prop("store").resume();
            },
            expandToasts ({ prop: prop }) {
                prop("store").expand();
            },
            collapseToasts ({ prop: prop }) {
                prop("store").collapse();
            },
            removeToast ({ prop: prop, event: event }) {
                prop("store").remove(event.id);
            },
            removeHeight ({ event: event, context: context }) {
                if (event?.id == null) return;
                queueMicrotask(()=>{
                    context.set("heights", (heights)=>heights.filter((height)=>height.id !== event.id));
                });
            },
            collapsedIfEmpty ({ send: send, computed: computed }) {
                if (!computed("overlap") || computed("count") > 1) return;
                send({
                    type: "REGION.OVERLAP"
                });
            },
            setLastFocusedEl ({ refs: refs, event: event }) {
                if (refs.get("isFocusWithin") || !event.target) return;
                refs.set("isFocusWithin", true);
                refs.set("lastFocusedEl", event.target);
            },
            restoreFocusIfPointerOut ({ refs: refs }) {
                if (!refs.get("lastFocusedEl") || refs.get("isPointerWithin")) return;
                refs.get("lastFocusedEl")?.focus({
                    preventScroll: true
                });
                refs.set("lastFocusedEl", null);
                refs.set("isFocusWithin", false);
            },
            setPointerWithin ({ refs: refs }) {
                refs.set("isPointerWithin", true);
            },
            clearPointerWithin ({ refs: refs }) {
                refs.set("isPointerWithin", false);
                if (refs.get("lastFocusedEl") && !refs.get("isFocusWithin")) {
                    refs.get("lastFocusedEl")?.focus({
                        preventScroll: true
                    });
                    refs.set("lastFocusedEl", null);
                }
            },
            clearFocusWithin ({ refs: refs }) {
                refs.set("isFocusWithin", false);
            },
            clearLastFocusedEl ({ refs: refs }) {
                if (!refs.get("lastFocusedEl")) return;
                refs.get("lastFocusedEl")?.focus({
                    preventScroll: true
                });
                refs.set("lastFocusedEl", null);
                refs.set("isFocusWithin", false);
            },
            ignoreMouseEventsTemporarily ({ refs: refs }) {
                refs.get("ignoreMouseTimer").request();
            },
            clearMouseEventTimer ({ refs: refs }) {
                refs.get("ignoreMouseTimer").cancel();
            }
        }
    }
});




// src/toast.machine.ts


var $d6c0a1f89bfb1a07$var$__defProp = Object.defineProperty;
var $d6c0a1f89bfb1a07$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $d6c0a1f89bfb1a07$var$__defNormalProp = (obj, key, value)=>key in obj ? $d6c0a1f89bfb1a07$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $d6c0a1f89bfb1a07$export$5cb848ba4d1f099 = (obj, key, value)=>$d6c0a1f89bfb1a07$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var $d6c0a1f89bfb1a07$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $d6c0a1f89bfb1a07$var$__typeError("Cannot " + msg);
var $d6c0a1f89bfb1a07$export$18a094aefa070634 = (obj, member, getter)=>($d6c0a1f89bfb1a07$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $d6c0a1f89bfb1a07$export$addf369becd23283 = (obj, member, value)=>member.has(obj) ? $d6c0a1f89bfb1a07$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);


// src/timers.ts
var $c3b737e7610b79ba$var$currentTime = ()=>performance.now();
var $c3b737e7610b79ba$var$_tick;
var $c3b737e7610b79ba$export$c57e9b2d8b9e4de = class {
    constructor(onTick){
        (0, $d6c0a1f89bfb1a07$export$5cb848ba4d1f099)(this, "onTick", onTick);
        (0, $d6c0a1f89bfb1a07$export$5cb848ba4d1f099)(this, "frameId", null);
        (0, $d6c0a1f89bfb1a07$export$5cb848ba4d1f099)(this, "pausedAtMs", null);
        (0, $d6c0a1f89bfb1a07$export$5cb848ba4d1f099)(this, "context");
        (0, $d6c0a1f89bfb1a07$export$5cb848ba4d1f099)(this, "cancelFrame", ()=>{
            if (this.frameId === null) return;
            cancelAnimationFrame(this.frameId);
            this.frameId = null;
        });
        (0, $d6c0a1f89bfb1a07$export$5cb848ba4d1f099)(this, "setStartMs", (startMs)=>{
            this.context.startMs = startMs;
        });
        (0, $d6c0a1f89bfb1a07$export$5cb848ba4d1f099)(this, "start", ()=>{
            if (this.frameId !== null) return;
            const now = $c3b737e7610b79ba$var$currentTime();
            if (this.pausedAtMs !== null) {
                this.context.startMs += now - this.pausedAtMs;
                this.pausedAtMs = null;
            } else this.context.startMs = now;
            this.frameId = requestAnimationFrame((0, $d6c0a1f89bfb1a07$export$18a094aefa070634)(this, $c3b737e7610b79ba$var$_tick));
        });
        (0, $d6c0a1f89bfb1a07$export$5cb848ba4d1f099)(this, "pause", ()=>{
            if (this.frameId === null) return;
            this.cancelFrame();
            this.pausedAtMs = $c3b737e7610b79ba$var$currentTime();
        });
        (0, $d6c0a1f89bfb1a07$export$5cb848ba4d1f099)(this, "stop", ()=>{
            if (this.frameId === null) return;
            this.cancelFrame();
            this.pausedAtMs = null;
        });
        (0, $d6c0a1f89bfb1a07$export$addf369becd23283)(this, $c3b737e7610b79ba$var$_tick, (now)=>{
            this.context.now = now;
            this.context.deltaMs = now - this.context.startMs;
            const shouldContinue = this.onTick(this.context);
            if (shouldContinue === false) {
                this.stop();
                return;
            }
            this.frameId = requestAnimationFrame((0, $d6c0a1f89bfb1a07$export$18a094aefa070634)(this, $c3b737e7610b79ba$var$_tick));
        });
        this.context = {
            now: 0,
            startMs: $c3b737e7610b79ba$var$currentTime(),
            deltaMs: 0
        };
    }
    get elapsedMs() {
        if (this.pausedAtMs !== null) return this.pausedAtMs - this.context.startMs;
        return $c3b737e7610b79ba$var$currentTime() - this.context.startMs;
    }
};
$c3b737e7610b79ba$var$_tick = new WeakMap();
function $c3b737e7610b79ba$export$f34283cc2c2ba8c8(fn, intervalMs) {
    const timer = new $c3b737e7610b79ba$export$c57e9b2d8b9e4de(({ now: now, deltaMs: deltaMs })=>{
        if (deltaMs >= intervalMs) {
            const startMs = intervalMs > 0 ? now - deltaMs % intervalMs : now;
            timer.setStartMs(startMs);
            fn({
                startMs: startMs,
                deltaMs: deltaMs
            });
        }
    });
    timer.start();
    return ()=>timer.stop();
}
function $c3b737e7610b79ba$export$6e04fbef349b692b(fn, delayMs) {
    const timer = new $c3b737e7610b79ba$export$c57e9b2d8b9e4de(({ deltaMs: deltaMs })=>{
        if (deltaMs >= delayMs) {
            fn();
            return false;
        }
    });
    timer.start();
    return ()=>timer.stop();
}




var { not: $534cb23390da6e7a$var$not } = (0, $9aa7f39f9520657f$export$285462e61607a24f)();
var $534cb23390da6e7a$export$ea56d40cd27c3480 = (0, $9aa7f39f9520657f$export$aaa7fa18f8e9b2e8)({
    props ({ props: props }) {
        (0, $db2b97a8c70ba27b$export$c96bf300e5609ed5)(props, [
            "id",
            "type",
            "parent",
            "removeDelay"
        ], "toast");
        return {
            closable: true,
            ...props,
            translations: {
                closeTriggerLabel: "Dismiss notification",
                ...props.translations
            },
            duration: (0, $a2968e013ced240e$export$9ff39afc2486f8cc)(props.duration, props.type)
        };
    },
    initialState ({ prop: prop }) {
        const persist = prop("type") === "loading" || prop("duration") === Infinity;
        return persist ? "visible:persist" : "visible";
    },
    context ({ prop: prop, bindable: bindable }) {
        return {
            remainingTime: bindable(()=>({
                    defaultValue: (0, $a2968e013ced240e$export$9ff39afc2486f8cc)(prop("duration"), prop("type"))
                })),
            createdAt: bindable(()=>({
                    defaultValue: Date.now()
                })),
            mounted: bindable(()=>({
                    defaultValue: false
                })),
            initialHeight: bindable(()=>({
                    defaultValue: 0
                }))
        };
    },
    refs () {
        return {
            closeTimerStartTime: Date.now(),
            lastCloseStartTimerStartTime: 0
        };
    },
    computed: {
        zIndex: ({ prop: prop })=>{
            const toasts = prop("parent").context.get("toasts");
            const index = toasts.findIndex((toast)=>toast.id === prop("id"));
            return toasts.length - index;
        },
        height: ({ prop: prop })=>{
            const heights = prop("parent").context.get("heights");
            const height = heights.find((height2)=>height2.id === prop("id"));
            return height?.height ?? 0;
        },
        heightIndex: ({ prop: prop })=>{
            const heights = prop("parent").context.get("heights");
            return heights.findIndex((height)=>height.id === prop("id"));
        },
        frontmost: ({ prop: prop })=>prop("index") === 0,
        heightBefore: ({ prop: prop })=>{
            const heights = prop("parent").context.get("heights");
            const heightIndex = heights.findIndex((height)=>height.id === prop("id"));
            return heights.reduce((prev, curr, reducerIndex)=>{
                if (reducerIndex >= heightIndex) return prev;
                return prev + curr.height;
            }, 0);
        },
        shouldPersist: ({ prop: prop })=>prop("type") === "loading" || prop("duration") === Infinity
    },
    watch ({ track: track, prop: prop, send: send }) {
        track([
            ()=>prop("message")
        ], ()=>{
            const message = prop("message");
            if (message) send({
                type: message,
                src: "programmatic"
            });
        });
        track([
            ()=>prop("type"),
            ()=>prop("duration")
        ], ()=>{
            send({
                type: "UPDATE"
            });
        });
    },
    on: {
        UPDATE: [
            {
                guard: "shouldPersist",
                target: "visible:persist",
                actions: [
                    "resetCloseTimer"
                ]
            },
            {
                target: "visible:updating",
                actions: [
                    "resetCloseTimer"
                ]
            }
        ],
        MEASURE: {
            actions: [
                "measureHeight"
            ]
        }
    },
    entry: [
        "setMounted",
        "measureHeight",
        "invokeOnVisible"
    ],
    effects: [
        "trackHeight"
    ],
    states: {
        "visible:updating": {
            tags: [
                "visible",
                "updating"
            ],
            effects: [
                "waitForNextTick"
            ],
            on: {
                SHOW: {
                    target: "visible"
                }
            }
        },
        "visible:persist": {
            tags: [
                "visible",
                "paused"
            ],
            on: {
                RESUME: {
                    guard: $534cb23390da6e7a$var$not("isLoadingType"),
                    target: "visible",
                    actions: [
                        "setCloseTimer"
                    ]
                },
                DISMISS: {
                    target: "dismissing"
                }
            }
        },
        visible: {
            tags: [
                "visible"
            ],
            effects: [
                "waitForDuration"
            ],
            on: {
                DISMISS: {
                    target: "dismissing"
                },
                PAUSE: {
                    target: "visible:persist",
                    actions: [
                        "syncRemainingTime"
                    ]
                }
            }
        },
        dismissing: {
            entry: [
                "invokeOnDismiss"
            ],
            effects: [
                "waitForRemoveDelay"
            ],
            on: {
                REMOVE: {
                    target: "unmounted",
                    actions: [
                        "notifyParentToRemove"
                    ]
                }
            }
        },
        unmounted: {
            entry: [
                "invokeOnUnmount"
            ]
        }
    },
    implementations: {
        effects: {
            waitForRemoveDelay ({ prop: prop, send: send }) {
                return (0, $c3b737e7610b79ba$export$6e04fbef349b692b)(()=>{
                    send({
                        type: "REMOVE",
                        src: "timer"
                    });
                }, prop("removeDelay"));
            },
            waitForDuration ({ send: send, context: context, computed: computed }) {
                if (computed("shouldPersist")) return;
                return (0, $c3b737e7610b79ba$export$6e04fbef349b692b)(()=>{
                    send({
                        type: "DISMISS",
                        src: "timer"
                    });
                }, context.get("remainingTime"));
            },
            waitForNextTick ({ send: send }) {
                return (0, $c3b737e7610b79ba$export$6e04fbef349b692b)(()=>{
                    send({
                        type: "SHOW",
                        src: "timer"
                    });
                }, 0);
            },
            trackHeight ({ scope: scope, prop: prop }) {
                let cleanup;
                (0, $7eacfb22d5a39e52$export$27f233d61a9e2fa4)(()=>{
                    const rootEl = $8141bd6b70fa174e$export$5688053fba312fa5(scope);
                    if (!rootEl) return;
                    const syncHeight = ()=>{
                        const originalHeight = rootEl.style.height;
                        rootEl.style.height = "auto";
                        const height = rootEl.getBoundingClientRect().height;
                        rootEl.style.height = originalHeight;
                        const item = {
                            id: prop("id"),
                            height: height
                        };
                        $534cb23390da6e7a$var$setHeight(prop("parent"), item);
                    };
                    const win = scope.getWin();
                    const observer = new win.MutationObserver(syncHeight);
                    observer.observe(rootEl, {
                        childList: true,
                        subtree: true,
                        characterData: true
                    });
                    cleanup = ()=>observer.disconnect();
                });
                return ()=>cleanup?.();
            }
        },
        guards: {
            isLoadingType: ({ prop: prop })=>prop("type") === "loading",
            shouldPersist: ({ computed: computed })=>computed("shouldPersist")
        },
        actions: {
            setMounted ({ context: context }) {
                (0, $7eacfb22d5a39e52$export$27f233d61a9e2fa4)(()=>{
                    context.set("mounted", true);
                });
            },
            measureHeight ({ scope: scope, prop: prop, context: context }) {
                queueMicrotask(()=>{
                    const rootEl = $8141bd6b70fa174e$export$5688053fba312fa5(scope);
                    if (!rootEl) return;
                    const originalHeight = rootEl.style.height;
                    rootEl.style.height = "auto";
                    const height = rootEl.getBoundingClientRect().height;
                    rootEl.style.height = originalHeight;
                    context.set("initialHeight", height);
                    const item = {
                        id: prop("id"),
                        height: height
                    };
                    $534cb23390da6e7a$var$setHeight(prop("parent"), item);
                });
            },
            setCloseTimer ({ refs: refs }) {
                refs.set("closeTimerStartTime", Date.now());
            },
            resetCloseTimer ({ context: context, refs: refs, prop: prop }) {
                refs.set("closeTimerStartTime", Date.now());
                context.set("remainingTime", (0, $a2968e013ced240e$export$9ff39afc2486f8cc)(prop("duration"), prop("type")));
            },
            syncRemainingTime ({ context: context, refs: refs }) {
                context.set("remainingTime", (prev)=>{
                    const closeTimerStartTime = refs.get("closeTimerStartTime");
                    const elapsedTime = Date.now() - closeTimerStartTime;
                    refs.set("lastCloseStartTimerStartTime", Date.now());
                    return prev - elapsedTime;
                });
            },
            notifyParentToRemove ({ prop: prop }) {
                const parent = prop("parent");
                parent.send({
                    type: "TOAST.REMOVE",
                    id: prop("id")
                });
            },
            invokeOnDismiss ({ prop: prop, event: event }) {
                prop("onStatusChange")?.({
                    status: "dismissing",
                    src: event.src
                });
            },
            invokeOnUnmount ({ prop: prop }) {
                prop("onStatusChange")?.({
                    status: "unmounted"
                });
            },
            invokeOnVisible ({ prop: prop }) {
                prop("onStatusChange")?.({
                    status: "visible"
                });
            }
        }
    }
});
function $534cb23390da6e7a$var$setHeight(parent, item) {
    const { id: id, height: height } = item;
    parent.context.set("heights", (prev)=>{
        const alreadyExists = prev.find((i)=>i.id === id);
        if (!alreadyExists) return [
            {
                id: id,
                height: height
            },
            ...prev
        ];
        else return prev.map((i)=>i.id === id ? {
                ...i,
                height: height
            } : i);
    });
}



var $248d96e2a19fc818$export$e5e25fbcc1f7affe = {
    connect: (0, $ab9e306324d7c3cb$export$db16d4faa4cb2b8f),
    machine: (0, $7ca5379fa32331e6$export$bb9b40b999ae9dbb)
};



var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/toast/toaster.tsx
var $09f9f5180c8c2371$export$fb98e3a2a4cd92d7 = (0, $8v0nu.forwardRef)((props, ref)=>{
    const { toaster: toaster, children: children, ...localProps } = props;
    const locale = (0, $af19f2672b388a39$export$2a7b1d9f665d6730)();
    const env = (0, $cfa7a900a06000ef$export$899b1e582a0b3c80)();
    const service = (0, $54265883fb157840$export$e0338c4153421160)($248d96e2a19fc818$export$e5e25fbcc1f7affe.machine, {
        store: toaster,
        id: (0, $8v0nu.useId)(),
        dir: locale?.dir,
        getRootNode: env?.getRootNode
    });
    const api = $248d96e2a19fc818$export$e5e25fbcc1f7affe.connect(service, (0, $06b0a2ce147a2fe4$export$601abcd8103db5e4));
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)(api.getGroupProps(), localProps);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).div, {
        ...mergedProps,
        ref: ref,
        children: api.getToasts().map((toast, index)=>/* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)($09f9f5180c8c2371$var$ToastActor, {
                value: toast,
                parent: service,
                index: index,
                children: (ctx)=>children(ctx)
            }, toast.id))
    });
});
$09f9f5180c8c2371$export$fb98e3a2a4cd92d7.displayName = "Toaster";
var $09f9f5180c8c2371$var$ToastActor = (props)=>{
    const env = (0, $cfa7a900a06000ef$export$899b1e582a0b3c80)();
    const localProps = {
        ...props.value,
        parent: props.parent,
        index: props.index,
        getRootNode: env.getRootNode
    };
    const service = (0, $54265883fb157840$export$e0338c4153421160)($534cb23390da6e7a$export$ea56d40cd27c3480, {
        ...localProps
    });
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $09f4670cb5c31849$export$f5d03d415824e0e), {
        value: $c24977ae36f92554$export$64605811ab45167f(service, (0, $06b0a2ce147a2fe4$export$601abcd8103db5e4)),
        children: props.children(props.value)
    });
};
$09f9f5180c8c2371$var$ToastActor.displayName = "ToastActor";



var $8v0nu = parcelRequire("8v0nu");



"use strict";
"use client";
const { withProvider: $5e0ddd0f2d32d482$var$withProvider, withContext: $5e0ddd0f2d32d482$var$withContext, useStyles: $5e0ddd0f2d32d482$export$a824b8ecc0b3d876 } = (0, $04636a451c2392c0$export$ac7f79c9443925b8)({
    key: "toast"
});
const $5e0ddd0f2d32d482$export$fb98e3a2a4cd92d7 = (0, $4042601bfa1a9d25$export$7cd122d781af9fa4)((0, $09f9f5180c8c2371$export$fb98e3a2a4cd92d7), {}, {
    forwardAsChild: true
});
const $5e0ddd0f2d32d482$export$23ad0642d3ca56f8 = $5e0ddd0f2d32d482$var$withProvider((0, $31de3b58cb54507d$export$86736d28bad4679b).Root, "root", {
    forwardAsChild: true
});
const $5e0ddd0f2d32d482$export$f5ef638cf70daa7c = $5e0ddd0f2d32d482$var$withContext((0, $31de3b58cb54507d$export$86736d28bad4679b).CloseTrigger, "closeTrigger", {
    forwardAsChild: true,
    defaultProps: {
        children: /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $2ec3c16c879c0088$export$cae179f078f4b4a4), {})
    }
});
const $5e0ddd0f2d32d482$export$16d42d7c29b95a4 = $5e0ddd0f2d32d482$var$withContext((0, $31de3b58cb54507d$export$86736d28bad4679b).Title, "title", {
    forwardAsChild: true
});
const $5e0ddd0f2d32d482$export$ecddd96c53621d9a = $5e0ddd0f2d32d482$var$withContext((0, $31de3b58cb54507d$export$86736d28bad4679b).Description, "description", {
    forwardAsChild: true
});
const $5e0ddd0f2d32d482$export$40c7bd277b2b5f0f = $5e0ddd0f2d32d482$var$withContext((0, $31de3b58cb54507d$export$86736d28bad4679b).ActionTrigger, "actionTrigger", {
    forwardAsChild: true
});
const $5e0ddd0f2d32d482$var$iconMap = {
    warning: (0, $2ec3c16c879c0088$export$f7dc499a72baa103),
    success: (0, $2ec3c16c879c0088$export$f6dd727656c97851),
    error: (0, $2ec3c16c879c0088$export$f7dc499a72baa103)
};
const $5e0ddd0f2d32d482$export$c5f1a77e8dc95e53 = (0, $8v0nu.forwardRef)(function ToastIndicator2(props, ref) {
    const { unstyled: unstyled, ...restProps } = props;
    const api = (0, $09f4670cb5c31849$export$91b3d218c74c79e4)();
    const styles = $5e0ddd0f2d32d482$export$a824b8ecc0b3d876();
    const Component = $5e0ddd0f2d32d482$var$iconMap[api.type];
    if (!Component) return null;
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)(Component, {
        ref: ref,
        ...restProps,
        css: [
            !unstyled ? styles.indicator : void 0,
            props.css
        ]
    });
});


"use strict";






parcelRequire("8v0nu");
// Pull a human-readable message out of whatever shape the server returned.
// Covers the common ones: plain string body, OAuth/IdP { error_description },
// FastAPI/STAC { detail: 'string' } / { message } / { description }. Returns
// undefined when nothing usable is there so callers can fall back to a
// canned message instead of rendering an empty toast.
function $99f040781eeb1a87$var$extractErrorMessage(detail) {
    if (typeof detail === 'string') return detail || undefined;
    if (detail && typeof detail === 'object') {
        const d = detail;
        if (typeof d.error_description === 'string') return d.error_description;
        if (typeof d.message === 'string') return d.message;
        if (typeof d.detail === 'string') return d.detail;
        if (typeof d.description === 'string') return d.description;
    }
    return undefined;
}
function $99f040781eeb1a87$export$909e4416e391c200(response) {
    const detailObj = response.detail && typeof response.detail === 'object' ? response.detail : {};
    if (response.status === 400 && Array.isArray(detailObj.detail)) {
        const notifications = detailObj.detail.reduce((acc, error, i)=>{
            let p = error.loc.slice(1);
            const last = error.loc[error.loc.length - 1];
            if (last === 'float' || last === 'int') p = p.slice(0, -1);
            const path = p.join('.');
            return acc.has(path) ? acc : acc.set(path, {
                id: i,
                type: 'validation-error',
                path: path,
                message: error.msg
            });
        }, new Map());
        return Array.from(notifications.values());
    }
    const serverMessage = $99f040781eeb1a87$var$extractErrorMessage(response.detail);
    if (response.status === 403) return [
        {
            id: 0,
            type: 'error',
            title: 'Forbidden',
            message: serverMessage ?? 'You do not have permission to perform this action.'
        }
    ];
    return [
        {
            id: 0,
            type: 'error',
            title: `Error ${response.status}`,
            message: serverMessage ?? `An error occurred: ${response.statusText}`
        }
    ];
}
function $99f040781eeb1a87$export$96920386c636a51b(notifications) {
    if (notifications.length === 0) {
        (0, $8d97b9cd1bee0709$export$a224d1f4f6f98541).dismiss('notifications');
        return;
    }
    const meta = {
        kind: 'notifications',
        notifications: notifications
    };
    if ((0, $8d97b9cd1bee0709$export$a224d1f4f6f98541).isVisible('notifications')) (0, $8d97b9cd1bee0709$export$a224d1f4f6f98541).update('notifications', {
        meta: meta
    });
    else (0, $8d97b9cd1bee0709$export$a224d1f4f6f98541).create({
        id: 'notifications',
        duration: Number.POSITIVE_INFINITY,
        meta: meta
    });
}
function $99f040781eeb1a87$export$692ce0c46c25a0f8() {
    (0, $8d97b9cd1bee0709$export$a224d1f4f6f98541).dismiss('notifications');
}
function $99f040781eeb1a87$export$595cbcb116fb5622(props) {
    const { notifications: notifications } = props;
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $a987639d7be6b91e$export$353f5b6fc5456de1), {
        "aria-label": "Notifications",
        variant: "outline",
        onClick: ()=>$99f040781eeb1a87$export$96920386c636a51b(notifications),
        children: [
            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9138db1f951ed55c$export$6d44efda105760b1), {}),
            !!notifications.length && /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $486a1f24d187216b$export$37acb3580601e69a), {
                variant: "solid",
                color: "white",
                bg: "base.400a",
                position: "absolute",
                top: "-0.5rem",
                right: "-0.5rem",
                px: 2,
                children: notifications.length < 10 ? `0${notifications.length}` : notifications.length
            })
        ]
    });
}
function $99f040781eeb1a87$export$4cc4937c9c6837aa(props) {
    const { onCloseClick: onCloseClick, notifications: notifications } = props;
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $1415810625b263eb$export$e71c4d32a2263218), {
        shadow: "md",
        borderRadius: "md",
        bg: "surface.500",
        w: "100%",
        overflow: "hidden",
        children: [
            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
                p: 4,
                borderBottomWidth: "1px",
                borderBottomStyle: "solid",
                borderBottomColor: "base.100",
                boxShadow: "0 1px 0 0 rgba(0, 0, 0, 0.08)",
                position: "relative",
                alignItems: "center",
                gap: 4,
                children: [
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $5dcf33ee745c0ffc$export$a8a3e93435678ff9), {
                        size: "xs",
                        children: "Notifications"
                    }),
                    !!notifications.length && /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $486a1f24d187216b$export$37acb3580601e69a), {
                        variant: "solid",
                        color: "white",
                        bg: "base.400a",
                        px: 2,
                        children: [
                            ' ',
                            notifications.length < 10 ? `0${notifications.length}` : notifications.length
                        ]
                    }),
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $756da344c07e2b07$export$c25acd513dcc8062), {
                        "aria-label": "Close notifications",
                        size: "sm",
                        variant: "outline",
                        onClick: onCloseClick,
                        ml: "auto",
                        children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9138db1f951ed55c$export$4cca98ab4f54f41d), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $1415810625b263eb$export$e71c4d32a2263218), {
                overflowY: "scroll",
                maxH: "30rem",
                children: notifications.length ? notifications.map((n)=>/*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)($99f040781eeb1a87$var$ErrorNotification, {
                        ...n
                    }, n.id)) : /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
                    height: 20,
                    alignItems: "center",
                    justifyContent: "center",
                    px: 8,
                    children: "Nothing to show besides this satellite \uD83D\uDEF0\uFE0F"
                })
            })
        ]
    });
}
function $99f040781eeb1a87$var$ErrorNotification(props) {
    const { message: message, title: title } = props;
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
        boxShadow: "0 -1px 0 0 rgba(0, 0, 0, 0.08)",
        position: "relative",
        children: [
            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
                bg: "danger.200",
                p: 4,
                children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9138db1f951ed55c$export$f72e08a2ef494448), {
                    color: "danger.500"
                })
            }),
            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $1415810625b263eb$export$e71c4d32a2263218), {
                p: 4,
                children: [
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9318c0c5b8c25a88$export$5f1af8db9871e1d6), {
                        fontWeight: "bold",
                        mb: 2,
                        children: title || (props.type === 'validation-error' ? 'Validation error' : 'Error')
                    }),
                    props.type === 'validation-error' && /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $ef524fb144c5d632$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9318c0c5b8c25a88$export$5f1af8db9871e1d6), {
                                as: "span",
                                fontWeight: "bold",
                                children: "At:"
                            }),
                            ' ',
                            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9318c0c5b8c25a88$export$5f1af8db9871e1d6), {
                                as: "span",
                                fontStyle: "italic",
                                children: props.path
                            }),
                            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)("br", {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9318c0c5b8c25a88$export$5f1af8db9871e1d6), {
                        children: message
                    })
                ]
            })
        ]
    });
}


const $8d97b9cd1bee0709$export$a224d1f4f6f98541 = (0, $22c2a82039340f2c$export$485098e18d680f1a)({
    placement: 'bottom-end',
    pauseOnPageIdle: true
});
function $8d97b9cd1bee0709$var$isNotificationsMeta(meta) {
    return !!meta && meta.kind === 'notifications';
}
function $8d97b9cd1bee0709$export$fb98e3a2a4cd92d7() {
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $5e0ddd0f2d32d482$export$fb98e3a2a4cd92d7), {
        toaster: $8d97b9cd1bee0709$export$a224d1f4f6f98541,
        children: (toast)=>{
            if ($8d97b9cd1bee0709$var$isNotificationsMeta(toast.meta)) // The toast group is `position: fixed` with no width and its roots
            // are absolutely positioned, so the group collapses to 0 width and
            // the recipe's `width: full` resolves to 0. Give the root an explicit
            // width (Chakra's docs do the same) and drop the recipe padding/bg so
            // NotificationBox — which brings its own surface — fills it edge to
            // edge.
            return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $776869f4a947130c$exports).Root, {
                width: {
                    base: 'calc(100vw - 2rem)',
                    md: 'md'
                },
                p: 0,
                bg: "transparent",
                boxShadow: "none",
                children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $99f040781eeb1a87$export$4cc4937c9c6837aa), {
                    notifications: toast.meta.notifications,
                    onCloseClick: ()=>$8d97b9cd1bee0709$export$a224d1f4f6f98541.dismiss(toast.id)
                })
            });
            return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $776869f4a947130c$exports).Root, {
                width: {
                    base: 'calc(100vw - 2rem)',
                    md: 'sm'
                },
                children: [
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $776869f4a947130c$exports).Indicator, {}),
                    toast.title && /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $776869f4a947130c$exports).Title, {
                        children: toast.title
                    }),
                    toast.description && /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $776869f4a947130c$exports).Description, {
                        children: toast.description
                    }),
                    toast.closable && /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $776869f4a947130c$exports).CloseTrigger, {})
                ]
            });
        }
    });
}







var $8v0nu = parcelRequire("8v0nu");

parcelRequire("8v0nu");

"use strict";
"use client";
const { withContext: $935a7e20cc1c3704$var$withContext, PropsProvider: $935a7e20cc1c3704$var$PropsProvider } = (0, $aa5f4d03028a5427$export$e99ac154c18649c5)({
    key: "code"
});
const $935a7e20cc1c3704$export$52f0f02147b12c03 = $935a7e20cc1c3704$var$withContext("code");
const $935a7e20cc1c3704$export$ef326c0c0d8810ed = $935a7e20cc1c3704$var$PropsProvider;



var $jTKGQ = parcelRequire("jTKGQ");


var $8v0nu = parcelRequire("8v0nu");
// Plugin context provider
const $a8feea9ca12f00da$var$PluginContext = /*#__PURE__*/ (0, $8v0nu.createContext)(undefined);
const $a8feea9ca12f00da$export$cb523441152b28bb = (props)=>{
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)($a8feea9ca12f00da$var$PluginContext.Provider, {
        value: props.plugin,
        children: props.children
    });
};
const $a8feea9ca12f00da$export$56d29ed512ea644 = ()=>{
    const plugin = (0, $8v0nu.useContext)($a8feea9ca12f00da$var$PluginContext);
    if (!plugin) throw new Error('usePlugin must be used within a PluginProvider');
    return plugin;
};


/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars */ const $c0a25ef586f9da64$var$HIDDEN = Symbol('hidden');
const $c0a25ef586f9da64$var$HOOKS = Symbol('hooks');
class $c0a25ef586f9da64$export$901cf72dabf2112a {
    static HIDDEN = $c0a25ef586f9da64$var$HIDDEN;
    static HOOKS = $c0a25ef586f9da64$var$HOOKS;
    [$c0a25ef586f9da64$var$HOOKS] = [];
    name = 'Plugin';
    init(data) {}
    editSchema(formData) {
        return undefined;
    }
    enterData(data) {
        throw new Error(`Plugin [${this.name}] must implement enterData`);
    }
    exitData(data) {
        throw new Error(`Plugin [${this.name}] must implement exitData`);
    }
    /**
   * Registers a hook to be applied on a given plugin.
   *
   * @param targetName - The name of the target plugin to which the hook will be
   * applied.
   * @param hookName - The name of the hook.
   * @param hook - The hook function.
   */ registerHook(targetName, hookName, hook) {
        const hookEntry = this[$c0a25ef586f9da64$export$901cf72dabf2112a.HOOKS].find((h)=>h.name === targetName);
        if (hookEntry) hookEntry[hookName] = hook;
        else this[$c0a25ef586f9da64$export$901cf72dabf2112a.HOOKS].push({
            name: targetName,
            [hookName]: hook
        });
    }
}



parcelRequire("8v0nu");

function $f49fc02b2c636efe$export$f04a3ea04edc0e04(props) {
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
        maxW: "3xl",
        alignItems: "center",
        direction: "column",
        gap: 4,
        py: 16,
        px: 8,
        color: "red.500",
        borderRadius: "md",
        borderWidth: 1,
        borderStyle: "dashed",
        borderColor: "red.500",
        ...props
    });
}


function $4f2b90a8dcc95f5b$export$6a4d9223b7302baa(props) {
    const { plugin: plugin, children: children } = props;
    const { values: values } = (0, $jTKGQ.useFormikContext)();
    const editSchema = plugin.editSchema(values);
    if (!editSchema) return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $f49fc02b2c636efe$export$f04a3ea04edc0e04), {
        "data-testid": "plugin-box-error",
        children: [
            "Plugin ",
            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $935a7e20cc1c3704$export$52f0f02147b12c03), {
                color: "red",
                children: plugin.name
            }),
            " has no edit schema."
        ]
    });
    if (editSchema === (0, $c0a25ef586f9da64$export$901cf72dabf2112a).HIDDEN) return null;
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $a8feea9ca12f00da$export$cb523441152b28bb), {
        plugin: plugin,
        children: children({
            field: editSchema
        })
    });
}


var $8v0nu = parcelRequire("8v0nu");

var $jTKGQ = parcelRequire("jTKGQ");
var $75b98c86abc67c8e$exports = {};
/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */ 'use strict';
function $75b98c86abc67c8e$var$Cache(maxSize) {
    this._maxSize = maxSize;
    this.clear();
}
$75b98c86abc67c8e$var$Cache.prototype.clear = function() {
    this._size = 0;
    this._values = Object.create(null);
};
$75b98c86abc67c8e$var$Cache.prototype.get = function(key) {
    return this._values[key];
};
$75b98c86abc67c8e$var$Cache.prototype.set = function(key, value) {
    this._size >= this._maxSize && this.clear();
    if (!(key in this._values)) this._size++;
    return this._values[key] = value;
};
var $75b98c86abc67c8e$var$SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g, $75b98c86abc67c8e$var$DIGIT_REGEX = /^\d+$/, $75b98c86abc67c8e$var$LEAD_DIGIT_REGEX = /^\d/, $75b98c86abc67c8e$var$SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, $75b98c86abc67c8e$var$CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/, $75b98c86abc67c8e$var$MAX_CACHE_SIZE = 512;
var $75b98c86abc67c8e$var$pathCache = new $75b98c86abc67c8e$var$Cache($75b98c86abc67c8e$var$MAX_CACHE_SIZE), $75b98c86abc67c8e$var$setCache = new $75b98c86abc67c8e$var$Cache($75b98c86abc67c8e$var$MAX_CACHE_SIZE), $75b98c86abc67c8e$var$getCache = new $75b98c86abc67c8e$var$Cache($75b98c86abc67c8e$var$MAX_CACHE_SIZE);
var $75b98c86abc67c8e$var$config;
$75b98c86abc67c8e$exports = {
    Cache: $75b98c86abc67c8e$var$Cache,
    split: $75b98c86abc67c8e$var$split,
    normalizePath: $75b98c86abc67c8e$var$normalizePath,
    setter: function(path) {
        var parts = $75b98c86abc67c8e$var$normalizePath(path);
        return $75b98c86abc67c8e$var$setCache.get(path) || $75b98c86abc67c8e$var$setCache.set(path, function setter(obj, value) {
            var index = 0;
            var len = parts.length;
            var data = obj;
            while(index < len - 1){
                var part = parts[index];
                if (part === '__proto__' || part === 'constructor' || part === 'prototype') return obj;
                data = data[parts[index++]];
            }
            data[parts[index]] = value;
        });
    },
    getter: function(path, safe) {
        var parts = $75b98c86abc67c8e$var$normalizePath(path);
        return $75b98c86abc67c8e$var$getCache.get(path) || $75b98c86abc67c8e$var$getCache.set(path, function getter(data) {
            var index = 0, len = parts.length;
            while(index < len){
                if (data != null || !safe) data = data[parts[index++]];
                else return;
            }
            return data;
        });
    },
    join: function(segments) {
        return segments.reduce(function(path, part) {
            return path + ($75b98c86abc67c8e$var$isQuoted(part) || $75b98c86abc67c8e$var$DIGIT_REGEX.test(part) ? '[' + part + ']' : (path ? '.' : '') + part);
        }, '');
    },
    forEach: function(path, cb, thisArg) {
        $75b98c86abc67c8e$var$forEach(Array.isArray(path) ? path : $75b98c86abc67c8e$var$split(path), cb, thisArg);
    }
};
function $75b98c86abc67c8e$var$normalizePath(path) {
    return $75b98c86abc67c8e$var$pathCache.get(path) || $75b98c86abc67c8e$var$pathCache.set(path, $75b98c86abc67c8e$var$split(path).map(function(part) {
        return part.replace($75b98c86abc67c8e$var$CLEAN_QUOTES_REGEX, '$2');
    }));
}
function $75b98c86abc67c8e$var$split(path) {
    return path.match($75b98c86abc67c8e$var$SPLIT_REGEX) || [
        ''
    ];
}
function $75b98c86abc67c8e$var$forEach(parts, iter, thisArg) {
    var len = parts.length, part, idx, isArray, isBracket;
    for(idx = 0; idx < len; idx++){
        part = parts[idx];
        if (part) {
            if ($75b98c86abc67c8e$var$shouldBeQuoted(part)) part = '"' + part + '"';
            isBracket = $75b98c86abc67c8e$var$isQuoted(part);
            isArray = !isBracket && /^\d+$/.test(part);
            iter.call(thisArg, part, isBracket, isArray, idx, parts);
        }
    }
}
function $75b98c86abc67c8e$var$isQuoted(str) {
    return typeof str === 'string' && str && [
        "'",
        '"'
    ].indexOf(str.charAt(0)) !== -1;
}
function $75b98c86abc67c8e$var$hasLeadingNumber(part) {
    return part.match($75b98c86abc67c8e$var$LEAD_DIGIT_REGEX) && !part.match($75b98c86abc67c8e$var$DIGIT_REGEX);
}
function $75b98c86abc67c8e$var$hasSpecialChars(part) {
    return $75b98c86abc67c8e$var$SPEC_CHAR_REGEX.test(part);
}
function $75b98c86abc67c8e$var$shouldBeQuoted(part) {
    return !$75b98c86abc67c8e$var$isQuoted(part) && ($75b98c86abc67c8e$var$hasLeadingNumber(part) || $75b98c86abc67c8e$var$hasSpecialChars(part));
}


var $a214d9c9202f8fd9$exports = {};
const $a214d9c9202f8fd9$var$reWords = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:1ST|2ND|3RD|(?![123])\dTH)(?=\b|[a-z_])|\d*(?:1st|2nd|3rd|(?![123])\dth)(?=\b|[A-Z_])|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g;
const $a214d9c9202f8fd9$var$words = (str)=>str.match($a214d9c9202f8fd9$var$reWords) || [];
const $a214d9c9202f8fd9$var$upperFirst = (str)=>str[0].toUpperCase() + str.slice(1);
const $a214d9c9202f8fd9$var$join = (str, d)=>$a214d9c9202f8fd9$var$words(str).join(d).toLowerCase();
const $a214d9c9202f8fd9$var$camelCase = (str)=>$a214d9c9202f8fd9$var$words(str).reduce((acc, next)=>`${acc}${!acc ? next.toLowerCase() : next[0].toUpperCase() + next.slice(1).toLowerCase()}`, '');
const $a214d9c9202f8fd9$var$pascalCase = (str)=>$a214d9c9202f8fd9$var$upperFirst($a214d9c9202f8fd9$var$camelCase(str));
const $a214d9c9202f8fd9$var$snakeCase = (str)=>$a214d9c9202f8fd9$var$join(str, '_');
const $a214d9c9202f8fd9$var$kebabCase = (str)=>$a214d9c9202f8fd9$var$join(str, '-');
const $a214d9c9202f8fd9$var$sentenceCase = (str)=>$a214d9c9202f8fd9$var$upperFirst($a214d9c9202f8fd9$var$join(str, ' '));
const $a214d9c9202f8fd9$var$titleCase = (str)=>$a214d9c9202f8fd9$var$words(str).map($a214d9c9202f8fd9$var$upperFirst).join(' ');
$a214d9c9202f8fd9$exports = {
    words: $a214d9c9202f8fd9$var$words,
    upperFirst: $a214d9c9202f8fd9$var$upperFirst,
    camelCase: $a214d9c9202f8fd9$var$camelCase,
    pascalCase: $a214d9c9202f8fd9$var$pascalCase,
    snakeCase: $a214d9c9202f8fd9$var$snakeCase,
    kebabCase: $a214d9c9202f8fd9$var$kebabCase,
    sentenceCase: $a214d9c9202f8fd9$var$sentenceCase,
    titleCase: $a214d9c9202f8fd9$var$titleCase
};


var $fc86160b8cf91a0e$exports = {};
/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */ $fc86160b8cf91a0e$exports = function(edges) {
    return $fc86160b8cf91a0e$var$toposort($fc86160b8cf91a0e$var$uniqueNodes(edges), edges);
};
$fc86160b8cf91a0e$exports.array = $fc86160b8cf91a0e$var$toposort;
function $fc86160b8cf91a0e$var$toposort(nodes, edges) {
    var cursor = nodes.length, sorted = new Array(cursor), visited = {}, i = cursor, outgoingEdges = $fc86160b8cf91a0e$var$makeOutgoingEdges(edges), nodesHash = $fc86160b8cf91a0e$var$makeNodesHash(nodes);
    // check for unknown nodes
    edges.forEach(function(edge) {
        if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) throw new Error('Unknown node. There is an unknown node in the supplied edges.');
    });
    while(i--)if (!visited[i]) visit(nodes[i], i, new Set());
    return sorted;
    function visit(node, i, predecessors) {
        if (predecessors.has(node)) {
            var nodeRep;
            try {
                nodeRep = ", node was:" + JSON.stringify(node);
            } catch (e) {
                nodeRep = "";
            }
            throw new Error('Cyclic dependency' + nodeRep);
        }
        if (!nodesHash.has(node)) throw new Error('Found unknown node. Make sure to provided all involved nodes. Unknown node: ' + JSON.stringify(node));
        if (visited[i]) return;
        visited[i] = true;
        var outgoing = outgoingEdges.get(node) || new Set();
        outgoing = Array.from(outgoing);
        if (i = outgoing.length) {
            predecessors.add(node);
            do {
                var child = outgoing[--i];
                visit(child, nodesHash.get(child), predecessors);
            }while (i);
            predecessors.delete(node);
        }
        sorted[--cursor] = node;
    }
}
function $fc86160b8cf91a0e$var$uniqueNodes(arr) {
    var res = new Set();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        res.add(edge[0]);
        res.add(edge[1]);
    }
    return Array.from(res);
}
function $fc86160b8cf91a0e$var$makeOutgoingEdges(arr) {
    var edges = new Map();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        if (!edges.has(edge[0])) edges.set(edge[0], new Set());
        if (!edges.has(edge[1])) edges.set(edge[1], new Set());
        edges.get(edge[0]).add(edge[1]);
    }
    return edges;
}
function $fc86160b8cf91a0e$var$makeNodesHash(arr) {
    var res = new Map();
    for(var i = 0, len = arr.length; i < len; i++)res.set(arr[i], i);
    return res;
}


const $1b19c6085a6e9611$var$toString = Object.prototype.toString;
const $1b19c6085a6e9611$var$errorToString = Error.prototype.toString;
const $1b19c6085a6e9611$var$regExpToString = RegExp.prototype.toString;
const $1b19c6085a6e9611$var$symbolToString = typeof Symbol !== 'undefined' ? Symbol.prototype.toString : ()=>'';
const $1b19c6085a6e9611$var$SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
function $1b19c6085a6e9611$var$printNumber(val) {
    if (val != +val) return 'NaN';
    const isNegativeZero = val === 0 && 1 / val < 0;
    return isNegativeZero ? '-0' : '' + val;
}
function $1b19c6085a6e9611$var$printSimpleValue(val, quoteStrings = false) {
    if (val == null || val === true || val === false) return '' + val;
    const typeOf = typeof val;
    if (typeOf === 'number') return $1b19c6085a6e9611$var$printNumber(val);
    if (typeOf === 'string') return quoteStrings ? `"${val}"` : val;
    if (typeOf === 'function') return '[Function ' + (val.name || 'anonymous') + ']';
    if (typeOf === 'symbol') return $1b19c6085a6e9611$var$symbolToString.call(val).replace($1b19c6085a6e9611$var$SYMBOL_REGEXP, 'Symbol($1)');
    const tag = $1b19c6085a6e9611$var$toString.call(val).slice(8, -1);
    if (tag === 'Date') return isNaN(val.getTime()) ? '' + val : val.toISOString(val);
    if (tag === 'Error' || val instanceof Error) return '[' + $1b19c6085a6e9611$var$errorToString.call(val) + ']';
    if (tag === 'RegExp') return $1b19c6085a6e9611$var$regExpToString.call(val);
    return null;
}
function $1b19c6085a6e9611$export$5790025c6e6c2ba6(value, quoteStrings) {
    let result = $1b19c6085a6e9611$var$printSimpleValue(value, quoteStrings);
    if (result !== null) return result;
    return JSON.stringify(value, function(key, value) {
        let result = $1b19c6085a6e9611$var$printSimpleValue(this[key], quoteStrings);
        if (result !== null) return result;
        return value;
    }, 2);
}
function $1b19c6085a6e9611$var$toArray(value) {
    return value == null ? [] : [].concat(value);
}
let $1b19c6085a6e9611$var$_Symbol$toStringTag, $1b19c6085a6e9611$var$_Symbol$hasInstance, $1b19c6085a6e9611$var$_Symbol$toStringTag2;
let $1b19c6085a6e9611$var$strReg = /\$\{\s*(\w+)\s*\}/g;
$1b19c6085a6e9611$var$_Symbol$toStringTag = Symbol.toStringTag;
class $1b19c6085a6e9611$var$ValidationErrorNoStack {
    constructor(errorOrErrors, value, field, type){
        this.name = void 0;
        this.message = void 0;
        this.value = void 0;
        this.path = void 0;
        this.type = void 0;
        this.params = void 0;
        this.errors = void 0;
        this.inner = void 0;
        this[$1b19c6085a6e9611$var$_Symbol$toStringTag] = 'Error';
        this.name = 'ValidationError';
        this.value = value;
        this.path = field;
        this.type = type;
        this.errors = [];
        this.inner = [];
        $1b19c6085a6e9611$var$toArray(errorOrErrors).forEach((err)=>{
            if ($1b19c6085a6e9611$export$2191b9da168c6cf0.isError(err)) {
                this.errors.push(...err.errors);
                const innerErrors = err.inner.length ? err.inner : [
                    err
                ];
                this.inner.push(...innerErrors);
            } else this.errors.push(err);
        });
        this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
    }
}
$1b19c6085a6e9611$var$_Symbol$hasInstance = Symbol.hasInstance;
$1b19c6085a6e9611$var$_Symbol$toStringTag2 = Symbol.toStringTag;
class $1b19c6085a6e9611$export$2191b9da168c6cf0 extends Error {
    static formatError(message, params) {
        // Attempt to make the path more friendly for error message interpolation.
        const path = params.label || params.path || 'this';
        // Store the original path under `originalPath` so it isn't lost to custom
        // message functions; e.g., ones provided in `setLocale()` calls.
        params = Object.assign({}, params, {
            path: path,
            originalPath: params.path
        });
        if (typeof message === 'string') return message.replace($1b19c6085a6e9611$var$strReg, (_, key)=>$1b19c6085a6e9611$export$5790025c6e6c2ba6(params[key]));
        if (typeof message === 'function') return message(params);
        return message;
    }
    static isError(err) {
        return err && err.name === 'ValidationError';
    }
    constructor(errorOrErrors, value, field, type, disableStack){
        const errorNoStack = new $1b19c6085a6e9611$var$ValidationErrorNoStack(errorOrErrors, value, field, type);
        if (disableStack) return errorNoStack;
        super();
        this.value = void 0;
        this.path = void 0;
        this.type = void 0;
        this.params = void 0;
        this.errors = [];
        this.inner = [];
        this[$1b19c6085a6e9611$var$_Symbol$toStringTag2] = 'Error';
        this.name = errorNoStack.name;
        this.message = errorNoStack.message;
        this.type = errorNoStack.type;
        this.value = errorNoStack.value;
        this.path = errorNoStack.path;
        this.errors = errorNoStack.errors;
        this.inner = errorNoStack.inner;
        if (Error.captureStackTrace) Error.captureStackTrace(this, $1b19c6085a6e9611$export$2191b9da168c6cf0);
    }
    static [$1b19c6085a6e9611$var$_Symbol$hasInstance](inst) {
        return $1b19c6085a6e9611$var$ValidationErrorNoStack[Symbol.hasInstance](inst) || super[Symbol.hasInstance](inst);
    }
}
let $1b19c6085a6e9611$var$mixed = {
    default: '${path} is invalid',
    required: '${path} is a required field',
    defined: '${path} must be defined',
    notNull: '${path} cannot be null',
    oneOf: '${path} must be one of the following values: ${values}',
    notOneOf: '${path} must not be one of the following values: ${values}',
    notType: ({ path: path, type: type, value: value, originalValue: originalValue })=>{
        const castMsg = originalValue != null && originalValue !== value ? ` (cast from the value \`${$1b19c6085a6e9611$export$5790025c6e6c2ba6(originalValue, true)}\`).` : '.';
        return type !== 'mixed' ? `${path} must be a \`${type}\` type, ` + `but the final value was: \`${$1b19c6085a6e9611$export$5790025c6e6c2ba6(value, true)}\`` + castMsg : `${path} must match the configured type. ` + `The validated value was: \`${$1b19c6085a6e9611$export$5790025c6e6c2ba6(value, true)}\`` + castMsg;
    }
};
let $1b19c6085a6e9611$var$string = {
    length: '${path} must be exactly ${length} characters',
    min: '${path} must be at least ${min} characters',
    max: '${path} must be at most ${max} characters',
    matches: '${path} must match the following: "${regex}"',
    email: '${path} must be a valid email',
    url: '${path} must be a valid URL',
    uuid: '${path} must be a valid UUID',
    datetime: '${path} must be a valid ISO date-time',
    datetime_precision: '${path} must be a valid ISO date-time with a sub-second precision of exactly ${precision} digits',
    datetime_offset: '${path} must be a valid ISO date-time with UTC "Z" timezone',
    trim: '${path} must be a trimmed string',
    lowercase: '${path} must be a lowercase string',
    uppercase: '${path} must be a upper case string'
};
let $1b19c6085a6e9611$var$number = {
    min: '${path} must be greater than or equal to ${min}',
    max: '${path} must be less than or equal to ${max}',
    lessThan: '${path} must be less than ${less}',
    moreThan: '${path} must be greater than ${more}',
    positive: '${path} must be a positive number',
    negative: '${path} must be a negative number',
    integer: '${path} must be an integer'
};
let $1b19c6085a6e9611$var$date = {
    min: '${path} field must be later than ${min}',
    max: '${path} field must be at earlier than ${max}'
};
let $1b19c6085a6e9611$var$boolean = {
    isValue: '${path} field must be ${value}'
};
let $1b19c6085a6e9611$var$object = {
    noUnknown: '${path} field has unspecified keys: ${unknown}',
    exact: '${path} object contains unknown properties: ${properties}'
};
let $1b19c6085a6e9611$var$array = {
    min: '${path} field must have at least ${min} items',
    max: '${path} field must have less than or equal to ${max} items',
    length: '${path} must have ${length} items'
};
let $1b19c6085a6e9611$var$tuple = {
    notType: (params)=>{
        const { path: path, value: value, spec: spec } = params;
        const typeLen = spec.types.length;
        if (Array.isArray(value)) {
            if (value.length < typeLen) return `${path} tuple value has too few items, expected a length of ${typeLen} but got ${value.length} for value: \`${$1b19c6085a6e9611$export$5790025c6e6c2ba6(value, true)}\``;
            if (value.length > typeLen) return `${path} tuple value has too many items, expected a length of ${typeLen} but got ${value.length} for value: \`${$1b19c6085a6e9611$export$5790025c6e6c2ba6(value, true)}\``;
        }
        return $1b19c6085a6e9611$export$2191b9da168c6cf0.formatError($1b19c6085a6e9611$var$mixed.notType, params);
    }
};
var $1b19c6085a6e9611$export$d7f512c98c859244 = Object.assign(Object.create(null), {
    mixed: $1b19c6085a6e9611$var$mixed,
    string: $1b19c6085a6e9611$var$string,
    number: $1b19c6085a6e9611$var$number,
    date: $1b19c6085a6e9611$var$date,
    object: $1b19c6085a6e9611$var$object,
    array: $1b19c6085a6e9611$var$array,
    boolean: $1b19c6085a6e9611$var$boolean,
    tuple: $1b19c6085a6e9611$var$tuple
});
const $1b19c6085a6e9611$export$213e2a3e7c4f326e = (obj)=>obj && obj.__isYupSchema__;
class $1b19c6085a6e9611$var$Condition {
    static fromOptions(refs, config) {
        if (!config.then && !config.otherwise) throw new TypeError('either `then:` or `otherwise:` is required for `when()` conditions');
        let { is: is, then: then, otherwise: otherwise } = config;
        let check = typeof is === 'function' ? is : (...values)=>values.every((value)=>value === is);
        return new $1b19c6085a6e9611$var$Condition(refs, (values, schema)=>{
            var _branch;
            let branch = check(...values) ? then : otherwise;
            return (_branch = branch == null ? void 0 : branch(schema)) != null ? _branch : schema;
        });
    }
    constructor(refs, builder){
        this.fn = void 0;
        this.refs = refs;
        this.refs = refs;
        this.fn = builder;
    }
    resolve(base, options) {
        let values = this.refs.map((ref)=>// TODO: ? operator here?
            ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context));
        let schema = this.fn(values, base, options);
        if (schema === undefined || // @ts-ignore this can be base
        schema === base) return base;
        if (!$1b19c6085a6e9611$export$213e2a3e7c4f326e(schema)) throw new TypeError('conditions must return a schema object');
        return schema.resolve(options);
    }
}
const $1b19c6085a6e9611$var$prefixes = {
    context: '$',
    value: '.'
};
function $1b19c6085a6e9611$export$eff4d24c3ff7876e(key, options) {
    return new $1b19c6085a6e9611$var$Reference(key, options);
}
class $1b19c6085a6e9611$var$Reference {
    constructor(key, options = {}){
        this.key = void 0;
        this.isContext = void 0;
        this.isValue = void 0;
        this.isSibling = void 0;
        this.path = void 0;
        this.getter = void 0;
        this.map = void 0;
        if (typeof key !== 'string') throw new TypeError('ref must be a string, got: ' + key);
        this.key = key.trim();
        if (key === '') throw new TypeError('ref must be a non-empty string');
        this.isContext = this.key[0] === $1b19c6085a6e9611$var$prefixes.context;
        this.isValue = this.key[0] === $1b19c6085a6e9611$var$prefixes.value;
        this.isSibling = !this.isContext && !this.isValue;
        let prefix = this.isContext ? $1b19c6085a6e9611$var$prefixes.context : this.isValue ? $1b19c6085a6e9611$var$prefixes.value : '';
        this.path = this.key.slice(prefix.length);
        this.getter = this.path && (0, $75b98c86abc67c8e$exports.getter)(this.path, true);
        this.map = options.map;
    }
    getValue(value, parent, context) {
        let result = this.isContext ? context : this.isValue ? value : parent;
        if (this.getter) result = this.getter(result || {});
        if (this.map) result = this.map(result);
        return result;
    }
    /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */ cast(value, options) {
        return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
    }
    resolve() {
        return this;
    }
    describe() {
        return {
            type: 'ref',
            key: this.key
        };
    }
    toString() {
        return `Ref(${this.key})`;
    }
    static isRef(value) {
        return value && value.__isYupRef;
    }
}
// @ts-ignore
$1b19c6085a6e9611$var$Reference.prototype.__isYupRef = true;
const $1b19c6085a6e9611$var$isAbsent = (value)=>value == null;
function $1b19c6085a6e9611$var$createValidation(config) {
    function validate({ value: value, path: path = '', options: options, originalValue: originalValue, schema: schema }, panic, next) {
        const { name: name, test: test, params: params, message: message, skipAbsent: skipAbsent } = config;
        let { parent: parent, context: context, abortEarly: abortEarly = schema.spec.abortEarly, disableStackTrace: disableStackTrace = schema.spec.disableStackTrace } = options;
        const resolveOptions = {
            value: value,
            parent: parent,
            context: context
        };
        function createError(overrides = {}) {
            const nextParams = $1b19c6085a6e9611$var$resolveParams(Object.assign({
                value: value,
                originalValue: originalValue,
                label: schema.spec.label,
                path: overrides.path || path,
                spec: schema.spec,
                disableStackTrace: overrides.disableStackTrace || disableStackTrace
            }, params, overrides.params), resolveOptions);
            const error = new $1b19c6085a6e9611$export$2191b9da168c6cf0($1b19c6085a6e9611$export$2191b9da168c6cf0.formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name, nextParams.disableStackTrace);
            error.params = nextParams;
            return error;
        }
        const invalid = abortEarly ? panic : next;
        let ctx = {
            path: path,
            parent: parent,
            type: name,
            from: options.from,
            createError: createError,
            resolve (item) {
                return $1b19c6085a6e9611$var$resolveMaybeRef(item, resolveOptions);
            },
            options: options,
            originalValue: originalValue,
            schema: schema
        };
        const handleResult = (validOrError)=>{
            if ($1b19c6085a6e9611$export$2191b9da168c6cf0.isError(validOrError)) invalid(validOrError);
            else if (!validOrError) invalid(createError());
            else next(null);
        };
        const handleError = (err)=>{
            if ($1b19c6085a6e9611$export$2191b9da168c6cf0.isError(err)) invalid(err);
            else panic(err);
        };
        const shouldSkip = skipAbsent && $1b19c6085a6e9611$var$isAbsent(value);
        if (shouldSkip) return handleResult(true);
        let result;
        try {
            var _result;
            result = test.call(ctx, value, ctx);
            if (typeof ((_result = result) == null ? void 0 : _result.then) === 'function') {
                if (options.sync) throw new Error(`Validation test of type: "${ctx.type}" returned a Promise during a synchronous validate. ` + `This test will finish after the validate call has returned`);
                return Promise.resolve(result).then(handleResult, handleError);
            }
        } catch (err) {
            handleError(err);
            return;
        }
        handleResult(result);
    }
    validate.OPTIONS = config;
    return validate;
}
// Warning: mutates the input
function $1b19c6085a6e9611$var$resolveParams(params, options) {
    if (!params) return params;
    for (const key of Object.keys(params))params[key] = $1b19c6085a6e9611$var$resolveMaybeRef(params[key], options);
    return params;
}
function $1b19c6085a6e9611$var$resolveMaybeRef(item, options) {
    return $1b19c6085a6e9611$var$Reference.isRef(item) ? item.getValue(options.value, options.parent, options.context) : item;
}
function $1b19c6085a6e9611$export$c52e5867d5879e24(schema, path, value, context = value) {
    let parent, lastPart, lastPartDebug;
    // root path: ''
    if (!path) return {
        parent: parent,
        parentPath: path,
        schema: schema
    };
    (0, $75b98c86abc67c8e$exports.forEach)(path, (_part, isBracket, isArray)=>{
        let part = isBracket ? _part.slice(1, _part.length - 1) : _part;
        schema = schema.resolve({
            context: context,
            parent: parent,
            value: value
        });
        let isTuple = schema.type === 'tuple';
        let idx = isArray ? parseInt(part, 10) : 0;
        if (schema.innerType || isTuple) {
            if (isTuple && !isArray) throw new Error(`Yup.reach cannot implicitly index into a tuple type. the path part "${lastPartDebug}" must contain an index to the tuple element, e.g. "${lastPartDebug}[0]"`);
            if (value && idx >= value.length) throw new Error(`Yup.reach cannot resolve an array item at index: ${_part}, in the path: ${path}. ` + `because there is no value at that index. `);
            parent = value;
            value = value && value[idx];
            schema = isTuple ? schema.spec.types[idx] : schema.innerType;
        }
        // sometimes the array index part of a path doesn't exist: "nested.arr.child"
        // in these cases the current part is the next schema and should be processed
        // in this iteration. For cases where the index signature is included this
        // check will fail and we'll handle the `child` part on the next iteration like normal
        if (!isArray) {
            if (!schema.fields || !schema.fields[part]) throw new Error(`The schema does not contain the path: ${path}. ` + `(failed at: ${lastPartDebug} which is a type: "${schema.type}")`);
            parent = value;
            value = value && value[part];
            schema = schema.fields[part];
        }
        lastPart = part;
        lastPartDebug = isBracket ? '[' + _part + ']' : '.' + _part;
    });
    return {
        schema: schema,
        parent: parent,
        parentPath: lastPart
    };
}
function $1b19c6085a6e9611$export$cfedb76369cc7782(obj, path, value, context) {
    return $1b19c6085a6e9611$export$c52e5867d5879e24(obj, path, value, context).schema;
}
class $1b19c6085a6e9611$var$ReferenceSet extends Set {
    describe() {
        const description = [];
        for (const item of this.values())description.push($1b19c6085a6e9611$var$Reference.isRef(item) ? item.describe() : item);
        return description;
    }
    resolveAll(resolve) {
        let result = [];
        for (const item of this.values())result.push(resolve(item));
        return result;
    }
    clone() {
        return new $1b19c6085a6e9611$var$ReferenceSet(this.values());
    }
    merge(newItems, removeItems) {
        const next = this.clone();
        newItems.forEach((value)=>next.add(value));
        removeItems.forEach((value)=>next.delete(value));
        return next;
    }
}
// tweaked from https://github.com/Kelin2025/nanoclone/blob/0abeb7635bda9b68ef2277093f76dbe3bf3948e1/src/index.js
function $1b19c6085a6e9611$var$clone(src, seen = new Map()) {
    if ($1b19c6085a6e9611$export$213e2a3e7c4f326e(src) || !src || typeof src !== 'object') return src;
    if (seen.has(src)) return seen.get(src);
    let copy;
    if (src instanceof Date) {
        // Date
        copy = new Date(src.getTime());
        seen.set(src, copy);
    } else if (src instanceof RegExp) {
        // RegExp
        copy = new RegExp(src);
        seen.set(src, copy);
    } else if (Array.isArray(src)) {
        // Array
        copy = new Array(src.length);
        seen.set(src, copy);
        for(let i = 0; i < src.length; i++)copy[i] = $1b19c6085a6e9611$var$clone(src[i], seen);
    } else if (src instanceof Map) {
        // Map
        copy = new Map();
        seen.set(src, copy);
        for (const [k, v] of src.entries())copy.set(k, $1b19c6085a6e9611$var$clone(v, seen));
    } else if (src instanceof Set) {
        // Set
        copy = new Set();
        seen.set(src, copy);
        for (const v of src)copy.add($1b19c6085a6e9611$var$clone(v, seen));
    } else if (src instanceof Object) {
        // Object
        copy = {};
        seen.set(src, copy);
        for (const [k, v] of Object.entries(src))copy[k] = $1b19c6085a6e9611$var$clone(v, seen);
    } else throw Error(`Unable to clone ${src}`);
    return copy;
}
/**
 * Copied from @standard-schema/spec to avoid having a dependency on it.
 * https://github.com/standard-schema/standard-schema/blob/main/packages/spec/src/index.ts
 */ function $1b19c6085a6e9611$var$createStandardPath(path) {
    if (!(path != null && path.length)) return undefined;
    // Array to store the final path segments
    const segments = [];
    // Buffer for building the current segment
    let currentSegment = '';
    // Track if we're inside square brackets (array/property access)
    let inBrackets = false;
    // Track if we're inside quotes (for property names with special chars)
    let inQuotes = false;
    for(let i = 0; i < path.length; i++){
        const char = path[i];
        if (char === '[' && !inQuotes) {
            // When entering brackets, push any accumulated segment after splitting on dots
            if (currentSegment) {
                segments.push(...currentSegment.split('.').filter(Boolean));
                currentSegment = '';
            }
            inBrackets = true;
            continue;
        }
        if (char === ']' && !inQuotes) {
            if (currentSegment) {
                // Handle numeric indices (e.g. arr[0])
                if (/^\d+$/.test(currentSegment)) segments.push(currentSegment);
                else // Handle quoted property names (e.g. obj["foo.bar"])
                segments.push(currentSegment.replace(/^"|"$/g, ''));
                currentSegment = '';
            }
            inBrackets = false;
            continue;
        }
        if (char === '"') {
            // Toggle quote state for handling quoted property names
            inQuotes = !inQuotes;
            continue;
        }
        if (char === '.' && !inBrackets && !inQuotes) {
            // On dots outside brackets/quotes, push current segment
            if (currentSegment) {
                segments.push(currentSegment);
                currentSegment = '';
            }
            continue;
        }
        currentSegment += char;
    }
    // Push any remaining segment after splitting on dots
    if (currentSegment) segments.push(...currentSegment.split('.').filter(Boolean));
    return segments;
}
function $1b19c6085a6e9611$var$createStandardIssues(error, parentPath) {
    const path = parentPath ? `${parentPath}.${error.path}` : error.path;
    return error.errors.map((err)=>({
            message: err,
            path: $1b19c6085a6e9611$var$createStandardPath(path)
        }));
}
function $1b19c6085a6e9611$var$issuesFromValidationError(error, parentPath) {
    var _error$inner;
    if (!((_error$inner = error.inner) != null && _error$inner.length) && error.errors.length) return $1b19c6085a6e9611$var$createStandardIssues(error, parentPath);
    const path = parentPath ? `${parentPath}.${error.path}` : error.path;
    return error.inner.flatMap((err)=>$1b19c6085a6e9611$var$issuesFromValidationError(err, path));
}
// If `CustomSchemaMeta` isn't extended with any keys, we'll fall back to a
// loose Record definition allowing free form usage.
class $1b19c6085a6e9611$export$19342e026b58ebb7 {
    constructor(options){
        this.type = void 0;
        this.deps = [];
        this.tests = void 0;
        this.transforms = void 0;
        this.conditions = [];
        this._mutate = void 0;
        this.internalTests = {};
        this._whitelist = new $1b19c6085a6e9611$var$ReferenceSet();
        this._blacklist = new $1b19c6085a6e9611$var$ReferenceSet();
        this.exclusiveTests = Object.create(null);
        this._typeCheck = void 0;
        this.spec = void 0;
        this.tests = [];
        this.transforms = [];
        this.withMutation(()=>{
            this.typeError($1b19c6085a6e9611$var$mixed.notType);
        });
        this.type = options.type;
        this._typeCheck = options.check;
        this.spec = Object.assign({
            strip: false,
            strict: false,
            abortEarly: true,
            recursive: true,
            disableStackTrace: false,
            nullable: false,
            optional: true,
            coerce: true
        }, options == null ? void 0 : options.spec);
        this.withMutation((s)=>{
            s.nonNullable();
        });
    }
    // TODO: remove
    get _type() {
        return this.type;
    }
    clone(spec) {
        if (this._mutate) {
            if (spec) Object.assign(this.spec, spec);
            return this;
        }
        // if the nested value is a schema we can skip cloning, since
        // they are already immutable
        const next = Object.create(Object.getPrototypeOf(this));
        // @ts-expect-error this is readonly
        next.type = this.type;
        next._typeCheck = this._typeCheck;
        next._whitelist = this._whitelist.clone();
        next._blacklist = this._blacklist.clone();
        next.internalTests = Object.assign({}, this.internalTests);
        next.exclusiveTests = Object.assign({}, this.exclusiveTests);
        // @ts-expect-error this is readonly
        next.deps = [
            ...this.deps
        ];
        next.conditions = [
            ...this.conditions
        ];
        next.tests = [
            ...this.tests
        ];
        next.transforms = [
            ...this.transforms
        ];
        next.spec = $1b19c6085a6e9611$var$clone(Object.assign({}, this.spec, spec));
        return next;
    }
    label(label) {
        let next = this.clone();
        next.spec.label = label;
        return next;
    }
    meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
    }
    withMutation(fn) {
        let before = this._mutate;
        this._mutate = true;
        let result = fn(this);
        this._mutate = before;
        return result;
    }
    concat(schema) {
        if (!schema || schema === this) return this;
        if (schema.type !== this.type && this.type !== 'mixed') throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema.type}`);
        let base = this;
        let combined = schema.clone();
        const mergedSpec = Object.assign({}, base.spec, combined.spec);
        combined.spec = mergedSpec;
        combined.internalTests = Object.assign({}, base.internalTests, combined.internalTests);
        // manually merge the blacklist/whitelist (the other `schema` takes
        // precedence in case of conflicts)
        combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
        combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist);
        // start with the current tests
        combined.tests = base.tests;
        combined.exclusiveTests = base.exclusiveTests;
        // manually add the new tests to ensure
        // the deduping logic is consistent
        combined.withMutation((next)=>{
            schema.tests.forEach((fn)=>{
                next.test(fn.OPTIONS);
            });
        });
        combined.transforms = [
            ...base.transforms,
            ...combined.transforms
        ];
        return combined;
    }
    isType(v) {
        if (v == null) {
            if (this.spec.nullable && v === null) return true;
            if (this.spec.optional && v === undefined) return true;
            return false;
        }
        return this._typeCheck(v);
    }
    resolve(options) {
        let schema = this;
        if (schema.conditions.length) {
            let conditions = schema.conditions;
            schema = schema.clone();
            schema.conditions = [];
            schema = conditions.reduce((prevSchema, condition)=>condition.resolve(prevSchema, options), schema);
            schema = schema.resolve(options);
        }
        return schema;
    }
    resolveOptions(options) {
        var _options$strict, _options$abortEarly, _options$recursive, _options$disableStack;
        return Object.assign({}, options, {
            from: options.from || [],
            strict: (_options$strict = options.strict) != null ? _options$strict : this.spec.strict,
            abortEarly: (_options$abortEarly = options.abortEarly) != null ? _options$abortEarly : this.spec.abortEarly,
            recursive: (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive,
            disableStackTrace: (_options$disableStack = options.disableStackTrace) != null ? _options$disableStack : this.spec.disableStackTrace
        });
    }
    /**
   * Run the configured transform pipeline over an input value.
   */ cast(value, options = {}) {
        let resolvedSchema = this.resolve(Object.assign({}, options, {
            value: value
        }));
        let allowOptionality = options.assert === 'ignore-optionality';
        let result = resolvedSchema._cast(value, options);
        if (options.assert !== false && !resolvedSchema.isType(result)) {
            if (allowOptionality && $1b19c6085a6e9611$var$isAbsent(result)) return result;
            let formattedValue = $1b19c6085a6e9611$export$5790025c6e6c2ba6(value);
            let formattedResult = $1b19c6085a6e9611$export$5790025c6e6c2ba6(result);
            throw new TypeError(`The value of ${options.path || 'field'} could not be cast to a value ` + `that satisfies the schema type: "${resolvedSchema.type}". \n\n` + `attempted value: ${formattedValue} \n` + (formattedResult !== formattedValue ? `result of cast: ${formattedResult}` : ''));
        }
        return result;
    }
    _cast(rawValue, options) {
        let value = rawValue === undefined ? rawValue : this.transforms.reduce((prevValue, fn)=>fn.call(this, prevValue, rawValue, this, options), rawValue);
        if (value === undefined) value = this.getDefault(options);
        return value;
    }
    _validate(_value, options = {}, panic, next) {
        let { path: path, originalValue: originalValue = _value, strict: strict = this.spec.strict } = options;
        let value = _value;
        if (!strict) value = this._cast(value, Object.assign({
            assert: false
        }, options));
        let initialTests = [];
        for (let test of Object.values(this.internalTests))if (test) initialTests.push(test);
        this.runTests({
            path: path,
            value: value,
            originalValue: originalValue,
            options: options,
            tests: initialTests
        }, panic, (initialErrors)=>{
            // even if we aren't ending early we can't proceed further if the types aren't correct
            if (initialErrors.length) return next(initialErrors, value);
            this.runTests({
                path: path,
                value: value,
                originalValue: originalValue,
                options: options,
                tests: this.tests
            }, panic, next);
        });
    }
    /**
   * Executes a set of validations, either schema, produced Tests or a nested
   * schema validate result.
   */ runTests(runOptions, panic, next) {
        let fired = false;
        let { tests: tests, value: value, originalValue: originalValue, path: path, options: options } = runOptions;
        let panicOnce = (arg)=>{
            if (fired) return;
            fired = true;
            panic(arg, value);
        };
        let nextOnce = (arg)=>{
            if (fired) return;
            fired = true;
            next(arg, value);
        };
        let count = tests.length;
        let nestedErrors = [];
        if (!count) return nextOnce([]);
        let args = {
            value: value,
            originalValue: originalValue,
            path: path,
            options: options,
            schema: this
        };
        for(let i = 0; i < tests.length; i++){
            const test = tests[i];
            test(args, panicOnce, function finishTestRun(err) {
                if (err) Array.isArray(err) ? nestedErrors.push(...err) : nestedErrors.push(err);
                if (--count <= 0) nextOnce(nestedErrors);
            });
        }
    }
    asNestedTest({ key: key, index: index, parent: parent, parentPath: parentPath, originalParent: originalParent, options: options }) {
        const k = key != null ? key : index;
        if (k == null) throw TypeError('Must include `key` or `index` for nested validations');
        const isIndex = typeof k === 'number';
        let value = parent[k];
        const testOptions = Object.assign({}, options, {
            // Nested validations fields are always strict:
            //    1. parent isn't strict so the casting will also have cast inner values
            //    2. parent is strict in which case the nested values weren't cast either
            strict: true,
            parent: parent,
            value: value,
            originalValue: originalParent[k],
            // FIXME: tests depend on `index` being passed around deeply,
            //   we should not let the options.key/index bleed through
            key: undefined,
            // index: undefined,
            [isIndex ? 'index' : 'key']: k,
            path: isIndex || k.includes('.') ? `${parentPath || ''}[${isIndex ? k : `"${k}"`}]` : (parentPath ? `${parentPath}.` : '') + key
        });
        return (_, panic, next)=>this.resolve(testOptions)._validate(value, testOptions, panic, next);
    }
    validate(value, options) {
        var _options$disableStack2;
        let schema = this.resolve(Object.assign({}, options, {
            value: value
        }));
        let disableStackTrace = (_options$disableStack2 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack2 : schema.spec.disableStackTrace;
        return new Promise((resolve, reject)=>schema._validate(value, options, (error, parsed)=>{
                if ($1b19c6085a6e9611$export$2191b9da168c6cf0.isError(error)) error.value = parsed;
                reject(error);
            }, (errors, validated)=>{
                if (errors.length) reject(new $1b19c6085a6e9611$export$2191b9da168c6cf0(errors, validated, undefined, undefined, disableStackTrace));
                else resolve(validated);
            }));
    }
    validateSync(value, options) {
        var _options$disableStack3;
        let schema = this.resolve(Object.assign({}, options, {
            value: value
        }));
        let result;
        let disableStackTrace = (_options$disableStack3 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack3 : schema.spec.disableStackTrace;
        schema._validate(value, Object.assign({}, options, {
            sync: true
        }), (error, parsed)=>{
            if ($1b19c6085a6e9611$export$2191b9da168c6cf0.isError(error)) error.value = parsed;
            throw error;
        }, (errors, validated)=>{
            if (errors.length) throw new $1b19c6085a6e9611$export$2191b9da168c6cf0(errors, value, undefined, undefined, disableStackTrace);
            result = validated;
        });
        return result;
    }
    isValid(value, options) {
        return this.validate(value, options).then(()=>true, (err)=>{
            if ($1b19c6085a6e9611$export$2191b9da168c6cf0.isError(err)) return false;
            throw err;
        });
    }
    isValidSync(value, options) {
        try {
            this.validateSync(value, options);
            return true;
        } catch (err) {
            if ($1b19c6085a6e9611$export$2191b9da168c6cf0.isError(err)) return false;
            throw err;
        }
    }
    _getDefault(options) {
        let defaultValue = this.spec.default;
        if (defaultValue == null) return defaultValue;
        return typeof defaultValue === 'function' ? defaultValue.call(this, options) : $1b19c6085a6e9611$var$clone(defaultValue);
    }
    getDefault(options) {
        let schema = this.resolve(options || {});
        return schema._getDefault(options);
    }
    default(def) {
        if (arguments.length === 0) return this._getDefault();
        let next = this.clone({
            default: def
        });
        return next;
    }
    strict(isStrict = true) {
        return this.clone({
            strict: isStrict
        });
    }
    nullability(nullable, message) {
        const next = this.clone({
            nullable: nullable
        });
        next.internalTests.nullable = $1b19c6085a6e9611$var$createValidation({
            message: message,
            name: 'nullable',
            test (value) {
                return value === null ? this.schema.spec.nullable : true;
            }
        });
        return next;
    }
    optionality(optional, message) {
        const next = this.clone({
            optional: optional
        });
        next.internalTests.optionality = $1b19c6085a6e9611$var$createValidation({
            message: message,
            name: 'optionality',
            test (value) {
                return value === undefined ? this.schema.spec.optional : true;
            }
        });
        return next;
    }
    optional() {
        return this.optionality(true);
    }
    defined(message = $1b19c6085a6e9611$var$mixed.defined) {
        return this.optionality(false, message);
    }
    nullable() {
        return this.nullability(true);
    }
    nonNullable(message = $1b19c6085a6e9611$var$mixed.notNull) {
        return this.nullability(false, message);
    }
    required(message = $1b19c6085a6e9611$var$mixed.required) {
        return this.clone().withMutation((next)=>next.nonNullable(message).defined(message));
    }
    notRequired() {
        return this.clone().withMutation((next)=>next.nullable().optional());
    }
    transform(fn) {
        let next = this.clone();
        next.transforms.push(fn);
        return next;
    }
    /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */ test(...args) {
        let opts;
        if (args.length === 1) {
            if (typeof args[0] === 'function') opts = {
                test: args[0]
            };
            else opts = args[0];
        } else if (args.length === 2) opts = {
            name: args[0],
            test: args[1]
        };
        else opts = {
            name: args[0],
            message: args[1],
            test: args[2]
        };
        if (opts.message === undefined) opts.message = $1b19c6085a6e9611$var$mixed.default;
        if (typeof opts.test !== 'function') throw new TypeError('`test` is a required parameters');
        let next = this.clone();
        let validate = $1b19c6085a6e9611$var$createValidation(opts);
        let isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;
        if (opts.exclusive) {
            if (!opts.name) throw new TypeError('Exclusive tests must provide a unique `name` identifying the test');
        }
        if (opts.name) next.exclusiveTests[opts.name] = !!opts.exclusive;
        next.tests = next.tests.filter((fn)=>{
            if (fn.OPTIONS.name === opts.name) {
                if (isExclusive) return false;
                if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
            }
            return true;
        });
        next.tests.push(validate);
        return next;
    }
    when(keys, options) {
        if (!Array.isArray(keys) && typeof keys !== 'string') {
            options = keys;
            keys = '.';
        }
        let next = this.clone();
        let deps = $1b19c6085a6e9611$var$toArray(keys).map((key)=>new $1b19c6085a6e9611$var$Reference(key));
        deps.forEach((dep)=>{
            // @ts-ignore readonly array
            if (dep.isSibling) next.deps.push(dep.key);
        });
        next.conditions.push(typeof options === 'function' ? new $1b19c6085a6e9611$var$Condition(deps, options) : $1b19c6085a6e9611$var$Condition.fromOptions(deps, options));
        return next;
    }
    typeError(message) {
        let next = this.clone();
        next.internalTests.typeError = $1b19c6085a6e9611$var$createValidation({
            message: message,
            name: 'typeError',
            skipAbsent: true,
            test (value) {
                if (!this.schema._typeCheck(value)) return this.createError({
                    params: {
                        type: this.schema.type
                    }
                });
                return true;
            }
        });
        return next;
    }
    oneOf(enums, message = $1b19c6085a6e9611$var$mixed.oneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._whitelist.add(val);
            next._blacklist.delete(val);
        });
        next.internalTests.whiteList = $1b19c6085a6e9611$var$createValidation({
            message: message,
            name: 'oneOf',
            skipAbsent: true,
            test (value) {
                let valids = this.schema._whitelist;
                let resolved = valids.resolveAll(this.resolve);
                return resolved.includes(value) ? true : this.createError({
                    params: {
                        values: Array.from(valids).join(', '),
                        resolved: resolved
                    }
                });
            }
        });
        return next;
    }
    notOneOf(enums, message = $1b19c6085a6e9611$var$mixed.notOneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._blacklist.add(val);
            next._whitelist.delete(val);
        });
        next.internalTests.blacklist = $1b19c6085a6e9611$var$createValidation({
            message: message,
            name: 'notOneOf',
            test (value) {
                let invalids = this.schema._blacklist;
                let resolved = invalids.resolveAll(this.resolve);
                if (resolved.includes(value)) return this.createError({
                    params: {
                        values: Array.from(invalids).join(', '),
                        resolved: resolved
                    }
                });
                return true;
            }
        });
        return next;
    }
    strip(strip = true) {
        let next = this.clone();
        next.spec.strip = strip;
        return next;
    }
    /**
   * Return a serialized description of the schema including validations, flags, types etc.
   *
   * @param options Provide any needed context for resolving runtime schema alterations (lazy, when conditions, etc).
   */ describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const { label: label, meta: meta, optional: optional, nullable: nullable } = next.spec;
        const description = {
            meta: meta,
            label: label,
            optional: optional,
            nullable: nullable,
            default: next.getDefault(options),
            type: next.type,
            oneOf: next._whitelist.describe(),
            notOneOf: next._blacklist.describe(),
            tests: next.tests.filter((n, idx, list)=>list.findIndex((c)=>c.OPTIONS.name === n.OPTIONS.name) === idx).map((fn)=>{
                const params = fn.OPTIONS.params && options ? $1b19c6085a6e9611$var$resolveParams(Object.assign({}, fn.OPTIONS.params), options) : fn.OPTIONS.params;
                return {
                    name: fn.OPTIONS.name,
                    params: params
                };
            })
        };
        return description;
    }
    get ['~standard']() {
        const schema = this;
        const standard = {
            version: 1,
            vendor: 'yup',
            async validate (value) {
                try {
                    const result = await schema.validate(value, {
                        abortEarly: false
                    });
                    return {
                        value: result
                    };
                } catch (err) {
                    if (err instanceof $1b19c6085a6e9611$export$2191b9da168c6cf0) return {
                        issues: $1b19c6085a6e9611$var$issuesFromValidationError(err)
                    };
                    throw err;
                }
            }
        };
        return standard;
    }
}
// @ts-expect-error
$1b19c6085a6e9611$export$19342e026b58ebb7.prototype.__isYupSchema__ = true;
for (const method of [
    'validate',
    'validateSync'
])$1b19c6085a6e9611$export$19342e026b58ebb7.prototype[`${method}At`] = function(path, value, options = {}) {
    const { parent: parent, parentPath: parentPath, schema: schema } = $1b19c6085a6e9611$export$c52e5867d5879e24(this, path, value, options.context);
    return schema[method](parent && parent[parentPath], Object.assign({}, options, {
        parent: parent,
        path: path
    }));
};
for (const alias of [
    'equals',
    'is'
])$1b19c6085a6e9611$export$19342e026b58ebb7.prototype[alias] = $1b19c6085a6e9611$export$19342e026b58ebb7.prototype.oneOf;
for (const alias of [
    'not',
    'nope'
])$1b19c6085a6e9611$export$19342e026b58ebb7.prototype[alias] = $1b19c6085a6e9611$export$19342e026b58ebb7.prototype.notOneOf;
const $1b19c6085a6e9611$var$returnsTrue = ()=>true;
function $1b19c6085a6e9611$export$9b30b6294c1449a8(spec) {
    return new $1b19c6085a6e9611$export$1e88358c94ddec71(spec);
}
class $1b19c6085a6e9611$export$1e88358c94ddec71 extends $1b19c6085a6e9611$export$19342e026b58ebb7 {
    constructor(spec){
        super(typeof spec === 'function' ? {
            type: 'mixed',
            check: spec
        } : Object.assign({
            type: 'mixed',
            check: $1b19c6085a6e9611$var$returnsTrue
        }, spec));
    }
}
$1b19c6085a6e9611$export$9b30b6294c1449a8.prototype = $1b19c6085a6e9611$export$1e88358c94ddec71.prototype;
function $1b19c6085a6e9611$export$87b259aa03e3d267() {
    return new $1b19c6085a6e9611$export$c7980688f11e1f49();
}
class $1b19c6085a6e9611$export$c7980688f11e1f49 extends $1b19c6085a6e9611$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: 'boolean',
            check (v) {
                if (v instanceof Boolean) v = v.valueOf();
                return typeof v === 'boolean';
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw)=>{
                if (this.spec.coerce && !this.isType(value)) {
                    if (/^(true|1)$/i.test(String(value))) return true;
                    if (/^(false|0)$/i.test(String(value))) return false;
                }
                return value;
            });
        });
    }
    isTrue(message = $1b19c6085a6e9611$var$boolean.isValue) {
        return this.test({
            message: message,
            name: 'is-value',
            exclusive: true,
            params: {
                value: 'true'
            },
            test (value) {
                return $1b19c6085a6e9611$var$isAbsent(value) || value === true;
            }
        });
    }
    isFalse(message = $1b19c6085a6e9611$var$boolean.isValue) {
        return this.test({
            message: message,
            name: 'is-value',
            exclusive: true,
            params: {
                value: 'false'
            },
            test (value) {
                return $1b19c6085a6e9611$var$isAbsent(value) || value === false;
            }
        });
    }
    default(def) {
        return super.default(def);
    }
    defined(msg) {
        return super.defined(msg);
    }
    optional() {
        return super.optional();
    }
    required(msg) {
        return super.required(msg);
    }
    notRequired() {
        return super.notRequired();
    }
    nullable() {
        return super.nullable();
    }
    nonNullable(msg) {
        return super.nonNullable(msg);
    }
    strip(v) {
        return super.strip(v);
    }
}
$1b19c6085a6e9611$export$87b259aa03e3d267.prototype = $1b19c6085a6e9611$export$c7980688f11e1f49.prototype;
/**
 * This file is a modified version of the file from the following repository:
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */ // prettier-ignore
//                1 YYYY                2 MM        3 DD              4 HH     5 mm        6 ss           7 msec         8 Z 9 ±   10 tzHH    11 tzmm
const $1b19c6085a6e9611$var$isoReg = /^(\d{4}|[+-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,.](\d{1,}))?)?(?:(Z)|([+-])(\d{2})(?::?(\d{2}))?)?)?$/;
function $1b19c6085a6e9611$var$parseIsoDate(date) {
    const struct = $1b19c6085a6e9611$var$parseDateStruct(date);
    if (!struct) return Date.parse ? Date.parse(date) : Number.NaN;
    // timestamps without timezone identifiers should be considered local time
    if (struct.z === undefined && struct.plusMinus === undefined) return new Date(struct.year, struct.month, struct.day, struct.hour, struct.minute, struct.second, struct.millisecond).valueOf();
    let totalMinutesOffset = 0;
    if (struct.z !== 'Z' && struct.plusMinus !== undefined) {
        totalMinutesOffset = struct.hourOffset * 60 + struct.minuteOffset;
        if (struct.plusMinus === '+') totalMinutesOffset = 0 - totalMinutesOffset;
    }
    return Date.UTC(struct.year, struct.month, struct.day, struct.hour, struct.minute + totalMinutesOffset, struct.second, struct.millisecond);
}
function $1b19c6085a6e9611$var$parseDateStruct(date) {
    var _regexResult$7$length, _regexResult$;
    const regexResult = $1b19c6085a6e9611$var$isoReg.exec(date);
    if (!regexResult) return null;
    // use of toNumber() avoids NaN timestamps caused by “undefined”
    // values being passed to Date constructor
    return {
        year: $1b19c6085a6e9611$var$toNumber(regexResult[1]),
        month: $1b19c6085a6e9611$var$toNumber(regexResult[2], 1) - 1,
        day: $1b19c6085a6e9611$var$toNumber(regexResult[3], 1),
        hour: $1b19c6085a6e9611$var$toNumber(regexResult[4]),
        minute: $1b19c6085a6e9611$var$toNumber(regexResult[5]),
        second: $1b19c6085a6e9611$var$toNumber(regexResult[6]),
        millisecond: regexResult[7] ? // allow arbitrary sub-second precision beyond milliseconds
        $1b19c6085a6e9611$var$toNumber(regexResult[7].substring(0, 3)) : 0,
        precision: (_regexResult$7$length = (_regexResult$ = regexResult[7]) == null ? void 0 : _regexResult$.length) != null ? _regexResult$7$length : undefined,
        z: regexResult[8] || undefined,
        plusMinus: regexResult[9] || undefined,
        hourOffset: $1b19c6085a6e9611$var$toNumber(regexResult[10]),
        minuteOffset: $1b19c6085a6e9611$var$toNumber(regexResult[11])
    };
}
function $1b19c6085a6e9611$var$toNumber(str, defaultValue = 0) {
    return Number(str) || defaultValue;
}
// Taken from HTML spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
let $1b19c6085a6e9611$var$rEmail = // eslint-disable-next-line
/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
let $1b19c6085a6e9611$var$rUrl = // eslint-disable-next-line
/^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i;
// eslint-disable-next-line
let $1b19c6085a6e9611$var$rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
let $1b19c6085a6e9611$var$yearMonthDay = '^\\d{4}-\\d{2}-\\d{2}';
let $1b19c6085a6e9611$var$hourMinuteSecond = '\\d{2}:\\d{2}:\\d{2}';
let $1b19c6085a6e9611$var$zOrOffset = '(([+-]\\d{2}(:?\\d{2})?)|Z)';
let $1b19c6085a6e9611$var$rIsoDateTime = new RegExp(`${$1b19c6085a6e9611$var$yearMonthDay}T${$1b19c6085a6e9611$var$hourMinuteSecond}(\\.\\d+)?${$1b19c6085a6e9611$var$zOrOffset}$`);
let $1b19c6085a6e9611$var$isTrimmed = (value)=>$1b19c6085a6e9611$var$isAbsent(value) || value === value.trim();
let $1b19c6085a6e9611$var$objStringTag = ({}).toString();
function $1b19c6085a6e9611$export$22b082955e083ec3() {
    return new $1b19c6085a6e9611$export$49bf8b2ede5138eb();
}
class $1b19c6085a6e9611$export$49bf8b2ede5138eb extends $1b19c6085a6e9611$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: 'string',
            check (value) {
                if (value instanceof String) value = value.valueOf();
                return typeof value === 'string';
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw)=>{
                if (!this.spec.coerce || this.isType(value)) return value;
                // don't ever convert arrays
                if (Array.isArray(value)) return value;
                const strValue = value != null && value.toString ? value.toString() : value;
                // no one wants plain objects converted to [Object object]
                if (strValue === $1b19c6085a6e9611$var$objStringTag) return value;
                return strValue;
            });
        });
    }
    required(message) {
        return super.required(message).withMutation((schema)=>schema.test({
                message: message || $1b19c6085a6e9611$var$mixed.required,
                name: 'required',
                skipAbsent: true,
                test: (value)=>!!value.length
            }));
    }
    notRequired() {
        return super.notRequired().withMutation((schema)=>{
            schema.tests = schema.tests.filter((t)=>t.OPTIONS.name !== 'required');
            return schema;
        });
    }
    length(length, message = $1b19c6085a6e9611$var$string.length) {
        return this.test({
            message: message,
            name: 'length',
            exclusive: true,
            params: {
                length: length
            },
            skipAbsent: true,
            test (value) {
                return value.length === this.resolve(length);
            }
        });
    }
    min(min, message = $1b19c6085a6e9611$var$string.min) {
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value.length >= this.resolve(min);
            }
        });
    }
    max(max, message = $1b19c6085a6e9611$var$string.max) {
        return this.test({
            name: 'max',
            exclusive: true,
            message: message,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value.length <= this.resolve(max);
            }
        });
    }
    matches(regex, options) {
        let excludeEmptyString = false;
        let message;
        let name;
        if (options) {
            if (typeof options === 'object') ({ excludeEmptyString: excludeEmptyString = false, message: message, name: name } = options);
            else message = options;
        }
        return this.test({
            name: name || 'matches',
            message: message || $1b19c6085a6e9611$var$string.matches,
            params: {
                regex: regex
            },
            skipAbsent: true,
            test: (value)=>value === '' && excludeEmptyString || value.search(regex) !== -1
        });
    }
    email(message = $1b19c6085a6e9611$var$string.email) {
        return this.matches($1b19c6085a6e9611$var$rEmail, {
            name: 'email',
            message: message,
            excludeEmptyString: true
        });
    }
    url(message = $1b19c6085a6e9611$var$string.url) {
        return this.matches($1b19c6085a6e9611$var$rUrl, {
            name: 'url',
            message: message,
            excludeEmptyString: true
        });
    }
    uuid(message = $1b19c6085a6e9611$var$string.uuid) {
        return this.matches($1b19c6085a6e9611$var$rUUID, {
            name: 'uuid',
            message: message,
            excludeEmptyString: false
        });
    }
    datetime(options) {
        let message = '';
        let allowOffset;
        let precision;
        if (options) {
            if (typeof options === 'object') ({ message: message = '', allowOffset: allowOffset = false, precision: precision } = options);
            else message = options;
        }
        return this.matches($1b19c6085a6e9611$var$rIsoDateTime, {
            name: 'datetime',
            message: message || $1b19c6085a6e9611$var$string.datetime,
            excludeEmptyString: true
        }).test({
            name: 'datetime_offset',
            message: message || $1b19c6085a6e9611$var$string.datetime_offset,
            params: {
                allowOffset: allowOffset
            },
            skipAbsent: true,
            test: (value)=>{
                if (!value || allowOffset) return true;
                const struct = $1b19c6085a6e9611$var$parseDateStruct(value);
                if (!struct) return false;
                return !!struct.z;
            }
        }).test({
            name: 'datetime_precision',
            message: message || $1b19c6085a6e9611$var$string.datetime_precision,
            params: {
                precision: precision
            },
            skipAbsent: true,
            test: (value)=>{
                if (!value || precision == undefined) return true;
                const struct = $1b19c6085a6e9611$var$parseDateStruct(value);
                if (!struct) return false;
                return struct.precision === precision;
            }
        });
    }
    //-- transforms --
    ensure() {
        return this.default('').transform((val)=>val === null ? '' : val);
    }
    trim(message = $1b19c6085a6e9611$var$string.trim) {
        return this.transform((val)=>val != null ? val.trim() : val).test({
            message: message,
            name: 'trim',
            test: $1b19c6085a6e9611$var$isTrimmed
        });
    }
    lowercase(message = $1b19c6085a6e9611$var$string.lowercase) {
        return this.transform((value)=>!$1b19c6085a6e9611$var$isAbsent(value) ? value.toLowerCase() : value).test({
            message: message,
            name: 'string_case',
            exclusive: true,
            skipAbsent: true,
            test: (value)=>$1b19c6085a6e9611$var$isAbsent(value) || value === value.toLowerCase()
        });
    }
    uppercase(message = $1b19c6085a6e9611$var$string.uppercase) {
        return this.transform((value)=>!$1b19c6085a6e9611$var$isAbsent(value) ? value.toUpperCase() : value).test({
            message: message,
            name: 'string_case',
            exclusive: true,
            skipAbsent: true,
            test: (value)=>$1b19c6085a6e9611$var$isAbsent(value) || value === value.toUpperCase()
        });
    }
}
$1b19c6085a6e9611$export$22b082955e083ec3.prototype = $1b19c6085a6e9611$export$49bf8b2ede5138eb.prototype;
//
// String Interfaces
//
let $1b19c6085a6e9611$var$isNaN$1 = (value)=>value != +value;
function $1b19c6085a6e9611$export$98e628dec113755e() {
    return new $1b19c6085a6e9611$export$f192ec5e9228ab19();
}
class $1b19c6085a6e9611$export$f192ec5e9228ab19 extends $1b19c6085a6e9611$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: 'number',
            check (value) {
                if (value instanceof Number) value = value.valueOf();
                return typeof value === 'number' && !$1b19c6085a6e9611$var$isNaN$1(value);
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw)=>{
                if (!this.spec.coerce) return value;
                let parsed = value;
                if (typeof parsed === 'string') {
                    parsed = parsed.replace(/\s/g, '');
                    if (parsed === '') return NaN;
                    // don't use parseFloat to avoid positives on alpha-numeric strings
                    parsed = +parsed;
                }
                // null -> NaN isn't useful; treat all nulls as null and let it fail on
                // nullability check vs TypeErrors
                if (this.isType(parsed) || parsed === null) return parsed;
                return parseFloat(parsed);
            });
        });
    }
    min(min, message = $1b19c6085a6e9611$var$number.min) {
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value >= this.resolve(min);
            }
        });
    }
    max(max, message = $1b19c6085a6e9611$var$number.max) {
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value <= this.resolve(max);
            }
        });
    }
    lessThan(less, message = $1b19c6085a6e9611$var$number.lessThan) {
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                less: less
            },
            skipAbsent: true,
            test (value) {
                return value < this.resolve(less);
            }
        });
    }
    moreThan(more, message = $1b19c6085a6e9611$var$number.moreThan) {
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                more: more
            },
            skipAbsent: true,
            test (value) {
                return value > this.resolve(more);
            }
        });
    }
    positive(msg = $1b19c6085a6e9611$var$number.positive) {
        return this.moreThan(0, msg);
    }
    negative(msg = $1b19c6085a6e9611$var$number.negative) {
        return this.lessThan(0, msg);
    }
    integer(message = $1b19c6085a6e9611$var$number.integer) {
        return this.test({
            name: 'integer',
            message: message,
            skipAbsent: true,
            test: (val)=>Number.isInteger(val)
        });
    }
    truncate() {
        return this.transform((value)=>!$1b19c6085a6e9611$var$isAbsent(value) ? value | 0 : value);
    }
    round(method) {
        var _method;
        let avail = [
            'ceil',
            'floor',
            'round',
            'trunc'
        ];
        method = ((_method = method) == null ? void 0 : _method.toLowerCase()) || 'round';
        // this exists for symemtry with the new Math.trunc
        if (method === 'trunc') return this.truncate();
        if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError('Only valid options for round() are: ' + avail.join(', '));
        return this.transform((value)=>!$1b19c6085a6e9611$var$isAbsent(value) ? Math[method](value) : value);
    }
}
$1b19c6085a6e9611$export$98e628dec113755e.prototype = $1b19c6085a6e9611$export$f192ec5e9228ab19.prototype;
//
// Number Interfaces
//
let $1b19c6085a6e9611$var$invalidDate = new Date('');
let $1b19c6085a6e9611$var$isDate = (obj)=>Object.prototype.toString.call(obj) === '[object Date]';
function $1b19c6085a6e9611$export$324d90190a8b822a() {
    return new $1b19c6085a6e9611$export$18ec3cc5a157503f();
}
class $1b19c6085a6e9611$export$18ec3cc5a157503f extends $1b19c6085a6e9611$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: 'date',
            check (v) {
                return $1b19c6085a6e9611$var$isDate(v) && !isNaN(v.getTime());
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw)=>{
                // null -> InvalidDate isn't useful; treat all nulls as null and let it fail on
                // nullability check vs TypeErrors
                if (!this.spec.coerce || this.isType(value) || value === null) return value;
                value = $1b19c6085a6e9611$var$parseIsoDate(value);
                // 0 is a valid timestamp equivalent to 1970-01-01T00:00:00Z(unix epoch) or before.
                return !isNaN(value) ? new Date(value) : $1b19c6085a6e9611$export$18ec3cc5a157503f.INVALID_DATE;
            });
        });
    }
    prepareParam(ref, name) {
        let param;
        if (!$1b19c6085a6e9611$var$Reference.isRef(ref)) {
            let cast = this.cast(ref);
            if (!this._typeCheck(cast)) throw new TypeError(`\`${name}\` must be a Date or a value that can be \`cast()\` to a Date`);
            param = cast;
        } else param = ref;
        return param;
    }
    min(min, message = $1b19c6085a6e9611$var$date.min) {
        let limit = this.prepareParam(min, 'min');
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value >= this.resolve(limit);
            }
        });
    }
    max(max, message = $1b19c6085a6e9611$var$date.max) {
        let limit = this.prepareParam(max, 'max');
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value <= this.resolve(limit);
            }
        });
    }
}
$1b19c6085a6e9611$export$18ec3cc5a157503f.INVALID_DATE = $1b19c6085a6e9611$var$invalidDate;
$1b19c6085a6e9611$export$324d90190a8b822a.prototype = $1b19c6085a6e9611$export$18ec3cc5a157503f.prototype;
$1b19c6085a6e9611$export$324d90190a8b822a.INVALID_DATE = $1b19c6085a6e9611$var$invalidDate;
// @ts-expect-error
function $1b19c6085a6e9611$var$sortFields(fields, excludedEdges = []) {
    let edges = [];
    let nodes = new Set();
    let excludes = new Set(excludedEdges.map(([a, b])=>`${a}-${b}`));
    function addNode(depPath, key) {
        let node = (0, $75b98c86abc67c8e$exports.split)(depPath)[0];
        nodes.add(node);
        if (!excludes.has(`${key}-${node}`)) edges.push([
            key,
            node
        ]);
    }
    for (const key of Object.keys(fields)){
        let value = fields[key];
        nodes.add(key);
        if ($1b19c6085a6e9611$var$Reference.isRef(value) && value.isSibling) addNode(value.path, key);
        else if ($1b19c6085a6e9611$export$213e2a3e7c4f326e(value) && 'deps' in value) value.deps.forEach((path)=>addNode(path, key));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($fc86160b8cf91a0e$exports))).array(Array.from(nodes), edges).reverse();
}
function $1b19c6085a6e9611$var$findIndex(arr, err) {
    let idx = Infinity;
    arr.some((key, ii)=>{
        var _err$path;
        if ((_err$path = err.path) != null && _err$path.includes(key)) {
            idx = ii;
            return true;
        }
    });
    return idx;
}
function $1b19c6085a6e9611$var$sortByKeyOrder(keys) {
    return (a, b)=>{
        return $1b19c6085a6e9611$var$findIndex(keys, a) - $1b19c6085a6e9611$var$findIndex(keys, b);
    };
}
const $1b19c6085a6e9611$var$parseJson = (value, _, schema)=>{
    if (typeof value !== 'string') return value;
    let parsed = value;
    try {
        parsed = JSON.parse(value);
    } catch (err) {
    /* */ }
    return schema.isType(parsed) ? parsed : value;
};
// @ts-ignore
function $1b19c6085a6e9611$var$deepPartial(schema) {
    if ('fields' in schema) {
        const partial = {};
        for (const [key, fieldSchema] of Object.entries(schema.fields))partial[key] = $1b19c6085a6e9611$var$deepPartial(fieldSchema);
        return schema.setFields(partial);
    }
    if (schema.type === 'array') {
        const nextArray = schema.optional();
        if (nextArray.innerType) nextArray.innerType = $1b19c6085a6e9611$var$deepPartial(nextArray.innerType);
        return nextArray;
    }
    if (schema.type === 'tuple') return schema.optional().clone({
        types: schema.spec.types.map($1b19c6085a6e9611$var$deepPartial)
    });
    if ('optional' in schema) return schema.optional();
    return schema;
}
const $1b19c6085a6e9611$var$deepHas = (obj, p)=>{
    const path = [
        ...(0, $75b98c86abc67c8e$exports.normalizePath)(p)
    ];
    if (path.length === 1) return path[0] in obj;
    let last = path.pop();
    let parent = (0, $75b98c86abc67c8e$exports.getter)((0, $75b98c86abc67c8e$exports.join)(path), true)(obj);
    return !!(parent && last in parent);
};
let $1b19c6085a6e9611$var$isObject = (obj)=>Object.prototype.toString.call(obj) === '[object Object]';
function $1b19c6085a6e9611$var$unknown(ctx, value) {
    let known = Object.keys(ctx.fields);
    return Object.keys(value).filter((key)=>known.indexOf(key) === -1);
}
const $1b19c6085a6e9611$var$defaultSort = $1b19c6085a6e9611$var$sortByKeyOrder([]);
function $1b19c6085a6e9611$export$be5493f9613cbbe(spec) {
    return new $1b19c6085a6e9611$export$18b4fc70ec7eccf8(spec);
}
class $1b19c6085a6e9611$export$18b4fc70ec7eccf8 extends $1b19c6085a6e9611$export$19342e026b58ebb7 {
    constructor(spec){
        super({
            type: 'object',
            check (value) {
                return $1b19c6085a6e9611$var$isObject(value) || typeof value === 'function';
            }
        });
        this.fields = Object.create(null);
        this._sortErrors = $1b19c6085a6e9611$var$defaultSort;
        this._nodes = [];
        this._excludedEdges = [];
        this.withMutation(()=>{
            if (spec) this.shape(spec);
        });
    }
    _cast(_value, options = {}) {
        var _options$stripUnknown;
        let value = super._cast(_value, options);
        //should ignore nulls here
        if (value === undefined) return this.getDefault(options);
        if (!this._typeCheck(value)) return value;
        let fields = this.fields;
        let strip = (_options$stripUnknown = options.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;
        let props = [].concat(this._nodes, Object.keys(value).filter((v)=>!this._nodes.includes(v)));
        let intermediateValue = {}; // is filled during the transform below
        let innerOptions = Object.assign({}, options, {
            parent: intermediateValue,
            __validating: options.__validating || false
        });
        let isChanged = false;
        for (const prop of props){
            let field = fields[prop];
            let exists = prop in value;
            let inputValue = value[prop];
            if (field) {
                let fieldValue;
                // safe to mutate since this is fired in sequence
                innerOptions.path = (options.path ? `${options.path}.` : '') + prop;
                field = field.resolve({
                    value: inputValue,
                    context: options.context,
                    parent: intermediateValue
                });
                let fieldSpec = field instanceof $1b19c6085a6e9611$export$19342e026b58ebb7 ? field.spec : undefined;
                let strict = fieldSpec == null ? void 0 : fieldSpec.strict;
                if (fieldSpec != null && fieldSpec.strip) {
                    isChanged = isChanged || prop in value;
                    continue;
                }
                fieldValue = !options.__validating || !strict ? field.cast(inputValue, innerOptions) : inputValue;
                if (fieldValue !== undefined) intermediateValue[prop] = fieldValue;
            } else if (exists && !strip) intermediateValue[prop] = inputValue;
            if (exists !== prop in intermediateValue || intermediateValue[prop] !== inputValue) isChanged = true;
        }
        return isChanged ? intermediateValue : value;
    }
    _validate(_value, options = {}, panic, next) {
        let { from: from = [], originalValue: originalValue = _value, recursive: recursive = this.spec.recursive } = options;
        options.from = [
            {
                schema: this,
                value: originalValue
            },
            ...from
        ];
        // this flag is needed for handling `strict` correctly in the context of
        // validation vs just casting. e.g strict() on a field is only used when validating
        options.__validating = true;
        options.originalValue = originalValue;
        super._validate(_value, options, panic, (objectErrors, value)=>{
            if (!recursive || !$1b19c6085a6e9611$var$isObject(value)) {
                next(objectErrors, value);
                return;
            }
            originalValue = originalValue || value;
            let tests = [];
            for (let key of this._nodes){
                let field = this.fields[key];
                if (!field || $1b19c6085a6e9611$var$Reference.isRef(field)) continue;
                tests.push(field.asNestedTest({
                    options: options,
                    key: key,
                    parent: value,
                    parentPath: options.path,
                    originalParent: originalValue
                }));
            }
            this.runTests({
                tests: tests,
                value: value,
                originalValue: originalValue,
                options: options
            }, panic, (fieldErrors)=>{
                next(fieldErrors.sort(this._sortErrors).concat(objectErrors), value);
            });
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        next.fields = Object.assign({}, this.fields);
        next._nodes = this._nodes;
        next._excludedEdges = this._excludedEdges;
        next._sortErrors = this._sortErrors;
        return next;
    }
    concat(schema) {
        let next = super.concat(schema);
        let nextFields = next.fields;
        for (let [field, schemaOrRef] of Object.entries(this.fields)){
            const target = nextFields[field];
            nextFields[field] = target === undefined ? schemaOrRef : target;
        }
        return next.withMutation((s)=>// XXX: excludes here is wrong
            s.setFields(nextFields, [
                ...this._excludedEdges,
                ...schema._excludedEdges
            ]));
    }
    _getDefault(options) {
        if ('default' in this.spec) return super._getDefault(options);
        // if there is no default set invent one
        if (!this._nodes.length) return undefined;
        let dft = {};
        this._nodes.forEach((key)=>{
            var _innerOptions;
            const field = this.fields[key];
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[key]
            });
            dft[key] = field && 'getDefault' in field ? field.getDefault(innerOptions) : undefined;
        });
        return dft;
    }
    setFields(shape, excludedEdges) {
        let next = this.clone();
        next.fields = shape;
        next._nodes = $1b19c6085a6e9611$var$sortFields(shape, excludedEdges);
        next._sortErrors = $1b19c6085a6e9611$var$sortByKeyOrder(Object.keys(shape));
        // XXX: this carries over edges which may not be what you want
        if (excludedEdges) next._excludedEdges = excludedEdges;
        return next;
    }
    shape(additions, excludes = []) {
        return this.clone().withMutation((next)=>{
            let edges = next._excludedEdges;
            if (excludes.length) {
                if (!Array.isArray(excludes[0])) excludes = [
                    excludes
                ];
                edges = [
                    ...next._excludedEdges,
                    ...excludes
                ];
            }
            // XXX: excludes here is wrong
            return next.setFields(Object.assign(next.fields, additions), edges);
        });
    }
    partial() {
        const partial = {};
        for (const [key, schema] of Object.entries(this.fields))partial[key] = 'optional' in schema && schema.optional instanceof Function ? schema.optional() : schema;
        return this.setFields(partial);
    }
    deepPartial() {
        const next = $1b19c6085a6e9611$var$deepPartial(this);
        return next;
    }
    pick(keys) {
        const picked = {};
        for (const key of keys)if (this.fields[key]) picked[key] = this.fields[key];
        return this.setFields(picked, this._excludedEdges.filter(([a, b])=>keys.includes(a) && keys.includes(b)));
    }
    omit(keys) {
        const remaining = [];
        for (const key of Object.keys(this.fields)){
            if (keys.includes(key)) continue;
            remaining.push(key);
        }
        return this.pick(remaining);
    }
    from(from, to, alias) {
        let fromGetter = (0, $75b98c86abc67c8e$exports.getter)(from, true);
        return this.transform((obj)=>{
            if (!obj) return obj;
            let newObj = obj;
            if ($1b19c6085a6e9611$var$deepHas(obj, from)) {
                newObj = Object.assign({}, obj);
                if (!alias) delete newObj[from];
                newObj[to] = fromGetter(obj);
            }
            return newObj;
        });
    }
    /** Parse an input JSON string to an object */ json() {
        return this.transform($1b19c6085a6e9611$var$parseJson);
    }
    /**
   * Similar to `noUnknown` but only validates that an object is the right shape without stripping the unknown keys
   */ exact(message) {
        return this.test({
            name: 'exact',
            exclusive: true,
            message: message || $1b19c6085a6e9611$var$object.exact,
            test (value) {
                if (value == null) return true;
                const unknownKeys = $1b19c6085a6e9611$var$unknown(this.schema, value);
                return unknownKeys.length === 0 || this.createError({
                    params: {
                        properties: unknownKeys.join(', ')
                    }
                });
            }
        });
    }
    stripUnknown() {
        return this.clone({
            noUnknown: true
        });
    }
    noUnknown(noAllow = true, message = $1b19c6085a6e9611$var$object.noUnknown) {
        if (typeof noAllow !== 'boolean') {
            message = noAllow;
            noAllow = true;
        }
        let next = this.test({
            name: 'noUnknown',
            exclusive: true,
            message: message,
            test (value) {
                if (value == null) return true;
                const unknownKeys = $1b19c6085a6e9611$var$unknown(this.schema, value);
                return !noAllow || unknownKeys.length === 0 || this.createError({
                    params: {
                        unknown: unknownKeys.join(', ')
                    }
                });
            }
        });
        next.spec.noUnknown = noAllow;
        return next;
    }
    unknown(allow = true, message = $1b19c6085a6e9611$var$object.noUnknown) {
        return this.noUnknown(!allow, message);
    }
    transformKeys(fn) {
        return this.transform((obj)=>{
            if (!obj) return obj;
            const result = {};
            for (const key of Object.keys(obj))result[fn(key)] = obj[key];
            return result;
        });
    }
    camelCase() {
        return this.transformKeys((0, $a214d9c9202f8fd9$exports.camelCase));
    }
    snakeCase() {
        return this.transformKeys((0, $a214d9c9202f8fd9$exports.snakeCase));
    }
    constantCase() {
        return this.transformKeys((key)=>(0, $a214d9c9202f8fd9$exports.snakeCase)(key).toUpperCase());
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        base.fields = {};
        for (const [key, value] of Object.entries(next.fields)){
            var _innerOptions2;
            let innerOptions = options;
            if ((_innerOptions2 = innerOptions) != null && _innerOptions2.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[key]
            });
            base.fields[key] = value.describe(innerOptions);
        }
        return base;
    }
}
$1b19c6085a6e9611$export$be5493f9613cbbe.prototype = $1b19c6085a6e9611$export$18b4fc70ec7eccf8.prototype;
function $1b19c6085a6e9611$export$2f23118c22fb2630(type) {
    return new $1b19c6085a6e9611$export$4347112b8447a7d(type);
}
class $1b19c6085a6e9611$export$4347112b8447a7d extends $1b19c6085a6e9611$export$19342e026b58ebb7 {
    constructor(type){
        super({
            type: 'array',
            spec: {
                types: type
            },
            check (v) {
                return Array.isArray(v);
            }
        });
        // `undefined` specifically means uninitialized, as opposed to "no subtype"
        this.innerType = void 0;
        this.innerType = type;
    }
    _cast(_value, _opts) {
        const value = super._cast(_value, _opts);
        // should ignore nulls here
        if (!this._typeCheck(value) || !this.innerType) return value;
        let isChanged = false;
        const castArray = value.map((v, idx)=>{
            const castElement = this.innerType.cast(v, Object.assign({}, _opts, {
                path: `${_opts.path || ''}[${idx}]`,
                parent: value,
                originalValue: v,
                value: v,
                index: idx
            }));
            if (castElement !== v) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    }
    _validate(_value, options = {}, panic, next) {
        var _options$recursive;
        // let sync = options.sync;
        // let path = options.path;
        let innerType = this.innerType;
        // let endEarly = options.abortEarly ?? this.spec.abortEarly;
        let recursive = (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive;
        options.originalValue != null ? options.originalValue : _value;
        super._validate(_value, options, panic, (arrayErrors, value)=>{
            var _options$originalValu2;
            if (!recursive || !innerType || !this._typeCheck(value)) {
                next(arrayErrors, value);
                return;
            }
            // #950 Ensure that sparse array empty slots are validated
            let tests = new Array(value.length);
            for(let index = 0; index < value.length; index++){
                var _options$originalValu;
                tests[index] = innerType.asNestedTest({
                    options: options,
                    index: index,
                    parent: value,
                    parentPath: options.path,
                    originalParent: (_options$originalValu = options.originalValue) != null ? _options$originalValu : _value
                });
            }
            this.runTests({
                value: value,
                tests: tests,
                originalValue: (_options$originalValu2 = options.originalValue) != null ? _options$originalValu2 : _value,
                options: options
            }, panic, (innerTypeErrors)=>next(innerTypeErrors.concat(arrayErrors), value));
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        // @ts-expect-error readonly
        next.innerType = this.innerType;
        return next;
    }
    /** Parse an input JSON string to an object */ json() {
        return this.transform($1b19c6085a6e9611$var$parseJson);
    }
    concat(schema) {
        let next = super.concat(schema);
        // @ts-expect-error readonly
        next.innerType = this.innerType;
        if (schema.innerType) // @ts-expect-error readonly
        next.innerType = next.innerType ? // @ts-expect-error Lazy doesn't have concat and will break
        next.innerType.concat(schema.innerType) : schema.innerType;
        return next;
    }
    of(schema) {
        // FIXME: this should return a new instance of array without the default to be
        let next = this.clone();
        if (!$1b19c6085a6e9611$export$213e2a3e7c4f326e(schema)) throw new TypeError('`array.of()` sub-schema must be a valid yup schema not: ' + $1b19c6085a6e9611$export$5790025c6e6c2ba6(schema));
        // @ts-expect-error readonly
        next.innerType = schema;
        next.spec = Object.assign({}, next.spec, {
            types: schema
        });
        return next;
    }
    length(length, message = $1b19c6085a6e9611$var$array.length) {
        return this.test({
            message: message,
            name: 'length',
            exclusive: true,
            params: {
                length: length
            },
            skipAbsent: true,
            test (value) {
                return value.length === this.resolve(length);
            }
        });
    }
    min(min, message) {
        message = message || $1b19c6085a6e9611$var$array.min;
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            // FIXME(ts): Array<typeof T>
            test (value) {
                return value.length >= this.resolve(min);
            }
        });
    }
    max(max, message) {
        message = message || $1b19c6085a6e9611$var$array.max;
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value.length <= this.resolve(max);
            }
        });
    }
    ensure() {
        return this.default(()=>[]).transform((val, original)=>{
            // We don't want to return `null` for nullable schema
            if (this._typeCheck(val)) return val;
            return original == null ? [] : [].concat(original);
        });
    }
    compact(rejector) {
        let reject = !rejector ? (v)=>!!v : (v, i, a)=>!rejector(v, i, a);
        return this.transform((values)=>values != null ? values.filter(reject) : values);
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        if (next.innerType) {
            var _innerOptions;
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[0]
            });
            base.innerType = next.innerType.describe(innerOptions);
        }
        return base;
    }
}
$1b19c6085a6e9611$export$2f23118c22fb2630.prototype = $1b19c6085a6e9611$export$4347112b8447a7d.prototype;
// @ts-ignore
function $1b19c6085a6e9611$export$65e3907585753458(schemas) {
    return new $1b19c6085a6e9611$export$411c3b3687e8ecc8(schemas);
}
class $1b19c6085a6e9611$export$411c3b3687e8ecc8 extends $1b19c6085a6e9611$export$19342e026b58ebb7 {
    constructor(schemas){
        super({
            type: 'tuple',
            spec: {
                types: schemas
            },
            check (v) {
                const types = this.spec.types;
                return Array.isArray(v) && v.length === types.length;
            }
        });
        this.withMutation(()=>{
            this.typeError($1b19c6085a6e9611$var$tuple.notType);
        });
    }
    _cast(inputValue, options) {
        const { types: types } = this.spec;
        const value = super._cast(inputValue, options);
        if (!this._typeCheck(value)) return value;
        let isChanged = false;
        const castArray = types.map((type, idx)=>{
            const castElement = type.cast(value[idx], Object.assign({}, options, {
                path: `${options.path || ''}[${idx}]`,
                parent: value,
                originalValue: value[idx],
                value: value[idx],
                index: idx
            }));
            if (castElement !== value[idx]) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    }
    _validate(_value, options = {}, panic, next) {
        let itemTypes = this.spec.types;
        super._validate(_value, options, panic, (tupleErrors, value)=>{
            var _options$originalValu2;
            // intentionally not respecting recursive
            if (!this._typeCheck(value)) {
                next(tupleErrors, value);
                return;
            }
            let tests = [];
            for (let [index, itemSchema] of itemTypes.entries()){
                var _options$originalValu;
                tests[index] = itemSchema.asNestedTest({
                    options: options,
                    index: index,
                    parent: value,
                    parentPath: options.path,
                    originalParent: (_options$originalValu = options.originalValue) != null ? _options$originalValu : _value
                });
            }
            this.runTests({
                value: value,
                tests: tests,
                originalValue: (_options$originalValu2 = options.originalValue) != null ? _options$originalValu2 : _value,
                options: options
            }, panic, (innerTypeErrors)=>next(innerTypeErrors.concat(tupleErrors), value));
        });
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        base.innerType = next.spec.types.map((schema, index)=>{
            var _innerOptions;
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[index]
            });
            return schema.describe(innerOptions);
        });
        return base;
    }
}
$1b19c6085a6e9611$export$65e3907585753458.prototype = $1b19c6085a6e9611$export$411c3b3687e8ecc8.prototype;
function $1b19c6085a6e9611$export$488013bae63b21da(builder) {
    return new $1b19c6085a6e9611$export$71117d144d3091c9(builder);
}
function $1b19c6085a6e9611$var$catchValidationError(fn) {
    try {
        return fn();
    } catch (err) {
        if ($1b19c6085a6e9611$export$2191b9da168c6cf0.isError(err)) return Promise.reject(err);
        throw err;
    }
}
class $1b19c6085a6e9611$export$71117d144d3091c9 {
    constructor(builder){
        this.type = 'lazy';
        this.__isYupSchema__ = true;
        this.spec = void 0;
        this._resolve = (value, options = {})=>{
            let schema = this.builder(value, options);
            if (!$1b19c6085a6e9611$export$213e2a3e7c4f326e(schema)) throw new TypeError('lazy() functions must return a valid schema');
            if (this.spec.optional) schema = schema.optional();
            return schema.resolve(options);
        };
        this.builder = builder;
        this.spec = {
            meta: undefined,
            optional: false
        };
    }
    clone(spec) {
        const next = new $1b19c6085a6e9611$export$71117d144d3091c9(this.builder);
        next.spec = Object.assign({}, this.spec, spec);
        return next;
    }
    optionality(optional) {
        const next = this.clone({
            optional: optional
        });
        return next;
    }
    optional() {
        return this.optionality(true);
    }
    resolve(options) {
        return this._resolve(options.value, options);
    }
    cast(value, options) {
        return this._resolve(value, options).cast(value, options);
    }
    asNestedTest(config) {
        let { key: key, index: index, parent: parent, options: options } = config;
        let value = parent[index != null ? index : key];
        return this._resolve(value, Object.assign({}, options, {
            value: value,
            parent: parent
        })).asNestedTest(config);
    }
    validate(value, options) {
        return $1b19c6085a6e9611$var$catchValidationError(()=>this._resolve(value, options).validate(value, options));
    }
    validateSync(value, options) {
        return this._resolve(value, options).validateSync(value, options);
    }
    validateAt(path, value, options) {
        return $1b19c6085a6e9611$var$catchValidationError(()=>this._resolve(value, options).validateAt(path, value, options));
    }
    validateSyncAt(path, value, options) {
        return this._resolve(value, options).validateSyncAt(path, value, options);
    }
    isValid(value, options) {
        try {
            return this._resolve(value, options).isValid(value, options);
        } catch (err) {
            if ($1b19c6085a6e9611$export$2191b9da168c6cf0.isError(err)) return Promise.resolve(false);
            throw err;
        }
    }
    isValidSync(value, options) {
        return this._resolve(value, options).isValidSync(value, options);
    }
    describe(options) {
        return options ? this.resolve(options).describe(options) : {
            type: 'lazy',
            meta: this.spec.meta,
            label: undefined
        };
    }
    meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
    }
    get ['~standard']() {
        const schema = this;
        const standard = {
            version: 1,
            vendor: 'yup',
            async validate (value) {
                try {
                    const result = await schema.validate(value, {
                        abortEarly: false
                    });
                    return {
                        value: result
                    };
                } catch (err) {
                    if ($1b19c6085a6e9611$export$2191b9da168c6cf0.isError(err)) return {
                        issues: $1b19c6085a6e9611$var$issuesFromValidationError(err)
                    };
                    throw err;
                }
            }
        };
        return standard;
    }
}
function $1b19c6085a6e9611$export$c8aadf3621e41efb(custom) {
    Object.keys(custom).forEach((type)=>{
        // @ts-ignore
        Object.keys(custom[type]).forEach((method)=>{
            // @ts-ignore
            $1b19c6085a6e9611$export$d7f512c98c859244[type][method] = custom[type][method];
        });
    });
}
function $1b19c6085a6e9611$export$20be359f745f973c(schemaType, name, fn) {
    if (!schemaType || !$1b19c6085a6e9611$export$213e2a3e7c4f326e(schemaType.prototype)) throw new TypeError('You must provide a yup schema constructor function');
    if (typeof name !== 'string') throw new TypeError('A Method name must be provided');
    if (typeof fn !== 'function') throw new TypeError('Method function must be provided');
    schemaType.prototype[name] = fn;
}



var $jTKGQ = parcelRequire("jTKGQ");

function $27cb5f515eacb0bf$export$51063abe2742d805(plugins, data) {
    const validationSchema = plugins.reduce((acc, plugin)=>{
        const editSchema = plugin.editSchema(data);
        if (!editSchema || editSchema === (0, $c0a25ef586f9da64$export$901cf72dabf2112a).HIDDEN) return acc;
        const schema = $27cb5f515eacb0bf$var$createObjectSchema({
            ...editSchema,
            type: 'object'
        });
        return acc.concat(schema);
    }, $1b19c6085a6e9611$export$be5493f9613cbbe());
    try {
        const result = validationSchema.validateSync(data, {
            abortEarly: false
        });
        return [
            result,
            null
        ];
    } catch (error) {
        const e = (0, $jTKGQ.yupToFormErrors)(error);
        return [
            null,
            e
        ];
    }
}
/**
 * Creates a Yup object schema based on the provided data.
 * @param {SchemaFieldObject} data - The schema field object.
 * @param {boolean} [isRequired] - Whether the schema is required.
 * @returns {Yup.ObjectSchema<object>} - The Yup object schema.
 */ function $27cb5f515eacb0bf$var$createObjectSchema(data, isRequired) {
    const required = data.required || [];
    const properties = data.properties || {};
    const mappedProperties = Object.keys(properties).reduce((acc, key)=>{
        const field = properties[key];
        const type = field.type;
        const isFieldRequired = required.includes(key);
        let schema;
        if (type === 'object' || type === 'root') schema = $27cb5f515eacb0bf$var$createObjectSchema(field, isFieldRequired);
        else if (type === 'string') schema = $27cb5f515eacb0bf$var$createStringSchema(field, isFieldRequired);
        else if (type === 'number') schema = $27cb5f515eacb0bf$var$createNumberSchema(field, isFieldRequired);
        else if (type === 'json') schema = $27cb5f515eacb0bf$var$createJsonSchema(field, isFieldRequired);
        else if (type === 'array') schema = $27cb5f515eacb0bf$var$createArraySchema(field, isFieldRequired);
        else throw new Error('Invalid item type');
        return {
            ...acc,
            [key]: schema
        };
    }, {});
    if (isRequired) return $1b19c6085a6e9611$export$be5493f9613cbbe(mappedProperties).required();
    else return $1b19c6085a6e9611$export$be5493f9613cbbe(mappedProperties);
}
/**
 * Creates a Yup string schema based on the provided data.
 * @param {SchemaFieldString} data - The schema field string.
 * @param {boolean} [isRequired] - Whether the schema is required.
 * @returns {Yup.StringSchema} - The Yup string schema.
 */ function $27cb5f515eacb0bf$var$createStringSchema(data, isRequired) {
    let schema = $1b19c6085a6e9611$export$22b082955e083ec3().label(typeof data.label === 'string' ? data.label : 'Value');
    if (data.enum) schema = schema.test('enum', '${path} value is invalid', (value)=>{
        if (value === '' && !isRequired) return true;
        const inOption = data.enum.some(([v])=>v === value);
        if (inOption) return true;
        if (data.allowOther) return typeof value === data.allowOther.type;
        return false;
    });
    return isRequired ? schema.required() : schema;
}
/**
 * Creates a Yup number schema based on the provided data.
 * @param {SchemaFieldNumber} data - The schema field number.
 * @param {boolean} [isRequired] - Whether the schema is required.
 * @returns {Yup.NumberSchema} - The Yup number schema.
 */ function $27cb5f515eacb0bf$var$createNumberSchema(data, isRequired) {
    const schema = $1b19c6085a6e9611$export$98e628dec113755e().label(typeof data.label === 'string' ? data.label : 'Value').typeError('Value must be a number');
    return isRequired ? schema.required() : schema;
}
/**
 * Creates a Yup JSON schema based on the provided data.
 * @param {SchemaFieldJson} data - The schema field JSON.
 * @param {boolean} [isRequired] - Whether the schema is required.
 * @returns {Yup.ObjectSchema} - The Yup JSON schema.
 */ function $27cb5f515eacb0bf$var$createJsonSchema(data, isRequired) {
    const schema = $1b19c6085a6e9611$export$be5493f9613cbbe().label(typeof data.label === 'string' ? data.label : 'Value');
    return isRequired ? schema.required() : schema;
}
/**
 * Creates a Yup array schema based on the provided data.
 * @param {SchemaFieldArray} data - The schema field array.
 * @param {boolean} [isRequired] - Whether the schema is required.
 * @returns {Yup.ArraySchema} - The Yup array schema.
 */ function $27cb5f515eacb0bf$var$createArraySchema(data, isRequired) {
    const field = data.items || {};
    const type = field.type;
    let itemSchema;
    if (type === 'object') itemSchema = $27cb5f515eacb0bf$var$createObjectSchema(field);
    else if (type === 'string') itemSchema = $27cb5f515eacb0bf$var$createStringSchema(field);
    else if (type === 'number') itemSchema = $27cb5f515eacb0bf$var$createNumberSchema(field);
    else if (type === 'json') itemSchema = $27cb5f515eacb0bf$var$createJsonSchema(field);
    else if (type === 'array') itemSchema = $27cb5f515eacb0bf$var$createArraySchema(field);
    else throw new Error('Invalid item type');
    const schema = $1b19c6085a6e9611$export$2f23118c22fb2630().label(typeof data.label === 'string' ? data.label : 'Value').of(itemSchema).min(data.minItems || 0).max(data.maxItems || Infinity);
    return isRequired ? schema.required() : schema;
}
function $27cb5f515eacb0bf$export$4c3eba979352498d(obj) {
    if (typeof obj !== 'object' || obj === null) return '';
    const firstKey = Object.keys(obj)[0];
    if (!firstKey) return '';
    const path = $27cb5f515eacb0bf$export$4c3eba979352498d(obj[firstKey]);
    return path ? `${firstKey}.${path}` : firstKey;
}


function $1f4c49dac40f32d2$export$bbcdeaee0c64136a() {
    const { errors: errors, isSubmitting: isSubmitting, isValidating: isValidating } = (0, $jTKGQ.useFormikContext)();
    (0, $8v0nu.useEffect)(()=>{
        // Run on submission after validation took place.
        if (!errors || !isSubmitting || isValidating) return;
        const path = (0, $27cb5f515eacb0bf$export$4c3eba979352498d)(errors);
        // Use the parent node because if the element is a hidden input, it won't
        // scroll.
        const element = document.querySelector(`[name="${path}"]`)?.parentNode;
        element?.scrollIntoView({
            block: 'center',
            behavior: 'smooth'
        });
    }, [
        errors,
        isSubmitting,
        isValidating
    ]);
    return null;
}


var $8v0nu = parcelRequire("8v0nu");
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $69dffeaae91691c1$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
var $69dffeaae91691c1$export$2e2bcd8739ae039 = $69dffeaae91691c1$var$apply;


/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $019f7528cf907441$var$identity(value) {
    return value;
}
var $019f7528cf907441$export$2e2bcd8739ae039 = $019f7528cf907441$var$identity;



/* Built-in method references for those with the same name as other `lodash` methods. */ var $1e51bc401b6043cd$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $1e51bc401b6043cd$var$overRest(func, start, transform) {
    start = $1e51bc401b6043cd$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $1e51bc401b6043cd$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return (0, $69dffeaae91691c1$export$2e2bcd8739ae039)(func, this, otherArgs);
    };
}
var $1e51bc401b6043cd$export$2e2bcd8739ae039 = $1e51bc401b6043cd$var$overRest;


/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $349f7f1053f1b044$var$constant(value) {
    return function() {
        return value;
    };
}
var $349f7f1053f1b044$export$2e2bcd8739ae039 = $349f7f1053f1b044$var$constant;



var $2cPDw = parcelRequire("2cPDw");

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $a51109bbe361e9ec$var$baseSetToString = !(0, $2cPDw.default) ? (0, $019f7528cf907441$export$2e2bcd8739ae039) : function(func, string) {
    return (0, $2cPDw.default)(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': (0, $349f7f1053f1b044$export$2e2bcd8739ae039)(string),
        'writable': true
    });
};
var $a51109bbe361e9ec$export$2e2bcd8739ae039 = $a51109bbe361e9ec$var$baseSetToString;


/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $5df937161dce32d0$var$HOT_COUNT = 800, $5df937161dce32d0$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $5df937161dce32d0$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $5df937161dce32d0$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $5df937161dce32d0$var$nativeNow(), remaining = $5df937161dce32d0$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $5df937161dce32d0$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
var $5df937161dce32d0$export$2e2bcd8739ae039 = $5df937161dce32d0$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $391c7ab9c566c7e5$var$setToString = (0, $5df937161dce32d0$export$2e2bcd8739ae039)((0, $a51109bbe361e9ec$export$2e2bcd8739ae039));
var $391c7ab9c566c7e5$export$2e2bcd8739ae039 = $391c7ab9c566c7e5$var$setToString;


/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $3b00e771d951739b$var$baseRest(func, start) {
    return (0, $391c7ab9c566c7e5$export$2e2bcd8739ae039)((0, $1e51bc401b6043cd$export$2e2bcd8739ae039)(func, start, (0, $019f7528cf907441$export$2e2bcd8739ae039)), func + '');
}
var $3b00e771d951739b$export$2e2bcd8739ae039 = $3b00e771d951739b$var$baseRest;



var $5dLfO = parcelRequire("5dLfO");

var $8Xlz0 = parcelRequire("8Xlz0");

var $5TPq9 = parcelRequire("5TPq9");
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $883fc7d74a4b25ca$var$assignMergeValue(object, key, value) {
    if (value !== undefined && !(0, $5TPq9.default)(object[key], value) || value === undefined && !(key in object)) (0, $8Xlz0.default)(object, key, value);
}
var $883fc7d74a4b25ca$export$2e2bcd8739ae039 = $883fc7d74a4b25ca$var$assignMergeValue;


/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $f2bbfbbebae8ef06$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
var $f2bbfbbebae8ef06$export$2e2bcd8739ae039 = $f2bbfbbebae8ef06$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $c2253e8a3eee9abf$var$baseFor = (0, $f2bbfbbebae8ef06$export$2e2bcd8739ae039)();
var $c2253e8a3eee9abf$export$2e2bcd8739ae039 = $c2253e8a3eee9abf$var$baseFor;




var $jXF4S = parcelRequire("jXF4S");

var $1Z4Db = parcelRequire("1Z4Db");

var $7KNPo = parcelRequire("7KNPo");

var $55JsH = parcelRequire("55JsH");

var $774DM = parcelRequire("774DM");

var $eA9yl = parcelRequire("eA9yl");

var $b9DUl = parcelRequire("b9DUl");

var $9XysK = parcelRequire("9XysK");
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $2d3d78af7e122ce2$var$isArrayLikeObject(value) {
    return (0, $9XysK.default)(value) && (0, $b9DUl.default)(value);
}
var $2d3d78af7e122ce2$export$2e2bcd8739ae039 = $2d3d78af7e122ce2$var$isArrayLikeObject;



var $43Y3b = parcelRequire("43Y3b");

var $65Nb9 = parcelRequire("65Nb9");

var $55CT4 = parcelRequire("55CT4");

var $336aN = parcelRequire("336aN");

var $dK8Wz = parcelRequire("dK8Wz");
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $dd492644efd2ba18$var$safeGet(object, key) {
    if (key === 'constructor' && typeof object[key] === 'function') return;
    if (key == '__proto__') return;
    return object[key];
}
var $dd492644efd2ba18$export$2e2bcd8739ae039 = $dd492644efd2ba18$var$safeGet;



var $4Ekk0 = parcelRequire("4Ekk0");

var $efjUI = parcelRequire("efjUI");
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function $15853149df88a066$var$toPlainObject(value) {
    return (0, $4Ekk0.default)(value, (0, $efjUI.default)(value));
}
var $15853149df88a066$export$2e2bcd8739ae039 = $15853149df88a066$var$toPlainObject;


/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $75022fcc643a5dcc$var$baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = (0, $dd492644efd2ba18$export$2e2bcd8739ae039)(object, key), srcValue = (0, $dd492644efd2ba18$export$2e2bcd8739ae039)(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        (0, $883fc7d74a4b25ca$export$2e2bcd8739ae039)(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = (0, $eA9yl.default)(srcValue), isBuff = !isArr && (0, $43Y3b.default)(srcValue), isTyped = !isArr && !isBuff && (0, $dK8Wz.default)(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ((0, $eA9yl.default)(objValue)) newValue = objValue;
            else if ((0, $2d3d78af7e122ce2$export$2e2bcd8739ae039)(objValue)) newValue = (0, $7KNPo.default)(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = (0, $jXF4S.default)(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = (0, $1Z4Db.default)(srcValue, true);
            } else newValue = [];
        } else if ((0, $336aN.default)(srcValue) || (0, $774DM.default)(srcValue)) {
            newValue = objValue;
            if ((0, $774DM.default)(objValue)) newValue = (0, $15853149df88a066$export$2e2bcd8739ae039)(objValue);
            else if (!(0, $55CT4.default)(objValue) || (0, $65Nb9.default)(objValue)) newValue = (0, $55JsH.default)(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
    }
    (0, $883fc7d74a4b25ca$export$2e2bcd8739ae039)(object, key, newValue);
}
var $75022fcc643a5dcc$export$2e2bcd8739ae039 = $75022fcc643a5dcc$var$baseMergeDeep;



var $55CT4 = parcelRequire("55CT4");

var $efjUI = parcelRequire("efjUI");

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $bacc30e4bab426fb$var$baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    (0, $c2253e8a3eee9abf$export$2e2bcd8739ae039)(source, function(srcValue, key) {
        stack || (stack = new (0, $5dLfO.default));
        if ((0, $55CT4.default)(srcValue)) (0, $75022fcc643a5dcc$export$2e2bcd8739ae039)(object, source, key, srcIndex, $bacc30e4bab426fb$var$baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer((0, $dd492644efd2ba18$export$2e2bcd8739ae039)(object, key), srcValue, key + '', object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            (0, $883fc7d74a4b25ca$export$2e2bcd8739ae039)(object, key, newValue);
        }
    }, (0, $efjUI.default));
}
var $bacc30e4bab426fb$export$2e2bcd8739ae039 = $bacc30e4bab426fb$var$baseMerge;



var $55CT4 = parcelRequire("55CT4");
/**
 * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
 * objects into destination objects that are passed thru.
 *
 * @private
 * @param {*} objValue The destination value.
 * @param {*} srcValue The source value.
 * @param {string} key The key of the property to merge.
 * @param {Object} object The parent object of `objValue`.
 * @param {Object} source The parent object of `srcValue`.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 * @returns {*} Returns the value to assign.
 */ function $3bc5a02e252daa06$var$customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
    if ((0, $55CT4.default)(objValue) && (0, $55CT4.default)(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        (0, $bacc30e4bab426fb$export$2e2bcd8739ae039)(objValue, srcValue, undefined, $3bc5a02e252daa06$var$customDefaultsMerge, stack);
        stack['delete'](srcValue);
    }
    return objValue;
}
var $3bc5a02e252daa06$export$2e2bcd8739ae039 = $3bc5a02e252daa06$var$customDefaultsMerge;





var $5TPq9 = parcelRequire("5TPq9");

var $b9DUl = parcelRequire("b9DUl");

var $7Jqv7 = parcelRequire("7Jqv7");

var $55CT4 = parcelRequire("55CT4");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $48e480d9285ffdde$var$isIterateeCall(value, index, object) {
    if (!(0, $55CT4.default)(object)) return false;
    var type = typeof index;
    if (type == 'number' ? (0, $b9DUl.default)(object) && (0, $7Jqv7.default)(index, object.length) : type == 'string' && index in object) return (0, $5TPq9.default)(object[index], value);
    return false;
}
var $48e480d9285ffdde$export$2e2bcd8739ae039 = $48e480d9285ffdde$var$isIterateeCall;


/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $e883878ef1245bc3$var$createAssigner(assigner) {
    return (0, $3b00e771d951739b$export$2e2bcd8739ae039)(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
        if (guard && (0, $48e480d9285ffdde$export$2e2bcd8739ae039)(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
var $e883878ef1245bc3$export$2e2bcd8739ae039 = $e883878ef1245bc3$var$createAssigner;


/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */ var $7ebba4c02f8804f7$var$mergeWith = (0, $e883878ef1245bc3$export$2e2bcd8739ae039)(function(object, source, srcIndex, customizer) {
    (0, $bacc30e4bab426fb$export$2e2bcd8739ae039)(object, source, srcIndex, customizer);
});
var $7ebba4c02f8804f7$export$2e2bcd8739ae039 = $7ebba4c02f8804f7$var$mergeWith;


/**
 * This method is like `_.defaults` except that it recursively assigns
 * default properties.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaults
 * @example
 *
 * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
 * // => { 'a': { 'b': 2, 'c': 3 } }
 */ var $dbc7df56edeb0963$var$defaultsDeep = (0, $3b00e771d951739b$export$2e2bcd8739ae039)(function(args) {
    args.push(undefined, (0, $3bc5a02e252daa06$export$2e2bcd8739ae039));
    return (0, $69dffeaae91691c1$export$2e2bcd8739ae039)((0, $7ebba4c02f8804f7$export$2e2bcd8739ae039), undefined, args);
});
var $dbc7df56edeb0963$export$2e2bcd8739ae039 = $dbc7df56edeb0963$var$defaultsDeep;



var $jGWdr = parcelRequire("jGWdr");

const $f9867bdb459b34dd$export$115139354037a140 = (plugins, data)=>{
    const p = plugins.flatMap((pl)=>{
        if (pl instanceof (0, $c0a25ef586f9da64$export$901cf72dabf2112a)) return pl;
        else if (typeof pl === 'function') return pl(data);
        return;
    }).filter((p)=>p instanceof (0, $c0a25ef586f9da64$export$901cf72dabf2112a));
    return $f9867bdb459b34dd$export$6b8f01ca77e7b831(p);
};
const $f9867bdb459b34dd$export$6b8f01ca77e7b831 = (plugins)=>{
    const pluginsCopy = (0, $jGWdr.default)(plugins);
    for (const plSource of pluginsCopy)for (const hook of plSource[(0, $c0a25ef586f9da64$export$901cf72dabf2112a).HOOKS]){
        // Target where to apply the hook
        const plTarget = pluginsCopy.find((p)=>p.name === hook.name);
        if (!plTarget) continue;
        // The onAfterInit hook is made by executing one function after another.
        if (hook.onAfterInit) {
            const fn = hook.onAfterInit;
            const origInit = plTarget.init;
            plTarget.init = async (data)=>{
                await origInit.call(plTarget, data);
                await fn.call(plSource, plTarget, data);
            };
        }
        // The onAfterEditSchema hook is made by composing functions.
        if (hook.onAfterEditSchema) {
            const fn = hook.onAfterEditSchema;
            const origEditSchema = plTarget.editSchema;
            plTarget.editSchema = (formData)=>{
                return fn.call(plSource, plTarget, formData, origEditSchema.call(plTarget, formData));
            };
        }
    }
    return pluginsCopy;
};



function $c1e8126e9c607e51$export$bb0693b91fc28141(field) {
    if ([
        'root',
        'object'
    ].includes(field.type)) return Object.entries(field.properties).reduce((acc, [key, value])=>{
        return {
            ...acc,
            [key]: $c1e8126e9c607e51$export$bb0693b91fc28141(value)
        };
    }, {});
    if (field.type === 'array') {
        if ((field.minItems || 0) > 0) return Array.from({
            length: field.minItems
        }).map(()=>$c1e8126e9c607e51$export$bb0693b91fc28141(field.items));
        return [];
    }
    if (field.type === 'json') return {};
    return '';
}


const $4509732b37c182a7$var$usePlugins = (plugins, data)=>{
    const [readyPlugins, setReadyPlugins] = (0, $8v0nu.useState)();
    // `resolvePlugins` deep-clones each plugin (so hook composition doesn't
    // mutate the originals), which means any state a plugin sets in `init` only
    // lives on that one clone. If we re-resolve on every data change, a plugin
    // like PluginCore that derives `isNew` from data on `init` flips back and
    // forth as the user toggles between the Form and JSON views (the form's
    // `id` field then disappears mid-session). Pin init to the data captured at
    // mount; subsequent data updates flow through `enterData` -> `formData`.
    const initialDataRef = (0, $8v0nu.useRef)(data);
    (0, $8v0nu.useEffect)(()=>{
        // Guard against out-of-order resolution: if `plugins` changes (or the
        // component unmounts, including StrictMode's double-invoke) while a
        // previous `load()` is still awaiting `init`, the stale resolve must not
        // overwrite the newer plugins or set state after unmount.
        let cancelled = false;
        async function load() {
            const resolvedPlugins = (0, $f9867bdb459b34dd$export$115139354037a140)(plugins, initialDataRef.current);
            await Promise.all(resolvedPlugins.map((pl)=>pl.init(initialDataRef.current)));
            if (cancelled) return;
            setReadyPlugins(resolvedPlugins);
        }
        load();
        return ()=>{
            cancelled = true;
        };
    }, [
        plugins
    ]);
    const formData = (0, $8v0nu.useMemo)(()=>{
        if (!readyPlugins) return;
        const emptyStructure = readyPlugins.reduce((acc, pl)=>{
            const schema = pl.editSchema();
            if (!schema || typeof schema === 'symbol') return acc;
            return (0, $dbc7df56edeb0963$export$2e2bcd8739ae039)((0, $c1e8126e9c607e51$export$bb0693b91fc28141)(schema), acc);
        }, {});
        return readyPlugins.reduce((acc, pl)=>(0, $dbc7df56edeb0963$export$2e2bcd8739ae039)(pl.enterData(data), acc), emptyStructure);
    }, [
        readyPlugins,
        data
    ]);
    const toOutData = (0, $8v0nu.useCallback)((formData)=>readyPlugins && readyPlugins.reduce((acc, pl)=>({
                ...acc,
                ...pl.exitData(formData)
            }), {}), [
        readyPlugins
    ]);
    if (!readyPlugins) return {
        isLoading: true,
        plugins: undefined,
        formData: undefined,
        /* eslint-disable-next-line @typescript-eslint/no-unused-vars */ toOutData: (formData)=>undefined
    };
    return {
        isLoading: false,
        plugins: readyPlugins,
        formData: formData,
        toOutData: toOutData
    };
};
function $4509732b37c182a7$export$43d14ac0efc7a321(data) {
    const config = (0, $c14d6b556e5e27a6$export$bb6ca6e2ef1fe760)();
    return $4509732b37c182a7$var$usePlugins(config.collectionPlugins, data);
}
function $4509732b37c182a7$export$cd20375f87d4c554(data) {
    const config = (0, $c14d6b556e5e27a6$export$bb6ca6e2ef1fe760)();
    return $4509732b37c182a7$var$usePlugins(config.itemPlugins, data);
}



var $8v0nu = parcelRequire("8v0nu");



function $a43fa2f2fffac74f$export$bac6ca00840ef02b(props) {
    const { pointer: pointer, field: field, isRequired: isRequired } = props;
    const config = (0, $c14d6b556e5e27a6$export$bb6ca6e2ef1fe760)();
    const renderWidget = (widget)=>{
        const Widget = config['ui:widget'][widget];
        return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)($a43fa2f2fffac74f$var$WidgetErrorBoundary, {
            field: field,
            widgetName: widget,
            pointer: pointer,
            children: Widget ? /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)(Widget, {
                pointer: pointer,
                field: field,
                isRequired: isRequired
            }) : /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $f49fc02b2c636efe$export$f04a3ea04edc0e04), {
                children: [
                    'Widget "',
                    widget,
                    '" not found'
                ]
            })
        });
    };
    // Explicitly defined widget
    if (field['ui:widget']) return renderWidget(field['ui:widget']);
    if (field.type === 'array') {
        if (field.items.type === 'string' && field.items.enum) return renderWidget('checkbox');
        if ([
            'string',
            'number'
        ].includes(field.items.type)) return renderWidget('array:string');
        return renderWidget('array');
    }
    if (field.type === 'root' || field.type === 'object') return renderWidget('object');
    if (field.type === 'string' && field.enum) return renderWidget('radio');
    if (field.type === 'json') return renderWidget('json');
    if (field.type === 'number') return renderWidget('number');
    return renderWidget('text');
}
class $a43fa2f2fffac74f$var$WidgetErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($8v0nu))).Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    render() {
        if (this.state.error) return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $f49fc02b2c636efe$export$f04a3ea04edc0e04), {
            color: "base.500",
            alignItems: "left",
            p: 4,
            children: [
                /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $9318c0c5b8c25a88$export$5f1af8db9871e1d6), {
                    textTransform: "uppercase",
                    color: "red.500",
                    children: [
                        "\uD83D\uDC94 Error rendering widget (",
                        this.props.widgetName,
                        ")"
                    ]
                }),
                /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9318c0c5b8c25a88$export$5f1af8db9871e1d6), {
                    children: this.state.error.message || 'Something is wrong with this widget'
                }),
                /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $1415810625b263eb$export$e71c4d32a2263218), {
                    as: "pre",
                    bg: "base.100",
                    borderRadius: "md",
                    p: 2,
                    fontSize: "small",
                    maxH: 64,
                    overflow: "auto",
                    children: [
                        "@.",
                        this.props.pointer,
                        " ",
                        /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)("br", {}),
                        /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)("code", {
                            children: JSON.stringify(this.props.field, null, 2)
                        })
                    ]
                })
            ]
        });
        return this.props.children;
    }
}




var $8v0nu = parcelRequire("8v0nu");



"use strict";
"use client";
const $6ef2bd114974330d$export$69b1032f2ecdf404 = (0, $8v0nu.forwardRef)(function ButtonGroup2(props, ref) {
    const recipe = (0, $971213434541a23d$export$cf0e09a7086104ff)({
        key: "button"
    });
    const [variantProps, otherProps] = (0, $8v0nu.useMemo)(()=>recipe.splitVariantProps(props), [
        props,
        recipe
    ]);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $a987639d7be6b91e$export$1e26e075ed062b9a), {
        value: variantProps,
        children: /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $8ce9521b7a4b2ead$export$eb2fcfdbd7ba97d4), {
            ref: ref,
            ...otherProps
        })
    });
});
$6ef2bd114974330d$export$69b1032f2ecdf404.displayName = "ButtonGroup";



var $jTKGQ = parcelRequire("jTKGQ");


var $8v0nu = parcelRequire("8v0nu");
var $5e0ca4edd90668b0$exports = {};

$parcel$export($5e0ca4edd90668b0$exports, "ErrorIcon", function () { return $67b87129845a99b9$export$bda0d075e0e342c9; });
$parcel$export($5e0ca4edd90668b0$exports, "ErrorText", function () { return $67b87129845a99b9$export$71fe3e2630a403d6; });
$parcel$export($5e0ca4edd90668b0$exports, "HelperText", function () { return $67b87129845a99b9$export$ce9510a731ecfe22; });
$parcel$export($5e0ca4edd90668b0$exports, "Label", function () { return $67b87129845a99b9$export$1acdcf5a973a8414; });
$parcel$export($5e0ca4edd90668b0$exports, "PropsProvider", function () { return $67b87129845a99b9$export$2df495b48b6383af; });
$parcel$export($5e0ca4edd90668b0$exports, "RequiredIndicator", function () { return $67b87129845a99b9$export$9c2e1d1b54e4a192; });
$parcel$export($5e0ca4edd90668b0$exports, "Root", function () { return $67b87129845a99b9$export$7c6bb459c5438342; });
$parcel$export($5e0ca4edd90668b0$exports, "Context", function () { return $77a51379c83d21b4$export$f630cb8464d0f36; });
$parcel$export($5e0ca4edd90668b0$exports, "Item", function () { return $6ae406ff2fd72a14$export$d0a9fb76f948d598; });



var $8v0nu = parcelRequire("8v0nu");





var $8v0nu = parcelRequire("8v0nu");

"use strict";
"use client";
function $078ae894fb278fde$export$274edc73af1ae9c8(options) {
    const { viewBox: viewBox = "0 0 24 24", d: pathDefinition, displayName: displayName, defaultProps: defaultProps = {} } = options;
    const path = (0, $8v0nu.Children).toArray(options.path);
    const Comp = (0, $8v0nu.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $bd1cd963a7426b0d$export$f04a61298a47a40f), {
            ref: ref,
            asChild: false,
            viewBox: viewBox,
            ...defaultProps,
            ...props,
            children: path.length ? path : /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)("path", {
                fill: "currentColor",
                d: pathDefinition
            })
        }));
    Comp.displayName = displayName;
    return Comp;
}


"use strict";
"use client";
const { withProvider: $67b87129845a99b9$var$withProvider, withContext: $67b87129845a99b9$var$withContext, useStyles: $67b87129845a99b9$export$1a8d8f7f99fc7d5b, useClassNames: $67b87129845a99b9$var$useClassNames, PropsProvider: $67b87129845a99b9$var$PropsProvider } = (0, $04636a451c2392c0$export$ac7f79c9443925b8)({
    key: "field"
});
const $67b87129845a99b9$export$7c6bb459c5438342 = $67b87129845a99b9$var$withProvider((0, $61e790c8e9adb68c$export$583ec68827c6c3b1).Root, "root", {
    forwardAsChild: true
});
const $67b87129845a99b9$export$2df495b48b6383af = $67b87129845a99b9$var$PropsProvider;
const $67b87129845a99b9$export$1acdcf5a973a8414 = $67b87129845a99b9$var$withContext((0, $61e790c8e9adb68c$export$583ec68827c6c3b1).Label, "label", {
    forwardAsChild: true
});
const $67b87129845a99b9$export$ce9510a731ecfe22 = $67b87129845a99b9$var$withContext((0, $61e790c8e9adb68c$export$583ec68827c6c3b1).HelperText, "helperText", {
    forwardAsChild: true
});
const $67b87129845a99b9$export$71fe3e2630a403d6 = $67b87129845a99b9$var$withContext((0, $61e790c8e9adb68c$export$583ec68827c6c3b1).ErrorText, "errorText", {
    forwardAsChild: true
});
const $67b87129845a99b9$export$bda0d075e0e342c9 = (0, $078ae894fb278fde$export$274edc73af1ae9c8)({
    d: "M11.983,0a12.206,12.206,0,0,0-8.51,3.653A11.8,11.8,0,0,0,0,12.207,11.779,11.779,0,0,0,11.8,24h.214A12.111,12.111,0,0,0,24,11.791h0A11.766,11.766,0,0,0,11.983,0ZM10.5,16.542a1.476,1.476,0,0,1,1.449-1.53h.027a1.527,1.527,0,0,1,1.523,1.47,1.475,1.475,0,0,1-1.449,1.53h-.027A1.529,1.529,0,0,1,10.5,16.542ZM11,12.5v-6a1,1,0,0,1,2,0v6a1,1,0,1,1-2,0Z",
    defaultProps: {
        boxSize: "1em"
    }
});
const $67b87129845a99b9$export$9c2e1d1b54e4a192 = (0, $8v0nu.forwardRef)(function RequiredIndicator(props, ref) {
    const { fallback: fallback, children: children = "*", ...restProps } = props;
    const field = (0, $df31a980f7a28a5b$export$d02e393030f1ec84)();
    const classNames = $67b87129845a99b9$var$useClassNames();
    const styles = $67b87129845a99b9$export$1a8d8f7f99fc7d5b();
    if (!field?.required) return fallback;
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $4042601bfa1a9d25$export$7cd122d781af9fa4).span, {
        ref: ref,
        "aria-hidden": "true",
        ...restProps,
        className: (0, $99474b193e949655$export$a274e22fb40f762e)(classNames.requiredIndicator, props.className),
        css: [
            styles.requiredIndicator,
            props.css
        ],
        children: children
    });
});



"use strict";



var $jTKGQ = parcelRequire("jTKGQ");


parcelRequire("8v0nu");


function $8f2967926209c75b$export$e154be390aa0e14(props) {
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
        as: "fieldset",
        flexDirection: "column",
        gap: 8,
        p: 4,
        bg: "base.50a",
        borderRadius: "md",
        ...props
    });
}
function $8f2967926209c75b$export$4177b95adc81bedf(props) {
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
        justifyContent: "space-between",
        gap: 4,
        ...props
    });
}
function $8f2967926209c75b$export$47bfc31835db02f5(props) {
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
        flexDirection: "column",
        gap: 4,
        ...props
    });
}
function $8f2967926209c75b$export$849069c87286ea39(props) {
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
        gap: 4,
        ...props
    });
}
function $8f2967926209c75b$export$1acdcf5a973a8414(props) {
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $5dcf33ee745c0ffc$export$a8a3e93435678ff9), {
        as: "span",
        size: "sm",
        display: "inline-flex",
        alignItems: "center",
        gap: 2,
        ...props,
        css: {
            '& small': {
                borderRadius: 'sm',
                bg: 'base.400a',
                color: 'surface.500',
                px: '0.5rem',
                fontSize: 'xs'
            }
        }
    });
}
function $8f2967926209c75b$export$90c6246c969554fc(props) {
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $756da344c07e2b07$export$c25acd513dcc8062), {
        colorPalette: "base",
        variant: "soft-outline",
        size: "xs",
        ...props
    });
}
function $8f2967926209c75b$export$4520a427b44f3477(props) {
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)($8f2967926209c75b$export$90c6246c969554fc, {
        size: "sm",
        "aria-label": "Delete",
        ...props,
        children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9138db1f951ed55c$export$5918e8962b6636e9), {})
    });
}
function $8f2967926209c75b$export$528341e82434bd(props) {
    const { label: label, isRequired: isRequired, children: children, onRemove: onRemove, onAdd: onAdd, addDisabled: addDisabled, removeDisabled: removeDisabled } = props;
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)($8f2967926209c75b$export$e154be390aa0e14, {
        className: "widget--array",
        children: [
            (label || onRemove) && /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)($8f2967926209c75b$export$4177b95adc81bedf, {
                children: [
                    label && /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $1415810625b263eb$export$e71c4d32a2263218), {
                        children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)($8f2967926209c75b$export$1acdcf5a973a8414, {
                            children: [
                                label,
                                isRequired && /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9318c0c5b8c25a88$export$5f1af8db9871e1d6), {
                                    as: "span",
                                    color: "danger.500",
                                    role: "presentation",
                                    "aria-hidden": "true",
                                    children: "*"
                                })
                            ]
                        })
                    }),
                    onRemove && /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $1415810625b263eb$export$e71c4d32a2263218), {
                        children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)($8f2967926209c75b$export$4520a427b44f3477, {
                            onClick: onRemove,
                            disabled: removeDisabled,
                            "aria-label": "Remove item"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)($8f2967926209c75b$export$47bfc31835db02f5, {
                children: children
            }),
            onAdd && /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)($8f2967926209c75b$export$849069c87286ea39, {
                children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $a987639d7be6b91e$export$353f5b6fc5456de1), {
                    colorPalette: "base",
                    size: "sm",
                    onClick: onAdd,
                    "aria-label": "Add item",
                    disabled: addDisabled,
                    children: [
                        /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9138db1f951ed55c$export$3a9f56a1d1f9a714), {}),
                        "Add another"
                    ]
                })
            })
        ]
    });
}



parcelRequire("8v0nu");

const $7dfa35a587ad2e70$export$302c944b8da23f96 = (0, $9138db1f951ed55c$export$7209ba2b0568490)((props)=>/*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $ef524fb144c5d632$exports.Fragment), {
        children: [
            props.title && /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)("title", {
                children: props.title
            }),
            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)("path", {
                d: "M 0,32 v 64 h 416 v -64 z M 160,160 v 64 h 352 v -64 z M 160,288 v 64 h 288 v -64 z M 0,416 v 64 h 320 v -64 z"
            })
        ]
    }), {
    viewBox: '0 0 512 512'
});




var $8v0nu = parcelRequire("8v0nu");

var $e0f5559cedeb4c29$exports = {};
/*!
 * jsoneditor.js
 *
 * @brief
 * JSONEditor is a web-based tool to view, edit, format, and validate JSON.
 * It has various modes such as a tree editor, a code editor, and a plain text
 * editor.
 *
 * Supported browsers: Chrome, Firefox, Safari, Edge
 *
 * @license
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not
 * use this file except in compliance with the License. You may obtain a copy
 * of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions and limitations under
 * the License.
 *
 * Copyright (c) 2011-2026 Jos de Jong, http://jsoneditoronline.org
 *
 * @author  Jos de Jong, <wjosdejong@gmail.com>
 * @version 10.4.3
 * @date    2026-04-01
 */ ((e, t)=>{
    $e0f5559cedeb4c29$exports = t();
})(self, function() {
    var i, o;
    return i = {
        6545: function(e, t, i) {
            i.d(t, {
                t: function() {
                    return r;
                }
            });
            var c = i(1925), h = i(6237), d = i(3057);
            function o(e) {
                return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                })(e);
            }
            function n(e, t) {
                for(var i = 0; i < t.length; i++){
                    var n = t[i];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, ((e)=>(e = ((e, t)=>{
                            if ("object" != o(e) || !e) return e;
                            var i = e[Symbol.toPrimitive];
                            if (void 0 === i) return ("string" === t ? String : Number)(e);
                            if ("object" != o(i = i.call(e, t || "default"))) return i;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        })(e, "string"), "symbol" == o(e) ? e : e + ""))(n.key), n);
                }
            }
            var r = (()=>{
                function l(t, e) {
                    if (!(this instanceof l)) throw new TypeError("Cannot call a class as a function");
                    this.dom = {};
                    var h = this, i = this.dom, e = (this.anchor = void 0, this.items = t, this.eventListeners = {}, this.selection = void 0, this.onClose = e ? e.close : void 0, this.limitHeight = !!e && e.limitHeight, document.createElement("div")), n = (e.className = "jsoneditor-contextmenu-root", i.root = e, document.createElement("div")), e = (n.className = "jsoneditor-contextmenu", i.menu = n, e.appendChild(n), document.createElement("ul")), n = (e.className = "jsoneditor-menu", n.appendChild(e), i.list = e, i.items = [], document.createElement("button")), i = (n.type = "button", i.focusButton = n, document.createElement("li"));
                    i.style.overflow = "hidden", i.style.height = "0", i.appendChild(n), e.appendChild(i), function a(l, c, e) {
                        e.forEach(function(t) {
                            var i, e, n, o, r, s;
                            "separator" === t.type ? ((r = document.createElement("div")).className = "jsoneditor-separator", (e = document.createElement("li")).appendChild(r), l.appendChild(e)) : (i = {}, r = document.createElement("li"), l.appendChild(r), (e = document.createElement("button")).type = "button", e.className = t.className, i.button = e, t.title && (e.title = t.title), t.click && (e.onclick = function(e) {
                                e.preventDefault(), h.hide(), t.click();
                            }), r.appendChild(e), t.submenu ? ((o = document.createElement("div")).className = "jsoneditor-icon", e.appendChild(o), (o = document.createElement("div")).className = "jsoneditor-text" + (t.click ? "" : " jsoneditor-right-margin"), o.appendChild(document.createTextNode(t.text)), e.appendChild(o), (n = t.click ? (e.className += " jsoneditor-default", (o = document.createElement("button")).type = "button", (i.buttonExpand = o).className = "jsoneditor-expand", (s = document.createElement("div")).className = "jsoneditor-expand", o.appendChild(s), r.appendChild(o), t.submenuTitle && (o.title = t.submenuTitle), o) : ((s = document.createElement("div")).className = "jsoneditor-expand", e.appendChild(s), e)).onclick = function(e) {
                                e.preventDefault(), h._onExpandItem(i), n.focus();
                            }, i.subItems = o = [], s = document.createElement("ul"), (i.ul = s).className = "jsoneditor-menu", s.style.height = "0", r.appendChild(s), a(s, o, t.submenu)) : ((r = document.createElement("div")).className = "jsoneditor-icon", e.appendChild(r), (s = document.createElement("div")).className = "jsoneditor-text", s.appendChild(document.createTextNode((0, d.Tl)(t.text))), e.appendChild(s)), c.push(i));
                        });
                    }(e, this.dom.items, t), this.maxHeight = 0, t.forEach(function(e) {
                        e = 24 * (t.length + (e.submenu ? e.submenu.length : 0));
                        h.maxHeight = Math.max(h.maxHeight, e);
                    });
                }
                var e, t, i;
                return e = l, t = [
                    {
                        key: "_getVisibleButtons",
                        value: function() {
                            var t = [], i = this;
                            return this.dom.items.forEach(function(e) {
                                t.push(e.button), e.buttonExpand && t.push(e.buttonExpand), e.subItems && e === i.expandedItem && e.subItems.forEach(function(e) {
                                    t.push(e.button), e.buttonExpand && t.push(e.buttonExpand);
                                });
                            }), t;
                        }
                    },
                    {
                        key: "show",
                        value: function(e, t, i) {
                            this.hide();
                            var n = !0, o = e.parentNode, r = e.getBoundingClientRect(), o = o.getBoundingClientRect(), s = t.getBoundingClientRect(), a = this, t = (this.dom.absoluteAnchor = (0, c.p)(e, t, function() {
                                a.hide();
                            }), r.bottom + this.maxHeight < s.bottom || r.top - this.maxHeight > s.top && (n = !1), i ? 0 : r.top - o.top);
                            n ? (i = e.offsetHeight, this.dom.menu.style.left = "0", this.dom.menu.style.top = t + i + "px", this.dom.menu.style.bottom = "") : (this.dom.menu.style.left = "0", this.dom.menu.style.top = "", this.dom.menu.style.bottom = "0px"), this.limitHeight && (o = n ? s.bottom - r.bottom - 10 : r.top - s.top - 10, this.dom.list.style.maxHeight = o + "px", this.dom.list.style.overflowY = "auto"), this.dom.absoluteAnchor.appendChild(this.dom.root), this.selection = (0, h.getSelection)(), this.anchor = e, setTimeout(function() {
                                a.dom.focusButton.focus();
                            }, 0), l.visibleMenu && l.visibleMenu.hide(), l.visibleMenu = this;
                        }
                    },
                    {
                        key: "hide",
                        value: function() {
                            this.dom.absoluteAnchor && (this.dom.absoluteAnchor.destroy(), delete this.dom.absoluteAnchor), this.dom.root.parentNode && (this.dom.root.parentNode.removeChild(this.dom.root), this.onClose) && this.onClose(), l.visibleMenu === this && (l.visibleMenu = void 0);
                        }
                    },
                    {
                        key: "_onExpandItem",
                        value: function(i) {
                            var n, o = this, e = i === this.expandedItem, t = this.expandedItem;
                            t && (t.ul.style.height = "0", t.ul.style.padding = "", setTimeout(function() {
                                o.expandedItem !== t && (t.ul.style.display = "", h.removeClassName)(t.ul.parentNode, "jsoneditor-selected");
                            }, 300), this.expandedItem = void 0), e || ((n = i.ul).style.display = "block", setTimeout(function() {
                                if (o.expandedItem === i) {
                                    for(var e = 0, t = 0; t < n.childNodes.length; t++)e += n.childNodes[t].clientHeight;
                                    n.style.height = e + "px", n.style.padding = "5px 10px";
                                }
                            }, 0), (0, h.addClassName)(n.parentNode, "jsoneditor-selected"), this.expandedItem = i);
                        }
                    },
                    {
                        key: "_onKeyDown",
                        value: function(e) {
                            var t, i, n, o, r = e.target, s = e.which, a = !1;
                            27 === s ? (this.selection && (0, h.setSelection)(this.selection), this.anchor && this.anchor.focus(), this.hide(), a = !0) : 9 === s ? e.shiftKey ? 0 === (i = (t = this._getVisibleButtons()).indexOf(r)) && (t[t.length - 1].focus(), a = !0) : (i = (t = this._getVisibleButtons()).indexOf(r)) === t.length - 1 && (t[0].focus(), a = !0) : 37 === s ? ("jsoneditor-expand" === r.className && (i = (t = this._getVisibleButtons()).indexOf(r), n = t[i - 1]) && n.focus(), a = !0) : 38 === s ? (i = (t = this._getVisibleButtons()).indexOf(r), (n = (n = (n = t[i - 1]) && "jsoneditor-expand" === n.className ? t[i - 2] : n) || t[t.length - 1]) && n.focus(), a = !0) : 39 === s ? (i = (t = this._getVisibleButtons()).indexOf(r), (o = t[i + 1]) && "jsoneditor-expand" === o.className && o.focus(), a = !0) : 40 === s && (i = (t = this._getVisibleButtons()).indexOf(r), (o = (o = (o = t[i + 1]) && "jsoneditor-expand" === o.className ? t[i + 2] : o) || t[0]) && (o.focus(), a = !0), a = !0), a && (e.stopPropagation(), e.preventDefault());
                        }
                    }
                ], n(e.prototype, t), i && n(e, i), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), e;
            })();
            r.visibleMenu = void 0;
        },
        2115: function(e, t, i) {
            function o(e) {
                return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                })(e);
            }
            function r(e, t) {
                for(var i = 0; i < t.length; i++){
                    var n = t[i];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, ((e)=>(e = ((e, t)=>{
                            if ("object" != o(e) || !e) return e;
                            var i = e[Symbol.toPrimitive];
                            if (void 0 === i) return ("string" === t ? String : Number)(e);
                            if ("object" != o(i = i.call(e, t || "default"))) return i;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        })(e, "string"), "symbol" == o(e) ? e : e + ""))(n.key), n);
                }
            }
            i.d(t, {
                N: function() {
                    return n;
                }
            });
            var n = (()=>{
                function i(e) {
                    if (!(this instanceof i)) throw new TypeError("Cannot call a class as a function");
                    this.errorTableVisible = e.errorTableVisible, this.onToggleVisibility = e.onToggleVisibility, this.onFocusLine = e.onFocusLine || function() {}, this.onChangeHeight = e.onChangeHeight, this.dom = {};
                    var e = document.createElement("div"), t = (e.className = "jsoneditor-validation-errors-container", this.dom.validationErrorsContainer = e, document.createElement("div")), e = (t.style.display = "none", t.className = "jsoneditor-additional-errors fadein", t.textContent = "Scroll for more \u25BF", this.dom.additionalErrorsIndication = t, e.appendChild(t), document.createElement("span")), t = (e.className = "jsoneditor-validation-error-icon", e.style.display = "none", this.dom.validationErrorIcon = e, document.createElement("span"));
                    t.className = "jsoneditor-validation-error-count", t.style.display = "none", this.dom.validationErrorCount = t, this.dom.parseErrorIndication = document.createElement("span"), this.dom.parseErrorIndication.className = "jsoneditor-parse-error-icon", this.dom.parseErrorIndication.style.display = "none";
                }
                var e, t, n;
                return e = i, t = [
                    {
                        key: "getErrorTable",
                        value: function() {
                            return this.dom.validationErrorsContainer;
                        }
                    },
                    {
                        key: "getErrorCounter",
                        value: function() {
                            return this.dom.validationErrorCount;
                        }
                    },
                    {
                        key: "getWarningIcon",
                        value: function() {
                            return this.dom.validationErrorIcon;
                        }
                    },
                    {
                        key: "getErrorIcon",
                        value: function() {
                            return this.dom.parseErrorIndication;
                        }
                    },
                    {
                        key: "toggleTableVisibility",
                        value: function() {
                            this.errorTableVisible = !this.errorTableVisible, this.onToggleVisibility(this.errorTableVisible);
                        }
                    },
                    {
                        key: "setErrors",
                        value: function(e, r) {
                            var s, t, a = this, i = (this.dom.validationErrors && (this.dom.validationErrors.parentNode.removeChild(this.dom.validationErrors), this.dom.validationErrors = null, this.dom.additionalErrorsIndication.style.display = "none"), this.errorTableVisible && 0 < e.length ? ((i = document.createElement("div")).className = "jsoneditor-validation-errors", (t = document.createElement("table")).className = "jsoneditor-text-errors", i.appendChild(t), s = document.createElement("tbody"), t.appendChild(s), e.forEach(function(t) {
                                isNaN(t.line) ? t.dataPath && (i = r.find(function(e) {
                                    return e.path === t.dataPath;
                                })) && (e = i.line + 1) : e = t.line;
                                var e, i = document.createElement("tr"), n = (i.className = isNaN(e) ? "" : "jump-to-line", "error" === t.type ? i.className += " parse-error" : i.className += " validation-error", document.createElement("td")), o = document.createElement("button"), o = (o.className = "jsoneditor-schema-error", n.appendChild(o), i.appendChild(n), document.createElement("td"));
                                o.style = "white-space: nowrap;", o.textContent = isNaN(e) ? "" : "Ln " + e, i.appendChild(o), "string" == typeof t ? ((n = document.createElement("td")).colSpan = 2, (o = document.createElement("pre")).appendChild(document.createTextNode(t)), n.appendChild(o), i.appendChild(n)) : ((o = document.createElement("td")).appendChild(document.createTextNode(t.dataPath || "")), i.appendChild(o), n = document.createElement("td"), (o = document.createElement("pre")).appendChild(document.createTextNode(t.message.replace(/<br>/gi, "\n"))), n.appendChild(o), i.appendChild(n)), i.onclick = function() {
                                    a.onFocusLine(e);
                                }, s.appendChild(i);
                            }), this.dom.validationErrors = i, this.dom.validationErrorsContainer.appendChild(i), this.dom.additionalErrorsIndication.title = e.length + " errors total", this.dom.validationErrorsContainer.clientHeight < this.dom.validationErrorsContainer.scrollHeight ? (this.dom.additionalErrorsIndication.style.display = "block", this.dom.validationErrorsContainer.onscroll = function() {
                                a.dom.additionalErrorsIndication.style.display = 0 < a.dom.validationErrorsContainer.clientHeight && 0 === a.dom.validationErrorsContainer.scrollTop ? "block" : "none";
                            }) : this.dom.validationErrorsContainer.onscroll = void 0, t = this.dom.validationErrorsContainer.clientHeight + (this.dom.statusBar ? this.dom.statusBar.clientHeight : 0), this.onChangeHeight(t)) : this.onChangeHeight(0), e.filter(function(e) {
                                return "error" !== e.type;
                            }).length);
                            0 < i ? (this.dom.validationErrorCount.style.display = "inline", this.dom.validationErrorCount.innerText = i, this.dom.validationErrorCount.onclick = this.toggleTableVisibility.bind(this), this.dom.validationErrorIcon.style.display = "inline", this.dom.validationErrorIcon.title = i + " schema validation error(s) found", this.dom.validationErrorIcon.onclick = this.toggleTableVisibility.bind(this)) : (this.dom.validationErrorCount.style.display = "none", this.dom.validationErrorIcon.style.display = "none"), e.some(function(e) {
                                return "error" === e.type;
                            }) ? (t = e[0].line, this.dom.parseErrorIndication.style.display = "block", this.dom.parseErrorIndication.title = isNaN(t) ? "parse error - check that the json is valid" : "parse error on line " + t, this.dom.parseErrorIndication.onclick = this.toggleTableVisibility.bind(this)) : this.dom.parseErrorIndication.style.display = "none";
                        }
                    }
                ], r(e.prototype, t), n && r(e, n), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), e;
            })();
        },
        2877: function(e, t, i) {
            function o(e) {
                return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                })(e);
            }
            function r(e, t) {
                for(var i = 0; i < t.length; i++){
                    var n = t[i];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, ((e)=>(e = ((e, t)=>{
                            if ("object" != o(e) || !e) return e;
                            var i = e[Symbol.toPrimitive];
                            if (void 0 === i) return ("string" === t ? String : Number)(e);
                            if ("object" != o(i = i.call(e, t || "default"))) return i;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        })(e, "string"), "symbol" == o(e) ? e : e + ""))(n.key), n);
                }
            }
            i.d(t, {
                $: function() {
                    return n;
                }
            });
            var n = (()=>{
                function t(e) {
                    if (!(this instanceof t)) throw new TypeError("Cannot call a class as a function");
                    if (this.target = e.target || null, !this.target) throw new Error('FocusTracker constructor called without a "target" to track.');
                    this.onFocus = "function" == typeof e.onFocus ? e.onFocus : null, this.onBlur = "function" == typeof e.onBlur ? e.onBlur : null, this._onClick = this._onEvent.bind(this), this._onKeyUp = (function(e) {
                        9 !== e.which && 9 !== e.keyCode || this._onEvent(e);
                    }).bind(this), this._onBlur = this._onEvent.bind(this), this.focusFlag = !1, this.firstEventFlag = !0, (this.onFocus || this.onBlur) && (document.addEventListener("click", this._onClick), document.addEventListener("keyup", this._onKeyUp), document.addEventListener("blur", this._onBlur));
                }
                var e, i, n;
                return e = t, i = [
                    {
                        key: "destroy",
                        value: function() {
                            document.removeEventListener("click", this._onClick), document.removeEventListener("keyup", this._onKeyUp), document.removeEventListener("blur", this._onBlur), this._onEvent({
                                target: document.body
                            });
                        }
                    },
                    {
                        key: "_onEvent",
                        value: function(e) {
                            e = e.target, e = e === this.target || !(!this.target.contains(e) && !this.target.contains(document.activeElement));
                            e ? this.focusFlag || (this.onFocus && this.onFocus({
                                type: "focus",
                                target: this.target
                            }), this.focusFlag = !0) : (this.focusFlag || this.firstEventFlag) && (this.onBlur && this.onBlur({
                                type: "blur",
                                target: this.target
                            }), this.focusFlag = !1, this.firstEventFlag) && (this.firstEventFlag = !1);
                        }
                    }
                ], r(e.prototype, i), n && r(e, n), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), e;
            })();
        },
        1346: function(e, t, o) {
            var i = o(7413), n = o(1746), r = o(5633).treeModeMixins, s = o(1948).textModeMixins, a = o(7483).previewModeMixins, l = o(6237), c = l.clear, h = l.extend, d = l.getInnerText, u = l.getInternetExplorerVersion, g = l.parse, l = o(2870).tryRequireAjv, p = o(5609).showTransformModal, m = o(2915).showSortModal, f = l();
            function C(e, t, i) {
                if (!(this instanceof C)) throw new Error('JSONEditor constructor called without "new".');
                var n = u();
                if (-1 !== n && n < 9) throw new Error("Unsupported browser, IE9 or newer required. Please install the newest version of your browser.");
                t && (t.error && (console.warn('Option "error" has been renamed to "onError"'), t.onError = t.error, delete t.error), t.change && (console.warn('Option "change" has been renamed to "onChange"'), t.onChange = t.change, delete t.change), t.editable && (console.warn('Option "editable" has been renamed to "onEditable"'), t.onEditable = t.editable, delete t.editable), t.onChangeJSON && ("text" === t.mode || "code" === t.mode || t.modes && (-1 !== t.modes.indexOf("text") || -1 !== t.modes.indexOf("code"))) && console.warn('Option "onChangeJSON" is not applicable to modes "text" and "code". Use "onChangeText" or "onChange" instead.'), t) && Object.keys(t).forEach(function(e) {
                    -1 === C.VALID_OPTIONS.indexOf(e) && console.warn('Unknown option "' + e + '". This option will be ignored');
                }), arguments.length && this._create(e, t, i);
            }
            "undefined" == typeof Promise && console.error("Promise undefined. Please load a Promise polyfill in the browser in order to use JSONEditor"), C.modes = {}, C.prototype.DEBOUNCE_INTERVAL = 150, C.VALID_OPTIONS = [
                "ajv",
                "schema",
                "schemaRefs",
                "templates",
                "ace",
                "theme",
                "autocomplete",
                "onChange",
                "onChangeJSON",
                "onChangeText",
                "onExpand",
                "onEditable",
                "onError",
                "onEvent",
                "onModeChange",
                "onNodeName",
                "onValidate",
                "onCreateMenu",
                "onSelectionChange",
                "onTextSelectionChange",
                "onClassName",
                "onFocus",
                "onBlur",
                "colorPicker",
                "onColorPicker",
                "timestampTag",
                "timestampFormat",
                "escapeUnicode",
                "history",
                "search",
                "mode",
                "modes",
                "name",
                "indentation",
                "sortObjectKeys",
                "navigationBar",
                "statusBar",
                "mainMenuBar",
                "languages",
                "language",
                "enableSort",
                "enableTransform",
                "limitDragging",
                "maxVisibleChilds",
                "onValidationError",
                "modalAnchor",
                "popupAnchor",
                "createQuery",
                "executeQuery",
                "queryDescription",
                "allowSchemaSuggestions",
                "showErrorTable"
            ], C.prototype._create = function(e, t, i) {
                this.container = e, this.options = t || {}, this.json = i || {};
                e = this.options.mode || this.options.modes && this.options.modes[0] || "tree";
                this.setMode(e);
            }, C.prototype.destroy = function() {}, C.prototype.set = function(e) {
                this.json = e;
            }, C.prototype.get = function() {
                return this.json;
            }, C.prototype.setText = function(e) {
                this.json = g(e);
            }, C.prototype.getText = function() {
                return JSON.stringify(this.json);
            }, C.prototype.setName = function(e) {
                this.options || (this.options = {}), this.options.name = e;
            }, C.prototype.getName = function() {
                return this.options && this.options.name;
            }, C.prototype.setMode = function(e) {
                if (e !== this.options.mode || !this.create) {
                    var t = this.container, i = h({}, this.options), n = i.mode, o = C.modes[i.mode = e];
                    if (!o) throw new Error('Unknown mode "' + i.mode + '"');
                    var r = "text" === o.data, s = this.getName(), a = this[r ? "getText" : "get"]();
                    if (this.destroy(), c(this), h(this, o.mixin), this.create(t, i), this.setName(s), this[r ? "setText" : "set"](a), "function" == typeof o.load) try {
                        o.load.call(this);
                    } catch (e) {
                        console.error(e);
                    }
                    if ("function" == typeof i.onModeChange && e !== n) try {
                        i.onModeChange(e, n);
                    } catch (e) {
                        console.error(e);
                    }
                }
            }, C.prototype.getMode = function() {
                return this.options.mode;
            }, C.prototype._onError = function(e) {
                this.options && "function" == typeof this.options.onError ? this.options.onError(e) : window.alert(e.toString());
            }, C.prototype.setSchema = function(e, t) {
                if (e) {
                    var i;
                    try {
                        this.options.ajv ? i = this.options.ajv : ((i = f({
                            allErrors: !0,
                            verbose: !0,
                            schemaId: "auto",
                            $data: !0
                        })).addMetaSchema(o(5207)), i.addMetaSchema(o(6801)));
                    } catch (e) {
                        console.warn("Failed to create an instance of Ajv, JSON Schema validation is not available. Please use a JSONEditor bundle including Ajv, or pass an instance of Ajv as via the configuration option `ajv`.");
                    }
                    if (i) {
                        if (t) {
                            for(var n in t)i.removeSchema(n), t[n] && i.addSchema(t[n], n);
                            this.options.schemaRefs = t;
                        }
                        this.validateSchema = i.compile(e), this.options.schema = e, this.options.schemaRefs = t, this.validate();
                    }
                } else this.validateSchema = null, this.options.schema = null, this.options.schemaRefs = null, this.validate();
                this.refresh(), "function" == typeof this._onSchemaChange && this._onSchemaChange(e, t);
            }, C.prototype.validate = function() {
                return Promise.resolve([]);
            }, C.prototype.refresh = function() {}, (C.registerMode = function(e) {
                var t;
                if (Array.isArray(e)) for(o = 0; o < e.length; o++)C.registerMode(e[o]);
                else {
                    if (!("mode" in e)) throw new Error('Property "mode" missing');
                    if (!("mixin" in e)) throw new Error('Property "mixin" missing');
                    if (!("data" in e)) throw new Error('Property "data" missing');
                    var i = e.mode;
                    if (i in C.modes) throw new Error('Mode "' + i + '" already registered');
                    if ("function" != typeof e.mixin.create) throw new Error('Required function "create" missing on mixin');
                    for(var n = [
                        "setMode",
                        "registerMode",
                        "modes"
                    ], o = 0; o < n.length; o++)if ((t = n[o]) in e.mixin) throw new Error('Reserved property "' + t + '" not allowed in mixin');
                    C.modes[i] = e;
                }
            })(r), C.registerMode(s), C.registerMode(a), C.ace = i, C.Ajv = f, C.VanillaPicker = n, C.showTransformModal = p, C.showSortModal = m, C.getInnerText = d, e.exports = C.default = C;
        },
        1389: function(e, t, i) {
            i.d(t, {
                n: function() {
                    return r;
                }
            });
            var u = i(6545), g = i(3057);
            function o(e) {
                return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                })(e);
            }
            function n(e, t) {
                for(var i = 0; i < t.length; i++){
                    var n = t[i];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, ((e)=>(e = ((e, t)=>{
                            if ("object" != o(e) || !e) return e;
                            var i = e[Symbol.toPrimitive];
                            if (void 0 === i) return ("string" === t ? String : Number)(e);
                            if ("object" != o(i = i.call(e, t || "default"))) return i;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        })(e, "string"), "symbol" == o(e) ? e : e + ""))(n.key), n);
                }
            }
            var r = (()=>{
                function d(e, t, i, n) {
                    if (!(this instanceof d)) throw new TypeError("Cannot call a class as a function");
                    for(var o = {
                        code: {
                            text: (0, g.Tl)("modeCodeText"),
                            title: (0, g.Tl)("modeCodeTitle"),
                            click: function() {
                                n("code");
                            }
                        },
                        form: {
                            text: (0, g.Tl)("modeFormText"),
                            title: (0, g.Tl)("modeFormTitle"),
                            click: function() {
                                n("form");
                            }
                        },
                        text: {
                            text: (0, g.Tl)("modeTextText"),
                            title: (0, g.Tl)("modeTextTitle"),
                            click: function() {
                                n("text");
                            }
                        },
                        tree: {
                            text: (0, g.Tl)("modeTreeText"),
                            title: (0, g.Tl)("modeTreeTitle"),
                            click: function() {
                                n("tree");
                            }
                        },
                        view: {
                            text: (0, g.Tl)("modeViewText"),
                            title: (0, g.Tl)("modeViewTitle"),
                            click: function() {
                                n("view");
                            }
                        },
                        preview: {
                            text: (0, g.Tl)("modePreviewText"),
                            title: (0, g.Tl)("modePreviewTitle"),
                            click: function() {
                                n("preview");
                            }
                        }
                    }, r = [], s = 0; s < t.length; s++){
                        var a = t[s], l = o[a];
                        if (!l) throw new Error('Unknown mode "' + a + '"');
                        l.className = "jsoneditor-type-modes" + (i === a ? " jsoneditor-selected" : ""), r.push(l);
                    }
                    var c = o[i];
                    if (!c) throw new Error('Unknown mode "' + i + '"');
                    var c = c.text, h = document.createElement("button"), c = (h.type = "button", h.className = "jsoneditor-modes jsoneditor-separator", h.textContent = c + " \u25BE", h.title = (0, g.Tl)("modeEditorTitle"), h.onclick = function() {
                        new u.t(r).show(h, e);
                    }, document.createElement("div"));
                    c.className = "jsoneditor-modes", c.style.position = "relative", c.appendChild(h), e.appendChild(c), this.dom = {
                        container: e,
                        box: h,
                        frame: c
                    };
                }
                var e, t, i;
                return e = d, t = [
                    {
                        key: "focus",
                        value: function() {
                            this.dom.box.focus();
                        }
                    },
                    {
                        key: "destroy",
                        value: function() {
                            this.dom && this.dom.frame && this.dom.frame.parentNode && this.dom.frame.parentNode.removeChild(this.dom.frame), this.dom = null;
                        }
                    }
                ], n(e.prototype, t), i && n(e, i), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), e;
            })();
        },
        7413: function(e, t, i) {
            var n;
            if (window.ace) n = window.ace;
            else try {
                n = i(6990), i(4221), i(6534), i(6489);
                var o = i(5477);
                n.config.setModuleUrl("ace/mode/json_worker", o);
            } catch (e) {}
            e.exports = n;
        },
        9762: function() {
            window.ace.define("ace/theme/jsoneditor", [
                "require",
                "exports",
                "module",
                "ace/lib/dom"
            ], function(e, t, i) {
                t.isDark = !1, t.cssClass = "ace-jsoneditor", t.cssText = '.ace-jsoneditor .ace_gutter {\nbackground: #ebebeb;\ncolor: #333\n}\n\n.ace-jsoneditor.ace_editor {\nline-height: 1.3;\nbackground-color: #fff;\n}\n.ace-jsoneditor .ace_print-margin {\nwidth: 1px;\nbackground: #e8e8e8\n}\n.ace-jsoneditor .ace_scroller {\nbackground-color: #FFFFFF\n}\n.ace-jsoneditor .ace_text-layer {\ncolor: gray\n}\n.ace-jsoneditor .ace_variable {\ncolor: #1a1a1a\n}\n.ace-jsoneditor .ace_cursor {\nborder-left: 2px solid #000000\n}\n.ace-jsoneditor .ace_overwrite-cursors .ace_cursor {\nborder-left: 0px;\nborder-bottom: 1px solid #000000\n}\n.ace-jsoneditor .ace_marker-layer .ace_selection {\nbackground: lightgray\n}\n.ace-jsoneditor.ace_multiselect .ace_selection.ace_start {\nbox-shadow: 0 0 3px 0px #FFFFFF;\nborder-radius: 2px\n}\n.ace-jsoneditor .ace_marker-layer .ace_step {\nbackground: rgb(255, 255, 0)\n}\n.ace-jsoneditor .ace_marker-layer .ace_bracket {\nmargin: -1px 0 0 -1px;\nborder: 1px solid #BFBFBF\n}\n.ace-jsoneditor .ace_marker-layer .ace_active-line {\nbackground: #FFFBD1\n}\n.ace-jsoneditor .ace_gutter-active-line {\nbackground-color : #dcdcdc\n}\n.ace-jsoneditor .ace_marker-layer .ace_selected-word {\nborder: 1px solid lightgray\n}\n.ace-jsoneditor .ace_invisible {\ncolor: #BFBFBF\n}\n.ace-jsoneditor .ace_keyword,\n.ace-jsoneditor .ace_meta,\n.ace-jsoneditor .ace_support.ace_constant.ace_property-value {\ncolor: #AF956F\n}\n.ace-jsoneditor .ace_keyword.ace_operator {\ncolor: #484848\n}\n.ace-jsoneditor .ace_keyword.ace_other.ace_unit {\ncolor: #96DC5F\n}\n.ace-jsoneditor .ace_constant.ace_language {\ncolor: darkorange\n}\n.ace-jsoneditor .ace_constant.ace_numeric {\ncolor: red\n}\n.ace-jsoneditor .ace_constant.ace_character.ace_entity {\ncolor: #BF78CC\n}\n.ace-jsoneditor .ace_invalid {\ncolor: #FFFFFF;\nbackground-color: #FF002A;\n}\n.ace-jsoneditor .ace_fold {\nbackground-color: #AF956F;\nborder-color: #000000\n}\n.ace-jsoneditor .ace_storage,\n.ace-jsoneditor .ace_support.ace_class,\n.ace-jsoneditor .ace_support.ace_function,\n.ace-jsoneditor .ace_support.ace_other,\n.ace-jsoneditor .ace_support.ace_type {\ncolor: #C52727\n}\n.ace-jsoneditor .ace_string {\ncolor: green\n}\n.ace-jsoneditor .ace_comment {\ncolor: #BCC8BA\n}\n.ace-jsoneditor .ace_entity.ace_name.ace_tag,\n.ace-jsoneditor .ace_entity.ace_other.ace_attribute-name {\ncolor: #606060\n}\n.ace-jsoneditor .ace_markup.ace_underline {\ntext-decoration: underline\n}\n.ace-jsoneditor .ace_indent-guide {\nbackground: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAAE0lEQVQImWP4////f4bLly//BwAmVgd1/w11/gAAAABJRU5ErkJggg==") right repeat-y\n}', e("../lib/dom").importCssString(t.cssText, t.cssClass);
            });
        },
        5736: function(e, t) {
            (i = {
                trace: function() {},
                yy: {},
                symbols_: {
                    error: 2,
                    JSONString: 3,
                    STRING: 4,
                    JSONNumber: 5,
                    NUMBER: 6,
                    JSONNullLiteral: 7,
                    NULL: 8,
                    JSONBooleanLiteral: 9,
                    TRUE: 10,
                    FALSE: 11,
                    JSONText: 12,
                    JSONValue: 13,
                    EOF: 14,
                    JSONObject: 15,
                    JSONArray: 16,
                    "{": 17,
                    "}": 18,
                    JSONMemberList: 19,
                    JSONMember: 20,
                    ":": 21,
                    ",": 22,
                    "[": 23,
                    "]": 24,
                    JSONElementList: 25,
                    $accept: 0,
                    $end: 1
                },
                terminals_: {
                    2: "error",
                    4: "STRING",
                    6: "NUMBER",
                    8: "NULL",
                    10: "TRUE",
                    11: "FALSE",
                    14: "EOF",
                    17: "{",
                    18: "}",
                    21: ":",
                    22: ",",
                    23: "[",
                    24: "]"
                },
                productions_: [
                    0,
                    [
                        3,
                        1
                    ],
                    [
                        5,
                        1
                    ],
                    [
                        7,
                        1
                    ],
                    [
                        9,
                        1
                    ],
                    [
                        9,
                        1
                    ],
                    [
                        12,
                        2
                    ],
                    [
                        13,
                        1
                    ],
                    [
                        13,
                        1
                    ],
                    [
                        13,
                        1
                    ],
                    [
                        13,
                        1
                    ],
                    [
                        13,
                        1
                    ],
                    [
                        13,
                        1
                    ],
                    [
                        15,
                        2
                    ],
                    [
                        15,
                        3
                    ],
                    [
                        20,
                        3
                    ],
                    [
                        19,
                        1
                    ],
                    [
                        19,
                        3
                    ],
                    [
                        16,
                        2
                    ],
                    [
                        16,
                        3
                    ],
                    [
                        25,
                        1
                    ],
                    [
                        25,
                        3
                    ]
                ],
                performAction: function(e, t, i, n, o, r, s) {
                    var a = r.length - 1;
                    switch(o){
                        case 1:
                            this.$ = e.replace(/\\(\\|")/g, "$1").replace(/\\n/g, "\n").replace(/\\r/g, "\r").replace(/\\t/g, "\t").replace(/\\v/g, "\v").replace(/\\f/g, "\f").replace(/\\b/g, "\b");
                            break;
                        case 2:
                            this.$ = Number(e);
                            break;
                        case 3:
                            this.$ = null;
                            break;
                        case 4:
                            this.$ = !0;
                            break;
                        case 5:
                            this.$ = !1;
                            break;
                        case 6:
                            return this.$ = r[a - 1];
                        case 13:
                            this.$ = {};
                            break;
                        case 14:
                            this.$ = r[a - 1];
                            break;
                        case 15:
                            this.$ = [
                                r[a - 2],
                                r[a]
                            ];
                            break;
                        case 16:
                            this.$ = {}, this.$[r[a][0]] = r[a][1];
                            break;
                        case 17:
                            this.$ = r[a - 2], r[a - 2][r[a][0]] = r[a][1];
                            break;
                        case 18:
                            this.$ = [];
                            break;
                        case 19:
                            this.$ = r[a - 1];
                            break;
                        case 20:
                            this.$ = [
                                r[a]
                            ];
                            break;
                        case 21:
                            this.$ = r[a - 2], r[a - 2].push(r[a]);
                    }
                },
                table: [
                    {
                        3: 5,
                        4: [
                            1,
                            12
                        ],
                        5: 6,
                        6: [
                            1,
                            13
                        ],
                        7: 3,
                        8: [
                            1,
                            9
                        ],
                        9: 4,
                        10: [
                            1,
                            10
                        ],
                        11: [
                            1,
                            11
                        ],
                        12: 1,
                        13: 2,
                        15: 7,
                        16: 8,
                        17: [
                            1,
                            14
                        ],
                        23: [
                            1,
                            15
                        ]
                    },
                    {
                        1: [
                            3
                        ]
                    },
                    {
                        14: [
                            1,
                            16
                        ]
                    },
                    {
                        14: [
                            2,
                            7
                        ],
                        18: [
                            2,
                            7
                        ],
                        22: [
                            2,
                            7
                        ],
                        24: [
                            2,
                            7
                        ]
                    },
                    {
                        14: [
                            2,
                            8
                        ],
                        18: [
                            2,
                            8
                        ],
                        22: [
                            2,
                            8
                        ],
                        24: [
                            2,
                            8
                        ]
                    },
                    {
                        14: [
                            2,
                            9
                        ],
                        18: [
                            2,
                            9
                        ],
                        22: [
                            2,
                            9
                        ],
                        24: [
                            2,
                            9
                        ]
                    },
                    {
                        14: [
                            2,
                            10
                        ],
                        18: [
                            2,
                            10
                        ],
                        22: [
                            2,
                            10
                        ],
                        24: [
                            2,
                            10
                        ]
                    },
                    {
                        14: [
                            2,
                            11
                        ],
                        18: [
                            2,
                            11
                        ],
                        22: [
                            2,
                            11
                        ],
                        24: [
                            2,
                            11
                        ]
                    },
                    {
                        14: [
                            2,
                            12
                        ],
                        18: [
                            2,
                            12
                        ],
                        22: [
                            2,
                            12
                        ],
                        24: [
                            2,
                            12
                        ]
                    },
                    {
                        14: [
                            2,
                            3
                        ],
                        18: [
                            2,
                            3
                        ],
                        22: [
                            2,
                            3
                        ],
                        24: [
                            2,
                            3
                        ]
                    },
                    {
                        14: [
                            2,
                            4
                        ],
                        18: [
                            2,
                            4
                        ],
                        22: [
                            2,
                            4
                        ],
                        24: [
                            2,
                            4
                        ]
                    },
                    {
                        14: [
                            2,
                            5
                        ],
                        18: [
                            2,
                            5
                        ],
                        22: [
                            2,
                            5
                        ],
                        24: [
                            2,
                            5
                        ]
                    },
                    {
                        14: [
                            2,
                            1
                        ],
                        18: [
                            2,
                            1
                        ],
                        21: [
                            2,
                            1
                        ],
                        22: [
                            2,
                            1
                        ],
                        24: [
                            2,
                            1
                        ]
                    },
                    {
                        14: [
                            2,
                            2
                        ],
                        18: [
                            2,
                            2
                        ],
                        22: [
                            2,
                            2
                        ],
                        24: [
                            2,
                            2
                        ]
                    },
                    {
                        3: 20,
                        4: [
                            1,
                            12
                        ],
                        18: [
                            1,
                            17
                        ],
                        19: 18,
                        20: 19
                    },
                    {
                        3: 5,
                        4: [
                            1,
                            12
                        ],
                        5: 6,
                        6: [
                            1,
                            13
                        ],
                        7: 3,
                        8: [
                            1,
                            9
                        ],
                        9: 4,
                        10: [
                            1,
                            10
                        ],
                        11: [
                            1,
                            11
                        ],
                        13: 23,
                        15: 7,
                        16: 8,
                        17: [
                            1,
                            14
                        ],
                        23: [
                            1,
                            15
                        ],
                        24: [
                            1,
                            21
                        ],
                        25: 22
                    },
                    {
                        1: [
                            2,
                            6
                        ]
                    },
                    {
                        14: [
                            2,
                            13
                        ],
                        18: [
                            2,
                            13
                        ],
                        22: [
                            2,
                            13
                        ],
                        24: [
                            2,
                            13
                        ]
                    },
                    {
                        18: [
                            1,
                            24
                        ],
                        22: [
                            1,
                            25
                        ]
                    },
                    {
                        18: [
                            2,
                            16
                        ],
                        22: [
                            2,
                            16
                        ]
                    },
                    {
                        21: [
                            1,
                            26
                        ]
                    },
                    {
                        14: [
                            2,
                            18
                        ],
                        18: [
                            2,
                            18
                        ],
                        22: [
                            2,
                            18
                        ],
                        24: [
                            2,
                            18
                        ]
                    },
                    {
                        22: [
                            1,
                            28
                        ],
                        24: [
                            1,
                            27
                        ]
                    },
                    {
                        22: [
                            2,
                            20
                        ],
                        24: [
                            2,
                            20
                        ]
                    },
                    {
                        14: [
                            2,
                            14
                        ],
                        18: [
                            2,
                            14
                        ],
                        22: [
                            2,
                            14
                        ],
                        24: [
                            2,
                            14
                        ]
                    },
                    {
                        3: 20,
                        4: [
                            1,
                            12
                        ],
                        20: 29
                    },
                    {
                        3: 5,
                        4: [
                            1,
                            12
                        ],
                        5: 6,
                        6: [
                            1,
                            13
                        ],
                        7: 3,
                        8: [
                            1,
                            9
                        ],
                        9: 4,
                        10: [
                            1,
                            10
                        ],
                        11: [
                            1,
                            11
                        ],
                        13: 30,
                        15: 7,
                        16: 8,
                        17: [
                            1,
                            14
                        ],
                        23: [
                            1,
                            15
                        ]
                    },
                    {
                        14: [
                            2,
                            19
                        ],
                        18: [
                            2,
                            19
                        ],
                        22: [
                            2,
                            19
                        ],
                        24: [
                            2,
                            19
                        ]
                    },
                    {
                        3: 5,
                        4: [
                            1,
                            12
                        ],
                        5: 6,
                        6: [
                            1,
                            13
                        ],
                        7: 3,
                        8: [
                            1,
                            9
                        ],
                        9: 4,
                        10: [
                            1,
                            10
                        ],
                        11: [
                            1,
                            11
                        ],
                        13: 31,
                        15: 7,
                        16: 8,
                        17: [
                            1,
                            14
                        ],
                        23: [
                            1,
                            15
                        ]
                    },
                    {
                        18: [
                            2,
                            17
                        ],
                        22: [
                            2,
                            17
                        ]
                    },
                    {
                        18: [
                            2,
                            15
                        ],
                        22: [
                            2,
                            15
                        ]
                    },
                    {
                        22: [
                            2,
                            21
                        ],
                        24: [
                            2,
                            21
                        ]
                    }
                ],
                defaultActions: {
                    16: [
                        2,
                        6
                    ]
                },
                parseError: function(e, t) {
                    throw new Error(e);
                },
                parse: function(e) {
                    var t = this, i = [
                        0
                    ], n = [
                        null
                    ], o = [], r = this.table, s = "", a = 0, l = 0, c = 0, h = (this.lexer.setInput(e), this.lexer.yy = this.yy, this.yy.lexer = this.lexer, void 0 === this.lexer.yylloc && (this.lexer.yylloc = {}), this.lexer.yylloc);
                    function d() {
                        var e = t.lexer.lex() || 1;
                        return e = "number" != typeof e ? t.symbols_[e] || e : e;
                    }
                    o.push(h), "function" == typeof this.yy.parseError && (this.parseError = this.yy.parseError);
                    for(var u, g, p, m, f, C, y, v, I, b = {};;){
                        if (p = i[i.length - 1], void 0 === (m = this.defaultActions[p] || (null == u && (u = d()), r[p] && r[p][u])) || !m.length || !m[0]) {
                            if (!c) {
                                for(f in v = [], r[p])this.terminals_[f] && 2 < f && v.push("'" + this.terminals_[f] + "'");
                                var A = "", A = this.lexer.showPosition ? "Parse error on line " + (a + 1) + ":\n" + this.lexer.showPosition() + "\nExpecting " + v.join(", ") + ", got '" + this.terminals_[u] + "'" : "Parse error on line " + (a + 1) + ": Unexpected " + (1 == u ? "end of input" : "'" + (this.terminals_[u] || u) + "'");
                                this.parseError(A, {
                                    text: this.lexer.match,
                                    token: this.terminals_[u] || u,
                                    line: this.lexer.yylineno,
                                    loc: h,
                                    expected: v
                                });
                            }
                            if (3 == c) {
                                if (1 == u) throw new Error(A || "Parsing halted.");
                                l = this.lexer.yyleng, s = this.lexer.yytext, a = this.lexer.yylineno, h = this.lexer.yylloc, u = d();
                            }
                            for(;;){
                                if (2..toString() in r[p]) break;
                                if (0 == p) throw new Error(A || "Parsing halted.");
                                I = 1, i.length = i.length - 2 * I, n.length = n.length - I, o.length = o.length - I, p = i[i.length - 1];
                            }
                            g = u, u = 2, m = r[p = i[i.length - 1]] && r[p][2], c = 3;
                        }
                        if (m[0] instanceof Array && 1 < m.length) throw new Error("Parse Error: multiple actions possible at state: " + p + ", token: " + u);
                        switch(m[0]){
                            case 1:
                                i.push(u), n.push(this.lexer.yytext), o.push(this.lexer.yylloc), i.push(m[1]), u = null, g ? (u = g, g = null) : (l = this.lexer.yyleng, s = this.lexer.yytext, a = this.lexer.yylineno, h = this.lexer.yylloc, 0 < c && c--);
                                break;
                            case 2:
                                if (C = this.productions_[m[1]][1], b.$ = n[n.length - C], b._$ = {
                                    first_line: o[o.length - (C || 1)].first_line,
                                    last_line: o[o.length - 1].last_line,
                                    first_column: o[o.length - (C || 1)].first_column,
                                    last_column: o[o.length - 1].last_column
                                }, void 0 !== (y = this.performAction.call(b, s, l, a, this.yy, m[1], n, o))) return y;
                                C && (i = i.slice(0, -1 * C * 2), n = n.slice(0, -1 * C), o = o.slice(0, -1 * C)), i.push(this.productions_[m[1]][0]), n.push(b.$), o.push(b._$), y = r[i[i.length - 2]][i[i.length - 1]], i.push(y);
                                break;
                            case 3:
                                return !0;
                        }
                    }
                    return !0;
                }
            }).lexer = {
                EOF: 1,
                parseError: function(e, t) {
                    if (!this.yy.parseError) throw new Error(e);
                    this.yy.parseError(e, t);
                },
                setInput: function(e) {
                    return this._input = e, this._more = this._less = this.done = !1, this.yylineno = this.yyleng = 0, this.yytext = this.matched = this.match = "", this.conditionStack = [
                        "INITIAL"
                    ], this.yylloc = {
                        first_line: 1,
                        first_column: 0,
                        last_line: 1,
                        last_column: 0
                    }, this;
                },
                input: function() {
                    var e = this._input[0];
                    return this.yytext += e, this.yyleng++, this.match += e, this.matched += e, e.match(/\n/) && this.yylineno++, this._input = this._input.slice(1), e;
                },
                unput: function(e) {
                    return this._input = e + this._input, this;
                },
                more: function() {
                    return this._more = !0, this;
                },
                less: function(e) {
                    this._input = this.match.slice(e) + this._input;
                },
                pastInput: function() {
                    var e = this.matched.substr(0, this.matched.length - this.match.length);
                    return (20 < e.length ? "..." : "") + e.substr(-20).replace(/\n/g, "");
                },
                upcomingInput: function() {
                    var e = this.match;
                    return e.length < 20 && (e += this._input.substr(0, 20 - e.length)), (e.substr(0, 20) + (20 < e.length ? "..." : "")).replace(/\n/g, "");
                },
                showPosition: function() {
                    var e = this.pastInput(), t = new Array(e.length + 1).join("-");
                    return e + this.upcomingInput() + "\n" + t + "^";
                },
                next: function() {
                    if (this.done) return this.EOF;
                    this._input || (this.done = !0), this._more || (this.yytext = "", this.match = "");
                    for(var e, t, i, n, o = this._currentRules(), r = 0; r < o.length && (!(t = this._input.match(this.rules[o[r]])) || e && !(t[0].length > e[0].length) || (e = t, i = r, this.options.flex)); r++);
                    return e ? ((n = e[0].match(/\n.*/g)) && (this.yylineno += n.length), this.yylloc = {
                        first_line: this.yylloc.last_line,
                        last_line: this.yylineno + 1,
                        first_column: this.yylloc.last_column,
                        last_column: n ? n[n.length - 1].length - 1 : this.yylloc.last_column + e[0].length
                    }, this.yytext += e[0], this.match += e[0], this.yyleng = this.yytext.length, this._more = !1, this._input = this._input.slice(e[0].length), this.matched += e[0], n = this.performAction.call(this, this.yy, this, o[i], this.conditionStack[this.conditionStack.length - 1]), this.done && this._input && (this.done = !1), n || void 0) : "" === this._input ? this.EOF : void this.parseError("Lexical error on line " + (this.yylineno + 1) + ". Unrecognized text.\n" + this.showPosition(), {
                        text: "",
                        token: null,
                        line: this.yylineno
                    });
                },
                lex: function() {
                    var e = this.next();
                    return void 0 !== e ? e : this.lex();
                },
                begin: function(e) {
                    this.conditionStack.push(e);
                },
                popState: function() {
                    return this.conditionStack.pop();
                },
                _currentRules: function() {
                    return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
                },
                topState: function() {
                    return this.conditionStack[this.conditionStack.length - 2];
                },
                pushState: function(e) {
                    this.begin(e);
                },
                options: {},
                performAction: function(e, t, i, n) {
                    switch(i){
                        case 0:
                            break;
                        case 1:
                            return 6;
                        case 2:
                            return t.yytext = t.yytext.substr(1, t.yyleng - 2), 4;
                        case 3:
                            return 17;
                        case 4:
                            return 18;
                        case 5:
                            return 23;
                        case 6:
                            return 24;
                        case 7:
                            return 22;
                        case 8:
                            return 21;
                        case 9:
                            return 10;
                        case 10:
                            return 11;
                        case 11:
                            return 8;
                        case 12:
                            return 14;
                        case 13:
                            return "INVALID";
                    }
                },
                rules: [
                    /^(?:\s+)/,
                    /^(?:(-?([0-9]|[1-9][0-9]+))(\.[0-9]+)?([eE][-+]?[0-9]+)?\b)/,
                    /^(?:"(?:\\[\\"bfnrt/]|\\u[a-fA-F0-9]{4}|[^\\\0-\x09\x0a-\x1f"])*")/,
                    /^(?:\{)/,
                    /^(?:\})/,
                    /^(?:\[)/,
                    /^(?:\])/,
                    /^(?:,)/,
                    /^(?::)/,
                    /^(?:true\b)/,
                    /^(?:false\b)/,
                    /^(?:null\b)/,
                    /^(?:$)/,
                    /^(?:.)/
                ],
                conditions: {
                    INITIAL: {
                        rules: [
                            0,
                            1,
                            2,
                            3,
                            4,
                            5,
                            6,
                            7,
                            8,
                            9,
                            10,
                            11,
                            12,
                            13
                        ],
                        inclusive: !0
                    }
                }
            };
            var i;
            t.parser = i, t.parse = i.parse.bind(i);
        },
        4772: function(e) {
            function n() {}
            n.prototype = {
                on: function(e, t) {
                    this._events = this._events || {}, this._events[e] = this._events[e] || [], this._events[e].push(t);
                },
                off: function(e, t) {
                    this._events = this._events || {}, e in this._events != !1 && this._events[e].splice(this._events[e].indexOf(t), 1);
                },
                emit: function(e) {
                    if (this._events = this._events || {}, e in this._events != !1) for(var t = 0; t < this._events[e].length; t++)this._events[e][t].apply(this, Array.prototype.slice.call(arguments, 1));
                }
            }, n.mixin = function(e) {
                for(var t = [
                    "on",
                    "off",
                    "emit"
                ], i = 0; i < t.length; i++)"function" == typeof e ? e.prototype[t[i]] = n.prototype[t[i]] : e[t[i]] = n.prototype[t[i]];
                return e;
            };
            var u = {
                escapeRegExp: function(e) {
                    var t = /[\\^$.*+?()[\]{}|]/g, i = new RegExp(t.source);
                    return e && i.test(e) ? e.replace(t, "\\$&") : e;
                },
                extend: function(e, t) {
                    for(var i in t){
                        var n;
                        t.hasOwnProperty(i) && ((n = t[i]) && "[object Object]" === Object.prototype.toString.call(n) ? (e[i] = e[i] || {}, u.extend(e[i], n)) : e[i] = n);
                    }
                    return e;
                },
                each: function(e, t, i) {
                    if ("[object Object]" === Object.prototype.toString.call(e)) for(var n in e)Object.prototype.hasOwnProperty.call(e, n) && t.call(i, n, e[n], e);
                    else for(var o = 0, r = e.length; o < r; o++)t.call(i, o, e[o], e);
                },
                createElement: function(e, t) {
                    var i, n = document.createElement(e);
                    if (t && "[object Object]" === Object.prototype.toString.call(t)) for(i in t)i in n ? n[i] = t[i] : "html" === i ? n.innerHTML = t[i] : n.setAttribute(i, t[i]);
                    return n;
                },
                hasClass: function(e, t) {
                    if (e) return e.classList ? e.classList.contains(t) : !!e.className && !!e.className.match(new RegExp("(\\s|^)" + t + "(\\s|$)"));
                },
                addClass: function(e, t) {
                    u.hasClass(e, t) || (e.classList ? e.classList.add(t) : e.className = e.className.trim() + " " + t);
                },
                removeClass: function(e, t) {
                    u.hasClass(e, t) && (e.classList ? e.classList.remove(t) : e.className = e.className.replace(new RegExp("(^|\\s)" + t.split(" ").join("|") + "(\\s|$)", "gi"), " "));
                },
                closest: function(e, t) {
                    return e && e !== document.body && (t(e) ? e : u.closest(e.parentNode, t));
                },
                isInt: function(e) {
                    return "number" == typeof e && isFinite(e) && Math.floor(e) === e;
                },
                debounce: function(n, o, r) {
                    var s;
                    return function() {
                        var e = this, t = arguments, i = r && !s;
                        clearTimeout(s), s = setTimeout(function() {
                            s = null, r || n.apply(e, t);
                        }, o), i && n.apply(e, t);
                    };
                },
                rect: function(e, t) {
                    var i = window, e = e.getBoundingClientRect(), n = t ? i.pageXOffset : 0, t = t ? i.pageYOffset : 0;
                    return {
                        bottom: e.bottom + t,
                        height: e.height,
                        left: e.left + n,
                        right: e.right + n,
                        top: e.top + t,
                        width: e.width
                    };
                },
                includes: function(e, t) {
                    return -1 < e.indexOf(t);
                },
                startsWith: function(e, t) {
                    return e.substr(0, t.length) === t;
                },
                truncate: function(e) {
                    for(; e.firstChild;)e.removeChild(e.firstChild);
                }
            };
            function h(e, t) {
                return e.hasOwnProperty(t) && (!0 === e[t] || e[t].length);
            }
            function g(e, t, i) {
                e.parentNode ? e.parentNode.parentNode || t.appendChild(e.parentNode) : t.appendChild(e), u.removeClass(e, "excluded"), i || (e.textContent = e.textContent);
            }
            function o() {
                var i, e;
                this.items.length && (i = document.createDocumentFragment(), this.config.pagination ? (e = this.pages.slice(0, this.pageIndex), u.each(e, function(e, t) {
                    u.each(t, function(e, t) {
                        g(t, i, this.customOption);
                    }, this);
                }, this)) : u.each(this.items, function(e, t) {
                    g(t, i, this.customOption);
                }, this), i.childElementCount && (u.removeClass(this.items[this.navIndex], "active"), this.navIndex = (i.querySelector(".selectr-option.selected") || i.querySelector(".selectr-option")).idx, u.addClass(this.items[this.navIndex], "active")), this.tree.appendChild(i));
            }
            function d(e, t) {
                t = t || e;
                var i = {
                    class: "selectr-option",
                    role: "treeitem",
                    "aria-selected": !1
                };
                return this.customOption ? i.html = this.config.renderOption(t) : i.textContent = e.textContent, (t = u.createElement("li", i)).idx = e.idx, this.items.push(t), e.defaultSelected && this.defaultSelected.push(e.idx), e.disabled && (t.disabled = !0, u.addClass(t, "disabled")), t;
            }
            function r() {
                var i, e = this.tree, t = e.scrollTop;
                e.scrollHeight - e.offsetHeight <= t && this.pageIndex < this.pages.length && (i = document.createDocumentFragment(), u.each(this.pages[this.pageIndex], function(e, t) {
                    g(t, i, this.customOption);
                }, this), e.appendChild(i), this.pageIndex++, this.emit("selectr.paginate", {
                    items: this.items.length,
                    total: this.data.length,
                    page: this.pageIndex,
                    pages: this.pages.length
                }));
            }
            function s() {
                (this.config.searchable || this.config.taggable) && (this.input.value = null, this.searching = !1, this.config.searchable && u.removeClass(this.inputContainer, "active"), u.hasClass(this.container, "notice") && (u.removeClass(this.container, "notice"), u.addClass(this.container, "open"), this.input.focus()), u.each(this.items, function(e, t) {
                    u.removeClass(t, "excluded"), this.customOption || (t.textContent = t.textContent);
                }, this));
            }
            function t(e, t) {
                if (!e) throw new Error("You must supply either a HTMLSelectElement or a CSS3 selector string.");
                if ("string" == typeof (this.el = e) && (this.el = document.querySelector(e)), null === this.el) throw new Error("The element you passed to Selectr can not be found.");
                if ("select" !== this.el.nodeName.toLowerCase()) throw new Error("The element you passed to Selectr is not a HTMLSelectElement.");
                this.render(t);
            }
            t.prototype.render = function(e) {
                var t;
                this.rendered || ((this.el.selectr = this).config = u.extend({
                    defaultSelected: !0,
                    width: "auto",
                    disabled: !1,
                    disabledMobile: !1,
                    searchable: !0,
                    clearable: !1,
                    sortSelected: !1,
                    allowDeselect: !1,
                    closeOnScroll: !1,
                    nativeDropdown: !1,
                    nativeKeyboard: !1,
                    placeholder: "Select an option...",
                    taggable: !1,
                    tagPlaceholder: "Enter a tag...",
                    messages: {
                        noResults: "No results.",
                        noOptions: "No options available.",
                        maxSelections: "A maximum of {max} items can be selected.",
                        tagDuplicate: "That tag is already in use.",
                        searchPlaceholder: "Search options..."
                    }
                }, e), this.originalType = this.el.type, this.originalIndex = this.el.tabIndex, this.defaultSelected = [], this.originalOptionCount = this.el.options.length, (this.config.multiple || this.config.taggable) && (this.el.multiple = !0), this.disabled = h(this.config, "disabled"), this.opened = !1, this.config.taggable && (this.config.searchable = !1), this.navigating = !1, this.mobileDevice = !1, !this.config.disabledMobile && /Android|webOS|iPhone|iPad|BlackBerry|Windows Phone|Opera Mini|IEMobile|Mobile/i.test(navigator.userAgent) && (this.mobileDevice = !0), this.customOption = this.config.hasOwnProperty("renderOption") && "function" == typeof this.config.renderOption, this.customSelected = this.config.hasOwnProperty("renderSelection") && "function" == typeof this.config.renderSelection, this.supportsEventPassiveOption = this.detectEventPassiveOption(), n.mixin(this), (function() {
                    this.requiresPagination = this.config.pagination && 0 < this.config.pagination, h(this.config, "width") && (u.isInt(this.config.width) ? this.width = this.config.width + "px" : "auto" === this.config.width ? this.width = "100%" : u.includes(this.config.width, "%") && (this.width = this.config.width)), this.container = u.createElement("div", {
                        class: "selectr-container"
                    }), this.config.customClass && u.addClass(this.container, this.config.customClass), this.mobileDevice ? u.addClass(this.container, "selectr-mobile") : u.addClass(this.container, "selectr-desktop"), this.el.tabIndex = -1, this.config.nativeDropdown || this.mobileDevice ? u.addClass(this.el, "selectr-visible") : u.addClass(this.el, "selectr-hidden"), this.selected = u.createElement("div", {
                        class: "selectr-selected",
                        disabled: this.disabled,
                        tabIndex: 0,
                        "aria-expanded": !1
                    }), this.label = u.createElement(this.el.multiple ? "ul" : "span", {
                        class: "selectr-label"
                    });
                    var e = u.createElement("div", {
                        class: "selectr-options-container"
                    });
                    if (this.tree = u.createElement("ul", {
                        class: "selectr-options",
                        role: "tree",
                        "aria-hidden": !0,
                        "aria-expanded": !1
                    }), this.notice = u.createElement("div", {
                        class: "selectr-notice"
                    }), this.el.setAttribute("aria-hidden", !0), this.disabled && (this.el.disabled = !0), this.el.multiple ? (u.addClass(this.label, "selectr-tags"), u.addClass(this.container, "multiple"), this.tags = [], this.selectedValues = this.config.defaultSelected ? this.getSelectedProperties("value") : [], this.selectedIndexes = this.getSelectedProperties("idx")) : (this.selectedValue = null, this.selectedIndex = -1), this.selected.appendChild(this.label), this.config.clearable && (this.selectClear = u.createElement("button", {
                        class: "selectr-clear",
                        type: "button"
                    }), this.container.appendChild(this.selectClear), u.addClass(this.container, "clearable")), this.config.taggable) {
                        var t = u.createElement("li", {
                            class: "input-tag"
                        });
                        if (this.input = u.createElement("input", {
                            class: "selectr-tag-input",
                            placeholder: this.config.tagPlaceholder,
                            tagIndex: 0,
                            autocomplete: "off",
                            autocorrect: "off",
                            autocapitalize: "off",
                            spellcheck: "false",
                            role: "textbox",
                            type: "search"
                        }), t.appendChild(this.input), this.label.appendChild(t), u.addClass(this.container, "taggable"), this.tagSeperators = [
                            ","
                        ], this.config.tagSeperators) {
                            this.tagSeperators = this.tagSeperators.concat(this.config.tagSeperators);
                            for(var i = [], n = 0; n < this.tagSeperators.length; n++)i.push(u.escapeRegExp(this.tagSeperators[n]));
                            this.tagSeperatorsRegex = new RegExp(i.join("|"), "i");
                        } else this.tagSeperatorsRegex = new RegExp(",", "i");
                    }
                    this.config.searchable && (this.input = u.createElement("input", {
                        class: "selectr-input",
                        tagIndex: -1,
                        autocomplete: "off",
                        autocorrect: "off",
                        autocapitalize: "off",
                        spellcheck: "false",
                        role: "textbox",
                        type: "search",
                        placeholder: this.config.messages.searchPlaceholder
                    }), this.inputClear = u.createElement("button", {
                        class: "selectr-input-clear",
                        type: "button"
                    }), this.inputContainer = u.createElement("div", {
                        class: "selectr-input-container"
                    }), this.inputContainer.appendChild(this.input), this.inputContainer.appendChild(this.inputClear), e.appendChild(this.inputContainer)), e.appendChild(this.notice), e.appendChild(this.tree), this.items = [], this.options = [], this.el.options.length && (this.options = [].slice.call(this.el.options));
                    var o, r, s, a = !1, l = 0;
                    this.el.children.length && u.each(this.el.children, function(e, t) {
                        "OPTGROUP" === t.nodeName ? (a = u.createElement("ul", {
                            class: "selectr-optgroup",
                            role: "group",
                            html: "<li class='selectr-optgroup--label'>" + t.label + "</li>"
                        }), u.each(t.children, function(e, t) {
                            t.idx = l, a.appendChild(d.call(this, t, a)), l++;
                        }, this)) : (t.idx = l, d.call(this, t), l++);
                    }, this), this.config.data && Array.isArray(this.config.data) && (o = (this.data = [], false), a = !1, l = 0, u.each(this.config.data, function(e, t) {
                        h(t, "children") ? (o = u.createElement("optgroup", {
                            label: t.text
                        }), a = u.createElement("ul", {
                            class: "selectr-optgroup",
                            role: "group",
                            html: "<li class='selectr-optgroup--label'>" + t.text + "</li>"
                        }), u.each(t.children, function(e, t) {
                            (r = new Option(t.text, t.value, !1, t.hasOwnProperty("selected") && !0 === t.selected)).disabled = h(t, "disabled"), this.options.push(r), o.appendChild(r), r.idx = l, a.appendChild(d.call(this, r, t)), this.data[l] = t, l++;
                        }, this), this.el.appendChild(o)) : ((r = new Option(t.text, t.value, !1, t.hasOwnProperty("selected") && !0 === t.selected)).disabled = h(t, "disabled"), this.options.push(r), r.idx = l, d.call(this, r, t), this.data[l] = t, l++);
                    }, this)), this.setSelected(!0);
                    for(var c = this.navIndex = 0; c < this.items.length; c++)if (s = this.items[c], !u.hasClass(s, "disabled")) {
                        u.addClass(s, "active"), this.navIndex = c;
                        break;
                    }
                    this.requiresPagination && (this.pageIndex = 1, this.paginate()), this.container.appendChild(this.selected), this.container.appendChild(e), this.placeEl = u.createElement("div", {
                        class: "selectr-placeholder"
                    }), this.setPlaceholder(), this.selected.appendChild(this.placeEl), this.disabled && this.disable(), this.el.parentNode.insertBefore(this.container, this.el), this.container.appendChild(this.el);
                }).call(this), this.bindEvents(), this.update(), this.optsRect = u.rect(this.tree), this.rendered = !0, this.el.multiple || (this.el.selectedIndex = this.selectedIndex), t = this, setTimeout(function() {
                    t.emit("selectr.init");
                }, 20));
            }, t.prototype.getSelected = function() {
                return this.el.querySelectorAll("option:checked");
            }, t.prototype.getSelectedProperties = function(t) {
                var e = this.getSelected();
                return [].slice.call(e).map(function(e) {
                    return e[t];
                }).filter(function(e) {
                    return null != e;
                });
            }, t.prototype.detectEventPassiveOption = function() {
                var e = !1;
                try {
                    var t = Object.defineProperty({}, "passive", {
                        get: function() {
                            e = !0;
                        }
                    });
                    window.addEventListener("test", null, t);
                } catch (e) {}
                return e;
            }, t.prototype.bindEvents = function() {
                var i, n = this;
                this.events = {}, this.events.dismiss = (function(e) {
                    e = e.target;
                    this.container.contains(e) || !this.opened && !u.hasClass(this.container, "notice") || this.close();
                }).bind(this), this.events.navigate = (function(e) {
                    if (e = e || window.event, this.items.length && this.opened && u.includes([
                        13,
                        38,
                        40
                    ], e.which)) {
                        if (e.preventDefault(), 13 === e.which) return !(this.noResults || this.config.taggable && 0 < this.input.value.length) && this.change(this.navIndex);
                        var t, i = this.items[this.navIndex], n = this.navIndex;
                        switch(e.which){
                            case 38:
                                (t = 0) < this.navIndex && this.navIndex--;
                                break;
                            case 40:
                                this.navIndex < this.items.length - (t = 1) && this.navIndex++;
                        }
                        for(this.navigating = !0; u.hasClass(this.items[this.navIndex], "disabled") || u.hasClass(this.items[this.navIndex], "excluded");){
                            if (!(0 < this.navIndex && this.navIndex < this.items.length - 1)) {
                                this.navIndex = n;
                                break;
                            }
                            if (t ? this.navIndex++ : this.navIndex--, this.searching) {
                                if (this.navIndex > this.tree.lastElementChild.idx) {
                                    this.navIndex = this.tree.lastElementChild.idx;
                                    break;
                                }
                                if (this.navIndex < this.tree.firstElementChild.idx) {
                                    this.navIndex = this.tree.firstElementChild.idx;
                                    break;
                                }
                            }
                        }
                        e = u.rect(this.items[this.navIndex]);
                        t ? (0 === this.navIndex ? this.tree.scrollTop = 0 : e.top + e.height > this.optsRect.top + this.optsRect.height && (this.tree.scrollTop = this.tree.scrollTop + (e.top + e.height - (this.optsRect.top + this.optsRect.height))), this.navIndex === this.tree.childElementCount - 1 && this.requiresPagination && r.call(this)) : 0 === this.navIndex ? this.tree.scrollTop = 0 : e.top - this.optsRect.top < 0 && (this.tree.scrollTop = this.tree.scrollTop + (e.top - this.optsRect.top)), i && u.removeClass(i, "active"), u.addClass(this.items[this.navIndex], "active");
                    } else this.navigating = !1;
                }).bind(this), this.events.reset = this.reset.bind(this), (this.config.nativeDropdown || this.mobileDevice) && (this.container.addEventListener("touchstart", function(e) {
                    e.changedTouches[0].target === n.el && n.toggle();
                }, !!this.supportsEventPassiveOption && {
                    passive: !0
                }), this.container.addEventListener("click", function(e) {
                    e.target === n.el && n.toggle();
                }), this.el.addEventListener("change", function(e) {
                    e.__selfTriggered || (n.el.multiple ? (e = n.getSelectedProperties("idx"), e = ((e, t)=>{
                        for(var i, n = [], o = e.slice(0), r = 0; r < t.length; r++)-1 < (i = o.indexOf(t[r])) ? o.splice(i, 1) : n.push(t[r]);
                        return [
                            n,
                            o
                        ];
                    })(n.selectedIndexes, e), u.each(e[0], function(e, t) {
                        n.select(t);
                    }, n), u.each(e[1], function(e, t) {
                        n.deselect(t);
                    }, n)) : -1 < n.el.selectedIndex && n.select(n.el.selectedIndex));
                })), this.config.nativeDropdown && this.container.addEventListener("keydown", function(e) {
                    "Enter" === e.key && n.selected === document.activeElement && (n.toggle(), setTimeout(function() {
                        n.el.focus();
                    }, 200));
                }), this.selected.addEventListener("click", function(e) {
                    n.disabled || n.toggle(), e.preventDefault();
                }), this.config.nativeKeyboard && (i = "", this.selected.addEventListener("keydown", function(e) {
                    var t;
                    n.disabled || n.selected !== document.activeElement || e.altKey || e.ctrlKey || e.metaKey || (" " === e.key || !n.opened && -1 < [
                        "Enter",
                        "ArrowUp",
                        "ArrowDown"
                    ].indexOf(e.key) ? (n.toggle(), e.preventDefault(), e.stopPropagation()) : e.key.length <= 2 && String[String.fromCodePoint ? "fromCodePoint" : "fromCharCode"](e.key[String.codePointAt ? "codePointAt" : "charCodeAt"](0)) === e.key && (n.config.multiple ? (n.open(), n.config.searchable && (n.input.value = e.key, n.input.focus(), n.search(null, !0))) : (i += e.key, (t = n.search(i, !0)) && t.length && (n.clear(), n.setValue(t[0].value)), setTimeout(function() {
                        i = "";
                    }, 1e3)), e.preventDefault(), e.stopPropagation()));
                }), this.container.addEventListener("keyup", function(e) {
                    n.opened && "Escape" === e.key && (n.close(), e.stopPropagation(), n.selected.focus());
                })), this.label.addEventListener("click", function(e) {
                    u.hasClass(e.target, "selectr-tag-remove") && n.deselect(e.target.parentNode.idx);
                }), this.selectClear && this.selectClear.addEventListener("click", this.clear.bind(this)), this.tree.addEventListener("mousedown", function(e) {
                    e.preventDefault();
                }), this.tree.addEventListener("click", function(e) {
                    var t = u.closest(e.target, function(e) {
                        return e && u.hasClass(e, "selectr-option");
                    });
                    t && !u.hasClass(t, "disabled") && (u.hasClass(t, "selected") ? (n.el.multiple || !n.el.multiple && n.config.allowDeselect) && n.deselect(t.idx) : n.select(t.idx), n.opened && !n.el.multiple) && n.close(), e.preventDefault(), e.stopPropagation();
                }), this.tree.addEventListener("mouseover", function(e) {
                    !u.hasClass(e.target, "selectr-option") || u.hasClass(e.target, "disabled") || (u.removeClass(n.items[n.navIndex], "active"), u.addClass(e.target, "active"), n.navIndex = [].slice.call(n.items).indexOf(e.target));
                }), this.config.searchable && (this.input.addEventListener("focus", function(e) {
                    n.searching = !0;
                }), this.input.addEventListener("blur", function(e) {
                    n.searching = !1;
                }), this.input.addEventListener("keyup", function(e) {
                    n.search(), n.config.taggable || (this.value.length ? u.addClass(this.parentNode, "active") : u.removeClass(this.parentNode, "active"));
                }), this.inputClear.addEventListener("click", function(e) {
                    n.input.value = null, s.call(n), n.tree.childElementCount || o.call(n);
                })), this.config.taggable && this.input.addEventListener("keyup", function(e) {
                    var t, i;
                    n.search(), n.config.taggable && this.value.length && (t = this.value.trim()).length && (13 === e.which || n.tagSeperatorsRegex.test(t)) && (e = t.replace(n.tagSeperatorsRegex, ""), (i = (e = (e = u.escapeRegExp(e)).trim()).length ? n.add({
                        value: e,
                        textContent: e,
                        selected: !0
                    }, !0) : i) ? (n.close(), s.call(n)) : (this.value = "", n.setMessage(n.config.messages.tagDuplicate)));
                }), this.update = u.debounce(function() {
                    n.opened && n.config.closeOnScroll && n.close(), n.width && (n.container.style.width = n.width), n.invert();
                }, 50), this.requiresPagination && (this.paginateItems = u.debounce(function() {
                    r.call(this);
                }, 50), this.tree.addEventListener("scroll", this.paginateItems.bind(this))), document.addEventListener("click", this.events.dismiss), window.addEventListener("keydown", this.events.navigate), window.addEventListener("resize", this.update), window.addEventListener("scroll", this.update), this.on("selectr.destroy", function() {
                    document.removeEventListener("click", this.events.dismiss), window.removeEventListener("keydown", this.events.navigate), window.removeEventListener("resize", this.update), window.removeEventListener("scroll", this.update);
                }), this.el.form && (this.el.form.addEventListener("reset", this.events.reset), this.on("selectr.destroy", function() {
                    this.el.form.removeEventListener("reset", this.events.reset);
                }));
            }, t.prototype.setSelected = function(e) {
                var i;
                this.config.data || this.el.multiple || !this.el.options.length || (0 !== this.el.selectedIndex || this.el.options[0].defaultSelected || this.config.defaultSelected || (this.el.selectedIndex = -1), this.selectedIndex = this.el.selectedIndex, -1 < this.selectedIndex && this.select(this.selectedIndex)), this.config.multiple && "select-one" === this.originalType && !this.config.data && this.el.options[0].selected && !this.el.options[0].defaultSelected && (this.el.options[0].selected = !1), u.each(this.options, function(e, t) {
                    t.selected && t.defaultSelected && this.select(t.idx);
                }, this), this.config.selectedValue && this.setValue(this.config.selectedValue), this.config.data && (!this.el.multiple && this.config.defaultSelected && this.el.selectedIndex < 0 && 0 < this.config.data.length && this.select(0), i = 0, u.each(this.config.data, function(e, t) {
                    h(t, "children") ? u.each(t.children, function(e, t) {
                        t.hasOwnProperty("selected") && !0 === t.selected && this.select(i), i++;
                    }, this) : (t.hasOwnProperty("selected") && !0 === t.selected && this.select(i), i++);
                }, this));
            }, t.prototype.destroy = function() {
                this.rendered && (this.emit("selectr.destroy"), "select-one" === this.originalType && (this.el.multiple = !1), this.config.data && (this.el.innerHTML = ""), u.removeClass(this.el, "selectr-hidden"), this.container.parentNode.replaceChild(this.el, this.container), this.rendered = !1, delete this.el.selectr);
            }, t.prototype.change = function(e) {
                var t = this.items[e], i = this.options[e];
                i.disabled || (i.selected && u.hasClass(t, "selected") ? this.deselect(e) : this.select(e), this.opened && !this.el.multiple && this.close());
            }, t.prototype.select = function(n) {
                var e = this.items[n], t = [].slice.call(this.el.options), i = this.options[n];
                if (this.el.multiple) {
                    if (u.includes(this.selectedIndexes, n)) return !1;
                    if (this.config.maxSelections && this.tags.length === this.config.maxSelections) return this.setMessage(this.config.messages.maxSelections.replace("{max}", this.config.maxSelections), !0), !1;
                    this.selectedValues.push(i.value), this.selectedIndexes.push(n), (function(e) {
                        var l, c = this, i = document.createDocumentFragment(), t = this.options[e.idx], n = this.data ? this.data[e.idx] : t, o = {
                            class: "selectr-tag"
                        }, n = (this.customSelected ? o.html = this.config.renderSelection(n) : o.textContent = t.textContent, u.createElement("li", o)), o = u.createElement("button", {
                            class: "selectr-tag-remove",
                            type: "button"
                        });
                        n.appendChild(o), n.idx = e.idx, n.tag = t.value, this.tags.push(n), this.config.sortSelected ? (o = this.tags.slice(), l = function(e, n) {
                            e.replace(/(\d+)|(\D+)/g, function(e, t, i) {
                                n.push([
                                    t || 1 / 0,
                                    i || ""
                                ]);
                            });
                        }, o.sort(function(e, t) {
                            var i, n, o = [], r = [];
                            for(!0 === c.config.sortSelected ? (i = e.tag, n = t.tag) : "text" === c.config.sortSelected && (i = e.textContent, n = t.textContent), l(i, o), l(n, r); o.length && r.length;){
                                var s = o.shift(), a = r.shift(), s = s[0] - a[0] || s[1].localeCompare(a[1]);
                                if (s) return s;
                            }
                            return o.length - r.length;
                        }), u.each(o, function(e, t) {
                            i.appendChild(t);
                        }), this.label.innerHTML = "") : i.appendChild(n), this.config.taggable ? this.label.insertBefore(i, this.input.parentNode) : this.label.appendChild(i);
                    }).call(this, e);
                } else {
                    var o = this.data ? this.data[n] : i;
                    this.customSelected ? this.label.innerHTML = this.config.renderSelection(o) : this.label.textContent = i.textContent, this.selectedValue = i.value, this.selectedIndex = n, u.each(this.options, function(e, t) {
                        var i = this.items[e];
                        e !== n && (i && u.removeClass(i, "selected"), t.selected = !1, t.removeAttribute("selected"));
                    }, this);
                }
                u.includes(t, i) || this.el.add(i), e.setAttribute("aria-selected", !0), u.addClass(e, "selected"), u.addClass(this.container, "has-selected"), i.selected = !0, i.setAttribute("selected", ""), this.emit("selectr.change", i), this.emit("selectr.select", i), "createEvent" in document ? ((o = document.createEvent("HTMLEvents")).initEvent("change", !0, !0), o.__selfTriggered = !0, this.el.dispatchEvent(o)) : this.el.fireEvent("onchange");
            }, t.prototype.deselect = function(e, t) {
                var i = this.items[e], n = this.options[e];
                if (this.el.multiple) {
                    var o = this.selectedIndexes.indexOf(e), o = (this.selectedIndexes.splice(o, 1), this.selectedValues.indexOf(n.value));
                    this.selectedValues.splice(o, 1), (function(i) {
                        var n = !1;
                        u.each(this.tags, function(e, t) {
                            t.idx === i.idx && (n = t);
                        }, this), n && (this.label.removeChild(n), this.tags.splice(this.tags.indexOf(n), 1));
                    }).call(this, i), this.tags.length || u.removeClass(this.container, "has-selected");
                } else {
                    if (!t && !this.config.clearable && !this.config.allowDeselect) return !1;
                    this.label.innerHTML = "", this.selectedValue = null, this.el.selectedIndex = this.selectedIndex = -1, u.removeClass(this.container, "has-selected");
                }
                this.items[e].setAttribute("aria-selected", !1), u.removeClass(this.items[e], "selected"), n.selected = !1, n.removeAttribute("selected"), this.emit("selectr.change", null), this.emit("selectr.deselect", n), "createEvent" in document ? ((o = document.createEvent("HTMLEvents")).initEvent("change", !0, !0), o.__selfTriggered = !0, this.el.dispatchEvent(o)) : this.el.fireEvent("onchange");
            }, t.prototype.setValue = function(i) {
                var n = Array.isArray(i);
                if (n || (i = i.toString().trim()), !this.el.multiple && n) return !1;
                u.each(this.options, function(e, t) {
                    (n && -1 < i.indexOf(t.value) || t.value === i) && this.change(t.idx);
                }, this);
            }, t.prototype.getValue = function(e, t) {
                var i, n;
                return this.el.multiple ? e ? this.selectedIndexes.length && (n = {
                    values: []
                }, u.each(this.selectedIndexes, function(e, t) {
                    t = this.options[t];
                    n.values[e] = {
                        value: t.value,
                        text: t.textContent
                    };
                }, this)) : n = this.selectedValues.slice() : n = e ? {
                    value: (i = this.options[this.selectedIndex]).value,
                    text: i.textContent
                } : this.selectedValue, n = e && t ? JSON.stringify(n) : n;
            }, t.prototype.add = function(i, n) {
                if (i) {
                    if (this.data = this.data || [], this.items = this.items || [], this.options = this.options || [], Array.isArray(i)) u.each(i, function(e, t) {
                        this.add(t, n);
                    }, this);
                    else if ("[object Object]" === Object.prototype.toString.call(i)) {
                        if (n) {
                            var o = !1;
                            if (u.each(this.options, function(e, t) {
                                t.value.toLowerCase() === i.value.toLowerCase() && (o = !0);
                            }), o) return !1;
                        }
                        var e = u.createElement("option", i);
                        return this.data.push(i), this.mobileDevice && this.el.add(e), this.options.push(e), e.idx = 0 < this.options.length ? this.options.length - 1 : 0, d.call(this, e), i.selected && this.select(e.idx), this.setPlaceholder(), e;
                    }
                    return this.config.pagination && this.paginate(), !0;
                }
            }, t.prototype.remove = function(e) {
                var i, n = [];
                Array.isArray(e) ? u.each(e, function(e, t) {
                    u.isInt(t) ? n.push(this.getOptionByIndex(t)) : "string" == typeof t && n.push(this.getOptionByValue(t));
                }, this) : u.isInt(e) ? n.push(this.getOptionByIndex(e)) : "string" == typeof e && n.push(this.getOptionByValue(e)), n.length && (u.each(n, function(e, t) {
                    i = t.idx, this.el.remove(t), this.options.splice(i, 1);
                    t = this.items[i].parentNode;
                    t && t.removeChild(this.items[i]), this.items.splice(i, 1), u.each(this.options, function(e, t) {
                        t.idx = e, this.items[e].idx = e;
                    }, this);
                }, this), this.setPlaceholder(), this.config.pagination) && this.paginate();
            }, t.prototype.removeAll = function() {
                this.clear(!0), u.each(this.el.options, function(e, t) {
                    this.el.remove(t);
                }, this), u.truncate(this.tree), this.items = [], this.options = [], this.data = [], this.navIndex = 0, this.requiresPagination && (this.requiresPagination = !1, this.pageIndex = 1, this.pages = []), this.setPlaceholder();
            }, t.prototype.search = function(a, e) {
                var l, c, h, d, t;
                if (!this.navigating) return l = !1, a || (a = this.input.value, l = !0, this.removeMessage(), u.truncate(this.tree)), c = [], h = document.createDocumentFragment(), 0 < (a = a.trim().toLowerCase()).length ? (d = e ? u.startsWith : u.includes, u.each(this.options, function(e, t) {
                    var i, n, o, r, s = this.items[t.idx];
                    d(t.textContent.trim().toLowerCase(), a) && !t.disabled ? (c.push({
                        text: t.textContent,
                        value: t.value
                    }), l && (g(s, h, this.customOption), u.removeClass(s, "excluded"), !this.customOption) && (i = a, o = t.textContent, i = new RegExp(i, "ig"), r = i.exec(o)) && (t.innerHTML = "", (n = document.createElement("span")).classList.add("selectr-match"), n.textContent = r[0], t.appendChild(document.createTextNode(o.substring(0, r.index))), t.appendChild(n), t.appendChild(document.createTextNode(o.substring(i.lastIndex))))) : l && u.addClass(s, "excluded");
                }, this), l && (h.childElementCount ? (e = this.items[this.navIndex], t = h.querySelector(".selectr-option:not(.excluded)"), this.noResults = !1, u.removeClass(e, "active"), this.navIndex = t.idx, u.addClass(t, "active")) : this.config.taggable || (this.noResults = !0, this.setMessage(this.config.messages.noResults)), this.tree.appendChild(h))) : o.call(this), c;
            }, t.prototype.toggle = function() {
                this.disabled || (this.opened ? this.close() : this.open());
            }, t.prototype.open = function() {
                var e = this;
                if (!this.options.length) return !1;
                this.opened || this.emit("selectr.open"), this.opened = !0, this.mobileDevice || this.config.nativeDropdown ? (u.addClass(this.container, "native-open"), this.config.data && u.each(this.options, function(e, t) {
                    this.el.add(t);
                }, this)) : (u.addClass(this.container, "open"), o.call(this), this.invert(), this.tree.scrollTop = 0, u.removeClass(this.container, "notice"), this.selected.setAttribute("aria-expanded", !0), this.tree.setAttribute("aria-hidden", !1), this.tree.setAttribute("aria-expanded", !0), this.config.searchable && !this.config.taggable && setTimeout(function() {
                    e.input.focus(), e.input.tabIndex = 0;
                }, 10));
            }, t.prototype.close = function() {
                var e;
                this.opened && this.emit("selectr.close"), this.opened = !1, this.navigating = !1, this.mobileDevice || this.config.nativeDropdown ? u.removeClass(this.container, "native-open") : (e = u.hasClass(this.container, "notice"), this.config.searchable && !e && (this.input.blur(), this.input.tabIndex = -1, this.searching = !1), e && (u.removeClass(this.container, "notice"), this.notice.textContent = ""), u.removeClass(this.container, "open"), u.removeClass(this.container, "native-open"), this.selected.setAttribute("aria-expanded", !1), this.tree.setAttribute("aria-hidden", !0), this.tree.setAttribute("aria-expanded", !1), u.truncate(this.tree), s.call(this));
            }, t.prototype.enable = function() {
                this.disabled = !1, this.el.disabled = !1, this.selected.tabIndex = this.originalIndex, this.el.multiple && u.each(this.tags, function(e, t) {
                    t.lastElementChild.tabIndex = 0;
                }), u.removeClass(this.container, "selectr-disabled");
            }, t.prototype.disable = function(e) {
                e || (this.el.disabled = !0), this.selected.tabIndex = -1, this.el.multiple && u.each(this.tags, function(e, t) {
                    t.lastElementChild.tabIndex = -1;
                }), this.disabled = !0, u.addClass(this.container, "selectr-disabled");
            }, t.prototype.reset = function() {
                this.disabled || (this.clear(), this.setSelected(!0), u.each(this.defaultSelected, function(e, t) {
                    this.select(t);
                }, this), this.emit("selectr.reset"));
            }, t.prototype.clear = function(e, t) {
                var i;
                this.el.multiple ? this.selectedIndexes.length && (i = this.selectedIndexes.slice(), t ? this.deselect(i.slice(-1)[0]) : u.each(i, function(e, t) {
                    this.deselect(t);
                }, this)) : -1 < this.selectedIndex && this.deselect(this.selectedIndex, e), this.emit("selectr.clear");
            }, t.prototype.serialise = function(e) {
                var n = [];
                return u.each(this.options, function(e, t) {
                    var i = {
                        value: t.value,
                        text: t.textContent
                    };
                    t.selected && (i.selected = !0), t.disabled && (i.disabled = !0), n[e] = i;
                }), e ? JSON.stringify(n) : n;
            }, t.prototype.serialize = function(e) {
                return this.serialise(e);
            }, t.prototype.setPlaceholder = function(e) {
                e = e || this.config.placeholder || this.el.getAttribute("placeholder"), this.options.length || (e = this.config.messages.noOptions), this.placeEl.innerHTML = e;
            }, t.prototype.paginate = function() {
                var i;
                if (this.items.length) return (i = this).pages = this.items.map(function(e, t) {
                    return t % i.config.pagination == 0 ? i.items.slice(t, t + i.config.pagination) : null;
                }).filter(function(e) {
                    return e;
                }), this.pages;
            }, t.prototype.setMessage = function(e, t) {
                t && this.close(), u.addClass(this.container, "notice"), this.notice.textContent = e;
            }, t.prototype.removeMessage = function() {
                u.removeClass(this.container, "notice"), this.notice.innerHTML = "";
            }, t.prototype.invert = function() {
                var e = u.rect(this.selected), t = this.tree.parentNode.offsetHeight, i = window.innerHeight;
                e.top + e.height + t > i ? (u.addClass(this.container, "inverted"), this.isInverted = !0) : (u.removeClass(this.container, "inverted"), this.isInverted = !1), this.optsRect = u.rect(this.tree);
            }, t.prototype.getOptionByIndex = function(e) {
                return this.options[e];
            }, t.prototype.getOptionByValue = function(e) {
                for(var t = !1, i = 0, n = this.options.length; i < n; i++)if (this.options[i].value.trim() === e.toString().trim()) {
                    t = this.options[i];
                    break;
                }
                return t;
            }, e.exports = t;
        },
        660: function(e, t, i) {
            i.d(t, {
                Oq: function() {
                    return o;
                },
                SC: function() {
                    return s;
                },
                ai: function() {
                    return n;
                },
                hJ: function() {
                    return r;
                }
            });
            var n = document.body, o = 10485760, r = 2e4, s = 2147483648;
        },
        1925: function(e, t, i) {
            i.d(t, {
                p: function() {
                    return n;
                }
            });
            var u = i(6237);
            function n(i, e, n) {
                var t, o = 3 < arguments.length && void 0 !== arguments[3] && arguments[3], r = "function" == typeof (a = i).getRootNode ? a.getRootNode() : window, s = {}, a = i.getBoundingClientRect(), l = e.getBoundingClientRect(), c = document.createElement("div");
                function h() {
                    if (c && c.parentNode) {
                        for(var e in c.parentNode.removeChild(c), s)t = e, Object.prototype.hasOwnProperty.call(s, t) && ((t = s[e]) && (0, u.removeEventListener)(r, e, t), delete s[e]);
                        "function" == typeof n && n(i);
                    }
                    var t;
                }
                function d(e) {
                    (e = e.target) === c || (0, u.isChildOf)(e, c) || h();
                }
                return c.className = "jsoneditor-anchor", c.style.position = "absolute", c.style.left = a.left - l.left + "px", c.style.top = a.top - l.top + "px", c.style.width = a.width - 2 + "px", c.style.height = a.height - 2 + "px", c.style.boxSizing = "border-box", e.appendChild(c), s.mousedown = (0, u.addEventListener)(r, "mousedown", d), s.mousewheel = (0, u.addEventListener)(r, "mousewheel", d), o && (t = null, c.onmouseover = function() {
                    clearTimeout(t), t = null;
                }, c.onmouseout = function() {
                    t = t || setTimeout(h, 200);
                }), c.destroy = h, c;
            }
        },
        5477: function(e) {
            e.exports = "data:application/javascript;base64,Im5vIHVzZSBzdHJpY3QiOwohKGZ1bmN0aW9uKHdpbmRvdykgewppZiAodHlwZW9mIHdpbmRvdy53aW5kb3cgIT0gInVuZGVmaW5lZCIgJiYgd2luZG93LmRvY3VtZW50KQogICAgcmV0dXJuOwppZiAod2luZG93LnJlcXVpcmUgJiYgd2luZG93LmRlZmluZSkKICAgIHJldHVybjsKCmlmICghd2luZG93LmNvbnNvbGUpIHsKICAgIHdpbmRvdy5jb25zb2xlID0gZnVuY3Rpb24oKSB7CiAgICAgICAgdmFyIG1zZ3MgPSBBcnJheS5wcm90b3R5cGUuc2xpY2UuY2FsbChhcmd1bWVudHMsIDApOwogICAgICAgIHBvc3RNZXNzYWdlKHt0eXBlOiAibG9nIiwgZGF0YTogbXNnc30pOwogICAgfTsKICAgIHdpbmRvdy5jb25zb2xlLmVycm9yID0KICAgIHdpbmRvdy5jb25zb2xlLndhcm4gPSAKICAgIHdpbmRvdy5jb25zb2xlLmxvZyA9CiAgICB3aW5kb3cuY29uc29sZS50cmFjZSA9IHdpbmRvdy5jb25zb2xlOwp9CndpbmRvdy53aW5kb3cgPSB3aW5kb3c7CndpbmRvdy5hY2UgPSB3aW5kb3c7Cgp3aW5kb3cub25lcnJvciA9IGZ1bmN0aW9uKG1lc3NhZ2UsIGZpbGUsIGxpbmUsIGNvbCwgZXJyKSB7CiAgICBwb3N0TWVzc2FnZSh7dHlwZTogImVycm9yIiwgZGF0YTogewogICAgICAgIG1lc3NhZ2U6IG1lc3NhZ2UsCiAgICAgICAgZGF0YTogZXJyICYmIGVyci5kYXRhLAogICAgICAgIGZpbGU6IGZpbGUsCiAgICAgICAgbGluZTogbGluZSwgCiAgICAgICAgY29sOiBjb2wsCiAgICAgICAgc3RhY2s6IGVyciAmJiBlcnIuc3RhY2sKICAgIH19KTsKfTsKCndpbmRvdy5ub3JtYWxpemVNb2R1bGUgPSBmdW5jdGlvbihwYXJlbnRJZCwgbW9kdWxlTmFtZSkgewogICAgLy8gbm9ybWFsaXplIHBsdWdpbiByZXF1aXJlcwogICAgaWYgKG1vZHVsZU5hbWUuaW5kZXhPZigiISIpICE9PSAtMSkgewogICAgICAgIHZhciBjaHVua3MgPSBtb2R1bGVOYW1lLnNwbGl0KCIhIik7CiAgICAgICAgcmV0dXJuIHdpbmRvdy5ub3JtYWxpemVNb2R1bGUocGFyZW50SWQsIGNodW5rc1swXSkgKyAiISIgKyB3aW5kb3cubm9ybWFsaXplTW9kdWxlKHBhcmVudElkLCBjaHVua3NbMV0pOwogICAgfQogICAgLy8gbm9ybWFsaXplIHJlbGF0aXZlIHJlcXVpcmVzCiAgICBpZiAobW9kdWxlTmFtZS5jaGFyQXQoMCkgPT0gIi4iKSB7CiAgICAgICAgdmFyIGJhc2UgPSBwYXJlbnRJZC5zcGxpdCgiLyIpLnNsaWNlKDAsIC0xKS5qb2luKCIvIik7CiAgICAgICAgbW9kdWxlTmFtZSA9IChiYXNlID8gYmFzZSArICIvIiA6ICIiKSArIG1vZHVsZU5hbWU7CiAgICAgICAgCiAgICAgICAgd2hpbGUgKG1vZHVsZU5hbWUuaW5kZXhPZigiLiIpICE9PSAtMSAmJiBwcmV2aW91cyAhPSBtb2R1bGVOYW1lKSB7CiAgICAgICAgICAgIHZhciBwcmV2aW91cyA9IG1vZHVsZU5hbWU7CiAgICAgICAgICAgIG1vZHVsZU5hbWUgPSBtb2R1bGVOYW1lLnJlcGxhY2UoL15cLlwvLywgIiIpLnJlcGxhY2UoL1wvXC5cLy8sICIvIikucmVwbGFjZSgvW15cL10rXC9cLlwuXC8vLCAiIik7CiAgICAgICAgfQogICAgfQogICAgCiAgICByZXR1cm4gbW9kdWxlTmFtZTsKfTsKCndpbmRvdy5yZXF1aXJlID0gZnVuY3Rpb24gcmVxdWlyZShwYXJlbnRJZCwgaWQpIHsKICAgIGlmICghaWQpIHsKICAgICAgICBpZCA9IHBhcmVudElkOwogICAgICAgIHBhcmVudElkID0gbnVsbDsKICAgIH0KICAgIGlmICghaWQuY2hhckF0KQogICAgICAgIHRocm93IG5ldyBFcnJvcigid29ya2VyLmpzIHJlcXVpcmUoKSBhY2NlcHRzIG9ubHkgKHBhcmVudElkLCBpZCkgYXMgYXJndW1lbnRzIik7CgogICAgaWQgPSB3aW5kb3cubm9ybWFsaXplTW9kdWxlKHBhcmVudElkLCBpZCk7CgogICAgdmFyIG1vZHVsZSA9IHdpbmRvdy5yZXF1aXJlLm1vZHVsZXNbaWRdOwogICAgaWYgKG1vZHVsZSkgewogICAgICAgIGlmICghbW9kdWxlLmluaXRpYWxpemVkKSB7CiAgICAgICAgICAgIG1vZHVsZS5pbml0aWFsaXplZCA9IHRydWU7CiAgICAgICAgICAgIG1vZHVsZS5leHBvcnRzID0gbW9kdWxlLmZhY3RvcnkoKS5leHBvcnRzOwogICAgICAgIH0KICAgICAgICByZXR1cm4gbW9kdWxlLmV4cG9ydHM7CiAgICB9CiAgIAogICAgaWYgKCF3aW5kb3cucmVxdWlyZS50bG5zKQogICAgICAgIHJldHVybiBjb25zb2xlLmxvZygidW5hYmxlIHRvIGxvYWQgIiArIGlkKTsKICAgIAogICAgdmFyIHBhdGggPSByZXNvbHZlTW9kdWxlSWQoaWQsIHdpbmRvdy5yZXF1aXJlLnRsbnMpOwogICAgaWYgKHBhdGguc2xpY2UoLTMpICE9ICIuanMiKSBwYXRoICs9ICIuanMiOwogICAgCiAgICB3aW5kb3cucmVxdWlyZS5pZCA9IGlkOwogICAgd2luZG93LnJlcXVpcmUubW9kdWxlc1tpZF0gPSB7fTsgLy8gcHJldmVudCBpbmZpbml0ZSBsb29wIG9uIGJyb2tlbiBtb2R1bGVzCiAgICBpbXBvcnRTY3JpcHRzKHBhdGgpOwogICAgcmV0dXJuIHdpbmRvdy5yZXF1aXJlKHBhcmVudElkLCBpZCk7Cn07CmZ1bmN0aW9uIHJlc29sdmVNb2R1bGVJZChpZCwgcGF0aHMpIHsKICAgIHZhciB0ZXN0UGF0aCA9IGlkLCB0YWlsID0gIiI7CiAgICB3aGlsZSAodGVzdFBhdGgpIHsKICAgICAgICB2YXIgYWxpYXMgPSBwYXRoc1t0ZXN0UGF0aF07CiAgICAgICAgaWYgKHR5cGVvZiBhbGlhcyA9PSAic3RyaW5nIikgewogICAgICAgICAgICByZXR1cm4gYWxpYXMgKyB0YWlsOwogICAgICAgIH0gZWxzZSBpZiAoYWxpYXMpIHsKICAgICAgICAgICAgcmV0dXJuICBhbGlhcy5sb2NhdGlvbi5yZXBsYWNlKC9cLyokLywgIi8iKSArICh0YWlsIHx8IGFsaWFzLm1haW4gfHwgYWxpYXMubmFtZSk7CiAgICAgICAgfSBlbHNlIGlmIChhbGlhcyA9PT0gZmFsc2UpIHsKICAgICAgICAgICAgcmV0dXJuICIiOwogICAgICAgIH0KICAgICAgICB2YXIgaSA9IHRlc3RQYXRoLmxhc3RJbmRleE9mKCIvIik7CiAgICAgICAgaWYgKGkgPT09IC0xKSBicmVhazsKICAgICAgICB0YWlsID0gdGVzdFBhdGguc3Vic3RyKGkpICsgdGFpbDsKICAgICAgICB0ZXN0UGF0aCA9IHRlc3RQYXRoLnNsaWNlKDAsIGkpOwogICAgfQogICAgcmV0dXJuIGlkOwp9CndpbmRvdy5yZXF1aXJlLm1vZHVsZXMgPSB7fTsKd2luZG93LnJlcXVpcmUudGxucyA9IHt9OwoKd2luZG93LmRlZmluZSA9IGZ1bmN0aW9uKGlkLCBkZXBzLCBmYWN0b3J5KSB7CiAgICBpZiAoYXJndW1lbnRzLmxlbmd0aCA9PSAyKSB7CiAgICAgICAgZmFjdG9yeSA9IGRlcHM7CiAgICAgICAgaWYgKHR5cGVvZiBpZCAhPSAic3RyaW5nIikgewogICAgICAgICAgICBkZXBzID0gaWQ7CiAgICAgICAgICAgIGlkID0gd2luZG93LnJlcXVpcmUuaWQ7CiAgICAgICAgfQogICAgfSBlbHNlIGlmIChhcmd1bWVudHMubGVuZ3RoID09IDEpIHsKICAgICAgICBmYWN0b3J5ID0gaWQ7CiAgICAgICAgZGVwcyA9IFtdOwogICAgICAgIGlkID0gd2luZG93LnJlcXVpcmUuaWQ7CiAgICB9CiAgICAKICAgIGlmICh0eXBlb2YgZmFjdG9yeSAhPSAiZnVuY3Rpb24iKSB7CiAgICAgICAgd2luZG93LnJlcXVpcmUubW9kdWxlc1tpZF0gPSB7CiAgICAgICAgICAgIGV4cG9ydHM6IGZhY3RvcnksCiAgICAgICAgICAgIGluaXRpYWxpemVkOiB0cnVlCiAgICAgICAgfTsKICAgICAgICByZXR1cm47CiAgICB9CgogICAgaWYgKCFkZXBzLmxlbmd0aCkKICAgICAgICAvLyBJZiB0aGVyZSBpcyBubyBkZXBlbmRlbmNpZXMsIHdlIGluamVjdCAicmVxdWlyZSIsICJleHBvcnRzIiBhbmQKICAgICAgICAvLyAibW9kdWxlIiBhcyBkZXBlbmRlbmNpZXMsIHRvIHByb3ZpZGUgQ29tbW9uSlMgY29tcGF0aWJpbGl0eS4KICAgICAgICBkZXBzID0gWyJyZXF1aXJlIiwgImV4cG9ydHMiLCAibW9kdWxlIl07CgogICAgdmFyIHJlcSA9IGZ1bmN0aW9uKGNoaWxkSWQpIHsKICAgICAgICByZXR1cm4gd2luZG93LnJlcXVpcmUoaWQsIGNoaWxkSWQpOwogICAgfTsKCiAgICB3aW5kb3cucmVxdWlyZS5tb2R1bGVzW2lkXSA9IHsKICAgICAgICBleHBvcnRzOiB7fSwKICAgICAgICBmYWN0b3J5OiBmdW5jdGlvbigpIHsKICAgICAgICAgICAgdmFyIG1vZHVsZSA9IHRoaXM7CiAgICAgICAgICAgIHZhciByZXR1cm5FeHBvcnRzID0gZmFjdG9yeS5hcHBseSh0aGlzLCBkZXBzLnNsaWNlKDAsIGZhY3RvcnkubGVuZ3RoKS5tYXAoZnVuY3Rpb24oZGVwKSB7CiAgICAgICAgICAgICAgICBzd2l0Y2ggKGRlcCkgewogICAgICAgICAgICAgICAgICAgIC8vIEJlY2F1c2UgInJlcXVpcmUiLCAiZXhwb3J0cyIgYW5kICJtb2R1bGUiIGFyZW4ndCBhY3R1YWwKICAgICAgICAgICAgICAgICAgICAvLyBkZXBlbmRlbmNpZXMsIHdlIG11c3QgaGFuZGxlIHRoZW0gc2VwZXJhdGVseS4KICAgICAgICAgICAgICAgICAgICBjYXNlICJyZXF1aXJlIjogcmV0dXJuIHJlcTsKICAgICAgICAgICAgICAgICAgICBjYXNlICJleHBvcnRzIjogcmV0dXJuIG1vZHVsZS5leHBvcnRzOwogICAgICAgICAgICAgICAgICAgIGNhc2UgIm1vZHVsZSI6ICByZXR1cm4gbW9kdWxlOwogICAgICAgICAgICAgICAgICAgIC8vIEJ1dCBmb3IgYWxsIG90aGVyIGRlcGVuZGVuY2llcywgd2UgY2FuIGp1c3QgZ28gYWhlYWQgYW5kCiAgICAgICAgICAgICAgICAgICAgLy8gcmVxdWlyZSB0aGVtLgogICAgICAgICAgICAgICAgICAgIGRlZmF1bHQ6ICAgICAgICByZXR1cm4gcmVxKGRlcCk7CiAgICAgICAgICAgICAgICB9CiAgICAgICAgICAgIH0pKTsKICAgICAgICAgICAgaWYgKHJldHVybkV4cG9ydHMpCiAgICAgICAgICAgICAgICBtb2R1bGUuZXhwb3J0cyA9IHJldHVybkV4cG9ydHM7CiAgICAgICAgICAgIHJldHVybiBtb2R1bGU7CiAgICAgICAgfQogICAgfTsKfTsKd2luZG93LmRlZmluZS5hbWQgPSB7fTsKd2luZG93LnJlcXVpcmUudGxucyA9IHt9Owp3aW5kb3cuaW5pdEJhc2VVcmxzICA9IGZ1bmN0aW9uIGluaXRCYXNlVXJscyh0b3BMZXZlbE5hbWVzcGFjZXMpIHsKICAgIGZvciAodmFyIGkgaW4gdG9wTGV2ZWxOYW1lc3BhY2VzKQogICAgICAgIHRoaXMucmVxdWlyZS50bG5zW2ldID0gdG9wTGV2ZWxOYW1lc3BhY2VzW2ldOwp9OwoKd2luZG93LmluaXRTZW5kZXIgPSBmdW5jdGlvbiBpbml0U2VuZGVyKCkgewoKICAgIHZhciBFdmVudEVtaXR0ZXIgPSB3aW5kb3cucmVxdWlyZSgiYWNlL2xpYi9ldmVudF9lbWl0dGVyIikuRXZlbnRFbWl0dGVyOwogICAgdmFyIG9vcCA9IHdpbmRvdy5yZXF1aXJlKCJhY2UvbGliL29vcCIpOwogICAgCiAgICB2YXIgU2VuZGVyID0gZnVuY3Rpb24oKSB7fTsKICAgIAogICAgKGZ1bmN0aW9uKCkgewogICAgICAgIAogICAgICAgIG9vcC5pbXBsZW1lbnQodGhpcywgRXZlbnRFbWl0dGVyKTsKICAgICAgICAgICAgICAgIAogICAgICAgIHRoaXMuY2FsbGJhY2sgPSBmdW5jdGlvbihkYXRhLCBjYWxsYmFja0lkKSB7CiAgICAgICAgICAgIHBvc3RNZXNzYWdlKHsKICAgICAgICAgICAgICAgIHR5cGU6ICJjYWxsIiwKICAgICAgICAgICAgICAgIGlkOiBjYWxsYmFja0lkLAogICAgICAgICAgICAgICAgZGF0YTogZGF0YQogICAgICAgICAgICB9KTsKICAgICAgICB9OwogICAgCiAgICAgICAgdGhpcy5lbWl0ID0gZnVuY3Rpb24obmFtZSwgZGF0YSkgewogICAgICAgICAgICBwb3N0TWVzc2FnZSh7CiAgICAgICAgICAgICAgICB0eXBlOiAiZXZlbnQiLAogICAgICAgICAgICAgICAgbmFtZTogbmFtZSwKICAgICAgICAgICAgICAgIGRhdGE6IGRhdGEKICAgICAgICAgICAgfSk7CiAgICAgICAgfTsKICAgICAgICAKICAgIH0pLmNhbGwoU2VuZGVyLnByb3RvdHlwZSk7CiAgICAKICAgIHJldHVybiBuZXcgU2VuZGVyKCk7Cn07Cgp2YXIgbWFpbiA9IHdpbmRvdy5tYWluID0gbnVsbDsKdmFyIHNlbmRlciA9IHdpbmRvdy5zZW5kZXIgPSBudWxsOwoKd2luZG93Lm9ubWVzc2FnZSA9IGZ1bmN0aW9uKGUpIHsKICAgIHZhciBtc2cgPSBlLmRhdGE7CiAgICBpZiAobXNnLmV2ZW50ICYmIHNlbmRlcikgewogICAgICAgIHNlbmRlci5fc2lnbmFsKG1zZy5ldmVudCwgbXNnLmRhdGEpOwogICAgfQogICAgZWxzZSBpZiAobXNnLmNvbW1hbmQpIHsKICAgICAgICBpZiAobWFpblttc2cuY29tbWFuZF0pCiAgICAgICAgICAgIG1haW5bbXNnLmNvbW1hbmRdLmFwcGx5KG1haW4sIG1zZy5hcmdzKTsKICAgICAgICBlbHNlIGlmICh3aW5kb3dbbXNnLmNvbW1hbmRdKQogICAgICAgICAgICB3aW5kb3dbbXNnLmNvbW1hbmRdLmFwcGx5KHdpbmRvdywgbXNnLmFyZ3MpOwogICAgICAgIGVsc2UKICAgICAgICAgICAgdGhyb3cgbmV3IEVycm9yKCJVbmtub3duIGNvbW1hbmQ6IiArIG1zZy5jb21tYW5kKTsKICAgIH0KICAgIGVsc2UgaWYgKG1zZy5pbml0KSB7CiAgICAgICAgd2luZG93LmluaXRCYXNlVXJscyhtc2cudGxucyk7CiAgICAgICAgc2VuZGVyID0gd2luZG93LnNlbmRlciA9IHdpbmRvdy5pbml0U2VuZGVyKCk7CiAgICAgICAgdmFyIGNsYXp6ID0gdGhpcy5yZXF1aXJlKG1zZy5tb2R1bGUpW21zZy5jbGFzc25hbWVdOwogICAgICAgIG1haW4gPSB3aW5kb3cubWFpbiA9IG5ldyBjbGF6eihzZW5kZXIpOwogICAgfQp9Owp9KSh0aGlzKTsKCmFjZS5kZWZpbmUoImFjZS9saWIvb29wIixbXSwgZnVuY3Rpb24ocmVxdWlyZSwgZXhwb3J0cywgbW9kdWxlKXsidXNlIHN0cmljdCI7CmV4cG9ydHMuaW5oZXJpdHMgPSBmdW5jdGlvbiAoY3Rvciwgc3VwZXJDdG9yKSB7CiAgICBjdG9yLnN1cGVyXyA9IHN1cGVyQ3RvcjsKICAgIGN0b3IucHJvdG90eXBlID0gT2JqZWN0LmNyZWF0ZShzdXBlckN0b3IucHJvdG90eXBlLCB7CiAgICAgICAgY29uc3RydWN0b3I6IHsKICAgICAgICAgICAgdmFsdWU6IGN0b3IsCiAgICAgICAgICAgIGVudW1lcmFibGU6IGZhbHNlLAogICAgICAgICAgICB3cml0YWJsZTogdHJ1ZSwKICAgICAgICAgICAgY29uZmlndXJhYmxlOiB0cnVlCiAgICAgICAgfQogICAgfSk7Cn07CmV4cG9ydHMubWl4aW4gPSBmdW5jdGlvbiAob2JqLCBtaXhpbikgewogICAgZm9yICh2YXIga2V5IGluIG1peGluKSB7CiAgICAgICAgb2JqW2tleV0gPSBtaXhpbltrZXldOwogICAgfQogICAgcmV0dXJuIG9iajsKfTsKZXhwb3J0cy5pbXBsZW1lbnQgPSBmdW5jdGlvbiAocHJvdG8sIG1peGluKSB7CiAgICBleHBvcnRzLm1peGluKHByb3RvLCBtaXhpbik7Cn07Cgp9KTsKCmFjZS5kZWZpbmUoImFjZS9hcHBseV9kZWx0YSIsW10sIGZ1bmN0aW9uKHJlcXVpcmUsIGV4cG9ydHMsIG1vZHVsZSl7InVzZSBzdHJpY3QiOwpmdW5jdGlvbiB0aHJvd0RlbHRhRXJyb3IoZGVsdGEsIGVycm9yVGV4dCkgewogICAgY29uc29sZS5sb2coIkludmFsaWQgRGVsdGE6IiwgZGVsdGEpOwogICAgdGhyb3cgIkludmFsaWQgRGVsdGE6ICIgKyBlcnJvclRleHQ7Cn0KZnVuY3Rpb24gcG9zaXRpb25JbkRvY3VtZW50KGRvY0xpbmVzLCBwb3NpdGlvbikgewogICAgcmV0dXJuIHBvc2l0aW9uLnJvdyA+PSAwICYmIHBvc2l0aW9uLnJvdyA8IGRvY0xpbmVzLmxlbmd0aCAmJgogICAgICAgIHBvc2l0aW9uLmNvbHVtbiA+PSAwICYmIHBvc2l0aW9uLmNvbHVtbiA8PSBkb2NMaW5lc1twb3NpdGlvbi5yb3ddLmxlbmd0aDsKfQpmdW5jdGlvbiB2YWxpZGF0ZURlbHRhKGRvY0xpbmVzLCBkZWx0YSkgewogICAgaWYgKGRlbHRhLmFjdGlvbiAhPSAiaW5zZXJ0IiAmJiBkZWx0YS5hY3Rpb24gIT0gInJlbW92ZSIpCiAgICAgICAgdGhyb3dEZWx0YUVycm9yKGRlbHRhLCAiZGVsdGEuYWN0aW9uIG11c3QgYmUgJ2luc2VydCcgb3IgJ3JlbW92ZSciKTsKICAgIGlmICghKGRlbHRhLmxpbmVzIGluc3RhbmNlb2YgQXJyYXkpKQogICAgICAgIHRocm93RGVsdGFFcnJvcihkZWx0YSwgImRlbHRhLmxpbmVzIG11c3QgYmUgYW4gQXJyYXkiKTsKICAgIGlmICghZGVsdGEuc3RhcnQgfHwgIWRlbHRhLmVuZCkKICAgICAgICB0aHJvd0RlbHRhRXJyb3IoZGVsdGEsICJkZWx0YS5zdGFydC9lbmQgbXVzdCBiZSBhbiBwcmVzZW50Iik7CiAgICB2YXIgc3RhcnQgPSBkZWx0YS5zdGFydDsKICAgIGlmICghcG9zaXRpb25JbkRvY3VtZW50KGRvY0xpbmVzLCBkZWx0YS5zdGFydCkpCiAgICAgICAgdGhyb3dEZWx0YUVycm9yKGRlbHRhLCAiZGVsdGEuc3RhcnQgbXVzdCBiZSBjb250YWluZWQgaW4gZG9jdW1lbnQiKTsKICAgIHZhciBlbmQgPSBkZWx0YS5lbmQ7CiAgICBpZiAoZGVsdGEuYWN0aW9uID09ICJyZW1vdmUiICYmICFwb3NpdGlvbkluRG9jdW1lbnQoZG9jTGluZXMsIGVuZCkpCiAgICAgICAgdGhyb3dEZWx0YUVycm9yKGRlbHRhLCAiZGVsdGEuZW5kIG11c3QgY29udGFpbmVkIGluIGRvY3VtZW50IGZvciAncmVtb3ZlJyBhY3Rpb25zIik7CiAgICB2YXIgbnVtUmFuZ2VSb3dzID0gZW5kLnJvdyAtIHN0YXJ0LnJvdzsKICAgIHZhciBudW1SYW5nZUxhc3RMaW5lQ2hhcnMgPSAoZW5kLmNvbHVtbiAtIChudW1SYW5nZVJvd3MgPT0gMCA/IHN0YXJ0LmNvbHVtbiA6IDApKTsKICAgIGlmIChudW1SYW5nZVJvd3MgIT0gZGVsdGEubGluZXMubGVuZ3RoIC0gMSB8fCBkZWx0YS5saW5lc1tudW1SYW5nZVJvd3NdLmxlbmd0aCAhPSBudW1SYW5nZUxhc3RMaW5lQ2hhcnMpCiAgICAgICAgdGhyb3dEZWx0YUVycm9yKGRlbHRhLCAiZGVsdGEucmFuZ2UgbXVzdCBtYXRjaCBkZWx0YSBsaW5lcyIpOwp9CmV4cG9ydHMuYXBwbHlEZWx0YSA9IGZ1bmN0aW9uIChkb2NMaW5lcywgZGVsdGEsIGRvTm90VmFsaWRhdGUpIHsKICAgIHZhciByb3cgPSBkZWx0YS5zdGFydC5yb3c7CiAgICB2YXIgc3RhcnRDb2x1bW4gPSBkZWx0YS5zdGFydC5jb2x1bW47CiAgICB2YXIgbGluZSA9IGRvY0xpbmVzW3Jvd10gfHwgIiI7CiAgICBzd2l0Y2ggKGRlbHRhLmFjdGlvbikgewogICAgICAgIGNhc2UgImluc2VydCI6CiAgICAgICAgICAgIHZhciBsaW5lcyA9IGRlbHRhLmxpbmVzOwogICAgICAgICAgICBpZiAobGluZXMubGVuZ3RoID09PSAxKSB7CiAgICAgICAgICAgICAgICBkb2NMaW5lc1tyb3ddID0gbGluZS5zdWJzdHJpbmcoMCwgc3RhcnRDb2x1bW4pICsgZGVsdGEubGluZXNbMF0gKyBsaW5lLnN1YnN0cmluZyhzdGFydENvbHVtbik7CiAgICAgICAgICAgIH0KICAgICAgICAgICAgZWxzZSB7CiAgICAgICAgICAgICAgICB2YXIgYXJncyA9IFtyb3csIDFdLmNvbmNhdChkZWx0YS5saW5lcyk7CiAgICAgICAgICAgICAgICBkb2NMaW5lcy5zcGxpY2UuYXBwbHkoZG9jTGluZXMsIGFyZ3MpOwogICAgICAgICAgICAgICAgZG9jTGluZXNbcm93XSA9IGxpbmUuc3Vic3RyaW5nKDAsIHN0YXJ0Q29sdW1uKSArIGRvY0xpbmVzW3Jvd107CiAgICAgICAgICAgICAgICBkb2NMaW5lc1tyb3cgKyBkZWx0YS5saW5lcy5sZW5ndGggLSAxXSArPSBsaW5lLnN1YnN0cmluZyhzdGFydENvbHVtbik7CiAgICAgICAgICAgIH0KICAgICAgICAgICAgYnJlYWs7CiAgICAgICAgY2FzZSAicmVtb3ZlIjoKICAgICAgICAgICAgdmFyIGVuZENvbHVtbiA9IGRlbHRhLmVuZC5jb2x1bW47CiAgICAgICAgICAgIHZhciBlbmRSb3cgPSBkZWx0YS5lbmQucm93OwogICAgICAgICAgICBpZiAocm93ID09PSBlbmRSb3cpIHsKICAgICAgICAgICAgICAgIGRvY0xpbmVzW3Jvd10gPSBsaW5lLnN1YnN0cmluZygwLCBzdGFydENvbHVtbikgKyBsaW5lLnN1YnN0cmluZyhlbmRDb2x1bW4pOwogICAgICAgICAgICB9CiAgICAgICAgICAgIGVsc2UgewogICAgICAgICAgICAgICAgZG9jTGluZXMuc3BsaWNlKHJvdywgZW5kUm93IC0gcm93ICsgMSwgbGluZS5zdWJzdHJpbmcoMCwgc3RhcnRDb2x1bW4pICsgZG9jTGluZXNbZW5kUm93XS5zdWJzdHJpbmcoZW5kQ29sdW1uKSk7CiAgICAgICAgICAgIH0KICAgICAgICAgICAgYnJlYWs7CiAgICB9Cn07Cgp9KTsKCmFjZS5kZWZpbmUoImFjZS9saWIvZXZlbnRfZW1pdHRlciIsW10sIGZ1bmN0aW9uKHJlcXVpcmUsIGV4cG9ydHMsIG1vZHVsZSl7InVzZSBzdHJpY3QiOwp2YXIgRXZlbnRFbWl0dGVyID0ge307CnZhciBzdG9wUHJvcGFnYXRpb24gPSBmdW5jdGlvbiAoKSB7IHRoaXMucHJvcGFnYXRpb25TdG9wcGVkID0gdHJ1ZTsgfTsKdmFyIHByZXZlbnREZWZhdWx0ID0gZnVuY3Rpb24gKCkgeyB0aGlzLmRlZmF1bHRQcmV2ZW50ZWQgPSB0cnVlOyB9OwpFdmVudEVtaXR0ZXIuX2VtaXQgPQogICAgRXZlbnRFbWl0dGVyLl9kaXNwYXRjaEV2ZW50ID0gZnVuY3Rpb24gKGV2ZW50TmFtZSwgZSkgewogICAgICAgIHRoaXMuX2V2ZW50UmVnaXN0cnkgfHwgKHRoaXMuX2V2ZW50UmVnaXN0cnkgPSB7fSk7CiAgICAgICAgdGhpcy5fZGVmYXVsdEhhbmRsZXJzIHx8ICh0aGlzLl9kZWZhdWx0SGFuZGxlcnMgPSB7fSk7CiAgICAgICAgdmFyIGxpc3RlbmVycyA9IHRoaXMuX2V2ZW50UmVnaXN0cnlbZXZlbnROYW1lXSB8fCBbXTsKICAgICAgICB2YXIgZGVmYXVsdEhhbmRsZXIgPSB0aGlzLl9kZWZhdWx0SGFuZGxlcnNbZXZlbnROYW1lXTsKICAgICAgICBpZiAoIWxpc3RlbmVycy5sZW5ndGggJiYgIWRlZmF1bHRIYW5kbGVyKQogICAgICAgICAgICByZXR1cm47CiAgICAgICAgaWYgKHR5cGVvZiBlICE9ICJvYmplY3QiIHx8ICFlKQogICAgICAgICAgICBlID0ge307CiAgICAgICAgaWYgKCFlLnR5cGUpCiAgICAgICAgICAgIGUudHlwZSA9IGV2ZW50TmFtZTsKICAgICAgICBpZiAoIWUuc3RvcFByb3BhZ2F0aW9uKQogICAgICAgICAgICBlLnN0b3BQcm9wYWdhdGlvbiA9IHN0b3BQcm9wYWdhdGlvbjsKICAgICAgICBpZiAoIWUucHJldmVudERlZmF1bHQpCiAgICAgICAgICAgIGUucHJldmVudERlZmF1bHQgPSBwcmV2ZW50RGVmYXVsdDsKICAgICAgICBsaXN0ZW5lcnMgPSBsaXN0ZW5lcnMuc2xpY2UoKTsKICAgICAgICBmb3IgKHZhciBpID0gMDsgaSA8IGxpc3RlbmVycy5sZW5ndGg7IGkrKykgewogICAgICAgICAgICBsaXN0ZW5lcnNbaV0oZSwgdGhpcyk7CiAgICAgICAgICAgIGlmIChlLnByb3BhZ2F0aW9uU3RvcHBlZCkKICAgICAgICAgICAgICAgIGJyZWFrOwogICAgICAgIH0KICAgICAgICBpZiAoZGVmYXVsdEhhbmRsZXIgJiYgIWUuZGVmYXVsdFByZXZlbnRlZCkKICAgICAgICAgICAgcmV0dXJuIGRlZmF1bHRIYW5kbGVyKGUsIHRoaXMpOwogICAgfTsKRXZlbnRFbWl0dGVyLl9zaWduYWwgPSBmdW5jdGlvbiAoZXZlbnROYW1lLCBlKSB7CiAgICB2YXIgbGlzdGVuZXJzID0gKHRoaXMuX2V2ZW50UmVnaXN0cnkgfHwge30pW2V2ZW50TmFtZV07CiAgICBpZiAoIWxpc3RlbmVycykKICAgICAgICByZXR1cm47CiAgICBsaXN0ZW5lcnMgPSBsaXN0ZW5lcnMuc2xpY2UoKTsKICAgIGZvciAodmFyIGkgPSAwOyBpIDwgbGlzdGVuZXJzLmxlbmd0aDsgaSsrKQogICAgICAgIGxpc3RlbmVyc1tpXShlLCB0aGlzKTsKfTsKRXZlbnRFbWl0dGVyLm9uY2UgPSBmdW5jdGlvbiAoZXZlbnROYW1lLCBjYWxsYmFjaykgewogICAgdmFyIF9zZWxmID0gdGhpczsKICAgIHRoaXMub24oZXZlbnROYW1lLCBmdW5jdGlvbiBuZXdDYWxsYmFjaygpIHsKICAgICAgICBfc2VsZi5vZmYoZXZlbnROYW1lLCBuZXdDYWxsYmFjayk7CiAgICAgICAgY2FsbGJhY2suYXBwbHkobnVsbCwgYXJndW1lbnRzKTsKICAgIH0pOwogICAgaWYgKCFjYWxsYmFjaykgewogICAgICAgIHJldHVybiBuZXcgUHJvbWlzZShmdW5jdGlvbiAocmVzb2x2ZSkgewogICAgICAgICAgICBjYWxsYmFjayA9IHJlc29sdmU7CiAgICAgICAgfSk7CiAgICB9Cn07CkV2ZW50RW1pdHRlci5zZXREZWZhdWx0SGFuZGxlciA9IGZ1bmN0aW9uIChldmVudE5hbWUsIGNhbGxiYWNrKSB7CiAgICB2YXIgaGFuZGxlcnMgPSB0aGlzLl9kZWZhdWx0SGFuZGxlcnM7CiAgICBpZiAoIWhhbmRsZXJzKQogICAgICAgIGhhbmRsZXJzID0gdGhpcy5fZGVmYXVsdEhhbmRsZXJzID0geyBfZGlzYWJsZWRfOiB7fSB9OwogICAgaWYgKGhhbmRsZXJzW2V2ZW50TmFtZV0pIHsKICAgICAgICB2YXIgb2xkID0gaGFuZGxlcnNbZXZlbnROYW1lXTsKICAgICAgICB2YXIgZGlzYWJsZWQgPSBoYW5kbGVycy5fZGlzYWJsZWRfW2V2ZW50TmFtZV07CiAgICAgICAgaWYgKCFkaXNhYmxlZCkKICAgICAgICAgICAgaGFuZGxlcnMuX2Rpc2FibGVkX1tldmVudE5hbWVdID0gZGlzYWJsZWQgPSBbXTsKICAgICAgICBkaXNhYmxlZC5wdXNoKG9sZCk7CiAgICAgICAgdmFyIGkgPSBkaXNhYmxlZC5pbmRleE9mKGNhbGxiYWNrKTsKICAgICAgICBpZiAoaSAhPSAtMSkKICAgICAgICAgICAgZGlzYWJsZWQuc3BsaWNlKGksIDEpOwogICAgfQogICAgaGFuZGxlcnNbZXZlbnROYW1lXSA9IGNhbGxiYWNrOwp9OwpFdmVudEVtaXR0ZXIucmVtb3ZlRGVmYXVsdEhhbmRsZXIgPSBmdW5jdGlvbiAoZXZlbnROYW1lLCBjYWxsYmFjaykgewogICAgdmFyIGhhbmRsZXJzID0gdGhpcy5fZGVmYXVsdEhhbmRsZXJzOwogICAgaWYgKCFoYW5kbGVycykKICAgICAgICByZXR1cm47CiAgICB2YXIgZGlzYWJsZWQgPSBoYW5kbGVycy5fZGlzYWJsZWRfW2V2ZW50TmFtZV07CiAgICBpZiAoaGFuZGxlcnNbZXZlbnROYW1lXSA9PSBjYWxsYmFjaykgewogICAgICAgIGlmIChkaXNhYmxlZCkKICAgICAgICAgICAgdGhpcy5zZXREZWZhdWx0SGFuZGxlcihldmVudE5hbWUsIGRpc2FibGVkLnBvcCgpKTsKICAgIH0KICAgIGVsc2UgaWYgKGRpc2FibGVkKSB7CiAgICAgICAgdmFyIGkgPSBkaXNhYmxlZC5pbmRleE9mKGNhbGxiYWNrKTsKICAgICAgICBpZiAoaSAhPSAtMSkKICAgICAgICAgICAgZGlzYWJsZWQuc3BsaWNlKGksIDEpOwogICAgfQp9OwpFdmVudEVtaXR0ZXIub24gPQogICAgRXZlbnRFbWl0dGVyLmFkZEV2ZW50TGlzdGVuZXIgPSBmdW5jdGlvbiAoZXZlbnROYW1lLCBjYWxsYmFjaywgY2FwdHVyaW5nKSB7CiAgICAgICAgdGhpcy5fZXZlbnRSZWdpc3RyeSA9IHRoaXMuX2V2ZW50UmVnaXN0cnkgfHwge307CiAgICAgICAgdmFyIGxpc3RlbmVycyA9IHRoaXMuX2V2ZW50UmVnaXN0cnlbZXZlbnROYW1lXTsKICAgICAgICBpZiAoIWxpc3RlbmVycykKICAgICAgICAgICAgbGlzdGVuZXJzID0gdGhpcy5fZXZlbnRSZWdpc3RyeVtldmVudE5hbWVdID0gW107CiAgICAgICAgaWYgKGxpc3RlbmVycy5pbmRleE9mKGNhbGxiYWNrKSA9PSAtMSkKICAgICAgICAgICAgbGlzdGVuZXJzW2NhcHR1cmluZyA/ICJ1bnNoaWZ0IiA6ICJwdXNoIl0oY2FsbGJhY2spOwogICAgICAgIHJldHVybiBjYWxsYmFjazsKICAgIH07CkV2ZW50RW1pdHRlci5vZmYgPQogICAgRXZlbnRFbWl0dGVyLnJlbW92ZUxpc3RlbmVyID0KICAgICAgICBFdmVudEVtaXR0ZXIucmVtb3ZlRXZlbnRMaXN0ZW5lciA9IGZ1bmN0aW9uIChldmVudE5hbWUsIGNhbGxiYWNrKSB7CiAgICAgICAgICAgIHRoaXMuX2V2ZW50UmVnaXN0cnkgPSB0aGlzLl9ldmVudFJlZ2lzdHJ5IHx8IHt9OwogICAgICAgICAgICB2YXIgbGlzdGVuZXJzID0gdGhpcy5fZXZlbnRSZWdpc3RyeVtldmVudE5hbWVdOwogICAgICAgICAgICBpZiAoIWxpc3RlbmVycykKICAgICAgICAgICAgICAgIHJldHVybjsKICAgICAgICAgICAgdmFyIGluZGV4ID0gbGlzdGVuZXJzLmluZGV4T2YoY2FsbGJhY2spOwogICAgICAgICAgICBpZiAoaW5kZXggIT09IC0xKQogICAgICAgICAgICAgICAgbGlzdGVuZXJzLnNwbGljZShpbmRleCwgMSk7CiAgICAgICAgfTsKRXZlbnRFbWl0dGVyLnJlbW92ZUFsbExpc3RlbmVycyA9IGZ1bmN0aW9uIChldmVudE5hbWUpIHsKICAgIGlmICghZXZlbnROYW1lKQogICAgICAgIHRoaXMuX2V2ZW50UmVnaXN0cnkgPSB0aGlzLl9kZWZhdWx0SGFuZGxlcnMgPSB1bmRlZmluZWQ7CiAgICBpZiAodGhpcy5fZXZlbnRSZWdpc3RyeSkKICAgICAgICB0aGlzLl9ldmVudFJlZ2lzdHJ5W2V2ZW50TmFtZV0gPSB1bmRlZmluZWQ7CiAgICBpZiAodGhpcy5fZGVmYXVsdEhhbmRsZXJzKQogICAgICAgIHRoaXMuX2RlZmF1bHRIYW5kbGVyc1tldmVudE5hbWVdID0gdW5kZWZpbmVkOwp9OwpleHBvcnRzLkV2ZW50RW1pdHRlciA9IEV2ZW50RW1pdHRlcjsKCn0pOwoKYWNlLmRlZmluZSgiYWNlL3JhbmdlIixbXSwgZnVuY3Rpb24ocmVxdWlyZSwgZXhwb3J0cywgbW9kdWxlKXsidXNlIHN0cmljdCI7CnZhciBSYW5nZSA9IC8qKiBAY2xhc3MgKi8gKGZ1bmN0aW9uICgpIHsKICAgIGZ1bmN0aW9uIFJhbmdlKHN0YXJ0Um93LCBzdGFydENvbHVtbiwgZW5kUm93LCBlbmRDb2x1bW4pIHsKICAgICAgICB0aGlzLnN0YXJ0ID0gewogICAgICAgICAgICByb3c6IHN0YXJ0Um93LAogICAgICAgICAgICBjb2x1bW46IHN0YXJ0Q29sdW1uCiAgICAgICAgfTsKICAgICAgICB0aGlzLmVuZCA9IHsKICAgICAgICAgICAgcm93OiBlbmRSb3csCiAgICAgICAgICAgIGNvbHVtbjogZW5kQ29sdW1uCiAgICAgICAgfTsKICAgIH0KICAgIFJhbmdlLnByb3RvdHlwZS5pc0VxdWFsID0gZnVuY3Rpb24gKHJhbmdlKSB7CiAgICAgICAgcmV0dXJuIHRoaXMuc3RhcnQucm93ID09PSByYW5nZS5zdGFydC5yb3cgJiYKICAgICAgICAgICAgdGhpcy5lbmQucm93ID09PSByYW5nZS5lbmQucm93ICYmCiAgICAgICAgICAgIHRoaXMuc3RhcnQuY29sdW1uID09PSByYW5nZS5zdGFydC5jb2x1bW4gJiYKICAgICAgICAgICAgdGhpcy5lbmQuY29sdW1uID09PSByYW5nZS5lbmQuY29sdW1uOwogICAgfTsKICAgIFJhbmdlLnByb3RvdHlwZS50b1N0cmluZyA9IGZ1bmN0aW9uICgpIHsKICAgICAgICByZXR1cm4gKCJSYW5nZTogWyIgKyB0aGlzLnN0YXJ0LnJvdyArICIvIiArIHRoaXMuc3RhcnQuY29sdW1uICsKICAgICAgICAgICAgIl0gLT4gWyIgKyB0aGlzLmVuZC5yb3cgKyAiLyIgKyB0aGlzLmVuZC5jb2x1bW4gKyAiXSIpOwogICAgfTsKICAgIFJhbmdlLnByb3RvdHlwZS5jb250YWlucyA9IGZ1bmN0aW9uIChyb3csIGNvbHVtbikgewogICAgICAgIHJldHVybiB0aGlzLmNvbXBhcmUocm93LCBjb2x1bW4pID09IDA7CiAgICB9OwogICAgUmFuZ2UucHJvdG90eXBlLmNvbXBhcmVSYW5nZSA9IGZ1bmN0aW9uIChyYW5nZSkgewogICAgICAgIHZhciBjbXAsIGVuZCA9IHJhbmdlLmVuZCwgc3RhcnQgPSByYW5nZS5zdGFydDsKICAgICAgICBjbXAgPSB0aGlzLmNvbXBhcmUoZW5kLnJvdywgZW5kLmNvbHVtbik7CiAgICAgICAgaWYgKGNtcCA9PSAxKSB7CiAgICAgICAgICAgIGNtcCA9IHRoaXMuY29tcGFyZShzdGFydC5yb3csIHN0YXJ0LmNvbHVtbik7CiAgICAgICAgICAgIGlmIChjbXAgPT0gMSkgewogICAgICAgICAgICAgICAgcmV0dXJuIDI7CiAgICAgICAgICAgIH0KICAgICAgICAgICAgZWxzZSBpZiAoY21wID09IDApIHsKICAgICAgICAgICAgICAgIHJldHVybiAxOwogICAgICAgICAgICB9CiAgICAgICAgICAgIGVsc2UgewogICAgICAgICAgICAgICAgcmV0dXJuIDA7CiAgICAgICAgICAgIH0KICAgICAgICB9CiAgICAgICAgZWxzZSBpZiAoY21wID09IC0xKSB7CiAgICAgICAgICAgIHJldHVybiAtMjsKICAgICAgICB9CiAgICAgICAgZWxzZSB7CiAgICAgICAgICAgIGNtcCA9IHRoaXMuY29tcGFyZShzdGFydC5yb3csIHN0YXJ0LmNvbHVtbik7CiAgICAgICAgICAgIGlmIChjbXAgPT0gLTEpIHsKICAgICAgICAgICAgICAgIHJldHVybiAtMTsKICAgICAgICAgICAgfQogICAgICAgICAgICBlbHNlIGlmIChjbXAgPT0gMSkgewogICAgICAgICAgICAgICAgcmV0dXJuIDQyOwogICAgICAgICAgICB9CiAgICAgICAgICAgIGVsc2UgewogICAgICAgICAgICAgICAgcmV0dXJuIDA7CiAgICAgICAgICAgIH0KICAgICAgICB9CiAgICB9OwogICAgUmFuZ2UucHJvdG90eXBlLmNvbXBhcmVQb2ludCA9IGZ1bmN0aW9uIChwKSB7CiAgICAgICAgcmV0dXJuIHRoaXMuY29tcGFyZShwLnJvdywgcC5jb2x1bW4pOwogICAgfTsKICAgIFJhbmdlLnByb3RvdHlwZS5jb250YWluc1JhbmdlID0gZnVuY3Rpb24gKHJhbmdlKSB7CiAgICAgICAgcmV0dXJuIHRoaXMuY29tcGFyZVBvaW50KHJhbmdlLnN0YXJ0KSA9PSAwICYmIHRoaXMuY29tcGFyZVBvaW50KHJhbmdlLmVuZCkgPT0gMDsKICAgIH07CiAgICBSYW5nZS5wcm90b3R5cGUuaW50ZXJzZWN0cyA9IGZ1bmN0aW9uIChyYW5nZSkgewogICAgICAgIHZhciBjbXAgPSB0aGlzLmNvbXBhcmVSYW5nZShyYW5nZSk7CiAgICAgICAgcmV0dXJuIChjbXAgPT0gLTEgfHwgY21wID09IDAgfHwgY21wID09IDEpOwogICAgfTsKICAgIFJhbmdlLnByb3RvdHlwZS5pc0VuZCA9IGZ1bmN0aW9uIChyb3csIGNvbHVtbikgewogICAgICAgIHJldHVybiB0aGlzLmVuZC5yb3cgPT0gcm93ICYmIHRoaXMuZW5kLmNvbHVtbiA9PSBjb2x1bW47CiAgICB9OwogICAgUmFuZ2UucHJvdG90eXBlLmlzU3RhcnQgPSBmdW5jdGlvbiAocm93LCBjb2x1bW4pIHsKICAgICAgICByZXR1cm4gdGhpcy5zdGFydC5yb3cgPT0gcm93ICYmIHRoaXMuc3RhcnQuY29sdW1uID09IGNvbHVtbjsKICAgIH07CiAgICBSYW5nZS5wcm90b3R5cGUuc2V0U3RhcnQgPSBmdW5jdGlvbiAocm93LCBjb2x1bW4pIHsKICAgICAgICBpZiAodHlwZW9mIHJvdyA9PSAib2JqZWN0IikgewogICAgICAgICAgICB0aGlzLnN0YXJ0LmNvbHVtbiA9IHJvdy5jb2x1bW47CiAgICAgICAgICAgIHRoaXMuc3RhcnQucm93ID0gcm93LnJvdzsKICAgICAgICB9CiAgICAgICAgZWxzZSB7CiAgICAgICAgICAgIHRoaXMuc3RhcnQucm93ID0gcm93OwogICAgICAgICAgICB0aGlzLnN0YXJ0LmNvbHVtbiA9IGNvbHVtbjsKICAgICAgICB9CiAgICB9OwogICAgUmFuZ2UucHJvdG90eXBlLnNldEVuZCA9IGZ1bmN0aW9uIChyb3csIGNvbHVtbikgewogICAgICAgIGlmICh0eXBlb2Ygcm93ID09ICJvYmplY3QiKSB7CiAgICAgICAgICAgIHRoaXMuZW5kLmNvbHVtbiA9IHJvdy5jb2x1bW47CiAgICAgICAgICAgIHRoaXMuZW5kLnJvdyA9IHJvdy5yb3c7CiAgICAgICAgfQogICAgICAgIGVsc2UgewogICAgICAgICAgICB0aGlzLmVuZC5yb3cgPSByb3c7CiAgICAgICAgICAgIHRoaXMuZW5kLmNvbHVtbiA9IGNvbHVtbjsKICAgICAgICB9CiAgICB9OwogICAgUmFuZ2UucHJvdG90eXBlLmluc2lkZSA9IGZ1bmN0aW9uIChyb3csIGNvbHVtbikgewogICAgICAgIGlmICh0aGlzLmNvbXBhcmUocm93LCBjb2x1bW4pID09IDApIHsKICAgICAgICAgICAgaWYgKHRoaXMuaXNFbmQocm93LCBjb2x1bW4pIHx8IHRoaXMuaXNTdGFydChyb3csIGNvbHVtbikpIHsKICAgICAgICAgICAgICAgIHJldHVybiBmYWxzZTsKICAgICAgICAgICAgfQogICAgICAgICAgICBlbHNlIHsKICAgICAgICAgICAgICAgIHJldHVybiB0cnVlOwogICAgICAgICAgICB9CiAgICAgICAgfQogICAgICAgIHJldHVybiBmYWxzZTsKICAgIH07CiAgICBSYW5nZS5wcm90b3R5cGUuaW5zaWRlU3RhcnQgPSBmdW5jdGlvbiAocm93LCBjb2x1bW4pIHsKICAgICAgICBpZiAodGhpcy5jb21wYXJlKHJvdywgY29sdW1uKSA9PSAwKSB7CiAgICAgICAgICAgIGlmICh0aGlzLmlzRW5kKHJvdywgY29sdW1uKSkgewogICAgICAgICAgICAgICAgcmV0dXJuIGZhbHNlOwogICAgICAgICAgICB9CiAgICAgICAgICAgIGVsc2UgewogICAgICAgICAgICAgICAgcmV0dXJuIHRydWU7CiAgICAgICAgICAgIH0KICAgICAgICB9CiAgICAgICAgcmV0dXJuIGZhbHNlOwogICAgfTsKICAgIFJhbmdlLnByb3RvdHlwZS5pbnNpZGVFbmQgPSBmdW5jdGlvbiAocm93LCBjb2x1bW4pIHsKICAgICAgICBpZiAodGhpcy5jb21wYXJlKHJvdywgY29sdW1uKSA9PSAwKSB7CiAgICAgICAgICAgIGlmICh0aGlzLmlzU3RhcnQocm93LCBjb2x1bW4pKSB7CiAgICAgICAgICAgICAgICByZXR1cm4gZmFsc2U7CiAgICAgICAgICAgIH0KICAgICAgICAgICAgZWxzZSB7CiAgICAgICAgICAgICAgICByZXR1cm4gdHJ1ZTsKICAgICAgICAgICAgfQogICAgICAgIH0KICAgICAgICByZXR1cm4gZmFsc2U7CiAgICB9OwogICAgUmFuZ2UucHJvdG90eXBlLmNvbXBhcmUgPSBmdW5jdGlvbiAocm93LCBjb2x1bW4pIHsKICAgICAgICBpZiAoIXRoaXMuaXNNdWx0aUxpbmUoKSkgewogICAgICAgICAgICBpZiAocm93ID09PSB0aGlzLnN0YXJ0LnJvdykgewogICAgICAgICAgICAgICAgcmV0dXJuIGNvbHVtbiA8IHRoaXMuc3RhcnQuY29sdW1uID8gLTEgOiAoY29sdW1uID4gdGhpcy5lbmQuY29sdW1uID8gMSA6IDApOwogICAgICAgICAgICB9CiAgICAgICAgfQogICAgICAgIGlmIChyb3cgPCB0aGlzLnN0YXJ0LnJvdykKICAgICAgICAgICAgcmV0dXJuIC0xOwogICAgICAgIGlmIChyb3cgPiB0aGlzLmVuZC5yb3cpCiAgICAgICAgICAgIHJldHVybiAxOwogICAgICAgIGlmICh0aGlzLnN0YXJ0LnJvdyA9PT0gcm93KQogICAgICAgICAgICByZXR1cm4gY29sdW1uID49IHRoaXMuc3RhcnQuY29sdW1uID8gMCA6IC0xOwogICAgICAgIGlmICh0aGlzLmVuZC5yb3cgPT09IHJvdykKICAgICAgICAgICAgcmV0dXJuIGNvbHVtbiA8PSB0aGlzLmVuZC5jb2x1bW4gPyAwIDogMTsKICAgICAgICByZXR1cm4gMDsKICAgIH07CiAgICBSYW5nZS5wcm90b3R5cGUuY29tcGFyZVN0YXJ0ID0gZnVuY3Rpb24gKHJvdywgY29sdW1uKSB7CiAgICAgICAgaWYgKHRoaXMuc3RhcnQucm93ID09IHJvdyAmJiB0aGlzLnN0YXJ0LmNvbHVtbiA9PSBjb2x1bW4pIHsKICAgICAgICAgICAgcmV0dXJuIC0xOwogICAgICAgIH0KICAgICAgICBlbHNlIHsKICAgICAgICAgICAgcmV0dXJuIHRoaXMuY29tcGFyZShyb3csIGNvbHVtbik7CiAgICAgICAgfQogICAgfTsKICAgIFJhbmdlLnByb3RvdHlwZS5jb21wYXJlRW5kID0gZnVuY3Rpb24gKHJvdywgY29sdW1uKSB7CiAgICAgICAgaWYgKHRoaXMuZW5kLnJvdyA9PSByb3cgJiYgdGhpcy5lbmQuY29sdW1uID09IGNvbHVtbikgewogICAgICAgICAgICByZXR1cm4gMTsKICAgICAgICB9CiAgICAgICAgZWxzZSB7CiAgICAgICAgICAgIHJldHVybiB0aGlzLmNvbXBhcmUocm93LCBjb2x1bW4pOwogICAgICAgIH0KICAgIH07CiAgICBSYW5nZS5wcm90b3R5cGUuY29tcGFyZUluc2lkZSA9IGZ1bmN0aW9uIChyb3csIGNvbHVtbikgewogICAgICAgIGlmICh0aGlzLmVuZC5yb3cgPT0gcm93ICYmIHRoaXMuZW5kLmNvbHVtbiA9PSBjb2x1bW4pIHsKICAgICAgICAgICAgcmV0dXJuIDE7CiAgICAgICAgfQogICAgICAgIGVsc2UgaWYgKHRoaXMuc3RhcnQucm93ID09IHJvdyAmJiB0aGlzLnN0YXJ0LmNvbHVtbiA9PSBjb2x1bW4pIHsKICAgICAgICAgICAgcmV0dXJuIC0xOwogICAgICAgIH0KICAgICAgICBlbHNlIHsKICAgICAgICAgICAgcmV0dXJuIHRoaXMuY29tcGFyZShyb3csIGNvbHVtbik7CiAgICAgICAgfQogICAgfTsKICAgIFJhbmdlLnByb3RvdHlwZS5jbGlwUm93cyA9IGZ1bmN0aW9uIChmaXJzdFJvdywgbGFzdFJvdykgewogICAgICAgIGlmICh0aGlzLmVuZC5yb3cgPiBsYXN0Um93KQogICAgICAgICAgICB2YXIgZW5kID0geyByb3c6IGxhc3RSb3cgKyAxLCBjb2x1bW46IDAgfTsKICAgICAgICBlbHNlIGlmICh0aGlzLmVuZC5yb3cgPCBmaXJzdFJvdykKICAgICAgICAgICAgdmFyIGVuZCA9IHsgcm93OiBmaXJzdFJvdywgY29sdW1uOiAwIH07CiAgICAgICAgaWYgKHRoaXMuc3RhcnQucm93ID4gbGFzdFJvdykKICAgICAgICAgICAgdmFyIHN0YXJ0ID0geyByb3c6IGxhc3RSb3cgKyAxLCBjb2x1bW46IDAgfTsKICAgICAgICBlbHNlIGlmICh0aGlzLnN0YXJ0LnJvdyA8IGZpcnN0Um93KQogICAgICAgICAgICB2YXIgc3RhcnQgPSB7IHJvdzogZmlyc3RSb3csIGNvbHVtbjogMCB9OwogICAgICAgIHJldHVybiBSYW5nZS5mcm9tUG9pbnRzKHN0YXJ0IHx8IHRoaXMuc3RhcnQsIGVuZCB8fCB0aGlzLmVuZCk7CiAgICB9OwogICAgUmFuZ2UucHJvdG90eXBlLmV4dGVuZCA9IGZ1bmN0aW9uIChyb3csIGNvbHVtbikgewogICAgICAgIHZhciBjbXAgPSB0aGlzLmNvbXBhcmUocm93LCBjb2x1bW4pOwogICAgICAgIGlmIChjbXAgPT0gMCkKICAgICAgICAgICAgcmV0dXJuIHRoaXM7CiAgICAgICAgZWxzZSBpZiAoY21wID09IC0xKQogICAgICAgICAgICB2YXIgc3RhcnQgPSB7IHJvdzogcm93LCBjb2x1bW46IGNvbHVtbiB9OwogICAgICAgIGVsc2UKICAgICAgICAgICAgdmFyIGVuZCA9IHsgcm93OiByb3csIGNvbHVtbjogY29sdW1uIH07CiAgICAgICAgcmV0dXJuIFJhbmdlLmZyb21Qb2ludHMoc3RhcnQgfHwgdGhpcy5zdGFydCwgZW5kIHx8IHRoaXMuZW5kKTsKICAgIH07CiAgICBSYW5nZS5wcm90b3R5cGUuaXNFbXB0eSA9IGZ1bmN0aW9uICgpIHsKICAgICAgICByZXR1cm4gKHRoaXMuc3RhcnQucm93ID09PSB0aGlzLmVuZC5yb3cgJiYgdGhpcy5zdGFydC5jb2x1bW4gPT09IHRoaXMuZW5kLmNvbHVtbik7CiAgICB9OwogICAgUmFuZ2UucHJvdG90eXBlLmlzTXVsdGlMaW5lID0gZnVuY3Rpb24gKCkgewogICAgICAgIHJldHVybiAodGhpcy5zdGFydC5yb3cgIT09IHRoaXMuZW5kLnJvdyk7CiAgICB9OwogICAgUmFuZ2UucHJvdG90eXBlLmNsb25lID0gZnVuY3Rpb24gKCkgewogICAgICAgIHJldHVybiBSYW5nZS5mcm9tUG9pbnRzKHRoaXMuc3RhcnQsIHRoaXMuZW5kKTsKICAgIH07CiAgICBSYW5nZS5wcm90b3R5cGUuY29sbGFwc2VSb3dzID0gZnVuY3Rpb24gKCkgewogICAgICAgIGlmICh0aGlzLmVuZC5jb2x1bW4gPT0gMCkKICAgICAgICAgICAgcmV0dXJuIG5ldyBSYW5nZSh0aGlzLnN0YXJ0LnJvdywgMCwgTWF0aC5tYXgodGhpcy5zdGFydC5yb3csIHRoaXMuZW5kLnJvdyAtIDEpLCAwKTsKICAgICAgICBlbHNlCiAgICAgICAgICAgIHJldHVybiBuZXcgUmFuZ2UodGhpcy5zdGFydC5yb3csIDAsIHRoaXMuZW5kLnJvdywgMCk7CiAgICB9OwogICAgUmFuZ2UucHJvdG90eXBlLnRvU2NyZWVuUmFuZ2UgPSBmdW5jdGlvbiAoc2Vzc2lvbikgewogICAgICAgIHZhciBzY3JlZW5Qb3NTdGFydCA9IHNlc3Npb24uZG9jdW1lbnRUb1NjcmVlblBvc2l0aW9uKHRoaXMuc3RhcnQpOwogICAgICAgIHZhciBzY3JlZW5Qb3NFbmQgPSBzZXNzaW9uLmRvY3VtZW50VG9TY3JlZW5Qb3NpdGlvbih0aGlzLmVuZCk7CiAgICAgICAgcmV0dXJuIG5ldyBSYW5nZShzY3JlZW5Qb3NTdGFydC5yb3csIHNjcmVlblBvc1N0YXJ0LmNvbHVtbiwgc2NyZWVuUG9zRW5kLnJvdywgc2NyZWVuUG9zRW5kLmNvbHVtbik7CiAgICB9OwogICAgUmFuZ2UucHJvdG90eXBlLm1vdmVCeSA9IGZ1bmN0aW9uIChyb3csIGNvbHVtbikgewogICAgICAgIHRoaXMuc3RhcnQucm93ICs9IHJvdzsKICAgICAgICB0aGlzLnN0YXJ0LmNvbHVtbiArPSBjb2x1bW47CiAgICAgICAgdGhpcy5lbmQucm93ICs9IHJvdzsKICAgICAgICB0aGlzLmVuZC5jb2x1bW4gKz0gY29sdW1uOwogICAgfTsKICAgIHJldHVybiBSYW5nZTsKfSgpKTsKUmFuZ2UuZnJvbVBvaW50cyA9IGZ1bmN0aW9uIChzdGFydCwgZW5kKSB7CiAgICByZXR1cm4gbmV3IFJhbmdlKHN0YXJ0LnJvdywgc3RhcnQuY29sdW1uLCBlbmQucm93LCBlbmQuY29sdW1uKTsKfTsKUmFuZ2UuY29tcGFyZVBvaW50cyA9IGZ1bmN0aW9uIChwMSwgcDIpIHsKICAgIHJldHVybiBwMS5yb3cgLSBwMi5yb3cgfHwgcDEuY29sdW1uIC0gcDIuY29sdW1uOwp9OwpleHBvcnRzLlJhbmdlID0gUmFuZ2U7Cgp9KTsKCmFjZS5kZWZpbmUoImFjZS9hbmNob3IiLFtdLCBmdW5jdGlvbihyZXF1aXJlLCBleHBvcnRzLCBtb2R1bGUpeyJ1c2Ugc3RyaWN0IjsKdmFyIG9vcCA9IHJlcXVpcmUoIi4vbGliL29vcCIpOwp2YXIgRXZlbnRFbWl0dGVyID0gcmVxdWlyZSgiLi9saWIvZXZlbnRfZW1pdHRlciIpLkV2ZW50RW1pdHRlcjsKdmFyIEFuY2hvciA9IC8qKiBAY2xhc3MgKi8gKGZ1bmN0aW9uICgpIHsKICAgIGZ1bmN0aW9uIEFuY2hvcihkb2MsIHJvdywgY29sdW1uKSB7CiAgICAgICAgdGhpcy4kb25DaGFuZ2UgPSB0aGlzLm9uQ2hhbmdlLmJpbmQodGhpcyk7CiAgICAgICAgdGhpcy5hdHRhY2goZG9jKTsKICAgICAgICBpZiAodHlwZW9mIHJvdyAhPSAibnVtYmVyIikKICAgICAgICAgICAgdGhpcy5zZXRQb3NpdGlvbihyb3cucm93LCByb3cuY29sdW1uKTsKICAgICAgICBlbHNlCiAgICAgICAgICAgIHRoaXMuc2V0UG9zaXRpb24ocm93LCBjb2x1bW4pOwogICAgfQogICAgQW5jaG9yLnByb3RvdHlwZS5nZXRQb3NpdGlvbiA9IGZ1bmN0aW9uICgpIHsKICAgICAgICByZXR1cm4gdGhpcy4kY2xpcFBvc2l0aW9uVG9Eb2N1bWVudCh0aGlzLnJvdywgdGhpcy5jb2x1bW4pOwogICAgfTsKICAgIEFuY2hvci5wcm90b3R5cGUuZ2V0RG9jdW1lbnQgPSBmdW5jdGlvbiAoKSB7CiAgICAgICAgcmV0dXJuIHRoaXMuZG9jdW1lbnQ7CiAgICB9OwogICAgQW5jaG9yLnByb3RvdHlwZS5vbkNoYW5nZSA9IGZ1bmN0aW9uIChkZWx0YSkgewogICAgICAgIGlmIChkZWx0YS5zdGFydC5yb3cgPT0gZGVsdGEuZW5kLnJvdyAmJiBkZWx0YS5zdGFydC5yb3cgIT0gdGhpcy5yb3cpCiAgICAgICAgICAgIHJldHVybjsKICAgICAgICBpZiAoZGVsdGEuc3RhcnQucm93ID4gdGhpcy5yb3cpCiAgICAgICAgICAgIHJldHVybjsKICAgICAgICB2YXIgcG9pbnQgPSAkZ2V0VHJhbnNmb3JtZWRQb2ludChkZWx0YSwgeyByb3c6IHRoaXMucm93LCBjb2x1bW46IHRoaXMuY29sdW1uIH0sIHRoaXMuJGluc2VydFJpZ2h0KTsKICAgICAgICB0aGlzLnNldFBvc2l0aW9uKHBvaW50LnJvdywgcG9pbnQuY29sdW1uLCB0cnVlKTsKICAgIH07CiAgICBBbmNob3IucHJvdG90eXBlLnNldFBvc2l0aW9uID0gZnVuY3Rpb24gKHJvdywgY29sdW1uLCBub0NsaXApIHsKICAgICAgICB2YXIgcG9zOwogICAgICAgIGlmIChub0NsaXApIHsKICAgICAgICAgICAgcG9zID0gewogICAgICAgICAgICAgICAgcm93OiByb3csCiAgICAgICAgICAgICAgICBjb2x1bW46IGNvbHVtbgogICAgICAgICAgICB9OwogICAgICAgIH0KICAgICAgICBlbHNlIHsKICAgICAgICAgICAgcG9zID0gdGhpcy4kY2xpcFBvc2l0aW9uVG9Eb2N1bWVudChyb3csIGNvbHVtbik7CiAgICAgICAgfQogICAgICAgIGlmICh0aGlzLnJvdyA9PSBwb3Mucm93ICYmIHRoaXMuY29sdW1uID09IHBvcy5jb2x1bW4pCiAgICAgICAgICAgIHJldHVybjsKICAgICAgICB2YXIgb2xkID0gewogICAgICAgICAgICByb3c6IHRoaXMucm93LAogICAgICAgICAgICBjb2x1bW46IHRoaXMuY29sdW1uCiAgICAgICAgfTsKICAgICAgICB0aGlzLnJvdyA9IHBvcy5yb3c7CiAgICAgICAgdGhpcy5jb2x1bW4gPSBwb3MuY29sdW1uOwogICAgICAgIHRoaXMuX3NpZ25hbCgiY2hhbmdlIiwgewogICAgICAgICAgICBvbGQ6IG9sZCwKICAgICAgICAgICAgdmFsdWU6IHBvcwogICAgICAgIH0pOwogICAgfTsKICAgIEFuY2hvci5wcm90b3R5cGUuZGV0YWNoID0gZnVuY3Rpb24gKCkgewogICAgICAgIHRoaXMuZG9jdW1lbnQub2ZmKCJjaGFuZ2UiLCB0aGlzLiRvbkNoYW5nZSk7CiAgICB9OwogICAgQW5jaG9yLnByb3RvdHlwZS5hdHRhY2ggPSBmdW5jdGlvbiAoZG9jKSB7CiAgICAgICAgdGhpcy5kb2N1bWVudCA9IGRvYyB8fCB0aGlzLmRvY3VtZW50OwogICAgICAgIHRoaXMuZG9jdW1lbnQub24oImNoYW5nZSIsIHRoaXMuJG9uQ2hhbmdlKTsKICAgIH07CiAgICBBbmNob3IucHJvdG90eXBlLiRjbGlwUG9zaXRpb25Ub0RvY3VtZW50ID0gZnVuY3Rpb24gKHJvdywgY29sdW1uKSB7CiAgICAgICAgdmFyIHBvcyA9IHt9OwogICAgICAgIGlmIChyb3cgPj0gdGhpcy5kb2N1bWVudC5nZXRMZW5ndGgoKSkgewogICAgICAgICAgICBwb3Mucm93ID0gTWF0aC5tYXgoMCwgdGhpcy5kb2N1bWVudC5nZXRMZW5ndGgoKSAtIDEpOwogICAgICAgICAgICBwb3MuY29sdW1uID0gdGhpcy5kb2N1bWVudC5nZXRMaW5lKHBvcy5yb3cpLmxlbmd0aDsKICAgICAgICB9CiAgICAgICAgZWxzZSBpZiAocm93IDwgMCkgewogICAgICAgICAgICBwb3Mucm93ID0gMDsKICAgICAgICAgICAgcG9zLmNvbHVtbiA9IDA7CiAgICAgICAgfQogICAgICAgIGVsc2UgewogICAgICAgICAgICBwb3Mucm93ID0gcm93OwogICAgICAgICAgICBwb3MuY29sdW1uID0gTWF0aC5taW4odGhpcy5kb2N1bWVudC5nZXRMaW5lKHBvcy5yb3cpLmxlbmd0aCwgTWF0aC5tYXgoMCwgY29sdW1uKSk7CiAgICAgICAgfQogICAgICAgIGlmIChjb2x1bW4gPCAwKQogICAgICAgICAgICBwb3MuY29sdW1uID0gMDsKICAgICAgICByZXR1cm4gcG9zOwogICAgfTsKICAgIHJldHVybiBBbmNob3I7Cn0oKSk7CkFuY2hvci5wcm90b3R5cGUuJGluc2VydFJpZ2h0ID0gZmFsc2U7Cm9vcC5pbXBsZW1lbnQoQW5jaG9yLnByb3RvdHlwZSwgRXZlbnRFbWl0dGVyKTsKZnVuY3Rpb24gJHBvaW50c0luT3JkZXIocG9pbnQxLCBwb2ludDIsIGVxdWFsUG9pbnRzSW5PcmRlcikgewogICAgdmFyIGJDb2xJc0FmdGVyID0gZXF1YWxQb2ludHNJbk9yZGVyID8gcG9pbnQxLmNvbHVtbiA8PSBwb2ludDIuY29sdW1uIDogcG9pbnQxLmNvbHVtbiA8IHBvaW50Mi5jb2x1bW47CiAgICByZXR1cm4gKHBvaW50MS5yb3cgPCBwb2ludDIucm93KSB8fCAocG9pbnQxLnJvdyA9PSBwb2ludDIucm93ICYmIGJDb2xJc0FmdGVyKTsKfQpmdW5jdGlvbiAkZ2V0VHJhbnNmb3JtZWRQb2ludChkZWx0YSwgcG9pbnQsIG1vdmVJZkVxdWFsKSB7CiAgICB2YXIgZGVsdGFJc0luc2VydCA9IGRlbHRhLmFjdGlvbiA9PSAiaW5zZXJ0IjsKICAgIHZhciBkZWx0YVJvd1NoaWZ0ID0gKGRlbHRhSXNJbnNlcnQgPyAxIDogLTEpICogKGRlbHRhLmVuZC5yb3cgLSBkZWx0YS5zdGFydC5yb3cpOwogICAgdmFyIGRlbHRhQ29sU2hpZnQgPSAoZGVsdGFJc0luc2VydCA/IDEgOiAtMSkgKiAoZGVsdGEuZW5kLmNvbHVtbiAtIGRlbHRhLnN0YXJ0LmNvbHVtbik7CiAgICB2YXIgZGVsdGFTdGFydCA9IGRlbHRhLnN0YXJ0OwogICAgdmFyIGRlbHRhRW5kID0gZGVsdGFJc0luc2VydCA/IGRlbHRhU3RhcnQgOiBkZWx0YS5lbmQ7IC8vIENvbGxhcHNlIGluc2VydCByYW5nZS4KICAgIGlmICgkcG9pbnRzSW5PcmRlcihwb2ludCwgZGVsdGFTdGFydCwgbW92ZUlmRXF1YWwpKSB7CiAgICAgICAgcmV0dXJuIHsKICAgICAgICAgICAgcm93OiBwb2ludC5yb3csCiAgICAgICAgICAgIGNvbHVtbjogcG9pbnQuY29sdW1uCiAgICAgICAgfTsKICAgIH0KICAgIGlmICgkcG9pbnRzSW5PcmRlcihkZWx0YUVuZCwgcG9pbnQsICFtb3ZlSWZFcXVhbCkpIHsKICAgICAgICByZXR1cm4gewogICAgICAgICAgICByb3c6IHBvaW50LnJvdyArIGRlbHRhUm93U2hpZnQsCiAgICAgICAgICAgIGNvbHVtbjogcG9pbnQuY29sdW1uICsgKHBvaW50LnJvdyA9PSBkZWx0YUVuZC5yb3cgPyBkZWx0YUNvbFNoaWZ0IDogMCkKICAgICAgICB9OwogICAgfQogICAgcmV0dXJuIHsKICAgICAgICByb3c6IGRlbHRhU3RhcnQucm93LAogICAgICAgIGNvbHVtbjogZGVsdGFTdGFydC5jb2x1bW4KICAgIH07Cn0KZXhwb3J0cy5BbmNob3IgPSBBbmNob3I7Cgp9KTsKCmFjZS5kZWZpbmUoImFjZS9kb2N1bWVudCIsW10sIGZ1bmN0aW9uKHJlcXVpcmUsIGV4cG9ydHMsIG1vZHVsZSl7InVzZSBzdHJpY3QiOwp2YXIgb29wID0gcmVxdWlyZSgiLi9saWIvb29wIik7CnZhciBhcHBseURlbHRhID0gcmVxdWlyZSgiLi9hcHBseV9kZWx0YSIpLmFwcGx5RGVsdGE7CnZhciBFdmVudEVtaXR0ZXIgPSByZXF1aXJlKCIuL2xpYi9ldmVudF9lbWl0dGVyIikuRXZlbnRFbWl0dGVyOwp2YXIgUmFuZ2UgPSByZXF1aXJlKCIuL3JhbmdlIikuUmFuZ2U7CnZhciBBbmNob3IgPSByZXF1aXJlKCIuL2FuY2hvciIpLkFuY2hvcjsKdmFyIERvY3VtZW50ID0gLyoqIEBjbGFzcyAqLyAoZnVuY3Rpb24gKCkgewogICAgZnVuY3Rpb24gRG9jdW1lbnQodGV4dE9yTGluZXMpIHsKICAgICAgICB0aGlzLiRsaW5lcyA9IFsiIl07CiAgICAgICAgaWYgKHRleHRPckxpbmVzLmxlbmd0aCA9PT0gMCkgewogICAgICAgICAgICB0aGlzLiRsaW5lcyA9IFsiIl07CiAgICAgICAgfQogICAgICAgIGVsc2UgaWYgKEFycmF5LmlzQXJyYXkodGV4dE9yTGluZXMpKSB7CiAgICAgICAgICAgIHRoaXMuaW5zZXJ0TWVyZ2VkTGluZXMoeyByb3c6IDAsIGNvbHVtbjogMCB9LCB0ZXh0T3JMaW5lcyk7CiAgICAgICAgfQogICAgICAgIGVsc2UgewogICAgICAgICAgICB0aGlzLmluc2VydCh7IHJvdzogMCwgY29sdW1uOiAwIH0sIHRleHRPckxpbmVzKTsKICAgICAgICB9CiAgICB9CiAgICBEb2N1bWVudC5wcm90b3R5cGUuc2V0VmFsdWUgPSBmdW5jdGlvbiAodGV4dCkgewogICAgICAgIHZhciBsZW4gPSB0aGlzLmdldExlbmd0aCgpIC0gMTsKICAgICAgICB0aGlzLnJlbW92ZShuZXcgUmFuZ2UoMCwgMCwgbGVuLCB0aGlzLmdldExpbmUobGVuKS5sZW5ndGgpKTsKICAgICAgICB0aGlzLmluc2VydCh7IHJvdzogMCwgY29sdW1uOiAwIH0sIHRleHQgfHwgIiIpOwogICAgfTsKICAgIERvY3VtZW50LnByb3RvdHlwZS5nZXRWYWx1ZSA9IGZ1bmN0aW9uICgpIHsKICAgICAgICByZXR1cm4gdGhpcy5nZXRBbGxMaW5lcygpLmpvaW4odGhpcy5nZXROZXdMaW5lQ2hhcmFjdGVyKCkpOwogICAgfTsKICAgIERvY3VtZW50LnByb3RvdHlwZS5jcmVhdGVBbmNob3IgPSBmdW5jdGlvbiAocm93LCBjb2x1bW4pIHsKICAgICAgICByZXR1cm4gbmV3IEFuY2hvcih0aGlzLCByb3csIGNvbHVtbik7CiAgICB9OwogICAgRG9jdW1lbnQucHJvdG90eXBlLiRkZXRlY3ROZXdMaW5lID0gZnVuY3Rpb24gKHRleHQpIHsKICAgICAgICB2YXIgbWF0Y2ggPSB0ZXh0Lm1hdGNoKC9eLio/KFxyXG58XHJ8XG4pL20pOwogICAgICAgIHRoaXMuJGF1dG9OZXdMaW5lID0gbWF0Y2ggPyBtYXRjaFsxXSA6ICJcbiI7CiAgICAgICAgdGhpcy5fc2lnbmFsKCJjaGFuZ2VOZXdMaW5lTW9kZSIpOwogICAgfTsKICAgIERvY3VtZW50LnByb3RvdHlwZS5nZXROZXdMaW5lQ2hhcmFjdGVyID0gZnVuY3Rpb24gKCkgewogICAgICAgIHN3aXRjaCAodGhpcy4kbmV3TGluZU1vZGUpIHsKICAgICAgICAgICAgY2FzZSAid2luZG93cyI6CiAgICAgICAgICAgICAgICByZXR1cm4gIlxyXG4iOwogICAgICAgICAgICBjYXNlICJ1bml4IjoKICAgICAgICAgICAgICAgIHJldHVybiAiXG4iOwogICAgICAgICAgICBkZWZhdWx0OgogICAgICAgICAgICAgICAgcmV0dXJuIHRoaXMuJGF1dG9OZXdMaW5lIHx8ICJcbiI7CiAgICAgICAgfQogICAgfTsKICAgIERvY3VtZW50LnByb3RvdHlwZS5zZXROZXdMaW5lTW9kZSA9IGZ1bmN0aW9uIChuZXdMaW5lTW9kZSkgewogICAgICAgIGlmICh0aGlzLiRuZXdMaW5lTW9kZSA9PT0gbmV3TGluZU1vZGUpCiAgICAgICAgICAgIHJldHVybjsKICAgICAgICB0aGlzLiRuZXdMaW5lTW9kZSA9IG5ld0xpbmVNb2RlOwogICAgICAgIHRoaXMuX3NpZ25hbCgiY2hhbmdlTmV3TGluZU1vZGUiKTsKICAgIH07CiAgICBEb2N1bWVudC5wcm90b3R5cGUuZ2V0TmV3TGluZU1vZGUgPSBmdW5jdGlvbiAoKSB7CiAgICAgICAgcmV0dXJuIHRoaXMuJG5ld0xpbmVNb2RlOwogICAgfTsKICAgIERvY3VtZW50LnByb3RvdHlwZS5pc05ld0xpbmUgPSBmdW5jdGlvbiAodGV4dCkgewogICAgICAgIHJldHVybiAodGV4dCA9PSAiXHJcbiIgfHwgdGV4dCA9PSAiXHIiIHx8IHRleHQgPT0gIlxuIik7CiAgICB9OwogICAgRG9jdW1lbnQucHJvdG90eXBlLmdldExpbmUgPSBmdW5jdGlvbiAocm93KSB7CiAgICAgICAgcmV0dXJuIHRoaXMuJGxpbmVzW3Jvd10gfHwgIiI7CiAgICB9OwogICAgRG9jdW1lbnQucHJvdG90eXBlLmdldExpbmVzID0gZnVuY3Rpb24gKGZpcnN0Um93LCBsYXN0Um93KSB7CiAgICAgICAgcmV0dXJuIHRoaXMuJGxpbmVzLnNsaWNlKGZpcnN0Um93LCBsYXN0Um93ICsgMSk7CiAgICB9OwogICAgRG9jdW1lbnQucHJvdG90eXBlLmdldEFsbExpbmVzID0gZnVuY3Rpb24gKCkgewogICAgICAgIHJldHVybiB0aGlzLmdldExpbmVzKDAsIHRoaXMuZ2V0TGVuZ3RoKCkpOwogICAgfTsKICAgIERvY3VtZW50LnByb3RvdHlwZS5nZXRMZW5ndGggPSBmdW5jdGlvbiAoKSB7CiAgICAgICAgcmV0dXJuIHRoaXMuJGxpbmVzLmxlbmd0aDsKICAgIH07CiAgICBEb2N1bWVudC5wcm90b3R5cGUuZ2V0VGV4dFJhbmdlID0gZnVuY3Rpb24gKHJhbmdlKSB7CiAgICAgICAgcmV0dXJuIHRoaXMuZ2V0TGluZXNGb3JSYW5nZShyYW5nZSkuam9pbih0aGlzLmdldE5ld0xpbmVDaGFyYWN0ZXIoKSk7CiAgICB9OwogICAgRG9jdW1lbnQucHJvdG90eXBlLmdldExpbmVzRm9yUmFuZ2UgPSBmdW5jdGlvbiAocmFuZ2UpIHsKICAgICAgICB2YXIgbGluZXM7CiAgICAgICAgaWYgKHJhbmdlLnN0YXJ0LnJvdyA9PT0gcmFuZ2UuZW5kLnJvdykgewogICAgICAgICAgICBsaW5lcyA9IFt0aGlzLmdldExpbmUocmFuZ2Uuc3RhcnQucm93KS5zdWJzdHJpbmcocmFuZ2Uuc3RhcnQuY29sdW1uLCByYW5nZS5lbmQuY29sdW1uKV07CiAgICAgICAgfQogICAgICAgIGVsc2UgewogICAgICAgICAgICBsaW5lcyA9IHRoaXMuZ2V0TGluZXMocmFuZ2Uuc3RhcnQucm93LCByYW5nZS5lbmQucm93KTsKICAgICAgICAgICAgbGluZXNbMF0gPSAobGluZXNbMF0gfHwgIiIpLnN1YnN0cmluZyhyYW5nZS5zdGFydC5jb2x1bW4pOwogICAgICAgICAgICB2YXIgbCA9IGxpbmVzLmxlbmd0aCAtIDE7CiAgICAgICAgICAgIGlmIChyYW5nZS5lbmQucm93IC0gcmFuZ2Uuc3RhcnQucm93ID09IGwpCiAgICAgICAgICAgICAgICBsaW5lc1tsXSA9IGxpbmVzW2xdLnN1YnN0cmluZygwLCByYW5nZS5lbmQuY29sdW1uKTsKICAgICAgICB9CiAgICAgICAgcmV0dXJuIGxpbmVzOwogICAgfTsKICAgIERvY3VtZW50LnByb3RvdHlwZS5pbnNlcnRMaW5lcyA9IGZ1bmN0aW9uIChyb3csIGxpbmVzKSB7CiAgICAgICAgY29uc29sZS53YXJuKCJVc2Ugb2YgZG9jdW1lbnQuaW5zZXJ0TGluZXMgaXMgZGVwcmVjYXRlZC4gVXNlIHRoZSBpbnNlcnRGdWxsTGluZXMgbWV0aG9kIGluc3RlYWQuIik7CiAgICAgICAgcmV0dXJuIHRoaXMuaW5zZXJ0RnVsbExpbmVzKHJvdywgbGluZXMpOwogICAgfTsKICAgIERvY3VtZW50LnByb3RvdHlwZS5yZW1vdmVMaW5lcyA9IGZ1bmN0aW9uIChmaXJzdFJvdywgbGFzdFJvdykgewogICAgICAgIGNvbnNvbGUud2FybigiVXNlIG9mIGRvY3VtZW50LnJlbW92ZUxpbmVzIGlzIGRlcHJlY2F0ZWQuIFVzZSB0aGUgcmVtb3ZlRnVsbExpbmVzIG1ldGhvZCBpbnN0ZWFkLiIpOwogICAgICAgIHJldHVybiB0aGlzLnJlbW92ZUZ1bGxMaW5lcyhmaXJzdFJvdywgbGFzdFJvdyk7CiAgICB9OwogICAgRG9jdW1lbnQucHJvdG90eXBlLmluc2VydE5ld0xpbmUgPSBmdW5jdGlvbiAocG9zaXRpb24pIHsKICAgICAgICBjb25zb2xlLndhcm4oIlVzZSBvZiBkb2N1bWVudC5pbnNlcnROZXdMaW5lIGlzIGRlcHJlY2F0ZWQuIFVzZSBpbnNlcnRNZXJnZWRMaW5lcyhwb3NpdGlvbiwgWycnLCAnJ10pIGluc3RlYWQuIik7CiAgICAgICAgcmV0dXJuIHRoaXMuaW5zZXJ0TWVyZ2VkTGluZXMocG9zaXRpb24sIFsiIiwgIiJdKTsKICAgIH07CiAgICBEb2N1bWVudC5wcm90b3R5cGUuaW5zZXJ0ID0gZnVuY3Rpb24gKHBvc2l0aW9uLCB0ZXh0KSB7CiAgICAgICAgaWYgKHRoaXMuZ2V0TGVuZ3RoKCkgPD0gMSkKICAgICAgICAgICAgdGhpcy4kZGV0ZWN0TmV3TGluZSh0ZXh0KTsKICAgICAgICByZXR1cm4gdGhpcy5pbnNlcnRNZXJnZWRMaW5lcyhwb3NpdGlvbiwgdGhpcy4kc3BsaXQodGV4dCkpOwogICAgfTsKICAgIERvY3VtZW50LnByb3RvdHlwZS5pbnNlcnRJbkxpbmUgPSBmdW5jdGlvbiAocG9zaXRpb24sIHRleHQpIHsKICAgICAgICB2YXIgc3RhcnQgPSB0aGlzLmNsaXBwZWRQb3MocG9zaXRpb24ucm93LCBwb3NpdGlvbi5jb2x1bW4pOwogICAgICAgIHZhciBlbmQgPSB0aGlzLnBvcyhwb3NpdGlvbi5yb3csIHBvc2l0aW9uLmNvbHVtbiArIHRleHQubGVuZ3RoKTsKICAgICAgICB0aGlzLmFwcGx5RGVsdGEoewogICAgICAgICAgICBzdGFydDogc3RhcnQsCiAgICAgICAgICAgIGVuZDogZW5kLAogICAgICAgICAgICBhY3Rpb246ICJpbnNlcnQiLAogICAgICAgICAgICBsaW5lczogW3RleHRdCiAgICAgICAgfSwgdHJ1ZSk7CiAgICAgICAgcmV0dXJuIHRoaXMuY2xvbmVQb3MoZW5kKTsKICAgIH07CiAgICBEb2N1bWVudC5wcm90b3R5cGUuY2xpcHBlZFBvcyA9IGZ1bmN0aW9uIChyb3csIGNvbHVtbikgewogICAgICAgIHZhciBsZW5ndGggPSB0aGlzLmdldExlbmd0aCgpOwogICAgICAgIGlmIChyb3cgPT09IHVuZGVmaW5lZCkgewogICAgICAgICAgICByb3cgPSBsZW5ndGg7CiAgICAgICAgfQogICAgICAgIGVsc2UgaWYgKHJvdyA8IDApIHsKICAgICAgICAgICAgcm93ID0gMDsKICAgICAgICB9CiAgICAgICAgZWxzZSBpZiAocm93ID49IGxlbmd0aCkgewogICAgICAgICAgICByb3cgPSBsZW5ndGggLSAxOwogICAgICAgICAgICBjb2x1bW4gPSB1bmRlZmluZWQ7CiAgICAgICAgfQogICAgICAgIHZhciBsaW5lID0gdGhpcy5nZXRMaW5lKHJvdyk7CiAgICAgICAgaWYgKGNvbHVtbiA9PSB1bmRlZmluZWQpCiAgICAgICAgICAgIGNvbHVtbiA9IGxpbmUubGVuZ3RoOwogICAgICAgIGNvbHVtbiA9IE1hdGgubWluKE1hdGgubWF4KGNvbHVtbiwgMCksIGxpbmUubGVuZ3RoKTsKICAgICAgICByZXR1cm4geyByb3c6IHJvdywgY29sdW1uOiBjb2x1bW4gfTsKICAgIH07CiAgICBEb2N1bWVudC5wcm90b3R5cGUuY2xvbmVQb3MgPSBmdW5jdGlvbiAocG9zKSB7CiAgICAgICAgcmV0dXJuIHsgcm93OiBwb3Mucm93LCBjb2x1bW46IHBvcy5jb2x1bW4gfTsKICAgIH07CiAgICBEb2N1bWVudC5wcm90b3R5cGUucG9zID0gZnVuY3Rpb24gKHJvdywgY29sdW1uKSB7CiAgICAgICAgcmV0dXJuIHsgcm93OiByb3csIGNvbHVtbjogY29sdW1uIH07CiAgICB9OwogICAgRG9jdW1lbnQucHJvdG90eXBlLiRjbGlwUG9zaXRpb24gPSBmdW5jdGlvbiAocG9zaXRpb24pIHsKICAgICAgICB2YXIgbGVuZ3RoID0gdGhpcy5nZXRMZW5ndGgoKTsKICAgICAgICBpZiAocG9zaXRpb24ucm93ID49IGxlbmd0aCkgewogICAgICAgICAgICBwb3NpdGlvbi5yb3cgPSBNYXRoLm1heCgwLCBsZW5ndGggLSAxKTsKICAgICAgICAgICAgcG9zaXRpb24uY29sdW1uID0gdGhpcy5nZXRMaW5lKGxlbmd0aCAtIDEpLmxlbmd0aDsKICAgICAgICB9CiAgICAgICAgZWxzZSB7CiAgICAgICAgICAgIHBvc2l0aW9uLnJvdyA9IE1hdGgubWF4KDAsIHBvc2l0aW9uLnJvdyk7CiAgICAgICAgICAgIHBvc2l0aW9uLmNvbHVtbiA9IE1hdGgubWluKE1hdGgubWF4KHBvc2l0aW9uLmNvbHVtbiwgMCksIHRoaXMuZ2V0TGluZShwb3NpdGlvbi5yb3cpLmxlbmd0aCk7CiAgICAgICAgfQogICAgICAgIHJldHVybiBwb3NpdGlvbjsKICAgIH07CiAgICBEb2N1bWVudC5wcm90b3R5cGUuaW5zZXJ0RnVsbExpbmVzID0gZnVuY3Rpb24gKHJvdywgbGluZXMpIHsKICAgICAgICByb3cgPSBNYXRoLm1pbihNYXRoLm1heChyb3csIDApLCB0aGlzLmdldExlbmd0aCgpKTsKICAgICAgICB2YXIgY29sdW1uID0gMDsKICAgICAgICBpZiAocm93IDwgdGhpcy5nZXRMZW5ndGgoKSkgewogICAgICAgICAgICBsaW5lcyA9IGxpbmVzLmNvbmNhdChbIiJdKTsKICAgICAgICAgICAgY29sdW1uID0gMDsKICAgICAgICB9CiAgICAgICAgZWxzZSB7CiAgICAgICAgICAgIGxpbmVzID0gWyIiXS5jb25jYXQobGluZXMpOwogICAgICAgICAgICByb3ctLTsKICAgICAgICAgICAgY29sdW1uID0gdGhpcy4kbGluZXNbcm93XS5sZW5ndGg7CiAgICAgICAgfQogICAgICAgIHRoaXMuaW5zZXJ0TWVyZ2VkTGluZXMoeyByb3c6IHJvdywgY29sdW1uOiBjb2x1bW4gfSwgbGluZXMpOwogICAgfTsKICAgIERvY3VtZW50LnByb3RvdHlwZS5pbnNlcnRNZXJnZWRMaW5lcyA9IGZ1bmN0aW9uIChwb3NpdGlvbiwgbGluZXMpIHsKICAgICAgICB2YXIgc3RhcnQgPSB0aGlzLmNsaXBwZWRQb3MocG9zaXRpb24ucm93LCBwb3NpdGlvbi5jb2x1bW4pOwogICAgICAgIHZhciBlbmQgPSB7CiAgICAgICAgICAgIHJvdzogc3RhcnQucm93ICsgbGluZXMubGVuZ3RoIC0gMSwKICAgICAgICAgICAgY29sdW1uOiAobGluZXMubGVuZ3RoID09IDEgPyBzdGFydC5jb2x1bW4gOiAwKSArIGxpbmVzW2xpbmVzLmxlbmd0aCAtIDFdLmxlbmd0aAogICAgICAgIH07CiAgICAgICAgdGhpcy5hcHBseURlbHRhKHsKICAgICAgICAgICAgc3RhcnQ6IHN0YXJ0LAogICAgICAgICAgICBlbmQ6IGVuZCwKICAgICAgICAgICAgYWN0aW9uOiAiaW5zZXJ0IiwKICAgICAgICAgICAgbGluZXM6IGxpbmVzCiAgICAgICAgfSk7CiAgICAgICAgcmV0dXJuIHRoaXMuY2xvbmVQb3MoZW5kKTsKICAgIH07CiAgICBEb2N1bWVudC5wcm90b3R5cGUucmVtb3ZlID0gZnVuY3Rpb24gKHJhbmdlKSB7CiAgICAgICAgdmFyIHN0YXJ0ID0gdGhpcy5jbGlwcGVkUG9zKHJhbmdlLnN0YXJ0LnJvdywgcmFuZ2Uuc3RhcnQuY29sdW1uKTsKICAgICAgICB2YXIgZW5kID0gdGhpcy5jbGlwcGVkUG9zKHJhbmdlLmVuZC5yb3csIHJhbmdlLmVuZC5jb2x1bW4pOwogICAgICAgIHRoaXMuYXBwbHlEZWx0YSh7CiAgICAgICAgICAgIHN0YXJ0OiBzdGFydCwKICAgICAgICAgICAgZW5kOiBlbmQsCiAgICAgICAgICAgIGFjdGlvbjogInJlbW92ZSIsCiAgICAgICAgICAgIGxpbmVzOiB0aGlzLmdldExpbmVzRm9yUmFuZ2UoeyBzdGFydDogc3RhcnQsIGVuZDogZW5kIH0pCiAgICAgICAgfSk7CiAgICAgICAgcmV0dXJuIHRoaXMuY2xvbmVQb3Moc3RhcnQpOwogICAgfTsKICAgIERvY3VtZW50LnByb3RvdHlwZS5yZW1vdmVJbkxpbmUgPSBmdW5jdGlvbiAocm93LCBzdGFydENvbHVtbiwgZW5kQ29sdW1uKSB7CiAgICAgICAgdmFyIHN0YXJ0ID0gdGhpcy5jbGlwcGVkUG9zKHJvdywgc3RhcnRDb2x1bW4pOwogICAgICAgIHZhciBlbmQgPSB0aGlzLmNsaXBwZWRQb3Mocm93LCBlbmRDb2x1bW4pOwogICAgICAgIHRoaXMuYXBwbHlEZWx0YSh7CiAgICAgICAgICAgIHN0YXJ0OiBzdGFydCwKICAgICAgICAgICAgZW5kOiBlbmQsCiAgICAgICAgICAgIGFjdGlvbjogInJlbW92ZSIsCiAgICAgICAgICAgIGxpbmVzOiB0aGlzLmdldExpbmVzRm9yUmFuZ2UoeyBzdGFydDogc3RhcnQsIGVuZDogZW5kIH0pCiAgICAgICAgfSwgdHJ1ZSk7CiAgICAgICAgcmV0dXJuIHRoaXMuY2xvbmVQb3Moc3RhcnQpOwogICAgfTsKICAgIERvY3VtZW50LnByb3RvdHlwZS5yZW1vdmVGdWxsTGluZXMgPSBmdW5jdGlvbiAoZmlyc3RSb3csIGxhc3RSb3cpIHsKICAgICAgICBmaXJzdFJvdyA9IE1hdGgubWluKE1hdGgubWF4KDAsIGZpcnN0Um93KSwgdGhpcy5nZXRMZW5ndGgoKSAtIDEpOwogICAgICAgIGxhc3RSb3cgPSBNYXRoLm1pbihNYXRoLm1heCgwLCBsYXN0Um93KSwgdGhpcy5nZXRMZW5ndGgoKSAtIDEpOwogICAgICAgIHZhciBkZWxldGVGaXJzdE5ld0xpbmUgPSBsYXN0Um93ID09IHRoaXMuZ2V0TGVuZ3RoKCkgLSAxICYmIGZpcnN0Um93ID4gMDsKICAgICAgICB2YXIgZGVsZXRlTGFzdE5ld0xpbmUgPSBsYXN0Um93IDwgdGhpcy5nZXRMZW5ndGgoKSAtIDE7CiAgICAgICAgdmFyIHN0YXJ0Um93ID0gKGRlbGV0ZUZpcnN0TmV3TGluZSA/IGZpcnN0Um93IC0gMSA6IGZpcnN0Um93KTsKICAgICAgICB2YXIgc3RhcnRDb2wgPSAoZGVsZXRlRmlyc3ROZXdMaW5lID8gdGhpcy5nZXRMaW5lKHN0YXJ0Um93KS5sZW5ndGggOiAwKTsKICAgICAgICB2YXIgZW5kUm93ID0gKGRlbGV0ZUxhc3ROZXdMaW5lID8gbGFzdFJvdyArIDEgOiBsYXN0Um93KTsKICAgICAgICB2YXIgZW5kQ29sID0gKGRlbGV0ZUxhc3ROZXdMaW5lID8gMCA6IHRoaXMuZ2V0TGluZShlbmRSb3cpLmxlbmd0aCk7CiAgICAgICAgdmFyIHJhbmdlID0gbmV3IFJhbmdlKHN0YXJ0Um93LCBzdGFydENvbCwgZW5kUm93LCBlbmRDb2wpOwogICAgICAgIHZhciBkZWxldGVkTGluZXMgPSB0aGlzLiRsaW5lcy5zbGljZShmaXJzdFJvdywgbGFzdFJvdyArIDEpOwogICAgICAgIHRoaXMuYXBwbHlEZWx0YSh7CiAgICAgICAgICAgIHN0YXJ0OiByYW5nZS5zdGFydCwKICAgICAgICAgICAgZW5kOiByYW5nZS5lbmQsCiAgICAgICAgICAgIGFjdGlvbjogInJlbW92ZSIsCiAgICAgICAgICAgIGxpbmVzOiB0aGlzLmdldExpbmVzRm9yUmFuZ2UocmFuZ2UpCiAgICAgICAgfSk7CiAgICAgICAgcmV0dXJuIGRlbGV0ZWRMaW5lczsKICAgIH07CiAgICBEb2N1bWVudC5wcm90b3R5cGUucmVtb3ZlTmV3TGluZSA9IGZ1bmN0aW9uIChyb3cpIHsKICAgICAgICBpZiAocm93IDwgdGhpcy5nZXRMZW5ndGgoKSAtIDEgJiYgcm93ID49IDApIHsKICAgICAgICAgICAgdGhpcy5hcHBseURlbHRhKHsKICAgICAgICAgICAgICAgIHN0YXJ0OiB0aGlzLnBvcyhyb3csIHRoaXMuZ2V0TGluZShyb3cpLmxlbmd0aCksCiAgICAgICAgICAgICAgICBlbmQ6IHRoaXMucG9zKHJvdyArIDEsIDApLAogICAgICAgICAgICAgICAgYWN0aW9uOiAicmVtb3ZlIiwKICAgICAgICAgICAgICAgIGxpbmVzOiBbIiIsICIiXQogICAgICAgICAgICB9KTsKICAgICAgICB9CiAgICB9OwogICAgRG9jdW1lbnQucHJvdG90eXBlLnJlcGxhY2UgPSBmdW5jdGlvbiAocmFuZ2UsIHRleHQpIHsKICAgICAgICBpZiAoIShyYW5nZSBpbnN0YW5jZW9mIFJhbmdlKSkKICAgICAgICAgICAgcmFuZ2UgPSBSYW5nZS5mcm9tUG9pbnRzKHJhbmdlLnN0YXJ0LCByYW5nZS5lbmQpOwogICAgICAgIGlmICh0ZXh0Lmxlbmd0aCA9PT0gMCAmJiByYW5nZS5pc0VtcHR5KCkpCiAgICAgICAgICAgIHJldHVybiByYW5nZS5zdGFydDsKICAgICAgICBpZiAodGV4dCA9PSB0aGlzLmdldFRleHRSYW5nZShyYW5nZSkpCiAgICAgICAgICAgIHJldHVybiByYW5nZS5lbmQ7CiAgICAgICAgdGhpcy5yZW1vdmUocmFuZ2UpOwogICAgICAgIHZhciBlbmQ7CiAgICAgICAgaWYgKHRleHQpIHsKICAgICAgICAgICAgZW5kID0gdGhpcy5pbnNlcnQocmFuZ2Uuc3RhcnQsIHRleHQpOwogICAgICAgIH0KICAgICAgICBlbHNlIHsKICAgICAgICAgICAgZW5kID0gcmFuZ2Uuc3RhcnQ7CiAgICAgICAgfQogICAgICAgIHJldHVybiBlbmQ7CiAgICB9OwogICAgRG9jdW1lbnQucHJvdG90eXBlLmFwcGx5RGVsdGFzID0gZnVuY3Rpb24gKGRlbHRhcykgewogICAgICAgIGZvciAodmFyIGkgPSAwOyBpIDwgZGVsdGFzLmxlbmd0aDsgaSsrKSB7CiAgICAgICAgICAgIHRoaXMuYXBwbHlEZWx0YShkZWx0YXNbaV0pOwogICAgICAgIH0KICAgIH07CiAgICBEb2N1bWVudC5wcm90b3R5cGUucmV2ZXJ0RGVsdGFzID0gZnVuY3Rpb24gKGRlbHRhcykgewogICAgICAgIGZvciAodmFyIGkgPSBkZWx0YXMubGVuZ3RoIC0gMTsgaSA+PSAwOyBpLS0pIHsKICAgICAgICAgICAgdGhpcy5yZXZlcnREZWx0YShkZWx0YXNbaV0pOwogICAgICAgIH0KICAgIH07CiAgICBEb2N1bWVudC5wcm90b3R5cGUuYXBwbHlEZWx0YSA9IGZ1bmN0aW9uIChkZWx0YSwgZG9Ob3RWYWxpZGF0ZSkgewogICAgICAgIHZhciBpc0luc2VydCA9IGRlbHRhLmFjdGlvbiA9PSAiaW5zZXJ0IjsKICAgICAgICBpZiAoaXNJbnNlcnQgPyBkZWx0YS5saW5lcy5sZW5ndGggPD0gMSAmJiAhZGVsdGEubGluZXNbMF0KICAgICAgICAgICAgOiAhUmFuZ2UuY29tcGFyZVBvaW50cyhkZWx0YS5zdGFydCwgZGVsdGEuZW5kKSkgewogICAgICAgICAgICByZXR1cm47CiAgICAgICAgfQogICAgICAgIGlmIChpc0luc2VydCAmJiBkZWx0YS5saW5lcy5sZW5ndGggPiAyMDAwMCkgewogICAgICAgICAgICB0aGlzLiRzcGxpdEFuZGFwcGx5TGFyZ2VEZWx0YShkZWx0YSwgMjAwMDApOwogICAgICAgIH0KICAgICAgICBlbHNlIHsKICAgICAgICAgICAgYXBwbHlEZWx0YSh0aGlzLiRsaW5lcywgZGVsdGEsIGRvTm90VmFsaWRhdGUpOwogICAgICAgICAgICB0aGlzLl9zaWduYWwoImNoYW5nZSIsIGRlbHRhKTsKICAgICAgICB9CiAgICB9OwogICAgRG9jdW1lbnQucHJvdG90eXBlLiRzYWZlQXBwbHlEZWx0YSA9IGZ1bmN0aW9uIChkZWx0YSkgewogICAgICAgIHZhciBkb2NMZW5ndGggPSB0aGlzLiRsaW5lcy5sZW5ndGg7CiAgICAgICAgaWYgKGRlbHRhLmFjdGlvbiA9PSAicmVtb3ZlIiAmJiBkZWx0YS5zdGFydC5yb3cgPCBkb2NMZW5ndGggJiYgZGVsdGEuZW5kLnJvdyA8IGRvY0xlbmd0aAogICAgICAgICAgICB8fCBkZWx0YS5hY3Rpb24gPT0gImluc2VydCIgJiYgZGVsdGEuc3RhcnQucm93IDw9IGRvY0xlbmd0aCkgewogICAgICAgICAgICB0aGlzLmFwcGx5RGVsdGEoZGVsdGEpOwogICAgICAgIH0KICAgIH07CiAgICBEb2N1bWVudC5wcm90b3R5cGUuJHNwbGl0QW5kYXBwbHlMYXJnZURlbHRhID0gZnVuY3Rpb24gKGRlbHRhLCBNQVgpIHsKICAgICAgICB2YXIgbGluZXMgPSBkZWx0YS5saW5lczsKICAgICAgICB2YXIgbCA9IGxpbmVzLmxlbmd0aCAtIE1BWCArIDE7CiAgICAgICAgdmFyIHJvdyA9IGRlbHRhLnN0YXJ0LnJvdzsKICAgICAgICB2YXIgY29sdW1uID0gZGVsdGEuc3RhcnQuY29sdW1uOwogICAgICAgIGZvciAodmFyIGZyb20gPSAwLCB0byA9IDA7IGZyb20gPCBsOyBmcm9tID0gdG8pIHsKICAgICAgICAgICAgdG8gKz0gTUFYIC0gMTsKICAgICAgICAgICAgdmFyIGNodW5rID0gbGluZXMuc2xpY2UoZnJvbSwgdG8pOwogICAgICAgICAgICBjaHVuay5wdXNoKCIiKTsKICAgICAgICAgICAgdGhpcy5hcHBseURlbHRhKHsKICAgICAgICAgICAgICAgIHN0YXJ0OiB0aGlzLnBvcyhyb3cgKyBmcm9tLCBjb2x1bW4pLAogICAgICAgICAgICAgICAgZW5kOiB0aGlzLnBvcyhyb3cgKyB0bywgY29sdW1uID0gMCksCiAgICAgICAgICAgICAgICBhY3Rpb246IGRlbHRhLmFjdGlvbiwKICAgICAgICAgICAgICAgIGxpbmVzOiBjaHVuawogICAgICAgICAgICB9LCB0cnVlKTsKICAgICAgICB9CiAgICAgICAgZGVsdGEubGluZXMgPSBsaW5lcy5zbGljZShmcm9tKTsKICAgICAgICBkZWx0YS5zdGFydC5yb3cgPSByb3cgKyBmcm9tOwogICAgICAgIGRlbHRhLnN0YXJ0LmNvbHVtbiA9IGNvbHVtbjsKICAgICAgICB0aGlzLmFwcGx5RGVsdGEoZGVsdGEsIHRydWUpOwogICAgfTsKICAgIERvY3VtZW50LnByb3RvdHlwZS5yZXZlcnREZWx0YSA9IGZ1bmN0aW9uIChkZWx0YSkgewogICAgICAgIHRoaXMuJHNhZmVBcHBseURlbHRhKHsKICAgICAgICAgICAgc3RhcnQ6IHRoaXMuY2xvbmVQb3MoZGVsdGEuc3RhcnQpLAogICAgICAgICAgICBlbmQ6IHRoaXMuY2xvbmVQb3MoZGVsdGEuZW5kKSwKICAgICAgICAgICAgYWN0aW9uOiAoZGVsdGEuYWN0aW9uID09ICJpbnNlcnQiID8gInJlbW92ZSIgOiAiaW5zZXJ0IiksCiAgICAgICAgICAgIGxpbmVzOiBkZWx0YS5saW5lcy5zbGljZSgpCiAgICAgICAgfSk7CiAgICB9OwogICAgRG9jdW1lbnQucHJvdG90eXBlLmluZGV4VG9Qb3NpdGlvbiA9IGZ1bmN0aW9uIChpbmRleCwgc3RhcnRSb3cpIHsKICAgICAgICB2YXIgbGluZXMgPSB0aGlzLiRsaW5lcyB8fCB0aGlzLmdldEFsbExpbmVzKCk7CiAgICAgICAgdmFyIG5ld2xpbmVMZW5ndGggPSB0aGlzLmdldE5ld0xpbmVDaGFyYWN0ZXIoKS5sZW5ndGg7CiAgICAgICAgZm9yICh2YXIgaSA9IHN0YXJ0Um93IHx8IDAsIGwgPSBsaW5lcy5sZW5ndGg7IGkgPCBsOyBpKyspIHsKICAgICAgICAgICAgaW5kZXggLT0gbGluZXNbaV0ubGVuZ3RoICsgbmV3bGluZUxlbmd0aDsKICAgICAgICAgICAgaWYgKGluZGV4IDwgMCkKICAgICAgICAgICAgICAgIHJldHVybiB7IHJvdzogaSwgY29sdW1uOiBpbmRleCArIGxpbmVzW2ldLmxlbmd0aCArIG5ld2xpbmVMZW5ndGggfTsKICAgICAgICB9CiAgICAgICAgcmV0dXJuIHsgcm93OiBsIC0gMSwgY29sdW1uOiBpbmRleCArIGxpbmVzW2wgLSAxXS5sZW5ndGggKyBuZXdsaW5lTGVuZ3RoIH07CiAgICB9OwogICAgRG9jdW1lbnQucHJvdG90eXBlLnBvc2l0aW9uVG9JbmRleCA9IGZ1bmN0aW9uIChwb3MsIHN0YXJ0Um93KSB7CiAgICAgICAgdmFyIGxpbmVzID0gdGhpcy4kbGluZXMgfHwgdGhpcy5nZXRBbGxMaW5lcygpOwogICAgICAgIHZhciBuZXdsaW5lTGVuZ3RoID0gdGhpcy5nZXROZXdMaW5lQ2hhcmFjdGVyKCkubGVuZ3RoOwogICAgICAgIHZhciBpbmRleCA9IDA7CiAgICAgICAgdmFyIHJvdyA9IE1hdGgubWluKHBvcy5yb3csIGxpbmVzLmxlbmd0aCk7CiAgICAgICAgZm9yICh2YXIgaSA9IHN0YXJ0Um93IHx8IDA7IGkgPCByb3c7ICsraSkKICAgICAgICAgICAgaW5kZXggKz0gbGluZXNbaV0ubGVuZ3RoICsgbmV3bGluZUxlbmd0aDsKICAgICAgICByZXR1cm4gaW5kZXggKyBwb3MuY29sdW1uOwogICAgfTsKICAgIERvY3VtZW50LnByb3RvdHlwZS4kc3BsaXQgPSBmdW5jdGlvbiAodGV4dCkgewogICAgICAgIHJldHVybiB0ZXh0LnNwbGl0KC9cclxufFxyfFxuLyk7CiAgICB9OwogICAgcmV0dXJuIERvY3VtZW50Owp9KCkpOwpEb2N1bWVudC5wcm90b3R5cGUuJGF1dG9OZXdMaW5lID0gIiI7CkRvY3VtZW50LnByb3RvdHlwZS4kbmV3TGluZU1vZGUgPSAiYXV0byI7Cm9vcC5pbXBsZW1lbnQoRG9jdW1lbnQucHJvdG90eXBlLCBFdmVudEVtaXR0ZXIpOwpleHBvcnRzLkRvY3VtZW50ID0gRG9jdW1lbnQ7Cgp9KTsKCmFjZS5kZWZpbmUoImFjZS9saWIvZGVlcF9jb3B5IixbXSwgZnVuY3Rpb24ocmVxdWlyZSwgZXhwb3J0cywgbW9kdWxlKXtleHBvcnRzLmRlZXBDb3B5ID0gZnVuY3Rpb24gZGVlcENvcHkob2JqKSB7CiAgICBpZiAodHlwZW9mIG9iaiAhPT0gIm9iamVjdCIgfHwgIW9iaikKICAgICAgICByZXR1cm4gb2JqOwogICAgdmFyIGNvcHk7CiAgICBpZiAoQXJyYXkuaXNBcnJheShvYmopKSB7CiAgICAgICAgY29weSA9IFtdOwogICAgICAgIGZvciAodmFyIGtleSA9IDA7IGtleSA8IG9iai5sZW5ndGg7IGtleSsrKSB7CiAgICAgICAgICAgIGNvcHlba2V5XSA9IGRlZXBDb3B5KG9ialtrZXldKTsKICAgICAgICB9CiAgICAgICAgcmV0dXJuIGNvcHk7CiAgICB9CiAgICBpZiAoT2JqZWN0LnByb3RvdHlwZS50b1N0cmluZy5jYWxsKG9iaikgIT09ICJbb2JqZWN0IE9iamVjdF0iKQogICAgICAgIHJldHVybiBvYmo7CiAgICBjb3B5ID0ge307CiAgICBmb3IgKHZhciBrZXkgaW4gb2JqKQogICAgICAgIGNvcHlba2V5XSA9IGRlZXBDb3B5KG9ialtrZXldKTsKICAgIHJldHVybiBjb3B5Owp9OwoKfSk7CgphY2UuZGVmaW5lKCJhY2UvbGliL2xhbmciLFtdLCBmdW5jdGlvbihyZXF1aXJlLCBleHBvcnRzLCBtb2R1bGUpeyJ1c2Ugc3RyaWN0IjsKZXhwb3J0cy5sYXN0ID0gZnVuY3Rpb24gKGEpIHsKICAgIHJldHVybiBhW2EubGVuZ3RoIC0gMV07Cn07CmV4cG9ydHMuc3RyaW5nUmV2ZXJzZSA9IGZ1bmN0aW9uIChzdHJpbmcpIHsKICAgIHJldHVybiBzdHJpbmcuc3BsaXQoIiIpLnJldmVyc2UoKS5qb2luKCIiKTsKfTsKZXhwb3J0cy5zdHJpbmdSZXBlYXQgPSBmdW5jdGlvbiAoc3RyaW5nLCBjb3VudCkgewogICAgdmFyIHJlc3VsdCA9ICcnOwogICAgd2hpbGUgKGNvdW50ID4gMCkgewogICAgICAgIGlmIChjb3VudCAmIDEpCiAgICAgICAgICAgIHJlc3VsdCArPSBzdHJpbmc7CiAgICAgICAgaWYgKGNvdW50ID4+PSAxKQogICAgICAgICAgICBzdHJpbmcgKz0gc3RyaW5nOwogICAgfQogICAgcmV0dXJuIHJlc3VsdDsKfTsKdmFyIHRyaW1CZWdpblJlZ2V4cCA9IC9eXHNccyovOwp2YXIgdHJpbUVuZFJlZ2V4cCA9IC9cc1xzKiQvOwpleHBvcnRzLnN0cmluZ1RyaW1MZWZ0ID0gZnVuY3Rpb24gKHN0cmluZykgewogICAgcmV0dXJuIHN0cmluZy5yZXBsYWNlKHRyaW1CZWdpblJlZ2V4cCwgJycpOwp9OwpleHBvcnRzLnN0cmluZ1RyaW1SaWdodCA9IGZ1bmN0aW9uIChzdHJpbmcpIHsKICAgIHJldHVybiBzdHJpbmcucmVwbGFjZSh0cmltRW5kUmVnZXhwLCAnJyk7Cn07CmV4cG9ydHMuY29weU9iamVjdCA9IGZ1bmN0aW9uIChvYmopIHsKICAgIHZhciBjb3B5ID0ge307CiAgICBmb3IgKHZhciBrZXkgaW4gb2JqKSB7CiAgICAgICAgY29weVtrZXldID0gb2JqW2tleV07CiAgICB9CiAgICByZXR1cm4gY29weTsKfTsKZXhwb3J0cy5jb3B5QXJyYXkgPSBmdW5jdGlvbiAoYXJyYXkpIHsKICAgIHZhciBjb3B5ID0gW107CiAgICBmb3IgKHZhciBpID0gMCwgbCA9IGFycmF5Lmxlbmd0aDsgaSA8IGw7IGkrKykgewogICAgICAgIGlmIChhcnJheVtpXSAmJiB0eXBlb2YgYXJyYXlbaV0gPT0gIm9iamVjdCIpCiAgICAgICAgICAgIGNvcHlbaV0gPSB0aGlzLmNvcHlPYmplY3QoYXJyYXlbaV0pOwogICAgICAgIGVsc2UKICAgICAgICAgICAgY29weVtpXSA9IGFycmF5W2ldOwogICAgfQogICAgcmV0dXJuIGNvcHk7Cn07CmV4cG9ydHMuZGVlcENvcHkgPSByZXF1aXJlKCIuL2RlZXBfY29weSIpLmRlZXBDb3B5OwpleHBvcnRzLmFycmF5VG9NYXAgPSBmdW5jdGlvbiAoYXJyKSB7CiAgICB2YXIgbWFwID0ge307CiAgICBmb3IgKHZhciBpID0gMDsgaSA8IGFyci5sZW5ndGg7IGkrKykgewogICAgICAgIG1hcFthcnJbaV1dID0gMTsKICAgIH0KICAgIHJldHVybiBtYXA7Cn07CmV4cG9ydHMuY3JlYXRlTWFwID0gZnVuY3Rpb24gKHByb3BzKSB7CiAgICB2YXIgbWFwID0gT2JqZWN0LmNyZWF0ZShudWxsKTsKICAgIGZvciAodmFyIGkgaW4gcHJvcHMpIHsKICAgICAgICBtYXBbaV0gPSBwcm9wc1tpXTsKICAgIH0KICAgIHJldHVybiBtYXA7Cn07CmV4cG9ydHMuYXJyYXlSZW1vdmUgPSBmdW5jdGlvbiAoYXJyYXksIHZhbHVlKSB7CiAgICBmb3IgKHZhciBpID0gMDsgaSA8PSBhcnJheS5sZW5ndGg7IGkrKykgewogICAgICAgIGlmICh2YWx1ZSA9PT0gYXJyYXlbaV0pIHsKICAgICAgICAgICAgYXJyYXkuc3BsaWNlKGksIDEpOwogICAgICAgIH0KICAgIH0KfTsKZXhwb3J0cy5lc2NhcGVSZWdFeHAgPSBmdW5jdGlvbiAoc3RyKSB7CiAgICByZXR1cm4gc3RyLnJlcGxhY2UoLyhbLiorP14ke30oKXxbXF1cL1xcXSkvZywgJ1xcJDEnKTsKfTsKZXhwb3J0cy5lc2NhcGVIVE1MID0gZnVuY3Rpb24gKHN0cikgewogICAgcmV0dXJuICgiIiArIHN0cikucmVwbGFjZSgvJi9nLCAiJiMzODsiKS5yZXBsYWNlKC8iL2csICImIzM0OyIpLnJlcGxhY2UoLycvZywgIiYjMzk7IikucmVwbGFjZSgvPC9nLCAiJiM2MDsiKTsKfTsKZXhwb3J0cy5nZXRNYXRjaE9mZnNldHMgPSBmdW5jdGlvbiAoc3RyaW5nLCByZWdFeHApIHsKICAgIHZhciBtYXRjaGVzID0gW107CiAgICBzdHJpbmcucmVwbGFjZShyZWdFeHAsIGZ1bmN0aW9uIChzdHIpIHsKICAgICAgICBtYXRjaGVzLnB1c2goewogICAgICAgICAgICBvZmZzZXQ6IGFyZ3VtZW50c1thcmd1bWVudHMubGVuZ3RoIC0gMl0sCiAgICAgICAgICAgIGxlbmd0aDogc3RyLmxlbmd0aAogICAgICAgIH0pOwogICAgfSk7CiAgICByZXR1cm4gbWF0Y2hlczsKfTsKZXhwb3J0cy5kZWZlcnJlZENhbGwgPSBmdW5jdGlvbiAoZmNuKSB7CiAgICB2YXIgdGltZXIgPSBudWxsOwogICAgdmFyIGNhbGxiYWNrID0gZnVuY3Rpb24gKCkgewogICAgICAgIHRpbWVyID0gbnVsbDsKICAgICAgICBmY24oKTsKICAgIH07CiAgICB2YXIgZGVmZXJyZWQgPSBmdW5jdGlvbiAodGltZW91dCkgewogICAgICAgIGRlZmVycmVkLmNhbmNlbCgpOwogICAgICAgIHRpbWVyID0gc2V0VGltZW91dChjYWxsYmFjaywgdGltZW91dCB8fCAwKTsKICAgICAgICByZXR1cm4gZGVmZXJyZWQ7CiAgICB9OwogICAgZGVmZXJyZWQuc2NoZWR1bGUgPSBkZWZlcnJlZDsKICAgIGRlZmVycmVkLmNhbGwgPSBmdW5jdGlvbiAoKSB7CiAgICAgICAgdGhpcy5jYW5jZWwoKTsKICAgICAgICBmY24oKTsKICAgICAgICByZXR1cm4gZGVmZXJyZWQ7CiAgICB9OwogICAgZGVmZXJyZWQuY2FuY2VsID0gZnVuY3Rpb24gKCkgewogICAgICAgIGNsZWFyVGltZW91dCh0aW1lcik7CiAgICAgICAgdGltZXIgPSBudWxsOwogICAgICAgIHJldHVybiBkZWZlcnJlZDsKICAgIH07CiAgICBkZWZlcnJlZC5pc1BlbmRpbmcgPSBmdW5jdGlvbiAoKSB7CiAgICAgICAgcmV0dXJuIHRpbWVyOwogICAgfTsKICAgIHJldHVybiBkZWZlcnJlZDsKfTsKZXhwb3J0cy5kZWxheWVkQ2FsbCA9IGZ1bmN0aW9uIChmY24sIGRlZmF1bHRUaW1lb3V0KSB7CiAgICB2YXIgdGltZXIgPSBudWxsOwogICAgdmFyIGNhbGxiYWNrID0gZnVuY3Rpb24gKCkgewogICAgICAgIHRpbWVyID0gbnVsbDsKICAgICAgICBmY24oKTsKICAgIH07CiAgICB2YXIgX3NlbGYgPSBmdW5jdGlvbiAodGltZW91dCkgewogICAgICAgIGlmICh0aW1lciA9PSBudWxsKQogICAgICAgICAgICB0aW1lciA9IHNldFRpbWVvdXQoY2FsbGJhY2ssIHRpbWVvdXQgfHwgZGVmYXVsdFRpbWVvdXQpOwogICAgfTsKICAgIF9zZWxmLmRlbGF5ID0gZnVuY3Rpb24gKHRpbWVvdXQpIHsKICAgICAgICB0aW1lciAmJiBjbGVhclRpbWVvdXQodGltZXIpOwogICAgICAgIHRpbWVyID0gc2V0VGltZW91dChjYWxsYmFjaywgdGltZW91dCB8fCBkZWZhdWx0VGltZW91dCk7CiAgICB9OwogICAgX3NlbGYuc2NoZWR1bGUgPSBfc2VsZjsKICAgIF9zZWxmLmNhbGwgPSBmdW5jdGlvbiAoKSB7CiAgICAgICAgdGhpcy5jYW5jZWwoKTsKICAgICAgICBmY24oKTsKICAgIH07CiAgICBfc2VsZi5jYW5jZWwgPSBmdW5jdGlvbiAoKSB7CiAgICAgICAgdGltZXIgJiYgY2xlYXJUaW1lb3V0KHRpbWVyKTsKICAgICAgICB0aW1lciA9IG51bGw7CiAgICB9OwogICAgX3NlbGYuaXNQZW5kaW5nID0gZnVuY3Rpb24gKCkgewogICAgICAgIHJldHVybiB0aW1lcjsKICAgIH07CiAgICByZXR1cm4gX3NlbGY7Cn07CmV4cG9ydHMuc3VwcG9ydHNMb29rYmVoaW5kID0gZnVuY3Rpb24gKCkgewogICAgdHJ5IHsKICAgICAgICBuZXcgUmVnRXhwKCcoPzw9LiknKTsKICAgIH0KICAgIGNhdGNoIChlKSB7CiAgICAgICAgcmV0dXJuIGZhbHNlOwogICAgfQogICAgcmV0dXJuIHRydWU7Cn07CmV4cG9ydHMuc2tpcEVtcHR5TWF0Y2ggPSBmdW5jdGlvbiAobGluZSwgbGFzdCwgc3VwcG9ydHNVbmljb2RlRmxhZykgewogICAgcmV0dXJuIHN1cHBvcnRzVW5pY29kZUZsYWcgJiYgbGluZS5jb2RlUG9pbnRBdChsYXN0KSA+IDB4ZmZmZiA/IDIgOiAxOwp9OwoKfSk7CgphY2UuZGVmaW5lKCJhY2Uvd29ya2VyL21pcnJvciIsW10sIGZ1bmN0aW9uKHJlcXVpcmUsIGV4cG9ydHMsIG1vZHVsZSkgewoidXNlIHN0cmljdCI7Cgp2YXIgRG9jdW1lbnQgPSByZXF1aXJlKCIuLi9kb2N1bWVudCIpLkRvY3VtZW50Owp2YXIgbGFuZyA9IHJlcXVpcmUoIi4uL2xpYi9sYW5nIik7CiAgICAKdmFyIE1pcnJvciA9IGV4cG9ydHMuTWlycm9yID0gZnVuY3Rpb24oc2VuZGVyKSB7CiAgICB0aGlzLnNlbmRlciA9IHNlbmRlcjsKICAgIHZhciBkb2MgPSB0aGlzLmRvYyA9IG5ldyBEb2N1bWVudCgiIik7CiAgICAKICAgIHZhciBkZWZlcnJlZFVwZGF0ZSA9IHRoaXMuZGVmZXJyZWRVcGRhdGUgPSBsYW5nLmRlbGF5ZWRDYWxsKHRoaXMub25VcGRhdGUuYmluZCh0aGlzKSk7CiAgICAKICAgIHZhciBfc2VsZiA9IHRoaXM7CiAgICBzZW5kZXIub24oImNoYW5nZSIsIGZ1bmN0aW9uKGUpIHsKICAgICAgICB2YXIgZGF0YSA9IGUuZGF0YTsKICAgICAgICBpZiAoZGF0YVswXS5zdGFydCkgewogICAgICAgICAgICBkb2MuYXBwbHlEZWx0YXMoZGF0YSk7CiAgICAgICAgfSBlbHNlIHsKICAgICAgICAgICAgZm9yICh2YXIgaSA9IDA7IGkgPCBkYXRhLmxlbmd0aDsgaSArPSAyKSB7CiAgICAgICAgICAgICAgICB2YXIgZCwgZXJyOyAKICAgICAgICAgICAgICAgIGlmIChBcnJheS5pc0FycmF5KGRhdGFbaSsxXSkpIHsKICAgICAgICAgICAgICAgICAgICBkID0ge2FjdGlvbjogImluc2VydCIsIHN0YXJ0OiBkYXRhW2ldLCBsaW5lczogZGF0YVtpKzFdfTsKICAgICAgICAgICAgICAgIH0gZWxzZSB7CiAgICAgICAgICAgICAgICAgICAgZCA9IHthY3Rpb246ICJyZW1vdmUiLCBzdGFydDogZGF0YVtpXSwgZW5kOiBkYXRhW2krMV19OwogICAgICAgICAgICAgICAgfQogICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICBpZiAoKGQuYWN0aW9uID09ICJpbnNlcnQiID8gZC5zdGFydCA6IGQuZW5kKS5yb3cgPj0gZG9jLiRsaW5lcy5sZW5ndGgpIHsKICAgICAgICAgICAgICAgICAgICBlcnIgPSBuZXcgRXJyb3IoIkludmFsaWQgZGVsdGEiKTsKICAgICAgICAgICAgICAgICAgICBlcnIuZGF0YSA9IHsKICAgICAgICAgICAgICAgICAgICAgICAgcGF0aDogX3NlbGYuJHBhdGgsCiAgICAgICAgICAgICAgICAgICAgICAgIGxpbmVzTGVuZ3RoOiBkb2MuJGxpbmVzLmxlbmd0aCwKICAgICAgICAgICAgICAgICAgICAgICAgc3RhcnQ6IGQuc3RhcnQsCiAgICAgICAgICAgICAgICAgICAgICAgIGVuZDogZC5lbmQKICAgICAgICAgICAgICAgICAgICB9OwogICAgICAgICAgICAgICAgICAgIHRocm93IGVycjsKICAgICAgICAgICAgICAgIH0KCiAgICAgICAgICAgICAgICBkb2MuYXBwbHlEZWx0YShkLCB0cnVlKTsKICAgICAgICAgICAgfQogICAgICAgIH0KICAgICAgICBpZiAoX3NlbGYuJHRpbWVvdXQpCiAgICAgICAgICAgIHJldHVybiBkZWZlcnJlZFVwZGF0ZS5zY2hlZHVsZShfc2VsZi4kdGltZW91dCk7CiAgICAgICAgX3NlbGYub25VcGRhdGUoKTsKICAgIH0pOwp9OwoKKGZ1bmN0aW9uKCkgewogICAgCiAgICB0aGlzLiR0aW1lb3V0ID0gNTAwOwogICAgCiAgICB0aGlzLnNldFRpbWVvdXQgPSBmdW5jdGlvbih0aW1lb3V0KSB7CiAgICAgICAgdGhpcy4kdGltZW91dCA9IHRpbWVvdXQ7CiAgICB9OwogICAgCiAgICB0aGlzLnNldFZhbHVlID0gZnVuY3Rpb24odmFsdWUpIHsKICAgICAgICB0aGlzLmRvYy5zZXRWYWx1ZSh2YWx1ZSk7CiAgICAgICAgdGhpcy5kZWZlcnJlZFVwZGF0ZS5zY2hlZHVsZSh0aGlzLiR0aW1lb3V0KTsKICAgIH07CiAgICAKICAgIHRoaXMuZ2V0VmFsdWUgPSBmdW5jdGlvbihjYWxsYmFja0lkKSB7CiAgICAgICAgdGhpcy5zZW5kZXIuY2FsbGJhY2sodGhpcy5kb2MuZ2V0VmFsdWUoKSwgY2FsbGJhY2tJZCk7CiAgICB9OwogICAgCiAgICB0aGlzLm9uVXBkYXRlID0gZnVuY3Rpb24oKSB7CiAgICB9OwogICAgCiAgICB0aGlzLmlzUGVuZGluZyA9IGZ1bmN0aW9uKCkgewogICAgICAgIHJldHVybiB0aGlzLmRlZmVycmVkVXBkYXRlLmlzUGVuZGluZygpOwogICAgfTsKICAgIAp9KS5jYWxsKE1pcnJvci5wcm90b3R5cGUpOwoKfSk7CgphY2UuZGVmaW5lKCJhY2UvbW9kZS9qc29uL2pzb25fcGFyc2UiLFtdLCBmdW5jdGlvbihyZXF1aXJlLCBleHBvcnRzLCBtb2R1bGUpIHsKInVzZSBzdHJpY3QiOwoKICAgIHZhciBhdCwgICAgIC8vIFRoZSBpbmRleCBvZiB0aGUgY3VycmVudCBjaGFyYWN0ZXIKICAgICAgICBjaCwgICAgIC8vIFRoZSBjdXJyZW50IGNoYXJhY3RlcgogICAgICAgIGVzY2FwZWUgPSB7CiAgICAgICAgICAgICciJzogICciJywKICAgICAgICAgICAgJ1xcJzogJ1xcJywKICAgICAgICAgICAgJy8nOiAgJy8nLAogICAgICAgICAgICBiOiAgICAnXGInLAogICAgICAgICAgICBmOiAgICAnXGYnLAogICAgICAgICAgICBuOiAgICAnXG4nLAogICAgICAgICAgICByOiAgICAnXHInLAogICAgICAgICAgICB0OiAgICAnXHQnCiAgICAgICAgfSwKICAgICAgICB0ZXh0LAoKICAgICAgICBlcnJvciA9IGZ1bmN0aW9uIChtKSB7CgogICAgICAgICAgICB0aHJvdyB7CiAgICAgICAgICAgICAgICBuYW1lOiAgICAnU3ludGF4RXJyb3InLAogICAgICAgICAgICAgICAgbWVzc2FnZTogbSwKICAgICAgICAgICAgICAgIGF0OiAgICAgIGF0LAogICAgICAgICAgICAgICAgdGV4dDogICAgdGV4dAogICAgICAgICAgICB9OwogICAgICAgIH0sCgogICAgICAgIG5leHQgPSBmdW5jdGlvbiAoYykgewoKICAgICAgICAgICAgaWYgKGMgJiYgYyAhPT0gY2gpIHsKICAgICAgICAgICAgICAgIGVycm9yKCJFeHBlY3RlZCAnIiArIGMgKyAiJyBpbnN0ZWFkIG9mICciICsgY2ggKyAiJyIpOwogICAgICAgICAgICB9CgogICAgICAgICAgICBjaCA9IHRleHQuY2hhckF0KGF0KTsKICAgICAgICAgICAgYXQgKz0gMTsKICAgICAgICAgICAgcmV0dXJuIGNoOwogICAgICAgIH0sCgogICAgICAgIG51bWJlciA9IGZ1bmN0aW9uICgpIHsKCiAgICAgICAgICAgIHZhciBudW1iZXIsCiAgICAgICAgICAgICAgICBzdHJpbmcgPSAnJzsKCiAgICAgICAgICAgIGlmIChjaCA9PT0gJy0nKSB7CiAgICAgICAgICAgICAgICBzdHJpbmcgPSAnLSc7CiAgICAgICAgICAgICAgICBuZXh0KCctJyk7CiAgICAgICAgICAgIH0KICAgICAgICAgICAgd2hpbGUgKGNoID49ICcwJyAmJiBjaCA8PSAnOScpIHsKICAgICAgICAgICAgICAgIHN0cmluZyArPSBjaDsKICAgICAgICAgICAgICAgIG5leHQoKTsKICAgICAgICAgICAgfQogICAgICAgICAgICBpZiAoY2ggPT09ICcuJykgewogICAgICAgICAgICAgICAgc3RyaW5nICs9ICcuJzsKICAgICAgICAgICAgICAgIHdoaWxlIChuZXh0KCkgJiYgY2ggPj0gJzAnICYmIGNoIDw9ICc5JykgewogICAgICAgICAgICAgICAgICAgIHN0cmluZyArPSBjaDsKICAgICAgICAgICAgICAgIH0KICAgICAgICAgICAgfQogICAgICAgICAgICBpZiAoY2ggPT09ICdlJyB8fCBjaCA9PT0gJ0UnKSB7CiAgICAgICAgICAgICAgICBzdHJpbmcgKz0gY2g7CiAgICAgICAgICAgICAgICBuZXh0KCk7CiAgICAgICAgICAgICAgICBpZiAoY2ggPT09ICctJyB8fCBjaCA9PT0gJysnKSB7CiAgICAgICAgICAgICAgICAgICAgc3RyaW5nICs9IGNoOwogICAgICAgICAgICAgICAgICAgIG5leHQoKTsKICAgICAgICAgICAgICAgIH0KICAgICAgICAgICAgICAgIHdoaWxlIChjaCA+PSAnMCcgJiYgY2ggPD0gJzknKSB7CiAgICAgICAgICAgICAgICAgICAgc3RyaW5nICs9IGNoOwogICAgICAgICAgICAgICAgICAgIG5leHQoKTsKICAgICAgICAgICAgICAgIH0KICAgICAgICAgICAgfQogICAgICAgICAgICBudW1iZXIgPSArc3RyaW5nOwogICAgICAgICAgICBpZiAoaXNOYU4obnVtYmVyKSkgewogICAgICAgICAgICAgICAgZXJyb3IoIkJhZCBudW1iZXIiKTsKICAgICAgICAgICAgfSBlbHNlIHsKICAgICAgICAgICAgICAgIHJldHVybiBudW1iZXI7CiAgICAgICAgICAgIH0KICAgICAgICB9LAoKICAgICAgICBzdHJpbmcgPSBmdW5jdGlvbiAoKSB7CgogICAgICAgICAgICB2YXIgaGV4LAogICAgICAgICAgICAgICAgaSwKICAgICAgICAgICAgICAgIHN0cmluZyA9ICcnLAogICAgICAgICAgICAgICAgdWZmZmY7CgogICAgICAgICAgICBpZiAoY2ggPT09ICciJykgewogICAgICAgICAgICAgICAgd2hpbGUgKG5leHQoKSkgewogICAgICAgICAgICAgICAgICAgIGlmIChjaCA9PT0gJyInKSB7CiAgICAgICAgICAgICAgICAgICAgICAgIG5leHQoKTsKICAgICAgICAgICAgICAgICAgICAgICAgcmV0dXJuIHN0cmluZzsKICAgICAgICAgICAgICAgICAgICB9IGVsc2UgaWYgKGNoID09PSAnXFwnKSB7CiAgICAgICAgICAgICAgICAgICAgICAgIG5leHQoKTsKICAgICAgICAgICAgICAgICAgICAgICAgaWYgKGNoID09PSAndScpIHsKICAgICAgICAgICAgICAgICAgICAgICAgICAgIHVmZmZmID0gMDsKICAgICAgICAgICAgICAgICAgICAgICAgICAgIGZvciAoaSA9IDA7IGkgPCA0OyBpICs9IDEpIHsKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICBoZXggPSBwYXJzZUludChuZXh0KCksIDE2KTsKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICBpZiAoIWlzRmluaXRlKGhleCkpIHsKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgYnJlYWs7CiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgfQogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIHVmZmZmID0gdWZmZmYgKiAxNiArIGhleDsKICAgICAgICAgICAgICAgICAgICAgICAgICAgIH0KICAgICAgICAgICAgICAgICAgICAgICAgICAgIHN0cmluZyArPSBTdHJpbmcuZnJvbUNoYXJDb2RlKHVmZmZmKTsKICAgICAgICAgICAgICAgICAgICAgICAgfSBlbHNlIGlmICh0eXBlb2YgZXNjYXBlZVtjaF0gPT09ICdzdHJpbmcnKSB7CiAgICAgICAgICAgICAgICAgICAgICAgICAgICBzdHJpbmcgKz0gZXNjYXBlZVtjaF07CiAgICAgICAgICAgICAgICAgICAgICAgIH0gZWxzZSB7CiAgICAgICAgICAgICAgICAgICAgICAgICAgICBicmVhazsKICAgICAgICAgICAgICAgICAgICAgICAgfQogICAgICAgICAgICAgICAgICAgIH0gZWxzZSBpZiAoY2ggPT0gIlxuIiB8fCBjaCA9PSAiXHIiKSB7CiAgICAgICAgICAgICAgICAgICAgICAgIGJyZWFrOwogICAgICAgICAgICAgICAgICAgIH0gZWxzZSB7CiAgICAgICAgICAgICAgICAgICAgICAgIHN0cmluZyArPSBjaDsKICAgICAgICAgICAgICAgICAgICB9CiAgICAgICAgICAgICAgICB9CiAgICAgICAgICAgIH0KICAgICAgICAgICAgZXJyb3IoIkJhZCBzdHJpbmciKTsKICAgICAgICB9LAoKICAgICAgICB3aGl0ZSA9IGZ1bmN0aW9uICgpIHsKCiAgICAgICAgICAgIHdoaWxlIChjaCAmJiBjaCA8PSAnICcpIHsKICAgICAgICAgICAgICAgIG5leHQoKTsKICAgICAgICAgICAgfQogICAgICAgIH0sCgogICAgICAgIHdvcmQgPSBmdW5jdGlvbiAoKSB7CgogICAgICAgICAgICBzd2l0Y2ggKGNoKSB7CiAgICAgICAgICAgIGNhc2UgJ3QnOgogICAgICAgICAgICAgICAgbmV4dCgndCcpOwogICAgICAgICAgICAgICAgbmV4dCgncicpOwogICAgICAgICAgICAgICAgbmV4dCgndScpOwogICAgICAgICAgICAgICAgbmV4dCgnZScpOwogICAgICAgICAgICAgICAgcmV0dXJuIHRydWU7CiAgICAgICAgICAgIGNhc2UgJ2YnOgogICAgICAgICAgICAgICAgbmV4dCgnZicpOwogICAgICAgICAgICAgICAgbmV4dCgnYScpOwogICAgICAgICAgICAgICAgbmV4dCgnbCcpOwogICAgICAgICAgICAgICAgbmV4dCgncycpOwogICAgICAgICAgICAgICAgbmV4dCgnZScpOwogICAgICAgICAgICAgICAgcmV0dXJuIGZhbHNlOwogICAgICAgICAgICBjYXNlICduJzoKICAgICAgICAgICAgICAgIG5leHQoJ24nKTsKICAgICAgICAgICAgICAgIG5leHQoJ3UnKTsKICAgICAgICAgICAgICAgIG5leHQoJ2wnKTsKICAgICAgICAgICAgICAgIG5leHQoJ2wnKTsKICAgICAgICAgICAgICAgIHJldHVybiBudWxsOwogICAgICAgICAgICB9CiAgICAgICAgICAgIGVycm9yKCJVbmV4cGVjdGVkICciICsgY2ggKyAiJyIpOwogICAgICAgIH0sCgogICAgICAgIHZhbHVlLCAgLy8gUGxhY2UgaG9sZGVyIGZvciB0aGUgdmFsdWUgZnVuY3Rpb24uCgogICAgICAgIGFycmF5ID0gZnVuY3Rpb24gKCkgewoKICAgICAgICAgICAgdmFyIGFycmF5ID0gW107CgogICAgICAgICAgICBpZiAoY2ggPT09ICdbJykgewogICAgICAgICAgICAgICAgbmV4dCgnWycpOwogICAgICAgICAgICAgICAgd2hpdGUoKTsKICAgICAgICAgICAgICAgIGlmIChjaCA9PT0gJ10nKSB7CiAgICAgICAgICAgICAgICAgICAgbmV4dCgnXScpOwogICAgICAgICAgICAgICAgICAgIHJldHVybiBhcnJheTsgICAvLyBlbXB0eSBhcnJheQogICAgICAgICAgICAgICAgfQogICAgICAgICAgICAgICAgd2hpbGUgKGNoKSB7CiAgICAgICAgICAgICAgICAgICAgYXJyYXkucHVzaCh2YWx1ZSgpKTsKICAgICAgICAgICAgICAgICAgICB3aGl0ZSgpOwogICAgICAgICAgICAgICAgICAgIGlmIChjaCA9PT0gJ10nKSB7CiAgICAgICAgICAgICAgICAgICAgICAgIG5leHQoJ10nKTsKICAgICAgICAgICAgICAgICAgICAgICAgcmV0dXJuIGFycmF5OwogICAgICAgICAgICAgICAgICAgIH0KICAgICAgICAgICAgICAgICAgICBuZXh0KCcsJyk7CiAgICAgICAgICAgICAgICAgICAgd2hpdGUoKTsKICAgICAgICAgICAgICAgIH0KICAgICAgICAgICAgfQogICAgICAgICAgICBlcnJvcigiQmFkIGFycmF5Iik7CiAgICAgICAgfSwKCiAgICAgICAgb2JqZWN0ID0gZnVuY3Rpb24gKCkgewoKICAgICAgICAgICAgdmFyIGtleSwKICAgICAgICAgICAgICAgIG9iamVjdCA9IHt9OwoKICAgICAgICAgICAgaWYgKGNoID09PSAneycpIHsKICAgICAgICAgICAgICAgIG5leHQoJ3snKTsKICAgICAgICAgICAgICAgIHdoaXRlKCk7CiAgICAgICAgICAgICAgICBpZiAoY2ggPT09ICd9JykgewogICAgICAgICAgICAgICAgICAgIG5leHQoJ30nKTsKICAgICAgICAgICAgICAgICAgICByZXR1cm4gb2JqZWN0OyAgIC8vIGVtcHR5IG9iamVjdAogICAgICAgICAgICAgICAgfQogICAgICAgICAgICAgICAgd2hpbGUgKGNoKSB7CiAgICAgICAgICAgICAgICAgICAga2V5ID0gc3RyaW5nKCk7CiAgICAgICAgICAgICAgICAgICAgd2hpdGUoKTsKICAgICAgICAgICAgICAgICAgICBuZXh0KCc6Jyk7CiAgICAgICAgICAgICAgICAgICAgaWYgKE9iamVjdC5oYXNPd25Qcm9wZXJ0eS5jYWxsKG9iamVjdCwga2V5KSkgewogICAgICAgICAgICAgICAgICAgICAgICBlcnJvcignRHVwbGljYXRlIGtleSAiJyArIGtleSArICciJyk7CiAgICAgICAgICAgICAgICAgICAgfQogICAgICAgICAgICAgICAgICAgIG9iamVjdFtrZXldID0gdmFsdWUoKTsKICAgICAgICAgICAgICAgICAgICB3aGl0ZSgpOwogICAgICAgICAgICAgICAgICAgIGlmIChjaCA9PT0gJ30nKSB7CiAgICAgICAgICAgICAgICAgICAgICAgIG5leHQoJ30nKTsKICAgICAgICAgICAgICAgICAgICAgICAgcmV0dXJuIG9iamVjdDsKICAgICAgICAgICAgICAgICAgICB9CiAgICAgICAgICAgICAgICAgICAgbmV4dCgnLCcpOwogICAgICAgICAgICAgICAgICAgIHdoaXRlKCk7CiAgICAgICAgICAgICAgICB9CiAgICAgICAgICAgIH0KICAgICAgICAgICAgZXJyb3IoIkJhZCBvYmplY3QiKTsKICAgICAgICB9OwoKICAgIHZhbHVlID0gZnVuY3Rpb24gKCkgewoKICAgICAgICB3aGl0ZSgpOwogICAgICAgIHN3aXRjaCAoY2gpIHsKICAgICAgICBjYXNlICd7JzoKICAgICAgICAgICAgcmV0dXJuIG9iamVjdCgpOwogICAgICAgIGNhc2UgJ1snOgogICAgICAgICAgICByZXR1cm4gYXJyYXkoKTsKICAgICAgICBjYXNlICciJzoKICAgICAgICAgICAgcmV0dXJuIHN0cmluZygpOwogICAgICAgIGNhc2UgJy0nOgogICAgICAgICAgICByZXR1cm4gbnVtYmVyKCk7CiAgICAgICAgZGVmYXVsdDoKICAgICAgICAgICAgcmV0dXJuIGNoID49ICcwJyAmJiBjaCA8PSAnOScgPyBudW1iZXIoKSA6IHdvcmQoKTsKICAgICAgICB9CiAgICB9OwoKICAgIHJldHVybiBmdW5jdGlvbiAoc291cmNlLCByZXZpdmVyKSB7CiAgICAgICAgdmFyIHJlc3VsdDsKCiAgICAgICAgdGV4dCA9IHNvdXJjZTsKICAgICAgICBhdCA9IDA7CiAgICAgICAgY2ggPSAnICc7CiAgICAgICAgcmVzdWx0ID0gdmFsdWUoKTsKICAgICAgICB3aGl0ZSgpOwogICAgICAgIGlmIChjaCkgewogICAgICAgICAgICBlcnJvcigiU3ludGF4IGVycm9yIik7CiAgICAgICAgfQoKICAgICAgICByZXR1cm4gdHlwZW9mIHJldml2ZXIgPT09ICdmdW5jdGlvbicgPyBmdW5jdGlvbiB3YWxrKGhvbGRlciwga2V5KSB7CiAgICAgICAgICAgIHZhciBrLCB2LCB2YWx1ZSA9IGhvbGRlcltrZXldOwogICAgICAgICAgICBpZiAodmFsdWUgJiYgdHlwZW9mIHZhbHVlID09PSAnb2JqZWN0JykgewogICAgICAgICAgICAgICAgZm9yIChrIGluIHZhbHVlKSB7CiAgICAgICAgICAgICAgICAgICAgaWYgKE9iamVjdC5oYXNPd25Qcm9wZXJ0eS5jYWxsKHZhbHVlLCBrKSkgewogICAgICAgICAgICAgICAgICAgICAgICB2ID0gd2Fsayh2YWx1ZSwgayk7CiAgICAgICAgICAgICAgICAgICAgICAgIGlmICh2ICE9PSB1bmRlZmluZWQpIHsKICAgICAgICAgICAgICAgICAgICAgICAgICAgIHZhbHVlW2tdID0gdjsKICAgICAgICAgICAgICAgICAgICAgICAgfSBlbHNlIHsKICAgICAgICAgICAgICAgICAgICAgICAgICAgIGRlbGV0ZSB2YWx1ZVtrXTsKICAgICAgICAgICAgICAgICAgICAgICAgfQogICAgICAgICAgICAgICAgICAgIH0KICAgICAgICAgICAgICAgIH0KICAgICAgICAgICAgfQogICAgICAgICAgICByZXR1cm4gcmV2aXZlci5jYWxsKGhvbGRlciwga2V5LCB2YWx1ZSk7CiAgICAgICAgfSh7Jyc6IHJlc3VsdH0sICcnKSA6IHJlc3VsdDsKICAgIH07Cn0pOwoKYWNlLmRlZmluZSgiYWNlL21vZGUvanNvbl93b3JrZXIiLFtdLCBmdW5jdGlvbihyZXF1aXJlLCBleHBvcnRzLCBtb2R1bGUpIHsKInVzZSBzdHJpY3QiOwoKdmFyIG9vcCA9IHJlcXVpcmUoIi4uL2xpYi9vb3AiKTsKdmFyIE1pcnJvciA9IHJlcXVpcmUoIi4uL3dvcmtlci9taXJyb3IiKS5NaXJyb3I7CnZhciBwYXJzZSA9IHJlcXVpcmUoIi4vanNvbi9qc29uX3BhcnNlIik7Cgp2YXIgSnNvbldvcmtlciA9IGV4cG9ydHMuSnNvbldvcmtlciA9IGZ1bmN0aW9uKHNlbmRlcikgewogICAgTWlycm9yLmNhbGwodGhpcywgc2VuZGVyKTsKICAgIHRoaXMuc2V0VGltZW91dCgyMDApOwp9OwoKb29wLmluaGVyaXRzKEpzb25Xb3JrZXIsIE1pcnJvcik7CgooZnVuY3Rpb24oKSB7CgogICAgdGhpcy5vblVwZGF0ZSA9IGZ1bmN0aW9uKCkgewogICAgICAgIHZhciB2YWx1ZSA9IHRoaXMuZG9jLmdldFZhbHVlKCk7CiAgICAgICAgdmFyIGVycm9ycyA9IFtdOwogICAgICAgIHRyeSB7CiAgICAgICAgICAgIGlmICh2YWx1ZSkKICAgICAgICAgICAgICAgIHBhcnNlKHZhbHVlKTsKICAgICAgICB9IGNhdGNoIChlKSB7CiAgICAgICAgICAgIHZhciBwb3MgPSB0aGlzLmRvYy5pbmRleFRvUG9zaXRpb24oZS5hdC0xKTsKICAgICAgICAgICAgZXJyb3JzLnB1c2goewogICAgICAgICAgICAgICAgcm93OiBwb3Mucm93LAogICAgICAgICAgICAgICAgY29sdW1uOiBwb3MuY29sdW1uLAogICAgICAgICAgICAgICAgdGV4dDogZS5tZXNzYWdlLAogICAgICAgICAgICAgICAgdHlwZTogImVycm9yIgogICAgICAgICAgICB9KTsKICAgICAgICB9CiAgICAgICAgdGhpcy5zZW5kZXIuZW1pdCgiYW5ub3RhdGUiLCBlcnJvcnMpOwogICAgfTsKCn0pLmNhbGwoSnNvbldvcmtlci5wcm90b3R5cGUpOwoKfSk7Cg==";
        },
        3057: function(e, t, i) {
            i.d(t, {
                AI: function() {
                    return c;
                },
                Tl: function() {
                    return h;
                },
                xC: function() {
                    return l;
                }
            });
            i(1081);
            var r = {
                en: {
                    array: "Array",
                    auto: "Auto",
                    appendText: "Append",
                    appendTitle: "Append a new field with type 'auto' after this field (Ctrl+Shift+Ins)",
                    appendSubmenuTitle: "Select the type of the field to be appended",
                    appendTitleAuto: "Append a new field with type 'auto' (Ctrl+Shift+Ins)",
                    ascending: "Ascending",
                    ascendingTitle: "Sort the childs of this ${type} in ascending order",
                    actionsMenu: "Click to open the actions menu (Ctrl+M)",
                    cannotParseFieldError: "Cannot parse field into JSON",
                    cannotParseValueError: "Cannot parse value into JSON",
                    collapseAll: "Collapse all fields",
                    compactTitle: "Compact JSON data, remove all whitespaces (Ctrl+Shift+I)",
                    descending: "Descending",
                    descendingTitle: "Sort the childs of this ${type} in descending order",
                    drag: "Drag to move this field (Alt+Shift+Arrows)",
                    duplicateKey: "duplicate key",
                    duplicateText: "Duplicate",
                    duplicateTitle: "Duplicate selected fields (Ctrl+D)",
                    duplicateField: "Duplicate this field (Ctrl+D)",
                    duplicateFieldError: "Duplicate field name",
                    empty: "empty",
                    expandAll: "Expand all fields",
                    expandTitle: "Click to expand/collapse this field (Ctrl+E). \nCtrl+Click to expand/collapse including all childs.",
                    formatTitle: "Format JSON data, with proper indentation and line feeds (Ctrl+I)",
                    insert: "Insert",
                    insertTitle: "Insert a new field with type 'auto' before this field (Ctrl+Ins)",
                    insertSub: "Select the type of the field to be inserted",
                    object: "Object",
                    ok: "Ok",
                    redo: "Redo (Ctrl+Shift+Z)",
                    removeText: "Remove",
                    removeTitle: "Remove selected fields (Ctrl+Del)",
                    removeField: "Remove this field (Ctrl+Del)",
                    repairTitle: "Repair JSON: fix quotes and escape characters, remove comments and JSONP notation, turn JavaScript objects into JSON.",
                    searchTitle: "Search fields and values",
                    searchNextResultTitle: "Next result (Enter)",
                    searchPreviousResultTitle: "Previous result (Shift + Enter)",
                    selectNode: "Select a node...",
                    showAll: "show all",
                    showMore: "show more",
                    showMoreStatus: "displaying ${visibleChilds} of ${totalChilds} items.",
                    sort: "Sort",
                    sortTitle: "Sort the childs of this ${type}",
                    sortTitleShort: "Sort contents",
                    sortFieldLabel: "Field:",
                    sortDirectionLabel: "Direction:",
                    sortFieldTitle: "Select the nested field by which to sort the array or object",
                    sortAscending: "Ascending",
                    sortAscendingTitle: "Sort the selected field in ascending order",
                    sortDescending: "Descending",
                    sortDescendingTitle: "Sort the selected field in descending order",
                    string: "String",
                    transform: "Transform",
                    transformTitle: "Filter, sort, or transform the childs of this ${type}",
                    transformTitleShort: "Filter, sort, or transform contents",
                    extract: "Extract",
                    extractTitle: "Extract this ${type}",
                    transformQueryTitle: "Enter a JMESPath query",
                    transformWizardLabel: "Wizard",
                    transformWizardFilter: "Filter",
                    transformWizardSortBy: "Sort by",
                    transformWizardSelectFields: "Select fields",
                    transformQueryLabel: "Query",
                    transformPreviewLabel: "Preview",
                    type: "Type",
                    typeTitle: "Change the type of this field",
                    openUrl: "Ctrl+Click or Ctrl+Enter to open url in new window",
                    undo: "Undo last action (Ctrl+Z)",
                    validationCannotMove: "Cannot move a field into a child of itself",
                    autoType: 'Field type "auto". The field type is automatically determined from the value and can be a string, number, boolean, or null.',
                    objectType: 'Field type "object". An object contains an unordered set of key/value pairs.',
                    arrayType: 'Field type "array". An array contains an ordered collection of values.',
                    stringType: 'Field type "string". Field type is not determined from the value, but always returned as string.',
                    modeEditorTitle: "Switch Editor Mode",
                    modeCodeText: "Code",
                    modeCodeTitle: "Switch to code highlighter",
                    modeFormText: "Form",
                    modeFormTitle: "Switch to form editor",
                    modeTextText: "Text",
                    modeTextTitle: "Switch to plain text editor",
                    modeTreeText: "Tree",
                    modeTreeTitle: "Switch to tree editor",
                    modeViewText: "View",
                    modeViewTitle: "Switch to tree view",
                    modePreviewText: "Preview",
                    modePreviewTitle: "Switch to preview mode",
                    examples: "Examples",
                    default: "Default",
                    containsInvalidProperties: "Contains invalid properties",
                    containsInvalidItems: "Contains invalid items"
                },
                es: {
                    array: "Matriz",
                    auto: "Auto",
                    appendText: "Agregar",
                    appendTitle: "Agregue un nuevo campo con el tipo 'auto' despu\xe9s de este campo (Ctrl + Shift + Ins)",
                    appendSubmenuTitle: "Seleccione el tipo de campo que se agregar\xe1",
                    appendTitleAuto: "Agregue un nuevo campo con el tipo 'auto' (Ctrl + Shift + Ins)",
                    ascending: "Ascendente",
                    ascendingTitle: "Ordene los elementos secundarios de este ${type} en orden ascendente",
                    actionsMenu: "Haga clic para abrir el men\xfa de acciones (Ctrl + M)",
                    cannotParseFieldError: "No se puede parsear el campo en JSON",
                    cannotParseValueError: "No se puede parsear el valor en JSON",
                    collapseAll: "Contraer todos los campos",
                    compactTitle: "Compactar datos JSON, eliminar todos los espacios en blanco (Ctrl + Shift + I)",
                    descending: "Descendente",
                    descendingTitle: "Ordene los hijos de este ${type} en orden descendente",
                    drag: "Arrastre para mover este campo (Alt + May\xfas + Flechas)",
                    duplicateKey: "llave duplicada",
                    duplicateText: "Duplicar",
                    duplicateTitle: "Duplicar campos seleccionados (Ctrl + D)",
                    duplicateField: "Duplicar este campo (Ctrl + D)",
                    duplicateFieldError: "Nombre de campo duplicado",
                    empty: "vacio",
                    expandAll: "Expandir todos los campos",
                    expandTitle: "Haga clic para expandir/contraer este campo (Ctrl + E). \n  Ctrl+Clic para expandir/contraer incluyendo todos los ni\xf1os.",
                    formatTitle: "Formatee los datos JSON, con la sangr\xeda y los avances de l\xednea adecuados (Ctrl + I)",
                    insert: "Insertar",
                    insertTitle: "Inserte un nuevo campo con el tipo 'auto' antes de este campo (Ctrl + Ins)",
                    insertSub: "Seleccione el tipo de campo a insertar",
                    object: "Objeto",
                    ok: "Ok",
                    redo: "Rehacer (Ctrl+May\xfas+Z)",
                    removeText: "Eliminar",
                    removeTitle: "Eliminar campos seleccionados (Ctrl+Supr)",
                    removeField: "Eliminar este campo (Ctrl+Supr)",
                    repairTitle: "Reparar JSON: corrija comillas y caracteres de escape, elimine comentarios y notaci\xf3n JSONP, convierta objetos JavaScript en JSON.",
                    searchTitle: "Campos de b\xfasqueda y valores",
                    searchNextResultTitle: "Siguiente resultado (Entrar)",
                    searchPreviousResultTitle: "Resultado anterior (Shift + Enter)",
                    selectNode: "Seleccione un nodo...",
                    showAll: "mostrar todo",
                    showMore: "mostrar m\xe1s",
                    showMoreStatus: "mostrando ${visibleChilds} de ${totalChilds} elementos.",
                    sort: "Ordenar",
                    sortTitle: "Ordene los hijos de este ${type}",
                    sortTitleShort: "Ordenar contenidos",
                    sortFieldLabel: "Campo:",
                    sortDirectionLabel: "Direcci\xf3n:",
                    sortFieldTitle: "Seleccione el campo anidado por el cual ordenar la matriz u objeto",
                    sortAscending: "Ascendente",
                    sortAscendingTitle: "Ordenar el campo seleccionado en orden ascendente",
                    sortDescending: "Descendente",
                    sortDescendingTitle: "Ordenar por el campo seleccionado, en orden descendente",
                    string: "Texto",
                    transform: "Transformar",
                    transformTitle: "Filtrar, ordenar o transformar los hijos de este ${type}",
                    transformTitleShort: "Filtrar, ordenar o transformar contenidos",
                    extract: "Extraer",
                    extractTitle: "Extrae este ${type}",
                    transformQueryTitle: "Ingrese una consulta JMESPath",
                    transformWizardLabel: "Wizard",
                    transformWizardFilter: "Filtro",
                    transformWizardSortBy: "Ordenar por",
                    transformWizardSelectFields: "Seleccione un campo",
                    transformQueryLabel: "Consulta",
                    transformPreviewLabel: "Vista Previa",
                    type: "Tipo",
                    typeTitle: "Cambiar el tipo de campo",
                    openUrl: "Ctrl+Click o Ctrl+Enter para abrir la URL en una nueva ventana",
                    undo: "Deshacer la \xfaltima acci\xf3n (Ctrl+Z)",
                    validationCannotMove: "No se puede mover un campo a un hijo de s\xed mismo.",
                    autoType: 'Tipo de campo "auto". El tipo de campo se determina autom\xe1ticamente a partir del valor y puede ser una cadena, un n\xfamero, un booleano o un valor nulo.',
                    objectType: 'Tipo de campo "objeto".  Un objeto contiene un conjunto desordenado de pares clave/valor.',
                    arrayType: 'Tipo de campo "matriz".  Una matriz contiene una colecci\xf3n ordenada de valores.',
                    stringType: 'Tipo de campo "cadena".  El tipo de campo no se determina a partir del valor,  pero siempre se devuelve como una cadena.',
                    modeEditorTitle: "Cambiar modo de editor",
                    modeCodeText: "C\xf3digo",
                    modeCodeTitle: "Cambiar al resaltador de c\xf3digo",
                    modeFormText: "Formulario",
                    modeFormTitle: "Cambiar al editor de formularios",
                    modeTextText: "Texto",
                    modeTextTitle: "Cambiar al editor de texto sin formato",
                    modeTreeText: "\xc1rbol",
                    modeTreeTitle: "Cambiar al editor de \xe1rbol",
                    modeViewText: "Vista",
                    modeViewTitle: "Cambiar a la vista de \xe1rbol",
                    modePreviewText: "Vista Previa",
                    modePreviewTitle: "Cambiar al modo de vista previa",
                    examples: "Ejemplos",
                    default: "Predeterminado",
                    containsInvalidProperties: "Contiene propiedades no v\xe1lidas",
                    containsInvalidItems: "Contiene \xedtems no v\xe1lidos"
                },
                "zh-CN": {
                    array: "\u6570\u7EC4",
                    auto: "\u81EA\u52A8",
                    appendText: "\u8FFD\u52A0",
                    appendTitle: "\u5728\u6B64\u5B57\u6BB5\u540E\u8FFD\u52A0\u4E00\u4E2A\u7C7B\u578B\u4E3A\u201Cauto\u201D\u7684\u65B0\u5B57\u6BB5 (Ctrl+Shift+Ins)",
                    appendSubmenuTitle: "\u9009\u62E9\u8981\u8FFD\u52A0\u7684\u5B57\u6BB5\u7C7B\u578B",
                    appendTitleAuto: "\u8FFD\u52A0\u7C7B\u578B\u4E3A\u201Cauto\u201D\u7684\u65B0\u5B57\u6BB5 (Ctrl+Shift+Ins)",
                    ascending: "\u5347\u5E8F",
                    ascendingTitle: "\u5347\u5E8F\u6392\u5217${type}\u7684\u5B50\u8282\u70B9",
                    actionsMenu: "\u70B9\u51FB\u6253\u5F00\u52A8\u4F5C\u83DC\u5355(Ctrl+M)",
                    cannotParseFieldError: "\u65E0\u6CD5\u5C06\u5B57\u6BB5\u89E3\u6790\u4E3AJSON",
                    cannotParseValueError: "\u65E0\u6CD5\u5C06\u503C\u89E3\u6790\u4E3AJSON",
                    collapseAll: "\u7F29\u8FDB\u6240\u6709\u5B57\u6BB5",
                    compactTitle: "\u538B\u7F29JSON\u6570\u636E\uFF0C\u5220\u9664\u6240\u6709\u7A7A\u683C (Ctrl+Shift+I)",
                    descending: "\u964D\u5E8F",
                    descendingTitle: "\u964D\u5E8F\u6392\u5217${type}\u7684\u5B50\u8282\u70B9",
                    drag: "\u62D6\u62FD\u79FB\u52A8\u8BE5\u8282\u70B9(Alt+Shift+Arrows)",
                    duplicateKey: "\u91CD\u590D\u952E",
                    duplicateText: "\u590D\u5236",
                    duplicateTitle: "\u590D\u5236\u9009\u4E2D\u5B57\u6BB5(Ctrl+D)",
                    duplicateField: "\u590D\u5236\u8BE5\u5B57\u6BB5(Ctrl+D)",
                    duplicateFieldError: "\u91CD\u590D\u7684\u5B57\u6BB5\u540D\u79F0",
                    empty: "\u6E05\u7A7A",
                    expandAll: "\u5C55\u5F00\u6240\u6709\u5B57\u6BB5",
                    expandTitle: "\u70B9\u51FB \u5C55\u5F00/\u6536\u7F29 \u8BE5\u5B57\u6BB5(Ctrl+E). \nCtrl+Click \u5C55\u5F00/\u6536\u7F29 \u5305\u542B\u6240\u6709\u5B50\u8282\u70B9.",
                    formatTitle: "\u4F7F\u7528\u9002\u5F53\u7684\u7F29\u8FDB\u548C\u6362\u884C\u7B26\u683C\u5F0F\u5316JSON\u6570\u636E (Ctrl+I)",
                    insert: "\u63D2\u5165",
                    insertTitle: "\u5728\u6B64\u5B57\u6BB5\u524D\u63D2\u5165\u7C7B\u578B\u4E3A\u201Cauto\u201D\u7684\u65B0\u5B57\u6BB5 (Ctrl+Ins)",
                    insertSub: "\u9009\u62E9\u8981\u63D2\u5165\u7684\u5B57\u6BB5\u7C7B\u578B",
                    object: "\u5BF9\u8C61",
                    ok: "Ok",
                    redo: "\u91CD\u505A (Ctrl+Shift+Z)",
                    removeText: "\u79FB\u9664",
                    removeTitle: "\u79FB\u9664\u9009\u4E2D\u5B57\u6BB5 (Ctrl+Del)",
                    removeField: "\u79FB\u9664\u8BE5\u5B57\u6BB5 (Ctrl+Del)",
                    repairTitle: "\u4FEE\u590DJSON\uFF1A\u4FEE\u590D\u5F15\u53F7\u548C\u8F6C\u4E49\u7B26\uFF0C\u5220\u9664\u6CE8\u91CA\u548CJSONP\u8868\u793A\u6CD5\uFF0C\u5C06JavaScript\u5BF9\u8C61\u8F6C\u6362\u4E3AJSON\u3002",
                    selectNode: "\u9009\u62E9\u4E00\u4E2A\u8282\u70B9...",
                    showAll: "\u5C55\u793A\u5168\u90E8",
                    showMore: "\u5C55\u793A\u66F4\u591A",
                    showMoreStatus: "\u663E\u793A${totalChilds}\u7684${visibleChilds}\u9879\u76EE.",
                    sort: "\u6392\u5E8F",
                    sortTitle: "\u6392\u5E8F${type}\u7684\u5B50\u8282\u70B9",
                    sortTitleShort: "\u5185\u5BB9\u6392\u5E8F",
                    sortFieldLabel: "\u5B57\u6BB5\uFF1A",
                    sortDirectionLabel: "\u65B9\u5411\uFF1A",
                    sortFieldTitle: "\u9009\u62E9\u7528\u4E8E\u5BF9\u6570\u7EC4\u6216\u5BF9\u8C61\u6392\u5E8F\u7684\u5D4C\u5957\u5B57\u6BB5",
                    sortAscending: "\u5347\u5E8F\u6392\u5E8F",
                    sortAscendingTitle: "\u6309\u7167\u8BE5\u5B57\u6BB5\u5347\u5E8F\u6392\u5E8F",
                    sortDescending: "\u964D\u5E8F\u6392\u5E8F",
                    sortDescendingTitle: "\u6309\u7167\u8BE5\u5B57\u6BB5\u964D\u5E8F\u6392\u5E8F",
                    string: "\u5B57\u7B26\u4E32",
                    transform: "\u53D8\u6362",
                    transformTitle: "\u7B5B\u9009\uFF0C\u6392\u5E8F\uFF0C\u6216\u8005\u8F6C\u6362${type}\u7684\u5B50\u8282\u70B9",
                    transformTitleShort: "\u7B5B\u9009\uFF0C\u6392\u5E8F\uFF0C\u6216\u8005\u8F6C\u6362\u5185\u5BB9",
                    extract: "\u63D0\u53D6",
                    extractTitle: "\u63D0\u53D6\u8FD9\u4E2A ${type}",
                    transformQueryTitle: "\u8F93\u5165JMESPath\u67E5\u8BE2",
                    transformWizardLabel: "\u5411\u5BFC",
                    transformWizardFilter: "\u7B5B\u9009",
                    transformWizardSortBy: "\u6392\u5E8F",
                    transformWizardSelectFields: "\u9009\u62E9\u5B57\u6BB5",
                    transformQueryLabel: "\u67E5\u8BE2",
                    transformPreviewLabel: "\u9884\u89C8",
                    type: "\u7C7B\u578B",
                    typeTitle: "\u66F4\u6539\u5B57\u6BB5\u7C7B\u578B",
                    openUrl: "Ctrl+Click \u6216\u8005 Ctrl+Enter \u5728\u65B0\u7A97\u53E3\u6253\u5F00\u94FE\u63A5",
                    undo: "\u64A4\u9500\u4E0A\u6B21\u52A8\u4F5C (Ctrl+Z)",
                    validationCannotMove: "\u65E0\u6CD5\u5C06\u5B57\u6BB5\u79FB\u5165\u5176\u5B50\u8282\u70B9",
                    autoType: '\u5B57\u6BB5\u7C7B\u578B "auto". \u5B57\u6BB5\u7C7B\u578B\u7531\u503C\u81EA\u52A8\u786E\u5B9A \u53EF\u4EE5\u4E3A string\uFF0Cnumber\uFF0Cboolean\uFF0C\u6216\u8005 null.',
                    objectType: '\u5B57\u6BB5\u7C7B\u578B "object". \u5BF9\u8C61\u5305\u542B\u4E00\u7EC4\u65E0\u5E8F\u7684\u952E/\u503C\u5BF9.',
                    arrayType: '\u5B57\u6BB5\u7C7B\u578B "array". \u6570\u7EC4\u5305\u542B\u503C\u7684\u6709\u5E8F\u96C6\u5408.',
                    stringType: '\u5B57\u6BB5\u7C7B\u578B "string". \u5B57\u6BB5\u7C7B\u578B\u7531\u503C\u81EA\u52A8\u786E\u5B9A\uFF0C\u4F46\u59CB\u7EC8\u4F5C\u4E3A\u5B57\u7B26\u4E32\u8FD4\u56DE.',
                    modeCodeText: "\u4EE3\u7801",
                    modeCodeTitle: "\u5207\u6362\u81F3\u4EE3\u7801\u9AD8\u4EAE",
                    modeFormText: "\u8868\u5355",
                    modeFormTitle: "\u5207\u6362\u81F3\u8868\u5355\u7F16\u8F91",
                    modeTextText: "\u6587\u672C",
                    modeTextTitle: "\u5207\u6362\u81F3\u6587\u672C\u7F16\u8F91",
                    modeTreeText: "\u6811",
                    modeTreeTitle: "\u5207\u6362\u81F3\u6811\u7F16\u8F91",
                    modeViewText: "\u89C6\u56FE",
                    modeViewTitle: "\u5207\u6362\u81F3\u6811\u89C6\u56FE",
                    modePreviewText: "\u9884\u89C8",
                    modePreviewTitle: "\u5207\u6362\u81F3\u9884\u89C8\u6A21\u5F0F",
                    examples: "\u4F8B\u5B50",
                    default: "\u7F3A\u7701",
                    containsInvalidProperties: "\u5305\u542B\u65E0\u6548\u7684\u5C5E\u6027",
                    containsInvalidItems: "\u5305\u542B\u65E0\u6548\u9879\u76EE"
                },
                "pt-BR": {
                    array: "Lista",
                    auto: "Automatico",
                    appendText: "Adicionar",
                    appendTitle: "Adicionar novo campo com tipo 'auto' depois deste campo (Ctrl+Shift+Ins)",
                    appendSubmenuTitle: "Selecione o tipo do campo a ser adicionado",
                    appendTitleAuto: "Adicionar novo campo com tipo 'auto' (Ctrl+Shift+Ins)",
                    ascending: "Ascendente",
                    ascendingTitle: "Organizar filhor do tipo ${type} em crescente",
                    actionsMenu: "Clique para abrir o menu de a\xe7\xf5es (Ctrl+M)",
                    cannotParseFieldError: "N\xe3o \xe9 poss\xedvel analisar o campo no JSON",
                    cannotParseValueError: "N\xe3o \xe9 poss\xedvel analisar o valor em JSON",
                    collapseAll: "Fechar todos campos",
                    compactTitle: "Dados JSON compactos, remova todos os espa\xe7os em branco (Ctrl+Shift+I)",
                    descending: "Descendente",
                    descendingTitle: "Organizar o filhos do tipo ${type} em decrescente",
                    duplicateKey: "chave duplicada",
                    drag: "Arraste para mover este campo (Alt+Shift+Arrows)",
                    duplicateText: "Duplicar",
                    duplicateTitle: "Duplicar campos selecionados (Ctrl+D)",
                    duplicateField: "Duplicar este campo (Ctrl+D)",
                    duplicateFieldError: "Nome do campo duplicado",
                    empty: "vazio",
                    expandAll: "Expandir todos campos",
                    expandTitle: "Clique para expandir/encolher este campo (Ctrl+E). \nCtrl+Click para expandir/encolher incluindo todos os filhos.",
                    formatTitle: "Formate dados JSON, com recuo e feeds de linha adequados (Ctrl+I)",
                    insert: "Inserir",
                    insertTitle: "Inserir um novo campo do tipo 'auto' antes deste campo (Ctrl+Ins)",
                    insertSub: "Selecionar o tipo de campo a ser inserido",
                    object: "Objeto",
                    ok: "Ok",
                    redo: "Refazer (Ctrl+Shift+Z)",
                    removeText: "Remover",
                    removeTitle: "Remover campos selecionados (Ctrl+Del)",
                    removeField: "Remover este campo (Ctrl+Del)",
                    repairTitle: "Repare JSON: corrija aspas e caracteres de escape, remova coment\xe1rios e nota\xe7\xe3o JSONP, transforme objetos JavaScript em JSON.",
                    selectNode: "Selecione um n\xf3dulo...",
                    showAll: "mostrar todos",
                    showMore: "mostrar mais",
                    showMoreStatus: "exibindo ${visibleChilds} de ${totalChilds} itens.",
                    sort: "Organizar",
                    sortTitle: "Organizar os filhos deste ${type}",
                    sortTitleShort: "Organizar os filhos",
                    sortFieldLabel: "Campo:",
                    sortDirectionLabel: "Dire\xe7\xe3o:",
                    sortFieldTitle: "Selecione um campo filho pelo qual ordenar o array ou objeto",
                    sortAscending: "Ascendente",
                    sortAscendingTitle: "Ordenar o campo selecionado por ordem ascendente",
                    sortDescending: "Descendente",
                    sortDescendingTitle: "Ordenar o campo selecionado por ordem descendente",
                    string: "Texto",
                    transform: "Transformar",
                    transformTitle: "Filtrar, ordenar ou transformar os filhos deste ${type}",
                    transformTitleShort: "Filtrar, ordenar ou transformar conte\xfados",
                    transformQueryTitle: "Insira uma express\xe3o JMESPath",
                    transformWizardLabel: "Assistente",
                    transformWizardFilter: "Filtro",
                    transformWizardSortBy: "Ordenar por",
                    transformWizardSelectFields: "Selecionar campos",
                    transformQueryLabel: "Express\xe3o",
                    transformPreviewLabel: "Visualizar",
                    type: "Tipo",
                    typeTitle: "Mudar o tipo deste campo",
                    openUrl: "Ctrl+Click ou Ctrl+Enter para abrir link em nova janela",
                    undo: "Desfazer \xfaltimo a\xe7\xe3o (Ctrl+Z)",
                    validationCannotMove: "N\xe3o pode mover um campo como filho dele mesmo",
                    autoType: 'Campo do tipo "auto". O tipo do campo \xe9 determinao automaticamente a partir do seu valor e pode ser texto, n\xfamero, verdade/falso ou nulo.',
                    objectType: 'Campo do tipo "objeto". Um objeto cont\xe9m uma lista de pares com chave e valor.',
                    arrayType: 'Campo do tipo "lista". Uma lista contem uma cole\xe7\xe3o de valores ordenados.',
                    stringType: 'Campo do tipo "string". Campo do tipo nao \xe9 determinado atrav\xe9s do seu valor, mas sempre retornara um texto.',
                    examples: "Exemplos",
                    default: "Revelia",
                    containsInvalidProperties: "Cont\xe9m propriedades inv\xe1lidas",
                    containsInvalidItems: "Cont\xe9m itens inv\xe1lidos"
                },
                tr: {
                    array: "Dizin",
                    auto: "Otomatik",
                    appendText: "Ekle",
                    appendTitle: "Bu alan\u0131n alt\u0131na 'otomatik' tipinde yeni bir alan ekle (Ctrl+Shift+Ins)",
                    appendSubmenuTitle: "Eklenecek alan\u0131n tipini se\xe7",
                    appendTitleAuto: "'Otomatik' tipinde yeni bir alan ekle (Ctrl+Shift+Ins)",
                    ascending: "Artan",
                    ascendingTitle: "${type}'\u0131n alt tiplerini artan d\xfczende s\u0131rala",
                    actionsMenu: "Aksiyon men\xfcs\xfcn\xfc a\xe7mak i\xe7in t\u0131klay\u0131n (Ctrl+M)",
                    collapseAll: "T\xfcm alanlar\u0131 kapat",
                    descending: "Azalan",
                    descendingTitle: "${type}'\u0131n alt tiplerini azalan d\xfczende s\u0131rala",
                    drag: "Bu alan\u0131 ta\u015F\u0131mak i\xe7in s\xfcr\xfckleyin (Alt+Shift+Arrows)",
                    duplicateKey: "Var olan anahtar",
                    duplicateText: "A\u015Fa\u011F\u0131ya kopyala",
                    duplicateTitle: "Se\xe7ili alanlardan bir daha olu\u015Ftur (Ctrl+D)",
                    duplicateField: "Bu alandan bir daha olu\u015Ftur (Ctrl+D)",
                    duplicateFieldError: "Duplicate field name",
                    cannotParseFieldError: "Alan JSON'a ayr\u0131\u015Ft\u0131r\u0131lam\u0131yor",
                    cannotParseValueError: "JSON'a de\u011Fer ayr\u0131\u015Ft\u0131r\u0131lam\u0131yor",
                    empty: "bo\u015F",
                    expandAll: "T\xfcm alanlar\u0131 a\xe7",
                    expandTitle: "Bu alan\u0131 a\xe7mak/kapatmak i\xe7in t\u0131kla (Ctrl+E). \nAlt alanlarda dahil t\xfcm alanlar\u0131 a\xe7mak i\xe7in Ctrl+Click ",
                    insert: "Ekle",
                    insertTitle: "Bu alan\u0131n \xfcst\xfcne 'otomatik' tipinde yeni bir alan ekle (Ctrl+Ins)",
                    insertSub: "Araya eklenecek alan\u0131n tipini se\xe7",
                    object: "Nesne",
                    ok: "Tamam",
                    redo: "Yeniden yap (Ctrl+Shift+Z)",
                    removeText: "Kald\u0131r",
                    removeTitle: "Se\xe7ilen alanlar\u0131 kald\u0131r (Ctrl+Del)",
                    removeField: "Bu alan\u0131 kald\u0131r (Ctrl+Del)",
                    selectNode: "Bir nesne se\xe7...",
                    showAll: "t\xfcm\xfcn\xfc g\xf6ster",
                    showMore: "daha fazla g\xf6ster",
                    showMoreStatus: "${totalChilds} alan\u0131n ${visibleChilds} alt alanlar\u0131 g\xf6steriliyor",
                    sort: "S\u0131rala",
                    sortTitle: "${type}'\u0131n alt alanlar\u0131n\u0131 s\u0131rala",
                    sortTitleShort: "\u0130\xe7erikleri s\u0131rala",
                    sortFieldLabel: "Alan:",
                    sortDirectionLabel: "Y\xf6n:",
                    sortFieldTitle: "Diziyi veya nesneyi s\u0131ralamak i\xe7in i\xe7 i\xe7e ge\xe7mi\u015F alan\u0131 se\xe7in",
                    sortAscending: "Artan",
                    sortAscendingTitle: "Se\xe7ili alan\u0131 artan d\xfczende s\u0131rala",
                    sortDescending: "Azalan",
                    sortDescendingTitle: "Se\xe7ili alan\u0131 azalan d\xfczende s\u0131rala",
                    string: "Karakter Dizisi",
                    transform: "D\xf6n\xfc\u015Ft\xfcr",
                    transformTitle: "${type}'\u0131n alt alanlar\u0131n\u0131 filtrele, s\u0131rala veya d\xf6n\xfc\u015Ft\xfcr",
                    transformTitleShort: "\u0130\xe7erikleri filterele, s\u0131rala veya d\xf6n\xfc\u015Ft\xfcr",
                    transformQueryTitle: "JMESPath sorgusu gir",
                    transformWizardLabel: "Sihirbaz",
                    transformWizardFilter: "Filtre",
                    transformWizardSortBy: "S\u0131rala",
                    transformWizardSelectFields: "Alanlar\u0131 se\xe7",
                    transformQueryLabel: "Sorgu",
                    transformPreviewLabel: "\xd6nizleme",
                    type: "Tip",
                    typeTitle: "Bu alan\u0131n tipini de\u011Fi\u015Ftir",
                    openUrl: "URL'i yeni bir pencerede a\xe7mak i\xe7in Ctrl+Click veya Ctrl+Enter",
                    undo: "Son de\u011Fi\u015Fikli\u011Fi geri al (Ctrl+Z)",
                    validationCannotMove: "Alt alan olarak ta\u015F\u0131nam\u0131yor",
                    autoType: 'Alan tipi "otomatik". Alan t\xfcr\xfc otomatik olarak de\u011Ferden belirlenirve bir dize, say\u0131, boolean veya null olabilir.',
                    objectType: 'Alan tipi "nesne". Bir nesne, s\u0131ralanmam\u0131\u015F bir anahtar / de\u011Fer \xe7ifti k\xfcmesi i\xe7erir.',
                    arrayType: 'Alan tipi "dizi". Bir dizi, d\xfczenli de\u011Ferler koleksiyonu i\xe7erir.',
                    stringType: 'Alan tipi "karakter dizisi". Alan t\xfcr\xfc de\u011Ferden belirlenmez,ancak her zaman karakter dizisi olarak d\xf6nd\xfcr\xfcl\xfcr.',
                    modeCodeText: "Kod",
                    modeCodeTitle: "Kod vurgulay\u0131c\u0131ya ge\xe7",
                    modeFormText: "Form",
                    modeFormTitle: "Form d\xfczenleyiciye ge\xe7",
                    modeTextText: "Metin",
                    modeTextTitle: "D\xfcz metin d\xfczenleyiciye ge\xe7",
                    modeTreeText: "A\u011Fa\xe7",
                    modeTreeTitle: "A\u011Fa\xe7 d\xfczenleyiciye ge\xe7",
                    modeViewText: "G\xf6r\xfcn\xfcm",
                    modeViewTitle: "A\u011Fa\xe7 g\xf6r\xfcn\xfcm\xfcne ge\xe7",
                    examples: "\xd6rnekler",
                    default: "Varsay\u0131lan",
                    containsInvalidProperties: "Ge\xe7ersiz \xf6zellikler i\xe7eriyor",
                    containsInvalidItems: "Ge\xe7ersiz \xf6\u011Feler i\xe7eriyor"
                },
                ja: {
                    array: "\u914D\u5217",
                    auto: "\u30AA\u30FC\u30C8",
                    appendText: "\u8FFD\u52A0",
                    appendTitle: '\u6B21\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u306B"\u30AA\u30FC\u30C8"\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u8FFD\u52A0 (Ctrl+Shift+Ins)',
                    appendSubmenuTitle: "\u8FFD\u52A0\u3059\u308B\u30D5\u30A3\u30FC\u30EB\u30C9\u306E\u578B\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
                    appendTitleAuto: '"\u30AA\u30FC\u30C8"\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u8FFD\u52A0 (Ctrl+Shift+Ins)',
                    ascending: "\u6607\u9806",
                    ascendingTitle: "${type}\u306E\u5B50\u8981\u7D20\u3092\u6607\u9806\u306B\u4E26\u3079\u66FF\u3048",
                    actionsMenu: "\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u30A2\u30AF\u30B7\u30E7\u30F3\u30E1\u30CB\u30E5\u30FC\u3092\u958B\u304F (Ctrl+M)",
                    collapseAll: "\u3059\u3079\u3066\u3092\u6298\u308A\u305F\u305F\u3080",
                    descending: "\u964D\u9806",
                    descendingTitle: "${type}\u306E\u5B50\u8981\u7D20\u3092\u964D\u9806\u306B\u4E26\u3079\u66FF\u3048",
                    drag: "\u30C9\u30E9\u30C3\u30B0\u3057\u3066\u9078\u629E\u4E2D\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u79FB\u52D5 (Alt+Shift+Arrows)",
                    duplicateKey: "\u8907\u88FD\u30AD\u30FC",
                    duplicateText: "\u8907\u88FD",
                    duplicateTitle: "\u9078\u629E\u4E2D\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u8907\u88FD (Ctrl+D)",
                    duplicateField: "\u9078\u629E\u4E2D\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u8907\u88FD (Ctrl+D)",
                    duplicateFieldError: "\u30D5\u30A3\u30FC\u30EB\u30C9\u540D\u304C\u91CD\u8907\u3057\u3066\u3044\u307E\u3059",
                    cannotParseFieldError: "JSON\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u89E3\u6790\u3067\u304D\u307E\u305B\u3093",
                    cannotParseValueError: "JSON\u306E\u5024\u3092\u89E3\u6790\u3067\u304D\u307E\u305B\u3093",
                    empty: "\u7A7A",
                    expandAll: "\u3059\u3079\u3066\u3092\u5C55\u958B",
                    expandTitle: "\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u5C55\u958B/\u6298\u308A\u305F\u305F\u3080 (Ctrl+E). \nCtrl+Click \u3067\u3059\u3079\u3066\u306E\u5B50\u8981\u7D20\u3092\u5C55\u958B/\u6298\u308A\u305F\u305F\u3080",
                    insert: "\u633F\u5165",
                    insertTitle: "\u9078\u629E\u4E2D\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u306E\u524D\u306B\u65B0\u3057\u3044\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u633F\u5165 (Ctrl+Ins)",
                    insertSub: "\u633F\u5165\u3059\u308B\u30D5\u30A3\u30FC\u30EB\u30C9\u306E\u578B\u3092\u9078\u629E",
                    object: "\u30AA\u30D6\u30B8\u30A7\u30AF\u30C8",
                    ok: "\u5B9F\u884C",
                    redo: "\u3084\u308A\u76F4\u3059 (Ctrl+Shift+Z)",
                    removeText: "\u524A\u9664",
                    removeTitle: "\u9078\u629E\u4E2D\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u524A\u9664 (Ctrl+Del)",
                    removeField: "\u9078\u629E\u4E2D\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u524A\u9664 (Ctrl+Del)",
                    selectNode: "\u30CE\u30FC\u30C9\u3092\u9078\u629E...",
                    showAll: "\u3059\u3079\u3066\u3092\u8868\u793A",
                    showMore: "\u3082\u3063\u3068\u898B\u308B",
                    showMoreStatus: "${totalChilds}\u500B\u306E\u30A2\u30A4\u30C6\u30E0\u306E\u3046\u3061 ${visibleChilds}\u500B\u3092\u8868\u793A\u3057\u3066\u3044\u307E\u3059\u3002",
                    sort: "\u4E26\u3079\u66FF\u3048",
                    sortTitle: "${type}\u306E\u5B50\u8981\u7D20\u3092\u4E26\u3079\u66FF\u3048",
                    sortTitleShort: "\u4E26\u3079\u66FF\u3048",
                    sortFieldLabel: "\u30D5\u30A3\u30FC\u30EB\u30C9:",
                    sortDirectionLabel: "\u9806\u5E8F:",
                    sortFieldTitle: "\u914D\u5217\u307E\u305F\u306F\u30AA\u30D6\u30B8\u30A7\u30AF\u30C8\u3092\u4E26\u3073\u66FF\u3048\u308B\u305F\u3081\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u9078\u629E",
                    sortAscending: "\u6607\u9806",
                    sortAscendingTitle: "\u9078\u629E\u4E2D\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u6607\u9806\u306B\u4E26\u3073\u66FF\u3048",
                    sortDescending: "\u964D\u9806",
                    sortDescendingTitle: "\u9078\u629E\u4E2D\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u964D\u9806\u306B\u4E26\u3073\u66FF\u3048",
                    string: "\u6587\u5B57\u5217",
                    transform: "\u5909\u63DB",
                    transformTitle: "${type}\u306E\u5B50\u8981\u7D20\u3092\u30D5\u30A3\u30EB\u30BF\u30FC\u30FB\u4E26\u3073\u66FF\u3048\u30FB\u5909\u63DB\u3059\u308B",
                    transformTitleShort: "\u5185\u5BB9\u3092\u30D5\u30A3\u30EB\u30BF\u30FC\u30FB\u4E26\u3073\u66FF\u3048\u30FB\u5909\u63DB\u3059\u308B",
                    extract: "\u62BD\u51FA",
                    extractTitle: "${type}\u3092\u62BD\u51FA",
                    transformQueryTitle: "JMESPath\u30AF\u30A8\u30EA\u3092\u5165\u529B",
                    transformWizardLabel: "\u30A6\u30A3\u30B6\u30FC\u30C9",
                    transformWizardFilter: "\u30D5\u30A3\u30EB\u30BF\u30FC",
                    transformWizardSortBy: "\u4E26\u3073\u66FF\u3048",
                    transformWizardSelectFields: "\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u9078\u629E",
                    transformQueryLabel: "\u30AF\u30A8\u30EA",
                    transformPreviewLabel: "\u30D7\u30EC\u30D3\u30E5\u30FC",
                    type: "\u578B",
                    typeTitle: "\u9078\u629E\u4E2D\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u306E\u578B\u3092\u5909\u66F4",
                    openUrl: "Ctrl+Click \u307E\u305F\u306F Ctrl+Enter \u3067 \u65B0\u898F\u30A6\u30A3\u30F3\u30C9\u30A6\u3067URL\u3092\u958B\u304F",
                    undo: "\u5143\u306B\u623B\u3059 (Ctrl+Z)",
                    validationCannotMove: "\u5B50\u8981\u7D20\u306B\u79FB\u52D5\u3067\u304D\u307E\u305B\u3093 ",
                    autoType: "\u30AA\u30FC\u30C8\uFF1A \u30D5\u30A3\u30FC\u30EB\u30C9\u306E\u578B\u306F\u5024\u304B\u3089\u81EA\u52D5\u7684\u306B\u6C7A\u5B9A\u3055\u308C\u307E\u3059\u3002 (\u6587\u5B57\u5217\u30FB\u6570\u5024\u30FB\u30D6\u30FC\u30EB\u30FBnull)",
                    objectType: "\u30AA\u30D6\u30B8\u30A7\u30AF\u30C8\uFF1A \u30AA\u30D6\u30B8\u30A7\u30AF\u30C8\u306F\u9806\u5E8F\u304C\u6C7A\u307E\u3063\u3066\u3044\u306A\u3044\u30AD\u30FC\u3068\u5024\u306E\u30DA\u30A2\u7D44\u307F\u5408\u308F\u305B\u3067\u3059\u3002",
                    arrayType: "\u914D\u5217\uFF1A \u914D\u5217\u306F\u9806\u5E8F\u304C\u6C7A\u307E\u3063\u3066\u3044\u308B\u5024\u306E\u96C6\u5408\u4F53\u3067\u3059\u3002",
                    stringType: "\u6587\u5B57\u5217\uFF1A \u30D5\u30A3\u30FC\u30EB\u30C9\u578B\u306F\u5024\u304B\u3089\u6C7A\u5B9A\u3055\u308C\u307E\u305B\u3093\u304C\u3001\u5E38\u306B\u6587\u5B57\u5217\u3068\u3057\u3066\u8FD4\u3055\u308C\u307E\u3059\u3002",
                    modeCodeText: "\u30B3\u30FC\u30C9\u30E2\u30FC\u30C9",
                    modeCodeTitle: "\u30CF\u30A4\u30E9\u30A4\u30C8\u30E2\u30FC\u30C9\u306B\u5207\u308A\u66FF\u3048",
                    modeFormText: "\u30D5\u30A9\u30FC\u30E0\u30E2\u30FC\u30C9",
                    modeFormTitle: "\u30D5\u30A9\u30FC\u30E0\u30E2\u30FC\u30C9\u306B\u5207\u308A\u66FF\u3048",
                    modeTextText: "\u30C6\u30AD\u30B9\u30C8\u30E2\u30FC\u30C9",
                    modeTextTitle: "\u30C6\u30AD\u30B9\u30C8\u30E2\u30FC\u30C9\u306B\u5207\u308A\u66FF\u3048",
                    modeTreeText: "\u30C4\u30EA\u30FC\u30E2\u30FC\u30C9",
                    modeTreeTitle: "\u30C4\u30EA\u30FC\u30E2\u30FC\u30C9\u306B\u5207\u308A\u66FF\u3048",
                    modeViewText: "\u30D3\u30E5\u30FC\u30E2\u30FC\u30C9",
                    modeViewTitle: "\u30D3\u30E5\u30FC\u30E2\u30FC\u30C9\u306B\u5207\u308A\u66FF\u3048",
                    modePreviewText: "\u30D7\u30EC\u30D3\u30E5\u30FC",
                    modePreviewTitle: "\u30D7\u30EC\u30D3\u30E5\u30FC\u306B\u5207\u308A\u66FF\u3048",
                    examples: "\u4F8B",
                    default: "\u30C7\u30D5\u30A9\u30EB\u30C8",
                    containsInvalidProperties: "\u7121\u52B9\u306A\u30D7\u30ED\u30D1\u30C6\u30A3\u304C\u542B\u307E\u308C\u3066\u3044\u307E\u3059",
                    containsInvalidItems: "\u7121\u52B9\u306A\u30A2\u30A4\u30C6\u30E0\u304C\u542B\u307E\u308C\u3066\u3044\u307E\u3059"
                },
                "fr-FR": {
                    array: "Liste",
                    auto: "Auto",
                    appendText: "Ajouter",
                    appendTitle: "Ajouter un champ de type 'auto' apr\xe8s ce champ (Ctrl+Shift+Ins)",
                    appendSubmenuTitle: "S\xe9lectionner le type du champ \xe0 ajouter",
                    appendTitleAuto: "Ajouter un champ de type 'auto' (Ctrl+Shift+Ins)",
                    ascending: "Ascendant",
                    ascendingTitle: "Trier les enfants de ce ${type} par ordre ascendant",
                    actionsMenu: "Ouvrir le menu des actions (Ctrl+M)",
                    collapseAll: "Regrouper",
                    descending: "Descendant",
                    descendingTitle: "Trier les enfants de ce ${type} par ordre descendant",
                    drag: "D\xe9placer (Alt+Shift+Arrows)",
                    duplicateKey: "Dupliquer la cl\xe9",
                    duplicateText: "Dupliquer",
                    duplicateTitle: "Dupliquer les champs s\xe9lectionn\xe9s (Ctrl+D)",
                    duplicateField: "Dupliquer ce champ (Ctrl+D)",
                    duplicateFieldError: "Dupliquer le nom de champ",
                    cannotParseFieldError: "Champ impossible \xe0 parser en JSON",
                    cannotParseValueError: "Valeur impossible \xe0 parser en JSON",
                    empty: "vide",
                    expandAll: "\xc9tendre",
                    expandTitle: "\xc9tendre/regrouper ce champ (Ctrl+E). \nCtrl+Click pour \xe9tendre/regrouper avec tous les champs.",
                    insert: "Ins\xe9rer",
                    insertTitle: "Ins\xe9rer un champ de type 'auto' avant ce champ (Ctrl+Ins)",
                    insertSub: "S\xe9lectionner le type de champ \xe0 ins\xe9rer",
                    object: "Objet",
                    ok: "Ok",
                    redo: "Rejouer (Ctrl+Shift+Z)",
                    removeText: "Supprimer",
                    removeTitle: "Supprimer les champs s\xe9lectionn\xe9s (Ctrl+Del)",
                    removeField: "Supprimer ce champ (Ctrl+Del)",
                    searchTitle: "Rechercher champs et valeurs",
                    searchNextResultTitle: "R\xe9sultat suivant (Enter)",
                    searchPreviousResultTitle: "R\xe9sultat pr\xe9c\xe9dent (Shift + Enter)",
                    selectNode: "S\xe9lectionner un n\u0153ud...",
                    showAll: "voir tout",
                    showMore: "voir plus",
                    showMoreStatus: "${visibleChilds} \xe9l\xe9ments affich\xe9s de ${totalChilds}.",
                    sort: "Trier",
                    sortTitle: "Trier les champs de ce ${type}",
                    sortTitleShort: "Trier",
                    sortFieldLabel: "Champ:",
                    sortDirectionLabel: "Direction:",
                    sortFieldTitle: "S\xe9lectionner les champs permettant de trier les listes et objet",
                    sortAscending: "Ascendant",
                    sortAscendingTitle: "Trier les champs s\xe9lectionn\xe9s par ordre ascendant",
                    sortDescending: "Descendant",
                    sortDescendingTitle: "Trier les champs s\xe9lectionn\xe9s par ordre descendant",
                    string: "Cha\xeene",
                    transform: "Transformer",
                    transformTitle: "Filtrer, trier, or transformer les enfants de ce ${type}",
                    transformTitleShort: "Filtrer, trier ou transformer le contenu",
                    extract: "Extraire",
                    extractTitle: "Extraire ce ${type}",
                    transformQueryTitle: "Saisir une requ\xeate JMESPath",
                    transformWizardLabel: "Assistant",
                    transformWizardFilter: "Filtrer",
                    transformWizardSortBy: "Trier par",
                    transformWizardSelectFields: "S\xe9lectionner les champs",
                    transformQueryLabel: "Requ\xeate",
                    transformPreviewLabel: "Pr\xe9visualisation",
                    type: "Type",
                    typeTitle: "Changer le type de ce champ",
                    openUrl: "Ctrl+Click ou Ctrl+Enter pour ouvrir l'url dans une autre fen\xeatre",
                    undo: "Annuler la derni\xe8re action (Ctrl+Z)",
                    validationCannotMove: "Cannot move a field into a child of itself",
                    autoType: 'Champe de type "auto". Ce type de champ est automatiquement d\xe9termin\xe9 en fonction de la valeur et peut \xeatre de type "cha\xeene", "nombre", "bool\xe9en" ou null.',
                    objectType: 'Champ de type "objet". Un objet contient un ensemble non ordonn\xe9 de paires cl\xe9/valeur.',
                    arrayType: 'Champ de type "liste". Une liste contient une collection ordonn\xe9e de valeurs.',
                    stringType: 'Champ de type "cha\xeene". Ce type de champ n\'est pas d\xe9termin\xe9 en fonction de la valeur, mais retourne syst\xe9matiquement une cha\xeene de caract\xe8res.',
                    modeEditorTitle: "Changer mode d'\xe9dition",
                    modeCodeText: "Code",
                    modeCodeTitle: "Activer surlignage code",
                    modeFormText: "Formulaire",
                    modeFormTitle: "Activer formulaire",
                    modeTextText: "Texte",
                    modeTextTitle: "Activer \xe9diteur texte",
                    modeTreeText: "Arbre",
                    modeTreeTitle: "Activer \xe9diteur arbre",
                    modeViewText: "Lecture seule",
                    modeViewTitle: "Activer vue arbre",
                    modePreviewText: "Pr\xe9visualisation",
                    modePreviewTitle: "Activer mode pr\xe9visualiser",
                    examples: "Exemples",
                    default: "D\xe9faut",
                    containsInvalidProperties: "Contient des propri\xe9t\xe9s non valides",
                    containsInvalidItems: "Contient des \xe9l\xe9ments invalides"
                },
                de: {
                    array: "Auflistung",
                    auto: "Auto",
                    appendText: "anh\xe4ngen",
                    appendTitle: "F\xfcgen Sie nach diesem Feld ein neues Feld mit dem Typ 'auto' ein (Strg+Umschalt+Ein)",
                    appendSubmenuTitle: "W\xe4hlen Sie den Typ des neuen Feldes",
                    appendTitleAuto: "Ein neues Feld vom Typ 'auto' hinzuf\xfcgen (Strg+Umschalt+Ein)",
                    ascending: "Aufsteigend",
                    ascendingTitle: "Sortieren Sie die Elemente dieses ${type} in aufsteigender Reihenfolge",
                    actionsMenu: "Klicken Sie zum \xd6ffnen des Aktionsmen\xfcs (Strg+M)",
                    cannotParseFieldError: "Feld kann nicht in JSON geparst werden",
                    cannotParseValueError: "Wert kann nicht in JSON geparst werden",
                    collapseAll: "Alle Felder zuklappen",
                    compactTitle: "JSON-Daten verdichten, alle Leerzeichen entfernen (Strg+Umschalt+\\)",
                    descending: "Absteigend",
                    descendingTitle: "Sortieren Sie die Elemente dieses ${type} in absteigender Reihenfolge",
                    drag: "Ziehen, um dieses Feld zu verschieben (Alt+Umschalt+Pfeile)",
                    duplicateKey: "Doppelter Schl\xfcssel",
                    duplicateText: "Duplikat",
                    duplicateTitle: "Ausgew\xe4hlte Felder duplizieren (Strg+D)",
                    duplicateField: "Dieses Feld duplizieren (Strg+D)",
                    duplicateFieldError: "Doppelter Feldname",
                    empty: "leer",
                    expandAll: "Alle Felder anzeigen",
                    expandTitle: "Klicken Sie, um dieses Feld zu erweitern/zu kollabieren (Strg+E). \nStrg+Klicken Sie, um dieses Feld einschlie\xdflich aller Elemente zu erweitern/zu kollabieren.",
                    formatTitle: "JSON-Daten mit korrekter Einr\xfcckung und Zeilenvorsch\xfcben formatieren (Strg+\\)",
                    insert: "einf\xfcgen",
                    insertTitle: "F\xfcgen Sie vor diesem Feld ein neues Feld mit dem Typ 'auto' ein (Strg+Einfg)",
                    insertSub: "W\xe4hlen Sie den Typ des neuen Feldes",
                    object: "Objekt",
                    ok: "Ok",
                    redo: "Wiederholen (Strg+Umschalt+Z)",
                    removeText: "entfernen",
                    removeTitle: "Ausgew\xe4hlte Felder entfernen (Strg+Entf)",
                    removeField: "Dieses Feld entfernen (Strg+Entf)",
                    repairTitle: "JSON reparieren: Anf\xfchrungszeichen und Escape-Zeichen korrigieren, Kommentare und JSONP-Notation entfernen, JavaScript-Objekte in JSON umwandeln.",
                    searchTitle: "Suchfelder und Werte",
                    searchNextResultTitle: "N\xe4chstes Ergebnis (Enter)",
                    searchPreviousResultTitle: "Vorheriges Ergebnis (Umschalt + Eingabe)",
                    selectNode: "W\xe4hlen Sie einen Knoten aus...",
                    showAll: "alle anzeigen",
                    showMore: "mehr anzeigen",
                    showMoreStatus: "Anzeige von ${visibleChilds} von ${totalChilds}-Elementen.",
                    sort: "Sortieren",
                    sortTitle: "Sortieren Sie die Elemente dieses ${type}",
                    sortTitleShort: "Inhalt sortieren",
                    sortFieldLabel: "Feld:",
                    sortDirectionLabel: "Richtung:",
                    sortFieldTitle: "W\xe4hlen Sie das verschachtelte Feld, nach dem das Array oder Objekt sortiert werden soll.",
                    sortAscending: "Aufsteigend",
                    sortAscendingTitle: "Sortieren Sie das ausgew\xe4hlte Feld in aufsteigender Reihenfolge",
                    sortDescending: "Absteigend",
                    sortDescendingTitle: "Sortieren Sie das ausgew\xe4hlte Feld in absteigender Reihenfolge",
                    string: "Zeichenfolge",
                    transform: "Verwandeln",
                    transformTitle: "Die Elemente dieses ${type} filtern, sortieren oder transformieren",
                    transformTitleShort: "Inhalte filtern, sortieren oder transformieren",
                    extract: "Auszug",
                    extractTitle: "Extrahieren Sie diesen ${type}",
                    transformQueryTitle: "Eine JMESPath-Abfrage eingeben",
                    transformWizardLabel: "Zauberer",
                    transformWizardFilter: "Filter",
                    transformWizardSortBy: "Sortieren nach",
                    transformWizardSelectFields: "Felder ausw\xe4hlen",
                    transformQueryLabel: "Anfrage",
                    transformPreviewLabel: "Vorschau",
                    type: "Geben Sie  ein.",
                    typeTitle: "\xc4ndern Sie den Typ dieses Feldes",
                    openUrl: "Strg+Klicken oder Strg+Eingabe, um die URL in einem neuen Fenster zu \xf6ffnen",
                    undo: "Letzte Aktion r\xfcckg\xe4ngig machen (Strg+Z)",
                    validationCannotMove: "Kann ein Feld nicht in ein Kind seiner selbst verschieben",
                    autoType: 'Feldtyp "auto". Der Feldtyp wird automatisch aus dem Wert bestimmt und kann ein String, eine Zahl, boolesch oder null sein.',
                    objectType: 'Feldtyp "Objekt". Ein Objekt enth\xe4lt eine ungeordnete Menge von Schl\xfcssel/Wert-Paaren.',
                    arrayType: 'Feldtyp "Array". Ein Array enth\xe4lt eine geordnete Sammlung von Werten.',
                    stringType: 'Feldtyp "Zeichenfolge". Der Feldtyp wird nicht aus dem Wert bestimmt, sondern immer als Zeichenfolge zur\xfcckgegeben.',
                    modeEditorTitle: "Editor-Modus umschalten",
                    modeCodeText: "Code",
                    modeCodeTitle: "Umschalten auf Code-Highlighter",
                    modeFormText: "Formular",
                    modeFormTitle: "Zum Formular-Editor wechseln",
                    modeTextText: "Text",
                    modeTextTitle: "Zum Editor f\xfcr einfachen Text wechseln",
                    modeTreeText: "Baum",
                    modeTreeTitle: "Zum Baum-Editor wechseln",
                    modeViewText: "Siehe",
                    modeViewTitle: "Zur Baumansicht wechseln",
                    modePreviewText: "Vorschau",
                    modePreviewTitle: "In den Vorschau-Modus wechseln",
                    examples: "Beispiele",
                    default: "Standardm\xe4\xdfig",
                    containsInvalidProperties: "Enth\xe4lt ung\xfcltige Eigenschaften",
                    containsInvalidItems: "Enth\xe4lt ung\xfcltige Elemente"
                },
                ru: {
                    array: "\u041C\u0430\u0441\u0441\u0438\u0432",
                    auto: "\u0410\u0432\u0442\u043E",
                    appendText: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C",
                    appendTitle: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043D\u043E\u0432\u043E\u0435 \u043F\u043E\u043B\u0435 \u0441 \u0442\u0438\u043F\u043E\u043C '\u0430\u0432\u0442\u043E' \u043F\u043E\u0441\u043B\u0435 \u044D\u0442\u043E\u0433\u043E \u043F\u043E\u043B\u044F (Ctrl+Shift+Ins)",
                    appendSubmenuTitle: "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0442\u0438\u043F \u043F\u043E\u043B\u044F \u0434\u043B\u044F \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0438\u044F",
                    appendTitleAuto: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043D\u043E\u0432\u043E\u0435 \u043F\u043E\u043B\u0435 \u0441 \u0442\u0438\u043F\u043E\u043C '\u0430\u0432\u0442\u043E' (Ctrl+Shift+Ins)",
                    ascending: "\u041F\u043E \u0432\u043E\u0437\u0440\u0430\u0441\u0442\u0430\u043D\u0438\u044E",
                    ascendingTitle: "\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C ${type} \u043F\u043E \u0432\u043E\u0437\u0440\u0430\u0441\u0442\u0430\u043D\u0438\u044E",
                    actionsMenu: "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u0434\u043B\u044F \u043E\u0442\u043A\u0440\u044B\u0442\u0438\u044F \u043C\u0435\u043D\u044E \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0439 (Ctrl+M)",
                    cannotParseFieldError: "\u041D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E \u043F\u0440\u0435\u043E\u0431\u0440\u0430\u0437\u043E\u0432\u0430\u0442\u044C \u043F\u043E\u043B\u0435 \u0432 JSON",
                    cannotParseValueError: "\u041D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E \u043F\u0440\u0435\u043E\u0431\u0440\u0430\u0437\u043E\u0432\u0430\u0442\u044C \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u0432 JSON",
                    collapseAll: "\u0421\u0432\u0435\u0440\u043D\u0443\u0442\u044C \u0432\u0441\u0435",
                    compactTitle: "\u041C\u0438\u043D\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F JSON (Ctrl+Shift+I)",
                    descending: "\u041F\u043E \u0443\u0431\u044B\u0432\u0430\u043D\u0438\u044E",
                    descendingTitle: "\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C ${type} \u043F\u043E \u0443\u0431\u044B\u0432\u0430\u043D\u0438\u044E",
                    drag: "\u041F\u043E\u0442\u044F\u043D\u0438\u0442\u0435 \u0434\u043B\u044F \u043F\u0435\u0440\u0435\u043C\u0435\u0449\u0435\u043D\u0438\u044F \u044D\u0442\u043E\u0433\u043E \u043F\u043E\u043B\u044F (Alt+Shift+Arrows)",
                    duplicateKey: "\u043F\u043E\u0432\u0442\u043E\u0440\u044F\u044E\u0449\u0438\u0439\u0441\u044F \u043A\u043B\u044E\u0447",
                    duplicateText: "\u0414\u0443\u0431\u043B\u0438\u0440\u043E\u0432\u0430\u0442\u044C",
                    duplicateTitle: "\u0414\u0443\u0431\u043B\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u043F\u043E\u043B\u0435\u0439 (Ctrl+D)",
                    duplicateField: "\u0414\u0443\u0431\u043B\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043F\u043E\u043B\u0435 (Ctrl+D)",
                    duplicateFieldError: "\u0414\u0443\u0431\u043B\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u044F \u043F\u043E\u043B\u044F",
                    empty: "\u043F\u0443\u0441\u0442\u043E\u0439",
                    expandAll: "\u0420\u0430\u0437\u0432\u0435\u0440\u043D\u0443\u0442\u044C \u0432\u0441\u0435",
                    expandTitle: "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u0434\u043B\u044F \u0440\u0430\u0441\u043A\u0440\u044B\u0442\u0438\u044F/\u0441\u043A\u0440\u044B\u0442\u0438\u044F \u043F\u043E\u043B\u044F (Ctrl+E)\n\u0438\u043B\u0438 Ctrl+Click \u0434\u043B\u044F \u0440\u0430\u0441\u043A\u0440\u044B\u0442\u0438\u044F/\u0441\u043A\u0440\u044B\u0442\u0438\u044F \u0432\u0441\u0435\u0445 \u043F\u043E\u0442\u043E\u043C\u043A\u043E\u0432.",
                    formatTitle: "\u0424\u043E\u0440\u043C\u0430\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 JSON (Ctrl+I)",
                    insert: "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C",
                    insertTitle: "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u043D\u043E\u0432\u043E\u0435 \u043F\u043E\u043B\u0435 \u0441 \u0442\u0438\u043F\u043E\u043C '\u0430\u0432\u0442\u043E' \u043F\u0435\u0440\u0435\u0434 \u044D\u0442\u0438\u043C \u043F\u043E\u043B\u0435\u043C (Ctrl+Ins)",
                    insertSub: "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0442\u0438\u043F \u043F\u043E\u043B\u044F \u0434\u043B\u044F \u0432\u0441\u0442\u0430\u0432\u043A\u0438",
                    object: "\u041E\u0431\u044A\u0435\u043A\u0442",
                    ok: "\u041E\u041A",
                    redo: "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C (Ctrl+Shift+Z)",
                    removeText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C",
                    removeTitle: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0435 \u043F\u043E\u043B\u044F (Ctrl+Del)",
                    removeField: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u043F\u043E\u043B\u0435 (Ctrl+Del)",
                    repairTitle: "\u0412\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u0435 JSON: \u0438\u0441\u043F\u0440\u0430\u0432\u044C\u0442\u0435 \u043A\u0430\u0432\u044B\u0447\u043A\u0438 \u0438 escape-\u0441\u0438\u043C\u0432\u043E\u043B\u044B, \u0443\u0434\u0430\u043B\u0438\u0442\u0435 \u043A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0438 \u0438 \u043D\u043E\u0442\u0430\u0446\u0438\u044E JSONP, \u043C\u043E\u0434\u0438\u0444\u0438\u0446\u0438\u0440\u0443\u0439\u0442\u0435 \u043E\u0431\u044A\u0435\u043A\u0442\u044B JavaScript \u0432 JSON.",
                    searchTitle: "\u041F\u043E\u0438\u0441\u043A",
                    searchNextResultTitle: "\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442 (Enter)",
                    searchPreviousResultTitle: "\u041F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0438\u0439 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442 (Shift + Enter)",
                    selectNode: "\u0412\u044B\u0431\u043E\u0440 \u0443\u0437\u043B\u0430...",
                    showAll: "\u043F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0432\u0441\u0435",
                    showMore: "\u0431\u043E\u043B\u044C\u0448\u0435",
                    showMoreStatus: "${visibleChilds} \u0438\u0437 ${totalChilds}",
                    sort: "\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0430",
                    sortTitle: "\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0430 \u043F\u043E\u0442\u043E\u043C\u043A\u043E\u0432 \u0442\u0438\u043F\u0430 ${type}",
                    sortTitleShort: "\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0430 \u0441\u043E\u0434\u0435\u0440\u0436\u0438\u043C\u043E\u0433\u043E",
                    sortFieldLabel: "\u041F\u043E\u043B\u0435:",
                    sortDirectionLabel: "\u041D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435:",
                    sortFieldTitle: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043F\u043E\u043B\u0435 \u0434\u043B\u044F \u0441\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0438 \u043C\u0430\u0441\u0441\u0438\u0432\u0430 \u0438\u043B\u0438 \u043E\u0431\u044A\u0435\u043A\u0442\u0430",
                    sortAscending: "\u041F\u043E \u0432\u043E\u0437\u0440\u0430\u0441\u0442\u0430\u043D\u0438\u044E",
                    sortAscendingTitle: "\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0430 \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u043E\u0433\u043E \u043F\u043E\u0440\u044F \u043F\u043E \u0432\u043E\u0437\u0440\u0430\u0441\u0442\u0430\u043D\u0438\u044E",
                    sortDescending: "\u041F\u043E \u0443\u0431\u044B\u0432\u0430\u043D\u0438\u044E",
                    sortDescendingTitle: "\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0430 \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u043E\u0433\u043E \u043F\u043E\u0440\u044F \u043F\u043E \u0443\u0431\u044B\u0432\u0430\u043D\u0438\u044E",
                    string: "\u0421\u0442\u0440\u043E\u043A\u0430",
                    transform: "\u041C\u043E\u0434\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F",
                    transformTitle: "\u0424\u0438\u043B\u044C\u0442\u0440\u0430\u0446\u0438\u044F, \u0441\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0430 \u0438\u043B\u0438 \u043C\u043E\u0434\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F \u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u0430 ${type}",
                    transformTitleShort: "\u0424\u0438\u043B\u044C\u0442\u0440\u0430\u0446\u0438\u044F, \u0441\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0430 \u0438\u043B\u0438 \u043C\u043E\u0434\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F \u0434\u0430\u043D\u043D\u044B\u0445",
                    extract: "\u0418\u0437\u0432\u043B\u0435\u0447\u0435\u043D\u0438\u0435",
                    extractTitle: "\u0418\u0437\u0432\u043B\u0435\u0447\u044C \u0442\u0438\u043F ${type}",
                    transformQueryTitle: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 JMESpath \u0437\u0430\u043F\u0440\u043E\u0441",
                    transformWizardLabel: "\u041C\u0430\u0441\u0442\u0435\u0440",
                    transformWizardFilter: "\u0424\u0438\u043B\u044C\u0442\u0440",
                    transformWizardSortBy: "\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0430",
                    transformWizardSelectFields: "\u041F\u043E\u043B\u044F",
                    transformQueryLabel: "\u0417\u0430\u043F\u0440\u043E\u0441",
                    transformPreviewLabel: "\u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440",
                    type: "\u0422\u0438\u043F",
                    typeTitle: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u0442\u0438\u043F \u044D\u0442\u043E\u0433\u043E \u043F\u043E\u043B\u044F",
                    openUrl: "Ctrl+Click \u0438\u043B\u0438 Ctrl+Enter \u0434\u043B\u044F \u043E\u0442\u043A\u0440\u044B\u0442\u0438\u044F url \u0432 \u043D\u043E\u0432\u043E\u043C \u043E\u043A\u043D\u0435",
                    undo: "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C (Ctrl+Z)",
                    validationCannotMove: "\u041F\u043E\u043B\u0435 \u043D\u0435 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u043F\u0435\u0440\u0435\u043C\u0435\u0449\u0435\u043D\u043E \u0432 \u043F\u043E\u0442\u043E\u043C\u043A\u0430",
                    autoType: "\u0422\u0438\u043F \u043F\u043E\u043B\u044F \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u044F\u0435\u0442\u0441\u044F \u043F\u043E \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044E \u0438 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u0441\u0442\u0440\u043E\u043A\u043E\u0439, \u0447\u0438\u0441\u043B\u043E\u043C, \u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u0438\u043C \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435\u043C \u0438\u043B\u0438 null.",
                    objectType: "\u041E\u0431\u044A\u0435\u043A\u0442 \u0441\u043E\u0434\u0435\u0440\u0436\u0438\u0442 \u043D\u0435\u0443\u043F\u043E\u0440\u044F\u0434\u043E\u0447\u0435\u043D\u043D\u044B\u0439 \u043D\u0430\u0431\u043E\u0440 \u043F\u0430\u0440 \u043A\u043B\u044E\u0447/\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435.",
                    arrayType: "\u041C\u0430\u0441\u0441\u0438\u0432 \u0441\u043E\u0434\u0435\u0440\u0436\u0438\u0442 \u0443\u043F\u043E\u0440\u044F\u0434\u043E\u0447\u0435\u043D\u043D\u044B\u0439 \u043D\u0430\u0431\u043E\u0440 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439.",
                    stringType: "\u0422\u0438\u043F \u043F\u043E\u043B\u044F \u043D\u0435 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u044F\u0435\u0442\u0441\u044F \u0438\u0437 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F, \u043D\u043E \u0432\u0441\u0435\u0433\u0434\u0430 \u0432\u043E\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442\u0441\u044F \u043A\u0430\u043A \u0441\u0442\u0440\u043E\u043A\u0430.",
                    modeEditorTitle: "\u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u0440\u0435\u0436\u0438\u043C\u0430 \u0440\u0435\u0434\u0430\u043A\u0442\u043E\u0440\u0430",
                    modeCodeText: "\u041A\u043E\u0434",
                    modeCodeTitle: "\u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0432 \u0440\u0435\u0436\u0438\u043C \u0440\u0435\u0434\u0430\u043A\u0442\u043E\u0440\u0430 \u043A\u043E\u0434\u0430",
                    modeFormText: "\u0424\u043E\u0440\u043C\u0430",
                    modeFormTitle: "\u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0432 \u0440\u0435\u0436\u0438\u043C \u0444\u043E\u0440\u043C\u044B",
                    modeTextText: "\u0422\u0435\u043A\u0441\u0442",
                    modeTextTitle: "\u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0432 \u0440\u0435\u0436\u0438\u043C \u0440\u0435\u0434\u0430\u043A\u0442\u043E\u0440\u0430 \u0442\u0435\u043A\u0441\u0442\u0430",
                    modeTreeText: "\u0414\u0435\u0440\u0435\u0432\u043E",
                    modeTreeTitle: "\u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0432 \u0440\u0435\u0436\u0438\u043C \u0440\u0435\u0434\u0430\u043A\u0442\u043E\u0440\u0430 \u0434\u0435\u0440\u0435\u0432\u0430",
                    modeViewText: "\u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440 \u0434\u0435\u0440\u0435\u0432\u0430",
                    modeViewTitle: "\u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0432 \u0440\u0435\u0436\u0438\u043C \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0430 \u0434\u0435\u0440\u0435\u0432\u0430",
                    modePreviewText: "\u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440",
                    modePreviewTitle: "\u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0432 \u0440\u0435\u0436\u0438\u043C \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0430",
                    examples: "\u041F\u0440\u0438\u043C\u0435\u0440\u044B",
                    default: "\u041F\u043E \u0443\u043C\u043E\u043B\u0447\u0430\u043D\u0438\u044E",
                    containsInvalidProperties: "\u0421\u043E\u0434\u0435\u0440\u0436\u0438\u0442 \u043D\u0435\u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u044B\u0435 \u0441\u0432\u043E\u0439\u0441\u0442\u0432\u0430",
                    containsInvalidItems: "\u0421\u043E\u0434\u0435\u0440\u0436\u0438\u0442 \u043D\u0435\u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u044B\u0435 \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u044B"
                },
                ko: {
                    array: "\uBC30\uC5F4",
                    auto: "\uC790\uB3D9",
                    appendText: "\uCD94\uAC00",
                    appendTitle: '\uC120\uD0DD\uD55C \uC694\uC18C \uC544\uB798\uC5D0 "\uC790\uB3D9" \uC694\uC18C\uB97C \uCD94\uAC00\uD569\uB2C8\uB2E4. (Ctrl + Shift + Ins)',
                    appendSubmenuTitle: "\uCD94\uAC00\uD560 \uC694\uC18C\uC758 \uC720\uD615\uC744 \uC120\uD0DD\uD574\uC8FC\uC138\uC694.",
                    appendTitleAuto: '"\uC790\uB3D9" \uC694\uC18C\uB97C \uCD94\uAC00\uD569\uB2C8\uB2E4. (Ctrl + Shift + Ins)',
                    ascending: "\uC624\uB984\uCC28\uC21C",
                    ascendingTitle: "\uC120\uD0DD\uD55C ${type}\uC758 \uD558\uC704 \uC694\uC18C\uB97C \uC624\uB984\uCC28\uC21C \uC815\uB82C\uD569\uB2C8\uB2E4.",
                    actionsMenu: "\uBA54\uB274 \uC5F4\uAE30 (Ctrl + M)",
                    cannotParseFieldError: "JSON\uC758 \uC694\uC18C\uB97C \uD574\uC11D\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.",
                    cannotParseValueError: "JSON\uC758 \uAC12\uC744 \uD574\uC11D\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.",
                    collapseAll: "\uBAA8\uB450 \uC811\uAE30",
                    compactTitle: "\uBAA8\uB4E0 \uACF5\uBC31\uC744 \uC81C\uAC70\uD558\uC5EC JSON \uB370\uC774\uD130\uB97C \uC791\uAC8C \uB9CC\uB4ED\uB2C8\uB2E4. (Ctrl + Shift + I)",
                    descending: "\uB0B4\uB9BC\uCC28\uC21C",
                    descendingTitle: "\uC120\uD0DD\uD55C ${type}\uC758 \uD558\uC704 \uC694\uC18C\uB97C \uB0B4\uB9BC\uCC28\uC21C\uC73C\uB85C \uC815\uB82C",
                    drag: "\uB4DC\uB798\uADF8\uD558\uC5EC \uC694\uC18C\uB97C \uC774\uB3D9\uD569\uB2C8\uB2E4. (Alt + Shift + Arrows)",
                    duplicateKey: "\uBCF5\uC81C\uD0A4",
                    duplicateText: "\uBCF5\uC81C",
                    duplicateTitle: "\uC120\uD0DD\uD55C \uC694\uC18C\uB97C \uBCF5\uC81C\uD569\uB2C8\uB2E4. (Ctrl + D)",
                    duplicateField: "\uC120\uD0DD\uD55C \uC694\uC18C\uB97C \uBCF5\uC81C\uD569\uB2C8\uB2E4. (Ctrl + D)",
                    duplicateFieldError: "\uC694\uC18C \uC774\uB984\uC774 \uC911\uBCF5\uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
                    empty: "\uBE44\uC5B4\uC788\uC74C",
                    expandAll: "\uBAA8\uB450 \uC5F4\uAE30",
                    expandTitle: "\uD074\uB9AD\uD558\uC5EC \uC694\uC18C\uB97C \uC5F4\uAC70\uB098 \uB2EB\uC2B5\uB2C8\uB2E4. (Ctrl + E) \nCtrl + Click\uC73C\uB85C \uBAA8\uB4E0 \uD558\uC704 \uC694\uC18C\uB97C \uC5F4\uAC70\uB098 \uB2EB\uC2B5\uB2C8\uB2E4.",
                    formatTitle: "\uC801\uC808\uD55C \uB4E4\uC5EC\uC4F0\uAE30 \uBC0F \uC904\uBC14\uAFC8\uC73C\uB85C JSON \uB370\uC774\uD130\uB97C \uC815\uD615\uD654\uD569\uB2C8\uB2E4. (Ctrl + I)",
                    insert: "\uC0BD\uC785",
                    insertTitle: "\uC120\uD0DD\uD55C \uC694\uC18C \uC704\uC5D0 \uC0C8\uC694\uC18C\uB97C \uC0BD\uC785\uD569\uB2C8\uB2E4. (Ctrl + Ins)",
                    insertSub: "\uC0BD\uC785\uD560 \uC694\uC18C\uC758 \uC720\uD615\uC744 \uC120\uD0DD\uD574\uC8FC\uC138\uC694.",
                    object: "\uAC1D\uCCB4",
                    ok: "\uD655\uC778",
                    redo: "\uB2E4\uC2DC \uC2E4\uD589 (Ctrl + Shift + Z)",
                    removeText: "\uC0AD\uC81C",
                    removeTitle: "\uC120\uD0DD\uD55C \uC694\uC18C\uB97C \uC0AD\uC81C\uD569\uB2C8\uB2E4. (Ctrl + Del)",
                    removeField: "\uC120\uD0DD\uD55C \uC694\uC18C\uB97C \uC0AD\uC81C\uD569\uB2C8\uB2E4. (Ctrl + Del)",
                    repairTitle: "JSON \uAD50\uC815: JSON \uB0B4\uC758 \uC8FC\uC11D\uACFC JSONP \uD45C\uAE30\uBC95\uC744 \uC9C0\uC6B0\uACE0 \uB530\uC634\uD45C\uC640 \uC774\uC2A4\uCF00\uC774\uD504 \uBB38\uC790\uB97C \uC218\uC815\uD569\uB2C8\uB2E4.",
                    searchTitle: "\uC694\uC18C \uB610\uB294 \uAC12 \uCC3E\uAE30",
                    searchNextResultTitle: "\uB2E4\uC74C\uC73C\uB85C \uCC3E\uAE30 (Enter)",
                    searchPreviousResultTitle: "\uC774\uC804\uC73C\uB85C \uCC3E\uAE30 (Shift + Enter)",
                    selectNode: "\uC694\uC18C\uB97C \uC120\uD0DD\uD574\uC8FC\uC138\uC694...",
                    showAll: "\uBAA8\uB450\uBCF4\uAE30",
                    showMore: "\uB354\uBCF4\uAE30",
                    showMoreStatus: "${totalChilds} \uAC1C\uC758 \uD56D\uBAA9 \uC911 ${visibleChilds} \uAC1C\uB97C \uD45C\uC2DC\uD569\uB2C8\uB2E4.",
                    sort: "\uC815\uB82C",
                    sortTitle: "\uC120\uD0DD\uD55C ${type}\uC758 \uD558\uC704 \uC694\uC18C\uB97C \uC815\uB82C\uD569\uB2C8\uB2E4.",
                    sortTitleShort: "\uC815\uB82C",
                    sortFieldLabel: "\uC694\uC18C:",
                    sortDirectionLabel: "\uC21C\uC11C:",
                    sortFieldTitle: "\uBC30\uC5F4\uC774\uB098 \uAC1D\uCCB4\uB97C \uC815\uB82C\uD558\uB294 \uC694\uC18C\uB97C \uC120\uD0DD\uD574\uC8FC\uC138\uC694.",
                    sortAscending: "\uC624\uB984\uCC28\uC21C",
                    sortAscendingTitle: "\uC120\uD0DD\uD55C \uC694\uC18C\uB97C \uC624\uB984\uCC28\uC21C\uC73C\uB85C \uC815\uB82C\uD569\uB2C8\uB2E4.",
                    sortDescending: "\uB0B4\uB9BC\uCC28\uC21C",
                    sortDescendingTitle: "\uC120\uD0DD\uD55C \uC694\uC18C\uB97C \uB0B4\uB9BC\uCC28\uC21C\uC73C\uB85C \uC815\uB82C\uD569\uB2C8\uB2E4.",
                    string: "\uBB38\uC790",
                    transform: "\uBCC0\uD658",
                    transformTitle: "\uC120\uD0DD\uD55C ${type}\uC758 \uD558\uC704 \uC694\uC18C\uB97C \uD544\uD130\uD558\uAC70\uB098 \uC815\uB82C \uB610\uB294 \uBCC0\uD658\uD569\uB2C8\uB2E4.",
                    transformTitleShort: "\uB0B4\uC6A9\uC744 \uD544\uD130\uD558\uAC70\uB098 \uC815\uB82C \uB610\uB294 \uBCC0\uD658\uD569\uB2C8\uB2E4.",
                    extract: "\uCD94\uCD9C",
                    extractTitle: "\uC120\uD0DD\uD55C ${type}\uC758 \uAC12\uC744 \uCD5C\uC0C1\uC704\uC5D0 \uC704\uCE58\uC2DC\uD0B5\uB2C8\uB2E4.",
                    transformQueryTitle: "JMESPath \uCFFC\uB9AC\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694.",
                    transformWizardLabel: "\uB9C8\uBC95\uC0AC",
                    transformWizardFilter: "\uD544\uD130",
                    transformWizardSortBy: "\uC815\uB82C",
                    transformWizardSelectFields: "\uC694\uC18C\uB97C \uC120\uD0DD\uD574\uC8FC\uC138\uC694.",
                    transformQueryLabel: "\uCFFC\uB9AC",
                    transformPreviewLabel: "\uBBF8\uB9AC\uBCF4\uAE30",
                    type: "\uC720\uD615",
                    typeTitle: "\uC120\uD0DD\uD55C \uC694\uC18C\uC758 \uC720\uD615\uC744 \uBCC0\uACBD\uD569\uB2C8\uB2E4.",
                    openUrl: "Ctrl + Click \uB610\uB294 Ctrl + Enter\uB85C \uC0C8 \uCC3D\uC5D0\uC11C URL \uC5F4\uAE30",
                    undo: "\uC2E4\uD589 \uCDE8\uC18C (Ctrl + Z)",
                    validationCannotMove: "\uD558\uC704 \uC694\uC18C\uB85C \uC774\uB3D9\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.",
                    autoType: "\uC790\uB3D9: \uC694\uC18C\uC758 \uD615\uC2DD\uC774 \uAC12\uC758 \uC720\uD615\uC73C\uB85C \uACB0\uC815\uB429\uB2C8\uB2E4. \uBB38\uC790, \uC22B\uC790, \uBD80\uC6B8, \uB610\uB294 null\uB9CC \uD5C8\uC6A9\uB429\uB2C8\uB2E4.",
                    objectType: "\uAC1D\uCCB4: \uC21C\uC11C\uB300\uB85C \uB098\uC5F4\uB418\uC9C0 \uC54A\uC740 \uC774\uB984/\uAC12 \uC30D\uC73C\uB85C \uC774\uB8E8\uC5B4\uC9C4 \uC9D1\uD569\uC785\uB2C8\uB2E4.",
                    arrayType: "\uBC30\uC5F4: \uC21C\uC11C\uB300\uB85C \uB098\uC5F4\uB41C \uAC12\uC758 \uC9D1\uD569\uC785\uB2C8\uB2E4.",
                    stringType: "\uBB38\uC790: \uC694\uC18C\uC758 \uC720\uD615\uC774 \uAC12\uC5D0\uC11C \uACB0\uC815\uB418\uC9C0 \uC54A\uC9C0\uB9CC \uD56D\uC0C1 \uBB38\uC790\uB85C \uBC18\uD658\uB429\uB2C8\uB2E4.",
                    modeEditorTitle: "\uD3B8\uC9D1\uAE30 \uC720\uD615 \uBCC0\uACBD",
                    modeCodeText: "\uCF54\uB4DC",
                    modeCodeTitle: "\uD615\uC2DD \uAD50\uC815\uC744 \uB3C4\uC640\uC8FC\uB294 \uAE30\uB2A5\uC774 \uD3EC\uD568\uB41C \uBB38\uC790 \uD3B8\uC9D1\uAE30",
                    modeFormText: "\uC785\uB825 \uC591\uC2DD",
                    modeFormTitle: "\uC815\uD574\uC9C4 \uC694\uC18C\uC5D0 \uAC12\uC744 \uC785\uB825\uD558\uB294 \uD3B8\uC9D1\uAE30",
                    modeTextText: "\uBB38\uC790",
                    modeTextTitle: "\uB2E8\uC21C \uBB38\uC790 \uD3B8\uC9D1\uAE30",
                    modeTreeText: "\uD2B8\uB9AC",
                    modeTreeTitle: "\uD2B8\uB9AC \uAD6C\uC870\uB85C \uD45C\uC2DC\uB418\uB294 \uD3B8\uC9D1\uAE30",
                    modeViewText: "\uBCF4\uAE30",
                    modeViewTitle: "\uC77D\uAE30\uC804\uC6A9 \uD2B8\uB9AC \uAD6C\uC870\uB85C JSON\uC744 \uD45C\uC2DC",
                    modePreviewText: "\uBBF8\uB9AC\uBCF4\uAE30",
                    modePreviewTitle: "\uC77D\uAE30\uC804\uC6A9 \uBB38\uC790\uB85C JSON\uC744 \uD45C\uC2DC",
                    examples: "\uC608\uC81C",
                    default: "\uAE30\uBCF8\uAC12",
                    containsInvalidProperties: "\uC798\uBABB\uB41C \uC18D\uC131\uC774 \uD3EC\uD568\uB418\uC5B4 \uC788\uC2B5\uB2C8\uB2E4.",
                    containsInvalidItems: "\uC798\uBABB\uB41C \uD56D\uBAA9\uC774 \uD3EC\uD568\uB418\uC5B4 \uC788\uC2B5\uB2C8\uB2E4"
                }
            }, n = Object.keys(r), s = "en", o = "undefined" != typeof navigator ? navigator.language || navigator.userLanguage : void 0, a = n.find(function(e) {
                return e === o;
            }) || s;
            function l(t) {
                var e;
                t && ((e = n.find(function(e) {
                    return e === t;
                })) ? a = e : console.error("Language not found"));
            }
            function c(e) {
                if (e) for(var t in e)((t)=>{
                    n.find(function(e) {
                        return e === t;
                    }) || n.push(t), r[t] = Object.assign({}, r[s], r[t], e[t]);
                })(t);
            }
            function h(e, t, i) {
                var n = r[i = i || a][e] || r[s][e] || e;
                if (t) for(var o in t)n = n.replace("${" + o + "}", t[o]);
                return n;
            }
        },
        359: function(e, t, i) {
            i.d(t, {
                V: function() {
                    return o;
                },
                e: function() {
                    return r;
                }
            });
            var t = i(9151), n = i.n(t), s = i(6237);
            function o(e, t) {
                var i, n = t.sort, o = t.filter, t = t.projection, r = "";
                return o ? (i = "@" !== o.field ? [
                    "0"
                ].concat((0, s.parsePath)("." + o.field)) : [
                    "0"
                ], i = "string" == typeof (0, s.get)(e, i) ? o.value : (0, s.parseString)(o.value), r += "[? " + o.field + " " + o.relation + " `" + JSON.stringify(i) + "`]") : r += Array.isArray(e) ? "[*]" : "@", n && ("desc" === n.direction ? r += " | reverse(sort_by(@, &" + n.field + "))" : r += " | sort_by(@, &" + n.field + ")"), t && ("]" !== r[r.length - 1] && (r += " | [*]"), 1 === t.fields.length ? r += "." + t.fields[0] : 1 < t.fields.length && (r += ".{" + t.fields.map(function(e) {
                    var t = e.split(".");
                    return t[t.length - 1] + ": " + e;
                }).join(", ") + "}")), r;
            }
            function r(e, t) {
                return n().search(e, t);
            }
        },
        1081: function() {
            function e(e) {
                void 0 === e || "remove" in e || Object.defineProperty(e, "remove", {
                    configurable: !0,
                    enumerable: !0,
                    writable: !0,
                    value: function() {
                        void 0 !== this.parentNode && this.parentNode.removeChild(this);
                    }
                });
            }
            "undefined" != typeof Element && (void 0 !== window.Element && e(window.Element.prototype), void 0 !== window.CharacterData && e(window.CharacterData.prototype), void 0 !== window.DocumentType) && e(window.DocumentType.prototype), Array.prototype.findIndex || Object.defineProperty(Array.prototype, "findIndex", {
                value: function(e) {
                    for(var t = 0; t < this.length; t++){
                        var i = this[t];
                        if (e.call(this, i, t, this)) return t;
                    }
                    return -1;
                },
                configurable: !0,
                writable: !0
            }), Array.prototype.find || Object.defineProperty(Array.prototype, "find", {
                value: function(e) {
                    e = this.findIndex(e);
                    return this[e];
                },
                configurable: !0,
                writable: !0
            }), String.prototype.trim || (String.prototype.trim = function() {
                return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
            });
        },
        7483: function(e, t, i) {
            i.r(t), i.d(t, {
                previewModeMixins: function() {
                    return f;
                }
            });
            var n = i(9857), s = i(660), o = i(2115), r = i(2877);
            function a(e) {
                return (a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                })(e);
            }
            function l(e, t) {
                for(var i = 0; i < t.length; i++){
                    var n = t[i];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, ((e)=>(e = ((e, t)=>{
                            if ("object" != a(e) || !e) return e;
                            var i = e[Symbol.toPrimitive];
                            if (void 0 === i) return ("string" === t ? String : Number)(e);
                            if ("object" != a(i = i.call(e, t || "default"))) return i;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        })(e, "string"), "symbol" == a(e) ? e : e + ""))(n.key), n);
                }
            }
            var c = (()=>{
                function n(e, t, i) {
                    if (!(this instanceof n)) throw new TypeError("Cannot call a class as a function");
                    this.onChange = e, this.calculateItemSize = t || function() {
                        return 1;
                    }, this.limit = i, this.items = [], this.index = -1;
                }
                var e, t, i;
                return e = n, t = [
                    {
                        key: "add",
                        value: function(e) {
                            for(; this._calculateHistorySize() > this.limit && 1 < this.items.length;)this.items.shift(), this.index--;
                            this.items = this.items.slice(0, this.index + 1), this.items.push(e), this.index++, this.onChange();
                        }
                    },
                    {
                        key: "_calculateHistorySize",
                        value: function() {
                            var t = this.calculateItemSize, i = 0;
                            return this.items.forEach(function(e) {
                                i += t(e);
                            }), i;
                        }
                    },
                    {
                        key: "undo",
                        value: function() {
                            if (this.canUndo()) return this.index--, this.onChange(), this.items[this.index];
                        }
                    },
                    {
                        key: "redo",
                        value: function() {
                            if (this.canRedo()) return this.index++, this.onChange(), this.items[this.index];
                        }
                    },
                    {
                        key: "canUndo",
                        value: function() {
                            return 0 < this.index;
                        }
                    },
                    {
                        key: "canRedo",
                        value: function() {
                            return this.index < this.items.length - 1;
                        }
                    },
                    {
                        key: "clear",
                        value: function() {
                            this.items = [], this.index = -1, this.onChange();
                        }
                    }
                ], l(e.prototype, t), i && l(e, i), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), e;
            })(), h = i(3057), d = i(359), u = i(1389), g = i(2915), p = i(5609), t = i(1948), m = i(6237), i = t.textModeMixins[0].mixin, t = {
                create: function(e) {
                    var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {}, i = (void 0 === t.statusBar && (t.statusBar = !0), t.mainMenuBar = !1 !== t.mainMenuBar, t.enableSort = !1 !== t.enableSort, t.enableTransform = !1 !== t.enableTransform, t.createQuery = t.createQuery || d.V, t.executeQuery = t.executeQuery || d.e, this.options = t, this.indentation = "number" == typeof t.indentation ? Number(t.indentation) : 2, (0, h.AI)(this.options.languages), (0, h.xC)(this.options.language), this.mode = "preview", this), e = (this.container = e, this.dom = {}, this.json = void 0, this.text = "", this._debouncedValidate = (0, m.debounce)(this.validate.bind(this), this.DEBOUNCE_INTERVAL), this.width = e.clientWidth, this.height = e.clientHeight, this.frame = document.createElement("div"), this.frame.className = "jsoneditor jsoneditor-mode-preview", this.frame.onclick = function(e) {
                        e.preventDefault();
                    }, {
                        target: this.frame,
                        onFocus: this.options.onFocus || null,
                        onBlur: this.options.onBlur || null
                    }), e = (this.frameFocusTracker = new r.$(e), this.content = document.createElement("div"), this.content.className = "jsoneditor-outer", this.dom.busy = document.createElement("div"), this.dom.busy.className = "jsoneditor-busy", this.dom.busyContent = document.createElement("span"), this.dom.busyContent.textContent = "busy...", this.dom.busy.appendChild(this.dom.busyContent), this.content.appendChild(this.dom.busy), this.dom.previewContent = document.createElement("pre"), this.dom.previewContent.className = "jsoneditor-preview", this.dom.previewText = document.createTextNode(""), this.dom.previewContent.appendChild(this.dom.previewText), this.content.appendChild(this.dom.previewContent), this.options.mainMenuBar && ((0, m.addClassName)(this.content, "has-main-menu-bar"), this.menu = document.createElement("div"), this.menu.className = "jsoneditor-menu", this.frame.appendChild(this.menu), (e = document.createElement("button")).type = "button", e.className = "jsoneditor-format", e.title = (0, h.Tl)("formatTitle"), this.menu.appendChild(e), e.onclick = function() {
                        i.executeWithBusyMessage(function() {
                            try {
                                i.format();
                            } catch (e) {
                                i._onError(e);
                            }
                        }, "formatting...");
                    }, (e = document.createElement("button")).type = "button", e.className = "jsoneditor-compact", e.title = (0, h.Tl)("compactTitle"), this.menu.appendChild(e), e.onclick = function() {
                        i.executeWithBusyMessage(function() {
                            try {
                                i.compact();
                            } catch (e) {
                                i._onError(e);
                            }
                        }, "compacting...");
                    }, this.options.enableSort && ((e = document.createElement("button")).type = "button", e.className = "jsoneditor-sort", e.title = (0, h.Tl)("sortTitleShort"), e.onclick = function() {
                        i._showSortModal();
                    }, this.menu.appendChild(e)), this.options.enableTransform && ((e = document.createElement("button")).type = "button", e.title = (0, h.Tl)("transformTitleShort"), e.className = "jsoneditor-transform", e.onclick = function() {
                        i._showTransformModal();
                    }, this.dom.transform = e, this.menu.appendChild(e)), (e = document.createElement("button")).type = "button", e.className = "jsoneditor-repair", e.title = (0, h.Tl)("repairTitle"), this.menu.appendChild(e), (e.onclick = function() {
                        void 0 === i.json && i.executeWithBusyMessage(function() {
                            try {
                                i.repair();
                            } catch (e) {
                                i._onError(e);
                            }
                        }, "repairing...");
                    }, false) !== this.options.history && (this.history = new c(function() {
                        i.dom.undo.disabled = !i.history.canUndo(), i.dom.redo.disabled = !i.history.canRedo();
                    }, function(e) {
                        return 2 * e.text.length;
                    }, s.SC), (e = document.createElement("button")).type = "button", e.className = "jsoneditor-undo jsoneditor-separator", e.title = (0, h.Tl)("undo"), e.onclick = function() {
                        var e = i.history.undo();
                        e && i._applyHistory(e);
                    }, this.menu.appendChild(e), this.dom.undo = e, (e = document.createElement("button")).type = "button", e.className = "jsoneditor-redo", e.title = (0, h.Tl)("redo"), e.onclick = function() {
                        var e = i.history.redo();
                        e && i._applyHistory(e);
                    }, this.menu.appendChild(e), this.dom.redo = e, this.history.onChange()), this.options) && this.options.modes && this.options.modes.length && (this.modeSwitcher = new u.n(this.menu, this.options.modes, this.options.mode, function(e) {
                        try {
                            i.setMode(e), i.modeSwitcher.focus();
                        } catch (e) {
                            i._onError(e);
                        }
                    })), Array.isArray(this.options.showErrorTable) ? this.options.showErrorTable.includes(this.mode) : !0 === this.options.showErrorTable);
                    this.errorTable = new o.N({
                        errorTableVisible: e,
                        onToggleVisibility: function() {
                            i.validate();
                        },
                        onFocusLine: null,
                        onChangeHeight: function(e) {
                            e = e + (i.dom.statusBar ? i.dom.statusBar.clientHeight : 0) + 1;
                            i.content.style.marginBottom = -e + "px", i.content.style.paddingBottom = e + "px";
                        }
                    }), this.frame.appendChild(this.content), this.frame.appendChild(this.errorTable.getErrorTable()), this.container.appendChild(this.frame), t.statusBar && ((0, m.addClassName)(this.content, "has-status-bar"), e = document.createElement("div"), (this.dom.statusBar = e).className = "jsoneditor-statusbar", this.frame.appendChild(e), this.dom.fileSizeInfo = document.createElement("span"), this.dom.fileSizeInfo.className = "jsoneditor-size-info", this.dom.fileSizeInfo.innerText = "", e.appendChild(this.dom.fileSizeInfo), this.dom.arrayInfo = document.createElement("span"), this.dom.arrayInfo.className = "jsoneditor-size-info", this.dom.arrayInfo.innerText = "", e.appendChild(this.dom.arrayInfo), e.appendChild(this.errorTable.getErrorCounter()), e.appendChild(this.errorTable.getWarningIcon()), e.appendChild(this.errorTable.getErrorIcon())), this._renderPreview(), this.setSchema(this.options.schema, this.options.schemaRefs);
                },
                _renderPreview: function() {
                    var e = this.getText();
                    this.dom.previewText.nodeValue = (0, m.limitCharacters)(e, s.hJ), this.dom.fileSizeInfo && (this.dom.fileSizeInfo.innerText = "Size: " + (0, m.formatSize)(e.length)), this.dom.arrayInfo && (Array.isArray(this.json) ? this.dom.arrayInfo.innerText = "Array: " + this.json.length + " items" : this.dom.arrayInfo.innerText = "");
                },
                _onChange: function() {
                    if (this._debouncedValidate(), this.options.onChange) try {
                        this.options.onChange();
                    } catch (e) {
                        console.error("Error in onChange callback: ", e);
                    }
                    if (this.options.onChangeJSON) try {
                        this.options.onChangeJSON(this.get());
                    } catch (e) {
                        console.error("Error in onChangeJSON callback: ", e);
                    }
                    if (this.options.onChangeText) try {
                        this.options.onChangeText(this.getText());
                    } catch (e) {
                        console.error("Error in onChangeText callback: ", e);
                    }
                }
            }, f = (t._showSortModal = function() {
                var r = this;
                this.executeWithBusyMessage(function() {
                    var e = r.options.modalAnchor || s.ai, o = r.get();
                    r._renderPreview(), (0, g.showSortModal)(e, o, function(n) {
                        r.executeWithBusyMessage(function() {
                            var e, t, i;
                            e = o, t = n, Array.isArray(e) && (i = (0, m.sort)(e, t.path, t.direction), r.sortedBy = t, r._setAndFireOnChange(i)), (0, m.isObject)(e) && (i = (0, m.sortObjectKeys)(e, t.direction), r.sortedBy = t, r._setAndFireOnChange(i));
                        }, "sorting...");
                    }, r.sortedBy);
                }, "parsing...");
            }, t._showTransformModal = function() {
                var r = this;
                this.executeWithBusyMessage(function() {
                    var e = r.options, t = e.createQuery, i = e.executeQuery, n = e.modalAnchor, e = e.queryDescription, o = r.get();
                    r._renderPreview(), (0, p.showTransformModal)({
                        container: n || s.ai,
                        json: o,
                        queryDescription: e,
                        createQuery: t,
                        executeQuery: i,
                        onTransform: function(t) {
                            r.executeWithBusyMessage(function() {
                                var e = i(o, t);
                                r._setAndFireOnChange(e);
                            }, "transforming...");
                        }
                    });
                }, "parsing...");
            }, t.destroy = function() {
                this.frame && this.container && this.frame.parentNode === this.container && this.container.removeChild(this.frame), this.modeSwitcher && (this.modeSwitcher.destroy(), this.modeSwitcher = null), this._debouncedValidate = null, this.history && (this.history.clear(), this.history = null), this.frameFocusTracker.destroy();
            }, t.compact = function() {
                var e = this.get(), t = JSON.stringify(e);
                this._setTextAndFireOnChange(t, e);
            }, t.format = function() {
                var e = this.get(), t = JSON.stringify(e, null, this.indentation);
                this._setTextAndFireOnChange(t, e);
            }, t.repair = function() {
                var e = this.getText();
                try {
                    var t = (0, n.m)(e);
                    this._setTextAndFireOnChange(t);
                } catch (e) {}
            }, t.focus = function() {
                this.dom.transform.focus();
            }, t.set = function(e) {
                this.history && this.history.clear(), this._set(e);
            }, t.update = function(e) {
                this._set(e);
            }, t._set = function(e) {
                this.text = void 0, this.json = e, this._renderPreview(), this._pushHistory(), this._debouncedValidate();
            }, t._setAndFireOnChange = function(e) {
                this._set(e), this._onChange();
            }, t.get = function() {
                var e;
                return void 0 === this.json && (e = this.getText(), this.json = (0, m.parse)(e)), this.json;
            }, t.getText = function() {
                return void 0 === this.text && (this.text = JSON.stringify(this.json, null, this.indentation), !0 === this.options.escapeUnicode) && (this.text = (0, m.escapeUnicodeChars)(this.text)), this.text;
            }, t.setText = function(e) {
                this.history && this.history.clear(), this._setText(e);
            }, t.updateText = function(e) {
                this.getText() !== e && this._setText(e);
            }, t._setText = function(e, t) {
                var i;
                !0 === this.options.escapeUnicode ? this.text = (0, m.escapeUnicodeChars)(e) : this.text = e, this.json = t, this._renderPreview(), void 0 === this.json ? (i = this).executeWithBusyMessage(function() {
                    try {
                        i.json = i.get(), i._renderPreview(), i._pushHistory();
                    } catch (e) {}
                }, "parsing...") : this._pushHistory(), this._debouncedValidate();
            }, t._setTextAndFireOnChange = function(e, t) {
                this._setText(e, t), this._onChange();
            }, t._applyHistory = function(e) {
                this.json = e.json, this.text = e.text, this._renderPreview(), this._debouncedValidate();
            }, t._pushHistory = function() {
                var e;
                this.history && (e = {
                    text: this.text,
                    json: this.json
                }, this.history.add(e));
            }, t.executeWithBusyMessage = function(e, t) {
                var i;
                this.getText().length > s.Oq ? ((0, m.addClassName)((i = this).frame, "busy"), i.dom.busyContent.innerText = t, setTimeout(function() {
                    e(), (0, m.removeClassName)(i.frame, "busy"), i.dom.busyContent.innerText = "";
                }, 100)) : e();
            }, t.validate = i.validate, t._renderErrors = i._renderErrors, [
                {
                    mode: "preview",
                    mixin: t,
                    data: "json"
                }
            ]);
        },
        2915: function(e, t, i) {
            i.r(t), i.d(t, {
                showSortModal: function() {
                    return s;
                }
            });
            var t = i(8340), n = i.n(t), o = i(3057), r = i(6237);
            function s(e, t, s, i) {
                var a = Array.isArray(t) ? (0, r.getChildPaths)(t) : [
                    ""
                ], l = i && i.path && (0, r.contains)(a, i.path) ? i.path : a[0], c = i && i.direction || "asc", t = '<div class="pico-modal-contents"><div class="pico-modal-header">' + (0, o.Tl)("sort") + "</div><form><table><tbody><tr>  <td>" + (0, o.Tl)("sortFieldLabel") + ' </td>  <td class="jsoneditor-modal-input">  <div class="jsoneditor-select-wrapper">    <select id="field" title="' + (0, o.Tl)("sortFieldTitle") + '">    </select>  </div>  </td></tr><tr>  <td>' + (0, o.Tl)("sortDirectionLabel") + ' </td>  <td class="jsoneditor-modal-input">  <div id="direction" class="jsoneditor-button-group"><input type="button" value="' + (0, o.Tl)("sortAscending") + '" title="' + (0, o.Tl)("sortAscendingTitle") + '" data-value="asc" class="jsoneditor-button-first jsoneditor-button-asc"/><input type="button" value="' + (0, o.Tl)("sortDescending") + '" title="' + (0, o.Tl)("sortDescendingTitle") + '" data-value="desc" class="jsoneditor-button-last jsoneditor-button-desc"/>  </div>  </td></tr><tr><td colspan="2" class="jsoneditor-modal-input jsoneditor-modal-actions">  <input type="submit" id="ok" value="' + (0, o.Tl)("ok") + '" /></td></tr></tbody></table></form></div>';
                n()({
                    parent: e,
                    content: t,
                    overlayClass: "jsoneditor-modal-overlay",
                    overlayStyles: {
                        backgroundColor: "rgb(1,1,1)",
                        opacity: .3
                    },
                    modalClass: "jsoneditor-modal jsoneditor-modal-sort"
                }).afterCreate(function(t) {
                    var e = t.modalElem().querySelector("form"), i = t.modalElem().querySelector("#ok"), n = t.modalElem().querySelector("#field"), o = t.modalElem().querySelector("#direction");
                    function r(e) {
                        o.value = e, o.className = "jsoneditor-button-group jsoneditor-button-group-value-" + o.value;
                    }
                    a.forEach(function(e) {
                        var t, i = document.createElement("option");
                        i.text = "" === (t = e) ? "@" : "." === t[0] ? t.slice(1) : t, i.value = e, n.appendChild(i);
                    }), n.value = l || a[0], r(c || "asc"), o.onclick = function(e) {
                        r(e.target.getAttribute("data-value"));
                    }, i.onclick = function(e) {
                        e.preventDefault(), e.stopPropagation(), t.close(), s({
                            path: n.value,
                            direction: o.value
                        });
                    }, e && (e.onsubmit = i.onclick);
                }).afterClose(function(e) {
                    e.destroy();
                }).show();
            }
        },
        5609: function(e, t, i) {
            i.r(t), i.d(t, {
                showTransformModal: function() {
                    return s;
                }
            });
            var t = i(8340), n = i.n(t), t = i(4772), S = i.n(t), o = i(3057);
            function I(e) {
                return (I = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                })(e);
            }
            function k(e, t, i, n) {
                if ("boolean" == typeof e || e instanceof Boolean || null === e || "number" == typeof e || e instanceof Number || "string" == typeof e || e instanceof String || e instanceof Date) return JSON.stringify(e);
                if (Array.isArray(e)) {
                    for(var o = e, r = t, s = i, a = n, l = r ? s + r : void 0, c = r ? "[\n" : "[", h = 0; h < o.length; h++){
                        var d = o[h];
                        if (r && (c += l), c += void 0 !== d && "function" != typeof d ? k(d, r, l, a) : "null", h < o.length - 1 && (c += r ? ",\n" : ","), c.length > a) return c + "...";
                    }
                    return c += r ? "\n" + s + "]" : "]";
                }
                if (e && "object" === I(e)) {
                    var u, g = e, p = t, s = i, m = n, f = p ? s + p : void 0, C = !0, y = p ? "{\n" : "{";
                    if ("function" == typeof g.toJSON) return k(g.toJSON(), p, s, m);
                    for(u in g)if (((e, t)=>Object.prototype.hasOwnProperty.call(e, t))(g, u)) {
                        var v = g[u];
                        if (C ? C = !1 : y += p ? ",\n" : ",", (y = (y += p ? f + '"' + u + '": ' : '"' + u + '":') + k(v, p, f, m)).length > m) return y + "...";
                    }
                    return y += p ? "\n" + s + "}" : "}";
                }
            }
            function T(e, t) {
                for(var i = ""; 0 < t--;)i += e;
                return i;
            }
            var E = i(6237), R = i(660), r = 'Enter a <a href="http://jmespath.org" target="_blank">JMESPath</a> query to filter, sort, or transform the JSON data.<br/>To learn JMESPath, go to <a href="http://jmespath.org/tutorial.html" target="_blank">the interactive tutorial</a>.';
            function s(e) {
                var t = e.container, I = e.json, i = e.queryDescription, i = void 0 === i ? r : i, b = e.createQuery, A = e.executeQuery, w = e.onTransform, x = I, e = '<div class="pico-modal-contents"><div class="pico-modal-header">' + (0, o.Tl)("transform") + "</div><p>" + i + '</p><div class="jsoneditor-jmespath-label">' + (0, o.Tl)("transformWizardLabel") + ' </div><div id="wizard" class="jsoneditor-jmespath-block jsoneditor-jmespath-wizard">  <table class="jsoneditor-jmespath-wizard-table">    <tbody>      <tr>        <th>' + (0, o.Tl)("transformWizardFilter") + '</th>        <td class="jsoneditor-jmespath-filter">          <div class="jsoneditor-inline jsoneditor-jmespath-filter-field" >            <select id="filterField">            </select>          </div>          <div class="jsoneditor-inline jsoneditor-jmespath-filter-relation" >            <select id="filterRelation">              <option value="==">==</option>              <option value="!=">!=</option>              <option value="<">&lt;</option>              <option value="<=">&lt;=</option>              <option value=">">&gt;</option>              <option value=">=">&gt;=</option>            </select>          </div>          <div class="jsoneditor-inline jsoneditor-jmespath-filter-value" >            <input type="text" class="value" placeholder="value..." id="filterValue" />          </div>        </td>      </tr>      <tr>        <th>' + (0, o.Tl)("transformWizardSortBy") + '</th>        <td class="jsoneditor-jmespath-filter">          <div class="jsoneditor-inline jsoneditor-jmespath-sort-field">            <select id="sortField">            </select>          </div>          <div class="jsoneditor-inline jsoneditor-jmespath-sort-order" >            <select id="sortOrder">              <option value="asc">Ascending</option>              <option value="desc">Descending</option>            </select>          </div>        </td>      </tr>      <tr id="selectFieldsPart">        <th>' + (0, o.Tl)("transformWizardSelectFields") + '</th>        <td class="jsoneditor-jmespath-filter">          <select class="jsoneditor-jmespath-select-fields" id="selectFields" multiple></select>        </td>      </tr>    </tbody>  </table></div><div class="jsoneditor-jmespath-label">' + (0, o.Tl)("transformQueryLabel") + ' </div><div class="jsoneditor-jmespath-block">  <textarea id="query"             rows="4"             autocomplete="off"             autocorrect="off"             autocapitalize="off"             spellcheck="false"            title="' + (0, o.Tl)("transformQueryTitle") + '">[*]</textarea></div><div class="jsoneditor-jmespath-label">' + (0, o.Tl)("transformPreviewLabel") + ' </div><div class="jsoneditor-jmespath-block">  <textarea id="preview"       class="jsoneditor-transform-preview"      readonly> </textarea></div><div class="jsoneditor-jmespath-block jsoneditor-modal-actions">  <input type="submit" id="ok" value="' + (0, o.Tl)("ok") + '" autofocus /></div></div>';
                n()({
                    parent: t,
                    content: e,
                    overlayClass: "jsoneditor-modal-overlay",
                    overlayStyles: {
                        backgroundColor: "rgb(1,1,1)",
                        opacity: .3
                    },
                    modalClass: "jsoneditor-modal jsoneditor-modal-transform",
                    focus: !1
                }).afterCreate(function(t) {
                    var e = t.modalElem(), i = e.querySelector("#wizard"), r = e.querySelector("#ok"), o = e.querySelector("#filterField"), s = e.querySelector("#filterRelation"), a = e.querySelector("#filterValue"), l = e.querySelector("#sortField"), c = e.querySelector("#sortOrder"), h = e.querySelector("#selectFields"), d = e.querySelector("#query"), u = e.querySelector("#preview");
                    Array.isArray(x) || (i.style.fontStyle = "italic", i.textContent = "(wizard not available for objects, only for arrays)");
                    (0, E.getChildPaths)(I).forEach(function(e) {
                        var e = f(e), t = document.createElement("option"), t = (t.text = e, t.value = e, o.appendChild(t), document.createElement("option"));
                        t.text = e, t.value = e, l.appendChild(t);
                    });
                    var i = (0, E.getChildPaths)(I, !0).filter(function(e) {
                        return "" !== e;
                    }), i = (0 < i.length ? i.forEach(function(e) {
                        var e = f(e), t = document.createElement("option");
                        t.text = e, t.value = e, h.appendChild(t);
                    }) : (i = e.querySelector("#selectFieldsPart")) && (i.style.display = "none"), new (S())(o, {
                        defaultSelected: !1,
                        clearable: !0,
                        allowDeselect: !0,
                        placeholder: "field..."
                    })), n = new (S())(s, {
                        defaultSelected: !1,
                        clearable: !0,
                        allowDeselect: !0,
                        placeholder: "compare..."
                    }), g = new (S())(l, {
                        defaultSelected: !1,
                        clearable: !0,
                        allowDeselect: !0,
                        placeholder: "field..."
                    }), p = new (S())(c, {
                        defaultSelected: !1,
                        clearable: !0,
                        allowDeselect: !0,
                        placeholder: "order..."
                    }), m = new (S())(h, {
                        multiple: !0,
                        clearable: !0,
                        defaultSelected: !1,
                        placeholder: "select fields..."
                    });
                    function f(e) {
                        return "" === e ? "@" : "." === e[0] ? e.slice(1) : e;
                    }
                    i.on("selectr.change", v), n.on("selectr.change", v), a.oninput = v, g.on("selectr.change", v), p.on("selectr.change", v), m.on("selectr.change", v), e.querySelector(".pico-modal-contents").onclick = function(e) {
                        "A" !== e.target.nodeName && e.preventDefault();
                    };
                    var C = (0, E.debounce)(function() {
                        try {
                            var e = A(x, d.value);
                            u.className = "jsoneditor-transform-preview", u.value = (t = e, i = 2, n = R.hJ, "number" == typeof i ? 10 < i ? o = T(" ", 10) : 1 <= i && (o = T(" ", i)) : "string" == typeof i && "" !== i && (o = i), (i = k(t, o, "", n)).length > n ? (t = i, ("number" == typeof (o = n) ? t.slice(0, o) : t) + "...") : i), r.disabled = !1;
                        } catch (e) {
                            u.className = "jsoneditor-transform-preview jsoneditor-error", u.value = e.toString(), r.disabled = !0;
                        }
                        var t, i, n, o;
                    }, 300);
                    function y(t, e) {
                        try {
                            d.value = b(t, e), r.disabled = !1, C();
                        } catch (e) {
                            t = 'Error: an error happened when executing "createQuery": ' + (e.message || e.toString());
                            d.value = "", r.disabled = !0, u.className = "jsoneditor-transform-preview jsoneditor-error", u.value = t;
                        }
                    }
                    function v() {
                        var e = {};
                        if (o.value && s.value && a.value && (e.filter = {
                            field: o.value,
                            relation: s.value,
                            value: a.value
                        }), l.value && c.value && (e.sort = {
                            field: l.value,
                            direction: c.value
                        }), h.value) {
                            for(var t, i = [], n = 0; n < h.options.length; n++)h.options[n].selected && (t = h.options[n].value, i.push(t));
                            e.projection = {
                                fields: i
                            };
                        }
                        y(I, e);
                    }
                    d.oninput = C, r.onclick = function(e) {
                        e.preventDefault(), e.stopPropagation(), t.close(), w(d.value);
                    }, y(I, {}), setTimeout(function() {
                        d.select(), d.focus(), d.selectionStart = 3, d.selectionEnd = 3;
                    });
                }).afterClose(function(e) {
                    e.destroy();
                }).show();
            }
        },
        1948: function(e, t, i) {
            i.r(t), i.d(t, {
                textModeMixins: function() {
                    return A;
                }
            });
            var n = i(9857), t = i(7413), l = i.n(t), a = i(660), c = i(2115), h = i(2877), d = i(3057), u = i(359), g = i(1389), o = i(2915), p = i(5609), m = i(5467), f = i(3094), C = i(6237);
            function r(e) {
                return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                })(e);
            }
            function s(e, t) {
                for(var i = 0; i < t.length; i++){
                    var n = t[i];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, ((e)=>(e = ((e, t)=>{
                            if ("object" != r(e) || !e) return e;
                            var i = e[Symbol.toPrimitive];
                            if (void 0 === i) return ("string" === t ? String : Number)(e);
                            if ("object" != r(i = i.call(e, t || "default"))) return i;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        })(e, "string"), "symbol" == r(e) ? e : e + ""))(n.key), n);
                }
            }
            var y = (()=>{
                function i(e, t) {
                    if (!(this instanceof i)) throw new TypeError("Cannot call a class as a function");
                    this.schema = e, this.schemaRefs = t || {}, this.suggestions = {}, this.suggestionsRefs = {}, this._buildSuggestions();
                }
                var e, t, n;
                return e = i, t = [
                    {
                        key: "_buildSuggestions",
                        value: function() {
                            for(var e in this._handleSchemaEntry("", this.schema, this.suggestions), this.schemaRefs)this.suggestionsRefs[e] = {}, this._handleSchemaEntry("", this.schemaRefs[e], this.suggestionsRefs[e]);
                        }
                    },
                    {
                        key: "_handleRef",
                        value: function(e, t, i) {
                            i[e] = i[e] || {}, i[e].refs = i[e].refs || [], i[e].refs = (0, C.uniqueMergeArrays)(i[e].refs, [
                                t
                            ]);
                        }
                    },
                    {
                        key: "_handleSchemaEntry",
                        value: function(e, t, i) {
                            if (t) {
                                if (t.$ref) this._handleRef(e, t.$ref, i);
                                else {
                                    var n = this._checkOfConditon(t);
                                    if (n) this._handleOfCondition(e, t[n], i);
                                    else switch(t.type){
                                        case "object":
                                            this._handleObject(e, t, i);
                                            break;
                                        case "string":
                                        case "number":
                                        case "integer":
                                            this._handlePrimitive(e, t, i);
                                            break;
                                        case "boolean":
                                            this._handleBoolean(e, t, i);
                                            break;
                                        case "array":
                                            this._handleArray(e, t, i);
                                    }
                                }
                            } else console.error("SchemaTextCompleter: schema node is missing for path", e);
                        }
                    },
                    {
                        key: "_handleObject",
                        value: function(t, i, n) {
                            var e, o = this;
                            (0, C.isObject)(i.properties) && (e = Object.keys(i.properties), n[t] = n[t] || {}, n[t].props = n[t].props || [], n[t].props = (0, C.uniqueMergeArrays)(n[t].props, e), e.forEach(function(e) {
                                (0, C.asyncExec)(function() {
                                    o._handleSchemaEntry("".concat(t, "/").concat(e), i.properties[e], n);
                                });
                            }));
                        }
                    },
                    {
                        key: "_handlePrimitive",
                        value: function(e, t, i) {
                            i[e] = i[e] || {}, (0, C.isArray)(t.examples) && (i[e].examples = i[e].examples || [], i[e].examples = (0, C.uniqueMergeArrays)(i[e].examples, t.examples)), (0, C.isArray)(t.enum) && (i[e].enum = i[e].enum || [], i[e].enum = (0, C.uniqueMergeArrays)(i[e].enum, t.enum));
                        }
                    },
                    {
                        key: "_handleBoolean",
                        value: function(e, t, i) {
                            i[e] || (i[e] = {
                                bool: [
                                    !0,
                                    !1
                                ]
                            });
                        }
                    },
                    {
                        key: "_handleArray",
                        value: function(e, t, i) {
                            var n = this;
                            t.items && (0, C.asyncExec)(function() {
                                n._handleSchemaEntry("".concat(e, "/\\d+"), t.items, i);
                            });
                        }
                    },
                    {
                        key: "_handleOfCondition",
                        value: function(t, e, i) {
                            var n = this;
                            e && e.length && e.forEach(function(e) {
                                (0, C.asyncExec)(function() {
                                    n._handleSchemaEntry(t, e, i);
                                });
                            });
                        }
                    },
                    {
                        key: "_checkOfConditon",
                        value: function(e) {
                            if (e) return e.oneOf ? "oneOf" : e.anyOf ? "anyOf" : e.allOf ? "allOf" : void 0;
                        }
                    },
                    {
                        key: "getCompletions",
                        value: function(e, t, n, i, s) {
                            var c = this;
                            try {
                                var o = f.parse(t.getValue()).pointers || {}, r = function(n) {
                                    function e(t) {
                                        var e, i = {
                                            props: "property",
                                            enum: "enum",
                                            bool: "boolean",
                                            examples: "examples"
                                        };
                                        n && null != (e = n[t]) && e.length && (o = o.concat(n[t].map(function(e) {
                                            return {
                                                caption: e + "",
                                                meta: "schema [".concat(i[t], "]"),
                                                score: r++,
                                                value: e + ""
                                            };
                                        })));
                                    }
                                    var o = [], r = 0;
                                    e("props"), e("enum"), e("bool"), e("examples"), o.length && s(null, o);
                                };
                                Object.keys(o).forEach(function(i) {
                                    (0, C.asyncExec)(function() {
                                        function l(i, e, n) {
                                            var t, o = Object.keys(e).reduce(function(e, t) {
                                                return new RegExp("^".concat(n).concat(t)).test(i) && (!e || e.length < t.length) ? t : e;
                                            }, null);
                                            if ("string" == typeof o) {
                                                if (null != (t = e[o]) && null != (t = t.refs) && t.length) {
                                                    var r, s = {};
                                                    for(r in e[o].refs){
                                                        var a = e[o].refs[r];
                                                        c.suggestionsRefs[a] && (null != (a = l(i, c.suggestionsRefs[a], "".concat(n).concat(o))) && a.enum && (s.enum = (0, C.uniqueMergeArrays)(s.enum, a.enum)), null != a && a.examples && (s.examples = (0, C.uniqueMergeArrays)(s.examples, a.examples)), null != a && a.bool && (s.bool = (0, C.uniqueMergeArrays)(s.bool, a.bool)), null != a) && a.props && (s.props = (0, C.uniqueMergeArrays)(s.props, a.props));
                                                    }
                                                    return s;
                                                }
                                                if (new RegExp("^".concat(n).concat(o, "$")).test(i)) return e[o];
                                            }
                                        }
                                        var e, t;
                                        (null == (t = o[i].key) ? void 0 : t.line) === n.row && n.column >= o[i].key.column && n.column <= o[i].keyEnd.column && (e = i.slice(0, i.lastIndexOf("/"))), (e = (null == (t = o[i].value) ? void 0 : t.line) === n.row && (null == (t = o[i].value) ? void 0 : t.line) === (null == (t = o[i].valueEnd) ? void 0 : t.line) && n.column >= o[i].value.column && n.column <= o[i].valueEnd.column ? i : e) && (t = l(e, c.suggestions, ""), r(t));
                                    });
                                });
                            } catch (e) {}
                        }
                    }
                ], s(e.prototype, t), n && s(e, n), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), e;
            })();
            function v(e) {
                return (v = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                })(e);
            }
            var t = {}, I = "ace/theme/jsoneditor";
            function b() {
                try {
                    this.format();
                } catch (e) {}
            }
            t.create = function(e) {
                var t, i, n, o = this, r = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {}, s = (void 0 === r.statusBar && (r.statusBar = !0), r.mainMenuBar = !1 !== r.mainMenuBar, r.enableSort = !1 !== r.enableSort, r.enableTransform = !1 !== r.enableTransform, r.createQuery = r.createQuery || u.V, r.executeQuery = r.executeQuery || u.e, r.showErrorTable = void 0 !== r.showErrorTable ? r.showErrorTable : [
                    "text",
                    "preview"
                ], this.options = r, this.indentation = "number" == typeof r.indentation ? Number(r.indentation) : 2, (0, d.AI)(this.options.languages), (0, d.xC)(this.options.language), r.ace || l()), a = (this.mode = "code" === r.mode ? "code" : "text", "code" === this.mode && void 0 === s && (this.mode = "text", console.warn("Failed to load Ace editor, falling back to plain text mode. Please use a JSONEditor bundle including Ace, or pass Ace as via the configuration option `ace`.")), this.theme = r.theme || I, this.theme === I && s && (0, m.J)(), r.onTextSelectionChange && this.onTextSelectionChange(r.onTextSelectionChange), this), e = (this.container = e, this.dom = {}, this.aceEditor = void 0, this.textarea = void 0, this.validateSchema = null, this.annotations = [], this.lastSchemaErrors = void 0, this._debouncedValidate = (0, C.debounce)(this._validateAndCatch.bind(this), this.DEBOUNCE_INTERVAL), this.width = e.clientWidth, this.height = e.clientHeight, this.frame = document.createElement("div"), this.frame.className = "jsoneditor jsoneditor-mode-" + this.options.mode, this.frame.onclick = function(e) {
                    e.preventDefault();
                }, this.frame.onkeydown = function(e) {
                    a._onKeyDown(e);
                }, {
                    target: this.frame,
                    onFocus: this.options.onFocus || null,
                    onBlur: this.options.onBlur || null
                }), e = (this.frameFocusTracker = new h.$(e), this.content = document.createElement("div"), this.content.className = "jsoneditor-outer", this.options.mainMenuBar && ((0, C.addClassName)(this.content, "has-main-menu-bar"), this.menu = document.createElement("div"), this.menu.className = "jsoneditor-menu", this.frame.appendChild(this.menu), (e = document.createElement("button")).type = "button", e.className = "jsoneditor-format", e.title = (0, d.Tl)("formatTitle"), this.menu.appendChild(e), e.onclick = function() {
                    try {
                        a.format(), a._onChange();
                    } catch (e) {
                        a._onError(e);
                    }
                }, (e = document.createElement("button")).type = "button", e.className = "jsoneditor-compact", e.title = (0, d.Tl)("compactTitle"), this.menu.appendChild(e), e.onclick = function() {
                    try {
                        a.compact(), a._onChange();
                    } catch (e) {
                        a._onError(e);
                    }
                }, this.options.enableSort && ((e = document.createElement("button")).type = "button", e.className = "jsoneditor-sort", e.title = (0, d.Tl)("sortTitleShort"), e.onclick = function() {
                    a._showSortModal();
                }, this.menu.appendChild(e)), this.options.enableTransform && ((e = document.createElement("button")).type = "button", e.title = (0, d.Tl)("transformTitleShort"), e.className = "jsoneditor-transform", e.onclick = function() {
                    a._showTransformModal();
                }, this.menu.appendChild(e)), (e = document.createElement("button")).type = "button", e.className = "jsoneditor-repair", e.title = (0, d.Tl)("repairTitle"), this.menu.appendChild(e), e.onclick = function() {
                    try {
                        a.repair(), a._onChange();
                    } catch (e) {
                        a._onError(e);
                    }
                }, "code" === this.mode && ((e = document.createElement("button")).type = "button", e.className = "jsoneditor-undo jsoneditor-separator", e.title = (0, d.Tl)("undo"), e.onclick = function() {
                    o.aceEditor.getSession().getUndoManager().undo();
                }, this.menu.appendChild(e), this.dom.undo = e, (e = document.createElement("button")).type = "button", e.className = "jsoneditor-redo", e.title = (0, d.Tl)("redo"), e.onclick = function() {
                    o.aceEditor.getSession().getUndoManager().redo();
                }, this.menu.appendChild(e), this.dom.redo = e), this.options && this.options.modes && this.options.modes.length && (this.modeSwitcher = new g.n(this.menu, this.options.modes, this.options.mode, function(e) {
                    try {
                        a.setMode(e), a.modeSwitcher.focus();
                    } catch (e) {
                        a._onError(e);
                    }
                })), "code" === this.mode) && ((t = document.createElement("a")).appendChild(document.createTextNode("powered by ace")), t.href = "https://ace.c9.io/", t.target = "_blank", t.className = "jsoneditor-poweredBy", t.onclick = function() {
                    window.open(t.href, t.target, "noreferrer");
                }, this.menu.appendChild(t)), this.options.onEditable && v("function" === this.options.onEditable) && !this.options.onEditable({})), s = (this.frame.appendChild(this.content), this.container.appendChild(this.frame), "code" === this.mode ? (this.editorDom = document.createElement("div"), this.editorDom.style.height = "100%", this.editorDom.style.width = "100%", this.content.appendChild(this.editorDom), n = (s = s.edit(this.editorDom)).getSession(), s.$blockScrolling = 1 / 0, s.setTheme(this.theme), s.setOptions({
                    readOnly: e
                }), s.setShowPrintMargin(!1), s.setFontSize("14px"), n.setMode("ace/mode/json"), n.setTabSize(this.indentation), n.setUseSoftTabs(!0), n.setUseWrapMode(!0), i = n.setAnnotations, n.setAnnotations = function(e) {
                    i.call(this, e && e.length ? e : a.annotations);
                }, s.commands.bindKey("Ctrl-L", null), s.commands.bindKey("Command-L", null), s.commands.bindKey("Ctrl-\\", null), s.commands.bindKey("Command-\\", null), s.commands.bindKey("Ctrl-Shift-\\", null), s.commands.bindKey("Command-Shift-\\", null), (this.aceEditor = s).on("change", this._onChange.bind(this)), s.on("changeSelection", this._onSelect.bind(this))) : ((n = document.createElement("textarea")).className = "jsoneditor-text", n.spellcheck = !1, this.content.appendChild(n), this.textarea = n, this.textarea.readOnly = e, null === this.textarea.oninput ? this.textarea.oninput = this._onChange.bind(this) : this.textarea.onchange = this._onChange.bind(this), n.onselect = this._onSelect.bind(this), n.onmousedown = this._onMouseDown.bind(this), n.onblur = this._onBlur.bind(this)), this._updateHistoryButtons(), Array.isArray(this.options.showErrorTable) ? this.options.showErrorTable.includes(this.mode) : !0 === this.options.showErrorTable);
                this.errorTable = new c.N({
                    errorTableVisible: s,
                    onToggleVisibility: function() {
                        a._validateAndCatch();
                    },
                    onFocusLine: function(e) {
                        a.isFocused = !0, isNaN(e) || a.setTextSelection({
                            row: e,
                            column: 1
                        }, {
                            row: e,
                            column: 1e3
                        });
                    },
                    onChangeHeight: function(e) {
                        e = e + (a.dom.statusBar ? a.dom.statusBar.clientHeight : 0) + 1;
                        a.content.style.marginBottom = -e + "px", a.content.style.paddingBottom = e + "px";
                    }
                }), this.frame.appendChild(this.errorTable.getErrorTable()), r.statusBar && ((0, C.addClassName)(this.content, "has-status-bar"), this.curserInfoElements = {}, e = document.createElement("div"), (this.dom.statusBar = e).className = "jsoneditor-statusbar", this.frame.appendChild(e), (n = document.createElement("span")).className = "jsoneditor-curserinfo-label", n.innerText = "Ln:", (s = document.createElement("span")).className = "jsoneditor-curserinfo-val", s.innerText = "1", e.appendChild(n), e.appendChild(s), (r = document.createElement("span")).className = "jsoneditor-curserinfo-label", r.innerText = "Col:", (n = document.createElement("span")).className = "jsoneditor-curserinfo-val", n.innerText = "1", e.appendChild(r), e.appendChild(n), this.curserInfoElements.colVal = n, this.curserInfoElements.lnVal = s, (r = document.createElement("span")).className = "jsoneditor-curserinfo-label", r.innerText = "characters selected", r.style.display = "none", (n = document.createElement("span")).className = "jsoneditor-curserinfo-count", n.innerText = "0", n.style.display = "none", this.curserInfoElements.countLabel = r, this.curserInfoElements.countVal = n, e.appendChild(n), e.appendChild(r), e.appendChild(this.errorTable.getErrorCounter()), e.appendChild(this.errorTable.getWarningIcon()), e.appendChild(this.errorTable.getErrorIcon())), this.setSchema(this.options.schema, this.options.schemaRefs);
            }, t._onSchemaChange = function(e, t) {
                this.aceEditor && (this.options.allowSchemaSuggestions && e ? (this.aceEditor.setOption("enableBasicAutocompletion", [
                    new y(e, t)
                ]), this.aceEditor.setOption("enableLiveAutocompletion", !0)) : (this.aceEditor.setOption("enableBasicAutocompletion", void 0), this.aceEditor.setOption("enableLiveAutocompletion", !1)));
            }, t._onChange = function() {
                var e = this;
                if (!this.onChangeDisabled) {
                    if (setTimeout(function() {
                        e._updateHistoryButtons && e._updateHistoryButtons();
                    }), this._debouncedValidate(), this.options.onChange) try {
                        this.options.onChange();
                    } catch (e) {
                        console.error("Error in onChange callback: ", e);
                    }
                    if (this.options.onChangeText) try {
                        this.options.onChangeText(this.getText());
                    } catch (e) {
                        console.error("Error in onChangeText callback: ", e);
                    }
                }
            }, t._updateHistoryButtons = function() {
                var e;
                this.aceEditor && this.dom.undo && this.dom.redo && (e = this.aceEditor.getSession().getUndoManager()) && e.hasUndo && e.hasRedo && (this.dom.undo.disabled = !e.hasUndo(), this.dom.redo.disabled = !e.hasRedo());
            }, t._showSortModal = function() {
                try {
                    var i = this, e = this.options.modalAnchor || a.ai, n = this.get();
                    (0, o.showSortModal)(e, n, function(e) {
                        var t;
                        Array.isArray(n) && (t = (0, C.sort)(n, e.path, e.direction), i.sortedBy = e, i.update(t)), (0, C.isObject)(n) && (t = (0, C.sortObjectKeys)(n, e.direction), i.sortedBy = e, i.update(t));
                    }, i.sortedBy);
                } catch (e) {
                    this._onError(e);
                }
            }, t._showTransformModal = function() {
                var t = this;
                try {
                    var e = this.options, i = e.modalAnchor, n = e.createQuery, o = e.executeQuery, r = e.queryDescription, s = this.get();
                    (0, p.showTransformModal)({
                        container: i || a.ai,
                        json: s,
                        queryDescription: r,
                        createQuery: n,
                        executeQuery: o,
                        onTransform: function(e) {
                            e = o(s, e);
                            t.update(e);
                        }
                    });
                } catch (e) {
                    this._onError(e);
                }
            }, t._onSelect = function() {
                this._updateCursorInfo(), this._emitSelectionChange();
            }, t._onKeyDown = function(e) {
                var t = !1;
                73 === (e.which || e.keyCode) && e.ctrlKey && (e.shiftKey ? this.compact() : this.format(), this._onChange(), t = !0), t && (e.preventDefault(), e.stopPropagation()), this._updateCursorInfo(), this._emitSelectionChange();
            }, t._onMouseDown = function() {
                this._updateCursorInfo(), this._emitSelectionChange();
            }, t._onBlur = function() {
                var e = this;
                setTimeout(function() {
                    e.isFocused || (e._updateCursorInfo(), e._emitSelectionChange()), e.isFocused = !1;
                });
            }, t._updateCursorInfo = function() {
                var e, t, i, n, o, r = this;
                function s() {
                    r.curserInfoElements.countVal.innerText !== o && (r.curserInfoElements.countVal.innerText = o, r.curserInfoElements.countVal.style.display = o ? "inline" : "none", r.curserInfoElements.countLabel.style.display = o ? "inline" : "none"), r.curserInfoElements.lnVal.innerText = i, r.curserInfoElements.colVal.innerText = n;
                }
                this.textarea ? setTimeout(function() {
                    var e = (0, C.getInputSelection)(r.textarea);
                    e.startIndex !== e.endIndex && (o = e.endIndex - e.startIndex), n = (o && r.cursorInfo && r.cursorInfo.line === e.end.row && r.cursorInfo.column === e.end.column ? (i = e.start.row, e.start) : (i = e.end.row, e.end)).column, r.cursorInfo = {
                        line: i,
                        column: n,
                        count: o
                    }, r.options.statusBar && s();
                }, 0) : this.aceEditor && this.curserInfoElements && (e = this.aceEditor.getCursorPosition(), t = this.aceEditor.getSelectedText(), i = e.row + 1, n = e.column + 1, o = t.length, r.cursorInfo = {
                    line: i,
                    column: n,
                    count: o
                }, this.options.statusBar) && s();
            }, t._emitSelectionChange = function() {
                var e;
                this._selectionChangedHandler && (e = this.getTextSelection(), this._selectionChangedHandler(e.start, e.end, e.text));
            }, t._refreshAnnotations = function() {
                var e, t = this.aceEditor && this.aceEditor.getSession();
                t && (e = t.getAnnotations().filter(function(e) {
                    return "error" === e.type;
                }), t.setAnnotations(e));
            }, t.destroy = function() {
                this.aceEditor && (this.aceEditor.destroy(), this.aceEditor = null), this.frame && this.container && this.frame.parentNode === this.container && this.container.removeChild(this.frame), this.modeSwitcher && (this.modeSwitcher.destroy(), this.modeSwitcher = null), this.textarea = null, this._debouncedValidate = null, this.frameFocusTracker.destroy();
            }, t.compact = function() {
                var e = this.get(), e = JSON.stringify(e);
                this.updateText(e);
            }, t.format = function() {
                var e = this.get(), e = JSON.stringify(e, null, this.indentation);
                this.updateText(e);
            }, t.repair = function() {
                var e = this.getText();
                try {
                    var t = (0, n.m)(e);
                    this.updateText(t);
                } catch (e) {}
            }, t.focus = function() {
                this.textarea && this.textarea.focus(), this.aceEditor && this.aceEditor.focus();
            }, t.resize = function() {
                this.aceEditor && this.aceEditor.resize(!1);
            }, t.set = function(e) {
                this.setText(JSON.stringify(e, null, this.indentation));
            }, t.update = function(e) {
                this.updateText(JSON.stringify(e, null, this.indentation));
            }, t.get = function() {
                var e = this.getText();
                return (0, C.parse)(e);
            }, t.getText = function() {
                return this.textarea ? this.textarea.value : this.aceEditor ? this.aceEditor.getValue() : "";
            }, t._setText = function(e, t) {
                var i, n = this, e = !0 === this.options.escapeUnicode ? (0, C.escapeUnicodeChars)(e) : e;
                this.textarea && (this.textarea.value = e), this.aceEditor && (this.onChangeDisabled = !0, this.aceEditor.setValue(e, -1), this.onChangeDisabled = !1, t && (i = this, setTimeout(function() {
                    i.aceEditor && i.aceEditor.session.getUndoManager().reset();
                })), setTimeout(function() {
                    n._updateHistoryButtons && n._updateHistoryButtons();
                })), this._debouncedValidate();
            }, t.setText = function(e) {
                this._setText(e, !0);
            }, t.updateText = function(e) {
                this.getText() !== e && this._setText(e, !1);
            }, t.validate = function() {
                var t, i = this, n = [], o = [];
                try {
                    var r = this.get(), s = (this.validateSchema && !this.validateSchema(r) && (n = this.validateSchema.errors.map(function(e) {
                        return e.type = "validation", (0, C.improveSchemaError)(e);
                    })), this.validationSequence = (this.validationSequence || 0) + 1, this), a = this.validationSequence;
                    return ((e, t)=>{
                        if (!t) return Promise.resolve([]);
                        try {
                            var i = t(e);
                            return ((0, C.isPromise)(i) ? i : Promise.resolve(i)).then(function(e) {
                                return Array.isArray(e) ? e.filter(function(e) {
                                    var t = (0, C.isValidValidationError)(e);
                                    return t || console.warn('Ignoring a custom validation error with invalid structure. Expected structure: {path: [...], message: "..."}. Actual error:', e), t;
                                }).map(function(e) {
                                    return {
                                        dataPath: (0, C.stringifyPath)(e.path),
                                        message: e.message,
                                        type: "customValidation"
                                    };
                                }) : [];
                            });
                        } catch (e) {
                            return Promise.reject(e);
                        }
                    })(r, this.options.onValidate).then(function(e) {
                        return a === s.validationSequence && (e = n.concat(o).concat(e), s._renderErrors(e), "function" == typeof i.options.onValidationError && (0, C.isValidationErrorChanged)(e, i.lastSchemaErrors) && i.options.onValidationError.call(i, e), i.lastSchemaErrors = e), i.lastSchemaErrors;
                    });
                } catch (e) {
                    return this.getText() && ((r = /\w*line\s*(\d+)\w*/g.exec(e.message)) && (t = +r[1]), o = [
                        {
                            type: "error",
                            message: e.message.replace(/\n/g, "<br>"),
                            line: t
                        }
                    ]), this._renderErrors(o), "function" == typeof this.options.onValidationError && (0, C.isValidationErrorChanged)(o, this.lastSchemaErrors) && this.options.onValidationError.call(this, o), this.lastSchemaErrors = o, Promise.resolve(this.lastSchemaErrors);
                }
            }, t._validateAndCatch = function() {
                this.validate().catch(function(e) {
                    console.error("Error running validation:", e);
                });
            }, t._renderErrors = function(n) {
                var e = this.getText(), t = [], e = (n.reduce(function(e, t) {
                    return "string" == typeof t.dataPath && -1 === e.indexOf(t.dataPath) && e.push(t.dataPath), e;
                }, t), (0, C.getPositionForPath)(e, t));
                this.aceEditor && (this.annotations = e.map(function(t) {
                    var e = n.filter(function(e) {
                        return e.dataPath === t.path;
                    }), i = e.map(function(e) {
                        return e.message;
                    }).join("\n");
                    return i ? {
                        row: t.line,
                        column: t.column,
                        text: "Schema validation error" + (1 !== e.length ? "s" : "") + ": \n" + i,
                        type: "warning",
                        source: "jsoneditor"
                    } : {};
                }), this._refreshAnnotations()), this.errorTable.setErrors(n, e), this.aceEditor && this.aceEditor.resize(!1);
            }, t.getTextSelection = function() {
                var e, t, i, n = {};
                return this.textarea ? (i = (0, C.getInputSelection)(this.textarea), this.cursorInfo && this.cursorInfo.line === i.end.row && this.cursorInfo.column === i.end.column ? (n.start = i.end, n.end = i.start) : n = i, {
                    start: n.start,
                    end: n.end,
                    text: this.textarea.value.substring(i.startIndex, i.endIndex)
                }) : this.aceEditor ? (i = this.aceEditor.getSelection(), e = this.aceEditor.getSelectedText(), t = i.getRange(), (i = i.getSelectionLead()).row === t.end.row && i.column === t.end.column ? n = t : (n.start = t.end, n.end = t.start), {
                    start: {
                        row: n.start.row + 1,
                        column: n.start.column + 1
                    },
                    end: {
                        row: n.end.row + 1,
                        column: n.end.column + 1
                    },
                    text: e
                }) : void 0;
            }, t.onTextSelectionChange = function(e) {
                "function" == typeof e && (this._selectionChangedHandler = (0, C.debounce)(e, this.DEBOUNCE_INTERVAL));
            }, t.setTextSelection = function(e, t) {
                var i, n, o;
                e && t && (this.textarea ? (i = (0, C.getIndexForPosition)(this.textarea, e.row, e.column), o = (0, C.getIndexForPosition)(this.textarea, t.row, t.column), -1 < i && -1 < o && (this.textarea.setSelectionRange ? (this.textarea.focus(), this.textarea.setSelectionRange(i, o)) : this.textarea.createTextRange && ((n = this.textarea.createTextRange()).collapse(!0), n.moveEnd("character", o), n.moveStart("character", i), n.select()), o = (this.textarea.value.match(/\n/g) || []).length + 1, i = this.textarea.scrollHeight / o, n = e.row * i, this.textarea.scrollTop = n > this.textarea.clientHeight ? n - this.textarea.clientHeight / 2 : 0)) : this.aceEditor && (o = {
                    start: {
                        row: e.row - 1,
                        column: e.column - 1
                    },
                    end: {
                        row: t.row - 1,
                        column: t.column - 1
                    }
                }, this.aceEditor.selection.setRange(o), this.aceEditor.scrollToLine(e.row - 1, !0)));
            };
            var A = [
                {
                    mode: "text",
                    mixin: t,
                    data: "text",
                    load: b
                },
                {
                    mode: "code",
                    mixin: t,
                    data: "text",
                    load: b
                }
            ];
        },
        5633: function(B, e, t) {
            function i(e) {
                return (i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                })(e);
            }
            t.r(e), t.d(e, {
                treeModeMixins: function() {
                    return Q;
                }
            });
            function D(e) {
                return S(e) ? e : String(e);
            }
            function n(e, t, i, n) {
                var o, r, e = k(e, i);
                return S(t) ? (o = w(t), r = x(t), o = k(o, i), r = k(r, i), n(o, e) || n(r, e)) : n(k(String(t), i), e);
            }
            var w = function(e) {
                return null == e ? "" : "string" == typeof e ? e : e.text || "";
            }, x = function(e) {
                return null == e ? "" : "string" == typeof e ? e : e.value || e.text || "";
            }, S = function(e) {
                return null !== e && "object" === i(e);
            }, k = function() {
                var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : "";
                return (1 < arguments.length ? arguments[1] : void 0).caseSensitive ? e : e.toLowerCase();
            }, T = {
                start: function(e, t, i) {
                    return n(e, t, i, function(e, t) {
                        return 0 === e.indexOf(t);
                    });
                },
                contain: function(e, t, i) {
                    return n(e, t, i, function(e, t) {
                        return -1 < e.indexOf(t);
                    });
                }
            };
            function O(d) {
                (d = d || {}).filter = d.filter || "start", d.trigger = d.trigger || "keydown", d.confirmKeys = d.confirmKeys || [
                    39,
                    35,
                    9
                ], d.caseSensitive = d.caseSensitive || !1;
                var t, u, o = "", r = "", s = document.createElement("div"), g = (s.style.position = "relative", s.style.outline = "0", s.style.border = "0", s.style.margin = "0", s.style.padding = "0", document.createElement("div"));
                g.className = "autocomplete dropdown", g.style.position = "absolute", g.style.visibility = "hidden";
                function a(e) {
                    var t, i;
                    document.createRange ? ((t = document.createRange()).selectNodeContents(e), t.collapse(!1), (i = window.getSelection()).removeAllRanges(), i.addRange(t)) : document.selection && ((t = document.body.createTextRange()).moveToElementText(e), t.collapse(!1), t.select());
                }
                function p(e) {
                    return void 0 === t && ((t = document.createElement("span")).style.visibility = "hidden", t.style.position = "fixed", t.style.outline = "0", t.style.margin = "0", t.style.padding = "0", t.style.border = "0", t.style.left = "0", t.style.whiteSpace = "pre", t.style.fontSize = o, t.style.fontFamily = r, t.style.fontWeight = "normal", document.body.appendChild(t)), t.textContent = e, t.getBoundingClientRect().right;
                }
                var c, h, m, i, f, l = {
                    onArrowDown: function() {},
                    onArrowUp: function() {},
                    onEnter: function() {},
                    onTab: function() {},
                    startFrom: 0,
                    options: [],
                    element: null,
                    elementHint: null,
                    elementStyle: null,
                    wrapper: s,
                    show: function(e, t, i) {
                        var n = this;
                        this.startFrom = t, this.wrapper.remove(), this.elementHint && (this.elementHint.remove(), this.elementHint = null), "" === o && (o = window.getComputedStyle(e).getPropertyValue("font-size")), "" === r && (r = window.getComputedStyle(e).getPropertyValue("font-family")), g.style.marginLeft = "0", g.style.marginTop = e.getBoundingClientRect().height + "px", this.options = i.map(D), this.element !== e && (this.element = e, this.elementStyle = {
                            zIndex: this.element.style.zIndex,
                            position: this.element.style.position,
                            backgroundColor: this.element.style.backgroundColor,
                            borderColor: this.element.style.borderColor
                        }), this.element.style.zIndex = 3, this.element.style.position = "relative", this.element.style.backgroundColor = "transparent", this.element.style.borderColor = "transparent", this.elementHint = e.cloneNode(), this.elementHint.className = "autocomplete hint", this.elementHint.style.zIndex = 2, this.elementHint.style.position = "absolute", this.elementHint.onfocus = function() {
                            n.element.focus();
                        }, this.element.addEventListener && (this.element.removeEventListener("keydown", b), this.element.addEventListener("keydown", b, !1), this.element.removeEventListener("blur", A), this.element.addEventListener("blur", A, !1)), s.appendChild(this.elementHint), s.appendChild(g), e.parentElement.appendChild(s), this.repaint(e);
                    },
                    setText: function(e) {
                        this.element.innerText = e;
                    },
                    getText: function() {
                        return this.element.innerText;
                    },
                    hideDropDown: function() {
                        this.wrapper.remove(), this.elementHint && (this.elementHint.remove(), this.elementHint = null, C.hide(), this.element.style.zIndex = this.elementStyle.zIndex, this.element.style.position = this.elementStyle.position, this.element.style.backgroundColor = this.elementStyle.backgroundColor, this.element.style.borderColor = this.elementStyle.borderColor);
                    },
                    repaint: function(e) {
                        for(var e = (e = e.innerText).replace("\n", ""), t = this.options.length, i = e.substring(this.startFrom), n = (u = e.substring(0, this.startFrom), "function" == typeof d.filter ? d.filter : T[d.filter]), o = 0; o < t; o++){
                            var r = this.options[o];
                            if (n && n(i, r, d)) {
                                var s = w(r), r = x(r), a = "", l = k(i, d), c = k(s, d), h = k(r, d), a = 0 === c.indexOf(l) ? u + i + s.substring(i.length) : 0 === h.indexOf(l) ? u + i + r.substring(i.length) : u + i;
                                this.elementHint.innerText = a, this.elementHint.realInnerText = u + r;
                                break;
                            }
                        }
                        g.style.left = p(u) + "px", C.refresh(i, this.options), this.elementHint.style.width = p(this.elementHint.innerText) + 10 + "px", "hidden" !== g.style.visibility && (this.elementHint.style.width = p(this.elementHint.innerText) + g.clientWidth + "px");
                    }
                }, C = (c = g, h = [], m = 0, i = -1, f = {
                    rs: l,
                    hide: function() {
                        c.style.visibility = "hidden";
                    },
                    refresh: function(l, e) {
                        c.style.visibility = "hidden", m = 0, c.textContent = "";
                        var t = window.innerHeight || document.documentElement.clientHeight, i = c.parentNode.getBoundingClientRect(), n = i.top - 6, t = t - i.bottom - 6, o = (h = [], "function" == typeof d.filter ? d.filter : T[d.filter]), i = o ? e.filter(function(e) {
                            return o(l, e, d);
                        }) : [];
                        0 !== (h = i.map(function(e) {
                            var t, i, n, o = document.createElement("div"), r = (o.className = "item", o.onmouseover = y, o.onmouseout = v, o.onmousedown = I, o.__hint = e, o.textContent = "", t = l, n = d, a = w(e), e = x(e), s = k(t, n), r = k(a, n), e = k(e, n), n = -1, t = t.length, i = a, -1 < r.indexOf(s) ? (n = r.indexOf(s), i = a) : -1 < e.indexOf(s) && (n = e.indexOf(s), i = a), -1 < n ? {
                                beforeText: i.substring(0, n),
                                matchText: i.substring(n, n + t),
                                afterText: i.substring(n + t),
                                displayText: i
                            } : {
                                beforeText: "",
                                matchText: "",
                                afterText: i,
                                displayText: i
                            }), e = r.beforeText, s = r.matchText, a = r.afterText;
                            return e && o.appendChild(document.createTextNode(e)), s && ((n = document.createElement("b")).appendChild(document.createTextNode(s)), o.appendChild(n)), a && o.appendChild(document.createTextNode(a)), c.appendChild(o), o;
                        })).length && (e = x(h[0].__hint), i = S(h[0].__hint) && "text" in h[0].__hint, 1 !== h.length || k(l, d) !== k(e, d) || i) && (f.highlight(0), 3 * t < n ? (c.style.maxHeight = n + "px", c.style.top = "", c.style.bottom = "100%") : (c.style.top = "100%", c.style.bottom = "", c.style.maxHeight = t + "px"), c.style.visibility = "visible");
                    },
                    highlight: function(e) {
                        -1 !== i && h[i] && (h[i].className = "item"), h[e].className = "item hover", i = e;
                    },
                    move: function(e) {
                        return "hidden" === c.style.visibility ? "" : (m + e !== -1 && m + e !== h.length && (m += e, f.highlight(m)), h[m].__hint);
                    },
                    onmouseselection: function() {}
                });
                function y() {
                    this.style.backgroundColor = "#ddd";
                }
                function v() {
                    this.style.backgroundColor = "";
                }
                function I() {
                    f.hide(), f.onmouseselection(this.__hint, f.rs);
                }
                var b = (function(e) {
                    var t = (e = e || window.event).keyCode;
                    if (null != this.elementHint && 33 !== t && 34 !== t) {
                        if (27 === t) l.hideDropDown(), l.element.focus(), e.preventDefault(), e.stopPropagation();
                        else {
                            var i, n = (n = this.element.innerText).replace("\n", "");
                            if (0 <= d.confirmKeys.indexOf(t)) 9 === t && 0 === this.elementHint.innerText.length && l.onTab(), 0 < this.elementHint.innerText.length && this.element.innerText !== this.elementHint.realInnerText && (this.element.innerText = this.elementHint.realInnerText, l.hideDropDown(), a(this.element), 9 === t) && (l.element.focus(), e.preventDefault(), e.stopPropagation());
                            else if (13 === t) {
                                if (0 === this.elementHint.innerText.length) l.onEnter();
                                else {
                                    var o = "hidden" === g.style.visibility;
                                    if (C.hide(), o) return l.hideDropDown(), l.element.focus(), void l.onEnter();
                                    this.element.innerText = this.elementHint.realInnerText, l.hideDropDown(), a(this.element), e.preventDefault(), e.stopPropagation();
                                }
                            } else 40 === t ? (o = n.substring(this.startFrom), "" === (i = C.move(1)) && l.onArrowDown(), this.elementHint.innerText = u + o + w(i).substring(o.length), this.elementHint.realInnerText = u + x(i), e.preventDefault(), e.stopPropagation()) : 38 === t && (o = n.substring(this.startFrom), "" === (i = C.move(-1)) && l.onArrowUp(), this.elementHint.innerText = u + o + w(i).substring(o.length), this.elementHint.realInnerText = u + x(i), e.preventDefault(), e.stopPropagation());
                        }
                    }
                }).bind(l), A = function(e) {
                    l.hideDropDown();
                };
                return C.onmouseselection = function(e, t) {
                    e = x(e);
                    t.element.innerText = t.elementHint.innerText = u + e, t.hideDropDown(), window.setTimeout(function() {
                        t.element.focus(), a(t.element);
                    }, 1);
                }, l;
            }
            var s = t(6545), P = t(2877);
            function o(e) {
                return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                })(e);
            }
            function r(e, t) {
                for(var i = 0; i < t.length; i++){
                    var n = t[i];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, ((e)=>(e = ((e, t)=>{
                            if ("object" != o(e) || !e) return e;
                            var i = e[Symbol.toPrimitive];
                            if (void 0 === i) return ("string" === t ? String : Number)(e);
                            if ("object" != o(i = i.call(e, t || "default"))) return i;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        })(e, "string"), "symbol" == o(e) ? e : e + ""))(n.key), n);
                }
            }
            var H = (()=>{
                function e() {
                    if (!(this instanceof e)) throw new TypeError("Cannot call a class as a function");
                    this.locked = !1;
                }
                var t, i, n;
                return t = e, i = [
                    {
                        key: "highlight",
                        value: function(e) {
                            this.locked || (this.node !== e && (this.node && this.node.setHighlight(!1), this.node = e, this.node.setHighlight(!0)), this._cancelUnhighlight());
                        }
                    },
                    {
                        key: "unhighlight",
                        value: function() {
                            var e;
                            this.locked || (e = this).node && (this._cancelUnhighlight(), this.unhighlightTimer = setTimeout(function() {
                                e.node.setHighlight(!1), e.node = void 0, e.unhighlightTimer = void 0;
                            }, 0));
                        }
                    },
                    {
                        key: "_cancelUnhighlight",
                        value: function() {
                            this.unhighlightTimer && (clearTimeout(this.unhighlightTimer), this.unhighlightTimer = void 0);
                        }
                    },
                    {
                        key: "lock",
                        value: function() {
                            this.locked = !0;
                        }
                    },
                    {
                        key: "unlock",
                        value: function() {
                            this.locked = !1;
                        }
                    }
                ], r(t.prototype, i), n && r(t, n), Object.defineProperty(t, "prototype", {
                    writable: !1
                }), t;
            })(), a = t(3057), l = t(359), G = t(1389), e = t(1342), c = t.n(e), h = t(1925), E = t(6237);
            var F = t(2915), V = t(5609), d = t(660);
            function Z(e) {
                return ((e)=>{
                    if (Array.isArray(e)) return p(e);
                })(e) || ((e)=>{
                    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
                })(e) || u(e) || (()=>{
                    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                })();
            }
            function j(e, t) {
                return ((e)=>{
                    if (Array.isArray(e)) return e;
                })(e) || ((e, t)=>{
                    var i = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                    if (null != i) {
                        var n, o, r, s, a = [], l = !0, c = !1;
                        try {
                            if (r = (i = i.call(e)).next, 0 === t) {
                                if (Object(i) !== i) return;
                                l = !1;
                            } else for(; !(l = (n = r.call(i)).done) && (a.push(n.value), a.length !== t); l = !0);
                        } catch (e) {
                            c = !0, o = e;
                        } finally{
                            try {
                                if (!l && null != i.return && (s = i.return(), Object(s) !== s)) return;
                            } finally{
                                if (c) throw o;
                            }
                        }
                        return a;
                    }
                })(e, t) || u(e, t) || (()=>{
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                })();
            }
            function g(e, t) {
                var i, n, o, r, s = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                if (s) return o = (n = !0, false), {
                    s: function() {
                        s = s.call(e);
                    },
                    n: function() {
                        var e = s.next();
                        return n = e.done, e;
                    },
                    e: function(e) {
                        o = !0, i = e;
                    },
                    f: function() {
                        try {
                            n || null == s.return || s.return();
                        } finally{
                            if (o) throw i;
                        }
                    }
                };
                if (Array.isArray(e) || (s = u(e)) || t && e && "number" == typeof e.length) return s && (e = s), r = 0, {
                    s: t = function() {},
                    n: function() {
                        return r >= e.length ? {
                            done: !0
                        } : {
                            done: !1,
                            value: e[r++]
                        };
                    },
                    e: function(e) {
                        throw e;
                    },
                    f: t
                };
                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function u(e, t) {
                var i;
                if (e) return "string" == typeof e ? p(e, t) : "Map" === (i = "Object" === (i = ({}).toString.call(e).slice(8, -1)) && e.constructor ? e.constructor.name : i) || "Set" === i ? Array.from(e) : "Arguments" === i || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i) ? p(e, t) : void 0;
            }
            function p(e, t) {
                (null == t || t > e.length) && (t = e.length);
                for(var i = 0, n = Array(t); i < t; i++)n[i] = e[i];
                return n;
            }
            function m(e) {
                return (m = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                })(e);
            }
            function f(e, t) {
                for(var i = 0; i < t.length; i++){
                    var n = t[i];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, ((e)=>(e = ((e, t)=>{
                            if ("object" != m(e) || !e) return e;
                            var i = e[Symbol.toPrimitive];
                            if (void 0 === i) return ("string" === t ? String : Number)(e);
                            if ("object" != m(i = i.call(e, t || "default"))) return i;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        })(e, "string"), "symbol" == m(e) ? e : e + ""))(n.key), n);
                }
            }
            var b = (()=>{
                function S(e, t) {
                    if (!(this instanceof S)) throw new TypeError("Cannot call a class as a function");
                    this.editor = e, this.dom = {}, this.expanded = !1, t && t instanceof Object ? (this.setField(t.field, t.fieldEditable), "value" in t && this.setValue(t.value, t.type), "internalValue" in t && this.setInternalValue(t.internalValue)) : (this.setField(""), this.setValue(null)), this._debouncedOnChangeValue = (0, E.debounce)(this._onChangeValue.bind(this), S.prototype.DEBOUNCE_INTERVAL), this._debouncedOnChangeField = (0, E.debounce)(this._onChangeField.bind(this), S.prototype.DEBOUNCE_INTERVAL), this.visibleChilds = this.getMaxVisibleChilds();
                }
                var e, t, i;
                return e = S, t = [
                    {
                        key: "getMaxVisibleChilds",
                        value: function() {
                            return this.editor && this.editor.options && this.editor.options.maxVisibleChilds ? this.editor.options.maxVisibleChilds : K;
                        }
                    },
                    {
                        key: "_updateEditability",
                        value: function() {
                            var e, t;
                            this.editable = {
                                field: !0,
                                value: !0
                            }, this.editor && (this.editable.field = "tree" === this.editor.options.mode, this.editable.value = "view" !== this.editor.options.mode, "tree" !== this.editor.options.mode && "form" !== this.editor.options.mode || "function" != typeof this.editor.options.onEditable || (e = this.getValue.bind(this), "boolean" == typeof (t = this.editor.options.onEditable({
                                field: this.field,
                                get value () {
                                    return e();
                                },
                                path: this.getPath()
                            })) ? (this.editable.field = t, this.editable.value = t) : "object" === m(t) && null !== t ? ("boolean" == typeof t.field && (this.editable.field = t.field), "boolean" == typeof t.value && (this.editable.value = t.value)) : (console.error("Invalid return value for function onEditable.", "Actual value:", t, ".", "Either a boolean or object { field: boolean, value: boolean } expected."), this.editable.field = !1, this.editable.value = !1)));
                        }
                    },
                    {
                        key: "getPath",
                        value: function() {
                            for(var e = this, t = []; e;){
                                var i = e.getName();
                                void 0 !== i && t.unshift(i), e = e.parent;
                            }
                            return t;
                        }
                    },
                    {
                        key: "getInternalPath",
                        value: function() {
                            for(var e = this, t = []; e;)e.parent && t.unshift(e.getIndex()), e = e.parent;
                            return t;
                        }
                    },
                    {
                        key: "getName",
                        value: function() {
                            return this.parent ? "array" !== this.parent.type ? this.field : this.index : void 0;
                        }
                    },
                    {
                        key: "findNodeByPath",
                        value: function(e) {
                            if (e) {
                                if (0 === e.length) return this;
                                if (e.length && this.childs && this.childs.length) {
                                    for(var t = 0; t < this.childs.length; ++t)if ("" + e[0] == "" + this.childs[t].getName()) return this.childs[t].findNodeByPath(e.slice(1));
                                }
                            }
                        }
                    },
                    {
                        key: "findNodeByInternalPath",
                        value: function(e) {
                            if (e) {
                                for(var t = this, i = 0; i < e.length && t; i++)t = t.childs[e[i]];
                                return t;
                            }
                        }
                    },
                    {
                        key: "serialize",
                        value: function() {
                            return {
                                value: this.getValue(),
                                path: this.getPath()
                            };
                        }
                    },
                    {
                        key: "findNode",
                        value: function(e) {
                            for(var i = (0, E.parsePath)(e), n = this; n && 0 < i.length;)(()=>{
                                var t = i.shift();
                                if ("number" == typeof t) {
                                    if ("array" !== n.type) throw new Error("Cannot get child node at index " + t + ": node is no array");
                                    n = n.childs[t];
                                } else {
                                    if ("object" !== n.type) throw new Error("Cannot get child node " + t + ": node is no object");
                                    n = n.childs.filter(function(e) {
                                        return e.field === t;
                                    })[0];
                                }
                            })();
                            return n;
                        }
                    },
                    {
                        key: "findParents",
                        value: function() {
                            for(var e = [], t = this.parent; t;)e.unshift(t), t = t.parent;
                            return e;
                        }
                    },
                    {
                        key: "setError",
                        value: function(e, t) {
                            this.error = e, this.errorChild = t, this.dom && this.dom.tr && this.updateError();
                        }
                    },
                    {
                        key: "updateError",
                        value: function() {
                            var i = this, n = this.fieldError || this.valueError || this.error, e = this.dom.tdError;
                            if (n && this.dom && this.dom.tr) {
                                (0, E.addClassName)(this.dom.tr, "jsoneditor-validation-error"), e || (e = document.createElement("td"), this.dom.tdError = e, this.dom.tdValue.parentNode.appendChild(e));
                                var o = document.createElement("button"), t = (o.type = "button", o.className = "jsoneditor-button jsoneditor-schema-error", function() {
                                    i.dom.popupAnchor && i.dom.popupAnchor.destroy();
                                }), r = function() {
                                    delete i.dom.popupAnchor;
                                }, s = function(e) {
                                    var t = i.editor.frame, e = (i.dom.popupAnchor = (0, h.p)(o, i.editor.getPopupAnchor(), r, e), o.getBoundingClientRect()), t = 120 < t.getBoundingClientRect().width - e.x ? "jsoneditor-above" : "jsoneditor-left", e = document.createElement("div");
                                    e.className = "jsoneditor-popover " + t, e.appendChild(document.createTextNode(n.message)), i.dom.popupAnchor.appendChild(e);
                                }, a = (o.onmouseover = function() {
                                    i.dom.popupAnchor || s(!0);
                                }, o.onfocus = function() {
                                    t(), s(!1);
                                }, o.onblur = function() {
                                    t();
                                }, this.errorChild);
                                for(a && (o.onclick = function() {
                                    a.findParents().forEach(function(e) {
                                        e.expand(!1);
                                    }), a.scrollTo(function() {
                                        a.focus();
                                    });
                                }); e.firstChild;)e.removeChild(e.firstChild);
                                e.appendChild(o);
                            } else this.dom.tr && (0, E.removeClassName)(this.dom.tr, "jsoneditor-validation-error"), e && (this.dom.tdError.parentNode.removeChild(this.dom.tdError), delete this.dom.tdError);
                        }
                    },
                    {
                        key: "getIndex",
                        value: function() {
                            var e;
                            return this.parent ? -1 !== (e = this.parent.childs.indexOf(this)) ? e : null : -1;
                        }
                    },
                    {
                        key: "setParent",
                        value: function(e) {
                            this.parent = e;
                        }
                    },
                    {
                        key: "setField",
                        value: function(e, t) {
                            this.field = e, this.previousField = e, this.fieldEditable = !0 === t;
                        }
                    },
                    {
                        key: "getField",
                        value: function() {
                            return void 0 === this.field && this._getDomField(), this.field;
                        }
                    },
                    {
                        key: "setValue",
                        value: function(e, t) {
                            var i, n, o, r, s, a, l = this.childs;
                            if (this.type = this._getType(e), t && t !== this.type) {
                                if ("string" !== t || "auto" !== this.type) throw new Error('Type mismatch: cannot cast value of type "' + this.type + ' to the specified type "' + t + '"');
                                this.type = t;
                            }
                            if ("array" === this.type) {
                                for(this.childs || (this.childs = []), i = 0; i < e.length; i++)void 0 === (s = e[i]) || s instanceof Function || (i < this.childs.length ? ((o = this.childs[i]).fieldEditable = !1, o.index = i, o.setValue(s)) : (o = new S(this.editor, {
                                    value: s
                                }), r = i < this.getMaxVisibleChilds(), this.appendChild(o, r, !1)));
                                for(n = this.childs.length; n >= e.length; n--)this.removeChild(this.childs[n], !1);
                            } else if ("object" === this.type) {
                                for(this.childs || (this.childs = []), n = this.childs.length - 1; 0 <= n; n--)y(e, this.childs[n].field) || this.removeChild(this.childs[n], !1);
                                for(var c in i = 0, e)y(e, c) && (void 0 === (s = e[c]) || s instanceof Function || ((a = this.findChildByProperty(c)) ? (a.setField(c, !0), a.setValue(s)) : (a = new S(this.editor, {
                                    field: c,
                                    value: s
                                }), c = i < this.getMaxVisibleChilds(), this.appendChild(a, c, !1))), i++);
                                (this.value = "", true) === this.editor.options.sortObjectKeys && this.sort([], "asc", !1);
                            } else this.hideChilds(), delete this.append, delete this.showMore, delete this.expanded, delete this.childs, this.value = e;
                            Array.isArray(l) !== Array.isArray(this.childs) && this.recreateDom(), this.updateDom({
                                updateIndexes: !0
                            }), this.previousValue = this.value;
                        }
                    },
                    {
                        key: "setInternalValue",
                        value: function(e) {
                            var t, i, n, o, r, s = this.childs;
                            if (this.type = e.type, "array" === e.type) {
                                for(this.childs || (this.childs = []), o = 0; o < e.childs.length; o++)void 0 === (t = e.childs[o]) || t instanceof Function || (o < this.childs.length ? ((i = this.childs[o]).fieldEditable = !1, i.index = o, i.setInternalValue(t)) : (i = new S(this.editor, {
                                    internalValue: t
                                }), n = o < this.getMaxVisibleChilds(), this.appendChild(i, n, !1)));
                                for(r = this.childs.length; r >= e.childs.length; r--)this.removeChild(this.childs[r], !1);
                            } else if ("object" === e.type) {
                                for(this.childs || (this.childs = []), o = 0; o < e.childs.length; o++)void 0 === (t = e.childs[o]) || t instanceof Function || (o < this.childs.length ? (delete (i = this.childs[o]).index, i.setField(t.field, !0), i.setInternalValue(t.value)) : (i = new S(this.editor, {
                                    field: t.field,
                                    internalValue: t.value
                                }), n = o < this.getMaxVisibleChilds(), this.appendChild(i, n, !1)));
                                for(r = this.childs.length; r >= e.childs.length; r--)this.removeChild(this.childs[r], !1);
                            } else this.hideChilds(), delete this.append, delete this.showMore, delete this.expanded, delete this.childs, this.value = e.value;
                            Array.isArray(s) !== Array.isArray(this.childs) && this.recreateDom(), this.updateDom({
                                updateIndexes: !0
                            }), this.previousValue = this.value;
                        }
                    },
                    {
                        key: "recreateDom",
                        value: function() {
                            var e;
                            this.dom && this.dom.tr && this.dom.tr.parentNode ? (e = this._detachFromDom(), this.clearDom(), this._attachToDom(e)) : this.clearDom();
                        }
                    },
                    {
                        key: "getValue",
                        value: function() {
                            var t, i;
                            return "array" === this.type ? (t = [], this.childs.forEach(function(e) {
                                t.push(e.getValue());
                            }), t) : "object" === this.type ? (i = {}, this.childs.forEach(function(e) {
                                i[e.getField()] = e.getValue();
                            }), i) : (void 0 === this.value && this._getDomValue(), this.value);
                        }
                    },
                    {
                        key: "getInternalValue",
                        value: function() {
                            return "array" === this.type ? {
                                type: this.type,
                                childs: this.childs.map(function(e) {
                                    return e.getInternalValue();
                                })
                            } : "object" === this.type ? {
                                type: this.type,
                                childs: this.childs.map(function(e) {
                                    return {
                                        field: e.getField(),
                                        value: e.getInternalValue()
                                    };
                                })
                            } : (void 0 === this.value && this._getDomValue(), {
                                type: this.type,
                                value: this.value
                            });
                        }
                    },
                    {
                        key: "getLevel",
                        value: function() {
                            return this.parent ? this.parent.getLevel() + 1 : 0;
                        }
                    },
                    {
                        key: "getNodePath",
                        value: function() {
                            var e = this.parent ? this.parent.getNodePath() : [];
                            return e.push(this), e;
                        }
                    },
                    {
                        key: "clone",
                        value: function() {
                            var t, i;
                            return (t = new S(this.editor)).type = this.type, t.field = this.field, t.fieldInnerText = this.fieldInnerText, t.fieldEditable = this.fieldEditable, t.previousField = this.previousField, t.value = this.value, t.valueInnerText = this.valueInnerText, t.previousValue = this.previousValue, t.expanded = this.expanded, t.visibleChilds = this.visibleChilds, this.childs ? (i = [], this.childs.forEach(function(e) {
                                e = e.clone();
                                e.setParent(t), i.push(e);
                            }), t.childs = i) : t.childs = void 0, t;
                        }
                    },
                    {
                        key: "expand",
                        value: function(t) {
                            this.childs && (this.expanded = !0, this.dom.expand && (this.dom.expand.className = "jsoneditor-button jsoneditor-expanded"), this.showChilds(), !1 !== t && this.childs.forEach(function(e) {
                                e.expand(t);
                            }), this.updateDom({
                                recurse: !1
                            }));
                        }
                    },
                    {
                        key: "collapse",
                        value: function(t) {
                            this.childs && (this.hideChilds(), !1 !== t && this.childs.forEach(function(e) {
                                e.collapse(t);
                            }), this.dom.expand && (this.dom.expand.className = "jsoneditor-button jsoneditor-collapsed"), this.expanded = !1, this.updateDom({
                                recurse: !1
                            }));
                        }
                    },
                    {
                        key: "showChilds",
                        value: function() {
                            var e = this.childs;
                            if (e && this.expanded) {
                                var e = this.dom.tr, t = e ? e.parentNode : void 0;
                                if (t) {
                                    for(var i = this.getAppendDom(), n = (i.parentNode || ((o = e.nextSibling) ? t.insertBefore(i, o) : t.appendChild(i)), Math.min(this.childs.length, this.visibleChilds)), o = this._getNextTr(), r = 0; r < n; r++){
                                        var s = this.childs[r];
                                        s.getDom().parentNode || t.insertBefore(s.getDom(), o), s.showChilds();
                                    }
                                    e = this.getShowMoreDom();
                                    o = this._getNextTr(), e.parentNode || t.insertBefore(e, o), this.showMore.updateDom();
                                }
                            }
                        }
                    },
                    {
                        key: "_getNextTr",
                        value: function() {
                            return this.showMore && this.showMore.getDom().parentNode ? this.showMore.getDom() : this.append && this.append.getDom().parentNode ? this.append.getDom() : void 0;
                        }
                    },
                    {
                        key: "hide",
                        value: function(e) {
                            var t = this.dom.tr, i = t ? t.parentNode : void 0;
                            i && i.removeChild(t), this.dom.popupAnchor && this.dom.popupAnchor.destroy(), this.hideChilds(e);
                        }
                    },
                    {
                        key: "hideChilds",
                        value: function(e) {
                            var t;
                            this.childs && this.expanded && ((t = this.getAppendDom()).parentNode && t.parentNode.removeChild(t), this.childs.forEach(function(e) {
                                e.hide();
                            }), (t = this.getShowMoreDom()).parentNode && t.parentNode.removeChild(t), e && !e.resetVisibleChilds || (this.visibleChilds = this.getMaxVisibleChilds()));
                        }
                    },
                    {
                        key: "_updateCssClassName",
                        value: function() {
                            var e, t;
                            this.dom.field && this.editor && this.editor.options && "function" == typeof this.editor.options.onClassName && this.dom.tree && ((0, E.removeAllClassNames)(this.dom.tree), e = this.getValue.bind(this), t = this.editor.options.onClassName({
                                path: this.getPath(),
                                field: this.field,
                                get value () {
                                    return e();
                                }
                            }) || "", (0, E.addClassName)(this.dom.tree, "jsoneditor-values " + t));
                        }
                    },
                    {
                        key: "recursivelyUpdateCssClassesOnNodes",
                        value: function() {
                            if (this._updateCssClassName(), Array.isArray(this.childs)) for(var e = 0; e < this.childs.length; e++)this.childs[e].recursivelyUpdateCssClassesOnNodes();
                        }
                    },
                    {
                        key: "expandTo",
                        value: function() {
                            for(var e = this.parent; e;)e.expanded || e.expand(), e = e.parent;
                        }
                    },
                    {
                        key: "appendChild",
                        value: function(e, t, i) {
                            var n, o;
                            this._hasChilds() && (e.setParent(this), e.fieldEditable = "object" === this.type, "array" === this.type && (e.index = this.childs.length), "object" === this.type && void 0 === e.field && e.setField(""), this.childs.push(e), this.expanded && !1 !== t && (t = e.getDom(), o = (n = this._getNextTr()) ? n.parentNode : void 0, n && o && o.insertBefore(t, n), e.showChilds(), this.visibleChilds++), !1 !== i) && (this.updateDom({
                                updateIndexes: !0
                            }), e.updateDom({
                                recurse: !0
                            }));
                        }
                    },
                    {
                        key: "moveBefore",
                        value: function(e, t, i) {
                            var n, o, r;
                            this._hasChilds() && ((n = this.dom.tr ? this.dom.tr.parentNode : void 0) && ((o = document.createElement("tr")).style.height = n.clientHeight + "px", n.appendChild(o)), e.parent && e.parent.removeChild(e), t instanceof $ || !t ? this.childs.length + 1 > this.visibleChilds ? (r = this.childs[this.visibleChilds - 1], this.insertBefore(e, r, i)) : this.appendChild(e, !0, i) : this.insertBefore(e, t, i), n) && o && n.removeChild(o);
                        }
                    },
                    {
                        key: "insertBefore",
                        value: function(e, t, i) {
                            if (this._hasChilds()) {
                                if (this.visibleChilds++, "object" === this.type && void 0 === e.field && e.setField(""), t === this.append) e.setParent(this), e.fieldEditable = "object" === this.type, this.childs.push(e);
                                else {
                                    var n = this.childs.indexOf(t);
                                    if (-1 === n) throw new Error("Node not found");
                                    e.setParent(this), e.fieldEditable = "object" === this.type, this.childs.splice(n, 0, e);
                                }
                                var o;
                                this.expanded && (n = e.getDom(), o = (t = t.getDom()) ? t.parentNode : void 0, t && o && o.insertBefore(n, t), e.showChilds(), this.showChilds()), !1 !== i && (this.updateDom({
                                    updateIndexes: !0
                                }), e.updateDom({
                                    recurse: !0
                                }));
                            }
                        }
                    },
                    {
                        key: "insertAfter",
                        value: function(e, t) {
                            this._hasChilds() && (t = this.childs.indexOf(t), (t = this.childs[t + 1]) ? this.insertBefore(e, t) : this.appendChild(e));
                        }
                    },
                    {
                        key: "search",
                        value: function(t, i) {
                            Array.isArray(i) || (i = []);
                            var e = t ? t.toLowerCase() : void 0;
                            return delete this.searchField, delete this.searchValue, void 0 !== this.field && i.length <= this.MAX_SEARCH_RESULTS && (-1 !== String(this.field).toLowerCase().indexOf(e) && (this.searchField = !0, i.push({
                                node: this,
                                elem: "field"
                            })), this._updateDomField()), this._hasChilds() ? this.childs && this.childs.forEach(function(e) {
                                e.search(t, i);
                            }) : void 0 !== this.value && i.length <= this.MAX_SEARCH_RESULTS && (-1 !== String(this.value).toLowerCase().indexOf(e) && (this.searchValue = !0, i.push({
                                node: this,
                                elem: "value"
                            })), this._updateDomValue()), i;
                        }
                    },
                    {
                        key: "scrollTo",
                        value: function(e) {
                            this.expandPathToNode(), this.dom.tr && this.dom.tr.parentNode && this.editor.scrollTo(this.dom.tr.offsetTop, e);
                        }
                    },
                    {
                        key: "expandPathToNode",
                        value: function() {
                            for(var e = this; e && e.parent;){
                                for(var t = "array" === e.parent.type ? e.index : e.parent.childs.indexOf(e); e.parent.visibleChilds < t + 1;)e.parent.visibleChilds += this.getMaxVisibleChilds();
                                e.parent.expand(!1), e = e.parent;
                            }
                        }
                    },
                    {
                        key: "focus",
                        value: function(e) {
                            if (S.focusElement = e, this.dom.tr && this.dom.tr.parentNode) {
                                var t = this.dom;
                                switch(e){
                                    case "drag":
                                        (t.drag || t.menu).focus();
                                        break;
                                    case "menu":
                                        t.menu.focus();
                                        break;
                                    case "expand":
                                        this._hasChilds() ? t.expand.focus() : t.field && this.fieldEditable ? (t.field.focus(), (0, E.selectContentEditable)(t.field)) : t.value && !this._hasChilds() ? (t.value.focus(), (0, E.selectContentEditable)(t.value)) : t.menu.focus();
                                        break;
                                    case "field":
                                        t.field && this.fieldEditable ? (t.field.focus(), (0, E.selectContentEditable)(t.field)) : t.value && !this._hasChilds() ? (t.value.focus(), (0, E.selectContentEditable)(t.value)) : (this._hasChilds() ? t.expand : t.menu).focus();
                                        break;
                                    default:
                                        t.select ? t.select.focus() : t.value && !this._hasChilds() ? (t.value.focus(), (0, E.selectContentEditable)(t.value)) : t.field && this.fieldEditable ? (t.field.focus(), (0, E.selectContentEditable)(t.field)) : (this._hasChilds() ? t.expand : t.menu).focus();
                                }
                            }
                        }
                    },
                    {
                        key: "containsNode",
                        value: function(e) {
                            if (this === e) return !0;
                            var t = this.childs;
                            if (t) {
                                for(var i = 0, n = t.length; i < n; i++)if (t[i].containsNode(e)) return !0;
                            }
                            return !1;
                        }
                    },
                    {
                        key: "removeChild",
                        value: function(e, t) {
                            if (this.childs) {
                                var i = this.childs.indexOf(e);
                                if (-1 !== i) return i < this.visibleChilds && this.expanded && this.visibleChilds--, e.hide(), delete e.searchField, delete e.searchValue, (e = this.childs.splice(i, 1)[0]).parent = null, !1 !== t && this.updateDom({
                                    updateIndexes: !0
                                }), e;
                            }
                        }
                    },
                    {
                        key: "_remove",
                        value: function(e) {
                            this.removeChild(e);
                        }
                    },
                    {
                        key: "changeType",
                        value: function(e) {
                            var t, i = this.type;
                            i !== e && ("string" !== e && "auto" !== e || "string" !== i && "auto" !== i ? (t = this._detachFromDom(), this.clearDom(), "object" === (this.type = e) ? (this.childs || (this.childs = []), this.childs.forEach(function(e) {
                                e.clearDom(), delete e.index, e.fieldEditable = !0, void 0 === e.field && (e.field = "");
                            }), "string" !== i && "auto" !== i || (this.expanded = !0)) : "array" === e ? (this.childs || (this.childs = []), this.childs.forEach(function(e, t) {
                                e.clearDom(), e.fieldEditable = !1, e.index = t;
                            }), "string" !== i && "auto" !== i || (this.expanded = !0)) : this.expanded = !1, this._attachToDom(t)) : this.type = e, "auto" !== e && "string" !== e || (this.value = "string" === e ? String(this.value) : (0, E.parseString)(String(this.value)), this.focus()), this.updateDom({
                                updateIndexes: !0
                            }));
                        }
                    },
                    {
                        key: "deepEqual",
                        value: function(e) {
                            var t;
                            if ("array" === this.type) {
                                if (!Array.isArray(e)) return !1;
                                if (this.childs.length !== e.length) return !1;
                                for(t = 0; t < this.childs.length; t++)if (!this.childs[t].deepEqual(e[t])) return !1;
                            } else if ("object" === this.type) {
                                if ("object" !== m(e) || !e) return !1;
                                var i = Object.keys(e);
                                if (this.childs.length !== i.length) return !1;
                                for(t = 0; t < i.length; t++){
                                    var n = this.childs[t];
                                    if (n.field !== i[t] || !n.deepEqual(e[n.field])) return !1;
                                }
                            } else if (this.value !== e) return !1;
                            return !0;
                        }
                    },
                    {
                        key: "_getDomValue",
                        value: function() {
                            if (this._clearValueError(), this.dom.value && "array" !== this.type && "object" !== this.type && (this.valueInnerText = (0, E.getInnerText)(this.dom.value), "" === this.valueInnerText) && "" !== this.dom.value.innerHTML && (this.dom.value.textContent = ""), void 0 !== this.valueInnerText) try {
                                var e, t;
                                (t = "string" === this.type ? this._unescapeHTML(this.valueInnerText) : (e = this._unescapeHTML(this.valueInnerText), (0, E.parseString)(e))) !== this.value && (this.value = t, this._debouncedOnChangeValue());
                            } catch (e) {
                                this._setValueError((0, a.Tl)("cannotParseValueError"));
                            }
                        }
                    },
                    {
                        key: "_setValueError",
                        value: function(e) {
                            this.valueError = {
                                message: e
                            }, this.updateError();
                        }
                    },
                    {
                        key: "_clearValueError",
                        value: function() {
                            this.valueError && (this.valueError = null, this.updateError());
                        }
                    },
                    {
                        key: "_setFieldError",
                        value: function(e) {
                            this.fieldError = {
                                message: e
                            }, this.updateError();
                        }
                    },
                    {
                        key: "_clearFieldError",
                        value: function() {
                            this.fieldError && (this.fieldError = null, this.updateError());
                        }
                    },
                    {
                        key: "_onChangeValue",
                        value: function() {
                            var e, t = this.editor.getDomSelection(), i = (t.range && (i = (0, E.textDiff)(String(this.value), String(this.previousValue)), t.range.startOffset = i.start, t.range.endOffset = i.end), this.editor.getDomSelection());
                            i.range && (e = (0, E.textDiff)(String(this.previousValue), String(this.value)), i.range.startOffset = e.start, i.range.endOffset = e.end), this.editor._onAction("editValue", {
                                path: this.getInternalPath(),
                                oldValue: this.previousValue,
                                newValue: this.value,
                                oldSelection: t,
                                newSelection: i
                            }), this.previousValue = this.value;
                        }
                    },
                    {
                        key: "_onChangeField",
                        value: function() {
                            var e = this.editor.getDomSelection(), t = this.previousField || "", i = (e.range && (i = (0, E.textDiff)(this.field, t), e.range.startOffset = i.start, e.range.endOffset = i.end), this.editor.getDomSelection());
                            i.range && (t = (0, E.textDiff)(t, this.field), i.range.startOffset = t.start, i.range.endOffset = t.end), this.editor._onAction("editField", {
                                parentPath: this.parent.getInternalPath(),
                                index: this.getIndex(),
                                oldValue: this.previousField,
                                newValue: this.field,
                                oldSelection: e,
                                newSelection: i
                            }), this.previousField = this.field;
                        }
                    },
                    {
                        key: "_updateDomValue",
                        value: function() {
                            var e = this.dom.value;
                            if (e) {
                                var t = [
                                    "jsoneditor-value"
                                ], i = this.value, n = "auto" === this.type ? (0, E.getType)(i) : this.type, o = "string" === n && (0, E.isUrl)(i);
                                if (t.push("jsoneditor-" + n), o && t.push("jsoneditor-url"), "" === String(this.value) && "array" !== this.type && "object" !== this.type && t.push("jsoneditor-empty"), this.searchValueActive && t.push("jsoneditor-highlight-active"), this.searchValue && t.push("jsoneditor-highlight"), e.className = t.join(" "), "array" === n || "object" === n ? (t = this.childs ? this.childs.length : 0, e.title = this.type + " containing " + t + " items") : o && this.editable.value ? e.title = (0, a.Tl)("openUrl") : e.title = "", "boolean" === n && this.editable.value ? (this.dom.checkbox || (this.dom.checkbox = document.createElement("input"), this.dom.checkbox.type = "checkbox", this.dom.tdCheckbox = document.createElement("td"), this.dom.tdCheckbox.className = "jsoneditor-tree", this.dom.tdCheckbox.appendChild(this.dom.checkbox), this.dom.tdValue.parentNode.insertBefore(this.dom.tdCheckbox, this.dom.tdValue)), this.dom.checkbox.checked = this.value) : this.dom.tdCheckbox && (this.dom.tdCheckbox.parentNode.removeChild(this.dom.tdCheckbox), delete this.dom.tdCheckbox, delete this.dom.checkbox), this.enum && this.editable.value ? (this.dom.select || (this.dom.select = document.createElement("select"), this.id = this.field + "_" + (new Date).getUTCMilliseconds(), this.dom.select.id = this.id, this.dom.select.name = this.dom.select.id, (t = document.createElement("option")).value = "", t.textContent = "--", this.dom.select.appendChild(t), this._updateEnumOptions(), this.dom.tdSelect = document.createElement("td"), this.dom.tdSelect.className = "jsoneditor-tree", this.dom.tdSelect.appendChild(this.dom.select), this.dom.tdValue.parentNode.insertBefore(this.dom.tdSelect, this.dom.tdValue)), this.dom.select.value = -1 !== this.enum.indexOf(this.value) ? this.value : "", !this.schema || y(this.schema, "oneOf") || y(this.schema, "anyOf") || y(this.schema, "allOf") ? delete this.valueFieldHTML : (this.valueFieldHTML = this.dom.tdValue.innerHTML, this.dom.tdValue.style.visibility = "hidden", this.dom.tdValue.textContent = "")) : this.dom.tdSelect && (this.dom.tdSelect.parentNode.removeChild(this.dom.tdSelect), delete this.dom.tdSelect, delete this.dom.select, this.dom.tdValue.innerHTML = this.valueFieldHTML, this.dom.tdValue.style.visibility = "", delete this.valueFieldHTML, this.dom.tdValue.appendChild(this.dom.value)), this.editor.options.colorPicker && "string" == typeof i && (0, E.isValidColor)(i) ? (this.dom.color || (this.dom.color = document.createElement("div"), this.dom.color.className = "jsoneditor-color", this.dom.tdColor = document.createElement("td"), this.dom.tdColor.className = "jsoneditor-tree", this.dom.tdColor.appendChild(this.dom.color), this.dom.tdValue.parentNode.insertBefore(this.dom.tdColor, this.dom.tdValue)), (0, E.addClassName)(this.dom.value, "jsoneditor-color-value"), (this.editable.value ? (0, E.removeClassName) : (0, E.addClassName))(this.dom.color, "jsoneditor-color-readonly"), this.dom.color.style.backgroundColor = i) : this._deleteDomColor(), this._showTimestampTag()) {
                                    this.dom.date || (this.dom.date = document.createElement("div"), this.dom.date.className = "jsoneditor-date", this.dom.value.parentNode.appendChild(this.dom.date));
                                    o = null;
                                    if (o = "function" == typeof this.editor.options.timestampFormat ? this.editor.options.timestampFormat({
                                        field: this.field,
                                        value: this.value,
                                        path: this.getPath()
                                    }) : o) {
                                        for(; this.dom.date.firstChild;)this.dom.date.removeChild(this.dom.date.firstChild);
                                        this.dom.date.appendChild(document.createTextNode(o));
                                    } else this.dom.date.textContent = new Date(i).toISOString();
                                    this.dom.date.title = new Date(i).toString();
                                } else this.dom.date && (this.dom.date.parentNode.removeChild(this.dom.date), delete this.dom.date);
                                (0, E.stripFormatting)(e), this._updateDomDefault();
                            }
                        }
                    },
                    {
                        key: "_updateEnumOptions",
                        value: function() {
                            if (this.enum && this.dom.select) {
                                this.dom.select.innerHTML = "";
                                for(var e = 0; e < this.enum.length; e++){
                                    var t = document.createElement("option");
                                    t.value = this.enum[e], t.textContent = this.enum[e], this.dom.select.appendChild(t);
                                }
                            }
                        }
                    },
                    {
                        key: "_deleteDomColor",
                        value: function() {
                            this.dom.color && (this.dom.tdColor.parentNode.removeChild(this.dom.tdColor), delete this.dom.tdColor, delete this.dom.color, (0, E.removeClassName)(this.dom.value, "jsoneditor-color-value"));
                        }
                    },
                    {
                        key: "_updateDomField",
                        value: function() {
                            var e, t = this.dom.field;
                            t && ((e = (0, E.makeFieldTooltip)(this.schema, this.editor.options.language)) && (t.title = e), ("" === String(this.field) && this.parent && "array" !== this.parent.type ? (0, E.addClassName) : (0, E.removeClassName))(t, "jsoneditor-empty"), (this.searchFieldActive ? (0, E.addClassName) : (0, E.removeClassName))(t, "jsoneditor-highlight-active"), (this.searchField ? (0, E.addClassName) : (0, E.removeClassName))(t, "jsoneditor-highlight"), (0, E.stripFormatting)(t));
                        }
                    },
                    {
                        key: "_getDomField",
                        value: function(e) {
                            if (this._clearFieldError(), this.dom.field && this.fieldEditable && (this.fieldInnerText = (0, E.getInnerText)(this.dom.field), "" === this.fieldInnerText) && "" !== this.dom.field.innerHTML && (this.dom.field.textContent = ""), void 0 !== this.fieldInnerText) try {
                                var t = this._unescapeHTML(this.fieldInnerText), i = this.parent.getFieldNames(this);
                                -1 !== i.indexOf(t) ? e ? (t = (0, E.findUniqueName)(t, i)) !== this.field && (this.field = t, this._debouncedOnChangeField()) : this._setFieldError((0, a.Tl)("duplicateFieldError")) : t !== this.field && (this.field = t, this._debouncedOnChangeField());
                            } catch (e) {
                                this._setFieldError((0, a.Tl)("cannotParseFieldError"));
                            }
                        }
                    },
                    {
                        key: "_updateDomDefault",
                        value: function() {
                            var e;
                            this.schema && void 0 !== this.schema.default && !this._hasChilds() && (e = this.dom.select || this.dom.value) && (this.value === this.schema.default ? (e.title = (0, a.Tl)("default"), (0, E.addClassName)(e, "jsoneditor-is-default"), E.removeClassName) : (e.removeAttribute("title"), (0, E.removeClassName)(e, "jsoneditor-is-default"), E.addClassName))(e, "jsoneditor-is-not-default");
                        }
                    },
                    {
                        key: "_showTimestampTag",
                        value: function() {
                            var e, t;
                            return "number" == typeof this.value && ("function" == typeof (e = this.editor.options.timestampTag) ? "boolean" == typeof (t = e({
                                field: this.field,
                                value: this.value,
                                path: this.getPath()
                            })) ? t : (0, E.isTimestamp)(this.field, this.value) : !0 === e && (0, E.isTimestamp)(this.field, this.value));
                        }
                    },
                    {
                        key: "clearDom",
                        value: function() {
                            this.dom = {};
                        }
                    },
                    {
                        key: "getDom",
                        value: function() {
                            var e, t, i = this.dom;
                            return i.tr || (this._updateEditability(), i.tr = document.createElement("tr"), "tree" === (i.tr.node = this).editor.options.mode && (t = document.createElement("td"), this.editable.field && this.parent && ((e = document.createElement("button")).type = "button", (i.drag = e).className = "jsoneditor-button jsoneditor-dragarea", e.title = (0, a.Tl)("drag"), t.appendChild(e)), i.tr.appendChild(t), e = document.createElement("td"), (t = document.createElement("button")).type = "button", (i.menu = t).className = "jsoneditor-button jsoneditor-contextmenu-button", t.title = (0, a.Tl)("actionsMenu"), e.appendChild(i.menu), i.tr.appendChild(e)), t = document.createElement("td"), i.tr.appendChild(t), i.tree = this._createDomTree(), t.appendChild(i.tree), this.updateDom({
                                updateIndexes: !0
                            })), i.tr;
                        }
                    },
                    {
                        key: "isVisible",
                        value: function() {
                            return this.dom && this.dom.tr && this.dom.tr.parentNode || !1;
                        }
                    },
                    {
                        key: "isDescendantOf",
                        value: function(e) {
                            for(var t = this.parent; t;){
                                if (t === e) return !0;
                                t = t.parent;
                            }
                            return !1;
                        }
                    },
                    {
                        key: "_createDomField",
                        value: function() {
                            return document.createElement("div");
                        }
                    },
                    {
                        key: "setHighlight",
                        value: function(t) {
                            this.dom.tr && ((t ? (0, E.addClassName) : (0, E.removeClassName))(this.dom.tr, "jsoneditor-highlight"), this.append && this.append.setHighlight(t), this.childs) && this.childs.forEach(function(e) {
                                e.setHighlight(t);
                            });
                        }
                    },
                    {
                        key: "setSelected",
                        value: function(t, e) {
                            this.selected = t, this.dom.tr && ((t ? (0, E.addClassName) : (0, E.removeClassName))(this.dom.tr, "jsoneditor-selected"), (e ? (0, E.addClassName) : (0, E.removeClassName))(this.dom.tr, "jsoneditor-first"), this.append && this.append.setSelected(t), this.showMore && this.showMore.setSelected(t), this.childs) && this.childs.forEach(function(e) {
                                e.setSelected(t);
                            });
                        }
                    },
                    {
                        key: "updateValue",
                        value: function(e) {
                            this.value = e, this.previousValue = e, this.valueError = void 0, this.updateDom();
                        }
                    },
                    {
                        key: "updateField",
                        value: function(e) {
                            this.field = e, this.previousField = e, this.fieldError = void 0, this.updateDom();
                        }
                    },
                    {
                        key: "updateDom",
                        value: function(t) {
                            var e, i = this.dom.tree, i = (i && (i.style.marginLeft = 24 * this.getLevel() + "px"), this.dom.field), i = (i && (this.fieldEditable ? (i.contentEditable = this.editable.field, i.spellcheck = !1, i.className = "jsoneditor-field") : (i.contentEditable = !1, i.className = "jsoneditor-readonly"), e = void 0 !== this.index ? this.index : void 0 !== this.field ? this.field : (e = this.editor.options.schema ? S._findSchema(this.editor.options.schema, this.editor.options.schemaRefs || {}, this.getPath()) : void 0) && e.title ? e.title : this._hasChilds() ? this.type : "", e = this._escapeHTML(e), document.activeElement !== i && e !== this._unescapeHTML((0, E.getInnerText)(i)) && (i.innerHTML = e), this._updateSchema(), this._updateEnumOptions()), this.dom.value), i = (i && ("array" === this.type || "object" === this.type ? this.updateNodeName() : (e = this._escapeHTML(this.value), document.activeElement !== i && e !== this._unescapeHTML((0, E.getInnerText)(i)) && (i.innerHTML = e))), this.dom.tr);
                            i && ("array" === this.type || "object" === this.type ? ((0, E.addClassName)(i, "jsoneditor-expandable"), this.expanded ? ((0, E.addClassName)(i, "jsoneditor-expanded"), (0, E.removeClassName)(i, "jsoneditor-collapsed")) : ((0, E.addClassName)(i, "jsoneditor-collapsed"), (0, E.removeClassName)(i, "jsoneditor-expanded"))) : ((0, E.removeClassName)(i, "jsoneditor-expandable"), (0, E.removeClassName)(i, "jsoneditor-expanded"), (0, E.removeClassName)(i, "jsoneditor-collapsed"))), this._updateDomField(), this._updateDomValue(), t && !0 === t.updateIndexes && this._updateDomIndexes(), t && !0 === t.recurse && this.childs && this.childs.forEach(function(e) {
                                e.updateDom(t);
                            }), this.error && this.updateError(), this.append && this.append.updateDom(), this.showMore && this.showMore.updateDom(), this._updateCssClassName();
                        }
                    },
                    {
                        key: "_updateSchema",
                        value: function() {
                            this.editor && this.editor.options && (this.schema = this.editor.options.schema ? S._findSchema(this.editor.options.schema, this.editor.options.schemaRefs || {}, this.getPath()) : null, this.schema ? this.enum = S._findEnum(this.schema) : delete this.enum);
                        }
                    },
                    {
                        key: "_updateDomIndexes",
                        value: function() {
                            var e = this.dom.value, t = this.childs;
                            e && t && ("array" === this.type ? t.forEach(function(e, t) {
                                e.index = t;
                                e = e.dom.field;
                                e && (e.textContent = t);
                            }) : "object" === this.type && t.forEach(function(e) {
                                void 0 !== e.index && (delete e.index, void 0 === e.field) && (e.field = "");
                            }));
                        }
                    },
                    {
                        key: "_createDomValue",
                        value: function() {
                            var e;
                            return "array" === this.type ? (e = document.createElement("div")).textContent = "[...]" : "object" === this.type ? (e = document.createElement("div")).textContent = "{...}" : (!this.editable.value && (0, E.isUrl)(this.value) ? (e = document.createElement("a")).href = this.value : ((e = document.createElement("div")).contentEditable = this.editable.value, e.spellcheck = !1), e.innerHTML = this._escapeHTML(this.value)), e;
                        }
                    },
                    {
                        key: "_createDomExpandButton",
                        value: function() {
                            var e = document.createElement("button");
                            return e.type = "button", this._hasChilds() ? (e.className = this.expanded ? "jsoneditor-button jsoneditor-expanded" : "jsoneditor-button jsoneditor-collapsed", e.title = (0, a.Tl)("expandTitle")) : (e.className = "jsoneditor-button jsoneditor-invisible", e.title = ""), e;
                        }
                    },
                    {
                        key: "_createDomTree",
                        value: function() {
                            var e = this.dom, t = document.createElement("table"), i = document.createElement("tbody"), n = (t.style.borderCollapse = "collapse", t.className = "jsoneditor-values", t.appendChild(i), document.createElement("tr")), i = (i.appendChild(n), document.createElement("td")), i = (i.className = "jsoneditor-tree", n.appendChild(i), e.expand = this._createDomExpandButton(), i.appendChild(e.expand), e.tdExpand = i, document.createElement("td")), i = (i.className = "jsoneditor-tree", n.appendChild(i), e.field = this._createDomField(), i.appendChild(e.field), e.tdField = i, document.createElement("td")), i = (i.className = "jsoneditor-tree", n.appendChild(i), "object" !== this.type && "array" !== this.type && (i.appendChild(document.createTextNode(":")), i.className = "jsoneditor-separator"), e.tdSeparator = i, document.createElement("td"));
                            return i.className = "jsoneditor-tree", n.appendChild(i), e.value = this._createDomValue(), i.appendChild(e.value), e.tdValue = i, t;
                        }
                    },
                    {
                        key: "onEvent",
                        value: function(e) {
                            var t, i = e.type, n = e.target || e.srcElement, o = this.dom, r = this, s = this._hasChilds(), a = (n !== o.drag && n !== o.menu || ("mouseover" === i ? this.editor.highlighter.highlight(this) : "mouseout" === i && this.editor.highlighter.unhighlight()), "click" === i && n === o.menu && ((t = r.editor.highlighter).highlight(r), t.lock(), (0, E.addClassName)(o.menu, "jsoneditor-selected"), this.showContextMenu(o.menu, function() {
                                (0, E.removeClassName)(o.menu, "jsoneditor-selected"), t.unlock(), t.unhighlight();
                            })), "click" === i && n === o.expand && s && (d = e.ctrlKey, this._onExpand(d)), "click" !== i || e.target !== r.dom.tdColor && e.target !== r.dom.color || !this.editable.value || this._showColorPicker(), "change" === i && n === o.checkbox && (this.dom.value.textContent = String(!this.value), this._getDomValue(), this._updateDomDefault()), "change" === i && n === o.select && (this.dom.value.innerHTML = this._escapeHTML(o.select.value), this._getDomValue(), this._updateDomValue()), o.value);
                            if (n === a) switch(i){
                                case "blur":
                                case "change":
                                    this._getDomValue(), this._clearValueError(), this._updateDomValue();
                                    var l = this._escapeHTML(this.value);
                                    l !== this._unescapeHTML((0, E.getInnerText)(a)) && (a.innerHTML = l);
                                    break;
                                case "input":
                                    this._getDomValue(), this._updateDomValue();
                                    break;
                                case "keydown":
                                case "mousedown":
                                    this.editor.selection = this.editor.getDomSelection();
                                    break;
                                case "click":
                                    e.ctrlKey && this.editable.value && (0, E.isUrl)(this.value) && (e.preventDefault(), window.open(this.value, "_blank", "noreferrer"));
                                    break;
                                case "keyup":
                                    this._getDomValue(), this._updateDomValue();
                                    break;
                                case "cut":
                                case "paste":
                                    setTimeout(function() {
                                        r._getDomValue(), r._updateDomValue();
                                    }, 1);
                            }
                            var c = o.field;
                            if (n === c) switch(i){
                                case "blur":
                                    this._getDomField(!0), this._updateDomField();
                                    var h = this._escapeHTML(this.field);
                                    h !== this._unescapeHTML((0, E.getInnerText)(c)) && (c.innerHTML = h);
                                    break;
                                case "input":
                                    this._getDomField(), this._updateSchema(), this._updateDomField(), this._updateDomValue();
                                    break;
                                case "keydown":
                                case "mousedown":
                                    this.editor.selection = this.editor.getDomSelection();
                                    break;
                                case "keyup":
                                    this._getDomField(), this._updateDomField();
                                    break;
                                case "cut":
                                case "paste":
                                    setTimeout(function() {
                                        r._getDomField(), r._updateDomField();
                                    }, 1);
                            }
                            var d = o.tree;
                            d && n === d.parentNode && "click" === i && !e.hasMoved && ((void 0 !== e.offsetX ? e.offsetX < 24 * (this.getLevel() + 1) : e.pageX < (0, E.getAbsoluteLeft)(o.tdSeparator)) || s ? c && ((0, E.setEndOfContentEditable)(c), c.focus()) : a && !this.enum && ((0, E.setEndOfContentEditable)(a), a.focus())), (n !== o.tdExpand || s) && n !== o.tdField && n !== o.tdSeparator || "click" !== i || e.hasMoved || c && ((0, E.setEndOfContentEditable)(c), c.focus()), "keydown" === i && this.onKeyDown(e), "function" == typeof this.editor.options.onEvent && this._onEvent(e);
                        }
                    },
                    {
                        key: "_onEvent",
                        value: function(e) {
                            var t = e.target, i = t === this.dom.field, t = t === this.dom.value || t === this.dom.checkbox || t === this.dom.select;
                            (i || t) && (i = {
                                field: this.getField(),
                                path: this.getPath()
                            }, t && !this._hasChilds() && (i.value = this.getValue()), this.editor.options.onEvent(i, e));
                        }
                    },
                    {
                        key: "onKeyDown",
                        value: function(e) {
                            var t, i, n, o, r, s, a, l, c, h, d, u, g, p, m = e.which || e.keyCode, f = e.target || e.srcElement, C = e.ctrlKey, y = e.shiftKey, v = e.altKey, I = !1, b = "tree" === this.editor.options.mode, A = 0 < this.editor.multiselection.nodes.length ? this.editor.multiselection.nodes : [
                                this
                            ], w = A[0], x = A[A.length - 1];
                            13 === m ? f === this.dom.value ? this.editable.value && !e.ctrlKey || (0, E.isUrl)(this.value) && (window.open(this.value, "_blank", "noreferrer"), I = !0) : f === this.dom.expand && this._hasChilds() && (g = e.ctrlKey, this._onExpand(g), f.focus(), I = !0) : 68 === m ? C && b && (S.onDuplicate(A), I = !0) : 69 === m ? C && (this._onExpand(y), f.focus(), I = !0) : 77 === m && b ? C && (this.showContextMenu(f), I = !0) : 46 === m && b ? C && (S.onRemove(A), I = !0) : 45 === m && b ? C && !y ? (this._onInsertBefore(), I = !0) : C && y && (this._onInsertAfter(), I = !0) : 35 === m ? v && ((g = this._lastNode()) && g.focus(S.focusElement || this._getElementName(f)), I = !0) : 36 === m ? v && ((g = this._firstNode()) && g.focus(S.focusElement || this._getElementName(f)), I = !0) : 37 === m ? v && !y ? ((g = this._previousElement(f)) && this.focus(this._getElementName(g)), I = !0) : v && y && b && (g = x.expanded ? (g = x.getAppendDom()) ? g.nextSibling : void 0 : x.getDom().nextSibling) && (d = S.getNodeFromTarget(g), g = g.nextSibling, u = S.getNodeFromTarget(g), d) && d instanceof $ && 1 !== x.parent.childs.length && u && u.parent && (i = this.editor.getDomSelection(), n = (o = w.parent).childs[x.getIndex() + 1] || o.append, r = w.getIndex(), s = u.getIndex(), a = o.getInternalPath(), l = u.parent.getInternalPath(), A.forEach(function(e) {
                                u.parent.moveBefore(e, u);
                            }), this.focus(S.focusElement || this._getElementName(f)), this.editor._onAction("moveNodes", {
                                count: A.length,
                                fieldNames: A.map(R),
                                oldParentPath: o.getInternalPath(),
                                newParentPath: w.parent.getInternalPath(),
                                oldIndex: n.getIndex(),
                                newIndex: w.getIndex(),
                                oldIndexRedo: r,
                                newIndexRedo: s,
                                oldParentPathRedo: a,
                                newParentPathRedo: l,
                                oldSelection: i,
                                newSelection: this.editor.getDomSelection()
                            })) : 38 === m ? v && !y ? ((t = this._previousNode()) && (this.editor.deselect(!0), t.focus(S.focusElement || this._getElementName(f))), I = !0) : !v && C && y && b ? ((t = this._previousNode()) && ((h = this.editor.multiselection).start = h.start || this, h.end = t, c = this.editor._findTopLevelNodes(h.start, h.end), this.editor.select(c), t.focus("field")), I = !0) : v && y && b && ((t = w._previousNode()) && t.parent && (i = this.editor.getDomSelection(), n = (o = w.parent).childs[x.getIndex() + 1] || o.append, r = w.getIndex(), s = t.getIndex(), a = o.getInternalPath(), l = t.parent.getInternalPath(), A.forEach(function(e) {
                                t.parent.moveBefore(e, t);
                            }), this.focus(S.focusElement || this._getElementName(f)), this.editor._onAction("moveNodes", {
                                count: A.length,
                                fieldNames: A.map(R),
                                oldParentPath: o.getInternalPath(),
                                newParentPath: w.parent.getInternalPath(),
                                oldIndex: n.getIndex(),
                                newIndex: w.getIndex(),
                                oldIndexRedo: r,
                                newIndexRedo: s,
                                oldParentPathRedo: a,
                                newParentPathRedo: l,
                                oldSelection: i,
                                newSelection: this.editor.getDomSelection()
                            })), I = !0) : 39 === m ? v && !y ? ((g = this._nextElement(f)) && this.focus(this._getElementName(g)), I = !0) : v && y && b && (g = w.getDom().previousSibling) && (t = S.getNodeFromTarget(g)) && t.parent && !t.isVisible() && (i = this.editor.getDomSelection(), n = (o = w.parent).childs[x.getIndex() + 1] || o.append, r = w.getIndex(), s = t.getIndex(), a = o.getInternalPath(), l = t.parent.getInternalPath(), A.forEach(function(e) {
                                t.parent.moveBefore(e, t);
                            }), this.focus(S.focusElement || this._getElementName(f)), this.editor._onAction("moveNodes", {
                                count: A.length,
                                fieldNames: A.map(R),
                                oldParentPath: o.getInternalPath(),
                                newParentPath: w.parent.getInternalPath(),
                                oldIndex: n.getIndex(),
                                newIndex: w.getIndex(),
                                oldIndexRedo: r,
                                newIndexRedo: s,
                                oldParentPathRedo: a,
                                newParentPathRedo: l,
                                oldSelection: i,
                                newSelection: this.editor.getDomSelection()
                            })) : 40 === m && (v && !y ? ((d = this._nextNode()) && (this.editor.deselect(!0), d.focus(S.focusElement || this._getElementName(f))), I = !0) : !v && C && y && b ? ((d = this._nextNode()) && ((h = this.editor.multiselection).start = h.start || this, h.end = d, c = this.editor._findTopLevelNodes(h.start, h.end), this.editor.select(c), d.focus("field")), I = !0) : v && y && b && ((p = (d = (d = (d = x.expanded ? x.append ? x.append._nextNode() : void 0 : x._nextNode()) && !d.isVisible() ? d.parent.showMore : d) && d instanceof $ ? x : d) && (d._nextNode() || d.parent.append)) && p.parent && (i = this.editor.getDomSelection(), n = (o = w.parent).childs[x.getIndex() + 1] || o.append, r = w.getIndex(), s = p.getIndex(), a = o.getInternalPath(), l = p.parent.getInternalPath(), A.forEach(function(e) {
                                p.parent.moveBefore(e, p);
                            }), this.focus(S.focusElement || this._getElementName(f)), this.editor._onAction("moveNodes", {
                                count: A.length,
                                fieldNames: A.map(R),
                                oldParentPath: o.getInternalPath(),
                                newParentPath: w.parent.getInternalPath(),
                                oldParentPathRedo: a,
                                newParentPathRedo: l,
                                oldIndexRedo: r,
                                newIndexRedo: s,
                                oldIndex: n.getIndex(),
                                newIndex: w.getIndex(),
                                oldSelection: i,
                                newSelection: this.editor.getDomSelection()
                            })), I = !0)), I && (e.preventDefault(), e.stopPropagation());
                        }
                    },
                    {
                        key: "_onExpand",
                        value: function(e) {
                            var t, i, n;
                            e && (n = (i = (t = this.dom.tr.parentNode).parentNode).scrollTop, i.removeChild(t)), this.expanded ? this.collapse(e) : this.expand(e), e && (i.appendChild(t), i.scrollTop = n), "function" == typeof this.editor.options.onExpand && this.editor.options.onExpand({
                                path: this.getPath(),
                                isExpand: this.expanded,
                                recursive: e
                            });
                        }
                    },
                    {
                        key: "_showColorPicker",
                        value: function() {
                            var t, e;
                            "function" == typeof this.editor.options.onColorPicker && this.dom.color && ((t = this)._deleteDomColor(), t.updateDom(), e = (0, h.p)(this.dom.color, this.editor.getPopupAnchor()), this.editor.options.onColorPicker(e, this.value, function(e) {
                                "string" == typeof e && e !== t.value && (t._deleteDomColor(), t.value = e, t.updateDom(), t._debouncedOnChangeValue());
                            }));
                        }
                    },
                    {
                        key: "getFieldNames",
                        value: function(t) {
                            return "object" === this.type ? this.childs.filter(function(e) {
                                return e !== t;
                            }).map(function(e) {
                                return e.field;
                            }) : [];
                        }
                    },
                    {
                        key: "_onInsertBefore",
                        value: function(e, t, i) {
                            var n = this.editor.getDomSelection(), e = new S(this.editor, {
                                field: void 0 !== e ? e : "",
                                value: void 0 !== t ? t : "",
                                type: i
                            }), t = (e.expand(!0), this.getInternalPath()), i = (this.parent.insertBefore(e, this), this.editor.highlighter.unhighlight(), e.focus("field"), this.editor.getDomSelection());
                            this.editor._onAction("insertBeforeNodes", {
                                nodes: [
                                    e
                                ],
                                paths: [
                                    e.getInternalPath()
                                ],
                                beforePath: t,
                                parentPath: this.parent.getInternalPath(),
                                oldSelection: n,
                                newSelection: i
                            });
                        }
                    },
                    {
                        key: "_onInsertAfter",
                        value: function(e, t, i) {
                            var n = this.editor.getDomSelection(), e = new S(this.editor, {
                                field: void 0 !== e ? e : "",
                                value: void 0 !== t ? t : "",
                                type: i
                            }), t = (e.expand(!0), this.parent.insertAfter(e, this), this.editor.highlighter.unhighlight(), e.focus("field"), this.editor.getDomSelection());
                            this.editor._onAction("insertAfterNodes", {
                                nodes: [
                                    e
                                ],
                                paths: [
                                    e.getInternalPath()
                                ],
                                afterPath: this.getInternalPath(),
                                parentPath: this.parent.getInternalPath(),
                                oldSelection: n,
                                newSelection: t
                            });
                        }
                    },
                    {
                        key: "_onAppend",
                        value: function(e, t, i) {
                            var n = this.editor.getDomSelection(), e = new S(this.editor, {
                                field: void 0 !== e ? e : "",
                                value: void 0 !== t ? t : "",
                                type: i
                            }), t = (e.expand(!0), this.parent.appendChild(e), this.editor.highlighter.unhighlight(), e.focus("field"), this.editor.getDomSelection());
                            this.editor._onAction("appendNodes", {
                                nodes: [
                                    e
                                ],
                                paths: [
                                    e.getInternalPath()
                                ],
                                parentPath: this.parent.getInternalPath(),
                                oldSelection: n,
                                newSelection: t
                            });
                        }
                    },
                    {
                        key: "_onChangeType",
                        value: function(e) {
                            var t, i, n = this.type;
                            e !== n && (t = this.editor.getDomSelection(), this.changeType(e), i = this.editor.getDomSelection(), this.editor._onAction("changeType", {
                                path: this.getInternalPath(),
                                oldType: n,
                                newType: e,
                                oldSelection: t,
                                newSelection: i
                            }));
                        }
                    },
                    {
                        key: "sort",
                        value: function(i, e) {
                            var t, n, o = !(2 < arguments.length && void 0 !== arguments[2]) || arguments[2];
                            "string" == typeof i && (i = (0, E.parsePath)(i)), this._hasChilds() && (this.hideChilds(), t = this.childs, this.childs = this.childs.concat(), n = "desc" === e ? -1 : 1, "object" === this.type ? this.childs.sort(function(e, t) {
                                return n * c()(e.field, t.field);
                            }) : this.childs.sort(function(e, t) {
                                var e = e.getNestedChild(i), t = t.getNestedChild(i);
                                return e ? t ? (e = e.value, t = t.value, "string" != typeof e && "string" != typeof t ? t < e ? n : e < t ? -n : 0 : n * c()(e, t)) : -n : n;
                            }), this._updateDomIndexes(), this.showChilds(), !0 === o) && this.editor._onAction("sort", {
                                path: this.getInternalPath(),
                                oldChilds: t,
                                newChilds: this.childs
                            });
                        }
                    },
                    {
                        key: "update",
                        value: function(e) {
                            var t = this.getInternalValue();
                            this.setValue(e), this.editor._onAction("transform", {
                                path: this.getInternalPath(),
                                oldValue: t,
                                newValue: this.getInternalValue()
                            });
                        }
                    },
                    {
                        key: "_detachFromDom",
                        value: function() {
                            var e = this.dom.tr ? this.dom.tr.parentNode : void 0, t = this.expanded ? this.getAppendDom() : this.getDom(), t = t && t.parentNode ? t.nextSibling : void 0;
                            return this.hide({
                                resetVisibleChilds: !1
                            }), {
                                table: e,
                                nextTr: t
                            };
                        }
                    },
                    {
                        key: "_attachToDom",
                        value: function(e) {
                            e.table && (e.nextTr ? e.table.insertBefore(this.getDom(), e.nextTr) : e.table.appendChild(this.getDom())), this.expanded && this.showChilds();
                        }
                    },
                    {
                        key: "transform",
                        value: function(e) {
                            if (this._hasChilds()) {
                                this.hideChilds();
                                try {
                                    var t = this.getInternalValue(), i = this.getValue(), n = this.editor.options.executeQuery(i, e), o = (this.setValue(n), this.getInternalValue());
                                    this.editor._onAction("transform", {
                                        path: this.getInternalPath(),
                                        oldValue: t,
                                        newValue: o
                                    }), this.showChilds();
                                } catch (e) {
                                    this.showChilds(), this.editor._onError(e);
                                }
                            }
                        }
                    },
                    {
                        key: "extract",
                        value: function() {
                            this.editor.node.hideChilds(), this.hideChilds();
                            try {
                                var e = this.editor.node.getInternalValue(), t = (this.editor._setRoot(this), this.editor.node.getInternalValue());
                                this.editor._onAction("transform", {
                                    path: this.editor.node.getInternalPath(),
                                    oldValue: e,
                                    newValue: t
                                });
                            } catch (e) {
                                this.editor._onError(e);
                            } finally{
                                this.updateDom({
                                    recurse: !0
                                }), this.showChilds();
                            }
                        }
                    },
                    {
                        key: "getNestedChild",
                        value: function(e) {
                            for(var t = 0, i = this; i && t < e.length;)i = i.findChildByProperty(e[t]), t++;
                            return i;
                        }
                    },
                    {
                        key: "findChildByProperty",
                        value: function(t) {
                            if ("object" === this.type) return this.childs.find(function(e) {
                                return e.field === t;
                            });
                        }
                    },
                    {
                        key: "getAppendDom",
                        value: function() {
                            return this.append || (this.append = new $(this.editor), this.append.setParent(this)), this.append.getDom();
                        }
                    },
                    {
                        key: "getShowMoreDom",
                        value: function() {
                            return this.showMore || (this.showMore = new z(this.editor, this)), this.showMore.getDom();
                        }
                    },
                    {
                        key: "nextSibling",
                        value: function() {
                            var e = this.parent.childs.indexOf(this);
                            return this.parent.childs[e + 1] || this.parent.append;
                        }
                    },
                    {
                        key: "_previousNode",
                        value: function() {
                            var e = null, t = this.getDom();
                            if (t && t.parentNode) for(var i = t; i = i.previousSibling, e = S.getNodeFromTarget(i), i && e && e instanceof $ && !e.isVisible(););
                            return e;
                        }
                    },
                    {
                        key: "_nextNode",
                        value: function() {
                            var e = null, t = this.getDom();
                            if (t && t.parentNode) for(var i = t; i = i.nextSibling, e = S.getNodeFromTarget(i), i && e && e instanceof $ && !e.isVisible(););
                            return e;
                        }
                    },
                    {
                        key: "_firstNode",
                        value: function() {
                            var e = null, t = this.getDom();
                            return t && t.parentNode && (t = t.parentNode.firstChild, e = S.getNodeFromTarget(t)), e;
                        }
                    },
                    {
                        key: "_lastNode",
                        value: function() {
                            var e = null, t = this.getDom();
                            if (t && t.parentNode) for(var i = t.parentNode.lastChild, e = S.getNodeFromTarget(i); i && e && !e.isVisible();)i = i.previousSibling, e = S.getNodeFromTarget(i);
                            return e;
                        }
                    },
                    {
                        key: "_previousElement",
                        value: function(e) {
                            var t = this.dom;
                            switch(e){
                                case t.value:
                                    if (this.fieldEditable) return t.field;
                                case t.field:
                                    if (this._hasChilds()) return t.expand;
                                case t.expand:
                                    return t.menu;
                                case t.menu:
                                    if (t.drag) return t.drag;
                                default:
                                    return null;
                            }
                        }
                    },
                    {
                        key: "_nextElement",
                        value: function(e) {
                            var t = this.dom;
                            switch(e){
                                case t.drag:
                                    return t.menu;
                                case t.menu:
                                    if (this._hasChilds()) return t.expand;
                                case t.expand:
                                    if (this.fieldEditable) return t.field;
                                case t.field:
                                    if (!this._hasChilds()) return t.value;
                                default:
                                    return null;
                            }
                        }
                    },
                    {
                        key: "_getElementName",
                        value: function(t) {
                            var i = this;
                            return Object.keys(this.dom).find(function(e) {
                                return i.dom[e] === t;
                            });
                        }
                    },
                    {
                        key: "_hasChilds",
                        value: function() {
                            return "array" === this.type || "object" === this.type;
                        }
                    },
                    {
                        key: "addTemplates",
                        value: function(t, i) {
                            var n = this, e = n.editor.options.templates;
                            null != e && (e.length && t.push({
                                type: "separator"
                            }), e.forEach(function(e) {
                                t.push({
                                    text: e.text,
                                    className: e.className || "jsoneditor-type-object",
                                    title: e.title,
                                    click: (i ? function(e, t) {
                                        n._onAppend(e, t);
                                    } : function(e, t) {
                                        n._onInsertBefore(e, t);
                                    }).bind(this, e.field, e.value)
                                });
                            }));
                        }
                    },
                    {
                        key: "showContextMenu",
                        value: function(e, t) {
                            var i, n = this, o = [];
                            this.editable.value && o.push({
                                text: (0, a.Tl)("type"),
                                title: (0, a.Tl)("typeTitle"),
                                className: "jsoneditor-type-" + this.type,
                                submenu: [
                                    {
                                        text: (0, a.Tl)("auto"),
                                        className: "jsoneditor-type-auto" + ("auto" === this.type ? " jsoneditor-selected" : ""),
                                        title: (0, a.Tl)("autoType"),
                                        click: function() {
                                            n._onChangeType("auto");
                                        }
                                    },
                                    {
                                        text: (0, a.Tl)("array"),
                                        className: "jsoneditor-type-array" + ("array" === this.type ? " jsoneditor-selected" : ""),
                                        title: (0, a.Tl)("arrayType"),
                                        click: function() {
                                            n._onChangeType("array");
                                        }
                                    },
                                    {
                                        text: (0, a.Tl)("object"),
                                        className: "jsoneditor-type-object" + ("object" === this.type ? " jsoneditor-selected" : ""),
                                        title: (0, a.Tl)("objectType"),
                                        click: function() {
                                            n._onChangeType("object");
                                        }
                                    },
                                    {
                                        text: (0, a.Tl)("string"),
                                        className: "jsoneditor-type-string" + ("string" === this.type ? " jsoneditor-selected" : ""),
                                        title: (0, a.Tl)("stringType"),
                                        click: function() {
                                            n._onChangeType("string");
                                        }
                                    }
                                ]
                            }), this._hasChilds() && (this.editor.options.enableSort && o.push({
                                text: (0, a.Tl)("sort"),
                                title: (0, a.Tl)("sortTitle", {
                                    type: this.type
                                }),
                                className: "jsoneditor-sort-asc",
                                click: function() {
                                    n.showSortModal();
                                }
                            }), this.editor.options.enableTransform && o.push({
                                text: (0, a.Tl)("transform"),
                                title: (0, a.Tl)("transformTitle", {
                                    type: this.type
                                }),
                                className: "jsoneditor-transform",
                                click: function() {
                                    n.showTransformModal();
                                }
                            }), this.parent) && o.push({
                                text: (0, a.Tl)("extract"),
                                title: (0, a.Tl)("extractTitle", {
                                    type: this.type
                                }),
                                className: "jsoneditor-extract",
                                click: function() {
                                    n.extract();
                                }
                            }), this.parent && this.parent._hasChilds() && (o.length && o.push({
                                type: "separator"
                            }), i = n.parent.childs, n === i[i.length - 1] && (i = [
                                {
                                    text: (0, a.Tl)("auto"),
                                    className: "jsoneditor-type-auto",
                                    title: (0, a.Tl)("autoType"),
                                    click: function() {
                                        n._onAppend("", "", "auto");
                                    }
                                },
                                {
                                    text: (0, a.Tl)("array"),
                                    className: "jsoneditor-type-array",
                                    title: (0, a.Tl)("arrayType"),
                                    click: function() {
                                        n._onAppend("", []);
                                    }
                                },
                                {
                                    text: (0, a.Tl)("object"),
                                    className: "jsoneditor-type-object",
                                    title: (0, a.Tl)("objectType"),
                                    click: function() {
                                        n._onAppend("", {});
                                    }
                                },
                                {
                                    text: (0, a.Tl)("string"),
                                    className: "jsoneditor-type-string",
                                    title: (0, a.Tl)("stringType"),
                                    click: function() {
                                        n._onAppend("", "", "string");
                                    }
                                }
                            ], n.addTemplates(i, !0), o.push({
                                text: (0, a.Tl)("appendText"),
                                title: (0, a.Tl)("appendTitle"),
                                submenuTitle: (0, a.Tl)("appendSubmenuTitle"),
                                className: "jsoneditor-append",
                                click: function() {
                                    n._onAppend("", "", "auto");
                                },
                                submenu: i
                            })), i = [
                                {
                                    text: (0, a.Tl)("auto"),
                                    className: "jsoneditor-type-auto",
                                    title: (0, a.Tl)("autoType"),
                                    click: function() {
                                        n._onInsertBefore("", "", "auto");
                                    }
                                },
                                {
                                    text: (0, a.Tl)("array"),
                                    className: "jsoneditor-type-array",
                                    title: (0, a.Tl)("arrayType"),
                                    click: function() {
                                        n._onInsertBefore("", []);
                                    }
                                },
                                {
                                    text: (0, a.Tl)("object"),
                                    className: "jsoneditor-type-object",
                                    title: (0, a.Tl)("objectType"),
                                    click: function() {
                                        n._onInsertBefore("", {});
                                    }
                                },
                                {
                                    text: (0, a.Tl)("string"),
                                    className: "jsoneditor-type-string",
                                    title: (0, a.Tl)("stringType"),
                                    click: function() {
                                        n._onInsertBefore("", "", "string");
                                    }
                                }
                            ], n.addTemplates(i, !1), o.push({
                                text: (0, a.Tl)("insert"),
                                title: (0, a.Tl)("insertTitle"),
                                submenuTitle: (0, a.Tl)("insertSub"),
                                className: "jsoneditor-insert",
                                click: function() {
                                    n._onInsertBefore("", "", "auto");
                                },
                                submenu: i
                            }), this.editable.field) && (o.push({
                                text: (0, a.Tl)("duplicateText"),
                                title: (0, a.Tl)("duplicateField"),
                                className: "jsoneditor-duplicate",
                                click: function() {
                                    S.onDuplicate(n);
                                }
                            }), o.push({
                                text: (0, a.Tl)("removeText"),
                                title: (0, a.Tl)("removeField"),
                                className: "jsoneditor-remove",
                                click: function() {
                                    S.onRemove(n);
                                }
                            })), this.editor.options.onCreateMenu && (i = n.getPath(), o = this.editor.options.onCreateMenu(o, {
                                type: "single",
                                path: i,
                                paths: [
                                    i
                                ]
                            })), new s.t(o, {
                                close: t
                            }).show(e, this.editor.getPopupAnchor());
                        }
                    },
                    {
                        key: "showSortModal",
                        value: function() {
                            var i = this, e = this.editor.options.modalAnchor || d.ai, t = this.getValue();
                            (0, F.showSortModal)(e, t, function(e) {
                                var t = e.path, t = (0, E.parsePath)(t);
                                i.sortedBy = e, i.sort(t, e.direction);
                            }, i.sortedBy);
                        }
                    },
                    {
                        key: "showTransformModal",
                        value: function() {
                            var t = this, e = this.editor.options, i = e.modalAnchor, n = e.createQuery, o = e.executeQuery, e = e.queryDescription, r = this.getValue();
                            (0, V.showTransformModal)({
                                container: i || d.ai,
                                json: r,
                                queryDescription: e,
                                createQuery: n,
                                executeQuery: o,
                                onTransform: function(e) {
                                    t.transform(e);
                                }
                            });
                        }
                    },
                    {
                        key: "_getType",
                        value: function(e) {
                            return e instanceof Array ? "array" : e instanceof Object ? "object" : "string" == typeof e && "string" != typeof (0, E.parseString)(e) ? "string" : "auto";
                        }
                    },
                    {
                        key: "_escapeHTML",
                        value: function(e) {
                            return "string" != typeof e ? String(e) : (e = String(e).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/ {2}/g, " &nbsp;").replace(/^ /, "&nbsp;").replace(/ $/, "&nbsp;"), e = (e = JSON.stringify(e)).substring(1, e.length - 1), !0 === this.editor.options.escapeUnicode ? (0, E.escapeUnicodeChars)(e) : e);
                        }
                    },
                    {
                        key: "_unescapeHTML",
                        value: function(e) {
                            e = '"' + this._escapeJSON(e) + '"';
                            return (0, E.parse)(e).replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&nbsp;|\u00A0/g, " ").replace(/&amp;/g, "&");
                        }
                    },
                    {
                        key: "_escapeJSON",
                        value: function(e) {
                            for(var t = "", i = 0; i < e.length;){
                                var n = e.charAt(i);
                                "\n" === n ? t += "\\n" : "\\" === n ? (t += n, i++, "" !== (n = e.charAt(i)) && -1 !== '"\\/bfnrtu'.indexOf(n) || (t += "\\"), t += n) : t += '"' === n ? '\\"' : n, i++;
                            }
                            return t;
                        }
                    },
                    {
                        key: "updateNodeName",
                        value: function() {
                            var e = this.childs ? this.childs.length : 0;
                            if ("object" === this.type || "array" === this.type) {
                                if (this.editor.options.onNodeName) try {
                                    var t = this.getValue.bind(this), i = this.editor.options.onNodeName({
                                        path: this.getPath(),
                                        size: e,
                                        type: this.type,
                                        get value () {
                                            return t();
                                        }
                                    });
                                } catch (e) {
                                    console.error("Error in onNodeName callback: ", e);
                                }
                                this.dom.value.textContent = "object" === this.type ? "{" + (i || e) + "}" : "[" + (i || e) + "]";
                            }
                        }
                    },
                    {
                        key: "recursivelyUpdateNodeName",
                        value: function() {
                            if (this.expanded && (this.updateNodeName(), "undefined" !== this.childs)) for(var e in this.childs)this.childs[e].recursivelyUpdateNodeName();
                        }
                    }
                ], f(e.prototype, t), i && f(e, i), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), e;
            })(), K = (b.prototype.DEBOUNCE_INTERVAL = 150, b.prototype.MAX_SEARCH_RESULTS = 999, 100);
            function C(e) {
                return e.getInternalPath();
            }
            function R(e) {
                return e.getField();
            }
            function y(e, t) {
                return Object.prototype.hasOwnProperty.call(e, t);
            }
            b.focusElement = void 0, b.select = function(e) {
                setTimeout(function() {
                    (0, E.selectContentEditable)(e);
                }, 0);
            }, b.onDragStart = function(t, e) {
                if (!Array.isArray(t)) return b.onDragStart([
                    t
                ], e);
                var i, n, o, r, s;
                0 !== t.length && (n = t[t.length - 1], o = (i = t[0]).parent, s = b.getNodeFromTarget(e.target), r = i.editor, s = (0, E.getAbsoluteTop)(s.dom.tr) - (0, E.getAbsoluteTop)(i.dom.tr), r.mousemove || (r.mousemove = (0, E.addEventListener)(e.view, "mousemove", function(e) {
                    b.onDrag(t, e);
                })), r.mouseup || (r.mouseup = (0, E.addEventListener)(e.view, "mouseup", function(e) {
                    b.onDragEnd(t, e);
                })), r.highlighter.lock(), r.drag = {
                    oldCursor: document.body.style.cursor,
                    oldSelection: r.getDomSelection(),
                    oldPaths: t.map(C),
                    oldParent: o,
                    oldNextNode: o.childs[n.getIndex() + 1] || o.append,
                    oldParentPathRedo: o.getInternalPath(),
                    oldIndexRedo: i.getIndex(),
                    mouseX: e.pageX,
                    offsetY: s,
                    level: i.getLevel()
                }, document.body.style.cursor = "move", e.preventDefault());
            }, b.onDrag = function(e, t) {
                if (!Array.isArray(e)) return b.onDrag([
                    e
                ], t);
                if (0 !== e.length) {
                    var i, n, o, r, s, a = e[0].editor, l = t.pageY - a.drag.offsetY, c = t.pageX, h = !1, d = e[0], u = d.dom.tr, g = (0, E.getAbsoluteTop)(u), p = u.offsetHeight;
                    if (l < g) {
                        for(y = u; y = y.previousSibling, v = b.getNodeFromTarget(y), o = y ? (0, E.getAbsoluteTop)(y) : 0, y && l < o;);
                        (v = v && !v.parent ? void 0 : v) || (y = (u = u.parentNode.firstChild) ? u.nextSibling : void 0, (v = b.getNodeFromTarget(y)) === d && (v = void 0)), !(v = v && v.isVisible() && (o = (y = v.dom.tr) ? (0, E.getAbsoluteTop)(y) : 0) + p < l ? void 0 : v) || !1 !== a.options.limitDragging && v.parent !== e[0].parent || (e.forEach(function(e) {
                            v.parent.moveBefore(e, v);
                        }), h = !0);
                    } else {
                        var m = e[e.length - 1];
                        if (p = (u = m.expanded && m.append ? m.append.getDom() : m.dom.tr) ? u.nextSibling : void 0) {
                            for(r = (0, E.getAbsoluteTop)(p), i = p; n = b.getNodeFromTarget(i), i && (s = i.nextSibling ? (0, E.getAbsoluteTop)(i.nextSibling) : 0, s = i ? s - r : 0, n && n.parent.childs.length === e.length && n.parent.childs[e.length - 1] === m && (g += 27), i = i.nextSibling), i && g + s < l;);
                            if (n && n.parent) {
                                for(var p = c - a.drag.mouseX, p = Math.round(p / 24 / 2), f = a.drag.level + p, C = n.getLevel(), y = n.dom.tr && n.dom.tr.previousSibling; C < f && y;){
                                    var v = b.getNodeFromTarget(y), I = e.some(function(e) {
                                        return e === v || v.isDescendantOf(e);
                                    });
                                    if (!I) {
                                        if (!(v instanceof $)) break;
                                        I = v.parent.childs;
                                        if (I.length === e.length && I[e.length - 1] === m) break;
                                        C = (n = b.getNodeFromTarget(y)).getLevel();
                                    }
                                    y = y.previousSibling;
                                }
                                (n = n instanceof $ && !n.isVisible() && n.parent.showMore.isVisible() ? n._nextNode() : n) && (!1 === a.options.limitDragging || n.parent === e[0].parent) && n.dom.tr && n.dom.tr !== u.nextSibling && (e.forEach(function(e) {
                                    n.parent.moveBefore(e, n);
                                }), h = !0);
                            }
                        }
                    }
                    h && (a.drag.mouseX = c, a.drag.level = d.getLevel()), a.startAutoScroll(l), t.preventDefault();
                }
            }, b.onDragEnd = function(e, t) {
                if (!Array.isArray(e)) return b.onDrag([
                    e
                ], t);
                var i, n, o, r, s, a, l, c, h;
                0 !== e.length && (i = (a = e[0]).editor, a && a.dom.menu && a.dom.menu.focus(), n = i.drag.oldParent.getInternalPath(), o = a.parent.getInternalPath(), r = i.drag.oldParent === a.parent, s = i.drag.oldNextNode.getIndex(), a = a.getIndex(), l = i.drag.oldParentPathRedo, c = i.drag.oldIndexRedo, h = r && c < a ? a + e.length : a, r && c === a || i._onAction("moveNodes", {
                    count: e.length,
                    fieldNames: e.map(R),
                    oldParentPath: n,
                    newParentPath: o,
                    oldIndex: s,
                    newIndex: a,
                    oldIndexRedo: c,
                    newIndexRedo: h,
                    oldParentPathRedo: l,
                    newParentPathRedo: null,
                    oldSelection: i.drag.oldSelection,
                    newSelection: i.getDomSelection()
                }), document.body.style.cursor = i.drag.oldCursor, i.highlighter.unlock(), e.forEach(function(e) {
                    e.updateDom(), t.target !== e.dom.drag && t.target !== e.dom.menu && i.highlighter.unhighlight();
                }), delete i.drag, i.mousemove && ((0, E.removeEventListener)(t.view, "mousemove", i.mousemove), delete i.mousemove), i.mouseup && ((0, E.removeEventListener)(t.view, "mouseup", i.mouseup), delete i.mouseup), i.stopAutoScroll(), t.preventDefault());
            }, b._findEnum = function(e) {
                if (e.enum) return e.enum;
                e = e.oneOf || e.anyOf || e.allOf;
                if (e) {
                    e = e.filter(function(e) {
                        return e.enum;
                    });
                    if (0 < e.length) return e[0].enum;
                }
                return null;
            }, b._findOneSchema = function(e, t, i, n) {
                var o = i.slice(1, i.length), r = i[0];
                if ("object" === m(n) && "$ref" in n && "string" == typeof n.$ref) {
                    var s = n.$ref;
                    if (s in t) n = t[s];
                    else {
                        if (!s.startsWith("#/")) {
                            if (1 === (null == (i = s.match(/#\//g)) ? void 0 : i.length)) {
                                var a, i = j(s.split("#/"), 2), l = i[0], i = i[1];
                                if (l in t) return l = t[l], i = {
                                    $ref: "#/".concat(i)
                                }, (a = []).push(r), 0 < o.length && a.push.apply(a, Z(o)), b._findSchema(l, t, a, i);
                            }
                            throw Error("Unable to resolve reference ".concat(s));
                        }
                        n = e;
                        var c, h = g(s.substring(2).split("/"));
                        try {
                            for(h.s(); !(c = h.n()).done;){
                                var d = c.value;
                                if (!(d in n)) throw Error("Unable to resolve reference ".concat(s));
                                n = n[d];
                            }
                        } catch (e) {
                            h.e(e);
                        } finally{
                            h.f();
                        }
                    }
                }
                if (void 0 === r) return n;
                if ("string" != typeof r) return "number" == typeof r && "object" === m(n.items) && null !== n.items ? (n = n.items, b._findSchema(e, t, o, n)) : null;
                if ("object" === m(n.properties) && null !== n.properties && r in n.properties) return n = n.properties[r], b._findSchema(e, t, o, n);
                if ("object" === m(n.patternProperties) && null !== n.patternProperties) {
                    for(var u in n.patternProperties)if (r.match(u)) return n = n.patternProperties[u], b._findSchema(e, t, o, n);
                }
                return "object" === m(n.additionalProperties) ? (n = n.additionalProperties, b._findSchema(e, t, o, n)) : null;
            }, b._findSchema = function(e, t, i) {
                for(var n = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : e, o = [
                    n
                ], r = 0, s = [
                    n.oneOf,
                    n.anyOf,
                    n.allOf
                ]; r < s.length; r++){
                    var a = s[r];
                    Array.isArray(a) && (o = o.concat(a));
                }
                var l, c = null, h = g(o);
                try {
                    for(h.s(); !(l = h.n()).done;){
                        var d = l.value, u = b._findOneSchema(e, t, i, d);
                        if (!0 === u) c = !0;
                        else if (null !== u) return u;
                    }
                } catch (e) {
                    h.e(e);
                } finally{
                    h.f();
                }
                return c;
            }, b.onRemove = function(e) {
                if (!Array.isArray(e)) return b.onRemove([
                    e
                ]);
                var t, i, n, o, r, s;
                e && 0 < e.length && (t = (n = e[0]).parent, i = n.editor, n = n.getIndex(), i.highlighter.unhighlight(), o = i.getDomSelection(), b.blurNodes(e), r = i.getDomSelection(), s = e.map(C), e.forEach(function(e) {
                    e.parent._remove(e);
                }), i._onAction("removeNodes", {
                    nodes: e,
                    paths: s,
                    parentPath: t.getInternalPath(),
                    index: n,
                    oldSelection: o,
                    newSelection: r
                }));
            }, b.onDuplicate = function(e) {
                if (!Array.isArray(e)) return b.onDuplicate([
                    e
                ]);
                var t, n, i, o, r, s, a;
                e && 0 < e.length && (t = e[e.length - 1], n = t.parent, (i = t.editor).deselect(i.multiselection.nodes), o = i.getDomSelection(), r = t, s = e.map(function(e) {
                    var t, i = e.clone();
                    return "object" === e.parent.type && (t = e.parent.getFieldNames(), i.field = (0, E.findUniqueName)(e.field, t)), n.insertAfter(i, r), r = i;
                }), 1 === e.length ? "object" === s[0].parent.type ? (s[0].dom.field.innerHTML = e[0]._escapeHTML(e[0].field), s[0].focus("field")) : s[0].focus() : i.select(s), a = i.getDomSelection(), i._onAction("duplicateNodes", {
                    paths: e.map(C),
                    clonePaths: s.map(C),
                    afterPath: t.getInternalPath(),
                    parentPath: n.getInternalPath(),
                    oldSelection: o,
                    newSelection: a
                }));
            }, b.getNodeFromTarget = function(e) {
                for(; e;){
                    if (e.node) return e.node;
                    e = e.parentNode;
                }
            }, b.targetIsColorPicker = function(e) {
                var t = b.getNodeFromTarget(e);
                if (t) for(var i = e && e.parentNode; i;){
                    if (i === t.dom.color) return !0;
                    i = i.parentNode;
                }
                return !1;
            }, b.blurNodes = function(e) {
                var t, i;
                Array.isArray(e) ? (t = (i = e[0]).parent, i = i.getIndex(), (t.childs[i + e.length] ? t.childs[i + e.length] : t.childs[i - 1] || t).focus()) : b.blurNodes([
                    e
                ]);
            };
            (v.prototype = new b).getDom = function() {
                var e = this.dom;
                if (e.tr) return e.tr;
                this._updateEditability();
                var t = document.createElement("tr"), i = (t.className = "jsoneditor-append", t.node = this, e.tr = t, "tree" === this.editor.options.mode && (e.tdDrag = document.createElement("td"), n = document.createElement("td"), e.tdMenu = n, (i = document.createElement("button")).type = "button", i.className = "jsoneditor-button jsoneditor-contextmenu-button", i.title = "Click to open the actions menu (Ctrl+M)", e.menu = i, n.appendChild(e.menu)), document.createElement("td")), n = document.createElement("div");
                return n.appendChild(document.createTextNode("(" + (0, a.Tl)("empty") + ")")), n.className = "jsoneditor-readonly", i.appendChild(n), e.td = i, e.text = n, this.updateDom(), t;
            }, v.prototype.getPath = function() {
                return null;
            }, v.prototype.getIndex = function() {
                return null;
            }, v.prototype.updateDom = function(e) {
                var t = this.dom, i = t.td, n = (i && (i.style.paddingLeft = 24 * this.getLevel() + 26 + "px"), t.text), n = (n && (n.firstChild.nodeValue = "(" + (0, a.Tl)("empty") + " " + this.parent.type + ")"), t.tr);
                this.isVisible() ? t.tr.firstChild || (t.tdDrag && n.appendChild(t.tdDrag), t.tdMenu && n.appendChild(t.tdMenu), n.appendChild(i)) : t.tr.firstChild && (t.tdDrag && n.removeChild(t.tdDrag), t.tdMenu && n.removeChild(t.tdMenu), n.removeChild(i));
            }, v.prototype.isVisible = function() {
                return 0 === this.parent.childs.length;
            }, v.prototype.showContextMenu = function(e, t) {
                var i, n = this, o = [
                    {
                        text: (0, a.Tl)("auto"),
                        className: "jsoneditor-type-auto",
                        title: (0, a.Tl)("autoType"),
                        click: function() {
                            n._onAppend("", "", "auto");
                        }
                    },
                    {
                        text: (0, a.Tl)("array"),
                        className: "jsoneditor-type-array",
                        title: (0, a.Tl)("arrayType"),
                        click: function() {
                            n._onAppend("", []);
                        }
                    },
                    {
                        text: (0, a.Tl)("object"),
                        className: "jsoneditor-type-object",
                        title: (0, a.Tl)("objectType"),
                        click: function() {
                            n._onAppend("", {});
                        }
                    },
                    {
                        text: (0, a.Tl)("string"),
                        className: "jsoneditor-type-string",
                        title: (0, a.Tl)("stringType"),
                        click: function() {
                            n._onAppend("", "", "string");
                        }
                    }
                ], o = (n.addTemplates(o, !0), [
                    {
                        text: (0, a.Tl)("appendText"),
                        title: (0, a.Tl)("appendTitleAuto"),
                        submenuTitle: (0, a.Tl)("appendSubmenuTitle"),
                        className: "jsoneditor-insert",
                        click: function() {
                            n._onAppend("", "", "auto");
                        },
                        submenu: o
                    }
                ]);
                this.editor.options.onCreateMenu && (i = n.parent.getPath(), o = this.editor.options.onCreateMenu(o, {
                    type: "append",
                    path: i,
                    paths: [
                        i
                    ]
                })), new s.t(o, {
                    close: t
                }).show(e, this.editor.getPopupAnchor());
            }, v.prototype.onEvent = function(e) {
                var t, i = e.type, n = e.target || e.srcElement, o = this.dom;
                n === o.menu && ("mouseover" === i ? this.editor.highlighter.highlight(this.parent) : "mouseout" === i && this.editor.highlighter.unhighlight()), "click" === i && n === o.menu && ((t = this.editor.highlighter).highlight(this.parent), t.lock(), (0, E.addClassName)(o.menu, "jsoneditor-selected"), this.showContextMenu(o.menu, function() {
                    (0, E.removeClassName)(o.menu, "jsoneditor-selected"), t.unlock(), t.unhighlight();
                })), "keydown" === i && this.onKeyDown(e);
            };
            var $ = v;
            function v(e) {
                this.editor = e, this.dom = {};
            }
            (I.prototype = new b).getDom = function() {
                var t, i, e, n, o, r;
                return this.dom.tr || (this._updateEditability(), this.dom.tr || (i = (t = this).parent, (o = document.createElement("a")).appendChild(document.createTextNode((0, a.Tl)("showMore"))), o.href = "#", o.onclick = function(e) {
                    return i.visibleChilds = Math.floor(i.visibleChilds / i.getMaxVisibleChilds() + 1) * i.getMaxVisibleChilds(), t.updateDom(), i.showChilds(), e.preventDefault(), !1;
                }, (r = document.createElement("a")).appendChild(document.createTextNode((0, a.Tl)("showAll"))), r.href = "#", r.onclick = function(e) {
                    return i.visibleChilds = 1 / 0, t.updateDom(), i.showChilds(), e.preventDefault(), !1;
                }, e = document.createElement("div"), n = document.createTextNode(this._getShowMoreText()), e.className = "jsoneditor-show-more", e.appendChild(n), e.appendChild(o), e.appendChild(document.createTextNode(". ")), e.appendChild(r), e.appendChild(document.createTextNode(". ")), (o = document.createElement("td")).appendChild(e), r = document.createElement("tr"), "tree" === this.editor.options.mode && (r.appendChild(document.createElement("td")), r.appendChild(document.createElement("td"))), r.appendChild(o), r.className = "jsoneditor-show-more", this.dom.tr = r, this.dom.moreContents = e, this.dom.moreText = n), this.updateDom()), this.dom.tr;
            }, I.prototype.updateDom = function(e) {
                var t;
                this.isVisible() ? (this.dom.tr.node = this.parent.childs[this.parent.visibleChilds], this.dom.tr.parentNode || (t = this.parent._getNextTr()) && t.parentNode.insertBefore(this.dom.tr, t), this.dom.moreText.nodeValue = this._getShowMoreText(), this.dom.moreContents.style.marginLeft = 24 * (this.getLevel() + 1) + "px") : this.dom.tr && this.dom.tr.parentNode && this.dom.tr.parentNode.removeChild(this.dom.tr);
            }, I.prototype._getShowMoreText = function() {
                return (0, a.Tl)("showMoreStatus", {
                    visibleChilds: this.parent.visibleChilds,
                    totalChilds: this.parent.childs.length
                }) + " ";
            }, I.prototype.isVisible = function() {
                return this.parent.expanded && this.parent.childs.length > this.parent.visibleChilds;
            }, I.prototype.onEvent = function(e) {
                "keydown" === e.type && this.onKeyDown(e);
            };
            var z = I;
            function I(e, t) {
                this.editor = e, this.parent = t, this.dom = {};
            }
            function A(e) {
                return (A = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                })(e);
            }
            function _(e, t) {
                for(var i = 0; i < t.length; i++){
                    var n = t[i];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, ((e)=>(e = ((e, t)=>{
                            if ("object" != A(e) || !e) return e;
                            var i = e[Symbol.toPrimitive];
                            if (void 0 === i) return ("string" === t ? String : Number)(e);
                            if ("object" != A(i = i.call(e, t || "default"))) return i;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        })(e, "string"), "symbol" == A(e) ? e : e + ""))(n.key), n);
                }
            }
            var X = (()=>{
                function e(t) {
                    if (!(this instanceof e)) throw new TypeError("Cannot call a class as a function");
                    function r(e) {
                        return t.node.findNodeByInternalPath(e);
                    }
                    this.editor = t, this.history = [], this.index = -1, this.clear(), this.actions = {
                        editField: {
                            undo: function(e) {
                                r(e.parentPath).childs[e.index].updateField(e.oldValue);
                            },
                            redo: function(e) {
                                r(e.parentPath).childs[e.index].updateField(e.newValue);
                            }
                        },
                        editValue: {
                            undo: function(e) {
                                r(e.path).updateValue(e.oldValue);
                            },
                            redo: function(e) {
                                r(e.path).updateValue(e.newValue);
                            }
                        },
                        changeType: {
                            undo: function(e) {
                                r(e.path).changeType(e.oldType);
                            },
                            redo: function(e) {
                                r(e.path).changeType(e.newType);
                            }
                        },
                        appendNodes: {
                            undo: function(e) {
                                var t = r(e.parentPath);
                                e.paths.map(r).forEach(function(e) {
                                    t.removeChild(e);
                                });
                            },
                            redo: function(e) {
                                var t = r(e.parentPath);
                                e.nodes.forEach(function(e) {
                                    t.appendChild(e);
                                });
                            }
                        },
                        insertBeforeNodes: {
                            undo: function(e) {
                                var t = r(e.parentPath);
                                e.paths.map(r).forEach(function(e) {
                                    t.removeChild(e);
                                });
                            },
                            redo: function(e) {
                                var t = r(e.parentPath), i = r(e.beforePath);
                                e.nodes.forEach(function(e) {
                                    t.insertBefore(e, i);
                                });
                            }
                        },
                        insertAfterNodes: {
                            undo: function(e) {
                                var t = r(e.parentPath);
                                e.paths.map(r).forEach(function(e) {
                                    t.removeChild(e);
                                });
                            },
                            redo: function(e) {
                                var t = r(e.parentPath), i = r(e.afterPath);
                                e.nodes.forEach(function(e) {
                                    t.insertAfter(e, i), i = e;
                                });
                            }
                        },
                        removeNodes: {
                            undo: function(e) {
                                var t = r(e.parentPath), i = t.childs[e.index] || t.append;
                                e.nodes.forEach(function(e) {
                                    t.insertBefore(e, i);
                                });
                            },
                            redo: function(e) {
                                var t = r(e.parentPath);
                                e.paths.map(r).forEach(function(e) {
                                    t.removeChild(e);
                                });
                            }
                        },
                        duplicateNodes: {
                            undo: function(e) {
                                var t = r(e.parentPath);
                                e.clonePaths.map(r).forEach(function(e) {
                                    t.removeChild(e);
                                });
                            },
                            redo: function(e) {
                                var n = r(e.parentPath), o = r(e.afterPath);
                                e.paths.map(r).forEach(function(e) {
                                    var t, i = e.clone();
                                    "object" === n.type && (t = n.getFieldNames(), i.field = (0, E.findUniqueName)(e.field, t)), n.insertAfter(i, o), o = i;
                                });
                            }
                        },
                        moveNodes: {
                            undo: function(i) {
                                var n = r(i.oldParentPath), e = r(i.newParentPath), o = n.childs[i.oldIndex] || n.append;
                                e.childs.slice(i.newIndex, i.newIndex + i.count).forEach(function(e, t) {
                                    e.field = i.fieldNames[t], n.moveBefore(e, o);
                                }), null === i.newParentPathRedo && (i.newParentPathRedo = e.getInternalPath());
                            },
                            redo: function(i) {
                                var e = r(i.oldParentPathRedo), n = r(i.newParentPathRedo), o = n.childs[i.newIndexRedo] || n.append;
                                e.childs.slice(i.oldIndexRedo, i.oldIndexRedo + i.count).forEach(function(e, t) {
                                    e.field = i.fieldNames[t], n.moveBefore(e, o);
                                });
                            }
                        },
                        sort: {
                            undo: function(e) {
                                var t = r(e.path);
                                t.hideChilds(), t.childs = e.oldChilds, t.updateDom({
                                    updateIndexes: !0
                                }), t.showChilds();
                            },
                            redo: function(e) {
                                var t = r(e.path);
                                t.hideChilds(), t.childs = e.newChilds, t.updateDom({
                                    updateIndexes: !0
                                }), t.showChilds();
                            }
                        },
                        transform: {
                            undo: function(e) {
                                r(e.path).setInternalValue(e.oldValue);
                            },
                            redo: function(e) {
                                r(e.path).setInternalValue(e.newValue);
                            }
                        }
                    };
                }
                var t, i, n;
                return t = e, i = [
                    {
                        key: "onChange",
                        value: function() {}
                    },
                    {
                        key: "add",
                        value: function(e, t) {
                            this.index++, this.history[this.index] = {
                                action: e,
                                params: t,
                                timestamp: new Date
                            }, this.index < this.history.length - 1 && this.history.splice(this.index + 1, this.history.length - this.index - 1), this.onChange();
                        }
                    },
                    {
                        key: "clear",
                        value: function() {
                            this.history = [], this.index = -1, this.onChange();
                        }
                    },
                    {
                        key: "canUndo",
                        value: function() {
                            return 0 <= this.index;
                        }
                    },
                    {
                        key: "canRedo",
                        value: function() {
                            return this.index < this.history.length - 1;
                        }
                    },
                    {
                        key: "undo",
                        value: function() {
                            if (this.canUndo()) {
                                var e = this.history[this.index];
                                if (e) {
                                    var t = this.actions[e.action];
                                    if (t && t.undo) {
                                        if (t.undo(e.params), e.params.oldSelection) try {
                                            this.editor.setDomSelection(e.params.oldSelection);
                                        } catch (e) {
                                            console.error(e);
                                        }
                                    } else console.error(new Error('unknown action "' + e.action + '"'));
                                }
                                this.index--, this.onChange();
                            }
                        }
                    },
                    {
                        key: "redo",
                        value: function() {
                            if (this.canRedo()) {
                                this.index++;
                                var e = this.history[this.index];
                                if (e) {
                                    var t = this.actions[e.action];
                                    if (t && t.redo) {
                                        if (t.redo(e.params), e.params.newSelection) try {
                                            this.editor.setDomSelection(e.params.newSelection);
                                        } catch (e) {
                                            console.error(e);
                                        }
                                    } else console.error(new Error('unknown action "' + e.action + '"'));
                                }
                                this.onChange();
                            }
                        }
                    },
                    {
                        key: "destroy",
                        value: function() {
                            this.editor = null, this.history = [], this.index = -1;
                        }
                    }
                ], _(t.prototype, i), n && _(t, n), Object.defineProperty(t, "prototype", {
                    writable: !1
                }), t;
            })();
            function L(e) {
                return (L = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                })(e);
            }
            function M(e, t) {
                for(var i = 0; i < t.length; i++){
                    var n = t[i];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, ((e)=>(e = ((e, t)=>{
                            if ("object" != L(e) || !e) return e;
                            var i = e[Symbol.toPrimitive];
                            if (void 0 === i) return ("string" === t ? String : Number)(e);
                            if ("object" != L(i = i.call(e, t || "default"))) return i;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        })(e, "string"), "symbol" == L(e) ? e : e + ""))(n.key), n);
                }
            }
            var Y = (()=>{
                function o(e, t) {
                    if (!(this instanceof o)) throw new TypeError("Cannot call a class as a function");
                    var i = this, e = (this.editor = e, this.timeout = void 0, this.delay = 200, this.lastText = void 0, this.results = null, this.dom = {}, this.dom.container = t, document.createElement("div")), t = ((this.dom.wrapper = e).className = "jsoneditor-search", t.appendChild(e), document.createElement("div")), t = ((this.dom.results = t).className = "jsoneditor-results", e.appendChild(t), document.createElement("div")), e = ((this.dom.input = t).className = "jsoneditor-frame", t.title = (0, a.Tl)("searchTitle"), e.appendChild(t), document.createElement("button")), n = (e.type = "button", e.className = "jsoneditor-refresh", t.appendChild(e), document.createElement("input")), e = (n.type = "text", (this.dom.search = n).oninput = function(e) {
                        i._onDelayedSearch(e);
                    }, n.onchange = function(e) {
                        i._onSearch();
                    }, n.onkeydown = function(e) {
                        i._onKeyDown(e);
                    }, n.onkeyup = function(e) {
                        i._onKeyUp(e);
                    }, e.onclick = function(e) {
                        n.select();
                    }, t.appendChild(n), document.createElement("button")), e = (e.type = "button", e.title = (0, a.Tl)("searchNextResultTitle"), e.className = "jsoneditor-next", e.onclick = function() {
                        i.next();
                    }, t.appendChild(e), document.createElement("button"));
                    e.type = "button", e.title = (0, a.Tl)("searchPreviousResultTitle"), e.className = "jsoneditor-previous", e.onclick = function() {
                        i.previous();
                    }, t.appendChild(e);
                }
                var e, t, i;
                return e = o, t = [
                    {
                        key: "next",
                        value: function(e) {
                            var t;
                            this.results && ((t = null !== this.resultIndex ? this.resultIndex + 1 : 0) > this.results.length - 1 && (t = 0), this._setActiveResult(t, e));
                        }
                    },
                    {
                        key: "previous",
                        value: function(e) {
                            var t, i;
                            this.results && (t = this.results.length - 1, i = null !== this.resultIndex ? this.resultIndex - 1 : t, this._setActiveResult(i = i < 0 ? t : i, e));
                        }
                    },
                    {
                        key: "_setActiveResult",
                        value: function(e, t) {
                            var i, n, o;
                            this.activeResult && (i = this.activeResult.node, "field" === this.activeResult.elem ? delete i.searchFieldActive : delete i.searchValueActive, i.updateDom()), this.results && this.results[e] ? (this.resultIndex = e, n = this.results[this.resultIndex].node, "field" === (o = this.results[this.resultIndex].elem) ? n.searchFieldActive = !0 : n.searchValueActive = !0, this.activeResult = this.results[this.resultIndex], n.updateDom(), n.scrollTo(function() {
                                t && n.focus(o);
                            })) : (this.resultIndex = void 0, this.activeResult = void 0);
                        }
                    },
                    {
                        key: "_clearDelay",
                        value: function() {
                            void 0 !== this.timeout && (clearTimeout(this.timeout), delete this.timeout);
                        }
                    },
                    {
                        key: "_onDelayedSearch",
                        value: function(e) {
                            this._clearDelay();
                            var t = this;
                            this.timeout = setTimeout(function(e) {
                                t._onSearch();
                            }, this.delay);
                        }
                    },
                    {
                        key: "_onSearch",
                        value: function(e) {
                            this._clearDelay();
                            var t = this.dom.search.value, t = 0 < t.length ? t : void 0;
                            if (t !== this.lastText || e) {
                                this.lastText = t, this.results = this.editor.search(t);
                                var e = this.results[0] ? this.results[0].node.MAX_SEARCH_RESULTS : 1 / 0, i = 0;
                                if (this.activeResult) {
                                    for(var n = 0; n < this.results.length; n++)if (this.results[n].node === this.activeResult.node) {
                                        i = n;
                                        break;
                                    }
                                }
                                this._setActiveResult(i, !1), void 0 !== t ? (t = this.results.length, this.dom.results.textContent = 0 === t ? "no\xa0results" : 1 === t ? "1\xa0result" : e < t ? e + "+\xa0results" : t + "\xa0results") : this.dom.results.textContent = "";
                            }
                        }
                    },
                    {
                        key: "_onKeyDown",
                        value: function(e) {
                            var t = e.which;
                            27 === t ? (this.dom.search.value = "", this._onSearch(), e.preventDefault(), e.stopPropagation()) : 13 === t && (e.ctrlKey ? this._onSearch(!0) : e.shiftKey ? this.previous() : this.next(), e.preventDefault(), e.stopPropagation());
                        }
                    },
                    {
                        key: "_onKeyUp",
                        value: function(e) {
                            var t = e.keyCode;
                            27 !== t && 13 !== t && this._onDelayedSearch(e);
                        }
                    },
                    {
                        key: "clear",
                        value: function() {
                            this.dom.search.value = "", this._onSearch();
                        }
                    },
                    {
                        key: "forceSearch",
                        value: function() {
                            this._onSearch(!0);
                        }
                    },
                    {
                        key: "isEmpty",
                        value: function() {
                            return "" === this.dom.search.value;
                        }
                    },
                    {
                        key: "destroy",
                        value: function() {
                            this.editor = null, this.dom.container.removeChild(this.dom.wrapper), this.dom = null, this.results = null, this.activeResult = null, this._clearDelay();
                        }
                    }
                ], M(e.prototype, t), i && M(e, i), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), e;
            })();
            function N(e) {
                return (N = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                })(e);
            }
            function W(e, t) {
                for(var i = 0; i < t.length; i++){
                    var n = t[i];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, ((e)=>(e = ((e, t)=>{
                            if ("object" != N(e) || !e) return e;
                            var i = e[Symbol.toPrimitive];
                            if (void 0 === i) return ("string" === t ? String : Number)(e);
                            if ("object" != N(i = i.call(e, t || "default"))) return i;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        })(e, "string"), "symbol" == N(e) ? e : e + ""))(n.key), n);
                }
            }
            var J = (()=>{
                function i(e, t) {
                    if (!(this instanceof i)) throw new TypeError("Cannot call a class as a function");
                    e && (this.root = t, this.path = document.createElement("div"), this.path.className = "jsoneditor-treepath", this.path.setAttribute("tabindex", 0), this.contentMenuClicked = !1, e.appendChild(this.path), this.reset());
                }
                var e, t, n;
                return e = i, t = [
                    {
                        key: "reset",
                        value: function() {
                            this.path.textContent = (0, a.Tl)("selectNode");
                        }
                    },
                    {
                        key: "setPath",
                        value: function(o) {
                            var r = this;
                            this.path.textContent = "", o && o.length && o.forEach(function(i, n) {
                                var e, t = document.createElement("span");
                                t.className = "jsoneditor-treepath-element", t.innerText = i.name, t.onclick = (function(e) {
                                    this.selectionCallback && this.selectionCallback(e);
                                }).bind(r, i), r.path.appendChild(t), i.children.length && ((e = document.createElement("span")).className = "jsoneditor-treepath-seperator", e.textContent = "\u25BA", e.onclick = function() {
                                    r.contentMenuClicked = !0;
                                    var t = [];
                                    i.children.forEach(function(e) {
                                        t.push({
                                            text: e.name,
                                            className: "jsoneditor-type-modes" + (o[n + 1] + 1 && o[n + 1].name === e.name ? " jsoneditor-selected" : ""),
                                            click: (function(e, t) {
                                                this.contextMenuCallback && this.contextMenuCallback(e, t);
                                            }).bind(r, i, e.name)
                                        });
                                    }), new s.t(t, {
                                        limitHeight: !0
                                    }).show(e, r.root, !0);
                                }, r.path.appendChild(e)), n === o.length - 1 && (t = (e || t).getBoundingClientRect().right, r.path.offsetWidth < t && (r.path.scrollLeft = t), r.path.scrollLeft) && ((t = document.createElement("span")).className = "jsoneditor-treepath-show-all-btn", t.title = "show all path", t.textContent = "...", t.onclick = (function(e) {
                                    (r.contentMenuClicked = !1, E.addClassName)(r.path, "show-all"), r.path.style.width = r.path.parentNode.getBoundingClientRect().width - 10 + "px", r.path.onblur = function() {
                                        r.contentMenuClicked ? (r.contentMenuClicked = !1, r.path.focus()) : ((0, E.removeClassName)(r.path, "show-all"), r.path.onblur = void 0, r.path.style.width = "", r.setPath(e));
                                    };
                                }).bind(r, o), r.path.insertBefore(t, r.path.firstChild));
                            });
                        }
                    },
                    {
                        key: "onSectionSelected",
                        value: function(e) {
                            "function" == typeof e && (this.selectionCallback = e);
                        }
                    },
                    {
                        key: "onContextMenuItemSelected",
                        value: function(e) {
                            "function" == typeof e && (this.contextMenuCallback = e);
                        }
                    }
                ], W(e.prototype, t), n && W(e, n), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), e;
            })(), e = t(1746), U = t.n(e), t = {
                create: function(e, t) {
                    if (!e) throw new Error("No container element provided.");
                    this.container = e, this.dom = {}, this.highlighter = new H, this.selection = void 0, this.multiselection = {
                        nodes: []
                    }, this.validateSchema = null, this.validationSequence = 0, this.errorNodes = [], this.lastSchemaErrors = void 0, this.node = null, this.focusTarget = null, this._setOptions(t), t.autocomplete && (this.autocomplete = O(t.autocomplete)), this.options.history && "view" !== this.options.mode && (this.history = new X(this)), this._createFrame(), this._createTable();
                },
                destroy: function() {
                    this.frame && this.container && this.frame.parentNode === this.container && (this.container.removeChild(this.frame), this.frame = null), this.container = null, this.dom = null, this.clear(), this.node = null, this.focusTarget = null, this.selection = null, this.multiselection = null, this.errorNodes = null, this.validateSchema = null, this._debouncedValidate = null, this.history && (this.history.destroy(), this.history = null), this.searchBox && (this.searchBox.destroy(), this.searchBox = null), this.modeSwitcher && (this.modeSwitcher.destroy(), this.modeSwitcher = null), this.frameFocusTracker.destroy();
                },
                _setOptions: function(t) {
                    var i = this;
                    this.options = {
                        search: !0,
                        history: !0,
                        mode: "tree",
                        name: void 0,
                        schema: null,
                        schemaRefs: null,
                        autocomplete: null,
                        navigationBar: !0,
                        mainMenuBar: !0,
                        limitDragging: !1,
                        onSelectionChange: null,
                        colorPicker: !0,
                        onColorPicker: function(e, t, i) {
                            var n;
                            U() ? (n = e.getBoundingClientRect().top, n = (0, E.getWindow)(e).innerHeight - n < 300 && 300 < n, new (U())({
                                parent: e,
                                color: t,
                                popup: n ? "top" : "bottom",
                                onDone: function(e) {
                                    e = 1 === e.rgba[3] ? e.hex.substr(0, 7) : e.hex;
                                    i(e);
                                }
                            }).show()) : console.warn("Cannot open color picker: the `vanilla-picker` library is not included in the bundle. Either use the full bundle or implement your own color picker using `onColorPicker`.");
                        },
                        timestampTag: !0,
                        timestampFormat: null,
                        createQuery: l.V,
                        executeQuery: l.e,
                        onEvent: null,
                        enableSort: !0,
                        enableTransform: !0
                    }, t && (Object.keys(t).forEach(function(e) {
                        i.options[e] = t[e];
                    }), null == t.limitDragging) && null != t.schema && (this.options.limitDragging = !0), this.setSchema(this.options.schema, this.options.schemaRefs), this._debouncedValidate = (0, E.debounce)(this._validateAndCatch.bind(this), this.DEBOUNCE_INTERVAL), t.onSelectionChange && this.onSelectionChange(t.onSelectionChange), (0, a.AI)(this.options.languages), (0, a.xC)(this.options.language);
                },
                set: function(e) {
                    e instanceof Function || void 0 === e ? this.clear() : (this.content.removeChild(this.table), e = {
                        field: this.options.name,
                        value: e
                    }, e = new b(this, e), this._setRoot(e), this._validateAndCatch(), this.node.expand(!1), this.content.appendChild(this.table)), this.history && this.history.clear(), this.searchBox && this.searchBox.clear();
                },
                update: function(e) {
                    var t, i;
                    this.node.deepEqual(e) || (t = this.getSelection(), this.onChangeDisabled = !0, this.node.update(e), this.onChangeDisabled = !1, this._validateAndCatch(), this.searchBox && !this.searchBox.isEmpty() && this.searchBox.forceSearch(), t && t.start && t.end && (e = this.node.findNodeByPath(t.start.path), i = this.node.findNodeByPath(t.end.path), e) && i ? this.setSelection(t.start, t.end) : this.setSelection({}, {}));
                },
                get: function() {
                    if (this.node) return this.node.getValue();
                },
                getText: function() {
                    return JSON.stringify(this.get());
                },
                setText: function(t) {
                    try {
                        this.set((0, E.parse)(t));
                    } catch (e) {
                        t = (0, E.tryJsonRepair)(t);
                        this.set((0, E.parse)(t));
                    }
                },
                updateText: function(t) {
                    try {
                        this.update((0, E.parse)(t));
                    } catch (e) {
                        t = (0, E.tryJsonRepair)(t);
                        this.update((0, E.parse)(t));
                    }
                },
                setName: function(e) {
                    this.options.name = e, this.node && this.node.updateField(this.options.name);
                },
                getName: function() {
                    return this.options.name;
                },
                focus: function() {
                    var e = this.scrollableContent.querySelector("[contenteditable=true]");
                    e ? e.focus() : this.node.dom.expand ? this.node.dom.expand.focus() : this.node.dom.menu ? this.node.dom.menu.focus() : (e = this.frame.querySelector("button")) && e.focus();
                },
                clear: function() {
                    this.node && (this.node.hide(), delete this.node), this.treePath && this.treePath.reset();
                },
                _setRoot: function(e) {
                    this.clear(), (this.node = e).setParent(null), e.setField(this.getName(), !1), delete e.index, this.tbody.appendChild(e.getDom());
                },
                search: function(e) {
                    var t;
                    return this.node ? (this.content.removeChild(this.table), t = this.node.search(e), this.content.appendChild(this.table)) : t = [], t;
                },
                expandAll: function() {
                    this.node && (this.content.removeChild(this.table), this.node.expand(), this.content.appendChild(this.table));
                },
                collapseAll: function() {
                    this.node && (this.content.removeChild(this.table), this.node.collapse(), this.content.appendChild(this.table));
                },
                expand: function(e) {
                    if (e && this.node) {
                        var t = this.node.findNodeByPath(e.path);
                        if (t) {
                            if (e.withPath) for(var i = 0; i < e.path.length; i++){
                                var n = this.node.findNodeByPath(e.path.slice(0, i));
                                n && (e.isExpand ? n.expand(!1) : n.collapse(!1));
                            }
                            e.isExpand ? t.expand(e.recursive) : t.collapse(e.recursive);
                        }
                    }
                },
                _onAction: function(e, t) {
                    this.history && this.history.add(e, t), this._onChange();
                },
                _onChange: function() {
                    if (!this.onChangeDisabled) {
                        var e;
                        if (this.selection = this.getDomSelection(), this._debouncedValidate(), this.treePath && ((e = this.node && this.selection ? this.node.findNodeByInternalPath(this.selection.path) : this.multiselection ? this.multiselection.nodes[0] : void 0) ? this._updateTreePath(e.getNodePath()) : this.treePath.reset()), this.options.onChange) try {
                            this.options.onChange();
                        } catch (e) {
                            console.error("Error in onChange callback: ", e);
                        }
                        if (this.options.onChangeJSON) try {
                            this.options.onChangeJSON(this.get());
                        } catch (e) {
                            console.error("Error in onChangeJSON callback: ", e);
                        }
                        if (this.options.onChangeText) try {
                            this.options.onChangeText(this.getText());
                        } catch (e) {
                            console.error("Error in onChangeText callback: ", e);
                        }
                        if (this.options.onClassName && this.node.recursivelyUpdateCssClassesOnNodes(), this.options.onNodeName && this.node.childs) try {
                            this.node.recursivelyUpdateNodeName();
                        } catch (e) {
                            console.error("Error in onNodeName callback: ", e);
                        }
                    }
                },
                validate: function() {
                    var t = this, i = this.node;
                    if (!i) return Promise.resolve([]);
                    var e = i.getValue(), n = [];
                    this.validateSchema && !this.validateSchema(e) && (n = this.validateSchema.errors.map(function(e) {
                        return (0, E.improveSchemaError)(e);
                    }).map(function(e) {
                        return {
                            node: i.findNode(e.dataPath),
                            error: e,
                            type: "validation"
                        };
                    }).filter(function(e) {
                        return null != e.node;
                    }));
                    try {
                        this.validationSequence++;
                        var o = this, r = this.validationSequence;
                        return this._validateCustom(e).then(function(e) {
                            return r === o.validationSequence && (e = [].concat(n, e || []), o._renderValidationErrors(e), "function" == typeof t.options.onValidationError && (0, E.isValidationErrorChanged)(e, t.lastSchemaErrors) && t.options.onValidationError.call(t, e), t.lastSchemaErrors = e), t.lastSchemaErrors;
                        });
                    } catch (e) {
                        return Promise.reject(e);
                    }
                },
                _validateAndCatch: function() {
                    this.validate().catch(function(e) {
                        console.error("Error running validation:", e);
                    });
                },
                _renderValidationErrors: function(e) {
                    this.errorNodes && this.errorNodes.forEach(function(e) {
                        e.setError(null);
                    });
                    var t = e.reduce(function(e, t) {
                        return t.node.findParents().filter(function(t) {
                            return !e.some(function(e) {
                                return e[0] === t;
                            });
                        }).map(function(e) {
                            return [
                                e,
                                t.node
                            ];
                        }).concat(e);
                    }, []);
                    this.errorNodes = t.map(function(e) {
                        return {
                            node: e[0],
                            child: e[1],
                            error: {
                                message: "object" === e[0].type ? (0, a.Tl)("containsInvalidProperties") : (0, a.Tl)("containsInvalidItems")
                            }
                        };
                    }).concat(e).map(function(e) {
                        return e.node.setError(e.error, e.child), e.node;
                    });
                },
                _validateCustom: function(e) {
                    try {
                        var i, t;
                        if (this.options.onValidate) return i = this.node, t = this.options.onValidate(e), ((0, E.isPromise)(t) ? t : Promise.resolve(t)).then(function(e) {
                            return Array.isArray(e) ? e.filter(function(e) {
                                var t = (0, E.isValidValidationError)(e);
                                return t || console.warn('Ignoring a custom validation error with invalid structure. Expected structure: {path: [...], message: "..."}. Actual error:', e), t;
                            }).map(function(e) {
                                var t;
                                try {
                                    t = e && e.path ? i.findNodeByPath(e.path) : null;
                                } catch (e) {}
                                return t || console.warn("Ignoring validation error: node not found. Path:", e.path, "Error:", e), {
                                    node: t,
                                    error: e,
                                    type: "customValidation"
                                };
                            }).filter(function(e) {
                                return e && e.node && e.error && e.error.message;
                            }) : null;
                        });
                    } catch (e) {
                        return Promise.reject(e);
                    }
                    return Promise.resolve(null);
                },
                refresh: function() {
                    this.node && this.node.updateDom({
                        recurse: !0
                    });
                },
                startAutoScroll: function(e) {
                    var t = this, i = this.scrollableContent, n = (0, E.getAbsoluteTop)(i), o = i.clientHeight, r = n + o;
                    e < n + 24 && 0 < i.scrollTop ? this.autoScrollStep = (n + 24 - e) / 3 : r - 24 < e && o + i.scrollTop < i.scrollHeight ? this.autoScrollStep = (r - 24 - e) / 3 : this.autoScrollStep = void 0, this.autoScrollStep ? this.autoScrollTimer || (this.autoScrollTimer = setInterval(function() {
                        t.autoScrollStep ? i.scrollTop -= t.autoScrollStep : t.stopAutoScroll();
                    }, 50)) : this.stopAutoScroll();
                },
                stopAutoScroll: function() {
                    this.autoScrollTimer && (clearTimeout(this.autoScrollTimer), delete this.autoScrollTimer), this.autoScrollStep && delete this.autoScrollStep;
                },
                setDomSelection: function(e) {
                    var t, i, n;
                    e && ("scrollTop" in e && this.scrollableContent && (this.scrollableContent.scrollTop = e.scrollTop), e.paths ? (t = this, i = e.paths.map(function(e) {
                        return t.node.findNodeByInternalPath(e);
                    }), this.select(i)) : (n = (i = e.path ? this.node.findNodeByInternalPath(e.path) : null) && e.domName ? i.dom[e.domName] : null, e.range && n ? (e = Object.assign({}, e.range, {
                        container: n
                    }), (0, E.setSelectionOffset)(e)) : i && i.focus()));
                },
                getDomSelection: function() {
                    var t = b.getNodeFromTarget(this.focusTarget), i = this.focusTarget, e = t ? Object.keys(t.dom).find(function(e) {
                        return t.dom[e] === i;
                    }) : null, n = (0, E.getSelectionOffset)();
                    return (n = (n = n && "DIV" !== n.container.nodeName ? null : n) && n.container !== i ? null : n) && delete n.container, {
                        path: t ? t.getInternalPath() : null,
                        domName: e,
                        range: n,
                        paths: 0 < this.multiselection.length ? this.multiselection.nodes.map(function(e) {
                            return e.getInternalPath();
                        }) : null,
                        scrollTop: this.scrollableContent ? this.scrollableContent.scrollTop : 0
                    };
                },
                scrollTo: function(e, t) {
                    var i, n, o, r, s, a = this.scrollableContent;
                    a ? ((i = this).animateTimeout && (clearTimeout(i.animateTimeout), delete i.animateTimeout), i.animateCallback && (i.animateCallback(!1), delete i.animateCallback), n = a.clientHeight, o = a.scrollHeight - n, r = Math.min(Math.max(e - n / 4, 0), o), (s = function() {
                        var e = a.scrollTop, e = r - e;
                        3 < Math.abs(e) ? (a.scrollTop += e / 3, i.animateCallback = t, i.animateTimeout = setTimeout(s, 50)) : (t && t(!0), a.scrollTop = r, delete i.animateTimeout, delete i.animateCallback);
                    })()) : t && t(!1);
                },
                _createFrame: function() {
                    var e = this, t = (this.frame = document.createElement("div"), this.frame.className = "jsoneditor jsoneditor-mode-" + this.options.mode, this.container.appendChild(this.frame), this.contentOuter = document.createElement("div"), this.contentOuter.className = "jsoneditor-outer", this);
                    function i(e) {
                        t._onEvent && t._onEvent(e);
                    }
                    var n, o, r, s = {
                        target: this.frame,
                        onFocus: this.options.onFocus || null,
                        onBlur: this.options.onBlur || null
                    };
                    this.frameFocusTracker = new P.$(s), this.frame.onclick = function(e) {
                        var t = e.target;
                        i(e), "BUTTON" === t.nodeName && e.preventDefault();
                    }, this.frame.oninput = i, this.frame.onchange = i, this.frame.onkeydown = i, this.frame.onkeyup = i, this.frame.oncut = i, this.frame.onpaste = i, this.frame.onmousedown = i, this.frame.onmouseup = i, this.frame.onmouseover = i, this.frame.onmouseout = i, (0, E.addEventListener)(this.frame, "focus", i, !0), (0, E.addEventListener)(this.frame, "blur", i, !0), this.frame.onfocusin = i, this.frame.onfocusout = i, this.options.mainMenuBar && ((0, E.addClassName)(this.contentOuter, "has-main-menu-bar"), this.menu = document.createElement("div"), this.menu.className = "jsoneditor-menu", this.frame.appendChild(this.menu), (s = document.createElement("button")).type = "button", s.className = "jsoneditor-expand-all", s.title = (0, a.Tl)("expandAll"), s.onclick = function() {
                        t.expandAll(), "function" == typeof e.options.onExpand && e.options.onExpand({
                            path: [],
                            isExpand: !0,
                            recursive: !0
                        });
                    }, this.menu.appendChild(s), (s = document.createElement("button")).type = "button", s.title = (0, a.Tl)("collapseAll"), s.className = "jsoneditor-collapse-all", s.onclick = function() {
                        t.collapseAll(), "function" == typeof e.options.onExpand && e.options.onExpand({
                            path: [],
                            isExpand: !1,
                            recursive: !0
                        });
                    }, this.menu.appendChild(s), this.options.enableSort && ((s = document.createElement("button")).type = "button", s.className = "jsoneditor-sort", s.title = (0, a.Tl)("sortTitleShort"), s.onclick = function() {
                        t.node.showSortModal();
                    }, this.menu.appendChild(s)), this.options.enableTransform && ((s = document.createElement("button")).type = "button", s.title = (0, a.Tl)("transformTitleShort"), s.className = "jsoneditor-transform", s.onclick = function() {
                        t.node.showTransformModal();
                    }, this.menu.appendChild(s)), this.history && ((n = document.createElement("button")).type = "button", n.className = "jsoneditor-undo jsoneditor-separator", n.title = (0, a.Tl)("undo"), n.onclick = function() {
                        t._onUndo();
                    }, this.menu.appendChild(n), this.dom.undo = n, (o = document.createElement("button")).type = "button", o.className = "jsoneditor-redo", o.title = (0, a.Tl)("redo"), o.onclick = function() {
                        t._onRedo();
                    }, this.menu.appendChild(o), this.dom.redo = o, this.history.onChange = function() {
                        n.disabled = !t.history.canUndo(), o.disabled = !t.history.canRedo();
                    }, this.history.onChange()), this.options && this.options.modes && this.options.modes.length && ((r = this).modeSwitcher = new G.n(this.menu, this.options.modes, this.options.mode, function(e) {
                        try {
                            r.setMode(e), r.modeSwitcher.focus();
                        } catch (e) {
                            r._onError(e);
                        }
                    })), this.options.search) && (this.searchBox = new Y(this, this.menu)), this.options.navigationBar && (this.navBar = document.createElement("div"), this.navBar.className = "jsoneditor-navigation-bar nav-bar-empty", this.frame.appendChild(this.navBar), this.treePath = new J(this.navBar, this.getPopupAnchor()), this.treePath.onSectionSelected(this._onTreePathSectionSelected.bind(this)), this.treePath.onContextMenuItemSelected(this._onTreePathMenuItemSelected.bind(this)));
                },
                _onUndo: function() {
                    this.history && (this.history.undo(), this._onChange());
                },
                _onRedo: function() {
                    this.history && (this.history.redo(), this._onChange());
                },
                _onEvent: function(e) {
                    if (!b.targetIsColorPicker(e.target)) {
                        var t, i = b.getNodeFromTarget(e.target);
                        if ("keydown" === e.type && this._onKeyDown(e), i && "focus" === e.type && (this.focusTarget = e.target, this.options.autocomplete) && "focus" === this.options.autocomplete.trigger && this._showAutoComplete(e.target), "mousedown" === e.type && this._startDragDistance(e), "mousemove" !== e.type && "mouseup" !== e.type && "click" !== e.type || this._updateDragDistance(e), i && this.options && this.options.navigationBar && i && ("keydown" === e.type || "mousedown" === e.type) && (t = this, setTimeout(function() {
                            t._updateTreePath(i.getNodePath());
                        })), i && i.selected) {
                            if ("click" === e.type) {
                                if (e.target === i.dom.menu) return void this.showContextMenu(e.target);
                                e.hasMoved || this.deselect();
                            }
                            "mousedown" === e.type && b.onDragStart(this.multiselection.nodes, e);
                        } else "mousedown" === e.type && (0, E.hasParentNode)(e.target, this.content) && (this.deselect(), i && e.target === i.dom.drag ? b.onDragStart(i, e) : i && (e.target === i.dom.field || e.target === i.dom.value || e.target === i.dom.select) || this._onMultiSelectStart(e));
                        i && i.onEvent(e);
                    }
                },
                _updateTreePath: function(e) {
                    var i;
                    function n(e) {
                        return e.parent ? "array" === e.parent.type ? e.index : e.field : e.field || e.type;
                    }
                    e && e.length ? ((0, E.removeClassName)(this.navBar, "nav-bar-empty"), i = [], e.forEach(function(e) {
                        var t = {
                            name: n(e),
                            node: e,
                            children: []
                        };
                        e.childs && e.childs.length && e.childs.forEach(function(e) {
                            t.children.push({
                                name: n(e),
                                node: e
                            });
                        }), i.push(t);
                    }), this.treePath.setPath(i)) : (0, E.addClassName)(this.navBar, "nav-bar-empty");
                },
                _onTreePathSectionSelected: function(e) {
                    e && e.node && (e.node.expandTo(), e.node.focus());
                },
                _onTreePathMenuItemSelected: function(e, t) {
                    e && e.children.length && (e = e.children.find(function(e) {
                        return e.name === t;
                    })) && e.node && (this._updateTreePath(e.node.getNodePath()), e.node.expandTo(), e.node.focus());
                },
                _startDragDistance: function(e) {
                    this.dragDistanceEvent = {
                        initialTarget: e.target,
                        initialPageX: e.pageX,
                        initialPageY: e.pageY,
                        dragDistance: 0,
                        hasMoved: !1
                    };
                },
                _updateDragDistance: function(e) {
                    this.dragDistanceEvent || this._startDragDistance(e);
                    var t = e.pageX - this.dragDistanceEvent.initialPageX, i = e.pageY - this.dragDistanceEvent.initialPageY;
                    return this.dragDistanceEvent.dragDistance = Math.sqrt(t * t + i * i), this.dragDistanceEvent.hasMoved = this.dragDistanceEvent.hasMoved || 10 < this.dragDistanceEvent.dragDistance, e.dragDistance = this.dragDistanceEvent.dragDistance, e.hasMoved = this.dragDistanceEvent.hasMoved, e.dragDistance;
                },
                _onMultiSelectStart: function(e) {
                    var t, i = b.getNodeFromTarget(e.target);
                    "tree" === this.options.mode && void 0 === this.options.onEditable && (this.multiselection = {
                        start: i || null,
                        end: null,
                        nodes: []
                    }, this._startDragDistance(e), (t = this).mousemove || (this.mousemove = (0, E.addEventListener)(e.view, "mousemove", function(e) {
                        t._onMultiSelect(e);
                    })), this.mouseup || (this.mouseup = (0, E.addEventListener)(e.view, "mouseup", function(e) {
                        t._onMultiSelectEnd(e);
                    })), e.preventDefault());
                },
                _onMultiSelect: function(e) {
                    var t;
                    e.preventDefault(), this._updateDragDistance(e), e.hasMoved && ((e = b.getNodeFromTarget(e.target)) && (null == this.multiselection.start && (this.multiselection.start = e), this.multiselection.end = e), this.deselect(), e = this.multiselection.start, t = this.multiselection.end || this.multiselection.start, e) && t && (this.multiselection.nodes = this._findTopLevelNodes(e, t), this.multiselection.nodes && this.multiselection.nodes.length && (e = this.multiselection.nodes[0], this.multiselection.start === e || this.multiselection.start.isDescendantOf(e) ? this.multiselection.direction = "down" : this.multiselection.direction = "up"), this.select(this.multiselection.nodes));
                },
                _onMultiSelectEnd: function(e) {
                    var t = this.multiselection.nodes[0];
                    t && t.dom.menu && t.dom.menu.focus(), this.multiselection.start = null, this.multiselection.end = null, this.mousemove && ((0, E.removeEventListener)(e.view, "mousemove", this.mousemove), delete this.mousemove), this.mouseup && ((0, E.removeEventListener)(e.view, "mouseup", this.mouseup), delete this.mouseup);
                },
                deselect: function(e) {
                    var t = !!this.multiselection.nodes.length;
                    this.multiselection.nodes.forEach(function(e) {
                        e.setSelected(!1);
                    }), this.multiselection.nodes = [], e && (this.multiselection.start = null, this.multiselection.end = null), t && this._selectionChangedHandler && this._selectionChangedHandler();
                },
                select: function(e) {
                    if (!Array.isArray(e)) return this.select([
                        e
                    ]);
                    var t;
                    e && (this.deselect(), this.multiselection.nodes = e.slice(0), t = e[0], e.forEach(function(e) {
                        e.expandPathToNode(), e.setSelected(!0, e === t);
                    }), this._selectionChangedHandler) && (e = this.getSelection(), this._selectionChangedHandler(e.start, e.end));
                },
                _findTopLevelNodes: function(e, t) {
                    for(var i = e.getNodePath(), n = t.getNodePath(), o = 0; o < i.length && i[o] === n[o];)o++;
                    var r, e = i[o - 1], t = i[o], s = n[o];
                    return t && s || (e.parent ? e = (s = t = e).parent : (t = e.childs[0], s = e.childs[e.childs.length - 1])), e && t && s ? (t = e.childs.indexOf(t), s = e.childs.indexOf(s), r = Math.min(t, s), t = Math.max(t, s), e.childs.slice(r, t + 1)) : [];
                },
                _showAutoComplete: function(t) {
                    var i, n = b.getNodeFromTarget(t), o = "";
                    0 <= t.className.indexOf("jsoneditor-value") && (o = "value"), "" !== (o = 0 <= t.className.indexOf("jsoneditor-field") ? "field" : o) && (i = this, setTimeout(function() {
                        var e;
                        !n || !("focus" === i.options.autocomplete.trigger || 0 < t.innerText.length) || null === (e = i.options.autocomplete.getOptions(t.innerText, n.getPath(), o, n.editor)) ? i.autocomplete.hideDropDown() : "function" == typeof e.then ? e.then(function(e) {
                            null === e ? i.autocomplete.hideDropDown() : e.options ? i.autocomplete.show(t, e.startFrom, e.options) : i.autocomplete.show(t, 0, e);
                        }).catch(function(e) {
                            console.error(e);
                        }) : e.options ? i.autocomplete.show(t, e.startFrom, e.options) : i.autocomplete.show(t, 0, e);
                    }, 50));
                },
                _onKeyDown: function(e) {
                    var t, i = e.which || e.keyCode, n = e.altKey, o = e.ctrlKey, r = e.metaKey, s = e.shiftKey, a = !1, l = this.focusTarget;
                    9 === i && (t = this, setTimeout(function() {
                        t.focusTarget !== l && (0, E.selectContentEditable)(t.focusTarget);
                    }, 0)), this.searchBox && (o && 70 === i ? (this.searchBox.dom.search.focus(), this.searchBox.dom.search.select(), a = !0) : (114 === i || o && 71 === i) && (s ? this.searchBox.previous(!0) : this.searchBox.next(!0), a = !0)), this.history && (o && !s && 90 === i ? (this._onUndo(), a = !0) : o && s && 90 === i && (this._onRedo(), a = !0)), !this.options.autocomplete || a || o || n || r || 1 !== e.key.length && 8 !== i && 46 !== i || (a = !1, this._showAutoComplete(e.target)), a && (e.preventDefault(), e.stopPropagation());
                },
                _createTable: function() {
                    var e;
                    this.options.navigationBar && (0, E.addClassName)(this.contentOuter, "has-nav-bar"), this.scrollableContent = document.createElement("div"), this.scrollableContent.className = "jsoneditor-tree", this.contentOuter.appendChild(this.scrollableContent), this.content = document.createElement("div"), this.content.className = "jsoneditor-tree-inner", this.scrollableContent.appendChild(this.content), this.table = document.createElement("table"), this.table.className = "jsoneditor-tree", this.content.appendChild(this.table), this.colgroupContent = document.createElement("colgroup"), "tree" === this.options.mode && ((e = document.createElement("col")).width = "24px", this.colgroupContent.appendChild(e)), (e = document.createElement("col")).width = "24px", this.colgroupContent.appendChild(e), e = document.createElement("col"), this.colgroupContent.appendChild(e), this.table.appendChild(this.colgroupContent), this.tbody = document.createElement("tbody"), this.table.appendChild(this.tbody), this.frame.appendChild(this.contentOuter);
                },
                showContextMenu: function(e, t) {
                    var i, n = [], o = this.multiselection.nodes.slice();
                    n.push({
                        text: (0, a.Tl)("duplicateText"),
                        title: (0, a.Tl)("duplicateTitle"),
                        className: "jsoneditor-duplicate",
                        click: function() {
                            b.onDuplicate(o);
                        }
                    }), n.push({
                        text: (0, a.Tl)("remove"),
                        title: (0, a.Tl)("removeTitle"),
                        className: "jsoneditor-remove",
                        click: function() {
                            b.onRemove(o);
                        }
                    }), this.options.onCreateMenu && (i = o.map(function(e) {
                        return e.getPath();
                    }), n = this.options.onCreateMenu(n, {
                        type: "multiple",
                        path: i[0],
                        paths: i
                    })), new s.t(n, {
                        close: t
                    }).show(e, this.getPopupAnchor());
                },
                getPopupAnchor: function() {
                    return this.options.popupAnchor || this.frame;
                },
                getSelection: function() {
                    var e, t, i = {
                        start: null,
                        end: null
                    };
                    return this.multiselection.nodes && this.multiselection.nodes.length && (e = this.multiselection.nodes[0], t = this.multiselection.nodes[this.multiselection.nodes.length - 1], "down" === this.multiselection.direction ? (i.start = e.serialize(), i.end = t.serialize()) : (i.start = t.serialize(), i.end = e.serialize())), i;
                },
                onSelectionChange: function(e) {
                    "function" == typeof e && (this._selectionChangedHandler = (0, E.debounce)(e, this.DEBOUNCE_INTERVAL));
                },
                setSelection: function(e, t) {
                    e && e.dom && e.range && (console.warn("setSelection/getSelection usage for text selection is deprecated and should not be used, see documentation for supported selection options"), this.setDomSelection(e));
                    e = this._getNodeInstancesByRange(e, t);
                    e.forEach(function(e) {
                        e.expandTo();
                    }), this.select(e);
                },
                _getNodeInstancesByRange: function(e, t) {
                    e && e.path && (i = this.node.findNodeByPath(e.path), t) && t.path && (n = this.node.findNodeByPath(t.path));
                    var i, n, o = [];
                    if (i instanceof b) {
                        if (n instanceof b && n !== i) {
                            if (i.parent === n.parent) {
                                t = i.getIndex() < n.getIndex() ? (e = i, n) : (e = n, i);
                                var r = e;
                                for(o.push(r); r = r.nextSibling(), o.push(r), r && r !== t;);
                            } else o = this._findTopLevelNodes(i, n);
                        } else o.push(i);
                    }
                    return o;
                },
                getNodesByRange: function(e, t) {
                    var e = this._getNodeInstancesByRange(e, t), i = [];
                    return e.forEach(function(e) {
                        i.push(e.serialize());
                    }), i;
                }
            }, Q = [
                {
                    mode: "tree",
                    mixin: t,
                    data: "json"
                },
                {
                    mode: "view",
                    mixin: t,
                    data: "json"
                },
                {
                    mode: "form",
                    mixin: t,
                    data: "json"
                }
            ];
        },
        2870: function(e, t, i) {
            t.tryRequireAjv = function() {
                try {
                    return i(2229);
                } catch (e) {}
            };
        },
        5467: function(e, t, i) {
            t.J = function() {
                try {
                    i(9762);
                } catch (e) {
                    console.error(e);
                }
            };
        },
        6237: function(B, e, t) {
            t.r(e), t.d(e, {
                addClassName: function() {
                    return P;
                },
                addEventListener: function() {
                    return X;
                },
                asyncExec: function() {
                    return Ie;
                },
                clear: function() {
                    return C;
                },
                compileJSONPointer: function() {
                    return _;
                },
                contains: function() {
                    return Ce;
                },
                debounce: function() {
                    return ie;
                },
                escapeUnicodeChars: function() {
                    return p;
                },
                extend: function() {
                    return f;
                },
                findUniqueName: function() {
                    return ce;
                },
                formatSize: function() {
                    return me;
                },
                get: function() {
                    return M;
                },
                getAbsoluteLeft: function() {
                    return D;
                },
                getAbsoluteTop: function() {
                    return O;
                },
                getChildPaths: function() {
                    return he;
                },
                getColorCSS: function() {
                    return L;
                },
                getIndexForPosition: function() {
                    return re;
                },
                getInnerText: function() {
                    return k;
                },
                getInputSelection: function() {
                    return oe;
                },
                getInternetExplorerVersion: function() {
                    return z;
                },
                getPositionForPath: function() {
                    return se;
                },
                getSelection: function() {
                    return x;
                },
                getSelectionOffset: function() {
                    return Z;
                },
                getType: function() {
                    return y;
                },
                getWindow: function() {
                    return A;
                },
                hasParentNode: function() {
                    return K;
                },
                improveSchemaError: function() {
                    return Q;
                },
                insideRect: function() {
                    return te;
                },
                isArray: function() {
                    return b;
                },
                isChildOf: function() {
                    return J;
                },
                isFirefox: function() {
                    return R;
                },
                isObject: function() {
                    return N;
                },
                isPromise: function() {
                    return q;
                },
                isTimestamp: function() {
                    return pe;
                },
                isUrl: function() {
                    return I;
                },
                isValidColor: function() {
                    return ae;
                },
                isValidValidationError: function() {
                    return ee;
                },
                isValidationErrorChanged: function() {
                    return ye;
                },
                limitCharacters: function() {
                    return fe;
                },
                makeFieldTooltip: function() {
                    return le;
                },
                parse: function() {
                    return u;
                },
                parsePath: function() {
                    return $;
                },
                parseString: function() {
                    return ge;
                },
                removeAllClassNames: function() {
                    return H;
                },
                removeClassName: function() {
                    return G;
                },
                removeEventListener: function() {
                    return Y;
                },
                removeReturnsAndSurroundingWhitespace: function() {
                    return T;
                },
                selectContentEditable: function() {
                    return V;
                },
                setEndOfContentEditable: function() {
                    return F;
                },
                setSelection: function() {
                    return S;
                },
                setSelectionOffset: function() {
                    return j;
                },
                sort: function() {
                    return de;
                },
                sortObjectKeys: function() {
                    return ue;
                },
                stringifyPath: function() {
                    return U;
                },
                stripFormatting: function() {
                    return w;
                },
                textDiff: function() {
                    return ne;
                },
                tryJsonRepair: function() {
                    return g;
                },
                uniqueMergeArrays: function() {
                    return ve;
                },
                validate: function() {
                    return m;
                }
            });
            t(1081);
            var e = t(1342), o = t.n(e), i = t(9857), n = t(5736), r = t(3094), s = t(3057);
            function a(e) {
                return ((e)=>{
                    if (Array.isArray(e)) return l(e);
                })(e) || ((e)=>{
                    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
                })(e) || ((e, t)=>{
                    var i;
                    if (e) return "string" == typeof e ? l(e, t) : "Map" === (i = "Object" === (i = ({}).toString.call(e).slice(8, -1)) && e.constructor ? e.constructor.name : i) || "Set" === i ? Array.from(e) : "Arguments" === i || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i) ? l(e, t) : void 0;
                })(e) || (()=>{
                    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                })();
            }
            function l(e, t) {
                (null == t || t > e.length) && (t = e.length);
                for(var i = 0, n = Array(t); i < t; i++)n[i] = e[i];
                return n;
            }
            function c(e) {
                return (c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                })(e);
            }
            var h = 1e4, d = 9466848e5;
            function u(t) {
                try {
                    return JSON.parse(t);
                } catch (e) {
                    throw m(t), e;
                }
            }
            function g(t) {
                try {
                    return (0, i.m)(t);
                } catch (e) {
                    return t;
                }
            }
            function p(e) {
                return e.replace(/[\u007F-\uFFFF]/g, function(e) {
                    return "\\u" + ("0000" + e.charCodeAt(0).toString(16)).slice(-4);
                });
            }
            function m(e) {
                (void 0 !== n ? n : JSON).parse(e);
            }
            function f(e, t) {
                for(var i in t)W(t, i) && (e[i] = t[i]);
                return e;
            }
            function C(e) {
                for(var t in e)W(e, t) && delete e[t];
                return e;
            }
            function y(e) {
                return null === e ? "null" : void 0 === e ? "undefined" : e instanceof Number || "number" == typeof e ? "number" : e instanceof String || "string" == typeof e ? "string" : e instanceof Boolean || "boolean" == typeof e ? "boolean" : e instanceof RegExp ? "regexp" : b(e) ? "array" : "object";
            }
            var v = /^https?:\/\/\S+$/;
            function I(e) {
                return ("string" == typeof e || e instanceof String) && v.test(e);
            }
            function b(e) {
                return "[object Array]" === Object.prototype.toString.call(e);
            }
            function A(e) {
                return e.ownerDocument.defaultView;
            }
            function D(e) {
                return e.getBoundingClientRect().left + window.pageXOffset || document.scrollLeft || 0;
            }
            function O(e) {
                return e.getBoundingClientRect().top + window.pageYOffset || document.scrollTop || 0;
            }
            function P(e, t) {
                var i = e.className.split(" ");
                -1 === i.indexOf(t) && (i.push(t), e.className = i.join(" "));
            }
            function H(e) {
                e.className = "";
            }
            function G(e, t) {
                var i = e.className.split(" "), t = i.indexOf(t);
                -1 !== t && (i.splice(t, 1), e.className = i.join(" "));
            }
            function w(e) {
                for(var t = e.childNodes, i = 0, n = t.length; i < n; i++){
                    var o = t[i], r = (o.style && o.removeAttribute("style"), o.attributes);
                    if (r) for(var s = r.length - 1; 0 <= s; s--){
                        var a = r[s];
                        !0 === a.specified && o.removeAttribute(a.name);
                    }
                    w(o);
                }
            }
            function F(e) {
                var t;
                document.createRange && ((t = document.createRange()).selectNodeContents(e), t.collapse(!1), (e = window.getSelection()).removeAllRanges(), e.addRange(t));
            }
            function V(e) {
                var t;
                e && "DIV" === e.nodeName && window.getSelection && document.createRange && ((t = document.createRange()).selectNodeContents(e), (e = window.getSelection()).removeAllRanges(), e.addRange(t));
            }
            function x() {
                if (window.getSelection) {
                    var e = window.getSelection();
                    if (e.getRangeAt && e.rangeCount) return e.getRangeAt(0);
                }
                return null;
            }
            function S(e) {
                var t;
                e && window.getSelection && ((t = window.getSelection()).removeAllRanges(), t.addRange(e));
            }
            function Z() {
                var e = x();
                return e && "startOffset" in e && "endOffset" in e && e.startContainer && e.startContainer === e.endContainer ? {
                    startOffset: e.startOffset,
                    endOffset: e.endOffset,
                    container: e.startContainer.parentNode
                } : null;
            }
            function j(e) {
                var t;
                document.createRange && window.getSelection && window.getSelection() && (t = document.createRange(), e.container.firstChild || e.container.appendChild(document.createTextNode("")), t.setStart(e.container.firstChild, e.startOffset), t.setEnd(e.container.firstChild, e.endOffset), S(t));
            }
            function k(e, t) {
                var i;
                if (void 0 === t && (t = {
                    _text: "",
                    flush: function() {
                        var e = this._text;
                        return this._text = "", e;
                    },
                    set: function(e) {
                        this._text = e;
                    }
                }), e.nodeValue) return "" !== (i = T(e.nodeValue)) ? t.flush() + i : "";
                if (e.hasChildNodes()) {
                    for(var n = e.childNodes, o = "", r = 0, s = n.length; r < s; r++){
                        var a, l = n[r];
                        "DIV" === l.nodeName || "P" === l.nodeName ? ((a = (a = n[r - 1]) ? a.nodeName : void 0) && "DIV" !== a && "P" !== a && "BR" !== a && ("" !== o && (o += "\n"), t.flush()), o += k(l, t), t.set("\n")) : "BR" === l.nodeName ? (o += t.flush(), t.set("\n")) : o += k(l, t);
                    }
                    return o;
                }
                return "";
            }
            function T(e) {
                return e.replace(/(\b|^)\s*(\b|$)/g, function(e) {
                    return /\n/.exec(e) ? "" : e;
                });
            }
            function K(e, t) {
                for(var i = e ? e.parentNode : void 0; i;){
                    if (i === t) return !0;
                    i = i.parentNode;
                }
                return !1;
            }
            function z() {
                var e;
                return -1 === E && (e = -1, "undefined" != typeof navigator && "Microsoft Internet Explorer" === navigator.appName && null != /MSIE ([0-9]+[.0-9]+)/.exec(navigator.userAgent) && (e = parseFloat(RegExp.$1)), E = e), E;
            }
            var E = -1;
            function R() {
                return "undefined" != typeof navigator && -1 !== navigator.userAgent.indexOf("Firefox");
            }
            function X(e, t, i, n) {
                return e.addEventListener ? (void 0 === n && (n = !1), "mousewheel" === t && R() && (t = "DOMMouseScroll"), e.addEventListener(t, i, n), i) : e.attachEvent ? (e.attachEvent("on" + t, n = function() {
                    return i.call(e, window.event);
                }), n) : void 0;
            }
            function Y(e, t, i, n) {
                e.removeEventListener ? (void 0 === n && (n = !1), "mousewheel" === t && R() && (t = "DOMMouseScroll"), e.removeEventListener(t, i, n)) : e.detachEvent && e.detachEvent("on" + t, i);
            }
            function J(e, t) {
                for(var i = e.parentNode; i;){
                    if (i === t) return !0;
                    i = i.parentNode;
                }
                return !1;
            }
            function $(i) {
                var e = [], n = 0;
                function t(e) {
                    for(var t = ""; void 0 !== i[n] && i[n] !== e;)t += i[n], n++;
                    if (i[n] !== e) throw new Error("Invalid JSON path: unexpected end, character " + e + " expected");
                    return t;
                }
                for(; void 0 !== i[n];)if ("." === i[n]) n++, e.push((()=>{
                    for(var e = ""; void 0 !== i[n] && /[\w$]/.test(i[n]);)e += i[n], n++;
                    if ("" === e) throw new Error("Invalid JSON path: property name expected at index " + n);
                    return e;
                })());
                else {
                    if ("[" !== i[n]) throw new Error('Invalid JSON path: unexpected character "' + i[n] + '" at index ' + n);
                    if ("'" === i[++n] || '"' === i[n]) {
                        var o = i[n];
                        if (n++, e.push(t(o)), i[n] !== o) throw new Error("Invalid JSON path: closing quote ' expected at index " + n);
                        n++;
                    } else {
                        o = t("]").trim();
                        if (0 === o.length) throw new Error("Invalid JSON path: array value expected at index " + n);
                        o = "*" === o ? o : JSON.parse(o), e.push(o);
                    }
                    if ("]" !== i[n]) throw new Error("Invalid JSON path: closing bracket ] expected at index " + n);
                    n++;
                }
                return e;
            }
            function U(e) {
                return e.map(function(e) {
                    return "number" == typeof e ? "[" + e + "]" : "string" == typeof e && e.match(/^[A-Za-z0-9_$]+$/) ? "." + e : '["' + e + '"]';
                }).join("");
            }
            function Q(e) {
                var t, i;
                return "enum" === e.keyword && Array.isArray(e.schema) && (i = e.schema) && (5 < (i = i.map(function(e) {
                    return JSON.stringify(e);
                })).length && (t = [
                    "(" + (i.length - 5) + " more...)"
                ], (i = i.slice(0, 5)).push(t)), e.message = "should be equal to one of: " + i.join(", ")), "additionalProperties" === e.keyword && (e.message = "should NOT have additional property: " + e.params.additionalProperty), e;
            }
            function q(e) {
                return e && "function" == typeof e.then && "function" == typeof e.catch;
            }
            function ee(e) {
                return "object" === c(e) && Array.isArray(e.path) && "string" == typeof e.message;
            }
            function te(e, t, i) {
                i = void 0 !== i ? i : 0;
                return t.left - i >= e.left && t.right + i <= e.right && t.top - i >= e.top && t.bottom + i <= e.bottom;
            }
            function ie(n, o, r) {
                var s;
                return function() {
                    var e = this, t = arguments, i = r && !s;
                    clearTimeout(s), s = setTimeout(function() {
                        s = null, r || n.apply(e, t);
                    }, o), i && n.apply(e, t);
                };
            }
            function ne(e, t) {
                for(var i = t.length, n = 0, o = e.length, r = t.length; t.charAt(n) === e.charAt(n) && n < i;)n++;
                for(; t.charAt(r - 1) === e.charAt(o - 1) && n < r && 0 < o;)r--, o--;
                return {
                    start: n,
                    end: r
                };
            }
            function oe(t) {
                var e, i, n, o, r = 0, s = 0;
                return "number" == typeof t.selectionStart && "number" == typeof t.selectionEnd ? (r = t.selectionStart, s = t.selectionEnd) : (o = document.selection.createRange()) && o.parentElement() === t && (n = t.value.length, e = t.value.replace(/\r\n/g, "\n"), (i = t.createTextRange()).moveToBookmark(o.getBookmark()), (o = t.createTextRange()).collapse(!1), -1 < i.compareEndPoints("StartToEnd", o) ? r = s = n : (r = -i.moveStart("character", -n), r += e.slice(0, r).split("\n").length - 1, -1 < i.compareEndPoints("EndToEnd", o) ? s = n : (s = -i.moveEnd("character", -n), s += e.slice(0, s).split("\n").length - 1))), {
                    startIndex: r,
                    endIndex: s,
                    start: a(r),
                    end: a(s)
                };
                function a(e) {
                    e = t.value.substring(0, e);
                    return {
                        row: (e.match(/\n/g) || []).length + 1,
                        column: e.length - e.lastIndexOf("\n")
                    };
                }
            }
            function re(e, t, i) {
                var e = e.value || "";
                return 0 < t && 0 < i ? (e = e.split("\n", t), t = Math.min(e.length, t), i = Math.min(e[t - 1].length, i - 1), i = 1 === t ? i : i + 1, e.slice(0, t - 1).join("\n").length + i) : -1;
            }
            function se(e, t) {
                var i, n = [];
                if (t && t.length) {
                    try {
                        i = r.parse(e);
                    } catch (e) {
                        return n;
                    }
                    t.forEach(function(e) {
                        var t = _($(e)), t = i.pointers[t];
                        t && n.push({
                            path: e,
                            line: t.key ? t.key.line : t.value ? t.value.line : 0,
                            column: t.key ? t.key.column : t.value ? t.value.column : 0
                        });
                    });
                }
                return n;
            }
            function _(e) {
                return e.map(function(e) {
                    return "/" + String(e).replace(/~/g, "~0").replace(/\//g, "~1");
                }).join("");
            }
            function L(e) {
                var t = document.createElement("div");
                return t.style.color = e, t.style.color.split(/\s+/).join("").toLowerCase() || null;
            }
            function ae(e) {
                return !!L(e);
            }
            function le(i, e) {
                var n;
                return i ? (n = "", i.title && (n += i.title), i.description && (0 < n.length && (n += "\n"), n += i.description), i.default && (0 < n.length && (n += "\n\n"), n = (n += (0, s.Tl)("default", void 0, e) + "\n") + JSON.stringify(i.default, null, 2)), Array.isArray(i.examples) && 0 < i.examples.length && (0 < n.length && (n += "\n\n"), n += (0, s.Tl)("examples", void 0, e) + "\n", i.examples.forEach(function(e, t) {
                    n += JSON.stringify(e, null, 2), t !== i.examples.length - 1 && (n += "\n");
                })), n) : "";
            }
            function M(e, t) {
                for(var i = e, n = 0; n < t.length && null != i; n++)i = i[t[n]];
                return i;
            }
            function ce(e, t) {
                if (-1 === t.indexOf(e)) return e;
                for(var i = e.replace(/ \(copy( \d+)?\)$/, ""), n = i, o = 1; -1 !== t.indexOf(n);){
                    n = i + " (" + ("copy" + (1 < o ? " " + o : "")) + ")";
                    o++;
                }
                return n;
            }
            function he(e, t) {
                var i = {};
                if (Array.isArray(e)) for(var n = Math.min(e.length, h), o = 0; o < n; o++)!function t(i, n, o, r) {
                    (Array.isArray(i) || N(i)) && !r || (n[o || ""] = !0), N(i) && Object.keys(i).forEach(function(e) {
                        t(i[e], n, o + "." + e, r);
                    });
                }(e[o], i, "", t);
                else i[""] = !0;
                return Object.keys(i).sort();
            }
            function de(e, t, i) {
                var n = t && "." !== t ? $(t) : [], o = "desc" === i ? -1 : 1, t = e.slice();
                return t.sort(function(e, t) {
                    e = M(e, n), t = M(t, n);
                    return o * (t < e ? 1 : e < t ? -1 : 0);
                }), t;
            }
            function ue(t, e) {
                var i = "desc" === e ? -1 : 1, e = Object.keys(t).sort(function(e, t) {
                    return i * o()(e, t);
                }), n = {};
                return e.forEach(function(e) {
                    n[e] = t[e];
                }), n;
            }
            function ge(e) {
                var t, i, n, o;
                return "" === e ? "" : "null" === (t = e.toLowerCase()) ? null : "true" === t || "false" !== t && (/^0\d+$/.test(e) || /^0[xbo]/i.test(e) || (t = Number(e), i = parseFloat(e), i = !isNaN(t) && !isNaN(i) && isFinite(t), n = t <= Number.MAX_SAFE_INTEGER && t >= Number.MIN_SAFE_INTEGER, o = /^\d+$/.test(e), !i) || !n && o ? e : t);
            }
            function pe(e, t) {
                return "number" == typeof t && d < t && isFinite(t) && Math.floor(t) === t && !isNaN(new Date(t).valueOf());
            }
            function me(e) {
                return e < 900 ? e.toFixed() + " B" : (e = e / 1e3) < 900 ? e.toFixed(1) + " KB" : (e = e / 1e3) < 900 ? e.toFixed(1) + " MB" : (e = e / 1e3) < 900 ? e.toFixed(1) + " GB" : (e / 1e3).toFixed(1) + " TB";
            }
            function fe(e, t) {
                return e.length <= t ? e : e.slice(0, t) + "...";
            }
            function N(e) {
                return "object" === c(e) && null !== e && !Array.isArray(e);
            }
            function Ce(e, t) {
                return -1 !== e.indexOf(t);
            }
            function ye(e, t) {
                if (e || t) {
                    if (!Array.isArray(e) || !Array.isArray(t) || t.length !== e.length) return !0;
                    for(var i = 0; i < e.length; i++){
                        var n = e[i], o = t[i];
                        if (n.type !== o.type || JSON.stringify(n.error) !== JSON.stringify(o.error)) return !0;
                    }
                }
                return !1;
            }
            function ve(e, t) {
                e = null != e && e.length ? e : [], t = null != t && t.length ? t : [];
                return a(new Set(e.concat(t)));
            }
            function Ie(e) {
                setTimeout(e);
            }
            function W(e, t) {
                return Object.prototype.hasOwnProperty.call(e, t);
            }
        },
        1746: function(e, t, i) {
            var n;
            if (window.Picker) n = window.Picker;
            else try {
                n = i(7598);
            } catch (e) {}
            e.exports = n;
        },
        6990: function(n, e, C) {
            var t, i, o, r, s, l, a, c;
            n = C.nmd(n), (o = function() {
                return this;
            }()) || "undefined" == typeof window || (o = window), (r = function(e, t, i) {
                "string" != typeof e ? r.original ? r.original.apply(this, arguments) : (console.error("dropping module because define wasn't a string."), console.trace()) : (2 == arguments.length && (i = t), r.modules[e] || (r.payloads[e] = i, r.modules[e] = null));
            }).modules = {}, r.payloads = {}, s = function(e, t, i) {
                if ("string" == typeof t) {
                    var n = c(e, t);
                    if (null != n) return i && i(), n;
                } else if ("[object Array]" === Object.prototype.toString.call(t)) {
                    for(var o = [], r = 0, s = t.length; r < s; ++r){
                        var a = c(e, t[r]);
                        if (null == a && l.original) return;
                        o.push(a);
                    }
                    return i && i.apply(null, o) || !0;
                }
            }, l = function(e, t) {
                e = s("", e, t);
                return null == e && l.original ? l.original.apply(this, arguments) : e;
            }, a = function(e, t) {
                var i;
                if (-1 !== t.indexOf("!")) return i = t.split("!"), a(e, i[0]) + "!" + a(e, i[1]);
                if ("." == t.charAt(0)) for(t = e.split("/").slice(0, -1).join("/") + "/" + t; -1 !== t.indexOf(".") && n != t;){
                    var n = t;
                    t = t.replace(/\/\.\//, "/").replace(/[^\/]+\/\.\.\//, "");
                }
                return t;
            }, c = function(e, i) {
                i = a(e, i);
                var t, n, e = r.modules[i];
                return e || ("function" == typeof (e = r.payloads[i]) && (t = {
                    id: i,
                    uri: "",
                    exports: n = {},
                    packaged: !0
                }, n = e(function(e, t) {
                    return s(i, e, t);
                }, n, t) || t.exports, r.modules[i] = n, delete r.payloads[i]), e = r.modules[i] = n || e), e;
            }, i = o, t = "ace", o[t] || (o[t] = {}), i = o[t], i.define && i.define.packaged || (r.original = i.define, i.define = r, i.define.packaged = !0), i.require && i.require.packaged || (l.original = i.require, i.require = l, i.require.packaged = !0), ace.define("ace/lib/es6-shim", [
                "require",
                "exports",
                "module"
            ], function(e, t, i) {
                function n(e, t, i) {
                    Object.defineProperty(e, t, {
                        value: i,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    });
                }
                String.prototype.startsWith || n(String.prototype, "startsWith", function(e, t) {
                    return this.lastIndexOf(e, t = t || 0) === t;
                }), String.prototype.endsWith || n(String.prototype, "endsWith", function(e, t) {
                    (void 0 === t || t > this.length) && (t = this.length), t -= e.length;
                    e = this.indexOf(e, t);
                    return -1 !== e && e === t;
                }), String.prototype.repeat || n(String.prototype, "repeat", function(e) {
                    for(var t = "", i = this; 0 < e;)1 & e && (t += i), (e >>= 1) && (i += i);
                    return t;
                }), String.prototype.includes || n(String.prototype, "includes", function(e, t) {
                    return -1 != this.indexOf(e, t);
                }), Object.assign || (Object.assign = function(e) {
                    if (null == e) throw new TypeError("Cannot convert undefined or null to object");
                    for(var t = Object(e), i = 1; i < arguments.length; i++){
                        var n = arguments[i];
                        null != n && Object.keys(n).forEach(function(e) {
                            t[e] = n[e];
                        });
                    }
                    return t;
                }), Object.values || (Object.values = function(t) {
                    return Object.keys(t).map(function(e) {
                        return t[e];
                    });
                }), Array.prototype.find || n(Array.prototype, "find", function(e) {
                    for(var t = this.length, i = arguments[1], n = 0; n < t; n++){
                        var o = this[n];
                        if (e.call(i, o, n, this)) return o;
                    }
                }), Array.prototype.findIndex || n(Array.prototype, "findIndex", function(e) {
                    for(var t = this.length, i = arguments[1], n = 0; n < t; n++){
                        var o = this[n];
                        if (e.call(i, o, n, this)) return n;
                    }
                }), Array.prototype.includes || n(Array.prototype, "includes", function(e, t) {
                    return -1 != this.indexOf(e, t);
                }), Array.prototype.fill || n(Array.prototype, "fill", function(e) {
                    for(var t = this.length >>> 0, i = arguments[1] >> 0, n = i < 0 ? Math.max(t + i, 0) : Math.min(i, t), i = arguments[2], i = void 0 === i ? t : i >> 0, o = i < 0 ? Math.max(t + i, 0) : Math.min(i, t); n < o;)this[n] = e, n++;
                    return this;
                }), Array.of || n(Array, "of", function() {
                    return Array.prototype.slice.call(arguments);
                });
            }), ace.define("ace/lib/fixoldbrowsers", [
                "require",
                "exports",
                "module",
                "ace/lib/es6-shim"
            ], function(e, t, i) {
                e("./es6-shim");
            }), ace.define("ace/lib/deep_copy", [
                "require",
                "exports",
                "module"
            ], function(e, t, i) {
                t.deepCopy = function e(t) {
                    if ("object" != typeof t || !t) return t;
                    if (Array.isArray(t)) for(var i = [], n = 0; n < t.length; n++)i[n] = e(t[n]);
                    else {
                        if ("[object Object]" !== Object.prototype.toString.call(t)) return t;
                        for(var n in i = {}, t)i[n] = e(t[n]);
                    }
                    return i;
                };
            }), ace.define("ace/lib/lang", [
                "require",
                "exports",
                "module",
                "ace/lib/deep_copy"
            ], function(e, t, i) {
                t.last = function(e) {
                    return e[e.length - 1];
                }, t.stringReverse = function(e) {
                    return e.split("").reverse().join("");
                }, t.stringRepeat = function(e, t) {
                    for(var i = ""; 0 < t;)1 & t && (i += e), (t >>= 1) && (e += e);
                    return i;
                };
                var n = /^\s\s*/, o = /\s\s*$/;
                t.stringTrimLeft = function(e) {
                    return e.replace(n, "");
                }, t.stringTrimRight = function(e) {
                    return e.replace(o, "");
                }, t.copyObject = function(e) {
                    var t, i = {};
                    for(t in e)i[t] = e[t];
                    return i;
                }, t.copyArray = function(e) {
                    for(var t = [], i = 0, n = e.length; i < n; i++)e[i] && "object" == typeof e[i] ? t[i] = this.copyObject(e[i]) : t[i] = e[i];
                    return t;
                }, t.deepCopy = e("./deep_copy").deepCopy, t.arrayToMap = function(e) {
                    for(var t = {}, i = 0; i < e.length; i++)t[e[i]] = 1;
                    return t;
                }, t.createMap = function(e) {
                    var t, i = Object.create(null);
                    for(t in e)i[t] = e[t];
                    return i;
                }, t.arrayRemove = function(e, t) {
                    for(var i = 0; i <= e.length; i++)t === e[i] && e.splice(i, 1);
                }, t.escapeRegExp = function(e) {
                    return e.replace(/([.*+?^${}()|[\]\/\\])/g, "\\$1");
                }, t.escapeHTML = function(e) {
                    return ("" + e).replace(/&/g, "&#38;").replace(/"/g, "&#34;").replace(/'/g, "&#39;").replace(/</g, "&#60;");
                }, t.getMatchOffsets = function(e, t) {
                    var i = [];
                    return e.replace(t, function(e) {
                        i.push({
                            offset: arguments[arguments.length - 2],
                            length: e.length
                        });
                    }), i;
                }, t.deferredCall = function(e) {
                    function t() {
                        n = null, e();
                    }
                    function i(e) {
                        return i.cancel(), n = setTimeout(t, e || 0), i;
                    }
                    var n = null;
                    return (i.schedule = i).call = function() {
                        return this.cancel(), e(), i;
                    }, i.cancel = function() {
                        return clearTimeout(n), n = null, i;
                    }, i.isPending = function() {
                        return n;
                    }, i;
                }, t.delayedCall = function(e, t) {
                    function i() {
                        o = null, e();
                    }
                    function n(e) {
                        null == o && (o = setTimeout(i, e || t));
                    }
                    var o = null;
                    return n.delay = function(e) {
                        o && clearTimeout(o), o = setTimeout(i, e || t);
                    }, (n.schedule = n).call = function() {
                        this.cancel(), e();
                    }, n.cancel = function() {
                        o && clearTimeout(o), o = null;
                    }, n.isPending = function() {
                        return o;
                    }, n;
                }, t.supportsLookbehind = function() {
                    try {
                        new RegExp("(?<=.)");
                    } catch (e) {
                        return !1;
                    }
                    return !0;
                }, t.skipEmptyMatch = function(e, t, i) {
                    return i && 65535 < e.codePointAt(t) ? 2 : 1;
                };
            }), ace.define("ace/lib/useragent", [
                "require",
                "exports",
                "module"
            ], function(e, t, i) {
                t.OS = {
                    LINUX: "LINUX",
                    MAC: "MAC",
                    WINDOWS: "WINDOWS"
                }, t.getOS = function() {
                    return t.isMac ? t.OS.MAC : t.isLinux ? t.OS.LINUX : t.OS.WINDOWS;
                };
                var n = "object" == typeof navigator ? navigator : {}, o = (/mac|win|linux/i.exec(n.platform) || [
                    "other"
                ])[0].toLowerCase(), r = n.userAgent || "", n = n.appName || "";
                t.isWin = "win" == o, t.isMac = "mac" == o, t.isLinux = "linux" == o, t.isIE = "Microsoft Internet Explorer" == n || 0 <= n.indexOf("MSAppHost") ? parseFloat((r.match(/(?:MSIE |Trident\/[0-9]+[\.0-9]+;.*rv:)([0-9]+[\.0-9]+)/) || [])[1]) : parseFloat((r.match(/(?:Trident\/[0-9]+[\.0-9]+;.*rv:)([0-9]+[\.0-9]+)/) || [])[1]), t.isOldIE = t.isIE && t.isIE < 9, t.isGecko = t.isMozilla = r.match(/ Gecko\/\d+/), t.isOpera = "object" == typeof opera && "[object Opera]" == Object.prototype.toString.call(window.opera), t.isWebKit = parseFloat(r.split("WebKit/")[1]) || void 0, t.isChrome = parseFloat(r.split(" Chrome/")[1]) || void 0, t.isSafari = parseFloat(r.split(" Safari/")[1]) && !t.isChrome || void 0, t.isEdge = parseFloat(r.split(" Edge/")[1]) || void 0, t.isAIR = 0 <= r.indexOf("AdobeAIR"), t.isAndroid = 0 <= r.indexOf("Android"), t.isChromeOS = 0 <= r.indexOf(" CrOS "), t.isIOS = /iPad|iPhone|iPod/.test(r) && !window.MSStream, t.isIOS && (t.isMac = !0), t.isMobile = t.isIOS || t.isAndroid;
            }), ace.define("ace/lib/dom", [
                "require",
                "exports",
                "module",
                "ace/lib/useragent"
            ], function(e, r, t) {
                var s, i, e = e("./useragent"), a = (r.buildDom = function e(t, i, n) {
                    if ("string" == typeof t && t) return c = document.createTextNode(t), i && i.appendChild(c), c;
                    if (!Array.isArray(t)) return t && t.appendChild && i && i.appendChild(t), t;
                    if ("string" != typeof t[0] || !t[0]) {
                        for(var o = [], r = 0; r < t.length; r++){
                            var s = e(t[r], i, n);
                            s && o.push(s);
                        }
                        return o;
                    }
                    for(var a = document.createElement(t[0]), l = t[1], c = 1, r = c = l && "object" == typeof l && !Array.isArray(l) ? 2 : c; r < t.length; r++)e(t[r], a, n);
                    return 2 == c && Object.keys(l).forEach(function(e) {
                        var t = l[e];
                        "class" === e ? a.className = Array.isArray(t) ? t.join(" ") : t : "function" == typeof t || "value" == e || "$" == e[0] ? a[e] = t : "ref" === e ? n && (n[t] = a) : "style" === e ? "string" == typeof t && (a.style.cssText = t) : null != t && a.setAttribute(e, t);
                    }), i && i.appendChild(a), a;
                }, r.getDocumentHead = function(e) {
                    return (e = e || document).head || e.getElementsByTagName("head")[0] || e.documentElement;
                }, r.createElement = function(e, t) {
                    return document.createElementNS ? document.createElementNS(t || "http://www.w3.org/1999/xhtml", e) : document.createElement(e);
                }, r.removeChildren = function(e) {
                    e.innerHTML = "";
                }, r.createTextNode = function(e, t) {
                    return (t ? t.ownerDocument : document).createTextNode(e);
                }, r.createFragment = function(e) {
                    return (e ? e.ownerDocument : document).createDocumentFragment();
                }, r.hasCssClass = function(e, t) {
                    return -1 !== (e.className + "").split(/\s+/g).indexOf(t);
                }, r.addCssClass = function(e, t) {
                    r.hasCssClass(e, t) || (e.className += " " + t);
                }, r.removeCssClass = function(e, t) {
                    for(var i = e.className.split(/\s+/g);;){
                        var n = i.indexOf(t);
                        if (-1 == n) break;
                        i.splice(n, 1);
                    }
                    e.className = i.join(" ");
                }, r.toggleCssClass = function(e, t) {
                    for(var i = e.className.split(/\s+/g), n = !0;;){
                        var o = i.indexOf(t);
                        if (-1 == o) break;
                        n = !1, i.splice(o, 1);
                    }
                    return n && i.push(t), e.className = i.join(" "), n;
                }, r.setCssClass = function(e, t, i) {
                    i ? r.addCssClass(e, t) : r.removeCssClass(e, t);
                }, r.hasCssString = function(e, t) {
                    var i, n = 0;
                    if (i = (t = t || document).querySelectorAll("style")) {
                        for(; n < i.length;)if (i[n++].id === e) return !0;
                    }
                }, r.removeElementById = function(e, t) {
                    (t = t || document).getElementById(e) && t.getElementById(e).remove();
                }, []);
                function l() {
                    var e = a;
                    a = null, e && e.forEach(function(e) {
                        n(e[0], e[1]);
                    });
                }
                function n(e, t, i) {
                    if ("undefined" != typeof document) {
                        if (a) {
                            if (i) l();
                            else if (!1 === i) return a.push([
                                e,
                                t
                            ]);
                        }
                        if (!s) {
                            var n = i, i = (n = i && i.getRootNode && (n = i.getRootNode()) && n != i ? n : document).ownerDocument || n;
                            if (t && r.hasCssString(t, n)) return null;
                            t && (e += "\n/*# sourceURL=ace/css/" + t + " */");
                            var o = r.createElement("style");
                            o.appendChild(i.createTextNode(e)), t && (o.id = t), (n = n == i ? r.getDocumentHead(i) : n).insertBefore(o, n.firstChild);
                        }
                    }
                }
                r.useStrictCSP = function(e) {
                    0 == (s = e) ? l() : a = a || [];
                }, r.importCssString = n, r.importCssStylsheet = function(e, t) {
                    r.buildDom([
                        "link",
                        {
                            rel: "stylesheet",
                            href: e
                        }
                    ], r.getDocumentHead(t));
                }, r.$fixPositionBug = function(e) {
                    var t, i, n = e.getBoundingClientRect();
                    e.style.left && (t = parseFloat(e.style.left), i = +n.left, 1 < Math.abs(t - i)) && (e.style.left = 2 * t - i + "px"), e.style.right && (t = parseFloat(e.style.right), i = window.innerWidth - n.right, 1 < Math.abs(t - i)) && (e.style.right = 2 * t - i + "px"), e.style.top && (t = parseFloat(e.style.top), i = +n.top, 1 < Math.abs(t - i)) && (e.style.top = 2 * t - i + "px"), e.style.bottom && (t = parseFloat(e.style.bottom), i = window.innerHeight - n.bottom, 1 < Math.abs(t - i)) && (e.style.bottom = 2 * t - i + "px");
                }, r.scrollbarWidth = function(e) {
                    var t = r.createElement("ace_inner"), i = (t.style.width = "100%", t.style.minWidth = "0px", t.style.height = "200px", t.style.display = "block", r.createElement("ace_outer")), n = i.style, e = (n.position = "absolute", n.left = "-10000px", n.overflow = "hidden", n.width = "200px", n.minWidth = "0px", n.height = "150px", n.display = "block", i.appendChild(t), e && e.documentElement || document && document.documentElement);
                    if (!e) return 0;
                    e.appendChild(i);
                    var o = t.offsetWidth, n = (n.overflow = "scroll", t.offsetWidth);
                    return o === n && (n = i.clientWidth), e.removeChild(i), o - n;
                }, r.computedStyle = function(e, t) {
                    return window.getComputedStyle(e, "") || {};
                }, r.setStyle = function(e, t, i) {
                    e[t] !== i && (e[t] = i);
                }, r.HAS_CSS_ANIMATION = !1, r.HAS_CSS_TRANSFORMS = !1, r.HI_DPI = !e.isWin || "undefined" != typeof window && 1.5 <= window.devicePixelRatio, e.isChromeOS && (r.HI_DPI = !1), "undefined" != typeof document && (i = document.createElement("div"), r.HI_DPI && void 0 !== i.style.transform && (r.HAS_CSS_TRANSFORMS = !0), e.isEdge || void 0 === i.style.animationName || (r.HAS_CSS_ANIMATION = !0), i = null), r.translate = r.HAS_CSS_TRANSFORMS ? function(e, t, i) {
                    e.style.transform = "translate(" + Math.round(t) + "px, " + Math.round(i) + "px)";
                } : function(e, t, i) {
                    e.style.top = Math.round(i) + "px", e.style.left = Math.round(t) + "px";
                };
            }), ace.define("ace/lib/net", [
                "require",
                "exports",
                "module",
                "ace/lib/dom"
            ], function(e, t, i) {
                var o = e("./dom");
                t.get = function(e, t) {
                    var i = new XMLHttpRequest;
                    i.open("GET", e, !0), i.onreadystatechange = function() {
                        4 === i.readyState && t(i.responseText);
                    }, i.send(null);
                }, t.loadScript = function(e, i) {
                    var t = o.getDocumentHead(), n = document.createElement("script");
                    n.src = e, t.appendChild(n), n.onload = n.onreadystatechange = function(e, t) {
                        !t && n.readyState && "loaded" != n.readyState && "complete" != n.readyState || (n = n.onload = n.onreadystatechange = null, t) || i();
                    };
                }, t.qualifyURL = function(e) {
                    var t = document.createElement("a");
                    return t.href = e, t.href;
                };
            }), ace.define("ace/lib/oop", [
                "require",
                "exports",
                "module"
            ], function(e, i, t) {
                i.inherits = function(e, t) {
                    e.super_ = t, e.prototype = Object.create(t.prototype, {
                        constructor: {
                            value: e,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    });
                }, i.mixin = function(e, t) {
                    for(var i in t)e[i] = t[i];
                    return e;
                }, i.implement = function(e, t) {
                    i.mixin(e, t);
                };
            }), ace.define("ace/lib/event_emitter", [
                "require",
                "exports",
                "module"
            ], function(e, t, i) {
                function r() {
                    this.propagationStopped = !0;
                }
                function s() {
                    this.defaultPrevented = !0;
                }
                var n = {};
                n._emit = n._dispatchEvent = function(e, t) {
                    this._eventRegistry || (this._eventRegistry = {}), this._defaultHandlers || (this._defaultHandlers = {});
                    var i = this._eventRegistry[e] || [], n = this._defaultHandlers[e];
                    if (i.length || n) {
                        (t = "object" == typeof t && t ? t : {}).type || (t.type = e), t.stopPropagation || (t.stopPropagation = r), t.preventDefault || (t.preventDefault = s);
                        for(var i = i.slice(), o = 0; o < i.length && (i[o](t, this), !t.propagationStopped); o++);
                        return n && !t.defaultPrevented ? n(t, this) : void 0;
                    }
                }, n._signal = function(e, t) {
                    if (i = (this._eventRegistry || {})[e]) for(var i = i.slice(), n = 0; n < i.length; n++)i[n](t, this);
                }, n.once = function(t, i) {
                    var n = this;
                    if (this.on(t, function e() {
                        n.off(t, e), i.apply(null, arguments);
                    }), !i) return new Promise(function(e) {
                        i = e;
                    });
                }, n.setDefaultHandler = function(e, t) {
                    var i, n, o = this._defaultHandlers;
                    (o = o || (this._defaultHandlers = {
                        _disabled_: {}
                    }))[e] && (n = o[e], (i = o._disabled_[e]) || (o._disabled_[e] = i = []), i.push(n), -1 != (n = i.indexOf(t))) && i.splice(n, 1), o[e] = t;
                }, n.removeDefaultHandler = function(e, t) {
                    var i, n = this._defaultHandlers;
                    n && (i = n._disabled_[e], n[e] == t ? i && this.setDefaultHandler(e, i.pop()) : i && -1 != (n = i.indexOf(t)) && i.splice(n, 1));
                }, n.on = n.addEventListener = function(e, t, i) {
                    this._eventRegistry = this._eventRegistry || {};
                    var n = this._eventRegistry[e];
                    return -1 == (n = n || (this._eventRegistry[e] = [])).indexOf(t) && n[i ? "unshift" : "push"](t), t;
                }, n.off = n.removeListener = n.removeEventListener = function(e, t) {
                    this._eventRegistry = this._eventRegistry || {};
                    e = this._eventRegistry[e];
                    e && -1 !== (t = e.indexOf(t)) && e.splice(t, 1);
                }, n.removeAllListeners = function(e) {
                    e || (this._eventRegistry = this._defaultHandlers = void 0), this._eventRegistry && (this._eventRegistry[e] = void 0), this._defaultHandlers && (this._defaultHandlers[e] = void 0);
                }, t.EventEmitter = n;
            }), ace.define("ace/lib/report_error", [
                "require",
                "exports",
                "module"
            ], function(e, t, i) {
                t.reportError = function(e, t) {
                    var i = new Error(e);
                    i.data = t, "object" == typeof console && console.error && console.error(i), setTimeout(function() {
                        throw i;
                    });
                };
            }), ace.define("ace/lib/default_english_messages", [
                "require",
                "exports",
                "module"
            ], function(e, t, i) {
                t.defaultEnglishMessages = {
                    "autocomplete.popup.aria-roledescription": "Autocomplete suggestions",
                    "autocomplete.popup.aria-label": "Autocomplete suggestions",
                    "autocomplete.popup.item.aria-roledescription": "item",
                    "autocomplete.loading": "Loading...",
                    "editor.scroller.aria-roledescription": "editor",
                    "editor.scroller.aria-label": "Editor content, press Enter to start editing, press Escape to exit",
                    "editor.gutter.aria-roledescription": "editor gutter",
                    "editor.gutter.aria-label": "Editor gutter, press Enter to interact with controls using arrow keys, press Escape to exit",
                    "error-marker.good-state": "Looks good!",
                    "prompt.recently-used": "Recently used",
                    "prompt.other-commands": "Other commands",
                    "prompt.no-matching-commands": "No matching commands",
                    "search-box.find.placeholder": "Search for",
                    "search-box.find-all.text": "All",
                    "search-box.replace.placeholder": "Replace with",
                    "search-box.replace-next.text": "Replace",
                    "search-box.replace-all.text": "All",
                    "search-box.toggle-replace.title": "Toggle Replace mode",
                    "search-box.toggle-regexp.title": "RegExp Search",
                    "search-box.toggle-case.title": "CaseSensitive Search",
                    "search-box.toggle-whole-word.title": "Whole Word Search",
                    "search-box.toggle-in-selection.title": "Search In Selection",
                    "search-box.search-counter": "$0 of $1",
                    "text-input.aria-roledescription": "editor",
                    "text-input.aria-label": "Cursor at row $0",
                    "gutter.code-folding.range.aria-label": "Toggle code folding, rows $0 through $1",
                    "gutter.code-folding.closed.aria-label": "Toggle code folding, rows $0 through $1",
                    "gutter.code-folding.open.aria-label": "Toggle code folding, row $0",
                    "gutter.code-folding.closed.title": "Unfold code",
                    "gutter.code-folding.open.title": "Fold code",
                    "gutter.annotation.aria-label.error": "Error, read annotations row $0",
                    "gutter.annotation.aria-label.warning": "Warning, read annotations row $0",
                    "gutter.annotation.aria-label.info": "Info, read annotations row $0",
                    "inline-fold.closed.title": "Unfold code",
                    "gutter-tooltip.aria-label.error.singular": "error",
                    "gutter-tooltip.aria-label.error.plural": "errors",
                    "gutter-tooltip.aria-label.warning.singular": "warning",
                    "gutter-tooltip.aria-label.warning.plural": "warnings",
                    "gutter-tooltip.aria-label.info.singular": "information message",
                    "gutter-tooltip.aria-label.info.plural": "information messages",
                    "gutter.annotation.aria-label.security": "Security finding, read annotations row $0",
                    "gutter.annotation.aria-label.hint": "Suggestion, read annotations row $0",
                    "gutter-tooltip.aria-label.security.singular": "security finding",
                    "gutter-tooltip.aria-label.security.plural": "security findings",
                    "gutter-tooltip.aria-label.hint.singular": "suggestion",
                    "gutter-tooltip.aria-label.hint.plural": "suggestions",
                    "editor.tooltip.disable-editing": "Editing is disabled"
                };
            }), ace.define("ace/lib/app_config", [
                "require",
                "exports",
                "module",
                "ace/lib/oop",
                "ace/lib/event_emitter",
                "ace/lib/report_error",
                "ace/lib/default_english_messages"
            ], function(e, t, i) {
                var n, o, r = e("./oop"), s = e("./event_emitter").EventEmitter, a = e("./report_error").reportError, l = e("./default_english_messages").defaultEnglishMessages, c = {
                    setOptions: function(t) {
                        Object.keys(t).forEach(function(e) {
                            this.setOption(e, t[e]);
                        }, this);
                    },
                    getOptions: function(e) {
                        var t, i = {};
                        return e ? Array.isArray(e) || (e = Object.keys(e)) : (t = this.$options, e = Object.keys(t).filter(function(e) {
                            return !t[e].hidden;
                        })), e.forEach(function(e) {
                            i[e] = this.getOption(e);
                        }, this), i;
                    },
                    setOption: function(e, t) {
                        var i;
                        if (this["$" + e] !== t) return (i = this.$options[e]) ? i.forwardTo ? this[i.forwardTo] && this[i.forwardTo].setOption(e, t) : (i.handlesSet || (this["$" + e] = t), void (i && i.set && i.set.call(this, t))) : h('misspelled option "' + e + '"');
                    },
                    getOption: function(e) {
                        var t = this.$options[e];
                        return t ? t.forwardTo ? this[t.forwardTo] && this[t.forwardTo].getOption(e) : t && t.get ? t.get.call(this) : this["$" + e] : h('misspelled option "' + e + '"');
                    }
                };
                function h(e) {
                    "undefined" != typeof console && console.warn && console.warn.apply(console, arguments);
                }
                d.prototype.defineOptions = function(i, e, n) {
                    return i.$options || (this.$defaultOptions[e] = i.$options = {}), Object.keys(n).forEach(function(e) {
                        var t = n[e];
                        (t = "string" == typeof t ? {
                            forwardTo: t
                        } : t).name || (t.name = e), "initialValue" in (i.$options[t.name] = t) && (i["$" + t.name] = t.initialValue);
                    }), r.implement(i, c), this;
                }, d.prototype.resetOptions = function(i) {
                    Object.keys(i.$options).forEach(function(e) {
                        var t = i.$options[e];
                        "value" in t && i.setOption(e, t.value);
                    });
                }, d.prototype.setDefaultValue = function(e, t, i) {
                    if (!e) {
                        for(e in this.$defaultOptions)if (this.$defaultOptions[e][t]) break;
                        if (!this.$defaultOptions[e][t]) return !1;
                    }
                    var n = this.$defaultOptions[e] || (this.$defaultOptions[e] = {});
                    n[t] && (n.forwardTo ? this.setDefaultValue(n.forwardTo, t, i) : n[t].value = i);
                }, d.prototype.setDefaultValues = function(t, i) {
                    Object.keys(i).forEach(function(e) {
                        this.setDefaultValue(t, e, i[e]);
                    }, this);
                }, d.prototype.setMessages = function(e, t) {
                    n = e, t && t.placeholders && (o = t.placeholders);
                }, d.prototype.nls = function(e, t, i) {
                    n[e] || (h("No message found for the key '" + e + "' in messages with id " + n.$id + ", trying to find a translation for the default string '" + t + "'."), n[t]) || h("No message found for the default string '" + t + "' in the provided messages. Falling back to the default English message.");
                    e = n[e] || n[t] || t;
                    return e = i && ("dollarSigns" === o && (e = e.replace(/\$(\$|[\d]+)/g, function(e, t) {
                        return "$" == t ? "$" : i[t];
                    })), "curlyBrackets" === o) ? e.replace(/\{([^\}]+)\}/g, function(e, t) {
                        return i[t];
                    }) : e;
                };
                e = d;
                function d() {
                    this.$defaultOptions = {}, n = l, o = "dollarSigns";
                }
                e.prototype.warn = h, e.prototype.reportError = a, r.implement(e.prototype, s), t.AppConfig = e;
            }), ace.define("ace/theme/textmate-css", [
                "require",
                "exports",
                "module"
            ], function(e, t, i) {
                i.exports = '.ace-tm .ace_gutter {\n  background: #f0f0f0;\n  color: #333;\n}\n\n.ace-tm .ace_print-margin {\n  width: 1px;\n  background: #e8e8e8;\n}\n\n.ace-tm .ace_fold {\n    background-color: #6B72E6;\n}\n\n.ace-tm {\n  background-color: #FFFFFF;\n  color: black;\n}\n\n.ace-tm .ace_cursor {\n  color: black;\n}\n        \n.ace-tm .ace_invisible {\n  color: rgb(191, 191, 191);\n}\n\n.ace-tm .ace_storage,\n.ace-tm .ace_keyword {\n  color: blue;\n}\n\n.ace-tm .ace_constant {\n  color: rgb(197, 6, 11);\n}\n\n.ace-tm .ace_constant.ace_buildin {\n  color: rgb(88, 72, 246);\n}\n\n.ace-tm .ace_constant.ace_language {\n  color: rgb(88, 92, 246);\n}\n\n.ace-tm .ace_constant.ace_library {\n  color: rgb(6, 150, 14);\n}\n\n.ace-tm .ace_invalid {\n  background-color: rgba(255, 0, 0, 0.1);\n  color: red;\n}\n\n.ace-tm .ace_support.ace_function {\n  color: rgb(60, 76, 114);\n}\n\n.ace-tm .ace_support.ace_constant {\n  color: rgb(6, 150, 14);\n}\n\n.ace-tm .ace_support.ace_type,\n.ace-tm .ace_support.ace_class {\n  color: rgb(109, 121, 222);\n}\n\n.ace-tm .ace_keyword.ace_operator {\n  color: rgb(104, 118, 135);\n}\n\n.ace-tm .ace_string {\n  color: rgb(3, 106, 7);\n}\n\n.ace-tm .ace_comment {\n  color: rgb(76, 136, 107);\n}\n\n.ace-tm .ace_comment.ace_doc {\n  color: rgb(0, 102, 255);\n}\n\n.ace-tm .ace_comment.ace_doc.ace_tag {\n  color: rgb(128, 159, 191);\n}\n\n.ace-tm .ace_constant.ace_numeric {\n  color: rgb(0, 0, 205);\n}\n\n.ace-tm .ace_variable {\n  color: rgb(49, 132, 149);\n}\n\n.ace-tm .ace_xml-pe {\n  color: rgb(104, 104, 91);\n}\n\n.ace-tm .ace_entity.ace_name.ace_function {\n  color: #0000A2;\n}\n\n\n.ace-tm .ace_heading {\n  color: rgb(12, 7, 255);\n}\n\n.ace-tm .ace_list {\n  color:rgb(185, 6, 144);\n}\n\n.ace-tm .ace_meta.ace_tag {\n  color:rgb(0, 22, 142);\n}\n\n.ace-tm .ace_string.ace_regex {\n  color: rgb(255, 0, 0)\n}\n\n.ace-tm .ace_marker-layer .ace_selection {\n  background: rgb(181, 213, 255);\n}\n.ace-tm.ace_multiselect .ace_selection.ace_start {\n  box-shadow: 0 0 3px 0px white;\n}\n.ace-tm .ace_marker-layer .ace_step {\n  background: rgb(252, 255, 0);\n}\n\n.ace-tm .ace_marker-layer .ace_stack {\n  background: rgb(164, 229, 101);\n}\n\n.ace-tm .ace_marker-layer .ace_bracket {\n  margin: -1px 0 0 -1px;\n  border: 1px solid rgb(192, 192, 192);\n}\n\n.ace-tm .ace_marker-layer .ace_active-line {\n  background: rgba(0, 0, 0, 0.07);\n}\n\n.ace-tm .ace_gutter-active-line {\n    background-color : #dcdcdc;\n}\n\n.ace-tm .ace_marker-layer .ace_selected-word {\n  background: rgb(250, 250, 255);\n  border: 1px solid rgb(200, 200, 250);\n}\n\n.ace-tm .ace_indent-guide {\n  background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAAE0lEQVQImWP4////f4bLly//BwAmVgd1/w11/gAAAABJRU5ErkJggg==") right repeat-y;\n}\n\n.ace-tm .ace_indent-guide-active {\n  background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAAAZSURBVHjaYvj///9/hivKyv8BAAAA//8DACLqBhbvk+/eAAAAAElFTkSuQmCC") right repeat-y;\n}\n';
            }), ace.define("ace/theme/textmate", [
                "require",
                "exports",
                "module",
                "ace/theme/textmate-css",
                "ace/lib/dom"
            ], function(e, t, i) {
                t.isDark = !1, t.cssClass = "ace-tm", t.cssText = e("./textmate-css"), t.$id = "ace/theme/textmate", e("../lib/dom").importCssString(t.cssText, t.cssClass, !1);
            }), ace.define("ace/config", [
                "require",
                "exports",
                "module",
                "ace/lib/lang",
                "ace/lib/net",
                "ace/lib/dom",
                "ace/lib/app_config",
                "ace/theme/textmate"
            ], function(s, a, t) {
                var l, e = s("./lib/lang"), c = s("./lib/net"), i = s("./lib/dom"), n = s("./lib/app_config").AppConfig, r = (t.exports = a = new n, {
                    packaged: !1,
                    workerPath: null,
                    modePath: null,
                    themePath: null,
                    basePath: "",
                    suffix: ".js",
                    $moduleUrls: {},
                    loadWorkerFromBlob: !0,
                    sharedPopups: !1,
                    useStrictCSP: null
                }), h = (a.get = function(e) {
                    if (r.hasOwnProperty(e)) return r[e];
                    throw new Error("Unknown config key: " + e);
                }, a.set = function(e, t) {
                    if (r.hasOwnProperty(e)) r[e] = t;
                    else if (0 == this.setDefaultValue("", e, t)) throw new Error("Unknown config key: " + e);
                    "useStrictCSP" == e && i.useStrictCSP(t);
                }, a.all = function() {
                    return e.copyObject(r);
                }, a.$modes = {}, a.moduleUrl = function(e, t) {
                    var i, n, o;
                    return r.$moduleUrls[e] || (e = e.split("/"), i = "snippets" == (t = t || e[e.length - 2] || "") ? "/" : "-", n = e[e.length - 1], "worker" == t && "-" == i && (o = new RegExp("^" + t + "[\\-_]|[\\-_]" + t + "$", "g"), n = n.replace(o, "")), (!n || n == t) && 1 < e.length && (n = e[e.length - 2]), null == (o = r[t + "Path"]) ? o = r.basePath : "/" == i && (t = i = ""), o && "/" != o.slice(-1) && (o += "/"), o + t + i + n + this.get("suffix"));
                }, a.setModuleUrl = function(e, t) {
                    return r.$moduleUrls[e] = t;
                }, a.setLoader = function(e) {
                    l = e;
                }, a.dynamicModules = Object.create(null), a.$loading = {}, a.$loaded = {}, a.loadModule = function(e, t) {
                    function i(e) {
                        if (e && !a.$loading[r]) return t && t(e);
                        if (a.$loading[r] || (a.$loading[r] = []), a.$loading[r].push(t), !(1 < a.$loading[r].length)) {
                            e = function() {
                                var e, t;
                                t = function(e, t) {
                                    t && (a.$loaded[r] = t), a._emit("load.module", {
                                        name: r,
                                        module: t
                                    });
                                    var i = a.$loading[r];
                                    a.$loading[r] = null, i.forEach(function(e) {
                                        e && e(t);
                                    });
                                }, "ace/theme/textmate" === (e = r) || "./theme/textmate" === e ? t(null, s("./theme/textmate")) : l ? l(e, t) : console.error("loader is not configured");
                            };
                            if (!a.get("packaged")) return e();
                            c.loadScript(a.moduleUrl(r, o), e), h();
                        }
                    }
                    var n, o, r;
                    Array.isArray(e) ? (o = e[0], r = e[1]) : "string" == typeof e && (r = e);
                    if (a.dynamicModules[r]) a.dynamicModules[r]().then(function(e) {
                        e.default ? i(e.default) : i(e);
                    });
                    else {
                        try {
                            n = this.$require(r);
                        } catch (e) {}
                        i(n || a.$loaded[r]);
                    }
                }, a.$require = function(e) {
                    if ("function" == typeof t.require) return t.require(e);
                }, a.setModuleLoader = function(e, t) {
                    a.dynamicModules[e] = t;
                }, function() {
                    r.basePath || r.workerPath || r.modePath || r.themePath || Object.keys(r.$moduleUrls).length || (console.error("Unable to infer path to ace from script src,", "use ace.config.set('basePath', 'path') to enable dynamic loading of modes and themes", "or with webpack use ace/webpack-resolver"), h = function() {});
                });
                a.version = "1.43.6";
            }), ace.define("ace/loader_build", [
                "require",
                "exports",
                "module",
                "ace/lib/fixoldbrowsers",
                "ace/config"
            ], function(g, e, p) {
                g("./lib/fixoldbrowsers");
                var m = g("./config"), f = (m.setLoader(function(e, t) {
                    g([
                        e
                    ], function(e) {
                        t(null, e);
                    });
                }), function() {
                    return this || "undefined" != typeof window && window;
                }());
                function t(e) {
                    if (f && f.document) {
                        m.set("packaged", e || g.packaged || p.packaged || f.define && C.amdD.packaged);
                        for(var t, i = {}, n = "", e = document.currentScript || document._currentScript, o = e && e.ownerDocument || document, r = (e && e.src && (n = e.src.split(/[?#]/)[0].split("/").slice(0, -1).join("/") || ""), o.getElementsByTagName("script")), s = 0; s < r.length; s++){
                            var a = r[s], l = a.src || a.getAttribute("src");
                            if (l) {
                                for(var c = a.attributes, h = 0, d = c.length; h < d; h++){
                                    var u = c[h];
                                    0 === u.name.indexOf("data-ace-") && (i[u.name.replace(/^data-ace-/, "").replace(/-(.)/g, function(e, t) {
                                        return t.toUpperCase();
                                    })] = u.value);
                                }
                                a = l.match(/^(.*)\/ace([\-.]\w+)?\.js(\?|$)/);
                                a && (n = a[1]);
                            }
                        }
                        for(t in n && (i.base = i.base || n, i.packaged = !0), i.basePath = i.base, i.workerPath = i.workerPath || i.base, i.modePath = i.modePath || i.base, i.themePath = i.themePath || i.base, delete i.base, i)void 0 !== i[t] && m.set(t, i[t]);
                    }
                }
                p.exports = function(e) {
                    m.init = t, m.$require = g, e.require = g, e.define = C.amdD;
                }, t(!0);
            }), ace.define("ace/range", [
                "require",
                "exports",
                "module"
            ], function(e, t, i) {
                r.prototype.isEqual = function(e) {
                    return this.start.row === e.start.row && this.end.row === e.end.row && this.start.column === e.start.column && this.end.column === e.end.column;
                }, r.prototype.toString = function() {
                    return "Range: [" + this.start.row + "/" + this.start.column + "] -> [" + this.end.row + "/" + this.end.column + "]";
                }, r.prototype.contains = function(e, t) {
                    return 0 == this.compare(e, t);
                }, r.prototype.compareRange = function(e) {
                    var t = e.end, e = e.start, t = this.compare(t.row, t.column);
                    return 1 == t ? 1 == (t = this.compare(e.row, e.column)) ? 2 : 0 == t ? 1 : 0 : -1 == t ? -2 : -1 == (t = this.compare(e.row, e.column)) ? -1 : 1 == t ? 42 : 0;
                }, r.prototype.comparePoint = function(e) {
                    return this.compare(e.row, e.column);
                }, r.prototype.containsRange = function(e) {
                    return 0 == this.comparePoint(e.start) && 0 == this.comparePoint(e.end);
                }, r.prototype.intersects = function(e) {
                    e = this.compareRange(e);
                    return -1 == e || 0 == e || 1 == e;
                }, r.prototype.isEnd = function(e, t) {
                    return this.end.row == e && this.end.column == t;
                }, r.prototype.isStart = function(e, t) {
                    return this.start.row == e && this.start.column == t;
                }, r.prototype.setStart = function(e, t) {
                    "object" == typeof e ? (this.start.column = e.column, this.start.row = e.row) : (this.start.row = e, this.start.column = t);
                }, r.prototype.setEnd = function(e, t) {
                    "object" == typeof e ? (this.end.column = e.column, this.end.row = e.row) : (this.end.row = e, this.end.column = t);
                }, r.prototype.inside = function(e, t) {
                    return 0 == this.compare(e, t) && !this.isEnd(e, t) && !this.isStart(e, t);
                }, r.prototype.insideStart = function(e, t) {
                    return 0 == this.compare(e, t) && !this.isEnd(e, t);
                }, r.prototype.insideEnd = function(e, t) {
                    return 0 == this.compare(e, t) && !this.isStart(e, t);
                }, r.prototype.compare = function(e, t) {
                    return this.isMultiLine() || e !== this.start.row ? e < this.start.row ? -1 : e > this.end.row ? 1 : this.start.row === e ? t >= this.start.column ? 0 : -1 : this.end.row !== e || t <= this.end.column ? 0 : 1 : t < this.start.column ? -1 : t > this.end.column ? 1 : 0;
                }, r.prototype.compareStart = function(e, t) {
                    return this.start.row == e && this.start.column == t ? -1 : this.compare(e, t);
                }, r.prototype.compareEnd = function(e, t) {
                    return this.end.row == e && this.end.column == t ? 1 : this.compare(e, t);
                }, r.prototype.compareInside = function(e, t) {
                    return this.end.row == e && this.end.column == t ? 1 : this.start.row == e && this.start.column == t ? -1 : this.compare(e, t);
                }, r.prototype.clipRows = function(e, t) {
                    var i, n;
                    return this.end.row > t ? i = {
                        row: t + 1,
                        column: 0
                    } : this.end.row < e && (i = {
                        row: e,
                        column: 0
                    }), this.start.row > t ? n = {
                        row: t + 1,
                        column: 0
                    } : this.start.row < e && (n = {
                        row: e,
                        column: 0
                    }), r.fromPoints(n || this.start, i || this.end);
                }, r.prototype.extend = function(e, t) {
                    var i, n, o = this.compare(e, t);
                    return 0 == o ? this : (-1 == o ? i = {
                        row: e,
                        column: t
                    } : n = {
                        row: e,
                        column: t
                    }, r.fromPoints(i || this.start, n || this.end));
                }, r.prototype.isEmpty = function() {
                    return this.start.row === this.end.row && this.start.column === this.end.column;
                }, r.prototype.isMultiLine = function() {
                    return this.start.row !== this.end.row;
                }, r.prototype.clone = function() {
                    return r.fromPoints(this.start, this.end);
                }, r.prototype.collapseRows = function() {
                    return 0 == this.end.column ? new r(this.start.row, 0, Math.max(this.start.row, this.end.row - 1), 0) : new r(this.start.row, 0, this.end.row, 0);
                }, r.prototype.toScreenRange = function(e) {
                    var t = e.documentToScreenPosition(this.start), e = e.documentToScreenPosition(this.end);
                    return new r(t.row, t.column, e.row, e.column);
                }, r.prototype.moveBy = function(e, t) {
                    this.start.row += e, this.start.column += t, this.end.row += e, this.end.column += t;
                };
                var n = r;
                function r(e, t, i, n) {
                    this.start = {
                        row: e,
                        column: t
                    }, this.end = {
                        row: i,
                        column: n
                    };
                }
                n.fromPoints = function(e, t) {
                    return new n(e.row, e.column, t.row, t.column);
                }, n.comparePoints = function(e, t) {
                    return e.row - t.row || e.column - t.column;
                }, t.Range = n;
            }), ace.define("ace/lib/keys", [
                "require",
                "exports",
                "module",
                "ace/lib/oop"
            ], function(e, t, i) {
                for(var e = e("./oop"), n = {
                    MODIFIER_KEYS: {
                        16: "Shift",
                        17: "Ctrl",
                        18: "Alt",
                        224: "Meta",
                        91: "MetaLeft",
                        92: "MetaRight",
                        93: "ContextMenu"
                    },
                    KEY_MODS: {
                        ctrl: 1,
                        alt: 2,
                        option: 2,
                        shift: 4,
                        super: 8,
                        meta: 8,
                        command: 8,
                        cmd: 8,
                        control: 1
                    },
                    FUNCTION_KEYS: {
                        8: "Backspace",
                        9: "Tab",
                        13: "Return",
                        19: "Pause",
                        27: "Esc",
                        32: "Space",
                        33: "PageUp",
                        34: "PageDown",
                        35: "End",
                        36: "Home",
                        37: "Left",
                        38: "Up",
                        39: "Right",
                        40: "Down",
                        44: "Print",
                        45: "Insert",
                        46: "Delete",
                        "-13": "NumpadEnter",
                        144: "Numlock",
                        145: "Scrolllock"
                    },
                    PRINTABLE_KEYS: {
                        32: " ",
                        59: ";",
                        61: "=",
                        107: "+",
                        109: "-",
                        110: ".",
                        186: ";",
                        187: "=",
                        188: ",",
                        189: "-",
                        190: ".",
                        191: "/",
                        192: "`",
                        219: "[",
                        220: "\\",
                        221: "]",
                        222: "'",
                        111: "/",
                        106: "*"
                    }
                }, o = {
                    Command: 224,
                    Backspace: 8,
                    Tab: 9,
                    Return: 13,
                    Enter: 13,
                    Pause: 19,
                    Escape: 27,
                    PageUp: 33,
                    PageDown: 34,
                    End: 35,
                    Home: 36,
                    Insert: 45,
                    Delete: 46,
                    ArrowLeft: 37,
                    ArrowUp: 38,
                    ArrowRight: 39,
                    ArrowDown: 40,
                    Backquote: 192,
                    Minus: 189,
                    Equal: 187,
                    BracketLeft: 219,
                    Backslash: 220,
                    BracketRight: 221,
                    Semicolon: 186,
                    Quote: 222,
                    Comma: 188,
                    Period: 190,
                    Slash: 191,
                    Space: 32,
                    NumpadAdd: 107,
                    NumpadDecimal: 110,
                    NumpadSubtract: 109,
                    NumpadDivide: 111,
                    NumpadMultiply: 106
                }, r = 0; r < 10; r++)o["Digit" + r] = 48 + r, o["Numpad" + r] = 96 + r, n.PRINTABLE_KEYS[48 + r] = "" + r, n.FUNCTION_KEYS[96 + r] = "Numpad" + r;
                for(r = 65; r < 91; r++){
                    var s = String.fromCharCode(r + 32);
                    o["Key" + s.toUpperCase()] = r, n.PRINTABLE_KEYS[r] = s;
                }
                for(r = 1; r < 13; r++)o["F" + r] = 111 + r, n.FUNCTION_KEYS[111 + r] = "F" + r;
                var a, l, c = {
                    Shift: 16,
                    Control: 17,
                    Alt: 18,
                    Meta: 224
                };
                for(a in c)o[a] = o[a + "Left"] = o[a + "Right"] = c[a];
                for(l in t.$codeToKeyCode = o, n.PRINTABLE_KEYS[173] = "-", n.FUNCTION_KEYS){
                    var h = n.FUNCTION_KEYS[l].toLowerCase();
                    n[h] = parseInt(l, 10);
                }
                for(l in n.PRINTABLE_KEYS){
                    h = n.PRINTABLE_KEYS[l].toLowerCase();
                    n[h] = parseInt(l, 10);
                }
                e.mixin(n, n.MODIFIER_KEYS), e.mixin(n, n.PRINTABLE_KEYS), e.mixin(n, n.FUNCTION_KEYS), n.enter = n.return, n.escape = n.esc, n.del = n.delete;
                for(var d = [
                    "cmd",
                    "ctrl",
                    "alt",
                    "shift"
                ], u = Math.pow(2, d.length); u--;)n.KEY_MODS[u] = d.filter(function(e) {
                    return u & n.KEY_MODS[e];
                }).join("-") + "-";
                n.KEY_MODS[0] = "", n.KEY_MODS[-1] = "input-", e.mixin(t, n), (t.default = t).keyCodeToString = function(e) {
                    var t = n[e];
                    return (t = "string" != typeof t ? String.fromCharCode(e) : t).toLowerCase();
                };
            }), ace.define("ace/lib/event", [
                "require",
                "exports",
                "module",
                "ace/lib/keys",
                "ace/lib/useragent"
            ], function(e, d, t) {
                var i, r = e("./keys"), u = e("./useragent"), s = null, a = 0;
                function o() {
                    if (null == i) {
                        i = !1;
                        try {
                            document.createComment("").addEventListener("test", function() {}, {
                                get passive () {
                                    return i = {
                                        passive: !1
                                    }, !0;
                                }
                            });
                        } catch (e) {}
                    }
                    return i;
                }
                function l(e, t, i) {
                    this.elem = e, this.type = t, this.callback = i;
                }
                l.prototype.destroy = function() {
                    h(this.elem, this.type, this.callback), this.elem = this.type = this.callback = void 0;
                };
                var c, g = d.addListener = function(e, t, i, n) {
                    e.addEventListener(t, i, o()), n && n.$toDestroy.push(new l(e, t, i));
                }, h = d.removeListener = function(e, t, i) {
                    e.removeEventListener(t, i, o());
                };
                function p(e) {
                    return 0 | (e.ctrlKey ? 1 : 0) | (e.altKey ? 2 : 0) | (e.shiftKey ? 4 : 0) | (e.metaKey ? 8 : 0);
                }
                function m() {
                    s = Object.create(null);
                }
                d.stopEvent = function(e) {
                    return d.stopPropagation(e), d.preventDefault(e), !1;
                }, d.stopPropagation = function(e) {
                    e.stopPropagation && e.stopPropagation();
                }, d.preventDefault = function(e) {
                    e.preventDefault && e.preventDefault();
                }, d.getButton = function(e) {
                    return "dblclick" == e.type ? 0 : "contextmenu" == e.type || u.isMac && e.ctrlKey && !e.altKey && !e.shiftKey ? 2 : e.button;
                }, d.capture = function(e, t, i) {
                    var n = e && e.ownerDocument || document;
                    function o(e) {
                        t && t(e), i && i(e), h(n, "mousemove", t), h(n, "mouseup", o), h(n, "dragstart", o);
                    }
                    return g(n, "mousemove", t), g(n, "mouseup", o), g(n, "dragstart", o), o;
                }, d.addMouseWheelListener = function(e, n, t) {
                    g(e, "wheel", function(e) {
                        var t = e.deltaX || 0, i = e.deltaY || 0;
                        switch(e.deltaMode){
                            case e.DOM_DELTA_PIXEL:
                                e.wheelX = .15 * t, e.wheelY = .15 * i;
                                break;
                            case e.DOM_DELTA_LINE:
                                e.wheelX = 15 * t, e.wheelY = 15 * i;
                                break;
                            case e.DOM_DELTA_PAGE:
                                e.wheelX = 150 * t, e.wheelY = 150 * i;
                        }
                        n(e);
                    }, t);
                }, d.addMultiMouseDownListener = function(e, i, n, o, t) {
                    var r, s, a, l = 0, c = {
                        2: "dblclick",
                        3: "tripleclick",
                        4: "quadclick"
                    };
                    function h(e) {
                        var t;
                        if (0 !== d.getButton(e) ? l = 0 : 1 < e.detail && !(4 < ++l) || (l = 1), u.isIE && (t = 5 < Math.abs(e.clientX - r) || 5 < Math.abs(e.clientY - s), a && !t || (l = 1), a && clearTimeout(a), a = setTimeout(function() {
                            a = null;
                        }, i[l - 1] || 600), 1 == l) && (r = e.clientX, s = e.clientY), e._clicks = l, n[o]("mousedown", e), 4 < l) l = 0;
                        else if (1 < l) return n[o](c[l], e);
                    }
                    (e = Array.isArray(e) ? e : [
                        e
                    ]).forEach(function(e) {
                        g(e, "mousedown", h, t);
                    });
                }, d.getModifierString = function(e) {
                    return r.KEY_MODS[p(e)];
                }, d.addCommandKeyListener = function(e, i, t) {
                    var n = null;
                    g(e, "keydown", function(e) {
                        s[e.keyCode] = (s[e.keyCode] || 0) + 1;
                        var t = ((e, t, i)=>{
                            var n, o = p(t);
                            if (!i && t.code && (i = r.$codeToKeyCode[t.code] || i), !u.isMac && s) {
                                if (t.getModifierState && (t.getModifierState("OS") || t.getModifierState("Win")) && (o |= 8), s.altGr) {
                                    if (3 == (3 & o)) return;
                                    s.altGr = 0;
                                }
                                18 !== i && 17 !== i || (n = t.location, 17 === i && 1 === n ? 1 == s[i] && (a = t.timeStamp) : 18 === i && 3 === o && 2 === n && t.timeStamp - a < 50 && (s.altGr = !0));
                            }
                            if (i in r.MODIFIER_KEYS && (i = -1), o || 13 !== i || 3 !== t.location || (e(t, o, -i), !t.defaultPrevented)) {
                                if (u.isChromeOS && 8 & o) {
                                    if (e(t, o, i), t.defaultPrevented) return;
                                    o &= -9;
                                }
                                return o || i in r.FUNCTION_KEYS || i in r.PRINTABLE_KEYS ? e(t, o, i) : !1;
                            }
                        })(i, e, e.keyCode);
                        return n = e.defaultPrevented, t;
                    }, t), g(e, "keypress", function(e) {
                        n && (e.ctrlKey || e.altKey || e.shiftKey || e.metaKey) && (d.stopEvent(e), n = null);
                    }, t), g(e, "keyup", function(e) {
                        s[e.keyCode] = null;
                    }, t), s || (m(), g(window, "focus", m));
                }, "object" == typeof window && window.postMessage && !u.isOldIE && (c = 1, d.nextTick = function(t, i) {
                    i = i || window;
                    function n(e) {
                        e.data == o && (d.stopPropagation(e), h(i, "message", n), t());
                    }
                    var o = "zero-timeout-message-" + c++;
                    g(i, "message", n), i.postMessage(o, "*");
                }), d.$idleBlocked = !1, d.onIdle = function(t, e) {
                    return setTimeout(function e() {
                        d.$idleBlocked ? setTimeout(e, 100) : t();
                    }, e);
                }, d.$idleBlockId = null, d.blockIdle = function(e) {
                    d.$idleBlockId && clearTimeout(d.$idleBlockId), d.$idleBlocked = !0, d.$idleBlockId = setTimeout(function() {
                        d.$idleBlocked = !1;
                    }, e || 100);
                }, d.nextFrame = "object" == typeof window && (window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame || window.oRequestAnimationFrame), d.nextFrame = d.nextFrame ? d.nextFrame.bind(window) : function(e) {
                    setTimeout(e, 17);
                };
            }), ace.define("ace/clipboard", [
                "require",
                "exports",
                "module"
            ], function(e, t, i) {
                var n;
                i.exports = {
                    lineMode: !1,
                    pasteCancelled: function() {
                        return !!(n && n > Date.now() - 50) || (n = !1);
                    },
                    cancel: function() {
                        n = Date.now();
                    }
                };
            }), ace.define("ace/keyboard/textinput", [
                "require",
                "exports",
                "module",
                "ace/lib/event",
                "ace/config",
                "ace/lib/useragent",
                "ace/lib/dom",
                "ace/lib/lang",
                "ace/clipboard",
                "ace/lib/keys"
            ], function(e, t, i) {
                var l = e("../lib/event"), n = e("../config").nls, d = e("../lib/useragent"), c = e("../lib/dom"), r = e("../lib/lang"), o = e("../clipboard"), s = d.isChrome < 18, a = d.isIE, h = 63 < d.isChrome, u = e("../lib/keys"), g = u.KEY_MODS, p = d.isIOS, m = p ? /\s/ : /\n/, f = d.isMobile;
                function C(e, n) {
                    var o = this;
                    this.host = n, this.text = c.createElement("textarea"), this.text.className = "ace_text-input", this.text.setAttribute("wrap", "off"), this.text.setAttribute("autocomplete", "off"), this.text.setAttribute("autocorrect", "off"), this.text.setAttribute("autocapitalize", "off"), this.text.setAttribute("spellcheck", "false"), this.text.style.opacity = "0", e.insertBefore(this.text, e.firstChild), this.copied = !1, this.pasted = !1, this.inComposition = !1, this.sendingText = !1, this.tempStyle = "", f || (this.text.style.fontSize = "1px"), this.commandMode = !1, this.ignoreFocusEvents = !1, this.lastValue = "", this.lastSelectionStart = 0, this.lastSelectionEnd = 0, this.lastRestoreEnd = 0, this.rowStart = Number.MAX_SAFE_INTEGER, this.rowEnd = Number.MIN_SAFE_INTEGER, this.numberOfExtraLines = 0;
                    try {
                        this.$isFocused = document.activeElement === this.text;
                    } catch (e) {}
                    this.cancelComposition = this.cancelComposition.bind(this), this.setAriaOptions({
                        role: "textbox"
                    }), l.addListener(this.text, "blur", function(e) {
                        o.ignoreFocusEvents || (n.onBlur(e), o.$isFocused = !1);
                    }, n), l.addListener(this.text, "focus", function(e) {
                        if (!o.ignoreFocusEvents) {
                            if (o.$isFocused = !0, d.isEdge) try {
                                if (!document.hasFocus()) return;
                            } catch (e) {}
                            n.onFocus(e), d.isEdge ? setTimeout(o.resetSelection.bind(o)) : o.resetSelection();
                        }
                    }, n), this.$focusScroll = !1, n.on("beforeEndOperation", function() {
                        var e = n.curOp, t = e && e.command && e.command.name;
                        "insertstring" != t && (t = t && (e.docChanged || e.selectionChanged), o.inComposition && t && (o.lastValue = o.text.value = "", o.onCompositionEnd()), o.resetSelection());
                    }), n.on("changeSelection", this.setAriaLabel.bind(this)), this.resetSelection = p ? this.$resetSelectionIOS : this.$resetSelection, this.$isFocused && n.onFocus(), this.inputHandler = null, this.afterContextMenu = !1, l.addCommandKeyListener(this.text, function(e, t, i) {
                        if (!o.inComposition) return n.onCommandKey(e, t, i);
                    }, n), l.addListener(this.text, "select", this.onSelect.bind(this), n), l.addListener(this.text, "input", this.onInput.bind(this), n), l.addListener(this.text, "cut", this.onCut.bind(this), n), l.addListener(this.text, "copy", this.onCopy.bind(this), n), l.addListener(this.text, "paste", this.onPaste.bind(this), n), "oncut" in this.text && "oncopy" in this.text && "onpaste" in this.text || l.addListener(e, "keydown", function(e) {
                        if ((!d.isMac || e.metaKey) && e.ctrlKey) switch(e.keyCode){
                            case 67:
                                o.onCopy(e);
                                break;
                            case 86:
                                o.onPaste(e);
                                break;
                            case 88:
                                o.onCut(e);
                        }
                    }, n), this.syncComposition = r.delayedCall(this.onCompositionUpdate.bind(this), 50).schedule.bind(null, null), l.addListener(this.text, "compositionstart", this.onCompositionStart.bind(this), n), l.addListener(this.text, "compositionupdate", this.onCompositionUpdate.bind(this), n), l.addListener(this.text, "keyup", this.onKeyup.bind(this), n), l.addListener(this.text, "keydown", this.syncComposition.bind(this), n), l.addListener(this.text, "compositionend", this.onCompositionEnd.bind(this), n), this.closeTimeout, l.addListener(this.text, "mouseup", this.$onContextMenu.bind(this), n), l.addListener(this.text, "mousedown", function(e) {
                        e.preventDefault(), o.onContextMenuClose();
                    }, n), l.addListener(n.renderer.scroller, "contextmenu", this.$onContextMenu.bind(this), n), l.addListener(this.text, "contextmenu", this.$onContextMenu.bind(this), n), p && this.addIosSelectionHandler(e, n, this.text);
                }
                C.prototype.addIosSelectionHandler = function(e, r, s) {
                    function t(e) {
                        var t, i, n, o;
                        document.activeElement !== s || l || a.inComposition || r.$mouseHandler.isMousePressed || a.copied || (t = s.selectionStart, i = s.selectionEnd, n = null, (o = 0) == t ? n = u.up : 1 == t ? n = u.home : i > a.lastSelectionEnd && "\n" == a.lastValue[i] ? n = u.end : t < a.lastSelectionStart && " " == a.lastValue[t - 1] ? (n = u.left, o = g.option) : t < a.lastSelectionStart || t == a.lastSelectionStart && a.lastSelectionEnd != a.lastSelectionStart && t == i ? n = u.left : i > a.lastSelectionEnd && 2 < a.lastValue.slice(0, i).split("\n").length ? n = u.down : i > a.lastSelectionEnd && " " == a.lastValue[i - 1] ? (n = u.right, o = g.option) : (i > a.lastSelectionEnd || i == a.lastSelectionEnd && a.lastSelectionEnd != a.lastSelectionStart && t == i) && (n = u.right), t !== i && (o |= g.shift), n && (!r.onCommandKey({}, o, n) && r.commands && (n = u.keyCodeToString(n), o = r.commands.findKeyCommand(o, n)) && r.execCommand(o), a.lastSelectionStart = t, a.lastSelectionEnd = i, a.resetSelection("")));
                    }
                    var a = this, i = null, l = !1;
                    s.addEventListener("keydown", function(e) {
                        i && clearTimeout(i), l = !0;
                    }, !0), s.addEventListener("keyup", function(e) {
                        i = setTimeout(function() {
                            l = !1;
                        }, 100);
                    }, !0);
                    document.addEventListener("selectionchange", t), r.on("destroy", function() {
                        document.removeEventListener("selectionchange", t);
                    });
                }, C.prototype.onContextMenuClose = function() {
                    var e = this;
                    clearTimeout(this.closeTimeout), this.closeTimeout = setTimeout(function() {
                        e.tempStyle && (e.text.style.cssText = e.tempStyle, e.tempStyle = ""), e.host.renderer.$isMousePressed = !1, e.host.renderer.$keepTextAreaAtCursor && e.host.renderer.$moveTextAreaToCursor();
                    }, 0);
                }, C.prototype.$onContextMenu = function(e) {
                    this.host.textInput.onContextMenu(e), this.onContextMenuClose();
                }, C.prototype.onKeyup = function(e) {
                    27 == e.keyCode && this.text.value.length < this.text.selectionStart && (this.inComposition || (this.lastValue = this.text.value), this.lastSelectionStart = this.lastSelectionEnd = -1, this.resetSelection()), this.syncComposition();
                }, C.prototype.cancelComposition = function() {
                    this.ignoreFocusEvents = !0, this.text.blur(), this.text.focus(), this.ignoreFocusEvents = !1;
                }, C.prototype.onCompositionStart = function(e) {
                    this.inComposition || !this.host.onCompositionStart || this.host.$readOnly || (this.inComposition = {}, this.commandMode) || (e.data && (this.inComposition.useTextareaForIME = !1), setTimeout(this.onCompositionUpdate.bind(this), 0), this.host._signal("compositionStart"), this.host.on("mousedown", this.cancelComposition), (e = this.host.getSelectionRange()).end.row = e.start.row, e.end.column = e.start.column, this.inComposition.markerRange = e, this.inComposition.selectionStart = this.lastSelectionStart, this.host.onCompositionStart(this.inComposition), this.inComposition.useTextareaForIME ? (this.lastValue = this.text.value = "", this.lastSelectionStart = 0, this.lastSelectionEnd = 0) : (this.text.msGetInputContext && (this.inComposition.context = this.text.msGetInputContext()), this.text.getInputContext && (this.inComposition.context = this.text.getInputContext())));
                }, C.prototype.onCompositionUpdate = function() {
                    var e;
                    if (this.inComposition && this.host.onCompositionUpdate && !this.host.$readOnly) return this.commandMode ? this.cancelComposition() : void (this.inComposition.useTextareaForIME ? this.host.onCompositionUpdate(this.text.value) : (e = this.text.value, this.sendText(e), this.inComposition.markerRange && (this.inComposition.context && (this.inComposition.markerRange.start.column = this.inComposition.selectionStart = this.inComposition.context.compositionStartOffset), this.inComposition.markerRange.end.column = this.inComposition.markerRange.start.column + this.lastSelectionEnd - this.inComposition.selectionStart + this.lastRestoreEnd)));
                }, C.prototype.onCompositionEnd = function(e) {
                    this.host.onCompositionEnd && !this.host.$readOnly && (this.inComposition = !1, this.host.onCompositionEnd(), this.host.off("mousedown", this.cancelComposition), e) && this.onInput();
                }, C.prototype.onCut = function(e) {
                    this.doCopy(e, !0);
                }, C.prototype.onCopy = function(e) {
                    this.doCopy(e, !1);
                }, C.prototype.onPaste = function(e) {
                    var t = this.handleClipboardData(e);
                    o.pasteCancelled() || ("string" == typeof t ? (t && this.host.onPaste(t, e), d.isIE && setTimeout(this.resetSelection), l.preventDefault(e)) : (this.text.value = "", this.pasted = !0));
                }, C.prototype.doCopy = function(e, t) {
                    var i = this, n = this.host.getCopyText();
                    if (!n) return l.preventDefault(e);
                    this.handleClipboardData(e, n) ? (p && (this.resetSelection(n), this.copied = n, setTimeout(function() {
                        i.copied = !1;
                    }, 10)), t ? this.host.onCut() : this.host.onCopy(), l.preventDefault(e)) : (this.copied = !0, this.text.value = n, this.text.select(), setTimeout(function() {
                        i.copied = !1, i.resetSelection(), t ? i.host.onCut() : i.host.onCopy();
                    }));
                }, C.prototype.handleClipboardData = function(e, t, i) {
                    var n = e.clipboardData || window.clipboardData;
                    if (n && !s) {
                        var o = a || i ? "Text" : "text/plain";
                        try {
                            return t ? !1 !== n.setData(o, t) : n.getData(o);
                        } catch (e) {
                            if (!i) return this.handleClipboardData(e, t, !0);
                        }
                    }
                }, C.prototype.onInput = function(e) {
                    if (this.inComposition) return this.onCompositionUpdate();
                    if (e && e.inputType) {
                        if ("historyUndo" == e.inputType) return this.host.execCommand("undo");
                        if ("historyRedo" == e.inputType) return this.host.execCommand("redo");
                    }
                    var e = this.text.value, t = this.sendText(e, !0);
                    (500 < e.length || m.test(t) || f && this.lastSelectionStart < 1 && this.lastSelectionStart == this.lastSelectionEnd) && this.resetSelection();
                }, C.prototype.sendText = function(e, t) {
                    if (this.afterContextMenu && (this.afterContextMenu = !1), this.pasted) return this.resetSelection(), e && this.host.onPaste(e), this.pasted = !1, "";
                    for(var i = this.text.selectionStart, n = this.text.selectionEnd, o = this.lastSelectionStart, r = this.lastValue.length - this.lastSelectionEnd, s = e, a = e.length - i, l = e.length - n, c = 0; 0 < o && this.lastValue[c] == e[c];)c++, o--;
                    for(s = s.slice(c), c = 1; 0 < r && this.lastValue.length - c > this.lastSelectionStart - 1 && this.lastValue[this.lastValue.length - c] == e[e.length - c];)c++, r--;
                    a -= c - 1, l -= c - 1;
                    var h = s.length - c + 1;
                    return h < 0 && (o = -h, h = 0), s = s.slice(0, h), t || s || a || o || r || l ? (h = (this.sendingText = !0, false), d.isAndroid && ". " == s && (s = "  ", h = !0), s && !o && !r && !a && !l || this.commandMode ? this.host.onTextInput(s) : this.host.onTextInput(s, {
                        extendLeft: o,
                        extendRight: r,
                        restoreStart: a,
                        restoreEnd: l
                    }), this.sendingText = !1, this.lastValue = e, this.lastSelectionStart = i, this.lastSelectionEnd = n, this.lastRestoreEnd = l, h ? "\n" : s) : "";
                }, C.prototype.onSelect = function(e) {
                    var t, i = this;
                    this.inComposition || (this.copied ? this.copied = !1 : 0 === (t = this.text).selectionStart && t.selectionEnd >= i.lastValue.length && t.value === i.lastValue && i.lastValue && t.selectionEnd !== i.lastSelectionEnd ? (this.host.selectAll(), this.resetSelection()) : f && this.text.selectionStart != this.lastSelectionStart && this.resetSelection());
                }, C.prototype.$resetSelectionIOS = function(e) {
                    var t;
                    !this.$isFocused || this.copied && !e || this.sendingText || ((t = "\n ab" + (e = e || "") + "cde fg\n") != this.text.value && (this.text.value = this.lastValue = t), t = 4 + (e.length || (this.host.selection.isEmpty() ? 0 : 1)), 4 == this.lastSelectionStart && this.lastSelectionEnd == t || this.text.setSelectionRange(4, t), this.lastSelectionStart = 4, this.lastSelectionEnd = t);
                }, C.prototype.$resetSelection = function() {
                    var o = this;
                    if (!this.inComposition && !this.sendingText && (this.$isFocused || this.afterContextMenu)) {
                        this.inComposition = !0;
                        var e = 0, t = 0, i = "", n = function(e, t) {
                            for(var i = t, n = 1; n <= e - o.rowStart && n < 2 * o.numberOfExtraLines + 1; n++)i += o.host.session.getLine(e - n).length + 1;
                            return i;
                        };
                        if (this.host.session) {
                            for(var r = this.host.selection, s = r.getRange(), r = r.cursor.row, a = (r === this.rowEnd + 1 ? (this.rowStart = this.rowEnd + 1, this.rowEnd = this.rowStart + 2 * this.numberOfExtraLines) : r === this.rowStart - 1 ? (this.rowEnd = this.rowStart - 1, this.rowStart = this.rowEnd - 2 * this.numberOfExtraLines) : (r < this.rowStart - 1 || r > this.rowEnd + 1) && (this.rowStart = r > this.numberOfExtraLines ? r - this.numberOfExtraLines : 0, this.rowEnd = r > this.numberOfExtraLines ? r + this.numberOfExtraLines : 2 * this.numberOfExtraLines), []), l = this.rowStart; l <= this.rowEnd; l++)a.push(this.host.session.getLine(l));
                            i = a.join("\n"), e = n(s.start.row, s.start.column), t = n(s.end.row, s.end.column), s.start.row < this.rowStart ? (n = this.host.session.getLine(this.rowStart - 1), e = s.start.row < this.rowStart - 1 ? 0 : e, t += n.length + 1, i = n + "\n" + i) : s.end.row > this.rowEnd ? (n = this.host.session.getLine(this.rowEnd + 1), t = s.end.row > this.rowEnd + 1 ? n.length : s.end.column, t += i.length + 1, i = i + "\n" + n) : f && 0 < r && (i = "\n" + i, t += 1, e += 1), 400 < i.length && (e < 400 && t < 400 ? i = i.slice(0, 400) : (i = "\n", e == t ? e = t = 0 : (e = 0, t = 1)));
                            s = i + "\n\n";
                            s != this.lastValue && (this.text.value = this.lastValue = s, this.lastSelectionStart = this.lastSelectionEnd = s.length);
                        }
                        if (this.afterContextMenu && (this.lastSelectionStart = this.text.selectionStart, this.lastSelectionEnd = this.text.selectionEnd), this.lastSelectionEnd != t || this.lastSelectionStart != e || this.text.selectionEnd != this.lastSelectionEnd) try {
                            this.text.setSelectionRange(e, t), this.lastSelectionStart = e, this.lastSelectionEnd = t;
                        } catch (e) {}
                        this.inComposition = !1;
                    }
                }, C.prototype.setHost = function(e) {
                    this.host = e;
                }, C.prototype.setNumberOfExtraLines = function(e) {
                    this.rowStart = Number.MAX_SAFE_INTEGER, this.rowEnd = Number.MIN_SAFE_INTEGER, this.numberOfExtraLines = e < 0 ? 0 : e;
                }, C.prototype.setAriaLabel = function() {
                    var e, t = "";
                    this.host.$textInputAriaLabel && (t += "".concat(this.host.$textInputAriaLabel, ", ")), this.host.session && (e = this.host.session.selection.cursor.row, t += n("text-input.aria-label", "Cursor at row $0", [
                        e + 1
                    ])), this.text.setAttribute("aria-label", t);
                }, C.prototype.setAriaOptions = function(e) {
                    e.activeDescendant ? (this.text.setAttribute("aria-haspopup", "true"), this.text.setAttribute("aria-autocomplete", e.inline ? "both" : "list"), this.text.setAttribute("aria-activedescendant", e.activeDescendant)) : (this.text.setAttribute("aria-haspopup", "false"), this.text.setAttribute("aria-autocomplete", "both"), this.text.removeAttribute("aria-activedescendant")), e.role && this.text.setAttribute("role", e.role), e.setLabel && (this.text.setAttribute("aria-roledescription", n("text-input.aria-roledescription", "editor")), this.setAriaLabel());
                }, C.prototype.focus = function() {
                    var e = this;
                    if (this.setAriaOptions({
                        setLabel: this.host.renderer.enableKeyboardAccessibility
                    }), this.tempStyle || h || "browser" == this.$focusScroll) return this.text.focus({
                        preventScroll: !0
                    });
                    var t = this.text.style.top;
                    this.text.style.position = "fixed", this.text.style.top = "0px";
                    try {
                        var i = 0 != this.text.getBoundingClientRect().top;
                    } catch (e) {
                        return;
                    }
                    var n = [];
                    if (i) for(var o = this.text.parentElement; o && 1 == o.nodeType;)n.push(o), o.setAttribute("ace_nocontext", "true"), o = !o.parentElement && o.getRootNode ? o.getRootNode().host : o.parentElement;
                    this.text.focus({
                        preventScroll: !0
                    }), i && n.forEach(function(e) {
                        e.removeAttribute("ace_nocontext");
                    }), setTimeout(function() {
                        e.text.style.position = "", "0px" == e.text.style.top && (e.text.style.top = t);
                    }, 0);
                }, C.prototype.blur = function() {
                    this.text.blur();
                }, C.prototype.isFocused = function() {
                    return this.$isFocused;
                }, C.prototype.setInputHandler = function(e) {
                    this.inputHandler = e;
                }, C.prototype.getInputHandler = function() {
                    return this.inputHandler;
                }, C.prototype.getElement = function() {
                    return this.text;
                }, C.prototype.setCommandMode = function(e) {
                    this.commandMode = e, this.text.readOnly = !1;
                }, C.prototype.setReadOnly = function(e) {
                    this.commandMode || (this.text.readOnly = e);
                }, C.prototype.setCopyWithEmptySelection = function(e) {}, C.prototype.onContextMenu = function(e) {
                    this.afterContextMenu = !0, this.resetSelection(), this.host._emit("nativecontextmenu", {
                        target: this.host,
                        domEvent: e
                    }), this.moveToMouse(e, !0);
                }, C.prototype.moveToMouse = function(e, t) {
                    function i(e) {
                        c.translate(n.text, e.clientX - s - 2, Math.min(e.clientY - r - 2, a));
                    }
                    var n = this, t = (this.tempStyle || (this.tempStyle = this.text.style.cssText), this.text.style.cssText = (t ? "z-index:100000;" : "") + (d.isIE ? "opacity:0.1;" : "") + "text-indent: -" + (this.lastSelectionStart + this.lastSelectionEnd) * this.host.renderer.characterWidth * .5 + "px;", this.host.container.getBoundingClientRect()), o = c.computedStyle(this.host.container), r = t.top + (parseInt(o.borderTopWidth) || 0), s = t.left + (parseInt(o.borderLeftWidth) || 0), a = t.bottom - r - this.text.clientHeight - 2;
                    i(e), "mousedown" == e.type && (this.host.renderer.$isMousePressed = !0, clearTimeout(this.closeTimeout), d.isWin) && l.capture(this.host.container, i, this.onContextMenuClose.bind(this));
                }, C.prototype.destroy = function() {
                    this.text.parentElement && this.text.parentElement.removeChild(this.text);
                }, t.TextInput = C, t.$setUserAgentForTests = function(e, t) {
                    f = e, p = t;
                };
            }), ace.define("ace/mouse/default_handlers", [
                "require",
                "exports",
                "module",
                "ace/lib/useragent"
            ], function(e, t, i) {
                var r = e("../lib/useragent"), e = (n.prototype.onMouseDown = function(e) {
                    var t = e.inSelection(), i = e.getDocumentPosition(), n = (this.mousedownEvent = e, this.editor), o = e.getButton();
                    if (0 !== o) !n.getSelectionRange().isEmpty() && 1 != o || n.selection.moveToPosition(i), 2 == o && (n.textInput.onContextMenu(e.domEvent), r.isMozilla || e.preventDefault());
                    else {
                        if (this.mousedownEvent.time = Date.now(), !t || n.isFocused() || (n.focus(), !this.$focusTimeout) || this.$clickSelection || n.inMultiSelectMode) return this.captureMouse(e), this.startSelect(i, 1 < e.domEvent._clicks), e.preventDefault();
                        this.setState("focusWait"), this.captureMouse(e);
                    }
                }, n.prototype.startSelect = function(e, t) {
                    e = e || this.editor.renderer.screenToTextCoordinates(this.x, this.y);
                    var i = this.editor;
                    this.mousedownEvent && (this.mousedownEvent.getShiftKey() ? i.selection.selectToPosition(e) : t || i.selection.moveToPosition(e), t || this.select(), i.setStyle("ace_selecting"), this.setState("select"));
                }, n.prototype.select = function() {
                    var e, t = this.editor, i = t.renderer.screenToTextCoordinates(this.x, this.y);
                    this.$clickSelection && (e = -1 == (e = this.$clickSelection.comparePoint(i)) ? this.$clickSelection.end : 1 == e ? this.$clickSelection.start : (i = (e = s(this.$clickSelection, i, t.session)).cursor, e.anchor), t.selection.setSelectionAnchor(e.row, e.column)), t.selection.selectToPosition(i), t.renderer.scrollCursorIntoView();
                }, n.prototype.extendSelectionBy = function(e) {
                    var t, i, n, o = this.editor, r = o.renderer.screenToTextCoordinates(this.x, this.y), e = o.selection[e](r.row, r.column);
                    this.$clickSelection && (i = this.$clickSelection.comparePoint(e.start), t = this.$clickSelection.comparePoint(e.end), -1 == i && t <= 0 ? (n = this.$clickSelection.end, e.end.row == r.row && e.end.column == r.column || (r = e.start)) : 1 == t && 0 <= i ? (n = this.$clickSelection.start, e.start.row == r.row && e.start.column == r.column || (r = e.end)) : n = -1 == i && 1 == t ? (r = e.end, e.start) : (r = (i = s(this.$clickSelection, r, o.session)).cursor, i.anchor), o.selection.setSelectionAnchor(n.row, n.column)), o.selection.selectToPosition(r), o.renderer.scrollCursorIntoView();
                }, n.prototype.selectByLinesEnd = function() {
                    this.$clickSelection = null, this.editor.unsetStyle("ace_selecting");
                }, n.prototype.focusWait = function() {
                    n = this.mousedownEvent.x, e = this.mousedownEvent.y, i = this.x, t = this.y;
                    var e, t, i = Math.sqrt(Math.pow(i - n, 2) + Math.pow(t - e, 2)), n = Date.now();
                    (0 < i || n - this.mousedownEvent.time > this.$focusTimeout) && this.startSelect(this.mousedownEvent.getDocumentPosition());
                }, n.prototype.onDoubleClick = function(e) {
                    var e = e.getDocumentPosition(), t = this.editor, i = t.session.getBracketRange(e);
                    i ? (i.isEmpty() && (i.start.column--, i.end.column++), this.setState("select")) : (i = t.selection.getWordRange(e.row, e.column), this.setState("selectByWords")), this.$clickSelection = i, this.select();
                }, n.prototype.onTripleClick = function(e) {
                    var e = e.getDocumentPosition(), t = this.editor, i = (this.setState("selectByLines"), t.getSelectionRange());
                    i.isMultiLine() && i.contains(e.row, e.column) ? (this.$clickSelection = t.selection.getLineRange(i.start.row), this.$clickSelection.end = t.selection.getLineRange(i.end.row).end) : this.$clickSelection = t.selection.getLineRange(e.row), this.select();
                }, n.prototype.onQuadClick = function(e) {
                    var t = this.editor;
                    t.selectAll(), this.$clickSelection = t.getSelectionRange(), this.setState("selectAll");
                }, n.prototype.onMouseWheel = function(e) {
                    var t, i, n, o, r, s, a;
                    if (!e.getAccelKey()) return e.getShiftKey() && e.wheelY && !e.wheelX && (e.wheelX = e.wheelY, e.wheelY = 0), t = this.editor, this.$lastScroll || (this.$lastScroll = {
                        t: 0,
                        vx: 0,
                        vy: 0,
                        allowed: 0
                    }), i = this.$lastScroll, o = (a = (n = e.domEvent.timeStamp) - i.t) ? e.wheelX / a : i.vx, r = a ? e.wheelY / a : i.vy, a < 550 && (o = (o + i.vx) / 2, r = (r + i.vy) / 2), a = !1, 1 <= (s = Math.abs(o / r)) && t.renderer.isScrollableBy(e.wheelX * e.speed, 0) && (a = !0), (a = s <= 1 && t.renderer.isScrollableBy(0, e.wheelY * e.speed) ? !0 : a) ? i.allowed = n : n - i.allowed < 550 && (Math.abs(o) <= 1.5 * Math.abs(i.vx) && Math.abs(r) <= 1.5 * Math.abs(i.vy) ? (a = !0, i.allowed = n) : i.allowed = 0), i.t = n, i.vx = o, i.vy = r, a ? (t.renderer.scrollBy(e.wheelX * e.speed, e.wheelY * e.speed), e.stop()) : void 0;
                }, n);
                function n(t) {
                    t.$clickSelection = null;
                    var e = t.editor;
                    e.setDefaultHandler("mousedown", this.onMouseDown.bind(t)), e.setDefaultHandler("dblclick", this.onDoubleClick.bind(t)), e.setDefaultHandler("tripleclick", this.onTripleClick.bind(t)), e.setDefaultHandler("quadclick", this.onQuadClick.bind(t)), e.setDefaultHandler("mousewheel", this.onMouseWheel.bind(t));
                    [
                        "select",
                        "startSelect",
                        "selectEnd",
                        "selectAllEnd",
                        "selectByWordsEnd",
                        "selectByLinesEnd",
                        "dragWait",
                        "dragWaitEnd",
                        "focusWait"
                    ].forEach(function(e) {
                        t[e] = this[e];
                    }, this), t.selectByLines = this.extendSelectionBy.bind(t, "getLineRange"), t.selectByWords = this.extendSelectionBy.bind(t, "getWordRange");
                }
                function s(e, t, i) {
                    return (e.start.row == e.end.row ? 2 * t.column - e.start.column - e.end.column : e.start.row != e.end.row - 1 || e.start.column || e.end.column ? 2 * t.row - e.start.row - e.end.row : 3 * t.column - 2 * i.getLine(e.start.row).length) < 0 ? {
                        cursor: e.start,
                        anchor: e.end
                    } : {
                        cursor: e.end,
                        anchor: e.start
                    };
                }
                e.prototype.selectEnd = e.prototype.selectByLinesEnd, e.prototype.selectAllEnd = e.prototype.selectByLinesEnd, e.prototype.selectByWordsEnd = e.prototype.selectByLinesEnd, t.DefaultHandlers = e;
            }), ace.define("ace/mouse/mouse_event", [
                "require",
                "exports",
                "module",
                "ace/lib/event",
                "ace/lib/useragent"
            ], function(e, t, i) {
                var n = e("../lib/event"), o = e("../lib/useragent");
                function r(e, t) {
                    this.speed, this.wheelX, this.wheelY, this.domEvent = e, this.editor = t, this.x = this.clientX = e.clientX, this.y = this.clientY = e.clientY, this.$pos = null, this.$inSelection = null, this.propagationStopped = !1, this.defaultPrevented = !1;
                }
                r.prototype.stopPropagation = function() {
                    n.stopPropagation(this.domEvent), this.propagationStopped = !0;
                }, r.prototype.preventDefault = function() {
                    n.preventDefault(this.domEvent), this.defaultPrevented = !0;
                }, r.prototype.stop = function() {
                    this.stopPropagation(), this.preventDefault();
                }, r.prototype.getDocumentPosition = function() {
                    return this.$pos || (this.$pos = this.editor.renderer.screenToTextCoordinates(this.clientX, this.clientY)), this.$pos;
                }, r.prototype.getGutterRow = function() {
                    var e = this.getDocumentPosition().row;
                    return this.editor.session.documentToScreenRow(e, 0) - this.editor.session.documentToScreenRow(this.editor.renderer.$gutterLayer.$lines.get(0).row, 0);
                }, r.prototype.inSelection = function() {
                    var e, t;
                    return null === this.$inSelection && ((e = this.editor.getSelectionRange()).isEmpty() ? this.$inSelection = !1 : (t = this.getDocumentPosition(), this.$inSelection = e.contains(t.row, t.column))), this.$inSelection;
                }, r.prototype.getButton = function() {
                    return n.getButton(this.domEvent);
                }, r.prototype.getShiftKey = function() {
                    return this.domEvent.shiftKey;
                }, r.prototype.getAccelKey = function() {
                    return o.isMac ? this.domEvent.metaKey : this.domEvent.ctrlKey;
                }, t.MouseEvent = r;
            }), ace.define("ace/lib/scroll", [
                "require",
                "exports",
                "module"
            ], function(e, t, i) {
                t.preventParentScroll = function(e) {
                    e.stopPropagation();
                    var t = e.currentTarget;
                    t.scrollHeight > t.clientHeight || e.preventDefault();
                };
            }), ace.define("ace/tooltip", [
                "require",
                "exports",
                "module",
                "ace/lib/dom",
                "ace/lib/event",
                "ace/range",
                "ace/lib/scroll"
            ], function(e, t, i) {
                var n, o = this && this.__extends || (n = function(e, t) {
                    return (n = Object.setPrototypeOf || (({
                        __proto__: []
                    }) instanceof Array ? function(e, t) {
                        e.__proto__ = t;
                    } : function(e, t) {
                        for(var i in t)Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
                    }))(e, t);
                }, function(e, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
                    function i() {
                        this.constructor = e;
                    }
                    n(e, t), e.prototype = null === t ? Object.create(t) : (i.prototype = t.prototype, new i);
                }), u = this && this.__values || function(e) {
                    var t = "function" == typeof Symbol && Symbol.iterator, i = t && e[t], n = 0;
                    if (i) return i.call(e);
                    if (e && "number" == typeof e.length) return {
                        next: function() {
                            return {
                                value: (e = e && n >= e.length ? void 0 : e) && e[n++],
                                done: !e
                            };
                        }
                    };
                    throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
                }, r = e("./lib/dom"), s = (e("./lib/event"), e("./range").Range), a = e("./lib/scroll").preventParentScroll, l = "ace_tooltip", e = (c.prototype.$init = function() {
                    return this.$element = r.createElement("div"), this.$element.className = l, this.$element.style.display = "none", this.$parentNode.appendChild(this.$element), this.$element;
                }, c.prototype.getElement = function() {
                    return this.$element || this.$init();
                }, c.prototype.setText = function(e) {
                    this.getElement().textContent = e;
                }, c.prototype.setHtml = function(e) {
                    this.getElement().innerHTML = e;
                }, c.prototype.setPosition = function(e, t) {
                    this.getElement().style.left = e + "px", this.getElement().style.top = t + "px";
                }, c.prototype.setClassName = function(e) {
                    r.addCssClass(this.getElement(), e);
                }, c.prototype.setTheme = function(e) {
                    this.theme && (this.theme.isDark && r.removeCssClass(this.getElement(), "ace_dark"), this.theme.cssClass) && r.removeCssClass(this.getElement(), this.theme.cssClass), e.isDark && r.addCssClass(this.getElement(), "ace_dark"), e.cssClass && r.addCssClass(this.getElement(), e.cssClass), this.theme = {
                        isDark: e.isDark,
                        cssClass: e.cssClass
                    };
                }, c.prototype.show = function(e, t, i) {
                    null != e && this.setText(e), null != t && null != i && this.setPosition(t, i), this.isOpen || (this.getElement().style.display = "block", this.isOpen = !0);
                }, c.prototype.hide = function(e) {
                    this.isOpen && (this.getElement().style.display = "none", this.getElement().className = l, this.isOpen = !1);
                }, c.prototype.getHeight = function() {
                    return this.getElement().offsetHeight;
                }, c.prototype.getWidth = function() {
                    return this.getElement().offsetWidth;
                }, c.prototype.destroy = function() {
                    this.isOpen = !1, this.$element && this.$element.parentNode && this.$element.parentNode.removeChild(this.$element);
                }, c);
                function c(e) {
                    this.isOpen = !1, this.$element = null, this.$parentNode = e;
                }
                function h() {
                    this.popups = [];
                }
                h.prototype.addPopup = function(e) {
                    this.popups.push(e), this.updatePopups();
                }, h.prototype.removePopup = function(e) {
                    e = this.popups.indexOf(e);
                    -1 !== e && (this.popups.splice(e, 1), this.updatePopups());
                }, h.prototype.updatePopups = function() {
                    this.popups.sort(function(e, t) {
                        return t.priority - e.priority;
                    });
                    var t, e, i, n, o = [];
                    try {
                        for(var r = u(this.popups), s = r.next(); !s.done; s = r.next()){
                            var a = s.value, l = !0;
                            try {
                                i = void 0;
                                for(var c = u(o), h = c.next(); !h.done; h = c.next()){
                                    var d = h.value;
                                    if (this.doPopupsOverlap(d, a)) {
                                        l = !1;
                                        break;
                                    }
                                }
                            } catch (e) {
                                i = {
                                    error: e
                                };
                            } finally{
                                try {
                                    h && !h.done && (n = c.return) && n.call(c);
                                } finally{
                                    if (i) throw i.error;
                                }
                            }
                            l ? o.push(a) : a.hide();
                        }
                    } catch (e) {
                        t = {
                            error: e
                        };
                    } finally{
                        try {
                            s && !s.done && (e = r.return) && e.call(r);
                        } finally{
                            if (t) throw t.error;
                        }
                    }
                }, h.prototype.doPopupsOverlap = function(e, t) {
                    e = e.getElement().getBoundingClientRect(), t = t.getElement().getBoundingClientRect();
                    return e.left < t.right && e.right > t.left && e.top < t.bottom && e.bottom > t.top;
                };
                var d, g = new h, o = (t.popupManager = g, o(p, d = t.Tooltip = e), p.prototype.addToEditor = function(e) {
                    e.on("mousemove", this.onMouseMove), e.on("mousedown", this.hide);
                    e = e.renderer.getMouseEventTarget();
                    e && "function" == typeof e.removeEventListener && e.addEventListener("mouseout", this.onMouseOut, !0);
                }, p.prototype.removeFromEditor = function(e) {
                    e.off("mousemove", this.onMouseMove), e.off("mousedown", this.hide);
                    e = e.renderer.getMouseEventTarget();
                    e && "function" == typeof e.removeEventListener && e.removeEventListener("mouseout", this.onMouseOut, !0), this.timeout && (clearTimeout(this.timeout), this.timeout = null);
                }, p.prototype.onMouseMove = function(e, t) {
                    this.lastEvent = e, this.lastT = Date.now();
                    var i, t = t.$mouseHandler.isMousePressed;
                    this.isOpen && (i = this.lastEvent && this.lastEvent.getDocumentPosition(), this.range && this.range.contains(i.row, i.column) && !t && !this.isOutsideOfText(this.lastEvent) || this.hide()), this.timeout || t || (this.lastEvent = e, this.timeout = setTimeout(this.waitForHover, this.idleTime));
                }, p.prototype.waitForHover = function() {
                    this.timeout && clearTimeout(this.timeout);
                    var e = Date.now() - this.lastT;
                    10 < this.idleTime - e ? this.timeout = setTimeout(this.waitForHover, this.idleTime - e) : (this.timeout = null, this.lastEvent && !this.isOutsideOfText(this.lastEvent) && this.$gatherData(this.lastEvent, this.lastEvent.editor));
                }, p.prototype.isOutsideOfText = function(e) {
                    var t = e.editor, i = e.getDocumentPosition(), n = t.session.getLine(i.row);
                    if (i.column == n.length) {
                        n = t.renderer.pixelToScreenCoordinates(e.clientX, e.clientY), e = t.session.documentToScreenPosition(i.row, i.column);
                        if (e.column != n.column || e.row != n.row) return !0;
                    }
                    return !1;
                }, p.prototype.setDataProvider = function(e) {
                    this.$gatherData = e;
                }, p.prototype.showForRange = function(e, t, i, n) {
                    var o;
                    n && n != this.lastEvent || this.isOpen && document.activeElement == this.getElement() || (n = e.renderer, this.isOpen || (g.addPopup(this), this.$registerCloseEvents(), this.setTheme(n.theme)), this.isOpen = !0, this.range = s.fromPoints(t.start, t.end), o = n.textToScreenCoordinates(t.start.row, t.start.column), n = n.scroller.getBoundingClientRect(), o.pageX < n.left && (o.pageX = n.left), (n = this.getElement()).innerHTML = "", n.appendChild(i), n.style.maxHeight = "", n.style.display = "block", this.$setPosition(e, o, !0, t), r.$fixPositionBug(n));
                }, p.prototype.$setPosition = function(e, t, i, n) {
                    i && this.addMarker(n, e.session);
                    var i = e.renderer, n = this.getElement(), e = n.offsetHeight, o = n.offsetWidth, r = t.pageY, t = t.pageX, s = window.innerHeight - r - i.lineHeight, e = this.$shouldPlaceAbove(e, r, s - 10);
                    n.style.maxHeight = (e ? r : s) - 10 + "px", n.style.top = e ? "" : r + i.lineHeight + "px", n.style.bottom = e ? window.innerHeight - r + "px" : "", n.style.left = Math.min(t, window.innerWidth - o - 10) + "px";
                }, p.prototype.$shouldPlaceAbove = function(e, t, i) {
                    return !(t - e < 0 && t < i);
                }, p.prototype.addMarker = function(e, t) {
                    this.marker && this.$markerSession.removeMarker(this.marker), this.$markerSession = t, this.marker = t && t.addMarker(e, "ace_highlight-marker", "text");
                }, p.prototype.hide = function(e) {
                    e && this.$fromKeyboard && "keydown" == e.type && "Escape" == e.code || !e && document.activeElement == this.getElement() || e && e.target && ("keydown" != e.type || e.ctrlKey || e.metaKey) && this.$element.contains(e.target) || (this.lastEvent = null, this.timeout && clearTimeout(this.timeout), this.timeout = null, this.addMarker(null), this.isOpen && (this.$fromKeyboard = !1, this.$removeCloseEvents(), this.getElement().style.display = "none", this.isOpen = !1, g.removePopup(this)));
                }, p.prototype.$registerCloseEvents = function() {
                    window.addEventListener("keydown", this.hide, !0), window.addEventListener("wheel", this.hide, !0), window.addEventListener("mousedown", this.hide, !0);
                }, p.prototype.$removeCloseEvents = function() {
                    window.removeEventListener("keydown", this.hide, !0), window.removeEventListener("wheel", this.hide, !0), window.removeEventListener("mousedown", this.hide, !0);
                }, p.prototype.onMouseOut = function(e) {
                    this.timeout && (clearTimeout(this.timeout), this.timeout = null), this.lastEvent = null, !this.isOpen || !e.relatedTarget || this.getElement().contains(e.relatedTarget) || e && e.currentTarget.contains(e.relatedTarget) || e.relatedTarget.classList.contains("ace_content") || this.hide();
                }, p);
                function p(e) {
                    void 0 === e && (e = document.body);
                    var e = d.call(this, e) || this, t = (e.timeout = void 0, e.lastT = 0, e.idleTime = 350, e.lastEvent = void 0, e.onMouseOut = e.onMouseOut.bind(e), e.onMouseMove = e.onMouseMove.bind(e), e.waitForHover = e.waitForHover.bind(e), e.hide = e.hide.bind(e), e.getElement());
                    return t.style.whiteSpace = "pre-wrap", t.style.pointerEvents = "auto", t.addEventListener("mouseout", e.onMouseOut), t.tabIndex = -1, t.addEventListener("blur", (function() {
                        t.contains(document.activeElement) || this.hide();
                    }).bind(e)), t.addEventListener("wheel", a), e;
                }
                t.HoverTooltip = o;
            }), ace.define("ace/mouse/default_gutter_handler", [
                "require",
                "exports",
                "module",
                "ace/lib/dom",
                "ace/mouse/mouse_event",
                "ace/tooltip",
                "ace/config",
                "ace/range"
            ], function(e, t, i) {
                var n, o = this && this.__extends || (n = function(e, t) {
                    return (n = Object.setPrototypeOf || (({
                        __proto__: []
                    }) instanceof Array ? function(e, t) {
                        e.__proto__ = t;
                    } : function(e, t) {
                        for(var i in t)Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
                    }))(e, t);
                }, function(e, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
                    function i() {
                        this.constructor = e;
                    }
                    n(e, t), e.prototype = null === t ? Object.create(t) : (i.prototype = t.prototype, new i);
                }), l = this && this.__values || function(e) {
                    var t = "function" == typeof Symbol && Symbol.iterator, i = t && e[t], n = 0;
                    if (i) return i.call(e);
                    if (e && "number" == typeof e.length) return {
                        next: function() {
                            return {
                                value: (e = e && n >= e.length ? void 0 : e) && e[n++],
                                done: !e
                            };
                        }
                    };
                    throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
                }, C = e("../lib/dom"), r = e("./mouse_event").MouseEvent, s = e("../tooltip").HoverTooltip, a = e("../config").nls, y = e("../range").Range;
                t.GutterHandler = function(n) {
                    var o = n.editor, r = o.renderer.$gutterLayer;
                    n.$tooltip = new h(o), n.$tooltip.addToEditor(o), n.$tooltip.setDataProvider(function(e, t) {
                        e = e.getDocumentPosition().row;
                        n.$tooltip.showTooltip(e);
                    }), n.editor.setDefaultHandler("guttermousedown", function(e) {
                        if (o.isFocused() && 0 == e.getButton()) {
                            var t = r.getRegion(e);
                            if ("foldWidgets" != t) {
                                var t = e.getDocumentPosition().row, i = o.session.selection;
                                if (e.getShiftKey()) i.selectTo(t, 0);
                                else {
                                    if (2 == e.domEvent.detail) return o.selectAll(), e.preventDefault();
                                    n.$clickSelection = o.selection.getLineRange(t);
                                }
                                return n.setState("selectByLines"), n.captureMouse(e), e.preventDefault();
                            }
                        }
                    });
                };
                o(v, c = s), v.prototype.onDomMouseMove = function(e) {
                    e = new r(e, this.editor);
                    this.onMouseMove(e, this.editor);
                }, v.prototype.onDomMouseOut = function(e) {
                    e = new r(e, this.editor);
                    this.onMouseOut(e);
                }, v.prototype.addToEditor = function(e) {
                    var t = e.renderer.$gutter;
                    t.addEventListener("mousemove", this.onDomMouseMove), t.addEventListener("mouseout", this.onDomMouseOut), c.prototype.addToEditor.call(this, e);
                }, v.prototype.removeFromEditor = function(e) {
                    var t = e.renderer.$gutter;
                    t.removeEventListener("mousemove", this.onDomMouseMove), t.removeEventListener("mouseout", this.onDomMouseOut), c.prototype.removeFromEditor.call(this, e);
                }, v.prototype.destroy = function() {
                    this.editor && this.removeFromEditor(this.editor), c.prototype.destroy.call(this);
                }, Object.defineProperty(v, "annotationLabels", {
                    get: function() {
                        return {
                            error: {
                                singular: a("gutter-tooltip.aria-label.error.singular", "error"),
                                plural: a("gutter-tooltip.aria-label.error.plural", "errors")
                            },
                            security: {
                                singular: a("gutter-tooltip.aria-label.security.singular", "security finding"),
                                plural: a("gutter-tooltip.aria-label.security.plural", "security findings")
                            },
                            warning: {
                                singular: a("gutter-tooltip.aria-label.warning.singular", "warning"),
                                plural: a("gutter-tooltip.aria-label.warning.plural", "warnings")
                            },
                            info: {
                                singular: a("gutter-tooltip.aria-label.info.singular", "information message"),
                                plural: a("gutter-tooltip.aria-label.info.plural", "information messages")
                            },
                            hint: {
                                singular: a("gutter-tooltip.aria-label.hint.singular", "suggestion"),
                                plural: a("gutter-tooltip.aria-label.hint.plural", "suggestions")
                            }
                        };
                    },
                    enumerable: !1,
                    configurable: !0
                }), v.prototype.showTooltip = function(e) {
                    var t, i = this.editor.renderer.$gutterLayer, n = i.$annotations[e], o = n ? {
                        displayText: Array.from(n.displayText),
                        type: Array.from(n.type)
                    } : {
                        displayText: [],
                        type: []
                    }, r = i.session.getFoldLine(e);
                    if (r && i.$showFoldedAnnotations) {
                        for(var s, a = {
                            error: [],
                            security: [],
                            warning: [],
                            info: [],
                            hint: []
                        }, l = {
                            error: 1,
                            security: 2,
                            warning: 3,
                            info: 4,
                            hint: 5
                        }, c = e + 1; c <= r.end.row; c++)if (i.$annotations[c]) for(var h = 0; h < i.$annotations[c].text.length; h++){
                            var d = i.$annotations[c].type[h];
                            a[d].push(i.$annotations[c].text[h]), (!s || l[d] < l[s]) && (s = d);
                        }
                        [
                            "error",
                            "security",
                            "warning"
                        ].includes(s) && (n = "".concat(v.annotationsToSummaryString(a), " in folded code."), o.displayText.push(n), o.type.push(s + "_fold"));
                    }
                    if (0 === o.displayText.length) return this.hide();
                    for(var u = {
                        error: [],
                        security: [],
                        warning: [],
                        info: [],
                        hint: []
                    }, g = i.$useSvgGutterIcons ? "ace_icon_svg" : "ace_icon", c = 0; c < o.displayText.length; c++){
                        var p = C.createElement("span"), m = C.createElement("span");
                        (t = m.classList).add.apply(t, [
                            "ace_".concat(o.type[c]),
                            g
                        ]), m.setAttribute("aria-label", "".concat(v.annotationLabels[o.type[c].replace("_fold", "")].singular)), m.setAttribute("role", "img"), m.appendChild(C.createTextNode(" ")), p.appendChild(m), p.appendChild(C.createTextNode(o.displayText[c])), p.appendChild(C.createElement("br")), u[o.type[c].replace("_fold", "")].push(p);
                    }
                    var f = C.createElement("span"), n = (u.error.forEach(function(e) {
                        return f.appendChild(e);
                    }), u.security.forEach(function(e) {
                        return f.appendChild(e);
                    }), u.warning.forEach(function(e) {
                        return f.appendChild(e);
                    }), u.info.forEach(function(e) {
                        return f.appendChild(e);
                    }), u.hint.forEach(function(e) {
                        return f.appendChild(e);
                    }), f.setAttribute("aria-live", "polite"), this.$findLinkedAnnotationNode(e)), n = (n && n.setAttribute("aria-describedby", this.id), y.fromPoints({
                        row: e,
                        column: 0
                    }, {
                        row: e,
                        column: 0
                    }));
                    this.showForRange(this.editor, n, f), this.visibleTooltipRow = e, this.editor._signal("showGutterTooltip", this);
                }, v.prototype.$setPosition = function(e, t, i, n) {
                    var o = this.$findCellByRow(n.start.row);
                    if (o) {
                        o = o && o.element, o = o && o.querySelector(".ace_gutter_annotation");
                        if (o) {
                            var o = o.getBoundingClientRect();
                            if (o) return o = {
                                pageX: o.right,
                                pageY: o.top
                            }, c.prototype.$setPosition.call(this, e, o, !1, n);
                        }
                    }
                }, v.prototype.$shouldPlaceAbove = function(e, t, i) {
                    return i < e;
                }, v.prototype.$findLinkedAnnotationNode = function(e) {
                    e = this.$findCellByRow(e);
                    if (e) {
                        e = e.element;
                        if (2 < e.childNodes.length) return e.childNodes[2];
                    }
                }, v.prototype.$findCellByRow = function(t) {
                    return this.editor.renderer.$gutterLayer.$lines.cells.find(function(e) {
                        return e.row === t;
                    });
                }, v.prototype.hide = function(e) {
                    var t;
                    this.isOpen && (this.$element.removeAttribute("aria-live"), null != this.visibleTooltipRow && (t = this.$findLinkedAnnotationNode(this.visibleTooltipRow)) && t.removeAttribute("aria-describedby"), this.visibleTooltipRow = void 0, this.editor._signal("hideGutterTooltip", this), c.prototype.hide.call(this, e));
                }, v.annotationsToSummaryString = function(e) {
                    var t, i, n = [];
                    try {
                        for(var o = l([
                            "error",
                            "security",
                            "warning",
                            "info",
                            "hint"
                        ]), r = o.next(); !r.done; r = o.next()){
                            var s, a = r.value;
                            e[a].length && (s = 1 === e[a].length ? v.annotationLabels[a].singular : v.annotationLabels[a].plural, n.push("".concat(e[a].length, " ").concat(s)));
                        }
                    } catch (e) {
                        t = {
                            error: e
                        };
                    } finally{
                        try {
                            r && !r.done && (i = o.return) && i.call(o);
                        } finally{
                            if (t) throw t.error;
                        }
                    }
                    return n.join(", ");
                }, v.prototype.isOutsideOfText = function(e) {
                    var t = e.editor.renderer.$gutter.getBoundingClientRect();
                    return !(e.clientX >= t.left && e.clientX <= t.right && e.clientY >= t.top && e.clientY <= t.bottom);
                };
                var c, h = v;
                function v(e) {
                    var t = c.call(this, e.container) || this, e = (t.id = "gt" + ++v.$uid, t.editor = e, t.getElement());
                    return e.setAttribute("role", "tooltip"), e.setAttribute("id", t.id), e.style.pointerEvents = "auto", t.idleTime = 50, t.onDomMouseMove = t.onDomMouseMove.bind(t), t.onDomMouseOut = t.onDomMouseOut.bind(t), t.setClassName("ace_gutter-tooltip"), t;
                }
                h.$uid = 0, t.GutterTooltip = h;
            }), ace.define("ace/mouse/dragdrop_handler", [
                "require",
                "exports",
                "module",
                "ace/lib/dom",
                "ace/lib/event",
                "ace/lib/useragent"
            ], function(e, t, i) {
                var w = e("../lib/dom"), x = e("../lib/event"), S = e("../lib/useragent");
                function n(t) {
                    var i, c, h, e, n, d, o, r, u, g, p, m = t.editor, s = w.createElement("div"), a = (s.style.cssText = "top:-100px;position:absolute;z-index:2147483647;opacity:0.5", s.textContent = "\xa0", [
                        "dragWait",
                        "dragWaitEnd",
                        "startDrag",
                        "dragReadyEnd",
                        "onMouseDrag"
                    ].forEach(function(e) {
                        t[e] = this[e];
                    }, this), m.on("mousedown", this.onMouseDown.bind(t)), m.container), l = 0;
                    function f() {
                        var e, t, i, n, o, r, s, a, l = d;
                        d = m.renderer.screenToTextCoordinates(c, h), i = d, t = l, n = Date.now(), e = !t || i.row != t.row, t = !t || i.column != t.column, !g || e || t ? (m.moveCursorToPosition(i), g = n, p = {
                            x: c,
                            y: h
                        }) : 5 < k(p.x, p.y, c, h) ? g = null : 200 <= n - g && (m.renderer.scrollCursorIntoView(), g = null), e = d, t = l, i = Date.now(), n = m.renderer.layerConfig.lineHeight, l = m.renderer.layerConfig.characterWidth, o = m.renderer.scroller.getBoundingClientRect(), o = {
                            x: {
                                left: c - o.left,
                                right: o.right - c
                            },
                            y: {
                                top: h - o.top,
                                bottom: o.bottom - h
                            }
                        }, r = Math.min(o.x.left, o.x.right), s = Math.min(o.y.top, o.y.bottom), a = {
                            row: e.row,
                            column: e.column
                        }, r / l <= 2 && (a.column += o.x.left < o.x.right ? -3 : 2), s / n <= 1 && (a.row += o.y.top < o.y.bottom ? -1 : 1), r = !t || e.row != t.row, e.row != a.row || e.column != a.column && !r ? u ? 200 <= i - u && m.renderer.scrollCursorIntoView(a) : u = i : u = null;
                    }
                    function C() {
                        n = m.selection.toOrientedRange(), i = m.session.addMarker(n, "ace_selection", m.getSelectionStyle()), m.clearSelection(), m.isFocused() && m.renderer.$cursorLayer.setBlinking(!1), clearInterval(e), f(), e = setInterval(f, 20), l = 0, x.addListener(document, "mousemove", I);
                    }
                    function y() {
                        clearInterval(e), m.session.removeMarker(i), i = null, m.selection.fromOrientedRange(n), m.isFocused() && !r && m.$resetCursorStyle(), l = 0, g = u = d = n = null, x.removeListener(document, "mousemove", I);
                    }
                    this.onDragStart = function(e) {
                        var t;
                        if (this.cancelDrag || !a.draggable) return t = this, setTimeout(function() {
                            t.startSelect(), t.captureMouse(e);
                        }, 0), e.preventDefault();
                        n = m.getSelectionRange();
                        var i = e.dataTransfer;
                        i.effectAllowed = m.getReadOnly() ? "copy" : "copyMove", m.container.appendChild(s), i.setDragImage && i.setDragImage(s, 0, 0), setTimeout(function() {
                            m.container.removeChild(s);
                        }), i.clearData(), i.setData("Text", m.session.getTextRange()), r = !0, this.setState("drag");
                    }, this.onDragEnd = function(e) {
                        a.draggable = !1, r = !1, this.setState(null), m.getReadOnly() || (e = e.dataTransfer.dropEffect, o || "move" != e || m.session.remove(m.getSelectionRange()), m.$resetCursorStyle()), this.editor.unsetStyle("ace_dragging"), this.editor.renderer.setCursorStyle("");
                    }, this.onDragEnter = function(e) {
                        if (!m.getReadOnly() && b(e.dataTransfer)) return c = e.clientX, h = e.clientY, i || C(), l++, e.dataTransfer.dropEffect = o = A(e), x.preventDefault(e);
                    }, this.onDragOver = function(e) {
                        if (!m.getReadOnly() && b(e.dataTransfer)) return c = e.clientX, h = e.clientY, i || (C(), l++), null !== v && (v = null), e.dataTransfer.dropEffect = o = A(e), x.preventDefault(e);
                    }, this.onDragLeave = function(e) {
                        if (--l <= 0 && i) return y(), o = null, x.preventDefault(e);
                    }, this.onDrop = function(e) {
                        if (d) {
                            var t = e.dataTransfer;
                            if (r) switch(o){
                                case "move":
                                    n = n.contains(d.row, d.column) ? {
                                        start: d,
                                        end: d
                                    } : m.moveText(n, d);
                                    break;
                                case "copy":
                                    n = m.moveText(n, d, !0);
                            }
                            else {
                                t = t.getData("Text");
                                n = {
                                    start: d,
                                    end: m.session.insert(d, t)
                                }, m.focus(), o = null;
                            }
                            return y(), x.preventDefault(e);
                        }
                    }, x.addListener(a, "dragstart", this.onDragStart.bind(t), m), x.addListener(a, "dragend", this.onDragEnd.bind(t), m), x.addListener(a, "dragenter", this.onDragEnter.bind(t), m), x.addListener(a, "dragover", this.onDragOver.bind(t), m), x.addListener(a, "dragleave", this.onDragLeave.bind(t), m), x.addListener(a, "drop", this.onDrop.bind(t), m);
                    var v = null;
                    function I() {
                        null == v && (v = setTimeout(function() {
                            null != v && i && y();
                        }, 20));
                    }
                    function b(e) {
                        e = e.types;
                        return !e || Array.prototype.some.call(e, function(e) {
                            return "text/plain" == e || "Text" == e;
                        });
                    }
                    function A(e) {
                        var t = [
                            "copy",
                            "copymove",
                            "all",
                            "uninitialized"
                        ], i = S.isMac ? e.altKey : e.ctrlKey, n = "uninitialized";
                        try {
                            n = e.dataTransfer.effectAllowed.toLowerCase();
                        } catch (e) {}
                        var o = "none";
                        return i && 0 <= t.indexOf(n) ? o = "copy" : 0 <= [
                            "move",
                            "copymove",
                            "linkmove",
                            "all",
                            "uninitialized"
                        ].indexOf(n) ? o = "move" : 0 <= t.indexOf(n) && (o = "copy"), o;
                    }
                }
                function k(e, t, i, n) {
                    return Math.sqrt(Math.pow(i - e, 2) + Math.pow(n - t, 2));
                }
                (function() {
                    this.dragWait = function() {
                        Date.now() - this.mousedownEvent.time > this.editor.getDragDelay() && this.startDrag();
                    }, this.dragWaitEnd = function() {
                        this.editor.container.draggable = !1, this.startSelect(this.mousedownEvent.getDocumentPosition()), this.selectEnd();
                    }, this.dragReadyEnd = function(e) {
                        this.editor.$resetCursorStyle(), this.editor.unsetStyle("ace_dragging"), this.editor.renderer.setCursorStyle(""), this.dragWaitEnd();
                    }, this.startDrag = function() {
                        this.cancelDrag = !1;
                        var e = this.editor, t = (e.container.draggable = !0, e.renderer.$cursorLayer.setBlinking(!1), e.setStyle("ace_dragging"), S.isWin ? "default" : "move");
                        e.renderer.setCursorStyle(t), this.setState("dragReady");
                    }, this.onMouseDrag = function(e) {
                        var t = this.editor.container;
                        S.isIE && "dragReady" == this.state && 3 < k(this.mousedownEvent.x, this.mousedownEvent.y, this.x, this.y) && t.dragDrop(), "dragWait" === this.state && 0 < k(this.mousedownEvent.x, this.mousedownEvent.y, this.x, this.y) && (t.draggable = !1, this.startSelect(this.mousedownEvent.getDocumentPosition()));
                    }, this.onMouseDown = function(e) {
                        var t, i, n;
                        this.$dragEnabled && (this.mousedownEvent = e, t = this.editor, i = e.inSelection(), n = e.getButton(), 1 !== (e.domEvent.detail || 1) || 0 !== n || !i || e.editor.inMultiSelectMode && (e.getAccelKey() || e.getShiftKey()) || (this.mousedownEvent.time = Date.now(), "unselectable" in (n = e.domEvent.target || e.domEvent.srcElement) && (n.unselectable = "on"), t.getDragDelay() ? (S.isWebKit && (this.cancelDrag = !0, t.container.draggable = !0), this.setState("dragWait")) : this.startDrag(), this.captureMouse(e, this.onMouseDrag.bind(this)), e.defaultPrevented = !0));
                    };
                }).call(n.prototype), t.DragdropHandler = n;
            }), ace.define("ace/mouse/touch_handler", [
                "require",
                "exports",
                "module",
                "ace/mouse/mouse_event",
                "ace/lib/event",
                "ace/lib/dom"
            ], function(e, t, i) {
                var x = e("./mouse_event").MouseEvent, n = e("../lib/event"), a = e("../lib/dom");
                t.addTouchListeners = function(e, h) {
                    var d, u, g, p, m, t, f, C, s, y = "scroll", v = 0, I = 0, b = 0, A = 0;
                    function o() {
                        function t(e) {
                            var t, i = e.target.getAttribute("action");
                            "more" != i && o ? ("paste" == i ? n.readText().then(function(e) {
                                h.execCommand(i, e);
                            }) : i && ("cut" != i && "copy" != i || (n ? n.writeText(h.getCopyText()) : document.execCommand("copy")), h.execCommand(i)), s.firstChild.style.display = "none", o = !1, "openCommandPalette" != i && h.focus()) : (o = !o, e = h.getCopyText(), t = h.session.getUndoManager().hasUndo(), s.replaceChild(a.buildDom(o ? [
                                "span",
                                !e && r("selectall") && [
                                    "span",
                                    {
                                        class: "ace_mobile-button",
                                        action: "selectall"
                                    },
                                    "Select All"
                                ],
                                e && r("copy") && [
                                    "span",
                                    {
                                        class: "ace_mobile-button",
                                        action: "copy"
                                    },
                                    "Copy"
                                ],
                                e && r("cut") && [
                                    "span",
                                    {
                                        class: "ace_mobile-button",
                                        action: "cut"
                                    },
                                    "Cut"
                                ],
                                n && r("paste") && [
                                    "span",
                                    {
                                        class: "ace_mobile-button",
                                        action: "paste"
                                    },
                                    "Paste"
                                ],
                                t && r("undo") && [
                                    "span",
                                    {
                                        class: "ace_mobile-button",
                                        action: "undo"
                                    },
                                    "Undo"
                                ],
                                r("find") && [
                                    "span",
                                    {
                                        class: "ace_mobile-button",
                                        action: "find"
                                    },
                                    "Find"
                                ],
                                r("openCommandPalette") && [
                                    "span",
                                    {
                                        class: "ace_mobile-button",
                                        action: "openCommandPalette"
                                    },
                                    "Palette"
                                ]
                            ] : [
                                "span"
                            ]), s.firstChild));
                        }
                        var n = window.navigator && window.navigator.clipboard, o = !1, r = function(e) {
                            return h.commands.canExecute(e, h);
                        };
                        s = a.buildDom([
                            "div",
                            {
                                class: "ace_mobile-menu",
                                ontouchstart: function(e) {
                                    y = "menu", e.stopPropagation(), e.preventDefault(), h.textInput.focus();
                                },
                                ontouchend: function(e) {
                                    e.stopPropagation(), e.preventDefault(), t(e);
                                },
                                onclick: t
                            },
                            [
                                "span"
                            ],
                            [
                                "span",
                                {
                                    class: "ace_mobile-button",
                                    action: "more"
                                },
                                "..."
                            ]
                        ], h.container);
                    }
                    function i() {
                        var e, t, i, n;
                        h.getOption("enableMobileMenu") ? (s || o(), e = h.selection.cursor, e = h.renderer.textToScreenCoordinates(e.row, e.column), t = h.renderer.textToScreenCoordinates(0, 0).pageX, i = h.renderer.scrollLeft, n = h.container.getBoundingClientRect(), s.style.top = e.pageY - n.top - 3 + "px", e.pageX - n.left < n.width - 70 ? (s.style.left = "", s.style.right = "10px") : (s.style.right = "", s.style.left = t + i - n.left + "px"), s.style.display = "", s.firstChild.style.display = "none", h.on("input", r)) : s && r();
                    }
                    function r(e) {
                        s && (s.style.display = "none"), h.off("input", r);
                    }
                    function w() {
                        m = null, clearTimeout(m);
                        var e = h.selection.getRange(), t = e.contains(f.row, f.column);
                        !e.isEmpty() && t || (h.selection.moveToPosition(f), h.selection.selectWord()), y = "wait", i();
                    }
                    n.addListener(e, "contextmenu", function(e) {
                        C && h.textInput.getElement().focus();
                    }, h), n.addListener(e, "touchstart", function(e) {
                        var t = e.touches;
                        if (m || 1 < t.length) clearTimeout(m), m = null, g = -1, y = "zoom";
                        else {
                            C = h.$mouseHandler.isMousePressed = !0;
                            var i = h.renderer.layerConfig.lineHeight, n = h.renderer.layerConfig.lineHeight, o = e.timeStamp, r = (p = o, t[0]), s = r.clientX, r = r.clientY, s = (Math.abs(d - s) + Math.abs(u - r) > i && (g = -1), d = e.clientX = s, u = e.clientY = r, b = A = 0, new x(e, h));
                            if (f = s.getDocumentPosition(), o - g < 500 && 1 == t.length && !v) I++, e.preventDefault(), e.button = 0, m = null, clearTimeout(m), h.selection.moveToPosition(f), (r = 2 <= I ? h.selection.getLineRange(f.row) : h.session.getBracketRange(f)) && !r.isEmpty() ? h.selection.setRange(r) : h.selection.selectWord(), y = "wait";
                            else {
                                I = 0;
                                var s = h.selection.cursor, t = h.selection.isEmpty() ? s : h.selection.anchor, r = h.renderer.$cursorLayer.getPixelPosition(s, !0), s = h.renderer.$cursorLayer.getPixelPosition(t, !0), t = h.renderer.scroller.getBoundingClientRect(), a = h.renderer.layerConfig.offset, l = h.renderer.scrollLeft, c = function(e, t) {
                                    return (e /= n) * e + (t = t / i - .75) * t;
                                };
                                if (e.clientX < t.left) return void (y = "zoom");
                                r = c(e.clientX - t.left - r.left + l, e.clientY - t.top - r.top + a), c = c(e.clientX - t.left - s.left + l, e.clientY - t.top - s.top + a);
                                r < 3.5 && c < 3.5 && (y = c < r ? "cursor" : "anchor"), y = c < 3.5 ? "anchor" : r < 3.5 ? "cursor" : "scroll", m = setTimeout(w, 450);
                            }
                            g = o;
                        }
                    }, h), n.addListener(e, "touchend", function(e) {
                        C = h.$mouseHandler.isMousePressed = !1, t && clearInterval(t), "zoom" == y ? (y = "", v = 0) : (m ? (h.selection.moveToPosition(f), v = 0, i) : "scroll" == y ? (v += 60, t = setInterval(function() {
                            v-- <= 0 && (clearInterval(t), t = null), Math.abs(b) < .01 && (b = 0), Math.abs(A) < .01 && (A = 0), v < 20 && (b *= .9), v < 20 && (A *= .9);
                            var e = h.session.getScrollTop();
                            h.renderer.scrollBy(10 * b, 10 * A), e == h.session.getScrollTop() && (v = 0);
                        }, 10), r) : i)(), clearTimeout(m), m = null;
                    }, h), n.addListener(e, "touchmove", function(e) {
                        m && (clearTimeout(m), m = null);
                        var t = e.touches;
                        if (!(1 < t.length || "zoom" == y)) {
                            var t = t[0], i = d - t.clientX, n = u - t.clientY;
                            if ("wait" == y) {
                                if (!(4 < i * i + n * n)) return e.preventDefault();
                                y = "cursor";
                            }
                            d = t.clientX, u = t.clientY, e.clientX = t.clientX, e.clientY = t.clientY;
                            var t = e.timeStamp, o = t - p;
                            p = t, "scroll" == y ? ((t = new x(e, h)).speed = 1, t.wheelX = i, t.wheelY = n, 10 * Math.abs(i) < Math.abs(n) && (i = 0), 10 * Math.abs(n) < Math.abs(i) && (n = 0), 0 != o && (b = i / o, A = n / o), h._emit("mousewheel", t), t.propagationStopped || (b = A = 0)) : (i = new x(e, h).getDocumentPosition(), "cursor" == y ? h.selection.moveCursorToPosition(i) : "anchor" == y && h.selection.setSelectionAnchor(i.row, i.column), h.renderer.scrollCursorIntoView(i), e.preventDefault());
                        }
                    }, h);
                };
            }), ace.define("ace/mouse/mouse_handler", [
                "require",
                "exports",
                "module",
                "ace/lib/event",
                "ace/lib/useragent",
                "ace/mouse/default_handlers",
                "ace/mouse/default_gutter_handler",
                "ace/mouse/mouse_event",
                "ace/mouse/dragdrop_handler",
                "ace/mouse/touch_handler",
                "ace/config"
            ], function(e, t, i) {
                var d = e("../lib/event"), u = e("../lib/useragent"), r = e("./default_handlers").DefaultHandlers, s = e("./default_gutter_handler").GutterHandler, g = e("./mouse_event").MouseEvent, a = e("./dragdrop_handler").DragdropHandler, l = e("./touch_handler").addTouchListeners, e = e("../config"), n = (o.prototype.onMouseEvent = function(e, t) {
                    this.editor.session && this.editor._emit(e, new g(t, this.editor));
                }, o.prototype.onMouseMove = function(e, t) {
                    var i = this.editor._eventRegistry && this.editor._eventRegistry.mousemove;
                    i && i.length && this.editor._emit(e, new g(t, this.editor));
                }, o.prototype.onMouseWheel = function(e, t) {
                    var i = new g(t, this.editor);
                    i.speed = 2 * this.$scrollSpeed, i.wheelX = t.wheelX, i.wheelY = t.wheelY, this.editor._emit(e, i);
                }, o.prototype.setState = function(e) {
                    this.state = e;
                }, o.prototype.captureMouse = function(e, t) {
                    this.x = e.x, this.y = e.y, this.isMousePressed = !0;
                    function i(e) {
                        if (e) {
                            if (u.isWebKit && !e.which && s.releaseMouse) return s.releaseMouse();
                            s.x = e.clientX, s.y = e.clientY, t && t(e), s.mouseEvent = new g(e, s.editor), s.$mouseMoved = !0;
                        }
                    }
                    function n(e) {
                        o.off("beforeEndOperation", h), a = !1, o.session && l(), s[s.state + "End"] && s[s.state + "End"](e), s.state = "", s.isMousePressed = r.$isMousePressed = !1, r.$keepTextAreaAtCursor && r.$moveTextAreaToCursor(), s.$onCaptureMouseMove = s.releaseMouse = null, e && s.onMouseEvent("mouseup", e), o.endOperation();
                    }
                    var o = this.editor, r = this.editor.renderer, s = (r.$isMousePressed = !0, this), a = !0, l = function() {
                        s[s.state] && s[s.state](), s.$mouseMoved = !1;
                    }, c = function() {
                        a && (l(), d.nextFrame(c));
                    };
                    if (u.isOldIE && "dblclick" == e.domEvent.type) return setTimeout(function() {
                        n(e);
                    });
                    var h = function(e) {
                        s.releaseMouse && o.curOp.command.name && o.curOp.selectionChanged && (s[s.state + "End"] && s[s.state + "End"](), s.state = "", s.releaseMouse());
                    };
                    o.on("beforeEndOperation", h), o.startOperation({
                        command: {
                            name: "mouse"
                        }
                    }), s.$onCaptureMouseMove = i, s.releaseMouse = d.capture(this.editor.container, i, n), c();
                }, o.prototype.cancelContextMenu = function() {
                    var t = (function(e) {
                        e && e.domEvent && "contextmenu" != e.domEvent.type || (this.editor.off("nativecontextmenu", t), e && e.domEvent && d.stopEvent(e.domEvent));
                    }).bind(this);
                    setTimeout(t, 10), this.editor.on("nativecontextmenu", t);
                }, o.prototype.destroy = function() {
                    this.releaseMouse && this.releaseMouse(), this.$tooltip && this.$tooltip.destroy();
                }, o);
                function o(n) {
                    this.$dragDelay, this.$dragEnabled, this.$mouseMoved, this.mouseEvent, this.$focusTimeout;
                    function e(e) {
                        document.hasFocus && document.hasFocus() && (n.isFocused() || document.activeElement != (n.textInput && n.textInput.getElement())) || window.focus(), n.focus(), setTimeout(function() {
                            n.isFocused() || n.focus();
                        });
                    }
                    var o = this, t = (this.editor = n, new r(this), new s(this), new a(this), n.renderer.getMouseEventTarget()), i = (d.addListener(t, "click", this.onMouseEvent.bind(this, "click"), n), d.addListener(t, "mousemove", this.onMouseMove.bind(this, "mousemove"), n), d.addMultiMouseDownListener([
                        t,
                        n.renderer.scrollBarV && n.renderer.scrollBarV.inner,
                        n.renderer.scrollBarH && n.renderer.scrollBarH.inner,
                        n.textInput && n.textInput.getElement()
                    ].filter(Boolean), [
                        400,
                        300,
                        250
                    ], this, "onMouseEvent", n), d.addMouseWheelListener(n.container, this.onMouseWheel.bind(this, "mousewheel"), n), l(n.container, n), n.renderer.$gutter);
                    d.addListener(i, "mousedown", this.onMouseEvent.bind(this, "guttermousedown"), n), d.addListener(i, "click", this.onMouseEvent.bind(this, "gutterclick"), n), d.addListener(i, "dblclick", this.onMouseEvent.bind(this, "gutterdblclick"), n), d.addListener(i, "mousemove", this.onMouseEvent.bind(this, "guttermousemove"), n), d.addListener(t, "mousedown", e, n), d.addListener(i, "mousedown", e, n), u.isIE && n.renderer.scrollBarV && (d.addListener(n.renderer.scrollBarV.element, "mousedown", e, n), d.addListener(n.renderer.scrollBarH.element, "mousedown", e, n)), n.on("mousemove", function(e) {
                        var t, i;
                        o.state || o.$dragDelay || !o.$dragEnabled || (e = n.renderer.screenToTextCoordinates(e.x, e.y), t = n.session.selection.getRange(), i = n.renderer, !t.isEmpty() && t.insideStart(e.row, e.column) ? i.setCursorStyle("default") : i.setCursorStyle(""));
                    }, n);
                }
                n.prototype.releaseMouse = null, e.defineOptions(n.prototype, "mouseHandler", {
                    scrollSpeed: {
                        initialValue: 2
                    },
                    dragDelay: {
                        initialValue: u.isMac ? 150 : 0
                    },
                    dragEnabled: {
                        initialValue: !0
                    },
                    focusTimeout: {
                        initialValue: 0
                    }
                }), t.MouseHandler = n;
            }), ace.define("ace/mouse/fold_handler", [
                "require",
                "exports",
                "module",
                "ace/lib/dom"
            ], function(e, t, i) {
                var n = e("../lib/dom");
                t.FoldHandler = function(o) {
                    o.on("click", function(e) {
                        var t = e.getDocumentPosition(), i = o.session, t = i.getFoldAt(t.row, t.column, 1), t = (t && (e.getAccelKey() ? i.removeFold(t) : i.expandFold(t), e.stop()), e.domEvent && e.domEvent.target);
                        t && n.hasCssClass(t, "ace_inline_button") && n.hasCssClass(t, "ace_toggle_wrap") && (i.setOption("wrap", !i.getUseWrapMode()), o.renderer.scrollCursorIntoView());
                    }), o.on("gutterclick", function(e) {
                        var t, i;
                        "foldWidgets" == o.renderer.$gutterLayer.getRegion(e) && (t = e.getDocumentPosition().row, (i = o.session).foldWidgets && i.foldWidgets[t] && o.session.onFoldWidgetClick(t, e), o.isFocused() || o.focus(), e.stop());
                    }), o.on("gutterdblclick", function(e) {
                        var t, i, n;
                        "foldWidgets" == o.renderer.$gutterLayer.getRegion(e) && (n = e.getDocumentPosition().row, (i = (i = (t = o.session).getParentFoldRangeData(n, !0)).range || i.firstRange) && (n = i.start.row, (n = t.getFoldAt(n, t.getLine(n).length, 1)) ? t.removeFold(n) : (t.addFold("...", i), o.renderer.scrollCursorIntoView({
                            row: i.start.row,
                            column: 0
                        }))), e.stop());
                    });
                };
            }), ace.define("ace/keyboard/keybinding", [
                "require",
                "exports",
                "module",
                "ace/lib/keys",
                "ace/lib/event"
            ], function(e, t, i) {
                var o = e("../lib/keys"), l = e("../lib/event");
                function n(e) {
                    this.$editor = e, this.$data = {
                        editor: e
                    }, this.$handlers = [], this.setDefaultHandler(e.commands);
                }
                n.prototype.setDefaultHandler = function(e) {
                    this.removeKeyboardHandler(this.$defaultHandler), this.$defaultHandler = e, this.addKeyboardHandler(e, 0);
                }, n.prototype.setKeyboardHandler = function(e) {
                    var t = this.$handlers;
                    if (t[t.length - 1] != e) {
                        for(; t[t.length - 1] && t[t.length - 1] != this.$defaultHandler;)this.removeKeyboardHandler(t[t.length - 1]);
                        this.addKeyboardHandler(e, 1);
                    }
                }, n.prototype.addKeyboardHandler = function(e, t) {
                    var i;
                    e && ("function" != typeof e || e.handleKeyboard || (e.handleKeyboard = e), -1 != (i = this.$handlers.indexOf(e)) && this.$handlers.splice(i, 1), null == t ? this.$handlers.push(e) : this.$handlers.splice(t, 0, e), -1 == i) && e.attach && e.attach(this.$editor);
                }, n.prototype.removeKeyboardHandler = function(e) {
                    var t = this.$handlers.indexOf(e);
                    return -1 != t && (this.$handlers.splice(t, 1), e.detach && e.detach(this.$editor), !0);
                }, n.prototype.getKeyboardHandler = function() {
                    return this.$handlers[this.$handlers.length - 1];
                }, n.prototype.getStatusText = function() {
                    var t = this.$data, i = t.editor;
                    return this.$handlers.map(function(e) {
                        return e.getStatusText && e.getStatusText(i, t) || "";
                    }).filter(Boolean).join(" ");
                }, n.prototype.$callKeyboardHandlers = function(e, t, i, n) {
                    for(var o, r = !1, s = this.$editor.commands, a = this.$handlers.length; a-- && !((o = this.$handlers[a].handleKeyboard(this.$data, e, t, i, n)) && o.command && ((r = "null" == o.command || s.exec(o.command, this.$editor, o.args, n)) && n && -1 != e && 1 != o.passEvent && 1 != o.command.passEvent && l.stopEvent(n), r)););
                    return r || -1 != e || (o = {
                        command: "insertstring"
                    }, r = s.exec("insertstring", this.$editor, t)), r && this.$editor._signal && this.$editor._signal("keyboardActivity", o), r;
                }, n.prototype.onCommandKey = function(e, t, i) {
                    var n = o.keyCodeToString(i);
                    return this.$callKeyboardHandlers(t, n, i, e);
                }, n.prototype.onTextInput = function(e) {
                    return this.$callKeyboardHandlers(-1, e);
                }, t.KeyBinding = n;
            }), ace.define("ace/lib/bidiutil", [
                "require",
                "exports",
                "module"
            ], function(e, l, t) {
                var p = 0, m = 0, f = !1, C = !1, y = !1, v = [
                    [
                        0,
                        3,
                        0,
                        1,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        3,
                        0,
                        1,
                        2,
                        2,
                        0
                    ],
                    [
                        0,
                        3,
                        0,
                        17,
                        2,
                        0,
                        1
                    ],
                    [
                        0,
                        3,
                        5,
                        5,
                        4,
                        1,
                        0
                    ],
                    [
                        0,
                        3,
                        21,
                        21,
                        4,
                        0,
                        1
                    ],
                    [
                        0,
                        3,
                        5,
                        5,
                        4,
                        2,
                        0
                    ]
                ], I = [
                    [
                        2,
                        0,
                        1,
                        1,
                        0,
                        1,
                        0
                    ],
                    [
                        2,
                        0,
                        1,
                        1,
                        0,
                        2,
                        0
                    ],
                    [
                        2,
                        0,
                        2,
                        1,
                        3,
                        2,
                        0
                    ],
                    [
                        2,
                        0,
                        2,
                        33,
                        3,
                        1,
                        1
                    ]
                ], b = 0, A = 1, w = 2, x = 3, S = 4, k = 5, T = 6, E = 7, R = 8, $ = 9, _ = 10, L = 11, M = 12, N = 13, W = 14, B = 15, D = 16, O = 17, P = 18, n = [
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    T,
                    k,
                    T,
                    R,
                    k,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    k,
                    k,
                    k,
                    T,
                    R,
                    S,
                    S,
                    L,
                    L,
                    L,
                    S,
                    S,
                    S,
                    S,
                    S,
                    _,
                    $,
                    _,
                    $,
                    $,
                    w,
                    w,
                    w,
                    w,
                    w,
                    w,
                    w,
                    w,
                    w,
                    w,
                    $,
                    S,
                    S,
                    S,
                    S,
                    S,
                    S,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    S,
                    S,
                    S,
                    S,
                    S,
                    S,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    S,
                    S,
                    S,
                    S,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    k,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    $,
                    S,
                    L,
                    L,
                    L,
                    L,
                    S,
                    S,
                    S,
                    S,
                    b,
                    S,
                    S,
                    P,
                    S,
                    S,
                    L,
                    L,
                    w,
                    w,
                    S,
                    b,
                    S,
                    S,
                    S,
                    w,
                    b,
                    S,
                    S,
                    S,
                    S,
                    S
                ], o = [
                    R,
                    R,
                    R,
                    R,
                    R,
                    R,
                    R,
                    R,
                    R,
                    R,
                    R,
                    P,
                    P,
                    P,
                    b,
                    A,
                    S,
                    S,
                    S,
                    S,
                    S,
                    S,
                    S,
                    S,
                    S,
                    S,
                    S,
                    S,
                    S,
                    S,
                    S,
                    S,
                    S,
                    S,
                    S,
                    S,
                    S,
                    S,
                    S,
                    S,
                    R,
                    k,
                    N,
                    W,
                    B,
                    D,
                    O,
                    $,
                    L,
                    L,
                    L,
                    L,
                    L,
                    S,
                    S,
                    S,
                    S,
                    S,
                    S,
                    S,
                    S,
                    S,
                    S,
                    S,
                    S,
                    S,
                    S,
                    S,
                    $,
                    S,
                    S,
                    S,
                    S,
                    S,
                    S,
                    S,
                    S,
                    S,
                    S,
                    S,
                    S,
                    S,
                    S,
                    S,
                    S,
                    S,
                    S,
                    S,
                    S,
                    S,
                    S,
                    S,
                    S,
                    S,
                    S,
                    R
                ];
                function c(e, t, i, n) {
                    var o, r, s, a = p ? I : v, l = 0, c = -1, h = null, d = null, u = [];
                    if (!n) for(h = 0, n = []; h < i; h++)n[h] = H(e[h]);
                    for(m = p, y = C = f = !1, d = 0; d < i; d++){
                        if (s = l, u[d] = o = ((e, t, i, n)=>{
                            var o, r, s, a = t[n];
                            switch(a){
                                case b:
                                case A:
                                    f = !1;
                                case S:
                                case x:
                                    return a;
                                case w:
                                    return f ? x : w;
                                case E:
                                    return f = !0, A;
                                case R:
                                    return S;
                                case $:
                                    return n < 1 || n + 1 >= t.length || (o = i[n - 1]) != w && o != x || (l = t[n + 1]) != w && l != x ? S : (l = f ? x : l) == o ? l : S;
                                case _:
                                    return (o = 0 < n ? i[n - 1] : k) == w && n + 1 < t.length && t[n + 1] == w ? w : S;
                                case L:
                                    if (0 < n && i[n - 1] == w) return w;
                                    if (f) return S;
                                    for(s = n + 1, r = t.length; s < r && t[s] == L;)s++;
                                    return s < r && t[s] == w ? w : S;
                                case M:
                                    for(r = t.length, s = n + 1; s < r && t[s] == M;)s++;
                                    if (s < r) {
                                        var l = e[n], l = 1425 <= l && l <= 2303 || 64286 == l;
                                        if (o = t[s], l && (o == A || o == E)) return A;
                                    }
                                    return n < 1 || (o = t[n - 1]) == k ? S : i[n - 1];
                                case k:
                                    return C = (f = !1, true), p;
                                case T:
                                    return y = !0, S;
                                case N:
                                case W:
                                case D:
                                case O:
                                case B:
                                    f = !1;
                                case P:
                                    return S;
                            }
                        })(e, n, u, d), s = 240 & (l = a[s][o]), l &= 15, t[d] = r = a[l][5], 0 < s) {
                            if (16 == s) for(h = c; h < d; h++)t[h] = 1;
                            c = -1;
                        }
                        if (a[l][6]) -1 == c && (c = d);
                        else if (-1 < c) {
                            for(h = c; h < d; h++)t[h] = r;
                            c = -1;
                        }
                        n[d] == k && (t[d] = 0), m |= r;
                    }
                    if (y) {
                        for(h = 0; h < i; h++)if (n[h] == T) {
                            t[h] = p;
                            for(var g = h - 1; 0 <= g && n[g] == R; g--)t[g] = p;
                        }
                    }
                }
                function h(e, t, i) {
                    if (!(m < e)) {
                        if (1 != e || 1 != p || C) for(var n, o, r, s, a = i.length, l = 0; l < a;){
                            if (t[l] >= e) {
                                for(n = l + 1; n < a && t[n] >= e;)n++;
                                for(o = l, r = n - 1; o < r; o++, r--)s = i[o], i[o] = i[r], i[r] = s;
                                l = n;
                            }
                            l++;
                        }
                        else i.reverse();
                    }
                }
                function H(e) {
                    var t = e.charCodeAt(0), i = t >> 8;
                    return 0 == i ? 191 < t ? b : n[t] : 5 == i ? /[\u0591-\u05f4]/.test(e) ? A : b : 6 == i ? /[\u0610-\u061a\u064b-\u065f\u06d6-\u06e4\u06e7-\u06ed]/.test(e) ? M : /[\u0660-\u0669\u066b-\u066c]/.test(e) ? x : 1642 == t ? L : /[\u06f0-\u06f9]/.test(e) ? w : E : 32 == i && t <= 8287 ? o[255 & t] : 254 == i && 65136 <= t ? E : S;
                }
                l.L = b, l.R = A, l.EN = w, l.ON_R = 3, l.AN = 4, l.R_H = 5, l.B = 6, l.RLE = 7, l.DOT = "\xb7", l.doBidiReorder = function(e, t, i) {
                    if (e.length < 2) return {};
                    var n = e.split(""), o = new Array(n.length), r = new Array(n.length), s = [];
                    p = i ? 1 : 0, c(n, s, n.length, t);
                    for(var a = 0; a < o.length; o[a] = a, a++);
                    h(2, s, o), h(1, s, o);
                    for(a = 0; a < o.length - 1; a++)t[a] === x ? s[a] = l.AN : s[a] === A && (t[a] > E && t[a] < N || t[a] === S || t[a] === P) ? s[a] = l.ON_R : 0 < a && "\u0644" === n[a - 1] && /\u0622|\u0623|\u0625|\u0627/.test(n[a]) && (s[a - 1] = s[a] = l.R_H, a++);
                    n[n.length - 1] === l.DOT && (s[n.length - 1] = l.B), "\u202B" === n[0] && (s[0] = l.RLE);
                    for(a = 0; a < o.length; a++)r[a] = s[o[a]];
                    return {
                        logicalFromVisual: o,
                        bidiLevels: r
                    };
                }, l.hasBidiCharacters = function(e, t) {
                    for(var i = !1, n = 0; n < e.length; n++)t[n] = H(e.charAt(n)), i || t[n] != A && t[n] != E && t[n] != x || (i = !0);
                    return i;
                }, l.getVisualFromLogicalIdx = function(e, t) {
                    for(var i = 0; i < t.logicalFromVisual.length; i++)if (t.logicalFromVisual[i] == e) return i;
                    return 0;
                };
            }), ace.define("ace/bidihandler", [
                "require",
                "exports",
                "module",
                "ace/lib/bidiutil",
                "ace/lib/lang"
            ], function(e, t, i) {
                var a = e("./lib/bidiutil"), s = e("./lib/lang"), n = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac\u202B]/;
                function o(e) {
                    this.session = e, this.bidiMap = {}, this.currentRow = null, this.bidiUtil = a, this.charWidths = [], this.EOL = "\xac", this.showInvisibles = !0, this.isRtlDir = !1, this.$isRtl = !1, this.line = "", this.wrapIndent = 0, this.EOF = "\xb6", this.RLE = "\u202B", this.contentWidth = 0, this.fontMetrics = null, this.rtlLineOffset = 0, this.wrapOffset = 0, this.isMoveLeftOperation = !1, this.seenBidi = n.test(e.getValue());
                }
                o.prototype.isBidiRow = function(e, t, i) {
                    return !!this.seenBidi && (e !== this.currentRow && (this.currentRow = e, this.updateRowLine(t, i), this.updateBidiMap()), this.bidiMap.bidiLevels);
                }, o.prototype.onChange = function(e) {
                    this.seenBidi ? this.currentRow = null : "insert" == e.action && n.test(e.lines.join("\n")) && (this.seenBidi = !0, this.currentRow = null);
                }, o.prototype.getDocumentRow = function() {
                    var e = 0, t = this.session.$screenRowCache;
                    return e = t.length && 0 <= (t = this.session.$getRowCacheIndex(t, this.currentRow)) ? this.session.$docRowCache[t] : e;
                }, o.prototype.getSplitIndex = function() {
                    var e = 0, t = this.session.$screenRowCache;
                    if (t.length) for(var i, n = this.session.$getRowCacheIndex(t, this.currentRow); 0 < this.currentRow - e && (i = this.session.$getRowCacheIndex(t, this.currentRow - e - 1)) === n;)n = i, e++;
                    else e = this.currentRow;
                    return e;
                }, o.prototype.updateRowLine = function(e, t) {
                    var i, n = (e = void 0 === e ? this.getDocumentRow() : e) === this.session.getLength() - 1 ? this.EOF : this.EOL, o = (this.wrapIndent = 0, this.line = this.session.getLine(e), this.isRtlDir = this.$isRtl || this.line.charAt(0) === this.RLE, (!this.session.$useWrapMode || (e = this.session.$wrapData[e]) && (0 < (t = void 0 === t ? this.getSplitIndex() : t) && e.length ? (this.wrapIndent = e.indent, this.wrapOffset = this.wrapIndent * this.charWidths[a.L], this.line = t < e.length ? this.line.substring(e[t - 1], e[t]) : this.line.substring(e[e.length - 1])) : this.line = this.line.substring(0, e[t]), t == e.length)) && (this.line += this.showInvisibles ? n : a.DOT), this.session), r = 0;
                    this.line = this.line.replace(/\t|[\u1100-\u2029, \u202F-\uFFE6]/g, function(e, t) {
                        return "\t" === e || o.isFullWidth(e.charCodeAt(0)) ? (i = "\t" === e ? o.getScreenTabSize(t + r) : 2, r += i - 1, s.stringRepeat(a.DOT, i)) : e;
                    }), this.isRtlDir && (this.fontMetrics.$main.textContent = this.line.charAt(this.line.length - 1) == a.DOT ? this.line.substr(0, this.line.length - 1) : this.line, this.rtlLineOffset = this.contentWidth - this.fontMetrics.$main.getBoundingClientRect().width);
                }, o.prototype.updateBidiMap = function() {
                    var e = [];
                    a.hasBidiCharacters(this.line, e) || this.isRtlDir ? this.bidiMap = a.doBidiReorder(this.line, e, this.isRtlDir) : this.bidiMap = {};
                }, o.prototype.markAsDirty = function() {
                    this.currentRow = null;
                }, o.prototype.updateCharacterWidths = function(e) {
                    var t;
                    this.characterWidth !== e.$characterSize.width && (this.fontMetrics = e, t = this.characterWidth = e.$characterSize.width, e = e.$measureCharWidth("\u05D4"), this.charWidths[a.L] = this.charWidths[a.EN] = this.charWidths[a.ON_R] = t, this.charWidths[a.R] = this.charWidths[a.AN] = e, this.charWidths[a.R_H] = .45 * e, this.charWidths[a.B] = this.charWidths[a.RLE] = 0, this.currentRow = null);
                }, o.prototype.setShowInvisibles = function(e) {
                    this.showInvisibles = e, this.currentRow = null;
                }, o.prototype.setEolChar = function(e) {
                    this.EOL = e;
                }, o.prototype.setContentWidth = function(e) {
                    this.contentWidth = e;
                }, o.prototype.isRtlLine = function(e) {
                    return !!this.$isRtl || (null != e ? this.session.getLine(e).charAt(0) == this.RLE : this.isRtlDir);
                }, o.prototype.setRtlDirection = function(e, t) {
                    for(var i = e.getCursorPosition(), n = e.selection.getSelectionAnchor().row; n <= i.row; n++)t || e.session.getLine(n).charAt(0) !== e.session.$bidiHandler.RLE ? t && e.session.getLine(n).charAt(0) !== e.session.$bidiHandler.RLE && e.session.doc.insert({
                        column: 0,
                        row: n
                    }, e.session.$bidiHandler.RLE) : e.session.doc.removeInLine(n, 0, 1);
                }, o.prototype.getPosLeft = function(e) {
                    e -= this.wrapIndent;
                    var t = this.line.charAt(0) === this.RLE ? 1 : 0, i = t < e ? this.session.getOverwrite() ? e : e - 1 : t, n = a.getVisualFromLogicalIdx(i, this.bidiMap), o = this.bidiMap.bidiLevels, r = 0;
                    !this.session.getOverwrite() && e <= t && o[n] % 2 != 0 && n++;
                    for(var s = 0; s < n; s++)r += this.charWidths[o[s]];
                    return !this.session.getOverwrite() && t < e && o[n] % 2 == 0 && (r += this.charWidths[o[n]]), this.wrapIndent && (r += this.isRtlDir ? -1 * this.wrapOffset : this.wrapOffset), this.isRtlDir && (r += this.rtlLineOffset), r;
                }, o.prototype.getSelections = function(e, t) {
                    var i, n = this.bidiMap, o = n.bidiLevels, r = [], s = 0, a = Math.min(e, t) - this.wrapIndent, l = Math.max(e, t) - this.wrapIndent, c = !1, h = !1, d = 0;
                    this.wrapIndent && (s += this.isRtlDir ? -1 * this.wrapOffset : this.wrapOffset);
                    for(var u, g = 0; g < o.length; g++)u = n.logicalFromVisual[g], i = o[g], (c = a <= u && u < l) && !h ? d = s : !c && h && r.push({
                        left: d,
                        width: s - d
                    }), s += this.charWidths[i], h = c;
                    if (c && g === o.length && r.push({
                        left: d,
                        width: s - d
                    }), this.isRtlDir) for(var p = 0; p < r.length; p++)r[p].left += this.rtlLineOffset;
                    return r;
                }, o.prototype.offsetToCol = function(e) {
                    this.isRtlDir && (e -= this.rtlLineOffset);
                    var t = 0, e = Math.max(e, 0), i = 0, n = 0, o = this.bidiMap.bidiLevels, r = this.charWidths[o[n]];
                    for(this.wrapIndent && (e -= this.isRtlDir ? -1 * this.wrapOffset : this.wrapOffset); i + r / 2 < e;){
                        if (i += r, n === o.length - 1) {
                            r = 0;
                            break;
                        }
                        r = this.charWidths[o[++n]];
                    }
                    return 0 === (t = 0 < n && o[n - 1] % 2 != 0 && o[n] % 2 == 0 ? (e < i && n--, this.bidiMap.logicalFromVisual[n]) : 0 < n && o[n - 1] % 2 == 0 && o[n] % 2 != 0 ? 1 + (i < e ? this.bidiMap.logicalFromVisual[n] : this.bidiMap.logicalFromVisual[n - 1]) : this.isRtlDir && n === o.length - 1 && 0 === r && o[n - 1] % 2 == 0 || !this.isRtlDir && 0 === n && o[n] % 2 != 0 ? 1 + this.bidiMap.logicalFromVisual[n] : (0 < n && o[n - 1] % 2 != 0 && 0 !== r && n--, this.bidiMap.logicalFromVisual[n])) && this.isRtlDir && t++, t + this.wrapIndent;
                }, t.BidiHandler = o;
            }), ace.define("ace/selection", [
                "require",
                "exports",
                "module",
                "ace/lib/oop",
                "ace/lib/lang",
                "ace/lib/event_emitter",
                "ace/range"
            ], function(e, t, i) {
                var n = e("./lib/oop"), o = e("./lib/lang"), r = e("./lib/event_emitter").EventEmitter, s = e("./range").Range, e = (a.prototype.isEmpty = function() {
                    return this.$isEmpty || this.anchor.row == this.lead.row && this.anchor.column == this.lead.column;
                }, a.prototype.isMultiLine = function() {
                    return !this.$isEmpty && this.anchor.row != this.cursor.row;
                }, a.prototype.getCursor = function() {
                    return this.lead.getPosition();
                }, a.prototype.setAnchor = function(e, t) {
                    this.$isEmpty = !1, this.anchor.setPosition(e, t);
                }, a.prototype.getAnchor = function() {
                    return this.$isEmpty ? this.getSelectionLead() : this.anchor.getPosition();
                }, a.prototype.getSelectionLead = function() {
                    return this.lead.getPosition();
                }, a.prototype.isBackwards = function() {
                    var e = this.anchor, t = this.lead;
                    return e.row > t.row || e.row == t.row && e.column > t.column;
                }, a.prototype.getRange = function() {
                    var e = this.anchor, t = this.lead;
                    return this.$isEmpty ? s.fromPoints(t, t) : this.isBackwards() ? s.fromPoints(t, e) : s.fromPoints(e, t);
                }, a.prototype.clearSelection = function() {
                    this.$isEmpty || (this.$isEmpty = !0, this._emit("changeSelection"));
                }, a.prototype.selectAll = function() {
                    this.$setSelection(0, 0, Number.MAX_VALUE, Number.MAX_VALUE);
                }, a.prototype.setRange = function(e, t) {
                    var i = t ? e.end : e.start, t = t ? e.start : e.end;
                    this.$setSelection(i.row, i.column, t.row, t.column);
                }, a.prototype.$setSelection = function(e, t, i, n) {
                    var o, r;
                    !this.$silent && (o = this.$isEmpty, r = this.inMultiSelectMode, this.$silent = !0, this.$cursorChanged = this.$anchorChanged = !1, this.anchor.setPosition(e, t), this.cursor.setPosition(i, n), this.$isEmpty = !s.comparePoints(this.anchor, this.cursor), this.$silent = !1, this.$cursorChanged && this._emit("changeCursor"), this.$cursorChanged || this.$anchorChanged || o != this.$isEmpty || r) && this._emit("changeSelection");
                }, a.prototype.$moveSelection = function(e) {
                    var t = this.lead;
                    this.$isEmpty && this.setSelectionAnchor(t.row, t.column), e.call(this);
                }, a.prototype.selectTo = function(e, t) {
                    this.$moveSelection(function() {
                        this.moveCursorTo(e, t);
                    });
                }, a.prototype.selectToPosition = function(e) {
                    this.$moveSelection(function() {
                        this.moveCursorToPosition(e);
                    });
                }, a.prototype.moveTo = function(e, t) {
                    this.clearSelection(), this.moveCursorTo(e, t);
                }, a.prototype.moveToPosition = function(e) {
                    this.clearSelection(), this.moveCursorToPosition(e);
                }, a.prototype.selectUp = function() {
                    this.$moveSelection(this.moveCursorUp);
                }, a.prototype.selectDown = function() {
                    this.$moveSelection(this.moveCursorDown);
                }, a.prototype.selectRight = function() {
                    this.$moveSelection(this.moveCursorRight);
                }, a.prototype.selectLeft = function() {
                    this.$moveSelection(this.moveCursorLeft);
                }, a.prototype.selectLineStart = function() {
                    this.$moveSelection(this.moveCursorLineStart);
                }, a.prototype.selectLineEnd = function() {
                    this.$moveSelection(this.moveCursorLineEnd);
                }, a.prototype.selectFileEnd = function() {
                    this.$moveSelection(this.moveCursorFileEnd);
                }, a.prototype.selectFileStart = function() {
                    this.$moveSelection(this.moveCursorFileStart);
                }, a.prototype.selectWordRight = function() {
                    this.$moveSelection(this.moveCursorWordRight);
                }, a.prototype.selectWordLeft = function() {
                    this.$moveSelection(this.moveCursorWordLeft);
                }, a.prototype.getWordRange = function(e, t) {
                    var i;
                    return void 0 === t && (e = (i = e || this.lead).row, t = i.column), this.session.getWordRange(e, t);
                }, a.prototype.selectWord = function() {
                    this.setSelectionRange(this.getWordRange());
                }, a.prototype.selectAWord = function() {
                    var e = this.getCursor(), e = this.session.getAWordRange(e.row, e.column);
                    this.setSelectionRange(e);
                }, a.prototype.getLineRange = function(e, t) {
                    var e = "number" == typeof e ? e : this.lead.row, i = this.session.getFoldLine(e), i = i ? (e = i.start.row, i.end.row) : e;
                    return !0 === t ? new s(e, 0, i, this.session.getLine(i).length) : new s(e, 0, i + 1, 0);
                }, a.prototype.selectLine = function() {
                    this.setSelectionRange(this.getLineRange());
                }, a.prototype.moveCursorUp = function() {
                    this.moveCursorBy(-1, 0);
                }, a.prototype.moveCursorDown = function() {
                    this.moveCursorBy(1, 0);
                }, a.prototype.wouldMoveIntoSoftTab = function(e, t, i) {
                    var n = e.column, o = e.column + t;
                    return i < 0 && (n = e.column - t, o = e.column), this.session.isTabStop(e) && this.doc.getLine(e.row).slice(n, o).split(" ").length - 1 == t;
                }, a.prototype.moveCursorLeft = function() {
                    var e, t = this.lead.getPosition();
                    (e = this.session.getFoldAt(t.row, t.column, -1)) ? this.moveCursorTo(e.start.row, e.start.column) : 0 === t.column ? 0 < t.row && this.moveCursorTo(t.row - 1, this.doc.getLine(t.row - 1).length) : (e = this.session.getTabSize(), this.wouldMoveIntoSoftTab(t, e, -1) && !this.session.getNavigateWithinSoftTabs() ? this.moveCursorBy(0, -e) : this.moveCursorBy(0, -1));
                }, a.prototype.moveCursorRight = function() {
                    var e, t = this.lead.getPosition();
                    (e = this.session.getFoldAt(t.row, t.column, 1)) ? this.moveCursorTo(e.end.row, e.end.column) : this.lead.column == this.doc.getLine(this.lead.row).length ? this.lead.row < this.doc.getLength() - 1 && this.moveCursorTo(this.lead.row + 1, 0) : (e = this.session.getTabSize(), t = this.lead, this.wouldMoveIntoSoftTab(t, e, 1) && !this.session.getNavigateWithinSoftTabs() ? this.moveCursorBy(0, e) : this.moveCursorBy(0, 1));
                }, a.prototype.moveCursorLineStart = function() {
                    var e = this.lead.row, t = this.lead.column, i = this.session.documentToScreenRow(e, t), i = this.session.screenToDocumentPosition(i, 0), e = this.session.getDisplayLine(e, null, i.row, i.column).match(/^\s*/);
                    e[0].length == t || this.session.$useEmacsStyleLineStart || (i.column += e[0].length), this.moveCursorToPosition(i);
                }, a.prototype.moveCursorLineEnd = function() {
                    var e, t = this.lead, t = this.session.getDocumentLastRowColumnPosition(t.row, t.column);
                    this.lead.column == t.column && (e = this.session.getLine(t.row), t.column == e.length) && 0 < (e = e.search(/\s+$/)) && (t.column = e), this.moveCursorTo(t.row, t.column);
                }, a.prototype.moveCursorFileEnd = function() {
                    var e = this.doc.getLength() - 1, t = this.doc.getLine(e).length;
                    this.moveCursorTo(e, t);
                }, a.prototype.moveCursorFileStart = function() {
                    this.moveCursorTo(0, 0);
                }, a.prototype.moveCursorLongWordRight = function() {
                    var e = this.lead.row, t = this.lead.column, i = this.doc.getLine(e), n = i.substring(t), o = (this.session.nonTokenRe.lastIndex = 0, this.session.tokenRe.lastIndex = 0, this.session.getFoldAt(e, t, 1));
                    o ? this.moveCursorTo(o.end.row, o.end.column) : (this.session.nonTokenRe.exec(n) && (t += this.session.nonTokenRe.lastIndex, this.session.nonTokenRe.lastIndex = 0, n = i.substring(t)), t >= i.length ? (this.moveCursorTo(e, i.length), this.moveCursorRight(), e < this.doc.getLength() - 1 && this.moveCursorWordRight()) : (this.session.tokenRe.exec(n) && (t += this.session.tokenRe.lastIndex, this.session.tokenRe.lastIndex = 0), this.moveCursorTo(e, t)));
                }, a.prototype.moveCursorLongWordLeft = function() {
                    var e, t = this.lead.row, i = this.lead.column;
                    (e = this.session.getFoldAt(t, i, -1)) ? this.moveCursorTo(e.start.row, e.start.column) : (null == (e = this.session.getFoldStringAt(t, i, -1)) && (e = this.doc.getLine(t).substring(0, i)), e = o.stringReverse(e), this.session.nonTokenRe.lastIndex = 0, this.session.tokenRe.lastIndex = 0, this.session.nonTokenRe.exec(e) && (i -= this.session.nonTokenRe.lastIndex, e = e.slice(this.session.nonTokenRe.lastIndex), this.session.nonTokenRe.lastIndex = 0), i <= 0 ? (this.moveCursorTo(t, 0), this.moveCursorLeft(), 0 < t && this.moveCursorWordLeft()) : (this.session.tokenRe.exec(e) && (i -= this.session.tokenRe.lastIndex, this.session.tokenRe.lastIndex = 0), this.moveCursorTo(t, i)));
                }, a.prototype.$shortWordEndIndex = function(e) {
                    var t, i = 0, n = /\s/, o = this.session.tokenRe;
                    if (o.lastIndex = 0, this.session.tokenRe.exec(e)) i = this.session.tokenRe.lastIndex;
                    else {
                        for(; (t = e[i]) && n.test(t);)i++;
                        if (i < 1) {
                            for(o.lastIndex = 0; (t = e[i]) && !o.test(t);)if (o.lastIndex = 0, i++, n.test(t)) {
                                if (2 < i) {
                                    i--;
                                    break;
                                }
                                for(; (t = e[i]) && n.test(t);)i++;
                                if (2 < i) break;
                            }
                        }
                    }
                    return o.lastIndex = 0, i;
                }, a.prototype.moveCursorShortWordRight = function() {
                    var e = this.lead.row, t = this.lead.column, i = this.doc.getLine(e), n = i.substring(t), o = this.session.getFoldAt(e, t, 1);
                    if (o) return this.moveCursorTo(o.end.row, o.end.column);
                    if (t == i.length) {
                        for(var r = this.doc.getLength(); n = this.doc.getLine(++e), e < r && /^\s*$/.test(n););
                        /^\s+/.test(n) || (n = ""), t = 0;
                    }
                    o = this.$shortWordEndIndex(n);
                    this.moveCursorTo(e, t + o);
                }, a.prototype.moveCursorShortWordLeft = function() {
                    var e = this.lead.row, t = this.lead.column;
                    if (n = this.session.getFoldAt(e, t, -1)) return this.moveCursorTo(n.start.row, n.start.column);
                    var i = this.session.getLine(e).substring(0, t);
                    if (0 === t) {
                        for(; i = this.doc.getLine(--e), 0 < e && /^\s*$/.test(i););
                        t = i.length, /\s+$/.test(i) || (i = "");
                    }
                    var n = o.stringReverse(i), n = this.$shortWordEndIndex(n);
                    return this.moveCursorTo(e, t - n);
                }, a.prototype.moveCursorWordRight = function() {
                    this.session.$selectLongWords ? this.moveCursorLongWordRight() : this.moveCursorShortWordRight();
                }, a.prototype.moveCursorWordLeft = function() {
                    this.session.$selectLongWords ? this.moveCursorLongWordLeft() : this.moveCursorShortWordLeft();
                }, a.prototype.moveCursorBy = function(e, t) {
                    var i, n = this.session.documentToScreenPosition(this.lead.row, this.lead.column), o = (0 === t && (0 !== e && (this.session.$bidiHandler.isBidiRow(n.row, this.lead.row) ? (i = this.session.$bidiHandler.getPosLeft(n.column), n.column = Math.round(i / this.session.$bidiHandler.charWidths[0])) : i = n.column * this.session.$bidiHandler.charWidths[0]), this.$desiredColumn ? n.column = this.$desiredColumn : this.$desiredColumn = n.column), 0 != e && this.session.lineWidgets && this.session.lineWidgets[this.lead.row] && (o = this.session.lineWidgets[this.lead.row], e < 0 ? e -= o.rowsAbove || 0 : 0 < e && (e += o.rowCount - (o.rowsAbove || 0))), this.session.screenToDocumentPosition(n.row + e, n.column, i));
                    0 !== e && 0 === t && o.row === this.lead.row && (o.column, this.lead.column), this.moveCursorTo(o.row, o.column + t, 0 === t);
                }, a.prototype.moveCursorToPosition = function(e) {
                    this.moveCursorTo(e.row, e.column);
                }, a.prototype.moveCursorTo = function(e, t, i) {
                    var n = this.session.getFoldAt(e, t, 1), n = (n && (e = n.start.row, t = n.start.column), this.$keepDesiredColumnOnChange = !0, this.session.getLine(e));
                    /[\uDC00-\uDFFF]/.test(n.charAt(t)) && n.charAt(t - 1) && (this.lead.row == e && this.lead.column == t + 1 ? t -= 1 : t += 1), this.lead.setPosition(e, t), this.$keepDesiredColumnOnChange = !1, i || (this.$desiredColumn = null);
                }, a.prototype.moveCursorToScreen = function(e, t, i) {
                    e = this.session.screenToDocumentPosition(e, t);
                    this.moveCursorTo(e.row, e.column, i);
                }, a.prototype.detach = function() {
                    this.lead.detach(), this.anchor.detach();
                }, a.prototype.fromOrientedRange = function(e) {
                    this.setSelectionRange(e, e.cursor == e.start), this.$desiredColumn = e.desiredColumn || this.$desiredColumn;
                }, a.prototype.toOrientedRange = function(e) {
                    var t = this.getRange();
                    return e ? (e.start.column = t.start.column, e.start.row = t.start.row, e.end.column = t.end.column, e.end.row = t.end.row) : e = t, e.cursor = this.isBackwards() ? e.start : e.end, e.desiredColumn = this.$desiredColumn, e;
                }, a.prototype.getRangeOfMovements = function(e) {
                    var t = this.getCursor();
                    try {
                        e(this);
                        var i = this.getCursor();
                        return s.fromPoints(t, i);
                    } catch (e) {
                        return s.fromPoints(t, t);
                    } finally{
                        this.moveCursorToPosition(t);
                    }
                }, a.prototype.toJSON = function() {
                    var e;
                    return this.rangeCount ? e = this.ranges.map(function(e) {
                        var t = e.clone();
                        return t.isBackwards = e.cursor == e.start, t;
                    }) : (e = this.getRange()).isBackwards = this.isBackwards(), e;
                }, a.prototype.fromJSON = function(e) {
                    if (null == e.start) {
                        if (this.rangeList && 1 < e.length) {
                            this.toSingleRange(e[0]);
                            for(var t = e.length; t--;){
                                var i = s.fromPoints(e[t].start, e[t].end);
                                e[t].isBackwards && (i.cursor = i.start), this.addRange(i, !0);
                            }
                            return;
                        }
                        e = e[0];
                    }
                    this.rangeList && this.toSingleRange(e), this.setSelectionRange(e, e.isBackwards);
                }, a.prototype.isEqual = function(e) {
                    if ((e.length || this.rangeCount) && e.length != this.rangeCount) return !1;
                    if (!e.length || !this.ranges) return this.getRange().isEqual(e);
                    for(var t = this.ranges.length; t--;)if (!this.ranges[t].isEqual(e[t])) return !1;
                    return !0;
                }, a);
                function a(e) {
                    this.session = e, this.doc = e.getDocument(), this.clearSelection(), this.cursor = this.lead = this.doc.createAnchor(0, 0), this.anchor = this.doc.createAnchor(0, 0), this.$silent = !1;
                    var t = this;
                    this.cursor.on("change", function(e) {
                        t.$cursorChanged = !0, t.$silent || t._emit("changeCursor"), t.$isEmpty || t.$silent || t._emit("changeSelection"), t.$keepDesiredColumnOnChange || e.old.column == e.value.column || (t.$desiredColumn = null);
                    }), this.anchor.on("change", function() {
                        t.$anchorChanged = !0, t.$isEmpty || t.$silent || t._emit("changeSelection");
                    });
                }
                e.prototype.setSelectionAnchor = e.prototype.setAnchor, e.prototype.getSelectionAnchor = e.prototype.getAnchor, e.prototype.setSelectionRange = e.prototype.setRange, n.implement(e.prototype, r), t.Selection = e;
            }), ace.define("ace/tokenizer", [
                "require",
                "exports",
                "module",
                "ace/lib/report_error"
            ], function(e, t, i) {
                var e = e("./lib/report_error").reportError, y = 2e3, n = (o.prototype.$setMaxTokenCount = function(e) {
                    y = 0 | e;
                }, o.prototype.$applyToken = function(e) {
                    var t = this.splitRegex.exec(e).slice(1), i = this.token.apply(this, t);
                    if ("string" == typeof i) return [
                        {
                            type: i,
                            value: e
                        }
                    ];
                    for(var n = [], o = 0, r = i.length; o < r; o++)t[o] && (n[n.length] = {
                        type: i[o],
                        value: t[o]
                    });
                    return n;
                }, o.prototype.$arrayTokens = function(e) {
                    if (!e) return [];
                    var t = this.splitRegex.exec(e);
                    if (!t) return "text";
                    for(var i = [], n = this.tokenArray, o = 0, r = n.length; o < r; o++)t[o + 1] && (i[i.length] = {
                        type: n[o],
                        value: t[o + 1]
                    });
                    return i;
                }, o.prototype.removeCapturingGroups = function(e) {
                    return e.replace(/\\.|\[(?:\\.|[^\\\]])*|\(\?[:=!<]|(\()/g, function(e, t) {
                        return t ? "(?:" : e;
                    });
                }, o.prototype.createSplitterRegexp = function(e, t) {
                    var s, a, l;
                    return "$" != (e = "^" != (e = -1 != e.indexOf("(?=") && (s = 0, a = !1, l = {}, e.replace(/(\\.)|(\((?:\?[=!])?)|(\))|([\[\]])/g, function(e, t, i, n, o, r) {
                        return a ? a = "]" != o : o ? a = !0 : n ? (s == l.stack && (l.end = r + 1, l.stack = -1), s--) : i && (s++, 1 != i.length) && (l.stack = s, l.start = r), e;
                    }), null != l.end) && /^\)*$/.test(e.substr(l.end)) ? e.substring(0, l.start) + e.substr(l.end) : e).charAt(0) ? "^" + e : e).charAt(e.length - 1) && (e += "$"), new RegExp(e, (t || "").replace("g", ""));
                }, o.prototype.getLineTokens = function(e, t) {
                    t && "string" != typeof t ? "#tmp" === (t = (i = t.slice(0))[0]) && (i.shift(), t = i.shift()) : i = [];
                    for(var i, n, o = t || "start", r = (r = this.states[o]) || this.states[o = "start"], s = this.matchMappings[o], a = this.regExps[o], l = [], c = a.lastIndex = 0, h = 0, d = {
                        type: null,
                        value: ""
                    }; n = a.exec(e);){
                        var u, g = s.defaultToken, p = null, m = n[0], f = a.lastIndex;
                        f - m.length > c && (u = e.substring(c, f - m.length), d.type == g ? d.value += u : (d.type && l.push(d), d = {
                            type: g,
                            value: u
                        }));
                        for(var C = 0; C < n.length - 2; C++)if (void 0 !== n[C + 1]) {
                            g = (p = r[s[C]]).onMatch ? p.onMatch(m, o, i, e) : p.token, p.next && (o = "string" == typeof p.next ? p.next : p.next(o, i), (r = this.states[o]) || (this.reportError("state doesn't exist", o), r = this.states[o = "start"]), s = this.matchMappings[o], (a = this.regExps[o]).lastIndex = c = f), p.consumeLineEnd && (c = f);
                            break;
                        }
                        if (m) {
                            if ("string" == typeof g) p && !1 === p.merge || d.type !== g ? (d.type && l.push(d), d = {
                                type: g,
                                value: m
                            }) : d.value += m;
                            else if (g) {
                                d.type && l.push(d);
                                for(d = {
                                    type: null,
                                    value: ""
                                }, C = 0; C < g.length; C++)l.push(g[C]);
                            }
                        }
                        if (c == e.length) break;
                        if (c = f, h++ > y) {
                            for(h > 2 * e.length && this.reportError("infinite loop with in ace tokenizer", {
                                startState: t,
                                line: e
                            }); c < e.length;)d.type && l.push(d), d = {
                                value: e.substring(c, c += 500),
                                type: "overflow"
                            };
                            o = "start", i = [];
                            break;
                        }
                    }
                    return d.type && l.push(d), 1 < i.length && i[0] !== o && i.unshift("#tmp", o), {
                        tokens: l,
                        state: i.length ? i : o
                    };
                }, o);
                function o(e) {
                    for(var t in this.splitRegex, this.states = e, this.regExps = {}, this.matchMappings = {}, this.states){
                        for(var i = this.states[t], n = [], o = 0, r = this.matchMappings[t] = {
                            defaultToken: "text"
                        }, s = "g", a = [], l = 0; l < i.length; l++){
                            var c, h, d = i[l];
                            d.defaultToken && (r.defaultToken = d.defaultToken), d.caseInsensitive && -1 === s.indexOf("i") && (s += "i"), d.unicode && -1 === s.indexOf("u") && (s += "u"), null == d.regex || (d.regex instanceof RegExp && (d.regex = d.regex.toString().slice(1, -1)), c = d.regex, h = new RegExp("(?:(" + c + ")|(.))").exec("a").length - 2, Array.isArray(d.token) ? 1 == d.token.length || 1 == h ? d.token = d.token[0] : h - 1 != d.token.length ? (this.reportError("number of classes and regexp groups doesn't match", {
                                rule: d,
                                groupCount: h - 1
                            }), d.token = d.token[0]) : (d.tokenArray = d.token, d.token = null, d.onMatch = this.$arrayTokens) : "function" != typeof d.token || d.onMatch || (d.onMatch = 1 < h ? this.$applyToken : d.token), 1 < h && (c = /\\\d/.test(d.regex) ? d.regex.replace(/\\([0-9]+)/g, function(e, t) {
                                return "\\" + (parseInt(t, 10) + o + 1);
                            }) : (h = 1, this.removeCapturingGroups(d.regex)), d.splitRegex || "string" == typeof d.token || a.push(d)), r[o] = l, o += h, n.push(c), d.onMatch) || (d.onMatch = null);
                        }
                        n.length || (r[0] = 0, n.push("$")), a.forEach(function(e) {
                            e.splitRegex = this.createSplitterRegexp(e.regex, s);
                        }, this), this.regExps[t] = new RegExp("(" + n.join(")|(") + ")|($)", s);
                    }
                }
                n.prototype.reportError = e, t.Tokenizer = n;
            }), ace.define("ace/mode/text_highlight_rules", [
                "require",
                "exports",
                "module",
                "ace/lib/deep_copy"
            ], function(e, t, i) {
                var l = e("../lib/deep_copy").deepCopy, e = function() {
                    this.$rules = {
                        start: [
                            {
                                token: "empty_line",
                                regex: "^$"
                            },
                            {
                                defaultToken: "text"
                            }
                        ]
                    };
                };
                (function() {
                    this.addRules = function(e, t) {
                        if (t) for(var i in e){
                            for(var n = e[i], o = 0; o < n.length; o++){
                                var r = n[o];
                                (r.next || r.onMatch) && ("string" == typeof r.next && 0 !== r.next.indexOf(t) && (r.next = t + r.next), r.nextState) && 0 !== r.nextState.indexOf(t) && (r.nextState = t + r.nextState);
                            }
                            this.$rules[t + i] = n;
                        }
                        else for(var i in e)this.$rules[i] = e[i];
                    }, this.getRules = function() {
                        return this.$rules;
                    }, this.embedRules = function(e, t, i, n, o) {
                        e = "function" == typeof e ? (new e).getRules() : e;
                        if (n) for(var r = 0; r < n.length; r++)n[r] = t + n[r];
                        else for(var s in n = [], e)n.push(t + s);
                        if (this.addRules(e, t), i) for(var a = Array.prototype[o ? "push" : "unshift"], r = 0; r < n.length; r++)a.apply(this.$rules[n[r]], l(i));
                        this.$embeds || (this.$embeds = []), this.$embeds.push(t);
                    }, this.getEmbeds = function() {
                        return this.$embeds;
                    };
                    function d(e, t) {
                        return "start" == e && !t.length || t.unshift(this.nextState, e), this.nextState;
                    }
                    function u(e, t) {
                        return t.shift(), t.shift() || "start";
                    }
                    this.normalizeRules = function() {
                        var c = 0, h = this.$rules;
                        Object.keys(h).forEach(function e(t) {
                            var i = h[t];
                            i.processed = !0;
                            for(var n = 0; n < i.length; n++){
                                var o = i[n], r = null, s = (Array.isArray(o) && (r = o, o = {}), !o.regex && o.start && (o.regex = o.start, o.next || (o.next = []), o.next.push({
                                    defaultToken: o.token
                                }, {
                                    token: o.token + ".end",
                                    regex: o.end || o.start,
                                    next: "pop"
                                }), o.token = o.token + ".start", o.push = !0), o.next || o.push);
                                if (s && Array.isArray(s) ? ((l = o.stateName) || ("string" != typeof (l = o.token) && (l = l[0] || ""), h[l] && (l += c++)), h[l] = s, e(o.next = l)) : "pop" == s && (o.next = u), o.push && (o.nextState = o.next || o.push, o.next = d, delete o.push), o.rules) for(var a in o.rules)h[a] ? h[a].push && h[a].push.apply(h[a], o.rules[a]) : h[a] = o.rules[a];
                                var l = "string" == typeof o ? o : o.include;
                                l && ("$self" === l && (l = "start"), r = Array.isArray(l) ? l.map(function(e) {
                                    return h[e];
                                }) : h[l]), r && (s = [
                                    n,
                                    1
                                ].concat(r), o.noEscape && (s = s.filter(function(e) {
                                    return !e.next;
                                })), i.splice.apply(i, s), n--), o.keywordMap && (o.token = this.createKeywordMapper(o.keywordMap, o.defaultToken || "text", o.caseInsensitive), delete o.defaultToken);
                            }
                        }, this);
                    }, this.createKeywordMapper = function(o, t, r, s) {
                        var a = Object.create(null);
                        return this.$keywordList = [], Object.keys(o).forEach(function(e) {
                            for(var t = o[e].split(s || "|"), i = t.length; i--;){
                                var n = t[i];
                                this.$keywordList.push(n), r && (n = n.toLowerCase()), a[n] = e;
                            }
                        }, this), o = null, r ? function(e) {
                            return a[e.toLowerCase()] || t;
                        } : function(e) {
                            return a[e] || t;
                        };
                    }, this.getKeywords = function() {
                        return this.$keywords;
                    };
                }).call(e.prototype), t.TextHighlightRules = e;
            }), ace.define("ace/mode/behaviour", [
                "require",
                "exports",
                "module"
            ], function(e, t, i) {
                var n = function() {
                    this.$behaviours = {};
                };
                (function() {
                    this.add = function(e, t, i) {
                        switch(void 0){
                            case this.$behaviours:
                                this.$behaviours = {};
                            case this.$behaviours[e]:
                                this.$behaviours[e] = {};
                        }
                        this.$behaviours[e][t] = i;
                    }, this.addBehaviours = function(e) {
                        for(var t in e)for(var i in e[t])this.add(t, i, e[t][i]);
                    }, this.remove = function(e) {
                        this.$behaviours && this.$behaviours[e] && delete this.$behaviours[e];
                    }, this.inherit = function(e, t) {
                        e = ("function" == typeof e ? new e : e).getBehaviours(t), this.addBehaviours(e);
                    }, this.getBehaviours = function(e) {
                        if (e) {
                            for(var t = {}, i = 0; i < e.length; i++)this.$behaviours[e[i]] && (t[e[i]] = this.$behaviours[e[i]]);
                            return t;
                        }
                        return this.$behaviours;
                    };
                }).call(n.prototype), t.Behaviour = n;
            }), ace.define("ace/token_iterator", [
                "require",
                "exports",
                "module",
                "ace/range"
            ], function(e, t, i) {
                var n = e("./range").Range;
                function o(e, t, i) {
                    this.$session = e, this.$row = t, this.$rowTokens = e.getTokens(t);
                    e = e.getTokenAt(t, i);
                    this.$tokenIndex = e ? e.index : -1;
                }
                o.prototype.stepBackward = function() {
                    for(--this.$tokenIndex; this.$tokenIndex < 0;){
                        if (--this.$row, this.$row < 0) return this.$row = 0, null;
                        this.$rowTokens = this.$session.getTokens(this.$row), this.$tokenIndex = this.$rowTokens.length - 1;
                    }
                    return this.$rowTokens[this.$tokenIndex];
                }, o.prototype.stepForward = function() {
                    var e;
                    for(this.$tokenIndex += 1; this.$tokenIndex >= this.$rowTokens.length;){
                        if (this.$row += 1, e = e || this.$session.getLength(), this.$row >= e) return this.$row = e - 1, null;
                        this.$rowTokens = this.$session.getTokens(this.$row), this.$tokenIndex = 0;
                    }
                    return this.$rowTokens[this.$tokenIndex];
                }, o.prototype.getCurrentToken = function() {
                    return this.$rowTokens[this.$tokenIndex];
                }, o.prototype.getCurrentTokenRow = function() {
                    return this.$row;
                }, o.prototype.getCurrentTokenColumn = function() {
                    var e = this.$rowTokens, t = this.$tokenIndex, i = e[t].start;
                    if (void 0 === i) for(i = 0; 0 < t;)i += e[--t].value.length;
                    return i;
                }, o.prototype.getCurrentTokenPosition = function() {
                    return {
                        row: this.$row,
                        column: this.getCurrentTokenColumn()
                    };
                }, o.prototype.getCurrentTokenRange = function() {
                    var e = this.$rowTokens[this.$tokenIndex], t = this.getCurrentTokenColumn();
                    return new n(this.$row, t, this.$row, t + e.value.length);
                }, t.TokenIterator = o;
            }), ace.define("ace/mode/behaviour/cstyle", [
                "require",
                "exports",
                "module",
                "ace/lib/oop",
                "ace/mode/behaviour",
                "ace/token_iterator",
                "ace/lib/lang"
            ], function(e, t, i) {
                function g(e) {
                    var t = -1;
                    if ((l = e.multiSelect && (t = e.selection.index, l.rangeCount != e.multiSelect.rangeCount) ? {
                        rangeCount: e.multiSelect.rangeCount
                    } : l)[t]) return m = l[t];
                    m = l[t] = {
                        autoInsertedBrackets: 0,
                        autoInsertedRow: -1,
                        autoInsertedLineEnd: "",
                        maybeInsertedBrackets: 0,
                        maybeInsertedRow: -1,
                        maybeInsertedLineStart: "",
                        maybeInsertedLineEnd: ""
                    };
                }
                function p(e, t, i, n) {
                    var o = e.end.row - e.start.row;
                    return {
                        text: i + t + n,
                        selection: [
                            0,
                            e.start.column + 1,
                            o,
                            e.end.column + (o ? 0 : 1)
                        ]
                    };
                }
                var m, n = e("../../lib/oop"), o = e("../behaviour").Behaviour, r = e("../../token_iterator").TokenIterator, f = e("../../lib/lang"), s = [
                    "text",
                    "paren.rparen",
                    "rparen",
                    "paren",
                    "punctuation.operator"
                ], a = [
                    "text",
                    "paren.rparen",
                    "rparen",
                    "paren",
                    "punctuation.operator",
                    "comment"
                ], l = {}, C = {
                    '"': '"',
                    "'": "'"
                }, y = function(u) {
                    u = u || {}, this.add("braces", "insertion", function(e, t, i, n, o) {
                        var r = i.getCursorPosition(), s = n.doc.getLine(r.row);
                        if ("{" == o) {
                            g(i);
                            var a = i.getSelectionRange(), l = n.doc.getTextRange(a), c = n.getTokenAt(r.row, r.column);
                            if ("" !== l && "{" !== l && i.getWrapBehavioursEnabled()) return p(a, l, "{", "}");
                            if (c && /(?:string)\.quasi|\.xml/.test(c.type)) {
                                if (!([
                                    /tag\-(?:open|name)/,
                                    /attribute\-name/
                                ].some(function(e) {
                                    return e.test(c.type);
                                }) || /(string)\.quasi/.test(c.type) && "$" !== c.value[r.column - c.start - 1])) return y.recordAutoInsert(i, n, "}"), {
                                    text: "{}",
                                    selection: [
                                        1,
                                        1
                                    ]
                                };
                            } else if (y.isSaneInsertion(i, n)) return /[\]\}\)]/.test(s[r.column]) || i.inMultiSelectMode || u.braces ? (y.recordAutoInsert(i, n, "}"), {
                                text: "{}",
                                selection: [
                                    1,
                                    1
                                ]
                            }) : (y.recordMaybeInsert(i, n, "{"), {
                                text: "{",
                                selection: [
                                    1,
                                    1
                                ]
                            });
                        } else if ("}" == o) {
                            g(i);
                            var h = s.substring(r.column, r.column + 1);
                            if ("}" == h) {
                                if (null !== n.$findOpeningBracket("}", {
                                    column: r.column + 1,
                                    row: r.row
                                }) && y.isAutoInsertedClosing(r, s, o)) return y.popAutoInsertedClosing(), {
                                    text: "",
                                    selection: [
                                        1,
                                        1
                                    ]
                                };
                            }
                        } else {
                            if ("\n" == o || "\r\n" == o) {
                                g(i);
                                a = "";
                                if (y.isMaybeInsertedClosing(r, s) && (a = f.stringRepeat("}", m.maybeInsertedBrackets), y.clearMaybeInsertedClosing()), "}" === (h = s.substring(r.column, r.column + 1))) {
                                    l = n.findMatchingBracket({
                                        row: r.row,
                                        column: r.column + 1
                                    }, "}");
                                    if (!l) return null;
                                    var d = this.$getIndent(n.getLine(l.row));
                                } else {
                                    if (!a) return void y.clearMaybeInsertedClosing();
                                    d = this.$getIndent(s);
                                }
                                o = d + n.getTabString();
                                return {
                                    text: "\n" + o + "\n" + d + a,
                                    selection: [
                                        1,
                                        o.length,
                                        1,
                                        o.length
                                    ]
                                };
                            }
                            y.clearMaybeInsertedClosing();
                        }
                    }), this.add("braces", "deletion", function(e, t, i, n, o) {
                        var r = n.doc.getTextRange(o);
                        if (!o.isMultiLine() && "{" == r) {
                            if (g(i), "}" == n.doc.getLine(o.start.row).substring(o.end.column, o.end.column + 1)) return o.end.column++, o;
                            m.maybeInsertedBrackets--;
                        }
                    }), this.add("parens", "insertion", function(e, t, i, n, o) {
                        if ("(" == o) return g(i), r = i.getSelectionRange(), "" !== (s = n.doc.getTextRange(r)) && i.getWrapBehavioursEnabled() ? p(r, s, "(", ")") : y.isSaneInsertion(i, n) ? (y.recordAutoInsert(i, n, ")"), {
                            text: "()",
                            selection: [
                                1,
                                1
                            ]
                        }) : void 0;
                        if (")" == o) {
                            g(i);
                            var r = i.getCursorPosition(), s = n.doc.getLine(r.row), i = s.substring(r.column, r.column + 1);
                            if (")" == i) {
                                if (null !== n.$findOpeningBracket(")", {
                                    column: r.column + 1,
                                    row: r.row
                                }) && y.isAutoInsertedClosing(r, s, o)) return y.popAutoInsertedClosing(), {
                                    text: "",
                                    selection: [
                                        1,
                                        1
                                    ]
                                };
                            }
                        }
                    }), this.add("parens", "deletion", function(e, t, i, n, o) {
                        var r = n.doc.getTextRange(o);
                        if (!o.isMultiLine() && "(" == r && (g(i), ")" == n.doc.getLine(o.start.row).substring(o.start.column + 1, o.start.column + 2))) return o.end.column++, o;
                    }), this.add("brackets", "insertion", function(e, t, i, n, o) {
                        if ("[" == o) return g(i), r = i.getSelectionRange(), "" !== (s = n.doc.getTextRange(r)) && i.getWrapBehavioursEnabled() ? p(r, s, "[", "]") : y.isSaneInsertion(i, n) ? (y.recordAutoInsert(i, n, "]"), {
                            text: "[]",
                            selection: [
                                1,
                                1
                            ]
                        }) : void 0;
                        if ("]" == o) {
                            g(i);
                            var r = i.getCursorPosition(), s = n.doc.getLine(r.row), i = s.substring(r.column, r.column + 1);
                            if ("]" == i) {
                                if (null !== n.$findOpeningBracket("]", {
                                    column: r.column + 1,
                                    row: r.row
                                }) && y.isAutoInsertedClosing(r, s, o)) return y.popAutoInsertedClosing(), {
                                    text: "",
                                    selection: [
                                        1,
                                        1
                                    ]
                                };
                            }
                        }
                    }), this.add("brackets", "deletion", function(e, t, i, n, o) {
                        var r = n.doc.getTextRange(o);
                        if (!o.isMultiLine() && "[" == r && (g(i), "]" == n.doc.getLine(o.start.row).substring(o.start.column + 1, o.start.column + 2))) return o.end.column++, o;
                    }), this.add("string_dquotes", "insertion", function(e, t, i, n, o) {
                        var r = n.$mode.$quotes || C;
                        if (1 == o.length && r[o] && (!this.lineCommentStart || -1 == this.lineCommentStart.indexOf(o))) {
                            g(i);
                            var s = i.getSelectionRange(), a = n.doc.getTextRange(s);
                            if (!("" === a || 1 == a.length && r[a]) && i.getWrapBehavioursEnabled()) return p(s, a, o, o);
                            if (!a) {
                                var r = i.getCursorPosition(), s = n.doc.getLine(r.row), a = s.substring(r.column - 1, r.column), i = s.substring(r.column, r.column + 1), l = n.getTokenAt(r.row, r.column), c = n.getTokenAt(r.row, r.column + 1);
                                if ("\\" == a && l && /escape/.test(l.type)) return null;
                                var h, l = l && /string|escape/.test(l.type), d = !c || /string|escape/.test(c.type);
                                if (i == o) (h = l !== d) && /string\.end/.test(c.type) && (h = !1);
                                else {
                                    if (l && !d) return null;
                                    if (l && d) return null;
                                    c = n.$mode.tokenRe, l = (c.lastIndex = 0, c.test(a)), d = (c.lastIndex = 0, c.test(i)), n = n.$mode.$pairQuotesAfter;
                                    if (!(n && n[o] && n[o].test(a)) && l || d) return null;
                                    if (i && !/[\s;,.})\]\\]/.test(i)) return null;
                                    n = s[r.column - 2];
                                    if (a == o && (n == o || c.test(n))) return null;
                                    h = !0;
                                }
                                return {
                                    text: h ? o + o : "",
                                    selection: [
                                        1,
                                        1
                                    ]
                                };
                            }
                        }
                    }), this.add("string_dquotes", "deletion", function(e, t, i, n, o) {
                        var r = n.$mode.$quotes || C, s = n.doc.getTextRange(o);
                        if (!o.isMultiLine() && r.hasOwnProperty(s) && (g(i), n.doc.getLine(o.start.row).substring(o.start.column + 1, o.start.column + 2) == s)) return o.end.column++, o;
                    }), !1 !== u.closeDocComment && this.add("doc comment end", "insertion", function(e, t, i, n, o) {
                        if ("doc-start" === e && ("\n" === o || "\r\n" === o) && i.selection.isEmpty()) {
                            var r = i.getCursorPosition();
                            if (0 !== r.column) {
                                for(var e = n.doc.getLine(r.row), i = n.doc.getLine(r.row + 1), s = n.getTokens(r.row), a = 0, l = 0; l < s.length; l++){
                                    a += s[l].value.length;
                                    var c = s[l];
                                    if (a >= r.column) {
                                        if (a === r.column) {
                                            if (!/\.doc/.test(c.type)) return;
                                            if (/\*\//.test(c.value)) {
                                                var h = s[l + 1];
                                                if (!h || !/\.doc/.test(h.type)) return;
                                            }
                                        }
                                        var h = r.column - (a - c.value.length), d = c.value.indexOf("*/"), u = c.value.indexOf("/**", -1 < d ? d + 2 : 0);
                                        if (-1 !== u && u < h && h < u + 3) return;
                                        if (-1 !== d && -1 !== u && d <= h && h <= u || !/\.doc/.test(c.type)) return;
                                        break;
                                    }
                                }
                                n = this.$getIndent(e);
                                return /\s*\*/.test(i) ? /^\s*\*/.test(e) ? {
                                    text: o + n + "* ",
                                    selection: [
                                        1,
                                        2 + n.length,
                                        1,
                                        2 + n.length
                                    ]
                                } : {
                                    text: o + n + " * ",
                                    selection: [
                                        1,
                                        3 + n.length,
                                        1,
                                        3 + n.length
                                    ]
                                } : /\/\*\*/.test(e.substring(0, r.column)) ? {
                                    text: o + n + " * " + o + " " + n + "*/",
                                    selection: [
                                        1,
                                        4 + n.length,
                                        1,
                                        4 + n.length
                                    ]
                                } : void 0;
                            }
                        }
                    });
                };
                y.isSaneInsertion = function(e, t) {
                    var i = e.getCursorPosition(), n = new r(t, i.row, i.column);
                    if (!this.$matchTokenType(n.getCurrentToken() || "text", s)) {
                        if (/[)}\]]/.test(e.session.getLine(i.row)[i.column])) return !0;
                        e = new r(t, i.row, i.column + 1);
                        if (!this.$matchTokenType(e.getCurrentToken() || "text", s)) return !1;
                    }
                    return n.stepForward(), n.getCurrentTokenRow() !== i.row || this.$matchTokenType(n.getCurrentToken() || "text", a);
                }, y.$matchTokenType = function(e, t) {
                    return -1 < t.indexOf(e.type || e);
                }, y.recordAutoInsert = function(e, t, i) {
                    e = e.getCursorPosition(), t = t.doc.getLine(e.row);
                    this.isAutoInsertedClosing(e, t, m.autoInsertedLineEnd[0]) || (m.autoInsertedBrackets = 0), m.autoInsertedRow = e.row, m.autoInsertedLineEnd = i + t.substr(e.column), m.autoInsertedBrackets++;
                }, y.recordMaybeInsert = function(e, t, i) {
                    e = e.getCursorPosition(), t = t.doc.getLine(e.row);
                    this.isMaybeInsertedClosing(e, t) || (m.maybeInsertedBrackets = 0), m.maybeInsertedRow = e.row, m.maybeInsertedLineStart = t.substr(0, e.column) + i, m.maybeInsertedLineEnd = t.substr(e.column), m.maybeInsertedBrackets++;
                }, y.isAutoInsertedClosing = function(e, t, i) {
                    return 0 < m.autoInsertedBrackets && e.row === m.autoInsertedRow && i === m.autoInsertedLineEnd[0] && t.substr(e.column) === m.autoInsertedLineEnd;
                }, y.isMaybeInsertedClosing = function(e, t) {
                    return 0 < m.maybeInsertedBrackets && e.row === m.maybeInsertedRow && t.substr(e.column) === m.maybeInsertedLineEnd && t.substr(0, e.column) == m.maybeInsertedLineStart;
                }, y.popAutoInsertedClosing = function() {
                    m.autoInsertedLineEnd = m.autoInsertedLineEnd.substr(1), m.autoInsertedBrackets--;
                }, y.clearMaybeInsertedClosing = function() {
                    m && (m.maybeInsertedBrackets = 0, m.maybeInsertedRow = -1);
                }, n.inherits(y, o), t.CstyleBehaviour = y;
            }), ace.define("ace/unicode", [
                "require",
                "exports",
                "module"
            ], function(e, t, i) {
                for(var n = [
                    48,
                    9,
                    8,
                    25,
                    5,
                    0,
                    2,
                    25,
                    48,
                    0,
                    11,
                    0,
                    5,
                    0,
                    6,
                    22,
                    2,
                    30,
                    2,
                    457,
                    5,
                    11,
                    15,
                    4,
                    8,
                    0,
                    2,
                    0,
                    18,
                    116,
                    2,
                    1,
                    3,
                    3,
                    9,
                    0,
                    2,
                    2,
                    2,
                    0,
                    2,
                    19,
                    2,
                    82,
                    2,
                    138,
                    2,
                    4,
                    3,
                    155,
                    12,
                    37,
                    3,
                    0,
                    8,
                    38,
                    10,
                    44,
                    2,
                    0,
                    2,
                    1,
                    2,
                    1,
                    2,
                    0,
                    9,
                    26,
                    6,
                    2,
                    30,
                    10,
                    7,
                    61,
                    2,
                    9,
                    5,
                    101,
                    2,
                    7,
                    3,
                    9,
                    2,
                    18,
                    3,
                    0,
                    17,
                    58,
                    3,
                    100,
                    15,
                    53,
                    5,
                    0,
                    6,
                    45,
                    211,
                    57,
                    3,
                    18,
                    2,
                    5,
                    3,
                    11,
                    3,
                    9,
                    2,
                    1,
                    7,
                    6,
                    2,
                    2,
                    2,
                    7,
                    3,
                    1,
                    3,
                    21,
                    2,
                    6,
                    2,
                    0,
                    4,
                    3,
                    3,
                    8,
                    3,
                    1,
                    3,
                    3,
                    9,
                    0,
                    5,
                    1,
                    2,
                    4,
                    3,
                    11,
                    16,
                    2,
                    2,
                    5,
                    5,
                    1,
                    3,
                    21,
                    2,
                    6,
                    2,
                    1,
                    2,
                    1,
                    2,
                    1,
                    3,
                    0,
                    2,
                    4,
                    5,
                    1,
                    3,
                    2,
                    4,
                    0,
                    8,
                    3,
                    2,
                    0,
                    8,
                    15,
                    12,
                    2,
                    2,
                    8,
                    2,
                    2,
                    2,
                    21,
                    2,
                    6,
                    2,
                    1,
                    2,
                    4,
                    3,
                    9,
                    2,
                    2,
                    2,
                    2,
                    3,
                    0,
                    16,
                    3,
                    3,
                    9,
                    18,
                    2,
                    2,
                    7,
                    3,
                    1,
                    3,
                    21,
                    2,
                    6,
                    2,
                    1,
                    2,
                    4,
                    3,
                    8,
                    3,
                    1,
                    3,
                    2,
                    9,
                    1,
                    5,
                    1,
                    2,
                    4,
                    3,
                    9,
                    2,
                    0,
                    17,
                    1,
                    2,
                    5,
                    4,
                    2,
                    2,
                    3,
                    4,
                    1,
                    2,
                    0,
                    2,
                    1,
                    4,
                    1,
                    4,
                    2,
                    4,
                    11,
                    5,
                    4,
                    4,
                    2,
                    2,
                    3,
                    3,
                    0,
                    7,
                    0,
                    15,
                    9,
                    18,
                    2,
                    2,
                    7,
                    2,
                    2,
                    2,
                    22,
                    2,
                    9,
                    2,
                    4,
                    4,
                    7,
                    2,
                    2,
                    2,
                    3,
                    8,
                    1,
                    2,
                    1,
                    7,
                    3,
                    3,
                    9,
                    19,
                    1,
                    2,
                    7,
                    2,
                    2,
                    2,
                    22,
                    2,
                    9,
                    2,
                    4,
                    3,
                    8,
                    2,
                    2,
                    2,
                    3,
                    8,
                    1,
                    8,
                    0,
                    2,
                    3,
                    3,
                    9,
                    19,
                    1,
                    2,
                    7,
                    2,
                    2,
                    2,
                    22,
                    2,
                    15,
                    4,
                    7,
                    2,
                    2,
                    2,
                    3,
                    10,
                    0,
                    9,
                    3,
                    3,
                    9,
                    11,
                    5,
                    3,
                    1,
                    2,
                    17,
                    4,
                    23,
                    2,
                    8,
                    2,
                    0,
                    3,
                    6,
                    4,
                    0,
                    5,
                    5,
                    2,
                    0,
                    2,
                    7,
                    19,
                    1,
                    14,
                    57,
                    6,
                    14,
                    2,
                    9,
                    40,
                    1,
                    2,
                    0,
                    3,
                    1,
                    2,
                    0,
                    3,
                    0,
                    7,
                    3,
                    2,
                    6,
                    2,
                    2,
                    2,
                    0,
                    2,
                    0,
                    3,
                    1,
                    2,
                    12,
                    2,
                    2,
                    3,
                    4,
                    2,
                    0,
                    2,
                    5,
                    3,
                    9,
                    3,
                    1,
                    35,
                    0,
                    24,
                    1,
                    7,
                    9,
                    12,
                    0,
                    2,
                    0,
                    2,
                    0,
                    5,
                    9,
                    2,
                    35,
                    5,
                    19,
                    2,
                    5,
                    5,
                    7,
                    2,
                    35,
                    10,
                    0,
                    58,
                    73,
                    7,
                    77,
                    3,
                    37,
                    11,
                    42,
                    2,
                    0,
                    4,
                    328,
                    2,
                    3,
                    3,
                    6,
                    2,
                    0,
                    2,
                    3,
                    3,
                    40,
                    2,
                    3,
                    3,
                    32,
                    2,
                    3,
                    3,
                    6,
                    2,
                    0,
                    2,
                    3,
                    3,
                    14,
                    2,
                    56,
                    2,
                    3,
                    3,
                    66,
                    5,
                    0,
                    33,
                    15,
                    17,
                    84,
                    13,
                    619,
                    3,
                    16,
                    2,
                    25,
                    6,
                    74,
                    22,
                    12,
                    2,
                    6,
                    12,
                    20,
                    12,
                    19,
                    13,
                    12,
                    2,
                    2,
                    2,
                    1,
                    13,
                    51,
                    3,
                    29,
                    4,
                    0,
                    5,
                    1,
                    3,
                    9,
                    34,
                    2,
                    3,
                    9,
                    7,
                    87,
                    9,
                    42,
                    6,
                    69,
                    11,
                    28,
                    4,
                    11,
                    5,
                    11,
                    11,
                    39,
                    3,
                    4,
                    12,
                    43,
                    5,
                    25,
                    7,
                    10,
                    38,
                    27,
                    5,
                    62,
                    2,
                    28,
                    3,
                    10,
                    7,
                    9,
                    14,
                    0,
                    89,
                    75,
                    5,
                    9,
                    18,
                    8,
                    13,
                    42,
                    4,
                    11,
                    71,
                    55,
                    9,
                    9,
                    4,
                    48,
                    83,
                    2,
                    2,
                    30,
                    14,
                    230,
                    23,
                    280,
                    3,
                    5,
                    3,
                    37,
                    3,
                    5,
                    3,
                    7,
                    2,
                    0,
                    2,
                    0,
                    2,
                    0,
                    2,
                    30,
                    3,
                    52,
                    2,
                    6,
                    2,
                    0,
                    4,
                    2,
                    2,
                    6,
                    4,
                    3,
                    3,
                    5,
                    5,
                    12,
                    6,
                    2,
                    2,
                    6,
                    67,
                    1,
                    20,
                    0,
                    29,
                    0,
                    14,
                    0,
                    17,
                    4,
                    60,
                    12,
                    5,
                    0,
                    4,
                    11,
                    18,
                    0,
                    5,
                    0,
                    3,
                    9,
                    2,
                    0,
                    4,
                    4,
                    7,
                    0,
                    2,
                    0,
                    2,
                    0,
                    2,
                    3,
                    2,
                    10,
                    3,
                    3,
                    6,
                    4,
                    5,
                    0,
                    53,
                    1,
                    2684,
                    46,
                    2,
                    46,
                    2,
                    132,
                    7,
                    6,
                    15,
                    37,
                    11,
                    53,
                    10,
                    0,
                    17,
                    22,
                    10,
                    6,
                    2,
                    6,
                    2,
                    6,
                    2,
                    6,
                    2,
                    6,
                    2,
                    6,
                    2,
                    6,
                    2,
                    6,
                    2,
                    31,
                    48,
                    0,
                    470,
                    1,
                    36,
                    5,
                    2,
                    4,
                    6,
                    1,
                    5,
                    85,
                    3,
                    1,
                    3,
                    2,
                    2,
                    89,
                    2,
                    3,
                    6,
                    40,
                    4,
                    93,
                    18,
                    23,
                    57,
                    15,
                    513,
                    6581,
                    75,
                    20939,
                    53,
                    1164,
                    68,
                    45,
                    3,
                    268,
                    4,
                    27,
                    21,
                    31,
                    3,
                    13,
                    13,
                    1,
                    2,
                    24,
                    9,
                    69,
                    11,
                    1,
                    38,
                    8,
                    3,
                    102,
                    3,
                    1,
                    111,
                    44,
                    25,
                    51,
                    13,
                    68,
                    12,
                    9,
                    7,
                    23,
                    4,
                    0,
                    5,
                    45,
                    3,
                    35,
                    13,
                    28,
                    4,
                    64,
                    15,
                    10,
                    39,
                    54,
                    10,
                    13,
                    3,
                    9,
                    7,
                    22,
                    4,
                    1,
                    5,
                    66,
                    25,
                    2,
                    227,
                    42,
                    2,
                    1,
                    3,
                    9,
                    7,
                    11171,
                    13,
                    22,
                    5,
                    48,
                    8453,
                    301,
                    3,
                    61,
                    3,
                    105,
                    39,
                    6,
                    13,
                    4,
                    6,
                    11,
                    2,
                    12,
                    2,
                    4,
                    2,
                    0,
                    2,
                    1,
                    2,
                    1,
                    2,
                    107,
                    34,
                    362,
                    19,
                    63,
                    3,
                    53,
                    41,
                    11,
                    5,
                    15,
                    17,
                    6,
                    13,
                    1,
                    25,
                    2,
                    33,
                    4,
                    2,
                    134,
                    20,
                    9,
                    8,
                    25,
                    5,
                    0,
                    2,
                    25,
                    12,
                    88,
                    4,
                    5,
                    3,
                    5,
                    3,
                    5,
                    3,
                    2
                ], o = 0, r = [], s = 0; s < n.length; s += 2)r.push(o += n[s]), n[s + 1] && r.push(45, o += n[s + 1]);
                t.wordChars = String.fromCharCode.apply(null, r);
            }), ace.define("ace/mode/text", [
                "require",
                "exports",
                "module",
                "ace/config",
                "ace/tokenizer",
                "ace/mode/text_highlight_rules",
                "ace/mode/behaviour/cstyle",
                "ace/unicode",
                "ace/lib/lang",
                "ace/token_iterator",
                "ace/range"
            ], function(e, t, i) {
                var a = e("../config"), n = e("../tokenizer").Tokenizer, o = e("./text_highlight_rules").TextHighlightRules, r = e("./behaviour/cstyle").CstyleBehaviour, s = e("../unicode"), b = e("../lib/lang"), m = e("../token_iterator").TokenIterator, f = e("../range").Range, e = function() {
                    this.HighlightRules = o;
                };
                (function() {
                    this.$defaultBehaviour = new r, this.tokenRe = new RegExp("^[" + s.wordChars + "\\$_]+", "g"), this.nonTokenRe = new RegExp("^(?:[^" + s.wordChars + "\\$_]|\\s])+", "g"), this.getTokenizer = function() {
                        return this.$tokenizer || (this.$highlightRules = this.$highlightRules || new this.HighlightRules(this.$highlightRuleConfig), this.$tokenizer = new n(this.$highlightRules.getRules())), this.$tokenizer;
                    }, this.lineCommentStart = "", this.blockComment = "", this.toggleCommentLines = function(e, o, i, n) {
                        var r = o.doc, s = !0, a = !0, l = 1 / 0, c = o.getTabSize(), t = !1;
                        if (this.lineCommentStart) {
                            m = Array.isArray(this.lineCommentStart) ? (C = this.lineCommentStart.map(b.escapeRegExp).join("|"), this.lineCommentStart[0]) : (C = b.escapeRegExp(this.lineCommentStart), this.lineCommentStart), C = new RegExp("^(\\s*)(?:" + C + ") ?"), t = o.getUseSoftTabs();
                            var h = function(e, t) {
                                var i, n, o = e.match(C);
                                o && (i = o[1].length, n = o[0].length, p(e, i, n) || " " != o[0][n - 1] || n--, r.removeInLine(t, i, n));
                            }, d = m + " ", u = function(e, t) {
                                s && !/\S/.test(e) || (p(e, l, l) ? r.insertInLine({
                                    row: t,
                                    column: l
                                }, d) : r.insertInLine({
                                    row: t,
                                    column: l
                                }, m));
                            }, g = function(e, t) {
                                return C.test(e);
                            }, p = function(e, t, i) {
                                for(var n = 0; t-- && " " == e.charAt(t);)n++;
                                if (n % c != 0) return !1;
                                for(n = 0; " " == e.charAt(i++);)n++;
                                return 2 < c ? n % c != c - 1 : n % c == 0;
                            };
                        } else {
                            if (!this.blockComment) return !1;
                            var m = this.blockComment.start, f = this.blockComment.end, C = new RegExp("^(\\s*)(?:" + b.escapeRegExp(m) + ")"), y = new RegExp("(?:" + b.escapeRegExp(f) + ")\\s*$"), u = function(e, t) {
                                g(e, t) || s && !/\S/.test(e) || (r.insertInLine({
                                    row: t,
                                    column: e.length
                                }, f), r.insertInLine({
                                    row: t,
                                    column: l
                                }, m));
                            }, h = function(e, t) {
                                var i;
                                (i = e.match(y)) && r.removeInLine(t, e.length - i[0].length, e.length), (i = e.match(C)) && r.removeInLine(t, i[1].length, i[0].length);
                            }, g = function(e, t) {
                                if (C.test(e)) return !0;
                                for(var i = o.getTokens(t), n = 0; n < i.length; n++)if ("comment" === i[n].type) return !0;
                            };
                        }
                        function v(e) {
                            for(var t = i; t <= n; t++)e(r.getLine(t), t);
                        }
                        var I = 1 / 0;
                        v(function(e, t) {
                            var i = e.search(/\S/);
                            -1 !== i ? (i < l && (l = i), a && !g(e, t) && (a = !1)) : I > e.length && (I = e.length);
                        }), l == 1 / 0 && (l = I, a = s = !1), t && l % c != 0 && (l = Math.floor(l / c) * c), v(a ? h : u);
                    }, this.toggleBlockComment = function(e, t, i, n) {
                        var o = this.blockComment;
                        if (o) {
                            !o.start && o[0] && (o = o[0]);
                            var r, s, a = (u = new m(t, n.row, n.column)).getCurrentToken(), l = (t.selection, t.selection.toOrientedRange());
                            if (a && /comment/.test(a.type)) {
                                for(; a && /comment/.test(a.type);){
                                    if (-1 != (g = a.value.indexOf(o.start))) {
                                        var c = u.getCurrentTokenRow(), h = u.getCurrentTokenColumn() + g, d = new f(c, h, c, h + o.start.length);
                                        break;
                                    }
                                    a = u.stepBackward();
                                }
                                for(var u, g, a = (u = new m(t, n.row, n.column)).getCurrentToken(); a && /comment/.test(a.type);){
                                    if (-1 != (g = a.value.indexOf(o.end))) {
                                        var c = u.getCurrentTokenRow(), h = u.getCurrentTokenColumn() + g, p = new f(c, h, c, h + o.end.length);
                                        break;
                                    }
                                    a = u.stepForward();
                                }
                                p && t.remove(p), d && (t.remove(d), r = d.start.row, s = -o.start.length);
                            } else s = o.start.length, r = i.start.row, t.insert(i.end, o.end), t.insert(i.start, o.start);
                            l.start.row == r && (l.start.column += s), l.end.row == r && (l.end.column += s), t.selection.fromOrientedRange(l);
                        }
                    }, this.getNextLineIndent = function(e, t, i) {
                        return this.$getIndent(t);
                    }, this.checkOutdent = function(e, t, i) {
                        return !1;
                    }, this.autoOutdent = function(e, t, i) {}, this.$getIndent = function(e) {
                        return e.match(/^\s*/)[0];
                    }, this.createWorker = function(e) {
                        return null;
                    }, this.createModeDelegates = function(e) {
                        for(var t in this.$embeds = [], this.$modes = {}, e){
                            var i, n, o;
                            e[t] && (n = (i = e[t]).prototype.$id, (o = a.$modes[n]) || (a.$modes[n] = o = new i), a.$modes[t] || (a.$modes[t] = o), this.$embeds.push(t), this.$modes[t] = o);
                        }
                        for(var r = [
                            "toggleBlockComment",
                            "toggleCommentLines",
                            "getNextLineIndent",
                            "checkOutdent",
                            "autoOutdent",
                            "transformAction",
                            "getCompletions"
                        ], s = this, t = 0; t < r.length; t++)((e)=>{
                            var t, i;
                            t = r[e], i = s[t], s[r[e]] = function() {
                                return this.$delegator(t, arguments, i);
                            };
                        })(t);
                    }, this.$delegator = function(e, t, i) {
                        var n = t[0] || "start";
                        if ("string" != typeof n) {
                            if (Array.isArray(n[2])) {
                                var o = n[2][n[2].length - 1];
                                if (s = this.$modes[o]) return s[e].apply(s, [
                                    n[1]
                                ].concat([].slice.call(t, 1)));
                            }
                            n = n[0] || "start";
                        }
                        for(var r = 0; r < this.$embeds.length; r++)if (this.$modes[this.$embeds[r]]) {
                            var s, a = n.split(this.$embeds[r]);
                            if (!a[0] && a[1]) return t[0] = a[1], (s = this.$modes[this.$embeds[r]])[e].apply(s, t);
                        }
                        o = i.apply(this, t);
                        return i ? o : void 0;
                    }, this.transformAction = function(e, t, i, n, o) {
                        if (this.$behaviour) {
                            var r, s = this.$behaviour.getBehaviours();
                            for(r in s)if (s[r][t]) {
                                var a = s[r][t].apply(this, arguments);
                                if (a) return a;
                            }
                        }
                    }, this.getKeywords = function(e) {
                        if (!this.completionKeywords) {
                            var t = this.$tokenizer.rules, i = [];
                            for(s in t)for(var n = t[s], o = 0, r = n.length; o < r; o++)if ("string" == typeof n[o].token) /keyword|support|storage/.test(n[o].token) && i.push(n[o].regex);
                            else if ("object" == typeof n[o].token) for(var s, a = 0, l = n[o].token.length; a < l; a++)/keyword|support|storage/.test(n[o].token[a]) && (s = n[o].regex.match(/\(.+?\)/g)[a], i.push(s.substr(1, s.length - 2)));
                            this.completionKeywords = i;
                        }
                        return e ? i.concat(this.$keywordList || []) : this.$keywordList;
                    }, this.$createKeywordList = function() {
                        return this.$highlightRules || this.getTokenizer(), this.$keywordList = this.$highlightRules.$keywordList || [];
                    }, this.getCompletions = function(e, t, i, n) {
                        return (this.$keywordList || this.$createKeywordList()).map(function(e) {
                            return {
                                name: e,
                                value: e,
                                score: 0,
                                meta: "keyword"
                            };
                        });
                    }, this.$id = "ace/mode/text";
                }).call(e.prototype), t.Mode = e;
            }), ace.define("ace/line_widgets", [
                "require",
                "exports",
                "module",
                "ace/lib/dom"
            ], function(e, t, i) {
                var o = e("./lib/dom");
                function n(e) {
                    this.session = e, (this.session.widgetManager = this).session.getRowLength = this.getRowLength, this.session.$getWidgetScreenLength = this.$getWidgetScreenLength, this.updateOnChange = this.updateOnChange.bind(this), this.renderWidgets = this.renderWidgets.bind(this), this.measureWidgets = this.measureWidgets.bind(this), this.session._changedWidgets = [], this.$onChangeEditor = this.$onChangeEditor.bind(this), this.session.on("change", this.updateOnChange), this.session.on("changeFold", this.updateOnFold), this.session.on("changeEditor", this.$onChangeEditor);
                }
                n.prototype.getRowLength = function(e) {
                    var t = this.lineWidgets && this.lineWidgets[e] && this.lineWidgets[e].rowCount || 0;
                    return this.$useWrapMode && this.$wrapData[e] ? this.$wrapData[e].length + 1 + t : 1 + t;
                }, n.prototype.$getWidgetScreenLength = function() {
                    var t = 0;
                    return this.lineWidgets.forEach(function(e) {
                        e && e.rowCount && !e.hidden && (t += e.rowCount);
                    }), t;
                }, n.prototype.$onChangeEditor = function(e) {
                    this.attach(e.editor);
                }, n.prototype.attach = function(e) {
                    e && e.widgetManager && e.widgetManager != this && e.widgetManager.detach(), this.editor != e && (this.detach(), this.editor = e) && (e.widgetManager = this, e.renderer.on("beforeRender", this.measureWidgets), e.renderer.on("afterRender", this.renderWidgets));
                }, n.prototype.detach = function(e) {
                    var t = this.editor;
                    t && (this.editor = null, t.widgetManager = null, t.renderer.off("beforeRender", this.measureWidgets), t.renderer.off("afterRender", this.renderWidgets), t = this.session.lineWidgets) && t.forEach(function(e) {
                        e && e.el && e.el.parentNode && (e._inDocument = !1, e.el.parentNode.removeChild(e.el));
                    });
                }, n.prototype.updateOnFold = function(e, t) {
                    var i = t.lineWidgets;
                    if (i && e.action) {
                        for(var t = e.data, n = t.start.row, o = t.end.row, r = "add" == e.action, s = n + 1; s < o; s++)i[s] && (i[s].hidden = r);
                        i[o] && (r ? i[n] ? i[o].hidden = r : i[n] = i[o] : (i[n] == i[o] && (i[n] = void 0), i[o].hidden = r));
                    }
                }, n.prototype.updateOnChange = function(e) {
                    var t, i, n, o = this.session.lineWidgets;
                    o && (t = e.start.row, 0 != (i = e.end.row - t)) && ("remove" == e.action ? (n = o.splice(t + 1, i), !o[t] && n[n.length - 1] && (o[t] = n.pop()), n.forEach(function(e) {
                        e && this.removeLineWidget(e);
                    }, this)) : (n = new Array(i), o[t] && null != o[t].column && e.start.column > o[t].column && t++, n.unshift(t, 0), o.splice.apply(o, n)), this.$updateRows());
                }, n.prototype.$updateRows = function() {
                    var i, e = this.session.lineWidgets;
                    e && (i = !0, e.forEach(function(e, t) {
                        if (e) for(i = !1, e.row = t; e.$oldWidget;)e.$oldWidget.row = t, e = e.$oldWidget;
                    }), i) && (this.session.lineWidgets = null);
                }, n.prototype.$registerLineWidget = function(e) {
                    this.session.lineWidgets || (this.session.lineWidgets = new Array(this.session.getLength()));
                    var t = this.session.lineWidgets[e.row];
                    return t && (e.$oldWidget = t).el && t.el.parentNode && (t.el.parentNode.removeChild(t.el), t._inDocument = !1), this.session.lineWidgets[e.row] = e;
                }, n.prototype.addLineWidget = function(e) {
                    var t, i, n;
                    return this.$registerLineWidget(e), e.session = this.session, this.editor && (t = this.editor.renderer, e.html && !e.el && (e.el = o.createElement("div"), e.el.innerHTML = e.html), e.text && !e.el && (e.el = o.createElement("div"), e.el.textContent = e.text), e.el && (o.addCssClass(e.el, "ace_lineWidgetContainer"), e.className && o.addCssClass(e.el, e.className), e.el.style.position = "absolute", e.el.style.zIndex = "5", t.container.appendChild(e.el), e._inDocument = !0, e.coverGutter || (e.el.style.zIndex = "3"), null == e.pixelHeight) && (e.pixelHeight = e.el.offsetHeight), null == e.rowCount && (e.rowCount = e.pixelHeight / t.layerConfig.lineHeight), i = this.session.getFoldAt(e.row, 0), (e.$fold = i) && (n = this.session.lineWidgets, e.row != i.end.row || n[i.start.row] ? e.hidden = !0 : n[i.start.row] = e), this.session._emit("changeFold", {
                        data: {
                            start: {
                                row: e.row
                            }
                        }
                    }), this.$updateRows(), this.renderWidgets(null, t), this.onWidgetChanged(e)), e;
                }, n.prototype.removeLineWidget = function(e) {
                    if (e._inDocument = !1, e.session = null, e.el && e.el.parentNode && e.el.parentNode.removeChild(e.el), e.editor && e.editor.destroy) try {
                        e.editor.destroy();
                    } catch (e) {}
                    if (this.session.lineWidgets) {
                        var t = this.session.lineWidgets[e.row];
                        if (t == e) this.session.lineWidgets[e.row] = e.$oldWidget, e.$oldWidget && this.onWidgetChanged(e.$oldWidget);
                        else for(; t;){
                            if (t.$oldWidget == e) {
                                t.$oldWidget = e.$oldWidget;
                                break;
                            }
                            t = t.$oldWidget;
                        }
                    }
                    this.session._emit("changeFold", {
                        data: {
                            start: {
                                row: e.row
                            }
                        }
                    }), this.$updateRows();
                }, n.prototype.getWidgetsAtRow = function(e) {
                    for(var t = this.session.lineWidgets, i = t && t[e], n = []; i;)n.push(i), i = i.$oldWidget;
                    return n;
                }, n.prototype.onWidgetChanged = function(e) {
                    this.session._changedWidgets.push(e), this.editor && this.editor.renderer.updateFull();
                }, n.prototype.measureWidgets = function(e, t) {
                    var i = this.session._changedWidgets, n = t.layerConfig;
                    if (i && i.length) {
                        for(var o = 1 / 0, r = 0; r < i.length; r++){
                            var s = i[r];
                            if (s && s.el && s.session == this.session) {
                                if (!s._inDocument) {
                                    if (this.session.lineWidgets[s.row] != s) continue;
                                    s._inDocument = !0, t.container.appendChild(s.el);
                                }
                                s.h = s.el.offsetHeight, s.fixedWidth || (s.w = s.el.offsetWidth, s.screenWidth = Math.ceil(s.w / n.characterWidth));
                                var a = s.h / n.lineHeight;
                                s.coverLine && (a -= this.session.getRowLineCount(s.row)) < 0 && (a = 0), s.rowCount != a && (s.rowCount = a, s.row < o) && (o = s.row);
                            }
                        }
                        o != 1 / 0 && (this.session._emit("changeFold", {
                            data: {
                                start: {
                                    row: o
                                }
                            }
                        }), this.session.lineWidgetWidth = null), this.session._changedWidgets = [];
                    }
                }, n.prototype.renderWidgets = function(e, t) {
                    var i = t.layerConfig, n = this.session.lineWidgets;
                    if (n) {
                        for(var o = Math.min(this.firstRow, i.firstRow), r = Math.max(this.lastRow, i.lastRow, n.length); 0 < o && !n[o];)o--;
                        this.firstRow = i.firstRow, this.lastRow = i.lastRow, t.$cursorLayer.config = i;
                        for(var s = o; s <= r; s++){
                            var a, l = n[s];
                            l && l.el && (l.hidden ? l.el.style.top = -100 - (l.pixelHeight || 0) + "px" : (l._inDocument || (l._inDocument = !0, t.container.appendChild(l.el)), a = t.$cursorLayer.getPixelPosition({
                                row: s,
                                column: 0
                            }, !0).top, l.coverLine || (a += i.lineHeight * this.session.getRowLineCount(l.row)), l.el.style.top = a - i.offset + "px", a = l.coverGutter ? 0 : t.gutterWidth, l.fixedWidth || (a -= t.scrollLeft), l.el.style.left = a + "px", l.fullWidth && l.screenWidth && (l.el.style.minWidth = i.width + 2 * i.padding + "px"), l.fixedWidth ? l.el.style.right = t.scrollBar.getWidth() + "px" : l.el.style.right = ""));
                        }
                    }
                }, t.LineWidgets = n;
            }), ace.define("ace/apply_delta", [
                "require",
                "exports",
                "module"
            ], function(e, t, i) {
                t.applyDelta = function(e, t, i) {
                    var n = t.start.row, o = t.start.column, r = e[n] || "";
                    switch(t.action){
                        case "insert":
                            1 === t.lines.length ? e[n] = r.substring(0, o) + t.lines[0] + r.substring(o) : (s = [
                                n,
                                1
                            ].concat(t.lines), e.splice.apply(e, s), e[n] = r.substring(0, o) + e[n], e[n + t.lines.length - 1] += r.substring(o));
                            break;
                        case "remove":
                            var s = t.end.column, a = t.end.row;
                            n === a ? e[n] = r.substring(0, o) + r.substring(s) : e.splice(n, a - n + 1, r.substring(0, o) + e[a].substring(s));
                    }
                };
            }), ace.define("ace/anchor", [
                "require",
                "exports",
                "module",
                "ace/lib/oop",
                "ace/lib/event_emitter"
            ], function(e, t, i) {
                var n = e("./lib/oop"), e = e("./lib/event_emitter").EventEmitter, o = (r.prototype.getPosition = function() {
                    return this.$clipPositionToDocument(this.row, this.column);
                }, r.prototype.getDocument = function() {
                    return this.document;
                }, r.prototype.onChange = function(e) {
                    e.start.row == e.end.row && e.start.row != this.row || e.start.row > this.row || (e = ((e, t, i)=>{
                        var n = ((s = "insert" == e.action) ? 1 : -1) * (e.end.row - e.start.row), o = (s ? 1 : -1) * (e.end.column - e.start.column), r = e.start, s = s ? r : e.end;
                        return a(t, r, i) ? {
                            row: t.row,
                            column: t.column
                        } : a(s, t, !i) ? {
                            row: t.row + n,
                            column: t.column + (t.row == s.row ? o : 0)
                        } : {
                            row: r.row,
                            column: r.column
                        };
                    })(e, {
                        row: this.row,
                        column: this.column
                    }, this.$insertRight), this.setPosition(e.row, e.column, !0));
                }, r.prototype.setPosition = function(e, t, i) {
                    i = i ? {
                        row: e,
                        column: t
                    } : this.$clipPositionToDocument(e, t);
                    this.row == i.row && this.column == i.column || (e = {
                        row: this.row,
                        column: this.column
                    }, this.row = i.row, this.column = i.column, this._signal("change", {
                        old: e,
                        value: i
                    }));
                }, r.prototype.detach = function() {
                    this.document.off("change", this.$onChange);
                }, r.prototype.attach = function(e) {
                    this.document = e || this.document, this.document.on("change", this.$onChange);
                }, r.prototype.$clipPositionToDocument = function(e, t) {
                    var i = {};
                    return e >= this.document.getLength() ? (i.row = Math.max(0, this.document.getLength() - 1), i.column = this.document.getLine(i.row).length) : e < 0 ? (i.row = 0, i.column = 0) : (i.row = e, i.column = Math.min(this.document.getLine(i.row).length, Math.max(0, t))), t < 0 && (i.column = 0), i;
                }, r);
                function r(e, t, i) {
                    this.$onChange = this.onChange.bind(this), this.attach(e), "number" != typeof t ? this.setPosition(t.row, t.column) : this.setPosition(t, i);
                }
                function a(e, t, i) {
                    i = i ? e.column <= t.column : e.column < t.column;
                    return e.row < t.row || e.row == t.row && i;
                }
                o.prototype.$insertRight = !1, n.implement(o.prototype, e), t.Anchor = o;
            }), ace.define("ace/document", [
                "require",
                "exports",
                "module",
                "ace/lib/oop",
                "ace/apply_delta",
                "ace/lib/event_emitter",
                "ace/range",
                "ace/anchor"
            ], function(e, t, i) {
                var n = e("./lib/oop"), o = e("./apply_delta").applyDelta, r = e("./lib/event_emitter").EventEmitter, s = e("./range").Range, a = e("./anchor").Anchor, e = (l.prototype.setValue = function(e) {
                    var t = this.getLength() - 1;
                    this.remove(new s(0, 0, t, this.getLine(t).length)), this.insert({
                        row: 0,
                        column: 0
                    }, e || "");
                }, l.prototype.getValue = function() {
                    return this.getAllLines().join(this.getNewLineCharacter());
                }, l.prototype.createAnchor = function(e, t) {
                    return new a(this, e, t);
                }, l.prototype.$detectNewLine = function(e) {
                    e = e.match(/^.*?(\r\n|\r|\n)/m);
                    this.$autoNewLine = e ? e[1] : "\n", this._signal("changeNewLineMode");
                }, l.prototype.getNewLineCharacter = function() {
                    switch(this.$newLineMode){
                        case "windows":
                            return "\r\n";
                        case "unix":
                            return "\n";
                        default:
                            return this.$autoNewLine || "\n";
                    }
                }, l.prototype.setNewLineMode = function(e) {
                    this.$newLineMode !== e && (this.$newLineMode = e, this._signal("changeNewLineMode"));
                }, l.prototype.getNewLineMode = function() {
                    return this.$newLineMode;
                }, l.prototype.isNewLine = function(e) {
                    return "\r\n" == e || "\r" == e || "\n" == e;
                }, l.prototype.getLine = function(e) {
                    return this.$lines[e] || "";
                }, l.prototype.getLines = function(e, t) {
                    return this.$lines.slice(e, t + 1);
                }, l.prototype.getAllLines = function() {
                    return this.getLines(0, this.getLength());
                }, l.prototype.getLength = function() {
                    return this.$lines.length;
                }, l.prototype.getTextRange = function(e) {
                    return this.getLinesForRange(e).join(this.getNewLineCharacter());
                }, l.prototype.getLinesForRange = function(e) {
                    var t, i;
                    return e.start.row === e.end.row ? t = [
                        this.getLine(e.start.row).substring(e.start.column, e.end.column)
                    ] : ((t = this.getLines(e.start.row, e.end.row))[0] = (t[0] || "").substring(e.start.column), i = t.length - 1, e.end.row - e.start.row == i && (t[i] = t[i].substring(0, e.end.column))), t;
                }, l.prototype.insertLines = function(e, t) {
                    return console.warn("Use of document.insertLines is deprecated. Use the insertFullLines method instead."), this.insertFullLines(e, t);
                }, l.prototype.removeLines = function(e, t) {
                    return console.warn("Use of document.removeLines is deprecated. Use the removeFullLines method instead."), this.removeFullLines(e, t);
                }, l.prototype.insertNewLine = function(e) {
                    return console.warn("Use of document.insertNewLine is deprecated. Use insertMergedLines(position, ['', '']) instead."), this.insertMergedLines(e, [
                        "",
                        ""
                    ]);
                }, l.prototype.insert = function(e, t) {
                    return this.getLength() <= 1 && this.$detectNewLine(t), this.insertMergedLines(e, this.$split(t));
                }, l.prototype.insertInLine = function(e, t) {
                    var i = this.clippedPos(e.row, e.column), e = this.pos(e.row, e.column + t.length);
                    return this.applyDelta({
                        start: i,
                        end: e,
                        action: "insert",
                        lines: [
                            t
                        ]
                    }, !0), this.clonePos(e);
                }, l.prototype.clippedPos = function(e, t) {
                    var i = this.getLength(), i = (void 0 === e ? e = i : e < 0 ? e = 0 : i <= e && (e = i - 1, t = void 0), this.getLine(e));
                    return null == t && (t = i.length), {
                        row: e,
                        column: t = Math.min(Math.max(t, 0), i.length)
                    };
                }, l.prototype.clonePos = function(e) {
                    return {
                        row: e.row,
                        column: e.column
                    };
                }, l.prototype.pos = function(e, t) {
                    return {
                        row: e,
                        column: t
                    };
                }, l.prototype.$clipPosition = function(e) {
                    var t = this.getLength();
                    return e.row >= t ? (e.row = Math.max(0, t - 1), e.column = this.getLine(t - 1).length) : (e.row = Math.max(0, e.row), e.column = Math.min(Math.max(e.column, 0), this.getLine(e.row).length)), e;
                }, l.prototype.insertFullLines = function(e, t) {
                    var i = 0, i = (e = Math.min(Math.max(e, 0), this.getLength())) < this.getLength() ? (t = t.concat([
                        ""
                    ]), 0) : (t = [
                        ""
                    ].concat(t), this.$lines[--e].length);
                    this.insertMergedLines({
                        row: e,
                        column: i
                    }, t);
                }, l.prototype.insertMergedLines = function(e, t) {
                    var e = this.clippedPos(e.row, e.column), i = {
                        row: e.row + t.length - 1,
                        column: (1 == t.length ? e.column : 0) + t[t.length - 1].length
                    };
                    return this.applyDelta({
                        start: e,
                        end: i,
                        action: "insert",
                        lines: t
                    }), this.clonePos(i);
                }, l.prototype.remove = function(e) {
                    var t = this.clippedPos(e.start.row, e.start.column), e = this.clippedPos(e.end.row, e.end.column);
                    return this.applyDelta({
                        start: t,
                        end: e,
                        action: "remove",
                        lines: this.getLinesForRange({
                            start: t,
                            end: e
                        })
                    }), this.clonePos(t);
                }, l.prototype.removeInLine = function(e, t, i) {
                    t = this.clippedPos(e, t), e = this.clippedPos(e, i);
                    return this.applyDelta({
                        start: t,
                        end: e,
                        action: "remove",
                        lines: this.getLinesForRange({
                            start: t,
                            end: e
                        })
                    }, !0), this.clonePos(t);
                }, l.prototype.removeFullLines = function(e, t) {
                    e = Math.min(Math.max(0, e), this.getLength() - 1);
                    var i = (t = Math.min(Math.max(0, t), this.getLength() - 1)) == this.getLength() - 1 && 0 < e, n = t < this.getLength() - 1, o = i ? e - 1 : e, i = i ? this.getLine(o).length : 0, r = n ? t + 1 : t, n = n ? 0 : this.getLine(r).length, o = new s(o, i, r, n), i = this.$lines.slice(e, t + 1);
                    return this.applyDelta({
                        start: o.start,
                        end: o.end,
                        action: "remove",
                        lines: this.getLinesForRange(o)
                    }), i;
                }, l.prototype.removeNewLine = function(e) {
                    e < this.getLength() - 1 && 0 <= e && this.applyDelta({
                        start: this.pos(e, this.getLine(e).length),
                        end: this.pos(e + 1, 0),
                        action: "remove",
                        lines: [
                            "",
                            ""
                        ]
                    });
                }, l.prototype.replace = function(e, t) {
                    return e instanceof s || (e = s.fromPoints(e.start, e.end)), 0 === t.length && e.isEmpty() ? e.start : t == this.getTextRange(e) ? e.end : (this.remove(e), t ? this.insert(e.start, t) : e.start);
                }, l.prototype.applyDeltas = function(e) {
                    for(var t = 0; t < e.length; t++)this.applyDelta(e[t]);
                }, l.prototype.revertDeltas = function(e) {
                    for(var t = e.length - 1; 0 <= t; t--)this.revertDelta(e[t]);
                }, l.prototype.applyDelta = function(e, t) {
                    var i = "insert" == e.action;
                    (i ? e.lines.length <= 1 && !e.lines[0] : !s.comparePoints(e.start, e.end)) || (i && 2e4 < e.lines.length ? this.$splitAndapplyLargeDelta(e, 2e4) : (o(this.$lines, e, t), this._signal("change", e)));
                }, l.prototype.$safeApplyDelta = function(e) {
                    var t = this.$lines.length;
                    ("remove" == e.action && e.start.row < t && e.end.row < t || "insert" == e.action && e.start.row <= t) && this.applyDelta(e);
                }, l.prototype.$splitAndapplyLargeDelta = function(e, t) {
                    for(var i = e.lines, n = i.length - t + 1, o = e.start.row, r = e.start.column, s = 0, a = 0; s < n; s = a){
                        a += t - 1;
                        var l = i.slice(s, a);
                        l.push(""), this.applyDelta({
                            start: this.pos(o + s, r),
                            end: this.pos(o + a, r = 0),
                            action: e.action,
                            lines: l
                        }, !0);
                    }
                    e.lines = i.slice(s), e.start.row = o + s, e.start.column = r, this.applyDelta(e, !0);
                }, l.prototype.revertDelta = function(e) {
                    this.$safeApplyDelta({
                        start: this.clonePos(e.start),
                        end: this.clonePos(e.end),
                        action: "insert" == e.action ? "remove" : "insert",
                        lines: e.lines.slice()
                    });
                }, l.prototype.indexToPosition = function(e, t) {
                    for(var i = this.$lines || this.getAllLines(), n = this.getNewLineCharacter().length, o = t || 0, r = i.length; o < r; o++)if ((e -= i[o].length + n) < 0) return {
                        row: o,
                        column: e + i[o].length + n
                    };
                    return {
                        row: r - 1,
                        column: e + i[r - 1].length + n
                    };
                }, l.prototype.positionToIndex = function(e, t) {
                    for(var i = this.$lines || this.getAllLines(), n = this.getNewLineCharacter().length, o = 0, r = Math.min(e.row, i.length), s = t || 0; s < r; ++s)o += i[s].length + n;
                    return o + e.column;
                }, l.prototype.$split = function(e) {
                    return e.split(/\r\n|\r|\n/);
                }, l);
                function l(e) {
                    this.$lines = [
                        ""
                    ], 0 === e.length ? this.$lines = [
                        ""
                    ] : Array.isArray(e) ? this.insertMergedLines({
                        row: 0,
                        column: 0
                    }, e) : this.insert({
                        row: 0,
                        column: 0
                    }, e);
                }
                e.prototype.$autoNewLine = "", e.prototype.$newLineMode = "auto", n.implement(e.prototype, r), t.Document = e;
            }), ace.define("ace/background_tokenizer", [
                "require",
                "exports",
                "module",
                "ace/lib/oop",
                "ace/lib/event_emitter"
            ], function(e, t, i) {
                var n = e("./lib/oop"), e = e("./lib/event_emitter").EventEmitter, o = (r.prototype.setTokenizer = function(e) {
                    this.tokenizer = e, this.lines = [], this.states = [], this.start(0);
                }, r.prototype.setDocument = function(e) {
                    this.doc = e, this.lines = [], this.states = [], this.stop();
                }, r.prototype.fireUpdateEvent = function(e, t) {
                    this._signal("update", {
                        data: {
                            first: e,
                            last: t
                        }
                    });
                }, r.prototype.start = function(e) {
                    this.currentLine = Math.min(e || 0, this.currentLine, this.doc.getLength()), this.lines.splice(this.currentLine, this.lines.length), this.states.splice(this.currentLine, this.states.length), this.stop(), this.running = setTimeout(this.$worker, 700);
                }, r.prototype.scheduleStart = function() {
                    this.running || (this.running = setTimeout(this.$worker, 700));
                }, r.prototype.$updateOnChange = function(e) {
                    var t = e.start.row, i = e.end.row - t;
                    0 == i ? this.lines[t] = null : "remove" == e.action ? (this.lines.splice(t, 1 + i, null), this.states.splice(t, 1 + i, null)) : ((e = Array(1 + i)).unshift(t, 1), this.lines.splice.apply(this.lines, e), this.states.splice.apply(this.states, e)), this.currentLine = Math.min(t, this.currentLine, this.doc.getLength()), this.stop();
                }, r.prototype.stop = function() {
                    this.running && clearTimeout(this.running), this.running = !1;
                }, r.prototype.getTokens = function(e) {
                    return this.lines[e] || this.$tokenizeRow(e);
                }, r.prototype.getState = function(e) {
                    return this.currentLine == e && this.$tokenizeRow(e), this.states[e] || "start";
                }, r.prototype.$tokenizeRow = function(e) {
                    var t = this.doc.getLine(e), i = this.states[e - 1], t = this.tokenizer.getLineTokens(t, i, e);
                    return this.states[e] + "" != t.state + "" ? (this.states[e] = t.state, this.lines[e + 1] = null, this.currentLine > e + 1 && (this.currentLine = e + 1)) : this.currentLine == e && (this.currentLine = e + 1), this.lines[e] = t.tokens;
                }, r.prototype.cleanup = function() {
                    this.running = !1, this.lines = [], this.states = [], this.currentLine = 0, this.removeAllListeners();
                }, r);
                function r(e, t) {
                    this.running = !1, this.lines = [], this.states = [], this.currentLine = 0, this.tokenizer = e;
                    var a = this;
                    this.$worker = function() {
                        if (a.running) {
                            for(var e = new Date, t = a.currentLine, i = -1, n = a.doc, o = t; a.lines[t];)t++;
                            var r = n.getLength(), s = 0;
                            for(a.running = !1; t < r;){
                                for(a.$tokenizeRow(t), i = t; t++, a.lines[t];);
                                if (++s % 5 == 0 && 20 < new Date - e) {
                                    a.running = setTimeout(a.$worker, 20);
                                    break;
                                }
                            }
                            a.currentLine = t, o <= (i = -1 == i ? t : i) && a.fireUpdateEvent(o, i);
                        }
                    };
                }
                n.implement(o.prototype, e), t.BackgroundTokenizer = o;
            }), ace.define("ace/search_highlight", [
                "require",
                "exports",
                "module",
                "ace/lib/lang",
                "ace/range"
            ], function(e, t, i) {
                var f = e("./lib/lang"), C = e("./range").Range, e = (n.prototype.setRegexp = function(e) {
                    this.regExp + "" != e + "" && (this.regExp = e, this.cache = []);
                }, n.prototype.update = function(e, t, i, n) {
                    if (this.regExp) {
                        for(var o = n.firstRow, r = n.lastRow, s = {}, a = i.$editor && i.$editor.$search, l = a && a.$isMultilineSearch(i.$editor.getLastSearchOptions()), c = o; c <= r; c++){
                            var h, d, u = this.cache[c];
                            if (null != u && i.getValue().length == this.docLen || (l ? (u = [], (h = a.$multiLineForward(i, this.regExp, c, r)) && (d = h.endRow <= r ? h.endRow - 1 : r, c < d && (c = d), u.push(new C(h.startRow, h.startCol, h.endRow, h.endCol))), u.length > this.MAX_RANGES && (u = u.slice(0, this.MAX_RANGES))) : u = (u = (u = f.getMatchOffsets(i.getLine(c), this.regExp)).length > this.MAX_RANGES ? u.slice(0, this.MAX_RANGES) : u).map(function(e) {
                                return new C(c, e.offset, c, e.offset + e.length);
                            }), this.cache[c] = u.length ? u : ""), 0 !== u.length) for(var g = u.length; g--;){
                                var p = u[g].toScreenRange(i), m = p.toString();
                                s[m] || (s[m] = !0, t.drawSingleLineMarker(e, p, this.clazz, n));
                            }
                        }
                        this.docLen = i.getValue().length;
                    }
                }, n);
                function n(e, t, i) {
                    void 0 === i && (i = "text"), this.setRegexp(e), this.clazz = t, this.type = i, this.docLen = 0;
                }
                e.prototype.MAX_RANGES = 500, t.SearchHighlight = e;
            }), ace.define("ace/undomanager", [
                "require",
                "exports",
                "module",
                "ace/range"
            ], function(e, t, i) {
                o.prototype.addSession = function(e) {
                    this.$session = e;
                }, o.prototype.add = function(e, t, i) {
                    this.$fromUndo || e != this.$lastDelta && (this.$keepRedoStack || (this.$redoStack.length = 0), !1 !== t && this.lastDeltas || (this.lastDeltas = [], (t = this.$undoStack.length) > this.$undoDepth - 1 && this.$undoStack.splice(0, t - this.$undoDepth + 1), this.$undoStack.push(this.lastDeltas), e.id = this.$rev = ++this.$maxRev), "remove" != e.action && "insert" != e.action || (this.$lastDelta = e), this.lastDeltas.push(e));
                }, o.prototype.addSelection = function(e, t) {
                    this.selections.push({
                        value: e,
                        rev: t || this.$rev
                    });
                }, o.prototype.startNewGroup = function() {
                    return this.lastDeltas = null, this.$rev;
                }, o.prototype.markIgnored = function(e, t) {
                    null == t && (t = this.$rev + 1);
                    for(var i = this.$undoStack, n = i.length; n--;){
                        var o = i[n][0];
                        if (o.id <= e) break;
                        o.id < t && (o.ignore = !0);
                    }
                    this.lastDeltas = null;
                }, o.prototype.getSelection = function(e, t) {
                    for(var i = this.selections, n = i.length; n--;){
                        var o = i[n];
                        if (o.rev < e) return o = t ? i[n + 1] : o;
                    }
                }, o.prototype.getRevision = function() {
                    return this.$rev;
                }, o.prototype.getDeltas = function(e, t) {
                    null == t && (t = this.$rev + 1);
                    for(var i = this.$undoStack, n = null, o = 0, r = i.length; r--;){
                        var s = i[r][0];
                        if (s.id < t && !n && (n = r + 1), s.id <= e) {
                            o = r + 1;
                            break;
                        }
                    }
                    return i.slice(o, n);
                }, o.prototype.getChangedRanges = function(e, t) {
                    null == t && this.$rev;
                }, o.prototype.getChangedLines = function(e, t) {
                    null == t && this.$rev;
                }, o.prototype.undo = function(e, t) {
                    this.lastDeltas = null;
                    var i, n = this.$undoStack;
                    if (((e, t)=>{
                        for(var i = t; i--;){
                            var n = e[i];
                            if (n && !n[0].ignore) {
                                for(; i < t - 1;){
                                    var o = ((e, t)=>{
                                        for(var i = e.length; i--;)for(var n = 0; n < t.length; n++)if (!a(e[i], t[n])) {
                                            for(; i < e.length;){
                                                for(; n--;)a(t[n], e[i]);
                                                n = t.length, i++;
                                            }
                                            return [
                                                e,
                                                t
                                            ];
                                        }
                                        return e.selectionBefore = t.selectionBefore = e.selectionAfter = t.selectionAfter = null, [
                                            t,
                                            e
                                        ];
                                    })(e[i], e[i + 1]);
                                    e[i] = o[0], e[i + 1] = o[1], i++;
                                }
                                return 1;
                            }
                        }
                    })(n, n.length)) return e = e || this.$session, this.$redoStackBaseRev !== this.$rev && this.$redoStack.length && (this.$redoStack = []), this.$fromUndo = !0, i = null, (n = n.pop()) && (i = e.undoChanges(n, t), this.$redoStack.push(n), this.$syncRev()), this.$fromUndo = !1, i;
                }, o.prototype.redo = function(e, t) {
                    if (this.lastDeltas = null, e = e || this.$session, this.$fromUndo = !0, this.$redoStackBaseRev != this.$rev) {
                        for(var i = this.getDeltas(this.$redoStackBaseRev, this.$rev + 1), n = this.$redoStack, o = i, r = 0; r < o.length; r++)for(var s = o[r], a = 0; a < s.length; a++){
                            l = void 0;
                            c = void 0;
                            h = void 0;
                            d = void 0;
                            u = void 0;
                            g = void 0;
                            var l = n;
                            var c = s[a];
                            c = ((e)=>({
                                    start: C(e.start),
                                    end: C(e.end),
                                    action: e.action,
                                    lines: e.lines.slice()
                                }))(c);
                            for(var h = l.length; h--;){
                                for(var d = l[h], u = 0; u < d.length; u++){
                                    var g = ((e, t)=>{
                                        var i, n, o = "insert" == e.action, r = "insert" == t.action;
                                        if (o && r) f(e.start, t.start) < 0 ? y(t, e, 1) : y(e, t, 1);
                                        else if (o && !r) 0 <= f(e.start, t.end) ? y(e, t, -1) : (f(e.start, t.start) <= 0 || y(e, m.fromPoints(t.start, e.start), -1), y(t, e, 1));
                                        else if (!o && r) 0 <= f(t.start, e.end) ? y(t, e, -1) : (f(t.start, e.start) <= 0 || y(t, m.fromPoints(e.start, t.start), -1), y(e, t, 1));
                                        else if (!o && !r) {
                                            if (0 <= f(t.start, e.end)) y(t, e, -1);
                                            else {
                                                if (!(f(t.end, e.start) <= 0)) return f(e.start, t.start) < 0 && (e = I(i = e, t.start)), 0 < f(e.end, t.end) && (n = I(e, t.end)), v(t.end, e.start, e.end, -1), n && !i && (e.lines = n.lines, e.start = n.start, e.end = n.end, n = e), [
                                                    t,
                                                    i,
                                                    n
                                                ].filter(Boolean);
                                                y(e, t, -1);
                                            }
                                        }
                                        return [
                                            t,
                                            e
                                        ];
                                    })(d[u], c);
                                    c = g[0], 2 != g.length && (g[2] ? (d.splice(u + 1, 1, g[1], g[2]), u++) : g[1] || (d.splice(u, 1), u--));
                                }
                                d.length || l.splice(h, 1);
                            }
                        }
                        this.$redoStackBaseRev = this.$rev, this.$redoStack.forEach(function(e) {
                            e[0].id = ++this.$maxRev;
                        }, this);
                    }
                    var i = this.$redoStack.pop(), p = null;
                    return i && (p = e.redoChanges(i, t), this.$undoStack.push(i), this.$syncRev()), this.$fromUndo = !1, p;
                }, o.prototype.$syncRev = function() {
                    var e = this.$undoStack, e = e[e.length - 1], e = e && e[0].id || 0;
                    this.$redoStackBaseRev = e, this.$rev = e;
                }, o.prototype.reset = function() {
                    this.lastDeltas = null, this.$lastDelta = null, this.$undoStack = [], this.$redoStack = [], this.$rev = 0, this.mark = 0, this.$redoStackBaseRev = this.$rev, this.selections = [];
                }, o.prototype.canUndo = function() {
                    return 0 < this.$undoStack.length;
                }, o.prototype.canRedo = function() {
                    return 0 < this.$redoStack.length;
                }, o.prototype.bookmark = function(e) {
                    null == e && (e = this.$rev), this.mark = e;
                }, o.prototype.isAtBookmark = function() {
                    return this.$rev === this.mark;
                }, o.prototype.toJSON = function() {
                    return {
                        $redoStack: this.$redoStack,
                        $undoStack: this.$undoStack
                    };
                }, o.prototype.fromJSON = function(e) {
                    this.reset(), this.$undoStack = e.$undoStack, this.$redoStack = e.$redoStack;
                }, o.prototype.$prettyPrint = function(e) {
                    return e ? r(e) : r(this.$undoStack) + "\n---\n" + r(this.$redoStack);
                };
                var n = o;
                function o() {
                    this.$keepRedoStack, this.$maxRev = 0, this.$fromUndo = !1, this.$undoDepth = 1 / 0, this.reset();
                }
                n.prototype.hasUndo = n.prototype.canUndo, n.prototype.hasRedo = n.prototype.canRedo, n.prototype.isClean = n.prototype.isAtBookmark, n.prototype.markClean = n.prototype.bookmark;
                var m = e("./range").Range, f = m.comparePoints;
                function C(e) {
                    return {
                        row: e.row,
                        column: e.column
                    };
                }
                function r(e) {
                    var t;
                    return e = e || this, Array.isArray(e) ? e.map(r).join("\n") : (t = "", e.action ? (t = "insert" == e.action ? "+" : "-", t += "[" + e.lines + "]") : e.value && (t = Array.isArray(e.value) ? e.value.map(s).join("\n") : s(e.value)), e.start && (t += s(e)), (e.id || e.rev) && (t += "\t(" + (e.id || e.rev) + ")"), t);
                }
                function s(e) {
                    return e.start.row + ":" + e.start.column + "=>" + e.end.row + ":" + e.end.column;
                }
                function a(e, t) {
                    var i = "insert" == e.action, n = "insert" == t.action;
                    if (i && n) {
                        if (0 <= f(t.start, e.end)) y(t, e, -1);
                        else {
                            if (!(f(t.start, e.start) <= 0)) return;
                            y(e, t, 1);
                        }
                    } else if (i && !n) {
                        if (0 <= f(t.start, e.end)) y(t, e, -1);
                        else {
                            if (!(f(t.end, e.start) <= 0)) return;
                            y(e, t, -1);
                        }
                    } else if (!i && n) {
                        if (0 <= f(t.start, e.start)) y(t, e, 1);
                        else {
                            if (!(f(t.start, e.start) <= 0)) return;
                            y(e, t, 1);
                        }
                    } else if (!i && !n) {
                        if (0 <= f(t.start, e.start)) y(t, e, 1);
                        else {
                            if (!(f(t.end, e.start) <= 0)) return;
                            y(e, t, -1);
                        }
                    }
                    return 1;
                }
                function y(e, t, i) {
                    v(e.start, t.start, t.end, i), v(e.end, t.start, t.end, i);
                }
                function v(e, t, i, n) {
                    e.row == (1 == n ? t : i).row && (e.column += n * (i.column - t.column)), e.row += n * (i.row - t.row);
                }
                function I(e, t) {
                    var i = e.lines, n = e.end, o = (e.end = C(t), e.end.row - e.start.row), r = i.splice(o, i.length), o = o ? t.column : t.column - e.start.column;
                    return i.push(r[0].substring(0, o)), r[0] = r[0].substr(o), {
                        start: C(t),
                        end: n,
                        lines: r,
                        action: e.action
                    };
                }
                t.UndoManager = n;
            }), ace.define("ace/edit_session/fold_line", [
                "require",
                "exports",
                "module",
                "ace/range"
            ], function(e, t, i) {
                var n = e("../range").Range;
                function o(e, t) {
                    this.foldData = e, Array.isArray(t) ? this.folds = t : t = this.folds = [
                        t
                    ];
                    e = t[t.length - 1];
                    this.range = new n(t[0].start.row, t[0].start.column, e.end.row, e.end.column), this.start = this.range.start, this.end = this.range.end, this.folds.forEach(function(e) {
                        e.setFoldLine(this);
                    }, this);
                }
                o.prototype.shiftRow = function(t) {
                    this.start.row += t, this.end.row += t, this.folds.forEach(function(e) {
                        e.start.row += t, e.end.row += t;
                    });
                }, o.prototype.addFold = function(e) {
                    if (e.sameRow) {
                        if (e.start.row < this.startRow || e.endRow > this.endRow) throw new Error("Can't add a fold to this FoldLine as it has no connection");
                        this.folds.push(e), this.folds.sort(function(e, t) {
                            return -e.range.compareEnd(t.start.row, t.start.column);
                        }), 0 < this.range.compareEnd(e.start.row, e.start.column) ? (this.end.row = e.end.row, this.end.column = e.end.column) : this.range.compareStart(e.end.row, e.end.column) < 0 && (this.start.row = e.start.row, this.start.column = e.start.column);
                    } else if (e.start.row == this.end.row) this.folds.push(e), this.end.row = e.end.row, this.end.column = e.end.column;
                    else {
                        if (e.end.row != this.start.row) throw new Error("Trying to add fold to FoldRow that doesn't have a matching row");
                        this.folds.unshift(e), this.start.row = e.start.row, this.start.column = e.start.column;
                    }
                    e.foldLine = this;
                }, o.prototype.containsRow = function(e) {
                    return e >= this.start.row && e <= this.end.row;
                }, o.prototype.walk = function(e, t, i) {
                    var n, o, r = 0, s = this.folds, a = !0;
                    null == t && (t = this.end.row, i = this.end.column);
                    for(var l = 0; l < s.length; l++){
                        if (-1 == (o = (n = s[l]).range.compareStart(t, i))) return void e(null, t, i, r, a);
                        if (!e(null, n.start.row, n.start.column, r, a) && e(n.placeholder, n.start.row, n.start.column, r) || 0 === o) return;
                        a = !n.sameRow, r = n.end.column;
                    }
                    e(null, t, i, r, a);
                }, o.prototype.getNextFoldTo = function(e, t) {
                    for(var i, n, o = 0; o < this.folds.length; o++){
                        if (-1 == (n = (i = this.folds[o]).range.compareEnd(e, t))) return {
                            fold: i,
                            kind: "after"
                        };
                        if (0 === n) return {
                            fold: i,
                            kind: "inside"
                        };
                    }
                    return null;
                }, o.prototype.addRemoveChars = function(e, t, i) {
                    var n, o = this.getNextFoldTo(e, t);
                    if (o) {
                        if (n = o.fold, "inside" == o.kind && n.start.column != t && n.start.row != e) window.console && window.console.log(e, t, n);
                        else if (n.start.row == e) {
                            var r, s = (r = this.folds).indexOf(n);
                            for(0 === s && (this.start.column += i); s < r.length; s++){
                                if ((n = r[s]).start.column += i, !n.sameRow) return;
                                n.end.column += i;
                            }
                            this.end.column += i;
                        }
                    }
                }, o.prototype.split = function(e, t) {
                    var i, n, e = this.getNextFoldTo(e, t);
                    return e && "inside" != e.kind ? (t = e.fold, e = this.folds, i = this.foldData, t = e.indexOf(t), n = e[t - 1], this.end.row = n.end.row, this.end.column = n.end.column, n = new o(i, e = e.splice(t, e.length - t)), i.splice(i.indexOf(this) + 1, 0, n), n) : null;
                }, o.prototype.merge = function(e) {
                    for(var t = e.folds, i = 0; i < t.length; i++)this.addFold(t[i]);
                    var n = this.foldData;
                    n.splice(n.indexOf(e), 1);
                }, o.prototype.toString = function() {
                    var t = [
                        this.range.toString() + ": ["
                    ];
                    return this.folds.forEach(function(e) {
                        t.push("  " + e.toString());
                    }), t.push("]"), t.join("\n");
                }, o.prototype.idxToPosition = function(e) {
                    for(var t = 0, i = 0; i < this.folds.length; i++){
                        var n = this.folds[i];
                        if ((e -= n.start.column - t) < 0) return {
                            row: n.start.row,
                            column: n.start.column + e
                        };
                        if ((e -= n.placeholder.length) < 0) return n.start;
                        t = n.end.column;
                    }
                    return {
                        row: this.end.row,
                        column: this.end.column + e
                    };
                }, t.FoldLine = o;
            }), ace.define("ace/range_list", [
                "require",
                "exports",
                "module",
                "ace/range"
            ], function(e, t, i) {
                var a = e("./range").Range.comparePoints, e = (n.prototype.pointIndex = function(e, t, i) {
                    for(var n = this.ranges, o = i || 0; o < n.length; o++){
                        var r = n[o], s = a(e, r.end);
                        if (!(0 < s)) return r = a(e, r.start), 0 === s ? t && 0 !== r ? -o - 2 : o : 0 < r || 0 === r && !t ? o : -o - 1;
                    }
                    return -o - 1;
                }, n.prototype.add = function(e) {
                    var t = !e.isEmpty(), i = this.pointIndex(e.start, t), t = this.pointIndex(e.end, t, i = i < 0 ? -i - 1 : i);
                    return t < 0 ? t = -t - 1 : t++, this.ranges.splice(i, t - i, e);
                }, n.prototype.addList = function(e) {
                    for(var t = [], i = e.length; i--;)t.push.apply(t, this.add(e[i]));
                    return t;
                }, n.prototype.substractPoint = function(e) {
                    e = this.pointIndex(e);
                    if (0 <= e) return this.ranges.splice(e, 1);
                }, n.prototype.merge = function() {
                    for(var e = [], t = this.ranges, i = (t = t.sort(function(e, t) {
                        return a(e.start, t.start);
                    }))[0], n = 1; n < t.length; n++){
                        var o = i, i = t[n], r = a(o.end, i.start);
                        r < 0 || (0 != r || o.isEmpty() || i.isEmpty()) && (a(o.end, i.end) < 0 && (o.end.row = i.end.row, o.end.column = i.end.column), t.splice(n, 1), e.push(i), i = o, n--);
                    }
                    return this.ranges = t, e;
                }, n.prototype.contains = function(e, t) {
                    return 0 <= this.pointIndex({
                        row: e,
                        column: t
                    });
                }, n.prototype.containsPoint = function(e) {
                    return 0 <= this.pointIndex(e);
                }, n.prototype.rangeAtPoint = function(e) {
                    e = this.pointIndex(e);
                    if (0 <= e) return this.ranges[e];
                }, n.prototype.clipRows = function(e, t) {
                    var i = this.ranges;
                    if (i[0].start.row > t || i[i.length - 1].start.row < e) return [];
                    for(var e = this.pointIndex({
                        row: e,
                        column: 0
                    }), n = this.pointIndex({
                        row: t,
                        column: 0
                    }, e = e < 0 ? -e - 1 : e), o = (n < 0 && (n = -n - 1), []), r = e; r < n; r++)o.push(i[r]);
                    return o;
                }, n.prototype.removeAll = function() {
                    return this.ranges.splice(0, this.ranges.length);
                }, n.prototype.attach = function(e) {
                    this.session && this.detach(), this.session = e, this.onChange = this.$onChange.bind(this), this.session.on("change", this.onChange);
                }, n.prototype.detach = function() {
                    this.session && (this.session.removeListener("change", this.onChange), this.session = null);
                }, n.prototype.$onChange = function(e) {
                    for(var t = e.start, i = e.end, n = t.row, o = i.row, r = this.ranges, s = 0, a = r.length; s < a && !((h = r[s]).end.row >= n); s++);
                    if ("insert" == e.action) for(var l = o - n, c = -t.column + i.column; s < a; s++){
                        if ((h = r[s]).start.row > n) break;
                        h.start.row == n && h.start.column >= t.column && (h.start.column == t.column && this.$bias <= 0 || (h.start.column += c, h.start.row += l)), h.end.row == n && h.end.column >= t.column && (h.end.column == t.column && this.$bias < 0 || (h.end.column == t.column && 0 < c && s < a - 1 && h.end.column > h.start.column && h.end.column == r[s + 1].start.column && (h.end.column -= c), h.end.column += c, h.end.row += l));
                    }
                    else for(var h, l = n - o, c = t.column - i.column; s < a; s++){
                        if ((h = r[s]).start.row > o) break;
                        h.end.row < o && (n < h.end.row || n == h.end.row && t.column < h.end.column) ? (h.end.row = n, h.end.column = t.column) : h.end.row == o ? h.end.column <= i.column ? (l || h.end.column > t.column) && (h.end.column = t.column, h.end.row = t.row) : (h.end.column += c, h.end.row += l) : h.end.row > o && (h.end.row += l), h.start.row < o && (n < h.start.row || n == h.start.row && t.column < h.start.column) ? (h.start.row = n, h.start.column = t.column) : h.start.row == o ? h.start.column <= i.column ? (l || h.start.column > t.column) && (h.start.column = t.column, h.start.row = t.row) : (h.start.column += c, h.start.row += l) : h.start.row > o && (h.start.row += l);
                    }
                    if (0 != l && s < a) for(; s < a; s++)(h = r[s]).start.row += l, h.end.row += l;
                }, n);
                function n() {
                    this.ranges = [], this.$bias = 1;
                }
                e.prototype.comparePoints = a, t.RangeList = e;
            }), ace.define("ace/edit_session/fold", [
                "require",
                "exports",
                "module",
                "ace/range_list"
            ], function(e, t, i) {
                var n, o, r = this && this.__extends || (n = function(e, t) {
                    return (n = Object.setPrototypeOf || (({
                        __proto__: []
                    }) instanceof Array ? function(e, t) {
                        e.__proto__ = t;
                    } : function(e, t) {
                        for(var i in t)Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
                    }))(e, t);
                }, function(e, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
                    function i() {
                        this.constructor = e;
                    }
                    n(e, t), e.prototype = null === t ? Object.create(t) : (i.prototype = t.prototype, new i);
                }), e = e("../range_list").RangeList, r = (r(s, o = e), s.prototype.toString = function() {
                    return '"' + this.placeholder + '" ' + this.range.toString();
                }, s.prototype.setFoldLine = function(t) {
                    this.foldLine = t, this.subFolds.forEach(function(e) {
                        e.setFoldLine(t);
                    });
                }, s.prototype.clone = function() {
                    var t = new s(this.range.clone(), this.placeholder);
                    return this.subFolds.forEach(function(e) {
                        t.subFolds.push(e.clone());
                    }), t.collapseChildren = this.collapseChildren, t;
                }, s.prototype.addSubFold = function(e) {
                    if (!this.range.isEqual(e)) {
                        r = e, s = this.start, d(r.start, s), d(r.end, s);
                        for(var t = e.start.row, i = e.start.column, n = 0, o = -1; n < this.subFolds.length && 1 == (o = this.subFolds[n].range.compare(t, i)); n++);
                        var r = this.subFolds[n], s = 0;
                        if (0 == o) {
                            if (r.range.containsRange(e)) return r.addSubFold(e);
                            s = 1;
                        }
                        for(var t = e.range.end.row, i = e.range.end.column, a = n, o = -1; a < this.subFolds.length && 1 == (o = this.subFolds[a].range.compare(t, i)); a++);
                        0 == o && a++;
                        for(var l = this.subFolds.splice(n, a - n, e), c = 0 == o ? l.length - 1 : l.length, h = s; h < c; h++)e.addSubFold(l[h]);
                        return e.setFoldLine(this.foldLine), e;
                    }
                }, s.prototype.restoreRange = function(e) {
                    var t;
                    return e, t = this.start, a(e.start, t), void a(e.end, t);
                }, s);
                function s(e, t) {
                    var i = o.call(this) || this;
                    return i.foldLine = null, i.placeholder = t, i.range = e, i.start = e.start, i.end = e.end, i.sameRow = e.start.row == e.end.row, i.subFolds = i.ranges = [], i;
                }
                function d(e, t) {
                    e.row -= t.row, 0 == e.row && (e.column -= t.column);
                }
                function a(e, t) {
                    0 == e.row && (e.column += t.column), e.row += t.row;
                }
                t.Fold = r;
            }), ace.define("ace/edit_session/folding", [
                "require",
                "exports",
                "module",
                "ace/range",
                "ace/edit_session/fold_line",
                "ace/edit_session/fold",
                "ace/token_iterator",
                "ace/mouse/mouse_event"
            ], function(e, t, i) {
                var h = e("../range").Range, u = e("./fold_line").FoldLine, g = e("./fold").Fold, d = e("../token_iterator").TokenIterator, n = e("../mouse/mouse_event").MouseEvent;
                t.Folding = function() {
                    this.getFoldAt = function(e, t, i) {
                        var n = this.getFoldLine(e);
                        if (!n) return null;
                        for(var o = n.folds, r = 0; r < o.length; r++){
                            var s = o[r].range;
                            if (s.contains(e, t) && (1 != i || !s.isEnd(e, t) || s.isEmpty()) && (-1 != i || !s.isStart(e, t) || s.isEmpty())) return o[r];
                        }
                    }, this.getFoldsInRange = function(e) {
                        var t = e.start, i = e.end, n = this.$foldData, o = [];
                        t.column += 1, --i.column;
                        for(var r = 0; r < n.length; r++){
                            var s = n[r].range.compareRange(e);
                            if (2 != s) {
                                if (-2 == s) break;
                                for(var a = n[r].folds, l = 0; l < a.length; l++){
                                    var c = a[l];
                                    if (-2 == (s = c.range.compareRange(e))) break;
                                    if (2 != s) {
                                        if (42 == s) break;
                                        o.push(c);
                                    }
                                }
                            }
                        }
                        return --t.column, i.column += 1, o;
                    }, this.getFoldsInRangeList = function(e) {
                        var t;
                        return Array.isArray(e) ? (t = [], e.forEach(function(e) {
                            t = t.concat(this.getFoldsInRange(e));
                        }, this)) : t = this.getFoldsInRange(e), t;
                    }, this.getAllFolds = function() {
                        for(var e = [], t = this.$foldData, i = 0; i < t.length; i++)for(var n = 0; n < t[i].folds.length; n++)e.push(t[i].folds[n]);
                        return e;
                    }, this.getFoldStringAt = function(e, t, i, n) {
                        if (!(n = n || this.getFoldLine(e))) return null;
                        for(var o, r = {
                            end: {
                                column: 0
                            }
                        }, s = 0; s < n.folds.length; s++){
                            var a, l = (a = n.folds[s]).range.compareEnd(e, t);
                            if (-1 == l) {
                                o = this.getLine(a.start.row).substring(r.end.column, a.start.column);
                                break;
                            }
                            if (0 === l) return null;
                            r = a;
                        }
                        return o = o || this.getLine(a.start.row).substring(r.end.column), -1 == i ? o.substring(0, t - r.end.column) : 1 == i ? o.substring(t - r.end.column) : o;
                    }, this.getFoldLine = function(e, t) {
                        var i = this.$foldData, n = 0;
                        for(-1 == (n = t ? i.indexOf(t) : n) && (n = 0); n < i.length; n++){
                            var o = i[n];
                            if (o.start.row <= e && o.end.row >= e) return o;
                            if (o.end.row > e) return null;
                        }
                        return null;
                    }, this.getNextFoldLine = function(e, t) {
                        var i = this.$foldData, n = 0;
                        for(-1 == (n = t ? i.indexOf(t) : n) && (n = 0); n < i.length; n++){
                            var o = i[n];
                            if (o.end.row >= e) return o;
                        }
                        return null;
                    }, this.getFoldedRowCount = function(e, t) {
                        for(var i = this.$foldData, n = t - e + 1, o = 0; o < i.length; o++){
                            var r = i[o], s = r.end.row, r = r.start.row;
                            if (t <= s) {
                                r < t && (e <= r ? n -= t - r : n = 0);
                                break;
                            }
                            e <= s && (n -= e <= r ? s - r : s - e + 1);
                        }
                        return n;
                    }, this.$addFoldLine = function(e) {
                        return this.$foldData.push(e), this.$foldData.sort(function(e, t) {
                            return e.start.row - t.start.row;
                        }), e;
                    }, this.addFold = function(e, t) {
                        var i, n = this.$foldData, o = !1, r = (e instanceof g ? i = e : (i = new g(t, e)).collapseChildren = t.collapseChildren, this.$clipRangeToDocument(i.range), i.start.row), e = i.start.column, s = i.end.row, t = i.end.column, a = this.getFoldAt(r, e, 1), l = this.getFoldAt(s, t, -1);
                        if (a && l == a) return a.addSubFold(i);
                        a && !a.range.isStart(r, e) && this.removeFold(a), l && !l.range.isEnd(s, t) && this.removeFold(l);
                        e = this.getFoldsInRange(i.range);
                        0 < e.length && (this.removeFolds(e), i.collapseChildren || e.forEach(function(e) {
                            i.addSubFold(e);
                        }));
                        for(var c = 0; c < n.length; c++){
                            var h = n[c];
                            if (s == h.start.row) {
                                h.addFold(i), o = !0;
                                break;
                            }
                            if (r == h.end.row) {
                                if (h.addFold(i), o = !0, !i.sameRow) {
                                    var d = n[c + 1];
                                    if (d && d.start.row == s) {
                                        h.merge(d);
                                        break;
                                    }
                                }
                                break;
                            }
                            if (s <= h.start.row) break;
                        }
                        return o || (h = this.$addFoldLine(new u(this.$foldData, i))), this.$useWrapMode ? this.$updateWrapData(h.start.row, h.start.row) : this.$updateRowLengthCache(h.start.row, h.start.row), this.$modified = !0, this._signal("changeFold", {
                            data: i,
                            action: "add"
                        }), i;
                    }, this.addFolds = function(e) {
                        e.forEach(function(e) {
                            this.addFold(e);
                        }, this);
                    }, this.removeFold = function(e) {
                        var t = e.foldLine, i = t.start.row, n = t.end.row, o = this.$foldData, r = t.folds;
                        1 == r.length ? o.splice(o.indexOf(t), 1) : t.range.isEnd(e.end.row, e.end.column) ? (r.pop(), t.end.row = r[r.length - 1].end.row, t.end.column = r[r.length - 1].end.column) : t.range.isStart(e.start.row, e.start.column) ? (r.shift(), t.start.row = r[0].start.row, t.start.column = r[0].start.column) : e.sameRow ? r.splice(r.indexOf(e), 1) : ((r = (o = t.split(e.start.row, e.start.column)).folds).shift(), o.start.row = r[0].start.row, o.start.column = r[0].start.column), this.$updating || (this.$useWrapMode ? this.$updateWrapData(i, n) : this.$updateRowLengthCache(i, n)), this.$modified = !0, this._signal("changeFold", {
                            data: e,
                            action: "remove"
                        });
                    }, this.removeFolds = function(e) {
                        for(var t = [], i = 0; i < e.length; i++)t.push(e[i]);
                        t.forEach(function(e) {
                            this.removeFold(e);
                        }, this), this.$modified = !0;
                    }, this.expandFold = function(t) {
                        this.removeFold(t), t.subFolds.forEach(function(e) {
                            t.restoreRange(e), this.addFold(e);
                        }, this), 0 < t.collapseChildren && this.foldAll(t.start.row + 1, t.end.row, t.collapseChildren - 1), t.subFolds = [];
                    }, this.expandFolds = function(e) {
                        e.forEach(function(e) {
                            this.expandFold(e);
                        }, this);
                    }, this.unfold = function(e, t) {
                        var i;
                        if (null == e) i = new h(0, 0, this.getLength(), 0), null == t && (t = !0);
                        else if ("number" == typeof e) i = new h(e, 0, e, this.getLine(e).length);
                        else if ("row" in e) i = h.fromPoints(e, e);
                        else {
                            if (Array.isArray(e)) return n = [], e.forEach(function(e) {
                                n = n.concat(this.unfold(e));
                            }, this), n;
                            i = e;
                        }
                        for(var n, e = n = this.getFoldsInRangeList(i); 1 == n.length && h.comparePoints(n[0].start, i.start) < 0 && 0 < h.comparePoints(n[0].end, i.end);)this.expandFolds(n), n = this.getFoldsInRangeList(i);
                        if (0 != t ? this.removeFolds(n) : this.expandFolds(n), e.length) return e;
                    }, this.isRowFolded = function(e, t) {
                        return !!this.getFoldLine(e, t);
                    }, this.getRowFoldEnd = function(e, t) {
                        t = this.getFoldLine(e, t);
                        return t ? t.end.row : e;
                    }, this.getRowFoldStart = function(e, t) {
                        t = this.getFoldLine(e, t);
                        return t ? t.start.row : e;
                    }, this.getFoldDisplayLine = function(e, t, i, o, r) {
                        null == o && (o = e.start.row), null == r && (r = 0), null == t && (t = e.end.row), null == i && (i = this.getLine(t).length);
                        var s = this.doc, a = "";
                        return e.walk(function(e, t, i, n) {
                            if (!(t < o)) {
                                if (t == o) {
                                    if (i < r) return;
                                    n = Math.max(r, n);
                                }
                                a += null != e ? e : s.getLine(t).substring(n, i);
                            }
                        }, t, i), a;
                    }, this.getDisplayLine = function(e, t, i, n) {
                        var o = this.getFoldLine(e);
                        return o ? this.getFoldDisplayLine(o, e, t, i, n) : (o = this.doc.getLine(e)).substring(n || 0, t || o.length);
                    }, this.$cloneFoldData = function() {
                        var t = [];
                        return t = this.$foldData.map(function(e) {
                            e = e.folds.map(function(e) {
                                return e.clone();
                            });
                            return new u(t, e);
                        });
                    }, this.toggleFold = function(e) {
                        var t = this.selection.getRange();
                        if (t.isEmpty()) {
                            var i, n = t.start;
                            if (i = this.getFoldAt(n.row, n.column)) return void this.expandFold(i);
                            if (e) return void ((o = this.getFoldLine(n.row)) && this.expandFolds(o.folds));
                            (o = this.findMatchingBracket(n)) ? 1 == t.comparePoint(o) ? t.end = o : (t.start = o, t.start.column++, t.end.column--) : (o = this.findMatchingBracket({
                                row: n.row,
                                column: n.column + 1
                            })) ? (1 == t.comparePoint(o) ? t.end = o : t.start = o, t.start.column++) : t = this.getCommentFoldRange(n.row, n.column) || t;
                        } else {
                            var o = this.getFoldsInRange(t);
                            if (e && o.length) return void this.expandFolds(o);
                            1 == o.length && (i = o[0]);
                        }
                        if ((i = i || this.getFoldAt(t.start.row, t.start.column)) && i.range.toString() == t.toString()) this.expandFold(i);
                        else {
                            n = "...";
                            if (!t.isMultiLine()) {
                                if ((n = this.getTextRange(t)).length < 4) return;
                                n = n.trim().substring(0, 2) + "..";
                            }
                            this.addFold(n, t);
                        }
                    }, this.getCommentFoldRange = function(e, t, i) {
                        var n = (s = new d(this, e, t)).getCurrentToken(), o = n && n.type;
                        if (n && /^comment|string/.test(o)) {
                            "comment" == (o = o.match(/comment|string/)[0]) && (o += "|doc-start|\\.doc");
                            var r = new RegExp(o), o = new h;
                            if (1 != i) {
                                for(; (n = s.stepBackward()) && r.test(n.type););
                                n = s.stepForward();
                            }
                            o.start.row = s.getCurrentTokenRow(), o.start.column = s.getCurrentTokenColumn() + n.value.length;
                            var s = new d(this, e, t), a = this.getState(s.$row);
                            if (-1 != i) {
                                var l = -1;
                                do {
                                    if (n = s.stepForward(), -1 == l) {
                                        var c = this.getState(s.$row);
                                        a.toString() !== c.toString() && (l = s.$row);
                                    } else if (s.$row > l) break;
                                }while (n && r.test(n.type));
                                n = s.stepBackward();
                            } else n = s.getCurrentToken();
                            if (o.end.row = s.getCurrentTokenRow(), o.end.column = s.getCurrentTokenColumn(), !(o.start.row == o.end.row && o.start.column > o.end.column)) return o;
                        }
                    }, this.foldAll = function(e, t, i, n) {
                        null == i && (i = 1e5);
                        var o = this.foldWidgets;
                        if (o) {
                            t = t || this.getLength();
                            for(var r, s = e = e || 0; s < t; s++)null == o[s] && (o[s] = this.getFoldWidget(s)), "start" != o[s] || n && !n(s) || (r = this.getFoldWidgetRange(s)) && r.isMultiLine() && r.end.row <= t && r.start.row >= e && (s = r.end.row, r.collapseChildren = i, this.addFold("...", r));
                        }
                    }, this.foldToLevel = function(e) {
                        for(this.foldAll(); 0 < e--;)this.unfold(null, !1);
                    }, this.foldAllComments = function() {
                        var o = this;
                        this.foldAll(null, null, null, function(e) {
                            for(var t = o.getTokens(e), i = 0; i < t.length; i++){
                                var n = t[i];
                                if ("text" != n.type || !/^\s+$/.test(n.value)) return !!/comment/.test(n.type);
                            }
                        });
                    }, this.$foldStyles = {
                        manual: 1,
                        markbegin: 1,
                        markbeginend: 1
                    }, this.$foldStyle = "markbegin", this.setFoldStyle = function(e) {
                        if (!this.$foldStyles[e]) throw new Error("invalid fold style: " + e + "[" + Object.keys(this.$foldStyles).join(", ") + "]");
                        this.$foldStyle != e && ("manual" == (this.$foldStyle = e) && this.unfold(), e = this.$foldMode, this.$setFolding(null), this.$setFolding(e));
                    }, this.$setFolding = function(e) {
                        this.$foldMode != e && (this.$foldMode = e, this.off("change", this.$updateFoldWidgets), this.off("tokenizerUpdate", this.$tokenizerUpdateFoldWidgets), this._signal("changeAnnotation"), e && "manual" != this.$foldStyle ? (this.foldWidgets = [], this.getFoldWidget = e.getFoldWidget.bind(e, this, this.$foldStyle), this.getFoldWidgetRange = e.getFoldWidgetRange.bind(e, this, this.$foldStyle), this.$updateFoldWidgets = this.updateFoldWidgets.bind(this), this.$tokenizerUpdateFoldWidgets = this.tokenizerUpdateFoldWidgets.bind(this), this.on("change", this.$updateFoldWidgets), this.on("tokenizerUpdate", this.$tokenizerUpdateFoldWidgets)) : this.foldWidgets = null);
                    }, this.getParentFoldRangeData = function(e, t) {
                        var i = this.foldWidgets;
                        if (!i || t && i[e]) return {};
                        for(var n = e - 1; 0 <= n;){
                            var o = i[n];
                            if ("start" == (o = null == o ? i[n] = this.getFoldWidget(n) : o)) {
                                var r = this.getFoldWidgetRange(n), s = s || r;
                                if (r && r.end.row >= e) break;
                            }
                            n--;
                        }
                        return {
                            range: -1 !== n && r,
                            firstRange: s
                        };
                    }, this.onFoldWidgetClick = function(e, t) {
                        var i = {
                            children: (t = t instanceof n ? t.domEvent : t).shiftKey,
                            all: t.ctrlKey || t.metaKey,
                            siblings: t.altKey
                        };
                        this.$toggleFoldWidget(e, i) || (e = t.target || t.srcElement) && /ace_fold-widget/.test(e.className) && (e.className += " ace_invalid");
                    }, this.$toggleFoldWidget = function(e, t) {
                        var i, n, o, r;
                        if (this.getFoldWidget) return i = this.getFoldWidget(e), n = this.getLine(e), (n = this.getFoldAt(e, -1 == (i = "end" === i ? -1 : 1) ? 0 : n.length, i)) ? (t.children || t.all ? this.removeFold(n) : this.expandFold(n), n) : (i = this.getFoldWidgetRange(e, !0)) && !i.isMultiLine() && (n = this.getFoldAt(i.start.row, i.start.column, 1)) && i.isEqual(n.range) ? (this.removeFold(n), n) : (t.siblings ? ((n = this.getParentFoldRangeData(e)).range && (o = n.range.start.row + 1, r = n.range.end.row), this.foldAll(o, r, t.all ? 1e4 : 0)) : t.children ? (r = i ? i.end.row : this.getLength(), this.foldAll(e + 1, r, t.all ? 1e4 : 0)) : i && (t.all && (i.collapseChildren = 1e4), this.addFold("...", i)), i);
                    }, this.toggleFoldWidget = function(e) {
                        var t, i = this.selection.getCursor().row;
                        i = this.getRowFoldStart(i), !this.$toggleFoldWidget(i, {}) && (t = (t = this.getParentFoldRangeData(i, !0)).range || t.firstRange) && (i = t.start.row, (i = this.getFoldAt(i, this.getLine(i).length, 1)) ? this.removeFold(i) : this.addFold("...", t));
                    }, this.updateFoldWidgets = function(e) {
                        var t = e.start.row, i = e.end.row - t;
                        0 == i ? this.foldWidgets[t] = null : "remove" == e.action ? this.foldWidgets.splice(t, 1 + i, null) : ((e = Array(1 + i)).unshift(t, 1), this.foldWidgets.splice.apply(this.foldWidgets, e));
                    }, this.tokenizerUpdateFoldWidgets = function(e) {
                        e = e.data;
                        e.first != e.last && this.foldWidgets.length > e.first && this.foldWidgets.splice(e.first, this.foldWidgets.length);
                    };
                };
            }), ace.define("ace/edit_session/bracket_match", [
                "require",
                "exports",
                "module",
                "ace/token_iterator",
                "ace/range"
            ], function(e, t, i) {
                var d = e("../token_iterator").TokenIterator, C = e("../range").Range;
                t.BracketMatch = function() {
                    this.findMatchingBracket = function(e, t) {
                        return 0 != e.column && "" != (t = t || this.getLine(e.row).charAt(e.column - 1)) && (t = t.match(/([\(\[\{])|([\)\]\}])/)) ? t[1] ? this.$findClosingBracket(t[1], e) : this.$findOpeningBracket(t[2], e) : null;
                    }, this.getBracketRange = function(e) {
                        var t, i, n = this.getLine(e.row), o = !0, r = n.charAt(e.column - 1), s = r && r.match(/([\(\[\{])|([\)\]\}])/);
                        if (s || (r = n.charAt(e.column), e = {
                            row: e.row,
                            column: e.column + 1
                        }, s = r && r.match(/([\(\[\{])|([\)\]\}])/), o = !1), !s) return null;
                        if (s[1]) {
                            if (!(i = this.$findClosingBracket(s[1], e))) return null;
                            t = C.fromPoints(e, i), o || (t.end.column++, t.start.column--), t.cursor = t.end;
                        } else {
                            if (!(i = this.$findOpeningBracket(s[2], e))) return null;
                            t = C.fromPoints(i, e), o || (t.start.column++, t.end.column--), t.cursor = t.start;
                        }
                        return t;
                    }, this.getMatchingBracketRanges = function(e, t) {
                        var i = this.getLine(e.row), n = /([\(\[\{])|([\)\]\}])/, o = !t && i.charAt(e.column - 1), r = o && o.match(n);
                        return r || (o = (void 0 === t || t) && i.charAt(e.column), e = {
                            row: e.row,
                            column: e.column + 1
                        }, r = o && o.match(n)), r ? (t = new C(e.row, e.column - 1, e.row, e.column), (i = r[1] ? this.$findClosingBracket(r[1], e) : this.$findOpeningBracket(r[2], e)) ? [
                            t,
                            new C(i.row, i.column, i.row, i.column + 1)
                        ] : [
                            t
                        ]) : null;
                    }, this.$brackets = {
                        ")": "(",
                        "(": ")",
                        "]": "[",
                        "[": "]",
                        "{": "}",
                        "}": "{",
                        "<": ">",
                        ">": "<"
                    }, this.$findOpeningBracket = function(e, t, i) {
                        var n = this.$brackets[e], o = 1, r = new d(this, t.row, t.column), s = r.getCurrentToken();
                        if (s = s || r.stepForward()) {
                            i = i || new RegExp("(\\.?" + s.type.replace(".", "\\.").replace("rparen", ".paren").replace(/\b(?:end)\b/, "(?:start|begin|end)").replace(/-close\b/, "-(close|open)") + ")+");
                            for(var a = t.column - r.getCurrentTokenColumn() - 2, l = s.value;;){
                                for(; 0 <= a;){
                                    var c = l.charAt(a);
                                    if (c == n) {
                                        if (0 == --o) return {
                                            row: r.getCurrentTokenRow(),
                                            column: a + r.getCurrentTokenColumn()
                                        };
                                    } else c == e && (o += 1);
                                    --a;
                                }
                                for(; (s = r.stepBackward()) && !i.test(s.type););
                                if (null == s) break;
                                a = (l = s.value).length - 1;
                            }
                            return null;
                        }
                    }, this.$findClosingBracket = function(e, t, i) {
                        var n = this.$brackets[e], o = 1, r = new d(this, t.row, t.column), s = r.getCurrentToken();
                        if (s = s || r.stepForward()) {
                            i = i || new RegExp("(\\.?" + s.type.replace(".", "\\.").replace("lparen", ".paren").replace(/\b(?:start|begin)\b/, "(?:start|begin|end)").replace(/-open\b/, "-(close|open)") + ")+");
                            for(var a = t.column - r.getCurrentTokenColumn();;){
                                for(var l = s.value, c = l.length; a < c;){
                                    var h = l.charAt(a);
                                    if (h == n) {
                                        if (0 == --o) return {
                                            row: r.getCurrentTokenRow(),
                                            column: a + r.getCurrentTokenColumn()
                                        };
                                    } else h == e && (o += 1);
                                    a += 1;
                                }
                                for(; (s = r.stepForward()) && !i.test(s.type););
                                if (null == s) break;
                                a = 0;
                            }
                            return null;
                        }
                    }, this.getMatchingTags = function(e) {
                        var e = new d(this, e.row, e.column), t = this.$findTagName(e);
                        if (t) return "<" === e.stepBackward().value ? this.$findClosingTag(e, t) : this.$findOpeningTag(e, t);
                    }, this.$findTagName = function(e) {
                        var t = e.getCurrentToken(), i = !1, n = !1;
                        if (t && -1 === t.type.indexOf("tag-name")) for(; (t = n ? e.stepBackward() : e.stepForward()) && ("/>" === t.value ? n = !0 : -1 !== t.type.indexOf("tag-name") && (i = !0)), t && !i;);
                        return t;
                    }, this.$findClosingTag = function(e, t) {
                        var i = t.value, n = t.value, o = 0, r = new C(e.getCurrentTokenRow(), e.getCurrentTokenColumn(), e.getCurrentTokenRow(), e.getCurrentTokenColumn() + 1), s = (t = e.stepForward(), new C(e.getCurrentTokenRow(), e.getCurrentTokenColumn(), e.getCurrentTokenRow(), e.getCurrentTokenColumn() + t.value.length)), a = !1;
                        do {
                            var l, c = t;
                            if (-1 === c.type.indexOf("tag-close") || a || (l = new C(e.getCurrentTokenRow(), e.getCurrentTokenColumn(), e.getCurrentTokenRow(), e.getCurrentTokenColumn() + 1), a = !0), t = e.stepForward()) {
                                if (">" !== t.value || a || (l = new C(e.getCurrentTokenRow(), e.getCurrentTokenColumn(), e.getCurrentTokenRow(), e.getCurrentTokenColumn() + 1), a = !0), -1 !== t.type.indexOf("tag-name")) {
                                    if (n === (i = t.value)) {
                                        if ("<" === c.value) o++;
                                        else if ("</" === c.value && --o < 0) {
                                            e.stepBackward();
                                            var h = new C(e.getCurrentTokenRow(), e.getCurrentTokenColumn(), e.getCurrentTokenRow(), e.getCurrentTokenColumn() + 2), d = (t = e.stepForward(), new C(e.getCurrentTokenRow(), e.getCurrentTokenColumn(), e.getCurrentTokenRow(), e.getCurrentTokenColumn() + t.value.length));
                                            if (!(t = -1 === t.type.indexOf("tag-close") ? e.stepForward() : t) || ">" !== t.value) return;
                                            var u = new C(e.getCurrentTokenRow(), e.getCurrentTokenColumn(), e.getCurrentTokenRow(), e.getCurrentTokenColumn() + 1);
                                        }
                                    }
                                } else n === i && "/>" === t.value && --o < 0 && (u = d = h = new C(e.getCurrentTokenRow(), e.getCurrentTokenColumn(), e.getCurrentTokenRow(), e.getCurrentTokenColumn() + 2), l = new C(s.end.row, s.end.column, s.end.row, s.end.column + 1));
                            }
                        }while (t && 0 <= o);
                        if (r && l && h && u && s && d) return {
                            openTag: new C(r.start.row, r.start.column, l.end.row, l.end.column),
                            closeTag: new C(h.start.row, h.start.column, u.end.row, u.end.column),
                            openTagName: s,
                            closeTagName: d
                        };
                    }, this.$findOpeningTag = function(e, t) {
                        var i, n = e.getCurrentToken(), o = t.value, r = 0, s = e.getCurrentTokenRow(), a = e.getCurrentTokenColumn(), l = new C(s, a, s, a + 2), c = (e.stepForward(), new C(e.getCurrentTokenRow(), e.getCurrentTokenColumn(), e.getCurrentTokenRow(), e.getCurrentTokenColumn() + t.value.length));
                        if ((t = -1 === t.type.indexOf("tag-close") ? e.stepForward() : t) && ">" === t.value) {
                            var h = new C(e.getCurrentTokenRow(), e.getCurrentTokenColumn(), e.getCurrentTokenRow(), e.getCurrentTokenColumn() + 1);
                            e.stepBackward(), e.stepBackward();
                            do if (t = n, s = e.getCurrentTokenRow(), i = (a = e.getCurrentTokenColumn()) + t.value.length, n = e.stepBackward(), t) {
                                if (-1 !== t.type.indexOf("tag-name")) {
                                    if (o === t.value) {
                                        if ("<" === n.value) {
                                            if (0 < ++r) {
                                                for(var d = new C(s, a, s, i), u = new C(e.getCurrentTokenRow(), e.getCurrentTokenColumn(), e.getCurrentTokenRow(), e.getCurrentTokenColumn() + 1); (t = e.stepForward()) && ">" !== t.value;);
                                                var g = new C(e.getCurrentTokenRow(), e.getCurrentTokenColumn(), e.getCurrentTokenRow(), e.getCurrentTokenColumn() + 1);
                                            }
                                        } else "</" === n.value && r--;
                                    }
                                } else if ("/>" === t.value) {
                                    for(var p = 0, m = n; m;){
                                        if (-1 !== m.type.indexOf("tag-name") && m.value === o) {
                                            r--;
                                            break;
                                        }
                                        if ("<" === m.value) break;
                                        m = e.stepBackward(), p++;
                                    }
                                    for(var f = 0; f < p; f++)e.stepForward();
                                }
                            }
                            while (n && r <= 0);
                            return u && g && l && h && d && c ? {
                                openTag: new C(u.start.row, u.start.column, g.end.row, g.end.column),
                                closeTag: new C(l.start.row, l.start.column, h.end.row, h.end.column),
                                openTagName: d,
                                closeTagName: c
                            } : void 0;
                        }
                    };
                };
            }), ace.define("ace/edit_session", [
                "require",
                "exports",
                "module",
                "ace/lib/oop",
                "ace/lib/lang",
                "ace/bidihandler",
                "ace/config",
                "ace/lib/event_emitter",
                "ace/selection",
                "ace/mode/text",
                "ace/range",
                "ace/line_widgets",
                "ace/document",
                "ace/background_tokenizer",
                "ace/search_highlight",
                "ace/undomanager",
                "ace/edit_session/folding",
                "ace/edit_session/bracket_match"
            ], function(e, t, i) {
                var n = e("./lib/oop"), o = e("./lib/lang"), r = e("./bidihandler").BidiHandler, s = e("./config"), a = e("./lib/event_emitter").EventEmitter, l = e("./selection").Selection, c = e("./mode/text").Mode, h = e("./range").Range, d = e("./line_widgets").LineWidgets, u = e("./document").Document, g = e("./background_tokenizer").BackgroundTokenizer, p = e("./search_highlight").SearchHighlight, m = e("./undomanager").UndoManager, f = (C.prototype.$initOperationListeners = function() {
                    var e = this;
                    this.curOp = null, this.on("change", function() {
                        e.curOp || (e.startOperation(), e.curOp.selectionBefore = e.$lastSel), e.curOp.docChanged = !0;
                    }, !0), this.on("changeSelection", function() {
                        e.curOp || (e.startOperation(), e.curOp.selectionBefore = e.$lastSel), e.curOp.selectionChanged = !0;
                    }, !0), this.$operationResetTimer = o.delayedCall(this.endOperation.bind(this, !0));
                }, C.prototype.startOperation = function(e) {
                    if (this.curOp) {
                        if (!e || this.curOp.command) return;
                        this.prevOp = this.curOp;
                    }
                    e = e || {}, this.$operationResetTimer.schedule(), this.curOp = {
                        command: e.command || {},
                        args: e.args
                    }, this.curOp.selectionBefore = this.selection.toJSON(), this._signal("startOperation", e);
                }, C.prototype.endOperation = function(e) {
                    var t;
                    this.curOp && (e && !1 === e.returnValue ? (this.curOp = null, this._signal("endOperation", e)) : 1 == e && this.curOp.command && "mouse" == this.curOp.command.name || (t = this.selection.toJSON(), this.curOp.selectionAfter = t, this.$lastSel = this.selection.toJSON(), this.getUndoManager().addSelection(t), this._signal("beforeEndOperation"), this.prevOp = this.curOp, this.curOp = null, this._signal("endOperation", e)));
                }, C.prototype.setDocument = function(e) {
                    this.doc && this.doc.off("change", this.$onChange), (this.doc = e).on("change", this.$onChange, !0), this.bgTokenizer.setDocument(this.getDocument()), this.resetCaches();
                }, C.prototype.getDocument = function() {
                    return this.doc;
                }, Object.defineProperty(C.prototype, "widgetManager", {
                    get: function() {
                        var e = new d(this);
                        return this.widgetManager = e, this.$editor && e.attach(this.$editor), e;
                    },
                    set: function(e) {
                        Object.defineProperty(this, "widgetManager", {
                            writable: !0,
                            enumerable: !0,
                            configurable: !0,
                            value: e
                        });
                    },
                    enumerable: !1,
                    configurable: !0
                }), C.prototype.$resetRowCache = function(e) {
                    var t;
                    e ? (t = this.$docRowCache.length, (e = this.$getRowCacheIndex(this.$docRowCache, e) + 1) < t && (this.$docRowCache.splice(e, t), this.$screenRowCache.splice(e, t))) : (this.$docRowCache = [], this.$screenRowCache = []);
                }, C.prototype.$getRowCacheIndex = function(e, t) {
                    for(var i = 0, n = e.length - 1; i <= n;){
                        var o = i + n >> 1, r = e[o];
                        if (r < t) i = 1 + o;
                        else {
                            if (!(t < r)) return o;
                            n = o - 1;
                        }
                    }
                    return i - 1;
                }, C.prototype.resetCaches = function() {
                    this.$modified = !0, this.$wrapData = [], this.$rowLengthCache = [], this.$resetRowCache(0), this.destroyed || this.bgTokenizer.start(0);
                }, C.prototype.onChangeFold = function(e) {
                    e = e.data;
                    this.$resetRowCache(e.start.row);
                }, C.prototype.onChange = function(e) {
                    this.$modified = !0, this.$bidiHandler.onChange(e), this.$resetRowCache(e.start.row);
                    var t = this.$updateInternalDataOnChange(e);
                    !this.$fromUndo && this.$undoManager && (t && t.length && (this.$undoManager.add({
                        action: "removeFolds",
                        folds: t
                    }, this.mergeUndoDeltas), this.mergeUndoDeltas = !0), this.$undoManager.add(e, this.mergeUndoDeltas), this.mergeUndoDeltas = !0, this.$informUndoManager.schedule()), this.bgTokenizer.$updateOnChange(e), this._signal("change", e);
                }, C.prototype.onSelectionChange = function() {
                    this._signal("changeSelection");
                }, C.prototype.setValue = function(e) {
                    this.doc.setValue(e), this.selection.moveTo(0, 0), this.$resetRowCache(0), this.setUndoManager(this.$undoManager), this.getUndoManager().reset();
                }, C.fromJSON = function(e) {
                    "string" == typeof e && (e = JSON.parse(e));
                    var t = new m, i = (t.$undoStack = e.history.undo, t.$redoStack = e.history.redo, t.mark = e.history.mark, t.$rev = e.history.rev, new C(e.value));
                    return e.folds.forEach(function(e) {
                        i.addFold("...", h.fromPoints(e.start, e.end));
                    }), i.setAnnotations(e.annotations), i.setBreakpoints(e.breakpoints), i.setMode(e.mode), i.setScrollLeft(e.scrollLeft), i.setScrollTop(e.scrollTop), i.setUndoManager(t), i.selection.fromJSON(e.selection), i;
                }, C.prototype.toJSON = function() {
                    return {
                        annotations: this.$annotations,
                        breakpoints: this.$breakpoints,
                        folds: this.getAllFolds().map(function(e) {
                            return e.range;
                        }),
                        history: this.getUndoManager(),
                        mode: this.$mode.$id,
                        scrollLeft: this.$scrollLeft,
                        scrollTop: this.$scrollTop,
                        selection: this.selection.toJSON(),
                        value: this.doc.getValue()
                    };
                }, C.prototype.toString = function() {
                    return this.doc.getValue();
                }, C.prototype.getSelection = function() {
                    return this.selection;
                }, C.prototype.getState = function(e) {
                    return this.bgTokenizer.getState(e);
                }, C.prototype.getTokens = function(e) {
                    return this.bgTokenizer.getTokens(e);
                }, C.prototype.getTokenAt = function(e, t) {
                    var i = this.bgTokenizer.getTokens(e), n = 0;
                    if (null == t) var o = i.length - 1, n = this.getLine(e).length;
                    else for(o = 0; o < i.length && !(t <= (n += i[o].value.length)); o++);
                    return (e = i[o]) ? (e.index = o, e.start = n - e.value.length, e) : null;
                }, C.prototype.setUndoManager = function(e) {
                    var t;
                    this.$undoManager = e, this.$informUndoManager && this.$informUndoManager.cancel(), e ? (e.addSession(t = this), this.$syncInformUndoManager = function() {
                        t.$informUndoManager.cancel(), t.mergeUndoDeltas = !1;
                    }, this.$informUndoManager = o.delayedCall(this.$syncInformUndoManager)) : this.$syncInformUndoManager = function() {};
                }, C.prototype.markUndoGroup = function() {
                    this.$syncInformUndoManager && this.$syncInformUndoManager();
                }, C.prototype.getUndoManager = function() {
                    return this.$undoManager || this.$defaultUndoManager;
                }, C.prototype.getTabString = function() {
                    return this.getUseSoftTabs() ? o.stringRepeat(" ", this.getTabSize()) : "\t";
                }, C.prototype.setUseSoftTabs = function(e) {
                    this.setOption("useSoftTabs", e);
                }, C.prototype.getUseSoftTabs = function() {
                    return this.$useSoftTabs && !this.$mode.$indentWithTabs;
                }, C.prototype.setTabSize = function(e) {
                    this.setOption("tabSize", e);
                }, C.prototype.getTabSize = function() {
                    return this.$tabSize;
                }, C.prototype.isTabStop = function(e) {
                    return this.$useSoftTabs && e.column % this.$tabSize == 0;
                }, C.prototype.setNavigateWithinSoftTabs = function(e) {
                    this.setOption("navigateWithinSoftTabs", e);
                }, C.prototype.getNavigateWithinSoftTabs = function() {
                    return this.$navigateWithinSoftTabs;
                }, C.prototype.setOverwrite = function(e) {
                    this.setOption("overwrite", e);
                }, C.prototype.getOverwrite = function() {
                    return this.$overwrite;
                }, C.prototype.toggleOverwrite = function() {
                    this.setOverwrite(!this.$overwrite);
                }, C.prototype.addGutterDecoration = function(e, t) {
                    this.$decorations[e] || (this.$decorations[e] = ""), this.$decorations[e] += " " + t, this._signal("changeBreakpoint", {});
                }, C.prototype.removeGutterCustomWidget = function(e) {
                    this.$editor && this.$editor.renderer.$gutterLayer.$removeCustomWidget(e);
                }, C.prototype.addGutterCustomWidget = function(e, t) {
                    this.$editor && this.$editor.renderer.$gutterLayer.$addCustomWidget(e, t);
                }, C.prototype.removeGutterDecoration = function(e, t) {
                    this.$decorations[e] = (this.$decorations[e] || "").replace(" " + t, ""), this._signal("changeBreakpoint", {});
                }, C.prototype.getBreakpoints = function() {
                    return this.$breakpoints;
                }, C.prototype.setBreakpoints = function(e) {
                    this.$breakpoints = [];
                    for(var t = 0; t < e.length; t++)this.$breakpoints[e[t]] = "ace_breakpoint";
                    this._signal("changeBreakpoint", {});
                }, C.prototype.clearBreakpoints = function() {
                    this.$breakpoints = [], this._signal("changeBreakpoint", {});
                }, C.prototype.setBreakpoint = function(e, t) {
                    (t = void 0 === t ? "ace_breakpoint" : t) ? this.$breakpoints[e] = t : delete this.$breakpoints[e], this._signal("changeBreakpoint", {});
                }, C.prototype.clearBreakpoint = function(e) {
                    delete this.$breakpoints[e], this._signal("changeBreakpoint", {});
                }, C.prototype.addMarker = function(e, t, i, n) {
                    var o = this.$markerId++, e = {
                        range: e,
                        type: i || "line",
                        renderer: "function" == typeof i ? i : null,
                        clazz: t,
                        inFront: !!n,
                        id: o
                    };
                    return n ? (this.$frontMarkers[o] = e, this._signal("changeFrontMarker")) : (this.$backMarkers[o] = e, this._signal("changeBackMarker")), o;
                }, C.prototype.addDynamicMarker = function(e, t) {
                    var i;
                    if (e.update) return i = this.$markerId++, e.id = i, e.inFront = !!t, t ? (this.$frontMarkers[i] = e, this._signal("changeFrontMarker")) : (this.$backMarkers[i] = e, this._signal("changeBackMarker")), e;
                }, C.prototype.removeMarker = function(e) {
                    var t = this.$frontMarkers[e] || this.$backMarkers[e];
                    t && (delete (t.inFront ? this.$frontMarkers : this.$backMarkers)[e], this._signal(t.inFront ? "changeFrontMarker" : "changeBackMarker"));
                }, C.prototype.getMarkers = function(e) {
                    return e ? this.$frontMarkers : this.$backMarkers;
                }, C.prototype.highlight = function(e) {
                    var t;
                    this.$searchHighlight || (t = new p(null, "ace_selected-word", "text"), this.$searchHighlight = this.addDynamicMarker(t)), this.$searchHighlight.setRegexp(e);
                }, C.prototype.highlightLines = function(e, t, i, n) {
                    "number" != typeof t && (i = t, t = e), i = i || "ace_step";
                    e = new h(e, 0, t, 1 / 0);
                    return e.id = this.addMarker(e, i, "fullLine", n), e;
                }, C.prototype.setAnnotations = function(e) {
                    this.$annotations = e, this._signal("changeAnnotation", {});
                }, C.prototype.getAnnotations = function() {
                    return this.$annotations || [];
                }, C.prototype.clearAnnotations = function() {
                    this.setAnnotations([]);
                }, C.prototype.$detectNewLine = function(e) {
                    e = e.match(/^.*?(\r?\n)/m);
                    this.$autoNewLine = e ? e[1] : "\n";
                }, C.prototype.getWordRange = function(e, t) {
                    var i, n = this.getLine(e), o = !1, r = (i = (o = (o = 0 < t ? !!n.charAt(t - 1).match(this.tokenRe) : o) || !!n.charAt(t).match(this.tokenRe)) ? this.tokenRe : /^\s+$/.test(n.slice(t - 1, t + 1)) ? /\s/ : this.nonTokenRe, t);
                    if (0 < r) {
                        for(; 0 <= --r && n.charAt(r).match(i););
                        r++;
                    }
                    for(var s = t; s < n.length && n.charAt(s).match(i);)s++;
                    return new h(e, r, e, s);
                }, C.prototype.getAWordRange = function(e, t) {
                    for(var i = this.getWordRange(e, t), n = this.getLine(i.end.row); n.charAt(i.end.column).match(/[ \t]/);)i.end.column += 1;
                    return i;
                }, C.prototype.setNewLineMode = function(e) {
                    this.doc.setNewLineMode(e);
                }, C.prototype.getNewLineMode = function() {
                    return this.doc.getNewLineMode();
                }, C.prototype.setUseWorker = function(e) {
                    this.setOption("useWorker", e);
                }, C.prototype.getUseWorker = function() {
                    return this.$useWorker;
                }, C.prototype.onReloadTokenizer = function(e) {
                    var t = e.data;
                    this.bgTokenizer.start(t.first), this._signal("tokenizerUpdate", e);
                }, C.prototype.setMode = function(e, t) {
                    if (e && "object" == typeof e) {
                        if (e.getTokenizer) return this.$onChangeMode(e);
                        var i = e, n = i.path;
                    } else n = e || "ace/mode/text";
                    this.$modes["ace/mode/text"] || (this.$modes["ace/mode/text"] = new c), this.$modes[n] && !i ? (this.$onChangeMode(this.$modes[n]), t && t()) : (this.$modeId = n, s.loadModule([
                        "mode",
                        n
                    ], (function(e) {
                        if (!this.destroyed) {
                            if (this.$modeId !== n) return t && t();
                            this.$modes[n] && !i ? this.$onChangeMode(this.$modes[n]) : e && e.Mode && (e = new e.Mode(i), i || ((this.$modes[n] = e).$id = n), this.$onChangeMode(e)), t && t();
                        }
                    }).bind(this)), this.$mode || this.$onChangeMode(this.$modes["ace/mode/text"], !0));
                }, C.prototype.$onChangeMode = function(e, t) {
                    var i, n, o;
                    t || (this.$modeId = e.$id), this.$mode === e || (i = this.$mode, this.$mode = e, this.$stopWorker(), this.$useWorker && this.$startWorker(), void 0 !== (n = e.getTokenizer()).on && (o = this.onReloadTokenizer.bind(this), n.on("update", o)), this.bgTokenizer.setTokenizer(n), this.bgTokenizer.setDocument(this.getDocument()), this.tokenRe = e.tokenRe, this.nonTokenRe = e.nonTokenRe, t) || (e.attachToSession && e.attachToSession(this), this.$options.wrapMethod.set.call(this, this.$wrapMethod), this.$setFolding(e.foldingRules), this.bgTokenizer.start(0), this._emit("changeMode", {
                        oldMode: i,
                        mode: e
                    }));
                }, C.prototype.$stopWorker = function() {
                    this.$worker && (this.$worker.terminate(), this.$worker = null);
                }, C.prototype.$startWorker = function() {
                    try {
                        this.$worker = this.$mode.createWorker(this);
                    } catch (e) {
                        s.warn("Could not load worker", e), this.$worker = null;
                    }
                }, C.prototype.getMode = function() {
                    return this.$mode;
                }, C.prototype.setScrollTop = function(e) {
                    this.$scrollTop === e || isNaN(e) || (this.$scrollTop = e, this._signal("changeScrollTop", e));
                }, C.prototype.getScrollTop = function() {
                    return this.$scrollTop;
                }, C.prototype.setScrollLeft = function(e) {
                    this.$scrollLeft === e || isNaN(e) || (this.$scrollLeft = e, this._signal("changeScrollLeft", e));
                }, C.prototype.getScrollLeft = function() {
                    return this.$scrollLeft;
                }, C.prototype.getScreenWidth = function() {
                    return this.$computeWidth(), this.lineWidgets ? Math.max(this.getLineWidgetMaxWidth(), this.screenWidth) : this.screenWidth;
                }, C.prototype.getLineWidgetMaxWidth = function() {
                    var t;
                    return null != this.lineWidgetsWidth ? this.lineWidgetsWidth : (t = 0, this.lineWidgets.forEach(function(e) {
                        e && e.screenWidth > t && (t = e.screenWidth);
                    }), this.lineWidgetWidth = t);
                }, C.prototype.$computeWidth = function(e) {
                    if (this.$modified || e) {
                        if (this.$modified = !1, this.$useWrapMode) return this.screenWidth = this.$wrapLimit;
                        for(var t = this.doc.getAllLines(), i = this.$rowLengthCache, n = 0, o = 0, r = this.$foldData[o], s = r ? r.start.row : 1 / 0, a = t.length, l = 0; l < a; l++){
                            if (s < l) {
                                if (a <= (l = r.end.row + 1)) break;
                                s = (r = this.$foldData[o++]) ? r.start.row : 1 / 0;
                            }
                            null == i[l] && (i[l] = this.$getStringScreenWidth(t[l])[0]), i[l] > n && (n = i[l]);
                        }
                        this.screenWidth = n;
                    }
                }, C.prototype.getLine = function(e) {
                    return this.doc.getLine(e);
                }, C.prototype.getLines = function(e, t) {
                    return this.doc.getLines(e, t);
                }, C.prototype.getLength = function() {
                    return this.doc.getLength();
                }, C.prototype.getTextRange = function(e) {
                    return this.doc.getTextRange(e || this.selection.getRange());
                }, C.prototype.insert = function(e, t) {
                    return this.doc.insert(e, t);
                }, C.prototype.remove = function(e) {
                    return this.doc.remove(e);
                }, C.prototype.removeFullLines = function(e, t) {
                    return this.doc.removeFullLines(e, t);
                }, C.prototype.undoChanges = function(e, t) {
                    if (e.length) {
                        this.$fromUndo = !0;
                        for(var i = e.length - 1; -1 != i; i--){
                            var n = e[i];
                            "insert" == n.action || "remove" == n.action ? this.doc.revertDelta(n) : n.folds && this.addFolds(n.folds);
                        }
                        !t && this.$undoSelect && (e.selectionBefore ? this.selection.fromJSON(e.selectionBefore) : this.selection.setRange(this.$getUndoSelection(e, !0))), this.$fromUndo = !1;
                    }
                }, C.prototype.redoChanges = function(e, t) {
                    if (e.length) {
                        this.$fromUndo = !0;
                        for(var i = 0; i < e.length; i++){
                            var n = e[i];
                            "insert" != n.action && "remove" != n.action || this.doc.$safeApplyDelta(n);
                        }
                        !t && this.$undoSelect && (e.selectionAfter ? this.selection.fromJSON(e.selectionAfter) : this.selection.setRange(this.$getUndoSelection(e, !1))), this.$fromUndo = !1;
                    }
                }, C.prototype.setUndoSelect = function(e) {
                    this.$undoSelect = e;
                }, C.prototype.$getUndoSelection = function(e, t) {
                    function i(e) {
                        return t ? "insert" !== e.action : "insert" === e.action;
                    }
                    for(var n, o, r = 0; r < e.length; r++){
                        var s = e[r];
                        s.start && (n ? i(s) ? (o = s.start, -1 == n.compare(o.row, o.column) && n.setStart(o), o = s.end, 1 == n.compare(o.row, o.column) && n.setEnd(o)) : (o = s.start, -1 == n.compare(o.row, o.column) && (n = h.fromPoints(s.start, s.start))) : n = i(s) ? h.fromPoints(s.start, s.end) : h.fromPoints(s.start, s.start));
                    }
                    return n;
                }, C.prototype.replace = function(e, t) {
                    return this.doc.replace(e, t);
                }, C.prototype.moveText = function(e, t, i) {
                    var n, o, r, s = this.getTextRange(e), a = this.getFoldsInRange(e), t = h.fromPoints(t, t);
                    return i || (this.remove(e), o = e.start.row - e.end.row, (r = o ? -e.end.column : e.start.column - e.end.column) && (t.start.row == e.end.row && t.start.column > e.end.column && (t.start.column += r), t.end.row == e.end.row) && t.end.column > e.end.column && (t.end.column += r), o && t.start.row >= e.end.row && (t.start.row += o, t.end.row += o)), t.end = this.insert(t.start, s), a.length && (n = e.start, i = t.start, o = i.row - n.row, r = i.column - n.column, this.addFolds(a.map(function(e) {
                        return (e = e.clone()).start.row == n.row && (e.start.column += r), e.end.row == n.row && (e.end.column += r), e.start.row += o, e.end.row += o, e;
                    }))), t;
                }, C.prototype.indentRows = function(e, t, i) {
                    i = i.replace(/\t/g, this.getTabString());
                    for(var n = e; n <= t; n++)this.doc.insertInLine({
                        row: n,
                        column: 0
                    }, i);
                }, C.prototype.outdentRows = function(e) {
                    for(var t = e.collapseRows(), i = new h(0, 0, 0, 0), n = this.getTabSize(), o = t.start.row; o <= t.end.row; ++o){
                        var r = this.getLine(o);
                        i.start.row = o, i.end.row = o;
                        for(var s = 0; s < n && " " == r.charAt(s); ++s);
                        s < n && "\t" == r.charAt(s) ? (i.start.column = s, i.end.column = s + 1) : (i.start.column = 0, i.end.column = s), this.remove(i);
                    }
                }, C.prototype.$moveLines = function(e, t, i) {
                    if (e = this.getRowFoldStart(e), t = this.getRowFoldEnd(t), i < 0) {
                        if ((o = this.getRowFoldStart(e + i)) < 0) return 0;
                        var n = o - e;
                    } else if (0 < i) {
                        if ((o = this.getRowFoldEnd(t + i)) > this.doc.getLength() - 1) return 0;
                        n = o - t;
                    } else {
                        e = this.$clipRowToDocument(e);
                        n = (t = this.$clipRowToDocument(t)) - e + 1;
                    }
                    var o = new h(e, 0, t, Number.MAX_VALUE), o = this.getFoldsInRange(o).map(function(e) {
                        return (e = e.clone()).start.row += n, e.end.row += n, e;
                    }), i = 0 == i ? this.doc.getLines(e, t) : this.doc.removeFullLines(e, t);
                    return this.doc.insertFullLines(e + n, i), o.length && this.addFolds(o), n;
                }, C.prototype.moveLinesUp = function(e, t) {
                    return this.$moveLines(e, t, -1);
                }, C.prototype.moveLinesDown = function(e, t) {
                    return this.$moveLines(e, t, 1);
                }, C.prototype.duplicateLines = function(e, t) {
                    return this.$moveLines(e, t, 0);
                }, C.prototype.$clipRowToDocument = function(e) {
                    return Math.max(0, Math.min(e, this.doc.getLength() - 1));
                }, C.prototype.$clipColumnToRow = function(e, t) {
                    return t < 0 ? 0 : Math.min(this.doc.getLine(e).length, t);
                }, C.prototype.$clipPositionToDocument = function(e, t) {
                    var i;
                    return t = Math.max(0, t), t = e < 0 ? e = 0 : (i = this.doc.getLength()) <= e ? this.doc.getLine(e = i - 1).length : Math.min(this.doc.getLine(e).length, t), {
                        row: e,
                        column: t
                    };
                }, C.prototype.$clipRangeToDocument = function(e) {
                    e.start.row < 0 ? (e.start.row = 0, e.start.column = 0) : e.start.column = this.$clipColumnToRow(e.start.row, e.start.column);
                    var t = this.doc.getLength() - 1;
                    return e.end.row > t ? (e.end.row = t, e.end.column = this.doc.getLine(t).length) : e.end.column = this.$clipColumnToRow(e.end.row, e.end.column), e;
                }, C.prototype.setUseWrapMode = function(e) {
                    e != this.$useWrapMode && (this.$useWrapMode = e, this.$modified = !0, this.$resetRowCache(0), e && (e = this.getLength(), this.$wrapData = Array(e), this.$updateWrapData(0, e - 1)), this._signal("changeWrapMode"));
                }, C.prototype.getUseWrapMode = function() {
                    return this.$useWrapMode;
                }, C.prototype.setWrapLimitRange = function(e, t) {
                    this.$wrapLimitRange.min === e && this.$wrapLimitRange.max === t || (this.$wrapLimitRange = {
                        min: e,
                        max: t
                    }, this.$modified = !0, this.$bidiHandler.markAsDirty(), this.$useWrapMode && this._signal("changeWrapMode"));
                }, C.prototype.adjustWrapLimit = function(e, t) {
                    var i = this.$wrapLimitRange, t = (i.max < 0 && (i = {
                        min: t,
                        max: t
                    }), this.$constrainWrapLimit(e, i.min, i.max));
                    return t != this.$wrapLimit && 1 < t && (this.$wrapLimit = t, this.$modified = !0, this.$useWrapMode && (this.$updateWrapData(0, this.getLength() - 1), this.$resetRowCache(0), this._signal("changeWrapLimit")), !0);
                }, C.prototype.$constrainWrapLimit = function(e, t, i) {
                    return t && (e = Math.max(t, e)), e = i ? Math.min(i, e) : e;
                }, C.prototype.getWrapLimit = function() {
                    return this.$wrapLimit;
                }, C.prototype.setWrapLimit = function(e) {
                    this.setWrapLimitRange(e, e);
                }, C.prototype.getWrapLimitRange = function() {
                    return {
                        min: this.$wrapLimitRange.min,
                        max: this.$wrapLimitRange.max
                    };
                }, C.prototype.$updateInternalDataOnChange = function(e) {
                    var t = this.$useWrapMode, i = e.action, n = e.start, o = e.end, r = n.row, s = o.row, a = s - r, l = null;
                    if (this.$updating = !0, 0 != a) {
                        if ("remove" === i) {
                            this[t ? "$wrapData" : "$rowLengthCache"].splice(r, a);
                            var c = this.$foldData, l = this.getFoldsInRange(e);
                            this.removeFolds(l);
                            var h = 0;
                            for((g = this.getFoldLine(o.row)) && (g.addRemoveChars(o.row, o.column, n.column - o.column), g.shiftRow(-a), (d = this.getFoldLine(r)) && d !== g && (d.merge(g), g = d), h = c.indexOf(g) + 1); h < c.length; h++)(g = c[h]).start.row >= o.row && g.shiftRow(-a);
                            s = r;
                        } else {
                            var d = Array(a), u = (d.unshift(r, 0), t ? this.$wrapData : this.$rowLengthCache), c = (u.splice.apply(u, d), this.$foldData), h = 0;
                            for((g = this.getFoldLine(r)) && (0 == (u = g.range.compareInside(n.row, n.column)) ? (g = g.split(n.row, n.column)) && (g.shiftRow(a), g.addRemoveChars(s, 0, o.column - n.column)) : -1 == u && (g.addRemoveChars(r, 0, o.column - n.column), g.shiftRow(a)), h = c.indexOf(g) + 1); h < c.length; h++)(g = c[h]).start.row >= r && g.shiftRow(a);
                        }
                    } else {
                        var g, a = Math.abs(e.start.column - e.end.column);
                        "remove" === i && (l = this.getFoldsInRange(e), this.removeFolds(l), a = -a), (g = this.getFoldLine(r)) && g.addRemoveChars(r, n.column, a);
                    }
                    return t && this.$wrapData.length != this.doc.getLength() && console.error("doc.getLength() and $wrapData.length have to be the same!"), this.$updating = !1, t ? this.$updateWrapData(r, s) : this.$updateRowLengthCache(r, s), l;
                }, C.prototype.$updateRowLengthCache = function(e, t) {
                    this.$rowLengthCache[e] = null, this.$rowLengthCache[t] = null;
                }, C.prototype.$updateWrapData = function(e, t) {
                    var s, i, a = this.doc.getAllLines(), n = this.getTabSize(), o = this.$wrapData, r = this.$wrapLimit, l = e;
                    for(t = Math.min(t, a.length - 1); l <= t;)(i = this.getFoldLine(l, i)) ? (s = [], i.walk((function(e, t, i, n) {
                        var o;
                        if (null != e) {
                            (o = this.$getDisplayTokens(e, s.length))[0] = I;
                            for(var r = 1; r < o.length; r++)o[r] = b;
                        } else o = this.$getDisplayTokens(a[t].substring(n, i), s.length);
                        s = s.concat(o);
                    }).bind(this), i.end.row, a[i.end.row].length + 1), o[i.start.row] = this.$computeWrapSplits(s, r, n), l = i.end.row + 1) : (s = this.$getDisplayTokens(a[l]), o[l] = this.$computeWrapSplits(s, r, n), l++);
                }, C.prototype.$computeWrapSplits = function(o, e, r) {
                    if (0 == o.length) return [];
                    var s = [], t = o.length, a = 0, l = 0, c = this.$wrapAsCode, h = this.$indentedSoftWrap, d = e <= Math.max(2 * r, 8) || !1 === h ? 0 : Math.floor(e / 2);
                    function i(e) {
                        for(var t = e - a, i = a; i < e; i++){
                            var n = o[i];
                            12 !== n && 2 !== n || --t;
                        }
                        s.length || (u = (()=>{
                            var e = 0;
                            if (0 === d) return e;
                            if (h) for(var t = 0; t < o.length; t++){
                                var i = o[t];
                                if (i == w) e += 1;
                                else if (i == x) e += r;
                                else if (i != S) break;
                            }
                            return c && !1 !== h && (e += r), Math.min(e, d);
                        })(), s.indent = u), l += t, s.push(l), a = e;
                    }
                    for(var u = 0; e - u < t - a;){
                        var n = a + e - u;
                        if (o[n - 1] >= w && o[n] >= w) i(n);
                        else if (o[n] == I || o[n] == b) {
                            for(; n != a - 1 && o[n] != I; n--);
                            if (a < n) ;
                            else {
                                for(n = a + e; n < o.length && o[n] == b; n++);
                                if (n == o.length) break;
                            }
                            i(n);
                        } else {
                            for(var g = Math.max(n - (e - (e >> 2)), a - 1); g < n && o[n] < I;)n--;
                            if (c) {
                                for(; g < n && o[n] < I;)n--;
                                for(; g < n && o[n] == A;)n--;
                            } else for(; g < n && o[n] < w;)n--;
                            g < n ? i(++n) : (o[n = a + e] == v && n--, i(n - u));
                        }
                    }
                    return s;
                }, C.prototype.$getDisplayTokens = function(e, t) {
                    var i, n = [];
                    t = t || 0;
                    for(var o = 0; o < e.length; o++){
                        var r = e.charCodeAt(o);
                        if (9 == r) {
                            i = this.getScreenTabSize(n.length + t), n.push(x);
                            for(var s = 1; s < i; s++)n.push(S);
                        } else 32 == r ? n.push(w) : 39 < r && r < 48 || 57 < r && r < 64 ? n.push(A) : 4352 <= r && k(r) ? n.push(y, v) : n.push(y);
                    }
                    return n;
                }, C.prototype.$getStringScreenWidth = function(e, t, i) {
                    if (0 == t) return [
                        0,
                        0
                    ];
                    var n, o;
                    for(null == t && (t = 1 / 0), i = i || 0, o = 0; o < e.length && (9 == (n = e.charCodeAt(o)) ? i += this.getScreenTabSize(i) : 4352 <= n && k(n) ? i += 2 : i += 1, !(t < i)); o++);
                    return [
                        i,
                        o
                    ];
                }, C.prototype.getRowLength = function(e) {
                    var t = 1;
                    return this.lineWidgets && (t += this.lineWidgets[e] && this.lineWidgets[e].rowCount || 0), this.$useWrapMode && this.$wrapData[e] ? this.$wrapData[e].length + t : t;
                }, C.prototype.getRowLineCount = function(e) {
                    return this.$useWrapMode && this.$wrapData[e] ? this.$wrapData[e].length + 1 : 1;
                }, C.prototype.getRowWrapIndent = function(e) {
                    var t;
                    return this.$useWrapMode && (e = this.screenToDocumentPosition(e, Number.MAX_VALUE), (t = this.$wrapData[e.row]).length) && t[0] < e.column ? t.indent : 0;
                }, C.prototype.getScreenLastRowColumn = function(e) {
                    e = this.screenToDocumentPosition(e, Number.MAX_VALUE);
                    return this.documentToScreenColumn(e.row, e.column);
                }, C.prototype.getDocumentLastRowColumn = function(e, t) {
                    e = this.documentToScreenRow(e, t);
                    return this.getScreenLastRowColumn(e);
                }, C.prototype.getDocumentLastRowColumnPosition = function(e, t) {
                    e = this.documentToScreenRow(e, t);
                    return this.screenToDocumentPosition(e, Number.MAX_VALUE / 10);
                }, C.prototype.getRowSplitData = function(e) {
                    if (this.$useWrapMode) return this.$wrapData[e];
                }, C.prototype.getScreenTabSize = function(e) {
                    return this.$tabSize - (e % this.$tabSize | 0);
                }, C.prototype.screenToDocumentRow = function(e, t) {
                    return this.screenToDocumentPosition(e, t).row;
                }, C.prototype.screenToDocumentColumn = function(e, t) {
                    return this.screenToDocumentPosition(e, t).column;
                }, C.prototype.screenToDocumentPosition = function(e, t, i) {
                    if (e < 0) return {
                        row: 0,
                        column: 0
                    };
                    for(var n, o, r, s = 0, a = 0, l = 0, c = 0, h = this.$screenRowCache, d = this.$getRowCacheIndex(h, e), u = h.length, g = (r = u && 0 <= d ? (l = h[d], s = this.$docRowCache[d], e > h[u - 1]) : !u, this.getLength() - 1), p = this.getNextFoldLine(s), m = p ? p.start.row : 1 / 0; l <= e && !(e < l + (c = this.getRowLength(s)) || g <= s);)l += c, m < ++s && (s = p.end.row + 1, m = (p = this.getNextFoldLine(s, p)) ? p.start.row : 1 / 0), r && (this.$docRowCache.push(s), this.$screenRowCache.push(l));
                    if (p && p.start.row <= s) n = this.getFoldDisplayLine(p), s = p.start.row;
                    else {
                        if (l + c <= e || g < s) return {
                            row: g,
                            column: this.getLine(g).length
                        };
                        n = this.getLine(s), p = null;
                    }
                    d = 0, h = Math.floor(e - l);
                    return this.$useWrapMode && (u = this.$wrapData[s]) && (o = u[h], 0 < h) && u.length && (d = u.indent, a = u[h - 1] || u[u.length - 1], n = n.substring(a)), void 0 !== i && this.$bidiHandler.isBidiRow(l + h, s, h) && (t = this.$bidiHandler.offsetToCol(i)), a += this.$getStringScreenWidth(n, t - d)[1], this.$useWrapMode && o <= a && (a = o - 1), p ? p.idxToPosition(a) : {
                        row: s,
                        column: a
                    };
                }, C.prototype.documentToScreenPosition = function(e, t) {
                    var i = void 0 === t ? this.$clipPositionToDocument(e.row, e.column) : this.$clipPositionToDocument(e, t), n = (e = i.row, t = i.column, 0), i = null;
                    (a = this.getFoldAt(e, t, 1)) && (e = a.start.row, t = a.start.column);
                    for(var o, r, s = 0, a = this.$docRowCache, l = this.$getRowCacheIndex(a, e), c = a.length, h = (r = c && 0 <= l ? (s = a[l], n = this.$screenRowCache[l], e > a[c - 1]) : !c, this.getNextFoldLine(s)), d = h ? h.start.row : 1 / 0; s < e;){
                        if (d <= s) {
                            if (e < (o = h.end.row + 1)) break;
                            d = (h = this.getNextFoldLine(o, h)) ? h.start.row : 1 / 0;
                        } else o = s + 1;
                        n += this.getRowLength(s), s = o, r && (this.$docRowCache.push(s), this.$screenRowCache.push(n));
                    }
                    var u = "", i = h && d <= s ? (u = this.getFoldDisplayLine(h, e, t), h.start.row) : (u = this.getLine(e).substring(0, t), e), l = 0;
                    if (this.$useWrapMode) {
                        var g = this.$wrapData[i];
                        if (g) {
                            for(var p = 0; u.length >= g[p];)n++, p++;
                            u = u.substring(g[p - 1] || 0, u.length), l = 0 < p ? g.indent : 0;
                        }
                    }
                    return this.lineWidgets && this.lineWidgets[s] && this.lineWidgets[s].rowsAbove && (n += this.lineWidgets[s].rowsAbove), {
                        row: n,
                        column: l + this.$getStringScreenWidth(u)[0]
                    };
                }, C.prototype.documentToScreenColumn = function(e, t) {
                    return this.documentToScreenPosition(e, t).column;
                }, C.prototype.documentToScreenRow = function(e, t) {
                    return this.documentToScreenPosition(e, t).row;
                }, C.prototype.getScreenLength = function() {
                    var e = 0, t = null;
                    if (this.$useWrapMode) for(var i = this.$wrapData.length, n = 0, o = 0, r = (t = this.$foldData[o++]) ? t.start.row : 1 / 0; n < i;){
                        var s = this.$wrapData[n];
                        e += s ? s.length + 1 : 1, r < ++n && (n = t.end.row + 1, r = (t = this.$foldData[o++]) ? t.start.row : 1 / 0);
                    }
                    else for(var e = this.getLength(), a = this.$foldData, o = 0; o < a.length; o++)e -= (t = a[o]).end.row - t.start.row;
                    return this.lineWidgets && (e += this.$getWidgetScreenLength()), e;
                }, C.prototype.$setFontMetrics = function(r) {
                    this.$enableVarChar && (this.$getStringScreenWidth = function(e, t, i) {
                        if (0 === t) return [
                            0,
                            0
                        ];
                        var n, o;
                        for(t = t || 1 / 0, i = i || 0, o = 0; o < e.length && !(t < (i += "\t" === (n = e.charAt(o)) ? this.getScreenTabSize(i) : r.getCharacterWidth(n))); o++);
                        return [
                            i,
                            o
                        ];
                    });
                }, C.prototype.getPrecedingCharacter = function() {
                    var e = this.selection.getCursor();
                    return 0 === e.column ? 0 === e.row ? "" : this.doc.getNewLineCharacter() : this.getLine(e.row)[e.column - 1];
                }, C.prototype.destroy = function() {
                    this.destroyed || (this.bgTokenizer.setDocument(null), this.bgTokenizer.cleanup(), this.destroyed = !0), this.endOperation(), this.$stopWorker(), this.removeAllListeners(), this.doc && this.doc.off("change", this.$onChange), this.selection && (this.selection.off("changeCursor", this.$onSelectionChange), this.selection.off("changeSelection", this.$onSelectionChange)), this.selection.detach();
                }, C);
                function C(e, t) {
                    this.doc, this.$breakpoints = [], this.$decorations = [], this.$frontMarkers = {}, this.$backMarkers = {}, this.$markerId = 1, this.$undoSelect = !0, this.$editor = null, this.prevOp = {}, this.$foldData = [], this.id = "session" + ++C.$uid, this.$foldData.toString = function() {
                        return this.join("\n");
                    }, this.$gutterCustomWidgets = {}, this.bgTokenizer = new g((new c).getTokenizer(), this);
                    var i = this;
                    this.bgTokenizer.on("update", function(e) {
                        i._signal("tokenizerUpdate", e);
                    }), this.on("changeFold", this.onChangeFold.bind(this)), this.$onChange = this.onChange.bind(this), "object" == typeof e && e.getLine || (e = new u(e)), this.setDocument(e), this.selection = new l(this), this.$onSelectionChange = this.onSelectionChange.bind(this), this.selection.on("changeSelection", this.$onSelectionChange), this.selection.on("changeCursor", this.$onSelectionChange), this.$bidiHandler = new r(this), s.resetOptions(this), this.setMode(t), s._signal("session", this), this.destroyed = !1, this.$initOperationListeners();
                }
                f.$uid = 0, f.prototype.$modes = s.$modes, f.prototype.getValue = f.prototype.toString, f.prototype.$defaultUndoManager = {
                    undo: function() {},
                    redo: function() {},
                    hasUndo: function() {},
                    hasRedo: function() {},
                    reset: function() {},
                    add: function() {},
                    addSelection: function() {},
                    startNewGroup: function() {},
                    addSession: function() {}
                }, f.prototype.$overwrite = !1, f.prototype.$mode = null, f.prototype.$modeId = null, f.prototype.$scrollTop = 0, f.prototype.$scrollLeft = 0, f.prototype.$wrapLimit = 80, f.prototype.$useWrapMode = !1, f.prototype.$wrapLimitRange = {
                    min: null,
                    max: null
                }, f.prototype.lineWidgets = null, f.prototype.isFullWidth = k, n.implement(f.prototype, a);
                var y = 1, v = 2, I = 3, b = 4, A = 9, w = 10, x = 11, S = 12;
                function k(e) {
                    return !(e < 4352) && (4352 <= e && e <= 4447 || 4515 <= e && e <= 4519 || 4602 <= e && e <= 4607 || 9001 <= e && e <= 9002 || 11904 <= e && e <= 11929 || 11931 <= e && e <= 12019 || 12032 <= e && e <= 12245 || 12272 <= e && e <= 12283 || 12288 <= e && e <= 12350 || 12353 <= e && e <= 12438 || 12441 <= e && e <= 12543 || 12549 <= e && e <= 12589 || 12593 <= e && e <= 12686 || 12688 <= e && e <= 12730 || 12736 <= e && e <= 12771 || 12784 <= e && e <= 12830 || 12832 <= e && e <= 12871 || 12880 <= e && e <= 13054 || 13056 <= e && e <= 19903 || 19968 <= e && e <= 42124 || 42128 <= e && e <= 42182 || 43360 <= e && e <= 43388 || 44032 <= e && e <= 55203 || 55216 <= e && e <= 55238 || 55243 <= e && e <= 55291 || 63744 <= e && e <= 64255 || 65040 <= e && e <= 65049 || 65072 <= e && e <= 65106 || 65108 <= e && e <= 65126 || 65128 <= e && e <= 65131 || 65281 <= e && e <= 65376 || 65504 <= e && e <= 65510);
                }
                e("./edit_session/folding").Folding.call(f.prototype), e("./edit_session/bracket_match").BracketMatch.call(f.prototype), s.defineOptions(f.prototype, "session", {
                    wrap: {
                        set: function(e) {
                            e && "off" != e ? "free" == e ? e = !0 : "printMargin" == e ? e = -1 : "string" == typeof e && (e = parseInt(e, 10) || !1) : e = !1, this.$wrap != e && ((this.$wrap = e) ? (this.setWrapLimitRange(e = "number" == typeof e ? e : null, e), this.setUseWrapMode(!0)) : this.setUseWrapMode(!1));
                        },
                        get: function() {
                            return this.getUseWrapMode() ? -1 == this.$wrap ? "printMargin" : this.getWrapLimitRange().min ? this.$wrap : "free" : "off";
                        },
                        handlesSet: !0
                    },
                    wrapMethod: {
                        set: function(e) {
                            (e = "auto" == e ? "text" != this.$mode.type : "text" != e) != this.$wrapAsCode && (this.$wrapAsCode = e, this.$useWrapMode) && (this.$useWrapMode = !1, this.setUseWrapMode(!0));
                        },
                        initialValue: "auto"
                    },
                    indentedSoftWrap: {
                        set: function() {
                            this.$useWrapMode && (this.$useWrapMode = !1, this.setUseWrapMode(!0));
                        },
                        initialValue: !0
                    },
                    firstLineNumber: {
                        set: function() {
                            this._signal("changeBreakpoint");
                        },
                        initialValue: 1
                    },
                    useWorker: {
                        set: function(e) {
                            this.$useWorker = e, this.$stopWorker(), e && this.$startWorker();
                        },
                        initialValue: !0
                    },
                    useSoftTabs: {
                        initialValue: !0
                    },
                    tabSize: {
                        set: function(e) {
                            0 < (e = parseInt(e)) && this.$tabSize !== e && (this.$modified = !0, this.$rowLengthCache = [], this.$tabSize = e, this._signal("changeTabSize"));
                        },
                        initialValue: 4,
                        handlesSet: !0
                    },
                    navigateWithinSoftTabs: {
                        initialValue: !1
                    },
                    foldStyle: {
                        set: function(e) {
                            this.setFoldStyle(e);
                        },
                        handlesSet: !0
                    },
                    overwrite: {
                        set: function(e) {
                            this._signal("changeOverwrite");
                        },
                        initialValue: !1
                    },
                    newLineMode: {
                        set: function(e) {
                            this.doc.setNewLineMode(e);
                        },
                        get: function() {
                            return this.doc.getNewLineMode();
                        },
                        handlesSet: !0
                    },
                    mode: {
                        set: function(e) {
                            this.setMode(e);
                        },
                        get: function() {
                            return this.$modeId;
                        },
                        handlesSet: !0
                    }
                }), t.EditSession = f;
            }), ace.define("ace/search", [
                "require",
                "exports",
                "module",
                "ace/lib/lang",
                "ace/lib/oop",
                "ace/range"
            ], function(e, t, i) {
                var I = e("./lib/lang"), n = e("./lib/oop"), b = e("./range").Range;
                function o() {
                    this.$options = {};
                }
                function p(e, t) {
                    t = e.doc.positionToIndex({
                        row: t,
                        column: 0
                    });
                    return e.doc.indexToPosition(t + 5e3).row + 1;
                }
                o.prototype.set = function(e) {
                    return n.mixin(this.$options, e), this;
                }, o.prototype.getOptions = function() {
                    return I.copyObject(this.$options);
                }, o.prototype.setOptions = function(e) {
                    this.$options = e;
                }, o.prototype.find = function(e) {
                    var o, r = this.$options, e = this.$matchIterator(e, r);
                    return !!e && (o = null, e.forEach(function(e, t, i, n) {
                        return o = new b(e, t, i, n), !(t == n && r.start && r.start.start && 0 != r.skipCurrent && o.isEqual(r.start) && (o = null, 1));
                    }), o);
                }, o.prototype.findAll = function(e) {
                    var t = this.$options;
                    if (!t.needle) return [];
                    this.$assembleRegExp(t);
                    var i = t.range, n = i ? e.getLines(i.start.row, i.end.row) : e.doc.getAllLines(), o = [], r = t.re;
                    if (t.$isMultiLine) {
                        var s, a = r.length, l = n.length - a;
                        e: for(var c = r.offset || 0; c <= l; c++){
                            for(var h = 0; h < a; h++)if (-1 == n[c + h].search(r[h])) continue e;
                            var d = n[c], u = n[c + a - 1], d = d.length - d.match(r[0])[0].length, u = u.match(r[a - 1])[0].length;
                            s && s.end.row === c && s.end.column > d || (o.push(s = new b(c, d, c + a - 1, u)), 2 < a && (c = c + a - 2));
                        }
                    } else for(var g = 0; g < n.length; g++)if (this.$isMultilineSearch(t)) {
                        var p, m = n.length - 1;
                        (p = this.$multiLineForward(e, r, g, m)) && (g < (m = p.endRow <= m ? p.endRow - 1 : m) && (g = m), o.push(new b(p.startRow, p.startCol, p.endRow, p.endCol)));
                    } else {
                        p = I.getMatchOffsets(n[g], r);
                        for(h = 0; h < p.length; h++){
                            var f = p[h];
                            o.push(new b(g, f.offset, g, f.offset + f.length));
                        }
                    }
                    if (i) {
                        for(var C = i.start.column, y = i.end.column, g = 0, h = o.length - 1; g < h && o[g].start.column < C && 0 == o[g].start.row;)g++;
                        for(var v = i.end.row - i.start.row; g < h && o[h].end.column > y && o[h].end.row == v;)h--;
                        for(o = o.slice(g, h + 1), g = 0, h = o.length; g < h; g++)o[g].start.row += i.start.row, o[g].end.row += i.start.row;
                    }
                    return o;
                }, o.prototype.parseReplaceString = function(e) {
                    for(var t = 36, i = 38, n = 48, o = 49, r = 57, s = 92, a = 110, l = 116, c = "", h = 0, d = e.length; h < d; h++){
                        var u = e.charCodeAt(h);
                        if (u === s) {
                            if (d <= ++h) {
                                c += "\\";
                                break;
                            }
                            switch(e.charCodeAt(h)){
                                case s:
                                    c += "\\";
                                    break;
                                case a:
                                    c += "\n";
                                    break;
                                case l:
                                    c += "\t";
                            }
                        } else {
                            if (u === t) {
                                if (d <= ++h) {
                                    c += "$";
                                    break;
                                }
                                u = e.charCodeAt(h);
                                if (u === t) {
                                    c += "$$";
                                    continue;
                                }
                                if (u === n || u === i) {
                                    c += "$&";
                                    continue;
                                }
                                if (o <= u && u <= r) {
                                    c += "$" + e[h];
                                    continue;
                                }
                            }
                            c += e[h];
                        }
                    }
                    return c || e;
                }, o.prototype.replace = function(e, t) {
                    var i = this.$options, n = this.$assembleRegExp(i);
                    if (i.$isMultiLine) return t;
                    if (n) {
                        var o = this.$isMultilineSearch(i), r = (o && (e = e.replace(/\r\n|\r|\n/g, "\n")), n.exec(e));
                        if (!r || !o && r[0].length != e.length) return null;
                        if (t = i.regExp ? this.parseReplaceString(t) : t.replace(/\$/g, "$$$$"), t = e.replace(n, t), i.preserveCase) {
                            t = t.split("");
                            for(var s = Math.min(e.length, e.length); s--;){
                                var a = e[s];
                                a && a.toLowerCase() != a ? t[s] = t[s].toUpperCase() : t[s] = t[s].toLowerCase();
                            }
                            t = t.join("");
                        }
                        return t;
                    }
                }, o.prototype.$assembleRegExp = function(t, e) {
                    if (t.needle instanceof RegExp) return t.re = t.needle;
                    var i = t.needle;
                    if (!t.needle) return t.re = !1;
                    t.regExp || (i = I.escapeRegExp(i));
                    var n, o, r, s, a, l = t.caseSensitive ? "gm" : "gmi";
                    try {
                        new RegExp(i, "u"), t.$supportsUnicodeFlag = !0, l += "u";
                    } catch (e) {
                        t.$supportsUnicodeFlag = !1;
                    }
                    function c(e, t) {
                        return void 0 === t && (t = !0), (r && o.$supportsUnicodeFlag ? new RegExp("[\\p{L}\\p{N}_]", "u") : new RegExp("\\w")).test(e) || o.regExp ? r && o.$supportsUnicodeFlag ? t ? "(?<=^|[^\\p{L}\\p{N}_])" : "(?=[^\\p{L}\\p{N}_]|$)" : "\\b" : "";
                    }
                    if (t.wholeWord && (n = i, o = t, r = I.supportsLookbehind(), s = Array.from(n), a = s[0], s = s[s.length - 1], i = c(a) + n + c(s, !1)), t.$isMultiLine = !e && /[\n\r]/.test(i), t.$isMultiLine) return t.re = this.$assembleMultilineRegExp(i, l);
                    try {
                        var h = new RegExp(i, l);
                    } catch (e) {
                        h = !1;
                    }
                    return t.re = h;
                }, o.prototype.$assembleMultilineRegExp = function(e, t) {
                    for(var i = e.replace(/\r\n|\r|\n/g, "$\n^").split("\n"), n = [], o = 0; o < i.length; o++)try {
                        n.push(new RegExp(i[o], t));
                    } catch (e) {
                        return !1;
                    }
                    return n;
                }, o.prototype.$isMultilineSearch = function(e) {
                    return e.re && /\\r\\n|\\r|\\n/.test(e.re.source) && e.regExp && !e.$isMultiLine;
                }, o.prototype.$multiLineForward = function(e, t, i, n) {
                    for(var o = p(e, i), r = i; r <= n;){
                        for(var s = 0; s < o && !(n < r); s++)var a = e.getLine(r++), l = null == l ? a : l + "\n" + a;
                        var c, h, d = t.exec(l);
                        if (t.lastIndex = 0, d) return h = l.slice(0, d.index).split("\n"), d = d[0].split("\n"), {
                            startRow: c = i + h.length - 1,
                            startCol: h = h[h.length - 1].length,
                            endRow: c + d.length - 1,
                            endCol: 1 == d.length ? h + d[0].length : d[d.length - 1].length
                        };
                    }
                    return null;
                }, o.prototype.$multiLineBackward = function(e, t, i, n, o) {
                    for(var r = p(e, n), s = e.getLine(n).length - i, a = n; o <= a;){
                        for(var l = 0; l < r && o <= a; l++)var c = e.getLine(a--), h = null == h ? c : c + "\n" + h;
                        var d, u, g = ((e, t, i)=>{
                            for(var n = null, o = 0; o <= e.length;){
                                t.lastIndex = o;
                                var r = t.exec(e);
                                if (!r) break;
                                var s = r.index + r[0].length;
                                if (s > e.length - i) break;
                                (!n || s > n.index + n[0].length) && (n = r), o = r.index + 1;
                            }
                            return n;
                        })(h, t, s);
                        if (g) return u = h.slice(0, g.index).split("\n"), g = g[0].split("\n"), {
                            startRow: d = a + u.length,
                            startCol: u = u[u.length - 1].length,
                            endRow: d + g.length - 1,
                            endCol: 1 == g.length ? u + g[0].length : g[g.length - 1].length
                        };
                    }
                    return null;
                }, o.prototype.$matchIterator = function(d, i) {
                    var u, a, g, l, e, p, t, n, m, c, h, o, f = this.$assembleRegExp(i);
                    return !!f && (u = this.$isMultilineSearch(i), a = this.$multiLineForward, g = this.$multiLineBackward, l = 1 == i.backwards, e = 0 != i.skipCurrent, p = f.unicode, t = i.range, (n = (n = i.start) || (t ? t[l ? "end" : "start"] : d.selection.getRange())).start && (n = n[e != l ? "end" : "start"]), m = t ? t.start.row : 0, c = t ? t.end.row : d.getLength() - 1, o = i.$isMultiLine ? (h = f.length, function(e, t, i) {
                        var n = l ? e - h + 1 : e;
                        if (!(n < 0 || n + h > d.getLength())) {
                            var o = d.getLine(n), e = o.search(f[0]);
                            if (!(!l && e < t || -1 === e)) {
                                for(var r = 1; r < h; r++)if (-1 == (o = d.getLine(n + r)).search(f[r])) return;
                                var s = o.match(f[h - 1])[0].length;
                                if (!(l && t < s)) return !!i(n, e, n + h - 1, s) || void 0;
                            }
                        }
                    }) : l ? function(e, t, i) {
                        var n;
                        if (u) return !!(n = g(d, f, t, e, m)) && (!!i(n.startRow, n.startCol, n.endRow, n.endCol) || void 0);
                        var o, r = d.getLine(e), s = [];
                        for(f.lastIndex = 0; o = f.exec(r);){
                            var a = o[0].length, l = o.index;
                            if (!a) {
                                if (l >= r.length) break;
                                f.lastIndex = l += I.skipEmptyMatch(r, l, p);
                            }
                            if (t < o.index + a) break;
                            s.push(o.index, a);
                        }
                        for(var c = s.length - 1; 0 <= c; c -= 2){
                            var h = s[c - 1];
                            if (i(e, h, e, h + (a = s[c]))) return !0;
                        }
                    } : function(e, t, i) {
                        var n;
                        if (f.lastIndex = t, u) return (t = a(d, f, e, c)) && e < (n = t.endRow <= c ? t.endRow - 1 : c) && (e = n), !!t && (!!i(t.startRow, t.startCol, t.endRow, t.endCol) || void 0);
                        for(var o = d.getLine(e); r = f.exec(o);){
                            var r, s = r[0].length;
                            if (i(e, r = r.index, e, r + s)) return !0;
                            if (!s && (f.lastIndex = r += I.skipEmptyMatch(o, r, p), r >= o.length)) return !1;
                        }
                    }, {
                        forEach: l ? function(e) {
                            var t = n.row;
                            if (!o(t, n.column, e)) {
                                for(t--; m <= t; t--)if (o(t, Number.MAX_VALUE, e)) return;
                                if (0 != i.wrap) {
                                    for(t = c, m = n.row; m <= t; t--)if (o(t, Number.MAX_VALUE, e)) return;
                                }
                            }
                        } : function(e) {
                            var t = n.row;
                            if (!o(t, n.column, e)) {
                                for(t += 1; t <= c; t++)if (o(t, 0, e)) return;
                                if (0 != i.wrap) {
                                    for(t = m, c = n.row; t <= c; t++)if (o(t, 0, e)) return;
                                }
                            }
                        }
                    });
                }, t.Search = o;
            }), ace.define("ace/keyboard/hash_handler", [
                "require",
                "exports",
                "module",
                "ace/lib/keys",
                "ace/lib/useragent"
            ], function(e, t, i) {
                var n, o = this && this.__extends || (n = function(e, t) {
                    return (n = Object.setPrototypeOf || (({
                        __proto__: []
                    }) instanceof Array ? function(e, t) {
                        e.__proto__ = t;
                    } : function(e, t) {
                        for(var i in t)Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
                    }))(e, t);
                }, function(e, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
                    function i() {
                        this.constructor = e;
                    }
                    n(e, t), e.prototype = null === t ? Object.create(t) : (i.prototype = t.prototype, new i);
                }), a = e("../lib/keys"), r = e("../lib/useragent"), s = a.KEY_MODS, l = (c.prototype.$init = function(e, t, i) {
                    this.platform = t || (r.isMac ? "mac" : "win"), this.commands = {}, this.commandKeyBinding = {}, this.addCommands(e), this.$singleCommand = i;
                }, c.prototype.addCommand = function(e) {
                    this.commands[e.name] && this.removeCommand(e), (this.commands[e.name] = e).bindKey && this._buildKeyHash(e);
                }, c.prototype.removeCommand = function(e, t) {
                    var i, n = e && ("string" == typeof e ? e : e.name), o = (e = this.commands[n], t || delete this.commands[n], this.commandKeyBinding);
                    for(i in o){
                        var r, s = o[i];
                        s == e ? delete o[i] : Array.isArray(s) && -1 != (r = s.indexOf(e)) && (s.splice(r, 1), 1 == s.length) && (o[i] = s[0]);
                    }
                }, c.prototype.bindKey = function(e, n, o) {
                    if ("object" == typeof e && e && (null == o && (o = e.position), e = e[this.platform]), e) return "function" == typeof n ? this.addCommand({
                        exec: n,
                        bindKey: e,
                        name: n.name || e
                    }) : void e.split("|").forEach(function(e) {
                        var t = "", i = (-1 != e.indexOf(" ") && (e = (i = e.split(/\s+/)).pop(), i.forEach(function(e) {
                            e = this.parseKeys(e), e = s[e.hashId] + e.key;
                            t += (t ? " " : "") + e, this._addCommandToBinding(t, "chainKeys");
                        }, this), t += " "), this.parseKeys(e)), e = s[i.hashId] + i.key;
                        this._addCommandToBinding(t + e, n, o);
                    }, this);
                }, c.prototype._addCommandToBinding = function(e, t, i) {
                    var n = this.commandKeyBinding;
                    if (t) {
                        if (!n[e] || this.$singleCommand) n[e] = t;
                        else {
                            Array.isArray(n[e]) ? -1 != (r = n[e].indexOf(t)) && n[e].splice(r, 1) : n[e] = [
                                n[e]
                            ], "number" != typeof i && (i = h(t));
                            for(var o = n[e], r = 0; r < o.length; r++)if (i < h(o[r])) break;
                            o.splice(r, 0, t);
                        }
                    } else delete n[e];
                }, c.prototype.addCommands = function(i) {
                    i && Object.keys(i).forEach(function(e) {
                        var t = i[e];
                        if (t) {
                            if ("string" == typeof t) return this.bindKey(t, e);
                            "object" == typeof (t = "function" == typeof t ? {
                                exec: t
                            } : t) && (t.name || (t.name = e), this.addCommand(t));
                        }
                    }, this);
                }, c.prototype.removeCommands = function(t) {
                    Object.keys(t).forEach(function(e) {
                        this.removeCommand(t[e]);
                    }, this);
                }, c.prototype.bindKeys = function(t) {
                    Object.keys(t).forEach(function(e) {
                        this.bindKey(e, t[e]);
                    }, this);
                }, c.prototype._buildKeyHash = function(e) {
                    this.bindKey(e.bindKey, e);
                }, c.prototype.parseKeys = function(e) {
                    var t = e.toLowerCase().split(/[\-\+]([\-\+])?/).filter(function(e) {
                        return e;
                    }), i = t.pop(), n = a[i];
                    if (a.FUNCTION_KEYS[n]) i = a.FUNCTION_KEYS[n].toLowerCase();
                    else {
                        if (!t.length) return {
                            key: i,
                            hashId: -1
                        };
                        if (1 == t.length && "shift" == t[0]) return {
                            key: i.toUpperCase(),
                            hashId: -1
                        };
                    }
                    for(var o = 0, r = t.length; r--;){
                        var s = a.KEY_MODS[t[r]];
                        if (null == s) return "undefined" != typeof console && console.error("invalid modifier " + t[r] + " in " + e), !1;
                        o |= s;
                    }
                    return {
                        key: i,
                        hashId: o
                    };
                }, c.prototype.findKeyCommand = function(e, t) {
                    e = s[e] + t;
                    return this.commandKeyBinding[e];
                }, c.prototype.handleKeyboard = function(e, t, i, n) {
                    var o, r;
                    if (!(n < 0)) return o = s[t] + i, r = this.commandKeyBinding[o], e.$keyChain && (e.$keyChain += " " + o, r = this.commandKeyBinding[e.$keyChain] || r), !r || "chainKeys" != r && "chainKeys" != r[r.length - 1] ? (e.$keyChain && (t && 4 != t || 1 != i.length ? (-1 == t || 0 < n) && (e.$keyChain = "") : e.$keyChain = e.$keyChain.slice(0, -o.length - 1)), {
                        command: r
                    }) : (e.$keyChain = e.$keyChain || o, {
                        command: "null"
                    });
                }, c.prototype.getStatusText = function(e, t) {
                    return t.$keyChain || "";
                }, c);
                function c(e, t) {
                    this.$init(e, t, !1);
                }
                function h(e) {
                    return "object" == typeof e && e.bindKey && e.bindKey.position || (e.isDefault ? -100 : 0);
                }
                o(u, d = l);
                var d, e = u;
                function u(e, t) {
                    e = d.call(this, e, t) || this;
                    return e.$singleCommand = !0, e;
                }
                e.call = function(e, t, i) {
                    l.prototype.$init.call(e, t, i, !0);
                }, l.call = function(e, t, i) {
                    l.prototype.$init.call(e, t, i, !1);
                }, t.HashHandler = e, t.MultiHashHandler = l;
            }), ace.define("ace/commands/command_manager", [
                "require",
                "exports",
                "module",
                "ace/lib/oop",
                "ace/keyboard/hash_handler",
                "ace/lib/event_emitter"
            ], function(e, t, i) {
                var n, o, r = this && this.__extends || (n = function(e, t) {
                    return (n = Object.setPrototypeOf || (({
                        __proto__: []
                    }) instanceof Array ? function(e, t) {
                        e.__proto__ = t;
                    } : function(e, t) {
                        for(var i in t)Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
                    }))(e, t);
                }, function(e, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
                    function i() {
                        this.constructor = e;
                    }
                    n(e, t), e.prototype = null === t ? Object.create(t) : (i.prototype = t.prototype, new i);
                }), s = e("../lib/oop"), a = e("../keyboard/hash_handler").MultiHashHandler, e = e("../lib/event_emitter").EventEmitter, r = (r(l, o = a), l.prototype.exec = function(e, t, i) {
                    if (Array.isArray(e)) {
                        for(var n = e.length; n--;)if (this.exec(e[n], t, i)) return !0;
                        return !1;
                    }
                    var o = {
                        editor: t,
                        command: e = "string" == typeof e ? this.commands[e] : e,
                        args: i
                    };
                    return this.canExecute(e, t) ? (o.returnValue = this._emit("exec", o), this._signal("afterExec", o), !1 !== o.returnValue) : (this._signal("commandUnavailable", o), !1);
                }, l.prototype.canExecute = function(e, t) {
                    return !!(e = "string" == typeof e ? this.commands[e] : e) && !(t && t.$readOnly && !e.readOnly || 0 != this.$checkCommandState && e.isAvailable && !e.isAvailable(t));
                }, l.prototype.toggleRecording = function(e) {
                    if (!this.$inReplay) return e && e._emit("changeStatus"), this.recording ? (this.macro.pop(), this.off("exec", this.$addCommandToMacro), this.macro.length || (this.macro = this.oldMacro), this.recording = !1) : (this.$addCommandToMacro || (this.$addCommandToMacro = (function(e) {
                        this.macro.push([
                            e.command,
                            e.args
                        ]);
                    }).bind(this)), this.oldMacro = this.macro, this.macro = [], this.on("exec", this.$addCommandToMacro), this.recording = !0);
                }, l.prototype.replay = function(t) {
                    if (!this.$inReplay && this.macro) {
                        if (this.recording) return this.toggleRecording(t);
                        try {
                            this.$inReplay = !0, this.macro.forEach(function(e) {
                                "string" == typeof e ? this.exec(e, t) : this.exec(e[0], t, e[1]);
                            }, this);
                        } finally{
                            this.$inReplay = !1;
                        }
                    }
                }, l.prototype.trimMacro = function(e) {
                    return e.map(function(e) {
                        return "string" != typeof e[0] && (e[0] = e[0].name), e = e[1] ? e : e[0];
                    });
                }, l);
                function l(e, t) {
                    t = o.call(this, t, e) || this;
                    return t.byName = t.commands, t.setDefaultHandler("exec", function(e) {
                        return e.args ? e.command.exec(e.editor, e.args, e.event, !1) : e.command.exec(e.editor, {}, e.event, !0);
                    }), t;
                }
                s.implement(r.prototype, e), t.CommandManager = r;
            }), ace.define("ace/commands/default_commands", [
                "require",
                "exports",
                "module",
                "ace/lib/lang",
                "ace/config",
                "ace/range"
            ], function(e, t, i) {
                var l = e("../lib/lang"), n = e("../config"), c = e("../range").Range;
                function o(e, t) {
                    return {
                        win: e,
                        mac: t
                    };
                }
                t.commands = [
                    {
                        name: "showSettingsMenu",
                        description: "Show settings menu",
                        bindKey: o("Ctrl-,", "Command-,"),
                        exec: function(t) {
                            n.loadModule("ace/ext/settings_menu", function(e) {
                                e.init(t), t.showSettingsMenu();
                            });
                        },
                        readOnly: !0
                    },
                    {
                        name: "goToNextError",
                        description: "Go to next error",
                        bindKey: o("Alt-E", "F4"),
                        exec: function(t) {
                            n.loadModule("ace/ext/error_marker", function(e) {
                                e.showErrorMarker(t, 1);
                            });
                        },
                        scrollIntoView: "animate",
                        readOnly: !0
                    },
                    {
                        name: "goToPreviousError",
                        description: "Go to previous error",
                        bindKey: o("Alt-Shift-E", "Shift-F4"),
                        exec: function(t) {
                            n.loadModule("ace/ext/error_marker", function(e) {
                                e.showErrorMarker(t, -1);
                            });
                        },
                        scrollIntoView: "animate",
                        readOnly: !0
                    },
                    {
                        name: "selectall",
                        description: "Select all",
                        bindKey: o("Ctrl-A", "Command-A"),
                        exec: function(e) {
                            e.selectAll();
                        },
                        readOnly: !0
                    },
                    {
                        name: "centerselection",
                        description: "Center selection",
                        bindKey: o(null, "Ctrl-L"),
                        exec: function(e) {
                            e.centerSelection();
                        },
                        readOnly: !0
                    },
                    {
                        name: "gotoline",
                        description: "Go to line...",
                        bindKey: o("Ctrl-L", "Command-L"),
                        exec: function(e, t) {
                            "number" != typeof t || isNaN(t) || e.gotoLine(t), e.prompt({
                                $type: "gotoLine"
                            });
                        },
                        readOnly: !0
                    },
                    {
                        name: "fold",
                        bindKey: o("Alt-L|Ctrl-F1", "Command-Alt-L|Command-F1"),
                        exec: function(e) {
                            e.session.toggleFold(!1);
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "center",
                        readOnly: !0
                    },
                    {
                        name: "unfold",
                        bindKey: o("Alt-Shift-L|Ctrl-Shift-F1", "Command-Alt-Shift-L|Command-Shift-F1"),
                        exec: function(e) {
                            e.session.toggleFold(!0);
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "center",
                        readOnly: !0
                    },
                    {
                        name: "toggleFoldWidget",
                        description: "Toggle fold widget",
                        bindKey: o("F2", "F2"),
                        exec: function(e) {
                            e.session.toggleFoldWidget();
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "center",
                        readOnly: !0
                    },
                    {
                        name: "toggleParentFoldWidget",
                        description: "Toggle parent fold widget",
                        bindKey: o("Alt-F2", "Alt-F2"),
                        exec: function(e) {
                            e.session.toggleFoldWidget(!0);
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "center",
                        readOnly: !0
                    },
                    {
                        name: "foldall",
                        description: "Fold all",
                        bindKey: o(null, "Ctrl-Command-Option-0"),
                        exec: function(e) {
                            e.session.foldAll();
                        },
                        scrollIntoView: "center",
                        readOnly: !0
                    },
                    {
                        name: "foldAllComments",
                        description: "Fold all comments",
                        bindKey: o(null, "Ctrl-Command-Option-0"),
                        exec: function(e) {
                            e.session.foldAllComments();
                        },
                        scrollIntoView: "center",
                        readOnly: !0
                    },
                    {
                        name: "foldOther",
                        description: "Fold other",
                        bindKey: o("Alt-0", "Command-Option-0"),
                        exec: function(e) {
                            e.session.foldAll(), e.session.unfold(e.selection.getAllRanges());
                        },
                        scrollIntoView: "center",
                        readOnly: !0
                    },
                    {
                        name: "unfoldall",
                        description: "Unfold all",
                        bindKey: o("Alt-Shift-0", "Command-Option-Shift-0"),
                        exec: function(e) {
                            e.session.unfold();
                        },
                        scrollIntoView: "center",
                        readOnly: !0
                    },
                    {
                        name: "findnext",
                        description: "Find next",
                        bindKey: o("Ctrl-K", "Command-G"),
                        exec: function(e) {
                            e.findNext();
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "center",
                        readOnly: !0
                    },
                    {
                        name: "findprevious",
                        description: "Find previous",
                        bindKey: o("Ctrl-Shift-K", "Command-Shift-G"),
                        exec: function(e) {
                            e.findPrevious();
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "center",
                        readOnly: !0
                    },
                    {
                        name: "selectOrFindNext",
                        description: "Select or find next",
                        bindKey: o("Alt-K", "Ctrl-G"),
                        exec: function(e) {
                            e.selection.isEmpty() ? e.selection.selectWord() : e.findNext();
                        },
                        readOnly: !0
                    },
                    {
                        name: "selectOrFindPrevious",
                        description: "Select or find previous",
                        bindKey: o("Alt-Shift-K", "Ctrl-Shift-G"),
                        exec: function(e) {
                            e.selection.isEmpty() ? e.selection.selectWord() : e.findPrevious();
                        },
                        readOnly: !0
                    },
                    {
                        name: "find",
                        description: "Find",
                        bindKey: o("Ctrl-F", "Command-F"),
                        exec: function(t) {
                            n.loadModule("ace/ext/searchbox", function(e) {
                                e.Search(t);
                            });
                        },
                        readOnly: !0
                    },
                    {
                        name: "overwrite",
                        description: "Overwrite",
                        bindKey: "Insert",
                        exec: function(e) {
                            e.toggleOverwrite();
                        },
                        readOnly: !0
                    },
                    {
                        name: "selecttostart",
                        description: "Select to start",
                        bindKey: o("Ctrl-Shift-Home", "Command-Shift-Home|Command-Shift-Up"),
                        exec: function(e) {
                            e.getSelection().selectFileStart();
                        },
                        multiSelectAction: "forEach",
                        readOnly: !0,
                        scrollIntoView: "animate",
                        aceCommandGroup: "fileJump"
                    },
                    {
                        name: "gotostart",
                        description: "Go to start",
                        bindKey: o("Ctrl-Home", "Command-Home|Command-Up"),
                        exec: function(e) {
                            e.navigateFileStart();
                        },
                        multiSelectAction: "forEach",
                        readOnly: !0,
                        scrollIntoView: "animate",
                        aceCommandGroup: "fileJump"
                    },
                    {
                        name: "selectup",
                        description: "Select up",
                        bindKey: o("Shift-Up", "Shift-Up|Ctrl-Shift-P"),
                        exec: function(e) {
                            e.getSelection().selectUp();
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor",
                        readOnly: !0
                    },
                    {
                        name: "golineup",
                        description: "Go line up",
                        bindKey: o("Up", "Up|Ctrl-P"),
                        exec: function(e, t) {
                            e.navigateUp(t.times);
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor",
                        readOnly: !0
                    },
                    {
                        name: "selecttoend",
                        description: "Select to end",
                        bindKey: o("Ctrl-Shift-End", "Command-Shift-End|Command-Shift-Down"),
                        exec: function(e) {
                            e.getSelection().selectFileEnd();
                        },
                        multiSelectAction: "forEach",
                        readOnly: !0,
                        scrollIntoView: "animate",
                        aceCommandGroup: "fileJump"
                    },
                    {
                        name: "gotoend",
                        description: "Go to end",
                        bindKey: o("Ctrl-End", "Command-End|Command-Down"),
                        exec: function(e) {
                            e.navigateFileEnd();
                        },
                        multiSelectAction: "forEach",
                        readOnly: !0,
                        scrollIntoView: "animate",
                        aceCommandGroup: "fileJump"
                    },
                    {
                        name: "selectdown",
                        description: "Select down",
                        bindKey: o("Shift-Down", "Shift-Down|Ctrl-Shift-N"),
                        exec: function(e) {
                            e.getSelection().selectDown();
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor",
                        readOnly: !0
                    },
                    {
                        name: "golinedown",
                        description: "Go line down",
                        bindKey: o("Down", "Down|Ctrl-N"),
                        exec: function(e, t) {
                            e.navigateDown(t.times);
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor",
                        readOnly: !0
                    },
                    {
                        name: "selectwordleft",
                        description: "Select word left",
                        bindKey: o("Ctrl-Shift-Left", "Option-Shift-Left"),
                        exec: function(e) {
                            e.getSelection().selectWordLeft();
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor",
                        readOnly: !0
                    },
                    {
                        name: "gotowordleft",
                        description: "Go to word left",
                        bindKey: o("Ctrl-Left", "Option-Left"),
                        exec: function(e) {
                            e.navigateWordLeft();
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor",
                        readOnly: !0
                    },
                    {
                        name: "selecttolinestart",
                        description: "Select to line start",
                        bindKey: o("Alt-Shift-Left", "Command-Shift-Left|Ctrl-Shift-A"),
                        exec: function(e) {
                            e.getSelection().selectLineStart();
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor",
                        readOnly: !0
                    },
                    {
                        name: "gotolinestart",
                        description: "Go to line start",
                        bindKey: o("Alt-Left|Home", "Command-Left|Home|Ctrl-A"),
                        exec: function(e) {
                            e.navigateLineStart();
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor",
                        readOnly: !0
                    },
                    {
                        name: "selectleft",
                        description: "Select left",
                        bindKey: o("Shift-Left", "Shift-Left|Ctrl-Shift-B"),
                        exec: function(e) {
                            e.getSelection().selectLeft();
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor",
                        readOnly: !0
                    },
                    {
                        name: "gotoleft",
                        description: "Go to left",
                        bindKey: o("Left", "Left|Ctrl-B"),
                        exec: function(e, t) {
                            e.navigateLeft(t.times);
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor",
                        readOnly: !0
                    },
                    {
                        name: "selectwordright",
                        description: "Select word right",
                        bindKey: o("Ctrl-Shift-Right", "Option-Shift-Right"),
                        exec: function(e) {
                            e.getSelection().selectWordRight();
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor",
                        readOnly: !0
                    },
                    {
                        name: "gotowordright",
                        description: "Go to word right",
                        bindKey: o("Ctrl-Right", "Option-Right"),
                        exec: function(e) {
                            e.navigateWordRight();
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor",
                        readOnly: !0
                    },
                    {
                        name: "selecttolineend",
                        description: "Select to line end",
                        bindKey: o("Alt-Shift-Right", "Command-Shift-Right|Shift-End|Ctrl-Shift-E"),
                        exec: function(e) {
                            e.getSelection().selectLineEnd();
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor",
                        readOnly: !0
                    },
                    {
                        name: "gotolineend",
                        description: "Go to line end",
                        bindKey: o("Alt-Right|End", "Command-Right|End|Ctrl-E"),
                        exec: function(e) {
                            e.navigateLineEnd();
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor",
                        readOnly: !0
                    },
                    {
                        name: "selectright",
                        description: "Select right",
                        bindKey: o("Shift-Right", "Shift-Right"),
                        exec: function(e) {
                            e.getSelection().selectRight();
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor",
                        readOnly: !0
                    },
                    {
                        name: "gotoright",
                        description: "Go to right",
                        bindKey: o("Right", "Right|Ctrl-F"),
                        exec: function(e, t) {
                            e.navigateRight(t.times);
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor",
                        readOnly: !0
                    },
                    {
                        name: "selectpagedown",
                        description: "Select page down",
                        bindKey: "Shift-PageDown",
                        exec: function(e) {
                            e.selectPageDown();
                        },
                        readOnly: !0
                    },
                    {
                        name: "pagedown",
                        description: "Page down",
                        bindKey: o(null, "Option-PageDown"),
                        exec: function(e) {
                            e.scrollPageDown();
                        },
                        readOnly: !0
                    },
                    {
                        name: "gotopagedown",
                        description: "Go to page down",
                        bindKey: o("PageDown", "PageDown|Ctrl-V"),
                        exec: function(e) {
                            e.gotoPageDown();
                        },
                        readOnly: !0
                    },
                    {
                        name: "selectpageup",
                        description: "Select page up",
                        bindKey: "Shift-PageUp",
                        exec: function(e) {
                            e.selectPageUp();
                        },
                        readOnly: !0
                    },
                    {
                        name: "pageup",
                        description: "Page up",
                        bindKey: o(null, "Option-PageUp"),
                        exec: function(e) {
                            e.scrollPageUp();
                        },
                        readOnly: !0
                    },
                    {
                        name: "gotopageup",
                        description: "Go to page up",
                        bindKey: "PageUp",
                        exec: function(e) {
                            e.gotoPageUp();
                        },
                        readOnly: !0
                    },
                    {
                        name: "scrollup",
                        description: "Scroll up",
                        bindKey: o("Ctrl-Up", null),
                        exec: function(e) {
                            e.renderer.scrollBy(0, -2 * e.renderer.layerConfig.lineHeight);
                        },
                        readOnly: !0
                    },
                    {
                        name: "scrolldown",
                        description: "Scroll down",
                        bindKey: o("Ctrl-Down", null),
                        exec: function(e) {
                            e.renderer.scrollBy(0, 2 * e.renderer.layerConfig.lineHeight);
                        },
                        readOnly: !0
                    },
                    {
                        name: "selectlinestart",
                        description: "Select line start",
                        bindKey: "Shift-Home",
                        exec: function(e) {
                            e.getSelection().selectLineStart();
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor",
                        readOnly: !0
                    },
                    {
                        name: "selectlineend",
                        description: "Select line end",
                        bindKey: "Shift-End",
                        exec: function(e) {
                            e.getSelection().selectLineEnd();
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor",
                        readOnly: !0
                    },
                    {
                        name: "togglerecording",
                        description: "Toggle recording",
                        bindKey: o("Ctrl-Alt-E", "Command-Option-E"),
                        exec: function(e) {
                            e.commands.toggleRecording(e);
                        },
                        readOnly: !0
                    },
                    {
                        name: "replaymacro",
                        description: "Replay macro",
                        bindKey: o("Ctrl-Shift-E", "Command-Shift-E"),
                        exec: function(e) {
                            e.commands.replay(e);
                        },
                        readOnly: !0
                    },
                    {
                        name: "jumptomatching",
                        description: "Jump to matching",
                        bindKey: o("Ctrl-\\|Ctrl-P", "Command-\\"),
                        exec: function(e) {
                            e.jumpToMatching();
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "animate",
                        readOnly: !0
                    },
                    {
                        name: "selecttomatching",
                        description: "Select to matching",
                        bindKey: o("Ctrl-Shift-\\|Ctrl-Shift-P", "Command-Shift-\\"),
                        exec: function(e) {
                            e.jumpToMatching(!0);
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "animate",
                        readOnly: !0
                    },
                    {
                        name: "expandToMatching",
                        description: "Expand to matching",
                        bindKey: o("Ctrl-Shift-M", "Ctrl-Shift-M"),
                        exec: function(e) {
                            e.jumpToMatching(!0, !0);
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "animate",
                        readOnly: !0
                    },
                    {
                        name: "passKeysToBrowser",
                        description: "Pass keys to browser",
                        bindKey: o(null, null),
                        exec: function() {},
                        passEvent: !0,
                        readOnly: !0
                    },
                    {
                        name: "copy",
                        description: "Copy",
                        exec: function(e) {},
                        readOnly: !0
                    },
                    {
                        name: "cut",
                        description: "Cut",
                        exec: function(e) {
                            var t = e.$copyWithEmptySelection && e.selection.isEmpty() ? e.selection.getLineRange() : e.selection.getRange();
                            e._emit("cut", t), t.isEmpty() || e.session.remove(t), e.clearSelection();
                        },
                        scrollIntoView: "cursor",
                        multiSelectAction: "forEach"
                    },
                    {
                        name: "paste",
                        description: "Paste",
                        exec: function(e, t) {
                            e.$handlePaste(t);
                        },
                        scrollIntoView: "cursor"
                    },
                    {
                        name: "removeline",
                        description: "Remove line",
                        bindKey: o("Ctrl-D", "Command-D"),
                        exec: function(e) {
                            e.removeLines();
                        },
                        scrollIntoView: "cursor",
                        multiSelectAction: "forEachLine"
                    },
                    {
                        name: "duplicateSelection",
                        description: "Duplicate selection",
                        bindKey: o("Ctrl-Shift-D", "Command-Shift-D"),
                        exec: function(e) {
                            e.duplicateSelection();
                        },
                        scrollIntoView: "cursor",
                        multiSelectAction: "forEach"
                    },
                    {
                        name: "sortlines",
                        description: "Sort lines",
                        bindKey: o("Ctrl-Alt-S", "Command-Alt-S"),
                        exec: function(e) {
                            e.sortLines();
                        },
                        scrollIntoView: "selection",
                        multiSelectAction: "forEachLine"
                    },
                    {
                        name: "togglecomment",
                        description: "Toggle comment",
                        bindKey: o("Ctrl-/", "Command-/"),
                        exec: function(e) {
                            e.toggleCommentLines();
                        },
                        multiSelectAction: "forEachLine",
                        scrollIntoView: "selectionPart"
                    },
                    {
                        name: "toggleBlockComment",
                        description: "Toggle block comment",
                        bindKey: o("Ctrl-Shift-/", "Command-Shift-/"),
                        exec: function(e) {
                            e.toggleBlockComment();
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "selectionPart"
                    },
                    {
                        name: "modifyNumberUp",
                        description: "Modify number up",
                        bindKey: o("Ctrl-Shift-Up", "Alt-Shift-Up"),
                        exec: function(e) {
                            e.modifyNumber(1);
                        },
                        scrollIntoView: "cursor",
                        multiSelectAction: "forEach"
                    },
                    {
                        name: "modifyNumberDown",
                        description: "Modify number down",
                        bindKey: o("Ctrl-Shift-Down", "Alt-Shift-Down"),
                        exec: function(e) {
                            e.modifyNumber(-1);
                        },
                        scrollIntoView: "cursor",
                        multiSelectAction: "forEach"
                    },
                    {
                        name: "replace",
                        description: "Replace",
                        bindKey: o("Ctrl-H", "Command-Option-F"),
                        exec: function(t) {
                            n.loadModule("ace/ext/searchbox", function(e) {
                                e.Search(t, !0);
                            });
                        }
                    },
                    {
                        name: "undo",
                        description: "Undo",
                        bindKey: o("Ctrl-Z", "Command-Z"),
                        exec: function(e) {
                            e.undo();
                        }
                    },
                    {
                        name: "redo",
                        description: "Redo",
                        bindKey: o("Ctrl-Shift-Z|Ctrl-Y", "Command-Shift-Z|Command-Y"),
                        exec: function(e) {
                            e.redo();
                        }
                    },
                    {
                        name: "copylinesup",
                        description: "Copy lines up",
                        bindKey: o("Alt-Shift-Up", "Command-Option-Up"),
                        exec: function(e) {
                            e.copyLinesUp();
                        },
                        scrollIntoView: "cursor"
                    },
                    {
                        name: "movelinesup",
                        description: "Move lines up",
                        bindKey: o("Alt-Up", "Option-Up"),
                        exec: function(e) {
                            e.moveLinesUp();
                        },
                        scrollIntoView: "cursor"
                    },
                    {
                        name: "copylinesdown",
                        description: "Copy lines down",
                        bindKey: o("Alt-Shift-Down", "Command-Option-Down"),
                        exec: function(e) {
                            e.copyLinesDown();
                        },
                        scrollIntoView: "cursor"
                    },
                    {
                        name: "movelinesdown",
                        description: "Move lines down",
                        bindKey: o("Alt-Down", "Option-Down"),
                        exec: function(e) {
                            e.moveLinesDown();
                        },
                        scrollIntoView: "cursor"
                    },
                    {
                        name: "del",
                        description: "Delete",
                        bindKey: o("Delete", "Delete|Ctrl-D|Shift-Delete"),
                        exec: function(e) {
                            e.remove("right");
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor"
                    },
                    {
                        name: "backspace",
                        description: "Backspace",
                        bindKey: o("Shift-Backspace|Backspace", "Ctrl-Backspace|Shift-Backspace|Backspace|Ctrl-H"),
                        exec: function(e) {
                            e.remove("left");
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor"
                    },
                    {
                        name: "cut_or_delete",
                        description: "Cut or delete",
                        bindKey: o("Shift-Delete", null),
                        exec: function(e) {
                            if (!e.selection.isEmpty()) return !1;
                            e.remove("left");
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor"
                    },
                    {
                        name: "removetolinestart",
                        description: "Remove to line start",
                        bindKey: o("Alt-Backspace", "Command-Backspace"),
                        exec: function(e) {
                            e.removeToLineStart();
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor"
                    },
                    {
                        name: "removetolineend",
                        description: "Remove to line end",
                        bindKey: o("Alt-Delete", "Ctrl-K|Command-Delete"),
                        exec: function(e) {
                            e.removeToLineEnd();
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor"
                    },
                    {
                        name: "removetolinestarthard",
                        description: "Remove to line start hard",
                        bindKey: o("Ctrl-Shift-Backspace", null),
                        exec: function(e) {
                            var t = e.selection.getRange();
                            t.start.column = 0, e.session.remove(t);
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor"
                    },
                    {
                        name: "removetolineendhard",
                        description: "Remove to line end hard",
                        bindKey: o("Ctrl-Shift-Delete", null),
                        exec: function(e) {
                            var t = e.selection.getRange();
                            t.end.column = Number.MAX_VALUE, e.session.remove(t);
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor"
                    },
                    {
                        name: "removewordleft",
                        description: "Remove word left",
                        bindKey: o("Ctrl-Backspace", "Alt-Backspace|Ctrl-Alt-Backspace"),
                        exec: function(e) {
                            e.removeWordLeft();
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor"
                    },
                    {
                        name: "removewordright",
                        description: "Remove word right",
                        bindKey: o("Ctrl-Delete", "Alt-Delete"),
                        exec: function(e) {
                            e.removeWordRight();
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor"
                    },
                    {
                        name: "outdent",
                        description: "Outdent",
                        bindKey: o("Shift-Tab", "Shift-Tab"),
                        exec: function(e) {
                            e.blockOutdent();
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "selectionPart"
                    },
                    {
                        name: "indent",
                        description: "Indent",
                        bindKey: o("Tab", "Tab"),
                        exec: function(e) {
                            e.indent();
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "selectionPart"
                    },
                    {
                        name: "blockoutdent",
                        description: "Block outdent",
                        bindKey: o("Ctrl-[", "Ctrl-["),
                        exec: function(e) {
                            e.blockOutdent();
                        },
                        multiSelectAction: "forEachLine",
                        scrollIntoView: "selectionPart"
                    },
                    {
                        name: "blockindent",
                        description: "Block indent",
                        bindKey: o("Ctrl-]", "Ctrl-]"),
                        exec: function(e) {
                            e.blockIndent();
                        },
                        multiSelectAction: "forEachLine",
                        scrollIntoView: "selectionPart"
                    },
                    {
                        name: "insertstring",
                        description: "Insert string",
                        exec: function(e, t) {
                            e.insert(t);
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor"
                    },
                    {
                        name: "inserttext",
                        description: "Insert text",
                        exec: function(e, t) {
                            e.insert(l.stringRepeat(t.text || "", t.times || 1));
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor"
                    },
                    {
                        name: "splitline",
                        description: "Split line",
                        bindKey: o(null, "Ctrl-O"),
                        exec: function(e) {
                            e.splitLine();
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor"
                    },
                    {
                        name: "transposeletters",
                        description: "Transpose letters",
                        bindKey: o("Alt-Shift-X", "Ctrl-T"),
                        exec: function(e) {
                            e.transposeLetters();
                        },
                        multiSelectAction: function(e) {
                            e.transposeSelections(1);
                        },
                        scrollIntoView: "cursor"
                    },
                    {
                        name: "touppercase",
                        description: "To uppercase",
                        bindKey: o("Ctrl-U", "Ctrl-U"),
                        exec: function(e) {
                            e.toUpperCase();
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor"
                    },
                    {
                        name: "tolowercase",
                        description: "To lowercase",
                        bindKey: o("Ctrl-Shift-U", "Ctrl-Shift-U"),
                        exec: function(e) {
                            e.toLowerCase();
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor"
                    },
                    {
                        name: "autoindent",
                        description: "Auto Indent",
                        bindKey: o(null, null),
                        exec: function(e) {
                            e.autoIndent();
                        },
                        scrollIntoView: "animate"
                    },
                    {
                        name: "expandtoline",
                        description: "Expand to line",
                        bindKey: o("Ctrl-Shift-L", "Command-Shift-L"),
                        exec: function(e) {
                            var t = e.selection.getRange();
                            t.start.column = t.end.column = 0, t.end.row++, e.selection.setRange(t, !1);
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor",
                        readOnly: !0
                    },
                    {
                        name: "openlink",
                        bindKey: o("Ctrl+F3", "F3"),
                        exec: function(e) {
                            e.openLink();
                        }
                    },
                    {
                        name: "joinlines",
                        description: "Join lines",
                        bindKey: o(null, null),
                        exec: function(e) {
                            for(var t = e.selection.isBackwards(), i = t ? e.selection.getSelectionLead() : e.selection.getSelectionAnchor(), n = t ? e.selection.getSelectionAnchor() : e.selection.getSelectionLead(), t = e.session.doc.getLine(i.row).length, o = e.session.doc.getTextRange(e.selection.getRange()).replace(/\n\s*/, " ").length, r = e.session.doc.getLine(i.row), s = i.row + 1; s <= n.row + 1; s++){
                                var a = l.stringTrimLeft(l.stringTrimRight(e.session.doc.getLine(s)));
                                r += a = 0 !== a.length ? " " + a : a;
                            }
                            n.row + 1 < e.session.doc.getLength() - 1 && (r += e.session.doc.getNewLineCharacter()), e.clearSelection(), e.session.doc.replace(new c(i.row, 0, n.row + 2, 0), r), 0 < o ? (e.selection.moveCursorTo(i.row, i.column), e.selection.selectTo(i.row, i.column + o)) : (t = e.session.doc.getLine(i.row).length > t ? t + 1 : t, e.selection.moveCursorTo(i.row, t));
                        },
                        multiSelectAction: "forEach",
                        readOnly: !0
                    },
                    {
                        name: "invertSelection",
                        description: "Invert selection",
                        bindKey: o(null, null),
                        exec: function(e) {
                            var t = e.session.doc.getLength() - 1, i = e.session.doc.getLine(t).length, n = e.selection.rangeList.ranges, o = [];
                            n.length < 1 && (n = [
                                e.selection.getRange()
                            ]);
                            for(var r = 0; r < n.length; r++)r != n.length - 1 || n[r].end.row === t && n[r].end.column === i || o.push(new c(n[r].end.row, n[r].end.column, t, i)), 0 === r ? 0 === n[r].start.row && 0 === n[r].start.column || o.push(new c(0, 0, n[r].start.row, n[r].start.column)) : o.push(new c(n[r - 1].end.row, n[r - 1].end.column, n[r].start.row, n[r].start.column));
                            e.exitMultiSelectMode(), e.clearSelection();
                            for(r = 0; r < o.length; r++)e.selection.addRange(o[r], !1);
                        },
                        readOnly: !0,
                        scrollIntoView: "none"
                    },
                    {
                        name: "addLineAfter",
                        description: "Add new line after the current line",
                        exec: function(e) {
                            e.selection.clearSelection(), e.navigateLineEnd(), e.insert("\n");
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor"
                    },
                    {
                        name: "addLineBefore",
                        description: "Add new line before the current line",
                        exec: function(e) {
                            e.selection.clearSelection();
                            var t = e.getCursorPosition();
                            e.selection.moveTo(t.row - 1, Number.MAX_VALUE), e.insert("\n"), 0 === t.row && e.navigateUp();
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor"
                    },
                    {
                        name: "openCommandPallete",
                        exec: function(e) {
                            console.warn("This is an obsolete command. Please use `openCommandPalette` instead."), e.prompt({
                                $type: "commands"
                            });
                        },
                        readOnly: !0
                    },
                    {
                        name: "openCommandPalette",
                        description: "Open command palette",
                        bindKey: o("F1", "F1"),
                        exec: function(e) {
                            e.prompt({
                                $type: "commands"
                            });
                        },
                        readOnly: !0
                    },
                    {
                        name: "modeSelect",
                        description: "Change language mode...",
                        bindKey: o(null, null),
                        exec: function(e) {
                            e.prompt({
                                $type: "modes"
                            });
                        },
                        readOnly: !0
                    }
                ];
                for(var r = 1; r < 9; r++)t.commands.push({
                    name: "foldToLevel" + r,
                    description: "Fold To Level " + r,
                    level: r,
                    exec: function(e) {
                        e.session.foldToLevel(this.level);
                    },
                    scrollIntoView: "center",
                    readOnly: !0
                });
            }), ace.define("ace/keyboard/gutter_handler", [
                "require",
                "exports",
                "module",
                "ace/lib/keys"
            ], function(e, t, i) {
                var n = e("../lib/keys");
                function o(e) {
                    this.editor = e, this.gutterLayer = e.renderer.$gutterLayer, this.element = e.renderer.$gutter, this.lines = e.renderer.$gutterLayer.$lines, this.activeRowIndex = null, this.activeLane = null, this.annotationTooltip = this.editor.$mouseHandler.$tooltip;
                }
                o.prototype.addListener = function() {
                    this.element.addEventListener("keydown", this.$onGutterKeyDown.bind(this)), this.element.addEventListener("focusout", this.$blurGutter.bind(this)), this.editor.on("mousewheel", this.$blurGutter.bind(this));
                }, o.prototype.removeListener = function() {
                    this.element.removeEventListener("keydown", this.$onGutterKeyDown.bind(this)), this.element.removeEventListener("focusout", this.$blurGutter.bind(this)), this.editor.off("mousewheel", this.$blurGutter.bind(this));
                }, o.prototype.$onGutterKeyDown = function(e) {
                    var t;
                    this.annotationTooltip.isOpen ? (e.preventDefault(), e.keyCode === n.escape && this.annotationTooltip.hide()) : e.target === this.element ? e.keyCode == n.enter && (e.preventDefault(), t = this.editor.getCursorPosition().row, this.editor.isRowVisible(t) || this.editor.scrollToLine(t, !0, !0), setTimeout((function() {
                        var e = this.$rowToRowIndex(this.gutterLayer.$cursorCell.row), t = this.$findNearestFoldLaneWidget(e), i = this.$findNearestAnnotation(e);
                        null === t && null === i || (this.$findClosestNumber(t, i, e) === t ? (this.activeLane = "fold", this.activeRowIndex = t, this.$isCustomWidgetVisible(t) ? this.$focusCustomWidget(this.activeRowIndex) : this.$focusFoldWidget(this.activeRowIndex)) : (this.activeRowIndex = i, this.activeLane = "annotation", this.$focusAnnotation(this.activeRowIndex)));
                    }).bind(this), 10)) : (this.$handleGutterKeyboardInteraction(e), setTimeout((function() {
                        this.editor._signal("gutterkeydown", new r(e, this));
                    }).bind(this), 10));
                }, o.prototype.$handleGutterKeyboardInteraction = function(e) {
                    if (e.keyCode === n.tab) e.preventDefault();
                    else if (e.keyCode === n.escape) e.preventDefault(), this.$blurGutter(), this.element.focus(), this.lane = null;
                    else if (e.keyCode === n.up) switch(e.preventDefault(), this.activeLane){
                        case "fold":
                            this.$moveFoldWidgetUp();
                            break;
                        case "annotation":
                            this.$moveAnnotationUp();
                    }
                    else if (e.keyCode === n.down) switch(e.preventDefault(), this.activeLane){
                        case "fold":
                            this.$moveFoldWidgetDown();
                            break;
                        case "annotation":
                            this.$moveAnnotationDown();
                    }
                    else if (e.keyCode === n.left) e.preventDefault(), this.$switchLane("annotation");
                    else if (e.keyCode === n.right) e.preventDefault(), this.$switchLane("fold");
                    else if (e.keyCode === n.enter || e.keyCode === n.space) switch(e.preventDefault(), this.activeLane){
                        case "fold":
                            var t = this.$rowIndexToRow(this.activeRowIndex), i = this.editor.session.$gutterCustomWidgets[t];
                            if (i) i.callbacks && i.callbacks.onClick && i.callbacks.onClick(e, t);
                            else {
                                if ("start" === this.gutterLayer.session.foldWidgets[t]) {
                                    this.editor.session.onFoldWidgetClick(this.$rowIndexToRow(this.activeRowIndex), e), setTimeout((function() {
                                        this.$rowIndexToRow(this.activeRowIndex) !== t && (this.$blurFoldWidget(this.activeRowIndex), this.activeRowIndex = this.$rowToRowIndex(t), this.$focusFoldWidget(this.activeRowIndex));
                                    }).bind(this), 10);
                                    break;
                                }
                                if ("end" === this.gutterLayer.session.foldWidgets[this.$rowIndexToRow(this.activeRowIndex)]) break;
                            }
                            return;
                        case "annotation":
                            this.annotationTooltip.showTooltip(this.$rowIndexToRow(this.activeRowIndex)), this.annotationTooltip.$fromKeyboard = !0;
                    }
                }, o.prototype.$blurGutter = function() {
                    if (null !== this.activeRowIndex) switch(this.activeLane){
                        case "fold":
                            this.$blurFoldWidget(this.activeRowIndex), this.$blurCustomWidget(this.activeRowIndex);
                            break;
                        case "annotation":
                            this.$blurAnnotation(this.activeRowIndex);
                    }
                    this.annotationTooltip.isOpen && this.annotationTooltip.hide();
                }, o.prototype.$isFoldWidgetVisible = function(e) {
                    var t = this.editor.isRowFullyVisible(this.$rowIndexToRow(e)), e = "none" !== this.$getFoldWidget(e).style.display;
                    return t && e;
                }, o.prototype.$isCustomWidgetVisible = function(e) {
                    var t = this.editor.isRowFullyVisible(this.$rowIndexToRow(e)), e = !!this.$getCustomWidget(e);
                    return t && e;
                }, o.prototype.$isAnnotationVisible = function(e) {
                    var t = this.editor.isRowFullyVisible(this.$rowIndexToRow(e)), e = "none" !== this.$getAnnotation(e).style.display;
                    return t && e;
                }, o.prototype.$getFoldWidget = function(e) {
                    return this.lines.get(e).element.childNodes[1];
                }, o.prototype.$getCustomWidget = function(e) {
                    return this.lines.get(e).element.childNodes[3];
                }, o.prototype.$getAnnotation = function(e) {
                    return this.lines.get(e).element.childNodes[2];
                }, o.prototype.$findNearestFoldLaneWidget = function(e) {
                    if (this.$isCustomWidgetVisible(e)) return e;
                    if (this.$isFoldWidgetVisible(e)) return e;
                    for(var t = 0; 0 < e - t || e + t < this.lines.getLength() - 1;){
                        if (0 <= e - ++t && this.$isCustomWidgetVisible(e - t)) return e - t;
                        if (e + t <= this.lines.getLength() - 1 && this.$isCustomWidgetVisible(e + t)) return e + t;
                        if (0 <= e - t && this.$isFoldWidgetVisible(e - t)) return e - t;
                        if (e + t <= this.lines.getLength() - 1 && this.$isFoldWidgetVisible(e + t)) return e + t;
                    }
                    return null;
                }, o.prototype.$findNearestAnnotation = function(e) {
                    if (this.$isAnnotationVisible(e)) return e;
                    for(var t = 0; 0 < e - t || e + t < this.lines.getLength() - 1;){
                        if (0 <= e - ++t && this.$isAnnotationVisible(e - t)) return e - t;
                        if (e + t <= this.lines.getLength() - 1 && this.$isAnnotationVisible(e + t)) return e + t;
                    }
                    return null;
                }, o.prototype.$focusFoldWidget = function(e) {
                    null != e && ((e = this.$getFoldWidget(e)).classList.add(this.editor.renderer.keyboardFocusClassName), e.focus());
                }, o.prototype.$focusCustomWidget = function(e) {
                    null != e && (e = this.$getCustomWidget(e)) && (e.classList.add(this.editor.renderer.keyboardFocusClassName), e.focus());
                }, o.prototype.$focusAnnotation = function(e) {
                    null != e && ((e = this.$getAnnotation(e)).classList.add(this.editor.renderer.keyboardFocusClassName), e.focus());
                }, o.prototype.$blurFoldWidget = function(e) {
                    e = this.$getFoldWidget(e);
                    e.classList.remove(this.editor.renderer.keyboardFocusClassName), e.blur();
                }, o.prototype.$blurCustomWidget = function(e) {
                    e = this.$getCustomWidget(e);
                    e && (e.classList.remove(this.editor.renderer.keyboardFocusClassName), e.blur());
                }, o.prototype.$blurAnnotation = function(e) {
                    e = this.$getAnnotation(e);
                    e.classList.remove(this.editor.renderer.keyboardFocusClassName), e.blur();
                }, o.prototype.$moveFoldWidgetUp = function() {
                    for(var e = this.activeRowIndex; 0 < e;)if (this.$isFoldWidgetVisible(--e) || this.$isCustomWidgetVisible(e)) return this.$blurFoldWidget(this.activeRowIndex), this.$blurCustomWidget(this.activeRowIndex), this.activeRowIndex = e, void (this.$isFoldWidgetVisible(e) ? this.$focusFoldWidget(this.activeRowIndex) : this.$focusCustomWidget(this.activeRowIndex));
                }, o.prototype.$moveFoldWidgetDown = function() {
                    for(var e = this.activeRowIndex; e < this.lines.getLength() - 1;)if (this.$isFoldWidgetVisible(++e) || this.$isCustomWidgetVisible(e)) return this.$blurFoldWidget(this.activeRowIndex), this.$blurCustomWidget(this.activeRowIndex), this.activeRowIndex = e, void (this.$isFoldWidgetVisible(e) ? this.$focusFoldWidget(this.activeRowIndex) : this.$focusCustomWidget(this.activeRowIndex));
                }, o.prototype.$moveAnnotationUp = function() {
                    for(var e = this.activeRowIndex; 0 < e;)if (this.$isAnnotationVisible(--e)) return this.$blurAnnotation(this.activeRowIndex), this.activeRowIndex = e, void this.$focusAnnotation(this.activeRowIndex);
                }, o.prototype.$moveAnnotationDown = function() {
                    for(var e = this.activeRowIndex; e < this.lines.getLength() - 1;)if (this.$isAnnotationVisible(++e)) return this.$blurAnnotation(this.activeRowIndex), this.activeRowIndex = e, void this.$focusAnnotation(this.activeRowIndex);
                }, o.prototype.$findClosestNumber = function(e, t, i) {
                    return null !== e && (null === t || Math.abs(i - e) <= Math.abs(i - t)) ? e : t;
                }, o.prototype.$switchLane = function(e) {
                    switch(e){
                        case "annotation":
                            "annotation" !== this.activeLane && null != (t = this.$findNearestAnnotation(this.activeRowIndex)) && (this.activeLane = "annotation", this.$blurFoldWidget(this.activeRowIndex), this.$blurCustomWidget(this.activeRowIndex), this.activeRowIndex = t, this.$focusAnnotation(this.activeRowIndex));
                            break;
                        case "fold":
                            var t;
                            "fold" !== this.activeLane && null !== (t = this.$findNearestFoldLaneWidget(this.activeRowIndex)) && (this.activeLane = "fold", this.$blurAnnotation(this.activeRowIndex), this.activeRowIndex = t, this.$isCustomWidgetVisible(t) ? this.$focusCustomWidget(this.activeRowIndex) : this.$focusFoldWidget(this.activeRowIndex));
                    }
                }, o.prototype.$rowIndexToRow = function(e) {
                    e = this.lines.get(e);
                    return e ? e.row : null;
                }, o.prototype.$rowToRowIndex = function(e) {
                    for(var t = 0; t < this.lines.getLength(); t++)if (this.lines.get(t).row == e) return t;
                    return null;
                }, t.GutterKeyboardHandler = o;
                s.prototype.getKey = function() {
                    return n.keyCodeToString(this.domEvent.keyCode);
                }, s.prototype.getRow = function() {
                    return this.gutterKeyboardHandler.$rowIndexToRow(this.gutterKeyboardHandler.activeRowIndex);
                }, s.prototype.isInAnnotationLane = function() {
                    return "annotation" === this.gutterKeyboardHandler.activeLane;
                }, s.prototype.isInFoldLane = function() {
                    return "fold" === this.gutterKeyboardHandler.activeLane;
                };
                var r = s;
                function s(e, t) {
                    this.gutterKeyboardHandler = t, this.domEvent = e;
                }
                t.GutterKeyboardEvent = r;
            }), ace.define("ace/editor", [
                "require",
                "exports",
                "module",
                "ace/lib/oop",
                "ace/lib/dom",
                "ace/lib/lang",
                "ace/lib/useragent",
                "ace/keyboard/textinput",
                "ace/mouse/mouse_handler",
                "ace/mouse/fold_handler",
                "ace/keyboard/keybinding",
                "ace/edit_session",
                "ace/search",
                "ace/range",
                "ace/lib/event_emitter",
                "ace/commands/command_manager",
                "ace/commands/default_commands",
                "ace/config",
                "ace/token_iterator",
                "ace/keyboard/gutter_handler",
                "ace/config",
                "ace/clipboard",
                "ace/lib/keys",
                "ace/lib/event",
                "ace/tooltip"
            ], function(e, t, i) {
                var d = this && this.__values || function(e) {
                    var t = "function" == typeof Symbol && Symbol.iterator, i = t && e[t], n = 0;
                    if (i) return i.call(e);
                    if (e && "number" == typeof e.length) return {
                        next: function() {
                            return {
                                value: (e = e && n >= e.length ? void 0 : e) && e[n++],
                                done: !e
                            };
                        }
                    };
                    throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
                }, o = e("./lib/oop"), n = e("./lib/dom"), m = e("./lib/lang"), r = e("./lib/useragent"), s = e("./keyboard/textinput").TextInput, a = e("./mouse/mouse_handler").MouseHandler, l = e("./mouse/fold_handler").FoldHandler, c = e("./keyboard/keybinding").KeyBinding, h = e("./edit_session").EditSession, u = e("./search").Search, f = e("./range").Range, g = e("./lib/event_emitter").EventEmitter, p = e("./commands/command_manager").CommandManager, C = e("./commands/default_commands").commands, y = e("./config"), v = e("./token_iterator").TokenIterator, I = e("./keyboard/gutter_handler").GutterKeyboardHandler, b = e("./config").nls, A = e("./clipboard"), w = e("./lib/keys"), x = e("./lib/event"), S = e("./tooltip").HoverTooltip, e = (k.prototype.$initOperationListeners = function() {
                    this.commands.on("exec", this.startOperation.bind(this), !0), this.commands.on("afterExec", this.endOperation.bind(this), !0);
                }, k.prototype.startOperation = function(e) {
                    this.session.startOperation(e);
                }, k.prototype.endOperation = function(e) {
                    this.session.endOperation(e);
                }, k.prototype.onStartOperation = function(e) {
                    this.curOp = this.session.curOp, this.curOp.scrollTop = this.renderer.scrollTop, this.prevOp = this.session.prevOp, e || (this.previousCommand = null);
                }, k.prototype.onEndOperation = function(e) {
                    if (this.curOp && this.session) {
                        if (e && !1 === e.returnValue) this.curOp = null;
                        else if (this._signal("beforeEndOperation"), this.curOp) {
                            var e = this.curOp.command, t = e && e.scrollIntoView;
                            if (t) {
                                switch(t){
                                    case "center-animate":
                                        t = "animate";
                                    case "center":
                                        this.renderer.scrollCursorIntoView(null, .5);
                                        break;
                                    case "animate":
                                    case "cursor":
                                        this.renderer.scrollCursorIntoView();
                                        break;
                                    case "selectionPart":
                                        var i = this.selection.getRange(), n = this.renderer.layerConfig;
                                        (i.start.row >= n.lastRow || i.end.row <= n.firstRow) && this.renderer.scrollSelectionIntoView(this.selection.anchor, this.selection.lead);
                                }
                                "animate" == t && this.renderer.animateScrolling(this.curOp.scrollTop);
                            }
                            this.$lastSel = this.session.selection.toJSON(), this.prevOp = this.curOp, this.curOp = null;
                        }
                    }
                }, k.prototype.$historyTracker = function(e) {
                    var t, i, n, o;
                    this.$mergeUndoDeltas && (t = this.prevOp, i = this.$mergeableCommands, n = t.command && e.command.name == t.command.name, "insertstring" == e.command.name ? (o = e.args, void 0 === this.mergeNextCommand && (this.mergeNextCommand = !0), n = n && this.mergeNextCommand && (!/\s/.test(o) || /\s/.test(t.args)), this.mergeNextCommand = !0) : n = n && -1 !== i.indexOf(e.command.name), (n = "always" != this.$mergeUndoDeltas && 2e3 < Date.now() - this.sequenceStartTime ? !1 : n) ? this.session.mergeUndoDeltas = !0 : -1 !== i.indexOf(e.command.name) && (this.sequenceStartTime = Date.now()));
                }, k.prototype.setKeyboardHandler = function(t, i) {
                    var n;
                    t && "string" == typeof t && "ace" != t ? (this.$keybindingId = t, n = this, y.loadModule([
                        "keybinding",
                        t
                    ], function(e) {
                        n.$keybindingId == t && n.keyBinding.setKeyboardHandler(e && e.handler), i && i();
                    })) : (this.$keybindingId = null, this.keyBinding.setKeyboardHandler(t), i && i());
                }, k.prototype.getKeyboardHandler = function() {
                    return this.keyBinding.getKeyboardHandler();
                }, k.prototype.setSession = function(e) {
                    var t, i;
                    this.session != e && (this.curOp && this.endOperation(), this.curOp = {}, (t = this.session) && (this.session.off("change", this.$onDocumentChange), this.session.off("changeMode", this.$onChangeMode), this.session.off("tokenizerUpdate", this.$onTokenizerUpdate), this.session.off("changeTabSize", this.$onChangeTabSize), this.session.off("changeWrapLimit", this.$onChangeWrapLimit), this.session.off("changeWrapMode", this.$onChangeWrapMode), this.session.off("changeFold", this.$onChangeFold), this.session.off("changeFrontMarker", this.$onChangeFrontMarker), this.session.off("changeBackMarker", this.$onChangeBackMarker), this.session.off("changeBreakpoint", this.$onChangeBreakpoint), this.session.off("changeAnnotation", this.$onChangeAnnotation), this.session.off("changeOverwrite", this.$onCursorChange), this.session.off("changeScrollTop", this.$onScrollTopChange), this.session.off("changeScrollLeft", this.$onScrollLeftChange), this.session.off("startOperation", this.$onStartOperation), this.session.off("endOperation", this.$onEndOperation), (i = this.session.getSelection()).off("changeCursor", this.$onCursorChange), i.off("changeSelection", this.$onSelectionChange)), (this.session = e) ? (this.$onDocumentChange = this.onDocumentChange.bind(this), e.on("change", this.$onDocumentChange), this.renderer.setSession(e), this.$onChangeMode = this.onChangeMode.bind(this), e.on("changeMode", this.$onChangeMode), this.$onTokenizerUpdate = this.onTokenizerUpdate.bind(this), e.on("tokenizerUpdate", this.$onTokenizerUpdate), this.$onChangeTabSize = this.renderer.onChangeTabSize.bind(this.renderer), e.on("changeTabSize", this.$onChangeTabSize), this.$onChangeWrapLimit = this.onChangeWrapLimit.bind(this), e.on("changeWrapLimit", this.$onChangeWrapLimit), this.$onChangeWrapMode = this.onChangeWrapMode.bind(this), e.on("changeWrapMode", this.$onChangeWrapMode), this.$onChangeFold = this.onChangeFold.bind(this), e.on("changeFold", this.$onChangeFold), this.$onChangeFrontMarker = this.onChangeFrontMarker.bind(this), this.session.on("changeFrontMarker", this.$onChangeFrontMarker), this.$onChangeBackMarker = this.onChangeBackMarker.bind(this), this.session.on("changeBackMarker", this.$onChangeBackMarker), this.$onChangeBreakpoint = this.onChangeBreakpoint.bind(this), this.session.on("changeBreakpoint", this.$onChangeBreakpoint), this.$onChangeAnnotation = this.onChangeAnnotation.bind(this), this.session.on("changeAnnotation", this.$onChangeAnnotation), this.$onCursorChange = this.onCursorChange.bind(this), this.session.on("changeOverwrite", this.$onCursorChange), this.$onScrollTopChange = this.onScrollTopChange.bind(this), this.session.on("changeScrollTop", this.$onScrollTopChange), this.$onScrollLeftChange = this.onScrollLeftChange.bind(this), this.session.on("changeScrollLeft", this.$onScrollLeftChange), this.selection = e.getSelection(), this.selection.on("changeCursor", this.$onCursorChange), this.$onSelectionChange = this.onSelectionChange.bind(this), this.selection.on("changeSelection", this.$onSelectionChange), this.$onStartOperation = this.onStartOperation.bind(this), this.session.on("startOperation", this.$onStartOperation), this.$onEndOperation = this.onEndOperation.bind(this), this.session.on("endOperation", this.$onEndOperation), this.onChangeMode(), this.onCursorChange(), this.onScrollTopChange(), this.onScrollLeftChange(), this.onSelectionChange(), this.onChangeFrontMarker(), this.onChangeBackMarker(), this.onChangeBreakpoint(), this.onChangeAnnotation(), this.session.getUseWrapMode() && this.renderer.adjustWrapLimit(), this.renderer.updateFull()) : (this.selection = null, this.renderer.setSession(e)), this._signal("changeSession", {
                        session: e,
                        oldSession: t
                    }), this.curOp = null, t && t._signal("changeEditor", {
                        oldEditor: this
                    }), t && (t.$editor = null), e && e._signal("changeEditor", {
                        editor: this
                    }), e && (e.$editor = this), e) && !e.destroyed && e.bgTokenizer.scheduleStart();
                }, k.prototype.getSession = function() {
                    return this.session;
                }, k.prototype.setValue = function(e, t) {
                    return this.session.doc.setValue(e), t ? 1 == t ? this.navigateFileEnd() : -1 == t && this.navigateFileStart() : this.selectAll(), e;
                }, k.prototype.getValue = function() {
                    return this.session.getValue();
                }, k.prototype.getSelection = function() {
                    return this.selection;
                }, k.prototype.resize = function(e) {
                    this.renderer.onResize(e);
                }, k.prototype.setTheme = function(e, t) {
                    this.renderer.setTheme(e, t);
                }, k.prototype.getTheme = function() {
                    return this.renderer.getTheme();
                }, k.prototype.setStyle = function(e, t) {
                    this.renderer.setStyle(e, t);
                }, k.prototype.unsetStyle = function(e) {
                    this.renderer.unsetStyle(e);
                }, k.prototype.getFontSize = function() {
                    return this.getOption("fontSize") || n.computedStyle(this.container).fontSize;
                }, k.prototype.setFontSize = function(e) {
                    this.setOption("fontSize", e);
                }, k.prototype.$highlightBrackets = function() {
                    var r;
                    this.$highlightPending || ((r = this).$highlightPending = !0, setTimeout(function() {
                        r.$highlightPending = !1;
                        var e, t, i, n, o = r.session;
                        o && !o.destroyed && (o.$bracketHighlight && (o.$bracketHighlight.markerIds.forEach(function(e) {
                            o.removeMarker(e);
                        }), o.$bracketHighlight = null), e = r.getCursorPosition(), t = (t = r.getKeyboardHandler()) && t.$getDirectionForHighlight && t.$getDirectionForHighlight(r), (t = o.getMatchingBracketRanges(e, t)) || (i = new v(o, e.row, e.column).getCurrentToken()) && /\b(?:tag-open|tag-name)/.test(i.type) && (i = o.getMatchingTags(e)) && (t = [
                            i.openTagName.isEmpty() ? i.openTag : i.openTagName,
                            i.closeTagName.isEmpty() ? i.closeTag : i.closeTagName
                        ]), (t = !t && o.$mode.getMatching ? o.$mode.getMatching(r.session) : t) && (n = "ace_bracket", Array.isArray(t) ? 1 == t.length && (n = "ace_error_bracket") : t = [
                            t
                        ], 2 == t.length && (0 == f.comparePoints(t[0].end, t[1].start) ? t = [
                            f.fromPoints(t[0].start, t[1].end)
                        ] : 0 == f.comparePoints(t[0].start, t[1].end) && (t = [
                            f.fromPoints(t[1].start, t[0].end)
                        ])), o.$bracketHighlight = {
                            ranges: t,
                            markerIds: t.map(function(e) {
                                return o.addMarker(e, n, "text");
                            })
                        }), r.getHighlightIndentGuides()) && r.renderer.$textLayer.$highlightIndentGuide();
                    }, 50));
                }, k.prototype.focus = function() {
                    this.textInput.focus();
                }, k.prototype.isFocused = function() {
                    return this.textInput.isFocused();
                }, k.prototype.blur = function() {
                    this.textInput.blur();
                }, k.prototype.onFocus = function(e) {
                    this.$isFocused || (this.$isFocused = !0, this.renderer.showCursor(), this.renderer.visualizeFocus(), this._emit("focus", e));
                }, k.prototype.onBlur = function(e) {
                    this.$isFocused && (this.$isFocused = !1, this.renderer.hideCursor(), this.renderer.visualizeBlur(), this._emit("blur", e));
                }, k.prototype.$cursorChange = function() {
                    this.renderer.updateCursor(), this.$highlightBrackets(), this.$updateHighlightActiveLine();
                }, k.prototype.onDocumentChange = function(e) {
                    var t = this.session.$useWrapMode, i = e.start.row == e.end.row ? e.end.row : 1 / 0;
                    this.renderer.updateLines(e.start.row, i, t), this._signal("change", e), this.$cursorChange();
                }, k.prototype.onTokenizerUpdate = function(e) {
                    e = e.data;
                    this.renderer.updateLines(e.first, e.last);
                }, k.prototype.onScrollTopChange = function() {
                    this.renderer.scrollToY(this.session.getScrollTop());
                }, k.prototype.onScrollLeftChange = function() {
                    this.renderer.scrollToX(this.session.getScrollLeft());
                }, k.prototype.onCursorChange = function() {
                    this.$cursorChange(), this._signal("changeSelection");
                }, k.prototype.$updateHighlightActiveLine = function() {
                    var e, t, i = this.getSession();
                    this.$highlightActiveLine && ("line" == this.$selectionStyle && this.selection.isMultiLine() || (e = this.getCursorPosition()), this.renderer.theme && this.renderer.theme.$selectionColorConflict && !this.selection.isEmpty() && (e = !1), !this.renderer.$maxLines || 1 !== this.session.getLength() || 1 < this.renderer.$minLines || (e = !1)), i.$highlightLineMarker && !e ? (i.removeMarker(i.$highlightLineMarker.id), i.$highlightLineMarker = null) : !i.$highlightLineMarker && e ? ((t = new f(e.row, e.column, e.row, 1 / 0)).id = i.addMarker(t, "ace_active-line", "screenLine"), i.$highlightLineMarker = t) : e && (i.$highlightLineMarker.start.row = e.row, i.$highlightLineMarker.end.row = e.row, i.$highlightLineMarker.start.column = e.column, i._signal("changeBackMarker"));
                }, k.prototype.onSelectionChange = function(e) {
                    var t, i, n = this.session, n = (n.$selectionMarker && n.removeMarker(n.$selectionMarker), n.$selectionMarker = null, this.selection.isEmpty() ? this.$updateHighlightActiveLine() : (t = this.selection.getRange(), i = this.getSelectionStyle(), n.$selectionMarker = n.addMarker(t, "ace_selection", i)), this.$highlightSelectedWord && this.$getSelectionHighLightRegexp());
                    this.session.highlight(n), this._signal("changeSelection");
                }, k.prototype.$getSelectionHighLightRegexp = function() {
                    var e = this.session, t = this.getSelectionRange();
                    if (!t.isEmpty() && !t.isMultiLine()) {
                        var i = t.start.column, n = t.end.column, e = e.getLine(t.start.row), t = e.substring(i, n);
                        if (!(5e3 < t.length) && /[\w\d]/.test(t)) {
                            t = this.$search.$assembleRegExp({
                                wholeWord: !0,
                                caseSensitive: !0,
                                needle: t
                            }), e = e.substring(i - 1, n + 1);
                            if (t.test(e)) return t;
                        }
                    }
                }, k.prototype.onChangeFrontMarker = function() {
                    this.renderer.updateFrontMarkers();
                }, k.prototype.onChangeBackMarker = function() {
                    this.renderer.updateBackMarkers();
                }, k.prototype.onChangeBreakpoint = function() {
                    this.renderer.updateBreakpoints();
                }, k.prototype.onChangeAnnotation = function() {
                    this.renderer.setAnnotations(this.session.getAnnotations());
                }, k.prototype.onChangeMode = function(e) {
                    this.renderer.updateText(), this._emit("changeMode", e);
                }, k.prototype.onChangeWrapLimit = function() {
                    this.renderer.updateFull();
                }, k.prototype.onChangeWrapMode = function() {
                    this.renderer.onResize(!0);
                }, k.prototype.onChangeFold = function() {
                    this.$updateHighlightActiveLine(), this.renderer.updateFull();
                }, k.prototype.getSelectedText = function() {
                    return this.session.getTextRange(this.getSelectionRange());
                }, k.prototype.getCopyText = function() {
                    var e = this.getSelectedText(), t = this.session.doc.getNewLineCharacter(), i = !1;
                    if (!e && this.$copyWithEmptySelection) for(var i = !0, n = this.selection.getAllRanges(), o = 0; o < n.length; o++){
                        var r = n[o];
                        o && n[o - 1].start.row == r.start.row || (e += this.session.getLine(r.start.row) + t);
                    }
                    var s = {
                        text: e
                    };
                    return this._signal("copy", s), A.lineMode = !!i && s.text, s.text;
                }, k.prototype.onCopy = function() {
                    this.commands.exec("copy", this);
                }, k.prototype.onCut = function() {
                    this.commands.exec("cut", this);
                }, k.prototype.onPaste = function(e, t) {
                    this.commands.exec("paste", this, {
                        text: e,
                        event: t
                    });
                }, k.prototype.$handlePaste = function(e) {
                    this._signal("paste", e = "string" == typeof e ? {
                        text: e
                    } : e);
                    var t = e.text, e = t === A.lineMode, i = this.session;
                    if (!this.inMultiSelectMode || this.inVirtualSelectionMode) e ? i.insert({
                        row: this.selection.lead.row,
                        column: 0
                    }, t) : this.insert(t);
                    else if (e) this.selection.rangeList.ranges.forEach(function(e) {
                        i.insert({
                            row: e.start.row,
                            column: 0
                        }, t);
                    });
                    else {
                        var n = t.split(/\r\n|\r|\n/), o = this.selection.rangeList.ranges, e = !(2 != n.length || n[0] && n[1]);
                        if (n.length != o.length || e) return this.commands.exec("insertstring", this, t);
                        for(var r = o.length; r--;){
                            var s = o[r];
                            s.isEmpty() || i.remove(s), i.insert(s.start, n[r]);
                        }
                    }
                }, k.prototype.execCommand = function(e, t) {
                    return this.commands.exec(e, this, t);
                }, k.prototype.insert = function(e, t) {
                    var i, n = this.session, o = n.getMode(), r = this.getCursorPosition(), s = (this.getBehavioursEnabled() && !t && (i = o.transformAction(n.getState(r.row), "insertion", this, n, e)) && (e === i.text || this.inVirtualSelectionMode || (this.session.mergeUndoDeltas = !1, this.mergeNextCommand = !1), e = i.text), "\t" == e && (e = this.session.getTabString()), this.selection.isEmpty() ? this.session.getOverwrite() && -1 == e.indexOf("\n") && ((s = f.fromPoints(r, r)).end.column += e.length, this.session.remove(s)) : (s = this.getSelectionRange(), r = this.session.remove(s), this.clearSelection()), "\n" != e && "\r\n" != e || (a = n.getLine(r.row), r.column > a.search(/\S|$/) && (t = a.substr(r.column).search(/\S|$/), n.doc.removeInLine(r.row, r.column, r.column + t))), this.clearSelection(), r.column), t = n.getState(r.row), a = n.getLine(r.row), l = o.checkOutdent(t, a, e);
                    n.insert(r, e), i && i.selection && (2 == i.selection.length ? this.selection.setSelectionRange(new f(r.row, s + i.selection[0], r.row, s + i.selection[1])) : this.selection.setSelectionRange(new f(r.row + i.selection[0], i.selection[1], r.row + i.selection[2], i.selection[3]))), this.$enableAutoIndent && (n.getDocument().isNewLine(e) && (s = o.getNextLineIndent(t, a.slice(0, r.column), n.getTabString()), n.insert({
                        row: r.row + 1,
                        column: 0
                    }, s)), l) && o.autoOutdent(t, n, r.row);
                }, k.prototype.autoIndent = function() {
                    for(var e = this.session, t = e.getMode(), i = this.selection.isEmpty() ? [
                        new f(0, 0, e.doc.getLength() - 1, 0)
                    ] : this.selection.getAllRanges(), n = "", o = "", r = e.getTabString(), s = 0; s < i.length; s++)for(var a = i[s].start.row, l = i[s].end.row, c = a; c <= l; c++){
                        0 < c && (n = e.getState(c - 1), h = e.getLine(c - 1), o = t.getNextLineIndent(n, h, r));
                        var h = e.getLine(c), d = t.$getIndent(h);
                        o !== d && (0 < d.length && (d = new f(c, 0, c, d.length), e.remove(d)), 0 < o.length) && e.insert({
                            row: c,
                            column: 0
                        }, o), t.autoOutdent(n, e, c);
                    }
                }, k.prototype.onTextInput = function(e, t) {
                    if (!t) return this.keyBinding.onTextInput(e);
                    this.startOperation({
                        command: {
                            name: "insertstring"
                        }
                    });
                    e = this.applyComposition.bind(this, e, t);
                    this.selection.rangeCount ? this.forEachSelection(e) : e(), this.endOperation();
                }, k.prototype.applyComposition = function(e, t) {
                    var i;
                    (t.extendLeft || t.extendRight) && ((i = this.selection.getRange()).start.column -= t.extendLeft, i.end.column += t.extendRight, i.start.column < 0 && (i.start.row--, i.start.column += this.session.getLine(i.start.row).length + 1), this.selection.setRange(i), e || i.isEmpty() || this.remove()), !e && this.selection.isEmpty() || this.insert(e, !0), (t.restoreStart || t.restoreEnd) && ((i = this.selection.getRange()).start.column -= t.restoreStart, i.end.column -= t.restoreEnd, this.selection.setRange(i));
                }, k.prototype.onCommandKey = function(e, t, i) {
                    return this.keyBinding.onCommandKey(e, t, i);
                }, k.prototype.setOverwrite = function(e) {
                    this.session.setOverwrite(e);
                }, k.prototype.getOverwrite = function() {
                    return this.session.getOverwrite();
                }, k.prototype.toggleOverwrite = function() {
                    this.session.toggleOverwrite();
                }, k.prototype.setScrollSpeed = function(e) {
                    this.setOption("scrollSpeed", e);
                }, k.prototype.getScrollSpeed = function() {
                    return this.getOption("scrollSpeed");
                }, k.prototype.setDragDelay = function(e) {
                    this.setOption("dragDelay", e);
                }, k.prototype.getDragDelay = function() {
                    return this.getOption("dragDelay");
                }, k.prototype.setSelectionStyle = function(e) {
                    this.setOption("selectionStyle", e);
                }, k.prototype.getSelectionStyle = function() {
                    return this.getOption("selectionStyle");
                }, k.prototype.setHighlightActiveLine = function(e) {
                    this.setOption("highlightActiveLine", e);
                }, k.prototype.getHighlightActiveLine = function() {
                    return this.getOption("highlightActiveLine");
                }, k.prototype.setHighlightGutterLine = function(e) {
                    this.setOption("highlightGutterLine", e);
                }, k.prototype.getHighlightGutterLine = function() {
                    return this.getOption("highlightGutterLine");
                }, k.prototype.setHighlightSelectedWord = function(e) {
                    this.setOption("highlightSelectedWord", e);
                }, k.prototype.getHighlightSelectedWord = function() {
                    return this.$highlightSelectedWord;
                }, k.prototype.setAnimatedScroll = function(e) {
                    this.renderer.setAnimatedScroll(e);
                }, k.prototype.getAnimatedScroll = function() {
                    return this.renderer.getAnimatedScroll();
                }, k.prototype.setShowInvisibles = function(e) {
                    this.renderer.setShowInvisibles(e);
                }, k.prototype.getShowInvisibles = function() {
                    return this.renderer.getShowInvisibles();
                }, k.prototype.setDisplayIndentGuides = function(e) {
                    this.renderer.setDisplayIndentGuides(e);
                }, k.prototype.getDisplayIndentGuides = function() {
                    return this.renderer.getDisplayIndentGuides();
                }, k.prototype.setHighlightIndentGuides = function(e) {
                    this.renderer.setHighlightIndentGuides(e);
                }, k.prototype.getHighlightIndentGuides = function() {
                    return this.renderer.getHighlightIndentGuides();
                }, k.prototype.setShowPrintMargin = function(e) {
                    this.renderer.setShowPrintMargin(e);
                }, k.prototype.getShowPrintMargin = function() {
                    return this.renderer.getShowPrintMargin();
                }, k.prototype.setPrintMarginColumn = function(e) {
                    this.renderer.setPrintMarginColumn(e);
                }, k.prototype.getPrintMarginColumn = function() {
                    return this.renderer.getPrintMarginColumn();
                }, k.prototype.setReadOnly = function(e) {
                    this.setOption("readOnly", e);
                }, k.prototype.getReadOnly = function() {
                    return this.getOption("readOnly");
                }, k.prototype.setBehavioursEnabled = function(e) {
                    this.setOption("behavioursEnabled", e);
                }, k.prototype.getBehavioursEnabled = function() {
                    return this.getOption("behavioursEnabled");
                }, k.prototype.setWrapBehavioursEnabled = function(e) {
                    this.setOption("wrapBehavioursEnabled", e);
                }, k.prototype.getWrapBehavioursEnabled = function() {
                    return this.getOption("wrapBehavioursEnabled");
                }, k.prototype.setShowFoldWidgets = function(e) {
                    this.setOption("showFoldWidgets", e);
                }, k.prototype.getShowFoldWidgets = function() {
                    return this.getOption("showFoldWidgets");
                }, k.prototype.setFadeFoldWidgets = function(e) {
                    this.setOption("fadeFoldWidgets", e);
                }, k.prototype.getFadeFoldWidgets = function() {
                    return this.getOption("fadeFoldWidgets");
                }, k.prototype.remove = function(e) {
                    this.selection.isEmpty() && ("left" == e ? this.selection.selectLeft() : this.selection.selectRight());
                    var t, i, n, e = this.getSelectionRange();
                    this.getBehavioursEnabled() && (i = (t = this.session).getState(e.start.row), i = t.getMode().transformAction(i, "deletion", this, t, e), 0 === e.end.column && "\n" == (n = t.getTextRange(e))[n.length - 1] && (n = t.getLine(e.end.row), /^\s+$/.test(n)) && (e.end.column = n.length), i) && (e = i), this.session.remove(e), this.clearSelection();
                }, k.prototype.removeWordRight = function() {
                    this.selection.isEmpty() && this.selection.selectWordRight(), this.session.remove(this.getSelectionRange()), this.clearSelection();
                }, k.prototype.removeWordLeft = function() {
                    this.selection.isEmpty() && this.selection.selectWordLeft(), this.session.remove(this.getSelectionRange()), this.clearSelection();
                }, k.prototype.removeToLineStart = function() {
                    this.selection.isEmpty() && this.selection.selectLineStart(), this.selection.isEmpty() && this.selection.selectLeft(), this.session.remove(this.getSelectionRange()), this.clearSelection();
                }, k.prototype.removeToLineEnd = function() {
                    this.selection.isEmpty() && this.selection.selectLineEnd();
                    var e = this.getSelectionRange();
                    e.start.column == e.end.column && e.start.row == e.end.row && (e.end.column = 0, e.end.row++), this.session.remove(e), this.clearSelection();
                }, k.prototype.splitLine = function() {
                    this.selection.isEmpty() || (this.session.remove(this.getSelectionRange()), this.clearSelection());
                    var e = this.getCursorPosition();
                    this.insert("\n"), this.moveCursorToPosition(e);
                }, k.prototype.setGhostText = function(e, t) {
                    this.renderer.setGhostText(e, t);
                }, k.prototype.removeGhostText = function() {
                    this.renderer.removeGhostText();
                }, k.prototype.transposeLetters = function() {
                    var e, t, i, n;
                    this.selection.isEmpty() && 0 !== (t = (e = this.getCursorPosition()).column) && (n = t < (n = this.session.getLine(e.row)).length ? (i = n.charAt(t) + n.charAt(t - 1), new f(e.row, t - 1, e.row, t + 1)) : (i = n.charAt(t - 1) + n.charAt(t - 2), new f(e.row, t - 2, e.row, t)), this.session.replace(n, i), this.session.selection.moveToPosition(n.end));
                }, k.prototype.toLowerCase = function() {
                    var e = this.getSelectionRange(), t = (this.selection.isEmpty() && this.selection.selectWord(), this.getSelectionRange()), i = this.session.getTextRange(t);
                    this.session.replace(t, i.toLowerCase()), this.selection.setSelectionRange(e);
                }, k.prototype.toUpperCase = function() {
                    var e = this.getSelectionRange(), t = (this.selection.isEmpty() && this.selection.selectWord(), this.getSelectionRange()), i = this.session.getTextRange(t);
                    this.session.replace(t, i.toUpperCase()), this.selection.setSelectionRange(e);
                }, k.prototype.indent = function() {
                    var e = this.session, t = this.getSelectionRange();
                    if (!(t.start.row < t.end.row)) {
                        if (t.start.column < t.end.column) {
                            var i, n = e.getTextRange(t);
                            if (!/^\s+$/.test(n)) return i = this.$getSelectedRows(), void e.indentRows(i.first, i.last, "\t");
                        }
                        var o = e.getLine(t.start.row), n = t.start, r = e.getTabSize(), n = e.documentToScreenColumn(n.row, n.column);
                        if (this.session.getUseSoftTabs()) var s = r - n % r, a = m.stringRepeat(" ", s);
                        else {
                            for(s = n % r; " " == o[t.start.column - 1] && s;)t.start.column--, s--;
                            this.selection.setSelectionRange(t), a = "\t";
                        }
                        return this.insert(a);
                    }
                    i = this.$getSelectedRows(), e.indentRows(i.first, i.last, "\t");
                }, k.prototype.blockIndent = function() {
                    var e = this.$getSelectedRows();
                    this.session.indentRows(e.first, e.last, "\t");
                }, k.prototype.blockOutdent = function() {
                    var e = this.session.getSelection();
                    this.session.outdentRows(e.getRange());
                }, k.prototype.sortLines = function() {
                    for(var e = this.$getSelectedRows(), t = this.session, i = [], n = e.first; n <= e.last; n++)i.push(t.getLine(n));
                    i.sort(function(e, t) {
                        return e.toLowerCase() < t.toLowerCase() ? -1 : e.toLowerCase() > t.toLowerCase() ? 1 : 0;
                    });
                    for(var o = new f(0, 0, 0, 0), n = e.first; n <= e.last; n++){
                        var r = t.getLine(n);
                        o.start.row = n, o.end.row = n, o.end.column = r.length, t.replace(o, i[n - e.first]);
                    }
                }, k.prototype.toggleCommentLines = function() {
                    var e = this.session.getState(this.getCursorPosition().row), t = this.$getSelectedRows();
                    this.session.getMode().toggleCommentLines(e, this.session, t.first, t.last);
                }, k.prototype.toggleBlockComment = function() {
                    var e = this.getCursorPosition(), t = this.session.getState(e.row), i = this.getSelectionRange();
                    this.session.getMode().toggleBlockComment(t, this.session, i, e);
                }, k.prototype.getNumberAt = function(e, t) {
                    for(var i = /[\-]?[0-9]+(?:\.[0-9]+)?/g, n = (i.lastIndex = 0, this.session.getLine(e)); i.lastIndex < t;){
                        var o = i.exec(n);
                        if (o.index <= t && o.index + o[0].length >= t) return {
                            value: o[0],
                            start: o.index,
                            end: o.index + o[0].length
                        };
                    }
                    return null;
                }, k.prototype.modifyNumber = function(e) {
                    var t, i, n, o = this.selection.getCursor().row, r = this.selection.getCursor().column, s = new f(o, r - 1, o, r), s = this.session.getTextRange(s);
                    !isNaN(parseFloat(s)) && isFinite(s) ? (s = this.getNumberAt(o, r)) && (n = 0 <= s.value.indexOf(".") ? s.start + s.value.indexOf(".") + 1 : s.end, t = s.start + s.value.length - n, i = parseFloat(s.value), i *= Math.pow(10, t), n !== s.end && r < n ? e *= Math.pow(10, s.end - r - 1) : e *= Math.pow(10, s.end - r), n = (i = (i += e) / Math.pow(10, t)).toFixed(t), e = new f(o, s.start, o, s.end), this.session.replace(e, n), this.moveCursorTo(o, Math.max(s.start + 1, r + n.length - s.value.length))) : this.toggleWord();
                }, k.prototype.toggleWord = function() {
                    for(var i, n = this.selection.getCursor().row, e = this.selection.getCursor().column, o = (this.selection.selectWord(), this.getSelectedText()), r = this.selection.getWordRange().start.column, t = o.replace(/([a-z]+|[A-Z]+)(?=[A-Z_]|$)/g, "$1 ").split(/\s/), s = e - r - 1, a = (s < 0 && (s = 0), 0), l = this, c = (o.match(/[A-Za-z0-9_]+/) && t.forEach(function(e, t) {
                        i = a + e.length, a <= s && s <= i && (o = e, l.selection.clearSelection(), l.moveCursorTo(n, a + r), l.selection.selectTo(n, i + r)), a = i;
                    }), this.$toggleWordPairs), h = 0; h < c.length; h++)for(var d = c[h], u = 0; u <= 1; u++){
                        var g = +!u, p = o.match(new RegExp("^\\s?_?(" + m.escapeRegExp(d[u]) + ")\\s?$", "i"));
                        p && o.match(new RegExp("([_]|^|\\s)(" + m.escapeRegExp(p[1]) + ")($|\\s)", "g")) && (p = o.replace(new RegExp(m.escapeRegExp(d[u]), "i"), function(e) {
                            var t = d[g];
                            return e.toUpperCase() == e ? t = t.toUpperCase() : e.charAt(0).toUpperCase() == e.charAt(0) && (t = t.substr(0, 0) + d[g].charAt(0).toUpperCase() + t.substr(1)), t;
                        }), this.insert(p));
                    }
                }, k.prototype.findLinkAt = function(e, t) {
                    var i, n, o, e = this.session.getLine(e).split(/((?:https?|ftp):\/\/[\S]+)/), r = t, s = (r < 0 && (r = 0), 0);
                    try {
                        for(var a = d(e), l = a.next(); !l.done; l = a.next()){
                            var c = l.value, h = s + c.length;
                            if (s <= r && r <= h && c.match(/((?:https?|ftp):\/\/[\S]+)/)) {
                                o = c.replace(/[\s:.,'";}\]]+$/, "");
                                break;
                            }
                            s = h;
                        }
                    } catch (e) {
                        i = {
                            error: e
                        };
                    } finally{
                        try {
                            l && !l.done && (n = a.return) && n.call(a);
                        } finally{
                            if (i) throw i.error;
                        }
                    }
                    return o;
                }, k.prototype.openLink = function() {
                    var e = this.selection.getCursor(), e = this.findLinkAt(e.row, e.column);
                    return e && window.open(e, "_blank"), null != e;
                }, k.prototype.removeLines = function() {
                    var e = this.$getSelectedRows();
                    this.session.removeFullLines(e.first, e.last), this.clearSelection();
                }, k.prototype.duplicateSelection = function() {
                    var e, t = this.selection, i = this.session, n = t.getRange(), o = t.isBackwards();
                    n.isEmpty() ? (e = n.start.row, i.duplicateLines(e, e)) : (e = o ? n.start : n.end, i = i.insert(e, i.getTextRange(n)), n.start = e, n.end = i, t.setSelectionRange(n, o));
                }, k.prototype.moveLinesDown = function() {
                    this.$moveLines(1, !1);
                }, k.prototype.moveLinesUp = function() {
                    this.$moveLines(-1, !1);
                }, k.prototype.moveText = function(e, t, i) {
                    return this.session.moveText(e, t, i);
                }, k.prototype.copyLinesUp = function() {
                    this.$moveLines(-1, !0);
                }, k.prototype.copyLinesDown = function() {
                    this.$moveLines(1, !0);
                }, k.prototype.$moveLines = function(e, t) {
                    var i = this.selection;
                    if (!i.inMultiSelectMode || this.inVirtualSelectionMode) {
                        var n = i.toOrientedRange(), o = this.$getSelectedRows(n), r = this.session.$moveLines(o.first, o.last, t ? 0 : e);
                        n.moveBy(r = t && -1 == e ? 0 : r, 0), i.fromOrientedRange(n);
                    } else {
                        for(var s = i.rangeList.ranges, a = (i.rangeList.detach(this.session), this.inVirtualSelectionMode = !0, 0), l = 0, c = s.length, h = 0; h < c; h++){
                            for(var d = h, u = (s[h].moveBy(a, 0), (o = this.$getSelectedRows(s[h])).first), g = o.last; ++h < c;){
                                l && s[h].moveBy(l, 0);
                                var p = this.$getSelectedRows(s[h]);
                                if (t && p.first != g) break;
                                if (!t && p.first > g + 1) break;
                                g = p.last;
                            }
                            for(h--, a = this.session.$moveLines(u, g, t ? 0 : e), t && -1 == e && (d = h + 1); d <= h;)s[d].moveBy(a, 0), d++;
                            l += a = t ? a : 0;
                        }
                        i.fromOrientedRange(i.ranges[0]), i.rangeList.attach(this.session), this.inVirtualSelectionMode = !1;
                    }
                }, k.prototype.$getSelectedRows = function(e) {
                    return e = (e || this.getSelectionRange()).collapseRows(), {
                        first: this.session.getRowFoldStart(e.start.row),
                        last: this.session.getRowFoldEnd(e.end.row)
                    };
                }, k.prototype.onCompositionStart = function(e) {
                    this.renderer.showComposition(e);
                }, k.prototype.onCompositionUpdate = function(e) {
                    this.renderer.setCompositionText(e);
                }, k.prototype.onCompositionEnd = function() {
                    this.renderer.hideComposition();
                }, k.prototype.getFirstVisibleRow = function() {
                    return this.renderer.getFirstVisibleRow();
                }, k.prototype.getLastVisibleRow = function() {
                    return this.renderer.getLastVisibleRow();
                }, k.prototype.isRowVisible = function(e) {
                    return e >= this.getFirstVisibleRow() && e <= this.getLastVisibleRow();
                }, k.prototype.isRowFullyVisible = function(e) {
                    return e >= this.renderer.getFirstFullyVisibleRow() && e <= this.renderer.getLastFullyVisibleRow();
                }, k.prototype.$getVisibleRowCount = function() {
                    return this.renderer.getScrollBottomRow() - this.renderer.getScrollTopRow() + 1;
                }, k.prototype.$moveByPage = function(e, t) {
                    var i = this.renderer, n = this.renderer.layerConfig, o = e * Math.floor(n.height / n.lineHeight), e = (!0 === t ? this.selection.$moveSelection(function() {
                        this.moveCursorBy(o, 0);
                    }) : !1 === t && (this.selection.moveCursorBy(o, 0), this.selection.clearSelection()), i.scrollTop);
                    i.scrollBy(0, o * n.lineHeight), null != t && i.scrollCursorIntoView(null, .5), i.animateScrolling(e);
                }, k.prototype.selectPageDown = function() {
                    this.$moveByPage(1, !0);
                }, k.prototype.selectPageUp = function() {
                    this.$moveByPage(-1, !0);
                }, k.prototype.gotoPageDown = function() {
                    this.$moveByPage(1, !1);
                }, k.prototype.gotoPageUp = function() {
                    this.$moveByPage(-1, !1);
                }, k.prototype.scrollPageDown = function() {
                    this.$moveByPage(1);
                }, k.prototype.scrollPageUp = function() {
                    this.$moveByPage(-1);
                }, k.prototype.scrollToRow = function(e) {
                    this.renderer.scrollToRow(e);
                }, k.prototype.scrollToLine = function(e, t, i, n) {
                    this.renderer.scrollToLine(e, t, i, n);
                }, k.prototype.centerSelection = function() {
                    var e = this.getSelectionRange(), e = {
                        row: Math.floor(e.start.row + (e.end.row - e.start.row) / 2),
                        column: Math.floor(e.start.column + (e.end.column - e.start.column) / 2)
                    };
                    this.renderer.alignCursor(e, .5);
                }, k.prototype.getCursorPosition = function() {
                    return this.selection.getCursor();
                }, k.prototype.getCursorPositionScreen = function() {
                    return this.session.documentToScreenPosition(this.getCursorPosition());
                }, k.prototype.getSelectionRange = function() {
                    return this.selection.getRange();
                }, k.prototype.selectAll = function() {
                    this.selection.selectAll();
                }, k.prototype.clearSelection = function() {
                    this.selection.clearSelection();
                }, k.prototype.moveCursorTo = function(e, t) {
                    this.selection.moveCursorTo(e, t);
                }, k.prototype.moveCursorToPosition = function(e) {
                    this.selection.moveCursorToPosition(e);
                }, k.prototype.jumpToMatching = function(e, t) {
                    var i = this.getCursorPosition(), n = new v(this.session, i.row, i.column), o = n.getCurrentToken(), r = 0, s = (o = o && -1 !== o.type.indexOf("tag-name") ? n.stepBackward() : o) || n.stepForward();
                    if (s) {
                        var a, l, c = !1, h = {}, d = i.column - s.start, u = {
                            ")": "(",
                            "(": "(",
                            "]": "[",
                            "[": "[",
                            "{": "{",
                            "}": "{"
                        };
                        do if (s.value.match(/[{}()\[\]]/g)) {
                            for(; d < s.value.length && !c; d++)if (u[s.value[d]]) switch(l = u[s.value[d]] + "." + s.type.replace("rparen", "lparen"), isNaN(h[l]) && (h[l] = 0), s.value[d]){
                                case "(":
                                case "[":
                                case "{":
                                    h[l]++;
                                    break;
                                case ")":
                                case "]":
                                case "}":
                                    h[l]--, -1 === h[l] && (a = "bracket", c = !0);
                            }
                        } else -1 !== s.type.indexOf("tag-name") && (isNaN(h[s.value]) && (h[s.value] = 0), "<" === o.value && 1 < r ? h[s.value]++ : "</" === o.value && h[s.value]--, -1 === h[s.value]) && (a = "tag", c = !0);
                        while (c || (o = s, r++, s = n.stepForward(), d = 0), s && !c);
                        if (a) {
                            if ("bracket" === a) !(p = this.session.getBracketRange(i)) && (m = (p = new f(n.getCurrentTokenRow(), n.getCurrentTokenColumn() + d - 1, n.getCurrentTokenRow(), n.getCurrentTokenColumn() + d - 1)).start, t || m.row === i.row && Math.abs(m.column - i.column) < 2) && (p = this.session.getBracketRange(m));
                            else if ("tag" === a) {
                                if (!s || -1 === s.type.indexOf("tag-name")) return;
                                var g, p, m = (m = 0 === (p = new f(n.getCurrentTokenRow(), n.getCurrentTokenColumn() - 2, n.getCurrentTokenRow(), n.getCurrentTokenColumn() - 2)).compare(i.row, i.column) && (g = this.session.getMatchingTags(i)) ? g.openTag.contains(i.row, i.column) ? (p = g.closeTag).start : (p = g.openTag, g.closeTag.start.row === i.row && g.closeTag.start.column === i.column ? p.end : p.start) : m) || p.start;
                            }
                            (m = p && p.cursor || m) && (e ? p && t ? this.selection.setRange(p) : p && p.isEqual(this.getSelectionRange()) ? this.clearSelection() : this.selection.selectTo(m.row, m.column) : this.selection.moveTo(m.row, m.column));
                        }
                    }
                }, k.prototype.gotoLine = function(e, t, i) {
                    this.selection.clearSelection(), this.session.unfold({
                        row: e - 1,
                        column: t || 0
                    }), this.exitMultiSelectMode && this.exitMultiSelectMode(), this.moveCursorTo(e - 1, t || 0), this.isRowFullyVisible(e - 1) || this.scrollToLine(e - 1, !0, i);
                }, k.prototype.navigateTo = function(e, t) {
                    this.selection.moveTo(e, t);
                }, k.prototype.navigateUp = function(e) {
                    var t;
                    if (this.selection.isMultiLine() && !this.selection.isBackwards()) return t = this.selection.anchor.getPosition(), this.moveCursorToPosition(t);
                    this.selection.clearSelection(), this.selection.moveCursorBy(-e || -1, 0);
                }, k.prototype.navigateDown = function(e) {
                    var t;
                    if (this.selection.isMultiLine() && this.selection.isBackwards()) return t = this.selection.anchor.getPosition(), this.moveCursorToPosition(t);
                    this.selection.clearSelection(), this.selection.moveCursorBy(e || 1, 0);
                }, k.prototype.navigateLeft = function(e) {
                    if (this.selection.isEmpty()) for(e = e || 1; e--;)this.selection.moveCursorLeft();
                    else {
                        var t = this.getSelectionRange().start;
                        this.moveCursorToPosition(t);
                    }
                    this.clearSelection();
                }, k.prototype.navigateRight = function(e) {
                    if (this.selection.isEmpty()) for(e = e || 1; e--;)this.selection.moveCursorRight();
                    else {
                        var t = this.getSelectionRange().end;
                        this.moveCursorToPosition(t);
                    }
                    this.clearSelection();
                }, k.prototype.navigateLineStart = function() {
                    this.selection.moveCursorLineStart(), this.clearSelection();
                }, k.prototype.navigateLineEnd = function() {
                    this.selection.moveCursorLineEnd(), this.clearSelection();
                }, k.prototype.navigateFileEnd = function() {
                    this.selection.moveCursorFileEnd(), this.clearSelection();
                }, k.prototype.navigateFileStart = function() {
                    this.selection.moveCursorFileStart(), this.clearSelection();
                }, k.prototype.navigateWordRight = function() {
                    this.selection.moveCursorWordRight(), this.clearSelection();
                }, k.prototype.navigateWordLeft = function() {
                    this.selection.moveCursorWordLeft(), this.clearSelection();
                }, k.prototype.replace = function(e, t) {
                    t && this.$search.set(t);
                    var t = this.$search.find(this.session), i = 0;
                    return t && (this.$tryReplace(t, e) && (i = 1), this.selection.setSelectionRange(t), this.renderer.scrollSelectionIntoView(t.start, t.end)), i;
                }, k.prototype.replaceAll = function(e, t) {
                    t && this.$search.set(t);
                    var i = this.$search.findAll(this.session), n = 0;
                    if (i.length) {
                        t = this.getSelectionRange();
                        this.selection.moveTo(0, 0);
                        for(var o = i.length - 1; 0 <= o; --o)this.$tryReplace(i[o], e) && n++;
                        this.selection.setSelectionRange(t);
                    }
                    return n;
                }, k.prototype.$tryReplace = function(e, t) {
                    var i = this.session.getTextRange(e);
                    return null !== (t = this.$search.replace(i, t)) ? (e.end = this.session.replace(e, t), e) : null;
                }, k.prototype.getLastSearchOptions = function() {
                    return this.$search.getOptions();
                }, k.prototype.find = function(e, t, i) {
                    t = t || {}, "string" == typeof e || e instanceof RegExp ? t.needle = e : "object" == typeof e && o.mixin(t, e);
                    var n = this.selection.getRange(), e = (null == t.needle && ((e = this.session.getTextRange(n) || this.$search.$options.needle) || (n = this.session.getWordRange(n.start.row, n.start.column), e = this.session.getTextRange(n)), this.$search.set({
                        needle: e
                    })), this.$search.set(t), t.start || this.$search.set({
                        start: n
                    }), this.$search.find(this.session));
                    return t.preventScroll ? e : e ? (this.revealRange(e, i), e) : (t.backwards ? n.start = n.end : n.end = n.start, void this.selection.setRange(n));
                }, k.prototype.findNext = function(e, t) {
                    this.find({
                        skipCurrent: !0,
                        backwards: !1
                    }, e, t);
                }, k.prototype.findPrevious = function(e, t) {
                    this.find(e, {
                        skipCurrent: !0,
                        backwards: !0
                    }, t);
                }, k.prototype.revealRange = function(e, t) {
                    this.session.unfold(e), this.selection.setSelectionRange(e);
                    var i = this.renderer.scrollTop;
                    this.renderer.scrollSelectionIntoView(e.start, e.end, .5), !1 !== t && this.renderer.animateScrolling(i);
                }, k.prototype.undo = function() {
                    this.session.getUndoManager().undo(this.session), this.renderer.scrollCursorIntoView(null, .5);
                }, k.prototype.redo = function() {
                    this.session.getUndoManager().redo(this.session), this.renderer.scrollCursorIntoView(null, .5);
                }, k.prototype.destroy = function() {
                    this.destroyed = !0, this.$toDestroy && (this.$toDestroy.forEach(function(e) {
                        e.destroy();
                    }), this.$toDestroy = []), this.$mouseHandler && this.$mouseHandler.destroy(), this.renderer.destroy(), this._signal("destroy", this), this.session && this.session.destroy(), this._$emitInputEvent && this._$emitInputEvent.cancel(), this.removeAllListeners();
                }, k.prototype.setAutoScrollEditorIntoView = function(e) {
                    var n, o, r, s, t, i, a;
                    e && (r = !1, (o = this).$scrollAnchor || (this.$scrollAnchor = document.createElement("div")), (s = this.$scrollAnchor).style.cssText = "position:absolute", this.container.insertBefore(s, this.container.firstChild), t = this.on("changeSelection", function() {
                        r = !0;
                    }), i = this.renderer.on("beforeRender", function() {
                        r && (n = o.renderer.container.getBoundingClientRect());
                    }), a = this.renderer.on("afterRender", function() {
                        var e, t, i;
                        r && n && (o.isFocused() || o.searchBox && o.searchBox.isFocused()) && (i = (e = (t = o.renderer).$cursorLayer.$pixelPos).top - (t = t.layerConfig).offset, null != (r = 0 <= e.top && i + n.top < 0 || !(e.top < t.height && e.top + n.top + t.lineHeight > window.innerHeight) && null) && (s.style.top = i + "px", s.style.left = e.left + "px", s.style.height = t.lineHeight + "px", s.scrollIntoView(r)), r = n = null);
                    }), this.setAutoScrollEditorIntoView = function(e) {
                        e || (delete this.setAutoScrollEditorIntoView, this.off("changeSelection", t), this.renderer.off("afterRender", a), this.renderer.off("beforeRender", i));
                    });
                }, k.prototype.$resetCursorStyle = function() {
                    var e = this.$cursorStyle || "ace", t = this.renderer.$cursorLayer;
                    t && (t.setSmoothBlinking(/smooth/.test(e)), t.isBlinking = !this.$readOnly && "wide" != e, n.setCssClass(t.element, "ace_slim-cursors", /slim/.test(e)));
                }, k.prototype.prompt = function(t, i, n) {
                    var o = this;
                    y.loadModule("ace/ext/prompt", function(e) {
                        e.prompt(o, t, i, n);
                    });
                }, Object.defineProperty(k.prototype, "hoverTooltip", {
                    get: function() {
                        return this.$hoverTooltip || (this.$hoverTooltip = new S(this.container));
                    },
                    set: function(e) {
                        this.$hoverTooltip && this.$hoverTooltip.destroy(), this.$hoverTooltip = e;
                    },
                    enumerable: !1,
                    configurable: !0
                }), k);
                function k(e, t, i) {
                    this.id = "editor" + ++k.$uid, this.session, this.$toDestroy = [];
                    var n = e.getContainerElement();
                    this.container = n, this.renderer = e, this.commands = new p(r.isMac ? "mac" : "win", C), "object" == typeof document && (this.textInput = new s(e.getTextAreaContainer(), this), this.renderer.textarea = this.textInput.getElement(), this.$mouseHandler = new a(this), new l(this)), this.keyBinding = new c(this), this.$search = (new u).set({
                        wrap: !0
                    }), this.$historyTracker = this.$historyTracker.bind(this), this.commands.on("exec", this.$historyTracker), this.$initOperationListeners(), this._$emitInputEvent = m.delayedCall((function() {
                        this._signal("input", {}), this.session && !this.session.destroyed && this.session.bgTokenizer.scheduleStart();
                    }).bind(this)), this.on("change", function(e, t) {
                        t._$emitInputEvent.schedule(31);
                    }), this.setSession(t || i && i.session || new h("")), y.resetOptions(this), i && this.setOptions(i), y._signal("editor", this);
                }
                e.$uid = 0, e.prototype.curOp = null, e.prototype.prevOp = {}, e.prototype.$mergeableCommands = [
                    "backspace",
                    "del",
                    "insertstring"
                ], e.prototype.$toggleWordPairs = [
                    [
                        "first",
                        "last"
                    ],
                    [
                        "true",
                        "false"
                    ],
                    [
                        "yes",
                        "no"
                    ],
                    [
                        "width",
                        "height"
                    ],
                    [
                        "top",
                        "bottom"
                    ],
                    [
                        "right",
                        "left"
                    ],
                    [
                        "on",
                        "off"
                    ],
                    [
                        "x",
                        "y"
                    ],
                    [
                        "get",
                        "set"
                    ],
                    [
                        "max",
                        "min"
                    ],
                    [
                        "horizontal",
                        "vertical"
                    ],
                    [
                        "show",
                        "hide"
                    ],
                    [
                        "add",
                        "remove"
                    ],
                    [
                        "up",
                        "down"
                    ],
                    [
                        "before",
                        "after"
                    ],
                    [
                        "even",
                        "odd"
                    ],
                    [
                        "in",
                        "out"
                    ],
                    [
                        "inside",
                        "outside"
                    ],
                    [
                        "next",
                        "previous"
                    ],
                    [
                        "increase",
                        "decrease"
                    ],
                    [
                        "attach",
                        "detach"
                    ],
                    [
                        "&&",
                        "||"
                    ],
                    [
                        "==",
                        "!="
                    ]
                ], o.implement(e.prototype, g), y.defineOptions(e.prototype, "editor", {
                    selectionStyle: {
                        set: function(e) {
                            this.onSelectionChange(), this._signal("changeSelectionStyle", {
                                data: e
                            });
                        },
                        initialValue: "line"
                    },
                    highlightActiveLine: {
                        set: function() {
                            this.$updateHighlightActiveLine();
                        },
                        initialValue: !0
                    },
                    highlightSelectedWord: {
                        set: function(e) {
                            this.$onSelectionChange();
                        },
                        initialValue: !0
                    },
                    readOnly: {
                        set: function(e) {
                            var t, i = this;
                            this.textInput.setReadOnly(e), this.destroyed || (this.$resetCursorStyle(), this.$readOnlyCallback || (this.$readOnlyCallback = function(e) {
                                var t = !1;
                                if (e && "keydown" == e.type) {
                                    if (e && e.key && !e.ctrlKey && !e.metaKey && (" " == e.key && e.preventDefault(), t = 1 == e.key.length), !t) return;
                                } else e && "exec" !== e.type && (t = !0);
                                t ? ((e = n.createElement("div")).textContent = b("editor.tooltip.disable-editing", "Editing is disabled"), i.hoverTooltip.isOpen || i.hoverTooltip.showForRange(i, i.getSelectionRange(), e)) : i.hoverTooltip && i.hoverTooltip.isOpen && i.hoverTooltip.hide();
                            }), t = this.textInput.getElement(), e ? (x.addListener(t, "keydown", this.$readOnlyCallback, this), this.commands.on("exec", this.$readOnlyCallback), this.commands.on("commandUnavailable", this.$readOnlyCallback)) : (x.removeListener(t, "keydown", this.$readOnlyCallback), this.commands.off("exec", this.$readOnlyCallback), this.commands.off("commandUnavailable", this.$readOnlyCallback)));
                        },
                        initialValue: !1
                    },
                    copyWithEmptySelection: {
                        set: function(e) {
                            this.textInput.setCopyWithEmptySelection(e);
                        },
                        initialValue: !1
                    },
                    cursorStyle: {
                        set: function(e) {
                            this.$resetCursorStyle();
                        },
                        values: [
                            "ace",
                            "slim",
                            "smooth",
                            "wide"
                        ],
                        initialValue: "ace"
                    },
                    mergeUndoDeltas: {
                        values: [
                            !1,
                            !0,
                            "always"
                        ],
                        initialValue: !0
                    },
                    behavioursEnabled: {
                        initialValue: !0
                    },
                    wrapBehavioursEnabled: {
                        initialValue: !0
                    },
                    enableAutoIndent: {
                        initialValue: !0
                    },
                    autoScrollEditorIntoView: {
                        set: function(e) {
                            this.setAutoScrollEditorIntoView(e);
                        }
                    },
                    keyboardHandler: {
                        set: function(e) {
                            this.setKeyboardHandler(e);
                        },
                        get: function() {
                            return this.$keybindingId;
                        },
                        handlesSet: !0
                    },
                    value: {
                        set: function(e) {
                            this.session.setValue(e);
                        },
                        get: function() {
                            return this.getValue();
                        },
                        handlesSet: !0,
                        hidden: !0
                    },
                    session: {
                        set: function(e) {
                            this.setSession(e);
                        },
                        get: function() {
                            return this.session;
                        },
                        handlesSet: !0,
                        hidden: !0
                    },
                    showLineNumbers: {
                        set: function(e) {
                            this.renderer.$gutterLayer.setShowLineNumbers(e), this.renderer.$loop.schedule(this.renderer.CHANGE_GUTTER), e && this.$relativeLineNumbers ? T.attach(this) : T.detach(this);
                        },
                        initialValue: !0
                    },
                    relativeLineNumbers: {
                        set: function(e) {
                            this.$showLineNumbers && e ? T.attach(this) : T.detach(this);
                        }
                    },
                    placeholder: {
                        set: function(e) {
                            this.$updatePlaceholder || (this.$updatePlaceholder = (function() {
                                var e = this.session && (this.renderer.$composition || 1 < this.session.getLength() || 0 < this.session.getLine(0).length);
                                e && this.renderer.placeholderNode ? (this.renderer.off("afterRender", this.$updatePlaceholder), n.removeCssClass(this.container, "ace_hasPlaceholder"), this.renderer.placeholderNode.remove(), this.renderer.placeholderNode = null) : e || this.renderer.placeholderNode ? !e && this.renderer.placeholderNode && (this.renderer.placeholderNode.textContent = this.$placeholder || "") : (this.renderer.on("afterRender", this.$updatePlaceholder), n.addCssClass(this.container, "ace_hasPlaceholder"), (e = n.createElement("div")).className = "ace_placeholder", e.textContent = this.$placeholder || "", this.renderer.placeholderNode = e, this.renderer.content.appendChild(this.renderer.placeholderNode));
                            }).bind(this), this.on("input", this.$updatePlaceholder)), this.$updatePlaceholder();
                        }
                    },
                    enableKeyboardAccessibility: {
                        set: function(e) {
                            function t(e) {
                                e.target == this.renderer.scroller && e.keyCode === w.enter && (e.preventDefault(), e = this.getCursorPosition().row, this.isRowVisible(e) || this.scrollToLine(e, !0, !0), this.focus());
                            }
                            var i, n = {
                                name: "blurTextInput",
                                description: "Set focus to the editor content div to allow tabbing through the page",
                                bindKey: "Esc",
                                exec: function(e) {
                                    e.blur(), e.renderer.scroller.focus();
                                },
                                readOnly: !0
                            };
                            e ? (this.renderer.enableKeyboardAccessibility = !0, this.renderer.keyboardFocusClassName = "ace_keyboard-focus", this.textInput.getElement().setAttribute("tabindex", -1), this.textInput.setNumberOfExtraLines(r.isWin ? 3 : 0), this.renderer.scroller.setAttribute("tabindex", 0), this.renderer.scroller.setAttribute("role", "group"), this.renderer.scroller.setAttribute("aria-roledescription", b("editor.scroller.aria-roledescription", "editor")), this.renderer.scroller.classList.add(this.renderer.keyboardFocusClassName), this.renderer.scroller.setAttribute("aria-label", b("editor.scroller.aria-label", "Editor content, press Enter to start editing, press Escape to exit")), this.renderer.scroller.addEventListener("keyup", t.bind(this)), this.commands.addCommand(n), this.renderer.$gutter.setAttribute("tabindex", 0), this.renderer.$gutter.setAttribute("aria-hidden", !1), this.renderer.$gutter.setAttribute("role", "group"), this.renderer.$gutter.setAttribute("aria-roledescription", b("editor.gutter.aria-roledescription", "editor gutter")), this.renderer.$gutter.setAttribute("aria-label", b("editor.gutter.aria-label", "Editor gutter, press Enter to interact with controls using arrow keys, press Escape to exit")), this.renderer.$gutter.classList.add(this.renderer.keyboardFocusClassName), this.renderer.content.setAttribute("aria-hidden", !0), (i = i || new I(this)).addListener(), this.textInput.setAriaOptions({
                                setLabel: !0
                            })) : (this.renderer.enableKeyboardAccessibility = !1, this.textInput.getElement().setAttribute("tabindex", 0), this.textInput.setNumberOfExtraLines(0), this.renderer.scroller.setAttribute("tabindex", -1), this.renderer.scroller.removeAttribute("role"), this.renderer.scroller.removeAttribute("aria-roledescription"), this.renderer.scroller.classList.remove(this.renderer.keyboardFocusClassName), this.renderer.scroller.removeAttribute("aria-label"), this.renderer.scroller.removeEventListener("keyup", t.bind(this)), this.commands.removeCommand(n), this.renderer.content.removeAttribute("aria-hidden"), this.renderer.$gutter.setAttribute("tabindex", -1), this.renderer.$gutter.setAttribute("aria-hidden", !0), this.renderer.$gutter.removeAttribute("role"), this.renderer.$gutter.removeAttribute("aria-roledescription"), this.renderer.$gutter.removeAttribute("aria-label"), this.renderer.$gutter.classList.remove(this.renderer.keyboardFocusClassName), i && i.removeListener());
                        },
                        initialValue: !1
                    },
                    textInputAriaLabel: {
                        set: function(e) {
                            this.$textInputAriaLabel = e;
                        },
                        initialValue: ""
                    },
                    enableMobileMenu: {
                        set: function(e) {
                            this.$enableMobileMenu = e;
                        },
                        initialValue: !0
                    },
                    customScrollbar: "renderer",
                    hScrollBarAlwaysVisible: "renderer",
                    vScrollBarAlwaysVisible: "renderer",
                    highlightGutterLine: "renderer",
                    animatedScroll: "renderer",
                    showInvisibles: "renderer",
                    showPrintMargin: "renderer",
                    printMarginColumn: "renderer",
                    printMargin: "renderer",
                    fadeFoldWidgets: "renderer",
                    showFoldWidgets: "renderer",
                    displayIndentGuides: "renderer",
                    highlightIndentGuides: "renderer",
                    showGutter: "renderer",
                    fontSize: "renderer",
                    fontFamily: "renderer",
                    maxLines: "renderer",
                    minLines: "renderer",
                    scrollPastEnd: "renderer",
                    fixedWidthGutter: "renderer",
                    theme: "renderer",
                    hasCssTransforms: "renderer",
                    maxPixelHeight: "renderer",
                    useTextareaForIME: "renderer",
                    useResizeObserver: "renderer",
                    useSvgGutterIcons: "renderer",
                    showFoldedAnnotations: "renderer",
                    scrollSpeed: "$mouseHandler",
                    dragDelay: "$mouseHandler",
                    dragEnabled: "$mouseHandler",
                    focusTimeout: "$mouseHandler",
                    firstLineNumber: "session",
                    overwrite: "session",
                    newLineMode: "session",
                    useWorker: "session",
                    useSoftTabs: "session",
                    navigateWithinSoftTabs: "session",
                    tabSize: "session",
                    wrap: "session",
                    indentedSoftWrap: "session",
                    foldStyle: "session",
                    mode: "session"
                });
                var T = {
                    getText: function(e, t) {
                        return (Math.abs(e.selection.lead.row - t) || t + 1 + (t < 9 ? "\xb7" : "")) + "";
                    },
                    getWidth: function(e, t, i) {
                        return Math.max(t.toString().length, (i.lastRow + 1).toString().length, 2) * i.characterWidth;
                    },
                    update: function(e, t) {
                        t.renderer.$loop.schedule(t.renderer.CHANGE_GUTTER);
                    },
                    attach: function(e) {
                        e.renderer.$gutterLayer.$renderer = this, e.on("changeSelection", this.update), this.update(null, e);
                    },
                    detach: function(e) {
                        e.renderer.$gutterLayer.$renderer == this && (e.renderer.$gutterLayer.$renderer = null), e.off("changeSelection", this.update), this.update(null, e);
                    }
                };
                t.Editor = e;
            }), ace.define("ace/layer/lines", [
                "require",
                "exports",
                "module",
                "ace/lib/dom"
            ], function(e, t, i) {
                var s = e("../lib/dom");
                function n(e, t) {
                    this.element = e, this.canvasHeight = t || 5e5, this.element.style.height = 2 * this.canvasHeight + "px", this.cells = [], this.cellCache = [], this.$offsetCoefficient = 0;
                }
                n.prototype.moveContainer = function(e) {
                    s.translate(this.element, 0, -(e.firstRowScreen * e.lineHeight % this.canvasHeight) - e.offset * this.$offsetCoefficient);
                }, n.prototype.pageChanged = function(e, t) {
                    return Math.floor(e.firstRowScreen * e.lineHeight / this.canvasHeight) !== Math.floor(t.firstRowScreen * t.lineHeight / this.canvasHeight);
                }, n.prototype.computeLineTop = function(e, t, i) {
                    var n = t.firstRowScreen * t.lineHeight, n = Math.floor(n / this.canvasHeight);
                    return i.documentToScreenRow(e, 0) * t.lineHeight - n * this.canvasHeight;
                }, n.prototype.computeLineHeight = function(e, t, i) {
                    return t.lineHeight * i.getRowLineCount(e);
                }, n.prototype.getLength = function() {
                    return this.cells.length;
                }, n.prototype.get = function(e) {
                    return this.cells[e];
                }, n.prototype.shift = function() {
                    this.$cacheCell(this.cells.shift());
                }, n.prototype.pop = function() {
                    this.$cacheCell(this.cells.pop());
                }, n.prototype.push = function(e) {
                    if (Array.isArray(e)) {
                        this.cells.push.apply(this.cells, e);
                        for(var t = s.createFragment(this.element), i = 0; i < e.length; i++)t.appendChild(e[i].element);
                        this.element.appendChild(t);
                    } else this.cells.push(e), this.element.appendChild(e.element);
                }, n.prototype.unshift = function(e) {
                    if (Array.isArray(e)) {
                        this.cells.unshift.apply(this.cells, e);
                        for(var t = s.createFragment(this.element), i = 0; i < e.length; i++)t.appendChild(e[i].element);
                        this.element.firstChild ? this.element.insertBefore(t, this.element.firstChild) : this.element.appendChild(t);
                    } else this.cells.unshift(e), this.element.insertAdjacentElement("afterbegin", e.element);
                }, n.prototype.last = function() {
                    return this.cells.length ? this.cells[this.cells.length - 1] : null;
                }, n.prototype.$cacheCell = function(e) {
                    e && (e.element.remove(), this.cellCache.push(e));
                }, n.prototype.createCell = function(e, t, i, n) {
                    var o, r = this.cellCache.pop();
                    return r || (o = s.createElement("div"), n && n(o), this.element.appendChild(o), r = {
                        element: o,
                        text: "",
                        row: e
                    }), r.row = e, r;
                }, t.Lines = n;
            }), ace.define("ace/layer/gutter", [
                "require",
                "exports",
                "module",
                "ace/lib/dom",
                "ace/lib/oop",
                "ace/lib/lang",
                "ace/lib/event_emitter",
                "ace/layer/lines",
                "ace/config"
            ], function(e, t, i) {
                var k = e("../lib/dom"), n = e("../lib/oop"), a = e("../lib/lang"), o = e("../lib/event_emitter").EventEmitter, r = e("./lines").Lines, T = e("../config").nls, e = (s.prototype.setSession = function(e) {
                    this.session && this.session.off("change", this.$updateAnnotations), (this.session = e) && e.on("change", this.$updateAnnotations);
                }, s.prototype.addGutterDecoration = function(e, t) {
                    window.console && console.warn && console.warn("deprecated use session.addGutterDecoration"), this.session.addGutterDecoration(e, t);
                }, s.prototype.removeGutterDecoration = function(e, t) {
                    window.console && console.warn && console.warn("deprecated use session.removeGutterDecoration"), this.session.removeGutterDecoration(e, t);
                }, s.prototype.setAnnotations = function(e) {
                    this.$annotations = [];
                    for(var t = 0; t < e.length; t++){
                        var i = e[t], n = i.row, o = (o = this.$annotations[n]) || (this.$annotations[n] = {
                            text: [],
                            type: [],
                            displayText: []
                        }), n = i.text, r = i.type, s = (s = i.text) ? a.escapeHTML(s) : i.html || "", n = n || i.html || "", s = (-1 === o.text.indexOf(s) && (o.text.push(s), o.type.push(r), o.displayText.push(n)), i.className);
                        s ? o.className = s : "error" === r ? o.className = " ace_error" : "security" !== r || /\bace_error\b/.test(o.className) ? "warning" !== r || /\bace_(error|security)\b/.test(o.className) ? "info" !== r || o.className ? "hint" !== r || o.className || (o.className = " ace_hint") : o.className = " ace_info" : o.className = " ace_warning" : o.className = " ace_security";
                    }
                }, s.prototype.$updateAnnotations = function(e) {
                    var t, i;
                    this.$annotations.length && (t = e.start.row, 0 != (i = e.end.row - t)) && ("remove" == e.action ? this.$annotations.splice(t, 1 + i, null) : ((e = new Array(1 + i)).unshift(t, 1), this.$annotations.splice.apply(this.$annotations, e)));
                }, s.prototype.update = function(e) {
                    this.config = e;
                    for(var t = this.session, i = e.firstRow, n = Math.min(e.lastRow + e.gutterOffset, t.getLength() - 1), o = (this.oldLastRow = n, this.config = e, this.$lines.moveContainer(e), this.$updateCursorRow(), t.getNextFoldLine(i)), r = o ? o.start.row : 1 / 0, s = null, a = -1, l = i;;){
                        if (r < l && (l = o.end.row + 1, r = (o = t.getNextFoldLine(l, o)) ? o.start.row : 1 / 0), n < l) {
                            for(; this.$lines.getLength() > a + 1;)this.$lines.pop();
                            break;
                        }
                        (s = this.$lines.get(++a)) ? s.row = l : (s = this.$lines.createCell(l, e, this.session, c), this.$lines.push(s)), this.$renderCell(s, e, o, l), l++;
                    }
                    this._signal("afterRender"), this.$updateGutterWidth(e), this.$showCursorMarker && this.$highlightGutterLine && this.$updateCursorMarker();
                }, s.prototype.$updateGutterWidth = function(e) {
                    var t = this.session, i = t.gutterRenderer || this.$renderer, n = t.$firstLineNumber, o = this.$lines.last() ? this.$lines.last().text : "", n = ((this.$fixedWidth || t.$useWrapMode) && (o = t.getLength() + n - 1), i ? i.getWidth(t, o, e) : o.toString().length * e.characterWidth), i = this.$padding || this.$computePadding();
                    (n += i.left + i.right) === this.gutterWidth || isNaN(n) || (this.gutterWidth = n, this.element.parentNode.style.width = this.element.style.width = Math.ceil(this.gutterWidth) + "px", this._signal("changeGutterWidth", n));
                }, s.prototype.$updateCursorRow = function() {
                    var e;
                    this.$highlightGutterLine && (e = this.session.selection.getCursor(), this.$cursorRow !== e.row) && (this.$cursorRow = e.row);
                }, s.prototype.updateLineHighlight = function() {
                    if (this.$showCursorMarker && this.$updateCursorMarker(), this.$highlightGutterLine) {
                        var e = this.session.selection.cursor.row;
                        if (this.$cursorRow = e, !this.$cursorCell || this.$cursorCell.row != e) {
                            this.$cursorCell && (this.$cursorCell.element.className = this.$cursorCell.element.className.replace("ace_gutter-active-line ", ""));
                            var t = this.$lines.cells;
                            this.$cursorCell = null;
                            for(var i = 0; i < t.length; i++){
                                var n = t[i];
                                if (n.row >= this.$cursorRow) {
                                    if (n.row > this.$cursorRow) {
                                        var o = this.session.getFoldLine(this.$cursorRow);
                                        if (!(0 < i && o && o.start.row == t[i - 1].row)) break;
                                        n = t[i - 1];
                                    }
                                    n.element.className = "ace_gutter-active-line " + n.element.className, this.$cursorCell = n;
                                    break;
                                }
                            }
                        }
                    }
                }, s.prototype.$updateCursorMarker = function() {
                    var e, t, i, n, o;
                    this.session && (o = this.session, this.$highlightElement || (this.$highlightElement = k.createElement("div"), this.$highlightElement.className = "ace_gutter-cursor", this.$highlightElement.style.pointerEvents = "none", this.element.appendChild(this.$highlightElement)), e = o.selection.cursor, t = this.config, i = this.$lines, n = t.firstRowScreen * t.lineHeight, n = Math.floor(n / i.canvasHeight), o = o.documentToScreenRow(e) * t.lineHeight - n * i.canvasHeight, k.setStyle(this.$highlightElement.style, "height", t.lineHeight + "px"), k.setStyle(this.$highlightElement.style, "top", o + "px"));
                }, s.prototype.scrollLines = function(e) {
                    var t = this.config;
                    if (this.config = e, this.$updateCursorRow(), this.$lines.pageChanged(t, e)) return this.update(e);
                    this.$lines.moveContainer(e);
                    var i = Math.min(e.lastRow + e.gutterOffset, this.session.getLength() - 1), n = this.oldLastRow;
                    if (this.oldLastRow = i, !t || n < e.firstRow) return this.update(e);
                    if (i < t.firstRow) return this.update(e);
                    if (t.firstRow < e.firstRow) for(var o = this.session.getFoldedRowCount(t.firstRow, e.firstRow - 1); 0 < o; o--)this.$lines.shift();
                    if (i < n) for(o = this.session.getFoldedRowCount(i + 1, n); 0 < o; o--)this.$lines.pop();
                    e.firstRow < t.firstRow && this.$lines.unshift(this.$renderLines(e, e.firstRow, t.firstRow - 1)), n < i && this.$lines.push(this.$renderLines(e, n + 1, i)), this.updateLineHighlight(), this._signal("afterRender"), this.$updateGutterWidth(e);
                }, s.prototype.$renderLines = function(e, t, i) {
                    for(var n = [], o = t, r = this.session.getNextFoldLine(o), s = r ? r.start.row : 1 / 0; s < o && (o = r.end.row + 1, s = (r = this.session.getNextFoldLine(o, r)) ? r.start.row : 1 / 0), !(i < o);){
                        var a = this.$lines.createCell(o, e, this.session, c);
                        this.$renderCell(a, e, r, o), n.push(a), o++;
                    }
                    return n;
                }, s.prototype.$renderCell = function(e, t, i, n) {
                    var o, r = e.element, s = this.session, a = r.childNodes[0], l = r.childNodes[1], c = r.childNodes[2], h = r.childNodes[3], d = c.firstChild, u = s.$firstLineNumber, g = s.$breakpoints, p = s.$decorations, m = s.gutterRenderer || this.$renderer, f = this.$showFoldWidgets && s.foldWidgets, C = i ? i.start.row : Number.MAX_VALUE, y = t.lineHeight + "px", v = this.$useSvgGutterIcons ? "ace_gutter-cell_svg-icons " : "ace_gutter-cell ", I = this.$useSvgGutterIcons ? "ace_icon_svg" : "ace_icon", b = (m ? m.getText(s, n) : n + u).toString();
                    if (this.$highlightGutterLine && (n == this.$cursorRow || i && n < this.$cursorRow && C <= n && this.$cursorRow <= i.end.row) && (v += "ace_gutter-active-line ", this.$cursorCell != e) && (this.$cursorCell && (this.$cursorCell.element.className = this.$cursorCell.element.className.replace("ace_gutter-active-line ", "")), this.$cursorCell = e), g[n] && (v += g[n]), p[n] && (v += p[n]), this.$annotations[n] && n !== C && (v += this.$annotations[n].className), o = f && null == (o = f[n]) ? f[n] = s.getFoldWidget(n) : o) {
                        m = "ace_fold-widget ace_" + o, u = "start" == o && n == C && n < i.end.row;
                        if (u) {
                            m += " ace_closed";
                            for(var A = "", w = !1, x = n + 1; x <= i.end.row; x++)if (this.$annotations[x]) {
                                if (" ace_error" === this.$annotations[x].className) {
                                    w = !0, A = " ace_error_fold";
                                    break;
                                }
                                " ace_security" === this.$annotations[x].className ? (w = !0, A = " ace_security_fold") : " ace_warning" === this.$annotations[x].className && " ace_security_fold" !== A && (w = !0, A = " ace_warning_fold");
                            }
                            v += A;
                        } else m += " ace_open";
                        l.className != m && (l.className = m), k.setStyle(l.style, "height", y), k.setStyle(l.style, "display", "inline-block"), l.setAttribute("role", "button"), l.setAttribute("tabindex", "-1");
                        g = s.getFoldWidgetRange(n);
                        g ? l.setAttribute("aria-label", T("gutter.code-folding.range.aria-label", "Toggle code folding, rows $0 through $1", [
                            g.start.row + 1,
                            g.end.row + 1
                        ])) : i ? l.setAttribute("aria-label", T("gutter.code-folding.closed.aria-label", "Toggle code folding, rows $0 through $1", [
                            i.start.row + 1,
                            i.end.row + 1
                        ])) : l.setAttribute("aria-label", T("gutter.code-folding.open.aria-label", "Toggle code folding, row $0", [
                            n + 1
                        ])), u ? (l.setAttribute("aria-expanded", "false"), l.setAttribute("title", T("gutter.code-folding.closed.title", "Unfold code"))) : (l.setAttribute("aria-expanded", "true"), l.setAttribute("title", T("gutter.code-folding.open.title", "Fold code")));
                    } else l && (k.setStyle(l.style, "display", "none"), l.setAttribute("tabindex", "0"), l.removeAttribute("role"), l.removeAttribute("aria-label"));
                    var S, p = this.session.$gutterCustomWidgets[n];
                    if (p ? this.$addCustomWidget(n, p, e) : h && this.$removeCustomWidget(n, e), w && this.$showFoldedAnnotations) {
                        switch(c.className = "ace_gutter_annotation", d.className = I, d.className += A, k.setStyle(d.style, "height", y), k.setStyle(c.style, "display", "block"), k.setStyle(c.style, "height", y), A){
                            case " ace_error_fold":
                                S = T("gutter.annotation.aria-label.error", "Error, read annotations row $0", [
                                    b
                                ]);
                                break;
                            case " ace_security_fold":
                                S = T("gutter.annotation.aria-label.security", "Security finding, read annotations row $0", [
                                    b
                                ]);
                                break;
                            case " ace_warning_fold":
                                S = T("gutter.annotation.aria-label.warning", "Warning, read annotations row $0", [
                                    b
                                ]);
                        }
                        c.setAttribute("aria-label", S), c.setAttribute("tabindex", "-1"), c.setAttribute("role", "button");
                    } else if (this.$annotations[n]) {
                        switch(c.className = "ace_gutter_annotation", d.className = I, this.$useSvgGutterIcons ? d.className += this.$annotations[n].className : r.classList.add(this.$annotations[n].className.replace(" ", "")), k.setStyle(d.style, "height", y), k.setStyle(c.style, "display", "block"), k.setStyle(c.style, "height", y), this.$annotations[n].className){
                            case " ace_error":
                                S = T("gutter.annotation.aria-label.error", "Error, read annotations row $0", [
                                    b
                                ]);
                                break;
                            case " ace_security":
                                S = T("gutter.annotation.aria-label.security", "Security finding, read annotations row $0", [
                                    b
                                ]);
                                break;
                            case " ace_warning":
                                S = T("gutter.annotation.aria-label.warning", "Warning, read annotations row $0", [
                                    b
                                ]);
                                break;
                            case " ace_info":
                                S = T("gutter.annotation.aria-label.info", "Info, read annotations row $0", [
                                    b
                                ]);
                                break;
                            case " ace_hint":
                                S = T("gutter.annotation.aria-label.hint", "Suggestion, read annotations row $0", [
                                    b
                                ]);
                        }
                        c.setAttribute("aria-label", S), c.setAttribute("tabindex", "-1"), c.setAttribute("role", "button");
                    } else k.setStyle(c.style, "display", "none"), c.removeAttribute("aria-label"), c.removeAttribute("role"), c.setAttribute("tabindex", "0");
                    return b !== a.data && (a.data = b), r.className != v && (r.className = v), k.setStyle(e.element.style, "height", this.$lines.computeLineHeight(n, t, s) + "px"), k.setStyle(e.element.style, "top", this.$lines.computeLineTop(n, t, s) + "px"), e.text = b, "none" !== c.style.display || "none" !== l.style.display || p ? e.element.setAttribute("aria-hidden", !1) : e.element.setAttribute("aria-hidden", !0), e;
                }, s.prototype.setHighlightGutterLine = function(e) {
                    !(this.$highlightGutterLine = e) && this.$highlightElement && (this.$highlightElement.remove(), this.$highlightElement = null);
                }, s.prototype.setShowLineNumbers = function(e) {
                    this.$renderer = !e && {
                        getWidth: function() {
                            return 0;
                        },
                        getText: function() {
                            return "";
                        }
                    };
                }, s.prototype.getShowLineNumbers = function() {
                    return this.$showLineNumbers;
                }, s.prototype.setShowFoldWidgets = function(e) {
                    e ? k.addCssClass(this.element, "ace_folding-enabled") : k.removeCssClass(this.element, "ace_folding-enabled"), this.$showFoldWidgets = e, this.$padding = null;
                }, s.prototype.getShowFoldWidgets = function() {
                    return this.$showFoldWidgets;
                }, s.prototype.$hideFoldWidget = function(e, t) {
                    t = t || this.$getGutterCell(e);
                    t && t.element && (e = t.element.childNodes[1]) && k.setStyle(e.style, "display", "none");
                }, s.prototype.$showFoldWidget = function(e, t) {
                    t = t || this.$getGutterCell(e);
                    t && t.element && (e = t.element.childNodes[1]) && this.session.foldWidgets && this.session.foldWidgets[t.row] && k.setStyle(e.style, "display", "inline-block");
                }, s.prototype.$getGutterCell = function(e) {
                    var t = this.$lines.cells, i = 0, n = t.length - 1;
                    if (!(e < t[0].row || e > t[n].row)) {
                        for(; i <= n;){
                            var o = Math.floor((i + n) / 2), r = t[o];
                            if (r.row > e) n = o - 1;
                            else {
                                if (!(r.row < e)) return r;
                                i = o + 1;
                            }
                        }
                        return r;
                    }
                }, s.prototype.$addCustomWidget = function(t, e, i) {
                    var n = e.className, o = e.label, r = e.title, s = e.callbacks, e = (this.session.$gutterCustomWidgets[t] = {
                        className: n,
                        label: o,
                        title: r,
                        callbacks: s
                    }, this.$hideFoldWidget(t, i), i || this.$getGutterCell(t));
                    e && e.element && ((i = e.element.querySelector(".ace_custom-widget")) && i.remove(), (i = k.createElement("span")).className = "ace_custom-widget ".concat(n), i.setAttribute("tabindex", "-1"), i.setAttribute("role", "button"), i.setAttribute("aria-label", o), i.setAttribute("title", r), k.setStyle(i.style, "display", "inline-block"), k.setStyle(i.style, "height", "inherit"), s && s.onClick && i.addEventListener("click", function(e) {
                        s.onClick(e, t), e.stopPropagation();
                    }), e.element.appendChild(i));
                }, s.prototype.$removeCustomWidget = function(e, t) {
                    delete this.session.$gutterCustomWidgets[e], this.$showFoldWidget(e, t);
                    t = t || this.$getGutterCell(e);
                    t && t.element && (e = t.element.querySelector(".ace_custom-widget")) && t.element.removeChild(e);
                }, s.prototype.$computePadding = function() {
                    var e;
                    return this.element.firstChild ? (e = k.computedStyle(this.element.firstChild), this.$padding = {}, this.$padding.left = (parseInt(e.borderLeftWidth) || 0) + (parseInt(e.paddingLeft) || 0) + 1, this.$padding.right = (parseInt(e.borderRightWidth) || 0) + (parseInt(e.paddingRight) || 0), this.$padding) : {
                        left: 0,
                        right: 0
                    };
                }, s.prototype.getRegion = function(e) {
                    var t = this.$padding || this.$computePadding(), i = this.element.getBoundingClientRect();
                    return e.x < t.left + i.left ? "markers" : this.$showFoldWidgets && e.x > i.right - t.right ? "foldWidgets" : void 0;
                }, s);
                function s(e) {
                    this.$showCursorMarker = null, this.element = k.createElement("div"), this.element.className = "ace_layer ace_gutter-layer", e.appendChild(this.element), this.setShowFoldWidgets(this.$showFoldWidgets), this.gutterWidth = 0, this.$annotations = [], this.$updateAnnotations = this.$updateAnnotations.bind(this), this.$lines = new r(this.element), this.$lines.$offsetCoefficient = 1;
                }
                function c(e) {
                    var t = document.createTextNode(""), t = (e.appendChild(t), k.createElement("span")), t = (e.appendChild(t), k.createElement("span")), i = (e.appendChild(t), k.createElement("span"));
                    return t.appendChild(i), e;
                }
                e.prototype.$fixedWidth = !1, e.prototype.$highlightGutterLine = !0, e.prototype.$renderer = void 0, e.prototype.$showLineNumbers = !0, e.prototype.$showFoldWidgets = !0, n.implement(e.prototype, o), t.Gutter = e;
            }), ace.define("ace/layer/marker", [
                "require",
                "exports",
                "module",
                "ace/range",
                "ace/lib/dom"
            ], function(e, t, i) {
                var g = e("../range").Range, n = e("../lib/dom"), e = (o.prototype.setPadding = function(e) {
                    this.$padding = e;
                }, o.prototype.setSession = function(e) {
                    this.session = e;
                }, o.prototype.setMarkers = function(e) {
                    this.markers = e;
                }, o.prototype.elt = function(e, t) {
                    var i = -1 != this.i && this.element.childNodes[this.i];
                    i ? this.i++ : (i = document.createElement("div"), this.element.appendChild(i), this.i = -1), i.style.cssText = t, i.className = e;
                }, o.prototype.update = function(e) {
                    if (e) {
                        var t, i;
                        for(i in this.config = e, this.i = 0, this.markers){
                            var n, o, r, s = this.markers[i];
                            s.range ? (r = s.range.clipRows(e.firstRow, e.lastRow)).isEmpty() || (r = r.toScreenRange(this.session), s.renderer ? (n = this.$getTop(r.start.row, e), o = this.$padding + r.start.column * e.characterWidth, s.renderer(t, r, o, n, e)) : "fullLine" == s.type ? this.drawFullLineMarker(t, r, s.clazz, e) : "screenLine" == s.type ? this.drawScreenLineMarker(t, r, s.clazz, e) : r.isMultiLine() ? "text" == s.type ? this.drawTextMarker(t, r, s.clazz, e) : this.drawMultiLineMarker(t, r, s.clazz, e) : this.drawSingleLineMarker(t, r, s.clazz + " ace_start ace_br15", e)) : s.update(t, this, this.session, e);
                        }
                        if (-1 != this.i) for(; this.i < this.element.childElementCount;)this.element.removeChild(this.element.lastChild);
                    }
                }, o.prototype.$getTop = function(e, t) {
                    return (e - t.firstRowScreen) * t.lineHeight;
                }, o.prototype.drawTextMarker = function(e, t, i, n, o) {
                    for(var r, s = this.session, a = t.start.row, l = t.end.row, c = a, h = 0, d = s.getScreenLastRowColumn(c), u = new g(c, t.start.column, c, h); c <= l; c++)u.start.row = u.end.row = c, u.start.column = c == a ? t.start.column : s.getRowWrapIndent(c), u.end.column = d, r = h, h = d, d = c + 1 < l ? s.getScreenLastRowColumn(c + 1) : c == l ? 0 : t.end.column, this.drawSingleLineMarker(e, u, i + (c == a ? " ace_start" : "") + " ace_br" + ((c == a || c == a + 1 && t.start.column ? 1 : 0) | (r < h ? 2 : 0) | (d < h ? 4 : 0) | (c == l ? 8 : 0)), n, c == l ? 0 : 1, o);
                }, o.prototype.drawMultiLineMarker = function(e, t, i, n, o) {
                    var r, s = this.$padding, a = n.lineHeight, l = this.$getTop(t.start.row, n), c = s + t.start.column * n.characterWidth;
                    o = o || "", this.session.$bidiHandler.isBidiRow(t.start.row) ? ((r = t.clone()).end.row = r.start.row, r.end.column = this.session.getLine(r.start.row).length, this.drawBidiSingleLineMarker(e, r, i + " ace_br1 ace_start", n, null, o)) : this.elt(i + " ace_br1 ace_start", "height:" + a + "px;right:" + s + "px;top:" + l + "px;left:" + c + "px;" + (o || "")), this.session.$bidiHandler.isBidiRow(t.end.row) ? ((r = t.clone()).start.row = r.end.row, r.start.column = 0, this.drawBidiSingleLineMarker(e, r, i + " ace_br12", n, null, o)) : (l = this.$getTop(t.end.row, n), c = t.end.column * n.characterWidth, this.elt(i + " ace_br12", "height:" + a + "px;width:" + c + "px;top:" + l + "px;left:" + s + "px;" + (o || ""))), (a = (t.end.row - t.start.row - 1) * n.lineHeight) <= 0 || (l = this.$getTop(t.start.row + 1, n), e = (t.start.column ? 1 : 0) | (t.end.column ? 0 : 8), this.elt(i + (e ? " ace_br" + e : ""), "height:" + a + "px;right:" + s + "px;top:" + l + "px;left:" + s + "px;" + (o || "")));
                }, o.prototype.drawSingleLineMarker = function(e, t, i, n, o, r) {
                    if (this.session.$bidiHandler.isBidiRow(t.start.row)) return this.drawBidiSingleLineMarker(e, t, i, n, o, r);
                    var e = n.lineHeight, o = (t.end.column + (o || 0) - t.start.column) * n.characterWidth, s = this.$getTop(t.start.row, n), t = this.$padding + t.start.column * n.characterWidth;
                    this.elt(i, "height:" + e + "px;width:" + o + "px;top:" + s + "px;left:" + t + "px;" + (r || ""));
                }, o.prototype.drawBidiSingleLineMarker = function(e, t, i, n, o, r) {
                    var s = n.lineHeight, a = this.$getTop(t.start.row, n), l = this.$padding;
                    this.session.$bidiHandler.getSelections(t.start.column, t.end.column).forEach(function(e) {
                        this.elt(i, "height:" + s + "px;width:" + (e.width + (o || 0)) + "px;top:" + a + "px;left:" + (l + e.left) + "px;" + (r || ""));
                    }, this);
                }, o.prototype.drawFullLineMarker = function(e, t, i, n, o) {
                    var r = this.$getTop(t.start.row, n), s = n.lineHeight;
                    t.start.row != t.end.row && (s += this.$getTop(t.end.row, n) - r), this.elt(i, "height:" + s + "px;top:" + r + "px;left:0;right:0;" + (o || ""));
                }, o.prototype.drawScreenLineMarker = function(e, t, i, n, o) {
                    t = this.$getTop(t.start.row, n), n = n.lineHeight;
                    this.elt(i, "height:" + n + "px;top:" + t + "px;left:0;right:0;" + (o || ""));
                }, o);
                function o(e) {
                    this.element = n.createElement("div"), this.element.className = "ace_layer ace_marker-layer", e.appendChild(this.element);
                }
                e.prototype.$padding = 0, t.Marker = e;
            }), ace.define("ace/layer/text_util", [
                "require",
                "exports",
                "module"
            ], function(e, t, i) {
                var n = new Set([
                    "text",
                    "rparen",
                    "lparen"
                ]);
                t.isTextToken = function(e) {
                    return n.has(e);
                };
            }), ace.define("ace/layer/text", [
                "require",
                "exports",
                "module",
                "ace/lib/oop",
                "ace/lib/dom",
                "ace/lib/lang",
                "ace/layer/lines",
                "ace/lib/event_emitter",
                "ace/config",
                "ace/layer/text_util"
            ], function(e, t, i) {
                var n = e("../lib/oop"), c = e("../lib/dom"), C = e("../lib/lang"), o = e("./lines").Lines, r = e("../lib/event_emitter").EventEmitter, y = e("../config").nls, v = e("./text_util").isTextToken, e = (s.prototype.$updateEolChar = function() {
                    var e = this.session.doc, e = "\n" == e.getNewLineCharacter() && "windows" != e.getNewLineMode() ? this.EOL_CHAR_LF : this.EOL_CHAR_CRLF;
                    if (this.EOL_CHAR != e) return this.EOL_CHAR = e, !0;
                }, s.prototype.setPadding = function(e) {
                    this.$padding = e, this.element.style.margin = "0 " + e + "px";
                }, s.prototype.getLineHeight = function() {
                    return this.$fontMetrics.$characterSize.height || 0;
                }, s.prototype.getCharacterWidth = function() {
                    return this.$fontMetrics.$characterSize.width || 0;
                }, s.prototype.$setFontMetrics = function(e) {
                    this.$fontMetrics = e, this.$fontMetrics.on("changeCharacterSize", (function(e) {
                        this._signal("changeCharacterSize", e);
                    }).bind(this)), this.$pollSizeChanges();
                }, s.prototype.checkForSizeChanges = function() {
                    this.$fontMetrics.checkForSizeChanges();
                }, s.prototype.$pollSizeChanges = function() {
                    return this.$pollSizeChangesTimer = this.$fontMetrics.$pollSizeChanges();
                }, s.prototype.setSession = function(e) {
                    (this.session = e) && this.$computeTabString();
                }, s.prototype.setShowInvisibles = function(e) {
                    return this.showInvisibles != e && ("string" == typeof (this.showInvisibles = e) ? (this.showSpaces = /tab/i.test(e), this.showTabs = /space/i.test(e), this.showEOL = /eol/i.test(e)) : this.showSpaces = this.showTabs = this.showEOL = e, this.$computeTabString(), !0);
                }, s.prototype.setDisplayIndentGuides = function(e) {
                    return this.displayIndentGuides != e && (this.displayIndentGuides = e, this.$computeTabString(), !0);
                }, s.prototype.setHighlightIndentGuides = function(e) {
                    return this.$highlightIndentGuides !== e && (this.$highlightIndentGuides = e);
                }, s.prototype.$computeTabString = function() {
                    for(var e, t, i, n, o, r, s = this.session.getTabSize(), a = (this.tabSize = s, this.$tabStrings = [
                        0
                    ]), l = 1; l < s + 1; l++)this.showTabs ? ((r = this.dom.createElement("span")).className = "ace_invisible ace_invisible_tab", r.textContent = C.stringRepeat(this.TAB_CHAR, l), a.push(r)) : a.push(this.dom.createTextNode(C.stringRepeat(" ", l), this.element));
                    this.displayIndentGuides && (this.$indentGuideRe = /\s\S| \t|\t |\s$/, e = "ace_indent-guide", t = this.showSpaces ? " ace_invisible ace_invisible_space" : "", i = this.showSpaces ? C.stringRepeat(this.SPACE_CHAR, this.tabSize) : C.stringRepeat(" ", this.tabSize), n = this.showTabs ? " ace_invisible ace_invisible_tab" : "", o = this.showTabs ? C.stringRepeat(this.TAB_CHAR, this.tabSize) : i, (r = this.dom.createElement("span")).className = e + t, r.textContent = i, this.$tabStrings[" "] = r, (r = this.dom.createElement("span")).className = e + n, r.textContent = o, this.$tabStrings["\t"] = r);
                }, s.prototype.updateLines = function(e, t, i) {
                    if (this.config.lastRow != e.lastRow || this.config.firstRow != e.firstRow) return this.update(e);
                    this.config = e;
                    for(var n = Math.max(t, e.firstRow), o = Math.min(i, e.lastRow), r = this.element.childNodes, s = 0, a = e.firstRow; a < n; a++){
                        if (l = this.session.getFoldLine(a)) {
                            if (l.containsRow(n)) {
                                n = l.start.row;
                                break;
                            }
                            a = l.end.row;
                        }
                        s++;
                    }
                    for(var l, c = !1, a = n, h = (l = this.session.getNextFoldLine(a)) ? l.start.row : 1 / 0; h < a && (a = l.end.row + 1, h = (l = this.session.getNextFoldLine(a, l)) ? l.start.row : 1 / 0), !(o < a);){
                        var d, u = r[s++];
                        u && (this.dom.removeChildren(u), this.$renderLine(u, a, a == h && l), c && (u.style.top = this.$lines.computeLineTop(a, e, this.session) + "px"), d = e.lineHeight * this.session.getRowLength(a) + "px", u.style.height != d) && (c = !0, u.style.height = d), a++;
                    }
                    if (c) for(; s < this.$lines.cells.length;){
                        var g = this.$lines.cells[s++];
                        g.element.style.top = this.$lines.computeLineTop(g.row, e, this.session) + "px";
                    }
                }, s.prototype.scrollLines = function(e) {
                    var t = this.config;
                    if (this.config = e, this.$lines.pageChanged(t, e)) return this.update(e);
                    this.$lines.moveContainer(e);
                    var i = e.lastRow, n = t ? t.lastRow : -1;
                    if (!t || n < e.firstRow) return this.update(e);
                    if (i < t.firstRow) return this.update(e);
                    if (!t || t.lastRow < e.firstRow) return this.update(e);
                    if (e.lastRow < t.firstRow) return this.update(e);
                    if (t.firstRow < e.firstRow) for(var o = this.session.getFoldedRowCount(t.firstRow, e.firstRow - 1); 0 < o; o--)this.$lines.shift();
                    if (t.lastRow > e.lastRow) for(o = this.session.getFoldedRowCount(e.lastRow + 1, t.lastRow); 0 < o; o--)this.$lines.pop();
                    e.firstRow < t.firstRow && this.$lines.unshift(this.$renderLinesFragment(e, e.firstRow, t.firstRow - 1)), e.lastRow > t.lastRow && this.$lines.push(this.$renderLinesFragment(e, t.lastRow + 1, e.lastRow)), this.$highlightIndentGuide();
                }, s.prototype.$renderLinesFragment = function(e, t, i) {
                    for(var n = [], o = t, r = this.session.getNextFoldLine(o), s = r ? r.start.row : 1 / 0; s < o && (o = r.end.row + 1, s = (r = this.session.getNextFoldLine(o, r)) ? r.start.row : 1 / 0), !(i < o);){
                        var a = this.$lines.createCell(o, e, this.session), l = a.element;
                        this.dom.removeChildren(l), c.setStyle(l.style, "height", this.$lines.computeLineHeight(o, e, this.session) + "px"), c.setStyle(l.style, "top", this.$lines.computeLineTop(o, e, this.session) + "px"), this.$renderLine(l, o, o == s && r), this.$useLineGroups() ? l.className = "ace_line_group" : l.className = "ace_line", n.push(a), o++;
                    }
                    return n;
                }, s.prototype.update = function(e) {
                    this.$lines.moveContainer(e);
                    for(var t = (this.config = e).firstRow, i = e.lastRow, n = this.$lines; n.getLength();)n.pop();
                    n.push(this.$renderLinesFragment(e, t, i));
                }, s.prototype.$renderToken = function(e, t, i, n) {
                    for(var o, r, s = this, a = /(\t)|( +)|([\x00-\x1f\x80-\xa0\xad\u1680\u180E\u2000-\u200f\u2028\u2029\u202F\u205F\uFEFF\uFFF9-\uFFFC\u2066\u2067\u2068\u202A\u202B\u202D\u202E\u202C\u2069\u2060\u2061\u2062\u2063\u2064\u206A\u206B\u206B\u206C\u206D\u206E\u206F]+)|(\u3000)|([\u1100-\u115F\u11A3-\u11A7\u11FA-\u11FF\u2329-\u232A\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFB\u3001-\u303E\u3041-\u3096\u3099-\u30FF\u3105-\u312D\u3131-\u318E\u3190-\u31BA\u31C0-\u31E3\u31F0-\u321E\u3220-\u3247\u3250-\u32FE\u3300-\u4DBF\u4E00-\uA48C\uA490-\uA4C6\uA960-\uA97C\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFAFF\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE66\uFE68-\uFE6B\uFF01-\uFF60\uFFE0-\uFFE6]|[\uD800-\uDBFF][\uDC00-\uDFFF])/g, l = this.dom.createFragment(this.element), c = 0; o = a.exec(n);){
                        var h, d, u = o[1], g = o[2], p = o[3], m = o[4], f = o[5];
                        !s.showSpaces && g || (h = c != o.index ? n.slice(c, o.index) : "", c = o.index + o[0].length, h && l.appendChild(this.dom.createTextNode(h, this.element)), u ? (h = s.session.getScreenTabSize(t + o.index), (u = s.$tabStrings[h].cloneNode(!0)).charCount = 1, l.appendChild(u), t += h - 1) : g ? s.showSpaces ? ((d = this.dom.createElement("span")).className = "ace_invisible ace_invisible_space", d.textContent = C.stringRepeat(s.SPACE_CHAR, g.length), l.appendChild(d)) : l.appendChild(this.dom.createTextNode(g, this.element)) : p ? ((d = this.dom.createElement("span")).className = "ace_invisible ace_invisible_space ace_invalid", d.textContent = C.stringRepeat(s.SPACE_CHAR, p.length), l.appendChild(d)) : m ? (t += 1, (d = this.dom.createElement("span")).style.width = 2 * s.config.characterWidth + "px", d.className = s.showSpaces ? "ace_cjk ace_invisible ace_invisible_space" : "ace_cjk", d.textContent = s.showSpaces ? s.SPACE_CHAR : m, l.appendChild(d)) : f && (t += 1, (d = this.dom.createElement("span")).style.width = 2 * s.config.characterWidth + "px", d.className = "ace_cjk", d.textContent = f, l.appendChild(d)));
                    }
                    return l.appendChild(this.dom.createTextNode(c ? n.slice(c) : n, this.element)), v(i.type) ? e.appendChild(l) : (r = "ace_" + i.type.replace(/\./g, " ace_"), d = this.dom.createElement("span"), "fold" == i.type && (d.style.width = i.value.length * this.config.characterWidth + "px", d.setAttribute("title", y("inline-fold.closed.title", "Unfold code"))), d.className = r, d.appendChild(l), e.appendChild(d)), t + n.length;
                }, s.prototype.renderIndentGuide = function(e, t, i) {
                    var n = t.search(this.$indentGuideRe);
                    if (!(n <= 0 || i <= n)) {
                        if (" " == t[0]) {
                            for(var o = (n -= n % this.tabSize) / this.tabSize, r = 0; r < o; r++)e.appendChild(this.$tabStrings[" "].cloneNode(!0));
                            return this.$highlightIndentGuide(), t.substr(n);
                        }
                        if ("\t" == t[0]) {
                            for(r = 0; r < n; r++)e.appendChild(this.$tabStrings["\t"].cloneNode(!0));
                            return this.$highlightIndentGuide(), t.substr(n);
                        }
                        this.$highlightIndentGuide();
                    }
                    return t;
                }, s.prototype.$highlightIndentGuide = function() {
                    if (this.$highlightIndentGuides && this.displayIndentGuides) {
                        this.$highlightIndentGuideMarker = {
                            indentLevel: void 0,
                            start: void 0,
                            end: void 0,
                            dir: void 0
                        };
                        var e = this.session.doc.$lines;
                        if (e) {
                            var t = this.session.selection.getCursor(), i = /^\s*/.exec(this.session.doc.getLine(t.row))[0].length, n = Math.floor(i / this.tabSize);
                            if (this.$highlightIndentGuideMarker = {
                                indentLevel: n,
                                start: t.row
                            }, this.session.$bracketHighlight) {
                                for(var o = this.session.$bracketHighlight.ranges, r = 0; r < o.length; r++)if (t.row !== o[r].start.row) {
                                    this.$highlightIndentGuideMarker.end = o[r].start.row + 1, t.row > o[r].start.row ? this.$highlightIndentGuideMarker.dir = -1 : this.$highlightIndentGuideMarker.dir = 1;
                                    break;
                                }
                            }
                            if (!this.$highlightIndentGuideMarker.end && "" !== e[t.row] && t.column === e[t.row].length) {
                                this.$highlightIndentGuideMarker.dir = 1;
                                for(r = t.row + 1; r < e.length; r++){
                                    var s = e[r], a = /^\s*/.exec(s)[0].length;
                                    if ("" !== s && (this.$highlightIndentGuideMarker.end = r, a <= i)) break;
                                }
                            }
                            this.$renderHighlightIndentGuide();
                        }
                    }
                }, s.prototype.$clearActiveIndentGuide = function() {
                    for(var e = this.element.querySelectorAll(".ace_indent-guide-active"), t = 0; t < e.length; t++)e[t].classList.remove("ace_indent-guide-active");
                }, s.prototype.$setIndentGuideActive = function(e, t) {
                    if ("" !== this.session.doc.getLine(e.row)) {
                        var i = e.element;
                        if (e.element.classList && e.element.classList.contains("ace_line_group")) {
                            if (!(0 < e.element.childNodes.length)) return;
                            i = e.element.childNodes[0];
                        }
                        e = i.childNodes;
                        e && (i = e[t - 1]) && i.classList && i.classList.contains("ace_indent-guide") && i.classList.add("ace_indent-guide-active");
                    }
                }, s.prototype.$renderHighlightIndentGuide = function() {
                    if (this.$lines) {
                        var e = this.$lines.cells, t = (this.$clearActiveIndentGuide(), this.$highlightIndentGuideMarker.indentLevel);
                        if (0 !== t) {
                            if (1 === this.$highlightIndentGuideMarker.dir) for(var i = 0; i < e.length; i++){
                                var n = e[i];
                                if (this.$highlightIndentGuideMarker.end && n.row >= this.$highlightIndentGuideMarker.start + 1) {
                                    if (n.row >= this.$highlightIndentGuideMarker.end) break;
                                    this.$setIndentGuideActive(n, t);
                                }
                            }
                            else for(i = e.length - 1; 0 <= i; i--){
                                n = e[i];
                                if (this.$highlightIndentGuideMarker.end && n.row < this.$highlightIndentGuideMarker.start) {
                                    if (n.row < this.$highlightIndentGuideMarker.end) break;
                                    this.$setIndentGuideActive(n, t);
                                }
                            }
                        }
                    }
                }, s.prototype.$createLineElement = function(e) {
                    var t = this.dom.createElement("div");
                    return t.className = "ace_line", t.style.height = this.config.lineHeight + "px", t;
                }, s.prototype.$renderWrappedLine = function(e, t, i) {
                    var n = 0, o = 0, r = i[0], s = 0, a = this.$createLineElement();
                    e.appendChild(a);
                    for(var l = 0; l < t.length; l++){
                        var c = t[l], h = c.value;
                        if (0 == l && this.displayIndentGuides) {
                            if (n = h.length, !(h = this.renderIndentGuide(a, h, r))) continue;
                            n -= h.length;
                        }
                        if (n + h.length < r) s = this.$renderToken(a, s, c, h), n += h.length;
                        else {
                            for(; n + h.length >= r;){
                                s = this.$renderToken(a, s, c, h.substring(0, r - n)), h = h.substring(r - n), n = r, a = this.$createLineElement(), e.appendChild(a);
                                var d = this.dom.createTextNode(C.stringRepeat("\xa0", i.indent), this.element);
                                d.charCount = 0, a.appendChild(d), s = 0, r = i[++o] || Number.MAX_VALUE;
                            }
                            0 != h.length && (n += h.length, s = this.$renderToken(a, s, c, h));
                        }
                    }
                    i[i.length - 1] > this.MAX_LINE_LENGTH && this.$renderOverflowMessage(a, s, null, "", !0);
                }, s.prototype.$renderSimpleLine = function(e, t) {
                    for(var i = 0, n = 0; n < t.length; n++){
                        var o = t[n], r = o.value;
                        if (0 != n || !this.displayIndentGuides || (r = this.renderIndentGuide(e, r))) {
                            if (i + r.length > this.MAX_LINE_LENGTH) return this.$renderOverflowMessage(e, i, o, r);
                            i = this.$renderToken(e, i, o, r);
                        }
                    }
                }, s.prototype.$renderOverflowMessage = function(e, t, i, n, o) {
                    i && this.$renderToken(e, t, i, n.slice(0, this.MAX_LINE_LENGTH - t));
                    i = this.dom.createElement("span");
                    i.className = "ace_inline_button ace_keyword ace_toggle_wrap", i.textContent = o ? "<hide>" : "<click to see more...>", e.appendChild(i);
                }, s.prototype.$renderLine = function(e, t, i) {
                    var n, o, r = e;
                    (n = (i = i || 0 == i ? i : this.session.getFoldLine(t)) ? this.$getFoldLineTokens(t, i) : this.session.getTokens(t)).length ? (o = this.session.getRowSplitData(t)) && o.length ? (this.$renderWrappedLine(e, n, o), r = e.lastChild) : (r = e, this.$useLineGroups() && (r = this.$createLineElement(), e.appendChild(r)), this.$renderSimpleLine(r, n)) : this.$useLineGroups() && (r = this.$createLineElement(), e.appendChild(r)), this.showEOL && r && (i && (t = i.end.row), (o = this.dom.createElement("span")).className = "ace_invisible ace_invisible_eol", o.textContent = t == this.session.getLength() - 1 ? this.EOF_CHAR : this.EOL_CHAR, r.appendChild(o));
                }, s.prototype.$getFoldLineTokens = function(e, t) {
                    var d = this.session, u = [];
                    var g = d.getTokens(e);
                    return t.walk(function(e, t, i, n, o) {
                        if (null != e) u.push({
                            type: "fold",
                            value: e
                        });
                        else if ((g = o ? d.getTokens(t) : g).length) {
                            for(var r, s = g, a = n, l = i, c = 0, h = 0; h + s[c].value.length < a;)if (h += s[c].value.length, ++c == s.length) return;
                            for(h != a && ((r = s[c].value.substring(a - h)).length > l - a && (r = r.substring(0, l - a)), u.push({
                                type: s[c].type,
                                value: r
                            }), h = a + r.length, c += 1); h < l && c < s.length;)(r = s[c].value).length + h > l ? u.push({
                                type: s[c].type,
                                value: r.substring(0, l - h)
                            }) : u.push(s[c]), h += r.length, c += 1;
                        }
                    }, t.end.row, this.session.getLine(t.end.row).length), u;
                }, s.prototype.$useLineGroups = function() {
                    return this.session.getUseWrapMode();
                }, s);
                function s(e) {
                    this.dom = c, this.element = this.dom.createElement("div"), this.element.className = "ace_layer ace_text-layer", e.appendChild(this.element), this.$updateEolChar = this.$updateEolChar.bind(this), this.$lines = new o(this.element);
                }
                e.prototype.EOF_CHAR = "\xb6", e.prototype.EOL_CHAR_LF = "\xac", e.prototype.EOL_CHAR_CRLF = "\xa4", e.prototype.EOL_CHAR = e.prototype.EOL_CHAR_LF, e.prototype.TAB_CHAR = "\u2014", e.prototype.SPACE_CHAR = "\xb7", e.prototype.$padding = 0, e.prototype.MAX_LINE_LENGTH = 1e4, e.prototype.showInvisibles = !1, e.prototype.showSpaces = !1, e.prototype.showTabs = !1, e.prototype.showEOL = !1, e.prototype.displayIndentGuides = !0, e.prototype.$highlightIndentGuides = !0, e.prototype.$tabStrings = [], e.prototype.destroy = {}, e.prototype.onChangeTabSize = e.prototype.$computeTabString, n.implement(e.prototype, r), t.Text = e;
            }), ace.define("ace/layer/cursor", [
                "require",
                "exports",
                "module",
                "ace/lib/dom"
            ], function(e, t, i) {
                var c = e("../lib/dom"), e = (n.prototype.$updateOpacity = function(e) {
                    for(var t = this.cursors, i = t.length; i--;)c.setStyle(t[i].style, "opacity", e ? "" : "0");
                }, n.prototype.$startCssAnimation = function() {
                    for(var e = this.cursors, t = e.length; t--;)e[t].style.animationDuration = this.blinkInterval + "ms";
                    this.$isAnimating = !0, setTimeout((function() {
                        this.$isAnimating && c.addCssClass(this.element, "ace_animate-blinking");
                    }).bind(this));
                }, n.prototype.$stopCssAnimation = function() {
                    this.$isAnimating = !1, c.removeCssClass(this.element, "ace_animate-blinking");
                }, n.prototype.setPadding = function(e) {
                    this.$padding = e;
                }, n.prototype.setSession = function(e) {
                    this.session = e;
                }, n.prototype.setBlinking = function(e) {
                    e != this.isBlinking && (this.isBlinking = e, this.restartTimer());
                }, n.prototype.setBlinkInterval = function(e) {
                    e != this.blinkInterval && (this.blinkInterval = e, this.restartTimer());
                }, n.prototype.setSmoothBlinking = function(e) {
                    e != this.smoothBlinking && (this.smoothBlinking = e, c.setCssClass(this.element, "ace_smooth-blinking", e), this.$updateCursors(!0), this.restartTimer());
                }, n.prototype.addCursor = function() {
                    var e = c.createElement("div");
                    return e.className = "ace_cursor", this.element.appendChild(e), this.cursors.push(e), e;
                }, n.prototype.removeCursor = function() {
                    var e;
                    if (1 < this.cursors.length) return (e = this.cursors.pop()).parentNode.removeChild(e), e;
                }, n.prototype.hideCursor = function() {
                    this.isVisible = !1, c.addCssClass(this.element, "ace_hidden-cursors"), this.restartTimer();
                }, n.prototype.showCursor = function() {
                    this.isVisible = !0, c.removeCssClass(this.element, "ace_hidden-cursors"), this.restartTimer();
                }, n.prototype.restartTimer = function() {
                    var e, t = this.$updateCursors;
                    clearInterval(this.intervalId), clearTimeout(this.timeoutId), this.$stopCssAnimation(), this.smoothBlinking && (this.$isSmoothBlinking = !1, c.removeCssClass(this.element, "ace_smooth-blinking")), t(!0), this.isBlinking && this.blinkInterval && this.isVisible ? (this.smoothBlinking && (this.$isSmoothBlinking = !0, setTimeout((function() {
                        this.$isSmoothBlinking && c.addCssClass(this.element, "ace_smooth-blinking");
                    }).bind(this))), c.HAS_CSS_ANIMATION ? this.$startCssAnimation() : (e = (function() {
                        this.timeoutId = setTimeout(function() {
                            t(!1);
                        }, .6 * this.blinkInterval);
                    }).bind(this), this.intervalId = setInterval(function() {
                        t(!0), e();
                    }, this.blinkInterval), e())) : this.$stopCssAnimation();
                }, n.prototype.getPixelPosition = function(e, t) {
                    if (!this.config || !this.session) return {
                        left: 0,
                        top: 0
                    };
                    e = e || this.session.selection.getCursor();
                    var i = this.session.documentToScreenPosition(e);
                    return {
                        left: this.$padding + (this.session.$bidiHandler.isBidiRow(i.row, e.row) ? this.session.$bidiHandler.getPosLeft(i.column) : i.column * this.config.characterWidth),
                        top: (i.row - (t ? this.config.firstRowScreen : 0)) * this.config.lineHeight
                    };
                }, n.prototype.isCursorInView = function(e, t) {
                    return 0 <= e.top && e.top < t.maxHeight;
                }, n.prototype.update = function(e) {
                    this.config = e;
                    for(var t = this.session.$selectionMarkers, i = 0, n = 0, i = 0, o = (t = void 0 !== t && 0 !== t.length ? t : [
                        {
                            cursor: null
                        }
                    ]).length; i < o; i++){
                        var r, s, a = this.getPixelPosition(t[i].cursor, !0);
                        (a.top > e.height + e.offset || a.top < 0) && 1 < i || (s = (r = this.cursors[n++] || this.addCursor()).style, this.drawCursor ? this.drawCursor(r, a, e, t[i], this.session) : this.isCursorInView(a, e) ? (c.setStyle(s, "display", "block"), c.translate(r, a.left, a.top), c.setStyle(s, "width", Math.round(e.characterWidth) + "px"), c.setStyle(s, "height", e.lineHeight + "px")) : c.setStyle(s, "display", "none"));
                    }
                    for(; this.cursors.length > n;)this.removeCursor();
                    var l = this.session.getOverwrite();
                    this.$setOverwrite(l), this.$pixelPos = a, this.restartTimer();
                }, n.prototype.$setOverwrite = function(e) {
                    e != this.overwrite && ((this.overwrite = e) ? c.addCssClass(this.element, "ace_overwrite-cursors") : c.removeCssClass(this.element, "ace_overwrite-cursors"));
                }, n.prototype.destroy = function() {
                    clearInterval(this.intervalId), clearTimeout(this.timeoutId);
                }, n);
                function n(e) {
                    this.element = c.createElement("div"), this.element.className = "ace_layer ace_cursor-layer", e.appendChild(this.element), this.isVisible = !1, this.isBlinking = !0, this.blinkInterval = 1e3, this.smoothBlinking = !1, this.cursors = [], this.cursor = this.addCursor(), c.addCssClass(this.element, "ace_hidden-cursors"), this.$updateCursors = this.$updateOpacity.bind(this);
                }
                e.prototype.$padding = 0, e.prototype.drawCursor = null, t.Cursor = e;
            }), ace.define("ace/scrollbar", [
                "require",
                "exports",
                "module",
                "ace/lib/oop",
                "ace/lib/dom",
                "ace/lib/event",
                "ace/lib/event_emitter"
            ], function(e, t, i) {
                var n, o = this && this.__extends || (n = function(e, t) {
                    return (n = Object.setPrototypeOf || (({
                        __proto__: []
                    }) instanceof Array ? function(e, t) {
                        e.__proto__ = t;
                    } : function(e, t) {
                        for(var i in t)Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
                    }))(e, t);
                }, function(e, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
                    function i() {
                        this.constructor = e;
                    }
                    n(e, t), e.prototype = null === t ? Object.create(t) : (i.prototype = t.prototype, new i);
                }), r = e("./lib/oop"), s = e("./lib/dom"), a = e("./lib/event"), e = e("./lib/event_emitter").EventEmitter, l = (c.prototype.setVisible = function(e) {
                    this.element.style.display = e ? "" : "none", this.isVisible = e, this.coeff = 1;
                }, c);
                function c(e, t) {
                    this.element = s.createElement("div"), this.element.className = "ace_scrollbar ace_scrollbar" + t, this.inner = s.createElement("div"), this.inner.className = "ace_scrollbar-inner", this.inner.textContent = "\xa0", this.element.appendChild(this.inner), e.appendChild(this.element), this.setVisible(!1), this.skipEvent = !1, a.addListener(this.element, "scroll", this.onScroll.bind(this)), a.addListener(this.element, "mousedown", a.preventDefault);
                }
                r.implement(l.prototype, e);
                o(d, h = l), d.prototype.onScroll = function() {
                    var e;
                    this.skipEvent || (this.scrollTop = this.element.scrollTop, 1 != this.coeff && (e = this.element.clientHeight / this.scrollHeight, this.scrollTop = this.scrollTop * (1 - e) / (this.coeff - e)), this._emit("scroll", {
                        data: this.scrollTop
                    })), this.skipEvent = !1;
                }, d.prototype.getWidth = function() {
                    return Math.max(this.isVisible ? this.width : 0, this.$minWidth || 0);
                }, d.prototype.setHeight = function(e) {
                    this.element.style.height = e + "px";
                }, d.prototype.setScrollHeight = function(e) {
                    32768 < (this.scrollHeight = e) ? (this.coeff = 32768 / e, e = 32768) : 1 != this.coeff && (this.coeff = 1), this.inner.style.height = e + "px";
                }, d.prototype.setScrollTop = function(e) {
                    this.scrollTop != e && (this.skipEvent = !0, this.scrollTop = e, this.element.scrollTop = e * this.coeff);
                };
                var h, r = d;
                function d(e, t) {
                    var i = h.call(this, e, "-v") || this;
                    return i.scrollTop = 0, i.scrollHeight = 0, t.$scrollbarWidth = i.width = s.scrollbarWidth(e.ownerDocument), i.inner.style.width = i.element.style.width = (i.width || 15) + 5 + "px", i.$minWidth = 0, i;
                }
                r.prototype.setInnerHeight = r.prototype.setScrollHeight;
                o(g, u = l), g.prototype.onScroll = function() {
                    this.skipEvent || (this.scrollLeft = this.element.scrollLeft, this._emit("scroll", {
                        data: this.scrollLeft
                    })), this.skipEvent = !1;
                }, g.prototype.getHeight = function() {
                    return this.isVisible ? this.height : 0;
                }, g.prototype.setWidth = function(e) {
                    this.element.style.width = e + "px";
                }, g.prototype.setInnerWidth = function(e) {
                    this.inner.style.width = e + "px";
                }, g.prototype.setScrollWidth = function(e) {
                    this.inner.style.width = e + "px";
                }, g.prototype.setScrollLeft = function(e) {
                    this.scrollLeft != e && (this.skipEvent = !0, this.scrollLeft = this.element.scrollLeft = e);
                };
                var u, e = g;
                function g(e, t) {
                    e = u.call(this, e, "-h") || this;
                    return e.scrollLeft = 0, e.height = t.$scrollbarWidth, e.inner.style.height = e.element.style.height = (e.height || 15) + 5 + "px", e;
                }
                t.ScrollBar = r, t.ScrollBarV = r, t.ScrollBarH = e, t.VScrollBar = r, t.HScrollBar = e;
            }), ace.define("ace/scrollbar_custom", [
                "require",
                "exports",
                "module",
                "ace/lib/oop",
                "ace/lib/dom",
                "ace/lib/event",
                "ace/lib/event_emitter"
            ], function(e, t, i) {
                var n, o = this && this.__extends || (n = function(e, t) {
                    return (n = Object.setPrototypeOf || (({
                        __proto__: []
                    }) instanceof Array ? function(e, t) {
                        e.__proto__ = t;
                    } : function(e, t) {
                        for(var i in t)Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
                    }))(e, t);
                }, function(e, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
                    function i() {
                        this.constructor = e;
                    }
                    n(e, t), e.prototype = null === t ? Object.create(t) : (i.prototype = t.prototype, new i);
                }), r = e("./lib/oop"), s = e("./lib/dom"), a = e("./lib/event"), e = e("./lib/event_emitter").EventEmitter, l = (s.importCssString(".ace_editor>.ace_sb-v div, .ace_editor>.ace_sb-h div{\n  position: absolute;\n  background: rgba(128, 128, 128, 0.6);\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n  border: 1px solid #bbb;\n  border-radius: 2px;\n  z-index: 8;\n}\n.ace_editor>.ace_sb-v, .ace_editor>.ace_sb-h {\n  position: absolute;\n  z-index: 6;\n  background: none;\n  overflow: hidden!important;\n}\n.ace_editor>.ace_sb-v {\n  z-index: 6;\n  right: 0;\n  top: 0;\n  width: 12px;\n}\n.ace_editor>.ace_sb-v div {\n  z-index: 8;\n  right: 0;\n  width: 100%;\n}\n.ace_editor>.ace_sb-h {\n  bottom: 0;\n  left: 0;\n  height: 12px;\n}\n.ace_editor>.ace_sb-h div {\n  bottom: 0;\n  height: 100%;\n}\n.ace_editor>.ace_sb_grabbed {\n  z-index: 8;\n  background: #000;\n}", "ace_scrollbar.css", !1), c.prototype.setVisible = function(e) {
                    this.element.style.display = e ? "" : "none", this.isVisible = e, this.coeff = 1;
                }, c);
                function c(e, t) {
                    this.element = s.createElement("div"), this.element.className = "ace_sb" + t, this.inner = s.createElement("div"), this.inner.className = "", this.element.appendChild(this.inner), this.VScrollWidth = 12, this.HScrollHeight = 12, e.appendChild(this.element), this.setVisible(!1), this.skipEvent = !1, a.addMultiMouseDownListener(this.element, [
                        500,
                        300,
                        300
                    ], this, "onMouseDown");
                }
                r.implement(l.prototype, e);
                o(d, h = l), d.prototype.onMouseDown = function(e, t) {
                    var i, n, o, r, s;
                    if ("mousedown" === e && 0 === a.getButton(t) && 2 !== t.detail) return t.target === this.inner ? (i = this, n = t.clientY, o = t.clientY, r = this.thumbTop, a.capture(this.inner, function(e) {
                        n = e.clientY;
                    }, function() {
                        clearInterval(s);
                    }), s = setInterval(function() {
                        var e;
                        void 0 !== n && (e = i.scrollTopFromThumbTop(r + n - o)) !== i.scrollTop && i._emit("scroll", {
                            data: e
                        });
                    }, 20)) : (e = t.clientY - this.element.getBoundingClientRect().top - this.thumbHeight / 2, this._emit("scroll", {
                        data: this.scrollTopFromThumbTop(e)
                    })), a.preventDefault(t);
                }, d.prototype.getHeight = function() {
                    return this.height;
                }, d.prototype.scrollTopFromThumbTop = function(e) {
                    e = e * (this.pageHeight - this.viewHeight) / (this.slideHeight - this.thumbHeight);
                    return (e >>= 0) < 0 ? e = 0 : e > this.pageHeight - this.viewHeight && (e = this.pageHeight - this.viewHeight), e;
                }, d.prototype.getWidth = function() {
                    return Math.max(this.isVisible ? this.width : 0, this.$minWidth || 0);
                }, d.prototype.setHeight = function(e) {
                    this.height = Math.max(0, e), this.slideHeight = this.height, this.viewHeight = this.height, this.setScrollHeight(this.pageHeight, !0);
                }, d.prototype.setScrollHeight = function(e, t) {
                    (this.pageHeight !== e || t) && (this.pageHeight = e, this.thumbHeight = this.slideHeight * this.viewHeight / this.pageHeight, this.thumbHeight > this.slideHeight && (this.thumbHeight = this.slideHeight), this.thumbHeight < 15 && (this.thumbHeight = 15), this.inner.style.height = this.thumbHeight + "px", this.scrollTop > this.pageHeight - this.viewHeight) && (this.scrollTop = this.pageHeight - this.viewHeight, this.scrollTop < 0 && (this.scrollTop = 0), this._emit("scroll", {
                        data: this.scrollTop
                    }));
                }, d.prototype.setScrollTop = function(e) {
                    this.scrollTop = e, this.thumbTop = (e = e < 0 ? 0 : e) * (this.slideHeight - this.thumbHeight) / (this.pageHeight - this.viewHeight), this.inner.style.top = this.thumbTop + "px";
                };
                var h, r = d;
                function d(e, t) {
                    var i = h.call(this, e, "-v") || this;
                    return i.scrollTop = 0, i.scrollHeight = 0, i.parent = e, i.width = i.VScrollWidth, i.renderer = t, i.inner.style.width = i.element.style.width = (i.width || 15) + "px", i.$minWidth = 0, i;
                }
                r.prototype.setInnerHeight = r.prototype.setScrollHeight;
                o(g, u = l), g.prototype.onMouseDown = function(e, t) {
                    var i, n, o, r, s;
                    if ("mousedown" === e && 0 === a.getButton(t) && 2 !== t.detail) return t.target === this.inner ? (i = this, n = t.clientX, o = t.clientX, r = this.thumbLeft, a.capture(this.inner, function(e) {
                        n = e.clientX;
                    }, function() {
                        clearInterval(s);
                    }), s = setInterval(function() {
                        var e;
                        void 0 !== n && (e = i.scrollLeftFromThumbLeft(r + n - o)) !== i.scrollLeft && i._emit("scroll", {
                            data: e
                        });
                    }, 20)) : (e = t.clientX - this.element.getBoundingClientRect().left - this.thumbWidth / 2, this._emit("scroll", {
                        data: this.scrollLeftFromThumbLeft(e)
                    })), a.preventDefault(t);
                }, g.prototype.getHeight = function() {
                    return this.isVisible ? this.height : 0;
                }, g.prototype.scrollLeftFromThumbLeft = function(e) {
                    e = e * (this.pageWidth - this.viewWidth) / (this.slideWidth - this.thumbWidth);
                    return (e >>= 0) < 0 ? e = 0 : e > this.pageWidth - this.viewWidth && (e = this.pageWidth - this.viewWidth), e;
                }, g.prototype.setWidth = function(e) {
                    this.width = Math.max(0, e), this.element.style.width = this.width + "px", this.slideWidth = this.width, this.viewWidth = this.width, this.setScrollWidth(this.pageWidth, !0);
                }, g.prototype.setScrollWidth = function(e, t) {
                    (this.pageWidth !== e || t) && (this.pageWidth = e, this.thumbWidth = this.slideWidth * this.viewWidth / this.pageWidth, this.thumbWidth > this.slideWidth && (this.thumbWidth = this.slideWidth), this.thumbWidth < 15 && (this.thumbWidth = 15), this.inner.style.width = this.thumbWidth + "px", this.scrollLeft > this.pageWidth - this.viewWidth) && (this.scrollLeft = this.pageWidth - this.viewWidth, this.scrollLeft < 0 && (this.scrollLeft = 0), this._emit("scroll", {
                        data: this.scrollLeft
                    }));
                }, g.prototype.setScrollLeft = function(e) {
                    this.scrollLeft = e, this.thumbLeft = (e = e < 0 ? 0 : e) * (this.slideWidth - this.thumbWidth) / (this.pageWidth - this.viewWidth), this.inner.style.left = this.thumbLeft + "px";
                };
                var u, e = g;
                function g(e, t) {
                    e = u.call(this, e, "-h") || this;
                    return e.scrollLeft = 0, e.scrollWidth = 0, e.height = e.HScrollHeight, e.inner.style.height = e.element.style.height = (e.height || 12) + "px", e.renderer = t, e;
                }
                e.prototype.setInnerWidth = e.prototype.setScrollWidth, t.ScrollBar = r, t.ScrollBarV = r, t.ScrollBarH = e, t.VScrollBar = r, t.HScrollBar = e;
            }), ace.define("ace/renderloop", [
                "require",
                "exports",
                "module",
                "ace/lib/event"
            ], function(e, t, i) {
                var n = e("./lib/event");
                function o(e, t) {
                    this.onRender = e, this.pending = !1, this.changes = 0, this.$recursionLimit = 2, this.window = t || window;
                    var i = this;
                    this._flush = function(e) {
                        i.pending = !1;
                        var t = i.changes;
                        t && (n.blockIdle(100), i.changes = 0, i.onRender(t)), i.changes ? i.$recursionLimit-- < 0 || i.schedule() : i.$recursionLimit = 2;
                    };
                }
                o.prototype.schedule = function(e) {
                    this.changes = this.changes | e, this.changes && !this.pending && (n.nextFrame(this._flush), this.pending = !0);
                }, o.prototype.clear = function(e) {
                    var t = this.changes;
                    return this.changes = 0, t;
                }, t.RenderLoop = o;
            }), ace.define("ace/layer/font_metrics", [
                "require",
                "exports",
                "module",
                "ace/lib/oop",
                "ace/lib/dom",
                "ace/lib/lang",
                "ace/lib/event",
                "ace/lib/useragent",
                "ace/lib/event_emitter"
            ], function(e, t, i) {
                var n = e("../lib/oop"), o = e("../lib/dom"), r = e("../lib/lang"), s = e("../lib/event"), a = e("../lib/useragent"), e = e("../lib/event_emitter").EventEmitter, l = "function" == typeof ResizeObserver, c = (h.prototype.$setMeasureNodeStyles = function(e, t) {
                    e.width = e.height = "auto", e.left = e.top = "0px", e.visibility = "hidden", e.position = "absolute", e.whiteSpace = "pre", a.isIE < 8 ? e["font-family"] = "inherit" : e.font = "inherit", e.overflow = t ? "hidden" : "visible";
                }, h.prototype.checkForSizeChanges = function(e) {
                    var t;
                    !(e = void 0 === e ? this.$measureSizes() : e) || this.$characterSize.width === e.width && this.$characterSize.height === e.height || (this.$measureNode.style.fontWeight = "bold", t = this.$measureSizes(), this.$measureNode.style.fontWeight = "", this.$characterSize = e, this.charSizes = Object.create(null), this.allowBoldFonts = t && t.width === e.width && t.height === e.height, this._emit("changeCharacterSize", {
                        data: e
                    }));
                }, h.prototype.$addObserver = function() {
                    var t = this;
                    this.$observer = new window.ResizeObserver(function(e) {
                        t.checkForSizeChanges();
                    }), this.$observer.observe(this.$measureNode);
                }, h.prototype.$pollSizeChanges = function() {
                    var t;
                    return this.$pollSizeChangesTimer || this.$observer ? this.$pollSizeChangesTimer : (t = this).$pollSizeChangesTimer = s.onIdle(function e() {
                        t.checkForSizeChanges(), s.onIdle(e, 500);
                    }, 500);
                }, h.prototype.setPolling = function(e) {
                    e ? this.$pollSizeChanges() : this.$pollSizeChangesTimer && (clearInterval(this.$pollSizeChangesTimer), this.$pollSizeChangesTimer = 0);
                }, h.prototype.$measureSizes = function(e) {
                    e = {
                        height: (e || this.$measureNode).clientHeight,
                        width: (e || this.$measureNode).clientWidth / 512
                    };
                    return 0 === e.width || 0 === e.height ? null : e;
                }, h.prototype.$measureCharWidth = function(e) {
                    return this.$main.textContent = r.stringRepeat(e, 512), this.$main.getBoundingClientRect().width / 512;
                }, h.prototype.getCharacterWidth = function(e) {
                    var t = this.charSizes[e];
                    return t = void 0 === t ? this.charSizes[e] = this.$measureCharWidth(e) / this.$characterSize.width : t;
                }, h.prototype.destroy = function() {
                    clearInterval(this.$pollSizeChangesTimer), this.$observer && this.$observer.disconnect(), this.el && this.el.parentNode && this.el.parentNode.removeChild(this.el);
                }, h.prototype.$getZoom = function(e) {
                    return e && e.parentElement ? (Number(window.getComputedStyle(e).zoom) || 1) * this.$getZoom(e.parentElement) : 1;
                }, h.prototype.$initTransformMeasureNodes = function() {
                    function e(e, t) {
                        return [
                            "div",
                            {
                                style: "position: absolute;top:" + e + "px;left:" + t + "px;"
                            }
                        ];
                    }
                    this.els = o.buildDom([
                        e(0, 0),
                        e(200, 0),
                        e(0, 200),
                        e(200, 200)
                    ], this.el);
                }, h.prototype.transformCoordinates = function(e, t) {
                    function i(e, t, i) {
                        var n = e[1] * t[0] - e[0] * t[1];
                        return [
                            (-t[1] * i[0] + t[0] * i[1]) / n,
                            (+e[1] * i[0] - e[0] * i[1]) / n
                        ];
                    }
                    function n(e, t) {
                        return [
                            e[0] - t[0],
                            e[1] - t[1]
                        ];
                    }
                    function o(e, t) {
                        return [
                            e[0] + t[0],
                            e[1] + t[1]
                        ];
                    }
                    function r(e, t) {
                        return [
                            e * t[0],
                            e * t[1]
                        ];
                    }
                    function s(e) {
                        e = e.getBoundingClientRect();
                        return [
                            e.left,
                            e.top
                        ];
                    }
                    e = e && r(1 / this.$getZoom(this.el), e), this.els || this.$initTransformMeasureNodes();
                    var a, l = s(this.els[0]), c = s(this.els[1]), h = s(this.els[2]), d = s(this.els[3]), d = i(n(d, c), n(d, h), n(o(c, h), o(d, l))), c = r(1 + d[0], n(c, l)), h = r(1 + d[1], n(h, l));
                    return t ? (a = d[0] * t[0] / 200 + d[1] * t[1] / 200 + 1, t = o(r(t[0], c), r(t[1], h)), o(r(1 / a / 200, t), l)) : (a = n(e, l), t = i(n(c, r(d[0], a)), n(h, r(d[1], a)), a), r(200, t));
                }, h);
                function h(e) {
                    this.el = o.createElement("div"), this.$setMeasureNodeStyles(this.el.style, !0), this.$main = o.createElement("div"), this.$setMeasureNodeStyles(this.$main.style), this.$measureNode = o.createElement("div"), this.$setMeasureNodeStyles(this.$measureNode.style), this.el.appendChild(this.$main), this.el.appendChild(this.$measureNode), e.appendChild(this.el), this.$measureNode.textContent = r.stringRepeat("X", 512), this.$characterSize = {
                        width: 0,
                        height: 0
                    }, l ? this.$addObserver() : this.checkForSizeChanges();
                }
                c.prototype.$characterSize = {
                    width: 0,
                    height: 0
                }, n.implement(c.prototype, e), t.FontMetrics = c;
            }), ace.define("ace/css/editor-css", [
                "require",
                "exports",
                "module"
            ], function(e, t, i) {
                i.exports = '\n.ace_br1 {border-top-left-radius    : 3px;}\n.ace_br2 {border-top-right-radius   : 3px;}\n.ace_br3 {border-top-left-radius    : 3px; border-top-right-radius:    3px;}\n.ace_br4 {border-bottom-right-radius: 3px;}\n.ace_br5 {border-top-left-radius    : 3px; border-bottom-right-radius: 3px;}\n.ace_br6 {border-top-right-radius   : 3px; border-bottom-right-radius: 3px;}\n.ace_br7 {border-top-left-radius    : 3px; border-top-right-radius:    3px; border-bottom-right-radius: 3px;}\n.ace_br8 {border-bottom-left-radius : 3px;}\n.ace_br9 {border-top-left-radius    : 3px; border-bottom-left-radius:  3px;}\n.ace_br10{border-top-right-radius   : 3px; border-bottom-left-radius:  3px;}\n.ace_br11{border-top-left-radius    : 3px; border-top-right-radius:    3px; border-bottom-left-radius:  3px;}\n.ace_br12{border-bottom-right-radius: 3px; border-bottom-left-radius:  3px;}\n.ace_br13{border-top-left-radius    : 3px; border-bottom-right-radius: 3px; border-bottom-left-radius:  3px;}\n.ace_br14{border-top-right-radius   : 3px; border-bottom-right-radius: 3px; border-bottom-left-radius:  3px;}\n.ace_br15{border-top-left-radius    : 3px; border-top-right-radius:    3px; border-bottom-right-radius: 3px; border-bottom-left-radius: 3px;}\n\n\n.ace_editor {\n    position: relative;\n    overflow: hidden;\n    padding: 0;\n    font: 12px/normal \'Monaco\', \'Menlo\', \'Ubuntu Mono\', \'Consolas\', \'Source Code Pro\', \'source-code-pro\', monospace;\n    direction: ltr;\n    text-align: left;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n    forced-color-adjust: none;\n}\n\n.ace_scroller {\n    position: absolute;\n    overflow: hidden;\n    top: 0;\n    bottom: 0;\n    background-color: inherit;\n    -ms-user-select: none;\n    -moz-user-select: none;\n    -webkit-user-select: none;\n    user-select: none;\n    cursor: text;\n}\n\n.ace_content {\n    position: absolute;\n    box-sizing: border-box;\n    min-width: 100%;\n    contain: style size layout;\n    font-variant-ligatures: no-common-ligatures;\n}\n.ace_invisible {\n    font-variant-ligatures: none;\n}\n\n.ace_keyboard-focus:focus {\n    box-shadow: inset 0 0 0 2px #5E9ED6;\n    outline: none;\n}\n\n.ace_dragging .ace_scroller:before{\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    content: \'\';\n    background: rgba(250, 250, 250, 0.01);\n    z-index: 1000;\n}\n.ace_dragging.ace_dark .ace_scroller:before{\n    background: rgba(0, 0, 0, 0.01);\n}\n\n.ace_gutter {\n    position: absolute;\n    overflow : hidden;\n    width: auto;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    cursor: default;\n    z-index: 4;\n    -ms-user-select: none;\n    -moz-user-select: none;\n    -webkit-user-select: none;\n    user-select: none;\n    contain: style size layout;\n}\n\n.ace_gutter-active-line {\n    position: absolute;\n    left: 0;\n    right: 0;\n}\n\n.ace_scroller.ace_scroll-left:after {\n    content: "";\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    box-shadow: 17px 0 16px -16px rgba(0, 0, 0, 0.4) inset;\n    pointer-events: none;\n}\n\n.ace_gutter-cell, .ace_gutter-cell_svg-icons {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    padding-left: 19px;\n    padding-right: 6px;\n    background-repeat: no-repeat;\n}\n\n.ace_gutter-cell_svg-icons .ace_gutter_annotation {\n    margin-left: -14px;\n    float: left;\n}\n\n.ace_gutter-cell .ace_gutter_annotation {\n    margin-left: -19px;\n    float: left;\n}\n\n.ace_gutter-cell.ace_error, .ace_icon.ace_error, .ace_icon.ace_error_fold, .ace_gutter-cell.ace_security, .ace_icon.ace_security, .ace_icon.ace_security_fold {\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAABOFBMVEX/////////QRswFAb/Ui4wFAYwFAYwFAaWGAfDRymzOSH/PxswFAb/SiUwFAYwFAbUPRvjQiDllog5HhHdRybsTi3/Tyv9Tir+Syj/UC3////XurebMBIwFAb/RSHbPx/gUzfdwL3kzMivKBAwFAbbvbnhPx66NhowFAYwFAaZJg8wFAaxKBDZurf/RB6mMxb/SCMwFAYwFAbxQB3+RB4wFAb/Qhy4Oh+4QifbNRcwFAYwFAYwFAb/QRzdNhgwFAYwFAbav7v/Uy7oaE68MBK5LxLewr/r2NXewLswFAaxJw4wFAbkPRy2PyYwFAaxKhLm1tMwFAazPiQwFAaUGAb/QBrfOx3bvrv/VC/maE4wFAbRPBq6MRO8Qynew8Dp2tjfwb0wFAbx6eju5+by6uns4uH9/f36+vr/GkHjAAAAYnRSTlMAGt+64rnWu/bo8eAA4InH3+DwoN7j4eLi4xP99Nfg4+b+/u9B/eDs1MD1mO7+4PHg2MXa347g7vDizMLN4eG+Pv7i5evs/v79yu7S3/DV7/498Yv24eH+4ufQ3Ozu/v7+y13sRqwAAADLSURBVHjaZc/XDsFgGIBhtDrshlitmk2IrbHFqL2pvXf/+78DPokj7+Fz9qpU/9UXJIlhmPaTaQ6QPaz0mm+5gwkgovcV6GZzd5JtCQwgsxoHOvJO15kleRLAnMgHFIESUEPmawB9ngmelTtipwwfASilxOLyiV5UVUyVAfbG0cCPHig+GBkzAENHS0AstVF6bacZIOzgLmxsHbt2OecNgJC83JERmePUYq8ARGkJx6XtFsdddBQgZE2nPR6CICZhawjA4Fb/chv+399kfR+MMMDGOQAAAABJRU5ErkJggg==");\n    background-repeat: no-repeat;\n    background-position: 2px center;\n}\n\n.ace_gutter-cell.ace_warning, .ace_icon.ace_warning, .ace_icon.ace_warning_fold {\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAmVBMVEX///8AAAD///8AAAAAAABPSzb/5sAAAAB/blH/73z/ulkAAAAAAAD85pkAAAAAAAACAgP/vGz/rkDerGbGrV7/pkQICAf////e0IsAAAD/oED/qTvhrnUAAAD/yHD/njcAAADuv2r/nz//oTj/p064oGf/zHAAAAA9Nir/tFIAAAD/tlTiuWf/tkIAAACynXEAAAAAAAAtIRW7zBpBAAAAM3RSTlMAABR1m7RXO8Ln31Z36zT+neXe5OzooRDfn+TZ4p3h2hTf4t3k3ucyrN1K5+Xaks52Sfs9CXgrAAAAjklEQVR42o3PbQ+CIBQFYEwboPhSYgoYunIqqLn6/z8uYdH8Vmdnu9vz4WwXgN/xTPRD2+sgOcZjsge/whXZgUaYYvT8QnuJaUrjrHUQreGczuEafQCO/SJTufTbroWsPgsllVhq3wJEk2jUSzX3CUEDJC84707djRc5MTAQxoLgupWRwW6UB5fS++NV8AbOZgnsC7BpEAAAAABJRU5ErkJggg==");\n    background-repeat: no-repeat;\n    background-position: 2px center;\n}\n\n.ace_gutter-cell.ace_info, .ace_icon.ace_info, .ace_gutter-cell.ace_hint, .ace_icon.ace_hint {\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAAAAAA6mKC9AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAAJ0Uk5TAAB2k804AAAAPklEQVQY02NgIB68QuO3tiLznjAwpKTgNyDbMegwisCHZUETUZV0ZqOquBpXj2rtnpSJT1AEnnRmL2OgGgAAIKkRQap2htgAAAAASUVORK5CYII=");\n    background-repeat: no-repeat;\n    background-position: 2px center;\n}\n\n.ace_dark .ace_gutter-cell.ace_info, .ace_dark .ace_icon.ace_info, .ace_dark .ace_gutter-cell.ace_hint, .ace_dark .ace_icon.ace_hint {\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQBAMAAADt3eJSAAAAJFBMVEUAAAChoaGAgIAqKiq+vr6tra1ZWVmUlJSbm5s8PDxubm56enrdgzg3AAAAAXRSTlMAQObYZgAAAClJREFUeNpjYMAPdsMYHegyJZFQBlsUlMFVCWUYKkAZMxZAGdxlDMQBAG+TBP4B6RyJAAAAAElFTkSuQmCC");\n}\n\n.ace_icon_svg.ace_error {\n    -webkit-mask-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAxNiI+CjxnIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlPSJyZWQiIHNoYXBlLXJlbmRlcmluZz0iZ2VvbWV0cmljUHJlY2lzaW9uIj4KPGNpcmNsZSBmaWxsPSJub25lIiBjeD0iOCIgY3k9IjgiIHI9IjciIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPGxpbmUgeDE9IjExIiB5MT0iNSIgeDI9IjUiIHkyPSIxMSIvPgo8bGluZSB4MT0iMTEiIHkxPSIxMSIgeDI9IjUiIHkyPSI1Ii8+CjwvZz4KPC9zdmc+");\n    background-color: crimson;\n}\n.ace_icon_svg.ace_security {\n    -webkit-mask-image: url("data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjAgMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8ZyBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZT0iZGFya29yYW5nZSIgZmlsbD0ibm9uZSIgc2hhcGUtcmVuZGVyaW5nPSJnZW9tZXRyaWNQcmVjaXNpb24iPgogICAgICAgIDxwYXRoIGNsYXNzPSJzdHJva2UtbGluZWpvaW4tcm91bmQiIGQ9Ik04IDE0LjgzMDdDOCAxNC44MzA3IDIgMTIuOTA0NyAyIDguMDg5OTJWMy4yNjU0OEM1LjMxIDMuMjY1NDggNy45ODk5OSAxLjM0OTE4IDcuOTg5OTkgMS4zNDkxOEM3Ljk4OTk5IDEuMzQ5MTggMTAuNjkgMy4yNjU0OCAxNCAzLjI2NTQ4VjguMDg5OTJDMTQgMTIuOTA0NyA4IDE0LjgzMDcgOCAxNC44MzA3WiIvPgogICAgICAgIDxwYXRoIGQ9Ik0yIDguMDg5OTJWMy4yNjU0OEM1LjMxIDMuMjY1NDggNy45ODk5OSAxLjM0OTE4IDcuOTg5OTkgMS4zNDkxOCIvPgogICAgICAgIDxwYXRoIGQ9Ik0xMy45OSA4LjA4OTkyVjMuMjY1NDhDMTAuNjggMy4yNjU0OCA4IDEuMzQ5MTggOCAxLjM0OTE4Ii8+CiAgICAgICAgPHBhdGggY2xhc3M9InN0cm9rZS1saW5lam9pbi1yb3VuZCIgZD0iTTggNFY5Ii8+CiAgICAgICAgPHBhdGggY2xhc3M9InN0cm9rZS1saW5lam9pbi1yb3VuZCIgZD0iTTggMTBWMTIiLz4KICAgIDwvZz4KPC9zdmc+");\n    background-color: crimson;\n}\n.ace_icon_svg.ace_warning {\n    -webkit-mask-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAxNiI+CjxnIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlPSJkYXJrb3JhbmdlIiBzaGFwZS1yZW5kZXJpbmc9Imdlb21ldHJpY1ByZWNpc2lvbiI+Cjxwb2x5Z29uIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGZpbGw9Im5vbmUiIHBvaW50cz0iOCAxIDE1IDE1IDEgMTUgOCAxIi8+CjxyZWN0IHg9IjgiIHk9IjEyIiB3aWR0aD0iMC4wMSIgaGVpZ2h0PSIwLjAxIi8+CjxsaW5lIHgxPSI4IiB5MT0iNiIgeDI9IjgiIHkyPSIxMCIvPgo8L2c+Cjwvc3ZnPg==");\n    background-color: darkorange;\n}\n.ace_icon_svg.ace_info {\n    -webkit-mask-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAxNiI+CjxnIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlPSJibHVlIiBzaGFwZS1yZW5kZXJpbmc9Imdlb21ldHJpY1ByZWNpc2lvbiI+CjxjaXJjbGUgZmlsbD0ibm9uZSIgY3g9IjgiIGN5PSI4IiByPSI3IiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjxwb2x5bGluZSBwb2ludHM9IjggMTEgOCA4Ii8+Cjxwb2x5bGluZSBwb2ludHM9IjkgOCA2IDgiLz4KPGxpbmUgeDE9IjEwIiB5MT0iMTEiIHgyPSI2IiB5Mj0iMTEiLz4KPHJlY3QgeD0iOCIgeT0iNSIgd2lkdGg9IjAuMDEiIGhlaWdodD0iMC4wMSIvPgo8L2c+Cjwvc3ZnPg==");\n    background-color: royalblue;\n}\n.ace_icon_svg.ace_hint {\n    -webkit-mask-image: url("data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjAgMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8ZyBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZT0ic2lsdmVyIiBmaWxsPSJub25lIiBzaGFwZS1yZW5kZXJpbmc9Imdlb21ldHJpY1ByZWNpc2lvbiI+CiAgICAgICAgPHBhdGggY2xhc3M9InN0cm9rZS1saW5lam9pbi1yb3VuZCIgZD0iTTYgMTRIMTAiLz4KICAgICAgICA8cGF0aCBkPSJNOCAxMUg5QzkgOS40NzAwMiAxMiA4LjU0MDAyIDEyIDUuNzYwMDJDMTIuMDIgNC40MDAwMiAxMS4zOSAzLjM2MDAyIDEwLjQzIDIuNjcwMDJDOSAxLjY0MDAyIDcuMDAwMDEgMS42NDAwMiA1LjU3MDAxIDIuNjcwMDJDNC42MTAwMSAzLjM2MDAyIDMuOTggNC40MDAwMiA0IDUuNzYwMDJDNCA4LjU0MDAyIDcuMDAwMDEgOS40NzAwMiA3LjAwMDAxIDExSDhaIi8+CiAgICA8L2c+Cjwvc3ZnPg==");\n    background-color: silver;\n}\n\n.ace_icon_svg.ace_error_fold {\n    -webkit-mask-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAxNiIgZmlsbD0ibm9uZSI+CiAgPHBhdGggZD0ibSAxOC45Mjk4NTEsNy44Mjk4MDc2IGMgMC4xNDYzNTMsNi4zMzc0NjA0IC02LjMyMzE0Nyw3Ljc3Nzg0NDQgLTcuNDc3OTEyLDcuNzc3ODQ0NCAtMi4xMDcyNzI2LC0wLjEyODc1IDUuMTE3Njc4LDAuMzU2MjQ5IDUuMDUxNjk4LC03Ljg3MDA2MTggLTAuNjA0NjcyLC04LjAwMzk3MzQ5IC03LjA3NzI3MDYsLTcuNTYzMTE4OSAtNC44NTczLC03LjQzMDM5NTU2IDEuNjA2LC0wLjExNTE0MjI1IDYuODk3NDg1LDEuMjYyNTQ1OTYgNy4yODM1MTQsNy41MjI2MTI5NiB6IiBmaWxsPSJjcmltc29uIiBzdHJva2Utd2lkdGg9IjIiLz4KICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0ibSA4LjExNDc1NjIsMi4wNTI5ODI4IGMgMy4zNDkxNjk4LDAgNi4wNjQxMzI4LDIuNjc2ODYyNyA2LjA2NDEzMjgsNS45Nzg5NTMgMCwzLjMwMjExMjIgLTIuNzE0OTYzLDUuOTc4OTIwMiAtNi4wNjQxMzI4LDUuOTc4OTIwMiAtMy4zNDkxNDczLDAgLTYuMDY0MTc3MiwtMi42NzY4MDggLTYuMDY0MTc3MiwtNS45Nzg5MjAyIDAuMDA1MzksLTMuMjk5ODg2MSAyLjcxNzI2NTYsLTUuOTczNjQwOCA2LjA2NDE3NzIsLTUuOTc4OTUzIHogbSAwLC0xLjczNTgyNzE5IGMgLTQuMzIxNDgzNiwwIC03LjgyNDc0MDM4LDMuNDU0MDE4NDkgLTcuODI0NzQwMzgsNy43MTQ3ODAxOSAwLDQuMjYwNzI4MiAzLjUwMzI1Njc4LDcuNzE0NzQ1MiA3LjgyNDc0MDM4LDcuNzE0NzQ1MiA0LjMyMTQ0OTgsMCA3LjgyNDY5OTgsLTMuNDU0MDE3IDcuODI0Njk5OCwtNy43MTQ3NDUyIDAsLTIuMDQ2MDkxNCAtMC44MjQzOTIsLTQuMDA4MzY3MiAtMi4yOTE3NTYsLTUuNDU1MTc0NiBDIDEyLjE4MDIyNSwxLjEyOTk2NDggMTAuMTkwMDEzLDAuMzE3MTU1NjEgOC4xMTQ3NTYyLDAuMzE3MTU1NjEgWiBNIDYuOTM3NDU2Myw4LjI0MDU5ODUgNC42NzE4Njg1LDEwLjQ4NTg1MiA2LjAwODY4MTQsMTEuODc2NzI4IDguMzE3MDAzNSw5LjYwMDc5MTEgMTAuNjI1MzM3LDExLjg3NjcyOCAxMS45NjIxMzgsMTAuNDg1ODUyIDkuNjk2NTUwOCw4LjI0MDU5ODUgMTEuOTYyMTM4LDYuMDA2ODA2NiAxMC41NzMyNDYsNC42Mzc0MzM1IDguMzE3MDAzNSw2Ljg3MzQyOTcgNi4wNjA3NjA3LDQuNjM3NDMzNSA0LjY3MTg2ODUsNi4wMDY4MDY2IFoiIGZpbGw9ImNyaW1zb24iIHN0cm9rZS13aWR0aD0iMiIvPgo8L3N2Zz4=");\n    background-color: crimson;\n}\n.ace_icon_svg.ace_security_fold {\n    -webkit-mask-image: url("data:image/svg+xml;base64,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");\n    background-color: crimson;\n}\n.ace_icon_svg.ace_warning_fold {\n    -webkit-mask-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAyMCAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNC43NzY5IDE0LjczMzdMOC42NTE5MiAyLjQ4MzY5QzguMzI5NDYgMS44Mzg3NyA3LjQwOTEzIDEuODM4NzcgNy4wODY2NyAyLjQ4MzY5TDAuOTYxNjY5IDE0LjczMzdDMC42NzA3NzUgMTUuMzE1NSAxLjA5MzgzIDE2IDEuNzQ0MjkgMTZIMTMuOTk0M0MxNC42NDQ4IDE2IDE1LjA2NzggMTUuMzE1NSAxNC43NzY5IDE0LjczMzdaTTMuMTYwMDcgMTQuMjVMNy44NjkyOSA0LjgzMTU2TDEyLjU3ODUgMTQuMjVIMy4xNjAwN1pNOC43NDQyOSAxMS42MjVWMTMuMzc1SDYuOTk0MjlWMTEuNjI1SDguNzQ0MjlaTTYuOTk0MjkgMTAuNzVWNy4yNUg4Ljc0NDI5VjEwLjc1SDYuOTk0MjlaIiBmaWxsPSIjRUM3MjExIi8+CjxwYXRoIGQ9Ik0xMS4xOTkxIDIuOTUyMzhDMTAuODgwOSAyLjMxNDY3IDEwLjM1MzcgMS44MDUyNiA5LjcwNTUgMS41MDlMMTEuMDQxIDEuMDY5NzhDMTEuNjg4MyAwLjk0OTgxNCAxMi4zMzcgMS4yNzI2MyAxMi42MzE3IDEuODYxNDFMMTcuNjEzNiAxMS44MTYxQzE4LjM1MjcgMTMuMjkyOSAxNy41OTM4IDE1LjA4MDQgMTYuMDE4IDE1LjU3NDVDMTYuNDA0NCAxNC40NTA3IDE2LjMyMzEgMTMuMjE4OCAxNS43OTI0IDEyLjE1NTVMMTEuMTk5MSAyLjk1MjM4WiIgZmlsbD0iI0VDNzIxMSIvPgo8L3N2Zz4=");\n    background-color: darkorange;\n}\n\n.ace_scrollbar {\n    contain: strict;\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    z-index: 6;\n}\n\n.ace_scrollbar-inner {\n    position: absolute;\n    cursor: text;\n    left: 0;\n    top: 0;\n}\n\n.ace_scrollbar-v{\n    overflow-x: hidden;\n    overflow-y: scroll;\n    top: 0;\n}\n\n.ace_scrollbar-h {\n    overflow-x: scroll;\n    overflow-y: hidden;\n    left: 0;\n}\n\n.ace_print-margin {\n    position: absolute;\n    height: 100%;\n}\n\n.ace_text-input {\n    position: absolute;\n    z-index: 0;\n    width: 0.5em;\n    height: 1em;\n    opacity: 0;\n    background: transparent;\n    -moz-appearance: none;\n    appearance: none;\n    border: none;\n    resize: none;\n    outline: none;\n    overflow: hidden;\n    font: inherit;\n    padding: 0 1px;\n    margin: 0 -1px;\n    contain: strict;\n    -ms-user-select: text;\n    -moz-user-select: text;\n    -webkit-user-select: text;\n    user-select: text;\n    /*with `pre-line` chrome inserts &nbsp; instead of space*/\n    white-space: pre!important;\n}\n.ace_text-input.ace_composition {\n    background: transparent;\n    color: inherit;\n    z-index: 1000;\n    opacity: 1;\n}\n.ace_composition_placeholder { color: transparent }\n.ace_composition_marker { \n    border-bottom: 1px solid;\n    position: absolute;\n    border-radius: 0;\n    margin-top: 1px;\n}\n\n[ace_nocontext=true] {\n    transform: none!important;\n    filter: none!important;\n    clip-path: none!important;\n    mask : none!important;\n    contain: none!important;\n    perspective: none!important;\n    mix-blend-mode: initial!important;\n    z-index: auto;\n}\n\n.ace_layer {\n    z-index: 1;\n    position: absolute;\n    overflow: hidden;\n    /* workaround for chrome bug https://github.com/ajaxorg/ace/issues/2312*/\n    word-wrap: normal;\n    white-space: pre;\n    height: 100%;\n    width: 100%;\n    box-sizing: border-box;\n    /* setting pointer-events: auto; on node under the mouse, which changes\n        during scroll, will break mouse wheel scrolling in Safari */\n    pointer-events: none;\n}\n\n.ace_gutter-layer {\n    position: relative;\n    width: auto;\n    text-align: right;\n    pointer-events: auto;\n    height: 1000000px;\n    contain: style size layout;\n}\n\n.ace_text-layer {\n    font: inherit !important;\n    position: absolute;\n    height: 1000000px;\n    width: 1000000px;\n    contain: style size layout;\n}\n\n.ace_text-layer > .ace_line, .ace_text-layer > .ace_line_group {\n    contain: style size layout;\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n}\n\n.ace_hidpi .ace_text-layer,\n.ace_hidpi .ace_gutter-layer,\n.ace_hidpi .ace_content,\n.ace_hidpi .ace_gutter {\n    contain: strict;\n}\n.ace_hidpi .ace_text-layer > .ace_line, \n.ace_hidpi .ace_text-layer > .ace_line_group {\n    contain: strict;\n}\n\n.ace_cjk {\n    display: inline-block;\n    text-align: center;\n}\n\n.ace_cursor-layer {\n    z-index: 4;\n}\n\n.ace_cursor {\n    z-index: 4;\n    position: absolute;\n    box-sizing: border-box;\n    border-left: 2px solid;\n    /* workaround for smooth cursor repaintng whole screen in chrome */\n    transform: translatez(0);\n}\n\n.ace_multiselect .ace_cursor {\n    border-left-width: 1px;\n}\n\n.ace_slim-cursors .ace_cursor {\n    border-left-width: 1px;\n}\n\n.ace_overwrite-cursors .ace_cursor {\n    border-left-width: 0;\n    border-bottom: 1px solid;\n}\n\n.ace_hidden-cursors .ace_cursor {\n    opacity: 0.2;\n}\n\n.ace_hasPlaceholder .ace_hidden-cursors .ace_cursor {\n    opacity: 0;\n}\n\n.ace_smooth-blinking .ace_cursor {\n    transition: opacity 0.18s;\n}\n\n.ace_animate-blinking .ace_cursor {\n    animation-duration: 1000ms;\n    animation-timing-function: step-end;\n    animation-name: blink-ace-animate;\n    animation-iteration-count: infinite;\n}\n\n.ace_animate-blinking.ace_smooth-blinking .ace_cursor {\n    animation-duration: 1000ms;\n    animation-timing-function: ease-in-out;\n    animation-name: blink-ace-animate-smooth;\n}\n    \n@keyframes blink-ace-animate {\n    from, to { opacity: 1; }\n    60% { opacity: 0; }\n}\n\n@keyframes blink-ace-animate-smooth {\n    from, to { opacity: 1; }\n    45% { opacity: 1; }\n    60% { opacity: 0; }\n    85% { opacity: 0; }\n}\n\n.ace_marker-layer .ace_step, .ace_marker-layer .ace_stack {\n    position: absolute;\n    z-index: 3;\n}\n\n.ace_marker-layer .ace_selection {\n    position: absolute;\n    z-index: 5;\n}\n\n.ace_marker-layer .ace_bracket {\n    position: absolute;\n    z-index: 6;\n}\n\n.ace_marker-layer .ace_error_bracket {\n    position: absolute;\n    border-bottom: 1px solid #DE5555;\n    border-radius: 0;\n}\n\n.ace_marker-layer .ace_active-line {\n    position: absolute;\n    z-index: 2;\n}\n\n.ace_marker-layer .ace_selected-word {\n    position: absolute;\n    z-index: 4;\n    box-sizing: border-box;\n}\n\n.ace_line .ace_fold {\n    box-sizing: border-box;\n\n    display: inline-block;\n    height: 11px;\n    margin-top: -2px;\n    vertical-align: middle;\n\n    background-image:\n        url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAJCAYAAADU6McMAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAJpJREFUeNpi/P//PwOlgAXGYGRklAVSokD8GmjwY1wasKljQpYACtpCFeADcHVQfQyMQAwzwAZI3wJKvCLkfKBaMSClBlR7BOQikCFGQEErIH0VqkabiGCAqwUadAzZJRxQr/0gwiXIal8zQQPnNVTgJ1TdawL0T5gBIP1MUJNhBv2HKoQHHjqNrA4WO4zY0glyNKLT2KIfIMAAQsdgGiXvgnYAAAAASUVORK5CYII="),\n        url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAA3CAYAAADNNiA5AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAACJJREFUeNpi+P//fxgTAwPDBxDxD078RSX+YeEyDFMCIMAAI3INmXiwf2YAAAAASUVORK5CYII=");\n    background-repeat: no-repeat, repeat-x;\n    background-position: center center, top left;\n    color: transparent;\n\n    border: 1px solid black;\n    border-radius: 2px;\n\n    cursor: pointer;\n    pointer-events: auto;\n}\n\n.ace_dark .ace_fold {\n}\n\n.ace_fold:hover{\n    background-image:\n        url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAJCAYAAADU6McMAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAJpJREFUeNpi/P//PwOlgAXGYGRklAVSokD8GmjwY1wasKljQpYACtpCFeADcHVQfQyMQAwzwAZI3wJKvCLkfKBaMSClBlR7BOQikCFGQEErIH0VqkabiGCAqwUadAzZJRxQr/0gwiXIal8zQQPnNVTgJ1TdawL0T5gBIP1MUJNhBv2HKoQHHjqNrA4WO4zY0glyNKLT2KIfIMAAQsdgGiXvgnYAAAAASUVORK5CYII="),\n        url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAA3CAYAAADNNiA5AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAACBJREFUeNpi+P//fz4TAwPDZxDxD5X4i5fLMEwJgAADAEPVDbjNw87ZAAAAAElFTkSuQmCC");\n}\n\n.ace_tooltip {\n    background-color: #f5f5f5;\n    border: 1px solid gray;\n    border-radius: 1px;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);\n    color: black;\n    padding: 3px 4px;\n    position: fixed;\n    z-index: 999999;\n    box-sizing: border-box;\n    cursor: default;\n    white-space: pre-wrap;\n    word-wrap: break-word;\n    line-height: normal;\n    font-style: normal;\n    font-weight: normal;\n    letter-spacing: normal;\n    pointer-events: none;\n    overflow: auto;\n    max-width: min(33em, 66vw);\n    overscroll-behavior: contain;\n}\n.ace_tooltip pre {\n    white-space: pre-wrap;\n}\n\n.ace_tooltip.ace_dark {\n    background-color: #636363;\n    color: #fff;\n}\n\n.ace_tooltip:focus {\n    outline: 1px solid #5E9ED6;\n}\n\n.ace_icon {\n    display: inline-block;\n    width: 18px;\n    vertical-align: top;\n}\n\n.ace_icon_svg {\n    display: inline-block;\n    width: 12px;\n    vertical-align: top;\n    -webkit-mask-repeat: no-repeat;\n    -webkit-mask-size: 12px;\n    -webkit-mask-position: center;\n}\n\n.ace_folding-enabled > .ace_gutter-cell, .ace_folding-enabled > .ace_gutter-cell_svg-icons {\n    padding-right: 13px;\n}\n\n.ace_fold-widget, .ace_custom-widget {\n    box-sizing: border-box;\n\n    margin: 0 -12px 0 1px;\n    display: none;\n    width: 11px;\n    vertical-align: top;\n\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAANElEQVR42mWKsQ0AMAzC8ixLlrzQjzmBiEjp0A6WwBCSPgKAXoLkqSot7nN3yMwR7pZ32NzpKkVoDBUxKAAAAABJRU5ErkJggg==");\n    background-repeat: no-repeat;\n    background-position: center;\n\n    border-radius: 3px;\n    \n    border: 1px solid transparent;\n    cursor: pointer;\n    pointer-events: auto;\n}\n\n.ace_custom-widget {\n    background: none;\n}\n\n.ace_folding-enabled .ace_fold-widget {\n    display: inline-block;   \n}\n\n.ace_fold-widget.ace_end {\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAANElEQVR42m3HwQkAMAhD0YzsRchFKI7sAikeWkrxwScEB0nh5e7KTPWimZki4tYfVbX+MNl4pyZXejUO1QAAAABJRU5ErkJggg==");\n}\n\n.ace_fold-widget.ace_closed {\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAGCAYAAAAG5SQMAAAAOUlEQVR42jXKwQkAMAgDwKwqKD4EwQ26sSOkVWjgIIHAzPiCgaqiqnJHZnKICBERHN194O5b9vbLuAVRL+l0YWnZAAAAAElFTkSuQmCCXA==");\n}\n\n.ace_fold-widget:hover {\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    background-color: rgba(255, 255, 255, 0.2);\n    box-shadow: 0 1px 1px rgba(255, 255, 255, 0.7);\n}\n\n.ace_fold-widget:active {\n    border: 1px solid rgba(0, 0, 0, 0.4);\n    background-color: rgba(0, 0, 0, 0.05);\n    box-shadow: 0 1px 1px rgba(255, 255, 255, 0.8);\n}\n/**\n * Dark version for fold widgets\n */\n.ace_dark .ace_fold-widget {\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHklEQVQIW2P4//8/AzoGEQ7oGCaLLAhWiSwB146BAQCSTPYocqT0AAAAAElFTkSuQmCC");\n}\n.ace_dark .ace_fold-widget.ace_end {\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAH0lEQVQIW2P4//8/AxQ7wNjIAjDMgC4AxjCVKBirIAAF0kz2rlhxpAAAAABJRU5ErkJggg==");\n}\n.ace_dark .ace_fold-widget.ace_closed {\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAFCAYAAACAcVaiAAAAHElEQVQIW2P4//+/AxAzgDADlOOAznHAKgPWAwARji8UIDTfQQAAAABJRU5ErkJggg==");\n}\n.ace_dark .ace_fold-widget:hover {\n    box-shadow: 0 1px 1px rgba(255, 255, 255, 0.2);\n    background-color: rgba(255, 255, 255, 0.1);\n}\n.ace_dark .ace_fold-widget:active {\n    box-shadow: 0 1px 1px rgba(255, 255, 255, 0.2);\n}\n\n.ace_inline_button {\n    border: 1px solid lightgray;\n    display: inline-block;\n    margin: -1px 8px;\n    padding: 0 5px;\n    pointer-events: auto;\n    cursor: pointer;\n}\n.ace_inline_button:hover {\n    border-color: gray;\n    background: rgba(200,200,200,0.2);\n    display: inline-block;\n    pointer-events: auto;\n}\n\n.ace_fold-widget.ace_invalid {\n    background-color: #FFB4B4;\n    border-color: #DE5555;\n}\n\n.ace_fade-fold-widgets .ace_fold-widget {\n    transition: opacity 0.4s ease 0.05s;\n    opacity: 0;\n}\n\n.ace_fade-fold-widgets:hover .ace_fold-widget {\n    transition: opacity 0.05s ease 0.05s;\n    opacity:1;\n}\n\n.ace_underline {\n    text-decoration: underline;\n}\n\n.ace_bold {\n    font-weight: bold;\n}\n\n.ace_nobold .ace_bold {\n    font-weight: normal;\n}\n\n.ace_italic {\n    font-style: italic;\n}\n\n\n.ace_error-marker {\n    background-color: rgba(255, 0, 0,0.2);\n    position: absolute;\n    z-index: 9;\n}\n\n.ace_highlight-marker {\n    background-color: rgba(255, 255, 0,0.2);\n    position: absolute;\n    z-index: 8;\n}\n\n.ace_mobile-menu {\n    position: absolute;\n    line-height: 1.5;\n    border-radius: 4px;\n    -ms-user-select: none;\n    -moz-user-select: none;\n    -webkit-user-select: none;\n    user-select: none;\n    background: white;\n    box-shadow: 1px 3px 2px grey;\n    border: 1px solid #dcdcdc;\n    color: black;\n}\n.ace_dark > .ace_mobile-menu {\n    background: #333;\n    color: #ccc;\n    box-shadow: 1px 3px 2px grey;\n    border: 1px solid #444;\n\n}\n.ace_mobile-button {\n    padding: 2px;\n    cursor: pointer;\n    overflow: hidden;\n}\n.ace_mobile-button:hover {\n    background-color: #eee;\n    opacity:1;\n}\n.ace_mobile-button:active {\n    background-color: #ddd;\n}\n\n.ace_placeholder {\n    position: relative;\n    font-family: arial;\n    transform: scale(0.9);\n    transform-origin: left;\n    white-space: pre;\n    opacity: 0.7;\n    margin: 0 10px;\n    z-index: 1;\n}\n\n.ace_ghost_text {\n    opacity: 0.5;\n    font-style: italic;\n}\n\n.ace_ghost_text_container > div {\n    white-space: pre;\n}\n\n.ghost_text_line_wrapped::after {\n    content: "\u21A9";\n    position: absolute;\n}\n\n.ace_lineWidgetContainer.ace_ghost_text {\n    margin: 0px 4px\n}\n\n.ace_screenreader-only {\n    position:absolute;\n    left:-10000px;\n    top:auto;\n    width:1px;\n    height:1px;\n    overflow:hidden;\n}\n\n.ace_hidden_token {\n    display: none;\n}';
            }), ace.define("ace/layer/decorators", [
                "require",
                "exports",
                "module",
                "ace/lib/dom",
                "ace/lib/oop",
                "ace/lib/event_emitter"
            ], function(e, t, i) {
                var n = e("../lib/dom"), o = e("../lib/oop"), e = e("../lib/event_emitter").EventEmitter, r = (s.prototype.$createCanvas = function() {
                    this.canvas = n.createElement("canvas"), this.canvas.style.top = "0px", this.canvas.style.right = "0px", this.canvas.style.zIndex = "7", this.canvas.style.position = "absolute";
                }, s.prototype.setScrollBarV = function(e) {
                    this.$createCanvas(), (this.scrollbarV = e).element.appendChild(this.canvas), this.setDimensions();
                }, s.prototype.$updateDecorators = function(e) {
                    if ("function" == typeof this.canvas.getContext) {
                        var t = !0 === this.renderer.theme.isDark ? this.colors.dark : this.colors.light, i = (this.setDimensions(e), this.canvas.getContext("2d")), n = this.renderer.session.$annotations;
                        if (i.clearRect(0, 0, this.canvas.width, this.canvas.height), n) {
                            var o = {
                                info: 1,
                                warning: 2,
                                error: 3
                            };
                            n.forEach(function(e) {
                                e.priority = o[e.type] || null;
                            });
                            for(var n = n.sort(function(e, t) {
                                return e.priority < t.priority ? -1 : t.priority < e.priority ? 1 : 0;
                            }), r = 0; r < n.length; r++){
                                var s = n[r].row, s = this.getVerticalOffsetForRow(s), a = s + this.lineHeight, s = Math.round(this.heightRatio * s), a = Math.round(this.heightRatio * a), s = Math.round((s + a) / 2), a = a - s, l = (s = (s = s - (a = a < this.halfMinDecorationHeight ? this.halfMinDecorationHeight : a) < 0 ? a : s) + a > this.canvasHeight ? this.canvasHeight - a : s) - a, s = s + a - l;
                                i.fillStyle = t[n[r].type] || null, i.fillRect(0, l, Math.round(this.oneZoneWidth - 1), s);
                            }
                        }
                        var e = this.renderer.session.selection.getCursor();
                        e && (e = Math.round(this.getVerticalOffsetForRow(e.row) * this.heightRatio), i.fillStyle = "rgba(0, 0, 0, 0.5)", i.fillRect(0, e, this.canvasWidth, 2));
                    }
                }, s.prototype.getVerticalOffsetForRow = function(e) {
                    return this.renderer.session.documentToScreenRow(e |= 0, 0) * this.lineHeight;
                }, s.prototype.setDimensions = function(e) {
                    e = e || this.renderer.layerConfig, this.maxHeight = e.maxHeight, this.lineHeight = e.lineHeight, this.canvasHeight = e.height, this.canvasWidth = this.scrollbarV.width || this.canvasWidth, this.setZoneWidth(), this.canvas.width = this.canvasWidth, this.canvas.height = this.canvasHeight, this.maxHeight < this.canvasHeight ? this.heightRatio = 1 : this.heightRatio = this.canvasHeight / this.maxHeight;
                }, s.prototype.setZoneWidth = function() {
                    this.oneZoneWidth = this.canvasWidth;
                }, s.prototype.destroy = function() {
                    this.canvas.parentNode.removeChild(this.canvas);
                }, s);
                function s(e, t) {
                    this.renderer = t, this.pixelRatio = 1, this.maxHeight = t.layerConfig.maxHeight, this.lineHeight = t.layerConfig.lineHeight, this.minDecorationHeight = 2 * this.pixelRatio | 0, this.halfMinDecorationHeight = this.minDecorationHeight / 2 | 0, this.colors = {}, this.colors.dark = {
                        error: "rgba(255, 18, 18, 1)",
                        warning: "rgba(18, 136, 18, 1)",
                        info: "rgba(18, 18, 136, 1)"
                    }, this.colors.light = {
                        error: "rgb(255,51,51)",
                        warning: "rgb(32,133,72)",
                        info: "rgb(35,68,138)"
                    }, this.setScrollBarV(e);
                }
                o.implement(r.prototype, e), t.Decorator = r;
            }), ace.define("ace/virtual_renderer", [
                "require",
                "exports",
                "module",
                "ace/lib/oop",
                "ace/lib/dom",
                "ace/lib/lang",
                "ace/config",
                "ace/layer/gutter",
                "ace/layer/marker",
                "ace/layer/text",
                "ace/layer/cursor",
                "ace/scrollbar",
                "ace/scrollbar",
                "ace/scrollbar_custom",
                "ace/scrollbar_custom",
                "ace/renderloop",
                "ace/layer/font_metrics",
                "ace/lib/event_emitter",
                "ace/css/editor-css",
                "ace/layer/decorators",
                "ace/lib/useragent",
                "ace/layer/text_util"
            ], function(e, t, i) {
                var n = e("./lib/oop"), a = e("./lib/dom"), o = e("./lib/lang"), r = e("./config"), s = e("./layer/gutter").Gutter, l = e("./layer/marker").Marker, c = e("./layer/text").Text, h = e("./layer/cursor").Cursor, d = e("./scrollbar").HScrollBar, u = e("./scrollbar").VScrollBar, g = e("./scrollbar_custom").HScrollBar, p = e("./scrollbar_custom").VScrollBar, m = e("./renderloop").RenderLoop, f = e("./layer/font_metrics").FontMetrics, C = e("./lib/event_emitter").EventEmitter, y = e("./css/editor-css"), v = e("./layer/decorators").Decorator, I = e("./lib/useragent"), b = e("./layer/text_util").isTextToken, e = (a.importCssString(y, "ace_editor.css", !1), A.prototype.updateCharacterSize = function() {
                    this.$textLayer.allowBoldFonts != this.$allowBoldFonts && (this.$allowBoldFonts = this.$textLayer.allowBoldFonts, this.setStyle("ace_nobold", !this.$allowBoldFonts)), this.layerConfig.characterWidth = this.characterWidth = this.$textLayer.getCharacterWidth(), this.layerConfig.lineHeight = this.lineHeight = this.$textLayer.getLineHeight(), this.$updatePrintMargin(), a.setStyle(this.scroller.style, "line-height", this.lineHeight + "px");
                }, A.prototype.setSession = function(e) {
                    this.session && this.session.doc.off("changeNewLineMode", this.onChangeNewLineMode), (this.session = e) && this.scrollMargin.top && e.getScrollTop() <= 0 && e.setScrollTop(-this.scrollMargin.top), this.$cursorLayer.setSession(e), this.$markerBack.setSession(e), this.$markerFront.setSession(e), this.$gutterLayer.setSession(e), this.$textLayer.setSession(e), e && (this.$loop.schedule(this.CHANGE_FULL), this.session.$setFontMetrics(this.$fontMetrics), this.scrollBarH.scrollLeft = this.scrollBarV.scrollTop = null, this.onChangeNewLineMode = this.onChangeNewLineMode.bind(this), this.onChangeNewLineMode(), this.session.doc.on("changeNewLineMode", this.onChangeNewLineMode));
                }, A.prototype.updateLines = function(e, t, i) {
                    if (void 0 === t && (t = 1 / 0), this.$changedLines ? (this.$changedLines.firstRow > e && (this.$changedLines.firstRow = e), this.$changedLines.lastRow < t && (this.$changedLines.lastRow = t)) : this.$changedLines = {
                        firstRow: e,
                        lastRow: t
                    }, this.$changedLines.lastRow < this.layerConfig.firstRow) {
                        if (!i) return;
                        this.$changedLines.lastRow = this.layerConfig.lastRow;
                    }
                    this.$changedLines.firstRow > this.layerConfig.lastRow || this.$loop.schedule(this.CHANGE_LINES);
                }, A.prototype.onChangeNewLineMode = function() {
                    this.$loop.schedule(this.CHANGE_TEXT), this.$textLayer.$updateEolChar(), this.session.$bidiHandler.setEolChar(this.$textLayer.EOL_CHAR);
                }, A.prototype.onChangeTabSize = function() {
                    this.$loop.schedule(this.CHANGE_TEXT | this.CHANGE_MARKER), this.$textLayer.onChangeTabSize();
                }, A.prototype.updateText = function() {
                    this.$loop.schedule(this.CHANGE_TEXT);
                }, A.prototype.updateFull = function(e) {
                    e ? this.$renderChanges(this.CHANGE_FULL, !0) : this.$loop.schedule(this.CHANGE_FULL);
                }, A.prototype.updateFontSize = function() {
                    this.$textLayer.checkForSizeChanges();
                }, A.prototype.$updateSizeAsync = function() {
                    this.$loop.pending ? this.$size.$dirty = !0 : this.onResize();
                }, A.prototype.onResize = function(e, t, i, n) {
                    if (!(2 < this.resizing)) {
                        0 < this.resizing ? this.resizing++ : this.resizing = e ? 1 : 0;
                        var o = this.container, o = (!(n = n || o.clientHeight || o.scrollHeight) && this.$maxLines && 1 < this.lineHeight && (o.style.height && "0px" != o.style.height || (o.style.height = "1px", n = o.clientHeight || o.scrollHeight)), i = i || o.clientWidth || o.scrollWidth, this.$updateCachedSize(e, t, i, n));
                        if (this.$resizeTimer && this.$resizeTimer.cancel(), !this.$size.scrollerHeight || !i && !n) return this.resizing = 0;
                        e && (this.$gutterLayer.$padding = null), e ? this.$renderChanges(o | this.$changes, !0) : this.$loop.schedule(o | this.$changes), this.resizing && (this.resizing = 0), this.scrollBarH.scrollLeft = this.scrollBarV.scrollTop = null, this.$customScrollbar && this.$updateCustomScrollbar(!0);
                    }
                }, A.prototype.$updateCachedSize = function(e, t, i, n) {
                    n -= this.$extraHeight || 0;
                    var o = 0, r = this.$size, s = {
                        width: r.width,
                        height: r.height,
                        scrollerHeight: r.scrollerHeight,
                        scrollerWidth: r.scrollerWidth
                    };
                    return n && (e || r.height != n) && (r.height = n, o |= this.CHANGE_SIZE, r.scrollerHeight = r.height, this.$horizScroll && (r.scrollerHeight -= this.scrollBarH.getHeight()), this.scrollBarV.setHeight(r.scrollerHeight), this.scrollBarV.element.style.bottom = this.scrollBarH.getHeight() + "px", o |= this.CHANGE_SCROLL), i && (e || r.width != i) && (o |= this.CHANGE_SIZE, r.width = i, null == t && (t = this.$showGutter ? this.$gutter.offsetWidth : 0), this.gutterWidth = t, a.setStyle(this.scrollBarH.element.style, "left", t + "px"), a.setStyle(this.scroller.style, "left", t + this.margin.left + "px"), r.scrollerWidth = Math.max(0, i - t - this.scrollBarV.getWidth() - this.margin.h), a.setStyle(this.$gutter.style, "left", this.margin.left + "px"), t = this.scrollBarV.getWidth() + "px", a.setStyle(this.scrollBarH.element.style, "right", t), a.setStyle(this.scroller.style, "right", t), a.setStyle(this.scroller.style, "bottom", this.scrollBarH.getHeight()), this.scrollBarH.setWidth(r.scrollerWidth), this.session && this.session.getUseWrapMode() && this.adjustWrapLimit() || e) && (o |= this.CHANGE_FULL), r.$dirty = !i || !n, o && this._signal("resize", s), o;
                }, A.prototype.onGutterResize = function(e) {
                    e = this.$showGutter ? e : 0;
                    e != this.gutterWidth && (this.$changes |= this.$updateCachedSize(!0, e, this.$size.width, this.$size.height)), this.session.getUseWrapMode() && this.adjustWrapLimit() || this.$size.$dirty ? this.$loop.schedule(this.CHANGE_FULL) : this.$computeLayerConfig();
                }, A.prototype.adjustWrapLimit = function() {
                    var e = this.$size.scrollerWidth - 2 * this.$padding, e = Math.floor(e / this.characterWidth);
                    return this.session.adjustWrapLimit(e, this.$showPrintMargin && this.$printMarginColumn);
                }, A.prototype.setAnimatedScroll = function(e) {
                    this.setOption("animatedScroll", e);
                }, A.prototype.getAnimatedScroll = function() {
                    return this.$animatedScroll;
                }, A.prototype.setShowInvisibles = function(e) {
                    this.setOption("showInvisibles", e), this.session.$bidiHandler.setShowInvisibles(e);
                }, A.prototype.getShowInvisibles = function() {
                    return this.getOption("showInvisibles");
                }, A.prototype.getDisplayIndentGuides = function() {
                    return this.getOption("displayIndentGuides");
                }, A.prototype.setDisplayIndentGuides = function(e) {
                    this.setOption("displayIndentGuides", e);
                }, A.prototype.getHighlightIndentGuides = function() {
                    return this.getOption("highlightIndentGuides");
                }, A.prototype.setHighlightIndentGuides = function(e) {
                    this.setOption("highlightIndentGuides", e);
                }, A.prototype.setShowPrintMargin = function(e) {
                    this.setOption("showPrintMargin", e);
                }, A.prototype.getShowPrintMargin = function() {
                    return this.getOption("showPrintMargin");
                }, A.prototype.setPrintMarginColumn = function(e) {
                    this.setOption("printMarginColumn", e);
                }, A.prototype.getPrintMarginColumn = function() {
                    return this.getOption("printMarginColumn");
                }, A.prototype.getShowGutter = function() {
                    return this.getOption("showGutter");
                }, A.prototype.setShowGutter = function(e) {
                    return this.setOption("showGutter", e);
                }, A.prototype.getFadeFoldWidgets = function() {
                    return this.getOption("fadeFoldWidgets");
                }, A.prototype.setFadeFoldWidgets = function(e) {
                    this.setOption("fadeFoldWidgets", e);
                }, A.prototype.setHighlightGutterLine = function(e) {
                    this.setOption("highlightGutterLine", e);
                }, A.prototype.getHighlightGutterLine = function() {
                    return this.getOption("highlightGutterLine");
                }, A.prototype.$updatePrintMargin = function() {
                    var e;
                    (this.$showPrintMargin || this.$printMarginEl) && (this.$printMarginEl || ((e = a.createElement("div")).className = "ace_layer ace_print-margin-layer", this.$printMarginEl = a.createElement("div"), this.$printMarginEl.className = "ace_print-margin", e.appendChild(this.$printMarginEl), this.content.insertBefore(e, this.content.firstChild)), (e = this.$printMarginEl.style).left = Math.round(this.characterWidth * this.$printMarginColumn + this.$padding) + "px", e.visibility = this.$showPrintMargin ? "visible" : "hidden", this.session) && -1 == this.session.$wrap && this.adjustWrapLimit();
                }, A.prototype.getContainerElement = function() {
                    return this.container;
                }, A.prototype.getMouseEventTarget = function() {
                    return this.scroller;
                }, A.prototype.getTextAreaContainer = function() {
                    return this.container;
                }, A.prototype.$moveTextAreaToCursor = function() {
                    var e, t, i, n, o, r, s;
                    this.$isMousePressed || (e = this.textarea.style, r = this.$composition, this.$keepTextAreaAtCursor || r ? (i = this.$cursorLayer.$pixelPos) && (r && r.markerRange && (i = this.$cursorLayer.getPixelPosition(r.markerRange.start, !0)), s = this.layerConfig, t = i.top, i = i.left, t -= s.offset, n = r && r.useTextareaForIME || I.isMobile ? this.lineHeight : 1, t < 0 || t > s.height - n ? a.translate(this.textarea, 0, 0) : (s = 1, o = this.$size.height - n, r ? r.useTextareaForIME ? (r = this.textarea.value, s = this.characterWidth * this.session.$getStringScreenWidth(r)[0]) : t += this.lineHeight + 2 : t += this.lineHeight, (i -= this.scrollLeft) > this.$size.scrollerWidth - s && (i = this.$size.scrollerWidth - s), i += this.gutterWidth + this.margin.left, a.setStyle(e, "height", n + "px"), a.setStyle(e, "width", s + "px"), a.translate(this.textarea, Math.min(i, this.$size.scrollerWidth - s), Math.min(t, o)))) : a.translate(this.textarea, -100, 0));
                }, A.prototype.getFirstVisibleRow = function() {
                    return this.layerConfig.firstRow;
                }, A.prototype.getFirstFullyVisibleRow = function() {
                    return this.layerConfig.firstRow + (0 === this.layerConfig.offset ? 0 : 1);
                }, A.prototype.getLastFullyVisibleRow = function() {
                    var e = this.layerConfig, t = e.lastRow;
                    return this.session.documentToScreenRow(t, 0) * e.lineHeight - this.session.getScrollTop() > e.height - e.lineHeight ? t - 1 : t;
                }, A.prototype.getLastVisibleRow = function() {
                    return this.layerConfig.lastRow;
                }, A.prototype.setPadding = function(e) {
                    this.$padding = e, this.$textLayer.setPadding(e), this.$cursorLayer.setPadding(e), this.$markerFront.setPadding(e), this.$markerBack.setPadding(e), this.$loop.schedule(this.CHANGE_FULL), this.$updatePrintMargin();
                }, A.prototype.setScrollMargin = function(e, t, i, n) {
                    var o = this.scrollMargin;
                    o.top = 0 | e, o.bottom = 0 | t, o.right = 0 | n, o.left = 0 | i, o.v = o.top + o.bottom, o.h = o.left + o.right, o.top && this.scrollTop <= 0 && this.session && this.session.setScrollTop(-o.top), this.updateFull();
                }, A.prototype.setMargin = function(e, t, i, n) {
                    var o = this.margin;
                    o.top = 0 | e, o.bottom = 0 | t, o.right = 0 | n, o.left = 0 | i, o.v = o.top + o.bottom, o.h = o.left + o.right, this.$updateCachedSize(!0, this.gutterWidth, this.$size.width, this.$size.height), this.updateFull();
                }, A.prototype.getHScrollBarAlwaysVisible = function() {
                    return this.$hScrollBarAlwaysVisible;
                }, A.prototype.setHScrollBarAlwaysVisible = function(e) {
                    this.setOption("hScrollBarAlwaysVisible", e);
                }, A.prototype.getVScrollBarAlwaysVisible = function() {
                    return this.$vScrollBarAlwaysVisible;
                }, A.prototype.setVScrollBarAlwaysVisible = function(e) {
                    this.setOption("vScrollBarAlwaysVisible", e);
                }, A.prototype.$updateScrollBarV = function() {
                    var e = this.layerConfig.maxHeight, t = this.$size.scrollerHeight;
                    !this.$maxLines && this.$scrollPastEnd && (e -= (t - this.lineHeight) * this.$scrollPastEnd, this.scrollTop > e - t) && (e = this.scrollTop + t, this.scrollBarV.scrollTop = null), this.scrollBarV.setScrollHeight(e + this.scrollMargin.v), this.scrollBarV.setScrollTop(this.scrollTop + this.scrollMargin.top);
                }, A.prototype.$updateScrollBarH = function() {
                    this.scrollBarH.setScrollWidth(this.layerConfig.width + 2 * this.$padding + this.scrollMargin.h), this.scrollBarH.setScrollLeft(this.scrollLeft + this.scrollMargin.left);
                }, A.prototype.freeze = function() {
                    this.$frozen = !0;
                }, A.prototype.unfreeze = function() {
                    this.$frozen = !1;
                }, A.prototype.$renderChanges = function(e, t) {
                    if (this.$changes && (e |= this.$changes, this.$changes = 0), this.session && this.container.offsetWidth && !this.$frozen && (e || t)) {
                        if (this.$size.$dirty) return this.$changes |= e, this.onResize(!0);
                        this.lineHeight || this.$textLayer.checkForSizeChanges(), this._signal("beforeRender", e), this.session && this.session.$bidiHandler && this.session.$bidiHandler.updateCharacterWidths(this.$fontMetrics);
                        var i, n, t = this.layerConfig;
                        (e & this.CHANGE_FULL || e & this.CHANGE_SIZE || e & this.CHANGE_TEXT || e & this.CHANGE_LINES || e & this.CHANGE_SCROLL || e & this.CHANGE_H_SCROLL) && (e |= this.$computeLayerConfig() | this.$loop.clear(), t.firstRow != this.layerConfig.firstRow && t.firstRowScreen == this.layerConfig.firstRowScreen && 0 < (i = this.scrollTop + (t.firstRow - Math.max(this.layerConfig.firstRow, 0)) * this.lineHeight) && (this.scrollTop = i, e = (e |= this.CHANGE_SCROLL) | (this.$computeLayerConfig() | this.$loop.clear())), t = this.layerConfig, this.$updateScrollBarV(), e & this.CHANGE_H_SCROLL && this.$updateScrollBarH(), a.translate(this.content, -this.scrollLeft, -t.offset), i = t.width + 2 * this.$padding + "px", n = t.minHeight + "px", a.setStyle(this.content.style, "width", i), a.setStyle(this.content.style, "height", n)), e & this.CHANGE_H_SCROLL && (a.translate(this.content, -this.scrollLeft, -t.offset), this.scroller.className = this.scrollLeft <= 0 ? "ace_scroller " : "ace_scroller ace_scroll-left ", this.enableKeyboardAccessibility) && (this.scroller.className += this.keyboardFocusClassName), e & this.CHANGE_FULL ? (this.$changedLines = null, this.$textLayer.update(t), this.$showGutter && this.$gutterLayer.update(t), this.$customScrollbar && this.$scrollDecorator.$updateDecorators(t), this.$markerBack.update(t), this.$markerFront.update(t), this.$cursorLayer.update(t), this.$moveTextAreaToCursor()) : e & this.CHANGE_SCROLL ? (this.$changedLines = null, e & this.CHANGE_TEXT || e & this.CHANGE_LINES ? this.$textLayer.update(t) : this.$textLayer.scrollLines(t), this.$showGutter && (e & this.CHANGE_GUTTER || e & this.CHANGE_LINES ? this.$gutterLayer.update(t) : this.$gutterLayer.scrollLines(t)), this.$customScrollbar && this.$scrollDecorator.$updateDecorators(t), this.$markerBack.update(t), this.$markerFront.update(t), this.$cursorLayer.update(t), this.$moveTextAreaToCursor()) : (e & this.CHANGE_TEXT ? (this.$changedLines = null, this.$textLayer.update(t), this.$showGutter && this.$gutterLayer.update(t), this.$customScrollbar && this.$scrollDecorator.$updateDecorators(t)) : e & this.CHANGE_LINES ? ((this.$updateLines() || e & this.CHANGE_GUTTER && this.$showGutter) && this.$gutterLayer.update(t), this.$customScrollbar && this.$scrollDecorator.$updateDecorators(t)) : e & this.CHANGE_TEXT || e & this.CHANGE_GUTTER ? (this.$showGutter && this.$gutterLayer.update(t), this.$customScrollbar && this.$scrollDecorator.$updateDecorators(t)) : e & this.CHANGE_CURSOR && (this.$highlightGutterLine && this.$gutterLayer.updateLineHighlight(t), this.$customScrollbar) && this.$scrollDecorator.$updateDecorators(t), e & this.CHANGE_CURSOR && (this.$cursorLayer.update(t), this.$moveTextAreaToCursor()), e & (this.CHANGE_MARKER | this.CHANGE_MARKER_FRONT) && this.$markerFront.update(t), e & (this.CHANGE_MARKER | this.CHANGE_MARKER_BACK) && this.$markerBack.update(t)), this._signal("afterRender", e);
                    } else this.$changes |= e;
                }, A.prototype.$autosize = function() {
                    var e = this.session.getScreenLength() * this.lineHeight, t = this.$maxLines * this.lineHeight, i = Math.min(t, Math.max((this.$minLines || 1) * this.lineHeight, e)) + this.scrollMargin.v + (this.$extraHeight || 0);
                    this.$horizScroll && (i += this.scrollBarH.getHeight());
                    t = !((i = this.$maxPixelHeight && i > this.$maxPixelHeight ? this.$maxPixelHeight : i) <= 2 * this.lineHeight) && t < e;
                    i == this.desiredHeight && this.$size.height == this.desiredHeight && t == this.$vScroll || (t != this.$vScroll && (this.$vScroll = t, this.scrollBarV.setVisible(t)), e = this.container.clientWidth, this.container.style.height = i + "px", this.$updateCachedSize(!0, this.$gutterWidth, e, i), this.desiredHeight = i, this._signal("autosize"));
                }, A.prototype.$computeLayerConfig = function() {
                    var e, t = this.session, i = this.$size, n = i.height <= 2 * this.lineHeight, o = this.session.getScreenLength() * this.lineHeight, r = this.$getLongestLine(), s = !n && (this.$hScrollBarAlwaysVisible || i.scrollerWidth - r - 2 * this.$padding < 0), a = this.$horizScroll !== s, s = (a && (this.$horizScroll = s, this.scrollBarH.setVisible(s)), this.$vScroll), l = (this.$maxLines && 1 < this.lineHeight && (this.$autosize(), n = i.height <= 2 * this.lineHeight), i.scrollerHeight + this.lineHeight), c = !this.$maxLines && this.$scrollPastEnd ? (i.scrollerHeight - this.lineHeight) * this.$scrollPastEnd : 0, h = (o += c, this.scrollMargin), n = (this.session.setScrollTop(Math.max(-h.top, Math.min(this.scrollTop, o - i.scrollerHeight + h.bottom))), this.session.setScrollLeft(Math.max(-h.left, Math.min(this.scrollLeft, r + 2 * this.$padding - i.scrollerWidth + h.right))), !n && (this.$vScrollBarAlwaysVisible || i.scrollerHeight - o + c < 0 || this.scrollTop > h.top)), c = s !== n, h = (c && (this.$vScroll = n, this.scrollBarV.setVisible(n)), this.scrollTop % this.lineHeight), s = Math.ceil(l / this.lineHeight) - 1, s = (n = Math.max(0, Math.round((this.scrollTop - h) / this.lineHeight))) + s, d = this.lineHeight, n = t.screenToDocumentRow(n, 0), u = t.getFoldLine(n), t = (u && (n = u.start.row), u = t.documentToScreenRow(n, 0), e = t.getRowLength(n) * d, s = Math.min(t.screenToDocumentRow(s, 0), t.getLength() - 1), l = i.scrollerHeight + t.getRowLength(s) * d + e, (h = this.scrollTop - u * d) < 0 && 0 < u && (u = Math.max(0, u + Math.floor(h / d)), h = this.scrollTop - u * d), 0);
                    return this.layerConfig.width == r && !a || (t = this.CHANGE_H_SCROLL), (a || c) && (t |= this.$updateCachedSize(!0, this.gutterWidth, i.width, i.height), this._signal("scrollbarVisibilityChanged"), c) && (r = this.$getLongestLine()), this.layerConfig = {
                        width: r,
                        padding: this.$padding,
                        firstRow: n,
                        firstRowScreen: u,
                        lastRow: s,
                        lineHeight: d,
                        characterWidth: this.characterWidth,
                        minHeight: l,
                        maxHeight: o,
                        offset: h,
                        gutterOffset: d ? Math.max(0, Math.ceil((h + i.height - i.scrollerHeight) / d)) : 0,
                        height: this.$size.scrollerHeight
                    }, this.session.$bidiHandler && this.session.$bidiHandler.setContentWidth(r - this.$padding), t;
                }, A.prototype.$updateLines = function() {
                    if (this.$changedLines) {
                        var e = this.$changedLines.firstRow, t = this.$changedLines.lastRow, i = (this.$changedLines = null, this.layerConfig);
                        if (!(e > i.lastRow + 1 || t < i.firstRow)) {
                            if (t !== 1 / 0) return this.$textLayer.updateLines(i, e, t), !0;
                            this.$showGutter && this.$gutterLayer.update(i), this.$textLayer.update(i);
                        }
                    }
                }, A.prototype.$getLongestLine = function() {
                    var e = this.session.getScreenWidth();
                    return this.showInvisibles && !this.session.$useWrapMode && (e += 1), this.$textLayer && e > this.$textLayer.MAX_LINE_LENGTH && (e = this.$textLayer.MAX_LINE_LENGTH + 30), Math.max(this.$size.scrollerWidth - 2 * this.$padding, Math.round(e * this.characterWidth));
                }, A.prototype.updateFrontMarkers = function() {
                    this.$markerFront.setMarkers(this.session.getMarkers(!0)), this.$loop.schedule(this.CHANGE_MARKER_FRONT);
                }, A.prototype.updateBackMarkers = function() {
                    this.$markerBack.setMarkers(this.session.getMarkers()), this.$loop.schedule(this.CHANGE_MARKER_BACK);
                }, A.prototype.addGutterDecoration = function(e, t) {
                    this.$gutterLayer.addGutterDecoration(e, t);
                }, A.prototype.removeGutterDecoration = function(e, t) {
                    this.$gutterLayer.removeGutterDecoration(e, t);
                }, A.prototype.updateBreakpoints = function(e) {
                    this._rows = e, this.$loop.schedule(this.CHANGE_GUTTER);
                }, A.prototype.setAnnotations = function(e) {
                    this.$gutterLayer.setAnnotations(e), this.$loop.schedule(this.CHANGE_GUTTER);
                }, A.prototype.updateCursor = function() {
                    this.$loop.schedule(this.CHANGE_CURSOR);
                }, A.prototype.hideCursor = function() {
                    this.$cursorLayer.hideCursor();
                }, A.prototype.showCursor = function() {
                    this.$cursorLayer.showCursor();
                }, A.prototype.scrollSelectionIntoView = function(e, t, i) {
                    this.scrollCursorIntoView(e, i), this.scrollCursorIntoView(t, i);
                }, A.prototype.scrollCursorIntoView = function(e, t, i) {
                    var n, o, r;
                    0 !== this.$size.scrollerHeight && (n = (e = this.$cursorLayer.getPixelPosition(e)).left, e = e.top, o = i && i.top || 0, i = i && i.bottom || 0, this.$scrollAnimation && (this.$stopAnimation = !0), e < (r = this.$scrollAnimation ? this.session.getScrollTop() : this.scrollTop) + o ? (t && r + o > e + this.lineHeight && (e -= t * this.$size.scrollerHeight), 0 === e && (e = -this.scrollMargin.top), this.session.setScrollTop(e)) : r + this.$size.scrollerHeight - i < e + this.lineHeight && (t && r + this.$size.scrollerHeight - i < e - this.lineHeight && (e += t * this.$size.scrollerHeight), this.session.setScrollTop(e + this.lineHeight + i - this.$size.scrollerHeight)), o = this.scrollLeft, n - (r = 2 * this.layerConfig.characterWidth) < o ? ((n -= r) < this.$padding + r && (n = -this.scrollMargin.left), this.session.setScrollLeft(n)) : o + this.$size.scrollerWidth < (n += r) + this.characterWidth ? this.session.setScrollLeft(Math.round(n + this.characterWidth - this.$size.scrollerWidth)) : o <= this.$padding && n - o < this.characterWidth && this.session.setScrollLeft(0));
                }, A.prototype.getScrollTop = function() {
                    return this.session.getScrollTop();
                }, A.prototype.getScrollLeft = function() {
                    return this.session.getScrollLeft();
                }, A.prototype.getScrollTopRow = function() {
                    return this.scrollTop / this.lineHeight;
                }, A.prototype.getScrollBottomRow = function() {
                    return Math.max(0, Math.floor((this.scrollTop + this.$size.scrollerHeight) / this.lineHeight) - 1);
                }, A.prototype.scrollToRow = function(e) {
                    this.session.setScrollTop(e * this.lineHeight);
                }, A.prototype.alignCursor = function(e, t) {
                    var e = this.$cursorLayer.getPixelPosition(e = "number" == typeof e ? {
                        row: e,
                        column: 0
                    } : e), i = this.$size.scrollerHeight - this.lineHeight, e = e.top - i * (t || 0);
                    return this.session.setScrollTop(e), e;
                }, A.prototype.$calcSteps = function(e, t) {
                    for(var i, n, o = 0, r = this.STEPS, s = [], o = 0; o < r; ++o)s.push((i = o / this.STEPS, (t - (n = e)) * (Math.pow(i - 1, 3) + 1) + n));
                    return s;
                }, A.prototype.scrollToLine = function(e, t, i, n) {
                    e = this.$cursorLayer.getPixelPosition({
                        row: e,
                        column: 0
                    }).top, t && (e -= this.$size.scrollerHeight / 2), t = this.scrollTop;
                    this.session.setScrollTop(e), !1 !== i && this.animateScrolling(t, n);
                }, A.prototype.animateScrolling = function(e, t) {
                    var i = this.scrollTop;
                    if (this.$animatedScroll) {
                        var n = this;
                        if (e != i) {
                            if (this.$scrollAnimation) {
                                var o = this.$scrollAnimation.steps;
                                if (o.length && (e = o[0]) == i) return;
                            }
                            var r = n.$calcSteps(e, i);
                            this.$scrollAnimation = {
                                from: e,
                                to: i,
                                steps: r
                            }, clearInterval(this.$timer), n.session.setScrollTop(r.shift()), n.session.$scrollTop = i, this.$timer = setInterval(function() {
                                if (!n.$stopAnimation) return n.session ? void (r.length ? (n.session.setScrollTop(r.shift()), n.session.$scrollTop = i) : null != i ? (n.session.$scrollTop = -1, n.session.setScrollTop(i), i = null) : s()) : clearInterval(n.$timer);
                                s();
                            }, 10);
                        }
                    }
                    function s() {
                        n.$timer = clearInterval(n.$timer), n.$scrollAnimation = null, n.$stopAnimation = !1, t && t();
                    }
                }, A.prototype.scrollToY = function(e) {
                    this.scrollTop !== e && (this.$loop.schedule(this.CHANGE_SCROLL), this.scrollTop = e);
                }, A.prototype.scrollToX = function(e) {
                    this.scrollLeft !== e && (this.scrollLeft = e), this.$loop.schedule(this.CHANGE_H_SCROLL);
                }, A.prototype.scrollTo = function(e, t) {
                    this.session.setScrollTop(t), this.session.setScrollLeft(e);
                }, A.prototype.scrollBy = function(e, t) {
                    t && this.session.setScrollTop(this.session.getScrollTop() + t), e && this.session.setScrollLeft(this.session.getScrollLeft() + e);
                }, A.prototype.isScrollableBy = function(e, t) {
                    return t < 0 && this.session.getScrollTop() >= 1 - this.scrollMargin.top || 0 < t && this.session.getScrollTop() + this.$size.scrollerHeight - this.layerConfig.maxHeight < -1 + this.scrollMargin.bottom || e < 0 && this.session.getScrollLeft() >= 1 - this.scrollMargin.left || 0 < e && this.session.getScrollLeft() + this.$size.scrollerWidth - this.layerConfig.width < -1 + this.scrollMargin.right || void 0;
                }, A.prototype.pixelToScreenCoordinates = function(e, t) {
                    this.$hasCssTransforms ? (n = {
                        top: 0,
                        left: 0
                    }, e = (i = this.$fontMetrics.transformCoordinates([
                        e,
                        t
                    ]))[1] - this.gutterWidth - this.margin.left, t = i[0]) : n = this.scroller.getBoundingClientRect();
                    var i = e + this.scrollLeft - n.left - this.$padding, e = i / this.characterWidth, t = Math.floor((t + this.scrollTop - n.top) / this.lineHeight), n = this.$blockCursor ? Math.floor(e) : Math.round(e);
                    return {
                        row: t,
                        column: n,
                        side: 0 < e - n ? 1 : -1,
                        offsetX: i
                    };
                }, A.prototype.screenToTextCoordinates = function(e, t) {
                    this.$hasCssTransforms ? (i = {
                        top: 0,
                        left: 0
                    }, e = (n = this.$fontMetrics.transformCoordinates([
                        e,
                        t
                    ]))[1] - this.gutterWidth - this.margin.left, t = n[0]) : i = this.scroller.getBoundingClientRect();
                    var i, n = e + this.scrollLeft - i.left - this.$padding, e = n / this.characterWidth, e = this.$blockCursor ? Math.floor(e) : Math.round(e), t = Math.floor((t + this.scrollTop - i.top) / this.lineHeight);
                    return this.session.screenToDocumentPosition(t, Math.max(e, 0), n);
                }, A.prototype.textToScreenCoordinates = function(e, t) {
                    var i = this.scroller.getBoundingClientRect(), t = this.session.documentToScreenPosition(e, t), e = this.$padding + (this.session.$bidiHandler.isBidiRow(t.row, e) ? this.session.$bidiHandler.getPosLeft(t.column) : Math.round(t.column * this.characterWidth)), t = t.row * this.lineHeight;
                    return {
                        pageX: i.left + e - this.scrollLeft,
                        pageY: i.top + t - this.scrollTop
                    };
                }, A.prototype.visualizeFocus = function() {
                    a.addCssClass(this.container, "ace_focus");
                }, A.prototype.visualizeBlur = function() {
                    a.removeCssClass(this.container, "ace_focus");
                }, A.prototype.showComposition = function(e) {
                    (this.$composition = e).cssText || (e.cssText = this.textarea.style.cssText), null == e.useTextareaForIME && (e.useTextareaForIME = this.$useTextareaForIME), this.$useTextareaForIME ? (a.addCssClass(this.textarea, "ace_composition"), this.textarea.style.cssText = "", this.$moveTextAreaToCursor(), this.$cursorLayer.element.style.display = "none") : e.markerId = this.session.addMarker(e.markerRange, "ace_composition_marker", "text");
                }, A.prototype.setCompositionText = function(e) {
                    var t = this.session.selection.cursor;
                    this.addToken(e, "composition_placeholder", t.row, t.column), this.$moveTextAreaToCursor();
                }, A.prototype.hideComposition = function() {
                    var e;
                    this.$composition && (this.$composition.markerId && this.session.removeMarker(this.$composition.markerId), a.removeCssClass(this.textarea, "ace_composition"), this.textarea.style.cssText = this.$composition.cssText, e = this.session.selection.cursor, this.removeExtraToken(e.row, e.column), this.$composition = null, this.$cursorLayer.element.style.display = "");
                }, A.prototype.setGhostText = function(e, t) {
                    var n, i, o, r = this.session.selection.cursor, t = t || {
                        row: r.row,
                        column: r.column
                    }, r = (this.removeGhostText(), this.$calculateWrappedTextChunks(e, t)), s = (this.addToken(r[0].text, "ghost_text", t.row, t.column), this.$ghostText = {
                        text: e,
                        position: {
                            row: t.row,
                            column: t.column
                        }
                    }, a.createElement("div"));
                    1 < r.length && (e = this.hideTokensAfterPosition(t.row, t.column), r.slice(1).forEach(function(e) {
                        var t = a.createElement("div"), i = a.createElement("span");
                        i.className = "ace_ghost_text", e.wrapped && (t.className = "ghost_text_line_wrapped"), 0 === e.text.length && (e.text = " "), i.appendChild(a.createTextNode(e.text)), t.appendChild(i), s.appendChild(t), n = t;
                    }), e.forEach(function(e) {
                        var t = a.createElement("span");
                        b(e.type) || (t.className = "ace_" + e.type.replace(/\./g, " ace_")), t.appendChild(a.createTextNode(e.value)), n.appendChild(t);
                    }), this.$ghostTextWidget = {
                        el: s,
                        row: t.row,
                        column: t.column,
                        className: "ace_ghost_text_container"
                    }, this.session.widgetManager.addLineWidget(this.$ghostTextWidget), e = this.$cursorLayer.getPixelPosition(t, !0), i = this.container.getBoundingClientRect().height, (o = r.length * this.lineHeight) < i - e.top || (o < i ? this.scrollBy(0, (r.length - 1) * this.lineHeight) : this.scrollToRow(t.row)));
                }, A.prototype.$calculateWrappedTextChunks = function(e, t) {
                    for(var i = this.$size.scrollerWidth - 2 * this.$padding, n = (n = Math.floor(i / this.characterWidth) - 2) <= 0 ? 60 : n, o = e.split(/\r?\n/), r = [], s = 0; s < o.length; s++){
                        var a = this.session.$getDisplayTokens(o[s], t.column), l = this.session.$computeWrapSplits(a, n, this.session.$tabSize);
                        if (0 < l.length) {
                            var c = 0;
                            l.push(o[s].length);
                            for(var h = 0; h < l.length; h++){
                                var d = o[s].slice(c, l[h]);
                                r.push({
                                    text: d,
                                    wrapped: !0
                                }), c = l[h];
                            }
                        } else r.push({
                            text: o[s],
                            wrapped: !1
                        });
                    }
                    return r;
                }, A.prototype.removeGhostText = function() {
                    var e;
                    this.$ghostText && (e = this.$ghostText.position, this.removeExtraToken(e.row, e.column), this.$ghostTextWidget && (this.session.widgetManager.removeLineWidget(this.$ghostTextWidget), this.$ghostTextWidget = null), this.$ghostText = null);
                }, A.prototype.addToken = function(e, t, i, n) {
                    var o = this.session, r = (o.bgTokenizer.lines[i] = null, {
                        type: t,
                        value: e
                    }), s = o.getTokens(i);
                    if (null != n && s.length) for(var a = 0, l = 0; l < s.length; l++){
                        var c = s[l];
                        if (n <= (a += c.value.length)) {
                            var h = c.value.length - (a - n), d = c.value.slice(0, h), h = c.value.slice(h);
                            s.splice(l, 1, {
                                type: c.type,
                                value: d
                            }, r, {
                                type: c.type,
                                value: h
                            });
                            break;
                        }
                    }
                    else s.push(r);
                    this.updateLines(i, i);
                }, A.prototype.hideTokensAfterPosition = function(e, t) {
                    for(var i = this.session.getTokens(e), n = 0, o = !1, r = [], s = 0; s < i.length; s++){
                        var a = i[s];
                        n += a.value.length, "ghost_text" !== a.type && (o ? (r.push({
                            type: a.type,
                            value: a.value
                        }), a.type = "hidden_token") : n === t && (o = !0));
                    }
                    return this.updateLines(e, e), r;
                }, A.prototype.removeExtraToken = function(e, t) {
                    this.session.bgTokenizer.lines[e] = null, this.updateLines(e, e);
                }, A.prototype.setTheme = function(i, n) {
                    var e, o = this;
                    function t(e) {
                        if (o.$themeId != i) return n && n();
                        if (!e || !e.cssClass) throw new Error("couldn't load module " + i + " or it didn't call define");
                        e.$id && (o.$themeId = e.$id), a.importCssString(e.cssText, e.cssClass, o.container), o.theme && a.removeCssClass(o.container, o.theme.cssClass);
                        var t = "padding" in e ? e.padding : "padding" in (o.theme || {}) ? 4 : o.$padding;
                        o.$padding && t != o.$padding && o.setPadding(t), o.$gutterLayer && ((t = e.$showGutterCursorMarker) && !o.$gutterLayer.$showCursorMarker ? o.$gutterLayer.$showCursorMarker = "theme" : t || "theme" != o.$gutterLayer.$showCursorMarker || (o.$gutterLayer.$showCursorMarker = null)), o.$theme = e.cssClass, o.theme = e, a.addCssClass(o.container, e.cssClass), a.setCssClass(o.container, "ace_dark", e.isDark), o.$size && (o.$size.width = 0, o.$updateSizeAsync()), o._dispatchEvent("themeLoaded", {
                            theme: e
                        }), n && n(), I.isSafari && o.scroller && (o.scroller.style.background = "red", o.scroller.style.background = "");
                    }
                    this.$themeId = i, o._dispatchEvent("themeChange", {
                        theme: i
                    }), i && "string" != typeof i ? t(i) : (e = i || this.$options.theme.initialValue, r.loadModule([
                        "theme",
                        e
                    ], t));
                }, A.prototype.getTheme = function() {
                    return this.$themeId;
                }, A.prototype.setStyle = function(e, t) {
                    a.setCssClass(this.container, e, !1 !== t);
                }, A.prototype.unsetStyle = function(e) {
                    a.removeCssClass(this.container, e);
                }, A.prototype.setCursorStyle = function(e) {
                    a.setStyle(this.scroller.style, "cursor", e);
                }, A.prototype.setMouseCursor = function(e) {
                    a.setStyle(this.scroller.style, "cursor", e);
                }, A.prototype.attachToShadowRoot = function() {
                    a.importCssString(y, "ace_editor.css", this.container);
                }, A.prototype.destroy = function() {
                    this.freeze(), this.$fontMetrics.destroy(), this.$cursorLayer.destroy(), this.removeAllListeners(), this.container.textContent = "", this.setOption("useResizeObserver", !1);
                }, A.prototype.$updateCustomScrollbar = function(e) {
                    var t = this;
                    this.$horizScroll = this.$vScroll = null, this.scrollBarV.element.remove(), this.scrollBarH.element.remove(), !0 === e ? (this.scrollBarV = new p(this.container, this), this.scrollBarH = new g(this.container, this), this.scrollBarV.setHeight(this.$size.scrollerHeight), this.scrollBarH.setWidth(this.$size.scrollerWidth), this.scrollBarV.addEventListener("scroll", function(e) {
                        t.$scrollAnimation || t.session.setScrollTop(e.data - t.scrollMargin.top);
                    }), this.scrollBarH.addEventListener("scroll", function(e) {
                        t.$scrollAnimation || t.session.setScrollLeft(e.data - t.scrollMargin.left);
                    }), this.$scrollDecorator ? this.$scrollDecorator.setScrollBarV(this.scrollBarV) : this.$scrollDecorator = new v(this.scrollBarV, this), this.$scrollDecorator.$updateDecorators()) : (this.scrollBarV = new u(this.container, this), this.scrollBarH = new d(this.container, this), this.scrollBarV.addEventListener("scroll", function(e) {
                        t.$scrollAnimation || t.session.setScrollTop(e.data - t.scrollMargin.top);
                    }), this.scrollBarH.addEventListener("scroll", function(e) {
                        t.$scrollAnimation || t.session.setScrollLeft(e.data - t.scrollMargin.left);
                    }));
                }, A.prototype.$addResizeObserver = function() {
                    var i;
                    window.ResizeObserver && !this.$resizeObserver && ((i = this).$resizeTimer = o.delayedCall(function() {
                        i.destroyed || i.onResize();
                    }, 50), this.$resizeObserver = new window.ResizeObserver(function(e) {
                        var t = e[0].contentRect.width, e = e[0].contentRect.height;
                        1 < Math.abs(i.$size.width - t) || 1 < Math.abs(i.$size.height - e) ? i.$resizeTimer.delay() : i.$resizeTimer.cancel();
                    }), this.$resizeObserver.observe(this.container));
                }, A);
                function A(e, t) {
                    var i = this, e = (this.container = e || a.createElement("div"), a.addCssClass(this.container, "ace_editor"), a.HI_DPI && a.addCssClass(this.container, "ace_hidpi"), this.setTheme(t), null == r.get("useStrictCSP") && r.set("useStrictCSP", !1), this.$gutter = a.createElement("div"), this.$gutter.className = "ace_gutter", this.container.appendChild(this.$gutter), this.$gutter.setAttribute("aria-hidden", "true"), this.scroller = a.createElement("div"), this.scroller.className = "ace_scroller", this.container.appendChild(this.scroller), this.content = a.createElement("div"), this.content.className = "ace_content", this.scroller.appendChild(this.content), this.$gutterLayer = new s(this.$gutter), this.$gutterLayer.on("changeGutterWidth", this.onGutterResize.bind(this)), this.$markerBack = new l(this.content), this.$textLayer = new c(this.content));
                    this.canvas = e.element, this.$markerFront = new l(this.content), this.$cursorLayer = new h(this.content), this.$horizScroll = !1, this.$vScroll = !1, this.scrollBar = this.scrollBarV = new u(this.container, this), this.scrollBarH = new d(this.container, this), this.scrollBarV.on("scroll", function(e) {
                        i.$scrollAnimation || i.session.setScrollTop(e.data - i.scrollMargin.top);
                    }), this.scrollBarH.on("scroll", function(e) {
                        i.$scrollAnimation || i.session.setScrollLeft(e.data - i.scrollMargin.left);
                    }), this.scrollTop = 0, this.scrollLeft = 0, this.cursorPos = {
                        row: 0,
                        column: 0
                    }, this.$fontMetrics = new f(this.container), this.$textLayer.$setFontMetrics(this.$fontMetrics), this.$textLayer.on("changeCharacterSize", function(e) {
                        i.updateCharacterSize(), i.onResize(!0, i.gutterWidth, i.$size.width, i.$size.height), i._signal("changeCharacterSize", e);
                    }), this.$size = {
                        width: 0,
                        height: 0,
                        scrollerHeight: 0,
                        scrollerWidth: 0,
                        $dirty: !0
                    }, this.layerConfig = {
                        width: 1,
                        padding: 0,
                        firstRow: 0,
                        firstRowScreen: 0,
                        lastRow: 0,
                        lineHeight: 0,
                        characterWidth: 0,
                        minHeight: 1,
                        maxHeight: 1,
                        offset: 0,
                        height: 1,
                        gutterOffset: 1
                    }, this.scrollMargin = {
                        left: 0,
                        right: 0,
                        top: 0,
                        bottom: 0,
                        v: 0,
                        h: 0
                    }, this.margin = {
                        left: 0,
                        right: 0,
                        top: 0,
                        bottom: 0,
                        v: 0,
                        h: 0
                    }, this.$keepTextAreaAtCursor = !I.isIOS, this.$loop = new m(this.$renderChanges.bind(this), this.container.ownerDocument.defaultView), this.$loop.schedule(this.CHANGE_FULL), this.updateCharacterSize(), this.setPadding(4), this.$addResizeObserver(), r.resetOptions(this), r._signal("renderer", this);
                }
                e.prototype.CHANGE_CURSOR = 1, e.prototype.CHANGE_MARKER = 2, e.prototype.CHANGE_GUTTER = 4, e.prototype.CHANGE_SCROLL = 8, e.prototype.CHANGE_LINES = 16, e.prototype.CHANGE_TEXT = 32, e.prototype.CHANGE_SIZE = 64, e.prototype.CHANGE_MARKER_BACK = 128, e.prototype.CHANGE_MARKER_FRONT = 256, e.prototype.CHANGE_FULL = 512, e.prototype.CHANGE_H_SCROLL = 1024, e.prototype.$changes = 0, e.prototype.$padding = null, e.prototype.$frozen = !1, e.prototype.STEPS = 8, n.implement(e.prototype, C), r.defineOptions(e.prototype, "renderer", {
                    useResizeObserver: {
                        set: function(e) {
                            !e && this.$resizeObserver ? (this.$resizeObserver.disconnect(), this.$resizeTimer.cancel(), this.$resizeTimer = this.$resizeObserver = null) : e && !this.$resizeObserver && this.$addResizeObserver();
                        }
                    },
                    animatedScroll: {
                        initialValue: !1
                    },
                    showInvisibles: {
                        set: function(e) {
                            this.$textLayer.setShowInvisibles(e) && this.$loop.schedule(this.CHANGE_TEXT);
                        },
                        initialValue: !1
                    },
                    showPrintMargin: {
                        set: function() {
                            this.$updatePrintMargin();
                        },
                        initialValue: !0
                    },
                    printMarginColumn: {
                        set: function() {
                            this.$updatePrintMargin();
                        },
                        initialValue: 80
                    },
                    printMargin: {
                        set: function(e) {
                            "number" == typeof e && (this.$printMarginColumn = e), this.$showPrintMargin = !!e, this.$updatePrintMargin();
                        },
                        get: function() {
                            return this.$showPrintMargin && this.$printMarginColumn;
                        }
                    },
                    showGutter: {
                        set: function(e) {
                            this.$gutter.style.display = e ? "block" : "none", this.$loop.schedule(this.CHANGE_FULL), this.onGutterResize();
                        },
                        initialValue: !0
                    },
                    useSvgGutterIcons: {
                        set: function(e) {
                            this.$gutterLayer.$useSvgGutterIcons = e;
                        },
                        initialValue: !1
                    },
                    showFoldedAnnotations: {
                        set: function(e) {
                            this.$gutterLayer.$showFoldedAnnotations = e;
                        },
                        initialValue: !1
                    },
                    fadeFoldWidgets: {
                        set: function(e) {
                            a.setCssClass(this.$gutter, "ace_fade-fold-widgets", e);
                        },
                        initialValue: !1
                    },
                    showFoldWidgets: {
                        set: function(e) {
                            this.$gutterLayer.setShowFoldWidgets(e), this.$loop.schedule(this.CHANGE_GUTTER);
                        },
                        initialValue: !0
                    },
                    displayIndentGuides: {
                        set: function(e) {
                            this.$textLayer.setDisplayIndentGuides(e) && this.$loop.schedule(this.CHANGE_TEXT);
                        },
                        initialValue: !0
                    },
                    highlightIndentGuides: {
                        set: function(e) {
                            1 == this.$textLayer.setHighlightIndentGuides(e) ? this.$textLayer.$highlightIndentGuide() : this.$textLayer.$clearActiveIndentGuide(this.$textLayer.$lines.cells);
                        },
                        initialValue: !0
                    },
                    highlightGutterLine: {
                        set: function(e) {
                            this.$gutterLayer.setHighlightGutterLine(e), this.$loop.schedule(this.CHANGE_GUTTER);
                        },
                        initialValue: !0
                    },
                    hScrollBarAlwaysVisible: {
                        set: function(e) {
                            this.$hScrollBarAlwaysVisible && this.$horizScroll || this.$loop.schedule(this.CHANGE_SCROLL);
                        },
                        initialValue: !1
                    },
                    vScrollBarAlwaysVisible: {
                        set: function(e) {
                            this.$vScrollBarAlwaysVisible && this.$vScroll || this.$loop.schedule(this.CHANGE_SCROLL);
                        },
                        initialValue: !1
                    },
                    fontSize: {
                        set: function(e) {
                            "number" == typeof e && (e += "px"), this.container.style.fontSize = e, this.updateFontSize();
                        },
                        initialValue: 12
                    },
                    fontFamily: {
                        set: function(e) {
                            this.container.style.fontFamily = e, this.updateFontSize();
                        }
                    },
                    maxLines: {
                        set: function(e) {
                            this.updateFull();
                        }
                    },
                    minLines: {
                        set: function(e) {
                            this.$minLines < 562949953421311 || (this.$minLines = 0), this.updateFull();
                        }
                    },
                    maxPixelHeight: {
                        set: function(e) {
                            this.updateFull();
                        },
                        initialValue: 0
                    },
                    scrollPastEnd: {
                        set: function(e) {
                            this.$scrollPastEnd != (e = +e || 0) && (this.$scrollPastEnd = e, this.$loop.schedule(this.CHANGE_SCROLL));
                        },
                        initialValue: 0,
                        handlesSet: !0
                    },
                    fixedWidthGutter: {
                        set: function(e) {
                            this.$gutterLayer.$fixedWidth = !!e, this.$loop.schedule(this.CHANGE_GUTTER);
                        }
                    },
                    customScrollbar: {
                        set: function(e) {
                            this.$updateCustomScrollbar(e);
                        },
                        initialValue: !1
                    },
                    theme: {
                        set: function(e) {
                            this.setTheme(e);
                        },
                        get: function() {
                            return this.$themeId || this.theme;
                        },
                        initialValue: "./theme/textmate",
                        handlesSet: !0
                    },
                    hasCssTransforms: {},
                    useTextareaForIME: {
                        initialValue: !I.isMobile && !I.isIE
                    }
                }), t.VirtualRenderer = e;
            }), ace.define("ace/worker/worker_client", [
                "require",
                "exports",
                "module",
                "ace/lib/oop",
                "ace/lib/net",
                "ace/lib/event_emitter",
                "ace/config"
            ], function(a, e, t) {
                var i = a("../lib/oop"), n = a("../lib/net"), c = a("../lib/event_emitter").EventEmitter, h = a("../config");
                function l(e) {
                    var t;
                    return "undefined" == typeof Worker ? {
                        postMessage: function() {},
                        terminate: function() {}
                    } : h.get("loadWorkerFromBlob") ? (t = ((t)=>{
                        t = "importScripts('" + n.qualifyURL(t) + "');";
                        try {
                            return new Blob([
                                t
                            ], {
                                type: "application/javascript"
                            });
                        } catch (e) {
                            var i = new (window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder);
                            return i.append(t), i.getBlob("application/javascript");
                        }
                    })(e), t = (window.URL || window.webkitURL).createObjectURL(t), new Worker(t)) : new Worker(e);
                }
                function d(e) {
                    e.postMessage || (e = this.$createWorkerFromOldConfig.apply(this, arguments)), this.$worker = e, this.$sendDeltaQueue = this.$sendDeltaQueue.bind(this), this.changeListener = this.changeListener.bind(this), this.onMessage = this.onMessage.bind(this), this.callbackId = 1, this.callbacks = {}, this.$worker.onmessage = this.onMessage;
                }
                (function() {
                    i.implement(this, c), this.$createWorkerFromOldConfig = function(e, t, i, n, o) {
                        var r, s;
                        return a.nameToUrl && !a.toUrl && (a.toUrl = a.nameToUrl), h.get("packaged") || !a.toUrl ? n = n || h.moduleUrl(t, "worker") : (r = this.$normalizePath, n = n || r(a.toUrl("ace/worker/worker.js", null, "_")), s = {}, e.forEach(function(e) {
                            s[e] = r(a.toUrl(e, null, "_").replace(/(\.js)?(\?.*)?$/, ""));
                        })), this.$worker = l(n), o && this.send("importScripts", o), this.$worker.postMessage({
                            init: !0,
                            tlns: s,
                            module: t,
                            classname: i
                        }), this.$worker;
                    }, this.onMessage = function(e) {
                        var t = e.data;
                        switch(t.type){
                            case "event":
                                this._signal(t.name, {
                                    data: t.data
                                });
                                break;
                            case "call":
                                var i = this.callbacks[t.id];
                                i && (i(t.data), delete this.callbacks[t.id]);
                                break;
                            case "error":
                                this.reportError(t.data);
                                break;
                            case "log":
                                window.console && console.log && console.log.apply(console, t.data);
                        }
                    }, this.reportError = function(e) {
                        window.console && console.error && console.error(e);
                    }, this.$normalizePath = function(e) {
                        return n.qualifyURL(e);
                    }, this.terminate = function() {
                        this._signal("terminate", {}), this.deltaQueue = null, this.$worker.terminate(), this.$worker.onerror = function(e) {
                            e.preventDefault();
                        }, this.$worker = null, this.$doc && this.$doc.off("change", this.changeListener), this.$doc = null;
                    }, this.send = function(e, t) {
                        this.$worker.postMessage({
                            command: e,
                            args: t
                        });
                    }, this.call = function(e, t, i) {
                        var n;
                        i && (n = this.callbackId++, this.callbacks[n] = i, t.push(n)), this.send(e, t);
                    }, this.emit = function(e, t) {
                        try {
                            t.data && t.data.err && (t.data.err = {
                                message: t.data.err.message,
                                stack: t.data.err.stack,
                                code: t.data.err.code
                            }), this.$worker && this.$worker.postMessage({
                                event: e,
                                data: {
                                    data: t.data
                                }
                            });
                        } catch (e) {
                            console.error(e.stack);
                        }
                    }, this.attachToDocument = function(e) {
                        this.$doc && this.terminate(), this.$doc = e, this.call("setValue", [
                            e.getValue()
                        ]), e.on("change", this.changeListener, !0);
                    }, this.changeListener = function(e) {
                        this.deltaQueue || (this.deltaQueue = [], setTimeout(this.$sendDeltaQueue, 0)), "insert" == e.action ? this.deltaQueue.push(e.start, e.lines) : this.deltaQueue.push(e.start, e.end);
                    }, this.$sendDeltaQueue = function() {
                        var e = this.deltaQueue;
                        e && (this.deltaQueue = null, 50 < e.length && e.length > this.$doc.getLength() >> 1 ? this.call("setValue", [
                            this.$doc.getValue()
                        ]) : this.emit("change", {
                            data: e
                        }));
                    };
                }).call(d.prototype);
                e.UIWorkerClient = function(e, t, i) {
                    var n = null, o = !1, r = Object.create(c), s = [], a = new d({
                        messageBuffer: s,
                        terminate: function() {},
                        postMessage: function(e) {
                            s.push(e), n && (o ? setTimeout(l) : l());
                        }
                    }), l = (a.setEmitSync = function(e) {
                        o = e;
                    }, function() {
                        var e = s.shift();
                        e.command ? n[e.command].apply(n, e.args) : e.event && r._signal(e.event, e.data);
                    });
                    return r.postMessage = function(e) {
                        a.onMessage({
                            data: e
                        });
                    }, r.callback = function(e, t) {
                        this.postMessage({
                            type: "call",
                            id: t,
                            data: e
                        });
                    }, r.emit = function(e, t) {
                        this.postMessage({
                            type: "event",
                            name: e,
                            data: t
                        });
                    }, h.loadModule([
                        "worker",
                        t
                    ], function(e) {
                        for(n = new e[i](r); s.length;)l();
                    }), a;
                }, e.WorkerClient = d, e.createWorker = l;
            }), ace.define("ace/placeholder", [
                "require",
                "exports",
                "module",
                "ace/range",
                "ace/lib/event_emitter",
                "ace/lib/oop"
            ], function(e, t, i) {
                var l = e("./range").Range, n = e("./lib/event_emitter").EventEmitter, e = e("./lib/oop"), o = (r.prototype.setup = function() {
                    var t = this, i = this.doc, e = this.session, n = (this.selectionBefore = e.selection.toJSON(), e.selection.inMultiSelectMode && e.selection.toSingleRange(), this.pos = i.createAnchor(this.$pos.row, this.$pos.column), this.pos);
                    n.$insertRight = !0, n.detach(), n.markerId = e.addMarker(new l(n.row, n.column, n.row, n.column + this.length), this.mainClass, null, !1), this.others = [], this.$others.forEach(function(e) {
                        e = i.createAnchor(e.row, e.column);
                        e.$insertRight = !0, e.detach(), t.others.push(e);
                    }), e.setUndoSelect(!1);
                }, r.prototype.showOtherMarkers = function() {
                    var t, i;
                    this.othersActive || (t = this.session, (i = this).othersActive = !0, this.others.forEach(function(e) {
                        e.markerId = t.addMarker(new l(e.row, e.column, e.row, e.column + i.length), i.othersClass, null, !1);
                    }));
                }, r.prototype.hideOtherMarkers = function() {
                    if (this.othersActive) {
                        this.othersActive = !1;
                        for(var e = 0; e < this.others.length; e++)this.session.removeMarker(this.others[e].markerId);
                    }
                }, r.prototype.onUpdate = function(e) {
                    if (this.$updating) return this.updateAnchors(e);
                    var t = e;
                    if (t.start.row === t.end.row && t.start.row === this.pos.row) {
                        this.$updating = !0;
                        var i = "insert" === e.action ? t.end.column - t.start.column : t.start.column - t.end.column, n = t.start.column >= this.pos.column && t.start.column <= this.pos.column + this.length + 1, o = t.start.column - this.pos.column;
                        if (this.updateAnchors(e), n && (this.length += i), n && !this.session.$fromUndo) {
                            if ("insert" === e.action) for(var r = this.others.length - 1; 0 <= r; r--){
                                var s = {
                                    row: (a = this.others[r]).row,
                                    column: a.column + o
                                };
                                this.doc.insertMergedLines(s, e.lines);
                            }
                            else if ("remove" === e.action) for(r = this.others.length - 1; 0 <= r; r--){
                                var a, s = {
                                    row: (a = this.others[r]).row,
                                    column: a.column + o
                                };
                                this.doc.remove(new l(s.row, s.column, s.row, s.column - i));
                            }
                        }
                        this.$updating = !1, this.updateMarkers();
                    }
                }, r.prototype.updateAnchors = function(e) {
                    this.pos.onChange(e);
                    for(var t = this.others.length; t--;)this.others[t].onChange(e);
                    this.updateMarkers();
                }, r.prototype.updateMarkers = function() {
                    if (!this.$updating) {
                        var i = this, n = this.session, e = function(e, t) {
                            n.removeMarker(e.markerId), e.markerId = n.addMarker(new l(e.row, e.column, e.row, e.column + i.length), t, null, !1);
                        };
                        e(this.pos, this.mainClass);
                        for(var t = this.others.length; t--;)e(this.others[t], this.othersClass);
                    }
                }, r.prototype.onCursorChange = function(e) {
                    var t;
                    !this.$updating && this.session && ((t = this.session.selection.getCursor()).row === this.pos.row && t.column >= this.pos.column && t.column <= this.pos.column + this.length ? (this.showOtherMarkers(), this._emit("cursorEnter", e)) : (this.hideOtherMarkers(), this._emit("cursorLeave", e)));
                }, r.prototype.detach = function() {
                    this.session.removeMarker(this.pos && this.pos.markerId), this.hideOtherMarkers(), this.doc.off("change", this.$onUpdate), this.session.selection.off("changeCursor", this.$onCursorChange), this.session.setUndoSelect(!0), this.session = null;
                }, r.prototype.cancel = function() {
                    if (-1 !== this.$undoStackDepth) {
                        for(var e = this.session.getUndoManager(), t = (e.$undoStack || e.$undostack).length - this.$undoStackDepth, i = 0; i < t; i++)e.undo(this.session, !0);
                        this.selectionBefore && this.session.selection.fromJSON(this.selectionBefore);
                    }
                }, r);
                function r(e, t, i, n, o, r) {
                    var s = this, t = (this.length = t, this.session = e, this.doc = e.getDocument(), this.mainClass = o, this.othersClass = r, this.$onUpdate = this.onUpdate.bind(this), this.doc.on("change", this.$onUpdate, !0), this.$others = n, this.$onCursorChange = function() {
                        setTimeout(function() {
                            s.onCursorChange();
                        });
                    }, this.$pos = i, e.getUndoManager().$undoStack || e.getUndoManager().$undostack || {
                        length: -1
                    });
                    this.$undoStackDepth = t.length, this.setup(), e.selection.on("changeCursor", this.$onCursorChange);
                }
                e.implement(o.prototype, n), t.PlaceHolder = o;
            }), ace.define("ace/mouse/multi_select_handler", [
                "require",
                "exports",
                "module",
                "ace/lib/event",
                "ace/lib/useragent"
            ], function(e, t, i) {
                var S = e("../lib/event"), k = e("../lib/useragent");
                function T(e, t) {
                    return e.row == t.row && e.column == t.column;
                }
                t.onMouseDown = function(e) {
                    var t = e.domEvent, i = t.altKey, n = t.shiftKey, o = t.ctrlKey, r = e.getAccelKey(), s = e.getButton();
                    if (o && k.isMac && (s = t.button), e.editor.inMultiSelectMode && 2 == s) e.editor.textInput.onContextMenu(e.domEvent);
                    else if (o || i || r) {
                        if (0 === s) {
                            var a, l, c, h, d, u, g, p, m = e.editor, f = m.selection, C = m.inMultiSelectMode, y = e.getDocumentPosition(), v = f.getCursor(), v = e.inSelection() || f.isEmpty() && T(y, v), I = e.x, b = e.y, A = m.session, w = m.renderer.pixelToScreenCoordinates(I, b), x = w;
                            if (m.$mouseHandler.$enableJumpToDef) o && i || r && i ? a = n ? "block" : "add" : i && m.$blockSelectEnabled && (a = "block");
                            else if (r && !i) {
                                if (a = "add", !C && n) return;
                            } else i && m.$blockSelectEnabled && (a = "block");
                            if (a && k.isMac && t.ctrlKey && m.$mouseHandler.cancelContextMenu(), "add" == a) !C && v || (C || (l = f.toOrientedRange(), m.addSelectionMarker(l)), c = f.rangeList.rangeAtPoint(y), m.inVirtualSelectionMode = !0, n && (c = null, l = f.ranges[0] || l, m.removeSelectionMarker(l)), m.once("mouseup", function() {
                                var e = f.toOrientedRange();
                                c && e.isEmpty() && T(c.cursor, e.cursor) ? f.substractPoint(e.cursor) : (n ? f.substractPoint(l.cursor) : l && (m.removeSelectionMarker(l), f.addRange(l)), f.addRange(e)), m.inVirtualSelectionMode = !1;
                            }));
                            else if ("block" == a) return e.stop(), m.inVirtualSelectionMode = !0, d = [], u = function() {
                                var e = m.renderer.pixelToScreenCoordinates(I, b), t = A.screenToDocumentPosition(e.row, e.column, e.offsetX);
                                T(x, e) && T(t, f.lead) || (x = e, m.selection.moveToPosition(t), m.renderer.scrollCursorIntoView(), m.removeSelectionMarkers(d), d = f.rectangularRangeBlock(x, w), m.$mouseHandler.$clickSelection && 1 == d.length && d[0].isEmpty() && (d[0] = m.$mouseHandler.$clickSelection.clone()), d.forEach(m.addSelectionMarker, m), m.updateSelectionMarkers());
                            }, C && !r ? f.toSingleRange() : !C && r && (h = f.toOrientedRange(), m.addSelectionMarker(h)), n ? w = A.documentToScreenPosition(f.lead) : f.moveToPosition(y), x = {
                                row: -1,
                                column: -1
                            }, g = u, S.capture(m.container, function(e) {
                                I = e.clientX, b = e.clientY;
                            }, function(e) {
                                u(), clearInterval(p), m.removeSelectionMarkers(d), d.length || (d = [
                                    f.toOrientedRange()
                                ]), h && (m.removeSelectionMarker(h), f.toSingleRange(h));
                                for(var t = 0; t < d.length; t++)f.addRange(d[t]);
                                m.inVirtualSelectionMode = !1, m.$mouseHandler.$clickSelection = null;
                            }), p = setInterval(function() {
                                g();
                            }, 20), e.preventDefault();
                        }
                    } else 0 === s && e.editor.inMultiSelectMode && e.editor.exitMultiSelectMode();
                };
            }), ace.define("ace/commands/multi_select_commands", [
                "require",
                "exports",
                "module",
                "ace/keyboard/hash_handler"
            ], function(e, t, i) {
                t.defaultCommands = [
                    {
                        name: "addCursorAbove",
                        description: "Add cursor above",
                        exec: function(e) {
                            e.selectMoreLines(-1);
                        },
                        bindKey: {
                            win: "Ctrl-Alt-Up",
                            mac: "Ctrl-Alt-Up"
                        },
                        scrollIntoView: "cursor",
                        readOnly: !0
                    },
                    {
                        name: "addCursorBelow",
                        description: "Add cursor below",
                        exec: function(e) {
                            e.selectMoreLines(1);
                        },
                        bindKey: {
                            win: "Ctrl-Alt-Down",
                            mac: "Ctrl-Alt-Down"
                        },
                        scrollIntoView: "cursor",
                        readOnly: !0
                    },
                    {
                        name: "addCursorAboveSkipCurrent",
                        description: "Add cursor above (skip current)",
                        exec: function(e) {
                            e.selectMoreLines(-1, !0);
                        },
                        bindKey: {
                            win: "Ctrl-Alt-Shift-Up",
                            mac: "Ctrl-Alt-Shift-Up"
                        },
                        scrollIntoView: "cursor",
                        readOnly: !0
                    },
                    {
                        name: "addCursorBelowSkipCurrent",
                        description: "Add cursor below (skip current)",
                        exec: function(e) {
                            e.selectMoreLines(1, !0);
                        },
                        bindKey: {
                            win: "Ctrl-Alt-Shift-Down",
                            mac: "Ctrl-Alt-Shift-Down"
                        },
                        scrollIntoView: "cursor",
                        readOnly: !0
                    },
                    {
                        name: "selectMoreBefore",
                        description: "Select more before",
                        exec: function(e) {
                            e.selectMore(-1);
                        },
                        bindKey: {
                            win: "Ctrl-Alt-Left",
                            mac: "Ctrl-Alt-Left"
                        },
                        scrollIntoView: "cursor",
                        readOnly: !0
                    },
                    {
                        name: "selectMoreAfter",
                        description: "Select more after",
                        exec: function(e) {
                            e.selectMore(1);
                        },
                        bindKey: {
                            win: "Ctrl-Alt-Right",
                            mac: "Ctrl-Alt-Right"
                        },
                        scrollIntoView: "cursor",
                        readOnly: !0
                    },
                    {
                        name: "selectNextBefore",
                        description: "Select next before",
                        exec: function(e) {
                            e.selectMore(-1, !0);
                        },
                        bindKey: {
                            win: "Ctrl-Alt-Shift-Left",
                            mac: "Ctrl-Alt-Shift-Left"
                        },
                        scrollIntoView: "cursor",
                        readOnly: !0
                    },
                    {
                        name: "selectNextAfter",
                        description: "Select next after",
                        exec: function(e) {
                            e.selectMore(1, !0);
                        },
                        bindKey: {
                            win: "Ctrl-Alt-Shift-Right",
                            mac: "Ctrl-Alt-Shift-Right"
                        },
                        scrollIntoView: "cursor",
                        readOnly: !0
                    },
                    {
                        name: "toggleSplitSelectionIntoLines",
                        description: "Split selection into lines",
                        exec: function(e) {
                            1 < e.multiSelect.rangeCount ? e.multiSelect.joinSelections() : e.multiSelect.splitIntoLines();
                        },
                        bindKey: {
                            win: "Ctrl-Alt-L",
                            mac: "Ctrl-Alt-L"
                        },
                        readOnly: !0
                    },
                    {
                        name: "splitSelectionIntoLines",
                        description: "Split into lines",
                        exec: function(e) {
                            e.multiSelect.splitIntoLines();
                        },
                        readOnly: !0
                    },
                    {
                        name: "alignCursors",
                        description: "Align cursors",
                        exec: function(e) {
                            e.alignCursors();
                        },
                        bindKey: {
                            win: "Ctrl-Alt-A",
                            mac: "Ctrl-Alt-A"
                        },
                        scrollIntoView: "cursor"
                    },
                    {
                        name: "findAll",
                        description: "Find all",
                        exec: function(e) {
                            e.findAll();
                        },
                        bindKey: {
                            win: "Ctrl-Alt-K",
                            mac: "Ctrl-Alt-G"
                        },
                        scrollIntoView: "cursor",
                        readOnly: !0
                    }
                ], t.multiSelectCommands = [
                    {
                        name: "singleSelection",
                        description: "Single selection",
                        bindKey: "esc",
                        exec: function(e) {
                            e.exitMultiSelectMode();
                        },
                        scrollIntoView: "cursor",
                        readOnly: !0,
                        isAvailable: function(e) {
                            return e && e.inMultiSelectMode;
                        }
                    }
                ];
                e = e("../keyboard/hash_handler").HashHandler;
                t.keyboardHandler = new e(t.multiSelectCommands);
            }), ace.define("ace/multi_select", [
                "require",
                "exports",
                "module",
                "ace/range_list",
                "ace/range",
                "ace/selection",
                "ace/mouse/multi_select_handler",
                "ace/lib/event",
                "ace/lib/lang",
                "ace/commands/multi_select_commands",
                "ace/search",
                "ace/edit_session",
                "ace/editor",
                "ace/config"
            ], function(e, o, t) {
                var i = e("./range_list").RangeList, I = e("./range").Range, u = e("./selection").Selection, r = e("./mouse/multi_select_handler").onMouseDown, s = e("./lib/event"), g = e("./lib/lang"), a = e("./commands/multi_select_commands");
                o.commands = a.defaultCommands.concat(a.multiSelectCommands);
                var l = new (e("./search")).Search;
                var n = e("./edit_session").EditSession, n = (!(function() {
                    this.getSelectionMarkers = function() {
                        return this.$selectionMarkers;
                    };
                }).call(n.prototype), (function() {
                    this.ranges = null, this.rangeList = null, this.addRange = function(e, t) {
                        if (e) {
                            if (!this.inMultiSelectMode && 0 === this.rangeCount) {
                                var i = this.toOrientedRange();
                                if (this.rangeList.add(i), this.rangeList.add(e), 2 != this.rangeList.ranges.length) return this.rangeList.removeAll(), t || this.fromOrientedRange(e);
                                this.rangeList.removeAll(), this.rangeList.add(i), this.$onAddRange(i);
                            }
                            e.cursor || (e.cursor = e.end);
                            i = this.rangeList.add(e);
                            return this.$onAddRange(e), i.length && this.$onRemoveRange(i), 1 < this.rangeCount && !this.inMultiSelectMode && (this._signal("multiSelect"), this.inMultiSelectMode = !0, this.session.$undoSelect = !1, this.rangeList.attach(this.session)), t || this.fromOrientedRange(e);
                        }
                    }, this.toSingleRange = function(e) {
                        e = e || this.ranges[0];
                        var t = this.rangeList.removeAll();
                        t.length && this.$onRemoveRange(t), e && this.fromOrientedRange(e);
                    }, this.substractPoint = function(e) {
                        e = this.rangeList.substractPoint(e);
                        if (e) return this.$onRemoveRange(e), e[0];
                    }, this.mergeOverlappingRanges = function() {
                        var e = this.rangeList.merge();
                        e.length && this.$onRemoveRange(e);
                    }, this.$onAddRange = function(e) {
                        this.rangeCount = this.rangeList.ranges.length, this.ranges.unshift(e), this._signal("addRange", {
                            range: e
                        });
                    }, this.$onRemoveRange = function(e) {
                        var t;
                        this.rangeCount = this.rangeList.ranges.length, 1 == this.rangeCount && this.inMultiSelectMode && (t = this.rangeList.ranges.pop(), e.push(t), this.rangeCount = 0);
                        for(var i = e.length; i--;){
                            var n = this.ranges.indexOf(e[i]);
                            this.ranges.splice(n, 1);
                        }
                        this._signal("removeRange", {
                            ranges: e
                        }), 0 === this.rangeCount && this.inMultiSelectMode && (this.inMultiSelectMode = !1, this._signal("singleSelect"), this.session.$undoSelect = !0, this.rangeList.detach(this.session)), (t = t || this.ranges[0]) && !t.isEqual(this.getRange()) && this.fromOrientedRange(t);
                    }, this.$initRangeList = function() {
                        this.rangeList || (this.rangeList = new i, this.ranges = [], this.rangeCount = 0);
                    }, this.getAllRanges = function() {
                        return this.rangeCount ? this.rangeList.ranges.concat() : [
                            this.getRange()
                        ];
                    }, this.splitIntoLines = function() {
                        for(var e = this.ranges.length ? this.ranges : [
                            this.getRange()
                        ], t = [], i = 0; i < e.length; i++){
                            var n = e[i], o = n.start.row, r = n.end.row;
                            if (o === r) t.push(n.clone());
                            else {
                                for(t.push(new I(o, n.start.column, o, this.session.getLine(o).length)); ++o < r;)t.push(this.getLineRange(o, !0));
                                t.push(new I(r, 0, r, n.end.column));
                            }
                            0 != i || this.isBackwards() || (t = t.reverse());
                        }
                        this.toSingleRange();
                        for(i = t.length; i--;)this.addRange(t[i]);
                    }, this.joinSelections = function() {
                        var e = this.rangeList.ranges, t = e[e.length - 1], e = I.fromPoints(e[0].start, t.end);
                        this.toSingleRange(), this.setSelectionRange(e, t.cursor == t.start);
                    }, this.toggleBlockSelection = function() {
                        var e, t;
                        1 < this.rangeCount ? (t = (e = this.rangeList.ranges)[e.length - 1], e = I.fromPoints(e[0].start, t.end), this.toSingleRange(), this.setSelectionRange(e, t.cursor == t.start)) : (e = this.session.documentToScreenPosition(this.cursor), t = this.session.documentToScreenPosition(this.anchor), this.rectangularRangeBlock(e, t).forEach(this.addRange, this));
                    }, this.rectangularRangeBlock = function(e, t, i) {
                        var n, o, r, s, a, l, c, h = [], d = e.column < t.column, u = (s = (d ? (n = e.column, o = t.column, r = e.offsetX, t) : (n = t.column, o = e.column, r = t.offsetX, e)).offsetX, e.row < t.row);
                        l = (u ? (a = e.row, t) : (a = t.row, e)).row, n < 0 && (n = 0), (a = a < 0 ? 0 : a) == l && (i = !0);
                        for(var g, p, m = a; m <= l; m++){
                            var f = I.fromPoints(this.session.screenToDocumentPosition(m, n, r), this.session.screenToDocumentPosition(m, o, s));
                            if (f.isEmpty()) {
                                if (c && (g = f.end, p = c, g.row == p.row) && g.column == p.column) break;
                                c = f.end;
                            }
                            f.cursor = d ? f.start : f.end, h.push(f);
                        }
                        if (u && h.reverse(), !i) {
                            for(var C = h.length - 1; h[C].isEmpty() && 0 < C;)C--;
                            if (0 < C) for(var y = 0; h[y].isEmpty();)y++;
                            for(var v = C; y <= v; v--)h[v].isEmpty() && h.splice(v, 1);
                        }
                        return h;
                    };
                }).call(u.prototype), e("./editor").Editor);
                function c(e) {
                    var t, i;
                    function n(e) {
                        i && (t.renderer.setMouseCursor(""), i = !1);
                    }
                    e.$multiselectOnSessionChange || (e.$onAddRange = e.$onAddRange.bind(e), e.$onRemoveRange = e.$onRemoveRange.bind(e), e.$onMultiSelect = e.$onMultiSelect.bind(e), e.$onSingleSelect = e.$onSingleSelect.bind(e), e.$multiselectOnSessionChange = o.onSessionChange.bind(e), e.$checkMultiselectChange = e.$checkMultiselectChange.bind(e), e.$multiselectOnSessionChange(e), e.on("changeSession", e.$multiselectOnSessionChange), e.on("mousedown", r), e.commands.addCommands(a.defaultCommands), (t = e).textInput && (e = t.textInput.getElement(), i = !1, s.addListener(e, "keydown", function(e) {
                        e = 18 == e.keyCode && !(e.ctrlKey || e.shiftKey || e.metaKey);
                        t.$blockSelectEnabled && e ? i || (t.renderer.setMouseCursor("crosshair"), i = !0) : i && n();
                    }, t), s.addListener(e, "keyup", n, t), s.addListener(e, "blur", n, t)));
                }
                (function() {
                    this.updateSelectionMarkers = function() {
                        this.renderer.updateCursor(), this.renderer.updateBackMarkers();
                    }, this.addSelectionMarker = function(e) {
                        e.cursor || (e.cursor = e.end);
                        var t = this.getSelectionStyle();
                        return e.marker = this.session.addMarker(e, "ace_selection", t), this.session.$selectionMarkers.push(e), this.session.selectionMarkerCount = this.session.$selectionMarkers.length, e;
                    }, this.removeSelectionMarker = function(e) {
                        e.marker && (this.session.removeMarker(e.marker), -1 != (e = this.session.$selectionMarkers.indexOf(e)) && this.session.$selectionMarkers.splice(e, 1), this.session.selectionMarkerCount = this.session.$selectionMarkers.length);
                    }, this.removeSelectionMarkers = function(e) {
                        for(var t = this.session.$selectionMarkers, i = e.length; i--;){
                            var n = e[i];
                            n.marker && (this.session.removeMarker(n.marker), -1 != (n = t.indexOf(n))) && t.splice(n, 1);
                        }
                        this.session.selectionMarkerCount = t.length;
                    }, this.$onAddRange = function(e) {
                        this.addSelectionMarker(e.range), this.renderer.updateCursor(), this.renderer.updateBackMarkers();
                    }, this.$onRemoveRange = function(e) {
                        this.removeSelectionMarkers(e.ranges), this.renderer.updateCursor(), this.renderer.updateBackMarkers();
                    }, this.$onMultiSelect = function(e) {
                        this.inMultiSelectMode || (this.inMultiSelectMode = !0, this.setStyle("ace_multiselect"), this.keyBinding.addKeyboardHandler(a.keyboardHandler), this.commands.setDefaultHandler("exec", this.$onMultiSelectExec), this.renderer.updateCursor(), this.renderer.updateBackMarkers());
                    }, this.$onSingleSelect = function(e) {
                        this.session.multiSelect.inVirtualMode || (this.inMultiSelectMode = !1, this.unsetStyle("ace_multiselect"), this.keyBinding.removeKeyboardHandler(a.keyboardHandler), this.commands.removeDefaultHandler("exec", this.$onMultiSelectExec), this.renderer.updateCursor(), this.renderer.updateBackMarkers(), this._emit("changeSelection"));
                    }, this.$onMultiSelectExec = function(e) {
                        var t, i = e.command, n = e.editor;
                        if (n.multiSelect) return i.multiSelectAction ? t = "forEach" == i.multiSelectAction ? n.forEachSelection(i, e.args) : "forEachLine" == i.multiSelectAction ? n.forEachSelection(i, e.args, !0) : "single" == i.multiSelectAction ? (n.exitMultiSelectMode(), i.exec(n, e.args || {})) : i.multiSelectAction(n, e.args || {}) : (t = i.exec(n, e.args || {}), n.multiSelect.addRange(n.multiSelect.toOrientedRange()), n.multiSelect.mergeOverlappingRanges()), t;
                    }, this.forEachSelection = function(e, t, i) {
                        if (!this.inVirtualSelectionMode) {
                            var n, o = i && i.keepOrder, r = 1 == i || i && i.$byLines, s = this.session, i = this.selection, a = i.rangeList, l = (o ? i : a).ranges;
                            if (!l.length) return e.exec ? e.exec(this, t || {}) : e(this, t || {});
                            var o = i._eventRegistry, c = (i._eventRegistry = {}, new u(s));
                            this.inVirtualSelectionMode = !0;
                            for(var h = l.length; h--;){
                                if (r) for(; 0 < h && l[h].start.row == l[h - 1].end.row;)h--;
                                c.fromOrientedRange(l[h]), c.index = h, this.selection = s.selection = c;
                                var d = e.exec ? e.exec(this, t || {}) : e(this, t || {});
                                n || void 0 === d || (n = d), c.toOrientedRange(l[h]);
                            }
                            c.detach(), this.selection = s.selection = i, this.inVirtualSelectionMode = !1, i._eventRegistry = o, i.mergeOverlappingRanges(), i.ranges[0] && i.fromOrientedRange(i.ranges[0]);
                            a = this.renderer.$scrollAnimation;
                            return this.onCursorChange(), this.onSelectionChange(), a && a.from == a.to && this.renderer.animateScrolling(a.from), n;
                        }
                    }, this.exitMultiSelectMode = function() {
                        this.inMultiSelectMode && !this.inVirtualSelectionMode && this.multiSelect.toSingleRange();
                    }, this.getSelectedText = function() {
                        var e = "";
                        if (this.inMultiSelectMode && !this.inVirtualSelectionMode) {
                            for(var t = this.multiSelect.rangeList.ranges, i = [], n = 0; n < t.length; n++)i.push(this.session.getTextRange(t[n]));
                            var o = this.session.getDocument().getNewLineCharacter();
                            (e = i.join(o)).length == (i.length - 1) * o.length && (e = "");
                        } else this.selection.isEmpty() || (e = this.session.getTextRange(this.getSelectionRange()));
                        return e;
                    }, this.$checkMultiselectChange = function(e, t) {
                        var i;
                        this.inMultiSelectMode && !this.inVirtualSelectionMode && (i = this.multiSelect.ranges[0], this.multiSelect.isEmpty() && t == this.multiSelect.anchor || ((i = t == this.multiSelect.anchor ? i.cursor == i.start ? i.end : i.start : i.cursor).row != t.row || this.session.$clipPositionToDocument(i.row, i.column).column != t.column ? this.multiSelect.toSingleRange(this.multiSelect.toOrientedRange()) : this.multiSelect.mergeOverlappingRanges()));
                    }, this.findAll = function(e, t, i) {
                        (t = t || {}).needle = e || t.needle, null == t.needle && (n = this.selection.isEmpty() ? this.selection.getWordRange() : this.selection.getRange(), t.needle = this.session.getTextRange(n)), this.$search.set(t);
                        var n, o = this.$search.findAll(this.session);
                        if (!o.length) return 0;
                        var r = this.multiSelect;
                        i || r.toSingleRange(o[0]);
                        for(var s = o.length; s--;)r.addRange(o[s], !0);
                        return n && r.rangeList.rangeAtPoint(n.start) && r.addRange(n, !0), o.length;
                    }, this.selectMoreLines = function(e, t) {
                        var i, n, o, r = this.selection.toOrientedRange(), s = r.cursor == r.end, a = this.session.documentToScreenPosition(r.cursor), l = (this.selection.$desiredColumn && (a.column = this.selection.$desiredColumn), this.session.screenToDocumentPosition(a.row + e, a.column));
                        e = r.isEmpty() ? l : (i = this.session.documentToScreenPosition(s ? r.end : r.start), this.session.screenToDocumentPosition(i.row + e, i.column)), s ? (n = I.fromPoints(l, e)).cursor = n.start : (n = I.fromPoints(e, l)).cursor = n.end, n.desiredColumn = a.column, this.selection.inMultiSelectMode ? t && (o = r.cursor) : this.selection.addRange(r), this.selection.addRange(n), o && this.selection.substractPoint(o);
                    }, this.transposeSelections = function(e) {
                        for(var t, i = this.session, n = i.multiSelect, o = n.ranges, r = o.length; r--;)(a = o[r]).isEmpty() && (t = i.getWordRange(a.start.row, a.start.column), a.start.row = t.start.row, a.start.column = t.start.column, a.end.row = t.end.row, a.end.column = t.end.column);
                        n.mergeOverlappingRanges();
                        for(var s = [], r = o.length; r--;){
                            var a = o[r];
                            s.unshift(i.getTextRange(a));
                        }
                        e < 0 ? s.unshift(s.pop()) : s.push(s.shift());
                        for(r = o.length; r--;){
                            var l = (a = o[r]).clone();
                            i.replace(a, s[r]), a.start.row = l.start.row, a.start.column = l.start.column;
                        }
                        n.fromOrientedRange(n.ranges[0]);
                    }, this.selectMore = function(e, t, i) {
                        var n, o = this.session, r = o.multiSelect.toOrientedRange();
                        r.isEmpty() && ((r = o.getWordRange(r.start.row, r.start.column)).cursor = -1 == e ? r.start : r.end, this.multiSelect.addRange(r), i) || (i = o.getTextRange(r), o, i, n = e, l.$options.wrap = !0, l.$options.needle = i, l.$options.backwards = -1 == n, (i = l.find(o)) && (i.cursor = -1 == e ? i.start : i.end, this.session.unfold(i), this.multiSelect.addRange(i), this.renderer.scrollCursorIntoView(null, .5)), t && this.multiSelect.substractPoint(r.cursor));
                    }, this.alignCursors = function() {
                        var o = this.session, t = o.multiSelect, e = t.ranges, i = -1, n = e.filter(function(e) {
                            if (e.cursor.row == i) return !0;
                            i = e.cursor.row;
                        });
                        if (e.length && n.length != e.length - 1) {
                            n.forEach(function(e) {
                                t.substractPoint(e.cursor);
                            });
                            var r = 0, s = 1 / 0, a = e.map(function(e) {
                                var e = e.cursor, t = o.getLine(e.row).substr(e.column).search(/\S/g);
                                return e.column > r && (r = e.column), (t = -1 == t ? 0 : t) < s && (s = t), t;
                            });
                            e.forEach(function(e, t) {
                                var i = e.cursor, n = r - i.column, t = a[t] - s;
                                t < n ? o.insert(i, g.stringRepeat(" ", n - t)) : o.remove(new I(i.row, i.column, i.row, i.column - n + t)), e.start.column = e.end.column = r, e.start.row = e.end.row = i.row, e.cursor = e.end;
                            }), t.fromOrientedRange(e[0]), this.renderer.updateCursor(), this.renderer.updateBackMarkers();
                        } else {
                            var n = this.selection.getRange(), l = n.start.row, c = n.end.row, e = l == c;
                            if (e) {
                                for(var h, d = this.session.getLength(); h = this.session.getLine(c), /[=:]/.test(h) && ++c < d;);
                                for(; h = this.session.getLine(l), /[=:]/.test(h) && 0 < --l;);
                                l < 0 && (l = 0), d <= c && (c = d - 1);
                            }
                            var u = this.session.removeFullLines(l, c), u = this.$reAlignText(u, e);
                            this.session.insert({
                                row: l,
                                column: 0
                            }, u.join("\n") + "\n"), e || (n.start.column = 0, n.end.column = u[u.length - 1].length), this.selection.setRange(n);
                        }
                    }, this.$reAlignText = function(e, t) {
                        var i, n, o, r = !0, s = !0;
                        return e.map(function(e) {
                            var t = e.match(/(\s*)(.*?)(\s*)([=:].*)/);
                            return t ? (null == i ? (i = t[1].length, n = t[2].length, o = t[3].length) : (i + n + o != t[1].length + t[2].length + t[3].length && (s = !1), i != t[1].length && (r = !1), i > t[1].length && (i = t[1].length), n < t[2].length && (n = t[2].length), o > t[3].length && (o = t[3].length)), t) : [
                                e
                            ];
                        }).map(t ? l : r ? s ? function(e) {
                            return e[2] ? a(i + n - e[2].length) + e[2] + a(o) + e[4].replace(/^([=:])\s+/, "$1 ") : e[0];
                        } : l : function(e) {
                            return e[2] ? a(i) + e[2] + a(o) + e[4].replace(/^([=:])\s+/, "$1 ") : e[0];
                        });
                        function a(e) {
                            return g.stringRepeat(" ", e);
                        }
                        function l(e) {
                            return e[2] ? a(i) + e[2] + a(n - e[2].length + o) + e[4].replace(/^([=:])\s+/, "$1 ") : e[0];
                        }
                    };
                }).call(n.prototype), o.onSessionChange = function(e) {
                    var t = e.session, e = (t && !t.multiSelect && (t.$selectionMarkers = [], t.selection.$initRangeList(), t.multiSelect = t.selection), this.multiSelect = t && t.multiSelect, e.oldSession);
                    e && (e.multiSelect.off("addRange", this.$onAddRange), e.multiSelect.off("removeRange", this.$onRemoveRange), e.multiSelect.off("multiSelect", this.$onMultiSelect), e.multiSelect.off("singleSelect", this.$onSingleSelect), e.multiSelect.lead.off("change", this.$checkMultiselectChange), e.multiSelect.anchor.off("change", this.$checkMultiselectChange)), t && (t.multiSelect.on("addRange", this.$onAddRange), t.multiSelect.on("removeRange", this.$onRemoveRange), t.multiSelect.on("multiSelect", this.$onMultiSelect), t.multiSelect.on("singleSelect", this.$onSingleSelect), t.multiSelect.lead.on("change", this.$checkMultiselectChange), t.multiSelect.anchor.on("change", this.$checkMultiselectChange)), t && this.inMultiSelectMode != t.selection.inMultiSelectMode && (t.selection.inMultiSelectMode ? this.$onMultiSelect() : this.$onSingleSelect());
                }, o.MultiSelect = c, e("./config").defineOptions(n.prototype, "editor", {
                    enableMultiselect: {
                        set: function(e) {
                            c(this), e ? this.on("mousedown", r) : this.off("mousedown", r);
                        },
                        value: !0
                    },
                    enableBlockSelect: {
                        set: function(e) {
                            this.$blockSelectEnabled = e;
                        },
                        value: !0
                    }
                });
            }), ace.define("ace/mode/folding/fold_mode", [
                "require",
                "exports",
                "module",
                "ace/range"
            ], function(e, t, i) {
                var h = e("../../range").Range, e = t.FoldMode = function() {};
                (function() {
                    this.foldingStartMarker = null, this.foldingStopMarker = null, this.getFoldWidget = function(e, t, i) {
                        e = e.getLine(i);
                        return this.foldingStartMarker.test(e) ? "start" : "markbeginend" == t && this.foldingStopMarker && this.foldingStopMarker.test(e) ? "end" : "";
                    }, this.getFoldWidgetRange = function(e, t, i) {
                        return null;
                    }, this.indentationBlock = function(e, t, i) {
                        var n = /\S/, o = e.getLine(t), r = o.search(n);
                        if (-1 != r) {
                            for(var s, i = i || o.length, a = e.getLength(), o = t, l = t; ++t < a;){
                                var c = e.getLine(t).search(n);
                                if (-1 != c) {
                                    if (c <= r) {
                                        c = e.getTokenAt(t, 0);
                                        if (!c || "string" !== c.type) break;
                                    }
                                    l = t;
                                }
                            }
                            return o < l ? (s = e.getLine(l).length, new h(o, i, l, s)) : void 0;
                        }
                    }, this.openingBracketBlock = function(e, t, i, n, o) {
                        i = {
                            row: i,
                            column: n + 1
                        }, n = e.$findClosingBracket(t, i, o);
                        if (n) return "start" == (t = null == (t = e.foldWidgets[n.row]) ? e.getFoldWidget(n.row) : t) && n.row > i.row && (n.row--, n.column = e.getLine(n.row).length), h.fromPoints(i, n);
                    }, this.closingBracketBlock = function(e, t, i, n, o) {
                        i = {
                            row: i,
                            column: n
                        }, n = e.$findOpeningBracket(t, i);
                        if (n) return n.column++, i.column--, h.fromPoints(n, i);
                    };
                }).call(e.prototype);
            }), ace.define("ace/ext/error_marker", [
                "require",
                "exports",
                "module",
                "ace/lib/dom",
                "ace/range",
                "ace/config"
            ], function(e, t, i) {
                var h = e("../lib/dom"), a = e("../range").Range, d = e("../config").nls;
                function u(e, t, i) {
                    var n = e.getAnnotations().sort(a.comparePoints);
                    if (n.length) {
                        var o = ((e, t, i)=>{
                            for(var n = 0, o = e.length - 1; n <= o;){
                                var r = n + o >> 1, s = i(t, e[r]);
                                if (0 < s) n = 1 + r;
                                else {
                                    if (!(s < 0)) return r;
                                    o = r - 1;
                                }
                            }
                            return -(n + 1);
                        })(n, {
                            row: t,
                            column: -1
                        }, a.comparePoints), r = (n.length <= (o = o < 0 ? -o - 1 : o) ? o = 0 < i ? 0 : n.length - 1 : 0 === o && i < 0 && (o = n.length - 1), n[o]);
                        if (r && i) {
                            if (r.row === t) {
                                for(; (r = n[o += i]) && r.row === t;);
                                if (!r) return n.slice();
                            }
                            var s = [];
                            for(t = r.row; s[i < 0 ? "unshift" : "push"](r), (r = n[o += i]) && r.row == t;);
                            return s.length && s;
                        }
                    }
                }
                t.showErrorMarker = function(e, t) {
                    var i, n = e.session, o = e.getCursorPosition(), r = o.row, s = n.widgetManager.getWidgetsAtRow(r).filter(function(e) {
                        return "errorMarker" == e.type;
                    })[0], r = (s ? s.destroy() : r -= t, u(n, r, t));
                    if (r) {
                        t = r[0];
                        o.column = (t.pos && "number" != typeof t.column ? t.pos.sc : t.column) || 0, o.row = t.row, i = e.renderer.$gutterLayer.$annotations[o.row];
                    } else {
                        if (s) return;
                        i = {
                            displayText: [
                                d("error-marker.good-state", "Looks good!")
                            ],
                            className: "ace_ok"
                        };
                    }
                    e.session.unfold(o.row), e.selection.moveToPosition(o);
                    function a(e, t, i) {
                        if (0 === t && ("esc" === i || "return" === i)) return l.destroy(), {
                            command: "null"
                        };
                    }
                    var l = {
                        row: o.row,
                        fixedWidth: !0,
                        coverGutter: !0,
                        el: h.createElement("div"),
                        type: "errorMarker"
                    }, c = l.el.appendChild(h.createElement("div")), r = l.el.appendChild(h.createElement("div")), t = (r.className = "error_widget_arrow " + i.className, e.renderer.$cursorLayer.getPixelPosition(o).left);
                    r.style.left = t + e.renderer.gutterWidth - 5 + "px", l.el.className = "error_widget_wrapper", c.className = "error_widget " + i.className, i.displayText.forEach(function(e, t) {
                        c.appendChild(h.createTextNode(e)), t < i.displayText.length - 1 && c.appendChild(h.createElement("br"));
                    }), c.appendChild(h.createElement("div"));
                    l.destroy = function() {
                        e.$mouseHandler.isMousePressed || (e.keyBinding.removeKeyboardHandler(a), n.widgetManager.removeLineWidget(l), e.off("changeSelection", l.destroy), e.off("changeSession", l.destroy), e.off("mouseup", l.destroy), e.off("change", l.destroy));
                    }, e.keyBinding.addKeyboardHandler(a), e.on("changeSelection", l.destroy), e.on("changeSession", l.destroy), e.on("mouseup", l.destroy), e.on("change", l.destroy), e.session.widgetManager.addLineWidget(l), l.el.onmousedown = e.focus.bind(e), e.renderer.scrollCursorIntoView(null, .5, {
                        bottom: l.el.offsetHeight
                    });
                }, h.importCssString("\n    .error_widget_wrapper {\n        background: inherit;\n        color: inherit;\n        border:none\n    }\n    .error_widget {\n        border-top: solid 2px;\n        border-bottom: solid 2px;\n        margin: 5px 0;\n        padding: 10px 40px;\n        white-space: pre-wrap;\n    }\n    .error_widget.ace_error, .error_widget_arrow.ace_error{\n        border-color: #ff5a5a\n    }\n    .error_widget.ace_warning, .error_widget_arrow.ace_warning{\n        border-color: #F1D817\n    }\n    .error_widget.ace_info, .error_widget_arrow.ace_info{\n        border-color: #5a5a5a\n    }\n    .error_widget.ace_ok, .error_widget_arrow.ace_ok{\n        border-color: #5aaa5a\n    }\n    .error_widget_arrow {\n        position: absolute;\n        border: solid 5px;\n        border-top-color: transparent!important;\n        border-right-color: transparent!important;\n        border-left-color: transparent!important;\n        top: -5px;\n    }\n", "error_marker.css", !1);
            }), ace.define("ace/ace", [
                "require",
                "exports",
                "module",
                "ace/lib/dom",
                "ace/range",
                "ace/editor",
                "ace/edit_session",
                "ace/undomanager",
                "ace/virtual_renderer",
                "ace/worker/worker_client",
                "ace/keyboard/hash_handler",
                "ace/placeholder",
                "ace/multi_select",
                "ace/mode/folding/fold_mode",
                "ace/theme/textmate",
                "ace/ext/error_marker",
                "ace/config",
                "ace/loader_build"
            ], function(e, r, t) {
                e("./loader_build")(r);
                var s = e("./lib/dom"), i = e("./range").Range, a = e("./editor").Editor, n = e("./edit_session").EditSession, o = e("./undomanager").UndoManager, l = e("./virtual_renderer").VirtualRenderer, e = (e("./worker/worker_client"), e("./keyboard/hash_handler"), e("./placeholder"), e("./multi_select"), e("./mode/folding/fold_mode"), e("./theme/textmate"), e("./ext/error_marker"), r.config = e("./config"), r.edit = function(e, t) {
                    if ("string" == typeof e) {
                        var i = e;
                        if (!(e = document.getElementById(i))) throw new Error("ace.edit can't find div #" + i);
                    }
                    var n, o;
                    return e && e.env && e.env.editor instanceof a ? e.env.editor : (i = "", e && /input|textarea/i.test(e.tagName) ? (i = (n = e).value, e = s.createElement("pre"), n.parentNode.replaceChild(e, n)) : e && (i = e.textContent, e.innerHTML = ""), i = r.createEditSession(i), e = new a(new l(e), i, t), o = {
                        document: i,
                        editor: e,
                        onResize: e.resize.bind(e, null)
                    }, n && (o.textarea = n), e.on("destroy", function() {
                        o.editor.container.env = null;
                    }), e.container.env = e.env = o, e);
                }, r.createEditSession = function(e, t) {
                    e = new n(e, t);
                    return e.setUndoManager(new o), e;
                }, r.Range = i, r.Editor = a, r.EditSession = n, r.UndoManager = o, r.VirtualRenderer = l, r.config.version);
                r.version = e;
            }), ace.require([
                "ace/ace"
            ], function(e) {
                e && (e.config.init(!0), e.define = ace.define);
                var t, i = function() {
                    return this;
                }();
                for(t in (i = (i = i || "undefined" == typeof window ? i : window) || "undefined" == typeof self ? i : self).ace || (i.ace = e), e)e.hasOwnProperty(t) && (i.ace[t] = e[t]);
                i.ace.default = i.ace, n && (n.exports = i.ace);
            });
        },
        6489: function(t, e, i) {
            t = i.nmd(t), ace.define("ace/snippets", [
                "require",
                "exports",
                "module",
                "ace/lib/dom",
                "ace/lib/oop",
                "ace/lib/event_emitter",
                "ace/lib/lang",
                "ace/range",
                "ace/range_list",
                "ace/keyboard/hash_handler",
                "ace/tokenizer",
                "ace/clipboard",
                "ace/editor"
            ], function(e, s, t) {
                var i = e("./lib/dom"), n = e("./lib/oop"), o = e("./lib/event_emitter").EventEmitter, c = e("./lib/lang"), d = e("./range").Range, u = e("./range_list").RangeList, r = e("./keyboard/hash_handler").HashHandler, a = e("./tokenizer").Tokenizer, l = e("./clipboard"), h = {
                    CURRENT_WORD: function(e) {
                        return e.session.getTextRange(e.session.getWordRange());
                    },
                    SELECTION: function(e, t, i) {
                        e = e.session.getTextRange();
                        return i ? e.replace(/\n\r?([ \t]*\S)/g, "\n" + i + "$1") : e;
                    },
                    CURRENT_LINE: function(e) {
                        return e.session.getLine(e.getCursorPosition().row);
                    },
                    PREV_LINE: function(e) {
                        return e.session.getLine(e.getCursorPosition().row - 1);
                    },
                    LINE_INDEX: function(e) {
                        return e.getCursorPosition().row;
                    },
                    LINE_NUMBER: function(e) {
                        return e.getCursorPosition().row + 1;
                    },
                    SOFT_TABS: function(e) {
                        return e.session.getUseSoftTabs() ? "YES" : "NO";
                    },
                    TAB_SIZE: function(e) {
                        return e.session.getTabSize();
                    },
                    CLIPBOARD: function(e) {
                        return l.getText && l.getText();
                    },
                    FILENAME: function(e) {
                        return /[^/\\]*$/.exec(this.FILEPATH(e))[0];
                    },
                    FILENAME_BASE: function(e) {
                        return /[^/\\]*$/.exec(this.FILEPATH(e))[0].replace(/\.[^.]*$/, "");
                    },
                    DIRECTORY: function(e) {
                        return this.FILEPATH(e).replace(/[^/\\]*$/, "");
                    },
                    FILEPATH: function(e) {
                        return "/not implemented.txt";
                    },
                    WORKSPACE_NAME: function() {
                        return "Unknown";
                    },
                    FULLNAME: function() {
                        return "Unknown";
                    },
                    BLOCK_COMMENT_START: function(e) {
                        e = e.session.$mode || {};
                        return e.blockComment && e.blockComment.start || "";
                    },
                    BLOCK_COMMENT_END: function(e) {
                        e = e.session.$mode || {};
                        return e.blockComment && e.blockComment.end || "";
                    },
                    LINE_COMMENT: function(e) {
                        return (e.session.$mode || {}).lineCommentStart || "";
                    },
                    CURRENT_YEAR: g.bind(null, {
                        year: "numeric"
                    }),
                    CURRENT_YEAR_SHORT: g.bind(null, {
                        year: "2-digit"
                    }),
                    CURRENT_MONTH: g.bind(null, {
                        month: "numeric"
                    }),
                    CURRENT_MONTH_NAME: g.bind(null, {
                        month: "long"
                    }),
                    CURRENT_MONTH_NAME_SHORT: g.bind(null, {
                        month: "short"
                    }),
                    CURRENT_DATE: g.bind(null, {
                        day: "2-digit"
                    }),
                    CURRENT_DAY_NAME: g.bind(null, {
                        weekday: "long"
                    }),
                    CURRENT_DAY_NAME_SHORT: g.bind(null, {
                        weekday: "short"
                    }),
                    CURRENT_HOUR: g.bind(null, {
                        hour: "2-digit",
                        hour12: !1
                    }),
                    CURRENT_MINUTE: g.bind(null, {
                        minute: "2-digit"
                    }),
                    CURRENT_SECOND: g.bind(null, {
                        second: "2-digit"
                    })
                };
                function g(e) {
                    e = (new Date).toLocaleString("en-us", e);
                    return 1 == e.length ? "0" + e : e;
                }
                h.SELECTED_TEXT = h.SELECTION;
                m.prototype.getTokenizer = function() {
                    return m.$tokenizer || this.createTokenizer();
                }, m.prototype.createTokenizer = function() {
                    function n(e) {
                        return e = e.substr(1), /^\d+$/.test(e) ? [
                            {
                                tabstopId: parseInt(e, 10)
                            }
                        ] : [
                            {
                                text: e
                            }
                        ];
                    }
                    function e(e) {
                        return "(?:[^\\\\" + e + "]|\\\\.)";
                    }
                    var t = {
                        regex: "/(" + e("/") + "+)/",
                        onMatch: function(e, t, i) {
                            i = i[0];
                            return i.fmtString = !0, i.guard = e.slice(1, -1), i.flag = "";
                        },
                        next: "formatString"
                    };
                    return m.$tokenizer = new a({
                        start: [
                            {
                                regex: /\\./,
                                onMatch: function(e, t, i) {
                                    var n = e[1];
                                    return [
                                        e = "}" == n && i.length || -1 != "`$\\".indexOf(n) ? n : e
                                    ];
                                }
                            },
                            {
                                regex: /}/,
                                onMatch: function(e, t, i) {
                                    return [
                                        i.length ? i.shift() : e
                                    ];
                                }
                            },
                            {
                                regex: /\$(?:\d+|\w+)/,
                                onMatch: n
                            },
                            {
                                regex: /\$\{[\dA-Z_a-z]+/,
                                onMatch: function(e, t, i) {
                                    e = n(e.substr(1));
                                    return i.unshift(e[0]), e;
                                },
                                next: "snippetVar"
                            },
                            {
                                regex: /\n/,
                                token: "newline",
                                merge: !1
                            }
                        ],
                        snippetVar: [
                            {
                                regex: "\\|" + e("\\|") + "*\\|",
                                onMatch: function(e, t, i) {
                                    e = e.slice(1, -1).replace(/\\[,|\\]|,/g, function(e) {
                                        return 2 == e.length ? e[1] : "\0";
                                    }).split("\0").map(function(e) {
                                        return {
                                            value: e
                                        };
                                    });
                                    return [
                                        (i[0].choices = e)[0]
                                    ];
                                },
                                next: "start"
                            },
                            t,
                            {
                                regex: "([^:}\\\\]|\\\\.)*:?",
                                token: "",
                                next: "start"
                            }
                        ],
                        formatString: [
                            {
                                regex: /:/,
                                onMatch: function(e, t, i) {
                                    return i.length && i[0].expectElse ? (i[0].expectElse = !1, i[0].ifEnd = {
                                        elseEnd: i[0]
                                    }, [
                                        i[0].ifEnd
                                    ]) : ":";
                                }
                            },
                            {
                                regex: /\\./,
                                onMatch: function(e, t, i) {
                                    var n = e[1];
                                    return "}" == n && i.length || -1 != "`$\\".indexOf(n) ? e = n : "n" == n ? e = "\n" : "t" == n ? e = "\t" : -1 != "ulULE".indexOf(n) && (e = {
                                        changeCase: n,
                                        local: "a" < n
                                    }), [
                                        e
                                    ];
                                }
                            },
                            {
                                regex: "/\\w*}",
                                onMatch: function(e, t, i) {
                                    i = i.shift();
                                    return i && (i.flag = e.slice(1, -1)), this.next = i && i.tabstopId ? "start" : "", [
                                        i || e
                                    ];
                                },
                                next: "start"
                            },
                            {
                                regex: /\$(?:\d+|\w+)/,
                                onMatch: function(e, t, i) {
                                    return [
                                        {
                                            text: e.slice(1)
                                        }
                                    ];
                                }
                            },
                            {
                                regex: /\${\w+/,
                                onMatch: function(e, t, i) {
                                    e = {
                                        text: e.slice(2)
                                    };
                                    return i.unshift(e), [
                                        e
                                    ];
                                },
                                next: "formatStringVar"
                            },
                            {
                                regex: /\n/,
                                token: "newline",
                                merge: !1
                            },
                            {
                                regex: /}/,
                                onMatch: function(e, t, i) {
                                    i = i.shift();
                                    return this.next = i && i.tabstopId ? "start" : "", [
                                        i || e
                                    ];
                                },
                                next: "start"
                            }
                        ],
                        formatStringVar: [
                            {
                                regex: /:\/\w+}/,
                                onMatch: function(e, t, i) {
                                    return i[0].formatFunction = e.slice(2, -1), [
                                        i.shift()
                                    ];
                                },
                                next: "formatString"
                            },
                            t,
                            {
                                regex: /:[\?\-+]?/,
                                onMatch: function(e, t, i) {
                                    "+" == e[1] && (i[0].ifEnd = i[0]), "?" == e[1] && (i[0].expectElse = !0);
                                },
                                next: "formatString"
                            },
                            {
                                regex: "([^:}\\\\]|\\\\.)*:?",
                                token: "",
                                next: "formatString"
                            }
                        ]
                    });
                }, m.prototype.tokenizeTmSnippet = function(e, t) {
                    return this.getTokenizer().getLineTokens(e, t).tokens.map(function(e) {
                        return e.value || e;
                    });
                }, m.prototype.getVariableValue = function(e, t, i) {
                    var n;
                    return /^\d+$/.test(t) ? (this.variables.__ || {})[t] || "" : /^[A-Z]\d+$/.test(t) ? (this.variables[t[0] + "__"] || {})[t.substr(1)] || "" : (t = t.replace(/^TM_/, ""), !this.variables.hasOwnProperty(t) || null == (n = "function" == typeof (n = this.variables[t]) ? this.variables[t](e, t, i) : n) ? "" : n);
                }, m.prototype.tmStrFormat = function(e, t, s) {
                    var i, a, l;
                    return t.fmt ? (i = t.guard, i = new RegExp(i, (t.flag || "").replace(/[^gim]/g, "")), a = "string" == typeof t.fmt ? this.tokenizeTmSnippet(t.fmt, "formatString") : t.fmt, l = this, e.replace(i, function() {
                        for(var e = l.variables.__, t = (l.variables.__ = [].slice.call(arguments), l.resolveVariables(a, s)), i = "E", n = 0; n < t.length; n++){
                            var o, r = t[n];
                            "object" == typeof r ? (t[n] = "", r.changeCase && r.local ? (o = t[n + 1]) && "string" == typeof o && ("u" == r.changeCase ? t[n] = o[0].toUpperCase() : t[n] = o[0].toLowerCase(), t[n + 1] = o.substr(1)) : r.changeCase && (i = r.changeCase)) : "U" == i ? t[n] = r.toUpperCase() : "L" == i && (t[n] = r.toLowerCase());
                        }
                        return l.variables.__ = e, t.join("");
                    })) : e;
                }, m.prototype.tmFormatFunction = function(e, t, i) {
                    return "upcase" == t.formatFunction ? e.toUpperCase() : "downcase" == t.formatFunction ? e.toLowerCase() : e;
                }, m.prototype.resolveVariables = function(t, e) {
                    for(var i = [], n = "", o = !0, r = 0; r < t.length; r++){
                        var s, a = t[r];
                        "string" == typeof a ? (i.push(a), "\n" == a ? (o = !0, n = "") : o && (n = /^\t*/.exec(a)[0], o = /\S/.test(a))) : a && (o = !1, a.fmtString && (-1 == (s = t.indexOf(a, r + 1)) && (s = t.length), a.fmt = t.slice(r + 1, s), r = s), a.text ? (s = this.getVariableValue(e, a.text, n) + "", a.fmtString && (s = this.tmStrFormat(s, a, e)), (s = a.formatFunction ? this.tmFormatFunction(s, a, e) : s) && !a.ifEnd ? (i.push(s), l(a)) : !s && a.ifEnd && l(a.ifEnd)) : a.elseEnd ? l(a.elseEnd) : null == a.tabstopId && null == a.changeCase || i.push(a));
                    }
                    function l(e) {
                        e = t.indexOf(e, r + 1);
                        -1 != e && (r = e);
                    }
                    return i;
                }, m.prototype.getDisplayTextForSnippet = function(e, t) {
                    return f.call(this, e, t).text;
                }, m.prototype.insertSnippetForSelection = function(e, t, i) {
                    var t = f.call(this, e, t, i = void 0 === i ? {} : i), i = e.getSelectionRange(), n = e.session.replace(i, t.text), o = new C(e), e = e.inVirtualSelectionMode && e.selection.index;
                    o.addTabstops(t.tabstops, i.start, n, e);
                }, m.prototype.insertSnippet = function(e, t, i) {
                    void 0 === i && (i = {});
                    var n = this;
                    if (e.inVirtualSelectionMode) return n.insertSnippetForSelection(e, t, i);
                    e.forEachSelection(function() {
                        n.insertSnippetForSelection(e, t, i);
                    }, null, {
                        keepOrder: !0
                    }), e.tabstopManager && e.tabstopManager.tabNext();
                }, m.prototype.$getScope = function(e) {
                    var t, i = e.session.$mode.$id || "";
                    return "html" !== (i = i.split("/").pop()) && "php" !== i || ("php" !== i || e.session.$mode.inlinePhp || (i = "html"), t = e.getCursorPosition(), (e = "object" == typeof (e = e.session.getState(t.row)) ? e[0] : e).substring && ("js-" == e.substring(0, 3) ? i = "javascript" : "css-" == e.substring(0, 4) ? i = "css" : "php-" == e.substring(0, 4) && (i = "php"))), i;
                }, m.prototype.getActiveScopes = function(e) {
                    var e = this.$getScope(e), t = [
                        e
                    ], i = this.snippetMap;
                    return i[e] && i[e].includeScopes && t.push.apply(t, i[e].includeScopes), t.push("_"), t;
                }, m.prototype.expandWithTab = function(e, t) {
                    var i = this, n = e.forEachSelection(function() {
                        return i.expandSnippetForSelection(e, t);
                    }, null, {
                        keepOrder: !0
                    });
                    return n && e.tabstopManager && e.tabstopManager.tabNext(), n;
                }, m.prototype.expandSnippetForSelection = function(e, t) {
                    var i, n = e.getCursorPosition(), o = e.session.getLine(n.row), r = o.substring(0, n.column), s = o.substr(n.column), a = this.snippetMap;
                    return this.getActiveScopes(e).some(function(e) {
                        e = a[e];
                        return !!(i = e ? this.findMatchingSnippet(e, r, s) : i);
                    }, this), !!i && (t && t.dryRun || (e.session.doc.removeInLine(n.row, n.column - i.replaceBefore.length, n.column + i.replaceAfter.length), this.variables.M__ = i.matchBefore, this.variables.T__ = i.matchAfter, this.insertSnippetForSelection(e, i.content), this.variables.M__ = this.variables.T__ = null), !0);
                }, m.prototype.findMatchingSnippet = function(e, t, i) {
                    for(var n = e.length; n--;){
                        var o = e[n];
                        if ((!o.startRe || o.startRe.test(t)) && (!o.endRe || o.endRe.test(i)) && (o.startRe || o.endRe)) return o.matchBefore = o.startRe ? o.startRe.exec(t) : [
                            ""
                        ], o.matchAfter = o.endRe ? o.endRe.exec(i) : [
                            ""
                        ], o.replaceBefore = o.triggerRe ? o.triggerRe.exec(t)[0] : "", o.replaceAfter = o.endTriggerRe ? o.endTriggerRe.exec(i)[0] : "", o;
                    }
                }, m.prototype.register = function(t, n) {
                    var o = this.snippetMap, r = this.snippetNameMap, s = this;
                    function a(e) {
                        return (e = e && !/^\^?\(.*\)\$?$|^\\b$/.test(e) ? "(?:" + e + ")" : e) || "";
                    }
                    function l(e, t, i) {
                        return e = a(e), t = a(t), i ? (e = t + e) && "$" != e[e.length - 1] && (e += "$") : (e += t) && "^" != e[0] && (e = "^" + e), new RegExp(e);
                    }
                    function i(e) {
                        e.scope || (e.scope = n || "_"), o[n = e.scope] || (o[n] = [], r[n] = {});
                        var t, i = r[n];
                        e.name && ((t = i[e.name]) && s.unregister(t), i[e.name] = e), o[n].push(e), e.prefix && (e.tabTrigger = e.prefix), !e.content && e.body && (e.content = Array.isArray(e.body) ? e.body.join("\n") : e.body), e.tabTrigger && !e.trigger && (!e.guard && /^\w/.test(e.tabTrigger) && (e.guard = "\\b"), e.trigger = c.escapeRegExp(e.tabTrigger)), (e.trigger || e.guard || e.endTrigger || e.endGuard) && (e.startRe = l(e.trigger, e.guard, !0), e.triggerRe = new RegExp(e.trigger), e.endRe = l(e.endTrigger, e.endGuard, !0), e.endTriggerRe = new RegExp(e.endTrigger));
                    }
                    t = t || [], Array.isArray(t) ? t.forEach(i) : Object.keys(t).forEach(function(e) {
                        i(t[e]);
                    }), this._signal("registerSnippets", {
                        scope: n
                    });
                }, m.prototype.unregister = function(e, i) {
                    var n = this.snippetMap, o = this.snippetNameMap;
                    function t(e) {
                        var t = o[e.scope || i];
                        t && t[e.name] && (delete t[e.name], 0 <= (e = (t = n[e.scope || i]) && t.indexOf(e))) && t.splice(e, 1);
                    }
                    e.content ? t(e) : Array.isArray(e) && e.forEach(t);
                }, m.prototype.parseSnippetFile = function(e) {
                    e = e.replace(/\r/g, "");
                    for(var t, i, n, o = [], r = {}, s = /^#.*|^({[\s\S]*})\s*$|^(\S+) (.*)$|^((?:\n*\t.*)+)/gm; i = s.exec(e);){
                        if (i[1]) try {
                            r = JSON.parse(i[1]), o.push(r);
                        } catch (e) {}
                        i[4] ? (r.content = i[4].replace(/^\t/gm, ""), o.push(r), r = {}) : (t = i[2], i = i[3], "regex" == t ? (r.guard = (n = /\/((?:[^\/\\]|\\.)*)|$/g).exec(i)[1], r.trigger = n.exec(i)[1], r.endTrigger = n.exec(i)[1], r.endGuard = n.exec(i)[1]) : "snippet" == t ? (r.tabTrigger = i.match(/^\S*/)[0], r.name || (r.name = i)) : t && (r[t] = i));
                    }
                    return o;
                }, m.prototype.getSnippetByName = function(t, e) {
                    var i, n = this.snippetNameMap;
                    return this.getActiveScopes(e).some(function(e) {
                        e = n[e];
                        return !!(i = e ? e[t] : i);
                    }, this), i;
                };
                var p = m;
                function m() {
                    this.snippetMap = {}, this.snippetNameMap = {}, this.variables = h;
                }
                n.implement(p.prototype, o);
                var f = function(e, t, i) {
                    void 0 === i && (i = {});
                    var n = e.getCursorPosition(), o = e.session.getLine(n.row), r = e.session.getTabString(), s = o.match(/^\s*/)[0], a = (n.column < s.length && (s = s.slice(0, n.column)), t = t.replace(/\r/g, ""), this.tokenizeTmSnippet(t)), l = (a = (a = this.resolveVariables(a, e)).map(function(e) {
                        return "\n" != e || i.excludeExtraIndent ? "string" == typeof e ? e.replace(/\t/g, r) : e : e + s;
                    }), []), c = (a.forEach(function(e, t) {
                        var i, n, o;
                        "object" == typeof e && (o = e.tabstopId, (i = l[o]) || ((i = l[o] = []).index = o, i.value = "", i.parents = {}), -1 === i.indexOf(e)) && (e.choices && !i.choices && (i.choices = e.choices), i.push(e), -1 !== (n = a.indexOf(e, t + 1))) && ((o = a.slice(t + 1, n)).some(function(e) {
                            return "object" == typeof e;
                        }) && !i.value ? i.value = o : !o.length || i.value && "string" == typeof i.value || (i.value = o.join("")));
                    }), l.forEach(function(e) {
                        e.length = 0;
                    }), {});
                    for(var h = 0; h < a.length; h++){
                        var d, u, g, p = a[h];
                        "object" == typeof p && (g = p.tabstopId, d = l[g], u = a.indexOf(p, h + 1), c[g] ? c[g] === p && (delete c[g], Object.keys(c).forEach(function(e) {
                            d.parents[e] = !0;
                        })) : (c[g] = p, "string" != typeof (g = d.value) ? g = ((e)=>{
                            for(var t = [], i = 0; i < e.length; i++){
                                if ("object" == typeof (n = e[i])) {
                                    if (c[n.tabstopId]) continue;
                                    var n = t[e.lastIndexOf(n, i - 1)] || {
                                        tabstopId: n.tabstopId
                                    };
                                }
                                t[i] = n;
                            }
                            return t;
                        })(g) : p.fmt && (g = this.tmStrFormat(g, p, e)), a.splice.apply(a, [
                            h + 1,
                            Math.max(0, u - h)
                        ].concat(g, p)), -1 === d.indexOf(p) && d.push(p)));
                    }
                    var m = 0, f = 0, C = "";
                    return a.forEach(function(e) {
                        var t;
                        "string" == typeof e ? (1 < (t = e.split("\n")).length ? (f = t[t.length - 1].length, m += t.length - 1) : f += e.length, C += e) : e && (e.start ? e.end = {
                            row: m,
                            column: f
                        } : e.start = {
                            row: m,
                            column: f
                        });
                    }), {
                        text: C,
                        tabstops: l,
                        tokens: a
                    };
                }, C = (y.prototype.attach = function(e) {
                    this.$openTabstops = null, this.selectedTabstop = null, this.editor = e, this.session = e.session, this.editor.on("change", this.$onChange), this.editor.on("changeSelection", this.$onChangeSelection), this.editor.on("changeSession", this.$onChangeSession), this.editor.commands.on("afterExec", this.$onAfterExec), this.editor.keyBinding.addKeyboardHandler(this.keyboardHandler);
                }, y.prototype.detach = function() {
                    this.tabstops.forEach(this.removeTabstopMarkers, this), this.ranges.length = 0, this.tabstops.length = 0, this.selectedTabstop = null, this.editor.off("change", this.$onChange), this.editor.off("changeSelection", this.$onChangeSelection), this.editor.off("changeSession", this.$onChangeSession), this.editor.commands.off("afterExec", this.$onAfterExec), this.editor.keyBinding.removeKeyboardHandler(this.keyboardHandler), this.editor.tabstopManager = null, this.session = null, this.editor = null;
                }, y.prototype.onChange = function(e) {
                    for(var t = "r" == e.action[0], i = this.selectedTabstop || {}, n = i.parents || {}, o = this.tabstops.slice(), r = 0; r < o.length; r++){
                        var s = o[r], a = s == i || n[s.index];
                        if (s.rangeList.$bias = a ? 0 : 1, "remove" == e.action && s !== i) for(var a = s.parents && s.parents[i.index], l = (l = s.rangeList.pointIndex(e.start, a)) < 0 ? -l - 1 : l + 1, a = s.rangeList.pointIndex(e.end, a), c = s.rangeList.ranges.slice(l, a < 0 ? -a - 1 : a - 1), h = 0; h < c.length; h++)this.removeRange(c[h]);
                        s.rangeList.$onChange(e);
                    }
                    var d = this.session;
                    this.$inChange || !t || 1 != d.getLength() || d.getValue() || this.detach();
                }, y.prototype.updateLinkedFields = function() {
                    var e = this.selectedTabstop;
                    if (e && e.hasLinkedRanges && e.firstNonLinked) {
                        this.$inChange = !0;
                        for(var t = this.session, i = t.getTextRange(e.firstNonLinked), n = 0; n < e.length; n++){
                            var o, r = e[n];
                            r.linked && (o = s.snippetManager.tmStrFormat(i, r.original, this.editor), t.replace(r, o));
                        }
                        this.$inChange = !1;
                    }
                }, y.prototype.onAfterExec = function(e) {
                    e.command && !e.command.readOnly && this.updateLinkedFields();
                }, y.prototype.onChangeSelection = function() {
                    if (this.editor) {
                        for(var e = this.editor.selection.lead, t = this.editor.selection.anchor, i = this.editor.selection.isEmpty(), n = 0; n < this.ranges.length; n++)if (!this.ranges[n].linked) {
                            var o = this.ranges[n].contains(e.row, e.column), r = i || this.ranges[n].contains(t.row, t.column);
                            if (o && r) return;
                        }
                        this.detach();
                    }
                }, y.prototype.onChangeSession = function() {
                    this.detach();
                }, y.prototype.tabNext = function(e) {
                    var t = this.tabstops.length, e = this.index + (e || 1), e = Math.min(Math.max(e, 1), t);
                    this.selectTabstop(e = e == t ? 0 : e), this.updateTabstopMarkers(), 0 === e && this.detach();
                }, y.prototype.selectTabstop = function(e) {
                    this.$openTabstops = null;
                    var t = this.tabstops[this.index];
                    if (t && this.addTabstopMarkers(t), this.index = e, (t = this.tabstops[this.index]) && t.length) {
                        e = (this.selectedTabstop = t).firstNonLinked || t;
                        if (t.choices && (e.cursor = e.start), this.editor.inVirtualSelectionMode) this.editor.selection.fromOrientedRange(e);
                        else {
                            var i = this.editor.multiSelect;
                            i.toSingleRange(e);
                            for(var n = 0; n < t.length; n++)t.hasLinkedRanges && t[n].linked || i.addRange(t[n].clone(), !0);
                        }
                        this.editor.keyBinding.addKeyboardHandler(this.keyboardHandler), this.selectedTabstop && this.selectedTabstop.choices && this.editor.execCommand("startAutocomplete", {
                            matches: this.selectedTabstop.choices
                        });
                    }
                }, y.prototype.addTabstops = function(e, s, t) {
                    var a = this.useLink || !this.editor.getOption("enableMultiselect");
                    this.$openTabstops || (this.$openTabstops = []), e[0] || (t = d.fromPoints(t, t), I(t.start, s), I(t.end, s), e[0] = [
                        t
                    ], e[0].index = 0);
                    var l = [
                        this.index + 1,
                        0
                    ], c = this.ranges, h = this.snippetId = (this.snippetId || 0) + 1;
                    e.forEach(function(e, t) {
                        var i = this.$openTabstops[t] || e;
                        i.snippetId = h;
                        for(var n = 0; n < e.length; n++){
                            var o = e[n], r = d.fromPoints(o.start, o.end || o.start);
                            v(r.start, s), v(r.end, s), r.original = o, r.tabstop = i, c.push(r), i != e ? i.unshift(r) : i[n] = r, o.fmtString || i.firstNonLinked && a ? (r.linked = !0, i.hasLinkedRanges = !0) : i.firstNonLinked || (i.firstNonLinked = r);
                        }
                        i.firstNonLinked || (i.hasLinkedRanges = !1), i === e && (l.push(i), this.$openTabstops[t] = i), this.addTabstopMarkers(i), i.rangeList = i.rangeList || new u, i.rangeList.$bias = 0, i.rangeList.addList(i);
                    }, this), 2 < l.length && (this.tabstops.length && l.push(l.splice(2, 1)[0]), this.tabstops.splice.apply(this.tabstops, l));
                }, y.prototype.addTabstopMarkers = function(e) {
                    var t = this.session;
                    e.forEach(function(e) {
                        e.markerId || (e.markerId = t.addMarker(e, "ace_snippet-marker", "text"));
                    });
                }, y.prototype.removeTabstopMarkers = function(e) {
                    var t = this.session;
                    e.forEach(function(e) {
                        t.removeMarker(e.markerId), e.markerId = null;
                    });
                }, y.prototype.updateTabstopMarkers = function() {
                    var t;
                    this.selectedTabstop && (t = this.selectedTabstop.snippetId, 0 === this.selectedTabstop.index && t--, this.tabstops.forEach(function(e) {
                        e.snippetId === t ? this.addTabstopMarkers(e) : this.removeTabstopMarkers(e);
                    }, this));
                }, y.prototype.removeRange = function(e) {
                    var t = e.tabstop.indexOf(e);
                    -1 != t && e.tabstop.splice(t, 1), -1 != (t = this.ranges.indexOf(e)) && this.ranges.splice(t, 1), -1 != (t = e.tabstop.rangeList.ranges.indexOf(e)) && e.tabstop.splice(t, 1), this.session.removeMarker(e.markerId), e.tabstop.length || (-1 != (t = this.tabstops.indexOf(e.tabstop)) && this.tabstops.splice(t, 1), this.tabstops.length) || this.detach();
                }, y);
                function y(e) {
                    if (this.index = 0, this.ranges = [], this.tabstops = [], e.tabstopManager) return e.tabstopManager;
                    (e.tabstopManager = this).$onChange = this.onChange.bind(this), this.$onChangeSelection = c.delayedCall(this.onChangeSelection.bind(this)).schedule, this.$onChangeSession = this.onChangeSession.bind(this), this.$onAfterExec = this.onAfterExec.bind(this), this.attach(e);
                }
                C.prototype.keyboardHandler = new r, C.prototype.keyboardHandler.bindKeys({
                    Tab: function(e) {
                        s.snippetManager && s.snippetManager.expandWithTab(e) || (e.tabstopManager.tabNext(1), e.renderer.scrollCursorIntoView());
                    },
                    "Shift-Tab": function(e) {
                        e.tabstopManager.tabNext(-1), e.renderer.scrollCursorIntoView();
                    },
                    Esc: function(e) {
                        e.tabstopManager.detach();
                    }
                });
                var v = function(e, t) {
                    0 == e.row && (e.column += t.column), e.row += t.row;
                }, I = function(e, t) {
                    e.row == t.row && (e.column -= t.column), e.row -= t.row;
                }, n = (i.importCssString("\n.ace_snippet-marker {\n    -moz-box-sizing: border-box;\n    box-sizing: border-box;\n    background: rgba(194, 193, 208, 0.09);\n    border: 1px dotted rgba(211, 208, 235, 0.62);\n    position: absolute;\n}", "snippets.css", !1), s.snippetManager = new p, e("./editor").Editor);
                (function() {
                    this.insertSnippet = function(e, t) {
                        return s.snippetManager.insertSnippet(this, e, t);
                    }, this.expandSnippet = function(e) {
                        return s.snippetManager.expandWithTab(this, e);
                    };
                }).call(n.prototype);
            }), ace.define("ace/autocomplete/popup", [
                "require",
                "exports",
                "module",
                "ace/virtual_renderer",
                "ace/editor",
                "ace/range",
                "ace/lib/event",
                "ace/lib/lang",
                "ace/lib/dom",
                "ace/config",
                "ace/lib/useragent"
            ], function(e, t, i) {
                function a(e) {
                    return "suggest-aria-id:".concat(e);
                }
                function l(e) {
                    return (e = new o(e)).$maxLines = 4, (e = new r(e)).setHighlightActiveLine(!1), e.setShowPrintMargin(!1), e.renderer.setShowGutter(!1), e.renderer.setHighlightGutterLine(!1), e.$mouseHandler.$focusTimeout = 0, e.$highlightTagPending = !0, e;
                }
                function n(e) {
                    function t() {}
                    function i() {
                        s(-1);
                    }
                    var g, n = m.createElement("div"), p = l(n), o = (e && e.appendChild(n), n.style.display = "none", p.renderer.content.style.cursor = "default", p.renderer.setStyle("ace_autocomplete"), p.renderer.$textLayer.element.setAttribute("role", f), p.renderer.$textLayer.element.setAttribute("aria-roledescription", u("autocomplete.popup.aria-roledescription", "Autocomplete suggestions")), p.renderer.$textLayer.element.setAttribute("aria-label", u("autocomplete.popup.aria-label", "Autocomplete suggestions")), p.renderer.textarea.setAttribute("aria-hidden", "true"), p.setOption("displayIndentGuides", !1), p.setOption("dragDelay", 150), p.focus = t, p.$isFocused = !0, p.renderer.$cursorLayer.restartTimer = t, p.renderer.$cursorLayer.element.style.opacity = "0", p.renderer.$maxLines = 8, p.renderer.$keepTextAreaAtCursor = !1, p.setHighlightActiveLine(!1), p.session.highlight(""), p.session.$searchHighlight.clazz = "ace_highlight-marker", p.on("mousedown", function(e) {
                        var t = e.getDocumentPosition();
                        p.selection.moveToPosition(t), r.start.row = r.end.row = t.row, e.stop();
                    }), new c(-1, 0, -1, 1 / 0)), r = new c(-1, 0, -1, 1 / 0), s = (r.id = p.session.addMarker(r, "ace_active-line", "fullLine"), p.setSelectOnHover = function(e) {
                        e ? o.id && (p.session.removeMarker(o.id), o.id = null) : o.id = p.session.addMarker(o, "ace_line-hover", "fullLine");
                    }, p.setSelectOnHover(!1), p.on("mousemove", function(e) {
                        var t;
                        g ? g.x == e.x && g.y == e.y || ((g = e).scrollTop = p.renderer.scrollTop, p.isMouseOver = !0, t = g.getDocumentPosition().row, o.start.row != t && (o.id || p.setRow(t), s(t))) : g = e;
                    }), p.renderer.on("beforeRender", function() {
                        var e;
                        g && -1 != o.start.row && (g.$pos = null, e = g.getDocumentPosition().row, o.id || p.setRow(e), s(e, !0));
                    }), p.renderer.on("afterRender", function() {
                        for(var e = p.renderer.$textLayer, t = e.config.firstRow, i = e.config.lastRow; t <= i; t++){
                            var n = e.element.childNodes[t - e.config.firstRow], o = (n.setAttribute("role", C), n.setAttribute("aria-roledescription", u("autocomplete.popup.item.aria-roledescription", "item")), n.setAttribute("aria-setsize", p.data.length), n.setAttribute("aria-describedby", "doc-tooltip"), n.setAttribute("aria-posinset", t + 1), p.getData(t));
                            o && (o = "".concat(o.caption || o.value).concat(o.meta ? ", ".concat(o.meta) : ""), n.setAttribute("aria-label", o)), n.querySelectorAll(".ace_completion-highlight").forEach(function(e) {
                                e.setAttribute("role", "mark");
                            });
                        }
                    }), p.renderer.on("afterRender", function() {
                        var e = p.getRow(), t = p.renderer.$textLayer, i = t.element.childNodes[e - t.config.firstRow], n = document.activeElement;
                        i !== p.selectedNode && p.selectedNode && (m.removeCssClass(p.selectedNode, "ace_selected"), p.selectedNode.removeAttribute(y), p.selectedNode.removeAttribute("id")), n.removeAttribute("aria-activedescendant"), (p.selectedNode = i) && (e = a(e), m.addCssClass(i, "ace_selected"), i.id = e, t.element.setAttribute("aria-activedescendant", e), n.setAttribute("aria-activedescendant", e), i.setAttribute(y, "true"));
                    }), function(e, t) {
                        e !== o.start.row && (o.start.row = o.end.row = e, t || p.session._emit("changeBackMarker"), p._emit("changeHoverMarker"));
                    });
                    return p.getHoveredRow = function() {
                        return o.start.row;
                    }, h.addListener(p.container, "mouseout", function() {
                        p.isMouseOver = !1, i();
                    }), p.on("hide", i), p.on("changeSelection", i), p.session.doc.getLength = function() {
                        return p.data.length;
                    }, p.session.doc.getLine = function(e) {
                        e = p.data[e];
                        return "string" == typeof e ? e : e && e.value || "";
                    }, (e = p.session.bgTokenizer).$tokenizeRow = function(e) {
                        var i = p.data[e], n = [];
                        if (i) {
                            for(var t, o, r = (i = "string" == typeof i ? {
                                value: i
                            } : i).caption || i.value || i.name, s = r.toLowerCase(), a = (p.filterText || "").toLowerCase(), l = 0, c = 0, h = 0; h <= a.length; h++)h != c && (i.matchMask & 1 << h || h == a.length) && (t = a.slice(c, h), c = h, -1 != (o = s.indexOf(t, l))) && (d(r.slice(l, o), ""), l = o + t.length, d(r.slice(o, l), "completion-highlight"));
                            d(r.slice(l, r.length), ""), n.push({
                                type: "completion-spacer",
                                value: " "
                            }), i.meta && n.push({
                                type: "completion-meta",
                                value: i.meta
                            }), i.message && n.push({
                                type: "completion-message",
                                value: i.message
                            });
                        }
                        return n;
                        function d(e, t) {
                            e && n.push({
                                type: (i.className || "") + (t || ""),
                                value: e
                            });
                        }
                    }, e.$updateOnChange = t, e.start = t, p.session.$computeWidth = function() {
                        return this.screenWidth = 0;
                    }, p.isOpen = !1, p.isTopdown = !1, p.autoSelect = !0, p.filterText = "", p.isMouseOver = !1, p.data = [], p.setData = function(e, t) {
                        p.filterText = t || "", p.setValue(d.stringRepeat("\n", e.length), -1), p.data = e || [], p.setRow(0);
                    }, p.getData = function(e) {
                        return p.data[e];
                    }, p.getRow = function() {
                        return r.start.row;
                    }, p.setRow = function(e) {
                        e = Math.max(this.autoSelect ? 0 : -1, Math.min(this.data.length - 1, e)), r.start.row != e && (p.selection.clearSelection(), r.start.row = r.end.row = e || 0, p.session._emit("changeBackMarker"), p.moveCursorTo(e || 0, 0), p.isOpen) && p._signal("select");
                    }, p.on("changeSelection", function() {
                        p.isOpen && p.setRow(p.selection.lead.row), p.renderer.scrollCursorIntoView();
                    }), p.hide = function() {
                        this.container.style.display = "none", p.anchorPos = null, p.anchor = null, p.isOpen && (p.isOpen = !1, this._signal("hide"));
                    }, p.tryShow = function(e, t, i, n) {
                        if (n || !p.isOpen || !p.anchorPos || !p.anchor || p.anchorPos.top !== e.top || p.anchorPos.left !== e.left || p.anchor !== i) {
                            var o = this.container, r = this.renderer.scrollBar.width || 10, s = window.innerHeight - r, a = window.innerWidth - r, l = this.renderer, c = l.$maxLines * t * 1.4, h = {
                                top: 0,
                                bottom: 0,
                                left: 0
                            }, d = s - e.top - 3 * this.$borderSize - t, u = e.top - 3 * this.$borderSize, t = ("top" === (i = i || (u <= d || c <= d ? "bottom" : "top")) ? (h.bottom = e.top - this.$borderSize, h.top = h.bottom - c) : "bottom" === i && (h.top = e.top + t + this.$borderSize, h.bottom = h.top + c), 0 <= h.top && h.bottom <= s);
                            if (!n && !t) return !1;
                            l.$maxPixelHeight = t ? null : "top" === i ? u : d, "top" === i ? (o.style.top = "", o.style.bottom = s + r - h.bottom + "px", p.isTopdown = !1) : (o.style.top = h.top + "px", o.style.bottom = "", p.isTopdown = !0), o.style.display = "";
                            c = e.left;
                            a < c + o.offsetWidth && (c = a - o.offsetWidth), o.style.left = c + "px", o.style.right = "", m.$fixPositionBug(o), p.isOpen || (p.isOpen = !0, this._signal("show"), g = null), p.anchorPos = e, p.anchor = i;
                        }
                        return !0;
                    }, p.show = function(e, t, i) {
                        this.tryShow(e, t, i ? "bottom" : void 0, !0);
                    }, p.goTo = function(e) {
                        var t = this.getRow(), i = this.session.getLength() - 1;
                        switch(e){
                            case "up":
                                t = t <= 0 ? i : t - 1;
                                break;
                            case "down":
                                t = i <= t ? -1 : t + 1;
                                break;
                            case "start":
                                t = 0;
                                break;
                            case "end":
                                t = i;
                        }
                        this.setRow(t);
                    }, p.getTextLeftOffset = function() {
                        return this.$borderSize + this.renderer.$padding + this.$imageSize;
                    }, p.$imageSize = 0, p.$borderSize = 1, p;
                }
                var o = e("../virtual_renderer").VirtualRenderer, r = e("../editor").Editor, c = e("../range").Range, h = e("../lib/event"), d = e("../lib/lang"), m = e("../lib/dom"), u = e("../config").nls, e = e("./../lib/useragent"), f = e.isSafari ? "menu" : "listbox", C = e.isSafari ? "menuitem" : "option", y = e.isSafari ? "aria-current" : "aria-selected";
                m.importCssString('\n.ace_editor.ace_autocomplete .ace_marker-layer .ace_active-line {\n    background-color: #CAD6FA;\n    z-index: 1;\n}\n.ace_dark.ace_editor.ace_autocomplete .ace_marker-layer .ace_active-line {\n    background-color: #3a674e;\n}\n.ace_editor.ace_autocomplete .ace_line-hover {\n    border: 1px solid #abbffe;\n    margin-top: -1px;\n    background: rgba(233,233,253,0.4);\n    position: absolute;\n    z-index: 2;\n}\n.ace_dark.ace_editor.ace_autocomplete .ace_line-hover {\n    border: 1px solid rgba(109, 150, 13, 0.8);\n    background: rgba(58, 103, 78, 0.62);\n}\n.ace_completion-meta {\n    opacity: 0.5;\n    margin-left: 0.9em;\n}\n.ace_completion-message {\n    margin-left: 0.9em;\n    color: blue;\n}\n.ace_editor.ace_autocomplete .ace_completion-highlight{\n    color: #2d69c7;\n}\n.ace_dark.ace_editor.ace_autocomplete .ace_completion-highlight{\n    color: #93ca12;\n}\n.ace_editor.ace_autocomplete {\n    width: 300px;\n    z-index: 200000;\n    border: 1px lightgray solid;\n    position: fixed;\n    box-shadow: 2px 3px 5px rgba(0,0,0,.2);\n    line-height: 1.4;\n    background: #fefefe;\n    color: #111;\n}\n.ace_dark.ace_editor.ace_autocomplete {\n    border: 1px #484747 solid;\n    box-shadow: 2px 3px 5px rgba(0, 0, 0, 0.51);\n    line-height: 1.4;\n    background: #25282c;\n    color: #c1c1c1;\n}\n.ace_autocomplete .ace_text-layer  {\n    width: calc(100% - 8px);\n}\n.ace_autocomplete .ace_line {\n    display: flex;\n    align-items: center;\n}\n.ace_autocomplete .ace_line > * {\n    min-width: 0;\n    flex: 0 0 auto;\n}\n.ace_autocomplete .ace_line .ace_ {\n    flex: 0 1 auto;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n.ace_autocomplete .ace_completion-spacer {\n    flex: 1;\n}\n.ace_autocomplete.ace_loading:after  {\n    content: "";\n    position: absolute;\n    top: 0px;\n    height: 2px;\n    width: 8%;\n    background: blue;\n    z-index: 100;\n    animation: ace_progress 3s infinite linear;\n    animation-delay: 300ms;\n    transform: translateX(-100%) scaleX(1);\n}\n@keyframes ace_progress {\n    0% { transform: translateX(-100%) scaleX(1) }\n    50% { transform: translateX(625%) scaleX(2) } \n    100% { transform: translateX(1500%) scaleX(3) } \n}\n@media (prefers-reduced-motion) {\n    .ace_autocomplete.ace_loading:after {\n        transform: translateX(625%) scaleX(2);\n        animation: none;\n     }\n}\n', "autocompletion.css", !1), t.AcePopup = n, t.$singleLineEditor = l, t.getAriaId = a;
            }), ace.define("ace/autocomplete/inline_screenreader", [
                "require",
                "exports",
                "module"
            ], function(e, t, i) {
                function n(e) {
                    this.editor = e, this.screenReaderDiv = document.createElement("div"), this.screenReaderDiv.classList.add("ace_screenreader-only"), this.editor.container.appendChild(this.screenReaderDiv);
                }
                n.prototype.setScreenReaderContent = function(e) {
                    for(!this.popup && this.editor.completer && this.editor.completer.popup && (this.popup = this.editor.completer.popup, this.popup.renderer.on("afterRender", (function() {
                        var e = this.popup.getRow(), t = this.popup.renderer.$textLayer, e = t.element.childNodes[e - t.config.firstRow];
                        if (e) {
                            for(var i = "doc-tooltip ", n = 0; n < this._lines.length; n++)i += "ace-inline-screenreader-line-".concat(n, " ");
                            e.setAttribute("aria-describedby", i);
                        }
                    }).bind(this))); this.screenReaderDiv.firstChild;)this.screenReaderDiv.removeChild(this.screenReaderDiv.firstChild);
                    this._lines = e.split(/\r\n|\r|\n/);
                    e = this.createCodeBlock();
                    this.screenReaderDiv.appendChild(e);
                }, n.prototype.destroy = function() {
                    this.screenReaderDiv.remove();
                }, n.prototype.createCodeBlock = function() {
                    var e = document.createElement("pre");
                    e.setAttribute("id", "ace-inline-screenreader");
                    for(var t = 0; t < this._lines.length; t++){
                        var i = document.createElement("code"), n = (i.setAttribute("id", "ace-inline-screenreader-line-".concat(t)), document.createTextNode(this._lines[t]));
                        i.appendChild(n), e.appendChild(i);
                    }
                    return e;
                }, t.AceInlineScreenReader = n;
            }), ace.define("ace/autocomplete/inline", [
                "require",
                "exports",
                "module",
                "ace/snippets",
                "ace/autocomplete/inline_screenreader"
            ], function(e, t, i) {
                var o = e("../snippets").snippetManager, r = e("./inline_screenreader").AceInlineScreenReader;
                function n() {
                    this.editor = null;
                }
                n.prototype.show = function(e, t, i) {
                    if (i = i || "", e && this.editor && this.editor !== e && (this.hide(), this.editor = null, this.inlineScreenReader = null), !e || !t) return !1;
                    this.inlineScreenReader || (this.inlineScreenReader = new r(e));
                    var n = t.snippet ? o.getDisplayTextForSnippet(e, t.snippet) : t.value;
                    return !(t.hideInlinePreview || !n || !n.startsWith(i) || (this.editor = e, this.inlineScreenReader.setScreenReaderContent(n), "" === (n = n.slice(i.length)) ? e.removeGhostText() : e.setGhostText(n), 0));
                }, n.prototype.isOpen = function() {
                    return !!this.editor && !!this.editor.renderer.$ghostText;
                }, n.prototype.hide = function() {
                    return !!this.editor && (this.editor.removeGhostText(), !0);
                }, n.prototype.destroy = function() {
                    this.hide(), this.editor = null, this.inlineScreenReader && (this.inlineScreenReader.destroy(), this.inlineScreenReader = null);
                }, t.AceInline = n;
            }), ace.define("ace/autocomplete/util", [
                "require",
                "exports",
                "module"
            ], function(e, t, i) {
                t.parForEach = function(e, t, i) {
                    var n = 0, o = e.length;
                    0 === o && i();
                    for(var r = 0; r < o; r++)t(e[r], function(e, t) {
                        ++n === o && i(e, t);
                    });
                };
                var r = /[a-zA-Z_0-9\$\-\u00A2-\u2000\u2070-\uFFFF]/;
                t.retrievePrecedingIdentifier = function(e, t, i) {
                    i = i || r;
                    for(var n = [], o = t - 1; 0 <= o && i.test(e[o]); o--)n.push(e[o]);
                    return n.reverse().join("");
                }, t.retrieveFollowingIdentifier = function(e, t, i) {
                    i = i || r;
                    for(var n = [], o = t; o < e.length && i.test(e[o]); o++)n.push(e[o]);
                    return n;
                }, t.getCompletionPrefix = function(e) {
                    var t, i = e.getCursorPosition(), n = e.session.getLine(i.row);
                    return e.completers.forEach((function(e) {
                        e.identifierRegexps && e.identifierRegexps.forEach((function(e) {
                            !t && e && (t = this.retrievePrecedingIdentifier(n, i.column, e));
                        }).bind(this));
                    }).bind(this)), t || this.retrievePrecedingIdentifier(n, i.column);
                }, t.triggerAutocomplete = function(e, t) {
                    t = null == t ? e.session.getPrecedingCharacter() : t;
                    return e.completers.some(function(e) {
                        if (e.triggerCharacters && Array.isArray(e.triggerCharacters)) return e.triggerCharacters.includes(t);
                    });
                };
            }), ace.define("ace/autocomplete", [
                "require",
                "exports",
                "module",
                "ace/keyboard/hash_handler",
                "ace/autocomplete/popup",
                "ace/autocomplete/inline",
                "ace/autocomplete/popup",
                "ace/autocomplete/util",
                "ace/lib/lang",
                "ace/lib/dom",
                "ace/snippets",
                "ace/config",
                "ace/lib/event",
                "ace/lib/scroll"
            ], function(e, t, i) {
                function n(e, t) {
                    t.completer && t.completer.destroy();
                }
                var o = e("./keyboard/hash_handler").HashHandler, r = e("./autocomplete/popup").AcePopup, s = e("./autocomplete/inline").AceInline, a = e("./autocomplete/popup").getAriaId, c = e("./autocomplete/util"), l = e("./lib/lang"), h = e("./lib/dom"), d = e("./snippets").snippetManager, u = e("./config"), g = e("./lib/event"), p = e("./lib/scroll").preventParentScroll, m = (Object.defineProperty(f, "completionsForLoading", {
                    get: function() {
                        return [
                            {
                                caption: u.nls("autocomplete.loading", "Loading..."),
                                value: ""
                            }
                        ];
                    },
                    enumerable: !1,
                    configurable: !0
                }), f.prototype.$init = function() {
                    return this.popup = new r(this.parentNode || document.body || document.documentElement), this.popup.on("click", (function(e) {
                        this.insertMatch(), e.stop();
                    }).bind(this)), this.popup.focus = this.editor.focus.bind(this.editor), this.popup.on("show", this.$onPopupShow.bind(this)), this.popup.on("hide", this.$onHidePopup.bind(this)), this.popup.on("select", this.$onPopupChange.bind(this)), g.addListener(this.popup.container, "mouseout", this.mouseOutListener.bind(this)), this.popup.on("changeHoverMarker", this.tooltipTimer.bind(null, null)), this.popup.renderer.on("afterRender", this.$onPopupRender.bind(this)), this.popup;
                }, f.prototype.$initInline = function() {
                    if (this.inlineEnabled && !this.inlineRenderer) return this.inlineRenderer = new s, this.inlineRenderer;
                }, f.prototype.getPopup = function() {
                    return this.popup || this.$init();
                }, f.prototype.$onHidePopup = function() {
                    this.inlineRenderer && this.inlineRenderer.hide(), this.hideDocTooltip(), this.stickySelectionTimer.cancel(), this.popupTimer.cancel(), this.stickySelection = !1;
                }, f.prototype.$seen = function(e) {
                    !this.hasSeen.has(e) && e && e.completer && e.completer.onSeen && "function" == typeof e.completer.onSeen && (e.completer.onSeen(this.editor, e), this.hasSeen.add(e));
                }, f.prototype.$onPopupChange = function(e) {
                    this.inlineRenderer && this.inlineEnabled ? (e = e ? null : this.popup.getData(this.popup.getRow()), this.$updateGhostText(e), this.popup.isMouseOver && this.setSelectOnHover ? this.tooltipTimer.call(null, null) : (this.popupTimer.schedule(), this.tooltipTimer.schedule())) : (this.popupTimer.call(null, null), this.tooltipTimer.call(null, null));
                }, f.prototype.$updateGhostText = function(e) {
                    var t = this.base.row, i = this.base.column, n = this.editor.getCursorPosition().column, t = this.editor.session.getLine(t).slice(i, n);
                    this.inlineRenderer.show(this.editor, e, t) ? this.$seen(e) : this.inlineRenderer.hide();
                }, f.prototype.$onPopupRender = function() {
                    var e = this.inlineRenderer && this.inlineEnabled;
                    if (this.completions && this.completions.filtered && 0 < this.completions.filtered.length) for(var t = this.popup.getFirstVisibleRow(); t <= this.popup.getLastVisibleRow(); t++){
                        var i = this.popup.getData(t);
                        !i || e && !i.hideInlinePreview || this.$seen(i);
                    }
                }, f.prototype.$onPopupShow = function(e) {
                    this.$onPopupChange(e), this.stickySelection = !1, 0 <= this.stickySelectionDelay && this.stickySelectionTimer.schedule(this.stickySelectionDelay);
                }, f.prototype.observeLayoutChanges = function() {
                    if (!this.$elements && this.editor) {
                        window.addEventListener("resize", this.onLayoutChange, {
                            passive: !0
                        }), window.addEventListener("wheel", this.mousewheelListener);
                        for(var e = this.editor.container.parentNode, t = []; e;)t.push(e), e.addEventListener("scroll", this.onLayoutChange, {
                            passive: !0
                        }), e = e.parentNode;
                        this.$elements = t;
                    }
                }, f.prototype.unObserveLayoutChanges = function() {
                    var t = this;
                    window.removeEventListener("resize", this.onLayoutChange, {
                        passive: !0
                    }), window.removeEventListener("wheel", this.mousewheelListener), this.$elements && this.$elements.forEach(function(e) {
                        e.removeEventListener("scroll", t.onLayoutChange, {
                            passive: !0
                        });
                    }), this.$elements = null;
                }, f.prototype.onLayoutChange = function() {
                    if (!this.popup.isOpen) return this.unObserveLayoutChanges();
                    this.$updatePopupPosition(), this.updateDocTooltip();
                }, f.prototype.$updatePopupPosition = function() {
                    var e = this.editor, t = e.renderer, i = t.layerConfig.lineHeight, n = t.$cursorLayer.getPixelPosition(this.base, !0), o = (n.left -= this.popup.getTextLeftOffset(), e.container.getBoundingClientRect()), o = (n.top += o.top - t.layerConfig.offset, n.left += o.left - e.renderer.scrollLeft, n.left += t.gutterWidth, {
                        top: n.top,
                        left: n.left
                    }), t = (t.$ghostText && t.$ghostTextWidget && this.base.row === t.$ghostText.position.row && (o.top += t.$ghostTextWidget.el.offsetHeight), e.container.getBoundingClientRect().bottom - i);
                    this.popup.tryShow(t < o.top ? {
                        top: t,
                        left: o.left
                    } : o, i, "bottom") || this.popup.tryShow(n, i, "top") || this.popup.show(n, i);
                }, f.prototype.openPopup = function(e, t, i) {
                    this.$firstOpenTimer.cancel(), this.popup || this.$init(), this.inlineEnabled && !this.inlineRenderer && this.$initInline(), this.popup.autoSelect = this.autoSelect, this.popup.setSelectOnHover(this.setSelectOnHover);
                    var n, o = this.popup.getRow(), r = this.popup.data[o], r = (this.popup.setData(this.completions.filtered, this.completions.filterText), this.editor.textInput.setAriaOptions && this.editor.textInput.setAriaOptions({
                        activeDescendant: a(this.popup.getRow()),
                        inline: this.inlineEnabled
                    }), e.keyBinding.addKeyboardHandler(this.keyboardHandler), (n = this.stickySelection ? this.popup.data.indexOf(r) : n) && -1 !== n || (n = 0), this.popup.setRow(this.autoSelect ? n : -1), n === o && r !== this.completions.filtered[n] && this.$onPopupChange(), this.inlineRenderer && this.inlineEnabled);
                    n === o && r && (n = this.popup.getData(this.popup.getRow()), this.$updateGhostText(n)), i || (this.popup.setTheme(e.getTheme()), this.popup.setFontSize(e.getFontSize()), this.$updatePopupPosition(), this.tooltipNode && this.updateDocTooltip()), this.changeTimer.cancel(), this.observeLayoutChanges();
                }, f.prototype.detach = function() {
                    this.editor && (this.editor.keyBinding.removeKeyboardHandler(this.keyboardHandler), this.editor.off("changeSelection", this.changeListener), this.editor.off("blur", this.blurListener), this.editor.off("mousedown", this.mousedownListener), this.editor.off("mousewheel", this.mousewheelListener)), this.$firstOpenTimer.cancel(), this.changeTimer.cancel(), this.hideDocTooltip(), this.completionProvider && this.completionProvider.detach(), this.popup && this.popup.isOpen && this.popup.hide(), this.popup && this.popup.renderer && this.popup.renderer.off("afterRender", this.$onPopupRender), this.base && this.base.detach(), this.activated = !1, this.completionProvider = this.completions = this.base = null, this.unObserveLayoutChanges();
                }, f.prototype.changeListener = function(e) {
                    var t = this.editor.selection.lead;
                    (t.row != this.base.row || t.column < this.base.column) && this.detach(), this.activated ? this.changeTimer.schedule() : this.detach();
                }, f.prototype.blurListener = function(e) {
                    var t = document.activeElement, i = this.editor.textInput.getElement(), n = e.relatedTarget && this.tooltipNode && this.tooltipNode.contains(e.relatedTarget), o = this.popup && this.popup.container;
                    t == i || t.parentNode == o || n || t == this.tooltipNode || e.relatedTarget == i || this.detach();
                }, f.prototype.mousedownListener = function(e) {
                    this.detach();
                }, f.prototype.mousewheelListener = function(e) {
                    this.popup && !this.popup.isMouseOver && this.detach();
                }, f.prototype.mouseOutListener = function(e) {
                    this.popup.isOpen && this.$updatePopupPosition();
                }, f.prototype.goTo = function(e) {
                    this.popup.goTo(e);
                }, f.prototype.insertMatch = function(e, t) {
                    var i;
                    return !!(e = e || this.popup.getData(this.popup.getRow())) && ("" === e.value ? this.detach() : (i = this.completions, e = this.getCompletionProvider().insertMatch(this.editor, e, i.filterText, t), this.completions == i && this.detach(), e));
                }, f.prototype.showPopup = function(e, t) {
                    this.editor && this.detach(), this.activated = !0, (this.editor = e).completer != this && (e.completer && e.completer.detach(), e.completer = this), e.on("changeSelection", this.changeListener), e.on("blur", this.blurListener), e.on("mousedown", this.mousedownListener), e.on("mousewheel", this.mousewheelListener), this.updateCompletions(!1, t);
                }, f.prototype.getCompletionProvider = function(e) {
                    return this.completionProvider || (this.completionProvider = new C(e)), this.completionProvider;
                }, f.prototype.gatherCompletions = function(e, t) {
                    return this.getCompletionProvider().gatherCompletions(e, t);
                }, f.prototype.updateCompletions = function(s, e) {
                    var t, i;
                    return s && this.base && this.completions ? (t = this.editor.getCursorPosition(), (i = this.editor.session.getTextRange({
                        start: this.base,
                        end: t
                    })) == this.completions.filterText ? void 0 : (this.completions.setFilter(i), this.completions.filtered.length && (1 != this.completions.filtered.length || this.completions.filtered[0].value != i || this.completions.filtered[0].snippet) ? void this.openPopup(this.editor, i, s) : this.detach())) : e && e.matches ? (t = this.editor.getSelectionRange().start, this.base = this.editor.session.doc.createAnchor(t.row, t.column), this.base.$insertRight = !0, this.completions = new v(e.matches), this.getCompletionProvider().completions = this.completions, this.openPopup(this.editor, "", s)) : (e = this.editor.getSession(), t = this.editor.getCursorPosition(), i = c.getCompletionPrefix(this.editor), this.base = e.doc.createAnchor(t.row, t.column - i.length), this.base.$insertRight = !0, e = {
                        exactMatch: this.exactMatch,
                        ignoreCaption: this.ignoreCaption
                    }, this.getCompletionProvider({
                        prefix: i,
                        pos: t
                    }).provideCompletions(this.editor, e, (function(e, t, i) {
                        var n, o = t.filtered, r = c.getCompletionPrefix(this.editor);
                        if (this.$firstOpenTimer.cancel(), i) {
                            if (!o.length) return (n = "function" == typeof (n = !this.autoShown && this.emptyMessage) ? this.emptyMessage(r) : n) ? (this.completions = new v([
                                {
                                    caption: n,
                                    value: ""
                                }
                            ]), this.openPopup(this.editor, r, s), this.popup.renderer.setStyle("ace_loading", !1), void this.popup.renderer.setStyle("ace_empty-message", !0)) : this.detach();
                            if (1 == o.length && o[0].value == r && !o[0].snippet) return this.detach();
                            if (this.autoInsert && !this.autoShown && 1 == o.length) return this.insertMatch(o[0]);
                        }
                        this.completions = !i && this.showLoadingState ? new v(f.completionsForLoading.concat(o), t.filterText) : t, this.openPopup(this.editor, r, s), this.popup.renderer.setStyle("ace_empty-message", !1), this.popup.renderer.setStyle("ace_loading", !i);
                    }).bind(this)), void (!this.showLoadingState || this.autoShown || this.popup && this.popup.isOpen || this.$firstOpenTimer.delay(this.stickySelectionDelay / 2)));
                }, f.prototype.cancelContextMenu = function() {
                    this.editor.$mouseHandler.cancelContextMenu();
                }, f.prototype.updateDocTooltip = function() {
                    var e = this.popup, t = this.completions && this.completions.filtered, i = t && (t[e.getHoveredRow()] || t[e.getRow()]), n = null;
                    if (!i || !this.editor || !this.popup.isOpen) return this.hideDocTooltip();
                    for(var o = this.editor.completers.length, r = 0; r < o; r++){
                        var s = this.editor.completers[r];
                        if (s.getDocTooltip && i.completerId === s.id) {
                            n = s.getDocTooltip(i);
                            break;
                        }
                    }
                    if (!(n = "string" == typeof (n = n || "string" == typeof i ? n : i) ? {
                        docText: n
                    } : n) || !n.docHTML && !n.docText) return this.hideDocTooltip();
                    this.showDocTooltip(n);
                }, f.prototype.showDocTooltip = function(e) {
                    this.tooltipNode || (this.tooltipNode = h.createElement("div"), this.tooltipNode.style.margin = "0", this.tooltipNode.style.pointerEvents = "auto", this.tooltipNode.style.overscrollBehavior = "contain", this.tooltipNode.tabIndex = -1, this.tooltipNode.onblur = this.blurListener.bind(this), this.tooltipNode.onclick = this.onTooltipClick.bind(this), this.tooltipNode.id = "doc-tooltip", this.tooltipNode.setAttribute("role", "tooltip"), this.tooltipNode.addEventListener("wheel", p));
                    var t = this.editor.renderer.theme, t = (this.tooltipNode.className = "ace_tooltip ace_doc-tooltip " + (t.isDark ? "ace_dark " : "") + (t.cssClass || ""), this.tooltipNode), e = (e.docHTML ? t.innerHTML = e.docHTML : e.docText && (t.textContent = e.docText), t.parentNode || this.popup.container.appendChild(this.tooltipNode), this.popup), i = e.container.getBoundingClientRect(), n = e.renderer.scrollBar.width || 10, o = i.left, r = window.innerWidth - i.right - n, s = e.isTopdown ? window.innerHeight - n - i.bottom : i.top, r = [
                        Math.min(r / 400, 1),
                        Math.min(o / 400, 1),
                        .9 * Math.min(s / 300, 1)
                    ], o = Math.max.apply(Math, r), s = t.style;
                    s.display = "block", o == r[0] || 1 <= r[0] ? (s.left = i.right + 1 + "px", s.right = "", s.maxWidth = 400 * o + "px", s.top = i.top + "px", s.bottom = "", s.maxHeight = Math.min(window.innerHeight - n - i.top, 300) + "px") : o == r[1] || 1 <= r[1] ? (s.right = window.innerWidth - i.left + "px", s.left = "", s.maxWidth = 400 * o + "px", s.top = i.top + "px", s.bottom = "", s.maxHeight = Math.min(window.innerHeight - n - i.top, 300) + "px") : o == r[2] && (s.left = i.left + "px", s.right = "", s.maxWidth = Math.min(400, window.innerWidth - i.left) + "px", e.isTopdown ? (s.top = i.bottom + "px", s.bottom = "", s.maxHeight = Math.min(window.innerHeight - n - i.bottom, 300) + "px") : (s.top = "", s.bottom = window.innerHeight - i.top + "px", s.maxHeight = Math.min(i.top, 300) + "px")), h.$fixPositionBug(t);
                }, f.prototype.hideDocTooltip = function() {
                    var e;
                    this.tooltipTimer.cancel(), this.tooltipNode && (e = this.tooltipNode, this.editor.isFocused() || document.activeElement != e || this.editor.focus(), this.tooltipNode = null, e.parentNode) && e.parentNode.removeChild(e);
                }, f.prototype.onTooltipClick = function(e) {
                    for(var t = e.target; t && t != this.tooltipNode;){
                        if ("A" == t.nodeName && t.href) {
                            t.rel = "noreferrer", t.target = "_blank";
                            break;
                        }
                        t = t.parentNode;
                    }
                }, f.prototype.destroy = function() {
                    var e;
                    this.detach(), this.popup && (this.popup.destroy(), e = this.popup.container) && e.parentNode && e.parentNode.removeChild(e), this.editor && this.editor.completer == this && (this.editor.off("destroy", n), this.editor.completer = null), this.inlineRenderer = this.popup = this.editor = null;
                }, f.for = function(e) {
                    return e.completer instanceof f || (e.completer && (e.completer.destroy(), e.completer = null), u.get("sharedPopups") ? (f.$sharedInstance || (f.$sharedInstance = new f), e.completer = f.$sharedInstance) : (e.completer = new f, e.once("destroy", n))), e.completer;
                }, f);
                function f() {
                    this.autoInsert = !1, this.autoSelect = !0, this.autoShown = !1, this.exactMatch = !1, this.inlineEnabled = !1, this.keyboardHandler = new o, this.keyboardHandler.bindKeys(this.commands), this.parentNode = null, this.setSelectOnHover = !1, this.hasSeen = new Set, this.showLoadingState = !1, this.stickySelectionDelay = 500, this.blurListener = this.blurListener.bind(this), this.changeListener = this.changeListener.bind(this), this.mousedownListener = this.mousedownListener.bind(this), this.mousewheelListener = this.mousewheelListener.bind(this), this.onLayoutChange = this.onLayoutChange.bind(this), this.changeTimer = l.delayedCall((function() {
                        this.updateCompletions(!0);
                    }).bind(this)), this.tooltipTimer = l.delayedCall(this.updateDocTooltip.bind(this), 50), this.popupTimer = l.delayedCall(this.$updatePopupPosition.bind(this), 50), this.stickySelectionTimer = l.delayedCall((function() {
                        this.stickySelection = !0;
                    }).bind(this), this.stickySelectionDelay), this.$firstOpenTimer = l.delayedCall((function() {
                        var e = this.completionProvider && this.completionProvider.initialPosition;
                        this.autoShown || this.popup && this.popup.isOpen || !e || 0 === this.editor.completers.length || (this.completions = new v(f.completionsForLoading), this.openPopup(this.editor, e.prefix, !1), this.popup.renderer.setStyle("ace_loading", !0));
                    }).bind(this), this.stickySelectionDelay);
                }
                m.prototype.commands = {
                    Up: function(e) {
                        e.completer.goTo("up");
                    },
                    Down: function(e) {
                        e.completer.goTo("down");
                    },
                    "Ctrl-Up|Ctrl-Home": function(e) {
                        e.completer.goTo("start");
                    },
                    "Ctrl-Down|Ctrl-End": function(e) {
                        e.completer.goTo("end");
                    },
                    Esc: function(e) {
                        e.completer.detach();
                    },
                    Return: function(e) {
                        return e.completer.insertMatch();
                    },
                    "Shift-Return": function(e) {
                        e.completer.insertMatch(null, {
                            deleteSuffix: !0
                        });
                    },
                    Tab: function(e) {
                        var t = e.completer.insertMatch();
                        if (t || e.tabstopManager) return t;
                        e.completer.goTo("down");
                    },
                    Backspace: function(e) {
                        e.execCommand("backspace"), !c.getCompletionPrefix(e) && e.completer && e.completer.detach();
                    },
                    PageUp: function(e) {
                        e.completer.popup.gotoPageUp();
                    },
                    PageDown: function(e) {
                        e.completer.popup.gotoPageDown();
                    }
                }, m.startCommand = {
                    name: "startAutocomplete",
                    exec: function(e, t) {
                        var i = m.for(e);
                        i.autoInsert = !1, i.autoSelect = !0, i.autoShown = !1, i.showPopup(e, t), i.cancelContextMenu();
                    },
                    bindKey: "Ctrl-Space|Ctrl-Shift-Space|Alt-Space"
                };
                y.prototype.insertByIndex = function(e, t, i) {
                    return !(!this.completions || !this.completions.filtered) && this.insertMatch(e, this.completions.filtered[t], i);
                }, y.prototype.insertMatch = function(e, t, i) {
                    if (!t) return !1;
                    if (e.startOperation({
                        command: {
                            name: "insertMatch"
                        }
                    }), t.completer && t.completer.insertMatch) t.completer.insertMatch(e, t);
                    else {
                        if (!this.completions) return !1;
                        var n = this.completions.filterText.length, o = 0;
                        if (t.range && t.range.start.row === t.range.end.row && (n = (n -= this.initialPosition.prefix.length) + (this.initialPosition.pos.column - t.range.start.column), o += t.range.end.column - this.initialPosition.pos.column), n || o) for(var r, s = e.selection.getAllRanges ? e.selection.getAllRanges() : [
                            e.getSelectionRange()
                        ], a = 0; r = s[a]; a++)r.start.column -= n, r.end.column += o, e.session.remove(r);
                        t.snippet ? d.insertSnippet(e, t.snippet) : this.$insertString(e, t), t.completer && t.completer.onInsert && "function" == typeof t.completer.onInsert && t.completer.onInsert(e, t), t.command && "startAutocomplete" === t.command && e.execCommand(t.command);
                    }
                    return e.endOperation(), !0;
                }, y.prototype.$insertString = function(e, t) {
                    t = t.value || t;
                    e.execCommand("insertstring", t);
                }, y.prototype.gatherCompletions = function(n, o) {
                    var t = n.getSession(), r = n.getCursorPosition(), s = c.getCompletionPrefix(n), a = [], l = (this.completers = n.completers, n.completers.length);
                    return n.completers.forEach(function(i, e) {
                        i.getCompletions(n, t, r, s, function(e, t) {
                            i.hideInlinePreview && (t = t.map(function(e) {
                                return Object.assign(e, {
                                    hideInlinePreview: i.hideInlinePreview
                                });
                            })), !e && t && (a = a.concat(t)), o(null, {
                                prefix: c.getCompletionPrefix(n),
                                matches: a,
                                finished: 0 == --l
                            });
                        });
                    }), !0;
                }, y.prototype.provideCompletions = function(e, i, n) {
                    var o = (function(e) {
                        var t = e.prefix;
                        this.completions = new v(e.matches), i.exactMatch && (this.completions.exactMatch = !0), i.ignoreCaption && (this.completions.ignoreCaption = !0), this.completions.setFilter(t), (e.finished || this.completions.filtered.length) && n(null, this.completions, e.finished);
                    }).bind(this), r = !0, s = null;
                    this.gatherCompletions(e, (function(e, t) {
                        this.active && (e && (n(e, [], !0), this.detach()), 0 === t.prefix.indexOf(t.prefix)) && (r ? s = t : o(t));
                    }).bind(this)), r = !1, s && (e = s, s = null, o(e));
                }, y.prototype.detach = function() {
                    this.active = !1, this.completers && this.completers.forEach(function(e) {
                        "function" == typeof e.cancel && e.cancel();
                    });
                };
                var C = y;
                function y(e) {
                    this.initialPosition = e, this.active = !0;
                }
                I.prototype.setFilter = function(e) {
                    t = e.length > this.filterText && 0 === e.lastIndexOf(this.filterText, 0) ? this.filtered : this.all, this.filterText = e, t = (t = this.filterCompletions(t, this.filterText)).sort(function(e, t) {
                        return t.exactMatch - e.exactMatch || t.$score - e.$score || (e.caption || e.value).localeCompare(t.caption || t.value);
                    });
                    var t, i = null;
                    t = t.filter(function(e) {
                        e = e.snippet || e.caption || e.value;
                        return e !== i && (i = e, !0);
                    }), this.filtered = t;
                }, I.prototype.filterCompletions = function(e, t) {
                    var i = [], n = t.toUpperCase(), o = t.toLowerCase();
                    e: for(var r, s = 0; r = e[s]; s++)if (r.skipFilter) r.$score = r.score, i.push(r);
                    else {
                        var a = !this.ignoreCaption && r.caption || r.value || r.snippet;
                        if (a) {
                            var l = -1, c = 0, h = 0;
                            if (this.exactMatch) {
                                if (t !== a.substr(0, t.length)) continue;
                            } else {
                                var d = a.toLowerCase().indexOf(o);
                                if (-1 < d) h = d;
                                else for(var u = 0; u < t.length; u++){
                                    var g = a.indexOf(o[u], l + 1), p = a.indexOf(n[u], l + 1);
                                    if ((g = 0 <= g && (p < 0 || g < p) ? g : p) < 0) continue e;
                                    0 < (p = g - l - 1) && (-1 === l && (h += 10), h += p, c |= 1 << u), l = g;
                                }
                            }
                            r.matchMask = c, r.exactMatch = h ? 0 : 1, r.$score = (r.score || 0) - h, i.push(r);
                        }
                    }
                    return i;
                };
                var v = I;
                function I(e, t) {
                    this.all = e, this.filtered = e, this.filterText = t || "", this.exactMatch = !1, this.ignoreCaption = !1;
                }
                t.Autocomplete = m, t.CompletionProvider = C, t.FilteredList = v;
            }), ace.define("ace/marker_group", [
                "require",
                "exports",
                "module"
            ], function(e, t, i) {
                o.prototype.getMarkerAtPosition = function(t) {
                    return this.markers.find(function(e) {
                        return e.range.contains(t.row, t.column);
                    });
                }, o.prototype.markersComparator = function(e, t) {
                    return e.range.start.row - t.range.start.row;
                }, o.prototype.setMarkers = function(e) {
                    this.markers = e.sort(this.markersComparator).slice(0, this.MAX_MARKERS), this.session._signal("changeBackMarker");
                }, o.prototype.update = function(e, t, i, n) {
                    if (this.markers && this.markers.length) for(var o, r = n.firstRow, s = n.lastRow, a = 0, l = 0, c = 0; c < this.markers.length; c++){
                        var h, d, u = this.markers[c];
                        u.range.end.row < r || u.range.start.row > s || (u.range.start.row === l ? a++ : (l = u.range.start.row, a = 0), 200 < a) || (h = u.range.clipRows(r, s)).start.row === h.end.row && h.start.column === h.end.column || ((d = h.toScreenRange(i)).isEmpty() ? (o = i.getNextFoldLine(h.end.row, o)) && o.end.row > h.end.row && (r = o.end.row) : "fullLine" === this.markerType ? t.drawFullLineMarker(e, d, u.className, n) : d.isMultiLine() ? "line" === this.markerType ? t.drawMultiLineMarker(e, d, u.className, n) : t.drawTextMarker(e, d, u.className, n) : t.drawSingleLineMarker(e, d, u.className + " ace_br15", n));
                    }
                };
                var n = o;
                function o(e, t) {
                    t && (this.markerType = t.markerType), this.markers = [], (this.session = e).addDynamicMarker(this);
                }
                n.prototype.MAX_MARKERS = 1e4, t.MarkerGroup = n;
            }), ace.define("ace/autocomplete/text_completer", [
                "require",
                "exports",
                "module",
                "ace/range"
            ], function(e, t, i) {
                var s = e("../range").Range, a = /[^a-zA-Z_0-9\$\-\u00C0-\u1FFF\u2C00-\uD7FF\w]+/;
                function l(e, t) {
                    var i = e.getTextRange(s.fromPoints({
                        row: 0,
                        column: 0
                    }, t)).split(a).length - 1, n = e.getValue().split(a), o = Object.create(null), r = n[i];
                    return n.forEach(function(e, t) {
                        e && e !== r && (t = Math.abs(i - t), t = n.length - t, o[e] ? o[e] = Math.max(t, o[e]) : o[e] = t);
                    }), o;
                }
                t.id = "textCompleter", t.getCompletions = function(e, t, i, n, o) {
                    var r = l(t, i);
                    o(null, Object.keys(r).map(function(e) {
                        return {
                            caption: e,
                            value: e,
                            score: r[e],
                            meta: "local"
                        };
                    }));
                };
            }), ace.define("ace/ext/language_tools", [
                "require",
                "exports",
                "module",
                "ace/snippets",
                "ace/autocomplete",
                "ace/config",
                "ace/lib/lang",
                "ace/autocomplete/util",
                "ace/marker_group",
                "ace/autocomplete/text_completer",
                "ace/editor",
                "ace/config"
            ], function(e, t, i) {
                function n(e, t) {
                    C(t.session.$mode);
                }
                function o(e) {
                    var t = e.editor, i = t.completer && t.completer.activated;
                    "backspace" === e.command.name ? i && !h.getCompletionPrefix(t) && t.completer.detach() : "insertstring" !== e.command.name || i || ((t = (r = e).editor.$liveAutocompletionDelay) ? v.delay(t) : I(e));
                }
                var r, l = e("../snippets").snippetManager, s = e("../autocomplete").Autocomplete, a = e("../config"), c = e("../lib/lang"), h = e("../autocomplete/util"), d = e("../marker_group").MarkerGroup, u = e("../autocomplete/text_completer"), g = {
                    getCompletions: function(e, t, i, n, o) {
                        if (t.$mode.completer) return t.$mode.completer.getCompletions(e, t, i, n, o);
                        e = e.session.getState(i.row);
                        o(null, t.$mode.getCompletions(e, t, i, n).map(function(e) {
                            return e.completerId = g.id, e;
                        }));
                    },
                    id: "keywordCompleter"
                }, p = {
                    getCompletions: function(e, t, i, n, o) {
                        var r = [], t = t.getTokenAt(i.row, i.column), s = (t && t.type.match(/(tag-name|tag-open|tag-whitespace|attribute-name|attribute-value)\.xml$/) ? r.push("html-tag") : r = l.getActiveScopes(e), l.snippetMap), a = [];
                        r.forEach(function(e) {
                            for(var t = s[e] || [], i = t.length; i--;){
                                var n = t[i], o = n.name || n.tabTrigger;
                                o && a.push({
                                    caption: o,
                                    snippet: n.content,
                                    meta: n.tabTrigger && !n.name ? n.tabTrigger + "\u21E5 " : "snippet",
                                    completerId: p.id
                                });
                            }
                        }, this), o(null, a);
                    },
                    getDocTooltip: function(e) {
                        var o;
                        e.snippet && !e.docHTML && (e.docHTML = [
                            "<b>",
                            c.escapeHTML(e.caption),
                            "</b>",
                            "<hr></hr>",
                            c.escapeHTML((e = e.snippet, o = {}, e.replace(/\${(\d+)(:(.*?))?}/g, function(e, t, i, n) {
                                return o[t] = n || "";
                            }).replace(/\$(\d+?)/g, function(e, t) {
                                return o[t];
                            })))
                        ].join(""));
                    },
                    id: "snippetCompleter"
                }, m = [
                    p,
                    u,
                    g
                ], f = (t.setCompleters = function(e) {
                    m.length = 0, e && m.push.apply(m, e);
                }, t.addCompleter = function(e) {
                    m.push(e);
                }, t.textCompleter = u, t.keyWordCompleter = g, t.snippetCompleter = p, {
                    name: "expandSnippet",
                    exec: function(e) {
                        return l.expandWithTab(e);
                    },
                    bindKey: "Tab"
                }), C = function(e) {
                    (e = "string" == typeof e ? a.$modes[e] : e) && (l.files || (l.files = {}), y(e.$id, e.snippetFileId), e.modes) && e.modes.forEach(C);
                }, y = function(t, e) {
                    e && t && !l.files[t] && (l.files[t] = {}, a.loadModule(e, function(e) {
                        e && (!(l.files[t] = e).snippets && e.snippetText && (e.snippets = l.parseSnippetFile(e.snippetText)), l.register(e.snippets || [], e.scope), e.includeScopes) && (l.snippetMap[e.scope].includeScopes = e.includeScopes, e.includeScopes.forEach(function(e) {
                            C("ace/mode/" + e);
                        }));
                    }));
                }, v = c.delayedCall(function() {
                    I(r);
                }, 0), I = function(e) {
                    var t = e.editor, i = h.getCompletionPrefix(t), e = e.args, e = h.triggerAutocomplete(t, e);
                    (i && i.length >= t.$liveAutocompletionThreshold || e) && ((i = s.for(t)).autoShown = !0, i.showPopup(t));
                }, u = e("../editor").Editor;
                e("../config").defineOptions(u.prototype, "editor", {
                    enableBasicAutocompletion: {
                        set: function(e) {
                            e ? (s.for(this), this.completers || (this.completers = Array.isArray(e) ? e : m), this.commands.addCommand(s.startCommand)) : this.commands.removeCommand(s.startCommand);
                        },
                        value: !1
                    },
                    enableLiveAutocompletion: {
                        set: function(e) {
                            e ? (this.completers || (this.completers = Array.isArray(e) ? e : m), this.commands.on("afterExec", o)) : this.commands.off("afterExec", o);
                        },
                        value: !1
                    },
                    liveAutocompletionDelay: {
                        initialValue: 0
                    },
                    liveAutocompletionThreshold: {
                        initialValue: 0
                    },
                    enableSnippets: {
                        set: function(e) {
                            e ? (this.commands.addCommand(f), this.on("changeMode", n), n(0, this)) : (this.commands.removeCommand(f), this.off("changeMode", n));
                        },
                        value: !1
                    }
                }), t.MarkerGroup = d;
            }), ace.require([
                "ace/ext/language_tools"
            ], function(e) {
                t && (t.exports = e);
            });
        },
        6534: function(t, e, i) {
            t = i.nmd(t), ace.define("ace/ext/searchbox-css", [
                "require",
                "exports",
                "module"
            ], function(e, t, i) {
                i.exports = '\n\n/* ------------------------------------------------------------------------------------------\n * Editor Search Form\n * --------------------------------------------------------------------------------------- */\n.ace_search {\n    background-color: #ddd;\n    color: #666;\n    border: 1px solid #cbcbcb;\n    border-top: 0 none;\n    overflow: hidden;\n    margin: 0;\n    padding: 4px 6px 0 4px;\n    position: absolute;\n    top: 0;\n    z-index: 99;\n    white-space: normal;\n}\n.ace_search.left {\n    border-left: 0 none;\n    border-radius: 0px 0px 5px 0px;\n    left: 0;\n}\n.ace_search.right {\n    border-radius: 0px 0px 0px 5px;\n    border-right: 0 none;\n    right: 0;\n}\n\n.ace_search_form, .ace_replace_form {\n    margin: 0 20px 4px 0;\n    overflow: hidden;\n    line-height: 1.9;\n}\n.ace_replace_form {\n    margin-right: 0;\n}\n.ace_search_form.ace_nomatch {\n    outline: 1px solid red;\n}\n\n.ace_search_field {\n    border-radius: 3px 0 0 3px;\n    background-color: white;\n    color: black;\n    border: 1px solid #cbcbcb;\n    border-right: 0 none;\n    outline: 0;\n    padding: 0;\n    font-size: inherit;\n    margin: 0;\n    line-height: inherit;\n    padding: 0 6px;\n    min-width: 17em;\n    vertical-align: top;\n    min-height: 1.8em;\n    box-sizing: content-box;\n}\n.ace_searchbtn {\n    border: 1px solid #cbcbcb;\n    line-height: inherit;\n    display: inline-block;\n    padding: 0 6px;\n    background: #fff;\n    border-right: 0 none;\n    border-left: 1px solid #dcdcdc;\n    cursor: pointer;\n    margin: 0;\n    position: relative;\n    color: #666;\n}\n.ace_searchbtn:last-child {\n    border-radius: 0 3px 3px 0;\n    border-right: 1px solid #cbcbcb;\n}\n.ace_searchbtn:disabled {\n    background: none;\n    cursor: default;\n}\n.ace_searchbtn:hover {\n    background-color: #eef1f6;\n}\n.ace_searchbtn.prev, .ace_searchbtn.next {\n     padding: 0px 0.7em\n}\n.ace_searchbtn.prev:after, .ace_searchbtn.next:after {\n     content: "";\n     border: solid 2px #888;\n     width: 0.5em;\n     height: 0.5em;\n     border-width:  2px 0 0 2px;\n     display:inline-block;\n     transform: rotate(-45deg);\n}\n.ace_searchbtn.next:after {\n     border-width: 0 2px 2px 0 ;\n}\n.ace_searchbtn_close {\n    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAcCAYAAABRVo5BAAAAZ0lEQVR42u2SUQrAMAhDvazn8OjZBilCkYVVxiis8H4CT0VrAJb4WHT3C5xU2a2IQZXJjiQIRMdkEoJ5Q2yMqpfDIo+XY4k6h+YXOyKqTIj5REaxloNAd0xiKmAtsTHqW8sR2W5f7gCu5nWFUpVjZwAAAABJRU5ErkJggg==) no-repeat 50% 0;\n    border-radius: 50%;\n    border: 0 none;\n    color: #656565;\n    cursor: pointer;\n    font: 16px/16px Arial;\n    padding: 0;\n    height: 14px;\n    width: 14px;\n    top: 9px;\n    right: 7px;\n    position: absolute;\n}\n.ace_searchbtn_close:hover {\n    background-color: #656565;\n    background-position: 50% 100%;\n    color: white;\n}\n\n.ace_button {\n    margin-left: 2px;\n    cursor: pointer;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -o-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    overflow: hidden;\n    opacity: 0.7;\n    border: 1px solid rgba(100,100,100,0.23);\n    padding: 1px;\n    box-sizing:    border-box!important;\n    color: black;\n}\n\n.ace_button:hover {\n    background-color: #eee;\n    opacity:1;\n}\n.ace_button:active {\n    background-color: #ddd;\n}\n\n.ace_button.checked {\n    border-color: #3399ff;\n    opacity:1;\n}\n\n.ace_search_options{\n    margin-bottom: 3px;\n    text-align: right;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -o-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    clear: both;\n}\n\n.ace_search_counter {\n    float: left;\n    font-family: arial;\n    padding: 0 8px;\n}';
            }), ace.define("ace/ext/searchbox", [
                "require",
                "exports",
                "module",
                "ace/ext/searchbox",
                "ace/ext/searchbox",
                "ace/lib/dom",
                "ace/lib/lang",
                "ace/lib/event",
                "ace/ext/searchbox-css",
                "ace/keyboard/hash_handler",
                "ace/lib/keys",
                "ace/config"
            ], function(e, t, i) {
                var n = e("../lib/dom"), c = e("../lib/lang"), o = e("../lib/event"), r = e("./searchbox-css"), s = e("../keyboard/hash_handler").HashHandler, a = e("../lib/keys"), h = e("../config").nls, l = (n.importCssString(r, "ace_searchbox", !1), d.prototype.setEditor = function(e) {
                    e.searchBox = this, e.renderer.scroller.appendChild(this.element), this.editor = e;
                }, d.prototype.setSession = function(e) {
                    this.searchRange = null, this.$syncOptions(!0);
                }, d.prototype.onEditorInput = function() {
                    this.find(!1, !1, !0);
                }, d.prototype.$initElements = function(e) {
                    this.searchBox = e.querySelector(".ace_search_form"), this.replaceBox = e.querySelector(".ace_replace_form"), this.searchOption = e.querySelector("[action=searchInSelection]"), this.replaceOption = e.querySelector("[action=toggleReplace]"), this.regExpOption = e.querySelector("[action=toggleRegexpMode]"), this.caseSensitiveOption = e.querySelector("[action=toggleCaseSensitive]"), this.wholeWordOption = e.querySelector("[action=toggleWholeWords]"), this.searchInput = this.searchBox.querySelector(".ace_search_field"), this.replaceInput = this.replaceBox.querySelector(".ace_search_field"), this.searchCounter = e.querySelector(".ace_search_counter");
                }, d.prototype.$init = function() {
                    var e = this.element, n = (this.$initElements(e), this);
                    o.addListener(e, "mousedown", function(e) {
                        setTimeout(function() {
                            n.activeInput.focus();
                        }, 0), o.stopPropagation(e);
                    }), o.addListener(e, "click", function(e) {
                        var t = (e.target || e.srcElement).getAttribute("action");
                        t && n[t] ? n[t]() : n.$searchBarKb.commands[t] && n.$searchBarKb.commands[t].exec(n), o.stopPropagation(e);
                    }), o.addCommandKeyListener(e, function(e, t, i) {
                        i = a.keyCodeToString(i), t = n.$searchBarKb.findKeyCommand(t, i);
                        t && t.exec && (t.exec(n), o.stopEvent(e));
                    }), this.$onChange = c.delayedCall(function() {
                        n.find(!1, !1);
                    }), o.addListener(this.searchInput, "input", function() {
                        n.$onChange.schedule(20);
                    }), o.addListener(this.searchInput, "focus", function() {
                        n.activeInput = n.searchInput, n.searchInput.value && n.highlight();
                    }), o.addListener(this.replaceInput, "focus", function() {
                        n.activeInput = n.replaceInput, n.searchInput.value && n.highlight();
                    });
                }, d.prototype.setSearchRange = function(e) {
                    (this.searchRange = e) ? this.searchRangeMarker = this.editor.session.addMarker(e, "ace_active-line") : this.searchRangeMarker && (this.editor.session.removeMarker(this.searchRangeMarker), this.searchRangeMarker = null);
                }, d.prototype.$syncOptions = function(e) {
                    n.setCssClass(this.replaceOption, "checked", this.searchRange), n.setCssClass(this.searchOption, "checked", this.searchOption.checked), this.replaceOption.textContent = this.replaceOption.checked ? "-" : "+", n.setCssClass(this.regExpOption, "checked", this.regExpOption.checked), n.setCssClass(this.wholeWordOption, "checked", this.wholeWordOption.checked), n.setCssClass(this.caseSensitiveOption, "checked", this.caseSensitiveOption.checked);
                    var t = this.editor.getReadOnly();
                    this.replaceOption.style.display = t ? "none" : "", this.replaceBox.style.display = this.replaceOption.checked && !t ? "" : "none", this.find(!1, !1, e);
                }, d.prototype.highlight = function(e) {
                    this.editor.session.highlight(e || this.editor.$search.$options.re), this.editor.renderer.updateBackMarkers();
                }, d.prototype.find = function(e, t, i) {
                    this.editor.session && (e = !this.editor.find(this.searchInput.value, {
                        skipCurrent: e,
                        backwards: t,
                        wrap: !0,
                        regExp: this.regExpOption.checked,
                        caseSensitive: this.caseSensitiveOption.checked,
                        wholeWord: this.wholeWordOption.checked,
                        preventScroll: i,
                        range: this.searchRange
                    }) && this.searchInput.value, n.setCssClass(this.searchBox, "ace_nomatch", e), this.editor._emit("findSearchBox", {
                        match: !e
                    }), this.highlight(), this.updateCounter());
                }, d.prototype.updateCounter = function() {
                    var e = this.editor, t = e.$search.$options.re, i = t.unicode, n = 0, o = 0;
                    if (t) {
                        var r, s, a = this.searchRange ? e.session.getTextRange(this.searchRange) : e.getValue(), l = (e.$search.$isMultilineSearch(e.getLastSearchOptions()) && (a = a.replace(/\r\n|\r|\n/g, "\n"), e.session.doc.$autoNewLine = "\n"), e.session.doc.positionToIndex(e.selection.anchor));
                        for(this.searchRange && (l -= e.session.doc.positionToIndex(this.searchRange.start)), t.lastIndex = 0; (s = t.exec(a)) && ((r = s.index) <= l && o++, !(999 < ++n)) && (s[0] || (t.lastIndex = r += c.skipEmptyMatch(a, r, i), !(r >= a.length))););
                    }
                    this.searchCounter.textContent = h("search-box.search-counter", "$0 of $1", [
                        o,
                        999 < n ? "999+" : n
                    ]);
                }, d.prototype.findNext = function() {
                    this.find(!0, !1);
                }, d.prototype.findPrev = function() {
                    this.find(!0, !0);
                }, d.prototype.findAll = function() {
                    var e = !this.editor.findAll(this.searchInput.value, {
                        regExp: this.regExpOption.checked,
                        caseSensitive: this.caseSensitiveOption.checked,
                        wholeWord: this.wholeWordOption.checked
                    }) && this.searchInput.value;
                    n.setCssClass(this.searchBox, "ace_nomatch", e), this.editor._emit("findSearchBox", {
                        match: !e
                    }), this.highlight(), this.hide();
                }, d.prototype.replace = function() {
                    this.editor.getReadOnly() || this.editor.replace(this.replaceInput.value);
                }, d.prototype.replaceAndFindNext = function() {
                    this.editor.getReadOnly() || (this.editor.replace(this.replaceInput.value), this.findNext());
                }, d.prototype.replaceAll = function() {
                    this.editor.getReadOnly() || this.editor.replaceAll(this.replaceInput.value);
                }, d.prototype.hide = function() {
                    this.active = !1, this.setSearchRange(null), this.editor.off("changeSession", this.setSession), this.editor.off("input", this.$onEditorInput), this.element.style.display = "none", this.editor.keyBinding.removeKeyboardHandler(this.$closeSearchBarKb), this.editor.focus();
                }, d.prototype.show = function(e, t) {
                    this.active = !0, this.editor.on("changeSession", this.setSession), this.editor.on("input", this.$onEditorInput), this.element.style.display = "", this.replaceOption.checked = t, null != (e = this.editor.$search.$options.regExp ? c.escapeRegExp(e) : e) && (this.searchInput.value = e), this.searchInput.focus(), this.searchInput.select(), this.editor.keyBinding.addKeyboardHandler(this.$closeSearchBarKb), this.$syncOptions(!0);
                }, d.prototype.isFocused = function() {
                    var e = document.activeElement;
                    return e == this.searchInput || e == this.replaceInput;
                }, d);
                function d(e, t, i) {
                    this.activeInput, this.element = n.buildDom([
                        "div",
                        {
                            class: "ace_search right"
                        },
                        [
                            "span",
                            {
                                action: "hide",
                                class: "ace_searchbtn_close"
                            }
                        ],
                        [
                            "div",
                            {
                                class: "ace_search_form"
                            },
                            [
                                "input",
                                {
                                    class: "ace_search_field",
                                    placeholder: h("search-box.find.placeholder", "Search for"),
                                    spellcheck: "false"
                                }
                            ],
                            [
                                "span",
                                {
                                    action: "findPrev",
                                    class: "ace_searchbtn prev"
                                },
                                "\u200B"
                            ],
                            [
                                "span",
                                {
                                    action: "findNext",
                                    class: "ace_searchbtn next"
                                },
                                "\u200B"
                            ],
                            [
                                "span",
                                {
                                    action: "findAll",
                                    class: "ace_searchbtn",
                                    title: "Alt-Enter"
                                },
                                h("search-box.find-all.text", "All")
                            ]
                        ],
                        [
                            "div",
                            {
                                class: "ace_replace_form"
                            },
                            [
                                "input",
                                {
                                    class: "ace_search_field",
                                    placeholder: h("search-box.replace.placeholder", "Replace with"),
                                    spellcheck: "false"
                                }
                            ],
                            [
                                "span",
                                {
                                    action: "replaceAndFindNext",
                                    class: "ace_searchbtn"
                                },
                                h("search-box.replace-next.text", "Replace")
                            ],
                            [
                                "span",
                                {
                                    action: "replaceAll",
                                    class: "ace_searchbtn"
                                },
                                h("search-box.replace-all.text", "All")
                            ]
                        ],
                        [
                            "div",
                            {
                                class: "ace_search_options"
                            },
                            [
                                "span",
                                {
                                    action: "toggleReplace",
                                    class: "ace_button",
                                    title: h("search-box.toggle-replace.title", "Toggle Replace mode"),
                                    style: "float:left;margin-top:-2px;padding:0 5px;"
                                },
                                "+"
                            ],
                            [
                                "span",
                                {
                                    class: "ace_search_counter"
                                }
                            ],
                            [
                                "span",
                                {
                                    action: "toggleRegexpMode",
                                    class: "ace_button",
                                    title: h("search-box.toggle-regexp.title", "RegExp Search")
                                },
                                ".*"
                            ],
                            [
                                "span",
                                {
                                    action: "toggleCaseSensitive",
                                    class: "ace_button",
                                    title: h("search-box.toggle-case.title", "CaseSensitive Search")
                                },
                                "Aa"
                            ],
                            [
                                "span",
                                {
                                    action: "toggleWholeWords",
                                    class: "ace_button",
                                    title: h("search-box.toggle-whole-word.title", "Whole Word Search")
                                },
                                "\\b"
                            ],
                            [
                                "span",
                                {
                                    action: "searchInSelection",
                                    class: "ace_button",
                                    title: h("search-box.toggle-in-selection.title", "Search In Selection")
                                },
                                "S"
                            ]
                        ]
                    ]), this.setSession = this.setSession.bind(this), this.$onEditorInput = this.onEditorInput.bind(this), this.$init(), this.setEditor(e), n.importCssString(r, "ace_searchbox", e.container), o.addListener(this.element, "touchstart", function(e) {
                        e.stopPropagation();
                    }, e);
                }
                e = new s, e.bindKeys({
                    "Ctrl-f|Command-f": function(e) {
                        var t = e.isReplace = !e.isReplace;
                        e.replaceBox.style.display = t ? "" : "none", e.replaceOption.checked = !1, e.$syncOptions(), e.searchInput.focus();
                    },
                    "Ctrl-H|Command-Option-F": function(e) {
                        e.editor.getReadOnly() || (e.replaceOption.checked = !0, e.$syncOptions(), e.replaceInput.focus());
                    },
                    "Ctrl-G|Command-G": function(e) {
                        e.findNext();
                    },
                    "Ctrl-Shift-G|Command-Shift-G": function(e) {
                        e.findPrev();
                    },
                    esc: function(e) {
                        setTimeout(function() {
                            e.hide();
                        });
                    },
                    Return: function(e) {
                        e.activeInput == e.replaceInput && e.replace(), e.findNext();
                    },
                    "Shift-Return": function(e) {
                        e.activeInput == e.replaceInput && e.replace(), e.findPrev();
                    },
                    "Alt-Return": function(e) {
                        e.activeInput == e.replaceInput && e.replaceAll(), e.findAll();
                    },
                    Tab: function(e) {
                        (e.activeInput == e.replaceInput ? e.searchInput : e.replaceInput).focus();
                    }
                }), e.addCommands([
                    {
                        name: "toggleRegexpMode",
                        bindKey: {
                            win: "Alt-R|Alt-/",
                            mac: "Ctrl-Alt-R|Ctrl-Alt-/"
                        },
                        exec: function(e) {
                            e.regExpOption.checked = !e.regExpOption.checked, e.$syncOptions();
                        }
                    },
                    {
                        name: "toggleCaseSensitive",
                        bindKey: {
                            win: "Alt-C|Alt-I",
                            mac: "Ctrl-Alt-R|Ctrl-Alt-I"
                        },
                        exec: function(e) {
                            e.caseSensitiveOption.checked = !e.caseSensitiveOption.checked, e.$syncOptions();
                        }
                    },
                    {
                        name: "toggleWholeWords",
                        bindKey: {
                            win: "Alt-B|Alt-W",
                            mac: "Ctrl-Alt-B|Ctrl-Alt-W"
                        },
                        exec: function(e) {
                            e.wholeWordOption.checked = !e.wholeWordOption.checked, e.$syncOptions();
                        }
                    },
                    {
                        name: "toggleReplace",
                        exec: function(e) {
                            e.replaceOption.checked = !e.replaceOption.checked, e.$syncOptions();
                        }
                    },
                    {
                        name: "searchInSelection",
                        exec: function(e) {
                            e.searchOption.checked = !e.searchRange, e.setSearchRange(e.searchOption.checked && e.editor.getSelectionRange()), e.$syncOptions();
                        }
                    }
                ]), s = new s([
                    {
                        bindKey: "Esc",
                        name: "closeSearchBar",
                        exec: function(e) {
                            e.searchBox.hide();
                        }
                    }
                ]);
                l.prototype.$searchBarKb = e, l.prototype.$closeSearchBarKb = s, t.SearchBox = l, t.Search = function(e, t) {
                    var i = e.searchBox || new l(e), n = e.session.selection.getRange(), e = n.isMultiLine() ? "" : e.session.getTextRange(n);
                    i.show(e, t);
                };
            }), ace.require([
                "ace/ext/searchbox"
            ], function(e) {
                t && (t.exports = e);
            });
        },
        4221: function(t, e, i) {
            t = i.nmd(t), ace.define("ace/mode/json_highlight_rules", [
                "require",
                "exports",
                "module",
                "ace/lib/oop",
                "ace/mode/text_highlight_rules"
            ], function(e, t, i) {
                function n() {
                    this.$rules = {
                        start: [
                            {
                                token: "variable",
                                regex: '["](?:(?:\\\\.)|(?:[^"\\\\]))*?["]\\s*(?=:)'
                            },
                            {
                                token: "string",
                                regex: '"',
                                next: "string"
                            },
                            {
                                token: "constant.numeric",
                                regex: "0[xX][0-9a-fA-F]+\\b"
                            },
                            {
                                token: "constant.numeric",
                                regex: "[+-]?\\d+(?:(?:\\.\\d*)?(?:[eE][+-]?\\d+)?)?\\b"
                            },
                            {
                                token: "constant.language.boolean",
                                regex: "(?:true|false)\\b"
                            },
                            {
                                token: "text",
                                regex: "['](?:(?:\\\\.)|(?:[^'\\\\]))*?[']"
                            },
                            {
                                token: "comment",
                                regex: "\\/\\/.*$"
                            },
                            {
                                token: "comment.start",
                                regex: "\\/\\*",
                                next: "comment"
                            },
                            {
                                token: "paren.lparen",
                                regex: "[[({]"
                            },
                            {
                                token: "paren.rparen",
                                regex: "[\\])}]"
                            },
                            {
                                token: "punctuation.operator",
                                regex: /[,]/
                            },
                            {
                                token: "text",
                                regex: "\\s+"
                            }
                        ],
                        string: [
                            {
                                token: "constant.language.escape",
                                regex: /\\(?:x[0-9a-fA-F]{2}|u[0-9a-fA-F]{4}|["\\\/bfnrt])/
                            },
                            {
                                token: "string",
                                regex: '"|$',
                                next: "start"
                            },
                            {
                                defaultToken: "string"
                            }
                        ],
                        comment: [
                            {
                                token: "comment.end",
                                regex: "\\*\\/",
                                next: "start"
                            },
                            {
                                defaultToken: "comment"
                            }
                        ]
                    };
                }
                var o = e("../lib/oop"), e = e("./text_highlight_rules").TextHighlightRules;
                o.inherits(n, e), t.JsonHighlightRules = n;
            }), ace.define("ace/mode/matching_brace_outdent", [
                "require",
                "exports",
                "module",
                "ace/range"
            ], function(e, t, i) {
                function n() {}
                var o = e("../range").Range;
                (function() {
                    this.checkOutdent = function(e, t) {
                        return !!/^\s+$/.test(e) && /^\s*\}/.test(t);
                    }, this.autoOutdent = function(e, t) {
                        var i, n = e.getLine(t).match(/^(\s*\})/);
                        return n && (n = n[1].length, i = e.findMatchingBracket({
                            row: t,
                            column: n
                        })) && i.row != t ? (i = this.$getIndent(e.getLine(i.row)), void e.replace(new o(t, 0, t, n - 1), i)) : 0;
                    }, this.$getIndent = function(e) {
                        return e.match(/^\s*/)[0];
                    };
                }).call(n.prototype), t.MatchingBraceOutdent = n;
            }), ace.define("ace/mode/folding/cstyle", [
                "require",
                "exports",
                "module",
                "ace/lib/oop",
                "ace/range",
                "ace/mode/folding/fold_mode"
            ], function(e, t, i) {
                var n = e("../../lib/oop"), h = e("../../range").Range, e = e("./fold_mode").FoldMode, t = t.FoldMode = function(e) {
                    e && (this.foldingStartMarker = new RegExp(this.foldingStartMarker.source.replace(/\|[^|]*?$/, "|" + e.start)), this.foldingStopMarker = new RegExp(this.foldingStopMarker.source.replace(/\|[^|]*?$/, "|" + e.end)));
                };
                n.inherits(t, e), (function() {
                    this.foldingStartMarker = /([\{\[\(])[^\}\]\)]*$|^\s*(\/\*)/, this.foldingStopMarker = /^[^\[\{\(]*([\}\]\)])|^[\s\*]*(\*\/)/, this.singleLineBlockCommentRe = /^\s*(\/\*).*\*\/\s*$/, this.tripleStarBlockCommentRe = /^\s*(\/\*\*\*).*\*\/\s*$/, this.startRegionRe = /^\s*(\/\*|\/\/)#?region\b/, this._getFoldWidgetBase = this.getFoldWidget, this.getFoldWidget = function(e, t, i) {
                        var n = e.getLine(i);
                        return !this.singleLineBlockCommentRe.test(n) || this.startRegionRe.test(n) || this.tripleStarBlockCommentRe.test(n) ? !(e = this._getFoldWidgetBase(e, t, i)) && this.startRegionRe.test(n) ? "start" : e : "";
                    }, this.getFoldWidgetRange = function(e, t, i, n) {
                        var o, r, s, a = e.getLine(i);
                        return this.startRegionRe.test(a) ? this.getCommentRegionBlock(e, a, i) : (r = a.match(this.foldingStartMarker)) ? (s = r.index, r[1] ? this.openingBracketBlock(e, r[1], i, s) : ((o = e.getCommentFoldRange(i, s + r[0].length, 1)) && !o.isMultiLine() && (n ? o = this.getSectionRange(e, i) : "all" != t && (o = null)), o)) : "markbegin" !== t && (r = a.match(this.foldingStopMarker)) ? (s = r.index + r[0].length, r[1] ? this.closingBracketBlock(e, r[1], i, s) : e.getCommentFoldRange(i, s, -1)) : void 0;
                    }, this.getSectionRange = function(e, t) {
                        for(var i = (a = e.getLine(t)).search(/\S/), n = t, o = a.length, r = t += 1, s = e.getLength(); ++t < s;){
                            var a, l = (a = e.getLine(t)).search(/\S/);
                            if (-1 !== l) {
                                if (l < i) break;
                                var c = this.getFoldWidgetRange(e, "all", t);
                                if (c) {
                                    if (c.start.row <= n) break;
                                    if (c.isMultiLine()) t = c.end.row;
                                    else if (i == l) break;
                                }
                                r = t;
                            }
                        }
                        return new h(n, o, r, e.getLine(r).length);
                    }, this.getCommentRegionBlock = function(e, t, i) {
                        for(var n = t.search(/\s*$/), o = e.getLength(), r = i, s = /^\s*(?:\/\*|\/\/|--)#?(end)?region\b/, a = 1; ++i < o;){
                            t = e.getLine(i);
                            var l = s.exec(t);
                            if (l && (l[1] ? a-- : a++, !a)) break;
                        }
                        if (r < i) return new h(r, n, i, t.length);
                    };
                }).call(t.prototype);
            }), ace.define("ace/mode/json", [
                "require",
                "exports",
                "module",
                "ace/lib/oop",
                "ace/mode/text",
                "ace/mode/json_highlight_rules",
                "ace/mode/matching_brace_outdent",
                "ace/mode/folding/cstyle",
                "ace/worker/worker_client"
            ], function(e, t, i) {
                function n() {
                    this.HighlightRules = s, this.$outdent = new a, this.$behaviour = this.$defaultBehaviour, this.foldingRules = new l;
                }
                var o = e("../lib/oop"), r = e("./text").Mode, s = e("./json_highlight_rules").JsonHighlightRules, a = e("./matching_brace_outdent").MatchingBraceOutdent, l = e("./folding/cstyle").FoldMode, c = e("../worker/worker_client").WorkerClient;
                o.inherits(n, r), (function() {
                    this.lineCommentStart = "//", this.blockComment = {
                        start: "/*",
                        end: "*/"
                    }, this.getNextLineIndent = function(e, t, i) {
                        var n = this.$getIndent(t);
                        return "start" == e && t.match(/^.*[\{\(\[]\s*$/) && (n += i), n;
                    }, this.checkOutdent = function(e, t, i) {
                        return this.$outdent.checkOutdent(t, i);
                    }, this.autoOutdent = function(e, t, i) {
                        this.$outdent.autoOutdent(t, i);
                    }, this.createWorker = function(t) {
                        var e = new c([
                            "ace"
                        ], "ace/mode/json_worker", "JsonWorker");
                        return e.attachToDocument(t.getDocument()), e.on("annotate", function(e) {
                            t.setAnnotations(e.data);
                        }), e.on("terminate", function() {
                            t.clearAnnotations();
                        }), e;
                    }, this.$id = "ace/mode/json";
                }).call(n.prototype), t.Mode = n;
            }), ace.require([
                "ace/mode/json"
            ], function(e) {
                t && (t.exports = e);
            });
        },
        2229: function(e, t, g) {
            var s = g(2620), l = g(4292), p = g(9336), c = g(4427), m = g(9306), f = g(2084), C = g(3483), y = g(8852), v = g(6862), e = ((e.exports = w).prototype.validate = function(e, t) {
                var i;
                if ("string" == typeof e) {
                    if (!(i = this.getSchema(e))) throw new Error('no schema with key or ref "' + e + '"');
                } else {
                    e = this._addSchema(e);
                    i = e.validate || this._compile(e);
                }
                e = i(t);
                !0 !== i.$async && (this.errors = i.errors);
                return e;
            }, w.prototype.compile = function(e, t) {
                e = this._addSchema(e, void 0, t);
                return e.validate || this._compile(e);
            }, w.prototype.addSchema = function(e, t, i, n) {
                if (Array.isArray(e)) for(var o = 0; o < e.length; o++)this.addSchema(e[o], void 0, i, n);
                else {
                    var r = this._getId(e);
                    if (void 0 !== r && "string" != typeof r) throw new Error("schema id must be string");
                    h(this, t = l.normalizeId(t || r)), this._schemas[t] = this._addSchema(e, i, n, !0);
                }
                return this;
            }, w.prototype.addMetaSchema = function(e, t, i) {
                return this.addSchema(e, t, i, !0), this;
            }, w.prototype.validateSchema = function(e, t) {
                var i = e.$schema;
                if (void 0 !== i && "string" != typeof i) throw new Error("$schema must be a string");
                if (!(i = i || this._opts.defaultMeta || ((e)=>{
                    var t = e._opts.meta;
                    return e._opts.defaultMeta = "object" == typeof t ? e._getId(t) || t : e.getSchema(I) ? I : void 0, e._opts.defaultMeta;
                })(this))) return this.logger.warn("meta-schema not available"), this.errors = null, true;
                i = this.validate(i, e);
                if (!i && t) {
                    e = "schema is invalid: " + this.errorsText();
                    if ("log" != this._opts.validateSchema) throw new Error(e);
                    this.logger.error(e);
                }
                return i;
            }, w.prototype.getSchema = function(e) {
                var t = i(this, e);
                switch(typeof t){
                    case "object":
                        return t.validate || this._compile(t);
                    case "string":
                        return this.getSchema(t);
                    case "undefined":
                        return ((e, t)=>{
                            var i, n, o, r = l.schema.call(e, {
                                schema: {}
                            }, t);
                            if (r) return i = r.schema, n = r.root, r = r.baseId, o = s.call(e, i, n, void 0, r), e._fragments[t] = new c({
                                ref: t,
                                fragment: !0,
                                schema: i,
                                root: n,
                                baseId: r,
                                validate: o
                            }), o;
                        })(this, e);
                }
            }, w.prototype.removeSchema = function(e) {
                if (e instanceof RegExp) n(this, this._schemas, e), n(this, this._refs, e);
                else switch(typeof e){
                    case "undefined":
                        return n(this, this._schemas), n(this, this._refs), this._cache.clear(), this;
                    case "string":
                        var t = i(this, e);
                        return t && this._cache.del(t.cacheKey), delete this._schemas[e], delete this._refs[e], this;
                    case "object":
                        t = this._opts.serialize, t = t ? t(e) : e, t = (this._cache.del(t), this._getId(e));
                        t && (t = l.normalizeId(t), delete this._schemas[t], delete this._refs[t]);
                }
                return this;
            }, w.prototype.addFormat = function(e, t) {
                "string" == typeof t && (t = new RegExp(t));
                return this._formats[e] = t, this;
            }, w.prototype.errorsText = function(e, t) {
                if (!(e = e || this.errors)) return "No errors";
                for(var i = void 0 === (t = t || {}).separator ? ", " : t.separator, n = void 0 === t.dataVar ? "data" : t.dataVar, o = "", r = 0; r < e.length; r++){
                    var s = e[r];
                    s && (o += n + s.dataPath + " " + s.message + i);
                }
                return o.slice(0, -i.length);
            }, w.prototype._addSchema = function(e, t, i, n) {
                if ("object" != typeof e && "boolean" != typeof e) throw new Error("schema should be object or boolean");
                var o = this._opts.serialize, o = o ? o(e) : e, r = this._cache.get(o);
                if (r) return r;
                n = n || !1 !== this._opts.addUsedSchema;
                r = l.normalizeId(this._getId(e));
                r && n && h(this, r);
                var s, t = !1 !== this._opts.validateSchema && !t;
                t && !(s = r && r == l.normalizeId(e.$schema)) && this.validateSchema(e, !0);
                var a = l.ids.call(this, e), a = new c({
                    id: r,
                    schema: e,
                    localRefs: a,
                    cacheKey: o,
                    meta: i
                });
                "#" != r[0] && n && (this._refs[r] = a);
                this._cache.put(o, a), t && s && this.validateSchema(e, !0);
                return a;
            }, w.prototype._compile = function(i, e) {
                if (i.compiling) return (i.validate = o).schema = i.schema, o.errors = null, o.root = e || o, !0 === i.schema.$async && (o.$async = !0), o;
                var t, n;
                i.compiling = !0, i.meta && (t = this._opts, this._opts = this._metaOpts);
                try {
                    n = s.call(this, i.schema, e, i.localRefs);
                } catch (e) {
                    throw delete i.validate, e;
                } finally{
                    i.compiling = !1, i.meta && (this._opts = t);
                }
                return i.validate = n, i.refs = n.refs, i.refVal = n.refVal, i.root = n.root, n;
                function o() {
                    var e = i.validate, t = e.apply(this, arguments);
                    return o.errors = e.errors, t;
                }
            }, w.prototype.compileAsync = g(600), g(413)), e = (w.prototype.addKeyword = e.add, w.prototype.getKeyword = e.get, w.prototype.removeKeyword = e.remove, w.prototype.validateKeyword = e.validate, g(3689)), I = (w.ValidationError = e.Validation, w.MissingRefError = e.MissingRef, w.$dataMetaSchema = y, "http://json-schema.org/draft-07/schema"), b = [
                "removeAdditional",
                "useDefaults",
                "coerceTypes",
                "strictDefaults"
            ], A = [
                "/properties"
            ];
            function w(e) {
                if (!(this instanceof w)) return new w(e);
                e = this._opts = v.copy(e) || {};
                var t = this, i = t._opts.logger;
                if (!1 === i) t.logger = {
                    log: T,
                    warn: T,
                    error: T
                };
                else {
                    if (!("object" == typeof (i = void 0 === i ? console : i) && i.log && i.warn && i.error)) throw new Error("logger must implement log, warn and error methods");
                    t.logger = i;
                }
                if (this._schemas = {}, this._refs = {}, this._fragments = {}, this._formats = f(e.format), this._cache = e.cache || new p, this._loadingSchemas = {}, this._compilations = [], this.RULES = C(), this._getId = ((e)=>{
                    switch(e.schemaId){
                        case "auto":
                            return k;
                        case "id":
                            return x;
                        default:
                            return S;
                    }
                })(e), e.loopRequired = e.loopRequired || 1 / 0, "property" == e.errorDataPath && (e._errorDataPathProperty = !0), void 0 === e.serialize && (e.serialize = m), this._metaOpts = ((e)=>{
                    for(var t = v.copy(e._opts), i = 0; i < b.length; i++)delete t[b[i]];
                    return t;
                })(this), e.formats) {
                    var n, o = this;
                    for(n in o._opts.formats){
                        var r = o._opts.formats[n];
                        o.addFormat(n, r);
                    }
                }
                if (e.keywords) {
                    var s, a = this;
                    for(s in a._opts.keywords){
                        var l = a._opts.keywords[s];
                        a.addKeyword(s, l);
                    }
                }
                var c, t = this, h = (t._opts.$data && (c = g(3420), t.addMetaSchema(c, c.$id, !0)), !1 !== t._opts.meta && (c = g(8198), t._opts.$data && (c = y(c, A)), t.addMetaSchema(c, I, !0), t._refs["http://json-schema.org/schema"] = I), "object" == typeof e.meta && this.addMetaSchema(e.meta), e.nullable && this.addKeyword("nullable", {
                    metaSchema: {
                        type: "boolean"
                    }
                }), this), d = h._opts.schemas;
                if (d) {
                    if (Array.isArray(d)) h.addSchema(d);
                    else for(var u in d)h.addSchema(d[u], u);
                }
            }
            function i(e, t) {
                return t = l.normalizeId(t), e._schemas[t] || e._refs[t] || e._fragments[t];
            }
            function n(e, t, i) {
                for(var n in t){
                    var o = t[n];
                    o.meta || i && !i.test(n) || (e._cache.del(o.cacheKey), delete t[n]);
                }
            }
            function x(e) {
                return e.$id && this.logger.warn("schema $id ignored", e.$id), e.id;
            }
            function S(e) {
                return e.id && this.logger.warn("schema id ignored", e.id), e.$id;
            }
            function k(e) {
                if (e.$id && e.id && e.$id != e.id) throw new Error("schema $id is different from id");
                return e.$id || e.id;
            }
            function h(e, t) {
                if (e._schemas[t] || e._refs[t]) throw new Error('schema with key or id "' + t + '" already exists');
            }
            function T() {}
        },
        9336: function(e) {
            e = e.exports = function() {
                this._cache = {};
            };
            e.prototype.put = function(e, t) {
                this._cache[e] = t;
            }, e.prototype.get = function(e) {
                return this._cache[e];
            }, e.prototype.del = function(e) {
                delete this._cache[e];
            }, e.prototype.clear = function() {
                this._cache = {};
            };
        },
        600: function(e, t, i) {
            var n = i(3689).MissingRef;
            function o(t, s, i) {
                var a = this;
                if ("function" != typeof this._opts.loadSchema) throw new Error("options.loadSchema should be a function");
                "function" == typeof s && (i = s, s = void 0);
                var e = l(t).then(function() {
                    var e = a._addSchema(t, void 0, s);
                    return e.validate || function o(r) {
                        try {
                            return a._compile(r);
                        } catch (e) {
                            if (e instanceof n) return t(e);
                            throw e;
                        }
                        function t(e) {
                            var t = e.missingSchema;
                            if (n(t)) throw new Error("Schema " + t + " is loaded but " + e.missingRef + " cannot be resolved");
                            e = a._loadingSchemas[t];
                            return e || (e = a._loadingSchemas[t] = a._opts.loadSchema(t)).then(i, i), e.then(function(e) {
                                if (!n(t)) return l(e).then(function() {
                                    n(t) || a.addSchema(e, t, void 0, s);
                                });
                            }).then(function() {
                                return o(r);
                            });
                            function i() {
                                delete a._loadingSchemas[t];
                            }
                            function n(e) {
                                return a._refs[e] || a._schemas[e];
                            }
                        }
                    }(e);
                });
                return i && e.then(function(e) {
                    i(null, e);
                }, i), e;
                function l(e) {
                    e = e.$schema;
                    return e && !a.getSchema(e) ? o.call(a, {
                        $ref: e
                    }, !0) : Promise.resolve();
                }
            }
            e.exports = o;
        },
        3689: function(e, t, i) {
            var n = i(4292);
            function o(e, t, i) {
                this.message = i || o.message(e, t), this.missingRef = n.url(e, t), this.missingSchema = n.normalizeId(n.fullPath(this.missingRef));
            }
            function r(e) {
                return e.prototype = Object.create(Error.prototype), e.prototype.constructor = e;
            }
            e.exports = {
                Validation: r(function(e) {
                    this.message = "validation failed", this.errors = e, this.ajv = this.validation = !0;
                }),
                MissingRef: r(o)
            }, o.message = function(e, t) {
                return "can't resolve reference " + t + " from id " + e;
            };
        },
        2084: function(e, t, i) {
            var n = i(6862), o = /^(\d\d\d\d)-(\d\d)-(\d\d)$/, r = [
                0,
                31,
                28,
                31,
                30,
                31,
                30,
                31,
                31,
                30,
                31,
                30,
                31
            ], s = /^(\d\d):(\d\d):(\d\d)(\.\d+)?(z|[+-]\d\d(?::?\d\d)?)?$/i, i = /^(?=.{1,253}\.?$)[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[-0-9a-z]{0,61}[0-9a-z])?)*\.?$/i, a = /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)(?:\?(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i, l = /^(?:(?:[^\x00-\x20"'<>%\\^`{|}]|%[0-9a-f]{2})|\{[+#./;?&=,!@|]?(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?(?:,(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?)*\})*$/i, c = /^(?:(?:http[s\u017F]?|ftp):\/\/)(?:(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+(?::(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)?@)?(?:(?!10(?:\.[0-9]{1,3}){3})(?!127(?:\.[0-9]{1,3}){3})(?!169\.254(?:\.[0-9]{1,3}){2})(?!192\.168(?:\.[0-9]{1,3}){2})(?!172\.(?:1[6-9]|2[0-9]|3[01])(?:\.[0-9]{1,3}){2})(?:[1-9][0-9]?|1[0-9][0-9]|2[01][0-9]|22[0-3])(?:\.(?:1?[0-9]{1,2}|2[0-4][0-9]|25[0-5])){2}(?:\.(?:[1-9][0-9]?|1[0-9][0-9]|2[0-4][0-9]|25[0-4]))|(?:(?:(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+-)*(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)(?:\.(?:(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+-)*(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)*(?:\.(?:(?:[a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]){2,})))(?::[0-9]{2,5})?(?:\/(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)?$/i, h = /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i, d = /^(?:\/(?:[^~/]|~0|~1)*)*$/, u = /^#(?:\/(?:[a-z0-9_\-.!$&'()*+,;:=@]|%[0-9a-f]{2}|~0|~1)*)*$/i, g = /^(?:0|[1-9][0-9]*)(?:#|(?:\/(?:[^~/]|~0|~1)*)*)$/;
            function p(e) {
                return n.copy(p[e = "full" == e ? "full" : "fast"]);
            }
            function m(e) {
                var t, i, e = e.match(o);
                return !!e && (t = +e[1], i = +e[3], 1 <= (e = +e[2])) && e <= 12 && 1 <= i && i <= (2 != e || (i = t) % 4 != 0 || i % 100 == 0 && i % 400 != 0 ? r[e] : 29);
            }
            function f(e, t) {
                var i, n, o, e = e.match(s);
                return !!e && (i = e[1], n = e[2], o = e[3], i <= 23 && n <= 59 && o <= 59 || 23 == i && 59 == n && 60 == o) && (!t || e[5]);
            }
            (e.exports = p).fast = {
                date: /^\d\d\d\d-[0-1]\d-[0-3]\d$/,
                time: /^(?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)?$/i,
                "date-time": /^\d\d\d\d-[0-1]\d-[0-3]\d[t\s](?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)$/i,
                uri: /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/)?[^\s]*$/i,
                "uri-reference": /^(?:(?:[a-z][a-z0-9+\-.]*:)?\/?\/)?(?:[^\\\s#][^\s#]*)?(?:#[^\\\s]*)?$/i,
                "uri-template": l,
                url: c,
                email: /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i,
                hostname: i,
                ipv4: /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,
                ipv6: /^\s*(?:(?:(?:[0-9a-f]{1,4}:){7}(?:[0-9a-f]{1,4}|:))|(?:(?:[0-9a-f]{1,4}:){6}(?::[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){5}(?:(?:(?::[0-9a-f]{1,4}){1,2})|:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){4}(?:(?:(?::[0-9a-f]{1,4}){1,3})|(?:(?::[0-9a-f]{1,4})?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){3}(?:(?:(?::[0-9a-f]{1,4}){1,4})|(?:(?::[0-9a-f]{1,4}){0,2}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){2}(?:(?:(?::[0-9a-f]{1,4}){1,5})|(?:(?::[0-9a-f]{1,4}){0,3}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){1}(?:(?:(?::[0-9a-f]{1,4}){1,6})|(?:(?::[0-9a-f]{1,4}){0,4}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?::(?:(?:(?::[0-9a-f]{1,4}){1,7})|(?:(?::[0-9a-f]{1,4}){0,5}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(?:%.+)?\s*$/i,
                regex: I,
                uuid: h,
                "json-pointer": d,
                "json-pointer-uri-fragment": u,
                "relative-json-pointer": g
            }, p.full = {
                date: m,
                time: f,
                "date-time": function(e) {
                    e = e.split(C);
                    return 2 == e.length && m(e[0]) && f(e[1], !0);
                },
                uri: function(e) {
                    return y.test(e) && a.test(e);
                },
                "uri-reference": /^(?:[a-z][a-z0-9+\-.]*:)?(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'"()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?(?:\?(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i,
                "uri-template": l,
                url: c,
                email: /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i,
                hostname: i,
                ipv4: /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,
                ipv6: /^\s*(?:(?:(?:[0-9a-f]{1,4}:){7}(?:[0-9a-f]{1,4}|:))|(?:(?:[0-9a-f]{1,4}:){6}(?::[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){5}(?:(?:(?::[0-9a-f]{1,4}){1,2})|:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){4}(?:(?:(?::[0-9a-f]{1,4}){1,3})|(?:(?::[0-9a-f]{1,4})?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){3}(?:(?:(?::[0-9a-f]{1,4}){1,4})|(?:(?::[0-9a-f]{1,4}){0,2}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){2}(?:(?:(?::[0-9a-f]{1,4}){1,5})|(?:(?::[0-9a-f]{1,4}){0,3}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){1}(?:(?:(?::[0-9a-f]{1,4}){1,6})|(?:(?::[0-9a-f]{1,4}){0,4}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?::(?:(?:(?::[0-9a-f]{1,4}){1,7})|(?:(?::[0-9a-f]{1,4}){0,5}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(?:%.+)?\s*$/i,
                regex: I,
                uuid: h,
                "json-pointer": d,
                "json-pointer-uri-fragment": u,
                "relative-json-pointer": g
            };
            var C = /t|\s/i;
            var y = /\/|:/;
            var v = /[^\\]\\Z/;
            function I(e) {
                if (v.test(e)) return !1;
                try {
                    return new RegExp(e), !0;
                } catch (e) {
                    return !1;
                }
            }
        },
        2620: function(e, t, i) {
            var E = i(4292), R = i(6862), $ = i(3689), _ = i(9306), L = i(1035), M = R.ucs2length, N = i(5215), W = $.Validation;
            function B(e, s, a, t) {
                var l = this, c = this._opts, h = [
                    void 0
                ], d = {}, u = [], i = {}, g = [], n = {}, p = [];
                function m(e, t) {
                    return "var pattern" + e + " = " + (c.regExp ? "regExp" : "new RegExp") + "(" + R.toQuotedString(t[e]) + ");";
                }
                s = s || {
                    schema: e,
                    refVal: h,
                    refs: d
                };
                var o = (function(e, t, i) {
                    var n = D.call(this, e, t, i);
                    return 0 <= n ? {
                        index: n,
                        compiling: !0
                    } : (n = this._compilations.length, this._compilations[n] = {
                        schema: e,
                        root: t,
                        baseId: i
                    }, {
                        index: n,
                        compiling: !1
                    });
                }).call(this, e, s, t), r = this._compilations[o.index];
                if (o.compiling) return r.callValidate = I;
                var f = this._formats, C = this.RULES;
                try {
                    var y = b(e, s, a, t), v = (r.validate = y, r.callValidate);
                    return v && (v.schema = y.schema, v.errors = null, v.refs = y.refs, v.refVal = y.refVal, v.root = y.root, v.$async = y.$async, c.sourceCode) && (v.source = y.source), y;
                } finally{
                    (function(e, t, i) {
                        e = D.call(this, e, t, i);
                        0 <= e && this._compilations.splice(e, 1);
                    }).call(this, e, s, t);
                }
                function I() {
                    var e = r.validate, t = e.apply(this, arguments);
                    return I.errors = e.errors, t;
                }
                function b(e, t, i, n) {
                    var o = !t || t.schema == e;
                    if (t.schema != s.schema) return B.call(l, e, t, i, n);
                    i = !0 === e.$async, n = L({
                        isTop: !0,
                        schema: e,
                        isRoot: o,
                        baseId: n,
                        root: t,
                        schemaPath: "",
                        errSchemaPath: "#",
                        errorPath: '""',
                        MissingRefError: $.MissingRef,
                        RULES: C,
                        validate: L,
                        util: R,
                        resolve: E,
                        resolveRef: A,
                        usePattern: S,
                        useDefault: k,
                        useCustomRule: T,
                        opts: c,
                        formats: f,
                        logger: l.logger,
                        self: l
                    }), n = G(h, P) + G(u, m) + G(g, O) + G(p, H) + n;
                    c.processCode && (n = c.processCode(n, e));
                    try {
                        var r = new Function("self", "RULES", "formats", "root", "refVal", "defaults", "customRules", "equal", "ucs2length", "ValidationError", "regExp", n)(l, C, f, s, h, g, p, N, M, W, c.regExp);
                        h[0] = r;
                    } catch (e) {
                        throw l.logger.error("Error compiling schema, function code:", n), e;
                    }
                    return r.schema = e, r.errors = null, r.refs = d, r.refVal = h, r.root = o ? r : t, i && (r.$async = !0), !0 === c.sourceCode && (r.source = {
                        code: n,
                        patterns: u,
                        defaults: g
                    }), r;
                }
                function A(e, t, i) {
                    t = E.url(e, t);
                    var n = d[t];
                    if (void 0 !== n) return x(o = h[n], r = "refVal[" + n + "]");
                    if (!i && s.refs) {
                        n = s.refs[t];
                        if (void 0 !== n) return x(o = s.refVal[n], r = w(t, o));
                    }
                    var o, r = w(t), i = E.call(l, b, s, t);
                    if (void 0 !== (i = void 0 === i && (n = a && a[t]) ? E.inlineRef(n, c.inlineRefs) ? n : B.call(l, n, s, a, e) : i)) return o = i, n = d[n = t], h[n] = o, x(i, r);
                    delete d[t];
                }
                function w(e, t) {
                    var i = h.length;
                    return h[i] = t, "refVal" + (d[e] = i);
                }
                function x(e, t) {
                    return "object" == typeof e || "boolean" == typeof e ? {
                        code: t,
                        schema: e,
                        inline: !0
                    } : {
                        code: t,
                        $async: e && !!e.$async
                    };
                }
                function S(e) {
                    var t = i[e];
                    return void 0 === t && (t = i[e] = u.length, u[t] = e), "pattern" + t;
                }
                function k(e) {
                    switch(typeof e){
                        case "boolean":
                        case "number":
                            return "" + e;
                        case "string":
                            return R.toQuotedString(e);
                        case "object":
                            var t, i;
                            return null === e ? "null" : (t = _(e), void 0 === (i = n[t]) && (i = n[t] = g.length, g[i] = e), "default" + i);
                    }
                }
                function T(e, t, i, n) {
                    if (!1 !== l._opts.validateSchema) {
                        var o = e.definition.dependencies;
                        if (o && !o.every(function(e) {
                            return Object.prototype.hasOwnProperty.call(i, e);
                        })) throw new Error("parent schema must have all required keywords: " + o.join(","));
                        o = e.definition.validateSchema;
                        if (o) {
                            if (!o(t)) {
                                o = "keyword schema is invalid: " + l.errorsText(o.errors);
                                if ("log" != l._opts.validateSchema) throw new Error(o);
                                l.logger.error(o);
                            }
                        }
                    }
                    var r, o = e.definition.compile, s = e.definition.inline, a = e.definition.macro;
                    if (o) r = o.call(l, t, i, n);
                    else if (a) r = a.call(l, t, i, n), !1 !== c.validateSchema && l.validateSchema(r, !0);
                    else if (s) r = s.call(l, n, e.keyword, t, i);
                    else if (!(r = e.definition.validate)) return;
                    if (void 0 === r) throw new Error('custom keyword "' + e.keyword + '"failed to compile');
                    o = p.length;
                    return {
                        code: "customRule" + o,
                        validate: p[o] = r
                    };
                }
            }
            function D(e, t, i) {
                for(var n = 0; n < this._compilations.length; n++){
                    var o = this._compilations[n];
                    if (o.schema == e && o.root == t && o.baseId == i) return n;
                }
                return -1;
            }
            function O(e) {
                return "var default" + e + " = defaults[" + e + "];";
            }
            function P(e, t) {
                return void 0 === t[e] ? "" : "var refVal" + e + " = refVal[" + e + "];";
            }
            function H(e) {
                return "var customRule" + e + " = customRules[" + e + "];";
            }
            function G(e, t) {
                if (!e.length) return "";
                for(var i = "", n = 0; n < e.length; n++)i += t(n, e);
                return i;
            }
            e.exports = B;
        },
        4292: function(e, t, i) {
            var g = i(6777), p = i(5215), m = i(6862), a = i(4427), n = i(4316);
            function l(e, t, i) {
                var n, o, r, s = this._refs[i];
                if ("string" == typeof s) {
                    if (!this._refs[s]) return l.call(this, e, t, s);
                    s = this._refs[s];
                }
                return (s = s || this._schemas[i]) instanceof a ? u(s.schema, this._opts.inlineRefs) ? s.schema : s.validate || this._compile(s) : ((s = c.call(this, t, i)) && (n = s.schema, t = s.root, r = s.baseId), n instanceof a ? o = n.validate || e.call(this, n.schema, t, void 0, r) : void 0 !== n && (o = u(n, this._opts.inlineRefs) ? n : e.call(this, n, t, void 0, r)), o);
            }
            function c(e, t) {
                var i = g.parse(t), n = C(i), o = f(this._getId(e.schema));
                if (0 === Object.keys(e.schema).length || n !== o) {
                    var n = y(n), r = this._refs[n];
                    if ("string" == typeof r) return (function(e, t, i) {
                        t = c.call(this, e, t);
                        var n, o;
                        if (t) return n = t.schema, o = t.baseId, e = t.root, (t = this._getId(n)) && (o = v(o, t)), s.call(this, i, o, n, e);
                    }).call(this, e, r, i);
                    if (r instanceof a) r.validate || this._compile(r);
                    else {
                        if (!((r = this._schemas[n]) instanceof a)) return;
                        if (r.validate || this._compile(r), n == y(t)) return {
                            schema: r,
                            root: e,
                            baseId: o
                        };
                    }
                    if (!(e = r).schema) return;
                    o = f(this._getId(e.schema));
                }
                return s.call(this, i, o, e.schema, e);
            }
            (e.exports = l).normalizeId = y, l.fullPath = f, l.url = v, l.ids = function(e) {
                var t = y(this._getId(e)), c = {
                    "": t
                }, h = {
                    "": f(t, !1)
                }, d = {}, u = this;
                return n(e, {
                    allKeys: !0
                }, function(e, t, i, n, o, r, s) {
                    if ("" !== t) {
                        var a = u._getId(e), l = c[n], n = h[n] + "/" + o;
                        if (void 0 !== s && (n += "/" + ("number" == typeof s ? s : m.escapeFragment(s))), "string" == typeof a) {
                            a = l = y(l ? g.resolve(l, a) : a), o = u._refs[a];
                            if ((o = "string" == typeof o ? u._refs[o] : o) && o.schema) {
                                if (!p(e, o.schema)) throw new Error('id "' + a + '" resolves to more than one schema');
                            } else if (a != y(n)) {
                                if ("#" == a[0]) {
                                    if (d[a] && !p(e, d[a])) throw new Error('id "' + a + '" resolves to more than one schema');
                                    d[a] = e;
                                } else u._refs[a] = n;
                            }
                        }
                        c[t] = l, h[t] = n;
                    }
                }), d;
            }, l.inlineRef = u, l.schema = c;
            var h = m.toHash([
                "properties",
                "patternProperties",
                "enum",
                "dependencies",
                "definitions"
            ]);
            function s(e, t, i, n) {
                if (e.fragment = e.fragment || "", "/" == e.fragment.slice(0, 1)) {
                    for(var o = e.fragment.split("/"), r = 1; r < o.length; r++){
                        var s = o[r];
                        if (s) {
                            if (void 0 === (i = i[s = m.unescapeFragment(s)])) break;
                            h[s] || ((s = this._getId(i)) && (t = v(t, s)), i.$ref && (s = v(t, i.$ref), s = c.call(this, n, s)) && (i = s.schema, n = s.root, t = s.baseId));
                        }
                    }
                    return void 0 !== i && i !== n.schema ? {
                        schema: i,
                        root: n,
                        baseId: t
                    } : void 0;
                }
            }
            var d = m.toHash([
                "type",
                "format",
                "pattern",
                "maxLength",
                "minLength",
                "maxProperties",
                "minProperties",
                "maxItems",
                "minItems",
                "maximum",
                "minimum",
                "uniqueItems",
                "multipleOf",
                "required",
                "enum"
            ]);
            function u(e, t) {
                return !1 !== t && (void 0 === t || !0 === t ? function e(t) {
                    var i;
                    if (Array.isArray(t)) {
                        for(var n = 0; n < t.length; n++)if ("object" == typeof (i = t[n]) && !e(i)) return !1;
                    } else for(var o in t){
                        if ("$ref" == o) return !1;
                        if ("object" == typeof (i = t[o]) && !e(i)) return !1;
                    }
                    return !0;
                }(e) : t ? function e(t) {
                    var i, n = 0;
                    if (Array.isArray(t)) {
                        for(var o = 0; o < t.length; o++)if ("object" == typeof (i = t[o]) && (n += e(i)), n == 1 / 0) return 1 / 0;
                    } else for(var r in t){
                        if ("$ref" == r) return 1 / 0;
                        if (d[r]) n++;
                        else if ("object" == typeof (i = t[r]) && (n += e(i) + 1), n == 1 / 0) return 1 / 0;
                    }
                    return n;
                }(e) <= t : void 0);
            }
            function f(e, t) {
                return !1 !== t && (e = y(e)), C(g.parse(e));
            }
            function C(e) {
                return g.serialize(e).split("#")[0] + "#";
            }
            var o = /#\/?$/;
            function y(e) {
                return e ? e.replace(o, "") : "";
            }
            function v(e, t) {
                return t = y(t), g.resolve(e, t);
            }
        },
        3483: function(e, t, i) {
            var r = i(8161), s = i(6862).toHash;
            e.exports = function() {
                var n = [
                    {
                        type: "number",
                        rules: [
                            {
                                maximum: [
                                    "exclusiveMaximum"
                                ]
                            },
                            {
                                minimum: [
                                    "exclusiveMinimum"
                                ]
                            },
                            "multipleOf",
                            "format"
                        ]
                    },
                    {
                        type: "string",
                        rules: [
                            "maxLength",
                            "minLength",
                            "pattern",
                            "format"
                        ]
                    },
                    {
                        type: "array",
                        rules: [
                            "maxItems",
                            "minItems",
                            "items",
                            "contains",
                            "uniqueItems"
                        ]
                    },
                    {
                        type: "object",
                        rules: [
                            "maxProperties",
                            "minProperties",
                            "required",
                            "dependencies",
                            "propertyNames",
                            {
                                properties: [
                                    "additionalProperties",
                                    "patternProperties"
                                ]
                            }
                        ]
                    },
                    {
                        rules: [
                            "$ref",
                            "const",
                            "enum",
                            "not",
                            "anyOf",
                            "oneOf",
                            "allOf",
                            "if"
                        ]
                    }
                ], o = [
                    "type",
                    "$comment"
                ];
                return n.all = s(o), n.types = s([
                    "number",
                    "integer",
                    "string",
                    "array",
                    "object",
                    "boolean",
                    "null"
                ]), n.forEach(function(e) {
                    e.rules = e.rules.map(function(e) {
                        var t, i;
                        return "object" == typeof e && (i = e[t = Object.keys(e)[0]], e = t, i.forEach(function(e) {
                            o.push(e), n.all[e] = !0;
                        })), o.push(e), n.all[e] = {
                            keyword: e,
                            code: r[e],
                            implements: i
                        };
                    }), n.all.$comment = {
                        keyword: "$comment",
                        code: r.$comment
                    }, e.type && (n.types[e.type] = e);
                }), n.keywords = s(o.concat([
                    "$schema",
                    "$id",
                    "id",
                    "$data",
                    "$async",
                    "title",
                    "description",
                    "default",
                    "definitions",
                    "examples",
                    "readOnly",
                    "writeOnly",
                    "contentMediaType",
                    "contentEncoding",
                    "additionalItems",
                    "then",
                    "else"
                ])), n.custom = {}, n;
            };
        },
        4427: function(e, t, i) {
            var n = i(6862);
            e.exports = function(e) {
                n.copy(e, this);
            };
        },
        611: function(e) {
            e.exports = function(e) {
                for(var t, i = 0, n = e.length, o = 0; o < n;)i++, 55296 <= (t = e.charCodeAt(o++)) && t <= 56319 && o < n && 56320 == (64512 & e.charCodeAt(o)) && o++;
                return i;
            };
        },
        6862: function(e, t, i) {
            function r(e, t, i, n) {
                var o = n ? " !== " : " === ", r = n ? " || " : " && ", s = n ? "!" : "", a = n ? "" : "!";
                switch(e){
                    case "null":
                        return t + o + "null";
                    case "array":
                        return s + "Array.isArray(" + t + ")";
                    case "object":
                        return "(" + s + t + r + "typeof " + t + o + '"object"' + r + a + "Array.isArray(" + t + "))";
                    case "integer":
                        return "(typeof " + t + o + '"number"' + r + a + "(" + t + " % 1)" + r + t + o + t + (i ? r + s + "isFinite(" + t + ")" : "") + ")";
                    case "number":
                        return "(typeof " + t + o + '"' + e + '"' + (i ? r + s + "isFinite(" + t + ")" : "") + ")";
                    default:
                        return "typeof " + t + o + '"' + e + '"';
                }
            }
            e.exports = {
                copy: function(e, t) {
                    for(var i in t = t || {}, e)t[i] = e[i];
                    return t;
                },
                checkDataType: r,
                checkDataTypes: function(e, t, i) {
                    if (1 === e.length) return r(e[0], t, i, !0);
                    var n, o = "", e = a(e);
                    for(n in e.array && e.object && (o = e.null ? "(" : "(!" + t + " || ", o += "typeof " + t + ' !== "object")', delete e.null, delete e.array, delete e.object), e.number && delete e.integer, e)o += (o ? " && " : "") + r(n, t, i, !0);
                    return o;
                },
                coerceToTypes: function(e, t) {
                    if (!Array.isArray(t)) return s[t] ? [
                        t
                    ] : "array" === e && "array" === t ? [
                        "array"
                    ] : void 0;
                    for(var i = [], n = 0; n < t.length; n++){
                        var o = t[n];
                        (s[o] || "array" === e && "array" === o) && (i[i.length] = o);
                    }
                    return i.length ? i : void 0;
                },
                toHash: a,
                getProperty: h,
                escapeQuotes: l,
                equal: i(5215),
                ucs2length: i(611),
                varOccurences: function(e, t) {
                    t += "[^0-9]";
                    e = e.match(new RegExp(t, "g"));
                    return e ? e.length : 0;
                },
                varReplace: function(e, t, i) {
                    return t += "([^0-9])", i = i.replace(/\$/g, "$$$$"), e.replace(new RegExp(t, "g"), i + "$1");
                },
                schemaHasRules: function(e, t) {
                    if ("boolean" == typeof e) return !e;
                    for(var i in e)if (t[i]) return !0;
                },
                schemaHasRulesExcept: function(e, t, i) {
                    if ("boolean" == typeof e) return !e && "not" != i;
                    for(var n in e)if (n != i && t[n]) return !0;
                },
                schemaUnknownRules: function(e, t) {
                    if ("boolean" != typeof e) {
                        for(var i in e)if (!t[i]) return i;
                    }
                },
                toQuotedString: c,
                getPathExpr: function(e, t, i, n) {
                    return g(e, i ? "'/' + " + t + (n ? "" : ".replace(/~/g, '~0').replace(/\\//g, '~1')") : n ? "'[' + " + t + " + ']'" : "'[\\'' + " + t + " + '\\']'");
                },
                getPath: function(e, t, i) {
                    i = c(i ? "/" + p(t) : h(t));
                    return g(e, i);
                },
                getData: function(e, t, i) {
                    var n, o, r;
                    if ("" === e) return "rootData";
                    if ("/" == e[0]) {
                        if (!d.test(e)) throw new Error("Invalid JSON-pointer: " + e);
                        n = e, o = "rootData";
                    } else {
                        if (!(r = e.match(u))) throw new Error("Invalid JSON-pointer: " + e);
                        if (e = +r[1], "#" == (n = r[2])) {
                            if (t <= e) throw new Error("Cannot access property/index " + e + " levels up, current level is " + t);
                            return i[t - e];
                        }
                        if (t < e) throw new Error("Cannot access data " + e + " levels up, current level is " + t);
                        if (o = "data" + (t - e || ""), !n) return o;
                    }
                    for(var s = o, a = n.split("/"), l = 0; l < a.length; l++){
                        var c = a[l];
                        c && (o += h(m(c)), s += " && " + o);
                    }
                    return s;
                },
                unescapeFragment: function(e) {
                    return m(decodeURIComponent(e));
                },
                unescapeJsonPointer: m,
                escapeFragment: function(e) {
                    return encodeURIComponent(p(e));
                },
                escapeJsonPointer: p
            };
            var s = a([
                "string",
                "number",
                "integer",
                "boolean",
                "null"
            ]);
            function a(e) {
                for(var t = {}, i = 0; i < e.length; i++)t[e[i]] = !0;
                return t;
            }
            var n = /^[a-z$_][a-z$_0-9]*$/i, o = /'|\\/g;
            function h(e) {
                return "number" == typeof e ? "[" + e + "]" : n.test(e) ? "." + e : "['" + l(e) + "']";
            }
            function l(e) {
                return e.replace(o, "\\$&").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\f/g, "\\f").replace(/\t/g, "\\t");
            }
            function c(e) {
                return "'" + l(e) + "'";
            }
            var d = /^\/(?:[^~]|~0|~1)*$/, u = /^([0-9]+)(#|\/(?:[^~]|~0|~1)*)?$/;
            function g(e, t) {
                return '""' == e ? t : (e + " + " + t).replace(/([^\\])' \+ '/g, "$1");
            }
            function p(e) {
                return e.replace(/~/g, "~0").replace(/\//g, "~1");
            }
            function m(e) {
                return e.replace(/~1/g, "/").replace(/~0/g, "~");
            }
        },
        8852: function(e) {
            var l = [
                "multipleOf",
                "maximum",
                "exclusiveMaximum",
                "minimum",
                "exclusiveMinimum",
                "maxLength",
                "minLength",
                "pattern",
                "additionalItems",
                "maxItems",
                "minItems",
                "uniqueItems",
                "maxProperties",
                "minProperties",
                "required",
                "additionalProperties",
                "enum",
                "format",
                "const"
            ];
            e.exports = function(e, t) {
                for(var i = 0; i < t.length; i++){
                    e = JSON.parse(JSON.stringify(e));
                    for(var n = t[i].split("/"), o = e, r = 1; r < n.length; r++)o = o[n[r]];
                    for(r = 0; r < l.length; r++){
                        var s = l[r], a = o[s];
                        a && (o[s] = {
                            anyOf: [
                                a,
                                {
                                    $ref: "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#"
                                }
                            ]
                        });
                    }
                }
                return e;
            };
        },
        9407: function(e, t, i) {
            i = i(8198);
            e.exports = {
                $id: "https://github.com/ajv-validator/ajv/blob/master/lib/definition_schema.js",
                definitions: {
                    simpleTypes: i.definitions.simpleTypes
                },
                type: "object",
                dependencies: {
                    schema: [
                        "validate"
                    ],
                    $data: [
                        "validate"
                    ],
                    statements: [
                        "inline"
                    ],
                    valid: {
                        not: {
                            required: [
                                "macro"
                            ]
                        }
                    }
                },
                properties: {
                    type: i.properties.type,
                    schema: {
                        type: "boolean"
                    },
                    statements: {
                        type: "boolean"
                    },
                    dependencies: {
                        type: "array",
                        items: {
                            type: "string"
                        }
                    },
                    metaSchema: {
                        type: "object"
                    },
                    modifying: {
                        type: "boolean"
                    },
                    valid: {
                        type: "boolean"
                    },
                    $data: {
                        type: "boolean"
                    },
                    async: {
                        type: "boolean"
                    },
                    errors: {
                        anyOf: [
                            {
                                type: "boolean"
                            },
                            {
                                const: "full"
                            }
                        ]
                    }
                }
            };
        },
        1765: function(e) {
            e.exports = function(e, t, i) {
                var n, o, r, s, a, l = " ", c = e.level, h = e.dataLevel, d = e.schema[t], u = e.schemaPath + e.util.getProperty(t), g = e.errSchemaPath + "/" + t, p = !e.opts.allErrors, m = "data" + (h || ""), f = e.opts.$data && d && d.$data, C = f ? (l += " var schema" + c + " = " + e.util.getData(d.$data, h, e.dataPathArr) + "; ", "schema" + c) : d, y = "maximum" == t, v = y ? "exclusiveMaximum" : "exclusiveMinimum", I = e.schema[v], b = e.opts.$data && I && I.$data, A = y ? "<" : ">", w = y ? ">" : "<", x = void 0;
                if (!f && "number" != typeof d && void 0 !== d) throw new Error(t + " must be number");
                if (!b && void 0 !== I && "number" != typeof I && "boolean" != typeof I) throw new Error(v + " must be number or boolean");
                b ? (h = e.util.getData(I.$data, h, e.dataPathArr), r = "exclIsNumber" + c, s = "' + " + (a = "op" + c) + " + '", x = v, (S = S || []).push(l = l + (" var schemaExcl" + c + " = " + h + "; ") + (" var " + (n = "exclusive" + c) + "; var " + (o = "exclType" + c) + " = typeof " + (h = "schemaExcl" + c) + "; if (" + o + " != 'boolean' && " + o + " != 'undefined' && " + o + " != 'number') { ")), l = "", !1 !== e.createErrors ? (l += " { keyword: '" + (x || "_exclusiveLimit") + "' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(g) + " , params: {} ", !1 !== e.opts.messages && (l += " , message: '" + v + " should be boolean' "), e.opts.verbose && (l += " , schema: validate.schema" + u + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + m + " "), l += " } ") : l += " {} ", k = l, l = S.pop(), !e.compositeRule && p ? e.async ? l += " throw new ValidationError([" + k + "]); " : l += " validate.errors = [" + k + "]; return false; " : l += " var err = " + k + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", l += " } else if ( ", f && (l += " (" + C + " !== undefined && typeof " + C + " != 'number') || "), l += " " + o + " == 'number' ? ( (" + n + " = " + C + " === undefined || " + h + " " + A + "= " + C + ") ? " + m + " " + w + "= " + h + " : " + m + " " + w + " " + C + " ) : ( (" + n + " = " + h + " === true) ? " + m + " " + w + "= " + C + " : " + m + " " + w + " " + C + " ) || " + m + " !== " + m + ") { var op" + c + " = " + n + " ? '" + A + "' : '" + A + "='; ", void 0 === d && (g = e.errSchemaPath + "/" + (x = v), C = h, f = b)) : (s = A, (r = "number" == typeof I) && f ? (a = "'" + s + "'", l += " if ( ", f && (l += " (" + C + " !== undefined && typeof " + C + " != 'number') || "), l += " ( " + C + " === undefined || " + I + " " + A + "= " + C + " ? " + m + " " + w + "= " + I + " : " + m + " " + w + " " + C + " ) || " + m + " !== " + m + ") { ") : (r && void 0 === d ? (n = !0, g = e.errSchemaPath + "/" + (x = v), C = I, w += "=") : (r && (C = Math[y ? "min" : "max"](I, d)), I === (!r || C) ? (n = !0, g = e.errSchemaPath + "/" + (x = v), w += "=") : (n = !1, s += "=")), a = "'" + s + "'", l += " if ( ", f && (l += " (" + C + " !== undefined && typeof " + C + " != 'number') || "), l += " " + m + " " + w + " " + C + " || " + m + " !== " + m + ") { ")), x = x || t;
                (S = S || []).push(l), l = "", !1 !== e.createErrors ? (l += " { keyword: '" + (x || "_limit") + "' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(g) + " , params: { comparison: " + a + ", limit: " + C + ", exclusive: " + n + " } ", !1 !== e.opts.messages && (l = l + " , message: 'should be " + s + " " + (f ? "' + " + C : C + "'")), e.opts.verbose && (l = (l += " , schema:  ") + (f ? "validate.schema" + u : "" + d) + "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + m + " "), l += " } ") : l += " {} ";
                var S, k = l;
                return l = S.pop(), !e.compositeRule && p ? e.async ? l += " throw new ValidationError([" + k + "]); " : l += " validate.errors = [" + k + "]; return false; " : l += " var err = " + k + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", l += " } ", p && (l += " else { "), l;
            };
        },
        9337: function(e) {
            e.exports = function(e, t, i) {
                var n, o = " ", r = e.level, s = e.dataLevel, a = e.schema[t], l = e.schemaPath + e.util.getProperty(t), c = e.errSchemaPath + "/" + t, h = !e.opts.allErrors, d = "data" + (s || ""), u = e.opts.$data && a && a.$data, s = u ? (o += " var schema" + r + " = " + e.util.getData(a.$data, s, e.dataPathArr) + "; ", "schema" + r) : a;
                if (u || "number" == typeof a) return o += "if ( ", u && (o += " (" + s + " !== undefined && typeof " + s + " != 'number') || "), (r = []).push(o += " " + d + ".length " + ("maxItems" == (n = t) ? ">" : "<") + " " + s + ") { "), o = "", !1 !== e.createErrors ? (o += " { keyword: '" + (n || "_limitItems") + "' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: { limit: " + s + " } ", !1 !== e.opts.messages && (o = (o = (o += " , message: 'should NOT have ") + ("maxItems" == t ? "more" : "fewer") + " than ") + (u ? "' + " + s + " + '" : "" + a) + " items' "), e.opts.verbose && (o = (o += " , schema:  ") + (u ? "validate.schema" + l : "" + a) + "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + d + " "), o += " } ") : o += " {} ", n = o, o = r.pop(), !e.compositeRule && h ? e.async ? o += " throw new ValidationError([" + n + "]); " : o += " validate.errors = [" + n + "]; return false; " : o += " var err = " + n + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", o += "} ", h && (o += " else { "), o;
                throw new Error(t + " must be number");
            };
        },
        5433: function(e) {
            e.exports = function(e, t, i) {
                var n, o = " ", r = e.level, s = e.dataLevel, a = e.schema[t], l = e.schemaPath + e.util.getProperty(t), c = e.errSchemaPath + "/" + t, h = !e.opts.allErrors, d = "data" + (s || ""), u = e.opts.$data && a && a.$data, s = u ? (o += " var schema" + r + " = " + e.util.getData(a.$data, s, e.dataPathArr) + "; ", "schema" + r) : a;
                if (u || "number" == typeof a) return o += "if ( ", u && (o += " (" + s + " !== undefined && typeof " + s + " != 'number') || "), !1 === e.opts.unicode ? o += " " + d + ".length " : o += " ucs2length(" + d + ") ", (r = []).push(o += " " + ("maxLength" == (n = t) ? ">" : "<") + " " + s + ") { "), o = "", !1 !== e.createErrors ? (o += " { keyword: '" + (n || "_limitLength") + "' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: { limit: " + s + " } ", !1 !== e.opts.messages && (o = (o = (o += " , message: 'should NOT be ") + ("maxLength" == t ? "longer" : "shorter") + " than ") + (u ? "' + " + s + " + '" : "" + a) + " characters' "), e.opts.verbose && (o = (o += " , schema:  ") + (u ? "validate.schema" + l : "" + a) + "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + d + " "), o += " } ") : o += " {} ", n = o, o = r.pop(), !e.compositeRule && h ? e.async ? o += " throw new ValidationError([" + n + "]); " : o += " validate.errors = [" + n + "]; return false; " : o += " var err = " + n + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", o += "} ", h && (o += " else { "), o;
                throw new Error(t + " must be number");
            };
        },
        7724: function(e) {
            e.exports = function(e, t, i) {
                var n, o = " ", r = e.level, s = e.dataLevel, a = e.schema[t], l = e.schemaPath + e.util.getProperty(t), c = e.errSchemaPath + "/" + t, h = !e.opts.allErrors, d = "data" + (s || ""), u = e.opts.$data && a && a.$data, s = u ? (o += " var schema" + r + " = " + e.util.getData(a.$data, s, e.dataPathArr) + "; ", "schema" + r) : a;
                if (u || "number" == typeof a) return o += "if ( ", u && (o += " (" + s + " !== undefined && typeof " + s + " != 'number') || "), (r = []).push(o += " Object.keys(" + d + ").length " + ("maxProperties" == (n = t) ? ">" : "<") + " " + s + ") { "), o = "", !1 !== e.createErrors ? (o += " { keyword: '" + (n || "_limitProperties") + "' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: { limit: " + s + " } ", !1 !== e.opts.messages && (o = (o = (o += " , message: 'should NOT have ") + ("maxProperties" == t ? "more" : "fewer") + " than ") + (u ? "' + " + s + " + '" : "" + a) + " properties' "), e.opts.verbose && (o = (o += " , schema:  ") + (u ? "validate.schema" + l : "" + a) + "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + d + " "), o += " } ") : o += " {} ", n = o, o = r.pop(), !e.compositeRule && h ? e.async ? o += " throw new ValidationError([" + n + "]); " : o += " validate.errors = [" + n + "]; return false; " : o += " var err = " + n + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", o += "} ", h && (o += " else { "), o;
                throw new Error(t + " must be number");
            };
        },
        3531: function(e) {
            e.exports = function(e, t, i) {
                var n = " ", o = e.schema[t], r = e.schemaPath + e.util.getProperty(t), s = e.errSchemaPath + "/" + t, a = !e.opts.allErrors, l = e.util.copy(e), c = "", h = (l.level++, "valid" + l.level), d = l.baseId, u = !0, g = o;
                if (g) for(var p, m = -1, f = g.length - 1; m < f;)p = g[m += 1], (e.opts.strictKeywords ? "object" == typeof p && 0 < Object.keys(p).length || !1 === p : e.util.schemaHasRules(p, e.RULES.all)) && (u = !1, l.schema = p, l.schemaPath = r + "[" + m + "]", l.errSchemaPath = s + "/" + m, n += "  " + e.validate(l) + " ", l.baseId = d, a) && (n += " if (" + h + ") { ", c += "}");
                return a && (n += u ? " if (true) { " : " " + c.slice(0, -1) + " "), n;
            };
        },
        8854: function(e) {
            e.exports = function(t, e, i) {
                var n = " ", o = t.level, r = t.dataLevel, s = t.schema[e], a = t.schemaPath + t.util.getProperty(e), l = t.errSchemaPath + "/" + e, e = !t.opts.allErrors, r = "data" + (r || ""), c = "valid" + o, o = "errs__" + o, h = t.util.copy(t), d = "", u = (h.level++, "valid" + h.level);
                if (s.every(function(e) {
                    return t.opts.strictKeywords ? "object" == typeof e && 0 < Object.keys(e).length || !1 === e : t.util.schemaHasRules(e, t.RULES.all);
                })) {
                    var g = h.baseId, p = (n += " var " + o + " = errors; var " + c + " = false;  ", t.compositeRule), m = (t.compositeRule = h.compositeRule = !0, s);
                    if (m) for(var f, C = -1, y = m.length - 1; C < y;)f = m[C += 1], h.schema = f, h.schemaPath = a + "[" + C + "]", h.errSchemaPath = l + "/" + C, n += "  " + t.validate(h) + " ", h.baseId = g, n += " " + c + " = " + c + " || " + u + "; if (!" + c + ") { ", d += "}";
                    t.compositeRule = h.compositeRule = p, n += " " + d + " if (!" + c + ") {   var err =   ", !1 !== t.createErrors ? (n += " { keyword: 'anyOf' , dataPath: (dataPath || '') + " + t.errorPath + " , schemaPath: " + t.util.toQuotedString(l) + " , params: {} ", !1 !== t.opts.messages && (n += " , message: 'should match some schema in anyOf' "), t.opts.verbose && (n += " , schema: validate.schema" + a + " , parentSchema: validate.schema" + t.schemaPath + " , data: " + r + " "), n += " } ") : n += " {} ", n += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", !t.compositeRule && e && (t.async ? n += " throw new ValidationError(vErrors); " : n += " validate.errors = vErrors; return false; "), n += " } else {  errors = " + o + "; if (vErrors !== null) { if (" + o + ") vErrors.length = " + o + "; else vErrors = null; } ", t.opts.allErrors && (n += " } ");
                } else e && (n += " if (true) { ");
                return n;
            };
        },
        8372: function(e) {
            e.exports = function(e, t, i) {
                var n = " ", o = e.schema[t], t = e.errSchemaPath + "/" + t, o = (e.opts.allErrors, e.util.toQuotedString(o));
                return !0 === e.opts.$comment ? n += " console.log(" + o + ");" : "function" == typeof e.opts.$comment && (n += " self._opts.$comment(" + o + ", " + e.util.toQuotedString(t) + ", validate.root.schema);"), n;
            };
        },
        9650: function(e) {
            e.exports = function(e, t, i) {
                var n = " ", o = e.level, r = e.dataLevel, s = e.schema[t], a = e.schemaPath + e.util.getProperty(t), t = e.errSchemaPath + "/" + t, l = !e.opts.allErrors, c = "data" + (r || ""), h = "valid" + o, d = e.opts.$data && s && s.$data, s = (d && (n += " var schema" + o + " = " + e.util.getData(s.$data, r, e.dataPathArr) + "; "), d || (n += " var schema" + o + " = validate.schema" + a + ";"), []), r = (s.push(n += "var " + h + " = equal(" + c + ", schema" + o + "); if (!" + h + ") {   "), n = "", !1 !== e.createErrors ? (n += " { keyword: 'const' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(t) + " , params: { allowedValue: schema" + o + " } ", !1 !== e.opts.messages && (n += " , message: 'should be equal to constant' "), e.opts.verbose && (n += " , schema: validate.schema" + a + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), n += " } ") : n += " {} ", n), n = s.pop();
                return !e.compositeRule && l ? e.async ? n += " throw new ValidationError([" + r + "]); " : n += " validate.errors = [" + r + "]; return false; " : n += " var err = " + r + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", n += " }", l && (n += " else { "), n;
            };
        },
        1292: function(e) {
            e.exports = function(e, t, i) {
                var n = " ", o = e.level, r = e.dataLevel, s = e.schema[t], a = e.schemaPath + e.util.getProperty(t), t = e.errSchemaPath + "/" + t, l = !e.opts.allErrors, r = "data" + (r || ""), c = "valid" + o, h = "errs__" + o, d = e.util.copy(e), u = (d.level++, "valid" + d.level), o = "i" + o, g = d.dataLevel = e.dataLevel + 1, p = "data" + g, m = e.baseId, f = e.opts.strictKeywords ? "object" == typeof s && 0 < Object.keys(s).length || !1 === s : e.util.schemaHasRules(s, e.RULES.all), o = (n += "var " + h + " = errors;var " + c + ";", f ? (c = e.compositeRule, e.compositeRule = d.compositeRule = !0, d.schema = s, d.schemaPath = a, d.errSchemaPath = t, n += " var " + u + " = false; for (var " + o + " = 0; " + o + " < " + r + ".length; " + o + "++) { ", d.errorPath = e.util.getPathExpr(e.errorPath, o, e.opts.jsonPointers, !0), s = r + "[" + o + "]", d.dataPathArr[g] = o, g = e.validate(d), d.baseId = m, e.util.varOccurences(g, p) < 2 ? n += " " + e.util.varReplace(g, p, s) + " " : n += " var " + p + " = " + s + "; " + g + " ", n += " if (" + u + ") break; }  ", e.compositeRule = d.compositeRule = c, n += "  if (!" + u + ") {") : n += " if (" + r + ".length == 0) {", []), m = (o.push(n), n = "", !1 !== e.createErrors ? (n += " { keyword: 'contains' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(t) + " , params: {} ", !1 !== e.opts.messages && (n += " , message: 'should contain a valid item' "), e.opts.verbose && (n += " , schema: validate.schema" + a + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + r + " "), n += " } ") : n += " {} ", n), n = o.pop();
                return !e.compositeRule && l ? e.async ? n += " throw new ValidationError([" + m + "]); " : n += " validate.errors = [" + m + "]; return false; " : n += " var err = " + m + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", n += " } else { ", f && (n += "  errors = " + h + "; if (vErrors !== null) { if (" + h + ") vErrors.length = " + h + "; else vErrors = null; } "), e.opts.allErrors && (n += " } "), n;
            };
        },
        8050: function(e) {
            e.exports = function(e, t, i) {
                var n, o, r, s = " ", a = e.level, l = e.dataLevel, c = e.schema[t], h = e.schemaPath + e.util.getProperty(t), d = e.errSchemaPath + "/" + t, u = !e.opts.allErrors, g = "data" + (l || ""), p = "valid" + a, m = "errs__" + a, f = e.opts.$data && c && c.$data, C = f ? (s += " var schema" + a + " = " + e.util.getData(c.$data, l, e.dataPathArr) + "; ", "schema" + a) : c, y = "definition" + a, v = this.definition, I = "";
                if (f && v.$data) {
                    var b = "keywordValidate" + a, A = v.validateSchema;
                    s += " var " + y + " = RULES.custom['" + t + "'].definition; var " + b + " = " + y + ".validate;";
                } else {
                    if (!(k = e.useCustomRule(this, c, e.schema, e))) return;
                    C = "validate.schema" + h, b = k.code, n = v.compile, o = v.inline, r = v.macro;
                }
                var w, x, S, k, T, t = b + ".errors", c = "i" + a, E = "ruleErr" + a, R = v.async;
                if (R && !e.async) throw new Error("async keyword in sync schema");
                return o || r || (s += t + " = null;"), s += "var " + m + " = errors;var " + p + ";", f && v.$data && (I += "}", s += " if (" + C + " === undefined) { " + p + " = true; } else { ", A) && (I += "}", s += " " + p + " = " + y + ".validateSchema(" + C + "); if (" + p + ") { "), o ? v.statements ? s += " " + k.validate + " " : s += " " + p + " = " + k.validate + "; " : r ? (I = "", (f = e.util.copy(e)).level++, w = "valid" + f.level, f.schema = k.validate, f.schemaPath = "", A = e.compositeRule, e.compositeRule = f.compositeRule = !0, y = e.validate(f).replace(/validate\.schema/g, b), e.compositeRule = f.compositeRule = A, s += " " + y) : ((T = T || []).push(s), s = "", s += "  " + b + ".call( ", e.opts.passContext ? s += "this" : s += "self", n || !1 === v.schema ? s += " , " + g + " " : s += " , " + C + " , " + g + " , validate.schema" + e.schemaPath + " ", s += " , (dataPath || '')", '""' != e.errorPath && (s += " + " + e.errorPath), k = s += " , " + (x = l ? "data" + (l - 1 || "") : "parentData") + " , " + (S = l ? e.dataPathArr[l] : "parentDataProperty") + " , rootData )  ", s = T.pop(), !1 === v.errors ? (s += " " + p + " = ", R && (s += "await "), s += k + "; ") : s += R ? " var " + (t = "customErrors" + a) + " = null; try { " + p + " = await " + k + "; } catch (e) { " + p + " = false; if (e instanceof ValidationError) " + t + " = e.errors; else throw e; } " : " " + t + " = null; " + p + " = " + k + "; "), v.modifying && (s += " if (" + x + ") " + g + " = " + x + "[" + S + "];"), s += "" + I, v.valid ? u && (s += " if (true) { ") : (s += " if ( ", void 0 === v.valid ? s = s + " !" + (r ? "" + w : p) : s += " " + !v.valid + " ", f = this.keyword, (T = T || []).push(s += ") { "), (T = T || []).push(s = ""), s = "", !1 !== e.createErrors ? (s += " { keyword: '" + (f || "custom") + "' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(d) + " , params: { keyword: '" + this.keyword + "' } ", !1 !== e.opts.messages && (s += " , message: 'should pass \"" + this.keyword + "\" keyword validation' "), e.opts.verbose && (s += " , schema: validate.schema" + h + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + g + " "), s += " } ") : s += " {} ", A = s, s = T.pop(), !e.compositeRule && u ? e.async ? s += " throw new ValidationError([" + A + "]); " : s += " validate.errors = [" + A + "]; return false; " : s += " var err = " + A + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", y = s, s = T.pop(), o ? v.errors ? "full" != v.errors && (s += "  for (var " + c + "=" + m + "; " + c + "<errors; " + c + "++) { var " + E + " = vErrors[" + c + "]; if (" + E + ".dataPath === undefined) " + E + ".dataPath = (dataPath || '') + " + e.errorPath + "; if (" + E + ".schemaPath === undefined) { " + E + '.schemaPath = "' + d + '"; } ', e.opts.verbose && (s += " " + E + ".schema = " + C + "; " + E + ".data = " + g + "; "), s += " } ") : !1 === v.errors ? s += " " + y + " " : (s += " if (" + m + " == errors) { " + y + " } else {  for (var " + c + "=" + m + "; " + c + "<errors; " + c + "++) { var " + E + " = vErrors[" + c + "]; if (" + E + ".dataPath === undefined) " + E + ".dataPath = (dataPath || '') + " + e.errorPath + "; if (" + E + ".schemaPath === undefined) { " + E + '.schemaPath = "' + d + '"; } ', e.opts.verbose && (s += " " + E + ".schema = " + C + "; " + E + ".data = " + g + "; "), s += " } } ") : r ? (s += "   var err =   ", !1 !== e.createErrors ? (s += " { keyword: '" + (f || "custom") + "' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(d) + " , params: { keyword: '" + this.keyword + "' } ", !1 !== e.opts.messages && (s += " , message: 'should pass \"" + this.keyword + "\" keyword validation' "), e.opts.verbose && (s += " , schema: validate.schema" + h + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + g + " "), s += " } ") : s += " {} ", s += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", !e.compositeRule && u && (e.async ? s += " throw new ValidationError(vErrors); " : s += " validate.errors = vErrors; return false; ")) : !1 === v.errors ? s += " " + y + " " : (s += " if (Array.isArray(" + t + ")) { if (vErrors === null) vErrors = " + t + "; else vErrors = vErrors.concat(" + t + "); errors = vErrors.length;  for (var " + c + "=" + m + "; " + c + "<errors; " + c + "++) { var " + E + " = vErrors[" + c + "]; if (" + E + ".dataPath === undefined) " + E + ".dataPath = (dataPath || '') + " + e.errorPath + ";  " + E + '.schemaPath = "' + d + '";  ', e.opts.verbose && (s += " " + E + ".schema = " + C + "; " + E + ".data = " + g + "; "), s += " } } else { " + y + " } "), s += " } ", u && (s += " else { ")), s;
            };
        },
        2860: function(e) {
            e.exports = function(e, t, i) {
                var n, o = " ", r = e.level, s = e.dataLevel, a = e.schema[t], l = e.schemaPath + e.util.getProperty(t), c = e.errSchemaPath + "/" + t, h = !e.opts.allErrors, d = "data" + (s || ""), t = "errs__" + r, u = e.util.copy(e), g = "", p = (u.level++, "valid" + u.level), m = {}, f = {}, C = e.opts.ownProperties;
                for(_ in a)"__proto__" != _ && (M = a[_], (n = Array.isArray(M) ? f : m)[_] = M);
                var y = e.errorPath;
                for(_ in o = o + ("var " + t + " = errors;") + ("var missing" + r + ";"), f)if ((n = f[_]).length) {
                    if (o += " if ( " + d + e.util.getProperty(_) + " !== undefined ", C && (o += " && Object.prototype.hasOwnProperty.call(" + d + ", '" + e.util.escapeQuotes(_) + "') "), h) {
                        o += " && ( ";
                        var v = n;
                        if (v) for(var I = -1, b = v.length - 1; I < b;)k = v[I += 1], I && (o += " || "), o += " ( ( " + ($ = d + (R = e.util.getProperty(k))) + " === undefined ", C && (o += " || ! Object.prototype.hasOwnProperty.call(" + d + ", '" + e.util.escapeQuotes(k) + "') "), o += ") && (missing" + r + " = " + e.util.toQuotedString(e.opts.jsonPointers ? k : R) + ") ) ";
                        o += ")) {  ";
                        var A = "missing" + r, w = "' + " + A + " + '", x = (e.opts._errorDataPathProperty && (e.errorPath = e.opts.jsonPointers ? e.util.getPathExpr(y, A, !0) : y + " + " + A), x || []), A = (x.push(o), o = "", !1 !== e.createErrors ? (o += " { keyword: 'dependencies' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: { property: '" + e.util.escapeQuotes(_) + "', missingProperty: '" + w + "', depsCount: " + n.length + ", deps: '" + e.util.escapeQuotes(1 == n.length ? n[0] : n.join(", ")) + "' } ", !1 !== e.opts.messages && (o += " , message: 'should have ", 1 == n.length ? o += "property " + e.util.escapeQuotes(n[0]) : o += "properties " + e.util.escapeQuotes(n.join(", ")), o += " when property " + e.util.escapeQuotes(_) + " is present' "), e.opts.verbose && (o += " , schema: validate.schema" + l + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + d + " "), o += " } ") : o += " {} ", o), o = x.pop();
                        !e.compositeRule && h ? e.async ? o += " throw new ValidationError([" + A + "]); " : o += " validate.errors = [" + A + "]; return false; " : o += " var err = " + A + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
                    } else {
                        o += " ) { ";
                        var S = n;
                        if (S) for(var k, T = -1, E = S.length - 1; T < E;){
                            k = S[T += 1];
                            var R = e.util.getProperty(k), w = e.util.escapeQuotes(k), $ = d + R;
                            e.opts._errorDataPathProperty && (e.errorPath = e.util.getPath(y, k, e.opts.jsonPointers)), o += " if ( " + $ + " === undefined ", C && (o += " || ! Object.prototype.hasOwnProperty.call(" + d + ", '" + e.util.escapeQuotes(k) + "') "), o += ") {  var err =   ", !1 !== e.createErrors ? (o += " { keyword: 'dependencies' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: { property: '" + e.util.escapeQuotes(_) + "', missingProperty: '" + w + "', depsCount: " + n.length + ", deps: '" + e.util.escapeQuotes(1 == n.length ? n[0] : n.join(", ")) + "' } ", !1 !== e.opts.messages && (o += " , message: 'should have ", 1 == n.length ? o += "property " + e.util.escapeQuotes(n[0]) : o += "properties " + e.util.escapeQuotes(n.join(", ")), o += " when property " + e.util.escapeQuotes(_) + " is present' "), e.opts.verbose && (o += " , schema: validate.schema" + l + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + d + " "), o += " } ") : o += " {} ", o += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } ";
                        }
                    }
                    o += " }   ", h && (g += "}", o += " else { ");
                }
                e.errorPath = y;
                var _, L = u.baseId;
                for(_ in m){
                    var M = m[_];
                    (e.opts.strictKeywords ? "object" == typeof M && 0 < Object.keys(M).length || !1 === M : e.util.schemaHasRules(M, e.RULES.all)) && (o += " " + p + " = true; if ( " + d + e.util.getProperty(_) + " !== undefined ", C && (o += " && Object.prototype.hasOwnProperty.call(" + d + ", '" + e.util.escapeQuotes(_) + "') "), o += ") { ", u.schema = M, u.schemaPath = l + e.util.getProperty(_), u.errSchemaPath = c + "/" + e.util.escapeFragment(_), o += "  " + e.validate(u) + " ", u.baseId = L, o += " }  ", h) && (o += " if (" + p + ") { ", g += "}");
                }
                return h && (o += "   " + g + " if (" + t + " == errors) {"), o;
            };
        },
        7112: function(e) {
            e.exports = function(e, t, i) {
                var n = " ", o = e.level, r = e.dataLevel, s = e.schema[t], a = e.schemaPath + e.util.getProperty(t), t = e.errSchemaPath + "/" + t, l = !e.opts.allErrors, c = "data" + (r || ""), h = "valid" + o, d = e.opts.$data && s && s.$data, s = (d && (n += " var schema" + o + " = " + e.util.getData(s.$data, r, e.dataPathArr) + "; "), "i" + o), r = "schema" + o, r = (d || (n += " var " + r + " = validate.schema" + a + ";"), n += "var " + h + ";", d && (n += " if (schema" + o + " === undefined) " + h + " = true; else if (!Array.isArray(schema" + o + ")) " + h + " = false; else {"), n += h + " = false;for (var " + s + "=0; " + s + "<" + r + ".length; " + s + "++) if (equal(" + c + ", " + r + "[" + s + "])) { " + h + " = true; break; }", d && (n += "  }  "), []), s = (r.push(n += " if (!" + h + ") {   "), n = "", !1 !== e.createErrors ? (n += " { keyword: 'enum' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(t) + " , params: { allowedValues: schema" + o + " } ", !1 !== e.opts.messages && (n += " , message: 'should be equal to one of the allowed values' "), e.opts.verbose && (n += " , schema: validate.schema" + a + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), n += " } ") : n += " {} ", n), n = r.pop();
                return !e.compositeRule && l ? e.async ? n += " throw new ValidationError([" + s + "]); " : n += " validate.errors = [" + s + "]; return false; " : n += " var err = " + s + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", n += " }", l && (n += " else { "), n;
            };
        },
        4682: function(e) {
            e.exports = function(e, t, i) {
                var n = " ", o = e.level, r = e.dataLevel, s = e.schema[t], a = e.schemaPath + e.util.getProperty(t), t = e.errSchemaPath + "/" + t, l = !e.opts.allErrors, c = "data" + (r || "");
                if (!1 === e.opts.format) l && (n += " if (true) { ");
                else {
                    var h, d = e.opts.$data && s && s.$data, r = d ? (n += " var schema" + o + " = " + e.util.getData(s.$data, r, e.dataPathArr) + "; ", "schema" + o) : s, u = e.opts.unknownFormats, g = Array.isArray(u);
                    if (d) n += " var " + (h = "format" + o) + " = formats[" + r + "]; var " + (p = "isObject" + o) + " = typeof " + h + " == 'object' && !(" + h + " instanceof RegExp) && " + h + ".validate; var " + (f = "formatType" + o) + " = " + p + " && " + h + ".type || 'string'; if (" + p + ") { ", e.async && (n += " var async" + o + " = " + h + ".async; "), n += " " + h + " = " + h + ".validate; } if (  ", d && (n += " (" + r + " !== undefined && typeof " + r + " != 'string') || "), n += " (", "ignore" != u && (n += " (" + r + " && !" + h + " ", g && (n += " && self._opts.unknownFormats.indexOf(" + r + ") == -1 "), n += ") || "), n = (n += " (" + h + " && " + f + " == '" + i + "' && !(typeof " + h + " == 'function' ? ") + (e.async ? " (async" + o + " ? await " + h + "(" + c + ") : " + h + "(" + c + ")) " : " " + h + "(" + c + ") ") + (" : " + h + ".test(" + c + "))))) {");
                    else {
                        if (!(h = e.formats[s])) {
                            if ("ignore" == u) return e.logger.warn('unknown format "' + s + '" ignored in schema at path "' + e.errSchemaPath + '"'), l && (n += " if (true) { "), n;
                            if (g && 0 <= u.indexOf(s)) return l && (n += " if (true) { "), n;
                            throw new Error('unknown format "' + s + '" is used in schema at path "' + e.errSchemaPath + '"');
                        }
                        var p, m, f = (p = "object" == typeof h && !(h instanceof RegExp) && h.validate) && h.type || "string";
                        if (p && (m = !0 === h.async, h = h.validate), f != i) return l && (n += " if (true) { "), n;
                        if (m) {
                            if (!e.async) throw new Error("async format in sync schema");
                            n += " if (!(await " + (C = "formats" + e.util.getProperty(s) + ".validate") + "(" + c + "))) { ";
                        } else {
                            n += " if (! ";
                            var C = "formats" + e.util.getProperty(s);
                            p && (C += ".validate"), n = n + ("function" == typeof h ? " " + C + "(" + c + ") " : " " + C + ".test(" + c + ") ") + ") { ";
                        }
                    }
                    o = [], g = (o.push(n), n = "", !1 !== e.createErrors ? (n = (n += " { keyword: 'format' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(t) + " , params: { format:  ") + (d ? "" + r : "" + e.util.toQuotedString(s)) + "  } ", !1 !== e.opts.messages && (n = (n += " , message: 'should match format \"") + (d ? "' + " + r + " + '" : "" + e.util.escapeQuotes(s)) + "\"' "), e.opts.verbose && (n = (n = (n += " , schema:  ") + (d ? "validate.schema" + a : "" + e.util.toQuotedString(s))) + "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), n += " } ") : n += " {} ", n), n = o.pop();
                    !e.compositeRule && l ? e.async ? n += " throw new ValidationError([" + g + "]); " : n += " validate.errors = [" + g + "]; return false; " : n += " var err = " + g + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", n += " } ", l && (n += " else { ");
                }
                return n;
            };
        },
        1678: function(e) {
            e.exports = function(e, t, i) {
                var n, o = " ", r = e.level, s = e.dataLevel, a = e.schema[t], l = e.schemaPath + e.util.getProperty(t), t = e.errSchemaPath + "/" + t, c = !e.opts.allErrors, s = "data" + (s || ""), h = "valid" + r, d = "errs__" + r, u = e.util.copy(e), g = (u.level++, "valid" + u.level), p = e.schema.then, m = e.schema.else, p = void 0 !== p && (e.opts.strictKeywords ? "object" == typeof p && 0 < Object.keys(p).length || !1 === p : e.util.schemaHasRules(p, e.RULES.all)), m = void 0 !== m && (e.opts.strictKeywords ? "object" == typeof m && 0 < Object.keys(m).length || !1 === m : e.util.schemaHasRules(m, e.RULES.all)), f = u.baseId;
                return p || m ? (u.createErrors = !1, u.schema = a, u.schemaPath = l, u.errSchemaPath = t, o += " var " + d + " = errors; var " + h + " = true;  ", a = e.compositeRule, e.compositeRule = u.compositeRule = !0, o += "  " + e.validate(u) + " ", u.baseId = f, u.createErrors = !0, o += "  errors = " + d + "; if (vErrors !== null) { if (" + d + ") vErrors.length = " + d + "; else vErrors = null; }  ", e.compositeRule = u.compositeRule = a, p ? (o += " if (" + g + ") {  ", u.schema = e.schema.then, u.schemaPath = e.schemaPath + ".then", u.errSchemaPath = e.errSchemaPath + "/then", o += "  " + e.validate(u) + " ", u.baseId = f, o += " " + h + " = " + g + "; ", p && m ? o += " var " + (n = "ifClause" + r) + " = 'then'; " : n = "'then'", o += " } ", m && (o += " else { ")) : o += " if (!" + g + ") { ", m && (u.schema = e.schema.else, u.schemaPath = e.schemaPath + ".else", u.errSchemaPath = e.errSchemaPath + "/else", o += "  " + e.validate(u) + " ", u.baseId = f, o += " " + h + " = " + g + "; ", p && m ? o += " var " + (n = "ifClause" + r) + " = 'else'; " : n = "'else'", o += " } "), o += " if (!" + h + ") {   var err =   ", !1 !== e.createErrors ? (o += " { keyword: 'if' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(t) + " , params: { failingKeyword: " + n + " } ", !1 !== e.opts.messages && (o += " , message: 'should match \"' + " + n + " + '\" schema' "), e.opts.verbose && (o += " , schema: validate.schema" + l + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + s + " "), o += " } ") : o += " {} ", o += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", !e.compositeRule && c && (e.async ? o += " throw new ValidationError(vErrors); " : o += " validate.errors = vErrors; return false; "), o += " }   ", c && (o += " else { ")) : c && (o += " if (true) { "), o;
            };
        },
        8161: function(e, t, i) {
            e.exports = {
                $ref: i(7096),
                allOf: i(3531),
                anyOf: i(8854),
                $comment: i(8372),
                const: i(9650),
                contains: i(1292),
                dependencies: i(2860),
                enum: i(7112),
                format: i(4682),
                if: i(1678),
                items: i(3913),
                maximum: i(1765),
                minimum: i(1765),
                maxItems: i(9337),
                minItems: i(9337),
                maxLength: i(5433),
                minLength: i(5433),
                maxProperties: i(7724),
                minProperties: i(7724),
                multipleOf: i(812),
                not: i(1004),
                oneOf: i(6288),
                pattern: i(2079),
                properties: i(2124),
                propertyNames: i(4926),
                required: i(2e3),
                uniqueItems: i(7812),
                validate: i(1035)
            };
        },
        3913: function(e) {
            e.exports = function(e, t, i) {
                var n = " ", o = e.level, r = e.dataLevel, s = e.schema[t], a = e.schemaPath + e.util.getProperty(t), l = e.errSchemaPath + "/" + t, c = !e.opts.allErrors, h = "data" + (r || ""), t = "valid" + o, r = "errs__" + o, d = e.util.copy(e), u = "", g = (d.level++, "valid" + d.level), o = "i" + o, p = d.dataLevel = e.dataLevel + 1, m = "data" + p, f = e.baseId;
                if (n += "var " + r + " = errors;var " + t + ";", Array.isArray(s)) {
                    var C, y, v = e.schema.additionalItems, I = (!1 === v && (n += " " + t + " = " + h + ".length <= " + s.length + "; ", C = l, l = e.errSchemaPath + "/additionalItems", (y = y || []).push(n += "  if (!" + t + ") {   "), n = "", !1 !== e.createErrors ? (n += " { keyword: 'additionalItems' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(l) + " , params: { limit: " + s.length + " } ", !1 !== e.opts.messages && (n += " , message: 'should NOT have more than " + s.length + " items' "), e.opts.verbose && (n += " , schema: false , parentSchema: validate.schema" + e.schemaPath + " , data: " + h + " "), n += " } ") : n += " {} ", t = n, n = y.pop(), !e.compositeRule && c ? e.async ? n += " throw new ValidationError([" + t + "]); " : n += " validate.errors = [" + t + "]; return false; " : n += " var err = " + t + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", n += " } ", l = C, c) && (u += "}", n += " else { "), s);
                    if (I) for(var b = -1, A = I.length - 1; b < A;){
                        var w, x, S = I[b += 1];
                        (e.opts.strictKeywords ? "object" == typeof S && 0 < Object.keys(S).length || !1 === S : e.util.schemaHasRules(S, e.RULES.all)) && (n += " " + g + " = true; if (" + h + ".length > " + b + ") { ", w = h + "[" + b + "]", d.schema = S, d.schemaPath = a + "[" + b + "]", d.errSchemaPath = l + "/" + b, d.errorPath = e.util.getPathExpr(e.errorPath, b, e.opts.jsonPointers, !0), d.dataPathArr[p] = b, x = e.validate(d), d.baseId = f, e.util.varOccurences(x, m) < 2 ? n += " " + e.util.varReplace(x, m, w) + " " : n += " var " + m + " = " + w + "; " + x + " ", n += " }  ", c) && (n += " if (" + g + ") { ", u += "}");
                    }
                    "object" == typeof v && (e.opts.strictKeywords ? "object" == typeof v && 0 < Object.keys(v).length || !1 === v : e.util.schemaHasRules(v, e.RULES.all)) && (d.schema = v, d.schemaPath = e.schemaPath + ".additionalItems", d.errSchemaPath = e.errSchemaPath + "/additionalItems", n += " " + g + " = true; if (" + h + ".length > " + s.length + ") {  for (var " + o + " = " + s.length + "; " + o + " < " + h + ".length; " + o + "++) { ", d.errorPath = e.util.getPathExpr(e.errorPath, o, e.opts.jsonPointers, !0), w = h + "[" + o + "]", d.dataPathArr[p] = o, x = e.validate(d), d.baseId = f, e.util.varOccurences(x, m) < 2 ? n += " " + e.util.varReplace(x, m, w) + " " : n += " var " + m + " = " + w + "; " + x + " ", c && (n += " if (!" + g + ") break; "), n += " } }  ", c) && (n += " if (" + g + ") { ", u += "}");
                } else (e.opts.strictKeywords ? "object" == typeof s && 0 < Object.keys(s).length || !1 === s : e.util.schemaHasRules(s, e.RULES.all)) && (d.schema = s, d.schemaPath = a, d.errSchemaPath = l, n += "  for (var " + o + " = 0; " + o + " < " + h + ".length; " + o + "++) { ", d.errorPath = e.util.getPathExpr(e.errorPath, o, e.opts.jsonPointers, !0), w = h + "[" + o + "]", d.dataPathArr[p] = o, x = e.validate(d), d.baseId = f, e.util.varOccurences(x, m) < 2 ? n += " " + e.util.varReplace(x, m, w) + " " : n += " var " + m + " = " + w + "; " + x + " ", c && (n += " if (!" + g + ") break; "), n += " }");
                return c && (n += " " + u + " if (" + r + " == errors) {"), n;
            };
        },
        812: function(e) {
            e.exports = function(e, t, i) {
                var n = " ", o = e.level, r = e.dataLevel, s = e.schema[t], a = e.schemaPath + e.util.getProperty(t), l = e.errSchemaPath + "/" + t, c = !e.opts.allErrors, h = "data" + (r || ""), d = e.opts.$data && s && s.$data, r = d ? (n += " var schema" + o + " = " + e.util.getData(s.$data, r, e.dataPathArr) + "; ", "schema" + o) : s;
                if (!d && "number" != typeof s) throw new Error(t + " must be number");
                n += "var division" + o + ";if (", d && (n += " " + r + " !== undefined && ( typeof " + r + " != 'number' || "), n += " (division" + o + " = " + h + " / " + r + ", ", e.opts.multipleOfPrecision ? n += " Math.abs(Math.round(division" + o + ") - division" + o + ") > 1e-" + e.opts.multipleOfPrecision + " " : n += " division" + o + " !== parseInt(division" + o + ") ", n += " ) ", d && (n += "  )  ");
                t = [], t.push(n += " ) {   "), n = "", !1 !== e.createErrors ? (n += " { keyword: 'multipleOf' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(l) + " , params: { multipleOf: " + r + " } ", !1 !== e.opts.messages && (n = n + " , message: 'should be multiple of " + (d ? "' + " + r : r + "'")), e.opts.verbose && (n = (n += " , schema:  ") + (d ? "validate.schema" + a : "" + s) + "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + h + " "), n += " } ") : n += " {} ", o = n, n = t.pop();
                return !e.compositeRule && c ? e.async ? n += " throw new ValidationError([" + o + "]); " : n += " validate.errors = [" + o + "]; return false; " : n += " var err = " + o + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", n += "} ", c && (n += " else { "), n;
            };
        },
        1004: function(e) {
            e.exports = function(e, t, i) {
                var n, o, r = " ", s = e.level, a = e.dataLevel, l = e.schema[t], c = e.schemaPath + e.util.getProperty(t), t = e.errSchemaPath + "/" + t, h = !e.opts.allErrors, a = "data" + (a || ""), s = "errs__" + s, d = e.util.copy(e), u = (d.level++, "valid" + d.level);
                return (e.opts.strictKeywords ? "object" == typeof l && 0 < Object.keys(l).length || !1 === l : e.util.schemaHasRules(l, e.RULES.all)) ? (d.schema = l, d.schemaPath = c, d.errSchemaPath = t, r += " var " + s + " = errors;  ", l = e.compositeRule, e.compositeRule = d.compositeRule = !0, d.createErrors = !1, d.opts.allErrors && (o = d.opts.allErrors, d.opts.allErrors = !1), r += " " + e.validate(d) + " ", d.createErrors = !0, o && (d.opts.allErrors = o), e.compositeRule = d.compositeRule = l, (n = n || []).push(r += " if (" + u + ") {   "), r = "", !1 !== e.createErrors ? (r += " { keyword: 'not' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(t) + " , params: {} ", !1 !== e.opts.messages && (r += " , message: 'should NOT be valid' "), e.opts.verbose && (r += " , schema: validate.schema" + c + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + a + " "), r += " } ") : r += " {} ", o = r, r = n.pop(), !e.compositeRule && h ? e.async ? r += " throw new ValidationError([" + o + "]); " : r += " validate.errors = [" + o + "]; return false; " : r += " var err = " + o + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", r += " } else {  errors = " + s + "; if (vErrors !== null) { if (" + s + ") vErrors.length = " + s + "; else vErrors = null; } ", e.opts.allErrors && (r += " } ")) : (r += "  var err =   ", !1 !== e.createErrors ? (r += " { keyword: 'not' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(t) + " , params: {} ", !1 !== e.opts.messages && (r += " , message: 'should NOT be valid' "), e.opts.verbose && (r += " , schema: validate.schema" + c + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + a + " "), r += " } ") : r += " {} ", r += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", h && (r += " if (false) { ")), r;
            };
        },
        6288: function(e) {
            e.exports = function(e, t, i) {
                var n = " ", o = e.level, r = e.dataLevel, s = e.schema[t], a = e.schemaPath + e.util.getProperty(t), l = e.errSchemaPath + "/" + t, t = !e.opts.allErrors, r = "data" + (r || ""), c = "valid" + o, h = "errs__" + o, d = e.util.copy(e), u = "", g = (d.level++, "valid" + d.level), p = d.baseId, m = "prevValid" + o, f = "passingSchemas" + o, o = (n += "var " + h + " = errors , " + m + " = false , " + c + " = false , " + f + " = null; ", e.compositeRule), C = (e.compositeRule = d.compositeRule = !0, s);
                if (C) for(var y, v = -1, I = C.length - 1; v < I;)y = C[v += 1], (e.opts.strictKeywords ? "object" == typeof y && 0 < Object.keys(y).length || !1 === y : e.util.schemaHasRules(y, e.RULES.all)) ? (d.schema = y, d.schemaPath = a + "[" + v + "]", d.errSchemaPath = l + "/" + v, n += "  " + e.validate(d) + " ", d.baseId = p) : n += " var " + g + " = true; ", v && (n += " if (" + g + " && " + m + ") { " + c + " = false; " + f + " = [" + f + ", " + v + "]; } else { ", u += "}"), n += " if (" + g + ") { " + c + " = " + m + " = true; " + f + " = " + v + "; }";
                return e.compositeRule = d.compositeRule = o, n += u + "if (!" + c + ") {   var err =   ", !1 !== e.createErrors ? (n += " { keyword: 'oneOf' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(l) + " , params: { passingSchemas: " + f + " } ", !1 !== e.opts.messages && (n += " , message: 'should match exactly one schema in oneOf' "), e.opts.verbose && (n += " , schema: validate.schema" + a + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + r + " "), n += " } ") : n += " {} ", n += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", !e.compositeRule && t && (e.async ? n += " throw new ValidationError(vErrors); " : n += " validate.errors = vErrors; return false; "), n += "} else {  errors = " + h + "; if (vErrors !== null) { if (" + h + ") vErrors.length = " + h + "; else vErrors = null; }", e.opts.allErrors && (n += " } "), n;
            };
        },
        2079: function(e) {
            e.exports = function(e, t, i) {
                var n = " ", o = e.level, r = e.dataLevel, s = e.schema[t], a = e.schemaPath + e.util.getProperty(t), t = e.errSchemaPath + "/" + t, l = !e.opts.allErrors, c = "data" + (r || ""), h = "valid" + o, d = e.opts.$data && s && s.$data, r = d ? (n += " var schema" + o + " = " + e.util.getData(s.$data, r, e.dataPathArr) + "; ", "schema" + o) : s, o = e.opts.regExp ? "regExp" : "new RegExp", o = (d ? (n += " var " + h + " = true; try { " + h + " = " + o + "(" + r + ").test(" + c + "); } catch(e) { " + h + " = false; } if ( ", d && (n += " (" + r + " !== undefined && typeof " + r + " != 'string') || "), n += " !" + h + ") {") : (n += " if ( ", d && (n += " (" + r + " !== undefined && typeof " + r + " != 'string') || "), n += " !" + e.usePattern(s) + ".test(" + c + ") ) {"), []), h = (o.push(n), n = "", !1 !== e.createErrors ? (n = (n += " { keyword: 'pattern' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(t) + " , params: { pattern:  ") + (d ? "" + r : "" + e.util.toQuotedString(s)) + "  } ", !1 !== e.opts.messages && (n = (n += " , message: 'should match pattern \"") + (d ? "' + " + r + " + '" : "" + e.util.escapeQuotes(s)) + "\"' "), e.opts.verbose && (n = (n = (n += " , schema:  ") + (d ? "validate.schema" + a : "" + e.util.toQuotedString(s))) + "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), n += " } ") : n += " {} ", n), n = o.pop();
                return !e.compositeRule && l ? e.async ? n += " throw new ValidationError([" + h + "]); " : n += " validate.errors = [" + h + "]; return false; " : n += " var err = " + h + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", n += "} ", l && (n += " else { "), n;
            };
        },
        2124: function(e) {
            e.exports = function(e, t, B) {
                var i, n = " ", o = e.level, r = e.dataLevel, D = e.schema[t], s = e.schemaPath + e.util.getProperty(t), a = e.errSchemaPath + "/" + t, l = !e.opts.allErrors, c = "data" + (r || ""), t = "errs__" + o, h = e.util.copy(e), d = "", u = (h.level++, "valid" + h.level), g = "key" + o, p = "idx" + o, m = h.dataLevel = e.dataLevel + 1, f = "data" + m, C = "dataProperties" + o, r = Object.keys(D || {}).filter(F), O = e.schema.patternProperties || {}, y = Object.keys(O).filter(F), v = e.schema.additionalProperties, P = r.length || y.length, H = !1 === v, G = "object" == typeof v && Object.keys(v).length, I = e.opts.removeAdditional, b = H || G || I, A = e.opts.ownProperties, w = e.baseId, x = e.schema.required;
                function F(e) {
                    return "__proto__" !== e;
                }
                if (x && (!e.opts.$data || !x.$data) && x.length < e.opts.loopRequired && (i = e.util.toHash(x)), n += "var " + t + " = errors;var " + u + " = true;", A && (n += " var " + C + " = undefined;"), b) {
                    if (n += A ? " " + C + " = " + C + " || Object.keys(" + c + "); for (var " + p + "=0; " + p + "<" + C + ".length; " + p + "++) { var " + g + " = " + C + "[" + p + "]; " : " for (var " + g + " in " + c + ") { ", P) {
                        if (n += " var isAdditional" + o + " = !(false ", r.length) {
                            if (8 < r.length) n += " || validate.schema" + s + ".hasOwnProperty(" + g + ") ";
                            else {
                                var V = r;
                                if (V) for(var Z = -1, j = V.length - 1; Z < j;)S = V[Z += 1], n += " || " + g + " == " + e.util.toQuotedString(S) + " ";
                            }
                        }
                        if (y.length) {
                            var K = y;
                            if (K) for(var z = -1, X = K.length - 1; z < X;)M = K[z += 1], n += " || " + e.usePattern(M) + ".test(" + g + ") ";
                        }
                        n += " ); if (isAdditional" + o + ") { ";
                    }
                    "all" == I ? n += " delete " + c + "[" + g + "]; " : (T = e.errorPath, x = "' + " + g + " + '", e.opts._errorDataPathProperty && (e.errorPath = e.util.getPathExpr(e.errorPath, g, e.opts.jsonPointers)), H ? I ? n += " delete " + c + "[" + g + "]; " : (E = a, a = e.errSchemaPath + "/additionalProperties", ($ = $ || []).push(n += " " + u + " = false; "), n = "", !1 !== e.createErrors ? (n += " { keyword: 'additionalProperties' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(a) + " , params: { additionalProperty: '" + x + "' } ", !1 !== e.opts.messages && (n += " , message: '", e.opts._errorDataPathProperty ? n += "is an invalid additional property" : n += "should NOT have additional properties", n += "' "), e.opts.verbose && (n += " , schema: false , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), n += " } ") : n += " {} ", _ = n, n = $.pop(), !e.compositeRule && l ? e.async ? n += " throw new ValidationError([" + _ + "]); " : n += " validate.errors = [" + _ + "]; return false; " : n += " var err = " + _ + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", a = E, l && (n += " break; ")) : G && ("failing" == I ? (n += " var " + t + " = errors;  ", b = e.compositeRule, e.compositeRule = h.compositeRule = !0, h.schema = v, h.schemaPath = e.schemaPath + ".additionalProperties", h.errSchemaPath = e.errSchemaPath + "/additionalProperties", h.errorPath = e.opts._errorDataPathProperty ? e.errorPath : e.util.getPathExpr(e.errorPath, g, e.opts.jsonPointers), N = c + "[" + g + "]", h.dataPathArr[m] = g, W = e.validate(h), h.baseId = w, e.util.varOccurences(W, f) < 2 ? n += " " + e.util.varReplace(W, f, N) + " " : n += " var " + f + " = " + N + "; " + W + " ", n += " if (!" + u + ") { errors = " + t + "; if (validate.errors !== null) { if (errors) validate.errors.length = errors; else validate.errors = null; } delete " + c + "[" + g + "]; }  ", e.compositeRule = h.compositeRule = b) : (h.schema = v, h.schemaPath = e.schemaPath + ".additionalProperties", h.errSchemaPath = e.errSchemaPath + "/additionalProperties", h.errorPath = e.opts._errorDataPathProperty ? e.errorPath : e.util.getPathExpr(e.errorPath, g, e.opts.jsonPointers), N = c + "[" + g + "]", h.dataPathArr[m] = g, W = e.validate(h), h.baseId = w, e.util.varOccurences(W, f) < 2 ? n += " " + e.util.varReplace(W, f, N) + " " : n += " var " + f + " = " + N + "; " + W + " ", l && (n += " if (!" + u + ") break; "))), e.errorPath = T), P && (n += " } "), n += " }  ", l && (n += " if (" + u + ") { ", d += "}");
                }
                var Y = e.opts.useDefaults && !e.compositeRule;
                if (r.length) {
                    var J = r;
                    if (J) for(var S, U = -1, Q = J.length - 1; U < Q;){
                        var q, k, T, E, R, $, _, L = D[S = J[U += 1]];
                        (e.opts.strictKeywords ? "object" == typeof L && 0 < Object.keys(L).length || !1 === L : e.util.schemaHasRules(L, e.RULES.all)) && (N = c + (R = e.util.getProperty(S)), q = Y && void 0 !== L.default, h.schema = L, h.schemaPath = s + R, h.errSchemaPath = a + "/" + e.util.escapeFragment(S), h.errorPath = e.util.getPath(e.errorPath, S, e.opts.jsonPointers), h.dataPathArr[m] = e.util.toQuotedString(S), W = e.validate(h), h.baseId = w, e.util.varOccurences(W, f) < 2 ? (W = e.util.varReplace(W, f, N), k = N) : n += " var " + (k = f) + " = " + N + "; ", q ? n += " " + W + " " : (i && i[S] ? (n += " if ( " + k + " === undefined ", A && (n += " || ! Object.prototype.hasOwnProperty.call(" + c + ", '" + e.util.escapeQuotes(S) + "') "), n += ") { " + u + " = false; ", T = e.errorPath, E = a, R = e.util.escapeQuotes(S), e.opts._errorDataPathProperty && (e.errorPath = e.util.getPath(T, S, e.opts.jsonPointers)), a = e.errSchemaPath + "/required", ($ = $ || []).push(n), n = "", !1 !== e.createErrors ? (n += " { keyword: 'required' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(a) + " , params: { missingProperty: '" + R + "' } ", !1 !== e.opts.messages && (n += " , message: '", e.opts._errorDataPathProperty ? n += "is a required property" : n += "should have required property \\'" + R + "\\'", n += "' "), e.opts.verbose && (n += " , schema: validate.schema" + s + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), n += " } ") : n += " {} ", _ = n, n = $.pop(), !e.compositeRule && l ? e.async ? n += " throw new ValidationError([" + _ + "]); " : n += " validate.errors = [" + _ + "]; return false; " : n += " var err = " + _ + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", a = E, e.errorPath = T, n += " } else { ") : l ? (n += " if ( " + k + " === undefined ", A && (n += " || ! Object.prototype.hasOwnProperty.call(" + c + ", '" + e.util.escapeQuotes(S) + "') "), n += ") { " + u + " = true; } else { ") : (n += " if (" + k + " !== undefined ", A && (n += " &&   Object.prototype.hasOwnProperty.call(" + c + ", '" + e.util.escapeQuotes(S) + "') "), n += " ) { "), n += " " + W + " } ")), l && (n += " if (" + u + ") { ", d += "}");
                    }
                }
                if (y.length) {
                    var ee = y;
                    if (ee) for(var M, te = -1, ie = ee.length - 1; te < ie;){
                        var N, W, L = O[M = ee[te += 1]];
                        (e.opts.strictKeywords ? "object" == typeof L && 0 < Object.keys(L).length || !1 === L : e.util.schemaHasRules(L, e.RULES.all)) && (h.schema = L, h.schemaPath = e.schemaPath + ".patternProperties" + e.util.getProperty(M), h.errSchemaPath = e.errSchemaPath + "/patternProperties/" + e.util.escapeFragment(M), n = (n += A ? " " + C + " = " + C + " || Object.keys(" + c + "); for (var " + p + "=0; " + p + "<" + C + ".length; " + p + "++) { var " + g + " = " + C + "[" + p + "]; " : " for (var " + g + " in " + c + ") { ") + " if (" + e.usePattern(M) + ".test(" + g + ")) { ", h.errorPath = e.util.getPathExpr(e.errorPath, g, e.opts.jsonPointers), N = c + "[" + g + "]", h.dataPathArr[m] = g, W = e.validate(h), h.baseId = w, e.util.varOccurences(W, f) < 2 ? n += " " + e.util.varReplace(W, f, N) + " " : n += " var " + f + " = " + N + "; " + W + " ", l && (n += " if (!" + u + ") break; "), n += " } ", l && (n += " else " + u + " = true; "), n += " }  ", l) && (n += " if (" + u + ") { ", d += "}");
                    }
                }
                return l && (n += " " + d + " if (" + t + " == errors) {"), n;
            };
        },
        4926: function(e) {
            e.exports = function(e, t, i) {
                var n, o, r, s, a, l, c, h = " ", d = e.level, u = e.dataLevel, g = e.schema[t], p = e.schemaPath + e.util.getProperty(t), t = e.errSchemaPath + "/" + t, m = !e.opts.allErrors, u = "data" + (u || ""), f = "errs__" + d, C = e.util.copy(e), y = (C.level++, "valid" + C.level);
                return h += "var " + f + " = errors;", (e.opts.strictKeywords ? "object" == typeof g && 0 < Object.keys(g).length || !1 === g : e.util.schemaHasRules(g, e.RULES.all)) && (C.schema = g, C.schemaPath = p, C.errSchemaPath = t, g = "idx" + d, o = "i" + d, r = "' + " + (n = "key" + d) + " + '", s = "data" + (C.dataLevel = e.dataLevel + 1), c = "dataProperties" + d, l = e.opts.ownProperties, a = e.baseId, l && (h += " var " + c + " = undefined; "), h = h + (l ? " " + c + " = " + c + " || Object.keys(" + u + "); for (var " + g + "=0; " + g + "<" + c + ".length; " + g + "++) { var " + n + " = " + c + "[" + g + "]; " : " for (var " + n + " in " + u + ") { ") + " var startErrs" + d + " = errors; ", l = n, c = e.compositeRule, e.compositeRule = C.compositeRule = !0, g = e.validate(C), C.baseId = a, e.util.varOccurences(g, s) < 2 ? h += " " + e.util.varReplace(g, s, l) + " " : h += " var " + s + " = " + l + "; " + g + " ", e.compositeRule = C.compositeRule = c, h += " if (!" + y + ") { for (var " + o + "=startErrs" + d + "; " + o + "<errors; " + o + "++) { vErrors[" + o + "].propertyName = " + n + "; }   var err =   ", !1 !== e.createErrors ? (h += " { keyword: 'propertyNames' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(t) + " , params: { propertyName: '" + r + "' } ", !1 !== e.opts.messages && (h += " , message: 'property name \\'" + r + "\\' is invalid' "), e.opts.verbose && (h += " , schema: validate.schema" + p + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + u + " "), h += " } ") : h += " {} ", h += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", !e.compositeRule && m && (e.async ? h += " throw new ValidationError(vErrors); " : h += " validate.errors = vErrors; return false; "), m && (h += " break; "), h += " } }"), m && (h += "  if (" + f + " == errors) {"), h;
            };
        },
        7096: function(e) {
            e.exports = function(e, t, i) {
                var n, o, r = " ", s = e.level, a = e.dataLevel, l = e.schema[t], t = e.errSchemaPath + "/" + t, c = !e.opts.allErrors, h = "data" + (a || ""), s = "valid" + s;
                if ("#" == l || "#/" == l) o = e.isRoot ? (n = e.async, "validate") : (n = !0 === e.root.schema.$async, "root.refVal[0]");
                else {
                    var d = e.resolveRef(e.baseId, l, e.isRoot);
                    if (void 0 === d) {
                        var u = e.MissingRefError.message(e.baseId, l);
                        if ("fail" == e.opts.missingRefs) {
                            e.logger.error(u);
                            (g = g || []).push(r), r = "", !1 !== e.createErrors ? (r += " { keyword: '$ref' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(t) + " , params: { ref: '" + e.util.escapeQuotes(l) + "' } ", !1 !== e.opts.messages && (r += " , message: 'can\\'t resolve reference " + e.util.escapeQuotes(l) + "' "), e.opts.verbose && (r += " , schema: " + e.util.toQuotedString(l) + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + h + " "), r += " } ") : r += " {} ";
                            t = r, r = g.pop();
                            !e.compositeRule && c ? e.async ? r += " throw new ValidationError([" + t + "]); " : r += " validate.errors = [" + t + "]; return false; " : r += " var err = " + t + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", c && (r += " if (false) { ");
                        } else {
                            if ("ignore" != e.opts.missingRefs) throw new e.MissingRefError(e.baseId, l, u);
                            e.logger.warn(u), c && (r += " if (true) { ");
                        }
                    } else d.inline ? ((t = e.util.copy(e)).level++, u = "valid" + t.level, t.schema = d.schema, t.schemaPath = "", t.errSchemaPath = l, r += " " + e.validate(t).replace(/validate\.schema/g, d.code) + " ", c && (r += " if (" + u + ") { ")) : (n = !0 === d.$async || e.async && !1 !== d.$async, o = d.code);
                }
                if (o) {
                    (g = g || []).push(r), r = "", e.opts.passContext ? r += " " + o + ".call(this, " : r += " " + o + "( ", r += " " + h + ", (dataPath || '')", '""' != e.errorPath && (r += " + " + e.errorPath);
                    var g, l = a ? "data" + (a - 1 || "") : "parentData", t = r += " , " + l + " , " + (a ? e.dataPathArr[a] : "parentDataProperty") + ", rootData)  ";
                    if (r = g.pop(), n) {
                        if (!e.async) throw new Error("async schema referenced by sync schema");
                        c && (r += " var " + s + "; "), r += " try { await " + t + "; ", c && (r += " " + s + " = true; "), r += " } catch (e) { if (!(e instanceof ValidationError)) throw e; if (vErrors === null) vErrors = e.errors; else vErrors = vErrors.concat(e.errors); errors = vErrors.length; ", c && (r += " " + s + " = false; "), r += " } ", c && (r += " if (" + s + ") { ");
                    } else r += " if (!" + t + ") { if (vErrors === null) vErrors = " + o + ".errors; else vErrors = vErrors.concat(" + o + ".errors); errors = vErrors.length; } ", c && (r += " else { ");
                }
                return r;
            };
        },
        2e3: function(e) {
            e.exports = function(e, t, i) {
                var n = " ", o = e.level, r = e.dataLevel, s = e.schema[t], a = e.schemaPath + e.util.getProperty(t), l = e.errSchemaPath + "/" + t, t = !e.opts.allErrors, c = "data" + (r || ""), h = "valid" + o, d = e.opts.$data && s && s.$data, r = (d && (n += " var schema" + o + " = " + e.util.getData(s.$data, r, e.dataPathArr) + "; "), "schema" + o);
                if (!d) {
                    if (s.length < e.opts.loopRequired && e.schema.properties && Object.keys(e.schema.properties).length) {
                        var u = [], g = s;
                        if (g) for(var p = -1, m = g.length - 1; p < m;){
                            var f = g[p += 1], C = e.schema.properties[f];
                            C && (e.opts.strictKeywords ? "object" == typeof C && 0 < Object.keys(C).length || !1 === C : e.util.schemaHasRules(C, e.RULES.all)) || (u[u.length] = f);
                        }
                    } else u = s;
                }
                if (d || u.length) {
                    var y = e.errorPath, s = d || u.length >= e.opts.loopRequired, v = e.opts.ownProperties;
                    if (t) {
                        if (n += " var missing" + o + "; ", s) {
                            d || (n += " var " + r + " = validate.schema" + a + "; ");
                            var I = "' + " + (k = "schema" + o + "[" + (w = "i" + o) + "]") + " + '";
                            e.opts._errorDataPathProperty && (e.errorPath = e.util.getPathExpr(y, k, e.opts.jsonPointers)), n += " var " + h + " = true; ", d && (n += " if (schema" + o + " === undefined) " + h + " = true; else if (!Array.isArray(schema" + o + ")) " + h + " = false; else {"), n += " for (var " + w + " = 0; " + w + " < " + r + ".length; " + w + "++) { " + h + " = " + c + "[" + r + "[" + w + "]] !== undefined ", v && (n += " &&   Object.prototype.hasOwnProperty.call(" + c + ", " + r + "[" + w + "]) "), n += "; if (!" + h + ") break; } ", d && (n += "  }  ");
                            (S = S || []).push(n += "  if (!" + h + ") {   "), n = "", !1 !== e.createErrors ? (n += " { keyword: 'required' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(l) + " , params: { missingProperty: '" + I + "' } ", !1 !== e.opts.messages && (n += " , message: '", e.opts._errorDataPathProperty ? n += "is a required property" : n += "should have required property \\'" + I + "\\'", n += "' "), e.opts.verbose && (n += " , schema: validate.schema" + a + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), n += " } ") : n += " {} ";
                            var b = n, n = S.pop();
                        } else {
                            n += " if ( ";
                            var A = u;
                            if (A) for(var w = -1, x = A.length - 1; w < x;)E = A[w += 1], w && (n += " || "), n += " ( ( " + (L = c + (_ = e.util.getProperty(E))) + " === undefined ", v && (n += " || ! Object.prototype.hasOwnProperty.call(" + c + ", '" + e.util.escapeQuotes(E) + "') "), n += ") && (missing" + o + " = " + e.util.toQuotedString(e.opts.jsonPointers ? E : _) + ") ) ";
                            n += ") {  ";
                            I = "' + " + (k = "missing" + o) + " + '";
                            e.opts._errorDataPathProperty && (e.errorPath = e.opts.jsonPointers ? e.util.getPathExpr(y, k, !0) : y + " + " + k);
                            (S = S || []).push(n), n = "", !1 !== e.createErrors ? (n += " { keyword: 'required' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(l) + " , params: { missingProperty: '" + I + "' } ", !1 !== e.opts.messages && (n += " , message: '", e.opts._errorDataPathProperty ? n += "is a required property" : n += "should have required property \\'" + I + "\\'", n += "' "), e.opts.verbose && (n += " , schema: validate.schema" + a + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), n += " } ") : n += " {} ";
                            var S, b = n;
                            n = S.pop();
                        }
                        !e.compositeRule && t ? e.async ? n += " throw new ValidationError([" + b + "]); " : n += " validate.errors = [" + b + "]; return false; " : n += " var err = " + b + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", n += " } else { ";
                    } else if (s) {
                        d || (n += " var " + r + " = validate.schema" + a + "; ");
                        var k, I = "' + " + (k = "schema" + o + "[" + (w = "i" + o) + "]") + " + '";
                        e.opts._errorDataPathProperty && (e.errorPath = e.util.getPathExpr(y, k, e.opts.jsonPointers)), d && (n += " if (" + r + " && !Array.isArray(" + r + ")) {  var err =   ", !1 !== e.createErrors ? (n += " { keyword: 'required' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(l) + " , params: { missingProperty: '" + I + "' } ", !1 !== e.opts.messages && (n += " , message: '", e.opts._errorDataPathProperty ? n += "is a required property" : n += "should have required property \\'" + I + "\\'", n += "' "), e.opts.verbose && (n += " , schema: validate.schema" + a + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), n += " } ") : n += " {} ", n += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } else if (" + r + " !== undefined) { "), n += " for (var " + w + " = 0; " + w + " < " + r + ".length; " + w + "++) { if (" + c + "[" + r + "[" + w + "]] === undefined ", v && (n += " || ! Object.prototype.hasOwnProperty.call(" + c + ", " + r + "[" + w + "]) "), n += ") {  var err =   ", !1 !== e.createErrors ? (n += " { keyword: 'required' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(l) + " , params: { missingProperty: '" + I + "' } ", !1 !== e.opts.messages && (n += " , message: '", e.opts._errorDataPathProperty ? n += "is a required property" : n += "should have required property \\'" + I + "\\'", n += "' "), e.opts.verbose && (n += " , schema: validate.schema" + a + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), n += " } ") : n += " {} ", n += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } } ", d && (n += "  }  ");
                    } else {
                        var T = u;
                        if (T) for(var E, R = -1, $ = T.length - 1; R < $;){
                            E = T[R += 1];
                            var _ = e.util.getProperty(E), I = e.util.escapeQuotes(E), L = c + _;
                            e.opts._errorDataPathProperty && (e.errorPath = e.util.getPath(y, E, e.opts.jsonPointers)), n += " if ( " + L + " === undefined ", v && (n += " || ! Object.prototype.hasOwnProperty.call(" + c + ", '" + e.util.escapeQuotes(E) + "') "), n += ") {  var err =   ", !1 !== e.createErrors ? (n += " { keyword: 'required' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(l) + " , params: { missingProperty: '" + I + "' } ", !1 !== e.opts.messages && (n += " , message: '", e.opts._errorDataPathProperty ? n += "is a required property" : n += "should have required property \\'" + I + "\\'", n += "' "), e.opts.verbose && (n += " , schema: validate.schema" + a + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), n += " } ") : n += " {} ", n += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } ";
                        }
                    }
                    e.errorPath = y;
                } else t && (n += " if (true) {");
                return n;
            };
        },
        7812: function(e) {
            e.exports = function(e, t, i) {
                var n, o = " ", r = e.level, s = e.dataLevel, a = e.schema[t], l = e.schemaPath + e.util.getProperty(t), t = e.errSchemaPath + "/" + t, c = !e.opts.allErrors, h = "data" + (s || ""), d = "valid" + r, u = e.opts.$data && a && a.$data, s = u ? (o += " var schema" + r + " = " + e.util.getData(a.$data, s, e.dataPathArr) + "; ", "schema" + r) : a;
                return (a || u) && !1 !== e.opts.uniqueItems ? (u && (o += " var " + d + "; if (" + s + " === false || " + s + " === undefined) " + d + " = true; else if (typeof " + s + " != 'boolean') " + d + " = false; else { "), o += " var i = " + h + ".length , " + d + " = true , j; if (i > 1) { ", r = e.schema.items && e.schema.items.type, s = Array.isArray(r), !r || "object" == r || "array" == r || s && (0 <= r.indexOf("object") || 0 <= r.indexOf("array")) ? o += " outer: for (;i--;) { for (j = i; j--;) { if (equal(" + h + "[i], " + h + "[j])) { " + d + " = false; break outer; } } } " : (o = (o += " var itemIndices = {}, item; for (;i--;) { var item = " + h + "[i]; ") + " if (" + e.util["checkDataType" + (s ? "s" : "")](r, "item", e.opts.strictNumbers, !0) + ") continue; ", s && (o += " if (typeof item == 'string') item = '\"' + item; "), o += " if (typeof itemIndices[item] == 'number') { " + d + " = false; j = itemIndices[item]; break; } itemIndices[item] = i; } "), o += " } ", u && (o += "  }  "), (n = n || []).push(o += " if (!" + d + ") {   "), o = "", !1 !== e.createErrors ? (o += " { keyword: 'uniqueItems' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(t) + " , params: { i: i, j: j } ", !1 !== e.opts.messages && (o += " , message: 'should NOT have duplicate items (items ## ' + j + ' and ' + i + ' are identical)' "), e.opts.verbose && (o = (o += " , schema:  ") + (u ? "validate.schema" + l : "" + a) + "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + h + " "), o += " } ") : o += " {} ", r = o, o = n.pop(), !e.compositeRule && c ? e.async ? o += " throw new ValidationError([" + r + "]); " : o += " validate.errors = [" + r + "]; return false; " : o += " var err = " + r + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", o += " } ", c && (o += " else { ")) : c && (o += " if (true) { "), o;
            };
        },
        1035: function(e) {
            e.exports = function(n, e, B) {
                var t = "", i = !0 === n.schema.$async, o = n.util.schemaHasRulesExcept(n.schema, n.RULES.all, "$ref"), r = n.self._getId(n.schema);
                if (n.opts.strictKeywords) {
                    var s = n.util.schemaUnknownRules(n.schema, n.RULES.keywords);
                    if (s) {
                        s = "unknown keyword: " + s;
                        if ("log" !== n.opts.strictKeywords) throw new Error(s);
                        n.logger.warn(s);
                    }
                }
                if (n.isTop && (t += " var validate = ", i && (n.async = !0, t += "async "), t += "function(data, dataPath, parentData, parentDataProperty, rootData) { 'use strict'; ", r) && (n.opts.sourceCode || n.opts.processCode) && (t += " /*# sourceURL=" + r + " */ "), "boolean" == typeof n.schema || !o && !n.schema.$ref) l = n.level, c = n.dataLevel, R = n.schema[e = "false schema"], I = n.schemaPath + n.util.getProperty(e), b = n.errSchemaPath + "/" + e, g = !n.opts.allErrors, h = "data" + (c || ""), u = "valid" + l, !1 === n.schema ? (n.isTop ? g = !0 : t += " var " + u + " = false; ", (N = N || []).push(t), t = "", !1 !== n.createErrors ? (t += " { keyword: 'false schema' , dataPath: (dataPath || '') + " + n.errorPath + " , schemaPath: " + n.util.toQuotedString(b) + " , params: {} ", !1 !== n.opts.messages && (t += " , message: 'boolean schema is false' "), n.opts.verbose && (t += " , schema: false , parentSchema: validate.schema" + n.schemaPath + " , data: " + h + " "), t += " } ") : t += " {} ", T = t, t = N.pop(), !n.compositeRule && g ? n.async ? t += " throw new ValidationError([" + T + "]); " : t += " validate.errors = [" + T + "]; return false; " : t += " var err = " + T + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ") : n.isTop ? t += i ? " return data; " : " validate.errors = null; return true; " : t += " var " + u + " = true; ", n.isTop && (t += " }; return validate; ");
                else {
                    if (n.isTop) {
                        var a = n.isTop, l = n.level = 0, c = n.dataLevel = 0, h = "data";
                        if (n.rootId = n.resolve.fullPath(n.self._getId(n.root.schema)), n.baseId = n.baseId || n.rootId, delete n.isTop, n.dataPathArr = [
                            ""
                        ], void 0 !== n.schema.default && n.opts.useDefaults && n.opts.strictDefaults) {
                            var d = "default is ignored in the schema root";
                            if ("log" !== n.opts.strictDefaults) throw new Error(d);
                            n.logger.warn(d);
                        }
                        t = (t += " var vErrors = null; ") + " var errors = 0;     " + " if (rootData === undefined) rootData = data; ";
                    } else {
                        l = n.level, h = "data" + ((c = n.dataLevel) || "");
                        if (r && (n.baseId = n.resolve.url(n.baseId, r)), i && !n.async) throw new Error("async schema in sync schema");
                        t += " var errs_" + l + " = errors;";
                    }
                    var u = "valid" + l, g = !n.opts.allErrors, p = "", m = "", f = n.schema.type, C = Array.isArray(f);
                    if (f && n.opts.nullable && !0 === n.schema.nullable && (C ? -1 == f.indexOf("null") && (f = f.concat("null")) : "null" != f && (f = [
                        f,
                        "null"
                    ], C = !0)), C && 1 == f.length && (f = f[0], C = !1), n.schema.$ref && o) {
                        if ("fail" == n.opts.extendRefs) throw new Error('$ref: validation keywords used in schema at path "' + n.errSchemaPath + '" (see option extendRefs)');
                        !0 !== n.opts.extendRefs && (o = !1, n.logger.warn('$ref: keywords ignored in schema at path "' + n.errSchemaPath + '"'));
                    }
                    if (n.schema.$comment && n.opts.$comment && (t += " " + n.RULES.all.$comment.code(n, "$comment")), f) {
                        n.opts.coerceTypes && (y = n.util.coerceToTypes(n.opts.coerceTypes, f));
                        var y, v = n.RULES.types[f];
                        if (y || C || !0 === v || v && !z(v)) {
                            var I = n.schemaPath + ".type", b = n.errSchemaPath + "/type", I = n.schemaPath + ".type", b = n.errSchemaPath + "/type";
                            if (t += " if (" + n.util[C ? "checkDataTypes" : "checkDataType"](f, h, n.opts.strictNumbers, !0) + ") { ", y) {
                                var A = "dataType" + l, w = "coerced" + l, x = (t += " var " + A + " = typeof " + h + "; var " + w + " = undefined; ", "array" == n.opts.coerceTypes && (t += " if (" + A + " == 'object' && Array.isArray(" + h + ") && " + h + ".length == 1) { " + h + " = " + h + "[0]; " + A + " = typeof " + h + "; if (" + n.util.checkDataType(n.schema.type, h, n.opts.strictNumbers) + ") " + w + " = " + h + "; } "), t += " if (" + w + " !== undefined) ; ", y);
                                if (x) for(var S, k = -1, D = x.length - 1; k < D;)"string" == (S = x[k += 1]) ? t += " else if (" + A + " == 'number' || " + A + " == 'boolean') " + w + " = '' + " + h + "; else if (" + h + " === null) " + w + " = ''; " : "number" == S || "integer" == S ? (t += " else if (" + A + " == 'boolean' || " + h + " === null || (" + A + " == 'string' && " + h + " && " + h + " == +" + h + " ", "integer" == S && (t += " && !(" + h + " % 1)"), t += ")) " + w + " = +" + h + "; ") : "boolean" == S ? t += " else if (" + h + " === 'false' || " + h + " === 0 || " + h + " === null) " + w + " = false; else if (" + h + " === 'true' || " + h + " === 1) " + w + " = true; " : "null" == S ? t += " else if (" + h + " === '' || " + h + " === 0 || " + h + " === false) " + w + " = null; " : "array" == n.opts.coerceTypes && "array" == S && (t += " else if (" + A + " == 'string' || " + A + " == 'number' || " + A + " == 'boolean' || " + h + " == null) " + w + " = [" + h + "]; ");
                                (N = N || []).push(t += " else {   "), t = "", !1 !== n.createErrors ? (t = (t += " { keyword: 'type' , dataPath: (dataPath || '') + " + n.errorPath + " , schemaPath: " + n.util.toQuotedString(b) + " , params: { type: '") + (C ? "" + f.join(",") : "" + f) + "' } ", !1 !== n.opts.messages && (t = (t += " , message: 'should be ") + (C ? "" + f.join(",") : "" + f) + "' "), n.opts.verbose && (t += " , schema: validate.schema" + I + " , parentSchema: validate.schema" + n.schemaPath + " , data: " + h + " "), t += " } ") : t += " {} ";
                                var T = t, s = (t = N.pop(), !n.compositeRule && g ? n.async ? t += " throw new ValidationError([" + T + "]); " : t += " validate.errors = [" + T + "]; return false; " : t += " var err = " + T + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", c ? "data" + (c - 1 || "") : "parentData");
                                t = t + (" } if (" + w + " !== undefined) {  ") + (" " + h + " = " + w + "; "), c || (t += "if (" + s + " !== undefined)"), t += " " + s + "[" + (c ? n.dataPathArr[c] : "parentDataProperty") + "] = " + w + "; } ";
                            } else {
                                T = ((N = N || []).push(t), t = "", !1 !== n.createErrors ? (t = (t += " { keyword: 'type' , dataPath: (dataPath || '') + " + n.errorPath + " , schemaPath: " + n.util.toQuotedString(b) + " , params: { type: '") + (C ? "" + f.join(",") : "" + f) + "' } ", !1 !== n.opts.messages && (t = (t += " , message: 'should be ") + (C ? "" + f.join(",") : "" + f) + "' "), n.opts.verbose && (t += " , schema: validate.schema" + I + " , parentSchema: validate.schema" + n.schemaPath + " , data: " + h + " "), t += " } ") : t += " {} ", t);
                                t = N.pop(), !n.compositeRule && g ? n.async ? t += " throw new ValidationError([" + T + "]); " : t += " validate.errors = [" + T + "]; return false; " : t += " var err = " + T + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
                            }
                            t += " } ";
                        }
                    }
                    if (n.schema.$ref && !o) t += " " + n.RULES.all.$ref.code(n, "$ref") + " ", g && (t = (t += " } if (errors === ") + (a ? "0" : "errs_" + l) + ") { ", m += "}");
                    else {
                        var E = n.RULES;
                        if (E) {
                            for(var O = -1, P = E.length - 1; O < P;)if (z(v = E[O += 1])) {
                                if (v.type && (t += " if (" + n.util.checkDataType(v.type, h, n.opts.strictNumbers) + ") { "), n.opts.useDefaults) {
                                    if ("object" == v.type && n.schema.properties) {
                                        var R = n.schema.properties, $ = Object.keys(R);
                                        if ($) {
                                            for(var H, G = -1, F = $.length - 1; G < F;)if (void 0 !== (M = R[H = $[G += 1]]).default) {
                                                var _ = h + n.util.getProperty(H);
                                                if (n.compositeRule) {
                                                    if (n.opts.strictDefaults) {
                                                        d = "default is ignored for: " + _;
                                                        if ("log" !== n.opts.strictDefaults) throw new Error(d);
                                                        n.logger.warn(d);
                                                    }
                                                } else t += " if (" + _ + " === undefined ", "empty" == n.opts.useDefaults && (t += " || " + _ + " === null || " + _ + " === '' "), t += " ) " + _ + " = ", "shared" == n.opts.useDefaults ? t += " " + n.useDefault(M.default) + " " : t += " " + JSON.stringify(M.default) + " ", t += "; ";
                                            }
                                        }
                                    } else if ("array" == v.type && Array.isArray(n.schema.items)) {
                                        var L = n.schema.items;
                                        if (L) {
                                            for(var M, k = -1, V = L.length - 1; k < V;)if (void 0 !== (M = L[k += 1]).default) {
                                                _ = h + "[" + k + "]";
                                                if (n.compositeRule) {
                                                    if (n.opts.strictDefaults) {
                                                        d = "default is ignored for: " + _;
                                                        if ("log" !== n.opts.strictDefaults) throw new Error(d);
                                                        n.logger.warn(d);
                                                    }
                                                } else t += " if (" + _ + " === undefined ", "empty" == n.opts.useDefaults && (t += " || " + _ + " === null || " + _ + " === '' "), t += " ) " + _ + " = ", "shared" == n.opts.useDefaults ? t += " " + n.useDefault(M.default) + " " : t += " " + JSON.stringify(M.default) + " ", t += "; ";
                                            }
                                        }
                                    }
                                }
                                var N, Z = v.rules;
                                if (Z) for(var W, j = -1, K = Z.length - 1; j < K;)X(W = Z[j += 1]) && (W = W.code(n, W.keyword, v.type)) && (t += " " + W + " ", g) && (p += "}");
                                g && (t += " " + p + " ", p = ""), v.type && (t += " } ", f) && f === v.type && !y && (t += " else { ", I = n.schemaPath + ".type", b = n.errSchemaPath + "/type", (N = N || []).push(t), t = "", !1 !== n.createErrors ? (t = (t += " { keyword: 'type' , dataPath: (dataPath || '') + " + n.errorPath + " , schemaPath: " + n.util.toQuotedString(b) + " , params: { type: '") + (C ? "" + f.join(",") : "" + f) + "' } ", !1 !== n.opts.messages && (t = (t += " , message: 'should be ") + (C ? "" + f.join(",") : "" + f) + "' "), n.opts.verbose && (t += " , schema: validate.schema" + I + " , parentSchema: validate.schema" + n.schemaPath + " , data: " + h + " "), t += " } ") : t += " {} ", T = t, t = N.pop(), !n.compositeRule && g ? n.async ? t += " throw new ValidationError([" + T + "]); " : t += " validate.errors = [" + T + "]; return false; " : t += " var err = " + T + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", t += " } "), g && (t = (t += " if (errors === ") + (a ? "0" : "errs_" + l) + ") { ", m += "}");
                            }
                        }
                    }
                    g && (t += " " + m + " "), a ? t = t + (i ? " if (errors === 0) return data;            else throw new ValidationError(vErrors); " : " validate.errors = vErrors;  return errors === 0;       ") + " }; return validate;" : t += " var " + u + " = errors === errs_" + l + ";";
                }
                return t;
                function z(e) {
                    for(var t = e.rules, i = 0; i < t.length; i++)if (X(t[i])) return 1;
                }
                function X(e) {
                    return void 0 !== n.schema[e.keyword] || e.implements && ((e)=>{
                        for(var t = e.implements, i = 0; i < t.length; i++)if (void 0 !== n.schema[t[i]]) return 1;
                    })(e);
                }
            };
        },
        413: function(e, t, i) {
            var a = /^[a-z_$][a-z0-9_$-]*$/i, l = i(8050), n = i(9407);
            function o(e, t) {
                o.errors = null;
                var i = this._validateKeyword = this._validateKeyword || this.compile(n, !0);
                if (i(e)) return !0;
                if (o.errors = i.errors, t) throw new Error("custom keyword definition is invalid: " + this.errorsText(i.errors));
                return !1;
            }
            e.exports = {
                add: function(e, t) {
                    var s = this.RULES;
                    if (s.keywords[e]) throw new Error("Keyword " + e + " is already defined");
                    if (!a.test(e)) throw new Error("Keyword " + e + " is not a valid identifier");
                    if (t) {
                        this.validateKeyword(t, !0);
                        var i = t.type;
                        if (Array.isArray(i)) for(var n = 0; n < i.length; n++)r(e, i[n], t);
                        else r(e, i, t);
                        var o = t.metaSchema;
                        o && (t.$data && this._opts.$data && (o = {
                            anyOf: [
                                o,
                                {
                                    $ref: "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#"
                                }
                            ]
                        }), t.validateSchema = this.compile(o, !0));
                    }
                    function r(e, t, i) {
                        for(var n, o = 0; o < s.length; o++){
                            var r = s[o];
                            if (r.type == t) {
                                n = r;
                                break;
                            }
                        }
                        n || s.push(n = {
                            type: t,
                            rules: []
                        });
                        i = {
                            keyword: e,
                            definition: i,
                            custom: !0,
                            code: l,
                            implements: i.implements
                        };
                        n.rules.push(i), s.custom[e] = i;
                    }
                    return s.keywords[e] = s.all[e] = !0, this;
                },
                get: function(e) {
                    var t = this.RULES.custom[e];
                    return t ? t.definition : this.RULES.keywords[e] || !1;
                },
                remove: function(e) {
                    var t = this.RULES;
                    delete t.keywords[e], delete t.all[e], delete t.custom[e];
                    for(var i = 0; i < t.length; i++)for(var n = t[i].rules, o = 0; o < n.length; o++)if (n[o].keyword == e) {
                        n.splice(o, 1);
                        break;
                    }
                    return this;
                },
                validate: o
            };
        },
        5215: function(e) {
            e.exports = function e(t, i) {
                if (t === i) return !0;
                if (t && i && "object" == typeof t && "object" == typeof i) {
                    if (t.constructor !== i.constructor) return !1;
                    var n, o, r;
                    if (Array.isArray(t)) {
                        if ((n = t.length) != i.length) return !1;
                        for(o = n; 0 != o--;)if (!e(t[o], i[o])) return !1;
                    } else {
                        if (t.constructor === RegExp) return t.source === i.source && t.flags === i.flags;
                        if (t.valueOf !== Object.prototype.valueOf) return t.valueOf() === i.valueOf();
                        if (t.toString !== Object.prototype.toString) return t.toString() === i.toString();
                        if ((n = (r = Object.keys(t)).length) !== Object.keys(i).length) return !1;
                        for(o = n; 0 != o--;)if (!Object.prototype.hasOwnProperty.call(i, r[o])) return !1;
                        for(o = n; 0 != o--;){
                            var s = r[o];
                            if (!e(t[s], i[s])) return !1;
                        }
                    }
                    return !0;
                }
                return t != t && i != i;
            };
        },
        9306: function(e) {
            e.exports = function(e, t) {
                var n, l = "boolean" == typeof (t = "function" == typeof (t = t || {}) ? {
                    cmp: t
                } : t).cycles && t.cycles, c = t.cmp && (n = t.cmp, function(i) {
                    return function(e, t) {
                        e = {
                            key: e,
                            value: i[e]
                        };
                        return n(e, {
                            key: t,
                            value: i[t]
                        });
                    };
                }), h = [];
                return function e(t) {
                    if (void 0 !== (t = t && t.toJSON && "function" == typeof t.toJSON ? t.toJSON() : t)) {
                        if ("number" == typeof t) return isFinite(t) ? "" + t : "null";
                        if ("object" != typeof t) return JSON.stringify(t);
                        if (Array.isArray(t)) {
                            for(o = "[", r = 0; r < t.length; r++)r && (o += ","), o += e(t[r]) || "null";
                            return o + "]";
                        }
                        if (null === t) return "null";
                        if (-1 !== h.indexOf(t)) {
                            if (l) return JSON.stringify("__cycle__");
                            throw new TypeError("Converting circular structure to JSON");
                        }
                        for(var i = h.push(t) - 1, n = Object.keys(t).sort(c && c(t)), o = "", r = 0; r < n.length; r++){
                            var s = n[r], a = e(t[s]);
                            a && (o && (o += ","), o += JSON.stringify(s) + ":" + a);
                        }
                        return h.splice(i, 1), "{" + o + "}";
                    }
                }(e);
            };
        },
        1342: function(e) {
            e.exports = function t(e, i) {
                function n(e) {
                    return t.insensitive && ("" + e).toLowerCase() || "" + e;
                }
                var o, r, s = /(^([+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?)?$|^0x[0-9a-f]+$|\d+)/gi, a = /(^[ ]*|[ ]*$)/g, l = /(^([\w ]+,?[\w ]+)?[\w ]+,?[\w ]+\d+:\d+(:\d+)?[\w ]?|^\d{1,4}[\/\-]\d{1,4}[\/\-]\d{1,4}|^\w+, \w+ \d+, \d{4})/, c = /^0x[0-9a-f]+$/i, h = /^0/, e = n(e).replace(a, "") || "", i = n(i).replace(a, "") || "", d = e.replace(s, "\0$1\0").replace(/\0$/, "").replace(/^\0/, "").split("\0"), u = i.replace(s, "\0$1\0").replace(/\0$/, "").replace(/^\0/, "").split("\0"), a = parseInt(e.match(c), 16) || 1 !== d.length && e.match(l) && Date.parse(e), s = parseInt(i.match(c), 16) || a && i.match(l) && Date.parse(i) || null;
                if (s) {
                    if (a < s) return -1;
                    if (s < a) return 1;
                }
                for(var g = 0, p = Math.max(d.length, u.length); g < p; g++){
                    if (o = !(d[g] || "").match(h) && parseFloat(d[g]) || d[g] || 0, r = !(u[g] || "").match(h) && parseFloat(u[g]) || u[g] || 0, isNaN(o) !== isNaN(r)) return isNaN(o) ? 1 : -1;
                    if (typeof o != typeof r && (o += "", r += ""), o < r) return -1;
                    if (r < o) return 1;
                }
                return 0;
            };
        },
        9151: function(e, t) {
            function w(e) {
                return null !== e && "[object Array]" === Object.prototype.toString.call(e);
            }
            function x(e) {
                return null !== e && "[object Object]" === Object.prototype.toString.call(e);
            }
            function S(e, t) {
                if (e !== t) {
                    if (Object.prototype.toString.call(e) !== Object.prototype.toString.call(t)) return !1;
                    if (!0 === w(e)) {
                        if (e.length !== t.length) return !1;
                        for(var i = 0; i < e.length; i++)if (!1 === S(e[i], t[i])) return !1;
                    } else {
                        if (!0 !== x(e)) return !1;
                        var n, o, r = {};
                        for(n in e)if (hasOwnProperty.call(e, n)) {
                            if (!1 === S(e[n], t[n])) return !1;
                            r[n] = !0;
                        }
                        for(o in t)if (hasOwnProperty.call(t, o) && !0 !== r[o]) return !1;
                    }
                }
                return !0;
            }
            function k(e) {
                if ("" === e || !1 === e || null === e) return !0;
                if (w(e) && 0 === e.length) return !0;
                if (x(e)) {
                    for(var t in e)if (e.hasOwnProperty(t)) return !1;
                    return !0;
                }
                return !1;
            }
            function s(e) {
                return "0" <= e && e <= "9" || "-" === e;
            }
            function i() {}
            function r() {}
            function a(e) {
                this.runtime = e;
            }
            function l(e) {
                this._interpreter = e, this.functionTable = {
                    abs: {
                        _func: this._functionAbs,
                        _signature: [
                            {
                                types: [
                                    0
                                ]
                            }
                        ]
                    },
                    avg: {
                        _func: this._functionAvg,
                        _signature: [
                            {
                                types: [
                                    8
                                ]
                            }
                        ]
                    },
                    ceil: {
                        _func: this._functionCeil,
                        _signature: [
                            {
                                types: [
                                    0
                                ]
                            }
                        ]
                    },
                    contains: {
                        _func: this._functionContains,
                        _signature: [
                            {
                                types: [
                                    2,
                                    3
                                ]
                            },
                            {
                                types: [
                                    1
                                ]
                            }
                        ]
                    },
                    ends_with: {
                        _func: this._functionEndsWith,
                        _signature: [
                            {
                                types: [
                                    2
                                ]
                            },
                            {
                                types: [
                                    2
                                ]
                            }
                        ]
                    },
                    floor: {
                        _func: this._functionFloor,
                        _signature: [
                            {
                                types: [
                                    0
                                ]
                            }
                        ]
                    },
                    length: {
                        _func: this._functionLength,
                        _signature: [
                            {
                                types: [
                                    2,
                                    3,
                                    4
                                ]
                            }
                        ]
                    },
                    map: {
                        _func: this._functionMap,
                        _signature: [
                            {
                                types: [
                                    6
                                ]
                            },
                            {
                                types: [
                                    3
                                ]
                            }
                        ]
                    },
                    max: {
                        _func: this._functionMax,
                        _signature: [
                            {
                                types: [
                                    8,
                                    9
                                ]
                            }
                        ]
                    },
                    merge: {
                        _func: this._functionMerge,
                        _signature: [
                            {
                                types: [
                                    4
                                ],
                                variadic: !0
                            }
                        ]
                    },
                    max_by: {
                        _func: this._functionMaxBy,
                        _signature: [
                            {
                                types: [
                                    3
                                ]
                            },
                            {
                                types: [
                                    6
                                ]
                            }
                        ]
                    },
                    sum: {
                        _func: this._functionSum,
                        _signature: [
                            {
                                types: [
                                    8
                                ]
                            }
                        ]
                    },
                    starts_with: {
                        _func: this._functionStartsWith,
                        _signature: [
                            {
                                types: [
                                    2
                                ]
                            },
                            {
                                types: [
                                    2
                                ]
                            }
                        ]
                    },
                    min: {
                        _func: this._functionMin,
                        _signature: [
                            {
                                types: [
                                    8,
                                    9
                                ]
                            }
                        ]
                    },
                    min_by: {
                        _func: this._functionMinBy,
                        _signature: [
                            {
                                types: [
                                    3
                                ]
                            },
                            {
                                types: [
                                    6
                                ]
                            }
                        ]
                    },
                    type: {
                        _func: this._functionType,
                        _signature: [
                            {
                                types: [
                                    1
                                ]
                            }
                        ]
                    },
                    keys: {
                        _func: this._functionKeys,
                        _signature: [
                            {
                                types: [
                                    4
                                ]
                            }
                        ]
                    },
                    values: {
                        _func: this._functionValues,
                        _signature: [
                            {
                                types: [
                                    4
                                ]
                            }
                        ]
                    },
                    sort: {
                        _func: this._functionSort,
                        _signature: [
                            {
                                types: [
                                    9,
                                    8
                                ]
                            }
                        ]
                    },
                    sort_by: {
                        _func: this._functionSortBy,
                        _signature: [
                            {
                                types: [
                                    3
                                ]
                            },
                            {
                                types: [
                                    6
                                ]
                            }
                        ]
                    },
                    join: {
                        _func: this._functionJoin,
                        _signature: [
                            {
                                types: [
                                    2
                                ]
                            },
                            {
                                types: [
                                    9
                                ]
                            }
                        ]
                    },
                    reverse: {
                        _func: this._functionReverse,
                        _signature: [
                            {
                                types: [
                                    2,
                                    3
                                ]
                            }
                        ]
                    },
                    to_array: {
                        _func: this._functionToArray,
                        _signature: [
                            {
                                types: [
                                    1
                                ]
                            }
                        ]
                    },
                    to_string: {
                        _func: this._functionToString,
                        _signature: [
                            {
                                types: [
                                    1
                                ]
                            }
                        ]
                    },
                    to_number: {
                        _func: this._functionToNumber,
                        _signature: [
                            {
                                types: [
                                    1
                                ]
                            }
                        ]
                    },
                    not_null: {
                        _func: this._functionNotNull,
                        _signature: [
                            {
                                types: [
                                    1
                                ],
                                variadic: !0
                            }
                        ]
                    }
                };
            }
            var o, h, c, d, u, g, p, m, f, C, T, E, R, $, y, v, I, b, A, _, L, M, N, W;
            t, o = "function" == typeof String.prototype.trimLeft ? function(e) {
                return e.trimLeft();
            } : function(e) {
                return e.match(/^\s*(.*)/)[1];
            }, h = {
                0: "number",
                1: "any",
                2: "string",
                3: "array",
                4: "object",
                5: "boolean",
                6: "expression",
                7: "null",
                8: "Array<number>",
                9: "Array<string>"
            }, c = "UnquotedIdentifier", d = "QuotedIdentifier", C = "Number", E = "Expref", R = "Pipe", $ = "Flatten", v = "Filter", b = "Lbracket", _ = "Literal", L = {
                ".": "Dot",
                "*": y = "Star",
                ",": p = "Comma",
                ":": m = "Colon",
                "{": I = "Lbrace",
                "}": f = "Rbrace",
                "]": u = "Rbracket",
                "(": A = "Lparen",
                ")": g = "Rparen",
                "@": T = "Current"
            }, M = {
                "<": !0,
                ">": !0,
                "=": !0,
                "!": !0
            }, N = {
                " ": !0,
                "\t": !0,
                "\n": !0
            }, i.prototype = {
                tokenize: function(e) {
                    var t, i, n = [];
                    for(this._current = 0; this._current < e.length;)if ("a" <= (r = e[this._current]) && r <= "z" || "A" <= r && r <= "Z" || "_" === r) o = this._current, t = this._consumeUnquotedIdentifier(e), n.push({
                        type: c,
                        value: t,
                        start: o
                    });
                    else if (void 0 !== L[e[this._current]]) n.push({
                        type: L[e[this._current]],
                        value: e[this._current],
                        start: this._current
                    }), this._current++;
                    else if (s(e[this._current])) i = this._consumeNumber(e), n.push(i);
                    else if ("[" === e[this._current]) i = this._consumeLBracket(e), n.push(i);
                    else if ('"' === e[this._current]) o = this._current, t = this._consumeQuotedIdentifier(e), n.push({
                        type: d,
                        value: t,
                        start: o
                    });
                    else if ("'" === e[this._current]) o = this._current, t = this._consumeRawStringLiteral(e), n.push({
                        type: _,
                        value: t,
                        start: o
                    });
                    else if ("`" === e[this._current]) {
                        var o = this._current, r = this._consumeLiteral(e);
                        n.push({
                            type: _,
                            value: r,
                            start: o
                        });
                    } else if (void 0 !== M[e[this._current]]) n.push(this._consumeOperator(e));
                    else if (void 0 !== N[e[this._current]]) this._current++;
                    else if ("&" === e[this._current]) o = this._current, this._current++, "&" === e[this._current] ? (this._current++, n.push({
                        type: "And",
                        value: "&&",
                        start: o
                    })) : n.push({
                        type: E,
                        value: "&",
                        start: o
                    });
                    else {
                        if ("|" !== e[this._current]) throw (r = new Error("Unknown character:" + e[this._current])).name = "LexerError", r;
                        o = this._current, this._current++, "|" === e[this._current] ? (this._current++, n.push({
                            type: "Or",
                            value: "||",
                            start: o
                        })) : n.push({
                            type: R,
                            value: "|",
                            start: o
                        });
                    }
                    return n;
                },
                _consumeUnquotedIdentifier: function(e) {
                    var t, i = this._current;
                    for(this._current++; this._current < e.length && ("a" <= (t = e[this._current]) && t <= "z" || "A" <= t && t <= "Z" || "0" <= t && t <= "9" || "_" === t);)this._current++;
                    return e.slice(i, this._current);
                },
                _consumeQuotedIdentifier: function(e) {
                    for(var t = this._current, i = (this._current++, e.length); '"' !== e[this._current] && this._current < i;){
                        var n = this._current;
                        "\\" !== e[n] || "\\" !== e[n + 1] && '"' !== e[n + 1] ? n++ : n += 2, this._current = n;
                    }
                    return this._current++, JSON.parse(e.slice(t, this._current));
                },
                _consumeRawStringLiteral: function(e) {
                    for(var t = this._current, i = (this._current++, e.length); "'" !== e[this._current] && this._current < i;){
                        var n = this._current;
                        "\\" !== e[n] || "\\" !== e[n + 1] && "'" !== e[n + 1] ? n++ : n += 2, this._current = n;
                    }
                    return this._current++, e.slice(t + 1, this._current - 1).replace("\\'", "'");
                },
                _consumeNumber: function(e) {
                    for(var t = this._current, i = (this._current++, e.length); s(e[this._current]) && this._current < i;)this._current++;
                    var n = parseInt(e.slice(t, this._current));
                    return {
                        type: C,
                        value: n,
                        start: t
                    };
                },
                _consumeLBracket: function(e) {
                    var t = this._current;
                    return this._current++, "?" === e[this._current] ? (this._current++, {
                        type: v,
                        value: "[?",
                        start: t
                    }) : "]" === e[this._current] ? (this._current++, {
                        type: $,
                        value: "[]",
                        start: t
                    }) : {
                        type: b,
                        value: "[",
                        start: t
                    };
                },
                _consumeOperator: function(e) {
                    var t = this._current, i = e[t];
                    return this._current++, "!" === i ? "=" === e[this._current] ? (this._current++, {
                        type: "NE",
                        value: "!=",
                        start: t
                    }) : {
                        type: "Not",
                        value: "!",
                        start: t
                    } : "<" === i ? "=" === e[this._current] ? (this._current++, {
                        type: "LTE",
                        value: "<=",
                        start: t
                    }) : {
                        type: "LT",
                        value: "<",
                        start: t
                    } : ">" === i ? "=" === e[this._current] ? (this._current++, {
                        type: "GTE",
                        value: ">=",
                        start: t
                    }) : {
                        type: "GT",
                        value: ">",
                        start: t
                    } : "=" === i && "=" === e[this._current] ? (this._current++, {
                        type: "EQ",
                        value: "==",
                        start: t
                    }) : void 0;
                },
                _consumeLiteral: function(e) {
                    this._current++;
                    for(var t = this._current, i = e.length; "`" !== e[this._current] && this._current < i;){
                        var n = this._current;
                        "\\" !== e[n] || "\\" !== e[n + 1] && "`" !== e[n + 1] ? n++ : n += 2, this._current = n;
                    }
                    t = (t = o(e.slice(t, this._current))).replace("\\`", "`"), t = this._looksLikeJSON(t) ? JSON.parse(t) : JSON.parse('"' + t + '"');
                    return this._current++, t;
                },
                _looksLikeJSON: function(e) {
                    if ("" === e) return !1;
                    if (0 <= '[{"'.indexOf(e[0])) return !0;
                    if (0 <= [
                        "true",
                        "false",
                        "null"
                    ].indexOf(e)) return !0;
                    if (!(0 <= "-0123456789".indexOf(e[0]))) return !1;
                    try {
                        return JSON.parse(e), !0;
                    } catch (e) {
                        return !1;
                    }
                }
            }, W = {
                EOF: 0,
                UnquotedIdentifier: 0,
                QuotedIdentifier: 0,
                Rbracket: 0,
                Rparen: 0,
                Comma: 0,
                Rbrace: 0,
                Number: 0,
                Current: 0,
                Expref: 0,
                Pipe: 1,
                Or: 2,
                And: 3,
                EQ: 5,
                GT: 5,
                LT: 5,
                GTE: 5,
                LTE: 5,
                NE: 5,
                Flatten: 9,
                Star: 20,
                Filter: 21,
                Dot: 40,
                Not: 45,
                Lbrace: 50,
                Lbracket: 55,
                Lparen: 60
            }, r.prototype = {
                parse: function(e) {
                    this._loadTokens(e), this.index = 0;
                    var t, e = this.expression(0);
                    if ("EOF" !== this._lookahead(0)) throw t = this._lookaheadToken(0), (t = new Error("Unexpected token type: " + t.type + ", value: " + t.value)).name = "ParserError", t;
                    return e;
                },
                _loadTokens: function(e) {
                    var t = (new i).tokenize(e);
                    t.push({
                        type: "EOF",
                        value: "",
                        start: e.length
                    }), this.tokens = t;
                },
                expression: function(e) {
                    for(var t = this._lookaheadToken(0), i = (this._advance(), this.nud(t)), n = this._lookahead(0); e < W[n];)this._advance(), i = this.led(n, i), n = this._lookahead(0);
                    return i;
                },
                _lookahead: function(e) {
                    return this.tokens[this.index + e].type;
                },
                _lookaheadToken: function(e) {
                    return this.tokens[this.index + e];
                },
                _advance: function() {
                    this.index++;
                },
                nud: function(e) {
                    var t, i;
                    switch(e.type){
                        case _:
                            return {
                                type: "Literal",
                                value: e.value
                            };
                        case c:
                            return {
                                type: "Field",
                                name: e.value
                            };
                        case d:
                            var n = {
                                type: "Field",
                                name: e.value
                            };
                            if (this._lookahead(0) === A) throw new Error("Quoted identifier not allowed for function names.");
                            return n;
                        case "Not":
                            return {
                                type: "NotExpression",
                                children: [
                                    t = this.expression(W.Not)
                                ]
                            };
                        case y:
                            return t = null, {
                                type: "ValueProjection",
                                children: [
                                    {
                                        type: "Identity"
                                    },
                                    t = this._lookahead(0) === u ? {
                                        type: "Identity"
                                    } : this._parseProjectionRHS(W.Star)
                                ]
                            };
                        case v:
                            return this.led(e.type, {
                                type: "Identity"
                            });
                        case I:
                            return this._parseMultiselectHash();
                        case $:
                            return {
                                type: "Projection",
                                children: [
                                    {
                                        type: $,
                                        children: [
                                            {
                                                type: "Identity"
                                            }
                                        ]
                                    },
                                    t = this._parseProjectionRHS(W.Flatten)
                                ]
                            };
                        case b:
                            return this._lookahead(0) === C || this._lookahead(0) === m ? (t = this._parseIndexExpression(), this._projectIfSlice({
                                type: "Identity"
                            }, t)) : this._lookahead(0) === y && this._lookahead(1) === u ? (this._advance(), this._advance(), {
                                type: "Projection",
                                children: [
                                    {
                                        type: "Identity"
                                    },
                                    t = this._parseProjectionRHS(W.Star)
                                ]
                            }) : this._parseMultiselectList();
                        case T:
                            return {
                                type: T
                            };
                        case E:
                            return {
                                type: "ExpressionReference",
                                children: [
                                    i = this.expression(W.Expref)
                                ]
                            };
                        case A:
                            for(var o = []; this._lookahead(0) !== g;)this._lookahead(0) === T ? (i = {
                                type: T
                            }, this._advance()) : i = this.expression(0), o.push(i);
                            return this._match(g), o[0];
                        default:
                            this._errorToken(e);
                    }
                },
                led: function(e, t) {
                    var i;
                    switch(e){
                        case "Dot":
                            var n = W.Dot;
                            return this._lookahead(0) !== y ? {
                                type: "Subexpression",
                                children: [
                                    t,
                                    i = this._parseDotRHS(n)
                                ]
                            } : (this._advance(), {
                                type: "ValueProjection",
                                children: [
                                    t,
                                    i = this._parseProjectionRHS(n)
                                ]
                            });
                        case R:
                            return i = this.expression(W.Pipe), {
                                type: R,
                                children: [
                                    t,
                                    i
                                ]
                            };
                        case "Or":
                            return {
                                type: "OrExpression",
                                children: [
                                    t,
                                    i = this.expression(W.Or)
                                ]
                            };
                        case "And":
                            return {
                                type: "AndExpression",
                                children: [
                                    t,
                                    i = this.expression(W.And)
                                ]
                            };
                        case A:
                            for(var o, n = t.name, r = []; this._lookahead(0) !== g;)this._lookahead(0) === T ? (o = {
                                type: T
                            }, this._advance()) : o = this.expression(0), this._lookahead(0) === p && this._match(p), r.push(o);
                            return this._match(g), {
                                type: "Function",
                                name: n,
                                children: r
                            };
                        case v:
                            n = this.expression(0);
                            return this._match(u), {
                                type: "FilterProjection",
                                children: [
                                    t,
                                    i = this._lookahead(0) === $ ? {
                                        type: "Identity"
                                    } : this._parseProjectionRHS(W.Filter),
                                    n
                                ]
                            };
                        case $:
                            return {
                                type: "Projection",
                                children: [
                                    {
                                        type: $,
                                        children: [
                                            t
                                        ]
                                    },
                                    this._parseProjectionRHS(W.Flatten)
                                ]
                            };
                        case "EQ":
                        case "NE":
                        case "GT":
                        case "GTE":
                        case "LT":
                        case "LTE":
                            return this._parseComparator(t, e);
                        case b:
                            n = this._lookaheadToken(0);
                            return n.type === C || n.type === m ? (i = this._parseIndexExpression(), this._projectIfSlice(t, i)) : (this._match(y), this._match(u), {
                                type: "Projection",
                                children: [
                                    t,
                                    i = this._parseProjectionRHS(W.Star)
                                ]
                            });
                        default:
                            this._errorToken(this._lookaheadToken(0));
                    }
                },
                _match: function(e) {
                    var t;
                    if (this._lookahead(0) !== e) throw t = this._lookaheadToken(0), (e = new Error("Expected " + e + ", got: " + t.type)).name = "ParserError", e;
                    this._advance();
                },
                _errorToken: function(e) {
                    e = new Error("Invalid token (" + e.type + '): "' + e.value + '"');
                    throw e.name = "ParserError", e;
                },
                _parseIndexExpression: function() {
                    var e;
                    return this._lookahead(0) === m || this._lookahead(1) === m ? this._parseSliceExpression() : (e = {
                        type: "Index",
                        value: this._lookaheadToken(0).value
                    }, this._advance(), this._match(u), e);
                },
                _projectIfSlice: function(e, t) {
                    e = {
                        type: "IndexExpression",
                        children: [
                            e,
                            t
                        ]
                    };
                    return "Slice" === t.type ? {
                        type: "Projection",
                        children: [
                            e,
                            this._parseProjectionRHS(W.Star)
                        ]
                    } : e;
                },
                _parseSliceExpression: function() {
                    for(var e, t = [
                        null,
                        null,
                        null
                    ], i = 0, n = this._lookahead(0); n !== u && i < 3;){
                        if (n === m) i++;
                        else {
                            if (n !== C) throw e = this._lookahead(0), (e = new Error("Syntax error, unexpected token: " + e.value + "(" + e.type + ")")).name = "Parsererror", e;
                            t[i] = this._lookaheadToken(0).value;
                        }
                        this._advance(), n = this._lookahead(0);
                    }
                    return this._match(u), {
                        type: "Slice",
                        children: t
                    };
                },
                _parseComparator: function(e, t) {
                    return {
                        type: "Comparator",
                        name: t,
                        children: [
                            e,
                            this.expression(W[t])
                        ]
                    };
                },
                _parseDotRHS: function(e) {
                    var t = this._lookahead(0);
                    return 0 <= [
                        c,
                        d,
                        y
                    ].indexOf(t) ? this.expression(e) : t === b ? (this._match(b), this._parseMultiselectList()) : t === I ? (this._match(I), this._parseMultiselectHash()) : void 0;
                },
                _parseProjectionRHS: function(e) {
                    var t, i;
                    if (W[this._lookahead(0)] < 10) t = {
                        type: "Identity"
                    };
                    else if (this._lookahead(0) === b) t = this.expression(e);
                    else if (this._lookahead(0) === v) t = this.expression(e);
                    else {
                        if ("Dot" !== this._lookahead(0)) throw i = this._lookaheadToken(0), (i = new Error("Sytanx error, unexpected token: " + i.value + "(" + i.type + ")")).name = "ParserError", i;
                        this._match("Dot"), t = this._parseDotRHS(e);
                    }
                    return t;
                },
                _parseMultiselectList: function() {
                    for(var e = []; this._lookahead(0) !== u;){
                        var t = this.expression(0);
                        if (e.push(t), this._lookahead(0) === p && (this._match(p), this._lookahead(0) === u)) throw new Error("Unexpected token Rbracket");
                    }
                    return this._match(u), {
                        type: "MultiSelectList",
                        children: e
                    };
                },
                _parseMultiselectHash: function() {
                    for(var e, t, i = [], n = [
                        c,
                        d
                    ];;){
                        if (e = this._lookaheadToken(0), n.indexOf(e.type) < 0) throw new Error("Expecting an identifier token, got: " + e.type);
                        if (e = e.value, this._advance(), this._match(m), t = this.expression(0), i.push({
                            type: "KeyValuePair",
                            name: e,
                            value: t
                        }), this._lookahead(0) === p) this._match(p);
                        else if (this._lookahead(0) === f) {
                            this._match(f);
                            break;
                        }
                    }
                    return {
                        type: "MultiSelectHash",
                        children: i
                    };
                }
            }, a.prototype = {
                search: function(e, t) {
                    return this.visit(e, t);
                },
                visit: function(e, t) {
                    var i, n, o, r, s, a;
                    switch(e.type){
                        case "Field":
                            return null !== t && x(t) ? void 0 === (l = t[e.name]) ? null : l : null;
                        case "Subexpression":
                            for(u = this.visit(e.children[0], t), f = 1; f < e.children.length; f++)if (null === (u = this.visit(e.children[1], u))) return null;
                            return u;
                        case "IndexExpression":
                            return s = this.visit(e.children[0], t), this.visit(e.children[1], s);
                        case "Index":
                            return w(t) ? void 0 === (u = t[l = (l = e.value) < 0 ? t.length + l : l]) ? null : u : null;
                        case "Slice":
                            if (!w(t)) return null;
                            var l = e.children.slice(0), l = this.computeSliceParams(t.length, l), c = l[0], h = l[1], d = l[2], u = [];
                            if (0 < d) for(f = c; f < h; f += d)u.push(t[f]);
                            else for(f = c; h < f; f += d)u.push(t[f]);
                            return u;
                        case "Projection":
                            var g = this.visit(e.children[0], t);
                            if (!w(g)) return null;
                            for(p = [], f = 0; f < g.length; f++)null !== (n = this.visit(e.children[1], g[f])) && p.push(n);
                            return p;
                        case "ValueProjection":
                            if (!x(g = this.visit(e.children[0], t))) return null;
                            for(var p = [], m = ((e)=>{
                                for(var t = Object.keys(e), i = [], n = 0; n < t.length; n++)i.push(e[t[n]]);
                                return i;
                            })(g), f = 0; f < m.length; f++)null !== (n = this.visit(e.children[1], m[f])) && p.push(n);
                            return p;
                        case "FilterProjection":
                            if (!w(g = this.visit(e.children[0], t))) return null;
                            var C = [], y = [];
                            for(f = 0; f < g.length; f++)k(i = this.visit(e.children[2], g[f])) || C.push(g[f]);
                            for(var v = 0; v < C.length; v++)null !== (n = this.visit(e.children[1], C[v])) && y.push(n);
                            return y;
                        case "Comparator":
                            switch(o = this.visit(e.children[0], t), r = this.visit(e.children[1], t), e.name){
                                case "EQ":
                                    u = S(o, r);
                                    break;
                                case "NE":
                                    u = !S(o, r);
                                    break;
                                case "GT":
                                    u = r < o;
                                    break;
                                case "GTE":
                                    u = r <= o;
                                    break;
                                case "LT":
                                    u = o < r;
                                    break;
                                case "LTE":
                                    u = o <= r;
                                    break;
                                default:
                                    throw new Error("Unknown comparator: " + e.name);
                            }
                            return u;
                        case $:
                            var I = this.visit(e.children[0], t);
                            if (!w(I)) return null;
                            var b = [];
                            for(f = 0; f < I.length; f++)w(n = I[f]) ? b.push.apply(b, n) : b.push(n);
                            return b;
                        case "Identity":
                            return t;
                        case "MultiSelectList":
                            if (null === t) return null;
                            for(p = [], f = 0; f < e.children.length; f++)p.push(this.visit(e.children[f], t));
                            return p;
                        case "MultiSelectHash":
                            if (null === t) return null;
                            for(p = {}, f = 0; f < e.children.length; f++)p[(a = e.children[f]).name] = this.visit(a.value, t);
                            return p;
                        case "OrExpression":
                            return i = k(i = this.visit(e.children[0], t)) ? this.visit(e.children[1], t) : i;
                        case "AndExpression":
                            return !0 === k(o = this.visit(e.children[0], t)) ? o : this.visit(e.children[1], t);
                        case "NotExpression":
                            return k(o = this.visit(e.children[0], t));
                        case "Literal":
                            return e.value;
                        case R:
                            return s = this.visit(e.children[0], t), this.visit(e.children[1], s);
                        case T:
                            return t;
                        case "Function":
                            var A = [];
                            for(f = 0; f < e.children.length; f++)A.push(this.visit(e.children[f], t));
                            return this.runtime.callFunction(e.name, A);
                        case "ExpressionReference":
                            l = e.children[0];
                            return l.jmespathType = E, l;
                        default:
                            throw new Error("Unknown node type: " + e.type);
                    }
                },
                computeSliceParams: function(e, t) {
                    var i = t[0], n = t[1], t = t[2], o = [
                        null,
                        null,
                        null
                    ];
                    if (null === t) t = 1;
                    else if (0 === t) throw (r = new Error("Invalid slice, step cannot be 0")).name = "RuntimeError", r;
                    var r = t < 0, i = null === i ? r ? e - 1 : 0 : this.capSliceRange(e, i, t), n = null === n ? r ? -1 : e : this.capSliceRange(e, n, t);
                    return o[0] = i, o[1] = n, o[2] = t, o;
                },
                capSliceRange: function(e, t, i) {
                    return t < 0 ? (t += e) < 0 && (t = i < 0 ? -1 : 0) : e <= t && (t = i < 0 ? e - 1 : e), t;
                }
            }, l.prototype = {
                callFunction: function(e, t) {
                    var i = this.functionTable[e];
                    if (void 0 === i) throw new Error("Unknown function: " + e + "()");
                    return this._validateArgs(e, t, i._signature), i._func.call(this, t);
                },
                _validateArgs: function(e, t, i) {
                    var n;
                    if (i[i.length - 1].variadic) {
                        if (t.length < i.length) throw n = 1 === i.length ? " argument" : " arguments", new Error("ArgumentError: " + e + "() takes at least" + i.length + n + " but received " + t.length);
                    } else if (t.length !== i.length) throw n = 1 === i.length ? " argument" : " arguments", new Error("ArgumentError: " + e + "() takes " + i.length + n + " but received " + t.length);
                    for(var o = 0; o < i.length; o++){
                        for(var r, s = !1, a = i[o].types, l = this._getTypeName(t[o]), c = 0; c < a.length; c++)if (this._typeMatches(l, a[c], t[o])) {
                            s = !0;
                            break;
                        }
                        if (!s) throw r = a.map(function(e) {
                            return h[e];
                        }).join(","), new Error("TypeError: " + e + "() expected argument " + (o + 1) + " to be type " + r + " but received type " + h[l] + " instead.");
                    }
                },
                _typeMatches: function(e, t, i) {
                    if (1 === t) return !0;
                    if (9 !== t && 8 !== t && 3 !== t) return e === t;
                    if (3 === t) return 3 === e;
                    if (3 === e) {
                        var n;
                        8 === t ? n = 0 : 9 === t && (n = 2);
                        for(var o = 0; o < i.length; o++)if (!this._typeMatches(this._getTypeName(i[o]), n, i[o])) return !1;
                        return !0;
                    }
                },
                _getTypeName: function(e) {
                    switch(Object.prototype.toString.call(e)){
                        case "[object String]":
                            return 2;
                        case "[object Number]":
                            return 0;
                        case "[object Array]":
                            return 3;
                        case "[object Boolean]":
                            return 5;
                        case "[object Null]":
                            return 7;
                        case "[object Object]":
                            return e.jmespathType === E ? 6 : 4;
                    }
                },
                _functionStartsWith: function(e) {
                    return 0 === e[0].lastIndexOf(e[1]);
                },
                _functionEndsWith: function(e) {
                    var t = e[0], e = e[1];
                    return -1 !== t.indexOf(e, t.length - e.length);
                },
                _functionReverse: function(e) {
                    var t;
                    if (2 !== this._getTypeName(e[0])) return (t = e[0].slice(0)).reverse(), t;
                    for(var i = e[0], n = "", o = i.length - 1; 0 <= o; o--)n += i[o];
                    return n;
                },
                _functionAbs: function(e) {
                    return Math.abs(e[0]);
                },
                _functionCeil: function(e) {
                    return Math.ceil(e[0]);
                },
                _functionAvg: function(e) {
                    for(var t = 0, i = e[0], n = 0; n < i.length; n++)t += i[n];
                    return t / i.length;
                },
                _functionContains: function(e) {
                    return 0 <= e[0].indexOf(e[1]);
                },
                _functionFloor: function(e) {
                    return Math.floor(e[0]);
                },
                _functionLength: function(e) {
                    return (x(e[0]) ? Object.keys(e[0]) : e[0]).length;
                },
                _functionMap: function(e) {
                    for(var t = [], i = this._interpreter, n = e[0], o = e[1], r = 0; r < o.length; r++)t.push(i.visit(n, o[r]));
                    return t;
                },
                _functionMerge: function(e) {
                    for(var t = {}, i = 0; i < e.length; i++){
                        var n, o = e[i];
                        for(n in o)t[n] = o[n];
                    }
                    return t;
                },
                _functionMax: function(e) {
                    if (0 < e[0].length) {
                        if (0 === this._getTypeName(e[0][0])) return Math.max.apply(Math, e[0]);
                        for(var t = e[0], i = t[0], n = 1; n < t.length; n++)i.localeCompare(t[n]) < 0 && (i = t[n]);
                        return i;
                    }
                    return null;
                },
                _functionMin: function(e) {
                    if (0 < e[0].length) {
                        if (0 === this._getTypeName(e[0][0])) return Math.min.apply(Math, e[0]);
                        for(var t = e[0], i = t[0], n = 1; n < t.length; n++)t[n].localeCompare(i) < 0 && (i = t[n]);
                        return i;
                    }
                    return null;
                },
                _functionSum: function(e) {
                    for(var t = 0, i = e[0], n = 0; n < i.length; n++)t += i[n];
                    return t;
                },
                _functionType: function(e) {
                    switch(this._getTypeName(e[0])){
                        case 0:
                            return "number";
                        case 2:
                            return "string";
                        case 3:
                            return "array";
                        case 4:
                            return "object";
                        case 5:
                            return "boolean";
                        case 6:
                            return "expref";
                        case 7:
                            return "null";
                    }
                },
                _functionKeys: function(e) {
                    return Object.keys(e[0]);
                },
                _functionValues: function(e) {
                    for(var t = e[0], i = Object.keys(t), n = [], o = 0; o < i.length; o++)n.push(t[i[o]]);
                    return n;
                },
                _functionJoin: function(e) {
                    var t = e[0];
                    return e[1].join(t);
                },
                _functionToArray: function(e) {
                    return 3 === this._getTypeName(e[0]) ? e[0] : [
                        e[0]
                    ];
                },
                _functionToString: function(e) {
                    return 2 === this._getTypeName(e[0]) ? e[0] : JSON.stringify(e[0]);
                },
                _functionToNumber: function(e) {
                    var t = this._getTypeName(e[0]);
                    return 0 === t ? e[0] : 2 !== t || (t = +e[0], isNaN(t)) ? null : t;
                },
                _functionNotNull: function(e) {
                    for(var t = 0; t < e.length; t++)if (7 !== this._getTypeName(e[t])) return e[t];
                    return null;
                },
                _functionSort: function(e) {
                    e = e[0].slice(0);
                    return e.sort(), e;
                },
                _functionSortBy: function(e) {
                    var t = e[0].slice(0);
                    if (0 !== t.length) {
                        var o = this._interpreter, r = e[1], s = this._getTypeName(o.visit(r, t[0]));
                        if ([
                            0,
                            2
                        ].indexOf(s) < 0) throw new Error("TypeError");
                        for(var a = this, i = [], n = 0; n < t.length; n++)i.push([
                            n,
                            t[n]
                        ]);
                        i.sort(function(e, t) {
                            var i = o.visit(r, e[1]), n = o.visit(r, t[1]);
                            if (a._getTypeName(i) !== s) throw new Error("TypeError: expected " + s + ", received " + a._getTypeName(i));
                            if (a._getTypeName(n) !== s) throw new Error("TypeError: expected " + s + ", received " + a._getTypeName(n));
                            return n < i ? 1 : i < n ? -1 : e[0] - t[0];
                        });
                        for(var l = 0; l < i.length; l++)t[l] = i[l][1];
                    }
                    return t;
                },
                _functionMaxBy: function(e) {
                    for(var t, i, n = e[1], o = e[0], r = this.createKeyFunction(n, [
                        0,
                        2
                    ]), s = -1 / 0, a = 0; a < o.length; a++)s < (i = r(o[a])) && (s = i, t = o[a]);
                    return t;
                },
                _functionMinBy: function(e) {
                    for(var t, i, n = e[1], o = e[0], r = this.createKeyFunction(n, [
                        0,
                        2
                    ]), s = 1 / 0, a = 0; a < o.length; a++)(i = r(o[a])) < s && (s = i, t = o[a]);
                    return t;
                },
                createKeyFunction: function(i, n) {
                    var o = this, r = this._interpreter;
                    return function(e) {
                        var t, e = r.visit(i, e);
                        if (n.indexOf(o._getTypeName(e)) < 0) throw t = "TypeError: expected one of " + n + ", received " + o._getTypeName(e), new Error(t);
                        return e;
                    };
                }
            }, t.tokenize = function(e) {
                return (new i).tokenize(e);
            }, t.compile = function(e) {
                return (new r).parse(e);
            }, t.search = function(e, t) {
                var i = new r, n = new a(o = new l), o = (o._interpreter = n, i.parse(t));
                return n.search(o, e);
            }, t.strictDeepEqual = S;
        },
        4316: function(e) {
            var m = e.exports = function(e, t, i) {
                "function" == typeof t && (i = t, t = {}), function e(t, i, n, o, r, s, a, l, c, h) {
                    if (o && "object" == typeof o && !Array.isArray(o)) {
                        for(var d in i(o, r, s, a, l, c, h), o){
                            var u = o[d];
                            if (Array.isArray(u)) {
                                if (d in m.arrayKeywords) for(var g = 0; g < u.length; g++)e(t, i, n, u[g], r + "/" + d + "/" + g, s, r, d, o, g);
                            } else if (d in m.propsKeywords) {
                                if (u && "object" == typeof u) for(var p in u)e(t, i, n, u[p], r + "/" + d + "/" + f(p), s, r, d, o, p);
                            } else (d in m.keywords || t.allKeys && !(d in m.skipKeywords)) && e(t, i, n, u, r + "/" + d, s, r, d, o);
                        }
                        n(o, r, s, a, l, c, h);
                    }
                }(t, "function" == typeof (i = t.cb || i) ? i : i.pre || function() {}, i.post || function() {}, e, "", e);
            };
            function f(e) {
                return e.replace(/~/g, "~0").replace(/\//g, "~1");
            }
            m.keywords = {
                additionalItems: !0,
                items: !0,
                contains: !0,
                additionalProperties: !0,
                propertyNames: !0,
                not: !0
            }, m.arrayKeywords = {
                items: !0,
                allOf: !0,
                anyOf: !0,
                oneOf: !0
            }, m.propsKeywords = {
                definitions: !0,
                properties: !0,
                patternProperties: !0,
                dependencies: !0
            }, m.skipKeywords = {
                default: !0,
                enum: !0,
                const: !0,
                required: !0,
                maximum: !0,
                minimum: !0,
                exclusiveMaximum: !0,
                exclusiveMinimum: !0,
                multipleOf: !0,
                maxLength: !0,
                minLength: !0,
                pattern: !0,
                format: !0,
                maxItems: !0,
                minItems: !0,
                uniqueItems: !0,
                maxProperties: !0,
                minProperties: !0
            };
        },
        3094: function(e, t) {
            var b = {
                b: "\b",
                f: "\f",
                n: "\n",
                r: "\r",
                t: "\t",
                '"': '"',
                "/": "/",
                "\\": "\\"
            }, A = "a".charCodeAt(), i = (t.parse = function(o, e, t) {
                var n = {}, i = 0, r = 0, s = 0, a = t && t.bigint && "undefined" != typeof BigInt;
                return {
                    data: l("", !0),
                    pointers: n
                };
                function l(e, t) {
                    c(), m(e, "value");
                    var i, n = u();
                    switch(n){
                        case "t":
                            d("rue"), i = !0;
                            break;
                        case "f":
                            d("alse"), i = !1;
                            break;
                        case "n":
                            d("ull"), i = null;
                            break;
                        case '"':
                            i = h();
                            break;
                        case "[":
                            i = ((e)=>{
                                c();
                                var t = [], i = 0;
                                if ("]" != u()) for(g();;){
                                    t.push(l(e + "/" + i)), c();
                                    var n = u();
                                    if ("]" == n) break;
                                    "," != n && v(), c(), i++;
                                }
                                return t;
                            })(e);
                            break;
                        case "{":
                            i = ((e)=>{
                                c();
                                var t = {};
                                if ("}" != u()) for(g();;){
                                    var i = C(), n = ('"' != u() && v(), h()), o = e + "/" + w(n), i = (f(o, "key", i), m(o, "keyEnd"), c(), ":" != u() && v(), c(), t[n] = l(o), c(), u());
                                    if ("}" == i) break;
                                    "," != i && v(), c();
                                }
                                return t;
                            })(e);
                            break;
                        default:
                            g(), 0 <= "-0123456789".indexOf(n) ? i = (()=>{
                                var e = "", t = !0, i = ("-" == o[s] && (e += u()), e += ("0" == o[s] ? u : p)(), "." == o[s] && (e += u() + p(), t = !1), "e" != o[s] && "E" != o[s] || (e += u(), "+" != o[s] && "-" != o[s] || (e += u()), e += p(), t = !1), +e);
                                return a && t && (i > Number.MAX_SAFE_INTEGER || i < Number.MIN_SAFE_INTEGER) ? BigInt(e) : i;
                            })() : y();
                    }
                    return m(e, "valueEnd"), c(), t && s < o.length && y(), i;
                }
                function c() {
                    e: for(; s < o.length;){
                        switch(o[s]){
                            case " ":
                                r++;
                                break;
                            case "\t":
                                r += 4;
                                break;
                            case "\r":
                                r = 0;
                                break;
                            case "\n":
                                r = 0, i++;
                                break;
                            default:
                                break e;
                        }
                        s++;
                    }
                }
                function h() {
                    for(var e, t = ""; '"' != (e = u());)"\\" == e ? (e = u()) in b ? t += b[e] : "u" == e ? t += (()=>{
                        for(var e = 4, t = 0; e--;){
                            t <<= 4;
                            var i = u().toLowerCase();
                            "a" <= i && i <= "f" ? t += i.charCodeAt() - A + 10 : "0" <= i && i <= "9" ? t += +i : v();
                        }
                        return String.fromCharCode(t);
                    })() : v() : t += e;
                    return t;
                }
                function d(e) {
                    for(var t = 0; t < e.length; t++)u() !== e[t] && v();
                }
                function u() {
                    I();
                    var e = o[s];
                    return s++, r++, e;
                }
                function g() {
                    s--, r--;
                }
                function p() {
                    for(var e = ""; "0" <= o[s] && o[s] <= "9";)e += u();
                    if (e.length) return e;
                    I(), y();
                }
                function m(e, t) {
                    f(e, t, C());
                }
                function f(e, t, i) {
                    n[e] = n[e] || {}, n[e][t] = i;
                }
                function C() {
                    return {
                        line: i,
                        column: r,
                        pos: s
                    };
                }
                function y() {
                    throw new SyntaxError("Unexpected token " + o[s] + " in JSON at position " + s);
                }
                function v() {
                    g(), y();
                }
                function I() {
                    if (s >= o.length) throw new SyntaxError("Unexpected end of JSON input");
                }
            }, t.stringify = function(e, t, i) {
                if (v(e)) {
                    var n = 0;
                    switch(typeof (u = "object" == typeof i ? i.space : i)){
                        case "number":
                            var o = 10 < u ? 10 : u < 0 ? 0 : Math.floor(u), u = o && y(o, " "), r = o, s = o;
                            break;
                        case "string":
                            u = u.slice(0, 10);
                            for(var a = s = r = 0; a < u.length; a++){
                                switch(u[a]){
                                    case " ":
                                        s++;
                                        break;
                                    case "\t":
                                        s += 4;
                                        break;
                                    case "\r":
                                        s = 0;
                                        break;
                                    case "\n":
                                        s = 0, n++;
                                        break;
                                    default:
                                        throw new Error("whitespace characters not allowed in JSON");
                                }
                                r++;
                            }
                            break;
                        default:
                            u = void 0;
                    }
                    var l = "", c = {}, h = 0, d = 0, g = 0, p = i && i.es6 && "function" == typeof Map;
                    return function l(c, h, d) {
                        C(d, "value");
                        switch(typeof c){
                            case "number":
                            case "bigint":
                            case "boolean":
                                m("" + c);
                                break;
                            case "string":
                                m(I(c));
                                break;
                            case "object":
                                null === c ? m("null") : "function" == typeof c.toJSON ? m(I(c.toJSON())) : Array.isArray(c) ? e() : p ? c.constructor.BYTES_PER_ELEMENT ? e() : c instanceof Map ? i() : c instanceof Set ? i(!0) : t() : t();
                        }
                        C(d, "valueEnd");
                        function e() {
                            if (c.length) {
                                m("[");
                                for(var e = h + 1, t = 0; t < c.length; t++){
                                    t && m(","), f(e);
                                    var i = v(c[t]) ? c[t] : null, n = d + "/" + t;
                                    l(i, e, n);
                                }
                                f(h), m("]");
                            } else m("[]");
                        }
                        function t() {
                            var e = Object.keys(c);
                            if (e.length) {
                                m("{");
                                for(var t = h + 1, i = 0; i < e.length; i++){
                                    var n, o = e[i], r = c[o];
                                    v(r) && (i && m(","), n = d + "/" + w(o), f(t), C(n, "key"), m(I(o)), C(n, "keyEnd"), m(":"), u && m(" "), l(r, t, n));
                                }
                                f(h), m("}");
                            } else m("{}");
                        }
                        function i(e) {
                            if (c.size) {
                                m("{");
                                for(var t = h + 1, i = !0, n = c.entries(), o = n.next(); !o.done;){
                                    var r, s = o.value, a = s[0], s = !!e || s[1];
                                    v(s) && (i || m(","), i = !1, r = d + "/" + w(a), f(t), C(r, "key"), m(I(a)), C(r, "keyEnd"), m(":"), u && m(" "), l(s, t, r)), o = n.next();
                                }
                                f(h), m("}");
                            } else m("{}");
                        }
                    }(e, 0, ""), {
                        json: l,
                        pointers: c
                    };
                }
                function m(e) {
                    d += e.length, g += e.length, l += e;
                }
                function f(e) {
                    if (u) {
                        for(l += "\n" + y(e, u), h++, d = 0; e--;)n ? (h += n, d = s) : d += s, g += r;
                        g += 1;
                    }
                }
                function C(e, t) {
                    c[e] = c[e] || {}, c[e][t] = {
                        line: h,
                        column: d,
                        pos: g
                    };
                }
                function y(e, t) {
                    return Array(e + 1).join(t);
                }
            }, [
                "number",
                "bigint",
                "boolean",
                "string",
                "object"
            ]);
            function v(e) {
                return 0 <= i.indexOf(typeof e);
            }
            var n = /"|\\/g, o = /[\b]/g, r = /\f/g, s = /\n/g, a = /\r/g, l = /\t/g;
            function I(e) {
                return '"' + (e = e.replace(n, "\\$&").replace(r, "\\f").replace(o, "\\b").replace(s, "\\n").replace(a, "\\r").replace(l, "\\t")) + '"';
            }
            var c = /~/g, h = /\//g;
            function w(e) {
                return e.replace(c, "~0").replace(h, "~1");
            }
        },
        8340: function(e, t) {
            var i;
            void 0 !== (t = "function" == typeof (i = function() {
                "use strict";
                function C(e) {
                    if (typeof Node === "object") return e instanceof Node;
                    else return e && typeof e === "object" && typeof e.nodeType === "number";
                }
                function y(e) {
                    return typeof e === "string";
                }
                function v() {
                    var r = [];
                    return {
                        watch: r.push.bind(r),
                        trigger: function(e, t) {
                            var i = true;
                            var n = {
                                detail: t,
                                preventDefault: function e() {
                                    i = false;
                                }
                            };
                            for(var o = 0; o < r.length; o++)r[o](e, n);
                            return i;
                        }
                    };
                }
                function o(e) {
                    return window.getComputedStyle(e).display === "none";
                }
                function r(e) {
                    this.elem = e;
                }
                function I(e, t) {
                    return r.make(e("parent")).clazz("pico-overlay").clazz(e("overlayClass", "")).stylize({
                        display: "none",
                        position: "fixed",
                        top: "0px",
                        left: "0px",
                        height: "100%",
                        width: "100%",
                        zIndex: 1e4
                    }).stylize(e("overlayStyles", {
                        opacity: .5,
                        background: "#000"
                    })).onClick(function() {
                        if (e("overlayClose", true)) t();
                    });
                }
                r.make = function(e, t) {
                    if (typeof e === "string") e = document.querySelector(e);
                    var i = document.createElement(t || "div");
                    (e || document.body).appendChild(i);
                    return new r(i);
                }, r.prototype = {
                    child: function(e) {
                        return r.make(this.elem, e);
                    },
                    stylize: function(e) {
                        e = e || {};
                        if (typeof e.opacity !== "undefined") e.filter = "alpha(opacity=" + e.opacity * 100 + ")";
                        for(var t in e)if (e.hasOwnProperty(t)) this.elem.style[t] = e[t];
                        return this;
                    },
                    clazz: function(e) {
                        this.elem.className += " " + e;
                        return this;
                    },
                    html: function(e) {
                        if (C(e)) this.elem.appendChild(e);
                        else this.elem.innerHTML = e;
                        return this;
                    },
                    onClick: function(e) {
                        this.elem.addEventListener("click", e);
                        return this;
                    },
                    destroy: function() {
                        this.elem.parentNode.removeChild(this.elem);
                    },
                    hide: function() {
                        this.elem.style.display = "none";
                    },
                    show: function() {
                        this.elem.style.display = "block";
                    },
                    attr: function(e, t) {
                        if (t !== undefined) this.elem.setAttribute(e, t);
                        return this;
                    },
                    anyAncestor: function(e) {
                        var t = this.elem;
                        while(t)if (e(new r(t))) return true;
                        else t = t.parentNode;
                        return false;
                    },
                    isVisible: function() {
                        return !o(this.elem);
                    }
                };
                var s = 1;
                function b(e, i) {
                    var t = e("width", "auto");
                    if (typeof t === "number") t = "" + t + "px";
                    var n = e("modalId", "pico-" + s++);
                    var o = r.make(e("parent")).clazz("pico-content").clazz(e("modalClass", "")).stylize({
                        display: "none",
                        position: "fixed",
                        zIndex: 10001,
                        left: "50%",
                        top: "38.1966%",
                        maxHeight: "90%",
                        boxSizing: "border-box",
                        width: t,
                        "-ms-transform": "translate(-50%,-38.1966%)",
                        "-moz-transform": "translate(-50%,-38.1966%)",
                        "-webkit-transform": "translate(-50%,-38.1966%)",
                        "-o-transform": "translate(-50%,-38.1966%)",
                        transform: "translate(-50%,-38.1966%)"
                    }).stylize(e("modalStyles", {
                        overflow: "auto",
                        backgroundColor: "white",
                        padding: "20px",
                        borderRadius: "5px"
                    })).html(e("content")).attr("id", n).attr("role", "dialog").attr("aria-labelledby", e("ariaLabelledBy")).attr("aria-describedby", e("ariaDescribedBy", n)).onClick(function(e) {
                        var t = new r(e.target).anyAncestor(function(e) {
                            return /\bpico-close\b/.test(e.elem.className);
                        });
                        if (t) i();
                    });
                    return o;
                }
                function A(e, t) {
                    if (t("closeButton", true)) return e.child("button").html(t("closeHtml", "&#xD7;")).clazz("pico-close").clazz(t("closeClass", "")).stylize(t("closeStyles", {
                        borderRadius: "2px",
                        border: 0,
                        padding: 0,
                        cursor: "pointer",
                        height: "15px",
                        width: "15px",
                        position: "absolute",
                        top: "5px",
                        right: "5px",
                        fontSize: "16px",
                        textAlign: "center",
                        lineHeight: "15px",
                        background: "#CCC"
                    })).attr("aria-label", t("close-label", "Close"));
                }
                function w(e) {
                    return function() {
                        return e().elem;
                    };
                }
                var x = v(), c = v();
                function S(r, s) {
                    function t(e, t) {
                        var i = e.msMatchesSelector || e.webkitMatchesSelector || e.matches;
                        return i.call(e, t);
                    }
                    function n(e) {
                        if (o(e) || t(e, ":disabled") || e.hasAttribute("contenteditable")) return false;
                        else return e.hasAttribute("tabindex") || t(e, "input,select,textarea,button,a[href],area[href],iframe");
                    }
                    function a(e) {
                        var t = e.getElementsByTagName("*");
                        for(var i = 0; i < t.length; i++)if (n(t[i])) return t[i];
                    }
                    function l(e) {
                        var t = e.getElementsByTagName("*");
                        for(var i = t.length; i--;)if (n(t[i])) return t[i];
                    }
                    var i;
                    r.beforeShow(function e() {
                        i = document.activeElement;
                    });
                    r.afterShow(function e() {
                        if (s()) {
                            var t = a(r.modalElem());
                            if (t) t.focus();
                        }
                    });
                    r.afterClose(function e() {
                        if (s() && i) i.focus();
                        i = null;
                    });
                    c.watch(function e(t) {
                        if (s() && r.isVisible()) {
                            var i = a(r.modalElem());
                            var n = l(r.modalElem());
                            var o = t.shiftKey ? i : n;
                            if (o === document.activeElement) {
                                (t.shiftKey ? n : i).focus();
                                t.preventDefault();
                            }
                        }
                    });
                }
                function k(e, t) {
                    var i;
                    var n = new r(document.body);
                    e.beforeShow(function() {
                        i = n.elem.style.overflow;
                        if (t()) n.stylize({
                            overflow: "hidden"
                        });
                    });
                    e.afterClose(function() {
                        n.stylize({
                            overflow: i
                        });
                    });
                }
                return document.documentElement.addEventListener("keydown", function e(t) {
                    var i = t.which || t.keyCode;
                    if (i === 27) x.trigger();
                    else if (i === 9) c.trigger(t);
                }), function e(n) {
                    if (y(n) || C(n)) n = {
                        content: n
                    };
                    var o = v();
                    var t = v();
                    var i = v();
                    var r = v();
                    var s = v();
                    function a(e, t) {
                        var i = n[e];
                        if (typeof i === "function") i = i(t);
                        return i === undefined ? t : i;
                    }
                    var l = f.bind(window, "modal");
                    var c = f.bind(window, "overlay");
                    var h = f.bind(window, "close");
                    var d;
                    function u(e) {
                        c().hide();
                        l().hide();
                        s.trigger(d, e);
                    }
                    function g(e) {
                        if (r.trigger(d, e)) u(e);
                    }
                    function p(e) {
                        return function() {
                            e.apply(this, arguments);
                            return d;
                        };
                    }
                    var m;
                    function f(e, t) {
                        if (!m) {
                            var i = b(a, g);
                            m = {
                                modal: i,
                                overlay: I(a, g),
                                close: A(i, a)
                            };
                            o.trigger(d, t);
                        }
                        return m[e];
                    }
                    d = {
                        modalElem: w(l),
                        closeElem: w(h),
                        overlayElem: w(c),
                        buildDom: p(f.bind(null, null)),
                        isVisible: function() {
                            return !!(m && l && l().isVisible());
                        },
                        show: function(e) {
                            if (t.trigger(d, e)) {
                                c().show();
                                h();
                                l().show();
                                i.trigger(d, e);
                            }
                            return this;
                        },
                        close: p(g),
                        forceClose: p(u),
                        destroy: function() {
                            l().destroy();
                            c().destroy();
                            c = l = h = undefined;
                        },
                        options: function(t) {
                            Object.keys(t).map(function(e) {
                                n[e] = t[e];
                            });
                        },
                        afterCreate: p(o.watch),
                        beforeShow: p(t.watch),
                        afterShow: p(i.watch),
                        beforeClose: p(r.watch),
                        afterClose: p(s.watch)
                    };
                    S(d, a.bind(null, "focus", true));
                    k(d, a.bind(null, "bodyOverflow", true));
                    x.watch(function e() {
                        if (a("escCloses", true) && d.isVisible()) d.close();
                    });
                    return d;
                };
            }) ? i.apply(t, []) : i) && (e.exports = t);
        },
        6777: function(e, t) {
            /** @license URI.js v4.4.1 (c) 2011 Gary Court. License: http://github.com/garycourt/uri-js */ ((e)=>{
                function y() {
                    for(var e = arguments.length, t = Array(e), i = 0; i < e; i++)t[i] = arguments[i];
                    if (1 < t.length) {
                        t[0] = t[0].slice(0, -1);
                        for(var n = t.length - 1, o = 1; o < n; ++o)t[o] = t[o].slice(1, -1);
                        return t[n] = t[n].slice(1), t.join("");
                    }
                    return t[0];
                }
                function v(e) {
                    return "(?:" + e + ")";
                }
                function n(e) {
                    return void 0 === e ? "undefined" : null === e ? "null" : Object.prototype.toString.call(e).split(" ").pop().split("]").shift().toLowerCase();
                }
                function g(e) {
                    return e.toUpperCase();
                }
                function t(e) {
                    var t = "[A-Za-z]", i = "[0-9]", n = y(i, "[A-Fa-f]"), o = v(v("%[EFef]" + n + "%" + n + n + "%" + n + n) + "|" + v("%[89A-Fa-f]" + n + "%" + n + n) + "|" + v("%" + n + n)), r = "[\\!\\$\\&\\'\\(\\)\\*\\+\\,\\;\\=]", s = y("[\\:\\/\\?\\#\\[\\]\\@]", r), a = e ? "[\\uE000-\\uF8FF]" : "[]", e = y(t, i, "[\\-\\.\\_\\~]", e ? "[\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]" : "[]"), l = (v(t + y(t, i, "[\\+\\-\\.]") + "*"), v(v(o + "|" + y(e, r, "[\\:]")) + "*"), "(?:(?:25[0-5])|(?:2[0-4][0-9])|(?:1[0-9][0-9])|(?:0?[1-9][0-9])|0?0?[0-9])"), l = v(l + "\\." + l + "\\." + l + "\\." + l), c = v(n + "{1,4}"), h = v(v(c + "\\:" + c) + "|" + l), d = v(v(c + "\\:") + "{6}" + h), u = v("\\:\\:" + v(c + "\\:") + "{5}" + h), g = v(v(c) + "?\\:\\:" + v(c + "\\:") + "{4}" + h), p = v(v(v(c + "\\:") + "{0,1}" + c) + "?\\:\\:" + v(c + "\\:") + "{3}" + h), m = v(v(v(c + "\\:") + "{0,2}" + c) + "?\\:\\:" + v(c + "\\:") + "{2}" + h), f = v(v(v(c + "\\:") + "{0,3}" + c) + "?\\:\\:" + c + "\\:" + h), h = v(v(v(c + "\\:") + "{0,4}" + c) + "?\\:\\:" + h), C = v(v(v(c + "\\:") + "{0,5}" + c) + "?\\:\\:" + c), c = v(v(v(c + "\\:") + "{0,6}" + c) + "?\\:\\:"), d = v([
                        d,
                        u,
                        g,
                        p,
                        m,
                        f,
                        h,
                        C,
                        c
                    ].join("|")), u = v(v(e + "|" + o) + "+"), g = (v("[vV]" + n + "+\\." + y(e, r, "[\\:]") + "+"), v(v(o + "|" + y(e, r)) + "*"), v(o + "|" + y(e, r, "[\\:\\@]")));
                    v(v(o + "|" + y(e, r, "[\\@]")) + "+"), v(v(g + "|" + y("[\\/\\?]", a)) + "*");
                    return {
                        NOT_SCHEME: new RegExp(y("[^]", t, i, "[\\+\\-\\.]"), "g"),
                        NOT_USERINFO: new RegExp(y("[^\\%\\:]", e, r), "g"),
                        NOT_HOST: new RegExp(y("[^\\%\\[\\]\\:]", e, r), "g"),
                        NOT_PATH: new RegExp(y("[^\\%\\/\\:\\@]", e, r), "g"),
                        NOT_PATH_NOSCHEME: new RegExp(y("[^\\%\\/\\@]", e, r), "g"),
                        NOT_QUERY: new RegExp(y("[^\\%]", e, r, "[\\:\\@\\/\\?]", a), "g"),
                        NOT_FRAGMENT: new RegExp(y("[^\\%]", e, r, "[\\:\\@\\/\\?]"), "g"),
                        ESCAPE: new RegExp(y("[^]", e, r), "g"),
                        UNRESERVED: new RegExp(e, "g"),
                        OTHER_CHARS: new RegExp(y("[^\\%]", e, s), "g"),
                        PCT_ENCODED: new RegExp(o, "g"),
                        IPV4ADDRESS: new RegExp("^(" + l + ")$"),
                        IPV6ADDRESS: new RegExp("^\\[?(" + d + ")" + v(v("\\%25|\\%(?!" + n + "{2})") + "(" + u + ")") + "?\\]?$")
                    };
                }
                var a = t(!1), l = t(!0), d = function(e, t) {
                    if (Array.isArray(e)) return e;
                    if (Symbol.iterator in Object(e)) {
                        var i = t, n = [], o = !0, t = !1, r = void 0;
                        try {
                            for(var s, a = e[Symbol.iterator](); !(o = (s = a.next()).done) && (n.push(s.value), !i || n.length !== i); o = !0);
                        } catch (e) {
                            t = !0, r = e;
                        } finally{
                            try {
                                !o && a.return && a.return();
                            } finally{
                                if (t) throw r;
                            }
                        }
                        return n;
                    }
                    throw new TypeError("Invalid attempt to destructure non-iterable instance");
                }, _ = 2147483647, L = 36, M = 26, E = 38, R = 700, $ = /^xn--/, P = /[^\0-\x7E]/, H = /[\x2E\u3002\uFF0E\uFF61]/g, G = {
                    overflow: "Overflow: input needs wider integers to process",
                    "not-basic": "Illegal input >= 0x80 (not a basic code point)",
                    "invalid-input": "Invalid input"
                }, o = L - 1, N = Math.floor, W = String.fromCharCode;
                function B(e) {
                    throw new RangeError(G[e]);
                }
                function i(e, t) {
                    var i = e.split("@"), n = "", i = (1 < i.length && (n = i[0] + "@", e = i[1]), (e = e.replace(H, ".")).split("."));
                    return n + ((e, t)=>{
                        for(var i = [], n = e.length; n--;)i[n] = t(e[n]);
                        return i;
                    })(i, t).join(".");
                }
                function F(e) {
                    for(var t = [], i = 0, n = e.length; i < n;){
                        var o, r = e.charCodeAt(i++);
                        55296 <= r && r <= 56319 && i < n ? 56320 == (64512 & (o = e.charCodeAt(i++))) ? t.push(((1023 & r) << 10) + (1023 & o) + 65536) : (t.push(r), i--) : t.push(r);
                    }
                    return t;
                }
                function D(e, t) {
                    return e + 22 + 75 * (e < 26) - ((0 != t) << 5);
                }
                function O(e, t, i) {
                    var n = 0;
                    for(e = i ? N(e / R) : e >> 1, e += N(e / t); o * M >> 1 < e; n += L)e = N(e / o);
                    return N(n + (o + 1) * e / (e + E));
                }
                function V(e) {
                    var t = [], i = e.length, n = 0, o = 128, r = 72, s = e.lastIndexOf("-");
                    s < 0 && (s = 0);
                    for(var a = 0; a < s; ++a)128 <= e.charCodeAt(a) && B("not-basic"), t.push(e.charCodeAt(a));
                    for(var l = 0 < s ? s + 1 : 0; l < i;){
                        for(var c = n, h = 1, d = L;; d += L){
                            i <= l && B("invalid-input");
                            var u = (u = e.charCodeAt(l++)) - 48 < 10 ? u - 22 : u - 65 < 26 ? u - 65 : u - 97 < 26 ? u - 97 : L, g = ((L <= u || u > N((_ - n) / h)) && B("overflow"), n += u * h, d <= r ? 1 : r + M <= d ? M : d - r);
                            if (u < g) break;
                            u = L - g;
                            h > N(_ / u) && B("overflow"), h *= u;
                        }
                        var p = t.length + 1, r = O(n - c, p, 0 == c);
                        N(n / p) > _ - o && B("overflow"), o += N(n / p), n %= p, t.splice(n++, 0, o);
                    }
                    return String.fromCodePoint.apply(String, t);
                }
                function Z(e) {
                    var t = [], i = (e = F(e)).length, n = 128, o = 0, r = 72, s = !0, a = !1, l = void 0;
                    try {
                        for(var c, h = e[Symbol.iterator](); !(s = (c = h.next()).done); s = !0){
                            var d = c.value;
                            d < 128 && t.push(W(d));
                        }
                    } catch (e) {
                        a = !0, l = e;
                    } finally{
                        try {
                            !s && h.return && h.return();
                        } finally{
                            if (a) throw l;
                        }
                    }
                    var u = t.length, g = u;
                    for(u && t.push("-"); g < i;){
                        var p = _, m = !0, f = !1, C = void 0;
                        try {
                            for(var y, v = e[Symbol.iterator](); !(m = (y = v.next()).done); m = !0){
                                var I = y.value;
                                n <= I && I < p && (p = I);
                            }
                        } catch (e) {
                            f = !0, C = e;
                        } finally{
                            try {
                                !m && v.return && v.return();
                            } finally{
                                if (f) throw C;
                            }
                        }
                        var b = g + 1, A = (p - n > N((_ - o) / b) && B("overflow"), o += (p - n) * b, n = p, !0), f = !1, C = void 0;
                        try {
                            for(var w, x = e[Symbol.iterator](); !(A = (w = x.next()).done); A = !0){
                                var S = w.value;
                                if (S < n && ++o > _ && B("overflow"), S == n) {
                                    for(var k = o, T = L;; T += L){
                                        var E = T <= r ? 1 : r + M <= T ? M : T - r;
                                        if (k < E) break;
                                        var R = k - E, $ = L - E;
                                        t.push(W(D(E + R % $, 0))), k = N(R / $);
                                    }
                                    t.push(W(D(k, 0))), r = O(o, b, g == u), o = 0, ++g;
                                }
                            }
                        } catch (e) {
                            f = !0, C = e;
                        } finally{
                            try {
                                !A && x.return && x.return();
                            } finally{
                                if (f) throw C;
                            }
                        }
                        ++o, ++n;
                    }
                    return t.join("");
                }
                var f = function(e) {
                    return i(e, function(e) {
                        return P.test(e) ? "xn--" + Z(e) : e;
                    });
                }, j = function(e) {
                    return i(e, function(e) {
                        return $.test(e) ? V(e.slice(4).toLowerCase()) : e;
                    });
                }, c = {};
                function p(e) {
                    e = e.charCodeAt(0);
                    return e < 16 ? "%0" + e.toString(16).toUpperCase() : e < 128 ? "%" + e.toString(16).toUpperCase() : e < 2048 ? "%" + (e >> 6 | 192).toString(16).toUpperCase() + "%" + (63 & e | 128).toString(16).toUpperCase() : "%" + (e >> 12 | 224).toString(16).toUpperCase() + "%" + (e >> 6 & 63 | 128).toString(16).toUpperCase() + "%" + (63 & e | 128).toString(16).toUpperCase();
                }
                function h(e) {
                    for(var t = "", i = 0, n = e.length; i < n;){
                        var o, r, s = parseInt(e.substr(i + 1, 2), 16);
                        s < 128 ? (t += String.fromCharCode(s), i += 3) : 194 <= s && s < 224 ? (6 <= n - i ? (o = parseInt(e.substr(i + 4, 2), 16), t += String.fromCharCode((31 & s) << 6 | 63 & o)) : t += e.substr(i, 6), i += 6) : 224 <= s ? (9 <= n - i ? (o = parseInt(e.substr(i + 4, 2), 16), r = parseInt(e.substr(i + 7, 2), 16), t += String.fromCharCode((15 & s) << 12 | (63 & o) << 6 | 63 & r)) : t += e.substr(i, 9), i += 9) : (t += e.substr(i, 3), i += 3);
                    }
                    return t;
                }
                function u(e, i) {
                    function t(e) {
                        var t = h(e);
                        return t.match(i.UNRESERVED) ? t : e;
                    }
                    e.scheme && (e.scheme = String(e.scheme).replace(i.PCT_ENCODED, t).toLowerCase().replace(i.NOT_SCHEME, "")), void 0 !== e.userinfo && (e.userinfo = String(e.userinfo).replace(i.PCT_ENCODED, t).replace(i.NOT_USERINFO, p).replace(i.PCT_ENCODED, g)), void 0 !== e.host && (e.host = String(e.host).replace(i.PCT_ENCODED, t).toLowerCase().replace(i.NOT_HOST, p).replace(i.PCT_ENCODED, g)), void 0 !== e.path && (e.path = String(e.path).replace(i.PCT_ENCODED, t).replace(e.scheme ? i.NOT_PATH : i.NOT_PATH_NOSCHEME, p).replace(i.PCT_ENCODED, g)), void 0 !== e.query && (e.query = String(e.query).replace(i.PCT_ENCODED, t).replace(i.NOT_QUERY, p).replace(i.PCT_ENCODED, g)), void 0 !== e.fragment && (e.fragment = String(e.fragment).replace(i.PCT_ENCODED, t).replace(i.NOT_FRAGMENT, p).replace(i.PCT_ENCODED, g));
                }
                function m(e) {
                    return e.replace(/^0*(.*)/, "$1") || "0";
                }
                function C(e, t) {
                    t = e.match(t.IPV4ADDRESS) || [], t = d(t, 2)[1];
                    return t ? t.split(".").map(m).join(".") : e;
                }
                function K(e, t) {
                    var i = e.match(t.IPV6ADDRESS) || [], i = d(i, 3), n = i[1], i = i[2];
                    if (n) {
                        for(var n = n.toLowerCase().split("::").reverse(), n = d(n, 2), o = n[0], n = n[1], r = n ? n.split(":").map(m) : [], s = o.split(":").map(m), n = t.IPV4ADDRESS.test(s[s.length - 1]), a = n ? 7 : 8, l = s.length - a, c = Array(a), h = 0; h < a; ++h)c[h] = r[h] || s[l + h] || "";
                        n && (c[a - 1] = C(c[a - 1], t));
                        var o = c.reduce(function(e, t, i) {
                            return t && "0" !== t || ((t = e[e.length - 1]) && t.index + t.length === i ? t.length++ : e.push({
                                index: i,
                                length: 1
                            })), e;
                        }, []).sort(function(e, t) {
                            return t.length - e.length;
                        })[0], n = void 0;
                        return n = o && 1 < o.length ? (t = c.slice(0, o.index), o = c.slice(o.index + o.length), t.join(":") + "::" + o.join(":")) : c.join(":"), i && (n += "%" + i), n;
                    }
                    return e;
                }
                var z = /^(?:([^:\/?#]+):)?(?:\/\/((?:([^\/?#@]*)@)?(\[[^\/?#\]]+\]|[^\/?#:]*)(?:\:(\d*))?))?([^?#]*)(?:\?([^#]*))?(?:#((?:.|\n|\r)*))?/i, X = void 0 === "".match(/(){0}/)[1];
                function r(e) {
                    var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {}, i = {}, n = !1 !== t.iri ? l : a, o = (e = "suffix" === t.reference ? (t.scheme ? t.scheme + ":" : "") + "//" + e : e).match(z);
                    if (o) {
                        X ? (i.scheme = o[1], i.userinfo = o[3], i.host = o[4], i.port = parseInt(o[5], 10), i.path = o[6] || "", i.query = o[7], i.fragment = o[8], isNaN(i.port) && (i.port = o[5])) : (i.scheme = o[1] || void 0, i.userinfo = -1 !== e.indexOf("@") ? o[3] : void 0, i.host = -1 !== e.indexOf("//") ? o[4] : void 0, i.port = parseInt(o[5], 10), i.path = o[6] || "", i.query = -1 !== e.indexOf("?") ? o[7] : void 0, i.fragment = -1 !== e.indexOf("#") ? o[8] : void 0, isNaN(i.port) && (i.port = e.match(/\/\/(?:.|\n)*\:(?:\/|\?|\#|$)/) ? o[4] : void 0)), i.host && (i.host = K(C(i.host, n), n)), i.reference = void 0 !== i.scheme || void 0 !== i.userinfo || void 0 !== i.host || void 0 !== i.port || i.path || void 0 !== i.query ? void 0 === i.scheme ? "relative" : void 0 === i.fragment ? "absolute" : "uri" : "same-document", t.reference && "suffix" !== t.reference && t.reference !== i.reference && (i.error = i.error || "URI is not a " + t.reference + " reference.");
                        e = c[(t.scheme || i.scheme || "").toLowerCase()];
                        if (t.unicodeSupport || e && e.unicodeSupport) u(i, n);
                        else {
                            if (i.host && (t.domainHost || e && e.domainHost)) try {
                                i.host = f(i.host.replace(n.PCT_ENCODED, h).toLowerCase());
                            } catch (e) {
                                i.error = i.error || "Host's domain name can not be converted to ASCII via punycode: " + e;
                            }
                            u(i, a);
                        }
                        e && e.parse && e.parse(i, t);
                    } else i.error = i.error || "URI can not be parsed.";
                    return i;
                }
                var Y = /^\.\.?\//, J = /^\/\.(\/|$)/, U = /^\/\.\.(\/|$)/, Q = /^\/?(?:.|\n)*?(?=\/|$)/;
                function I(e) {
                    for(var t = []; e.length;)if (e.match(Y)) e = e.replace(Y, "");
                    else if (e.match(J)) e = e.replace(J, "/");
                    else if (e.match(U)) e = e.replace(U, "/"), t.pop();
                    else if ("." === e || ".." === e) e = "";
                    else {
                        var i = e.match(Q);
                        if (!i) throw new Error("Unexpected dot segment condition");
                        i = i[0];
                        e = e.slice(i.length), t.push(i);
                    }
                    return t.join("");
                }
                function s(t) {
                    var i = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {}, e = i.iri ? l : a, n = [], o = c[(i.scheme || t.scheme || "").toLowerCase()];
                    if (o && o.serialize && o.serialize(t, i), t.host && !e.IPV6ADDRESS.test(t.host) && (i.domainHost || o && o.domainHost)) try {
                        t.host = i.iri ? j(t.host) : f(t.host.replace(e.PCT_ENCODED, h).toLowerCase());
                    } catch (e) {
                        t.error = t.error || "Host's domain name can not be converted to " + (i.iri ? "Unicode" : "ASCII") + " via punycode: " + e;
                    }
                    u(t, e), "suffix" !== i.reference && t.scheme && (n.push(t.scheme), n.push(":"));
                    e = t, s = !1 !== (s = i).iri ? l : a, r = [], void 0 !== e.userinfo && (r.push(e.userinfo), r.push("@")), void 0 !== e.host && r.push(K(C(String(e.host), s), s).replace(s.IPV6ADDRESS, function(e, t, i) {
                        return "[" + t + (i ? "%25" + i : "") + "]";
                    })), "number" != typeof e.port && "string" != typeof e.port || (r.push(":"), r.push(String(e.port)));
                    var r, s = r.length ? r.join("") : void 0;
                    return void 0 !== s && ("suffix" !== i.reference && n.push("//"), n.push(s), t.path) && "/" !== t.path.charAt(0) && n.push("/"), void 0 !== t.path && (e = t.path, i.absolutePath || o && o.absolutePath || (e = I(e)), void 0 === s && (e = e.replace(/^\/\//, "/%2F")), n.push(e)), void 0 !== t.query && (n.push("?"), n.push(t.query)), void 0 !== t.fragment && (n.push("#"), n.push(t.fragment)), n.join("");
                }
                function q(e, t) {
                    var i = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : {}, n = {};
                    return arguments[3] || (e = r(s(e, i), i), t = r(s(t, i), i)), !(i || {}).tolerant && t.scheme ? (n.scheme = t.scheme, n.userinfo = t.userinfo, n.host = t.host, n.port = t.port, n.path = I(t.path || ""), n.query = t.query) : (void 0 !== t.userinfo || void 0 !== t.host || void 0 !== t.port ? (n.userinfo = t.userinfo, n.host = t.host, n.port = t.port, n.path = I(t.path || ""), n.query = t.query) : (t.path ? ("/" === t.path.charAt(0) ? n.path = I(t.path) : (void 0 === e.userinfo && void 0 === e.host && void 0 === e.port || e.path ? e.path ? n.path = e.path.slice(0, e.path.lastIndexOf("/") + 1) + t.path : n.path = t.path : n.path = "/" + t.path, n.path = I(n.path)), n.query = t.query) : (n.path = e.path, void 0 !== t.query ? n.query = t.query : n.query = e.query), n.userinfo = e.userinfo, n.host = e.host, n.port = e.port), n.scheme = e.scheme), n.fragment = t.fragment, n;
                }
                function b(e, t) {
                    return e && e.toString().replace((t && t.iri ? l : a).PCT_ENCODED, h);
                }
                var A = {
                    scheme: "http",
                    domainHost: !0,
                    parse: function(e, t) {
                        return e.host || (e.error = e.error || "HTTP URIs must have a host."), e;
                    },
                    serialize: function(e, t) {
                        var i = "https" === String(e.scheme).toLowerCase();
                        return e.port !== (i ? 443 : 80) && "" !== e.port || (e.port = void 0), e.path || (e.path = "/"), e;
                    }
                }, ee = {
                    scheme: "https",
                    domainHost: A.domainHost,
                    parse: A.parse,
                    serialize: A.serialize
                };
                function te(e) {
                    return "boolean" == typeof e.secure ? e.secure : "wss" === String(e.scheme).toLowerCase();
                }
                var w = {
                    scheme: "ws",
                    domainHost: !0,
                    parse: function(e, t) {
                        return e.secure = te(e), e.resourceName = (e.path || "/") + (e.query ? "?" + e.query : ""), e.path = void 0, e.query = void 0, e;
                    },
                    serialize: function(e, t) {
                        var i, n;
                        return e.port !== (te(e) ? 443 : 80) && "" !== e.port || (e.port = void 0), "boolean" == typeof e.secure && (e.scheme = e.secure ? "wss" : "ws", e.secure = void 0), e.resourceName && (n = e.resourceName.split("?"), i = (n = d(n, 2))[0], n = n[1], e.path = i && "/" !== i ? i : void 0, e.query = n, e.resourceName = void 0), e.fragment = void 0, e;
                    }
                }, ie = {
                    scheme: "wss",
                    domainHost: w.domainHost,
                    parse: w.parse,
                    serialize: w.serialize
                }, ne = {}, x = "[A-Za-z0-9\\-\\.\\_\\~\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]", S = y("[\\!\\$\\%\\'\\(\\)\\*\\+\\,\\-\\.0-9\\<\\>A-Z\\x5E-\\x7E]", '[\\"\\\\]'), oe = new RegExp(x, "g"), k = new RegExp("(?:(?:%[EFef][0-9A-Fa-f]%[0-9A-Fa-f][0-9A-Fa-f]%[0-9A-Fa-f][0-9A-Fa-f])|(?:%[89A-Fa-f][0-9A-Fa-f]%[0-9A-Fa-f][0-9A-Fa-f])|(?:%[0-9A-Fa-f][0-9A-Fa-f]))", "g"), re = new RegExp(y("[^]", "[A-Za-z0-9\\!\\$\\%\\'\\*\\+\\-\\^\\_\\`\\{\\|\\}\\~]", "[\\.]", '[\\"]', S), "g"), se = new RegExp(y("[^]", x, "[\\!\\$\\'\\(\\)\\*\\+\\,\\;\\:\\@]"), "g"), ae = se;
                function T(e) {
                    var t = h(e);
                    return t.match(oe) ? t : e;
                }
                var S = {
                    scheme: "mailto",
                    parse: function(e, t) {
                        var i = e, n = i.to = i.path ? i.path.split(",") : [];
                        if (i.path = void 0, i.query) {
                            for(var o = !1, r = {}, s = i.query.split("&"), a = 0, l = s.length; a < l; ++a){
                                var c = s[a].split("=");
                                switch(c[0]){
                                    case "to":
                                        for(var h = c[1].split(","), d = 0, u = h.length; d < u; ++d)n.push(h[d]);
                                        break;
                                    case "subject":
                                        i.subject = b(c[1], t);
                                        break;
                                    case "body":
                                        i.body = b(c[1], t);
                                        break;
                                    default:
                                        o = !0, r[b(c[0], t)] = b(c[1], t);
                                }
                            }
                            o && (i.headers = r);
                        }
                        i.query = void 0;
                        for(var g = 0, p = n.length; g < p; ++g){
                            var m = n[g].split("@");
                            if (m[0] = b(m[0]), t.unicodeSupport) m[1] = b(m[1], t).toLowerCase();
                            else try {
                                m[1] = f(b(m[1], t).toLowerCase());
                            } catch (e) {
                                i.error = i.error || "Email address's domain name can not be converted to ASCII via punycode: " + e;
                            }
                            n[g] = m.join("@");
                        }
                        return i;
                    },
                    serialize: function(e, t) {
                        var i, n = e, o = null != (i = e.to) ? i instanceof Array ? i : "number" != typeof i.length || i.split || i.setInterval || i.call ? [
                            i
                        ] : Array.prototype.slice.call(i) : [];
                        if (o) {
                            for(var r = 0, s = o.length; r < s; ++r){
                                var a = String(o[r]), l = a.lastIndexOf("@"), c = a.slice(0, l).replace(k, T).replace(k, g).replace(re, p), a = a.slice(l + 1);
                                try {
                                    a = t.iri ? j(a) : f(b(a, t).toLowerCase());
                                } catch (e) {
                                    n.error = n.error || "Email address's domain name can not be converted to " + (t.iri ? "Unicode" : "ASCII") + " via punycode: " + e;
                                }
                                o[r] = c + "@" + a;
                            }
                            n.path = o.join(",");
                        }
                        var h, d = e.headers = e.headers || {}, u = (e.subject && (d.subject = e.subject), e.body && (d.body = e.body), []);
                        for(h in d)d[h] !== ne[h] && u.push(h.replace(k, T).replace(k, g).replace(se, p) + "=" + d[h].replace(k, T).replace(k, g).replace(ae, p));
                        return u.length && (n.query = u.join("&")), n;
                    }
                }, le = /^([^\:]+)\:(.*)/, x = {
                    scheme: "urn",
                    parse: function(e, t) {
                        var i, n, o = e.path && e.path.match(le);
                        return o ? (n = t.scheme || e.scheme || "urn", i = o[1].toLowerCase(), o = o[2], n = n + ":" + (t.nid || i), n = c[n], e.nid = i, e.nss = o, e.path = void 0, n && (e = n.parse(e, t))) : e.error = e.error || "URN can not be parsed.", e;
                    },
                    serialize: function(e, t) {
                        var i = t.scheme || e.scheme || "urn", n = e.nid, i = c[i + ":" + (t.nid || n)], i = e = i ? i.serialize(e, t) : e, e = e.nss;
                        return i.path = (n || t.nid) + ":" + e, i;
                    }
                }, ce = /^[0-9A-Fa-f]{8}(?:\-[0-9A-Fa-f]{4}){3}\-[0-9A-Fa-f]{12}$/, he = {
                    scheme: "urn:uuid",
                    parse: function(e, t) {
                        return e.uuid = e.nss, e.nss = void 0, t.tolerant || e.uuid && e.uuid.match(ce) || (e.error = e.error || "UUID is not valid."), e;
                    },
                    serialize: function(e, t) {
                        var i = e;
                        return i.nss = (e.uuid || "").toLowerCase(), i;
                    }
                };
                c[A.scheme] = A, c[ee.scheme] = ee, c[w.scheme] = w, c[ie.scheme] = ie, c[S.scheme] = S, c[x.scheme] = x, c[he.scheme] = he, e.SCHEMES = c, e.pctEncChar = p, e.pctDecChars = h, e.parse = r, e.removeDotSegments = I, e.serialize = s, e.resolveComponents = q, e.resolve = function(e, t, i) {
                    return i = ((e, t)=>{
                        var i = e;
                        if (t) for(var n in t)i[n] = t[n];
                        return i;
                    })({
                        scheme: "null"
                    }, i), s(q(r(e, i), r(t, i), i, !0), i);
                }, e.normalize = function(e, t) {
                    return "string" == typeof e ? e = s(r(e, t), t) : "object" === n(e) && (e = r(s(e, t), t)), e;
                }, e.equal = function(e, t, i) {
                    return "string" == typeof e ? e = s(r(e, i), i) : "object" === n(e) && (e = s(e, i)), "string" == typeof t ? t = s(r(t, i), i) : "object" === n(t) && (t = s(t, i)), e === t;
                }, e.escapeComponent = function(e, t) {
                    return e && e.toString().replace((t && t.iri ? l : a).ESCAPE, p);
                }, e.unescapeComponent = b, Object.defineProperty(e, "__esModule", {
                    value: !0
                });
            })(t);
        },
        7598: function(e) {
            e.exports = (()=>{
                function d(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }
                var e = (()=>{
                    function n(e, t) {
                        for(var i = 0; i < t.length; i++){
                            var n = t[i];
                            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                        }
                    }
                    return function(e, t, i) {
                        return t && n(e.prototype, t), i && n(e, i), e;
                    };
                })(), u = function(e, t) {
                    if (Array.isArray(e)) return e;
                    if (Symbol.iterator in Object(e)) {
                        var i = t, n = [], o = !0, t = !1, r = void 0;
                        try {
                            for(var s, a = e[Symbol.iterator](); !(o = (s = a.next()).done) && (n.push(s.value), !i || n.length !== i); o = !0);
                        } catch (e) {
                            t = !0, r = e;
                        } finally{
                            try {
                                !o && a.return && a.return();
                            } finally{
                                if (t) throw r;
                            }
                        }
                        return n;
                    }
                    throw new TypeError("Invalid attempt to destructure non-iterable instance");
                }, t = (String.prototype.startsWith = String.prototype.startsWith || function(e) {
                    return 0 === this.indexOf(e);
                }, String.prototype.padStart = String.prototype.padStart || function(e, t) {
                    for(var i = this; i.length < e;)i = t + i;
                    return i;
                }, {
                    cb: "0f8ff",
                    tqw: "aebd7",
                    q: "-ffff",
                    qmrn: "7fffd4",
                    zr: "0ffff",
                    bg: "5f5dc",
                    bsq: "e4c4",
                    bck: "---",
                    nch: "ebcd",
                    b: "--ff",
                    bvt: "8a2be2",
                    brwn: "a52a2a",
                    brw: "deb887",
                    ctb: "5f9ea0",
                    hrt: "7fff-",
                    chcT: "d2691e",
                    cr: "7f50",
                    rnw: "6495ed",
                    crns: "8dc",
                    crms: "dc143c",
                    cn: "-ffff",
                    Db: "--8b",
                    Dcn: "-8b8b",
                    Dgnr: "b8860b",
                    Dgr: "a9a9a9",
                    Dgrn: "-64-",
                    Dkhk: "bdb76b",
                    Dmgn: "8b-8b",
                    Dvgr: "556b2f",
                    Drng: "8c-",
                    Drch: "9932cc",
                    Dr: "8b--",
                    Dsmn: "e9967a",
                    Dsgr: "8fbc8f",
                    DsTb: "483d8b",
                    DsTg: "2f4f4f",
                    Dtrq: "-ced1",
                    Dvt: "94-d3",
                    ppnk: "1493",
                    pskb: "-bfff",
                    mgr: "696969",
                    grb: "1e90ff",
                    rbrc: "b22222",
                    rwht: "af0",
                    stg: "228b22",
                    chs: "-ff",
                    gnsb: "dcdcdc",
                    st: "8f8ff",
                    g: "d7-",
                    gnr: "daa520",
                    gr: "808080",
                    grn: "-8-0",
                    grnw: "adff2f",
                    hnw: "0fff0",
                    htpn: "69b4",
                    nnr: "cd5c5c",
                    ng: "4b-82",
                    vr: "0",
                    khk: "0e68c",
                    vnr: "e6e6fa",
                    nrb: "0f5",
                    wngr: "7cfc-",
                    mnch: "acd",
                    Lb: "add8e6",
                    Lcr: "08080",
                    Lcn: "e0ffff",
                    Lgnr: "afad2",
                    Lgr: "d3d3d3",
                    Lgrn: "90ee90",
                    Lpnk: "b6c1",
                    Lsmn: "a07a",
                    Lsgr: "20b2aa",
                    Lskb: "87cefa",
                    LsTg: "778899",
                    Lstb: "b0c4de",
                    Lw: "e0",
                    m: "-ff-",
                    mgrn: "32cd32",
                    nn: "af0e6",
                    mgnt: "-ff",
                    mrn: "8--0",
                    mqm: "66cdaa",
                    mmb: "--cd",
                    mmrc: "ba55d3",
                    mmpr: "9370db",
                    msg: "3cb371",
                    mmsT: "7b68ee",
                    "": "-fa9a",
                    mtr: "48d1cc",
                    mmvt: "c71585",
                    mnLb: "191970",
                    ntc: "5fffa",
                    mstr: "e4e1",
                    mccs: "e4b5",
                    vjw: "dead",
                    nv: "--80",
                    c: "df5e6",
                    v: "808-0",
                    vrb: "6b8e23",
                    rng: "a5-",
                    rngr: "45-",
                    rch: "da70d6",
                    pgnr: "eee8aa",
                    pgrn: "98fb98",
                    ptrq: "afeeee",
                    pvtr: "db7093",
                    ppwh: "efd5",
                    pchp: "dab9",
                    pr: "cd853f",
                    pnk: "c0cb",
                    pm: "dda0dd",
                    pwrb: "b0e0e6",
                    prp: "8-080",
                    cc: "663399",
                    r: "--",
                    sbr: "bc8f8f",
                    rb: "4169e1",
                    sbrw: "8b4513",
                    smn: "a8072",
                    nbr: "4a460",
                    sgrn: "2e8b57",
                    ssh: "5ee",
                    snn: "a0522d",
                    svr: "c0c0c0",
                    skb: "87ceeb",
                    sTb: "6a5acd",
                    sTgr: "708090",
                    snw: "afa",
                    n: "-ff7f",
                    stb: "4682b4",
                    tn: "d2b48c",
                    t: "-8080",
                    thst: "d8bfd8",
                    tmT: "6347",
                    trqs: "40e0d0",
                    vt: "ee82ee",
                    whT: "5deb3",
                    wht: "",
                    hts: "5f5f5",
                    w: "-",
                    wgrn: "9acd32"
                });
                function o(e, t) {
                    t = 1 < arguments.length && void 0 !== t ? t : 1;
                    return (0 < t ? e.toFixed(t).replace(/0+$/, "").replace(/\.$/, "") : e.toString()) || "0";
                }
                var n = (()=>{
                    function h(e, t, i, n) {
                        d(this, h);
                        var o, r, s, a, l, c = this;
                        void 0 !== e && (Array.isArray(e) ? this.rgba = e : void 0 === i ? (o = e && "" + e) && ((o = o.toLowerCase()).startsWith("hsl") ? (a = o.match(/([\-\d\.e]+)/g).map(Number), l = (a = u(a, 4))[0], r = a[1], s = a[2], c.hsla = [
                            l /= 360,
                            r /= 100,
                            s /= 100,
                            l = void 0 === (l = a[3]) ? 1 : l
                        ]) : o.startsWith("rgb") ? (r = o.match(/([\-\d\.e]+)/g).map(Number), a = (s = u(r, 4))[0], c.rgba = [
                            a,
                            s[1],
                            s[2],
                            l = void 0 === (l = s[3]) ? 1 : l
                        ]) : o.startsWith("#") ? c.rgba = h.hexToRgb(o) : c.rgba = h.nameToRgb(o) || h.hexToRgb(o)) : this.rgba = [
                            e,
                            t,
                            i,
                            void 0 === n ? 1 : n
                        ]);
                    }
                    return e(h, [
                        {
                            key: "printRGB",
                            value: function(e) {
                                var t = (e ? this.rgba : this.rgba.slice(0, 3)).map(function(e, t) {
                                    return o(e, 3 === t ? 3 : 0);
                                });
                                return e ? "rgba(" + t + ")" : "rgb(" + t + ")";
                            }
                        },
                        {
                            key: "printHSL",
                            value: function(e) {
                                var i = [
                                    360,
                                    100,
                                    100,
                                    1
                                ], n = [
                                    "",
                                    "%",
                                    "%",
                                    ""
                                ], t = (e ? this.hsla : this.hsla.slice(0, 3)).map(function(e, t) {
                                    return o(e * i[t], 3 === t ? 3 : 1) + n[t];
                                });
                                return e ? "hsla(" + t + ")" : "hsl(" + t + ")";
                            }
                        },
                        {
                            key: "printHex",
                            value: function(e) {
                                var t = this.hex;
                                return e ? t : t.substring(0, 7);
                            }
                        },
                        {
                            key: "rgba",
                            get: function() {
                                if (this._rgba) return this._rgba;
                                if (this._hsla) return this._rgba = h.hslToRgb(this._hsla);
                                throw new Error("No color is set");
                            },
                            set: function(e) {
                                3 === e.length && (e[3] = 1), this._rgba = e, this._hsla = null;
                            }
                        },
                        {
                            key: "rgbString",
                            get: function() {
                                return this.printRGB();
                            }
                        },
                        {
                            key: "rgbaString",
                            get: function() {
                                return this.printRGB(!0);
                            }
                        },
                        {
                            key: "hsla",
                            get: function() {
                                if (this._hsla) return this._hsla;
                                if (this._rgba) return this._hsla = h.rgbToHsl(this._rgba);
                                throw new Error("No color is set");
                            },
                            set: function(e) {
                                3 === e.length && (e[3] = 1), this._hsla = e, this._rgba = null;
                            }
                        },
                        {
                            key: "hslString",
                            get: function() {
                                return this.printHSL();
                            }
                        },
                        {
                            key: "hslaString",
                            get: function() {
                                return this.printHSL(!0);
                            }
                        },
                        {
                            key: "hex",
                            get: function() {
                                return "#" + this.rgba.map(function(e, t) {
                                    return (t < 3 ? e : Math.round(255 * e)).toString(16);
                                }).map(function(e) {
                                    return e.padStart(2, "0");
                                }).join("");
                            },
                            set: function(e) {
                                this.rgba = h.hexToRgb(e);
                            }
                        }
                    ], [
                        {
                            key: "hexToRgb",
                            value: function(e) {
                                var t = (e.startsWith("#") ? e.slice(1) : e).replace(/^(\w{3})$/, "$1F").replace(/^(\w)(\w)(\w)(\w)$/, "$1$1$2$2$3$3$4$4").replace(/^(\w{6})$/, "$1FF");
                                if (t.match(/^([0-9a-fA-F]{8})$/)) return (t = t.match(/^(\w\w)(\w\w)(\w\w)(\w\w)$/).slice(1).map(function(e) {
                                    return parseInt(e, 16);
                                }))[3] = t[3] / 255, t;
                                throw new Error("Unknown hex color; " + e);
                            }
                        },
                        {
                            key: "nameToRgb",
                            value: function(e) {
                                e = e.toLowerCase().replace("at", "T").replace(/[aeiouyldf]/g, "").replace("ght", "L").replace("rk", "D").slice(-5, 4), e = t[e];
                                return void 0 === e ? e : h.hexToRgb(e.replace(/\-/g, "00").padStart(6, "f"));
                            }
                        },
                        {
                            key: "rgbToHsl",
                            value: function(e) {
                                var e = u(e, 4), t = e[0], i = e[1], n = e[2], e = e[3], o = (t /= 255, i /= 255, n /= 255, Math.max(t, i, n)), r = Math.min(t, i, n), s = void 0, a = void 0, l = (o + r) / 2;
                                if (o === r) s = a = 0;
                                else {
                                    var c = o - r, a = .5 < l ? c / (2 - o - r) : c / (o + r);
                                    switch(o){
                                        case t:
                                            s = (i - n) / c + (i < n ? 6 : 0);
                                            break;
                                        case i:
                                            s = (n - t) / c + 2;
                                            break;
                                        case n:
                                            s = (t - i) / c + 4;
                                    }
                                    s /= 6;
                                }
                                return [
                                    s,
                                    a,
                                    l,
                                    e
                                ];
                            }
                        },
                        {
                            key: "hslToRgb",
                            value: function(e) {
                                var e = u(e, 4), t = e[0], i = e[1], n = e[2], e = e[3], o = void 0, r = void 0, s = void 0, a = (0 === i ? o = r = s = n : (o = (a = function(e, t, i) {
                                    return i < 0 && (i += 1), 1 < i && --i, i < 1 / 6 ? e + 6 * (t - e) * i : i < .5 ? t : i < 2 / 3 ? e + (t - e) * (2 / 3 - i) * 6 : e;
                                })(i = 2 * n - (n = n < .5 ? n * (1 + i) : n + i - n * i), n, t + 1 / 3), r = a(i, n, t), s = a(i, n, t - 1 / 3)), [
                                    255 * o,
                                    255 * r,
                                    255 * s
                                ].map(Math.round));
                                return a[3] = e, a;
                            }
                        }
                    ]), h;
                })(), i = (()=>{
                    function r() {
                        d(this, r), this._events = [];
                    }
                    return e(r, [
                        {
                            key: "add",
                            value: function(e, t, i) {
                                e.addEventListener(t, i, !1), this._events.push({
                                    target: e,
                                    type: t,
                                    handler: i
                                });
                            }
                        },
                        {
                            key: "remove",
                            value: function(i, n, o) {
                                this._events = this._events.filter(function(e) {
                                    var t = !0;
                                    return i && i !== e.target && (t = !1), n && n !== e.type && (t = !1), (t = o && o !== e.handler ? !1 : t) && r._doRemove(e.target, e.type, e.handler), !t;
                                });
                            }
                        },
                        {
                            key: "destroy",
                            value: function() {
                                this._events.forEach(function(e) {
                                    return r._doRemove(e.target, e.type, e.handler);
                                }), this._events = [];
                            }
                        }
                    ], [
                        {
                            key: "_doRemove",
                            value: function(e, t, i) {
                                e.removeEventListener(t, i, !1);
                            }
                        }
                    ]), r;
                })();
                function a(e, r, s) {
                    var a = !1;
                    function l(e, t, i) {
                        return Math.max(t, Math.min(e, i));
                    }
                    function i(e, t, i) {
                        var n, o;
                        (a = i ? !0 : a) && (e.preventDefault(), e = (i = r.getBoundingClientRect()).width, n = i.height, o = t.clientX, t = t.clientY, o = l(o - i.left, 0, e), t = l(t - i.top, 0, n), s(o / e, t / n));
                    }
                    function t(e, t) {
                        1 === (void 0 === e.buttons ? e.which : e.buttons) ? i(e, e, t) : a = !1;
                    }
                    function n(e, t) {
                        1 === e.touches.length ? i(e, e.touches[0], t) : a = !1;
                    }
                    e.add(r, "mousedown", function(e) {
                        t(e, !0);
                    }), e.add(r, "touchstart", function(e) {
                        n(e, !0);
                    }), e.add(window, "mousemove", t), e.add(r, "touchmove", n), e.add(window, "mouseup", function(e) {
                        a = !1;
                    }), e.add(r, "touchend", function(e) {
                        a = !1;
                    }), e.add(r, "touchcancel", function(e) {
                        a = !1;
                    });
                }
                var l = "mousedown", c = "focusin";
                function p(e, t) {
                    return (t || document).querySelector(e);
                }
                function r(e) {
                    e.preventDefault(), e.stopPropagation();
                }
                function h(e, t, i, n, o) {
                    e.add(t, "keydown", function(e) {
                        0 <= i.indexOf(e.key) && (o && r(e), n(e));
                    });
                }
                var s = (()=>{
                    function t(e) {
                        d(this, t), this.settings = {
                            popup: "right",
                            layout: "default",
                            alpha: !0,
                            editor: !0,
                            editorFormat: "hex",
                            cancelButton: !1,
                            defaultColor: "#0cf"
                        }, this._events = new i, this.onChange = null, this.onDone = null, this.onOpen = null, this.onClose = null, this.setOptions(e);
                    }
                    return e(t, [
                        {
                            key: "setOptions",
                            value: function(e) {
                                var t = this;
                                if (e) {
                                    var i = this.settings;
                                    if (e instanceof HTMLElement) i.parent = e;
                                    else {
                                        i.parent && e.parent && i.parent !== e.parent && (this._events.remove(i.parent), this._popupInited = !1);
                                        var n, o = e, r = i, s = void 0;
                                        for(n in o)s && 0 <= s.indexOf(n) || (r[n] = o[n]);
                                        e.onChange && (this.onChange = e.onChange), e.onDone && (this.onDone = e.onDone), e.onOpen && (this.onOpen = e.onOpen), e.onClose && (this.onClose = e.onClose);
                                        var a = e.color || e.colour;
                                        a && this._setColor(a);
                                    }
                                    var l, a = i.parent;
                                    a && i.popup && !this._popupInited ? (this._events.add(a, "click", l = function(e) {
                                        return t.openHandler(e);
                                    }), h(this._events, a, [
                                        " ",
                                        "Spacebar",
                                        "Enter"
                                    ], l), this._popupInited = !0) : e.parent && !i.popup && this.show();
                                }
                            }
                        },
                        {
                            key: "openHandler",
                            value: function(e) {
                                var t;
                                this.show() && (e && e.preventDefault(), this.settings.parent.style.pointerEvents = "none", t = e && "keydown" === e.type ? this._domEdit : this.domElement, setTimeout(function() {
                                    return t.focus();
                                }, 100), this.onOpen) && this.onOpen(this.colour);
                            }
                        },
                        {
                            key: "closeHandler",
                            value: function(e) {
                                var t, i = e && e.type, n = !1;
                                e ? i === l || i === c ? (t = (this.__containedEvent || 0) + 100, e.timeStamp > t && (n = !0)) : (r(e), n = !0) : n = !0, n && this.hide() && (this.settings.parent.style.pointerEvents = "", i !== l && this.settings.parent.focus(), this.onClose) && this.onClose(this.colour);
                            }
                        },
                        {
                            key: "movePopup",
                            value: function(e, t) {
                                this.closeHandler(), this.setOptions(e), t && this.openHandler();
                            }
                        },
                        {
                            key: "setColor",
                            value: function(e, t) {
                                this._setColor(e, {
                                    silent: t
                                });
                            }
                        },
                        {
                            key: "_setColor",
                            value: function(e, t) {
                                if (e = "string" == typeof e ? e.trim() : e) {
                                    t = t || {};
                                    var i = void 0;
                                    try {
                                        i = new n(e);
                                    } catch (e) {
                                        if (t.failSilently) return;
                                        throw e;
                                    }
                                    this.settings.alpha || ((e = i.hsla)[3] = 1, i.hsla = e), this.colour = this.color = i, this._setHSLA(null, null, null, null, t);
                                }
                            }
                        },
                        {
                            key: "setColour",
                            value: function(e, t) {
                                this.setColor(e, t);
                            }
                        },
                        {
                            key: "show",
                            value: function() {
                                var e, t, i;
                                return !!this.settings.parent && (this.domElement ? (t = this._toggleDOM(!0), this._setPosition(), t) : (t = this.settings.template || '<div class="picker_wrapper" tabindex="-1"><div class="picker_arrow"></div><div class="picker_hue picker_slider"><div class="picker_selector"></div></div><div class="picker_sl"><div class="picker_selector"></div></div><div class="picker_alpha picker_slider"><div class="picker_selector"></div></div><div class="picker_editor"><input aria-label="Type a color name or hex value"/></div><div class="picker_sample"></div><div class="picker_done"><button>Ok</button></div><div class="picker_cancel"><button>Cancel</button></div></div>', t, (i = document.createElement("div")).innerHTML = t, e = i.firstElementChild, this.domElement = e, this._domH = p(".picker_hue", e), this._domSL = p(".picker_sl", e), this._domA = p(".picker_alpha", e), this._domEdit = p(".picker_editor input", e), this._domSample = p(".picker_sample", e), this._domOkay = p(".picker_done button", e), this._domCancel = p(".picker_cancel button", e), e.classList.add("layout_" + this.settings.layout), this.settings.alpha || e.classList.add("no_alpha"), this.settings.editor || e.classList.add("no_editor"), this.settings.cancelButton || e.classList.add("no_cancel"), this._ifPopup(function() {
                                    return e.classList.add("popup");
                                }), this._setPosition(), this.colour ? this._updateUI() : this._setColor(this.settings.defaultColor), this._bindEvents(), !0));
                            }
                        },
                        {
                            key: "hide",
                            value: function() {
                                return this._toggleDOM(!1);
                            }
                        },
                        {
                            key: "destroy",
                            value: function() {
                                this._events.destroy(), this.domElement && this.settings.parent.removeChild(this.domElement);
                            }
                        },
                        {
                            key: "_bindEvents",
                            value: function() {
                                var i = this, n = this, o = this.domElement, r = this._events;
                                function s(e, t, i) {
                                    r.add(e, t, i);
                                }
                                s(o, "click", function(e) {
                                    return e.preventDefault();
                                }), a(r, this._domH, function(e, t) {
                                    n._setHSLA(e);
                                }), a(r, this._domSL, function(e, t) {
                                    n._setHSLA(null, e, 1 - t);
                                }), this.settings.alpha && a(r, this._domA, function(e, t) {
                                    n._setHSLA(null, null, null, 1 - t);
                                });
                                function e(e) {
                                    i._ifPopup(function() {
                                        return i.closeHandler(e);
                                    }), i.onDone && i.onDone(i.colour);
                                }
                                var t = this._domEdit;
                                s(t, "input", function(e) {
                                    n._setColor(this.value, {
                                        fromEditor: !0,
                                        failSilently: !0
                                    });
                                }), s(t, "focus", function(e) {
                                    this.selectionStart === this.selectionEnd && this.select();
                                }), this._ifPopup(function() {
                                    function e(e) {
                                        return i.closeHandler(e);
                                    }
                                    function t(e) {
                                        i.__containedEvent = e.timeStamp;
                                    }
                                    s(window, l, e), s(window, c, e), h(r, o, [
                                        "Esc",
                                        "Escape"
                                    ], e);
                                    s(o, l, t), s(o, c, t), s(i._domCancel, "click", e);
                                });
                                s(this._domOkay, "click", e), h(r, o, [
                                    "Enter"
                                ], e);
                            }
                        },
                        {
                            key: "_setPosition",
                            value: function() {
                                var i = this.settings.parent, n = this.domElement;
                                i !== n.parentNode && i.appendChild(n), this._ifPopup(function(e) {
                                    "static" === getComputedStyle(i).position && (i.style.position = "relative");
                                    var t = !0 === e ? "popup_right" : "popup_" + e;
                                    [
                                        "popup_top",
                                        "popup_bottom",
                                        "popup_left",
                                        "popup_right"
                                    ].forEach(function(e) {
                                        e === t ? n.classList.add(e) : n.classList.remove(e);
                                    }), n.classList.add(t);
                                });
                            }
                        },
                        {
                            key: "_setHSLA",
                            value: function(e, t, i, n, o) {
                                o = o || {};
                                var r = this.colour, s = r.hsla;
                                [
                                    e,
                                    t,
                                    i,
                                    n
                                ].forEach(function(e, t) {
                                    !e && 0 !== e || (s[t] = e);
                                }), r.hsla = s, this._updateUI(o), this.onChange && !o.silent && this.onChange(r);
                            }
                        },
                        {
                            key: "_updateUI",
                            value: function(e) {
                                if (this.domElement) {
                                    e = e || {};
                                    var t = this.colour, i = t.hsla, n = "hsl(" + 360 * i[0] + ", 100%, 50%)", o = t.hslString, r = t.hslaString, s = this._domH, a = this._domSL, l = this._domA, s = p(".picker_selector", s), c = p(".picker_selector", a), l = p(".picker_selector", l), s = (u(0, s, i[0]), this._domSL.style.backgroundColor = this._domH.style.color = n, u(0, c, i[1]), g(0, c, 1 - i[2]), a.style.color = o, g(0, l, 1 - i[3]), o), n = s.replace("hsl", "hsla").replace(")", ", 0)");
                                    if (this._domA.style.background = "linear-gradient(" + [
                                        s,
                                        n
                                    ] + ")" + ", linear-gradient(45deg, lightgrey 25%, transparent 25%, transparent 75%, lightgrey 75%) 0 0 / 2em 2em,\n                   linear-gradient(45deg, lightgrey 25%,       white 25%,       white 75%, lightgrey 75%) 1em 1em / 2em 2em", !e.fromEditor) {
                                        var c = this.settings.editorFormat, h = this.settings.alpha, d = void 0;
                                        switch(c){
                                            case "rgb":
                                                d = t.printRGB(h);
                                                break;
                                            case "hsl":
                                                d = t.printHSL(h);
                                                break;
                                            default:
                                                d = t.printHex(h);
                                        }
                                        this._domEdit.value = d;
                                    }
                                    this._domSample.style.color = r;
                                }
                                function u(e, t, i) {
                                    t.style.left = 100 * i + "%";
                                }
                                function g(e, t, i) {
                                    t.style.top = 100 * i + "%";
                                }
                            }
                        },
                        {
                            key: "_ifPopup",
                            value: function(e, t) {
                                this.settings.parent && this.settings.popup ? e && e(this.settings.popup) : t && t();
                            }
                        },
                        {
                            key: "_toggleDOM",
                            value: function(e) {
                                var t, i = this.domElement;
                                return !!i && ((t = i.style.display !== (e = e ? "" : "none")) && (i.style.display = e), t);
                            }
                        }
                    ]), t;
                })(), g = document.createElement("style");
                return g.textContent = '.picker_wrapper.no_alpha .picker_alpha{display:none}.picker_wrapper.no_editor .picker_editor{position:absolute;z-index:-1;opacity:0}.picker_wrapper.no_cancel .picker_cancel{display:none}.layout_default.picker_wrapper{display:flex;flex-flow:row wrap;justify-content:space-between;align-items:stretch;font-size:10px;width:25em;padding:.5em}.layout_default.picker_wrapper input,.layout_default.picker_wrapper button{font-size:1rem}.layout_default.picker_wrapper>*{margin:.5em}.layout_default.picker_wrapper::before{content:"";display:block;width:100%;height:0;order:1}.layout_default .picker_slider,.layout_default .picker_selector{padding:1em}.layout_default .picker_hue{width:100%}.layout_default .picker_sl{flex:1 1 auto}.layout_default .picker_sl::before{content:"";display:block;padding-bottom:100%}.layout_default .picker_editor{order:1;width:6.5rem}.layout_default .picker_editor input{width:100%;height:100%}.layout_default .picker_sample{order:1;flex:1 1 auto}.layout_default .picker_done,.layout_default .picker_cancel{order:1}.picker_wrapper{box-sizing:border-box;background:#f2f2f2;box-shadow:0 0 0 1px silver;cursor:default;font-family:sans-serif;color:#444;pointer-events:auto}.picker_wrapper:focus{outline:none}.picker_wrapper button,.picker_wrapper input{box-sizing:border-box;border:none;box-shadow:0 0 0 1px silver;outline:none}.picker_wrapper button:focus,.picker_wrapper button:active,.picker_wrapper input:focus,.picker_wrapper input:active{box-shadow:0 0 2px 1px #1e90ff}.picker_wrapper button{padding:.4em .6em;cursor:pointer;background-color:#f5f5f5;background-image:linear-gradient(0deg, gainsboro, transparent)}.picker_wrapper button:active{background-image:linear-gradient(0deg, transparent, gainsboro)}.picker_wrapper button:hover{background-color:#fff}.picker_selector{position:absolute;z-index:1;display:block;-webkit-transform:translate(-50%, -50%);transform:translate(-50%, -50%);border:2px solid #fff;border-radius:100%;box-shadow:0 0 3px 1px #67b9ff;background:currentColor;cursor:pointer}.picker_slider .picker_selector{border-radius:2px}.picker_hue{position:relative;background-image:linear-gradient(90deg, red, yellow, lime, cyan, blue, magenta, red);box-shadow:0 0 0 1px silver}.picker_sl{position:relative;box-shadow:0 0 0 1px silver;background-image:linear-gradient(180deg, white, rgba(255, 255, 255, 0) 50%),linear-gradient(0deg, black, rgba(0, 0, 0, 0) 50%),linear-gradient(90deg, #808080, rgba(128, 128, 128, 0))}.picker_alpha,.picker_sample{position:relative;background:linear-gradient(45deg, lightgrey 25%, transparent 25%, transparent 75%, lightgrey 75%) 0 0/2em 2em,linear-gradient(45deg, lightgrey 25%, white 25%, white 75%, lightgrey 75%) 1em 1em/2em 2em;box-shadow:0 0 0 1px silver}.picker_alpha .picker_selector,.picker_sample .picker_selector{background:none}.picker_editor input{font-family:monospace;padding:.2em .4em}.picker_sample::before{content:"";position:absolute;display:block;width:100%;height:100%;background:currentColor}.picker_arrow{position:absolute;z-index:-1}.picker_wrapper.popup{position:absolute;z-index:2;margin:1.5em}.picker_wrapper.popup,.picker_wrapper.popup .picker_arrow::before,.picker_wrapper.popup .picker_arrow::after{background:#f2f2f2;box-shadow:0 0 10px 1px rgba(0,0,0,.4)}.picker_wrapper.popup .picker_arrow{width:3em;height:3em;margin:0}.picker_wrapper.popup .picker_arrow::before,.picker_wrapper.popup .picker_arrow::after{content:"";display:block;position:absolute;top:0;left:0;z-index:-99}.picker_wrapper.popup .picker_arrow::before{width:100%;height:100%;-webkit-transform:skew(45deg);transform:skew(45deg);-webkit-transform-origin:0 100%;transform-origin:0 100%}.picker_wrapper.popup .picker_arrow::after{width:150%;height:150%;box-shadow:none}.popup.popup_top{bottom:100%;left:0}.popup.popup_top .picker_arrow{bottom:0;left:0;-webkit-transform:rotate(-90deg);transform:rotate(-90deg)}.popup.popup_bottom{top:100%;left:0}.popup.popup_bottom .picker_arrow{top:0;left:0;-webkit-transform:rotate(90deg) scale(1, -1);transform:rotate(90deg) scale(1, -1)}.popup.popup_left{top:0;right:100%}.popup.popup_left .picker_arrow{top:0;right:0;-webkit-transform:scale(-1, 1);transform:scale(-1, 1)}.popup.popup_right{top:0;left:100%}.popup.popup_right .picker_arrow{top:0;left:0}', document.documentElement.firstElementChild.appendChild(g), s.StyleElement = g, s;
            })();
        },
        9857: function(l, e, t) {
            t.d(e, {
                m: function() {
                    return a;
                }
            });
            class b extends Error {
                constructor(e, t){
                    super(e + " at position " + t), this.position = t;
                }
            }
            let i = 32, n = 10, o = 9, r = 13, d = 160, u = 6158, A = 8192, w = 8203, x = 8239, S = 8287, k = 12288, T = 65279;
            function E(e) {
                return "0" <= e && e <= "9";
            }
            function R(e) {
                return ",:[]/{}()\n+".includes(e);
            }
            function $(e) {
                return "a" <= e && e <= "z" || "A" <= e && e <= "Z" || "_" === e || "$" === e;
            }
            function _(e) {
                return "a" <= e && e <= "z" || "A" <= e && e <= "Z" || "_" === e || "$" === e || "0" <= e && e <= "9";
            }
            let L = /^(http|https|ftp|mailto|file|data|irc):\/\/$/, M = /^[A-Za-z0-9-._~:/?#@!$&'()*+;=]$/;
            function N(e) {
                return ",[]/{}\n+".includes(e);
            }
            function W(e) {
                return O(e) || s.test(e);
            }
            let s = /^[[{\w-]$/;
            function B(e, t) {
                e = e.charCodeAt(t);
                return e === i || e === n || e === o || e === r;
            }
            function D(e, t) {
                e = e.charCodeAt(t);
                return e === i || e === o || e === r;
            }
            function O(e) {
                return P(e) || G(e);
            }
            function P(e) {
                return '"' === e || "\u201C" === e || "\u201D" === e;
            }
            function H(e) {
                return '"' === e;
            }
            function G(e) {
                return "'" === e || "\u2018" === e || "\u2019" === e || "`" === e || "\xb4" === e;
            }
            function F(e) {
                return "'" === e;
            }
            function V(e, t, i) {
                i = 2 < arguments.length && void 0 !== i && i, t = e.lastIndexOf(t);
                return -1 !== t ? e.substring(0, t) + (i ? "" : e.substring(t + 1)) : e;
            }
            function Z(e, t) {
                let i = e.length;
                if (!B(e, i - 1)) return e + t;
                for(; B(e, i - 1);)i--;
                return e.substring(0, i) + t + e.substring(i);
            }
            let j = {
                "\b": "\\b",
                "\f": "\\f",
                "\n": "\\n",
                "\r": "\\r",
                "\t": "\\t"
            }, K = {
                '"': '"',
                "\\": "\\",
                "/": "/",
                b: "\b",
                f: "\f",
                n: "\n",
                r: "\r",
                t: "\t"
            };
            function a(g) {
                let p = 0, m = "";
                if (t([
                    "```",
                    "[```",
                    "{```"
                ]), !r()) throw new b("Unexpected end of json string", g.length);
                t([
                    "```",
                    "```]",
                    "```}"
                ]);
                var e = s(",");
                if (e && f(), W(g[p]) && /[,\n][ \t\r]*$/.test(m)) {
                    e || (m = Z(m, ","));
                    {
                        let e = !0, t = !0;
                        for(; t;)e ? e = !1 : s(",") || (m = Z(m, ",")), t = r();
                        m = `[
${m = t ? m : V(m, ",")}
]`;
                    }
                } else e && (m = V(m, ","));
                for(; "}" === g[p] || "]" === g[p];)p++, f();
                if (p >= g.length) return m;
                throw new b("Unexpected character " + JSON.stringify(g[p]), p);
                function r() {
                    f();
                    var e = (()=>{
                        if ("{" !== g[p]) return !1;
                        {
                            m += "{", p++, f(), C(",") && f();
                            let t = !0;
                            for(; p < g.length && "}" !== g[p];){
                                let e;
                                if (t ? (e = !0, t = !1) : ((e = s(",")) || (m = Z(m, ",")), f()), a(), !(y() || l(!0))) {
                                    "}" === g[p] || "{" === g[p] || "]" === g[p] || "[" === g[p] || void 0 === g[p] ? m = V(m, ",") : (()=>{
                                        throw new b("Object key expected", p);
                                    })();
                                    break;
                                }
                                f();
                                var i = s(":"), n = p >= g.length, o = (i || (W(g[p]) || n ? m = Z(m, ":") : h()), r());
                                o || (i || n ? m += "null" : h());
                            }
                            return "}" === g[p] ? (m += "}", p++) : m = Z(m, "}"), !0;
                        }
                    })() || (()=>{
                        if ("[" !== g[p]) return !1;
                        {
                            m += "[", p++, f(), C(",") && f();
                            let e = !0;
                            for(; p < g.length && "]" !== g[p];){
                                e ? e = !1 : s(",") || (m = Z(m, ",")), a();
                                var t = r();
                                if (!t) {
                                    m = V(m, ",");
                                    break;
                                }
                            }
                            return "]" === g[p] ? (m += "]", p++) : m = Z(m, "]"), !0;
                        }
                    })() || y() || (()=>{
                        var e, t, i = p;
                        if ("-" === g[p]) {
                            if (p++, o()) return c(i), !0;
                            if (!E(g[p])) return p = i, !1;
                        }
                        for(; E(g[p]);)p++;
                        if ("." === g[p]) {
                            if (p++, o()) return c(i), !0;
                            if (!E(g[p])) return p = i, !1;
                            for(; E(g[p]);)p++;
                        }
                        if ("e" === g[p] || "E" === g[p]) {
                            if (p++, "-" !== g[p] && "+" !== g[p] || p++, o()) return c(i), !0;
                            if (!E(g[p])) return p = i, !1;
                            for(; E(g[p]);)p++;
                        }
                        if (o()) {
                            if (p > i) return e = g.slice(i, p), t = /^0\d/.test(e), m += t ? `"${e}"` : e, !0;
                        } else p = i;
                        return !1;
                    })() || i("true", "true") || i("false", "false") || i("null", "null") || i("True", "true") || i("False", "false") || i("None", "null") || l(!1) || (()=>{
                        if ("/" === g[p]) {
                            var e = p;
                            for(p++; p < g.length && ("/" !== g[p] || "\\" === g[p - 1]);)p++;
                            return p++, m += JSON.stringify(g.substring(e, p)), !0;
                        }
                    })();
                    return f(), e;
                }
                function f(e) {
                    var t = !(0 < arguments.length && void 0 !== e) || e;
                    p;
                    let i = n(t);
                    for(; i = (i = (()=>{
                        if ("/" === g[p] && "*" === g[p + 1]) {
                            for(; p < g.length && !((e, t)=>"*" === e[t] && "/" === e[t + 1])(g, p);)p++;
                            p += 2;
                        } else {
                            if ("/" !== g[p] || "/" !== g[p + 1]) return !1;
                            for(; p < g.length && "\n" !== g[p];)p++;
                        }
                        return !0;
                    })()) && n(t););
                    p;
                }
                function n(e) {
                    var t, i, n = e ? B : D;
                    let o = "";
                    for(;;){
                        if (n(g, p)) o += g[p];
                        else {
                            if (t = g, i = p, !((t = t.charCodeAt(i)) === d || t === u || t >= A && t <= w || t === x || t === S || t === k || t === T)) break;
                            o += " ";
                        }
                        p++;
                    }
                    return 0 < o.length && (m += o, !0);
                }
                function t(e) {
                    if (((e)=>{
                        n(!0);
                        for (var t of e){
                            var i = p + t.length;
                            if (g.slice(p, i) === t) return p = i, 1;
                        }
                    })(e)) {
                        if ($(g[p])) for(; p < g.length && _(g[p]);)p++;
                        f();
                    }
                }
                function s(e) {
                    return g[p] === e && (m += g[p], p++, !0);
                }
                function C(e) {
                    return g[p] === e && (p++, !0);
                }
                function a() {
                    f(), "." === g[p] && "." === g[p + 1] && "." === g[p + 2] && (p += 3, f(), C(","));
                }
                function y(e, t) {
                    var i = 0 < arguments.length && void 0 !== e && e, n = 1 < arguments.length && void 0 !== t ? t : -1;
                    let o = "\\" === g[p];
                    if (o && (p++, o = !0), O(g[p])) {
                        var r = H(g[p]) ? H : F(g[p]) ? F : G(g[p]) ? G : P, s = p, a = m.length;
                        let t = '"';
                        for(p++;;){
                            if (p >= g.length) return l = I(p - 1), !i && R(g.charAt(l)) ? (p = s, m = m.substring(0, a), y(!0)) : (t = Z(t, '"'), m += t, !0);
                            if (p === n) return t = Z(t, '"'), m += t, !0;
                            if (r(g[p])) {
                                var l = p, c = t.length;
                                if (t += '"', p++, m += t, f(!1), i || p >= g.length || R(g[p]) || O(g[p]) || E(g[p])) return v(), !0;
                                var h = I(l - 1), d = g.charAt(h);
                                if ("," === d) return p = s, m = m.substring(0, a), y(!1, h);
                                if (R(d)) return p = s, m = m.substring(0, a), y(!0);
                                m = m.substring(0, a), p = l + 1, t = t.substring(0, c) + "\\" + t.substring(c);
                            } else {
                                if (i && N(g[p])) {
                                    if (":" === g[p - 1] && L.test(g.substring(s + 1, p + 2))) for(; p < g.length && M.test(g[p]);)t += g[p], p++;
                                    return t = Z(t, '"'), m += t, v(), !0;
                                }
                                if ("\\" === g[p]) {
                                    h = g.charAt(p + 1);
                                    if (void 0 !== K[h]) t += g.slice(p, p + 2), p += 2;
                                    else if ("u" === h) {
                                        let e = 2;
                                        for(; e < 6 && /^[0-9A-Fa-f]$/.test(g[p + e]);)e++;
                                        if (6 === e) t += g.slice(p, p + 6), p += 6;
                                        else {
                                            if (!(p + e >= g.length)) throw d = void 0, d = g.slice(p, p + 6), new b(`Invalid unicode character "${d}"`, p);
                                            p = g.length;
                                        }
                                    } else t += h, p += 2;
                                } else {
                                    var u, c = g.charAt(p);
                                    if ('"' === c && "\\" !== g[p - 1]) t += "\\" + c;
                                    else if ("\n" === (u = c) || "\r" === u || "\t" === u || "\b" === u || "\f" === u) t += j[c];
                                    else {
                                        if (!(" " <= c)) throw u = void 0, u = c, new b("Invalid character " + JSON.stringify(u), p);
                                        t += c;
                                    }
                                    p++;
                                }
                            }
                            o && C("\\");
                        }
                    }
                    return !1;
                }
                function v() {
                    let e = !1;
                    for(f(); "+" === g[p];){
                        e = !0, p++, f();
                        var t = (m = V(m, '"', !0)).length, i = y();
                        m = i ? (i = m, t, n = 1, i.substring(0, t) + i.substring(t + n)) : Z(m, '"');
                    }
                    var n;
                    e;
                }
                function i(e, t) {
                    return g.slice(p, p + e.length) === e && (m += t, p += e.length, !0);
                }
                function l(e) {
                    var t = p;
                    if ($(g[p])) {
                        for(; p < g.length && _(g[p]);)p++;
                        let e = p;
                        for(; B(g, e);)e++;
                        if ("(" === g[e]) return p = e + 1, r(), ")" === g[p] && (p++, ";" === g[p]) && p++, !0;
                    }
                    for(; p < g.length && !N(g[p]) && !O(g[p]) && (!e || ":" !== g[p]);)p++;
                    if (":" === g[p - 1] && L.test(g.substring(t, p + 2))) for(; p < g.length && M.test(g[p]);)p++;
                    if (p > t) {
                        for(; B(g, p - 1) && 0 < p;)p--;
                        t = g.slice(t, p);
                        return m += "undefined" === t ? "null" : JSON.stringify(t), '"' === g[p] && p++, !0;
                    }
                }
                function I(e) {
                    let t = e;
                    for(; 0 < t && B(g, t);)t--;
                    return t;
                }
                function o() {
                    return p >= g.length || R(g[p]) || B(g, p);
                }
                function c(e) {
                    m += g.slice(e, p) + "0";
                }
                function h() {
                    throw new b("Colon expected", p);
                }
            }
        },
        3420: function(e) {
            e.exports = JSON.parse('{"$schema":"http://json-schema.org/draft-07/schema#","$id":"https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#","description":"Meta-schema for $data reference (JSON Schema extension proposal)","type":"object","required":["$data"],"properties":{"$data":{"type":"string","anyOf":[{"format":"relative-json-pointer"},{"format":"json-pointer"}]}},"additionalProperties":false}');
        },
        5207: function(e) {
            e.exports = JSON.parse('{"id":"http://json-schema.org/draft-04/schema#","$schema":"http://json-schema.org/draft-04/schema#","description":"Core schema meta-schema","definitions":{"schemaArray":{"type":"array","minItems":1,"items":{"$ref":"#"}},"positiveInteger":{"type":"integer","minimum":0},"positiveIntegerDefault0":{"allOf":[{"$ref":"#/definitions/positiveInteger"},{"default":0}]},"simpleTypes":{"enum":["array","boolean","integer","null","number","object","string"]},"stringArray":{"type":"array","items":{"type":"string"},"minItems":1,"uniqueItems":true}},"type":"object","properties":{"id":{"type":"string"},"$schema":{"type":"string"},"title":{"type":"string"},"description":{"type":"string"},"default":{},"multipleOf":{"type":"number","minimum":0,"exclusiveMinimum":true},"maximum":{"type":"number"},"exclusiveMaximum":{"type":"boolean","default":false},"minimum":{"type":"number"},"exclusiveMinimum":{"type":"boolean","default":false},"maxLength":{"$ref":"#/definitions/positiveInteger"},"minLength":{"$ref":"#/definitions/positiveIntegerDefault0"},"pattern":{"type":"string","format":"regex"},"additionalItems":{"anyOf":[{"type":"boolean"},{"$ref":"#"}],"default":{}},"items":{"anyOf":[{"$ref":"#"},{"$ref":"#/definitions/schemaArray"}],"default":{}},"maxItems":{"$ref":"#/definitions/positiveInteger"},"minItems":{"$ref":"#/definitions/positiveIntegerDefault0"},"uniqueItems":{"type":"boolean","default":false},"maxProperties":{"$ref":"#/definitions/positiveInteger"},"minProperties":{"$ref":"#/definitions/positiveIntegerDefault0"},"required":{"$ref":"#/definitions/stringArray"},"additionalProperties":{"anyOf":[{"type":"boolean"},{"$ref":"#"}],"default":{}},"definitions":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"properties":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"patternProperties":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"dependencies":{"type":"object","additionalProperties":{"anyOf":[{"$ref":"#"},{"$ref":"#/definitions/stringArray"}]}},"enum":{"type":"array","minItems":1,"uniqueItems":true},"type":{"anyOf":[{"$ref":"#/definitions/simpleTypes"},{"type":"array","items":{"$ref":"#/definitions/simpleTypes"},"minItems":1,"uniqueItems":true}]},"format":{"type":"string"},"allOf":{"$ref":"#/definitions/schemaArray"},"anyOf":{"$ref":"#/definitions/schemaArray"},"oneOf":{"$ref":"#/definitions/schemaArray"},"not":{"$ref":"#"}},"dependencies":{"exclusiveMaximum":["maximum"],"exclusiveMinimum":["minimum"]},"default":{}}');
        },
        6801: function(e) {
            e.exports = JSON.parse('{"$schema":"http://json-schema.org/draft-06/schema#","$id":"http://json-schema.org/draft-06/schema#","title":"Core schema meta-schema","definitions":{"schemaArray":{"type":"array","minItems":1,"items":{"$ref":"#"}},"nonNegativeInteger":{"type":"integer","minimum":0},"nonNegativeIntegerDefault0":{"allOf":[{"$ref":"#/definitions/nonNegativeInteger"},{"default":0}]},"simpleTypes":{"enum":["array","boolean","integer","null","number","object","string"]},"stringArray":{"type":"array","items":{"type":"string"},"uniqueItems":true,"default":[]}},"type":["object","boolean"],"properties":{"$id":{"type":"string","format":"uri-reference"},"$schema":{"type":"string","format":"uri"},"$ref":{"type":"string","format":"uri-reference"},"title":{"type":"string"},"description":{"type":"string"},"default":{},"examples":{"type":"array","items":{}},"multipleOf":{"type":"number","exclusiveMinimum":0},"maximum":{"type":"number"},"exclusiveMaximum":{"type":"number"},"minimum":{"type":"number"},"exclusiveMinimum":{"type":"number"},"maxLength":{"$ref":"#/definitions/nonNegativeInteger"},"minLength":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"pattern":{"type":"string","format":"regex"},"additionalItems":{"$ref":"#"},"items":{"anyOf":[{"$ref":"#"},{"$ref":"#/definitions/schemaArray"}],"default":{}},"maxItems":{"$ref":"#/definitions/nonNegativeInteger"},"minItems":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"uniqueItems":{"type":"boolean","default":false},"contains":{"$ref":"#"},"maxProperties":{"$ref":"#/definitions/nonNegativeInteger"},"minProperties":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"required":{"$ref":"#/definitions/stringArray"},"additionalProperties":{"$ref":"#"},"definitions":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"properties":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"patternProperties":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"dependencies":{"type":"object","additionalProperties":{"anyOf":[{"$ref":"#"},{"$ref":"#/definitions/stringArray"}]}},"propertyNames":{"$ref":"#"},"const":{},"enum":{"type":"array","minItems":1,"uniqueItems":true},"type":{"anyOf":[{"$ref":"#/definitions/simpleTypes"},{"type":"array","items":{"$ref":"#/definitions/simpleTypes"},"minItems":1,"uniqueItems":true}]},"format":{"type":"string"},"allOf":{"$ref":"#/definitions/schemaArray"},"anyOf":{"$ref":"#/definitions/schemaArray"},"oneOf":{"$ref":"#/definitions/schemaArray"},"not":{"$ref":"#"}},"default":{}}');
        },
        8198: function(e) {
            e.exports = JSON.parse('{"$schema":"http://json-schema.org/draft-07/schema#","$id":"http://json-schema.org/draft-07/schema#","title":"Core schema meta-schema","definitions":{"schemaArray":{"type":"array","minItems":1,"items":{"$ref":"#"}},"nonNegativeInteger":{"type":"integer","minimum":0},"nonNegativeIntegerDefault0":{"allOf":[{"$ref":"#/definitions/nonNegativeInteger"},{"default":0}]},"simpleTypes":{"enum":["array","boolean","integer","null","number","object","string"]},"stringArray":{"type":"array","items":{"type":"string"},"uniqueItems":true,"default":[]}},"type":["object","boolean"],"properties":{"$id":{"type":"string","format":"uri-reference"},"$schema":{"type":"string","format":"uri"},"$ref":{"type":"string","format":"uri-reference"},"$comment":{"type":"string"},"title":{"type":"string"},"description":{"type":"string"},"default":true,"readOnly":{"type":"boolean","default":false},"examples":{"type":"array","items":true},"multipleOf":{"type":"number","exclusiveMinimum":0},"maximum":{"type":"number"},"exclusiveMaximum":{"type":"number"},"minimum":{"type":"number"},"exclusiveMinimum":{"type":"number"},"maxLength":{"$ref":"#/definitions/nonNegativeInteger"},"minLength":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"pattern":{"type":"string","format":"regex"},"additionalItems":{"$ref":"#"},"items":{"anyOf":[{"$ref":"#"},{"$ref":"#/definitions/schemaArray"}],"default":true},"maxItems":{"$ref":"#/definitions/nonNegativeInteger"},"minItems":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"uniqueItems":{"type":"boolean","default":false},"contains":{"$ref":"#"},"maxProperties":{"$ref":"#/definitions/nonNegativeInteger"},"minProperties":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"required":{"$ref":"#/definitions/stringArray"},"additionalProperties":{"$ref":"#"},"definitions":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"properties":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"patternProperties":{"type":"object","additionalProperties":{"$ref":"#"},"propertyNames":{"format":"regex"},"default":{}},"dependencies":{"type":"object","additionalProperties":{"anyOf":[{"$ref":"#"},{"$ref":"#/definitions/stringArray"}]}},"propertyNames":{"$ref":"#"},"const":true,"enum":{"type":"array","items":true,"minItems":1,"uniqueItems":true},"type":{"anyOf":[{"$ref":"#/definitions/simpleTypes"},{"type":"array","items":{"$ref":"#/definitions/simpleTypes"},"minItems":1,"uniqueItems":true}]},"format":{"type":"string"},"contentMediaType":{"type":"string"},"contentEncoding":{"type":"string"},"if":{"$ref":"#"},"then":{"$ref":"#"},"else":{"$ref":"#"},"allOf":{"$ref":"#/definitions/schemaArray"},"anyOf":{"$ref":"#/definitions/schemaArray"},"oneOf":{"$ref":"#/definitions/schemaArray"},"not":{"$ref":"#"}},"default":true}');
        }
    }, o = {}, n.amdD = function() {
        throw new Error("define cannot be used indirect");
    }, n.n = function(e) {
        var t = e && e.__esModule ? function() {
            return e.default;
        } : function() {
            return e;
        };
        return n.d(t, {
            a: t
        }), t;
    }, n.d = function(e, t) {
        for(var i in t)n.o(t, i) && !n.o(e, i) && Object.defineProperty(e, i, {
            enumerable: !0,
            get: t[i]
        });
    }, n.o = function(e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
    }, n.r = function(e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(e, "__esModule", {
            value: !0
        });
    }, n.nmd = function(e) {
        return e.paths = [], e.children || (e.children = []), e;
    }, n(1346);
    function n(e) {
        var t = o[e];
        return void 0 !== t || (t = o[e] = {
            id: e,
            loaded: !1,
            exports: {}
        }, i[e].call(t.exports, t, t.exports, n), t.loaded = !0), t.exports;
    }
}); //# sourceMappingURL=jsoneditor.map



function $8431272958d6d256$export$2e2bcd8739ae039(props) {
    const { value: value, onChange: onChange, onLoad: onLoad, editorRef: editorRef } = props;
    const element = (0, $8v0nu.useRef)(null);
    // Stash latest callback identities in refs so the mount-only effect below
    // always invokes the freshest closure without re-creating the editor.
    const onChangeRef = (0, $8v0nu.useRef)(onChange);
    const onLoadRef = (0, $8v0nu.useRef)(onLoad);
    (0, $8v0nu.useEffect)(()=>{
        onChangeRef.current = onChange;
        onLoadRef.current = onLoad;
    });
    (0, $8v0nu.useEffect)(()=>{
        if (element.current) {
            const editor = new (0, (/*@__PURE__*/$parcel$interopDefault($e0f5559cedeb4c29$exports)))(element.current, {
                mode: 'code',
                mainMenuBar: false,
                statusBar: false,
                onChange: ()=>{
                    try {
                        onChangeRef.current(editor.get());
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                    } catch (error) {
                    // no-op
                    }
                }
            }, value || '');
            editor.aceEditor.setOptions({
                tooltipFollowsMouse: false
            });
            editorRef.current = editor;
            onLoadRef.current?.();
            return ()=>{
                editor.destroy();
                editorRef.current = null;
            };
        }
    // The initial `value` is captured intentionally for the editor's initial
    // contents; subsequent updates flow through the effect below.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $8v0nu.useEffect)(()=>{
        if (editorRef.current && value) try {
            const currentValue = JSON.stringify(editorRef.current.get());
            const newValue = JSON.stringify(value);
            if (currentValue !== newValue) editorRef.current.set(value);
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error('Invalid incoming JSON value {value, error}', {
                value: value,
                error: error
            });
        }
    }, [
        value,
        editorRef
    ]);
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $1415810625b263eb$export$e71c4d32a2263218), {
        ref: element,
        w: "100%",
        h: "20rem",
        css: {
            '& .jsoneditor': {
                borderColor: 'base.200',
                borderWidth: '2px',
                borderRadius: 'md'
            },
            '& .ace-jsoneditor .ace_tooltip': {
                minHeight: 'auto'
            },
            '& .ace-jsoneditor .ace_marker-layer .ace_active-line': {
                bg: 'primary.100a'
            }
        }
    });
}


function $5d31050dffea9ad7$export$28f0f0b6ca7da3eb(props) {
    const field = props.field;
    const editorRef = (0, $8v0nu.useRef)(null);
    const [isLoaded, setIsLoaded] = (0, $8v0nu.useState)(false);
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $5e0ca4edd90668b0$exports).Root, {
        children: [
            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
                gap: 4,
                children: [
                    field.label && /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $5e0ca4edd90668b0$exports).Label, {
                        children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $8f2967926209c75b$export$1acdcf5a973a8414), {
                            size: "xs",
                            children: field.label
                        })
                    }),
                    isLoaded && /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)($5d31050dffea9ad7$var$ControlBar, {
                        editor: editorRef.current
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $jTKGQ.FastField), {
                name: props.pointer,
                children: ({ field: { value: value }, form: { setFieldValue: setFieldValue } })=>/*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $8431272958d6d256$export$2e2bcd8739ae039), {
                        value: value,
                        onChange: (v)=>setFieldValue(props.pointer, v),
                        editorRef: editorRef,
                        onLoad: ()=>setIsLoaded(true)
                    })
            })
        ]
    });
}
function $5d31050dffea9ad7$var$ControlBar(props) {
    const { editor: editor } = props;
    const undoManager = editor.aceEditor.getSession().getUndoManager();
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
        ml: "auto",
        gap: 2,
        children: [
            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $8f2967926209c75b$export$90c6246c969554fc), {
                "aria-label": "Fix",
                onClick: ()=>{
                    editor.repair?.();
                    editor._onChange?.();
                },
                children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9138db1f951ed55c$export$db99d8e121938012), {
                    boxSize: 3
                })
            }),
            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $8f2967926209c75b$export$90c6246c969554fc), {
                "aria-label": "Compact",
                onClick: ()=>{
                    editor.compact?.();
                },
                children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9138db1f951ed55c$export$3b8ef319a6c5f131), {
                    boxSize: 3
                })
            }),
            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $8f2967926209c75b$export$90c6246c969554fc), {
                "aria-label": "Format",
                onClick: ()=>{
                    editor.format?.();
                },
                children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $7dfa35a587ad2e70$export$302c944b8da23f96), {
                    boxSize: 3
                })
            }),
            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $8f2967926209c75b$export$90c6246c969554fc), {
                "aria-label": "Undo",
                disabled: !undoManager?.canUndo(),
                onClick: ()=>{
                    undoManager?.undo();
                },
                children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9138db1f951ed55c$export$d33a98b6c97f9bcf), {
                    boxSize: 3
                })
            }),
            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $8f2967926209c75b$export$90c6246c969554fc), {
                "aria-label": "Redo",
                disabled: !undoManager?.canRedo(),
                onClick: ()=>{
                    undoManager?.redo();
                },
                children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9138db1f951ed55c$export$65b63483548348e7), {
                    boxSize: 3
                })
            })
        ]
    });
}





parcelRequire("8v0nu");

const $69e88a791767d218$export$cc646d2f0b9a8ed7 = (0, $9138db1f951ed55c$export$7209ba2b0568490)((props)=>/*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $ef524fb144c5d632$exports.Fragment), {
        children: [
            props.title && /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)("title", {
                children: props.title
            }),
            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M2 9V11H14V9H2ZM1 7C0.447715 7 0 7.44772 0 8V12C0 12.5523 0.447715 13 1 13H15C15.5523 13 16 12.5523 16 12V8C16 7.44772 15.5523 7 15 7H1Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M2 2V4H14V2H2ZM1 0C0.447715 0 0 0.447715 0 1V5C0 5.55228 0.447715 6 1 6H15C15.5523 6 16 5.55228 16 5V1C16 0.447715 15.5523 0 15 0H1Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)("rect", {
                y: "14",
                width: "8",
                height: "2",
                fill: "currentColor"
            })
        ]
    }));



// Shared validation for STAC spatial-extent bboxes, used both when creating a
// collection (to block submit) and when viewing one (to warn). A STAC 2D bbox
// is [minLon, minLat, maxLon, maxLat]; the 3D form inserts elevation as
// [minLon, minLat, minElev, maxLon, maxLat, maxElev], so we read the
// horizontal corners out of either shape before checking them.
const $8d719f960351be1e$export$9768604b3d70b668 = 'Must be a valid number';
const $8d719f960351be1e$export$7caf39e0c4c2f19 = 'Longitude must be between -180 and 180';
const $8d719f960351be1e$export$b8a60fbb1ef036e2 = 'Latitude must be between -90 and 90';
const $8d719f960351be1e$export$2d1ea6bc64e8866d = 'Max latitude must be greater than min latitude';
const $8d719f960351be1e$export$bc824a09a5efc969 = "Min and max latitude are equal \u2014 the extent has zero height";
const $8d719f960351be1e$export$fa85fd8189644744 = "Min and max longitude are equal \u2014 the extent has zero width";
const $8d719f960351be1e$export$fb7aabd6ecc7e33f = 0;
const $8d719f960351be1e$export$f1243798854ef6d9 = 1;
const $8d719f960351be1e$export$ae474362eb906601 = 2;
const $8d719f960351be1e$export$9d992249d75860c0 = 3;
const $8d719f960351be1e$var$toNumber = (v)=>{
    if (typeof v === 'number') return v;
    if (typeof v === 'string' && v.trim() !== '') return Number(v);
    return NaN;
};
const $8d719f960351be1e$var$isFiniteNum = (n)=>Number.isFinite(n);
// Pull the four horizontal corners out of a 2D ([4]) or 3D ([6]) bbox. Returns
// null when the array isn't one of those shapes.
function $8d719f960351be1e$var$horizontalCorners(bbox) {
    if (!Array.isArray(bbox)) return null;
    if (bbox.length === 4) return [
        bbox[0],
        bbox[1],
        bbox[2],
        bbox[3]
    ];
    if (bbox.length === 6) return [
        bbox[0],
        bbox[1],
        bbox[3],
        bbox[4]
    ];
    return null;
}
function $8d719f960351be1e$export$b7f30a10cdcde4ab(bbox) {
    const corners = $8d719f960351be1e$var$horizontalCorners(bbox);
    if (!corners) return [];
    const [minLon, minLat, maxLon, maxLat] = corners.map($8d719f960351be1e$var$toNumber);
    const issues = [];
    const checkFinite = (value, index)=>{
        if (!$8d719f960351be1e$var$isFiniteNum(value)) {
            issues.push({
                index: index,
                message: $8d719f960351be1e$export$9768604b3d70b668
            });
            return false;
        }
        return true;
    };
    const minLonOk = checkFinite(minLon, $8d719f960351be1e$export$fb7aabd6ecc7e33f);
    const minLatOk = checkFinite(minLat, $8d719f960351be1e$export$f1243798854ef6d9);
    const maxLonOk = checkFinite(maxLon, $8d719f960351be1e$export$ae474362eb906601);
    const maxLatOk = checkFinite(maxLat, $8d719f960351be1e$export$9d992249d75860c0);
    let lonRangeOk = minLonOk && maxLonOk;
    let latRangeOk = minLatOk && maxLatOk;
    if (minLonOk && (minLon < -180 || minLon > 180)) {
        issues.push({
            index: $8d719f960351be1e$export$fb7aabd6ecc7e33f,
            message: $8d719f960351be1e$export$7caf39e0c4c2f19
        });
        lonRangeOk = false;
    }
    if (maxLonOk && (maxLon < -180 || maxLon > 180)) {
        issues.push({
            index: $8d719f960351be1e$export$ae474362eb906601,
            message: $8d719f960351be1e$export$7caf39e0c4c2f19
        });
        lonRangeOk = false;
    }
    if (minLatOk && (minLat < -90 || minLat > 90)) {
        issues.push({
            index: $8d719f960351be1e$export$f1243798854ef6d9,
            message: $8d719f960351be1e$export$b8a60fbb1ef036e2
        });
        latRangeOk = false;
    }
    if (maxLatOk && (maxLat < -90 || maxLat > 90)) {
        issues.push({
            index: $8d719f960351be1e$export$9d992249d75860c0,
            message: $8d719f960351be1e$export$b8a60fbb1ef036e2
        });
        latRangeOk = false;
    }
    // Ordering / zero-area only make sense once the corners are valid numbers in
    // range; otherwise the range errors above already point at the real problem.
    if (latRangeOk) {
        if (minLat > maxLat) issues.push({
            index: $8d719f960351be1e$export$9d992249d75860c0,
            message: $8d719f960351be1e$export$2d1ea6bc64e8866d
        });
        else if (minLat === maxLat) issues.push({
            index: $8d719f960351be1e$export$9d992249d75860c0,
            message: $8d719f960351be1e$export$bc824a09a5efc969
        });
    }
    if (lonRangeOk && minLon === maxLon) issues.push({
        index: $8d719f960351be1e$export$ae474362eb906601,
        message: $8d719f960351be1e$export$fa85fd8189644744
    });
    return issues;
}
function $8d719f960351be1e$export$5366d0e90f4fb990(bboxes) {
    if (!Array.isArray(bboxes)) return [];
    const messages = new Set();
    bboxes.forEach((bbox)=>$8d719f960351be1e$export$b7f30a10cdcde4ab(bbox).forEach((issue)=>messages.add(issue.message)));
    return Array.from(messages);
}


// The generic schema → Yup validation only knows each bbox corner is a number;
// it can't express the geographic rules (ranges, ordering, zero-area). Build
// Formik errors for `values.spatial` (number[][]) keyed at spatial.<i>.<corner>
// so they render inline on the offending coordinate input.
function $8f2e993a8ece010b$var$buildSpatialErrors(values) {
    const spatial = values?.spatial;
    if (!Array.isArray(spatial)) return undefined;
    const spatialErrors = [];
    let hasError = false;
    spatial.forEach((bbox, i)=>{
        const issues = (0, $8d719f960351be1e$export$b7f30a10cdcde4ab)(bbox);
        if (!issues.length) return;
        const row = [];
        // First issue per corner wins — enough to point the user at the field.
        issues.forEach(({ index: index, message: message })=>{
            if (row[index] === undefined) row[index] = message;
        });
        spatialErrors[i] = row;
        hasError = true;
    });
    return hasError ? {
        spatial: spatialErrors
    } : undefined;
}
// Deep-merge two Formik error trees. `base` (schema errors) wins on a leaf
// conflict so a "must be a number" isn't clobbered by a range message; `extra`
// (bbox errors) fills the gaps. Returns undefined when both are empty.
function $8f2e993a8ece010b$var$mergeErrors(base, extra) {
    if (extra === undefined || extra === null) return base ?? undefined;
    if (base === undefined || base === null) return extra;
    if (typeof base === 'string' || typeof extra === 'string') return base;
    const out = Array.isArray(base) || Array.isArray(extra) ? [] : {};
    const keys = new Set([
        ...Object.keys(base),
        ...Object.keys(extra)
    ]);
    keys.forEach((key)=>{
        out[key] = $8f2e993a8ece010b$var$mergeErrors(base[key], extra[key]);
    });
    return out;
}
function $8f2e993a8ece010b$export$b63a055d7d5b8fe6(props) {
    const { initialData: initialData, onSubmit: onSubmit, notifications: notifications = [] } = props;
    const [stacData, setStacData] = (0, $8v0nu.useState)(initialData || {});
    const { plugins: plugins, formData: formData, toOutData: toOutData, isLoading: isLoading } = (0, $4509732b37c182a7$export$43d14ac0efc7a321)(stacData);
    const [view, setView] = (0, $8v0nu.useState)('fields');
    const editorData = (0, $8v0nu.useMemo)(()=>view === 'json' ? {
            jsonData: stacData
        } : formData, [
        view,
        formData,
        stacData
    ]);
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $1415810625b263eb$export$e71c4d32a2263218), {
        children: isLoading ? /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $1415810625b263eb$export$e71c4d32a2263218), {
            children: "Loading plugins..."
        }) : /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
            direction: "column",
            gap: 4,
            children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $jTKGQ.Formik), {
                validateOnChange: false,
                enableReinitialize: true,
                initialValues: editorData,
                onSubmit: (values, actions)=>{
                    const exitData = view === 'json' ? values.jsonData : toOutData(values);
                    return onSubmit(exitData, actions);
                },
                validate: (values)=>{
                    if (view === 'json') return;
                    const [, schemaError] = (0, $27cb5f515eacb0bf$export$51063abe2742d805)(plugins, values);
                    const merged = $8f2e993a8ece010b$var$mergeErrors(schemaError, $8f2e993a8ece010b$var$buildSpatialErrors(values));
                    if (merged) return merged;
                },
                children: ({ handleSubmit: handleSubmit, values: values, isSubmitting: isSubmitting })=>/*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
                        as: "form",
                        direction: "column",
                        gap: 8,
                        // @ts-expect-error Can't detect the as=form and throws error
                        onSubmit: handleSubmit,
                        children: [
                            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $1f4c49dac40f32d2$export$bbcdeaee0c64136a), {}),
                            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $dfd76aae8c4830bc$export$47c5baa971b64ccb), {
                                overline: initialData ? 'Editing Collection' : 'Creating Collection',
                                title: initialData ? initialData.title || initialData.id : 'New Collection',
                                actions: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
                                    gap: 4,
                                    children: [
                                        /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $99f040781eeb1a87$export$595cbcb116fb5622), {
                                            notifications: notifications
                                        }),
                                        /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $a987639d7be6b91e$export$353f5b6fc5456de1), {
                                            type: "submit",
                                            disabled: isSubmitting,
                                            colorPalette: "primary",
                                            size: "md",
                                            children: [
                                                /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9138db1f951ed55c$export$7679025d661a5f99), {}),
                                                initialData ? 'Save' : 'Create'
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
                                alignItems: "center",
                                justifyContent: "space-between",
                                px: 8,
                                children: [
                                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $5dcf33ee745c0ffc$export$a8a3e93435678ff9), {
                                        size: "md",
                                        as: "h2",
                                        children: initialData ? 'Edit' : 'New'
                                    }),
                                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $6ef2bd114974330d$export$69b1032f2ecdf404), {
                                        attached: true,
                                        variant: "outline",
                                        size: "md",
                                        children: [
                                            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $a987639d7be6b91e$export$353f5b6fc5456de1), {
                                                "aria-label": "Edit Form",
                                                onClick: ()=>{
                                                    if (view === 'fields') return;
                                                    setView('fields');
                                                    setStacData(values.jsonData);
                                                },
                                                "data-active": view === 'fields' ? '' : undefined,
                                                children: [
                                                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $69e88a791767d218$export$cc646d2f0b9a8ed7), {}),
                                                    "Form"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $a987639d7be6b91e$export$353f5b6fc5456de1), {
                                                "aria-label": "Edit JSON",
                                                onClick: ()=>{
                                                    if (view === 'json') return;
                                                    setView('json');
                                                    setStacData(toOutData(values));
                                                },
                                                "data-active": view === 'json' ? '' : undefined,
                                                children: [
                                                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9138db1f951ed55c$export$1610bcb056ae58bb), {}),
                                                    "JSON"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
                                flexFlow: "column",
                                gap: 4,
                                children: view === 'fields' ? plugins.map((pl)=>/*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $4f2b90a8dcc95f5b$export$6a4d9223b7302baa), {
                                        plugin: pl,
                                        children: ({ field: field })=>/*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $1415810625b263eb$export$e71c4d32a2263218), {
                                                p: "8",
                                                borderRadius: "lg",
                                                bg: "base.50a",
                                                display: "flex",
                                                flexDir: "column",
                                                gap: 8,
                                                children: [
                                                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $5dcf33ee745c0ffc$export$a8a3e93435678ff9), {
                                                        size: "sm",
                                                        children: pl.name
                                                    }),
                                                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $a43fa2f2fffac74f$export$bac6ca00840ef02b), {
                                                        pointer: "",
                                                        field: field
                                                    })
                                                ]
                                            })
                                    }, pl.name)) : /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $5d31050dffea9ad7$export$28f0f0b6ca7da3eb), {
                                    field: {
                                        type: 'json',
                                        label: 'Json Document'
                                    },
                                    pointer: "jsonData"
                                })
                            })
                        ]
                    })
            })
        })
    });
}




function $d8d64c35e07ebf83$export$9fbdb99242c1b155() {
    const { collectionId: collectionId } = (0, $aa6b6e9e15323f83$export$99eaa27ddbbb95ef)();
    return collectionId ? /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)($d8d64c35e07ebf83$export$140ee8e6e165c7dc, {
        id: collectionId
    }) : /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)($d8d64c35e07ebf83$export$bdbef02b82d36d61, {});
}
function $d8d64c35e07ebf83$export$bdbef02b82d36d61() {
    (0, $aec39e40387762bd$export$2e2bcd8739ae039)('New collection');
    const navigate = (0, $aa6b6e9e15323f83$export$9770f232ac06a008)();
    const api = (0, $e60c4cd554136647$export$eb2799109db70ffd)();
    const [notifications, setNotifications] = (0, $8v0nu.useState)();
    const onSubmit = async (data, formikHelpers)=>{
        try {
            (0, $8d97b9cd1bee0709$export$a224d1f4f6f98541).dismiss();
            setNotifications(undefined);
            (0, $8d97b9cd1bee0709$export$a224d1f4f6f98541).create({
                id: 'collection-submit',
                title: 'Creating collection...',
                type: 'loading',
                duration: Number.POSITIVE_INFINITY
            });
            await $d8d64c35e07ebf83$var$collectionTransaction(api).create(data);
            (0, $8d97b9cd1bee0709$export$a224d1f4f6f98541).update('collection-submit', {
                title: 'Collection created',
                type: 'success',
                duration: 5000,
                closable: true
            });
            navigate(`/collections/${data.id}`);
        } catch (error) {
            (0, $8d97b9cd1bee0709$export$a224d1f4f6f98541).dismiss('collection-submit');
            const next = (0, $99f040781eeb1a87$export$909e4416e391c200)(error);
            setNotifications(next);
            (0, $99f040781eeb1a87$export$96920386c636a51b)(next);
        }
        formikHelpers.setSubmitting(false);
    };
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $8f2e993a8ece010b$export$b63a055d7d5b8fe6), {
        onSubmit: onSubmit,
        notifications: notifications
    });
}
function $d8d64c35e07ebf83$export$140ee8e6e165c7dc(props) {
    const { id: id } = props;
    const { collection: collection, isLoading: isLoading, error: error } = (0, $65e1a4342c129241$export$6cd28814d92fa9c9)(id);
    const api = (0, $e60c4cd554136647$export$eb2799109db70ffd)();
    const [triedLoading, setTriedLoading] = (0, $8v0nu.useState)(!!collection);
    const [notifications, setNotifications] = (0, $8v0nu.useState)();
    (0, $aec39e40387762bd$export$2e2bcd8739ae039)(collection ? `Edit collection ${id}` : 'Edit collection');
    const navigate = (0, $aa6b6e9e15323f83$export$9770f232ac06a008)();
    (0, $8v0nu.useEffect)(()=>{
        if (isLoading) setTriedLoading(true);
    }, [
        isLoading
    ]);
    if (isLoading || !triedLoading) return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $1415810625b263eb$export$e71c4d32a2263218), {
        children: "Loading collection..."
    });
    if (error) return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $1415810625b263eb$export$e71c4d32a2263218), {
        children: [
            "Error loading collection:",
            ' ',
            typeof error.detail === 'string' ? error.detail : JSON.stringify(error.detail)
        ]
    });
    const onSubmit = async (data, formikHelpers)=>{
        try {
            (0, $8d97b9cd1bee0709$export$a224d1f4f6f98541).dismiss();
            setNotifications(undefined);
            (0, $8d97b9cd1bee0709$export$a224d1f4f6f98541).create({
                id: 'collection-submit',
                title: 'Updating collection...',
                type: 'loading',
                duration: Number.POSITIVE_INFINITY
            });
            await $d8d64c35e07ebf83$var$collectionTransaction(api).update(id, data);
            (0, $8d97b9cd1bee0709$export$a224d1f4f6f98541).update('collection-submit', {
                title: 'Collection updated',
                type: 'success',
                duration: 5000,
                closable: true
            });
            navigate(`/collections/${data.id}`);
        } catch (error) {
            (0, $8d97b9cd1bee0709$export$a224d1f4f6f98541).dismiss('collection-submit');
            const next = (0, $99f040781eeb1a87$export$909e4416e391c200)(error);
            setNotifications(next);
            (0, $99f040781eeb1a87$export$96920386c636a51b)(next);
        }
        formikHelpers.setSubmitting(false);
    };
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $8f2e993a8ece010b$export$b63a055d7d5b8fe6), {
        onSubmit: onSubmit,
        initialData: collection,
        notifications: notifications
    });
}
function $d8d64c35e07ebf83$var$collectionTransaction(api) {
    const createRequest = async (url, method, data)=>{
        return api.fetch(url, {
            method: method,
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
    };
    return {
        update: (id, data)=>createRequest(`${(0, $e60c4cd554136647$export$b919fd560f065399)}/collections/${id}`, 'PUT', data),
        create: (data)=>createRequest(`${(0, $e60c4cd554136647$export$b919fd560f065399)}/collections/`, 'POST', data)
    };
}



parcelRequire("8v0nu");



var $8v0nu = parcelRequire("8v0nu");



"use strict";
"use client";
function $ab9f2dd725a15473$var$spanFn(span) {
    return (0, $73e475e2b22cc1e3$export$d6051a0f7a227332)(span, (value)=>value === "auto" ? "auto" : `span ${value}/span ${value}`);
}
const $ab9f2dd725a15473$export$9eb849b9b922d396 = (0, $8v0nu.forwardRef)(function GridItem2(props, ref) {
    const { area: area, colSpan: colSpan, colStart: colStart, colEnd: colEnd, rowEnd: rowEnd, rowSpan: rowSpan, rowStart: rowStart, css: css, ...rest } = props;
    const styles = (0, $8v0nu.useMemo)(()=>(0, $e1589b4b448a2f71$export$8e16b83750b44988)({
            gridArea: area,
            gridColumn: $ab9f2dd725a15473$var$spanFn(colSpan),
            gridRow: $ab9f2dd725a15473$var$spanFn(rowSpan),
            gridColumnStart: colStart,
            gridColumnEnd: colEnd,
            gridRowStart: rowStart,
            gridRowEnd: rowEnd
        }), [
        area,
        colSpan,
        colStart,
        colEnd,
        rowEnd,
        rowSpan,
        rowStart
    ]);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $4042601bfa1a9d25$export$7cd122d781af9fa4).div, {
        ref: ref,
        css: [
            styles,
            css
        ],
        ...rest
    });
});
$ab9f2dd725a15473$export$9eb849b9b922d396.displayName = "GridItem";


"use strict";
"use client";
const $d1327e49e5a351f3$export$8fecac46448b5689 = {
    border: "0",
    clip: "rect(0, 0, 0, 0)",
    height: "1px",
    width: "1px",
    margin: "-1px",
    padding: "0",
    overflow: "hidden",
    whiteSpace: "nowrap",
    position: "absolute"
};
const $d1327e49e5a351f3$export$439d29a4e110a164 = (0, $4042601bfa1a9d25$export$7cd122d781af9fa4)("span", {
    base: $d1327e49e5a351f3$export$8fecac46448b5689
});
$d1327e49e5a351f3$export$439d29a4e110a164.displayName = "VisuallyHidden";







parcelRequire("8v0nu");

var $b9191d8af0471bbc$exports = {};

var $3Dz4Y = parcelRequire("3Dz4Y");

$3Dz4Y.importFields((parcelRequire("aUdEw")));

$3Dz4Y.addDependency('@musement/iso-duration', (parcelRequire("4mRY8")));

$3Dz4Y.addDependency('content-type', (parcelRequire("fJT3K")));

$3Dz4Y.addDependency('commonmark', (parcelRequire("4TV4A")));

$3Dz4Y.addDependency('multihashes', (parcelRequire("hci3a")));





$b9191d8af0471bbc$exports = {
    ...(parcelRequire("5cAwf")),
    Fields: $3Dz4Y.exportFields(),
    Registry: $3Dz4Y,
    Helper: (parcelRequire("f5gxW")),
    DataTypes: (parcelRequire("cbZCz")),
    Formatters: (parcelRequire("e6fPk")),
    I18N: (parcelRequire("3IH32"))
};






function $12023aea359e11c1$var$Asset({ asset: asset, assetKey: assetKey }) {
    const { title: title, description: description, roles: roles, type: type, href: href, alternate: alternate } = asset;
    const formattedProperties = (0, (/*@__PURE__*/$parcel$interopDefault($b9191d8af0471bbc$exports))).formatAsset({
        type: type
    })[0].properties;
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $3456399f909bb134$export$f55f1d663c7efb35), {
        title: title || assetKey,
        subtitle: formattedProperties.type.formatted,
        description: description,
        tags: roles,
        renderMenu: ()=>{
            return alternate ? /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $32db75c38a72e4b5$exports).Root, {
                positioning: {
                    placement: 'bottom-end'
                },
                children: [
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $32db75c38a72e4b5$exports).Trigger, {
                        asChild: true,
                        children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $756da344c07e2b07$export$c25acd513dcc8062), {
                            "aria-label": "Download options",
                            variant: "outline",
                            size: "sm",
                            children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9138db1f951ed55c$export$b307b75901e71920), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $25e8aada90e0332f$export$602eac185826482c), {
                        children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $32db75c38a72e4b5$exports).Positioner, {
                            children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $32db75c38a72e4b5$exports).Content, {
                                children: Object.entries(alternate).map(([key, val])=>/*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $32db75c38a72e4b5$exports).Item, {
                                        value: key,
                                        asChild: true,
                                        children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $78d29a24c660df8a$export$2e2bcd8739ae039), {
                                            to: val.href,
                                            children: val.title || val.href
                                        })
                                    }, key))
                            })
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $756da344c07e2b07$export$c25acd513dcc8062), {
                as: (0, $78d29a24c660df8a$export$2e2bcd8739ae039),
                // @ts-expect-error: forwarding `to` to SmartLink via `as` polymorphism
                to: href,
                "aria-label": "Download",
                variant: "outline",
                size: "sm",
                children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9138db1f951ed55c$export$c1c6fe15475bbb7e), {})
            });
        }
    });
}
function $12023aea359e11c1$var$AssetList({ assets: assets }) {
    const assetsList = Object.entries(assets);
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
        direction: "column",
        gap: "8",
        as: "section",
        children: [
            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
                direction: "row",
                px: "8",
                gap: "8",
                as: "header",
                children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $1415810625b263eb$export$e71c4d32a2263218), {
                    flexBasis: "100%",
                    children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $5dcf33ee745c0ffc$export$a8a3e93435678ff9), {
                        size: "md",
                        as: "h2",
                        children: [
                            "Assets ",
                            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $486a1f24d187216b$export$37acb3580601e69a), {
                                variant: "solid",
                                children: (0, $f55c5bb8e60e90fc$export$3cdc770bf8b2ed3d)(assetsList.length)
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $64f958309d0faa1a$export$de97fecb6d4b30a5), {
                gap: 8,
                templateColumns: "repeat(auto-fill, minmax(20rem, 1fr))",
                children: assetsList.map(([key, asset])=>/*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)($12023aea359e11c1$var$Asset, {
                        asset: asset,
                        assetKey: key
                    }, key))
            })
        ]
    });
}
var $12023aea359e11c1$export$2e2bcd8739ae039 = $12023aea359e11c1$var$AssetList;




parcelRequire("8v0nu");



const $9fe47dbb44516a54$var$baseStacBrowserUrl = `https://radiantearth.github.io/stac-browser/#/external/${"https://eoapi.develop.eoepca.org/stac/"}`;
function $9fe47dbb44516a54$export$2b6a1f5f68a01133(props) {
    const { resourcePath: resourcePath, value: value, ...rest } = props;
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $32db75c38a72e4b5$exports).Item, {
        value: value ?? 'stac-browser',
        ...rest,
        asChild: true,
        children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $78d29a24c660df8a$export$2e2bcd8739ae039), {
            to: `${$9fe47dbb44516a54$var$baseStacBrowserUrl}${resourcePath}`,
            children: [
                /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9138db1f951ed55c$export$922c85641f9f6751), {}),
                "View in STAC Browser"
            ]
        })
    });
}




var $8v0nu = parcelRequire("8v0nu");

var $8v0nu = parcelRequire("8v0nu");

var $8v0nu = parcelRequire("8v0nu");

var $8v0nu = parcelRequire("8v0nu");

const $5377e9d4a5edec71$export$c6c68f6e4db55944 = $8v0nu.createContext(null);
const $5377e9d4a5edec71$export$507c997ee09bb471 = (props)=>{
    const [maps, setMaps] = (0, $8v0nu.useState)({});
    const onMapMount = (0, $8v0nu.useCallback)((map, id = 'default')=>{
        setMaps((currMaps)=>{
            if (id === 'current') throw new Error("'current' cannot be used as map id");
            if (currMaps[id]) throw new Error(`Multiple maps with the same id: ${id}`);
            return {
                ...currMaps,
                [id]: map
            };
        });
    }, []);
    const onMapUnmount = (0, $8v0nu.useCallback)((id = 'default')=>{
        setMaps((currMaps)=>{
            if (currMaps[id]) {
                const nextMaps = {
                    ...currMaps
                };
                delete nextMaps[id];
                return nextMaps;
            }
            return currMaps;
        });
    }, []);
    return $8v0nu.createElement($5377e9d4a5edec71$export$c6c68f6e4db55944.Provider, {
        value: {
            maps: maps,
            onMapMount: onMapMount,
            onMapUnmount: onMapUnmount
        }
    }, props.children);
};
function $5377e9d4a5edec71$export$86f8f9f08863e403() {
    var _a;
    const maps = (_a = (0, $8v0nu.useContext)($5377e9d4a5edec71$export$c6c68f6e4db55944)) === null || _a === void 0 ? void 0 : _a.maps;
    const currentMap = (0, $8v0nu.useContext)((0, $b2f07233b90f3c17$export$dc7344301ae78f85));
    const mapsWithCurrent = (0, $8v0nu.useMemo)(()=>{
        return {
            ...maps,
            current: currentMap === null || currentMap === void 0 ? void 0 : currentMap.map
        };
    }, [
        maps,
        currentMap
    ]);
    return mapsWithCurrent;
}


/**
 * Compare two points
 * @param a
 * @param b
 * @returns true if the points are equal
 */ function $87aad2a444d91539$export$cb7477365ef68362(a, b) {
    const ax = Array.isArray(a) ? a[0] : a ? a.x : 0;
    const ay = Array.isArray(a) ? a[1] : a ? a.y : 0;
    const bx = Array.isArray(b) ? b[0] : b ? b.x : 0;
    const by = Array.isArray(b) ? b[1] : b ? b.y : 0;
    return ax === bx && ay === by;
}
function $87aad2a444d91539$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    if (!a || !b) return false;
    if (Array.isArray(a)) {
        if (!Array.isArray(b) || a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (!$87aad2a444d91539$export$9cb4719e2e525b7a(a[i], b[i])) return false;
        }
        return true;
    } else if (Array.isArray(b)) return false;
    if (typeof a === 'object' && typeof b === 'object') {
        const aKeys = Object.keys(a);
        const bKeys = Object.keys(b);
        if (aKeys.length !== bKeys.length) return false;
        for (const key of aKeys){
            if (!b.hasOwnProperty(key)) return false;
            if (!$87aad2a444d91539$export$9cb4719e2e525b7a(a[key], b[key])) return false;
        }
        return true;
    }
    return false;
}


function $36e35180a1a0c360$export$dd516654c5f598fb(tr) {
    const newTransform = tr.clone();
    // Work around mapbox bug - this value is not assigned in clone(), only in resize()
    newTransform.pixelsToGLUnits = tr.pixelsToGLUnits;
    return newTransform;
}
function $36e35180a1a0c360$export$7bd220dfde473c56(src, dest) {
    if (!src.getProjection) return;
    const srcProjection = src.getProjection();
    const destProjection = dest.getProjection();
    if (!(0, $87aad2a444d91539$export$9cb4719e2e525b7a)(srcProjection, destProjection)) dest.setProjection(srcProjection);
}
function $36e35180a1a0c360$export$6a605c5aa5bd97a8(tr) {
    return {
        longitude: tr.center.lng,
        latitude: tr.center.lat,
        zoom: tr.zoom,
        pitch: tr.pitch,
        bearing: tr.bearing,
        padding: tr.padding
    };
}
function $36e35180a1a0c360$export$5cf06eaeb862e3ce(tr, props) {
    const v = props.viewState || props;
    let changed = false;
    if ('zoom' in v) {
        const zoom = tr.zoom;
        tr.zoom = v.zoom;
        changed = changed || zoom !== tr.zoom;
    }
    if ('bearing' in v) {
        const bearing = tr.bearing;
        tr.bearing = v.bearing;
        changed = changed || bearing !== tr.bearing;
    }
    if ('pitch' in v) {
        const pitch = tr.pitch;
        tr.pitch = v.pitch;
        changed = changed || pitch !== tr.pitch;
    }
    if (v.padding && !tr.isPaddingEqual(v.padding)) {
        changed = true;
        tr.padding = v.padding;
    }
    if ('longitude' in v && 'latitude' in v) {
        const center = tr.center;
        // @ts-ignore
        tr.center = new center.constructor(v.longitude, v.latitude);
        changed = changed || center !== tr.center;
    }
    return changed;
}


const $67ed04f5529e50d6$var$refProps = [
    'type',
    'source',
    'source-layer',
    'minzoom',
    'maxzoom',
    'filter',
    'layout'
];
function $67ed04f5529e50d6$export$8756898546458274(style) {
    if (!style) return null;
    if (typeof style === 'string') return style;
    if ('toJS' in style) style = style.toJS();
    if (!style.layers) return style;
    const layerIndex = {};
    for (const layer of style.layers)layerIndex[layer.id] = layer;
    const layers = style.layers.map((layer)=>{
        let normalizedLayer = null;
        if ('interactive' in layer) {
            normalizedLayer = Object.assign({}, layer);
            // Breaks style diffing :(
            // @ts-ignore legacy field not typed
            delete normalizedLayer.interactive;
        }
        // Style diffing doesn't work with refs so expand them out manually before diffing.
        // @ts-ignore legacy field not typed
        const layerRef = layerIndex[layer.ref];
        if (layerRef) {
            normalizedLayer = normalizedLayer || Object.assign({}, layer);
            // @ts-ignore
            delete normalizedLayer.ref;
            // https://github.com/mapbox/mapbox-gl-js/blob/master/src/style-spec/deref.js
            for (const propName of $67ed04f5529e50d6$var$refProps)if (propName in layerRef) normalizedLayer[propName] = layerRef[propName];
        }
        return normalizedLayer || layer;
    });
    // Do not mutate the style object provided by the user
    return {
        ...style,
        layers: layers
    };
}



const $329a4d9bb02600da$var$DEFAULT_STYLE = {
    version: 8,
    sources: {},
    layers: []
};
const $329a4d9bb02600da$var$pointerEvents = {
    mousedown: 'onMouseDown',
    mouseup: 'onMouseUp',
    mouseover: 'onMouseOver',
    mousemove: 'onMouseMove',
    click: 'onClick',
    dblclick: 'onDblClick',
    mouseenter: 'onMouseEnter',
    mouseleave: 'onMouseLeave',
    mouseout: 'onMouseOut',
    contextmenu: 'onContextMenu',
    touchstart: 'onTouchStart',
    touchend: 'onTouchEnd',
    touchmove: 'onTouchMove',
    touchcancel: 'onTouchCancel'
};
const $329a4d9bb02600da$var$cameraEvents = {
    movestart: 'onMoveStart',
    move: 'onMove',
    moveend: 'onMoveEnd',
    dragstart: 'onDragStart',
    drag: 'onDrag',
    dragend: 'onDragEnd',
    zoomstart: 'onZoomStart',
    zoom: 'onZoom',
    zoomend: 'onZoomEnd',
    rotatestart: 'onRotateStart',
    rotate: 'onRotate',
    rotateend: 'onRotateEnd',
    pitchstart: 'onPitchStart',
    pitch: 'onPitch',
    pitchend: 'onPitchEnd'
};
const $329a4d9bb02600da$var$otherEvents = {
    wheel: 'onWheel',
    boxzoomstart: 'onBoxZoomStart',
    boxzoomend: 'onBoxZoomEnd',
    boxzoomcancel: 'onBoxZoomCancel',
    resize: 'onResize',
    load: 'onLoad',
    render: 'onRender',
    idle: 'onIdle',
    remove: 'onRemove',
    data: 'onData',
    styledata: 'onStyleData',
    sourcedata: 'onSourceData',
    error: 'onError'
};
const $329a4d9bb02600da$var$settingNames = [
    'minZoom',
    'maxZoom',
    'minPitch',
    'maxPitch',
    'maxBounds',
    'projection',
    'renderWorldCopies'
];
const $329a4d9bb02600da$var$handlerNames = [
    'scrollZoom',
    'boxZoom',
    'dragRotate',
    'dragPan',
    'keyboard',
    'doubleClickZoom',
    'touchZoomRotate',
    'touchPitch'
];
class $329a4d9bb02600da$export$2e2bcd8739ae039 {
    constructor(MapClass, props, container){
        // mapboxgl.Map instance
        this._map = null;
        // Internal states
        this._internalUpdate = false;
        this._inRender = false;
        this._hoveredFeatures = null;
        this._deferredEvents = {
            move: false,
            zoom: false,
            pitch: false,
            rotate: false
        };
        this._onEvent = (e)=>{
            // @ts-ignore
            const cb = this.props[$329a4d9bb02600da$var$otherEvents[e.type]];
            if (cb) cb(e);
            else if (e.type === 'error') console.error(e.error); // eslint-disable-line
        };
        this._onPointerEvent = (e)=>{
            if (e.type === 'mousemove' || e.type === 'mouseout') this._updateHover(e);
            // @ts-ignore
            const cb = this.props[$329a4d9bb02600da$var$pointerEvents[e.type]];
            if (cb) {
                if (this.props.interactiveLayerIds && e.type !== 'mouseover' && e.type !== 'mouseout') e.features = this._hoveredFeatures || this._queryRenderedFeatures(e.point);
                cb(e);
                delete e.features;
            }
        };
        this._onCameraEvent = (e)=>{
            if (!this._internalUpdate) {
                // @ts-ignore
                const cb = this.props[$329a4d9bb02600da$var$cameraEvents[e.type]];
                if (cb) cb(e);
            }
            if (e.type in this._deferredEvents) this._deferredEvents[e.type] = false;
        };
        this._MapClass = MapClass;
        this.props = props;
        this._initialize(container);
    }
    get map() {
        return this._map;
    }
    get transform() {
        return this._renderTransform;
    }
    setProps(props) {
        const oldProps = this.props;
        this.props = props;
        const settingsChanged = this._updateSettings(props, oldProps);
        if (settingsChanged) this._createShadowTransform(this._map);
        const sizeChanged = this._updateSize(props);
        const viewStateChanged = this._updateViewState(props, true);
        this._updateStyle(props, oldProps);
        this._updateStyleComponents(props, oldProps);
        this._updateHandlers(props, oldProps);
        // If 1) view state has changed to match props and
        //    2) the props change is not triggered by map events,
        // it's driven by an external state change. Redraw immediately
        if (settingsChanged || sizeChanged || viewStateChanged && !this._map.isMoving()) this.redraw();
    }
    static reuse(props, container) {
        const that = $329a4d9bb02600da$export$2e2bcd8739ae039.savedMaps.pop();
        if (!that) return null;
        const map = that.map;
        // When reusing the saved map, we need to reparent the map(canvas) and other child nodes
        // intoto the new container from the props.
        // Step 1: reparenting child nodes from old container to new container
        const oldContainer = map.getContainer();
        container.className = oldContainer.className;
        while(oldContainer.childNodes.length > 0)container.appendChild(oldContainer.childNodes[0]);
        // Step 2: replace the internal container with new container from the react component
        // @ts-ignore
        map._container = container;
        // With maplibre-gl as mapLib, map uses ResizeObserver to observe when its container resizes.
        // When reusing the saved map, we need to disconnect the observer and observe the new container.
        // Step 3: telling the ResizeObserver to disconnect and observe the new container
        // @ts-ignore
        const resizeObserver = map._resizeObserver;
        if (resizeObserver) {
            resizeObserver.disconnect();
            resizeObserver.observe(container);
        }
        // Step 4: apply new props
        that.setProps({
            ...props,
            styleDiffing: false
        });
        map.resize();
        const { initialViewState: initialViewState } = props;
        if (initialViewState) {
            if (initialViewState.bounds) map.fitBounds(initialViewState.bounds, {
                ...initialViewState.fitBoundsOptions,
                duration: 0
            });
            else that._updateViewState(initialViewState, false);
        }
        // Simulate load event
        if (map.isStyleLoaded()) map.fire('load');
        else map.once('styledata', ()=>map.fire('load'));
        // Force reload
        // @ts-ignore
        map._update();
        return that;
    }
    /* eslint-disable complexity,max-statements */ _initialize(container) {
        const { props: props } = this;
        const { mapStyle: mapStyle = $329a4d9bb02600da$var$DEFAULT_STYLE } = props;
        const mapOptions = {
            ...props,
            ...props.initialViewState,
            accessToken: props.mapboxAccessToken || $329a4d9bb02600da$var$getAccessTokenFromEnv() || null,
            container: container,
            style: (0, $67ed04f5529e50d6$export$8756898546458274)(mapStyle)
        };
        const viewState = mapOptions.initialViewState || mapOptions.viewState || mapOptions;
        Object.assign(mapOptions, {
            center: [
                viewState.longitude || 0,
                viewState.latitude || 0
            ],
            zoom: viewState.zoom || 0,
            pitch: viewState.pitch || 0,
            bearing: viewState.bearing || 0
        });
        if (props.gl) {
            // eslint-disable-next-line
            const getContext = HTMLCanvasElement.prototype.getContext;
            // Hijack canvas.getContext to return our own WebGLContext
            // This will be called inside the mapboxgl.Map constructor
            // @ts-expect-error
            HTMLCanvasElement.prototype.getContext = ()=>{
                // Unhijack immediately
                HTMLCanvasElement.prototype.getContext = getContext;
                return props.gl;
            };
        }
        const map = new this._MapClass(mapOptions);
        // Props that are not part of constructor options
        if (viewState.padding) map.setPadding(viewState.padding);
        if (props.cursor) map.getCanvas().style.cursor = props.cursor;
        this._createShadowTransform(map);
        // Hack
        // Insert code into map's render cycle
        const renderMap = map._render;
        map._render = (arg)=>{
            this._inRender = true;
            renderMap.call(map, arg);
            this._inRender = false;
        };
        const runRenderTaskQueue = map._renderTaskQueue.run;
        map._renderTaskQueue.run = (arg)=>{
            runRenderTaskQueue.call(map._renderTaskQueue, arg);
            this._onBeforeRepaint();
        };
        map.on('render', ()=>this._onAfterRepaint());
        // Insert code into map's event pipeline
        // eslint-disable-next-line @typescript-eslint/unbound-method
        const fireEvent = map.fire;
        map.fire = this._fireEvent.bind(this, fireEvent);
        // add listeners
        map.on('resize', ()=>{
            this._renderTransform.resize(map.transform.width, map.transform.height);
        });
        map.on('styledata', ()=>{
            this._updateStyleComponents(this.props, {});
            // Projection can be set in stylesheet
            (0, $36e35180a1a0c360$export$7bd220dfde473c56)(map.transform, this._renderTransform);
        });
        map.on('sourcedata', ()=>this._updateStyleComponents(this.props, {}));
        for(const eventName in $329a4d9bb02600da$var$pointerEvents)map.on(eventName, this._onPointerEvent);
        for(const eventName in $329a4d9bb02600da$var$cameraEvents)map.on(eventName, this._onCameraEvent);
        for(const eventName in $329a4d9bb02600da$var$otherEvents)map.on(eventName, this._onEvent);
        this._map = map;
    }
    /* eslint-enable complexity,max-statements */ recycle() {
        // Clean up unnecessary elements before storing for reuse.
        const container = this.map.getContainer();
        const children = container.querySelector('[mapboxgl-children]');
        children === null || children === void 0 || children.remove();
        $329a4d9bb02600da$export$2e2bcd8739ae039.savedMaps.push(this);
    }
    destroy() {
        this._map.remove();
    }
    // Force redraw the map now. Typically resize() and jumpTo() is reflected in the next
    // render cycle, which is managed by Mapbox's animation loop.
    // This removes the synchronization issue caused by requestAnimationFrame.
    redraw() {
        const map = this._map;
        // map._render will throw error if style does not exist
        // https://github.com/mapbox/mapbox-gl-js/blob/fb9fc316da14e99ff4368f3e4faa3888fb43c513
        //   /src/ui/map.js#L1834
        if (!this._inRender && map.style) {
            // cancel the scheduled update
            if (map._frame) {
                map._frame.cancel();
                map._frame = null;
            }
            // the order is important - render() may schedule another update
            map._render();
        }
    }
    _createShadowTransform(map) {
        const renderTransform = (0, $36e35180a1a0c360$export$dd516654c5f598fb)(map.transform);
        map.painter.transform = renderTransform;
        this._renderTransform = renderTransform;
    }
    /* Trigger map resize if size is controlled
       @param {object} nextProps
       @returns {bool} true if size has changed
     */ _updateSize(nextProps) {
        // Check if size is controlled
        const { viewState: viewState } = nextProps;
        if (viewState) {
            const map = this._map;
            if (viewState.width !== map.transform.width || viewState.height !== map.transform.height) {
                map.resize();
                return true;
            }
        }
        return false;
    }
    // Adapted from map.jumpTo
    /* Update camera to match props
       @param {object} nextProps
       @param {bool} triggerEvents - should fire camera events
       @returns {bool} true if anything is changed
     */ _updateViewState(nextProps, triggerEvents) {
        if (this._internalUpdate) return false;
        const map = this._map;
        const tr = this._renderTransform;
        // Take a snapshot of the transform before mutation
        const { zoom: zoom, pitch: pitch, bearing: bearing } = tr;
        const isMoving = map.isMoving();
        if (isMoving) // All movement of the camera is done relative to the sea level
        tr.cameraElevationReference = 'sea';
        const changed = (0, $36e35180a1a0c360$export$5cf06eaeb862e3ce)(tr, {
            ...(0, $36e35180a1a0c360$export$6a605c5aa5bd97a8)(map.transform),
            ...nextProps
        });
        if (isMoving) // Reset camera reference
        tr.cameraElevationReference = 'ground';
        if (changed && triggerEvents) {
            const deferredEvents = this._deferredEvents;
            // Delay DOM control updates to the next render cycle
            deferredEvents.move = true;
            deferredEvents.zoom || (deferredEvents.zoom = zoom !== tr.zoom);
            deferredEvents.rotate || (deferredEvents.rotate = bearing !== tr.bearing);
            deferredEvents.pitch || (deferredEvents.pitch = pitch !== tr.pitch);
        }
        // Avoid manipulating the real transform when interaction/animation is ongoing
        // as it would interfere with Mapbox's handlers
        if (!isMoving) (0, $36e35180a1a0c360$export$5cf06eaeb862e3ce)(map.transform, nextProps);
        return changed;
    }
    /* Update camera constraints and projection settings to match props
       @param {object} nextProps
       @param {object} currProps
       @returns {bool} true if anything is changed
     */ _updateSettings(nextProps, currProps) {
        const map = this._map;
        let changed = false;
        for (const propName of $329a4d9bb02600da$var$settingNames)if (propName in nextProps && !(0, $87aad2a444d91539$export$9cb4719e2e525b7a)(nextProps[propName], currProps[propName])) {
            changed = true;
            const setter = map[`set${propName[0].toUpperCase()}${propName.slice(1)}`];
            setter === null || setter === void 0 || setter.call(map, nextProps[propName]);
        }
        return changed;
    }
    /* Update map style to match props
       @param {object} nextProps
       @param {object} currProps
       @returns {bool} true if style is changed
     */ _updateStyle(nextProps, currProps) {
        if (nextProps.cursor !== currProps.cursor) this._map.getCanvas().style.cursor = nextProps.cursor || '';
        if (nextProps.mapStyle !== currProps.mapStyle) {
            const { mapStyle: mapStyle = $329a4d9bb02600da$var$DEFAULT_STYLE, styleDiffing: styleDiffing = true } = nextProps;
            const options = {
                diff: styleDiffing
            };
            if ('localIdeographFontFamily' in nextProps) // @ts-ignore Mapbox specific prop
            options.localIdeographFontFamily = nextProps.localIdeographFontFamily;
            this._map.setStyle((0, $67ed04f5529e50d6$export$8756898546458274)(mapStyle), options);
            return true;
        }
        return false;
    }
    /* Update fog, light and terrain to match props
       @param {object} nextProps
       @param {object} currProps
       @returns {bool} true if anything is changed
     */ _updateStyleComponents(nextProps, currProps) {
        const map = this._map;
        let changed = false;
        if (map.isStyleLoaded()) {
            if ('light' in nextProps && map.setLight && !(0, $87aad2a444d91539$export$9cb4719e2e525b7a)(nextProps.light, currProps.light)) {
                changed = true;
                map.setLight(nextProps.light);
            }
            if ('fog' in nextProps && map.setFog && !(0, $87aad2a444d91539$export$9cb4719e2e525b7a)(nextProps.fog, currProps.fog)) {
                changed = true;
                map.setFog(nextProps.fog);
            }
            if ('terrain' in nextProps && map.setTerrain && !(0, $87aad2a444d91539$export$9cb4719e2e525b7a)(nextProps.terrain, currProps.terrain)) {
                if (!nextProps.terrain || map.getSource(nextProps.terrain.source)) {
                    changed = true;
                    map.setTerrain(nextProps.terrain);
                }
            }
        }
        return changed;
    }
    /* Update interaction handlers to match props
       @param {object} nextProps
       @param {object} currProps
       @returns {bool} true if anything is changed
     */ _updateHandlers(nextProps, currProps) {
        var _a, _b;
        const map = this._map;
        let changed = false;
        for (const propName of $329a4d9bb02600da$var$handlerNames){
            const newValue = (_a = nextProps[propName]) !== null && _a !== void 0 ? _a : true;
            const oldValue = (_b = currProps[propName]) !== null && _b !== void 0 ? _b : true;
            if (!(0, $87aad2a444d91539$export$9cb4719e2e525b7a)(newValue, oldValue)) {
                changed = true;
                if (newValue) map[propName].enable(newValue);
                else map[propName].disable();
            }
        }
        return changed;
    }
    _queryRenderedFeatures(point) {
        const map = this._map;
        const tr = map.transform;
        const { interactiveLayerIds: interactiveLayerIds = [] } = this.props;
        try {
            map.transform = this._renderTransform;
            return map.queryRenderedFeatures(point, {
                layers: interactiveLayerIds.filter(map.getLayer.bind(map))
            });
        } catch (_a) {
            // May fail if style is not loaded
            return [];
        } finally{
            map.transform = tr;
        }
    }
    _updateHover(e) {
        var _a;
        const { props: props } = this;
        const shouldTrackHoveredFeatures = props.interactiveLayerIds && (props.onMouseMove || props.onMouseEnter || props.onMouseLeave);
        if (shouldTrackHoveredFeatures) {
            const eventType = e.type;
            const wasHovering = ((_a = this._hoveredFeatures) === null || _a === void 0 ? void 0 : _a.length) > 0;
            const features = this._queryRenderedFeatures(e.point);
            const isHovering = features.length > 0;
            if (!isHovering && wasHovering) {
                e.type = 'mouseleave';
                this._onPointerEvent(e);
            }
            this._hoveredFeatures = features;
            if (isHovering && !wasHovering) {
                e.type = 'mouseenter';
                this._onPointerEvent(e);
            }
            e.type = eventType;
        } else this._hoveredFeatures = null;
    }
    _fireEvent(baseFire, event, properties) {
        const map = this._map;
        const tr = map.transform;
        const eventType = typeof event === 'string' ? event : event.type;
        if (eventType === 'move') this._updateViewState(this.props, false);
        if (eventType in $329a4d9bb02600da$var$cameraEvents) {
            if (typeof event === 'object') event.viewState = (0, $36e35180a1a0c360$export$6a605c5aa5bd97a8)(tr);
            if (this._map.isMoving()) {
                // Replace map.transform with ours during the callbacks
                map.transform = this._renderTransform;
                baseFire.call(map, event, properties);
                map.transform = tr;
                return map;
            }
        }
        baseFire.call(map, event, properties);
        return map;
    }
    // All camera manipulations are complete, ready to repaint
    _onBeforeRepaint() {
        const map = this._map;
        // If there are camera changes driven by props, invoke camera events so that DOM controls are synced
        this._internalUpdate = true;
        for(const eventType in this._deferredEvents)if (this._deferredEvents[eventType]) map.fire(eventType);
        this._internalUpdate = false;
        const tr = this._map.transform;
        // Make sure camera matches the current props
        map.transform = this._renderTransform;
        this._onAfterRepaint = ()=>{
            // Mapbox transitions between non-mercator projection and mercator during render time
            // Copy it back to the other
            (0, $36e35180a1a0c360$export$7bd220dfde473c56)(this._renderTransform, tr);
            // Restores camera state before render/load events are fired
            map.transform = tr;
        };
    }
}
$329a4d9bb02600da$export$2e2bcd8739ae039.savedMaps = [];
/**
 * Access token can be provided via one of:
 *   mapboxAccessToken prop
 *   access_token query parameter
 *   MapboxAccessToken environment variable
 *   REACT_APP_MAPBOX_ACCESS_TOKEN environment variable
 * @returns access token
 */ function $329a4d9bb02600da$var$getAccessTokenFromEnv() {
    let accessToken = null;
    /* global location, process */ if (typeof location !== 'undefined') {
        const match = /access_token=([^&\/]*)/.exec(location.search);
        accessToken = match && match[1];
    }
    // Note: This depends on bundler plugins (e.g. webpack) importing environment correctly
    try {
        accessToken = accessToken || undefined;
    } catch (_a) {
    // ignore
    }
    try {
        accessToken = accessToken || undefined;
    } catch (_b) {
    // ignore
    }
    return accessToken;
}


/** These methods may break the react binding if called directly */ const $214202ad690e3e14$var$skipMethods = [
    'setMaxBounds',
    'setMinZoom',
    'setMaxZoom',
    'setMinPitch',
    'setMaxPitch',
    'setRenderWorldCopies',
    'setProjection',
    'setStyle',
    'addSource',
    'removeSource',
    'addLayer',
    'removeLayer',
    'setLayerZoomRange',
    'setFilter',
    'setPaintProperty',
    'setLayoutProperty',
    'setLight',
    'setTerrain',
    'setFog',
    'remove'
];
function $214202ad690e3e14$export$2e2bcd8739ae039(mapInstance) {
    if (!mapInstance) return null;
    const map = mapInstance.map;
    const result = {
        getMap: ()=>map,
        // Overwrite getters to use our shadow transform
        getCenter: ()=>mapInstance.transform.center,
        getZoom: ()=>mapInstance.transform.zoom,
        getBearing: ()=>mapInstance.transform.bearing,
        getPitch: ()=>mapInstance.transform.pitch,
        getPadding: ()=>mapInstance.transform.padding,
        getBounds: ()=>mapInstance.transform.getBounds(),
        project: (lnglat)=>{
            const tr = map.transform;
            map.transform = mapInstance.transform;
            const result = map.project(lnglat);
            map.transform = tr;
            return result;
        },
        unproject: (point)=>{
            const tr = map.transform;
            map.transform = mapInstance.transform;
            const result = map.unproject(point);
            map.transform = tr;
            return result;
        },
        // options diverge between mapbox and maplibre
        queryTerrainElevation: (lnglat, options)=>{
            const tr = map.transform;
            map.transform = mapInstance.transform;
            const result = map.queryTerrainElevation(lnglat, options);
            map.transform = tr;
            return result;
        },
        queryRenderedFeatures: (geometry, options)=>{
            const tr = map.transform;
            map.transform = mapInstance.transform;
            const result = map.queryRenderedFeatures(geometry, options);
            map.transform = tr;
            return result;
        }
    };
    for (const key of $214202ad690e3e14$var$getMethodNames(map))// @ts-expect-error
    if (!(key in result) && !$214202ad690e3e14$var$skipMethods.includes(key)) result[key] = map[key].bind(map);
    return result;
}
function $214202ad690e3e14$var$getMethodNames(obj) {
    const result = new Set();
    let proto = obj;
    while(proto){
        for (const key of Object.getOwnPropertyNames(proto))if (key[0] !== '_' && typeof obj[key] === 'function' && key !== 'fire' && key !== 'setEventedParent') result.add(key);
        proto = Object.getPrototypeOf(proto);
    }
    return Array.from(result);
}


// From https://github.com/streamich/react-use/blob/master/src/useIsomorphicLayoutEffect.ts
// useLayoutEffect but does not trigger warning in server-side rendering

var $8v0nu = parcelRequire("8v0nu");
const $712c19a90c423e23$var$useIsomorphicLayoutEffect = typeof document !== 'undefined' ? (0, $8v0nu.useLayoutEffect) : (0, $8v0nu.useEffect);
var $712c19a90c423e23$export$2e2bcd8739ae039 = $712c19a90c423e23$var$useIsomorphicLayoutEffect;


const $c7ac951aa5402f6e$var$globalSettings = [
    'baseApiUrl',
    'maxParallelImageRequests',
    'workerClass',
    'workerCount',
    'workerUrl'
];
function $c7ac951aa5402f6e$export$2e2bcd8739ae039(mapLib, props) {
    for (const key of $c7ac951aa5402f6e$var$globalSettings)if (key in props) mapLib[key] = props[key];
    const { RTLTextPlugin: RTLTextPlugin = 'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js' } = props;
    if (RTLTextPlugin && mapLib.getRTLTextPluginStatus && mapLib.getRTLTextPluginStatus() === 'unavailable') mapLib.setRTLTextPlugin(RTLTextPlugin, (error)=>{
        if (error) // eslint-disable-next-line
        console.error(error);
    }, true);
}


const $b2f07233b90f3c17$export$dc7344301ae78f85 = $8v0nu.createContext(null);
function $b2f07233b90f3c17$export$2e2bcd8739ae039(props, ref, defaultLib) {
    const mountedMapsContext = (0, $8v0nu.useContext)((0, $5377e9d4a5edec71$export$c6c68f6e4db55944));
    const [mapInstance, setMapInstance] = (0, $8v0nu.useState)(null);
    const containerRef = (0, $8v0nu.useRef)();
    const { current: contextValue } = (0, $8v0nu.useRef)({
        mapLib: null,
        map: null
    });
    (0, $8v0nu.useEffect)(()=>{
        const mapLib = props.mapLib;
        let isMounted = true;
        let mapbox;
        Promise.resolve(mapLib || defaultLib).then((module)=>{
            if (!isMounted) return;
            if (!module) throw new Error('Invalid mapLib');
            const mapboxgl = 'Map' in module ? module : module.default;
            if (!mapboxgl.Map) throw new Error('Invalid mapLib');
            // workerUrl & workerClass may change the result of supported()
            // https://github.com/visgl/react-map-gl/discussions/2027
            (0, $c7ac951aa5402f6e$export$2e2bcd8739ae039)(mapboxgl, props);
            if (!mapboxgl.supported || mapboxgl.supported(props)) {
                if (props.reuseMaps) mapbox = (0, $329a4d9bb02600da$export$2e2bcd8739ae039).reuse(props, containerRef.current);
                if (!mapbox) mapbox = new (0, $329a4d9bb02600da$export$2e2bcd8739ae039)(mapboxgl.Map, props, containerRef.current);
                contextValue.map = (0, $214202ad690e3e14$export$2e2bcd8739ae039)(mapbox);
                contextValue.mapLib = mapboxgl;
                setMapInstance(mapbox);
                mountedMapsContext === null || mountedMapsContext === void 0 || mountedMapsContext.onMapMount(contextValue.map, props.id);
            } else throw new Error('Map is not supported by this browser');
        }).catch((error)=>{
            const { onError: onError } = props;
            if (onError) onError({
                type: 'error',
                target: null,
                originalEvent: null,
                error: error
            });
            else console.error(error); // eslint-disable-line
        });
        return ()=>{
            isMounted = false;
            if (mapbox) {
                mountedMapsContext === null || mountedMapsContext === void 0 || mountedMapsContext.onMapUnmount(props.id);
                if (props.reuseMaps) mapbox.recycle();
                else mapbox.destroy();
            }
        };
    }, []);
    (0, $712c19a90c423e23$export$2e2bcd8739ae039)(()=>{
        if (mapInstance) mapInstance.setProps(props);
    });
    (0, $8v0nu.useImperativeHandle)(ref, ()=>contextValue.map, [
        mapInstance
    ]);
    const style = (0, $8v0nu.useMemo)(()=>({
            position: 'relative',
            width: '100%',
            height: '100%',
            ...props.style
        }), [
        props.style
    ]);
    const CHILD_CONTAINER_STYLE = {
        height: '100%'
    };
    return $8v0nu.createElement("div", {
        id: props.id,
        ref: containerRef,
        style: style
    }, mapInstance && $8v0nu.createElement($b2f07233b90f3c17$export$dc7344301ae78f85.Provider, {
        value: contextValue
    }, $8v0nu.createElement("div", {
        "mapboxgl-children": "",
        style: CHILD_CONTAINER_STYLE
    }, props.children)));
}


/* global document */ 
var $8v0nu = parcelRequire("8v0nu");

var $k2dbP = parcelRequire("k2dbP");
// This is a simplified version of
// https://github.com/facebook/react/blob/4131af3e4bf52f3a003537ec95a1655147c81270/src/renderers/dom/shared/CSSPropertyOperations.js#L62
const $f8cebf08ed85b99f$var$unitlessNumber = /box|flex|grid|column|lineHeight|fontWeight|opacity|order|tabSize|zIndex/;
function $f8cebf08ed85b99f$export$cd93e47e6d398387(element, styles) {
    if (!element || !styles) return;
    const style = element.style;
    for(const key in styles){
        const value = styles[key];
        if (Number.isFinite(value) && !$f8cebf08ed85b99f$var$unitlessNumber.test(key)) style[key] = `${value}px`;
        else style[key] = value;
    }
}




/* eslint-disable complexity,max-statements */ function $6a50da6bce3f3c4f$var$Marker(props, ref) {
    const { map: map, mapLib: mapLib } = (0, $8v0nu.useContext)((0, $b2f07233b90f3c17$export$dc7344301ae78f85));
    const thisRef = (0, $8v0nu.useRef)({
        props: props
    });
    thisRef.current.props = props;
    const marker = (0, $8v0nu.useMemo)(()=>{
        let hasChildren = false;
        $8v0nu.Children.forEach(props.children, (el)=>{
            if (el) hasChildren = true;
        });
        const options = {
            ...props,
            element: hasChildren ? document.createElement('div') : null
        };
        const mk = new mapLib.Marker(options);
        mk.setLngLat([
            props.longitude,
            props.latitude
        ]);
        mk.getElement().addEventListener('click', (e)=>{
            var _a, _b;
            (_b = (_a = thisRef.current.props).onClick) === null || _b === void 0 || _b.call(_a, {
                type: 'click',
                target: mk,
                originalEvent: e
            });
        });
        mk.on('dragstart', (e)=>{
            var _a, _b;
            const evt = e;
            evt.lngLat = marker.getLngLat();
            (_b = (_a = thisRef.current.props).onDragStart) === null || _b === void 0 || _b.call(_a, evt);
        });
        mk.on('drag', (e)=>{
            var _a, _b;
            const evt = e;
            evt.lngLat = marker.getLngLat();
            (_b = (_a = thisRef.current.props).onDrag) === null || _b === void 0 || _b.call(_a, evt);
        });
        mk.on('dragend', (e)=>{
            var _a, _b;
            const evt = e;
            evt.lngLat = marker.getLngLat();
            (_b = (_a = thisRef.current.props).onDragEnd) === null || _b === void 0 || _b.call(_a, evt);
        });
        return mk;
    }, []);
    (0, $8v0nu.useEffect)(()=>{
        marker.addTo(map.getMap());
        return ()=>{
            marker.remove();
        };
    }, []);
    const { longitude: longitude, latitude: latitude, offset: offset, style: style, draggable: draggable = false, popup: popup = null, rotation: rotation = 0, rotationAlignment: rotationAlignment = 'auto', pitchAlignment: pitchAlignment = 'auto' } = props;
    (0, $8v0nu.useEffect)(()=>{
        (0, $f8cebf08ed85b99f$export$cd93e47e6d398387)(marker.getElement(), style);
    }, [
        style
    ]);
    (0, $8v0nu.useImperativeHandle)(ref, ()=>marker, []);
    if (marker.getLngLat().lng !== longitude || marker.getLngLat().lat !== latitude) marker.setLngLat([
        longitude,
        latitude
    ]);
    if (offset && !(0, $87aad2a444d91539$export$cb7477365ef68362)(marker.getOffset(), offset)) marker.setOffset(offset);
    if (marker.isDraggable() !== draggable) marker.setDraggable(draggable);
    if (marker.getRotation() !== rotation) marker.setRotation(rotation);
    if (marker.getRotationAlignment() !== rotationAlignment) marker.setRotationAlignment(rotationAlignment);
    if (marker.getPitchAlignment() !== pitchAlignment) marker.setPitchAlignment(pitchAlignment);
    if (marker.getPopup() !== popup) marker.setPopup(popup);
    return (0, $k2dbP.createPortal)(props.children, marker.getElement());
}
var $6a50da6bce3f3c4f$export$2e2bcd8739ae039 = (0, $8v0nu.memo)((0, $8v0nu.forwardRef)($6a50da6bce3f3c4f$var$Marker));



var $k2dbP = parcelRequire("k2dbP");

var $8v0nu = parcelRequire("8v0nu");



// Adapted from https://github.com/mapbox/mapbox-gl-js/blob/v1.13.0/src/ui/popup.js
function $00b6207a2230a531$var$getClassList(className) {
    return new Set(className ? className.trim().split(/\s+/) : []);
}
/* eslint-disable complexity,max-statements */ function $00b6207a2230a531$var$Popup(props, ref) {
    const { map: map, mapLib: mapLib } = (0, $8v0nu.useContext)((0, $b2f07233b90f3c17$export$dc7344301ae78f85));
    const container = (0, $8v0nu.useMemo)(()=>{
        return document.createElement('div');
    }, []);
    const thisRef = (0, $8v0nu.useRef)({
        props: props
    });
    thisRef.current.props = props;
    const popup = (0, $8v0nu.useMemo)(()=>{
        const options = {
            ...props
        };
        const pp = new mapLib.Popup(options);
        pp.setLngLat([
            props.longitude,
            props.latitude
        ]);
        pp.once('open', (e)=>{
            var _a, _b;
            (_b = (_a = thisRef.current.props).onOpen) === null || _b === void 0 || _b.call(_a, e);
        });
        return pp;
    }, []);
    (0, $8v0nu.useEffect)(()=>{
        const onClose = (e)=>{
            var _a, _b;
            (_b = (_a = thisRef.current.props).onClose) === null || _b === void 0 || _b.call(_a, e);
        };
        popup.on('close', onClose);
        popup.setDOMContent(container).addTo(map.getMap());
        return ()=>{
            // https://github.com/visgl/react-map-gl/issues/1825
            // onClose should not be fired if the popup is removed by unmounting
            // When using React strict mode, the component is mounted twice.
            // Firing the onClose callback here would be a false signal to remove the component.
            popup.off('close', onClose);
            if (popup.isOpen()) popup.remove();
        };
    }, []);
    (0, $8v0nu.useEffect)(()=>{
        (0, $f8cebf08ed85b99f$export$cd93e47e6d398387)(popup.getElement(), props.style);
    }, [
        props.style
    ]);
    (0, $8v0nu.useImperativeHandle)(ref, ()=>popup, []);
    if (popup.isOpen()) {
        if (popup.getLngLat().lng !== props.longitude || popup.getLngLat().lat !== props.latitude) popup.setLngLat([
            props.longitude,
            props.latitude
        ]);
        if (props.offset && !(0, $87aad2a444d91539$export$9cb4719e2e525b7a)(popup.options.offset, props.offset)) popup.setOffset(props.offset);
        if (popup.options.anchor !== props.anchor || popup.options.maxWidth !== props.maxWidth) {
            popup.options.anchor = props.anchor;
            popup.setMaxWidth(props.maxWidth);
        }
        if (popup.options.className !== props.className) {
            const prevClassList = $00b6207a2230a531$var$getClassList(popup.options.className);
            const nextClassList = $00b6207a2230a531$var$getClassList(props.className);
            for (const c of prevClassList)if (!nextClassList.has(c)) popup.removeClassName(c);
            for (const c of nextClassList)if (!prevClassList.has(c)) popup.addClassName(c);
            popup.options.className = props.className;
        }
    }
    return (0, $k2dbP.createPortal)(props.children, container);
}
var $00b6207a2230a531$export$2e2bcd8739ae039 = (0, $8v0nu.memo)((0, $8v0nu.forwardRef)($00b6207a2230a531$var$Popup));



var $8v0nu = parcelRequire("8v0nu");


var $8v0nu = parcelRequire("8v0nu");

function $292435df3b1ad9f2$var$useControl(onCreate, arg1, arg2, arg3) {
    const context = (0, $8v0nu.useContext)((0, $b2f07233b90f3c17$export$dc7344301ae78f85));
    const ctrl = (0, $8v0nu.useMemo)(()=>onCreate(context), []);
    (0, $8v0nu.useEffect)(()=>{
        const opts = arg3 || arg2 || arg1;
        const onAdd = typeof arg1 === 'function' && typeof arg2 === 'function' ? arg1 : null;
        const onRemove = typeof arg2 === 'function' ? arg2 : typeof arg1 === 'function' ? arg1 : null;
        const { map: map } = context;
        if (!map.hasControl(ctrl)) {
            map.addControl(ctrl, opts === null || opts === void 0 ? void 0 : opts.position);
            if (onAdd) onAdd(context);
        }
        return ()=>{
            if (onRemove) onRemove(context);
            // Map might have been removed (parent effects are destroyed before child ones)
            if (map.hasControl(ctrl)) map.removeControl(ctrl);
        };
    }, []);
    return ctrl;
}
var $292435df3b1ad9f2$export$2e2bcd8739ae039 = $292435df3b1ad9f2$var$useControl;


function $8069b126d2ec059e$var$AttributionControl(props) {
    const ctrl = (0, $292435df3b1ad9f2$export$2e2bcd8739ae039)(({ mapLib: mapLib })=>new mapLib.AttributionControl(props), {
        position: props.position
    });
    (0, $8v0nu.useEffect)(()=>{
        (0, $f8cebf08ed85b99f$export$cd93e47e6d398387)(ctrl._container, props.style);
    }, [
        props.style
    ]);
    return null;
}
var $8069b126d2ec059e$export$2e2bcd8739ae039 = (0, $8v0nu.memo)($8069b126d2ec059e$var$AttributionControl);



var $8v0nu = parcelRequire("8v0nu");


function $a7fb663833fbe2de$var$FullscreenControl(props) {
    const ctrl = (0, $292435df3b1ad9f2$export$2e2bcd8739ae039)(({ mapLib: mapLib })=>new mapLib.FullscreenControl({
            container: props.containerId && document.getElementById(props.containerId)
        }), {
        position: props.position
    });
    (0, $8v0nu.useEffect)(()=>{
        (0, $f8cebf08ed85b99f$export$cd93e47e6d398387)(ctrl._controlContainer, props.style);
    }, [
        props.style
    ]);
    return null;
}
var $a7fb663833fbe2de$export$2e2bcd8739ae039 = (0, $8v0nu.memo)($a7fb663833fbe2de$var$FullscreenControl);



var $8v0nu = parcelRequire("8v0nu");


function $51edc6221479b95c$var$GeolocateControl(props, ref) {
    const thisRef = (0, $8v0nu.useRef)({
        props: props
    });
    const ctrl = (0, $292435df3b1ad9f2$export$2e2bcd8739ae039)(({ mapLib: mapLib })=>{
        const gc = new mapLib.GeolocateControl(props);
        // Hack: fix GeolocateControl reuse
        // When using React strict mode, the component is mounted twice.
        // GeolocateControl's UI creation is asynchronous. Removing and adding it back causes the UI to be initialized twice.
        // @ts-expect-error private method
        const setupUI = gc._setupUI;
        // @ts-expect-error private method
        gc._setupUI = (args)=>{
            if (!gc._container.hasChildNodes()) setupUI(args);
        };
        gc.on('geolocate', (e)=>{
            var _a, _b;
            (_b = (_a = thisRef.current.props).onGeolocate) === null || _b === void 0 || _b.call(_a, e);
        });
        gc.on('error', (e)=>{
            var _a, _b;
            (_b = (_a = thisRef.current.props).onError) === null || _b === void 0 || _b.call(_a, e);
        });
        gc.on('outofmaxbounds', (e)=>{
            var _a, _b;
            (_b = (_a = thisRef.current.props).onOutOfMaxBounds) === null || _b === void 0 || _b.call(_a, e);
        });
        gc.on('trackuserlocationstart', (e)=>{
            var _a, _b;
            (_b = (_a = thisRef.current.props).onTrackUserLocationStart) === null || _b === void 0 || _b.call(_a, e);
        });
        gc.on('trackuserlocationend', (e)=>{
            var _a, _b;
            (_b = (_a = thisRef.current.props).onTrackUserLocationEnd) === null || _b === void 0 || _b.call(_a, e);
        });
        return gc;
    }, {
        position: props.position
    });
    thisRef.current.props = props;
    (0, $8v0nu.useImperativeHandle)(ref, ()=>ctrl, []);
    (0, $8v0nu.useEffect)(()=>{
        (0, $f8cebf08ed85b99f$export$cd93e47e6d398387)(ctrl._container, props.style);
    }, [
        props.style
    ]);
    return null;
}
var $51edc6221479b95c$export$2e2bcd8739ae039 = (0, $8v0nu.memo)((0, $8v0nu.forwardRef)($51edc6221479b95c$var$GeolocateControl));



var $8v0nu = parcelRequire("8v0nu");


function $2e5681d2a48fa66a$var$NavigationControl(props) {
    const ctrl = (0, $292435df3b1ad9f2$export$2e2bcd8739ae039)(({ mapLib: mapLib })=>new mapLib.NavigationControl(props), {
        position: props.position
    });
    (0, $8v0nu.useEffect)(()=>{
        (0, $f8cebf08ed85b99f$export$cd93e47e6d398387)(ctrl._container, props.style);
    }, [
        props.style
    ]);
    return null;
}
var $2e5681d2a48fa66a$export$2e2bcd8739ae039 = (0, $8v0nu.memo)($2e5681d2a48fa66a$var$NavigationControl);



var $8v0nu = parcelRequire("8v0nu");


function $0332b4ab49423833$var$ScaleControl(props) {
    const ctrl = (0, $292435df3b1ad9f2$export$2e2bcd8739ae039)(({ mapLib: mapLib })=>new mapLib.ScaleControl(props), {
        position: props.position
    });
    const propsRef = (0, $8v0nu.useRef)(props);
    const prevProps = propsRef.current;
    propsRef.current = props;
    const { style: style } = props;
    if (props.maxWidth !== undefined && props.maxWidth !== prevProps.maxWidth) ctrl.options.maxWidth = props.maxWidth;
    if (props.unit !== undefined && props.unit !== prevProps.unit) ctrl.setUnit(props.unit);
    (0, $8v0nu.useEffect)(()=>{
        (0, $f8cebf08ed85b99f$export$cd93e47e6d398387)(ctrl._container, style);
    }, [
        style
    ]);
    return null;
}
var $0332b4ab49423833$export$2e2bcd8739ae039 = (0, $8v0nu.memo)($0332b4ab49423833$var$ScaleControl);



var $8v0nu = parcelRequire("8v0nu");

function $9b69bdaabd4a0af4$export$2e2bcd8739ae039(condition, message) {
    if (!condition) throw new Error(message);
}



/* eslint-disable complexity, max-statements */ function $f48dc7a238e481e1$var$updateLayer(map, id, props, prevProps) {
    (0, $9b69bdaabd4a0af4$export$2e2bcd8739ae039)(props.id === prevProps.id, 'layer id changed');
    (0, $9b69bdaabd4a0af4$export$2e2bcd8739ae039)(props.type === prevProps.type, 'layer type changed');
    if (props.type === 'custom' || prevProps.type === 'custom') return;
    const { layout: layout = {}, paint: paint = {}, filter: filter, minzoom: minzoom, maxzoom: maxzoom, beforeId: beforeId } = props;
    if (beforeId !== prevProps.beforeId) map.moveLayer(id, beforeId);
    if (layout !== prevProps.layout) {
        const prevLayout = prevProps.layout || {};
        for(const key in layout)if (!(0, $87aad2a444d91539$export$9cb4719e2e525b7a)(layout[key], prevLayout[key])) map.setLayoutProperty(id, key, layout[key]);
        for(const key in prevLayout)if (!layout.hasOwnProperty(key)) map.setLayoutProperty(id, key, undefined);
    }
    if (paint !== prevProps.paint) {
        const prevPaint = prevProps.paint || {};
        for(const key in paint)if (!(0, $87aad2a444d91539$export$9cb4719e2e525b7a)(paint[key], prevPaint[key])) map.setPaintProperty(id, key, paint[key]);
        for(const key in prevPaint)if (!paint.hasOwnProperty(key)) map.setPaintProperty(id, key, undefined);
    }
    if (!(0, $87aad2a444d91539$export$9cb4719e2e525b7a)(filter, prevProps.filter)) map.setFilter(id, filter);
    if (minzoom !== prevProps.minzoom || maxzoom !== prevProps.maxzoom) map.setLayerZoomRange(id, minzoom, maxzoom);
}
function $f48dc7a238e481e1$var$createLayer(map, id, props) {
    // @ts-ignore
    if (map.style && map.style._loaded && (!('source' in props) || map.getSource(props.source))) {
        const options = {
            ...props,
            id: id
        };
        delete options.beforeId;
        // @ts-ignore
        map.addLayer(options, props.beforeId);
    }
}
/* eslint-enable complexity, max-statements */ let $f48dc7a238e481e1$var$layerCounter = 0;
function $f48dc7a238e481e1$var$Layer(props) {
    const map = (0, $8v0nu.useContext)((0, $b2f07233b90f3c17$export$dc7344301ae78f85)).map.getMap();
    const propsRef = (0, $8v0nu.useRef)(props);
    const [, setStyleLoaded] = (0, $8v0nu.useState)(0);
    const id = (0, $8v0nu.useMemo)(()=>props.id || `jsx-layer-${$f48dc7a238e481e1$var$layerCounter++}`, []);
    (0, $8v0nu.useEffect)(()=>{
        if (map) {
            const forceUpdate = ()=>setStyleLoaded((version)=>version + 1);
            map.on('styledata', forceUpdate);
            forceUpdate();
            return ()=>{
                map.off('styledata', forceUpdate);
                // @ts-ignore
                if (map.style && map.style._loaded && map.getLayer(id)) map.removeLayer(id);
            };
        }
        return undefined;
    }, [
        map
    ]);
    // @ts-ignore
    const layer = map && map.style && map.getLayer(id);
    if (layer) try {
        $f48dc7a238e481e1$var$updateLayer(map, id, props, propsRef.current);
    } catch (error) {
        console.warn(error); // eslint-disable-line
    }
    else $f48dc7a238e481e1$var$createLayer(map, id, props);
    // Store last rendered props
    propsRef.current = props;
    return null;
}
var $f48dc7a238e481e1$export$2e2bcd8739ae039 = $f48dc7a238e481e1$var$Layer;



var $8v0nu = parcelRequire("8v0nu");



let $3421ea1e93ab58a1$var$sourceCounter = 0;
function $3421ea1e93ab58a1$var$createSource(map, id, props) {
    // @ts-ignore
    if (map.style && map.style._loaded) {
        const options = {
            ...props
        };
        delete options.id;
        delete options.children;
        // @ts-ignore
        map.addSource(id, options);
        return map.getSource(id);
    }
    return null;
}
/* eslint-disable complexity */ function $3421ea1e93ab58a1$var$updateSource(source, props, prevProps) {
    (0, $9b69bdaabd4a0af4$export$2e2bcd8739ae039)(props.id === prevProps.id, 'source id changed');
    (0, $9b69bdaabd4a0af4$export$2e2bcd8739ae039)(props.type === prevProps.type, 'source type changed');
    let changedKey = '';
    let changedKeyCount = 0;
    for(const key in props)if (key !== 'children' && key !== 'id' && !(0, $87aad2a444d91539$export$9cb4719e2e525b7a)(prevProps[key], props[key])) {
        changedKey = key;
        changedKeyCount++;
    }
    if (!changedKeyCount) return;
    const type = props.type;
    if (type === 'geojson') source.setData(props.data);
    else if (type === 'image') source.updateImage({
        url: props.url,
        coordinates: props.coordinates
    });
    else if ('setCoordinates' in source && changedKeyCount === 1 && changedKey === 'coordinates') source.setCoordinates(props.coordinates);
    else if ('setUrl' in source && changedKey === 'url') source.setUrl(props.url);
    else if ('setTiles' in source && changedKey === 'tiles') source.setTiles(props.tiles);
    else // eslint-disable-next-line
    console.warn(`Unable to update <Source> prop: ${changedKey}`);
}
/* eslint-enable complexity */ function $3421ea1e93ab58a1$var$Source(props) {
    const map = (0, $8v0nu.useContext)((0, $b2f07233b90f3c17$export$dc7344301ae78f85)).map.getMap();
    const propsRef = (0, $8v0nu.useRef)(props);
    const [, setStyleLoaded] = (0, $8v0nu.useState)(0);
    const id = (0, $8v0nu.useMemo)(()=>props.id || `jsx-source-${$3421ea1e93ab58a1$var$sourceCounter++}`, []);
    (0, $8v0nu.useEffect)(()=>{
        if (map) {
            /* global setTimeout */ const forceUpdate = ()=>setTimeout(()=>setStyleLoaded((version)=>version + 1), 0);
            map.on('styledata', forceUpdate);
            forceUpdate();
            return ()=>{
                var _a;
                map.off('styledata', forceUpdate);
                // @ts-ignore
                if (map.style && map.style._loaded && map.getSource(id)) {
                    // Parent effects are destroyed before child ones, see
                    // https://github.com/facebook/react/issues/16728
                    // Source can only be removed after all child layers are removed
                    const allLayers = (_a = map.getStyle()) === null || _a === void 0 ? void 0 : _a.layers;
                    if (allLayers) {
                        for (const layer of allLayers)// @ts-ignore (2339) source does not exist on all layer types
                        if (layer.source === id) map.removeLayer(layer.id);
                    }
                    map.removeSource(id);
                }
            };
        }
        return undefined;
    }, [
        map
    ]);
    // @ts-ignore
    let source = map && map.style && map.getSource(id);
    if (source) $3421ea1e93ab58a1$var$updateSource(source, props, propsRef.current);
    else source = $3421ea1e93ab58a1$var$createSource(map, id, props);
    propsRef.current = props;
    return source && $8v0nu.Children.map(props.children, (child)=>child && (0, $8v0nu.cloneElement)(child, {
            source: id
        })) || null;
}
var $3421ea1e93ab58a1$export$2e2bcd8739ae039 = $3421ea1e93ab58a1$var$Source;








function $5364b873ba521936$export$86f8f9f08863e403() {
    return (0, $5377e9d4a5edec71$export$86f8f9f08863e403)();
}

const $5364b873ba521936$var$mapLib = Promise.resolve((parcelRequire("31zZV")));
const $5364b873ba521936$export$a5c7b93649eaf8f8 = (()=>{
    return $8v0nu.forwardRef(function Map(props, ref) {
        return (0, $b2f07233b90f3c17$export$2e2bcd8739ae039)(props, ref, $5364b873ba521936$var$mapLib);
    });
})();
const $5364b873ba521936$export$e98856a975cab58e = (0, $6a50da6bce3f3c4f$export$2e2bcd8739ae039);
const $5364b873ba521936$export$129a32eedafa97c5 = (0, $00b6207a2230a531$export$2e2bcd8739ae039);
const $5364b873ba521936$export$5af5c3cc9905683 = (0, $8069b126d2ec059e$export$2e2bcd8739ae039);
const $5364b873ba521936$export$91e8ffb52c2b32c5 = (0, $a7fb663833fbe2de$export$2e2bcd8739ae039);
const $5364b873ba521936$export$49a437922edc1bd9 = (0, $2e5681d2a48fa66a$export$2e2bcd8739ae039);
const $5364b873ba521936$export$15e4ff48f7e9d8e0 = (0, $51edc6221479b95c$export$2e2bcd8739ae039);
const $5364b873ba521936$export$1fb16e435eedcce9 = (0, $0332b4ab49423833$export$2e2bcd8739ae039);
const $5364b873ba521936$export$936d0764594b6eb3 = (0, $f48dc7a238e481e1$export$2e2bcd8739ae039);
const $5364b873ba521936$export$1d2df86270c81ecb = (0, $3421ea1e93ab58a1$export$2e2bcd8739ae039);
var $5364b873ba521936$export$2e2bcd8739ae039 = $5364b873ba521936$export$a5c7b93649eaf8f8;


// index.ts
// index.ts
// index.ts
var $32169f69e04c6230$export$e3a1ee0e9945697f = 63710088e-1;
var $32169f69e04c6230$export$f929e47acbed771a = {
    centimeters: $32169f69e04c6230$export$e3a1ee0e9945697f * 100,
    centimetres: $32169f69e04c6230$export$e3a1ee0e9945697f * 100,
    degrees: 360 / (2 * Math.PI),
    feet: $32169f69e04c6230$export$e3a1ee0e9945697f * 3.28084,
    inches: $32169f69e04c6230$export$e3a1ee0e9945697f * 39.37,
    kilometers: $32169f69e04c6230$export$e3a1ee0e9945697f / 1e3,
    kilometres: $32169f69e04c6230$export$e3a1ee0e9945697f / 1e3,
    meters: $32169f69e04c6230$export$e3a1ee0e9945697f,
    metres: $32169f69e04c6230$export$e3a1ee0e9945697f,
    miles: $32169f69e04c6230$export$e3a1ee0e9945697f / 1609.344,
    millimeters: $32169f69e04c6230$export$e3a1ee0e9945697f * 1e3,
    millimetres: $32169f69e04c6230$export$e3a1ee0e9945697f * 1e3,
    nauticalmiles: $32169f69e04c6230$export$e3a1ee0e9945697f / 1852,
    radians: 1,
    yards: $32169f69e04c6230$export$e3a1ee0e9945697f * 1.0936
};
var $32169f69e04c6230$export$44665ce4f7f4c82b = {
    acres: 247105e-9,
    centimeters: 1e4,
    centimetres: 1e4,
    feet: 10.763910417,
    hectares: 1e-4,
    inches: 1550.003100006,
    kilometers: 1e-6,
    kilometres: 1e-6,
    meters: 1,
    metres: 1,
    miles: 386e-9,
    nauticalmiles: 29155334959812285e-23,
    millimeters: 1e6,
    millimetres: 1e6,
    yards: 1.195990046
};
function $32169f69e04c6230$export$ced6ed16dfd6a264(geom, properties, options = {}) {
    const feat = {
        type: "Feature"
    };
    if (options.id === 0 || options.id) feat.id = options.id;
    if (options.bbox) feat.bbox = options.bbox;
    feat.properties = properties || {};
    feat.geometry = geom;
    return feat;
}
function $32169f69e04c6230$export$42a7622cbf932bb(type, coordinates, _options = {}) {
    switch(type){
        case "Point":
            return $32169f69e04c6230$export$105684a3041cb6f3(coordinates).geometry;
        case "LineString":
            return $32169f69e04c6230$export$98ec381bb06902c3(coordinates).geometry;
        case "Polygon":
            return $32169f69e04c6230$export$b7b19aa0ee06c73(coordinates).geometry;
        case "MultiPoint":
            return $32169f69e04c6230$export$335fc20ed6b6dbb6(coordinates).geometry;
        case "MultiLineString":
            return $32169f69e04c6230$export$bd735230309493da(coordinates).geometry;
        case "MultiPolygon":
            return $32169f69e04c6230$export$79bd594da96638d3(coordinates).geometry;
        default:
            throw new Error(type + " is invalid");
    }
}
function $32169f69e04c6230$export$105684a3041cb6f3(coordinates, properties, options = {}) {
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    if (coordinates.length < 2) throw new Error("coordinates must be at least 2 numbers long");
    if (!$32169f69e04c6230$export$7e4aa119212bc614(coordinates[0]) || !$32169f69e04c6230$export$7e4aa119212bc614(coordinates[1])) throw new Error("coordinates must contain numbers");
    const geom = {
        type: "Point",
        coordinates: coordinates
    };
    return $32169f69e04c6230$export$ced6ed16dfd6a264(geom, properties, options);
}
function $32169f69e04c6230$export$9f048bf86ee2e9d2(coordinates, properties, options = {}) {
    return $32169f69e04c6230$export$4717c67ac3e5e04d(coordinates.map((coords)=>{
        return $32169f69e04c6230$export$105684a3041cb6f3(coords, properties);
    }), options);
}
function $32169f69e04c6230$export$b7b19aa0ee06c73(coordinates, properties, options = {}) {
    for (const ring of coordinates){
        if (ring.length < 4) throw new Error("Each LinearRing of a Polygon must have 4 or more Positions.");
        if (ring[ring.length - 1].length !== ring[0].length) throw new Error("First and last Position are not equivalent.");
        for(let j = 0; j < ring[ring.length - 1].length; j++){
            if (ring[ring.length - 1][j] !== ring[0][j]) throw new Error("First and last Position are not equivalent.");
        }
    }
    const geom = {
        type: "Polygon",
        coordinates: coordinates
    };
    return $32169f69e04c6230$export$ced6ed16dfd6a264(geom, properties, options);
}
function $32169f69e04c6230$export$8869eb68a940f9c2(coordinates, properties, options = {}) {
    return $32169f69e04c6230$export$4717c67ac3e5e04d(coordinates.map((coords)=>{
        return $32169f69e04c6230$export$b7b19aa0ee06c73(coords, properties);
    }), options);
}
function $32169f69e04c6230$export$98ec381bb06902c3(coordinates, properties, options = {}) {
    if (coordinates.length < 2) throw new Error("coordinates must be an array of two or more positions");
    const geom = {
        type: "LineString",
        coordinates: coordinates
    };
    return $32169f69e04c6230$export$ced6ed16dfd6a264(geom, properties, options);
}
function $32169f69e04c6230$export$74f7306c35db993f(coordinates, properties, options = {}) {
    return $32169f69e04c6230$export$4717c67ac3e5e04d(coordinates.map((coords)=>{
        return $32169f69e04c6230$export$98ec381bb06902c3(coords, properties);
    }), options);
}
function $32169f69e04c6230$export$4717c67ac3e5e04d(features, options = {}) {
    const fc = {
        type: "FeatureCollection"
    };
    if (options.id) fc.id = options.id;
    if (options.bbox) fc.bbox = options.bbox;
    fc.features = features;
    return fc;
}
function $32169f69e04c6230$export$bd735230309493da(coordinates, properties, options = {}) {
    const geom = {
        type: "MultiLineString",
        coordinates: coordinates
    };
    return $32169f69e04c6230$export$ced6ed16dfd6a264(geom, properties, options);
}
function $32169f69e04c6230$export$335fc20ed6b6dbb6(coordinates, properties, options = {}) {
    const geom = {
        type: "MultiPoint",
        coordinates: coordinates
    };
    return $32169f69e04c6230$export$ced6ed16dfd6a264(geom, properties, options);
}
function $32169f69e04c6230$export$79bd594da96638d3(coordinates, properties, options = {}) {
    const geom = {
        type: "MultiPolygon",
        coordinates: coordinates
    };
    return $32169f69e04c6230$export$ced6ed16dfd6a264(geom, properties, options);
}
function $32169f69e04c6230$export$9242f1e18250422a(geometries, properties, options = {}) {
    const geom = {
        type: "GeometryCollection",
        geometries: geometries
    };
    return $32169f69e04c6230$export$ced6ed16dfd6a264(geom, properties, options);
}
function $32169f69e04c6230$export$2077e0241d6afd3c(num, precision = 0) {
    if (precision && !(precision >= 0)) throw new Error("precision must be a positive number");
    const multiplier = Math.pow(10, precision || 0);
    return Math.round(num * multiplier) / multiplier;
}
function $32169f69e04c6230$export$f234631d6a2eedf8(radians, units = "kilometers") {
    const factor = $32169f69e04c6230$export$f929e47acbed771a[units];
    if (!factor) throw new Error(units + " units is invalid");
    return radians * factor;
}
function $32169f69e04c6230$export$a2280f7debae8f10(distance, units = "kilometers") {
    const factor = $32169f69e04c6230$export$f929e47acbed771a[units];
    if (!factor) throw new Error(units + " units is invalid");
    return distance / factor;
}
function $32169f69e04c6230$export$c7a138e00a89bd01(distance, units) {
    return $32169f69e04c6230$export$c41dd2a8460d3196($32169f69e04c6230$export$a2280f7debae8f10(distance, units));
}
function $32169f69e04c6230$export$f2077d29c73b33ec(bearing) {
    let angle = bearing % 360;
    if (angle < 0) angle += 360;
    return angle;
}
function $32169f69e04c6230$export$b4c4eb04cfe49fab(angle) {
    angle = angle % 360;
    if (angle > 180) return angle - 360;
    else if (angle < -180) return angle + 360;
    return angle;
}
function $32169f69e04c6230$export$c41dd2a8460d3196(radians) {
    const normalisedRadians = radians % (2 * Math.PI);
    return normalisedRadians * 180 / Math.PI;
}
function $32169f69e04c6230$export$c9fcf1a7df975d78(degrees) {
    const normalisedDegrees = degrees % 360;
    return normalisedDegrees * Math.PI / 180;
}
function $32169f69e04c6230$export$ea1536a749e80563(length, originalUnit = "kilometers", finalUnit = "kilometers") {
    if (!(length >= 0)) throw new Error("length must be a positive number");
    return $32169f69e04c6230$export$f234631d6a2eedf8($32169f69e04c6230$export$a2280f7debae8f10(length, originalUnit), finalUnit);
}
function $32169f69e04c6230$export$2e65e2c759f7e341(area, originalUnit = "meters", finalUnit = "kilometers") {
    if (!(area >= 0)) throw new Error("area must be a positive number");
    const startFactor = $32169f69e04c6230$export$44665ce4f7f4c82b[originalUnit];
    if (!startFactor) throw new Error("invalid original units");
    const finalFactor = $32169f69e04c6230$export$44665ce4f7f4c82b[finalUnit];
    if (!finalFactor) throw new Error("invalid final units");
    return area / startFactor * finalFactor;
}
function $32169f69e04c6230$export$7e4aa119212bc614(num) {
    return !isNaN(num) && num !== null && !Array.isArray(num);
}
function $32169f69e04c6230$export$a6cdc56e425d0d0a(input) {
    return input !== null && typeof input === "object" && !Array.isArray(input);
}
function $32169f69e04c6230$export$28ac7bb8f5309bea(bbox) {
    if (!bbox) throw new Error("bbox is required");
    if (!Array.isArray(bbox)) throw new Error("bbox must be an Array");
    if (bbox.length !== 4 && bbox.length !== 6) throw new Error("bbox must be an Array of 4 or 6 numbers");
    bbox.forEach((num)=>{
        if (!$32169f69e04c6230$export$7e4aa119212bc614(num)) throw new Error("bbox must only contain numbers");
    });
}
function $32169f69e04c6230$export$f35f128fd59ea256(id) {
    if (!id) throw new Error("id is required");
    if ([
        "string",
        "number"
    ].indexOf(typeof id) === -1) throw new Error("id must be a number or a string");
}


function $e8099e45e96a17c6$export$6e011439fde007ae(geojson, callback, excludeWrapCoord) {
    if (geojson === null) return;
    var j, k, l, geometry, stopG, coords, geometryMaybeCollection, wrapShrink = 0, coordIndex = 0, isGeometryCollection, type = geojson.type, isFeatureCollection = type === "FeatureCollection", isFeature = type === "Feature", stop = isFeatureCollection ? geojson.features.length : 1;
    for(var featureIndex = 0; featureIndex < stop; featureIndex++){
        geometryMaybeCollection = isFeatureCollection ? // @ts-expect-error: Known type conflict
        geojson.features[featureIndex].geometry : isFeature ? // @ts-expect-error: Known type conflict
        geojson.geometry : geojson;
        isGeometryCollection = geometryMaybeCollection ? geometryMaybeCollection.type === "GeometryCollection" : false;
        stopG = isGeometryCollection ? geometryMaybeCollection.geometries.length : 1;
        for(var geomIndex = 0; geomIndex < stopG; geomIndex++){
            var multiFeatureIndex = 0;
            var geometryIndex = 0;
            geometry = isGeometryCollection ? geometryMaybeCollection.geometries[geomIndex] : geometryMaybeCollection;
            if (geometry === null) continue;
            coords = geometry.coordinates;
            var geomType = geometry.type;
            wrapShrink = excludeWrapCoord && (geomType === "Polygon" || geomType === "MultiPolygon") ? 1 : 0;
            switch(geomType){
                case null:
                    break;
                case "Point":
                    if (// @ts-expect-error: Known type conflict
                    callback(coords, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                    coordIndex++;
                    multiFeatureIndex++;
                    break;
                case "LineString":
                case "MultiPoint":
                    for(j = 0; j < coords.length; j++){
                        if (// @ts-expect-error: Known type conflict
                        callback(coords[j], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                        coordIndex++;
                        if (geomType === "MultiPoint") multiFeatureIndex++;
                    }
                    if (geomType === "LineString") multiFeatureIndex++;
                    break;
                case "Polygon":
                case "MultiLineString":
                    for(j = 0; j < coords.length; j++){
                        for(k = 0; k < coords[j].length - wrapShrink; k++){
                            if (// @ts-expect-error: Known type conflict
                            callback(coords[j][k], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                            coordIndex++;
                        }
                        if (geomType === "MultiLineString") multiFeatureIndex++;
                        if (geomType === "Polygon") geometryIndex++;
                    }
                    if (geomType === "Polygon") multiFeatureIndex++;
                    break;
                case "MultiPolygon":
                    for(j = 0; j < coords.length; j++){
                        geometryIndex = 0;
                        for(k = 0; k < coords[j].length; k++){
                            for(l = 0; l < coords[j][k].length - wrapShrink; l++){
                                if (// @ts-expect-error: Known type conflict
                                callback(coords[j][k][l], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                                coordIndex++;
                            }
                            geometryIndex++;
                        }
                        multiFeatureIndex++;
                    }
                    break;
                case "GeometryCollection":
                    for(j = 0; j < geometry.geometries.length; j++)if (// @ts-expect-error: Known type conflict
                    $e8099e45e96a17c6$export$6e011439fde007ae(geometry.geometries[j], callback, excludeWrapCoord) === false) return false;
                    break;
                default:
                    throw new Error("Unknown Geometry Type");
            }
        }
    }
}
function $e8099e45e96a17c6$export$6f96eac39184ffe9(geojson, callback, initialValue, excludeWrapCoord) {
    var previousValue = initialValue;
    $e8099e45e96a17c6$export$6e011439fde007ae(geojson, function(currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
        if (coordIndex === 0 && initialValue === void 0) previousValue = currentCoord;
        else previousValue = callback(// @ts-expect-error: Known type conflict
        previousValue, currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex);
    }, excludeWrapCoord);
    return previousValue;
}
function $e8099e45e96a17c6$export$9d63c695566dbaa3(geojson, callback) {
    var i;
    switch(geojson.type){
        case "FeatureCollection":
            for(i = 0; i < geojson.features.length; i++){
                if (callback(geojson.features[i].properties, i) === false) break;
            }
            break;
        case "Feature":
            callback(geojson.properties, 0);
            break;
    }
}
function $e8099e45e96a17c6$export$7ff6f75e5ef85a65(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $e8099e45e96a17c6$export$9d63c695566dbaa3(geojson, function(currentProperties, featureIndex) {
        if (featureIndex === 0 && initialValue === void 0) previousValue = currentProperties;
        else previousValue = callback(previousValue, currentProperties, featureIndex);
    });
    return previousValue;
}
function $e8099e45e96a17c6$export$45a31c4de8035258(geojson, callback) {
    if (geojson.type === "Feature") callback(geojson, 0);
    else if (geojson.type === "FeatureCollection") for(var i = 0; i < geojson.features.length; i++){
        if (callback(geojson.features[i], i) === false) break;
    }
}
function $e8099e45e96a17c6$export$b18fee751b10b055(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $e8099e45e96a17c6$export$45a31c4de8035258(geojson, function(currentFeature, featureIndex) {
        if (featureIndex === 0 && initialValue === void 0) previousValue = currentFeature;
        else previousValue = callback(previousValue, currentFeature, featureIndex);
    });
    return previousValue;
}
function $e8099e45e96a17c6$export$5485820fc560fe4e(geojson) {
    var coords = [];
    $e8099e45e96a17c6$export$6e011439fde007ae(geojson, function(coord) {
        coords.push(coord);
    });
    return coords;
}
function $e8099e45e96a17c6$export$d2d248a56672ab3d(geojson, callback) {
    var i, j, g, geometry, stopG, geometryMaybeCollection, isGeometryCollection, featureProperties, featureBBox, featureId, featureIndex = 0, isFeatureCollection = geojson.type === "FeatureCollection", isFeature = geojson.type === "Feature", stop = isFeatureCollection ? geojson.features.length : 1;
    for(i = 0; i < stop; i++){
        geometryMaybeCollection = isFeatureCollection ? // @ts-expect-error: Known type conflict
        geojson.features[i].geometry : isFeature ? // @ts-expect-error: Known type conflict
        geojson.geometry : geojson;
        featureProperties = isFeatureCollection ? // @ts-expect-error: Known type conflict
        geojson.features[i].properties : isFeature ? // @ts-expect-error: Known type conflict
        geojson.properties : {};
        featureBBox = isFeatureCollection ? // @ts-expect-error: Known type conflict
        geojson.features[i].bbox : isFeature ? // @ts-expect-error: Known type conflict
        geojson.bbox : void 0;
        featureId = isFeatureCollection ? // @ts-expect-error: Known type conflict
        geojson.features[i].id : isFeature ? // @ts-expect-error: Known type conflict
        geojson.id : void 0;
        isGeometryCollection = geometryMaybeCollection ? geometryMaybeCollection.type === "GeometryCollection" : false;
        stopG = isGeometryCollection ? geometryMaybeCollection.geometries.length : 1;
        for(g = 0; g < stopG; g++){
            geometry = isGeometryCollection ? geometryMaybeCollection.geometries[g] : geometryMaybeCollection;
            if (geometry === null) {
                if (// @ts-expect-error: Known type conflict
                callback(// @ts-expect-error: Known type conflict
                null, featureIndex, featureProperties, featureBBox, featureId) === false) return false;
                continue;
            }
            switch(geometry.type){
                case "Point":
                case "LineString":
                case "MultiPoint":
                case "Polygon":
                case "MultiLineString":
                case "MultiPolygon":
                    if (// @ts-expect-error: Known type conflict
                    callback(geometry, featureIndex, featureProperties, featureBBox, featureId) === false) return false;
                    break;
                case "GeometryCollection":
                    for(j = 0; j < geometry.geometries.length; j++){
                        if (// @ts-expect-error: Known type conflict
                        callback(geometry.geometries[j], featureIndex, featureProperties, featureBBox, featureId) === false) return false;
                    }
                    break;
                default:
                    throw new Error("Unknown Geometry Type");
            }
        }
        featureIndex++;
    }
}
function $e8099e45e96a17c6$export$30055ae7bd157809(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $e8099e45e96a17c6$export$d2d248a56672ab3d(geojson, function(currentGeometry, featureIndex, featureProperties, featureBBox, featureId) {
        if (featureIndex === 0 && initialValue === void 0) previousValue = currentGeometry;
        else previousValue = callback(// @ts-expect-error: Known type conflict
        previousValue, currentGeometry, featureIndex, featureProperties, featureBBox, featureId);
    });
    return previousValue;
}
function $e8099e45e96a17c6$export$12cba8b31beb353b(geojson, callback) {
    $e8099e45e96a17c6$export$d2d248a56672ab3d(geojson, function(geometry, featureIndex, properties, bbox, id) {
        var type = geometry === null ? null : geometry.type;
        switch(type){
            case null:
            case "Point":
            case "LineString":
            case "Polygon":
                if (// @ts-expect-error: Known type conflict
                callback((0, $32169f69e04c6230$export$ced6ed16dfd6a264)(geometry, properties, {
                    bbox: bbox,
                    id: id
                }), featureIndex, 0) === false) return false;
                return;
        }
        var geomType;
        switch(type){
            case "MultiPoint":
                geomType = "Point";
                break;
            case "MultiLineString":
                geomType = "LineString";
                break;
            case "MultiPolygon":
                geomType = "Polygon";
                break;
        }
        for(var multiFeatureIndex = 0; // @ts-expect-error: Known type conflict
        multiFeatureIndex < geometry.coordinates.length; multiFeatureIndex++){
            var coordinate = geometry.coordinates[multiFeatureIndex];
            var geom = {
                type: geomType,
                coordinates: coordinate
            };
            if (// @ts-expect-error: Known type conflict
            callback((0, $32169f69e04c6230$export$ced6ed16dfd6a264)(geom, properties), featureIndex, multiFeatureIndex) === false) return false;
        }
    });
}
function $e8099e45e96a17c6$export$af6f15fec62b5d18(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $e8099e45e96a17c6$export$12cba8b31beb353b(geojson, function(currentFeature, featureIndex, multiFeatureIndex) {
        if (featureIndex === 0 && multiFeatureIndex === 0 && initialValue === void 0) previousValue = currentFeature;
        else previousValue = callback(// @ts-expect-error: Known type conflict
        previousValue, currentFeature, featureIndex, multiFeatureIndex);
    });
    return previousValue;
}
function $e8099e45e96a17c6$export$d3ecc1efb2be121e(geojson, callback) {
    $e8099e45e96a17c6$export$12cba8b31beb353b(geojson, function(feature2, featureIndex, multiFeatureIndex) {
        var segmentIndex = 0;
        if (!feature2.geometry) return;
        var type = feature2.geometry.type;
        if (type === "Point" || type === "MultiPoint") return;
        var previousCoords;
        var previousFeatureIndex = 0;
        var previousMultiIndex = 0;
        var prevGeomIndex = 0;
        if (// @ts-expect-error: Known type conflict
        $e8099e45e96a17c6$export$6e011439fde007ae(feature2, function(currentCoord, coordIndex, featureIndexCoord, multiPartIndexCoord, geometryIndex) {
            if (// @ts-expect-error: Known type conflict
            previousCoords === void 0 || featureIndex > previousFeatureIndex || multiPartIndexCoord > previousMultiIndex || geometryIndex > prevGeomIndex) {
                previousCoords = currentCoord;
                previousFeatureIndex = featureIndex;
                previousMultiIndex = multiPartIndexCoord;
                prevGeomIndex = geometryIndex;
                segmentIndex = 0;
                return;
            }
            var currentSegment = (0, $32169f69e04c6230$export$98ec381bb06902c3)(// @ts-expect-error: Known type conflict
            [
                previousCoords,
                currentCoord
            ], feature2.properties);
            if (// @ts-expect-error: Known type conflict
            callback(// @ts-expect-error: Known type conflict
            currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) === false) return false;
            segmentIndex++;
            previousCoords = currentCoord;
        }) === false) return false;
    });
}
function $e8099e45e96a17c6$export$eec78cdd4d343a79(geojson, callback, initialValue) {
    var previousValue = initialValue;
    var started = false;
    $e8099e45e96a17c6$export$d3ecc1efb2be121e(geojson, function(currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) {
        if (started === false && initialValue === void 0) previousValue = currentSegment;
        else previousValue = callback(previousValue, // @ts-expect-error: Known type conflict
        currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex);
        started = true;
    });
    return previousValue;
}
function $e8099e45e96a17c6$export$985a91771cfc783d(geojson, callback) {
    if (!geojson) throw new Error("geojson is required");
    $e8099e45e96a17c6$export$12cba8b31beb353b(geojson, function(feature2, featureIndex, multiFeatureIndex) {
        if (feature2.geometry === null) return;
        var type = feature2.geometry.type;
        var coords = feature2.geometry.coordinates;
        switch(type){
            case "LineString":
                if (callback(feature2, featureIndex, multiFeatureIndex, 0, 0) === false) return false;
                break;
            case "Polygon":
                for(var geometryIndex = 0; geometryIndex < coords.length; geometryIndex++){
                    if (// @ts-expect-error: Known type conflict
                    callback(// @ts-expect-error: Known type conflict
                    (0, $32169f69e04c6230$export$98ec381bb06902c3)(coords[geometryIndex], feature2.properties), featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                }
                break;
        }
    });
}
function $e8099e45e96a17c6$export$a150e51c8ec9198a(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $e8099e45e96a17c6$export$985a91771cfc783d(geojson, function(currentLine, featureIndex, multiFeatureIndex, geometryIndex) {
        if (featureIndex === 0 && initialValue === void 0) previousValue = currentLine;
        else previousValue = callback(previousValue, currentLine, featureIndex, multiFeatureIndex, geometryIndex);
    });
    return previousValue;
}
function $e8099e45e96a17c6$export$2b6ba91fd8680d67(geojson, options) {
    options = options || {};
    if (!(0, $32169f69e04c6230$export$a6cdc56e425d0d0a)(options)) throw new Error("options is invalid");
    var featureIndex = options.featureIndex || 0;
    var multiFeatureIndex = options.multiFeatureIndex || 0;
    var geometryIndex = options.geometryIndex || 0;
    var segmentIndex = options.segmentIndex || 0;
    var properties = options.properties;
    var geometry;
    switch(geojson.type){
        case "FeatureCollection":
            if (featureIndex < 0) featureIndex = geojson.features.length + featureIndex;
            properties = properties || geojson.features[featureIndex].properties;
            geometry = geojson.features[featureIndex].geometry;
            break;
        case "Feature":
            properties = properties || geojson.properties;
            geometry = geojson.geometry;
            break;
        case "Point":
        case "MultiPoint":
            return null;
        case "LineString":
        case "Polygon":
        case "MultiLineString":
        case "MultiPolygon":
            geometry = geojson;
            break;
        default:
            throw new Error("geojson is invalid");
    }
    if (geometry === null) return null;
    var coords = geometry.coordinates;
    switch(geometry.type){
        case "Point":
        case "MultiPoint":
            return null;
        case "LineString":
            if (segmentIndex < 0) segmentIndex = coords.length + segmentIndex - 1;
            return (0, $32169f69e04c6230$export$98ec381bb06902c3)(// @ts-expect-error: Known type conflict
            [
                coords[segmentIndex],
                coords[segmentIndex + 1]
            ], properties, options);
        case "Polygon":
            if (geometryIndex < 0) geometryIndex = coords.length + geometryIndex;
            if (segmentIndex < 0) segmentIndex = coords[geometryIndex].length + segmentIndex - 1;
            return (0, $32169f69e04c6230$export$98ec381bb06902c3)([
                // @ts-expect-error: Known type conflict
                coords[geometryIndex][segmentIndex],
                // @ts-expect-error: Known type conflict
                coords[geometryIndex][segmentIndex + 1]
            ], properties, options);
        case "MultiLineString":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (segmentIndex < 0) segmentIndex = coords[multiFeatureIndex].length + segmentIndex - 1;
            return (0, $32169f69e04c6230$export$98ec381bb06902c3)([
                // @ts-expect-error: Known type conflict
                coords[multiFeatureIndex][segmentIndex],
                // @ts-expect-error: Known type conflict
                coords[multiFeatureIndex][segmentIndex + 1]
            ], properties, options);
        case "MultiPolygon":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (geometryIndex < 0) geometryIndex = coords[multiFeatureIndex].length + geometryIndex;
            if (segmentIndex < 0) segmentIndex = coords[multiFeatureIndex][geometryIndex].length - segmentIndex - 1;
            return (0, $32169f69e04c6230$export$98ec381bb06902c3)([
                // @ts-expect-error: Known type conflict
                coords[multiFeatureIndex][geometryIndex][segmentIndex],
                // @ts-expect-error: Known type conflict
                coords[multiFeatureIndex][geometryIndex][segmentIndex + 1]
            ], properties, options);
    }
    throw new Error("geojson is invalid");
}
function $e8099e45e96a17c6$export$ed60ae5df1bac687(geojson, options) {
    options = options || {};
    if (!(0, $32169f69e04c6230$export$a6cdc56e425d0d0a)(options)) throw new Error("options is invalid");
    var featureIndex = options.featureIndex || 0;
    var multiFeatureIndex = options.multiFeatureIndex || 0;
    var geometryIndex = options.geometryIndex || 0;
    var coordIndex = options.coordIndex || 0;
    var properties = options.properties;
    var geometry;
    switch(geojson.type){
        case "FeatureCollection":
            if (featureIndex < 0) featureIndex = geojson.features.length + featureIndex;
            properties = properties || geojson.features[featureIndex].properties;
            geometry = geojson.features[featureIndex].geometry;
            break;
        case "Feature":
            properties = properties || geojson.properties;
            geometry = geojson.geometry;
            break;
        case "Point":
        case "MultiPoint":
            return null;
        case "LineString":
        case "Polygon":
        case "MultiLineString":
        case "MultiPolygon":
            geometry = geojson;
            break;
        default:
            throw new Error("geojson is invalid");
    }
    if (geometry === null) return null;
    var coords = geometry.coordinates;
    switch(geometry.type){
        case "Point":
            return (0, $32169f69e04c6230$export$105684a3041cb6f3)(coords, properties, options);
        case "MultiPoint":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            return (0, $32169f69e04c6230$export$105684a3041cb6f3)(coords[multiFeatureIndex], properties, options);
        case "LineString":
            if (coordIndex < 0) coordIndex = coords.length + coordIndex;
            return (0, $32169f69e04c6230$export$105684a3041cb6f3)(coords[coordIndex], properties, options);
        case "Polygon":
            if (geometryIndex < 0) geometryIndex = coords.length + geometryIndex;
            if (coordIndex < 0) coordIndex = coords[geometryIndex].length + coordIndex;
            return (0, $32169f69e04c6230$export$105684a3041cb6f3)(coords[geometryIndex][coordIndex], properties, options);
        case "MultiLineString":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (coordIndex < 0) coordIndex = coords[multiFeatureIndex].length + coordIndex;
            return (0, $32169f69e04c6230$export$105684a3041cb6f3)(coords[multiFeatureIndex][coordIndex], properties, options);
        case "MultiPolygon":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (geometryIndex < 0) geometryIndex = coords[multiFeatureIndex].length + geometryIndex;
            if (coordIndex < 0) coordIndex = coords[multiFeatureIndex][geometryIndex].length - coordIndex;
            return (0, $32169f69e04c6230$export$105684a3041cb6f3)(coords[multiFeatureIndex][geometryIndex][coordIndex], properties, options);
    }
    throw new Error("geojson is invalid");
}


function $a4850b24012d1fae$export$bf67010aacbe66fa(geojson, options = {}) {
    if (geojson.bbox != null && true !== options.recompute) return geojson.bbox;
    const result = [
        Infinity,
        Infinity,
        -Infinity,
        -Infinity
    ];
    (0, $e8099e45e96a17c6$export$6e011439fde007ae)(geojson, (coord)=>{
        if (result[0] > coord[0]) result[0] = coord[0];
        if (result[1] > coord[1]) result[1] = coord[1];
        if (result[2] < coord[0]) result[2] = coord[0];
        if (result[3] < coord[1]) result[3] = coord[1];
    });
    return result;
}
var $a4850b24012d1fae$export$2e2bcd8739ae039 = $a4850b24012d1fae$export$bf67010aacbe66fa;



parcelRequire("8v0nu");

function $3cdef1182cb7804b$var$BackgroundTiles() {
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $5364b873ba521936$export$1d2df86270c81ecb), {
        id: "background",
        type: "raster",
        tiles: [
            'https://tile.openstreetmap.org/{z}/{x}/{y}.png'
        ],
        tileSize: 256,
        attribution: "Background tiles: \xa9 <a href='https://www.openstreetmap.org/copyright'>OpenStreetMap contributors</a>",
        children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $5364b873ba521936$export$936d0764594b6eb3), {
            id: "background-tiles",
            type: "raster"
        })
    });
}
var $3cdef1182cb7804b$export$2e2bcd8739ae039 = $3cdef1182cb7804b$var$BackgroundTiles;


// Web Mercator can't represent the poles — latitude projects to infinity at
// ±90°, which yields NaN map coordinates and out-of-range tile requests (e.g.
// .../22/1048576/0.png) that crash the map. Clamp to the standard Mercator
// limit and keep lon/lat finite and in range before handing corners to maplibre.
const $a9017d83e58866ff$export$a4cfeb564968fa40 = 85.0511287798066;
const $a9017d83e58866ff$var$clamp = (value, min, max)=>Math.min(Math.max(value, min), max);
function $a9017d83e58866ff$export$9f1a7761e34d7c8f(bbox) {
    const [x1, y1, x2, y2] = bbox;
    if (![
        x1,
        y1,
        x2,
        y2
    ].every((n)=>Number.isFinite(n))) return null;
    return [
        $a9017d83e58866ff$var$clamp(x1, -180, 180),
        $a9017d83e58866ff$var$clamp(y1, -$a9017d83e58866ff$export$a4cfeb564968fa40, $a9017d83e58866ff$export$a4cfeb564968fa40),
        $a9017d83e58866ff$var$clamp(x2, -180, 180),
        $a9017d83e58866ff$var$clamp(y2, -$a9017d83e58866ff$export$a4cfeb564968fa40, $a9017d83e58866ff$export$a4cfeb564968fa40)
    ];
}




const $854c342785fecb8e$var$resultsOutline = {
    'line-color': '#C53030',
    'line-width': 2
};
const $854c342785fecb8e$var$resultsFill = {
    'fill-color': '#C53030',
    'fill-opacity': 0.1
};
const $854c342785fecb8e$var$cogMediaTypes = [
    'image/tiff; application=geotiff; profile=cloud-optimized',
    'image/vnd.stac.geotiff'
];
function $854c342785fecb8e$export$a9105c4033140ee1(props) {
    const { item: item, ...rest } = props;
    const [map, setMap] = (0, $8v0nu.useState)();
    const setMapRef = (m)=>setMap(m);
    // Fit the map view around the current results bbox
    (0, $8v0nu.useEffect)(()=>{
        if (!map || !item) return;
        const bounds = (0, $a9017d83e58866ff$export$9f1a7761e34d7c8f)((0, $a4850b24012d1fae$export$2e2bcd8739ae039)(item));
        if (!bounds) return;
        // maxZoom keeps a zero-area geometry (a single point) from fitting to an
        // absurd zoom; the guard stops a still-degenerate extent from crashing.
        try {
            map.fitBounds(bounds, {
                padding: 30,
                duration: 0,
                maxZoom: 12
            });
        } catch (error) {
            // eslint-disable-next-line no-console
            console.warn('Unable to fit map to item extent', error);
        }
    }, [
        item,
        map
    ]);
    const previewAsset = (0, $8v0nu.useMemo)(()=>{
        if (!item) return undefined;
        const cogs = Object.values(item.assets).filter((a)=>$854c342785fecb8e$var$cogMediaTypes.includes(a.type || ''));
        return (cogs.find((a)=>a.roles?.includes('visual')) ?? cogs[0])?.href;
    }, [
        item
    ]);
    // STAC bbox can be 4 (2D) or 6 (3D: minx,miny,minz,maxx,maxy,maxz) values;
    // maplibre's Source.bounds wants the 2D corners only. Constraining tile
    // requests to the item extent stops rdnt.io from being asked for tiles
    // outside the COG, which return 204 and surface as a maplibre decode error.
    const previewBounds = (0, $8v0nu.useMemo)(()=>{
        const bbox = item?.bbox;
        if (!bbox) return undefined;
        if (bbox.length === 4) return [
            bbox[0],
            bbox[1],
            bbox[2],
            bbox[3]
        ];
        if (bbox.length === 6) return [
            bbox[0],
            bbox[1],
            bbox[3],
            bbox[4]
        ];
        return undefined;
    }, [
        item
    ]);
    // rdnt.io returns 204 for COG tiles outside the imagery extent (even within
    // the declared bbox, since COGs can be irregularly shaped). maplibre then
    // logs a generic "could not be decoded" console.error per empty tile, which
    // Parcel's dev overlay surfaces as a runtime error. Swallow those — they're
    // benign for sparse-coverage previews — while letting real map errors
    // through.
    const handleMapError = (0, $8v0nu.useCallback)((e)=>{
        if (e.error?.message?.includes('could not be decoded')) return;
        // eslint-disable-next-line no-console
        console.error(e.error);
    }, []);
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $5364b873ba521936$export$2e2bcd8739ae039), {
        ref: setMapRef,
        ...rest,
        onError: handleMapError,
        children: [
            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $3cdef1182cb7804b$export$2e2bcd8739ae039), {}),
            previewAsset && /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $5364b873ba521936$export$1d2df86270c81ecb), {
                id: "preview",
                type: "raster",
                tiles: [
                    `https://tiles.rdnt.io/tiles/{z}/{x}/{y}@2x?url=${previewAsset}`
                ],
                tileSize: 256,
                bounds: previewBounds,
                attribution: "Background tiles: \xa9 <a href='https://www.openstreetmap.org/copyright'>OpenStreetMap contributors</a>",
                children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $5364b873ba521936$export$936d0764594b6eb3), {
                    id: "preview-tiles",
                    type: "raster"
                })
            }),
            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $5364b873ba521936$export$1d2df86270c81ecb), {
                id: "results",
                type: "geojson",
                data: item,
                children: [
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $5364b873ba521936$export$936d0764594b6eb3), {
                        id: "results-line",
                        type: "line",
                        paint: $854c342785fecb8e$var$resultsOutline
                    }),
                    !previewAsset && /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $5364b873ba521936$export$936d0764594b6eb3), {
                        id: "results-fill",
                        type: "fill",
                        paint: $854c342785fecb8e$var$resultsFill
                    })
                ]
            })
        ]
    });
}


const $943c638232d86618$var$dateFormat = {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
};
function $943c638232d86618$var$ItemDetail() {
    const { collectionId: collectionId, itemId: itemId } = (0, $aa6b6e9e15323f83$export$99eaa27ddbbb95ef)();
    (0, $aec39e40387762bd$export$2e2bcd8739ae039)(`Item ${itemId}`);
    const itemResource = `${(0, $e60c4cd554136647$export$b919fd560f065399)}/collections/${collectionId}/items/${itemId}`;
    const { item: item, isLoading: isLoading } = (0, $65e1a4342c129241$export$9842ce616dcc8723)(itemResource);
    if (!item || isLoading) return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $1415810625b263eb$export$e71c4d32a2263218), {
        p: 8,
        children: [
            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
                direction: "column",
                gap: 4,
                children: [
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $e2f153dab803da15$export$8f31e4c4a37b8e9c), {
                        h: 6,
                        maxW: "25rem"
                    }),
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $e2f153dab803da15$export$8f31e4c4a37b8e9c), {
                        h: 12,
                        maxW: "30rem"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $e2f153dab803da15$export$cb6ddd830302c2a8), {
                mt: 8,
                noOfLines: 4,
                maxW: "50rem"
            })
        ]
    });
    const { title: title, description: description, ...properties } = item.properties;
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
        direction: "column",
        gap: 8,
        children: [
            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $dfd76aae8c4830bc$export$644c29b44a905178), {
                overline: "Viewing Item",
                title: title || item.id,
                actions: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $ef524fb144c5d632$exports.Fragment), {
                    children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $32db75c38a72e4b5$exports).Root, {
                        positioning: {
                            placement: 'bottom-end'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $32db75c38a72e4b5$exports).Trigger, {
                                asChild: true,
                                children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $756da344c07e2b07$export$c25acd513dcc8062), {
                                    "aria-label": "Options",
                                    variant: "outline",
                                    size: "md",
                                    children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9138db1f951ed55c$export$b307b75901e71920), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $25e8aada90e0332f$export$602eac185826482c), {
                                children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $32db75c38a72e4b5$exports).Positioner, {
                                    children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $32db75c38a72e4b5$exports).Content, {
                                        children: [
                                            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9fe47dbb44516a54$export$2b6a1f5f68a01133), {
                                                resourcePath: `/collections/${item.collection}/items/${item.id}`
                                            }),
                                            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $32db75c38a72e4b5$exports).Item, {
                                                value: "delete",
                                                color: "danger.500",
                                                _hover: {
                                                    bg: 'danger.200'
                                                },
                                                _focus: {
                                                    bg: 'danger.200'
                                                },
                                                onClick: ()=>alert('Soon!'),
                                                children: [
                                                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9138db1f951ed55c$export$5918e8962b6636e9), {}),
                                                    "Delete"
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
                direction: "column",
                gap: "8",
                as: "section",
                children: [
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
                        direction: "row",
                        px: "8",
                        gap: "8",
                        as: "header",
                        children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $1415810625b263eb$export$e71c4d32a2263218), {
                            flexBasis: "100%",
                            children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $5dcf33ee745c0ffc$export$a8a3e93435678ff9), {
                                size: "md",
                                as: "h2",
                                children: "Overview"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $b0c5791b137f2783$export$ef2184bd89960b14), {
                        templateColumns: "repeat(12, 1fr)",
                        gap: 8,
                        children: [
                            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $ab9f2dd725a15473$export$9eb849b9b922d396), {
                                colSpan: 8,
                                children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
                                    bg: "base.50",
                                    borderRadius: "md",
                                    p: 8,
                                    direction: "column",
                                    gap: 4,
                                    minH: "100%",
                                    children: [
                                        /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
                                            direction: "column",
                                            gap: "2",
                                            children: [
                                                /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $5dcf33ee745c0ffc$export$a8a3e93435678ff9), {
                                                    size: "sm",
                                                    as: "h3",
                                                    children: "Collection"
                                                }),
                                                /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9318c0c5b8c25a88$export$5f1af8db9871e1d6), {
                                                    children: item.collection
                                                })
                                            ]
                                        }),
                                        description && /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
                                            direction: "column",
                                            gap: "2",
                                            children: [
                                                /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $5dcf33ee745c0ffc$export$a8a3e93435678ff9), {
                                                    size: "sm",
                                                    as: "h3",
                                                    children: "Description"
                                                }),
                                                /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $9318c0c5b8c25a88$export$5f1af8db9871e1d6), {
                                                    children: [
                                                        description,
                                                        " "
                                                    ]
                                                })
                                            ]
                                        }),
                                        properties.datetime && /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
                                            direction: "column",
                                            gap: "2",
                                            children: [
                                                /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $5dcf33ee745c0ffc$export$a8a3e93435678ff9), {
                                                    size: "sm",
                                                    as: "h3",
                                                    children: "Date"
                                                }),
                                                /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9318c0c5b8c25a88$export$5f1af8db9871e1d6), {
                                                    children: new Date(properties.datetime).toLocaleString('en-GB', $943c638232d86618$var$dateFormat)
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $ab9f2dd725a15473$export$9eb849b9b922d396), {
                                colSpan: 4,
                                children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
                                    bg: "base.50",
                                    borderRadius: "md",
                                    p: 8,
                                    direction: "column",
                                    gap: 2,
                                    position: "relative",
                                    overflow: "hidden",
                                    height: "20rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $5dcf33ee745c0ffc$export$a8a3e93435678ff9), {
                                            size: "sm",
                                            as: "h3",
                                            children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $d1327e49e5a351f3$export$439d29a4e110a164), {
                                                children: "Spacial extent"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $1415810625b263eb$export$e71c4d32a2263218), {
                                            position: "absolute",
                                            inset: "0",
                                            children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $854c342785fecb8e$export$a9105c4033140ee1), {
                                                item: item
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $12023aea359e11c1$export$2e2bcd8739ae039), {
                assets: item.assets
            })
        ]
    });
}
var $943c638232d86618$export$2e2bcd8739ae039 = $943c638232d86618$var$ItemDetail;



parcelRequire("8v0nu");




function $8027973e38821351$var$NotFound() {
    (0, $aec39e40387762bd$export$2e2bcd8739ae039)('Not found');
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
        direction: "column",
        gap: 4,
        children: [
            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $dfd76aae8c4830bc$export$644c29b44a905178), {
                title: "Not Found",
                overline: "Error 404"
            }),
            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
                direction: "column",
                gap: 2,
                p: 4,
                children: [
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9318c0c5b8c25a88$export$5f1af8db9871e1d6), {
                        children: "The resource you're looking for could not be found."
                    }),
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $9318c0c5b8c25a88$export$5f1af8db9871e1d6), {
                        children: [
                            "Perhaps in the mean time you can check out the",
                            ' ',
                            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $78d29a24c660df8a$export$2e2bcd8739ae039), {
                                to: "/collections",
                                children: "collections"
                            }),
                            " page."
                        ]
                    })
                ]
            })
        ]
    });
}
var $8027973e38821351$export$2e2bcd8739ae039 = $8027973e38821351$var$NotFound;




var $8v0nu = parcelRequire("8v0nu");

var $5cb430f47138e5f7$exports = {};

$parcel$export($5cb430f47138e5f7$exports, "Anchor", function () { return $dc37cbbff4098605$export$96e5381f42521a79; });
$parcel$export($5cb430f47138e5f7$exports, "Arrow", function () { return $dc37cbbff4098605$export$3152841115e061b2; });
$parcel$export($5cb430f47138e5f7$exports, "ArrowTip", function () { return $dc37cbbff4098605$export$ea3466c65b5f02ba; });
$parcel$export($5cb430f47138e5f7$exports, "Body", function () { return $dc37cbbff4098605$export$472ec417bca1d382; });
$parcel$export($5cb430f47138e5f7$exports, "CloseTrigger", function () { return $dc37cbbff4098605$export$33040f0ac68bdc86; });
$parcel$export($5cb430f47138e5f7$exports, "Content", function () { return $dc37cbbff4098605$export$d7e1f420b25549ff; });
$parcel$export($5cb430f47138e5f7$exports, "Context", function () { return $dc37cbbff4098605$export$9b9a0cd73afb7ca4; });
$parcel$export($5cb430f47138e5f7$exports, "Description", function () { return $dc37cbbff4098605$export$39a373e70f52f23b; });
$parcel$export($5cb430f47138e5f7$exports, "Footer", function () { return $dc37cbbff4098605$export$18083345862c6206; });
$parcel$export($5cb430f47138e5f7$exports, "Header", function () { return $dc37cbbff4098605$export$24cbcada8f546cfe; });
$parcel$export($5cb430f47138e5f7$exports, "Positioner", function () { return $dc37cbbff4098605$export$9867a80d22e08cf4; });
$parcel$export($5cb430f47138e5f7$exports, "PropsProvider", function () { return $dc37cbbff4098605$export$6d083edfcd2ea36d; });
$parcel$export($5cb430f47138e5f7$exports, "Root", function () { return $dc37cbbff4098605$export$bcce13685275fc99; });
$parcel$export($5cb430f47138e5f7$exports, "RootProvider", function () { return $dc37cbbff4098605$export$ee7ce89098ff365a; });
$parcel$export($5cb430f47138e5f7$exports, "Title", function () { return $dc37cbbff4098605$export$67a688130f1df71; });
$parcel$export($5cb430f47138e5f7$exports, "Trigger", function () { return $dc37cbbff4098605$export$7dacb05d26466c3; });
$parcel$export($5cb430f47138e5f7$exports, "usePopoverStyles", function () { return $dc37cbbff4098605$export$bdabad59d033c81a; });




"use client";
//#region src/components/popover/use-popover-context.ts
var [$b01c4b02c8308000$export$bf694c7c431c162a, $b01c4b02c8308000$export$1468d0761b26e6c8] = (0, $51a09ee1e9e91bf5$export$fd42f52fd3ae1109)({
    name: "PopoverContext",
    hookName: "usePopoverContext",
    providerName: "<PopoverProvider />"
});



var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/popover/popover-anchor.tsx
var $e7eedfbf148c152a$export$96e5381f42521a79 = (0, $8v0nu.forwardRef)((props, ref)=>{
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)((0, $b01c4b02c8308000$export$1468d0761b26e6c8)().getAnchorProps(), props);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).div, {
        ...mergedProps,
        ref: ref
    });
});
$e7eedfbf148c152a$export$96e5381f42521a79.displayName = "PopoverAnchor";





var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/popover/popover-arrow.tsx
var $522411838549558c$export$3152841115e061b2 = (0, $8v0nu.forwardRef)((props, ref)=>{
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)((0, $b01c4b02c8308000$export$1468d0761b26e6c8)().getArrowProps(), props);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).div, {
        ...mergedProps,
        ref: ref
    });
});
$522411838549558c$export$3152841115e061b2.displayName = "PopoverArrow";





var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/popover/popover-arrow-tip.tsx
var $b2a97abe295d0b8d$export$ea3466c65b5f02ba = (0, $8v0nu.forwardRef)((props, ref)=>{
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)((0, $b01c4b02c8308000$export$1468d0761b26e6c8)().getArrowTipProps(), props);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).div, {
        ...mergedProps,
        ref: ref
    });
});
$b2a97abe295d0b8d$export$ea3466c65b5f02ba.displayName = "PopoverArrowTip";





var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/popover/popover-close-trigger.tsx
var $6f0ca6951e45e378$export$33040f0ac68bdc86 = (0, $8v0nu.forwardRef)((props, ref)=>{
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)((0, $b01c4b02c8308000$export$1468d0761b26e6c8)().getCloseTriggerProps(), props);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).button, {
        ...mergedProps,
        ref: ref
    });
});
$6f0ca6951e45e378$export$33040f0ac68bdc86.displayName = "PopoverCloseTrigger";







var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/popover/popover-content.tsx
var $012aa710447895e5$export$d7e1f420b25549ff = (0, $8v0nu.forwardRef)((props, ref)=>{
    const popover = (0, $b01c4b02c8308000$export$1468d0761b26e6c8)();
    const presence = (0, $a356685fe9cf7378$export$de7b90475d798ca5)();
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)(popover.getContentProps(), presence.getPresenceProps(), props);
    if (presence.unmounted) return null;
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).div, {
        ...mergedProps,
        ref: (0, $ab7129f9bbf0085f$export$43e446d32b3d21af)(presence.ref, ref)
    });
});
$012aa710447895e5$export$d7e1f420b25549ff.displayName = "PopoverContent";



"use client";
//#region src/components/popover/popover-context.tsx
var $5e2f51e31df521fd$export$9b9a0cd73afb7ca4 = (props)=>props.children((0, $b01c4b02c8308000$export$1468d0761b26e6c8)());





var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/popover/popover-description.tsx
var $ae56256954d68556$export$39a373e70f52f23b = (0, $8v0nu.forwardRef)((props, ref)=>{
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)((0, $b01c4b02c8308000$export$1468d0761b26e6c8)().getDescriptionProps(), props);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).div, {
        ...mergedProps,
        ref: ref
    });
});
$ae56256954d68556$export$39a373e70f52f23b.displayName = "PopoverDescription";





var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/popover/popover-indicator.tsx
var $3e00c163eee30659$export$10a3c7e65c6f2a1f = (0, $8v0nu.forwardRef)((props, ref)=>{
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)((0, $b01c4b02c8308000$export$1468d0761b26e6c8)().getIndicatorProps(), props);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).div, {
        ...mergedProps,
        ref: ref
    });
});
$3e00c163eee30659$export$10a3c7e65c6f2a1f.displayName = "PopoverIndicator";






var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/popover/popover-positioner.tsx
var $0ee7975af1d54464$export$9867a80d22e08cf4 = (0, $8v0nu.forwardRef)((props, ref)=>{
    const popover = (0, $b01c4b02c8308000$export$1468d0761b26e6c8)();
    const presence = (0, $a356685fe9cf7378$export$de7b90475d798ca5)();
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)(popover.getPositionerProps(), props);
    if (presence.unmounted) return null;
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).div, {
        ...mergedProps,
        ref: ref
    });
});
$0ee7975af1d54464$export$9867a80d22e08cf4.displayName = "PopoverPositioner";








// src/popover.connect.ts


// src/popover.anatomy.ts

var $40970757bbe640c2$export$477202748c7242bf = (0, $07b08c6ef332e8db$export$197e6e8d4b33fd6c)("popover").parts("arrow", "arrowTip", "anchor", "trigger", "indicator", "positioner", "content", "title", "description", "closeTrigger");
var $40970757bbe640c2$export$6e2410c1d27f06e7 = $40970757bbe640c2$export$477202748c7242bf.build();


// src/popover.dom.ts


var $5f1aa5f54f81623a$export$a42527045c52cb4d = (scope)=>scope.ids?.anchor ?? `popover:${scope.id}:anchor`;
var $5f1aa5f54f81623a$export$1e04a9a9d2b169fc = (scope, value)=>{
    const customId = scope.ids?.trigger;
    if (customId != null) return (0, $9a966d729185a601$export$f6e2535fb5126e54)(customId) ? customId(value) : customId;
    return value ? `popover:${scope.id}:trigger:${value}` : `popover:${scope.id}:trigger`;
};
var $5f1aa5f54f81623a$export$90a11d81f952f37f = (scope)=>scope.ids?.content ?? `popover:${scope.id}:content`;
var $5f1aa5f54f81623a$export$4d71d3401bdedcfa = (scope)=>scope.ids?.positioner ?? `popover:${scope.id}:popper`;
var $5f1aa5f54f81623a$export$7deab7528f89fcdf = (scope)=>scope.ids?.arrow ?? `popover:${scope.id}:arrow`;
var $5f1aa5f54f81623a$export$aed19156d565b1d7 = (scope)=>scope.ids?.title ?? `popover:${scope.id}:title`;
var $5f1aa5f54f81623a$export$abcfdc629db68a85 = (scope)=>scope.ids?.description ?? `popover:${scope.id}:desc`;
var $5f1aa5f54f81623a$export$eae8ddee3c3e583f = (scope)=>scope.ids?.closeTrigger ?? `popover:${scope.id}:close`;
var $5f1aa5f54f81623a$export$1d8a4179b7d5d63 = (scope)=>scope.getById($5f1aa5f54f81623a$export$a42527045c52cb4d(scope));
var $5f1aa5f54f81623a$export$cb60912464303603 = (scope)=>(0, $0a4b14a4ad082330$export$dcd0d083aa86c355)(scope.getDoc(), `[data-scope="popover"][data-part="trigger"][data-ownedby="${scope.id}"]`);
var $5f1aa5f54f81623a$export$65278ba5d6c7842c = (scope, value)=>{
    return value == null ? $5f1aa5f54f81623a$export$cb60912464303603(scope)[0] : scope.getById($5f1aa5f54f81623a$export$1e04a9a9d2b169fc(scope, value));
};
var $5f1aa5f54f81623a$export$64fc6550ad675c6a = (scope)=>scope.getById($5f1aa5f54f81623a$export$90a11d81f952f37f(scope));
var $5f1aa5f54f81623a$export$804920e034783925 = (scope)=>scope.getById($5f1aa5f54f81623a$export$4d71d3401bdedcfa(scope));
var $5f1aa5f54f81623a$export$87e74ed3dcc32874 = (scope)=>scope.getById($5f1aa5f54f81623a$export$aed19156d565b1d7(scope));
var $5f1aa5f54f81623a$export$bfbb834a7112b099 = (scope)=>scope.getById($5f1aa5f54f81623a$export$abcfdc629db68a85(scope));
var $5f1aa5f54f81623a$export$9fbfc930c1ab36c4 = (scope)=>(0, $07c78e08d1e50b44$export$f6768025e418420e)($5f1aa5f54f81623a$export$64fc6550ad675c6a(scope));
var $5f1aa5f54f81623a$export$cf2d52fb3242606 = (scope)=>$5f1aa5f54f81623a$export$9fbfc930c1ab36c4(scope)[0];


function $6a83254767954ef5$export$64605811ab45167f(service, normalize) {
    const { state: state, context: context, send: send, computed: computed, prop: prop, scope: scope } = service;
    const translations = prop("translations");
    const open = state.matches("open");
    const currentPlacement = context.get("currentPlacement");
    const portalled = computed("currentPortalled");
    const rendered = context.get("renderedElements");
    const triggerValue = context.get("triggerValue");
    const popperStyles = (0, $c1525c906b88b106$export$736498a3bfbba398)({
        ...prop("positioning"),
        placement: currentPlacement
    });
    return {
        portalled: portalled,
        open: open,
        setOpen (nextOpen) {
            const open2 = state.matches("open");
            if (open2 === nextOpen) return;
            send({
                type: nextOpen ? "OPEN" : "CLOSE"
            });
        },
        triggerValue: triggerValue,
        setTriggerValue (value) {
            send({
                type: "TRIGGER_VALUE.SET",
                value: value
            });
        },
        reposition (options = {}) {
            send({
                type: "POSITIONING.SET",
                options: options
            });
        },
        getArrowProps () {
            return normalize.element({
                id: $5f1aa5f54f81623a$export$7deab7528f89fcdf(scope),
                ...(0, $40970757bbe640c2$export$6e2410c1d27f06e7).arrow.attrs,
                dir: prop("dir"),
                style: popperStyles.arrow
            });
        },
        getArrowTipProps () {
            return normalize.element({
                ...(0, $40970757bbe640c2$export$6e2410c1d27f06e7).arrowTip.attrs,
                dir: prop("dir"),
                style: popperStyles.arrowTip
            });
        },
        getAnchorProps () {
            return normalize.element({
                ...(0, $40970757bbe640c2$export$6e2410c1d27f06e7).anchor.attrs,
                dir: prop("dir"),
                id: $5f1aa5f54f81623a$export$a42527045c52cb4d(scope)
            });
        },
        getTriggerProps (props = {}) {
            const { value: value } = props;
            const current = value == null ? false : triggerValue === value;
            return normalize.button({
                ...(0, $40970757bbe640c2$export$6e2410c1d27f06e7).trigger.attrs,
                dir: prop("dir"),
                type: "button",
                "data-placement": currentPlacement,
                id: $5f1aa5f54f81623a$export$1e04a9a9d2b169fc(scope, value),
                "data-ownedby": scope.id,
                "data-value": value,
                "data-current": (0, $dbd9babc41e226bd$export$5cc3b7b83e34ade7)(current),
                "aria-haspopup": "dialog",
                "aria-expanded": value == null ? open : open && current,
                "data-state": open ? "open" : "closed",
                "aria-controls": $5f1aa5f54f81623a$export$90a11d81f952f37f(scope),
                onPointerDown (event) {
                    if (!(0, $3921311bf0c8eca9$export$698c4f0ff5e11e52)(event)) return;
                    if ((0, $1bdb5bdc36ac2529$export$95df08bae54cb4df)()) event.currentTarget.focus();
                },
                onClick (event) {
                    if (event.defaultPrevented) return;
                    const shouldSwitch = open && value != null && !current;
                    send({
                        type: shouldSwitch ? "TRIGGER_VALUE.SET" : "TOGGLE",
                        value: value
                    });
                },
                onBlur (event) {
                    send({
                        type: "TRIGGER_BLUR",
                        target: event.relatedTarget
                    });
                }
            });
        },
        getIndicatorProps () {
            return normalize.element({
                ...(0, $40970757bbe640c2$export$6e2410c1d27f06e7).indicator.attrs,
                dir: prop("dir"),
                "data-state": open ? "open" : "closed"
            });
        },
        getPositionerProps () {
            return normalize.element({
                id: $5f1aa5f54f81623a$export$4d71d3401bdedcfa(scope),
                ...(0, $40970757bbe640c2$export$6e2410c1d27f06e7).positioner.attrs,
                dir: prop("dir"),
                style: popperStyles.floating
            });
        },
        getContentProps () {
            return normalize.element({
                ...(0, $40970757bbe640c2$export$6e2410c1d27f06e7).content.attrs,
                dir: prop("dir"),
                id: $5f1aa5f54f81623a$export$90a11d81f952f37f(scope),
                tabIndex: -1,
                role: "dialog",
                "aria-modal": (0, $dbd9babc41e226bd$export$91a6105db3d4be7b)(prop("modal")),
                hidden: !open,
                "data-state": open ? "open" : "closed",
                "data-expanded": (0, $dbd9babc41e226bd$export$5cc3b7b83e34ade7)(open),
                "aria-labelledby": rendered.title ? $5f1aa5f54f81623a$export$aed19156d565b1d7(scope) : void 0,
                "aria-describedby": rendered.description ? $5f1aa5f54f81623a$export$abcfdc629db68a85(scope) : void 0,
                "data-placement": currentPlacement
            });
        },
        getTitleProps () {
            return normalize.element({
                ...(0, $40970757bbe640c2$export$6e2410c1d27f06e7).title.attrs,
                id: $5f1aa5f54f81623a$export$aed19156d565b1d7(scope),
                dir: prop("dir")
            });
        },
        getDescriptionProps () {
            return normalize.element({
                ...(0, $40970757bbe640c2$export$6e2410c1d27f06e7).description.attrs,
                id: $5f1aa5f54f81623a$export$abcfdc629db68a85(scope),
                dir: prop("dir")
            });
        },
        getCloseTriggerProps () {
            return normalize.button({
                ...(0, $40970757bbe640c2$export$6e2410c1d27f06e7).closeTrigger.attrs,
                dir: prop("dir"),
                id: $5f1aa5f54f81623a$export$eae8ddee3c3e583f(scope),
                type: "button",
                "aria-label": translations.closeTriggerLabel,
                onClick (event) {
                    if (event.defaultPrevented) return;
                    event.stopPropagation();
                    send({
                        type: "CLOSE"
                    });
                }
            });
        }
    };
}

// src/popover.machine.ts
// src/index.ts
// src/aria-hidden.ts
// src/walk-tree-outside.ts

var $aa195cb484927b5a$var$counterMap = /* @__PURE__ */ new WeakMap();
var $aa195cb484927b5a$var$uncontrolledNodes = /* @__PURE__ */ new WeakMap();
var $aa195cb484927b5a$var$markerMap = {};
var $aa195cb484927b5a$var$lockCount = 0;
var $aa195cb484927b5a$var$unwrapHost = (node)=>node && (node.host || $aa195cb484927b5a$var$unwrapHost(node.parentNode));
var $aa195cb484927b5a$var$correctTargets = (parent, targets)=>targets.map((target)=>{
        if (parent.contains(target)) return target;
        const correctedTarget = $aa195cb484927b5a$var$unwrapHost(target);
        if (correctedTarget && parent.contains(correctedTarget)) return correctedTarget;
        console.error("[zag-js > ariaHidden] target", target, "in not contained inside", parent, ". Doing nothing");
        return null;
    }).filter((x)=>Boolean(x));
var $aa195cb484927b5a$var$ignoreableNodes = /* @__PURE__ */ new Set([
    "script",
    "output",
    "status",
    "next-route-announcer"
]);
var $aa195cb484927b5a$var$isIgnoredNode = (node)=>{
    if ($aa195cb484927b5a$var$ignoreableNodes.has(node.localName)) return true;
    if (node.role === "status") return true;
    if (node.hasAttribute("aria-live")) return true;
    return node.matches("[data-live-announcer]");
};
var $aa195cb484927b5a$export$8f3c183776c23d89 = (originalTarget, props)=>{
    const { parentNode: parentNode, markerName: markerName, controlAttribute: controlAttribute, explicitBooleanValue: explicitBooleanValue, followControlledElements: followControlledElements = true } = props;
    const targets = $aa195cb484927b5a$var$correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    $aa195cb484927b5a$var$markerMap[markerName] || ($aa195cb484927b5a$var$markerMap[markerName] = /* @__PURE__ */ new WeakMap());
    const markerCounter = $aa195cb484927b5a$var$markerMap[markerName];
    const hiddenNodes = [];
    const elementsToKeep = /* @__PURE__ */ new Set();
    const elementsToStop = new Set(targets);
    const keep = (el)=>{
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        keep(el.parentNode);
    };
    targets.forEach((target)=>{
        keep(target);
        if (followControlledElements && (0, $2020ec4601cca401$export$1b3bfaa9684536aa)(target)) (0, $912bae6dd4ff9bca$export$af976ebb0ca4d827)(target, (controlledElement)=>{
            keep(controlledElement);
        });
    });
    const deep = (parent)=>{
        if (!parent || elementsToStop.has(parent)) return;
        Array.prototype.forEach.call(parent.children, (node)=>{
            if (elementsToKeep.has(node)) deep(node);
            else try {
                if ($aa195cb484927b5a$var$isIgnoredNode(node)) return;
                const attr = node.getAttribute(controlAttribute);
                const alreadyHidden = explicitBooleanValue ? attr === "true" : attr !== null && attr !== "false";
                const counterValue = ($aa195cb484927b5a$var$counterMap.get(node) || 0) + 1;
                const markerValue = (markerCounter.get(node) || 0) + 1;
                $aa195cb484927b5a$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenNodes.push(node);
                if (counterValue === 1 && alreadyHidden) $aa195cb484927b5a$var$uncontrolledNodes.set(node, true);
                if (markerValue === 1) node.setAttribute(markerName, "");
                if (!alreadyHidden) node.setAttribute(controlAttribute, explicitBooleanValue ? "true" : "");
            } catch (e) {
                console.error("[zag-js > ariaHidden] cannot operate on ", node, e);
            }
        });
    };
    deep(parentNode);
    elementsToKeep.clear();
    $aa195cb484927b5a$var$lockCount++;
    return ()=>{
        hiddenNodes.forEach((node)=>{
            const counterValue = $aa195cb484927b5a$var$counterMap.get(node) - 1;
            const markerValue = markerCounter.get(node) - 1;
            $aa195cb484927b5a$var$counterMap.set(node, counterValue);
            markerCounter.set(node, markerValue);
            if (!counterValue) {
                if (!$aa195cb484927b5a$var$uncontrolledNodes.has(node)) node.removeAttribute(controlAttribute);
                $aa195cb484927b5a$var$uncontrolledNodes.delete(node);
            }
            if (!markerValue) node.removeAttribute(markerName);
        });
        $aa195cb484927b5a$var$lockCount--;
        if (!$aa195cb484927b5a$var$lockCount) {
            $aa195cb484927b5a$var$counterMap = /* @__PURE__ */ new WeakMap();
            $aa195cb484927b5a$var$counterMap = /* @__PURE__ */ new WeakMap();
            $aa195cb484927b5a$var$uncontrolledNodes = /* @__PURE__ */ new WeakMap();
            $aa195cb484927b5a$var$markerMap = {};
        }
    };
};


var $a2f97718d197679f$var$getParentNode = (originalTarget)=>{
    const target = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
    return target.ownerDocument.body;
};
var $a2f97718d197679f$export$6e33d16126ed003c = (originalTarget, parentNode = $a2f97718d197679f$var$getParentNode(originalTarget), markerName = "data-aria-hidden", followControlledElements = true)=>{
    if (!parentNode) return;
    return (0, $aa195cb484927b5a$export$8f3c183776c23d89)(originalTarget, {
        parentNode: parentNode,
        markerName: markerName,
        controlAttribute: "aria-hidden",
        explicitBooleanValue: true,
        followControlledElements: followControlledElements
    });
};
var $a2f97718d197679f$export$59151cc8db999a24 = (originalTarget, parentNode = $a2f97718d197679f$var$getParentNode(originalTarget), markerName = "data-inerted", followControlledElements = true)=>{
    if (!parentNode) return;
    return (0, $aa195cb484927b5a$export$8f3c183776c23d89)(originalTarget, {
        parentNode: parentNode,
        markerName: markerName,
        controlAttribute: "inert",
        explicitBooleanValue: false,
        followControlledElements: followControlledElements
    });
};
var $a2f97718d197679f$var$supportsInert = ()=>typeof HTMLElement !== "undefined" && HTMLElement.prototype.hasOwnProperty("inert");
var $a2f97718d197679f$export$9845d4b6bdad192b = (originalTarget, parentNode, markerName = "data-suppressed", followControlledElements = true)=>{
    const fn = $a2f97718d197679f$var$supportsInert() ? $a2f97718d197679f$export$59151cc8db999a24 : $a2f97718d197679f$export$6e33d16126ed003c;
    return fn(originalTarget, parentNode, markerName, followControlledElements);
};


var $5cc784adb074ad2f$var$raf = (fn)=>{
    const frameId = requestAnimationFrame(()=>fn());
    return ()=>cancelAnimationFrame(frameId);
};
function $5cc784adb074ad2f$export$e1bd0c6150f13d96(targetsOrFn, options = {}) {
    const { defer: defer = true } = options;
    const func = defer ? $5cc784adb074ad2f$var$raf : (v)=>v();
    const cleanups = [];
    cleanups.push(func(()=>{
        const targets = typeof targetsOrFn === "function" ? targetsOrFn() : targetsOrFn;
        const elements = targets.filter(Boolean);
        if (elements.length === 0) return;
        cleanups.push((0, $a2f97718d197679f$export$6e33d16126ed003c)(elements));
    }));
    return ()=>{
        cleanups.forEach((fn)=>fn?.());
    };
}









function $7b1fe2ef9c54e049$var$proxyTabFocusImpl(container, options = {}) {
    const { triggerElement: triggerElement, onFocus: onFocus, onFocusEnter: onFocusEnter, getShadowRoot: getShadowRoot } = options;
    const doc = container?.ownerDocument || document;
    const body = doc.body;
    function onKeyDown(event) {
        if (event.key !== "Tab") return;
        let elementToFocus = null;
        const [firstTabbable, lastTabbable] = (0, $07c78e08d1e50b44$export$1b7701f2d138464c)(container, {
            includeContainer: true,
            getShadowRoot: getShadowRoot
        });
        const nextTabbableAfterTrigger = (0, $07c78e08d1e50b44$export$28f33206776129a7)(body, {
            current: triggerElement,
            getShadowRoot: getShadowRoot
        });
        const noTabbableElements = !firstTabbable && !lastTabbable;
        if (event.shiftKey && (0, $2020ec4601cca401$export$8a2eb51c14bb8899)(nextTabbableAfterTrigger)) {
            onFocusEnter?.();
            elementToFocus = lastTabbable;
        } else if (event.shiftKey && ((0, $2020ec4601cca401$export$8a2eb51c14bb8899)(firstTabbable) || noTabbableElements)) elementToFocus = triggerElement;
        else if (!event.shiftKey && (0, $2020ec4601cca401$export$8a2eb51c14bb8899)(triggerElement)) {
            onFocusEnter?.();
            elementToFocus = firstTabbable;
        } else if (!event.shiftKey && ((0, $2020ec4601cca401$export$8a2eb51c14bb8899)(lastTabbable) || noTabbableElements)) elementToFocus = nextTabbableAfterTrigger;
        if (!elementToFocus) return;
        event.preventDefault();
        if (typeof onFocus === "function") onFocus(elementToFocus);
        else elementToFocus.focus();
    }
    return (0, $3921311bf0c8eca9$export$b1d829ddf82884aa)(doc, "keydown", onKeyDown, true);
}
function $7b1fe2ef9c54e049$export$c90f8060ab168f84(container, options) {
    const { defer: defer, triggerElement: triggerElement, ...restOptions } = options;
    const func = defer ? (0, $7eacfb22d5a39e52$export$27f233d61a9e2fa4) : (v)=>v();
    const cleanups = [];
    cleanups.push(func(()=>{
        const node = typeof container === "function" ? container() : container;
        const trigger = typeof triggerElement === "function" ? triggerElement() : triggerElement;
        cleanups.push($7b1fe2ef9c54e049$var$proxyTabFocusImpl(node, {
            triggerElement: trigger,
            ...restOptions
        }));
    }));
    return ()=>{
        cleanups.forEach((fn)=>fn?.());
    };
}




var $741c536b41d2b326$var$__defProp = Object.defineProperty;
var $741c536b41d2b326$var$__defNormalProp = (obj, key, value)=>key in obj ? $741c536b41d2b326$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $741c536b41d2b326$export$5cb848ba4d1f099 = (obj, key, value)=>$741c536b41d2b326$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);



var $ce9075a007cf2c22$var$activeFocusTraps = {
    activateTrap (trapStack, trap) {
        if (trapStack.length > 0) {
            const activeTrap = trapStack[trapStack.length - 1];
            if (activeTrap !== trap) activeTrap.pause();
        }
        const trapIndex = trapStack.indexOf(trap);
        if (trapIndex === -1) trapStack.push(trap);
        else {
            trapStack.splice(trapIndex, 1);
            trapStack.push(trap);
        }
    },
    deactivateTrap (trapStack, trap) {
        const trapIndex = trapStack.indexOf(trap);
        if (trapIndex !== -1) trapStack.splice(trapIndex, 1);
        if (trapStack.length > 0) trapStack[trapStack.length - 1].unpause();
    }
};
var $ce9075a007cf2c22$var$sharedTrapStack = [];
var $ce9075a007cf2c22$export$34eba2437817a67b = class {
    constructor(elements, options){
        (0, $741c536b41d2b326$export$5cb848ba4d1f099)(this, "trapStack");
        (0, $741c536b41d2b326$export$5cb848ba4d1f099)(this, "config");
        (0, $741c536b41d2b326$export$5cb848ba4d1f099)(this, "doc");
        (0, $741c536b41d2b326$export$5cb848ba4d1f099)(this, "state", {
            containers: [],
            containerGroups: [],
            tabbableGroups: [],
            nodeFocusedBeforeActivation: null,
            mostRecentlyFocusedNode: null,
            active: false,
            paused: false,
            delayInitialFocusTimer: void 0,
            recentNavEvent: void 0
        });
        // Track portal containers that contain controlled elements
        (0, $741c536b41d2b326$export$5cb848ba4d1f099)(this, "portalContainers", /* @__PURE__ */ new Set());
        (0, $741c536b41d2b326$export$5cb848ba4d1f099)(this, "listenerCleanups", []);
        (0, $741c536b41d2b326$export$5cb848ba4d1f099)(this, "handleFocus", (event)=>{
            const target = (0, $3921311bf0c8eca9$export$e58f029f0fbfdb29)(event);
            const targetContained = this.findContainerIndex(target, event) >= 0;
            if (targetContained || (0, $2020ec4601cca401$export$62858bae88b53fd0)(target)) {
                if (targetContained) this.state.mostRecentlyFocusedNode = target;
            } else {
                event.stopImmediatePropagation();
                let nextNode;
                let navAcrossContainers = true;
                if (this.state.mostRecentlyFocusedNode) {
                    if ((0, $07c78e08d1e50b44$export$a4672efddb4181b8)(this.state.mostRecentlyFocusedNode) > 0) {
                        const mruContainerIdx = this.findContainerIndex(this.state.mostRecentlyFocusedNode);
                        const { tabbableNodes: tabbableNodes } = this.state.containerGroups[mruContainerIdx];
                        if (tabbableNodes.length > 0) {
                            const mruTabIdx = tabbableNodes.findIndex((node)=>node === this.state.mostRecentlyFocusedNode);
                            if (mruTabIdx >= 0) {
                                if (this.config.isKeyForward(this.state.recentNavEvent)) {
                                    if (mruTabIdx + 1 < tabbableNodes.length) {
                                        nextNode = tabbableNodes[mruTabIdx + 1];
                                        navAcrossContainers = false;
                                    }
                                } else if (mruTabIdx - 1 >= 0) {
                                    nextNode = tabbableNodes[mruTabIdx - 1];
                                    navAcrossContainers = false;
                                }
                            }
                        }
                    } else if (!this.state.containerGroups.some((g)=>g.tabbableNodes.some((n)=>(0, $07c78e08d1e50b44$export$a4672efddb4181b8)(n) > 0))) navAcrossContainers = false;
                } else navAcrossContainers = false;
                if (navAcrossContainers) nextNode = this.findNextNavNode({
                    // move FROM the MRU node, not event-related node (which will be the node that is
                    //  outside the trap causing the focus escape we're trying to fix)
                    target: this.state.mostRecentlyFocusedNode,
                    isBackward: this.config.isKeyBackward(this.state.recentNavEvent)
                });
                if (nextNode) this.tryFocus(nextNode);
                else this.tryFocus(this.state.mostRecentlyFocusedNode || this.getInitialFocusNode());
            }
            this.state.recentNavEvent = void 0;
        });
        (0, $741c536b41d2b326$export$5cb848ba4d1f099)(this, "handlePointerDown", (event)=>{
            const target = (0, $3921311bf0c8eca9$export$e58f029f0fbfdb29)(event);
            if (this.findContainerIndex(target, event) >= 0) return;
            if ($ce9075a007cf2c22$var$valueOrHandler(this.config.clickOutsideDeactivates, event)) {
                this.deactivate({
                    returnFocus: this.config.returnFocusOnDeactivate
                });
                return;
            }
            if ($ce9075a007cf2c22$var$valueOrHandler(this.config.allowOutsideClick, event)) return;
            event.preventDefault();
        });
        (0, $741c536b41d2b326$export$5cb848ba4d1f099)(this, "handleClick", (event)=>{
            const target = (0, $3921311bf0c8eca9$export$e58f029f0fbfdb29)(event);
            if (this.findContainerIndex(target, event) >= 0) return;
            if ($ce9075a007cf2c22$var$valueOrHandler(this.config.clickOutsideDeactivates, event)) return;
            if ($ce9075a007cf2c22$var$valueOrHandler(this.config.allowOutsideClick, event)) return;
            event.preventDefault();
            event.stopImmediatePropagation();
        });
        (0, $741c536b41d2b326$export$5cb848ba4d1f099)(this, "handleTabKey", (event)=>{
            if (this.config.isKeyForward(event) || this.config.isKeyBackward(event)) {
                this.state.recentNavEvent = event;
                const isBackward = this.config.isKeyBackward(event);
                const destinationNode = this.findNextNavNode({
                    event: event,
                    isBackward: isBackward
                });
                if (!destinationNode) return;
                if ($ce9075a007cf2c22$var$isTabEvent(event)) event.preventDefault();
                this.tryFocus(destinationNode);
            }
        });
        (0, $741c536b41d2b326$export$5cb848ba4d1f099)(this, "handleEscapeKey", (event)=>{
            if ($ce9075a007cf2c22$var$isEscapeEvent(event) && $ce9075a007cf2c22$var$valueOrHandler(this.config.escapeDeactivates, event) !== false) {
                event.preventDefault();
                this.deactivate();
            }
        });
        (0, $741c536b41d2b326$export$5cb848ba4d1f099)(this, "_mutationObserver");
        (0, $741c536b41d2b326$export$5cb848ba4d1f099)(this, "setupMutationObserver", ()=>{
            const win = this.doc.defaultView || window;
            this._mutationObserver = new win.MutationObserver((mutations)=>{
                const isFocusedNodeRemoved = mutations.some((mutation)=>{
                    const removedNodes = Array.from(mutation.removedNodes);
                    return removedNodes.some((node)=>node === this.state.mostRecentlyFocusedNode);
                });
                if (isFocusedNodeRemoved) this.tryFocus(this.getInitialFocusNode());
                const hasControlledChanges = mutations.some((mutation)=>{
                    if (mutation.type === "attributes" && (mutation.attributeName === "aria-controls" || mutation.attributeName === "aria-expanded")) return true;
                    if (mutation.type === "childList" && mutation.addedNodes.length > 0) return Array.from(mutation.addedNodes).some((node)=>{
                        if (node.nodeType !== Node.ELEMENT_NODE) return false;
                        const element = node;
                        if ((0, $912bae6dd4ff9bca$export$1ebdf3db449817ba)(element)) return true;
                        if (element.id && !this.state.containers.some((c)=>c.contains(element))) return (0, $912bae6dd4ff9bca$export$144f869056b2a98)(element);
                        return false;
                    });
                    return false;
                });
                if (hasControlledChanges && this.state.active && !this.state.paused) {
                    this.updateTabbableNodes();
                    this.updatePortalContainers();
                }
            });
        });
        (0, $741c536b41d2b326$export$5cb848ba4d1f099)(this, "updateObservedNodes", ()=>{
            this._mutationObserver?.disconnect();
            if (this.state.active && !this.state.paused) {
                this.state.containers.map((container)=>{
                    this._mutationObserver?.observe(container, {
                        subtree: true,
                        childList: true,
                        attributes: true,
                        attributeFilter: [
                            "aria-controls",
                            "aria-expanded"
                        ]
                    });
                });
                this.portalContainers.forEach((portalContainer)=>{
                    this.observePortalContainer(portalContainer);
                });
            }
        });
        (0, $741c536b41d2b326$export$5cb848ba4d1f099)(this, "getInitialFocusNode", ()=>{
            let node = this.getNodeForOption("initialFocus", {
                hasFallback: true
            });
            if (node === false) return false;
            if (node === void 0 || node && !(0, $07c78e08d1e50b44$export$4c063cf1350e6fed)(node)) {
                const activeElement = (0, $2020ec4601cca401$export$cd4e5573fbe2b576)(this.doc);
                if (activeElement && this.findContainerIndex(activeElement) >= 0) node = activeElement;
                else {
                    const firstTabbableGroup = this.state.tabbableGroups[0];
                    const firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode;
                    node = firstTabbableNode || this.getNodeForOption("fallbackFocus");
                }
            } else if (node === null) node = this.getNodeForOption("fallbackFocus");
            if (!node) throw new Error("Your focus-trap needs to have at least one focusable element");
            if (!node.isConnected) node = this.getNodeForOption("fallbackFocus");
            if (!node || !node.isConnected) throw new Error("Your focus-trap needs to have at least one focusable element");
            return node;
        });
        (0, $741c536b41d2b326$export$5cb848ba4d1f099)(this, "tryFocus", (node)=>{
            if (node === false) return;
            if (node === (0, $2020ec4601cca401$export$cd4e5573fbe2b576)(this.doc)) return;
            if (!node || !node.focus) {
                this.tryFocus(this.getInitialFocusNode());
                return;
            }
            node.focus({
                preventScroll: !!this.config.preventScroll
            });
            this.state.mostRecentlyFocusedNode = node;
            if ($ce9075a007cf2c22$var$isSelectableInput(node)) node.select();
        });
        (0, $741c536b41d2b326$export$5cb848ba4d1f099)(this, "deactivate", (deactivateOptions)=>{
            if (!this.state.active) return this;
            const options = {
                onDeactivate: this.config.onDeactivate,
                onPostDeactivate: this.config.onPostDeactivate,
                checkCanReturnFocus: this.config.checkCanReturnFocus,
                ...deactivateOptions
            };
            clearTimeout(this.state.delayInitialFocusTimer);
            this.state.delayInitialFocusTimer = void 0;
            this.removeListeners();
            this.state.active = false;
            this.state.paused = false;
            this.updateObservedNodes();
            $ce9075a007cf2c22$var$activeFocusTraps.deactivateTrap(this.trapStack, this);
            this.portalContainers.clear();
            const onDeactivate = this.getOption(options, "onDeactivate");
            const onPostDeactivate = this.getOption(options, "onPostDeactivate");
            const checkCanReturnFocus = this.getOption(options, "checkCanReturnFocus");
            const returnFocus = this.getOption(options, "returnFocus", "returnFocusOnDeactivate");
            onDeactivate?.();
            const finishDeactivation = ()=>{
                $ce9075a007cf2c22$var$delay(()=>{
                    if (returnFocus) {
                        const returnFocusNode = this.getReturnFocusNode(this.state.nodeFocusedBeforeActivation);
                        this.tryFocus(returnFocusNode);
                    }
                    onPostDeactivate?.();
                });
            };
            if (returnFocus && checkCanReturnFocus) {
                const returnFocusNode = this.getReturnFocusNode(this.state.nodeFocusedBeforeActivation);
                checkCanReturnFocus(returnFocusNode).then(finishDeactivation, finishDeactivation);
                return this;
            }
            finishDeactivation();
            return this;
        });
        (0, $741c536b41d2b326$export$5cb848ba4d1f099)(this, "pause", (pauseOptions)=>{
            if (this.state.paused || !this.state.active) return this;
            const onPause = this.getOption(pauseOptions, "onPause");
            const onPostPause = this.getOption(pauseOptions, "onPostPause");
            this.state.paused = true;
            onPause?.();
            this.removeListeners();
            this.updateObservedNodes();
            onPostPause?.();
            return this;
        });
        (0, $741c536b41d2b326$export$5cb848ba4d1f099)(this, "unpause", (unpauseOptions)=>{
            if (!this.state.paused || !this.state.active) return this;
            const onUnpause = this.getOption(unpauseOptions, "onUnpause");
            const onPostUnpause = this.getOption(unpauseOptions, "onPostUnpause");
            this.state.paused = false;
            onUnpause?.();
            this.updateTabbableNodes();
            this.addListeners();
            this.updateObservedNodes();
            onPostUnpause?.();
            return this;
        });
        (0, $741c536b41d2b326$export$5cb848ba4d1f099)(this, "updateContainerElements", (containerElements)=>{
            this.state.containers = Array.isArray(containerElements) ? containerElements.filter(Boolean) : [
                containerElements
            ].filter(Boolean);
            if (this.state.active) this.updateTabbableNodes();
            this.updateObservedNodes();
            return this;
        });
        (0, $741c536b41d2b326$export$5cb848ba4d1f099)(this, "getReturnFocusNode", (previousActiveElement)=>{
            const node = this.getNodeForOption("setReturnFocus", {
                params: [
                    previousActiveElement
                ]
            });
            return node ? node : node === false ? false : previousActiveElement;
        });
        (0, $741c536b41d2b326$export$5cb848ba4d1f099)(this, "getOption", (configOverrideOptions, optionName, configOptionName)=>{
            return configOverrideOptions && configOverrideOptions[optionName] !== void 0 ? configOverrideOptions[optionName] : // @ts-expect-error
            this.config[configOptionName || optionName];
        });
        (0, $741c536b41d2b326$export$5cb848ba4d1f099)(this, "getNodeForOption", (optionName, { hasFallback: hasFallback = false, params: params = [] } = {})=>{
            let optionValue = this.config[optionName];
            if (typeof optionValue === "function") optionValue = optionValue(...params);
            if (optionValue === true) optionValue = void 0;
            if (!optionValue) {
                if (optionValue === void 0 || optionValue === false) return optionValue;
                throw new Error(`\`${optionName}\` was specified but was not a node, or did not return a node`);
            }
            let node = optionValue;
            if (typeof optionValue === "string") {
                try {
                    node = this.doc.querySelector(optionValue);
                } catch (err) {
                    throw new Error(`\`${optionName}\` appears to be an invalid selector; error="${err.message}"`);
                }
                if (!node) {
                    if (!hasFallback) throw new Error(`\`${optionName}\` as selector refers to no known node`);
                }
            }
            return node;
        });
        (0, $741c536b41d2b326$export$5cb848ba4d1f099)(this, "findNextNavNode", (opts)=>{
            const { event: event, isBackward: isBackward = false } = opts;
            const target = opts.target || (0, $3921311bf0c8eca9$export$e58f029f0fbfdb29)(event);
            this.updateTabbableNodes();
            let destinationNode = null;
            if (this.state.tabbableGroups.length > 0) {
                const containerIndex = this.findContainerIndex(target, event);
                const containerGroup = containerIndex >= 0 ? this.state.containerGroups[containerIndex] : void 0;
                if (containerIndex < 0) {
                    if (isBackward) destinationNode = this.state.tabbableGroups[this.state.tabbableGroups.length - 1].lastTabbableNode;
                    else destinationNode = this.state.tabbableGroups[0].firstTabbableNode;
                } else if (isBackward) {
                    let startOfGroupIndex = this.state.tabbableGroups.findIndex(({ firstTabbableNode: firstTabbableNode })=>target === firstTabbableNode);
                    if (startOfGroupIndex < 0 && (containerGroup?.container === target || (0, $07c78e08d1e50b44$export$4c063cf1350e6fed)(target) && !(0, $07c78e08d1e50b44$export$bebd5a1431fec25d)(target) && !containerGroup?.nextTabbableNode(target, false))) startOfGroupIndex = containerIndex;
                    if (startOfGroupIndex >= 0) {
                        const destinationGroupIndex = startOfGroupIndex === 0 ? this.state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
                        const destinationGroup = this.state.tabbableGroups[destinationGroupIndex];
                        destinationNode = (0, $07c78e08d1e50b44$export$a4672efddb4181b8)(target) >= 0 ? destinationGroup.lastTabbableNode : destinationGroup.lastDomTabbableNode;
                    } else if (!$ce9075a007cf2c22$var$isTabEvent(event)) destinationNode = containerGroup?.nextTabbableNode(target, false);
                } else {
                    let lastOfGroupIndex = this.state.tabbableGroups.findIndex(({ lastTabbableNode: lastTabbableNode })=>target === lastTabbableNode);
                    if (lastOfGroupIndex < 0 && (containerGroup?.container === target || (0, $07c78e08d1e50b44$export$4c063cf1350e6fed)(target) && !(0, $07c78e08d1e50b44$export$bebd5a1431fec25d)(target) && !containerGroup?.nextTabbableNode(target))) lastOfGroupIndex = containerIndex;
                    if (lastOfGroupIndex >= 0) {
                        const destinationGroupIndex = lastOfGroupIndex === this.state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;
                        const destinationGroup = this.state.tabbableGroups[destinationGroupIndex];
                        destinationNode = (0, $07c78e08d1e50b44$export$a4672efddb4181b8)(target) >= 0 ? destinationGroup.firstTabbableNode : destinationGroup.firstDomTabbableNode;
                    } else if (!$ce9075a007cf2c22$var$isTabEvent(event)) destinationNode = containerGroup?.nextTabbableNode(target);
                }
            } else destinationNode = this.getNodeForOption("fallbackFocus");
            return destinationNode;
        });
        this.trapStack = options.trapStack || $ce9075a007cf2c22$var$sharedTrapStack;
        const config = {
            returnFocusOnDeactivate: true,
            escapeDeactivates: true,
            delayInitialFocus: true,
            followControlledElements: true,
            isKeyForward: $ce9075a007cf2c22$var$isKeyForward,
            isKeyBackward: $ce9075a007cf2c22$var$isKeyBackward,
            ...options
        };
        this.doc = config.document || (0, $2020ec4601cca401$export$f65ca476c09acec0)(Array.isArray(elements) ? elements[0] : elements);
        this.config = config;
        this.updateContainerElements(elements);
        this.setupMutationObserver();
    }
    addPortalContainer(controlledElement) {
        const portalContainer = controlledElement.parentElement;
        if (portalContainer && !this.portalContainers.has(portalContainer)) {
            this.portalContainers.add(portalContainer);
            if (this.state.active && !this.state.paused) this.observePortalContainer(portalContainer);
        }
    }
    observePortalContainer(portalContainer) {
        this._mutationObserver?.observe(portalContainer, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "aria-controls",
                "aria-expanded"
            ]
        });
    }
    updatePortalContainers() {
        if (!this.config.followControlledElements) return;
        this.state.containers.forEach((container)=>{
            const controlledElements = (0, $912bae6dd4ff9bca$export$6160e89b490c5e0b)(container);
            controlledElements.forEach((controlledElement)=>{
                this.addPortalContainer(controlledElement);
            });
        });
    }
    get active() {
        return this.state.active;
    }
    get paused() {
        return this.state.paused;
    }
    findContainerIndex(element, event) {
        const composedPath = typeof event?.composedPath === "function" ? event.composedPath() : void 0;
        return this.state.containerGroups.findIndex(({ container: container, tabbableNodes: tabbableNodes })=>container.contains(element) || composedPath?.includes(container) || tabbableNodes.find((node)=>node === element) || this.isControlledElement(container, element));
    }
    isControlledElement(container, element) {
        if (!this.config.followControlledElements) return false;
        return (0, $912bae6dd4ff9bca$export$e5e931dc5029df72)(container, element);
    }
    updateTabbableNodes() {
        this.state.containerGroups = this.state.containers.map((container)=>{
            const tabbableNodes = (0, $07c78e08d1e50b44$export$5f161a4b62f9e29a)(container, {
                getShadowRoot: this.config.getShadowRoot
            });
            const focusableNodes = (0, $07c78e08d1e50b44$export$f6768025e418420e)(container, {
                getShadowRoot: this.config.getShadowRoot
            });
            const firstTabbableNode = tabbableNodes[0];
            const lastTabbableNode = tabbableNodes[tabbableNodes.length - 1];
            const firstDomTabbableNode = firstTabbableNode;
            const lastDomTabbableNode = lastTabbableNode;
            let posTabIndexesFound = false;
            for(let i = 0; i < tabbableNodes.length; i++)if ((0, $07c78e08d1e50b44$export$a4672efddb4181b8)(tabbableNodes[i]) > 0) {
                posTabIndexesFound = true;
                break;
            }
            function nextTabbableNode(node, forward = true) {
                const nodeIdx = tabbableNodes.indexOf(node);
                if (nodeIdx >= 0) return tabbableNodes[nodeIdx + (forward ? 1 : -1)];
                const focusableIdx = focusableNodes.indexOf(node);
                if (focusableIdx < 0) return void 0;
                if (forward) for(let i = focusableIdx + 1; i < focusableNodes.length; i++){
                    if ((0, $07c78e08d1e50b44$export$bebd5a1431fec25d)(focusableNodes[i])) return focusableNodes[i];
                }
                else for(let i = focusableIdx - 1; i >= 0; i--){
                    if ((0, $07c78e08d1e50b44$export$bebd5a1431fec25d)(focusableNodes[i])) return focusableNodes[i];
                }
                return void 0;
            }
            return {
                container: container,
                tabbableNodes: tabbableNodes,
                focusableNodes: focusableNodes,
                posTabIndexesFound: posTabIndexesFound,
                firstTabbableNode: firstTabbableNode,
                lastTabbableNode: lastTabbableNode,
                firstDomTabbableNode: firstDomTabbableNode,
                lastDomTabbableNode: lastDomTabbableNode,
                nextTabbableNode: nextTabbableNode
            };
        });
        this.state.tabbableGroups = this.state.containerGroups.filter((group)=>group.tabbableNodes.length > 0);
        if (this.state.tabbableGroups.length <= 0 && !this.getNodeForOption("fallbackFocus")) throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
        if (this.state.containerGroups.find((g)=>g.posTabIndexesFound) && this.state.containerGroups.length > 1) throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
    }
    addListeners() {
        if (!this.state.active) return;
        $ce9075a007cf2c22$var$activeFocusTraps.activateTrap(this.trapStack, this);
        this.state.delayInitialFocusTimer = this.config.delayInitialFocus ? $ce9075a007cf2c22$var$delay(()=>{
            this.tryFocus(this.getInitialFocusNode());
        }) : this.tryFocus(this.getInitialFocusNode());
        this.listenerCleanups.push((0, $3921311bf0c8eca9$export$b1d829ddf82884aa)(this.doc, "focusin", this.handleFocus, true), (0, $3921311bf0c8eca9$export$b1d829ddf82884aa)(this.doc, "mousedown", this.handlePointerDown, {
            capture: true,
            passive: false
        }), (0, $3921311bf0c8eca9$export$b1d829ddf82884aa)(this.doc, "touchstart", this.handlePointerDown, {
            capture: true,
            passive: false
        }), (0, $3921311bf0c8eca9$export$b1d829ddf82884aa)(this.doc, "click", this.handleClick, {
            capture: true,
            passive: false
        }), (0, $3921311bf0c8eca9$export$b1d829ddf82884aa)(this.doc, "keydown", this.handleTabKey, {
            capture: true,
            passive: false
        }), (0, $3921311bf0c8eca9$export$b1d829ddf82884aa)(this.doc, "keydown", this.handleEscapeKey));
        return this;
    }
    removeListeners() {
        if (!this.state.active) return;
        this.listenerCleanups.forEach((cleanup)=>cleanup());
        this.listenerCleanups = [];
        return this;
    }
    activate(activateOptions) {
        if (this.state.active) return this;
        const onActivate = this.getOption(activateOptions, "onActivate");
        const onPostActivate = this.getOption(activateOptions, "onPostActivate");
        const checkCanFocusTrap = this.getOption(activateOptions, "checkCanFocusTrap");
        if (!checkCanFocusTrap) this.updateTabbableNodes();
        this.state.active = true;
        this.state.paused = false;
        this.state.nodeFocusedBeforeActivation = (0, $2020ec4601cca401$export$cd4e5573fbe2b576)(this.doc);
        onActivate?.();
        const finishActivation = ()=>{
            if (checkCanFocusTrap) this.updateTabbableNodes();
            this.addListeners();
            this.updateObservedNodes();
            onPostActivate?.();
        };
        if (checkCanFocusTrap) {
            checkCanFocusTrap(this.state.containers.concat()).then(finishActivation, finishActivation);
            return this;
        }
        finishActivation();
        return this;
    }
};
var $ce9075a007cf2c22$var$isKeyboardEvent = (event)=>event?.type === "keydown";
var $ce9075a007cf2c22$var$isTabEvent = (event)=>$ce9075a007cf2c22$var$isKeyboardEvent(event) && event?.key === "Tab";
var $ce9075a007cf2c22$var$isKeyForward = (e)=>$ce9075a007cf2c22$var$isKeyboardEvent(e) && e.key === "Tab" && !e?.shiftKey;
var $ce9075a007cf2c22$var$isKeyBackward = (e)=>$ce9075a007cf2c22$var$isKeyboardEvent(e) && e.key === "Tab" && e?.shiftKey;
var $ce9075a007cf2c22$var$valueOrHandler = (value, ...params)=>typeof value === "function" ? value(...params) : value;
var $ce9075a007cf2c22$var$isEscapeEvent = (event)=>!event.isComposing && event.key === "Escape";
var $ce9075a007cf2c22$var$delay = (fn)=>setTimeout(fn, 0);
var $ce9075a007cf2c22$var$isSelectableInput = (node)=>node.localName === "input" && "select" in node && typeof node.select === "function";


function $a6c80f353485669d$export$bec45a54c2e66c22(el, options = {}) {
    let trap;
    const cleanup = (0, $7eacfb22d5a39e52$export$27f233d61a9e2fa4)(()=>{
        const elements = Array.isArray(el) ? el : [
            el
        ];
        const resolvedElements = elements.map((e)=>typeof e === "function" ? e() : e).filter((e)=>e != null);
        if (resolvedElements.length === 0) return;
        const primaryEl = resolvedElements[0];
        trap = new (0, $ce9075a007cf2c22$export$34eba2437817a67b)(resolvedElements, {
            escapeDeactivates: false,
            allowOutsideClick: true,
            preventScroll: true,
            returnFocusOnDeactivate: true,
            delayInitialFocus: false,
            fallbackFocus: primaryEl,
            ...options,
            document: (0, $2020ec4601cca401$export$f65ca476c09acec0)(primaryEl)
        });
        try {
            trap.activate();
        } catch  {}
    });
    return function destroy() {
        trap?.deactivate();
        cleanup();
    };
}



// src/index.ts

var $ec78083546bbc476$var$LOCK_CLASSNAME = "data-scroll-lock";
function $ec78083546bbc476$var$getPaddingProperty(documentElement) {
    const documentLeft = documentElement.getBoundingClientRect().left;
    const scrollbarX = Math.round(documentLeft) + documentElement.scrollLeft;
    return scrollbarX ? "paddingLeft" : "paddingRight";
}
function $ec78083546bbc476$var$hasStableScrollbarGutter(element) {
    const styles = (0, $8c3f3ba8f408b68b$export$3735103072e4a80)(element);
    const scrollbarGutter = styles?.scrollbarGutter;
    return scrollbarGutter === "stable" || scrollbarGutter?.startsWith("stable ") === true;
}
function $ec78083546bbc476$export$253461bf837fc8c7(_document) {
    const doc = _document ?? document;
    const win = doc.defaultView ?? window;
    const { documentElement: documentElement, body: body } = doc;
    const locked = body.hasAttribute($ec78083546bbc476$var$LOCK_CLASSNAME);
    if (locked) return;
    const hasStableGutter = $ec78083546bbc476$var$hasStableScrollbarGutter(documentElement) || $ec78083546bbc476$var$hasStableScrollbarGutter(body);
    const scrollbarWidth = win.innerWidth - documentElement.clientWidth;
    body.setAttribute($ec78083546bbc476$var$LOCK_CLASSNAME, "");
    const setScrollbarWidthProperty = ()=>(0, $7ac6bc7380fa7b77$export$36a7c0615a5a1a31)(documentElement, "--scrollbar-width", `${scrollbarWidth}px`);
    const paddingProperty = $ec78083546bbc476$var$getPaddingProperty(documentElement);
    const setBodyStyle = ()=>{
        const styles = {
            overflow: "hidden"
        };
        if (!hasStableGutter && scrollbarWidth > 0) styles[paddingProperty] = `${scrollbarWidth}px`;
        return (0, $7ac6bc7380fa7b77$export$37a5fde709c1db82)(body, styles);
    };
    const setBodyStyleIOS = ()=>{
        const { scrollX: scrollX, scrollY: scrollY, visualViewport: visualViewport } = win;
        const offsetLeft = visualViewport?.offsetLeft ?? 0;
        const offsetTop = visualViewport?.offsetTop ?? 0;
        const styles = {
            position: "fixed",
            overflow: "hidden",
            top: `${-(scrollY - Math.floor(offsetTop))}px`,
            left: `${-(scrollX - Math.floor(offsetLeft))}px`,
            right: "0"
        };
        if (!hasStableGutter && scrollbarWidth > 0) styles[paddingProperty] = `${scrollbarWidth}px`;
        const restoreStyle = (0, $7ac6bc7380fa7b77$export$37a5fde709c1db82)(body, styles);
        return ()=>{
            restoreStyle?.();
            win.scrollTo({
                left: scrollX,
                top: scrollY,
                behavior: "instant"
            });
        };
    };
    const cleanups = [
        setScrollbarWidthProperty(),
        (0, $1bdb5bdc36ac2529$export$41a665f744414057)() ? setBodyStyleIOS() : setBodyStyle()
    ];
    return ()=>{
        cleanups.forEach((fn)=>fn?.());
        body.removeAttribute($ec78083546bbc476$var$LOCK_CLASSNAME);
    };
}



var $32739a83e97153c4$export$ea56d40cd27c3480 = (0, $9aa7f39f9520657f$export$aaa7fa18f8e9b2e8)({
    props ({ props: props }) {
        return {
            closeOnInteractOutside: true,
            closeOnEscape: true,
            autoFocus: true,
            modal: false,
            portalled: true,
            restoreFocus: true,
            ...props,
            translations: {
                closeTriggerLabel: "close",
                ...props.translations
            },
            positioning: {
                placement: "bottom",
                ...props.positioning
            }
        };
    },
    initialState ({ prop: prop }) {
        const open = prop("open") || prop("defaultOpen");
        return open ? "open" : "closed";
    },
    context ({ bindable: bindable, prop: prop, scope: scope }) {
        return {
            currentPlacement: bindable(()=>({
                    defaultValue: void 0
                })),
            renderedElements: bindable(()=>({
                    defaultValue: {
                        title: true,
                        description: true
                    }
                })),
            triggerValue: bindable(()=>({
                    defaultValue: prop("defaultTriggerValue") ?? null,
                    value: prop("triggerValue"),
                    onChange (value) {
                        const onTriggerValueChange = prop("onTriggerValueChange");
                        if (!onTriggerValueChange) return;
                        const triggerElement = $5f1aa5f54f81623a$export$65278ba5d6c7842c(scope, value);
                        onTriggerValueChange({
                            value: value,
                            triggerElement: triggerElement
                        });
                    }
                }))
        };
    },
    computed: {
        currentPortalled: ({ prop: prop })=>!!prop("modal") || !!prop("portalled")
    },
    watch ({ track: track, prop: prop, action: action }) {
        track([
            ()=>prop("open")
        ], ()=>{
            action([
                "toggleVisibility"
            ]);
        });
    },
    entry: [
        "checkRenderedElements"
    ],
    on: {
        "TRIGGER_VALUE.SET": {
            actions: [
                "setTriggerValue",
                "reposition"
            ]
        }
    },
    states: {
        closed: {
            on: {
                "CONTROLLED.OPEN": {
                    target: "open",
                    actions: [
                        "setInitialFocus"
                    ]
                },
                TOGGLE: [
                    {
                        guard: "isOpenControlled",
                        actions: [
                            "invokeOnOpen",
                            "setTriggerValue"
                        ]
                    },
                    {
                        target: "open",
                        actions: [
                            "invokeOnOpen",
                            "setTriggerValue",
                            "setInitialFocus"
                        ]
                    }
                ],
                OPEN: [
                    {
                        guard: "isOpenControlled",
                        actions: [
                            "invokeOnOpen",
                            "setTriggerValue"
                        ]
                    },
                    {
                        target: "open",
                        actions: [
                            "invokeOnOpen",
                            "setTriggerValue",
                            "setInitialFocus"
                        ]
                    }
                ]
            }
        },
        open: {
            effects: [
                "trapFocus",
                "preventScroll",
                "hideContentBelow",
                "trackDismissableElement",
                "trackPositioning",
                "proxyTabFocus"
            ],
            on: {
                "CONTROLLED.CLOSE": {
                    target: "closed",
                    actions: [
                        "setFinalFocus"
                    ]
                },
                CLOSE: [
                    {
                        guard: "isOpenControlled",
                        actions: [
                            "invokeOnClose"
                        ]
                    },
                    {
                        target: "closed",
                        actions: [
                            "invokeOnClose",
                            "setFinalFocus"
                        ]
                    }
                ],
                TOGGLE: [
                    {
                        guard: "isOpenControlled",
                        actions: [
                            "invokeOnClose"
                        ]
                    },
                    {
                        target: "closed",
                        actions: [
                            "invokeOnClose"
                        ]
                    }
                ],
                "POSITIONING.SET": {
                    actions: [
                        "reposition"
                    ]
                }
            }
        }
    },
    implementations: {
        guards: {
            isOpenControlled: ({ prop: prop })=>prop("open") != void 0
        },
        effects: {
            trackPositioning ({ context: context, prop: prop, scope: scope }) {
                context.set("currentPlacement", prop("positioning").placement);
                const anchorEl = $5f1aa5f54f81623a$export$1d8a4179b7d5d63(scope);
                const getPositionerEl2 = ()=>$5f1aa5f54f81623a$export$804920e034783925(scope);
                const getTriggerEl = ()=>anchorEl ?? $5f1aa5f54f81623a$export$65278ba5d6c7842c(scope, context.get("triggerValue"));
                return (0, $21d1221b99f40370$export$a9fe23cfa43a7b55)(getTriggerEl, getPositionerEl2, {
                    ...prop("positioning"),
                    defer: true,
                    onComplete (data) {
                        context.set("currentPlacement", data.placement);
                    }
                });
            },
            trackDismissableElement ({ send: send, prop: prop, scope: scope }) {
                const getContentEl2 = ()=>$5f1aa5f54f81623a$export$64fc6550ad675c6a(scope);
                let restoreFocus = true;
                return (0, $1492ced6e5ccca82$export$72bda0e502b8ea31)(getContentEl2, {
                    type: "popover",
                    pointerBlocking: prop("modal"),
                    exclude: $5f1aa5f54f81623a$export$cb60912464303603(scope),
                    defer: true,
                    onEscapeKeyDown (event) {
                        prop("onEscapeKeyDown")?.(event);
                        if (prop("closeOnEscape")) return;
                        event.preventDefault();
                    },
                    onInteractOutside (event) {
                        prop("onInteractOutside")?.(event);
                        if (event.defaultPrevented) return;
                        restoreFocus = !(event.detail.focusable || event.detail.contextmenu);
                        if (!prop("closeOnInteractOutside")) event.preventDefault();
                    },
                    onPointerDownOutside: prop("onPointerDownOutside"),
                    onFocusOutside: prop("onFocusOutside"),
                    persistentElements: prop("persistentElements"),
                    onRequestDismiss: prop("onRequestDismiss"),
                    onDismiss () {
                        send({
                            type: "CLOSE",
                            src: "interact-outside",
                            restoreFocus: restoreFocus
                        });
                    }
                });
            },
            proxyTabFocus ({ prop: prop, scope: scope, context: context }) {
                if (prop("modal") || !prop("portalled")) return;
                const getContentEl2 = ()=>$5f1aa5f54f81623a$export$64fc6550ad675c6a(scope);
                return (0, $7b1fe2ef9c54e049$export$c90f8060ab168f84)(getContentEl2, {
                    triggerElement: $5f1aa5f54f81623a$export$65278ba5d6c7842c(scope, context.get("triggerValue")),
                    defer: true,
                    getShadowRoot: true,
                    onFocus (el) {
                        el.focus({
                            preventScroll: true
                        });
                    }
                });
            },
            hideContentBelow ({ prop: prop, scope: scope, context: context }) {
                if (!prop("modal")) return;
                const getElements = ()=>[
                        $5f1aa5f54f81623a$export$64fc6550ad675c6a(scope),
                        $5f1aa5f54f81623a$export$65278ba5d6c7842c(scope, context.get("triggerValue"))
                    ];
                return (0, $5cc784adb074ad2f$export$e1bd0c6150f13d96)(getElements, {
                    defer: true
                });
            },
            preventScroll ({ prop: prop, scope: scope }) {
                if (!prop("modal")) return;
                return (0, $ec78083546bbc476$export$253461bf837fc8c7)(scope.getDoc());
            },
            trapFocus ({ prop: prop, scope: scope, context: context }) {
                if (!prop("modal")) return;
                const contentEl = ()=>$5f1aa5f54f81623a$export$64fc6550ad675c6a(scope);
                return (0, $a6c80f353485669d$export$bec45a54c2e66c22)(contentEl, {
                    preventScroll: true,
                    returnFocusOnDeactivate: !!prop("restoreFocus"),
                    initialFocus: ()=>(0, $0fc785dfc7f02888$export$af1ff6d51ec218ea)({
                            root: $5f1aa5f54f81623a$export$64fc6550ad675c6a(scope),
                            getInitialEl: prop("initialFocusEl"),
                            enabled: prop("autoFocus")
                        }),
                    setReturnFocus: (el)=>{
                        const finalFocusEl = prop("finalFocusEl")?.();
                        if (finalFocusEl) return finalFocusEl;
                        const triggerValue = context.get("triggerValue");
                        if (triggerValue) {
                            const activeTriggerEl = $5f1aa5f54f81623a$export$65278ba5d6c7842c(scope, triggerValue);
                            if (activeTriggerEl) return activeTriggerEl;
                        }
                        const fallbackTrigger = $5f1aa5f54f81623a$export$cb60912464303603(scope)[0];
                        if (fallbackTrigger) return fallbackTrigger;
                        return el;
                    },
                    getShadowRoot: true
                });
            }
        },
        actions: {
            reposition ({ event: event, prop: prop, scope: scope, context: context }) {
                const anchorEl = $5f1aa5f54f81623a$export$1d8a4179b7d5d63(scope);
                const getPositionerEl2 = ()=>$5f1aa5f54f81623a$export$804920e034783925(scope);
                const getTriggerEl = ()=>anchorEl ?? $5f1aa5f54f81623a$export$65278ba5d6c7842c(scope, context.get("triggerValue"));
                (0, $21d1221b99f40370$export$a9fe23cfa43a7b55)(getTriggerEl, getPositionerEl2, {
                    ...prop("positioning"),
                    ...event.options,
                    defer: true,
                    listeners: false,
                    onComplete (data) {
                        context.set("currentPlacement", data.placement);
                    }
                });
            },
            setTriggerValue ({ context: context, event: event }) {
                if (event.value === void 0) return;
                context.set("triggerValue", event.value);
            },
            checkRenderedElements ({ context: context, scope: scope }) {
                (0, $7eacfb22d5a39e52$export$27f233d61a9e2fa4)(()=>{
                    Object.assign(context.get("renderedElements"), {
                        title: !!$5f1aa5f54f81623a$export$87e74ed3dcc32874(scope),
                        description: !!$5f1aa5f54f81623a$export$bfbb834a7112b099(scope)
                    });
                });
            },
            setInitialFocus ({ prop: prop, scope: scope }) {
                if (prop("modal")) return;
                (0, $7eacfb22d5a39e52$export$27f233d61a9e2fa4)(()=>{
                    const element = (0, $0fc785dfc7f02888$export$af1ff6d51ec218ea)({
                        root: $5f1aa5f54f81623a$export$64fc6550ad675c6a(scope),
                        getInitialEl: prop("initialFocusEl"),
                        enabled: prop("autoFocus")
                    });
                    element?.focus({
                        preventScroll: true
                    });
                });
            },
            setFinalFocus ({ event: event, prop: prop, scope: scope, context: context }) {
                const eventRestoreFocus = event.restoreFocus ?? event.previousEvent?.restoreFocus;
                if (eventRestoreFocus != null && !eventRestoreFocus) return;
                if (!prop("restoreFocus")) return;
                (0, $7eacfb22d5a39e52$export$27f233d61a9e2fa4)(()=>{
                    const finalFocusEl = prop("finalFocusEl")?.();
                    if (finalFocusEl) {
                        finalFocusEl.focus({
                            preventScroll: true
                        });
                        return;
                    }
                    const element = $5f1aa5f54f81623a$export$65278ba5d6c7842c(scope, context.get("triggerValue"));
                    element?.focus({
                        preventScroll: true
                    });
                });
            },
            invokeOnOpen ({ prop: prop, flush: flush }) {
                flush(()=>{
                    prop("onOpenChange")?.({
                        open: true
                    });
                });
            },
            invokeOnClose ({ prop: prop, flush: flush }) {
                flush(()=>{
                    prop("onOpenChange")?.({
                        open: false
                    });
                });
            },
            toggleVisibility ({ event: event, send: send, prop: prop }) {
                send({
                    type: prop("open") ? "CONTROLLED.OPEN" : "CONTROLLED.CLOSE",
                    previousEvent: event
                });
            }
        }
    }
});



var $8v0nu = parcelRequire("8v0nu");

"use client";
//#region src/components/popover/use-popover.ts
var $97419ccf80385baf$export$542a6fd13ac93354 = (props)=>{
    const id = (0, $8v0nu.useId)();
    const { getRootNode: getRootNode } = (0, $cfa7a900a06000ef$export$899b1e582a0b3c80)();
    const { dir: dir } = (0, $af19f2672b388a39$export$2a7b1d9f665d6730)();
    const machineProps = {
        id: id,
        dir: dir,
        getRootNode: getRootNode,
        ...props
    };
    const service = (0, $54265883fb157840$export$e0338c4153421160)($32739a83e97153c4$export$ea56d40cd27c3480, machineProps);
    return $6a83254767954ef5$export$64605811ab45167f(service, (0, $06b0a2ce147a2fe4$export$601abcd8103db5e4));
};




"use client";
//#region src/components/popover/popover-root.tsx
var $d6ee65ee1f5be619$export$bcce13685275fc99 = (props)=>{
    const [presenceProps, { children: children, ...localProps }] = (0, $efed63aa977b1a61$export$785dc0c15a64f8f7)(props);
    const popover = (0, $97419ccf80385baf$export$542a6fd13ac93354)(localProps);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $b01c4b02c8308000$export$bf694c7c431c162a), {
        value: popover,
        children: /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $a356685fe9cf7378$export$446d8ecac66007a1), {
            value: (0, $3e7c90e8656e783c$export$2a8c16d82a0a0e26)((0, $ea59bff5c9936d72$export$9d1611c77c2fe928)({
                present: popover.open
            }, presenceProps)),
            children: children
        })
    });
};








"use client";
//#region src/components/popover/popover-root-provider.tsx
var $ea4804e99cf5b169$export$ee7ce89098ff365a = (props)=>{
    const [presenceProps, { value: popover, children: children }] = (0, $efed63aa977b1a61$export$785dc0c15a64f8f7)(props);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $b01c4b02c8308000$export$bf694c7c431c162a), {
        value: popover,
        children: /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $a356685fe9cf7378$export$446d8ecac66007a1), {
            value: (0, $3e7c90e8656e783c$export$2a8c16d82a0a0e26)((0, $ea59bff5c9936d72$export$9d1611c77c2fe928)({
                present: popover.open
            }, presenceProps)),
            children: children
        })
    });
};





var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/popover/popover-title.tsx
var $473409fadfd45c66$export$67a688130f1df71 = (0, $8v0nu.forwardRef)((props, ref)=>{
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)((0, $b01c4b02c8308000$export$1468d0761b26e6c8)().getTitleProps(), props);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).div, {
        ...mergedProps,
        ref: ref
    });
});
$473409fadfd45c66$export$67a688130f1df71.displayName = "PopoverTitle";







var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/popover/popover-trigger.tsx
var $4873d993549a8609$var$splitTriggerProps = (0, $41bdb03050f91b76$export$3ea53b214fbc1986)();
var $4873d993549a8609$export$7dacb05d26466c3 = (0, $8v0nu.forwardRef)((props, ref)=>{
    const [triggerProps, localProps] = $4873d993549a8609$var$splitTriggerProps(props, [
        "value"
    ]);
    const popover = (0, $b01c4b02c8308000$export$1468d0761b26e6c8)();
    const presence = (0, $a356685fe9cf7378$export$de7b90475d798ca5)();
    const triggerPropsRaw = popover.getTriggerProps(triggerProps);
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)({
        ...triggerPropsRaw,
        "aria-controls": presence.unmounted ? void 0 : triggerPropsRaw["aria-controls"]
    }, localProps);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).button, {
        ...mergedProps,
        ref: ref
    });
});
$4873d993549a8609$export$7dacb05d26466c3.displayName = "PopoverTrigger";


//#region src/components/popover/popover.ts
var $0bbf4ad6530e4c19$export$44c22e7d77ecab12 = /* @__PURE__ */ (0, $57db88e2bf337fea$export$8126e515a7516e2)({
    Anchor: ()=>(0, $e7eedfbf148c152a$export$96e5381f42521a79),
    Arrow: ()=>(0, $522411838549558c$export$3152841115e061b2),
    ArrowTip: ()=>(0, $b2a97abe295d0b8d$export$ea3466c65b5f02ba),
    CloseTrigger: ()=>(0, $6f0ca6951e45e378$export$33040f0ac68bdc86),
    Content: ()=>(0, $012aa710447895e5$export$d7e1f420b25549ff),
    Context: ()=>(0, $5e2f51e31df521fd$export$9b9a0cd73afb7ca4),
    Description: ()=>(0, $ae56256954d68556$export$39a373e70f52f23b),
    Indicator: ()=>(0, $3e00c163eee30659$export$10a3c7e65c6f2a1f),
    Positioner: ()=>(0, $0ee7975af1d54464$export$9867a80d22e08cf4),
    Root: ()=>(0, $d6ee65ee1f5be619$export$bcce13685275fc99),
    RootProvider: ()=>(0, $ea4804e99cf5b169$export$ee7ce89098ff365a),
    Title: ()=>(0, $473409fadfd45c66$export$67a688130f1df71),
    Trigger: ()=>(0, $4873d993549a8609$export$7dacb05d26466c3)
});



"use strict";
"use client";
const { withRootProvider: $dc37cbbff4098605$var$withRootProvider, withContext: $dc37cbbff4098605$var$withContext, useStyles: $dc37cbbff4098605$export$bdabad59d033c81a, PropsProvider: $dc37cbbff4098605$var$PropsProvider } = (0, $04636a451c2392c0$export$ac7f79c9443925b8)({
    key: "popover"
});
const $dc37cbbff4098605$export$ee7ce89098ff365a = $dc37cbbff4098605$var$withRootProvider((0, $0bbf4ad6530e4c19$export$44c22e7d77ecab12).RootProvider);
const $dc37cbbff4098605$export$bcce13685275fc99 = $dc37cbbff4098605$var$withRootProvider((0, $0bbf4ad6530e4c19$export$44c22e7d77ecab12).Root);
const $dc37cbbff4098605$export$6d083edfcd2ea36d = $dc37cbbff4098605$var$PropsProvider;
const $dc37cbbff4098605$export$7dacb05d26466c3 = $dc37cbbff4098605$var$withContext((0, $0bbf4ad6530e4c19$export$44c22e7d77ecab12).Trigger, "trigger", {
    forwardAsChild: true
});
const $dc37cbbff4098605$export$9867a80d22e08cf4 = $dc37cbbff4098605$var$withContext((0, $0bbf4ad6530e4c19$export$44c22e7d77ecab12).Positioner, "positioner", {
    forwardAsChild: true
});
const $dc37cbbff4098605$export$d7e1f420b25549ff = $dc37cbbff4098605$var$withContext((0, $0bbf4ad6530e4c19$export$44c22e7d77ecab12).Content, "content", {
    forwardAsChild: true
});
const $dc37cbbff4098605$export$ea3466c65b5f02ba = $dc37cbbff4098605$var$withContext((0, $0bbf4ad6530e4c19$export$44c22e7d77ecab12).ArrowTip, "arrowTip", {
    forwardAsChild: true
});
const $dc37cbbff4098605$export$3152841115e061b2 = $dc37cbbff4098605$var$withContext((0, $0bbf4ad6530e4c19$export$44c22e7d77ecab12).Arrow, "arrow", {
    forwardAsChild: true,
    defaultProps: {
        children: /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)($dc37cbbff4098605$export$ea3466c65b5f02ba, {})
    }
});
const $dc37cbbff4098605$export$33040f0ac68bdc86 = $dc37cbbff4098605$var$withContext((0, $0bbf4ad6530e4c19$export$44c22e7d77ecab12).CloseTrigger, "closeTrigger", {
    forwardAsChild: true
});
const $dc37cbbff4098605$export$10a3c7e65c6f2a1f = $dc37cbbff4098605$var$withContext((0, $0bbf4ad6530e4c19$export$44c22e7d77ecab12).Indicator, "indicator", {
    forwardAsChild: true
});
const $dc37cbbff4098605$export$67a688130f1df71 = $dc37cbbff4098605$var$withContext((0, $0bbf4ad6530e4c19$export$44c22e7d77ecab12).Title, "title", {
    forwardAsChild: true
});
const $dc37cbbff4098605$export$39a373e70f52f23b = $dc37cbbff4098605$var$withContext((0, $0bbf4ad6530e4c19$export$44c22e7d77ecab12).Description, "description", {
    forwardAsChild: true
});
const $dc37cbbff4098605$export$18083345862c6206 = $dc37cbbff4098605$var$withContext("footer", "footer");
const $dc37cbbff4098605$export$24cbcada8f546cfe = $dc37cbbff4098605$var$withContext("header", "header");
const $dc37cbbff4098605$export$472ec417bca1d382 = $dc37cbbff4098605$var$withContext("div", "body");
const $dc37cbbff4098605$export$96e5381f42521a79 = $dc37cbbff4098605$var$withContext((0, $0bbf4ad6530e4c19$export$44c22e7d77ecab12).Anchor, void 0, {
    forwardAsChild: true
});
const $dc37cbbff4098605$export$9b9a0cd73afb7ca4 = (0, $0bbf4ad6530e4c19$export$44c22e7d77ecab12).Context;


"use strict";







var $8v0nu = parcelRequire("8v0nu");


var $31zZV = parcelRequire("31zZV");
// index.ts

function $d106280e61f380a2$export$b8b8bb64565c10e(bbox, options = {}) {
    const west = Number(bbox[0]);
    const south = Number(bbox[1]);
    const east = Number(bbox[2]);
    const north = Number(bbox[3]);
    if (bbox.length === 6) throw new Error("@turf/bbox-polygon does not support BBox with 6 positions");
    const lowLeft = [
        west,
        south
    ];
    const topLeft = [
        west,
        north
    ];
    const topRight = [
        east,
        north
    ];
    const lowRight = [
        east,
        south
    ];
    return (0, $32169f69e04c6230$export$b7b19aa0ee06c73)([
        [
            lowLeft,
            lowRight,
            topRight,
            topLeft,
            lowLeft
        ]
    ], options.properties, {
        bbox: bbox,
        id: options.id
    });
}
var $d106280e61f380a2$export$2e2bcd8739ae039 = $d106280e61f380a2$export$b8b8bb64565c10e;



const $cd2e1fccb6e85b32$var$extentOutline = {
    'line-color': '#276749',
    'line-width': 2,
    'line-dasharray': [
        2,
        2
    ]
};
const $cd2e1fccb6e85b32$var$dataOutline = {
    'line-color': '#C53030',
    'line-width': 1
};
function $cd2e1fccb6e85b32$var$CollectionMap({ collection: collection }) {
    const [map, setMap] = (0, $8v0nu.useState)();
    const setMapRef = (m)=>setMap(m);
    // Create GeoJSON polygon from extent
    const extent = (0, $8v0nu.useMemo)(()=>{
        if (!collection) return;
        const [x1, y1, x2, y2] = collection.extent.spatial.bbox[0];
        return (0, $d106280e61f380a2$export$2e2bcd8739ae039)([
            x1,
            y1,
            x2,
            y2
        ]);
    }, [
        collection
    ]);
    // Create GeoJSON Feature collection from data extents
    const dataExtents = (0, $8v0nu.useMemo)(()=>{
        if (!collection) return;
        if (collection.extent.spatial.bbox.length > 1) {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const [_, ...data] = collection.extent.spatial.bbox;
            return {
                type: 'FeatureCollection',
                features: data.map(([x1, y1, x2, y2])=>(0, $d106280e61f380a2$export$2e2bcd8739ae039)([
                        x1,
                        y1,
                        x2,
                        y2
                    ]))
            };
        }
    }, [
        collection
    ]);
    // Fit the map view around the current collection extent
    (0, $8v0nu.useEffect)(()=>{
        if (!collection || !map) return;
        const sanitized = collection.extent.spatial.bbox.map((0, $a9017d83e58866ff$export$9f1a7761e34d7c8f)).filter((b)=>b !== null);
        if (sanitized.length === 0) return;
        const bounds = new (0, $31zZV.LngLatBounds)(sanitized[0]);
        for(let i = 1; i < sanitized.length; i++){
            const [x1, y1, x2, y2] = sanitized[i];
            bounds.extend([
                x1,
                y1,
                x2,
                y2
            ]);
        }
        // maxZoom keeps a zero-area extent (a single point, e.g. a bbox like
        // [-90, 90, -90, 90]) from fitting to an absurd zoom level. Guard the
        // call so a still-degenerate extent can't take the whole app down.
        try {
            map.fitBounds(bounds, {
                padding: 30,
                duration: 0,
                maxZoom: 12
            });
        } catch (error) {
            // eslint-disable-next-line no-console
            console.warn('Unable to fit map to collection extent', error);
        }
    }, [
        collection,
        map
    ]);
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $5364b873ba521936$export$2e2bcd8739ae039), {
        ref: setMapRef,
        children: [
            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $3cdef1182cb7804b$export$2e2bcd8739ae039), {}),
            extent && /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $5364b873ba521936$export$1d2df86270c81ecb), {
                id: "extent",
                type: "geojson",
                data: extent,
                children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $5364b873ba521936$export$936d0764594b6eb3), {
                    id: "extent-line",
                    type: "line",
                    paint: $cd2e1fccb6e85b32$var$extentOutline
                })
            }),
            dataExtents && /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $5364b873ba521936$export$1d2df86270c81ecb), {
                id: "data-extent",
                type: "geojson",
                data: dataExtents,
                children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $5364b873ba521936$export$936d0764594b6eb3), {
                    id: "data-extent-line",
                    type: "line",
                    paint: $cd2e1fccb6e85b32$var$dataOutline
                })
            })
        ]
    });
}
var $cd2e1fccb6e85b32$export$2e2bcd8739ae039 = $cd2e1fccb6e85b32$var$CollectionMap;









parcelRequire("8v0nu");


function $72a6bfb38741f9f1$export$5ac124715785374c(props) {
    const { value: value = 'delete', ...rest } = props;
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $488a343786980c50$export$6831baa95aeeaf1e), {
        value: value,
        color: "danger.500",
        _hover: {
            bg: 'danger.200'
        },
        _focus: {
            bg: 'danger.200'
        },
        ...rest,
        children: [
            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9138db1f951ed55c$export$5918e8962b6636e9), {}),
            "Delete"
        ]
    });
}




const $c3fcc3bc13c840b3$var$dateFormat = {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
};
function $c3fcc3bc13c840b3$var$CollectionDetail() {
    const { collectionId: collectionId } = (0, $aa6b6e9e15323f83$export$99eaa27ddbbb95ef)();
    (0, $aec39e40387762bd$export$2e2bcd8739ae039)(`Collection ${collectionId}`);
    const { collection: collection, isLoading: isLoading } = (0, $65e1a4342c129241$export$6cd28814d92fa9c9)(collectionId);
    const { results: results, collections: collections, setCollections: setCollections, submit: submit, nextPage: nextPage, previousPage: previousPage, limit: limit } = (0, $65e1a4342c129241$export$47c1284bb8faa96)();
    // The stac search pagination is token based and has no pages, but we can fake
    // it tracking the prev and next clicks.
    const [page, setPage] = (0, $8v0nu.useState)(1);
    const onPageNavigate = (0, $8v0nu.useCallback)((actions)=>{
        if (actions === 'next') {
            setPage((prev)=>prev + 1);
            nextPage?.();
        } else {
            setPage((prev)=>prev - 1);
            previousPage?.();
        }
    }, [
        nextPage,
        previousPage
    ]);
    // Initialize the search with the current collection ID.
    //
    // We depend on `collections` so this effect re-runs and re-applies the value
    // if useStacSearch's internal state-reset (M() in stac-react v1, fires when
    // its StacApi instance changes — e.g. token-driven rebuild during initial
    // OIDC load) wipes it back to undefined. Without this, direct page loads
    // that hit a token-load remount never restore `collections`, leaving the
    // query disabled (v stays null) and no /search request goes out.
    (0, $8v0nu.useEffect)(()=>{
        if (collectionId && collections?.[0] !== collectionId) {
            setCollections([
                collectionId
            ]);
            // A (re-)applied filter means the auto-resubmit below lands on results
            // page 1, so the faked page counter must follow it — otherwise a
            // token-driven reset mid-pagination leaves "Showing page 3" over
            // page-1 results.
            setPage(1);
        }
    }, [
        collectionId,
        collections,
        setCollections
    ]);
    // Automatically submit once collections is set (or re-set after a reset).
    (0, $8v0nu.useEffect)(()=>{
        if (!collections) return;
        submit();
    }, [
        collections,
        submit
    ]);
    // Surface a non-blocking heads-up when the stored spatial extent is invalid
    // or degenerate. The map clamps such bboxes so it won't crash, but the view
    // would otherwise silently misrepresent the data.
    const bboxIssues = (0, $8v0nu.useMemo)(()=>(0, $8d719f960351be1e$export$5366d0e90f4fb990)(collection?.extent?.spatial?.bbox), [
        collection
    ]);
    const dateLabel = (0, $8v0nu.useMemo)(()=>{
        if (!collection) return;
        const [fromDate, toDate] = collection.extent.temporal.interval[0];
        const fromLabel = fromDate && new Date(fromDate).toLocaleString('en-GB', $c3fcc3bc13c840b3$var$dateFormat);
        const toLabel = toDate && new Date(toDate).toLocaleString('en-GB', $c3fcc3bc13c840b3$var$dateFormat);
        if (fromLabel && toLabel) return `${fromLabel} \u{2013} ${toLabel}`;
        if (fromLabel) return `From: ${fromLabel}`;
        if (toLabel) return `To: ${toLabel}`;
        return "\u2014";
    }, [
        collection
    ]);
    if (!collection || isLoading) return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $1415810625b263eb$export$e71c4d32a2263218), {
        p: 8,
        children: [
            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
                direction: "column",
                gap: 4,
                children: [
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $e2f153dab803da15$export$8f31e4c4a37b8e9c), {
                        h: 6,
                        maxW: "25rem"
                    }),
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $e2f153dab803da15$export$8f31e4c4a37b8e9c), {
                        h: 12,
                        maxW: "30rem"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $e2f153dab803da15$export$cb6ddd830302c2a8), {
                mt: 8,
                noOfLines: 4,
                maxW: "50rem"
            })
        ]
    });
    const { id: id, title: title, description: description, keywords: keywords, license: license } = collection;
    // STAC APIs commonly include `numberMatched` (OAFeat / OGC Features
    // convention), but stac-react v1 dropped it from the typed SearchResponse.
    // Read it off the raw response when present; otherwise hide the badge to
    // avoid showing a misleading page-size count.
    const numberMatched = results?.numberMatched;
    const pageItemsCount = results?.features?.length ?? 0;
    const totalPages = numberMatched !== undefined && limit > 0 ? Math.ceil(numberMatched / limit) : undefined;
    const shouldPaginate = (results?.links?.length ?? 0) > 1 && (!!nextPage || !!previousPage);
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
        direction: "column",
        gap: 8,
        children: [
            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $dfd76aae8c4830bc$export$644c29b44a905178), {
                overline: "Viewing Collection",
                title: title || id,
                actions: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $ef524fb144c5d632$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $43aa0a8514afe58f$export$c8d4523fa9306542), {
                            colorPalette: "primary",
                            to: `/collections/${id}/edit`,
                            children: [
                                /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9138db1f951ed55c$export$b8f31e9a5cf17074), {}),
                                "Edit"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $32db75c38a72e4b5$exports).Root, {
                            children: [
                                /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $32db75c38a72e4b5$exports).Trigger, {
                                    asChild: true,
                                    children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $756da344c07e2b07$export$c25acd513dcc8062), {
                                        "aria-label": "Options",
                                        variant: "outline",
                                        size: "md",
                                        children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9138db1f951ed55c$export$b307b75901e71920), {})
                                    })
                                }),
                                /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $25e8aada90e0332f$export$602eac185826482c), {
                                    children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $32db75c38a72e4b5$exports).Positioner, {
                                        children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $32db75c38a72e4b5$exports).Content, {
                                            children: [
                                                /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9fe47dbb44516a54$export$2b6a1f5f68a01133), {
                                                    resourcePath: `/collections/${id}`
                                                }),
                                                /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $72a6bfb38741f9f1$export$5ac124715785374c), {})
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
                direction: "column",
                gap: "8",
                as: "section",
                children: [
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
                        direction: "row",
                        px: "8",
                        gap: "8",
                        as: "header",
                        children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $1415810625b263eb$export$e71c4d32a2263218), {
                            flexBasis: "100%",
                            children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $5dcf33ee745c0ffc$export$a8a3e93435678ff9), {
                                size: "md",
                                as: "h2",
                                children: "Overview"
                            })
                        })
                    }),
                    bboxIssues.length > 0 && /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
                        mx: "8",
                        gap: "3",
                        p: "4",
                        borderRadius: "md",
                        bg: "danger.50",
                        borderWidth: "1px",
                        borderColor: "danger.200",
                        alignItems: "flex-start",
                        children: [
                            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9138db1f951ed55c$export$f72e08a2ef494448), {
                                color: "danger.500"
                            }),
                            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $1415810625b263eb$export$e71c4d32a2263218), {
                                children: [
                                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9318c0c5b8c25a88$export$5f1af8db9871e1d6), {
                                        fontWeight: "bold",
                                        color: "danger.600",
                                        children: "This collection's spatial extent looks invalid"
                                    }),
                                    bboxIssues.map((message)=>/*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9318c0c5b8c25a88$export$5f1af8db9871e1d6), {
                                            fontSize: "sm",
                                            children: message
                                        }, message)),
                                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9318c0c5b8c25a88$export$5f1af8db9871e1d6), {
                                        fontSize: "sm",
                                        color: "base.400",
                                        children: "The map may not display the extent correctly."
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $b0c5791b137f2783$export$ef2184bd89960b14), {
                        templateColumns: "repeat(12, 1fr)",
                        gap: 8,
                        children: [
                            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $ab9f2dd725a15473$export$9eb849b9b922d396), {
                                colSpan: 8,
                                children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
                                    bg: "base.50",
                                    borderRadius: "md",
                                    p: 8,
                                    direction: "column",
                                    gap: 4,
                                    minH: "100%",
                                    children: [
                                        description && /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
                                            direction: "column",
                                            gap: "2",
                                            children: [
                                                /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $5dcf33ee745c0ffc$export$a8a3e93435678ff9), {
                                                    size: "sm",
                                                    as: "h3",
                                                    children: "Description"
                                                }),
                                                /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9318c0c5b8c25a88$export$5f1af8db9871e1d6), {
                                                    children: description
                                                })
                                            ]
                                        }),
                                        dateLabel && /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
                                            direction: "column",
                                            gap: "2",
                                            children: [
                                                /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $5dcf33ee745c0ffc$export$a8a3e93435678ff9), {
                                                    size: "sm",
                                                    as: "h3",
                                                    children: "Temporal extent"
                                                }),
                                                /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9318c0c5b8c25a88$export$5f1af8db9871e1d6), {
                                                    children: dateLabel
                                                })
                                            ]
                                        }),
                                        license && /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
                                            direction: "column",
                                            gap: "2",
                                            children: [
                                                /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $5dcf33ee745c0ffc$export$a8a3e93435678ff9), {
                                                    size: "sm",
                                                    as: "h3",
                                                    children: "License"
                                                }),
                                                /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9318c0c5b8c25a88$export$5f1af8db9871e1d6), {
                                                    children: license
                                                })
                                            ]
                                        }),
                                        keywords && /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
                                            direction: "column",
                                            gap: "2",
                                            children: [
                                                /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $5dcf33ee745c0ffc$export$a8a3e93435678ff9), {
                                                    size: "sm",
                                                    as: "h3",
                                                    children: "Keywords"
                                                }),
                                                /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $16fbc3bd2b5bc884$export$15e411dc07b9c834), {
                                                    gap: 2,
                                                    children: keywords.map((keyword)=>/*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $90c39535b5b4c9ce$exports).Root, {
                                                            size: "md",
                                                            colorPalette: "primary",
                                                            children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $90c39535b5b4c9ce$exports).Label, {
                                                                children: keyword
                                                            })
                                                        }, keyword))
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $ab9f2dd725a15473$export$9eb849b9b922d396), {
                                colSpan: 4,
                                children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
                                    bg: "base.50",
                                    borderRadius: "md",
                                    p: 8,
                                    direction: "column",
                                    gap: 2,
                                    position: "relative",
                                    overflow: "hidden",
                                    height: "20rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $5dcf33ee745c0ffc$export$a8a3e93435678ff9), {
                                            size: "sm",
                                            as: "h3",
                                            children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $d1327e49e5a351f3$export$439d29a4e110a164), {
                                                children: "Spacial extent"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $1415810625b263eb$export$e71c4d32a2263218), {
                                            position: "absolute",
                                            inset: "0",
                                            children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $cd2e1fccb6e85b32$export$2e2bcd8739ae039), {
                                                collection: collection
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
                direction: "column",
                gap: "8",
                as: "section",
                children: [
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
                        direction: "row",
                        px: "8",
                        gap: "8",
                        as: "header",
                        children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $1415810625b263eb$export$e71c4d32a2263218), {
                            flexBasis: "100%",
                            children: [
                                /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $5dcf33ee745c0ffc$export$a8a3e93435678ff9), {
                                    size: "md",
                                    as: "h2",
                                    children: [
                                        "Items",
                                        ' ',
                                        numberMatched !== undefined && /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $486a1f24d187216b$export$37acb3580601e69a), {
                                            variant: "solid",
                                            children: (0, $f55c5bb8e60e90fc$export$3cdc770bf8b2ed3d)(numberMatched)
                                        })
                                    ]
                                }),
                                pageItemsCount > 0 && /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9318c0c5b8c25a88$export$5f1af8db9871e1d6), {
                                    fontSize: "sm",
                                    color: "base.400",
                                    children: totalPages ? `Showing page ${page} of ${totalPages}` : `Showing page ${page}`
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $64f958309d0faa1a$export$de97fecb6d4b30a5), {
                        gap: 8,
                        templateColumns: "repeat(auto-fill, minmax(18rem, 1fr))",
                        children: results ? results.features.map((item)=>/*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $3456399f909bb134$export$f55f1d663c7efb35), {
                                title: item.id,
                                to: `/collections/${id}/items/${item.id}`,
                                renderMenu: ()=>{
                                    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
                                        gap: 2,
                                        children: [
                                            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $32db75c38a72e4b5$exports).Root, {
                                                positioning: {
                                                    placement: 'bottom-end'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $32db75c38a72e4b5$exports).Trigger, {
                                                        asChild: true,
                                                        children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $756da344c07e2b07$export$c25acd513dcc8062), {
                                                            "aria-label": "Options",
                                                            variant: "outline",
                                                            size: "sm",
                                                            children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9138db1f951ed55c$export$b307b75901e71920), {})
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $25e8aada90e0332f$export$602eac185826482c), {
                                                        children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $32db75c38a72e4b5$exports).Positioner, {
                                                            children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $32db75c38a72e4b5$exports).Content, {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9fe47dbb44516a54$export$2b6a1f5f68a01133), {
                                                                        resourcePath: `/collections/${id}/items/${item.id}`
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $32db75c38a72e4b5$exports).Item, {
                                                                        value: "view",
                                                                        asChild: true,
                                                                        children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $78d29a24c660df8a$export$2e2bcd8739ae039), {
                                                                            to: `/collections/${id}/items/${item.id}`,
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9138db1f951ed55c$export$3b8ef319a6c5f131), {}),
                                                                                "View"
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $5cb430f47138e5f7$exports).Root, {
                                                positioning: {
                                                    placement: 'top'
                                                },
                                                lazyMount: true,
                                                children: [
                                                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $5cb430f47138e5f7$exports).Trigger, {
                                                        asChild: true,
                                                        children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $756da344c07e2b07$export$c25acd513dcc8062), {
                                                            "aria-label": "Preview",
                                                            variant: "outline",
                                                            size: "sm",
                                                            children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9138db1f951ed55c$export$5b296b74fc93300b), {})
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $25e8aada90e0332f$export$602eac185826482c), {
                                                        children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $5cb430f47138e5f7$exports).Positioner, {
                                                            children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $5cb430f47138e5f7$exports).Content, {
                                                                boxShadow: "sm",
                                                                borderColor: "base.200",
                                                                borderWidth: "2px",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $5cb430f47138e5f7$exports).Arrow, {
                                                                        children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $5cb430f47138e5f7$exports).ArrowTip, {})
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $5cb430f47138e5f7$exports).Body, {
                                                                        p: 0,
                                                                        overflow: "hidden",
                                                                        borderRadius: "md",
                                                                        children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $1415810625b263eb$export$e71c4d32a2263218), {
                                                                            h: "15rem",
                                                                            children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $854c342785fecb8e$export$a9105c4033140ee1), {
                                                                                item: item,
                                                                                reuseMaps: true
                                                                            })
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    });
                                }
                            }, item.id)) : /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $ef524fb144c5d632$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $3456399f909bb134$export$d49dc2f4fca0ae8c), {
                                    mini: true
                                }),
                                /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $3456399f909bb134$export$d49dc2f4fca0ae8c), {
                                    mini: true
                                }),
                                /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $3456399f909bb134$export$d49dc2f4fca0ae8c), {
                                    mini: true
                                })
                            ]
                        })
                    }),
                    shouldPaginate && /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
                        direction: "column",
                        alignItems: "center",
                        children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $6ef2bd114974330d$export$69b1032f2ecdf404), {
                            size: "sm",
                            variant: "outline",
                            attached: true,
                            children: [
                                /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $a987639d7be6b91e$export$353f5b6fc5456de1), {
                                    disabled: !previousPage,
                                    onClick: ()=>onPageNavigate('previous'),
                                    children: "Previous"
                                }),
                                /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $a987639d7be6b91e$export$353f5b6fc5456de1), {
                                    disabled: !nextPage,
                                    onClick: ()=>onPageNavigate('next'),
                                    children: "Next"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
var $c3fcc3bc13c840b3$export$2e2bcd8739ae039 = $c3fcc3bc13c840b3$var$CollectionDetail;



parcelRequire("8v0nu");




function $ea162eceb2783502$export$2e2bcd8739ae039() {
    (0, $aec39e40387762bd$export$2e2bcd8739ae039)('Sandbox');
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
        direction: "column",
        gap: 8,
        p: 4,
        children: [
            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $dfd76aae8c4830bc$export$644c29b44a905178), {
                overline: "Sandbox",
                title: "Sandbox"
            }),
            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
                direction: "column",
                gap: 8,
                children: [
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)("p", {
                        children: "This is the sandbox."
                    }),
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $64f958309d0faa1a$export$de97fecb6d4b30a5), {
                        gap: 8,
                        templateColumns: "repeat(auto-fill, minmax(18rem, 1fr))",
                        children: [
                            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $3456399f909bb134$export$f55f1d663c7efb35), {}),
                            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $3456399f909bb134$export$f55f1d663c7efb35), {}),
                            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $3456399f909bb134$export$f55f1d663c7efb35), {}),
                            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $3456399f909bb134$export$f55f1d663c7efb35), {})
                        ]
                    })
                ]
            })
        ]
    });
}



parcelRequire("8v0nu");


var $jTKGQ = parcelRequire("jTKGQ");

// Dev-only harness for functional/Playwright tests of WidgetJSON. Mounts the
// widget inside a Formik form with a fixed value, with no auth, no
// StacApiProvider, and no async data fetches — so the test can isolate the
// jsoneditor/Ace rendering layer from everything else.
const $1dc4026270491911$var$FIXED_VALUE = {
    type: 'Collection',
    id: 'test-collection',
    title: 'Test Collection',
    description: 'A fixture for the JSON editor functional test.',
    extent: {
        spatial: {
            bbox: [
                [
                    -180,
                    -90,
                    180,
                    90
                ]
            ]
        },
        temporal: {
            interval: [
                [
                    '2020-01-01T00:00:00Z',
                    null
                ]
            ]
        }
    },
    license: 'proprietary'
};
function $1dc4026270491911$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $1415810625b263eb$export$e71c4d32a2263218), {
        children: [
            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $5dcf33ee745c0ffc$export$a8a3e93435678ff9), {
                size: "md",
                mb: 4,
                children: "JSON Editor harness"
            }),
            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $jTKGQ.Formik), {
                enableReinitialize: true,
                initialValues: {
                    jsonData: $1dc4026270491911$var$FIXED_VALUE
                },
                onSubmit: ()=>{},
                children: ()=>/*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $1415810625b263eb$export$e71c4d32a2263218), {
                        "data-testid": "json-editor-harness",
                        children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $5d31050dffea9ad7$export$28f0f0b6ca7da3eb), {
                            field: {
                                type: 'json',
                                label: 'Json Document'
                            },
                            pointer: "jsonData"
                        })
                    })
            })
        ]
    });
}




const $abca8739d4d09600$var$rotate = (0, $4968c539ba80adb3$export$d25ddfdf17c3ad3e)`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;
const $abca8739d4d09600$var$rotate2 = (0, $4968c539ba80adb3$export$d25ddfdf17c3ad3e)`
  from {
    transform: rotate(22.5deg);
  }
  to {
    transform: rotate(382.5deg);
  }
`;
function $abca8739d4d09600$export$86fbec116b87613f() {
    const { isLoading: isLoading } = (0, $c837ac9c698038bc$export$1d39dc5b47e56ff0)();
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $ef524fb144c5d632$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $f1f51be609a91d37$export$3ae376d12526dd6f), {
                children: isLoading && /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $43985e09e2ba1586$export$e25e478948902b8b).div, {
                    initial: {
                        opacity: 0
                    },
                    animate: {
                        opacity: 1
                    },
                    exit: {
                        opacity: 0
                    },
                    children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
                        minW: "100vw",
                        minH: "100vh",
                        bg: "white",
                        align: "center",
                        justify: "center",
                        children: [
                            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9138db1f951ed55c$export$4073c4c5b5a233d4), {
                                boxSize: "5em",
                                color: "base.300",
                                animation: `${$abca8739d4d09600$var$rotate} 4s linear infinite`
                            }),
                            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9138db1f951ed55c$export$4073c4c5b5a233d4), {
                                ml: -2,
                                boxSize: "5em",
                                color: "base.300",
                                animation: `${$abca8739d4d09600$var$rotate2} 4s linear infinite reverse`
                            })
                        ]
                    })
                })
            }),
            !isLoading && /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $655f1686b6512ed9$export$42a852a2b6b56249), {
                maxW: "7xl",
                minH: "100vh",
                display: "flex",
                flexDirection: "column",
                gap: 4,
                children: [
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
                        as: "header",
                        gap: 4,
                        alignItems: "center",
                        justifyContent: "space-between",
                        py: 8,
                        children: [
                            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
                                gap: 4,
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $b3ebe15a85950994$export$3e431a229df88919), {
                                        src: `${"/".replace(/\/+$/, '')}/meta/icon-512.png`,
                                        width: 8,
                                        aspectRatio: 1,
                                        borderRadius: "md"
                                    }),
                                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $01474eb65f0b7d4e$export$1ff3c3f08ae963c0), {
                                        orientation: "vertical",
                                        borderColor: "base.200a",
                                        h: "1rem",
                                        borderLeftWidth: "2px"
                                    }),
                                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $5dcf33ee745c0ffc$export$a8a3e93435678ff9), {
                                        as: "p",
                                        size: "sm",
                                        children: "STAC Manager"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $e206030315a52ed9$export$2e2bcd8739ae039), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $1415810625b263eb$export$e71c4d32a2263218), {
                        as: "main",
                        children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $aa6b6e9e15323f83$export$3565eb3d00ca5a74), {
                            children: [
                                /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $aa6b6e9e15323f83$export$e7b0ac011bb776c6), {
                                    path: "/",
                                    element: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $d26150280087d264$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $aa6b6e9e15323f83$export$e7b0ac011bb776c6), {
                                    path: "/collections/",
                                    element: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $16109d62536d0cfb$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $aa6b6e9e15323f83$export$e7b0ac011bb776c6), {
                                    path: "/collections/new/",
                                    element: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $ab8658d5c674cf12$export$8ef2ed426dede42d), {
                                        Component: (0, $d8d64c35e07ebf83$export$9fbdb99242c1b155)
                                    })
                                }),
                                /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $aa6b6e9e15323f83$export$e7b0ac011bb776c6), {
                                    path: "/collections/:collectionId/",
                                    element: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $c3fcc3bc13c840b3$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $aa6b6e9e15323f83$export$e7b0ac011bb776c6), {
                                    path: "/collections/:collectionId/edit/",
                                    element: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $ab8658d5c674cf12$export$8ef2ed426dede42d), {
                                        Component: (0, $d8d64c35e07ebf83$export$9fbdb99242c1b155)
                                    })
                                }),
                                /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $aa6b6e9e15323f83$export$e7b0ac011bb776c6), {
                                    path: "/collections/:collectionId/items/:itemId/",
                                    element: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $943c638232d86618$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $aa6b6e9e15323f83$export$e7b0ac011bb776c6), {
                                    path: "/sandbox",
                                    element: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $ea162eceb2783502$export$2e2bcd8739ae039), {})
                                }),
                                false,
                                /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $aa6b6e9e15323f83$export$e7b0ac011bb776c6), {
                                    path: "*",
                                    element: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $8027973e38821351$export$2e2bcd8739ae039), {})
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)($abca8739d4d09600$var$AppFooter, {})
                ]
            })
        ]
    });
}
function $abca8739d4d09600$var$AppFooter() {
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
        as: "footer",
        gap: 4,
        alignItems: "center",
        justifyContent: "space-between",
        mt: "auto",
        p: 4,
        children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
            gap: 4,
            alignItems: "center",
            width: "100%",
            children: [
                /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $9318c0c5b8c25a88$export$5f1af8db9871e1d6), {
                    as: "span",
                    children: [
                        "Powered by",
                        ' ',
                        /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)("strong", {
                            children: [
                                "STAC Manager",
                                ' ',
                                /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $486a1f24d187216b$export$37acb3580601e69a), {
                                    bg: "base.400a",
                                    color: "surface.500",
                                    px: "0.375rem",
                                    children: "fix/bbox-validation"
                                })
                            ]
                        }),
                        ' '
                    ]
                }),
                /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $01474eb65f0b7d4e$export$1ff3c3f08ae963c0), {
                    orientation: "vertical",
                    borderColor: "base.200a",
                    h: "1em"
                }),
                new Date().getFullYear(),
                /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $9318c0c5b8c25a88$export$5f1af8db9871e1d6), {
                    as: "span",
                    ml: "auto",
                    children: [
                        "Made with ",
                        /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9138db1f951ed55c$export$3094a1b9f32c68d5), {
                            meaningful: true,
                            title: "love"
                        }),
                        " by",
                        ' ',
                        /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $78d29a24c660df8a$export$2e2bcd8739ae039), {
                            to: "https://developmentseed.org",
                            color: "inherit",
                            children: "Development Seed"
                        }),
                        "."
                    ]
                })
            ]
        })
    });
}


// src/index.ts
var $95df779b5bd42a09$var$userGeneratedStr = "";
var $95df779b5bd42a09$var$userGenerated = $95df779b5bd42a09$var$userGeneratedStr.split(",");
var $95df779b5bd42a09$var$cssPropertiesStr = "WebkitAppearance,WebkitBorderBefore,WebkitBorderBeforeColor,WebkitBorderBeforeStyle,WebkitBorderBeforeWidth,WebkitBoxReflect,WebkitLineClamp,WebkitMask,WebkitMaskAttachment,WebkitMaskClip,WebkitMaskComposite,WebkitMaskImage,WebkitMaskOrigin,WebkitMaskPosition,WebkitMaskPositionX,WebkitMaskPositionY,WebkitMaskRepeat,WebkitMaskRepeatX,WebkitMaskRepeatY,WebkitMaskSize,WebkitOverflowScrolling,WebkitTapHighlightColor,WebkitTextFillColor,WebkitTextStroke,WebkitTextStrokeColor,WebkitTextStrokeWidth,WebkitTouchCallout,WebkitUserModify,WebkitUserSelect,accentColor,alignContent,alignItems,alignSelf,alignTracks,all,anchorName,anchorScope,animation,animationComposition,animationDelay,animationDirection,animationDuration,animationFillMode,animationIterationCount,animationName,animationPlayState,animationRange,animationRangeEnd,animationRangeStart,animationTimeline,animationTimingFunction,appearance,aspectRatio,backdropFilter,backfaceVisibility,background,backgroundAttachment,backgroundBlendMode,backgroundClip,backgroundColor,backgroundImage,backgroundOrigin,backgroundPosition,backgroundPositionX,backgroundPositionY,backgroundRepeat,backgroundSize,blockSize,border,borderBlock,borderBlockColor,borderBlockEnd,borderBlockEndColor,borderBlockEndStyle,borderBlockEndWidth,borderBlockStart,borderBlockStartColor,borderBlockStartStyle,borderBlockStartWidth,borderBlockStyle,borderBlockWidth,borderBottom,borderBottomColor,borderBottomLeftRadius,borderBottomRightRadius,borderBottomStyle,borderBottomWidth,borderCollapse,borderColor,borderEndEndRadius,borderEndStartRadius,borderImage,borderImageOutset,borderImageRepeat,borderImageSlice,borderImageSource,borderImageWidth,borderInline,borderInlineColor,borderInlineEnd,borderInlineEndColor,borderInlineEndStyle,borderInlineEndWidth,borderInlineStart,borderInlineStartColor,borderInlineStartStyle,borderInlineStartWidth,borderInlineStyle,borderInlineWidth,borderLeft,borderLeftColor,borderLeftStyle,borderLeftWidth,borderRadius,borderRight,borderRightColor,borderRightStyle,borderRightWidth,borderSpacing,borderStartEndRadius,borderStartStartRadius,borderStyle,borderTop,borderTopColor,borderTopLeftRadius,borderTopRightRadius,borderTopStyle,borderTopWidth,borderWidth,bottom,boxAlign,boxDecorationBreak,boxDirection,boxFlex,boxFlexGroup,boxLines,boxOrdinalGroup,boxOrient,boxPack,boxShadow,boxSizing,breakAfter,breakBefore,breakInside,captionSide,caret,caretColor,caretShape,clear,clip,clipPath,clipRule,color,colorInterpolationFilters,colorScheme,columnCount,columnFill,columnGap,columnRule,columnRuleColor,columnRuleStyle,columnRuleWidth,columnSpan,columnWidth,columns,contain,containIntrinsicBlockSize,containIntrinsicHeight,containIntrinsicInlineSize,containIntrinsicSize,containIntrinsicWidth,container,containerName,containerType,content,contentVisibility,cornerShape,counterIncrement,counterReset,counterSet,cursor,cx,cy,d,direction,display,dominantBaseline,emptyCells,fieldSizing,fill,fillOpacity,fillRule,filter,flex,flexBasis,flexDirection,flexFlow,flexGrow,flexShrink,flexWrap,float,floodColor,floodOpacity,font,fontFamily,fontFeatureSettings,fontKerning,fontLanguageOverride,fontOpticalSizing,fontPalette,fontSize,fontSizeAdjust,fontSmooth,fontStretch,fontStyle,fontSynthesis,fontSynthesisPosition,fontSynthesisSmallCaps,fontSynthesisStyle,fontSynthesisWeight,fontVariant,fontVariantAlternates,fontVariantCaps,fontVariantEastAsian,fontVariantEmoji,fontVariantLigatures,fontVariantNumeric,fontVariantPosition,fontVariationSettings,fontWeight,forcedColorAdjust,gap,grid,gridArea,gridAutoColumns,gridAutoFlow,gridAutoRows,gridColumn,gridColumnEnd,gridColumnGap,gridColumnStart,gridGap,gridRow,gridRowEnd,gridRowGap,gridRowStart,gridTemplate,gridTemplateAreas,gridTemplateColumns,gridTemplateRows,hangingPunctuation,height,hyphenateCharacter,hyphenateLimitChars,hyphens,imageOrientation,imageRendering,imageResolution,imeMode,initialLetter,initialLetterAlign,inlineSize,inset,insetBlock,insetBlockEnd,insetBlockStart,insetInline,insetInlineEnd,insetInlineStart,interpolateSize,isolation,justifyContent,justifyItems,justifySelf,justifyTracks,left,letterSpacing,lightingColor,lineBreak,lineClamp,lineHeight,lineHeightStep,listStyle,listStyleImage,listStylePosition,listStyleType,margin,marginBlock,marginBlockEnd,marginBlockStart,marginBottom,marginInline,marginInlineEnd,marginInlineStart,marginLeft,marginRight,marginTop,marginTrim,marker,markerEnd,markerMid,markerStart,mask,maskBorder,maskBorderMode,maskBorderOutset,maskBorderRepeat,maskBorderSlice,maskBorderSource,maskBorderWidth,maskClip,maskComposite,maskImage,maskMode,maskOrigin,maskPosition,maskRepeat,maskSize,maskType,masonryAutoFlow,mathDepth,mathShift,mathStyle,maxBlockSize,maxHeight,maxInlineSize,maxLines,maxWidth,minBlockSize,minHeight,minInlineSize,minWidth,mixBlendMode,objectFit,objectPosition,offset,offsetAnchor,offsetDistance,offsetPath,offsetPosition,offsetRotate,opacity,order,orphans,outline,outlineColor,outlineOffset,outlineStyle,outlineWidth,overflow,overflowAnchor,overflowBlock,overflowClipBox,overflowClipMargin,overflowInline,overflowWrap,overflowX,overflowY,overlay,overscrollBehavior,overscrollBehaviorBlock,overscrollBehaviorInline,overscrollBehaviorX,overscrollBehaviorY,padding,paddingBlock,paddingBlockEnd,paddingBlockStart,paddingBottom,paddingInline,paddingInlineEnd,paddingInlineStart,paddingLeft,paddingRight,paddingTop,page,pageBreakAfter,pageBreakBefore,pageBreakInside,paintOrder,perspective,perspectiveOrigin,placeContent,placeItems,placeSelf,pointerEvents,position,positionAnchor,positionArea,positionTry,positionTryFallbacks,positionTryOrder,positionVisibility,printColorAdjust,quotes,r,resize,right,rotate,rowGap,rubyAlign,rubyMerge,rubyPosition,rx,ry,scale,scrollBehavior,scrollMargin,scrollMarginBlock,scrollMarginBlockEnd,scrollMarginBlockStart,scrollMarginBottom,scrollMarginInline,scrollMarginInlineEnd,scrollMarginInlineStart,scrollMarginLeft,scrollMarginRight,scrollMarginTop,scrollPadding,scrollPaddingBlock,scrollPaddingBlockEnd,scrollPaddingBlockStart,scrollPaddingBottom,scrollPaddingInline,scrollPaddingInlineEnd,scrollPaddingInlineStart,scrollPaddingLeft,scrollPaddingRight,scrollPaddingTop,scrollSnapAlign,scrollSnapCoordinate,scrollSnapDestination,scrollSnapPointsX,scrollSnapPointsY,scrollSnapStop,scrollSnapType,scrollSnapTypeX,scrollSnapTypeY,scrollTimeline,scrollTimelineAxis,scrollTimelineName,scrollbarColor,scrollbarGutter,scrollbarWidth,shapeImageThreshold,shapeMargin,shapeOutside,shapeRendering,stopColor,stopOpacity,stroke,strokeDasharray,strokeDashoffset,strokeLinecap,strokeLinejoin,strokeMiterlimit,strokeOpacity,strokeWidth,tabSize,tableLayout,textAlign,textAlignLast,textAnchor,textBox,textBoxEdge,textBoxTrim,textCombineUpright,textDecoration,textDecorationColor,textDecorationLine,textDecorationSkip,textDecorationSkipInk,textDecorationStyle,textDecorationThickness,textEmphasis,textEmphasisColor,textEmphasisPosition,textEmphasisStyle,textIndent,textJustify,textOrientation,textOverflow,textRendering,textShadow,textSizeAdjust,textSpacingTrim,textTransform,textUnderlineOffset,textUnderlinePosition,textWrap,textWrapMode,textWrapStyle,timelineScope,top,touchAction,transform,transformBox,transformOrigin,transformStyle,transition,transitionBehavior,transitionDelay,transitionDuration,transitionProperty,transitionTimingFunction,translate,unicodeBidi,userSelect,vectorEffect,verticalAlign,viewTimeline,viewTimelineAxis,viewTimelineInset,viewTimelineName,viewTransitionName,visibility,whiteSpace,whiteSpaceCollapse,widows,width,willChange,wordBreak,wordSpacing,wordWrap,writingMode,x,y,zIndex,zoom,alignmentBaseline,baselineShift,colorInterpolation,colorRendering,glyphOrientationVertical";
var $95df779b5bd42a09$export$e22b134a0d53ed0a = $95df779b5bd42a09$var$cssPropertiesStr.split(",").concat($95df779b5bd42a09$var$userGenerated);
var $95df779b5bd42a09$var$properties = new Map($95df779b5bd42a09$export$e22b134a0d53ed0a.map((prop)=>[
        prop,
        true
    ]));
function $95df779b5bd42a09$var$memo(fn) {
    const cache = /* @__PURE__ */ Object.create(null);
    return (arg)=>{
        if (cache[arg] === void 0) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $95df779b5bd42a09$var$cssPropertySelectorRegex = /&|@/;
var $95df779b5bd42a09$export$74465ce51e034ce6 = /* @__PURE__ */ $95df779b5bd42a09$var$memo((prop)=>{
    return $95df779b5bd42a09$var$properties.has(prop) || prop.startsWith("--") || $95df779b5bd42a09$var$cssPropertySelectorRegex.test(prop);
});



"use strict";
function $9024565373fe4cd0$export$592ef47eabb05614(obj, f) {
    const result = {};
    for(const key in obj){
        const kv = f(key, obj[key]);
        result[kv[0]] = kv[1];
    }
    return result;
}



"use strict";
function $507626d6ae9c4a68$export$bffa455ba8c619a6(values, stop) {
    const result = {};
    (0, $73e475e2b22cc1e3$export$915658b6215945a4)(values, (token, paths)=>{
        if (token) result[paths.join(".")] = token.value;
    }, {
        stop: stop
    });
    return result;
}



"use strict";
var $17d2a907250d4d6f$var$__defProp = Object.defineProperty;
var $17d2a907250d4d6f$var$__defNormalProp = (obj, key, value)=>key in obj ? $17d2a907250d4d6f$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $17d2a907250d4d6f$var$__publicField = (obj, key, value)=>$17d2a907250d4d6f$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
function $17d2a907250d4d6f$var$simpleHash(value) {
    if (value === null) return "null";
    if (value === void 0) return "undefined";
    const type = typeof value;
    if (type === "string") return `s:${value}`;
    if (type === "number") return `n:${value}`;
    if (type === "boolean") return `b:${value}`;
    if (type === "function") return `f:${value.name || "anonymous"}`;
    if (Array.isArray(value)) return `a:[${value.map($17d2a907250d4d6f$var$simpleHash).join(",")}]`;
    if (type === "object") {
        const keys = Object.keys(value).sort();
        return `o:{${keys.map((k)=>`${k}:${$17d2a907250d4d6f$var$simpleHash(value[k])}`).join(",")}}`;
    }
    return String(value);
}
class $17d2a907250d4d6f$var$LRUCache {
    constructor(maxSize = 500){
        $17d2a907250d4d6f$var$__publicField(this, "cache", /* @__PURE__ */ new Map());
        $17d2a907250d4d6f$var$__publicField(this, "maxSize");
        this.maxSize = maxSize;
    }
    get(key) {
        const value = this.cache.get(key);
        if (value !== void 0) {
            this.cache.delete(key);
            this.cache.set(key, value);
        }
        return value;
    }
    set(key, value) {
        if (this.cache.has(key)) this.cache.delete(key);
        else if (this.cache.size >= this.maxSize) {
            const firstKey = this.cache.keys().next().value;
            if (firstKey !== void 0) this.cache.delete(firstKey);
        }
        this.cache.set(key, value);
    }
    clear() {
        this.cache.clear();
    }
}
const $17d2a907250d4d6f$export$7c73462e0d25e514 = (fn)=>{
    const cache = new $17d2a907250d4d6f$var$LRUCache();
    function get(...args) {
        const key = args.length === 1 ? $17d2a907250d4d6f$var$simpleHash(args[0]) : args.map($17d2a907250d4d6f$var$simpleHash).join("|");
        let result = cache.get(key);
        if (result === void 0) {
            result = fn.apply(this, args);
            cache.set(key, result);
        }
        return result;
    }
    return get;
};



"use strict";
function $3f37eeec613ba395$var$merge(target, source) {
    if (source == null) return target;
    for (const key of Object.keys(source)){
        if (source[key] === void 0 || key === "__proto__") continue;
        if (!(0, $02f5f697eb6a66a5$export$a6cdc56e425d0d0a)(target[key]) && (0, $02f5f697eb6a66a5$export$a6cdc56e425d0d0a)(source[key])) Object.assign(target, {
            [key]: source[key]
        });
        else if (target[key] && (0, $02f5f697eb6a66a5$export$a6cdc56e425d0d0a)(source[key])) $3f37eeec613ba395$var$merge(target[key], source[key]);
        else if (Array.isArray(source[key]) && Array.isArray(target[key])) {
            let i = 0;
            for(; i < source[key].length; i++)if ((0, $02f5f697eb6a66a5$export$a6cdc56e425d0d0a)(target[key][i]) && (0, $02f5f697eb6a66a5$export$a6cdc56e425d0d0a)(source[key][i])) $3f37eeec613ba395$var$merge(target[key][i], source[key][i]);
            else target[key][i] = source[key][i];
        } else Object.assign(target, {
            [key]: source[key]
        });
    }
    return target;
}
function $3f37eeec613ba395$export$2ee76fde9ffe109d(target, ...sources) {
    for (const source of sources)$3f37eeec613ba395$var$merge(target, source);
    return target;
}




"use strict";
const $0d8ecfa47c1a9d05$var$BASE_FONT_SIZE = 16;
const $0d8ecfa47c1a9d05$var$UNIT_PX = "px";
const $0d8ecfa47c1a9d05$var$UNIT_EM = "em";
const $0d8ecfa47c1a9d05$var$UNIT_REM = "rem";
function $0d8ecfa47c1a9d05$export$65f2564e9a9b9222(value = "") {
    const DIGIT_REGEX = new RegExp(String.raw`-?\d+(?:\.\d+|\d*)`);
    const UNIT_REGEX = new RegExp(`${$0d8ecfa47c1a9d05$var$UNIT_PX}|${$0d8ecfa47c1a9d05$var$UNIT_EM}|${$0d8ecfa47c1a9d05$var$UNIT_REM}`);
    const unit = value.match(new RegExp(`${DIGIT_REGEX.source}(${UNIT_REGEX.source})`));
    return unit?.[1];
}
function $0d8ecfa47c1a9d05$export$6562491d7413c9c9(value = "") {
    if (typeof value === "number") return `${value}px`;
    const unit = $0d8ecfa47c1a9d05$export$65f2564e9a9b9222(value);
    if (!unit) return value;
    if (unit === $0d8ecfa47c1a9d05$var$UNIT_PX) return value;
    if (unit === $0d8ecfa47c1a9d05$var$UNIT_EM || unit === $0d8ecfa47c1a9d05$var$UNIT_REM) return `${parseFloat(value) * $0d8ecfa47c1a9d05$var$BASE_FONT_SIZE}${$0d8ecfa47c1a9d05$var$UNIT_PX}`;
}
function $0d8ecfa47c1a9d05$export$6a029509daffbde8(value = "", fontSize = $0d8ecfa47c1a9d05$var$BASE_FONT_SIZE) {
    const unit = $0d8ecfa47c1a9d05$export$65f2564e9a9b9222(value);
    if (!unit) return value;
    if (unit === $0d8ecfa47c1a9d05$var$UNIT_EM) return value;
    if (unit === $0d8ecfa47c1a9d05$var$UNIT_PX) return `${parseFloat(value) / fontSize}${$0d8ecfa47c1a9d05$var$UNIT_EM}`;
    if (unit === $0d8ecfa47c1a9d05$var$UNIT_REM) return `${parseFloat(value) * $0d8ecfa47c1a9d05$var$BASE_FONT_SIZE / fontSize}${$0d8ecfa47c1a9d05$var$UNIT_EM}`;
}
function $0d8ecfa47c1a9d05$export$9aee8eecd1073da1(value = "") {
    const unit = $0d8ecfa47c1a9d05$export$65f2564e9a9b9222(value);
    if (!unit) return value;
    if (unit === $0d8ecfa47c1a9d05$var$UNIT_REM) return value;
    if (unit === $0d8ecfa47c1a9d05$var$UNIT_EM) return `${parseFloat(value)}${$0d8ecfa47c1a9d05$var$UNIT_REM}`;
    if (unit === $0d8ecfa47c1a9d05$var$UNIT_PX) return `${parseFloat(value) / $0d8ecfa47c1a9d05$var$BASE_FONT_SIZE}${$0d8ecfa47c1a9d05$var$UNIT_REM}`;
}


"use strict";
const $2f77fb784172d9f3$var$capitalize = (str)=>str.charAt(0).toUpperCase() + str.slice(1);
function $2f77fb784172d9f3$export$79e1df82cbbff4e9(breakpoints) {
    const sorted = $2f77fb784172d9f3$var$sort(breakpoints);
    const values = Object.fromEntries(sorted);
    function get(name) {
        return values[name];
    }
    function only(name) {
        return $2f77fb784172d9f3$var$build(get(name));
    }
    function getRanges() {
        const breakpoints2 = Object.keys(values);
        const permuations = $2f77fb784172d9f3$var$getPermutations(breakpoints2);
        const results = breakpoints2.flatMap((name)=>{
            const value = get(name);
            const down2 = [
                `${name}Down`,
                $2f77fb784172d9f3$var$build({
                    max: $2f77fb784172d9f3$var$adjust(value.min)
                })
            ];
            const up2 = [
                name,
                $2f77fb784172d9f3$var$build({
                    min: value.min
                })
            ];
            const _only = [
                `${name}Only`,
                only(name)
            ];
            return [
                up2,
                _only,
                down2
            ];
        }).filter(([, value])=>value !== "").concat(permuations.map(([min, max])=>{
            const minValue = get(min);
            const maxValue = get(max);
            return [
                `${min}To${$2f77fb784172d9f3$var$capitalize(max)}`,
                $2f77fb784172d9f3$var$build({
                    min: minValue.min,
                    max: $2f77fb784172d9f3$var$adjust(maxValue.min)
                })
            ];
        }));
        return Object.fromEntries(results);
    }
    function toConditions() {
        const ranges = getRanges();
        return Object.fromEntries(Object.entries(ranges));
    }
    const conditions = toConditions();
    const getCondition = (key)=>{
        return conditions[key];
    };
    function keys() {
        return (0, $a9ab35ecde99cc3b$export$f70730c3d1fc524e)([
            "base",
            ...Object.keys(values)
        ]);
    }
    function up(name) {
        return $2f77fb784172d9f3$var$build({
            min: get(name).min
        });
    }
    function down(name) {
        return $2f77fb784172d9f3$var$build({
            max: $2f77fb784172d9f3$var$adjust(get(name).min)
        });
    }
    return {
        values: Object.values(values),
        only: only,
        keys: keys,
        conditions: conditions,
        getCondition: getCondition,
        up: up,
        down: down
    };
}
function $2f77fb784172d9f3$var$adjust(value) {
    const computedMax = parseFloat((0, $0d8ecfa47c1a9d05$export$6562491d7413c9c9)(value) ?? "") - 0.04;
    return (0, $0d8ecfa47c1a9d05$export$9aee8eecd1073da1)(`${computedMax}px`);
}
function $2f77fb784172d9f3$var$sort(breakpoints) {
    const entries = Object.entries(breakpoints).sort(([, minA], [, minB])=>{
        return parseInt(minA, 10) < parseInt(minB, 10) ? -1 : 1;
    });
    return entries.map(([name, min], index, entries2)=>{
        let max = null;
        if (index <= entries2.length - 1) max = entries2[index + 1]?.[1];
        if (max != null) max = $2f77fb784172d9f3$var$adjust(max);
        return [
            name,
            {
                name: name,
                min: (0, $0d8ecfa47c1a9d05$export$9aee8eecd1073da1)(min),
                max: max
            }
        ];
    });
}
function $2f77fb784172d9f3$var$getPermutations(values) {
    const result = [];
    values.forEach((current, index)=>{
        let idx = index;
        idx++;
        let next = values[idx];
        while(next){
            result.push([
                current,
                next
            ]);
            idx++;
            next = values[idx];
        }
    });
    return result;
}
function $2f77fb784172d9f3$var$build({ min: min, max: max }) {
    if (min == null && max == null) return "";
    return [
        "@media screen",
        min && `(min-width: ${min})`,
        max && `(max-width: ${max})`
    ].filter(Boolean).join(" and ");
}




"use strict";
const $bb84a850d0d15696$var$SPECIAL_KEY_REGEX = /^@|&|&$/;
const $bb84a850d0d15696$export$4841b94afe59a0cf = (options)=>{
    const { breakpoints: breakpoints, conditions: conds = {} } = options;
    const conditions = (0, $9024565373fe4cd0$export$592ef47eabb05614)(conds, (key, value)=>[
            `_${key}`,
            value
        ]);
    const values = Object.assign({}, conditions, breakpoints.conditions);
    function keys() {
        return Object.keys(values);
    }
    function has(key) {
        return keys().includes(key) || $bb84a850d0d15696$var$SPECIAL_KEY_REGEX.test(key) || key.startsWith("_");
    }
    const sort = (0, $17d2a907250d4d6f$export$7c73462e0d25e514)((paths)=>{
        return paths.filter((v)=>v !== "base").sort((a, b)=>{
            const aa = has(a);
            const bb = has(b);
            if (aa && !bb) return 1;
            if (!aa && bb) return -1;
            return 0;
        });
    });
    function expandAtRule(key) {
        if (!key.startsWith("@breakpoint")) return key;
        return breakpoints.getCondition(key.replace("@breakpoint ", ""));
    }
    function resolve(key) {
        return Reflect.get(values, key) || key;
    }
    return {
        keys: keys,
        sort: sort,
        has: has,
        resolve: resolve,
        breakpoints: breakpoints.keys(),
        expandAtRule: expandAtRule
    };
};


"use strict";
function $895b3f47f22a1406$export$9cd59f9826255e47(obj) {
    if (obj === null || typeof obj !== "object") return obj;
    if (Array.isArray(obj)) return obj.map((prop)=>$895b3f47f22a1406$export$9cd59f9826255e47(prop));
    const _clone = Object.create(Object.getPrototypeOf(obj));
    for (const key of Object.keys(obj))_clone[key] = $895b3f47f22a1406$export$9cd59f9826255e47(obj[key]);
    return _clone;
}




"use strict";
const $e640443c3aa20e5d$var$tokenKeys = [
    "value",
    "type",
    "description"
];
const $e640443c3aa20e5d$var$isValidToken = (token)=>{
    return token && typeof token === "object" && !Array.isArray(token);
};
const $e640443c3aa20e5d$export$5d86b86a654a7039 = (...configs)=>{
    const merged = (0, $3f37eeec613ba395$export$2ee76fde9ffe109d)({}, ...configs.map((0, $895b3f47f22a1406$export$9cd59f9826255e47)));
    if (merged.theme?.tokens) (0, $73e475e2b22cc1e3$export$915658b6215945a4)(merged.theme.tokens, (value)=>{
        const keys = Object.keys(value);
        const nestedKeys = keys.filter((k)=>!$e640443c3aa20e5d$var$tokenKeys.includes(k));
        const hasNested = nestedKeys.length > 0;
        const hasTokenProps = $e640443c3aa20e5d$var$tokenKeys.some((k)=>value[k] != null);
        if (hasNested && hasTokenProps) {
            value.DEFAULT || (value.DEFAULT = {});
            $e640443c3aa20e5d$var$tokenKeys.forEach((key)=>{
                var _a;
                if (value[key] == null) return;
                (_a = value.DEFAULT)[key] || (_a[key] = value[key]);
                delete value[key];
            });
        }
        return value;
    }, {
        stop (value) {
            return $e640443c3aa20e5d$var$isValidToken(value) && Object.keys(value).some((k)=>$e640443c3aa20e5d$var$tokenKeys.includes(k) || k !== k.toLowerCase() && k !== k.toUpperCase());
        }
    });
    return merged;
};







"use strict";
const $a100815930a659d0$export$253fab909bb52269 = Object.freeze(/* @__PURE__ */ Object.create(null));
const $a100815930a659d0$export$2c66e96878bf4792 = Object.freeze([]);
function $a100815930a659d0$export$a72db9a51bf349f7() {
    return /* @__PURE__ */ Object.create(null);
}
function $a100815930a659d0$export$58e25551d636bf09(mutable = false) {
    return mutable ? $a100815930a659d0$export$a72db9a51bf349f7() : $a100815930a659d0$export$253fab909bb52269;
}




"use strict";
const $c1da3be54c1d434a$var$createMediaQueryRegex = (dimension)=>({
        minMax: new RegExp(`(!?\\(\\s*min(-device-)?-${dimension})(.|
)+\\(\\s*max(-device)?-${dimension}`, "i"),
        min: new RegExp(`\\(\\s*min(-device)?-${dimension}`, "i"),
        maxMin: new RegExp(`(!?\\(\\s*max(-device)?-${dimension})(.|
)+\\(\\s*min(-device)?-${dimension}`, "i"),
        max: new RegExp(`\\(\\s*max(-device)?-${dimension}`, "i")
    });
const $c1da3be54c1d434a$var$widthRegex = $c1da3be54c1d434a$var$createMediaQueryRegex("width");
const $c1da3be54c1d434a$var$heightRegex = $c1da3be54c1d434a$var$createMediaQueryRegex("height");
const $c1da3be54c1d434a$var$createQueryTester = (regexSet)=>({
        isMin: $c1da3be54c1d434a$var$_testQuery(regexSet.minMax, regexSet.maxMin, regexSet.min),
        isMax: $c1da3be54c1d434a$var$_testQuery(regexSet.maxMin, regexSet.minMax, regexSet.max)
    });
const { isMin: $c1da3be54c1d434a$var$isMinWidth, isMax: $c1da3be54c1d434a$var$isMaxWidth } = $c1da3be54c1d434a$var$createQueryTester($c1da3be54c1d434a$var$widthRegex);
const { isMin: $c1da3be54c1d434a$var$isMinHeight, isMax: $c1da3be54c1d434a$var$isMaxHeight } = $c1da3be54c1d434a$var$createQueryTester($c1da3be54c1d434a$var$heightRegex);
const $c1da3be54c1d434a$var$isPrint = /print/i;
const $c1da3be54c1d434a$var$isPrintOnly = /^print$/i;
const $c1da3be54c1d434a$var$isLength = /(-?\d*\.?\d+)(ch|em|ex|px|rem)/;
const $c1da3be54c1d434a$var$lengthExec = /(\d)/;
const $c1da3be54c1d434a$var$maxValue = Number.MAX_VALUE;
const $c1da3be54c1d434a$var$multipliers = {
    ch: 8.8984375,
    em: 16,
    rem: 16,
    ex: 8.296875,
    px: 1
};
function $c1da3be54c1d434a$var$getQueryLength(query) {
    const length = $c1da3be54c1d434a$var$isLength.exec(query) || ($c1da3be54c1d434a$var$isMinWidth(query) || $c1da3be54c1d434a$var$isMinHeight(query) ? $c1da3be54c1d434a$var$lengthExec.exec(query) : null);
    if (!length) return $c1da3be54c1d434a$var$maxValue;
    if (length[0] === "0") return 0;
    const number = parseFloat(length[1]);
    const unit = length[2];
    return number * ($c1da3be54c1d434a$var$multipliers[unit] || 1);
}
function $c1da3be54c1d434a$var$_testQuery(doubleTestTrue, doubleTestFalse, singleTest) {
    return (query)=>doubleTestTrue.test(query) || !doubleTestFalse.test(query) && singleTest.test(query);
}
function $c1da3be54c1d434a$var$_testIsPrint(a, b) {
    const isPrintA = $c1da3be54c1d434a$var$isPrint.test(a), isPrintOnlyA = $c1da3be54c1d434a$var$isPrintOnly.test(a);
    const isPrintB = $c1da3be54c1d434a$var$isPrint.test(b), isPrintOnlyB = $c1da3be54c1d434a$var$isPrintOnly.test(b);
    if (isPrintA && isPrintB) {
        if (!isPrintOnlyA && isPrintOnlyB) return 1;
        if (isPrintOnlyA && !isPrintOnlyB) return -1;
        return a.localeCompare(b);
    }
    return isPrintA ? 1 : isPrintB ? -1 : null;
}
const $c1da3be54c1d434a$export$6096a7de4975ce6d = (0, $17d2a907250d4d6f$export$7c73462e0d25e514)((a, b)=>{
    const testIsPrint = $c1da3be54c1d434a$var$_testIsPrint(a, b);
    if (testIsPrint !== null) return testIsPrint;
    const minA = $c1da3be54c1d434a$var$isMinWidth(a) || $c1da3be54c1d434a$var$isMinHeight(a), maxA = $c1da3be54c1d434a$var$isMaxWidth(a) || $c1da3be54c1d434a$var$isMaxHeight(a);
    const minB = $c1da3be54c1d434a$var$isMinWidth(b) || $c1da3be54c1d434a$var$isMinHeight(b), maxB = $c1da3be54c1d434a$var$isMaxWidth(b) || $c1da3be54c1d434a$var$isMaxHeight(b);
    if (minA && maxB) return -1;
    if (maxA && minB) return 1;
    const lengthA = $c1da3be54c1d434a$var$getQueryLength(a), lengthB = $c1da3be54c1d434a$var$getQueryLength(b);
    if (lengthA === $c1da3be54c1d434a$var$maxValue && lengthB === $c1da3be54c1d434a$var$maxValue) return a.localeCompare(b);
    if (lengthA === $c1da3be54c1d434a$var$maxValue) return 1;
    if (lengthB === $c1da3be54c1d434a$var$maxValue) return -1;
    if (lengthA !== lengthB) return lengthA > lengthB ? maxA ? -1 : 1 : maxA ? 1 : -1;
    return a.localeCompare(b);
});


"use strict";
function $dfc18cc50544bae4$var$sortQueries(queries) {
    return queries.sort(([a], [b])=>(0, $c1da3be54c1d434a$export$6096a7de4975ce6d)(a, b));
}
function $dfc18cc50544bae4$export$48f0d927df046b15(obj) {
    const mediaQueries = [];
    const containerQueries = [];
    const rest = {};
    for (const [key, value] of Object.entries(obj)){
        if (key.startsWith("@media")) mediaQueries.push([
            key,
            value
        ]);
        else if (key.startsWith("@container")) containerQueries.push([
            key,
            value
        ]);
        else if ((0, $02f5f697eb6a66a5$export$a6cdc56e425d0d0a)(value)) rest[key] = $dfc18cc50544bae4$export$48f0d927df046b15(value);
        else rest[key] = value;
    }
    const sortedMediaQueries = $dfc18cc50544bae4$var$sortQueries(mediaQueries);
    const sortedContainerQueries = $dfc18cc50544bae4$var$sortQueries(containerQueries);
    return {
        ...rest,
        ...Object.fromEntries(sortedMediaQueries),
        ...Object.fromEntries(sortedContainerQueries)
    };
}


"use strict";
const $6787b9161a75ec4e$var$importantRegex = /\s*!(important)?/i;
const $6787b9161a75ec4e$var$isImportant = (0, $17d2a907250d4d6f$export$7c73462e0d25e514)((v)=>(0, $02f5f697eb6a66a5$export$844ec244b1367d54)(v) ? $6787b9161a75ec4e$var$importantRegex.test(v) : false);
const $6787b9161a75ec4e$var$withoutImportant = (0, $17d2a907250d4d6f$export$7c73462e0d25e514)((v)=>(0, $02f5f697eb6a66a5$export$844ec244b1367d54)(v) ? v.replace($6787b9161a75ec4e$var$importantRegex, "").trim() : v);
function $6787b9161a75ec4e$export$7f714a6e05babb56(context) {
    const { transform: transform, conditions: conditions, normalize: normalize } = context;
    const mergeFn = $6787b9161a75ec4e$var$mergeCss(context);
    return (0, $17d2a907250d4d6f$export$7c73462e0d25e514)(function cssFn(...styleArgs) {
        const styles = mergeFn(...styleArgs);
        const normalized = normalize(styles);
        const result = (0, $a100815930a659d0$export$a72db9a51bf349f7)();
        (0, $73e475e2b22cc1e3$export$915658b6215945a4)(normalized, (value, paths)=>{
            if (value == null) return;
            const [prop, ...selectors] = conditions.sort(paths).map(conditions.resolve);
            const important = $6787b9161a75ec4e$var$isImportant(value);
            if (important) value = $6787b9161a75ec4e$var$withoutImportant(value);
            let transformed = transform(prop, value) ?? (0, $a100815930a659d0$export$253fab909bb52269);
            transformed = (0, $73e475e2b22cc1e3$export$915658b6215945a4)(transformed, (v)=>(0, $02f5f697eb6a66a5$export$844ec244b1367d54)(v) && important ? `${v} !important` : v, {
                getKey: (prop2)=>conditions.expandAtRule(prop2)
            });
            $6787b9161a75ec4e$var$mergeByPath(result, selectors.flat(), transformed);
        });
        return (0, $dfc18cc50544bae4$export$48f0d927df046b15)(result);
    });
}
function $6787b9161a75ec4e$var$mergeByPath(target, paths, value) {
    let acc = target;
    for (const path of paths){
        if (!path) continue;
        if (!acc[path]) acc[path] = (0, $a100815930a659d0$export$a72db9a51bf349f7)();
        acc = acc[path];
    }
    (0, $3f37eeec613ba395$export$2ee76fde9ffe109d)(acc, value);
}
function $6787b9161a75ec4e$var$compactFn(...styles) {
    return styles.filter((style)=>{
        if (!(0, $02f5f697eb6a66a5$export$a6cdc56e425d0d0a)(style)) return false;
        const compacted = (0, $e1589b4b448a2f71$export$8e16b83750b44988)(style);
        const keys = Object.keys(compacted);
        return keys.length > 0;
    });
}
function $6787b9161a75ec4e$var$mergeCss(ctx) {
    function resolve(styles) {
        const comp = $6787b9161a75ec4e$var$compactFn(...styles);
        if (comp.length === 1) return comp;
        return comp.map((style)=>ctx.normalize(style));
    }
    return (0, $17d2a907250d4d6f$export$7c73462e0d25e514)(function mergeFn(...styles) {
        return (0, $3f37eeec613ba395$export$2ee76fde9ffe109d)({}, ...resolve(styles));
    });
}











"use strict";
const $faf7ac710b9eff40$var$defaults = (conf)=>({
        base: (0, $a100815930a659d0$export$253fab909bb52269),
        variants: (0, $a100815930a659d0$export$253fab909bb52269),
        defaultVariants: (0, $a100815930a659d0$export$253fab909bb52269),
        compoundVariants: [],
        ...conf
    });
function $faf7ac710b9eff40$export$439f157863edac93(options) {
    const { css: css, conditions: conditions, normalize: normalize, layers: layers } = options;
    function cva(config = {}) {
        const defaultsConfig = $faf7ac710b9eff40$var$defaults(config);
        const { base: base, defaultVariants: defaultVariants, compoundVariants: compoundVariants } = defaultsConfig;
        const variants = (0, $9024565373fe4cd0$export$592ef47eabb05614)(defaultsConfig.variants, (key, obj)=>[
                key,
                (0, $9024565373fe4cd0$export$592ef47eabb05614)(obj, (optionKey, styles)=>[
                        optionKey,
                        normalize(styles)
                    ])
            ]);
        const getVariantCss = (0, $6787b9161a75ec4e$export$7f714a6e05babb56)({
            conditions: conditions,
            normalize: normalize,
            transform (prop, value) {
                return variants[prop]?.[value];
            }
        });
        const resolve = (props = {})=>{
            const variantSelections = normalize({
                ...defaultVariants,
                ...(0, $e1589b4b448a2f71$export$8e16b83750b44988)(props)
            });
            let variantCss = {
                ...normalize(base)
            };
            (0, $3f37eeec613ba395$export$2ee76fde9ffe109d)(variantCss, getVariantCss(variantSelections));
            const compoundVariantCss = getCompoundVariantCss(compoundVariants, variantSelections);
            return layers.wrap("recipes", css(variantCss, compoundVariantCss));
        };
        const variantKeys = Object.keys(variants);
        const splitVariantProps = (props)=>{
            const restProps = (0, $e505178ce7dbf967$export$30a06c8d3562193f)(props, [
                "recipe"
            ]);
            const [recipeProps, localProps] = (0, $a3a5d89effecc869$export$45029c61b0073d87)(restProps, variantKeys);
            const hasColorPalette = variantKeys.includes("colorPalette");
            const hasOrientation = variantKeys.includes("orientation");
            if (!hasColorPalette) recipeProps.colorPalette = props.colorPalette || defaultVariants.colorPalette;
            if (hasOrientation) localProps.orientation = props.orientation;
            return [
                recipeProps,
                localProps
            ];
        };
        const variantMap = (0, $9024565373fe4cd0$export$592ef47eabb05614)(variants, (key, value)=>[
                key,
                Object.keys(value)
            ]);
        const cvaFn = (props)=>css(resolve(props));
        return Object.assign(cvaFn, {
            className: config.className,
            __cva__: true,
            variantMap: variantMap,
            variantKeys: variantKeys,
            raw: resolve,
            config: config,
            splitVariantProps: splitVariantProps,
            merge (other) {
                return cva($faf7ac710b9eff40$var$mergeCva(options)(this, other));
            }
        });
    }
    function getCompoundVariantCss(cvs, vm) {
        let result = (0, $a100815930a659d0$export$253fab909bb52269);
        cvs.forEach((cv)=>{
            const isMatching = Object.entries(cv).every(([key, value])=>{
                if (key === "css") return true;
                const values = Array.isArray(value) ? value : [
                    value
                ];
                return values.some((value2)=>vm[key] === value2);
            });
            if (isMatching) result = css(result, cv.css);
        });
        return result;
    }
    return cva;
}
function $faf7ac710b9eff40$var$mergeCva(opts) {
    const { css: css } = opts;
    return function mergeCva2(cvaA, cvaB) {
        const override = $faf7ac710b9eff40$var$defaults(cvaB.config);
        const variantKeys = (0, $a9ab35ecde99cc3b$export$f70730c3d1fc524e)(cvaA.variantKeys, Object.keys(cvaB.variants));
        const base = css(cvaA.base, override.base);
        const variants = Object.fromEntries(variantKeys.map((key)=>[
                key,
                css(cvaA.config.variants[key], override.variants[key])
            ]));
        const defaultVariants = (0, $3f37eeec613ba395$export$2ee76fde9ffe109d)(cvaA.config.defaultVariants, override.defaultVariants);
        const compoundVariants = [
            ...cvaA.compoundVariants,
            ...override.compoundVariants
        ];
        const className = (0, $99474b193e949655$export$a274e22fb40f762e)(cvaA.className, cvaB.className);
        return {
            className: className,
            base: base,
            variants: variants,
            defaultVariants: defaultVariants,
            compoundVariants: compoundVariants
        };
    };
}


"use strict";
const $caf18c878197cbf3$var$defaultLayers = {
    reset: "reset",
    base: "base",
    tokens: "tokens",
    recipes: "recipes"
};
const $caf18c878197cbf3$var$layerOrder = {
    reset: 0,
    base: 1,
    tokens: 2,
    recipes: 3
};
function $caf18c878197cbf3$export$ddf51b1b91379574(config) {
    const layers = config.layers ?? $caf18c878197cbf3$var$defaultLayers;
    const values = Object.values(layers);
    const names = values.sort((a, b)=>$caf18c878197cbf3$var$layerOrder[a] - $caf18c878197cbf3$var$layerOrder[b]);
    return {
        names: names,
        atRule: `@layer ${names.join(", ")};`,
        wrap (layer, styles) {
            if (config.disableLayers) return styles;
            const params = layers[layer];
            return {
                [`@layer ${params}`]: styles
            };
        }
    };
}



"use strict";
function $698b2604809f64d8$export$358f081847bfe3e3(context) {
    const { utility: utility, normalize: normalize } = context;
    const { hasShorthand: hasShorthand, resolveShorthand: resolveShorthand } = utility;
    return function(styles) {
        return (0, $73e475e2b22cc1e3$export$915658b6215945a4)(styles, normalize, {
            stop: (value)=>Array.isArray(value),
            getKey: hasShorthand ? resolveShorthand : void 0
        });
    };
}



"use strict";
function $d123664c87f223b7$export$33276ec412a73052(options) {
    const { preflight: preflight } = options;
    if (!preflight) return {};
    const { scope: scope = "", level: level = "parent" } = (0, $02f5f697eb6a66a5$export$a6cdc56e425d0d0a)(preflight) ? preflight : {};
    let selector = "";
    if (scope && level === "parent") selector = `${scope} `;
    else if (scope && level === "element") selector = `&${scope}`;
    const scoped = {
        "*": {
            margin: "0px",
            padding: "0px",
            font: "inherit",
            wordWrap: "break-word",
            WebkitTapHighlightColor: "transparent"
        },
        "*, *::before, *::after, *::backdrop": {
            boxSizing: "border-box",
            borderWidth: "0px",
            borderStyle: "solid",
            borderColor: "var(--global-color-border, currentColor)"
        },
        hr: {
            height: "0px",
            color: "inherit",
            borderTopWidth: "1px"
        },
        body: {
            minHeight: "100dvh",
            position: "relative"
        },
        img: {
            borderStyle: "none"
        },
        "img, svg, video, canvas, audio, iframe, embed, object": {
            display: "block",
            verticalAlign: "middle"
        },
        iframe: {
            border: "none"
        },
        "img, video": {
            maxWidth: "100%",
            height: "auto"
        },
        "p, h1, h2, h3, h4, h5, h6": {
            overflowWrap: "break-word"
        },
        "ol, ul": {
            listStyle: "none"
        },
        "code, kbd, pre, samp": {
            fontSize: "1em"
        },
        "button, [type='button'], [type='reset'], [type='submit']": {
            WebkitAppearance: "button",
            backgroundColor: "transparent",
            backgroundImage: "none"
        },
        "button, input, optgroup, select, textarea": {
            color: "inherit"
        },
        "button, select": {
            textTransform: "none"
        },
        table: {
            textIndent: "0px",
            borderColor: "inherit",
            borderCollapse: "collapse"
        },
        "*::placeholder": {
            opacity: "unset",
            color: "#9ca3af",
            userSelect: "none"
        },
        textarea: {
            resize: "vertical"
        },
        summary: {
            display: "list-item"
        },
        small: {
            fontSize: "80%"
        },
        "sub, sup": {
            fontSize: "75%",
            lineHeight: 0,
            position: "relative",
            verticalAlign: "baseline"
        },
        sub: {
            bottom: "-0.25em"
        },
        sup: {
            top: "-0.5em"
        },
        dialog: {
            padding: "0px"
        },
        a: {
            color: "inherit",
            textDecoration: "inherit"
        },
        "abbr:where([title])": {
            textDecoration: "underline dotted"
        },
        "b, strong": {
            fontWeight: "bolder"
        },
        "code, kbd, samp, pre": {
            fontSize: "1em",
            "--font-mono-fallback": "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New'",
            fontFamily: "var(--global-font-mono, var(--font-mono-fallback))"
        },
        'input[type="text"], input[type="email"], input[type="search"], input[type="password"]': {
            WebkitAppearance: "none",
            MozAppearance: "none"
        },
        "input[type='search']": {
            WebkitAppearance: "textfield",
            outlineOffset: "-2px"
        },
        "::-webkit-search-decoration, ::-webkit-search-cancel-button": {
            WebkitAppearance: "none"
        },
        "::-webkit-file-upload-button": {
            WebkitAppearance: "button",
            font: "inherit"
        },
        'input[type="number"]::-webkit-inner-spin-button, input[type="number"]::-webkit-outer-spin-button': {
            height: "auto"
        },
        "input[type='number']": {
            MozAppearance: "textfield"
        },
        ":-moz-ui-invalid": {
            boxShadow: "none"
        },
        ":-moz-focusring": {
            outline: "auto"
        },
        "[hidden]:where(:not([hidden='until-found']))": {
            display: "none !important"
        }
    };
    const preflightCss = {
        [scope || "html"]: {
            lineHeight: 1.5,
            "--font-fallback": "ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
            WebkitTextSizeAdjust: "100%",
            WebkitFontSmoothing: "antialiased",
            MozOsxFontSmoothing: "grayscale",
            textRendering: "optimizeLegibility",
            touchAction: "manipulation",
            MozTabSize: "4",
            tabSize: "4",
            fontFamily: "var(--global-font-body, var(--font-fallback))"
        }
    };
    if (level === "element") {
        const modified = Object.entries(scoped).reduce((acc, [k, v])=>{
            acc[k] = {
                [selector]: v
            };
            return acc;
        }, {});
        Object.assign(preflightCss, modified);
    } else if (selector) preflightCss[selector] = scoped;
    else Object.assign(preflightCss, scoped);
    return preflightCss;
}





"use strict";
function $14da70852937ab14$export$173558e7ef6da591(options) {
    const { conditions: conditions, isValidProperty: isValidProperty } = options;
    const isSelectorLike = (0, $17d2a907250d4d6f$export$7c73462e0d25e514)((prop, valueKeys)=>{
        if (!isValidProperty(prop)) return true;
        return !valueKeys.split(",").every((key)=>key === "base" || conditions.has(key));
    });
    return function serialize(styles) {
        return (0, $73e475e2b22cc1e3$export$915658b6215945a4)(styles, (value)=>value, {
            stop: (value)=>Array.isArray(value),
            getKey: (prop, value)=>{
                if (!(0, $02f5f697eb6a66a5$export$a6cdc56e425d0d0a)(value)) return prop;
                if (conditions.has(prop)) return prop;
                if (isSelectorLike(prop, Object.keys(value).join(","))) return $14da70852937ab14$var$parseSelectors(prop).map((s)=>{
                    const selector = s.startsWith("&") ? s.slice(1) : s;
                    return $14da70852937ab14$var$isTopLevelSelector(selector) ? `${selector} &` : `&${selector}`;
                }).join(", ");
                return prop;
            }
        });
    };
}
function $14da70852937ab14$var$isTopLevelSelector(s) {
    const lower = s.toLowerCase();
    return lower.startsWith(":host-context") || lower.startsWith(":host") || lower.startsWith("::slotted");
}
function $14da70852937ab14$var$parseSelectors(selector) {
    const result = [];
    let parenCount = 0;
    let currentSelector = "";
    let inEscape = false;
    for(let i = 0; i < selector.length; i++){
        const char = selector[i];
        if (char === "\\" && !inEscape) {
            inEscape = true;
            currentSelector += char;
            continue;
        }
        if (inEscape) {
            inEscape = false;
            currentSelector += char;
            continue;
        }
        if (char === "(") parenCount++;
        else if (char === ")") parenCount--;
        if (char === "," && parenCount === 0) {
            result.push(currentSelector.trim());
            currentSelector = "";
        } else currentSelector += char;
    }
    if (currentSelector) result.push(currentSelector.trim());
    return result;
}







"use strict";
const $740ef15e233f398b$var$getSlotRecipes = (config = (0, $a100815930a659d0$export$253fab909bb52269))=>{
    const init = (slot)=>({
            base: config.base?.[slot] ?? (0, $a100815930a659d0$export$253fab909bb52269),
            variants: (0, $a100815930a659d0$export$a72db9a51bf349f7)(),
            defaultVariants: config.defaultVariants ?? (0, $a100815930a659d0$export$253fab909bb52269),
            compoundVariants: config.compoundVariants ? $740ef15e233f398b$export$ec9417c0c2e3abea(config.compoundVariants, slot) : (0, $a100815930a659d0$export$2c66e96878bf4792)
        });
    const slots = config.slots ?? [];
    const entries = slots.map((slot)=>[
            slot,
            init(slot)
        ]);
    for (const [variantsKey, variantsSpec] of Object.entries(config.variants ?? {}))for (const [variantKey, variantSpec] of Object.entries(variantsSpec))entries.forEach(([slot, slotRecipe])=>{
        var _a;
        (_a = slotRecipe.variants)[variantsKey] ?? (_a[variantsKey] = {});
        slotRecipe.variants[variantsKey][variantKey] = variantSpec[slot] ?? (0, $a100815930a659d0$export$253fab909bb52269);
    });
    return Object.fromEntries(entries);
};
const $740ef15e233f398b$export$ec9417c0c2e3abea = (compoundVariants, slotName)=>compoundVariants.filter((compoundVariant)=>compoundVariant.css[slotName]).map((compoundVariant)=>({
            ...compoundVariant,
            css: compoundVariant.css[slotName]
        }));
function $740ef15e233f398b$export$6882452d1db83150(options) {
    const { cva: cva } = options;
    return function sva(config = (0, $a100815930a659d0$export$253fab909bb52269)) {
        const slots = Object.entries($740ef15e233f398b$var$getSlotRecipes(config)).map(([slot, slotCva])=>[
                slot,
                cva(slotCva)
            ]);
        function svaFn(props) {
            const result = slots.map(([slot, cvaFn])=>[
                    slot,
                    cvaFn(props)
                ]);
            return Object.fromEntries(result);
        }
        const variants = config.variants ?? (0, $a100815930a659d0$export$253fab909bb52269);
        const variantKeys = Object.keys(variants);
        function splitVariantProps(props) {
            const restProps = (0, $e505178ce7dbf967$export$30a06c8d3562193f)(props, [
                "recipe"
            ]);
            const [recipeProps, localProps] = (0, $a3a5d89effecc869$export$45029c61b0073d87)(restProps, variantKeys);
            const hasColorPalette = variantKeys.includes("colorPalette");
            const hasOrientation = variantKeys.includes("orientation");
            if (!hasColorPalette) recipeProps.colorPalette = props.colorPalette || config.defaultVariants?.colorPalette;
            if (hasOrientation) localProps.orientation = props.orientation;
            return [
                recipeProps,
                localProps
            ];
        }
        const variantMap = (0, $9024565373fe4cd0$export$592ef47eabb05614)(variants, (key, value)=>[
                key,
                Object.keys(value)
            ]);
        let classNameMap = {};
        if (config.className) classNameMap = Object.fromEntries(config.slots.map((slot)=>[
                slot,
                `${config.className}__${slot}`
            ]));
        return Object.assign(svaFn, {
            variantMap: variantMap,
            variantKeys: variantKeys,
            splitVariantProps: splitVariantProps,
            classNameMap: classNameMap
        });
    };
}



"use strict";
const $55e6ec5e06773183$export$c94ea207b45fef3a = ()=>(props)=>Array.from(new Set(props));







"use strict";
const $d3817bdad33c74cf$var$escRegex = /[^a-zA-Z0-9_\u0081-\uffff-]/g;
function $d3817bdad33c74cf$var$esc(string) {
    return `${string}`.replace($d3817bdad33c74cf$var$escRegex, (s)=>`\\${s}`);
}
const $d3817bdad33c74cf$var$dashCaseRegex = /[A-Z]/g;
function $d3817bdad33c74cf$var$dashCase(string) {
    return string.replace($d3817bdad33c74cf$var$dashCaseRegex, (match)=>`-${match.toLowerCase()}`);
}
function $d3817bdad33c74cf$export$8b4981022bd80a4e(name, options = {}) {
    const { fallback: fallback = "", prefix: prefix = "" } = options;
    const variable = $d3817bdad33c74cf$var$dashCase([
        "-",
        prefix,
        $d3817bdad33c74cf$var$esc(name)
    ].filter(Boolean).join("-"));
    return {
        var: variable,
        ref: `var(${variable}${fallback ? `, ${fallback}` : ""})`
    };
}


"use strict";
const $0d714036624bc775$var$rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|^-|[^\x80-\uFFFF\w-]/g;
const $0d714036624bc775$var$fcssescape = function(ch, asCodePoint) {
    if (!asCodePoint) return "\\" + ch;
    if (ch === "\0") return "\uFFFD";
    if (ch === "-" && ch.length === 1) return "\\-";
    return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16);
};
const $0d714036624bc775$export$a1a11b095f88289a = (sel)=>{
    return (sel + "").replace($0d714036624bc775$var$rcssescape, $0d714036624bc775$var$fcssescape);
};



"use strict";
const $7bbb90b4bf225ab4$export$ae1eeb9bcad7a91d = (str, resolve)=>{
    let expanded = "";
    let index = 0;
    let state = "char";
    let tokenPath = "";
    let fallback = "";
    const currentStates = [];
    while(index < str.length){
        const char = str[index];
        if (char === "{") {
            const endIndex = str.indexOf("}", index);
            if (endIndex === -1) break;
            const path = str.slice(index + 1, endIndex);
            const resolved = resolve(path);
            expanded += resolved ?? path;
            index = endIndex + 1;
            continue;
        }
        if (state === "token") {
            if (char === ",") {
                if (str[index] === "") index++;
                state = "fallback";
                currentStates.push(state);
                const resolved = resolve(tokenPath);
                if (resolved?.endsWith(")")) expanded += resolved.slice(0, -1);
                tokenPath = "";
                fallback = "";
                continue;
            }
        }
        if (state === "fallback") {
            const nextFallback = fallback + char;
            if (nextFallback === ", var(") {
                const innerEndIndex = $7bbb90b4bf225ab4$var$cssVarParser(str.slice(index + 1));
                const endIndex = innerEndIndex + index + 1;
                const cssVar = str.slice(index + 1, endIndex);
                if (endIndex === -1) break;
                expanded += ", var(" + cssVar + ")";
                index = endIndex + 1;
                state = currentStates.pop() ?? state;
                fallback = "";
                continue;
            }
        }
        if (state === "token" || state === "fallback") {
            index++;
            if (char === ")") {
                state = currentStates.pop() ?? state ?? "char";
                fallback += char;
                const resolved = tokenPath ? resolve(tokenPath) ?? (0, $0d714036624bc775$export$a1a11b095f88289a)(tokenPath) : tokenPath;
                if (fallback) {
                    fallback = fallback.slice(1).trim();
                    if (!fallback.startsWith("token(") && fallback.endsWith(")")) fallback = fallback.slice(0, -1);
                    if (fallback.includes("token(")) {
                        const parsed = $7bbb90b4bf225ab4$export$ae1eeb9bcad7a91d(fallback, resolve);
                        if (parsed) fallback = parsed.slice(0, -1);
                    } else if (fallback) {
                        const resolvedFallback = resolve(fallback);
                        if (resolvedFallback) fallback = resolvedFallback;
                    }
                }
                const lastChar = expanded.at(-1);
                if (fallback) {
                    if (lastChar?.trim()) expanded += resolved.slice(0, -1) + (", " + fallback + ")");
                    else expanded += fallback;
                } else expanded += resolved || ")";
                tokenPath = "";
                fallback = "";
                state = "char";
                continue;
            }
            if (state === "token") tokenPath += char;
            if (state === "fallback") fallback += char;
            continue;
        }
        const tokenIndex = str.indexOf("token(", index);
        if (tokenIndex !== -1) {
            const innerTokenIndex = tokenIndex + 6;
            expanded += str.slice(index, tokenIndex);
            index = innerTokenIndex;
            state = "token";
            currentStates.push(state);
            continue;
        }
        expanded += char;
        index++;
    }
    return expanded;
};
const $7bbb90b4bf225ab4$var$cssVarParser = (str)=>{
    let index = 0;
    const openedParenthesises = [
        "("
    ];
    while(index < str.length){
        const char = str[index];
        if (char === "(") openedParenthesises.push(char);
        else if (char === ")") {
            openedParenthesises.pop();
            if (openedParenthesises.length === 0) return index;
        }
        index++;
    }
    return index;
};


"use strict";
function $65f17ec84106bf2d$export$18dc39132a3e8c51(map) {
    const obj = {};
    map.forEach((value, key)=>{
        if (value instanceof Map) obj[key] = Object.fromEntries(value);
        else obj[key] = value;
    });
    return obj;
}



"use strict";
const $ebefef13b11323bd$var$REFERENCE_REGEX = /({([^}]*)})/g;
const $ebefef13b11323bd$var$CURLY_REGEX = /[{}]/g;
const $ebefef13b11323bd$export$98aea2f7791dffee = /\w+\.\w+/;
const $ebefef13b11323bd$export$7a8750ced918912e = (value)=>{
    if (!(0, $02f5f697eb6a66a5$export$844ec244b1367d54)(value)) return [];
    const matches = value.match($ebefef13b11323bd$var$REFERENCE_REGEX);
    if (!matches) return [];
    return matches.map((match)=>match.replace($ebefef13b11323bd$var$CURLY_REGEX, "").trim());
};
const $ebefef13b11323bd$export$9d46be67a6e05ef0 = (value)=>$ebefef13b11323bd$var$REFERENCE_REGEX.test(value);
function $ebefef13b11323bd$export$6c976907770ec615(token) {
    if (!token.extensions?.references) return token.extensions?.cssVar?.ref ?? token.value;
    const references = token.extensions.references ?? {};
    let valueStr = token.value;
    const keys = Object.keys(references);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const referenceToken = references[key];
        if (referenceToken.extensions.conditions) continue;
        const value = $ebefef13b11323bd$export$6c976907770ec615(referenceToken);
        valueStr = valueStr.replace(`{${key}}`, value);
    }
    token.value = valueStr;
    delete token.extensions.references;
    return token.value;
}


"use strict";
function $37b5c316d82ee2ae$export$4e0830c5034f1c5f(category, value) {
    if (value == null || !Array.isArray(value)) return value;
    switch(category){
        case "easings":
            return `cubic-bezier(${value.join(", ")})`;
        case "animations":
        case "fonts":
        case "gradients":
        case "shadows":
            return value.join(", ");
        default:
            return value;
    }
}
function $37b5c316d82ee2ae$export$c947024896ff2e84(category, conditions) {
    const next = {};
    for(const key in conditions)next[key] = $37b5c316d82ee2ae$export$4e0830c5034f1c5f(category, conditions[key]);
    return next;
}




"use strict";
const $5db2c7f172e87a76$var$CALC_REGEX = /calc/g;
function $5db2c7f172e87a76$var$resolveReference(operand) {
    if ((0, $02f5f697eb6a66a5$export$a6cdc56e425d0d0a)(operand) && operand.reference) return operand.reference;
    return String(operand);
}
const $5db2c7f172e87a76$var$toExpression = (operator, ...operands)=>operands.map($5db2c7f172e87a76$var$resolveReference).join(` ${operator} `).replace($5db2c7f172e87a76$var$CALC_REGEX, "");
const $5db2c7f172e87a76$var$add = (...operands)=>`calc(${$5db2c7f172e87a76$var$toExpression("+", ...operands)})`;
const $5db2c7f172e87a76$var$subtract = (...operands)=>`calc(${$5db2c7f172e87a76$var$toExpression("-", ...operands)})`;
const $5db2c7f172e87a76$var$multiply = (...operands)=>`calc(${$5db2c7f172e87a76$var$toExpression("*", ...operands)})`;
const $5db2c7f172e87a76$var$divide = (...operands)=>`calc(${$5db2c7f172e87a76$var$toExpression("/", ...operands)})`;
const $5db2c7f172e87a76$var$negate = (x)=>{
    const value = $5db2c7f172e87a76$var$resolveReference(x);
    if (value != null && !Number.isNaN(parseFloat(value))) return String(value).startsWith("-") ? String(value).slice(1) : `-${value}`;
    return $5db2c7f172e87a76$var$multiply(value, -1);
};
const $5db2c7f172e87a76$export$42bfa9b2d4dad91a = Object.assign((x)=>({
        add: (...operands)=>$5db2c7f172e87a76$export$42bfa9b2d4dad91a($5db2c7f172e87a76$var$add(x, ...operands)),
        subtract: (...operands)=>$5db2c7f172e87a76$export$42bfa9b2d4dad91a($5db2c7f172e87a76$var$subtract(x, ...operands)),
        multiply: (...operands)=>$5db2c7f172e87a76$export$42bfa9b2d4dad91a($5db2c7f172e87a76$var$multiply(x, ...operands)),
        divide: (...operands)=>$5db2c7f172e87a76$export$42bfa9b2d4dad91a($5db2c7f172e87a76$var$divide(x, ...operands)),
        negate: ()=>$5db2c7f172e87a76$export$42bfa9b2d4dad91a($5db2c7f172e87a76$var$negate(x)),
        toString: ()=>x.toString()
    }), {
    add: $5db2c7f172e87a76$var$add,
    subtract: $5db2c7f172e87a76$var$subtract,
    multiply: $5db2c7f172e87a76$var$multiply,
    divide: $5db2c7f172e87a76$var$divide,
    negate: $5db2c7f172e87a76$var$negate
});



"use strict";
const $964ecc40ab7f5375$export$441a6ff10bae0bb3 = {
    enforce: "pre",
    transform (dictionary) {
        const { prefix: prefix, allTokens: allTokens, formatCssVar: formatCssVar, formatTokenName: formatTokenName, registerToken: registerToken } = dictionary;
        const tokens = allTokens.filter(({ extensions: extensions })=>extensions.category === "spacing");
        tokens.forEach((token)=>{
            const originalPath = token.path.slice();
            const originalVar = formatCssVar(originalPath, prefix);
            if ((0, $02f5f697eb6a66a5$export$844ec244b1367d54)(token.value) && token.value === "0rem") return;
            const newPath = [
                ...token.path
            ];
            const lastPath = newPath[newPath.length - 1];
            if (lastPath != null) newPath[newPath.length - 1] = `-${lastPath}`;
            const nextToken = {
                ...token,
                value: (0, $5db2c7f172e87a76$export$42bfa9b2d4dad91a).negate(originalVar.ref),
                name: formatTokenName(newPath),
                path: newPath,
                extensions: {
                    ...token.extensions,
                    negative: true,
                    prop: `-${token.extensions.prop}`,
                    originalPath: originalPath
                }
            };
            registerToken(nextToken);
        });
    }
};
const $964ecc40ab7f5375$var$units = /* @__PURE__ */ new Set([
    "spacing",
    "sizes",
    "borderWidths",
    "fontSizes",
    "radii"
]);
const $964ecc40ab7f5375$export$d69f1b5705d59b6c = {
    enforce: "post",
    transform (dictionary) {
        const tokens = dictionary.allTokens.filter((token)=>{
            return $964ecc40ab7f5375$var$units.has(token.extensions.category) && !token.extensions.negative;
        });
        tokens.forEach((token)=>{
            Object.assign(token.extensions, {
                pixelValue: (0, $0d8ecfa47c1a9d05$export$6562491d7413c9c9)(token.value)
            });
        });
    }
};
const $964ecc40ab7f5375$export$b525739f8f649fe4 = {
    enforce: "post",
    transform (dictionary) {
        const { allTokens: allTokens, registerToken: registerToken, formatTokenName: formatTokenName } = dictionary;
        const tokens = allTokens.filter(({ extensions: extensions })=>extensions.category === "colors");
        const keys = /* @__PURE__ */ new Map();
        const colorPalettes = /* @__PURE__ */ new Map();
        tokens.forEach((token)=>{
            const { colorPalette: colorPalette } = token.extensions;
            if (!colorPalette) return;
            colorPalette.keys.forEach((keyPath)=>{
                keys.set(formatTokenName(keyPath), keyPath);
            });
            colorPalette.roots.forEach((colorPaletteRoot)=>{
                const name = formatTokenName(colorPaletteRoot);
                const colorPaletteList = colorPalettes.get(name) || [];
                colorPaletteList.push(token);
                colorPalettes.set(name, colorPaletteList);
                if (token.extensions.default && colorPaletteRoot.length === 1) {
                    const keyPath = colorPalette.keys[0]?.filter(Boolean);
                    if (!keyPath.length) return;
                    const path = colorPaletteRoot.concat(keyPath);
                    keys.set(formatTokenName(path), []);
                }
            });
        });
        keys.forEach((segments)=>{
            const path = [
                "colors",
                "colorPalette",
                ...segments
            ].filter(Boolean);
            const name = formatTokenName(path);
            const prop = formatTokenName(path.slice(1));
            const token = {
                name: name,
                value: name,
                originalValue: name,
                path: path,
                extensions: {
                    condition: "base",
                    originalPath: path,
                    category: "colors",
                    prop: prop,
                    virtual: true
                }
            };
            registerToken(token, "pre");
        });
    }
};
const $964ecc40ab7f5375$export$52eea65c8f3bb51f = {
    enforce: "post",
    transform (dictionary) {
        dictionary.allTokens = dictionary.allTokens.filter((token)=>token.value !== "");
    }
};
const $964ecc40ab7f5375$export$52d04681fd073e3c = [
    $964ecc40ab7f5375$export$441a6ff10bae0bb3,
    $964ecc40ab7f5375$export$b525739f8f649fe4,
    $964ecc40ab7f5375$export$d69f1b5705d59b6c,
    $964ecc40ab7f5375$export$52eea65c8f3bb51f
];



"use strict";
const $f13d4025fbf8fc96$export$dbf77247e2e4face = {
    type: "extensions",
    enforce: "pre",
    name: "tokens/css-var",
    transform (token, dictionary) {
        const { prefix: prefix, formatCssVar: formatCssVar } = dictionary;
        const { negative: negative, originalPath: originalPath } = token.extensions;
        const path = negative ? originalPath : token.path;
        return {
            cssVar: formatCssVar(path.filter(Boolean), prefix)
        };
    }
};
const $f13d4025fbf8fc96$export$f78ef862fefbe03d = {
    enforce: "post",
    type: "value",
    name: "tokens/conditionals",
    transform (token, dictionary) {
        const { prefix: prefix, formatCssVar: formatCssVar, getByName: getByName } = dictionary;
        const refs = (0, $ebefef13b11323bd$export$7a8750ced918912e)(token.value);
        if (!refs.length) return token.value;
        refs.forEach((ref)=>{
            if (!getByName(ref)) return;
            const variable = formatCssVar(ref.split("."), prefix);
            token.value = token.value.replaceAll(`{${ref}}`, variable.ref);
        });
        return token.value;
    }
};
const $f13d4025fbf8fc96$export$f5aaa1c82e5da430 = {
    type: "extensions",
    enforce: "pre",
    name: "tokens/colors/colorPalette",
    match (token) {
        return token.extensions.category === "colors" && !token.extensions.virtual;
    },
    transform (token, dict) {
        let path = token.path.slice();
        path.pop();
        path.shift();
        if (path.length === 0) {
            const newPath = [
                ...token.path
            ];
            newPath.shift();
            path = newPath;
        }
        if (path.length === 0) return {};
        const roots = path.reduce((acc, _, i, arr)=>{
            const next = arr.slice(0, i + 1);
            acc.push(next);
            return acc;
        }, []);
        const root = path[0];
        const value = dict.formatTokenName(path);
        const keys = token.path.slice(token.path.indexOf(root) + 1).reduce((acc, _, i, arr)=>{
            acc.push(arr.slice(i));
            return acc;
        }, []);
        if (keys.length === 0) keys.push([
            ""
        ]);
        return {
            colorPalette: {
                value: value,
                roots: roots,
                keys: keys
            }
        };
    }
};
const $f13d4025fbf8fc96$export$12feaf11c829ef28 = [
    $f13d4025fbf8fc96$export$dbf77247e2e4face,
    $f13d4025fbf8fc96$export$f78ef862fefbe03d,
    $f13d4025fbf8fc96$export$f5aaa1c82e5da430
];


"use strict";
const $8467bab47643e51e$var$isToken = (value)=>{
    return (0, $02f5f697eb6a66a5$export$a6cdc56e425d0d0a)(value) && Object.prototype.hasOwnProperty.call(value, "value");
};
function $8467bab47643e51e$var$expandBreakpoints(breakpoints) {
    if (!breakpoints) return {
        breakpoints: {},
        sizes: {}
    };
    return {
        breakpoints: (0, $73e475e2b22cc1e3$export$d6051a0f7a227332)(breakpoints, (value)=>({
                value: value
            })),
        sizes: (0, $9024565373fe4cd0$export$592ef47eabb05614)(breakpoints, (key, value)=>[
                `breakpoint-${key}`,
                {
                    value: value
                }
            ])
    };
}
function $8467bab47643e51e$export$b2a6cfa443dacae(options) {
    const { prefix: prefix = "", tokens: tokens = {}, semanticTokens: semanticTokens = {}, breakpoints: breakpoints = {} } = options;
    const formatTokenName = (path)=>path.join(".");
    const formatCssVar = (path, prefix2)=>(0, $d3817bdad33c74cf$export$8b4981022bd80a4e)(path.join("-"), {
            prefix: prefix2
        });
    const allTokens = [];
    const tokenNameMap = /* @__PURE__ */ new Map();
    const conditionMap = /* @__PURE__ */ new Map();
    const cssVarMap = /* @__PURE__ */ new Map();
    const colorPaletteMap = /* @__PURE__ */ new Map();
    const flatMap = /* @__PURE__ */ new Map();
    const byCategory = /* @__PURE__ */ new Map();
    const categoryMap = /* @__PURE__ */ new Map();
    const transforms = /* @__PURE__ */ new Map();
    const middlewares = [];
    function registerToken(token, phase) {
        allTokens.push(token);
        tokenNameMap.set(token.name, token);
        if (phase) transforms.forEach((fn)=>{
            if (fn.enforce === phase) transformToken(fn, token);
        });
    }
    const breakpointTokens = $8467bab47643e51e$var$expandBreakpoints(breakpoints);
    const computedTokens = (0, $e1589b4b448a2f71$export$8e16b83750b44988)({
        ...tokens,
        breakpoints: breakpointTokens.breakpoints,
        sizes: {
            ...tokens.sizes,
            ...breakpointTokens.sizes
        }
    });
    function registerTokens() {
        (0, $73e475e2b22cc1e3$export$915658b6215945a4)(computedTokens, (entry, path)=>{
            const isDefault = path.includes("DEFAULT");
            path = $8467bab47643e51e$var$filterDefault(path);
            const category = path[0];
            const name = formatTokenName(path);
            const t = (0, $02f5f697eb6a66a5$export$844ec244b1367d54)(entry) ? {
                value: entry
            } : entry;
            const resolved = (0, $37b5c316d82ee2ae$export$4e0830c5034f1c5f)(category, t.value);
            const token = {
                value: resolved,
                originalValue: resolved,
                name: name,
                path: path,
                extensions: {
                    condition: "base",
                    originalPath: path,
                    category: category,
                    prop: formatTokenName(path.slice(1))
                }
            };
            if (isDefault) token.extensions.default = true;
            registerToken(token);
        }, {
            stop: $8467bab47643e51e$var$isToken
        });
        (0, $73e475e2b22cc1e3$export$915658b6215945a4)(semanticTokens, (entry, path)=>{
            const isDefault = path.includes("DEFAULT");
            path = $8467bab47643e51e$var$filterBaseCondition($8467bab47643e51e$var$filterDefault(path));
            const category = path[0];
            const name = formatTokenName(path);
            const t = (0, $02f5f697eb6a66a5$export$844ec244b1367d54)(entry.value) || Array.isArray(entry.value) ? {
                value: {
                    base: entry.value
                }
            } : entry;
            const cond = (0, $37b5c316d82ee2ae$export$c947024896ff2e84)(category, t.value);
            const token = {
                value: cond.base ?? "",
                originalValue: cond.base ?? "",
                name: name,
                path: path,
                extensions: {
                    originalPath: path,
                    category: category,
                    conditions: cond,
                    condition: "base",
                    prop: formatTokenName(path.slice(1))
                }
            };
            if (isDefault) token.extensions.default = true;
            registerToken(token);
        }, {
            stop: $8467bab47643e51e$var$isToken
        });
    }
    function getByName(name) {
        return tokenNameMap.get(name);
    }
    function buildConditionMap(token) {
        const { condition: condition } = token.extensions;
        if (!condition) return;
        if (!conditionMap.has(condition)) conditionMap.set(condition, /* @__PURE__ */ new Set());
        conditionMap.get(condition).add(token);
    }
    function buildCategoryMap(token) {
        const { category: category, prop: prop, condition: condition } = token.extensions;
        if (!category) return;
        if (condition != null && condition !== "base") return;
        if (!categoryMap.has(category)) categoryMap.set(category, /* @__PURE__ */ new Map());
        categoryMap.get(category).set(prop, token);
    }
    function buildCssVars(token) {
        const { condition: condition, negative: negative, virtual: virtual, cssVar: cssVar2 } = token.extensions;
        if (negative || virtual || !condition || !cssVar2) return;
        if (!cssVarMap.has(condition)) cssVarMap.set(condition, /* @__PURE__ */ new Map());
        cssVarMap.get(condition).set(cssVar2.var, token.value);
    }
    function buildFlatMap(token) {
        const { category: category, prop: prop, cssVar: cssVar2, negative: negative } = token.extensions;
        if (!category) return;
        if (!byCategory.has(category)) byCategory.set(category, /* @__PURE__ */ new Map());
        const value = negative ? token.extensions.conditions ? token.originalValue : token.value : cssVar2.ref;
        byCategory.get(category).set(prop, value);
        flatMap.set([
            category,
            prop
        ].join("."), value);
    }
    function buildColorPalette(token) {
        const { colorPalette: colorPalette, virtual: virtual, default: isDefault } = token.extensions;
        if (!colorPalette || virtual) return;
        colorPalette.roots.forEach((root)=>{
            const name = formatTokenName(root);
            if (!colorPaletteMap.has(name)) colorPaletteMap.set(name, /* @__PURE__ */ new Map());
            const virtualPath = $8467bab47643e51e$var$replaceRootWithColorPalette([
                ...token.path
            ], [
                ...root
            ]);
            const virtualName = formatTokenName(virtualPath);
            const virtualToken = getByName(virtualName);
            if (!virtualToken || !virtualToken.extensions.cssVar) return;
            const { var: virtualVar } = virtualToken.extensions.cssVar;
            colorPaletteMap.get(name).set(virtualVar, token.extensions.cssVar.ref);
            if (isDefault && root.length === 1) {
                const colorPaletteName = formatTokenName([
                    "colors",
                    "colorPalette"
                ]);
                const colorPaletteToken = getByName(colorPaletteName);
                if (!colorPaletteToken) return;
                const name2 = formatTokenName(token.path);
                const virtualToken2 = getByName(name2);
                if (!virtualToken2) return;
                const keyPath = colorPalette.keys[0]?.filter(Boolean);
                if (!keyPath.length) return;
                const computedName = formatTokenName(root.concat(keyPath));
                if (!colorPaletteMap.has(computedName)) colorPaletteMap.set(computedName, /* @__PURE__ */ new Map());
                colorPaletteMap.get(computedName).set(colorPaletteToken.extensions.cssVar.var, virtualToken2.extensions.cssVar.ref);
            }
        });
    }
    let byCategoryJson = {};
    function setupViews() {
        allTokens.forEach((token)=>{
            buildConditionMap(token);
            buildCategoryMap(token);
            buildCssVars(token);
            buildFlatMap(token);
            buildColorPalette(token);
        });
        byCategoryJson = (0, $65f17ec84106bf2d$export$18dc39132a3e8c51)(byCategory);
    }
    const colorMix = (value, tokenFn)=>{
        if (!value || typeof value !== "string") return {
            invalid: true,
            value: value
        };
        const [colorPath, rawOpacity] = value.split("/");
        if (!colorPath || !rawOpacity) return {
            invalid: true,
            value: colorPath
        };
        const colorToken = tokenFn(colorPath);
        const opacityToken = getByName(`opacity.${rawOpacity}`)?.value;
        if (!opacityToken && isNaN(Number(rawOpacity))) return {
            invalid: true,
            value: colorPath
        };
        const percent = opacityToken ? Number(opacityToken) * 100 + "%" : `${rawOpacity}%`;
        const color = colorToken ?? colorPath;
        return {
            invalid: false,
            color: color,
            value: `color-mix(in srgb, ${color} ${percent}, transparent)`
        };
    };
    const getVar = (0, $17d2a907250d4d6f$export$7c73462e0d25e514)((value, fallback)=>{
        return flatMap.get(value) ?? fallback;
    });
    const getCategoryValues = (0, $17d2a907250d4d6f$export$7c73462e0d25e514)((category)=>{
        return byCategoryJson[category] || null;
    });
    const expandReferenceInValue = (0, $17d2a907250d4d6f$export$7c73462e0d25e514)((value)=>{
        return (0, $7bbb90b4bf225ab4$export$ae1eeb9bcad7a91d)(value, (path)=>{
            if (!path) return;
            if (path.includes("/")) {
                const mix = colorMix(path, (v)=>getVar(v));
                if (mix.invalid) throw new Error("Invalid color mix at " + path + ": " + mix.value);
                return mix.value;
            }
            const resolved = getVar(path);
            if (resolved) return resolved;
            return (0, $ebefef13b11323bd$export$98aea2f7791dffee).test(path) ? (0, $0d714036624bc775$export$a1a11b095f88289a)(path) : path;
        });
    });
    const dictionary = {
        prefix: prefix,
        allTokens: allTokens,
        tokenMap: tokenNameMap,
        registerToken: registerToken,
        getByName: getByName,
        formatTokenName: formatTokenName,
        formatCssVar: formatCssVar,
        flatMap: flatMap,
        cssVarMap: cssVarMap,
        categoryMap: categoryMap,
        colorPaletteMap: colorPaletteMap,
        getVar: getVar,
        getCategoryValues: getCategoryValues,
        expandReferenceInValue: expandReferenceInValue
    };
    function registerTransform(...fns) {
        fns.forEach((fn)=>{
            transforms.set(fn.name, fn);
        });
    }
    function registerMiddleware(...fns) {
        middlewares.push(...fns);
    }
    function transformToken(transform, token) {
        if (token.extensions.references) return;
        if ((0, $02f5f697eb6a66a5$export$f6e2535fb5126e54)(transform.match) && !transform.match(token)) return;
        const fn = (v)=>transform.transform(v, dictionary);
        const transformed = fn(token);
        switch(true){
            case transform.type === "extensions":
                Object.assign(token.extensions, transformed);
                break;
            case transform.type === "value":
                token.value = transformed;
                break;
            default:
                token[transform.type] = transformed;
                break;
        }
    }
    function applyMiddlewares(enforce) {
        middlewares.forEach((middleware)=>{
            if (middleware.enforce === enforce) middleware.transform(dictionary);
        });
    }
    function applyTransforms(enforce) {
        transforms.forEach((transform)=>{
            if (transform.enforce === enforce) allTokens.forEach((token)=>{
                transformToken(transform, token);
            });
        });
    }
    function addConditionalTokens() {
        allTokens.slice().forEach((token)=>{
            const tokens2 = $8467bab47643e51e$var$getConditionalTokens(token);
            if (!tokens2 || tokens2.length === 0) return;
            tokens2.forEach((token2)=>{
                registerToken(token2);
            });
        });
    }
    function getTokenReferences(value) {
        const refs = (0, $ebefef13b11323bd$export$7a8750ced918912e)(value);
        const result = [];
        for(let i = 0; i < refs.length; i++){
            const token = getByName(refs[i]);
            if (token) result.push(token);
        }
        return result;
    }
    function addReferences() {
        allTokens.forEach((token)=>{
            if (!(0, $ebefef13b11323bd$export$9d46be67a6e05ef0)(token.value)) return;
            const references = getTokenReferences(token.value);
            token.extensions.references = references.reduce((acc, ref)=>{
                acc[ref.name] = ref;
                return acc;
            }, {});
        });
    }
    function expandTokenReferences$1() {
        allTokens.forEach((token)=>{
            (0, $ebefef13b11323bd$export$6c976907770ec615)(token);
        });
    }
    function build() {
        applyMiddlewares("pre");
        applyTransforms("pre");
        addConditionalTokens();
        addReferences();
        expandTokenReferences$1();
        applyMiddlewares("post");
        applyTransforms("post");
        setupViews();
    }
    registerTokens();
    registerTransform(...(0, $f13d4025fbf8fc96$export$12feaf11c829ef28));
    registerMiddleware(...(0, $964ecc40ab7f5375$export$52d04681fd073e3c));
    build();
    return dictionary;
}
function $8467bab47643e51e$var$filterDefault(path) {
    if (path[0] === "DEFAULT") return path;
    return path.filter((item)=>item !== "DEFAULT");
}
function $8467bab47643e51e$var$filterBaseCondition(path) {
    return path.filter((item)=>item !== "base");
}
function $8467bab47643e51e$var$getConditionalTokens(token) {
    if (!token.extensions.conditions) return;
    const { conditions: conditions } = token.extensions;
    const tokens = [];
    (0, $73e475e2b22cc1e3$export$915658b6215945a4)(conditions, (value, path)=>{
        const nextPath = $8467bab47643e51e$var$filterBaseCondition(path);
        if (!nextPath.length) return;
        const nextToken = {
            ...token,
            value: value,
            extensions: {
                ...(0, $e505178ce7dbf967$export$30a06c8d3562193f)(token.extensions, [
                    "conditions"
                ]),
                condition: nextPath.join(":")
            }
        };
        tokens.push(nextToken);
    });
    return tokens;
}
function $8467bab47643e51e$var$replaceRootWithColorPalette(path, roots) {
    const startIndex = path.findIndex((_, index)=>roots.every((rootElement, rootIndex)=>path[index + rootIndex] === rootElement));
    if (startIndex === -1) return path;
    path.splice(startIndex, roots.length);
    path.splice(startIndex, 0, "colorPalette");
    return path;
}
const $8467bab47643e51e$export$d4433a01ea838b6 = (0, $55e6ec5e06773183$export$c94ea207b45fef3a)()([
    "aspectRatios",
    "zIndex",
    "opacity",
    "colors",
    "fonts",
    "fontSizes",
    "fontWeights",
    "lineHeights",
    "letterSpacings",
    "sizes",
    "shadows",
    "spacing",
    "radii",
    "cursor",
    "borders",
    "borderWidths",
    "borderStyles",
    "durations",
    "easings",
    "animations",
    "blurs",
    "gradients",
    "breakpoints",
    "assets"
]);





"use strict";
const $143bade67be6bd19$export$9b476054b78b89cd = (value, token)=>{
    if (!value || typeof value !== "string") return {
        invalid: true,
        value: value
    };
    const [rawColor, rawOpacity] = value.split("/");
    if (!rawColor || !rawOpacity || rawColor === "currentBg") return {
        invalid: true,
        value: rawColor
    };
    const colorToken = token(`colors.${rawColor}`);
    const opacityToken = token.raw(`opacity.${rawOpacity}`)?.value;
    if (!opacityToken && isNaN(Number(rawOpacity))) return {
        invalid: true,
        value: rawColor
    };
    const percent = opacityToken ? Number(opacityToken) * 100 + "%" : `${rawOpacity}%`;
    const color = colorToken ?? rawColor;
    return {
        invalid: false,
        color: color,
        value: `color-mix(in srgb, ${color} ${percent}, transparent)`
    };
};
const $143bade67be6bd19$export$85907fd96ef7f08 = (prop)=>(value, args)=>{
        const mix = args.utils.colorMix(value);
        if (mix.invalid) return {
            [prop]: value
        };
        const cssVar = "--mix-" + prop;
        return {
            [cssVar]: mix.value,
            [prop]: `var(${cssVar}, ${mix.color})`
        };
    };




"use strict";
function $8c7cdd5120cc83e0$var$normalize(config) {
    return config;
}
function $8c7cdd5120cc83e0$var$normalizeConfig(config) {
    return (0, $9024565373fe4cd0$export$592ef47eabb05614)(config, (property, propertyConfig)=>[
            property,
            $8c7cdd5120cc83e0$var$normalize(propertyConfig)
        ]);
}
function $8c7cdd5120cc83e0$export$968c2adeac0c1baa(options) {
    const configs = $8c7cdd5120cc83e0$var$normalizeConfig(options.config);
    const tokens = options.tokens;
    const shorthands = /* @__PURE__ */ new Map();
    const propValues = /* @__PURE__ */ new Map();
    function register(property, config) {
        configs[property] = $8c7cdd5120cc83e0$var$normalize(config);
        assignProperty(property, config);
    }
    const assignProperty = (property, config)=>{
        const values = getPropertyValues(config);
        if (!values) return;
        propValues.set(property, values);
        assignPropertyType(property, config);
    };
    const assignProperties = ()=>{
        for (const [prop, config] of Object.entries(configs)){
            if (!config) continue;
            assignProperty(prop, config);
        }
    };
    const assignShorthands = ()=>{
        for (const [property, config] of Object.entries(configs)){
            const { shorthand: shorthand } = config ?? {};
            if (!shorthand) continue;
            const values = Array.isArray(shorthand) ? shorthand : [
                shorthand
            ];
            values.forEach((name)=>shorthands.set(name, property));
        }
    };
    const assignColorPaletteProperty = ()=>{
        const values = (0, $65f17ec84106bf2d$export$18dc39132a3e8c51)(tokens.colorPaletteMap);
        register("colorPalette", {
            values: Object.keys(values),
            transform: (0, $17d2a907250d4d6f$export$7c73462e0d25e514)((value)=>values[value])
        });
    };
    const propTypes = /* @__PURE__ */ new Map();
    const assignPropertyType = (property, config)=>{
        if (!config) return;
        const values = getPropertyValues(config, (key)=>`type:Tokens["${key}"]`);
        if (typeof values === "object" && values.type) {
            propTypes.set(property, /* @__PURE__ */ new Set([
                `type:${values.type}`
            ]));
            return;
        }
        if (values) {
            const keys2 = new Set(Object.keys(values));
            propTypes.set(property, keys2);
        }
        const set = propTypes.get(property) ?? /* @__PURE__ */ new Set();
        if (config.property) propTypes.set(property, set.add(`CssProperties["${config.property}"]`));
    };
    const assignPropertyTypes = ()=>{
        for (const [property, propertyConfig] of Object.entries(configs)){
            if (!propertyConfig) continue;
            assignPropertyType(property, propertyConfig);
        }
    };
    const addPropertyType = (property, type)=>{
        const set = propTypes.get(property) ?? /* @__PURE__ */ new Set();
        propTypes.set(property, /* @__PURE__ */ new Set([
            ...set,
            ...type
        ]));
    };
    const getTypes = ()=>{
        const map = /* @__PURE__ */ new Map();
        for (const [prop, values] of propTypes.entries()){
            if (values.size === 0) {
                map.set(prop, [
                    "string"
                ]);
                continue;
            }
            const typeValues = Array.from(values).map((key)=>{
                if (key.startsWith("CssProperties")) return key;
                if (key.startsWith("type:")) return key.replace("type:", "");
                return JSON.stringify(key);
            });
            map.set(prop, typeValues);
        }
        return map;
    };
    const getPropertyValues = (config, resolveFn)=>{
        const { values: values } = config;
        const fn = (key)=>{
            const value = resolveFn?.(key);
            return value ? {
                [value]: value
            } : void 0;
        };
        if ((0, $02f5f697eb6a66a5$export$844ec244b1367d54)(values)) return fn?.(values) ?? tokens.getCategoryValues(values) ?? (0, $a100815930a659d0$export$253fab909bb52269);
        if (Array.isArray(values)) {
            const result = {};
            for(let i = 0; i < values.length; i++)result[values[i]] = values[i];
            return result;
        }
        if ((0, $02f5f697eb6a66a5$export$f6e2535fb5126e54)(values)) return values(resolveFn ? fn : tokens.getCategoryValues);
        return values;
    };
    const defaultTransform = (0, $17d2a907250d4d6f$export$7c73462e0d25e514)((prop, value)=>{
        return {
            [prop]: prop.startsWith("--") ? tokens.getVar(value, value) : value
        };
    });
    const tokenFn = Object.assign(tokens.getVar, {
        raw: (path)=>tokens.getByName(path)
    });
    const transform = (0, $17d2a907250d4d6f$export$7c73462e0d25e514)((prop, raw)=>{
        const key = resolveShorthand(prop);
        if ((0, $02f5f697eb6a66a5$export$844ec244b1367d54)(raw) && !raw.includes("_EMO_")) raw = tokens.expandReferenceInValue(raw);
        const config = configs[key];
        if (!config) return defaultTransform(key, raw);
        const value = propValues.get(key)?.[raw];
        if (!config.transform) return defaultTransform(prop, value ?? raw);
        const _colorMix = (value2)=>(0, $143bade67be6bd19$export$9b476054b78b89cd)(value2, tokenFn);
        return config.transform(value ?? raw, {
            raw: raw,
            token: tokenFn,
            utils: {
                colorMix: _colorMix
            }
        });
    });
    function build() {
        assignShorthands();
        assignColorPaletteProperty();
        assignProperties();
        assignPropertyTypes();
    }
    build();
    const hasShorthand = shorthands.size > 0;
    const resolveShorthand = (0, $17d2a907250d4d6f$export$7c73462e0d25e514)((prop)=>{
        return shorthands.get(prop) ?? prop;
    });
    const keys = ()=>{
        return [
            ...Array.from(shorthands.keys()),
            ...Object.keys(configs)
        ];
    };
    const instance = {
        keys: keys,
        hasShorthand: hasShorthand,
        transform: transform,
        shorthands: shorthands,
        resolveShorthand: resolveShorthand,
        register: register,
        getTypes: getTypes,
        addPropertyType: addPropertyType
    };
    return instance;
}


"use strict";
function $39d60cdb5c92c6d4$export$b06ab6dfae3e7e3(...configs) {
    const config = (0, $e640443c3aa20e5d$export$5d86b86a654a7039)(...configs);
    const { theme: theme = {}, utilities: utilities = {}, globalCss: globalCss = {}, cssVarsRoot: cssVarsRoot = ":where(:root, :host)", cssVarsPrefix: cssVarsPrefix = "chakra", preflight: preflight } = config;
    const layers = (0, $caf18c878197cbf3$export$ddf51b1b91379574)(config);
    const tokens = (0, $8467bab47643e51e$export$b2a6cfa443dacae)({
        breakpoints: theme.breakpoints,
        tokens: theme.tokens,
        semanticTokens: theme.semanticTokens,
        prefix: cssVarsPrefix
    });
    const breakpoints = (0, $2f77fb784172d9f3$export$79e1df82cbbff4e9)(theme.breakpoints ?? (0, $a100815930a659d0$export$253fab909bb52269));
    const conditions = (0, $bb84a850d0d15696$export$4841b94afe59a0cf)({
        conditions: config.conditions ?? (0, $a100815930a659d0$export$253fab909bb52269),
        breakpoints: breakpoints
    });
    const utility = (0, $8c7cdd5120cc83e0$export$968c2adeac0c1baa)({
        config: utilities,
        tokens: tokens
    });
    function assignComposition() {
        const { textStyles: textStyles, layerStyles: layerStyles, animationStyles: animationStyles } = theme;
        const compositions = (0, $e1589b4b448a2f71$export$8e16b83750b44988)({
            textStyle: textStyles,
            layerStyle: layerStyles,
            animationStyle: animationStyles
        });
        for (const [key, values] of Object.entries(compositions)){
            const flatValues = (0, $507626d6ae9c4a68$export$bffa455ba8c619a6)(values ?? (0, $a100815930a659d0$export$253fab909bb52269), $39d60cdb5c92c6d4$var$stop);
            utility.register(key, {
                values: Object.keys(flatValues),
                transform (value) {
                    return css(flatValues[value]);
                }
            });
        }
    }
    assignComposition();
    utility.addPropertyType("animationName", Object.keys(theme.keyframes ?? (0, $a100815930a659d0$export$253fab909bb52269)));
    const properties = /* @__PURE__ */ new Set([
        "css",
        ...utility.keys(),
        ...conditions.keys()
    ]);
    const isValidProperty = (0, $17d2a907250d4d6f$export$7c73462e0d25e514)((prop)=>properties.has(prop) || (0, $95df779b5bd42a09$export$74465ce51e034ce6)(prop));
    const normalizeValue = (value)=>{
        if (Array.isArray(value)) {
            const result = (0, $a100815930a659d0$export$a72db9a51bf349f7)();
            for(let index = 0; index < value.length; index++){
                const current = value[index];
                if (current != null) {
                    const key = conditions.breakpoints[index];
                    result[key] = current;
                }
            }
            return result;
        }
        return value;
    };
    const normalizeFn = (0, $698b2604809f64d8$export$358f081847bfe3e3)({
        utility: utility,
        normalize: normalizeValue
    });
    const serialize = (0, $14da70852937ab14$export$173558e7ef6da591)({
        conditions: conditions,
        isValidProperty: isValidProperty
    });
    const css = (0, $6787b9161a75ec4e$export$7f714a6e05babb56)({
        transform: utility.transform,
        conditions: conditions,
        normalize: normalizeFn
    });
    const cva = (0, $faf7ac710b9eff40$export$439f157863edac93)({
        css: css,
        conditions: conditions,
        normalize: normalizeFn,
        layers: layers
    });
    const sva = (0, $740ef15e233f398b$export$6882452d1db83150)({
        cva: cva
    });
    function getTokenCss() {
        const result = {};
        for (const [key, values] of tokens.cssVarMap.entries()){
            const varsObj = Object.fromEntries(values);
            if (Object.keys(varsObj).length === 0) continue;
            const selector = key === "base" ? cssVarsRoot : conditions.resolve(key);
            const isAtRule = selector.startsWith("@");
            const cssObject = css(serialize({
                [selector]: isAtRule ? {
                    [cssVarsRoot]: varsObj
                } : varsObj
            }));
            (0, $3f37eeec613ba395$export$2ee76fde9ffe109d)(result, cssObject);
        }
        return layers.wrap("tokens", result);
    }
    function getGlobalCss() {
        const keyframes = (0, $9024565373fe4cd0$export$592ef47eabb05614)(theme.keyframes ?? (0, $a100815930a659d0$export$253fab909bb52269), (key, value)=>[
                `@keyframes ${key}`,
                value
            ]);
        const result = Object.assign({}, keyframes, css(serialize(globalCss)));
        return layers.wrap("base", result);
    }
    function splitCssProps(props) {
        return (0, $a3a5d89effecc869$export$45029c61b0073d87)(props, isValidProperty);
    }
    function getPreflightCss() {
        const result = (0, $d123664c87f223b7$export$33276ec412a73052)({
            preflight: preflight
        });
        return layers.wrap("reset", result);
    }
    const tokenMap = $39d60cdb5c92c6d4$var$getTokenMap(tokens);
    const tokenFn = (path, fallback)=>{
        return tokenMap.get(path)?.value || fallback;
    };
    tokenFn.var = (path, fallback)=>{
        return tokenMap.get(path)?.variable || fallback;
    };
    function getRecipe(key, fallback) {
        return theme.recipes?.[key] ?? fallback;
    }
    function getSlotRecipe(key, fallback) {
        return theme.slotRecipes?.[key] ?? fallback;
    }
    function isRecipe(key) {
        return Object.hasOwnProperty.call(theme.recipes ?? (0, $a100815930a659d0$export$253fab909bb52269), key);
    }
    function isSlotRecipe(key) {
        return Object.hasOwnProperty.call(theme.slotRecipes ?? (0, $a100815930a659d0$export$253fab909bb52269), key);
    }
    function hasRecipe(key) {
        return isRecipe(key) || isSlotRecipe(key);
    }
    const _global = [
        getPreflightCss(),
        getGlobalCss(),
        getTokenCss()
    ];
    const query = {
        layerStyles: $39d60cdb5c92c6d4$var$compositionQuery(theme.layerStyles ?? (0, $a100815930a659d0$export$253fab909bb52269)),
        textStyles: $39d60cdb5c92c6d4$var$compositionQuery(theme.textStyles ?? (0, $a100815930a659d0$export$253fab909bb52269)),
        animationStyles: $39d60cdb5c92c6d4$var$compositionQuery(theme.animationStyles ?? (0, $a100815930a659d0$export$253fab909bb52269)),
        tokens: $39d60cdb5c92c6d4$var$semanticTokenQuery(tokens, Object.keys(theme.tokens ?? (0, $a100815930a659d0$export$253fab909bb52269)), (value, key)=>!value.extensions.conditions && !key.includes("colorPalette")),
        semanticTokens: $39d60cdb5c92c6d4$var$semanticTokenQuery(tokens, Object.keys(theme.semanticTokens ?? (0, $a100815930a659d0$export$253fab909bb52269)), (value)=>!!value.extensions.conditions),
        keyframes: $39d60cdb5c92c6d4$var$basicQuery(theme.keyframes ?? (0, $a100815930a659d0$export$253fab909bb52269)),
        breakpoints: $39d60cdb5c92c6d4$var$basicQuery(theme.breakpoints ?? (0, $a100815930a659d0$export$253fab909bb52269))
    };
    return {
        $$chakra: true,
        _config: config,
        _global: _global,
        breakpoints: breakpoints,
        tokens: tokens,
        conditions: conditions,
        utility: utility,
        token: tokenFn,
        properties: properties,
        layers: layers,
        isValidProperty: isValidProperty,
        splitCssProps: splitCssProps,
        normalizeValue: normalizeValue,
        getTokenCss: getTokenCss,
        getGlobalCss: getGlobalCss,
        getPreflightCss: getPreflightCss,
        css: css,
        cva: cva,
        sva: sva,
        getRecipe: getRecipe,
        getSlotRecipe: getSlotRecipe,
        hasRecipe: hasRecipe,
        isRecipe: isRecipe,
        isSlotRecipe: isSlotRecipe,
        query: query
    };
}
function $39d60cdb5c92c6d4$var$getTokenMap(tokens) {
    const map = /* @__PURE__ */ new Map();
    tokens.allTokens.forEach((token)=>{
        const { cssVar: cssVar, virtual: virtual, conditions: conditions } = token.extensions;
        const value = !!conditions || virtual ? cssVar.ref : token.value;
        map.set(token.name, {
            value: value,
            variable: cssVar.ref
        });
    });
    return map;
}
const $39d60cdb5c92c6d4$export$50a73c89c311c4ca = (mod)=>{
    return (0, $02f5f697eb6a66a5$export$a6cdc56e425d0d0a)(mod) && !!Reflect.get(mod, "$$chakra");
};
const $39d60cdb5c92c6d4$var$stop = (v)=>(0, $02f5f697eb6a66a5$export$a6cdc56e425d0d0a)(v) && "value" in v;
const $39d60cdb5c92c6d4$var$compositionQuery = (dict)=>({
        list () {
            return Object.keys((0, $507626d6ae9c4a68$export$bffa455ba8c619a6)(dict, $39d60cdb5c92c6d4$var$stop));
        },
        search (query) {
            return this.list().filter((style)=>style.includes(query));
        }
    });
const $39d60cdb5c92c6d4$var$semanticTokenQuery = (tokens, categoryKeys, predicate)=>({
        categoryKeys: categoryKeys,
        list (category) {
            const map = tokens.categoryMap.get(category);
            const entries = map ? [
                ...map.entries()
            ] : [];
            const result = [];
            for(let i = 0; i < entries.length; i++){
                const [key, value] = entries[i];
                if (predicate(value, key)) result.push(key);
            }
            return result;
        },
        search (category, query) {
            return this.list(category).filter((style)=>style.includes(query));
        }
    });
const $39d60cdb5c92c6d4$var$basicQuery = (dict)=>({
        list () {
            return Object.keys(dict);
        },
        search (query) {
            return this.list().filter((style)=>style.includes(query));
        }
    });



"use strict";
const $a2f848fc882d4d28$export$d0de36da8d019bea = (v)=>v;
const $a2f848fc882d4d28$export$9ab6f981e4119117 = (v)=>v;
const $a2f848fc882d4d28$export$c28efc68fea5b4d6 = (v)=>v;
const $a2f848fc882d4d28$export$900dac1a2cda17d7 = (v)=>v;
const $a2f848fc882d4d28$export$22794656cac17ba4 = (v)=>v;
const $a2f848fc882d4d28$export$9a6b93c1c4f92839 = (v)=>v;
const $a2f848fc882d4d28$export$4e5d103345f1ef38 = (v)=>v;
const $a2f848fc882d4d28$export$cd834db0363565be = (v)=>v;
const $a2f848fc882d4d28$export$479138f860542d07 = (v)=>v;
function $a2f848fc882d4d28$var$createProxy() {
    const identity = (v)=>v;
    return new Proxy(identity, {
        get () {
            return identity;
        }
    });
}
const $a2f848fc882d4d28$export$8e135e7aaa7aabf6 = /* @__PURE__ */ $a2f848fc882d4d28$var$createProxy();
const $a2f848fc882d4d28$export$97e094f42fbe07cb = /* @__PURE__ */ $a2f848fc882d4d28$var$createProxy();
const $a2f848fc882d4d28$export$9e20b617fd74b180 = (v)=>v;



"use strict";
const $d843b0ee0da0e462$var$isCssVar = (v)=>/^var\(--.+\)$/.test(v);
const $d843b0ee0da0e462$var$wrap = (str, v)=>v != null ? `${str}(${v})` : v;
const $d843b0ee0da0e462$var$deg = (v)=>{
    if ($d843b0ee0da0e462$var$isCssVar(v) || v == null) return v;
    const unitless = typeof v === "string" && !v.endsWith("deg");
    return typeof v === "number" || unitless ? `${v}deg` : v;
};
const $d843b0ee0da0e462$var$createFocusRing = (selector)=>{
    return {
        values: [
            "outside",
            "inside",
            "mixed",
            "none"
        ],
        transform (value, { token: token }) {
            const focusRingColor = token("colors.colorPalette.focusRing");
            const styles = {
                inside: {
                    "--focus-ring-color": focusRingColor,
                    [selector]: {
                        outlineOffset: "0px",
                        outlineWidth: "var(--focus-ring-width, 1px)",
                        outlineColor: "var(--focus-ring-color)",
                        outlineStyle: "var(--focus-ring-style, solid)",
                        borderColor: "var(--focus-ring-color)"
                    }
                },
                outside: {
                    "--focus-ring-color": focusRingColor,
                    [selector]: {
                        outlineWidth: "var(--focus-ring-width, 2px)",
                        outlineOffset: "var(--focus-ring-offset, 2px)",
                        outlineStyle: "var(--focus-ring-style, solid)",
                        outlineColor: "var(--focus-ring-color)"
                    }
                },
                mixed: {
                    "--focus-ring-color": focusRingColor,
                    [selector]: {
                        outlineWidth: "var(--focus-ring-width, 3px)",
                        outlineStyle: "var(--focus-ring-style, solid)",
                        outlineColor: "color-mix(in srgb, var(--focus-ring-color), transparent 60%)",
                        borderColor: "var(--focus-ring-color)"
                    }
                },
                none: {
                    "--focus-ring-color": focusRingColor,
                    [selector]: {
                        outline: "none"
                    }
                }
            };
            return styles[value] ?? {};
        }
    };
};
const $d843b0ee0da0e462$var$divideColor = (0, $143bade67be6bd19$export$85907fd96ef7f08)("borderColor");
const $d843b0ee0da0e462$var$createTransition = (value)=>{
    return {
        transition: value,
        transitionTimingFunction: "cubic-bezier(0.4, 0, 0.2, 1)",
        transitionDuration: "150ms"
    };
};
const $d843b0ee0da0e462$export$f5b80887c0320fb6 = (0, $a2f848fc882d4d28$export$d0de36da8d019bea)({
    hover: [
        "@media (hover: hover)",
        "&:is(:hover, [data-hover]):not(:disabled, [data-disabled])"
    ],
    active: "&:is(:active, [data-active]):not(:disabled, [data-disabled], [data-state=open])",
    focus: "&:is(:focus, [data-focus])",
    focusWithin: "&:is(:focus-within, [data-focus-within])",
    focusVisible: "&:is(:focus-visible, [data-focus-visible])",
    disabled: "&:is(:disabled, [disabled], [data-disabled], [aria-disabled=true])",
    visited: "&:visited",
    target: "&:target",
    readOnly: "&:is([data-readonly], [aria-readonly=true], [readonly])",
    readWrite: "&:read-write",
    empty: "&:is(:empty, [data-empty])",
    checked: "&:is(:checked, [data-checked], [aria-checked=true], [data-state=checked])",
    enabled: "&:enabled",
    expanded: "&:is([aria-expanded=true], [data-expanded], [data-state=expanded])",
    highlighted: "&[data-highlighted]",
    complete: "&[data-complete]",
    incomplete: "&[data-incomplete]",
    dragging: "&[data-dragging]",
    before: "&::before",
    after: "&::after",
    firstLetter: "&::first-letter",
    firstLine: "&::first-line",
    marker: "&::marker",
    selection: "&::selection",
    file: "&::file-selector-button",
    backdrop: "&::backdrop",
    first: "&:first-of-type",
    last: "&:last-of-type",
    notFirst: "&:not(:first-of-type)",
    notLast: "&:not(:last-of-type)",
    only: "&:only-child",
    even: "&:nth-of-type(even)",
    odd: "&:nth-of-type(odd)",
    peerFocus: ".peer:is(:focus, [data-focus]) ~ &",
    peerHover: ".peer:is(:hover, [data-hover]):not(:disabled, [data-disabled]) ~ &",
    peerActive: ".peer:is(:active, [data-active]):not(:disabled, [data-disabled]) ~ &",
    peerFocusWithin: ".peer:focus-within ~ &",
    peerFocusVisible: ".peer:is(:focus-visible, [data-focus-visible]) ~ &",
    peerDisabled: ".peer:is(:disabled, [disabled], [data-disabled]) ~ &",
    peerChecked: ".peer:is(:checked, [data-checked], [aria-checked=true], [data-state=checked]) ~ &",
    peerInvalid: ".peer:is(:invalid, [data-invalid], [aria-invalid=true]) ~ &",
    peerExpanded: ".peer:is([aria-expanded=true], [data-expanded], [data-state=expanded]) ~ &",
    peerPlaceholderShown: ".peer:placeholder-shown ~ &",
    groupFocus: ".group:is(:focus, [data-focus]) &",
    groupHover: ".group:is(:hover, [data-hover]):not(:disabled, [data-disabled]) &",
    groupActive: ".group:is(:active, [data-active]):not(:disabled, [data-disabled]) &",
    groupFocusWithin: ".group:focus-within &",
    groupFocusVisible: ".group:is(:focus-visible, [data-focus-visible]) &",
    groupDisabled: ".group:is(:disabled, [disabled], [data-disabled]) &",
    groupChecked: ".group:is(:checked, [data-checked], [aria-checked=true], [data-state=checked]) &",
    groupExpanded: ".group:is([aria-expanded=true], [data-expanded], [data-state=expanded]) &",
    groupInvalid: ".group:invalid &",
    indeterminate: "&:is(:indeterminate, [data-indeterminate], [aria-checked=mixed], [data-state=indeterminate])",
    required: "&:is([data-required], [aria-required=true])",
    valid: "&:is([data-valid], [data-state=valid])",
    invalid: "&:is([data-invalid], [aria-invalid=true], [data-state=invalid])",
    autofill: "&:autofill",
    inRange: "&:is(:in-range, [data-in-range])",
    outOfRange: "&:is(:out-of-range, [data-outside-range])",
    placeholder: "&::placeholder, &[data-placeholder]",
    placeholderShown: "&:is(:placeholder-shown, [data-placeholder-shown])",
    pressed: "&:is([aria-pressed=true], [data-pressed])",
    selected: "&:is([aria-selected=true], [data-selected])",
    grabbed: "&:is([aria-grabbed=true], [data-grabbed])",
    underValue: "&[data-state=under-value]",
    overValue: "&[data-state=over-value]",
    atValue: "&[data-state=at-value]",
    default: "&:default",
    optional: "&:optional",
    open: "&:is([open], [data-open], [data-state=open])",
    closed: "&:is([closed], [data-closed], [data-state=closed])",
    fullscreen: "&:is(:fullscreen, [data-fullscreen])",
    loading: "&:is([data-loading], [aria-busy=true])",
    hidden: "&:is([hidden], [data-hidden])",
    current: "&[data-current]",
    currentPage: "&[aria-current=page]",
    currentStep: "&[aria-current=step]",
    today: "&[data-today]",
    unavailable: "&[data-unavailable]",
    rangeStart: "&[data-range-start]",
    rangeEnd: "&[data-range-end]",
    now: "&[data-now]",
    topmost: "&[data-topmost]",
    motionReduce: "@media (prefers-reduced-motion: reduce)",
    motionSafe: "@media (prefers-reduced-motion: no-preference)",
    print: "@media print",
    landscape: "@media (orientation: landscape)",
    portrait: "@media (orientation: portrait)",
    dark: ".dark &, .dark .chakra-theme:not(.light) &",
    light: ":root &, .light &",
    osDark: "@media (prefers-color-scheme: dark)",
    osLight: "@media (prefers-color-scheme: light)",
    highContrast: "@media (forced-colors: active)",
    lessContrast: "@media (prefers-contrast: less)",
    moreContrast: "@media (prefers-contrast: more)",
    ltr: "[dir=ltr] &",
    rtl: "[dir=rtl] &",
    scrollbar: "&::-webkit-scrollbar",
    scrollbarThumb: "&::-webkit-scrollbar-thumb",
    scrollbarTrack: "&::-webkit-scrollbar-track",
    horizontal: "&[data-orientation=horizontal]",
    vertical: "&[data-orientation=vertical]",
    icon: "& :where(svg)",
    starting: "@starting-style"
});
const $d843b0ee0da0e462$var$currentBgVar = (0, $d3817bdad33c74cf$export$8b4981022bd80a4e)("bg-currentcolor");
const $d843b0ee0da0e462$var$isCurrentBgVar = (value)=>value === $d843b0ee0da0e462$var$currentBgVar.ref || value === "currentBg";
const $d843b0ee0da0e462$var$colorValues = (theme)=>({
        ...theme("colors"),
        currentBg: $d843b0ee0da0e462$var$currentBgVar
    });
const $d843b0ee0da0e462$export$68b8fa3a393a40ba = (0, $a2f848fc882d4d28$export$9e20b617fd74b180)({
    conditions: $d843b0ee0da0e462$export$f5b80887c0320fb6,
    utilities: {
        // background
        background: {
            values: $d843b0ee0da0e462$var$colorValues,
            shorthand: [
                "bg"
            ],
            transform (value, args) {
                if ($d843b0ee0da0e462$var$isCurrentBgVar(args.raw)) return {
                    background: $d843b0ee0da0e462$var$currentBgVar.ref
                };
                const styleObj = (0, $143bade67be6bd19$export$85907fd96ef7f08)("background")(value, args);
                return {
                    ...styleObj,
                    [$d843b0ee0da0e462$var$currentBgVar.var]: styleObj?.background
                };
            }
        },
        backgroundColor: {
            values: $d843b0ee0da0e462$var$colorValues,
            shorthand: [
                "bgColor"
            ],
            transform (value, args) {
                if ($d843b0ee0da0e462$var$isCurrentBgVar(args.raw)) return {
                    backgroundColor: $d843b0ee0da0e462$var$currentBgVar.ref
                };
                const styleObj = (0, $143bade67be6bd19$export$85907fd96ef7f08)("backgroundColor")(value, args);
                return {
                    ...styleObj,
                    [$d843b0ee0da0e462$var$currentBgVar.var]: styleObj?.backgroundColor
                };
            }
        },
        backgroundSize: {
            shorthand: [
                "bgSize"
            ]
        },
        backgroundPosition: {
            shorthand: [
                "bgPos"
            ]
        },
        backgroundRepeat: {
            shorthand: [
                "bgRepeat"
            ]
        },
        backgroundAttachment: {
            shorthand: [
                "bgAttachment"
            ]
        },
        backgroundClip: {
            shorthand: [
                "bgClip"
            ],
            values: [
                "text"
            ],
            transform (value) {
                return value === "text" ? {
                    color: "transparent",
                    backgroundClip: "text"
                } : {
                    backgroundClip: value
                };
            }
        },
        backgroundGradient: {
            shorthand: [
                "bgGradient"
            ],
            values (theme) {
                return {
                    ...theme("gradients"),
                    "to-t": "linear-gradient(to top, var(--gradient))",
                    "to-tr": "linear-gradient(to top right, var(--gradient))",
                    "to-r": "linear-gradient(to right, var(--gradient))",
                    "to-br": "linear-gradient(to bottom right, var(--gradient))",
                    "to-b": "linear-gradient(to bottom, var(--gradient))",
                    "to-bl": "linear-gradient(to bottom left, var(--gradient))",
                    "to-l": "linear-gradient(to left, var(--gradient))",
                    "to-tl": "linear-gradient(to top left, var(--gradient))"
                };
            },
            transform (value) {
                return {
                    "--gradient-stops": "var(--gradient-from), var(--gradient-to)",
                    "--gradient": "var(--gradient-via-stops, var(--gradient-stops))",
                    backgroundImage: value
                };
            }
        },
        gradientFrom: {
            values: $d843b0ee0da0e462$var$colorValues,
            transform: (0, $143bade67be6bd19$export$85907fd96ef7f08)("--gradient-from")
        },
        gradientTo: {
            values: $d843b0ee0da0e462$var$colorValues,
            transform: (0, $143bade67be6bd19$export$85907fd96ef7f08)("--gradient-to")
        },
        gradientVia: {
            values: $d843b0ee0da0e462$var$colorValues,
            transform (value, args) {
                const styles = (0, $143bade67be6bd19$export$85907fd96ef7f08)("--gradient-via")(value, args);
                return {
                    ...styles,
                    "--gradient-via-stops": "var(--gradient-from), var(--gradient-via), var(--gradient-to)"
                };
            }
        },
        backgroundImage: {
            values (theme) {
                return {
                    ...theme("gradients"),
                    ...theme("assets")
                };
            },
            shorthand: [
                "bgImg",
                "bgImage"
            ]
        },
        // border
        border: {
            values: "borders"
        },
        borderTop: {
            values: "borders"
        },
        borderLeft: {
            values: "borders"
        },
        borderBlockStart: {
            values: "borders"
        },
        borderRight: {
            values: "borders"
        },
        borderBottom: {
            values: "borders"
        },
        borderBlockEnd: {
            values: "borders"
        },
        borderInlineStart: {
            values: "borders",
            shorthand: [
                "borderStart"
            ]
        },
        borderInlineEnd: {
            values: "borders",
            shorthand: [
                "borderEnd"
            ]
        },
        borderInline: {
            values: "borders",
            shorthand: [
                "borderX"
            ]
        },
        borderBlock: {
            values: "borders",
            shorthand: [
                "borderY"
            ]
        },
        // border colors
        borderColor: {
            values: $d843b0ee0da0e462$var$colorValues,
            transform: (0, $143bade67be6bd19$export$85907fd96ef7f08)("borderColor")
        },
        borderTopColor: {
            values: $d843b0ee0da0e462$var$colorValues,
            transform: (0, $143bade67be6bd19$export$85907fd96ef7f08)("borderTopColor")
        },
        borderBlockStartColor: {
            values: $d843b0ee0da0e462$var$colorValues,
            transform: (0, $143bade67be6bd19$export$85907fd96ef7f08)("borderBlockStartColor")
        },
        borderBottomColor: {
            values: $d843b0ee0da0e462$var$colorValues,
            transform: (0, $143bade67be6bd19$export$85907fd96ef7f08)("borderBottomColor")
        },
        borderBlockEndColor: {
            values: $d843b0ee0da0e462$var$colorValues,
            transform: (0, $143bade67be6bd19$export$85907fd96ef7f08)("borderBlockEndColor")
        },
        borderLeftColor: {
            values: $d843b0ee0da0e462$var$colorValues,
            transform: (0, $143bade67be6bd19$export$85907fd96ef7f08)("borderLeftColor")
        },
        borderInlineStartColor: {
            values: $d843b0ee0da0e462$var$colorValues,
            shorthand: [
                "borderStartColor"
            ],
            transform: (0, $143bade67be6bd19$export$85907fd96ef7f08)("borderInlineStartColor")
        },
        borderRightColor: {
            values: $d843b0ee0da0e462$var$colorValues,
            transform: (0, $143bade67be6bd19$export$85907fd96ef7f08)("borderRightColor")
        },
        borderInlineEndColor: {
            values: $d843b0ee0da0e462$var$colorValues,
            shorthand: [
                "borderEndColor"
            ],
            transform: (0, $143bade67be6bd19$export$85907fd96ef7f08)("borderInlineEndColor")
        },
        // border styles
        borderStyle: {
            values: "borderStyles"
        },
        borderTopStyle: {
            values: "borderStyles"
        },
        borderBlockStartStyle: {
            values: "borderStyles"
        },
        borderBottomStyle: {
            values: "borderStyles"
        },
        borderBlockEndStyle: {
            values: "borderStyles"
        },
        borderInlineStartStyle: {
            values: "borderStyles",
            shorthand: [
                "borderStartStyle"
            ]
        },
        borderInlineEndStyle: {
            values: "borderStyles",
            shorthand: [
                "borderEndStyle"
            ]
        },
        borderLeftStyle: {
            values: "borderStyles"
        },
        borderRightStyle: {
            values: "borderStyles"
        },
        // border radius
        borderRadius: {
            values: "radii",
            shorthand: [
                "rounded"
            ]
        },
        borderTopLeftRadius: {
            values: "radii",
            shorthand: [
                "roundedTopLeft"
            ]
        },
        borderStartStartRadius: {
            values: "radii",
            shorthand: [
                "roundedStartStart",
                "borderTopStartRadius"
            ]
        },
        borderEndStartRadius: {
            values: "radii",
            shorthand: [
                "roundedEndStart",
                "borderBottomStartRadius"
            ]
        },
        borderTopRightRadius: {
            values: "radii",
            shorthand: [
                "roundedTopRight"
            ]
        },
        borderStartEndRadius: {
            values: "radii",
            shorthand: [
                "roundedStartEnd",
                "borderTopEndRadius"
            ]
        },
        borderEndEndRadius: {
            values: "radii",
            shorthand: [
                "roundedEndEnd",
                "borderBottomEndRadius"
            ]
        },
        borderBottomLeftRadius: {
            values: "radii",
            shorthand: [
                "roundedBottomLeft"
            ]
        },
        borderBottomRightRadius: {
            values: "radii",
            shorthand: [
                "roundedBottomRight"
            ]
        },
        borderInlineStartRadius: {
            values: "radii",
            property: "borderRadius",
            shorthand: [
                "roundedStart",
                "borderStartRadius"
            ],
            transform: (value)=>({
                    borderStartStartRadius: value,
                    borderEndStartRadius: value
                })
        },
        borderInlineEndRadius: {
            values: "radii",
            property: "borderRadius",
            shorthand: [
                "roundedEnd",
                "borderEndRadius"
            ],
            transform: (value)=>({
                    borderStartEndRadius: value,
                    borderEndEndRadius: value
                })
        },
        borderTopRadius: {
            values: "radii",
            property: "borderRadius",
            shorthand: [
                "roundedTop"
            ],
            transform: (value)=>({
                    borderTopLeftRadius: value,
                    borderTopRightRadius: value
                })
        },
        borderBottomRadius: {
            values: "radii",
            property: "borderRadius",
            shorthand: [
                "roundedBottom"
            ],
            transform: (value)=>({
                    borderBottomLeftRadius: value,
                    borderBottomRightRadius: value
                })
        },
        borderLeftRadius: {
            values: "radii",
            property: "borderRadius",
            shorthand: [
                "roundedLeft"
            ],
            transform: (value)=>({
                    borderTopLeftRadius: value,
                    borderBottomLeftRadius: value
                })
        },
        borderRightRadius: {
            values: "radii",
            property: "borderRadius",
            shorthand: [
                "roundedRight"
            ],
            transform: (value)=>({
                    borderTopRightRadius: value,
                    borderBottomRightRadius: value
                })
        },
        borderWidth: {
            values: "borderWidths"
        },
        borderBlockStartWidth: {
            values: "borderWidths"
        },
        borderTopWidth: {
            values: "borderWidths"
        },
        borderBottomWidth: {
            values: "borderWidths"
        },
        borderBlockEndWidth: {
            values: "borderWidths"
        },
        borderRightWidth: {
            values: "borderWidths"
        },
        borderInlineWidth: {
            values: "borderWidths",
            shorthand: [
                "borderXWidth"
            ]
        },
        borderInlineStartWidth: {
            values: "borderWidths",
            shorthand: [
                "borderStartWidth"
            ]
        },
        borderInlineEndWidth: {
            values: "borderWidths",
            shorthand: [
                "borderEndWidth"
            ]
        },
        borderLeftWidth: {
            values: "borderWidths"
        },
        borderBlockWidth: {
            values: "borderWidths",
            shorthand: [
                "borderYWidth"
            ]
        },
        // colors
        color: {
            values: $d843b0ee0da0e462$var$colorValues,
            transform: (0, $143bade67be6bd19$export$85907fd96ef7f08)("color")
        },
        fill: {
            values: $d843b0ee0da0e462$var$colorValues,
            transform: (0, $143bade67be6bd19$export$85907fd96ef7f08)("fill")
        },
        stroke: {
            values: $d843b0ee0da0e462$var$colorValues,
            transform: (0, $143bade67be6bd19$export$85907fd96ef7f08)("stroke")
        },
        accentColor: {
            values: $d843b0ee0da0e462$var$colorValues,
            transform: (0, $143bade67be6bd19$export$85907fd96ef7f08)("accentColor")
        },
        // divide
        divideX: {
            values: {
                type: "string"
            },
            transform (value) {
                return {
                    "& > :not(style, [hidden]) ~ :not(style, [hidden])": {
                        borderInlineStartWidth: value,
                        borderInlineEndWidth: "0px"
                    }
                };
            }
        },
        divideY: {
            values: {
                type: "string"
            },
            transform (value) {
                return {
                    "& > :not(style, [hidden]) ~ :not(style, [hidden])": {
                        borderTopWidth: value,
                        borderBottomWidth: "0px"
                    }
                };
            }
        },
        divideColor: {
            values: $d843b0ee0da0e462$var$colorValues,
            transform (value, args) {
                return {
                    "& > :not(style, [hidden]) ~ :not(style, [hidden])": $d843b0ee0da0e462$var$divideColor(value, args)
                };
            }
        },
        divideStyle: {
            property: "borderStyle",
            transform (value) {
                return {
                    "& > :not(style, [hidden]) ~ :not(style, [hidden])": {
                        borderStyle: value
                    }
                };
            }
        },
        // effects
        boxShadow: {
            values: "shadows",
            shorthand: [
                "shadow"
            ]
        },
        boxShadowColor: {
            values: $d843b0ee0da0e462$var$colorValues,
            transform: (0, $143bade67be6bd19$export$85907fd96ef7f08)("--shadow-color"),
            shorthand: [
                "shadowColor"
            ]
        },
        mixBlendMode: {
            shorthand: [
                "blendMode"
            ]
        },
        backgroundBlendMode: {
            shorthand: [
                "bgBlendMode"
            ]
        },
        opacity: {
            values: "opacity"
        },
        // filters
        filter: {
            transform (v) {
                if (v !== "auto") return {
                    filter: v
                };
                return {
                    filter: `var(--blur) var(--brightness) var(--contrast) var(--grayscale) var(--hue-rotate) var(--invert) var(--saturate) var(--sepia) var(--drop-shadow)`
                };
            }
        },
        blur: {
            values: "blurs",
            transform: (v)=>({
                    "--blur": $d843b0ee0da0e462$var$wrap("blur", v)
                })
        },
        brightness: {
            transform: (v)=>({
                    "--brightness": $d843b0ee0da0e462$var$wrap("brightness", v)
                })
        },
        contrast: {
            transform: (v)=>({
                    "--contrast": $d843b0ee0da0e462$var$wrap("contrast", v)
                })
        },
        grayscale: {
            transform: (v)=>({
                    "--grayscale": $d843b0ee0da0e462$var$wrap("grayscale", v)
                })
        },
        hueRotate: {
            transform: (v)=>({
                    "--hue-rotate": $d843b0ee0da0e462$var$wrap("hue-rotate", $d843b0ee0da0e462$var$deg(v))
                })
        },
        invert: {
            transform: (v)=>({
                    "--invert": $d843b0ee0da0e462$var$wrap("invert", v)
                })
        },
        saturate: {
            transform: (v)=>({
                    "--saturate": $d843b0ee0da0e462$var$wrap("saturate", v)
                })
        },
        sepia: {
            transform: (v)=>({
                    "--sepia": $d843b0ee0da0e462$var$wrap("sepia", v)
                })
        },
        dropShadow: {
            transform: (v)=>({
                    "--drop-shadow": $d843b0ee0da0e462$var$wrap("drop-shadow", v)
                })
        },
        // backdrop filters
        backdropFilter: {
            transform (v) {
                if (v !== "auto") return {
                    backdropFilter: v
                };
                return {
                    backdropFilter: `var(--backdrop-blur) var(--backdrop-brightness) var(--backdrop-contrast) var(--backdrop-grayscale) var(--backdrop-hue-rotate) var(--backdrop-invert) var(--backdrop-opacity) var(--backdrop-saturate) var(--backdrop-sepia)`
                };
            }
        },
        backdropBlur: {
            values: "blurs",
            transform: (v)=>({
                    "--backdrop-blur": $d843b0ee0da0e462$var$wrap("blur", v)
                })
        },
        backdropBrightness: {
            transform: (v)=>({
                    "--backdrop-brightness": $d843b0ee0da0e462$var$wrap("brightness", v)
                })
        },
        backdropContrast: {
            transform: (v)=>({
                    "--backdrop-contrast": $d843b0ee0da0e462$var$wrap("contrast", v)
                })
        },
        backdropGrayscale: {
            transform: (v)=>({
                    "--backdrop-grayscale": $d843b0ee0da0e462$var$wrap("grayscale", v)
                })
        },
        backdropHueRotate: {
            transform: (v)=>({
                    "--backdrop-hue-rotate": $d843b0ee0da0e462$var$wrap("hue-rotate", $d843b0ee0da0e462$var$deg(v))
                })
        },
        backdropInvert: {
            transform: (v)=>({
                    "--backdrop-invert": $d843b0ee0da0e462$var$wrap("invert", v)
                })
        },
        backdropOpacity: {
            transform: (v)=>({
                    "--backdrop-opacity": $d843b0ee0da0e462$var$wrap("opacity", v)
                })
        },
        backdropSaturate: {
            transform: (v)=>({
                    "--backdrop-saturate": $d843b0ee0da0e462$var$wrap("saturate", v)
                })
        },
        backdropSepia: {
            transform: (v)=>({
                    "--backdrop-sepia": $d843b0ee0da0e462$var$wrap("sepia", v)
                })
        },
        // flexbox
        flexBasis: {
            values: "sizes"
        },
        gap: {
            values: "spacing"
        },
        rowGap: {
            values: "spacing",
            shorthand: [
                "gapY"
            ]
        },
        columnGap: {
            values: "spacing",
            shorthand: [
                "gapX"
            ]
        },
        flexDirection: {
            shorthand: [
                "flexDir"
            ]
        },
        // grid
        gridGap: {
            values: "spacing"
        },
        gridColumnGap: {
            values: "spacing"
        },
        gridRowGap: {
            values: "spacing"
        },
        // interactivity
        outlineColor: {
            values: $d843b0ee0da0e462$var$colorValues,
            transform: (0, $143bade67be6bd19$export$85907fd96ef7f08)("outlineColor")
        },
        focusRing: $d843b0ee0da0e462$var$createFocusRing("&:is(:focus, [data-focus])"),
        focusVisibleRing: $d843b0ee0da0e462$var$createFocusRing("&:is(:focus-visible, [data-focus-visible])"),
        focusRingColor: {
            values: $d843b0ee0da0e462$var$colorValues,
            transform: (0, $143bade67be6bd19$export$85907fd96ef7f08)("--focus-ring-color")
        },
        focusRingOffset: {
            values: "spacing",
            transform: (v)=>({
                    "--focus-ring-offset": v
                })
        },
        focusRingWidth: {
            values: "borderWidths",
            property: "outlineWidth",
            transform: (v)=>({
                    "--focus-ring-width": v
                })
        },
        focusRingStyle: {
            values: "borderStyles",
            property: "outlineStyle",
            transform: (v)=>({
                    "--focus-ring-style": v
                })
        },
        // layout
        aspectRatio: {
            values: "aspectRatios"
        },
        width: {
            values: "sizes",
            shorthand: [
                "w"
            ]
        },
        inlineSize: {
            values: "sizes"
        },
        height: {
            values: "sizes",
            shorthand: [
                "h"
            ]
        },
        blockSize: {
            values: "sizes"
        },
        boxSize: {
            values: "sizes",
            property: "width",
            transform: (v)=>({
                    width: v,
                    height: v
                })
        },
        minWidth: {
            values: "sizes",
            shorthand: [
                "minW"
            ]
        },
        minInlineSize: {
            values: "sizes"
        },
        minHeight: {
            values: "sizes",
            shorthand: [
                "minH"
            ]
        },
        minBlockSize: {
            values: "sizes"
        },
        maxWidth: {
            values: "sizes",
            shorthand: [
                "maxW"
            ]
        },
        maxInlineSize: {
            values: "sizes"
        },
        maxHeight: {
            values: "sizes",
            shorthand: [
                "maxH"
            ]
        },
        maxBlockSize: {
            values: "sizes"
        },
        hideFrom: {
            values: "breakpoints",
            //@ts-ignore
            transform: (value, { raw: raw, token: token })=>{
                const bp = token.raw(`breakpoints.${raw}`);
                const media = bp ? `@breakpoint ${raw}` : `@media screen and (min-width: ${value})`;
                return {
                    [media]: {
                        display: "none"
                    }
                };
            }
        },
        hideBelow: {
            values: "breakpoints",
            //@ts-ignore
            transform (value, { raw: raw, token: token }) {
                const bp = token.raw(`breakpoints.${raw}`);
                const media = bp ? `@breakpoint ${raw}Down` : `@media screen and (max-width: ${value})`;
                return {
                    [media]: {
                        display: "none"
                    }
                };
            }
        },
        // scroll
        overscrollBehavior: {
            shorthand: [
                "overscroll"
            ]
        },
        overscrollBehaviorX: {
            shorthand: [
                "overscrollX"
            ]
        },
        overscrollBehaviorY: {
            shorthand: [
                "overscrollY"
            ]
        },
        scrollbar: {
            values: [
                "visible",
                "hidden"
            ],
            transform (v) {
                switch(v){
                    case "visible":
                        return {
                            msOverflowStyle: "auto",
                            scrollbarWidth: "auto",
                            "&::-webkit-scrollbar": {
                                display: "block"
                            }
                        };
                    case "hidden":
                        return {
                            msOverflowStyle: "none",
                            scrollbarWidth: "none",
                            "&::-webkit-scrollbar": {
                                display: "none"
                            }
                        };
                    default:
                        return {};
                }
            }
        },
        scrollbarColor: {
            values: $d843b0ee0da0e462$var$colorValues,
            transform: (0, $143bade67be6bd19$export$85907fd96ef7f08)("scrollbarColor")
        },
        scrollbarGutter: {
            values: "spacing"
        },
        scrollbarWidth: {
            values: "sizes"
        },
        // scroll margin
        scrollMargin: {
            values: "spacing"
        },
        scrollMarginTop: {
            values: "spacing"
        },
        scrollMarginBottom: {
            values: "spacing"
        },
        scrollMarginLeft: {
            values: "spacing"
        },
        scrollMarginRight: {
            values: "spacing"
        },
        scrollMarginX: {
            values: "spacing",
            transform: (v)=>({
                    scrollMarginLeft: v,
                    scrollMarginRight: v
                })
        },
        scrollMarginY: {
            values: "spacing",
            transform: (v)=>({
                    scrollMarginTop: v,
                    scrollMarginBottom: v
                })
        },
        // scroll padding
        scrollPadding: {
            values: "spacing"
        },
        scrollPaddingTop: {
            values: "spacing"
        },
        scrollPaddingBottom: {
            values: "spacing"
        },
        scrollPaddingLeft: {
            values: "spacing"
        },
        scrollPaddingRight: {
            values: "spacing"
        },
        scrollPaddingInline: {
            values: "spacing",
            shorthand: [
                "scrollPaddingX"
            ]
        },
        scrollPaddingBlock: {
            values: "spacing",
            shorthand: [
                "scrollPaddingY"
            ]
        },
        // scroll snap
        scrollSnapType: {
            values: {
                none: "none",
                x: "x var(--scroll-snap-strictness)",
                y: "y var(--scroll-snap-strictness)",
                both: "both var(--scroll-snap-strictness)"
            }
        },
        scrollSnapStrictness: {
            values: [
                "mandatory",
                "proximity"
            ],
            transform: (v)=>({
                    "--scroll-snap-strictness": v
                })
        },
        scrollSnapMargin: {
            values: "spacing"
        },
        scrollSnapMarginTop: {
            values: "spacing"
        },
        scrollSnapMarginBottom: {
            values: "spacing"
        },
        scrollSnapMarginLeft: {
            values: "spacing"
        },
        scrollSnapMarginRight: {
            values: "spacing"
        },
        // list
        listStylePosition: {
            shorthand: [
                "listStylePos"
            ]
        },
        listStyleImage: {
            values: "assets",
            shorthand: [
                "listStyleImg"
            ]
        },
        // position
        position: {
            shorthand: [
                "pos"
            ]
        },
        zIndex: {
            values: "zIndex"
        },
        inset: {
            values: "spacing"
        },
        insetInline: {
            values: "spacing",
            shorthand: [
                "insetX"
            ]
        },
        insetBlock: {
            values: "spacing",
            shorthand: [
                "insetY"
            ]
        },
        top: {
            values: "spacing"
        },
        insetBlockStart: {
            values: "spacing"
        },
        bottom: {
            values: "spacing"
        },
        insetBlockEnd: {
            values: "spacing"
        },
        left: {
            values: "spacing"
        },
        right: {
            values: "spacing"
        },
        insetInlineStart: {
            values: "spacing",
            shorthand: [
                "insetStart"
            ]
        },
        insetInlineEnd: {
            values: "spacing",
            shorthand: [
                "insetEnd"
            ]
        },
        // shadow / ring
        ring: {
            transform (value) {
                return {
                    "--ring-offset-shadow": `var(--ring-inset) 0 0 0 var(--ring-offset-width) var(--ring-offset-color)`,
                    "--ring-shadow": `var(--ring-inset) 0 0 0 calc(var(--ring-width) + var(--ring-offset-width)) var(--ring-color)`,
                    "--ring-width": value,
                    boxShadow: "var(--ring-offset-shadow), var(--ring-shadow), var(--shadow, 0 0 #0000)"
                };
            }
        },
        ringColor: {
            values: $d843b0ee0da0e462$var$colorValues,
            transform: (0, $143bade67be6bd19$export$85907fd96ef7f08)("--ring-color")
        },
        ringOffset: {
            transform: (value)=>({
                    "--ring-offset-width": value
                })
        },
        ringOffsetColor: {
            values: $d843b0ee0da0e462$var$colorValues,
            transform: (0, $143bade67be6bd19$export$85907fd96ef7f08)("--ring-offset-color")
        },
        ringInset: {
            transform: (v)=>({
                    "--ring-inset": v
                })
        },
        // margin
        margin: {
            values: "spacing",
            shorthand: [
                "m"
            ]
        },
        marginTop: {
            values: "spacing",
            shorthand: [
                "mt"
            ]
        },
        marginBlockStart: {
            values: "spacing"
        },
        marginRight: {
            values: "spacing",
            shorthand: [
                "mr"
            ]
        },
        marginBottom: {
            values: "spacing",
            shorthand: [
                "mb"
            ]
        },
        marginBlockEnd: {
            values: "spacing"
        },
        marginLeft: {
            values: "spacing",
            shorthand: [
                "ml"
            ]
        },
        marginInlineStart: {
            values: "spacing",
            shorthand: [
                "ms",
                "marginStart"
            ]
        },
        marginInlineEnd: {
            values: "spacing",
            shorthand: [
                "me",
                "marginEnd"
            ]
        },
        marginInline: {
            values: "spacing",
            shorthand: [
                "mx",
                "marginX"
            ]
        },
        marginBlock: {
            values: "spacing",
            shorthand: [
                "my",
                "marginY"
            ]
        },
        // padding
        padding: {
            values: "spacing",
            shorthand: [
                "p"
            ]
        },
        paddingTop: {
            values: "spacing",
            shorthand: [
                "pt"
            ]
        },
        paddingRight: {
            values: "spacing",
            shorthand: [
                "pr"
            ]
        },
        paddingBottom: {
            values: "spacing",
            shorthand: [
                "pb"
            ]
        },
        paddingBlockStart: {
            values: "spacing"
        },
        paddingBlockEnd: {
            values: "spacing"
        },
        paddingLeft: {
            values: "spacing",
            shorthand: [
                "pl"
            ]
        },
        paddingInlineStart: {
            values: "spacing",
            shorthand: [
                "ps",
                "paddingStart"
            ]
        },
        paddingInlineEnd: {
            values: "spacing",
            shorthand: [
                "pe",
                "paddingEnd"
            ]
        },
        paddingInline: {
            values: "spacing",
            shorthand: [
                "px",
                "paddingX"
            ]
        },
        paddingBlock: {
            values: "spacing",
            shorthand: [
                "py",
                "paddingY"
            ]
        },
        // text decoration
        textDecoration: {
            shorthand: [
                "textDecor"
            ]
        },
        textDecorationColor: {
            values: $d843b0ee0da0e462$var$colorValues,
            transform: (0, $143bade67be6bd19$export$85907fd96ef7f08)("textDecorationColor")
        },
        textShadow: {
            values: "shadows"
        },
        // transform
        transform: {
            transform: (value)=>{
                let v = value;
                if (value === "auto") v = `translateX(var(--translate-x, 0)) translateY(var(--translate-y, 0)) rotate(var(--rotate, 0)) scaleX(var(--scale-x, 1)) scaleY(var(--scale-y, 1)) skewX(var(--skew-x, 0)) skewY(var(--skew-y, 0))`;
                if (value === "auto-gpu") v = `translate3d(var(--translate-x, 0), var(--translate-y, 0), 0) rotate(var(--rotate, 0)) scaleX(var(--scale-x, 1)) scaleY(var(--scale-y, 1)) skewX(var(--skew-x, 0)) skewY(var(--skew-y, 0))`;
                return {
                    transform: v
                };
            }
        },
        skewX: {
            transform: (v)=>({
                    "--skew-x": $d843b0ee0da0e462$var$deg(v)
                })
        },
        skewY: {
            transform: (v)=>({
                    "--skew-y": $d843b0ee0da0e462$var$deg(v)
                })
        },
        scaleX: {
            transform: (v)=>({
                    "--scale-x": v
                })
        },
        scaleY: {
            transform: (v)=>({
                    "--scale-y": v
                })
        },
        scale: {
            transform (value) {
                if (value !== "auto") return {
                    scale: value
                };
                return {
                    scale: `var(--scale-x, 1) var(--scale-y, 1)`
                };
            }
        },
        spaceXReverse: {
            values: {
                type: "boolean"
            },
            transform (value) {
                return {
                    "& > :not(style, [hidden]) ~ :not(style, [hidden])": {
                        "--space-x-reverse": value ? "1" : void 0
                    }
                };
            }
        },
        spaceX: {
            property: "marginInlineStart",
            values: "spacing",
            transform: (v)=>({
                    "& > :not(style, [hidden]) ~ :not(style, [hidden])": {
                        "--space-x-reverse": "0",
                        marginInlineStart: `calc(${v} * calc(1 - var(--space-x-reverse)))`,
                        marginInlineEnd: `calc(${v} * var(--space-x-reverse))`
                    }
                })
        },
        spaceYReverse: {
            values: {
                type: "boolean"
            },
            transform (value) {
                return {
                    "& > :not(style, [hidden]) ~ :not(style, [hidden])": {
                        "--space-y-reverse": value ? "1" : void 0
                    }
                };
            }
        },
        spaceY: {
            property: "marginTop",
            values: "spacing",
            transform: (v)=>({
                    "& > :not(style, [hidden]) ~ :not(style, [hidden])": {
                        "--space-y-reverse": "0",
                        marginTop: `calc(${v} * calc(1 - var(--space-y-reverse)))`,
                        marginBottom: `calc(${v} * var(--space-y-reverse))`
                    }
                })
        },
        rotate: {
            transform (value) {
                if (value !== "auto") return {
                    rotate: $d843b0ee0da0e462$var$deg(value)
                };
                return {
                    rotate: `var(--rotate-x, 0) var(--rotate-y, 0) var(--rotate-z, 0)`
                };
            }
        },
        rotateX: {
            transform (value) {
                return {
                    "--rotate-x": $d843b0ee0da0e462$var$deg(value)
                };
            }
        },
        rotateY: {
            transform (value) {
                return {
                    "--rotate-y": $d843b0ee0da0e462$var$deg(value)
                };
            }
        },
        // transform / translate
        translate: {
            transform (value) {
                if (value !== "auto") return {
                    translate: value
                };
                return {
                    translate: `var(--translate-x) var(--translate-y)`
                };
            }
        },
        translateX: {
            values: "spacing",
            transform: (v)=>({
                    "--translate-x": v
                })
        },
        translateY: {
            values: "spacing",
            transform: (v)=>({
                    "--translate-y": v
                })
        },
        // transition
        transition: {
            values: [
                "all",
                "common",
                "colors",
                "opacity",
                "position",
                "backgrounds",
                "size",
                "shadow",
                "transform"
            ],
            transform (value) {
                switch(value){
                    case "all":
                        return $d843b0ee0da0e462$var$createTransition("all");
                    case "position":
                        return $d843b0ee0da0e462$var$createTransition("left, right, top, bottom, inset-inline, inset-block");
                    case "colors":
                        return $d843b0ee0da0e462$var$createTransition("color, background-color, border-color, text-decoration-color, fill, stroke");
                    case "opacity":
                        return $d843b0ee0da0e462$var$createTransition("opacity");
                    case "shadow":
                        return $d843b0ee0da0e462$var$createTransition("box-shadow");
                    case "transform":
                        return $d843b0ee0da0e462$var$createTransition("transform");
                    case "size":
                        return $d843b0ee0da0e462$var$createTransition("width, height");
                    case "backgrounds":
                        return $d843b0ee0da0e462$var$createTransition("background, background-color, background-image, background-position");
                    case "common":
                        return $d843b0ee0da0e462$var$createTransition("color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter");
                    default:
                        return {
                            transition: value
                        };
                }
            }
        },
        transitionDuration: {
            values: "durations"
        },
        transitionProperty: {
            values: {
                common: "background-color, border-color, color, fill, stroke, opacity, box-shadow, translate, transform",
                colors: "background-color, border-color, color, fill, stroke",
                size: "width, height",
                position: "left, right, top, bottom, inset-inline, inset-block",
                background: "background, background-color, background-image, background-position"
            }
        },
        transitionTimingFunction: {
            values: "easings"
        },
        // animation
        animation: {
            values: "animations"
        },
        animationDuration: {
            values: "durations"
        },
        animationDelay: {
            values: "durations"
        },
        animationTimingFunction: {
            values: "easings"
        },
        // typography
        fontFamily: {
            values: "fonts"
        },
        fontSize: {
            values: "fontSizes"
        },
        fontWeight: {
            values: "fontWeights"
        },
        lineHeight: {
            values: "lineHeights"
        },
        letterSpacing: {
            values: "letterSpacings"
        },
        textIndent: {
            values: "spacing"
        },
        truncate: {
            values: {
                type: "boolean"
            },
            transform (value) {
                if (value === true) return {
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap"
                };
                return {};
            }
        },
        lineClamp: {
            transform (value) {
                if (value === "none") return {
                    WebkitLineClamp: "unset"
                };
                return {
                    overflow: "hidden",
                    display: "-webkit-box",
                    WebkitLineClamp: value,
                    WebkitBoxOrient: "vertical",
                    textWrap: "wrap"
                };
            }
        },
        // table
        borderSpacing: {
            values: (token)=>({
                    ...token("spacing"),
                    auto: "var(--border-spacing-x, 0) var(--border-spacing-y, 0)"
                })
        },
        borderSpacingX: {
            values: "spacing",
            transform (value) {
                return {
                    "--border-spacing-x": value
                };
            }
        },
        borderSpacingY: {
            values: "spacing",
            transform (value) {
                return {
                    "--border-spacing-y": value
                };
            }
        },
        // helpers
        srOnly: {
            values: {
                type: "boolean"
            },
            transform (value) {
                return $d843b0ee0da0e462$var$srMapping[value] || {};
            }
        },
        debug: {
            values: {
                type: "boolean"
            },
            transform (value) {
                if (!value) return {};
                return {
                    outline: "1px solid blue !important",
                    "& > *": {
                        outline: "1px solid red !important"
                    }
                };
            }
        },
        caretColor: {
            values: $d843b0ee0da0e462$var$colorValues,
            transform: (0, $143bade67be6bd19$export$85907fd96ef7f08)("caretColor")
        },
        cursor: {
            values: "cursor"
        }
    }
});
const $d843b0ee0da0e462$var$srMapping = {
    true: {
        position: "absolute",
        width: "1px",
        height: "1px",
        padding: "0",
        margin: "-1px",
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        borderWidth: "0"
    },
    false: {
        position: "static",
        width: "auto",
        height: "auto",
        padding: "0",
        margin: "0",
        overflow: "visible",
        clip: "auto",
        whiteSpace: "normal"
    }
};





"use strict";
const $395641f3954e06c3$export$d07517a676ce386f = {
    sm: "480px",
    md: "768px",
    lg: "1024px",
    xl: "1280px",
    "2xl": "1536px"
};



"use strict";
const $c4410a2f6e7f0a22$var$empty = "var(--chakra-empty, )";
const $c4410a2f6e7f0a22$export$db53682eef82cc11 = (0, $a2f848fc882d4d28$export$22794656cac17ba4)({
    "*": {
        fontFeatureSettings: '"cv11"',
        "--ring-inset": $c4410a2f6e7f0a22$var$empty,
        "--ring-offset-width": "0px",
        "--ring-offset-color": "#fff",
        "--ring-color": "rgba(66, 153, 225, 0.6)",
        "--ring-offset-shadow": "0 0 #0000",
        "--ring-shadow": "0 0 #0000",
        ...Object.fromEntries([
            "brightness",
            "contrast",
            "grayscale",
            "hue-rotate",
            "invert",
            "saturate",
            "sepia",
            "drop-shadow"
        ].map((prop)=>[
                `--${prop}`,
                $c4410a2f6e7f0a22$var$empty
            ])),
        ...Object.fromEntries([
            "blur",
            "brightness",
            "contrast",
            "grayscale",
            "hue-rotate",
            "invert",
            "opacity",
            "saturate",
            "sepia"
        ].map((prop)=>[
                `--backdrop-${prop}`,
                $c4410a2f6e7f0a22$var$empty
            ])),
        "--global-font-mono": "fonts.mono",
        "--global-font-body": "fonts.body",
        "--global-color-border": "colors.border"
    },
    html: {
        color: "fg",
        bg: "bg",
        lineHeight: "1.5",
        colorPalette: "gray"
    },
    "*::placeholder, *[data-placeholder]": {
        color: "fg.muted/80"
    },
    "*::selection": {
        bg: "colorPalette.emphasized/80"
    }
});



"use strict";
const $d30bdef3420e3f5f$export$c5ce54c56ca9d603 = (0, $a2f848fc882d4d28$export$479138f860542d07)({
    // fill: some background color + color combination
    "fill.muted": {
        value: {
            background: "colorPalette.muted",
            color: "colorPalette.fg"
        }
    },
    "fill.subtle": {
        value: {
            background: "colorPalette.subtle",
            color: "colorPalette.fg"
        }
    },
    "fill.surface": {
        value: {
            background: "colorPalette.subtle",
            color: "colorPalette.fg",
            boxShadow: "0 0 0px 1px var(--shadow-color)",
            boxShadowColor: "colorPalette.muted"
        }
    },
    "fill.solid": {
        value: {
            background: "colorPalette.solid",
            color: "colorPalette.contrast"
        }
    },
    // outline: some border color + color combination
    "outline.subtle": {
        value: {
            color: "colorPalette.fg",
            boxShadow: "inset 0 0 0px 1px var(--shadow-color)",
            boxShadowColor: "colorPalette.subtle"
        }
    },
    "outline.solid": {
        value: {
            borderWidth: "1px",
            borderColor: "colorPalette.solid",
            color: "colorPalette.fg"
        }
    },
    // indicator: floating border color or left/bottom border
    "indicator.bottom": {
        value: {
            position: "relative",
            "--indicator-color-fallback": "colors.colorPalette.solid",
            _before: {
                content: `""`,
                position: "absolute",
                bottom: "var(--indicator-offset-y, 0)",
                insetInline: "var(--indicator-offset-x, 0)",
                height: "var(--indicator-thickness, 2px)",
                background: "var(--indicator-color, var(--indicator-color-fallback))"
            }
        }
    },
    "indicator.top": {
        value: {
            position: "relative",
            "--indicator-color-fallback": "colors.colorPalette.solid",
            _before: {
                content: `""`,
                position: "absolute",
                top: "var(--indicator-offset-y, 0)",
                insetInline: "var(--indicator-offset-x, 0)",
                height: "var(--indicator-thickness, 2px)",
                background: "var(--indicator-color, var(--indicator-color-fallback))"
            }
        }
    },
    "indicator.start": {
        value: {
            position: "relative",
            "--indicator-color-fallback": "colors.colorPalette.solid",
            _before: {
                content: `""`,
                position: "absolute",
                insetInlineStart: "var(--indicator-offset-x, 0)",
                insetBlock: "var(--indicator-offset-y, 0)",
                width: "var(--indicator-thickness, 2px)",
                background: "var(--indicator-color, var(--indicator-color-fallback))"
            }
        }
    },
    "indicator.end": {
        value: {
            position: "relative",
            "--indicator-color-fallback": "colors.colorPalette.solid",
            _before: {
                content: `""`,
                position: "absolute",
                insetInlineEnd: "var(--indicator-offset-x, 0)",
                insetBlock: "var(--indicator-offset-y, 0)",
                width: "var(--indicator-thickness, 2px)",
                background: "var(--indicator-color, var(--indicator-color-fallback))"
            }
        }
    },
    disabled: {
        value: {
            opacity: "0.5",
            cursor: "not-allowed"
        }
    },
    none: {
        value: {}
    }
});



"use strict";
const $58c09e14a071fe94$export$af3299cdb043c88c = (0, $a2f848fc882d4d28$export$cd834db0363565be)({
    "slide-fade-in": {
        value: {
            transformOrigin: "var(--transform-origin)",
            "&[data-placement^=top]": {
                animationName: "slide-from-bottom, fade-in"
            },
            "&[data-placement^=bottom]": {
                animationName: "slide-from-top, fade-in"
            },
            "&[data-placement^=left]": {
                animationName: "slide-from-right, fade-in"
            },
            "&[data-placement^=right]": {
                animationName: "slide-from-left, fade-in"
            }
        }
    },
    "slide-fade-out": {
        value: {
            transformOrigin: "var(--transform-origin)",
            "&[data-placement^=top]": {
                animationName: "slide-to-bottom, fade-out"
            },
            "&[data-placement^=bottom]": {
                animationName: "slide-to-top, fade-out"
            },
            "&[data-placement^=left]": {
                animationName: "slide-to-right, fade-out"
            },
            "&[data-placement^=right]": {
                animationName: "slide-to-left, fade-out"
            }
        }
    },
    "scale-fade-in": {
        value: {
            transformOrigin: "var(--transform-origin)",
            animationName: "scale-in, fade-in"
        }
    },
    "scale-fade-out": {
        value: {
            transformOrigin: "var(--transform-origin)",
            animationName: "scale-out, fade-out"
        }
    }
});



"use strict";
const $3ad2981cdd451da7$export$251a0a63b19d28c5 = (0, $a2f848fc882d4d28$export$9ab6f981e4119117)({
    className: "chakra-badge",
    base: {
        display: "inline-flex",
        alignItems: "center",
        borderRadius: "l2",
        gap: "1",
        fontWeight: "medium",
        fontVariantNumeric: "tabular-nums",
        whiteSpace: "nowrap",
        userSelect: "none"
    },
    variants: {
        variant: {
            solid: {
                bg: "colorPalette.solid",
                color: "colorPalette.contrast"
            },
            subtle: {
                bg: "colorPalette.subtle",
                color: "colorPalette.fg"
            },
            outline: {
                color: "colorPalette.fg",
                "--outline-shadow-legacy": "colors.colorPalette.muted",
                "--outline-shadow": "colors.colorPalette.border",
                shadow: "inset 0 0 0px 1px var(--shadow-color)",
                shadowColor: "var(--outline-shadow, var(--outline-shadow-legacy))"
            },
            surface: {
                bg: "colorPalette.subtle",
                color: "colorPalette.fg",
                shadow: "inset 0 0 0px 1px var(--shadow-color)",
                shadowColor: "colorPalette.muted"
            },
            plain: {
                color: "colorPalette.fg"
            }
        },
        size: {
            xs: {
                textStyle: "2xs",
                px: "1",
                minH: "4"
            },
            sm: {
                textStyle: "xs",
                px: "1.5",
                minH: "5"
            },
            md: {
                textStyle: "sm",
                px: "2",
                minH: "6"
            },
            lg: {
                textStyle: "sm",
                px: "2.5",
                minH: "7"
            }
        }
    },
    defaultVariants: {
        variant: "subtle",
        size: "sm"
    }
});



"use strict";
const $de9c0d92b476de16$export$8fcda06ebbc760ff = (0, $a2f848fc882d4d28$export$9ab6f981e4119117)({
    className: "chakra-button",
    base: {
        display: "inline-flex",
        appearance: "none",
        alignItems: "center",
        justifyContent: "center",
        userSelect: "none",
        position: "relative",
        borderRadius: "l2",
        whiteSpace: "nowrap",
        verticalAlign: "middle",
        borderWidth: "1px",
        borderColor: "transparent",
        cursor: "button",
        flexShrink: "0",
        outline: "0",
        lineHeight: "1.2",
        isolation: "isolate",
        fontWeight: "medium",
        transitionProperty: "common",
        transitionDuration: "moderate",
        focusVisibleRing: "outside",
        _disabled: {
            layerStyle: "disabled"
        },
        _icon: {
            flexShrink: "0"
        }
    },
    variants: {
        size: {
            "2xs": {
                h: "6",
                minW: "6",
                textStyle: "xs",
                px: "2",
                gap: "1",
                _icon: {
                    width: "3.5",
                    height: "3.5"
                }
            },
            xs: {
                h: "8",
                minW: "8",
                textStyle: "xs",
                px: "2.5",
                gap: "1",
                _icon: {
                    width: "4",
                    height: "4"
                }
            },
            sm: {
                h: "9",
                minW: "9",
                px: "3.5",
                textStyle: "sm",
                gap: "2",
                _icon: {
                    width: "4",
                    height: "4"
                }
            },
            md: {
                h: "10",
                minW: "10",
                textStyle: "sm",
                px: "4",
                gap: "2",
                _icon: {
                    width: "5",
                    height: "5"
                }
            },
            lg: {
                h: "11",
                minW: "11",
                textStyle: "md",
                px: "5",
                gap: "3",
                _icon: {
                    width: "5",
                    height: "5"
                }
            },
            xl: {
                h: "12",
                minW: "12",
                textStyle: "md",
                px: "5",
                gap: "2.5",
                _icon: {
                    width: "5",
                    height: "5"
                }
            },
            "2xl": {
                h: "16",
                minW: "16",
                textStyle: "lg",
                px: "7",
                gap: "3",
                _icon: {
                    width: "6",
                    height: "6"
                }
            }
        },
        variant: {
            solid: {
                bg: "colorPalette.solid",
                color: "colorPalette.contrast",
                borderColor: "transparent",
                _hover: {
                    bg: "colorPalette.solid/90"
                },
                _expanded: {
                    bg: "colorPalette.solid/90"
                }
            },
            subtle: {
                bg: "colorPalette.subtle",
                color: "colorPalette.fg",
                borderColor: "transparent",
                _hover: {
                    bg: "colorPalette.muted"
                },
                _expanded: {
                    bg: "colorPalette.muted"
                }
            },
            surface: {
                bg: "colorPalette.subtle",
                color: "colorPalette.fg",
                shadow: "0 0 0px 1px var(--shadow-color)",
                shadowColor: "colorPalette.muted",
                _hover: {
                    bg: "colorPalette.muted"
                },
                _expanded: {
                    bg: "colorPalette.muted"
                }
            },
            outline: {
                borderWidth: "1px",
                "--outline-color-legacy": "colors.colorPalette.muted",
                "--outline-color": "colors.colorPalette.border",
                borderColor: "var(--outline-color, var(--outline-color-legacy))",
                color: "colorPalette.fg",
                _hover: {
                    bg: "colorPalette.subtle"
                },
                _expanded: {
                    bg: "colorPalette.subtle"
                }
            },
            ghost: {
                bg: "transparent",
                color: "colorPalette.fg",
                _hover: {
                    bg: "colorPalette.subtle"
                },
                _expanded: {
                    bg: "colorPalette.subtle"
                }
            },
            plain: {
                color: "colorPalette.fg"
            }
        }
    },
    defaultVariants: {
        size: "md",
        variant: "solid"
    }
});



"use strict";
const $104dd58d161685fc$export$ecb1dc0d32e8f247 = (0, $a2f848fc882d4d28$export$9ab6f981e4119117)({
    className: "chakra-checkmark",
    base: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: "0",
        color: "white",
        borderWidth: "1px",
        borderColor: "transparent",
        borderRadius: "l1",
        cursor: "checkbox",
        focusVisibleRing: "outside",
        _icon: {
            boxSize: "full"
        },
        _invalid: {
            colorPalette: "red",
            borderColor: "border.error"
        },
        _disabled: {
            opacity: "0.5",
            cursor: "disabled"
        }
    },
    variants: {
        size: {
            xs: {
                boxSize: "3"
            },
            sm: {
                boxSize: "4"
            },
            md: {
                boxSize: "5",
                p: "0.5"
            },
            lg: {
                boxSize: "6",
                p: "0.5"
            }
        },
        variant: {
            solid: {
                borderColor: "border.emphasized",
                "&:is([data-state=checked], [data-state=indeterminate])": {
                    bg: "colorPalette.solid",
                    color: "colorPalette.contrast",
                    borderColor: "colorPalette.solid"
                }
            },
            outline: {
                borderColor: "border",
                "&:is([data-state=checked], [data-state=indeterminate])": {
                    color: "colorPalette.fg",
                    borderColor: "colorPalette.solid"
                }
            },
            subtle: {
                bg: "colorPalette.muted",
                borderColor: "colorPalette.muted",
                "&:is([data-state=checked], [data-state=indeterminate])": {
                    color: "colorPalette.fg"
                }
            },
            plain: {
                "&:is([data-state=checked], [data-state=indeterminate])": {
                    color: "colorPalette.fg"
                }
            },
            inverted: {
                borderColor: "border",
                color: "colorPalette.fg",
                "&:is([data-state=checked], [data-state=indeterminate])": {
                    borderColor: "colorPalette.solid"
                }
            }
        },
        filled: {
            true: {
                bg: "bg"
            }
        }
    },
    defaultVariants: {
        variant: "solid",
        size: "md"
    }
});




"use strict";
const { variants: $09d4b7f3ac0642f8$var$variants, defaultVariants: $09d4b7f3ac0642f8$var$defaultVariants } = (0, $3ad2981cdd451da7$export$251a0a63b19d28c5);
const $09d4b7f3ac0642f8$export$7565e651dd12f58c = (0, $a2f848fc882d4d28$export$9ab6f981e4119117)({
    className: "chakra-code",
    base: {
        fontFamily: "mono",
        alignItems: "center",
        display: "inline-flex",
        borderRadius: "l2"
    },
    variants: $09d4b7f3ac0642f8$var$variants,
    defaultVariants: $09d4b7f3ac0642f8$var$defaultVariants
});



"use strict";
const $b9f6b2092cb477d8$export$9822f4e3dd6bcc87 = (0, $a2f848fc882d4d28$export$9ab6f981e4119117)({
    className: "color-swatch",
    base: {
        boxSize: "var(--swatch-size)",
        shadow: "inset 0 0 0 1px rgba(0, 0, 0, 0.1)",
        "--checker-size": "8px",
        "--checker-bg": "colors.bg",
        "--checker-fg": "colors.bg.emphasized",
        background: "linear-gradient(var(--color), var(--color)), repeating-conic-gradient(var(--checker-fg) 0%, var(--checker-fg) 25%, var(--checker-bg) 0%, var(--checker-bg) 50%) 0% 50% / var(--checker-size) var(--checker-size) !important",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: "0"
    },
    variants: {
        size: {
            "2xs": {
                "--swatch-size": "sizes.3.5"
            },
            xs: {
                "--swatch-size": "sizes.4"
            },
            sm: {
                "--swatch-size": "sizes.4.5"
            },
            md: {
                "--swatch-size": "sizes.5"
            },
            lg: {
                "--swatch-size": "sizes.6"
            },
            xl: {
                "--swatch-size": "sizes.7"
            },
            "2xl": {
                "--swatch-size": "sizes.8"
            },
            inherit: {
                "--swatch-size": "inherit"
            },
            full: {
                "--swatch-size": "100%"
            }
        },
        shape: {
            square: {
                borderRadius: "none"
            },
            circle: {
                borderRadius: "full"
            },
            rounded: {
                borderRadius: "l1"
            }
        }
    },
    defaultVariants: {
        size: "md",
        shape: "rounded"
    }
});



"use strict";
const $93bc7a25d01f9578$export$313800c084e919bf = (0, $a2f848fc882d4d28$export$9ab6f981e4119117)({
    className: "chakra-container",
    base: {
        position: "relative",
        maxWidth: "8xl",
        w: "100%",
        mx: "auto",
        px: {
            base: "4",
            md: "6",
            lg: "8"
        }
    },
    variants: {
        centerContent: {
            true: {
                display: "flex",
                flexDirection: "column",
                alignItems: "center"
            }
        },
        fluid: {
            true: {
                maxWidth: "full"
            }
        }
    }
});



"use strict";
const $69f991e9d4f38b15$export$74fda8a22e7f4a14 = (0, $a2f848fc882d4d28$export$9ab6f981e4119117)({
    className: "chakra-heading",
    base: {
        fontFamily: "heading",
        fontWeight: "semibold"
    },
    variants: {
        size: {
            xs: {
                textStyle: "xs"
            },
            sm: {
                textStyle: "sm"
            },
            md: {
                textStyle: "md"
            },
            lg: {
                textStyle: "lg"
            },
            xl: {
                textStyle: "xl"
            },
            "2xl": {
                textStyle: "2xl"
            },
            "3xl": {
                textStyle: "3xl"
            },
            "4xl": {
                textStyle: "4xl"
            },
            "5xl": {
                textStyle: "5xl"
            },
            "6xl": {
                textStyle: "6xl"
            },
            "7xl": {
                textStyle: "7xl"
            }
        }
    },
    defaultVariants: {
        size: "xl"
    }
});



"use strict";
const $b53ff8639abe880d$export$74f38ee0e7bd4336 = (0, $a2f848fc882d4d28$export$9ab6f981e4119117)({
    className: "chakra-icon",
    base: {
        display: "inline-block",
        lineHeight: "1em",
        flexShrink: "0",
        color: "currentcolor",
        verticalAlign: "middle"
    },
    variants: {
        size: {
            inherit: {},
            xs: {
                boxSize: "3"
            },
            sm: {
                boxSize: "4"
            },
            md: {
                boxSize: "5"
            },
            lg: {
                boxSize: "6"
            },
            xl: {
                boxSize: "7"
            },
            "2xl": {
                boxSize: "8"
            }
        }
    },
    defaultVariants: {
        size: "inherit"
    }
});



"use strict";
const $fd8ba95b29dad282$export$a6445e005c28dca2 = (0, $a2f848fc882d4d28$export$9ab6f981e4119117)({
    className: "chakra-input",
    base: {
        width: "100%",
        minWidth: "0",
        outline: "0",
        position: "relative",
        appearance: "none",
        textAlign: "start",
        borderRadius: "l2",
        _disabled: {
            layerStyle: "disabled"
        },
        height: "var(--input-height)",
        minW: "var(--input-height)",
        "--focus-color": "colors.colorPalette.focusRing",
        "--error-color": "colors.border.error",
        _invalid: {
            focusRingColor: "var(--error-color)",
            borderColor: "var(--error-color)"
        }
    },
    variants: {
        size: {
            "2xs": {
                textStyle: "xs",
                px: "2",
                "--input-height": "sizes.7"
            },
            xs: {
                textStyle: "xs",
                px: "2",
                "--input-height": "sizes.8"
            },
            sm: {
                textStyle: "sm",
                px: "2.5",
                "--input-height": "sizes.9"
            },
            md: {
                textStyle: "sm",
                px: "3",
                "--input-height": "sizes.10"
            },
            lg: {
                textStyle: "md",
                px: "4",
                "--input-height": "sizes.11"
            },
            xl: {
                textStyle: "md",
                px: "4.5",
                "--input-height": "sizes.12"
            },
            "2xl": {
                textStyle: "lg",
                px: "5",
                "--input-height": "sizes.16"
            }
        },
        variant: {
            outline: {
                bg: "transparent",
                borderWidth: "1px",
                borderColor: "border",
                focusVisibleRing: "inside",
                focusRingColor: "var(--focus-color)"
            },
            subtle: {
                borderWidth: "1px",
                borderColor: "transparent",
                bg: "bg.muted",
                focusVisibleRing: "inside",
                focusRingColor: "var(--focus-color)"
            },
            flushed: {
                bg: "transparent",
                borderBottomWidth: "1px",
                borderBottomColor: "border",
                borderRadius: "0",
                px: "0",
                _focusVisible: {
                    borderColor: "var(--focus-color)",
                    boxShadow: "0px 1px 0px 0px var(--focus-color)",
                    _invalid: {
                        borderColor: "var(--error-color)",
                        boxShadow: "0px 1px 0px 0px var(--error-color)"
                    }
                }
            }
        }
    },
    defaultVariants: {
        size: "md",
        variant: "outline"
    }
});




"use strict";
const $b802f9705601193f$export$5d8e524bc3a2e698 = (0, $a2f848fc882d4d28$export$9ab6f981e4119117)({
    className: "chakra-input-addon",
    base: {
        flex: "0 0 auto",
        width: "auto",
        display: "flex",
        alignItems: "center",
        whiteSpace: "nowrap",
        alignSelf: "stretch",
        borderRadius: "l2"
    },
    variants: {
        size: (0, $fd8ba95b29dad282$export$a6445e005c28dca2).variants.size,
        variant: {
            outline: {
                borderWidth: "1px",
                borderColor: "border",
                bg: "bg.muted"
            },
            subtle: {
                borderWidth: "1px",
                borderColor: "transparent",
                bg: "bg.emphasized"
            },
            flushed: {
                borderBottom: "1px solid",
                borderColor: "inherit",
                borderRadius: "0",
                px: "0",
                bg: "transparent"
            }
        }
    },
    defaultVariants: {
        size: "md",
        variant: "outline"
    }
});



"use strict";
const $7168ceaab9495c07$export$d0e46897d672167b = (0, $a2f848fc882d4d28$export$9ab6f981e4119117)({
    className: "chakra-kbd",
    base: {
        display: "inline-flex",
        alignItems: "center",
        fontWeight: "medium",
        fontFamily: "mono",
        flexShrink: "0",
        whiteSpace: "nowrap",
        wordSpacing: "-0.5em",
        userSelect: "none",
        px: "1",
        borderRadius: "l2"
    },
    variants: {
        variant: {
            raised: {
                bg: "colorPalette.subtle",
                color: "colorPalette.fg",
                borderWidth: "1px",
                borderBottomWidth: "2px",
                borderColor: "colorPalette.muted"
            },
            outline: {
                borderWidth: "1px",
                color: "colorPalette.fg"
            },
            subtle: {
                bg: "colorPalette.muted",
                color: "colorPalette.fg"
            },
            plain: {
                color: "colorPalette.fg"
            }
        },
        size: {
            sm: {
                textStyle: "xs",
                height: "4.5"
            },
            md: {
                textStyle: "sm",
                height: "5"
            },
            lg: {
                textStyle: "md",
                height: "6"
            }
        }
    },
    defaultVariants: {
        size: "md",
        variant: "raised"
    }
});



"use strict";
const $359437eef8cb2421$export$ffc13cc0f7c8dd4f = (0, $a2f848fc882d4d28$export$9ab6f981e4119117)({
    className: "chakra-link",
    base: {
        display: "inline-flex",
        alignItems: "center",
        outline: "none",
        gap: "1.5",
        cursor: "pointer",
        borderRadius: "l1",
        focusRing: "outside"
    },
    variants: {
        variant: {
            underline: {
                color: "colorPalette.fg",
                textDecoration: "underline",
                textUnderlineOffset: "3px",
                textDecorationColor: "currentColor/20"
            },
            plain: {
                color: "colorPalette.fg",
                _hover: {
                    textDecoration: "underline",
                    textUnderlineOffset: "3px",
                    textDecorationColor: "currentColor/20"
                }
            }
        }
    },
    defaultVariants: {
        variant: "plain"
    }
});



"use strict";
const $44ede10bcc0faf9c$export$348c05df4991a167 = (0, $a2f848fc882d4d28$export$9ab6f981e4119117)({
    className: "chakra-mark",
    base: {
        bg: "transparent",
        color: "inherit",
        whiteSpace: "nowrap"
    },
    variants: {
        variant: {
            subtle: {
                bg: "colorPalette.subtle",
                color: "inherit"
            },
            solid: {
                bg: "colorPalette.solid",
                color: "colorPalette.contrast"
            },
            text: {
                fontWeight: "medium"
            },
            plain: {}
        }
    }
});



"use strict";
const $17783a9fb3761078$export$f073ddc07274fbb0 = (0, $a2f848fc882d4d28$export$9ab6f981e4119117)({
    className: "chakra-radiomark",
    base: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        verticalAlign: "top",
        color: "white",
        borderWidth: "1px",
        borderColor: "transparent",
        borderRadius: "full",
        cursor: "radio",
        _focusVisible: {
            outline: "2px solid",
            outlineColor: "colorPalette.focusRing",
            outlineOffset: "2px"
        },
        _invalid: {
            colorPalette: "red",
            borderColor: "red.500"
        },
        _disabled: {
            opacity: "0.5",
            cursor: "disabled"
        },
        "& .dot": {
            height: "100%",
            width: "100%",
            borderRadius: "full",
            bg: "currentColor",
            scale: "0.4"
        }
    },
    variants: {
        variant: {
            solid: {
                borderWidth: "1px",
                borderColor: "border.emphasized",
                _checked: {
                    bg: "colorPalette.solid",
                    color: "colorPalette.contrast",
                    borderColor: "colorPalette.solid"
                }
            },
            subtle: {
                borderWidth: "1px",
                bg: "colorPalette.muted",
                borderColor: "colorPalette.muted",
                color: "transparent",
                _checked: {
                    color: "colorPalette.fg"
                }
            },
            outline: {
                borderWidth: "1px",
                borderColor: "inherit",
                _checked: {
                    color: "colorPalette.fg",
                    borderColor: "colorPalette.solid"
                },
                "& .dot": {
                    scale: "0.6"
                }
            },
            inverted: {
                bg: "bg",
                borderWidth: "1px",
                borderColor: "inherit",
                _checked: {
                    color: "colorPalette.solid",
                    borderColor: "currentcolor"
                }
            }
        },
        size: {
            xs: {
                boxSize: "3"
            },
            sm: {
                boxSize: "4"
            },
            md: {
                boxSize: "5"
            },
            lg: {
                boxSize: "6"
            }
        },
        filled: {
            true: {
                bg: "bg"
            }
        }
    },
    defaultVariants: {
        variant: "solid",
        size: "md"
    }
});



"use strict";
const $902536859fc5d296$export$4e3a2e764d3c1b3c = (0, $a2f848fc882d4d28$export$9ab6f981e4119117)({
    className: "chakra-separator",
    base: {
        display: "block",
        borderColor: "border"
    },
    variants: {
        variant: {
            solid: {
                borderStyle: "solid"
            },
            dashed: {
                borderStyle: "dashed"
            },
            dotted: {
                borderStyle: "dotted"
            }
        },
        orientation: {
            vertical: {
                borderInlineStartWidth: "var(--separator-thickness)"
            },
            horizontal: {
                borderTopWidth: "var(--separator-thickness)"
            }
        },
        size: {
            xs: {
                "--separator-thickness": "0.5px"
            },
            sm: {
                "--separator-thickness": "1px"
            },
            md: {
                "--separator-thickness": "2px"
            },
            lg: {
                "--separator-thickness": "3px"
            }
        }
    },
    defaultVariants: {
        size: "sm",
        variant: "solid",
        orientation: "horizontal"
    }
});



"use strict";
const $a2e367f8d9820715$export$bc76d6a8a834270c = (0, $a2f848fc882d4d28$export$9ab6f981e4119117)({
    className: "chakra-skeleton",
    base: {},
    variants: {
        loading: {
            true: {
                borderRadius: "l2",
                boxShadow: "none",
                backgroundClip: "padding-box",
                cursor: "default",
                color: "transparent",
                pointerEvents: "none",
                userSelect: "none",
                flexShrink: "0",
                "&::before, &::after, *": {
                    visibility: "hidden"
                }
            },
            false: {
                background: "unset",
                animation: "fade-in var(--fade-duration, 0.1s) ease-out !important"
            }
        },
        variant: {
            pulse: {
                background: "bg.emphasized",
                animation: "pulse",
                animationDuration: "var(--duration, 1.2s)"
            },
            shine: {
                "--animate-from": "200%",
                "--animate-to": "-200%",
                "--start-color": "colors.bg.muted",
                "--end-color": "colors.bg.emphasized",
                backgroundImage: "linear-gradient(270deg,var(--start-color),var(--end-color),var(--end-color),var(--start-color))",
                backgroundSize: "400% 100%",
                animation: "bg-position var(--duration, 5s) ease-in-out infinite"
            },
            none: {
                animation: "none"
            }
        }
    },
    defaultVariants: {
        variant: "pulse",
        loading: true
    }
});



"use strict";
const $0604d0228437a43d$export$380c51a04360915a = (0, $a2f848fc882d4d28$export$9ab6f981e4119117)({
    className: "chakra-skip-nav",
    base: {
        display: "inline-flex",
        bg: "bg.panel",
        padding: "2.5",
        borderRadius: "l2",
        fontWeight: "semibold",
        focusVisibleRing: "outside",
        textStyle: "sm",
        // visually hidden
        userSelect: "none",
        border: "0",
        height: "1px",
        width: "1px",
        margin: "-1px",
        outline: "0",
        overflow: "hidden",
        position: "absolute",
        clip: "rect(0 0 0 0)",
        _focusVisible: {
            clip: "auto",
            width: "auto",
            height: "auto",
            position: "fixed",
            top: "6",
            insetStart: "6"
        }
    }
});



"use strict";
const $5a7fa7fedeb04e10$export$c8e083fecedf753b = (0, $a2f848fc882d4d28$export$9ab6f981e4119117)({
    className: "chakra-spinner",
    base: {
        display: "inline-block",
        borderColor: "currentColor",
        borderStyle: "solid",
        borderWidth: "2px",
        borderRadius: "full",
        width: "var(--spinner-size)",
        height: "var(--spinner-size)",
        animation: "spin",
        animationDuration: "slowest",
        "--spinner-track-color": "transparent",
        borderBottomColor: "var(--spinner-track-color)",
        borderInlineStartColor: "var(--spinner-track-color)"
    },
    variants: {
        size: {
            inherit: {
                "--spinner-size": "1em"
            },
            xs: {
                "--spinner-size": "sizes.3"
            },
            sm: {
                "--spinner-size": "sizes.4"
            },
            md: {
                "--spinner-size": "sizes.5"
            },
            lg: {
                "--spinner-size": "sizes.8"
            },
            xl: {
                "--spinner-size": "sizes.10"
            }
        }
    },
    defaultVariants: {
        size: "md"
    }
});



"use strict";
const $040ce5af8e06ccf8$export$986b82e7411f2367 = (0, $a2f848fc882d4d28$export$9ab6f981e4119117)({
    className: "chakra-textarea",
    base: {
        width: "100%",
        minWidth: "0",
        outline: "0",
        position: "relative",
        appearance: "none",
        textAlign: "start",
        borderRadius: "l2",
        _disabled: {
            layerStyle: "disabled"
        },
        "--focus-color": "colors.colorPalette.focusRing",
        "--error-color": "colors.border.error",
        _invalid: {
            focusRingColor: "var(--error-color)",
            borderColor: "var(--error-color)"
        }
    },
    variants: {
        size: {
            xs: {
                textStyle: "xs",
                px: "2",
                py: "1.5",
                scrollPaddingBottom: "1.5"
            },
            sm: {
                textStyle: "sm",
                px: "2.5",
                py: "2",
                scrollPaddingBottom: "2"
            },
            md: {
                textStyle: "sm",
                px: "3",
                py: "2",
                scrollPaddingBottom: "2"
            },
            lg: {
                textStyle: "md",
                px: "4",
                py: "3",
                scrollPaddingBottom: "3"
            },
            xl: {
                textStyle: "md",
                px: "4.5",
                py: "3.5",
                scrollPaddingBottom: "3.5"
            }
        },
        variant: {
            outline: {
                bg: "transparent",
                borderWidth: "1px",
                borderColor: "border",
                focusVisibleRing: "inside"
            },
            subtle: {
                borderWidth: "1px",
                borderColor: "transparent",
                bg: "bg.muted",
                focusVisibleRing: "inside"
            },
            flushed: {
                bg: "transparent",
                borderBottomWidth: "1px",
                borderBottomColor: "border",
                borderRadius: "0",
                px: "0",
                _focusVisible: {
                    borderColor: "var(--focus-color)",
                    boxShadow: "0px 1px 0px 0px var(--focus-color)"
                }
            }
        }
    },
    defaultVariants: {
        size: "md",
        variant: "outline"
    }
});


"use strict";
const $4b950c49fa0a5c48$export$fa74c78a0037e9df = {
    badge: (0, $3ad2981cdd451da7$export$251a0a63b19d28c5),
    button: (0, $de9c0d92b476de16$export$8fcda06ebbc760ff),
    code: (0, $09d4b7f3ac0642f8$export$7565e651dd12f58c),
    container: (0, $93bc7a25d01f9578$export$313800c084e919bf),
    heading: (0, $69f991e9d4f38b15$export$74fda8a22e7f4a14),
    input: (0, $fd8ba95b29dad282$export$a6445e005c28dca2),
    inputAddon: (0, $b802f9705601193f$export$5d8e524bc3a2e698),
    kbd: (0, $7168ceaab9495c07$export$d0e46897d672167b),
    link: (0, $359437eef8cb2421$export$ffc13cc0f7c8dd4f),
    mark: (0, $44ede10bcc0faf9c$export$348c05df4991a167),
    separator: (0, $902536859fc5d296$export$4e3a2e764d3c1b3c),
    skeleton: (0, $a2e367f8d9820715$export$bc76d6a8a834270c),
    skipNavLink: (0, $0604d0228437a43d$export$380c51a04360915a),
    spinner: (0, $5a7fa7fedeb04e10$export$c8e083fecedf753b),
    textarea: (0, $040ce5af8e06ccf8$export$986b82e7411f2367),
    icon: (0, $b53ff8639abe880d$export$74f38ee0e7bd4336),
    checkmark: (0, $104dd58d161685fc$export$ecb1dc0d32e8f247),
    radiomark: (0, $17783a9fb3761078$export$f073ddc07274fbb0),
    colorSwatch: (0, $b9f6b2092cb477d8$export$9822f4e3dd6bcc87)
};



"use strict";
const $2f101dfb3da4f32e$export$bba894c3986a1bd6 = (0, $a2f848fc882d4d28$export$97e094f42fbe07cb).colors({
    bg: {
        DEFAULT: {
            value: {
                _light: "{colors.white}",
                _dark: "{colors.black}"
            }
        },
        subtle: {
            value: {
                _light: "{colors.gray.50}",
                _dark: "{colors.gray.950}"
            }
        },
        muted: {
            value: {
                _light: "{colors.gray.100}",
                _dark: "{colors.gray.900}"
            }
        },
        emphasized: {
            value: {
                _light: "{colors.gray.200}",
                _dark: "{colors.gray.800}"
            }
        },
        inverted: {
            value: {
                _light: "{colors.black}",
                _dark: "{colors.white}"
            }
        },
        panel: {
            value: {
                _light: "{colors.white}",
                _dark: "{colors.gray.950}"
            }
        },
        error: {
            value: {
                _light: "{colors.red.50}",
                _dark: "{colors.red.950}"
            }
        },
        warning: {
            value: {
                _light: "{colors.orange.50}",
                _dark: "{colors.orange.950}"
            }
        },
        success: {
            value: {
                _light: "{colors.green.50}",
                _dark: "{colors.green.950}"
            }
        },
        info: {
            value: {
                _light: "{colors.blue.50}",
                _dark: "{colors.blue.950}"
            }
        }
    },
    fg: {
        DEFAULT: {
            value: {
                _light: "{colors.black}",
                _dark: "{colors.gray.50}"
            }
        },
        muted: {
            value: {
                _light: "{colors.gray.600}",
                _dark: "{colors.gray.400}"
            }
        },
        subtle: {
            value: {
                _light: "{colors.gray.400}",
                _dark: "{colors.gray.500}"
            }
        },
        inverted: {
            value: {
                _light: "{colors.gray.50}",
                _dark: "{colors.black}"
            }
        },
        error: {
            value: {
                _light: "{colors.red.500}",
                _dark: "{colors.red.400}"
            }
        },
        warning: {
            value: {
                _light: "{colors.orange.600}",
                _dark: "{colors.orange.300}"
            }
        },
        success: {
            value: {
                _light: "{colors.green.600}",
                _dark: "{colors.green.300}"
            }
        },
        info: {
            value: {
                _light: "{colors.blue.600}",
                _dark: "{colors.blue.300}"
            }
        }
    },
    border: {
        DEFAULT: {
            value: {
                _light: "{colors.gray.200}",
                _dark: "{colors.gray.800}"
            }
        },
        muted: {
            value: {
                _light: "{colors.gray.100}",
                _dark: "{colors.gray.900}"
            }
        },
        subtle: {
            value: {
                _light: "{colors.gray.50}",
                _dark: "{colors.gray.950}"
            }
        },
        emphasized: {
            value: {
                _light: "{colors.gray.300}",
                _dark: "{colors.gray.700}"
            }
        },
        inverted: {
            value: {
                _light: "{colors.gray.800}",
                _dark: "{colors.gray.200}"
            }
        },
        error: {
            value: {
                _light: "{colors.red.500}",
                _dark: "{colors.red.400}"
            }
        },
        warning: {
            value: {
                _light: "{colors.orange.500}",
                _dark: "{colors.orange.400}"
            }
        },
        success: {
            value: {
                _light: "{colors.green.500}",
                _dark: "{colors.green.400}"
            }
        },
        info: {
            value: {
                _light: "{colors.blue.500}",
                _dark: "{colors.blue.400}"
            }
        }
    },
    gray: {
        contrast: {
            value: {
                _light: "{colors.white}",
                _dark: "{colors.black}"
            }
        },
        fg: {
            value: {
                _light: "{colors.gray.800}",
                _dark: "{colors.gray.200}"
            }
        },
        subtle: {
            value: {
                _light: "{colors.gray.100}",
                _dark: "{colors.gray.900}"
            }
        },
        muted: {
            value: {
                _light: "{colors.gray.200}",
                _dark: "{colors.gray.800}"
            }
        },
        emphasized: {
            value: {
                _light: "{colors.gray.300}",
                _dark: "{colors.gray.700}"
            }
        },
        solid: {
            value: {
                _light: "{colors.gray.900}",
                _dark: "{colors.white}"
            }
        },
        focusRing: {
            value: {
                _light: "{colors.gray.400}",
                _dark: "{colors.gray.400}"
            }
        },
        border: {
            value: {
                _light: "{colors.gray.200}",
                _dark: "{colors.gray.800}"
            }
        }
    },
    red: {
        contrast: {
            value: {
                _light: "white",
                _dark: "white"
            }
        },
        fg: {
            value: {
                _light: "{colors.red.700}",
                _dark: "{colors.red.300}"
            }
        },
        subtle: {
            value: {
                _light: "{colors.red.100}",
                _dark: "{colors.red.900}"
            }
        },
        muted: {
            value: {
                _light: "{colors.red.200}",
                _dark: "{colors.red.800}"
            }
        },
        emphasized: {
            value: {
                _light: "{colors.red.300}",
                _dark: "{colors.red.700}"
            }
        },
        solid: {
            value: {
                _light: "{colors.red.600}",
                _dark: "{colors.red.600}"
            }
        },
        focusRing: {
            value: {
                _light: "{colors.red.500}",
                _dark: "{colors.red.500}"
            }
        },
        border: {
            value: {
                _light: "{colors.red.500}",
                _dark: "{colors.red.400}"
            }
        }
    },
    orange: {
        contrast: {
            value: {
                _light: "white",
                _dark: "black"
            }
        },
        fg: {
            value: {
                _light: "{colors.orange.700}",
                _dark: "{colors.orange.300}"
            }
        },
        subtle: {
            value: {
                _light: "{colors.orange.100}",
                _dark: "{colors.orange.900}"
            }
        },
        muted: {
            value: {
                _light: "{colors.orange.200}",
                _dark: "{colors.orange.800}"
            }
        },
        emphasized: {
            value: {
                _light: "{colors.orange.300}",
                _dark: "{colors.orange.700}"
            }
        },
        solid: {
            value: {
                _light: "{colors.orange.600}",
                _dark: "{colors.orange.500}"
            }
        },
        focusRing: {
            value: {
                _light: "{colors.orange.500}",
                _dark: "{colors.orange.500}"
            }
        },
        border: {
            value: {
                _light: "{colors.orange.500}",
                _dark: "{colors.orange.400}"
            }
        }
    },
    green: {
        contrast: {
            value: {
                _light: "white",
                _dark: "white"
            }
        },
        fg: {
            value: {
                _light: "{colors.green.700}",
                _dark: "{colors.green.300}"
            }
        },
        subtle: {
            value: {
                _light: "{colors.green.100}",
                _dark: "{colors.green.900}"
            }
        },
        muted: {
            value: {
                _light: "{colors.green.200}",
                _dark: "{colors.green.800}"
            }
        },
        emphasized: {
            value: {
                _light: "{colors.green.300}",
                _dark: "{colors.green.700}"
            }
        },
        solid: {
            value: {
                _light: "{colors.green.600}",
                _dark: "{colors.green.600}"
            }
        },
        focusRing: {
            value: {
                _light: "{colors.green.500}",
                _dark: "{colors.green.500}"
            }
        },
        border: {
            value: {
                _light: "{colors.green.500}",
                _dark: "{colors.green.400}"
            }
        }
    },
    blue: {
        contrast: {
            value: {
                _light: "white",
                _dark: "white"
            }
        },
        fg: {
            value: {
                _light: "{colors.blue.700}",
                _dark: "{colors.blue.300}"
            }
        },
        subtle: {
            value: {
                _light: "{colors.blue.100}",
                _dark: "{colors.blue.900}"
            }
        },
        muted: {
            value: {
                _light: "{colors.blue.200}",
                _dark: "{colors.blue.800}"
            }
        },
        emphasized: {
            value: {
                _light: "{colors.blue.300}",
                _dark: "{colors.blue.700}"
            }
        },
        solid: {
            value: {
                _light: "{colors.blue.600}",
                _dark: "{colors.blue.600}"
            }
        },
        focusRing: {
            value: {
                _light: "{colors.blue.500}",
                _dark: "{colors.blue.500}"
            }
        },
        border: {
            value: {
                _light: "{colors.blue.500}",
                _dark: "{colors.blue.400}"
            }
        }
    },
    yellow: {
        contrast: {
            value: {
                _light: "black",
                _dark: "black"
            }
        },
        fg: {
            value: {
                _light: "{colors.yellow.800}",
                _dark: "{colors.yellow.300}"
            }
        },
        subtle: {
            value: {
                _light: "{colors.yellow.100}",
                _dark: "{colors.yellow.900}"
            }
        },
        muted: {
            value: {
                _light: "{colors.yellow.200}",
                _dark: "{colors.yellow.800}"
            }
        },
        emphasized: {
            value: {
                _light: "{colors.yellow.300}",
                _dark: "{colors.yellow.700}"
            }
        },
        solid: {
            value: {
                _light: "{colors.yellow.300}",
                _dark: "{colors.yellow.300}"
            }
        },
        focusRing: {
            value: {
                _light: "{colors.yellow.500}",
                _dark: "{colors.yellow.500}"
            }
        },
        border: {
            value: {
                _light: "{colors.yellow.500}",
                _dark: "{colors.yellow.500}"
            }
        }
    },
    teal: {
        contrast: {
            value: {
                _light: "white",
                _dark: "white"
            }
        },
        fg: {
            value: {
                _light: "{colors.teal.700}",
                _dark: "{colors.teal.300}"
            }
        },
        subtle: {
            value: {
                _light: "{colors.teal.100}",
                _dark: "{colors.teal.900}"
            }
        },
        muted: {
            value: {
                _light: "{colors.teal.200}",
                _dark: "{colors.teal.800}"
            }
        },
        emphasized: {
            value: {
                _light: "{colors.teal.300}",
                _dark: "{colors.teal.700}"
            }
        },
        solid: {
            value: {
                _light: "{colors.teal.600}",
                _dark: "{colors.teal.600}"
            }
        },
        focusRing: {
            value: {
                _light: "{colors.teal.500}",
                _dark: "{colors.teal.500}"
            }
        },
        border: {
            value: {
                _light: "{colors.teal.500}",
                _dark: "{colors.teal.400}"
            }
        }
    },
    purple: {
        contrast: {
            value: {
                _light: "white",
                _dark: "white"
            }
        },
        fg: {
            value: {
                _light: "{colors.purple.700}",
                _dark: "{colors.purple.300}"
            }
        },
        subtle: {
            value: {
                _light: "{colors.purple.100}",
                _dark: "{colors.purple.900}"
            }
        },
        muted: {
            value: {
                _light: "{colors.purple.200}",
                _dark: "{colors.purple.800}"
            }
        },
        emphasized: {
            value: {
                _light: "{colors.purple.300}",
                _dark: "{colors.purple.700}"
            }
        },
        solid: {
            value: {
                _light: "{colors.purple.600}",
                _dark: "{colors.purple.600}"
            }
        },
        focusRing: {
            value: {
                _light: "{colors.purple.500}",
                _dark: "{colors.purple.500}"
            }
        },
        border: {
            value: {
                _light: "{colors.purple.500}",
                _dark: "{colors.purple.400}"
            }
        }
    },
    pink: {
        contrast: {
            value: {
                _light: "white",
                _dark: "white"
            }
        },
        fg: {
            value: {
                _light: "{colors.pink.700}",
                _dark: "{colors.pink.300}"
            }
        },
        subtle: {
            value: {
                _light: "{colors.pink.100}",
                _dark: "{colors.pink.900}"
            }
        },
        muted: {
            value: {
                _light: "{colors.pink.200}",
                _dark: "{colors.pink.800}"
            }
        },
        emphasized: {
            value: {
                _light: "{colors.pink.300}",
                _dark: "{colors.pink.700}"
            }
        },
        solid: {
            value: {
                _light: "{colors.pink.600}",
                _dark: "{colors.pink.600}"
            }
        },
        focusRing: {
            value: {
                _light: "{colors.pink.500}",
                _dark: "{colors.pink.500}"
            }
        },
        border: {
            value: {
                _light: "{colors.pink.500}",
                _dark: "{colors.pink.400}"
            }
        }
    },
    cyan: {
        contrast: {
            value: {
                _light: "white",
                _dark: "white"
            }
        },
        fg: {
            value: {
                _light: "{colors.cyan.700}",
                _dark: "{colors.cyan.300}"
            }
        },
        subtle: {
            value: {
                _light: "{colors.cyan.100}",
                _dark: "{colors.cyan.900}"
            }
        },
        muted: {
            value: {
                _light: "{colors.cyan.200}",
                _dark: "{colors.cyan.800}"
            }
        },
        emphasized: {
            value: {
                _light: "{colors.cyan.300}",
                _dark: "{colors.cyan.700}"
            }
        },
        solid: {
            value: {
                _light: "{colors.cyan.600}",
                _dark: "{colors.cyan.600}"
            }
        },
        focusRing: {
            value: {
                _light: "{colors.cyan.500}",
                _dark: "{colors.cyan.500}"
            }
        },
        border: {
            value: {
                _light: "{colors.cyan.500}",
                _dark: "{colors.cyan.400}"
            }
        }
    }
});



"use strict";
const $3bf902b2a4cd1ab9$export$9a35918a914a3cfd = (0, $a2f848fc882d4d28$export$97e094f42fbe07cb).radii({
    l1: {
        value: "{radii.xs}"
    },
    l2: {
        value: "{radii.sm}"
    },
    l3: {
        value: "{radii.md}"
    }
});



"use strict";
const $fa075a3de6b27d92$export$be8678bc2461c05b = (0, $a2f848fc882d4d28$export$97e094f42fbe07cb).shadows({
    xs: {
        value: {
            _light: "0px 1px 2px {colors.gray.900/10}, 0px 0px 1px {colors.gray.900/20}",
            _dark: "0px 1px 1px {black/64}, 0px 0px 1px inset {colors.gray.300/20}"
        }
    },
    sm: {
        value: {
            _light: "0px 2px 4px {colors.gray.900/10}, 0px 0px 1px {colors.gray.900/30}",
            _dark: "0px 2px 4px {black/64}, 0px 0px 1px inset {colors.gray.300/30}"
        }
    },
    md: {
        value: {
            _light: "0px 4px 8px {colors.gray.900/10}, 0px 0px 1px {colors.gray.900/30}",
            _dark: "0px 4px 8px {black/64}, 0px 0px 1px inset {colors.gray.300/30}"
        }
    },
    lg: {
        value: {
            _light: "0px 8px 16px {colors.gray.900/10}, 0px 0px 1px {colors.gray.900/30}",
            _dark: "0px 8px 16px {black/64}, 0px 0px 1px inset {colors.gray.300/30}"
        }
    },
    xl: {
        value: {
            _light: "0px 16px 24px {colors.gray.900/10}, 0px 0px 1px {colors.gray.900/30}",
            _dark: "0px 16px 24px {black/64}, 0px 0px 1px inset {colors.gray.300/30}"
        }
    },
    "2xl": {
        value: {
            _light: "0px 24px 40px {colors.gray.900/16}, 0px 0px 1px {colors.gray.900/30}",
            _dark: "0px 24px 40px {black/64}, 0px 0px 1px inset {colors.gray.300/30}"
        }
    },
    inner: {
        value: {
            _light: "inset 0 2px 4px 0 {black/5}",
            _dark: "inset 0 2px 4px 0 black"
        }
    },
    inset: {
        value: {
            _light: "inset 0 0 0 1px {black/5}",
            _dark: "inset 0 0 0 1px {colors.gray.300/5}"
        }
    }
});


// src/combobox.anatomy.ts

var $424fafa8f97b2c36$export$477202748c7242bf = (0, $07b08c6ef332e8db$export$197e6e8d4b33fd6c)("combobox").parts("root", "clearTrigger", "content", "control", "input", "item", "itemGroup", "itemGroupLabel", "itemIndicator", "itemText", "label", "list", "positioner", "trigger");
var $424fafa8f97b2c36$export$6e2410c1d27f06e7 = $424fafa8f97b2c36$export$477202748c7242bf.build();


"use client";
//#region src/components/combobox/combobox.anatomy.ts
var $fb114b683499c1f8$export$feda4744fa5788da = (0, $424fafa8f97b2c36$export$477202748c7242bf).extendWith("empty");


// src/accordion.anatomy.ts

var $40dbae1872933c93$export$477202748c7242bf = (0, $07b08c6ef332e8db$export$197e6e8d4b33fd6c)("accordion").parts("root", "item", "itemTrigger", "itemContent", "itemIndicator");
var $40dbae1872933c93$export$6e2410c1d27f06e7 = $40dbae1872933c93$export$477202748c7242bf.build();



// src/clipboard.anatomy.ts

var $823e3b8ee3c08f83$export$477202748c7242bf = (0, $07b08c6ef332e8db$export$197e6e8d4b33fd6c)("clipboard").parts("root", "control", "trigger", "indicator", "input", "label");
var $823e3b8ee3c08f83$export$6e2410c1d27f06e7 = $823e3b8ee3c08f83$export$477202748c7242bf.build();


// src/color-picker.anatomy.ts

var $ab50adf0c43ea1bd$export$477202748c7242bf = (0, $07b08c6ef332e8db$export$197e6e8d4b33fd6c)("color-picker", [
    "root",
    "label",
    "control",
    "trigger",
    "positioner",
    "content",
    "area",
    "areaThumb",
    "valueText",
    "areaBackground",
    "channelSlider",
    "channelSliderLabel",
    "channelSliderTrack",
    "channelSliderThumb",
    "channelSliderValueText",
    "channelInput",
    "transparencyGrid",
    "swatchGroup",
    "swatchTrigger",
    "swatchIndicator",
    "swatch",
    "eyeDropperTrigger",
    "formatTrigger",
    "formatSelect"
]);
var $ab50adf0c43ea1bd$export$6e2410c1d27f06e7 = $ab50adf0c43ea1bd$export$477202748c7242bf.build();


"use client";
//#region src/components/color-picker/color-picker.anatomy.ts
var $b8c5206fe75ae7c4$export$5785807b87db4889 = (0, $ab50adf0c43ea1bd$export$477202748c7242bf).extendWith("view");


// src/date-picker.anatomy.ts

var $58103f4f9aacb854$export$477202748c7242bf = (0, $07b08c6ef332e8db$export$197e6e8d4b33fd6c)("date-picker").parts("clearTrigger", "content", "control", "input", "label", "monthSelect", "nextTrigger", "positioner", "presetTrigger", "prevTrigger", "rangeText", "root", "table", "tableBody", "tableCell", "tableCellTrigger", "tableHead", "tableHeader", "tableRow", "trigger", "view", "viewControl", "viewTrigger", "yearSelect");
var $58103f4f9aacb854$export$6e2410c1d27f06e7 = $58103f4f9aacb854$export$477202748c7242bf.build();


"use client";
//#region src/components/date-picker/date-picker.anatomy.ts
var $3943cb736a3bee84$export$317e47878665202b = (0, $58103f4f9aacb854$export$477202748c7242bf).extendWith("view", "valueText");


// src/dialog.anatomy.ts

var $bb373a1957e4f3ae$export$477202748c7242bf = (0, $07b08c6ef332e8db$export$197e6e8d4b33fd6c)("dialog").parts("trigger", "backdrop", "positioner", "content", "title", "description", "closeTrigger");
var $bb373a1957e4f3ae$export$6e2410c1d27f06e7 = $bb373a1957e4f3ae$export$477202748c7242bf.build();


// src/editable.anatomy.ts

var $957ab9fd5e84c8ae$export$477202748c7242bf = (0, $07b08c6ef332e8db$export$197e6e8d4b33fd6c)("editable").parts("root", "area", "label", "preview", "input", "editTrigger", "submitTrigger", "cancelTrigger", "control");
var $957ab9fd5e84c8ae$export$6e2410c1d27f06e7 = $957ab9fd5e84c8ae$export$477202748c7242bf.build();




"use client";
//#region src/components/fieldset/fieldset.anatomy.ts
var $22ffba3410e47486$export$3b2066f768dd72d0 = (0, $07b08c6ef332e8db$export$197e6e8d4b33fd6c)("fieldset").parts("root", "errorText", "helperText", "legend");
var $22ffba3410e47486$export$6e2410c1d27f06e7 = $22ffba3410e47486$export$3b2066f768dd72d0.build();


// src/file-upload.anatomy.ts

var $660517089def351f$export$477202748c7242bf = (0, $07b08c6ef332e8db$export$197e6e8d4b33fd6c)("file-upload").parts("root", "dropzone", "item", "itemDeleteTrigger", "itemGroup", "itemName", "itemPreview", "itemPreviewImage", "itemSizeText", "label", "trigger", "clearTrigger");
var $660517089def351f$export$6e2410c1d27f06e7 = $660517089def351f$export$477202748c7242bf.build();


// src/listbox.anatomy.ts

var $306bb2904208bb61$export$477202748c7242bf = (0, $07b08c6ef332e8db$export$197e6e8d4b33fd6c)("listbox").parts("label", "input", "item", "itemText", "itemIndicator", "itemGroup", "itemGroupLabel", "content", "root", "valueText");
var $306bb2904208bb61$export$6e2410c1d27f06e7 = $306bb2904208bb61$export$477202748c7242bf.build();


"use client";
//#region src/components/listbox/listbox.anatomy.ts
var $63a0fefa8f43e952$export$a647f00ed9c3a914 = (0, $306bb2904208bb61$export$477202748c7242bf).extendWith("empty");




// src/radio-group.anatomy.ts

var $e17d441bd191f763$export$477202748c7242bf = (0, $07b08c6ef332e8db$export$197e6e8d4b33fd6c)("radio-group").parts("root", "label", "item", "itemText", "itemControl", "indicator");
var $e17d441bd191f763$export$6e2410c1d27f06e7 = $e17d441bd191f763$export$477202748c7242bf.build();


// src/rating-group.anatomy.ts

var $62aec99ae463361c$export$477202748c7242bf = (0, $07b08c6ef332e8db$export$197e6e8d4b33fd6c)("rating-group").parts("root", "label", "item", "control");
var $62aec99ae463361c$export$6e2410c1d27f06e7 = $62aec99ae463361c$export$477202748c7242bf.build();


// src/select.anatomy.ts

var $aef2a905e122cf69$export$477202748c7242bf = (0, $07b08c6ef332e8db$export$197e6e8d4b33fd6c)("select").parts("label", "positioner", "trigger", "indicator", "clearTrigger", "item", "itemText", "itemIndicator", "itemGroup", "itemGroupLabel", "list", "content", "root", "control", "valueText");
var $aef2a905e122cf69$export$6e2410c1d27f06e7 = $aef2a905e122cf69$export$477202748c7242bf.build();


// src/slider.anatomy.ts

var $c3e2b800409056ce$export$477202748c7242bf = (0, $07b08c6ef332e8db$export$197e6e8d4b33fd6c)("slider").parts("root", "label", "thumb", "valueText", "track", "range", "control", "markerGroup", "marker", "draggingIndicator");
var $c3e2b800409056ce$export$6e2410c1d27f06e7 = $c3e2b800409056ce$export$477202748c7242bf.build();




var $9188a5e41e8687f3$export$477202748c7242bf = (0, $07b08c6ef332e8db$export$197e6e8d4b33fd6c)("splitter").parts("root", "panel", "resizeTrigger", "resizeTriggerIndicator");
var $9188a5e41e8687f3$export$6e2410c1d27f06e7 = $9188a5e41e8687f3$export$477202748c7242bf.build();


// src/switch.anatomy.ts

var $d04f029bed591a8e$export$477202748c7242bf = (0, $07b08c6ef332e8db$export$197e6e8d4b33fd6c)("switch").parts("root", "label", "control", "thumb");
var $d04f029bed591a8e$export$6e2410c1d27f06e7 = $d04f029bed591a8e$export$477202748c7242bf.build();

















"use strict";
const $210cc27d3a3db981$export$377a77e99e7c73a5 = (0, $40dbae1872933c93$export$477202748c7242bf).extendWith("itemBody");
const $210cc27d3a3db981$export$7dd5043f89c4709c = (0, $07b08c6ef332e8db$export$197e6e8d4b33fd6c)("action-bar").parts("positioner", "content", "separator", "selectionTrigger", "closeTrigger");
const $210cc27d3a3db981$export$fc51889fa4de265a = (0, $07b08c6ef332e8db$export$197e6e8d4b33fd6c)("alert").parts("title", "description", "root", "indicator", "content");
const $210cc27d3a3db981$export$2fb03f744a6ecf93 = (0, $07b08c6ef332e8db$export$197e6e8d4b33fd6c)("breadcrumb").parts("link", "currentLink", "item", "list", "root", "ellipsis", "separator");
const $210cc27d3a3db981$export$50ffc6bb83cc6686 = (0, $07b08c6ef332e8db$export$197e6e8d4b33fd6c)("blockquote").parts("root", "icon", "content", "caption");
const $210cc27d3a3db981$export$487a447ffa5755b6 = (0, $07b08c6ef332e8db$export$197e6e8d4b33fd6c)("card").parts("root", "header", "body", "footer", "title", "description");
const $210cc27d3a3db981$export$e4581dd169704619 = (0, $07b08c6ef332e8db$export$197e6e8d4b33fd6c)("checkbox-card", [
    "root",
    "control",
    "label",
    "description",
    "addon",
    "indicator",
    "content"
]);
const $210cc27d3a3db981$export$a5a7982d185494cc = (0, $07b08c6ef332e8db$export$197e6e8d4b33fd6c)("data-list").parts("root", "item", "itemLabel", "itemValue");
const $210cc27d3a3db981$export$317e47878665202b = (0, $3943cb736a3bee84$export$317e47878665202b).extendWith("indicatorGroup");
const $210cc27d3a3db981$export$c438f40c25a9407b = (0, $bb373a1957e4f3ae$export$477202748c7242bf).extendWith("header", "body", "footer", "backdrop");
const $210cc27d3a3db981$export$d3f4aaa4b0f2907a = (0, $bb373a1957e4f3ae$export$477202748c7242bf).extendWith("header", "body", "footer", "backdrop");
const $210cc27d3a3db981$export$2813c9511eeab082 = (0, $957ab9fd5e84c8ae$export$477202748c7242bf).extendWith("textarea");
const $210cc27d3a3db981$export$f18c66b472536888 = (0, $07b08c6ef332e8db$export$197e6e8d4b33fd6c)("empty-state", [
    "root",
    "content",
    "indicator",
    "title",
    "description"
]);
const $210cc27d3a3db981$export$a43048b0d2808e4e = (0, $4473332d2db12625$export$a43048b0d2808e4e).extendWith("requiredIndicator");
const $210cc27d3a3db981$export$3b2066f768dd72d0 = (0, $22ffba3410e47486$export$3b2066f768dd72d0).extendWith("content");
const $210cc27d3a3db981$export$b589745ee24985d = (0, $660517089def351f$export$477202748c7242bf).extendWith("itemContent", "dropzoneContent", "fileText");
const $210cc27d3a3db981$export$12b3a655a94374ed = (0, $07b08c6ef332e8db$export$197e6e8d4b33fd6c)("list").parts("root", "item", "indicator");
const $210cc27d3a3db981$export$e251092a5dcb1329 = (0, $b870bcac6acae260$export$477202748c7242bf).extendWith("itemCommand");
const $210cc27d3a3db981$export$f38e0304163546fd = (0, $07b08c6ef332e8db$export$197e6e8d4b33fd6c)("select").parts("root", "field", "indicator");
const $210cc27d3a3db981$export$afda07d12cd4337d = (0, $40970757bbe640c2$export$477202748c7242bf).extendWith("header", "body", "footer");
const $210cc27d3a3db981$export$837558ec9d0fab0d = (0, $e17d441bd191f763$export$477202748c7242bf).extendWith("itemAddon", "itemIndicator");
const $210cc27d3a3db981$export$6f8cb2f45f823e4d = $210cc27d3a3db981$export$837558ec9d0fab0d.extendWith("itemContent", "itemDescription");
const $210cc27d3a3db981$export$127aba8545f015d6 = (0, $62aec99ae463361c$export$477202748c7242bf).extendWith("itemIndicator");
const $210cc27d3a3db981$export$17993f0be9538b5a = (0, $aef2a905e122cf69$export$477202748c7242bf).extendWith("indicatorGroup");
const $210cc27d3a3db981$export$feda4744fa5788da = (0, $fb114b683499c1f8$export$feda4744fa5788da).extendWith("indicatorGroup", "empty");
const $210cc27d3a3db981$export$c21b4b3f8b239f32 = (0, $c3e2b800409056ce$export$477202748c7242bf).extendWith("markerIndicator", "markerLabel");
const $210cc27d3a3db981$export$2cfbad67ae6ee421 = (0, $07b08c6ef332e8db$export$197e6e8d4b33fd6c)("stat").parts("root", "label", "helpText", "valueText", "valueUnit", "indicator");
const $210cc27d3a3db981$export$6b07965b0539a879 = (0, $07b08c6ef332e8db$export$197e6e8d4b33fd6c)("status").parts("root", "indicator");
const $210cc27d3a3db981$export$5c3acf63225011aa = (0, $07b08c6ef332e8db$export$197e6e8d4b33fd6c)("steps", [
    "root",
    "list",
    "item",
    "trigger",
    "indicator",
    "separator",
    "content",
    "title",
    "description",
    "nextTrigger",
    "prevTrigger",
    "progress"
]);
const $210cc27d3a3db981$export$921c1a2d1ce1e86a = (0, $d04f029bed591a8e$export$477202748c7242bf).extendWith("indicator");
const $210cc27d3a3db981$export$8b1b9cdd5db9f5fd = (0, $07b08c6ef332e8db$export$197e6e8d4b33fd6c)("table").parts("root", "header", "body", "row", "columnHeader", "cell", "footer", "caption");
const $210cc27d3a3db981$export$c220e6c275daf119 = (0, $07b08c6ef332e8db$export$197e6e8d4b33fd6c)("toast").parts("root", "title", "description", "indicator", "closeTrigger", "actionTrigger");
const $210cc27d3a3db981$export$97383552563be58d = (0, $07b08c6ef332e8db$export$197e6e8d4b33fd6c)("tabs").parts("root", "trigger", "list", "content", "contentGroup", "indicator");
const $210cc27d3a3db981$export$4c2f5f7f2ea94a8e = (0, $07b08c6ef332e8db$export$197e6e8d4b33fd6c)("tag").parts("root", "label", "closeTrigger", "startElement", "endElement");
const $210cc27d3a3db981$export$174cdbdedca11ecf = (0, $07b08c6ef332e8db$export$197e6e8d4b33fd6c)("timeline").parts("root", "item", "content", "separator", "indicator", "connector", "title", "description");
const $210cc27d3a3db981$export$5785807b87db4889 = (0, $b8c5206fe75ae7c4$export$5785807b87db4889).extendWith("channelText");
const $210cc27d3a3db981$export$6a4205713a48b027 = (0, $07b08c6ef332e8db$export$197e6e8d4b33fd6c)("code-block", [
    "root",
    "content",
    "title",
    "header",
    "footer",
    "control",
    "overlay",
    "code",
    "codeText",
    "copyTrigger",
    "copyIndicator",
    "collapseTrigger",
    "collapseIndicator",
    "collapseText"
]);
const $210cc27d3a3db981$export$a71cb10e7bdef1a3 = (0, $9188a5e41e8687f3$export$477202748c7242bf).extendWith("resizeTriggerSeparator", "resizeTriggerIndicator");
const $210cc27d3a3db981$export$d43149442130cd05 = (0, $823e3b8ee3c08f83$export$477202748c7242bf).extendWith("valueText");
const $210cc27d3a3db981$export$a647f00ed9c3a914 = (0, $63a0fefa8f43e952$export$a647f00ed9c3a914);



"use strict";
const $f874c04e3d9fedcb$export$f4a442eb58b0fd05 = (0, $a2f848fc882d4d28$export$c28efc68fea5b4d6)({
    className: "chakra-accordion",
    slots: (0, $210cc27d3a3db981$export$377a77e99e7c73a5).keys(),
    base: {
        root: {
            width: "full",
            "--accordion-radius": "radii.l2"
        },
        item: {
            overflowAnchor: "none"
        },
        itemTrigger: {
            display: "flex",
            alignItems: "center",
            textAlign: "start",
            width: "full",
            outline: "0",
            gap: "3",
            fontWeight: "medium",
            borderRadius: "var(--accordion-radius)",
            _focusVisible: {
                outline: "2px solid",
                outlineColor: "colorPalette.focusRing"
            },
            _disabled: {
                layerStyle: "disabled"
            }
        },
        itemBody: {
            pt: "var(--accordion-padding-y)",
            pb: "calc(var(--accordion-padding-y) * 2)"
        },
        itemContent: {
            overflow: "hidden",
            borderRadius: "var(--accordion-radius)",
            _open: {
                animationName: "expand-height, fade-in",
                animationDuration: "moderate"
            },
            _closed: {
                animationName: "collapse-height, fade-out",
                animationDuration: "moderate"
            }
        },
        itemIndicator: {
            transition: "rotate 0.2s",
            transformOrigin: "center",
            color: "fg.subtle",
            _open: {
                rotate: "180deg"
            },
            _icon: {
                width: "1.2em",
                height: "1.2em"
            }
        }
    },
    variants: {
        variant: {
            outline: {
                item: {
                    borderBottomWidth: "1px"
                }
            },
            subtle: {
                itemTrigger: {
                    px: "var(--accordion-padding-x)"
                },
                itemContent: {
                    px: "var(--accordion-padding-x)"
                },
                item: {
                    borderRadius: "var(--accordion-radius)",
                    _open: {
                        bg: "colorPalette.subtle"
                    }
                }
            },
            enclosed: {
                root: {
                    borderWidth: "1px",
                    borderRadius: "var(--accordion-radius)",
                    divideY: "1px",
                    overflow: "hidden"
                },
                itemTrigger: {
                    px: "var(--accordion-padding-x)"
                },
                itemContent: {
                    px: "var(--accordion-padding-x)"
                },
                item: {
                    _open: {
                        bg: "bg.subtle"
                    }
                }
            },
            plain: {}
        },
        size: {
            sm: {
                root: {
                    "--accordion-padding-x": "spacing.3",
                    "--accordion-padding-y": "spacing.2"
                },
                itemTrigger: {
                    textStyle: "sm",
                    py: "var(--accordion-padding-y)"
                }
            },
            md: {
                root: {
                    "--accordion-padding-x": "spacing.4",
                    "--accordion-padding-y": "spacing.2"
                },
                itemTrigger: {
                    textStyle: "md",
                    py: "var(--accordion-padding-y)"
                }
            },
            lg: {
                root: {
                    "--accordion-padding-x": "spacing.4.5",
                    "--accordion-padding-y": "spacing.2.5"
                },
                itemTrigger: {
                    textStyle: "lg",
                    py: "var(--accordion-padding-y)"
                }
            }
        }
    },
    defaultVariants: {
        size: "md",
        variant: "outline"
    }
});




"use strict";
const $7170b8a5a618a83c$export$fa2b273b16ba8691 = (0, $a2f848fc882d4d28$export$c28efc68fea5b4d6)({
    className: "chakra-action-bar",
    slots: (0, $210cc27d3a3db981$export$7dd5043f89c4709c).keys(),
    base: {
        positioner: {
            position: "fixed",
            display: "flex",
            pointerEvents: "none",
            insetInline: "0",
            "--action-bar-offset": "spacing.4"
        },
        content: {
            bg: "bg.panel",
            shadow: "md",
            display: "flex",
            alignItems: "center",
            gap: "3",
            borderRadius: "l3",
            py: "2.5",
            px: "3",
            pointerEvents: "auto",
            // Stabilize the position of the action bar when the scrollbar is hidden
            // by using the scrollbar width to offset the position.
            translate: "calc(-1 * var(--scrollbar-width) / 2) 0px",
            _open: {
                animationName: "slide-from-bottom, fade-in",
                animationDuration: "moderate"
            },
            _closed: {
                animationName: "slide-to-bottom, fade-out",
                animationDuration: "faster"
            }
        },
        separator: {
            width: "1px",
            height: "5",
            bg: "border"
        },
        selectionTrigger: {
            display: "inline-flex",
            alignItems: "center",
            gap: "2",
            alignSelf: "stretch",
            textStyle: "sm",
            px: "4",
            py: "1",
            borderRadius: "l2",
            borderWidth: "1px",
            borderStyle: "dashed"
        }
    },
    variants: {
        placement: {
            bottom: {
                positioner: {
                    bottom: "calc(env(safe-area-inset-bottom) + var(--action-bar-offset))",
                    justifyContent: "center"
                }
            },
            "bottom-start": {
                positioner: {
                    bottom: "calc(env(safe-area-inset-bottom) + var(--action-bar-offset))",
                    justifyContent: "flex-start",
                    ps: "var(--action-bar-offset)"
                }
            },
            "bottom-end": {
                positioner: {
                    bottom: "calc(env(safe-area-inset-bottom) + var(--action-bar-offset))",
                    justifyContent: "flex-end",
                    pe: "var(--action-bar-offset)"
                }
            }
        }
    },
    defaultVariants: {
        placement: "bottom"
    }
});




"use strict";
const $23bce3028d4a0574$export$998588db5c35d89f = (0, $a2f848fc882d4d28$export$c28efc68fea5b4d6)({
    slots: (0, $210cc27d3a3db981$export$fc51889fa4de265a).keys(),
    className: "chakra-alert",
    base: {
        root: {
            width: "full",
            display: "flex",
            alignItems: "flex-start",
            position: "relative",
            borderRadius: "l3"
        },
        title: {
            fontWeight: "medium"
        },
        description: {
            display: "inline"
        },
        indicator: {
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: "0",
            width: "1em",
            height: "1em",
            _icon: {
                boxSize: "full"
            }
        },
        content: {
            display: "flex",
            flex: "1",
            gap: "1"
        }
    },
    variants: {
        status: {
            info: {
                root: {
                    colorPalette: "blue"
                }
            },
            warning: {
                root: {
                    colorPalette: "orange"
                }
            },
            success: {
                root: {
                    colorPalette: "green"
                }
            },
            error: {
                root: {
                    colorPalette: "red"
                }
            },
            neutral: {
                root: {
                    colorPalette: "gray"
                }
            }
        },
        inline: {
            true: {
                content: {
                    display: "inline-flex",
                    flexDirection: "row",
                    alignItems: "center"
                }
            },
            false: {
                content: {
                    display: "flex",
                    flexDirection: "column"
                }
            }
        },
        variant: {
            subtle: {
                root: {
                    bg: "colorPalette.subtle",
                    color: "colorPalette.fg"
                }
            },
            surface: {
                root: {
                    bg: "colorPalette.subtle",
                    color: "colorPalette.fg",
                    shadow: "inset 0 0 0px 1px var(--shadow-color)",
                    shadowColor: "colorPalette.muted"
                },
                indicator: {
                    color: "colorPalette.fg"
                }
            },
            outline: {
                root: {
                    color: "colorPalette.fg",
                    shadow: "inset 0 0 0px 1px var(--shadow-color)",
                    "--outline-shadow-legacy": "colors.colorPalette.muted",
                    "--outline-shadow": "colors.colorPalette.border",
                    shadowColor: "var(--outline-shadow, var(--outline-shadow-legacy))"
                },
                indicator: {
                    color: "colorPalette.fg"
                }
            },
            solid: {
                root: {
                    bg: "colorPalette.solid",
                    color: "colorPalette.contrast"
                },
                indicator: {
                    color: "colorPalette.contrast"
                }
            }
        },
        size: {
            sm: {
                root: {
                    gap: "2",
                    px: "3",
                    py: "3",
                    textStyle: "xs"
                },
                indicator: {
                    textStyle: "lg"
                }
            },
            md: {
                root: {
                    gap: "3",
                    px: "4",
                    py: "4",
                    textStyle: "sm"
                },
                indicator: {
                    textStyle: "xl"
                }
            },
            lg: {
                root: {
                    gap: "3",
                    px: "4",
                    py: "4",
                    textStyle: "md"
                },
                indicator: {
                    textStyle: "2xl"
                }
            }
        }
    },
    defaultVariants: {
        status: "info",
        variant: "subtle",
        size: "md",
        inline: false
    }
});




"use strict";
const $b705efe3fb62f23f$export$3abc6b3f791f1dd4 = (0, $a2f848fc882d4d28$export$c28efc68fea5b4d6)({
    slots: (0, $bae7990bd2b56513$export$477202748c7242bf).keys(),
    className: "chakra-avatar",
    base: {
        root: {
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: "medium",
            position: "relative",
            verticalAlign: "top",
            flexShrink: "0",
            userSelect: "none",
            width: "var(--avatar-size)",
            height: "var(--avatar-size)",
            fontSize: "var(--avatar-font-size)",
            borderRadius: "var(--avatar-radius)",
            "&[data-group-item]": {
                borderWidth: "2px",
                borderColor: "bg"
            }
        },
        image: {
            width: "100%",
            height: "100%",
            objectFit: "cover",
            borderRadius: "var(--avatar-radius)"
        },
        fallback: {
            lineHeight: "1",
            textTransform: "uppercase",
            fontWeight: "medium",
            fontSize: "var(--avatar-font-size)",
            borderRadius: "var(--avatar-radius)"
        }
    },
    variants: {
        size: {
            full: {
                root: {
                    "--avatar-size": "100%",
                    "--avatar-font-size": "100%"
                }
            },
            "2xs": {
                root: {
                    "--avatar-font-size": "fontSizes.2xs",
                    "--avatar-size": "sizes.6"
                }
            },
            xs: {
                root: {
                    "--avatar-font-size": "fontSizes.xs",
                    "--avatar-size": "sizes.8"
                }
            },
            sm: {
                root: {
                    "--avatar-font-size": "fontSizes.sm",
                    "--avatar-size": "sizes.9"
                }
            },
            md: {
                root: {
                    "--avatar-font-size": "fontSizes.md",
                    "--avatar-size": "sizes.10"
                }
            },
            lg: {
                root: {
                    "--avatar-font-size": "fontSizes.md",
                    "--avatar-size": "sizes.11"
                }
            },
            xl: {
                root: {
                    "--avatar-font-size": "fontSizes.lg",
                    "--avatar-size": "sizes.12"
                }
            },
            "2xl": {
                root: {
                    "--avatar-font-size": "fontSizes.xl",
                    "--avatar-size": "sizes.16"
                }
            }
        },
        variant: {
            solid: {
                root: {
                    bg: "colorPalette.solid",
                    color: "colorPalette.contrast"
                }
            },
            subtle: {
                root: {
                    bg: "colorPalette.muted",
                    color: "colorPalette.fg"
                }
            },
            outline: {
                root: {
                    color: "colorPalette.fg",
                    borderWidth: "1px",
                    "--outline-shadow-legacy": "colors.colorPalette.muted",
                    "--outline-shadow": "colors.colorPalette.border",
                    borderColor: "var(--outline-shadow, var(--outline-shadow-legacy))"
                }
            }
        },
        shape: {
            square: {},
            rounded: {
                root: {
                    "--avatar-radius": "radii.l3"
                }
            },
            full: {
                root: {
                    "--avatar-radius": "radii.full"
                }
            }
        },
        borderless: {
            true: {
                root: {
                    "&[data-group-item]": {
                        borderWidth: "0px"
                    }
                }
            }
        }
    },
    defaultVariants: {
        size: "md",
        shape: "full",
        variant: "subtle"
    }
});




"use strict";
const $247a76e2ef711f70$export$8b1f9367c4597998 = (0, $a2f848fc882d4d28$export$c28efc68fea5b4d6)({
    className: "chakra-blockquote",
    slots: (0, $210cc27d3a3db981$export$50ffc6bb83cc6686).keys(),
    base: {
        root: {
            position: "relative",
            display: "flex",
            flexDirection: "column",
            gap: "2"
        },
        caption: {
            textStyle: "sm",
            color: "fg.muted"
        },
        icon: {
            boxSize: "5"
        }
    },
    variants: {
        justify: {
            start: {
                root: {
                    alignItems: "flex-start",
                    textAlign: "start"
                }
            },
            center: {
                root: {
                    alignItems: "center",
                    textAlign: "center"
                }
            },
            end: {
                root: {
                    alignItems: "flex-end",
                    textAlign: "end"
                }
            }
        },
        variant: {
            subtle: {
                root: {
                    paddingX: "5",
                    borderStartWidth: "4px",
                    borderStartColor: "colorPalette.muted"
                },
                icon: {
                    color: "colorPalette.fg"
                }
            },
            solid: {
                root: {
                    paddingX: "5",
                    borderStartWidth: "4px",
                    borderStartColor: "colorPalette.solid"
                },
                icon: {
                    color: "colorPalette.solid"
                }
            },
            plain: {
                root: {
                    paddingX: "5"
                },
                icon: {
                    color: "colorPalette.solid"
                }
            }
        }
    },
    defaultVariants: {
        variant: "subtle",
        justify: "start"
    }
});




"use strict";
const $8d059d997880e84d$export$445bd218bcf49ac8 = (0, $a2f848fc882d4d28$export$c28efc68fea5b4d6)({
    className: "chakra-breadcrumb",
    slots: (0, $210cc27d3a3db981$export$2fb03f744a6ecf93).keys(),
    base: {
        list: {
            display: "flex",
            alignItems: "center",
            wordBreak: "break-word",
            color: "fg.muted",
            listStyle: "none"
        },
        link: {
            outline: "0",
            textDecoration: "none",
            borderRadius: "l1",
            focusRing: "outside",
            display: "inline-flex",
            alignItems: "center",
            gap: "2"
        },
        item: {
            display: "inline-flex",
            alignItems: "center"
        },
        separator: {
            color: "fg.muted",
            opacity: "0.8",
            _icon: {
                boxSize: "1em"
            },
            _rtl: {
                rotate: "180deg"
            }
        },
        ellipsis: {
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            _icon: {
                boxSize: "1em"
            }
        }
    },
    variants: {
        variant: {
            underline: {
                link: {
                    color: "colorPalette.fg",
                    textDecoration: "underline",
                    textUnderlineOffset: "0.2em",
                    textDecorationColor: "colorPalette.muted"
                },
                currentLink: {
                    color: "colorPalette.fg"
                }
            },
            plain: {
                link: {
                    color: "fg.muted",
                    _hover: {
                        color: "fg"
                    }
                },
                currentLink: {
                    color: "fg"
                }
            }
        },
        size: {
            sm: {
                list: {
                    gap: "1",
                    textStyle: "xs"
                }
            },
            md: {
                list: {
                    gap: "1.5",
                    textStyle: "sm"
                }
            },
            lg: {
                list: {
                    gap: "2",
                    textStyle: "md"
                }
            }
        }
    },
    defaultVariants: {
        variant: "plain",
        size: "md"
    }
});




"use strict";
const $37a6087dfe9e7f76$export$e4092ce1781694ee = (0, $a2f848fc882d4d28$export$c28efc68fea5b4d6)({
    className: "chakra-card",
    slots: (0, $210cc27d3a3db981$export$487a447ffa5755b6).keys(),
    base: {
        root: {
            display: "flex",
            flexDirection: "column",
            position: "relative",
            minWidth: "0",
            wordWrap: "break-word",
            borderRadius: "l3",
            color: "fg",
            textAlign: "start"
        },
        title: {
            fontWeight: "semibold"
        },
        description: {
            color: "fg.muted",
            fontSize: "sm"
        },
        header: {
            paddingInline: "var(--card-padding)",
            paddingTop: "var(--card-padding)",
            display: "flex",
            flexDirection: "column",
            gap: "1.5"
        },
        body: {
            padding: "var(--card-padding)",
            flex: "1",
            display: "flex",
            flexDirection: "column"
        },
        footer: {
            display: "flex",
            alignItems: "center",
            gap: "2",
            paddingInline: "var(--card-padding)",
            paddingBottom: "var(--card-padding)"
        }
    },
    variants: {
        size: {
            sm: {
                root: {
                    "--card-padding": "spacing.4"
                },
                title: {
                    textStyle: "md"
                }
            },
            md: {
                root: {
                    "--card-padding": "spacing.6"
                },
                title: {
                    textStyle: "lg"
                }
            },
            lg: {
                root: {
                    "--card-padding": "spacing.7"
                },
                title: {
                    textStyle: "xl"
                }
            }
        },
        variant: {
            elevated: {
                root: {
                    bg: "bg.panel",
                    boxShadow: "md"
                }
            },
            outline: {
                root: {
                    bg: "bg.panel",
                    borderWidth: "1px",
                    borderColor: "border"
                }
            },
            subtle: {
                root: {
                    bg: "bg.muted"
                }
            }
        }
    },
    defaultVariants: {
        variant: "outline",
        size: "md"
    }
});



// src/carousel.anatomy.ts

var $46ad3eb6ca2572c4$export$477202748c7242bf = (0, $07b08c6ef332e8db$export$197e6e8d4b33fd6c)("carousel").parts("root", "itemGroup", "item", "control", "nextTrigger", "prevTrigger", "indicatorGroup", "indicator", "autoplayTrigger", "progressText");
var $46ad3eb6ca2572c4$export$6e2410c1d27f06e7 = $46ad3eb6ca2572c4$export$477202748c7242bf.build();


"use client";
//#region src/components/carousel/carousel.anatomy.ts
var $2a6941b3dbedc57f$export$e67b3606cf57ab74 = (0, $46ad3eb6ca2572c4$export$477202748c7242bf).extendWith("progressText", "autoplayIndicator");


"use strict";
const $99515255363f0249$export$1a5a8bd3845f7bc6 = (0, $a2f848fc882d4d28$export$c28efc68fea5b4d6)({
    className: "carousel",
    slots: (0, $2a6941b3dbedc57f$export$e67b3606cf57ab74).keys(),
    base: {
        root: {
            position: "relative",
            display: "flex",
            gap: "2",
            _horizontal: {
                flexDirection: "column"
            },
            _vertical: {
                flexDirection: "row"
            }
        },
        item: {
            _horizontal: {
                width: "100%"
            },
            _vertical: {
                height: "100%"
            }
        },
        control: {
            display: "flex",
            alignItems: "center",
            _horizontal: {
                flexDirection: "row",
                width: "100%"
            },
            _vertical: {
                flexDirection: "column",
                height: "100%"
            }
        },
        indicatorGroup: {
            display: "flex",
            justifyContent: "center",
            gap: "3",
            _horizontal: {
                flexDirection: "row"
            },
            _vertical: {
                flexDirection: "column"
            }
        },
        indicator: {
            width: "2.5",
            height: "2.5",
            borderRadius: "full",
            bg: "colorPalette.subtle",
            cursor: "button",
            _current: {
                bg: "colorPalette.solid"
            }
        }
    },
    defaultVariants: {}
});




// src/checkbox.anatomy.ts

var $805958d46f3c1d25$export$477202748c7242bf = (0, $07b08c6ef332e8db$export$197e6e8d4b33fd6c)("checkbox").parts("root", "label", "control", "indicator");
var $805958d46f3c1d25$export$6e2410c1d27f06e7 = $805958d46f3c1d25$export$477202748c7242bf.build();


"use client";
//#region src/components/checkbox/checkbox.anatomy.ts
var $01ef0fa17d719948$export$21946b04497ed6ac = (0, $805958d46f3c1d25$export$477202748c7242bf).extendWith("group");


"use strict";
const $67e98e09244ed2b7$export$85054d78118eabd7 = (0, $a2f848fc882d4d28$export$c28efc68fea5b4d6)({
    slots: (0, $01ef0fa17d719948$export$21946b04497ed6ac).keys(),
    className: "chakra-checkbox",
    base: {
        root: {
            display: "inline-flex",
            gap: "2",
            alignItems: "center",
            verticalAlign: "top",
            position: "relative"
        },
        control: (0, $104dd58d161685fc$export$ecb1dc0d32e8f247).base,
        label: {
            fontWeight: "medium",
            userSelect: "none",
            _disabled: {
                opacity: "0.5"
            }
        }
    },
    variants: {
        size: {
            xs: {
                root: {
                    gap: "1.5"
                },
                label: {
                    textStyle: "xs"
                },
                control: (0, $104dd58d161685fc$export$ecb1dc0d32e8f247).variants?.size?.xs
            },
            sm: {
                root: {
                    gap: "2"
                },
                label: {
                    textStyle: "sm"
                },
                control: (0, $104dd58d161685fc$export$ecb1dc0d32e8f247).variants?.size?.sm
            },
            md: {
                root: {
                    gap: "2.5"
                },
                label: {
                    textStyle: "sm"
                },
                control: (0, $104dd58d161685fc$export$ecb1dc0d32e8f247).variants?.size?.md
            },
            lg: {
                root: {
                    gap: "3"
                },
                label: {
                    textStyle: "md"
                },
                control: (0, $104dd58d161685fc$export$ecb1dc0d32e8f247).variants?.size?.lg
            }
        },
        variant: {
            outline: {
                control: (0, $104dd58d161685fc$export$ecb1dc0d32e8f247).variants?.variant?.outline
            },
            solid: {
                control: (0, $104dd58d161685fc$export$ecb1dc0d32e8f247).variants?.variant?.solid
            },
            subtle: {
                control: (0, $104dd58d161685fc$export$ecb1dc0d32e8f247).variants?.variant?.subtle
            }
        }
    },
    defaultVariants: {
        variant: "solid",
        size: "md"
    }
});





"use strict";
const $e53d9954d2320e79$export$7450efef80368c09 = (0, $a2f848fc882d4d28$export$c28efc68fea5b4d6)({
    slots: (0, $210cc27d3a3db981$export$e4581dd169704619).keys(),
    className: "chakra-checkbox-card",
    base: {
        root: {
            display: "flex",
            flexDirection: "column",
            userSelect: "none",
            position: "relative",
            borderRadius: "l2",
            flex: "1",
            focusVisibleRing: "outside",
            _disabled: {
                opacity: "0.8"
            },
            _invalid: {
                outline: "2px solid",
                outlineColor: "border.error"
            }
        },
        control: {
            display: "inline-flex",
            flex: "1",
            position: "relative",
            borderRadius: "inherit",
            justifyContent: "var(--checkbox-card-justify)",
            alignItems: "var(--checkbox-card-align)"
        },
        label: {
            fontWeight: "medium",
            display: "flex",
            alignItems: "center",
            gap: "2",
            flex: "1",
            _disabled: {
                opacity: "0.5"
            }
        },
        description: {
            opacity: "0.64",
            textStyle: "sm",
            _disabled: {
                opacity: "0.5"
            }
        },
        addon: {
            _disabled: {
                opacity: "0.5"
            }
        },
        indicator: (0, $104dd58d161685fc$export$ecb1dc0d32e8f247).base,
        content: {
            display: "flex",
            flexDirection: "column",
            flex: "1",
            gap: "1",
            justifyContent: "var(--checkbox-card-justify)",
            alignItems: "var(--checkbox-card-align)"
        }
    },
    variants: {
        size: {
            sm: {
                root: {
                    textStyle: "sm"
                },
                control: {
                    padding: "3",
                    gap: "1.5"
                },
                addon: {
                    px: "3",
                    py: "1.5",
                    borderTopWidth: "1px"
                },
                indicator: (0, $104dd58d161685fc$export$ecb1dc0d32e8f247).variants?.size.sm
            },
            md: {
                root: {
                    textStyle: "sm"
                },
                control: {
                    padding: "4",
                    gap: "2.5"
                },
                addon: {
                    px: "4",
                    py: "2",
                    borderTopWidth: "1px"
                },
                indicator: (0, $104dd58d161685fc$export$ecb1dc0d32e8f247).variants?.size.md
            },
            lg: {
                root: {
                    textStyle: "md"
                },
                control: {
                    padding: "4",
                    gap: "3.5"
                },
                addon: {
                    px: "4",
                    py: "2",
                    borderTopWidth: "1px"
                },
                indicator: (0, $104dd58d161685fc$export$ecb1dc0d32e8f247).variants?.size.lg
            }
        },
        variant: {
            surface: {
                root: {
                    borderWidth: "1px",
                    borderColor: "border",
                    _checked: {
                        bg: "colorPalette.subtle",
                        color: "colorPalette.fg",
                        borderColor: "colorPalette.muted"
                    },
                    _disabled: {
                        bg: "bg.muted"
                    }
                },
                indicator: (0, $104dd58d161685fc$export$ecb1dc0d32e8f247).variants?.variant.solid
            },
            subtle: {
                root: {
                    bg: "bg.muted"
                },
                control: {
                    _checked: {
                        bg: "colorPalette.muted",
                        color: "colorPalette.fg"
                    }
                },
                indicator: (0, $104dd58d161685fc$export$ecb1dc0d32e8f247).variants?.variant.plain
            },
            outline: {
                root: {
                    borderWidth: "1px",
                    borderColor: "border",
                    _checked: {
                        boxShadow: "0 0 0 1px var(--shadow-color)",
                        boxShadowColor: "colorPalette.solid",
                        borderColor: "colorPalette.solid"
                    }
                },
                indicator: (0, $104dd58d161685fc$export$ecb1dc0d32e8f247).variants?.variant.solid
            },
            solid: {
                root: {
                    borderWidth: "1px",
                    _checked: {
                        bg: "colorPalette.solid",
                        color: "colorPalette.contrast",
                        borderColor: "colorPalette.solid"
                    }
                },
                indicator: (0, $104dd58d161685fc$export$ecb1dc0d32e8f247).variants?.variant.inverted
            }
        },
        justify: {
            start: {
                root: {
                    "--checkbox-card-justify": "flex-start"
                }
            },
            end: {
                root: {
                    "--checkbox-card-justify": "flex-end"
                }
            },
            center: {
                root: {
                    "--checkbox-card-justify": "center"
                }
            }
        },
        align: {
            start: {
                root: {
                    "--checkbox-card-align": "flex-start"
                },
                content: {
                    textAlign: "start"
                }
            },
            end: {
                root: {
                    "--checkbox-card-align": "flex-end"
                },
                content: {
                    textAlign: "end"
                }
            },
            center: {
                root: {
                    "--checkbox-card-align": "center"
                },
                content: {
                    textAlign: "center"
                }
            }
        },
        orientation: {
            vertical: {
                control: {
                    flexDirection: "column"
                }
            },
            horizontal: {
                control: {
                    flexDirection: "row"
                }
            }
        }
    },
    defaultVariants: {
        size: "md",
        variant: "outline",
        align: "start",
        orientation: "horizontal"
    }
});




"use strict";
const $6eec3e74c2da3949$export$e9293545fcf7204c = (0, $a2f848fc882d4d28$export$c28efc68fea5b4d6)({
    slots: (0, $210cc27d3a3db981$export$6a4205713a48b027).keys(),
    className: "code-block",
    base: {
        root: {
            colorPalette: "gray",
            rounded: "var(--code-block-radius)",
            overflow: "hidden",
            bg: "bg",
            color: "fg",
            borderWidth: "1px",
            "--code-block-max-height": "320px",
            "--code-block-bg": "colors.bg",
            "--code-block-fg": "colors.fg",
            "--code-block-obscured-opacity": "0.5",
            "--code-block-obscured-blur": "1px",
            "--code-block-line-number-width": "sizes.3",
            "--code-block-line-number-margin": "spacing.4",
            "--code-block-highlight-bg": "{colors.teal.focusRing/20}",
            "--code-block-highlight-border": "colors.teal.focusRing",
            "--code-block-highlight-added-bg": "{colors.green.focusRing/20}",
            "--code-block-highlight-added-border": "colors.green.focusRing",
            "--code-block-highlight-removed-bg": "{colors.red.focusRing/20}",
            "--code-block-highlight-removed-border": "colors.red.focusRing"
        },
        header: {
            display: "flex",
            alignItems: "center",
            gap: "2",
            position: "relative",
            px: "var(--code-block-padding)",
            minH: "var(--code-block-header-height)",
            mb: "calc(var(--code-block-padding) / 2 * -1)"
        },
        title: {
            display: "inline-flex",
            alignItems: "center",
            gap: "1.5",
            flex: "1",
            color: "fg.muted"
        },
        control: {
            gap: "1.5",
            display: "inline-flex",
            alignItems: "center"
        },
        footer: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "2",
            px: "var(--code-block-padding)",
            minH: "var(--code-block-header-height)"
        },
        content: {
            position: "relative",
            colorScheme: "dark",
            borderBottomRadius: "var(--code-block-radius)",
            maxHeight: "var(--code-block-max-height)",
            "& ::selection": {
                bg: "blue.500/40"
            },
            _expanded: {
                maxHeight: "unset"
            }
        },
        overlay: {
            "--bg": "{colors.black/50}",
            display: "flex",
            alignItems: "flex-end",
            justifyContent: "center",
            padding: "4",
            bgImage: "linear-gradient(0deg,var(--bg) 25%,transparent 100%)",
            color: "white",
            minH: "5rem",
            pos: "absolute",
            bottom: "0",
            insetInline: "0",
            zIndex: "1",
            fontWeight: "medium",
            _expanded: {
                display: "none"
            }
        },
        code: {
            fontFamily: "mono",
            lineHeight: "tall",
            whiteSpace: "pre",
            counterReset: "line 0",
            overflowX: "auto",
            overflowY: "hidden"
        },
        codeText: {
            px: "var(--code-block-padding)",
            py: "var(--code-block-padding)",
            position: "relative",
            display: "block",
            width: "100%",
            "&[data-has-focused]": {
                "& [data-line]:not([data-focused])": {
                    transitionProperty: "opacity, filter",
                    transitionDuration: "moderate",
                    transitionTimingFunction: "ease-in-out",
                    opacity: "var(--code-block-obscured-opacity)",
                    filter: "blur(var(--code-block-obscured-blur))"
                },
                "&:hover": {
                    "--code-block-obscured-opacity": "1",
                    "--code-block-obscured-blur": "0px"
                }
            },
            "&[data-has-line-numbers][data-plaintext]": {
                paddingInlineStart: "calc(var(--code-block-line-number-width) + var(--code-block-line-number-margin) + var(--code-block-padding))"
            },
            "& [data-line]": {
                position: "relative",
                paddingInlineEnd: "var(--code-block-padding)",
                "--highlight-bg": "var(--code-block-highlight-bg)",
                "--highlight-border": "var(--code-block-highlight-border)",
                "&[data-highlight], &[data-diff]": {
                    display: "inline-block",
                    width: "full",
                    "&:after": {
                        content: `''`,
                        display: "block",
                        position: "absolute",
                        top: "0",
                        insetStart: "calc(var(--code-block-padding) * -1)",
                        insetEnd: "0px",
                        width: "calc(100% + var(--code-block-padding) * 2)",
                        height: "100%",
                        bg: "var(--highlight-bg)",
                        borderStartWidth: "2px",
                        borderStartColor: "var(--highlight-border)"
                    }
                },
                "&[data-diff='added']": {
                    "--highlight-bg": "var(--code-block-highlight-added-bg)",
                    "--highlight-border": "var(--code-block-highlight-added-border)"
                },
                "&[data-diff='removed']": {
                    "--highlight-bg": "var(--code-block-highlight-removed-bg)",
                    "--highlight-border": "var(--code-block-highlight-removed-border)"
                }
            },
            "&[data-word-wrap]": {
                "&[data-plaintext], & [data-line]": {
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-all"
                }
            },
            "&[data-has-line-numbers]": {
                "--content": "counter(line)",
                "& [data-line]:before": {
                    content: "var(--content)",
                    counterIncrement: "line",
                    width: "var(--code-block-line-number-width)",
                    marginRight: "var(--code-block-line-number-margin)",
                    display: "inline-block",
                    textAlign: "end",
                    userSelect: "none",
                    whiteSpace: "nowrap",
                    opacity: 0.4
                },
                "& [data-diff='added']:before": {
                    content: "'+'"
                },
                "& [data-diff='removed']:before": {
                    content: "'-'"
                }
            }
        }
    },
    variants: {
        size: {
            sm: {
                root: {
                    "--code-block-padding": "spacing.4",
                    "--code-block-radius": "radii.md",
                    "--code-block-header-height": "sizes.8"
                },
                title: {
                    textStyle: "xs"
                },
                code: {
                    fontSize: "xs"
                }
            },
            md: {
                root: {
                    "--code-block-padding": "spacing.4",
                    "--code-block-radius": "radii.lg",
                    "--code-block-header-height": "sizes.10"
                },
                title: {
                    textStyle: "xs"
                },
                code: {
                    fontSize: "sm"
                }
            },
            lg: {
                root: {
                    "--code-block-padding": "spacing.5",
                    "--code-block-radius": "radii.xl",
                    "--code-block-header-height": "sizes.12"
                },
                title: {
                    textStyle: "sm"
                },
                code: {
                    fontSize: "sm"
                }
            }
        }
    },
    defaultVariants: {
        size: "md"
    }
});



// src/collapsible.anatomy.ts

var $23131156469f6faf$export$477202748c7242bf = (0, $07b08c6ef332e8db$export$197e6e8d4b33fd6c)("collapsible").parts("root", "trigger", "content", "indicator");
var $23131156469f6faf$export$6e2410c1d27f06e7 = $23131156469f6faf$export$477202748c7242bf.build();


"use strict";
const $d19284983fd35432$export$e9d5652bed1138b = (0, $a2f848fc882d4d28$export$c28efc68fea5b4d6)({
    slots: (0, $23131156469f6faf$export$477202748c7242bf).keys(),
    className: "chakra-collapsible",
    base: {
        content: {
            overflow: "hidden",
            _open: {
                animationName: "expand-height, fade-in",
                animationDuration: "moderate",
                "&[data-has-collapsed-size]": {
                    animationName: "expand-height"
                }
            },
            _closed: {
                animationName: "collapse-height, fade-out",
                animationDuration: "moderate",
                "&[data-has-collapsed-size]": {
                    animationName: "collapse-height"
                }
            }
        }
    }
});






"use strict";
const $2050d0c3bb270b24$export$e0aacfa04a4a59f3 = (0, $a2f848fc882d4d28$export$c28efc68fea5b4d6)({
    className: "colorPicker",
    slots: (0, $210cc27d3a3db981$export$5785807b87db4889).keys(),
    base: {
        root: {
            display: "flex",
            flexDirection: "column",
            gap: "1.5"
        },
        label: {
            color: "fg",
            fontWeight: "medium",
            textStyle: "sm",
            _disabled: {
                opacity: "0.5"
            }
        },
        valueText: {
            textAlign: "start"
        },
        control: {
            display: "flex",
            alignItems: "center",
            flexDirection: "row",
            gap: "2",
            position: "relative"
        },
        swatchTrigger: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        },
        trigger: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "row",
            flexShrink: "0",
            gap: "2",
            textStyle: "sm",
            minH: "var(--input-height)",
            minW: "var(--input-height)",
            px: "1",
            rounded: "l2",
            _disabled: {
                opacity: "0.5"
            },
            "--focus-color": "colors.colorPalette.focusRing",
            "&:focus-visible": {
                borderColor: "var(--focus-color)",
                outline: "1px solid var(--focus-color)"
            },
            "&[data-fit-content]": {
                "--input-height": "unset",
                px: "0",
                border: "0"
            }
        },
        content: {
            display: "flex",
            flexDirection: "column",
            bg: "bg.panel",
            borderRadius: "l3",
            boxShadow: "lg",
            width: "64",
            p: "4",
            gap: "3",
            "--color-picker-z-index": "zIndex.popover",
            zIndex: "calc(var(--color-picker-z-index) + var(--layer-index, 0))",
            _open: {
                animationStyle: "slide-fade-in",
                animationDuration: "fast"
            },
            _closed: {
                animationStyle: "slide-fade-out",
                animationDuration: "faster"
            }
        },
        area: {
            height: "180px",
            borderRadius: "l2",
            overflow: "hidden"
        },
        areaThumb: {
            borderRadius: "full",
            height: "var(--thumb-size)",
            width: "var(--thumb-size)",
            borderWidth: "2px",
            borderColor: "white",
            shadow: "sm",
            focusVisibleRing: "mixed",
            focusRingColor: "white"
        },
        areaBackground: {
            height: "full"
        },
        channelSlider: {
            borderRadius: "l2",
            flex: "1"
        },
        channelSliderTrack: {
            height: "var(--slider-height)",
            borderRadius: "inherit",
            boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.1)"
        },
        channelText: {
            textStyle: "xs",
            color: "fg.muted",
            fontWeight: "medium",
            textTransform: "capitalize"
        },
        swatchGroup: {
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            gap: "2"
        },
        swatch: {
            ...(0, $b9f6b2092cb477d8$export$9822f4e3dd6bcc87).base,
            borderRadius: "l1"
        },
        swatchIndicator: {
            color: "white",
            rounded: "full"
        },
        channelSliderThumb: {
            borderRadius: "full",
            height: "var(--thumb-size)",
            width: "var(--thumb-size)",
            borderWidth: "2px",
            borderColor: "white",
            shadow: "sm",
            transform: "translate(-50%, -50%)",
            focusVisibleRing: "outside",
            focusRingOffset: "1px"
        },
        channelInput: {
            ...(0, $fd8ba95b29dad282$export$a6445e005c28dca2).base,
            "&::-webkit-inner-spin-button, &::-webkit-outer-spin-button": {
                WebkitAppearance: "none",
                margin: 0
            }
        },
        formatSelect: {
            textStyle: "xs",
            textTransform: "uppercase",
            borderWidth: "1px",
            minH: "6",
            focusRing: "inside",
            rounded: "l2"
        },
        transparencyGrid: {
            borderRadius: "l2"
        },
        view: {
            display: "flex",
            flexDirection: "column",
            gap: "2"
        }
    },
    variants: {
        size: {
            "2xs": {
                channelInput: (0, $fd8ba95b29dad282$export$a6445e005c28dca2).variants?.size?.["2xs"],
                swatch: {
                    "--swatch-size": "sizes.4.5"
                },
                trigger: {
                    "--input-height": "sizes.7"
                },
                area: {
                    "--thumb-size": "sizes.3"
                },
                channelSlider: {
                    "--slider-height": "sizes.3",
                    "--thumb-size": "sizes.3"
                }
            },
            xs: {
                channelInput: (0, $fd8ba95b29dad282$export$a6445e005c28dca2).variants?.size?.xs,
                swatch: {
                    "--swatch-size": "sizes.5"
                },
                trigger: {
                    "--input-height": "sizes.8"
                },
                area: {
                    "--thumb-size": "sizes.3.5"
                },
                channelSlider: {
                    "--slider-height": "sizes.3.5",
                    "--thumb-size": "sizes.3.5"
                }
            },
            sm: {
                channelInput: (0, $fd8ba95b29dad282$export$a6445e005c28dca2).variants?.size?.sm,
                swatch: {
                    "--swatch-size": "sizes.6"
                },
                trigger: {
                    "--input-height": "sizes.9"
                },
                area: {
                    "--thumb-size": "sizes.3.5"
                },
                channelSlider: {
                    "--slider-height": "sizes.3.5",
                    "--thumb-size": "sizes.3.5"
                }
            },
            md: {
                channelInput: (0, $fd8ba95b29dad282$export$a6445e005c28dca2).variants?.size?.md,
                swatch: {
                    "--swatch-size": "sizes.7"
                },
                trigger: {
                    "--input-height": "sizes.10"
                },
                area: {
                    "--thumb-size": "sizes.3.5"
                },
                channelSlider: {
                    "--slider-height": "sizes.3.5",
                    "--thumb-size": "sizes.3.5"
                }
            },
            lg: {
                channelInput: (0, $fd8ba95b29dad282$export$a6445e005c28dca2).variants?.size?.lg,
                swatch: {
                    "--swatch-size": "sizes.7"
                },
                trigger: {
                    "--input-height": "sizes.11"
                },
                area: {
                    "--thumb-size": "sizes.3.5"
                },
                channelSlider: {
                    "--slider-height": "sizes.3.5",
                    "--thumb-size": "sizes.3.5"
                }
            },
            xl: {
                channelInput: (0, $fd8ba95b29dad282$export$a6445e005c28dca2).variants?.size?.xl,
                swatch: {
                    "--swatch-size": "sizes.8"
                },
                trigger: {
                    "--input-height": "sizes.12"
                },
                area: {
                    "--thumb-size": "sizes.3.5"
                },
                channelSlider: {
                    "--slider-height": "sizes.3.5",
                    "--thumb-size": "sizes.3.5"
                }
            },
            "2xl": {
                channelInput: (0, $fd8ba95b29dad282$export$a6445e005c28dca2).variants?.size?.["2xl"],
                swatch: {
                    "--swatch-size": "sizes.10"
                },
                trigger: {
                    "--input-height": "sizes.16"
                },
                area: {
                    "--thumb-size": "sizes.3.5"
                },
                channelSlider: {
                    "--slider-height": "sizes.3.5",
                    "--thumb-size": "sizes.3.5"
                }
            }
        },
        variant: {
            outline: {
                channelInput: (0, $fd8ba95b29dad282$export$a6445e005c28dca2).variants?.variant?.outline,
                trigger: {
                    borderWidth: "1px"
                }
            },
            subtle: {
                channelInput: (0, $fd8ba95b29dad282$export$a6445e005c28dca2).variants?.variant?.subtle,
                trigger: {
                    borderWidth: "1px",
                    borderColor: "transparent",
                    bg: "bg.muted"
                }
            }
        }
    },
    defaultVariants: {
        size: "md",
        variant: "outline"
    }
});




"use strict";
const $f4b0d0bb6b440b14$export$8fd0fff2ef925f46 = (0, $a2f848fc882d4d28$export$c28efc68fea5b4d6)({
    className: "chakra-combobox",
    slots: (0, $210cc27d3a3db981$export$feda4744fa5788da).keys(),
    base: {
        root: {
            display: "flex",
            flexDirection: "column",
            gap: "1.5",
            width: "full"
        },
        label: {
            fontWeight: "medium",
            userSelect: "none",
            textStyle: "sm",
            _disabled: {
                layerStyle: "disabled"
            }
        },
        control: {
            pos: "relative",
            "--padding-factor": "1",
            "--combobox-input-padding-end": "var(--combobox-input-padding-x)",
            "&:has([data-part=trigger]), &:has([data-part=clear-trigger])": {
                "--combobox-input-padding-end": "calc(var(--combobox-input-height) * var(--padding-factor))"
            },
            "&:has([data-part=trigger]):has([data-part=clear-trigger]:not([hidden]))": {
                "--padding-factor": "1.5"
            }
        },
        input: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            background: "bg.panel",
            width: "full",
            minH: "var(--combobox-input-height)",
            ps: "var(--combobox-input-padding-x)",
            pe: "var(--combobox-input-padding-end)",
            "--input-height": "var(--combobox-input-height)",
            borderRadius: "l2",
            outline: 0,
            userSelect: "none",
            textAlign: "start",
            _placeholderShown: {
                color: "fg.muted"
            },
            _disabled: {
                layerStyle: "disabled"
            },
            "--focus-color": "colors.colorPalette.focusRing",
            "--error-color": "colors.border.error",
            _invalid: {
                focusRingColor: "var(--error-color)",
                borderColor: "var(--error-color)"
            }
        },
        trigger: {
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            "--input-height": "var(--combobox-input-height)"
        },
        clearTrigger: {
            color: "fg.muted",
            pointerEvents: "auto",
            focusVisibleRing: "inside",
            focusRingWidth: "2px",
            rounded: "l1"
        },
        indicatorGroup: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "1",
            pos: "absolute",
            insetEnd: "0",
            top: "0",
            bottom: "0",
            px: "var(--combobox-input-padding-x)",
            _icon: {
                boxSize: "var(--combobox-indicator-size)"
            },
            "[data-disabled] &": {
                opacity: 0.5
            }
        },
        content: {
            background: "bg.panel",
            display: "flex",
            flexDirection: "column",
            "--combobox-z-index": "zIndex.popover",
            zIndex: "calc(var(--combobox-z-index) + var(--layer-index, 0))",
            borderRadius: "l2",
            outline: 0,
            maxH: "96",
            overflowY: "auto",
            boxShadow: "md",
            _open: {
                animationStyle: "slide-fade-in",
                animationDuration: "fast"
            },
            _closed: {
                animationStyle: "slide-fade-out",
                animationDuration: "0s"
            },
            "&[data-empty]:not(:has([data-scope=combobox][data-part=empty]))": {
                opacity: 0
            }
        },
        item: {
            position: "relative",
            userSelect: "none",
            display: "flex",
            alignItems: "center",
            gap: "2",
            py: "var(--combobox-item-padding-y)",
            px: "var(--combobox-item-padding-x)",
            cursor: "option",
            justifyContent: "space-between",
            flex: "1",
            textAlign: "start",
            borderRadius: "l1",
            _highlighted: {
                bg: "bg.emphasized/60"
            },
            _disabled: {
                pointerEvents: "none",
                opacity: "0.5"
            },
            _icon: {
                boxSize: "var(--combobox-indicator-size)"
            }
        },
        empty: {
            py: "var(--combobox-item-padding-y)",
            px: "var(--combobox-item-padding-x)"
        },
        itemText: {
            flex: "1"
        },
        itemGroup: {
            pb: "var(--combobox-item-padding-y)",
            _last: {
                pb: "0"
            }
        },
        itemGroupLabel: {
            fontWeight: "medium",
            py: "var(--combobox-item-padding-y)",
            px: "var(--combobox-item-padding-x)"
        }
    },
    variants: {
        variant: {
            outline: {
                input: {
                    bg: "transparent",
                    borderWidth: "1px",
                    borderColor: "border",
                    focusVisibleRing: "inside"
                }
            },
            subtle: {
                input: {
                    borderWidth: "1px",
                    borderColor: "transparent",
                    bg: "bg.muted",
                    focusVisibleRing: "inside"
                }
            },
            flushed: {
                input: {
                    bg: "transparent",
                    borderBottomWidth: "1px",
                    borderBottomColor: "border",
                    borderRadius: "0",
                    px: "0",
                    _focusVisible: {
                        borderColor: "var(--focus-color)",
                        boxShadow: "0px 1px 0px 0px var(--focus-color)"
                    }
                },
                indicatorGroup: {
                    px: "0"
                }
            }
        },
        size: {
            xs: {
                root: {
                    "--combobox-input-height": "sizes.8",
                    "--combobox-input-padding-x": "spacing.2",
                    "--combobox-indicator-size": "sizes.3.5"
                },
                input: {
                    textStyle: "xs"
                },
                content: {
                    "--combobox-item-padding-x": "spacing.1.5",
                    "--combobox-item-padding-y": "spacing.1",
                    "--combobox-indicator-size": "sizes.3.5",
                    p: "1",
                    textStyle: "xs"
                },
                trigger: {
                    textStyle: "xs",
                    gap: "1"
                }
            },
            sm: {
                root: {
                    "--combobox-input-height": "sizes.9",
                    "--combobox-input-padding-x": "spacing.2.5",
                    "--combobox-indicator-size": "sizes.4"
                },
                input: {
                    textStyle: "sm"
                },
                content: {
                    "--combobox-item-padding-x": "spacing.2",
                    "--combobox-item-padding-y": "spacing.1.5",
                    "--combobox-indicator-size": "sizes.4",
                    p: "1",
                    textStyle: "sm"
                },
                trigger: {
                    textStyle: "sm",
                    gap: "1"
                }
            },
            md: {
                root: {
                    "--combobox-input-height": "sizes.10",
                    "--combobox-input-padding-x": "spacing.3",
                    "--combobox-indicator-size": "sizes.4"
                },
                input: {
                    textStyle: "sm"
                },
                content: {
                    "--combobox-item-padding-x": "spacing.2",
                    "--combobox-item-padding-y": "spacing.1.5",
                    "--combobox-indicator-size": "sizes.4",
                    p: "1",
                    textStyle: "sm"
                },
                itemIndicator: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                },
                trigger: {
                    textStyle: "sm",
                    gap: "2"
                }
            },
            lg: {
                root: {
                    "--combobox-input-height": "sizes.12",
                    "--combobox-input-padding-x": "spacing.4",
                    "--combobox-indicator-size": "sizes.5"
                },
                input: {
                    textStyle: "md"
                },
                content: {
                    "--combobox-item-padding-y": "spacing.2",
                    "--combobox-item-padding-x": "spacing.3",
                    "--combobox-indicator-size": "sizes.5",
                    p: "1.5",
                    textStyle: "md"
                },
                trigger: {
                    textStyle: "md",
                    py: "3",
                    gap: "2"
                }
            }
        }
    },
    defaultVariants: {
        size: "md",
        variant: "outline"
    }
});




"use strict";
const $f45b6a68b0b8226d$export$8a8fa4faf7e5d248 = (0, $a2f848fc882d4d28$export$c28efc68fea5b4d6)({
    slots: (0, $210cc27d3a3db981$export$a5a7982d185494cc).keys(),
    className: "chakra-data-list",
    base: {
        itemLabel: {
            display: "flex",
            alignItems: "center",
            gap: "1"
        },
        itemValue: {
            display: "flex",
            minWidth: "0",
            flex: "1"
        }
    },
    variants: {
        orientation: {
            horizontal: {
                root: {
                    display: "flex",
                    flexDirection: "column"
                },
                item: {
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "4"
                },
                itemLabel: {
                    minWidth: "120px"
                }
            },
            vertical: {
                root: {
                    display: "flex",
                    flexDirection: "column"
                },
                item: {
                    display: "flex",
                    flexDirection: "column",
                    gap: "1"
                }
            }
        },
        size: {
            sm: {
                root: {
                    gap: "3"
                },
                item: {
                    textStyle: "xs"
                }
            },
            md: {
                root: {
                    gap: "4"
                },
                item: {
                    textStyle: "sm"
                }
            },
            lg: {
                root: {
                    gap: "5"
                },
                item: {
                    textStyle: "md"
                }
            }
        },
        variant: {
            subtle: {
                itemLabel: {
                    color: "fg.muted"
                }
            },
            bold: {
                itemLabel: {
                    fontWeight: "medium"
                },
                itemValue: {
                    color: "fg.muted"
                }
            }
        }
    },
    defaultVariants: {
        size: "md",
        orientation: "vertical",
        variant: "subtle"
    }
});




"use strict";
const $354a52b3dfcff0de$var$navTriggerStyle = (0, $a2f848fc882d4d28$export$9a6b93c1c4f92839)({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    boxSize: "var(--datepicker-nav-trigger-size)",
    borderRadius: "l2",
    color: "fg",
    focusVisibleRing: "inside",
    focusRingWidth: "2px",
    _hover: {
        bg: "colorPalette.subtle"
    },
    _focusVisible: {
        boxShadow: "0 0 0 2px var(--colors-color-palette-focus-ring)"
    },
    _disabled: {
        opacity: 0.5
    },
    _icon: {
        boxSize: "4"
    }
});
const $354a52b3dfcff0de$var$chevronDownSvg = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E")`;
const $354a52b3dfcff0de$var$selectStyle = (0, $a2f848fc882d4d28$export$9a6b93c1c4f92839)({
    height: "var(--datepicker-select-height)",
    ps: "2",
    pe: "8",
    textStyle: "sm",
    borderWidth: "1px",
    borderRadius: "l2",
    outline: "none",
    focusVisibleRing: "inside",
    appearance: "none",
    fieldSizing: "content",
    backgroundImage: $354a52b3dfcff0de$var$chevronDownSvg,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "right 0.375rem center",
    backgroundSize: "1.25em"
});
const $354a52b3dfcff0de$export$b19dc8c348722009 = (0, $a2f848fc882d4d28$export$c28efc68fea5b4d6)({
    className: "date-picker",
    slots: (0, $210cc27d3a3db981$export$317e47878665202b).keys(),
    base: {
        root: {
            display: "flex",
            flexDirection: "column",
            gap: "1.5",
            width: "full",
            "--datepicker-indicators-offset": "sizes.3",
            _disabled: {
                opacity: 0.5
            }
        },
        label: {
            textStyle: "sm",
            fontWeight: "medium"
        },
        indicatorGroup: {
            position: "absolute",
            insetEnd: "var(--datepicker-indicators-offset)",
            top: "50%",
            transform: "translateY(-50%)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "1"
        },
        control: {
            display: "flex",
            alignItems: "center",
            gap: "2",
            width: "full",
            position: "relative"
        },
        input: {
            flex: "1",
            minWidth: "0",
            height: "var(--datepicker-input-height)",
            "--input-height": "var(--datepicker-input-height)",
            px: "var(--datepicker-input-px)",
            textStyle: "sm",
            bg: "transparent",
            borderRadius: "l2",
            outline: "0",
            appearance: "none",
            color: "fg",
            "--focus-color": "colors.colorPalette.focusRing",
            "--error-color": "colors.border.error",
            _placeholder: {
                color: "fg.muted"
            },
            _invalid: {
                focusRingColor: "var(--error-color)",
                borderColor: "var(--error-color)"
            }
        },
        trigger: {
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: "6",
            height: "6",
            borderRadius: "l1",
            color: "fg.muted",
            outline: "none",
            _hover: {
                color: "fg"
            },
            focusVisibleRing: "inside",
            focusRingWidth: "2px",
            _icon: {
                boxSize: "4"
            }
        },
        content: {
            display: "flex",
            flexDirection: "column",
            gap: "3",
            p: "3",
            minW: "18rem",
            bg: "bg.panel",
            borderRadius: "l2",
            boxShadow: "lg",
            color: "fg",
            "--date-picker-z-index": "zIndex.popover",
            zIndex: "calc(var(--date-picker-z-index) + var(--layer-index, 0))",
            outline: "none",
            _open: {
                animationStyle: "scale-fade-in",
                animationDuration: "fast"
            },
            _closed: {
                animationStyle: "scale-fade-out",
                animationDuration: "faster"
            }
        },
        view: {
            display: "flex",
            flexDirection: "column",
            gap: "3"
        },
        viewControl: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "2",
            height: "var(--datepicker-nav-trigger-size)"
        },
        viewTrigger: {
            display: "inline-flex",
            flex: "1",
            alignItems: "center",
            justifyContent: "center",
            gap: "1",
            py: "1.5",
            px: "2",
            textStyle: "sm",
            fontWeight: "semibold",
            borderRadius: "l2",
            focusVisibleRing: "inside",
            focusRingWidth: "2px",
            _hover: {
                bg: "colorPalette.subtle"
            }
        },
        prevTrigger: $354a52b3dfcff0de$var$navTriggerStyle,
        nextTrigger: $354a52b3dfcff0de$var$navTriggerStyle,
        rangeText: {
            textStyle: "sm",
            fontWeight: "semibold"
        },
        table: {
            borderCollapse: "separate",
            borderSpacing: "0"
        },
        tableHeader: {
            width: "var(--table-cell-size)",
            py: "2",
            textStyle: "xs",
            fontWeight: "medium",
            color: "fg.muted",
            textAlign: "center",
            textTransform: "uppercase",
            "&[data-type='week-number']": {
                color: "fg.subtle"
            }
        },
        tableCell: {
            py: "0.5",
            "&[data-type='week-number']": {
                color: "fg.subtle"
            }
        },
        tableCellTrigger: {
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            minWidth: "var(--table-cell-size)",
            minHeight: "var(--table-cell-size)",
            textStyle: "sm",
            borderRadius: "l2",
            focusVisibleRing: "inside",
            focusRingWidth: "2px",
            focusRingOffset: "0px",
            cursor: "default",
            position: "relative",
            _hover: {
                bg: "colorPalette.subtle"
            },
            "[data-view=month] &, [data-view=year] &": {
                width: "calc(var(--table-cell-size) * 1.75)"
            },
            _today: {
                color: "colorPalette.fg",
                fontWeight: "semibold",
                textDecoration: "underline",
                textUnderlineOffset: "3px",
                textDecorationThickness: "2px"
            },
            "&[data-selected]": {
                bg: "colorPalette.solid",
                color: "colorPalette.contrast",
                _hover: {
                    bg: "colorPalette.solid"
                }
            },
            "&[data-in-range]": {
                bg: "colorPalette.subtle",
                color: "colorPalette.fg",
                borderRadius: "0",
                _hover: {
                    bg: "colorPalette.subtle"
                }
            },
            "&[data-in-range][data-selected]": {
                bg: "colorPalette.solid",
                color: "colorPalette.contrast",
                borderRadius: "0",
                _hover: {
                    bg: "colorPalette.solid"
                },
                "&[data-range-start][data-range-end]": {
                    borderRadius: "l2"
                },
                "&[data-range-start]:not([data-range-end])": {
                    borderStartRadius: "l2",
                    borderEndRadius: "0"
                },
                "&[data-range-end]:not([data-range-start])": {
                    borderEndRadius: "l2",
                    borderStartRadius: "0"
                }
            },
            _disabled: {
                opacity: 0.4
            }
        },
        monthSelect: $354a52b3dfcff0de$var$selectStyle,
        yearSelect: $354a52b3dfcff0de$var$selectStyle,
        clearTrigger: {
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: "6",
            height: "6",
            flexShrink: 0,
            textStyle: "xs",
            borderRadius: "l2",
            color: "fg.muted",
            _hover: {
                color: "fg"
            },
            focusVisibleRing: "inside",
            _icon: {
                width: "4",
                height: "4"
            }
        }
    },
    variants: {
        size: {
            xs: {
                root: {
                    "--datepicker-input-height": "sizes.8",
                    "--datepicker-input-px": "sizes.2",
                    "--datepicker-indicators-offset": "sizes.2"
                },
                view: {
                    "--table-cell-size": "sizes.8",
                    "--datepicker-nav-trigger-size": "sizes.7",
                    "--datepicker-select-height": "sizes.8"
                }
            },
            sm: {
                root: {
                    "--datepicker-input-height": "sizes.9",
                    "--datepicker-input-px": "sizes.2.5",
                    "--datepicker-indicators-offset": "sizes.2.5"
                },
                view: {
                    "--table-cell-size": "sizes.9",
                    "--datepicker-nav-trigger-size": "sizes.8",
                    "--datepicker-select-height": "sizes.9"
                }
            },
            md: {
                root: {
                    "--datepicker-input-height": "sizes.10",
                    "--datepicker-input-px": "sizes.3"
                },
                view: {
                    "--table-cell-size": "sizes.10",
                    "--datepicker-nav-trigger-size": "sizes.8",
                    "--datepicker-select-height": "sizes.10"
                }
            },
            lg: {
                root: {
                    "--datepicker-input-height": "sizes.11",
                    "--datepicker-input-px": "sizes.4"
                },
                view: {
                    "--table-cell-size": "sizes.10",
                    "--datepicker-nav-trigger-size": "sizes.9",
                    "--datepicker-select-height": "sizes.10"
                }
            },
            xl: {
                root: {
                    "--datepicker-input-height": "sizes.12",
                    "--datepicker-input-px": "sizes.4.5"
                },
                view: {
                    "--table-cell-size": "sizes.10",
                    "--datepicker-nav-trigger-size": "sizes.9",
                    "--datepicker-select-height": "sizes.10"
                }
            }
        },
        hideOutsideDays: {
            true: {
                tableCellTrigger: {
                    "&[data-outside-range]": {
                        visibility: "hidden"
                    }
                }
            }
        },
        variant: {
            outline: {
                input: {
                    bg: "transparent",
                    borderWidth: "1px",
                    borderColor: "border",
                    focusVisibleRing: "inside",
                    focusRingColor: "var(--focus-color)"
                }
            },
            subtle: {
                input: {
                    borderWidth: "1px",
                    borderColor: "transparent",
                    bg: "bg.muted",
                    focusVisibleRing: "inside",
                    focusRingColor: "var(--focus-color)"
                }
            },
            flushed: {
                input: {
                    bg: "transparent",
                    borderBottomWidth: "1px",
                    borderBottomColor: "border",
                    borderRadius: "0",
                    px: "0",
                    _focusVisible: {
                        borderColor: "var(--focus-color)",
                        boxShadow: "0px 1px 0px 0px var(--focus-color)",
                        _invalid: {
                            borderColor: "var(--error-color)",
                            boxShadow: "0px 1px 0px 0px var(--error-color)"
                        }
                    }
                },
                indicatorGroup: {
                    insetEnd: "0"
                }
            }
        }
    },
    defaultVariants: {
        size: "md",
        variant: "outline"
    }
});




"use strict";
const $268dcb2fd1153345$export$ffb2f7e6a3d6561c = (0, $a2f848fc882d4d28$export$c28efc68fea5b4d6)({
    slots: (0, $210cc27d3a3db981$export$c438f40c25a9407b).keys(),
    className: "chakra-dialog",
    base: {
        backdrop: {
            bg: "blackAlpha.500",
            pos: "fixed",
            left: 0,
            top: 0,
            w: "100dvw",
            h: "100dvh",
            "--dialog-z-index": "zIndex.popover",
            zIndex: "calc(var(--dialog-z-index) + var(--layer-index, 0) - 1)",
            _open: {
                animationName: "fade-in",
                animationDuration: "slow"
            },
            _closed: {
                animationName: "fade-out",
                animationDuration: "moderate"
            }
        },
        positioner: {
            display: "flex",
            width: "100dvw",
            height: "100dvh",
            position: "fixed",
            left: 0,
            top: 0,
            "--dialog-z-index": "zIndex.popover",
            zIndex: "calc(var(--dialog-z-index) + var(--layer-index, 0))",
            justifyContent: "center",
            overscrollBehaviorY: "none"
        },
        content: {
            display: "flex",
            flexDirection: "column",
            position: "relative",
            width: "100%",
            outline: 0,
            borderRadius: "l3",
            textStyle: "sm",
            my: "var(--dialog-margin, var(--dialog-base-margin))",
            "--dialog-z-index": "zIndex.popover",
            zIndex: "calc(var(--dialog-z-index) + var(--layer-index, 0))",
            bg: "bg.panel",
            boxShadow: "lg",
            _open: {
                animationDuration: "moderate"
            },
            _closed: {
                animationDuration: "faster"
            }
        },
        header: {
            display: "flex",
            gap: "2",
            flex: 0,
            px: "6",
            pt: "6",
            pb: "4"
        },
        body: {
            flex: "1",
            px: "6",
            pt: "2",
            pb: "6"
        },
        footer: {
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            gap: "3",
            px: "6",
            pt: "2",
            pb: "4"
        },
        title: {
            textStyle: "lg",
            fontWeight: "semibold"
        },
        description: {
            color: "fg.muted"
        },
        closeTrigger: {
            pos: "absolute",
            top: "2",
            insetEnd: "2"
        }
    },
    variants: {
        placement: {
            center: {
                positioner: {
                    alignItems: "center"
                },
                content: {
                    "--dialog-base-margin": "auto",
                    mx: "auto"
                }
            },
            top: {
                positioner: {
                    alignItems: "flex-start"
                },
                content: {
                    "--dialog-base-margin": "spacing.16",
                    mx: "auto"
                }
            },
            bottom: {
                positioner: {
                    alignItems: "flex-end"
                },
                content: {
                    "--dialog-base-margin": "spacing.16",
                    mx: "auto"
                }
            }
        },
        scrollBehavior: {
            inside: {
                positioner: {
                    overflow: "hidden"
                },
                content: {
                    maxH: "calc(100% - 7.5rem)"
                },
                body: {
                    overflow: "auto"
                }
            },
            outside: {
                positioner: {
                    overflow: "auto",
                    pointerEvents: "auto"
                }
            }
        },
        size: {
            xs: {
                content: {
                    maxW: "sm"
                }
            },
            sm: {
                content: {
                    maxW: "md"
                }
            },
            md: {
                content: {
                    maxW: "lg"
                }
            },
            lg: {
                content: {
                    maxW: "2xl"
                }
            },
            xl: {
                content: {
                    maxW: "4xl"
                }
            },
            cover: {
                positioner: {
                    padding: "10"
                },
                content: {
                    width: "100%",
                    height: "100%",
                    "--dialog-margin": "0"
                }
            },
            full: {
                content: {
                    maxW: "100dvw",
                    minH: "100dvh",
                    "--dialog-margin": "0",
                    borderRadius: "0"
                }
            }
        },
        motionPreset: {
            scale: {
                content: {
                    _open: {
                        animationName: "scale-in, fade-in"
                    },
                    _closed: {
                        animationName: "scale-out, fade-out"
                    }
                }
            },
            "slide-in-bottom": {
                content: {
                    _open: {
                        animationName: "slide-from-bottom, fade-in"
                    },
                    _closed: {
                        animationName: "slide-to-bottom, fade-out"
                    }
                }
            },
            "slide-in-top": {
                content: {
                    _open: {
                        animationName: "slide-from-top, fade-in"
                    },
                    _closed: {
                        animationName: "slide-to-top, fade-out"
                    }
                }
            },
            "slide-in-left": {
                content: {
                    _open: {
                        animationName: "slide-from-left, fade-in"
                    },
                    _closed: {
                        animationName: "slide-to-left, fade-out"
                    }
                }
            },
            "slide-in-right": {
                content: {
                    _open: {
                        animationName: "slide-from-right, fade-in"
                    },
                    _closed: {
                        animationName: "slide-to-right, fade-out"
                    }
                }
            },
            none: {}
        }
    },
    defaultVariants: {
        size: "md",
        scrollBehavior: "outside",
        placement: "top",
        motionPreset: "scale"
    }
});




"use strict";
const $36e918d5a1a24d4f$export$da2da8d2e5cdf76b = (0, $a2f848fc882d4d28$export$c28efc68fea5b4d6)({
    slots: (0, $210cc27d3a3db981$export$d3f4aaa4b0f2907a).keys(),
    className: "chakra-drawer",
    base: {
        backdrop: {
            bg: "blackAlpha.500",
            pos: "fixed",
            insetInlineStart: 0,
            top: 0,
            w: "100vw",
            h: "100dvh",
            "--drawer-z-index": "zIndex.popover",
            zIndex: "calc(var(--drawer-z-index) + var(--layer-index, 0) - 1)",
            _open: {
                animationName: "fade-in",
                animationDuration: "slow"
            },
            _closed: {
                animationName: "fade-out",
                animationDuration: "moderate"
            }
        },
        positioner: {
            display: "flex",
            width: "100vw",
            height: "100dvh",
            position: "fixed",
            insetInlineStart: 0,
            top: 0,
            "--drawer-z-index": "zIndex.popover",
            zIndex: "calc(var(--drawer-z-index) + var(--layer-index, 0))",
            overscrollBehaviorY: "none"
        },
        content: {
            display: "flex",
            flexDirection: "column",
            position: "relative",
            width: "100%",
            outline: 0,
            "--drawer-z-index": "zIndex.popover",
            zIndex: "calc(var(--drawer-z-index) + var(--layer-index, 0))",
            textStyle: "sm",
            maxH: "100dvh",
            color: "inherit",
            bg: "bg.panel",
            boxShadow: "lg",
            _open: {
                animationDuration: "slowest",
                animationTimingFunction: "ease-in-smooth"
            },
            _closed: {
                animationDuration: "slower",
                animationTimingFunction: "ease-in-smooth"
            }
        },
        header: {
            display: "flex",
            alignItems: "center",
            gap: "2",
            flex: 0,
            px: "6",
            pt: "6",
            pb: "4"
        },
        body: {
            px: "6",
            py: "2",
            flex: "1",
            overflow: "auto"
        },
        footer: {
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            gap: "3",
            px: "6",
            pt: "2",
            pb: "4"
        },
        title: {
            flex: "1",
            textStyle: "lg",
            fontWeight: "semibold"
        },
        description: {
            color: "fg.muted"
        },
        closeTrigger: {
            pos: "absolute",
            top: "3",
            insetEnd: "2"
        }
    },
    variants: {
        size: {
            xs: {
                content: {
                    maxW: "xs"
                }
            },
            sm: {
                content: {
                    maxW: "md"
                }
            },
            md: {
                content: {
                    maxW: "lg"
                }
            },
            lg: {
                content: {
                    maxW: "2xl"
                }
            },
            xl: {
                content: {
                    maxW: "4xl"
                }
            },
            full: {
                content: {
                    maxW: "100vw",
                    h: "100dvh"
                }
            }
        },
        placement: {
            start: {
                positioner: {
                    justifyContent: "flex-start",
                    alignItems: "stretch"
                },
                content: {
                    _open: {
                        animationName: {
                            base: "slide-from-left-full, fade-in",
                            _rtl: "slide-from-right-full, fade-in"
                        }
                    },
                    _closed: {
                        animationName: {
                            base: "slide-to-left-full, fade-out",
                            _rtl: "slide-to-right-full, fade-out"
                        }
                    }
                }
            },
            end: {
                positioner: {
                    justifyContent: "flex-end",
                    alignItems: "stretch"
                },
                content: {
                    _open: {
                        animationName: {
                            base: "slide-from-right-full, fade-in",
                            _rtl: "slide-from-left-full, fade-in"
                        }
                    },
                    _closed: {
                        animationName: {
                            base: "slide-to-right-full, fade-out",
                            _rtl: "slide-to-left-full, fade-out"
                        }
                    }
                }
            },
            top: {
                positioner: {
                    justifyContent: "stretch",
                    alignItems: "flex-start"
                },
                content: {
                    maxW: "100%",
                    _open: {
                        animationName: "slide-from-top-full, fade-in"
                    },
                    _closed: {
                        animationName: "slide-to-top-full, fade-out"
                    }
                }
            },
            bottom: {
                positioner: {
                    justifyContent: "stretch",
                    alignItems: "flex-end"
                },
                content: {
                    maxW: "100%",
                    _open: {
                        animationName: "slide-from-bottom-full, fade-in"
                    },
                    _closed: {
                        animationName: "slide-to-bottom-full, fade-out"
                    }
                }
            }
        },
        contained: {
            true: {
                positioner: {
                    padding: "4"
                },
                content: {
                    borderRadius: "l3"
                }
            }
        }
    },
    defaultVariants: {
        size: "xs",
        placement: "end"
    }
});




"use strict";
const $1c43ccd7d5b19018$var$sharedStyles = (0, $a2f848fc882d4d28$export$9a6b93c1c4f92839)({
    fontSize: "inherit",
    fontWeight: "inherit",
    textAlign: "inherit",
    bg: "transparent",
    borderRadius: "l2"
});
const $1c43ccd7d5b19018$export$e1e8b391e6213091 = (0, $a2f848fc882d4d28$export$c28efc68fea5b4d6)({
    slots: (0, $210cc27d3a3db981$export$2813c9511eeab082).keys(),
    className: "chakra-editable",
    base: {
        root: {
            display: "inline-flex",
            alignItems: "center",
            position: "relative",
            gap: "1.5",
            width: "full"
        },
        preview: {
            ...$1c43ccd7d5b19018$var$sharedStyles,
            py: "1",
            px: "1",
            display: "inline-flex",
            alignItems: "center",
            transitionProperty: "common",
            transitionDuration: "moderate",
            cursor: "text",
            _hover: {
                bg: "bg.muted"
            },
            _disabled: {
                userSelect: "none"
            }
        },
        input: {
            ...$1c43ccd7d5b19018$var$sharedStyles,
            outline: "0",
            py: "1",
            px: "1",
            transitionProperty: "common",
            transitionDuration: "normal",
            width: "full",
            focusVisibleRing: "inside",
            focusRingWidth: "2px",
            _placeholder: {
                opacity: 0.6
            }
        },
        control: {
            display: "inline-flex",
            alignItems: "center",
            gap: "1.5"
        }
    },
    variants: {
        size: {
            sm: {
                root: {
                    textStyle: "sm"
                },
                preview: {
                    minH: "8"
                },
                input: {
                    minH: "8"
                }
            },
            md: {
                root: {
                    textStyle: "sm"
                },
                preview: {
                    minH: "9"
                },
                input: {
                    minH: "9"
                }
            },
            lg: {
                root: {
                    textStyle: "md"
                },
                preview: {
                    minH: "10"
                },
                input: {
                    minH: "10"
                }
            }
        }
    },
    defaultVariants: {
        size: "md"
    }
});




"use strict";
const $b6ae7c1f5ab20dd5$export$93a945b6c6bfa0fe = (0, $a2f848fc882d4d28$export$c28efc68fea5b4d6)({
    slots: (0, $210cc27d3a3db981$export$f18c66b472536888).keys(),
    className: "chakra-empty-state",
    base: {
        root: {
            width: "full"
        },
        content: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center"
        },
        indicator: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "fg.subtle",
            _icon: {
                boxSize: "1em"
            }
        },
        title: {
            fontWeight: "semibold"
        },
        description: {
            textStyle: "sm",
            color: "fg.muted"
        }
    },
    variants: {
        size: {
            sm: {
                root: {
                    px: "4",
                    py: "6"
                },
                title: {
                    textStyle: "md"
                },
                content: {
                    gap: "4"
                },
                indicator: {
                    textStyle: "2xl"
                }
            },
            md: {
                root: {
                    px: "8",
                    py: "12"
                },
                title: {
                    textStyle: "lg"
                },
                content: {
                    gap: "6"
                },
                indicator: {
                    textStyle: "4xl"
                }
            },
            lg: {
                root: {
                    px: "12",
                    py: "16"
                },
                title: {
                    textStyle: "xl"
                },
                content: {
                    gap: "8"
                },
                indicator: {
                    textStyle: "6xl"
                }
            }
        }
    },
    defaultVariants: {
        size: "md"
    }
});




"use strict";
const $f8c1bd08ff93e948$export$9044d569b4a94288 = (0, $a2f848fc882d4d28$export$c28efc68fea5b4d6)({
    className: "chakra-field",
    slots: (0, $210cc27d3a3db981$export$a43048b0d2808e4e).keys(),
    base: {
        requiredIndicator: {
            color: "fg.error",
            lineHeight: "1"
        },
        root: {
            display: "flex",
            width: "100%",
            position: "relative",
            gap: "1.5"
        },
        label: {
            display: "flex",
            alignItems: "center",
            textAlign: "start",
            textStyle: "sm",
            fontWeight: "medium",
            gap: "1",
            userSelect: "none",
            _disabled: {
                opacity: "0.5"
            }
        },
        errorText: {
            display: "inline-flex",
            alignItems: "center",
            fontWeight: "medium",
            gap: "1",
            color: "fg.error",
            textStyle: "xs"
        },
        helperText: {
            color: "fg.muted",
            textStyle: "xs"
        }
    },
    variants: {
        orientation: {
            vertical: {
                root: {
                    flexDirection: "column",
                    alignItems: "flex-start"
                }
            },
            horizontal: {
                root: {
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between"
                },
                label: {
                    flex: "0 0 var(--field-label-width, 80px)"
                }
            }
        }
    },
    defaultVariants: {
        orientation: "vertical"
    }
});




"use strict";
const $177deaaba632c318$export$31b1fb468e8ba73 = (0, $a2f848fc882d4d28$export$c28efc68fea5b4d6)({
    className: "fieldset",
    slots: (0, $210cc27d3a3db981$export$3b2066f768dd72d0).keys(),
    base: {
        root: {
            display: "flex",
            flexDirection: "column",
            width: "full"
        },
        content: {
            display: "flex",
            flexDirection: "column",
            width: "full"
        },
        legend: {
            color: "fg",
            fontWeight: "medium",
            _disabled: {
                opacity: "0.5"
            }
        },
        helperText: {
            color: "fg.muted",
            textStyle: "sm"
        },
        errorText: {
            display: "inline-flex",
            alignItems: "center",
            color: "fg.error",
            gap: "2",
            fontWeight: "medium",
            textStyle: "sm"
        }
    },
    variants: {
        size: {
            sm: {
                root: {
                    spaceY: "2"
                },
                content: {
                    gap: "1.5"
                },
                legend: {
                    textStyle: "sm"
                }
            },
            md: {
                root: {
                    spaceY: "4"
                },
                content: {
                    gap: "4"
                },
                legend: {
                    textStyle: "sm"
                }
            },
            lg: {
                root: {
                    spaceY: "6"
                },
                content: {
                    gap: "4"
                },
                legend: {
                    textStyle: "md"
                }
            }
        }
    },
    defaultVariants: {
        size: "md"
    }
});




"use strict";
const $abd71573a2368057$export$bd84411a7156c13a = (0, $a2f848fc882d4d28$export$c28efc68fea5b4d6)({
    className: "chakra-file-upload",
    slots: (0, $210cc27d3a3db981$export$b589745ee24985d).keys(),
    base: {
        root: {
            display: "flex",
            flexDirection: "column",
            gap: "4",
            width: "100%",
            alignItems: "flex-start"
        },
        label: {
            fontWeight: "medium",
            textStyle: "sm"
        },
        dropzone: {
            background: "bg",
            borderRadius: "l3",
            borderWidth: "2px",
            borderStyle: "dashed",
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            gap: "4",
            justifyContent: "center",
            minHeight: "2xs",
            px: "3",
            py: "2",
            transition: "backgrounds",
            focusVisibleRing: "outside",
            _hover: {
                bg: "bg.subtle"
            },
            _dragging: {
                bg: "colorPalette.subtle",
                borderStyle: "solid",
                borderColor: "colorPalette.solid"
            }
        },
        dropzoneContent: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            gap: "1",
            textStyle: "sm"
        },
        item: {
            pos: "relative",
            textStyle: "sm",
            animationName: "fade-in",
            animationDuration: "moderate",
            background: "bg",
            borderRadius: "l2",
            borderWidth: "1px",
            width: "100%",
            display: "flex",
            alignItems: "center",
            gap: "3",
            p: "4"
        },
        itemGroup: {
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: "3",
            _empty: {
                display: "none"
            }
        },
        itemName: {
            color: "fg",
            fontWeight: "medium",
            lineClamp: "1"
        },
        itemContent: {
            display: "flex",
            flexDirection: "column",
            gap: "0.5",
            flex: "1"
        },
        itemSizeText: {
            color: "fg.muted",
            textStyle: "xs"
        },
        itemDeleteTrigger: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            alignSelf: "flex-start",
            boxSize: "5",
            p: "2px",
            color: "fg.muted",
            cursor: "button"
        },
        itemPreview: {
            color: "fg.muted",
            _icon: {
                boxSize: "4.5"
            }
        }
    },
    defaultVariants: {}
});



// src/hover-card.anatomy.ts

var $680e87170c2fa878$export$477202748c7242bf = (0, $07b08c6ef332e8db$export$197e6e8d4b33fd6c)("hoverCard").parts("arrow", "arrowTip", "trigger", "positioner", "content");
var $680e87170c2fa878$export$6e2410c1d27f06e7 = $680e87170c2fa878$export$477202748c7242bf.build();


"use strict";
const $bc39dc5a3ebcabba$export$2d0f90af978875ab = (0, $a2f848fc882d4d28$export$c28efc68fea5b4d6)({
    className: "chakra-hover-card",
    slots: (0, $680e87170c2fa878$export$477202748c7242bf).keys(),
    base: {
        content: {
            position: "relative",
            display: "flex",
            flexDirection: "column",
            textStyle: "sm",
            "--hovercard-bg": "colors.bg.panel",
            bg: "var(--hovercard-bg)",
            boxShadow: "lg",
            maxWidth: "80",
            borderRadius: "l3",
            "--hover-card-z-index": "zIndex.popover",
            zIndex: "calc(var(--hover-card-z-index) + var(--layer-index, 0))",
            transformOrigin: "var(--transform-origin)",
            outline: "0",
            _open: {
                animationStyle: "slide-fade-in",
                animationDuration: "fast"
            },
            _closed: {
                animationStyle: "slide-fade-out",
                animationDuration: "faster"
            }
        },
        arrow: {
            "--arrow-size": "sizes.3",
            "--arrow-background": "var(--hovercard-bg)"
        },
        arrowTip: {
            borderTopWidth: "0.5px",
            borderLeftWidth: "0.5px"
        }
    },
    variants: {
        size: {
            xs: {
                content: {
                    padding: "3"
                }
            },
            sm: {
                content: {
                    padding: "4"
                }
            },
            md: {
                content: {
                    padding: "5"
                }
            },
            lg: {
                content: {
                    padding: "6"
                }
            }
        }
    },
    defaultVariants: {
        size: "md"
    }
});




"use strict";
const $05c07103cf04ca2b$export$d6effa609ff73c80 = (0, $a2f848fc882d4d28$export$c28efc68fea5b4d6)({
    className: "chakra-list",
    slots: (0, $210cc27d3a3db981$export$12b3a655a94374ed).keys(),
    base: {
        root: {
            display: "flex",
            flexDirection: "column",
            gap: "var(--list-gap)",
            "& :where(ul, ol)": {
                marginTop: "var(--list-gap)"
            }
        },
        item: {
            whiteSpace: "normal",
            display: "list-item"
        },
        indicator: {
            marginEnd: "2",
            minHeight: "1lh",
            flexShrink: 0,
            display: "inline-block",
            verticalAlign: "middle"
        }
    },
    variants: {
        variant: {
            marker: {
                root: {
                    listStyle: "revert"
                },
                item: {
                    _marker: {
                        color: "fg.subtle"
                    }
                }
            },
            plain: {
                item: {
                    alignItems: "flex-start",
                    display: "inline-flex"
                }
            }
        },
        align: {
            center: {
                item: {
                    alignItems: "center"
                }
            },
            start: {
                item: {
                    alignItems: "flex-start"
                }
            },
            end: {
                item: {
                    alignItems: "flex-end"
                }
            }
        }
    },
    defaultVariants: {
        variant: "marker"
    }
});




"use strict";
const $d0386d0c989bee3f$export$380919383f821ef7 = (0, $a2f848fc882d4d28$export$c28efc68fea5b4d6)({
    className: "chakra-listbox",
    slots: (0, $210cc27d3a3db981$export$a647f00ed9c3a914).keys(),
    base: {
        root: {
            display: "flex",
            flexDirection: "column",
            gap: "1.5",
            width: "full"
        },
        content: {
            display: "flex",
            maxH: "96",
            p: "1",
            gap: "1",
            textStyle: "sm",
            outline: "none",
            scrollPadding: "1",
            _horizontal: {
                flexDirection: "row",
                overflowX: "auto"
            },
            _vertical: {
                flexDirection: "column",
                overflowY: "auto"
            },
            "--listbox-item-padding-x": "spacing.2",
            "--listbox-item-padding-y": "spacing.1.5"
        },
        item: {
            position: "relative",
            userSelect: "none",
            display: "flex",
            alignItems: "center",
            gap: "2",
            cursor: "pointer",
            justifyContent: "space-between",
            flex: "1",
            textAlign: "start",
            borderRadius: "l1",
            py: "var(--listbox-item-padding-y)",
            px: "var(--listbox-item-padding-x)",
            _highlighted: {
                outline: "2px solid",
                outlineColor: "border.emphasized"
            },
            _disabled: {
                pointerEvents: "none",
                opacity: "0.5"
            }
        },
        empty: {
            py: "var(--listbox-item-padding-y)",
            px: "var(--listbox-item-padding-x)"
        },
        itemText: {
            flex: "1"
        },
        itemGroup: {
            mt: "1.5",
            _first: {
                mt: "0"
            }
        },
        itemGroupLabel: {
            py: "1.5",
            px: "2",
            fontWeight: "medium"
        },
        label: {
            fontWeight: "medium",
            userSelect: "none",
            textStyle: "sm",
            _disabled: {
                layerStyle: "disabled"
            }
        },
        valueText: {
            lineClamp: "1",
            maxW: "80%"
        },
        itemIndicator: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            _icon: {
                boxSize: "4"
            }
        }
    },
    variants: {
        variant: {
            subtle: {
                content: {
                    bg: "bg.panel",
                    borderWidth: "1px",
                    borderRadius: "l2"
                },
                item: {
                    _hover: {
                        bg: "bg.emphasized/60"
                    },
                    _selected: {
                        bg: "bg.muted"
                    }
                }
            },
            solid: {
                content: {
                    bg: "bg.panel",
                    borderWidth: "1px",
                    borderRadius: "l2"
                },
                item: {
                    _selected: {
                        bg: "colorPalette.solid",
                        color: "colorPalette.contrast"
                    }
                }
            },
            plain: {}
        }
    },
    defaultVariants: {
        variant: "subtle"
    }
});



// src/marquee.anatomy.ts

var $895805cb007fcf0e$export$477202748c7242bf = (0, $07b08c6ef332e8db$export$197e6e8d4b33fd6c)("marquee").parts("root", "viewport", "content", "edge", "item");
var $895805cb007fcf0e$export$6e2410c1d27f06e7 = $895805cb007fcf0e$export$477202748c7242bf.build();


"use strict";
const $c801133429c9449e$export$1c1ce343236229a4 = (0, $a2f848fc882d4d28$export$c28efc68fea5b4d6)({
    className: "chakra-marquee",
    slots: (0, $895805cb007fcf0e$export$477202748c7242bf).keys(),
    base: {
        root: {
            position: "relative",
            width: "100%",
            "--marquee-edge-color": "colors.bg",
            "--marquee-edge-size": "20%",
            "&[data-paused]": {
                animationPlayState: "paused !important",
                "& *": {
                    animationPlayState: "paused !important"
                }
            }
        },
        viewport: {
            overflow: "hidden",
            display: "flex",
            width: "100%",
            height: "100%"
        },
        content: {
            display: "flex",
            minWidth: "max-content",
            animationTimingFunction: "linear",
            animationFillMode: "forwards",
            animationDuration: "var(--marquee-duration)",
            animationDelay: "var(--marquee-delay)",
            animationIterationCount: "var(--marquee-loop-count)",
            _motionReduce: {
                animation: "none !important"
            },
            "&[data-side='start'], &[data-side='end']": {
                animationName: "marqueeX"
            },
            "&[data-side='top'], &[data-side='bottom']": {
                animationName: "marqueeY"
            },
            "&[data-reverse]": {
                animationDirection: "reverse"
            },
            "&[data-orientation='horizontal']": {
                flexDirection: "row"
            },
            "&[data-orientation='vertical']": {
                flexDirection: "column"
            }
        },
        edge: {
            position: "absolute",
            zIndex: "1",
            pointerEvents: "none",
            "&[data-side='start']": {
                width: "var(--marquee-edge-size)",
                insetY: "0",
                insetInlineStart: "0",
                background: "linear-gradient(to right, var(--marquee-edge-color, white), transparent)",
                _rtl: {
                    background: "linear-gradient(to left, var(--marquee-edge-color, white), transparent)"
                }
            },
            "&[data-side='end']": {
                width: "var(--marquee-edge-size)",
                insetY: "0",
                insetInlineEnd: "0",
                background: "linear-gradient(to left, var(--marquee-edge-color, white), transparent)",
                _rtl: {
                    background: "linear-gradient(to right, var(--marquee-edge-color, white), transparent)"
                }
            },
            "&[data-side='top']": {
                height: "var(--marquee-edge-size)",
                insetX: "0",
                top: "0",
                background: "linear-gradient(to bottom, var(--marquee-edge-color, white), transparent)"
            },
            "&[data-side='bottom']": {
                height: "var(--marquee-edge-size)",
                insetX: "0",
                bottom: "0",
                background: "linear-gradient(to top, var(--marquee-edge-color, white), transparent)"
            }
        }
    }
});




"use strict";
const $2791cad8441971e4$export$51b7bcd215c1d4ed = (0, $a2f848fc882d4d28$export$c28efc68fea5b4d6)({
    className: "chakra-menu",
    slots: (0, $210cc27d3a3db981$export$e251092a5dcb1329).keys(),
    base: {
        content: {
            outline: 0,
            "--menu-bg": "colors.bg.panel",
            bg: "var(--menu-bg)",
            boxShadow: "lg",
            color: "fg",
            maxHeight: "var(--available-height)",
            "--menu-z-index": "zIndex.popover",
            zIndex: "calc(var(--menu-z-index) + var(--layer-index, 0))",
            borderRadius: "l2",
            overflow: "hidden",
            overflowY: "auto",
            _open: {
                animationStyle: "slide-fade-in",
                animationDuration: "fast"
            },
            _closed: {
                animationStyle: "slide-fade-out",
                animationDuration: "faster"
            }
        },
        item: {
            textDecoration: "none",
            color: "fg",
            userSelect: "none",
            borderRadius: "l1",
            width: "100%",
            display: "flex",
            cursor: "menuitem",
            alignItems: "center",
            textAlign: "start",
            position: "relative",
            flex: "0 0 auto",
            outline: 0,
            _disabled: {
                layerStyle: "disabled"
            },
            "&[data-type]": {
                ps: "8"
            }
        },
        itemText: {
            flex: "1"
        },
        itemIndicator: {
            position: "absolute",
            insetStart: "2",
            transform: "translateY(-50%)",
            top: "50%"
        },
        itemGroupLabel: {
            px: "2",
            py: "1.5",
            fontWeight: "semibold",
            textStyle: "sm"
        },
        indicator: {
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: "0"
        },
        itemCommand: {
            opacity: "0.6",
            textStyle: "xs",
            ms: "auto",
            ps: "4",
            letterSpacing: "widest",
            fontFamily: "inherit"
        },
        separator: {
            height: "1px",
            bg: "bg.muted",
            my: "1",
            mx: "-1"
        },
        arrow: {
            "--arrow-size": "sizes.3",
            "--arrow-background": "var(--menu-bg)"
        },
        arrowTip: {
            borderTopWidth: "1px",
            borderLeftWidth: "1px"
        }
    },
    variants: {
        variant: {
            subtle: {
                item: {
                    _highlighted: {
                        bg: "bg.emphasized/60"
                    }
                }
            },
            solid: {
                item: {
                    _highlighted: {
                        bg: "colorPalette.solid",
                        color: "colorPalette.contrast"
                    }
                }
            }
        },
        size: {
            sm: {
                content: {
                    minW: "8rem",
                    padding: "1",
                    scrollPadding: "1"
                },
                item: {
                    gap: "1",
                    textStyle: "xs",
                    py: "1",
                    px: "1.5"
                }
            },
            md: {
                content: {
                    minW: "8rem",
                    padding: "1.5",
                    scrollPadding: "1.5"
                },
                item: {
                    gap: "2",
                    textStyle: "sm",
                    py: "1.5",
                    px: "2"
                }
            }
        }
    },
    defaultVariants: {
        size: "md",
        variant: "subtle"
    }
});






"use strict";
const $8f19926842c66112$export$a17a1e7a6654f699 = (0, $a2f848fc882d4d28$export$c28efc68fea5b4d6)({
    className: "chakra-select",
    slots: (0, $210cc27d3a3db981$export$17993f0be9538b5a).keys(),
    base: {
        root: {
            display: "flex",
            flexDirection: "column",
            gap: "1.5",
            width: "full"
        },
        trigger: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "full",
            minH: "var(--select-trigger-height)",
            "--input-height": "var(--select-trigger-height)",
            px: "var(--select-trigger-padding-x)",
            borderRadius: "l2",
            userSelect: "none",
            textAlign: "start",
            focusVisibleRing: "inside",
            _placeholderShown: {
                color: "fg.muted/80"
            },
            _disabled: {
                layerStyle: "disabled"
            },
            _invalid: {
                borderColor: "border.error"
            }
        },
        indicatorGroup: {
            display: "flex",
            alignItems: "center",
            gap: "1",
            pos: "absolute",
            insetEnd: "0",
            top: "0",
            bottom: "0",
            px: "var(--select-trigger-padding-x)",
            pointerEvents: "none"
        },
        indicator: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: {
                base: "fg.muted",
                _disabled: "fg.subtle",
                _invalid: "fg.error"
            }
        },
        content: {
            background: "bg.panel",
            display: "flex",
            flexDirection: "column",
            "--select-z-index": "zIndex.popover",
            zIndex: "calc(var(--select-z-index) + var(--layer-index, 0))",
            borderRadius: "l2",
            outline: 0,
            maxH: "96",
            overflowY: "auto",
            boxShadow: "md",
            _open: {
                animationStyle: "slide-fade-in",
                animationDuration: "fast"
            },
            _closed: {
                animationStyle: "slide-fade-out",
                animationDuration: "fastest"
            }
        },
        item: {
            position: "relative",
            userSelect: "none",
            display: "flex",
            alignItems: "center",
            gap: "2",
            cursor: "option",
            justifyContent: "space-between",
            flex: "1",
            textAlign: "start",
            borderRadius: "l1",
            _highlighted: {
                bg: "bg.emphasized/60"
            },
            _disabled: {
                pointerEvents: "none",
                opacity: "0.5"
            },
            _icon: {
                width: "4",
                height: "4"
            }
        },
        control: {
            pos: "relative"
        },
        itemText: {
            flex: "1"
        },
        itemGroup: {
            _first: {
                mt: "0"
            }
        },
        itemGroupLabel: {
            py: "1",
            fontWeight: "medium"
        },
        label: {
            fontWeight: "medium",
            userSelect: "none",
            textStyle: "sm",
            _disabled: {
                layerStyle: "disabled"
            }
        },
        valueText: {
            lineClamp: "1",
            maxW: "80%"
        },
        clearTrigger: {
            color: "fg.muted",
            pointerEvents: "auto",
            focusVisibleRing: "inside",
            focusRingWidth: "2px",
            rounded: "l1"
        }
    },
    variants: {
        variant: {
            outline: {
                trigger: {
                    bg: "transparent",
                    borderWidth: "1px",
                    borderColor: "border",
                    _expanded: {
                        borderColor: "border.emphasized"
                    }
                }
            },
            subtle: {
                trigger: {
                    borderWidth: "1px",
                    borderColor: "transparent",
                    bg: "bg.muted"
                }
            },
            ghost: {
                trigger: {
                    bg: "transparent",
                    _expanded: {
                        bg: "bg.muted"
                    }
                }
            }
        },
        size: {
            xs: {
                root: {
                    "--select-trigger-height": "sizes.8",
                    "--select-trigger-padding-x": "spacing.2"
                },
                content: {
                    p: "1",
                    gap: "1",
                    textStyle: "xs"
                },
                trigger: {
                    textStyle: "xs",
                    gap: "1"
                },
                item: {
                    py: "1",
                    px: "2"
                },
                itemGroupLabel: {
                    py: "1",
                    px: "2"
                },
                indicator: {
                    _icon: {
                        width: "3.5",
                        height: "3.5"
                    }
                }
            },
            sm: {
                root: {
                    "--select-trigger-height": "sizes.9",
                    "--select-trigger-padding-x": "spacing.2.5"
                },
                content: {
                    p: "1",
                    textStyle: "sm"
                },
                trigger: {
                    textStyle: "sm",
                    gap: "1"
                },
                indicator: {
                    _icon: {
                        width: "4",
                        height: "4"
                    }
                },
                item: {
                    py: "1",
                    px: "1.5"
                },
                itemGroup: {
                    mt: "1"
                },
                itemGroupLabel: {
                    py: "1",
                    px: "1.5"
                }
            },
            md: {
                root: {
                    "--select-trigger-height": "sizes.10",
                    "--select-trigger-padding-x": "spacing.3"
                },
                content: {
                    p: "1",
                    textStyle: "sm"
                },
                itemGroup: {
                    mt: "1.5"
                },
                item: {
                    py: "1.5",
                    px: "2"
                },
                itemIndicator: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                },
                itemGroupLabel: {
                    py: "1.5",
                    px: "2"
                },
                trigger: {
                    textStyle: "sm",
                    gap: "2"
                },
                indicator: {
                    _icon: {
                        width: "4",
                        height: "4"
                    }
                }
            },
            lg: {
                root: {
                    "--select-trigger-height": "sizes.12",
                    "--select-trigger-padding-x": "spacing.4"
                },
                content: {
                    p: "1.5",
                    textStyle: "md"
                },
                itemGroup: {
                    mt: "2"
                },
                item: {
                    py: "2",
                    px: "3"
                },
                itemGroupLabel: {
                    py: "2",
                    px: "3"
                },
                trigger: {
                    textStyle: "md",
                    py: "3",
                    gap: "2"
                },
                indicator: {
                    _icon: {
                        width: "5",
                        height: "5"
                    }
                }
            }
        }
    },
    defaultVariants: {
        size: "md",
        variant: "outline"
    }
});


"use strict";
const $b3803ccb0ef3bb14$export$bd566e82fcc568be = (0, $a2f848fc882d4d28$export$c28efc68fea5b4d6)({
    className: "chakra-native-select",
    slots: (0, $210cc27d3a3db981$export$f38e0304163546fd).keys(),
    base: {
        root: {
            height: "fit-content",
            display: "flex",
            width: "100%",
            position: "relative"
        },
        field: {
            width: "100%",
            minWidth: "0",
            outline: "0",
            appearance: "none",
            borderRadius: "l2",
            "--error-color": "colors.border.error",
            "--input-height": "var(--select-field-height)",
            height: "var(--select-field-height)",
            _disabled: {
                layerStyle: "disabled"
            },
            _invalid: {
                focusRingColor: "var(--error-color)",
                borderColor: "var(--error-color)"
            },
            focusVisibleRing: "inside",
            lineHeight: "normal",
            "& > option, & > optgroup": {
                bg: "bg"
            }
        },
        indicator: {
            position: "absolute",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            pointerEvents: "none",
            top: "50%",
            transform: "translateY(-50%)",
            height: "100%",
            color: "fg.muted",
            _disabled: {
                opacity: "0.5"
            },
            _invalid: {
                color: "fg.error"
            },
            _icon: {
                width: "1em",
                height: "1em"
            }
        }
    },
    variants: {
        variant: {
            outline: {
                field: (0, $8f19926842c66112$export$a17a1e7a6654f699).variants?.variant.outline.trigger
            },
            subtle: {
                field: (0, $8f19926842c66112$export$a17a1e7a6654f699).variants?.variant.subtle.trigger
            },
            plain: {
                field: {
                    bg: "transparent",
                    color: "fg",
                    focusRingWidth: "2px"
                }
            },
            ghost: {
                field: (0, $8f19926842c66112$export$a17a1e7a6654f699).variants?.variant.ghost.trigger
            }
        },
        size: {
            xs: {
                root: {
                    "--select-field-height": "sizes.8"
                },
                field: {
                    textStyle: "xs",
                    ps: "2",
                    pe: "6"
                },
                indicator: {
                    textStyle: "sm",
                    insetEnd: "1.5"
                }
            },
            sm: {
                root: {
                    "--select-field-height": "sizes.9"
                },
                field: {
                    textStyle: "sm",
                    ps: "2.5",
                    pe: "8"
                },
                indicator: {
                    textStyle: "md",
                    insetEnd: "2"
                }
            },
            md: {
                root: {
                    "--select-field-height": "sizes.10"
                },
                field: {
                    textStyle: "sm",
                    ps: "3",
                    pe: "8"
                },
                indicator: {
                    textStyle: "lg",
                    insetEnd: "2"
                }
            },
            lg: {
                root: {
                    "--select-field-height": "sizes.11"
                },
                field: {
                    textStyle: "md",
                    ps: "4",
                    pe: "8"
                },
                indicator: {
                    textStyle: "xl",
                    insetEnd: "3"
                }
            },
            xl: {
                root: {
                    "--select-field-height": "sizes.12"
                },
                field: {
                    textStyle: "md",
                    ps: "4.5",
                    pe: "10"
                },
                indicator: {
                    textStyle: "xl",
                    insetEnd: "3"
                }
            }
        }
    },
    defaultVariants: (0, $8f19926842c66112$export$a17a1e7a6654f699).defaultVariants
});





// src/number-input.anatomy.ts

var $d189197ebf592a36$export$477202748c7242bf = (0, $07b08c6ef332e8db$export$197e6e8d4b33fd6c)("numberInput").parts("root", "label", "input", "control", "valueText", "incrementTrigger", "decrementTrigger", "scrubber");
var $d189197ebf592a36$export$6e2410c1d27f06e7 = $d189197ebf592a36$export$477202748c7242bf.build();


"use strict";
const $a302e814de7d4a66$var$triggerStyle = (0, $a2f848fc882d4d28$export$9a6b93c1c4f92839)({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flex: "1",
    userSelect: "none",
    cursor: "button",
    lineHeight: "1",
    color: "fg.muted",
    "--stepper-base-radius": "radii.l1",
    "--stepper-radius": "calc(var(--stepper-base-radius) + 1px)",
    _icon: {
        boxSize: "1em"
    },
    _disabled: {
        opacity: "0.5"
    },
    _hover: {
        bg: "bg.muted"
    },
    _active: {
        bg: "bg.emphasized"
    }
});
const $a302e814de7d4a66$export$a4772ecb6b3bbf82 = (0, $a2f848fc882d4d28$export$c28efc68fea5b4d6)({
    className: "chakra-number-input",
    slots: (0, $d189197ebf592a36$export$477202748c7242bf).keys(),
    base: {
        root: {
            position: "relative",
            zIndex: "0",
            isolation: "isolate"
        },
        input: {
            ...(0, $fd8ba95b29dad282$export$a6445e005c28dca2).base,
            verticalAlign: "top",
            pe: "calc(var(--stepper-width) + 0.5rem)"
        },
        control: {
            display: "flex",
            flexDirection: "column",
            position: "absolute",
            top: "0",
            insetEnd: "0px",
            margin: "1px",
            width: "var(--stepper-width)",
            height: "calc(100% - 2px)",
            zIndex: "1",
            borderStartWidth: "1px",
            divideY: "1px"
        },
        incrementTrigger: {
            ...$a302e814de7d4a66$var$triggerStyle,
            borderTopEndRadius: "var(--stepper-radius)"
        },
        decrementTrigger: {
            ...$a302e814de7d4a66$var$triggerStyle,
            borderBottomEndRadius: "var(--stepper-radius)"
        },
        valueText: {
            fontWeight: "medium",
            fontFeatureSettings: "pnum",
            fontVariantNumeric: "proportional-nums"
        }
    },
    variants: {
        size: {
            xs: {
                input: (0, $fd8ba95b29dad282$export$a6445e005c28dca2).variants.size.xs,
                control: {
                    fontSize: "2xs",
                    "--stepper-width": "sizes.4"
                }
            },
            sm: {
                input: (0, $fd8ba95b29dad282$export$a6445e005c28dca2).variants.size.sm,
                control: {
                    fontSize: "xs",
                    "--stepper-width": "sizes.5"
                }
            },
            md: {
                input: (0, $fd8ba95b29dad282$export$a6445e005c28dca2).variants.size.md,
                control: {
                    fontSize: "sm",
                    "--stepper-width": "sizes.6"
                }
            },
            lg: {
                input: (0, $fd8ba95b29dad282$export$a6445e005c28dca2).variants.size.lg,
                control: {
                    fontSize: "sm",
                    "--stepper-width": "sizes.6"
                }
            }
        },
        variant: (0, $9024565373fe4cd0$export$592ef47eabb05614)((0, $fd8ba95b29dad282$export$a6445e005c28dca2).variants.variant, (key, variantStyles)=>[
                key,
                {
                    input: variantStyles
                }
            ])
    },
    defaultVariants: {
        size: "md",
        variant: "outline"
    }
});





// src/pin-input.anatomy.ts

var $0d7bdf69f556a6e6$export$477202748c7242bf = (0, $07b08c6ef332e8db$export$197e6e8d4b33fd6c)("pinInput").parts("root", "label", "input", "control");
var $0d7bdf69f556a6e6$export$6e2410c1d27f06e7 = $0d7bdf69f556a6e6$export$477202748c7242bf.build();


"use strict";
const { variants: $8fa8763c131de2ac$var$variants, defaultVariants: $8fa8763c131de2ac$var$defaultVariants } = (0, $fd8ba95b29dad282$export$a6445e005c28dca2);
const $8fa8763c131de2ac$export$6ac4344d3861b231 = (0, $a2f848fc882d4d28$export$c28efc68fea5b4d6)({
    className: "chakra-pin-input",
    slots: (0, $0d7bdf69f556a6e6$export$477202748c7242bf).keys(),
    base: {
        input: {
            ...(0, $fd8ba95b29dad282$export$a6445e005c28dca2).base,
            textAlign: "center",
            width: "var(--input-height)"
        },
        control: {
            display: "inline-flex",
            gap: "2",
            isolation: "isolate"
        }
    },
    variants: {
        size: (0, $9024565373fe4cd0$export$592ef47eabb05614)($8fa8763c131de2ac$var$variants.size, (key, value)=>[
                key,
                {
                    input: {
                        ...value,
                        px: "1"
                    }
                }
            ]),
        variant: (0, $9024565373fe4cd0$export$592ef47eabb05614)($8fa8763c131de2ac$var$variants.variant, (key, value)=>[
                key,
                {
                    input: value
                }
            ]),
        attached: {
            true: {
                control: {
                    gap: "0",
                    spaceX: "-1px"
                },
                input: {
                    _notFirst: {
                        borderStartRadius: "0"
                    },
                    _notLast: {
                        borderEndRadius: "0"
                    },
                    _focusVisible: {
                        zIndex: "1"
                    }
                }
            }
        }
    },
    defaultVariants: $8fa8763c131de2ac$var$defaultVariants
});




"use strict";
const $1d6515b880a1ce95$export$d45077169de7cc48 = (0, $a2f848fc882d4d28$export$c28efc68fea5b4d6)({
    className: "chakra-popover",
    slots: (0, $210cc27d3a3db981$export$afda07d12cd4337d).keys(),
    base: {
        content: {
            position: "relative",
            display: "flex",
            flexDirection: "column",
            textStyle: "sm",
            "--popover-bg": "colors.bg.panel",
            bg: "var(--popover-bg)",
            boxShadow: "lg",
            "--popover-size": "sizes.xs",
            "--popover-mobile-size": "calc(100dvw - 1rem)",
            width: {
                base: "min(var(--popover-mobile-size), var(--popover-size))",
                sm: "var(--popover-size)"
            },
            borderRadius: "l3",
            "--popover-z-index": "zIndex.popover",
            zIndex: "calc(var(--popover-z-index) + var(--layer-index, 0))",
            outline: "0",
            transformOrigin: "var(--transform-origin)",
            maxHeight: "var(--available-height)",
            _open: {
                animationStyle: "scale-fade-in",
                animationDuration: "fast"
            },
            _closed: {
                animationStyle: "scale-fade-out",
                animationDuration: "faster"
            }
        },
        header: {
            paddingInline: "var(--popover-padding)",
            paddingTop: "var(--popover-padding)"
        },
        body: {
            padding: "var(--popover-padding)",
            flex: "1"
        },
        footer: {
            display: "flex",
            alignItems: "center",
            paddingInline: "var(--popover-padding)",
            paddingBottom: "var(--popover-padding)"
        },
        arrow: {
            "--arrow-size": "sizes.3",
            "--arrow-background": "var(--popover-bg)"
        },
        arrowTip: {
            borderTopWidth: "1px",
            borderLeftWidth: "1px"
        }
    },
    variants: {
        size: {
            xs: {
                content: {
                    "--popover-padding": "spacing.3"
                }
            },
            sm: {
                content: {
                    "--popover-padding": "spacing.4"
                }
            },
            md: {
                content: {
                    "--popover-padding": "spacing.5"
                }
            },
            lg: {
                content: {
                    "--popover-padding": "spacing.6"
                }
            }
        }
    },
    defaultVariants: {
        size: "md"
    }
});



// src/progress.anatomy.ts

var $a04d9e5b8230377c$export$477202748c7242bf = (0, $07b08c6ef332e8db$export$197e6e8d4b33fd6c)("progress").parts("root", "label", "track", "range", "valueText", "view", "circle", "circleTrack", "circleRange");
var $a04d9e5b8230377c$export$6e2410c1d27f06e7 = $a04d9e5b8230377c$export$477202748c7242bf.build();


"use strict";
const $9983ea69c64ddb91$export$9f977c65a046b227 = (0, $a2f848fc882d4d28$export$c28efc68fea5b4d6)({
    slots: (0, $a04d9e5b8230377c$export$477202748c7242bf).keys(),
    className: "chakra-progress",
    base: {
        root: {
            textStyle: "sm",
            position: "relative"
        },
        track: {
            overflow: "hidden",
            position: "relative"
        },
        range: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transitionProperty: "width, height",
            transitionDuration: "slow",
            height: "100%",
            bgColor: "var(--track-color)",
            _indeterminate: {
                "--animate-from-x": "-40%",
                "--animate-to-x": "100%",
                position: "absolute",
                willChange: "left",
                minWidth: "50%",
                animation: "position 1s ease infinite normal none running",
                backgroundImage: `linear-gradient(to right, transparent 0%, var(--track-color) 50%, transparent 100%)`
            }
        },
        label: {
            display: "inline-flex",
            fontWeight: "medium",
            alignItems: "center",
            gap: "1"
        },
        valueText: {
            textStyle: "xs",
            lineHeight: "1",
            fontWeight: "medium"
        }
    },
    variants: {
        variant: {
            outline: {
                track: {
                    shadow: "inset",
                    bgColor: "bg.muted"
                },
                range: {
                    bgColor: "colorPalette.solid"
                }
            },
            subtle: {
                track: {
                    bgColor: "colorPalette.muted"
                },
                range: {
                    bgColor: "colorPalette.solid/72"
                }
            }
        },
        shape: {
            square: {},
            rounded: {
                track: {
                    borderRadius: "l1"
                }
            },
            full: {
                track: {
                    borderRadius: "full"
                }
            }
        },
        striped: {
            true: {
                range: {
                    backgroundImage: `linear-gradient(45deg, var(--stripe-color) 25%, transparent 25%, transparent 50%, var(--stripe-color) 50%, var(--stripe-color) 75%, transparent 75%, transparent)`,
                    backgroundSize: `var(--stripe-size) var(--stripe-size)`,
                    "--stripe-size": "1rem",
                    "--stripe-color": {
                        _light: "rgba(255, 255, 255, 0.3)",
                        _dark: "rgba(0, 0, 0, 0.3)"
                    }
                }
            }
        },
        animated: {
            true: {
                range: {
                    "--animate-from": "var(--stripe-size)",
                    animation: "bg-position 1s linear infinite"
                }
            }
        },
        size: {
            xs: {
                track: {
                    h: "1.5"
                }
            },
            sm: {
                track: {
                    h: "2"
                }
            },
            md: {
                track: {
                    h: "2.5"
                }
            },
            lg: {
                track: {
                    h: "3"
                }
            },
            xl: {
                track: {
                    h: "4"
                }
            }
        }
    },
    defaultVariants: {
        variant: "outline",
        size: "md",
        shape: "rounded"
    }
});




"use strict";
const $329ae395a7c8fc9e$export$bf55419709f49d86 = (0, $a2f848fc882d4d28$export$c28efc68fea5b4d6)({
    className: "chakra-progress-circle",
    slots: (0, $a04d9e5b8230377c$export$477202748c7242bf).keys(),
    base: {
        root: {
            display: "inline-flex",
            textStyle: "sm",
            position: "relative"
        },
        circle: {
            _indeterminate: {
                animation: "spin 2s linear infinite"
            }
        },
        circleTrack: {
            "--track-color": "colors.colorPalette.muted",
            stroke: "var(--track-color)"
        },
        circleRange: {
            stroke: "colorPalette.solid",
            transitionProperty: "stroke-dashoffset, stroke-dasharray",
            transitionDuration: "0.6s",
            _indeterminate: {
                animation: "circular-progress 1.5s linear infinite"
            }
        },
        label: {
            display: "inline-flex"
        },
        valueText: {
            lineHeight: "1",
            fontWeight: "medium",
            letterSpacing: "tight",
            fontVariantNumeric: "tabular-nums"
        }
    },
    variants: {
        size: {
            xs: {
                circle: {
                    "--size": "24px",
                    "--thickness": "4px"
                },
                valueText: {
                    textStyle: "2xs"
                }
            },
            sm: {
                circle: {
                    "--size": "32px",
                    "--thickness": "5px"
                },
                valueText: {
                    textStyle: "2xs"
                }
            },
            md: {
                circle: {
                    "--size": "40px",
                    "--thickness": "6px"
                },
                valueText: {
                    textStyle: "xs"
                }
            },
            lg: {
                circle: {
                    "--size": "48px",
                    "--thickness": "7px"
                },
                valueText: {
                    textStyle: "sm"
                }
            },
            xl: {
                circle: {
                    "--size": "64px",
                    "--thickness": "8px"
                },
                valueText: {
                    textStyle: "sm"
                }
            }
        }
    },
    defaultVariants: {
        size: "md"
    }
});



// src/qr-code.anatomy.ts

var $999a09efe62f94e1$export$477202748c7242bf = (0, $07b08c6ef332e8db$export$197e6e8d4b33fd6c)("qr-code").parts("root", "frame", "pattern", "overlay", "downloadTrigger");
var $999a09efe62f94e1$export$6e2410c1d27f06e7 = $999a09efe62f94e1$export$477202748c7242bf.build();


"use strict";
const $3ccb9cb1a0ad6d6b$export$8ac26324cd542d34 = (0, $a2f848fc882d4d28$export$c28efc68fea5b4d6)({
    slots: (0, $999a09efe62f94e1$export$477202748c7242bf).keys(),
    className: "chakra-qr-code",
    base: {
        root: {
            position: "relative",
            width: "fit-content",
            "--qr-code-overlay-size": "calc(var(--qr-code-size) / 3)"
        },
        frame: {
            width: "var(--qr-code-size)",
            height: "var(--qr-code-size)",
            fill: "currentColor"
        },
        overlay: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "var(--qr-code-overlay-size)",
            height: "var(--qr-code-overlay-size)",
            padding: "1",
            bg: "bg",
            rounded: "l1"
        }
    },
    variants: {
        size: {
            "2xs": {
                root: {
                    "--qr-code-size": "40px"
                }
            },
            xs: {
                root: {
                    "--qr-code-size": "64px"
                }
            },
            sm: {
                root: {
                    "--qr-code-size": "80px"
                }
            },
            md: {
                root: {
                    "--qr-code-size": "120px"
                }
            },
            lg: {
                root: {
                    "--qr-code-size": "160px"
                }
            },
            xl: {
                root: {
                    "--qr-code-size": "200px"
                }
            },
            "2xl": {
                root: {
                    "--qr-code-size": "240px"
                }
            },
            full: {
                root: {
                    "--qr-code-size": "100%"
                }
            }
        }
    },
    defaultVariants: {
        size: "md"
    }
});





"use strict";
const $498bb9db1daeeadf$export$ba1bd7ba2c203b42 = (0, $a2f848fc882d4d28$export$c28efc68fea5b4d6)({
    className: "chakra-radio-card",
    slots: (0, $210cc27d3a3db981$export$6f8cb2f45f823e4d).keys(),
    base: {
        root: {
            display: "flex",
            flexDirection: "column",
            gap: "1.5",
            isolation: "isolate"
        },
        item: {
            flex: "1",
            display: "flex",
            flexDirection: "column",
            userSelect: "none",
            position: "relative",
            borderRadius: "l2",
            _focus: {
                bg: "colorPalette.muted/20"
            },
            _disabled: {
                opacity: "0.5"
            },
            _checked: {
                zIndex: "1"
            }
        },
        label: {
            display: "inline-flex",
            fontWeight: "medium",
            textStyle: "sm",
            _disabled: {
                opacity: "0.5"
            }
        },
        itemText: {
            fontWeight: "medium",
            flex: "1"
        },
        itemDescription: {
            opacity: "0.64",
            textStyle: "sm"
        },
        itemControl: {
            display: "inline-flex",
            flex: "1",
            pos: "relative",
            rounded: "inherit",
            justifyContent: "var(--radio-card-justify)",
            alignItems: "var(--radio-card-align)",
            _disabled: {
                bg: "bg.muted"
            }
        },
        itemIndicator: (0, $17783a9fb3761078$export$f073ddc07274fbb0).base,
        itemAddon: {
            roundedBottom: "inherit",
            _disabled: {
                color: "fg.muted"
            }
        },
        itemContent: {
            display: "flex",
            flexDirection: "column",
            flex: "1",
            gap: "1",
            justifyContent: "var(--radio-card-justify)",
            alignItems: "var(--radio-card-align)"
        }
    },
    variants: {
        size: {
            sm: {
                item: {
                    textStyle: "sm"
                },
                itemControl: {
                    padding: "3",
                    gap: "1.5"
                },
                itemAddon: {
                    px: "3",
                    py: "1.5",
                    borderTopWidth: "1px"
                },
                itemIndicator: (0, $17783a9fb3761078$export$f073ddc07274fbb0).variants?.size.sm
            },
            md: {
                item: {
                    textStyle: "sm"
                },
                itemControl: {
                    padding: "4",
                    gap: "2.5"
                },
                itemAddon: {
                    px: "4",
                    py: "2",
                    borderTopWidth: "1px"
                },
                itemIndicator: (0, $17783a9fb3761078$export$f073ddc07274fbb0).variants?.size.md
            },
            lg: {
                item: {
                    textStyle: "md"
                },
                itemControl: {
                    padding: "4",
                    gap: "3.5"
                },
                itemAddon: {
                    px: "4",
                    py: "2",
                    borderTopWidth: "1px"
                },
                itemIndicator: (0, $17783a9fb3761078$export$f073ddc07274fbb0).variants?.size.lg
            }
        },
        variant: {
            surface: {
                item: {
                    borderWidth: "1px",
                    _checked: {
                        bg: "colorPalette.subtle",
                        color: "colorPalette.fg",
                        borderColor: "colorPalette.muted"
                    }
                },
                itemIndicator: (0, $17783a9fb3761078$export$f073ddc07274fbb0).variants?.variant.solid
            },
            subtle: {
                item: {
                    bg: "bg.muted"
                },
                itemControl: {
                    _checked: {
                        bg: "colorPalette.muted",
                        color: "colorPalette.fg"
                    }
                },
                itemIndicator: (0, $17783a9fb3761078$export$f073ddc07274fbb0).variants?.variant.outline
            },
            outline: {
                item: {
                    borderWidth: "1px",
                    _checked: {
                        boxShadow: "0 0 0 1px var(--shadow-color)",
                        boxShadowColor: "colorPalette.solid",
                        borderColor: "colorPalette.solid"
                    }
                },
                itemIndicator: (0, $17783a9fb3761078$export$f073ddc07274fbb0).variants?.variant.solid
            },
            solid: {
                item: {
                    borderWidth: "1px",
                    _checked: {
                        bg: "colorPalette.solid",
                        color: "colorPalette.contrast",
                        borderColor: "colorPalette.solid"
                    }
                },
                itemControl: {
                    _disabled: {
                        bg: "unset"
                    }
                },
                itemIndicator: (0, $17783a9fb3761078$export$f073ddc07274fbb0).variants?.variant.inverted
            }
        },
        justify: {
            start: {
                item: {
                    "--radio-card-justify": "flex-start"
                }
            },
            end: {
                item: {
                    "--radio-card-justify": "flex-end"
                }
            },
            center: {
                item: {
                    "--radio-card-justify": "center"
                }
            }
        },
        align: {
            start: {
                item: {
                    "--radio-card-align": "flex-start"
                },
                itemControl: {
                    textAlign: "start"
                }
            },
            end: {
                item: {
                    "--radio-card-align": "flex-end"
                },
                itemControl: {
                    textAlign: "end"
                }
            },
            center: {
                item: {
                    "--radio-card-align": "center"
                },
                itemControl: {
                    textAlign: "center"
                }
            }
        },
        orientation: {
            vertical: {
                itemControl: {
                    flexDirection: "column"
                }
            },
            horizontal: {
                itemControl: {
                    flexDirection: "row"
                }
            }
        }
    },
    defaultVariants: {
        size: "md",
        variant: "outline",
        align: "start",
        orientation: "horizontal"
    }
});





"use strict";
const $5fc09042de0099f9$export$f22f9c9e9c78d451 = (0, $a2f848fc882d4d28$export$c28efc68fea5b4d6)({
    className: "chakra-radio-group",
    slots: (0, $210cc27d3a3db981$export$837558ec9d0fab0d).keys(),
    base: {
        item: {
            display: "inline-flex",
            alignItems: "center",
            position: "relative",
            fontWeight: "medium",
            _disabled: {
                cursor: "disabled"
            }
        },
        itemControl: (0, $17783a9fb3761078$export$f073ddc07274fbb0).base,
        label: {
            userSelect: "none",
            textStyle: "sm",
            _disabled: {
                opacity: "0.5"
            }
        }
    },
    variants: {
        variant: {
            outline: {
                itemControl: (0, $17783a9fb3761078$export$f073ddc07274fbb0).variants?.variant?.outline
            },
            subtle: {
                itemControl: (0, $17783a9fb3761078$export$f073ddc07274fbb0).variants?.variant?.subtle
            },
            solid: {
                itemControl: (0, $17783a9fb3761078$export$f073ddc07274fbb0).variants?.variant?.solid
            }
        },
        size: {
            xs: {
                item: {
                    textStyle: "xs",
                    gap: "1.5"
                },
                itemControl: (0, $17783a9fb3761078$export$f073ddc07274fbb0).variants?.size?.xs
            },
            sm: {
                item: {
                    textStyle: "sm",
                    gap: "2"
                },
                itemControl: (0, $17783a9fb3761078$export$f073ddc07274fbb0).variants?.size?.sm
            },
            md: {
                item: {
                    textStyle: "sm",
                    gap: "2.5"
                },
                itemControl: (0, $17783a9fb3761078$export$f073ddc07274fbb0).variants?.size?.md
            },
            lg: {
                item: {
                    textStyle: "md",
                    gap: "3"
                },
                itemControl: (0, $17783a9fb3761078$export$f073ddc07274fbb0).variants?.size?.lg
            }
        }
    },
    defaultVariants: {
        size: "md",
        variant: "solid"
    }
});




"use strict";
const $95865e7997a9b4a1$export$bd71218a24c0f454 = (0, $a2f848fc882d4d28$export$c28efc68fea5b4d6)({
    className: "chakra-rating-group",
    slots: (0, $210cc27d3a3db981$export$127aba8545f015d6).keys(),
    base: {
        root: {
            display: "inline-flex"
        },
        control: {
            display: "inline-flex",
            alignItems: "center"
        },
        item: {
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            userSelect: "none"
        },
        itemIndicator: {
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: "1em",
            height: "1em",
            position: "relative",
            "--clip-path": {
                base: "inset(0 50% 0 0)",
                _rtl: "inset(0 0 0 50%)"
            },
            _icon: {
                stroke: "currentColor",
                width: "100%",
                height: "100%",
                display: "inline-block",
                flexShrink: 0,
                position: "absolute",
                left: 0,
                top: 0
            },
            "& [data-bg]": {
                color: "bg.emphasized"
            },
            "& [data-fg]": {
                color: "transparent"
            },
            "&[data-highlighted]:not([data-half])": {
                "& [data-fg]": {
                    color: "colorPalette.solid"
                }
            },
            "&[data-half]": {
                "& [data-fg]": {
                    color: "colorPalette.solid",
                    clipPath: "var(--clip-path)"
                }
            }
        }
    },
    variants: {
        size: {
            xs: {
                item: {
                    textStyle: "sm"
                }
            },
            sm: {
                item: {
                    textStyle: "md"
                }
            },
            md: {
                item: {
                    textStyle: "xl"
                }
            },
            lg: {
                item: {
                    textStyle: "2xl"
                }
            }
        }
    },
    defaultVariants: {
        size: "md"
    }
});





var $febc4408897b8023$export$477202748c7242bf = (0, $07b08c6ef332e8db$export$197e6e8d4b33fd6c)("scroll-area").parts("root", "viewport", "content", "scrollbar", "thumb", "corner");
var $febc4408897b8023$export$6e2410c1d27f06e7 = $febc4408897b8023$export$477202748c7242bf.build();


"use strict";
const $e368f450dc482683$export$d777508e9bee4a37 = (0, $a2f848fc882d4d28$export$c28efc68fea5b4d6)({
    className: "chakra-scroll-area",
    slots: (0, $febc4408897b8023$export$477202748c7242bf).keys(),
    base: {
        root: {
            display: "flex",
            flexDirection: "column",
            width: "100%",
            height: "100%",
            position: "relative",
            overflow: "hidden",
            "--scrollbar-margin": "2px",
            "--scrollbar-click-area": "calc(var(--scrollbar-size) + calc(var(--scrollbar-margin) * 2))"
        },
        viewport: {
            display: "flex",
            flexDirection: "column",
            height: "100%",
            width: "100%",
            borderRadius: "inherit",
            WebkitOverflowScrolling: "touch",
            scrollbarWidth: "none",
            "&::-webkit-scrollbar": {
                display: "none"
            }
        },
        content: {
            minWidth: "100%"
        },
        scrollbar: {
            display: "flex",
            userSelect: "none",
            touchAction: "none",
            borderRadius: "full",
            colorPalette: "gray",
            transition: "opacity 150ms 300ms",
            position: "relative",
            margin: "var(--scrollbar-margin)",
            "&:not([data-overflow-x], [data-overflow-y])": {
                display: "none"
            },
            bg: "{colors.colorPalette.solid/10}",
            "--thumb-bg": "{colors.colorPalette.solid/25}",
            "&:is(:hover, :active)": {
                "--thumb-bg": "{colors.colorPalette.solid/50}"
            },
            _before: {
                content: '""',
                position: "absolute"
            },
            _vertical: {
                width: "var(--scrollbar-size)",
                flexDirection: "column",
                "&::before": {
                    width: "var(--scrollbar-click-area)",
                    height: "100%",
                    insetInlineStart: "calc(var(--scrollbar-margin) * -1)"
                }
            },
            _horizontal: {
                height: "var(--scrollbar-size)",
                flexDirection: "row",
                "&::before": {
                    height: "var(--scrollbar-click-area)",
                    width: "100%",
                    top: "calc(var(--scrollbar-margin) * -1)"
                }
            }
        },
        thumb: {
            borderRadius: "inherit",
            bg: "var(--thumb-bg)",
            transition: "backgrounds",
            _vertical: {
                width: "full"
            },
            _horizontal: {
                height: "full"
            }
        },
        corner: {
            bg: "bg.muted",
            margin: "var(--scrollbar-margin)",
            opacity: 0,
            transition: "opacity 150ms 300ms",
            "&[data-hover]": {
                transitionDelay: "0ms",
                opacity: 1
            }
        }
    },
    variants: {
        variant: {
            hover: {
                scrollbar: {
                    opacity: "0",
                    "&[data-hover], &[data-scrolling]": {
                        opacity: "1",
                        transitionDuration: "faster",
                        transitionDelay: "0ms"
                    }
                }
            },
            always: {
                scrollbar: {
                    opacity: "1"
                }
            }
        },
        size: {
            xs: {
                root: {
                    "--scrollbar-size": "sizes.1"
                }
            },
            sm: {
                root: {
                    "--scrollbar-size": "sizes.1.5"
                }
            },
            md: {
                root: {
                    "--scrollbar-size": "sizes.2"
                }
            },
            lg: {
                root: {
                    "--scrollbar-size": "sizes.3"
                }
            }
        }
    },
    defaultVariants: {
        size: "md",
        variant: "hover"
    }
});




"use client";
//#region src/components/segment-group/segment-group.anatomy.ts
var $106ac282d9129bbc$export$bdb66e13d4208038 = (0, $e17d441bd191f763$export$477202748c7242bf).rename("segment-group");
var $106ac282d9129bbc$export$6e2410c1d27f06e7 = $106ac282d9129bbc$export$bdb66e13d4208038.build();


"use strict";
const $50bad464d90c2607$export$7b9ca3573b9e7a3e = (0, $a2f848fc882d4d28$export$c28efc68fea5b4d6)({
    className: "chakra-segment-group",
    slots: (0, $106ac282d9129bbc$export$bdb66e13d4208038).keys(),
    base: {
        root: {
            "--segment-radius": "radii.l2",
            "--segment-indicator-bg": {
                _light: "colors.bg",
                _dark: "colors.bg.emphasized"
            },
            "--segment-indicator-shadow": "shadows.sm",
            borderRadius: "var(--segment-radius)",
            display: "inline-flex",
            boxShadow: "inset",
            minW: "max-content",
            textAlign: "center",
            position: "relative",
            isolation: "isolate",
            bg: "bg.muted",
            _vertical: {
                flexDirection: "column"
            }
        },
        item: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            userSelect: "none",
            fontSize: "sm",
            position: "relative",
            color: "fg",
            borderRadius: "var(--segment-radius)",
            _disabled: {
                opacity: "0.5"
            },
            "&:has(input:focus-visible)": {
                focusRing: "outside"
            },
            _before: {
                content: '""',
                position: "absolute",
                bg: "border",
                transition: "opacity 0.2s"
            },
            _horizontal: {
                _before: {
                    insetInlineStart: 0,
                    insetBlock: "1.5",
                    width: "1px"
                }
            },
            _vertical: {
                _before: {
                    insetBlockStart: 0,
                    insetInline: "1.5",
                    height: "1px"
                }
            },
            "& + &[data-state=checked], &[data-state=checked] + &, &:first-of-type": {
                _before: {
                    opacity: "0"
                }
            },
            "&[data-state=checked][data-ssr]": {
                shadow: "sm",
                bg: "bg",
                borderRadius: "var(--segment-radius)"
            }
        },
        indicator: {
            shadow: "var(--segment-indicator-shadow)",
            pos: "absolute",
            bg: "var(--segment-indicator-bg)",
            width: "var(--width)",
            height: "var(--height)",
            top: "var(--top)",
            left: "var(--left)",
            zIndex: -1,
            borderRadius: "var(--segment-radius)"
        }
    },
    variants: {
        size: {
            xs: {
                item: {
                    textStyle: "xs",
                    px: "3",
                    gap: "1",
                    height: "6"
                }
            },
            sm: {
                item: {
                    textStyle: "sm",
                    px: "4",
                    gap: "2",
                    height: "8"
                }
            },
            md: {
                item: {
                    textStyle: "sm",
                    px: "4",
                    gap: "2",
                    height: "10"
                }
            },
            lg: {
                item: {
                    textStyle: "md",
                    px: "4.5",
                    gap: "3",
                    height: "11"
                }
            }
        }
    },
    defaultVariants: {
        size: "md"
    }
});





"use strict";
const $0a5d545aa14058a5$export$d46f05a25a44100c = (0, $a2f848fc882d4d28$export$c28efc68fea5b4d6)({
    className: "chakra-slider",
    slots: (0, $210cc27d3a3db981$export$c21b4b3f8b239f32).keys(),
    base: {
        root: {
            display: "flex",
            flexDirection: "column",
            gap: "1",
            textStyle: "sm",
            position: "relative",
            isolation: "isolate",
            touchAction: "none"
        },
        label: {
            fontWeight: "medium",
            textStyle: "sm"
        },
        control: {
            display: "inline-flex",
            alignItems: "center",
            position: "relative"
        },
        track: {
            overflow: "hidden",
            borderRadius: "full",
            flex: "1"
        },
        range: {
            width: "inherit",
            height: "inherit",
            _disabled: {
                bg: "border.emphasized!"
            }
        },
        markerGroup: {
            position: "absolute!",
            zIndex: "1"
        },
        marker: {
            "--marker-bg": {
                base: "white",
                _underValue: "colors.bg"
            },
            display: "flex",
            alignItems: "center",
            gap: "calc(var(--slider-thumb-size) / 2)",
            color: "fg.muted",
            textStyle: "xs"
        },
        markerIndicator: {
            width: "var(--slider-marker-size)",
            height: "var(--slider-marker-size)",
            borderRadius: "full",
            bg: "var(--marker-bg)"
        },
        thumb: {
            width: "var(--slider-thumb-size)",
            height: "var(--slider-thumb-size)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            outline: 0,
            zIndex: "2",
            borderRadius: "full",
            transition: "shadow",
            _focusVisible: {
                ring: "3px",
                ringColor: "colorPalette.focusRing/50"
            }
        }
    },
    variants: {
        size: {
            sm: {
                root: {
                    "--slider-thumb-size": "sizes.4",
                    "--slider-track-size": "sizes.1.5",
                    "--slider-marker-center": "6px",
                    "--slider-marker-size": "sizes.1",
                    "--slider-marker-inset": "3px"
                }
            },
            md: {
                root: {
                    "--slider-thumb-size": "sizes.5",
                    "--slider-track-size": "sizes.2",
                    "--slider-marker-center": "8px",
                    "--slider-marker-size": "sizes.1",
                    "--slider-marker-inset": "4px"
                }
            },
            lg: {
                root: {
                    "--slider-thumb-size": "sizes.6",
                    "--slider-track-size": "sizes.2.5",
                    "--slider-marker-center": "9px",
                    "--slider-marker-size": "sizes.1.5",
                    "--slider-marker-inset": "5px"
                }
            }
        },
        variant: {
            outline: {
                track: {
                    shadow: "inset",
                    bg: "bg.emphasized/72"
                },
                range: {
                    bg: "colorPalette.solid"
                },
                thumb: {
                    borderWidth: "2px",
                    borderColor: "colorPalette.solid",
                    bg: "bg",
                    _disabled: {
                        bg: "border.emphasized",
                        borderColor: "border.emphasized"
                    }
                }
            },
            solid: {
                track: {
                    bg: "colorPalette.subtle",
                    _disabled: {
                        bg: "bg.muted"
                    }
                },
                range: {
                    bg: "colorPalette.solid"
                },
                thumb: {
                    bg: "colorPalette.solid",
                    _disabled: {
                        bg: "border.emphasized"
                    }
                }
            }
        },
        orientation: {
            vertical: {
                root: {
                    display: "inline-flex"
                },
                control: {
                    flexDirection: "column",
                    height: "100%",
                    minWidth: "var(--slider-thumb-size)",
                    "&:has(.chakra-slider__markerLabel)": {
                        marginEnd: "4"
                    }
                },
                track: {
                    width: "var(--slider-track-size)"
                },
                thumb: {
                    left: "50%",
                    translate: "-50% 0"
                },
                markerGroup: {
                    insetStart: "var(--slider-marker-center)",
                    insetBlock: "var(--slider-marker-inset)"
                },
                marker: {
                    flexDirection: "row"
                }
            },
            horizontal: {
                control: {
                    flexDirection: "row",
                    width: "100%",
                    minHeight: "var(--slider-thumb-size)",
                    "&:has(.chakra-slider__markerLabel)": {
                        marginBottom: "4"
                    }
                },
                track: {
                    height: "var(--slider-track-size)"
                },
                thumb: {
                    top: "50%",
                    translate: "0 -50%"
                },
                markerGroup: {
                    top: "var(--slider-marker-center)",
                    insetInline: "var(--slider-marker-inset)"
                },
                marker: {
                    flexDirection: "column"
                }
            }
        }
    },
    defaultVariants: {
        size: "md",
        variant: "outline",
        orientation: "horizontal"
    }
});




"use strict";
const $084d84921709909a$export$fea3591e553a0109 = (0, $a2f848fc882d4d28$export$c28efc68fea5b4d6)({
    slots: (0, $210cc27d3a3db981$export$a71cb10e7bdef1a3).keys(),
    className: "splitter",
    base: {
        resizeTrigger: {
            "--splitter-border-color": "colors.border",
            "--splitter-thumb-color": "colors.bg",
            "--splitter-thumb-size": "sizes.2",
            "--splitter-thumb-inset": "calc(var(--splitter-thumb-size) * -0.5)",
            "--splitter-border-size": "1px",
            "--splitter-handle-size": "sizes.6",
            outline: "0",
            display: "grid",
            placeItems: "center",
            position: "relative",
            _focus: {
                "--splitter-border-color": "colors.border.emphasized",
                "--splitter-thumb-color": "colors.colorPalette.subtle"
            },
            _dragging: {
                "--splitter-thumb-color": "colors.colorPalette.focusRing"
            },
            _horizontal: {
                minWidth: "var(--splitter-thumb-size)",
                marginInline: "var(--splitter-thumb-inset)"
            },
            _vertical: {
                minHeight: "var(--splitter-thumb-size)",
                marginBlock: "var(--splitter-thumb-inset)"
            }
        },
        resizeTriggerSeparator: {
            position: "absolute",
            bg: "var(--splitter-border-color)",
            "[data-part='resize-trigger'][data-orientation=horizontal] &": {
                insetInlineEnd: "calc(var(--splitter-thumb-size) * 0.5)",
                insetBlock: "0",
                insetInlineStart: "auto",
                w: "var(--splitter-border-size)"
            },
            "[data-part='resize-trigger'][data-orientation=vertical] &": {
                insetBlockEnd: "calc(var(--splitter-thumb-size) * 0.5)",
                insetInline: "0",
                insetBlockStart: "auto",
                h: "var(--splitter-border-size)"
            }
        },
        resizeTriggerIndicator: {
            position: "relative",
            rounded: "full",
            bg: "var(--splitter-thumb-color)",
            shadow: "xs",
            borderWidth: "1px",
            zIndex: "1",
            "[data-part='resize-trigger'][data-orientation=horizontal] &": {
                w: "full",
                h: "var(--splitter-handle-size)"
            },
            "[data-part='resize-trigger'][data-orientation=vertical] &": {
                w: "var(--splitter-handle-size)",
                h: "full"
            },
            "[data-part='resize-trigger'][data-focus]:focus-visible &": {
                outlineWidth: "2px",
                outlineColor: "colorPalette.focusRing",
                outlineStyle: "solid"
            },
            "[data-part='resize-trigger'][data-disabled] &": {
                visibility: "hidden"
            }
        }
    }
});




"use strict";
const $468e67f36e5bc3b6$export$49c5be1bec04cd74 = (0, $a2f848fc882d4d28$export$c28efc68fea5b4d6)({
    className: "chakra-stat",
    slots: (0, $210cc27d3a3db981$export$2cfbad67ae6ee421).keys(),
    base: {
        root: {
            display: "flex",
            flexDirection: "column",
            gap: "1",
            position: "relative",
            flex: "1"
        },
        label: {
            display: "inline-flex",
            gap: "1.5",
            alignItems: "center",
            color: "fg.muted",
            textStyle: "sm"
        },
        helpText: {
            color: "fg.muted",
            textStyle: "xs"
        },
        valueUnit: {
            color: "fg.muted",
            textStyle: "xs",
            fontWeight: "initial",
            letterSpacing: "initial"
        },
        valueText: {
            verticalAlign: "baseline",
            fontWeight: "semibold",
            letterSpacing: "tight",
            fontFeatureSettings: "pnum",
            fontVariantNumeric: "proportional-nums",
            display: "inline-flex",
            gap: "1"
        },
        indicator: {
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            marginEnd: 1,
            "& :where(svg)": {
                w: "1em",
                h: "1em"
            },
            "&[data-type=up]": {
                color: "fg.success"
            },
            "&[data-type=down]": {
                color: "fg.error"
            }
        }
    },
    variants: {
        size: {
            sm: {
                valueText: {
                    textStyle: "xl"
                }
            },
            md: {
                valueText: {
                    textStyle: "2xl"
                }
            },
            lg: {
                valueText: {
                    textStyle: "3xl"
                }
            }
        }
    },
    defaultVariants: {
        size: "md"
    }
});




"use strict";
const $1a217600f199fc5d$export$62ef19b4b5830661 = (0, $a2f848fc882d4d28$export$c28efc68fea5b4d6)({
    className: "chakra-status",
    slots: (0, $210cc27d3a3db981$export$6b07965b0539a879).keys(),
    base: {
        root: {
            display: "inline-flex",
            alignItems: "center",
            gap: "2"
        },
        indicator: {
            width: "0.64em",
            height: "0.64em",
            flexShrink: 0,
            borderRadius: "full",
            forcedColorAdjust: "none",
            bg: "colorPalette.solid"
        }
    },
    variants: {
        size: {
            sm: {
                root: {
                    textStyle: "xs"
                }
            },
            md: {
                root: {
                    textStyle: "sm"
                }
            },
            lg: {
                root: {
                    textStyle: "md"
                }
            }
        }
    },
    defaultVariants: {
        size: "md"
    }
});




"use strict";
const $614c61576e78a7d8$export$830e54a433c6be33 = (0, $a2f848fc882d4d28$export$c28efc68fea5b4d6)({
    className: "chakra-steps",
    slots: (0, $210cc27d3a3db981$export$5c3acf63225011aa).keys(),
    base: {
        root: {
            display: "flex",
            width: "full"
        },
        list: {
            display: "flex",
            justifyContent: "space-between",
            "--steps-gutter": "spacing.3",
            "--steps-thickness": "2px"
        },
        title: {
            fontWeight: "medium",
            color: "fg"
        },
        description: {
            color: "fg.muted"
        },
        separator: {
            bg: "border",
            flex: "1"
        },
        indicator: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexShrink: "0",
            borderRadius: "full",
            fontWeight: "medium",
            width: "var(--steps-size)",
            height: "var(--steps-size)",
            _icon: {
                flexShrink: "0",
                width: "var(--steps-icon-size)",
                height: "var(--steps-icon-size)"
            }
        },
        item: {
            position: "relative",
            display: "flex",
            gap: "3",
            flex: "1 0 0",
            "&:last-of-type": {
                flex: "initial",
                "& [data-part=separator]": {
                    display: "none"
                }
            }
        },
        trigger: {
            display: "flex",
            alignItems: "center",
            gap: "3",
            textAlign: "start",
            focusVisibleRing: "outside",
            borderRadius: "l2"
        },
        content: {
            focusVisibleRing: "outside"
        }
    },
    variants: {
        orientation: {
            vertical: {
                root: {
                    flexDirection: "row",
                    height: "100%"
                },
                list: {
                    flexDirection: "column",
                    alignItems: "flex-start"
                },
                separator: {
                    position: "absolute",
                    width: "var(--steps-thickness)",
                    height: "100%",
                    maxHeight: "calc(100% - var(--steps-size) - var(--steps-gutter) * 2)",
                    top: "calc(var(--steps-size) + var(--steps-gutter))",
                    insetStart: "calc(var(--steps-size) / 2 - 1px)"
                },
                item: {
                    alignItems: "flex-start"
                }
            },
            horizontal: {
                root: {
                    flexDirection: "column",
                    width: "100%"
                },
                list: {
                    flexDirection: "row",
                    alignItems: "center"
                },
                separator: {
                    width: "100%",
                    height: "var(--steps-thickness)",
                    marginX: "var(--steps-gutter)"
                },
                item: {
                    alignItems: "center"
                }
            }
        },
        variant: {
            solid: {
                indicator: {
                    _incomplete: {
                        borderWidth: "var(--steps-thickness)"
                    },
                    _current: {
                        bg: "colorPalette.muted",
                        borderWidth: "var(--steps-thickness)",
                        borderColor: "colorPalette.solid",
                        color: "colorPalette.fg"
                    },
                    _complete: {
                        bg: "colorPalette.solid",
                        borderColor: "colorPalette.solid",
                        color: "colorPalette.contrast"
                    }
                },
                separator: {
                    _complete: {
                        bg: "colorPalette.solid"
                    }
                }
            },
            subtle: {
                indicator: {
                    _incomplete: {
                        bg: "bg.muted"
                    },
                    _current: {
                        bg: "colorPalette.muted",
                        color: "colorPalette.fg"
                    },
                    _complete: {
                        bg: "colorPalette.emphasized",
                        color: "colorPalette.fg"
                    }
                },
                separator: {
                    _complete: {
                        bg: "colorPalette.emphasized"
                    }
                }
            }
        },
        size: {
            xs: {
                root: {
                    gap: "2.5"
                },
                list: {
                    "--steps-size": "sizes.6",
                    "--steps-icon-size": "sizes.3.5",
                    textStyle: "xs"
                },
                title: {
                    textStyle: "sm"
                }
            },
            sm: {
                root: {
                    gap: "3"
                },
                list: {
                    "--steps-size": "sizes.8",
                    "--steps-icon-size": "sizes.4",
                    textStyle: "xs"
                },
                title: {
                    textStyle: "sm"
                }
            },
            md: {
                root: {
                    gap: "4"
                },
                list: {
                    "--steps-size": "sizes.10",
                    "--steps-icon-size": "sizes.4",
                    textStyle: "sm"
                },
                title: {
                    textStyle: "sm"
                }
            },
            lg: {
                root: {
                    gap: "6"
                },
                list: {
                    "--steps-size": "sizes.11",
                    "--steps-icon-size": "sizes.5",
                    textStyle: "md"
                },
                title: {
                    textStyle: "md"
                }
            }
        }
    },
    defaultVariants: {
        size: "md",
        variant: "solid",
        orientation: "horizontal"
    }
});




"use strict";
const $e399f463a355c2cd$export$daa01504810a732d = (0, $a2f848fc882d4d28$export$c28efc68fea5b4d6)({
    slots: (0, $210cc27d3a3db981$export$921c1a2d1ce1e86a).keys(),
    className: "chakra-switch",
    base: {
        root: {
            display: "inline-flex",
            gap: "2.5",
            alignItems: "center",
            position: "relative",
            verticalAlign: "middle",
            "--switch-diff": "calc(var(--switch-width) - var(--switch-height))",
            "--switch-x": {
                base: "var(--switch-diff)",
                _rtl: "calc(var(--switch-diff) * -1)"
            }
        },
        label: {
            lineHeight: "1",
            userSelect: "none",
            fontSize: "sm",
            fontWeight: "medium",
            _disabled: {
                opacity: "0.5"
            }
        },
        indicator: {
            position: "absolute",
            height: "var(--switch-height)",
            width: "var(--switch-height)",
            fontSize: "var(--switch-indicator-font-size)",
            fontWeight: "medium",
            flexShrink: 0,
            userSelect: "none",
            display: "grid",
            placeContent: "center",
            transition: "inset-inline-start 0.12s ease",
            insetInlineStart: "calc(var(--switch-x) - 2px)",
            _checked: {
                insetInlineStart: "2px"
            }
        },
        control: {
            display: "inline-flex",
            gap: "0.5rem",
            flexShrink: 0,
            justifyContent: "flex-start",
            cursor: "switch",
            borderRadius: "full",
            position: "relative",
            width: "var(--switch-width)",
            height: "var(--switch-height)",
            transition: "backgrounds",
            _disabled: {
                opacity: "0.5",
                cursor: "not-allowed"
            },
            _invalid: {
                outline: "2px solid",
                outlineColor: "border.error",
                outlineOffset: "2px"
            }
        },
        thumb: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
            transitionProperty: "translate",
            transitionDuration: "fast",
            borderRadius: "inherit",
            _checked: {
                translate: "var(--switch-x) 0"
            }
        }
    },
    variants: {
        variant: {
            solid: {
                control: {
                    borderRadius: "full",
                    bg: "bg.emphasized",
                    focusVisibleRing: "outside",
                    _checked: {
                        bg: "colorPalette.solid"
                    }
                },
                thumb: {
                    bg: "white",
                    width: "var(--switch-height)",
                    height: "var(--switch-height)",
                    scale: "0.8",
                    boxShadow: "sm",
                    _checked: {
                        bg: "colorPalette.contrast"
                    }
                }
            },
            raised: {
                control: {
                    borderRadius: "full",
                    height: "calc(var(--switch-height) / 2)",
                    bg: "bg.muted",
                    boxShadow: "inset",
                    _checked: {
                        bg: "colorPalette.solid/60"
                    }
                },
                thumb: {
                    width: "var(--switch-height)",
                    height: "var(--switch-height)",
                    position: "relative",
                    top: "calc(var(--switch-height) * -0.25)",
                    bg: "white",
                    boxShadow: "xs",
                    focusVisibleRing: "outside",
                    _checked: {
                        bg: "colorPalette.solid"
                    }
                }
            }
        },
        size: {
            xs: {
                root: {
                    "--switch-width": "sizes.6",
                    "--switch-height": "sizes.3",
                    "--switch-indicator-font-size": "fontSizes.xs"
                }
            },
            sm: {
                root: {
                    "--switch-width": "sizes.8",
                    "--switch-height": "sizes.4",
                    "--switch-indicator-font-size": "fontSizes.xs"
                }
            },
            md: {
                root: {
                    "--switch-width": "sizes.10",
                    "--switch-height": "sizes.5",
                    "--switch-indicator-font-size": "fontSizes.sm"
                }
            },
            lg: {
                root: {
                    "--switch-width": "sizes.12",
                    "--switch-height": "sizes.6",
                    "--switch-indicator-font-size": "fontSizes.md"
                }
            }
        }
    },
    defaultVariants: {
        variant: "solid",
        size: "md"
    }
});




"use strict";
const $cdec6d33f0e9b914$export$5281e08caf496f42 = (0, $a2f848fc882d4d28$export$c28efc68fea5b4d6)({
    className: "chakra-table",
    slots: (0, $210cc27d3a3db981$export$8b1b9cdd5db9f5fd).keys(),
    base: {
        root: {
            fontVariantNumeric: "lining-nums tabular-nums",
            borderCollapse: "collapse",
            width: "full",
            textAlign: "start",
            verticalAlign: "top"
        },
        row: {
            _selected: {
                bg: "colorPalette.subtle"
            }
        },
        cell: {
            textAlign: "start",
            alignItems: "center"
        },
        columnHeader: {
            fontWeight: "medium",
            textAlign: "start",
            color: "fg"
        },
        caption: {
            fontWeight: "medium",
            textStyle: "xs"
        },
        footer: {
            fontWeight: "medium"
        }
    },
    variants: {
        interactive: {
            true: {
                body: {
                    "& tr": {
                        _hover: {
                            bg: "colorPalette.subtle"
                        }
                    }
                }
            }
        },
        stickyHeader: {
            true: {
                header: {
                    "& :where(tr)": {
                        top: "var(--table-sticky-offset, 0)",
                        position: "sticky",
                        zIndex: 1
                    }
                }
            }
        },
        striped: {
            true: {
                row: {
                    "&:nth-of-type(odd) td": {
                        bg: "bg.muted"
                    }
                }
            }
        },
        showColumnBorder: {
            true: {
                columnHeader: {
                    "&:not(:last-of-type)": {
                        borderInlineEndWidth: "1px"
                    }
                },
                cell: {
                    "&:not(:last-of-type)": {
                        borderInlineEndWidth: "1px"
                    }
                }
            }
        },
        variant: {
            line: {
                columnHeader: {
                    borderBottomWidth: "1px"
                },
                cell: {
                    borderBottomWidth: "1px"
                },
                row: {
                    bg: "bg"
                }
            },
            outline: {
                root: {
                    boxShadow: "0 0 0 1px {colors.border}"
                },
                columnHeader: {
                    borderBottomWidth: "1px"
                },
                header: {
                    bg: "bg.muted"
                },
                row: {
                    "&:not(:last-of-type)": {
                        borderBottomWidth: "1px"
                    }
                },
                footer: {
                    borderTopWidth: "1px"
                }
            }
        },
        size: {
            sm: {
                root: {
                    textStyle: "sm"
                },
                columnHeader: {
                    px: "2",
                    py: "2"
                },
                cell: {
                    px: "2",
                    py: "2"
                }
            },
            md: {
                root: {
                    textStyle: "sm"
                },
                columnHeader: {
                    px: "3",
                    py: "3"
                },
                cell: {
                    px: "3",
                    py: "3"
                }
            },
            lg: {
                root: {
                    textStyle: "md"
                },
                columnHeader: {
                    px: "4",
                    py: "3"
                },
                cell: {
                    px: "4",
                    py: "3"
                }
            }
        }
    },
    defaultVariants: {
        variant: "line",
        size: "md"
    }
});




"use strict";
const $f402e3e982e3a287$export$e5eae33afdf5ce13 = (0, $a2f848fc882d4d28$export$c28efc68fea5b4d6)({
    slots: (0, $210cc27d3a3db981$export$97383552563be58d).keys(),
    className: "chakra-tabs",
    base: {
        root: {
            "--tabs-trigger-radius": "radii.l2",
            "--tabs-indicator-shadow": "shadows.xs",
            "--tabs-indicator-bg": "colors.bg",
            position: "relative",
            _horizontal: {
                display: "block"
            },
            _vertical: {
                display: "flex"
            }
        },
        list: {
            display: "inline-flex",
            position: "relative",
            isolation: "isolate",
            minH: "var(--tabs-height)",
            _horizontal: {
                flexDirection: "row"
            },
            _vertical: {
                flexDirection: "column"
            }
        },
        trigger: {
            outline: "0",
            minW: "var(--tabs-height)",
            height: "var(--tabs-height)",
            display: "flex",
            alignItems: "center",
            fontWeight: "medium",
            position: "relative",
            cursor: "button",
            gap: "2",
            _focusVisible: {
                zIndex: 1,
                outline: "2px solid",
                outlineColor: "colorPalette.focusRing"
            },
            _disabled: {
                cursor: "not-allowed",
                opacity: 0.5
            }
        },
        content: {
            focusVisibleRing: "inside",
            _horizontal: {
                width: "100%",
                pt: "var(--tabs-content-padding)"
            },
            _vertical: {
                height: "100%",
                ps: "var(--tabs-content-padding)"
            }
        },
        indicator: {
            width: "var(--width)",
            height: "var(--height)",
            borderRadius: "var(--tabs-trigger-radius)",
            bg: "var(--tabs-indicator-bg)",
            shadow: "var(--tabs-indicator-shadow)",
            zIndex: -1
        }
    },
    variants: {
        fitted: {
            true: {
                list: {
                    display: "flex"
                },
                trigger: {
                    flex: 1,
                    textAlign: "center",
                    justifyContent: "center"
                }
            }
        },
        justify: {
            start: {
                list: {
                    justifyContent: "flex-start"
                }
            },
            center: {
                list: {
                    justifyContent: "center"
                }
            },
            end: {
                list: {
                    justifyContent: "flex-end"
                }
            }
        },
        size: {
            sm: {
                root: {
                    "--tabs-height": "sizes.9",
                    "--tabs-content-padding": "spacing.3"
                },
                trigger: {
                    py: "1",
                    px: "3",
                    textStyle: "sm"
                }
            },
            md: {
                root: {
                    "--tabs-height": "sizes.10",
                    "--tabs-content-padding": "spacing.4"
                },
                trigger: {
                    py: "2",
                    px: "4",
                    textStyle: "sm"
                }
            },
            lg: {
                root: {
                    "--tabs-height": "sizes.11",
                    "--tabs-content-padding": "spacing.4.5"
                },
                trigger: {
                    py: "2",
                    px: "4.5",
                    textStyle: "md"
                }
            }
        },
        variant: {
            line: {
                list: {
                    display: "flex",
                    borderColor: "border",
                    _horizontal: {
                        borderBottomWidth: "1px"
                    },
                    _vertical: {
                        borderEndWidth: "1px"
                    }
                },
                trigger: {
                    color: "fg.muted",
                    _disabled: {
                        _active: {
                            bg: "initial"
                        }
                    },
                    _selected: {
                        color: "fg",
                        _horizontal: {
                            layerStyle: "indicator.bottom",
                            "--indicator-offset-y": "-1px",
                            "--indicator-color": "colors.colorPalette.solid"
                        },
                        _vertical: {
                            layerStyle: "indicator.end",
                            "--indicator-offset-x": "-1px"
                        }
                    }
                }
            },
            subtle: {
                trigger: {
                    borderRadius: "var(--tabs-trigger-radius)",
                    color: "fg.muted",
                    _selected: {
                        bg: "colorPalette.subtle",
                        color: "colorPalette.fg"
                    }
                }
            },
            enclosed: {
                list: {
                    bg: "bg.muted",
                    padding: "1",
                    borderRadius: "l3",
                    minH: "calc(var(--tabs-height) - 4px)"
                },
                trigger: {
                    justifyContent: "center",
                    color: "fg.muted",
                    borderRadius: "var(--tabs-trigger-radius)",
                    _selected: {
                        bg: "bg",
                        color: "colorPalette.fg",
                        shadow: "xs"
                    }
                }
            },
            outline: {
                list: {
                    "--line-thickness": "1px",
                    "--line-offset": "calc(var(--line-thickness) * -1)",
                    borderColor: "border",
                    display: "flex",
                    _horizontal: {
                        _before: {
                            content: '""',
                            position: "absolute",
                            bottom: "0px",
                            width: "100%",
                            borderBottomWidth: "var(--line-thickness)",
                            borderBottomColor: "border"
                        }
                    },
                    _vertical: {
                        _before: {
                            content: '""',
                            position: "absolute",
                            insetInline: "var(--line-offset)",
                            height: "calc(100% - calc(var(--line-thickness) * 2))",
                            borderEndWidth: "var(--line-thickness)",
                            borderEndColor: "border"
                        }
                    }
                },
                trigger: {
                    color: "fg.muted",
                    borderWidth: "1px",
                    borderColor: "transparent",
                    _selected: {
                        bg: "currentBg",
                        color: "colorPalette.fg"
                    },
                    _horizontal: {
                        borderTopRadius: "var(--tabs-trigger-radius)",
                        marginBottom: "var(--line-offset)",
                        marginEnd: {
                            _notLast: "var(--line-offset)"
                        },
                        _selected: {
                            borderColor: "border",
                            borderBottomColor: "transparent"
                        }
                    },
                    _vertical: {
                        borderStartRadius: "var(--tabs-trigger-radius)",
                        marginEnd: "var(--line-offset)",
                        marginBottom: {
                            _notLast: "var(--line-offset)"
                        },
                        _selected: {
                            borderColor: "border",
                            borderEndColor: "transparent"
                        }
                    }
                }
            },
            plain: {
                trigger: {
                    color: "fg.muted",
                    _selected: {
                        color: "colorPalette.fg"
                    },
                    borderRadius: "var(--tabs-trigger-radius)",
                    "&[data-selected][data-ssr]": {
                        bg: "var(--tabs-indicator-bg)",
                        shadow: "var(--tabs-indicator-shadow)",
                        borderRadius: "var(--tabs-trigger-radius)"
                    }
                }
            }
        }
    },
    defaultVariants: {
        size: "md",
        variant: "line"
    }
});





"use strict";
const $0f5f63a924718697$var$badgeVariant = (0, $3ad2981cdd451da7$export$251a0a63b19d28c5).variants?.variant;
const $0f5f63a924718697$export$393c38caed566ad7 = (0, $a2f848fc882d4d28$export$c28efc68fea5b4d6)({
    slots: (0, $210cc27d3a3db981$export$4c2f5f7f2ea94a8e).keys(),
    className: "chakra-tag",
    base: {
        root: {
            display: "inline-flex",
            alignItems: "center",
            verticalAlign: "top",
            maxWidth: "100%",
            userSelect: "none",
            borderRadius: "l2",
            focusVisibleRing: "outside"
        },
        label: {
            lineClamp: "1"
        },
        closeTrigger: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            outline: "0",
            borderRadius: "l1",
            color: "currentColor",
            focusVisibleRing: "inside",
            focusRingWidth: "2px"
        },
        startElement: {
            flexShrink: 0,
            boxSize: "var(--tag-element-size)",
            ms: "var(--tag-element-offset)",
            "&:has([data-scope=avatar])": {
                boxSize: "var(--tag-avatar-size)",
                ms: "calc(var(--tag-element-offset) * 1.5)"
            },
            _icon: {
                boxSize: "100%"
            }
        },
        endElement: {
            flexShrink: 0,
            boxSize: "var(--tag-element-size)",
            me: "var(--tag-element-offset)",
            _icon: {
                boxSize: "100%"
            },
            "&:has(button)": {
                ms: "calc(var(--tag-element-offset) * -1)"
            }
        }
    },
    variants: {
        size: {
            sm: {
                root: {
                    px: "1.5",
                    minH: "4.5",
                    gap: "1",
                    "--tag-avatar-size": "spacing.3",
                    "--tag-element-size": "spacing.3",
                    "--tag-element-offset": "-2px"
                },
                label: {
                    textStyle: "xs"
                }
            },
            md: {
                root: {
                    px: "1.5",
                    minH: "5",
                    gap: "1",
                    "--tag-avatar-size": "spacing.3.5",
                    "--tag-element-size": "spacing.3.5",
                    "--tag-element-offset": "-2px"
                },
                label: {
                    textStyle: "xs"
                }
            },
            lg: {
                root: {
                    px: "2",
                    minH: "6",
                    gap: "1.5",
                    "--tag-avatar-size": "spacing.4.5",
                    "--tag-element-size": "spacing.4",
                    "--tag-element-offset": "-3px"
                },
                label: {
                    textStyle: "sm"
                }
            },
            xl: {
                root: {
                    px: "2.5",
                    minH: "8",
                    gap: "1.5",
                    "--tag-avatar-size": "spacing.6",
                    "--tag-element-size": "spacing.4.5",
                    "--tag-element-offset": "-4px"
                },
                label: {
                    textStyle: "sm"
                }
            }
        },
        variant: {
            subtle: {
                root: $0f5f63a924718697$var$badgeVariant?.subtle
            },
            solid: {
                root: $0f5f63a924718697$var$badgeVariant?.solid
            },
            outline: {
                root: $0f5f63a924718697$var$badgeVariant?.outline
            },
            surface: {
                root: $0f5f63a924718697$var$badgeVariant?.surface
            }
        }
    },
    defaultVariants: {
        size: "md",
        variant: "surface"
    }
});



// src/tags-input.anatomy.ts

var $f1614ced17a277cc$export$477202748c7242bf = (0, $07b08c6ef332e8db$export$197e6e8d4b33fd6c)("tagsInput").parts("root", "label", "control", "input", "clearTrigger", "item", "itemPreview", "itemInput", "itemText", "itemDeleteTrigger");
var $f1614ced17a277cc$export$6e2410c1d27f06e7 = $f1614ced17a277cc$export$477202748c7242bf.build();


"use strict";
const $abe81f96ca3a6194$export$134c045b56c6ef6c = (0, $a2f848fc882d4d28$export$c28efc68fea5b4d6)({
    slots: (0, $f1614ced17a277cc$export$477202748c7242bf).keys(),
    className: "tags-input",
    base: {
        root: {
            display: "flex",
            flexDirection: "column",
            gap: "1.5",
            width: "full"
        },
        label: {
            fontWeight: "medium",
            textStyle: "sm",
            _disabled: {
                opacity: "0.5"
            }
        },
        control: {
            "--focus-color": "colors.colorPalette.focusRing",
            "--error-color": "colors.border.error",
            minH: "var(--tags-input-height)",
            "--input-height": "var(--tags-input-height)",
            px: "var(--tags-input-px)",
            py: "var(--tags-input-py)",
            gap: "var(--tags-input-gap)",
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            borderRadius: "l2",
            pos: "relative",
            transitionProperty: "border-color, box-shadow",
            transitionDuration: "normal",
            _disabled: {
                opacity: "0.5"
            },
            _invalid: {
                borderColor: "var(--error-color)"
            }
        },
        input: {
            flex: "1",
            minWidth: "20",
            outline: "none",
            bg: "transparent",
            color: "fg",
            px: "calc(var(--tags-input-item-px) / 1.25)",
            height: "var(--tags-input-item-height)",
            _readOnly: {
                display: "none"
            }
        },
        item: {
            maxWidth: "100%",
            minWidth: "0"
        },
        itemText: {
            lineClamp: "1",
            minWidth: "0"
        },
        itemInput: {
            outline: "none",
            bg: "transparent",
            minWidth: "2ch",
            color: "inherit",
            px: "var(--tags-input-item-px)",
            height: "var(--tags-input-item-height)"
        },
        itemPreview: {
            height: "var(--tags-input-item-height)",
            userSelect: "none",
            display: "inline-flex",
            alignItems: "center",
            gap: "1",
            rounded: "l1",
            px: "var(--tags-input-item-px)",
            maxWidth: "100%"
        },
        itemDeleteTrigger: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: "0",
            boxSize: "calc(var(--tags-input-item-height) / 1.5)",
            cursor: {
                base: "button",
                _disabled: "initial"
            },
            me: "-1",
            opacity: "0.4",
            _hover: {
                opacity: "1"
            },
            "[data-highlighted] &": {
                opacity: "1"
            },
            _icon: {
                boxSize: "80%"
            }
        },
        clearTrigger: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxSize: "calc(var(--tags-input-item-height) / 1.5)",
            cursor: {
                base: "button",
                _disabled: "initial"
            },
            color: "fg.muted",
            focusVisibleRing: "inside",
            focusRingWidth: "2px",
            rounded: "l1",
            _icon: {
                boxSize: "5"
            }
        }
    },
    variants: {
        size: {
            xs: {
                root: {
                    "--tags-input-height": "sizes.8",
                    "--tags-input-px": "spacing.1.5",
                    "--tags-input-py": "spacing.1",
                    "--tags-input-gap": "spacing.1",
                    "--tags-input-item-height": "sizes.6",
                    "--tags-input-item-px": "spacing.2",
                    textStyle: "xs"
                }
            },
            sm: {
                root: {
                    "--tags-input-height": "sizes.9",
                    "--tags-input-px": "spacing.1.5",
                    "--tags-input-py": "spacing.1",
                    "--tags-input-gap": "spacing.1",
                    "--tags-input-item-height": "sizes.6",
                    "--tags-input-item-px": "spacing.2",
                    textStyle: "sm"
                }
            },
            md: {
                root: {
                    "--tags-input-height": "sizes.10",
                    "--tags-input-px": "spacing.1.5",
                    "--tags-input-py": "spacing.1",
                    "--tags-input-gap": "spacing.1",
                    "--tags-input-item-height": "sizes.7",
                    "--tags-input-item-px": "spacing.2",
                    textStyle: "sm"
                }
            },
            lg: {
                root: {
                    "--tags-input-height": "sizes.11",
                    "--tags-input-px": "spacing.1.5",
                    "--tags-input-py": "spacing.1",
                    "--tags-input-gap": "spacing.1",
                    "--tags-input-item-height": "sizes.8",
                    "--tags-input-item-px": "spacing.2",
                    textStyle: "md"
                }
            }
        },
        variant: {
            outline: {
                control: {
                    borderWidth: "1px",
                    bg: "bg",
                    _focus: {
                        outlineWidth: "1px",
                        outlineStyle: "solid",
                        outlineColor: "var(--focus-color)",
                        borderColor: "var(--focus-color)",
                        _invalid: {
                            outlineColor: "var(--error-color)",
                            borderColor: "var(--error-color)"
                        }
                    }
                },
                itemPreview: {
                    bg: "colorPalette.subtle",
                    _highlighted: {
                        bg: "colorPalette.muted"
                    }
                }
            },
            subtle: {
                control: {
                    bg: "bg.muted",
                    borderWidth: "1px",
                    borderColor: "transparent",
                    _focus: {
                        outlineWidth: "1px",
                        outlineStyle: "solid",
                        outlineColor: "var(--focus-color)",
                        borderColor: "var(--focus-color)",
                        _invalid: {
                            outlineColor: "var(--error-color)",
                            borderColor: "var(--error-color)"
                        }
                    }
                },
                itemPreview: {
                    bg: "bg",
                    borderWidth: "1px",
                    _highlighted: {
                        bg: "colorPalette.subtle",
                        borderColor: "colorPalette.emphasized"
                    }
                }
            },
            flushed: {
                control: {
                    borderRadius: "0",
                    px: "0",
                    bg: "transparent",
                    borderBottomWidth: "1px",
                    borderBottomColor: "border",
                    _focus: {
                        borderColor: "var(--focus-color)",
                        boxShadow: "0px 1px 0px 0px var(--focus-color)"
                    }
                },
                itemPreview: {
                    bg: "colorPalette.subtle",
                    _highlighted: {
                        bg: "colorPalette.muted"
                    }
                }
            }
        }
    },
    defaultVariants: {
        size: "md",
        variant: "outline"
    }
});




"use strict";
const $65070d9b6bed5cca$export$f0ba3c1ebe09d322 = (0, $a2f848fc882d4d28$export$c28efc68fea5b4d6)({
    slots: (0, $210cc27d3a3db981$export$174cdbdedca11ecf).keys(),
    className: "chakra-timeline",
    base: {
        root: {
            display: "flex",
            flexDirection: "column",
            width: "full",
            "--timeline-thickness": "1px",
            "--timeline-gutter": "4px"
        },
        item: {
            "--timeline-content-gap": "spacing.6",
            display: "flex",
            position: "relative",
            alignItems: "flex-start",
            flexShrink: 0,
            gap: "4",
            _last: {
                "--timeline-content-gap": "0"
            }
        },
        separator: {
            display: "var(--timeline-separator-display)",
            position: "absolute",
            borderStartWidth: "var(--timeline-thickness)",
            ms: "calc(-1 * var(--timeline-thickness) / 2)",
            insetInlineStart: "calc(var(--timeline-indicator-size) / 2)",
            insetBlock: "0",
            borderColor: "border"
        },
        indicator: {
            outline: "2px solid {colors.bg}",
            position: "relative",
            flexShrink: "0",
            boxSize: "var(--timeline-indicator-size)",
            fontSize: "var(--timeline-font-size)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "full",
            fontWeight: "medium"
        },
        connector: {
            alignSelf: "stretch",
            position: "relative"
        },
        content: {
            pb: "var(--timeline-content-gap)",
            display: "flex",
            flexDirection: "column",
            width: "full",
            gap: "2"
        },
        title: {
            display: "flex",
            fontWeight: "medium",
            flexWrap: "wrap",
            gap: "1.5",
            alignItems: "center",
            mt: "var(--timeline-margin)"
        },
        description: {
            color: "fg.muted",
            textStyle: "xs"
        }
    },
    variants: {
        variant: {
            subtle: {
                indicator: {
                    bg: "colorPalette.muted"
                }
            },
            solid: {
                indicator: {
                    bg: "colorPalette.solid",
                    color: "colorPalette.contrast"
                }
            },
            outline: {
                indicator: {
                    bg: "currentBg",
                    borderWidth: "1px",
                    borderColor: "colorPalette.muted"
                }
            },
            plain: {}
        },
        showLastSeparator: {
            true: {
                item: {
                    _last: {
                        "--timeline-separator-display": "initial"
                    }
                }
            },
            false: {
                item: {
                    _last: {
                        "--timeline-separator-display": "none"
                    }
                }
            }
        },
        size: {
            sm: {
                root: {
                    "--timeline-indicator-size": "sizes.4",
                    "--timeline-font-size": "fontSizes.2xs"
                },
                title: {
                    textStyle: "xs"
                }
            },
            md: {
                root: {
                    "--timeline-indicator-size": "sizes.5",
                    "--timeline-font-size": "fontSizes.xs"
                },
                title: {
                    textStyle: "sm"
                }
            },
            lg: {
                root: {
                    "--timeline-indicator-size": "sizes.6",
                    "--timeline-font-size": "fontSizes.xs"
                },
                title: {
                    mt: "0.5",
                    textStyle: "sm"
                }
            },
            xl: {
                root: {
                    "--timeline-indicator-size": "sizes.8",
                    "--timeline-font-size": "fontSizes.sm"
                },
                title: {
                    mt: "1.5",
                    textStyle: "sm"
                }
            }
        }
    },
    defaultVariants: {
        size: "md",
        variant: "solid",
        showLastSeparator: false
    }
});




"use strict";
const $5a8f855b59dafe6e$export$a32d889916d34b1f = (0, $a2f848fc882d4d28$export$c28efc68fea5b4d6)({
    slots: (0, $210cc27d3a3db981$export$c220e6c275daf119).keys(),
    className: "chakra-toast",
    base: {
        root: {
            width: "full",
            display: "flex",
            alignItems: "flex-start",
            position: "relative",
            gap: "3",
            py: "4",
            ps: "4",
            pe: "6",
            borderRadius: "l2",
            translate: "var(--x) var(--y)",
            scale: "var(--scale)",
            zIndex: "var(--z-index)",
            height: "var(--height)",
            opacity: "var(--opacity)",
            willChange: "translate, opacity, scale",
            transition: "translate 400ms, scale 400ms, opacity 400ms, height 400ms, box-shadow 200ms",
            transitionTimingFunction: "cubic-bezier(0.21, 1.02, 0.73, 1)",
            _closed: {
                transition: "translate 400ms, scale 400ms, opacity 200ms",
                transitionTimingFunction: "cubic-bezier(0.06, 0.71, 0.55, 1)"
            },
            bg: "bg.panel",
            color: "fg",
            boxShadow: "xl",
            "--toast-trigger-bg": "colors.bg.muted",
            "&[data-type=warning]": {
                bg: "orange.solid",
                color: "orange.contrast",
                "--toast-trigger-bg": "{white/10}",
                "--toast-border-color": "{white/40}"
            },
            "&[data-type=success]": {
                bg: "green.solid",
                color: "green.contrast",
                "--toast-trigger-bg": "{white/10}",
                "--toast-border-color": "{white/40}"
            },
            "&[data-type=error]": {
                bg: "red.solid",
                color: "red.contrast",
                "--toast-trigger-bg": "{white/10}",
                "--toast-border-color": "{white/40}"
            }
        },
        title: {
            fontWeight: "medium",
            textStyle: "sm",
            marginEnd: "2"
        },
        description: {
            display: "inline",
            textStyle: "sm",
            opacity: "0.8"
        },
        indicator: {
            flexShrink: "0",
            boxSize: "5"
        },
        actionTrigger: {
            textStyle: "sm",
            fontWeight: "medium",
            height: "8",
            px: "3",
            borderRadius: "l2",
            alignSelf: "center",
            borderWidth: "1px",
            borderColor: "var(--toast-border-color, inherit)",
            transition: "background 200ms",
            _hover: {
                bg: "var(--toast-trigger-bg)"
            }
        },
        closeTrigger: {
            position: "absolute",
            top: "1",
            insetEnd: "1",
            padding: "1",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            color: "{currentColor/60}",
            borderRadius: "l2",
            textStyle: "md",
            transition: "background 200ms",
            _icon: {
                boxSize: "1em"
            }
        }
    }
});



// src/tooltip.anatomy.ts

var $39a1e5c05d00d4dc$export$477202748c7242bf = (0, $07b08c6ef332e8db$export$197e6e8d4b33fd6c)("tooltip").parts("trigger", "arrow", "arrowTip", "positioner", "content");
var $39a1e5c05d00d4dc$export$6e2410c1d27f06e7 = $39a1e5c05d00d4dc$export$477202748c7242bf.build();


"use strict";
const $0f9122396697cfc0$export$a5b861b2913e76b1 = (0, $a2f848fc882d4d28$export$c28efc68fea5b4d6)({
    slots: (0, $39a1e5c05d00d4dc$export$477202748c7242bf).keys(),
    className: "chakra-tooltip",
    base: {
        content: {
            "--tooltip-bg": "colors.bg.inverted",
            bg: "var(--tooltip-bg)",
            color: "fg.inverted",
            px: "2.5",
            py: "1",
            borderRadius: "l2",
            fontWeight: "medium",
            textStyle: "xs",
            boxShadow: "md",
            maxW: "xs",
            zIndex: "tooltip",
            transformOrigin: "var(--transform-origin)",
            _open: {
                animationStyle: "scale-fade-in",
                animationDuration: "fast"
            },
            _closed: {
                animationStyle: "scale-fade-out",
                animationDuration: "fast"
            }
        },
        arrow: {
            "--arrow-size": "sizes.2",
            "--arrow-background": "var(--tooltip-bg)"
        },
        arrowTip: {
            borderTopWidth: "1px",
            borderLeftWidth: "1px",
            borderColor: "var(--tooltip-bg)"
        }
    }
});



// src/tree-view.anatomy.ts

var $1a97b60a0c2ac349$export$477202748c7242bf = (0, $07b08c6ef332e8db$export$197e6e8d4b33fd6c)("tree-view").parts("branch", "branchContent", "branchControl", "branchIndentGuide", "branchIndicator", "branchText", "branchTrigger", "item", "itemIndicator", "itemText", "label", "nodeCheckbox", "nodeRenameInput", "root", "tree");
var $1a97b60a0c2ac349$export$6e2410c1d27f06e7 = $1a97b60a0c2ac349$export$477202748c7242bf.build();


"use strict";
const $79798f7a6ceb4cb1$var$baseItemStyle = (0, $a2f848fc882d4d28$export$9a6b93c1c4f92839)({
    display: "flex",
    alignItems: "center",
    gap: "var(--tree-item-gap)",
    rounded: "l2",
    userSelect: "none",
    position: "relative",
    "--tree-depth": "calc(var(--depth) - 1)",
    "--tree-indentation-offset": "calc(var(--tree-indentation) * var(--tree-depth))",
    "--tree-icon-offset": "calc(var(--tree-icon-size) * var(--tree-depth) * 0.5)",
    "--tree-offset": "calc(var(--tree-padding-inline) + var(--tree-indentation-offset) + var(--tree-icon-offset))",
    ps: "var(--tree-offset)",
    pe: "var(--tree-padding-inline)",
    py: "var(--tree-padding-block)",
    focusVisibleRing: "inside",
    focusRingColor: "border.emphasized",
    focusRingWidth: "2px",
    "&:hover, &:focus-visible": {
        bg: "bg.muted"
    },
    _disabled: {
        layerStyle: "disabled"
    }
});
const $79798f7a6ceb4cb1$var$baseTextStyle = (0, $a2f848fc882d4d28$export$9a6b93c1c4f92839)({
    flex: "1"
});
const $79798f7a6ceb4cb1$var$subtleVariantStyle = (0, $a2f848fc882d4d28$export$9a6b93c1c4f92839)({
    _selected: {
        bg: "colorPalette.subtle",
        color: "colorPalette.fg"
    }
});
const $79798f7a6ceb4cb1$var$solidVariantStyle = (0, $a2f848fc882d4d28$export$9a6b93c1c4f92839)({
    _selected: {
        layerStyle: "fill.solid"
    }
});
const $79798f7a6ceb4cb1$export$e2141993a0cb2125 = (0, $a2f848fc882d4d28$export$c28efc68fea5b4d6)({
    slots: (0, $1a97b60a0c2ac349$export$477202748c7242bf).keys(),
    className: "chakra-tree-view",
    base: {
        root: {
            width: "full",
            display: "flex",
            flexDirection: "column",
            gap: "2"
        },
        tree: {
            display: "flex",
            flexDirection: "column",
            "--tree-item-gap": "spacing.2",
            _icon: {
                boxSize: "var(--tree-icon-size)"
            }
        },
        label: {
            fontWeight: "medium",
            textStyle: "sm"
        },
        branch: {
            position: "relative"
        },
        branchContent: {
            position: "relative"
        },
        branchIndentGuide: {
            height: "100%",
            width: "1px",
            bg: "border",
            position: "absolute",
            "--tree-depth": "calc(var(--depth) - 1)",
            "--tree-indentation-offset": "calc(var(--tree-indentation) * var(--tree-depth))",
            "--tree-offset": "calc(var(--tree-padding-inline) + var(--tree-indentation-offset))",
            "--tree-icon-offset": "calc(var(--tree-icon-size) * 0.5 * var(--depth))",
            insetInlineStart: "calc(var(--tree-offset) + var(--tree-icon-offset))",
            zIndex: "1"
        },
        branchIndicator: {
            color: "fg.muted",
            transformOrigin: "center",
            transitionDuration: "normal",
            transitionProperty: "transform",
            transitionTimingFunction: "default",
            _open: {
                transform: "rotate(90deg)"
            }
        },
        branchTrigger: {
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center"
        },
        branchControl: $79798f7a6ceb4cb1$var$baseItemStyle,
        item: $79798f7a6ceb4cb1$var$baseItemStyle,
        itemText: $79798f7a6ceb4cb1$var$baseTextStyle,
        branchText: $79798f7a6ceb4cb1$var$baseTextStyle,
        nodeCheckbox: {
            display: "inline-flex"
        }
    },
    variants: {
        size: {
            md: {
                tree: {
                    textStyle: "sm",
                    "--tree-indentation": "spacing.4",
                    "--tree-padding-inline": "spacing.3",
                    "--tree-padding-block": "spacing.1.5",
                    "--tree-icon-size": "spacing.4"
                }
            },
            sm: {
                tree: {
                    textStyle: "sm",
                    "--tree-indentation": "spacing.4",
                    "--tree-padding-inline": "spacing.3",
                    "--tree-padding-block": "spacing.1",
                    "--tree-icon-size": "spacing.3"
                }
            },
            xs: {
                tree: {
                    textStyle: "xs",
                    "--tree-indentation": "spacing.4",
                    "--tree-padding-inline": "spacing.2",
                    "--tree-padding-block": "spacing.1",
                    "--tree-icon-size": "spacing.3"
                }
            }
        },
        variant: {
            subtle: {
                branchControl: $79798f7a6ceb4cb1$var$subtleVariantStyle,
                item: $79798f7a6ceb4cb1$var$subtleVariantStyle
            },
            solid: {
                branchControl: $79798f7a6ceb4cb1$var$solidVariantStyle,
                item: $79798f7a6ceb4cb1$var$solidVariantStyle
            }
        },
        animateContent: {
            true: {
                branchContent: {
                    _open: {
                        animationName: "expand-height, fade-in",
                        animationDuration: "moderate"
                    },
                    _closed: {
                        animationName: "collapse-height, fade-out",
                        animationDuration: "moderate"
                    }
                }
            }
        }
    },
    defaultVariants: {
        size: "md",
        variant: "subtle"
    }
});


"use strict";
const $768eea4fc9163e2f$export$5a51f768ceeb5eb3 = {
    accordion: (0, $f874c04e3d9fedcb$export$f4a442eb58b0fd05),
    actionBar: (0, $7170b8a5a618a83c$export$fa2b273b16ba8691),
    alert: (0, $23bce3028d4a0574$export$998588db5c35d89f),
    avatar: (0, $b705efe3fb62f23f$export$3abc6b3f791f1dd4),
    blockquote: (0, $247a76e2ef711f70$export$8b1f9367c4597998),
    breadcrumb: (0, $8d059d997880e84d$export$445bd218bcf49ac8),
    card: (0, $37a6087dfe9e7f76$export$e4092ce1781694ee),
    carousel: (0, $99515255363f0249$export$1a5a8bd3845f7bc6),
    checkbox: (0, $67e98e09244ed2b7$export$85054d78118eabd7),
    checkboxCard: (0, $e53d9954d2320e79$export$7450efef80368c09),
    codeBlock: (0, $6eec3e74c2da3949$export$e9293545fcf7204c),
    collapsible: (0, $d19284983fd35432$export$e9d5652bed1138b),
    dataList: (0, $f45b6a68b0b8226d$export$8a8fa4faf7e5d248),
    datePicker: (0, $354a52b3dfcff0de$export$b19dc8c348722009),
    dialog: (0, $268dcb2fd1153345$export$ffb2f7e6a3d6561c),
    drawer: (0, $36e918d5a1a24d4f$export$da2da8d2e5cdf76b),
    editable: (0, $1c43ccd7d5b19018$export$e1e8b391e6213091),
    emptyState: (0, $b6ae7c1f5ab20dd5$export$93a945b6c6bfa0fe),
    field: (0, $f8c1bd08ff93e948$export$9044d569b4a94288),
    fieldset: (0, $177deaaba632c318$export$31b1fb468e8ba73),
    fileUpload: (0, $abd71573a2368057$export$bd84411a7156c13a),
    hoverCard: (0, $bc39dc5a3ebcabba$export$2d0f90af978875ab),
    list: (0, $05c07103cf04ca2b$export$d6effa609ff73c80),
    listbox: (0, $d0386d0c989bee3f$export$380919383f821ef7),
    menu: (0, $2791cad8441971e4$export$51b7bcd215c1d4ed),
    nativeSelect: (0, $b3803ccb0ef3bb14$export$bd566e82fcc568be),
    numberInput: (0, $a302e814de7d4a66$export$a4772ecb6b3bbf82),
    pinInput: (0, $8fa8763c131de2ac$export$6ac4344d3861b231),
    popover: (0, $1d6515b880a1ce95$export$d45077169de7cc48),
    progress: (0, $9983ea69c64ddb91$export$9f977c65a046b227),
    progressCircle: (0, $329ae395a7c8fc9e$export$bf55419709f49d86),
    radioCard: (0, $498bb9db1daeeadf$export$ba1bd7ba2c203b42),
    radioGroup: (0, $5fc09042de0099f9$export$f22f9c9e9c78d451),
    ratingGroup: (0, $95865e7997a9b4a1$export$bd71218a24c0f454),
    scrollArea: (0, $e368f450dc482683$export$d777508e9bee4a37),
    segmentGroup: (0, $50bad464d90c2607$export$7b9ca3573b9e7a3e),
    select: (0, $8f19926842c66112$export$a17a1e7a6654f699),
    combobox: (0, $f4b0d0bb6b440b14$export$8fd0fff2ef925f46),
    slider: (0, $0a5d545aa14058a5$export$d46f05a25a44100c),
    splitter: (0, $084d84921709909a$export$fea3591e553a0109),
    stat: (0, $468e67f36e5bc3b6$export$49c5be1bec04cd74),
    steps: (0, $614c61576e78a7d8$export$830e54a433c6be33),
    switch: (0, $e399f463a355c2cd$export$daa01504810a732d),
    table: (0, $cdec6d33f0e9b914$export$5281e08caf496f42),
    tabs: (0, $f402e3e982e3a287$export$e5eae33afdf5ce13),
    tag: (0, $0f5f63a924718697$export$393c38caed566ad7),
    tagsInput: (0, $abe81f96ca3a6194$export$134c045b56c6ef6c),
    toast: (0, $5a8f855b59dafe6e$export$a32d889916d34b1f),
    tooltip: (0, $0f9122396697cfc0$export$a5b861b2913e76b1),
    status: (0, $1a217600f199fc5d$export$62ef19b4b5830661),
    timeline: (0, $65070d9b6bed5cca$export$f0ba3c1ebe09d322),
    colorPicker: (0, $2050d0c3bb270b24$export$e0aacfa04a4a59f3),
    qrCode: (0, $3ccb9cb1a0ad6d6b$export$8ac26324cd542d34),
    treeView: (0, $79798f7a6ceb4cb1$export$e2141993a0cb2125),
    marquee: (0, $c801133429c9449e$export$1c1ce343236229a4)
};



"use strict";
const $0a61fc1e9896a828$export$6a54c24d15b0f6ba = (0, $a2f848fc882d4d28$export$4e5d103345f1ef38)({
    "2xs": {
        value: {
            fontSize: "2xs",
            lineHeight: "0.75rem"
        }
    },
    xs: {
        value: {
            fontSize: "xs",
            lineHeight: "1rem"
        }
    },
    sm: {
        value: {
            fontSize: "sm",
            lineHeight: "1.25rem"
        }
    },
    md: {
        value: {
            fontSize: "md",
            lineHeight: "1.5rem"
        }
    },
    lg: {
        value: {
            fontSize: "lg",
            lineHeight: "1.75rem"
        }
    },
    xl: {
        value: {
            fontSize: "xl",
            lineHeight: "1.875rem"
        }
    },
    "2xl": {
        value: {
            fontSize: "2xl",
            lineHeight: "2rem"
        }
    },
    "3xl": {
        value: {
            fontSize: "3xl",
            lineHeight: "2.375rem"
        }
    },
    "4xl": {
        value: {
            fontSize: "4xl",
            lineHeight: "2.75rem",
            letterSpacing: "-0.025em"
        }
    },
    "5xl": {
        value: {
            fontSize: "5xl",
            lineHeight: "3.75rem",
            letterSpacing: "-0.025em"
        }
    },
    "6xl": {
        value: {
            fontSize: "6xl",
            lineHeight: "4.5rem",
            letterSpacing: "-0.025em"
        }
    },
    "7xl": {
        value: {
            fontSize: "7xl",
            lineHeight: "5.75rem",
            letterSpacing: "-0.025em"
        }
    },
    none: {
        value: {}
    },
    label: {
        value: {
            fontSize: "sm",
            lineHeight: "1.25rem",
            fontWeight: "medium"
        }
    }
});



"use strict";
const $24b512aa1108303b$export$7f9953c70dacfd7f = (0, $a2f848fc882d4d28$export$8e135e7aaa7aabf6).animations({
    spin: {
        value: "spin 1s linear infinite"
    },
    ping: {
        value: "ping 1s cubic-bezier(0, 0, 0.2, 1) infinite"
    },
    pulse: {
        value: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite"
    },
    bounce: {
        value: "bounce 1s infinite"
    }
});



"use strict";
const $79ee7ee3ebc1ccde$export$d81ee2a7bf2dffaa = (0, $a2f848fc882d4d28$export$8e135e7aaa7aabf6).aspectRatios({
    square: {
        value: "1 / 1"
    },
    landscape: {
        value: "4 / 3"
    },
    portrait: {
        value: "3 / 4"
    },
    wide: {
        value: "16 / 9"
    },
    ultrawide: {
        value: "18 / 5"
    },
    golden: {
        value: "1.618 / 1"
    }
});



"use strict";
const $728f35f3942953c4$export$a86789f140d190e2 = (0, $a2f848fc882d4d28$export$8e135e7aaa7aabf6).blurs({
    none: {
        value: " "
    },
    sm: {
        value: "4px"
    },
    md: {
        value: "8px"
    },
    lg: {
        value: "12px"
    },
    xl: {
        value: "16px"
    },
    "2xl": {
        value: "24px"
    },
    "3xl": {
        value: "40px"
    },
    "4xl": {
        value: "64px"
    }
});



"use strict";
const $e8d8117761b2d3da$export$5a5da632d18030b0 = (0, $a2f848fc882d4d28$export$8e135e7aaa7aabf6).borders({
    xs: {
        value: "0.5px solid"
    },
    sm: {
        value: "1px solid"
    },
    md: {
        value: "2px solid"
    },
    lg: {
        value: "4px solid"
    },
    xl: {
        value: "8px solid"
    }
});



"use strict";
const $33b1ea5e5b87d7ce$export$8f45430ccf837300 = (0, $a2f848fc882d4d28$export$8e135e7aaa7aabf6).colors({
    transparent: {
        value: "transparent"
    },
    current: {
        value: "currentColor"
    },
    black: {
        value: "#09090B"
    },
    white: {
        value: "#FFFFFF"
    },
    whiteAlpha: {
        50: {
            value: "rgba(255, 255, 255, 0.04)"
        },
        100: {
            value: "rgba(255, 255, 255, 0.06)"
        },
        200: {
            value: "rgba(255, 255, 255, 0.08)"
        },
        300: {
            value: "rgba(255, 255, 255, 0.16)"
        },
        400: {
            value: "rgba(255, 255, 255, 0.24)"
        },
        500: {
            value: "rgba(255, 255, 255, 0.36)"
        },
        600: {
            value: "rgba(255, 255, 255, 0.48)"
        },
        700: {
            value: "rgba(255, 255, 255, 0.64)"
        },
        800: {
            value: "rgba(255, 255, 255, 0.80)"
        },
        900: {
            value: "rgba(255, 255, 255, 0.92)"
        },
        950: {
            value: "rgba(255, 255, 255, 0.95)"
        }
    },
    blackAlpha: {
        50: {
            value: "rgba(0, 0, 0, 0.04)"
        },
        100: {
            value: "rgba(0, 0, 0, 0.06)"
        },
        200: {
            value: "rgba(0, 0, 0, 0.08)"
        },
        300: {
            value: "rgba(0, 0, 0, 0.16)"
        },
        400: {
            value: "rgba(0, 0, 0, 0.24)"
        },
        500: {
            value: "rgba(0, 0, 0, 0.36)"
        },
        600: {
            value: "rgba(0, 0, 0, 0.48)"
        },
        700: {
            value: "rgba(0, 0, 0, 0.64)"
        },
        800: {
            value: "rgba(0, 0, 0, 0.80)"
        },
        900: {
            value: "rgba(0, 0, 0, 0.92)"
        },
        950: {
            value: "rgba(0, 0, 0, 0.95)"
        }
    },
    gray: {
        50: {
            value: "#fafafa"
        },
        100: {
            value: "#f4f4f5"
        },
        200: {
            value: "#e4e4e7"
        },
        300: {
            value: "#d4d4d8"
        },
        400: {
            value: "#a1a1aa"
        },
        500: {
            value: "#71717a"
        },
        600: {
            value: "#52525b"
        },
        700: {
            value: "#3f3f46"
        },
        800: {
            value: "#27272a"
        },
        900: {
            value: "#18181b"
        },
        950: {
            value: "#111111"
        }
    },
    red: {
        50: {
            value: "#fef2f2"
        },
        100: {
            value: "#fee2e2"
        },
        200: {
            value: "#fecaca"
        },
        300: {
            value: "#fca5a5"
        },
        400: {
            value: "#f87171"
        },
        500: {
            value: "#ef4444"
        },
        600: {
            value: "#dc2626"
        },
        700: {
            value: "#991919"
        },
        800: {
            value: "#511111"
        },
        900: {
            value: "#300c0c"
        },
        950: {
            value: "#1f0808"
        }
    },
    orange: {
        50: {
            value: "#fff7ed"
        },
        100: {
            value: "#ffedd5"
        },
        200: {
            value: "#fed7aa"
        },
        300: {
            value: "#fdba74"
        },
        400: {
            value: "#fb923c"
        },
        500: {
            value: "#f97316"
        },
        600: {
            value: "#ea580c"
        },
        700: {
            value: "#92310a"
        },
        800: {
            value: "#6c2710"
        },
        900: {
            value: "#3b1106"
        },
        950: {
            value: "#220a04"
        }
    },
    yellow: {
        50: {
            value: "#fefce8"
        },
        100: {
            value: "#fef9c3"
        },
        200: {
            value: "#fef08a"
        },
        300: {
            value: "#fde047"
        },
        400: {
            value: "#facc15"
        },
        500: {
            value: "#eab308"
        },
        600: {
            value: "#ca8a04"
        },
        700: {
            value: "#845209"
        },
        800: {
            value: "#713f12"
        },
        900: {
            value: "#422006"
        },
        950: {
            value: "#281304"
        }
    },
    green: {
        50: {
            value: "#f0fdf4"
        },
        100: {
            value: "#dcfce7"
        },
        200: {
            value: "#bbf7d0"
        },
        300: {
            value: "#86efac"
        },
        400: {
            value: "#4ade80"
        },
        500: {
            value: "#22c55e"
        },
        600: {
            value: "#16a34a"
        },
        700: {
            value: "#116932"
        },
        800: {
            value: "#124a28"
        },
        900: {
            value: "#042713"
        },
        950: {
            value: "#03190c"
        }
    },
    teal: {
        50: {
            value: "#f0fdfa"
        },
        100: {
            value: "#ccfbf1"
        },
        200: {
            value: "#99f6e4"
        },
        300: {
            value: "#5eead4"
        },
        400: {
            value: "#2dd4bf"
        },
        500: {
            value: "#14b8a6"
        },
        600: {
            value: "#0d9488"
        },
        700: {
            value: "#0c5d56"
        },
        800: {
            value: "#114240"
        },
        900: {
            value: "#032726"
        },
        950: {
            value: "#021716"
        }
    },
    blue: {
        50: {
            value: "#eff6ff"
        },
        100: {
            value: "#dbeafe"
        },
        200: {
            value: "#bfdbfe"
        },
        300: {
            value: "#a3cfff"
        },
        400: {
            value: "#60a5fa"
        },
        500: {
            value: "#3b82f6"
        },
        600: {
            value: "#2563eb"
        },
        700: {
            value: "#173da6"
        },
        800: {
            value: "#1a3478"
        },
        900: {
            value: "#14204a"
        },
        950: {
            value: "#0c142e"
        }
    },
    cyan: {
        50: {
            value: "#ecfeff"
        },
        100: {
            value: "#cffafe"
        },
        200: {
            value: "#a5f3fc"
        },
        300: {
            value: "#67e8f9"
        },
        400: {
            value: "#22d3ee"
        },
        500: {
            value: "#06b6d4"
        },
        600: {
            value: "#0891b2"
        },
        700: {
            value: "#0c5c72"
        },
        800: {
            value: "#134152"
        },
        900: {
            value: "#072a38"
        },
        950: {
            value: "#051b24"
        }
    },
    purple: {
        50: {
            value: "#faf5ff"
        },
        100: {
            value: "#f3e8ff"
        },
        200: {
            value: "#e9d5ff"
        },
        300: {
            value: "#d8b4fe"
        },
        400: {
            value: "#c084fc"
        },
        500: {
            value: "#a855f7"
        },
        600: {
            value: "#9333ea"
        },
        700: {
            value: "#641ba3"
        },
        800: {
            value: "#4a1772"
        },
        900: {
            value: "#2f0553"
        },
        950: {
            value: "#1a032e"
        }
    },
    pink: {
        50: {
            value: "#fdf2f8"
        },
        100: {
            value: "#fce7f3"
        },
        200: {
            value: "#fbcfe8"
        },
        300: {
            value: "#f9a8d4"
        },
        400: {
            value: "#f472b6"
        },
        500: {
            value: "#ec4899"
        },
        600: {
            value: "#db2777"
        },
        700: {
            value: "#a41752"
        },
        800: {
            value: "#6d0e34"
        },
        900: {
            value: "#45061f"
        },
        950: {
            value: "#2c0514"
        }
    }
});



"use strict";
const $a9536c2906a96ea9$export$58734539bbfa41a2 = (0, $a2f848fc882d4d28$export$8e135e7aaa7aabf6).cursor({
    button: {
        value: "pointer"
    },
    checkbox: {
        value: "default"
    },
    disabled: {
        value: "not-allowed"
    },
    menuitem: {
        value: "default"
    },
    option: {
        value: "default"
    },
    radio: {
        value: "default"
    },
    slider: {
        value: "default"
    },
    switch: {
        value: "pointer"
    }
});



"use strict";
const $bd3afdab9df13ac3$export$38b928a7167ce124 = (0, $a2f848fc882d4d28$export$8e135e7aaa7aabf6).durations({
    fastest: {
        value: "50ms"
    },
    faster: {
        value: "100ms"
    },
    fast: {
        value: "150ms"
    },
    moderate: {
        value: "200ms"
    },
    slow: {
        value: "300ms"
    },
    slower: {
        value: "400ms"
    },
    slowest: {
        value: "500ms"
    }
});



"use strict";
const $6959adc14d8fe6a9$export$15a0bf1b4bbacad8 = (0, $a2f848fc882d4d28$export$8e135e7aaa7aabf6).easings({
    "ease-in": {
        value: "cubic-bezier(0.42, 0, 1, 1)"
    },
    "ease-out": {
        value: "cubic-bezier(0, 0, 0.58, 1)"
    },
    "ease-in-out": {
        value: "cubic-bezier(0.42, 0, 0.58, 1)"
    },
    "ease-in-smooth": {
        value: "cubic-bezier(0.32, 0.72, 0, 1)"
    }
});



"use strict";
const $2b79fb9ee0dc88da$export$67baea80019ff381 = (0, $a2f848fc882d4d28$export$8e135e7aaa7aabf6).fontSizes({
    "2xs": {
        value: "0.625rem"
    },
    xs: {
        value: "0.75rem"
    },
    sm: {
        value: "0.875rem"
    },
    md: {
        value: "1rem"
    },
    lg: {
        value: "1.125rem"
    },
    xl: {
        value: "1.25rem"
    },
    "2xl": {
        value: "1.5rem"
    },
    "3xl": {
        value: "1.875rem"
    },
    "4xl": {
        value: "2.25rem"
    },
    "5xl": {
        value: "3rem"
    },
    "6xl": {
        value: "3.75rem"
    },
    "7xl": {
        value: "4.5rem"
    },
    "8xl": {
        value: "6rem"
    },
    "9xl": {
        value: "8rem"
    }
});



"use strict";
const $5521aac0078958d7$export$59230918eb9bd861 = (0, $a2f848fc882d4d28$export$8e135e7aaa7aabf6).fontWeights({
    thin: {
        value: "100"
    },
    extralight: {
        value: "200"
    },
    light: {
        value: "300"
    },
    normal: {
        value: "400"
    },
    medium: {
        value: "500"
    },
    semibold: {
        value: "600"
    },
    bold: {
        value: "700"
    },
    extrabold: {
        value: "800"
    },
    black: {
        value: "900"
    }
});



"use strict";
const $14fafb0d78b5039b$var$fallback = `-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`;
const $14fafb0d78b5039b$export$f45fbea8fe20ca8a = (0, $a2f848fc882d4d28$export$8e135e7aaa7aabf6).fonts({
    heading: {
        value: `Inter, ${$14fafb0d78b5039b$var$fallback}`
    },
    body: {
        value: `Inter, ${$14fafb0d78b5039b$var$fallback}`
    },
    mono: {
        value: `SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace`
    }
});



"use strict";
const $1024dd04cf01d565$export$d25ddfdf17c3ad3e = (0, $a2f848fc882d4d28$export$900dac1a2cda17d7)({
    spin: {
        "0%": {
            transform: "rotate(0deg)"
        },
        "100%": {
            transform: "rotate(360deg)"
        }
    },
    pulse: {
        "50%": {
            opacity: "0.5"
        }
    },
    ping: {
        "75%, 100%": {
            transform: "scale(2)",
            opacity: "0"
        }
    },
    bounce: {
        "0%, 100%": {
            transform: "translateY(-25%)",
            animationTimingFunction: "cubic-bezier(0.8,0,1,1)"
        },
        "50%": {
            transform: "none",
            animationTimingFunction: "cubic-bezier(0,0,0.2,1)"
        }
    },
    "bg-position": {
        from: {
            backgroundPosition: "var(--animate-from, 1rem) 0"
        },
        to: {
            backgroundPosition: "var(--animate-to, 0) 0"
        }
    },
    position: {
        from: {
            insetInlineStart: "var(--animate-from-x)",
            insetBlockStart: "var(--animate-from-y)"
        },
        to: {
            insetInlineStart: "var(--animate-to-x)",
            insetBlockStart: "var(--animate-to-y)"
        }
    },
    "circular-progress": {
        "0%": {
            strokeDasharray: "1, 400",
            strokeDashoffset: "0"
        },
        "50%": {
            strokeDasharray: "400, 400",
            strokeDashoffset: "-100%"
        },
        "100%": {
            strokeDasharray: "400, 400",
            strokeDashoffset: "-260%"
        }
    },
    // collapse
    "expand-height": {
        from: {
            height: "var(--collapsed-height, 0)"
        },
        to: {
            height: "var(--height)"
        }
    },
    "collapse-height": {
        from: {
            height: "var(--height)"
        },
        to: {
            height: "var(--collapsed-height, 0)"
        }
    },
    "expand-width": {
        from: {
            width: "var(--collapsed-width, 0)"
        },
        to: {
            width: "var(--width)"
        }
    },
    "collapse-width": {
        from: {
            width: "var(--width)"
        },
        to: {
            width: "var(--collapsed-width, 0)"
        }
    },
    // fade
    "fade-in": {
        from: {
            opacity: 0
        },
        to: {
            opacity: 1
        }
    },
    "fade-out": {
        from: {
            opacity: 1
        },
        to: {
            opacity: 0
        }
    },
    // slide from (full)
    "slide-from-left-full": {
        from: {
            translate: "-100% 0"
        },
        to: {
            translate: "0 0"
        }
    },
    "slide-from-right-full": {
        from: {
            translate: "100% 0"
        },
        to: {
            translate: "0 0"
        }
    },
    "slide-from-top-full": {
        from: {
            translate: "0 -100%"
        },
        to: {
            translate: "0 0"
        }
    },
    "slide-from-bottom-full": {
        from: {
            translate: "0 100%"
        },
        to: {
            translate: "0 0"
        }
    },
    // slide to (full)
    "slide-to-left-full": {
        from: {
            translate: "0 0"
        },
        to: {
            translate: "-100% 0"
        }
    },
    "slide-to-right-full": {
        from: {
            translate: "0 0"
        },
        to: {
            translate: "100% 0"
        }
    },
    "slide-to-top-full": {
        from: {
            translate: "0 0"
        },
        to: {
            translate: "0 -100%"
        }
    },
    "slide-to-bottom-full": {
        from: {
            translate: "0 0"
        },
        to: {
            translate: "0 100%"
        }
    },
    // slide from
    "slide-from-top": {
        "0%": {
            translate: "0 calc(var(--slide-from-top-distance, 0.5rem) * -1)"
        },
        to: {
            translate: "0"
        }
    },
    "slide-from-bottom": {
        "0%": {
            translate: "0 var(--slide-from-bottom-distance, 0.5rem)"
        },
        to: {
            translate: "0"
        }
    },
    "slide-from-left": {
        "0%": {
            translate: "calc(var(--slide-from-left-distance, 0.5rem) * -1) 0"
        },
        to: {
            translate: "0"
        }
    },
    "slide-from-right": {
        "0%": {
            translate: "var(--slide-from-right-distance, 0.5rem) 0"
        },
        to: {
            translate: "0"
        }
    },
    // slide to
    "slide-to-top": {
        "0%": {
            translate: "0"
        },
        to: {
            translate: "0 calc(var(--slide-to-top-distance, 0.5rem) * -1)"
        }
    },
    "slide-to-bottom": {
        "0%": {
            translate: "0"
        },
        to: {
            translate: "0 var(--slide-to-bottom-distance, 0.5rem)"
        }
    },
    "slide-to-left": {
        "0%": {
            translate: "0"
        },
        to: {
            translate: "calc(var(--slide-to-left-distance, 0.5rem) * -1) 0"
        }
    },
    "slide-to-right": {
        "0%": {
            translate: "0"
        },
        to: {
            translate: "var(--slide-to-right-distance, 0.5rem) 0"
        }
    },
    // scale
    "scale-in": {
        from: {
            scale: "0.95"
        },
        to: {
            scale: "1"
        }
    },
    "scale-out": {
        from: {
            scale: "1"
        },
        to: {
            scale: "0.95"
        }
    },
    // marquee
    marqueeX: {
        from: {
            transform: "translateX(0%)"
        },
        to: {
            transform: "translateX(var(--marquee-translate))"
        }
    },
    marqueeY: {
        from: {
            transform: "translateY(0%)"
        },
        to: {
            transform: "translateY(var(--marquee-translate))"
        }
    }
});



"use strict";
const $60fc2855d0bdad12$export$b74e30ebb52682da = (0, $a2f848fc882d4d28$export$8e135e7aaa7aabf6).letterSpacings({
    tighter: {
        value: "-0.05em"
    },
    tight: {
        value: "-0.025em"
    },
    wide: {
        value: "0.025em"
    },
    wider: {
        value: "0.05em"
    },
    widest: {
        value: "0.1em"
    }
});



"use strict";
const $a4ef4b16d28cf02b$export$e646ed6b629bf51e = (0, $a2f848fc882d4d28$export$8e135e7aaa7aabf6).lineHeights({
    shorter: {
        value: 1.25
    },
    short: {
        value: 1.375
    },
    moderate: {
        value: 1.5
    },
    tall: {
        value: 1.625
    },
    taller: {
        value: 2
    }
});



"use strict";
const $04071ff68d1643e0$export$18f838d5aba6962a = (0, $a2f848fc882d4d28$export$8e135e7aaa7aabf6).radii({
    none: {
        value: "0"
    },
    "2xs": {
        value: "0.0625rem"
    },
    xs: {
        value: "0.125rem"
    },
    sm: {
        value: "0.25rem"
    },
    md: {
        value: "0.375rem"
    },
    lg: {
        value: "0.5rem"
    },
    xl: {
        value: "0.75rem"
    },
    "2xl": {
        value: "1rem"
    },
    "3xl": {
        value: "1.5rem"
    },
    "4xl": {
        value: "2rem"
    },
    full: {
        value: "9999px"
    }
});




"use strict";
const $f560bf78c9aa89f0$export$5458b64234d1333c = (0, $a2f848fc882d4d28$export$8e135e7aaa7aabf6).spacing({
    0.5: {
        value: "0.125rem"
    },
    1: {
        value: "0.25rem"
    },
    1.5: {
        value: "0.375rem"
    },
    2: {
        value: "0.5rem"
    },
    2.5: {
        value: "0.625rem"
    },
    3: {
        value: "0.75rem"
    },
    3.5: {
        value: "0.875rem"
    },
    4: {
        value: "1rem"
    },
    4.5: {
        value: "1.125rem"
    },
    5: {
        value: "1.25rem"
    },
    6: {
        value: "1.5rem"
    },
    7: {
        value: "1.75rem"
    },
    8: {
        value: "2rem"
    },
    9: {
        value: "2.25rem"
    },
    10: {
        value: "2.5rem"
    },
    11: {
        value: "2.75rem"
    },
    12: {
        value: "3rem"
    },
    14: {
        value: "3.5rem"
    },
    16: {
        value: "4rem"
    },
    20: {
        value: "5rem"
    },
    24: {
        value: "6rem"
    },
    28: {
        value: "7rem"
    },
    32: {
        value: "8rem"
    },
    36: {
        value: "9rem"
    },
    40: {
        value: "10rem"
    },
    44: {
        value: "11rem"
    },
    48: {
        value: "12rem"
    },
    52: {
        value: "13rem"
    },
    56: {
        value: "14rem"
    },
    60: {
        value: "15rem"
    },
    64: {
        value: "16rem"
    },
    72: {
        value: "18rem"
    },
    80: {
        value: "20rem"
    },
    96: {
        value: "24rem"
    }
});


"use strict";
const $a049b4439767189d$var$largeSizes = (0, $a2f848fc882d4d28$export$8e135e7aaa7aabf6).sizes({
    "3xs": {
        value: "14rem"
    },
    "2xs": {
        value: "16rem"
    },
    xs: {
        value: "20rem"
    },
    sm: {
        value: "24rem"
    },
    md: {
        value: "28rem"
    },
    lg: {
        value: "32rem"
    },
    xl: {
        value: "36rem"
    },
    "2xl": {
        value: "42rem"
    },
    "3xl": {
        value: "48rem"
    },
    "4xl": {
        value: "56rem"
    },
    "5xl": {
        value: "64rem"
    },
    "6xl": {
        value: "72rem"
    },
    "7xl": {
        value: "80rem"
    },
    "8xl": {
        value: "90rem"
    }
});
const $a049b4439767189d$var$namedSizes = (0, $a2f848fc882d4d28$export$8e135e7aaa7aabf6).sizes({
    max: {
        value: "max-content"
    },
    min: {
        value: "min-content"
    },
    fit: {
        value: "fit-content"
    },
    prose: {
        value: "60ch"
    },
    full: {
        value: "100%"
    },
    dvh: {
        value: "100dvh"
    },
    svh: {
        value: "100svh"
    },
    lvh: {
        value: "100lvh"
    },
    dvw: {
        value: "100dvw"
    },
    svw: {
        value: "100svw"
    },
    lvw: {
        value: "100lvw"
    },
    vw: {
        value: "100vw"
    },
    vh: {
        value: "100vh"
    }
});
const $a049b4439767189d$var$fractionalSizes = (0, $a2f848fc882d4d28$export$8e135e7aaa7aabf6).sizes({
    "1/2": {
        value: "50%"
    },
    "1/3": {
        value: "33.333333%"
    },
    "2/3": {
        value: "66.666667%"
    },
    "1/4": {
        value: "25%"
    },
    "3/4": {
        value: "75%"
    },
    "1/5": {
        value: "20%"
    },
    "2/5": {
        value: "40%"
    },
    "3/5": {
        value: "60%"
    },
    "4/5": {
        value: "80%"
    },
    "1/6": {
        value: "16.666667%"
    },
    "2/6": {
        value: "33.333333%"
    },
    "3/6": {
        value: "50%"
    },
    "4/6": {
        value: "66.666667%"
    },
    "5/6": {
        value: "83.333333%"
    },
    "1/12": {
        value: "8.333333%"
    },
    "2/12": {
        value: "16.666667%"
    },
    "3/12": {
        value: "25%"
    },
    "4/12": {
        value: "33.333333%"
    },
    "5/12": {
        value: "41.666667%"
    },
    "6/12": {
        value: "50%"
    },
    "7/12": {
        value: "58.333333%"
    },
    "8/12": {
        value: "66.666667%"
    },
    "9/12": {
        value: "75%"
    },
    "10/12": {
        value: "83.333333%"
    },
    "11/12": {
        value: "91.666667%"
    }
});
const $a049b4439767189d$export$c647cb0ee6e282fe = (0, $a2f848fc882d4d28$export$8e135e7aaa7aabf6).sizes({
    ...$a049b4439767189d$var$largeSizes,
    ...(0, $f560bf78c9aa89f0$export$5458b64234d1333c),
    ...$a049b4439767189d$var$fractionalSizes,
    ...$a049b4439767189d$var$namedSizes
});




"use strict";
const $87535924b6c742fd$export$a01878c2d95345c0 = (0, $a2f848fc882d4d28$export$8e135e7aaa7aabf6).zIndex({
    hide: {
        value: -1
    },
    base: {
        value: 0
    },
    docked: {
        value: 10
    },
    dropdown: {
        value: 1e3
    },
    sticky: {
        value: 1100
    },
    banner: {
        value: 1200
    },
    overlay: {
        value: 1300
    },
    modal: {
        value: 1400
    },
    popover: {
        value: 1500
    },
    skipNav: {
        value: 1600
    },
    toast: {
        value: 1700
    },
    tooltip: {
        value: 1800
    },
    max: {
        value: 2147483647
    }
});












































































"use strict";
const $bcb7628c8147fe10$export$6ad93df59e712c43 = {
    aspectRatios: $79ee7ee3ebc1ccde$export$d81ee2a7bf2dffaa,
    animations: $24b512aa1108303b$export$7f9953c70dacfd7f,
    blurs: $728f35f3942953c4$export$a86789f140d190e2,
    borders: $e8d8117761b2d3da$export$5a5da632d18030b0,
    colors: $33b1ea5e5b87d7ce$export$8f45430ccf837300,
    durations: $bd3afdab9df13ac3$export$38b928a7167ce124,
    easings: $6959adc14d8fe6a9$export$15a0bf1b4bbacad8,
    fonts: $14fafb0d78b5039b$export$f45fbea8fe20ca8a,
    fontSizes: $2b79fb9ee0dc88da$export$67baea80019ff381,
    fontWeights: $5521aac0078958d7$export$59230918eb9bd861,
    letterSpacings: $60fc2855d0bdad12$export$b74e30ebb52682da,
    lineHeights: $a4ef4b16d28cf02b$export$e646ed6b629bf51e,
    radii: $04071ff68d1643e0$export$18f838d5aba6962a,
    spacing: $f560bf78c9aa89f0$export$5458b64234d1333c,
    sizes: $a049b4439767189d$export$c647cb0ee6e282fe,
    zIndex: (0, $87535924b6c742fd$export$a01878c2d95345c0),
    cursor: $a9536c2906a96ea9$export$58734539bbfa41a2
};
const $bcb7628c8147fe10$export$c1b409c4e1d33fce = {
    colors: (0, $2f101dfb3da4f32e$export$bba894c3986a1bd6),
    shadows: (0, $fa075a3de6b27d92$export$be8678bc2461c05b),
    radii: (0, $3bf902b2a4cd1ab9$export$9a35918a914a3cfd)
};
const $bcb7628c8147fe10$export$1c905876df607927 = "chakra";
const $bcb7628c8147fe10$export$50f5fb7a47ef358d = ":where(html, .chakra-theme)";
const $bcb7628c8147fe10$export$a9c3b64d72246606 = (0, $a2f848fc882d4d28$export$9e20b617fd74b180)({
    preflight: true,
    cssVarsPrefix: $bcb7628c8147fe10$export$1c905876df607927,
    cssVarsRoot: $bcb7628c8147fe10$export$50f5fb7a47ef358d,
    globalCss: $c4410a2f6e7f0a22$export$db53682eef82cc11,
    theme: {
        breakpoints: $395641f3954e06c3$export$d07517a676ce386f,
        keyframes: $1024dd04cf01d565$export$d25ddfdf17c3ad3e,
        tokens: $bcb7628c8147fe10$export$6ad93df59e712c43,
        semanticTokens: $bcb7628c8147fe10$export$c1b409c4e1d33fce,
        recipes: $4b950c49fa0a5c48$export$fa74c78a0037e9df,
        slotRecipes: $768eea4fc9163e2f$export$5a51f768ceeb5eb3,
        textStyles: $0a61fc1e9896a828$export$6a54c24d15b0f6ba,
        layerStyles: $d30bdef3420e3f5f$export$c5ce54c56ca9d603,
        animationStyles: $58c09e14a071fe94$export$af3299cdb043c88c
    }
});


"use strict";
const $d96278a3ee190ff4$export$f84bd70098573c5c = (0, $e640443c3aa20e5d$export$5d86b86a654a7039)((0, $d843b0ee0da0e462$export$68b8fa3a393a40ba), (0, $bcb7628c8147fe10$export$a9c3b64d72246606));
const $d96278a3ee190ff4$export$696a1c03ebc75055 = (0, $39d60cdb5c92c6d4$export$b06ab6dfae3e7e3)($d96278a3ee190ff4$export$f84bd70098573c5c);




function $8936f896c18fae91$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $3e402af6c1df600a$export$2e2bcd8739ae039(t, e) {
    return $3e402af6c1df600a$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $3e402af6c1df600a$export$2e2bcd8739ae039(t, e);
}


function $83bdfc144528e1e5$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $3e402af6c1df600a$export$2e2bcd8739ae039)(t, o);
}


function $53a741574f109c42$export$2e2bcd8739ae039(t) {
    return $53a741574f109c42$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $53a741574f109c42$export$2e2bcd8739ae039(t);
}



function $3801ec5cbb6ef197$export$2e2bcd8739ae039(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}


function $ed6a999545bb9645$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($ed6a999545bb9645$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}



function $7aaacdece758a983$export$2e2bcd8739ae039(t, e, r) {
    if ((0, $ed6a999545bb9645$export$2e2bcd8739ae039)()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && (0, $3e402af6c1df600a$export$2e2bcd8739ae039)(p, r.prototype), p;
}


function $8d007ef8f92c1f83$export$2e2bcd8739ae039(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return $8d007ef8f92c1f83$export$2e2bcd8739ae039 = function _wrapNativeSuper(t) {
        if (null === t || !(0, $3801ec5cbb6ef197$export$2e2bcd8739ae039)(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return (0, $7aaacdece758a983$export$2e2bcd8739ae039)(t, arguments, (0, $53a741574f109c42$export$2e2bcd8739ae039)(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), (0, $3e402af6c1df600a$export$2e2bcd8739ae039)(Wrapper, t);
    }, $8d007ef8f92c1f83$export$2e2bcd8739ae039(t);
}


function $b828f41498135548$export$2e2bcd8739ae039(e, t) {
    return t || (t = e.slice(0)), e.raw = t, e;
}


function $e4334fe97365ceb5$var$last() {
    var _ref;
    return _ref = arguments.length - 1, _ref < 0 || arguments.length <= _ref ? undefined : arguments[_ref];
}
function $e4334fe97365ceb5$var$negation(a) {
    return -a;
}
function $e4334fe97365ceb5$var$addition(a, b) {
    return a + b;
}
function $e4334fe97365ceb5$var$subtraction(a, b) {
    return a - b;
}
function $e4334fe97365ceb5$var$multiplication(a, b) {
    return a * b;
}
function $e4334fe97365ceb5$var$division(a, b) {
    return a / b;
}
function $e4334fe97365ceb5$var$max() {
    return Math.max.apply(Math, arguments);
}
function $e4334fe97365ceb5$var$min() {
    return Math.min.apply(Math, arguments);
}
function $e4334fe97365ceb5$var$comma() {
    return Array.of.apply(Array, arguments);
}
var $e4334fe97365ceb5$var$defaultSymbols = {
    symbols: {
        '*': {
            infix: {
                symbol: '*',
                f: $e4334fe97365ceb5$var$multiplication,
                notation: 'infix',
                precedence: 4,
                rightToLeft: 0,
                argCount: 2
            },
            symbol: '*',
            regSymbol: '\\*'
        },
        '/': {
            infix: {
                symbol: '/',
                f: $e4334fe97365ceb5$var$division,
                notation: 'infix',
                precedence: 4,
                rightToLeft: 0,
                argCount: 2
            },
            symbol: '/',
            regSymbol: '/'
        },
        '+': {
            infix: {
                symbol: '+',
                f: $e4334fe97365ceb5$var$addition,
                notation: 'infix',
                precedence: 2,
                rightToLeft: 0,
                argCount: 2
            },
            prefix: {
                symbol: '+',
                f: $e4334fe97365ceb5$var$last,
                notation: 'prefix',
                precedence: 3,
                rightToLeft: 0,
                argCount: 1
            },
            symbol: '+',
            regSymbol: '\\+'
        },
        '-': {
            infix: {
                symbol: '-',
                f: $e4334fe97365ceb5$var$subtraction,
                notation: 'infix',
                precedence: 2,
                rightToLeft: 0,
                argCount: 2
            },
            prefix: {
                symbol: '-',
                f: $e4334fe97365ceb5$var$negation,
                notation: 'prefix',
                precedence: 3,
                rightToLeft: 0,
                argCount: 1
            },
            symbol: '-',
            regSymbol: '-'
        },
        ',': {
            infix: {
                symbol: ',',
                f: $e4334fe97365ceb5$var$comma,
                notation: 'infix',
                precedence: 1,
                rightToLeft: 0,
                argCount: 2
            },
            symbol: ',',
            regSymbol: ','
        },
        '(': {
            prefix: {
                symbol: '(',
                f: $e4334fe97365ceb5$var$last,
                notation: 'prefix',
                precedence: 0,
                rightToLeft: 0,
                argCount: 1
            },
            symbol: '(',
            regSymbol: '\\('
        },
        ')': {
            postfix: {
                symbol: ')',
                f: undefined,
                notation: 'postfix',
                precedence: 0,
                rightToLeft: 0,
                argCount: 1
            },
            symbol: ')',
            regSymbol: '\\)'
        },
        min: {
            func: {
                symbol: 'min',
                f: $e4334fe97365ceb5$var$min,
                notation: 'func',
                precedence: 0,
                rightToLeft: 0,
                argCount: 1
            },
            symbol: 'min',
            regSymbol: 'min\\b'
        },
        max: {
            func: {
                symbol: 'max',
                f: $e4334fe97365ceb5$var$max,
                notation: 'func',
                precedence: 0,
                rightToLeft: 0,
                argCount: 1
            },
            symbol: 'max',
            regSymbol: 'max\\b'
        }
    }
};
var $e4334fe97365ceb5$var$defaultSymbolMap = $e4334fe97365ceb5$var$defaultSymbols;
// based on https://github.com/styled-components/styled-components/blob/fcf6f3804c57a14dd7984dfab7bc06ee2edca044/src/utils/error.js
/**
 * Parse errors.md and turn it into a simple hash of code: message
 * @private
 */ var $e4334fe97365ceb5$var$ERRORS = {
    "1": "Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).\n\n",
    "2": "Passed invalid arguments to hsla, please pass multiple numbers e.g. hsla(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).\n\n",
    "3": "Passed an incorrect argument to a color function, please pass a string representation of a color.\n\n",
    "4": "Couldn't generate valid rgb string from %s, it returned %s.\n\n",
    "5": "Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.\n\n",
    "6": "Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).\n\n",
    "7": "Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).\n\n",
    "8": "Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.\n\n",
    "9": "Please provide a number of steps to the modularScale helper.\n\n",
    "10": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
    "11": "Invalid value passed as base to modularScale, expected number or em string but got \"%s\"\n\n",
    "12": "Expected a string ending in \"px\" or a number passed as the first argument to %s(), got \"%s\" instead.\n\n",
    "13": "Expected a string ending in \"px\" or a number passed as the second argument to %s(), got \"%s\" instead.\n\n",
    "14": "Passed invalid pixel value (\"%s\") to %s(), please pass a value like \"12px\" or 12.\n\n",
    "15": "Passed invalid base value (\"%s\") to %s(), please pass a value like \"12px\" or 12.\n\n",
    "16": "You must provide a template to this method.\n\n",
    "17": "You passed an unsupported selector state to this method.\n\n",
    "18": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
    "19": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
    "20": "expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
    "21": "expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
    "22": "expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
    "23": "fontFace expects a name of a font-family.\n\n",
    "24": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
    "25": "fontFace expects localFonts to be an array.\n\n",
    "26": "fontFace expects fileFormats to be an array.\n\n",
    "27": "radialGradient requries at least 2 color-stops to properly render.\n\n",
    "28": "Please supply a filename to retinaImage() as the first argument.\n\n",
    "29": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
    "30": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
    "31": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation\n\n",
    "32": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')\n\n",
    "33": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation\n\n",
    "34": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
    "35": "borderRadius expects one of \"top\", \"bottom\", \"left\" or \"right\" as the first argument.\n\n",
    "36": "Property must be a string value.\n\n",
    "37": "Syntax Error at %s.\n\n",
    "38": "Formula contains a function that needs parentheses at %s.\n\n",
    "39": "Formula is missing closing parenthesis at %s.\n\n",
    "40": "Formula has too many closing parentheses at %s.\n\n",
    "41": "All values in a formula must have the same unit or be unitless.\n\n",
    "42": "Please provide a number of steps to the modularScale helper.\n\n",
    "43": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
    "44": "Invalid value passed as base to modularScale, expected number or em/rem string but got %s.\n\n",
    "45": "Passed invalid argument to hslToColorString, please pass a HslColor or HslaColor object.\n\n",
    "46": "Passed invalid argument to rgbToColorString, please pass a RgbColor or RgbaColor object.\n\n",
    "47": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
    "48": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
    "49": "Expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
    "50": "Expects the objects in the first argument array to have the properties prop, fromSize, and toSize.\n\n",
    "51": "Expects the first argument object to have the properties prop, fromSize, and toSize.\n\n",
    "52": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
    "53": "fontFace expects localFonts to be an array.\n\n",
    "54": "fontFace expects fileFormats to be an array.\n\n",
    "55": "fontFace expects a name of a font-family.\n\n",
    "56": "linearGradient requries at least 2 color-stops to properly render.\n\n",
    "57": "radialGradient requries at least 2 color-stops to properly render.\n\n",
    "58": "Please supply a filename to retinaImage() as the first argument.\n\n",
    "59": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
    "60": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
    "61": "Property must be a string value.\n\n",
    "62": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
    "63": "borderRadius expects one of \"top\", \"bottom\", \"left\" or \"right\" as the first argument.\n\n",
    "64": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation.\n\n",
    "65": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s').\n\n",
    "66": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation.\n\n",
    "67": "You must provide a template to this method.\n\n",
    "68": "You passed an unsupported selector state to this method.\n\n",
    "69": "Expected a string ending in \"px\" or a number passed as the first argument to %s(), got %s instead.\n\n",
    "70": "Expected a string ending in \"px\" or a number passed as the second argument to %s(), got %s instead.\n\n",
    "71": "Passed invalid pixel value %s to %s(), please pass a value like \"12px\" or 12.\n\n",
    "72": "Passed invalid base value %s to %s(), please pass a value like \"12px\" or 12.\n\n",
    "73": "Please provide a valid CSS variable.\n\n",
    "74": "CSS variable not found and no default was provided.\n\n",
    "75": "important requires a valid style object, got a %s instead.\n\n",
    "76": "fromSize and toSize must be provided as stringified numbers with the same units as minScreen and maxScreen.\n\n",
    "77": "remToPx expects a value in \"rem\" but you provided it in \"%s\".\n\n",
    "78": "base must be set in \"px\" or \"%\" but you set it in \"%s\".\n"
};
/**
 * super basic version of sprintf
 * @private
 */ function $e4334fe97365ceb5$var$format() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var a = args[0];
    var b = [];
    var c;
    for(c = 1; c < args.length; c += 1)b.push(args[c]);
    b.forEach(function(d) {
        a = a.replace(/%[a-z]/, d);
    });
    return a;
}
/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 * @private
 */ var $e4334fe97365ceb5$var$PolishedError = /*#__PURE__*/ function(_Error) {
    (0, $83bdfc144528e1e5$export$2e2bcd8739ae039)(PolishedError, _Error);
    function PolishedError(code) {
        var _this;
        var _len2, args, _key2;
        _this = _Error.call(this, "An error occurred. See https://github.com/styled-components/polished/blob/main/src/internalHelpers/errors.md#" + code + " for more information.") || this;
        return (0, $8936f896c18fae91$export$2e2bcd8739ae039)(_this);
    }
    return PolishedError;
}(/*#__PURE__*/ (0, $8d007ef8f92c1f83$export$2e2bcd8739ae039)(Error));
var $e4334fe97365ceb5$var$unitRegExp = /((?!\w)a|na|hc|mc|dg|me[r]?|xe|ni(?![a-zA-Z])|mm|cp|tp|xp|q(?!s)|hv|xamv|nimv|wv|sm|s(?!\D|$)|ged|darg?|nrut)/g;
// Merges additional math functionality into the defaults.
function $e4334fe97365ceb5$var$mergeSymbolMaps(additionalSymbols) {
    var symbolMap = {};
    symbolMap.symbols = additionalSymbols ? (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({}, $e4334fe97365ceb5$var$defaultSymbolMap.symbols, additionalSymbols.symbols) : (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({}, $e4334fe97365ceb5$var$defaultSymbolMap.symbols);
    return symbolMap;
}
function $e4334fe97365ceb5$var$exec(operators, values) {
    var _ref;
    var op = operators.pop();
    values.push(op.f.apply(op, (_ref = []).concat.apply(_ref, values.splice(-op.argCount))));
    return op.precedence;
}
function $e4334fe97365ceb5$var$calculate(expression, additionalSymbols) {
    var symbolMap = $e4334fe97365ceb5$var$mergeSymbolMaps(additionalSymbols);
    var match;
    var operators = [
        symbolMap.symbols['('].prefix
    ];
    var values = [];
    var pattern = new RegExp("\\d+(?:\\.\\d+)?|" + // ...and patterns for individual operators/function names
    Object.keys(symbolMap.symbols).map(function(key) {
        return symbolMap.symbols[key];
    })// longer symbols should be listed first
    // $FlowFixMe
    .sort(function(a, b) {
        return b.symbol.length - a.symbol.length;
    })// $FlowFixMe
    .map(function(val) {
        return val.regSymbol;
    }).join('|') + "|(\\S)", 'g');
    pattern.lastIndex = 0; // Reset regular expression object
    var afterValue = false;
    do {
        match = pattern.exec(expression);
        var _ref2 = match || [
            ')',
            undefined
        ], token = _ref2[0], bad = _ref2[1];
        var notNumber = symbolMap.symbols[token];
        var notNewValue = notNumber && !notNumber.prefix && !notNumber.func;
        var notAfterValue = !notNumber || !notNumber.postfix && !notNumber.infix;
        // Check for syntax errors:
        if (bad || (afterValue ? notAfterValue : notNewValue)) throw new $e4334fe97365ceb5$var$PolishedError(37, match ? match.index : expression.length, expression);
        if (afterValue) {
            // We either have an infix or postfix operator (they should be mutually exclusive)
            var curr = notNumber.postfix || notNumber.infix;
            do {
                var prev = operators[operators.length - 1];
                if ((curr.precedence - prev.precedence || prev.rightToLeft) > 0) break;
            // Apply previous operator, since it has precedence over current one
            }while ($e4334fe97365ceb5$var$exec(operators, values)); // Exit loop after executing an opening parenthesis or function
            afterValue = curr.notation === 'postfix';
            if (curr.symbol !== ')') {
                operators.push(curr);
                // Postfix always has precedence over any operator that follows after it
                if (afterValue) $e4334fe97365ceb5$var$exec(operators, values);
            }
        } else if (notNumber) {
            // prefix operator or function
            operators.push(notNumber.prefix || notNumber.func);
            if (notNumber.func) {
                // Require an opening parenthesis
                match = pattern.exec(expression);
                if (!match || match[0] !== '(') throw new $e4334fe97365ceb5$var$PolishedError(38, match ? match.index : expression.length, expression);
            }
        } else {
            // number
            values.push(+token);
            afterValue = true;
        }
    }while (match && operators.length);
    if (operators.length) throw new $e4334fe97365ceb5$var$PolishedError(39, match ? match.index : expression.length, expression);
    else if (match) throw new $e4334fe97365ceb5$var$PolishedError(40, match ? match.index : expression.length, expression);
    else return values.pop();
}
function $e4334fe97365ceb5$var$reverseString(str) {
    return str.split('').reverse().join('');
}
/**
 * Helper for doing math with CSS Units. Accepts a formula as a string. All values in the formula must have the same unit (or be unitless). Supports complex formulas utliziing addition, subtraction, multiplication, division, square root, powers, factorial, min, max, as well as parentheses for order of operation.
 *
 *In cases where you need to do calculations with mixed units where one unit is a [relative length unit](https://developer.mozilla.org/en-US/docs/Web/CSS/length#Relative_length_units), you will want to use [CSS Calc](https://developer.mozilla.org/en-US/docs/Web/CSS/calc).
 *
 * *warning* While we've done everything possible to ensure math safely evalutes formulas expressed as strings, you should always use extreme caution when passing `math` user provided values.
 * @example
 * // Styles as object usage
 * const styles = {
 *   fontSize: math('12rem + 8rem'),
 *   fontSize: math('(12px + 2px) * 3'),
 *   fontSize: math('3px^2 + sqrt(4)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   fontSize: ${math('12rem + 8rem')};
 *   fontSize: ${math('(12px + 2px) * 3')};
 *   fontSize: ${math('3px^2 + sqrt(4)')};
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   fontSize: '20rem',
 *   fontSize: '42px',
 *   fontSize: '11px',
 * }
 */ function $e4334fe97365ceb5$export$1c891a3202c0ba6a(formula, additionalSymbols) {
    var reversedFormula = $e4334fe97365ceb5$var$reverseString(formula);
    var formulaMatch = reversedFormula.match($e4334fe97365ceb5$var$unitRegExp);
    // Check that all units are the same
    if (formulaMatch && !formulaMatch.every(function(unit) {
        return unit === formulaMatch[0];
    })) throw new $e4334fe97365ceb5$var$PolishedError(41);
    var cleanFormula = $e4334fe97365ceb5$var$reverseString(reversedFormula.replace($e4334fe97365ceb5$var$unitRegExp, ''));
    return "" + $e4334fe97365ceb5$var$calculate(cleanFormula, additionalSymbols) + (formulaMatch ? $e4334fe97365ceb5$var$reverseString(formulaMatch[0]) : '');
}
var $e4334fe97365ceb5$var$cssVariableRegex = /--[\S]*/g;
/**
 * Fetches the value of a passed CSS Variable in the :root scope, or otherwise returns a defaultValue if provided.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'background': cssVar('--background-color'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${cssVar('--background-color')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'background': 'red'
 * }
 */ function $e4334fe97365ceb5$export$8b4981022bd80a4e(cssVariable, defaultValue) {
    if (!cssVariable || !cssVariable.match($e4334fe97365ceb5$var$cssVariableRegex)) throw new $e4334fe97365ceb5$var$PolishedError(73);
    var variableValue;
    /* eslint-disable */ /* istanbul ignore next */ if (typeof document !== 'undefined' && document.documentElement !== null) variableValue = getComputedStyle(document.documentElement).getPropertyValue(cssVariable);
    /* eslint-enable */ if (variableValue) return variableValue.trim();
    else if (defaultValue) return defaultValue;
    throw new $e4334fe97365ceb5$var$PolishedError(74);
}
// @private
function $e4334fe97365ceb5$var$capitalizeString(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
var $e4334fe97365ceb5$var$positionMap$1 = [
    'Top',
    'Right',
    'Bottom',
    'Left'
];
function $e4334fe97365ceb5$var$generateProperty(property, position) {
    if (!property) return position.toLowerCase();
    var splitProperty = property.split('-');
    if (splitProperty.length > 1) {
        splitProperty.splice(1, 0, position);
        return splitProperty.reduce(function(acc, val) {
            return "" + acc + $e4334fe97365ceb5$var$capitalizeString(val);
        });
    }
    var joinedProperty = property.replace(/([a-z])([A-Z])/g, "$1" + position + "$2");
    return property === joinedProperty ? "" + property + position : joinedProperty;
}
function $e4334fe97365ceb5$var$generateStyles(property, valuesWithDefaults) {
    var styles = {};
    for(var i = 0; i < valuesWithDefaults.length; i += 1)if (valuesWithDefaults[i] || valuesWithDefaults[i] === 0) styles[$e4334fe97365ceb5$var$generateProperty(property, $e4334fe97365ceb5$var$positionMap$1[i])] = valuesWithDefaults[i];
    return styles;
}
/**
 * Enables shorthand for direction-based properties. It accepts a property (hyphenated or camelCased) and up to four values that map to top, right, bottom, and left, respectively. You can optionally pass an empty string to get only the directional values as properties. You can also optionally pass a null argument for a directional value to ignore it.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...directionalProperty('padding', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${directionalProperty('padding', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */ function $e4334fe97365ceb5$export$4fc00c04dd60af95(property) {
    for(var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)values[_key - 1] = arguments[_key];
    //  prettier-ignore
    var firstValue = values[0], _values$ = values[1], secondValue = _values$ === void 0 ? firstValue : _values$, _values$2 = values[2], thirdValue = _values$2 === void 0 ? firstValue : _values$2, _values$3 = values[3], fourthValue = _values$3 === void 0 ? secondValue : _values$3;
    var valuesWithDefaults = [
        firstValue,
        secondValue,
        thirdValue,
        fourthValue
    ];
    return $e4334fe97365ceb5$var$generateStyles(property, valuesWithDefaults);
}
/**
 * Check if a string ends with something
 * @private
 */ function $e4334fe97365ceb5$var$endsWith(string, suffix) {
    return string.substr(-suffix.length) === suffix;
}
var $e4334fe97365ceb5$var$cssRegex$1 = /^([+-]?(?:\d+|\d*\.\d+))([a-z]*|%)$/;
/**
 * Returns a given CSS value minus its unit of measure.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   '--dimension': stripUnit('100px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   --dimension: ${stripUnit('100px')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   '--dimension': 100
 * }
 */ function $e4334fe97365ceb5$export$ef04e38dc423904(value) {
    if (typeof value !== 'string') return value;
    var matchedValue = value.match($e4334fe97365ceb5$var$cssRegex$1);
    return matchedValue ? parseFloat(value) : value;
}
/**
 * Factory function that creates pixel-to-x converters
 * @private
 */ var $e4334fe97365ceb5$var$pxtoFactory = function pxtoFactory(to) {
    return function(pxval, base) {
        if (base === void 0) base = '16px';
        var newPxval = pxval;
        var newBase = base;
        if (typeof pxval === 'string') {
            if (!$e4334fe97365ceb5$var$endsWith(pxval, 'px')) throw new $e4334fe97365ceb5$var$PolishedError(69, to, pxval);
            newPxval = $e4334fe97365ceb5$export$ef04e38dc423904(pxval);
        }
        if (typeof base === 'string') {
            if (!$e4334fe97365ceb5$var$endsWith(base, 'px')) throw new $e4334fe97365ceb5$var$PolishedError(70, to, base);
            newBase = $e4334fe97365ceb5$export$ef04e38dc423904(base);
        }
        if (typeof newPxval === 'string') throw new $e4334fe97365ceb5$var$PolishedError(71, pxval, to);
        if (typeof newBase === 'string') throw new $e4334fe97365ceb5$var$PolishedError(72, base, to);
        return "" + newPxval / newBase + to;
    };
};
var $e4334fe97365ceb5$var$pixelsto = $e4334fe97365ceb5$var$pxtoFactory;
/**
 * Convert pixel value to ems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': em('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${em('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1em'
 * }
 */ var $e4334fe97365ceb5$var$em = $e4334fe97365ceb5$var$pixelsto('em');
var $e4334fe97365ceb5$export$c63c6f932822f543 = $e4334fe97365ceb5$var$em;
var $e4334fe97365ceb5$var$cssRegex = /^([+-]?(?:\d+|\d*\.\d+))([a-z]*|%)$/;
/**
 * Returns a given CSS value and its unit as elements of an array.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   '--dimension': getValueAndUnit('100px')[0],
 *   '--unit': getValueAndUnit('100px')[1],
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   --dimension: ${getValueAndUnit('100px')[0]};
 *   --unit: ${getValueAndUnit('100px')[1]};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   '--dimension': 100,
 *   '--unit': 'px',
 * }
 */ function $e4334fe97365ceb5$export$feec6b849ef388ab(value) {
    if (typeof value !== 'string') return [
        value,
        ''
    ];
    var matchedValue = value.match($e4334fe97365ceb5$var$cssRegex);
    if (matchedValue) return [
        parseFloat(value),
        matchedValue[2]
    ];
    return [
        value,
        undefined
    ];
}
/**
 * Helper for targeting rules in a style block generated by polished modules that need !important-level specificity. Can optionally specify a rule (or rules) to target specific rules.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...important(cover())
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${important(cover())}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'position': 'absolute !important',
 *   'top': '0 !important',
 *   'right: '0 !important',
 *   'bottom': '0 !important',
 *   'left: '0 !important'
 * }
 */ function $e4334fe97365ceb5$export$929888ab0c9f043c(styleBlock, rules) {
    if (typeof styleBlock !== 'object' || styleBlock === null) throw new $e4334fe97365ceb5$var$PolishedError(75, typeof styleBlock);
    var newStyleBlock = {};
    Object.keys(styleBlock).forEach(function(key) {
        if (typeof styleBlock[key] === 'object' && styleBlock[key] !== null) newStyleBlock[key] = $e4334fe97365ceb5$export$929888ab0c9f043c(styleBlock[key], rules);
        else if (!rules || rules && (rules === key || rules.indexOf(key) >= 0)) newStyleBlock[key] = styleBlock[key] + " !important";
        else newStyleBlock[key] = styleBlock[key];
    });
    return newStyleBlock;
}
var $e4334fe97365ceb5$var$ratioNames = {
    minorSecond: 1.067,
    majorSecond: 1.125,
    minorThird: 1.2,
    majorThird: 1.25,
    perfectFourth: 1.333,
    augFourth: 1.414,
    perfectFifth: 1.5,
    minorSixth: 1.6,
    goldenSection: 1.618,
    majorSixth: 1.667,
    minorSeventh: 1.778,
    majorSeventh: 1.875,
    octave: 2,
    majorTenth: 2.5,
    majorEleventh: 2.667,
    majorTwelfth: 3,
    doubleOctave: 4
};
function $e4334fe97365ceb5$var$getRatio(ratioName) {
    return $e4334fe97365ceb5$var$ratioNames[ratioName];
}
/**
 * Establish consistent measurements and spacial relationships throughout your projects by incrementing an em or rem value up or down a defined scale. We provide a list of commonly used scales as pre-defined variables.
 * @example
 * // Styles as object usage
 * const styles = {
 *    // Increment two steps up the default scale
 *   'fontSize': modularScale(2)
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *    // Increment two steps up the default scale
 *   fontSize: ${modularScale(2)}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'fontSize': '1.77689em'
 * }
 */ function $e4334fe97365ceb5$export$c82a8a23c9e8bdb6(steps, base, ratio) {
    if (base === void 0) base = '1em';
    if (ratio === void 0) ratio = 1.333;
    if (typeof steps !== 'number') throw new $e4334fe97365ceb5$var$PolishedError(42);
    if (typeof ratio === 'string' && !$e4334fe97365ceb5$var$ratioNames[ratio]) throw new $e4334fe97365ceb5$var$PolishedError(43);
    var _ref = typeof base === 'string' ? $e4334fe97365ceb5$export$feec6b849ef388ab(base) : [
        base,
        ''
    ], realBase = _ref[0], unit = _ref[1];
    var realRatio = typeof ratio === 'string' ? $e4334fe97365ceb5$var$getRatio(ratio) : ratio;
    if (typeof realBase === 'string') throw new $e4334fe97365ceb5$var$PolishedError(44, base);
    return "" + realBase * Math.pow(realRatio, steps) + (unit || '');
}
/**
 * Convert pixel value to rems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': rem('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${rem('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1rem'
 * }
 */ var $e4334fe97365ceb5$var$rem = $e4334fe97365ceb5$var$pixelsto('rem');
var $e4334fe97365ceb5$export$fb1897a40d146f7f = $e4334fe97365ceb5$var$rem;
var $e4334fe97365ceb5$var$defaultFontSize = 16;
function $e4334fe97365ceb5$var$convertBase(base) {
    var deconstructedValue = $e4334fe97365ceb5$export$feec6b849ef388ab(base);
    if (deconstructedValue[1] === 'px') return parseFloat(base);
    if (deconstructedValue[1] === '%') return parseFloat(base) / 100 * $e4334fe97365ceb5$var$defaultFontSize;
    throw new $e4334fe97365ceb5$var$PolishedError(78, deconstructedValue[1]);
}
function $e4334fe97365ceb5$var$getBaseFromDoc() {
    /* eslint-disable */ /* istanbul ignore next */ if (typeof document !== 'undefined' && document.documentElement !== null) {
        var rootFontSize = getComputedStyle(document.documentElement).fontSize;
        return rootFontSize ? $e4334fe97365ceb5$var$convertBase(rootFontSize) : $e4334fe97365ceb5$var$defaultFontSize;
    }
    /* eslint-enable */ /* istanbul ignore next */ return $e4334fe97365ceb5$var$defaultFontSize;
}
/**
 * Convert rem values to px. By default, the base value is pulled from the font-size property on the root element (if it is set in % or px). It defaults to 16px if not found on the root. You can also override the base value by providing your own base in % or px.
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': remToPx('1.6rem')
 *   'height': remToPx('1.6rem', '10px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${remToPx('1.6rem')}
 *   height: ${remToPx('1.6rem', '10px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '25.6px',
 *   'height': '16px',
 * }
 */ function $e4334fe97365ceb5$export$7e5d3caf0359a67a(value, base) {
    var deconstructedValue = $e4334fe97365ceb5$export$feec6b849ef388ab(value);
    if (deconstructedValue[1] !== 'rem' && deconstructedValue[1] !== '') throw new $e4334fe97365ceb5$var$PolishedError(77, deconstructedValue[1]);
    var newBase = base ? $e4334fe97365ceb5$var$convertBase(base) : $e4334fe97365ceb5$var$getBaseFromDoc();
    return deconstructedValue[0] * newBase + "px";
}
var $e4334fe97365ceb5$var$functionsMap$3 = {
    back: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)',
    circ: 'cubic-bezier(0.600,  0.040, 0.980, 0.335)',
    cubic: 'cubic-bezier(0.550,  0.055, 0.675, 0.190)',
    expo: 'cubic-bezier(0.950,  0.050, 0.795, 0.035)',
    quad: 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
    quart: 'cubic-bezier(0.895,  0.030, 0.685, 0.220)',
    quint: 'cubic-bezier(0.755,  0.050, 0.855, 0.060)',
    sine: 'cubic-bezier(0.470,  0.000, 0.745, 0.715)'
};
/**
 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'transitionTimingFunction': easeIn('quad')
 * }
 *
 * // styled-components usage
 *  const div = styled.div`
 *   transitionTimingFunction: ${easeIn('quad')};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'transitionTimingFunction': 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
 * }
 */ function $e4334fe97365ceb5$export$929e5a82286172a6(functionName) {
    return $e4334fe97365ceb5$var$functionsMap$3[functionName.toLowerCase().trim()];
}
var $e4334fe97365ceb5$var$functionsMap$2 = {
    back: 'cubic-bezier(0.680, -0.550, 0.265, 1.550)',
    circ: 'cubic-bezier(0.785,  0.135, 0.150, 0.860)',
    cubic: 'cubic-bezier(0.645,  0.045, 0.355, 1.000)',
    expo: 'cubic-bezier(1.000,  0.000, 0.000, 1.000)',
    quad: 'cubic-bezier(0.455,  0.030, 0.515, 0.955)',
    quart: 'cubic-bezier(0.770,  0.000, 0.175, 1.000)',
    quint: 'cubic-bezier(0.860,  0.000, 0.070, 1.000)',
    sine: 'cubic-bezier(0.445,  0.050, 0.550, 0.950)'
};
/**
 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'transitionTimingFunction': easeInOut('quad')
 * }
 *
 * // styled-components usage
 *  const div = styled.div`
 *   transitionTimingFunction: ${easeInOut('quad')};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'transitionTimingFunction': 'cubic-bezier(0.455,  0.030, 0.515, 0.955)',
 * }
 */ function $e4334fe97365ceb5$export$c07234257a03d5e9(functionName) {
    return $e4334fe97365ceb5$var$functionsMap$2[functionName.toLowerCase().trim()];
}
var $e4334fe97365ceb5$var$functionsMap$1 = {
    back: 'cubic-bezier(0.175,  0.885, 0.320, 1.275)',
    cubic: 'cubic-bezier(0.215,  0.610, 0.355, 1.000)',
    circ: 'cubic-bezier(0.075,  0.820, 0.165, 1.000)',
    expo: 'cubic-bezier(0.190,  1.000, 0.220, 1.000)',
    quad: 'cubic-bezier(0.250,  0.460, 0.450, 0.940)',
    quart: 'cubic-bezier(0.165,  0.840, 0.440, 1.000)',
    quint: 'cubic-bezier(0.230,  1.000, 0.320, 1.000)',
    sine: 'cubic-bezier(0.390,  0.575, 0.565, 1.000)'
};
/**
 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'transitionTimingFunction': easeOut('quad')
 * }
 *
 * // styled-components usage
 *  const div = styled.div`
 *   transitionTimingFunction: ${easeOut('quad')};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'transitionTimingFunction': 'cubic-bezier(0.250,  0.460, 0.450, 0.940)',
 * }
 */ function $e4334fe97365ceb5$export$57636bb43b1ccbb0(functionName) {
    return $e4334fe97365ceb5$var$functionsMap$1[functionName.toLowerCase().trim()];
}
/**
 * Returns a CSS calc formula for linear interpolation of a property between two values. Accepts optional minScreen (defaults to '320px') and maxScreen (defaults to '1200px').
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   fontSize: between('20px', '100px', '400px', '1000px'),
 *   fontSize: between('20px', '100px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   fontSize: ${between('20px', '100px', '400px', '1000px')};
 *   fontSize: ${between('20px', '100px')}
 * `
 *
 * // CSS as JS Output
 *
 * h1: {
 *   'fontSize': 'calc(-33.33333333333334px + 13.333333333333334vw)',
 *   'fontSize': 'calc(-9.090909090909093px + 9.090909090909092vw)'
 * }
 */ function $e4334fe97365ceb5$export$cf95c51b03f10bae(fromSize, toSize, minScreen, maxScreen) {
    if (minScreen === void 0) minScreen = '320px';
    if (maxScreen === void 0) maxScreen = '1200px';
    var _getValueAndUnit = $e4334fe97365ceb5$export$feec6b849ef388ab(fromSize), unitlessFromSize = _getValueAndUnit[0], fromSizeUnit = _getValueAndUnit[1];
    var _getValueAndUnit2 = $e4334fe97365ceb5$export$feec6b849ef388ab(toSize), unitlessToSize = _getValueAndUnit2[0], toSizeUnit = _getValueAndUnit2[1];
    var _getValueAndUnit3 = $e4334fe97365ceb5$export$feec6b849ef388ab(minScreen), unitlessMinScreen = _getValueAndUnit3[0], minScreenUnit = _getValueAndUnit3[1];
    var _getValueAndUnit4 = $e4334fe97365ceb5$export$feec6b849ef388ab(maxScreen), unitlessMaxScreen = _getValueAndUnit4[0], maxScreenUnit = _getValueAndUnit4[1];
    if (typeof unitlessMinScreen !== 'number' || typeof unitlessMaxScreen !== 'number' || !minScreenUnit || !maxScreenUnit || minScreenUnit !== maxScreenUnit) throw new $e4334fe97365ceb5$var$PolishedError(47);
    if (typeof unitlessFromSize !== 'number' || typeof unitlessToSize !== 'number' || fromSizeUnit !== toSizeUnit) throw new $e4334fe97365ceb5$var$PolishedError(48);
    if (fromSizeUnit !== minScreenUnit || toSizeUnit !== maxScreenUnit) throw new $e4334fe97365ceb5$var$PolishedError(76);
    var slope = (unitlessFromSize - unitlessToSize) / (unitlessMinScreen - unitlessMaxScreen);
    var base = unitlessToSize - slope * unitlessMaxScreen;
    return "calc(" + base.toFixed(2) + (fromSizeUnit || '') + " + " + (100 * slope).toFixed(2) + "vw)";
}
/**
 * CSS to contain a float (credit to CSSMojo).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...clearFix(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${clearFix()}
 * `
 *
 * // CSS as JS Output
 *
 * '&::after': {
 *   'clear': 'both',
 *   'content': '""',
 *   'display': 'table'
 * }
 */ function $e4334fe97365ceb5$export$8c467e8859fdef13(parent) {
    var _ref;
    if (parent === void 0) parent = '&';
    var pseudoSelector = parent + "::after";
    return _ref = {}, _ref[pseudoSelector] = {
        clear: 'both',
        content: '""',
        display: 'table'
    }, _ref;
}
/**
 * CSS to fully cover an area. Can optionally be passed an offset to act as a "padding".
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...cover()
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${cover()}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'position': 'absolute',
 *   'top': '0',
 *   'right: '0',
 *   'bottom': '0',
 *   'left: '0'
 * }
 */ function $e4334fe97365ceb5$export$4bdbf921f0c0fd8c(offset) {
    if (offset === void 0) offset = 0;
    return {
        position: 'absolute',
        top: offset,
        right: offset,
        bottom: offset,
        left: offset
    };
}
/**
 * CSS to represent truncated text with an ellipsis. You can optionally pass a max-width and number of lines before truncating.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...ellipsis('250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${ellipsis('250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'display': 'inline-block',
 *   'maxWidth': '250px',
 *   'overflow': 'hidden',
 *   'textOverflow': 'ellipsis',
 *   'whiteSpace': 'nowrap',
 *   'wordWrap': 'normal'
 * }
 */ function $e4334fe97365ceb5$export$a5b94313d6908893(width, lines) {
    if (lines === void 0) lines = 1;
    var styles = {
        display: 'inline-block',
        maxWidth: width || '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        wordWrap: 'normal'
    };
    return lines > 1 ? (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({}, styles, {
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: lines,
        display: '-webkit-box',
        whiteSpace: 'normal'
    }) : styles;
}
function $e4334fe97365ceb5$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $e4334fe97365ceb5$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e4334fe97365ceb5$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e4334fe97365ceb5$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e4334fe97365ceb5$var$_arrayLikeToArray(o, minLen);
}
function $e4334fe97365ceb5$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
/**
 * Returns a set of media queries that resizes a property (or set of properties) between a provided fromSize and toSize. Accepts optional minScreen (defaults to '320px') and maxScreen (defaults to '1200px') to constrain the interpolation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...fluidRange(
 *    {
 *        prop: 'padding',
 *        fromSize: '20px',
 *        toSize: '100px',
 *      },
 *      '400px',
 *      '1000px',
 *    )
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${fluidRange(
 *      {
 *        prop: 'padding',
 *        fromSize: '20px',
 *        toSize: '100px',
 *      },
 *      '400px',
 *      '1000px',
 *    )}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   "@media (min-width: 1000px)": Object {
 *     "padding": "100px",
 *   },
 *   "@media (min-width: 400px)": Object {
 *     "padding": "calc(-33.33333333333334px + 13.333333333333334vw)",
 *   },
 *   "padding": "20px",
 * }
 */ function $e4334fe97365ceb5$export$de4c2ac00f6121cf(cssProp, minScreen, maxScreen) {
    if (minScreen === void 0) minScreen = '320px';
    if (maxScreen === void 0) maxScreen = '1200px';
    if (!Array.isArray(cssProp) && typeof cssProp !== 'object' || cssProp === null) throw new $e4334fe97365ceb5$var$PolishedError(49);
    if (Array.isArray(cssProp)) {
        var mediaQueries = {};
        var fallbacks = {};
        for(var _iterator = $e4334fe97365ceb5$var$_createForOfIteratorHelperLoose(cssProp), _step; !(_step = _iterator()).done;){
            var _extends2, _extends3;
            var obj = _step.value;
            if (!obj.prop || !obj.fromSize || !obj.toSize) throw new $e4334fe97365ceb5$var$PolishedError(50);
            fallbacks[obj.prop] = obj.fromSize;
            mediaQueries["@media (min-width: " + minScreen + ")"] = (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({}, mediaQueries["@media (min-width: " + minScreen + ")"], (_extends2 = {}, _extends2[obj.prop] = $e4334fe97365ceb5$export$cf95c51b03f10bae(obj.fromSize, obj.toSize, minScreen, maxScreen), _extends2));
            mediaQueries["@media (min-width: " + maxScreen + ")"] = (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({}, mediaQueries["@media (min-width: " + maxScreen + ")"], (_extends3 = {}, _extends3[obj.prop] = obj.toSize, _extends3));
        }
        return (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({}, fallbacks, mediaQueries);
    } else {
        var _ref, _ref2, _ref3;
        if (!cssProp.prop || !cssProp.fromSize || !cssProp.toSize) throw new $e4334fe97365ceb5$var$PolishedError(51);
        return _ref3 = {}, _ref3[cssProp.prop] = cssProp.fromSize, _ref3["@media (min-width: " + minScreen + ")"] = (_ref = {}, _ref[cssProp.prop] = $e4334fe97365ceb5$export$cf95c51b03f10bae(cssProp.fromSize, cssProp.toSize, minScreen, maxScreen), _ref), _ref3["@media (min-width: " + maxScreen + ")"] = (_ref2 = {}, _ref2[cssProp.prop] = cssProp.toSize, _ref2), _ref3;
    }
}
var $e4334fe97365ceb5$var$dataURIRegex = /^\s*data:([a-z]+\/[a-z-]+(;[a-z-]+=[a-z-]+)?)?(;charset=[a-z0-9-]+)?(;base64)?,[a-z0-9!$&',()*+,;=\-._~:@/?%\s]*\s*$/i;
var $e4334fe97365ceb5$var$formatHintMap = {
    woff: 'woff',
    woff2: 'woff2',
    ttf: 'truetype',
    otf: 'opentype',
    eot: 'embedded-opentype',
    svg: 'svg',
    svgz: 'svg'
};
function $e4334fe97365ceb5$var$generateFormatHint(format, formatHint) {
    if (!formatHint) return '';
    return " format(\"" + $e4334fe97365ceb5$var$formatHintMap[format] + "\")";
}
function $e4334fe97365ceb5$var$isDataURI(fontFilePath) {
    return !!fontFilePath.replace(/\s+/g, ' ').match($e4334fe97365ceb5$var$dataURIRegex);
}
function $e4334fe97365ceb5$var$generateFileReferences(fontFilePath, fileFormats, formatHint) {
    if ($e4334fe97365ceb5$var$isDataURI(fontFilePath)) return "url(\"" + fontFilePath + "\")" + $e4334fe97365ceb5$var$generateFormatHint(fileFormats[0], formatHint);
    var fileFontReferences = fileFormats.map(function(format) {
        return "url(\"" + fontFilePath + "." + format + "\")" + $e4334fe97365ceb5$var$generateFormatHint(format, formatHint);
    });
    return fileFontReferences.join(', ');
}
function $e4334fe97365ceb5$var$generateLocalReferences(localFonts) {
    var localFontReferences = localFonts.map(function(font) {
        return "local(\"" + font + "\")";
    });
    return localFontReferences.join(', ');
}
function $e4334fe97365ceb5$var$generateSources(fontFilePath, localFonts, fileFormats, formatHint) {
    var fontReferences = [];
    if (localFonts) fontReferences.push($e4334fe97365ceb5$var$generateLocalReferences(localFonts));
    if (fontFilePath) fontReferences.push($e4334fe97365ceb5$var$generateFileReferences(fontFilePath, fileFormats, formatHint));
    return fontReferences.join(', ');
}
/**
 * CSS for a @font-face declaration. Defaults to check for local copies of the font on the user's machine. You can disable this by passing `null` to localFonts.
 *
 * @example
 * // Styles as object basic usage
 * const styles = {
 *    ...fontFace({
 *      'fontFamily': 'Sans-Pro',
 *      'fontFilePath': 'path/to/file'
 *    })
 * }
 *
 * // styled-components basic usage
 * const GlobalStyle = createGlobalStyle`${
 *   fontFace({
 *     'fontFamily': 'Sans-Pro',
 *     'fontFilePath': 'path/to/file'
 *   }
 * )}`
 *
 * // CSS as JS Output
 *
 * '@font-face': {
 *   'fontFamily': 'Sans-Pro',
 *   'src': 'url("path/to/file.eot"), url("path/to/file.woff2"), url("path/to/file.woff"), url("path/to/file.ttf"), url("path/to/file.svg")',
 * }
 */ function $e4334fe97365ceb5$export$566c6c2ff0443c7(_ref) {
    var fontFamily = _ref.fontFamily, fontFilePath = _ref.fontFilePath, fontStretch = _ref.fontStretch, fontStyle = _ref.fontStyle, fontVariant = _ref.fontVariant, fontWeight = _ref.fontWeight, _ref$fileFormats = _ref.fileFormats, fileFormats = _ref$fileFormats === void 0 ? [
        'eot',
        'woff2',
        'woff',
        'ttf',
        'svg'
    ] : _ref$fileFormats, _ref$formatHint = _ref.formatHint, formatHint = _ref$formatHint === void 0 ? false : _ref$formatHint, _ref$localFonts = _ref.localFonts, localFonts = _ref$localFonts === void 0 ? [
        fontFamily
    ] : _ref$localFonts, unicodeRange = _ref.unicodeRange, fontDisplay = _ref.fontDisplay, fontVariationSettings = _ref.fontVariationSettings, fontFeatureSettings = _ref.fontFeatureSettings;
    // Error Handling
    if (!fontFamily) throw new $e4334fe97365ceb5$var$PolishedError(55);
    if (!fontFilePath && !localFonts) throw new $e4334fe97365ceb5$var$PolishedError(52);
    if (localFonts && !Array.isArray(localFonts)) throw new $e4334fe97365ceb5$var$PolishedError(53);
    if (!Array.isArray(fileFormats)) throw new $e4334fe97365ceb5$var$PolishedError(54);
    var fontFaceDeclaration = {
        '@font-face': {
            fontFamily: fontFamily,
            src: $e4334fe97365ceb5$var$generateSources(fontFilePath, localFonts, fileFormats, formatHint),
            unicodeRange: unicodeRange,
            fontStretch: fontStretch,
            fontStyle: fontStyle,
            fontVariant: fontVariant,
            fontWeight: fontWeight,
            fontDisplay: fontDisplay,
            fontVariationSettings: fontVariationSettings,
            fontFeatureSettings: fontFeatureSettings
        }
    };
    // Removes undefined fields for cleaner css object.
    return JSON.parse(JSON.stringify(fontFaceDeclaration));
}
/**
 * CSS to hide text to show a background image in a SEO-friendly way.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'backgroundImage': 'url(logo.png)',
 *   ...hideText(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   backgroundImage: url(logo.png);
 *   ${hideText()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'backgroundImage': 'url(logo.png)',
 *   'textIndent': '101%',
 *   'overflow': 'hidden',
 *   'whiteSpace': 'nowrap',
 * }
 */ function $e4334fe97365ceb5$export$27bef6389954e24d() {
    return {
        textIndent: '101%',
        overflow: 'hidden',
        whiteSpace: 'nowrap'
    };
}
/**
 * CSS to hide content visually but remain accessible to screen readers.
 * from [HTML5 Boilerplate](https://github.com/h5bp/html5-boilerplate/blob/9a176f57af1cfe8ec70300da4621fb9b07e5fa31/src/css/main.css#L121)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...hideVisually(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hideVisually()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'border': '0',
 *   'clip': 'rect(0 0 0 0)',
 *   'height': '1px',
 *   'margin': '-1px',
 *   'overflow': 'hidden',
 *   'padding': '0',
 *   'position': 'absolute',
 *   'whiteSpace': 'nowrap',
 *   'width': '1px',
 * }
 */ function $e4334fe97365ceb5$export$36e2157ae4e3cbdd() {
    return {
        border: '0',
        clip: 'rect(0 0 0 0)',
        height: '1px',
        margin: '-1px',
        overflow: 'hidden',
        padding: '0',
        position: 'absolute',
        whiteSpace: 'nowrap',
        width: '1px'
    };
}
/**
 * Generates a media query to target HiDPI devices.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  [hiDPI(1.5)]: {
 *    width: 200px;
 *  }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hiDPI(1.5)} {
 *     width: 200px;
 *   }
 * `
 *
 * // CSS as JS Output
 *
 * '@media only screen and (-webkit-min-device-pixel-ratio: 1.5),
 *  only screen and (min--moz-device-pixel-ratio: 1.5),
 *  only screen and (-o-min-device-pixel-ratio: 1.5/1),
 *  only screen and (min-resolution: 144dpi),
 *  only screen and (min-resolution: 1.5dppx)': {
 *   'width': '200px',
 * }
 */ function $e4334fe97365ceb5$export$e79006618d7c6cc3(ratio) {
    if (ratio === void 0) ratio = 1.3;
    return "\n    @media only screen and (-webkit-min-device-pixel-ratio: " + ratio + "),\n    only screen and (min--moz-device-pixel-ratio: " + ratio + "),\n    only screen and (-o-min-device-pixel-ratio: " + ratio + "/1),\n    only screen and (min-resolution: " + Math.round(ratio * 96) + "dpi),\n    only screen and (min-resolution: " + ratio + "dppx)\n  ";
}
function $e4334fe97365ceb5$var$constructGradientValue(literals) {
    var template = '';
    for(var _len = arguments.length, substitutions = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)substitutions[_key - 1] = arguments[_key];
    for(var i = 0; i < literals.length; i += 1){
        template += literals[i];
        if (i === substitutions.length - 1 && substitutions[i]) {
            var definedValues = substitutions.filter(function(substitute) {
                return !!substitute;
            });
            // Adds leading coma if properties preceed color-stops
            if (definedValues.length > 1) {
                template = template.slice(0, -1);
                template += ", " + substitutions[i];
            // No trailing space if color-stops is the only param provided
            } else if (definedValues.length === 1) template += "" + substitutions[i];
        } else if (substitutions[i]) template += substitutions[i] + " ";
    }
    return template.trim();
}
var $e4334fe97365ceb5$var$_templateObject$1;
/**
 * CSS for declaring a linear gradient, including a fallback background-color. The fallback is either the first color-stop or an explicitly passed fallback color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...linearGradient({
        colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
        toDirection: 'to top right',
        fallback: '#FFF',
      })
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${linearGradient({
        colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
        toDirection: 'to top right',
        fallback: '#FFF',
      })}
 *`
 *
 * // CSS as JS Output
 *
 * div: {
 *   'backgroundColor': '#FFF',
 *   'backgroundImage': 'linear-gradient(to top right, #00FFFF 0%, rgba(0, 0, 255, 0) 50%, #0000FF 95%)',
 * }
 */ function $e4334fe97365ceb5$export$46def8197cf4dd4c(_ref) {
    var colorStops = _ref.colorStops, fallback = _ref.fallback, _ref$toDirection = _ref.toDirection, toDirection = _ref$toDirection === void 0 ? '' : _ref$toDirection;
    if (!colorStops || colorStops.length < 2) throw new $e4334fe97365ceb5$var$PolishedError(56);
    return {
        backgroundColor: fallback || colorStops[0].replace(/,\s+/g, ',').split(' ')[0].replace(/,(?=\S)/g, ', '),
        backgroundImage: $e4334fe97365ceb5$var$constructGradientValue($e4334fe97365ceb5$var$_templateObject$1 || ($e4334fe97365ceb5$var$_templateObject$1 = (0, $b828f41498135548$export$2e2bcd8739ae039)([
            "linear-gradient(",
            "",
            ")"
        ])), toDirection, colorStops.join(', ').replace(/,(?=\S)/g, ', '))
    };
}
/**
 * CSS to normalize abnormalities across browsers (normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...normalize(),
 * }
 *
 * // styled-components usage
 * const GlobalStyle = createGlobalStyle`${normalize()}`
 *
 * // CSS as JS Output
 *
 * html {
 *   lineHeight: 1.15,
 *   textSizeAdjust: 100%,
 * } ...
 */ function $e4334fe97365ceb5$export$a3295358bff77e() {
    var _ref;
    return [
        (_ref = {
            html: {
                lineHeight: '1.15',
                textSizeAdjust: '100%'
            },
            body: {
                margin: '0'
            },
            main: {
                display: 'block'
            },
            h1: {
                fontSize: '2em',
                margin: '0.67em 0'
            },
            hr: {
                boxSizing: 'content-box',
                height: '0',
                overflow: 'visible'
            },
            pre: {
                fontFamily: 'monospace, monospace',
                fontSize: '1em'
            },
            a: {
                backgroundColor: 'transparent'
            },
            'abbr[title]': {
                borderBottom: 'none',
                textDecoration: 'underline'
            }
        }, _ref["b,\n    strong"] = {
            fontWeight: 'bolder'
        }, _ref["code,\n    kbd,\n    samp"] = {
            fontFamily: 'monospace, monospace',
            fontSize: '1em'
        }, _ref.small = {
            fontSize: '80%'
        }, _ref["sub,\n    sup"] = {
            fontSize: '75%',
            lineHeight: '0',
            position: 'relative',
            verticalAlign: 'baseline'
        }, _ref.sub = {
            bottom: '-0.25em'
        }, _ref.sup = {
            top: '-0.5em'
        }, _ref.img = {
            borderStyle: 'none'
        }, _ref["button,\n    input,\n    optgroup,\n    select,\n    textarea"] = {
            fontFamily: 'inherit',
            fontSize: '100%',
            lineHeight: '1.15',
            margin: '0'
        }, _ref["button,\n    input"] = {
            overflow: 'visible'
        }, _ref["button,\n    select"] = {
            textTransform: 'none'
        }, _ref["button,\n    html [type=\"button\"],\n    [type=\"reset\"],\n    [type=\"submit\"]"] = {
            WebkitAppearance: 'button'
        }, _ref["button::-moz-focus-inner,\n    [type=\"button\"]::-moz-focus-inner,\n    [type=\"reset\"]::-moz-focus-inner,\n    [type=\"submit\"]::-moz-focus-inner"] = {
            borderStyle: 'none',
            padding: '0'
        }, _ref["button:-moz-focusring,\n    [type=\"button\"]:-moz-focusring,\n    [type=\"reset\"]:-moz-focusring,\n    [type=\"submit\"]:-moz-focusring"] = {
            outline: '1px dotted ButtonText'
        }, _ref.fieldset = {
            padding: '0.35em 0.625em 0.75em'
        }, _ref.legend = {
            boxSizing: 'border-box',
            color: 'inherit',
            display: 'table',
            maxWidth: '100%',
            padding: '0',
            whiteSpace: 'normal'
        }, _ref.progress = {
            verticalAlign: 'baseline'
        }, _ref.textarea = {
            overflow: 'auto'
        }, _ref["[type=\"checkbox\"],\n    [type=\"radio\"]"] = {
            boxSizing: 'border-box',
            padding: '0'
        }, _ref["[type=\"number\"]::-webkit-inner-spin-button,\n    [type=\"number\"]::-webkit-outer-spin-button"] = {
            height: 'auto'
        }, _ref['[type="search"]'] = {
            WebkitAppearance: 'textfield',
            outlineOffset: '-2px'
        }, _ref['[type="search"]::-webkit-search-decoration'] = {
            WebkitAppearance: 'none'
        }, _ref['::-webkit-file-upload-button'] = {
            WebkitAppearance: 'button',
            font: 'inherit'
        }, _ref.details = {
            display: 'block'
        }, _ref.summary = {
            display: 'list-item'
        }, _ref.template = {
            display: 'none'
        }, _ref['[hidden]'] = {
            display: 'none'
        }, _ref),
        {
            'abbr[title]': {
                textDecoration: 'underline dotted'
            }
        }
    ];
}
var $e4334fe97365ceb5$var$_templateObject;
/**
 * CSS for declaring a radial gradient, including a fallback background-color. The fallback is either the first color-stop or an explicitly passed fallback color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })}
 *`
 *
 * // CSS as JS Output
 *
 * div: {
 *   'backgroundColor': '#00FFFF',
 *   'backgroundImage': 'radial-gradient(center ellipse farthest-corner at 45px 45px, #00FFFF 0%, rgba(0, 0, 255, 0) 50%, #0000FF 95%)',
 * }
 */ function $e4334fe97365ceb5$export$3922d1ccb8631cd8(_ref) {
    var colorStops = _ref.colorStops, _ref$extent = _ref.extent, extent = _ref$extent === void 0 ? '' : _ref$extent, fallback = _ref.fallback, _ref$position = _ref.position, position = _ref$position === void 0 ? '' : _ref$position, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? '' : _ref$shape;
    if (!colorStops || colorStops.length < 2) throw new $e4334fe97365ceb5$var$PolishedError(57);
    return {
        backgroundColor: fallback || colorStops[0].split(' ')[0],
        backgroundImage: $e4334fe97365ceb5$var$constructGradientValue($e4334fe97365ceb5$var$_templateObject || ($e4334fe97365ceb5$var$_templateObject = (0, $b828f41498135548$export$2e2bcd8739ae039)([
            "radial-gradient(",
            "",
            "",
            "",
            ")"
        ])), position, shape, extent, colorStops.join(', '))
    };
}
/**
 * A helper to generate a retina background image and non-retina
 * background image. The retina background image will output to a HiDPI media query. The mixin uses
 * a _2x.png filename suffix by default.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  ...retinaImage('my-img')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${retinaImage('my-img')}
 * `
 *
 * // CSS as JS Output
 * div {
 *   backgroundImage: 'url(my-img.png)',
 *   '@media only screen and (-webkit-min-device-pixel-ratio: 1.3),
 *    only screen and (min--moz-device-pixel-ratio: 1.3),
 *    only screen and (-o-min-device-pixel-ratio: 1.3/1),
 *    only screen and (min-resolution: 144dpi),
 *    only screen and (min-resolution: 1.5dppx)': {
 *     backgroundImage: 'url(my-img_2x.png)',
 *   }
 * }
 */ function $e4334fe97365ceb5$export$19389033401d366a(filename, backgroundSize, extension, retinaFilename, retinaSuffix) {
    var _ref;
    if (extension === void 0) extension = 'png';
    if (retinaSuffix === void 0) retinaSuffix = '_2x';
    if (!filename) throw new $e4334fe97365ceb5$var$PolishedError(58);
    // Replace the dot at the beginning of the passed extension if one exists
    var ext = extension.replace(/^\./, '');
    var rFilename = retinaFilename ? retinaFilename + "." + ext : "" + filename + retinaSuffix + "." + ext;
    return _ref = {
        backgroundImage: "url(" + filename + "." + ext + ")"
    }, _ref[$e4334fe97365ceb5$export$e79006618d7c6cc3()] = (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({
        backgroundImage: "url(" + rFilename + ")"
    }, backgroundSize ? {
        backgroundSize: backgroundSize
    } : {}), _ref;
}
/* eslint-disable key-spacing */ var $e4334fe97365ceb5$var$functionsMap = {
    easeInBack: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)',
    easeInCirc: 'cubic-bezier(0.600,  0.040, 0.980, 0.335)',
    easeInCubic: 'cubic-bezier(0.550,  0.055, 0.675, 0.190)',
    easeInExpo: 'cubic-bezier(0.950,  0.050, 0.795, 0.035)',
    easeInQuad: 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
    easeInQuart: 'cubic-bezier(0.895,  0.030, 0.685, 0.220)',
    easeInQuint: 'cubic-bezier(0.755,  0.050, 0.855, 0.060)',
    easeInSine: 'cubic-bezier(0.470,  0.000, 0.745, 0.715)',
    easeOutBack: 'cubic-bezier(0.175,  0.885, 0.320, 1.275)',
    easeOutCubic: 'cubic-bezier(0.215,  0.610, 0.355, 1.000)',
    easeOutCirc: 'cubic-bezier(0.075,  0.820, 0.165, 1.000)',
    easeOutExpo: 'cubic-bezier(0.190,  1.000, 0.220, 1.000)',
    easeOutQuad: 'cubic-bezier(0.250,  0.460, 0.450, 0.940)',
    easeOutQuart: 'cubic-bezier(0.165,  0.840, 0.440, 1.000)',
    easeOutQuint: 'cubic-bezier(0.230,  1.000, 0.320, 1.000)',
    easeOutSine: 'cubic-bezier(0.390,  0.575, 0.565, 1.000)',
    easeInOutBack: 'cubic-bezier(0.680, -0.550, 0.265, 1.550)',
    easeInOutCirc: 'cubic-bezier(0.785,  0.135, 0.150, 0.860)',
    easeInOutCubic: 'cubic-bezier(0.645,  0.045, 0.355, 1.000)',
    easeInOutExpo: 'cubic-bezier(1.000,  0.000, 0.000, 1.000)',
    easeInOutQuad: 'cubic-bezier(0.455,  0.030, 0.515, 0.955)',
    easeInOutQuart: 'cubic-bezier(0.770,  0.000, 0.175, 1.000)',
    easeInOutQuint: 'cubic-bezier(0.860,  0.000, 0.070, 1.000)',
    easeInOutSine: 'cubic-bezier(0.445,  0.050, 0.550, 0.950)'
};
/* eslint-enable key-spacing */ function $e4334fe97365ceb5$var$getTimingFunction(functionName) {
    return $e4334fe97365ceb5$var$functionsMap[functionName];
}
/**
 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
 *
 * @deprecated - This will be deprecated in v5 in favor of `easeIn`, `easeOut`, `easeInOut`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'transitionTimingFunction': timingFunctions('easeInQuad')
 * }
 *
 * // styled-components usage
 *  const div = styled.div`
 *   transitionTimingFunction: ${timingFunctions('easeInQuad')};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'transitionTimingFunction': 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
 * }
 */ function $e4334fe97365ceb5$export$61210fa83792a81(timingFunction) {
    return $e4334fe97365ceb5$var$getTimingFunction(timingFunction);
}
var $e4334fe97365ceb5$var$getBorderWidth = function getBorderWidth(pointingDirection, height, width) {
    var fullWidth = "" + width[0] + (width[1] || '');
    var halfWidth = "" + width[0] / 2 + (width[1] || '');
    var fullHeight = "" + height[0] + (height[1] || '');
    var halfHeight = "" + height[0] / 2 + (height[1] || '');
    switch(pointingDirection){
        case 'top':
            return "0 " + halfWidth + " " + fullHeight + " " + halfWidth;
        case 'topLeft':
            return fullWidth + " " + fullHeight + " 0 0";
        case 'left':
            return halfHeight + " " + fullWidth + " " + halfHeight + " 0";
        case 'bottomLeft':
            return fullWidth + " 0 0 " + fullHeight;
        case 'bottom':
            return fullHeight + " " + halfWidth + " 0 " + halfWidth;
        case 'bottomRight':
            return "0 0 " + fullWidth + " " + fullHeight;
        case 'right':
            return halfHeight + " 0 " + halfHeight + " " + fullWidth;
        case 'topRight':
        default:
            return "0 " + fullWidth + " " + fullHeight + " 0";
    }
};
var $e4334fe97365ceb5$var$getBorderColor = function getBorderColor(pointingDirection, foregroundColor) {
    switch(pointingDirection){
        case 'top':
        case 'bottomRight':
            return {
                borderBottomColor: foregroundColor
            };
        case 'right':
        case 'bottomLeft':
            return {
                borderLeftColor: foregroundColor
            };
        case 'bottom':
        case 'topLeft':
            return {
                borderTopColor: foregroundColor
            };
        case 'left':
        case 'topRight':
            return {
                borderRightColor: foregroundColor
            };
        default:
            throw new $e4334fe97365ceb5$var$PolishedError(59);
    }
};
/**
 * CSS to represent triangle with any pointing direction with an optional background color.
 *
 * @example
 * // Styles as object usage
 *
 * const styles = {
 *   ...triangle({ pointingDirection: 'right', width: '100px', height: '100px', foregroundColor: 'red' })
 * }
 *
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${triangle({ pointingDirection: 'right', width: '100px', height: '100px', foregroundColor: 'red' })}
 *
 *
 * // CSS as JS Output
 *
 * div: {
 *  'borderColor': 'transparent transparent transparent red',
 *  'borderStyle': 'solid',
 *  'borderWidth': '50px 0 50px 100px',
 *  'height': '0',
 *  'width': '0',
 * }
 */ function $e4334fe97365ceb5$export$9eed783d03e0135c(_ref) {
    var pointingDirection = _ref.pointingDirection, height = _ref.height, width = _ref.width, foregroundColor = _ref.foregroundColor, _ref$backgroundColor = _ref.backgroundColor, backgroundColor = _ref$backgroundColor === void 0 ? 'transparent' : _ref$backgroundColor;
    var widthAndUnit = $e4334fe97365ceb5$export$feec6b849ef388ab(width);
    var heightAndUnit = $e4334fe97365ceb5$export$feec6b849ef388ab(height);
    if (isNaN(heightAndUnit[0]) || isNaN(widthAndUnit[0])) throw new $e4334fe97365ceb5$var$PolishedError(60);
    return (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({
        width: '0',
        height: '0',
        borderColor: backgroundColor
    }, $e4334fe97365ceb5$var$getBorderColor(pointingDirection, foregroundColor), {
        borderStyle: 'solid',
        borderWidth: $e4334fe97365ceb5$var$getBorderWidth(pointingDirection, heightAndUnit, widthAndUnit)
    });
}
/**
 * Provides an easy way to change the `wordWrap` property.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...wordWrap('break-word')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${wordWrap('break-word')}
 * `
 *
 * // CSS as JS Output
 *
 * const styles = {
 *   overflowWrap: 'break-word',
 *   wordWrap: 'break-word',
 *   wordBreak: 'break-all',
 * }
 */ function $e4334fe97365ceb5$export$dca3d8ad656c34d2(wrap) {
    if (wrap === void 0) wrap = 'break-word';
    var wordBreak = wrap === 'break-word' ? 'break-all' : wrap;
    return {
        overflowWrap: wrap,
        wordWrap: wrap,
        wordBreak: wordBreak
    };
}
function $e4334fe97365ceb5$var$colorToInt(color) {
    return Math.round(color * 255);
}
function $e4334fe97365ceb5$var$convertToInt(red, green, blue) {
    return $e4334fe97365ceb5$var$colorToInt(red) + "," + $e4334fe97365ceb5$var$colorToInt(green) + "," + $e4334fe97365ceb5$var$colorToInt(blue);
}
function $e4334fe97365ceb5$var$hslToRgb(hue, saturation, lightness, convert) {
    if (convert === void 0) convert = $e4334fe97365ceb5$var$convertToInt;
    if (saturation === 0) // achromatic
    return convert(lightness, lightness, lightness);
    // formulae from https://en.wikipedia.org/wiki/HSL_and_HSV
    var huePrime = (hue % 360 + 360) % 360 / 60;
    var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
    var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
    var red = 0;
    var green = 0;
    var blue = 0;
    if (huePrime >= 0 && huePrime < 1) {
        red = chroma;
        green = secondComponent;
    } else if (huePrime >= 1 && huePrime < 2) {
        red = secondComponent;
        green = chroma;
    } else if (huePrime >= 2 && huePrime < 3) {
        green = chroma;
        blue = secondComponent;
    } else if (huePrime >= 3 && huePrime < 4) {
        green = secondComponent;
        blue = chroma;
    } else if (huePrime >= 4 && huePrime < 5) {
        red = secondComponent;
        blue = chroma;
    } else if (huePrime >= 5 && huePrime < 6) {
        red = chroma;
        blue = secondComponent;
    }
    var lightnessModification = lightness - chroma / 2;
    var finalRed = red + lightnessModification;
    var finalGreen = green + lightnessModification;
    var finalBlue = blue + lightnessModification;
    return convert(finalRed, finalGreen, finalBlue);
}
var $e4334fe97365ceb5$var$namedColorMap = {
    aliceblue: 'f0f8ff',
    antiquewhite: 'faebd7',
    aqua: '00ffff',
    aquamarine: '7fffd4',
    azure: 'f0ffff',
    beige: 'f5f5dc',
    bisque: 'ffe4c4',
    black: '000',
    blanchedalmond: 'ffebcd',
    blue: '0000ff',
    blueviolet: '8a2be2',
    brown: 'a52a2a',
    burlywood: 'deb887',
    cadetblue: '5f9ea0',
    chartreuse: '7fff00',
    chocolate: 'd2691e',
    coral: 'ff7f50',
    cornflowerblue: '6495ed',
    cornsilk: 'fff8dc',
    crimson: 'dc143c',
    cyan: '00ffff',
    darkblue: '00008b',
    darkcyan: '008b8b',
    darkgoldenrod: 'b8860b',
    darkgray: 'a9a9a9',
    darkgreen: '006400',
    darkgrey: 'a9a9a9',
    darkkhaki: 'bdb76b',
    darkmagenta: '8b008b',
    darkolivegreen: '556b2f',
    darkorange: 'ff8c00',
    darkorchid: '9932cc',
    darkred: '8b0000',
    darksalmon: 'e9967a',
    darkseagreen: '8fbc8f',
    darkslateblue: '483d8b',
    darkslategray: '2f4f4f',
    darkslategrey: '2f4f4f',
    darkturquoise: '00ced1',
    darkviolet: '9400d3',
    deeppink: 'ff1493',
    deepskyblue: '00bfff',
    dimgray: '696969',
    dimgrey: '696969',
    dodgerblue: '1e90ff',
    firebrick: 'b22222',
    floralwhite: 'fffaf0',
    forestgreen: '228b22',
    fuchsia: 'ff00ff',
    gainsboro: 'dcdcdc',
    ghostwhite: 'f8f8ff',
    gold: 'ffd700',
    goldenrod: 'daa520',
    gray: '808080',
    green: '008000',
    greenyellow: 'adff2f',
    grey: '808080',
    honeydew: 'f0fff0',
    hotpink: 'ff69b4',
    indianred: 'cd5c5c',
    indigo: '4b0082',
    ivory: 'fffff0',
    khaki: 'f0e68c',
    lavender: 'e6e6fa',
    lavenderblush: 'fff0f5',
    lawngreen: '7cfc00',
    lemonchiffon: 'fffacd',
    lightblue: 'add8e6',
    lightcoral: 'f08080',
    lightcyan: 'e0ffff',
    lightgoldenrodyellow: 'fafad2',
    lightgray: 'd3d3d3',
    lightgreen: '90ee90',
    lightgrey: 'd3d3d3',
    lightpink: 'ffb6c1',
    lightsalmon: 'ffa07a',
    lightseagreen: '20b2aa',
    lightskyblue: '87cefa',
    lightslategray: '789',
    lightslategrey: '789',
    lightsteelblue: 'b0c4de',
    lightyellow: 'ffffe0',
    lime: '0f0',
    limegreen: '32cd32',
    linen: 'faf0e6',
    magenta: 'f0f',
    maroon: '800000',
    mediumaquamarine: '66cdaa',
    mediumblue: '0000cd',
    mediumorchid: 'ba55d3',
    mediumpurple: '9370db',
    mediumseagreen: '3cb371',
    mediumslateblue: '7b68ee',
    mediumspringgreen: '00fa9a',
    mediumturquoise: '48d1cc',
    mediumvioletred: 'c71585',
    midnightblue: '191970',
    mintcream: 'f5fffa',
    mistyrose: 'ffe4e1',
    moccasin: 'ffe4b5',
    navajowhite: 'ffdead',
    navy: '000080',
    oldlace: 'fdf5e6',
    olive: '808000',
    olivedrab: '6b8e23',
    orange: 'ffa500',
    orangered: 'ff4500',
    orchid: 'da70d6',
    palegoldenrod: 'eee8aa',
    palegreen: '98fb98',
    paleturquoise: 'afeeee',
    palevioletred: 'db7093',
    papayawhip: 'ffefd5',
    peachpuff: 'ffdab9',
    peru: 'cd853f',
    pink: 'ffc0cb',
    plum: 'dda0dd',
    powderblue: 'b0e0e6',
    purple: '800080',
    rebeccapurple: '639',
    red: 'f00',
    rosybrown: 'bc8f8f',
    royalblue: '4169e1',
    saddlebrown: '8b4513',
    salmon: 'fa8072',
    sandybrown: 'f4a460',
    seagreen: '2e8b57',
    seashell: 'fff5ee',
    sienna: 'a0522d',
    silver: 'c0c0c0',
    skyblue: '87ceeb',
    slateblue: '6a5acd',
    slategray: '708090',
    slategrey: '708090',
    snow: 'fffafa',
    springgreen: '00ff7f',
    steelblue: '4682b4',
    tan: 'd2b48c',
    teal: '008080',
    thistle: 'd8bfd8',
    tomato: 'ff6347',
    turquoise: '40e0d0',
    violet: 'ee82ee',
    wheat: 'f5deb3',
    white: 'fff',
    whitesmoke: 'f5f5f5',
    yellow: 'ff0',
    yellowgreen: '9acd32'
};
/**
 * Checks if a string is a CSS named color and returns its equivalent hex value, otherwise returns the original color.
 * @private
 */ function $e4334fe97365ceb5$var$nameToHex(color) {
    if (typeof color !== 'string') return color;
    var normalizedColorName = color.toLowerCase();
    return $e4334fe97365ceb5$var$namedColorMap[normalizedColorName] ? "#" + $e4334fe97365ceb5$var$namedColorMap[normalizedColorName] : color;
}
var $e4334fe97365ceb5$var$hexRegex = /^#[a-fA-F0-9]{6}$/;
var $e4334fe97365ceb5$var$hexRgbaRegex = /^#[a-fA-F0-9]{8}$/;
var $e4334fe97365ceb5$var$reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
var $e4334fe97365ceb5$var$reducedRgbaHexRegex = /^#[a-fA-F0-9]{4}$/;
var $e4334fe97365ceb5$var$rgbRegex = /^rgb\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*\)$/i;
var $e4334fe97365ceb5$var$rgbaRegex = /^rgb(?:a)?\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
var $e4334fe97365ceb5$var$hslRegex = /^hsl\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i;
var $e4334fe97365ceb5$var$hslaRegex = /^hsl(?:a)?\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
/**
 * Returns an RgbColor or RgbaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a RgbColor or RgbaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = parseToRgb('rgb(255, 0, 0)');
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = parseToRgb('hsla(210, 10%, 40%, 0.75)');
 */ function $e4334fe97365ceb5$export$2f48baff6995707a(color) {
    if (typeof color !== 'string') throw new $e4334fe97365ceb5$var$PolishedError(3);
    var normalizedColor = $e4334fe97365ceb5$var$nameToHex(color);
    if (normalizedColor.match($e4334fe97365ceb5$var$hexRegex)) return {
        red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
        green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
        blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16)
    };
    if (normalizedColor.match($e4334fe97365ceb5$var$hexRgbaRegex)) {
        var alpha = parseFloat((parseInt("" + normalizedColor[7] + normalizedColor[8], 16) / 255).toFixed(2));
        return {
            red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
            green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
            blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16),
            alpha: alpha
        };
    }
    if (normalizedColor.match($e4334fe97365ceb5$var$reducedHexRegex)) return {
        red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
        green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
        blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16)
    };
    if (normalizedColor.match($e4334fe97365ceb5$var$reducedRgbaHexRegex)) {
        var _alpha = parseFloat((parseInt("" + normalizedColor[4] + normalizedColor[4], 16) / 255).toFixed(2));
        return {
            red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
            green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
            blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16),
            alpha: _alpha
        };
    }
    var rgbMatched = $e4334fe97365ceb5$var$rgbRegex.exec(normalizedColor);
    if (rgbMatched) return {
        red: parseInt("" + rgbMatched[1], 10),
        green: parseInt("" + rgbMatched[2], 10),
        blue: parseInt("" + rgbMatched[3], 10)
    };
    var rgbaMatched = $e4334fe97365ceb5$var$rgbaRegex.exec(normalizedColor.substring(0, 50));
    if (rgbaMatched) return {
        red: parseInt("" + rgbaMatched[1], 10),
        green: parseInt("" + rgbaMatched[2], 10),
        blue: parseInt("" + rgbaMatched[3], 10),
        alpha: parseFloat("" + rgbaMatched[4]) > 1 ? parseFloat("" + rgbaMatched[4]) / 100 : parseFloat("" + rgbaMatched[4])
    };
    var hslMatched = $e4334fe97365ceb5$var$hslRegex.exec(normalizedColor);
    if (hslMatched) {
        var hue = parseInt("" + hslMatched[1], 10);
        var saturation = parseInt("" + hslMatched[2], 10) / 100;
        var lightness = parseInt("" + hslMatched[3], 10) / 100;
        var rgbColorString = "rgb(" + $e4334fe97365ceb5$var$hslToRgb(hue, saturation, lightness) + ")";
        var hslRgbMatched = $e4334fe97365ceb5$var$rgbRegex.exec(rgbColorString);
        if (!hslRgbMatched) throw new $e4334fe97365ceb5$var$PolishedError(4, normalizedColor, rgbColorString);
        return {
            red: parseInt("" + hslRgbMatched[1], 10),
            green: parseInt("" + hslRgbMatched[2], 10),
            blue: parseInt("" + hslRgbMatched[3], 10)
        };
    }
    var hslaMatched = $e4334fe97365ceb5$var$hslaRegex.exec(normalizedColor.substring(0, 50));
    if (hslaMatched) {
        var _hue = parseInt("" + hslaMatched[1], 10);
        var _saturation = parseInt("" + hslaMatched[2], 10) / 100;
        var _lightness = parseInt("" + hslaMatched[3], 10) / 100;
        var _rgbColorString = "rgb(" + $e4334fe97365ceb5$var$hslToRgb(_hue, _saturation, _lightness) + ")";
        var _hslRgbMatched = $e4334fe97365ceb5$var$rgbRegex.exec(_rgbColorString);
        if (!_hslRgbMatched) throw new $e4334fe97365ceb5$var$PolishedError(4, normalizedColor, _rgbColorString);
        return {
            red: parseInt("" + _hslRgbMatched[1], 10),
            green: parseInt("" + _hslRgbMatched[2], 10),
            blue: parseInt("" + _hslRgbMatched[3], 10),
            alpha: parseFloat("" + hslaMatched[4]) > 1 ? parseFloat("" + hslaMatched[4]) / 100 : parseFloat("" + hslaMatched[4])
        };
    }
    throw new $e4334fe97365ceb5$var$PolishedError(5);
}
function $e4334fe97365ceb5$var$rgbToHsl(color) {
    // make sure rgb are contained in a set of [0, 255]
    var red = color.red / 255;
    var green = color.green / 255;
    var blue = color.blue / 255;
    var max = Math.max(red, green, blue);
    var min = Math.min(red, green, blue);
    var lightness = (max + min) / 2;
    if (max === min) {
        // achromatic
        if (color.alpha !== undefined) return {
            hue: 0,
            saturation: 0,
            lightness: lightness,
            alpha: color.alpha
        };
        else return {
            hue: 0,
            saturation: 0,
            lightness: lightness
        };
    }
    var hue;
    var delta = max - min;
    var saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);
    switch(max){
        case red:
            hue = (green - blue) / delta + (green < blue ? 6 : 0);
            break;
        case green:
            hue = (blue - red) / delta + 2;
            break;
        default:
            // blue case
            hue = (red - green) / delta + 4;
            break;
    }
    hue *= 60;
    if (color.alpha !== undefined) return {
        hue: hue,
        saturation: saturation,
        lightness: lightness,
        alpha: color.alpha
    };
    return {
        hue: hue,
        saturation: saturation,
        lightness: lightness
    };
}
/**
 * Returns an HslColor or HslaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a HslColor or HslaColor object back to a string.
 *
 * @example
 * // Assigns `{ hue: 0, saturation: 1, lightness: 0.5 }` to color1
 * const color1 = parseToHsl('rgb(255, 0, 0)');
 * // Assigns `{ hue: 128, saturation: 1, lightness: 0.5, alpha: 0.75 }` to color2
 * const color2 = parseToHsl('hsla(128, 100%, 50%, 0.75)');
 */ function $e4334fe97365ceb5$export$1286688e1b3fde9c(color) {
    // Note: At a later stage we can optimize this function as right now a hsl
    // color would be parsed converted to rgb values and converted back to hsl.
    return $e4334fe97365ceb5$var$rgbToHsl($e4334fe97365ceb5$export$2f48baff6995707a(color));
}
/**
 * Reduces hex values if possible e.g. #ff8866 to #f86
 * @private
 */ var $e4334fe97365ceb5$var$reduceHexValue = function reduceHexValue(value) {
    if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) return "#" + value[1] + value[3] + value[5];
    return value;
};
var $e4334fe97365ceb5$var$reduceHexValue$1 = $e4334fe97365ceb5$var$reduceHexValue;
function $e4334fe97365ceb5$var$numberToHex(value) {
    var hex = value.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
}
function $e4334fe97365ceb5$var$colorToHex(color) {
    return $e4334fe97365ceb5$var$numberToHex(Math.round(color * 255));
}
function $e4334fe97365ceb5$var$convertToHex(red, green, blue) {
    return $e4334fe97365ceb5$var$reduceHexValue$1("#" + $e4334fe97365ceb5$var$colorToHex(red) + $e4334fe97365ceb5$var$colorToHex(green) + $e4334fe97365ceb5$var$colorToHex(blue));
}
function $e4334fe97365ceb5$var$hslToHex(hue, saturation, lightness) {
    return $e4334fe97365ceb5$var$hslToRgb(hue, saturation, lightness, $e4334fe97365ceb5$var$convertToHex);
}
/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsl(359, 0.75, 0.4),
 *   background: hsl({ hue: 360, saturation: 0.75, lightness: 0.4 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsl(359, 0.75, 0.4)};
 *   background: ${hsl({ hue: 360, saturation: 0.75, lightness: 0.4 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#b3191c";
 *   background: "#b3191c";
 * }
 */ function $e4334fe97365ceb5$export$8f4a7c0bb78e6ea8(value, saturation, lightness) {
    if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number') return $e4334fe97365ceb5$var$hslToHex(value, saturation, lightness);
    else if (typeof value === 'object' && saturation === undefined && lightness === undefined) return $e4334fe97365ceb5$var$hslToHex(value.hue, value.saturation, value.lightness);
    throw new $e4334fe97365ceb5$var$PolishedError(1);
}
/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsla(359, 0.75, 0.4, 0.7),
 *   background: hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 }),
 *   background: hsla(359, 0.75, 0.4, 1),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsla(359, 0.75, 0.4, 0.7)};
 *   background: ${hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 })};
 *   background: ${hsla(359, 0.75, 0.4, 1)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(179,25,28,0.7)";
 *   background: "rgba(179,25,28,0.7)";
 *   background: "#b3191c";
 * }
 */ function $e4334fe97365ceb5$export$810b04175080204c(value, saturation, lightness, alpha) {
    if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number' && typeof alpha === 'number') return alpha >= 1 ? $e4334fe97365ceb5$var$hslToHex(value, saturation, lightness) : "rgba(" + $e4334fe97365ceb5$var$hslToRgb(value, saturation, lightness) + "," + alpha + ")";
    else if (typeof value === 'object' && saturation === undefined && lightness === undefined && alpha === undefined) return value.alpha >= 1 ? $e4334fe97365ceb5$var$hslToHex(value.hue, value.saturation, value.lightness) : "rgba(" + $e4334fe97365ceb5$var$hslToRgb(value.hue, value.saturation, value.lightness) + "," + value.alpha + ")";
    throw new $e4334fe97365ceb5$var$PolishedError(2);
}
/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgb(255, 205, 100),
 *   background: rgb({ red: 255, green: 205, blue: 100 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgb(255, 205, 100)};
 *   background: ${rgb({ red: 255, green: 205, blue: 100 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffcd64";
 *   background: "#ffcd64";
 * }
 */ function $e4334fe97365ceb5$export$8972dc0e6ad9238f(value, green, blue) {
    if (typeof value === 'number' && typeof green === 'number' && typeof blue === 'number') return $e4334fe97365ceb5$var$reduceHexValue$1("#" + $e4334fe97365ceb5$var$numberToHex(value) + $e4334fe97365ceb5$var$numberToHex(green) + $e4334fe97365ceb5$var$numberToHex(blue));
    else if (typeof value === 'object' && green === undefined && blue === undefined) return $e4334fe97365ceb5$var$reduceHexValue$1("#" + $e4334fe97365ceb5$var$numberToHex(value.red) + $e4334fe97365ceb5$var$numberToHex(value.green) + $e4334fe97365ceb5$var$numberToHex(value.blue));
    throw new $e4334fe97365ceb5$var$PolishedError(6);
}
/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * Can also be used to fade a color by passing a hex value or named CSS color along with an alpha value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgba(255, 205, 100, 0.7),
 *   background: rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 }),
 *   background: rgba(255, 205, 100, 1),
 *   background: rgba('#ffffff', 0.4),
 *   background: rgba('black', 0.7),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgba(255, 205, 100, 0.7)};
 *   background: ${rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 })};
 *   background: ${rgba(255, 205, 100, 1)};
 *   background: ${rgba('#ffffff', 0.4)};
 *   background: ${rgba('black', 0.7)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,205,100,0.7)";
 *   background: "rgba(255,205,100,0.7)";
 *   background: "#ffcd64";
 *   background: "rgba(255,255,255,0.4)";
 *   background: "rgba(0,0,0,0.7)";
 * }
 */ function $e4334fe97365ceb5$export$4e46ac54fc82cf3b(firstValue, secondValue, thirdValue, fourthValue) {
    if (typeof firstValue === 'string' && typeof secondValue === 'number') {
        var rgbValue = $e4334fe97365ceb5$export$2f48baff6995707a(firstValue);
        return "rgba(" + rgbValue.red + "," + rgbValue.green + "," + rgbValue.blue + "," + secondValue + ")";
    } else if (typeof firstValue === 'number' && typeof secondValue === 'number' && typeof thirdValue === 'number' && typeof fourthValue === 'number') return fourthValue >= 1 ? $e4334fe97365ceb5$export$8972dc0e6ad9238f(firstValue, secondValue, thirdValue) : "rgba(" + firstValue + "," + secondValue + "," + thirdValue + "," + fourthValue + ")";
    else if (typeof firstValue === 'object' && secondValue === undefined && thirdValue === undefined && fourthValue === undefined) return firstValue.alpha >= 1 ? $e4334fe97365ceb5$export$8972dc0e6ad9238f(firstValue.red, firstValue.green, firstValue.blue) : "rgba(" + firstValue.red + "," + firstValue.green + "," + firstValue.blue + "," + firstValue.alpha + ")";
    throw new $e4334fe97365ceb5$var$PolishedError(7);
}
var $e4334fe97365ceb5$var$isRgb = function isRgb(color) {
    return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};
var $e4334fe97365ceb5$var$isRgba = function isRgba(color) {
    return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && typeof color.alpha === 'number';
};
var $e4334fe97365ceb5$var$isHsl = function isHsl(color) {
    return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};
var $e4334fe97365ceb5$var$isHsla = function isHsla(color) {
    return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && typeof color.alpha === 'number';
};
/**
 * Converts a RgbColor, RgbaColor, HslColor or HslaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `rgb`, `rgba`, `hsl` or `hsla`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: toColorString({ red: 255, green: 205, blue: 100 }),
 *   background: toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 }),
 *   background: toColorString({ hue: 240, saturation: 1, lightness: 0.5 }),
 *   background: toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${toColorString({ red: 255, green: 205, blue: 100 })};
 *   background: ${toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 })};
 *   background: ${toColorString({ hue: 240, saturation: 1, lightness: 0.5 })};
 *   background: ${toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#ffcd64";
 *   background: "rgba(255,205,100,0.72)";
 *   background: "#00f";
 *   background: "rgba(179,25,25,0.72)";
 * }
 */ function $e4334fe97365ceb5$export$42fe740cdf79b2df(color) {
    if (typeof color !== 'object') throw new $e4334fe97365ceb5$var$PolishedError(8);
    if ($e4334fe97365ceb5$var$isRgba(color)) return $e4334fe97365ceb5$export$4e46ac54fc82cf3b(color);
    if ($e4334fe97365ceb5$var$isRgb(color)) return $e4334fe97365ceb5$export$8972dc0e6ad9238f(color);
    if ($e4334fe97365ceb5$var$isHsla(color)) return $e4334fe97365ceb5$export$810b04175080204c(color);
    if ($e4334fe97365ceb5$var$isHsl(color)) return $e4334fe97365ceb5$export$8f4a7c0bb78e6ea8(color);
    throw new $e4334fe97365ceb5$var$PolishedError(8);
}
// Type definitions taken from https://github.com/gcanti/flow-static-land/blob/master/src/Fun.js
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-redeclare
function $e4334fe97365ceb5$var$curried(f, length, acc) {
    return function fn() {
        // eslint-disable-next-line prefer-rest-params
        var combined = acc.concat(Array.prototype.slice.call(arguments));
        return combined.length >= length ? f.apply(this, combined) : $e4334fe97365ceb5$var$curried(f, length, combined);
    };
}
// eslint-disable-next-line no-redeclare
function $e4334fe97365ceb5$var$curry(f) {
    // eslint-disable-line no-redeclare
    return $e4334fe97365ceb5$var$curried(f, f.length, []);
}
/**
 * Changes the hue of the color. Hue is a number between 0 to 360. The first
 * argument for adjustHue is the amount of degrees the color is rotated around
 * the color wheel, always producing a positive hue value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: adjustHue(180, '#448'),
 *   background: adjustHue('180', 'rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${adjustHue(180, '#448')};
 *   background: ${adjustHue('180', 'rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#888844";
 *   background: "rgba(136,136,68,0.7)";
 * }
 */ function $e4334fe97365ceb5$var$adjustHue(degree, color) {
    if (color === 'transparent') return color;
    var hslColor = $e4334fe97365ceb5$export$1286688e1b3fde9c(color);
    return $e4334fe97365ceb5$export$42fe740cdf79b2df((0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({}, hslColor, {
        hue: hslColor.hue + parseFloat(degree)
    }));
}
// prettier-ignore
var $e4334fe97365ceb5$var$curriedAdjustHue = $e4334fe97365ceb5$var$curry /* ::<number | string, string, string> */ ($e4334fe97365ceb5$var$adjustHue);
var $e4334fe97365ceb5$export$2b372a09365374d6 = $e4334fe97365ceb5$var$curriedAdjustHue;
/**
 * Returns the complement of the provided color. This is identical to adjustHue(180, <color>).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: complement('#448'),
 *   background: complement('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${complement('#448')};
 *   background: ${complement('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#884";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */ function $e4334fe97365ceb5$export$bd4f6f7e1823bc9e(color) {
    if (color === 'transparent') return color;
    var hslColor = $e4334fe97365ceb5$export$1286688e1b3fde9c(color);
    return $e4334fe97365ceb5$export$42fe740cdf79b2df((0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({}, hslColor, {
        hue: (hslColor.hue + 180) % 360
    }));
}
function $e4334fe97365ceb5$var$guard(lowerBoundary, upperBoundary, value) {
    return Math.max(lowerBoundary, Math.min(upperBoundary, value));
}
/**
 * Returns a string value for the darkened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: darken(0.2, '#FFCD64'),
 *   background: darken('0.2', 'rgba(255,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${darken(0.2, '#FFCD64')};
 *   background: ${darken('0.2', 'rgba(255,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffbd31";
 *   background: "rgba(255,189,49,0.7)";
 * }
 */ function $e4334fe97365ceb5$var$darken(amount, color) {
    if (color === 'transparent') return color;
    var hslColor = $e4334fe97365ceb5$export$1286688e1b3fde9c(color);
    return $e4334fe97365ceb5$export$42fe740cdf79b2df((0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({}, hslColor, {
        lightness: $e4334fe97365ceb5$var$guard(0, 1, hslColor.lightness - parseFloat(amount))
    }));
}
// prettier-ignore
var $e4334fe97365ceb5$var$curriedDarken = $e4334fe97365ceb5$var$curry /* ::<number | string, string, string> */ ($e4334fe97365ceb5$var$darken);
var $e4334fe97365ceb5$export$4b073707ff63303 = $e4334fe97365ceb5$var$curriedDarken;
/**
 * Decreases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the desaturate function is the amount by how much the color
 * intensity should be decreased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: desaturate(0.2, '#CCCD64'),
 *   background: desaturate('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${desaturate(0.2, '#CCCD64')};
 *   background: ${desaturate('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#b8b979";
 *   background: "rgba(184,185,121,0.7)";
 * }
 */ function $e4334fe97365ceb5$var$desaturate(amount, color) {
    if (color === 'transparent') return color;
    var hslColor = $e4334fe97365ceb5$export$1286688e1b3fde9c(color);
    return $e4334fe97365ceb5$export$42fe740cdf79b2df((0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({}, hslColor, {
        saturation: $e4334fe97365ceb5$var$guard(0, 1, hslColor.saturation - parseFloat(amount))
    }));
}
// prettier-ignore
var $e4334fe97365ceb5$var$curriedDesaturate = $e4334fe97365ceb5$var$curry /* ::<number | string, string, string> */ ($e4334fe97365ceb5$var$desaturate);
var $e4334fe97365ceb5$export$fb75607d98509d9 = $e4334fe97365ceb5$var$curriedDesaturate;
/**
 * Returns a number (float) representing the luminance of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff',
 *   background: getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)',
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff'};
 *   background: ${getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)'};
 *
 * // CSS in JS Output
 *
 * div {
 *   background: "#CCCD64";
 *   background: "rgba(58, 133, 255, 1)";
 * }
 */ function $e4334fe97365ceb5$export$c852d90bf7403b62(color) {
    if (color === 'transparent') return 0;
    var rgbColor = $e4334fe97365ceb5$export$2f48baff6995707a(color);
    var _Object$keys$map = Object.keys(rgbColor).map(function(key) {
        var channel = rgbColor[key] / 255;
        return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
    }), r = _Object$keys$map[0], g = _Object$keys$map[1], b = _Object$keys$map[2];
    return parseFloat((0.2126 * r + 0.7152 * g + 0.0722 * b).toFixed(3));
}
/**
 * Returns the contrast ratio between two colors based on
 * [W3's recommended equation for calculating contrast](http://www.w3.org/TR/WCAG20/#contrast-ratiodef).
 *
 * @example
 * const contrastRatio = getContrast('#444', '#fff');
 */ function $e4334fe97365ceb5$export$850ce485a60d103b(color1, color2) {
    var luminance1 = $e4334fe97365ceb5$export$c852d90bf7403b62(color1);
    var luminance2 = $e4334fe97365ceb5$export$c852d90bf7403b62(color2);
    return parseFloat((luminance1 > luminance2 ? (luminance1 + 0.05) / (luminance2 + 0.05) : (luminance2 + 0.05) / (luminance1 + 0.05)).toFixed(2));
}
/**
 * Converts the color to a grayscale, by reducing its saturation to 0.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: grayscale('#CCCD64'),
 *   background: grayscale('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${grayscale('#CCCD64')};
 *   background: ${grayscale('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#999";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */ function $e4334fe97365ceb5$export$6f416a6db2dfcd5c(color) {
    if (color === 'transparent') return color;
    return $e4334fe97365ceb5$export$42fe740cdf79b2df((0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({}, $e4334fe97365ceb5$export$1286688e1b3fde9c(color), {
        saturation: 0
    }));
}
/**
 * Converts a HslColor or HslaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `hsl` or `hsla`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hslToColorString({ hue: 240, saturation: 1, lightness: 0.5 }),
 *   background: hslToColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hslToColorString({ hue: 240, saturation: 1, lightness: 0.5 })};
 *   background: ${hslToColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#00f";
 *   background: "rgba(179,25,25,0.72)";
 * }
 */ function $e4334fe97365ceb5$export$97fc773b219a4ae(color) {
    if (typeof color === 'object' && typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number') {
        if (color.alpha && typeof color.alpha === 'number') return $e4334fe97365ceb5$export$810b04175080204c({
            hue: color.hue,
            saturation: color.saturation,
            lightness: color.lightness,
            alpha: color.alpha
        });
        return $e4334fe97365ceb5$export$8f4a7c0bb78e6ea8({
            hue: color.hue,
            saturation: color.saturation,
            lightness: color.lightness
        });
    }
    throw new $e4334fe97365ceb5$var$PolishedError(45);
}
/**
 * Inverts the red, green and blue values of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: invert('#CCCD64'),
 *   background: invert('rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${invert('#CCCD64')};
 *   background: ${invert('rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#33329b";
 *   background: "rgba(154,155,50,0.7)";
 * }
 */ function $e4334fe97365ceb5$export$6897c284b6f9f4dc(color) {
    if (color === 'transparent') return color;
    // parse color string to rgb
    var value = $e4334fe97365ceb5$export$2f48baff6995707a(color);
    return $e4334fe97365ceb5$export$42fe740cdf79b2df((0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({}, value, {
        red: 255 - value.red,
        green: 255 - value.green,
        blue: 255 - value.blue
    }));
}
/**
 * Returns a string value for the lightened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: lighten(0.2, '#CCCD64'),
 *   background: lighten('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${lighten(0.2, '#FFCD64')};
 *   background: ${lighten('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e5e6b1";
 *   background: "rgba(229,230,177,0.7)";
 * }
 */ function $e4334fe97365ceb5$var$lighten(amount, color) {
    if (color === 'transparent') return color;
    var hslColor = $e4334fe97365ceb5$export$1286688e1b3fde9c(color);
    return $e4334fe97365ceb5$export$42fe740cdf79b2df((0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({}, hslColor, {
        lightness: $e4334fe97365ceb5$var$guard(0, 1, hslColor.lightness + parseFloat(amount))
    }));
}
// prettier-ignore
var $e4334fe97365ceb5$var$curriedLighten = $e4334fe97365ceb5$var$curry /* ::<number | string, string, string> */ ($e4334fe97365ceb5$var$lighten);
var $e4334fe97365ceb5$export$c0816ed86df316af = $e4334fe97365ceb5$var$curriedLighten;
/**
 * Determines which contrast guidelines have been met for two colors.
 * Based on the [contrast calculations recommended by W3](https://www.w3.org/WAI/WCAG21/Understanding/contrast-enhanced.html).
 *
 * @example
 * const scores = meetsContrastGuidelines('#444', '#fff');
 */ function $e4334fe97365ceb5$export$bc0d548020bc5a2(color1, color2) {
    var contrastRatio = $e4334fe97365ceb5$export$850ce485a60d103b(color1, color2);
    return {
        AA: contrastRatio >= 4.5,
        AALarge: contrastRatio >= 3,
        AAA: contrastRatio >= 7,
        AAALarge: contrastRatio >= 4.5
    };
}
/**
 * Mixes the two provided colors together by calculating the average of each of the RGB components weighted to the first color by the provided weight.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: mix(0.5, '#f00', '#00f')
 *   background: mix(0.25, '#f00', '#00f')
 *   background: mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${mix(0.5, '#f00', '#00f')};
 *   background: ${mix(0.25, '#f00', '#00f')};
 *   background: ${mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#7f007f";
 *   background: "#3f00bf";
 *   background: "rgba(63, 0, 191, 0.75)";
 * }
 */ function $e4334fe97365ceb5$var$mix(weight, color, otherColor) {
    if (color === 'transparent') return otherColor;
    if (otherColor === 'transparent') return color;
    if (weight === 0) return otherColor;
    var parsedColor1 = $e4334fe97365ceb5$export$2f48baff6995707a(color);
    var color1 = (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({}, parsedColor1, {
        alpha: typeof parsedColor1.alpha === 'number' ? parsedColor1.alpha : 1
    });
    var parsedColor2 = $e4334fe97365ceb5$export$2f48baff6995707a(otherColor);
    var color2 = (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({}, parsedColor2, {
        alpha: typeof parsedColor2.alpha === 'number' ? parsedColor2.alpha : 1
    });
    // The formula is copied from the original Sass implementation:
    // http://sass-lang.com/documentation/Sass/Script/Functions.html#mix-instance_method
    var alphaDelta = color1.alpha - color2.alpha;
    var x = parseFloat(weight) * 2 - 1;
    var y = x * alphaDelta === -1 ? x : x + alphaDelta;
    var z = 1 + x * alphaDelta;
    var weight1 = (y / z + 1) / 2.0;
    var weight2 = 1 - weight1;
    var mixedColor = {
        red: Math.floor(color1.red * weight1 + color2.red * weight2),
        green: Math.floor(color1.green * weight1 + color2.green * weight2),
        blue: Math.floor(color1.blue * weight1 + color2.blue * weight2),
        alpha: color1.alpha * parseFloat(weight) + color2.alpha * (1 - parseFloat(weight))
    };
    return $e4334fe97365ceb5$export$4e46ac54fc82cf3b(mixedColor);
}
// prettier-ignore
var $e4334fe97365ceb5$var$curriedMix = $e4334fe97365ceb5$var$curry /* ::<number | string, string, string, string> */ ($e4334fe97365ceb5$var$mix);
var $e4334fe97365ceb5$export$2c9e8a9632a706b2 = $e4334fe97365ceb5$var$curriedMix;
/**
 * Increases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: opacify(0.1, 'rgba(255, 255, 255, 0.9)');
 *   background: opacify(0.2, 'hsla(0, 0%, 100%, 0.5)'),
 *   background: opacify('0.5', 'rgba(255, 0, 0, 0.2)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${opacify(0.1, 'rgba(255, 255, 255, 0.9)')};
 *   background: ${opacify(0.2, 'hsla(0, 0%, 100%, 0.5)')},
 *   background: ${opacify('0.5', 'rgba(255, 0, 0, 0.2)')},
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#fff";
 *   background: "rgba(255,255,255,0.7)";
 *   background: "rgba(255,0,0,0.7)";
 * }
 */ function $e4334fe97365ceb5$var$opacify(amount, color) {
    if (color === 'transparent') return color;
    var parsedColor = $e4334fe97365ceb5$export$2f48baff6995707a(color);
    var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;
    var colorWithAlpha = (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({}, parsedColor, {
        alpha: $e4334fe97365ceb5$var$guard(0, 1, (alpha * 100 + parseFloat(amount) * 100) / 100)
    });
    return $e4334fe97365ceb5$export$4e46ac54fc82cf3b(colorWithAlpha);
}
// prettier-ignore
var $e4334fe97365ceb5$var$curriedOpacify = $e4334fe97365ceb5$var$curry /* ::<number | string, string, string> */ ($e4334fe97365ceb5$var$opacify);
var $e4334fe97365ceb5$export$f4f50e3877dd0530 = $e4334fe97365ceb5$var$curriedOpacify;
var $e4334fe97365ceb5$var$defaultReturnIfLightColor = '#000';
var $e4334fe97365ceb5$var$defaultReturnIfDarkColor = '#fff';
/**
 * Returns black or white (or optional passed colors) for best
 * contrast depending on the luminosity of the given color.
 * When passing custom return colors, strict mode ensures that the
 * return color always meets or exceeds WCAG level AA or greater. If this test
 * fails, the default return color (black or white) is returned in place of the
 * custom return color. You can optionally turn off strict mode.
 *
 * Follows [W3C specs for readability](https://www.w3.org/TR/WCAG20-TECHS/G18.html).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   color: readableColor('#000'),
 *   color: readableColor('black', '#001', '#ff8'),
 *   color: readableColor('white', '#001', '#ff8'),
 *   color: readableColor('red', '#333', '#ddd', true)
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   color: ${readableColor('#000')};
 *   color: ${readableColor('black', '#001', '#ff8')};
 *   color: ${readableColor('white', '#001', '#ff8')};
 *   color: ${readableColor('red', '#333', '#ddd', true)};
 * `
 *
 * // CSS in JS Output
 * element {
 *   color: "#fff";
 *   color: "#ff8";
 *   color: "#001";
 *   color: "#000";
 * }
 */ function $e4334fe97365ceb5$export$61654c1796c44811(color, returnIfLightColor, returnIfDarkColor, strict) {
    if (returnIfLightColor === void 0) returnIfLightColor = $e4334fe97365ceb5$var$defaultReturnIfLightColor;
    if (returnIfDarkColor === void 0) returnIfDarkColor = $e4334fe97365ceb5$var$defaultReturnIfDarkColor;
    if (strict === void 0) strict = true;
    var isColorLight = $e4334fe97365ceb5$export$c852d90bf7403b62(color) > 0.179;
    var preferredReturnColor = isColorLight ? returnIfLightColor : returnIfDarkColor;
    if (!strict || $e4334fe97365ceb5$export$850ce485a60d103b(color, preferredReturnColor) >= 4.5) return preferredReturnColor;
    return isColorLight ? $e4334fe97365ceb5$var$defaultReturnIfLightColor : $e4334fe97365ceb5$var$defaultReturnIfDarkColor;
}
/**
 * Converts a RgbColor or RgbaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `rgb` or `rgba`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgbToColorString({ red: 255, green: 205, blue: 100 }),
 *   background: rgbToColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgbToColorString({ red: 255, green: 205, blue: 100 })};
 *   background: ${rgbToColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#ffcd64";
 *   background: "rgba(255,205,100,0.72)";
 * }
 */ function $e4334fe97365ceb5$export$34b0917fcca19deb(color) {
    if (typeof color === 'object' && typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number') {
        if (typeof color.alpha === 'number') return $e4334fe97365ceb5$export$4e46ac54fc82cf3b({
            red: color.red,
            green: color.green,
            blue: color.blue,
            alpha: color.alpha
        });
        return $e4334fe97365ceb5$export$8972dc0e6ad9238f({
            red: color.red,
            green: color.green,
            blue: color.blue
        });
    }
    throw new $e4334fe97365ceb5$var$PolishedError(46);
}
/**
 * Increases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the saturate function is the amount by how much the color
 * intensity should be increased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: saturate(0.2, '#CCCD64'),
 *   background: saturate('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${saturate(0.2, '#FFCD64')};
 *   background: ${saturate('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e0e250";
 *   background: "rgba(224,226,80,0.7)";
 * }
 */ function $e4334fe97365ceb5$var$saturate(amount, color) {
    if (color === 'transparent') return color;
    var hslColor = $e4334fe97365ceb5$export$1286688e1b3fde9c(color);
    return $e4334fe97365ceb5$export$42fe740cdf79b2df((0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({}, hslColor, {
        saturation: $e4334fe97365ceb5$var$guard(0, 1, hslColor.saturation + parseFloat(amount))
    }));
}
// prettier-ignore
var $e4334fe97365ceb5$var$curriedSaturate = $e4334fe97365ceb5$var$curry /* ::<number | string, string, string> */ ($e4334fe97365ceb5$var$saturate);
var $e4334fe97365ceb5$export$5fcac96f5a87e3db = $e4334fe97365ceb5$var$curriedSaturate;
/**
 * Sets the hue of a color to the provided value. The hue range can be
 * from 0 and 359.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setHue(42, '#CCCD64'),
 *   background: setHue('244', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setHue(42, '#CCCD64')};
 *   background: ${setHue('244', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#cdae64";
 *   background: "rgba(107,100,205,0.7)";
 * }
 */ function $e4334fe97365ceb5$var$setHue(hue, color) {
    if (color === 'transparent') return color;
    return $e4334fe97365ceb5$export$42fe740cdf79b2df((0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({}, $e4334fe97365ceb5$export$1286688e1b3fde9c(color), {
        hue: parseFloat(hue)
    }));
}
// prettier-ignore
var $e4334fe97365ceb5$var$curriedSetHue = $e4334fe97365ceb5$var$curry /* ::<number | string, string, string> */ ($e4334fe97365ceb5$var$setHue);
var $e4334fe97365ceb5$export$3bf58ce3e497a846 = $e4334fe97365ceb5$var$curriedSetHue;
/**
 * Sets the lightness of a color to the provided value. The lightness range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setLightness(0.2, '#CCCD64'),
 *   background: setLightness('0.75', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setLightness(0.2, '#CCCD64')};
 *   background: ${setLightness('0.75', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#4d4d19";
 *   background: "rgba(223,224,159,0.7)";
 * }
 */ function $e4334fe97365ceb5$var$setLightness(lightness, color) {
    if (color === 'transparent') return color;
    return $e4334fe97365ceb5$export$42fe740cdf79b2df((0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({}, $e4334fe97365ceb5$export$1286688e1b3fde9c(color), {
        lightness: parseFloat(lightness)
    }));
}
// prettier-ignore
var $e4334fe97365ceb5$var$curriedSetLightness = $e4334fe97365ceb5$var$curry /* ::<number | string, string, string> */ ($e4334fe97365ceb5$var$setLightness);
var $e4334fe97365ceb5$export$7ef5d725337b805d = $e4334fe97365ceb5$var$curriedSetLightness;
/**
 * Sets the saturation of a color to the provided value. The saturation range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setSaturation(0.2, '#CCCD64'),
 *   background: setSaturation('0.75', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setSaturation(0.2, '#CCCD64')};
 *   background: ${setSaturation('0.75', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#adad84";
 *   background: "rgba(228,229,76,0.7)";
 * }
 */ function $e4334fe97365ceb5$var$setSaturation(saturation, color) {
    if (color === 'transparent') return color;
    return $e4334fe97365ceb5$export$42fe740cdf79b2df((0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({}, $e4334fe97365ceb5$export$1286688e1b3fde9c(color), {
        saturation: parseFloat(saturation)
    }));
}
// prettier-ignore
var $e4334fe97365ceb5$var$curriedSetSaturation = $e4334fe97365ceb5$var$curry /* ::<number | string, string, string> */ ($e4334fe97365ceb5$var$setSaturation);
var $e4334fe97365ceb5$export$b40fe421ea7a4f7e = $e4334fe97365ceb5$var$curriedSetSaturation;
/**
 * Shades a color by mixing it with black. `shade` can produce
 * hue shifts, where as `darken` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: shade(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${shade(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#00003f";
 * }
 */ function $e4334fe97365ceb5$var$shade(percentage, color) {
    if (color === 'transparent') return color;
    return $e4334fe97365ceb5$export$2c9e8a9632a706b2(parseFloat(percentage), 'rgb(0, 0, 0)', color);
}
// prettier-ignore
var $e4334fe97365ceb5$var$curriedShade = $e4334fe97365ceb5$var$curry /* ::<number | string, string, string> */ ($e4334fe97365ceb5$var$shade);
var $e4334fe97365ceb5$export$3e32adda0df4ef5d = $e4334fe97365ceb5$var$curriedShade;
/**
 * Tints a color by mixing it with white. `tint` can produce
 * hue shifts, where as `lighten` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: tint(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${tint(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#bfbfff";
 * }
 */ function $e4334fe97365ceb5$var$tint(percentage, color) {
    if (color === 'transparent') return color;
    return $e4334fe97365ceb5$export$2c9e8a9632a706b2(parseFloat(percentage), 'rgb(255, 255, 255)', color);
}
// prettier-ignore
var $e4334fe97365ceb5$var$curriedTint = $e4334fe97365ceb5$var$curry /* ::<number | string, string, string> */ ($e4334fe97365ceb5$var$tint);
var $e4334fe97365ceb5$export$fc176dd65a27d98b = $e4334fe97365ceb5$var$curriedTint;
/**
 * Decreases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: transparentize(0.1, '#fff'),
 *   background: transparentize(0.2, 'hsl(0, 0%, 100%)'),
 *   background: transparentize('0.5', 'rgba(255, 0, 0, 0.8)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${transparentize(0.1, '#fff')};
 *   background: ${transparentize(0.2, 'hsl(0, 0%, 100%)')};
 *   background: ${transparentize('0.5', 'rgba(255, 0, 0, 0.8)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,255,255,0.9)";
 *   background: "rgba(255,255,255,0.8)";
 *   background: "rgba(255,0,0,0.3)";
 * }
 */ function $e4334fe97365ceb5$var$transparentize(amount, color) {
    if (color === 'transparent') return color;
    var parsedColor = $e4334fe97365ceb5$export$2f48baff6995707a(color);
    var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;
    var colorWithAlpha = (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({}, parsedColor, {
        alpha: $e4334fe97365ceb5$var$guard(0, 1, +(alpha * 100 - parseFloat(amount) * 100).toFixed(2) / 100)
    });
    return $e4334fe97365ceb5$export$4e46ac54fc82cf3b(colorWithAlpha);
}
// prettier-ignore
var $e4334fe97365ceb5$var$curriedTransparentize = $e4334fe97365ceb5$var$curry /* ::<number | string, string, string> */ ($e4334fe97365ceb5$var$transparentize);
var $e4334fe97365ceb5$export$d11da87e55cc498f = $e4334fe97365ceb5$var$curriedTransparentize;
/**
 * Shorthand for easily setting the animation property. Allows either multiple arrays with animations
 * or a single animation spread over the arguments.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out, colorchange 2s'
 * }
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation('rotate', '1s', 'ease-in-out')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation('rotate', '1s', 'ease-in-out')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out'
 * }
 */ function $e4334fe97365ceb5$export$ecad260a8a5fef4f() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    // Allow single or multiple animations passed
    var multiMode = Array.isArray(args[0]);
    if (!multiMode && args.length > 8) throw new $e4334fe97365ceb5$var$PolishedError(64);
    var code = args.map(function(arg) {
        if (multiMode && !Array.isArray(arg) || !multiMode && Array.isArray(arg)) throw new $e4334fe97365ceb5$var$PolishedError(65);
        if (Array.isArray(arg) && arg.length > 8) throw new $e4334fe97365ceb5$var$PolishedError(66);
        return Array.isArray(arg) ? arg.join(' ') : arg;
    }).join(', ');
    return {
        animation: code
    };
}
/**
 * Shorthand that accepts any number of backgroundImage values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'backgroundImage': 'url("/image/background.jpg"), linear-gradient(red, green)'
 * }
 */ function $e4334fe97365ceb5$export$c7de706fee81cfb4() {
    for(var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++)properties[_key] = arguments[_key];
    return {
        backgroundImage: properties.join(', ')
    };
}
/**
 * Shorthand that accepts any number of background values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'background': 'url("/image/background.jpg"), linear-gradient(red, green), center no-repeat'
 * }
 */ function $e4334fe97365ceb5$export$d041fef2b78b7906() {
    for(var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++)properties[_key] = arguments[_key];
    return {
        background: properties.join(', ')
    };
}
var $e4334fe97365ceb5$var$sideMap = [
    'top',
    'right',
    'bottom',
    'left'
];
/**
 * Shorthand for the border property that splits out individual properties for use with tools like Fela and Styletron. A side keyword can optionally be passed to target only one side's border properties.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...border('1px', 'solid', 'red')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${border('1px', 'solid', 'red')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderColor': 'red',
 *   'borderStyle': 'solid',
 *   'borderWidth': `1px`,
 * }
 *
 * // Styles as object usage
 * const styles = {
 *   ...border('top', '1px', 'solid', 'red')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${border('top', '1px', 'solid', 'red')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopColor': 'red',
 *   'borderTopStyle': 'solid',
 *   'borderTopWidth': `1px`,
 * }
 */ function $e4334fe97365ceb5$export$1edee58a52776cd9(sideKeyword) {
    for(var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)values[_key - 1] = arguments[_key];
    if (typeof sideKeyword === 'string' && $e4334fe97365ceb5$var$sideMap.indexOf(sideKeyword) >= 0) {
        var _ref;
        return _ref = {}, _ref["border" + $e4334fe97365ceb5$var$capitalizeString(sideKeyword) + "Width"] = values[0], _ref["border" + $e4334fe97365ceb5$var$capitalizeString(sideKeyword) + "Style"] = values[1], _ref["border" + $e4334fe97365ceb5$var$capitalizeString(sideKeyword) + "Color"] = values[2], _ref;
    } else {
        values.unshift(sideKeyword);
        return {
            borderWidth: values[0],
            borderStyle: values[1],
            borderColor: values[2]
        };
    }
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderColor('red', 'green', 'blue', 'yellow')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderColor('red', 'green', 'blue', 'yellow')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopColor': 'red',
 *   'borderRightColor': 'green',
 *   'borderBottomColor': 'blue',
 *   'borderLeftColor': 'yellow'
 * }
 */ function $e4334fe97365ceb5$export$e7fb0694ba2404fc() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $e4334fe97365ceb5$export$4fc00c04dd60af95.apply(void 0, [
        'borderColor'
    ].concat(values));
}
/**
 * Shorthand that accepts a value for side and a value for radius and applies the radius value to both corners of the side.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderRadius('top', '5px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderRadius('top', '5px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopRightRadius': '5px',
 *   'borderTopLeftRadius': '5px',
 * }
 */ function $e4334fe97365ceb5$export$7a57f79000377ca2(side, radius) {
    var uppercaseSide = $e4334fe97365ceb5$var$capitalizeString(side);
    if (!radius && radius !== 0) throw new $e4334fe97365ceb5$var$PolishedError(62);
    if (uppercaseSide === 'Top' || uppercaseSide === 'Bottom') {
        var _ref;
        return _ref = {}, _ref["border" + uppercaseSide + "RightRadius"] = radius, _ref["border" + uppercaseSide + "LeftRadius"] = radius, _ref;
    }
    if (uppercaseSide === 'Left' || uppercaseSide === 'Right') {
        var _ref2;
        return _ref2 = {}, _ref2["borderTop" + uppercaseSide + "Radius"] = radius, _ref2["borderBottom" + uppercaseSide + "Radius"] = radius, _ref2;
    }
    throw new $e4334fe97365ceb5$var$PolishedError(63);
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderStyle('solid', 'dashed', 'dotted', 'double')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderStyle('solid', 'dashed', 'dotted', 'double')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopStyle': 'solid',
 *   'borderRightStyle': 'dashed',
 *   'borderBottomStyle': 'dotted',
 *   'borderLeftStyle': 'double'
 * }
 */ function $e4334fe97365ceb5$export$4d0a7f76ad443516() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $e4334fe97365ceb5$export$4fc00c04dd60af95.apply(void 0, [
        'borderStyle'
    ].concat(values));
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderWidth('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderWidth('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopWidth': '12px',
 *   'borderRightWidth': '24px',
 *   'borderBottomWidth': '36px',
 *   'borderLeftWidth': '48px'
 * }
 */ function $e4334fe97365ceb5$export$12879c7697ed953d() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $e4334fe97365ceb5$export$4fc00c04dd60af95.apply(void 0, [
        'borderWidth'
    ].concat(values));
}
function $e4334fe97365ceb5$var$generateSelectors(template, state) {
    var stateSuffix = state ? ":" + state : '';
    return template(stateSuffix);
}
/**
 * Function helper that adds an array of states to a template of selectors. Used in textInputs and buttons.
 * @private
 */ function $e4334fe97365ceb5$var$statefulSelectors(states, template, stateMap) {
    if (!template) throw new $e4334fe97365ceb5$var$PolishedError(67);
    if (states.length === 0) return $e4334fe97365ceb5$var$generateSelectors(template, null);
    var selectors = [];
    for(var i = 0; i < states.length; i += 1){
        if (stateMap && stateMap.indexOf(states[i]) < 0) throw new $e4334fe97365ceb5$var$PolishedError(68);
        selectors.push($e4334fe97365ceb5$var$generateSelectors(template, states[i]));
    }
    selectors = selectors.join(',');
    return selectors;
}
var $e4334fe97365ceb5$var$stateMap$1 = [
    undefined,
    null,
    'active',
    'focus',
    'hover'
];
function $e4334fe97365ceb5$var$template$1(state) {
    return "button" + state + ",\n  input[type=\"button\"]" + state + ",\n  input[type=\"reset\"]" + state + ",\n  input[type=\"submit\"]" + state;
}
/**
 * Populates selectors that target all buttons. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [buttons('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${buttons('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'button:active,
 *  'input[type="button"]:active,
 *  'input[type=\"reset\"]:active,
 *  'input[type=\"submit\"]:active: {
 *   'border': 'none'
 * }
 */ function $e4334fe97365ceb5$export$bbea856fdb3e3c5f() {
    for(var _len = arguments.length, states = new Array(_len), _key = 0; _key < _len; _key++)states[_key] = arguments[_key];
    return $e4334fe97365ceb5$var$statefulSelectors(states, $e4334fe97365ceb5$var$template$1, $e4334fe97365ceb5$var$stateMap$1);
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...margin('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${margin('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'marginTop': '12px',
 *   'marginRight': '24px',
 *   'marginBottom': '36px',
 *   'marginLeft': '48px'
 * }
 */ function $e4334fe97365ceb5$export$7ede87f9b603dd3c() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $e4334fe97365ceb5$export$4fc00c04dd60af95.apply(void 0, [
        'margin'
    ].concat(values));
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...padding('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${padding('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */ function $e4334fe97365ceb5$export$6f98e8eaf0be1996() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $e4334fe97365ceb5$export$4fc00c04dd60af95.apply(void 0, [
        'padding'
    ].concat(values));
}
var $e4334fe97365ceb5$var$positionMap = [
    'absolute',
    'fixed',
    'relative',
    'static',
    'sticky'
];
/**
 * Shorthand accepts up to five values, including null to skip a value, and maps them to their respective directions. The first value can optionally be a position keyword.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...position('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 *
 * // Styles as object usage
 * const styles = {
 *   ...position('absolute', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('absolute', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'position': 'absolute',
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 */ function $e4334fe97365ceb5$export$5880b8b5730aff45(firstValue) {
    for(var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)values[_key - 1] = arguments[_key];
    if ($e4334fe97365ceb5$var$positionMap.indexOf(firstValue) >= 0 && firstValue) return (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({}, $e4334fe97365ceb5$export$4fc00c04dd60af95.apply(void 0, [
        ''
    ].concat(values)), {
        position: firstValue
    });
    else return $e4334fe97365ceb5$export$4fc00c04dd60af95.apply(void 0, [
        '',
        firstValue
    ].concat(values));
}
/**
 * Shorthand to set the height and width properties in a single statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...size('300px', '250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${size('300px', '250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'height': '300px',
 *   'width': '250px',
 * }
 */ function $e4334fe97365ceb5$export$346677f925de839c(height, width) {
    if (width === void 0) width = height;
    return {
        height: height,
        width: width
    };
}
var $e4334fe97365ceb5$var$stateMap = [
    undefined,
    null,
    'active',
    'focus',
    'hover'
];
function $e4334fe97365ceb5$var$template(state) {
    return "input[type=\"color\"]" + state + ",\n    input[type=\"date\"]" + state + ",\n    input[type=\"datetime\"]" + state + ",\n    input[type=\"datetime-local\"]" + state + ",\n    input[type=\"email\"]" + state + ",\n    input[type=\"month\"]" + state + ",\n    input[type=\"number\"]" + state + ",\n    input[type=\"password\"]" + state + ",\n    input[type=\"search\"]" + state + ",\n    input[type=\"tel\"]" + state + ",\n    input[type=\"text\"]" + state + ",\n    input[type=\"time\"]" + state + ",\n    input[type=\"url\"]" + state + ",\n    input[type=\"week\"]" + state + ",\n    input:not([type])" + state + ",\n    textarea" + state;
}
/**
 * Populates selectors that target all text inputs. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [textInputs('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${textInputs('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'input[type="color"]:active,
 *  input[type="date"]:active,
 *  input[type="datetime"]:active,
 *  input[type="datetime-local"]:active,
 *  input[type="email"]:active,
 *  input[type="month"]:active,
 *  input[type="number"]:active,
 *  input[type="password"]:active,
 *  input[type="search"]:active,
 *  input[type="tel"]:active,
 *  input[type="text"]:active,
 *  input[type="time"]:active,
 *  input[type="url"]:active,
 *  input[type="week"]:active,
 *  input:not([type]):active,
 *  textarea:active': {
 *   'border': 'none'
 * }
 */ function $e4334fe97365ceb5$export$baad927ee93ccf9c() {
    for(var _len = arguments.length, states = new Array(_len), _key = 0; _key < _len; _key++)states[_key] = arguments[_key];
    return $e4334fe97365ceb5$var$statefulSelectors(states, $e4334fe97365ceb5$var$template, $e4334fe97365ceb5$var$stateMap);
}
/**
 * Accepts any number of transition values as parameters for creating a single transition statement. You may also pass an array of properties as the first parameter that you would like to apply the same transition values to (second parameter).
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s'),
 *   ...transitions(['color', 'background-color'], '2.0s ease-in 2s')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s')};
 *   ${transitions(['color', 'background-color'], '2.0s ease-in 2s'),};
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'transition': 'opacity 1.0s ease-in 0s, width 2.0s ease-in 2s'
 *   'transition': 'color 2.0s ease-in 2s, background-color 2.0s ease-in 2s',
 * }
 */ function $e4334fe97365ceb5$export$622eca585e740ed5() {
    for(var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++)properties[_key] = arguments[_key];
    if (Array.isArray(properties[0]) && properties.length === 2) {
        var value = properties[1];
        if (typeof value !== 'string') throw new $e4334fe97365ceb5$var$PolishedError(61);
        var transitionsString = properties[0].map(function(property) {
            return property + " " + value;
        }).join(', ');
        return {
            transition: transitionsString
        };
    } else return {
        transition: properties.join(', ')
    };
}



/**
 * Curry the polished rgba function to allow switching the parameters.
 */ const $ecd1a6a8f958a3d3$var$_rgba = (alpha)=>(color)=>(0, $e4334fe97365ceb5$export$4e46ac54fc82cf3b)(color, alpha);
const $ecd1a6a8f958a3d3$var$colorPaletteSettings = [
    {
        code: '50',
        colorFn: (0, $e4334fe97365ceb5$export$fc176dd65a27d98b)(0.96)
    },
    {
        code: '50a',
        colorFn: $ecd1a6a8f958a3d3$var$_rgba(0.04)
    },
    {
        code: '100',
        colorFn: (0, $e4334fe97365ceb5$export$fc176dd65a27d98b)(0.92)
    },
    {
        code: '100a',
        colorFn: $ecd1a6a8f958a3d3$var$_rgba(0.08)
    },
    {
        code: '200',
        colorFn: (0, $e4334fe97365ceb5$export$fc176dd65a27d98b)(0.84)
    },
    {
        code: '200a',
        colorFn: $ecd1a6a8f958a3d3$var$_rgba(0.16)
    },
    {
        code: '300',
        colorFn: (0, $e4334fe97365ceb5$export$fc176dd65a27d98b)(0.68)
    },
    {
        code: '300a',
        colorFn: $ecd1a6a8f958a3d3$var$_rgba(0.32)
    },
    {
        code: '400',
        colorFn: (0, $e4334fe97365ceb5$export$fc176dd65a27d98b)(0.36)
    },
    {
        code: '400a',
        colorFn: $ecd1a6a8f958a3d3$var$_rgba(0.64)
    },
    {
        code: '500',
        colorFn: (v)=>v
    },
    {
        code: '600',
        colorFn: (0, $e4334fe97365ceb5$export$3e32adda0df4ef5d)(0.16)
    },
    {
        code: '700',
        colorFn: (0, $e4334fe97365ceb5$export$3e32adda0df4ef5d)(0.32)
    },
    {
        code: '800',
        colorFn: (0, $e4334fe97365ceb5$export$3e32adda0df4ef5d)(0.48)
    },
    {
        code: '900',
        colorFn: (0, $e4334fe97365ceb5$export$3e32adda0df4ef5d)(0.64)
    }
];
function $ecd1a6a8f958a3d3$export$e48ea82efb9e52cb(baseColor) {
    return $ecd1a6a8f958a3d3$var$colorPaletteSettings.reduce((acc, c)=>({
            ...acc,
            [c.code]: c.colorFn(baseColor)
        }), {});
}


// `chakra typegen` may evaluate this file in a vm sandbox without a `process`
// global. Keep the `process.env.*` member expressions intact (Parcel replaces
// them statically) and fall back to the defaults when `process` is missing —
// the generated types are identical regardless of color values.
let $9f3e244f4ad36284$var$primary = '#6A5ACD';
let $9f3e244f4ad36284$var$secondary = '#048A81';
try {
    $9f3e244f4ad36284$var$primary;
    $9f3e244f4ad36284$var$secondary;
} catch  {
/* not running under Node */ }
const $9f3e244f4ad36284$var$base = (0, $e4334fe97365ceb5$export$b40fe421ea7a4f7e)(0.32, (0, $e4334fe97365ceb5$export$7ef5d725337b805d)(0.16, (0, $e4334fe97365ceb5$export$2b372a09365374d6)(48, $9f3e244f4ad36284$var$primary)));
/**
 * Wrap a flat `{ 50: '#hex', 100: '#hex', ... }` palette into the Chakra v3
 * token shape `{ 50: { value: '#hex' }, ... }` without modifying the
 * `createColorPalette` helper (which is also consumed standalone).
 */ function $9f3e244f4ad36284$var$toTokens(palette) {
    return Object.fromEntries(Object.entries(palette).map(([k, v])=>[
            k,
            {
                value: v
            }
        ]));
}
const $9f3e244f4ad36284$var$palettes = {
    primary: $9f3e244f4ad36284$var$toTokens((0, $ecd1a6a8f958a3d3$export$e48ea82efb9e52cb)($9f3e244f4ad36284$var$primary)),
    secondary: $9f3e244f4ad36284$var$toTokens((0, $ecd1a6a8f958a3d3$export$e48ea82efb9e52cb)($9f3e244f4ad36284$var$secondary)),
    base: $9f3e244f4ad36284$var$toTokens((0, $ecd1a6a8f958a3d3$export$e48ea82efb9e52cb)($9f3e244f4ad36284$var$base)),
    danger: $9f3e244f4ad36284$var$toTokens((0, $ecd1a6a8f958a3d3$export$e48ea82efb9e52cb)('#FF5353')),
    warning: $9f3e244f4ad36284$var$toTokens((0, $ecd1a6a8f958a3d3$export$e48ea82efb9e52cb)('#FFC849')),
    success: $9f3e244f4ad36284$var$toTokens((0, $ecd1a6a8f958a3d3$export$e48ea82efb9e52cb)('#46D6CD')),
    info: $9f3e244f4ad36284$var$toTokens((0, $ecd1a6a8f958a3d3$export$e48ea82efb9e52cb)('#1A5BDB')),
    surface: $9f3e244f4ad36284$var$toTokens((0, $ecd1a6a8f958a3d3$export$e48ea82efb9e52cb)('#FFF')),
    gray: $9f3e244f4ad36284$var$toTokens((0, $ecd1a6a8f958a3d3$export$e48ea82efb9e52cb)($9f3e244f4ad36284$var$base))
};
const $9f3e244f4ad36284$var$config = (0, $a2f848fc882d4d28$export$9e20b617fd74b180)({
    globalCss: {
        body: {
            fontSize: 'sm',
            color: 'base.500',
            maxWidth: '100vw',
            overflowX: 'hidden'
        },
        '*': {
            lineHeight: 'calc(0.5rem + 1em)'
        }
    },
    theme: {
        semanticTokens: {
            colors: Object.fromEntries(Object.keys($9f3e244f4ad36284$var$palettes).map((name)=>{
                // Neutral palettes follow Chakra's gray pattern (border/solid use
                // lighter/darker shades than the chromatic palettes). Our `base`,
                // `gray`, and `surface` are neutrals; the rest are chromatic.
                const isNeutral = name === 'gray' || name === 'base' || name === 'surface';
                return [
                    name,
                    {
                        contrast: {
                            value: 'white'
                        },
                        fg: {
                            value: `{colors.${name}.800}`
                        },
                        subtle: {
                            value: `{colors.${name}.100}`
                        },
                        muted: {
                            value: `{colors.${name}.200}`
                        },
                        emphasized: {
                            value: `{colors.${name}.300}`
                        },
                        solid: {
                            value: isNeutral ? `{colors.${name}.900}` : `{colors.${name}.500}`
                        },
                        focusRing: {
                            value: isNeutral ? `{colors.${name}.400}` : `{colors.${name}.500}`
                        },
                        border: {
                            value: isNeutral ? `{colors.${name}.200}` : `{colors.${name}.500}`
                        }
                    }
                ];
            }))
        },
        tokens: {
            colors: $9f3e244f4ad36284$var$palettes,
            fonts: {
                body: {
                    value: 'Inter'
                },
                heading: {
                    value: 'Inter'
                }
            },
            fontSizes: {
                xs: {
                    value: '0.75rem'
                },
                sm: {
                    value: '1rem'
                },
                md: {
                    value: '1.25rem'
                },
                lg: {
                    value: '1.5rem'
                },
                xl: {
                    value: '1.75rem'
                },
                '2xl': {
                    value: '2rem'
                },
                '3xl': {
                    value: '2.25rem'
                },
                '4xl': {
                    value: '2.5rem'
                },
                '5xl': {
                    value: '2.75rem'
                },
                '6xl': {
                    value: '3rem'
                },
                '7xl': {
                    value: '3.25rem'
                },
                '8xl': {
                    value: '3.5rem'
                },
                '9xl': {
                    value: '3.75rem'
                },
                '10xl': {
                    value: '4rem'
                }
            }
        },
        textStyles: {
            'lead.sm': {
                value: {
                    fontSize: 'md'
                }
            },
            'lead.lg': {
                value: {
                    fontSize: 'lg'
                }
            }
        },
        recipes: {
            heading: (0, $a2f848fc882d4d28$export$9ab6f981e4119117)({
                base: {
                    fontWeight: '700'
                },
                // v2's Heading sizes were shifted vs v3's 1:1 mapping
                // (v2 size='sm' → fontSize='md', etc.). Re-map to preserve
                // visual hierarchy without touching call sites.
                variants: {
                    size: {
                        xs: {
                            fontSize: 'sm'
                        },
                        sm: {
                            fontSize: 'md'
                        },
                        md: {
                            fontSize: 'lg'
                        },
                        lg: {
                            fontSize: 'xl'
                        },
                        xl: {
                            fontSize: '2xl'
                        },
                        '2xl': {
                            fontSize: '3xl'
                        },
                        '3xl': {
                            fontSize: '4xl'
                        },
                        '4xl': {
                            fontSize: '5xl'
                        }
                    }
                }
            }),
            link: (0, $a2f848fc882d4d28$export$9ab6f981e4119117)({
                base: {
                    color: 'primary.500'
                }
            }),
            button: (0, $a2f848fc882d4d28$export$9ab6f981e4119117)({
                base: {
                    borderRadius: 'md',
                    fontWeight: '700',
                    // Avoid removing underline on non-anchor buttons.
                    '&:is(a):hover': {
                        textDecoration: 'none'
                    }
                },
                variants: {
                    size: {
                        xs: {
                            fontSize: 'xs'
                        },
                        sm: {
                            fontSize: 'xs'
                        },
                        md: {
                            fontSize: 'sm'
                        },
                        lg: {
                            fontSize: 'sm'
                        }
                    },
                    variant: {
                        // Use individual border-* properties (not the `border` shorthand)
                        // so we override width only and Chakra v3's default
                        // `borderColor: colorPalette.border` (mapped to colorPalette.500 in
                        // our semantic tokens) is preserved.
                        outline: {
                            borderWidth: '2px',
                            borderStyle: 'solid',
                            // v3's ButtonGroup is implemented via <Group>, which exposes
                            // `data-attached` + `data-orientation` on the parent (no more
                            // `.chakra-button__group` class). Group's own attached rules use
                            // `marginEnd: -1px` for 1px borders; override with -2px so our
                            // 2px-bordered outline buttons overlap cleanly.
                            '[data-attached][data-orientation=horizontal] > &:not(:last-of-type)': {
                                marginEnd: '-2px'
                            },
                            '[data-attached][data-orientation=vertical] > &:not(:last-of-type)': {
                                marginBottom: '-2px'
                            },
                            // v3's outline recipe has no selected/active style. Components
                            // that mark a persistent active state via `data-active` (e.g. the
                            // Form/JSON view toggle) would otherwise be indistinguishable from
                            // their inactive siblings.
                            '&[data-active]': {
                                bg: 'colorPalette.subtle'
                            }
                        },
                        // v3 doesn't support function variants. Use `colorPalette.*` token
                        // references so `colorPalette={...}` (the v3 replacement for
                        // colorScheme) drives the palette lookup.
                        'soft-outline': {
                            borderWidth: '2px',
                            borderStyle: 'solid',
                            borderColor: 'colorPalette.200',
                            '[data-attached][data-orientation=horizontal] > &:not(:last-of-type)': {
                                marginEnd: '-2px'
                            },
                            '[data-attached][data-orientation=vertical] > &:not(:last-of-type)': {
                                marginBottom: '-2px'
                            },
                            _hover: {
                                bg: 'colorPalette.50a'
                            },
                            _active: {
                                bg: 'colorPalette.100a'
                            }
                        }
                    }
                }
            }),
            input: (0, $a2f848fc882d4d28$export$9ab6f981e4119117)({
                variants: {
                    variant: {
                        // Use individual border-* properties so Chakra v3's default
                        // `borderColor: 'border'` (resolves to our gray.200) is preserved.
                        outline: {
                            borderWidth: '2px',
                            borderStyle: 'solid'
                        }
                    }
                }
            })
        },
        slotRecipes: {
            // Declare the full v3 anatomy slot list. Omitting slots silently strips
            // styling from the default recipe for any slot not listed (same trap
            // we hit with `card`); always pass the complete anatomy keys.
            menu: (0, $a2f848fc882d4d28$export$c28efc68fea5b4d6)({
                slots: (0, $210cc27d3a3db981$export$e251092a5dcb1329).keys(),
                base: {
                    item: {
                        _hover: {
                            textDecoration: 'none !important'
                        }
                    }
                }
            }),
            card: (0, $a2f848fc882d4d28$export$c28efc68fea5b4d6)({
                slots: [
                    'root',
                    'header',
                    'body',
                    'footer',
                    'title',
                    'description'
                ],
                // v2 used 20px (spacing.5) padding; v3 defaults to 24px (spacing.6).
                // v2's header/footer also had uniform padding on all sides — v3
                // omits paddingBottom on header / paddingTop on footer assuming a
                // body fills the gap. Restore symmetric padding so ItemCards
                // without a body slot still look correct.
                base: {
                    header: {
                        paddingBottom: 'var(--card-padding)'
                    },
                    footer: {
                        paddingTop: 'var(--card-padding)'
                    }
                },
                variants: {
                    size: {
                        md: {
                            root: {
                                '--card-padding': 'spacing.5'
                            }
                        }
                    },
                    variant: {
                        filled: {
                            root: {
                                background: 'base.50'
                            }
                        }
                    }
                }
            }),
            select: (0, $a2f848fc882d4d28$export$c28efc68fea5b4d6)({
                slots: (0, $210cc27d3a3db981$export$17993f0be9538b5a).keys(),
                variants: {
                    variant: {
                        outline: {
                            trigger: {
                                borderWidth: '2px',
                                borderStyle: 'solid'
                            }
                        }
                    }
                }
            }),
            // v3 has no standalone FormLabel — labels live inside the `field` slot
            // recipe as the `label` slot.
            field: (0, $a2f848fc882d4d28$export$c28efc68fea5b4d6)({
                slots: (0, $210cc27d3a3db981$export$a43048b0d2808e4e).keys(),
                base: {
                    label: {
                        fontSize: 'sm'
                    }
                }
            })
        }
    }
});
const $9f3e244f4ad36284$export$505f1cb98cb78c0d = (0, $39d60cdb5c92c6d4$export$b06ab6dfae3e7e3)((0, $d96278a3ee190ff4$export$f84bd70098573c5c), $9f3e244f4ad36284$var$config);
var $9f3e244f4ad36284$export$2e2bcd8739ae039 = $9f3e244f4ad36284$export$505f1cb98cb78c0d;


const $aa58e4af7634fac0$var$configStructure = {
    collectionPlugins: [],
    itemPlugins: [],
    'ui:widget': {}
};
function $aa58e4af7634fac0$export$afcbd3cdfffb6e7c(...config) {
    return config.reduce((acc, c)=>{
        const { collectionPlugins: collectionPlugins = [], itemPlugins: itemPlugins = [], 'ui:widget': uiWidget = {} } = c;
        return {
            collectionPlugins: [
                ...acc.collectionPlugins,
                ...collectionPlugins
            ],
            itemPlugins: [
                ...acc.itemPlugins,
                ...itemPlugins
            ],
            'ui:widget': {
                ...acc['ui:widget'],
                ...uiWidget
            }
        };
    }, $aa58e4af7634fac0$var$configStructure);
}




parcelRequire("8v0nu");

parcelRequire("8v0nu");


var $jTKGQ = parcelRequire("jTKGQ");


const $02719087c988c832$var$identity = (v)=>v;
function $02719087c988c832$export$2a4b7b80ff003e13(props) {
    const { label: label, isDeletable: isDeletable, onDeleteClick: onDeleteClick, isDeleteDisabled: isDeleteDisabled, pointer: pointer, isRequired: isRequired, type: type, transformValue: transformValue = $02719087c988c832$var$identity } = props;
    const field = props.field;
    const fieldLabel = label || field.label;
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $jTKGQ.FastField), {
        name: pointer,
        children: ({ field: { value: value, onBlur: onBlur }, meta: meta, form: { setFieldValue: setFieldValue } })=>/*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $5e0ca4edd90668b0$exports).Root, {
                required: isRequired,
                invalid: meta.touched && meta.error ? true : false,
                children: [
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
                        gap: 4,
                        children: [
                            fieldLabel && /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $5e0ca4edd90668b0$exports).Label, {
                                children: [
                                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $8f2967926209c75b$export$1acdcf5a973a8414), {
                                        size: "xs",
                                        children: fieldLabel
                                    }),
                                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $5e0ca4edd90668b0$exports).RequiredIndicator, {})
                                ]
                            }),
                            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
                                ml: "auto",
                                gap: 2,
                                children: isDeletable && /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $8f2967926209c75b$export$90c6246c969554fc), {
                                    "aria-label": "Remove item",
                                    onClick: onDeleteClick,
                                    disabled: isDeleteDisabled,
                                    children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9138db1f951ed55c$export$5918e8962b6636e9), {
                                        boxSize: 3
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $88b24aa7301f8cd5$export$f5b8910cec6cf069), {
                        type: type,
                        size: "sm",
                        name: pointer,
                        bg: "surface.500",
                        borderColor: "base.200",
                        borderRadius: "md",
                        value: value ?? '',
                        onBlur: onBlur,
                        onChange: (e)=>{
                            setFieldValue(pointer, transformValue(e.target.value));
                        }
                    }),
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $5e0ca4edd90668b0$exports).ErrorText, {
                        children: meta.error
                    })
                ]
            })
    });
}


function $17485d2c0739238f$export$b63d030f4611938c(props) {
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $02719087c988c832$export$2a4b7b80ff003e13), {
        ...props
    });
}



parcelRequire("8v0nu");


parcelRequire("8v0nu");

function $81cc9f2a42ee34ee$export$842a2cf37af977e1(a, n) {
    return (a % n + n) % n;
}
function $81cc9f2a42ee34ee$export$ebfdb425fb84a7c7(field, index) {
    const label = field.label === undefined ? 'Item' : field.label;
    if (label === null) return null;
    if (typeof label === 'string') {
        const n = index + 1;
        return {
            label: label,
            num: n,
            formatted: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $ef524fb144c5d632$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9318c0c5b8c25a88$export$5f1af8db9871e1d6), {
                        as: "span",
                        children: label
                    }),
                    ' ',
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9318c0c5b8c25a88$export$5f1af8db9871e1d6), {
                        as: "small",
                        children: n <= 9 ? `0${n}` : n
                    })
                ]
            })
        };
    }
    const l = label[$81cc9f2a42ee34ee$export$842a2cf37af977e1(index, label.length)];
    return {
        label: l,
        num: null,
        formatted: l
    };
}
function $81cc9f2a42ee34ee$export$a0a81dc3380ce7d3(v) {
    const n = Number(v);
    return isNaN(n) ? null : n;
}
function $81cc9f2a42ee34ee$export$ff8cd4c6525ea2f6(value) {
    return Array.isArray(value) ? value : [
        value
    ];
}


function $c0c33d699328ac6c$export$7833621d74bfe8fb(props) {
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $02719087c988c832$export$2a4b7b80ff003e13), {
        ...props,
        type: "number",
        transformValue: (0, $81cc9f2a42ee34ee$export$a0a81dc3380ce7d3)
    });
}



parcelRequire("8v0nu");
var $007be631de130dc2$exports = {};

$parcel$export($007be631de130dc2$exports, "Content", function () { return $995b7a4d20307277$export$4f3df2b71415155d; });
$parcel$export($007be631de130dc2$exports, "Context", function () { return $995b7a4d20307277$export$74e4d3bc6dc1117; });
$parcel$export($007be631de130dc2$exports, "ErrorText", function () { return $995b7a4d20307277$export$a88fa6fd6cc2f529; });
$parcel$export($007be631de130dc2$exports, "HelperText", function () { return $995b7a4d20307277$export$a99b1f704e4ae247; });
$parcel$export($007be631de130dc2$exports, "Legend", function () { return $995b7a4d20307277$export$ea32fbba53a6ce79; });
$parcel$export($007be631de130dc2$exports, "Root", function () { return $995b7a4d20307277$export$2711d57e8c72610a; });



"use client";
//#region src/components/fieldset/fieldset-context.tsx
var $b564414c32cd4664$export$74e4d3bc6dc1117 = (props)=>props.children((0, $2a2f69e4c1ad7c1b$export$e46e66a55913b34c)());





var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/fieldset/fieldset-error-text.tsx
var $1005efa480964862$export$a88fa6fd6cc2f529 = (0, $8v0nu.forwardRef)((props, ref)=>{
    const fieldset = (0, $2a2f69e4c1ad7c1b$export$e46e66a55913b34c)();
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)(fieldset.getErrorTextProps(), props);
    return fieldset.invalid ? /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).span, {
        ...mergedProps,
        ref: ref
    }) : null;
});
$1005efa480964862$export$a88fa6fd6cc2f529.displayName = "FieldsetErrorText";





var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/fieldset/fieldset-helper-text.tsx
var $1c18b9f91a6da1a5$export$a99b1f704e4ae247 = (0, $8v0nu.forwardRef)((props, ref)=>{
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)((0, $2a2f69e4c1ad7c1b$export$e46e66a55913b34c)().getHelperTextProps(), props);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).span, {
        ...mergedProps,
        ref: ref
    });
});
$1c18b9f91a6da1a5$export$a99b1f704e4ae247.displayName = "FieldsetHelperText";





var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/fieldset/fieldset-legend.tsx
var $df515c2352b10951$export$ea32fbba53a6ce79 = (0, $8v0nu.forwardRef)((props, ref)=>{
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)((0, $2a2f69e4c1ad7c1b$export$e46e66a55913b34c)().getLegendProps(), props);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).legend, {
        ...mergedProps,
        ref: ref
    });
});
$df515c2352b10951$export$ea32fbba53a6ce79.displayName = "FieldsetLegend";










var $8v0nu = parcelRequire("8v0nu");

"use client";
//#region src/components/fieldset/use-fieldset.ts
var $c66735d32f0a2988$export$b140571ec72925dd = (props = {})=>{
    const { disabled: disabled = false, invalid: invalid = false } = props;
    const env = (0, $cfa7a900a06000ef$export$899b1e582a0b3c80)();
    const [textElements, setTextElements] = (0, $8v0nu.useState)({
        hasErrorText: false,
        hasHelperText: false
    });
    const uid = (0, $8v0nu.useId)();
    const id = props.id ?? uid;
    const rootRef = (0, $8v0nu.useRef)(null);
    const legendId = `fieldset::${id}::legend`;
    const errorTextId = `fieldset::${id}::error-text`;
    const helperTextId = `fieldset::${id}::helper-text`;
    (0, $9ae467e0bcfbf220$export$deebe11a338de063)(()=>{
        const rootNode = rootRef.current;
        if (!rootNode) return;
        const checkTextElements = ()=>{
            const docOrShadowRoot = env.getRootNode();
            setTextElements({
                hasErrorText: !!docOrShadowRoot.getElementById(errorTextId),
                hasHelperText: !!docOrShadowRoot.getElementById(helperTextId)
            });
        };
        checkTextElements();
        const observer = new (env.getWindow()).MutationObserver(checkTextElements);
        observer.observe(rootNode, {
            childList: true,
            subtree: true
        });
        return ()=>observer.disconnect();
    }, [
        env,
        errorTextId,
        helperTextId
    ]);
    const ids = [];
    if (textElements.hasErrorText && invalid) ids.push(errorTextId);
    if (textElements.hasHelperText) ids.push(helperTextId);
    const labelIds = ids.length > 0 ? ids.join(" ") : void 0;
    const getRootProps = ()=>({
            ...(0, $22ffba3410e47486$export$6e2410c1d27f06e7).root.attrs,
            ref: rootRef,
            disabled: disabled,
            "data-disabled": (0, $dbd9babc41e226bd$export$5cc3b7b83e34ade7)(disabled),
            "data-invalid": (0, $dbd9babc41e226bd$export$5cc3b7b83e34ade7)(invalid),
            "aria-labelledby": legendId,
            "aria-describedby": labelIds
        });
    const getLegendProps = ()=>({
            id: legendId,
            ...(0, $22ffba3410e47486$export$6e2410c1d27f06e7).legend.attrs,
            "data-disabled": (0, $dbd9babc41e226bd$export$5cc3b7b83e34ade7)(disabled),
            "data-invalid": (0, $dbd9babc41e226bd$export$5cc3b7b83e34ade7)(invalid)
        });
    const getHelperTextProps = ()=>({
            id: helperTextId,
            ...(0, $22ffba3410e47486$export$6e2410c1d27f06e7).helperText.attrs
        });
    const getErrorTextProps = ()=>({
            id: errorTextId,
            ...(0, $22ffba3410e47486$export$6e2410c1d27f06e7).errorText.attrs,
            "aria-live": "polite"
        });
    return {
        refs: {
            rootRef: rootRef
        },
        ids: {
            legend: legendId,
            errorText: errorTextId,
            helperText: helperTextId
        },
        disabled: disabled,
        invalid: invalid,
        getRootProps: getRootProps,
        getLegendProps: getLegendProps,
        getHelperTextProps: getHelperTextProps,
        getErrorTextProps: getErrorTextProps
    };
};



var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/fieldset/fieldset-root.tsx
var $b53cc32b0f7980f4$var$splitRootProps = (0, $41bdb03050f91b76$export$3ea53b214fbc1986)();
var $b53cc32b0f7980f4$export$2711d57e8c72610a = (0, $8v0nu.forwardRef)((props, ref)=>{
    const [useFieldsetProps, localProps] = $b53cc32b0f7980f4$var$splitRootProps(props, [
        "id",
        "disabled",
        "invalid"
    ]);
    const fieldset = (0, $c66735d32f0a2988$export$b140571ec72925dd)(useFieldsetProps);
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)(fieldset.getRootProps(), localProps);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $2a2f69e4c1ad7c1b$export$57473b03a87606d3), {
        value: fieldset,
        children: /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).fieldset, {
            ...mergedProps,
            ref: (0, $ab7129f9bbf0085f$export$43e446d32b3d21af)(ref, fieldset.refs.rootRef)
        })
    });
});
$b53cc32b0f7980f4$export$2711d57e8c72610a.displayName = "FieldsetRoot";






var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/fieldset/fieldset-root-provider.tsx
var $b7fa53d6df8032e0$var$splitRootProviderProps = (0, $41bdb03050f91b76$export$3ea53b214fbc1986)();
var $b7fa53d6df8032e0$export$38ac4701291cd62f = (0, $8v0nu.forwardRef)((props, ref)=>{
    const [{ value: fieldset }, localProps] = $b7fa53d6df8032e0$var$splitRootProviderProps(props, [
        "value"
    ]);
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)(fieldset.getRootProps(), localProps);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $2a2f69e4c1ad7c1b$export$57473b03a87606d3), {
        value: fieldset,
        children: /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).fieldset, {
            ...mergedProps,
            ref: ref
        })
    });
});
$b7fa53d6df8032e0$export$38ac4701291cd62f.displayName = "FieldsetRootProvider";


//#region src/components/fieldset/fieldset.ts
var $5474aa07e491c356$export$9da38c3a12e2ef38 = /* @__PURE__ */ (0, $57db88e2bf337fea$export$8126e515a7516e2)({
    Context: ()=>(0, $b564414c32cd4664$export$74e4d3bc6dc1117),
    ErrorText: ()=>(0, $1005efa480964862$export$a88fa6fd6cc2f529),
    HelperText: ()=>(0, $1c18b9f91a6da1a5$export$a99b1f704e4ae247),
    Legend: ()=>(0, $df515c2352b10951$export$ea32fbba53a6ce79),
    Root: ()=>(0, $b53cc32b0f7980f4$export$2711d57e8c72610a),
    RootProvider: ()=>(0, $b7fa53d6df8032e0$export$38ac4701291cd62f)
});



"use strict";
"use client";
const { withProvider: $995b7a4d20307277$var$withProvider, withContext: $995b7a4d20307277$var$withContext } = (0, $04636a451c2392c0$export$ac7f79c9443925b8)({
    key: "fieldset"
});
const $995b7a4d20307277$export$2711d57e8c72610a = $995b7a4d20307277$var$withProvider((0, $5474aa07e491c356$export$9da38c3a12e2ef38).Root, "root");
const $995b7a4d20307277$export$a88fa6fd6cc2f529 = $995b7a4d20307277$var$withContext((0, $5474aa07e491c356$export$9da38c3a12e2ef38).ErrorText, "errorText");
const $995b7a4d20307277$export$a99b1f704e4ae247 = $995b7a4d20307277$var$withContext((0, $5474aa07e491c356$export$9da38c3a12e2ef38).HelperText, "helperText");
const $995b7a4d20307277$export$ea32fbba53a6ce79 = $995b7a4d20307277$var$withContext((0, $5474aa07e491c356$export$9da38c3a12e2ef38).Legend, "legend");
const $995b7a4d20307277$export$4f3df2b71415155d = $995b7a4d20307277$var$withContext((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).div, "content");
const $995b7a4d20307277$export$74e4d3bc6dc1117 = (0, $5474aa07e491c356$export$9da38c3a12e2ef38).Context;


"use strict";

var $6094f717792fedac$exports = {};

$parcel$export($6094f717792fedac$exports, "Context", function () { return $d964deda44435a91$export$a79eda4ff50e30b6; });
$parcel$export($6094f717792fedac$exports, "Item", function () { return $d964deda44435a91$export$9f866c100ef519e4; });
$parcel$export($6094f717792fedac$exports, "ItemContext", function () { return $d964deda44435a91$export$816354ffcf4c626d; });
$parcel$export($6094f717792fedac$exports, "ItemControl", function () { return $d964deda44435a91$export$2066302a11743000; });
$parcel$export($6094f717792fedac$exports, "ItemHiddenInput", function () { return $d964deda44435a91$export$a8848d8b7434664e; });
$parcel$export($6094f717792fedac$exports, "ItemIndicator", function () { return $d964deda44435a91$export$e653518eb4823d9e; });
$parcel$export($6094f717792fedac$exports, "ItemText", function () { return $d964deda44435a91$export$ecfcbe15d1338b4d; });
$parcel$export($6094f717792fedac$exports, "Label", function () { return $d964deda44435a91$export$6d06580bd6ecb283; });
$parcel$export($6094f717792fedac$exports, "PropsProvider", function () { return $d964deda44435a91$export$92b956a9dfd5365e; });
$parcel$export($6094f717792fedac$exports, "Root", function () { return $d964deda44435a91$export$b2c628596de388b3; });
$parcel$export($6094f717792fedac$exports, "RootProvider", function () { return $d964deda44435a91$export$8d95b43f134f9f0c; });



"use client";
//#region src/components/radio-group/use-radio-group-context.ts
var [$72816d3edafb1469$export$59b7462f266cd53f, $72816d3edafb1469$export$7bea016dc7ad2ddf] = (0, $51a09ee1e9e91bf5$export$fd42f52fd3ae1109)({
    name: "RadioGroupContext",
    hookName: "useRadioGroupContext",
    providerName: "<RadioGroupProvider />"
});


"use client";
//#region src/components/radio-group/radio-group-context.tsx
var $f78458c321614b9f$export$a79eda4ff50e30b6 = (props)=>props.children((0, $72816d3edafb1469$export$7bea016dc7ad2ddf)());





var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/radio-group/radio-group-indicator.tsx
var $7728a48eed17d9ce$export$5fb54c671a65c88 = (0, $8v0nu.forwardRef)((props, ref)=>{
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)((0, $72816d3edafb1469$export$7bea016dc7ad2ddf)().getIndicatorProps(), props);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).div, {
        ...mergedProps,
        ref: ref
    });
});
$7728a48eed17d9ce$export$5fb54c671a65c88.displayName = "RadioGroupIndicator";






"use client";
//#region src/components/radio-group/use-radio-group-item-context.ts
var [$b97a6615c05b0d49$export$7164b0f0bf790dda, $b97a6615c05b0d49$export$ebc2b9179073fb61] = (0, $51a09ee1e9e91bf5$export$fd42f52fd3ae1109)({
    name: "RadioGroupItemContext",
    hookName: "useRadioGroupItemContext",
    providerName: "<RadioGroupItemProvider />"
});



"use client";
//#region src/components/radio-group/use-radio-group-item-props-context.ts
var [$b0b5eae9ffabd127$export$8ad4b2cbcae3ff2c, $b0b5eae9ffabd127$export$afdbd32672965213] = (0, $51a09ee1e9e91bf5$export$fd42f52fd3ae1109)({
    name: "RadioGroupItemPropsContext",
    hookName: "useRadioGroupItemPropsContext",
    providerName: "<RadioGroupItemPropsProvider />"
});



var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/radio-group/radio-group-item.tsx
var $98519634e450fdac$var$splitItemProps = (0, $41bdb03050f91b76$export$3ea53b214fbc1986)();
var $98519634e450fdac$export$9f866c100ef519e4 = (0, $8v0nu.forwardRef)((props, ref)=>{
    const [itemProps, localProps] = $98519634e450fdac$var$splitItemProps(props, [
        "value",
        "disabled",
        "invalid"
    ]);
    const radioGroup = (0, $72816d3edafb1469$export$7bea016dc7ad2ddf)();
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)(radioGroup.getItemProps(itemProps), localProps);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $b97a6615c05b0d49$export$7164b0f0bf790dda), {
        value: radioGroup.getItemState(itemProps),
        children: /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $b0b5eae9ffabd127$export$8ad4b2cbcae3ff2c), {
            value: itemProps,
            children: /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).label, {
                ...mergedProps,
                ref: ref
            })
        })
    });
});
$98519634e450fdac$export$9f866c100ef519e4.displayName = "RadioGroupItem";



"use client";
//#region src/components/radio-group/radio-group-item-context.tsx
var $b8a114b59973badc$export$816354ffcf4c626d = (props)=>props.children((0, $b97a6615c05b0d49$export$ebc2b9179073fb61)());






var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/radio-group/radio-group-item-control.tsx
var $a3b4194a823871da$export$2066302a11743000 = (0, $8v0nu.forwardRef)((props, ref)=>{
    const radioGroup = (0, $72816d3edafb1469$export$7bea016dc7ad2ddf)();
    const itemProps = (0, $b0b5eae9ffabd127$export$afdbd32672965213)();
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)(radioGroup.getItemControlProps(itemProps), props);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).div, {
        ...mergedProps,
        ref: ref
    });
});
$a3b4194a823871da$export$2066302a11743000.displayName = "RadioGroupItemControl";






var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/radio-group/radio-group-item-hidden-input.tsx
var $b1cc5bab80e1d332$export$a8848d8b7434664e = (0, $8v0nu.forwardRef)((props, ref)=>{
    const radioGroup = (0, $72816d3edafb1469$export$7bea016dc7ad2ddf)();
    const itemProps = (0, $b0b5eae9ffabd127$export$afdbd32672965213)();
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)(radioGroup.getItemHiddenInputProps(itemProps), props);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).input, {
        ...mergedProps,
        ref: ref
    });
});
$b1cc5bab80e1d332$export$a8848d8b7434664e.displayName = "RadioGroupItemHiddenInput";






var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/radio-group/radio-group-item-text.tsx
var $6f46b82e93828e60$export$ecfcbe15d1338b4d = (0, $8v0nu.forwardRef)((props, ref)=>{
    const radioGroup = (0, $72816d3edafb1469$export$7bea016dc7ad2ddf)();
    const itemProps = (0, $b0b5eae9ffabd127$export$afdbd32672965213)();
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)(radioGroup.getItemTextProps(itemProps), props);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).span, {
        ...mergedProps,
        ref: ref
    });
});
$6f46b82e93828e60$export$ecfcbe15d1338b4d.displayName = "RadioGroupItemText";





var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/radio-group/radio-group-label.tsx
var $e18ff8aad8d03f64$export$6d06580bd6ecb283 = (0, $8v0nu.forwardRef)((props, ref)=>{
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)((0, $72816d3edafb1469$export$7bea016dc7ad2ddf)().getLabelProps(), props);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).span, {
        ...mergedProps,
        ref: ref
    });
});
$e18ff8aad8d03f64$export$6d06580bd6ecb283.displayName = "RadioGroupLabel";








// src/radio-group.connect.ts

// src/visually-hidden.ts
var $20b7ad6451938f04$export$8fecac46448b5689 = {
    border: "0",
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: "0",
    position: "absolute",
    width: "1px",
    whiteSpace: "nowrap",
    wordWrap: "normal"
};
function $20b7ad6451938f04$export$ca1f3b6b815c75ae(el) {
    Object.assign(el.style, $20b7ad6451938f04$export$8fecac46448b5689);
}




// src/number.ts
var { floor: $7e1029ce012b1c7f$var$floor, abs: $7e1029ce012b1c7f$var$abs, round: $7e1029ce012b1c7f$var$round, min: $7e1029ce012b1c7f$var$min, max: $7e1029ce012b1c7f$var$max, pow: $7e1029ce012b1c7f$var$pow, sign: $7e1029ce012b1c7f$var$sign } = Math;
var $7e1029ce012b1c7f$export$c9f5652083b8129d = (v)=>Number.isNaN(v);
var $7e1029ce012b1c7f$export$9e06de0973666692 = (v)=>$7e1029ce012b1c7f$export$c9f5652083b8129d(v) ? 0 : v;
var $7e1029ce012b1c7f$export$842a2cf37af977e1 = (v, m)=>(v % m + m) % m;
var $7e1029ce012b1c7f$export$4997ffc0176396a6 = (v, vmax)=>(v % vmax + vmax) % vmax;
var $7e1029ce012b1c7f$export$9015d8af42444785 = (i, v, vmin)=>i === 0 ? vmin : v[i - 1];
var $7e1029ce012b1c7f$export$b2cceded85b4d6b0 = (i, v, vmax)=>i === v.length - 1 ? vmax : v[i + 1];
var $7e1029ce012b1c7f$export$e280c4b0ba1fba46 = (v, vmax)=>$7e1029ce012b1c7f$export$9e06de0973666692(v) >= vmax;
var $7e1029ce012b1c7f$export$f34fe80559da9f6e = (v, vmin)=>$7e1029ce012b1c7f$export$9e06de0973666692(v) <= vmin;
var $7e1029ce012b1c7f$export$7c4e06fee2f75722 = (v, vmin, vmax)=>{
    const value = $7e1029ce012b1c7f$export$9e06de0973666692(v);
    const minCheck = vmin == null || value >= vmin;
    const maxCheck = vmax == null || value <= vmax;
    return minCheck && maxCheck;
};
var $7e1029ce012b1c7f$export$6dc2969fe47f79f = (v, vmin, step)=>$7e1029ce012b1c7f$var$round(($7e1029ce012b1c7f$export$9e06de0973666692(v) - vmin) / step) * step + vmin;
var $7e1029ce012b1c7f$export$31ee16100cde6ce2 = (v, vmin, vmax)=>$7e1029ce012b1c7f$var$min($7e1029ce012b1c7f$var$max($7e1029ce012b1c7f$export$9e06de0973666692(v), vmin), vmax);
var $7e1029ce012b1c7f$export$864513891389ca82 = (v)=>$7e1029ce012b1c7f$export$31ee16100cde6ce2(v, 0, 1);
var $7e1029ce012b1c7f$export$22574034cd380c24 = (v, vmin, vmax)=>($7e1029ce012b1c7f$export$9e06de0973666692(v) - vmin) / (vmax - vmin);
var $7e1029ce012b1c7f$export$476354dbf49bdff6 = (p, vmin, vmax, step)=>$7e1029ce012b1c7f$export$31ee16100cde6ce2($7e1029ce012b1c7f$export$6dc2969fe47f79f(p * (vmax - vmin) + vmin, vmin, step), vmin, vmax);
var $7e1029ce012b1c7f$export$e1a7b8e69ef6c52f = (v, step)=>{
    let rv = v;
    let ss = step.toString();
    let pi = ss.indexOf(".");
    let p = pi >= 0 ? ss.length - pi : 0;
    if (p > 0) {
        let pw = $7e1029ce012b1c7f$var$pow(10, p);
        rv = $7e1029ce012b1c7f$var$round(rv * pw) / pw;
    }
    return rv;
};
var $7e1029ce012b1c7f$export$db558e705f7d32d7 = (v, dpr)=>typeof dpr === "number" ? $7e1029ce012b1c7f$var$floor(v * dpr + 0.5) / dpr : $7e1029ce012b1c7f$var$round(v);
var $7e1029ce012b1c7f$export$cb6e0bb50bc19463 = (v, vmin, vmax, step)=>{
    const min2 = vmin != null ? Number(vmin) : 0;
    const max2 = Number(vmax);
    const remainder = (v - min2) % step;
    let snapped = $7e1029ce012b1c7f$var$abs(remainder) * 2 >= step ? v + $7e1029ce012b1c7f$var$sign(remainder) * (step - $7e1029ce012b1c7f$var$abs(remainder)) : v - remainder;
    snapped = $7e1029ce012b1c7f$export$e1a7b8e69ef6c52f(snapped, step);
    if (!$7e1029ce012b1c7f$export$c9f5652083b8129d(min2) && snapped < min2) snapped = min2;
    else if (!$7e1029ce012b1c7f$export$c9f5652083b8129d(max2) && snapped > max2) {
        const stepsInRange = $7e1029ce012b1c7f$var$floor((max2 - min2) / step);
        const largestValidStep = min2 + stepsInRange * step;
        snapped = stepsInRange <= 0 || largestValidStep < min2 ? max2 : largestValidStep;
    }
    return $7e1029ce012b1c7f$export$e1a7b8e69ef6c52f(snapped, step);
};
var $7e1029ce012b1c7f$export$1119f90a8bbc6509 = (vs, i, v)=>{
    if (vs[i] === v) return vs;
    return [
        ...vs.slice(0, i),
        v,
        ...vs.slice(i + 1)
    ];
};
function $7e1029ce012b1c7f$export$d59398ffb0009913(index, ctx) {
    const minValueAtIndex = $7e1029ce012b1c7f$export$9015d8af42444785(index, ctx.values, ctx.min);
    const maxValueAtIndex = $7e1029ce012b1c7f$export$b2cceded85b4d6b0(index, ctx.values, ctx.max);
    let nextValues = ctx.values.slice();
    return function setValue(value) {
        let nextValue = $7e1029ce012b1c7f$export$cb6e0bb50bc19463(value, minValueAtIndex, maxValueAtIndex, ctx.step);
        nextValues = $7e1029ce012b1c7f$export$1119f90a8bbc6509(nextValues, index, value);
        nextValues[index] = nextValue;
        return nextValues;
    };
}
function $7e1029ce012b1c7f$export$883adeea0e999db3(index, ctx) {
    const nextValue = ctx.values[index] + ctx.step;
    return $7e1029ce012b1c7f$export$d59398ffb0009913(index, ctx)(nextValue);
}
function $7e1029ce012b1c7f$export$afee86354f7f91ab(index, ctx) {
    const nextValue = ctx.values[index] - ctx.step;
    return $7e1029ce012b1c7f$export$d59398ffb0009913(index, ctx)(nextValue);
}
var $7e1029ce012b1c7f$export$70ddabd6efec4c0a = (vs, t)=>{
    let i = vs.findIndex((v)=>t - v < 0);
    if (i === 0) return i;
    if (i === -1) return vs.length - 1;
    let vLeft = vs[i - 1];
    let vRight = vs[i];
    if ($7e1029ce012b1c7f$var$abs(vLeft - t) < $7e1029ce012b1c7f$var$abs(vRight - t)) return i - 1;
    return i;
};
var $7e1029ce012b1c7f$export$4b9ea961bfd9be6e = (vs, t)=>vs[$7e1029ce012b1c7f$export$70ddabd6efec4c0a(vs, t)];
var $7e1029ce012b1c7f$export$bf5bf18fe4d721e6 = (vs, vmin, vmax, gap)=>vs.map((v, i)=>({
            min: i === 0 ? vmin : vs[i - 1] + gap,
            max: i === vs.length - 1 ? vmax : vs[i + 1] - gap,
            value: v
        }));
var $7e1029ce012b1c7f$export$42961567a0fc6d1e = (va, vb)=>{
    const [a, b] = va;
    const [c, d] = vb;
    return (v)=>a === b || c === d ? c : c + (d - c) / (b - a) * (v - a);
};
var $7e1029ce012b1c7f$export$b6268554fba451f = (v, d = 0, b = 10)=>{
    const pow2 = Math.pow(b, d);
    return $7e1029ce012b1c7f$var$round(v * pow2) / pow2;
};
var $7e1029ce012b1c7f$var$countDecimals = (value)=>{
    if (!Number.isFinite(value)) return 0;
    let e = 1, p = 0;
    while(Math.round(value * e) / e !== value){
        e *= 10;
        p += 1;
    }
    return p;
};
var $7e1029ce012b1c7f$var$decimalOp = (a, op, b)=>{
    let result = op === "+" ? a + b : a - b;
    if (a % 1 !== 0 || b % 1 !== 0) {
        const multiplier = 10 ** Math.max($7e1029ce012b1c7f$var$countDecimals(a), $7e1029ce012b1c7f$var$countDecimals(b));
        a = Math.round(a * multiplier);
        b = Math.round(b * multiplier);
        result = op === "+" ? a + b : a - b;
        result /= multiplier;
    }
    return result;
};
var $7e1029ce012b1c7f$export$d3f405d8a429a91 = (v, s)=>$7e1029ce012b1c7f$var$decimalOp($7e1029ce012b1c7f$export$9e06de0973666692(v), "+", s);
var $7e1029ce012b1c7f$export$5b2c46821c67093d = (v, s)=>$7e1029ce012b1c7f$var$decimalOp($7e1029ce012b1c7f$export$9e06de0973666692(v), "-", s);
var $7e1029ce012b1c7f$export$6562491d7413c9c9 = (v)=>typeof v === "number" ? `${v}px` : v;



// src/radio-group.dom.ts

var $5c8879d781fe0348$export$dfdcab00b0f585a9 = (ctx)=>ctx.ids?.root ?? `radio-group:${ctx.id}`;
var $5c8879d781fe0348$export$3a89b5810eeb6aa5 = (ctx)=>ctx.ids?.label ?? `radio-group:${ctx.id}:label`;
var $5c8879d781fe0348$export$9145995848b05025 = (ctx, value)=>ctx.ids?.item?.(value) ?? `radio-group:${ctx.id}:radio:${value}`;
var $5c8879d781fe0348$export$1e1452898700ce03 = (ctx, value)=>ctx.ids?.itemHiddenInput?.(value) ?? `radio-group:${ctx.id}:radio:input:${value}`;
var $5c8879d781fe0348$export$8417e36ccdacec5b = (ctx, value)=>ctx.ids?.itemControl?.(value) ?? `radio-group:${ctx.id}:radio:control:${value}`;
var $5c8879d781fe0348$export$ffa09c785adb031c = (ctx, value)=>ctx.ids?.itemLabel?.(value) ?? `radio-group:${ctx.id}:radio:label:${value}`;
var $5c8879d781fe0348$export$146d1badb3706b40 = (ctx)=>ctx.ids?.indicator ?? `radio-group:${ctx.id}:indicator`;
var $5c8879d781fe0348$export$5688053fba312fa5 = (ctx)=>ctx.getById($5c8879d781fe0348$export$dfdcab00b0f585a9(ctx));
var $5c8879d781fe0348$export$d7bfae21deba79d6 = (ctx, value)=>ctx.getById($5c8879d781fe0348$export$1e1452898700ce03(ctx, value));
var $5c8879d781fe0348$export$b604b02e87731bc2 = (ctx)=>ctx.getById($5c8879d781fe0348$export$146d1badb3706b40(ctx));
var $5c8879d781fe0348$export$da154ea1eef21252 = (ctx)=>$5c8879d781fe0348$export$5688053fba312fa5(ctx)?.querySelector("input:not(:disabled)");
var $5c8879d781fe0348$export$df04f235934b664d = (ctx)=>$5c8879d781fe0348$export$5688053fba312fa5(ctx)?.querySelector("input:not(:disabled):checked");
var $5c8879d781fe0348$export$ad0d5fd7f2570af5 = (ctx)=>{
    const ownerId = CSS.escape($5c8879d781fe0348$export$dfdcab00b0f585a9(ctx));
    const selector = `input[type=radio][data-ownedby='${ownerId}']:not([disabled])`;
    return (0, $0a4b14a4ad082330$export$dcd0d083aa86c355)($5c8879d781fe0348$export$5688053fba312fa5(ctx), selector);
};
var $5c8879d781fe0348$export$f8295d70cfa78f0d = (ctx, value)=>{
    if (!value) return;
    return ctx.getById($5c8879d781fe0348$export$9145995848b05025(ctx, value));
};
var $5c8879d781fe0348$export$fa103b52b05c42ac = (el)=>({
        x: el?.offsetLeft ?? 0,
        y: el?.offsetTop ?? 0,
        width: el?.offsetWidth ?? 0,
        height: el?.offsetHeight ?? 0
    });
var $5c8879d781fe0348$export$5d213583b168eefa = (ctx, id)=>{
    const radioEl = ctx.getById($5c8879d781fe0348$export$9145995848b05025(ctx, id));
    if (!radioEl) return;
    return $5c8879d781fe0348$export$fa103b52b05c42ac(radioEl);
};


function $90d337c1df5d7f5f$export$64605811ab45167f(service, normalize) {
    const { context: context, send: send, computed: computed, prop: prop, scope: scope } = service;
    const groupDisabled = computed("isDisabled");
    const groupInvalid = prop("invalid");
    const readOnly = prop("readOnly");
    function getItemState(props) {
        return {
            value: props.value,
            invalid: !!props.invalid || !!groupInvalid,
            disabled: !!props.disabled || groupDisabled,
            checked: context.get("value") === props.value,
            focused: context.get("focusedValue") === props.value,
            focusVisible: context.get("focusVisibleValue") === props.value,
            hovered: context.get("hoveredValue") === props.value,
            active: context.get("activeValue") === props.value
        };
    }
    function getItemDataAttrs(props) {
        const itemState = getItemState(props);
        return {
            "data-focus": (0, $dbd9babc41e226bd$export$5cc3b7b83e34ade7)(itemState.focused),
            "data-focus-visible": (0, $dbd9babc41e226bd$export$5cc3b7b83e34ade7)(itemState.focusVisible),
            "data-disabled": (0, $dbd9babc41e226bd$export$5cc3b7b83e34ade7)(itemState.disabled),
            "data-readonly": (0, $dbd9babc41e226bd$export$5cc3b7b83e34ade7)(readOnly),
            "data-state": itemState.checked ? "checked" : "unchecked",
            "data-hover": (0, $dbd9babc41e226bd$export$5cc3b7b83e34ade7)(itemState.hovered),
            "data-invalid": (0, $dbd9babc41e226bd$export$5cc3b7b83e34ade7)(itemState.invalid),
            "data-orientation": prop("orientation"),
            "data-ssr": (0, $dbd9babc41e226bd$export$5cc3b7b83e34ade7)(context.get("ssr"))
        };
    }
    const focus = ()=>{
        const nodeToFocus = $5c8879d781fe0348$export$df04f235934b664d(scope) ?? $5c8879d781fe0348$export$da154ea1eef21252(scope);
        nodeToFocus?.focus();
    };
    return {
        focus: focus,
        value: context.get("value"),
        setValue (value) {
            send({
                type: "SET_VALUE",
                value: value,
                isTrusted: false
            });
        },
        clearValue () {
            send({
                type: "SET_VALUE",
                value: null,
                isTrusted: false
            });
        },
        getRootProps () {
            return normalize.element({
                ...(0, $e17d441bd191f763$export$6e2410c1d27f06e7).root.attrs,
                role: "radiogroup",
                id: $5c8879d781fe0348$export$dfdcab00b0f585a9(scope),
                "aria-labelledby": $5c8879d781fe0348$export$3a89b5810eeb6aa5(scope),
                "aria-required": prop("required") || void 0,
                "aria-disabled": groupDisabled || void 0,
                "aria-readonly": readOnly || void 0,
                "data-orientation": prop("orientation"),
                "data-disabled": (0, $dbd9babc41e226bd$export$5cc3b7b83e34ade7)(groupDisabled),
                "data-invalid": (0, $dbd9babc41e226bd$export$5cc3b7b83e34ade7)(groupInvalid),
                "data-required": (0, $dbd9babc41e226bd$export$5cc3b7b83e34ade7)(prop("required")),
                "aria-orientation": prop("orientation"),
                dir: prop("dir"),
                style: {
                    position: "relative"
                }
            });
        },
        getLabelProps () {
            return normalize.element({
                ...(0, $e17d441bd191f763$export$6e2410c1d27f06e7).label.attrs,
                dir: prop("dir"),
                "data-orientation": prop("orientation"),
                "data-disabled": (0, $dbd9babc41e226bd$export$5cc3b7b83e34ade7)(groupDisabled),
                "data-invalid": (0, $dbd9babc41e226bd$export$5cc3b7b83e34ade7)(groupInvalid),
                "data-required": (0, $dbd9babc41e226bd$export$5cc3b7b83e34ade7)(prop("required")),
                id: $5c8879d781fe0348$export$3a89b5810eeb6aa5(scope),
                onClick: focus
            });
        },
        getItemState: getItemState,
        getItemProps (props) {
            const itemState = getItemState(props);
            return normalize.label({
                ...(0, $e17d441bd191f763$export$6e2410c1d27f06e7).item.attrs,
                dir: prop("dir"),
                id: $5c8879d781fe0348$export$9145995848b05025(scope, props.value),
                htmlFor: $5c8879d781fe0348$export$1e1452898700ce03(scope, props.value),
                ...getItemDataAttrs(props),
                onPointerMove () {
                    if (itemState.disabled) return;
                    if (itemState.hovered) return;
                    send({
                        type: "SET_HOVERED",
                        value: props.value,
                        hovered: true
                    });
                },
                onPointerLeave () {
                    if (itemState.disabled) return;
                    send({
                        type: "SET_HOVERED",
                        value: null
                    });
                },
                onPointerDown (event) {
                    if (itemState.disabled) return;
                    if (!(0, $3921311bf0c8eca9$export$698c4f0ff5e11e52)(event)) return;
                    if (itemState.focused && event.pointerType === "mouse") event.preventDefault();
                    send({
                        type: "SET_ACTIVE",
                        value: props.value,
                        active: true
                    });
                },
                onPointerUp () {
                    if (itemState.disabled) return;
                    send({
                        type: "SET_ACTIVE",
                        value: null
                    });
                },
                onClick () {
                    if (!itemState.disabled && (0, $1bdb5bdc36ac2529$export$95df08bae54cb4df)()) $5c8879d781fe0348$export$d7bfae21deba79d6(scope, props.value)?.focus();
                }
            });
        },
        getItemTextProps (props) {
            return normalize.element({
                ...(0, $e17d441bd191f763$export$6e2410c1d27f06e7).itemText.attrs,
                dir: prop("dir"),
                id: $5c8879d781fe0348$export$ffa09c785adb031c(scope, props.value),
                ...getItemDataAttrs(props)
            });
        },
        getItemControlProps (props) {
            const itemState = getItemState(props);
            return normalize.element({
                ...(0, $e17d441bd191f763$export$6e2410c1d27f06e7).itemControl.attrs,
                dir: prop("dir"),
                id: $5c8879d781fe0348$export$8417e36ccdacec5b(scope, props.value),
                "data-active": (0, $dbd9babc41e226bd$export$5cc3b7b83e34ade7)(itemState.active),
                "aria-hidden": true,
                ...getItemDataAttrs(props)
            });
        },
        getItemHiddenInputProps (props) {
            const itemState = getItemState(props);
            return normalize.input({
                "data-ownedby": $5c8879d781fe0348$export$dfdcab00b0f585a9(scope),
                id: $5c8879d781fe0348$export$1e1452898700ce03(scope, props.value),
                type: "radio",
                name: prop("name") || prop("id"),
                form: prop("form"),
                value: props.value,
                required: prop("required"),
                "aria-labelledby": $5c8879d781fe0348$export$ffa09c785adb031c(scope, props.value),
                "aria-invalid": itemState.invalid || void 0,
                onClick (event) {
                    if (readOnly) {
                        event.preventDefault();
                        return;
                    }
                    if (event.currentTarget.checked) send({
                        type: "SET_VALUE",
                        value: props.value,
                        isTrusted: true
                    });
                },
                onBlur () {
                    send({
                        type: "SET_FOCUSED",
                        value: null,
                        focused: false,
                        focusVisible: false
                    });
                },
                onFocus () {
                    const focusVisible = (0, $855e001ba27d7a0a$export$b9b3dfddab17db27)();
                    send({
                        type: "SET_FOCUSED",
                        value: props.value,
                        focused: true,
                        focusVisible: focusVisible
                    });
                },
                onKeyDown (event) {
                    if (event.defaultPrevented) return;
                    if (event.key === " ") send({
                        type: "SET_ACTIVE",
                        value: props.value,
                        active: true
                    });
                },
                onKeyUp (event) {
                    if (event.defaultPrevented) return;
                    if (event.key === " ") send({
                        type: "SET_ACTIVE",
                        value: null
                    });
                },
                disabled: itemState.disabled || readOnly,
                defaultChecked: itemState.checked,
                style: (0, $20b7ad6451938f04$export$8fecac46448b5689)
            });
        },
        getIndicatorProps () {
            const rect = context.get("indicatorRect");
            const animateIndicator = context.get("animateIndicator");
            return normalize.element({
                id: $5c8879d781fe0348$export$146d1badb3706b40(scope),
                ...(0, $e17d441bd191f763$export$6e2410c1d27f06e7).indicator.attrs,
                dir: prop("dir"),
                hidden: context.get("value") == null || $90d337c1df5d7f5f$var$isRectEmpty(rect),
                "data-disabled": (0, $dbd9babc41e226bd$export$5cc3b7b83e34ade7)(groupDisabled),
                "data-orientation": prop("orientation"),
                onTransitionEnd (event) {
                    if ((0, $3921311bf0c8eca9$export$e58f029f0fbfdb29)(event) !== event.currentTarget) return;
                    send({
                        type: "INDICATOR_TRANSITION_END"
                    });
                },
                style: {
                    "--transition-property": "left, top, width, height",
                    "--left": (0, $7e1029ce012b1c7f$export$6562491d7413c9c9)(rect?.x),
                    "--top": (0, $7e1029ce012b1c7f$export$6562491d7413c9c9)(rect?.y),
                    "--width": (0, $7e1029ce012b1c7f$export$6562491d7413c9c9)(rect?.width),
                    "--height": (0, $7e1029ce012b1c7f$export$6562491d7413c9c9)(rect?.height),
                    position: "absolute",
                    willChange: animateIndicator ? "var(--transition-property)" : "auto",
                    transitionProperty: animateIndicator ? "var(--transition-property)" : "none",
                    transitionDuration: animateIndicator ? "var(--transition-duration, 150ms)" : "0ms",
                    transitionTimingFunction: "var(--transition-timing-function)",
                    [prop("orientation") === "horizontal" ? "left" : "top"]: prop("orientation") === "horizontal" ? "var(--left)" : "var(--top)"
                }
            });
        }
    };
}
var $90d337c1df5d7f5f$var$isRectEmpty = (rect)=>rect == null || rect.width === 0 && rect.height === 0 && rect.x === 0 && rect.y === 0;

// src/radio-group.machine.ts



function $80b3e775b628bedc$var$getDescriptor(el, options) {
    const { type: type = "HTMLInputElement", property: property = "value" } = options;
    const proto = (0, $2020ec4601cca401$export$38b2d434cce3ea22)(el)[type].prototype;
    return Object.getOwnPropertyDescriptor(proto, property) ?? {};
}
function $80b3e775b628bedc$var$getElementType(el) {
    if (el.localName === "input") return "HTMLInputElement";
    if (el.localName === "textarea") return "HTMLTextAreaElement";
    if (el.localName === "select") return "HTMLSelectElement";
}
function $80b3e775b628bedc$export$c2c7fef809f2f8ef(el, value, property = "value") {
    if (!el) return;
    const type = $80b3e775b628bedc$var$getElementType(el);
    if (type) {
        const descriptor = $80b3e775b628bedc$var$getDescriptor(el, {
            type: type,
            property: property
        });
        descriptor.set?.call(el, value);
    }
    el.setAttribute(property, value);
}
function $80b3e775b628bedc$export$1b2cb9f366b7b263(el, checked) {
    if (!el) return;
    const descriptor = $80b3e775b628bedc$var$getDescriptor(el, {
        type: "HTMLInputElement",
        property: "checked"
    });
    descriptor.set?.call(el, checked);
    if (checked) el.setAttribute("checked", "");
    else el.removeAttribute("checked");
}
function $80b3e775b628bedc$export$71608d92f9cda884(el, options) {
    const { value: value, bubbles: bubbles = true } = options;
    if (!el) return;
    const win = (0, $2020ec4601cca401$export$38b2d434cce3ea22)(el);
    if (!(el instanceof win.HTMLInputElement)) return;
    $80b3e775b628bedc$export$c2c7fef809f2f8ef(el, `${value}`);
    const event = new win.Event("input", {
        bubbles: bubbles
    });
    el.dispatchEvent($80b3e775b628bedc$export$fe1e8776a7f929e9(event));
}
function $80b3e775b628bedc$export$ebab7723673c874f(el, options) {
    const { checked: checked, bubbles: bubbles = true } = options;
    if (!el) return;
    const win = (0, $2020ec4601cca401$export$38b2d434cce3ea22)(el);
    if (!(el instanceof win.HTMLInputElement)) return;
    $80b3e775b628bedc$export$1b2cb9f366b7b263(el, checked);
    const event = new win.Event("click", {
        bubbles: bubbles
    });
    el.dispatchEvent($80b3e775b628bedc$export$fe1e8776a7f929e9(event));
}
function $80b3e775b628bedc$var$isFormElement(el) {
    return el.matches("textarea, input, select, button");
}
function $80b3e775b628bedc$var$trackFormReset(el, callback) {
    if (!el) return;
    const form = $80b3e775b628bedc$var$isFormElement(el) ? el.form : el.closest("form");
    const onReset = (e)=>{
        if (e.defaultPrevented) return;
        callback();
    };
    form?.addEventListener("reset", onReset, {
        passive: true
    });
    return ()=>form?.removeEventListener("reset", onReset);
}
function $80b3e775b628bedc$var$trackFieldsetDisabled(el, callback) {
    const fieldset = el?.closest("fieldset");
    if (!fieldset) return;
    callback(fieldset.disabled);
    const win = (0, $2020ec4601cca401$export$38b2d434cce3ea22)(fieldset);
    const obs = new win.MutationObserver(()=>callback(fieldset.disabled));
    obs.observe(fieldset, {
        attributes: true,
        attributeFilter: [
            "disabled"
        ]
    });
    return ()=>obs.disconnect();
}
function $80b3e775b628bedc$export$a48469c7b6beba26(el, options) {
    if (!el) return;
    const { onFieldsetDisabledChange: onFieldsetDisabledChange, onFormReset: onFormReset } = options;
    const cleanups = [
        $80b3e775b628bedc$var$trackFormReset(el, onFormReset),
        $80b3e775b628bedc$var$trackFieldsetDisabled(el, onFieldsetDisabledChange)
    ];
    return ()=>cleanups.forEach((cleanup)=>cleanup?.());
}
var $80b3e775b628bedc$var$INTERNAL_CHANGE_EVENT = /* @__PURE__ */ Symbol.for("zag.changeEvent");
function $80b3e775b628bedc$export$e18652b40d54e483(e) {
    return Object.prototype.hasOwnProperty.call(e, $80b3e775b628bedc$var$INTERNAL_CHANGE_EVENT);
}
function $80b3e775b628bedc$export$fe1e8776a7f929e9(event) {
    if ($80b3e775b628bedc$export$e18652b40d54e483(event)) return event;
    Object.defineProperty(event, $80b3e775b628bedc$var$INTERNAL_CHANGE_EVENT, {
        value: true
    });
    return event;
}



function $4ec69037fd8e0353$var$createSharedResizeObserver(options) {
    const listeners = /* @__PURE__ */ new WeakMap();
    let observer;
    const entries = /* @__PURE__ */ new WeakMap();
    const getObserver = (win)=>{
        if (observer) return observer;
        observer = new win.ResizeObserver((observedEntries)=>{
            for (const entry of observedEntries){
                entries.set(entry.target, entry);
                const elementListeners = listeners.get(entry.target);
                if (elementListeners) for (const listener of elementListeners)listener(entry);
            }
        });
        return observer;
    };
    const observe = (element, listener)=>{
        let elementListeners = listeners.get(element) || /* @__PURE__ */ new Set();
        elementListeners.add(listener);
        listeners.set(element, elementListeners);
        const win = (0, $2020ec4601cca401$export$38b2d434cce3ea22)(element);
        getObserver(win).observe(element, options);
        return ()=>{
            const elementListeners2 = listeners.get(element);
            if (!elementListeners2) return;
            elementListeners2.delete(listener);
            if (elementListeners2.size === 0) {
                listeners.delete(element);
                getObserver(win).unobserve(element);
            }
        };
    };
    const unobserve = (element)=>{
        listeners.delete(element);
        observer?.unobserve(element);
    };
    return {
        observe: observe,
        unobserve: unobserve
    };
}
var $4ec69037fd8e0353$export$31857af11cd1cf02 = /* @__PURE__ */ $4ec69037fd8e0353$var$createSharedResizeObserver({
    box: "content-box"
});
var $4ec69037fd8e0353$export$2d37f1fa7d6fb01e = /* @__PURE__ */ $4ec69037fd8e0353$var$createSharedResizeObserver({
    box: "border-box"
});
var $4ec69037fd8e0353$export$f3f82e1dc1990455 = /* @__PURE__ */ $4ec69037fd8e0353$var$createSharedResizeObserver({
    box: "device-pixel-content-box"
});




var { not: $6c8d93b945801d49$var$not } = (0, $9aa7f39f9520657f$export$285462e61607a24f)();
var $6c8d93b945801d49$export$ea56d40cd27c3480 = (0, $9aa7f39f9520657f$export$aaa7fa18f8e9b2e8)({
    props ({ props: props }) {
        return {
            orientation: "vertical",
            ...props
        };
    },
    initialState () {
        return "idle";
    },
    context ({ prop: prop, bindable: bindable }) {
        return {
            value: bindable(()=>({
                    defaultValue: prop("defaultValue"),
                    value: prop("value"),
                    onChange (value) {
                        prop("onValueChange")?.({
                            value: value
                        });
                    }
                })),
            activeValue: bindable(()=>({
                    defaultValue: null
                })),
            focusedValue: bindable(()=>({
                    defaultValue: null
                })),
            focusVisibleValue: bindable(()=>({
                    defaultValue: null
                })),
            hoveredValue: bindable(()=>({
                    defaultValue: null
                })),
            indicatorRect: bindable(()=>({
                    defaultValue: null
                })),
            animateIndicator: bindable(()=>({
                    defaultValue: false
                })),
            fieldsetDisabled: bindable(()=>({
                    defaultValue: false
                })),
            ssr: bindable(()=>({
                    defaultValue: true
                }))
        };
    },
    refs () {
        return {
            indicatorCleanup: null,
            focusVisibleValue: null,
            prevValue: null
        };
    },
    computed: {
        isDisabled: ({ prop: prop, context: context })=>!!prop("disabled") || context.get("fieldsetDisabled")
    },
    entry: [
        "syncPrevValue",
        "syncIndicatorRect",
        "syncSsr"
    ],
    exit: [
        "cleanupObserver"
    ],
    effects: [
        "trackFormControlState",
        "trackFocusVisible"
    ],
    watch ({ track: track, action: action, context: context }) {
        track([
            ()=>context.get("value")
        ], ()=>{
            action([
                "syncIndicatorAnimation",
                "syncIndicatorRect",
                "syncInputElements"
            ]);
        });
    },
    on: {
        SET_VALUE: [
            {
                guard: $6c8d93b945801d49$var$not("isTrusted"),
                actions: [
                    "setValue",
                    "dispatchChangeEvent"
                ]
            },
            {
                actions: [
                    "setValue"
                ]
            }
        ],
        SET_HOVERED: {
            actions: [
                "setHovered"
            ]
        },
        SET_ACTIVE: {
            actions: [
                "setActive"
            ]
        },
        SET_FOCUSED: {
            actions: [
                "setFocused"
            ]
        },
        INDICATOR_TRANSITION_END: {
            actions: [
                "clearIndicatorAnimation"
            ]
        }
    },
    states: {
        idle: {}
    },
    implementations: {
        guards: {
            isTrusted: ({ event: event })=>!!event.isTrusted
        },
        effects: {
            trackFormControlState ({ context: context, scope: scope }) {
                return (0, $80b3e775b628bedc$export$a48469c7b6beba26)($5c8879d781fe0348$export$5688053fba312fa5(scope), {
                    onFieldsetDisabledChange (disabled) {
                        context.set("fieldsetDisabled", disabled);
                    },
                    onFormReset () {
                        context.set("value", context.initial("value"));
                    }
                });
            },
            trackFocusVisible ({ scope: scope }) {
                return (0, $855e001ba27d7a0a$export$920b4983565c6f4d)({
                    root: scope.getRootNode?.()
                });
            }
        },
        actions: {
            setValue ({ context: context, event: event }) {
                context.set("value", event.value);
            },
            setHovered ({ context: context, event: event }) {
                context.set("hoveredValue", event.value);
            },
            setActive ({ context: context, event: event }) {
                context.set("activeValue", event.value);
            },
            setFocused ({ context: context, event: event }) {
                context.set("focusedValue", event.value);
                const focusVisibleValue = event.value != null && event.focusVisible ? event.value : null;
                context.set("focusVisibleValue", focusVisibleValue);
            },
            syncPrevValue ({ context: context, refs: refs }) {
                refs.set("prevValue", context.get("value"));
            },
            syncIndicatorAnimation ({ context: context, refs: refs }) {
                const prevValue = refs.get("prevValue");
                const nextValue = context.get("value");
                const animate = prevValue != null && nextValue != null && prevValue !== nextValue;
                context.set("animateIndicator", animate);
                refs.set("prevValue", nextValue);
            },
            clearIndicatorAnimation ({ context: context }) {
                context.set("animateIndicator", false);
            },
            syncInputElements ({ context: context, scope: scope }) {
                const inputs = $5c8879d781fe0348$export$ad0d5fd7f2570af5(scope);
                inputs.forEach((input)=>{
                    input.checked = input.value === context.get("value");
                });
            },
            cleanupObserver ({ refs: refs }) {
                refs.get("indicatorCleanup")?.();
            },
            syncSsr ({ context: context }) {
                context.set("ssr", false);
            },
            syncIndicatorRect ({ context: context, scope: scope, refs: refs }) {
                refs.get("indicatorCleanup")?.();
                if (!$5c8879d781fe0348$export$b604b02e87731bc2(scope)) return;
                const value = context.get("value");
                const radioEl = $5c8879d781fe0348$export$f8295d70cfa78f0d(scope, value);
                if (value == null || !radioEl) {
                    context.set("indicatorRect", null);
                    return;
                }
                const exec = ()=>{
                    context.set("indicatorRect", $5c8879d781fe0348$export$fa103b52b05c42ac(radioEl));
                };
                exec();
                const indicatorCleanup = (0, $4ec69037fd8e0353$export$2d37f1fa7d6fb01e).observe(radioEl, exec);
                refs.set("indicatorCleanup", indicatorCleanup);
            },
            dispatchChangeEvent ({ context: context, scope: scope }) {
                const inputEls = $5c8879d781fe0348$export$ad0d5fd7f2570af5(scope);
                inputEls.forEach((inputEl)=>{
                    const checked = inputEl.value === context.get("value");
                    if (checked === inputEl.checked) return;
                    (0, $80b3e775b628bedc$export$ebab7723673c874f)(inputEl, {
                        checked: checked
                    });
                });
            }
        }
    }
});



var $8v0nu = parcelRequire("8v0nu");

"use client";
//#region src/components/radio-group/use-radio-group.ts
var $c7c0bde658b6cc54$export$62b9571f283ff5c2 = (props)=>{
    const fieldset = (0, $2a2f69e4c1ad7c1b$export$e46e66a55913b34c)();
    const id = (0, $8v0nu.useId)();
    const { getRootNode: getRootNode } = (0, $cfa7a900a06000ef$export$899b1e582a0b3c80)();
    const { dir: dir } = (0, $af19f2672b388a39$export$2a7b1d9f665d6730)();
    const machineProps = {
        id: id,
        ids: {
            label: fieldset?.ids?.legend
        },
        dir: dir,
        disabled: fieldset?.disabled,
        invalid: fieldset?.invalid,
        getRootNode: getRootNode,
        ...props
    };
    const service = (0, $54265883fb157840$export$e0338c4153421160)($6c8d93b945801d49$export$ea56d40cd27c3480, machineProps);
    return $90d337c1df5d7f5f$export$64605811ab45167f(service, (0, $06b0a2ce147a2fe4$export$601abcd8103db5e4));
};



var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/radio-group/radio-group-root.tsx
var $160c5d9b04d3047b$var$splitRootProps = (0, $41bdb03050f91b76$export$3ea53b214fbc1986)();
var $160c5d9b04d3047b$export$b2c628596de388b3 = (0, $8v0nu.forwardRef)((props, ref)=>{
    const [useRadioGroupProps, localProps] = $160c5d9b04d3047b$var$splitRootProps(props, [
        "defaultValue",
        "disabled",
        "form",
        "id",
        "ids",
        "invalid",
        "name",
        "onValueChange",
        "orientation",
        "readOnly",
        "required",
        "value"
    ]);
    const radioGroup = (0, $c7c0bde658b6cc54$export$62b9571f283ff5c2)(useRadioGroupProps);
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)(radioGroup.getRootProps(), localProps);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $72816d3edafb1469$export$59b7462f266cd53f), {
        value: radioGroup,
        children: /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).div, {
            ...mergedProps,
            ref: ref
        })
    });
});
$160c5d9b04d3047b$export$b2c628596de388b3.displayName = "RadioGroupRoot";






var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/radio-group/radio-group-root-provider.tsx
var $67a99c86d8e215d8$var$splitRootProviderProps = (0, $41bdb03050f91b76$export$3ea53b214fbc1986)();
var $67a99c86d8e215d8$export$8d95b43f134f9f0c = (0, $8v0nu.forwardRef)((props, ref)=>{
    const [{ value: radioGroup }, localProps] = $67a99c86d8e215d8$var$splitRootProviderProps(props, [
        "value"
    ]);
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)(radioGroup.getRootProps(), localProps);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $72816d3edafb1469$export$59b7462f266cd53f), {
        value: radioGroup,
        children: /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).div, {
            ...mergedProps,
            ref: ref
        })
    });
});
$67a99c86d8e215d8$export$8d95b43f134f9f0c.displayName = "RadioGroupRootProvider";


//#region src/components/radio-group/radio-group.ts
var $9e11582bb0381976$export$d4004bde67a2efc3 = /* @__PURE__ */ (0, $57db88e2bf337fea$export$8126e515a7516e2)({
    Context: ()=>(0, $f78458c321614b9f$export$a79eda4ff50e30b6),
    Indicator: ()=>(0, $7728a48eed17d9ce$export$5fb54c671a65c88),
    Item: ()=>(0, $98519634e450fdac$export$9f866c100ef519e4),
    ItemContext: ()=>(0, $b8a114b59973badc$export$816354ffcf4c626d),
    ItemControl: ()=>(0, $a3b4194a823871da$export$2066302a11743000),
    ItemHiddenInput: ()=>(0, $b1cc5bab80e1d332$export$a8848d8b7434664e),
    ItemText: ()=>(0, $6f46b82e93828e60$export$ecfcbe15d1338b4d),
    Label: ()=>(0, $e18ff8aad8d03f64$export$6d06580bd6ecb283),
    Root: ()=>(0, $160c5d9b04d3047b$export$b2c628596de388b3),
    RootProvider: ()=>(0, $67a99c86d8e215d8$export$8d95b43f134f9f0c)
});



var $8v0nu = parcelRequire("8v0nu");



var $8v0nu = parcelRequire("8v0nu");




"use strict";
"use client";
const $74ca3e00678e77f3$export$c3158be77d05c398 = (0, $8v0nu.forwardRef)(function Radiomark2(props, ref) {
    const recipe = (0, $971213434541a23d$export$cf0e09a7086104ff)({
        key: "radiomark",
        recipe: props.recipe
    });
    const [variantProps, restProps] = recipe.splitVariantProps(props);
    const { checked: checked, disabled: disabled, unstyled: unstyled, children: children, ...rest } = restProps;
    const styles = unstyled ? (0, $0fb716203df70dd7$export$e37f626c01cb373a) : recipe(variantProps);
    const sharedProps = {
        ref: ref,
        "data-checked": (0, $f85b338274abd06b$export$5cc3b7b83e34ade7)(checked),
        "data-disabled": (0, $f85b338274abd06b$export$5cc3b7b83e34ade7)(disabled),
        ...rest,
        css: [
            styles,
            props.css
        ]
    };
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $4042601bfa1a9d25$export$7cd122d781af9fa4).span, {
        ...sharedProps,
        children: checked && /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)("span", {
            className: "dot"
        })
    });
});
$74ca3e00678e77f3$export$c3158be77d05c398.displayName = "Radiomark";


"use strict";
"use client";
const { withProvider: $d964deda44435a91$var$withProvider, withContext: $d964deda44435a91$var$withContext, useStyles: $d964deda44435a91$export$a891bed305baddcb, PropsProvider: $d964deda44435a91$var$PropsProvider } = (0, $04636a451c2392c0$export$ac7f79c9443925b8)({
    key: "radioGroup"
});
const $d964deda44435a91$export$8d95b43f134f9f0c = $d964deda44435a91$var$withProvider((0, $9e11582bb0381976$export$d4004bde67a2efc3).RootProvider, "root", {
    forwardAsChild: true
});
const $d964deda44435a91$export$b2c628596de388b3 = $d964deda44435a91$var$withProvider((0, $9e11582bb0381976$export$d4004bde67a2efc3).Root, "root", {
    forwardAsChild: true
});
const $d964deda44435a91$export$92b956a9dfd5365e = $d964deda44435a91$var$PropsProvider;
const $d964deda44435a91$export$6d06580bd6ecb283 = $d964deda44435a91$var$withContext((0, $9e11582bb0381976$export$d4004bde67a2efc3).Label, "label", {
    forwardAsChild: true
});
const $d964deda44435a91$export$9f866c100ef519e4 = $d964deda44435a91$var$withContext((0, $9e11582bb0381976$export$d4004bde67a2efc3).Item, "item", {
    forwardAsChild: true
});
const $d964deda44435a91$export$ecfcbe15d1338b4d = $d964deda44435a91$var$withContext((0, $9e11582bb0381976$export$d4004bde67a2efc3).ItemText, "itemText", {
    forwardAsChild: true
});
const $d964deda44435a91$export$2066302a11743000 = $d964deda44435a91$var$withContext((0, $9e11582bb0381976$export$d4004bde67a2efc3).ItemControl, "itemControl", {
    forwardAsChild: true
});
const $d964deda44435a91$export$e653518eb4823d9e = (0, $8v0nu.forwardRef)(function RadioGroupItemIndicator2(props, ref) {
    const styles = $d964deda44435a91$export$a891bed305baddcb();
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $9e11582bb0381976$export$d4004bde67a2efc3).ItemContext, {
        children: (itemState)=>/* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $9e11582bb0381976$export$d4004bde67a2efc3).ItemControl, {
                asChild: true,
                children: /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $74ca3e00678e77f3$export$c3158be77d05c398), {
                    ref: ref,
                    unstyled: true,
                    ...props,
                    checked: itemState.checked,
                    disabled: itemState.disabled,
                    css: [
                        styles["itemControl"],
                        props.css
                    ]
                })
            })
    });
});
const $d964deda44435a91$export$a79eda4ff50e30b6 = (0, $9e11582bb0381976$export$d4004bde67a2efc3).Context;
const $d964deda44435a91$export$816354ffcf4c626d = (0, $9e11582bb0381976$export$d4004bde67a2efc3).ItemContext;
const $d964deda44435a91$export$a8848d8b7434664e = (0, $9e11582bb0381976$export$d4004bde67a2efc3).ItemHiddenInput;


"use strict";



var $jTKGQ = parcelRequire("jTKGQ");

function $d8f83a902ec18287$export$578a0ba473f83a10(props) {
    const { pointer: pointer, isRequired: isRequired } = props;
    const field = props.field;
    const options = field.enum;
    if (field.allowOther) throw new Error("WidgetRadio: allowOther is not supported. Use widget 'tagger' instead");
    if (!options?.length) throw new Error('WidgetRadio: enum is required');
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $jTKGQ.FastField), {
        name: pointer,
        children: ({ field: { value: value }, meta: meta, form: { setFieldValue: setFieldValue, setFieldTouched: setFieldTouched } })=>// Fieldset (not Field.Root): a radio group is a set of controls, so a
            // single <label> has nothing valid to point at — Field.Label's
            // htmlFor would dangle. A legend labels the group as a whole.
            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $007be631de130dc2$exports).Root, {
                invalid: !!(meta.touched && meta.error),
                children: [
                    field.label && /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $007be631de130dc2$exports).Legend, {
                        children: [
                            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $8f2967926209c75b$export$1acdcf5a973a8414), {
                                size: "xs",
                                children: field.label
                            }),
                            isRequired && /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $f80be8aeb6fc9430$export$5f1714a13ed34c01), {
                                color: "fg.error",
                                lineHeight: "1",
                                ms: "1",
                                "aria-hidden": "true",
                                children: "*"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $6094f717792fedac$exports).Root, {
                        size: "sm",
                        gap: 4,
                        display: "flex",
                        // Formik leaves an untouched field undefined; coerce to null so the
                        // group mounts controlled and doesn't warn/flip on first change.
                        value: value ?? null,
                        onValueChange: (details)=>{
                            setFieldValue(pointer, details.value);
                            setFieldTouched(pointer, true);
                        },
                        children: options.map(([radioValue, label])=>/*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $6094f717792fedac$exports).Item, {
                                value: radioValue,
                                children: [
                                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $6094f717792fedac$exports).ItemHiddenInput, {}),
                                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $6094f717792fedac$exports).ItemControl, {}),
                                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $6094f717792fedac$exports).ItemText, {
                                        children: label
                                    })
                                ]
                            }, radioValue))
                    }),
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $007be631de130dc2$exports).ErrorText, {
                        children: meta.error
                    })
                ]
            })
    });
}



parcelRequire("8v0nu");
var $aa074b70fa1ae362$exports = {};

$parcel$export($aa074b70fa1ae362$exports, "Context", function () { return $2ad42aceae5b632f$export$b085522c77523c51; });
$parcel$export($aa074b70fa1ae362$exports, "Control", function () { return $2ad42aceae5b632f$export$92481776a9137611; });
$parcel$export($aa074b70fa1ae362$exports, "Group", function () { return $2ad42aceae5b632f$export$4aa08d5625cb8ead; });
$parcel$export($aa074b70fa1ae362$exports, "HiddenInput", function () { return $2ad42aceae5b632f$export$747d503966d03acf; });
$parcel$export($aa074b70fa1ae362$exports, "Indicator", function () { return $2ad42aceae5b632f$export$59aad738f51d1c05; });
$parcel$export($aa074b70fa1ae362$exports, "Label", function () { return $2ad42aceae5b632f$export$fc9014afe1b6db0; });
$parcel$export($aa074b70fa1ae362$exports, "PropsProvider", function () { return $2ad42aceae5b632f$export$a8ee2929b334a900; });
$parcel$export($aa074b70fa1ae362$exports, "Root", function () { return $2ad42aceae5b632f$export$ab09149c4c8e7904; });
$parcel$export($aa074b70fa1ae362$exports, "RootProvider", function () { return $2ad42aceae5b632f$export$c4b2d27a90e4eb45; });



"use client";
//#region src/components/checkbox/use-checkbox-context.ts
var [$d40a89ae1caded1f$export$8800744ef809e476, $d40a89ae1caded1f$export$9ab383537f4ea11b] = (0, $51a09ee1e9e91bf5$export$fd42f52fd3ae1109)({
    name: "CheckboxContext",
    hookName: "useCheckboxContext",
    providerName: "<CheckboxProvider />"
});


"use client";
//#region src/components/checkbox/checkbox-context.tsx
var $90e97f5d16bef67a$export$b085522c77523c51 = (props)=>props.children((0, $d40a89ae1caded1f$export$9ab383537f4ea11b)());





var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/checkbox/checkbox-control.tsx
var $7195cac0f0f393c1$export$92481776a9137611 = (0, $8v0nu.forwardRef)((props, ref)=>{
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)((0, $d40a89ae1caded1f$export$9ab383537f4ea11b)().getControlProps(), props);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).div, {
        ...mergedProps,
        ref: ref
    });
});
$7195cac0f0f393c1$export$92481776a9137611.displayName = "CheckboxControl";







var $8v0nu = parcelRequire("8v0nu");
"use client";
//#region src/utils/use-controllable-state.ts
function $a2fa7e0fcb6b696f$export$6f32135080cb4c3(props) {
    const { value: value, onChange: onChange, defaultValue: defaultValue } = props;
    const [uncontrolledValue, setUncontrolledValue] = (0, $8v0nu.useState)(defaultValue);
    const controlled = value !== void 0;
    return [
        controlled ? value : uncontrolledValue,
        (0, $8v0nu.useCallback)((value)=>{
            if (controlled) return onChange?.(value);
            setUncontrolledValue(value);
            return onChange?.(value);
        }, [
            controlled,
            onChange
        ])
    ];
}



"use client";
//#region src/components/checkbox/use-checkbox-group.ts
function $6af98ee550864816$export$49ff6f28c54f1cbe(props = {}) {
    const fieldset = (0, $2a2f69e4c1ad7c1b$export$e46e66a55913b34c)();
    const { defaultValue: defaultValue, value: controlledValue, onValueChange: onValueChange, disabled: disabled = fieldset?.disabled, readOnly: readOnly, name: name, invalid: invalid = fieldset?.invalid, maxSelectedValues: maxSelectedValues } = props;
    const interactive = !(disabled || readOnly);
    const onChangeProp = (0, $f47133aa934004c8$export$90fc3a17d93f704c)(onValueChange, {
        sync: true
    });
    const [value, setValue] = (0, $a2fa7e0fcb6b696f$export$6f32135080cb4c3)({
        value: controlledValue,
        defaultValue: defaultValue || [],
        onChange: onChangeProp
    });
    const isChecked = (val)=>{
        return value.some((v)=>String(v) === String(val));
    };
    const toggleValue = (val)=>{
        isChecked(val) ? removeValue(val) : addValue(val);
    };
    const isAtMax = maxSelectedValues != null && value.length >= maxSelectedValues;
    const addValue = (val)=>{
        if (!interactive) return;
        if (isChecked(val)) return;
        if (isAtMax) return;
        setValue(value.concat(val));
    };
    const removeValue = (val)=>{
        if (!interactive) return;
        setValue(value.filter((v)=>String(v) !== String(val)));
    };
    const getItemProps = (props)=>{
        const checked = props.value != null ? isChecked(props.value) : void 0;
        return {
            checked: checked,
            onCheckedChange () {
                if (props.value != null) toggleValue(props.value);
            },
            name: name,
            disabled: disabled || isAtMax && !checked,
            readOnly: readOnly,
            invalid: invalid
        };
    };
    return {
        isChecked: isChecked,
        value: value,
        name: name,
        disabled: !!disabled,
        readOnly: !!readOnly,
        invalid: !!invalid,
        setValue: setValue,
        addValue: addValue,
        toggleValue: toggleValue,
        getItemProps: getItemProps
    };
}



"use client";
//#region src/components/checkbox/use-checkbox-group-context.tsx
var [$e46fa022e185feda$export$e4e7fe569c243b11, $e46fa022e185feda$export$5575526870d5c2ae] = (0, $51a09ee1e9e91bf5$export$fd42f52fd3ae1109)({
    name: "CheckboxGroupContext",
    hookName: "useCheckboxGroupContext",
    providerName: "<CheckboxGroupProvider />",
    strict: false
});



var $8v0nu = parcelRequire("8v0nu");

"use client";
//#region src/components/checkbox/checkbox-group.tsx
var $7da0eaf499734511$var$splitGroupProps = (0, $41bdb03050f91b76$export$3ea53b214fbc1986)();
var $7da0eaf499734511$export$4aa08d5625cb8ead = (0, $8v0nu.forwardRef)((props, ref)=>{
    const [checkboxGroupProps, localProps] = $7da0eaf499734511$var$splitGroupProps(props, [
        "defaultValue",
        "value",
        "onValueChange",
        "disabled",
        "invalid",
        "readOnly",
        "name",
        "maxSelectedValues"
    ]);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $e46fa022e185feda$export$e4e7fe569c243b11), {
        value: (0, $6af98ee550864816$export$49ff6f28c54f1cbe)(checkboxGroupProps),
        children: /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).div, {
            ref: ref,
            role: "group",
            ...localProps,
            ...(0, $01ef0fa17d719948$export$21946b04497ed6ac).build().group.attrs
        })
    });
});
$7da0eaf499734511$export$4aa08d5625cb8ead.displayName = "CheckboxGroup";







var $8v0nu = parcelRequire("8v0nu");

"use client";
//#region src/components/checkbox/checkbox-group-provider.tsx
var $620ac251302e38de$var$splitProviderProps = (0, $41bdb03050f91b76$export$3ea53b214fbc1986)();
var $620ac251302e38de$export$95a3c27e07a551c3 = (0, $8v0nu.forwardRef)((props, ref)=>{
    const [localProps, restProps] = $620ac251302e38de$var$splitProviderProps(props, [
        "value"
    ]);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $e46fa022e185feda$export$e4e7fe569c243b11), {
        value: localProps.value,
        children: /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).div, {
            ref: ref,
            role: "group",
            ...restProps,
            ...(0, $01ef0fa17d719948$export$21946b04497ed6ac).build().group.attrs
        })
    });
});
$620ac251302e38de$export$95a3c27e07a551c3.displayName = "CheckboxGroupProvider";






var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/checkbox/checkbox-hidden-input.tsx
var $46845ab5c0c53910$export$747d503966d03acf = (0, $8v0nu.forwardRef)((props, ref)=>{
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)((0, $d40a89ae1caded1f$export$9ab383537f4ea11b)().getHiddenInputProps(), props);
    const field = (0, $df31a980f7a28a5b$export$d02e393030f1ec84)();
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).input, {
        "aria-describedby": field?.ariaDescribedby,
        ...mergedProps,
        ref: ref
    });
});
$46845ab5c0c53910$export$747d503966d03acf.displayName = "CheckboxHiddenInput";





var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/checkbox/checkbox-indicator.tsx
var $ef547e727f49c3f3$export$59aad738f51d1c05 = (0, $8v0nu.forwardRef)((props, ref)=>{
    const { indeterminate: indeterminate, ...rest } = props;
    const checkbox = (0, $d40a89ae1caded1f$export$9ab383537f4ea11b)();
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)(checkbox.getIndicatorProps(), rest);
    const isVisible = indeterminate ? checkbox.indeterminate : checkbox.checked;
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).div, {
        ...mergedProps,
        hidden: !isVisible,
        ref: ref
    });
});
$ef547e727f49c3f3$export$59aad738f51d1c05.displayName = "CheckboxIndicator";





var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/checkbox/checkbox-label.tsx
var $a4f1ec2f5eb3e8a6$export$fc9014afe1b6db0 = (0, $8v0nu.forwardRef)((props, ref)=>{
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)((0, $d40a89ae1caded1f$export$9ab383537f4ea11b)().getLabelProps(), props);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).span, {
        ...mergedProps,
        ref: ref
    });
});
$a4f1ec2f5eb3e8a6$export$fc9014afe1b6db0.displayName = "CheckboxLabel";









// src/checkbox.connect.ts



// src/checkbox.dom.ts
var $02d3910d050e3d1c$export$dfdcab00b0f585a9 = (ctx)=>ctx.ids?.root ?? `checkbox:${ctx.id}`;
var $02d3910d050e3d1c$export$3a89b5810eeb6aa5 = (ctx)=>ctx.ids?.label ?? `checkbox:${ctx.id}:label`;
var $02d3910d050e3d1c$export$7f4ba847cbff1e25 = (ctx)=>ctx.ids?.control ?? `checkbox:${ctx.id}:control`;
var $02d3910d050e3d1c$export$664bc9f21b66e8e6 = (ctx)=>ctx.ids?.hiddenInput ?? `checkbox:${ctx.id}:input`;
var $02d3910d050e3d1c$export$5688053fba312fa5 = (ctx)=>ctx.getById($02d3910d050e3d1c$export$dfdcab00b0f585a9(ctx));
var $02d3910d050e3d1c$export$a928616f14cfe4ec = (ctx)=>ctx.getById($02d3910d050e3d1c$export$664bc9f21b66e8e6(ctx));


function $9ba2cb264a488482$export$64605811ab45167f(service, normalize) {
    const { send: send, context: context, prop: prop, computed: computed, scope: scope } = service;
    const disabled = !!prop("disabled");
    const readOnly = !!prop("readOnly");
    const required = !!prop("required");
    const invalid = !!prop("invalid");
    const focused = !disabled && context.get("focused");
    const focusVisible = !disabled && context.get("focusVisible");
    const checked = computed("checked");
    const indeterminate = computed("indeterminate");
    const checkedState = context.get("checked");
    const dataAttrs = {
        "data-active": (0, $dbd9babc41e226bd$export$5cc3b7b83e34ade7)(context.get("active")),
        "data-focus": (0, $dbd9babc41e226bd$export$5cc3b7b83e34ade7)(focused),
        "data-focus-visible": (0, $dbd9babc41e226bd$export$5cc3b7b83e34ade7)(focusVisible),
        "data-readonly": (0, $dbd9babc41e226bd$export$5cc3b7b83e34ade7)(readOnly),
        "data-hover": (0, $dbd9babc41e226bd$export$5cc3b7b83e34ade7)(context.get("hovered")),
        "data-disabled": (0, $dbd9babc41e226bd$export$5cc3b7b83e34ade7)(disabled),
        "data-state": indeterminate ? "indeterminate" : checked ? "checked" : "unchecked",
        "data-invalid": (0, $dbd9babc41e226bd$export$5cc3b7b83e34ade7)(invalid),
        "data-required": (0, $dbd9babc41e226bd$export$5cc3b7b83e34ade7)(required)
    };
    return {
        checked: checked,
        disabled: disabled,
        indeterminate: indeterminate,
        focused: focused,
        checkedState: checkedState,
        setChecked (checked2) {
            send({
                type: "CHECKED.SET",
                checked: checked2,
                isTrusted: false
            });
        },
        toggleChecked () {
            send({
                type: "CHECKED.TOGGLE",
                checked: checked,
                isTrusted: false
            });
        },
        getRootProps () {
            return normalize.label({
                ...(0, $805958d46f3c1d25$export$6e2410c1d27f06e7).root.attrs,
                ...dataAttrs,
                dir: prop("dir"),
                id: $02d3910d050e3d1c$export$dfdcab00b0f585a9(scope),
                htmlFor: $02d3910d050e3d1c$export$664bc9f21b66e8e6(scope),
                onPointerMove () {
                    if (disabled) return;
                    send({
                        type: "CONTEXT.SET",
                        context: {
                            hovered: true
                        }
                    });
                },
                onPointerLeave () {
                    if (disabled) return;
                    send({
                        type: "CONTEXT.SET",
                        context: {
                            hovered: false
                        }
                    });
                },
                onClick (event) {
                    const target = (0, $3921311bf0c8eca9$export$e58f029f0fbfdb29)(event);
                    if (target === $02d3910d050e3d1c$export$a928616f14cfe4ec(scope)) event.stopPropagation();
                }
            });
        },
        getLabelProps () {
            return normalize.element({
                ...(0, $805958d46f3c1d25$export$6e2410c1d27f06e7).label.attrs,
                ...dataAttrs,
                dir: prop("dir"),
                id: $02d3910d050e3d1c$export$3a89b5810eeb6aa5(scope)
            });
        },
        getControlProps () {
            return normalize.element({
                ...(0, $805958d46f3c1d25$export$6e2410c1d27f06e7).control.attrs,
                ...dataAttrs,
                dir: prop("dir"),
                id: $02d3910d050e3d1c$export$7f4ba847cbff1e25(scope),
                "aria-hidden": true
            });
        },
        getIndicatorProps () {
            return normalize.element({
                ...(0, $805958d46f3c1d25$export$6e2410c1d27f06e7).indicator.attrs,
                ...dataAttrs,
                dir: prop("dir"),
                hidden: !indeterminate && !checked
            });
        },
        getHiddenInputProps () {
            return normalize.input({
                id: $02d3910d050e3d1c$export$664bc9f21b66e8e6(scope),
                type: "checkbox",
                required: prop("required"),
                defaultChecked: checked,
                disabled: disabled,
                "aria-labelledby": $02d3910d050e3d1c$export$3a89b5810eeb6aa5(scope),
                "aria-invalid": invalid,
                name: prop("name"),
                form: prop("form"),
                value: prop("value"),
                style: (0, $20b7ad6451938f04$export$8fecac46448b5689),
                onFocus () {
                    const focusVisible2 = (0, $855e001ba27d7a0a$export$b9b3dfddab17db27)();
                    send({
                        type: "CONTEXT.SET",
                        context: {
                            focused: true,
                            focusVisible: focusVisible2
                        }
                    });
                },
                onBlur () {
                    send({
                        type: "CONTEXT.SET",
                        context: {
                            focused: false,
                            focusVisible: false
                        }
                    });
                },
                onClick (event) {
                    if (readOnly) {
                        event.preventDefault();
                        return;
                    }
                    const checked2 = event.currentTarget.checked;
                    send({
                        type: "CHECKED.SET",
                        checked: checked2,
                        isTrusted: true
                    });
                }
            });
        }
    };
}

// src/checkbox.machine.ts





function $b1ac0f73ea4fffa7$export$9a7215eeb3481da(options) {
    const { pointerNode: pointerNode, keyboardNode: keyboardNode = pointerNode, onPress: onPress, onPressStart: onPressStart, onPressEnd: onPressEnd, isValidKey: isValidKey = (e)=>e.key === "Enter" } = options;
    if (!pointerNode) return 0, $dbd9babc41e226bd$export$8793edee2d425525;
    const win = (0, $2020ec4601cca401$export$38b2d434cce3ea22)(pointerNode);
    let removeStartListeners = (0, $dbd9babc41e226bd$export$8793edee2d425525);
    let removeEndListeners = (0, $dbd9babc41e226bd$export$8793edee2d425525);
    let removeAccessibleListeners = (0, $dbd9babc41e226bd$export$8793edee2d425525);
    const getInfo = (event)=>({
            point: (0, $3921311bf0c8eca9$export$a8637644cbd23a7b)(event),
            event: event
        });
    function startPress(event) {
        onPressStart?.(getInfo(event));
    }
    function cancelPress(event) {
        onPressEnd?.(getInfo(event));
    }
    const startPointerPress = (startEvent)=>{
        removeEndListeners();
        const endPointerPress = (endEvent)=>{
            const target = (0, $3921311bf0c8eca9$export$e58f029f0fbfdb29)(endEvent);
            if ((0, $2020ec4601cca401$export$2344b14b097df817)(pointerNode, target)) onPress?.(getInfo(endEvent));
            else onPressEnd?.(getInfo(endEvent));
        };
        const removePointerUpListener = (0, $3921311bf0c8eca9$export$b1d829ddf82884aa)(win, "pointerup", endPointerPress, {
            passive: !onPress,
            once: true
        });
        const removePointerCancelListener = (0, $3921311bf0c8eca9$export$b1d829ddf82884aa)(win, "pointercancel", cancelPress, {
            passive: !onPressEnd,
            once: true
        });
        removeEndListeners = (0, $dbd9babc41e226bd$export$a4627e546088548d)(removePointerUpListener, removePointerCancelListener);
        if ((0, $2020ec4601cca401$export$8a2eb51c14bb8899)(keyboardNode) && startEvent.pointerType === "mouse") startEvent.preventDefault();
        startPress(startEvent);
    };
    const removePointerListener = (0, $3921311bf0c8eca9$export$b1d829ddf82884aa)(pointerNode, "pointerdown", startPointerPress, {
        passive: !onPressStart
    });
    const removeFocusListener = (0, $3921311bf0c8eca9$export$b1d829ddf82884aa)(keyboardNode, "focus", startAccessiblePress);
    removeStartListeners = (0, $dbd9babc41e226bd$export$a4627e546088548d)(removePointerListener, removeFocusListener);
    function startAccessiblePress() {
        const handleKeydown = (keydownEvent)=>{
            if (!isValidKey(keydownEvent)) return;
            const handleKeyup = (keyupEvent)=>{
                if (!isValidKey(keyupEvent)) return;
                const evt2 = new win.PointerEvent("pointerup");
                const info = getInfo(evt2);
                onPress?.(info);
                onPressEnd?.(info);
            };
            removeEndListeners();
            removeEndListeners = (0, $3921311bf0c8eca9$export$b1d829ddf82884aa)(keyboardNode, "keyup", handleKeyup);
            const evt = new win.PointerEvent("pointerdown");
            startPress(evt);
        };
        const handleBlur = ()=>{
            const evt = new win.PointerEvent("pointercancel");
            cancelPress(evt);
        };
        const removeKeydownListener = (0, $3921311bf0c8eca9$export$b1d829ddf82884aa)(keyboardNode, "keydown", handleKeydown);
        const removeBlurListener = (0, $3921311bf0c8eca9$export$b1d829ddf82884aa)(keyboardNode, "blur", handleBlur);
        removeAccessibleListeners = (0, $dbd9babc41e226bd$export$a4627e546088548d)(removeKeydownListener, removeBlurListener);
    }
    return ()=>{
        removeStartListeners();
        removeEndListeners();
        removeAccessibleListeners();
    };
}




var { not: $4521e79efd1fcd12$var$not } = (0, $9aa7f39f9520657f$export$285462e61607a24f)();
var $4521e79efd1fcd12$export$ea56d40cd27c3480 = (0, $9aa7f39f9520657f$export$aaa7fa18f8e9b2e8)({
    props ({ props: props }) {
        return {
            value: "on",
            ...props,
            defaultChecked: props.defaultChecked ?? false
        };
    },
    initialState () {
        return "ready";
    },
    context ({ prop: prop, bindable: bindable }) {
        return {
            checked: bindable(()=>({
                    defaultValue: prop("defaultChecked"),
                    value: prop("checked"),
                    onChange (checked) {
                        prop("onCheckedChange")?.({
                            checked: checked
                        });
                    }
                })),
            fieldsetDisabled: bindable(()=>({
                    defaultValue: false
                })),
            focusVisible: bindable(()=>({
                    defaultValue: false
                })),
            active: bindable(()=>({
                    defaultValue: false
                })),
            focused: bindable(()=>({
                    defaultValue: false
                })),
            hovered: bindable(()=>({
                    defaultValue: false
                }))
        };
    },
    watch ({ track: track, context: context, prop: prop, action: action }) {
        track([
            ()=>prop("disabled")
        ], ()=>{
            action([
                "removeFocusIfNeeded"
            ]);
        });
        track([
            ()=>context.get("checked")
        ], ()=>{
            action([
                "syncInputElement"
            ]);
        });
    },
    effects: [
        "trackFormControlState",
        "trackPressEvent",
        "trackFocusVisible"
    ],
    on: {
        "CHECKED.TOGGLE": [
            {
                guard: $4521e79efd1fcd12$var$not("isTrusted"),
                actions: [
                    "toggleChecked",
                    "dispatchChangeEvent"
                ]
            },
            {
                actions: [
                    "toggleChecked"
                ]
            }
        ],
        "CHECKED.SET": [
            {
                guard: $4521e79efd1fcd12$var$not("isTrusted"),
                actions: [
                    "setChecked",
                    "dispatchChangeEvent"
                ]
            },
            {
                actions: [
                    "setChecked"
                ]
            }
        ],
        "CONTEXT.SET": {
            actions: [
                "setContext"
            ]
        }
    },
    computed: {
        indeterminate: ({ context: context })=>$4521e79efd1fcd12$var$isIndeterminate(context.get("checked")),
        checked: ({ context: context })=>$4521e79efd1fcd12$var$isChecked(context.get("checked")),
        disabled: ({ context: context, prop: prop })=>!!prop("disabled") || context.get("fieldsetDisabled")
    },
    states: {
        ready: {}
    },
    implementations: {
        guards: {
            isTrusted: ({ event: event })=>!!event.isTrusted
        },
        effects: {
            trackPressEvent ({ context: context, computed: computed, scope: scope }) {
                if (computed("disabled")) return;
                return (0, $b1ac0f73ea4fffa7$export$9a7215eeb3481da)({
                    pointerNode: $02d3910d050e3d1c$export$5688053fba312fa5(scope),
                    keyboardNode: $02d3910d050e3d1c$export$a928616f14cfe4ec(scope),
                    isValidKey: (event)=>event.key === " ",
                    onPress: ()=>context.set("active", false),
                    onPressStart: ()=>context.set("active", true),
                    onPressEnd: ()=>context.set("active", false)
                });
            },
            trackFocusVisible ({ computed: computed, scope: scope }) {
                if (computed("disabled")) return;
                return (0, $855e001ba27d7a0a$export$920b4983565c6f4d)({
                    root: scope.getRootNode?.()
                });
            },
            trackFormControlState ({ context: context, scope: scope }) {
                return (0, $80b3e775b628bedc$export$a48469c7b6beba26)($02d3910d050e3d1c$export$a928616f14cfe4ec(scope), {
                    onFieldsetDisabledChange (disabled) {
                        context.set("fieldsetDisabled", disabled);
                    },
                    onFormReset () {
                        context.set("checked", context.initial("checked"));
                    }
                });
            }
        },
        actions: {
            setContext ({ context: context, event: event }) {
                for(const key in event.context)context.set(key, event.context[key]);
            },
            syncInputElement ({ context: context, computed: computed, scope: scope }) {
                const inputEl = $02d3910d050e3d1c$export$a928616f14cfe4ec(scope);
                if (!inputEl) return;
                (0, $80b3e775b628bedc$export$1b2cb9f366b7b263)(inputEl, computed("checked"));
                inputEl.indeterminate = $4521e79efd1fcd12$var$isIndeterminate(context.get("checked"));
            },
            removeFocusIfNeeded ({ context: context, prop: prop }) {
                if (prop("disabled") && context.get("focused")) {
                    context.set("focused", false);
                    context.set("focusVisible", false);
                }
            },
            setChecked ({ context: context, event: event }) {
                context.set("checked", event.checked);
            },
            toggleChecked ({ context: context, computed: computed }) {
                const checked = $4521e79efd1fcd12$var$isIndeterminate(computed("checked")) ? true : !computed("checked");
                context.set("checked", checked);
            },
            dispatchChangeEvent ({ computed: computed, scope: scope }) {
                queueMicrotask(()=>{
                    const inputEl = $02d3910d050e3d1c$export$a928616f14cfe4ec(scope);
                    (0, $80b3e775b628bedc$export$ebab7723673c874f)(inputEl, {
                        checked: computed("checked")
                    });
                });
            }
        }
    }
});
function $4521e79efd1fcd12$var$isIndeterminate(checked) {
    return checked === "indeterminate";
}
function $4521e79efd1fcd12$var$isChecked(checked) {
    return $4521e79efd1fcd12$var$isIndeterminate(checked) ? false : !!checked;
}



var $8v0nu = parcelRequire("8v0nu");

"use client";
//#region src/components/checkbox/use-checkbox.ts
var $e5841df02f6c616d$export$e375f10ce42261c5 = (ownProps = {})=>{
    const checkboxGroup = (0, $e46fa022e185feda$export$5575526870d5c2ae)();
    const field = (0, $df31a980f7a28a5b$export$d02e393030f1ec84)();
    const props = (0, $8v0nu.useMemo)(()=>{
        return (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)(checkboxGroup?.getItemProps({
            value: ownProps.value
        }) ?? {}, ownProps);
    }, [
        ownProps,
        checkboxGroup
    ]);
    const id = (0, $8v0nu.useId)();
    const { getRootNode: getRootNode } = (0, $cfa7a900a06000ef$export$899b1e582a0b3c80)();
    const { dir: dir } = (0, $af19f2672b388a39$export$2a7b1d9f665d6730)();
    const machineProps = {
        id: id,
        ids: {
            label: field?.ids.label,
            hiddenInput: field?.ids.control
        },
        dir: dir,
        disabled: field?.disabled,
        readOnly: field?.readOnly,
        invalid: field?.invalid,
        required: field?.required,
        getRootNode: getRootNode,
        ...props
    };
    const service = (0, $54265883fb157840$export$e0338c4153421160)($4521e79efd1fcd12$export$ea56d40cd27c3480, machineProps);
    return $9ba2cb264a488482$export$64605811ab45167f(service, (0, $06b0a2ce147a2fe4$export$601abcd8103db5e4));
};



var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/checkbox/checkbox-root.tsx
var $75cdf56ea38fb9f7$var$splitRootProps = (0, $41bdb03050f91b76$export$3ea53b214fbc1986)();
var $75cdf56ea38fb9f7$export$ab09149c4c8e7904 = (0, $8v0nu.forwardRef)((props, ref)=>{
    const [useCheckboxProps, localProps] = $75cdf56ea38fb9f7$var$splitRootProps(props, [
        "checked",
        "defaultChecked",
        "disabled",
        "form",
        "id",
        "ids",
        "invalid",
        "name",
        "onCheckedChange",
        "readOnly",
        "required",
        "value"
    ]);
    const checkbox = (0, $e5841df02f6c616d$export$e375f10ce42261c5)(useCheckboxProps);
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)(checkbox.getRootProps(), localProps);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $d40a89ae1caded1f$export$8800744ef809e476), {
        value: checkbox,
        children: /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).label, {
            ...mergedProps,
            ref: ref
        })
    });
});
$75cdf56ea38fb9f7$export$ab09149c4c8e7904.displayName = "CheckboxRoot";






var $8v0nu = parcelRequire("8v0nu");


"use client";
//#region src/components/checkbox/checkbox-root-provider.tsx
var $37fd20264dd5267b$var$splitRootProviderProps = (0, $41bdb03050f91b76$export$3ea53b214fbc1986)();
var $37fd20264dd5267b$export$c4b2d27a90e4eb45 = (0, $8v0nu.forwardRef)((props, ref)=>{
    const [{ value: checkbox }, localProps] = $37fd20264dd5267b$var$splitRootProviderProps(props, [
        "value"
    ]);
    const mergedProps = (0, $ea59bff5c9936d72$export$9d1611c77c2fe928)(checkbox.getRootProps(), localProps);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $d40a89ae1caded1f$export$8800744ef809e476), {
        value: checkbox,
        children: /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $cc83854fb8cf60d1$export$d4dd0c6fc02249a9).label, {
            ...mergedProps,
            ref: ref
        })
    });
});
$37fd20264dd5267b$export$c4b2d27a90e4eb45.displayName = "CheckboxRootProvider";


//#region src/components/checkbox/checkbox.ts
var $8bbf6902112ad41e$export$89c35951e80213b8 = /* @__PURE__ */ (0, $57db88e2bf337fea$export$8126e515a7516e2)({
    Context: ()=>(0, $90e97f5d16bef67a$export$b085522c77523c51),
    Control: ()=>(0, $7195cac0f0f393c1$export$92481776a9137611),
    Group: ()=>(0, $7da0eaf499734511$export$4aa08d5625cb8ead),
    GroupProvider: ()=>(0, $620ac251302e38de$export$95a3c27e07a551c3),
    HiddenInput: ()=>(0, $46845ab5c0c53910$export$747d503966d03acf),
    Indicator: ()=>(0, $ef547e727f49c3f3$export$59aad738f51d1c05),
    Label: ()=>(0, $a4f1ec2f5eb3e8a6$export$fc9014afe1b6db0),
    Root: ()=>(0, $75cdf56ea38fb9f7$export$ab09149c4c8e7904),
    RootProvider: ()=>(0, $37fd20264dd5267b$export$c4b2d27a90e4eb45)
});



var $8v0nu = parcelRequire("8v0nu");




var $8v0nu = parcelRequire("8v0nu");




"use strict";
"use client";
const $fe7ac00d596374d5$export$4f481e0a96cfbed6 = (0, $8v0nu.forwardRef)(function Checkmark2(props, ref) {
    const recipe = (0, $971213434541a23d$export$cf0e09a7086104ff)({
        key: "checkmark",
        recipe: props.recipe
    });
    const [variantProps, restProps] = recipe.splitVariantProps(props);
    const { checked: checked, indeterminate: indeterminate, disabled: disabled, unstyled: unstyled, children: children, ...rest } = restProps;
    const styles = unstyled ? (0, $0fb716203df70dd7$export$e37f626c01cb373a) : recipe(variantProps);
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $4042601bfa1a9d25$export$7cd122d781af9fa4).svg, {
        ref: ref,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "3px",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        "data-state": indeterminate ? "indeterminate" : checked ? "checked" : "unchecked",
        "data-disabled": (0, $f85b338274abd06b$export$5cc3b7b83e34ade7)(disabled),
        css: [
            styles,
            props.css
        ],
        ...rest,
        children: indeterminate ? /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)("path", {
            d: "M5 12h14"
        }) : checked ? /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)("polyline", {
            points: "20 6 9 17 4 12"
        }) : null
    });
});
$fe7ac00d596374d5$export$4f481e0a96cfbed6.displayName = "Checkmark";


"use strict";
"use client";
const { withProvider: $2ad42aceae5b632f$var$withProvider, withContext: $2ad42aceae5b632f$var$withContext, useStyles: $2ad42aceae5b632f$export$6014d9361d9044e1, PropsProvider: $2ad42aceae5b632f$var$PropsProvider } = (0, $04636a451c2392c0$export$ac7f79c9443925b8)({
    key: "checkbox"
});
const $2ad42aceae5b632f$export$c4b2d27a90e4eb45 = $2ad42aceae5b632f$var$withProvider((0, $8bbf6902112ad41e$export$89c35951e80213b8).RootProvider, "root", {
    forwardAsChild: true
});
const $2ad42aceae5b632f$export$ab09149c4c8e7904 = $2ad42aceae5b632f$var$withProvider((0, $8bbf6902112ad41e$export$89c35951e80213b8).Root, "root", {
    forwardAsChild: true
});
const $2ad42aceae5b632f$export$a8ee2929b334a900 = $2ad42aceae5b632f$var$PropsProvider;
const $2ad42aceae5b632f$export$fc9014afe1b6db0 = $2ad42aceae5b632f$var$withContext((0, $8bbf6902112ad41e$export$89c35951e80213b8).Label, "label", {
    forwardAsChild: true
});
const $2ad42aceae5b632f$export$59aad738f51d1c05 = (0, $8v0nu.forwardRef)(function CheckboxIndicator2(props, ref) {
    const { checked: checked, indeterminate: indeterminate, ...rest } = props;
    const api = (0, $d40a89ae1caded1f$export$9ab383537f4ea11b)();
    const styles = $2ad42aceae5b632f$export$6014d9361d9044e1();
    if (checked && api.checked) return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $4042601bfa1a9d25$export$7cd122d781af9fa4).svg, {
        ref: ref,
        asChild: true,
        ...rest,
        css: [
            styles.indicator,
            props.css
        ],
        children: checked
    });
    if (indeterminate && api.indeterminate) return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $4042601bfa1a9d25$export$7cd122d781af9fa4).svg, {
        ref: ref,
        asChild: true,
        ...rest,
        css: [
            styles.indicator,
            props.css
        ],
        children: indeterminate
    });
    return /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)((0, $fe7ac00d596374d5$export$4f481e0a96cfbed6), {
        ref: ref,
        checked: api.checked,
        indeterminate: api.indeterminate,
        disabled: api.disabled,
        unstyled: true,
        ...rest,
        css: [
            styles.indicator,
            props.css
        ]
    });
});
const $2ad42aceae5b632f$export$92481776a9137611 = $2ad42aceae5b632f$var$withContext((0, $8bbf6902112ad41e$export$89c35951e80213b8).Control, "control", {
    forwardAsChild: true,
    defaultProps: {
        children: /* @__PURE__ */ (0, $ef524fb144c5d632$exports.jsx)($2ad42aceae5b632f$export$59aad738f51d1c05, {})
    }
});
const $2ad42aceae5b632f$export$4aa08d5625cb8ead = (0, $4042601bfa1a9d25$export$7cd122d781af9fa4)((0, $8bbf6902112ad41e$export$89c35951e80213b8).Group, {
    base: {
        display: "flex",
        flexDirection: "column",
        gap: "1.5"
    }
}, {
    forwardAsChild: true
});
const $2ad42aceae5b632f$export$b085522c77523c51 = (0, $8bbf6902112ad41e$export$89c35951e80213b8).Context;
const $2ad42aceae5b632f$export$747d503966d03acf = (0, $8bbf6902112ad41e$export$89c35951e80213b8).HiddenInput;


"use strict";



var $jTKGQ = parcelRequire("jTKGQ");

function $6369dd324fce8d1d$export$7125ae6e0d206208(props) {
    const { pointer: pointer, isRequired: isRequired } = props;
    const field = props.field;
    const options = field.items.enum;
    if (field.items.allowOther) throw new Error("WidgetCheckbox: allowOther is not supported. Use widget 'tagger' instead");
    if (!options?.length) throw new Error('WidgetCheckbox: items.enum is required');
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $jTKGQ.FastField), {
        name: pointer,
        children: ({ field: { value: value }, meta: meta, form: { setFieldValue: setFieldValue, setFieldTouched: setFieldTouched } })=>// Fieldset (not Field.Root) on purpose: Ark checkboxes consume the
            // surrounding Field context, so a group under one Field.Root would
            // share the Field's ids (duplicate DOM ids, every label toggling the
            // first input) and inherit its `required` onto every hidden input.
            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $007be631de130dc2$exports).Root, {
                invalid: !!(meta.touched && meta.error),
                children: [
                    field.label && /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $007be631de130dc2$exports).Legend, {
                        children: [
                            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $8f2967926209c75b$export$1acdcf5a973a8414), {
                                size: "xs",
                                children: field.label
                            }),
                            isRequired && /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $f80be8aeb6fc9430$export$5f1714a13ed34c01), {
                                color: "fg.error",
                                lineHeight: "1",
                                ms: "1",
                                "aria-hidden": "true",
                                children: "*"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
                        gap: 4,
                        children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $2ad42aceae5b632f$export$4aa08d5625cb8ead), {
                            // Formik leaves an untouched field undefined; coerce to [] so the
                            // group mounts controlled and doesn't warn/flip on first change.
                            value: value ?? [],
                            onValueChange: (v)=>{
                                setFieldValue(pointer, v);
                                setFieldTouched(pointer, true);
                            },
                            children: options.map(([checkboxVal, label])=>/*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $aa074b70fa1ae362$exports).Root, {
                                    size: "sm",
                                    value: checkboxVal,
                                    children: [
                                        /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $aa074b70fa1ae362$exports).HiddenInput, {}),
                                        /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $aa074b70fa1ae362$exports).Control, {}),
                                        /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $aa074b70fa1ae362$exports).Label, {
                                            children: label
                                        })
                                    ]
                                }, checkboxVal))
                        })
                    }),
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $007be631de130dc2$exports).ErrorText, {
                        children: meta.error
                    })
                ]
            })
    });
}



parcelRequire("8v0nu");


var $jTKGQ = parcelRequire("jTKGQ");



var $eA9yl = parcelRequire("eA9yl");

var $eA9yl = parcelRequire("eA9yl");

var $fdbzE = parcelRequire("fdbzE");
/** Used to match property names within property paths. */ var $052e06a52ad6a01d$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $052e06a52ad6a01d$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $052e06a52ad6a01d$var$isKey(value, object) {
    if ((0, $eA9yl.default)(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || (0, $fdbzE.default)(value)) return true;
    return $052e06a52ad6a01d$var$reIsPlainProp.test(value) || !$052e06a52ad6a01d$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
var $052e06a52ad6a01d$export$2e2bcd8739ae039 = $052e06a52ad6a01d$var$isKey;



var $2nPhd = parcelRequire("2nPhd");

var $hghOo = parcelRequire("hghOo");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $9bf1bc98bfb8909a$var$castPath(value, object) {
    if ((0, $eA9yl.default)(value)) return value;
    return (0, $052e06a52ad6a01d$export$2e2bcd8739ae039)(value, object) ? [
        value
    ] : (0, $2nPhd.default)((0, $hghOo.default)(value));
}
var $9bf1bc98bfb8909a$export$2e2bcd8739ae039 = $9bf1bc98bfb8909a$var$castPath;



var $e9clf = parcelRequire("e9clf");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $ec9ff061c841039c$var$baseGet(object, path) {
    path = (0, $9bf1bc98bfb8909a$export$2e2bcd8739ae039)(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[(0, $e9clf.default)(path[index++])];
    return index && index == length ? object : undefined;
}
var $ec9ff061c841039c$export$2e2bcd8739ae039 = $ec9ff061c841039c$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $de005c3c82706228$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : (0, $ec9ff061c841039c$export$2e2bcd8739ae039)(object, path);
    return result === undefined ? defaultValue : result;
}
var $de005c3c82706228$export$2e2bcd8739ae039 = $de005c3c82706228$var$get;




var $8v0nu = parcelRequire("8v0nu");





var $jTKGQ = parcelRequire("jTKGQ");

var $jGWdr = parcelRequire("jGWdr");
var $8Xlz0 = parcelRequire("8Xlz0");


var $31LnV = parcelRequire("31LnV");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $7c466d0ea92d97f8$var$baseForOwn(object, iteratee) {
    return object && (0, $c2253e8a3eee9abf$export$2e2bcd8739ae039)(object, iteratee, (0, $31LnV.default));
}
var $7c466d0ea92d97f8$export$2e2bcd8739ae039 = $7c466d0ea92d97f8$var$baseForOwn;



var $5dLfO = parcelRequire("5dLfO");

var $5dLfO = parcelRequire("5dLfO");

var $5Sw7u = parcelRequire("5Sw7u");
/** Used to stand-in for `undefined` hash values. */ var $72e5ab95c7257c18$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $72e5ab95c7257c18$var$setCacheAdd(value) {
    this.__data__.set(value, $72e5ab95c7257c18$var$HASH_UNDEFINED);
    return this;
}
var $72e5ab95c7257c18$export$2e2bcd8739ae039 = $72e5ab95c7257c18$var$setCacheAdd;


/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 */ function $b6b113104971d0a8$var$setCacheHas(value) {
    return this.__data__.has(value);
}
var $b6b113104971d0a8$export$2e2bcd8739ae039 = $b6b113104971d0a8$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $c131592e54ba9b88$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new (0, $5Sw7u.default);
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$c131592e54ba9b88$var$SetCache.prototype.add = $c131592e54ba9b88$var$SetCache.prototype.push = (0, $72e5ab95c7257c18$export$2e2bcd8739ae039);
$c131592e54ba9b88$var$SetCache.prototype.has = (0, $b6b113104971d0a8$export$2e2bcd8739ae039);
var $c131592e54ba9b88$export$2e2bcd8739ae039 = $c131592e54ba9b88$var$SetCache;


/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $884b246c373683d7$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
var $884b246c373683d7$export$2e2bcd8739ae039 = $884b246c373683d7$var$arraySome;


/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e583086f10c4851b$var$cacheHas(cache, key) {
    return cache.has(key);
}
var $e583086f10c4851b$export$2e2bcd8739ae039 = $e583086f10c4851b$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $78cd4d6f13b9771e$var$COMPARE_PARTIAL_FLAG = 1, $78cd4d6f13b9771e$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $78cd4d6f13b9771e$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $78cd4d6f13b9771e$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $78cd4d6f13b9771e$var$COMPARE_UNORDERED_FLAG ? new (0, $c131592e54ba9b88$export$2e2bcd8739ae039) : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!(0, $884b246c373683d7$export$2e2bcd8739ae039)(other, function(othValue, othIndex) {
                if (!(0, $e583086f10c4851b$export$2e2bcd8739ae039)(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
var $78cd4d6f13b9771e$export$2e2bcd8739ae039 = $78cd4d6f13b9771e$var$equalArrays;



var $hwtsf = parcelRequire("hwtsf");

var $hNU6C = parcelRequire("hNU6C");

var $5TPq9 = parcelRequire("5TPq9");

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $0a44bb80313e2977$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
var $0a44bb80313e2977$export$2e2bcd8739ae039 = $0a44bb80313e2977$var$mapToArray;


/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $35f29b582870dbac$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
var $35f29b582870dbac$export$2e2bcd8739ae039 = $35f29b582870dbac$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $64cd6d0f849c3e76$var$COMPARE_PARTIAL_FLAG = 1, $64cd6d0f849c3e76$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $64cd6d0f849c3e76$var$boolTag = '[object Boolean]', $64cd6d0f849c3e76$var$dateTag = '[object Date]', $64cd6d0f849c3e76$var$errorTag = '[object Error]', $64cd6d0f849c3e76$var$mapTag = '[object Map]', $64cd6d0f849c3e76$var$numberTag = '[object Number]', $64cd6d0f849c3e76$var$regexpTag = '[object RegExp]', $64cd6d0f849c3e76$var$setTag = '[object Set]', $64cd6d0f849c3e76$var$stringTag = '[object String]', $64cd6d0f849c3e76$var$symbolTag = '[object Symbol]';
var $64cd6d0f849c3e76$var$arrayBufferTag = '[object ArrayBuffer]', $64cd6d0f849c3e76$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $64cd6d0f849c3e76$var$symbolProto = (0, $hwtsf.default) ? (0, $hwtsf.default).prototype : undefined, $64cd6d0f849c3e76$var$symbolValueOf = $64cd6d0f849c3e76$var$symbolProto ? $64cd6d0f849c3e76$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $64cd6d0f849c3e76$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $64cd6d0f849c3e76$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $64cd6d0f849c3e76$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new (0, $hNU6C.default)(object), new (0, $hNU6C.default)(other))) return false;
            return true;
        case $64cd6d0f849c3e76$var$boolTag:
        case $64cd6d0f849c3e76$var$dateTag:
        case $64cd6d0f849c3e76$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return (0, $5TPq9.default)(+object, +other);
        case $64cd6d0f849c3e76$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $64cd6d0f849c3e76$var$regexpTag:
        case $64cd6d0f849c3e76$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $64cd6d0f849c3e76$var$mapTag:
            var convert = (0, $0a44bb80313e2977$export$2e2bcd8739ae039);
        case $64cd6d0f849c3e76$var$setTag:
            var isPartial = bitmask & $64cd6d0f849c3e76$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = (0, $35f29b582870dbac$export$2e2bcd8739ae039));
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $64cd6d0f849c3e76$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = (0, $78cd4d6f13b9771e$export$2e2bcd8739ae039)(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $64cd6d0f849c3e76$var$symbolTag:
            if ($64cd6d0f849c3e76$var$symbolValueOf) return $64cd6d0f849c3e76$var$symbolValueOf.call(object) == $64cd6d0f849c3e76$var$symbolValueOf.call(other);
    }
    return false;
}
var $64cd6d0f849c3e76$export$2e2bcd8739ae039 = $64cd6d0f849c3e76$var$equalByTag;



var $eNbR6 = parcelRequire("eNbR6");
/** Used to compose bitmasks for value comparisons. */ var $ebc0361046d549c9$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $ebc0361046d549c9$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ebc0361046d549c9$var$hasOwnProperty = $ebc0361046d549c9$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $ebc0361046d549c9$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $ebc0361046d549c9$var$COMPARE_PARTIAL_FLAG, objProps = (0, $eNbR6.default)(object), objLength = objProps.length, othProps = (0, $eNbR6.default)(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $ebc0361046d549c9$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
var $ebc0361046d549c9$export$2e2bcd8739ae039 = $ebc0361046d549c9$var$equalObjects;



var $6JaTE = parcelRequire("6JaTE");

var $eA9yl = parcelRequire("eA9yl");

var $43Y3b = parcelRequire("43Y3b");

var $dK8Wz = parcelRequire("dK8Wz");
/** Used to compose bitmasks for value comparisons. */ var $5a2a119a9a30679a$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $5a2a119a9a30679a$var$argsTag = '[object Arguments]', $5a2a119a9a30679a$var$arrayTag = '[object Array]', $5a2a119a9a30679a$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $5a2a119a9a30679a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $5a2a119a9a30679a$var$hasOwnProperty = $5a2a119a9a30679a$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $5a2a119a9a30679a$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = (0, $eA9yl.default)(object), othIsArr = (0, $eA9yl.default)(other), objTag = objIsArr ? $5a2a119a9a30679a$var$arrayTag : (0, $6JaTE.default)(object), othTag = othIsArr ? $5a2a119a9a30679a$var$arrayTag : (0, $6JaTE.default)(other);
    objTag = objTag == $5a2a119a9a30679a$var$argsTag ? $5a2a119a9a30679a$var$objectTag : objTag;
    othTag = othTag == $5a2a119a9a30679a$var$argsTag ? $5a2a119a9a30679a$var$objectTag : othTag;
    var objIsObj = objTag == $5a2a119a9a30679a$var$objectTag, othIsObj = othTag == $5a2a119a9a30679a$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && (0, $43Y3b.default)(object)) {
        if (!(0, $43Y3b.default)(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new (0, $5dLfO.default));
        return objIsArr || (0, $dK8Wz.default)(object) ? (0, $78cd4d6f13b9771e$export$2e2bcd8739ae039)(object, other, bitmask, customizer, equalFunc, stack) : (0, $64cd6d0f849c3e76$export$2e2bcd8739ae039)(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $5a2a119a9a30679a$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $5a2a119a9a30679a$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $5a2a119a9a30679a$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new (0, $5dLfO.default));
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new (0, $5dLfO.default));
    return (0, $ebc0361046d549c9$export$2e2bcd8739ae039)(object, other, bitmask, customizer, equalFunc, stack);
}
var $5a2a119a9a30679a$export$2e2bcd8739ae039 = $5a2a119a9a30679a$var$baseIsEqualDeep;



var $9XysK = parcelRequire("9XysK");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $8cdf62866f460374$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !(0, $9XysK.default)(value) && !(0, $9XysK.default)(other)) return value !== value && other !== other;
    return (0, $5a2a119a9a30679a$export$2e2bcd8739ae039)(value, other, bitmask, customizer, $8cdf62866f460374$var$baseIsEqual, stack);
}
var $8cdf62866f460374$export$2e2bcd8739ae039 = $8cdf62866f460374$var$baseIsEqual;


/** Used to compose bitmasks for value comparisons. */ var $3883254551e1c45c$var$COMPARE_PARTIAL_FLAG = 1, $3883254551e1c45c$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $3883254551e1c45c$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new (0, $5dLfO.default);
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? (0, $8cdf62866f460374$export$2e2bcd8739ae039)(srcValue, objValue, $3883254551e1c45c$var$COMPARE_PARTIAL_FLAG | $3883254551e1c45c$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
var $3883254551e1c45c$export$2e2bcd8739ae039 = $3883254551e1c45c$var$baseIsMatch;



var $55CT4 = parcelRequire("55CT4");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $93045016c4f0fe00$var$isStrictComparable(value) {
    return value === value && !(0, $55CT4.default)(value);
}
var $93045016c4f0fe00$export$2e2bcd8739ae039 = $93045016c4f0fe00$var$isStrictComparable;



var $31LnV = parcelRequire("31LnV");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $a261f4d6329851d0$var$getMatchData(object) {
    var result = (0, $31LnV.default)(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            (0, $93045016c4f0fe00$export$2e2bcd8739ae039)(value)
        ];
    }
    return result;
}
var $a261f4d6329851d0$export$2e2bcd8739ae039 = $a261f4d6329851d0$var$getMatchData;


/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $b24731c0968b40bc$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
var $b24731c0968b40bc$export$2e2bcd8739ae039 = $b24731c0968b40bc$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $0a2d5f2939faa887$var$baseMatches(source) {
    var matchData = (0, $a261f4d6329851d0$export$2e2bcd8739ae039)(source);
    if (matchData.length == 1 && matchData[0][2]) return (0, $b24731c0968b40bc$export$2e2bcd8739ae039)(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || (0, $3883254551e1c45c$export$2e2bcd8739ae039)(object, source, matchData);
    };
}
var $0a2d5f2939faa887$export$2e2bcd8739ae039 = $0a2d5f2939faa887$var$baseMatches;




/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $22a992897f809c7e$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
var $22a992897f809c7e$export$2e2bcd8739ae039 = $22a992897f809c7e$var$baseHasIn;




var $774DM = parcelRequire("774DM");

var $eA9yl = parcelRequire("eA9yl");

var $7Jqv7 = parcelRequire("7Jqv7");

var $XPYOH = parcelRequire("XPYOH");

var $e9clf = parcelRequire("e9clf");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $c9d7e073f88ea34c$var$hasPath(object, path, hasFunc) {
    path = (0, $9bf1bc98bfb8909a$export$2e2bcd8739ae039)(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = (0, $e9clf.default)(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && (0, $XPYOH.default)(length) && (0, $7Jqv7.default)(key, length) && ((0, $eA9yl.default)(object) || (0, $774DM.default)(object));
}
var $c9d7e073f88ea34c$export$2e2bcd8739ae039 = $c9d7e073f88ea34c$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $f537a0e45d3ec359$var$hasIn(object, path) {
    return object != null && (0, $c9d7e073f88ea34c$export$2e2bcd8739ae039)(object, path, (0, $22a992897f809c7e$export$2e2bcd8739ae039));
}
var $f537a0e45d3ec359$export$2e2bcd8739ae039 = $f537a0e45d3ec359$var$hasIn;






var $e9clf = parcelRequire("e9clf");
/** Used to compose bitmasks for value comparisons. */ var $07a91392a8336763$var$COMPARE_PARTIAL_FLAG = 1, $07a91392a8336763$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $07a91392a8336763$var$baseMatchesProperty(path, srcValue) {
    if ((0, $052e06a52ad6a01d$export$2e2bcd8739ae039)(path) && (0, $93045016c4f0fe00$export$2e2bcd8739ae039)(srcValue)) return (0, $b24731c0968b40bc$export$2e2bcd8739ae039)((0, $e9clf.default)(path), srcValue);
    return function(object) {
        var objValue = (0, $de005c3c82706228$export$2e2bcd8739ae039)(object, path);
        return objValue === undefined && objValue === srcValue ? (0, $f537a0e45d3ec359$export$2e2bcd8739ae039)(object, path) : (0, $8cdf62866f460374$export$2e2bcd8739ae039)(srcValue, objValue, $07a91392a8336763$var$COMPARE_PARTIAL_FLAG | $07a91392a8336763$var$COMPARE_UNORDERED_FLAG);
    };
}
var $07a91392a8336763$export$2e2bcd8739ae039 = $07a91392a8336763$var$baseMatchesProperty;




var $eA9yl = parcelRequire("eA9yl");
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $4a424799a0d7eb91$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
var $4a424799a0d7eb91$export$2e2bcd8739ae039 = $4a424799a0d7eb91$var$baseProperty;



/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $b8acccd980ba5911$var$basePropertyDeep(path) {
    return function(object) {
        return (0, $ec9ff061c841039c$export$2e2bcd8739ae039)(object, path);
    };
}
var $b8acccd980ba5911$export$2e2bcd8739ae039 = $b8acccd980ba5911$var$basePropertyDeep;




var $e9clf = parcelRequire("e9clf");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $47d7b0945c901d16$var$property(path) {
    return (0, $052e06a52ad6a01d$export$2e2bcd8739ae039)(path) ? (0, $4a424799a0d7eb91$export$2e2bcd8739ae039)((0, $e9clf.default)(path)) : (0, $b8acccd980ba5911$export$2e2bcd8739ae039)(path);
}
var $47d7b0945c901d16$export$2e2bcd8739ae039 = $47d7b0945c901d16$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $c522323f288f6e96$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return 0, $019f7528cf907441$export$2e2bcd8739ae039;
    if (typeof value == 'object') return (0, $eA9yl.default)(value) ? (0, $07a91392a8336763$export$2e2bcd8739ae039)(value[0], value[1]) : (0, $0a2d5f2939faa887$export$2e2bcd8739ae039)(value);
    return (0, $47d7b0945c901d16$export$2e2bcd8739ae039)(value);
}
var $c522323f288f6e96$export$2e2bcd8739ae039 = $c522323f288f6e96$var$baseIteratee;


/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */ function $6fa26b60fab43204$var$mapKeys(object, iteratee) {
    var result = {};
    iteratee = (0, $c522323f288f6e96$export$2e2bcd8739ae039)(iteratee, 3);
    (0, $7c466d0ea92d97f8$export$2e2bcd8739ae039)(object, function(value, key, object) {
        (0, $8Xlz0.default)(result, iteratee(value, key, object), value);
    });
    return result;
}
var $6fa26b60fab43204$export$2e2bcd8739ae039 = $6fa26b60fab43204$var$mapKeys;


var $fOFG0 = parcelRequire("fOFG0");


var $7Jqv7 = parcelRequire("7Jqv7");

var $55CT4 = parcelRequire("55CT4");

var $e9clf = parcelRequire("e9clf");
/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $aaefeec8d4fe0837$var$baseSet(object, path, value, customizer) {
    if (!(0, $55CT4.default)(object)) return object;
    path = (0, $9bf1bc98bfb8909a$export$2e2bcd8739ae039)(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = (0, $e9clf.default)(path[index]), newValue = value;
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = (0, $55CT4.default)(objValue) ? objValue : (0, $7Jqv7.default)(path[index + 1]) ? [] : {};
        }
        (0, $fOFG0.default)(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
var $aaefeec8d4fe0837$export$2e2bcd8739ae039 = $aaefeec8d4fe0837$var$baseSet;


/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $c26094c110838037$var$set(object, path, value) {
    return object == null ? object : (0, $aaefeec8d4fe0837$export$2e2bcd8739ae039)(object, path, value);
}
var $c26094c110838037$export$2e2bcd8739ae039 = $c26094c110838037$var$set;


var $cDRNl = parcelRequire("cDRNl");
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $0e1ef112a5678cb5$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
var $0e1ef112a5678cb5$export$2e2bcd8739ae039 = $0e1ef112a5678cb5$var$last;



/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $df6e0a0e3e355d0e$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
var $df6e0a0e3e355d0e$export$2e2bcd8739ae039 = $df6e0a0e3e355d0e$var$baseSlice;


/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $c3d90c86e994234b$var$parent(object, path) {
    return path.length < 2 ? object : (0, $ec9ff061c841039c$export$2e2bcd8739ae039)(object, (0, $df6e0a0e3e355d0e$export$2e2bcd8739ae039)(path, 0, -1));
}
var $c3d90c86e994234b$export$2e2bcd8739ae039 = $c3d90c86e994234b$var$parent;



var $e9clf = parcelRequire("e9clf");
/** Used for built-in method references. */ var $0a59692353704216$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0a59692353704216$var$hasOwnProperty = $0a59692353704216$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $0a59692353704216$var$baseUnset(object, path) {
    path = (0, $9bf1bc98bfb8909a$export$2e2bcd8739ae039)(path, object);
    // Prevent prototype pollution:
    // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
    // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
    var index = -1, length = path.length;
    if (!length) return true;
    while(++index < length){
        var key = (0, $e9clf.default)(path[index]);
        // Always block "__proto__" anywhere in the path if it's not expected
        if (key === '__proto__' && !$0a59692353704216$var$hasOwnProperty.call(object, '__proto__')) return false;
        // Block constructor/prototype as non-terminal traversal keys to prevent
        // escaping the object graph into built-in constructors and prototypes.
        if ((key === 'constructor' || key === 'prototype') && index < length - 1) return false;
    }
    var obj = (0, $c3d90c86e994234b$export$2e2bcd8739ae039)(object, path);
    return obj == null || delete obj[(0, $e9clf.default)((0, $0e1ef112a5678cb5$export$2e2bcd8739ae039)(path))];
}
var $0a59692353704216$export$2e2bcd8739ae039 = $0a59692353704216$var$baseUnset;


/**
 * Removes the property at `path` of `object`.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 7 } }] };
 * _.unset(object, 'a[0].b.c');
 * // => true
 *
 * console.log(object);
 * // => { 'a': [{ 'b': {} }] };
 *
 * _.unset(object, ['a', '0', 'b', 'c']);
 * // => true
 *
 * console.log(object);
 * // => { 'a': [{ 'b': {} }] };
 */ function $21a8c6b920d6a9a0$var$unset(object, path) {
    return object == null ? true : (0, $0a59692353704216$export$2e2bcd8739ae039)(object, path);
}
var $21a8c6b920d6a9a0$export$2e2bcd8739ae039 = $21a8c6b920d6a9a0$var$unset;


const $b7a8d4f3365bbf44$var$fieldTypes = [
    {
        value: 'string',
        label: 'String'
    },
    {
        value: 'number',
        label: 'Number'
    },
    {
        value: 'string[]',
        label: 'List of String'
    },
    {
        value: 'number[]',
        label: 'List of Number'
    },
    {
        value: 'json',
        label: 'JSON'
    }
];
const $b7a8d4f3365bbf44$export$831af5b09d04fe74 = (value)=>{
    if (typeof value === 'number') return 'number';
    if (Array.isArray(value)) {
        if (value.every((v)=>typeof v === 'number')) return 'number[]';
        if (value.every((v)=>typeof v === 'string')) return 'string[]';
        return 'json';
    }
    if (typeof value === 'object') return 'json';
    return 'string';
};
const $b7a8d4f3365bbf44$export$5700206816b2d436 = (type)=>{
    if (type === 'string') return {
        type: 'string',
        label: 'Value'
    };
    if (type === 'number') return {
        type: 'number',
        label: 'Value'
    };
    if ([
        'string[]',
        'number[]'
    ].includes(type)) return {
        type: 'array',
        label: 'Value',
        minItems: 1,
        items: {
            type: type.replace('[]', '')
        }
    };
    if (type === 'json') return {
        type: 'json',
        label: 'Value'
    };
    return null;
};
const $b7a8d4f3365bbf44$export$3e0178b40c01d493 = (obj, path, newKey)=>{
    const parts = (0, $cDRNl.default)(path);
    const last = parts.pop();
    const isRoot = !parts.length;
    const valuesAtPath = isRoot ? obj : (0, $de005c3c82706228$export$2e2bcd8739ae039)(obj, parts);
    const valuesWithNewKey = (0, $6fa26b60fab43204$export$2e2bcd8739ae039)(valuesAtPath, (_, key)=>{
        return key === last ? newKey : key;
    });
    valuesWithNewKey[newKey] = valuesAtPath[last];
    return isRoot ? valuesWithNewKey : (0, $c26094c110838037$export$2e2bcd8739ae039)((0, $jGWdr.default)(obj), parts, valuesWithNewKey);
};
function $b7a8d4f3365bbf44$export$70bee8710139c684(props) {
    const { pointer: pointer, property: property, existentProperties: existentProperties } = props;
    const ctx = (0, $jTKGQ.useFormikContext)();
    const value = pointer ? (0, $de005c3c82706228$export$2e2bcd8739ae039)(ctx.values, pointer) : ctx.values;
    const [fieldType, setFieldType] = (0, $8v0nu.useState)($b7a8d4f3365bbf44$export$831af5b09d04fe74(value));
    const [keyFieldValue, setKeyFieldValue] = (0, $8v0nu.useState)(property);
    const [keyError, setKeyError] = (0, $8v0nu.useState)();
    const onFieldKeyBlur = (0, $8v0nu.useCallback)((e)=>{
        const newProp = e.target.value;
        const keyExists = existentProperties.includes(newProp);
        // Revert to original value in case of error.
        setKeyError(undefined);
        if (keyExists || newProp === '') {
            setKeyFieldValue(property);
            return;
        }
        // Update the form values with the new property name.
        if (newProp === property) return;
        ctx.setValues($b7a8d4f3365bbf44$export$3e0178b40c01d493(ctx.values, pointer, newProp));
        const newPointer = pointer.replace(new RegExp(`${property}$`, 'g'), newProp);
        ctx.unregisterField(pointer);
        ctx.registerField(newPointer, {});
    }, [
        pointer,
        property,
        value,
        ctx
    ]);
    const removeProperty = (0, $8v0nu.useCallback)((pointer)=>{
        ctx.unregisterField(pointer);
        const valuesCopy = {
            ...ctx.values
        };
        (0, $21a8c6b920d6a9a0$export$2e2bcd8739ae039)(valuesCopy, pointer);
        ctx.setValues(valuesCopy);
    }, [
        ctx
    ]);
    const field = (0, $8v0nu.useMemo)(()=>$b7a8d4f3365bbf44$export$5700206816b2d436(fieldType), [
        fieldType
    ]);
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $8f2967926209c75b$export$e154be390aa0e14), {
        children: [
            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $8f2967926209c75b$export$4177b95adc81bedf), {
                children: [
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $1415810625b263eb$export$e71c4d32a2263218), {
                        children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $5e0ca4edd90668b0$exports).Root, {
                            invalid: !!keyError,
                            children: [
                                /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $4118161e107f6861$export$6e5a9cd40e0c9b97), {
                                    startElement: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9138db1f951ed55c$export$7b73804de18dac8e), {
                                        title: "Value for the object property"
                                    }),
                                    children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $88b24aa7301f8cd5$export$f5b8910cec6cf069), {
                                        size: "sm",
                                        bg: "surface.500",
                                        borderColor: "base.200",
                                        type: "text",
                                        placeholder: "Property name",
                                        value: keyFieldValue,
                                        onChange: (e)=>{
                                            const value = e.target.value;
                                            setKeyFieldValue(value);
                                            if (existentProperties.includes(value)) setKeyError('Property already exists');
                                            else if (value === '') setKeyError('Property name cannot be empty');
                                        },
                                        onBlur: onFieldKeyBlur
                                    })
                                }),
                                /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $5e0ca4edd90668b0$exports).ErrorText, {
                                    children: keyError
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $386ff1fd0b4cfff1$export$f51f4c4ede09e011), {
                        gap: 4,
                        children: [
                            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $70295da2572f7f22$exports).Root, {
                                size: "sm",
                                bg: "surface.500",
                                borderColor: "base.200",
                                borderRadius: "md",
                                children: [
                                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $70295da2572f7f22$exports).Field, {
                                        value: fieldType,
                                        onChange: (e)=>{
                                            const type = e.target.value;
                                            setFieldType(type);
                                            const schema = $b7a8d4f3365bbf44$export$5700206816b2d436(type);
                                            if (schema) {
                                                const valuesForSchema = (0, $c1e8126e9c607e51$export$bb0693b91fc28141)(schema);
                                                ctx.setFieldValue(pointer, valuesForSchema);
                                            }
                                        },
                                        children: $b7a8d4f3365bbf44$var$fieldTypes.map((type)=>/*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)("option", {
                                                value: type.value,
                                                children: type.label
                                            }, type.value))
                                    }),
                                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $70295da2572f7f22$exports).Indicator, {})
                                ]
                            }),
                            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $8f2967926209c75b$export$4520a427b44f3477), {
                                "aria-label": "Remove item",
                                onClick: ()=>removeProperty(pointer)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $8f2967926209c75b$export$47bfc31835db02f5), {
                children: field && /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $a43fa2f2fffac74f$export$bac6ca00840ef02b), {
                    field: field,
                    pointer: pointer
                })
            })
        ]
    });
}


/**
 * Finds the next unique value by appending an incrementing number to the given
 * value.
 *
 * @param value - The base value to which the incrementing number will be
 * appended.
 * @param valueKeys - An array of existing values to check against for
 * uniqueness.
 * @returns The next unique value that is not present in the valueKeys array.
 */ const $0fcc824096db126c$var$findNextValue = (value, valueKeys)=>{
    let i = 0;
    while(true){
        const v = `${value}-${++i}`;
        if (!valueKeys.includes(v)) return v;
    }
};
function $0fcc824096db126c$export$fc949cf2e017c75f(props) {
    const { pointer: pointer } = props;
    const field = props.field;
    const ctx = (0, $jTKGQ.useFormikContext)();
    const values = pointer ? (0, $de005c3c82706228$export$2e2bcd8739ae039)(ctx.values, pointer) : ctx.values;
    const schemaKeys = Object.keys(field.properties);
    const valueKeys = Object.keys(values || {});
    const unlistedKeys = valueKeys.filter((key)=>!schemaKeys.includes(key));
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $ef524fb144c5d632$exports.Fragment), {
        children: [
            Object.entries(field.properties).map(([key, item])=>/*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $a43fa2f2fffac74f$export$bac6ca00840ef02b), {
                    pointer: pointer ? `${pointer}.${key}` : key,
                    field: item,
                    isRequired: field.required?.includes(key)
                }, key)),
            field.additionalProperties && /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $ef524fb144c5d632$exports.Fragment), {
                children: [
                    unlistedKeys.map((key)=>/*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $b7a8d4f3365bbf44$export$70bee8710139c684), {
                            property: key,
                            existentProperties: valueKeys.filter((k)=>k !== key),
                            pointer: pointer ? `${pointer}.${key}` : key
                        }, key)),
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $a987639d7be6b91e$export$353f5b6fc5456de1), {
                        colorPalette: "base",
                        size: "sm",
                        onClick: ()=>{
                            const nextKey = $0fcc824096db126c$var$findNextValue('property', valueKeys);
                            ctx.setFieldValue(pointer ? `${pointer}.${nextKey}` : nextKey, '');
                        },
                        "aria-label": "Add property",
                        children: [
                            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $9138db1f951ed55c$export$3a9f56a1d1f9a714), {}),
                            "Add property"
                        ]
                    })
                ]
            })
        ]
    });
}



parcelRequire("8v0nu");


function $b10f7d2a328f4eb8$export$a9edb623e575de0d(props) {
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $8f2967926209c75b$export$528341e82434bd), {
        label: props.field.label,
        children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $0fcc824096db126c$export$fc949cf2e017c75f), {
            ...props
        })
    });
}



parcelRequire("8v0nu");



var $jTKGQ = parcelRequire("jTKGQ");



function $a19b114acf696fe3$export$a7e262ad5a444678(props) {
    const { pointer: pointer, isRequired: isRequired } = props;
    const field = props.field;
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)($a19b114acf696fe3$var$ArrayItem, {
        label: field.label,
        pointer: pointer,
        field: field,
        isRequired: isRequired
    });
}
function $a19b114acf696fe3$var$ArrayItem(props) {
    const { label: label, field: field, pointer: pointer, onRemove: onRemove, removeDisabled: removeDisabled, isRequired: isRequired } = props;
    const { values: values } = (0, $jTKGQ.useFormikContext)();
    const fields = (0, $de005c3c82706228$export$2e2bcd8739ae039)(values, pointer) || [];
    const items = field.items;
    const minItems = field.minItems || 0;
    const maxItems = field.maxItems || Infinity;
    const isFixedCount = minItems === maxItems;
    // Check if the nested array is special like an array of strings (Checkboxes)
    // for example. Same logic as widget renderer.
    const isRegularNestedArray = items.type === 'array' && ![
        'string',
        'number'
    ].includes(items.items.type);
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $jTKGQ.FieldArray), {
        name: pointer,
        render: ({ remove: remove, push: push })=>/*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $8f2967926209c75b$export$528341e82434bd), {
                label: label,
                isRequired: isRequired,
                onRemove: onRemove,
                onAdd: isFixedCount ? undefined : ()=>{
                    push((0, $c1e8126e9c607e51$export$bb0693b91fc28141)(items));
                },
                addDisabled: fields.length >= maxItems,
                removeDisabled: removeDisabled,
                children: fields.length ? /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $31d9364a1b2177e0$exports).Root, {
                    display: "flex",
                    flexDirection: "column",
                    gap: 4,
                    listStyle: "none",
                    children: fields.map((_, index)=>/*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $31d9364a1b2177e0$exports).Item, {
                            children: isRegularNestedArray ? /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)($a19b114acf696fe3$var$ArrayItem, {
                                label: (0, $81cc9f2a42ee34ee$export$ebfdb425fb84a7c7)(items, index)?.formatted,
                                pointer: `${pointer}.${index}`,
                                field: items,
                                onRemove: isFixedCount ? undefined : ()=>{
                                    remove(index);
                                },
                                removeDisabled: fields.length <= minItems
                            }) : /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $8f2967926209c75b$export$528341e82434bd), {
                                label: (0, $81cc9f2a42ee34ee$export$ebfdb425fb84a7c7)(items, index)?.formatted,
                                onRemove: isFixedCount ? undefined : ()=>{
                                    remove(index);
                                },
                                removeDisabled: fields.length <= minItems,
                                children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $a43fa2f2fffac74f$export$bac6ca00840ef02b), {
                                    pointer: `${pointer}.${index}`,
                                    field: items,
                                    isRequired: false
                                })
                            })
                        }, index /* eslint-disable-line react/no-array-index-key */ ))
                }) : /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)("p", {
                    children: "No items"
                })
            })
    });
}



parcelRequire("8v0nu");



var $jTKGQ = parcelRequire("jTKGQ");




function $a3347928c80810e5$export$9436aa8cdadea878(props) {
    const { pointer: pointer, isRequired: isRequired } = props;
    const field = props.field;
    const { values: values } = (0, $jTKGQ.useFormikContext)();
    const fields = (0, $de005c3c82706228$export$2e2bcd8739ae039)(values, pointer) || [];
    const minItems = field.minItems || 0;
    const maxItems = field.maxItems || Infinity;
    const isFixed = minItems === maxItems;
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $jTKGQ.FieldArray), {
        name: pointer,
        render: ({ remove: remove, push: push })=>/*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $8f2967926209c75b$export$528341e82434bd), {
                isRequired: isRequired,
                label: field.label,
                onAdd: isFixed ? undefined : ()=>{
                    push((0, $c1e8126e9c607e51$export$bb0693b91fc28141)(field.items));
                },
                addDisabled: fields.length >= maxItems,
                children: fields.length ? /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $31d9364a1b2177e0$exports).Root, {
                    display: "flex",
                    gap: 4,
                    flexDir: isFixed ? 'row' : 'column',
                    listStyle: "none",
                    children: fields.map((_, index)=>/*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $31d9364a1b2177e0$exports).Item, {
                            display: "flex",
                            width: "100%",
                            children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $02719087c988c832$export$2a4b7b80ff003e13), {
                                pointer: `${pointer}.${index}`,
                                type: field.items.type,
                                field: field.items,
                                label: (0, $81cc9f2a42ee34ee$export$ebfdb425fb84a7c7)(field.items, index)?.formatted,
                                isDeletable: !isFixed,
                                onDeleteClick: ()=>{
                                    remove(index);
                                },
                                transformValue: (v)=>{
                                    if (field.items.type === 'number') {
                                        const n = Number(v);
                                        return isNaN(n) ? null : n;
                                    }
                                    return v;
                                },
                                isDeleteDisabled: fields.length <= minItems
                            })
                        }, index /* eslint-disable-line react/no-array-index-key */ ))
                }) : /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)("p", {
                    children: "No items"
                })
            })
    });
}




var $8v0nu = parcelRequire("8v0nu");


var $jTKGQ = parcelRequire("jTKGQ");
function $2b339004796b0e2f$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $2b339004796b0e2f$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2b339004796b0e2f$export$2e2bcd8739ae039(o);
}



function $efdd2b035d469606$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $2b339004796b0e2f$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $2b339004796b0e2f$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $61a2d357b836eaab$export$2e2bcd8739ae039(t) {
    var i = (0, $efdd2b035d469606$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $2b339004796b0e2f$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $a038852823ee2701$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $61a2d357b836eaab$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}


function $0604ab8b4211d13c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0604ab8b4211d13c$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0604ab8b4211d13c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $a038852823ee2701$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0604ab8b4211d13c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}


function $2c46bfc13d730b1c$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $86e2ab5507bf31b8$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}


function $1cdff5d382dc9bd7$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $fb95e850070d972e$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $1cdff5d382dc9bd7$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $1cdff5d382dc9bd7$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $c06b5feaeed0bffe$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $5e8d680428cd6d3c$export$2e2bcd8739ae039(r, e) {
    return (0, $2c46bfc13d730b1c$export$2e2bcd8739ae039)(r) || (0, $86e2ab5507bf31b8$export$2e2bcd8739ae039)(r, e) || (0, $fb95e850070d972e$export$2e2bcd8739ae039)(r, e) || (0, $c06b5feaeed0bffe$export$2e2bcd8739ae039)();
}


function $49760e397f3641cf$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $a69ac13ab3c3f3dd$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $49760e397f3641cf$export$2e2bcd8739ae039)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}



var $8v0nu = parcelRequire("8v0nu");
var $502643e4fe0f2f4b$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $502643e4fe0f2f4b$export$3b14a55fb2447963(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $a69ac13ab3c3f3dd$export$2e2bcd8739ae039)(_ref, $502643e4fe0f2f4b$var$_excluded);
    var _useState = (0, $8v0nu.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $5e8d680428cd6d3c$export$2e2bcd8739ae039)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $8v0nu.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $5e8d680428cd6d3c$export$2e2bcd8739ae039)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $8v0nu.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $5e8d680428cd6d3c$export$2e2bcd8739ae039)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $8v0nu.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $8v0nu.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $8v0nu.useCallback)(function() {
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $8v0nu.useCallback)(function() {
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)((0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}




var $8v0nu = parcelRequire("8v0nu");


function $cad7451c9e32255d$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}



function $bd6fca2392fb7de2$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $61a2d357b836eaab$export$2e2bcd8739ae039)(o.key), o);
    }
}
function $bd6fca2392fb7de2$export$2e2bcd8739ae039(e, r, t) {
    return r && $bd6fca2392fb7de2$var$_defineProperties(e.prototype, r), t && $bd6fca2392fb7de2$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}



function $6c7ef991d1028cee$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $3e402af6c1df600a$export$2e2bcd8739ae039)(t, e);
}






function $3688045288b2795c$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $2b339004796b0e2f$export$2e2bcd8739ae039)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $8936f896c18fae91$export$2e2bcd8739ae039)(t);
}


function $1a0a5e846fa7425c$export$2e2bcd8739ae039(t) {
    var r = (0, $ed6a999545bb9645$export$2e2bcd8739ae039)();
    return function() {
        var e, o = (0, $53a741574f109c42$export$2e2bcd8739ae039)(t);
        if (r) {
            var s = (0, $53a741574f109c42$export$2e2bcd8739ae039)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $3688045288b2795c$export$2e2bcd8739ae039)(this, e);
    };
}



function $4b5563dfee11916e$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $1cdff5d382dc9bd7$export$2e2bcd8739ae039)(r);
}


function $688e32403021fe54$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}



function $c8c95eadc4281afa$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $aba02085c81f3bc8$export$2e2bcd8739ae039(r) {
    return (0, $4b5563dfee11916e$export$2e2bcd8739ae039)(r) || (0, $688e32403021fe54$export$2e2bcd8739ae039)(r) || (0, $fb95e850070d972e$export$2e2bcd8739ae039)(r) || (0, $c8c95eadc4281afa$export$2e2bcd8739ae039)();
}



var $8v0nu = parcelRequire("8v0nu");






function $440595ef322c396e$export$2e2bcd8739ae039(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}




var $8v0nu = parcelRequire("8v0nu");

var $k2dbP = parcelRequire("k2dbP");


var $8v0nu = parcelRequire("8v0nu");
var $33f8f3cd8d043d49$export$2e2bcd8739ae039 = (0, $8v0nu.useLayoutEffect);


var $b0015ad11dc7ba35$var$_excluded$4 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var $b0015ad11dc7ba35$export$b4171a6734a65d42 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $b0015ad11dc7ba35$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $b0015ad11dc7ba35$export$a9c23c6ac3fc3eca(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($b0015ad11dc7ba35$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(' ');
}
// ==============================
// Clean Value
// ==============================
var $b0015ad11dc7ba35$export$7f8ddf7c7c20b3cd = function cleanValue(value) {
    if ($b0015ad11dc7ba35$var$isArray(value)) return value.filter(Boolean);
    if ((0, $2b339004796b0e2f$export$2e2bcd8739ae039)(value) === 'object' && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var $b0015ad11dc7ba35$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $a69ac13ab3c3f3dd$export$2e2bcd8739ae039)(props, $b0015ad11dc7ba35$var$_excluded$4);
    return (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var $b0015ad11dc7ba35$var$getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function $b0015ad11dc7ba35$export$61196ced6d74a310(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === 'string') return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function $b0015ad11dc7ba35$export$2329c99376c9d0a4(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function $b0015ad11dc7ba35$var$normalizedHeight(el) {
    if ($b0015ad11dc7ba35$export$2329c99376c9d0a4(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function $b0015ad11dc7ba35$var$getScrollTop(el) {
    if ($b0015ad11dc7ba35$export$2329c99376c9d0a4(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $b0015ad11dc7ba35$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($b0015ad11dc7ba35$export$2329c99376c9d0a4(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function $b0015ad11dc7ba35$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $b0015ad11dc7ba35$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $b0015ad11dc7ba35$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $b0015ad11dc7ba35$export$b4171a6734a65d42;
    var start = $b0015ad11dc7ba35$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $b0015ad11dc7ba35$var$easeOutCubic(currentTime, start, change, duration);
        $b0015ad11dc7ba35$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function $b0015ad11dc7ba35$export$9bb611d729802a56(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $b0015ad11dc7ba35$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $b0015ad11dc7ba35$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $b0015ad11dc7ba35$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function $b0015ad11dc7ba35$export$df995fae86a55f06() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function $b0015ad11dc7ba35$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $b0015ad11dc7ba35$var$passiveOptionAccessed = false;
var $b0015ad11dc7ba35$var$options = {
    get passive () {
        return $b0015ad11dc7ba35$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $b0015ad11dc7ba35$var$w = typeof window !== 'undefined' ? window : {};
if ($b0015ad11dc7ba35$var$w.addEventListener && $b0015ad11dc7ba35$var$w.removeEventListener) {
    $b0015ad11dc7ba35$var$w.addEventListener('p', $b0015ad11dc7ba35$export$b4171a6734a65d42, $b0015ad11dc7ba35$var$options);
    $b0015ad11dc7ba35$var$w.removeEventListener('p', $b0015ad11dc7ba35$export$b4171a6734a65d42, false);
}
var $b0015ad11dc7ba35$export$2408f22a0fab9ae5 = $b0015ad11dc7ba35$var$passiveOptionAccessed;
function $b0015ad11dc7ba35$export$3466f893ebf79586(item) {
    return item != null;
}
function $b0015ad11dc7ba35$var$isArray(arg) {
    return Array.isArray(arg);
}
function $b0015ad11dc7ba35$export$96f57966bedc81b4(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $b0015ad11dc7ba35$export$e7094788287c5e9b(singleValue) {
    return singleValue;
}
function $b0015ad11dc7ba35$export$ef35774e6d314e91(multiValue) {
    return multiValue;
}
var $b0015ad11dc7ba35$export$43caf9889c228507 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $5e8d680428cd6d3c$export$2e2bcd8739ae039)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $5e8d680428cd6d3c$export$2e2bcd8739ae039)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
var $b0015ad11dc7ba35$var$_excluded$3 = [
    "children",
    "innerProps"
], $b0015ad11dc7ba35$var$_excluded2$1 = [
    "children",
    "innerProps"
];
function $b0015ad11dc7ba35$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $b0015ad11dc7ba35$var$getScrollParent(menuEl);
    var defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $b0015ad11dc7ba35$var$normalizedHeight(scrollParent);
    var scrollTop = $b0015ad11dc7ba35$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $b0015ad11dc7ba35$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $b0015ad11dc7ba35$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) $b0015ad11dc7ba35$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $b0015ad11dc7ba35$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $b0015ad11dc7ba35$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function $b0015ad11dc7ba35$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
var $b0015ad11dc7ba35$var$coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var $b0015ad11dc7ba35$export$953cecd6e717a553 = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)((_objectSpread2 = {
        label: 'menu'
    }, (0, $a038852823ee2701$export$2e2bcd8739ae039)(_objectSpread2, $b0015ad11dc7ba35$var$alignToControl(placement), '100%'), (0, $a038852823ee2701$export$2e2bcd8739ae039)(_objectSpread2, "position", 'absolute'), (0, $a038852823ee2701$export$2e2bcd8739ae039)(_objectSpread2, "width", '100%'), (0, $a038852823ee2701$export$2e2bcd8739ae039)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var $b0015ad11dc7ba35$var$PortalPlacementContext = /*#__PURE__*/ (0, $8v0nu.createContext)(null);
// NOTE: internal only
var $b0015ad11dc7ba35$export$3a1a48c8f6ef640e = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, $8v0nu.useContext)($b0015ad11dc7ba35$var$PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, $8v0nu.useRef)(null);
    var _useState = (0, $8v0nu.useState)(maxMenuHeight), _useState2 = (0, $5e8d680428cd6d3c$export$2e2bcd8739ae039)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $8v0nu.useState)(null), _useState4 = (0, $5e8d680428cd6d3c$export$2e2bcd8739ae039)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, $33f8f3cd8d043d49$export$2e2bcd8739ae039)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === 'fixed';
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $b0015ad11dc7ba35$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)((0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({}, props), {}, {
            placement: placement || $b0015ad11dc7ba35$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $b0015ad11dc7ba35$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $4968c539ba80adb3$export$c8a8987d4410bf2d)("div", (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({}, $b0015ad11dc7ba35$var$getStyleProps(props, 'menu', {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
var $b0015ad11dc7ba35$var$Menu$1 = $b0015ad11dc7ba35$var$Menu;
// ==============================
// Menu List
// ==============================
var $b0015ad11dc7ba35$export$7ccc53e8f1e7dfc5 = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({
        maxHeight: maxHeight,
        overflowY: 'auto',
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch'
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var $b0015ad11dc7ba35$var$MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $4968c539ba80adb3$export$c8a8987d4410bf2d)("div", (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({}, $b0015ad11dc7ba35$var$getStyleProps(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var $b0015ad11dc7ba35$var$noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({
        textAlign: 'center'
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var $b0015ad11dc7ba35$export$3b14a55fb2447963 = $b0015ad11dc7ba35$var$noticeCSS;
var $b0015ad11dc7ba35$export$342063e11d6c3cad = $b0015ad11dc7ba35$var$noticeCSS;
var $b0015ad11dc7ba35$var$NoOptionsMessage = function NoOptionsMessage(_ref6) {
    var _ref6$children = _ref6.children, children = _ref6$children === void 0 ? 'No options' : _ref6$children, innerProps = _ref6.innerProps, restProps = (0, $a69ac13ab3c3f3dd$export$2e2bcd8739ae039)(_ref6, $b0015ad11dc7ba35$var$_excluded$3);
    return (0, $4968c539ba80adb3$export$c8a8987d4410bf2d)("div", (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({}, $b0015ad11dc7ba35$var$getStyleProps((0, $0604ab8b4211d13c$export$2e2bcd8739ae039)((0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    }), innerProps), children);
};
var $b0015ad11dc7ba35$var$LoadingMessage = function LoadingMessage(_ref7) {
    var _ref7$children = _ref7.children, children = _ref7$children === void 0 ? 'Loading...' : _ref7$children, innerProps = _ref7.innerProps, restProps = (0, $a69ac13ab3c3f3dd$export$2e2bcd8739ae039)(_ref7, $b0015ad11dc7ba35$var$_excluded2$1);
    return (0, $4968c539ba80adb3$export$c8a8987d4410bf2d)("div", (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({}, $b0015ad11dc7ba35$var$getStyleProps((0, $0604ab8b4211d13c$export$2e2bcd8739ae039)((0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    }), innerProps), children);
};
// ==============================
// Menu Portal
// ==============================
var $b0015ad11dc7ba35$export$ae1af26003f05816 = function menuPortalCSS(_ref8) {
    var rect = _ref8.rect, offset = _ref8.offset, position = _ref8.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $b0015ad11dc7ba35$var$MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, $8v0nu.useRef)(null);
    var cleanupRef = (0, $8v0nu.useRef)(null);
    var _useState5 = (0, $8v0nu.useState)($b0015ad11dc7ba35$var$coercePlacement(menuPlacement)), _useState6 = (0, $5e8d680428cd6d3c$export$2e2bcd8739ae039)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $8v0nu.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $8v0nu.useState)(null), _useState8 = (0, $5e8d680428cd6d3c$export$2e2bcd8739ae039)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $8v0nu.useCallback)(function() {
        if (!controlElement) return;
        var rect = $b0015ad11dc7ba35$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $33f8f3cd8d043d49$export$2e2bcd8739ae039)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $8v0nu.useCallback)(function() {
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $e09b833f247449ac$export$deee3a793edee05f)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $33f8f3cd8d043d49$export$2e2bcd8739ae039)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $8v0nu.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, $4968c539ba80adb3$export$c8a8987d4410bf2d)("div", (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({
        ref: setMenuPortalElement
    }, $b0015ad11dc7ba35$var$getStyleProps((0, $0604ab8b4211d13c$export$2e2bcd8739ae039)((0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), 'menuPortal', {
        'menu-portal': true
    }), innerProps), children);
    return (0, $4968c539ba80adb3$export$c8a8987d4410bf2d)($b0015ad11dc7ba35$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $k2dbP.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var $b0015ad11dc7ba35$export$8b22cf2602fb60ce = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: 'container',
        direction: isRtl ? 'rtl' : undefined,
        pointerEvents: isDisabled ? 'none' : undefined,
        // cancel mouse events when disabled
        position: 'relative'
    };
};
var $b0015ad11dc7ba35$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $4968c539ba80adb3$export$c8a8987d4410bf2d)("div", (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({}, $b0015ad11dc7ba35$var$getStyleProps(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var $b0015ad11dc7ba35$export$4a5767248b18ef41 = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({
        alignItems: 'center',
        display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
        flex: 1,
        flexWrap: 'wrap',
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden'
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var $b0015ad11dc7ba35$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, $4968c539ba80adb3$export$c8a8987d4410bf2d)("div", (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({}, $b0015ad11dc7ba35$var$getStyleProps(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var $b0015ad11dc7ba35$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0
    };
};
var $b0015ad11dc7ba35$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $4968c539ba80adb3$export$c8a8987d4410bf2d)("div", (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({}, $b0015ad11dc7ba35$var$getStyleProps(props, 'indicatorsContainer', {
        indicators: true
    }), innerProps), children);
};
var $b0015ad11dc7ba35$var$_templateObject;
var $b0015ad11dc7ba35$var$_excluded$2 = [
    "size"
], $b0015ad11dc7ba35$var$_excluded2 = [
    "innerProps",
    "isRtl",
    "size"
];
function $b0015ad11dc7ba35$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $b0015ad11dc7ba35$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var $b0015ad11dc7ba35$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $a69ac13ab3c3f3dd$export$2e2bcd8739ae039)(_ref, $b0015ad11dc7ba35$var$_excluded$2);
    return (0, $4968c539ba80adb3$export$c8a8987d4410bf2d)("svg", (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $b0015ad11dc7ba35$var$_ref2
    }, props));
};
var $b0015ad11dc7ba35$var$CrossIcon = function CrossIcon(props) {
    return (0, $4968c539ba80adb3$export$c8a8987d4410bf2d)($b0015ad11dc7ba35$var$Svg, (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({
        size: 20
    }, props), (0, $4968c539ba80adb3$export$c8a8987d4410bf2d)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $b0015ad11dc7ba35$var$DownChevron = function DownChevron(props) {
    return (0, $4968c539ba80adb3$export$c8a8987d4410bf2d)($b0015ad11dc7ba35$var$Svg, (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({
        size: 20
    }, props), (0, $4968c539ba80adb3$export$c8a8987d4410bf2d)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $b0015ad11dc7ba35$var$baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ':hover': {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var $b0015ad11dc7ba35$export$f1e1789686576879 = $b0015ad11dc7ba35$var$baseCSS;
var $b0015ad11dc7ba35$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $4968c539ba80adb3$export$c8a8987d4410bf2d)("div", (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({}, $b0015ad11dc7ba35$var$getStyleProps(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    }), innerProps), children || (0, $4968c539ba80adb3$export$c8a8987d4410bf2d)($b0015ad11dc7ba35$var$DownChevron, null));
};
var $b0015ad11dc7ba35$export$407448d2b89b1813 = $b0015ad11dc7ba35$var$baseCSS;
var $b0015ad11dc7ba35$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $4968c539ba80adb3$export$c8a8987d4410bf2d)("div", (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({}, $b0015ad11dc7ba35$var$getStyleProps(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    }), innerProps), children || (0, $4968c539ba80adb3$export$c8a8987d4410bf2d)($b0015ad11dc7ba35$var$CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var $b0015ad11dc7ba35$export$dda1d9f60106f0e9 = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({
        label: 'indicatorSeparator',
        alignSelf: 'stretch',
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var $b0015ad11dc7ba35$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, $4968c539ba80adb3$export$c8a8987d4410bf2d)("span", (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({}, innerProps, $b0015ad11dc7ba35$var$getStyleProps(props, 'indicatorSeparator', {
        'indicator-separator': true
    })));
};
// ==============================
// Loading
// ==============================
var $b0015ad11dc7ba35$var$loadingDotAnimations = (0, $4968c539ba80adb3$export$d25ddfdf17c3ad3e)($b0015ad11dc7ba35$var$_templateObject || ($b0015ad11dc7ba35$var$_templateObject = (0, $440595ef322c396e$export$2e2bcd8739ae039)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $b0015ad11dc7ba35$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({
        label: 'loadingIndicator',
        display: 'flex',
        transition: 'color 150ms',
        alignSelf: 'center',
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: 'center',
        verticalAlign: 'middle'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var $b0015ad11dc7ba35$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $4968c539ba80adb3$export$c8a8987d4410bf2d)("span", {
        css: /*#__PURE__*/ (0, $4968c539ba80adb3$export$dbf350e5966cf602)({
            animation: "".concat($b0015ad11dc7ba35$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: 'currentColor',
            borderRadius: '1em',
            display: 'inline-block',
            marginLeft: offset ? '1em' : undefined,
            height: '1em',
            verticalAlign: 'top',
            width: '1em'
        }, "", "")
    });
};
var $b0015ad11dc7ba35$var$LoadingIndicator = function LoadingIndicator(_ref7) {
    var innerProps = _ref7.innerProps, isRtl = _ref7.isRtl, _ref7$size = _ref7.size, size = _ref7$size === void 0 ? 4 : _ref7$size, restProps = (0, $a69ac13ab3c3f3dd$export$2e2bcd8739ae039)(_ref7, $b0015ad11dc7ba35$var$_excluded2);
    return (0, $4968c539ba80adb3$export$c8a8987d4410bf2d)("div", (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({}, $b0015ad11dc7ba35$var$getStyleProps((0, $0604ab8b4211d13c$export$2e2bcd8739ae039)((0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    }), innerProps), (0, $4968c539ba80adb3$export$c8a8987d4410bf2d)($b0015ad11dc7ba35$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $4968c539ba80adb3$export$c8a8987d4410bf2d)($b0015ad11dc7ba35$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $4968c539ba80adb3$export$c8a8987d4410bf2d)($b0015ad11dc7ba35$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
var $b0015ad11dc7ba35$export$4368d992c4eafac0 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({
        label: 'control',
        alignItems: 'center',
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        minHeight: spacing.controlHeight,
        outline: '0 !important',
        position: 'relative',
        transition: 'all 100ms'
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: 'solid',
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        '&:hover': {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var $b0015ad11dc7ba35$var$Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $4968c539ba80adb3$export$c8a8987d4410bf2d)("div", (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({
        ref: innerRef
    }, $b0015ad11dc7ba35$var$getStyleProps(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    }), innerProps, {
        "aria-disabled": isDisabled || undefined
    }), children);
};
var $b0015ad11dc7ba35$var$Control$1 = $b0015ad11dc7ba35$var$Control;
var $b0015ad11dc7ba35$var$_excluded$1 = [
    "data"
];
var $b0015ad11dc7ba35$export$39b482c5e57630a8 = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $b0015ad11dc7ba35$var$Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $4968c539ba80adb3$export$c8a8987d4410bf2d)("div", (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({}, $b0015ad11dc7ba35$var$getStyleProps(props, 'group', {
        group: true
    }), innerProps), (0, $4968c539ba80adb3$export$c8a8987d4410bf2d)(Heading, (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, $4968c539ba80adb3$export$c8a8987d4410bf2d)("div", null, children));
};
var $b0015ad11dc7ba35$export$2d1720544b23b823 = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({
        label: 'group',
        cursor: 'default',
        display: 'block'
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: '75%',
        fontWeight: 500,
        marginBottom: '0.25em',
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: 'uppercase'
    });
};
var $b0015ad11dc7ba35$var$GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = $b0015ad11dc7ba35$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $a69ac13ab3c3f3dd$export$2e2bcd8739ae039)(_cleanCommonProps, $b0015ad11dc7ba35$var$_excluded$1);
    return (0, $4968c539ba80adb3$export$c8a8987d4410bf2d)("div", (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({}, $b0015ad11dc7ba35$var$getStyleProps(props, 'groupHeading', {
        'group-heading': true
    }), innerProps));
};
var $b0015ad11dc7ba35$var$Group$1 = $b0015ad11dc7ba35$var$Group;
var $b0015ad11dc7ba35$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var $b0015ad11dc7ba35$export$35e795649ee09318 = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)((0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({
        visibility: isDisabled ? 'hidden' : 'visible',
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? 'translateZ(0)' : ''
    }, $b0015ad11dc7ba35$var$containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var $b0015ad11dc7ba35$var$spacingStyle = {
    gridArea: '1 / 2',
    font: 'inherit',
    minWidth: '2px',
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var $b0015ad11dc7ba35$var$containerStyle = {
    flex: '1 1 auto',
    display: 'inline-grid',
    gridArea: '1 / 1 / 2 / 3',
    gridTemplateColumns: '0 min-content',
    '&:after': (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({
        content: 'attr(data-value) " "',
        visibility: 'hidden',
        whiteSpace: 'pre'
    }, $b0015ad11dc7ba35$var$spacingStyle)
};
var $b0015ad11dc7ba35$var$inputStyle = function inputStyle(isHidden) {
    return (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({
        label: 'input',
        color: 'inherit',
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: '100%'
    }, $b0015ad11dc7ba35$var$spacingStyle);
};
var $b0015ad11dc7ba35$var$Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = $b0015ad11dc7ba35$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, $a69ac13ab3c3f3dd$export$2e2bcd8739ae039)(_cleanCommonProps, $b0015ad11dc7ba35$var$_excluded);
    return (0, $4968c539ba80adb3$export$c8a8987d4410bf2d)("div", (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({}, $b0015ad11dc7ba35$var$getStyleProps(props, 'input', {
        'input-container': true
    }), {
        "data-value": value || ''
    }), (0, $4968c539ba80adb3$export$c8a8987d4410bf2d)("input", (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: $b0015ad11dc7ba35$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $b0015ad11dc7ba35$var$Input$1 = $b0015ad11dc7ba35$var$Input;
var $b0015ad11dc7ba35$export$ffb5f4729a158638 = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({
        label: 'multiValue',
        display: 'flex',
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var $b0015ad11dc7ba35$export$9e5f44173e64f162 = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({
        overflow: 'hidden',
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: '85%',
        padding: 3,
        paddingLeft: 6
    });
};
var $b0015ad11dc7ba35$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({
        alignItems: 'center',
        display: 'flex'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ':hover': {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var $b0015ad11dc7ba35$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $4968c539ba80adb3$export$c8a8987d4410bf2d)("div", innerProps, children);
};
var $b0015ad11dc7ba35$var$MultiValueContainer = $b0015ad11dc7ba35$var$MultiValueGeneric;
var $b0015ad11dc7ba35$var$MultiValueLabel = $b0015ad11dc7ba35$var$MultiValueGeneric;
function $b0015ad11dc7ba35$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $4968c539ba80adb3$export$c8a8987d4410bf2d)("div", (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({
        role: "button"
    }, innerProps), children || (0, $4968c539ba80adb3$export$c8a8987d4410bf2d)($b0015ad11dc7ba35$var$CrossIcon, {
        size: 14
    }));
}
var $b0015ad11dc7ba35$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $4968c539ba80adb3$export$c8a8987d4410bf2d)(Container, {
        data: data,
        innerProps: (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)((0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({}, $b0015ad11dc7ba35$var$getStyleProps(props, 'multiValue', {
            'multi-value': true,
            'multi-value--is-disabled': isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, $4968c539ba80adb3$export$c8a8987d4410bf2d)(Label, {
        data: data,
        innerProps: (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({}, $b0015ad11dc7ba35$var$getStyleProps(props, 'multiValueLabel', {
            'multi-value__label': true
        })),
        selectProps: selectProps
    }, children), (0, $4968c539ba80adb3$export$c8a8987d4410bf2d)(Remove, {
        data: data,
        innerProps: (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)((0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({}, $b0015ad11dc7ba35$var$getStyleProps(props, 'multiValueRemove', {
            'multi-value__remove': true
        })), {}, {
            'aria-label': "Remove ".concat(children || 'option')
        }, removeProps),
        selectProps: selectProps
    }));
};
var $b0015ad11dc7ba35$var$MultiValue$1 = $b0015ad11dc7ba35$var$MultiValue;
var $b0015ad11dc7ba35$export$90a7f3efeed30595 = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({
        label: 'option',
        cursor: 'default',
        display: 'block',
        fontSize: 'inherit',
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)'
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ':active': {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var $b0015ad11dc7ba35$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $4968c539ba80adb3$export$c8a8987d4410bf2d)("div", (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({}, $b0015ad11dc7ba35$var$getStyleProps(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var $b0015ad11dc7ba35$var$Option$1 = $b0015ad11dc7ba35$var$Option;
var $b0015ad11dc7ba35$export$efccba1c4a2ef57b = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({
        label: 'placeholder',
        gridArea: '1 / 1 / 2 / 3'
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $b0015ad11dc7ba35$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $4968c539ba80adb3$export$c8a8987d4410bf2d)("div", (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({}, $b0015ad11dc7ba35$var$getStyleProps(props, 'placeholder', {
        placeholder: true
    }), innerProps), children);
};
var $b0015ad11dc7ba35$var$Placeholder$1 = $b0015ad11dc7ba35$var$Placeholder;
var $b0015ad11dc7ba35$export$d141bba7fdc215a3 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({
        label: 'singleValue',
        gridArea: '1 / 1 / 2 / 3',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $b0015ad11dc7ba35$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $4968c539ba80adb3$export$c8a8987d4410bf2d)("div", (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({}, $b0015ad11dc7ba35$var$getStyleProps(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    }), innerProps), children);
};
var $b0015ad11dc7ba35$var$SingleValue$1 = $b0015ad11dc7ba35$var$SingleValue;
var $b0015ad11dc7ba35$export$db3b6bfb95261072 = {
    ClearIndicator: $b0015ad11dc7ba35$var$ClearIndicator,
    Control: $b0015ad11dc7ba35$var$Control$1,
    DropdownIndicator: $b0015ad11dc7ba35$var$DropdownIndicator,
    DownChevron: $b0015ad11dc7ba35$var$DownChevron,
    CrossIcon: $b0015ad11dc7ba35$var$CrossIcon,
    Group: $b0015ad11dc7ba35$var$Group$1,
    GroupHeading: $b0015ad11dc7ba35$var$GroupHeading,
    IndicatorsContainer: $b0015ad11dc7ba35$var$IndicatorsContainer,
    IndicatorSeparator: $b0015ad11dc7ba35$var$IndicatorSeparator,
    Input: $b0015ad11dc7ba35$var$Input$1,
    LoadingIndicator: $b0015ad11dc7ba35$var$LoadingIndicator,
    Menu: $b0015ad11dc7ba35$var$Menu$1,
    MenuList: $b0015ad11dc7ba35$var$MenuList,
    MenuPortal: $b0015ad11dc7ba35$var$MenuPortal,
    LoadingMessage: $b0015ad11dc7ba35$var$LoadingMessage,
    NoOptionsMessage: $b0015ad11dc7ba35$var$NoOptionsMessage,
    MultiValue: $b0015ad11dc7ba35$var$MultiValue$1,
    MultiValueContainer: $b0015ad11dc7ba35$var$MultiValueContainer,
    MultiValueLabel: $b0015ad11dc7ba35$var$MultiValueLabel,
    MultiValueRemove: $b0015ad11dc7ba35$var$MultiValueRemove,
    Option: $b0015ad11dc7ba35$var$Option$1,
    Placeholder: $b0015ad11dc7ba35$var$Placeholder$1,
    SelectContainer: $b0015ad11dc7ba35$var$SelectContainer,
    SingleValue: $b0015ad11dc7ba35$var$SingleValue$1,
    ValueContainer: $b0015ad11dc7ba35$var$ValueContainer
};
var $b0015ad11dc7ba35$export$d66501df72047452 = function defaultComponents(props) {
    return (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)((0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({}, $b0015ad11dc7ba35$export$db3b6bfb95261072), props.components);
};



var $c7b670e7608f7d67$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $c7b670e7608f7d67$var$isEqual(first, second) {
    if (first === second) return true;
    if ($c7b670e7608f7d67$var$safeIsNaN(first) && $c7b670e7608f7d67$var$safeIsNaN(second)) return true;
    return false;
}
function $c7b670e7608f7d67$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$c7b670e7608f7d67$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $c7b670e7608f7d67$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $c7b670e7608f7d67$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}



function $04156f3449b439eb$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var $04156f3449b439eb$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $04156f3449b439eb$var$A11yText = function A11yText(props) {
    return (0, $4968c539ba80adb3$export$c8a8987d4410bf2d)("span", (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({
        css: $04156f3449b439eb$var$_ref
    }, props));
};
var $04156f3449b439eb$var$A11yText$1 = $04156f3449b439eb$var$A11yText;
var $04156f3449b439eb$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, tabSelectsValue = props.tabSelectsValue, context = props.context, isInitialFocus = props.isInitialFocus;
        switch(context){
            case 'menu':
                return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");
            case 'input':
                return isInitialFocus ? "".concat(props['aria-label'] || 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '') : '';
            case 'value':
                return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
            default:
                return '';
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? '' : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return "option ".concat(label, ", deselected.");
            case 'clear':
                return 'All selected options have been cleared.';
            case 'initial-input-focus':
                return "option".concat(labels.length > 1 ? 's' : '', " ").concat(labels.join(','), ", selected.");
            case 'select-option':
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return '';
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? '' : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected, isAppleDevice = props.isAppleDevice;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : '';
        };
        if (context === 'value' && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === 'menu' && isAppleDevice) {
            var disabled = isDisabled ? ' disabled' : '';
            var status = "".concat(isSelected ? ' selected' : '').concat(disabled);
            return "".concat(label).concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return '';
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
    }
};
var $04156f3449b439eb$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id, isAppleDevice = props.isAppleDevice;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue, isLoading = selectProps.isLoading;
    var ariaLabel = selectProps['aria-label'];
    var ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    var messages = (0, $8v0nu.useMemo)(function() {
        return (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)((0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({}, $04156f3449b439eb$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $8v0nu.useMemo)(function() {
        var message = '';
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, $8v0nu.useMemo)(function() {
        var focusMsg = '';
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue,
                isAppleDevice: isAppleDevice
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue,
        isAppleDevice
    ]);
    var ariaResults = (0, $8v0nu.useMemo)(function() {
        var resultsMsg = '';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    var ariaGuidance = (0, $8v0nu.useMemo)(function() {
        var guidanceMsg = '';
        if (messages.guidance) {
            var context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue,
                isInitialFocus: isInitialFocus
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue,
        isInitialFocus
    ]);
    var ScreenReaderText = (0, $4968c539ba80adb3$export$c8a8987d4410bf2d)((0, $8v0nu.Fragment), null, (0, $4968c539ba80adb3$export$c8a8987d4410bf2d)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $4968c539ba80adb3$export$c8a8987d4410bf2d)("span", {
        id: "aria-focused"
    }, ariaFocused), (0, $4968c539ba80adb3$export$c8a8987d4410bf2d)("span", {
        id: "aria-results"
    }, ariaResults), (0, $4968c539ba80adb3$export$c8a8987d4410bf2d)("span", {
        id: "aria-guidance"
    }, ariaGuidance));
    return (0, $4968c539ba80adb3$export$c8a8987d4410bf2d)((0, $8v0nu.Fragment), null, (0, $4968c539ba80adb3$export$c8a8987d4410bf2d)($04156f3449b439eb$var$A11yText$1, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, $4968c539ba80adb3$export$c8a8987d4410bf2d)($04156f3449b439eb$var$A11yText$1, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        role: "log"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var $04156f3449b439eb$var$LiveRegion$1 = $04156f3449b439eb$var$LiveRegion;
var $04156f3449b439eb$var$diacritics = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $04156f3449b439eb$var$anyDiacritic = new RegExp('[' + $04156f3449b439eb$var$diacritics.map(function(d) {
    return d.letters;
}).join('') + ']', 'g');
var $04156f3449b439eb$var$diacriticToBase = {};
for(var $04156f3449b439eb$var$i = 0; $04156f3449b439eb$var$i < $04156f3449b439eb$var$diacritics.length; $04156f3449b439eb$var$i++){
    var $04156f3449b439eb$var$diacritic = $04156f3449b439eb$var$diacritics[$04156f3449b439eb$var$i];
    for(var $04156f3449b439eb$var$j = 0; $04156f3449b439eb$var$j < $04156f3449b439eb$var$diacritic.letters.length; $04156f3449b439eb$var$j++)$04156f3449b439eb$var$diacriticToBase[$04156f3449b439eb$var$diacritic.letters[$04156f3449b439eb$var$j]] = $04156f3449b439eb$var$diacritic.base;
}
var $04156f3449b439eb$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($04156f3449b439eb$var$anyDiacritic, function(match) {
        return $04156f3449b439eb$var$diacriticToBase[match];
    });
};
var $04156f3449b439eb$var$memoizedStripDiacriticsForInput = (0, $c7b670e7608f7d67$export$2e2bcd8739ae039)($04156f3449b439eb$var$stripDiacritics);
var $04156f3449b439eb$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
};
var $04156f3449b439eb$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $04156f3449b439eb$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $04156f3449b439eb$var$defaultStringify,
            trim: true,
            matchFrom: 'any'
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $04156f3449b439eb$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $04156f3449b439eb$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $04156f3449b439eb$var$memoizedStripDiacriticsForInput(input);
            candidate = $04156f3449b439eb$var$stripDiacritics(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var $04156f3449b439eb$var$_excluded = [
    "innerRef"
];
function $04156f3449b439eb$var$DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, $a69ac13ab3c3f3dd$export$2e2bcd8739ae039)(_ref, $04156f3449b439eb$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $b0015ad11dc7ba35$export$43caf9889c228507)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    return (0, $4968c539ba80adb3$export$c8a8987d4410bf2d)("input", (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, $4968c539ba80adb3$export$dbf350e5966cf602)({
            label: 'dummyInput',
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: 'transparent',
            fontSize: 'inherit',
            gridArea: '1 / 1 / 2 / 3',
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: 'transparent',
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: 'relative',
            transform: 'scale(.01)'
        }, "", "")
    }));
}
var $04156f3449b439eb$var$cancelScroll = function cancelScroll(event) {
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $04156f3449b439eb$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $8v0nu.useRef)(false);
    var isTop = (0, $8v0nu.useRef)(false);
    var touchStart = (0, $8v0nu.useRef)(0);
    var scrollTarget = (0, $8v0nu.useRef)(null);
    var handleEventDelta = (0, $8v0nu.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $04156f3449b439eb$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $8v0nu.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $8v0nu.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $8v0nu.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $8v0nu.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $b0015ad11dc7ba35$export$2408f22a0fab9ae5) ? {
            passive: false
        } : false;
        el.addEventListener('wheel', onWheel, notPassive);
        el.addEventListener('touchstart', onTouchStart, notPassive);
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $8v0nu.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener('wheel', onWheel, false);
        el.removeEventListener('touchstart', onTouchStart, false);
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $8v0nu.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $04156f3449b439eb$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
var $04156f3449b439eb$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $04156f3449b439eb$var$preventTouchMove(e) {
    if (e.cancelable) e.preventDefault();
}
function $04156f3449b439eb$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $04156f3449b439eb$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $04156f3449b439eb$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var $04156f3449b439eb$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var $04156f3449b439eb$var$activeScrollLocks = 0;
var $04156f3449b439eb$var$listenerOptions = {
    capture: false,
    passive: false
};
function $04156f3449b439eb$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $8v0nu.useRef)({});
    var scrollTarget = (0, $8v0nu.useRef)(null);
    var addScrollLock = (0, $8v0nu.useCallback)(function(touchScrollTarget) {
        if (!$04156f3449b439eb$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $04156f3449b439eb$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $04156f3449b439eb$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($04156f3449b439eb$var$LOCK_STYLES).forEach(function(key) {
                var val = $04156f3449b439eb$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $04156f3449b439eb$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener('touchmove', $04156f3449b439eb$var$preventTouchMove, $04156f3449b439eb$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener('touchstart', $04156f3449b439eb$var$preventInertiaScroll, $04156f3449b439eb$var$listenerOptions);
                touchScrollTarget.addEventListener('touchmove', $04156f3449b439eb$var$allowTouchMove, $04156f3449b439eb$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $04156f3449b439eb$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $8v0nu.useCallback)(function(touchScrollTarget) {
        if (!$04156f3449b439eb$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $04156f3449b439eb$var$activeScrollLocks = Math.max($04156f3449b439eb$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $04156f3449b439eb$var$activeScrollLocks < 1) $04156f3449b439eb$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $04156f3449b439eb$var$isTouchDevice()) {
            target.removeEventListener('touchmove', $04156f3449b439eb$var$preventTouchMove, $04156f3449b439eb$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener('touchstart', $04156f3449b439eb$var$preventInertiaScroll, $04156f3449b439eb$var$listenerOptions);
                touchScrollTarget.removeEventListener('touchmove', $04156f3449b439eb$var$allowTouchMove, $04156f3449b439eb$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $8v0nu.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $04156f3449b439eb$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $04156f3449b439eb$var$blurSelectInput = function blurSelectInput(event) {
    var element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
var $04156f3449b439eb$var$_ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $04156f3449b439eb$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $04156f3449b439eb$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $04156f3449b439eb$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $4968c539ba80adb3$export$c8a8987d4410bf2d)((0, $8v0nu.Fragment), null, lockEnabled && (0, $4968c539ba80adb3$export$c8a8987d4410bf2d)("div", {
        onClick: $04156f3449b439eb$var$blurSelectInput,
        css: $04156f3449b439eb$var$_ref2$1
    }), children(targetRef));
}
function $04156f3449b439eb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $04156f3449b439eb$var$_ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var $04156f3449b439eb$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, $4968c539ba80adb3$export$c8a8987d4410bf2d)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $04156f3449b439eb$var$_ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var $04156f3449b439eb$var$RequiredInput$1 = $04156f3449b439eb$var$RequiredInput;
/// <reference types="user-agent-data-types" />
function $04156f3449b439eb$var$testPlatform(re) {
    var _window$navigator$use;
    return typeof window !== 'undefined' && window.navigator != null ? re.test(((_window$navigator$use = window.navigator['userAgentData']) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.platform) || window.navigator.platform) : false;
}
function $04156f3449b439eb$var$isIPhone() {
    return $04156f3449b439eb$var$testPlatform(/^iPhone/i);
}
function $04156f3449b439eb$var$isMac() {
    return $04156f3449b439eb$var$testPlatform(/^Mac/i);
}
function $04156f3449b439eb$var$isIPad() {
    return $04156f3449b439eb$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $04156f3449b439eb$var$isMac() && navigator.maxTouchPoints > 1;
}
function $04156f3449b439eb$var$isIOS() {
    return $04156f3449b439eb$var$isIPhone() || $04156f3449b439eb$var$isIPad();
}
function $04156f3449b439eb$var$isAppleDevice() {
    return $04156f3449b439eb$var$isMac() || $04156f3449b439eb$var$isIOS();
}
var $04156f3449b439eb$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $04156f3449b439eb$export$8b22cf2602fb60ce = function getOptionLabel(option) {
    return option.label;
};
var $04156f3449b439eb$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $04156f3449b439eb$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $04156f3449b439eb$var$defaultStyles = {
    clearIndicator: (0, $b0015ad11dc7ba35$export$407448d2b89b1813),
    container: (0, $b0015ad11dc7ba35$export$8b22cf2602fb60ce),
    control: (0, $b0015ad11dc7ba35$export$4368d992c4eafac0),
    dropdownIndicator: (0, $b0015ad11dc7ba35$export$f1e1789686576879),
    group: (0, $b0015ad11dc7ba35$export$39b482c5e57630a8),
    groupHeading: (0, $b0015ad11dc7ba35$export$2d1720544b23b823),
    indicatorsContainer: (0, $b0015ad11dc7ba35$export$23f2a1d2818174ef),
    indicatorSeparator: (0, $b0015ad11dc7ba35$export$dda1d9f60106f0e9),
    input: (0, $b0015ad11dc7ba35$export$35e795649ee09318),
    loadingIndicator: (0, $b0015ad11dc7ba35$export$882b5998b3b9117c),
    loadingMessage: (0, $b0015ad11dc7ba35$export$342063e11d6c3cad),
    menu: (0, $b0015ad11dc7ba35$export$953cecd6e717a553),
    menuList: (0, $b0015ad11dc7ba35$export$7ccc53e8f1e7dfc5),
    menuPortal: (0, $b0015ad11dc7ba35$export$ae1af26003f05816),
    multiValue: (0, $b0015ad11dc7ba35$export$ffb5f4729a158638),
    multiValueLabel: (0, $b0015ad11dc7ba35$export$9e5f44173e64f162),
    multiValueRemove: (0, $b0015ad11dc7ba35$export$625550452a3fa3ec),
    noOptionsMessage: (0, $b0015ad11dc7ba35$export$3b14a55fb2447963),
    option: (0, $b0015ad11dc7ba35$export$90a7f3efeed30595),
    placeholder: (0, $b0015ad11dc7ba35$export$efccba1c4a2ef57b),
    singleValue: (0, $b0015ad11dc7ba35$export$d141bba7fdc215a3),
    valueContainer: (0, $b0015ad11dc7ba35$export$4a5767248b18ef41)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function $04156f3449b439eb$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $04156f3449b439eb$var$colors = {
    primary: '#2684FF',
    primary75: '#4C9AFF',
    primary50: '#B2D4FF',
    primary25: '#DEEBFF',
    danger: '#DE350B',
    dangerLight: '#FFBDAD',
    neutral0: 'hsl(0, 0%, 100%)',
    neutral5: 'hsl(0, 0%, 95%)',
    neutral10: 'hsl(0, 0%, 90%)',
    neutral20: 'hsl(0, 0%, 80%)',
    neutral30: 'hsl(0, 0%, 70%)',
    neutral40: 'hsl(0, 0%, 60%)',
    neutral50: 'hsl(0, 0%, 50%)',
    neutral60: 'hsl(0, 0%, 40%)',
    neutral70: 'hsl(0, 0%, 30%)',
    neutral80: 'hsl(0, 0%, 20%)',
    neutral90: 'hsl(0, 0%, 10%)'
};
var $04156f3449b439eb$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var $04156f3449b439eb$var$baseUnit = 4;
// The minimum height of the control
var $04156f3449b439eb$var$controlHeight = 38;
// The amount of space between the control and menu */
var $04156f3449b439eb$var$menuGutter = $04156f3449b439eb$var$baseUnit * 2;
var $04156f3449b439eb$var$spacing = {
    baseUnit: $04156f3449b439eb$var$baseUnit,
    controlHeight: $04156f3449b439eb$var$controlHeight,
    menuGutter: $04156f3449b439eb$var$menuGutter
};
var $04156f3449b439eb$export$4368d992c4eafac0 = {
    borderRadius: $04156f3449b439eb$var$borderRadius,
    colors: $04156f3449b439eb$var$colors,
    spacing: $04156f3449b439eb$var$spacing
};
var $04156f3449b439eb$export$407448d2b89b1813 = {
    'aria-live': 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $b0015ad11dc7ba35$export$df995fae86a55f06)(),
    captureMenuScroll: !(0, $b0015ad11dc7ba35$export$df995fae86a55f06)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $04156f3449b439eb$export$db3b6bfb95261072(),
    formatGroupLabel: $04156f3449b439eb$var$formatGroupLabel,
    getOptionLabel: $04156f3449b439eb$export$8b22cf2602fb60ce,
    getOptionValue: $04156f3449b439eb$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $04156f3449b439eb$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $b0015ad11dc7ba35$export$ebd11618f299a286)(),
    noOptionsMessage: function noOptionsMessage() {
        return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $04156f3449b439eb$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $04156f3449b439eb$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $04156f3449b439eb$var$_isOptionSelected(props, option, selectValue);
    var label = $04156f3449b439eb$var$getOptionLabel(props, option);
    var value = $04156f3449b439eb$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $04156f3449b439eb$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ('options' in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $04156f3449b439eb$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $04156f3449b439eb$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $04156f3449b439eb$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $04156f3449b439eb$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $b0015ad11dc7ba35$export$3466f893ebf79586));
}
function $04156f3449b439eb$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $aba02085c81f3bc8$export$2e2bcd8739ae039)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $04156f3449b439eb$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $aba02085c81f3bc8$export$2e2bcd8739ae039)(categorizedOption.options.map(function(option) {
            return {
                data: option.data,
                id: "".concat(optionId, "-").concat(categorizedOption.index, "-").concat(option.index)
            };
        })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: "".concat(optionId, "-").concat(categorizedOption.index)
        });
        return optionsAccumulator;
    }, []);
}
function $04156f3449b439eb$var$buildFocusableOptions(props, selectValue) {
    return $04156f3449b439eb$var$buildFocusableOptionsFromCategorizedOptions($04156f3449b439eb$var$buildCategorizedOptions(props, selectValue));
}
function $04156f3449b439eb$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$04156f3449b439eb$var$shouldHideSelectedOptions(props) || !isSelected) && $04156f3449b439eb$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $04156f3449b439eb$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $04156f3449b439eb$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $04156f3449b439eb$var$getFocusedOptionId = function getFocusedOptionId(focusableOptionsWithIds, focusedOption) {
    var _focusableOptionsWith;
    var focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find(function(option) {
        return option.data === focusedOption;
    })) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
    return focusedOptionId || null;
};
var $04156f3449b439eb$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $04156f3449b439eb$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $04156f3449b439eb$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $04156f3449b439eb$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    var candidate = $04156f3449b439eb$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $04156f3449b439eb$var$getOptionValue(props, i) === candidate;
    });
}
function $04156f3449b439eb$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $04156f3449b439eb$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $04156f3449b439eb$var$instanceId = 1;
var $04156f3449b439eb$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $6c7ef991d1028cee$export$2e2bcd8739ae039)(Select, _Component);
    var _super = (0, $1a0a5e846fa7425c$export$2e2bcd8739ae039)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $cad7451c9e32255d$export$2e2bcd8739ae039)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: '',
            isAppleDevice: false
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $b0015ad11dc7ba35$export$ef35774e6d314e91)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $b0015ad11dc7ba35$export$ef35774e6d314e91)([].concat((0, $aba02085c81f3bc8$export$2e2bcd8739ae039)(selectValue), [
                    newValue
                ])), 'select-option', newValue);
                else _this.setValue((0, $b0015ad11dc7ba35$export$e7094788287c5e9b)(newValue), 'select-option');
            } else {
                _this.ariaOnChange((0, $b0015ad11dc7ba35$export$e7094788287c5e9b)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $b0015ad11dc7ba35$export$96f57966bedc81b4)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $b0015ad11dc7ba35$export$96f57966bedc81b4)(_this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $b0015ad11dc7ba35$export$96f57966bedc81b4)(isMulti, newValueArray, newValueArray[0] || null);
            if (lastSelectedValue) _this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        };
        _this.getFocusedOptionId = function(focusedOption) {
            return $04156f3449b439eb$var$getFocusedOptionId(_this.state.focusableOptionsWithIds, focusedOption);
        };
        _this.getFocusableOptionsWithIds = function() {
            return $04156f3449b439eb$var$buildFocusableOptionsWithIds($04156f3449b439eb$var$buildCategorizedOptions(_this.props, _this.state.selectValue), _this.getElementId('option'));
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $b0015ad11dc7ba35$export$a9c23c6ac3fc3eca).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $04156f3449b439eb$var$getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $04156f3449b439eb$var$getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = $04156f3449b439eb$var$defaultStyles[key](props, unstyled);
            base.boxSizing = 'border-box';
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.state.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $b0015ad11dc7ba35$export$d66501df72047452)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $04156f3449b439eb$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $04156f3449b439eb$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) return;
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') _this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu('first');
            event.preventDefault();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === 'touchend') _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $b0015ad11dc7ba35$export$2329c99376c9d0a4)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === 'function') {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu('first');
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            var options = _this.getFocusableOptions();
            var focusedOptionIndex = options.indexOf(focusedOption);
            _this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? _this.getFocusedOptionId(focusedOption) : null
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $04156f3449b439eb$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) _this.focusOption('up');
                    else _this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) _this.focusOption('down');
                    else _this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    _this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    _this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    _this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    _this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.state.instancePrefix = 'react-select-' + (_this.props.instanceId || ++$04156f3449b439eb$var$instanceId);
        _this.state.selectValue = (0, $b0015ad11dc7ba35$export$7f8ddf7c7c20b3cd)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptionsWithIds = _this.getFocusableOptionsWithIds();
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            _this.state.focusedOption = focusableOptions[optionIndex];
            _this.state.focusedOptionId = $04156f3449b439eb$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
        return _this;
    }
    (0, $bd6fca2392fb7de2$export$2e2bcd8739ae039)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener('scroll', this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $b0015ad11dc7ba35$export$9bb611d729802a56)(this.menuListRef, this.focusedOptionRef);
                if ($04156f3449b439eb$var$isAppleDevice()) // eslint-disable-next-line react/no-did-mount-set-state
                this.setState({
                    isAppleDevice: true
                });
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $b0015ad11dc7ba35$export$9bb611d729802a56)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener('scroll', this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange('', {
                    action: 'menu-close',
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex],
                    focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case 'previous':
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case 'next':
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === 'pageup') {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === 'pagedown') {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === 'last') nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null,
                    focusedOptionId: this.getFocusedOptionId(options[nextFocus])
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return $04156f3449b439eb$export$4368d992c4eafac0;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === 'function') return this.props.theme($04156f3449b439eb$export$4368d992c4eafac0);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)((0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({}, $04156f3449b439eb$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $04156f3449b439eb$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $04156f3449b439eb$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $04156f3449b439eb$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === 'function') {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener('compositionstart', this.onCompositionStart, false);
                    document.addEventListener('compositionend', this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('compositionstart', this.onCompositionStart);
                    document.removeEventListener('compositionend', this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener('touchstart', this.onTouchStart, false);
                    document.addEventListener('touchmove', this.onTouchMove, false);
                    document.addEventListener('touchend', this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('touchstart', this.onTouchStart);
                    document.removeEventListener('touchmove', this.onTouchMove);
                    document.removeEventListener('touchend', this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId('input');
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)((0, $0604ab8b4211d13c$export$2e2bcd8739ae039)((0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({
                    'aria-autocomplete': 'list',
                    'aria-expanded': menuIsOpen,
                    'aria-haspopup': true,
                    'aria-errormessage': this.props['aria-errormessage'],
                    'aria-invalid': this.props['aria-invalid'],
                    'aria-label': this.props['aria-label'],
                    'aria-labelledby': this.props['aria-labelledby'],
                    'aria-required': required,
                    role: 'combobox',
                    'aria-activedescendant': this.state.isAppleDevice ? undefined : this.state.focusedOptionId || ''
                }, menuIsOpen && {
                    'aria-controls': this.getElementId('listbox')
                }), !isSearchable && {
                    'aria-readonly': true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus' && {
                    'aria-describedby': this.getElementId('live-region')
                } : {
                    'aria-describedby': this.getElementId('placeholder')
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ $8v0nu.createElement($04156f3449b439eb$var$DummyInput, (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $b0015ad11dc7ba35$export$b4171a6734a65d42),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ $8v0nu.createElement(Input, (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ $8v0nu.createElement(Placeholder, (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId('placeholder')
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ $8v0nu.createElement(MultiValue, (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, 'value'));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ $8v0nu.createElement(SingleValue, (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, 'value'));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $8v0nu.createElement(ClearIndicator, (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $8v0nu.createElement(LoadingIndicator, (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ $8v0nu.createElement(IndicatorSeparator, (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $8v0nu.createElement(DropdownIndicator, (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId('option'), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1,
                        role: 'option',
                        'aria-selected': _this4.state.isAppleDevice ? undefined : isSelected // is not supported on Apple devices
                    };
                    return /*#__PURE__*/ $8v0nu.createElement(Option, (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, 'menu'));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === 'group') {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId('group'), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ $8v0nu.createElement(Group, (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === 'option') return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ $8v0nu.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ $8v0nu.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ $8v0nu.createElement((0, $b0015ad11dc7ba35$export$3a1a48c8f6ef640e), (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ $8v0nu.createElement(Menu, (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ $8v0nu.createElement($04156f3449b439eb$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ $8v0nu.createElement(MenuList, (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            innerProps: {
                                role: 'listbox',
                                'aria-multiselectable': commonProps.isMulti,
                                id: _this4.getElementId('listbox')
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ $8v0nu.createElement(MenuPortal, (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ $8v0nu.createElement($04156f3449b439eb$var$RequiredInput$1, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ $8v0nu.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ $8v0nu.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ $8v0nu.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ $8v0nu.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                    return /*#__PURE__*/ $8v0nu.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ $8v0nu.createElement($04156f3449b439eb$var$LiveRegion$1, (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({}, commonProps, {
                    id: this.getElementId('live-region'),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions,
                    isAppleDevice: this.state.isAppleDevice
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ $8v0nu.createElement(SelectContainer, (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ $8v0nu.createElement(Control, (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ $8v0nu.createElement(ValueContainer, (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ $8v0nu.createElement(IndicatorsContainer, (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused, instancePrefix = state.instancePrefix;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $b0015ad11dc7ba35$export$7f8ddf7c7c20b3cd)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $04156f3449b439eb$var$buildFocusableOptions(props, selectValue) : [];
                    var focusableOptionsWithIds = menuIsOpen ? $04156f3449b439eb$var$buildFocusableOptionsWithIds($04156f3449b439eb$var$buildCategorizedOptions(props, selectValue), "".concat(instancePrefix, "-option")) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $04156f3449b439eb$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $04156f3449b439eb$var$getNextFocusedOption(state, focusableOptions);
                    var focusedOptionId = $04156f3449b439eb$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedOptionId: focusedOptionId,
                        focusableOptionsWithIds: focusableOptionsWithIds,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $b0015ad11dc7ba35$export$96f57966bedc81b4)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: 'initial-input-focus'
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') newAriaSelection = null;
                return (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)((0, $0604ab8b4211d13c$export$2e2bcd8739ae039)((0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, $8v0nu.Component));
$04156f3449b439eb$export$25ce5a424b770e84.defaultProps = $04156f3449b439eb$export$407448d2b89b1813;

















parcelRequire("k2dbP");


var $3ca06130fd21d224$var$StateManagedSelect = /*#__PURE__*/ (0, $8v0nu.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, $502643e4fe0f2f4b$export$3b14a55fb2447963)(props);
    return /*#__PURE__*/ $8v0nu.createElement((0, $04156f3449b439eb$export$25ce5a424b770e84), (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({
        ref: ref
    }, baseSelectProps));
});
var $3ca06130fd21d224$export$2e2bcd8739ae039 = $3ca06130fd21d224$var$StateManagedSelect;
var $3ca06130fd21d224$export$a7deb1594c5ce10e = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, $8v0nu.useMemo)(function() {
        return (0, $1c8035d6c52d1652$export$2e2bcd8739ae039)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ $8v0nu.createElement((0, $a2100d053ea71e0f$export$e7094788287c5e9b), {
        value: emotionCache
    }, children);
};





var $8v0nu = parcelRequire("8v0nu");

var $8v0nu = parcelRequire("8v0nu");
var $8c3e330d32b9f1f7$var$isPrimitive = function(val) {
    return val !== Object(val);
};
var $8c3e330d32b9f1f7$var$useCustomCompareEffect = function(effect, deps, depsEqual) {
    var ref = (0, $8v0nu.useRef)(undefined);
    if (!ref.current || !depsEqual(deps, ref.current)) ref.current = deps;
    (0, $8v0nu.useEffect)(effect, ref.current);
};
var $8c3e330d32b9f1f7$export$2e2bcd8739ae039 = $8c3e330d32b9f1f7$var$useCustomCompareEffect;


var $7c4e9ac5f6edde4e$exports = {};
'use strict';
// do not edit .js files directly - edit src/index.jst
$7c4e9ac5f6edde4e$exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};


var $7852941372b3df78$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($7c4e9ac5f6edde4e$exports)));


var $e8d4da89a8771ae1$var$isPrimitive = function(val) {
    return val !== Object(val);
};
var $e8d4da89a8771ae1$var$useDeepCompareEffect = function(effect, deps) {
    (0, $8c3e330d32b9f1f7$export$2e2bcd8739ae039)(effect, deps, (0, $7852941372b3df78$export$2e2bcd8739ae039));
};
var $e8d4da89a8771ae1$export$2e2bcd8739ae039 = $e8d4da89a8771ae1$var$useDeepCompareEffect;


const $b250f793f6b3703c$export$ae66a4a39529a5d9 = (props)=>{
    const [renderKey, setSenderKey] = (0, $8v0nu.useState)(-1);
    (0, $e8d4da89a8771ae1$export$2e2bcd8739ae039)(()=>{
        setSenderKey((v)=>v + 1);
    }, props);
    return `key-${Math.max(0, renderKey)}`;
};


function $4e9a8f866a5de52c$export$a42fc98e48605119(props) {
    const { field: field } = props;
    const isMulti = field.type === 'array';
    if (isMulti ? !field.items?.enum?.length : !field.enum?.length) throw new Error('WidgetSelect: enum is required');
    if (isMulti ? field.items.allowOther : field.allowOther) throw new Error("WidgetSelect: allowOther is not supported. Use widget 'tagger' instead");
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)($4e9a8f866a5de52c$var$WidgetSelectInner, {
        ...props
    });
}
function $4e9a8f866a5de52c$var$WidgetSelectInner(props) {
    const { pointer: pointer, isRequired: isRequired, field: field } = props;
    const isMulti = field.type === 'array';
    const key = (0, $b250f793f6b3703c$export$ae66a4a39529a5d9)([
        pointer,
        isRequired,
        isMulti,
        field
    ]);
    // Shared between Field.Root (whose label htmlFor points at the field id)
    // and react-select's input, so clicking the label focuses the control.
    const inputId = (0, $8v0nu.useId)();
    const options = (0, $8v0nu.useMemo)(()=>{
        const enums = isMulti ? field.items?.enum : field.enum;
        return enums.map(([value, label])=>({
                value: value,
                label: label
            }));
    }, [
        field
    ]);
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $jTKGQ.FastField), {
        name: pointer,
        children: ({ field: { name: name, value: value }, meta: meta, form: { setFieldValue: setFieldValue } })=>{
            const selectedOpts = options.filter((option)=>(0, $81cc9f2a42ee34ee$export$ff8cd4c6525ea2f6)(value).includes(option.value));
            return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $5e0ca4edd90668b0$exports).Root, {
                id: inputId,
                required: isRequired,
                invalid: !!(meta.touched && meta.error),
                children: [
                    field.label && /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $5e0ca4edd90668b0$exports).Label, {
                        children: [
                            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $8f2967926209c75b$export$1acdcf5a973a8414), {
                                size: "xs",
                                children: field.label
                            }),
                            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $5e0ca4edd90668b0$exports).RequiredIndicator, {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $3ca06130fd21d224$export$2e2bcd8739ae039), {
                        inputId: inputId,
                        name: name,
                        options: options,
                        isMulti: isMulti,
                        isClearable: !isRequired,
                        onChange: (option)=>{
                            if (option) setFieldValue(name, isMulti ? option.map((o)=>o.value) : option.value);
                            else setFieldValue(name, isMulti ? [] : undefined);
                        },
                        value: selectedOpts
                    }),
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $5e0ca4edd90668b0$exports).ErrorText, {
                        children: meta.error
                    })
                ]
            });
        }
    }, key);
}





var $8v0nu = parcelRequire("8v0nu");

"use strict";
"use client";
const { withContext: $34439ca3d963b033$var$withContext, PropsProvider: $34439ca3d963b033$var$PropsProvider } = (0, $aa5f4d03028a5427$export$e99ac154c18649c5)({
    key: "kbd"
});
const $34439ca3d963b033$export$5e66ad77b1eb2956 = $34439ca3d963b033$var$withContext("kbd");
const $34439ca3d963b033$export$745952e2499a20bf = $34439ca3d963b033$var$PropsProvider;



var $jTKGQ = parcelRequire("jTKGQ");


var $8v0nu = parcelRequire("8v0nu");






var $8v0nu = parcelRequire("8v0nu");


var $9b441a488a7ad306$var$_excluded = [
    "allowCreateWhileLoading",
    "createOptionPosition",
    "formatCreateLabel",
    "isValidNewOption",
    "getNewOptionData",
    "onCreateOption",
    "options",
    "onChange"
];
var $9b441a488a7ad306$var$compareOption = function compareOption() {
    var inputValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var option = arguments.length > 1 ? arguments[1] : undefined;
    var accessors = arguments.length > 2 ? arguments[2] : undefined;
    var candidate = String(inputValue).toLowerCase();
    var optionValue = String(accessors.getOptionValue(option)).toLowerCase();
    var optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
    return optionValue === candidate || optionLabel === candidate;
};
var $9b441a488a7ad306$var$builtins = {
    formatCreateLabel: function formatCreateLabel(inputValue) {
        return "Create \"".concat(inputValue, "\"");
    },
    isValidNewOption: function isValidNewOption(inputValue, selectValue, selectOptions, accessors) {
        return !(!inputValue || selectValue.some(function(option) {
            return $9b441a488a7ad306$var$compareOption(inputValue, option, accessors);
        }) || selectOptions.some(function(option) {
            return $9b441a488a7ad306$var$compareOption(inputValue, option, accessors);
        }));
    },
    getNewOptionData: function getNewOptionData(inputValue, optionLabel) {
        return {
            label: optionLabel,
            value: inputValue,
            __isNew__: true
        };
    }
};
function $9b441a488a7ad306$export$3b14a55fb2447963(_ref) {
    var _ref$allowCreateWhile = _ref.allowCreateWhileLoading, allowCreateWhileLoading = _ref$allowCreateWhile === void 0 ? false : _ref$allowCreateWhile, _ref$createOptionPosi = _ref.createOptionPosition, createOptionPosition = _ref$createOptionPosi === void 0 ? 'last' : _ref$createOptionPosi, _ref$formatCreateLabe = _ref.formatCreateLabel, formatCreateLabel = _ref$formatCreateLabe === void 0 ? $9b441a488a7ad306$var$builtins.formatCreateLabel : _ref$formatCreateLabe, _ref$isValidNewOption = _ref.isValidNewOption, isValidNewOption = _ref$isValidNewOption === void 0 ? $9b441a488a7ad306$var$builtins.isValidNewOption : _ref$isValidNewOption, _ref$getNewOptionData = _ref.getNewOptionData, getNewOptionData = _ref$getNewOptionData === void 0 ? $9b441a488a7ad306$var$builtins.getNewOptionData : _ref$getNewOptionData, onCreateOption = _ref.onCreateOption, _ref$options = _ref.options, propsOptions = _ref$options === void 0 ? [] : _ref$options, propsOnChange = _ref.onChange, restSelectProps = (0, $a69ac13ab3c3f3dd$export$2e2bcd8739ae039)(_ref, $9b441a488a7ad306$var$_excluded);
    var _restSelectProps$getO = restSelectProps.getOptionValue, getOptionValue$1 = _restSelectProps$getO === void 0 ? (0, $04156f3449b439eb$export$39b482c5e57630a8) : _restSelectProps$getO, _restSelectProps$getO2 = restSelectProps.getOptionLabel, getOptionLabel$1 = _restSelectProps$getO2 === void 0 ? (0, $04156f3449b439eb$export$8b22cf2602fb60ce) : _restSelectProps$getO2, inputValue = restSelectProps.inputValue, isLoading = restSelectProps.isLoading, isMulti = restSelectProps.isMulti, value = restSelectProps.value, name = restSelectProps.name;
    var newOption = (0, $8v0nu.useMemo)(function() {
        return isValidNewOption(inputValue, (0, $b0015ad11dc7ba35$export$7f8ddf7c7c20b3cd)(value), propsOptions, {
            getOptionValue: getOptionValue$1,
            getOptionLabel: getOptionLabel$1
        }) ? getNewOptionData(inputValue, formatCreateLabel(inputValue)) : undefined;
    }, [
        formatCreateLabel,
        getNewOptionData,
        getOptionLabel$1,
        getOptionValue$1,
        inputValue,
        isValidNewOption,
        propsOptions,
        value
    ]);
    var options = (0, $8v0nu.useMemo)(function() {
        return (allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [
            newOption
        ].concat((0, $aba02085c81f3bc8$export$2e2bcd8739ae039)(propsOptions)) : [].concat((0, $aba02085c81f3bc8$export$2e2bcd8739ae039)(propsOptions), [
            newOption
        ]) : propsOptions;
    }, [
        allowCreateWhileLoading,
        createOptionPosition,
        isLoading,
        newOption,
        propsOptions
    ]);
    var onChange = (0, $8v0nu.useCallback)(function(newValue, actionMeta) {
        if (actionMeta.action !== 'select-option') return propsOnChange(newValue, actionMeta);
        var valueArray = Array.isArray(newValue) ? newValue : [
            newValue
        ];
        if (valueArray[valueArray.length - 1] === newOption) {
            if (onCreateOption) onCreateOption(inputValue);
            else {
                var newOptionData = getNewOptionData(inputValue, inputValue);
                var newActionMeta = {
                    action: 'create-option',
                    name: name,
                    option: newOptionData
                };
                propsOnChange((0, $b0015ad11dc7ba35$export$96f57966bedc81b4)(isMulti, [].concat((0, $aba02085c81f3bc8$export$2e2bcd8739ae039)((0, $b0015ad11dc7ba35$export$7f8ddf7c7c20b3cd)(value)), [
                    newOptionData
                ]), newOptionData), newActionMeta);
            }
            return;
        }
        propsOnChange(newValue, actionMeta);
    }, [
        getNewOptionData,
        inputValue,
        isMulti,
        name,
        newOption,
        onCreateOption,
        propsOnChange,
        value
    ]);
    return (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)((0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({}, restSelectProps), {}, {
        options: options,
        onChange: onChange
    });
}















parcelRequire("k2dbP");



var $32cb2715631b50e8$var$CreatableSelect = /*#__PURE__*/ (0, $8v0nu.forwardRef)(function(props, ref) {
    var creatableProps = (0, $502643e4fe0f2f4b$export$3b14a55fb2447963)(props);
    var selectProps = (0, $9b441a488a7ad306$export$3b14a55fb2447963)(creatableProps);
    return /*#__PURE__*/ $8v0nu.createElement((0, $04156f3449b439eb$export$25ce5a424b770e84), (0, $1fcc864778fe3a17$export$2e2bcd8739ae039)({
        ref: ref
    }, selectProps));
});
var $32cb2715631b50e8$export$2e2bcd8739ae039 = $32cb2715631b50e8$var$CreatableSelect;




const $46645db2fc870d87$var$createOption = (label)=>({
        label: label,
        value: label
    });
const $46645db2fc870d87$var$onTabOrEnter = (cb)=>(event)=>{
        switch(event.key){
            case 'Enter':
            case 'Tab':
                cb(event);
        }
    };
function $46645db2fc870d87$export$20cd3f91cc937f5(props) {
    const { field: field } = props;
    if (field.type === 'string') {
        if (!field.enum) throw new Error("WidgetTagger: 'enum' is required when type is 'string'");
        if (field.allowOther?.type !== 'string') throw new Error("WidgetTagger: 'allowOther.type' is required for the 'tagger' widget with 'enum' options. Use the 'select' widget instead.");
        return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)($46645db2fc870d87$var$WidgetTaggerWithOptions, {
            ...props
        });
    }
    if (field.type === 'array') {
        if (field.items.type !== 'string') throw new Error("WidgetTagger: 'items.type' must be 'string' when type is 'array'");
        if (field.items.enum) {
            if (field.items.allowOther?.type !== 'string') throw new Error("WidgetTagger: 'items.allowOther.type' is required for the 'tagger' widget with 'enum' options. Use the 'select' widget instead.");
            return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)($46645db2fc870d87$var$WidgetTaggerWithOptions, {
                ...props,
                isMulti: true
            });
        }
        return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)($46645db2fc870d87$var$WidgetTaggerNoOptions, {
            ...props
        });
    }
    throw new Error(`WidgetTagger: Field type must be 'string' or 'array'. Got: ${field.type}`);
}
/******************************************************************************/ /*                                                                            */ /*                  N O   O P T I O N S   C O M P O N E N T                   */ /*    with CreatableSelect is in a separate component because of FastField    */ /*                                                                            */ /*  Tagger with no options to choose from. The user can only create new ones  */ /*                                                                            */ /******************************************************************************/ function $46645db2fc870d87$var$WidgetTaggerNoOptions(props) {
    const { pointer: pointer, isRequired: isRequired, field: field } = props;
    const key = (0, $b250f793f6b3703c$export$ae66a4a39529a5d9)([
        pointer,
        isRequired,
        field
    ]);
    // Shared between Field.Root (whose label htmlFor points at the field id)
    // and react-select's input, so clicking the label focuses the control.
    const inputId = (0, $8v0nu.useId)();
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $jTKGQ.FastField), {
        name: pointer,
        children: ({ field: { value: value, name: name }, meta: meta, form: { setFieldValue: setFieldValue } })=>/*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $5e0ca4edd90668b0$exports).Root, {
                id: inputId,
                required: isRequired,
                invalid: !!(meta.touched && meta.error),
                children: [
                    field.label && /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $5e0ca4edd90668b0$exports).Label, {
                        children: [
                            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $8f2967926209c75b$export$1acdcf5a973a8414), {
                                size: "xs",
                                children: field.label
                            }),
                            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $5e0ca4edd90668b0$exports).RequiredIndicator, {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)($46645db2fc870d87$var$WidgetTaggerNoOptionsSelect, {
                        pointer: pointer,
                        inputId: inputId,
                        value: value,
                        onChange: (v)=>setFieldValue(name, v)
                    }),
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $5e0ca4edd90668b0$exports).ErrorText, {
                        children: meta.error
                    })
                ]
            })
    }, key);
}
const $46645db2fc870d87$var$components = {
    DropdownIndicator: null
};
function $46645db2fc870d87$var$WidgetTaggerNoOptionsSelect(props) {
    const { value: value, onChange: onChange, pointer: pointer, inputId: inputId } = props;
    const [inputValue, setInputValue] = (0, $8v0nu.useState)('');
    const selectedValues = Array.isArray(value) ? value.map($46645db2fc870d87$var$createOption) : [];
    const handleKeyDown = $46645db2fc870d87$var$onTabOrEnter((event)=>{
        if (!inputValue) return;
        if (!value.includes(inputValue)) onChange([
            ...value,
            inputValue
        ]);
        setInputValue('');
        event.preventDefault();
    });
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $32cb2715631b50e8$export$2e2bcd8739ae039), {
        inputId: inputId,
        name: pointer,
        components: $46645db2fc870d87$var$components,
        inputValue: inputValue,
        isClearable: true,
        isMulti: true,
        menuIsOpen: false,
        onChange: (newValue)=>{
            onChange(newValue.map((option)=>option.value));
        },
        onInputChange: (newValue)=>setInputValue(newValue),
        onKeyDown: handleKeyDown,
        placeholder: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8v0nu))).Fragment, {
            children: [
                "Type & ",
                /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $34439ca3d963b033$export$5e66ad77b1eb2956), {
                    children: "enter"
                }),
                " to add options"
            ]
        }),
        value: selectedValues
    });
}
/******************************************************************************/ /*                                                                            */ /*                     O P T I O N S   C O M P O N E N T                      */ /*    with CreatableSelect is in a separate component because of FastField    */ /*                                                                            */ /*  Tagger with options to choose from as well as the option to create        */ /*  new ones.                                                                 */ /*                                                                            */ /******************************************************************************/ function $46645db2fc870d87$var$WidgetTaggerWithOptions(props) {
    const { pointer: pointer, isRequired: isRequired, isMulti: isMulti, field: field } = props;
    const key = (0, $b250f793f6b3703c$export$ae66a4a39529a5d9)([
        pointer,
        isRequired,
        isMulti,
        field
    ]);
    // Shared between Field.Root (whose label htmlFor points at the field id)
    // and react-select's input, so clicking the label focuses the control.
    const inputId = (0, $8v0nu.useId)();
    const options = (0, $8v0nu.useMemo)(()=>{
        const enums = isMulti ? field.items.enum : field.enum;
        return enums.map(([value, label])=>({
                value: value,
                label: label
            }));
    }, [
        field
    ]);
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $jTKGQ.FastField), {
        name: pointer,
        children: ({ field: { name: name, value: value }, meta: meta, form: { setFieldValue: setFieldValue } })=>/*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $5e0ca4edd90668b0$exports).Root, {
                id: inputId,
                required: isRequired,
                invalid: !!(meta.touched && meta.error),
                children: [
                    field.label && /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $5e0ca4edd90668b0$exports).Label, {
                        children: [
                            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $8f2967926209c75b$export$1acdcf5a973a8414), {
                                size: "xs",
                                children: field.label
                            }),
                            /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $5e0ca4edd90668b0$exports).RequiredIndicator, {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)($46645db2fc870d87$var$WidgetTaggerWithOptionsSelect, {
                        pointer: pointer,
                        inputId: inputId,
                        isMulti: !!isMulti,
                        value: value,
                        onChange: (v)=>setFieldValue(name, v),
                        options: options
                    }),
                    /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $5e0ca4edd90668b0$exports).ErrorText, {
                        children: meta.error
                    })
                ]
            })
    }, key);
}
function $46645db2fc870d87$var$WidgetTaggerWithOptionsSelect(props) {
    const { isMulti: isMulti, onChange: onChange, value: value, options: options, pointer: pointer, inputId: inputId } = props;
    const [inputValue, setInputValue] = (0, $8v0nu.useState)('');
    const selectedValues = value ? isMulti ? value.map($46645db2fc870d87$var$createOption) : $46645db2fc870d87$var$createOption(value) : isMulti ? [] : undefined;
    const handleKeyDown = $46645db2fc870d87$var$onTabOrEnter((event)=>{
        if (!inputValue) return;
        if (value.includes(inputValue)) {
            setInputValue('');
            event.preventDefault();
        }
    });
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $32cb2715631b50e8$export$2e2bcd8739ae039), {
        inputId: inputId,
        name: pointer,
        inputValue: inputValue,
        isClearable: true,
        isMulti: isMulti,
        onChange: (newValue)=>{
            if (isMulti) onChange((newValue || []).map((option)=>option.value));
            else onChange(newValue?.value);
        },
        onInputChange: (newValue)=>setInputValue(newValue),
        onKeyDown: handleKeyDown,
        options: options,
        placeholder: "Select or type to add",
        value: selectedValues
    });
}


const $ac885aba5ffedc46$export$41be205aae9631a4 = (0, $aa58e4af7634fac0$export$afcbd3cdfffb6e7c)({
    'ui:widget': {
        object: (0, $0fcc824096db126c$export$fc949cf2e017c75f),
        'object:fieldset': (0, $b10f7d2a328f4eb8$export$a9edb623e575de0d),
        text: (0, $17485d2c0739238f$export$b63d030f4611938c),
        number: (0, $c0c33d699328ac6c$export$7833621d74bfe8fb),
        radio: (0, $d8f83a902ec18287$export$578a0ba473f83a10),
        checkbox: (0, $6369dd324fce8d1d$export$7125ae6e0d206208),
        select: (0, $4e9a8f866a5de52c$export$a42fc98e48605119),
        tagger: (0, $46645db2fc870d87$export$20cd3f91cc937f5),
        array: (0, $a19b114acf696fe3$export$a7e262ad5a444678),
        'array:string': (0, $a3347928c80810e5$export$9436aa8cdadea878),
        json: (0, $5d31050dffea9ad7$export$28f0f0b6ca7da3eb)
    }
});




function $cec627a8235eede2$export$9558ee0e4173beb4(condition, id, ifTrue, ifFalse) {
    return condition ? {
        [id]: ifTrue
    } : ifFalse ? {
        [id]: ifFalse
    } : {};
}
function $cec627a8235eede2$export$daa8453c5457a43f(v) {
    if (Array.isArray(v)) return v.map($cec627a8235eede2$export$daa8453c5457a43f);
    return v === '' ? null : v;
}
function $cec627a8235eede2$export$4a3dd5ab3487d8b5(v) {
    if (Array.isArray(v)) return v.map($cec627a8235eede2$export$4a3dd5ab3487d8b5);
    return v === null ? '' : v;
}
function $cec627a8235eede2$export$1f4191cf9967a565(stack, keyName, each = (v)=>v) {
    return Object.entries(stack || {}).map(([key, value])=>{
        return {
            [keyName]: key,
            ...each(value)
        };
    });
}
function $cec627a8235eede2$export$f91e2d43f34fbadd(stack) {
    return Object.entries(stack || {}).map(([key, value])=>[
            key
        ].concat(value));
}
function $cec627a8235eede2$export$916f5f00d1f59607(stack, keyName, each = (v)=>v) {
    return (stack || []).reduce((acc, item)=>{
        const newItem = {
            ...item
        };
        delete newItem[keyName];
        return {
            ...acc,
            [item[keyName]]: each(newItem)
        };
    }, {});
}
function $cec627a8235eede2$export$9ad71af9b9b65995(stack) {
    return (stack || []).reduce((acc, [key, item])=>{
        return {
            ...acc,
            [key]: item
        };
    }, {});
}
function $cec627a8235eede2$export$7344ca394fcf1a58(data, extension, version) {
    const regex = new RegExp(`/${extension}/v([0-9.]+)/schema.json`);
    return data?.stac_extensions?.some((ext)=>{
        const match = ext.match(regex);
        return match && (!version || version(match[1]));
    });
}
function $cec627a8235eede2$export$66c404fc598e0f86($this, label, value) {
    // Quick way to get the name.
    const name = new (0, $6b77bd4fc5b65248$export$e620499b4783e2c1)().name;
    $this.registerHook(name, 'onAfterEditSchema', (pl, formData, schema)=>{
        if (!schema || typeof schema === 'symbol') return schema;
        const stac_extensions = schema.properties.stac_extensions;
        // Set the new extension value in the schema.
        stac_extensions.items.enum.push([
            value,
            label
        ]);
        return schema;
    });
}


class $6b77bd4fc5b65248$export$e620499b4783e2c1 extends (0, $c0a25ef586f9da64$export$901cf72dabf2112a) {
    name = 'CollectionsCore';
    isNew = false;
    hasInitialized = false;
    async init(data) {
        // `init` is invoked every time the form's data changes (e.g. when toggling
        // between the form and JSON views), so we can't unconditionally derive
        // `isNew` from the current data — once the user has typed an id, the data
        // will have one even on a "new" collection, which would otherwise hide the
        // id field on the next render. Lock it in on the first call.
        if (this.hasInitialized) return;
        this.hasInitialized = true;
        this.isNew = !data?.id;
    }
    editSchema() {
        return {
            type: 'root',
            required: [
                'id',
                'description',
                'license',
                'spatial',
                'temporal',
                'links'
            ],
            properties: {
                ...(0, $cec627a8235eede2$export$9558ee0e4173beb4)(this.isNew, 'id', {
                    label: 'Collection ID',
                    type: 'string'
                }),
                title: {
                    label: 'Title',
                    type: 'string'
                },
                description: {
                    label: 'Description',
                    type: 'string'
                },
                keywords: {
                    type: 'array',
                    label: 'Keywords',
                    'ui:widget': 'tagger',
                    items: {
                        label: 'Keyword',
                        type: 'string'
                    }
                },
                license: {
                    label: 'License',
                    type: 'string',
                    'ui:widget': 'tagger',
                    allowOther: {
                        type: 'string'
                    },
                    enum: [
                        [
                            'Apache-2.0',
                            'Apache License 2.0'
                        ],
                        [
                            'MIT',
                            'MIT License'
                        ],
                        [
                            'GPL-3.0',
                            'GNU General Public License v3.0'
                        ],
                        [
                            'BSD-3-Clause',
                            'BSD 3-Clause License'
                        ],
                        [
                            'MPL-2.0',
                            'Mozilla Public License 2.0'
                        ]
                    ]
                },
                providers: {
                    type: 'array',
                    label: 'Providers',
                    items: {
                        type: 'object',
                        required: [
                            'name'
                        ],
                        properties: {
                            name: {
                                label: 'Name',
                                type: 'string'
                            },
                            roles: {
                                label: 'Roles',
                                type: 'array',
                                items: {
                                    label: 'Role',
                                    type: 'string',
                                    enum: [
                                        [
                                            'licensor',
                                            'Licensor'
                                        ],
                                        [
                                            'producer',
                                            'Producer'
                                        ],
                                        [
                                            'processor',
                                            'Processor'
                                        ],
                                        [
                                            'host',
                                            'Host'
                                        ]
                                    ]
                                }
                            },
                            url: {
                                label: 'URL',
                                type: 'string'
                            }
                        }
                    }
                },
                stac_extensions: {
                    type: 'array',
                    label: 'STAC Extensions',
                    'ui:widget': 'tagger',
                    items: {
                        type: 'string',
                        allowOther: {
                            type: 'string'
                        },
                        enum: []
                    }
                },
                spatial: {
                    label: 'Spatial Extent',
                    type: 'array',
                    minItems: 1,
                    items: {
                        type: 'array',
                        label: 'Extent',
                        minItems: 4,
                        maxItems: 4,
                        items: {
                            label: [
                                'Min Longitude',
                                'Min Latitude',
                                'Max Longitude',
                                'Max Latitude'
                            ],
                            type: 'number'
                        }
                    }
                },
                temporal: {
                    label: 'Temporal Extent',
                    type: 'array',
                    minItems: 1,
                    items: {
                        type: 'array',
                        label: 'Extent',
                        minItems: 2,
                        maxItems: 2,
                        items: {
                            label: [
                                'Start',
                                'End'
                            ],
                            type: 'string'
                        }
                    }
                },
                links: {
                    type: 'array',
                    label: 'Links',
                    minItems: 1,
                    items: {
                        type: 'object',
                        required: [
                            'rel',
                            'href',
                            'type'
                        ],
                        properties: {
                            href: {
                                label: 'URL',
                                type: 'string'
                            },
                            rel: {
                                label: 'Relation',
                                type: 'string'
                            },
                            type: {
                                label: 'Type',
                                type: 'string',
                                'ui:widget': 'select',
                                enum: [
                                    [
                                        'application/geo+json',
                                        'geo+json'
                                    ],
                                    [
                                        'application/geopackage+sqlite3',
                                        'geopackage+sqlite3'
                                    ],
                                    [
                                        'application/json',
                                        'json'
                                    ],
                                    [
                                        'application/schema+json',
                                        'schema+json'
                                    ],
                                    [
                                        'application/vnd.google-earth.kml+xml',
                                        'vnd.google-earth.kml+xml'
                                    ],
                                    [
                                        'application/vnd.google-earth.kmz',
                                        'vnd.google-earth.kmz'
                                    ],
                                    [
                                        'application/vnd.oai.openapi+json;version=3.0',
                                        'vnd.oai.openapi+json;version=3.0'
                                    ],
                                    [
                                        'application/x-hdf',
                                        'x-hdf'
                                    ],
                                    [
                                        'application/x-hdf5',
                                        'x-hdf5'
                                    ],
                                    [
                                        'application/xml',
                                        'xml'
                                    ],
                                    [
                                        'image/jp2',
                                        'jp2'
                                    ],
                                    [
                                        'image/jpeg',
                                        'jpeg'
                                    ],
                                    [
                                        'image/png',
                                        'png'
                                    ],
                                    [
                                        'image/tiff; application=geotiff; profile=cloud-optimized',
                                        'COG'
                                    ],
                                    [
                                        'image/tiff; application=geotiff',
                                        'Geotiff'
                                    ],
                                    [
                                        'text/html',
                                        'HTML'
                                    ],
                                    [
                                        'text/plain',
                                        'Text'
                                    ]
                                ]
                            },
                            title: {
                                label: 'Title',
                                type: 'string'
                            }
                        }
                    }
                },
                thumbnail: {
                    type: 'object',
                    'ui:widget': 'object:fieldset',
                    label: 'Thumbnail',
                    properties: {
                        title: {
                            label: 'Title',
                            type: 'string'
                        },
                        href: {
                            label: 'Href',
                            type: 'string'
                        }
                    }
                },
                assets: {
                    type: 'array',
                    label: 'Assets',
                    items: {
                        type: 'object',
                        required: [
                            'id',
                            'href'
                        ],
                        properties: {
                            id: {
                                label: 'Id',
                                type: 'string'
                            },
                            href: {
                                label: 'Href',
                                type: 'string'
                            },
                            title: {
                                label: 'Title',
                                type: 'string'
                            },
                            description: {
                                label: 'Description',
                                type: 'string'
                            },
                            type: {
                                label: 'Type',
                                type: 'string'
                            },
                            roles: {
                                label: 'Roles',
                                type: 'array',
                                items: {
                                    label: 'Role',
                                    type: 'string'
                                }
                            }
                        }
                    }
                },
                summaries: {
                    type: 'json',
                    label: 'Summaries'
                }
            }
        };
    }
    enterData(data = {}) {
        return {
            id: data?.id,
            title: data?.title,
            description: data?.description,
            keywords: data?.keywords || [],
            license: data?.license,
            providers: data?.providers || [],
            stac_extensions: data?.stac_extensions,
            spatial: data?.extent?.spatial.bbox || [],
            temporal: data?.extent?.temporal.interval.map((0, $cec627a8235eede2$export$4a3dd5ab3487d8b5)) || [],
            links: data?.links || [],
            thumbnail: {
                title: data?.assets?.thumbnail?.title || '',
                href: data?.assets?.thumbnail?.href || ''
            },
            assets: Object.entries(data?.assets || {}).map(([key, value])=>({
                    id: key,
                    ...value
                })),
            summaries: data?.summaries || {}
        };
    }
    exitData(data) {
        const thumbnail = data.thumbnail.title ? {
            thumbnail: {
                href: data.thumbnail.href,
                title: data.thumbnail.title,
                roles: [
                    'thumbnail'
                ],
                type: data.thumbnail.href.match(/\.jpe?g$/) ? 'image/jpeg' : 'image/png'
            }
        } : {};
        return {
            type: 'Collection',
            stac_version: '1.0.0',
            id: data.id,
            title: data.title,
            description: data.description,
            keywords: data.keywords,
            license: data.license,
            providers: data.providers,
            stac_extensions: data.stac_extensions,
            extent: {
                spatial: {
                    bbox: data.spatial
                },
                temporal: {
                    interval: data.temporal.map((0, $cec627a8235eede2$export$daa8453c5457a43f))
                }
            },
            links: data.links,
            assets: data.assets.reduce((acc, asset)=>{
                return {
                    ...acc,
                    [asset.id]: asset
                };
            }, {
                ...thumbnail
            }),
            summaries: data.summaries
        };
    }
}



class $97855730a133c737$export$8708d1ece48244f6 extends (0, $c0a25ef586f9da64$export$901cf72dabf2112a) {
    name = 'Item Assets Extension';
    constructor(){
        super();
        (0, $cec627a8235eede2$export$66c404fc598e0f86)(this, 'Item Assets Definition', 'https://stac-extensions.github.io/item-assets/v1.0.0/schema.json');
    }
    editSchema(data) {
        if (!(0, $cec627a8235eede2$export$7344ca394fcf1a58)(data, 'item-assets')) return (0, $c0a25ef586f9da64$export$901cf72dabf2112a).HIDDEN;
        return {
            type: 'root',
            properties: {
                item_assets: {
                    type: 'array',
                    label: 'Item Assets',
                    minItems: 1,
                    items: {
                        type: 'object',
                        required: [
                            'id'
                        ],
                        properties: {
                            id: {
                                label: 'Item Asset ID',
                                type: 'string'
                            },
                            type: {
                                label: 'Type',
                                type: 'string'
                            },
                            title: {
                                label: 'Title',
                                type: 'string'
                            },
                            description: {
                                label: 'Description',
                                type: 'string'
                            },
                            roles: {
                                label: 'Roles',
                                type: 'array',
                                'ui:widget': 'tagger',
                                items: {
                                    label: 'Role',
                                    type: 'string',
                                    enum: [
                                        [
                                            'thumbnail',
                                            'Thumbnail'
                                        ],
                                        [
                                            'overview',
                                            'Overview'
                                        ],
                                        [
                                            'data',
                                            'Data'
                                        ],
                                        [
                                            'metadata',
                                            'Metadata'
                                        ]
                                    ]
                                }
                            }
                        }
                    }
                }
            }
        };
    }
    enterData(data = {}) {
        return {
            item_assets: (0, $cec627a8235eede2$export$1f4191cf9967a565)(data.item_assets, 'id')
        };
    }
    exitData(data) {
        return {
            item_assets: (0, $cec627a8235eede2$export$916f5f00d1f59607)(data.item_assets, 'id')
        };
    }
}



class $ee9b29702898ba23$export$c6379ecf8f55f1e4 extends (0, $c0a25ef586f9da64$export$901cf72dabf2112a) {
    name = 'Render Extension';
    constructor(){
        super();
        (0, $cec627a8235eede2$export$66c404fc598e0f86)(this, 'Render', 'https://stac-extensions.github.io/render/v2.0.0/schema.json');
    }
    editSchema(data) {
        if (!(0, $cec627a8235eede2$export$7344ca394fcf1a58)(data, 'render')) return (0, $c0a25ef586f9da64$export$901cf72dabf2112a).HIDDEN;
        return {
            type: 'root',
            properties: {
                renders: {
                    type: 'array',
                    label: 'Renders',
                    items: {
                        type: 'object',
                        required: [
                            'id',
                            'assets'
                        ],
                        additionalProperties: true,
                        properties: {
                            id: {
                                label: 'Render ID',
                                type: 'string'
                            },
                            assets: {
                                type: 'array',
                                label: 'Assets',
                                minItems: 1,
                                items: {
                                    type: 'string'
                                }
                            },
                            rescale: {
                                type: 'array',
                                label: 'Rescale',
                                items: {
                                    type: 'array',
                                    minItems: 2,
                                    maxItems: 2,
                                    items: {
                                        type: 'number',
                                        label: [
                                            'Min',
                                            'Max'
                                        ]
                                    }
                                }
                            },
                            nodata: {
                                label: 'No Data Value',
                                type: 'string'
                            },
                            colormap_name: {
                                label: 'Colormap',
                                type: 'string',
                                'ui:widget': 'tagger',
                                allowOther: {
                                    type: 'string'
                                },
                                enum: $ee9b29702898ba23$var$colorMaps
                            },
                            colormap: {
                                type: 'array',
                                label: 'Colormap (Custom)',
                                items: {
                                    type: 'array',
                                    minItems: 2,
                                    maxItems: 2,
                                    items: {
                                        type: 'string',
                                        label: [
                                            'Value',
                                            'Color'
                                        ]
                                    }
                                }
                            },
                            resampling: {
                                label: 'Resampling',
                                type: 'string',
                                'ui:widget': 'tagger',
                                allowOther: {
                                    type: 'string'
                                },
                                enum: [
                                    [
                                        'near',
                                        'Nearest neighbour'
                                    ],
                                    [
                                        'bilinear',
                                        'Bilinear'
                                    ],
                                    [
                                        'cubic',
                                        'Cubic'
                                    ],
                                    [
                                        'cubicspline',
                                        'Cubic spline'
                                    ],
                                    [
                                        'lanczos',
                                        'Lanczos windowed sinc'
                                    ],
                                    [
                                        'average',
                                        'Average'
                                    ],
                                    [
                                        'rms',
                                        'Root mean square'
                                    ],
                                    [
                                        'mode',
                                        'Mode'
                                    ],
                                    [
                                        'max',
                                        'Maximum'
                                    ],
                                    [
                                        'min',
                                        'Minimum'
                                    ],
                                    [
                                        'med',
                                        'Median'
                                    ],
                                    [
                                        'q1',
                                        'First quartile'
                                    ],
                                    [
                                        'q3',
                                        'Third quartile'
                                    ],
                                    [
                                        'sum',
                                        'Weighted sum'
                                    ]
                                ]
                            },
                            expression: {
                                label: 'Expression',
                                type: 'string'
                            },
                            minmax_zoom: {
                                type: 'array',
                                label: 'Min/Max Zoom',
                                minItems: 2,
                                maxItems: 2,
                                items: {
                                    type: 'number',
                                    label: [
                                        'Min',
                                        'Max'
                                    ]
                                }
                            }
                        }
                    }
                }
            }
        };
    }
    enterData(data = {}) {
        return {
            renders: (0, $cec627a8235eede2$export$1f4191cf9967a565)(data.renders, 'id', (v)=>({
                    ...v,
                    colormap: (0, $cec627a8235eede2$export$f91e2d43f34fbadd)(v.colormap)
                }))
        };
    }
    exitData(data) {
        return {
            renders: (0, $cec627a8235eede2$export$916f5f00d1f59607)(data.renders, 'id', (v)=>({
                    ...v,
                    colormap: (0, $cec627a8235eede2$export$9ad71af9b9b65995)(v.colormap)
                }))
        };
    }
}
const $ee9b29702898ba23$var$colorMaps = [
    'dense_r',
    'turbid',
    'rdbu',
    'ice',
    'purd_r',
    'bugn',
    'bone',
    'plasma_r',
    'gist_yarg',
    'rdpu_r',
    'afmhot_r',
    'plasma',
    'amp_r',
    'piyg_r',
    'ylorbr',
    'phase_r',
    'matter_r',
    'pastel1',
    'inferno_r',
    'purd',
    'paired',
    'thermal',
    'gist_heat_r',
    'greens_r',
    'summer',
    'terrain',
    'gist_earth_r',
    'gnbu',
    'topo_r',
    'algae_r',
    'gist_heat',
    'puor_r',
    'wistia_r',
    'speed',
    'gist_gray',
    'cubehelix_r',
    'brbg',
    'haline_r',
    'ylgnbu',
    'algae',
    'thermal_r',
    'rdgy_r',
    'winter',
    'rdylgn',
    'spring',
    'flag',
    'hot_r',
    'matter',
    'rdpu',
    'nipy_spectral_r',
    'prgn',
    'tab20b_r',
    'bupu_r',
    'coolwarm',
    'twilight_shifted',
    'hsv_r',
    'delta_r',
    'seismic',
    'amp',
    'oranges',
    'cmrmap',
    'diff_r',
    'tab20c',
    'paired_r',
    'ocean_r',
    'bwr',
    'topo',
    'seismic_r',
    'gist_stern_r',
    'tempo_r',
    'gnbu_r',
    'brg',
    'cividis',
    'gist_gray_r',
    'set2_r',
    'pubugn',
    'pastel2_r',
    'cool_r',
    'blues',
    'flag_r',
    'jet_r',
    'tab20',
    'curl',
    'winter_r',
    'nipy_spectral',
    'phase',
    'hot',
    'spectral_r',
    'summer_r',
    'hsv',
    'tarn',
    'twilight_shifted_r',
    'ylgnbu_r',
    'ylorbr_r',
    'ylgn_r',
    'pink_r',
    'puor',
    'viridis_r',
    'balance_r',
    'gist_earth',
    'magma',
    'pastel2',
    'rain_r',
    'brg_r',
    'solar',
    'binary_r',
    'reds',
    'tab10',
    'gray_r',
    'gist_yarg_r',
    'cubehelix',
    'accent_r',
    'delta',
    'gist_rainbow_r',
    'spectral',
    'pink',
    'set3',
    'gist_ncar',
    'balance',
    'greys',
    'rainbow',
    'diff',
    'bone_r',
    'speed_r',
    'bugn_r',
    'solar_r',
    'pubugn_r',
    'coolwarm_r',
    'cmrmap_r',
    'set1',
    'rain',
    'ylorrd',
    'set3_r',
    'twilight_r',
    'schwarzwald',
    'gnuplot2_r',
    'rdylgn_r',
    'greys_r',
    'set1_r',
    'cool',
    'pubu',
    'reds_r',
    'gray',
    'gnuplot_r',
    'spring_r',
    'pubu_r',
    'prism_r',
    'set2',
    'prgn_r',
    'tab20_r',
    'copper',
    'cividis_r',
    'bupu',
    'viridis',
    'rplumbo',
    'turbo_r',
    'dense',
    'accent',
    'gnuplot2',
    'prism',
    'orrd',
    'jet',
    'piyg',
    'brbg_r',
    'purples',
    'terrain_r',
    'deep_r',
    'rdbu_r',
    'turbo',
    'turbid_r',
    'deep',
    'rainbow_r',
    'tempo',
    'wistia',
    'dark2',
    'oranges_r',
    'cfastie',
    'twilight',
    'ylorrd_r',
    'autumn_r',
    'gist_rainbow',
    'tab20b',
    'rdylbu_r',
    'orrd_r',
    'rdgy',
    'gist_ncar_r',
    'binary',
    'magma_r',
    'gnuplot',
    'haline',
    'dark2_r',
    'tarn_r',
    'gist_stern',
    'inferno',
    'curl_r',
    'purples_r',
    'blues_r',
    'autumn',
    'rdylbu',
    'ocean',
    'afmhot',
    'tab20c_r',
    'oxy',
    'oxy_r',
    'ylgn',
    'pastel1_r',
    'greens',
    'ice_r',
    'copper_r',
    'tab10_r',
    'bwr_r'
].map((v)=>[
        v,
        v
    ]);


const $e23560f758eaee83$export$e506a1d27d1eaa20 = (0, $aa58e4af7634fac0$export$afcbd3cdfffb6e7c)((0, $ac885aba5ffedc46$export$41be205aae9631a4), {
    collectionPlugins: [
        new (0, $6b77bd4fc5b65248$export$e620499b4783e2c1)(),
        new (0, $97855730a133c737$export$8708d1ece48244f6)(),
        new (0, $ee9b29702898ba23$export$c6379ecf8f55f1e4)()
    ],
    // collectionPlugins: [new PluginKitchenSink()],
    itemPlugins: [],
    'ui:widget': {}
});





const $7a411f40ee06088b$var$publicUrl = "/";
const $7a411f40ee06088b$var$stacApiUrl = "https://eoapi.develop.eoepca.org/stac/";
let $7a411f40ee06088b$var$basename;
if ($7a411f40ee06088b$var$publicUrl) try {
    $7a411f40ee06088b$var$basename = new URL($7a411f40ee06088b$var$publicUrl).pathname;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
} catch (error) {
// no-op
}
// Single source of truth for auth-to-API wiring. Reads the current OIDC token
// from useAuth() and feeds it into two consumers:
//   1. ApiContext — for direct Api.fetch calls (mutations, ad-hoc reads).
//   2. StacApiProvider — for stac-react hooks (useCollection, useStacSearch…).
// A token change rebuilds both: a new Api instance via useMemo, and a new
// `options` identity that triggers stac-react's useStacApi effect to rebuild
// its StacApi with fresh headers.
//
// During OIDC load we render children without StacApiProvider so the rest of
// the app can still mount and read from ApiContext. NOTE: a stac-react hook
// rendered without the provider throws (the only QueryClientProvider lives
// inside StacApiProvider) — this is safe solely because App.tsx swaps all
// routes for a spinner behind the same auth isLoading flag, so no hook
// consumer mounts while the provider is absent. Keep those two gates in sync.
function $7a411f40ee06088b$var$StacApiAuthBridge({ children: children }) {
    const { token: token, isLoading: isLoading, refreshAuth: refreshAuth } = (0, $c837ac9c698038bc$export$1d39dc5b47e56ff0)();
    const api = (0, $8v0nu.useMemo)(()=>new (0, $e60c4cd554136647$export$2e2bcd8739ae039)(token, undefined, refreshAuth), [
        token,
        refreshAuth
    ]);
    const options = (0, $8v0nu.useMemo)(()=>token ? {
            headers: {
                Authorization: `Bearer ${token}`
            }
        } : undefined, [
        token
    ]);
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $e60c4cd554136647$export$f6d52655da4aa77d).Provider, {
        value: api,
        children: isLoading ? children : /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $65e1a4342c129241$export$dc253927969915ae), {
            apiUrl: $7a411f40ee06088b$var$stacApiUrl,
            options: options,
            children: children
        })
    });
}
// Root component.
function $7a411f40ee06088b$var$Root() {
    (0, $8v0nu.useEffect)(()=>{
        // Hide the welcome banner.
        const banner = document.querySelector('#welcome-banner');
        if (!banner) return;
        banner.classList.add('dismissed');
        setTimeout(()=>banner.remove(), 500);
    }, []);
    return /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8v0nu))).StrictMode, {
        children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsxs)((0, $771f18fb4c7e08d8$export$80dbe0482bcbd25a), {
            value: (0, $9f3e244f4ad36284$export$2e2bcd8739ae039),
            children: [
                /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $8d97b9cd1bee0709$export$fb98e3a2a4cd92d7), {}),
                /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $d9197f3f1e79e9d9$export$9ba4e89fdfa1fc54), {
                    basename: $7a411f40ee06088b$var$basename,
                    children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $c837ac9c698038bc$export$87091915187a1a85), {
                        children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)($7a411f40ee06088b$var$StacApiAuthBridge, {
                            children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $c14d6b556e5e27a6$export$1bd450f81b7fc15b), {
                                config: (0, $e23560f758eaee83$export$e506a1d27d1eaa20),
                                children: /*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)((0, $abca8739d4d09600$export$86fbec116b87613f), {})
                            })
                        })
                    })
                })
            ]
        })
    });
}
const $7a411f40ee06088b$var$rootNode = document.querySelector('#app-container');
const $7a411f40ee06088b$var$root = (0, $70200245338e5781$exports.createRoot)($7a411f40ee06088b$var$rootNode);
$7a411f40ee06088b$var$root.render(/*#__PURE__*/ (0, $ef524fb144c5d632$exports.jsx)($7a411f40ee06088b$var$Root, {}));


//# sourceMappingURL=client.941f62a2.js.map
